/**
 * @license @tabler/icons-react v3.31.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

'use strict';

var react = require('react');

var defaultAttributes = {
  outline: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  filled: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none"
  }
};

const createReactComponent = (type, iconName, iconNamePascal, iconNode) => {
  const Component = react.forwardRef(
    ({ color = "currentColor", size = 24, stroke = 2, title, className, children, ...rest }, ref) => react.createElement(
      "svg",
      {
        ref,
        ...defaultAttributes[type],
        width: size,
        height: size,
        className: [`tabler-icon`, `tabler-icon-${iconName}`, className].join(" "),
        ...type === "filled" ? {
          fill: color
        } : {
          strokeWidth: stroke,
          stroke: color
        },
        ...rest
      },
      [
        title && react.createElement("title", { key: "svg-title" }, title),
        ...iconNode.map(([tag, attrs]) => react.createElement(tag, attrs)),
        ...Array.isArray(children) ? children : [children]
      ]
    )
  );
  Component.displayName = `${iconNamePascal}`;
  return Component;
};

var IconAB2 = createReactComponent("outline", "a-b-2", "IconAB2", [["path", { "d": "M16 21h3c.81 0 1.48 -.67 1.48 -1.48l.02 -.02c0 -.82 -.69 -1.5 -1.5 -1.5h-3v3z", "key": "svg-0" }], ["path", { "d": "M16 15h2.5c.84 -.01 1.5 .66 1.5 1.5s-.66 1.5 -1.5 1.5h-2.5v-3z", "key": "svg-1" }], ["path", { "d": "M4 9v-4c0 -1.036 .895 -2 2 -2s2 .964 2 2v4", "key": "svg-2" }], ["path", { "d": "M2.99 11.98a9 9 0 0 0 9 9m9 -9a9 9 0 0 0 -9 -9", "key": "svg-3" }], ["path", { "d": "M8 7h-4", "key": "svg-4" }]]);

var IconAB2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAB2
});

var IconABOff = createReactComponent("outline", "a-b-off", "IconABOff", [["path", { "d": "M3 16v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5", "key": "svg-0" }], ["path", { "d": "M12 12v6", "key": "svg-1" }], ["path", { "d": "M12 6v2", "key": "svg-2" }], ["path", { "d": "M16 8h3a2 2 0 1 1 0 4h-3m3 0a2 2 0 0 1 .83 3.82m-3.83 -3.82v-4", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconABOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconABOff
});

var IconAB = createReactComponent("outline", "a-b", "IconAB", [["path", { "d": "M3 16v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5", "key": "svg-0" }], ["path", { "d": "M12 6l0 12", "key": "svg-1" }], ["path", { "d": "M16 16v-8h3a2 2 0 0 1 0 4h-3m3 0a2 2 0 0 1 0 4h-3", "key": "svg-2" }]]);

var IconAB$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAB
});

var IconAbacusOff = createReactComponent("outline", "abacus-off", "IconAbacusOff", [["path", { "d": "M5 5v16", "key": "svg-0" }], ["path", { "d": "M19 21v-2m0 -4v-12", "key": "svg-1" }], ["path", { "d": "M5 7h2m4 0h8", "key": "svg-2" }], ["path", { "d": "M5 15h10", "key": "svg-3" }], ["path", { "d": "M8 13v4", "key": "svg-4" }], ["path", { "d": "M11 13v4", "key": "svg-5" }], ["path", { "d": "M16 16v1", "key": "svg-6" }], ["path", { "d": "M14 5v4", "key": "svg-7" }], ["path", { "d": "M11 5v2", "key": "svg-8" }], ["path", { "d": "M8 8v1", "key": "svg-9" }], ["path", { "d": "M3 21h18", "key": "svg-10" }], ["path", { "d": "M3 3l18 18", "key": "svg-11" }]]);

var IconAbacusOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAbacusOff
});

var IconAbacus = createReactComponent("outline", "abacus", "IconAbacus", [["path", { "d": "M5 3v18", "key": "svg-0" }], ["path", { "d": "M19 21v-18", "key": "svg-1" }], ["path", { "d": "M5 7h14", "key": "svg-2" }], ["path", { "d": "M5 15h14", "key": "svg-3" }], ["path", { "d": "M8 13v4", "key": "svg-4" }], ["path", { "d": "M11 13v4", "key": "svg-5" }], ["path", { "d": "M16 13v4", "key": "svg-6" }], ["path", { "d": "M14 5v4", "key": "svg-7" }], ["path", { "d": "M11 5v4", "key": "svg-8" }], ["path", { "d": "M8 5v4", "key": "svg-9" }], ["path", { "d": "M3 21h18", "key": "svg-10" }]]);

var IconAbacus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAbacus
});

var IconAbc = createReactComponent("outline", "abc", "IconAbc", [["path", { "d": "M3 16v-6a2 2 0 1 1 4 0v6", "key": "svg-0" }], ["path", { "d": "M3 13h4", "key": "svg-1" }], ["path", { "d": "M10 8v6a2 2 0 1 0 4 0v-1a2 2 0 1 0 -4 0v1", "key": "svg-2" }], ["path", { "d": "M20.732 12a2 2 0 0 0 -3.732 1v1a2 2 0 0 0 3.726 1.01", "key": "svg-3" }]]);

var IconAbc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAbc
});

var IconAccessPointOff = createReactComponent("outline", "access-point-off", "IconAccessPointOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M14.828 9.172a4 4 0 0 1 1.172 2.828", "key": "svg-1" }], ["path", { "d": "M17.657 6.343a8 8 0 0 1 1.635 8.952", "key": "svg-2" }], ["path", { "d": "M9.168 14.828a4 4 0 0 1 0 -5.656", "key": "svg-3" }], ["path", { "d": "M6.337 17.657a8 8 0 0 1 0 -11.314", "key": "svg-4" }]]);

var IconAccessPointOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAccessPointOff
});

var IconAccessPoint = createReactComponent("outline", "access-point", "IconAccessPoint", [["path", { "d": "M12 12l0 .01", "key": "svg-0" }], ["path", { "d": "M14.828 9.172a4 4 0 0 1 0 5.656", "key": "svg-1" }], ["path", { "d": "M17.657 6.343a8 8 0 0 1 0 11.314", "key": "svg-2" }], ["path", { "d": "M9.168 14.828a4 4 0 0 1 0 -5.656", "key": "svg-3" }], ["path", { "d": "M6.337 17.657a8 8 0 0 1 0 -11.314", "key": "svg-4" }]]);

var IconAccessPoint$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAccessPoint
});

var IconAccessibleOff = createReactComponent("outline", "accessible-off", "IconAccessibleOff", [["path", { "d": "M10 16.5l2 -3l2 3m-2 -3v-1.5m2.627 -1.376l.373 -.124m-6 0l2.231 .744", "key": "svg-0" }], ["path", { "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73", "key": "svg-1" }], ["path", { "d": "M12 8a.5 .5 0 1 0 -.5 -.5", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconAccessibleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAccessibleOff
});

var IconAccessible = createReactComponent("outline", "accessible", "IconAccessible", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 16.5l2 -3l2 3m-2 -3v-2l3 -1m-6 0l3 1", "key": "svg-1" }], ["circle", { "cx": "12", "cy": "7.5", "r": ".5", "fill": "currentColor", "key": "svg-2" }]]);

var IconAccessible$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAccessible
});

var IconActivityHeartbeat = createReactComponent("outline", "activity-heartbeat", "IconActivityHeartbeat", [["path", { "d": "M3 12h4.5l1.5 -6l4 12l2 -9l1.5 3h4.5", "key": "svg-0" }]]);

var IconActivityHeartbeat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconActivityHeartbeat
});

var IconActivity = createReactComponent("outline", "activity", "IconActivity", [["path", { "d": "M3 12h4l3 8l4 -16l3 8h4", "key": "svg-0" }]]);

var IconActivity$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconActivity
});

var IconAd2 = createReactComponent("outline", "ad-2", "IconAd2", [["path", { "d": "M11.933 5h-6.933v16h13v-8", "key": "svg-0" }], ["path", { "d": "M14 17h-5", "key": "svg-1" }], ["path", { "d": "M9 13h5v-4h-5z", "key": "svg-2" }], ["path", { "d": "M15 5v-2", "key": "svg-3" }], ["path", { "d": "M18 6l2 -2", "key": "svg-4" }], ["path", { "d": "M19 9h2", "key": "svg-5" }]]);

var IconAd2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAd2
});

var IconAdCircleOff = createReactComponent("outline", "ad-circle-off", "IconAdCircleOff", [["path", { "d": "M4.91 4.949a9.968 9.968 0 0 0 -2.91 7.051c0 5.523 4.477 10 10 10a9.968 9.968 0 0 0 7.05 -2.909", "key": "svg-0" }], ["path", { "d": "M20.778 16.793a9.955 9.955 0 0 0 1.222 -4.793c0 -5.523 -4.477 -10 -10 -10c-1.74 0 -3.376 .444 -4.8 1.225", "key": "svg-1" }], ["path", { "d": "M7 15v-4.5a1.5 1.5 0 0 1 2.138 -1.358", "key": "svg-2" }], ["path", { "d": "M9.854 9.853c.094 .196 .146 .415 .146 .647v4.5", "key": "svg-3" }], ["path", { "d": "M7 13h3", "key": "svg-4" }], ["path", { "d": "M14 14v1h1", "key": "svg-5" }], ["path", { "d": "M17 13v-2a2 2 0 0 0 -2 -2h-1v1", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconAdCircleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdCircleOff
});

var IconAdCircle = createReactComponent("outline", "ad-circle", "IconAdCircle", [["path", { "d": "M12 12m-10 0a10 10 0 1 0 20 0a10 10 0 1 0 -20 0", "key": "svg-0" }], ["path", { "d": "M7 15v-4.5a1.5 1.5 0 0 1 3 0v4.5", "key": "svg-1" }], ["path", { "d": "M7 13h3", "key": "svg-2" }], ["path", { "d": "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z", "key": "svg-3" }]]);

var IconAdCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdCircle
});

var IconAdOff = createReactComponent("outline", "ad-off", "IconAdOff", [["path", { "d": "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M7 15v-4a2 2 0 0 1 2 -2m2 2v4", "key": "svg-1" }], ["path", { "d": "M7 13h4", "key": "svg-2" }], ["path", { "d": "M17 9v4", "key": "svg-3" }], ["path", { "d": "M16.115 12.131c.33 .149 .595 .412 .747 .74", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconAdOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdOff
});

var IconAd = createReactComponent("outline", "ad", "IconAd", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 15v-4a2 2 0 0 1 4 0v4", "key": "svg-1" }], ["path", { "d": "M7 13l4 0", "key": "svg-2" }], ["path", { "d": "M17 9v6h-1.5a1.5 1.5 0 1 1 1.5 -1.5", "key": "svg-3" }]]);

var IconAd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAd
});

var IconAddressBookOff = createReactComponent("outline", "address-book-off", "IconAddressBookOff", [["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.57 3.399c-.363 .37 -.87 .601 -1.43 .601h-10a2 2 0 0 1 -2 -2v-12", "key": "svg-0" }], ["path", { "d": "M10 16h6", "key": "svg-1" }], ["path", { "d": "M11 11a2 2 0 0 0 2 2m2 -2a2 2 0 0 0 -2 -2", "key": "svg-2" }], ["path", { "d": "M4 8h3", "key": "svg-3" }], ["path", { "d": "M4 12h3", "key": "svg-4" }], ["path", { "d": "M4 16h3", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconAddressBookOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAddressBookOff
});

var IconAddressBook = createReactComponent("outline", "address-book", "IconAddressBook", [["path", { "d": "M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z", "key": "svg-0" }], ["path", { "d": "M10 16h6", "key": "svg-1" }], ["path", { "d": "M13 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M4 8h3", "key": "svg-3" }], ["path", { "d": "M4 12h3", "key": "svg-4" }], ["path", { "d": "M4 16h3", "key": "svg-5" }]]);

var IconAddressBook$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAddressBook
});

var IconAdjustmentsAlt = createReactComponent("outline", "adjustments-alt", "IconAdjustmentsAlt", [["path", { "d": "M4 8h4v4h-4z", "key": "svg-0" }], ["path", { "d": "M6 4l0 4", "key": "svg-1" }], ["path", { "d": "M6 12l0 8", "key": "svg-2" }], ["path", { "d": "M10 14h4v4h-4z", "key": "svg-3" }], ["path", { "d": "M12 4l0 10", "key": "svg-4" }], ["path", { "d": "M12 18l0 2", "key": "svg-5" }], ["path", { "d": "M16 5h4v4h-4z", "key": "svg-6" }], ["path", { "d": "M18 4l0 1", "key": "svg-7" }], ["path", { "d": "M18 9l0 11", "key": "svg-8" }]]);

var IconAdjustmentsAlt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsAlt
});

var IconAdjustmentsBolt = createReactComponent("outline", "adjustments-bolt", "IconAdjustmentsBolt", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-5" }], ["path", { "d": "M12 18v2", "key": "svg-6" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-7" }], ["path", { "d": "M18 4v1", "key": "svg-8" }], ["path", { "d": "M18 9v3", "key": "svg-9" }]]);

var IconAdjustmentsBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsBolt
});

var IconAdjustmentsCancel = createReactComponent("outline", "adjustments-cancel", "IconAdjustmentsCancel", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.499 14.675a2 2 0 1 0 -1.499 3.325", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v3", "key": "svg-8" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-9" }], ["path", { "d": "M17 21l4 -4", "key": "svg-10" }]]);

var IconAdjustmentsCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsCancel
});

var IconAdjustmentsCheck = createReactComponent("outline", "adjustments-check", "IconAdjustmentsCheck", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.823 15.176a2 2 0 1 0 -2.638 2.651", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-5" }], ["path", { "d": "M18 4v1", "key": "svg-6" }], ["path", { "d": "M18 9v5", "key": "svg-7" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-8" }]]);

var IconAdjustmentsCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsCheck
});

var IconAdjustmentsCode = createReactComponent("outline", "adjustments-code", "IconAdjustmentsCode", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.557 14.745a2 2 0 1 0 -1.557 3.255", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v4", "key": "svg-8" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-9" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-10" }]]);

var IconAdjustmentsCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsCode
});

var IconAdjustmentsCog = createReactComponent("outline", "adjustments-cog", "IconAdjustmentsCog", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.199 14.399a2 2 0 1 0 -1.199 3.601", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v2.5", "key": "svg-8" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-9" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-10" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-11" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-12" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-13" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-14" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-15" }]]);

var IconAdjustmentsCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsCog
});

var IconAdjustmentsDollar = createReactComponent("outline", "adjustments-dollar", "IconAdjustmentsDollar", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.366 14.54a2 2 0 1 0 -.216 3.097", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v1", "key": "svg-8" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-9" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-10" }]]);

var IconAdjustmentsDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsDollar
});

var IconAdjustmentsDown = createReactComponent("outline", "adjustments-down", "IconAdjustmentsDown", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.945 15.53a2 2 0 1 0 -1.945 2.47", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v3", "key": "svg-8" }], ["path", { "d": "M19 16v6", "key": "svg-9" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-10" }]]);

var IconAdjustmentsDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsDown
});

var IconAdjustmentsExclamation = createReactComponent("outline", "adjustments-exclamation", "IconAdjustmentsExclamation", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v3", "key": "svg-8" }], ["path", { "d": "M19 16v3", "key": "svg-9" }], ["path", { "d": "M19 22v.01", "key": "svg-10" }]]);

var IconAdjustmentsExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsExclamation
});

var IconAdjustmentsHeart = createReactComponent("outline", "adjustments-heart", "IconAdjustmentsHeart", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M12 4v8.5", "key": "svg-3" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-4" }], ["path", { "d": "M18 4v1", "key": "svg-5" }], ["path", { "d": "M18 9v2.5", "key": "svg-6" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-7" }]]);

var IconAdjustmentsHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsHeart
});

var IconAdjustmentsHorizontal = createReactComponent("outline", "adjustments-horizontal", "IconAdjustmentsHorizontal", [["path", { "d": "M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M4 6l8 0", "key": "svg-1" }], ["path", { "d": "M16 6l4 0", "key": "svg-2" }], ["path", { "d": "M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M4 12l2 0", "key": "svg-4" }], ["path", { "d": "M10 12l10 0", "key": "svg-5" }], ["path", { "d": "M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-6" }], ["path", { "d": "M4 18l11 0", "key": "svg-7" }], ["path", { "d": "M19 18l1 0", "key": "svg-8" }]]);

var IconAdjustmentsHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsHorizontal
});

var IconAdjustmentsMinus = createReactComponent("outline", "adjustments-minus", "IconAdjustmentsMinus", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.954 15.574a2 2 0 1 0 -1.954 2.426", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v6", "key": "svg-8" }], ["path", { "d": "M16 19h6", "key": "svg-9" }]]);

var IconAdjustmentsMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsMinus
});

var IconAdjustmentsOff = createReactComponent("outline", "adjustments-off", "IconAdjustmentsOff", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 6v2", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M12 4v4m0 4v2", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v5m0 4v2", "key": "svg-8" }], ["path", { "d": "M3 3l18 18", "key": "svg-9" }]]);

var IconAdjustmentsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsOff
});

var IconAdjustmentsPause = createReactComponent("outline", "adjustments-pause", "IconAdjustmentsPause", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.627 14.836a2 2 0 1 0 -.62 2.892", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M17 17v5", "key": "svg-8" }], ["path", { "d": "M21 17v5", "key": "svg-9" }], ["path", { "d": "M18 9v4.5", "key": "svg-10" }]]);

var IconAdjustmentsPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsPause
});

var IconAdjustmentsPin = createReactComponent("outline", "adjustments-pin", "IconAdjustmentsPin", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.071 14.31a2 2 0 1 0 -1.071 3.69", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v2.5", "key": "svg-8" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-9" }], ["path", { "d": "M19 18v.01", "key": "svg-10" }]]);

var IconAdjustmentsPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsPin
});

var IconAdjustmentsPlus = createReactComponent("outline", "adjustments-plus", "IconAdjustmentsPlus", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.958 15.592a2 2 0 1 0 -1.958 2.408", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v3", "key": "svg-8" }], ["path", { "d": "M16 19h6", "key": "svg-9" }], ["path", { "d": "M19 16v6", "key": "svg-10" }]]);

var IconAdjustmentsPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsPlus
});

var IconAdjustmentsQuestion = createReactComponent("outline", "adjustments-question", "IconAdjustmentsQuestion", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.577 14.77a2 2 0 1 0 .117 2.295", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M19 22v.01", "key": "svg-5" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-6" }], ["path", { "d": "M12 18v2", "key": "svg-7" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-8" }], ["path", { "d": "M18 4v1", "key": "svg-9" }], ["path", { "d": "M18 9v2", "key": "svg-10" }]]);

var IconAdjustmentsQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsQuestion
});

var IconAdjustmentsSearch = createReactComponent("outline", "adjustments-search", "IconAdjustmentsSearch", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M12 14a2 2 0 0 0 -1.042 3.707", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-5" }], ["path", { "d": "M18 4v1", "key": "svg-6" }], ["path", { "d": "M18 9v2", "key": "svg-7" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-8" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-9" }]]);

var IconAdjustmentsSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsSearch
});

var IconAdjustmentsShare = createReactComponent("outline", "adjustments-share", "IconAdjustmentsShare", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.387 14.56a2 2 0 1 0 -.798 3.352", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M16 22l5 -5", "key": "svg-8" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-9" }], ["path", { "d": "M18 9v4", "key": "svg-10" }]]);

var IconAdjustmentsShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsShare
});

var IconAdjustmentsSpark = createReactComponent("outline", "adjustments-spark", "IconAdjustmentsSpark", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.879 15.312a2 2 0 1 0 -2.26 2.652", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-5" }], ["path", { "d": "M18 4v1", "key": "svg-6" }], ["path", { "d": "M18 9v2.5", "key": "svg-7" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-8" }]]);

var IconAdjustmentsSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsSpark
});

var IconAdjustmentsStar = createReactComponent("outline", "adjustments-star", "IconAdjustmentsStar", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M12 4v9.5", "key": "svg-3" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-4" }], ["path", { "d": "M18 4v1", "key": "svg-5" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-6" }], ["path", { "d": "M18 9v1", "key": "svg-7" }]]);

var IconAdjustmentsStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsStar
});

var IconAdjustmentsUp = createReactComponent("outline", "adjustments-up", "IconAdjustmentsUp", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.927 15.462a2 2 0 1 0 -1.927 2.538", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v3", "key": "svg-8" }], ["path", { "d": "M19 22v-6", "key": "svg-9" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-10" }]]);

var IconAdjustmentsUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsUp
});

var IconAdjustmentsX = createReactComponent("outline", "adjustments-x", "IconAdjustmentsX", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M13.653 14.874a2 2 0 1 0 -.586 2.818", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v4", "key": "svg-8" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-9" }], ["path", { "d": "M17 22l5 -5", "key": "svg-10" }]]);

var IconAdjustmentsX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsX
});

var IconAdjustments = createReactComponent("outline", "adjustments", "IconAdjustments", [["path", { "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 4v4", "key": "svg-1" }], ["path", { "d": "M6 12v8", "key": "svg-2" }], ["path", { "d": "M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M12 4v10", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M18 4v1", "key": "svg-7" }], ["path", { "d": "M18 9v11", "key": "svg-8" }]]);

var IconAdjustments$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustments
});

var IconAerialLift = createReactComponent("outline", "aerial-lift", "IconAerialLift", [["path", { "d": "M4 5l16 -2m-8 1v10m-5.106 -6h10.306c2.45 3 2.45 9 -.2 12h-10.106c-2.544 -3 -2.544 -9 0 -12zm-1.894 6h14", "key": "svg-0" }]]);

var IconAerialLift$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAerialLift
});

var IconAffiliate = createReactComponent("outline", "affiliate", "IconAffiliate", [["path", { "d": "M5.931 6.936l1.275 4.249m5.607 5.609l4.251 1.275", "key": "svg-0" }], ["path", { "d": "M11.683 12.317l5.759 -5.759", "key": "svg-1" }], ["path", { "d": "M5.5 5.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0", "key": "svg-2" }], ["path", { "d": "M18.5 5.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0", "key": "svg-3" }], ["path", { "d": "M18.5 18.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0", "key": "svg-4" }], ["path", { "d": "M8.5 15.5m-4.5 0a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0", "key": "svg-5" }]]);

var IconAffiliate$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAffiliate
});

var IconAi = createReactComponent("outline", "ai", "IconAi", [["path", { "d": "M8 16v-6a2 2 0 1 1 4 0v6", "key": "svg-0" }], ["path", { "d": "M8 13h4", "key": "svg-1" }], ["path", { "d": "M16 8v8", "key": "svg-2" }]]);

var IconAi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAi
});

var IconAirBalloon = createReactComponent("outline", "air-balloon", "IconAirBalloon", [["path", { "d": "M10 19m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M12 16c3.314 0 6 -4.686 6 -8a6 6 0 1 0 -12 0c0 3.314 2.686 8 6 8z", "key": "svg-1" }], ["path", { "d": "M12 9m-2 0a2 7 0 1 0 4 0a2 7 0 1 0 -4 0", "key": "svg-2" }]]);

var IconAirBalloon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAirBalloon
});

var IconAirConditioningDisabled = createReactComponent("outline", "air-conditioning-disabled", "IconAirConditioningDisabled", [["path", { "d": "M3 8m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 16v-3a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v3", "key": "svg-1" }]]);

var IconAirConditioningDisabled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAirConditioningDisabled
});

var IconAirConditioning = createReactComponent("outline", "air-conditioning", "IconAirConditioning", [["path", { "d": "M8 16a3 3 0 0 1 -3 3", "key": "svg-0" }], ["path", { "d": "M16 16a3 3 0 0 0 3 3", "key": "svg-1" }], ["path", { "d": "M12 16v4", "key": "svg-2" }], ["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-3" }], ["path", { "d": "M7 13v-3a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v3", "key": "svg-4" }]]);

var IconAirConditioning$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAirConditioning
});

var IconAirTrafficControl = createReactComponent("outline", "air-traffic-control", "IconAirTrafficControl", [["path", { "d": "M11 3h2", "key": "svg-0" }], ["path", { "d": "M12 3v3", "key": "svg-1" }], ["path", { "d": "M5.998 6h12.004a2 2 0 0 1 1.916 2.575l-1.8 6a2 2 0 0 1 -1.916 1.425h-8.404a2 2 0 0 1 -1.916 -1.425l-1.8 -6a2 2 0 0 1 1.916 -2.575z", "key": "svg-2" }], ["path", { "d": "M8.5 6l1.5 10v5", "key": "svg-3" }], ["path", { "d": "M15.5 6l-1.5 10v5", "key": "svg-4" }]]);

var IconAirTrafficControl$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAirTrafficControl
});

var IconAlarmAverage = createReactComponent("outline", "alarm-average", "IconAlarmAverage", [["path", { "d": "M5 13a7 7 0 1 0 14 0a7 7 0 0 0 -14 0", "key": "svg-0" }], ["path", { "d": "M7 4l-2.75 2", "key": "svg-1" }], ["path", { "d": "M17 4l2.75 2", "key": "svg-2" }], ["path", { "d": "M8 13h1l2 3l2 -6l2 3h1", "key": "svg-3" }]]);

var IconAlarmAverage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlarmAverage
});

var IconAlarmMinus = createReactComponent("outline", "alarm-minus", "IconAlarmMinus", [["path", { "d": "M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M7 4l-2.75 2", "key": "svg-1" }], ["path", { "d": "M17 4l2.75 2", "key": "svg-2" }], ["path", { "d": "M10 13h4", "key": "svg-3" }]]);

var IconAlarmMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlarmMinus
});

var IconAlarmOff = createReactComponent("outline", "alarm-off", "IconAlarmOff", [["path", { "d": "M7.587 7.566a7 7 0 1 0 9.833 9.864m1.35 -2.645a7 7 0 0 0 -8.536 -8.56", "key": "svg-0" }], ["path", { "d": "M12 12v1h1", "key": "svg-1" }], ["path", { "d": "M5.261 5.265l-1.011 .735", "key": "svg-2" }], ["path", { "d": "M17 4l2.75 2", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconAlarmOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlarmOff
});

var IconAlarmPlus = createReactComponent("outline", "alarm-plus", "IconAlarmPlus", [["path", { "d": "M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M7 4l-2.75 2", "key": "svg-1" }], ["path", { "d": "M17 4l2.75 2", "key": "svg-2" }], ["path", { "d": "M10 13h4", "key": "svg-3" }], ["path", { "d": "M12 11v4", "key": "svg-4" }]]);

var IconAlarmPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlarmPlus
});

var IconAlarmSmoke = createReactComponent("outline", "alarm-smoke", "IconAlarmSmoke", [["path", { "d": "M18 8l-.8 3a1.25 1.25 0 0 1 -1.2 1h-8a1.25 1.25 0 0 1 -1.2 -1l-.8 -3", "key": "svg-0" }], ["path", { "d": "M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M12 16c.643 .288 1.017 .756 1 1.25c.017 .494 -.357 .962 -1 1.25s-1.017 .756 -1 1.25c-.017 .494 .357 .962 1 1.25", "key": "svg-2" }], ["path", { "d": "M7 16c.643 .288 1.017 .756 1 1.25c.017 .494 -.357 .962 -1 1.25s-1.017 .756 -1 1.25c-.017 .494 .357 .962 1 1.25", "key": "svg-3" }], ["path", { "d": "M17 16c.643 .288 1.017 .756 1 1.25c.017 .494 -.357 .962 -1 1.25s-1.017 .756 -1 1.25c-.017 .494 .357 .962 1 1.25", "key": "svg-4" }]]);

var IconAlarmSmoke$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlarmSmoke
});

var IconAlarmSnooze = createReactComponent("outline", "alarm-snooze", "IconAlarmSnooze", [["path", { "d": "M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M10 11h4l-4 4h4", "key": "svg-1" }], ["path", { "d": "M7 4l-2.75 2", "key": "svg-2" }], ["path", { "d": "M17 4l2.75 2", "key": "svg-3" }]]);

var IconAlarmSnooze$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlarmSnooze
});

var IconAlarm = createReactComponent("outline", "alarm", "IconAlarm", [["path", { "d": "M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M12 10l0 3l2 0", "key": "svg-1" }], ["path", { "d": "M7 4l-2.75 2", "key": "svg-2" }], ["path", { "d": "M17 4l2.75 2", "key": "svg-3" }]]);

var IconAlarm$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlarm
});

var IconAlbumOff = createReactComponent("outline", "album-off", "IconAlbumOff", [["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.581 3.41c-.362 .364 -.864 .59 -1.419 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.052 .585 -1.413", "key": "svg-0" }], ["path", { "d": "M12 4v4m1.503 1.497l.497 -.497l2 2v-7", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconAlbumOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlbumOff
});

var IconAlbum = createReactComponent("outline", "album", "IconAlbum", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 4v7l2 -2l2 2v-7", "key": "svg-1" }]]);

var IconAlbum$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlbum
});

var IconAlertCircleOff = createReactComponent("outline", "alert-circle-off", "IconAlertCircleOff", [["path", { "d": "M5.644 5.629a9 9 0 1 0 12.715 12.741m1.693 -2.349a9 9 0 0 0 -12.087 -12.068", "key": "svg-0" }], ["path", { "d": "M12 7v1", "key": "svg-1" }], ["path", { "d": "M12 16h.01", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconAlertCircleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertCircleOff
});

var IconAlertCircle = createReactComponent("outline", "alert-circle", "IconAlertCircle", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 8v4", "key": "svg-1" }], ["path", { "d": "M12 16h.01", "key": "svg-2" }]]);

var IconAlertCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertCircle
});

var IconAlertHexagonOff = createReactComponent("outline", "alert-hexagon-off", "IconAlertHexagonOff", [["path", { "d": "M18.36 18.387l-5.268 3.333a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l1.317 -.777m2.535 -1.493l2.898 -1.709a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .414 -.116 .812 -.326 1.155", "key": "svg-0" }], ["path", { "d": "M12 7v1", "key": "svg-1" }], ["path", { "d": "M12 8v.01", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }], ["path", { "d": "M12 16h.01", "key": "svg-4" }]]);

var IconAlertHexagonOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertHexagonOff
});

var IconAlertHexagon = createReactComponent("outline", "alert-hexagon", "IconAlertHexagon", [["path", { "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M12 8v4", "key": "svg-1" }], ["path", { "d": "M12 16h.01", "key": "svg-2" }]]);

var IconAlertHexagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertHexagon
});

var IconAlertOctagon = createReactComponent("outline", "alert-octagon", "IconAlertOctagon", [["path", { "d": "M12.802 2.165l5.575 2.389c.48 .206 .863 .589 1.07 1.07l2.388 5.574c.22 .512 .22 1.092 0 1.604l-2.389 5.575c-.206 .48 -.589 .863 -1.07 1.07l-5.574 2.388c-.512 .22 -1.092 .22 -1.604 0l-5.575 -2.389a2.036 2.036 0 0 1 -1.07 -1.07l-2.388 -5.574a2.036 2.036 0 0 1 0 -1.604l2.389 -5.575c.206 -.48 .589 -.863 1.07 -1.07l5.574 -2.388a2.036 2.036 0 0 1 1.604 0z", "key": "svg-0" }], ["path", { "d": "M12 8v4", "key": "svg-1" }], ["path", { "d": "M12 16h.01", "key": "svg-2" }]]);

var IconAlertOctagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertOctagon
});

var IconAlertSmallOff = createReactComponent("outline", "alert-small-off", "IconAlertSmallOff", [["path", { "d": "M12 16h.01", "key": "svg-0" }], ["path", { "d": "M12 7v1", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconAlertSmallOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertSmallOff
});

var IconAlertSmall = createReactComponent("outline", "alert-small", "IconAlertSmall", [["path", { "d": "M12 8v4", "key": "svg-0" }], ["path", { "d": "M12 16h.01", "key": "svg-1" }]]);

var IconAlertSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertSmall
});

var IconAlertSquareRoundedOff = createReactComponent("outline", "alert-square-rounded-off", "IconAlertSquareRoundedOff", [["path", { "d": "M19.201 19.199c-1.35 1.35 -3.6 1.801 -7.201 1.801c-7.2 0 -9 -1.8 -9 -9c0 -3.598 .45 -5.847 1.797 -7.197m2.626 -1.376c1.204 -.307 2.709 -.427 4.577 -.427c7.2 0 9 1.8 9 9c0 1.865 -.12 3.367 -.425 4.57", "key": "svg-0" }], ["path", { "d": "M12 7v1", "key": "svg-1" }], ["path", { "d": "M12 16h.01", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconAlertSquareRoundedOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertSquareRoundedOff
});

var IconAlertSquareRounded = createReactComponent("outline", "alert-square-rounded", "IconAlertSquareRounded", [["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-0" }], ["path", { "d": "M12 8v4", "key": "svg-1" }], ["path", { "d": "M12 16h.01", "key": "svg-2" }]]);

var IconAlertSquareRounded$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertSquareRounded
});

var IconAlertSquare = createReactComponent("outline", "alert-square", "IconAlertSquare", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M12 8v4", "key": "svg-1" }], ["path", { "d": "M12 16h.01", "key": "svg-2" }]]);

var IconAlertSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertSquare
});

var IconAlertTriangleOff = createReactComponent("outline", "alert-triangle-off", "IconAlertTriangleOff", [["path", { "d": "M21.998 17.997a1.913 1.913 0 0 0 -.255 -.872l-8.106 -13.534a1.914 1.914 0 0 0 -3.274 0l-1.04 1.736m-1.493 2.493l-5.573 9.304a1.914 1.914 0 0 0 1.636 2.871h16.107", "key": "svg-0" }], ["path", { "d": "M12 16h.01", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }], ["path", { "d": "M12 7v1", "key": "svg-3" }]]);

var IconAlertTriangleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertTriangleOff
});

var IconAlertTriangle = createReactComponent("outline", "alert-triangle", "IconAlertTriangle", [["path", { "d": "M12 9v4", "key": "svg-0" }], ["path", { "d": "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z", "key": "svg-1" }], ["path", { "d": "M12 16h.01", "key": "svg-2" }]]);

var IconAlertTriangle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertTriangle
});

var IconAlien = createReactComponent("outline", "alien", "IconAlien", [["path", { "d": "M11 17a2.5 2.5 0 0 0 2 0", "key": "svg-0" }], ["path", { "d": "M12 3c-4.664 0 -7.396 2.331 -7.862 5.595a11.816 11.816 0 0 0 2 8.592a10.777 10.777 0 0 0 3.199 3.064c1.666 1 3.664 1 5.33 0a10.777 10.777 0 0 0 3.199 -3.064a11.89 11.89 0 0 0 2 -8.592c-.466 -3.265 -3.198 -5.595 -7.862 -5.595z", "key": "svg-1" }], ["path", { "d": "M8 11l2 2", "key": "svg-2" }], ["path", { "d": "M16 11l-2 2", "key": "svg-3" }]]);

var IconAlien$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlien
});

var IconAlignBoxBottomCenter = createReactComponent("outline", "align-box-bottom-center", "IconAlignBoxBottomCenter", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 15v2", "key": "svg-1" }], ["path", { "d": "M12 11v6", "key": "svg-2" }], ["path", { "d": "M15 13v4", "key": "svg-3" }]]);

var IconAlignBoxBottomCenter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxBottomCenter
});

var IconAlignBoxBottomLeft = createReactComponent("outline", "align-box-bottom-left", "IconAlignBoxBottomLeft", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 15v2", "key": "svg-1" }], ["path", { "d": "M10 11v6", "key": "svg-2" }], ["path", { "d": "M13 13v4", "key": "svg-3" }]]);

var IconAlignBoxBottomLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxBottomLeft
});

var IconAlignBoxBottomRight = createReactComponent("outline", "align-box-bottom-right", "IconAlignBoxBottomRight", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M11 15v2", "key": "svg-1" }], ["path", { "d": "M14 11v6", "key": "svg-2" }], ["path", { "d": "M17 13v4", "key": "svg-3" }]]);

var IconAlignBoxBottomRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxBottomRight
});

var IconAlignBoxCenterBottom = createReactComponent("outline", "align-box-center-bottom", "IconAlignBoxCenterBottom", [["path", { "d": "M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M11 17h2", "key": "svg-1" }], ["path", { "d": "M9 14h6", "key": "svg-2" }], ["path", { "d": "M10 11h4", "key": "svg-3" }]]);

var IconAlignBoxCenterBottom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxCenterBottom
});

var IconAlignBoxCenterMiddle = createReactComponent("outline", "align-box-center-middle", "IconAlignBoxCenterMiddle", [["path", { "d": "M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M11 15h2", "key": "svg-1" }], ["path", { "d": "M9 12h6", "key": "svg-2" }], ["path", { "d": "M10 9h4", "key": "svg-3" }]]);

var IconAlignBoxCenterMiddle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxCenterMiddle
});

var IconAlignBoxCenterStretch = createReactComponent("outline", "align-box-center-stretch", "IconAlignBoxCenterStretch", [["path", { "d": "M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M11 17h2", "key": "svg-1" }], ["path", { "d": "M9 12h6", "key": "svg-2" }], ["path", { "d": "M10 7h4", "key": "svg-3" }]]);

var IconAlignBoxCenterStretch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxCenterStretch
});

var IconAlignBoxCenterTop = createReactComponent("outline", "align-box-center-top", "IconAlignBoxCenterTop", [["path", { "d": "M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M11 13h2", "key": "svg-1" }], ["path", { "d": "M9 10h6", "key": "svg-2" }], ["path", { "d": "M10 7h4", "key": "svg-3" }]]);

var IconAlignBoxCenterTop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxCenterTop
});

var IconAlignBoxLeftBottom = createReactComponent("outline", "align-box-left-bottom", "IconAlignBoxLeftBottom", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 17h-2", "key": "svg-1" }], ["path", { "d": "M13 14h-6", "key": "svg-2" }], ["path", { "d": "M11 11h-4", "key": "svg-3" }]]);

var IconAlignBoxLeftBottom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxLeftBottom
});

var IconAlignBoxLeftMiddle = createReactComponent("outline", "align-box-left-middle", "IconAlignBoxLeftMiddle", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 15h-2", "key": "svg-1" }], ["path", { "d": "M13 12h-6", "key": "svg-2" }], ["path", { "d": "M11 9h-4", "key": "svg-3" }]]);

var IconAlignBoxLeftMiddle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxLeftMiddle
});

var IconAlignBoxLeftStretch = createReactComponent("outline", "align-box-left-stretch", "IconAlignBoxLeftStretch", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M9 17h-2", "key": "svg-1" }], ["path", { "d": "M13 12h-6", "key": "svg-2" }], ["path", { "d": "M11 7h-4", "key": "svg-3" }]]);

var IconAlignBoxLeftStretch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxLeftStretch
});

var IconAlignBoxLeftTop = createReactComponent("outline", "align-box-left-top", "IconAlignBoxLeftTop", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 13h-2", "key": "svg-1" }], ["path", { "d": "M13 10h-6", "key": "svg-2" }], ["path", { "d": "M11 7h-4", "key": "svg-3" }]]);

var IconAlignBoxLeftTop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxLeftTop
});

var IconAlignBoxRightBottom = createReactComponent("outline", "align-box-right-bottom", "IconAlignBoxRightBottom", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M15 17h2", "key": "svg-1" }], ["path", { "d": "M11 14h6", "key": "svg-2" }], ["path", { "d": "M13 11h4", "key": "svg-3" }]]);

var IconAlignBoxRightBottom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxRightBottom
});

var IconAlignBoxRightMiddle = createReactComponent("outline", "align-box-right-middle", "IconAlignBoxRightMiddle", [["path", { "d": "M15 15h2", "key": "svg-0" }], ["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-1" }], ["path", { "d": "M11 12h6", "key": "svg-2" }], ["path", { "d": "M13 9h4", "key": "svg-3" }]]);

var IconAlignBoxRightMiddle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxRightMiddle
});

var IconAlignBoxRightStretch = createReactComponent("outline", "align-box-right-stretch", "IconAlignBoxRightStretch", [["path", { "d": "M15 17h2", "key": "svg-0" }], ["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-1" }], ["path", { "d": "M11 12h6", "key": "svg-2" }], ["path", { "d": "M13 7h4", "key": "svg-3" }]]);

var IconAlignBoxRightStretch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxRightStretch
});

var IconAlignBoxRightTop = createReactComponent("outline", "align-box-right-top", "IconAlignBoxRightTop", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M15 13h2", "key": "svg-1" }], ["path", { "d": "M11 10h6", "key": "svg-2" }], ["path", { "d": "M13 7h4", "key": "svg-3" }]]);

var IconAlignBoxRightTop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxRightTop
});

var IconAlignBoxTopCenter = createReactComponent("outline", "align-box-top-center", "IconAlignBoxTopCenter", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 9v-2", "key": "svg-1" }], ["path", { "d": "M12 13v-6", "key": "svg-2" }], ["path", { "d": "M15 11v-4", "key": "svg-3" }]]);

var IconAlignBoxTopCenter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxTopCenter
});

var IconAlignBoxTopLeft = createReactComponent("outline", "align-box-top-left", "IconAlignBoxTopLeft", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 9v-2", "key": "svg-1" }], ["path", { "d": "M10 13v-6", "key": "svg-2" }], ["path", { "d": "M13 11v-4", "key": "svg-3" }]]);

var IconAlignBoxTopLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxTopLeft
});

var IconAlignBoxTopRight = createReactComponent("outline", "align-box-top-right", "IconAlignBoxTopRight", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M11 9v-2", "key": "svg-1" }], ["path", { "d": "M14 13v-6", "key": "svg-2" }], ["path", { "d": "M17 11v-4", "key": "svg-3" }]]);

var IconAlignBoxTopRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxTopRight
});

var IconAlignCenter = createReactComponent("outline", "align-center", "IconAlignCenter", [["path", { "d": "M4 6l16 0", "key": "svg-0" }], ["path", { "d": "M8 12l8 0", "key": "svg-1" }], ["path", { "d": "M6 18l12 0", "key": "svg-2" }]]);

var IconAlignCenter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignCenter
});

var IconAlignJustified = createReactComponent("outline", "align-justified", "IconAlignJustified", [["path", { "d": "M4 6l16 0", "key": "svg-0" }], ["path", { "d": "M4 12l16 0", "key": "svg-1" }], ["path", { "d": "M4 18l12 0", "key": "svg-2" }]]);

var IconAlignJustified$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignJustified
});

var IconAlignLeft2 = createReactComponent("outline", "align-left-2", "IconAlignLeft2", [["path", { "d": "M4 4v16", "key": "svg-0" }], ["path", { "d": "M8 6h12", "key": "svg-1" }], ["path", { "d": "M8 12h6", "key": "svg-2" }], ["path", { "d": "M8 18h10", "key": "svg-3" }]]);

var IconAlignLeft2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignLeft2
});

var IconAlignLeft = createReactComponent("outline", "align-left", "IconAlignLeft", [["path", { "d": "M4 6l16 0", "key": "svg-0" }], ["path", { "d": "M4 12l10 0", "key": "svg-1" }], ["path", { "d": "M4 18l14 0", "key": "svg-2" }]]);

var IconAlignLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignLeft
});

var IconAlignRight2 = createReactComponent("outline", "align-right-2", "IconAlignRight2", [["path", { "d": "M20 4v16", "key": "svg-0" }], ["path", { "d": "M4 6h12", "key": "svg-1" }], ["path", { "d": "M10 12h6", "key": "svg-2" }], ["path", { "d": "M6 18h10", "key": "svg-3" }]]);

var IconAlignRight2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignRight2
});

var IconAlignRight = createReactComponent("outline", "align-right", "IconAlignRight", [["path", { "d": "M4 6l16 0", "key": "svg-0" }], ["path", { "d": "M10 12l10 0", "key": "svg-1" }], ["path", { "d": "M6 18l14 0", "key": "svg-2" }]]);

var IconAlignRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignRight
});

var IconAlpha = createReactComponent("outline", "alpha", "IconAlpha", [["path", { "d": "M18.1 6c-1.1 2.913 -1.9 4.913 -2.4 6c-1.879 4.088 -3.713 6 -6 6c-2.4 0 -4.8 -2.4 -4.8 -6s2.4 -6 4.8 -6c2.267 0 4.135 1.986 6 6c.512 1.102 1.312 3.102 2.4 6", "key": "svg-0" }]]);

var IconAlpha$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlpha
});

var IconAlphabetArabic = createReactComponent("outline", "alphabet-arabic", "IconAlphabetArabic", [["path", { "d": "M10 6v4", "key": "svg-0" }], ["path", { "d": "M13 14h8q -2.518 -3 -4 -3", "key": "svg-1" }], ["path", { "d": "M13 6v9.958c0 .963 0 1.444 -.293 1.743s-.764 .299 -1.707 .299h-1", "key": "svg-2" }], ["path", { "d": "M7 6v9.958c0 .963 0 1.444 -.293 1.743s-.764 .299 -1.707 .299h-1", "key": "svg-3" }]]);

var IconAlphabetArabic$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlphabetArabic
});

var IconAlphabetBangla = createReactComponent("outline", "alphabet-bangla", "IconAlphabetBangla", [["path", { "d": "M14 12c.904 -.027 3 2 3 7", "key": "svg-0" }], ["path", { "d": "M10 11c0 -.955 0 -2 .786 -2.677c1.262 -1.089 3.025 .55 3.2 2.06c.086 .741 -.215 3.109 -1.489 4.527c-.475 .53 -.904 .992 -1.711 1.074c-.75 .076 -1.364 -.122 -2.076 -.588c-1.138 -.743 -2.327 -1.997 -3.336 -3.73c-1.078 -1.849 -1.66 -3.113 -2.374 -5.666", "key": "svg-1" }], ["path", { "d": "M7.37 7.072c.769 -.836 5.246 -4.094 8.4 -.202c.382 .472 .573 .708 .9 1.63c.326 .921 .326 1.562 .326 2.844v7.656", "key": "svg-2" }], ["path", { "d": "M17 10c0 -1.989 1.5 -4 4 -4", "key": "svg-3" }]]);

var IconAlphabetBangla$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlphabetBangla
});

var IconAlphabetCyrillic = createReactComponent("outline", "alphabet-cyrillic", "IconAlphabetCyrillic", [["path", { "d": "M6 10h2a2 2 0 0 1 2 2v5h-3a2 2 0 1 1 0 -4h3", "key": "svg-0" }], ["path", { "d": "M19 7h-3a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h1a2 2 0 0 0 2 -2v-3a2 2 0 0 0 -2 -2h-3", "key": "svg-1" }]]);

var IconAlphabetCyrillic$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlphabetCyrillic
});

var IconAlphabetGreek = createReactComponent("outline", "alphabet-greek", "IconAlphabetGreek", [["path", { "d": "M10 10v7", "key": "svg-0" }], ["path", { "d": "M5 10m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M14 20v-11a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2", "key": "svg-2" }]]);

var IconAlphabetGreek$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlphabetGreek
});

var IconAlphabetHebrew = createReactComponent("outline", "alphabet-hebrew", "IconAlphabetHebrew", [["path", { "d": "M7 6c2.333 5.143 6.611 6.857 9.333 12", "key": "svg-0" }], ["path", { "d": "M13.667 14c2.505 -1.5 2.666 -4.141 2.666 -5.333c0 -1.778 -.443 -2.667 -.443 -2.667", "key": "svg-1" }], ["path", { "d": "M7.485 18s-.485 -.905 -.485 -2.714c0 -1.172 .164 -3.722 2.641 -5.27", "key": "svg-2" }]]);

var IconAlphabetHebrew$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlphabetHebrew
});

var IconAlphabetKorean = createReactComponent("outline", "alphabet-korean", "IconAlphabetKorean", [["path", { "d": "M7 7h6c0 2.5 -1.593 8.474 -6 10", "key": "svg-0" }], ["path", { "d": "M16 5v14z", "key": "svg-1" }], ["path", { "d": "M16 12h2", "key": "svg-2" }]]);

var IconAlphabetKorean$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlphabetKorean
});

var IconAlphabetLatin = createReactComponent("outline", "alphabet-latin", "IconAlphabetLatin", [["path", { "d": "M6 10h2a2 2 0 0 1 2 2v5h-3a2 2 0 1 1 0 -4h3", "key": "svg-0" }], ["path", { "d": "M14 7v10", "key": "svg-1" }], ["path", { "d": "M14 10m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconAlphabetLatin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlphabetLatin
});

var IconAlphabetThai = createReactComponent("outline", "alphabet-thai", "IconAlphabetThai", [["path", { "d": "M8 18v-3.444c0 -.49 .165 -.924 .494 -1.363c.326 -.449 1.009 -.76 1.506 -.934c.032 -.011 .035 -.079 .004 -.095c-.434 -.22 -1.294 -.52 -1.626 -1.032l-.014 -.021l-.083 -.125c-.281 -.42 -.281 -1.246 -.281 -1.246c0 -1.456 .849 -2.62 1.837 -3.199q .9 -.54 2.137 -.541q 1.077 0 1.995 .47c1.328 .647 2.031 2.202 2.031 3.976v7.554", "key": "svg-0" }]]);

var IconAlphabetThai$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlphabetThai
});

var IconAlt = createReactComponent("outline", "alt", "IconAlt", [["path", { "d": "M4 16v-6a2 2 0 1 1 4 0v6", "key": "svg-0" }], ["path", { "d": "M4 13h4", "key": "svg-1" }], ["path", { "d": "M11 8v8h4", "key": "svg-2" }], ["path", { "d": "M16 8h4", "key": "svg-3" }], ["path", { "d": "M18 8v8", "key": "svg-4" }]]);

var IconAlt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlt
});

var IconAmbulance = createReactComponent("outline", "ambulance", "IconAmbulance", [["path", { "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5", "key": "svg-2" }], ["path", { "d": "M6 10h4m-2 -2v4", "key": "svg-3" }]]);

var IconAmbulance$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAmbulance
});

var IconAmpersand = createReactComponent("outline", "ampersand", "IconAmpersand", [["path", { "d": "M19 20l-10.403 -10.972a2.948 2.948 0 0 1 0 -4.165a2.94 2.94 0 0 1 4.161 0a2.948 2.948 0 0 1 0 4.165l-4.68 4.687a3.685 3.685 0 0 0 0 5.207a3.675 3.675 0 0 0 5.2 0l5.722 -5.922", "key": "svg-0" }]]);

var IconAmpersand$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAmpersand
});

var IconAnalyzeOff = createReactComponent("outline", "analyze-off", "IconAnalyzeOff", [["path", { "d": "M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.086 8.086 0 0 0 -4.31 .62m-2.383 1.608a8.089 8.089 0 0 0 -1.326 1.69", "key": "svg-0" }], ["path", { "d": "M4 13a8.1 8.1 0 0 0 13.687 4.676", "key": "svg-1" }], ["path", { "d": "M20 16a1 1 0 0 0 -1 -1", "key": "svg-2" }], ["path", { "d": "M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M9.888 9.87a3 3 0 1 0 4.233 4.252m.595 -3.397a3.012 3.012 0 0 0 -1.426 -1.435", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconAnalyzeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAnalyzeOff
});

var IconAnalyze = createReactComponent("outline", "analyze", "IconAnalyze", [["path", { "d": "M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918", "key": "svg-0" }], ["path", { "d": "M4 13a8.1 8.1 0 0 0 15 3", "key": "svg-1" }], ["path", { "d": "M19 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }]]);

var IconAnalyze$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAnalyze
});

var IconAnchorOff = createReactComponent("outline", "anchor-off", "IconAnchorOff", [["path", { "d": "M12 12v9", "key": "svg-0" }], ["path", { "d": "M4 13a8 8 0 0 0 14.138 5.13m1.44 -2.56a7.99 7.99 0 0 0 .422 -2.57", "key": "svg-1" }], ["path", { "d": "M21 13h-2", "key": "svg-2" }], ["path", { "d": "M5 13h-2", "key": "svg-3" }], ["path", { "d": "M12.866 8.873a3 3 0 1 0 -3.737 -3.747", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconAnchorOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAnchorOff
});

var IconAnchor = createReactComponent("outline", "anchor", "IconAnchor", [["path", { "d": "M12 9v12m-8 -8a8 8 0 0 0 16 0m1 0h-2m-14 0h-2", "key": "svg-0" }], ["path", { "d": "M12 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }]]);

var IconAnchor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAnchor
});

var IconAngle = createReactComponent("outline", "angle", "IconAngle", [["path", { "d": "M21 19h-18l9 -15", "key": "svg-0" }], ["path", { "d": "M20.615 15.171h.015", "key": "svg-1" }], ["path", { "d": "M19.515 11.771h.015", "key": "svg-2" }], ["path", { "d": "M17.715 8.671h.015", "key": "svg-3" }], ["path", { "d": "M15.415 5.971h.015", "key": "svg-4" }]]);

var IconAngle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAngle
});

var IconAnkh = createReactComponent("outline", "ankh", "IconAnkh", [["path", { "d": "M6 13h12", "key": "svg-0" }], ["path", { "d": "M12 21v-8l-.422 -.211a6.472 6.472 0 0 1 -3.578 -5.789a4 4 0 1 1 8 0a6.472 6.472 0 0 1 -3.578 5.789l-.422 .211", "key": "svg-1" }]]);

var IconAnkh$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAnkh
});

var IconAntennaBars1 = createReactComponent("outline", "antenna-bars-1", "IconAntennaBars1", [["path", { "d": "M6 18l0 .01", "key": "svg-0" }], ["path", { "d": "M10 18l0 .01", "key": "svg-1" }], ["path", { "d": "M14 18l0 .01", "key": "svg-2" }], ["path", { "d": "M18 18l0 .01", "key": "svg-3" }]]);

var IconAntennaBars1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAntennaBars1
});

var IconAntennaBars2 = createReactComponent("outline", "antenna-bars-2", "IconAntennaBars2", [["path", { "d": "M6 18l0 -3", "key": "svg-0" }], ["path", { "d": "M10 18l0 .01", "key": "svg-1" }], ["path", { "d": "M14 18l0 .01", "key": "svg-2" }], ["path", { "d": "M18 18l0 .01", "key": "svg-3" }]]);

var IconAntennaBars2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAntennaBars2
});

var IconAntennaBars3 = createReactComponent("outline", "antenna-bars-3", "IconAntennaBars3", [["path", { "d": "M6 18l0 -3", "key": "svg-0" }], ["path", { "d": "M10 18l0 -6", "key": "svg-1" }], ["path", { "d": "M14 18l0 .01", "key": "svg-2" }], ["path", { "d": "M18 18l0 .01", "key": "svg-3" }]]);

var IconAntennaBars3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAntennaBars3
});

var IconAntennaBars4 = createReactComponent("outline", "antenna-bars-4", "IconAntennaBars4", [["path", { "d": "M6 18l0 -3", "key": "svg-0" }], ["path", { "d": "M10 18l0 -6", "key": "svg-1" }], ["path", { "d": "M14 18l0 -9", "key": "svg-2" }], ["path", { "d": "M18 18l0 .01", "key": "svg-3" }]]);

var IconAntennaBars4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAntennaBars4
});

var IconAntennaBars5 = createReactComponent("outline", "antenna-bars-5", "IconAntennaBars5", [["path", { "d": "M6 18l0 -3", "key": "svg-0" }], ["path", { "d": "M10 18l0 -6", "key": "svg-1" }], ["path", { "d": "M14 18l0 -9", "key": "svg-2" }], ["path", { "d": "M18 18l0 -12", "key": "svg-3" }]]);

var IconAntennaBars5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAntennaBars5
});

var IconAntennaBarsOff = createReactComponent("outline", "antenna-bars-off", "IconAntennaBarsOff", [["path", { "d": "M6 18v-3", "key": "svg-0" }], ["path", { "d": "M10 18v-6", "key": "svg-1" }], ["path", { "d": "M14 18v-4", "key": "svg-2" }], ["path", { "d": "M14 10v-1", "key": "svg-3" }], ["path", { "d": "M18 14v-8", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconAntennaBarsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAntennaBarsOff
});

var IconAntennaOff = createReactComponent("outline", "antenna-off", "IconAntennaOff", [["path", { "d": "M20 4v8", "key": "svg-0" }], ["path", { "d": "M16 4.5v7", "key": "svg-1" }], ["path", { "d": "M12 5v3m0 4v9", "key": "svg-2" }], ["path", { "d": "M8 8v2.5", "key": "svg-3" }], ["path", { "d": "M4 6v4", "key": "svg-4" }], ["path", { "d": "M20 8h-8m-4 0h-4", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconAntennaOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAntennaOff
});

var IconAntenna = createReactComponent("outline", "antenna", "IconAntenna", [["path", { "d": "M20 4v8", "key": "svg-0" }], ["path", { "d": "M16 4.5v7", "key": "svg-1" }], ["path", { "d": "M12 5v16", "key": "svg-2" }], ["path", { "d": "M8 5.5v5", "key": "svg-3" }], ["path", { "d": "M4 6v4", "key": "svg-4" }], ["path", { "d": "M20 8h-16", "key": "svg-5" }]]);

var IconAntenna$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAntenna
});

var IconApertureOff = createReactComponent("outline", "aperture-off", "IconApertureOff", [["path", { "d": "M3.6 15h10.55", "key": "svg-0" }], ["path", { "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098", "key": "svg-1" }], ["path", { "d": "M7.395 7.534l2.416 7.438", "key": "svg-2" }], ["path", { "d": "M17.032 4.636l-4.852 3.526m-2.334 1.695l-1.349 .98", "key": "svg-3" }], ["path", { "d": "M20.559 14.51l-8.535 -6.201", "key": "svg-4" }], ["path", { "d": "M12.257 20.916l2.123 -6.533m.984 -3.028l.154 -.473", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconApertureOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconApertureOff
});

var IconAperture = createReactComponent("outline", "aperture", "IconAperture", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M3.6 15h10.55", "key": "svg-1" }], ["path", { "d": "M6.551 4.938l3.26 10.034", "key": "svg-2" }], ["path", { "d": "M17.032 4.636l-8.535 6.201", "key": "svg-3" }], ["path", { "d": "M20.559 14.51l-8.535 -6.201", "key": "svg-4" }], ["path", { "d": "M12.257 20.916l3.261 -10.034", "key": "svg-5" }]]);

var IconAperture$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAperture
});

var IconApiAppOff = createReactComponent("outline", "api-app-off", "IconApiAppOff", [["path", { "d": "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5", "key": "svg-0" }], ["path", { "d": "M15 15v3.5a2.5 2.5 0 1 1 -5 0v-.5", "key": "svg-1" }], ["path", { "d": "M13 9h5.5a2.5 2.5 0 1 1 0 5h-.5", "key": "svg-2" }], ["path", { "d": "M9 12v-3m.042 -3.957a2.5 2.5 0 0 1 4.958 .457v.5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconApiAppOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconApiAppOff
});

var IconApiApp = createReactComponent("outline", "api-app", "IconApiApp", [["path", { "d": "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5", "key": "svg-0" }], ["path", { "d": "M15 12v6.5a2.5 2.5 0 1 1 -5 0v-.5", "key": "svg-1" }], ["path", { "d": "M12 9h6.5a2.5 2.5 0 1 1 0 5h-.5", "key": "svg-2" }], ["path", { "d": "M9 12v-6.5a2.5 2.5 0 0 1 5 0v.5", "key": "svg-3" }]]);

var IconApiApp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconApiApp
});

var IconApiOff = createReactComponent("outline", "api-off", "IconApiOff", [["path", { "d": "M4 13h5", "key": "svg-0" }], ["path", { "d": "M12 16v-4m0 -4h3a2 2 0 0 1 2 2v1c0 .554 -.225 1.055 -.589 1.417m-3.411 .583h-1", "key": "svg-1" }], ["path", { "d": "M20 8v8", "key": "svg-2" }], ["path", { "d": "M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconApiOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconApiOff
});

var IconApi = createReactComponent("outline", "api", "IconApi", [["path", { "d": "M4 13h5", "key": "svg-0" }], ["path", { "d": "M12 16v-8h3a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-3", "key": "svg-1" }], ["path", { "d": "M20 8v8", "key": "svg-2" }], ["path", { "d": "M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5", "key": "svg-3" }]]);

var IconApi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconApi
});

var IconAppWindow = createReactComponent("outline", "app-window", "IconAppWindow", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M6 8h.01", "key": "svg-1" }], ["path", { "d": "M9 8h.01", "key": "svg-2" }]]);

var IconAppWindow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAppWindow
});

var IconApple = createReactComponent("outline", "apple", "IconApple", [["path", { "d": "M4 11.319c0 3.102 .444 5.319 2.222 7.978c1.351 1.797 3.156 2.247 5.08 .988c.426 -.268 .97 -.268 1.397 0c1.923 1.26 3.728 .809 5.079 -.988c1.778 -2.66 2.222 -4.876 2.222 -7.977c0 -2.661 -1.99 -5.32 -4.444 -5.32c-1.267 0 -2.41 .693 -3.22 1.44a.5 .5 0 0 1 -.672 0c-.809 -.746 -1.953 -1.44 -3.22 -1.44c-2.454 0 -4.444 2.66 -4.444 5.319", "key": "svg-0" }], ["path", { "d": "M7 12c0 -1.47 .454 -2.34 1.5 -3", "key": "svg-1" }], ["path", { "d": "M12 7c0 -1.2 .867 -4 3 -4", "key": "svg-2" }]]);

var IconApple$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconApple
});

var IconAppsOff = createReactComponent("outline", "apps-off", "IconAppsOff", [["path", { "d": "M8 4h1a1 1 0 0 1 1 1v1m-.29 3.704a1 1 0 0 1 -.71 .296h-4a1 1 0 0 1 -1 -1v-4c0 -.276 .111 -.525 .292 -.706", "key": "svg-0" }], ["path", { "d": "M18 14h1a1 1 0 0 1 1 1v1m-.29 3.704a1 1 0 0 1 -.71 .296h-4a1 1 0 0 1 -1 -1v-4c0 -.276 .111 -.525 .292 -.706", "key": "svg-1" }], ["path", { "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M14 7h6", "key": "svg-3" }], ["path", { "d": "M17 4v6", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconAppsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAppsOff
});

var IconApps = createReactComponent("outline", "apps", "IconApps", [["path", { "d": "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M14 7l6 0", "key": "svg-3" }], ["path", { "d": "M17 4l0 6", "key": "svg-4" }]]);

var IconApps$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconApps
});

var IconArcheryArrow = createReactComponent("outline", "archery-arrow", "IconArcheryArrow", [["path", { "d": "M14 7v3h3l3 -3h-3v-3z", "key": "svg-0" }], ["path", { "d": "M14 10l-9 9", "key": "svg-1" }], ["path", { "d": "M5 15v4h4", "key": "svg-2" }]]);

var IconArcheryArrow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArcheryArrow
});

var IconArchiveOff = createReactComponent("outline", "archive-off", "IconArchiveOff", [["path", { "d": "M8 4h11a2 2 0 1 1 0 4h-7m-4 0h-3a2 2 0 0 1 -.826 -3.822", "key": "svg-0" }], ["path", { "d": "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 1.824 -1.18m.176 -3.82v-7", "key": "svg-1" }], ["path", { "d": "M10 12h2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconArchiveOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArchiveOff
});

var IconArchive = createReactComponent("outline", "archive", "IconArchive", [["path", { "d": "M3 4m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10", "key": "svg-1" }], ["path", { "d": "M10 12l4 0", "key": "svg-2" }]]);

var IconArchive$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArchive
});

var IconArmchair2Off = createReactComponent("outline", "armchair-2-off", "IconArmchair2Off", [["path", { "d": "M5 10v-4a3 3 0 0 1 .128 -.869m2.038 -2.013c.264 -.078 .544 -.118 .834 -.118h8a3 3 0 0 1 3 3v4", "key": "svg-0" }], ["path", { "d": "M16.124 12.145a3 3 0 1 1 3.756 3.724m-.88 3.131h-14v-3a3 3 0 1 1 3 -3v2", "key": "svg-1" }], ["path", { "d": "M8 12h4", "key": "svg-2" }], ["path", { "d": "M7 19v2", "key": "svg-3" }], ["path", { "d": "M17 19v2", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconArmchair2Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArmchair2Off
});

var IconArmchair2 = createReactComponent("outline", "armchair-2", "IconArmchair2", [["path", { "d": "M5 10v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4", "key": "svg-0" }], ["path", { "d": "M16 15v-2a3 3 0 1 1 3 3v3h-14v-3a3 3 0 1 1 3 -3v2", "key": "svg-1" }], ["path", { "d": "M8 12h8", "key": "svg-2" }], ["path", { "d": "M7 19v2", "key": "svg-3" }], ["path", { "d": "M17 19v2", "key": "svg-4" }]]);

var IconArmchair2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArmchair2
});

var IconArmchairOff = createReactComponent("outline", "armchair-off", "IconArmchairOff", [["path", { "d": "M17 13a2 2 0 1 1 4 0v4m-2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 1 1 4 0v2h8.036", "key": "svg-0" }], ["path", { "d": "M5 11v-5a3 3 0 0 1 .134 -.89m1.987 -1.98a3 3 0 0 1 .879 -.13h8a3 3 0 0 1 3 3v5", "key": "svg-1" }], ["path", { "d": "M6 19v2", "key": "svg-2" }], ["path", { "d": "M18 19v2", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconArmchairOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArmchairOff
});

var IconArmchair = createReactComponent("outline", "armchair", "IconArmchair", [["path", { "d": "M5 11a2 2 0 0 1 2 2v2h10v-2a2 2 0 1 1 4 0v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M5 11v-5a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v5", "key": "svg-1" }], ["path", { "d": "M6 19v2", "key": "svg-2" }], ["path", { "d": "M18 19v2", "key": "svg-3" }]]);

var IconArmchair$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArmchair
});

var IconArrowAutofitContent = createReactComponent("outline", "arrow-autofit-content", "IconArrowAutofitContent", [["path", { "d": "M6 4l-3 3l3 3", "key": "svg-0" }], ["path", { "d": "M18 4l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M4 14m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-2" }], ["path", { "d": "M10 7h-7", "key": "svg-3" }], ["path", { "d": "M21 7h-7", "key": "svg-4" }]]);

var IconArrowAutofitContent$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitContent
});

var IconArrowAutofitDown = createReactComponent("outline", "arrow-autofit-down", "IconArrowAutofitDown", [["path", { "d": "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8", "key": "svg-0" }], ["path", { "d": "M18 4v17", "key": "svg-1" }], ["path", { "d": "M15 18l3 3l3 -3", "key": "svg-2" }]]);

var IconArrowAutofitDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitDown
});

var IconArrowAutofitHeight = createReactComponent("outline", "arrow-autofit-height", "IconArrowAutofitHeight", [["path", { "d": "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h6", "key": "svg-0" }], ["path", { "d": "M18 14v7", "key": "svg-1" }], ["path", { "d": "M18 3v7", "key": "svg-2" }], ["path", { "d": "M15 18l3 3l3 -3", "key": "svg-3" }], ["path", { "d": "M15 6l3 -3l3 3", "key": "svg-4" }]]);

var IconArrowAutofitHeight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitHeight
});

var IconArrowAutofitLeft = createReactComponent("outline", "arrow-autofit-left", "IconArrowAutofitLeft", [["path", { "d": "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M20 18h-17", "key": "svg-1" }], ["path", { "d": "M6 15l-3 3l3 3", "key": "svg-2" }]]);

var IconArrowAutofitLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitLeft
});

var IconArrowAutofitRight = createReactComponent("outline", "arrow-autofit-right", "IconArrowAutofitRight", [["path", { "d": "M20 12v-6a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v8", "key": "svg-0" }], ["path", { "d": "M4 18h17", "key": "svg-1" }], ["path", { "d": "M18 15l3 3l-3 3", "key": "svg-2" }]]);

var IconArrowAutofitRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitRight
});

var IconArrowAutofitUp = createReactComponent("outline", "arrow-autofit-up", "IconArrowAutofitUp", [["path", { "d": "M12 4h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8", "key": "svg-0" }], ["path", { "d": "M18 20v-17", "key": "svg-1" }], ["path", { "d": "M15 6l3 -3l3 3", "key": "svg-2" }]]);

var IconArrowAutofitUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitUp
});

var IconArrowAutofitWidth = createReactComponent("outline", "arrow-autofit-width", "IconArrowAutofitWidth", [["path", { "d": "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M10 18h-7", "key": "svg-1" }], ["path", { "d": "M21 18h-7", "key": "svg-2" }], ["path", { "d": "M6 15l-3 3l3 3", "key": "svg-3" }], ["path", { "d": "M18 15l3 3l-3 3", "key": "svg-4" }]]);

var IconArrowAutofitWidth$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitWidth
});

var IconArrowBackUpDouble = createReactComponent("outline", "arrow-back-up-double", "IconArrowBackUpDouble", [["path", { "d": "M13 14l-4 -4l4 -4", "key": "svg-0" }], ["path", { "d": "M8 14l-4 -4l4 -4", "key": "svg-1" }], ["path", { "d": "M9 10h7a4 4 0 1 1 0 8h-1", "key": "svg-2" }]]);

var IconArrowBackUpDouble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBackUpDouble
});

var IconArrowBackUp = createReactComponent("outline", "arrow-back-up", "IconArrowBackUp", [["path", { "d": "M9 14l-4 -4l4 -4", "key": "svg-0" }], ["path", { "d": "M5 10h11a4 4 0 1 1 0 8h-1", "key": "svg-1" }]]);

var IconArrowBackUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBackUp
});

var IconArrowBack = createReactComponent("outline", "arrow-back", "IconArrowBack", [["path", { "d": "M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1", "key": "svg-0" }]]);

var IconArrowBack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBack
});

var IconArrowBadgeDown = createReactComponent("outline", "arrow-badge-down", "IconArrowBadgeDown", [["path", { "d": "M17 13v-6l-5 4l-5 -4v6l5 4z", "key": "svg-0" }]]);

var IconArrowBadgeDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBadgeDown
});

var IconArrowBadgeLeft = createReactComponent("outline", "arrow-badge-left", "IconArrowBadgeLeft", [["path", { "d": "M11 17h6l-4 -5l4 -5h-6l-4 5z", "key": "svg-0" }]]);

var IconArrowBadgeLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBadgeLeft
});

var IconArrowBadgeRight = createReactComponent("outline", "arrow-badge-right", "IconArrowBadgeRight", [["path", { "d": "M13 7h-6l4 5l-4 5h6l4 -5z", "key": "svg-0" }]]);

var IconArrowBadgeRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBadgeRight
});

var IconArrowBadgeUp = createReactComponent("outline", "arrow-badge-up", "IconArrowBadgeUp", [["path", { "d": "M17 11v6l-5 -4l-5 4v-6l5 -4z", "key": "svg-0" }]]);

var IconArrowBadgeUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBadgeUp
});

var IconArrowBarBoth = createReactComponent("outline", "arrow-bar-both", "IconArrowBarBoth", [["path", { "d": "M8 12h-6", "key": "svg-0" }], ["path", { "d": "M5 15l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M22 12h-6", "key": "svg-2" }], ["path", { "d": "M19 15l3 -3l-3 -3", "key": "svg-3" }], ["path", { "d": "M12 4v16", "key": "svg-4" }]]);

var IconArrowBarBoth$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBarBoth
});

var IconArrowBarDown = createReactComponent("outline", "arrow-bar-down", "IconArrowBarDown", [["path", { "d": "M12 20l0 -10", "key": "svg-0" }], ["path", { "d": "M12 20l4 -4", "key": "svg-1" }], ["path", { "d": "M12 20l-4 -4", "key": "svg-2" }], ["path", { "d": "M4 4l16 0", "key": "svg-3" }]]);

var IconArrowBarDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBarDown
});

var IconArrowBarLeft = createReactComponent("outline", "arrow-bar-left", "IconArrowBarLeft", [["path", { "d": "M4 12l10 0", "key": "svg-0" }], ["path", { "d": "M4 12l4 4", "key": "svg-1" }], ["path", { "d": "M4 12l4 -4", "key": "svg-2" }], ["path", { "d": "M20 4l0 16", "key": "svg-3" }]]);

var IconArrowBarLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBarLeft
});

var IconArrowBarRight = createReactComponent("outline", "arrow-bar-right", "IconArrowBarRight", [["path", { "d": "M20 12l-10 0", "key": "svg-0" }], ["path", { "d": "M20 12l-4 4", "key": "svg-1" }], ["path", { "d": "M20 12l-4 -4", "key": "svg-2" }], ["path", { "d": "M4 4l0 16", "key": "svg-3" }]]);

var IconArrowBarRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBarRight
});

var IconArrowBarToDown = createReactComponent("outline", "arrow-bar-to-down", "IconArrowBarToDown", [["path", { "d": "M4 20l16 0", "key": "svg-0" }], ["path", { "d": "M12 14l0 -10", "key": "svg-1" }], ["path", { "d": "M12 14l4 -4", "key": "svg-2" }], ["path", { "d": "M12 14l-4 -4", "key": "svg-3" }]]);

var IconArrowBarToDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBarToDown
});

var IconArrowBarToLeft = createReactComponent("outline", "arrow-bar-to-left", "IconArrowBarToLeft", [["path", { "d": "M10 12l10 0", "key": "svg-0" }], ["path", { "d": "M10 12l4 4", "key": "svg-1" }], ["path", { "d": "M10 12l4 -4", "key": "svg-2" }], ["path", { "d": "M4 4l0 16", "key": "svg-3" }]]);

var IconArrowBarToLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBarToLeft
});

var IconArrowBarToRight = createReactComponent("outline", "arrow-bar-to-right", "IconArrowBarToRight", [["path", { "d": "M14 12l-10 0", "key": "svg-0" }], ["path", { "d": "M14 12l-4 4", "key": "svg-1" }], ["path", { "d": "M14 12l-4 -4", "key": "svg-2" }], ["path", { "d": "M20 4l0 16", "key": "svg-3" }]]);

var IconArrowBarToRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBarToRight
});

var IconArrowBarToUp = createReactComponent("outline", "arrow-bar-to-up", "IconArrowBarToUp", [["path", { "d": "M12 10l0 10", "key": "svg-0" }], ["path", { "d": "M12 10l4 4", "key": "svg-1" }], ["path", { "d": "M12 10l-4 4", "key": "svg-2" }], ["path", { "d": "M4 4l16 0", "key": "svg-3" }]]);

var IconArrowBarToUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBarToUp
});

var IconArrowBarUp = createReactComponent("outline", "arrow-bar-up", "IconArrowBarUp", [["path", { "d": "M12 4l0 10", "key": "svg-0" }], ["path", { "d": "M12 4l4 4", "key": "svg-1" }], ["path", { "d": "M12 4l-4 4", "key": "svg-2" }], ["path", { "d": "M4 20l16 0", "key": "svg-3" }]]);

var IconArrowBarUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBarUp
});

var IconArrowBearLeft2 = createReactComponent("outline", "arrow-bear-left-2", "IconArrowBearLeft2", [["path", { "d": "M9 3h-5v5", "key": "svg-0" }], ["path", { "d": "M4 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93", "key": "svg-1" }], ["path", { "d": "M20 5l-4.5 4.5", "key": "svg-2" }]]);

var IconArrowBearLeft2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBearLeft2
});

var IconArrowBearLeft = createReactComponent("outline", "arrow-bear-left", "IconArrowBearLeft", [["path", { "d": "M13 3h-5v5", "key": "svg-0" }], ["path", { "d": "M8 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93", "key": "svg-1" }]]);

var IconArrowBearLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBearLeft
});

var IconArrowBearRight2 = createReactComponent("outline", "arrow-bear-right-2", "IconArrowBearRight2", [["path", { "d": "M15 3h5v5", "key": "svg-0" }], ["path", { "d": "M20 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93", "key": "svg-1" }], ["path", { "d": "M4 5l4.5 4.5", "key": "svg-2" }]]);

var IconArrowBearRight2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBearRight2
});

var IconArrowBearRight = createReactComponent("outline", "arrow-bear-right", "IconArrowBearRight", [["path", { "d": "M12 3h5v5", "key": "svg-0" }], ["path", { "d": "M17 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93", "key": "svg-1" }]]);

var IconArrowBearRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBearRight
});

var IconArrowBigDownLine = createReactComponent("outline", "arrow-big-down-line", "IconArrowBigDownLine", [["path", { "d": "M15 12h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-6h6v6z", "key": "svg-0" }], ["path", { "d": "M15 3h-6", "key": "svg-1" }]]);

var IconArrowBigDownLine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigDownLine
});

var IconArrowBigDownLines = createReactComponent("outline", "arrow-big-down-lines", "IconArrowBigDownLines", [["path", { "d": "M15 12h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-3h6v3z", "key": "svg-0" }], ["path", { "d": "M15 3h-6", "key": "svg-1" }], ["path", { "d": "M15 6h-6", "key": "svg-2" }]]);

var IconArrowBigDownLines$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigDownLines
});

var IconArrowBigDown = createReactComponent("outline", "arrow-big-down", "IconArrowBigDown", [["path", { "d": "M15 4v8h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-8a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1z", "key": "svg-0" }]]);

var IconArrowBigDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigDown
});

var IconArrowBigLeftLine = createReactComponent("outline", "arrow-big-left-line", "IconArrowBigLeftLine", [["path", { "d": "M12 15v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h6v6h-6z", "key": "svg-0" }], ["path", { "d": "M21 15v-6", "key": "svg-1" }]]);

var IconArrowBigLeftLine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigLeftLine
});

var IconArrowBigLeftLines = createReactComponent("outline", "arrow-big-left-lines", "IconArrowBigLeftLines", [["path", { "d": "M12 15v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h3v6h-3z", "key": "svg-0" }], ["path", { "d": "M21 15v-6", "key": "svg-1" }], ["path", { "d": "M18 15v-6", "key": "svg-2" }]]);

var IconArrowBigLeftLines$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigLeftLines
});

var IconArrowBigLeft = createReactComponent("outline", "arrow-big-left", "IconArrowBigLeft", [["path", { "d": "M20 15h-8v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h8a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1z", "key": "svg-0" }]]);

var IconArrowBigLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigLeft
});

var IconArrowBigRightLine = createReactComponent("outline", "arrow-big-right-line", "IconArrowBigRightLine", [["path", { "d": "M12 9v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-6v-6h6z", "key": "svg-0" }], ["path", { "d": "M3 9v6", "key": "svg-1" }]]);

var IconArrowBigRightLine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigRightLine
});

var IconArrowBigRightLines = createReactComponent("outline", "arrow-big-right-lines", "IconArrowBigRightLines", [["path", { "d": "M12 9v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-3v-6h3z", "key": "svg-0" }], ["path", { "d": "M3 9v6", "key": "svg-1" }], ["path", { "d": "M6 9v6", "key": "svg-2" }]]);

var IconArrowBigRightLines$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigRightLines
});

var IconArrowBigRight = createReactComponent("outline", "arrow-big-right", "IconArrowBigRight", [["path", { "d": "M4 9h8v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconArrowBigRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigRight
});

var IconArrowBigUpLine = createReactComponent("outline", "arrow-big-up-line", "IconArrowBigUpLine", [["path", { "d": "M9 12h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v6h-6v-6z", "key": "svg-0" }], ["path", { "d": "M9 21h6", "key": "svg-1" }]]);

var IconArrowBigUpLine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigUpLine
});

var IconArrowBigUpLines = createReactComponent("outline", "arrow-big-up-lines", "IconArrowBigUpLines", [["path", { "d": "M9 12h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v3h-6v-3z", "key": "svg-0" }], ["path", { "d": "M9 21h6", "key": "svg-1" }], ["path", { "d": "M9 18h6", "key": "svg-2" }]]);

var IconArrowBigUpLines$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigUpLines
});

var IconArrowBigUp = createReactComponent("outline", "arrow-big-up", "IconArrowBigUp", [["path", { "d": "M9 20v-8h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v8a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }]]);

var IconArrowBigUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigUp
});

var IconArrowBounce = createReactComponent("outline", "arrow-bounce", "IconArrowBounce", [["path", { "d": "M10 18h4", "key": "svg-0" }], ["path", { "d": "M3 8a9 9 0 0 1 9 9v1l1.428 -4.285a12 12 0 0 1 6.018 -6.938l.554 -.277", "key": "svg-1" }], ["path", { "d": "M15 6h5v5", "key": "svg-2" }]]);

var IconArrowBounce$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBounce
});

var IconArrowCapsule = createReactComponent("outline", "arrow-capsule", "IconArrowCapsule", [["path", { "d": "M18 15a6 6 0 1 1 -12 0v-6a6 6 0 1 1 12 0v2", "key": "svg-0" }], ["path", { "d": "M15 8l3 3l3 -3", "key": "svg-1" }]]);

var IconArrowCapsule$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowCapsule
});

var IconArrowCurveLeft = createReactComponent("outline", "arrow-curve-left", "IconArrowCurveLeft", [["path", { "d": "M14 7l-4 -4l-4 4", "key": "svg-0" }], ["path", { "d": "M10 3v4.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v2.394", "key": "svg-1" }]]);

var IconArrowCurveLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowCurveLeft
});

var IconArrowCurveRight = createReactComponent("outline", "arrow-curve-right", "IconArrowCurveRight", [["path", { "d": "M10 7l4 -4l4 4", "key": "svg-0" }], ["path", { "d": "M14 3v4.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v2.394", "key": "svg-1" }]]);

var IconArrowCurveRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowCurveRight
});

var IconArrowDownBar = createReactComponent("outline", "arrow-down-bar", "IconArrowDownBar", [["path", { "d": "M12 3v18", "key": "svg-0" }], ["path", { "d": "M9 18l3 3l3 -3", "key": "svg-1" }], ["path", { "d": "M9 3h6", "key": "svg-2" }]]);

var IconArrowDownBar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownBar
});

var IconArrowDownCircle = createReactComponent("outline", "arrow-down-circle", "IconArrowDownCircle", [["path", { "d": "M12 7v14", "key": "svg-0" }], ["path", { "d": "M9 18l3 3l3 -3", "key": "svg-1" }], ["path", { "d": "M12 7a2 2 0 1 0 0 -4a2 2 0 0 0 0 4", "key": "svg-2" }]]);

var IconArrowDownCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownCircle
});

var IconArrowDownDashed = createReactComponent("outline", "arrow-down-dashed", "IconArrowDownDashed", [["path", { "d": "M12 5v.5m0 3v1.5m0 3v6", "key": "svg-0" }], ["path", { "d": "M18 13l-6 6", "key": "svg-1" }], ["path", { "d": "M6 13l6 6", "key": "svg-2" }]]);

var IconArrowDownDashed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownDashed
});

var IconArrowDownFromArc = createReactComponent("outline", "arrow-down-from-arc", "IconArrowDownFromArc", [["path", { "d": "M12 15v-12", "key": "svg-0" }], ["path", { "d": "M16 7l-4 -4l-4 4", "key": "svg-1" }], ["path", { "d": "M3 12a9 9 0 0 0 18 0", "key": "svg-2" }]]);

var IconArrowDownFromArc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownFromArc
});

var IconArrowDownLeftCircle = createReactComponent("outline", "arrow-down-left-circle", "IconArrowDownLeftCircle", [["path", { "d": "M15.536 8.464l-9.536 9.536", "key": "svg-0" }], ["path", { "d": "M6 14v4h4", "key": "svg-1" }], ["path", { "d": "M15.586 8.414a2 2 0 1 0 2.828 -2.828a2 2 0 0 0 -2.828 2.828", "key": "svg-2" }]]);

var IconArrowDownLeftCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownLeftCircle
});

var IconArrowDownLeft = createReactComponent("outline", "arrow-down-left", "IconArrowDownLeft", [["path", { "d": "M17 7l-10 10", "key": "svg-0" }], ["path", { "d": "M16 17l-9 0l0 -9", "key": "svg-1" }]]);

var IconArrowDownLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownLeft
});

var IconArrowDownRhombus = createReactComponent("outline", "arrow-down-rhombus", "IconArrowDownRhombus", [["path", { "d": "M12 8v13", "key": "svg-0" }], ["path", { "d": "M15 18l-3 3l-3 -3", "key": "svg-1" }], ["path", { "d": "M14.5 5.5l-2.5 -2.5l-2.5 2.5l2.5 2.5z", "key": "svg-2" }]]);

var IconArrowDownRhombus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownRhombus
});

var IconArrowDownRightCircle = createReactComponent("outline", "arrow-down-right-circle", "IconArrowDownRightCircle", [["path", { "d": "M8.464 8.464l9.536 9.536", "key": "svg-0" }], ["path", { "d": "M14 18h4v-4", "key": "svg-1" }], ["path", { "d": "M8.414 8.414a2 2 0 1 0 -2.828 -2.828a2 2 0 0 0 2.828 2.828", "key": "svg-2" }]]);

var IconArrowDownRightCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownRightCircle
});

var IconArrowDownRight = createReactComponent("outline", "arrow-down-right", "IconArrowDownRight", [["path", { "d": "M7 7l10 10", "key": "svg-0" }], ["path", { "d": "M17 8l0 9l-9 0", "key": "svg-1" }]]);

var IconArrowDownRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownRight
});

var IconArrowDownSquare = createReactComponent("outline", "arrow-down-square", "IconArrowDownSquare", [["path", { "d": "M12 7v14", "key": "svg-0" }], ["path", { "d": "M9 18l3 3l3 -3", "key": "svg-1" }], ["path", { "d": "M14 3v4h-4v-4z", "key": "svg-2" }]]);

var IconArrowDownSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownSquare
});

var IconArrowDownTail = createReactComponent("outline", "arrow-down-tail", "IconArrowDownTail", [["path", { "d": "M12 6v15", "key": "svg-0" }], ["path", { "d": "M9 18l3 3l3 -3", "key": "svg-1" }], ["path", { "d": "M9 3l3 3l3 -3", "key": "svg-2" }]]);

var IconArrowDownTail$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownTail
});

var IconArrowDownToArc = createReactComponent("outline", "arrow-down-to-arc", "IconArrowDownToArc", [["path", { "d": "M12 3v12", "key": "svg-0" }], ["path", { "d": "M16 11l-4 4l-4 -4", "key": "svg-1" }], ["path", { "d": "M3 12a9 9 0 0 0 18 0", "key": "svg-2" }]]);

var IconArrowDownToArc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownToArc
});

var IconArrowDown = createReactComponent("outline", "arrow-down", "IconArrowDown", [["path", { "d": "M12 5l0 14", "key": "svg-0" }], ["path", { "d": "M18 13l-6 6", "key": "svg-1" }], ["path", { "d": "M6 13l6 6", "key": "svg-2" }]]);

var IconArrowDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDown
});

var IconArrowElbowLeft = createReactComponent("outline", "arrow-elbow-left", "IconArrowElbowLeft", [["path", { "d": "M3 14v-6h6", "key": "svg-0" }], ["path", { "d": "M3 8l9 9l9 -9", "key": "svg-1" }]]);

var IconArrowElbowLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowElbowLeft
});

var IconArrowElbowRight = createReactComponent("outline", "arrow-elbow-right", "IconArrowElbowRight", [["path", { "d": "M21 14v-6h-6", "key": "svg-0" }], ["path", { "d": "M21 8l-9 9l-9 -9", "key": "svg-1" }]]);

var IconArrowElbowRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowElbowRight
});

var IconArrowFork = createReactComponent("outline", "arrow-fork", "IconArrowFork", [["path", { "d": "M16 3h5v5", "key": "svg-0" }], ["path", { "d": "M8 3h-5v5", "key": "svg-1" }], ["path", { "d": "M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93", "key": "svg-2" }], ["path", { "d": "M3 3l7.536 7.536a5 5 0 0 1 1.464 3.534v.93", "key": "svg-3" }]]);

var IconArrowFork$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowFork
});

var IconArrowForwardUpDouble = createReactComponent("outline", "arrow-forward-up-double", "IconArrowForwardUpDouble", [["path", { "d": "M11 14l4 -4l-4 -4", "key": "svg-0" }], ["path", { "d": "M16 14l4 -4l-4 -4", "key": "svg-1" }], ["path", { "d": "M15 10h-7a4 4 0 1 0 0 8h1", "key": "svg-2" }]]);

var IconArrowForwardUpDouble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowForwardUpDouble
});

var IconArrowForwardUp = createReactComponent("outline", "arrow-forward-up", "IconArrowForwardUp", [["path", { "d": "M15 14l4 -4l-4 -4", "key": "svg-0" }], ["path", { "d": "M19 10h-11a4 4 0 1 0 0 8h1", "key": "svg-1" }]]);

var IconArrowForwardUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowForwardUp
});

var IconArrowForward = createReactComponent("outline", "arrow-forward", "IconArrowForward", [["path", { "d": "M15 11l4 4l-4 4m4 -4h-11a4 4 0 0 1 0 -8h1", "key": "svg-0" }]]);

var IconArrowForward$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowForward
});

var IconArrowGuide = createReactComponent("outline", "arrow-guide", "IconArrowGuide", [["path", { "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M7 19h3a2 2 0 0 0 2 -2v-8a2 2 0 0 1 2 -2h7", "key": "svg-1" }], ["path", { "d": "M18 4l3 3l-3 3", "key": "svg-2" }]]);

var IconArrowGuide$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowGuide
});

var IconArrowIteration = createReactComponent("outline", "arrow-iteration", "IconArrowIteration", [["path", { "d": "M8.5 16a5.5 5.5 0 1 0 -5.5 -5.5v.5", "key": "svg-0" }], ["path", { "d": "M3 16h18", "key": "svg-1" }], ["path", { "d": "M18 13l3 3l-3 3", "key": "svg-2" }]]);

var IconArrowIteration$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowIteration
});

var IconArrowLeftBar = createReactComponent("outline", "arrow-left-bar", "IconArrowLeftBar", [["path", { "d": "M21 12h-18", "key": "svg-0" }], ["path", { "d": "M6 9l-3 3l3 3", "key": "svg-1" }], ["path", { "d": "M21 9v6", "key": "svg-2" }]]);

var IconArrowLeftBar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeftBar
});

var IconArrowLeftCircle = createReactComponent("outline", "arrow-left-circle", "IconArrowLeftCircle", [["path", { "d": "M17 12h-14", "key": "svg-0" }], ["path", { "d": "M6 9l-3 3l3 3", "key": "svg-1" }], ["path", { "d": "M19 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }]]);

var IconArrowLeftCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeftCircle
});

var IconArrowLeftDashed = createReactComponent("outline", "arrow-left-dashed", "IconArrowLeftDashed", [["path", { "d": "M5 12h6m3 0h1.5m3 0h.5", "key": "svg-0" }], ["path", { "d": "M5 12l6 6", "key": "svg-1" }], ["path", { "d": "M5 12l6 -6", "key": "svg-2" }]]);

var IconArrowLeftDashed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeftDashed
});

var IconArrowLeftFromArc = createReactComponent("outline", "arrow-left-from-arc", "IconArrowLeftFromArc", [["path", { "d": "M9 12h12", "key": "svg-0" }], ["path", { "d": "M17 16l4 -4l-4 -4", "key": "svg-1" }], ["path", { "d": "M12 3a9 9 0 1 0 0 18", "key": "svg-2" }]]);

var IconArrowLeftFromArc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeftFromArc
});

var IconArrowLeftRhombus = createReactComponent("outline", "arrow-left-rhombus", "IconArrowLeftRhombus", [["path", { "d": "M16 12h-13", "key": "svg-0" }], ["path", { "d": "M6 9l-3 3l3 3", "key": "svg-1" }], ["path", { "d": "M18.5 9.5l2.5 2.5l-2.5 2.5l-2.5 -2.5z", "key": "svg-2" }]]);

var IconArrowLeftRhombus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeftRhombus
});

var IconArrowLeftRight = createReactComponent("outline", "arrow-left-right", "IconArrowLeftRight", [["path", { "d": "M17 13l4 -4l-4 -4", "key": "svg-0" }], ["path", { "d": "M7 13l-4 -4l4 -4", "key": "svg-1" }], ["path", { "d": "M12 14a5 5 0 0 1 5 -5h4", "key": "svg-2" }], ["path", { "d": "M12 19v-5a5 5 0 0 0 -5 -5h-4", "key": "svg-3" }]]);

var IconArrowLeftRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeftRight
});

var IconArrowLeftSquare = createReactComponent("outline", "arrow-left-square", "IconArrowLeftSquare", [["path", { "d": "M17 12h-14", "key": "svg-0" }], ["path", { "d": "M6 9l-3 3l3 3", "key": "svg-1" }], ["path", { "d": "M21 14h-4v-4h4z", "key": "svg-2" }]]);

var IconArrowLeftSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeftSquare
});

var IconArrowLeftTail = createReactComponent("outline", "arrow-left-tail", "IconArrowLeftTail", [["path", { "d": "M18 12h-15", "key": "svg-0" }], ["path", { "d": "M6 9l-3 3l3 3", "key": "svg-1" }], ["path", { "d": "M21 9l-3 3l3 3", "key": "svg-2" }]]);

var IconArrowLeftTail$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeftTail
});

var IconArrowLeftToArc = createReactComponent("outline", "arrow-left-to-arc", "IconArrowLeftToArc", [["path", { "d": "M21 12h-12", "key": "svg-0" }], ["path", { "d": "M13 16l-4 -4l4 -4", "key": "svg-1" }], ["path", { "d": "M12 3a9 9 0 1 0 0 18", "key": "svg-2" }]]);

var IconArrowLeftToArc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeftToArc
});

var IconArrowLeft = createReactComponent("outline", "arrow-left", "IconArrowLeft", [["path", { "d": "M5 12l14 0", "key": "svg-0" }], ["path", { "d": "M5 12l6 6", "key": "svg-1" }], ["path", { "d": "M5 12l6 -6", "key": "svg-2" }]]);

var IconArrowLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeft
});

var IconArrowLoopLeft2 = createReactComponent("outline", "arrow-loop-left-2", "IconArrowLoopLeft2", [["path", { "d": "M13 21v-6m0 -6v-1a4 4 0 1 1 4 4h-13", "key": "svg-0" }], ["path", { "d": "M8 16l-4 -4l4 -4", "key": "svg-1" }]]);

var IconArrowLoopLeft2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLoopLeft2
});

var IconArrowLoopLeft = createReactComponent("outline", "arrow-loop-left", "IconArrowLoopLeft", [["path", { "d": "M13 21v-13a4 4 0 1 1 4 4h-13", "key": "svg-0" }], ["path", { "d": "M8 16l-4 -4l4 -4", "key": "svg-1" }]]);

var IconArrowLoopLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLoopLeft
});

var IconArrowLoopRight2 = createReactComponent("outline", "arrow-loop-right-2", "IconArrowLoopRight2", [["path", { "d": "M12 21v-6m0 -6v-1a4 4 0 1 0 -4 4h13", "key": "svg-0" }], ["path", { "d": "M17 16l4 -4l-4 -4", "key": "svg-1" }]]);

var IconArrowLoopRight2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLoopRight2
});

var IconArrowLoopRight = createReactComponent("outline", "arrow-loop-right", "IconArrowLoopRight", [["path", { "d": "M12 21v-13a4 4 0 1 0 -4 4h13", "key": "svg-0" }], ["path", { "d": "M17 16l4 -4l-4 -4", "key": "svg-1" }]]);

var IconArrowLoopRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLoopRight
});

var IconArrowMergeAltLeft = createReactComponent("outline", "arrow-merge-alt-left", "IconArrowMergeAltLeft", [["path", { "d": "M8 7l4 -4l4 4", "key": "svg-0" }], ["path", { "d": "M18 21v.01", "key": "svg-1" }], ["path", { "d": "M18 18.01v.01", "key": "svg-2" }], ["path", { "d": "M17 15.02v.01", "key": "svg-3" }], ["path", { "d": "M14 13.03v.01", "key": "svg-4" }], ["path", { "d": "M12 3v5.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v1.394", "key": "svg-5" }]]);

var IconArrowMergeAltLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMergeAltLeft
});

var IconArrowMergeAltRight = createReactComponent("outline", "arrow-merge-alt-right", "IconArrowMergeAltRight", [["path", { "d": "M16 7l-4 -4l-4 4", "key": "svg-0" }], ["path", { "d": "M6 21v.01", "key": "svg-1" }], ["path", { "d": "M6 18.01v.01", "key": "svg-2" }], ["path", { "d": "M7 15.02v.01", "key": "svg-3" }], ["path", { "d": "M10 13.03v.01", "key": "svg-4" }], ["path", { "d": "M12 3v5.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v1.394", "key": "svg-5" }]]);

var IconArrowMergeAltRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMergeAltRight
});

var IconArrowMergeBoth = createReactComponent("outline", "arrow-merge-both", "IconArrowMergeBoth", [["path", { "d": "M16 8l-4 -4l-4 4", "key": "svg-0" }], ["path", { "d": "M12 20v-16", "key": "svg-1" }], ["path", { "d": "M18 18c-4 -1.333 -6 -4.667 -6 -10", "key": "svg-2" }], ["path", { "d": "M6 18c4 -1.333 6 -4.667 6 -10", "key": "svg-3" }]]);

var IconArrowMergeBoth$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMergeBoth
});

var IconArrowMergeLeft = createReactComponent("outline", "arrow-merge-left", "IconArrowMergeLeft", [["path", { "d": "M8 8l4 -4l4 4", "key": "svg-0" }], ["path", { "d": "M12 20v-16", "key": "svg-1" }], ["path", { "d": "M6 18c4 -1.333 6 -4.667 6 -10", "key": "svg-2" }]]);

var IconArrowMergeLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMergeLeft
});

var IconArrowMergeRight = createReactComponent("outline", "arrow-merge-right", "IconArrowMergeRight", [["path", { "d": "M16 8l-4 -4l-4 4", "key": "svg-0" }], ["path", { "d": "M12 20v-16", "key": "svg-1" }], ["path", { "d": "M18 18c-4 -1.333 -6 -4.667 -6 -10", "key": "svg-2" }]]);

var IconArrowMergeRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMergeRight
});

var IconArrowMerge = createReactComponent("outline", "arrow-merge", "IconArrowMerge", [["path", { "d": "M8 7l4 -4l4 4", "key": "svg-0" }], ["path", { "d": "M12 3v5.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v1.394", "key": "svg-1" }], ["path", { "d": "M12 3v5.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v1.394", "key": "svg-2" }]]);

var IconArrowMerge$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMerge
});

var IconArrowMoveDown = createReactComponent("outline", "arrow-move-down", "IconArrowMoveDown", [["path", { "d": "M12 11v10", "key": "svg-0" }], ["path", { "d": "M9 18l3 3l3 -3", "key": "svg-1" }], ["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }]]);

var IconArrowMoveDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMoveDown
});

var IconArrowMoveLeft = createReactComponent("outline", "arrow-move-left", "IconArrowMoveLeft", [["path", { "d": "M13 12h-10", "key": "svg-0" }], ["path", { "d": "M6 15l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M17 12a2 2 0 1 1 4 0a2 2 0 0 1 -4 0z", "key": "svg-2" }]]);

var IconArrowMoveLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMoveLeft
});

var IconArrowMoveRight = createReactComponent("outline", "arrow-move-right", "IconArrowMoveRight", [["path", { "d": "M11 12h10", "key": "svg-0" }], ["path", { "d": "M18 9l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M7 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z", "key": "svg-2" }]]);

var IconArrowMoveRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMoveRight
});

var IconArrowMoveUp = createReactComponent("outline", "arrow-move-up", "IconArrowMoveUp", [["path", { "d": "M12 13v-10", "key": "svg-0" }], ["path", { "d": "M9 6l3 -3l3 3", "key": "svg-1" }], ["path", { "d": "M12 17a2 2 0 1 1 0 4a2 2 0 0 1 0 -4z", "key": "svg-2" }]]);

var IconArrowMoveUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMoveUp
});

var IconArrowNarrowDownDashed = createReactComponent("outline", "arrow-narrow-down-dashed", "IconArrowNarrowDownDashed", [["path", { "d": "M12 5v.5m0 3v1.5m0 3v6", "key": "svg-0" }], ["path", { "d": "M16 15l-4 4", "key": "svg-1" }], ["path", { "d": "M8 15l4 4", "key": "svg-2" }]]);

var IconArrowNarrowDownDashed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowNarrowDownDashed
});

var IconArrowNarrowDown = createReactComponent("outline", "arrow-narrow-down", "IconArrowNarrowDown", [["path", { "d": "M12 5l0 14", "key": "svg-0" }], ["path", { "d": "M16 15l-4 4", "key": "svg-1" }], ["path", { "d": "M8 15l4 4", "key": "svg-2" }]]);

var IconArrowNarrowDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowNarrowDown
});

var IconArrowNarrowLeftDashed = createReactComponent("outline", "arrow-narrow-left-dashed", "IconArrowNarrowLeftDashed", [["path", { "d": "M5 12h6m3 0h1.5m3 0h.5", "key": "svg-0" }], ["path", { "d": "M5 12l4 4", "key": "svg-1" }], ["path", { "d": "M5 12l4 -4", "key": "svg-2" }]]);

var IconArrowNarrowLeftDashed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowNarrowLeftDashed
});

var IconArrowNarrowLeft = createReactComponent("outline", "arrow-narrow-left", "IconArrowNarrowLeft", [["path", { "d": "M5 12l14 0", "key": "svg-0" }], ["path", { "d": "M5 12l4 4", "key": "svg-1" }], ["path", { "d": "M5 12l4 -4", "key": "svg-2" }]]);

var IconArrowNarrowLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowNarrowLeft
});

var IconArrowNarrowRightDashed = createReactComponent("outline", "arrow-narrow-right-dashed", "IconArrowNarrowRightDashed", [["path", { "d": "M5 12h.5m3 0h1.5m3 0h6", "key": "svg-0" }], ["path", { "d": "M15 16l4 -4", "key": "svg-1" }], ["path", { "d": "M15 8l4 4", "key": "svg-2" }]]);

var IconArrowNarrowRightDashed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowNarrowRightDashed
});

var IconArrowNarrowRight = createReactComponent("outline", "arrow-narrow-right", "IconArrowNarrowRight", [["path", { "d": "M5 12l14 0", "key": "svg-0" }], ["path", { "d": "M15 16l4 -4", "key": "svg-1" }], ["path", { "d": "M15 8l4 4", "key": "svg-2" }]]);

var IconArrowNarrowRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowNarrowRight
});

var IconArrowNarrowUpDashed = createReactComponent("outline", "arrow-narrow-up-dashed", "IconArrowNarrowUpDashed", [["path", { "d": "M12 5v6m0 3v1.5m0 3v.5", "key": "svg-0" }], ["path", { "d": "M16 9l-4 -4", "key": "svg-1" }], ["path", { "d": "M8 9l4 -4", "key": "svg-2" }]]);

var IconArrowNarrowUpDashed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowNarrowUpDashed
});

var IconArrowNarrowUp = createReactComponent("outline", "arrow-narrow-up", "IconArrowNarrowUp", [["path", { "d": "M12 5l0 14", "key": "svg-0" }], ["path", { "d": "M16 9l-4 -4", "key": "svg-1" }], ["path", { "d": "M8 9l4 -4", "key": "svg-2" }]]);

var IconArrowNarrowUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowNarrowUp
});

var IconArrowRampLeft2 = createReactComponent("outline", "arrow-ramp-left-2", "IconArrowRampLeft2", [["path", { "d": "M18 3v8.707", "key": "svg-0" }], ["path", { "d": "M8 14l-4 -4l4 -4", "key": "svg-1" }], ["path", { "d": "M18 21c0 -6.075 -4.925 -11 -11 -11h-3", "key": "svg-2" }]]);

var IconArrowRampLeft2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRampLeft2
});

var IconArrowRampLeft3 = createReactComponent("outline", "arrow-ramp-left-3", "IconArrowRampLeft3", [["path", { "d": "M18 3v6", "key": "svg-0" }], ["path", { "d": "M8 16l-4 -4l4 -4", "key": "svg-1" }], ["path", { "d": "M18 21v-6a3 3 0 0 0 -3 -3h-11", "key": "svg-2" }]]);

var IconArrowRampLeft3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRampLeft3
});

var IconArrowRampLeft = createReactComponent("outline", "arrow-ramp-left", "IconArrowRampLeft", [["path", { "d": "M17 3l0 8.707", "key": "svg-0" }], ["path", { "d": "M13 7l4 -4l4 4", "key": "svg-1" }], ["path", { "d": "M7 14l-4 -4l4 -4", "key": "svg-2" }], ["path", { "d": "M17 21a11 11 0 0 0 -11 -11h-3", "key": "svg-3" }]]);

var IconArrowRampLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRampLeft
});

var IconArrowRampRight2 = createReactComponent("outline", "arrow-ramp-right-2", "IconArrowRampRight2", [["path", { "d": "M6 3v8.707", "key": "svg-0" }], ["path", { "d": "M16 14l4 -4l-4 -4", "key": "svg-1" }], ["path", { "d": "M6 21c0 -6.075 4.925 -11 11 -11h3", "key": "svg-2" }]]);

var IconArrowRampRight2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRampRight2
});

var IconArrowRampRight3 = createReactComponent("outline", "arrow-ramp-right-3", "IconArrowRampRight3", [["path", { "d": "M6 3v6", "key": "svg-0" }], ["path", { "d": "M16 16l4 -4l-4 -4", "key": "svg-1" }], ["path", { "d": "M6 21v-6a3 3 0 0 1 3 -3h11", "key": "svg-2" }]]);

var IconArrowRampRight3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRampRight3
});

var IconArrowRampRight = createReactComponent("outline", "arrow-ramp-right", "IconArrowRampRight", [["path", { "d": "M7 3l0 8.707", "key": "svg-0" }], ["path", { "d": "M11 7l-4 -4l-4 4", "key": "svg-1" }], ["path", { "d": "M17 14l4 -4l-4 -4", "key": "svg-2" }], ["path", { "d": "M7 21a11 11 0 0 1 11 -11h3", "key": "svg-3" }]]);

var IconArrowRampRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRampRight
});

var IconArrowRightBar = createReactComponent("outline", "arrow-right-bar", "IconArrowRightBar", [["path", { "d": "M18 15l3 -3l-3 -3", "key": "svg-0" }], ["path", { "d": "M3 12h18", "key": "svg-1" }], ["path", { "d": "M3 9v6", "key": "svg-2" }]]);

var IconArrowRightBar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRightBar
});

var IconArrowRightCircle = createReactComponent("outline", "arrow-right-circle", "IconArrowRightCircle", [["path", { "d": "M18 15l3 -3l-3 -3", "key": "svg-0" }], ["path", { "d": "M5 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M7 12h14", "key": "svg-2" }]]);

var IconArrowRightCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRightCircle
});

var IconArrowRightDashed = createReactComponent("outline", "arrow-right-dashed", "IconArrowRightDashed", [["path", { "d": "M5 12h.5m3 0h1.5m3 0h6", "key": "svg-0" }], ["path", { "d": "M13 18l6 -6", "key": "svg-1" }], ["path", { "d": "M13 6l6 6", "key": "svg-2" }]]);

var IconArrowRightDashed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRightDashed
});

var IconArrowRightFromArc = createReactComponent("outline", "arrow-right-from-arc", "IconArrowRightFromArc", [["path", { "d": "M15 12h-12", "key": "svg-0" }], ["path", { "d": "M7 8l-4 4l4 4", "key": "svg-1" }], ["path", { "d": "M12 21a9 9 0 0 0 0 -18", "key": "svg-2" }]]);

var IconArrowRightFromArc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRightFromArc
});

var IconArrowRightRhombus = createReactComponent("outline", "arrow-right-rhombus", "IconArrowRightRhombus", [["path", { "d": "M8 12h13", "key": "svg-0" }], ["path", { "d": "M18 9l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M5.5 9.5l-2.5 2.5l2.5 2.5l2.5 -2.5z", "key": "svg-2" }]]);

var IconArrowRightRhombus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRightRhombus
});

var IconArrowRightSquare = createReactComponent("outline", "arrow-right-square", "IconArrowRightSquare", [["path", { "d": "M7 12l14 0", "key": "svg-0" }], ["path", { "d": "M18 15l3 -3l-3 -3", "key": "svg-1" }], ["path", { "d": "M3 10h4v4h-4z", "key": "svg-2" }]]);

var IconArrowRightSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRightSquare
});

var IconArrowRightTail = createReactComponent("outline", "arrow-right-tail", "IconArrowRightTail", [["path", { "d": "M18 15l3 -3l-3 -3", "key": "svg-0" }], ["path", { "d": "M3 15l3 -3l-3 -3", "key": "svg-1" }], ["path", { "d": "M6 12l15 0", "key": "svg-2" }]]);

var IconArrowRightTail$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRightTail
});

var IconArrowRightToArc = createReactComponent("outline", "arrow-right-to-arc", "IconArrowRightToArc", [["path", { "d": "M3 12h12", "key": "svg-0" }], ["path", { "d": "M11 8l4 4l-4 4", "key": "svg-1" }], ["path", { "d": "M12 21a9 9 0 0 0 0 -18", "key": "svg-2" }]]);

var IconArrowRightToArc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRightToArc
});

var IconArrowRight = createReactComponent("outline", "arrow-right", "IconArrowRight", [["path", { "d": "M5 12l14 0", "key": "svg-0" }], ["path", { "d": "M13 18l6 -6", "key": "svg-1" }], ["path", { "d": "M13 6l6 6", "key": "svg-2" }]]);

var IconArrowRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRight
});

var IconArrowRotaryFirstLeft = createReactComponent("outline", "arrow-rotary-first-left", "IconArrowRotaryFirstLeft", [["path", { "d": "M16 10a3 3 0 1 1 0 -6a3 3 0 0 1 0 6z", "key": "svg-0" }], ["path", { "d": "M16 10v10", "key": "svg-1" }], ["path", { "d": "M13.5 9.5l-8.5 8.5", "key": "svg-2" }], ["path", { "d": "M10 18h-5v-5", "key": "svg-3" }]]);

var IconArrowRotaryFirstLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRotaryFirstLeft
});

var IconArrowRotaryFirstRight = createReactComponent("outline", "arrow-rotary-first-right", "IconArrowRotaryFirstRight", [["path", { "d": "M8 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M8 10v10", "key": "svg-1" }], ["path", { "d": "M10.5 9.5l8.5 8.5", "key": "svg-2" }], ["path", { "d": "M14 18h5v-5", "key": "svg-3" }]]);

var IconArrowRotaryFirstRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRotaryFirstRight
});

var IconArrowRotaryLastLeft = createReactComponent("outline", "arrow-rotary-last-left", "IconArrowRotaryLastLeft", [["path", { "d": "M15 15a3 3 0 1 1 0 -6a3 3 0 0 1 0 6z", "key": "svg-0" }], ["path", { "d": "M15 15v6", "key": "svg-1" }], ["path", { "d": "M12.5 9.5l-6.5 -6.5", "key": "svg-2" }], ["path", { "d": "M11 3h-5v5", "key": "svg-3" }]]);

var IconArrowRotaryLastLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRotaryLastLeft
});

var IconArrowRotaryLastRight = createReactComponent("outline", "arrow-rotary-last-right", "IconArrowRotaryLastRight", [["path", { "d": "M9 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 15v6", "key": "svg-1" }], ["path", { "d": "M11.5 9.5l6.5 -6.5", "key": "svg-2" }], ["path", { "d": "M13 3h5v5", "key": "svg-3" }]]);

var IconArrowRotaryLastRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRotaryLastRight
});

var IconArrowRotaryLeft = createReactComponent("outline", "arrow-rotary-left", "IconArrowRotaryLeft", [["path", { "d": "M16 10a3 3 0 1 1 0 -6a3 3 0 0 1 0 6z", "key": "svg-0" }], ["path", { "d": "M16 10v10", "key": "svg-1" }], ["path", { "d": "M13 7h-10", "key": "svg-2" }], ["path", { "d": "M7 11l-4 -4l4 -4", "key": "svg-3" }]]);

var IconArrowRotaryLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRotaryLeft
});

var IconArrowRotaryRight = createReactComponent("outline", "arrow-rotary-right", "IconArrowRotaryRight", [["path", { "d": "M8 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M8 10v10", "key": "svg-1" }], ["path", { "d": "M17 11l4 -4l-4 -4", "key": "svg-2" }], ["path", { "d": "M11 7h10", "key": "svg-3" }]]);

var IconArrowRotaryRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRotaryRight
});

var IconArrowRotaryStraight = createReactComponent("outline", "arrow-rotary-straight", "IconArrowRotaryStraight", [["path", { "d": "M13 13m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M13 16v5", "key": "svg-1" }], ["path", { "d": "M13 3v7", "key": "svg-2" }], ["path", { "d": "M9 7l4 -4l4 4", "key": "svg-3" }]]);

var IconArrowRotaryStraight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRotaryStraight
});

var IconArrowRoundaboutLeft = createReactComponent("outline", "arrow-roundabout-left", "IconArrowRoundaboutLeft", [["path", { "d": "M3 9h8a5 5 0 1 1 5 5v7", "key": "svg-0" }], ["path", { "d": "M7 5l-4 4l4 4", "key": "svg-1" }]]);

var IconArrowRoundaboutLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRoundaboutLeft
});

var IconArrowRoundaboutRight = createReactComponent("outline", "arrow-roundabout-right", "IconArrowRoundaboutRight", [["path", { "d": "M21 9h-8a5 5 0 1 0 -5 5v7", "key": "svg-0" }], ["path", { "d": "M17 5l4 4l-4 4", "key": "svg-1" }]]);

var IconArrowRoundaboutRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRoundaboutRight
});

var IconArrowSharpTurnLeft = createReactComponent("outline", "arrow-sharp-turn-left", "IconArrowSharpTurnLeft", [["path", { "d": "M17 18v-11.31a.7 .7 0 0 0 -1.195 -.495l-9.805 9.805", "key": "svg-0" }], ["path", { "d": "M11 16h-5v-5", "key": "svg-1" }]]);

var IconArrowSharpTurnLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowSharpTurnLeft
});

var IconArrowSharpTurnRight = createReactComponent("outline", "arrow-sharp-turn-right", "IconArrowSharpTurnRight", [["path", { "d": "M7 18v-11.31a.7 .7 0 0 1 1.195 -.495l9.805 9.805", "key": "svg-0" }], ["path", { "d": "M13 16h5v-5", "key": "svg-1" }]]);

var IconArrowSharpTurnRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowSharpTurnRight
});

var IconArrowUpBar = createReactComponent("outline", "arrow-up-bar", "IconArrowUpBar", [["path", { "d": "M12 21l0 -18", "key": "svg-0" }], ["path", { "d": "M15 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M9 21l6 0", "key": "svg-2" }]]);

var IconArrowUpBar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpBar
});

var IconArrowUpCircle = createReactComponent("outline", "arrow-up-circle", "IconArrowUpCircle", [["path", { "d": "M12 17v-14", "key": "svg-0" }], ["path", { "d": "M15 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M12 17a2 2 0 1 0 0 4a2 2 0 0 0 0 -4", "key": "svg-2" }]]);

var IconArrowUpCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpCircle
});

var IconArrowUpDashed = createReactComponent("outline", "arrow-up-dashed", "IconArrowUpDashed", [["path", { "d": "M12 5v6m0 3v1.5m0 3v.5", "key": "svg-0" }], ["path", { "d": "M18 11l-6 -6", "key": "svg-1" }], ["path", { "d": "M6 11l6 -6", "key": "svg-2" }]]);

var IconArrowUpDashed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpDashed
});

var IconArrowUpFromArc = createReactComponent("outline", "arrow-up-from-arc", "IconArrowUpFromArc", [["path", { "d": "M12 9v12", "key": "svg-0" }], ["path", { "d": "M8 17l4 4l4 -4", "key": "svg-1" }], ["path", { "d": "M21 12a9 9 0 0 0 -18 0", "key": "svg-2" }]]);

var IconArrowUpFromArc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpFromArc
});

var IconArrowUpLeftCircle = createReactComponent("outline", "arrow-up-left-circle", "IconArrowUpLeftCircle", [["path", { "d": "M15.536 15.536l-9.536 -9.536", "key": "svg-0" }], ["path", { "d": "M10 6h-4v4", "key": "svg-1" }], ["path", { "d": "M15.586 15.586a2 2 0 1 0 2.828 2.828a2 2 0 0 0 -2.828 -2.828", "key": "svg-2" }]]);

var IconArrowUpLeftCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpLeftCircle
});

var IconArrowUpLeft = createReactComponent("outline", "arrow-up-left", "IconArrowUpLeft", [["path", { "d": "M7 7l10 10", "key": "svg-0" }], ["path", { "d": "M16 7l-9 0l0 9", "key": "svg-1" }]]);

var IconArrowUpLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpLeft
});

var IconArrowUpRhombus = createReactComponent("outline", "arrow-up-rhombus", "IconArrowUpRhombus", [["path", { "d": "M12 16v-13", "key": "svg-0" }], ["path", { "d": "M15 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M14.5 18.5l-2.5 2.5l-2.5 -2.5l2.5 -2.5z", "key": "svg-2" }]]);

var IconArrowUpRhombus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpRhombus
});

var IconArrowUpRightCircle = createReactComponent("outline", "arrow-up-right-circle", "IconArrowUpRightCircle", [["path", { "d": "M8.464 15.536l9.536 -9.536", "key": "svg-0" }], ["path", { "d": "M18 10v-4h-4", "key": "svg-1" }], ["path", { "d": "M8.414 15.586a2 2 0 1 0 -2.828 2.828a2 2 0 0 0 2.828 -2.828", "key": "svg-2" }]]);

var IconArrowUpRightCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpRightCircle
});

var IconArrowUpRight = createReactComponent("outline", "arrow-up-right", "IconArrowUpRight", [["path", { "d": "M17 7l-10 10", "key": "svg-0" }], ["path", { "d": "M8 7l9 0l0 9", "key": "svg-1" }]]);

var IconArrowUpRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpRight
});

var IconArrowUpSquare = createReactComponent("outline", "arrow-up-square", "IconArrowUpSquare", [["path", { "d": "M12 17l0 -14", "key": "svg-0" }], ["path", { "d": "M15 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M10 21v-4h4v4z", "key": "svg-2" }]]);

var IconArrowUpSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpSquare
});

var IconArrowUpTail = createReactComponent("outline", "arrow-up-tail", "IconArrowUpTail", [["path", { "d": "M12 18l0 -15", "key": "svg-0" }], ["path", { "d": "M15 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M15 21l-3 -3l-3 3", "key": "svg-2" }]]);

var IconArrowUpTail$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpTail
});

var IconArrowUpToArc = createReactComponent("outline", "arrow-up-to-arc", "IconArrowUpToArc", [["path", { "d": "M12 21v-12", "key": "svg-0" }], ["path", { "d": "M8 13l4 -4l4 4", "key": "svg-1" }], ["path", { "d": "M21 12a9 9 0 0 0 -18 0", "key": "svg-2" }]]);

var IconArrowUpToArc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpToArc
});

var IconArrowUp = createReactComponent("outline", "arrow-up", "IconArrowUp", [["path", { "d": "M12 5l0 14", "key": "svg-0" }], ["path", { "d": "M18 11l-6 -6", "key": "svg-1" }], ["path", { "d": "M6 11l6 -6", "key": "svg-2" }]]);

var IconArrowUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUp
});

var IconArrowWaveLeftDown = createReactComponent("outline", "arrow-wave-left-down", "IconArrowWaveLeftDown", [["path", { "d": "M7 14h-4v-4", "key": "svg-0" }], ["path", { "d": "M21 12c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3.113 -.716 -4 -2s-2.48 -2.033 -4 -2c-1.52 -.033 -3 1 -4 2l-2 2", "key": "svg-1" }]]);

var IconArrowWaveLeftDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowWaveLeftDown
});

var IconArrowWaveLeftUp = createReactComponent("outline", "arrow-wave-left-up", "IconArrowWaveLeftUp", [["path", { "d": "M7 10h-4v4", "key": "svg-0" }], ["path", { "d": "M21 12c-.887 -1.285 -2.48 -2.033 -4 -2c-1.52 -.033 -3.113 .715 -4 2c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3 -1 -4 -2l-2 -2", "key": "svg-1" }]]);

var IconArrowWaveLeftUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowWaveLeftUp
});

var IconArrowWaveRightDown = createReactComponent("outline", "arrow-wave-right-down", "IconArrowWaveRightDown", [["path", { "d": "M17 14h4v-4", "key": "svg-0" }], ["path", { "d": "M3 12c.887 1.284 2.48 2.033 4 2c1.52 .033 3.113 -.716 4 -2s2.48 -2.033 4 -2c1.52 -.033 3 1 4 2l2 2", "key": "svg-1" }]]);

var IconArrowWaveRightDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowWaveRightDown
});

var IconArrowWaveRightUp = createReactComponent("outline", "arrow-wave-right-up", "IconArrowWaveRightUp", [["path", { "d": "M17 10h4v4", "key": "svg-0" }], ["path", { "d": "M3 12c.887 -1.284 2.48 -2.033 4 -2c1.52 -.033 3.113 .716 4 2s2.48 2.033 4 2c1.52 .033 3 -1 4 -2l2 -2", "key": "svg-1" }]]);

var IconArrowWaveRightUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowWaveRightUp
});

var IconArrowZigZag = createReactComponent("outline", "arrow-zig-zag", "IconArrowZigZag", [["path", { "d": "M6 20v-10l10 6v-12", "key": "svg-0" }], ["path", { "d": "M13 7l3 -3l3 3", "key": "svg-1" }]]);

var IconArrowZigZag$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowZigZag
});

var IconArrowsCross = createReactComponent("outline", "arrows-cross", "IconArrowsCross", [["path", { "d": "M16 4h4v4", "key": "svg-0" }], ["path", { "d": "M15 9l5 -5", "key": "svg-1" }], ["path", { "d": "M4 20l5 -5", "key": "svg-2" }], ["path", { "d": "M16 20h4v-4", "key": "svg-3" }], ["path", { "d": "M4 4l16 16", "key": "svg-4" }]]);

var IconArrowsCross$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsCross
});

var IconArrowsDiagonal2 = createReactComponent("outline", "arrows-diagonal-2", "IconArrowsDiagonal2", [["path", { "d": "M16 20l4 0l0 -4", "key": "svg-0" }], ["path", { "d": "M14 14l6 6", "key": "svg-1" }], ["path", { "d": "M8 4l-4 0l0 4", "key": "svg-2" }], ["path", { "d": "M4 4l6 6", "key": "svg-3" }]]);

var IconArrowsDiagonal2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsDiagonal2
});

var IconArrowsDiagonalMinimize2 = createReactComponent("outline", "arrows-diagonal-minimize-2", "IconArrowsDiagonalMinimize2", [["path", { "d": "M18 10h-4v-4", "key": "svg-0" }], ["path", { "d": "M20 4l-6 6", "key": "svg-1" }], ["path", { "d": "M6 14h4v4", "key": "svg-2" }], ["path", { "d": "M10 14l-6 6", "key": "svg-3" }]]);

var IconArrowsDiagonalMinimize2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsDiagonalMinimize2
});

var IconArrowsDiagonalMinimize = createReactComponent("outline", "arrows-diagonal-minimize", "IconArrowsDiagonalMinimize", [["path", { "d": "M6 10h4v-4", "key": "svg-0" }], ["path", { "d": "M4 4l6 6", "key": "svg-1" }], ["path", { "d": "M18 14h-4v4", "key": "svg-2" }], ["path", { "d": "M14 14l6 6", "key": "svg-3" }]]);

var IconArrowsDiagonalMinimize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsDiagonalMinimize
});

var IconArrowsDiagonal = createReactComponent("outline", "arrows-diagonal", "IconArrowsDiagonal", [["path", { "d": "M16 4l4 0l0 4", "key": "svg-0" }], ["path", { "d": "M14 10l6 -6", "key": "svg-1" }], ["path", { "d": "M8 20l-4 0l0 -4", "key": "svg-2" }], ["path", { "d": "M4 20l6 -6", "key": "svg-3" }]]);

var IconArrowsDiagonal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsDiagonal
});

var IconArrowsDiff = createReactComponent("outline", "arrows-diff", "IconArrowsDiff", [["path", { "d": "M11 16h10", "key": "svg-0" }], ["path", { "d": "M11 16l4 4", "key": "svg-1" }], ["path", { "d": "M11 16l4 -4", "key": "svg-2" }], ["path", { "d": "M13 8h-10", "key": "svg-3" }], ["path", { "d": "M13 8l-4 4", "key": "svg-4" }], ["path", { "d": "M13 8l-4 -4", "key": "svg-5" }]]);

var IconArrowsDiff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsDiff
});

var IconArrowsDoubleNeSw = createReactComponent("outline", "arrows-double-ne-sw", "IconArrowsDoubleNeSw", [["path", { "d": "M3 14l11 -11", "key": "svg-0" }], ["path", { "d": "M10 3h4v4", "key": "svg-1" }], ["path", { "d": "M10 17v4h4", "key": "svg-2" }], ["path", { "d": "M21 10l-11 11", "key": "svg-3" }]]);

var IconArrowsDoubleNeSw$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsDoubleNeSw
});

var IconArrowsDoubleNwSe = createReactComponent("outline", "arrows-double-nw-se", "IconArrowsDoubleNwSe", [["path", { "d": "M14 21l-11 -11", "key": "svg-0" }], ["path", { "d": "M3 14v-4h4", "key": "svg-1" }], ["path", { "d": "M17 14h4v-4", "key": "svg-2" }], ["path", { "d": "M10 3l11 11", "key": "svg-3" }]]);

var IconArrowsDoubleNwSe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsDoubleNwSe
});

var IconArrowsDoubleSeNw = createReactComponent("outline", "arrows-double-se-nw", "IconArrowsDoubleSeNw", [["path", { "d": "M3 10l11 11", "key": "svg-0" }], ["path", { "d": "M14 17v4h-4", "key": "svg-1" }], ["path", { "d": "M14 3h-4v4", "key": "svg-2" }], ["path", { "d": "M21 14l-11 -11", "key": "svg-3" }]]);

var IconArrowsDoubleSeNw$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsDoubleSeNw
});

var IconArrowsDoubleSwNe = createReactComponent("outline", "arrows-double-sw-ne", "IconArrowsDoubleSwNe", [["path", { "d": "M14 3l-11 11", "key": "svg-0" }], ["path", { "d": "M3 10v4h4", "key": "svg-1" }], ["path", { "d": "M17 10h4v4", "key": "svg-2" }], ["path", { "d": "M10 21l11 -11", "key": "svg-3" }]]);

var IconArrowsDoubleSwNe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsDoubleSwNe
});

var IconArrowsDownUp = createReactComponent("outline", "arrows-down-up", "IconArrowsDownUp", [["path", { "d": "M17 3l0 18", "key": "svg-0" }], ["path", { "d": "M10 18l-3 3l-3 -3", "key": "svg-1" }], ["path", { "d": "M7 21l0 -18", "key": "svg-2" }], ["path", { "d": "M20 6l-3 -3l-3 3", "key": "svg-3" }]]);

var IconArrowsDownUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsDownUp
});

var IconArrowsDown = createReactComponent("outline", "arrows-down", "IconArrowsDown", [["path", { "d": "M7 21l0 -18", "key": "svg-0" }], ["path", { "d": "M20 18l-3 3l-3 -3", "key": "svg-1" }], ["path", { "d": "M4 18l3 3l3 -3", "key": "svg-2" }], ["path", { "d": "M17 21l0 -18", "key": "svg-3" }]]);

var IconArrowsDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsDown
});

var IconArrowsExchange2 = createReactComponent("outline", "arrows-exchange-2", "IconArrowsExchange2", [["path", { "d": "M17 10h-14l4 -4", "key": "svg-0" }], ["path", { "d": "M7 14h14l-4 4", "key": "svg-1" }]]);

var IconArrowsExchange2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsExchange2
});

var IconArrowsExchange = createReactComponent("outline", "arrows-exchange", "IconArrowsExchange", [["path", { "d": "M7 10h14l-4 -4", "key": "svg-0" }], ["path", { "d": "M17 14h-14l4 4", "key": "svg-1" }]]);

var IconArrowsExchange$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsExchange
});

var IconArrowsHorizontal = createReactComponent("outline", "arrows-horizontal", "IconArrowsHorizontal", [["path", { "d": "M7 8l-4 4l4 4", "key": "svg-0" }], ["path", { "d": "M17 8l4 4l-4 4", "key": "svg-1" }], ["path", { "d": "M3 12l18 0", "key": "svg-2" }]]);

var IconArrowsHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsHorizontal
});

var IconArrowsJoin2 = createReactComponent("outline", "arrows-join-2", "IconArrowsJoin2", [["path", { "d": "M3 7h1.948c1.913 0 3.705 .933 4.802 2.5a5.861 5.861 0 0 0 4.802 2.5h6.448", "key": "svg-0" }], ["path", { "d": "M3 17h1.95a5.854 5.854 0 0 0 4.798 -2.5a5.854 5.854 0 0 1 4.798 -2.5h5.454", "key": "svg-1" }], ["path", { "d": "M18 15l3 -3l-3 -3", "key": "svg-2" }]]);

var IconArrowsJoin2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsJoin2
});

var IconArrowsJoin = createReactComponent("outline", "arrows-join", "IconArrowsJoin", [["path", { "d": "M3 7h5l3.5 5h9.5", "key": "svg-0" }], ["path", { "d": "M3 17h5l3.495 -5", "key": "svg-1" }], ["path", { "d": "M18 15l3 -3l-3 -3", "key": "svg-2" }]]);

var IconArrowsJoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsJoin
});

var IconArrowsLeftDown = createReactComponent("outline", "arrows-left-down", "IconArrowsLeftDown", [["path", { "d": "M7 3l-4 4l4 4", "key": "svg-0" }], ["path", { "d": "M3 7h11a3 3 0 0 1 3 3v11", "key": "svg-1" }], ["path", { "d": "M13 17l4 4l4 -4", "key": "svg-2" }]]);

var IconArrowsLeftDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsLeftDown
});

var IconArrowsLeftRight = createReactComponent("outline", "arrows-left-right", "IconArrowsLeftRight", [["path", { "d": "M21 17l-18 0", "key": "svg-0" }], ["path", { "d": "M6 10l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M3 7l18 0", "key": "svg-2" }], ["path", { "d": "M18 20l3 -3l-3 -3", "key": "svg-3" }]]);

var IconArrowsLeftRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsLeftRight
});

var IconArrowsLeft = createReactComponent("outline", "arrows-left", "IconArrowsLeft", [["path", { "d": "M3 7l18 0", "key": "svg-0" }], ["path", { "d": "M6 20l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M6 4l-3 3l3 3", "key": "svg-2" }], ["path", { "d": "M3 17l18 0", "key": "svg-3" }]]);

var IconArrowsLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsLeft
});

var IconArrowsMaximize = createReactComponent("outline", "arrows-maximize", "IconArrowsMaximize", [["path", { "d": "M16 4l4 0l0 4", "key": "svg-0" }], ["path", { "d": "M14 10l6 -6", "key": "svg-1" }], ["path", { "d": "M8 20l-4 0l0 -4", "key": "svg-2" }], ["path", { "d": "M4 20l6 -6", "key": "svg-3" }], ["path", { "d": "M16 20l4 0l0 -4", "key": "svg-4" }], ["path", { "d": "M14 14l6 6", "key": "svg-5" }], ["path", { "d": "M8 4l-4 0l0 4", "key": "svg-6" }], ["path", { "d": "M4 4l6 6", "key": "svg-7" }]]);

var IconArrowsMaximize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsMaximize
});

var IconArrowsMinimize = createReactComponent("outline", "arrows-minimize", "IconArrowsMinimize", [["path", { "d": "M5 9l4 0l0 -4", "key": "svg-0" }], ["path", { "d": "M3 3l6 6", "key": "svg-1" }], ["path", { "d": "M5 15l4 0l0 4", "key": "svg-2" }], ["path", { "d": "M3 21l6 -6", "key": "svg-3" }], ["path", { "d": "M19 9l-4 0l0 -4", "key": "svg-4" }], ["path", { "d": "M15 9l6 -6", "key": "svg-5" }], ["path", { "d": "M19 15l-4 0l0 4", "key": "svg-6" }], ["path", { "d": "M15 15l6 6", "key": "svg-7" }]]);

var IconArrowsMinimize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsMinimize
});

var IconArrowsMoveHorizontal = createReactComponent("outline", "arrows-move-horizontal", "IconArrowsMoveHorizontal", [["path", { "d": "M18 9l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M15 12h6", "key": "svg-1" }], ["path", { "d": "M6 9l-3 3l3 3", "key": "svg-2" }], ["path", { "d": "M3 12h6", "key": "svg-3" }]]);

var IconArrowsMoveHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsMoveHorizontal
});

var IconArrowsMoveVertical = createReactComponent("outline", "arrows-move-vertical", "IconArrowsMoveVertical", [["path", { "d": "M9 18l3 3l3 -3", "key": "svg-0" }], ["path", { "d": "M12 15v6", "key": "svg-1" }], ["path", { "d": "M15 6l-3 -3l-3 3", "key": "svg-2" }], ["path", { "d": "M12 3v6", "key": "svg-3" }]]);

var IconArrowsMoveVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsMoveVertical
});

var IconArrowsMove = createReactComponent("outline", "arrows-move", "IconArrowsMove", [["path", { "d": "M18 9l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M15 12h6", "key": "svg-1" }], ["path", { "d": "M6 9l-3 3l3 3", "key": "svg-2" }], ["path", { "d": "M3 12h6", "key": "svg-3" }], ["path", { "d": "M9 18l3 3l3 -3", "key": "svg-4" }], ["path", { "d": "M12 15v6", "key": "svg-5" }], ["path", { "d": "M15 6l-3 -3l-3 3", "key": "svg-6" }], ["path", { "d": "M12 3v6", "key": "svg-7" }]]);

var IconArrowsMove$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsMove
});

var IconArrowsRandom = createReactComponent("outline", "arrows-random", "IconArrowsRandom", [["path", { "d": "M20 21h-4v-4", "key": "svg-0" }], ["path", { "d": "M16 21l5 -5", "key": "svg-1" }], ["path", { "d": "M6.5 9.504l-3.5 -2l2 -3.504", "key": "svg-2" }], ["path", { "d": "M3 7.504l6.83 -1.87", "key": "svg-3" }], ["path", { "d": "M4 16l4 -1l1 4", "key": "svg-4" }], ["path", { "d": "M8 15l-3.5 6", "key": "svg-5" }], ["path", { "d": "M21 5l-.5 4l-4 -.5", "key": "svg-6" }], ["path", { "d": "M20.5 9l-4.5 -5.5", "key": "svg-7" }]]);

var IconArrowsRandom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsRandom
});

var IconArrowsRightDown = createReactComponent("outline", "arrows-right-down", "IconArrowsRightDown", [["path", { "d": "M3 17l4 4l4 -4", "key": "svg-0" }], ["path", { "d": "M7 21v-11a3 3 0 0 1 3 -3h11", "key": "svg-1" }], ["path", { "d": "M17 11l4 -4l-4 -4", "key": "svg-2" }]]);

var IconArrowsRightDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsRightDown
});

var IconArrowsRightLeft = createReactComponent("outline", "arrows-right-left", "IconArrowsRightLeft", [["path", { "d": "M21 7l-18 0", "key": "svg-0" }], ["path", { "d": "M18 10l3 -3l-3 -3", "key": "svg-1" }], ["path", { "d": "M6 20l-3 -3l3 -3", "key": "svg-2" }], ["path", { "d": "M3 17l18 0", "key": "svg-3" }]]);

var IconArrowsRightLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsRightLeft
});

var IconArrowsRight = createReactComponent("outline", "arrows-right", "IconArrowsRight", [["path", { "d": "M21 17l-18 0", "key": "svg-0" }], ["path", { "d": "M18 4l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M18 20l3 -3l-3 -3", "key": "svg-2" }], ["path", { "d": "M21 7l-18 0", "key": "svg-3" }]]);

var IconArrowsRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsRight
});

var IconArrowsShuffle2 = createReactComponent("outline", "arrows-shuffle-2", "IconArrowsShuffle2", [["path", { "d": "M18 4l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M18 20l3 -3l-3 -3", "key": "svg-1" }], ["path", { "d": "M3 7h3a5 5 0 0 1 5 5a5 5 0 0 0 5 5h5", "key": "svg-2" }], ["path", { "d": "M3 17h3a5 5 0 0 0 5 -5a5 5 0 0 1 5 -5h5", "key": "svg-3" }]]);

var IconArrowsShuffle2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsShuffle2
});

var IconArrowsShuffle = createReactComponent("outline", "arrows-shuffle", "IconArrowsShuffle", [["path", { "d": "M18 4l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M18 20l3 -3l-3 -3", "key": "svg-1" }], ["path", { "d": "M3 7h3a5 5 0 0 1 5 5a5 5 0 0 0 5 5h5", "key": "svg-2" }], ["path", { "d": "M21 7h-5a4.978 4.978 0 0 0 -3 1m-4 8a4.984 4.984 0 0 1 -3 1h-3", "key": "svg-3" }]]);

var IconArrowsShuffle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsShuffle
});

var IconArrowsSort = createReactComponent("outline", "arrows-sort", "IconArrowsSort", [["path", { "d": "M3 9l4 -4l4 4m-4 -4v14", "key": "svg-0" }], ["path", { "d": "M21 15l-4 4l-4 -4m4 4v-14", "key": "svg-1" }]]);

var IconArrowsSort$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsSort
});

var IconArrowsSplit2 = createReactComponent("outline", "arrows-split-2", "IconArrowsSplit2", [["path", { "d": "M21 17h-5.397a5 5 0 0 1 -4.096 -2.133l-.514 -.734a5 5 0 0 0 -4.096 -2.133h-3.897", "key": "svg-0" }], ["path", { "d": "M21 7h-5.395a5 5 0 0 0 -4.098 2.135l-.51 .73a5 5 0 0 1 -4.097 2.135h-3.9", "key": "svg-1" }], ["path", { "d": "M18 10l3 -3l-3 -3", "key": "svg-2" }], ["path", { "d": "M18 20l3 -3l-3 -3", "key": "svg-3" }]]);

var IconArrowsSplit2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsSplit2
});

var IconArrowsSplit = createReactComponent("outline", "arrows-split", "IconArrowsSplit", [["path", { "d": "M21 17h-8l-3.5 -5h-6.5", "key": "svg-0" }], ["path", { "d": "M21 7h-8l-3.495 5", "key": "svg-1" }], ["path", { "d": "M18 10l3 -3l-3 -3", "key": "svg-2" }], ["path", { "d": "M18 20l3 -3l-3 -3", "key": "svg-3" }]]);

var IconArrowsSplit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsSplit
});

var IconArrowsTransferDown = createReactComponent("outline", "arrows-transfer-down", "IconArrowsTransferDown", [["path", { "d": "M17 3v6", "key": "svg-0" }], ["path", { "d": "M10 18l-3 3l-3 -3", "key": "svg-1" }], ["path", { "d": "M7 21v-18", "key": "svg-2" }], ["path", { "d": "M20 6l-3 -3l-3 3", "key": "svg-3" }], ["path", { "d": "M17 21v-2", "key": "svg-4" }], ["path", { "d": "M17 15v-2", "key": "svg-5" }]]);

var IconArrowsTransferDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsTransferDown
});

var IconArrowsTransferUpDown = createReactComponent("outline", "arrows-transfer-up-down", "IconArrowsTransferUpDown", [["path", { "d": "M7 21v-6", "key": "svg-0" }], ["path", { "d": "M20 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M10 18l-3 3l-3 -3", "key": "svg-2" }], ["path", { "d": "M7 3v2", "key": "svg-3" }], ["path", { "d": "M7 9v2", "key": "svg-4" }], ["path", { "d": "M17 3v6", "key": "svg-5" }], ["path", { "d": "M17 21v-2", "key": "svg-6" }], ["path", { "d": "M17 15v-2", "key": "svg-7" }]]);

var IconArrowsTransferUpDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsTransferUpDown
});

var IconArrowsTransferUp = createReactComponent("outline", "arrows-transfer-up", "IconArrowsTransferUp", [["path", { "d": "M7 21v-6", "key": "svg-0" }], ["path", { "d": "M20 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M17 3v18", "key": "svg-2" }], ["path", { "d": "M10 18l-3 3l-3 -3", "key": "svg-3" }], ["path", { "d": "M7 3v2", "key": "svg-4" }], ["path", { "d": "M7 9v2", "key": "svg-5" }]]);

var IconArrowsTransferUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsTransferUp
});

var IconArrowsUpDown = createReactComponent("outline", "arrows-up-down", "IconArrowsUpDown", [["path", { "d": "M7 3l0 18", "key": "svg-0" }], ["path", { "d": "M10 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M20 18l-3 3l-3 -3", "key": "svg-2" }], ["path", { "d": "M17 21l0 -18", "key": "svg-3" }]]);

var IconArrowsUpDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsUpDown
});

var IconArrowsUpLeft = createReactComponent("outline", "arrows-up-left", "IconArrowsUpLeft", [["path", { "d": "M21 7l-4 -4l-4 4", "key": "svg-0" }], ["path", { "d": "M17 3v11a3 3 0 0 1 -3 3h-11", "key": "svg-1" }], ["path", { "d": "M7 13l-4 4l4 4", "key": "svg-2" }]]);

var IconArrowsUpLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsUpLeft
});

var IconArrowsUpRight = createReactComponent("outline", "arrows-up-right", "IconArrowsUpRight", [["path", { "d": "M17 21l4 -4l-4 -4", "key": "svg-0" }], ["path", { "d": "M21 17h-11a3 3 0 0 1 -3 -3v-11", "key": "svg-1" }], ["path", { "d": "M11 7l-4 -4l-4 4", "key": "svg-2" }]]);

var IconArrowsUpRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsUpRight
});

var IconArrowsUp = createReactComponent("outline", "arrows-up", "IconArrowsUp", [["path", { "d": "M17 3l0 18", "key": "svg-0" }], ["path", { "d": "M4 6l3 -3l3 3", "key": "svg-1" }], ["path", { "d": "M20 6l-3 -3l-3 3", "key": "svg-2" }], ["path", { "d": "M7 3l0 18", "key": "svg-3" }]]);

var IconArrowsUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsUp
});

var IconArrowsVertical = createReactComponent("outline", "arrows-vertical", "IconArrowsVertical", [["path", { "d": "M8 7l4 -4l4 4", "key": "svg-0" }], ["path", { "d": "M8 17l4 4l4 -4", "key": "svg-1" }], ["path", { "d": "M12 3l0 18", "key": "svg-2" }]]);

var IconArrowsVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowsVertical
});

var IconArtboardOff = createReactComponent("outline", "artboard-off", "IconArtboardOff", [["path", { "d": "M12 8h3a1 1 0 0 1 1 1v3", "key": "svg-0" }], ["path", { "d": "M15.716 15.698a1 1 0 0 1 -.716 .302h-6a1 1 0 0 1 -1 -1v-6c0 -.273 .11 -.52 .287 -.7", "key": "svg-1" }], ["path", { "d": "M3 8h1", "key": "svg-2" }], ["path", { "d": "M3 16h1", "key": "svg-3" }], ["path", { "d": "M8 3v1", "key": "svg-4" }], ["path", { "d": "M16 3v1", "key": "svg-5" }], ["path", { "d": "M20 8h1", "key": "svg-6" }], ["path", { "d": "M20 16h1", "key": "svg-7" }], ["path", { "d": "M8 20v1", "key": "svg-8" }], ["path", { "d": "M16 20v1", "key": "svg-9" }], ["path", { "d": "M3 3l18 18", "key": "svg-10" }]]);

var IconArtboardOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArtboardOff
});

var IconArtboard = createReactComponent("outline", "artboard", "IconArtboard", [["path", { "d": "M8 8m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M3 8l1 0", "key": "svg-1" }], ["path", { "d": "M3 16l1 0", "key": "svg-2" }], ["path", { "d": "M8 3l0 1", "key": "svg-3" }], ["path", { "d": "M16 3l0 1", "key": "svg-4" }], ["path", { "d": "M20 8l1 0", "key": "svg-5" }], ["path", { "d": "M20 16l1 0", "key": "svg-6" }], ["path", { "d": "M8 20l0 1", "key": "svg-7" }], ["path", { "d": "M16 20l0 1", "key": "svg-8" }]]);

var IconArtboard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArtboard
});

var IconArticleOff = createReactComponent("outline", "article-off", "IconArticleOff", [["path", { "d": "M8 4h11a2 2 0 0 1 2 2v11m-1.172 2.821a1.993 1.993 0 0 1 -.828 .179h-14a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 1.156 -1.814", "key": "svg-0" }], ["path", { "d": "M7 8h1m4 0h5", "key": "svg-1" }], ["path", { "d": "M7 12h5m4 0h1", "key": "svg-2" }], ["path", { "d": "M7 16h9", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconArticleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArticleOff
});

var IconArticle = createReactComponent("outline", "article", "IconArticle", [["path", { "d": "M3 4m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 8h10", "key": "svg-1" }], ["path", { "d": "M7 12h10", "key": "svg-2" }], ["path", { "d": "M7 16h10", "key": "svg-3" }]]);

var IconArticle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArticle
});

var IconAspectRatioOff = createReactComponent("outline", "aspect-ratio-off", "IconAspectRatioOff", [["path", { "d": "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M7 12v-3h2", "key": "svg-1" }], ["path", { "d": "M17 12v1m-2 2h-1", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconAspectRatioOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAspectRatioOff
});

var IconAspectRatio = createReactComponent("outline", "aspect-ratio", "IconAspectRatio", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 12v-3h3", "key": "svg-1" }], ["path", { "d": "M17 12v3h-3", "key": "svg-2" }]]);

var IconAspectRatio$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAspectRatio
});

var IconAssemblyOff = createReactComponent("outline", "assembly-off", "IconAssemblyOff", [["path", { "d": "M18.376 18.377l-5.284 3.343a2.27 2.27 0 0 1 -2.184 0l-6.75 -4.27a2.23 2.23 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l1.328 -.783m2.514 -1.487l2.908 -1.71a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .417 -.118 .817 -.33 1.16", "key": "svg-0" }], ["path", { "d": "M14.855 14.855l-2.37 1.519a1 1 0 0 1 -.97 0l-3 -1.922a1 1 0 0 1 -.515 -.876v-3.278c0 -.364 .197 -.7 .514 -.877l.563 -.336m2.437 -1.454a1.03 1.03 0 0 1 1 0l3 1.79h-.014c.312 .181 .503 .516 .5 .877v1.702", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconAssemblyOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAssemblyOff
});

var IconAssembly = createReactComponent("outline", "assembly", "IconAssembly", [["path", { "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.27 2.27 0 0 1 -2.184 0l-6.75 -4.27a2.23 2.23 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98z", "key": "svg-0" }], ["path", { "d": "M15.5 9.422c.312 .18 .503 .515 .5 .876v3.277c0 .364 -.197 .7 -.515 .877l-3 1.922a1 1 0 0 1 -.97 0l-3 -1.922a1 1 0 0 1 -.515 -.876v-3.278c0 -.364 .197 -.7 .514 -.877l3 -1.79c.311 -.174 .69 -.174 1 0l3 1.79h-.014z", "key": "svg-1" }]]);

var IconAssembly$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAssembly
});

var IconAsset = createReactComponent("outline", "asset", "IconAsset", [["path", { "d": "M9 15m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-0" }], ["path", { "d": "M9 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M14.218 17.975l6.619 -12.174", "key": "svg-3" }], ["path", { "d": "M6.079 9.756l12.217 -6.631", "key": "svg-4" }], ["path", { "d": "M9 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-5" }]]);

var IconAsset$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAsset
});

var IconAsteriskSimple = createReactComponent("outline", "asterisk-simple", "IconAsteriskSimple", [["path", { "d": "M12 12v-9", "key": "svg-0" }], ["path", { "d": "M12 12l-9 -2.5", "key": "svg-1" }], ["path", { "d": "M12 12l9 -2.5", "key": "svg-2" }], ["path", { "d": "M12 12l6 8.5", "key": "svg-3" }], ["path", { "d": "M12 12l-6 8.5", "key": "svg-4" }]]);

var IconAsteriskSimple$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAsteriskSimple
});

var IconAsterisk = createReactComponent("outline", "asterisk", "IconAsterisk", [["path", { "d": "M12 12l8 -4.5", "key": "svg-0" }], ["path", { "d": "M12 12v9", "key": "svg-1" }], ["path", { "d": "M12 12l-8 -4.5", "key": "svg-2" }], ["path", { "d": "M12 12l8 4.5", "key": "svg-3" }], ["path", { "d": "M12 3v9", "key": "svg-4" }], ["path", { "d": "M12 12l-8 4.5", "key": "svg-5" }]]);

var IconAsterisk$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAsterisk
});

var IconAtOff = createReactComponent("outline", "at-off", "IconAtOff", [["path", { "d": "M9.174 9.17a4 4 0 0 0 5.646 5.668m1.18 -2.838a4 4 0 0 0 -4 -4", "key": "svg-0" }], ["path", { "d": "M19.695 15.697a2.5 2.5 0 0 0 1.305 -2.197v-1.5a9 9 0 0 0 -13.055 -8.047m-2.322 1.683a9 9 0 0 0 9.877 14.644", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconAtOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAtOff
});

var IconAt = createReactComponent("outline", "at", "IconAt", [["path", { "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M16 12v1.5a2.5 2.5 0 0 0 5 0v-1.5a9 9 0 1 0 -5.5 8.28", "key": "svg-1" }]]);

var IconAt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAt
});

var IconAtom2 = createReactComponent("outline", "atom-2", "IconAtom2", [["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12 21l0 .01", "key": "svg-1" }], ["path", { "d": "M3 9l0 .01", "key": "svg-2" }], ["path", { "d": "M21 9l0 .01", "key": "svg-3" }], ["path", { "d": "M8 20.1a9 9 0 0 1 -5 -7.1", "key": "svg-4" }], ["path", { "d": "M16 20.1a9 9 0 0 0 5 -7.1", "key": "svg-5" }], ["path", { "d": "M6.2 5a9 9 0 0 1 11.4 0", "key": "svg-6" }]]);

var IconAtom2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAtom2
});

var IconAtomOff = createReactComponent("outline", "atom-off", "IconAtomOff", [["path", { "d": "M12 12v.01", "key": "svg-0" }], ["path", { "d": "M9.172 9.172c-3.906 3.905 -5.805 8.337 -4.243 9.9c1.562 1.561 6 -.338 9.9 -4.244m1.884 -2.113c2.587 -3.277 3.642 -6.502 2.358 -7.786c-1.284 -1.284 -4.508 -.23 -7.784 2.357", "key": "svg-1" }], ["path", { "d": "M4.929 4.929c-1.562 1.562 .337 6 4.243 9.9c3.905 3.905 8.337 5.804 9.9 4.242m-.072 -4.071c-.767 -1.794 -2.215 -3.872 -4.172 -5.828c-1.944 -1.945 -4.041 -3.402 -5.828 -4.172", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconAtomOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAtomOff
});

var IconAtom = createReactComponent("outline", "atom", "IconAtom", [["path", { "d": "M12 12v.01", "key": "svg-0" }], ["path", { "d": "M19.071 4.929c-1.562 -1.562 -6 .337 -9.9 4.243c-3.905 3.905 -5.804 8.337 -4.242 9.9c1.562 1.561 6 -.338 9.9 -4.244c3.905 -3.905 5.804 -8.337 4.242 -9.9", "key": "svg-1" }], ["path", { "d": "M4.929 4.929c-1.562 1.562 .337 6 4.243 9.9c3.905 3.905 8.337 5.804 9.9 4.242c1.561 -1.562 -.338 -6 -4.244 -9.9c-3.905 -3.905 -8.337 -5.804 -9.9 -4.242", "key": "svg-2" }]]);

var IconAtom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAtom
});

var IconAugmentedReality2 = createReactComponent("outline", "augmented-reality-2", "IconAugmentedReality2", [["path", { "d": "M10 21h-2a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M17 17l-4 -2.5l4 -2.5l4 2.5v4.5l-4 2.5z", "key": "svg-1" }], ["path", { "d": "M13 14.5v4.5l4 2.5", "key": "svg-2" }], ["path", { "d": "M17 17l4 -2.5", "key": "svg-3" }], ["path", { "d": "M11 4h2", "key": "svg-4" }]]);

var IconAugmentedReality2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAugmentedReality2
});

var IconAugmentedRealityOff = createReactComponent("outline", "augmented-reality-off", "IconAugmentedRealityOff", [["path", { "d": "M4 8v-2c0 -.557 .228 -1.061 .595 -1.424", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2c.558 0 1.062 -.228 1.425 -.596", "key": "svg-3" }], ["path", { "d": "M12 12.5l.312 -.195m2.457 -1.536l1.231 -.769", "key": "svg-4" }], ["path", { "d": "M9.225 9.235l-1.225 .765l4 2.5v4.5l3.076 -1.923m.924 -3.077v-2l-4 -2.5l-.302 .189", "key": "svg-5" }], ["path", { "d": "M8 10v4.5l4 2.5", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconAugmentedRealityOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAugmentedRealityOff
});

var IconAugmentedReality = createReactComponent("outline", "augmented-reality", "IconAugmentedReality", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M12 12.5l4 -2.5", "key": "svg-4" }], ["path", { "d": "M8 10l4 2.5v4.5l4 -2.5v-4.5l-4 -2.5z", "key": "svg-5" }], ["path", { "d": "M8 10v4.5l4 2.5", "key": "svg-6" }]]);

var IconAugmentedReality$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAugmentedReality
});

var IconAuth2fa = createReactComponent("outline", "auth-2fa", "IconAuth2fa", [["path", { "d": "M7 16h-4l3.47 -4.66a2 2 0 1 0 -3.47 -1.54", "key": "svg-0" }], ["path", { "d": "M10 16v-8h4", "key": "svg-1" }], ["path", { "d": "M10 12l3 0", "key": "svg-2" }], ["path", { "d": "M17 16v-6a2 2 0 0 1 4 0v6", "key": "svg-3" }], ["path", { "d": "M17 13l4 0", "key": "svg-4" }]]);

var IconAuth2fa$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAuth2fa
});

var IconAutomaticGearbox = createReactComponent("outline", "automatic-gearbox", "IconAutomaticGearbox", [["path", { "d": "M17 17v4h1a2 2 0 1 0 0 -4h-1z", "key": "svg-0" }], ["path", { "d": "M17 11h1.5a1.5 1.5 0 0 0 0 -3h-1.5v5", "key": "svg-1" }], ["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M5 7v3a1 1 0 0 0 1 1h3v7a1 1 0 0 0 1 1h3", "key": "svg-3" }], ["path", { "d": "M9 11h4", "key": "svg-4" }]]);

var IconAutomaticGearbox$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAutomaticGearbox
});

var IconAutomation = createReactComponent("outline", "automation", "IconAutomation", [["path", { "d": "M13 20.693c-.905 .628 -2.36 .292 -2.675 -1.01a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.492 .362 1.716 2.219 .674 3.03", "key": "svg-0" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 22l5 -3l-5 -3z", "key": "svg-2" }]]);

var IconAutomation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAutomation
});

var IconAvocado = createReactComponent("outline", "avocado", "IconAvocado", [["path", { "d": "M17.8 14.04a3.905 3.905 0 0 1 1.337 -2.075c1.195 -.985 1.816 -2.285 1.863 -3.902c-.047 -1.43 -.54 -2.626 -1.477 -3.586c-.96 -.938 -2.156 -1.43 -3.585 -1.477c-1.618 .047 -2.918 .668 -3.903 1.863c-.562 .68 -1.254 1.125 -2.074 1.336c-.938 .188 -1.828 .48 -2.672 .88c-.844 .398 -1.559 .878 -2.144 1.44c-1.43 1.501 -2.145 3.224 -2.145 5.169c0 1.946 .715 3.668 2.145 5.168c1.5 1.429 3.222 2.144 5.168 2.144c1.945 0 3.667 -.715 5.167 -2.145c.563 -.585 1.055 -1.3 1.477 -2.144c.398 -.844 .68 -1.723 .844 -2.637v-.035z", "key": "svg-0" }], ["path", { "d": "M10.87 10.036c-.942 .112 -1.794 .538 -2.556 1.278c-.74 .762 -1.166 1.614 -1.278 2.556c-.135 .92 .112 1.704 .74 2.354c.65 .628 1.435 .875 2.354 .74c.942 -.112 1.794 -.538 2.556 -1.278c.74 -.762 1.166 -1.614 1.278 -2.556c.135 -.92 -.112 -1.704 -.74 -2.354c-.65 -.628 -1.435 -.875 -2.354 -.74z", "key": "svg-1" }]]);

var IconAvocado$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAvocado
});

var IconAwardOff = createReactComponent("outline", "award-off", "IconAwardOff", [["path", { "d": "M16.72 12.704a6 6 0 0 0 -8.433 -8.418m-1.755 2.24a6 6 0 0 0 7.936 7.944", "key": "svg-0" }], ["path", { "d": "M12 15l3.4 5.89l1.598 -3.233l.707 .046m1.108 -2.902l-1.617 -2.8", "key": "svg-1" }], ["path", { "d": "M6.802 12l-3.4 5.89l3.598 -.233l1.598 3.232l3.4 -5.889", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconAwardOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAwardOff
});

var IconAward = createReactComponent("outline", "award", "IconAward", [["path", { "d": "M12 9m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-0" }], ["path", { "d": "M12 15l3.4 5.89l1.598 -3.233l3.598 .232l-3.4 -5.889", "key": "svg-1" }], ["path", { "d": "M6.802 12l-3.4 5.89l3.598 -.233l1.598 3.232l3.4 -5.889", "key": "svg-2" }]]);

var IconAward$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAward
});

var IconAxe = createReactComponent("outline", "axe", "IconAxe", [["path", { "d": "M13 9l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385", "key": "svg-0" }], ["path", { "d": "M6.66 15.66l-3.32 -3.32a1.25 1.25 0 0 1 .42 -2.044l3.24 -1.296l6 -6l3 3l-6 6l-1.296 3.24a1.25 1.25 0 0 1 -2.044 .42z", "key": "svg-1" }]]);

var IconAxe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAxe
});

var IconAxisX = createReactComponent("outline", "axis-x", "IconAxisX", [["path", { "d": "M4 13v.01", "key": "svg-0" }], ["path", { "d": "M4 9v.01", "key": "svg-1" }], ["path", { "d": "M4 5v.01", "key": "svg-2" }], ["path", { "d": "M17 20l3 -3l-3 -3", "key": "svg-3" }], ["path", { "d": "M4 17h16", "key": "svg-4" }]]);

var IconAxisX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAxisX
});

var IconAxisY = createReactComponent("outline", "axis-y", "IconAxisY", [["path", { "d": "M11 20h-.01", "key": "svg-0" }], ["path", { "d": "M15 20h-.01", "key": "svg-1" }], ["path", { "d": "M19 20h-.01", "key": "svg-2" }], ["path", { "d": "M4 7l3 -3l3 3", "key": "svg-3" }], ["path", { "d": "M7 20v-16", "key": "svg-4" }]]);

var IconAxisY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAxisY
});

var IconBabyBottle = createReactComponent("outline", "baby-bottle", "IconBabyBottle", [["path", { "d": "M5 10h14", "key": "svg-0" }], ["path", { "d": "M12 2v2", "key": "svg-1" }], ["path", { "d": "M12 4a5 5 0 0 1 5 5v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-11a5 5 0 0 1 5 -5z", "key": "svg-2" }]]);

var IconBabyBottle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBabyBottle
});

var IconBabyCarriage = createReactComponent("outline", "baby-carriage", "IconBabyCarriage", [["path", { "d": "M8 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M18 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M2 5h2.5l1.632 4.897a6 6 0 0 0 5.693 4.103h2.675a5.5 5.5 0 0 0 0 -11h-.5v6", "key": "svg-2" }], ["path", { "d": "M6 9h14", "key": "svg-3" }], ["path", { "d": "M9 17l1 -3", "key": "svg-4" }], ["path", { "d": "M16 14l1 3", "key": "svg-5" }]]);

var IconBabyCarriage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBabyCarriage
});

var IconBackground = createReactComponent("outline", "background", "IconBackground", [["path", { "d": "M4 8l4 -4", "key": "svg-0" }], ["path", { "d": "M14 4l-10 10", "key": "svg-1" }], ["path", { "d": "M4 20l16 -16", "key": "svg-2" }], ["path", { "d": "M20 10l-10 10", "key": "svg-3" }], ["path", { "d": "M20 16l-4 4", "key": "svg-4" }]]);

var IconBackground$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBackground
});

var IconBackhoe = createReactComponent("outline", "backhoe", "IconBackhoe", [["path", { "d": "M4 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M13 19l-9 0", "key": "svg-2" }], ["path", { "d": "M4 15l9 0", "key": "svg-3" }], ["path", { "d": "M8 12v-5h2a3 3 0 0 1 3 3v5", "key": "svg-4" }], ["path", { "d": "M5 15v-2a1 1 0 0 1 1 -1h7", "key": "svg-5" }], ["path", { "d": "M21.12 9.88l-3.12 -4.88l-5 5", "key": "svg-6" }], ["path", { "d": "M21.12 9.88a3 3 0 0 1 -2.12 5.12a3 3 0 0 1 -2.12 -.88l4.24 -4.24z", "key": "svg-7" }]]);

var IconBackhoe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBackhoe
});

var IconBackpackOff = createReactComponent("outline", "backpack-off", "IconBackpackOff", [["path", { "d": "M10 6h3a6 6 0 0 1 6 6v3m-.129 3.872a3 3 0 0 1 -2.871 2.128h-8a3 3 0 0 1 -3 -3v-6a5.99 5.99 0 0 1 2.285 -4.712", "key": "svg-0" }], ["path", { "d": "M10 6v-1a2 2 0 1 1 4 0v1", "key": "svg-1" }], ["path", { "d": "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconBackpackOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBackpackOff
});

var IconBackpack = createReactComponent("outline", "backpack", "IconBackpack", [["path", { "d": "M5 18v-6a6 6 0 0 1 6 -6h2a6 6 0 0 1 6 6v6a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M10 6v-1a2 2 0 1 1 4 0v1", "key": "svg-1" }], ["path", { "d": "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4", "key": "svg-2" }], ["path", { "d": "M11 10h2", "key": "svg-3" }]]);

var IconBackpack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBackpack
});

var IconBackslash = createReactComponent("outline", "backslash", "IconBackslash", [["path", { "d": "M7 5l10 14", "key": "svg-0" }]]);

var IconBackslash$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBackslash
});

var IconBackspace = createReactComponent("outline", "backspace", "IconBackspace", [["path", { "d": "M20 6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-11l-5 -5a1.5 1.5 0 0 1 0 -2l5 -5z", "key": "svg-0" }], ["path", { "d": "M12 10l4 4m0 -4l-4 4", "key": "svg-1" }]]);

var IconBackspace$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBackspace
});

var IconBadge2k = createReactComponent("outline", "badge-2k", "IconBadge2k", [["path", { "d": "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 9v6", "key": "svg-1" }], ["path", { "d": "M17 9l-2 3l2 3", "key": "svg-2" }], ["path", { "d": "M15 12h-1", "key": "svg-3" }], ["path", { "d": "M7 9h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2", "key": "svg-4" }]]);

var IconBadge2k$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadge2k
});

var IconBadge3d = createReactComponent("outline", "badge-3d", "IconBadge3d", [["path", { "d": "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 9h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5", "key": "svg-1" }], ["path", { "d": "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z", "key": "svg-2" }]]);

var IconBadge3d$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadge3d
});

var IconBadge3k = createReactComponent("outline", "badge-3k", "IconBadge3k", [["path", { "d": "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 9v6", "key": "svg-1" }], ["path", { "d": "M17 9l-2 3l2 3", "key": "svg-2" }], ["path", { "d": "M15 12h-1", "key": "svg-3" }], ["path", { "d": "M7 9.5a.5 .5 0 0 1 .5 -.5h1a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1a.5 .5 0 0 1 -.5 -.5", "key": "svg-4" }]]);

var IconBadge3k$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadge3k
});

var IconBadge4k = createReactComponent("outline", "badge-4k", "IconBadge4k", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 9v2a1 1 0 0 0 1 1h1", "key": "svg-1" }], ["path", { "d": "M10 9v6", "key": "svg-2" }], ["path", { "d": "M14 9v6", "key": "svg-3" }], ["path", { "d": "M17 9l-2 3l2 3", "key": "svg-4" }], ["path", { "d": "M15 12h-1", "key": "svg-5" }]]);

var IconBadge4k$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadge4k
});

var IconBadge5k = createReactComponent("outline", "badge-5k", "IconBadge5k", [["path", { "d": "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 9v6", "key": "svg-1" }], ["path", { "d": "M17 9l-2 3l2 3", "key": "svg-2" }], ["path", { "d": "M15 12h-1", "key": "svg-3" }], ["path", { "d": "M7 15h2a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2v-3h3", "key": "svg-4" }]]);

var IconBadge5k$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadge5k
});

var IconBadge8k = createReactComponent("outline", "badge-8k", "IconBadge8k", [["path", { "d": "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 9v6", "key": "svg-1" }], ["path", { "d": "M17 9l-2 3l2 3", "key": "svg-2" }], ["path", { "d": "M15 12h-1", "key": "svg-3" }], ["path", { "d": "M8.5 12h-.5a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1zh-.5a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1", "key": "svg-4" }]]);

var IconBadge8k$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadge8k
});

var IconBadgeAdOff = createReactComponent("outline", "badge-ad-off", "IconBadgeAdOff", [["path", { "d": "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M14 14v1h1m2 -2v-2a2 2 0 0 0 -2 -2h-1v1", "key": "svg-1" }], ["path", { "d": "M7 15v-4.5a1.5 1.5 0 0 1 2.077 -1.385m.788 .762c.087 .19 .135 .4 .135 .623v4.5", "key": "svg-2" }], ["path", { "d": "M7 13h3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconBadgeAdOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeAdOff
});

var IconBadgeAd = createReactComponent("outline", "badge-ad", "IconBadgeAd", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z", "key": "svg-1" }], ["path", { "d": "M7 15v-4.5a1.5 1.5 0 0 1 3 0v4.5", "key": "svg-2" }], ["path", { "d": "M7 13h3", "key": "svg-3" }]]);

var IconBadgeAd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeAd
});

var IconBadgeAr = createReactComponent("outline", "badge-ar", "IconBadgeAr", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 15v-4.5a1.5 1.5 0 0 1 3 0v4.5", "key": "svg-1" }], ["path", { "d": "M7 13h3", "key": "svg-2" }], ["path", { "d": "M14 12h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6m3 0l-2 -3", "key": "svg-3" }]]);

var IconBadgeAr$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeAr
});

var IconBadgeCc = createReactComponent("outline", "badge-cc", "IconBadgeCc", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 10.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0", "key": "svg-1" }], ["path", { "d": "M17 10.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0", "key": "svg-2" }]]);

var IconBadgeCc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeCc
});

var IconBadgeHd = createReactComponent("outline", "badge-hd", "IconBadgeHd", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z", "key": "svg-1" }], ["path", { "d": "M7 15v-6", "key": "svg-2" }], ["path", { "d": "M10 15v-6", "key": "svg-3" }], ["path", { "d": "M7 12h3", "key": "svg-4" }]]);

var IconBadgeHd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeHd
});

var IconBadgeOff = createReactComponent("outline", "badge-off", "IconBadgeOff", [["path", { "d": "M7 7v10l5 3l5 -3m0 -4v-9l-5 3l-2.496 -1.497", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconBadgeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeOff
});

var IconBadgeSd = createReactComponent("outline", "badge-sd", "IconBadgeSd", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z", "key": "svg-1" }], ["path", { "d": "M7 14.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-2" }]]);

var IconBadgeSd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeSd
});

var IconBadgeTm = createReactComponent("outline", "badge-tm", "IconBadgeTm", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M6 9h4", "key": "svg-1" }], ["path", { "d": "M8 9v6", "key": "svg-2" }], ["path", { "d": "M13 15v-6l2 3l2 -3v6", "key": "svg-3" }]]);

var IconBadgeTm$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeTm
});

var IconBadgeVo = createReactComponent("outline", "badge-vo", "IconBadgeVo", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 9l2 6l2 -6", "key": "svg-1" }], ["path", { "d": "M15.5 9a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1 -3 0v-3a1.5 1.5 0 0 1 1.5 -1.5z", "key": "svg-2" }]]);

var IconBadgeVo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeVo
});

var IconBadgeVr = createReactComponent("outline", "badge-vr", "IconBadgeVr", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 12h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6m3 0l-2 -3", "key": "svg-1" }], ["path", { "d": "M7 9l2 6l2 -6", "key": "svg-2" }]]);

var IconBadgeVr$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeVr
});

var IconBadgeWc = createReactComponent("outline", "badge-wc", "IconBadgeWc", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M6.5 9l.5 6l2 -4l2 4l.5 -6", "key": "svg-1" }], ["path", { "d": "M17 10.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0", "key": "svg-2" }]]);

var IconBadgeWc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeWc
});

var IconBadge = createReactComponent("outline", "badge", "IconBadge", [["path", { "d": "M17 17v-13l-5 3l-5 -3v13l5 3z", "key": "svg-0" }]]);

var IconBadge$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadge
});

var IconBadgesOff = createReactComponent("outline", "badges-off", "IconBadgesOff", [["path", { "d": "M14.505 14.497l-2.505 1.503l-5 -3v4l5 3l5 -3", "key": "svg-0" }], ["path", { "d": "M13.873 9.876l3.127 -1.876v-4l-5 3l-2.492 -1.495m-2.508 1.495v1l2.492 1.495", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconBadgesOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgesOff
});

var IconBadges = createReactComponent("outline", "badges", "IconBadges", [["path", { "d": "M17 17v-4l-5 3l-5 -3v4l5 3z", "key": "svg-0" }], ["path", { "d": "M17 8v-4l-5 3l-5 -3v4l5 3z", "key": "svg-1" }]]);

var IconBadges$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadges
});

var IconBaguette = createReactComponent("outline", "baguette", "IconBaguette", [["path", { "d": "M5.628 11.283l5.644 -5.637c2.665 -2.663 5.924 -3.747 8.663 -1.205l.188 .181a2.987 2.987 0 0 1 0 4.228l-11.287 11.274a3 3 0 0 1 -4.089 .135l-.143 -.135c-2.728 -2.724 -1.704 -6.117 1.024 -8.841z", "key": "svg-0" }], ["path", { "d": "M9.5 7.5l1.5 3.5", "key": "svg-1" }], ["path", { "d": "M6.5 10.5l1.5 3.5", "key": "svg-2" }], ["path", { "d": "M12.5 4.5l1.5 3.5", "key": "svg-3" }]]);

var IconBaguette$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBaguette
});

var IconBallAmericanFootballOff = createReactComponent("outline", "ball-american-football-off", "IconBallAmericanFootballOff", [["path", { "d": "M15 9l-1 1m-2 2l-3 3", "key": "svg-0" }], ["path", { "d": "M10 12l2 2", "key": "svg-1" }], ["path", { "d": "M8 21a5 5 0 0 0 -5 -5", "key": "svg-2" }], ["path", { "d": "M6.813 6.802a12.96 12.96 0 0 0 -3.813 9.198a5 5 0 0 0 5 5a12.96 12.96 0 0 0 9.186 -3.801m1.789 -2.227a12.94 12.94 0 0 0 2.025 -6.972a5 5 0 0 0 -5 -5a12.94 12.94 0 0 0 -6.967 2.022", "key": "svg-3" }], ["path", { "d": "M16 3a5 5 0 0 0 5 5", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconBallAmericanFootballOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBallAmericanFootballOff
});

var IconBallAmericanFootball = createReactComponent("outline", "ball-american-football", "IconBallAmericanFootball", [["path", { "d": "M15 9l-6 6", "key": "svg-0" }], ["path", { "d": "M10 12l2 2", "key": "svg-1" }], ["path", { "d": "M12 10l2 2", "key": "svg-2" }], ["path", { "d": "M8 21a5 5 0 0 0 -5 -5", "key": "svg-3" }], ["path", { "d": "M16 3c-7.18 0 -13 5.82 -13 13a5 5 0 0 0 5 5c7.18 0 13 -5.82 13 -13a5 5 0 0 0 -5 -5", "key": "svg-4" }], ["path", { "d": "M16 3a5 5 0 0 0 5 5", "key": "svg-5" }]]);

var IconBallAmericanFootball$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBallAmericanFootball
});

var IconBallBaseball = createReactComponent("outline", "ball-baseball", "IconBallBaseball", [["path", { "d": "M5.636 18.364a9 9 0 1 0 12.728 -12.728a9 9 0 0 0 -12.728 12.728z", "key": "svg-0" }], ["path", { "d": "M12.495 3.02a9 9 0 0 1 -9.475 9.475", "key": "svg-1" }], ["path", { "d": "M20.98 11.505a9 9 0 0 0 -9.475 9.475", "key": "svg-2" }], ["path", { "d": "M9 9l2 2", "key": "svg-3" }], ["path", { "d": "M13 13l2 2", "key": "svg-4" }], ["path", { "d": "M11 7l2 1", "key": "svg-5" }], ["path", { "d": "M7 11l1 2", "key": "svg-6" }], ["path", { "d": "M16 11l1 2", "key": "svg-7" }], ["path", { "d": "M11 16l2 1", "key": "svg-8" }]]);

var IconBallBaseball$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBallBaseball
});

var IconBallBasketball = createReactComponent("outline", "ball-basketball", "IconBallBasketball", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M5.65 5.65l12.7 12.7", "key": "svg-1" }], ["path", { "d": "M5.65 18.35l12.7 -12.7", "key": "svg-2" }], ["path", { "d": "M12 3a9 9 0 0 0 9 9", "key": "svg-3" }], ["path", { "d": "M3 12a9 9 0 0 1 9 9", "key": "svg-4" }]]);

var IconBallBasketball$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBallBasketball
});

var IconBallBowling = createReactComponent("outline", "ball-bowling", "IconBallBowling", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M11 9l0 .01", "key": "svg-1" }], ["path", { "d": "M15 8l0 .01", "key": "svg-2" }], ["path", { "d": "M14 12l0 .01", "key": "svg-3" }]]);

var IconBallBowling$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBallBowling
});

var IconBallFootballOff = createReactComponent("outline", "ball-football-off", "IconBallFootballOff", [["path", { "d": "M20.041 16.046a9 9 0 0 0 -12.084 -12.09m-2.323 1.683a9 9 0 0 0 12.726 12.73", "key": "svg-0" }], ["path", { "d": "M12 7l4.755 3.455l-.566 1.743l-.98 3.014l-.209 .788h-6l-1.755 -5.545l1.86 -1.351l2.313 -1.681z", "key": "svg-1" }], ["path", { "d": "M12 7v-4", "key": "svg-2" }], ["path", { "d": "M15 16l2.5 3", "key": "svg-3" }], ["path", { "d": "M16.755 10.455l3.745 -1.455", "key": "svg-4" }], ["path", { "d": "M9.061 16.045l-2.561 2.955", "key": "svg-5" }], ["path", { "d": "M7.245 10.455l-3.745 -1.455", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconBallFootballOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBallFootballOff
});

var IconBallFootball = createReactComponent("outline", "ball-football", "IconBallFootball", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 7l4.76 3.45l-1.76 5.55h-6l-1.76 -5.55z", "key": "svg-1" }], ["path", { "d": "M12 7v-4m3 13l2.5 3m-.74 -8.55l3.74 -1.45m-11.44 7.05l-2.56 2.95m.74 -8.55l-3.74 -1.45", "key": "svg-2" }]]);

var IconBallFootball$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBallFootball
});

var IconBallTennis = createReactComponent("outline", "ball-tennis", "IconBallTennis", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M6 5.3a9 9 0 0 1 0 13.4", "key": "svg-1" }], ["path", { "d": "M18 5.3a9 9 0 0 0 0 13.4", "key": "svg-2" }]]);

var IconBallTennis$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBallTennis
});

var IconBallVolleyball = createReactComponent("outline", "ball-volleyball", "IconBallVolleyball", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12a8 8 0 0 0 8 4", "key": "svg-1" }], ["path", { "d": "M7.5 13.5a12 12 0 0 0 8.5 6.5", "key": "svg-2" }], ["path", { "d": "M12 12a8 8 0 0 0 -7.464 4.928", "key": "svg-3" }], ["path", { "d": "M12.951 7.353a12 12 0 0 0 -9.88 4.111", "key": "svg-4" }], ["path", { "d": "M12 12a8 8 0 0 0 -.536 -8.928", "key": "svg-5" }], ["path", { "d": "M15.549 15.147a12 12 0 0 0 1.38 -10.611", "key": "svg-6" }]]);

var IconBallVolleyball$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBallVolleyball
});

var IconBalloonOff = createReactComponent("outline", "balloon-off", "IconBalloonOff", [["path", { "d": "M14 8a2 2 0 0 0 -2 -2", "key": "svg-0" }], ["path", { "d": "M7.762 3.753a6 6 0 0 1 10.238 4.247c0 1.847 -.37 3.564 -1.007 4.993m-1.59 2.42c-.967 1 -2.14 1.587 -3.403 1.587c-3.314 0 -6 -4.03 -6 -9c0 -.593 .086 -1.166 .246 -1.707", "key": "svg-1" }], ["path", { "d": "M12 17v1a2 2 0 0 1 -2 2h-3a2 2 0 0 0 -2 2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconBalloonOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBalloonOff
});

var IconBalloon = createReactComponent("outline", "balloon", "IconBalloon", [["path", { "d": "M14 8a2 2 0 0 0 -2 -2", "key": "svg-0" }], ["path", { "d": "M6 8a6 6 0 1 1 12 0c0 4.97 -2.686 9 -6 9s-6 -4.03 -6 -9", "key": "svg-1" }], ["path", { "d": "M12 17v1a2 2 0 0 1 -2 2h-3a2 2 0 0 0 -2 2", "key": "svg-2" }]]);

var IconBalloon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBalloon
});

var IconBallpenOff = createReactComponent("outline", "ballpen-off", "IconBallpenOff", [["path", { "d": "M14 6l7 7l-2 2", "key": "svg-0" }], ["path", { "d": "M10 10l-4.172 4.172a2.828 2.828 0 1 0 4 4l4.172 -4.172", "key": "svg-1" }], ["path", { "d": "M16 12l4.414 -4.414a2 2 0 0 0 0 -2.829l-1.171 -1.171a2 2 0 0 0 -2.829 0l-4.414 4.414", "key": "svg-2" }], ["path", { "d": "M4 20l1.768 -1.768", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconBallpenOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBallpenOff
});

var IconBallpen = createReactComponent("outline", "ballpen", "IconBallpen", [["path", { "d": "M14 6l7 7l-4 4", "key": "svg-0" }], ["path", { "d": "M5.828 18.172a2.828 2.828 0 0 0 4 0l10.586 -10.586a2 2 0 0 0 0 -2.829l-1.171 -1.171a2 2 0 0 0 -2.829 0l-10.586 10.586a2.828 2.828 0 0 0 0 4z", "key": "svg-1" }], ["path", { "d": "M4 20l1.768 -1.768", "key": "svg-2" }]]);

var IconBallpen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBallpen
});

var IconBan = createReactComponent("outline", "ban", "IconBan", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M5.7 5.7l12.6 12.6", "key": "svg-1" }]]);

var IconBan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBan
});

var IconBandageOff = createReactComponent("outline", "bandage-off", "IconBandageOff", [["path", { "d": "M10 12v.01", "key": "svg-0" }], ["path", { "d": "M12 14v.01", "key": "svg-1" }], ["path", { "d": "M10.513 6.487l1.987 -1.987a4.95 4.95 0 0 1 7 7l-2.018 2.018m-1.982 1.982l-4 4a4.95 4.95 0 0 1 -7 -7l4 -4", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconBandageOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBandageOff
});

var IconBandage = createReactComponent("outline", "bandage", "IconBandage", [["path", { "d": "M14 12l0 .01", "key": "svg-0" }], ["path", { "d": "M10 12l0 .01", "key": "svg-1" }], ["path", { "d": "M12 10l0 .01", "key": "svg-2" }], ["path", { "d": "M12 14l0 .01", "key": "svg-3" }], ["path", { "d": "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7", "key": "svg-4" }]]);

var IconBandage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBandage
});

var IconBarbellOff = createReactComponent("outline", "barbell-off", "IconBarbellOff", [["path", { "d": "M2 12h1", "key": "svg-0" }], ["path", { "d": "M6 8h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2", "key": "svg-1" }], ["path", { "d": "M6.298 6.288a1 1 0 0 0 -.298 .712v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-8", "key": "svg-2" }], ["path", { "d": "M9 12h3", "key": "svg-3" }], ["path", { "d": "M15 15v2a1 1 0 0 0 1 1h1c.275 0 .523 -.11 .704 -.29m.296 -3.71v-7a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1v4", "key": "svg-4" }], ["path", { "d": "M18 8h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1", "key": "svg-5" }], ["path", { "d": "M22 12h-1", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconBarbellOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBarbellOff
});

var IconBarbell = createReactComponent("outline", "barbell", "IconBarbell", [["path", { "d": "M2 12h1", "key": "svg-0" }], ["path", { "d": "M6 8h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2", "key": "svg-1" }], ["path", { "d": "M6 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-10a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1z", "key": "svg-2" }], ["path", { "d": "M9 12h6", "key": "svg-3" }], ["path", { "d": "M15 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-10a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1z", "key": "svg-4" }], ["path", { "d": "M18 8h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2", "key": "svg-5" }], ["path", { "d": "M22 12h-1", "key": "svg-6" }]]);

var IconBarbell$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBarbell
});

var IconBarcodeOff = createReactComponent("outline", "barcode-off", "IconBarcodeOff", [["path", { "d": "M4 7v-1c0 -.552 .224 -1.052 .586 -1.414", "key": "svg-0" }], ["path", { "d": "M4 17v1a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v1", "key": "svg-2" }], ["path", { "d": "M16 20h2c.551 0 1.05 -.223 1.412 -.584", "key": "svg-3" }], ["path", { "d": "M5 11h1v2h-1z", "key": "svg-4" }], ["path", { "d": "M10 11v2", "key": "svg-5" }], ["path", { "d": "M15 11v.01", "key": "svg-6" }], ["path", { "d": "M19 11v2", "key": "svg-7" }], ["path", { "d": "M3 3l18 18", "key": "svg-8" }]]);

var IconBarcodeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBarcodeOff
});

var IconBarcode = createReactComponent("outline", "barcode", "IconBarcode", [["path", { "d": "M4 7v-1a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 17v1a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v1", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-1", "key": "svg-3" }], ["path", { "d": "M5 11h1v2h-1z", "key": "svg-4" }], ["path", { "d": "M10 11l0 2", "key": "svg-5" }], ["path", { "d": "M14 11h1v2h-1z", "key": "svg-6" }], ["path", { "d": "M19 11l0 2", "key": "svg-7" }]]);

var IconBarcode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBarcode
});

var IconBarrelOff = createReactComponent("outline", "barrel-off", "IconBarrelOff", [["path", { "d": "M8 4h8.722a2 2 0 0 1 1.841 1.22c.958 2.26 1.437 4.52 1.437 6.78a16.35 16.35 0 0 1 -.407 3.609m-.964 3.013l-.066 .158a2 2 0 0 1 -1.841 1.22h-9.444a2 2 0 0 1 -1.841 -1.22c-.958 -2.26 -1.437 -4.52 -1.437 -6.78c0 -2.21 .458 -4.42 1.374 -6.63", "key": "svg-0" }], ["path", { "d": "M14 4c.585 2.337 .913 4.674 .985 7.01m-.114 3.86a33.415 33.415 0 0 1 -.871 5.13", "key": "svg-1" }], ["path", { "d": "M10 4a34.42 34.42 0 0 0 -.366 1.632m-.506 3.501a32.126 32.126 0 0 0 -.128 2.867c0 2.667 .333 5.333 1 8", "key": "svg-2" }], ["path", { "d": "M4.5 16h11.5", "key": "svg-3" }], ["path", { "d": "M19.5 8h-7.5m-4 0h-3.5", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconBarrelOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBarrelOff
});

var IconBarrel = createReactComponent("outline", "barrel", "IconBarrel", [["path", { "d": "M7.278 4h9.444a2 2 0 0 1 1.841 1.22c.958 2.26 1.437 4.52 1.437 6.78c0 2.26 -.479 4.52 -1.437 6.78a2 2 0 0 1 -1.841 1.22h-9.444a2 2 0 0 1 -1.841 -1.22c-.958 -2.26 -1.437 -4.52 -1.437 -6.78c0 -2.26 .479 -4.52 1.437 -6.78a2 2 0 0 1 1.841 -1.22z", "key": "svg-0" }], ["path", { "d": "M14 4c.667 2.667 1 5.333 1 8s-.333 5.333 -1 8", "key": "svg-1" }], ["path", { "d": "M10 4c-.667 2.667 -1 5.333 -1 8s.333 5.333 1 8", "key": "svg-2" }], ["path", { "d": "M4.5 16h15", "key": "svg-3" }], ["path", { "d": "M19.5 8h-15", "key": "svg-4" }]]);

var IconBarrel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBarrel
});

var IconBarrierBlockOff = createReactComponent("outline", "barrier-block-off", "IconBarrierBlockOff", [["path", { "d": "M11 7h8a1 1 0 0 1 1 1v7c0 .27 -.107 .516 -.282 .696", "key": "svg-0" }], ["path", { "d": "M16 16h-11a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h2", "key": "svg-1" }], ["path", { "d": "M7 16v4", "key": "svg-2" }], ["path", { "d": "M7.5 16l4.244 -4.244", "key": "svg-3" }], ["path", { "d": "M13.745 9.755l2.755 -2.755", "key": "svg-4" }], ["path", { "d": "M13.5 16l1.249 -1.249", "key": "svg-5" }], ["path", { "d": "M16.741 12.759l3.259 -3.259", "key": "svg-6" }], ["path", { "d": "M4 13.5l4.752 -4.752", "key": "svg-7" }], ["path", { "d": "M17 17v3", "key": "svg-8" }], ["path", { "d": "M5 20h4", "key": "svg-9" }], ["path", { "d": "M15 20h4", "key": "svg-10" }], ["path", { "d": "M17 7v-2", "key": "svg-11" }], ["path", { "d": "M3 3l18 18", "key": "svg-12" }]]);

var IconBarrierBlockOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBarrierBlockOff
});

var IconBarrierBlock = createReactComponent("outline", "barrier-block", "IconBarrierBlock", [["path", { "d": "M4 7m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v7a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M7 16v4", "key": "svg-1" }], ["path", { "d": "M7.5 16l9 -9", "key": "svg-2" }], ["path", { "d": "M13.5 16l6.5 -6.5", "key": "svg-3" }], ["path", { "d": "M4 13.5l6.5 -6.5", "key": "svg-4" }], ["path", { "d": "M17 16v4", "key": "svg-5" }], ["path", { "d": "M5 20h4", "key": "svg-6" }], ["path", { "d": "M15 20h4", "key": "svg-7" }], ["path", { "d": "M17 7v-2", "key": "svg-8" }], ["path", { "d": "M7 7v-2", "key": "svg-9" }]]);

var IconBarrierBlock$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBarrierBlock
});

var IconBaselineDensityLarge = createReactComponent("outline", "baseline-density-large", "IconBaselineDensityLarge", [["path", { "d": "M4 4h16", "key": "svg-0" }], ["path", { "d": "M4 20h16", "key": "svg-1" }]]);

var IconBaselineDensityLarge$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBaselineDensityLarge
});

var IconBaselineDensityMedium = createReactComponent("outline", "baseline-density-medium", "IconBaselineDensityMedium", [["path", { "d": "M4 20h16", "key": "svg-0" }], ["path", { "d": "M4 12h16", "key": "svg-1" }], ["path", { "d": "M4 4h16", "key": "svg-2" }]]);

var IconBaselineDensityMedium$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBaselineDensityMedium
});

var IconBaselineDensitySmall = createReactComponent("outline", "baseline-density-small", "IconBaselineDensitySmall", [["path", { "d": "M4 3h16", "key": "svg-0" }], ["path", { "d": "M4 9h16", "key": "svg-1" }], ["path", { "d": "M4 15h16", "key": "svg-2" }], ["path", { "d": "M4 21h16", "key": "svg-3" }]]);

var IconBaselineDensitySmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBaselineDensitySmall
});

var IconBaseline = createReactComponent("outline", "baseline", "IconBaseline", [["path", { "d": "M4 20h16", "key": "svg-0" }], ["path", { "d": "M8 16v-8a4 4 0 1 1 8 0v8", "key": "svg-1" }], ["path", { "d": "M8 10h8", "key": "svg-2" }]]);

var IconBaseline$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBaseline
});

var IconBasketBolt = createReactComponent("outline", "basket-bolt", "IconBasketBolt", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M13 20h-5.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.358 2.04", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-4" }]]);

var IconBasketBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketBolt
});

var IconBasketCancel = createReactComponent("outline", "basket-cancel", "IconBasketCancel", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M12 20h-4.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.3 1.713", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }], ["path", { "d": "M17 21l4 -4", "key": "svg-5" }]]);

var IconBasketCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketCancel
});

var IconBasketCheck = createReactComponent("outline", "basket-check", "IconBasketCheck", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M11 20h-3.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.479 2.729", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-4" }]]);

var IconBasketCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketCheck
});

var IconBasketCode = createReactComponent("outline", "basket-code", "IconBasketCode", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M11 20h-3.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304c-.21 1.202 -.37 2.104 -.475 2.705", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-4" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-5" }]]);

var IconBasketCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketCode
});

var IconBasketCog = createReactComponent("outline", "basket-cog", "IconBasketCog", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M12 20h-4.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.267 1.522", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-5" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-6" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-7" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-8" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-9" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-10" }]]);

var IconBasketCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketCog
});

var IconBasketDiscount = createReactComponent("outline", "basket-discount", "IconBasketDiscount", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M12.5 20h-5.256a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.394 2.248", "key": "svg-2" }], ["path", { "d": "M13.856 13.254a2 2 0 1 0 -1.856 2.746", "key": "svg-3" }], ["path", { "d": "M16 21l5 -5", "key": "svg-4" }], ["path", { "d": "M21 21v.01", "key": "svg-5" }], ["path", { "d": "M16 16v.01", "key": "svg-6" }]]);

var IconBasketDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketDiscount
});

var IconBasketDollar = createReactComponent("outline", "basket-dollar", "IconBasketDollar", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M13 20h-5.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-4" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-5" }]]);

var IconBasketDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketDollar
});

var IconBasketDown = createReactComponent("outline", "basket-down", "IconBasketDown", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M12 20h-4.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.349 1.989", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-5" }]]);

var IconBasketDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketDown
});

var IconBasketExclamation = createReactComponent("outline", "basket-exclamation", "IconBasketExclamation", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M15 20h-7.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.36 2.055", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19 16v3", "key": "svg-4" }], ["path", { "d": "M19 22v.01", "key": "svg-5" }]]);

var IconBasketExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketExclamation
});

var IconBasketHeart = createReactComponent("outline", "basket-heart", "IconBasketHeart", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M10.5 20h-3.256a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.143 .817", "key": "svg-2" }], ["path", { "d": "M12.602 12.092a2 2 0 0 0 -2.233 3.066", "key": "svg-3" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-4" }]]);

var IconBasketHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketHeart
});

var IconBasketMinus = createReactComponent("outline", "basket-minus", "IconBasketMinus", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M12 20h-4.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.833 4.75", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }]]);

var IconBasketMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketMinus
});

var IconBasketOff = createReactComponent("outline", "basket-off", "IconBasketOff", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l.75 -2.252m1.001 -3.002l.249 -.746", "key": "svg-1" }], ["path", { "d": "M12 8h7a2 2 0 0 1 1.977 2.304c-.442 2.516 -.756 4.438 -.977 5.696m-1.01 3.003a2.997 2.997 0 0 1 -2.234 .997h-9.512a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h2.999", "key": "svg-2" }], ["path", { "d": "M12 12a2 2 0 1 0 2 2", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconBasketOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketOff
});

var IconBasketPause = createReactComponent("outline", "basket-pause", "IconBasketPause", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M13 20h-5.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.478 2.725", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M17 17v5", "key": "svg-4" }], ["path", { "d": "M21 17v5", "key": "svg-5" }]]);

var IconBasketPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketPause
});

var IconBasketPin = createReactComponent("outline", "basket-pin", "IconBasketPin", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M12 20h-4.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.161 .92", "key": "svg-2" }], ["path", { "d": "M13.866 13.28a2 2 0 1 0 -1.866 2.72", "key": "svg-3" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-4" }], ["path", { "d": "M19 18v.01", "key": "svg-5" }]]);

var IconBasketPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketPin
});

var IconBasketPlus = createReactComponent("outline", "basket-plus", "IconBasketPlus", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M12 20h-4.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.359 2.043", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16v6", "key": "svg-5" }]]);

var IconBasketPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketPlus
});

var IconBasketQuestion = createReactComponent("outline", "basket-question", "IconBasketQuestion", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M15 20h-7.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.161 .918", "key": "svg-2" }], ["path", { "d": "M12 16a2 2 0 1 0 0 -4a2 2 0 0 0 0 4z", "key": "svg-3" }], ["path", { "d": "M19 22v.01", "key": "svg-4" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-5" }]]);

var IconBasketQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketQuestion
});

var IconBasketSearch = createReactComponent("outline", "basket-search", "IconBasketSearch", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M11 20h-3.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.215 1.227", "key": "svg-2" }], ["path", { "d": "M13.483 12.658a2 2 0 1 0 -2.162 3.224", "key": "svg-3" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-5" }]]);

var IconBasketSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketSearch
});

var IconBasketShare = createReactComponent("outline", "basket-share", "IconBasketShare", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M12.5 20h-5.256a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.478 2.723", "key": "svg-2" }], ["path", { "d": "M14 14a2 2 0 1 0 -2 2", "key": "svg-3" }], ["path", { "d": "M16 22l5 -5", "key": "svg-4" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-5" }]]);

var IconBasketShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketShare
});

var IconBasketStar = createReactComponent("outline", "basket-star", "IconBasketStar", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M10.5 20h-3.256a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.133 .757", "key": "svg-2" }], ["path", { "d": "M13.596 12.794a2 2 0 0 0 -3.377 2.116", "key": "svg-3" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-4" }]]);

var IconBasketStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketStar
});

var IconBasketUp = createReactComponent("outline", "basket-up", "IconBasketUp", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M12 20h-4.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.358 2.04", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19 22v-6", "key": "svg-4" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-5" }]]);

var IconBasketUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketUp
});

var IconBasketX = createReactComponent("outline", "basket-x", "IconBasketX", [["path", { "d": "M17 10l-2 -6", "key": "svg-0" }], ["path", { "d": "M7 10l2 -6", "key": "svg-1" }], ["path", { "d": "M13.5 20h-6.256a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.532 3.03", "key": "svg-2" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-3" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-4" }], ["path", { "d": "M17 22l5 -5", "key": "svg-5" }]]);

var IconBasketX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketX
});

var IconBasket = createReactComponent("outline", "basket", "IconBasket", [["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M5.001 8h13.999a2 2 0 0 1 1.977 2.304l-1.255 7.152a3 3 0 0 1 -2.966 2.544h-9.512a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304z", "key": "svg-1" }], ["path", { "d": "M17 10l-2 -6", "key": "svg-2" }], ["path", { "d": "M7 10l2 -6", "key": "svg-3" }]]);

var IconBasket$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasket
});

var IconBat = createReactComponent("outline", "bat", "IconBat", [["path", { "d": "M17 16c.74 -2.286 2.778 -3.762 5 -3c-.173 -2.595 .13 -5.314 -2 -7.5c-1.708 2.648 -3.358 2.557 -5 2.5v-4l-3 2l-3 -2v4c-1.642 .057 -3.292 .148 -5 -2.5c-2.13 2.186 -1.827 4.905 -2 7.5c2.222 -.762 4.26 .714 5 3c2.593 0 3.889 .952 5 4c1.111 -3.048 2.407 -4 5 -4z", "key": "svg-0" }], ["path", { "d": "M9 8a3 3 0 0 0 6 0", "key": "svg-1" }]]);

var IconBat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBat
});

var IconBathOff = createReactComponent("outline", "bath-off", "IconBathOff", [["path", { "d": "M16 12h4a1 1 0 0 1 1 1v3c0 .311 -.036 .614 -.103 .904m-1.61 2.378a3.982 3.982 0 0 1 -2.287 .718h-10a4 4 0 0 1 -4 -4v-3a1 1 0 0 1 1 -1h8", "key": "svg-0" }], ["path", { "d": "M6 12v-6m1.178 -2.824c.252 -.113 .53 -.176 .822 -.176h3v2.25", "key": "svg-1" }], ["path", { "d": "M4 21l1 -1.5", "key": "svg-2" }], ["path", { "d": "M20 21l-1 -1.5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconBathOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBathOff
});

var IconBath = createReactComponent("outline", "bath", "IconBath", [["path", { "d": "M4 12h16a1 1 0 0 1 1 1v3a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4v-3a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M6 12v-7a2 2 0 0 1 2 -2h3v2.25", "key": "svg-1" }], ["path", { "d": "M4 21l1 -1.5", "key": "svg-2" }], ["path", { "d": "M20 21l-1 -1.5", "key": "svg-3" }]]);

var IconBath$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBath
});

var IconBattery1 = createReactComponent("outline", "battery-1", "IconBattery1", [["path", { "d": "M6 7h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M7 10l0 4", "key": "svg-1" }]]);

var IconBattery1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBattery1
});

var IconBattery2 = createReactComponent("outline", "battery-2", "IconBattery2", [["path", { "d": "M6 7h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M7 10l0 4", "key": "svg-1" }], ["path", { "d": "M10 10l0 4", "key": "svg-2" }]]);

var IconBattery2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBattery2
});

var IconBattery3 = createReactComponent("outline", "battery-3", "IconBattery3", [["path", { "d": "M6 7h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M7 10l0 4", "key": "svg-1" }], ["path", { "d": "M10 10l0 4", "key": "svg-2" }], ["path", { "d": "M13 10l0 4", "key": "svg-3" }]]);

var IconBattery3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBattery3
});

var IconBattery4 = createReactComponent("outline", "battery-4", "IconBattery4", [["path", { "d": "M6 7h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M7 10l0 4", "key": "svg-1" }], ["path", { "d": "M10 10l0 4", "key": "svg-2" }], ["path", { "d": "M13 10l0 4", "key": "svg-3" }], ["path", { "d": "M16 10l0 4", "key": "svg-4" }]]);

var IconBattery4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBattery4
});

var IconBatteryAutomotive = createReactComponent("outline", "battery-automotive", "IconBatteryAutomotive", [["path", { "d": "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M6 5v-2", "key": "svg-1" }], ["path", { "d": "M18 3v2", "key": "svg-2" }], ["path", { "d": "M6.5 12h3", "key": "svg-3" }], ["path", { "d": "M14.5 12h3", "key": "svg-4" }], ["path", { "d": "M16 10.5v3", "key": "svg-5" }]]);

var IconBatteryAutomotive$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryAutomotive
});

var IconBatteryCharging2 = createReactComponent("outline", "battery-charging-2", "IconBatteryCharging2", [["path", { "d": "M4 9a2 2 0 0 1 2 -2h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-4.5", "key": "svg-0" }], ["path", { "d": "M3 15h6v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2v-2z", "key": "svg-1" }], ["path", { "d": "M6 22v-3", "key": "svg-2" }], ["path", { "d": "M4 15v-2.5", "key": "svg-3" }], ["path", { "d": "M8 15v-2.5", "key": "svg-4" }]]);

var IconBatteryCharging2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryCharging2
});

var IconBatteryCharging = createReactComponent("outline", "battery-charging", "IconBatteryCharging", [["path", { "d": "M16 7h1a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-2", "key": "svg-0" }], ["path", { "d": "M8 7h-2a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h1", "key": "svg-1" }], ["path", { "d": "M12 8l-2 4h3l-2 4", "key": "svg-2" }]]);

var IconBatteryCharging$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryCharging
});

var IconBatteryEco = createReactComponent("outline", "battery-eco", "IconBatteryEco", [["path", { "d": "M4 9a2 2 0 0 1 2 -2h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-5.5", "key": "svg-0" }], ["path", { "d": "M3 16.143c0 -2.84 2.09 -5.143 4.667 -5.143h2.333v.857c0 2.84 -2.09 5.143 -4.667 5.143h-2.333v-.857z", "key": "svg-1" }], ["path", { "d": "M3 20v-3", "key": "svg-2" }]]);

var IconBatteryEco$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryEco
});

var IconBatteryExclamation = createReactComponent("outline", "battery-exclamation", "IconBatteryExclamation", [["path", { "d": "M9 17h8c1.105 0 2 -.895 2 -2v-.5c0 -.276 .224 -.5 .5 -.5s.5 -.224 .5 -.5v-3c0 -.276 -.224 -.5 -.5 -.5s-.5 -.224 -.5 -.5v-.5c0 -1.105 -.895 -2 -2 -2h-11c-1.105 0 -2 .895 -2 2v3", "key": "svg-0" }], ["path", { "d": "M5 16v3", "key": "svg-1" }], ["path", { "d": "M5 22v.01", "key": "svg-2" }]]);

var IconBatteryExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryExclamation
});

var IconBatteryOff = createReactComponent("outline", "battery-off", "IconBatteryOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M11 7h6a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5m-2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h1", "key": "svg-1" }]]);

var IconBatteryOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryOff
});

var IconBatterySpark = createReactComponent("outline", "battery-spark", "IconBatterySpark", [["path", { "d": "M12 17h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v1", "key": "svg-0" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-1" }]]);

var IconBatterySpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatterySpark
});

var IconBatteryVertical1 = createReactComponent("outline", "battery-vertical-1", "IconBatteryVertical1", [["path", { "d": "M7 18v-11a2 2 0 0 1 2 -2h.5a.5 .5 0 0 0 .5 -.5a.5 .5 0 0 1 .5 -.5h3a.5 .5 0 0 1 .5 .5a.5 .5 0 0 0 .5 .5h.5a2 2 0 0 1 2 2v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2", "key": "svg-0" }], ["path", { "d": "M10 17h4", "key": "svg-1" }]]);

var IconBatteryVertical1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVertical1
});

var IconBatteryVertical2 = createReactComponent("outline", "battery-vertical-2", "IconBatteryVertical2", [["path", { "d": "M7 18v-11a2 2 0 0 1 2 -2h.5a.5 .5 0 0 0 .5 -.5a.5 .5 0 0 1 .5 -.5h3a.5 .5 0 0 1 .5 .5a.5 .5 0 0 0 .5 .5h.5a2 2 0 0 1 2 2v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2", "key": "svg-0" }], ["path", { "d": "M10 17h4", "key": "svg-1" }], ["path", { "d": "M10 14h4", "key": "svg-2" }]]);

var IconBatteryVertical2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVertical2
});

var IconBatteryVertical3 = createReactComponent("outline", "battery-vertical-3", "IconBatteryVertical3", [["path", { "d": "M7 18v-11a2 2 0 0 1 2 -2h.5a.5 .5 0 0 0 .5 -.5a.5 .5 0 0 1 .5 -.5h3a.5 .5 0 0 1 .5 .5a.5 .5 0 0 0 .5 .5h.5a2 2 0 0 1 2 2v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2", "key": "svg-0" }], ["path", { "d": "M10 17h4", "key": "svg-1" }], ["path", { "d": "M10 14h4", "key": "svg-2" }], ["path", { "d": "M10 11h4", "key": "svg-3" }]]);

var IconBatteryVertical3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVertical3
});

var IconBatteryVertical4 = createReactComponent("outline", "battery-vertical-4", "IconBatteryVertical4", [["path", { "d": "M7 18v-11a2 2 0 0 1 2 -2h.5a.5 .5 0 0 0 .5 -.5a.5 .5 0 0 1 .5 -.5h3a.5 .5 0 0 1 .5 .5a.5 .5 0 0 0 .5 .5h.5a2 2 0 0 1 2 2v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2", "key": "svg-0" }], ["path", { "d": "M10 17h4", "key": "svg-1" }], ["path", { "d": "M10 14h4", "key": "svg-2" }], ["path", { "d": "M10 11h4", "key": "svg-3" }], ["path", { "d": "M10 8h4", "key": "svg-4" }]]);

var IconBatteryVertical4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVertical4
});

var IconBatteryVerticalCharging2 = createReactComponent("outline", "battery-vertical-charging-2", "IconBatteryVerticalCharging2", [["path", { "d": "M7 18v-11c0 -1.105 .895 -2 2 -2h.5c.276 0 .5 -.224 .5 -.5s.224 -.5 .5 -.5h3c.276 0 .5 .224 .5 .5s.224 .5 .5 .5h.5c1.105 0 2 .895 2 2v1m-10 10c0 1.105 .895 2 2 2h1", "key": "svg-0" }], ["path", { "d": "M12 14h6v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M15 21v-3", "key": "svg-2" }], ["path", { "d": "M13 14v-2.5", "key": "svg-3" }], ["path", { "d": "M17 14v-2.5", "key": "svg-4" }]]);

var IconBatteryVerticalCharging2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVerticalCharging2
});

var IconBatteryVerticalCharging = createReactComponent("outline", "battery-vertical-charging", "IconBatteryVerticalCharging", [["path", { "d": "M7 18v-11a2 2 0 0 1 2 -2h.5a.5 .5 0 0 0 .5 -.5a.5 .5 0 0 1 .5 -.5h3a.5 .5 0 0 1 .5 .5a.5 .5 0 0 0 .5 .5h.5a2 2 0 0 1 2 2v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2", "key": "svg-0" }], ["path", { "d": "M12.667 8l-2.667 4h4l-2.667 4", "key": "svg-1" }]]);

var IconBatteryVerticalCharging$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVerticalCharging
});

var IconBatteryVerticalEco = createReactComponent("outline", "battery-vertical-eco", "IconBatteryVerticalEco", [["path", { "d": "M7 18v-11c0 -1.105 .895 -2 2 -2h.5c.276 0 .5 -.224 .5 -.5s.224 -.5 .5 -.5h3c.276 0 .5 .224 .5 .5s.224 .5 .5 .5h.5c1.105 0 2 .895 2 2v1m-8 12c-1.105 0 -2 -.895 -2 -2", "key": "svg-0" }], ["path", { "d": "M13 17.143c0 -2.84 2.09 -5.143 4.667 -5.143h2.333v.857c0 2.84 -2.09 5.143 -4.667 5.143h-2.333z", "key": "svg-1" }], ["path", { "d": "M13 21v-3", "key": "svg-2" }]]);

var IconBatteryVerticalEco$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVerticalEco
});

var IconBatteryVerticalExclamation = createReactComponent("outline", "battery-vertical-exclamation", "IconBatteryVerticalExclamation", [["path", { "d": "M17 12v-5c0 -1.105 -.895 -2 -2 -2h-.5c-.276 0 -.5 -.224 -.5 -.5s-.224 -.5 -.5 -.5h-3c-.276 0 -.5 .224 -.5 .5s-.224 .5 -.5 .5h-.5c-1.105 0 -2 .895 -2 2v11c0 1.105 .895 2 2 2h6", "key": "svg-0" }], ["path", { "d": "M19 16v3", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }]]);

var IconBatteryVerticalExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVerticalExclamation
});

var IconBatteryVerticalOff = createReactComponent("outline", "battery-vertical-off", "IconBatteryVerticalOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M17 13v-6a2 2 0 0 0 -2 -2h-.5a.5 .5 0 0 1 -.5 -.5a.5 .5 0 0 0 -.5 -.5h-3a.5 .5 0 0 0 -.5 .5a.5 .5 0 0 1 -.5 .5h-.5m-2 2v11a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-1", "key": "svg-1" }]]);

var IconBatteryVerticalOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVerticalOff
});

var IconBatteryVertical = createReactComponent("outline", "battery-vertical", "IconBatteryVertical", [["path", { "d": "M7 18v-11a2 2 0 0 1 2 -2h.5a.5 .5 0 0 0 .5 -.5a.5 .5 0 0 1 .5 -.5h3a.5 .5 0 0 1 .5 .5a.5 .5 0 0 0 .5 .5h.5a2 2 0 0 1 2 2v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2", "key": "svg-0" }]]);

var IconBatteryVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVertical
});

var IconBattery = createReactComponent("outline", "battery", "IconBattery", [["path", { "d": "M6 7h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2", "key": "svg-0" }]]);

var IconBattery$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBattery
});

var IconBeachOff = createReactComponent("outline", "beach-off", "IconBeachOff", [["path", { "d": "M15.071 15.102a7.502 7.502 0 0 0 -8.124 1.648", "key": "svg-0" }], ["path", { "d": "M10.27 6.269l9.926 5.731a6 6 0 0 0 -10.32 -6.123", "key": "svg-1" }], ["path", { "d": "M16.732 10c1.658 -2.87 2.225 -5.644 1.268 -6.196c-.957 -.552 -3.075 1.326 -4.732 4.196", "key": "svg-2" }], ["path", { "d": "M15 9l-.739 1.279", "key": "svg-3" }], ["path", { "d": "M12.794 12.82l-.794 1.376", "key": "svg-4" }], ["path", { "d": "M3 19.25a2.4 2.4 0 0 1 1 -.25a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1.135 -.858", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconBeachOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBeachOff
});

var IconBeach = createReactComponent("outline", "beach", "IconBeach", [["path", { "d": "M17.553 16.75a7.5 7.5 0 0 0 -10.606 0", "key": "svg-0" }], ["path", { "d": "M18 3.804a6 6 0 0 0 -8.196 2.196l10.392 6a6 6 0 0 0 -2.196 -8.196z", "key": "svg-1" }], ["path", { "d": "M16.732 10c1.658 -2.87 2.225 -5.644 1.268 -6.196c-.957 -.552 -3.075 1.326 -4.732 4.196", "key": "svg-2" }], ["path", { "d": "M15 9l-3 5.196", "key": "svg-3" }], ["path", { "d": "M3 19.25a2.4 2.4 0 0 1 1 -.25a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 1 .25", "key": "svg-4" }]]);

var IconBeach$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBeach
});

var IconBedFlat = createReactComponent("outline", "bed-flat", "IconBedFlat", [["path", { "d": "M5 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M10 13h11v-2a3 3 0 0 0 -3 -3h-8v5z", "key": "svg-1" }], ["path", { "d": "M3 16h18", "key": "svg-2" }]]);

var IconBedFlat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBedFlat
});

var IconBedOff = createReactComponent("outline", "bed-off", "IconBedOff", [["path", { "d": "M7 7a2 2 0 1 0 2 2", "key": "svg-0" }], ["path", { "d": "M22 17v-3h-4m-4 0h-12", "key": "svg-1" }], ["path", { "d": "M2 8v9", "key": "svg-2" }], ["path", { "d": "M12 12v2h2m4 0h4v-2a3 3 0 0 0 -3 -3h-6", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconBedOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBedOff
});

var IconBed = createReactComponent("outline", "bed", "IconBed", [["path", { "d": "M7 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M22 17v-3h-20", "key": "svg-1" }], ["path", { "d": "M2 8v9", "key": "svg-2" }], ["path", { "d": "M12 14h10v-2a3 3 0 0 0 -3 -3h-7v5z", "key": "svg-3" }]]);

var IconBed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBed
});

var IconBeerOff = createReactComponent("outline", "beer-off", "IconBeerOff", [["path", { "d": "M7 7v1.111c0 1.242 .29 2.467 .845 3.578l.31 .622a8 8 0 0 1 .845 3.578v4.111h6v-4.111a8 8 0 0 1 .045 -.85m.953 -3.035l.157 -.315a8 8 0 0 0 .845 -3.578v-4.111h-9", "key": "svg-0" }], ["path", { "d": "M7 8h1m4 0h5", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconBeerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBeerOff
});

var IconBeer = createReactComponent("outline", "beer", "IconBeer", [["path", { "d": "M9 21h6a1 1 0 0 0 1 -1v-3.625c0 -1.397 .29 -2.775 .845 -4.025l.31 -.7c.556 -1.25 .845 -2.253 .845 -3.65v-4a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v4c0 1.397 .29 2.4 .845 3.65l.31 .7a9.931 9.931 0 0 1 .845 4.025v3.625a1 1 0 0 0 1 1z", "key": "svg-0" }], ["path", { "d": "M6 8h12", "key": "svg-1" }]]);

var IconBeer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBeer
});

var IconBellBolt = createReactComponent("outline", "bell-bolt", "IconBellBolt", [["path", { "d": "M13.5 17h-9.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 4.368 2.67", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }]]);

var IconBellBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellBolt
});

var IconBellCancel = createReactComponent("outline", "bell-cancel", "IconBellCancel", [["path", { "d": "M12.5 17h-8.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 3 3", "key": "svg-1" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M17 21l4 -4", "key": "svg-3" }]]);

var IconBellCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellCancel
});

var IconBellCheck = createReactComponent("outline", "bell-check", "IconBellCheck", [["path", { "d": "M11.5 17h-7.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3c.016 .129 .037 .256 .065 .382", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 2.502 2.959", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconBellCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellCheck
});

var IconBellCode = createReactComponent("outline", "bell-code", "IconBellCode", [["path", { "d": "M11.5 17h-7.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v2", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 2.498 2.958", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

var IconBellCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellCode
});

var IconBellCog = createReactComponent("outline", "bell-cog", "IconBellCog", [["path", { "d": "M12 17h-8a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v.5", "key": "svg-0" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-2" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-3" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-7" }], ["path", { "d": "M9 17v1a3 3 0 0 0 3 3", "key": "svg-8" }]]);

var IconBellCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellCog
});

var IconBellDollar = createReactComponent("outline", "bell-dollar", "IconBellDollar", [["path", { "d": "M13 17h-9a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 3.911 5.17", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 4.02 2.822", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconBellDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellDollar
});

var IconBellDown = createReactComponent("outline", "bell-down", "IconBellDown", [["path", { "d": "M12.5 17h-8.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 3.518 2.955", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-3" }]]);

var IconBellDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellDown
});

var IconBellExclamation = createReactComponent("outline", "bell-exclamation", "IconBellExclamation", [["path", { "d": "M15 17h-11a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1.5", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 6 0v-1", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconBellExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellExclamation
});

var IconBellHeart = createReactComponent("outline", "bell-heart", "IconBellHeart", [["path", { "d": "M10 17h-6a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6", "key": "svg-0" }], ["path", { "d": "M9 17v1c0 1.408 .97 2.59 2.28 2.913", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconBellHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellHeart
});

var IconBellMinus = createReactComponent("outline", "bell-minus", "IconBellMinus", [["path", { "d": "M12.5 17h-8.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3c.047 .386 .149 .758 .3 1.107", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 3.504 2.958", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconBellMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellMinus
});

var IconBellOff = createReactComponent("outline", "bell-off", "IconBellOff", [["path", { "d": "M9.346 5.353c.21 -.129 .428 -.246 .654 -.353a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3m-1 3h-13a4 4 0 0 0 2 -3v-3a6.996 6.996 0 0 1 1.273 -3.707", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 6 0v-1", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconBellOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellOff
});

var IconBellPause = createReactComponent("outline", "bell-pause", "IconBellPause", [["path", { "d": "M13 17h-9a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v2", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 4.022 2.821", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

var IconBellPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellPause
});

var IconBellPin = createReactComponent("outline", "bell-pin", "IconBellPin", [["path", { "d": "M12 17h-8a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 3.64 2.931", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }]]);

var IconBellPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellPin
});

var IconBellPlus = createReactComponent("outline", "bell-plus", "IconBellPlus", [["path", { "d": "M12.5 17h-8.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 3.51 2.957", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconBellPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellPlus
});

var IconBellQuestion = createReactComponent("outline", "bell-question", "IconBellQuestion", [["path", { "d": "M13.5 17h-9.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 5.914 .716", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }]]);

var IconBellQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellQuestion
});

var IconBellRinging2 = createReactComponent("outline", "bell-ringing-2", "IconBellRinging2", [["path", { "d": "M19.364 4.636a2 2 0 0 1 0 2.828a7 7 0 0 1 -1.414 7.072l-2.122 2.12a4 4 0 0 0 -.707 3.536l-11.313 -11.312a4 4 0 0 0 3.535 -.707l2.121 -2.123a7 7 0 0 1 7.072 -1.414a2 2 0 0 1 2.828 0z", "key": "svg-0" }], ["path", { "d": "M7.343 12.414l-.707 .707a3 3 0 0 0 4.243 4.243l.707 -.707", "key": "svg-1" }]]);

var IconBellRinging2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellRinging2
});

var IconBellRinging = createReactComponent("outline", "bell-ringing", "IconBellRinging", [["path", { "d": "M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 6 0v-1", "key": "svg-1" }], ["path", { "d": "M21 6.727a11.05 11.05 0 0 0 -2.794 -3.727", "key": "svg-2" }], ["path", { "d": "M3 6.727a11.05 11.05 0 0 1 2.792 -3.727", "key": "svg-3" }]]);

var IconBellRinging$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellRinging
});

var IconBellSchool = createReactComponent("outline", "bell-school", "IconBellSchool", [["path", { "d": "M10 10m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-0" }], ["path", { "d": "M13.5 15h.5a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-1a2 2 0 0 1 2 -2h.5", "key": "svg-1" }], ["path", { "d": "M16 17a5.698 5.698 0 0 0 4.467 -7.932l-.467 -1.068", "key": "svg-2" }], ["path", { "d": "M10 10v.01", "key": "svg-3" }], ["path", { "d": "M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }]]);

var IconBellSchool$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellSchool
});

var IconBellSearch = createReactComponent("outline", "bell-search", "IconBellSearch", [["path", { "d": "M11 17h-7a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 2.685 2.984", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconBellSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellSearch
});

var IconBellShare = createReactComponent("outline", "bell-share", "IconBellShare", [["path", { "d": "M12.5 17h-8.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v2", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 3 3", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconBellShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellShare
});

var IconBellStar = createReactComponent("outline", "bell-star", "IconBellStar", [["path", { "d": "M9.5 17h-5.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 3.88 5", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 2.15 2.878", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconBellStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellStar
});

var IconBellUp = createReactComponent("outline", "bell-up", "IconBellUp", [["path", { "d": "M12.5 17h-8.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 3.49 2.96", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }]]);

var IconBellUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellUp
});

var IconBellX = createReactComponent("outline", "bell-x", "IconBellX", [["path", { "d": "M13 17h-9a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v2", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 4.194 2.753", "key": "svg-1" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-2" }], ["path", { "d": "M17 22l5 -5", "key": "svg-3" }]]);

var IconBellX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellX
});

var IconBellZ = createReactComponent("outline", "bell-z", "IconBellZ", [["path", { "d": "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 6 0v-1", "key": "svg-1" }], ["path", { "d": "M10 9h4l-4 4h4", "key": "svg-2" }]]);

var IconBellZ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellZ
});

var IconBell = createReactComponent("outline", "bell", "IconBell", [["path", { "d": "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6", "key": "svg-0" }], ["path", { "d": "M9 17v1a3 3 0 0 0 6 0v-1", "key": "svg-1" }]]);

var IconBell$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBell
});

var IconBeta = createReactComponent("outline", "beta", "IconBeta", [["path", { "d": "M8 22v-14a4 4 0 0 1 4 -4h.5a3.5 3.5 0 0 1 0 7h-.5h.5a4.5 4.5 0 1 1 -4.5 4.5v-.5", "key": "svg-0" }]]);

var IconBeta$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBeta
});

var IconBible = createReactComponent("outline", "bible", "IconBible", [["path", { "d": "M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z", "key": "svg-0" }], ["path", { "d": "M19 16h-12a2 2 0 0 0 -2 2", "key": "svg-1" }], ["path", { "d": "M12 7v6", "key": "svg-2" }], ["path", { "d": "M10 9h4", "key": "svg-3" }]]);

var IconBible$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBible
});

var IconBikeOff = createReactComponent("outline", "bike-off", "IconBikeOff", [["path", { "d": "M5 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M16.437 16.44a3 3 0 0 0 4.123 4.123m1.44 -2.563a3 3 0 0 0 -3 -3", "key": "svg-1" }], ["path", { "d": "M12 19v-4l-3 -3l1.665 -1.332m2.215 -1.772l1.12 -.896l2 3h3", "key": "svg-2" }], ["path", { "d": "M17 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconBikeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBikeOff
});

var IconBike = createReactComponent("outline", "bike", "IconBike", [["path", { "d": "M5 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M19 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M12 19l0 -4l-3 -3l5 -4l2 3l3 0", "key": "svg-2" }], ["path", { "d": "M17 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }]]);

var IconBike$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBike
});

var IconBinaryOff = createReactComponent("outline", "binary-off", "IconBinaryOff", [["path", { "d": "M11 7v-2h-1", "key": "svg-0" }], ["path", { "d": "M18 19v-1", "key": "svg-1" }], ["path", { "d": "M15.5 5h2a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-2a.5 .5 0 0 1 -.5 -.5v-4a.5 .5 0 0 1 .5 -.5z", "key": "svg-2" }], ["path", { "d": "M10.5 14h2a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-2a.5 .5 0 0 1 -.5 -.5v-4a.5 .5 0 0 1 .5 -.5z", "key": "svg-3" }], ["path", { "d": "M6 10v.01", "key": "svg-4" }], ["path", { "d": "M6 19v.01", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconBinaryOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBinaryOff
});

var IconBinaryTree2 = createReactComponent("outline", "binary-tree-2", "IconBinaryTree2", [["path", { "d": "M14 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M7 14a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M21 14a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M14 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M12 8v8", "key": "svg-4" }], ["path", { "d": "M6.316 12.496l4.368 -4.992", "key": "svg-5" }], ["path", { "d": "M17.684 12.496l-4.366 -4.99", "key": "svg-6" }]]);

var IconBinaryTree2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBinaryTree2
});

var IconBinaryTree = createReactComponent("outline", "binary-tree", "IconBinaryTree", [["path", { "d": "M6 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M16 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M16 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M11 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M21 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-4" }], ["path", { "d": "M5.058 18.306l2.88 -4.606", "key": "svg-5" }], ["path", { "d": "M10.061 10.303l2.877 -4.604", "key": "svg-6" }], ["path", { "d": "M10.065 13.705l2.876 4.6", "key": "svg-7" }], ["path", { "d": "M15.063 5.7l2.881 4.61", "key": "svg-8" }]]);

var IconBinaryTree$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBinaryTree
});

var IconBinary = createReactComponent("outline", "binary", "IconBinary", [["path", { "d": "M11 10v-5h-1m8 14v-5h-1", "key": "svg-0" }], ["path", { "d": "M15 5m0 .5a.5 .5 0 0 1 .5 -.5h2a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-2a.5 .5 0 0 1 -.5 -.5z", "key": "svg-1" }], ["path", { "d": "M10 14m0 .5a.5 .5 0 0 1 .5 -.5h2a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-2a.5 .5 0 0 1 -.5 -.5z", "key": "svg-2" }], ["path", { "d": "M6 10h.01m-.01 9h.01", "key": "svg-3" }]]);

var IconBinary$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBinary
});

var IconBinoculars = createReactComponent("outline", "binoculars", "IconBinoculars", [["path", { "d": "M7 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M16.346 9.17l-.729 -1.261c-.16 -.248 -1.056 -.203 -1.117 .091l-.177 1.38", "key": "svg-2" }], ["path", { "d": "M19.761 14.813l-2.84 -5.133c-.189 -.31 -.592 -.68 -1.421 -.68c-.828 0 -1.5 .448 -1.5 1v6", "key": "svg-3" }], ["path", { "d": "M7.654 9.17l.729 -1.261c.16 -.249 1.056 -.203 1.117 .091l.177 1.38", "key": "svg-4" }], ["path", { "d": "M4.239 14.813l2.84 -5.133c.189 -.31 .592 -.68 1.421 -.68c.828 0 1.5 .448 1.5 1v6", "key": "svg-5" }], ["rect", { "width": "4", "height": "2", "x": "10", "y": "12", "key": "svg-6" }]]);

var IconBinoculars$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBinoculars
});

var IconBiohazardOff = createReactComponent("outline", "biohazard-off", "IconBiohazardOff", [["path", { "d": "M10.586 10.586a2 2 0 1 0 2.836 2.82", "key": "svg-0" }], ["path", { "d": "M11.939 14c0 .173 .048 .351 .056 .533v.217a4.75 4.75 0 0 1 -4.533 4.745h-.217", "key": "svg-1" }], ["path", { "d": "M2.495 14.745a4.75 4.75 0 0 1 7.737 -3.693", "key": "svg-2" }], ["path", { "d": "M16.745 19.495a4.75 4.75 0 0 1 -4.69 -5.503h-.06", "key": "svg-3" }], ["path", { "d": "M14.533 10.538a4.75 4.75 0 0 1 6.957 3.987v.217", "key": "svg-4" }], ["path", { "d": "M10.295 10.929a4.75 4.75 0 0 1 -2.988 -3.64m.66 -3.324a4.75 4.75 0 0 1 .5 -.66l.164 -.172", "key": "svg-5" }], ["path", { "d": "M15.349 3.133a4.75 4.75 0 0 1 -.836 7.385", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconBiohazardOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBiohazardOff
});

var IconBiohazard = createReactComponent("outline", "biohazard", "IconBiohazard", [["path", { "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M11.939 14c0 .173 .048 .351 .056 .533l0 .217a4.75 4.75 0 0 1 -4.533 4.745l-.217 0m-4.75 -4.75a4.75 4.75 0 0 1 7.737 -3.693m6.513 8.443a4.75 4.75 0 0 1 -4.69 -5.503l-.06 0m1.764 -2.944a4.75 4.75 0 0 1 7.731 3.477l0 .217m-11.195 -3.813a4.75 4.75 0 0 1 -1.828 -7.624l.164 -.172m6.718 0a4.75 4.75 0 0 1 -1.665 7.798", "key": "svg-1" }]]);

var IconBiohazard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBiohazard
});

var IconBlade = createReactComponent("outline", "blade", "IconBlade", [["path", { "d": "M17.707 3.707l2.586 2.586a1 1 0 0 1 0 1.414l-.586 .586a1 1 0 0 0 0 1.414l.586 .586a1 1 0 0 1 0 1.414l-8.586 8.586a1 1 0 0 1 -1.414 0l-.586 -.586a1 1 0 0 0 -1.414 0l-.586 .586a1 1 0 0 1 -1.414 0l-2.586 -2.586a1 1 0 0 1 0 -1.414l.586 -.586a1 1 0 0 0 0 -1.414l-.586 -.586a1 1 0 0 1 0 -1.414l8.586 -8.586a1 1 0 0 1 1.414 0l.586 .586a1 1 0 0 0 1.414 0l.586 -.586a1 1 0 0 1 1.414 0z", "key": "svg-0" }], ["path", { "d": "M8 16l3.2 -3.2", "key": "svg-1" }], ["path", { "d": "M12.8 11.2l3.2 -3.2", "key": "svg-2" }], ["path", { "d": "M14 8l2 2", "key": "svg-3" }], ["path", { "d": "M8 14l2 2", "key": "svg-4" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-5" }]]);

var IconBlade$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBlade
});

var IconBleachChlorine = createReactComponent("outline", "bleach-chlorine", "IconBleachChlorine", [["path", { "d": "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75", "key": "svg-0" }], ["path", { "d": "M11 12h-1a2 2 0 1 0 0 4h1", "key": "svg-1" }], ["path", { "d": "M14 12v4h2", "key": "svg-2" }]]);

var IconBleachChlorine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBleachChlorine
});

var IconBleachNoChlorine = createReactComponent("outline", "bleach-no-chlorine", "IconBleachNoChlorine", [["path", { "d": "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75", "key": "svg-0" }], ["path", { "d": "M6.576 19l7.907 -13.733", "key": "svg-1" }], ["path", { "d": "M11.719 19.014l5.346 -9.284", "key": "svg-2" }]]);

var IconBleachNoChlorine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBleachNoChlorine
});

var IconBleachOff = createReactComponent("outline", "bleach-off", "IconBleachOff", [["path", { "d": "M5 19h14m1.986 -1.977a2 2 0 0 0 -.146 -.773l-7.1 -12.25a2 2 0 0 0 -3.5 0l-.815 1.405m-1.488 2.568l-4.797 8.277a2 2 0 0 0 1.75 2.75", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconBleachOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBleachOff
});

var IconBleach = createReactComponent("outline", "bleach", "IconBleach", [["path", { "d": "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75", "key": "svg-0" }]]);

var IconBleach$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBleach
});

var IconBlendMode = createReactComponent("outline", "blend-mode", "IconBlendMode", [["path", { "d": "M14.5 9.5m-6.5 0a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0 -13 0", "key": "svg-0" }], ["path", { "d": "M9.5 14.5m-6.5 0a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0 -13 0", "key": "svg-1" }]]);

var IconBlendMode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBlendMode
});

var IconBlender = createReactComponent("outline", "blender", "IconBlender", [["path", { "d": "M9 10h-3a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h10.802a1 1 0 0 1 .984 1.179l-1.786 9.821", "key": "svg-0" }], ["path", { "d": "M8 4l2 11", "key": "svg-1" }], ["path", { "d": "M11 15h4a3 3 0 0 1 3 3v2a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-2a3 3 0 0 1 3 -3z", "key": "svg-2" }], ["path", { "d": "M12 4v-1h2v1", "key": "svg-3" }], ["path", { "d": "M13 18v.01", "key": "svg-4" }]]);

var IconBlender$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBlender
});

var IconBlob = createReactComponent("outline", "blob", "IconBlob", [["path", { "d": "M5.897 20.188c1.67 .752 3.896 .812 6.103 .812s4.434 -.059 6.104 -.812c.868 -.392 1.614 -.982 2.133 -1.856c.514 -.865 .763 -1.94 .763 -3.234c0 -2.577 -.983 -5.315 -2.557 -7.416c-1.57 -2.094 -3.833 -3.682 -6.443 -3.682s-4.873 1.588 -6.443 3.682c-1.574 2.101 -2.557 4.84 -2.557 7.416c0 1.295 .249 2.369 .763 3.234c.519 .874 1.265 1.464 2.134 1.856", "key": "svg-0" }]]);

var IconBlob$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBlob
});

var IconBlockquote = createReactComponent("outline", "blockquote", "IconBlockquote", [["path", { "d": "M6 15h15", "key": "svg-0" }], ["path", { "d": "M21 19h-15", "key": "svg-1" }], ["path", { "d": "M15 11h6", "key": "svg-2" }], ["path", { "d": "M21 7h-6", "key": "svg-3" }], ["path", { "d": "M9 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2", "key": "svg-4" }], ["path", { "d": "M3 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2", "key": "svg-5" }]]);

var IconBlockquote$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBlockquote
});

var IconBlocks = createReactComponent("outline", "blocks", "IconBlocks", [["path", { "d": "M14 4a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M3 14h12a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h3a2 2 0 0 1 2 2v12", "key": "svg-1" }]]);

var IconBlocks$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBlocks
});

var IconBluetoothConnected = createReactComponent("outline", "bluetooth-connected", "IconBluetoothConnected", [["path", { "d": "M7 8l10 8l-5 4l0 -16l5 4l-10 8", "key": "svg-0" }], ["path", { "d": "M4 12l1 0", "key": "svg-1" }], ["path", { "d": "M18 12l1 0", "key": "svg-2" }]]);

var IconBluetoothConnected$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBluetoothConnected
});

var IconBluetoothOff = createReactComponent("outline", "bluetooth-off", "IconBluetoothOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M16.438 16.45l-4.438 3.55v-8m0 -4v-4l5 4l-2.776 2.22m-2.222 1.779l-5 4", "key": "svg-1" }]]);

var IconBluetoothOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBluetoothOff
});

var IconBluetoothX = createReactComponent("outline", "bluetooth-x", "IconBluetoothX", [["path", { "d": "M7 8l10 8l-5 4v-16l1 .802m0 6.396l-6 4.802", "key": "svg-0" }], ["path", { "d": "M16 6l4 4", "key": "svg-1" }], ["path", { "d": "M20 6l-4 4", "key": "svg-2" }]]);

var IconBluetoothX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBluetoothX
});

var IconBluetooth = createReactComponent("outline", "bluetooth", "IconBluetooth", [["path", { "d": "M7 8l10 8l-5 4l0 -16l5 4l-10 8", "key": "svg-0" }]]);

var IconBluetooth$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBluetooth
});

var IconBlurOff = createReactComponent("outline", "blur-off", "IconBlurOff", [["path", { "d": "M12 3v5m0 4v8", "key": "svg-0" }], ["path", { "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098", "key": "svg-1" }], ["path", { "d": "M16 12h5", "key": "svg-2" }], ["path", { "d": "M13 9h7", "key": "svg-3" }], ["path", { "d": "M12 6h6", "key": "svg-4" }], ["path", { "d": "M12 18h6", "key": "svg-5" }], ["path", { "d": "M12 15h3m4 0h1", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconBlurOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBlurOff
});

var IconBlur = createReactComponent("outline", "blur", "IconBlur", [["path", { "d": "M12 21a9.01 9.01 0 0 0 2.32 -.302a9 9 0 0 0 1.74 -16.733a9 9 0 1 0 -4.06 17.035z", "key": "svg-0" }], ["path", { "d": "M12 3v17", "key": "svg-1" }], ["path", { "d": "M12 12h9", "key": "svg-2" }], ["path", { "d": "M12 9h8", "key": "svg-3" }], ["path", { "d": "M12 6h6", "key": "svg-4" }], ["path", { "d": "M12 18h6", "key": "svg-5" }], ["path", { "d": "M12 15h8", "key": "svg-6" }]]);

var IconBlur$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBlur
});

var IconBmp = createReactComponent("outline", "bmp", "IconBmp", [["path", { "d": "M18 16v-8h2a2 2 0 1 1 0 4h-2", "key": "svg-0" }], ["path", { "d": "M6 14a2 2 0 0 1 -2 2h-2v-8h2a2 2 0 1 1 0 4h-2h2a2 2 0 0 1 2 2z", "key": "svg-1" }], ["path", { "d": "M9 16v-8l3 6l3 -6v8", "key": "svg-2" }]]);

var IconBmp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBmp
});

var IconBodyScan = createReactComponent("outline", "body-scan", "IconBodyScan", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M12 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["path", { "d": "M10 17v-1a2 2 0 1 1 4 0v1", "key": "svg-5" }], ["path", { "d": "M8 10c.666 .666 1.334 1 2 1h4c.666 0 1.334 -.334 2 -1", "key": "svg-6" }], ["path", { "d": "M12 11v3", "key": "svg-7" }]]);

var IconBodyScan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBodyScan
});

var IconBoldOff = createReactComponent("outline", "bold-off", "IconBoldOff", [["path", { "d": "M9 5h4a3.5 3.5 0 0 1 2.222 6.204m-3.222 .796h-5v-5", "key": "svg-0" }], ["path", { "d": "M17.107 17.112a3.5 3.5 0 0 1 -3.107 1.888h-7v-7", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconBoldOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoldOff
});

var IconBold = createReactComponent("outline", "bold", "IconBold", [["path", { "d": "M7 5h6a3.5 3.5 0 0 1 0 7h-6z", "key": "svg-0" }], ["path", { "d": "M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7", "key": "svg-1" }]]);

var IconBold$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBold
});

var IconBoltOff = createReactComponent("outline", "bolt-off", "IconBoltOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M15.212 15.21l-4.212 5.79v-7h-6l3.79 -5.21m1.685 -2.32l2.525 -3.47v6m1 1h5l-2.104 2.893", "key": "svg-1" }]]);

var IconBoltOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoltOff
});

var IconBolt = createReactComponent("outline", "bolt", "IconBolt", [["path", { "d": "M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11", "key": "svg-0" }]]);

var IconBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBolt
});

var IconBomb = createReactComponent("outline", "bomb", "IconBomb", [["path", { "d": "M15.349 5.349l3.301 3.301a1.2 1.2 0 0 1 0 1.698l-.972 .972a7.5 7.5 0 1 1 -5 -5l.972 -.972a1.2 1.2 0 0 1 1.698 0z", "key": "svg-0" }], ["path", { "d": "M17 7l1.293 -1.293a2.414 2.414 0 0 0 .707 -1.707a1 1 0 0 1 1 -1h1", "key": "svg-1" }], ["path", { "d": "M7 13a3 3 0 0 1 3 -3", "key": "svg-2" }]]);

var IconBomb$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBomb
});

var IconBoneOff = createReactComponent("outline", "bone-off", "IconBoneOff", [["path", { "d": "M12.5 8.502l.38 -.38a3 3 0 1 1 5.12 -2.122a3 3 0 1 1 -2.12 5.122l-.372 .372m-2.008 2.008l-2.378 2.378a3 3 0 1 1 -5.117 2.297l0 -.177l-.176 0a3 3 0 1 1 2.298 -5.115l2.378 -2.378", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconBoneOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoneOff
});

var IconBone = createReactComponent("outline", "bone", "IconBone", [["path", { "d": "M15 3a3 3 0 0 1 3 3a3 3 0 1 1 -2.12 5.122l-4.758 4.758a3 3 0 1 1 -5.117 2.297l0 -.177l-.176 0a3 3 0 1 1 2.298 -5.115l4.758 -4.758a3 3 0 0 1 2.12 -5.122z", "key": "svg-0" }]]);

var IconBone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBone
});

var IconBongOff = createReactComponent("outline", "bong-off", "IconBongOff", [["path", { "d": "M9 5v-2h4v6m1.5 1.5l2.5 -2.5l2 2l-2.5 2.5m-.5 3.505a5 5 0 1 1 -7 -4.589v-2.416", "key": "svg-0" }], ["path", { "d": "M8 3h6", "key": "svg-1" }], ["path", { "d": "M6.1 17h9.8", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconBongOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBongOff
});

var IconBong = createReactComponent("outline", "bong", "IconBong", [["path", { "d": "M13 3v8.416c.134 .059 .265 .123 .393 .193l3.607 -3.609l2 2l-3.608 3.608a5 5 0 1 1 -6.392 -2.192v-8.416h4z", "key": "svg-0" }], ["path", { "d": "M8 3h6", "key": "svg-1" }], ["path", { "d": "M6.1 17h9.8", "key": "svg-2" }]]);

var IconBong$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBong
});

var IconBook2 = createReactComponent("outline", "book-2", "IconBook2", [["path", { "d": "M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z", "key": "svg-0" }], ["path", { "d": "M19 16h-12a2 2 0 0 0 -2 2", "key": "svg-1" }], ["path", { "d": "M9 8h6", "key": "svg-2" }]]);

var IconBook2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBook2
});

var IconBookDownload = createReactComponent("outline", "book-download", "IconBookDownload", [["path", { "d": "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12v5", "key": "svg-0" }], ["path", { "d": "M13 16h-7a2 2 0 0 0 -2 2", "key": "svg-1" }], ["path", { "d": "M15 19l3 3l3 -3", "key": "svg-2" }], ["path", { "d": "M18 22v-9", "key": "svg-3" }]]);

var IconBookDownload$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookDownload
});

var IconBookOff = createReactComponent("outline", "book-off", "IconBookOff", [["path", { "d": "M3 19a9 9 0 0 1 9 0a9 9 0 0 1 5.899 -1.096", "key": "svg-0" }], ["path", { "d": "M3 6a9 9 0 0 1 2.114 -.884m3.8 -.21c1.07 .17 2.116 .534 3.086 1.094a9 9 0 0 1 9 0", "key": "svg-1" }], ["path", { "d": "M3 6v13", "key": "svg-2" }], ["path", { "d": "M12 6v2m0 4v7", "key": "svg-3" }], ["path", { "d": "M21 6v11", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconBookOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookOff
});

var IconBookUpload = createReactComponent("outline", "book-upload", "IconBookUpload", [["path", { "d": "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12v5", "key": "svg-0" }], ["path", { "d": "M11 16h-5a2 2 0 0 0 -2 2", "key": "svg-1" }], ["path", { "d": "M15 16l3 -3l3 3", "key": "svg-2" }], ["path", { "d": "M18 13v9", "key": "svg-3" }]]);

var IconBookUpload$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookUpload
});

var IconBook = createReactComponent("outline", "book", "IconBook", [["path", { "d": "M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0", "key": "svg-0" }], ["path", { "d": "M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0", "key": "svg-1" }], ["path", { "d": "M3 6l0 13", "key": "svg-2" }], ["path", { "d": "M12 6l0 13", "key": "svg-3" }], ["path", { "d": "M21 6l0 13", "key": "svg-4" }]]);

var IconBook$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBook
});

var IconBookmarkAi = createReactComponent("outline", "bookmark-ai", "IconBookmarkAi", [["path", { "d": "M10.02 18.32l-4.02 2.68v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v4.5", "key": "svg-0" }], ["path", { "d": "M14 21v-4a2 2 0 1 1 4 0v4", "key": "svg-1" }], ["path", { "d": "M14 19h4", "key": "svg-2" }], ["path", { "d": "M21 15v6", "key": "svg-3" }]]);

var IconBookmarkAi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookmarkAi
});

var IconBookmarkEdit = createReactComponent("outline", "bookmark-edit", "IconBookmarkEdit", [["path", { "d": "M12 17l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v4", "key": "svg-0" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 1 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z", "key": "svg-1" }]]);

var IconBookmarkEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookmarkEdit
});

var IconBookmarkMinus = createReactComponent("outline", "bookmark-minus", "IconBookmarkMinus", [["path", { "d": "M12 17l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v8", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconBookmarkMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookmarkMinus
});

var IconBookmarkOff = createReactComponent("outline", "bookmark-off", "IconBookmarkOff", [["path", { "d": "M7.708 3.721a3.982 3.982 0 0 1 2.292 -.721h4a4 4 0 0 1 4 4v7m0 4v3l-6 -4l-6 4v-14c0 -.308 .035 -.609 .1 -.897", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconBookmarkOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookmarkOff
});

var IconBookmarkPlus = createReactComponent("outline", "bookmark-plus", "IconBookmarkPlus", [["path", { "d": "M12 17l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v5", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconBookmarkPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookmarkPlus
});

var IconBookmarkQuestion = createReactComponent("outline", "bookmark-question", "IconBookmarkQuestion", [["path", { "d": "M15 19l-3 -2l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v4", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconBookmarkQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookmarkQuestion
});

var IconBookmark = createReactComponent("outline", "bookmark", "IconBookmark", [["path", { "d": "M18 7v14l-6 -4l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4z", "key": "svg-0" }]]);

var IconBookmark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookmark
});

var IconBookmarksOff = createReactComponent("outline", "bookmarks-off", "IconBookmarksOff", [["path", { "d": "M11 7h2a2 2 0 0 1 2 2v2m0 4v6l-5 -3l-5 3v-12a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M9.265 4a2 2 0 0 1 1.735 -1h6a2 2 0 0 1 2 2v10", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconBookmarksOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookmarksOff
});

var IconBookmarks = createReactComponent("outline", "bookmarks", "IconBookmarks", [["path", { "d": "M15 10v11l-5 -3l-5 3v-11a3 3 0 0 1 3 -3h4a3 3 0 0 1 3 3z", "key": "svg-0" }], ["path", { "d": "M11 3h5a3 3 0 0 1 3 3v11", "key": "svg-1" }]]);

var IconBookmarks$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookmarks
});

var IconBooksOff = createReactComponent("outline", "books-off", "IconBooksOff", [["path", { "d": "M9 9v10a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-14", "key": "svg-0" }], ["path", { "d": "M8 4a1 1 0 0 1 1 1", "key": "svg-1" }], ["path", { "d": "M9 5a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4", "key": "svg-2" }], ["path", { "d": "M13 13v6a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-10", "key": "svg-3" }], ["path", { "d": "M5 8h3", "key": "svg-4" }], ["path", { "d": "M9 16h4", "key": "svg-5" }], ["path", { "d": "M14.254 10.244l-1.218 -4.424a1.02 1.02 0 0 1 .634 -1.219l.133 -.041l2.184 -.53c.562 -.135 1.133 .19 1.282 .732l3.236 11.75", "key": "svg-6" }], ["path", { "d": "M19.585 19.589l-1.572 .38c-.562 .136 -1.133 -.19 -1.282 -.731l-.952 -3.458", "key": "svg-7" }], ["path", { "d": "M14 9l4 -1", "key": "svg-8" }], ["path", { "d": "M19.207 15.199l.716 -.18", "key": "svg-9" }], ["path", { "d": "M3 3l18 18", "key": "svg-10" }]]);

var IconBooksOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBooksOff
});

var IconBooks = createReactComponent("outline", "books", "IconBooks", [["path", { "d": "M5 4m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M9 4m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M5 8h4", "key": "svg-2" }], ["path", { "d": "M9 16h4", "key": "svg-3" }], ["path", { "d": "M13.803 4.56l2.184 -.53c.562 -.135 1.133 .19 1.282 .732l3.695 13.418a1.02 1.02 0 0 1 -.634 1.219l-.133 .041l-2.184 .53c-.562 .135 -1.133 -.19 -1.282 -.732l-3.695 -13.418a1.02 1.02 0 0 1 .634 -1.219l.133 -.041z", "key": "svg-4" }], ["path", { "d": "M14 9l4 -1", "key": "svg-5" }], ["path", { "d": "M16 16l3.923 -.98", "key": "svg-6" }]]);

var IconBooks$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBooks
});

var IconBoom = createReactComponent("outline", "boom", "IconBoom", [["path", { "d": "M3 9.662c2 2.338 2 4.338 0 6.338c3 .5 4.5 1 5 4c2 -3 6 -4 9 0c0 -3 1 -4 4 -4.004q -3 -2.995 0 -5.996c-3 0 -5 -2 -5 -5c-2 4 -5 3 -7.5 -1c-.5 3 -2.5 5 -5.5 5.662", "key": "svg-0" }]]);

var IconBoom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoom
});

var IconBorderAll = createReactComponent("outline", "border-all", "IconBorderAll", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 12l16 0", "key": "svg-1" }], ["path", { "d": "M12 4l0 16", "key": "svg-2" }]]);

var IconBorderAll$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderAll
});

var IconBorderBottomPlus = createReactComponent("outline", "border-bottom-plus", "IconBorderBottomPlus", [["path", { "d": "M4 20h16", "key": "svg-0" }], ["path", { "d": "M4 16v-.01", "key": "svg-1" }], ["path", { "d": "M20 16v-.01", "key": "svg-2" }], ["path", { "d": "M4 12v-.01", "key": "svg-3" }], ["path", { "d": "M20 12v-.01", "key": "svg-4" }], ["path", { "d": "M4 8v-.01", "key": "svg-5" }], ["path", { "d": "M20 8v-.01", "key": "svg-6" }], ["path", { "d": "M4 4v-.01", "key": "svg-7" }], ["path", { "d": "M8 4v-.01", "key": "svg-8" }], ["path", { "d": "M12 4v-.01", "key": "svg-9" }], ["path", { "d": "M16 4v-.01", "key": "svg-10" }], ["path", { "d": "M20 4v-.01", "key": "svg-11" }], ["path", { "d": "M15 12h-6", "key": "svg-12" }], ["path", { "d": "M12 9v6", "key": "svg-13" }]]);

var IconBorderBottomPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderBottomPlus
});

var IconBorderBottom = createReactComponent("outline", "border-bottom", "IconBorderBottom", [["path", { "d": "M20 20l-16 0", "key": "svg-0" }], ["path", { "d": "M4 4l0 .01", "key": "svg-1" }], ["path", { "d": "M8 4l0 .01", "key": "svg-2" }], ["path", { "d": "M12 4l0 .01", "key": "svg-3" }], ["path", { "d": "M16 4l0 .01", "key": "svg-4" }], ["path", { "d": "M20 4l0 .01", "key": "svg-5" }], ["path", { "d": "M4 8l0 .01", "key": "svg-6" }], ["path", { "d": "M12 8l0 .01", "key": "svg-7" }], ["path", { "d": "M20 8l0 .01", "key": "svg-8" }], ["path", { "d": "M4 12l0 .01", "key": "svg-9" }], ["path", { "d": "M8 12l0 .01", "key": "svg-10" }], ["path", { "d": "M12 12l0 .01", "key": "svg-11" }], ["path", { "d": "M16 12l0 .01", "key": "svg-12" }], ["path", { "d": "M20 12l0 .01", "key": "svg-13" }], ["path", { "d": "M4 16l0 .01", "key": "svg-14" }], ["path", { "d": "M12 16l0 .01", "key": "svg-15" }], ["path", { "d": "M20 16l0 .01", "key": "svg-16" }]]);

var IconBorderBottom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderBottom
});

var IconBorderCornerIos = createReactComponent("outline", "border-corner-ios", "IconBorderCornerIos", [["path", { "d": "M4 20c0 -6.559 0 -9.838 1.628 -12.162a9 9 0 0 1 2.21 -2.21c2.324 -1.628 5.602 -1.628 12.162 -1.628", "key": "svg-0" }]]);

var IconBorderCornerIos$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderCornerIos
});

var IconBorderCornerPill = createReactComponent("outline", "border-corner-pill", "IconBorderCornerPill", [["path", { "d": "M4 20v-5c0 -6.075 4.925 -11 11 -11h5", "key": "svg-0" }]]);

var IconBorderCornerPill$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderCornerPill
});

var IconBorderCornerRounded = createReactComponent("outline", "border-corner-rounded", "IconBorderCornerRounded", [["path", { "d": "M4 20v-10a6 6 0 0 1 6 -6h10", "key": "svg-0" }]]);

var IconBorderCornerRounded$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderCornerRounded
});

var IconBorderCornerSquare = createReactComponent("outline", "border-corner-square", "IconBorderCornerSquare", [["path", { "d": "M4 20v-15a1 1 0 0 1 1 -1h15", "key": "svg-0" }]]);

var IconBorderCornerSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderCornerSquare
});

var IconBorderCorners = createReactComponent("outline", "border-corners", "IconBorderCorners", [["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-0" }], ["path", { "d": "M20 16v2a2 2 0 0 1 -2 2h-2", "key": "svg-1" }], ["path", { "d": "M8 20h-2a2 2 0 0 1 -2 -2v-2", "key": "svg-2" }], ["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-3" }]]);

var IconBorderCorners$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderCorners
});

var IconBorderHorizontal = createReactComponent("outline", "border-horizontal", "IconBorderHorizontal", [["path", { "d": "M4 12l16 0", "key": "svg-0" }], ["path", { "d": "M4 4l0 .01", "key": "svg-1" }], ["path", { "d": "M8 4l0 .01", "key": "svg-2" }], ["path", { "d": "M12 4l0 .01", "key": "svg-3" }], ["path", { "d": "M16 4l0 .01", "key": "svg-4" }], ["path", { "d": "M20 4l0 .01", "key": "svg-5" }], ["path", { "d": "M4 8l0 .01", "key": "svg-6" }], ["path", { "d": "M12 8l0 .01", "key": "svg-7" }], ["path", { "d": "M20 8l0 .01", "key": "svg-8" }], ["path", { "d": "M4 16l0 .01", "key": "svg-9" }], ["path", { "d": "M12 16l0 .01", "key": "svg-10" }], ["path", { "d": "M20 16l0 .01", "key": "svg-11" }], ["path", { "d": "M4 20l0 .01", "key": "svg-12" }], ["path", { "d": "M8 20l0 .01", "key": "svg-13" }], ["path", { "d": "M12 20l0 .01", "key": "svg-14" }], ["path", { "d": "M16 20l0 .01", "key": "svg-15" }], ["path", { "d": "M20 20l0 .01", "key": "svg-16" }]]);

var IconBorderHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderHorizontal
});

var IconBorderInner = createReactComponent("outline", "border-inner", "IconBorderInner", [["path", { "d": "M4 12l16 0", "key": "svg-0" }], ["path", { "d": "M12 4l0 16", "key": "svg-1" }], ["path", { "d": "M4 4l0 .01", "key": "svg-2" }], ["path", { "d": "M8 4l0 .01", "key": "svg-3" }], ["path", { "d": "M16 4l0 .01", "key": "svg-4" }], ["path", { "d": "M20 4l0 .01", "key": "svg-5" }], ["path", { "d": "M4 8l0 .01", "key": "svg-6" }], ["path", { "d": "M20 8l0 .01", "key": "svg-7" }], ["path", { "d": "M4 16l0 .01", "key": "svg-8" }], ["path", { "d": "M20 16l0 .01", "key": "svg-9" }], ["path", { "d": "M4 20l0 .01", "key": "svg-10" }], ["path", { "d": "M8 20l0 .01", "key": "svg-11" }], ["path", { "d": "M16 20l0 .01", "key": "svg-12" }], ["path", { "d": "M20 20l0 .01", "key": "svg-13" }]]);

var IconBorderInner$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderInner
});

var IconBorderLeftPlus = createReactComponent("outline", "border-left-plus", "IconBorderLeftPlus", [["path", { "d": "M4 20v-16", "key": "svg-0" }], ["path", { "d": "M8 4v.01", "key": "svg-1" }], ["path", { "d": "M12 4v.01", "key": "svg-2" }], ["path", { "d": "M16 4v.01", "key": "svg-3" }], ["path", { "d": "M20 4v.01", "key": "svg-4" }], ["path", { "d": "M20 8v.01", "key": "svg-5" }], ["path", { "d": "M20 12v.01", "key": "svg-6" }], ["path", { "d": "M20 16v.01", "key": "svg-7" }], ["path", { "d": "M8 20v.01", "key": "svg-8" }], ["path", { "d": "M12 20v.01", "key": "svg-9" }], ["path", { "d": "M16 20v.01", "key": "svg-10" }], ["path", { "d": "M20 20v.01", "key": "svg-11" }], ["path", { "d": "M9 12h6", "key": "svg-12" }], ["path", { "d": "M12 9v6", "key": "svg-13" }]]);

var IconBorderLeftPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderLeftPlus
});

var IconBorderLeft = createReactComponent("outline", "border-left", "IconBorderLeft", [["path", { "d": "M4 20l0 -16", "key": "svg-0" }], ["path", { "d": "M8 4l0 .01", "key": "svg-1" }], ["path", { "d": "M12 4l0 .01", "key": "svg-2" }], ["path", { "d": "M16 4l0 .01", "key": "svg-3" }], ["path", { "d": "M20 4l0 .01", "key": "svg-4" }], ["path", { "d": "M12 8l0 .01", "key": "svg-5" }], ["path", { "d": "M20 8l0 .01", "key": "svg-6" }], ["path", { "d": "M8 12l0 .01", "key": "svg-7" }], ["path", { "d": "M12 12l0 .01", "key": "svg-8" }], ["path", { "d": "M16 12l0 .01", "key": "svg-9" }], ["path", { "d": "M20 12l0 .01", "key": "svg-10" }], ["path", { "d": "M12 16l0 .01", "key": "svg-11" }], ["path", { "d": "M20 16l0 .01", "key": "svg-12" }], ["path", { "d": "M8 20l0 .01", "key": "svg-13" }], ["path", { "d": "M12 20l0 .01", "key": "svg-14" }], ["path", { "d": "M16 20l0 .01", "key": "svg-15" }], ["path", { "d": "M20 20l0 .01", "key": "svg-16" }]]);

var IconBorderLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderLeft
});

var IconBorderNone = createReactComponent("outline", "border-none", "IconBorderNone", [["path", { "d": "M4 4l0 .01", "key": "svg-0" }], ["path", { "d": "M8 4l0 .01", "key": "svg-1" }], ["path", { "d": "M12 4l0 .01", "key": "svg-2" }], ["path", { "d": "M16 4l0 .01", "key": "svg-3" }], ["path", { "d": "M20 4l0 .01", "key": "svg-4" }], ["path", { "d": "M4 8l0 .01", "key": "svg-5" }], ["path", { "d": "M12 8l0 .01", "key": "svg-6" }], ["path", { "d": "M20 8l0 .01", "key": "svg-7" }], ["path", { "d": "M4 12l0 .01", "key": "svg-8" }], ["path", { "d": "M8 12l0 .01", "key": "svg-9" }], ["path", { "d": "M12 12l0 .01", "key": "svg-10" }], ["path", { "d": "M16 12l0 .01", "key": "svg-11" }], ["path", { "d": "M20 12l0 .01", "key": "svg-12" }], ["path", { "d": "M4 16l0 .01", "key": "svg-13" }], ["path", { "d": "M12 16l0 .01", "key": "svg-14" }], ["path", { "d": "M20 16l0 .01", "key": "svg-15" }], ["path", { "d": "M4 20l0 .01", "key": "svg-16" }], ["path", { "d": "M8 20l0 .01", "key": "svg-17" }], ["path", { "d": "M12 20l0 .01", "key": "svg-18" }], ["path", { "d": "M16 20l0 .01", "key": "svg-19" }], ["path", { "d": "M20 20l0 .01", "key": "svg-20" }]]);

var IconBorderNone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderNone
});

var IconBorderOuter = createReactComponent("outline", "border-outer", "IconBorderOuter", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 8l0 .01", "key": "svg-1" }], ["path", { "d": "M8 12l0 .01", "key": "svg-2" }], ["path", { "d": "M12 12l0 .01", "key": "svg-3" }], ["path", { "d": "M16 12l0 .01", "key": "svg-4" }], ["path", { "d": "M12 16l0 .01", "key": "svg-5" }]]);

var IconBorderOuter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderOuter
});

var IconBorderRadius = createReactComponent("outline", "border-radius", "IconBorderRadius", [["path", { "d": "M4 12v-4a4 4 0 0 1 4 -4h4", "key": "svg-0" }], ["path", { "d": "M16 4l0 .01", "key": "svg-1" }], ["path", { "d": "M20 4l0 .01", "key": "svg-2" }], ["path", { "d": "M20 8l0 .01", "key": "svg-3" }], ["path", { "d": "M20 12l0 .01", "key": "svg-4" }], ["path", { "d": "M4 16l0 .01", "key": "svg-5" }], ["path", { "d": "M20 16l0 .01", "key": "svg-6" }], ["path", { "d": "M4 20l0 .01", "key": "svg-7" }], ["path", { "d": "M8 20l0 .01", "key": "svg-8" }], ["path", { "d": "M12 20l0 .01", "key": "svg-9" }], ["path", { "d": "M16 20l0 .01", "key": "svg-10" }], ["path", { "d": "M20 20l0 .01", "key": "svg-11" }]]);

var IconBorderRadius$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderRadius
});

var IconBorderRightPlus = createReactComponent("outline", "border-right-plus", "IconBorderRightPlus", [["path", { "d": "M20 20v-16", "key": "svg-0" }], ["path", { "d": "M16 4v.01", "key": "svg-1" }], ["path", { "d": "M12 4v.01", "key": "svg-2" }], ["path", { "d": "M8 4v.01", "key": "svg-3" }], ["path", { "d": "M4 4v.01", "key": "svg-4" }], ["path", { "d": "M4 8v.01", "key": "svg-5" }], ["path", { "d": "M4 12v.01", "key": "svg-6" }], ["path", { "d": "M4 16v.01", "key": "svg-7" }], ["path", { "d": "M16 20v.01", "key": "svg-8" }], ["path", { "d": "M12 20v.01", "key": "svg-9" }], ["path", { "d": "M8 20v.01", "key": "svg-10" }], ["path", { "d": "M4 20v.01", "key": "svg-11" }], ["path", { "d": "M15 12h-6", "key": "svg-12" }], ["path", { "d": "M12 9v6", "key": "svg-13" }]]);

var IconBorderRightPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderRightPlus
});

var IconBorderRight = createReactComponent("outline", "border-right", "IconBorderRight", [["path", { "d": "M20 4l0 16", "key": "svg-0" }], ["path", { "d": "M4 4l0 .01", "key": "svg-1" }], ["path", { "d": "M8 4l0 .01", "key": "svg-2" }], ["path", { "d": "M12 4l0 .01", "key": "svg-3" }], ["path", { "d": "M16 4l0 .01", "key": "svg-4" }], ["path", { "d": "M4 8l0 .01", "key": "svg-5" }], ["path", { "d": "M12 8l0 .01", "key": "svg-6" }], ["path", { "d": "M4 12l0 .01", "key": "svg-7" }], ["path", { "d": "M8 12l0 .01", "key": "svg-8" }], ["path", { "d": "M12 12l0 .01", "key": "svg-9" }], ["path", { "d": "M16 12l0 .01", "key": "svg-10" }], ["path", { "d": "M4 16l0 .01", "key": "svg-11" }], ["path", { "d": "M12 16l0 .01", "key": "svg-12" }], ["path", { "d": "M4 20l0 .01", "key": "svg-13" }], ["path", { "d": "M8 20l0 .01", "key": "svg-14" }], ["path", { "d": "M12 20l0 .01", "key": "svg-15" }], ["path", { "d": "M16 20l0 .01", "key": "svg-16" }]]);

var IconBorderRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderRight
});

var IconBorderSides = createReactComponent("outline", "border-sides", "IconBorderSides", [["path", { "d": "M4 8v8", "key": "svg-0" }], ["path", { "d": "M20 16v-8", "key": "svg-1" }], ["path", { "d": "M8 4h8", "key": "svg-2" }], ["path", { "d": "M8 20h8", "key": "svg-3" }]]);

var IconBorderSides$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderSides
});

var IconBorderStyle2 = createReactComponent("outline", "border-style-2", "IconBorderStyle2", [["path", { "d": "M4 18v.01", "key": "svg-0" }], ["path", { "d": "M8 18v.01", "key": "svg-1" }], ["path", { "d": "M12 18v.01", "key": "svg-2" }], ["path", { "d": "M16 18v.01", "key": "svg-3" }], ["path", { "d": "M20 18v.01", "key": "svg-4" }], ["path", { "d": "M18 12h2", "key": "svg-5" }], ["path", { "d": "M11 12h2", "key": "svg-6" }], ["path", { "d": "M4 12h2", "key": "svg-7" }], ["path", { "d": "M4 6h16", "key": "svg-8" }]]);

var IconBorderStyle2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderStyle2
});

var IconBorderStyle = createReactComponent("outline", "border-style", "IconBorderStyle", [["path", { "d": "M4 20v-14a2 2 0 0 1 2 -2h14", "key": "svg-0" }], ["path", { "d": "M20 8v.01", "key": "svg-1" }], ["path", { "d": "M20 12v.01", "key": "svg-2" }], ["path", { "d": "M20 16v.01", "key": "svg-3" }], ["path", { "d": "M8 20v.01", "key": "svg-4" }], ["path", { "d": "M12 20v.01", "key": "svg-5" }], ["path", { "d": "M16 20v.01", "key": "svg-6" }], ["path", { "d": "M20 20v.01", "key": "svg-7" }]]);

var IconBorderStyle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderStyle
});

var IconBorderTopPlus = createReactComponent("outline", "border-top-plus", "IconBorderTopPlus", [["path", { "d": "M4 4h16", "key": "svg-0" }], ["path", { "d": "M4 8v.01", "key": "svg-1" }], ["path", { "d": "M20 8v.01", "key": "svg-2" }], ["path", { "d": "M4 12v.01", "key": "svg-3" }], ["path", { "d": "M20 12v.01", "key": "svg-4" }], ["path", { "d": "M4 16v.01", "key": "svg-5" }], ["path", { "d": "M15 12h-6", "key": "svg-6" }], ["path", { "d": "M12 9v6", "key": "svg-7" }], ["path", { "d": "M20 16v.01", "key": "svg-8" }], ["path", { "d": "M4 20v.01", "key": "svg-9" }], ["path", { "d": "M8 20v.01", "key": "svg-10" }], ["path", { "d": "M12 20v.01", "key": "svg-11" }], ["path", { "d": "M16 20v.01", "key": "svg-12" }], ["path", { "d": "M20 20v.01", "key": "svg-13" }]]);

var IconBorderTopPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderTopPlus
});

var IconBorderTop = createReactComponent("outline", "border-top", "IconBorderTop", [["path", { "d": "M4 4l16 0", "key": "svg-0" }], ["path", { "d": "M4 8l0 .01", "key": "svg-1" }], ["path", { "d": "M12 8l0 .01", "key": "svg-2" }], ["path", { "d": "M20 8l0 .01", "key": "svg-3" }], ["path", { "d": "M4 12l0 .01", "key": "svg-4" }], ["path", { "d": "M8 12l0 .01", "key": "svg-5" }], ["path", { "d": "M12 12l0 .01", "key": "svg-6" }], ["path", { "d": "M16 12l0 .01", "key": "svg-7" }], ["path", { "d": "M20 12l0 .01", "key": "svg-8" }], ["path", { "d": "M4 16l0 .01", "key": "svg-9" }], ["path", { "d": "M12 16l0 .01", "key": "svg-10" }], ["path", { "d": "M20 16l0 .01", "key": "svg-11" }], ["path", { "d": "M4 20l0 .01", "key": "svg-12" }], ["path", { "d": "M8 20l0 .01", "key": "svg-13" }], ["path", { "d": "M12 20l0 .01", "key": "svg-14" }], ["path", { "d": "M16 20l0 .01", "key": "svg-15" }], ["path", { "d": "M20 20l0 .01", "key": "svg-16" }]]);

var IconBorderTop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderTop
});

var IconBorderVertical = createReactComponent("outline", "border-vertical", "IconBorderVertical", [["path", { "d": "M12 4l0 16", "key": "svg-0" }], ["path", { "d": "M4 4l0 .01", "key": "svg-1" }], ["path", { "d": "M8 4l0 .01", "key": "svg-2" }], ["path", { "d": "M16 4l0 .01", "key": "svg-3" }], ["path", { "d": "M20 4l0 .01", "key": "svg-4" }], ["path", { "d": "M4 8l0 .01", "key": "svg-5" }], ["path", { "d": "M20 8l0 .01", "key": "svg-6" }], ["path", { "d": "M4 12l0 .01", "key": "svg-7" }], ["path", { "d": "M8 12l0 .01", "key": "svg-8" }], ["path", { "d": "M16 12l0 .01", "key": "svg-9" }], ["path", { "d": "M20 12l0 .01", "key": "svg-10" }], ["path", { "d": "M4 16l0 .01", "key": "svg-11" }], ["path", { "d": "M20 16l0 .01", "key": "svg-12" }], ["path", { "d": "M4 20l0 .01", "key": "svg-13" }], ["path", { "d": "M8 20l0 .01", "key": "svg-14" }], ["path", { "d": "M16 20l0 .01", "key": "svg-15" }], ["path", { "d": "M20 20l0 .01", "key": "svg-16" }]]);

var IconBorderVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBorderVertical
});

var IconBottleOff = createReactComponent("outline", "bottle-off", "IconBottleOff", [["path", { "d": "M10 5h4v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2z", "key": "svg-0" }], ["path", { "d": "M14 3.5c0 1.626 .507 3.212 1.45 4.537l.05 .07a8.093 8.093 0 0 1 1.5 4.694v.199m0 4v2a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-6.2a8.09 8.09 0 0 1 1.35 -4.474m1.336 -2.63a7.822 7.822 0 0 0 .314 -2.196", "key": "svg-1" }], ["path", { "d": "M7 14.803a2.4 2.4 0 0 0 1 -.803a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 .866 -.142", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconBottleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBottleOff
});

var IconBottle = createReactComponent("outline", "bottle", "IconBottle", [["path", { "d": "M10 5h4v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2z", "key": "svg-0" }], ["path", { "d": "M14 3.5c0 1.626 .507 3.212 1.45 4.537l.05 .07a8.093 8.093 0 0 1 1.5 4.694v6.199a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-6.2c0 -1.682 .524 -3.322 1.5 -4.693l.05 -.07a7.823 7.823 0 0 0 1.45 -4.537", "key": "svg-1" }], ["path", { "d": "M7 14.803a2.4 2.4 0 0 0 1 -.803a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1 -.805", "key": "svg-2" }]]);

var IconBottle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBottle
});

var IconBounceLeft = createReactComponent("outline", "bounce-left", "IconBounceLeft", [["path", { "d": "M20 15.5c-3 -1 -5.5 -.5 -8 4.5c-.5 -3 -1.5 -5.5 -3 -8", "key": "svg-0" }], ["path", { "d": "M6 9a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z", "key": "svg-1" }]]);

var IconBounceLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBounceLeft
});

var IconBounceRight = createReactComponent("outline", "bounce-right", "IconBounceRight", [["path", { "d": "M4 15.5c3 -1 5.5 -.5 8 4.5c.5 -3 1.5 -5.5 3 -8", "key": "svg-0" }], ["path", { "d": "M18 9a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z", "key": "svg-1" }]]);

var IconBounceRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBounceRight
});

var IconBow = createReactComponent("outline", "bow", "IconBow", [["path", { "d": "M17 3h4v4", "key": "svg-0" }], ["path", { "d": "M21 3l-15 15", "key": "svg-1" }], ["path", { "d": "M3 18h3v3", "key": "svg-2" }], ["path", { "d": "M16.5 20c1.576 -1.576 2.5 -4.095 2.5 -6.5c0 -4.81 -3.69 -8.5 -8.5 -8.5c-2.415 0 -4.922 .913 -6.5 2.5l12.5 12.5z", "key": "svg-3" }]]);

var IconBow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBow
});

var IconBowlChopsticks = createReactComponent("outline", "bowl-chopsticks", "IconBowlChopsticks", [["path", { "d": "M4 11h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M19 7l-14 1", "key": "svg-1" }], ["path", { "d": "M19 2l-14 3", "key": "svg-2" }]]);

var IconBowlChopsticks$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBowlChopsticks
});

var IconBowlSpoon = createReactComponent("outline", "bowl-spoon", "IconBowlSpoon", [["path", { "d": "M4 11h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M8 7c1.657 0 3 -.895 3 -2s-1.343 -2 -3 -2s-3 .895 -3 2s1.343 2 3 2", "key": "svg-1" }], ["path", { "d": "M11 5h9", "key": "svg-2" }]]);

var IconBowlSpoon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBowlSpoon
});

var IconBowl = createReactComponent("outline", "bowl", "IconBowl", [["path", { "d": "M4 8h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconBowl$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBowl
});

var IconBowling = createReactComponent("outline", "bowling", "IconBowling", [["path", { "d": "M7 11v.01", "key": "svg-0" }], ["path", { "d": "M11 10v.01", "key": "svg-1" }], ["path", { "d": "M10 14v.01", "key": "svg-2" }], ["path", { "d": "M11.059 6.07a8 8 0 1 0 .32 15.81", "key": "svg-3" }], ["path", { "d": "M15.969 9h4", "key": "svg-4" }], ["path", { "d": "M14.969 5c0 1.5 1 2 1 4c0 2.5 -2 4.5 -2 7c0 2.6 1.9 6 1.9 6h4.1s2 -3.4 2 -6c0 -2.5 -2 -4.5 -2 -7c0 -2 1 -2.5 1 -4a3 3 0 1 0 -6 0", "key": "svg-5" }]]);

var IconBowling$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBowling
});

var IconBoxAlignBottomLeft = createReactComponent("outline", "box-align-bottom-left", "IconBoxAlignBottomLeft", [["path", { "d": "M5 13h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M4 9v.01", "key": "svg-1" }], ["path", { "d": "M4 4v.01", "key": "svg-2" }], ["path", { "d": "M9 4v.01", "key": "svg-3" }], ["path", { "d": "M15 4v.01", "key": "svg-4" }], ["path", { "d": "M15 20v.01", "key": "svg-5" }], ["path", { "d": "M20 4v.01", "key": "svg-6" }], ["path", { "d": "M20 9v.01", "key": "svg-7" }], ["path", { "d": "M20 15v.01", "key": "svg-8" }], ["path", { "d": "M20 20v.01", "key": "svg-9" }]]);

var IconBoxAlignBottomLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignBottomLeft
});

var IconBoxAlignBottomRight = createReactComponent("outline", "box-align-bottom-right", "IconBoxAlignBottomRight", [["path", { "d": "M19 13h-5a1 1 0 0 0 -1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1 -1v-5a1 1 0 0 0 -1 -1z", "key": "svg-0" }], ["path", { "d": "M20 9v.01", "key": "svg-1" }], ["path", { "d": "M20 4v.01", "key": "svg-2" }], ["path", { "d": "M15 4v.01", "key": "svg-3" }], ["path", { "d": "M9 4v.01", "key": "svg-4" }], ["path", { "d": "M9 20v.01", "key": "svg-5" }], ["path", { "d": "M4 4v.01", "key": "svg-6" }], ["path", { "d": "M4 9v.01", "key": "svg-7" }], ["path", { "d": "M4 15v.01", "key": "svg-8" }], ["path", { "d": "M4 20v.01", "key": "svg-9" }]]);

var IconBoxAlignBottomRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignBottomRight
});

var IconBoxAlignBottom = createReactComponent("outline", "box-align-bottom", "IconBoxAlignBottom", [["path", { "d": "M4 14h16v5a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-5z", "key": "svg-0" }], ["path", { "d": "M4 9v.01", "key": "svg-1" }], ["path", { "d": "M4 4v.01", "key": "svg-2" }], ["path", { "d": "M9 4v.01", "key": "svg-3" }], ["path", { "d": "M15 4v.01", "key": "svg-4" }], ["path", { "d": "M20 4v.01", "key": "svg-5" }], ["path", { "d": "M20 9v.01", "key": "svg-6" }]]);

var IconBoxAlignBottom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignBottom
});

var IconBoxAlignLeft = createReactComponent("outline", "box-align-left", "IconBoxAlignLeft", [["path", { "d": "M10.002 20.003v-16h-5a1 1 0 0 0 -1 1v14a1 1 0 0 0 1 1h5z", "key": "svg-0" }], ["path", { "d": "M15.002 20.003h-.01", "key": "svg-1" }], ["path", { "d": "M20.003 20.003h-.011", "key": "svg-2" }], ["path", { "d": "M20.003 15.002h-.011", "key": "svg-3" }], ["path", { "d": "M20.003 9.002h-.011", "key": "svg-4" }], ["path", { "d": "M20.003 4.002h-.011", "key": "svg-5" }], ["path", { "d": "M15.002 4.002h-.01", "key": "svg-6" }]]);

var IconBoxAlignLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignLeft
});

var IconBoxAlignRight = createReactComponent("outline", "box-align-right", "IconBoxAlignRight", [["path", { "d": "M13.998 20.003v-16h5a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-5z", "key": "svg-0" }], ["path", { "d": "M8.998 20.003h.01", "key": "svg-1" }], ["path", { "d": "M3.997 20.003h.011", "key": "svg-2" }], ["path", { "d": "M3.997 15.002h.011", "key": "svg-3" }], ["path", { "d": "M3.997 9.002h.011", "key": "svg-4" }], ["path", { "d": "M3.997 4.002h.011", "key": "svg-5" }], ["path", { "d": "M8.998 4.002h.01", "key": "svg-6" }]]);

var IconBoxAlignRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignRight
});

var IconBoxAlignTopLeft = createReactComponent("outline", "box-align-top-left", "IconBoxAlignTopLeft", [["path", { "d": "M11 5v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1z", "key": "svg-0" }], ["path", { "d": "M15 4h-.01", "key": "svg-1" }], ["path", { "d": "M20 4h-.01", "key": "svg-2" }], ["path", { "d": "M20 9h-.01", "key": "svg-3" }], ["path", { "d": "M20 15h-.01", "key": "svg-4" }], ["path", { "d": "M4 15h-.01", "key": "svg-5" }], ["path", { "d": "M20 20h-.01", "key": "svg-6" }], ["path", { "d": "M15 20h-.01", "key": "svg-7" }], ["path", { "d": "M9 20h-.01", "key": "svg-8" }], ["path", { "d": "M4 20h-.01", "key": "svg-9" }]]);

var IconBoxAlignTopLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignTopLeft
});

var IconBoxAlignTopRight = createReactComponent("outline", "box-align-top-right", "IconBoxAlignTopRight", [["path", { "d": "M19 11.01h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1z", "key": "svg-0" }], ["path", { "d": "M20 15.01v-.01", "key": "svg-1" }], ["path", { "d": "M20 20.01v-.01", "key": "svg-2" }], ["path", { "d": "M15 20.01v-.01", "key": "svg-3" }], ["path", { "d": "M9 20.01v-.01", "key": "svg-4" }], ["path", { "d": "M9 4.01v-.01", "key": "svg-5" }], ["path", { "d": "M4 20.01v-.01", "key": "svg-6" }], ["path", { "d": "M4 15.01v-.01", "key": "svg-7" }], ["path", { "d": "M4 9.01v-.01", "key": "svg-8" }], ["path", { "d": "M4 4.01v-.01", "key": "svg-9" }]]);

var IconBoxAlignTopRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignTopRight
});

var IconBoxAlignTop = createReactComponent("outline", "box-align-top", "IconBoxAlignTop", [["path", { "d": "M4 10.005h16v-5a1 1 0 0 0 -1 -1h-14a1 1 0 0 0 -1 1v5z", "key": "svg-0" }], ["path", { "d": "M4 15.005v-.01", "key": "svg-1" }], ["path", { "d": "M4 20.005v-.01", "key": "svg-2" }], ["path", { "d": "M9 20.005v-.01", "key": "svg-3" }], ["path", { "d": "M15 20.005v-.01", "key": "svg-4" }], ["path", { "d": "M20 20.005v-.01", "key": "svg-5" }], ["path", { "d": "M20 15.005v-.01", "key": "svg-6" }]]);

var IconBoxAlignTop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignTop
});

var IconBoxMargin = createReactComponent("outline", "box-margin", "IconBoxMargin", [["path", { "d": "M8 8h8v8h-8z", "key": "svg-0" }], ["path", { "d": "M4 4v.01", "key": "svg-1" }], ["path", { "d": "M8 4v.01", "key": "svg-2" }], ["path", { "d": "M12 4v.01", "key": "svg-3" }], ["path", { "d": "M16 4v.01", "key": "svg-4" }], ["path", { "d": "M20 4v.01", "key": "svg-5" }], ["path", { "d": "M4 20v.01", "key": "svg-6" }], ["path", { "d": "M8 20v.01", "key": "svg-7" }], ["path", { "d": "M12 20v.01", "key": "svg-8" }], ["path", { "d": "M16 20v.01", "key": "svg-9" }], ["path", { "d": "M20 20v.01", "key": "svg-10" }], ["path", { "d": "M20 16v.01", "key": "svg-11" }], ["path", { "d": "M20 12v.01", "key": "svg-12" }], ["path", { "d": "M20 8v.01", "key": "svg-13" }], ["path", { "d": "M4 16v.01", "key": "svg-14" }], ["path", { "d": "M4 12v.01", "key": "svg-15" }], ["path", { "d": "M4 8v.01", "key": "svg-16" }]]);

var IconBoxMargin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMargin
});

var IconBoxModel2Off = createReactComponent("outline", "box-model-2-off", "IconBoxModel2Off", [["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405", "key": "svg-0" }], ["path", { "d": "M12 8h4v4m0 4h-8v-8", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconBoxModel2Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxModel2Off
});

var IconBoxModel2 = createReactComponent("outline", "box-model-2", "IconBoxModel2", [["path", { "d": "M8 8h8v8h-8z", "key": "svg-0" }], ["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconBoxModel2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxModel2
});

var IconBoxModelOff = createReactComponent("outline", "box-model-off", "IconBoxModelOff", [["path", { "d": "M12 8h4v4m0 4h-8v-8", "key": "svg-0" }], ["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405", "key": "svg-1" }], ["path", { "d": "M16 16l3.3 3.3", "key": "svg-2" }], ["path", { "d": "M16 8l3.3 -3.3", "key": "svg-3" }], ["path", { "d": "M8 8l-3.3 -3.3", "key": "svg-4" }], ["path", { "d": "M8 16l-3.3 3.3", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconBoxModelOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxModelOff
});

var IconBoxModel = createReactComponent("outline", "box-model", "IconBoxModel", [["path", { "d": "M8 8h8v8h-8z", "key": "svg-0" }], ["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M16 16l3.3 3.3", "key": "svg-2" }], ["path", { "d": "M16 8l3.3 -3.3", "key": "svg-3" }], ["path", { "d": "M8 8l-3.3 -3.3", "key": "svg-4" }], ["path", { "d": "M8 16l-3.3 3.3", "key": "svg-5" }]]);

var IconBoxModel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxModel
});

var IconBoxMultiple0 = createReactComponent("outline", "box-multiple-0", "IconBoxMultiple0", [["path", { "d": "M14 6a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-2" }]]);

var IconBoxMultiple0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMultiple0
});

var IconBoxMultiple1 = createReactComponent("outline", "box-multiple-1", "IconBoxMultiple1", [["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M14 14v-8l-2 2", "key": "svg-2" }]]);

var IconBoxMultiple1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMultiple1
});

var IconBoxMultiple2 = createReactComponent("outline", "box-multiple-2", "IconBoxMultiple2", [["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M12 8a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0", "key": "svg-2" }]]);

var IconBoxMultiple2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMultiple2
});

var IconBoxMultiple3 = createReactComponent("outline", "box-multiple-3", "IconBoxMultiple3", [["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M14 10a2 2 0 1 0 -2 -2", "key": "svg-2" }], ["path", { "d": "M12 12a2 2 0 1 0 2 -2", "key": "svg-3" }]]);

var IconBoxMultiple3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMultiple3
});

var IconBoxMultiple4 = createReactComponent("outline", "box-multiple-4", "IconBoxMultiple4", [["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M15 14v-8l-4 6h5", "key": "svg-2" }]]);

var IconBoxMultiple4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMultiple4
});

var IconBoxMultiple5 = createReactComponent("outline", "box-multiple-5", "IconBoxMultiple5", [["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 14h2a2 2 0 1 0 0 -4h-2v-4h4", "key": "svg-1" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-2" }]]);

var IconBoxMultiple5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMultiple5
});

var IconBoxMultiple6 = createReactComponent("outline", "box-multiple-6", "IconBoxMultiple6", [["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M16 8a2 2 0 1 0 -4 0v4", "key": "svg-2" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-3" }]]);

var IconBoxMultiple6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMultiple6
});

var IconBoxMultiple7 = createReactComponent("outline", "box-multiple-7", "IconBoxMultiple7", [["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 6h4l-2 8", "key": "svg-1" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-2" }]]);

var IconBoxMultiple7$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMultiple7
});

var IconBoxMultiple8 = createReactComponent("outline", "box-multiple-8", "IconBoxMultiple8", [["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M14 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-3" }]]);

var IconBoxMultiple8$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMultiple8
});

var IconBoxMultiple9 = createReactComponent("outline", "box-multiple-9", "IconBoxMultiple9", [["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M12 12a2 2 0 1 0 4 0v-4", "key": "svg-2" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-3" }]]);

var IconBoxMultiple9$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMultiple9
});

var IconBoxMultiple = createReactComponent("outline", "box-multiple", "IconBoxMultiple", [["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-1" }]]);

var IconBoxMultiple$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMultiple
});

var IconBoxOff = createReactComponent("outline", "box-off", "IconBoxOff", [["path", { "d": "M17.765 17.757l-5.765 3.243l-8 -4.5v-9l2.236 -1.258m2.57 -1.445l3.194 -1.797l8 4.5v8.5", "key": "svg-0" }], ["path", { "d": "M14.561 10.559l5.439 -3.059", "key": "svg-1" }], ["path", { "d": "M12 12v9", "key": "svg-2" }], ["path", { "d": "M12 12l-8 -4.5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconBoxOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxOff
});

var IconBoxPadding = createReactComponent("outline", "box-padding", "IconBoxPadding", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 16v.01", "key": "svg-1" }], ["path", { "d": "M8 12v.01", "key": "svg-2" }], ["path", { "d": "M8 8v.01", "key": "svg-3" }], ["path", { "d": "M16 16v.01", "key": "svg-4" }], ["path", { "d": "M16 12v.01", "key": "svg-5" }], ["path", { "d": "M16 8v.01", "key": "svg-6" }], ["path", { "d": "M12 8v.01", "key": "svg-7" }], ["path", { "d": "M12 16v.01", "key": "svg-8" }]]);

var IconBoxPadding$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxPadding
});

var IconBox = createReactComponent("outline", "box", "IconBox", [["path", { "d": "M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5", "key": "svg-0" }], ["path", { "d": "M12 12l8 -4.5", "key": "svg-1" }], ["path", { "d": "M12 12l0 9", "key": "svg-2" }], ["path", { "d": "M12 12l-8 -4.5", "key": "svg-3" }]]);

var IconBox$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBox
});

var IconBracesOff = createReactComponent("outline", "braces-off", "IconBracesOff", [["path", { "d": "M5.176 5.177c-.113 .251 -.176 .53 -.176 .823v3c0 1.657 -.895 3 -2 3c1.105 0 2 1.343 2 3v3a2 2 0 0 0 2 2", "key": "svg-0" }], ["path", { "d": "M17 4a2 2 0 0 1 2 2v3c0 1.657 .895 3 2 3c-1.105 0 -2 1.343 -2 3m-.176 3.821a2 2 0 0 1 -1.824 1.179", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconBracesOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBracesOff
});

var IconBraces = createReactComponent("outline", "braces", "IconBraces", [["path", { "d": "M7 4a2 2 0 0 0 -2 2v3a2 3 0 0 1 -2 3a2 3 0 0 1 2 3v3a2 2 0 0 0 2 2", "key": "svg-0" }], ["path", { "d": "M17 4a2 2 0 0 1 2 2v3a2 3 0 0 0 2 3a2 3 0 0 0 -2 3v3a2 2 0 0 1 -2 2", "key": "svg-1" }]]);

var IconBraces$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBraces
});

var IconBracketsAngleOff = createReactComponent("outline", "brackets-angle-off", "IconBracketsAngleOff", [["path", { "d": "M8 4h.01", "key": "svg-0" }], ["path", { "d": "M6.453 6.474l-3.453 5.526l5 8", "key": "svg-1" }], ["path", { "d": "M16 4l5 8l-1.917 3.067", "key": "svg-2" }], ["path", { "d": "M17.535 17.544l-1.535 2.456", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconBracketsAngleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBracketsAngleOff
});

var IconBracketsAngle = createReactComponent("outline", "brackets-angle", "IconBracketsAngle", [["path", { "d": "M8 4l-5 8l5 8", "key": "svg-0" }], ["path", { "d": "M16 4l5 8l-5 8", "key": "svg-1" }]]);

var IconBracketsAngle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBracketsAngle
});

var IconBracketsContainEnd = createReactComponent("outline", "brackets-contain-end", "IconBracketsContainEnd", [["path", { "d": "M14 4h4v16h-4", "key": "svg-0" }], ["path", { "d": "M5 16h.01", "key": "svg-1" }], ["path", { "d": "M9 16h.01", "key": "svg-2" }], ["path", { "d": "M13 16h.01", "key": "svg-3" }]]);

var IconBracketsContainEnd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBracketsContainEnd
});

var IconBracketsContainStart = createReactComponent("outline", "brackets-contain-start", "IconBracketsContainStart", [["path", { "d": "M9 4h-4v16h4", "key": "svg-0" }], ["path", { "d": "M18 16h-.01", "key": "svg-1" }], ["path", { "d": "M14 16h-.01", "key": "svg-2" }], ["path", { "d": "M10 16h-.01", "key": "svg-3" }]]);

var IconBracketsContainStart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBracketsContainStart
});

var IconBracketsContain = createReactComponent("outline", "brackets-contain", "IconBracketsContain", [["path", { "d": "M7 4h-4v16h4", "key": "svg-0" }], ["path", { "d": "M17 4h4v16h-4", "key": "svg-1" }], ["path", { "d": "M8 16h.01", "key": "svg-2" }], ["path", { "d": "M12 16h.01", "key": "svg-3" }], ["path", { "d": "M16 16h.01", "key": "svg-4" }]]);

var IconBracketsContain$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBracketsContain
});

var IconBracketsOff = createReactComponent("outline", "brackets-off", "IconBracketsOff", [["path", { "d": "M5 5v15h3", "key": "svg-0" }], ["path", { "d": "M16 4h3v11m0 4v1h-3", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconBracketsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBracketsOff
});

var IconBrackets = createReactComponent("outline", "brackets", "IconBrackets", [["path", { "d": "M8 4h-3v16h3", "key": "svg-0" }], ["path", { "d": "M16 4h3v16h-3", "key": "svg-1" }]]);

var IconBrackets$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrackets
});

var IconBraille = createReactComponent("outline", "braille", "IconBraille", [["path", { "d": "M15 5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z", "key": "svg-0" }], ["path", { "d": "M7 5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z", "key": "svg-1" }], ["path", { "d": "M7 19a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z", "key": "svg-2" }], ["path", { "d": "M16 12h.01", "key": "svg-3" }], ["path", { "d": "M8 12h.01", "key": "svg-4" }], ["path", { "d": "M16 19h.01", "key": "svg-5" }]]);

var IconBraille$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBraille
});

var IconBrain = createReactComponent("outline", "brain", "IconBrain", [["path", { "d": "M15.5 13a3.5 3.5 0 0 0 -3.5 3.5v1a3.5 3.5 0 0 0 7 0v-1.8", "key": "svg-0" }], ["path", { "d": "M8.5 13a3.5 3.5 0 0 1 3.5 3.5v1a3.5 3.5 0 0 1 -7 0v-1.8", "key": "svg-1" }], ["path", { "d": "M17.5 16a3.5 3.5 0 0 0 0 -7h-.5", "key": "svg-2" }], ["path", { "d": "M19 9.3v-2.8a3.5 3.5 0 0 0 -7 0", "key": "svg-3" }], ["path", { "d": "M6.5 16a3.5 3.5 0 0 1 0 -7h.5", "key": "svg-4" }], ["path", { "d": "M5 9.3v-2.8a3.5 3.5 0 0 1 7 0v10", "key": "svg-5" }]]);

var IconBrain$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrain
});

var IconBrand4chan = createReactComponent("outline", "brand-4chan", "IconBrand4chan", [["path", { "d": "M14 11s6.054 -1.05 6 -4.5c-.038 -2.324 -2.485 -3.19 -3.016 -1.5c0 0 -.502 -2 -2.01 -2c-1.508 0 -2.984 3 -.974 8z", "key": "svg-0" }], ["path", { "d": "M13.98 11s6.075 -1.05 6.02 -4.5c-.038 -2.324 -2.493 -3.19 -3.025 -1.5c0 0 -.505 -2 -2.017 -2c-1.513 0 -3 3 -.977 8z", "key": "svg-1" }], ["path", { "d": "M13 13.98l.062 .309l.081 .35l.075 .29l.092 .328l.11 .358l.061 .188l.139 .392c.64 1.73 1.841 3.837 3.88 3.805c2.324 -.038 3.19 -2.493 1.5 -3.025l.148 -.045l.165 -.058a4.13 4.13 0 0 0 .098 -.039l.222 -.098c.586 -.28 1.367 -.832 1.367 -1.777c0 -1.513 -3 -3 -8 -.977z", "key": "svg-2" }], ["path", { "d": "M10.02 13l-.309 .062l-.35 .081l-.29 .075l-.328 .092l-.358 .11l-.188 .061l-.392 .139c-1.73 .64 -3.837 1.84 -3.805 3.88c.038 2.324 2.493 3.19 3.025 1.5l.045 .148l.058 .165l.039 .098l.098 .222c.28 .586 .832 1.367 1.777 1.367c1.513 0 3 -3 .977 -8z", "key": "svg-3" }], ["path", { "d": "M11 10.02l-.062 -.309l-.081 -.35l-.075 -.29l-.092 -.328l-.11 -.358l-.128 -.382l-.148 -.399c-.658 -1.687 -1.844 -3.634 -3.804 -3.604c-2.324 .038 -3.19 2.493 -1.5 3.025l-.148 .045l-.164 .058a4.13 4.13 0 0 0 -.1 .039l-.22 .098c-.588 .28 -1.368 .832 -1.368 1.777c0 1.513 3 3 8 .977z", "key": "svg-4" }]]);

var IconBrand4chan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrand4chan
});

var IconBrandAbstract = createReactComponent("outline", "brand-abstract", "IconBrandAbstract", [["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-0" }], ["path", { "d": "M10.5 13.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-1" }], ["path", { "d": "M8 8h8v8", "key": "svg-2" }]]);

var IconBrandAbstract$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAbstract
});

var IconBrandAdobeAfterEffect = createReactComponent("outline", "brand-adobe-after-effect", "IconBrandAdobeAfterEffect", [["path", { "d": "M3 12c0 -4.243 0 -6.364 1.318 -7.682s3.44 -1.318 7.682 -1.318s6.364 0 7.682 1.318s1.318 3.44 1.318 7.682s0 6.364 -1.318 7.682s-3.44 1.318 -7.682 1.318s-6.364 0 -7.682 -1.318s-1.318 -3.44 -1.318 -7.682", "key": "svg-0" }], ["path", { "d": "M12 15.79l-.82 -2.653m-4.864 2.652l.82 -2.652m0 0l.686 -2.218c.559 -1.806 .838 -2.708 1.336 -2.708s.777 .902 1.335 2.708l.686 2.218m-4.043 0h4.043", "key": "svg-1" }], ["path", { "d": "M13.895 12.824v1.07a1.895 1.895 0 0 0 3.54 .942m-3.54 -2.012v-.824a1.895 1.895 0 1 1 3.79 0v.824z", "key": "svg-2" }]]);

var IconBrandAdobeAfterEffect$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAdobeAfterEffect
});

var IconBrandAdobeIllustrator = createReactComponent("outline", "brand-adobe-illustrator", "IconBrandAdobeIllustrator", [["path", { "d": "M3 12c0 -4.243 0 -6.364 1.318 -7.682s3.44 -1.318 7.682 -1.318s6.364 0 7.682 1.318s1.318 3.44 1.318 7.682s0 6.364 -1.318 7.682s-3.44 1.318 -7.682 1.318s-6.364 0 -7.682 -1.318s-1.318 -3.44 -1.318 -7.682", "key": "svg-0" }], ["path", { "d": "M12.947 15.79l-.82 -2.653m-4.864 2.652l.82 -2.652m0 0l.687 -2.218c.558 -1.806 .838 -2.708 1.335 -2.708c.498 0 .777 .902 1.336 2.708l.686 2.218m-4.043 0h4.043", "key": "svg-1" }], ["path", { "d": "M15.789 15.789v-4.736", "key": "svg-2" }], ["path", { "d": "M15.789 8.684v-.473", "key": "svg-3" }]]);

var IconBrandAdobeIllustrator$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAdobeIllustrator
});

var IconBrandAdobeIndesign = createReactComponent("outline", "brand-adobe-indesign", "IconBrandAdobeIndesign", [["path", { "d": "M3 12c0 -4.243 0 -6.364 1.318 -7.682s3.44 -1.318 7.682 -1.318s6.364 0 7.682 1.318s1.318 3.44 1.318 7.682s0 6.364 -1.318 7.682s-3.44 1.318 -7.682 1.318s-6.364 0 -7.682 -1.318s-1.318 -3.44 -1.318 -7.682", "key": "svg-0" }], ["path", { "d": "M14.842 11.053v3.79c0 1.044 -.49 .946 -1.42 .946a2.368 2.368 0 0 1 0 -4.736zm0 0v-2.843", "key": "svg-1" }], ["path", { "d": "M8.211 8.211v7.578", "key": "svg-2" }]]);

var IconBrandAdobeIndesign$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAdobeIndesign
});

var IconBrandAdobePhotoshop = createReactComponent("outline", "brand-adobe-photoshop", "IconBrandAdobePhotoshop", [["path", { "d": "M3 12c0 -4.243 0 -6.364 1.318 -7.682s3.44 -1.318 7.682 -1.318s6.364 0 7.682 1.318s1.318 3.44 1.318 7.682s0 6.364 -1.318 7.682s-3.44 1.318 -7.682 1.318s-6.364 0 -7.682 -1.318s-1.318 -3.44 -1.318 -7.682", "key": "svg-0" }], ["path", { "d": "M6.79 15.79v-3.79m0 0v-2.724c0 -.11 0 -.165 .004 -.211c.044 -.45 .4 -.806 .85 -.85c.046 -.004 .101 -.004 .211 -.004h1.303a1.895 1.895 0 1 1 0 3.789z", "key": "svg-1" }], ["path", { "d": "M17.178 11.263c-.164 -.659 -.935 -1.158 -1.862 -1.158c-1.047 0 -1.895 .637 -1.895 1.421c0 .785 .848 1.421 1.895 1.421c1.046 0 1.895 .637 1.895 1.421c0 .785 -.849 1.421 -1.895 1.421c-.93 0 -1.704 -.502 -1.864 -1.165", "key": "svg-2" }]]);

var IconBrandAdobePhotoshop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAdobePhotoshop
});

var IconBrandAdobePremier = createReactComponent("outline", "brand-adobe-premier", "IconBrandAdobePremier", [["path", { "d": "M3 12c0 -4.243 0 -6.364 1.318 -7.682s3.44 -1.318 7.682 -1.318s6.364 0 7.682 1.318s1.318 3.44 1.318 7.682s0 6.364 -1.318 7.682s-3.44 1.318 -7.682 1.318s-6.364 0 -7.682 -1.318s-1.318 -3.44 -1.318 -7.682", "key": "svg-0" }], ["path", { "d": "M7.263 15.79v-3.79m0 0v-3.248c0 -.335 .222 -.541 .542 -.541h1.353a1.895 1.895 0 1 1 0 3.789z", "key": "svg-1" }], ["path", { "d": "M13.895 10.579v1.895m0 0v3.315m0 -3.315c.531 -.709 1.026 -1.592 1.894 -1.832q .22 -.062 .474 -.063", "key": "svg-2" }]]);

var IconBrandAdobePremier$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAdobePremier
});

var IconBrandAdobeXd = createReactComponent("outline", "brand-adobe-xd", "IconBrandAdobeXd", [["path", { "d": "M3 12c0 -4.243 0 -6.364 1.318 -7.682s3.44 -1.318 7.682 -1.318s6.364 0 7.682 1.318s1.318 3.44 1.318 7.682s0 6.364 -1.318 7.682s-3.44 1.318 -7.682 1.318s-6.364 0 -7.682 -1.318s-1.318 -3.44 -1.318 -7.682", "key": "svg-0" }], ["path", { "d": "M6.316 8.21l5.684 7.58m-5.684 0l5.684 -7.58", "key": "svg-1" }], ["path", { "d": "M17.684 11.053v3.79c0 1.044 -.49 .946 -1.42 .946a2.368 2.368 0 0 1 0 -4.736zm0 0v-2.843", "key": "svg-2" }]]);

var IconBrandAdobeXd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAdobeXd
});

var IconBrandAdobe = createReactComponent("outline", "brand-adobe", "IconBrandAdobe", [["path", { "d": "M12.893 4.514l7.977 14a.993 .993 0 0 1 -.394 1.365a1.04 1.04 0 0 1 -.5 .127h-3.476l-4.5 -8l-2.5 4h1.5l2 4h-8.977c-.565 0 -1.023 -.45 -1.023 -1c0 -.171 .045 -.34 .13 -.49l7.977 -13.993a1.034 1.034 0 0 1 1.786 0z", "key": "svg-0" }]]);

var IconBrandAdobe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAdobe
});

var IconBrandAdonisJs = createReactComponent("outline", "brand-adonis-js", "IconBrandAdonisJs", [["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-0" }], ["path", { "d": "M8.863 16.922c1.137 -.422 1.637 -.922 3.137 -.922s2 .5 3.138 .922c.713 .264 1.516 -.102 1.778 -.772c.126 -.32 .11 -.673 -.044 -.983l-3.708 -7.474c-.297 -.598 -1.058 -.859 -1.7 -.583a1.24 1.24 0 0 0 -.627 .583l-3.709 7.474c-.321 .648 -.017 1.415 .679 1.714c.332 .143 .715 .167 1.056 .04z", "key": "svg-1" }]]);

var IconBrandAdonisJs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAdonisJs
});

var IconBrandAirbnb = createReactComponent("outline", "brand-airbnb", "IconBrandAirbnb", [["path", { "d": "M12 10c-2 0 -3 1 -3 3c0 1.5 1.494 3.535 3 5.5c1 1 1.5 1.5 2.5 2s2.5 1 4.5 -.5s1.5 -3.5 .5 -6s-2.333 -5.5 -5 -9.5c-.834 -1 -1.5 -1.5 -2.503 -1.5c-1 0 -1.623 .45 -2.497 1.5c-2.667 4 -4 7 -5 9.5s-1.5 4.5 .5 6s3.5 1 4.5 .5s1.5 -1 2.5 -2c1.506 -1.965 3 -4 3 -5.5c0 -2 -1 -3 -3 -3z", "key": "svg-0" }]]);

var IconBrandAirbnb$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAirbnb
});

var IconBrandAirtable = createReactComponent("outline", "brand-airtable", "IconBrandAirtable", [["path", { "d": "M3 10v8l7 -3v-2.6z", "key": "svg-0" }], ["path", { "d": "M3 6l9 3l9 -3l-9 -3z", "key": "svg-1" }], ["path", { "d": "M14 12.3v8.7l7 -3v-8z", "key": "svg-2" }]]);

var IconBrandAirtable$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAirtable
});

var IconBrandAlgolia = createReactComponent("outline", "brand-algolia", "IconBrandAlgolia", [["path", { "d": "M15.5 11c-.414 -1.477 -1.886 -2.5 -3.5 -2.5a3.47 3.47 0 0 0 -3.5 3.5a3.47 3.47 0 0 0 3.5 3.5c.974 0 1.861 -.357 2.5 -1l4.5 4.5v-15h-7c-4.386 0 -8 3.582 -8 8s3.614 8 8 8a7.577 7.577 0 0 0 2.998 -.614", "key": "svg-0" }]]);

var IconBrandAlgolia$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAlgolia
});

var IconBrandAlipay = createReactComponent("outline", "brand-alipay", "IconBrandAlipay", [["path", { "d": "M19 3h-14a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-14a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 7h10", "key": "svg-1" }], ["path", { "d": "M12 3v7", "key": "svg-2" }], ["path", { "d": "M21 17.314c-2.971 -1.923 -15 -8.779 -15 -1.864c0 1.716 1.52 2.55 2.985 2.55c3.512 0 6.814 -5.425 6.814 -8h-6.604", "key": "svg-3" }]]);

var IconBrandAlipay$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAlipay
});

var IconBrandAlpineJs = createReactComponent("outline", "brand-alpine-js", "IconBrandAlpineJs", [["path", { "d": "M3 11.5l4.5 4.5h9l-9 -9z", "key": "svg-0" }], ["path", { "d": "M16.5 16l4.5 -4.5l-4.5 -4.5l-4.5 4.5", "key": "svg-1" }]]);

var IconBrandAlpineJs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAlpineJs
});

var IconBrandAmazon = createReactComponent("outline", "brand-amazon", "IconBrandAmazon", [["path", { "d": "M17 12.5a15.198 15.198 0 0 1 -7.37 1.44a14.62 14.62 0 0 1 -6.63 -2.94", "key": "svg-0" }], ["path", { "d": "M19.5 15c.907 -1.411 1.451 -3.323 1.5 -5c-1.197 -.773 -2.577 -.935 -4 -1", "key": "svg-1" }]]);

var IconBrandAmazon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAmazon
});

var IconBrandAmd = createReactComponent("outline", "brand-amd", "IconBrandAmd", [["path", { "d": "M16 16v-7c0 -.566 -.434 -1 -1 -1h-7l-5 -5h17c.566 0 1 .434 1 1v17l-5 -5z", "key": "svg-0" }], ["path", { "d": "M11.293 20.707l4.707 -4.707h-7a1 1 0 0 1 -1 -1v-7l-4.707 4.707a1 1 0 0 0 -.293 .707v6.586a1 1 0 0 0 1 1h6.586a1 1 0 0 0 .707 -.293z", "key": "svg-1" }]]);

var IconBrandAmd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAmd
});

var IconBrandAmie = createReactComponent("outline", "brand-amie", "IconBrandAmie", [["path", { "d": "M3 8.5c0 1.33 .472 2.55 1.257 3.5a5.5 5.5 0 0 0 7.743 7.743a5.5 5.5 0 0 0 7.743 -7.743a5.5 5.5 0 0 0 -7.743 -7.743a5.5 5.5 0 0 0 -9 4.243", "key": "svg-0" }], ["path", { "d": "M10 9.5c0 -.828 .895 -1.5 2 -1.5s2 .672 2 1.5v5c0 .828 -.895 1.5 -2 1.5s-2 -.672 -2 -1.5z", "key": "svg-1" }]]);

var IconBrandAmie$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAmie
});

var IconBrandAmigo = createReactComponent("outline", "brand-amigo", "IconBrandAmigo", [["path", { "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M9.591 3.635l-7.13 14.082c-1.712 3.38 1.759 5.45 3.69 3.573l1.86 -1.81c3.142 -3.054 4.959 -2.99 8.039 .11l1.329 1.337c2.372 2.387 5.865 .078 4.176 -3.225l-7.195 -14.067c-1.114 -2.18 -3.666 -2.18 -4.77 0z", "key": "svg-1" }]]);

var IconBrandAmigo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAmigo
});

var IconBrandAmongUs = createReactComponent("outline", "brand-among-us", "IconBrandAmongUs", [["path", { "d": "M10.646 12.774c-1.939 .396 -4.467 .317 -6.234 -.601c-2.454 -1.263 -1.537 -4.66 1.423 -4.982c2.254 -.224 3.814 -.354 5.65 .214c.835 .256 1.93 .569 1.355 3.281c-.191 1.067 -1.07 1.904 -2.194 2.088z", "key": "svg-0" }], ["path", { "d": "M5.84 7.132c.083 -.564 .214 -1.12 .392 -1.661c.456 -.936 1.095 -2.068 3.985 -2.456a22.464 22.464 0 0 1 2.867 .08c1.776 .14 2.643 1.234 3.287 3.368c.339 1.157 .46 2.342 .629 3.537v11l-12.704 -.019c-.552 -2.386 -.262 -5.894 .204 -8.481", "key": "svg-1" }], ["path", { "d": "M17 10c.991 .163 2.105 .383 3.069 .67c.255 .13 .52 .275 .534 .505c.264 3.434 .57 7.448 .278 9.825h-3.881", "key": "svg-2" }]]);

var IconBrandAmongUs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAmongUs
});

var IconBrandAndroid = createReactComponent("outline", "brand-android", "IconBrandAndroid", [["path", { "d": "M4 10l0 6", "key": "svg-0" }], ["path", { "d": "M20 10l0 6", "key": "svg-1" }], ["path", { "d": "M7 9h10v8a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-8a5 5 0 0 1 10 0", "key": "svg-2" }], ["path", { "d": "M8 3l1 2", "key": "svg-3" }], ["path", { "d": "M16 3l-1 2", "key": "svg-4" }], ["path", { "d": "M9 18l0 3", "key": "svg-5" }], ["path", { "d": "M15 18l0 3", "key": "svg-6" }]]);

var IconBrandAndroid$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAndroid
});

var IconBrandAngular = createReactComponent("outline", "brand-angular", "IconBrandAngular", [["path", { "d": "M5.428 17.245l6.076 3.471a1 1 0 0 0 .992 0l6.076 -3.471a1 1 0 0 0 .495 -.734l1.323 -9.704a1 1 0 0 0 -.658 -1.078l-7.4 -2.612a1 1 0 0 0 -.665 0l-7.399 2.613a1 1 0 0 0 -.658 1.078l1.323 9.704a1 1 0 0 0 .495 .734z", "key": "svg-0" }], ["path", { "d": "M9 15l3 -8l3 8", "key": "svg-1" }], ["path", { "d": "M10 13h4", "key": "svg-2" }]]);

var IconBrandAngular$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAngular
});

var IconBrandAnsible = createReactComponent("outline", "brand-ansible", "IconBrandAnsible", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9.647 12.294l6.353 3.706l-4 -9l-4 9", "key": "svg-1" }]]);

var IconBrandAnsible$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAnsible
});

var IconBrandAo3 = createReactComponent("outline", "brand-ao3", "IconBrandAo3", [["path", { "d": "M2 5c7.109 4.1 10.956 10.131 12 14c1.074 -4.67 4.49 -8.94 8 -11", "key": "svg-0" }], ["path", { "d": "M14 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M7 9c-.278 5.494 -2.337 7.33 -4 10c4.013 -2 6.02 -5 15.05 -5c4.012 0 3.51 2.5 1 3c2 .5 2.508 5 -2.007 2", "key": "svg-2" }]]);

var IconBrandAo3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAo3
});

var IconBrandAppgallery = createReactComponent("outline", "brand-appgallery", "IconBrandAppgallery", [["path", { "d": "M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z", "key": "svg-0" }], ["path", { "d": "M9 8a3 3 0 0 0 6 0", "key": "svg-1" }]]);

var IconBrandAppgallery$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAppgallery
});

var IconBrandAppleArcade = createReactComponent("outline", "brand-apple-arcade", "IconBrandAppleArcade", [["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M20 12.5v4.75a.734 .734 0 0 1 -.055 .325a.704 .704 0 0 1 -.348 .366l-5.462 2.58a5 5 0 0 1 -4.27 0l-5.462 -2.58a.705 .705 0 0 1 -.401 -.691l0 -4.75", "key": "svg-1" }], ["path", { "d": "M4.431 12.216l5.634 -2.332a5.065 5.065 0 0 1 3.87 0l5.634 2.332a.692 .692 0 0 1 .028 1.269l-5.462 2.543a5.064 5.064 0 0 1 -4.27 0l-5.462 -2.543a.691 .691 0 0 1 .028 -1.27z", "key": "svg-2" }], ["path", { "d": "M12 7l0 6", "key": "svg-3" }]]);

var IconBrandAppleArcade$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAppleArcade
});

var IconBrandAppleNews = createReactComponent("outline", "brand-apple-news", "IconBrandAppleNews", [["path", { "d": "M4 14l6 6h-6z", "key": "svg-0" }], ["path", { "d": "M20 10l-6 -6h6z", "key": "svg-1" }], ["path", { "d": "M4 4v4l12 12h4v-4l-12 -12z", "key": "svg-2" }]]);

var IconBrandAppleNews$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAppleNews
});

var IconBrandApplePodcast = createReactComponent("outline", "brand-apple-podcast", "IconBrandApplePodcast", [["path", { "d": "M18.364 18.364a9 9 0 1 0 -12.728 0", "key": "svg-0" }], ["path", { "d": "M11.766 22h.468a2 2 0 0 0 1.985 -1.752l.5 -4a2 2 0 0 0 -1.985 -2.248h-1.468a2 2 0 0 0 -1.985 2.248l.5 4a2 2 0 0 0 1.985 1.752z", "key": "svg-1" }], ["path", { "d": "M12 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }]]);

var IconBrandApplePodcast$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandApplePodcast
});

var IconBrandApple = createReactComponent("outline", "brand-apple", "IconBrandApple", [["path", { "d": "M8.286 7.008c-3.216 0 -4.286 3.23 -4.286 5.92c0 3.229 2.143 8.072 4.286 8.072c1.165 -.05 1.799 -.538 3.214 -.538c1.406 0 1.607 .538 3.214 .538s4.286 -3.229 4.286 -5.381c-.03 -.011 -2.649 -.434 -2.679 -3.23c-.02 -2.335 2.589 -3.179 2.679 -3.228c-1.096 -1.606 -3.162 -2.113 -3.75 -2.153c-1.535 -.12 -3.032 1.077 -3.75 1.077c-.729 0 -2.036 -1.077 -3.214 -1.077z", "key": "svg-0" }], ["path", { "d": "M12 4a2 2 0 0 0 2 -2a2 2 0 0 0 -2 2", "key": "svg-1" }]]);

var IconBrandApple$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandApple
});

var IconBrandAppstore = createReactComponent("outline", "brand-appstore", "IconBrandAppstore", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M8 16l1.106 -1.99m1.4 -2.522l2.494 -4.488", "key": "svg-1" }], ["path", { "d": "M7 14h5m2.9 0h2.1", "key": "svg-2" }], ["path", { "d": "M16 16l-2.51 -4.518m-1.487 -2.677l-1 -1.805", "key": "svg-3" }]]);

var IconBrandAppstore$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAppstore
});

var IconBrandArc = createReactComponent("outline", "brand-arc", "IconBrandArc", [["path", { "d": "M4.687 14.694l-.987 2.103c-.502 1.07 -.125 2.387 .908 2.945c1.096 .59 2.444 .13 2.972 -.995l.9 -1.92", "key": "svg-0" }], ["path", { "d": "M18.317 14.576c1.818 -1.6 3.16 -3.78 3.64 -6.217c.235 -1.194 -.525 -2.351 -1.695 -2.586a2.14 2.14 0 0 0 -1.625 .326c-.478 .323 -.81 .826 -.922 1.398c-.208 1.054 -.695 2.037 -1.366 2.872", "key": "svg-1" }], ["path", { "d": "M12.68 12.759a5.4 5.4 0 0 1 -1.283 .157c-.336 0 -.683 -.04 -1.03 -.115c-1.44 -.31 -2.89 -1.215 -3.709 -2.315a3.7 3.7 0 0 1 -.487 -.853a2.157 2.157 0 0 0 -2.818 -1.213c-1.107 .455 -1.641 1.736 -1.196 2.86c.508 1.278 1.404 2.45 2.53 3.415a11.2 11.2 0 0 0 3.791 2.133c.953 .31 1.942 .483 2.916 .483a9.8 9.8 0 0 0 3.162 -.537", "key": "svg-2" }], ["path", { "d": "M10.37 12.801l.943 -2.013c.09 -.19 .357 -.19 .446 0l.923 1.97h.006h-.006l1.88 4.015l.923 1.971a2.16 2.16 0 0 0 1.957 1.254q .29 0 .576 -.081c1.303 -.365 1.92 -1.887 1.339 -3.129l-1.04 -2.218l-1.968 -4.204l-.003 .003l.003 -.003l-2.862 -6.112a2.16 2.16 0 0 0 -1.954 -1.254c-.833 0 -1.593 .488 -1.953 1.254l-2.92 6.232", "key": "svg-3" }]]);

var IconBrandArc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandArc
});

var IconBrandAsana = createReactComponent("outline", "brand-asana", "IconBrandAsana", [["path", { "d": "M12 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M7 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }]]);

var IconBrandAsana$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAsana
});

var IconBrandAstro = createReactComponent("outline", "brand-astro", "IconBrandAstro", [["path", { "d": "M14.972 3.483c.163 .196 .247 .46 .413 .987l3.64 11.53a15.5 15.5 0 0 0 -4.352 -1.42l-2.37 -7.723a.31 .31 0 0 0 -.296 -.213a.31 .31 0 0 0 -.295 .214l-2.342 7.718a15.5 15.5 0 0 0 -4.37 1.422l3.657 -11.53c.168 -.527 .251 -.79 .415 -.986c.144 -.172 .331 -.306 .544 -.388c.242 -.094 .527 -.094 1.099 -.094h2.612c.572 0 .858 0 1.1 .094c.213 .082 .4 .217 .545 .39", "key": "svg-0" }], ["path", { "d": "M9 18c0 1.5 2 3 3 4c1 -1 3 -3 3 -4q -3 1.5 -6 0", "key": "svg-1" }]]);

var IconBrandAstro$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAstro
});

var IconBrandAuth0 = createReactComponent("outline", "brand-auth0", "IconBrandAuth0", [["path", { "d": "M12 14.5l-5.5 3.5l2 -6l-4.5 -4h6l2 -5l2 5h6l-4.5 4l2 6z", "key": "svg-0" }], ["path", { "d": "M20.507 8.872l-2.01 -5.872h-12.994l-2.009 5.872c-1.242 3.593 -.135 7.094 3.249 9.407l5.257 3.721l5.257 -3.721c3.385 -2.313 4.49 -5.814 3.25 -9.407z", "key": "svg-1" }]]);

var IconBrandAuth0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAuth0
});

var IconBrandAws = createReactComponent("outline", "brand-aws", "IconBrandAws", [["path", { "d": "M17 18.5a15.198 15.198 0 0 1 -7.37 1.44a14.62 14.62 0 0 1 -6.63 -2.94", "key": "svg-0" }], ["path", { "d": "M19.5 21c.907 -1.411 1.451 -3.323 1.5 -5c-1.197 -.773 -2.577 -.935 -4 -1", "key": "svg-1" }], ["path", { "d": "M3 11v-4.5a1.5 1.5 0 0 1 3 0v4.5", "key": "svg-2" }], ["path", { "d": "M3 9h3", "key": "svg-3" }], ["path", { "d": "M9 5l1.2 6l1.8 -4l1.8 4l1.2 -6", "key": "svg-4" }], ["path", { "d": "M18 10.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-5" }]]);

var IconBrandAws$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAws
});

var IconBrandAzure = createReactComponent("outline", "brand-azure", "IconBrandAzure", [["path", { "d": "M6 7.5l-4 9.5h4l6 -15z", "key": "svg-0" }], ["path", { "d": "M22 20l-7 -15l-3 7l4 5l-8 3z", "key": "svg-1" }]]);

var IconBrandAzure$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAzure
});

var IconBrandBackbone = createReactComponent("outline", "brand-backbone", "IconBrandBackbone", [["path", { "d": "M5 20l14 -8l-14 -8z", "key": "svg-0" }], ["path", { "d": "M19 20l-14 -8l14 -8z", "key": "svg-1" }]]);

var IconBrandBackbone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBackbone
});

var IconBrandBadoo = createReactComponent("outline", "brand-badoo", "IconBrandBadoo", [["path", { "d": "M22 9.43c0 5.838 -4.477 10.57 -10 10.57s-10 -4.662 -10 -10.5c0 -2.667 1.83 -5.01 4.322 -5.429c2.492 -.418 4.9 1.392 5.678 3.929c.768 -2.54 3.177 -4.354 5.668 -3.931c2.495 .417 4.332 2.69 4.332 5.36z", "key": "svg-0" }], ["path", { "d": "M7.5 10c0 2.761 2.015 5 4.5 5s4.5 -2.239 4.5 -5", "key": "svg-1" }]]);

var IconBrandBadoo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBadoo
});

var IconBrandBaidu = createReactComponent("outline", "brand-baidu", "IconBrandBaidu", [["path", { "d": "M5 9.5m-1 0a1 1.5 0 1 0 2 0a1 1.5 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M14.463 11.596c1.282 1.774 3.476 3.416 3.476 3.416s1.921 1.574 .593 3.636c-1.328 2.063 -4.892 1.152 -4.892 1.152s-1.416 -.44 -3.06 -.088c-1.644 .356 -3.06 .22 -3.06 .22s-2.055 -.22 -2.47 -2.304c-.416 -2.084 1.918 -3.638 2.102 -3.858c.182 -.222 1.409 -.966 2.284 -2.394c.875 -1.428 3.337 -2.287 5.027 .221z", "key": "svg-1" }], ["path", { "d": "M9 4.5m-1 0a1 1.5 0 1 0 2 0a1 1.5 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M15 4.5m-1 0a1 1.5 0 1 0 2 0a1 1.5 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M19 9.5m-1 0a1 1.5 0 1 0 2 0a1 1.5 0 1 0 -2 0", "key": "svg-4" }]]);

var IconBrandBaidu$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBaidu
});

var IconBrandBandcamp = createReactComponent("outline", "brand-bandcamp", "IconBrandBandcamp", [["path", { "d": "M8.5 6h13.5l-7 12h-13z", "key": "svg-0" }]]);

var IconBrandBandcamp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBandcamp
});

var IconBrandBandlab = createReactComponent("outline", "brand-bandlab", "IconBrandBandlab", [["path", { "d": "M6.885 7l-2.536 4.907c-2.021 3.845 -2.499 8.775 3.821 9.093h6.808c4.86 -.207 7.989 -2.975 4.607 -9.093l-2.988 -4.907", "key": "svg-0" }], ["path", { "d": "M15.078 4h-5.136l3.678 8.768c.547 1.14 .847 1.822 .162 2.676c-.053 .093 -1.332 1.907 -3.053 1.495c-.825 -.187 -1.384 -.926 -1.32 -1.74c.04 -.91 .62 -1.717 1.488 -2.074a4.463 4.463 0 0 1 2.723 -.358", "key": "svg-1" }]]);

var IconBrandBandlab$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBandlab
});

var IconBrandBeats = createReactComponent("outline", "brand-beats", "IconBrandBeats", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12.5 12.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0", "key": "svg-1" }], ["path", { "d": "M9 12v-8", "key": "svg-2" }]]);

var IconBrandBeats$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBeats
});

var IconBrandBebo = createReactComponent("outline", "brand-bebo", "IconBrandBebo", [["path", { "d": "M12 17.5a3.5 3.5 0 0 0 3.5 -3.5c0 -1.838 -1.159 -3.002 -3.005 -3.372c-.746 -.15 -1.37 -.745 -1.37 -1.506c0 -1.142 .934 -2.095 2.058 -1.894c3.61 .645 5.817 3.058 5.817 6.772a7 7 0 1 1 -14 0v-9.25a1.75 1.75 0 1 1 3.5 0v9.25a3.5 3.5 0 0 0 3.5 3.5", "key": "svg-0" }]]);

var IconBrandBebo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBebo
});

var IconBrandBehance = createReactComponent("outline", "brand-behance", "IconBrandBehance", [["path", { "d": "M3 18v-12h4.5a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-4.5", "key": "svg-0" }], ["path", { "d": "M3 12l4.5 0", "key": "svg-1" }], ["path", { "d": "M14 13h7a3.5 3.5 0 0 0 -7 0v2a3.5 3.5 0 0 0 6.64 1", "key": "svg-2" }], ["path", { "d": "M16 6l3 0", "key": "svg-3" }]]);

var IconBrandBehance$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBehance
});

var IconBrandBilibili = createReactComponent("outline", "brand-bilibili", "IconBrandBilibili", [["path", { "d": "M3 10a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v6a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4v-6z", "key": "svg-0" }], ["path", { "d": "M8 3l2 3", "key": "svg-1" }], ["path", { "d": "M16 3l-2 3", "key": "svg-2" }], ["path", { "d": "M9 13v-2", "key": "svg-3" }], ["path", { "d": "M15 11v2", "key": "svg-4" }]]);

var IconBrandBilibili$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBilibili
});

var IconBrandBinance = createReactComponent("outline", "brand-binance", "IconBrandBinance", [["path", { "d": "M6 8l2 2l4 -4l4 4l2 -2l-6 -6z", "key": "svg-0" }], ["path", { "d": "M6 16l2 -2l4 4l3.5 -3.5l2 2l-5.5 5.5z", "key": "svg-1" }], ["path", { "d": "M20 10l2 2l-2 2l-2 -2z", "key": "svg-2" }], ["path", { "d": "M4 10l2 2l-2 2l-2 -2z", "key": "svg-3" }], ["path", { "d": "M12 10l2 2l-2 2l-2 -2z", "key": "svg-4" }]]);

var IconBrandBinance$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBinance
});

var IconBrandBing = createReactComponent("outline", "brand-bing", "IconBrandBing", [["path", { "d": "M5 3l4 1.5v12l6 -2.5l-2 -1l-1 -4l7 2.5v4.5l-10 5l-4 -2z", "key": "svg-0" }]]);

var IconBrandBing$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBing
});

var IconBrandBitbucket = createReactComponent("outline", "brand-bitbucket", "IconBrandBitbucket", [["path", { "d": "M3.648 4a.64 .64 0 0 0 -.64 .744l3.14 14.528c.07 .417 .43 .724 .852 .728h10a.644 .644 0 0 0 .642 -.539l3.35 -14.71a.641 .641 0 0 0 -.64 -.744l-16.704 -.007z", "key": "svg-0" }], ["path", { "d": "M14 15h-4l-1 -6h6z", "key": "svg-1" }]]);

var IconBrandBitbucket$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBitbucket
});

var IconBrandBlackberry = createReactComponent("outline", "brand-blackberry", "IconBrandBlackberry", [["path", { "d": "M7 6a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z", "key": "svg-0" }], ["path", { "d": "M6 12a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z", "key": "svg-1" }], ["path", { "d": "M13 12a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z", "key": "svg-2" }], ["path", { "d": "M14 6a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z", "key": "svg-3" }], ["path", { "d": "M12 18a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z", "key": "svg-4" }], ["path", { "d": "M20 15a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z", "key": "svg-5" }], ["path", { "d": "M21 9a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z", "key": "svg-6" }]]);

var IconBrandBlackberry$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBlackberry
});

var IconBrandBlender = createReactComponent("outline", "brand-blender", "IconBrandBlender", [["path", { "d": "M15 14m-6 0a6 5 0 1 0 12 0a6 5 0 1 0 -12 0", "key": "svg-0" }], ["path", { "d": "M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M3 16l9 -6.5", "key": "svg-2" }], ["path", { "d": "M6 9h9", "key": "svg-3" }], ["path", { "d": "M13 5l5.65 5", "key": "svg-4" }]]);

var IconBrandBlender$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBlender
});

var IconBrandBlogger = createReactComponent("outline", "brand-blogger", "IconBrandBlogger", [["path", { "d": "M8 21h8a5 5 0 0 0 5 -5v-3a3 3 0 0 0 -3 -3h-1v-2a5 5 0 0 0 -5 -5h-4a5 5 0 0 0 -5 5v8a5 5 0 0 0 5 5z", "key": "svg-0" }], ["path", { "d": "M7 7m0 1.5a1.5 1.5 0 0 1 1.5 -1.5h3a1.5 1.5 0 0 1 1.5 1.5v0a1.5 1.5 0 0 1 -1.5 1.5h-3a1.5 1.5 0 0 1 -1.5 -1.5z", "key": "svg-1" }], ["path", { "d": "M7 14m0 1.5a1.5 1.5 0 0 1 1.5 -1.5h7a1.5 1.5 0 0 1 1.5 1.5v0a1.5 1.5 0 0 1 -1.5 1.5h-7a1.5 1.5 0 0 1 -1.5 -1.5z", "key": "svg-2" }]]);

var IconBrandBlogger$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBlogger
});

var IconBrandBluesky = createReactComponent("outline", "brand-bluesky", "IconBrandBluesky", [["path", { "d": "M6.335 5.144c-1.654 -1.199 -4.335 -2.127 -4.335 .826c0 .59 .35 4.953 .556 5.661c.713 2.463 3.13 2.75 5.444 2.369c-4.045 .665 -4.889 3.208 -2.667 5.41c1.03 1.018 1.913 1.59 2.667 1.59c2 0 3.134 -2.769 3.5 -3.5c.333 -.667 .5 -1.167 .5 -1.5c0 .333 .167 .833 .5 1.5c.366 .731 1.5 3.5 3.5 3.5c.754 0 1.637 -.571 2.667 -1.59c2.222 -2.203 1.378 -4.746 -2.667 -5.41c2.314 .38 4.73 .094 5.444 -2.369c.206 -.708 .556 -5.072 .556 -5.661c0 -2.953 -2.68 -2.025 -4.335 -.826c-2.293 1.662 -4.76 5.048 -5.665 6.856c-.905 -1.808 -3.372 -5.194 -5.665 -6.856z", "key": "svg-0" }]]);

var IconBrandBluesky$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBluesky
});

var IconBrandBooking = createReactComponent("outline", "brand-booking", "IconBrandBooking", [["path", { "d": "M4 18v-9.5a4.5 4.5 0 0 1 4.5 -4.5h7a4.5 4.5 0 0 1 4.5 4.5v7a4.5 4.5 0 0 1 -4.5 4.5h-9.5a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 12h3.5a2 2 0 1 1 0 4h-3.5v-7a1 1 0 0 1 1 -1h1.5a2 2 0 1 1 0 4h-1.5", "key": "svg-1" }], ["path", { "d": "M16 16l.01 0", "key": "svg-2" }]]);

var IconBrandBooking$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBooking
});

var IconBrandBootstrap = createReactComponent("outline", "brand-bootstrap", "IconBrandBootstrap", [["path", { "d": "M2 12a2 2 0 0 0 2 -2v-4a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2", "key": "svg-0" }], ["path", { "d": "M2 12a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-4a2 2 0 0 1 2 -2", "key": "svg-1" }], ["path", { "d": "M9 16v-8h3.5a2 2 0 1 1 0 4h-3.5h4a2 2 0 1 1 0 4h-4z", "key": "svg-2" }]]);

var IconBrandBootstrap$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBootstrap
});

var IconBrandBulma = createReactComponent("outline", "brand-bulma", "IconBrandBulma", [["path", { "d": "M5 16l1 -9l5 -5l6.5 6l-3.5 4l5 5l-8 5z", "key": "svg-0" }]]);

var IconBrandBulma$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBulma
});

var IconBrandBumble = createReactComponent("outline", "brand-bumble", "IconBrandBumble", [["path", { "d": "M7 12h10", "key": "svg-0" }], ["path", { "d": "M9 8h6", "key": "svg-1" }], ["path", { "d": "M10 16h4", "key": "svg-2" }], ["path", { "d": "M16.268 3h-8.536a1.46 1.46 0 0 0 -1.268 .748l-4.268 7.509a1.507 1.507 0 0 0 0 1.486l4.268 7.509c.26 .462 .744 .747 1.268 .748h8.536a1.46 1.46 0 0 0 1.268 -.748l4.268 -7.509a1.507 1.507 0 0 0 0 -1.486l-4.268 -7.509a1.46 1.46 0 0 0 -1.268 -.748z", "key": "svg-3" }]]);

var IconBrandBumble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBumble
});

var IconBrandBunpo = createReactComponent("outline", "brand-bunpo", "IconBrandBunpo", [["path", { "d": "M3.9 7.205a17.764 17.764 0 0 0 4.008 2.753a7.917 7.917 0 0 0 4.57 .567c1.5 -.33 2.907 -1 4.121 -1.956a12.107 12.107 0 0 0 2.892 -2.903c.603 -.94 .745 -1.766 .484 -2.231c-.261 -.465 -.927 -.568 -1.72 -.257a7.564 7.564 0 0 0 -2.608 2.034a18.425 18.425 0 0 0 -2.588 3.884a34.927 34.927 0 0 0 -2.093 5.073a12.908 12.908 0 0 0 -.677 3.515c-.07 .752 .07 1.51 .405 2.184c.323 .562 1.06 1.132 2.343 1.132c3.474 0 5.093 -3.53 5.463 -5.62c.24 -1.365 -.085 -3.197 -1.182 -4.01", "key": "svg-0" }]]);

var IconBrandBunpo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBunpo
});

var IconBrandCSharp = createReactComponent("outline", "brand-c-sharp", "IconBrandCSharp", [["path", { "d": "M10 9a3 3 0 0 0 -3 -3h-.5a3.5 3.5 0 0 0 -3.5 3.5v5a3.5 3.5 0 0 0 3.5 3.5h.5a3 3 0 0 0 3 -3", "key": "svg-0" }], ["path", { "d": "M16 7l-1 10", "key": "svg-1" }], ["path", { "d": "M20 7l-1 10", "key": "svg-2" }], ["path", { "d": "M14 10h7.5", "key": "svg-3" }], ["path", { "d": "M21 14h-7.5", "key": "svg-4" }]]);

var IconBrandCSharp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCSharp
});

var IconBrandCake = createReactComponent("outline", "brand-cake", "IconBrandCake", [["path", { "d": "M20.84 12c0 2.05 .985 3.225 -.04 5c-1.026 1.775 -2.537 1.51 -4.314 2.534c-1.776 1.026 -2.302 2.466 -4.353 2.466c-2.051 0 -2.576 -1.441 -4.353 -2.466c-1.776 -1.024 -3.288 -.759 -4.314 -2.534c-1.025 -1.775 -.04 -2.95 -.04 -5s-.985 -3.225 .04 -5c1.026 -1.775 2.537 -1.51 4.314 -2.534c1.776 -1.026 2.302 -2.466 4.353 -2.466s2.577 1.441 4.353 2.466c1.776 1.024 3.288 .759 4.313 2.534c1.026 1.775 .04 2.95 .04 5z", "key": "svg-0" }]]);

var IconBrandCake$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCake
});

var IconBrandCakephp = createReactComponent("outline", "brand-cakephp", "IconBrandCakephp", [["path", { "d": "M12 11l8 2c1.361 -.545 2 -1.248 2 -2v-3.8c0 -1.765 -4.479 -3.2 -10.002 -3.2c-5.522 0 -9.998 1.435 -9.998 3.2v2.8c0 1.766 4.478 4 10 4v-3z", "key": "svg-0" }], ["path", { "d": "M12 14v3l8 2c1.362 -.547 2 -1.246 2 -2v-3c0 .754 -.638 1.453 -2 2l-8 -2z", "key": "svg-1" }], ["path", { "d": "M2 17c0 1.766 4.476 3 9.998 3l.002 -3c-5.522 0 -10 -1.734 -10 -3.5v3.5z", "key": "svg-2" }], ["path", { "d": "M2 10v4", "key": "svg-3" }], ["path", { "d": "M22 10v4", "key": "svg-4" }]]);

var IconBrandCakephp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCakephp
});

var IconBrandCampaignmonitor = createReactComponent("outline", "brand-campaignmonitor", "IconBrandCampaignmonitor", [["path", { "d": "M3 18l9 -6.462l-9 -5.538v12h18v-12l-9 5.538", "key": "svg-0" }]]);

var IconBrandCampaignmonitor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCampaignmonitor
});

var IconBrandCarbon = createReactComponent("outline", "brand-carbon", "IconBrandCarbon", [["path", { "d": "M14 10v-.2a1.8 1.8 0 0 0 -1.8 -1.8h-.4a1.8 1.8 0 0 0 -1.8 1.8v4.4a1.8 1.8 0 0 0 1.8 1.8h.4a1.8 1.8 0 0 0 1.8 -1.8v-.2", "key": "svg-0" }], ["path", { "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-1" }]]);

var IconBrandCarbon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCarbon
});

var IconBrandCashapp = createReactComponent("outline", "brand-cashapp", "IconBrandCashapp", [["path", { "d": "M17.1 8.648a.568 .568 0 0 1 -.761 .011a5.682 5.682 0 0 0 -3.659 -1.34c-1.102 0 -2.205 .363 -2.205 1.374c0 1.023 1.182 1.364 2.546 1.875c2.386 .796 4.363 1.796 4.363 4.137c0 2.545 -1.977 4.295 -5.204 4.488l-.295 1.364a.557 .557 0 0 1 -.546 .443h-2.034l-.102 -.011a.568 .568 0 0 1 -.432 -.67l.318 -1.444a7.432 7.432 0 0 1 -3.273 -1.784v-.011a.545 .545 0 0 1 0 -.773l1.137 -1.102c.214 -.2 .547 -.2 .761 0a5.495 5.495 0 0 0 3.852 1.5c1.478 0 2.466 -.625 2.466 -1.614c0 -.989 -1 -1.25 -2.886 -1.954c-2 -.716 -3.898 -1.728 -3.898 -4.091c0 -2.75 2.284 -4.091 4.989 -4.216l.284 -1.398a.545 .545 0 0 1 .545 -.432h2.023l.114 .012a.544 .544 0 0 1 .42 .647l-.307 1.557a8.528 8.528 0 0 1 2.818 1.58l.023 .022c.216 .228 .216 .569 0 .773l-1.057 1.057z", "key": "svg-0" }]]);

var IconBrandCashapp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCashapp
});

var IconBrandChrome = createReactComponent("outline", "brand-chrome", "IconBrandChrome", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M12 9h8.4", "key": "svg-2" }], ["path", { "d": "M14.598 13.5l-4.2 7.275", "key": "svg-3" }], ["path", { "d": "M9.402 13.5l-4.2 -7.275", "key": "svg-4" }]]);

var IconBrandChrome$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandChrome
});

var IconBrandCinema4d = createReactComponent("outline", "brand-cinema-4d", "IconBrandCinema4d", [["path", { "d": "M9.65 6.956a5.39 5.39 0 0 0 7.494 7.495", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }], ["path", { "d": "M17.7 12.137a5.738 5.738 0 1 1 -5.737 -5.737", "key": "svg-2" }], ["path", { "d": "M17.7 12.338v-1.175c0 -.47 .171 -.92 .476 -1.253a1.56 1.56 0 0 1 1.149 -.52c.827 0 1.523 .676 1.62 1.573c.037 .344 .055 .69 .055 1.037", "key": "svg-3" }], ["path", { "d": "M11.662 6.4h1.175c.47 0 .92 -.176 1.253 -.49c.333 -.314 .52 -.74 .52 -1.184c0 -.852 -.676 -1.57 -1.573 -1.67a9.496 9.496 0 0 0 -1.037 -.056", "key": "svg-4" }]]);

var IconBrandCinema4d$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCinema4d
});

var IconBrandCitymapper = createReactComponent("outline", "brand-citymapper", "IconBrandCitymapper", [["path", { "d": "M3 11a1 1 0 1 1 -1 1.013a1 1 0 0 1 1 -1v-.013z", "key": "svg-0" }], ["path", { "d": "M21 11a1 1 0 1 1 -1 1.013a1 1 0 0 1 1 -1v-.013z", "key": "svg-1" }], ["path", { "d": "M8 12h8", "key": "svg-2" }], ["path", { "d": "M13 9l3 3l-3 3", "key": "svg-3" }]]);

var IconBrandCitymapper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCitymapper
});

var IconBrandCloudflare = createReactComponent("outline", "brand-cloudflare", "IconBrandCloudflare", [["path", { "d": "M13.031 7.007c2.469 -.007 3.295 1.293 3.969 2.993c4 0 4.994 3.825 5 6h-20c-.001 -1.64 1.36 -2.954 3 -3c0 -1.5 1 -3 3 -3c.66 -1.942 2.562 -2.986 5.031 -2.993z", "key": "svg-0" }], ["path", { "d": "M12 13h6", "key": "svg-1" }], ["path", { "d": "M17 10l-2.5 6", "key": "svg-2" }]]);

var IconBrandCloudflare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCloudflare
});

var IconBrandCodecov = createReactComponent("outline", "brand-codecov", "IconBrandCodecov", [["path", { "d": "M9.695 12.985a5.972 5.972 0 0 0 -3.295 -.985c-1.257 0 -2.436 .339 -3.4 1a9 9 0 1 1 18 0c-.966 -.664 -2.14 -1 -3.4 -1a6 6 0 0 0 -5.605 8.144", "key": "svg-0" }]]);

var IconBrandCodecov$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCodecov
});

var IconBrandCodepen = createReactComponent("outline", "brand-codepen", "IconBrandCodepen", [["path", { "d": "M3 15l9 6l9 -6l-9 -6l-9 6", "key": "svg-0" }], ["path", { "d": "M3 9l9 6l9 -6l-9 -6l-9 6", "key": "svg-1" }], ["path", { "d": "M3 9l0 6", "key": "svg-2" }], ["path", { "d": "M21 9l0 6", "key": "svg-3" }], ["path", { "d": "M12 3l0 6", "key": "svg-4" }], ["path", { "d": "M12 15l0 6", "key": "svg-5" }]]);

var IconBrandCodepen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCodepen
});

var IconBrandCodesandbox = createReactComponent("outline", "brand-codesandbox", "IconBrandCodesandbox", [["path", { "d": "M20 7.5v9l-4 2.25l-4 2.25l-4 -2.25l-4 -2.25v-9l4 -2.25l4 -2.25l4 2.25z", "key": "svg-0" }], ["path", { "d": "M12 12l4 -2.25l4 -2.25", "key": "svg-1" }], ["path", { "d": "M12 12l0 9", "key": "svg-2" }], ["path", { "d": "M12 12l-4 -2.25l-4 -2.25", "key": "svg-3" }], ["path", { "d": "M20 12l-4 2v4.75", "key": "svg-4" }], ["path", { "d": "M4 12l4 2l0 4.75", "key": "svg-5" }], ["path", { "d": "M8 5.25l4 2.25l4 -2.25", "key": "svg-6" }]]);

var IconBrandCodesandbox$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCodesandbox
});

var IconBrandCohost = createReactComponent("outline", "brand-cohost", "IconBrandCohost", [["path", { "d": "M17 14m-3 0a3 2 0 1 0 6 0a3 2 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M4.526 17.666c-1.133 -.772 -1.897 -1.924 -2.291 -3.456c-.398 -1.54 -.29 -2.937 .32 -4.19c.61 -1.255 1.59 -2.34 2.938 -3.254c1.348 -.914 2.93 -1.625 4.749 -2.132c1.81 -.504 3.516 -.708 5.12 -.61c1.608 .1 2.979 .537 4.112 1.31s1.897 1.924 2.291 3.456c.398 1.541 .29 2.938 -.32 4.192c-.61 1.253 -1.59 2.337 -2.938 3.252c-1.348 .915 -2.93 1.626 -4.749 2.133c-1.81 .503 -3.516 .707 -5.12 .61c-1.608 -.102 -2.979 -.538 -4.112 -1.31z", "key": "svg-1" }], ["path", { "d": "M11 12.508c-.53 -.316 -1.23 -.508 -2 -.508c-1.657 0 -3 .895 -3 2s1.343 2 3 2c.767 0 1.467 -.192 2 -.508", "key": "svg-2" }]]);

var IconBrandCohost$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCohost
});

var IconBrandCoinbase = createReactComponent("outline", "brand-coinbase", "IconBrandCoinbase", [["path", { "d": "M12.95 22c-4.503 0 -8.445 -3.04 -9.61 -7.413c-1.165 -4.373 .737 -8.988 4.638 -11.25a9.906 9.906 0 0 1 12.008 1.598l-3.335 3.367a5.185 5.185 0 0 0 -7.354 .013a5.252 5.252 0 0 0 0 7.393a5.185 5.185 0 0 0 7.354 .013l3.349 3.367a9.887 9.887 0 0 1 -7.05 2.912z", "key": "svg-0" }]]);

var IconBrandCoinbase$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCoinbase
});

var IconBrandComedyCentral = createReactComponent("outline", "brand-comedy-central", "IconBrandComedyCentral", [["path", { "d": "M5.343 17.657a8 8 0 1 0 0 -11.314", "key": "svg-0" }], ["path", { "d": "M13.828 9.172a4 4 0 1 0 0 5.656", "key": "svg-1" }]]);

var IconBrandComedyCentral$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandComedyCentral
});

var IconBrandCoreos = createReactComponent("outline", "brand-coreos", "IconBrandCoreos", [["path", { "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z", "key": "svg-0" }], ["path", { "d": "M12 3c-3.263 3.212 -3 7.654 -3 12c4.59 .244 8.814 -.282 12 -3", "key": "svg-1" }], ["path", { "d": "M9.5 9a4.494 4.494 0 0 1 5.5 5.5", "key": "svg-2" }]]);

var IconBrandCoreos$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCoreos
});

var IconBrandCouchdb = createReactComponent("outline", "brand-couchdb", "IconBrandCouchdb", [["path", { "d": "M6 12h12v-2a2 2 0 0 1 2 -2a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2a2 2 0 0 1 2 2v2z", "key": "svg-0" }], ["path", { "d": "M6 15h12", "key": "svg-1" }], ["path", { "d": "M6 18h12", "key": "svg-2" }], ["path", { "d": "M21 11v7", "key": "svg-3" }], ["path", { "d": "M3 11v7", "key": "svg-4" }]]);

var IconBrandCouchdb$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCouchdb
});

var IconBrandCouchsurfing = createReactComponent("outline", "brand-couchsurfing", "IconBrandCouchsurfing", [["path", { "d": "M3.1 13c3.267 0 5.9 -.167 7.9 -.5c3 -.5 4 -2 4 -3.5a3 3 0 1 0 -6 0c0 1.554 1.807 3 3 4c1.193 1 2 2.5 2 3.5a1.5 1.5 0 1 1 -3 0c0 -2 4 -3.5 7 -3.5h2.9", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconBrandCouchsurfing$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCouchsurfing
});

var IconBrandCpp = createReactComponent("outline", "brand-cpp", "IconBrandCpp", [["path", { "d": "M18 12h4", "key": "svg-0" }], ["path", { "d": "M20 10v4", "key": "svg-1" }], ["path", { "d": "M11 12h4", "key": "svg-2" }], ["path", { "d": "M13 10v4", "key": "svg-3" }], ["path", { "d": "M9 9a3 3 0 0 0 -3 -3h-.5a3.5 3.5 0 0 0 -3.5 3.5v5a3.5 3.5 0 0 0 3.5 3.5h.5a3 3 0 0 0 3 -3", "key": "svg-4" }]]);

var IconBrandCpp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCpp
});

var IconBrandCraft = createReactComponent("outline", "brand-craft", "IconBrandCraft", [["path", { "d": "M20 4h-8a8 8 0 1 0 0 16h8a8 8 0 0 0 -8 -8a8 8 0 0 0 8 -8", "key": "svg-0" }], ["path", { "d": "M4 12h8", "key": "svg-1" }], ["path", { "d": "M12 4v16", "key": "svg-2" }]]);

var IconBrandCraft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCraft
});

var IconBrandCrunchbase = createReactComponent("outline", "brand-crunchbase", "IconBrandCrunchbase", [["path", { "d": "M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10.414 11.586a2 2 0 1 0 0 2.828", "key": "svg-1" }], ["path", { "d": "M15 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M13 7v6", "key": "svg-3" }]]);

var IconBrandCrunchbase$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCrunchbase
});

var IconBrandCss3 = createReactComponent("outline", "brand-css3", "IconBrandCss3", [["path", { "d": "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z", "key": "svg-0" }], ["path", { "d": "M8.5 8h7l-4.5 4h4l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5", "key": "svg-1" }]]);

var IconBrandCss3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCss3
});

var IconBrandCtemplar = createReactComponent("outline", "brand-ctemplar", "IconBrandCtemplar", [["path", { "d": "M6.04 14.831l4.46 -4.331", "key": "svg-0" }], ["path", { "d": "M12.555 20.82c4.55 -3.456 7.582 -8.639 8.426 -14.405a1.668 1.668 0 0 0 -.934 -1.767a19.647 19.647 0 0 0 -8.047 -1.648a19.647 19.647 0 0 0 -8.047 1.647a1.668 1.668 0 0 0 -.934 1.767c.844 5.766 3.875 10.95 8.426 14.406a.948 .948 0 0 0 1.11 0z", "key": "svg-1" }], ["path", { "d": "M20 5c-2 0 -4.37 3.304 -8 6.644c-3.63 -3.34 -6 -6.644 -8 -6.644", "key": "svg-2" }], ["path", { "d": "M17.738 15l-4.238 -4.5", "key": "svg-3" }]]);

var IconBrandCtemplar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCtemplar
});

var IconBrandCucumber = createReactComponent("outline", "brand-cucumber", "IconBrandCucumber", [["path", { "d": "M20 10.99c-.01 5.52 -4.48 10 -10 10.01v-2.26l-.01 -.01c-4.28 -1.11 -6.86 -5.47 -5.76 -9.75a8 8 0 0 1 9.74 -5.76c3.53 .91 6.03 4.13 6.03 7.78v-.01z", "key": "svg-0" }], ["path", { "d": "M10.5 8l-.5 -1", "key": "svg-1" }], ["path", { "d": "M13.5 14l.5 1", "key": "svg-2" }], ["path", { "d": "M9 12.5l-1 .5", "key": "svg-3" }], ["path", { "d": "M11 14l-.5 1", "key": "svg-4" }], ["path", { "d": "M13 8l.5 -1", "key": "svg-5" }], ["path", { "d": "M16 12.5l-1 -.5", "key": "svg-6" }], ["path", { "d": "M9 10l-1 -.5", "key": "svg-7" }]]);

var IconBrandCucumber$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCucumber
});

var IconBrandCupra = createReactComponent("outline", "brand-cupra", "IconBrandCupra", [["path", { "d": "M4.5 10l-2.5 -4l15.298 6.909a.2 .2 0 0 1 .09 .283l-3.388 5.808", "key": "svg-0" }], ["path", { "d": "M10 19l-3.388 -5.808a.2 .2 0 0 1 .09 -.283l15.298 -6.909l-2.5 4", "key": "svg-1" }]]);

var IconBrandCupra$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCupra
});

var IconBrandCypress = createReactComponent("outline", "brand-cypress", "IconBrandCypress", [["path", { "d": "M19.48 17.007a9 9 0 1 0 -7.48 3.993c.896 0 1.691 -.573 1.974 -1.423l3.526 -10.577", "key": "svg-0" }], ["path", { "d": "M13.5 9l2 6", "key": "svg-1" }], ["path", { "d": "M10.764 9.411a3 3 0 1 0 -.023 5.19", "key": "svg-2" }]]);

var IconBrandCypress$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandCypress
});

var IconBrandD3 = createReactComponent("outline", "brand-d3", "IconBrandD3", [["path", { "d": "M3 4h1.8c3.976 0 7.2 3.582 7.2 8s-3.224 8 -7.2 8h-1.8", "key": "svg-0" }], ["path", { "d": "M12 4h5.472c1.948 0 3.528 1.79 3.528 4s-1.58 4 -3.528 4", "key": "svg-1" }], ["path", { "d": "M17.472 12h-2.472", "key": "svg-2" }], ["path", { "d": "M17.472 12h-2.352", "key": "svg-3" }], ["path", { "d": "M17.472 12c1.948 0 3.528 1.79 3.528 4s-1.58 4 -3.528 4h-5.472", "key": "svg-4" }]]);

var IconBrandD3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandD3
});

var IconBrandDatabricks = createReactComponent("outline", "brand-databricks", "IconBrandDatabricks", [["path", { "d": "M3 17l9 5l9 -5v-3l-9 5l-9 -5v-3l9 5l9 -5v-3l-9 5l-9 -5l9 -5l5.418 3.01", "key": "svg-0" }]]);

var IconBrandDatabricks$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDatabricks
});

var IconBrandDaysCounter = createReactComponent("outline", "brand-days-counter", "IconBrandDaysCounter", [["path", { "d": "M20.779 10.007a9 9 0 1 0 -10.77 10.772", "key": "svg-0" }], ["path", { "d": "M13 21h8v-7", "key": "svg-1" }], ["path", { "d": "M12 8v4l3 3", "key": "svg-2" }]]);

var IconBrandDaysCounter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDaysCounter
});

var IconBrandDcos = createReactComponent("outline", "brand-dcos", "IconBrandDcos", [["path", { "d": "M3 18l18 -12h-18l9 14l9 -14v10l-18 -10z", "key": "svg-0" }]]);

var IconBrandDcos$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDcos
});

var IconBrandDebian = createReactComponent("outline", "brand-debian", "IconBrandDebian", [["path", { "d": "M12 17c-2.397 -.943 -4 -3.153 -4 -5.635c0 -2.19 1.039 -3.14 1.604 -3.595c2.646 -2.133 6.396 -.27 6.396 3.23c0 2.5 -2.905 2.121 -3.5 1.5c-.595 -.621 -1 -1.5 -.5 -2.5", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconBrandDebian$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDebian
});

var IconBrandDeezer = createReactComponent("outline", "brand-deezer", "IconBrandDeezer", [["path", { "d": "M3 16.5h2v.5h-2z", "key": "svg-0" }], ["path", { "d": "M8 16.5h2.5v.5h-2.5z", "key": "svg-1" }], ["path", { "d": "M16 17h-2.5v-.5h2.5z", "key": "svg-2" }], ["path", { "d": "M21.5 17h-2.5v-.5h2.5z", "key": "svg-3" }], ["path", { "d": "M21.5 13h-2.5v.5h2.5z", "key": "svg-4" }], ["path", { "d": "M21.5 9.5h-2.5v.5h2.5z", "key": "svg-5" }], ["path", { "d": "M21.5 6h-2.5v.5h2.5z", "key": "svg-6" }], ["path", { "d": "M16 13h-2.5v.5h2.5z", "key": "svg-7" }], ["path", { "d": "M8 13.5h2.5v-.5h-2.5z", "key": "svg-8" }], ["path", { "d": "M8 9.5h2.5v.5h-2.5z", "key": "svg-9" }]]);

var IconBrandDeezer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDeezer
});

var IconBrandDeliveroo = createReactComponent("outline", "brand-deliveroo", "IconBrandDeliveroo", [["path", { "d": "M15 11l1 -9l5 .5l-1 13.5l-3 6l-12.5 -2.5l-1.5 -6l7 -1.5l-1.5 -7.5l4.5 -1z", "key": "svg-0" }], ["circle", { "cx": "15.5", "cy": "15.5", "r": "1", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "11.5", "cy": "14.5", "r": "1", "fill": "currentColor", "key": "svg-2" }]]);

var IconBrandDeliveroo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDeliveroo
});

var IconBrandDeno = createReactComponent("outline", "brand-deno", "IconBrandDeno", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M13.47 20.882l-1.47 -5.882c-2.649 -.088 -5 -1.624 -5 -3.5c0 -1.933 2.239 -3.5 5 -3.5s4 1 5 3c.024 .048 .69 2.215 2 6.5", "key": "svg-1" }], ["path", { "d": "M12 11h.01", "key": "svg-2" }]]);

var IconBrandDeno$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDeno
});

var IconBrandDenodo = createReactComponent("outline", "brand-denodo", "IconBrandDenodo", [["path", { "d": "M11 11h2v2h-2z", "key": "svg-0" }], ["path", { "d": "M3.634 15.634l1.732 -1l1 1.732l-1.732 1z", "key": "svg-1" }], ["path", { "d": "M11 19h2v2h-2z", "key": "svg-2" }], ["path", { "d": "M18.634 14.634l1.732 1l-1 1.732l-1.732 -1z", "key": "svg-3" }], ["path", { "d": "M17.634 7.634l1.732 -1l1 1.732l-1.732 1z", "key": "svg-4" }], ["path", { "d": "M11 3h2v2h-2z", "key": "svg-5" }], ["path", { "d": "M3.634 8.366l1 -1.732l1.732 1l-1 1.732z", "key": "svg-6" }]]);

var IconBrandDenodo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDenodo
});

var IconBrandDeviantart = createReactComponent("outline", "brand-deviantart", "IconBrandDeviantart", [["path", { "d": "M18 3v4l-3.857 6h3.857v4h-6.429l-2.571 4h-3v-4l3.857 -6h-3.857v-4h6.429l2.571 -4z", "key": "svg-0" }]]);

var IconBrandDeviantart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDeviantart
});

var IconBrandDigg = createReactComponent("outline", "brand-digg", "IconBrandDigg", [["path", { "d": "M6 15h-3v-4h3", "key": "svg-0" }], ["path", { "d": "M15 15h-3v-4h3", "key": "svg-1" }], ["path", { "d": "M9 15v-4", "key": "svg-2" }], ["path", { "d": "M15 11v7h-3", "key": "svg-3" }], ["path", { "d": "M6 7v8", "key": "svg-4" }], ["path", { "d": "M21 15h-3v-4h3", "key": "svg-5" }], ["path", { "d": "M21 11v7h-3", "key": "svg-6" }]]);

var IconBrandDigg$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDigg
});

var IconBrandDingtalk = createReactComponent("outline", "brand-dingtalk", "IconBrandDingtalk", [["path", { "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z", "key": "svg-0" }], ["path", { "d": "M8 7.5l7.02 2.632a1 1 0 0 1 .567 1.33l-1.087 2.538h1.5l-5 4l1 -4c-3.1 .03 -3.114 -3.139 -4 -6.5z", "key": "svg-1" }]]);

var IconBrandDingtalk$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDingtalk
});

var IconBrandDiscord = createReactComponent("outline", "brand-discord", "IconBrandDiscord", [["path", { "d": "M8 12a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M14 12a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M15.5 17c0 1 1.5 3 2 3c1.5 0 2.833 -1.667 3.5 -3c.667 -1.667 .5 -5.833 -1.5 -11.5c-1.457 -1.015 -3 -1.34 -4.5 -1.5l-.972 1.923a11.913 11.913 0 0 0 -4.053 0l-.975 -1.923c-1.5 .16 -3.043 .485 -4.5 1.5c-2 5.667 -2.167 9.833 -1.5 11.5c.667 1.333 2 3 3.5 3c.5 0 2 -2 2 -3", "key": "svg-2" }], ["path", { "d": "M7 16.5c3.5 1 6.5 1 10 0", "key": "svg-3" }]]);

var IconBrandDiscord$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDiscord
});

var IconBrandDisney = createReactComponent("outline", "brand-disney", "IconBrandDisney", [["path", { "d": "M3.22 5.838c-1.307 -.15 -1.22 -.578 -1.22 -.794c0 -.216 .424 -1.044 4.34 -1.044c4.694 0 14.66 3.645 14.66 10.042s-8.71 4.931 -10.435 4.52c-1.724 -.412 -5.565 -2.256 -5.565 -4.174c0 -1.395 3.08 -2.388 6.715 -2.388c3.634 0 5.285 1.041 5.285 2c0 .5 -.074 1.229 -1 1.5", "key": "svg-0" }], ["path", { "d": "M10.02 8a505.153 505.153 0 0 0 0 13", "key": "svg-1" }]]);

var IconBrandDisney$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDisney
});

var IconBrandDisqus = createReactComponent("outline", "brand-disqus", "IconBrandDisqus", [["path", { "d": "M11.847 21c-2.259 0 -4.323 -.667 -5.919 -2h-3.928l1.708 -3.266c-.545 -1.174 -.759 -2.446 -.758 -3.734c0 -4.97 3.84 -9 8.898 -9c5.052 0 9.152 4.03 9.152 9c0 4.972 -4.098 9 -9.153 9z", "key": "svg-0" }], ["path", { "d": "M11.485 15h-1.485v-6h1.485c2.112 0 3.515 .823 3.515 2.981v.035c0 2.18 -1.403 2.984 -3.515 2.984z", "key": "svg-1" }]]);

var IconBrandDisqus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDisqus
});

var IconBrandDjango = createReactComponent("outline", "brand-django", "IconBrandDjango", [["path", { "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M12 7v8.5l-2.015 .201a2.715 2.715 0 1 1 0 -5.402l2.015 .201", "key": "svg-1" }], ["path", { "d": "M16 7v.01", "key": "svg-2" }], ["path", { "d": "M16 10v5.586c0 .905 -.36 1.774 -1 2.414", "key": "svg-3" }]]);

var IconBrandDjango$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDjango
});

var IconBrandDocker = createReactComponent("outline", "brand-docker", "IconBrandDocker", [["path", { "d": "M22 12.54c-1.804 -.345 -2.701 -1.08 -3.523 -2.94c-.487 .696 -1.102 1.568 -.92 2.4c.028 .238 -.32 1 -.557 1h-14c0 5.208 3.164 7 6.196 7c4.124 .022 7.828 -1.376 9.854 -5c1.146 -.101 2.296 -1.505 2.95 -2.46z", "key": "svg-0" }], ["path", { "d": "M5 10h3v3h-3z", "key": "svg-1" }], ["path", { "d": "M8 10h3v3h-3z", "key": "svg-2" }], ["path", { "d": "M11 10h3v3h-3z", "key": "svg-3" }], ["path", { "d": "M8 7h3v3h-3z", "key": "svg-4" }], ["path", { "d": "M11 7h3v3h-3z", "key": "svg-5" }], ["path", { "d": "M11 4h3v3h-3z", "key": "svg-6" }], ["path", { "d": "M4.571 18c1.5 0 2.047 -.074 2.958 -.78", "key": "svg-7" }], ["path", { "d": "M10 16l0 .01", "key": "svg-8" }]]);

var IconBrandDocker$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDocker
});

var IconBrandDoctrine = createReactComponent("outline", "brand-doctrine", "IconBrandDoctrine", [["path", { "d": "M12 14m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M9 14h6", "key": "svg-1" }], ["path", { "d": "M12 11l3 3l-3 3", "key": "svg-2" }], ["path", { "d": "M10 3l6.9 6", "key": "svg-3" }]]);

var IconBrandDoctrine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDoctrine
});

var IconBrandDolbyDigital = createReactComponent("outline", "brand-dolby-digital", "IconBrandDolbyDigital", [["path", { "d": "M21 6v12h-.89c-3.34 0 -6.047 -2.686 -6.047 -6s2.707 -6 6.046 -6h.891z", "key": "svg-0" }], ["path", { "d": "M3.063 6v12h.891c3.34 0 6.046 -2.686 6.046 -6s-2.707 -6 -6.046 -6h-.89z", "key": "svg-1" }]]);

var IconBrandDolbyDigital$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDolbyDigital
});

var IconBrandDouban = createReactComponent("outline", "brand-douban", "IconBrandDouban", [["path", { "d": "M4 20h16", "key": "svg-0" }], ["path", { "d": "M5 4h14", "key": "svg-1" }], ["path", { "d": "M8 8h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-2a2 2 0 0 1 2 -2z", "key": "svg-2" }], ["path", { "d": "M16 14l-2 6", "key": "svg-3" }], ["path", { "d": "M8 17l1 3", "key": "svg-4" }]]);

var IconBrandDouban$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDouban
});

var IconBrandDribbble = createReactComponent("outline", "brand-dribbble", "IconBrandDribbble", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 3.6c5 6 7 10.5 7.5 16.2", "key": "svg-1" }], ["path", { "d": "M6.4 19c3.5 -3.5 6 -6.5 14.5 -6.4", "key": "svg-2" }], ["path", { "d": "M3.1 10.75c5 0 9.814 -.38 15.314 -5", "key": "svg-3" }]]);

var IconBrandDribbble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDribbble
});

var IconBrandDrops = createReactComponent("outline", "brand-drops", "IconBrandDrops", [["path", { "d": "M17.637 7.416a7.907 7.907 0 0 1 1.76 8.666a8 8 0 0 1 -7.397 4.918a8 8 0 0 1 -7.396 -4.918a7.907 7.907 0 0 1 1.759 -8.666l5.637 -5.416l5.637 5.416z", "key": "svg-0" }], ["path", { "d": "M14.466 10.923a3.595 3.595 0 0 1 .77 3.877a3.5 3.5 0 0 1 -3.236 2.2a3.5 3.5 0 0 1 -3.236 -2.2a3.595 3.595 0 0 1 .77 -3.877l2.466 -2.423l2.466 2.423z", "key": "svg-1" }]]);

var IconBrandDrops$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDrops
});

var IconBrandDrupal = createReactComponent("outline", "brand-drupal", "IconBrandDrupal", [["path", { "d": "M12 2c0 4.308 -7 6 -7 12a7 7 0 0 0 14 0c0 -6 -7 -7.697 -7 -12z", "key": "svg-0" }], ["path", { "d": "M12 11.33a65.753 65.753 0 0 1 -2.012 2.023c-1 .957 -1.988 1.967 -1.988 3.647c0 2.17 1.79 4 4 4s4 -1.827 4 -4c0 -1.676 -.989 -2.685 -1.983 -3.642c-.42 -.404 -2.259 -2.357 -5.517 -5.858l3.5 3.83z", "key": "svg-1" }]]);

var IconBrandDrupal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDrupal
});

var IconBrandEdge = createReactComponent("outline", "brand-edge", "IconBrandEdge", [["path", { "d": "M20.978 11.372a9 9 0 1 0 -1.593 5.773", "key": "svg-0" }], ["path", { "d": "M20.978 11.372c.21 2.993 -5.034 2.413 -6.913 1.486c1.392 -1.6 .402 -4.038 -2.274 -3.851c-1.745 .122 -2.927 1.157 -2.784 3.202c.28 3.99 4.444 6.205 10.36 4.79", "key": "svg-1" }], ["path", { "d": "M3.022 12.628c-.283 -4.043 8.717 -7.228 11.248 -2.688", "key": "svg-2" }], ["path", { "d": "M12.628 20.978c-2.993 .21 -5.162 -4.725 -3.567 -9.748", "key": "svg-3" }]]);

var IconBrandEdge$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandEdge
});

var IconBrandElastic = createReactComponent("outline", "brand-elastic", "IconBrandElastic", [["path", { "d": "M14 2a5 5 0 0 1 5 5c0 .712 -.232 1.387 -.5 2c1.894 .042 3.5 1.595 3.5 3.5c0 1.869 -1.656 3.4 -3.5 3.5c.333 .625 .5 1.125 .5 1.5a2.5 2.5 0 0 1 -2.5 2.5c-.787 0 -1.542 -.432 -2 -1c-.786 1.73 -2.476 3 -4.5 3a5 5 0 0 1 -4.583 -7a3.5 3.5 0 0 1 -.11 -6.992l.195 0a2.5 2.5 0 0 1 2 -4c.787 0 1.542 .432 2 1c.786 -1.73 2.476 -3 4.5 -3z", "key": "svg-0" }], ["path", { "d": "M8.5 9l-3 -1", "key": "svg-1" }], ["path", { "d": "M9.5 5l-1 4l1 2l5 2l4 -4", "key": "svg-2" }], ["path", { "d": "M18.499 16l-3 -.5l-1 -2.5", "key": "svg-3" }], ["path", { "d": "M14.5 19l1 -3.5", "key": "svg-4" }], ["path", { "d": "M5.417 15l4.083 -4", "key": "svg-5" }]]);

var IconBrandElastic$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandElastic
});

var IconBrandElectronicArts = createReactComponent("outline", "brand-electronic-arts", "IconBrandElectronicArts", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M17.5 15l-3 -6l-3 6h-5l1.5 -3", "key": "svg-1" }], ["path", { "d": "M17 14h-2", "key": "svg-2" }], ["path", { "d": "M6.5 12h3.5", "key": "svg-3" }], ["path", { "d": "M8 9h3", "key": "svg-4" }]]);

var IconBrandElectronicArts$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandElectronicArts
});

var IconBrandEmber = createReactComponent("outline", "brand-ember", "IconBrandEmber", [["path", { "d": "M3 12.958c8.466 1.647 11.112 -1.196 12.17 -2.294c2.116 -2.196 0 -6.589 -2.646 -5.49c-2.644 1.096 -6.35 7.686 -3.174 12.078c2.116 2.928 6 2.178 11.65 -2.252", "key": "svg-0" }]]);

var IconBrandEmber$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandEmber
});

var IconBrandEnvato = createReactComponent("outline", "brand-envato", "IconBrandEnvato", [["path", { "d": "M4.711 17.875c-.534 -1.339 -1.35 -4.178 .129 -6.47c1.415 -2.193 3.769 -3.608 5.099 -4.278l-5.229 10.748z", "key": "svg-0" }], ["path", { "d": "M19.715 12.508c-.54 3.409 -2.094 6.156 -4.155 7.348c-4.069 2.353 -8.144 .45 -9.297 -.188c.877 -1.436 4.433 -7.22 6.882 -10.591c2.714 -3.737 5.864 -5.978 6.565 -6.077c0 .201 .03 .55 .071 1.03c.144 1.709 .443 5.264 -.066 8.478z", "key": "svg-1" }]]);

var IconBrandEnvato$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandEnvato
});

var IconBrandEtsy = createReactComponent("outline", "brand-etsy", "IconBrandEtsy", [["path", { "d": "M14 12h-5", "key": "svg-0" }], ["path", { "d": "M3 3m0 5a5 5 0 0 1 5 -5h8a5 5 0 0 1 5 5v8a5 5 0 0 1 -5 5h-8a5 5 0 0 1 -5 -5z", "key": "svg-1" }], ["path", { "d": "M15 16h-5a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h5", "key": "svg-2" }]]);

var IconBrandEtsy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandEtsy
});

var IconBrandEvernote = createReactComponent("outline", "brand-evernote", "IconBrandEvernote", [["path", { "d": "M4 8h5v-5", "key": "svg-0" }], ["path", { "d": "M17.9 19c.6 -2.5 1.1 -5.471 1.1 -9c0 -4.5 -2 -5 -3 -5c-1.906 0 -3 -.5 -3.5 -1c-.354 -.354 -.5 -1 -1.5 -1h-2l-5 5c0 6 2.5 8 5 8c1 0 1.5 -.5 2 -1.5s1.414 -.326 2.5 0c1.044 .313 2.01 .255 2.5 .5c1 .5 2 1.5 2 3c0 .5 0 3 -3 3s-3 -3 -1 -3", "key": "svg-1" }], ["path", { "d": "M15 10h1", "key": "svg-2" }]]);

var IconBrandEvernote$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandEvernote
});

var IconBrandFacebook = createReactComponent("outline", "brand-facebook", "IconBrandFacebook", [["path", { "d": "M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3", "key": "svg-0" }]]);

var IconBrandFacebook$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFacebook
});

var IconBrandFeedly = createReactComponent("outline", "brand-feedly", "IconBrandFeedly", [["path", { "d": "M7.833 12.278l4.445 -4.445", "key": "svg-0" }], ["path", { "d": "M10.055 14.5l2.223 -2.222", "key": "svg-1" }], ["path", { "d": "M12.278 16.722l.555 -.555", "key": "svg-2" }], ["path", { "d": "M19.828 14.828a4 4 0 0 0 0 -5.656l-5 -5a4 4 0 0 0 -5.656 0l-5 5a4 4 0 0 0 0 5.656l6.171 6.172h3.314l6.171 -6.172z", "key": "svg-3" }]]);

var IconBrandFeedly$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFeedly
});

var IconBrandFigma = createReactComponent("outline", "brand-figma", "IconBrandFigma", [["path", { "d": "M15 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M6 3m0 3a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v0a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3z", "key": "svg-1" }], ["path", { "d": "M9 9a3 3 0 0 0 0 6h3m-3 0a3 3 0 1 0 3 3v-15", "key": "svg-2" }]]);

var IconBrandFigma$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFigma
});

var IconBrandFilezilla = createReactComponent("outline", "brand-filezilla", "IconBrandFilezilla", [["path", { "d": "M16 15.824a4.062 4.062 0 0 1 -2.25 .033c-.738 -.201 -2.018 -.08 -2.75 .143l4.583 -5h-6.583", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }], ["path", { "d": "M8 15l2 -8h5", "key": "svg-2" }]]);

var IconBrandFilezilla$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFilezilla
});

var IconBrandFinder = createReactComponent("outline", "brand-finder", "IconBrandFinder", [["path", { "d": "M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M7 8v1", "key": "svg-1" }], ["path", { "d": "M17 8v1", "key": "svg-2" }], ["path", { "d": "M12.5 4c-.654 1.486 -1.26 3.443 -1.5 9h2.5c-.19 2.867 .094 5.024 .5 7", "key": "svg-3" }], ["path", { "d": "M7 15.5c3.667 2 6.333 2 10 0", "key": "svg-4" }]]);

var IconBrandFinder$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFinder
});

var IconBrandFirebase = createReactComponent("outline", "brand-firebase", "IconBrandFirebase", [["path", { "d": "M4.53 17.05l6.15 -11.72h-.02c.38 -.74 1.28 -1.02 2.01 -.63c.26 .14 .48 .36 .62 .62l1.06 2.01", "key": "svg-0" }], ["path", { "d": "M15.47 6.45c.58 -.59 1.53 -.59 2.11 -.01c.22 .22 .36 .5 .41 .81l1.5 9.11c.1 .62 -.2 1.24 -.76 1.54l-6.07 2.9c-.46 .25 -1.01 .26 -1.46 0l-6.02 -2.92c-.55 -.31 -.85 -.92 -.75 -1.54l1.96 -12.04c.12 -.82 .89 -1.38 1.7 -1.25c.46 .07 .87 .36 1.09 .77l1.24 1.76", "key": "svg-1" }], ["path", { "d": "M4.57 17.18l10.93 -10.68", "key": "svg-2" }]]);

var IconBrandFirebase$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFirebase
});

var IconBrandFirefox = createReactComponent("outline", "brand-firefox", "IconBrandFirefox", [["path", { "d": "M4.028 7.82a9 9 0 1 0 12.823 -3.4c-1.636 -1.02 -3.064 -1.02 -4.851 -1.02h-1.647", "key": "svg-0" }], ["path", { "d": "M4.914 9.485c-1.756 -1.569 -.805 -5.38 .109 -6.17c.086 .896 .585 1.208 1.111 1.685c.88 -.275 1.313 -.282 1.867 0c.82 -.91 1.694 -2.354 2.628 -2.093c-1.082 1.741 -.07 3.733 1.371 4.173c-.17 .975 -1.484 1.913 -2.76 2.686c-1.296 .938 -.722 1.85 0 2.234c.949 .506 3.611 -1 4.545 .354c-1.698 .102 -1.536 3.107 -3.983 2.727c2.523 .957 4.345 .462 5.458 -.34c1.965 -1.52 2.879 -3.542 2.879 -5.557c-.014 -1.398 .194 -2.695 -1.26 -4.75", "key": "svg-1" }]]);

var IconBrandFirefox$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFirefox
});

var IconBrandFiverr = createReactComponent("outline", "brand-fiverr", "IconBrandFiverr", [["path", { "d": "M15 3h-2a6 6 0 0 0 -6 6h-3v4h3v8h4v-7h4v7h4v-11h-8v-1.033a1.967 1.967 0 0 1 2 -1.967h2v-4z", "key": "svg-0" }]]);

var IconBrandFiverr$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFiverr
});

var IconBrandFlickr = createReactComponent("outline", "brand-flickr", "IconBrandFlickr", [["path", { "d": "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }]]);

var IconBrandFlickr$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFlickr
});

var IconBrandFlightradar24 = createReactComponent("outline", "brand-flightradar24", "IconBrandFlightradar24", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-1" }], ["path", { "d": "M8.5 20l3.5 -8l-6.5 6", "key": "svg-2" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }]]);

var IconBrandFlightradar24$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFlightradar24
});

var IconBrandFlipboard = createReactComponent("outline", "brand-flipboard", "IconBrandFlipboard", [["path", { "d": "M3.973 3h16.054c.537 0 .973 .436 .973 .973v4.052a.973 .973 0 0 1 -.973 .973h-5.025v4.831c0 .648 -.525 1.173 -1.173 1.173h-4.829v5.025a.973 .973 0 0 1 -.974 .973h-4.053a.973 .973 0 0 1 -.973 -.973v-16.054c0 -.537 .436 -.973 .973 -.973z", "key": "svg-0" }]]);

var IconBrandFlipboard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFlipboard
});

var IconBrandFlutter = createReactComponent("outline", "brand-flutter", "IconBrandFlutter", [["path", { "d": "M7 14l-3 -3l8 -8h6z", "key": "svg-0" }], ["path", { "d": "M14 21l-5 -5l5 -5h5l-5 5l5 5z", "key": "svg-1" }]]);

var IconBrandFlutter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFlutter
});

var IconBrandFortnite = createReactComponent("outline", "brand-fortnite", "IconBrandFortnite", [["path", { "d": "M8 3h7.5l-.5 4h-3v3h3v3.5h-3v6.5l-4 1z", "key": "svg-0" }]]);

var IconBrandFortnite$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFortnite
});

var IconBrandFoursquare = createReactComponent("outline", "brand-foursquare", "IconBrandFoursquare", [["path", { "d": "M7 3h10c.644 0 1.11 .696 .978 1.33l-1.984 9.859a1.014 1.014 0 0 1 -1 .811h-2.254c-.308 0 -.6 .141 -.793 .382l-4.144 5.25c-.599 .752 -1.809 .331 -1.809 -.632v-16c0 -.564 .44 -1 1 -1z", "key": "svg-0" }], ["path", { "d": "M12 9l5 0", "key": "svg-1" }]]);

var IconBrandFoursquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFoursquare
});

var IconBrandFramerMotion = createReactComponent("outline", "brand-framer-motion", "IconBrandFramerMotion", [["path", { "d": "M12 12l-8 -8v16l16 -16v16l-4 -4", "key": "svg-0" }], ["path", { "d": "M20 12l-8 8l-4 -4", "key": "svg-1" }]]);

var IconBrandFramerMotion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFramerMotion
});

var IconBrandFramer = createReactComponent("outline", "brand-framer", "IconBrandFramer", [["path", { "d": "M6 15h12l-12 -12h12v6h-12v6l6 6v-6", "key": "svg-0" }]]);

var IconBrandFramer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFramer
});

var IconBrandFunimation = createReactComponent("outline", "brand-funimation", "IconBrandFunimation", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M8 13h8a4 4 0 1 1 -8 0z", "key": "svg-1" }]]);

var IconBrandFunimation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFunimation
});

var IconBrandGatsby = createReactComponent("outline", "brand-gatsby", "IconBrandGatsby", [["path", { "d": "M3.296 14.297l6.407 6.407a9.018 9.018 0 0 1 -6.325 -6.116l-.082 -.291z", "key": "svg-0" }], ["path", { "d": "M16 13h5c-.41 3.603 -3.007 6.59 -6.386 7.614l-11.228 -11.229a9 9 0 0 1 15.66 -2.985", "key": "svg-1" }]]);

var IconBrandGatsby$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGatsby
});

var IconBrandGit = createReactComponent("outline", "brand-git", "IconBrandGit", [["path", { "d": "M16 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M12 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M12 15v-6", "key": "svg-3" }], ["path", { "d": "M15 11l-2 -2", "key": "svg-4" }], ["path", { "d": "M11 7l-1.9 -1.9", "key": "svg-5" }], ["path", { "d": "M13.446 2.6l7.955 7.954a2.045 2.045 0 0 1 0 2.892l-7.955 7.955a2.045 2.045 0 0 1 -2.892 0l-7.955 -7.955a2.045 2.045 0 0 1 0 -2.892l7.955 -7.955a2.045 2.045 0 0 1 2.892 0z", "key": "svg-6" }]]);

var IconBrandGit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGit
});

var IconBrandGithubCopilot = createReactComponent("outline", "brand-github-copilot", "IconBrandGithubCopilot", [["path", { "d": "M4 18v-5.5c0 -.667 .167 -1.333 .5 -2", "key": "svg-0" }], ["path", { "d": "M12 7.5c0 -1 -.01 -4.07 -4 -3.5c-3.5 .5 -4 2.5 -4 3.5c0 1.5 0 4 3 4c4 0 5 -2.5 5 -4z", "key": "svg-1" }], ["path", { "d": "M4 12c-1.333 .667 -2 1.333 -2 2c0 1 0 3 1.5 4c3 2 6.5 3 8.5 3s5.499 -1 8.5 -3c1.5 -1 1.5 -3 1.5 -4c0 -.667 -.667 -1.333 -2 -2", "key": "svg-2" }], ["path", { "d": "M20 18v-5.5c0 -.667 -.167 -1.333 -.5 -2", "key": "svg-3" }], ["path", { "d": "M12 7.5l0 -.297l.01 -.269l.027 -.298l.013 -.105l.033 -.215c.014 -.073 .029 -.146 .046 -.22l.06 -.223c.336 -1.118 1.262 -2.237 3.808 -1.873c2.838 .405 3.703 1.797 3.93 2.842l.036 .204c0 .033 .01 .066 .013 .098l.016 .185l0 .171l0 .49l-.015 .394l-.02 .271c-.122 1.366 -.655 2.845 -2.962 2.845c-3.256 0 -4.524 -1.656 -4.883 -3.081l-.053 -.242a3.865 3.865 0 0 1 -.036 -.235l-.021 -.227a3.518 3.518 0 0 1 -.007 -.215z", "key": "svg-4" }], ["path", { "d": "M10 15v2", "key": "svg-5" }], ["path", { "d": "M14 15v2", "key": "svg-6" }]]);

var IconBrandGithubCopilot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGithubCopilot
});

var IconBrandGithub = createReactComponent("outline", "brand-github", "IconBrandGithub", [["path", { "d": "M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5", "key": "svg-0" }]]);

var IconBrandGithub$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGithub
});

var IconBrandGitlab = createReactComponent("outline", "brand-gitlab", "IconBrandGitlab", [["path", { "d": "M21 14l-9 7l-9 -7l3 -11l3 7h6l3 -7z", "key": "svg-0" }]]);

var IconBrandGitlab$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGitlab
});

var IconBrandGmail = createReactComponent("outline", "brand-gmail", "IconBrandGmail", [["path", { "d": "M16 20h3a1 1 0 0 0 1 -1v-14a1 1 0 0 0 -1 -1h-3v16z", "key": "svg-0" }], ["path", { "d": "M5 20h3v-16h-3a1 1 0 0 0 -1 1v14a1 1 0 0 0 1 1z", "key": "svg-1" }], ["path", { "d": "M16 4l-4 4l-4 -4", "key": "svg-2" }], ["path", { "d": "M4 6.5l8 7.5l8 -7.5", "key": "svg-3" }]]);

var IconBrandGmail$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGmail
});

var IconBrandGolang = createReactComponent("outline", "brand-golang", "IconBrandGolang", [["path", { "d": "M15.695 14.305c1.061 1.06 2.953 .888 4.226 -.384c1.272 -1.273 1.444 -3.165 .384 -4.226c-1.061 -1.06 -2.953 -.888 -4.226 .384c-1.272 1.273 -1.444 3.165 -.384 4.226z", "key": "svg-0" }], ["path", { "d": "M12.68 9.233c-1.084 -.497 -2.545 -.191 -3.591 .846c-1.284 1.273 -1.457 3.165 -.388 4.226c1.07 1.06 2.978 .888 4.261 -.384a3.669 3.669 0 0 0 1.038 -1.921h-2.427", "key": "svg-1" }], ["path", { "d": "M5.5 15h-1.5", "key": "svg-2" }], ["path", { "d": "M6 9h-2", "key": "svg-3" }], ["path", { "d": "M5 12h-3", "key": "svg-4" }]]);

var IconBrandGolang$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGolang
});

var IconBrandGoogleAnalytics = createReactComponent("outline", "brand-google-analytics", "IconBrandGoogleAnalytics", [["path", { "d": "M10 9m0 1.105a1.105 1.105 0 0 1 1.105 -1.105h1.79a1.105 1.105 0 0 1 1.105 1.105v9.79a1.105 1.105 0 0 1 -1.105 1.105h-1.79a1.105 1.105 0 0 1 -1.105 -1.105z", "key": "svg-0" }], ["path", { "d": "M17 3m0 1.105a1.105 1.105 0 0 1 1.105 -1.105h1.79a1.105 1.105 0 0 1 1.105 1.105v15.79a1.105 1.105 0 0 1 -1.105 1.105h-1.79a1.105 1.105 0 0 1 -1.105 -1.105z", "key": "svg-1" }], ["path", { "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }]]);

var IconBrandGoogleAnalytics$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGoogleAnalytics
});

var IconBrandGoogleBigQuery = createReactComponent("outline", "brand-google-big-query", "IconBrandGoogleBigQuery", [["path", { "d": "M17.73 19.875a2.225 2.225 0 0 1 -1.948 1.125h-7.283a2.222 2.222 0 0 1 -1.947 -1.158l-4.272 -6.75a2.269 2.269 0 0 1 0 -2.184l4.272 -6.75a2.225 2.225 0 0 1 1.946 -1.158h7.285c.809 0 1.554 .443 1.947 1.158l3.98 6.75a2.33 2.33 0 0 1 0 2.25l-3.98 6.75v-.033z", "key": "svg-0" }], ["path", { "d": "M11.5 11.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0", "key": "svg-1" }], ["path", { "d": "M14 14l2 2", "key": "svg-2" }]]);

var IconBrandGoogleBigQuery$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGoogleBigQuery
});

var IconBrandGoogleDrive = createReactComponent("outline", "brand-google-drive", "IconBrandGoogleDrive", [["path", { "d": "M12 10l-6 10l-3 -5l6 -10z", "key": "svg-0" }], ["path", { "d": "M9 15h12l-3 5h-12", "key": "svg-1" }], ["path", { "d": "M15 15l-6 -10h6l6 10z", "key": "svg-2" }]]);

var IconBrandGoogleDrive$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGoogleDrive
});

var IconBrandGoogleFit = createReactComponent("outline", "brand-google-fit", "IconBrandGoogleFit", [["path", { "d": "M12 8.866l-2.733 -2.734a3.866 3.866 0 0 0 -5.467 5.467l2.733 2.734l5.467 5.467l8.202 -8.201a3.866 3.866 0 0 0 -5.469 -5.466l-8.201 8.2", "key": "svg-0" }]]);

var IconBrandGoogleFit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGoogleFit
});

var IconBrandGoogleHome = createReactComponent("outline", "brand-google-home", "IconBrandGoogleHome", [["path", { "d": "M19.072 21h-14.144a1.928 1.928 0 0 1 -1.928 -1.928v-6.857c0 -.512 .203 -1 .566 -1.365l7.07 -7.063a1.928 1.928 0 0 1 2.727 0l7.071 7.063c.363 .362 .566 .853 .566 1.365v6.857a1.928 1.928 0 0 1 -1.928 1.928z", "key": "svg-0" }], ["path", { "d": "M7 13v4h10v-4l-5 -5", "key": "svg-1" }], ["path", { "d": "M14.8 5.2l-11.8 11.8", "key": "svg-2" }], ["path", { "d": "M7 17v4", "key": "svg-3" }], ["path", { "d": "M17 17v4", "key": "svg-4" }]]);

var IconBrandGoogleHome$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGoogleHome
});

var IconBrandGoogleMaps = createReactComponent("outline", "brand-google-maps", "IconBrandGoogleMaps", [["path", { "d": "M12 9.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-0" }], ["path", { "d": "M6.428 12.494l7.314 -9.252", "key": "svg-1" }], ["path", { "d": "M10.002 7.935l-2.937 -2.545", "key": "svg-2" }], ["path", { "d": "M17.693 6.593l-8.336 9.979", "key": "svg-3" }], ["path", { "d": "M17.591 6.376c.472 .907 .715 1.914 .709 2.935a7.263 7.263 0 0 1 -.72 3.18a19.085 19.085 0 0 1 -2.089 3c-.784 .933 -1.49 1.93 -2.11 2.98c-.314 .62 -.568 1.27 -.757 1.938c-.121 .36 -.277 .591 -.622 .591c-.315 0 -.463 -.136 -.626 -.593a10.595 10.595 0 0 0 -.779 -1.978a18.18 18.18 0 0 0 -1.423 -2.091c-.877 -1.184 -2.179 -2.535 -2.853 -4.071a7.077 7.077 0 0 1 -.621 -2.967a6.226 6.226 0 0 1 1.476 -4.055a6.25 6.25 0 0 1 4.811 -2.245a6.462 6.462 0 0 1 1.918 .284a6.255 6.255 0 0 1 3.686 3.092z", "key": "svg-4" }]]);

var IconBrandGoogleMaps$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGoogleMaps
});

var IconBrandGoogleOne = createReactComponent("outline", "brand-google-one", "IconBrandGoogleOne", [["path", { "d": "M11 5v13.982a2 2 0 0 0 4 0v-13.982a2 2 0 1 0 -4 0z", "key": "svg-0" }], ["path", { "d": "M6.63 8.407a2.125 2.125 0 0 0 -.074 2.944c.77 .834 2.051 .869 2.862 .077l4.95 -4.834c.812 -.792 .846 -2.11 .076 -2.945a1.984 1.984 0 0 0 -2.861 -.077l-4.953 4.835z", "key": "svg-1" }]]);

var IconBrandGoogleOne$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGoogleOne
});

var IconBrandGooglePhotos = createReactComponent("outline", "brand-google-photos", "IconBrandGooglePhotos", [["path", { "d": "M7.5 7c2.485 0 4.5 1.974 4.5 4.409v.591h-8.397a.61 .61 0 0 1 -.426 -.173a.585 .585 0 0 1 -.177 -.418c0 -2.435 2.015 -4.409 4.5 -4.409z", "key": "svg-0" }], ["path", { "d": "M16.5 17c-2.485 0 -4.5 -1.974 -4.5 -4.409v-.591h8.397c.333 0 .603 .265 .603 .591c0 2.435 -2.015 4.409 -4.5 4.409z", "key": "svg-1" }], ["path", { "d": "M7 16.5c0 -2.485 1.972 -4.5 4.405 -4.5h.595v8.392a.61 .61 0 0 1 -.173 .431a.584 .584 0 0 1 -.422 .177c-2.433 0 -4.405 -2.015 -4.405 -4.5z", "key": "svg-2" }], ["path", { "d": "M17 7.5c0 2.485 -1.972 4.5 -4.405 4.5h-.595v-8.397a.61 .61 0 0 1 .175 -.428a.584 .584 0 0 1 .42 -.175c2.433 0 4.405 2.015 4.405 4.5z", "key": "svg-3" }]]);

var IconBrandGooglePhotos$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGooglePhotos
});

var IconBrandGooglePlay = createReactComponent("outline", "brand-google-play", "IconBrandGooglePlay", [["path", { "d": "M4 3.71v16.58a.7 .7 0 0 0 1.05 .606l14.622 -8.42a.55 .55 0 0 0 0 -.953l-14.622 -8.419a.7 .7 0 0 0 -1.05 .607z", "key": "svg-0" }], ["path", { "d": "M15 9l-10.5 11.5", "key": "svg-1" }], ["path", { "d": "M4.5 3.5l10.5 11.5", "key": "svg-2" }]]);

var IconBrandGooglePlay$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGooglePlay
});

var IconBrandGooglePodcasts = createReactComponent("outline", "brand-google-podcasts", "IconBrandGooglePodcasts", [["path", { "d": "M12 3v2", "key": "svg-0" }], ["path", { "d": "M12 19v2", "key": "svg-1" }], ["path", { "d": "M12 8v8", "key": "svg-2" }], ["path", { "d": "M8 17v2", "key": "svg-3" }], ["path", { "d": "M4 11v2", "key": "svg-4" }], ["path", { "d": "M20 11v2", "key": "svg-5" }], ["path", { "d": "M8 5v8", "key": "svg-6" }], ["path", { "d": "M16 7v-2", "key": "svg-7" }], ["path", { "d": "M16 19v-8", "key": "svg-8" }]]);

var IconBrandGooglePodcasts$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGooglePodcasts
});

var IconBrandGoogle = createReactComponent("outline", "brand-google", "IconBrandGoogle", [["path", { "d": "M20.945 11a9 9 0 1 1 -3.284 -5.997l-2.655 2.392a5.5 5.5 0 1 0 2.119 6.605h-4.125v-3h7.945z", "key": "svg-0" }]]);

var IconBrandGoogle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGoogle
});

var IconBrandGrammarly = createReactComponent("outline", "brand-grammarly", "IconBrandGrammarly", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M15.697 9.434a4.5 4.5 0 1 0 .217 4.788", "key": "svg-1" }], ["path", { "d": "M13.5 14h2.5v2.5", "key": "svg-2" }]]);

var IconBrandGrammarly$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGrammarly
});

var IconBrandGraphql = createReactComponent("outline", "brand-graphql", "IconBrandGraphql", [["path", { "d": "M4 8l8 -5l8 5v8l-8 5l-8 -5z", "key": "svg-0" }], ["path", { "d": "M12 4l7.5 12h-15z", "key": "svg-1" }], ["path", { "d": "M11 3a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-2" }], ["path", { "d": "M11 21a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-3" }], ["path", { "d": "M3 8a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-4" }], ["path", { "d": "M3 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-5" }], ["path", { "d": "M19 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-6" }], ["path", { "d": "M19 8a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-7" }]]);

var IconBrandGraphql$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGraphql
});

var IconBrandGravatar = createReactComponent("outline", "brand-gravatar", "IconBrandGravatar", [["path", { "d": "M5.64 5.632a9 9 0 1 0 6.36 -2.632v7.714", "key": "svg-0" }]]);

var IconBrandGravatar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGravatar
});

var IconBrandGrindr = createReactComponent("outline", "brand-grindr", "IconBrandGrindr", [["path", { "d": "M13 13.282c0 .492 .784 1.718 2.102 1.718c1.318 0 2.898 -.966 2.898 -2.062c0 -.817 -.932 -.938 -1.409 -.938c-.228 0 -3.591 .111 -3.591 1.282z", "key": "svg-0" }], ["path", { "d": "M12 21c-2.984 0 -6.471 -2.721 -6.63 -2.982c-2.13 -3.49 -2.37 -13.703 -2.37 -13.703l1.446 -1.315c2.499 .39 5.023 .617 7.554 .68a58.626 58.626 0 0 0 7.554 -.68l1.446 1.315s-.24 10.213 -2.37 13.704c-.16 .26 -3.646 2.981 -6.63 2.981z", "key": "svg-1" }], ["path", { "d": "M11 13.282c0 .492 -.784 1.718 -2.102 1.718c-1.318 0 -2.898 -.966 -2.898 -2.062c0 -.817 .932 -.938 1.409 -.938c.228 0 3.591 .111 3.591 1.282z", "key": "svg-2" }]]);

var IconBrandGrindr$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGrindr
});

var IconBrandGuardian = createReactComponent("outline", "brand-guardian", "IconBrandGuardian", [["path", { "d": "M14 13h6", "key": "svg-0" }], ["path", { "d": "M4 12c0 -9.296 9.5 -9 9.5 -9c-2.808 0 -4.5 4.373 -4.5 9s1.763 8.976 4.572 8.976c0 .023 -9.572 1.092 -9.572 -8.976z", "key": "svg-1" }], ["path", { "d": "M14.5 3c1.416 0 3.853 1.16 4.5 2v3.5", "key": "svg-2" }], ["path", { "d": "M15 13v8s2.77 -.37 4 -2v-6", "key": "svg-3" }], ["path", { "d": "M13.5 21h1.5", "key": "svg-4" }], ["path", { "d": "M13.5 3h1", "key": "svg-5" }]]);

var IconBrandGuardian$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGuardian
});

var IconBrandGumroad = createReactComponent("outline", "brand-gumroad", "IconBrandGumroad", [["path", { "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z", "key": "svg-0" }], ["path", { "d": "M13.5 13h2.5v3", "key": "svg-1" }], ["path", { "d": "M15.024 9.382a4 4 0 1 0 -3.024 6.618c1.862 0 2.554 -1.278 3 -3", "key": "svg-2" }]]);

var IconBrandGumroad$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGumroad
});

var IconBrandHackerrank = createReactComponent("outline", "brand-hackerrank", "IconBrandHackerrank", [["path", { "d": "M19.484 5.667c-1.146 -.904 -3.35 -2.394 -6.497 -3.429c-.484 -.159 -.725 -.238 -1.04 -.238c-.314 0 -.556 .08 -1.04 .238c-3.147 1.035 -5.35 2.525 -6.496 3.43c-.402 .317 -.604 .476 -.797 .816c-.194 .341 -.233 .62 -.309 1.178a33 33 0 0 0 -.305 4.338c0 1.742 .165 3.317 .305 4.338c.076 .558 .115 .837 .309 1.178c.193 .34 .395 .5 .797 .817c1.146 .904 3.35 2.394 6.497 3.429c.483 .159 .725 .238 1.04 .238c.314 0 .555 -.08 1.04 -.238c3.146 -1.035 5.35 -2.525 6.496 -3.43c.402 -.317 .603 -.476 .797 -.816c.194 -.341 .232 -.62 .309 -1.178c.14 -1.021 .305 -2.596 .305 -4.338s-.165 -3.317 -.305 -4.338c-.077 -.558 -.115 -.837 -.309 -1.178s-.395 -.5 -.797 -.817", "key": "svg-0" }], ["path", { "d": "M9 8v7", "key": "svg-1" }], ["path", { "d": "M9 12h6", "key": "svg-2" }], ["path", { "d": "M16 16h-2l1 1z", "key": "svg-3" }], ["path", { "d": "M8 8h2l-1 -1z", "key": "svg-4" }], ["path", { "d": "M15 9v7", "key": "svg-5" }]]);

var IconBrandHackerrank$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandHackerrank
});

var IconBrandHbo = createReactComponent("outline", "brand-hbo", "IconBrandHbo", [["path", { "d": "M2 16v-8", "key": "svg-0" }], ["path", { "d": "M6 8v8", "key": "svg-1" }], ["path", { "d": "M2 12h4", "key": "svg-2" }], ["path", { "d": "M9 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z", "key": "svg-3" }], ["path", { "d": "M19 8a4 4 0 1 1 0 8a4 4 0 0 1 0 -8z", "key": "svg-4" }], ["path", { "d": "M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-5" }]]);

var IconBrandHbo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandHbo
});

var IconBrandHeadlessui = createReactComponent("outline", "brand-headlessui", "IconBrandHeadlessui", [["path", { "d": "M6.744 4.325l7.82 -1.267a4.456 4.456 0 0 1 5.111 3.686l1.267 7.82a4.456 4.456 0 0 1 -3.686 5.111l-7.82 1.267a4.456 4.456 0 0 1 -5.111 -3.686l-1.267 -7.82a4.456 4.456 0 0 1 3.686 -5.111z", "key": "svg-0" }], ["path", { "d": "M7.252 7.704l7.897 -1.28a1 1 0 0 1 1.147 .828l.36 2.223l-9.562 3.51l-.67 -4.134a1 1 0 0 1 .828 -1.147z", "key": "svg-1" }]]);

var IconBrandHeadlessui$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandHeadlessui
});

var IconBrandHexo = createReactComponent("outline", "brand-hexo", "IconBrandHexo", [["path", { "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M9 8v8", "key": "svg-1" }], ["path", { "d": "M15 8v8", "key": "svg-2" }], ["path", { "d": "M9 12h6", "key": "svg-3" }]]);

var IconBrandHexo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandHexo
});

var IconBrandHipchat = createReactComponent("outline", "brand-hipchat", "IconBrandHipchat", [["path", { "d": "M17.802 17.292s.077 -.055 .2 -.149c1.843 -1.425 3 -3.49 3 -5.789c0 -4.286 -4.03 -7.764 -9 -7.764c-4.97 0 -9 3.478 -9 7.764c0 4.288 4.03 7.646 9 7.646c.424 0 1.12 -.028 2.088 -.084c1.262 .82 3.104 1.493 4.716 1.493c.499 0 .734 -.41 .414 -.828c-.486 -.596 -1.156 -1.551 -1.416 -2.29z", "key": "svg-0" }], ["path", { "d": "M7.5 13.5c2.5 2.5 6.5 2.5 9 0", "key": "svg-1" }]]);

var IconBrandHipchat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandHipchat
});

var IconBrandHtml5 = createReactComponent("outline", "brand-html5", "IconBrandHtml5", [["path", { "d": "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z", "key": "svg-0" }], ["path", { "d": "M15.5 8h-7l.5 4h6l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5", "key": "svg-1" }]]);

var IconBrandHtml5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandHtml5
});

var IconBrandInertia = createReactComponent("outline", "brand-inertia", "IconBrandInertia", [["path", { "d": "M12.5 8l4 4l-4 4h4.5l4 -4l-4 -4z", "key": "svg-0" }], ["path", { "d": "M3.5 8l4 4l-4 4h4.5l4 -4l-4 -4z", "key": "svg-1" }]]);

var IconBrandInertia$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandInertia
});

var IconBrandInstagram = createReactComponent("outline", "brand-instagram", "IconBrandInstagram", [["path", { "d": "M4 8a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z", "key": "svg-0" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M16.5 7.5v.01", "key": "svg-2" }]]);

var IconBrandInstagram$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandInstagram
});

var IconBrandIntercom = createReactComponent("outline", "brand-intercom", "IconBrandIntercom", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 8v3", "key": "svg-1" }], ["path", { "d": "M10 7v6", "key": "svg-2" }], ["path", { "d": "M14 7v6", "key": "svg-3" }], ["path", { "d": "M17 8v3", "key": "svg-4" }], ["path", { "d": "M7 15c4 2.667 6 2.667 10 0", "key": "svg-5" }]]);

var IconBrandIntercom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandIntercom
});

var IconBrandItch = createReactComponent("outline", "brand-itch", "IconBrandItch", [["path", { "d": "M2 7v1c0 1.087 1.078 2 2 2c1.107 0 2 -.91 2 -2c0 1.09 .893 2 2 2s2 -.91 2 -2c0 1.09 .893 2 2 2s2 -.91 2 -2c0 1.09 .893 2 2 2s2 -.91 2 -2c0 1.09 .893 2 2 2c.922 0 2 -.913 2 -2v-1c-.009 -.275 -.538 -.964 -1.588 -2.068a3 3 0 0 0 -2.174 -.932h-12.476a3 3 0 0 0 -2.174 .932c-1.05 1.104 -1.58 1.793 -1.588 2.068z", "key": "svg-0" }], ["path", { "d": "M4 10c-.117 6.28 .154 9.765 .814 10.456c1.534 .367 4.355 .535 7.186 .536c2.83 -.001 5.652 -.169 7.186 -.536c.99 -1.037 .898 -9.559 .814 -10.456", "key": "svg-1" }], ["path", { "d": "M10 16l2 -2l2 2", "key": "svg-2" }], ["path", { "d": "M12 14v4", "key": "svg-3" }]]);

var IconBrandItch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandItch
});

var IconBrandJavascript = createReactComponent("outline", "brand-javascript", "IconBrandJavascript", [["path", { "d": "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z", "key": "svg-0" }], ["path", { "d": "M7.5 8h3v8l-2 -1", "key": "svg-1" }], ["path", { "d": "M16.5 8h-2.5a.5 .5 0 0 0 -.5 .5v3a.5 .5 0 0 0 .5 .5h1.423a.5 .5 0 0 1 .495 .57l-.418 2.93l-2 .5", "key": "svg-2" }]]);

var IconBrandJavascript$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandJavascript
});

var IconBrandJuejin = createReactComponent("outline", "brand-juejin", "IconBrandJuejin", [["path", { "d": "M2 12l10 7.422l10 -7.422", "key": "svg-0" }], ["path", { "d": "M7 9l5 4l5 -4", "key": "svg-1" }], ["path", { "d": "M11 6l1 .8l1 -.8l-1 -.8z", "key": "svg-2" }]]);

var IconBrandJuejin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandJuejin
});

var IconBrandKakoTalk = createReactComponent("outline", "brand-kako-talk", "IconBrandKakoTalk", [["path", { "d": "M10 8v7", "key": "svg-0" }], ["path", { "d": "M14 10l-2 2.5l2 2.5", "key": "svg-1" }], ["path", { "d": "M12 4c4.97 0 9 3.358 9 7.5c0 4.142 -4.03 7.5 -9 7.5c-.67 0 -1.323 -.061 -1.95 -.177l-3.05 2.177l.592 -2.962c-2.741 -1.284 -4.592 -3.73 -4.592 -6.538c0 -4.142 4.03 -7.5 9 -7.5z", "key": "svg-2" }]]);

var IconBrandKakoTalk$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandKakoTalk
});

var IconBrandKbin = createReactComponent("outline", "brand-kbin", "IconBrandKbin", [["g", { "key": "svg-0", "strokeWidth": "1.838" }]]);

var IconBrandKbin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandKbin
});

var IconBrandKick = createReactComponent("outline", "brand-kick", "IconBrandKick", [["path", { "d": "M4 4h5v4h3v-2h2v-2h6v4h-2v2h-2v4h2v2h2v4h-6v-2h-2v-2h-3v4h-5z", "key": "svg-0" }]]);

var IconBrandKick$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandKick
});

var IconBrandKickstarter = createReactComponent("outline", "brand-kickstarter", "IconBrandKickstarter", [["path", { "d": "M11 9l2.975 -4.65c.615 -.9 1.405 -1.35 2.377 -1.35c.79 0 1.474 .286 2.054 .858c.576 .574 .866 1.256 .866 2.054c0 .588 -.153 1.109 -.46 1.559l-2.812 4.029l3.465 4.912c.356 .46 .535 1 .535 1.613a2.92 2.92 0 0 1 -.843 2.098c-.561 .584 -1.242 .877 -2.04 .877c-.876 0 -1.545 -.29 -2 -.87l-4.112 -5.697v3.067c0 .876 -.313 1.69 -.611 2.175c-.543 .883 -1.35 1.325 -2.389 1.325c-.944 0 -1.753 -.327 -2.271 -.974c-.486 -.6 -.729 -1.392 -.729 -2.38v-11.371c0 -.934 .247 -1.706 .74 -2.313c.512 -.641 1.347 -.962 2.26 -.962c.868 0 1.821 .321 2.4 .962c.323 .356 .515 .714 .6 1.08c.052 .224 0 .643 0 1.26v2.698z", "key": "svg-0" }]]);

var IconBrandKickstarter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandKickstarter
});

var IconBrandKotlin = createReactComponent("outline", "brand-kotlin", "IconBrandKotlin", [["path", { "d": "M20 20h-16v-16h16", "key": "svg-0" }], ["path", { "d": "M4 20l16 -16", "key": "svg-1" }], ["path", { "d": "M4 12l8 -8", "key": "svg-2" }], ["path", { "d": "M12 12l8 8", "key": "svg-3" }]]);

var IconBrandKotlin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandKotlin
});

var IconBrandLaravel = createReactComponent("outline", "brand-laravel", "IconBrandLaravel", [["path", { "d": "M3 17l8 5l7 -4v-8l-4 -2.5l4 -2.5l4 2.5v4l-11 6.5l-4 -2.5v-7.5l-4 -2.5z", "key": "svg-0" }], ["path", { "d": "M11 18v4", "key": "svg-1" }], ["path", { "d": "M7 15.5l7 -4", "key": "svg-2" }], ["path", { "d": "M14 7.5v4", "key": "svg-3" }], ["path", { "d": "M14 11.5l4 2.5", "key": "svg-4" }], ["path", { "d": "M11 13v-7.5l-4 -2.5l-4 2.5", "key": "svg-5" }], ["path", { "d": "M7 8l4 -2.5", "key": "svg-6" }], ["path", { "d": "M18 10l4 -2.5", "key": "svg-7" }]]);

var IconBrandLaravel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandLaravel
});

var IconBrandLastfm = createReactComponent("outline", "brand-lastfm", "IconBrandLastfm", [["path", { "d": "M20 8c-.83 -1 -1.388 -1 -2 -1c-.612 0 -2 .271 -2 2s1.384 2.233 3 3c1.616 .767 2.125 1.812 2 3s-1 2 -3 2s-3 -1 -3.5 -2s-1.585 -4.78 -2.497 -6a5 5 0 1 0 -1 7", "key": "svg-0" }]]);

var IconBrandLastfm$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandLastfm
});

var IconBrandLeetcode = createReactComponent("outline", "brand-leetcode", "IconBrandLeetcode", [["path", { "d": "M12 13h7.5", "key": "svg-0" }], ["path", { "d": "M9.424 7.268l4.999 -4.999", "key": "svg-1" }], ["path", { "d": "M16.633 16.644l-2.402 2.415a3.189 3.189 0 0 1 -4.524 0l-3.77 -3.787a3.223 3.223 0 0 1 0 -4.544l3.77 -3.787a3.189 3.189 0 0 1 4.524 0l2.302 2.313", "key": "svg-2" }]]);

var IconBrandLeetcode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandLeetcode
});

var IconBrandLetterboxd = createReactComponent("outline", "brand-letterboxd", "IconBrandLetterboxd", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M16 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }]]);

var IconBrandLetterboxd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandLetterboxd
});

var IconBrandLine = createReactComponent("outline", "brand-line", "IconBrandLine", [["path", { "d": "M21 10.663c0 -4.224 -4.041 -7.663 -9 -7.663s-9 3.439 -9 7.663c0 3.783 3.201 6.958 7.527 7.56c1.053 .239 .932 .644 .696 2.133c-.039 .238 -.184 .932 .777 .512c.96 -.42 5.18 -3.201 7.073 -5.48c1.304 -1.504 1.927 -3.029 1.927 -4.715v-.01z", "key": "svg-0" }]]);

var IconBrandLine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandLine
});

var IconBrandLinkedin = createReactComponent("outline", "brand-linkedin", "IconBrandLinkedin", [["path", { "d": "M8 11v5", "key": "svg-0" }], ["path", { "d": "M8 8v.01", "key": "svg-1" }], ["path", { "d": "M12 16v-5", "key": "svg-2" }], ["path", { "d": "M16 16v-3a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M3 7a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4z", "key": "svg-4" }]]);

var IconBrandLinkedin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandLinkedin
});

var IconBrandLinktree = createReactComponent("outline", "brand-linktree", "IconBrandLinktree", [["path", { "d": "M4 10h16", "key": "svg-0" }], ["path", { "d": "M6.5 4.5l11 11", "key": "svg-1" }], ["path", { "d": "M6.5 15.5l11 -11", "key": "svg-2" }], ["path", { "d": "M12 10v-8", "key": "svg-3" }], ["path", { "d": "M12 15v7", "key": "svg-4" }]]);

var IconBrandLinktree$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandLinktree
});

var IconBrandLinqpad = createReactComponent("outline", "brand-linqpad", "IconBrandLinqpad", [["path", { "d": "M5 21h3.5l2.5 -6l2.5 -1l2.5 7h4l1 -4.5l-2 -1l-7 -12l-6 -.5l1.5 4l2.5 .5l1 2.5l-7 8z", "key": "svg-0" }]]);

var IconBrandLinqpad$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandLinqpad
});

var IconBrandLivewire = createReactComponent("outline", "brand-livewire", "IconBrandLivewire", [["path", { "d": "M20.982 18.777c-.372 .548 -.652 1.223 -1.406 1.223c-1.269 0 -1.337 -1.913 -2.607 -1.913c-1.27 0 -1.2 1.913 -2.47 1.913c-1.268 0 -1.337 -1.913 -2.607 -1.913c-1.269 0 -1.2 1.913 -2.47 1.913c-1.268 0 -1.337 -1.913 -2.607 -1.913c-1.27 0 -1.2 1.913 -2.47 1.913c-.398 0 -.679 -.189 -.915 -.448a10.414 10.414 0 0 1 -1.43 -5.29c0 -5.669 4.477 -10.262 10 -10.262c5.524 0 10 4.594 10 10.261c0 1.62 -.366 3.152 -1.018 4.516z", "key": "svg-0" }], ["path", { "d": "M20.982 18.777c-.372 .548 -.652 1.223 -1.406 1.223c-1.269 0 -1.337 -1.913 -2.607 -1.913c-1.27 0 -1.2 1.913 -2.47 1.913c-1.268 0 -1.337 -1.913 -2.607 -1.913c-1.269 0 -1.2 1.913 -2.47 1.913c-1.268 0 -1.337 -1.913 -2.607 -1.913c-1.27 0 -1.2 1.913 -2.47 1.913c-.398 0 -.679 -.189 -.915 -.448a10.414 10.414 0 0 1 -1.43 -5.29c0 -5.669 4.477 -10.262 10 -10.262c5.524 0 10 4.594 10 10.261c0 1.62 -.366 3.152 -1.018 4.516z", "key": "svg-1" }], ["path", { "d": "M11.5 16c3.167 0 4.5 -1.748 4.5 -4.231c0 -2.484 -2.014 -4.769 -4.5 -4.769c-2.485 0 -4.5 2.286 -4.5 4.769s1.333 4.231 4.5 4.231z", "key": "svg-2" }], ["path", { "d": "M10 11a1 1 0 1 0 0 -2a1 1 0 0 0 0 2z", "key": "svg-3" }]]);

var IconBrandLivewire$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandLivewire
});

var IconBrandLoom = createReactComponent("outline", "brand-loom", "IconBrandLoom", [["path", { "d": "M17.464 6.518a6 6 0 1 0 -3.023 7.965", "key": "svg-0" }], ["path", { "d": "M17.482 17.464a6 6 0 1 0 -7.965 -3.023", "key": "svg-1" }], ["path", { "d": "M6.54 17.482a6 6 0 1 0 3.024 -7.965", "key": "svg-2" }], ["path", { "d": "M6.518 6.54a6 6 0 1 0 7.965 3.024", "key": "svg-3" }]]);

var IconBrandLoom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandLoom
});

var IconBrandMailgun = createReactComponent("outline", "brand-mailgun", "IconBrandMailgun", [["path", { "d": "M17 12a2 2 0 1 0 4 0a9 9 0 1 0 -2.987 6.697", "key": "svg-0" }], ["path", { "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-1" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }]]);

var IconBrandMailgun$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMailgun
});

var IconBrandMantine = createReactComponent("outline", "brand-mantine", "IconBrandMantine", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M11 16c1.22 -.912 2 -2.36 2 -4a5.01 5.01 0 0 0 -2 -4", "key": "svg-1" }], ["path", { "d": "M14 9h-2", "key": "svg-2" }], ["path", { "d": "M14 15h-2", "key": "svg-3" }], ["path", { "d": "M10 12h.01", "key": "svg-4" }]]);

var IconBrandMantine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMantine
});

var IconBrandMastercard = createReactComponent("outline", "brand-mastercard", "IconBrandMastercard", [["path", { "d": "M14 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12 9.765a3 3 0 1 0 0 4.47", "key": "svg-1" }], ["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconBrandMastercard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMastercard
});

var IconBrandMastodon = createReactComponent("outline", "brand-mastodon", "IconBrandMastodon", [["path", { "d": "M18.648 15.254c-1.816 1.763 -6.648 1.626 -6.648 1.626a18.262 18.262 0 0 1 -3.288 -.256c1.127 1.985 4.12 2.81 8.982 2.475c-1.945 2.013 -13.598 5.257 -13.668 -7.636l-.026 -1.154c0 -3.036 .023 -4.115 1.352 -5.633c1.671 -1.91 6.648 -1.666 6.648 -1.666s4.977 -.243 6.648 1.667c1.329 1.518 1.352 2.597 1.352 5.633s-.456 4.074 -1.352 4.944z", "key": "svg-0" }], ["path", { "d": "M12 11.204v-2.926c0 -1.258 -.895 -2.278 -2 -2.278s-2 1.02 -2 2.278v4.722m4 -4.722c0 -1.258 .895 -2.278 2 -2.278s2 1.02 2 2.278v4.722", "key": "svg-1" }]]);

var IconBrandMastodon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMastodon
});

var IconBrandMatrix = createReactComponent("outline", "brand-matrix", "IconBrandMatrix", [["path", { "d": "M4 3h-1v18h1", "key": "svg-0" }], ["path", { "d": "M20 21h1v-18h-1", "key": "svg-1" }], ["path", { "d": "M7 9v6", "key": "svg-2" }], ["path", { "d": "M12 15v-3.5a2.5 2.5 0 1 0 -5 0v.5", "key": "svg-3" }], ["path", { "d": "M17 15v-3.5a2.5 2.5 0 1 0 -5 0v.5", "key": "svg-4" }]]);

var IconBrandMatrix$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMatrix
});

var IconBrandMcdonalds = createReactComponent("outline", "brand-mcdonalds", "IconBrandMcdonalds", [["path", { "d": "M20 20c0 -3.952 -.966 -16 -4.038 -16s-3.962 9.087 -3.962 14.756c0 -5.669 -.896 -14.756 -3.962 -14.756c-3.065 0 -4.038 12.048 -4.038 16", "key": "svg-0" }]]);

var IconBrandMcdonalds$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMcdonalds
});

var IconBrandMedium = createReactComponent("outline", "brand-medium", "IconBrandMedium", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 9h1l3 3l3 -3h1", "key": "svg-1" }], ["path", { "d": "M8 15l2 0", "key": "svg-2" }], ["path", { "d": "M14 15l2 0", "key": "svg-3" }], ["path", { "d": "M9 9l0 6", "key": "svg-4" }], ["path", { "d": "M15 9l0 6", "key": "svg-5" }]]);

var IconBrandMedium$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMedium
});

var IconBrandMeetup = createReactComponent("outline", "brand-meetup", "IconBrandMeetup", [["path", { "d": "M5.455 10.82c.935 -2.163 3.045 -3.82 5.545 -3.82c2.104 0 2.844 1.915 2 4l-2 6", "key": "svg-0" }], ["path", { "d": "M6.981 7l-3.981 9.914", "key": "svg-1" }], ["path", { "d": "M13 11c.937 -2.16 3.071 -3.802 5.42 -3.972c2.104 0 3.128 1.706 2.284 3.792l-2.454 6.094c-.853 1.676 .75 2.586 2.75 2.086", "key": "svg-2" }]]);

var IconBrandMeetup$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMeetup
});

var IconBrandMercedes = createReactComponent("outline", "brand-mercedes", "IconBrandMercedes", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 3v9", "key": "svg-1" }], ["path", { "d": "M12 12l7 5", "key": "svg-2" }], ["path", { "d": "M12 12l-7 5", "key": "svg-3" }]]);

var IconBrandMercedes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMercedes
});

var IconBrandMessenger = createReactComponent("outline", "brand-messenger", "IconBrandMessenger", [["path", { "d": "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1", "key": "svg-0" }], ["path", { "d": "M8 13l3 -2l2 2l3 -2", "key": "svg-1" }]]);

var IconBrandMessenger$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMessenger
});

var IconBrandMeta = createReactComponent("outline", "brand-meta", "IconBrandMeta", [["path", { "d": "M12 10.174c1.766 -2.784 3.315 -4.174 4.648 -4.174c2 0 3.263 2.213 4 5.217c.704 2.869 .5 6.783 -2 6.783c-1.114 0 -2.648 -1.565 -4.148 -3.652a27.627 27.627 0 0 1 -2.5 -4.174z", "key": "svg-0" }], ["path", { "d": "M12 10.174c-1.766 -2.784 -3.315 -4.174 -4.648 -4.174c-2 0 -3.263 2.213 -4 5.217c-.704 2.869 -.5 6.783 2 6.783c1.114 0 2.648 -1.565 4.148 -3.652c1 -1.391 1.833 -2.783 2.5 -4.174z", "key": "svg-1" }]]);

var IconBrandMeta$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMeta
});

var IconBrandMetabrainz = createReactComponent("outline", "brand-metabrainz", "IconBrandMetabrainz", [["path", { "d": "M3 7v10l7 4v-18z", "key": "svg-0" }], ["path", { "d": "M21 7v10l-7 4v-18z", "key": "svg-1" }]]);

var IconBrandMetabrainz$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMetabrainz
});

var IconBrandMinecraft = createReactComponent("outline", "brand-minecraft", "IconBrandMinecraft", [["path", { "d": "M21 16.008v-8.018a1.98 1.98 0 0 0 -1 -1.717l-7 -4.008a2.016 2.016 0 0 0 -2 0l-7 4.008c-.619 .355 -1 1.01 -1 1.718v8.018c0 .709 .381 1.363 1 1.717l7 4.008c.62 .354 1.38 .354 2 0l7 -4.008c.619 -.355 1 -1.01 1 -1.718z", "key": "svg-0" }], ["path", { "d": "M12 22v-10", "key": "svg-1" }], ["path", { "d": "M12 12l8.73 -5.04", "key": "svg-2" }], ["path", { "d": "M3.27 6.96l8.73 5.04", "key": "svg-3" }], ["path", { "d": "M12 17l3.003 -1.668m3 -1.667l2.997 -1.665m-9 5l-9 -5", "key": "svg-4" }], ["path", { "d": "M15 17l3 -1.67v-3l-3 1.67z", "key": "svg-5" }]]);

var IconBrandMinecraft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMinecraft
});

var IconBrandMiniprogram = createReactComponent("outline", "brand-miniprogram", "IconBrandMiniprogram", [["path", { "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z", "key": "svg-0" }], ["path", { "d": "M8 11.503a2.5 2.5 0 1 0 4 2v-3a2.5 2.5 0 1 1 4 2", "key": "svg-1" }]]);

var IconBrandMiniprogram$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMiniprogram
});

var IconBrandMixpanel = createReactComponent("outline", "brand-mixpanel", "IconBrandMixpanel", [["path", { "d": "M4.5 12m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-0" }], ["path", { "d": "M20.5 12m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0", "key": "svg-1" }], ["path", { "d": "M13 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }]]);

var IconBrandMixpanel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMixpanel
});

var IconBrandMonday = createReactComponent("outline", "brand-monday", "IconBrandMonday", [["path", { "d": "M19.5 15.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0", "key": "svg-0" }], ["path", { "d": "M9.5 7a1.5 1.5 0 0 1 1.339 2.177l-4.034 7.074c-.264 .447 -.75 .749 -1.305 .749a1.5 1.5 0 0 1 -1.271 -2.297l3.906 -6.827a1.5 1.5 0 0 1 1.365 -.876z", "key": "svg-1" }], ["path", { "d": "M16.5 7a1.5 1.5 0 0 1 1.339 2.177l-4.034 7.074c-.264 .447 -.75 .749 -1.305 .749a1.5 1.5 0 0 1 -1.271 -2.297l3.906 -6.827a1.5 1.5 0 0 1 1.365 -.876z", "key": "svg-2" }]]);

var IconBrandMonday$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMonday
});

var IconBrandMongodb = createReactComponent("outline", "brand-mongodb", "IconBrandMongodb", [["path", { "d": "M12 3v19", "key": "svg-0" }], ["path", { "d": "M18 11.227c0 3.273 -1.812 4.77 -6 9.273c-4.188 -4.503 -6 -6 -6 -9.273c0 -4.454 3.071 -6.927 6 -9.227c2.929 2.3 6 4.773 6 9.227z", "key": "svg-1" }]]);

var IconBrandMongodb$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMongodb
});

var IconBrandMyOppo = createReactComponent("outline", "brand-my-oppo", "IconBrandMyOppo", [["path", { "d": "M18.316 5h-12.632l-3.418 4.019a1.089 1.089 0 0 0 .019 1.447l9.714 10.534l9.715 -10.49a1.09 1.09 0 0 0 .024 -1.444l-3.422 -4.066z", "key": "svg-0" }], ["path", { "d": "M9 11l3 3l3 -3", "key": "svg-1" }]]);

var IconBrandMyOppo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMyOppo
});

var IconBrandMysql = createReactComponent("outline", "brand-mysql", "IconBrandMysql", [["path", { "d": "M13 21c-1.427 -1.026 -3.59 -3.854 -4 -6c-.486 .77 -1.501 2 -2 2c-1.499 -.888 -.574 -3.973 0 -6c-1.596 -1.433 -2.468 -2.458 -2.5 -4c-3.35 -3.44 -.444 -5.27 2.5 -3h1c8.482 .5 6.421 8.07 9 11.5c2.295 .522 3.665 2.254 5 3.5c-2.086 -.2 -2.784 -.344 -3.5 0c.478 1.64 2.123 2.2 3.5 3", "key": "svg-0" }], ["path", { "d": "M9 7h.01", "key": "svg-1" }]]);

var IconBrandMysql$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMysql
});

var IconBrandNationalGeographic = createReactComponent("outline", "brand-national-geographic", "IconBrandNationalGeographic", [["path", { "d": "M7 3h10v18h-10z", "key": "svg-0" }]]);

var IconBrandNationalGeographic$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNationalGeographic
});

var IconBrandNem = createReactComponent("outline", "brand-nem", "IconBrandNem", [["path", { "d": "M12.182 2c1.94 .022 3.879 .382 5.818 1.08l.364 .135a23.075 23.075 0 0 1 3.636 1.785c0 5.618 -1.957 10.258 -5.87 13.92c-1.24 1.239 -2.5 2.204 -3.78 2.898l-.35 .182c-1.4 -.703 -2.777 -1.729 -4.13 -3.079c-3.912 -3.663 -5.87 -8.303 -5.87 -13.921c2.545 -1.527 5.09 -2.471 7.636 -2.832l.364 -.048a16.786 16.786 0 0 1 1.818 -.12h.364z", "key": "svg-0" }], ["path", { "d": "M2.1 7.07c2.073 6.72 5.373 7.697 9.9 2.93c0 -4 1.357 -6.353 4.07 -7.06l.59 -.11", "key": "svg-1" }], ["path", { "d": "M16.35 18.51s2.65 -5.51 -4.35 -8.51", "key": "svg-2" }]]);

var IconBrandNem$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNem
});

var IconBrandNetbeans = createReactComponent("outline", "brand-netbeans", "IconBrandNetbeans", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M15.5 9.43a1 1 0 0 1 .5 .874v3.268a1 1 0 0 1 -.515 .874l-3 1.917a1 1 0 0 1 -.97 0l-3 -1.917a1 1 0 0 1 -.515 -.873v-3.269a1 1 0 0 1 .514 -.874l3 -1.786c.311 -.173 .69 -.173 1 0l3 1.787h-.014z", "key": "svg-1" }], ["path", { "d": "M12 21v-9l-7.5 -4.5", "key": "svg-2" }], ["path", { "d": "M12 12l7.5 -4.5", "key": "svg-3" }], ["path", { "d": "M12 3v4.5", "key": "svg-4" }], ["path", { "d": "M19.5 16l-3.5 -2", "key": "svg-5" }], ["path", { "d": "M8 14l-3.5 2", "key": "svg-6" }]]);

var IconBrandNetbeans$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNetbeans
});

var IconBrandNeteaseMusic = createReactComponent("outline", "brand-netease-music", "IconBrandNeteaseMusic", [["path", { "d": "M9 4c-2.93 1.346 -5 5.046 -5 8.492c0 4.508 4 7.508 8 7.508s8 -3 8 -7c0 -3.513 -3.5 -5.513 -6 -5.513s-5 1.513 -5 4.513c0 2 1.5 3 3 3s3 -1 3 -3c0 -3.513 -2 -4.508 -2 -6.515c0 -3.504 3.5 -2.603 4 -1.502", "key": "svg-0" }]]);

var IconBrandNeteaseMusic$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNeteaseMusic
});

var IconBrandNetflix = createReactComponent("outline", "brand-netflix", "IconBrandNetflix", [["path", { "d": "M9 3l10 18h-4l-10 -18z", "key": "svg-0" }], ["path", { "d": "M5 3v18h4v-10.5", "key": "svg-1" }], ["path", { "d": "M19 21v-18h-4v10.5", "key": "svg-2" }]]);

var IconBrandNetflix$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNetflix
});

var IconBrandNexo = createReactComponent("outline", "brand-nexo", "IconBrandNexo", [["path", { "d": "M17 3l5 3v12l-5 3l-10 -6v-6l10 6v-6l-5 -3z", "key": "svg-0" }], ["path", { "d": "M12 6l-5 -3l-5 3v12l5 3l4.7 -3.13", "key": "svg-1" }]]);

var IconBrandNexo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNexo
});

var IconBrandNextcloud = createReactComponent("outline", "brand-nextcloud", "IconBrandNextcloud", [["path", { "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M4.5 12.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-1" }], ["path", { "d": "M19.5 12.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-2" }]]);

var IconBrandNextcloud$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNextcloud
});

var IconBrandNextjs = createReactComponent("outline", "brand-nextjs", "IconBrandNextjs", [["path", { "d": "M9 15v-6l7.745 10.65a9 9 0 1 1 2.255 -1.993", "key": "svg-0" }], ["path", { "d": "M15 12v-3", "key": "svg-1" }]]);

var IconBrandNextjs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNextjs
});

var IconBrandNodejs = createReactComponent("outline", "brand-nodejs", "IconBrandNodejs", [["path", { "d": "M9 9v8.044a2 2 0 0 1 -2.996 1.734l-1.568 -.9a3 3 0 0 1 -1.436 -2.561v-6.635a3 3 0 0 1 1.436 -2.56l6 -3.667a3 3 0 0 1 3.128 0l6 3.667a3 3 0 0 1 1.436 2.561v6.634a3 3 0 0 1 -1.436 2.56l-6 3.667a3 3 0 0 1 -3.128 0", "key": "svg-0" }], ["path", { "d": "M17 9h-3.5a1.5 1.5 0 0 0 0 3h2a1.5 1.5 0 0 1 0 3h-3.5", "key": "svg-1" }]]);

var IconBrandNodejs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNodejs
});

var IconBrandNordVpn = createReactComponent("outline", "brand-nord-vpn", "IconBrandNordVpn", [["path", { "d": "M9.992 15l-2.007 -3l-4.015 8c-2.212 -3.061 -2.625 -7.098 -.915 -10.463a10.14 10.14 0 0 1 8.945 -5.537a10.14 10.14 0 0 1 8.945 5.537c1.71 3.365 1.297 7.402 -.915 10.463l-4.517 -8l-1.505 1.5", "key": "svg-0" }], ["path", { "d": "M14.5 15l-3 -6l-2.5 4.5", "key": "svg-1" }]]);

var IconBrandNordVpn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNordVpn
});

var IconBrandNotion = createReactComponent("outline", "brand-notion", "IconBrandNotion", [["path", { "d": "M11 17.5v-6.5h.5l4 6h.5v-6.5", "key": "svg-0" }], ["path", { "d": "M19.077 20.071l-11.53 .887a1 1 0 0 1 -.876 -.397l-2.471 -3.294a1 1 0 0 1 -.2 -.6v-10.741a1 1 0 0 1 .923 -.997l11.389 -.876a2 2 0 0 1 1.262 .33l1.535 1.023a2 2 0 0 1 .891 1.664v12.004a1 1 0 0 1 -.923 .997z", "key": "svg-1" }], ["path", { "d": "M4.5 5.5l2.5 2.5", "key": "svg-2" }], ["path", { "d": "M20 7l-13 1v12.5", "key": "svg-3" }]]);

var IconBrandNotion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNotion
});

var IconBrandNpm = createReactComponent("outline", "brand-npm", "IconBrandNpm", [["path", { "d": "M1 8h22v7h-12v2h-4v-2h-6z", "key": "svg-0" }], ["path", { "d": "M7 8v7", "key": "svg-1" }], ["path", { "d": "M14 8v7", "key": "svg-2" }], ["path", { "d": "M17 11v4", "key": "svg-3" }], ["path", { "d": "M4 11v4", "key": "svg-4" }], ["path", { "d": "M11 11v1", "key": "svg-5" }], ["path", { "d": "M20 11v4", "key": "svg-6" }]]);

var IconBrandNpm$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNpm
});

var IconBrandNuxt = createReactComponent("outline", "brand-nuxt", "IconBrandNuxt", [["path", { "d": "M12.146 8.583l-1.3 -2.09a1.046 1.046 0 0 0 -1.786 .017l-5.91 9.908a1.046 1.046 0 0 0 .897 1.582h3.913", "key": "svg-0" }], ["path", { "d": "M20.043 18c.743 0 1.201 -.843 .82 -1.505l-4.044 -7.013a.936 .936 0 0 0 -1.638 0l-4.043 7.013c-.382 .662 .076 1.505 .819 1.505h8.086z", "key": "svg-1" }]]);

var IconBrandNuxt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNuxt
});

var IconBrandNytimes = createReactComponent("outline", "brand-nytimes", "IconBrandNytimes", [["path", { "d": "M11.036 5.058a8 8 0 1 0 8.706 9.965", "key": "svg-0" }], ["path", { "d": "M12 21v-11l-7.5 4", "key": "svg-1" }], ["path", { "d": "M17.5 3a2.5 2.5 0 1 1 0 5l-11 -5a2.5 2.5 0 0 0 -.67 4.91", "key": "svg-2" }], ["path", { "d": "M9 12v8", "key": "svg-3" }], ["path", { "d": "M16 13h-.01", "key": "svg-4" }]]);

var IconBrandNytimes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandNytimes
});

var IconBrandOauth = createReactComponent("outline", "brand-oauth", "IconBrandOauth", [["path", { "d": "M12 12m-10 0a10 10 0 1 0 20 0a10 10 0 1 0 -20 0", "key": "svg-0" }], ["path", { "d": "M12.556 6c.65 0 1.235 .373 1.508 .947l2.839 7.848a1.646 1.646 0 0 1 -1.01 2.108a1.673 1.673 0 0 1 -2.068 -.851l-.46 -1.052h-2.73l-.398 .905a1.67 1.67 0 0 1 -1.977 1.045l-.153 -.047a1.647 1.647 0 0 1 -1.056 -1.956l2.824 -7.852a1.664 1.664 0 0 1 1.409 -1.087l1.272 -.008z", "key": "svg-1" }]]);

var IconBrandOauth$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandOauth
});

var IconBrandOffice = createReactComponent("outline", "brand-office", "IconBrandOffice", [["path", { "d": "M4 18h9v-12l-5 2v5l-4 2v-8l9 -4l7 2v13l-7 3z", "key": "svg-0" }]]);

var IconBrandOffice$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandOffice
});

var IconBrandOkRu = createReactComponent("outline", "brand-ok-ru", "IconBrandOkRu", [["path", { "d": "M12 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M20 12c0 8 0 8 -8 8s-8 0 -8 -8s0 -8 8 -8s8 0 8 8z", "key": "svg-1" }], ["path", { "d": "M9.5 13c1.333 .667 3.667 .667 5 0", "key": "svg-2" }], ["path", { "d": "M9.5 17l2.5 -3l2.5 3", "key": "svg-3" }], ["path", { "d": "M12 13.5v.5", "key": "svg-4" }]]);

var IconBrandOkRu$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandOkRu
});

var IconBrandOnedrive = createReactComponent("outline", "brand-onedrive", "IconBrandOnedrive", [["path", { "d": "M18.456 10.45a6.45 6.45 0 0 0 -12 -2.151a4.857 4.857 0 0 0 -4.44 5.241a4.856 4.856 0 0 0 5.236 4.444h10.751a3.771 3.771 0 0 0 3.99 -3.54a3.772 3.772 0 0 0 -3.538 -3.992z", "key": "svg-0" }]]);

var IconBrandOnedrive$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandOnedrive
});

var IconBrandOnlyfans = createReactComponent("outline", "brand-onlyfans", "IconBrandOnlyfans", [["path", { "d": "M8.5 6a6.5 6.5 0 1 0 0 13a6.5 6.5 0 0 0 0 -13z", "key": "svg-0" }], ["path", { "d": "M8.5 15a2.5 2.5 0 1 1 0 -5a2.5 2.5 0 0 1 0 5z", "key": "svg-1" }], ["path", { "d": "M14 16c2.5 0 6.42 -1.467 7 -4h-6c3 -1 6.44 -3.533 7 -6h-4c-3.03 0 -3.764 -.196 -5 1.5", "key": "svg-2" }]]);

var IconBrandOnlyfans$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandOnlyfans
});

var IconBrandOpenSource = createReactComponent("outline", "brand-open-source", "IconBrandOpenSource", [["path", { "d": "M12 3a9 9 0 0 1 3.618 17.243l-2.193 -5.602a3 3 0 1 0 -2.849 0l-2.193 5.603a9 9 0 0 1 3.617 -17.244z", "key": "svg-0" }]]);

var IconBrandOpenSource$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandOpenSource
});

var IconBrandOpenai = createReactComponent("outline", "brand-openai", "IconBrandOpenai", [["path", { "d": "M11.217 19.384a3.501 3.501 0 0 0 6.783 -1.217v-5.167l-6 -3.35", "key": "svg-0" }], ["path", { "d": "M5.214 15.014a3.501 3.501 0 0 0 4.446 5.266l4.34 -2.534v-6.946", "key": "svg-1" }], ["path", { "d": "M6 7.63c-1.391 -.236 -2.787 .395 -3.534 1.689a3.474 3.474 0 0 0 1.271 4.745l4.263 2.514l6 -3.348", "key": "svg-2" }], ["path", { "d": "M12.783 4.616a3.501 3.501 0 0 0 -6.783 1.217v5.067l6 3.45", "key": "svg-3" }], ["path", { "d": "M18.786 8.986a3.501 3.501 0 0 0 -4.446 -5.266l-4.34 2.534v6.946", "key": "svg-4" }], ["path", { "d": "M18 16.302c1.391 .236 2.787 -.395 3.534 -1.689a3.474 3.474 0 0 0 -1.271 -4.745l-4.308 -2.514l-5.955 3.42", "key": "svg-5" }]]);

var IconBrandOpenai$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandOpenai
});

var IconBrandOpenvpn = createReactComponent("outline", "brand-openvpn", "IconBrandOpenvpn", [["path", { "d": "M15.618 20.243l-2.193 -5.602a3 3 0 1 0 -2.849 0l-2.193 5.603", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconBrandOpenvpn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandOpenvpn
});

var IconBrandOpera = createReactComponent("outline", "brand-opera", "IconBrandOpera", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-3 0a3 5 0 1 0 6 0a3 5 0 1 0 -6 0", "key": "svg-1" }]]);

var IconBrandOpera$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandOpera
});

var IconBrandPagekit = createReactComponent("outline", "brand-pagekit", "IconBrandPagekit", [["path", { "d": "M12.077 20h-5.077v-16h11v14h-5.077", "key": "svg-0" }]]);

var IconBrandPagekit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPagekit
});

var IconBrandParsinta = createReactComponent("outline", "brand-parsinta", "IconBrandParsinta", [["path", { "d": "M12 3a9 9 0 1 0 9 9", "key": "svg-0" }], ["path", { "d": "M21 12a9 9 0 0 0 -9 -9", "opacity": ".5", "key": "svg-1" }], ["path", { "d": "M10 9v6l5 -3z", "key": "svg-2" }]]);

var IconBrandParsinta$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandParsinta
});

var IconBrandPatreon = createReactComponent("outline", "brand-patreon", "IconBrandPatreon", [["path", { "d": "M20 8.408c-.003 -2.299 -1.746 -4.182 -3.79 -4.862c-2.54 -.844 -5.888 -.722 -8.312 .453c-2.939 1.425 -3.862 4.545 -3.896 7.656c-.028 2.559 .22 9.297 3.92 9.345c2.75 .036 3.159 -3.603 4.43 -5.356c.906 -1.247 2.071 -1.599 3.506 -1.963c2.465 -.627 4.146 -2.626 4.142 -5.273z", "key": "svg-0" }]]);

var IconBrandPatreon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPatreon
});

var IconBrandPaypal = createReactComponent("outline", "brand-paypal", "IconBrandPaypal", [["path", { "d": "M10 13l2.5 0c2.5 0 5 -2.5 5 -5c0 -3 -1.9 -5 -5 -5h-5.5c-.5 0 -1 .5 -1 1l-2 14c0 .5 .5 1 1 1h2.8l1.2 -5c.1 -.6 .4 -1 1 -1zm7.5 -5.8c1.7 1 2.5 2.8 2.5 4.8c0 2.5 -2.5 4.5 -5 4.5h-2.6l-.6 3.6a1 1 0 0 1 -1 .8l-2.7 0a.5 .5 0 0 1 -.5 -.6l.2 -1.4", "key": "svg-0" }]]);

var IconBrandPaypal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPaypal
});

var IconBrandPaypay = createReactComponent("outline", "brand-paypay", "IconBrandPaypay", [["path", { "d": "M6.375 21l3.938 -13.838", "key": "svg-0" }], ["path", { "d": "M3 6c16.731 0 21.231 9.881 4.5 11", "key": "svg-1" }], ["path", { "d": "M21 19v-14a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2z", "key": "svg-2" }]]);

var IconBrandPaypay$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPaypay
});

var IconBrandPeanut = createReactComponent("outline", "brand-peanut", "IconBrandPeanut", [["path", { "d": "M15 16.25l-.816 -.36l-.462 -.196c-1.444 -.592 -2 -.593 -3.447 0l-.462 .195l-.817 .359a4.5 4.5 0 1 1 0 -8.49v0l1.054 .462l.434 .178c1.292 .507 1.863 .48 3.237 -.082l.462 -.195l.817 -.359a4.5 4.5 0 1 1 0 8.49", "key": "svg-0" }]]);

var IconBrandPeanut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPeanut
});

var IconBrandPepsi = createReactComponent("outline", "brand-pepsi", "IconBrandPepsi", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M4 16c5.713 -2.973 11 -3.5 13.449 -11.162", "key": "svg-1" }], ["path", { "d": "M5 17.5c5.118 -2.859 15 0 14 -11", "key": "svg-2" }]]);

var IconBrandPepsi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPepsi
});

var IconBrandPhp = createReactComponent("outline", "brand-php", "IconBrandPhp", [["path", { "d": "M12 12m-10 0a10 9 0 1 0 20 0a10 9 0 1 0 -20 0", "key": "svg-0" }], ["path", { "d": "M5.5 15l.395 -1.974l.605 -3.026h1.32a1 1 0 0 1 .986 1.164l-.167 1a1 1 0 0 1 -.986 .836h-1.653", "key": "svg-1" }], ["path", { "d": "M15.5 15l.395 -1.974l.605 -3.026h1.32a1 1 0 0 1 .986 1.164l-.167 1a1 1 0 0 1 -.986 .836h-1.653", "key": "svg-2" }], ["path", { "d": "M12 7.5l-1 5.5", "key": "svg-3" }], ["path", { "d": "M11.6 10h2.4l-.5 3", "key": "svg-4" }]]);

var IconBrandPhp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPhp
});

var IconBrandPicsart = createReactComponent("outline", "brand-picsart", "IconBrandPicsart", [["path", { "d": "M12 9m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M12 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M5 9v11a2 2 0 1 0 4 0v-4.5", "key": "svg-2" }]]);

var IconBrandPicsart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPicsart
});

var IconBrandPinterest = createReactComponent("outline", "brand-pinterest", "IconBrandPinterest", [["path", { "d": "M8 20l4 -9", "key": "svg-0" }], ["path", { "d": "M10.7 14c.437 1.263 1.43 2 2.55 2c2.071 0 3.75 -1.554 3.75 -4a5 5 0 1 0 -9.7 1.7", "key": "svg-1" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-2" }]]);

var IconBrandPinterest$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPinterest
});

var IconBrandPlanetscale = createReactComponent("outline", "brand-planetscale", "IconBrandPlanetscale", [["path", { "d": "M20.993 11.63a9 9 0 0 1 -9.362 9.362l9.362 -9.362z", "key": "svg-0" }], ["path", { "d": "M12 3a9.001 9.001 0 0 1 8.166 5.211l-11.955 11.955a9 9 0 0 1 3.789 -17.166z", "key": "svg-1" }], ["path", { "d": "M12 12l-6 6", "key": "svg-2" }]]);

var IconBrandPlanetscale$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPlanetscale
});

var IconBrandPnpm = createReactComponent("outline", "brand-pnpm", "IconBrandPnpm", [["path", { "d": "M3 17h4v4h-4z", "key": "svg-0" }], ["path", { "d": "M10 17h4v4h-4z", "key": "svg-1" }], ["path", { "d": "M17 17h4v4h-4z", "key": "svg-2" }], ["path", { "d": "M17 10h4v4h-4z", "key": "svg-3" }], ["path", { "d": "M17 3h4v4h-4z", "key": "svg-4" }], ["path", { "d": "M10 10h4v4h-4z", "key": "svg-5" }], ["path", { "d": "M10 3h4v4h-4z", "key": "svg-6" }], ["path", { "d": "M3 3h4v4h-4z", "key": "svg-7" }]]);

var IconBrandPnpm$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPnpm
});

var IconBrandPocket = createReactComponent("outline", "brand-pocket", "IconBrandPocket", [["path", { "d": "M5 4h14a2 2 0 0 1 2 2v6a9 9 0 0 1 -18 0v-6a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M8 11l4 4l4 -4", "key": "svg-1" }]]);

var IconBrandPocket$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPocket
});

var IconBrandPolymer = createReactComponent("outline", "brand-polymer", "IconBrandPolymer", [["path", { "d": "M6.706 6l-3.706 6l3.706 6h1.059l8.47 -12h1.06l3.705 6l-3.706 6", "key": "svg-0" }]]);

var IconBrandPolymer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPolymer
});

var IconBrandPowershell = createReactComponent("outline", "brand-powershell", "IconBrandPowershell", [["path", { "d": "M4.887 20h11.868c.893 0 1.664 -.665 1.847 -1.592l2.358 -12c.212 -1.081 -.442 -2.14 -1.462 -2.366a1.784 1.784 0 0 0 -.385 -.042h-11.868c-.893 0 -1.664 .665 -1.847 1.592l-2.358 12c-.212 1.081 .442 2.14 1.462 2.366c.127 .028 .256 .042 .385 .042z", "key": "svg-0" }], ["path", { "d": "M9 8l4 4l-6 4", "key": "svg-1" }], ["path", { "d": "M12 16h3", "key": "svg-2" }]]);

var IconBrandPowershell$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPowershell
});

var IconBrandPrintables = createReactComponent("outline", "brand-printables", "IconBrandPrintables", [["path", { "d": "M6 21l12 -7v-7.5l-6 -3.5l-6 3.5l6 3.5v7.5l-6 -3.5z", "key": "svg-0" }]]);

var IconBrandPrintables$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPrintables
});

var IconBrandPrisma = createReactComponent("outline", "brand-prisma", "IconBrandPrisma", [["path", { "d": "M4.186 16.202l3.615 5.313c.265 .39 .754 .57 1.215 .447l10.166 -2.718a1.086 1.086 0 0 0 .713 -1.511l-7.505 -15.483a.448 .448 0 0 0 -.787 -.033l-7.453 12.838a1.07 1.07 0 0 0 .037 1.147z", "key": "svg-0" }], ["path", { "d": "M8.5 22l3.5 -20", "key": "svg-1" }]]);

var IconBrandPrisma$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPrisma
});

var IconBrandProducthunt = createReactComponent("outline", "brand-producthunt", "IconBrandProducthunt", [["path", { "d": "M10 16v-8h2.5a2.5 2.5 0 1 1 0 5h-2.5", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconBrandProducthunt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandProducthunt
});

var IconBrandPushbullet = createReactComponent("outline", "brand-pushbullet", "IconBrandPushbullet", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M11 8v8h2a4 4 0 1 0 0 -8h-2z", "key": "svg-1" }], ["path", { "d": "M8 8v8", "key": "svg-2" }]]);

var IconBrandPushbullet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPushbullet
});

var IconBrandPushover = createReactComponent("outline", "brand-pushover", "IconBrandPushover", [["path", { "d": "M6.16 10.985c-.83 -1.935 1.53 -7.985 8.195 -7.985c3.333 0 4.645 1.382 4.645 3.9c0 2.597 -2.612 6.1 -9 6.1", "key": "svg-0" }], ["path", { "d": "M12.5 6l-5.5 15", "key": "svg-1" }]]);

var IconBrandPushover$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPushover
});

var IconBrandPython = createReactComponent("outline", "brand-python", "IconBrandPython", [["path", { "d": "M12 9h-7a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3", "key": "svg-0" }], ["path", { "d": "M12 15h7a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-3", "key": "svg-1" }], ["path", { "d": "M8 9v-4a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v5a2 2 0 0 1 -2 2h-4a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4", "key": "svg-2" }], ["path", { "d": "M11 6l0 .01", "key": "svg-3" }], ["path", { "d": "M13 18l0 .01", "key": "svg-4" }]]);

var IconBrandPython$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPython
});

var IconBrandQq = createReactComponent("outline", "brand-qq", "IconBrandQq", [["path", { "d": "M6 9.748a14.716 14.716 0 0 0 11.995 -.052c.275 -9.236 -11.104 -11.256 -11.995 .052z", "key": "svg-0" }], ["path", { "d": "M18 10c.984 2.762 1.949 4.765 2 7.153c.014 .688 -.664 1.346 -1.184 .303c-.346 -.696 -.952 -1.181 -1.816 -1.456", "key": "svg-1" }], ["path", { "d": "M17 16c.031 1.831 .147 3.102 -1 4", "key": "svg-2" }], ["path", { "d": "M8 20c-1.099 -.87 -.914 -2.24 -1 -4", "key": "svg-3" }], ["path", { "d": "M6 10c-.783 2.338 -1.742 4.12 -1.968 6.43c-.217 2.227 .716 1.644 1.16 .917c.296 -.487 .898 -.934 1.808 -1.347", "key": "svg-4" }], ["path", { "d": "M15.898 13l-.476 -2", "key": "svg-5" }], ["path", { "d": "M8 20l-1.5 1c-.5 .5 -.5 1 .5 1h10c1 0 1 -.5 .5 -1l-1.5 -1", "key": "svg-6" }], ["path", { "d": "M13.75 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-7" }], ["path", { "d": "M10.25 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-8" }]]);

var IconBrandQq$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandQq
});

var IconBrandRadixUi = createReactComponent("outline", "brand-radix-ui", "IconBrandRadixUi", [["path", { "d": "M16.5 5.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-0" }], ["path", { "d": "M6 3h5v5h-5z", "key": "svg-1" }], ["path", { "d": "M11 11v10a5 5 0 0 1 -.217 -9.995l.217 -.005z", "key": "svg-2" }]]);

var IconBrandRadixUi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandRadixUi
});

var IconBrandReactNative = createReactComponent("outline", "brand-react-native", "IconBrandReactNative", [["path", { "d": "M6.357 9c-2.637 .68 -4.357 1.845 -4.357 3.175c0 2.107 4.405 3.825 9.85 3.825c.74 0 1.26 -.039 1.95 -.097", "key": "svg-0" }], ["path", { "d": "M9.837 15.9c-.413 -.596 -.806 -1.133 -1.18 -1.8c-2.751 -4.9 -3.488 -9.77 -1.63 -10.873c1.15 -.697 3.047 .253 4.974 2.254", "key": "svg-1" }], ["path", { "d": "M6.429 15.387c-.702 2.688 -.56 4.716 .56 5.395c1.783 1.08 5.387 -1.958 8.043 -6.804c.36 -.67 .683 -1.329 .968 -1.978", "key": "svg-2" }], ["path", { "d": "M12 18.52c1.928 2 3.817 2.95 4.978 2.253c1.85 -1.102 1.121 -5.972 -1.633 -10.873c-.384 -.677 -.777 -1.204 -1.18 -1.8", "key": "svg-3" }], ["path", { "d": "M17.66 15c2.612 -.687 4.34 -1.85 4.34 -3.176c0 -2.11 -4.408 -3.824 -9.845 -3.824c-.747 0 -1.266 .029 -1.955 .087", "key": "svg-4" }], ["path", { "d": "M8 12c.285 -.66 .607 -1.308 .968 -1.978c2.647 -4.844 6.253 -7.89 8.046 -6.801c1.11 .679 1.262 2.706 .56 5.393", "key": "svg-5" }], ["path", { "d": "M12.26 12.015h-.01c-.01 .13 -.12 .24 -.26 .24a.263 .263 0 0 1 -.25 -.26c0 -.14 .11 -.25 .24 -.25h-.01c.13 -.01 .25 .11 .25 .24", "key": "svg-6" }]]);

var IconBrandReactNative$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandReactNative
});

var IconBrandReact = createReactComponent("outline", "brand-react", "IconBrandReact", [["path", { "d": "M6.306 8.711c-2.602 .723 -4.306 1.926 -4.306 3.289c0 2.21 4.477 4 10 4c.773 0 1.526 -.035 2.248 -.102", "key": "svg-0" }], ["path", { "d": "M17.692 15.289c2.603 -.722 4.308 -1.926 4.308 -3.289c0 -2.21 -4.477 -4 -10 -4c-.773 0 -1.526 .035 -2.25 .102", "key": "svg-1" }], ["path", { "d": "M6.305 15.287c-.676 2.615 -.485 4.693 .695 5.373c1.913 1.105 5.703 -1.877 8.464 -6.66c.387 -.67 .733 -1.339 1.036 -2", "key": "svg-2" }], ["path", { "d": "M17.694 8.716c.677 -2.616 .487 -4.696 -.694 -5.376c-1.913 -1.105 -5.703 1.877 -8.464 6.66c-.387 .67 -.733 1.34 -1.037 2", "key": "svg-3" }], ["path", { "d": "M12 5.424c-1.925 -1.892 -3.82 -2.766 -5 -2.084c-1.913 1.104 -1.226 5.877 1.536 10.66c.386 .67 .793 1.304 1.212 1.896", "key": "svg-4" }], ["path", { "d": "M12 18.574c1.926 1.893 3.821 2.768 5 2.086c1.913 -1.104 1.226 -5.877 -1.536 -10.66c-.375 -.65 -.78 -1.283 -1.212 -1.897", "key": "svg-5" }], ["path", { "d": "M11.5 12.866a1 1 0 1 0 1 -1.732a1 1 0 0 0 -1 1.732z", "key": "svg-6" }]]);

var IconBrandReact$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandReact
});

var IconBrandReason = createReactComponent("outline", "brand-reason", "IconBrandReason", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M18 18h-3v-6h3", "key": "svg-1" }], ["path", { "d": "M18 15h-3", "key": "svg-2" }], ["path", { "d": "M8 18v-6h2.5a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }], ["path", { "d": "M12 18l-2 -3", "key": "svg-4" }]]);

var IconBrandReason$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandReason
});

var IconBrandReddit = createReactComponent("outline", "brand-reddit", "IconBrandReddit", [["path", { "d": "M12 8c2.648 0 5.028 .826 6.675 2.14a2.5 2.5 0 0 1 2.326 4.36c0 3.59 -4.03 6.5 -9 6.5c-4.875 0 -8.845 -2.8 -9 -6.294l-1 -.206a2.5 2.5 0 0 1 2.326 -4.36c1.646 -1.313 4.026 -2.14 6.674 -2.14z", "key": "svg-0" }], ["path", { "d": "M12 8l1 -5l6 1", "key": "svg-1" }], ["path", { "d": "M19 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["circle", { "cx": "9", "cy": "13", "r": ".5", "fill": "currentColor", "key": "svg-3" }], ["circle", { "cx": "15", "cy": "13", "r": ".5", "fill": "currentColor", "key": "svg-4" }], ["path", { "d": "M10 17c.667 .333 1.333 .5 2 .5s1.333 -.167 2 -.5", "key": "svg-5" }]]);

var IconBrandReddit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandReddit
});

var IconBrandRedhat = createReactComponent("outline", "brand-redhat", "IconBrandRedhat", [["path", { "d": "M6 10.5l1.436 -4c.318 -.876 .728 -1.302 1.359 -1.302c.219 0 1.054 .365 1.88 .583c.825 .219 .733 -.329 .908 -.487c.176 -.158 .355 -.294 .61 -.294c.242 0 .553 .048 1.692 .448c.759 .267 1.493 .574 2.204 .922c1.175 .582 1.426 .913 1.595 1.507l.816 4.623c2.086 .898 3.5 2.357 3.5 3.682c0 1.685 -1.2 3.818 -5.957 3.818c-6.206 0 -14.043 -4.042 -14.043 -7.32c0 -1.044 1.333 -1.77 4 -2.18z", "key": "svg-0" }], ["path", { "d": "M6 10.5c0 .969 4.39 3.5 9.5 3.5c1.314 0 3 .063 3 -1.5", "key": "svg-1" }]]);

var IconBrandRedhat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandRedhat
});

var IconBrandRedux = createReactComponent("outline", "brand-redux", "IconBrandRedux", [["path", { "d": "M16.54 7c-.805 -2.365 -2.536 -4 -4.54 -4c-2.774 0 -5.023 2.632 -5.023 6.496c0 1.956 1.582 4.727 2.512 6", "key": "svg-0" }], ["path", { "d": "M4.711 11.979c-1.656 1.877 -2.214 4.185 -1.211 5.911c1.387 2.39 5.138 2.831 8.501 .9c1.703 -.979 2.875 -3.362 3.516 -4.798", "key": "svg-1" }], ["path", { "d": "M15.014 19.99c2.511 0 4.523 -.438 5.487 -2.1c1.387 -2.39 -.215 -5.893 -3.579 -7.824c-1.702 -.979 -4.357 -1.235 -5.927 -1.07", "key": "svg-2" }], ["path", { "d": "M10.493 9.862c.48 .276 1.095 .112 1.372 -.366a1 1 0 0 0 -.367 -1.365a1.007 1.007 0 0 0 -1.373 .366a1 1 0 0 0 .368 1.365z", "key": "svg-3" }], ["path", { "d": "M9.5 15.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["path", { "d": "M15.5 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-5" }]]);

var IconBrandRedux$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandRedux
});

var IconBrandRevolut = createReactComponent("outline", "brand-revolut", "IconBrandRevolut", [["path", { "d": "M5 10h3v10h-3z", "key": "svg-0" }], ["path", { "d": "M14.5 4h-9.5v3h9.4a1.5 1.5 0 0 1 0 3h-3.4v4l4 6h4l-5 -7h.5a4.5 4.5 0 1 0 0 -9z", "key": "svg-1" }]]);

var IconBrandRevolut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandRevolut
});

var IconBrandRumble = createReactComponent("outline", "brand-rumble", "IconBrandRumble", [["path", { "d": "M19.993 9.108c.383 .4 .687 .863 .893 1.368a4.195 4.195 0 0 1 .006 3.166a4.37 4.37 0 0 1 -.887 1.372a20.233 20.233 0 0 1 -2.208 2a20.615 20.615 0 0 1 -2.495 1.669a21.322 21.322 0 0 1 -5.622 2.202a4.213 4.213 0 0 1 -3.002 -.404a3.98 3.98 0 0 1 -1.163 -.967a3.796 3.796 0 0 1 -.695 -1.312c-1.199 -3.902 -1.022 -8.312 .134 -12.23c.609 -2.057 2.643 -3.349 4.737 -2.874c3.88 .88 7.52 3.147 10.302 6.01z", "key": "svg-0" }], ["path", { "d": "M14.044 13.034c.67 -.505 .67 -1.489 0 -2.01a14.824 14.824 0 0 0 -1.498 -1.044a15.783 15.783 0 0 0 -1.62 -.865c-.77 -.35 -1.63 .139 -1.753 .973a15.385 15.385 0 0 0 -.1 3.786a1.232 1.232 0 0 0 1.715 1.027a14.783 14.783 0 0 0 1.694 -.827a14.46 14.46 0 0 0 1.562 -1.035v-.005z", "key": "svg-1" }]]);

var IconBrandRumble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandRumble
});

var IconBrandRust = createReactComponent("outline", "brand-rust", "IconBrandRust", [["path", { "d": "M10.139 3.463c.473 -1.95 3.249 -1.95 3.722 0a1.916 1.916 0 0 0 2.859 1.185c1.714 -1.045 3.678 .918 2.633 2.633a1.916 1.916 0 0 0 1.184 2.858c1.95 .473 1.95 3.249 0 3.722a1.916 1.916 0 0 0 -1.185 2.859c1.045 1.714 -.918 3.678 -2.633 2.633a1.916 1.916 0 0 0 -2.858 1.184c-.473 1.95 -3.249 1.95 -3.722 0a1.916 1.916 0 0 0 -2.859 -1.185c-1.714 1.045 -3.678 -.918 -2.633 -2.633a1.916 1.916 0 0 0 -1.184 -2.858c-1.95 -.473 -1.95 -3.249 0 -3.722a1.916 1.916 0 0 0 1.185 -2.859c-1.045 -1.714 .918 -3.678 2.633 -2.633a1.914 1.914 0 0 0 2.858 -1.184z", "key": "svg-0" }], ["path", { "d": "M8 12h6a2 2 0 1 0 0 -4h-6v8v-4z", "key": "svg-1" }], ["path", { "d": "M19 16h-2a2 2 0 0 1 -2 -2a2 2 0 0 0 -2 -2h-1", "key": "svg-2" }], ["path", { "d": "M9 8h-4", "key": "svg-3" }], ["path", { "d": "M5 16h4", "key": "svg-4" }]]);

var IconBrandRust$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandRust
});

var IconBrandSafari = createReactComponent("outline", "brand-safari", "IconBrandSafari", [["path", { "d": "M8 16l2 -6l6 -2l-2 6l-6 2", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconBrandSafari$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSafari
});

var IconBrandSamsungpass = createReactComponent("outline", "brand-samsungpass", "IconBrandSamsungpass", [["path", { "d": "M4 10m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 10v-1.862c0 -2.838 2.239 -5.138 5 -5.138s5 2.3 5 5.138v1.862", "key": "svg-1" }], ["path", { "d": "M10.485 17.577c.337 .29 .7 .423 1.515 .423h.413c.323 0 .633 -.133 .862 -.368a1.27 1.27 0 0 0 .356 -.886c0 -.332 -.128 -.65 -.356 -.886a1.203 1.203 0 0 0 -.862 -.368h-.826a1.2 1.2 0 0 1 -.861 -.367a1.27 1.27 0 0 1 -.356 -.886c0 -.332 .128 -.651 .356 -.886a1.2 1.2 0 0 1 .861 -.368h.413c.816 0 1.178 .133 1.515 .423", "key": "svg-2" }]]);

var IconBrandSamsungpass$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSamsungpass
});

var IconBrandSass = createReactComponent("outline", "brand-sass", "IconBrandSass", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 10.523c2.46 -.826 4 -.826 4 -2.155c0 -1.366 -1.347 -1.366 -2.735 -1.366c-1.91 0 -3.352 .49 -4.537 1.748c-.848 .902 -1.027 2.449 -.153 3.307c.973 .956 3.206 1.789 2.884 3.493c-.233 1.235 -1.469 1.823 -2.617 1.202c-.782 -.424 -.454 -1.746 .626 -2.512s2.822 -.992 4.1 -.24c.98 .575 1.046 1.724 .434 2.193", "key": "svg-1" }]]);

var IconBrandSass$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSass
});

var IconBrandSentry = createReactComponent("outline", "brand-sentry", "IconBrandSentry", [["path", { "d": "M3 18a1.93 1.93 0 0 0 .306 1.076a2 2 0 0 0 1.584 .924c.646 .033 -.537 0 .11 0h3a4.992 4.992 0 0 0 -3.66 -4.81c.558 -.973 1.24 -2.149 2.04 -3.531a9 9 0 0 1 5.62 8.341h4c.663 0 2.337 0 3 0a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-1.84 3.176c4.482 2.05 7.6 6.571 7.6 11.824", "key": "svg-0" }]]);

var IconBrandSentry$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSentry
});

var IconBrandSharik = createReactComponent("outline", "brand-sharik", "IconBrandSharik", [["path", { "d": "M4.281 16.606a8.968 8.968 0 0 1 1.363 -10.977a9.033 9.033 0 0 1 11.011 -1.346c-1.584 4.692 -2.415 6.96 -4.655 8.717c-1.584 1.242 -3.836 2.24 -7.719 3.606zm16.335 -7.306c2.113 7.59 -4.892 13.361 -11.302 11.264c1.931 -3.1 3.235 -4.606 4.686 -6.065c1.705 -1.715 3.591 -3.23 6.616 -5.199z", "key": "svg-0" }]]);

var IconBrandSharik$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSharik
});

var IconBrandShazam = createReactComponent("outline", "brand-shazam", "IconBrandShazam", [["path", { "d": "M10 12l2 -2a2.828 2.828 0 0 1 4 0a2.828 2.828 0 0 1 0 4l-3 3", "key": "svg-0" }], ["path", { "d": "M14 12l-2 2a2.828 2.828 0 1 1 -4 -4l3 -3", "key": "svg-1" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-2" }]]);

var IconBrandShazam$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandShazam
});

var IconBrandShopee = createReactComponent("outline", "brand-shopee", "IconBrandShopee", [["path", { "d": "M4 7l.867 12.143a2 2 0 0 0 2 1.857h10.276a2 2 0 0 0 2 -1.857l.867 -12.143h-16z", "key": "svg-0" }], ["path", { "d": "M8.5 7c0 -1.653 1.5 -4 3.5 -4s3.5 2.347 3.5 4", "key": "svg-1" }], ["path", { "d": "M9.5 17c.413 .462 1 1 2.5 1s2.5 -.897 2.5 -2s-1 -1.5 -2.5 -2s-2 -1.47 -2 -2c0 -1.104 1 -2 2 -2s1.5 0 2.5 1", "key": "svg-2" }]]);

var IconBrandShopee$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandShopee
});

var IconBrandSketch = createReactComponent("outline", "brand-sketch", "IconBrandSketch", [["path", { "d": "M3.262 10.878l8 8.789c.4 .44 1.091 .44 1.491 0l8 -8.79c.313 -.344 .349 -.859 .087 -1.243l-3.537 -5.194a1 1 0 0 0 -.823 -.436h-8.926a1 1 0 0 0 -.823 .436l-3.54 5.192c-.263 .385 -.227 .901 .087 1.246z", "key": "svg-0" }]]);

var IconBrandSketch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSketch
});

var IconBrandSkype = createReactComponent("outline", "brand-skype", "IconBrandSkype", [["path", { "d": "M12 3a9 9 0 0 1 8.603 11.65a4.5 4.5 0 0 1 -5.953 5.953a9 9 0 0 1 -11.253 -11.253a4.5 4.5 0 0 1 5.953 -5.954a8.987 8.987 0 0 1 2.65 -.396z", "key": "svg-0" }], ["path", { "d": "M8 14.5c.5 2 2.358 2.5 4 2.5c2.905 0 4 -1.187 4 -2.5c0 -1.503 -1.927 -2.5 -4 -2.5s-4 -1 -4 -2.5c0 -1.313 1.095 -2.5 4 -2.5c1.642 0 3.5 .5 4 2.5", "key": "svg-1" }]]);

var IconBrandSkype$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSkype
});

var IconBrandSlack = createReactComponent("outline", "brand-slack", "IconBrandSlack", [["path", { "d": "M12 12v-6a2 2 0 0 1 4 0v6m0 -2a2 2 0 1 1 2 2h-6", "key": "svg-0" }], ["path", { "d": "M12 12h6a2 2 0 0 1 0 4h-6m2 0a2 2 0 1 1 -2 2v-6", "key": "svg-1" }], ["path", { "d": "M12 12v6a2 2 0 0 1 -4 0v-6m0 2a2 2 0 1 1 -2 -2h6", "key": "svg-2" }], ["path", { "d": "M12 12h-6a2 2 0 0 1 0 -4h6m-2 0a2 2 0 1 1 2 -2v6", "key": "svg-3" }]]);

var IconBrandSlack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSlack
});

var IconBrandSnapchat = createReactComponent("outline", "brand-snapchat", "IconBrandSnapchat", [["path", { "d": "M16.882 7.842a4.882 4.882 0 0 0 -9.764 0c0 4.273 -.213 6.409 -4.118 8.118c2 .882 2 .882 3 3c3 0 4 2 6 2s3 -2 6 -2c1 -2.118 1 -2.118 3 -3c-3.906 -1.709 -4.118 -3.845 -4.118 -8.118zm-13.882 8.119c4 -2.118 4 -4.118 1 -7.118m17 7.118c-4 -2.118 -4 -4.118 -1 -7.118", "key": "svg-0" }]]);

var IconBrandSnapchat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSnapchat
});

var IconBrandSnapseed = createReactComponent("outline", "brand-snapseed", "IconBrandSnapseed", [["path", { "d": "M8.152 3.115a.46 .46 0 0 0 -.609 0c-2.943 2.58 -4.529 5.441 -4.543 8.378c0 2.928 1.586 5.803 4.543 8.392a.46 .46 0 0 0 .61 0c2.957 -2.589 4.547 -5.464 4.547 -8.392c0 -2.928 -1.6 -5.799 -4.548 -8.378z", "key": "svg-0" }], ["path", { "d": "M8 20l12.09 -.011c.503 0 .91 -.434 .91 -.969v-6.063c0 -.535 -.407 -.968 -.91 -.968h-7.382", "key": "svg-1" }]]);

var IconBrandSnapseed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSnapseed
});

var IconBrandSnowflake = createReactComponent("outline", "brand-snowflake", "IconBrandSnowflake", [["path", { "d": "M14 21v-5.5l4.5 2.5", "key": "svg-0" }], ["path", { "d": "M10 21v-5.5l-4.5 2.5", "key": "svg-1" }], ["path", { "d": "M3.5 14.5l4.5 -2.5l-4.5 -2.5", "key": "svg-2" }], ["path", { "d": "M20.5 9.5l-4.5 2.5l4.5 2.5", "key": "svg-3" }], ["path", { "d": "M10 3v5.5l-4.5 -2.5", "key": "svg-4" }], ["path", { "d": "M14 3v5.5l4.5 -2.5", "key": "svg-5" }], ["path", { "d": "M12 11l1 1l-1 1l-1 -1z", "key": "svg-6" }]]);

var IconBrandSnowflake$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSnowflake
});

var IconBrandSocketIo = createReactComponent("outline", "brand-socket-io", "IconBrandSocketIo", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M11 11h1l3 -4z", "key": "svg-1" }], ["path", { "d": "M12 13h1l-4 4z", "key": "svg-2" }]]);

var IconBrandSocketIo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSocketIo
});

var IconBrandSolidjs = createReactComponent("outline", "brand-solidjs", "IconBrandSolidjs", [["path", { "d": "M2 17.5c4.667 3 8 4.5 10 4.5c2.5 0 4 -1.5 4 -3.5s-1.5 -3.5 -4 -3.5c-2 0 -5.333 .833 -10 2.5z", "key": "svg-0" }], ["path", { "d": "M5 13.5c4.667 -1.667 8 -2.5 10 -2.5c2.5 0 4 1.5 4 3.5c0 .738 -.204 1.408 -.588 1.96l-2.883 3.825", "key": "svg-1" }], ["path", { "d": "M22 6.5c-4 -3 -8 -4.5 -10 -4.5c-2.04 0 -2.618 .463 -3.419 1.545", "key": "svg-2" }], ["path", { "d": "M2 17.5l3 -4", "key": "svg-3" }], ["path", { "d": "M22 6.5l-3 4", "key": "svg-4" }], ["path", { "d": "M8.581 3.545l-2.953 3.711", "key": "svg-5" }], ["path", { "d": "M7.416 12.662c-1.51 -.476 -2.416 -1.479 -2.416 -3.162c0 -2.5 1.5 -3.5 4 -3.5c1.688 0 5.087 1.068 8.198 3.204a114.76 114.76 0 0 1 1.802 1.296l-2.302 .785", "key": "svg-6" }]]);

var IconBrandSolidjs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSolidjs
});

var IconBrandSoundcloud = createReactComponent("outline", "brand-soundcloud", "IconBrandSoundcloud", [["path", { "d": "M17 11h1c1.38 0 3 1.274 3 3c0 1.657 -1.5 3 -3 3l-6 0v-10c3 0 4.5 1.5 5 4z", "key": "svg-0" }], ["path", { "d": "M9 8l0 9", "key": "svg-1" }], ["path", { "d": "M6 17l0 -7", "key": "svg-2" }], ["path", { "d": "M3 16l0 -2", "key": "svg-3" }]]);

var IconBrandSoundcloud$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSoundcloud
});

var IconBrandSpacehey = createReactComponent("outline", "brand-spacehey", "IconBrandSpacehey", [["path", { "d": "M17 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M14 20h6v-6a3 3 0 0 0 -6 0v6z", "key": "svg-1" }], ["path", { "d": "M11 8v2.5a3.5 3.5 0 0 1 -3.5 3.5h-.5a3 3 0 0 1 0 -6h4z", "key": "svg-2" }]]);

var IconBrandSpacehey$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSpacehey
});

var IconBrandSpeedtest = createReactComponent("outline", "brand-speedtest", "IconBrandSpeedtest", [["path", { "d": "M5.636 19.364a9 9 0 1 1 12.728 0", "key": "svg-0" }], ["path", { "d": "M16 9l-4 4", "key": "svg-1" }]]);

var IconBrandSpeedtest$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSpeedtest
});

var IconBrandSpotify = createReactComponent("outline", "brand-spotify", "IconBrandSpotify", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M8 11.973c2.5 -1.473 5.5 -.973 7.5 .527", "key": "svg-1" }], ["path", { "d": "M9 15c1.5 -1 4 -1 5 .5", "key": "svg-2" }], ["path", { "d": "M7 9c2 -1 6 -2 10 .5", "key": "svg-3" }]]);

var IconBrandSpotify$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSpotify
});

var IconBrandStackoverflow = createReactComponent("outline", "brand-stackoverflow", "IconBrandStackoverflow", [["path", { "d": "M4 17v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-1", "key": "svg-0" }], ["path", { "d": "M8 16h8", "key": "svg-1" }], ["path", { "d": "M8.322 12.582l7.956 .836", "key": "svg-2" }], ["path", { "d": "M8.787 9.168l7.826 1.664", "key": "svg-3" }], ["path", { "d": "M10.096 5.764l7.608 2.472", "key": "svg-4" }]]);

var IconBrandStackoverflow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandStackoverflow
});

var IconBrandStackshare = createReactComponent("outline", "brand-stackshare", "IconBrandStackshare", [["path", { "d": "M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M19 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M7 12h3l3.5 6h3.5", "key": "svg-3" }], ["path", { "d": "M17 6h-3.5l-3.5 6", "key": "svg-4" }]]);

var IconBrandStackshare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandStackshare
});

var IconBrandSteam = createReactComponent("outline", "brand-steam", "IconBrandSteam", [["path", { "d": "M16.5 5a4.5 4.5 0 1 1 -.653 8.953l-4.347 3.009l0 .038a3 3 0 0 1 -2.824 3l-.176 0a3 3 0 0 1 -2.94 -2.402l-2.56 -1.098v-3.5l3.51 1.755a2.989 2.989 0 0 1 2.834 -.635l2.727 -3.818a4.5 4.5 0 0 1 4.429 -5.302z", "key": "svg-0" }], ["circle", { "cx": "16.5", "cy": "9.5", "r": "1", "fill": "currentColor", "key": "svg-1" }]]);

var IconBrandSteam$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSteam
});

var IconBrandStocktwits = createReactComponent("outline", "brand-stocktwits", "IconBrandStocktwits", [["path", { "d": "M16 3l-8 4.5l8 4.5", "key": "svg-0" }], ["path", { "d": "M8 12l8 4.5l-8 4.5", "key": "svg-1" }]]);

var IconBrandStocktwits$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandStocktwits
});

var IconBrandStorj = createReactComponent("outline", "brand-storj", "IconBrandStorj", [["path", { "d": "M4 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M4 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M20 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M20 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M12 3m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["path", { "d": "M12 21m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-5" }], ["path", { "d": "M12 21l-8 -4v-10l8 -4l8 4v10z", "key": "svg-6" }], ["path", { "d": "M9.1 15a2.1 2.1 0 0 1 -.648 -4.098c.282 -1.648 1.319 -2.902 3.048 -2.902c1.694 0 2.906 1.203 3.23 2.8h.17a2.1 2.1 0 0 1 .202 4.19l-.202 .01h-5.8z", "key": "svg-7" }], ["path", { "d": "M4 7l4.323 2.702", "key": "svg-8" }], ["path", { "d": "M16.413 14.758l3.587 2.242", "key": "svg-9" }], ["path", { "d": "M4 17l3.529 -2.206", "key": "svg-10" }], ["path", { "d": "M14.609 10.37l5.391 -3.37", "key": "svg-11" }], ["path", { "d": "M12 3v5", "key": "svg-12" }], ["path", { "d": "M12 15v6", "key": "svg-13" }]]);

var IconBrandStorj$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandStorj
});

var IconBrandStorybook = createReactComponent("outline", "brand-storybook", "IconBrandStorybook", [["path", { "d": "M5 4l.5 16.5l13.5 .5v-18z", "key": "svg-0" }], ["path", { "d": "M9 15c.6 1.5 1.639 2 3.283 2h-.283c1.8 0 3 -.974 3 -2.435c0 -1.194 -.831 -1.799 -2.147 -2.333l-1.975 -.802c-1.15 -.467 -1.878 -1.422 -1.878 -2.467c0 -.97 .899 -1.786 2.087 -1.893l.613 -.055c1.528 -.138 3 .762 3.3 1.985", "key": "svg-1" }], ["path", { "d": "M16 3.5v1", "key": "svg-2" }]]);

var IconBrandStorybook$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandStorybook
});

var IconBrandStorytel = createReactComponent("outline", "brand-storytel", "IconBrandStorytel", [["path", { "d": "M4.103 22c2.292 -2.933 16.825 -2.43 16.825 -11.538c0 -6.298 -4.974 -8.462 -8.451 -8.462c-3.477 0 -9.477 3.036 -9.477 11.241c0 6.374 1.103 8.759 1.103 8.759z", "key": "svg-0" }]]);

var IconBrandStorytel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandStorytel
});

var IconBrandStrava = createReactComponent("outline", "brand-strava", "IconBrandStrava", [["path", { "d": "M15 13l-5 -10l-5 10m6 0l4 8l4 -8", "key": "svg-0" }]]);

var IconBrandStrava$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandStrava
});

var IconBrandStripe = createReactComponent("outline", "brand-stripe", "IconBrandStripe", [["path", { "d": "M11.453 8.056c0 -.623 .518 -.979 1.442 -.979c1.69 0 3.41 .343 4.605 .923l.5 -4c-.948 -.449 -2.82 -1 -5.5 -1c-1.895 0 -3.373 .087 -4.5 1c-1.172 .956 -2 2.33 -2 4c0 3.03 1.958 4.906 5 6c1.961 .69 3 .743 3 1.5c0 .735 -.851 1.5 -2 1.5c-1.423 0 -3.963 -.609 -5.5 -1.5l-.5 4c1.321 .734 3.474 1.5 6 1.5c2 0 3.957 -.468 5.084 -1.36c1.263 -.979 1.916 -2.268 1.916 -4.14c0 -3.096 -1.915 -4.547 -5 -5.637c-1.646 -.605 -2.544 -1.07 -2.544 -1.807z", "key": "svg-0" }]]);

var IconBrandStripe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandStripe
});

var IconBrandSublimeText = createReactComponent("outline", "brand-sublime-text", "IconBrandSublimeText", [["path", { "d": "M19 8l-14 4.5v-5.5l14 -4.5z", "key": "svg-0" }], ["path", { "d": "M19 17l-14 4.5v-5.5l14 -4.5z", "key": "svg-1" }], ["path", { "d": "M19 11.5l-14 -4.5", "key": "svg-2" }], ["path", { "d": "M5 12.5l14 4.5", "key": "svg-3" }]]);

var IconBrandSublimeText$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSublimeText
});

var IconBrandSugarizer = createReactComponent("outline", "brand-sugarizer", "IconBrandSugarizer", [["path", { "d": "M14.277 16l3.252 -3.252a1.61 1.61 0 0 0 -2.277 -2.276l-3.252 3.251l-3.252 -3.251a1.61 1.61 0 0 0 -2.276 2.276l3.251 3.252l-3.251 3.252a1.61 1.61 0 1 0 2.276 2.277l3.252 -3.252l3.252 3.252a1.61 1.61 0 1 0 2.277 -2.277l-3.252 -3.252z", "key": "svg-0" }], ["path", { "d": "M12 5m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }]]);

var IconBrandSugarizer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSugarizer
});

var IconBrandSupabase = createReactComponent("outline", "brand-supabase", "IconBrandSupabase", [["path", { "d": "M4 14h8v7l8 -11h-8v-7z", "key": "svg-0" }]]);

var IconBrandSupabase$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSupabase
});

var IconBrandSuperhuman = createReactComponent("outline", "brand-superhuman", "IconBrandSuperhuman", [["path", { "d": "M16 12l4 3l-8 7l-8 -7l4 -3", "key": "svg-0" }], ["path", { "d": "M12 3l-8 6l8 6l8 -6z", "key": "svg-1" }], ["path", { "d": "M12 15h8", "key": "svg-2" }]]);

var IconBrandSuperhuman$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSuperhuman
});

var IconBrandSupernova = createReactComponent("outline", "brand-supernova", "IconBrandSupernova", [["path", { "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M15 15h.5c3.038 0 5.5 -1.343 5.5 -3s-2.462 -3 -5.5 -3c-1.836 0 -3.462 .49 -4.46 1.245", "key": "svg-1" }], ["path", { "d": "M9 9h-.5c-3.038 0 -5.5 1.343 -5.5 3s2.462 3 5.5 3c1.844 0 3.476 -.495 4.474 -1.255", "key": "svg-2" }], ["path", { "d": "M15 9v-.5c0 -3.038 -1.343 -5.5 -3 -5.5s-3 2.462 -3 5.5c0 1.833 .49 3.457 1.241 4.456", "key": "svg-3" }], ["path", { "d": "M9 15v.5c0 3.038 1.343 5.5 3 5.5s3 -2.462 3 -5.5c0 -1.842 -.494 -3.472 -1.252 -4.47", "key": "svg-4" }]]);

var IconBrandSupernova$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSupernova
});

var IconBrandSurfshark = createReactComponent("outline", "brand-surfshark", "IconBrandSurfshark", [["path", { "d": "M19.954 9.447c-.237 -6.217 0 -6.217 -6 -6.425c-5.774 -.208 -6.824 1 -7.91 5.382c-2.884 11.816 -3.845 14.716 4.792 11.198c9.392 -3.831 9.297 -5.382 9.114 -10.155z", "key": "svg-0" }], ["path", { "d": "M8 16h.452c1.943 .007 3.526 -1.461 3.543 -3.286v-2.428c.018 -1.828 1.607 -3.298 3.553 -3.286h.452", "key": "svg-1" }]]);

var IconBrandSurfshark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSurfshark
});

var IconBrandSvelte = createReactComponent("outline", "brand-svelte", "IconBrandSvelte", [["path", { "d": "M15 8l-5 3l.821 -.495c1.86 -1.15 4.412 -.49 5.574 1.352a3.91 3.91 0 0 1 -1.264 5.42l-5.053 3.126c-1.86 1.151 -4.312 .591 -5.474 -1.251a3.91 3.91 0 0 1 1.263 -5.42l.26 -.16", "key": "svg-0" }], ["path", { "d": "M8 17l5 -3l-.822 .496c-1.86 1.151 -4.411 .491 -5.574 -1.351a3.91 3.91 0 0 1 1.264 -5.42l5.054 -3.127c1.86 -1.15 4.311 -.59 5.474 1.252a3.91 3.91 0 0 1 -1.264 5.42l-.26 .16", "key": "svg-1" }]]);

var IconBrandSvelte$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSvelte
});

var IconBrandSwift = createReactComponent("outline", "brand-swift", "IconBrandSwift", [["path", { "d": "M20.547 15.828c1.33 -4.126 -1.384 -9.521 -6.047 -12.828c-.135 -.096 2.39 6.704 1.308 9.124c-2.153 -1.454 -4.756 -3.494 -7.808 -6.124l-.5 2l-3.5 -1c4.36 4.748 7.213 7.695 8.56 8.841c-4.658 2.089 -10.65 -.978 -10.56 -.841c1.016 1.545 6 6 11 6c2 0 3.788 -.502 4.742 -1.389c.005 -.005 .432 -.446 1.378 -.17c.504 .148 1.463 .667 2.88 1.559v-1.507c0 -1.377 -.515 -2.67 -1.453 -3.665z", "key": "svg-0" }]]);

var IconBrandSwift$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSwift
});

var IconBrandSymfony = createReactComponent("outline", "brand-symfony", "IconBrandSymfony", [["path", { "d": "M6 13c.458 .667 1.125 1 2 1c1.313 0 2 -.875 2 -1.5c0 -1.5 -2 -1 -2 -2c0 -.625 .516 -1.5 1.5 -1.5c2.5 0 1.563 2 5.5 2c.667 0 1 -.333 1 -1", "key": "svg-0" }], ["path", { "d": "M9 17c-.095 .667 .238 1 1 1c1.714 0 2.714 -2 3 -6c.286 -4 1.571 -6 3 -6c.571 0 .905 .333 1 1", "key": "svg-1" }], ["path", { "d": "M22 12c0 5.523 -4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10a10 10 0 0 1 10 10z", "key": "svg-2" }]]);

var IconBrandSymfony$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSymfony
});

var IconBrandTabler = createReactComponent("outline", "brand-tabler", "IconBrandTabler", [["path", { "d": "M8 9l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M13 15h3", "key": "svg-1" }], ["path", { "d": "M3 7a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4z", "key": "svg-2" }]]);

var IconBrandTabler$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTabler
});

var IconBrandTailwind = createReactComponent("outline", "brand-tailwind", "IconBrandTailwind", [["path", { "d": "M11.667 6c-2.49 0 -4.044 1.222 -4.667 3.667c.933 -1.223 2.023 -1.68 3.267 -1.375c.71 .174 1.217 .68 1.778 1.24c.916 .912 2 1.968 4.288 1.968c2.49 0 4.044 -1.222 4.667 -3.667c-.933 1.223 -2.023 1.68 -3.267 1.375c-.71 -.174 -1.217 -.68 -1.778 -1.24c-.916 -.912 -1.975 -1.968 -4.288 -1.968zm-4 6.5c-2.49 0 -4.044 1.222 -4.667 3.667c.933 -1.223 2.023 -1.68 3.267 -1.375c.71 .174 1.217 .68 1.778 1.24c.916 .912 1.975 1.968 4.288 1.968c2.49 0 4.044 -1.222 4.667 -3.667c-.933 1.223 -2.023 1.68 -3.267 1.375c-.71 -.174 -1.217 -.68 -1.778 -1.24c-.916 -.912 -1.975 -1.968 -4.288 -1.968z", "key": "svg-0" }]]);

var IconBrandTailwind$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTailwind
});

var IconBrandTaobao = createReactComponent("outline", "brand-taobao", "IconBrandTaobao", [["path", { "d": "M2 5c.968 .555 1.335 1.104 2 2", "key": "svg-0" }], ["path", { "d": "M2 10c5.007 3.674 2.85 6.544 0 10", "key": "svg-1" }], ["path", { "d": "M10 4c-.137 4.137 -2.258 5.286 -3.709 6.684", "key": "svg-2" }], ["path", { "d": "M10 6c2.194 -.8 3.736 -.852 6.056 -.993c4.206 -.158 5.523 2.264 5.803 5.153c.428 4.396 -.077 7.186 -2.117 9.298c-1.188 1.23 -3.238 2.62 -7.207 .259", "key": "svg-3" }], ["path", { "d": "M11 10h6", "key": "svg-4" }], ["path", { "d": "M13 10v6.493", "key": "svg-5" }], ["path", { "d": "M8 13h10", "key": "svg-6" }], ["path", { "d": "M16 15.512l.853 1.72", "key": "svg-7" }], ["path", { "d": "M16.5 17c-1.145 .361 -7 3 -8.5 -.5", "key": "svg-8" }], ["path", { "d": "M11.765 8.539l-1.765 2.461", "key": "svg-9" }]]);

var IconBrandTaobao$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTaobao
});

var IconBrandTeams = createReactComponent("outline", "brand-teams", "IconBrandTeams", [["path", { "d": "M3 7h10v10h-10z", "key": "svg-0" }], ["path", { "d": "M6 10h4", "key": "svg-1" }], ["path", { "d": "M8 10v4", "key": "svg-2" }], ["path", { "d": "M8.104 17c.47 2.274 2.483 4 4.896 4a5 5 0 0 0 5 -5v-7h-5", "key": "svg-3" }], ["path", { "d": "M18 18a4 4 0 0 0 4 -4v-5h-4", "key": "svg-4" }], ["path", { "d": "M13.003 8.83a3 3 0 1 0 -1.833 -1.833", "key": "svg-5" }], ["path", { "d": "M15.83 8.36a2.5 2.5 0 1 0 .594 -4.117", "key": "svg-6" }]]);

var IconBrandTeams$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTeams
});

var IconBrandTed = createReactComponent("outline", "brand-ted", "IconBrandTed", [["path", { "d": "M2 8h4", "key": "svg-0" }], ["path", { "d": "M4 8v8", "key": "svg-1" }], ["path", { "d": "M13 8h-4v8h4", "key": "svg-2" }], ["path", { "d": "M9 12h2.5", "key": "svg-3" }], ["path", { "d": "M16 8v8h2a3 3 0 0 0 3 -3v-2a3 3 0 0 0 -3 -3h-2z", "key": "svg-4" }]]);

var IconBrandTed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTed
});

var IconBrandTelegram = createReactComponent("outline", "brand-telegram", "IconBrandTelegram", [["path", { "d": "M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4", "key": "svg-0" }]]);

var IconBrandTelegram$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTelegram
});

var IconBrandTerraform = createReactComponent("outline", "brand-terraform", "IconBrandTerraform", [["path", { "d": "M15 15.5l-11.476 -6.216a1 1 0 0 1 -.524 -.88v-4.054a1.35 1.35 0 0 1 2.03 -1.166l9.97 5.816v10.65a1.35 1.35 0 0 1 -2.03 1.166l-3.474 -2.027a1 1 0 0 1 -.496 -.863v-11.926", "key": "svg-0" }], ["path", { "d": "M15 15.5l5.504 -3.21a1 1 0 0 0 .496 -.864v-3.576a1.35 1.35 0 0 0 -2.03 -1.166l-3.97 2.316", "key": "svg-1" }]]);

var IconBrandTerraform$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTerraform
});

var IconBrandTesla = createReactComponent("outline", "brand-tesla", "IconBrandTesla", [["path", { "d": "M12 21l3 -11c2.359 0 3 0 3 1c0 0 1.18 -1.745 2 -3c-3.077 -1.464 -6 -1 -6 -1l-2 2l-2 -2s-2.923 -.464 -6 1c.82 1.255 2 3 2 3c0 -1 .744 -1 3 -1z", "key": "svg-0" }], ["path", { "d": "M20 5c-5.114 -2 -10.886 -2 -16 0", "key": "svg-1" }]]);

var IconBrandTesla$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTesla
});

var IconBrandTether = createReactComponent("outline", "brand-tether", "IconBrandTether", [["path", { "d": "M14.08 20.188c-1.15 1.083 -3.02 1.083 -4.17 0l-6.93 -6.548c-.96 -.906 -1.27 -2.624 -.69 -3.831l2.4 -5.018c.47 -.991 1.72 -1.791 2.78 -1.791h9.06c1.06 0 2.31 .802 2.78 1.79l2.4 5.019c.58 1.207 .26 2.925 -.69 3.83c-3.453 3.293 -3.466 3.279 -6.94 6.549z", "key": "svg-0" }], ["path", { "d": "M12 15v-7", "key": "svg-1" }], ["path", { "d": "M8 8h8", "key": "svg-2" }]]);

var IconBrandTether$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTether
});

var IconBrandThingiverse = createReactComponent("outline", "brand-thingiverse", "IconBrandThingiverse", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M8 9h8m-4 0v8", "key": "svg-1" }]]);

var IconBrandThingiverse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandThingiverse
});

var IconBrandThreads = createReactComponent("outline", "brand-threads", "IconBrandThreads", [["path", { "d": "M19 7.5c-1.333 -3 -3.667 -4.5 -7 -4.5c-5 0 -8 2.5 -8 9s3.5 9 8 9s7 -3 7 -5s-1 -5 -7 -5c-2.5 0 -3 1.25 -3 2.5c0 1.5 1 2.5 2.5 2.5c2.5 0 3.5 -1.5 3.5 -5s-2 -4 -3 -4s-1.833 .333 -2.5 1", "key": "svg-0" }]]);

var IconBrandThreads$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandThreads
});

var IconBrandThreejs = createReactComponent("outline", "brand-threejs", "IconBrandThreejs", [["path", { "d": "M8 22l-5 -19l19 5.5z", "key": "svg-0" }], ["path", { "d": "M12.573 17.58l-6.152 -1.576l8.796 -9.466l1.914 6.64", "key": "svg-1" }], ["path", { "d": "M12.573 17.58l-1.573 -6.58l6.13 2.179", "key": "svg-2" }], ["path", { "d": "M9.527 4.893l1.473 6.107l-6.31 -1.564z", "key": "svg-3" }]]);

var IconBrandThreejs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandThreejs
});

var IconBrandTidal = createReactComponent("outline", "brand-tidal", "IconBrandTidal", [["path", { "d": "M5.333 6l3.334 3.25l3.333 -3.25l3.333 3.25l3.334 -3.25l3.333 3.25l-3.333 3.25l-3.334 -3.25l-3.333 3.25l3.333 3.25l-3.333 3.25l-3.333 -3.25l3.333 -3.25l-3.333 -3.25l-3.334 3.25l-3.333 -3.25z", "key": "svg-0" }]]);

var IconBrandTidal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTidal
});

var IconBrandTiktok = createReactComponent("outline", "brand-tiktok", "IconBrandTiktok", [["path", { "d": "M21 7.917v4.034a9.948 9.948 0 0 1 -5 -1.951v4.5a6.5 6.5 0 1 1 -8 -6.326v4.326a2.5 2.5 0 1 0 4 2v-11.5h4.083a6.005 6.005 0 0 0 4.917 4.917z", "key": "svg-0" }]]);

var IconBrandTiktok$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTiktok
});

var IconBrandTinder = createReactComponent("outline", "brand-tinder", "IconBrandTinder", [["path", { "d": "M18.918 8.174c2.56 4.982 .501 11.656 -5.38 12.626c-7.702 1.687 -12.84 -7.716 -7.054 -13.229c.309 -.305 1.161 -1.095 1.516 -1.349c0 .528 .27 3.475 1 3.167c3 0 4 -4.222 3.587 -7.389c2.7 1.411 4.987 3.376 6.331 6.174z", "key": "svg-0" }]]);

var IconBrandTinder$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTinder
});

var IconBrandTopbuzz = createReactComponent("outline", "brand-topbuzz", "IconBrandTopbuzz", [["path", { "d": "M4.417 8.655a.524 .524 0 0 1 -.405 -.622l.986 -4.617a.524 .524 0 0 1 .626 -.404l14.958 3.162c.285 .06 .467 .339 .406 .622l-.987 4.618a.524 .524 0 0 1 -.625 .404l-4.345 -.92c-.198 -.04 -.315 .024 -.353 .197l-2.028 9.49a.527 .527 0 0 1 -.625 .404l-4.642 -.982a.527 .527 0 0 1 -.406 -.622l2.028 -9.493c.037 -.17 -.031 -.274 -.204 -.31l-4.384 -.927z", "key": "svg-0" }]]);

var IconBrandTopbuzz$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTopbuzz
});

var IconBrandTorchain = createReactComponent("outline", "brand-torchain", "IconBrandTorchain", [["path", { "d": "M15.588 15.537l-3.553 -3.537l-7.742 8.18c-.791 .85 .153 2.18 1.238 1.73l9.616 -4.096a1.398 1.398 0 0 0 .44 -2.277z", "key": "svg-0" }], ["path", { "d": "M8.412 8.464l3.553 3.536l7.742 -8.18c.791 -.85 -.153 -2.18 -1.238 -1.73l-9.616 4.098a1.398 1.398 0 0 0 -.44 2.277z", "key": "svg-1" }]]);

var IconBrandTorchain$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTorchain
});

var IconBrandToyota = createReactComponent("outline", "brand-toyota", "IconBrandToyota", [["path", { "d": "M12 12m-10 0a10 7 0 1 0 20 0a10 7 0 1 0 -20 0", "key": "svg-0" }], ["path", { "d": "M9 12c0 3.866 1.343 7 3 7s3 -3.134 3 -7s-1.343 -7 -3 -7s-3 3.134 -3 7z", "key": "svg-1" }], ["path", { "d": "M6.415 6.191c-.888 .503 -1.415 1.13 -1.415 1.809c0 1.657 3.134 3 7 3s7 -1.343 7 -3c0 -.678 -.525 -1.304 -1.41 -1.806", "key": "svg-2" }]]);

var IconBrandToyota$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandToyota
});

var IconBrandTrello = createReactComponent("outline", "brand-trello", "IconBrandTrello", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 7h3v10h-3z", "key": "svg-1" }], ["path", { "d": "M14 7h3v6h-3z", "key": "svg-2" }]]);

var IconBrandTrello$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTrello
});

var IconBrandTripadvisor = createReactComponent("outline", "brand-tripadvisor", "IconBrandTripadvisor", [["path", { "d": "M6.5 13.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0", "key": "svg-0" }], ["path", { "d": "M17.5 13.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0", "key": "svg-1" }], ["path", { "d": "M17.5 9a4.5 4.5 0 1 0 3.5 1.671l1 -1.671h-4.5z", "key": "svg-2" }], ["path", { "d": "M6.5 9a4.5 4.5 0 1 1 -3.5 1.671l-1 -1.671h4.5z", "key": "svg-3" }], ["path", { "d": "M10.5 15.5l1.5 2l1.5 -2", "key": "svg-4" }], ["path", { "d": "M9 6.75c2 -.667 4 -.667 6 0", "key": "svg-5" }]]);

var IconBrandTripadvisor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTripadvisor
});

var IconBrandTumblr = createReactComponent("outline", "brand-tumblr", "IconBrandTumblr", [["path", { "d": "M14 21h4v-4h-4v-6h4v-4h-4v-4h-4v1a3 3 0 0 1 -3 3h-1v4h4v6a4 4 0 0 0 4 4", "key": "svg-0" }]]);

var IconBrandTumblr$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTumblr
});

var IconBrandTwilio = createReactComponent("outline", "brand-twilio", "IconBrandTwilio", [["path", { "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z", "key": "svg-0" }], ["path", { "d": "M9 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M15 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M15 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M9 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }]]);

var IconBrandTwilio$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTwilio
});

var IconBrandTwitch = createReactComponent("outline", "brand-twitch", "IconBrandTwitch", [["path", { "d": "M4 5v11a1 1 0 0 0 1 1h2v4l4 -4h5.584c.266 0 .52 -.105 .707 -.293l2.415 -2.414c.187 -.188 .293 -.442 .293 -.708v-8.585a1 1 0 0 0 -1 -1h-14a1 1 0 0 0 -1 1z", "key": "svg-0" }], ["path", { "d": "M16 8l0 4", "key": "svg-1" }], ["path", { "d": "M12 8l0 4", "key": "svg-2" }]]);

var IconBrandTwitch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTwitch
});

var IconBrandTwitter = createReactComponent("outline", "brand-twitter", "IconBrandTwitter", [["path", { "d": "M22 4.01c-1 .49 -1.98 .689 -3 .99c-1.121 -1.265 -2.783 -1.335 -4.38 -.737s-2.643 2.06 -2.62 3.737v1c-3.245 .083 -6.135 -1.395 -8 -4c0 0 -4.182 7.433 4 11c-1.872 1.247 -3.739 2.088 -6 2c3.308 1.803 6.913 2.423 10.034 1.517c3.58 -1.04 6.522 -3.723 7.651 -7.742a13.84 13.84 0 0 0 .497 -3.753c0 -.249 1.51 -2.772 1.818 -4.013z", "key": "svg-0" }]]);

var IconBrandTwitter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTwitter
});

var IconBrandTypescript = createReactComponent("outline", "brand-typescript", "IconBrandTypescript", [["path", { "d": "M15 17.5c.32 .32 .754 .5 1.207 .5h.543c.69 0 1.25 -.56 1.25 -1.25v-.25a1.5 1.5 0 0 0 -1.5 -1.5a1.5 1.5 0 0 1 -1.5 -1.5v-.25c0 -.69 .56 -1.25 1.25 -1.25h.543c.453 0 .887 .18 1.207 .5", "key": "svg-0" }], ["path", { "d": "M9 12h4", "key": "svg-1" }], ["path", { "d": "M11 12v6", "key": "svg-2" }], ["path", { "d": "M21 19v-14a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2z", "key": "svg-3" }]]);

var IconBrandTypescript$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTypescript
});

var IconBrandUber = createReactComponent("outline", "brand-uber", "IconBrandUber", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 9m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M3 12h6", "key": "svg-2" }]]);

var IconBrandUber$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandUber
});

var IconBrandUbuntu = createReactComponent("outline", "brand-ubuntu", "IconBrandUbuntu", [["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17.723 7.41a7.992 7.992 0 0 0 -3.74 -2.162m-3.971 0a7.993 7.993 0 0 0 -3.789 2.216m-1.881 3.215a8 8 0 0 0 -.342 2.32c0 .738 .1 1.453 .287 2.132m1.96 3.428a7.993 7.993 0 0 0 3.759 2.19m4 0a7.993 7.993 0 0 0 3.747 -2.186m1.962 -3.43a8.008 8.008 0 0 0 .287 -2.131c0 -.764 -.107 -1.503 -.307 -2.203", "key": "svg-1" }], ["path", { "d": "M5 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }]]);

var IconBrandUbuntu$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandUbuntu
});

var IconBrandUnity = createReactComponent("outline", "brand-unity", "IconBrandUnity", [["path", { "d": "M14 3l6 4v7", "key": "svg-0" }], ["path", { "d": "M18 17l-6 4l-6 -4", "key": "svg-1" }], ["path", { "d": "M4 14v-7l6 -4", "key": "svg-2" }], ["path", { "d": "M4 7l8 5v9", "key": "svg-3" }], ["path", { "d": "M20 7l-8 5", "key": "svg-4" }]]);

var IconBrandUnity$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandUnity
});

var IconBrandUnsplash = createReactComponent("outline", "brand-unsplash", "IconBrandUnsplash", [["path", { "d": "M4 11h5v4h6v-4h5v9h-16zm5 -7h6v4h-6z", "key": "svg-0" }]]);

var IconBrandUnsplash$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandUnsplash
});

var IconBrandUpwork = createReactComponent("outline", "brand-upwork", "IconBrandUpwork", [["path", { "d": "M3 7v5a3 3 0 0 0 6 0v-5h1l4 6c.824 1.319 1.945 2 3.5 2a3.5 3.5 0 0 0 0 -7c-2.027 0 -3.137 1 -3.5 3c-.242 1.33 -.908 4 -2 8", "key": "svg-0" }]]);

var IconBrandUpwork$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandUpwork
});

var IconBrandValorant = createReactComponent("outline", "brand-valorant", "IconBrandValorant", [["path", { "d": "M14.5 14h4.5l2 -2v-6z", "key": "svg-0" }], ["path", { "d": "M9 19h5l-11 -13v6z", "key": "svg-1" }]]);

var IconBrandValorant$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandValorant
});

var IconBrandVercel = createReactComponent("outline", "brand-vercel", "IconBrandVercel", [["path", { "d": "M3 19h18l-9 -15z", "key": "svg-0" }]]);

var IconBrandVercel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVercel
});

var IconBrandVimeo = createReactComponent("outline", "brand-vimeo", "IconBrandVimeo", [["path", { "d": "M3 8.5l1 1s1.5 -1.102 2 -.5c.509 .609 1.863 7.65 2.5 9c.556 1.184 1.978 2.89 4 1.5c2 -1.5 7.5 -5.5 8.5 -11.5c.444 -2.661 -1 -4 -2.5 -4c-2 0 -4.047 1.202 -4.5 4c2.05 -1.254 2.551 1 1.5 3c-1.052 2 -2 3 -2.5 3c-.49 0 -.924 -1.165 -1.5 -3.5c-.59 -2.42 -.5 -6.5 -3 -6.5s-5.5 4.5 -5.5 4.5z", "key": "svg-0" }]]);

var IconBrandVimeo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVimeo
});

var IconBrandVinted = createReactComponent("outline", "brand-vinted", "IconBrandVinted", [["path", { "d": "M11.028 6c0 7.695 -.292 11.728 0 12c2.046 -5 4.246 -12.642 5.252 -14.099c.343 -.497 .768 -.93 1.257 -1.277c.603 -.39 1.292 -.76 1.463 -.575c-.07 2.319 -4.023 15.822 -4.209 16.314a6.135 6.135 0 0 1 -3.465 3.386c-3.213 .78 -3.429 -.446 -3.836 -1.134c-.95 -2.103 -1.682 -14.26 -1.445 -15.615c.05 -.523 .143 -1.851 2.491 -2c2.359 -.354 2.547 1.404 2.492 3z", "key": "svg-0" }]]);

var IconBrandVinted$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVinted
});

var IconBrandVisa = createReactComponent("outline", "brand-visa", "IconBrandVisa", [["path", { "d": "M21 15l-1 -6l-2.5 6", "key": "svg-0" }], ["path", { "d": "M9 15l1 -6", "key": "svg-1" }], ["path", { "d": "M3 9h1v6h.5l2.5 -6", "key": "svg-2" }], ["path", { "d": "M16 9.5a.5 .5 0 0 0 -.5 -.5h-.75c-.721 0 -1.337 .521 -1.455 1.233l-.09 .534a1.059 1.059 0 0 0 1.045 1.233a1.059 1.059 0 0 1 1.045 1.233l-.09 .534a1.476 1.476 0 0 1 -1.455 1.233h-.75a.5 .5 0 0 1 -.5 -.5", "key": "svg-3" }], ["path", { "d": "M18 14h2.7", "key": "svg-4" }]]);

var IconBrandVisa$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVisa
});

var IconBrandVisualStudio = createReactComponent("outline", "brand-visual-studio", "IconBrandVisualStudio", [["path", { "d": "M4 8l2 -1l10 13l4 -2v-12l-4 -2l-10 13l-2 -1z", "key": "svg-0" }]]);

var IconBrandVisualStudio$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVisualStudio
});

var IconBrandVite = createReactComponent("outline", "brand-vite", "IconBrandVite", [["path", { "d": "M10 4.5l6 -1.5l-2 6.5l2 -.5l-4 7v-5l-3 1z", "key": "svg-0" }], ["path", { "d": "M15 6.5l7 -1.5l-10 17l-10 -17l7.741 1.5", "key": "svg-1" }]]);

var IconBrandVite$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVite
});

var IconBrandVivaldi = createReactComponent("outline", "brand-vivaldi", "IconBrandVivaldi", [["path", { "d": "M21.648 6.808c-2.468 4.28 -4.937 8.56 -7.408 12.836c-.397 .777 -1.366 1.301 -2.24 1.356c-.962 .102 -1.7 -.402 -2.154 -1.254c-1.563 -2.684 -3.106 -5.374 -4.66 -8.064c-.943 -1.633 -1.891 -3.266 -2.83 -4.905a2.47 2.47 0 0 1 -.06 -2.45a2.493 2.493 0 0 1 2.085 -1.307c.951 -.065 1.85 .438 2.287 1.281c.697 1.19 2.043 3.83 2.55 4.682a3.919 3.919 0 0 0 3.282 2.017c2.126 .133 3.974 -.95 4.21 -3.058c0 -.164 .228 -3.178 .846 -3.962c.619 -.784 1.64 -1.155 2.606 -.893a2.484 2.484 0 0 1 1.814 2.062c.08 .581 -.041 1.171 -.343 1.674", "key": "svg-0" }]]);

var IconBrandVivaldi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVivaldi
});

var IconBrandVk = createReactComponent("outline", "brand-vk", "IconBrandVk", [["path", { "d": "M14 19h-4a8 8 0 0 1 -8 -8v-5h4v5a4 4 0 0 0 4 4h0v-9h4v4.5l.03 0a4.531 4.531 0 0 0 3.97 -4.496h4l-.342 1.711a6.858 6.858 0 0 1 -3.658 4.789h0a5.34 5.34 0 0 1 3.566 4.111l.434 2.389h0h-4a4.531 4.531 0 0 0 -3.97 -4.496v4.5z", "key": "svg-0" }]]);

var IconBrandVk$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVk
});

var IconBrandVlc = createReactComponent("outline", "brand-vlc", "IconBrandVlc", [["path", { "d": "M13.79 4.337l3.101 9.305c.33 .985 -.113 2.07 -1.02 2.499a9.148 9.148 0 0 1 -7.742 0c-.907 -.428 -1.35 -1.514 -1.02 -2.499l3.1 -9.305c.267 -.8 .985 -1.337 1.791 -1.337c.807 0 1.525 .537 1.79 1.337z", "key": "svg-0" }], ["path", { "d": "M7 14h-1.429a2 2 0 0 0 -1.923 1.45l-.571 2a2 2 0 0 0 1.923 2.55h13.998a2 2 0 0 0 1.923 -2.55l-.572 -2a2 2 0 0 0 -1.923 -1.45h-1.426", "key": "svg-1" }]]);

var IconBrandVlc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVlc
});

var IconBrandVolkswagen = createReactComponent("outline", "brand-volkswagen", "IconBrandVolkswagen", [["path", { "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z", "key": "svg-0" }], ["path", { "d": "M5 7l4.5 11l1.5 -5h2l1.5 5l4.5 -11", "key": "svg-1" }], ["path", { "d": "M9 4l2 6h2l2 -6", "key": "svg-2" }]]);

var IconBrandVolkswagen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVolkswagen
});

var IconBrandVsco = createReactComponent("outline", "brand-vsco", "IconBrandVsco", [["path", { "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z", "key": "svg-0" }], ["path", { "d": "M17 12a5 5 0 1 0 -10 0a5 5 0 0 0 10 0z", "key": "svg-1" }], ["path", { "d": "M12 3v4", "key": "svg-2" }], ["path", { "d": "M21 12h-4", "key": "svg-3" }], ["path", { "d": "M12 21v-4", "key": "svg-4" }], ["path", { "d": "M3 12h4", "key": "svg-5" }], ["path", { "d": "M18.364 5.636l-2.828 2.828", "key": "svg-6" }], ["path", { "d": "M18.364 18.364l-2.828 -2.828", "key": "svg-7" }], ["path", { "d": "M5.636 18.364l2.828 -2.828", "key": "svg-8" }], ["path", { "d": "M5.636 5.636l2.828 2.828", "key": "svg-9" }]]);

var IconBrandVsco$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVsco
});

var IconBrandVscode = createReactComponent("outline", "brand-vscode", "IconBrandVscode", [["path", { "d": "M16 3v18l4 -2.5v-13z", "key": "svg-0" }], ["path", { "d": "M9.165 13.903l-4.165 3.597l-2 -1l4.333 -4.5m1.735 -1.802l6.932 -7.198v5l-4.795 4.141", "key": "svg-1" }], ["path", { "d": "M16 16.5l-11 -10l-2 1l13 13.5", "key": "svg-2" }]]);

var IconBrandVscode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVscode
});

var IconBrandVue = createReactComponent("outline", "brand-vue", "IconBrandVue", [["path", { "d": "M16.5 4l-4.5 8l-4.5 -8", "key": "svg-0" }], ["path", { "d": "M3 4l9 16l9 -16", "key": "svg-1" }]]);

var IconBrandVue$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVue
});

var IconBrandWalmart = createReactComponent("outline", "brand-walmart", "IconBrandWalmart", [["path", { "d": "M12 8.04v-5.04", "key": "svg-0" }], ["path", { "d": "M15.5 10l4.5 -2.5", "key": "svg-1" }], ["path", { "d": "M15.5 14l4.5 2.5", "key": "svg-2" }], ["path", { "d": "M12 15.96v5.04", "key": "svg-3" }], ["path", { "d": "M8.5 14l-4.5 2.5", "key": "svg-4" }], ["path", { "d": "M8.5 10l-4.5 -2.505", "key": "svg-5" }]]);

var IconBrandWalmart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWalmart
});

var IconBrandWaze = createReactComponent("outline", "brand-waze", "IconBrandWaze", [["path", { "d": "M6.66 17.52a7 7 0 0 1 -3.66 -4.52c2 0 3 -1 3 -2.51c0 -3.92 2.25 -7.49 7.38 -7.49c4.62 0 7.62 3.51 7.62 8a8.08 8.08 0 0 1 -3.39 6.62", "key": "svg-0" }], ["path", { "d": "M10 18.69a17.29 17.29 0 0 0 3.33 .3h.54", "key": "svg-1" }], ["path", { "d": "M16 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M8 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M16 9h.01", "key": "svg-4" }], ["path", { "d": "M11 9h.01", "key": "svg-5" }]]);

var IconBrandWaze$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWaze
});

var IconBrandWebflow = createReactComponent("outline", "brand-webflow", "IconBrandWebflow", [["path", { "d": "M17 10s-1.376 3.606 -1.5 4c-.046 -.4 -1.5 -8 -1.5 -8c-2.627 0 -3.766 1.562 -4.5 3.5c0 0 -1.843 4.593 -2 5c-.013 -.368 -.5 -4.5 -.5 -4.5c-.15 -2.371 -2.211 -3.98 -4 -3.98l2 12.98c2.745 -.013 4.72 -1.562 5.5 -3.5c0 0 1.44 -4.3 1.5 -4.5c.013 .18 1 8 1 8c2.758 0 4.694 -1.626 5.5 -3.5l3.5 -9.5c-2.732 0 -4.253 2.055 -5 4z", "key": "svg-0" }]]);

var IconBrandWebflow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWebflow
});

var IconBrandWechat = createReactComponent("outline", "brand-wechat", "IconBrandWechat", [["path", { "d": "M16.5 10c3.038 0 5.5 2.015 5.5 4.5c0 1.397 -.778 2.645 -2 3.47l0 2.03l-1.964 -1.178a6.649 6.649 0 0 1 -1.536 .178c-3.038 0 -5.5 -2.015 -5.5 -4.5s2.462 -4.5 5.5 -4.5z", "key": "svg-0" }], ["path", { "d": "M11.197 15.698c-.69 .196 -1.43 .302 -2.197 .302a8.008 8.008 0 0 1 -2.612 -.432l-2.388 1.432v-2.801c-1.237 -1.082 -2 -2.564 -2 -4.199c0 -3.314 3.134 -6 7 -6c3.782 0 6.863 2.57 7 5.785l0 .233", "key": "svg-1" }], ["path", { "d": "M10 8h.01", "key": "svg-2" }], ["path", { "d": "M7 8h.01", "key": "svg-3" }], ["path", { "d": "M15 14h.01", "key": "svg-4" }], ["path", { "d": "M18 14h.01", "key": "svg-5" }]]);

var IconBrandWechat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWechat
});

var IconBrandWeibo = createReactComponent("outline", "brand-weibo", "IconBrandWeibo", [["path", { "d": "M19 14.127c0 3.073 -3.502 5.873 -8 5.873c-4.126 0 -8 -2.224 -8 -5.565c0 -1.78 .984 -3.737 2.7 -5.567c2.362 -2.51 5.193 -3.687 6.551 -2.238c.415 .44 .752 1.39 .749 2.062c2 -1.615 4.308 .387 3.5 2.693c1.26 .557 2.5 .538 2.5 2.742z", "key": "svg-0" }], ["path", { "d": "M15 4h1a5 5 0 0 1 5 5v1", "key": "svg-1" }]]);

var IconBrandWeibo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWeibo
});

var IconBrandWhatsapp = createReactComponent("outline", "brand-whatsapp", "IconBrandWhatsapp", [["path", { "d": "M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9", "key": "svg-0" }], ["path", { "d": "M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1", "key": "svg-1" }]]);

var IconBrandWhatsapp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWhatsapp
});

var IconBrandWikipedia = createReactComponent("outline", "brand-wikipedia", "IconBrandWikipedia", [["path", { "d": "M3 4.984h2", "key": "svg-0" }], ["path", { "d": "M8 4.984h2.5", "key": "svg-1" }], ["path", { "d": "M14.5 4.984h2.5", "key": "svg-2" }], ["path", { "d": "M22 4.984h-2", "key": "svg-3" }], ["path", { "d": "M4 4.984l5.455 14.516l6.545 -14.516", "key": "svg-4" }], ["path", { "d": "M9 4.984l6 14.516l6 -14.516", "key": "svg-5" }]]);

var IconBrandWikipedia$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWikipedia
});

var IconBrandWindows = createReactComponent("outline", "brand-windows", "IconBrandWindows", [["path", { "d": "M17.8 20l-12 -1.5c-1 -.1 -1.8 -.9 -1.8 -1.9v-9.2c0 -1 .8 -1.8 1.8 -1.9l12 -1.5c1.2 -.1 2.2 .8 2.2 1.9v12.1c0 1.2 -1.1 2.1 -2.2 1.9z", "key": "svg-0" }], ["path", { "d": "M12 5l0 14", "key": "svg-1" }], ["path", { "d": "M4 12l16 0", "key": "svg-2" }]]);

var IconBrandWindows$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWindows
});

var IconBrandWindy = createReactComponent("outline", "brand-windy", "IconBrandWindy", [["path", { "d": "M9 4c0 5.5 -.33 16 4 16s7.546 -11.27 8 -13", "key": "svg-0" }], ["path", { "d": "M3 4c.253 5.44 1.449 16 5.894 16c4.444 0 8.42 -10.036 9.106 -14", "key": "svg-1" }]]);

var IconBrandWindy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWindy
});

var IconBrandWish = createReactComponent("outline", "brand-wish", "IconBrandWish", [["path", { "d": "M2 6l5.981 2.392l-.639 6.037c-.18 .893 .06 1.819 .65 2.514a3 3 0 0 0 2.381 1.057a4.328 4.328 0 0 0 4.132 -3.57c-.18 .893 .06 1.819 .65 2.514a3 3 0 0 0 2.38 1.056a4.328 4.328 0 0 0 4.132 -3.57l.333 -4.633", "key": "svg-0" }], ["path", { "d": "M14.504 14.429l.334 -3", "key": "svg-1" }]]);

var IconBrandWish$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWish
});

var IconBrandWix = createReactComponent("outline", "brand-wix", "IconBrandWix", [["path", { "d": "M3 9l1.5 6l1.379 -5.515a.64 .64 0 0 1 1.242 0l1.379 5.515l1.5 -6", "key": "svg-0" }], ["path", { "d": "M13 11.5v3.5", "key": "svg-1" }], ["path", { "d": "M16 9l5 6", "key": "svg-2" }], ["path", { "d": "M21 9l-5 6", "key": "svg-3" }], ["path", { "d": "M13 9h.01", "key": "svg-4" }]]);

var IconBrandWix$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWix
});

var IconBrandWordpress = createReactComponent("outline", "brand-wordpress", "IconBrandWordpress", [["path", { "d": "M9.5 9h3", "key": "svg-0" }], ["path", { "d": "M4 9h2.5", "key": "svg-1" }], ["path", { "d": "M11 9l3 11l4 -9", "key": "svg-2" }], ["path", { "d": "M5.5 9l3.5 11l3 -7", "key": "svg-3" }], ["path", { "d": "M18 11c.177 -.528 1 -1.364 1 -2.5c0 -1.78 -.776 -2.5 -1.875 -2.5c-.898 0 -1.125 .812 -1.125 1.429c0 1.83 2 2.058 2 3.571z", "key": "svg-4" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-5" }]]);

var IconBrandWordpress$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWordpress
});

var IconBrandX = createReactComponent("outline", "brand-x", "IconBrandX", [["path", { "d": "M4 4l11.733 16h4.267l-11.733 -16z", "key": "svg-0" }], ["path", { "d": "M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772", "key": "svg-1" }]]);

var IconBrandX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandX
});

var IconBrandXamarin = createReactComponent("outline", "brand-xamarin", "IconBrandXamarin", [["path", { "d": "M15.958 21h-7.917a2 2 0 0 1 -1.732 -1l-4.041 -7a2 2 0 0 1 0 -2l4.041 -7a2 2 0 0 1 1.732 -1h7.917a2 2 0 0 1 1.732 1l4.042 7a2 2 0 0 1 0 2l-4.041 7a2 2 0 0 1 -1.733 1z", "key": "svg-0" }], ["path", { "d": "M15 16l-6 -8", "key": "svg-1" }], ["path", { "d": "M9 16l6 -8", "key": "svg-2" }]]);

var IconBrandXamarin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandXamarin
});

var IconBrandXbox = createReactComponent("outline", "brand-xbox", "IconBrandXbox", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M6.5 5c7.72 2.266 10.037 7.597 12.5 12.5", "key": "svg-1" }], ["path", { "d": "M17.5 5c-7.72 2.266 -10.037 7.597 -12.5 12.5", "key": "svg-2" }]]);

var IconBrandXbox$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandXbox
});

var IconBrandXdeep = createReactComponent("outline", "brand-xdeep", "IconBrandXdeep", [["path", { "d": "M14.401 8.398l1.599 -2.398h5l-4 6l4 6h-5l-8 -12h-5l4 6l-4 6h5l1.596 -2.393", "key": "svg-0" }]]);

var IconBrandXdeep$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandXdeep
});

var IconBrandXing = createReactComponent("outline", "brand-xing", "IconBrandXing", [["path", { "d": "M16 21l-4 -7l6.5 -11", "key": "svg-0" }], ["path", { "d": "M7 7l2 3.5l-3 4.5", "key": "svg-1" }]]);

var IconBrandXing$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandXing
});

var IconBrandYahoo = createReactComponent("outline", "brand-yahoo", "IconBrandYahoo", [["path", { "d": "M3 6l5 0", "key": "svg-0" }], ["path", { "d": "M7 18l7 0", "key": "svg-1" }], ["path", { "d": "M4.5 6l5.5 7v5", "key": "svg-2" }], ["path", { "d": "M10 13l6 -5", "key": "svg-3" }], ["path", { "d": "M12.5 8l5 0", "key": "svg-4" }], ["path", { "d": "M20 11l0 4", "key": "svg-5" }], ["path", { "d": "M20 18l0 .01", "key": "svg-6" }]]);

var IconBrandYahoo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandYahoo
});

var IconBrandYandex = createReactComponent("outline", "brand-yandex", "IconBrandYandex", [["path", { "d": "M15 20v-16h-2a4 4 0 0 0 -4 4v1a4 4 0 0 0 4 4h2", "key": "svg-0" }], ["path", { "d": "M9 20l3 -7", "key": "svg-1" }]]);

var IconBrandYandex$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandYandex
});

var IconBrandYarn = createReactComponent("outline", "brand-yarn", "IconBrandYarn", [["path", { "d": "M17.845 19.308c-1.268 .814 -2.41 1.254 -3.845 1.692c-.176 .21 -.645 .544 -.912 .588a42.469 42.469 0 0 1 -4.498 .412c-.812 .006 -1.31 -.214 -1.447 -.554c-.115 -.279 .336 -2.054 .298 -1.964c-.157 .392 -.575 1.287 -.997 1.72c-.579 .6 -1.674 .4 -2.322 .051c-.71 -.386 -.07 -1.28 -.346 -1.267c-.276 .014 -.776 -1.486 -.776 -2.236c0 -.828 .622 -1.674 1.235 -2.211a6.811 6.811 0 0 1 .46 -3.143a7.414 7.414 0 0 1 2.208 -2.615s-1.353 -1.534 -.849 -2.912c.328 -.902 .46 -.895 .567 -.935c.38 -.12 .727 -.33 1.013 -.612c.78 -.88 1.96 -1.438 3.116 -1.322c0 0 .781 -2.43 1.533 -1.936c.415 .653 .671 1.218 .967 1.936c0 0 1.15 -.7 1.25 -.5c.514 1.398 .487 3.204 .211 4.67c-.324 1.408 -.84 2.691 -1.711 3.83c-.094 .16 .98 .705 1.722 2.812c.686 1.928 .278 2.438 .278 2.688s.716 .144 2.296 -.855a5.848 5.848 0 0 1 2.984 -1.145c.735 -.066 .988 -.035 1.22 1c.232 1.035 -.346 1.406 -.744 1.506c0 0 -2.09 .675 -2.911 1.302z", "key": "svg-0" }]]);

var IconBrandYarn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandYarn
});

var IconBrandYatse = createReactComponent("outline", "brand-yatse", "IconBrandYatse", [["path", { "d": "M7 3l5 2.876v5.088l4.197 -2.73l4.803 2.731l-9.281 5.478l-2.383 1.41l-2.334 1.377l-3 1.77v-5.565l3 -1.771z", "key": "svg-0" }]]);

var IconBrandYatse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandYatse
});

var IconBrandYcombinator = createReactComponent("outline", "brand-ycombinator", "IconBrandYcombinator", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 7l4 6l4 -6", "key": "svg-1" }], ["path", { "d": "M12 17l0 -4", "key": "svg-2" }]]);

var IconBrandYcombinator$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandYcombinator
});

var IconBrandYoutubeKids = createReactComponent("outline", "brand-youtube-kids", "IconBrandYoutubeKids", [["path", { "d": "M18.608 17.75l-3.9 .268h-.027a13.83 13.83 0 0 0 -3.722 .828l-2.511 .908a4.111 4.111 0 0 1 -3.287 -.216a3.82 3.82 0 0 1 -1.98 -2.527l-1.376 -6.05a3.669 3.669 0 0 1 .536 -2.86a3.964 3.964 0 0 1 2.489 -1.661l11.25 -2.354c2.137 -.448 4.247 .85 4.713 2.9l1.403 6.162a3.677 3.677 0 0 1 -.697 3.086a4.007 4.007 0 0 1 -2.89 1.512v.002z", "key": "svg-0" }], ["path", { "d": "M9 10l1.208 5l4.292 -4z", "key": "svg-1" }]]);

var IconBrandYoutubeKids$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandYoutubeKids
});

var IconBrandYoutube = createReactComponent("outline", "brand-youtube", "IconBrandYoutube", [["path", { "d": "M2 8a4 4 0 0 1 4 -4h12a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-12a4 4 0 0 1 -4 -4v-8z", "key": "svg-0" }], ["path", { "d": "M10 9l5 3l-5 3z", "key": "svg-1" }]]);

var IconBrandYoutube$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandYoutube
});

var IconBrandZalando = createReactComponent("outline", "brand-zalando", "IconBrandZalando", [["path", { "d": "M7.531 21c-.65 0 -1 -.15 -1.196 -.27c-.266 -.157 -.753 -.563 -1.197 -1.747a20.583 20.583 0 0 1 -1.137 -6.983c.015 -2.745 .436 -5.07 1.137 -6.975c.444 -1.2 .93 -1.605 1.197 -1.763c.192 -.103 .545 -.262 1.195 -.262c.244 0 .532 .022 .871 .075a19.093 19.093 0 0 1 6.425 2.475h.007a19.572 19.572 0 0 1 5.287 4.508c.783 .99 .879 1.627 .879 1.942c0 .315 -.096 .953 -.879 1.943a19.571 19.571 0 0 1 -5.287 4.5h-.007a19.041 19.041 0 0 1 -6.425 2.474a5.01 5.01 0 0 1 -.871 .083z", "key": "svg-0" }]]);

var IconBrandZalando$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandZalando
});

var IconBrandZapier = createReactComponent("outline", "brand-zapier", "IconBrandZapier", [["path", { "d": "M3 12h6", "key": "svg-0" }], ["path", { "d": "M21 12h-6", "key": "svg-1" }], ["path", { "d": "M12 3v6", "key": "svg-2" }], ["path", { "d": "M12 15v6", "key": "svg-3" }], ["path", { "d": "M5.636 5.636l4.243 4.243", "key": "svg-4" }], ["path", { "d": "M18.364 18.364l-4.243 -4.243", "key": "svg-5" }], ["path", { "d": "M18.364 5.636l-4.243 4.243", "key": "svg-6" }], ["path", { "d": "M9.879 14.121l-4.243 4.243", "key": "svg-7" }]]);

var IconBrandZapier$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandZapier
});

var IconBrandZeit = createReactComponent("outline", "brand-zeit", "IconBrandZeit", [["path", { "d": "M3 20h18l-9 -16z", "key": "svg-0" }]]);

var IconBrandZeit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandZeit
});

var IconBrandZhihu = createReactComponent("outline", "brand-zhihu", "IconBrandZhihu", [["path", { "d": "M14 6h6v12h-2l-2 2l-1 -2h-1z", "key": "svg-0" }], ["path", { "d": "M4 12h6.5", "key": "svg-1" }], ["path", { "d": "M10.5 6h-5", "key": "svg-2" }], ["path", { "d": "M6 4c-.5 2.5 -1.5 3.5 -2.5 4.5", "key": "svg-3" }], ["path", { "d": "M8 6v7c0 4.5 -2 5.5 -4 7", "key": "svg-4" }], ["path", { "d": "M11 18l-3 -5", "key": "svg-5" }]]);

var IconBrandZhihu$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandZhihu
});

var IconBrandZoom = createReactComponent("outline", "brand-zoom", "IconBrandZoom", [["path", { "d": "M17.011 9.385v5.128l3.989 3.487v-12z", "key": "svg-0" }], ["path", { "d": "M3.887 6h10.08c1.468 0 3.033 1.203 3.033 2.803v8.196a.991 .991 0 0 1 -.975 1h-10.373c-1.667 0 -2.652 -1.5 -2.652 -3l.01 -8a.882 .882 0 0 1 .208 -.71a.841 .841 0 0 1 .67 -.287z", "key": "svg-1" }]]);

var IconBrandZoom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandZoom
});

var IconBrandZulip = createReactComponent("outline", "brand-zulip", "IconBrandZulip", [["path", { "d": "M6.5 3h11c1.325 0 2.5 1 2.5 2.5c0 2 -1.705 3.264 -2 3.5l-4.5 4l2 -5h-9a2.5 2.5 0 0 1 0 -5z", "key": "svg-0" }], ["path", { "d": "M17.5 21h-11c-1.325 0 -2.5 -1 -2.5 -2.5c0 -2 1.705 -3.264 2 -3.5l4.5 -4l-2 5h9a2.5 2.5 0 1 1 0 5z", "key": "svg-1" }]]);

var IconBrandZulip$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandZulip
});

var IconBrandZwift = createReactComponent("outline", "brand-zwift", "IconBrandZwift", [["path", { "d": "M5.5 4c-1.465 0 -2.5 1.101 -2.5 2.5s1.035 2.5 2.5 2.5h2.5l-4.637 7.19a2.434 2.434 0 0 0 -.011 2.538c.473 .787 1.35 1.272 2.3 1.272h10.848c1.465 0 2.5 -1.101 2.5 -2.5s-1.035 -2.5 -2.5 -2.5h-2.5l7 -11h-15.5z", "key": "svg-0" }]]);

var IconBrandZwift$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandZwift
});

var IconBreadOff = createReactComponent("outline", "bread-off", "IconBreadOff", [["path", { "d": "M8 4l10 .005v-.005a3 3 0 0 1 2 5.235v6.765m-.59 3.418c-.36 .36 -.86 .582 -1.41 .582h-12a2 2 0 0 1 -2 -2v-8.764a3 3 0 0 1 .418 -4.785", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconBreadOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBreadOff
});

var IconBread = createReactComponent("outline", "bread", "IconBread", [["path", { "d": "M18 4a3 3 0 0 1 2 5.235v8.765a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-8.764a3 3 0 0 1 1.824 -5.231h12.176v-.005z", "key": "svg-0" }]]);

var IconBread$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBread
});

var IconBriefcase2 = createReactComponent("outline", "briefcase-2", "IconBriefcase2", [["path", { "d": "M3 9a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9z", "key": "svg-0" }], ["path", { "d": "M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2", "key": "svg-1" }]]);

var IconBriefcase2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBriefcase2
});

var IconBriefcaseOff = createReactComponent("outline", "briefcase-off", "IconBriefcaseOff", [["path", { "d": "M11 7h8a2 2 0 0 1 2 2v8m-1.166 2.818a1.993 1.993 0 0 1 -.834 .182h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M8.185 4.158a2 2 0 0 1 1.815 -1.158h4a2 2 0 0 1 2 2v2", "key": "svg-1" }], ["path", { "d": "M12 12v.01", "key": "svg-2" }], ["path", { "d": "M3 13a20 20 0 0 0 11.905 1.928m3.263 -.763a20 20 0 0 0 2.832 -1.165", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconBriefcaseOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBriefcaseOff
});

var IconBriefcase = createReactComponent("outline", "briefcase", "IconBriefcase", [["path", { "d": "M3 7m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2", "key": "svg-1" }], ["path", { "d": "M12 12l0 .01", "key": "svg-2" }], ["path", { "d": "M3 13a20 20 0 0 0 18 0", "key": "svg-3" }]]);

var IconBriefcase$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBriefcase
});

var IconBrightness2 = createReactComponent("outline", "brightness-2", "IconBrightness2", [["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z", "key": "svg-1" }]]);

var IconBrightness2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrightness2
});

var IconBrightnessAuto = createReactComponent("outline", "brightness-auto", "IconBrightnessAuto", [["path", { "d": "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z", "key": "svg-0" }], ["path", { "d": "M10 14.5v-3.5a2 2 0 1 1 4 0v3.5", "key": "svg-1" }], ["path", { "d": "M10 13h4", "key": "svg-2" }]]);

var IconBrightnessAuto$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrightnessAuto
});

var IconBrightnessDown = createReactComponent("outline", "brightness-down", "IconBrightnessDown", [["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12 5l0 .01", "key": "svg-1" }], ["path", { "d": "M17 7l0 .01", "key": "svg-2" }], ["path", { "d": "M19 12l0 .01", "key": "svg-3" }], ["path", { "d": "M17 17l0 .01", "key": "svg-4" }], ["path", { "d": "M12 19l0 .01", "key": "svg-5" }], ["path", { "d": "M7 17l0 .01", "key": "svg-6" }], ["path", { "d": "M5 12l0 .01", "key": "svg-7" }], ["path", { "d": "M7 7l0 .01", "key": "svg-8" }]]);

var IconBrightnessDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrightnessDown
});

var IconBrightnessHalf = createReactComponent("outline", "brightness-half", "IconBrightnessHalf", [["path", { "d": "M12 9a3 3 0 0 0 0 6v-6z", "key": "svg-0" }], ["path", { "d": "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z", "key": "svg-1" }]]);

var IconBrightnessHalf$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrightnessHalf
});

var IconBrightnessOff = createReactComponent("outline", "brightness-off", "IconBrightnessOff", [["path", { "d": "M12 3v5m0 4v9", "key": "svg-0" }], ["path", { "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098", "key": "svg-1" }], ["path", { "d": "M12.5 8.5l4.15 -4.15", "key": "svg-2" }], ["path", { "d": "M12 14l1.025 -.983m2.065 -1.981l4.28 -4.106", "key": "svg-3" }], ["path", { "d": "M12 19.6l3.79 -3.79m2 -2l3.054 -3.054", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconBrightnessOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrightnessOff
});

var IconBrightnessUp = createReactComponent("outline", "brightness-up", "IconBrightnessUp", [["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12 5l0 -2", "key": "svg-1" }], ["path", { "d": "M17 7l1.4 -1.4", "key": "svg-2" }], ["path", { "d": "M19 12l2 0", "key": "svg-3" }], ["path", { "d": "M17 17l1.4 1.4", "key": "svg-4" }], ["path", { "d": "M12 19l0 2", "key": "svg-5" }], ["path", { "d": "M7 17l-1.4 1.4", "key": "svg-6" }], ["path", { "d": "M6 12l-2 0", "key": "svg-7" }], ["path", { "d": "M7 7l-1.4 -1.4", "key": "svg-8" }]]);

var IconBrightnessUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrightnessUp
});

var IconBrightness = createReactComponent("outline", "brightness", "IconBrightness", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 3l0 18", "key": "svg-1" }], ["path", { "d": "M12 9l4.65 -4.65", "key": "svg-2" }], ["path", { "d": "M12 14.3l7.37 -7.37", "key": "svg-3" }], ["path", { "d": "M12 19.6l8.85 -8.85", "key": "svg-4" }]]);

var IconBrightness$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrightness
});

var IconBroadcastOff = createReactComponent("outline", "broadcast-off", "IconBroadcastOff", [["path", { "d": "M18.364 19.364a9 9 0 0 0 -9.721 -14.717m-2.488 1.509a9 9 0 0 0 -.519 13.208", "key": "svg-0" }], ["path", { "d": "M15.536 16.536a5 5 0 0 0 -3.536 -8.536m-3 1a5 5 0 0 0 -.535 7.536", "key": "svg-1" }], ["path", { "d": "M12 12a1 1 0 1 0 1 1", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconBroadcastOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBroadcastOff
});

var IconBroadcast = createReactComponent("outline", "broadcast", "IconBroadcast", [["path", { "d": "M18.364 19.364a9 9 0 1 0 -12.728 0", "key": "svg-0" }], ["path", { "d": "M15.536 16.536a5 5 0 1 0 -7.072 0", "key": "svg-1" }], ["path", { "d": "M12 13m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }]]);

var IconBroadcast$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBroadcast
});

var IconBrowserCheck = createReactComponent("outline", "browser-check", "IconBrowserCheck", [["path", { "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M4 8h16", "key": "svg-1" }], ["path", { "d": "M8 4v4", "key": "svg-2" }], ["path", { "d": "M9.5 14.5l1.5 1.5l3 -3", "key": "svg-3" }]]);

var IconBrowserCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrowserCheck
});

var IconBrowserMaximize = createReactComponent("outline", "browser-maximize", "IconBrowserMaximize", [["path", { "d": "M4 8h8", "key": "svg-0" }], ["path", { "d": "M20 11.5v6.5a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h6.5", "key": "svg-1" }], ["path", { "d": "M8 4v4", "key": "svg-2" }], ["path", { "d": "M16 8l5 -5", "key": "svg-3" }], ["path", { "d": "M21 7.5v-4.5h-4.5", "key": "svg-4" }]]);

var IconBrowserMaximize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrowserMaximize
});

var IconBrowserMinus = createReactComponent("outline", "browser-minus", "IconBrowserMinus", [["path", { "d": "M4 8h16", "key": "svg-0" }], ["path", { "d": "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v9", "key": "svg-1" }], ["path", { "d": "M8 4v4", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconBrowserMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrowserMinus
});

var IconBrowserOff = createReactComponent("outline", "browser-off", "IconBrowserOff", [["path", { "d": "M8 4h11a1 1 0 0 1 1 1v11m-.288 3.702a1 1 0 0 1 -.712 .298h-14a1 1 0 0 1 -1 -1v-14c0 -.276 .112 -.526 .293 -.707", "key": "svg-0" }], ["path", { "d": "M4 8h4m4 0h8", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconBrowserOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrowserOff
});

var IconBrowserPlus = createReactComponent("outline", "browser-plus", "IconBrowserPlus", [["path", { "d": "M4 8h16", "key": "svg-0" }], ["path", { "d": "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6", "key": "svg-1" }], ["path", { "d": "M8 4v4", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconBrowserPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrowserPlus
});

var IconBrowserShare = createReactComponent("outline", "browser-share", "IconBrowserShare", [["path", { "d": "M4 8h16", "key": "svg-0" }], ["path", { "d": "M12.5 20h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7", "key": "svg-1" }], ["path", { "d": "M8 4v4", "key": "svg-2" }], ["path", { "d": "M16 22l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-4" }]]);

var IconBrowserShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrowserShare
});

var IconBrowserX = createReactComponent("outline", "browser-x", "IconBrowserX", [["path", { "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M4 8h16", "key": "svg-1" }], ["path", { "d": "M8 4v4", "key": "svg-2" }], ["path", { "d": "M10 16l4 -4", "key": "svg-3" }], ["path", { "d": "M14 16l-4 -4", "key": "svg-4" }]]);

var IconBrowserX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrowserX
});

var IconBrowser = createReactComponent("outline", "browser", "IconBrowser", [["path", { "d": "M4 8h16", "key": "svg-0" }], ["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M8 4v4", "key": "svg-2" }]]);

var IconBrowser$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrowser
});

var IconBrushOff = createReactComponent("outline", "brush-off", "IconBrushOff", [["path", { "d": "M3 17a4 4 0 1 1 4 4h-4v-4z", "key": "svg-0" }], ["path", { "d": "M21 3a16 16 0 0 0 -9.309 4.704m-1.795 2.212a15.993 15.993 0 0 0 -1.696 3.284", "key": "svg-1" }], ["path", { "d": "M21 3a16 16 0 0 1 -4.697 9.302m-2.195 1.786a15.993 15.993 0 0 1 -3.308 1.712", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconBrushOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrushOff
});

var IconBrush = createReactComponent("outline", "brush", "IconBrush", [["path", { "d": "M3 21v-4a4 4 0 1 1 4 4h-4", "key": "svg-0" }], ["path", { "d": "M21 3a16 16 0 0 0 -12.8 10.2", "key": "svg-1" }], ["path", { "d": "M21 3a16 16 0 0 1 -10.2 12.8", "key": "svg-2" }], ["path", { "d": "M10.6 9a9 9 0 0 1 4.4 4.4", "key": "svg-3" }]]);

var IconBrush$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrush
});

var IconBubbleMinus = createReactComponent("outline", "bubble-minus", "IconBubbleMinus", [["path", { "d": "M12.4 19a4.2 4.2 0 0 1 -1.57 -.298l-3.83 2.298v-3.134a2.668 2.668 0 0 1 -1.795 -3.773a4.8 4.8 0 0 1 2.908 -8.933a5.335 5.335 0 0 1 9.194 1.078a5.333 5.333 0 0 1 3.404 8.771", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconBubbleMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBubbleMinus
});

var IconBubblePlus = createReactComponent("outline", "bubble-plus", "IconBubblePlus", [["path", { "d": "M12.4 19a4.2 4.2 0 0 1 -1.57 -.298l-3.83 2.298v-3.134a2.668 2.668 0 0 1 -1.795 -3.773a4.8 4.8 0 0 1 2.908 -8.933a5.335 5.335 0 0 1 9.194 1.078a5.333 5.333 0 0 1 4.45 6.89", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconBubblePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBubblePlus
});

var IconBubbleTea2 = createReactComponent("outline", "bubble-tea-2", "IconBubbleTea2", [["path", { "d": "M17.95 9l-1.478 8.69c-.25 1.463 -.374 2.195 -.936 2.631c-1.2 .931 -6.039 .88 -7.172 0c-.562 -.436 -.687 -1.168 -.936 -2.632l-1.478 -8.689", "key": "svg-0" }], ["path", { "d": "M6 9l.514 -1.286a5.908 5.908 0 0 1 10.972 0l.514 1.286", "key": "svg-1" }], ["path", { "d": "M5 9h14", "key": "svg-2" }], ["path", { "d": "M12 9l4 -7", "key": "svg-3" }], ["path", { "d": "M7 14c.593 .642 1.484 1.017 2.5 1c1.016 .017 1.907 -.358 2.5 -1s1.484 -1.017 2.5 -1c1.016 -.017 1.907 .358 2.5 1", "key": "svg-4" }]]);

var IconBubbleTea2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBubbleTea2
});

var IconBubbleTea = createReactComponent("outline", "bubble-tea", "IconBubbleTea", [["path", { "d": "M17.95 9l-1.478 8.69c-.25 1.463 -.374 2.195 -.936 2.631c-1.2 .931 -6.039 .88 -7.172 0c-.562 -.436 -.687 -1.168 -.936 -2.632l-1.478 -8.689", "key": "svg-0" }], ["path", { "d": "M6 9l.514 -1.286a5.908 5.908 0 0 1 10.972 0l.514 1.286", "key": "svg-1" }], ["path", { "d": "M5 9h14", "key": "svg-2" }], ["path", { "d": "M12 9l4 -7", "key": "svg-3" }], ["path", { "d": "M10.01 14h.01", "key": "svg-4" }], ["path", { "d": "M11.02 18h.01", "key": "svg-5" }], ["path", { "d": "M13.02 16h.01", "key": "svg-6" }]]);

var IconBubbleTea$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBubbleTea
});

var IconBubbleText = createReactComponent("outline", "bubble-text", "IconBubbleText", [["path", { "d": "M7 10h10", "key": "svg-0" }], ["path", { "d": "M9 14h5", "key": "svg-1" }], ["path", { "d": "M12.4 3a5.34 5.34 0 0 1 4.906 3.239a5.333 5.333 0 0 1 -1.195 10.6a4.26 4.26 0 0 1 -5.28 1.863l-3.831 2.298v-3.134a2.668 2.668 0 0 1 -1.795 -3.773a4.8 4.8 0 0 1 2.908 -8.933a5.33 5.33 0 0 1 4.287 -2.16", "key": "svg-2" }]]);

var IconBubbleText$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBubbleText
});

var IconBubbleX = createReactComponent("outline", "bubble-x", "IconBubbleX", [["path", { "d": "M13.5 18.75c-.345 .09 -.727 .25 -1.1 .25a4.3 4.3 0 0 1 -1.57 -.298l-3.83 2.298v-3.134a2.668 2.668 0 0 1 -1.795 -3.773a4.8 4.8 0 0 1 2.908 -8.933a5.335 5.335 0 0 1 9.194 1.078a5.333 5.333 0 0 1 4.484 6.778", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }]]);

var IconBubbleX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBubbleX
});

var IconBubble = createReactComponent("outline", "bubble", "IconBubble", [["path", { "d": "M12.4 3a5.34 5.34 0 0 1 4.906 3.239a5.333 5.333 0 0 1 -1.195 10.6a4.26 4.26 0 0 1 -5.28 1.863l-3.831 2.298v-3.134a2.668 2.668 0 0 1 -1.795 -3.773a4.8 4.8 0 0 1 2.908 -8.933a5.33 5.33 0 0 1 4.287 -2.16", "key": "svg-0" }]]);

var IconBubble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBubble
});

var IconBucketDroplet = createReactComponent("outline", "bucket-droplet", "IconBucketDroplet", [["path", { "d": "M5 16l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z", "key": "svg-0" }], ["path", { "d": "M13.737 9.737c2.299 -2.3 3.23 -5.095 2.081 -6.245c-1.15 -1.15 -3.945 -.217 -6.244 2.082c-2.3 2.299 -3.231 5.095 -2.082 6.244c1.15 1.15 3.946 .218 6.245 -2.081z", "key": "svg-1" }], ["path", { "d": "M7.492 11.818c.362 .362 .768 .676 1.208 .934l6.895 4.047c1.078 .557 2.255 -.075 3.692 -1.512c1.437 -1.437 2.07 -2.614 1.512 -3.692c-.372 -.718 -1.72 -3.017 -4.047 -6.895a6.015 6.015 0 0 0 -.934 -1.208", "key": "svg-2" }]]);

var IconBucketDroplet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBucketDroplet
});

var IconBucketOff = createReactComponent("outline", "bucket-off", "IconBucketOff", [["path", { "d": "M5.029 5.036c-.655 .58 -1.029 1.25 -1.029 1.964c0 2.033 3.033 3.712 6.96 3.967m3.788 -.21c3.064 -.559 5.252 -2.029 5.252 -3.757c0 -2.21 -3.582 -4 -8 -4c-1.605 0 -3.1 .236 -4.352 .643", "key": "svg-0" }], ["path", { "d": "M4 7c0 .664 .088 1.324 .263 1.965l2.737 10.035c.5 1.5 2.239 2 5 2s4.5 -.5 5 -2c.1 -.3 .252 -.812 .457 -1.535m.862 -3.146c.262 -.975 .735 -2.76 1.418 -5.354a7.45 7.45 0 0 0 .263 -1.965", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconBucketOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBucketOff
});

var IconBucket = createReactComponent("outline", "bucket", "IconBucket", [["path", { "d": "M12 7m-8 0a8 4 0 1 0 16 0a8 4 0 1 0 -16 0", "key": "svg-0" }], ["path", { "d": "M4 7c0 .664 .088 1.324 .263 1.965l2.737 10.035c.5 1.5 2.239 2 5 2s4.5 -.5 5 -2c.333 -1 1.246 -4.345 2.737 -10.035a7.45 7.45 0 0 0 .263 -1.965", "key": "svg-1" }]]);

var IconBucket$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBucket
});

var IconBugOff = createReactComponent("outline", "bug-off", "IconBugOff", [["path", { "d": "M9.884 5.873a3 3 0 0 1 5.116 2.127v1", "key": "svg-0" }], ["path", { "d": "M13 9h3a6 6 0 0 1 1 3v1m-.298 3.705a5 5 0 0 1 -9.702 -1.705v-3a6 6 0 0 1 1 -3h1", "key": "svg-1" }], ["path", { "d": "M3 13h4", "key": "svg-2" }], ["path", { "d": "M17 13h4", "key": "svg-3" }], ["path", { "d": "M12 20v-6", "key": "svg-4" }], ["path", { "d": "M4 19l3.35 -2", "key": "svg-5" }], ["path", { "d": "M4 7l3.75 2.4", "key": "svg-6" }], ["path", { "d": "M20 7l-3.75 2.4", "key": "svg-7" }], ["path", { "d": "M3 3l18 18", "key": "svg-8" }]]);

var IconBugOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBugOff
});

var IconBug = createReactComponent("outline", "bug", "IconBug", [["path", { "d": "M9 9v-1a3 3 0 0 1 6 0v1", "key": "svg-0" }], ["path", { "d": "M8 9h8a6 6 0 0 1 1 3v3a5 5 0 0 1 -10 0v-3a6 6 0 0 1 1 -3", "key": "svg-1" }], ["path", { "d": "M3 13l4 0", "key": "svg-2" }], ["path", { "d": "M17 13l4 0", "key": "svg-3" }], ["path", { "d": "M12 20l0 -6", "key": "svg-4" }], ["path", { "d": "M4 19l3.35 -2", "key": "svg-5" }], ["path", { "d": "M20 19l-3.35 -2", "key": "svg-6" }], ["path", { "d": "M4 7l3.75 2.4", "key": "svg-7" }], ["path", { "d": "M20 7l-3.75 2.4", "key": "svg-8" }]]);

var IconBug$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBug
});

var IconBuildingAirport = createReactComponent("outline", "building-airport", "IconBuildingAirport", [["path", { "d": "M3.59 7h8.82a1 1 0 0 1 .902 1.433l-1.44 3a1 1 0 0 1 -.901 .567h-5.942a1 1 0 0 1 -.901 -.567l-1.44 -3a1 1 0 0 1 .901 -1.433", "key": "svg-0" }], ["path", { "d": "M6 7l-.78 -2.342a.5 .5 0 0 1 .473 -.658h4.612a.5 .5 0 0 1 .475 .658l-.78 2.342", "key": "svg-1" }], ["path", { "d": "M8 2v2", "key": "svg-2" }], ["path", { "d": "M6 12v9h4v-9", "key": "svg-3" }], ["path", { "d": "M3 21h18", "key": "svg-4" }], ["path", { "d": "M22 5h-6l-1 -1", "key": "svg-5" }], ["path", { "d": "M18 3l2 2l-2 2", "key": "svg-6" }], ["path", { "d": "M10 17h7a2 2 0 0 1 2 2v2", "key": "svg-7" }]]);

var IconBuildingAirport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingAirport
});

var IconBuildingArch = createReactComponent("outline", "building-arch", "IconBuildingArch", [["path", { "d": "M3 21l18 0", "key": "svg-0" }], ["path", { "d": "M4 21v-15a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v15", "key": "svg-1" }], ["path", { "d": "M9 21v-8a3 3 0 0 1 6 0v8", "key": "svg-2" }]]);

var IconBuildingArch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingArch
});

var IconBuildingBank = createReactComponent("outline", "building-bank", "IconBuildingBank", [["path", { "d": "M3 21l18 0", "key": "svg-0" }], ["path", { "d": "M3 10l18 0", "key": "svg-1" }], ["path", { "d": "M5 6l7 -3l7 3", "key": "svg-2" }], ["path", { "d": "M4 10l0 11", "key": "svg-3" }], ["path", { "d": "M20 10l0 11", "key": "svg-4" }], ["path", { "d": "M8 14l0 3", "key": "svg-5" }], ["path", { "d": "M12 14l0 3", "key": "svg-6" }], ["path", { "d": "M16 14l0 3", "key": "svg-7" }]]);

var IconBuildingBank$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingBank
});

var IconBuildingBridge2 = createReactComponent("outline", "building-bridge-2", "IconBuildingBridge2", [["path", { "d": "M6 7h12a2 2 0 0 1 2 2v9a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a4 4 0 0 0 -8 0v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-9a2 2 0 0 1 2 -2", "key": "svg-0" }]]);

var IconBuildingBridge2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingBridge2
});

var IconBuildingBridge = createReactComponent("outline", "building-bridge", "IconBuildingBridge", [["path", { "d": "M6 5l0 14", "key": "svg-0" }], ["path", { "d": "M18 5l0 14", "key": "svg-1" }], ["path", { "d": "M2 15l20 0", "key": "svg-2" }], ["path", { "d": "M3 8a7.5 7.5 0 0 0 3 -2a6.5 6.5 0 0 0 12 0a7.5 7.5 0 0 0 3 2", "key": "svg-3" }], ["path", { "d": "M12 10l0 5", "key": "svg-4" }]]);

var IconBuildingBridge$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingBridge
});

var IconBuildingBroadcastTower = createReactComponent("outline", "building-broadcast-tower", "IconBuildingBroadcastTower", [["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M16.616 13.924a5 5 0 1 0 -9.23 0", "key": "svg-1" }], ["path", { "d": "M20.307 15.469a9 9 0 1 0 -16.615 0", "key": "svg-2" }], ["path", { "d": "M9 21l3 -9l3 9", "key": "svg-3" }], ["path", { "d": "M10 19h4", "key": "svg-4" }]]);

var IconBuildingBroadcastTower$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingBroadcastTower
});

var IconBuildingBurjAlArab = createReactComponent("outline", "building-burj-al-arab", "IconBuildingBurjAlArab", [["path", { "d": "M3 21h18", "key": "svg-0" }], ["path", { "d": "M7 21v-18", "key": "svg-1" }], ["path", { "d": "M7 4c5.675 .908 10 5.613 10 11.28a11 11 0 0 1 -1.605 5.72", "key": "svg-2" }], ["path", { "d": "M5 9h12", "key": "svg-3" }], ["path", { "d": "M7 13h4", "key": "svg-4" }], ["path", { "d": "M7 17h4", "key": "svg-5" }]]);

var IconBuildingBurjAlArab$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingBurjAlArab
});

var IconBuildingCarousel = createReactComponent("outline", "building-carousel", "IconBuildingCarousel", [["path", { "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-0" }], ["path", { "d": "M5 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M12 4m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M5 16m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M19 16m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-5" }], ["path", { "d": "M8 22l4 -10l4 10", "key": "svg-6" }]]);

var IconBuildingCarousel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingCarousel
});

var IconBuildingCastle = createReactComponent("outline", "building-castle", "IconBuildingCastle", [["path", { "d": "M15 19v-2a3 3 0 0 0 -6 0v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14h4v3h3v-3h4v3h3v-3h4v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M3 11l18 0", "key": "svg-1" }]]);

var IconBuildingCastle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingCastle
});

var IconBuildingChurch = createReactComponent("outline", "building-church", "IconBuildingChurch", [["path", { "d": "M3 21l18 0", "key": "svg-0" }], ["path", { "d": "M10 21v-4a2 2 0 0 1 4 0v4", "key": "svg-1" }], ["path", { "d": "M10 5l4 0", "key": "svg-2" }], ["path", { "d": "M12 3l0 5", "key": "svg-3" }], ["path", { "d": "M6 21v-7m-2 2l8 -8l8 8m-2 -2v7", "key": "svg-4" }]]);

var IconBuildingChurch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingChurch
});

var IconBuildingCircus = createReactComponent("outline", "building-circus", "IconBuildingCircus", [["path", { "d": "M4 11h16", "key": "svg-0" }], ["path", { "d": "M12 6.5c0 1 -5 4.5 -8 4.5", "key": "svg-1" }], ["path", { "d": "M12 6.5c0 1 5 4.5 8 4.5", "key": "svg-2" }], ["path", { "d": "M6 11c-.333 5.333 -1 8.667 -2 10h4c1 0 4 -4 4 -9v-1", "key": "svg-3" }], ["path", { "d": "M18 11c.333 5.333 1 8.667 2 10h-4c-1 0 -4 -4 -4 -9v-1", "key": "svg-4" }], ["path", { "d": "M12 7v-4l2 1h-2", "key": "svg-5" }]]);

var IconBuildingCircus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingCircus
});

var IconBuildingCog = createReactComponent("outline", "building-cog", "IconBuildingCog", [["path", { "d": "M3 21h9", "key": "svg-0" }], ["path", { "d": "M9 8h1", "key": "svg-1" }], ["path", { "d": "M9 12h1", "key": "svg-2" }], ["path", { "d": "M9 16h1", "key": "svg-3" }], ["path", { "d": "M14 8h1", "key": "svg-4" }], ["path", { "d": "M14 12h1", "key": "svg-5" }], ["path", { "d": "M5 21v-16c0 -.53 .211 -1.039 .586 -1.414c.375 -.375 .884 -.586 1.414 -.586h10c.53 0 1.039 .211 1.414 .586c.375 .375 .586 .884 .586 1.414v7", "key": "svg-6" }], ["path", { "d": "M16 18c0 .53 .211 1.039 .586 1.414c.375 .375 .884 .586 1.414 .586c.53 0 1.039 -.211 1.414 -.586c.375 -.375 .586 -.884 .586 -1.414c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586c-.53 0 -1.039 .211 -1.414 .586c-.375 .375 -.586 .884 -.586 1.414z", "key": "svg-7" }], ["path", { "d": "M18 14.5v1.5", "key": "svg-8" }], ["path", { "d": "M18 20v1.5", "key": "svg-9" }], ["path", { "d": "M21.032 16.25l-1.299 .75", "key": "svg-10" }], ["path", { "d": "M16.27 19l-1.3 .75", "key": "svg-11" }], ["path", { "d": "M14.97 16.25l1.3 .75", "key": "svg-12" }], ["path", { "d": "M19.733 19l1.3 .75", "key": "svg-13" }]]);

var IconBuildingCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingCog
});

var IconBuildingCommunity = createReactComponent("outline", "building-community", "IconBuildingCommunity", [["path", { "d": "M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8", "key": "svg-0" }], ["path", { "d": "M13 7l0 .01", "key": "svg-1" }], ["path", { "d": "M17 7l0 .01", "key": "svg-2" }], ["path", { "d": "M17 11l0 .01", "key": "svg-3" }], ["path", { "d": "M17 15l0 .01", "key": "svg-4" }]]);

var IconBuildingCommunity$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingCommunity
});

var IconBuildingCottage = createReactComponent("outline", "building-cottage", "IconBuildingCottage", [["path", { "d": "M3 21l18 0", "key": "svg-0" }], ["path", { "d": "M4 21v-11l2.5 -4.5l5.5 -2.5l5.5 2.5l2.5 4.5v11", "key": "svg-1" }], ["path", { "d": "M12 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M9 21v-5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v5", "key": "svg-3" }]]);

var IconBuildingCottage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingCottage
});

var IconBuildingEstate = createReactComponent("outline", "building-estate", "IconBuildingEstate", [["path", { "d": "M3 21h18", "key": "svg-0" }], ["path", { "d": "M19 21v-4", "key": "svg-1" }], ["path", { "d": "M19 17a2 2 0 0 0 2 -2v-2a2 2 0 1 0 -4 0v2a2 2 0 0 0 2 2z", "key": "svg-2" }], ["path", { "d": "M14 21v-14a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v14", "key": "svg-3" }], ["path", { "d": "M9 17v4", "key": "svg-4" }], ["path", { "d": "M8 13h2", "key": "svg-5" }], ["path", { "d": "M8 9h2", "key": "svg-6" }]]);

var IconBuildingEstate$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingEstate
});

var IconBuildingFactory2 = createReactComponent("outline", "building-factory-2", "IconBuildingFactory2", [["path", { "d": "M3 21h18", "key": "svg-0" }], ["path", { "d": "M5 21v-12l5 4v-4l5 4h4", "key": "svg-1" }], ["path", { "d": "M19 21v-8l-1.436 -9.574a.5 .5 0 0 0 -.495 -.426h-1.145a.5 .5 0 0 0 -.494 .418l-1.43 8.582", "key": "svg-2" }], ["path", { "d": "M9 17h1", "key": "svg-3" }], ["path", { "d": "M14 17h1", "key": "svg-4" }]]);

var IconBuildingFactory2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingFactory2
});

var IconBuildingFactory = createReactComponent("outline", "building-factory", "IconBuildingFactory", [["path", { "d": "M4 21c1.147 -4.02 1.983 -8.027 2 -12h6c.017 3.973 .853 7.98 2 12", "key": "svg-0" }], ["path", { "d": "M12.5 13h4.5c.025 2.612 .894 5.296 2 8", "key": "svg-1" }], ["path", { "d": "M9 5a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1", "key": "svg-2" }], ["path", { "d": "M3 21l19 0", "key": "svg-3" }]]);

var IconBuildingFactory$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingFactory
});

var IconBuildingFortress = createReactComponent("outline", "building-fortress", "IconBuildingFortress", [["path", { "d": "M7 21h1a1 1 0 0 0 1 -1v-1h0a3 3 0 0 1 6 0m3 2h1a1 1 0 0 0 1 -1v-15l-3 -2l-3 2v6h-4v-6l-3 -2l-3 2v15a1 1 0 0 0 1 1h2m8 -2v1a1 1 0 0 0 1 1h2", "key": "svg-0" }], ["path", { "d": "M7 7h0v.01", "key": "svg-1" }], ["path", { "d": "M7 10h0v.01", "key": "svg-2" }], ["path", { "d": "M7 13h0v.01", "key": "svg-3" }], ["path", { "d": "M17 7h0v.01", "key": "svg-4" }], ["path", { "d": "M17 10h0v.01", "key": "svg-5" }], ["path", { "d": "M17 13h0v.01", "key": "svg-6" }]]);

var IconBuildingFortress$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingFortress
});

var IconBuildingHospital = createReactComponent("outline", "building-hospital", "IconBuildingHospital", [["path", { "d": "M3 21l18 0", "key": "svg-0" }], ["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16", "key": "svg-1" }], ["path", { "d": "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4", "key": "svg-2" }], ["path", { "d": "M10 9l4 0", "key": "svg-3" }], ["path", { "d": "M12 7l0 4", "key": "svg-4" }]]);

var IconBuildingHospital$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingHospital
});

var IconBuildingLighthouse = createReactComponent("outline", "building-lighthouse", "IconBuildingLighthouse", [["path", { "d": "M12 3l2 3l2 15h-8l2 -15z", "key": "svg-0" }], ["path", { "d": "M8 9l8 0", "key": "svg-1" }], ["path", { "d": "M3 11l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M21 11l-2 -2l2 -2", "key": "svg-3" }]]);

var IconBuildingLighthouse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingLighthouse
});

var IconBuildingMinus = createReactComponent("outline", "building-minus", "IconBuildingMinus", [["path", { "d": "M3 21h9", "key": "svg-0" }], ["path", { "d": "M9 8h1", "key": "svg-1" }], ["path", { "d": "M9 12h1", "key": "svg-2" }], ["path", { "d": "M9 16h1", "key": "svg-3" }], ["path", { "d": "M14 8h1", "key": "svg-4" }], ["path", { "d": "M14 12h1", "key": "svg-5" }], ["path", { "d": "M5 21v-16c0 -.53 .211 -1.039 .586 -1.414c.375 -.375 .884 -.586 1.414 -.586h10c.53 0 1.039 .211 1.414 .586c.375 .375 .586 .884 .586 1.414v7", "key": "svg-6" }], ["path", { "d": "M16 19h6", "key": "svg-7" }]]);

var IconBuildingMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingMinus
});

var IconBuildingMonument = createReactComponent("outline", "building-monument", "IconBuildingMonument", [["path", { "d": "M8 18l2 -13l2 -2l2 2l2 13", "key": "svg-0" }], ["path", { "d": "M5 21v-3h14v3", "key": "svg-1" }], ["path", { "d": "M3 21l18 0", "key": "svg-2" }]]);

var IconBuildingMonument$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingMonument
});

var IconBuildingMosque = createReactComponent("outline", "building-mosque", "IconBuildingMosque", [["path", { "d": "M3 21h7v-2a2 2 0 1 1 4 0v2h7", "key": "svg-0" }], ["path", { "d": "M4 21v-10", "key": "svg-1" }], ["path", { "d": "M20 21v-10", "key": "svg-2" }], ["path", { "d": "M4 16h3v-3h10v3h3", "key": "svg-3" }], ["path", { "d": "M17 13a5 5 0 0 0 -10 0", "key": "svg-4" }], ["path", { "d": "M21 10.5c0 -.329 -.077 -.653 -.224 -.947l-.776 -1.553l-.776 1.553a2.118 2.118 0 0 0 -.224 .947a.5 .5 0 0 0 .5 .5h1a.5 .5 0 0 0 .5 -.5z", "key": "svg-5" }], ["path", { "d": "M5 10.5c0 -.329 -.077 -.653 -.224 -.947l-.776 -1.553l-.776 1.553a2.118 2.118 0 0 0 -.224 .947a.5 .5 0 0 0 .5 .5h1a.5 .5 0 0 0 .5 -.5z", "key": "svg-6" }], ["path", { "d": "M12 2a2 2 0 1 0 2 2", "key": "svg-7" }], ["path", { "d": "M12 6v2", "key": "svg-8" }]]);

var IconBuildingMosque$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingMosque
});

var IconBuildingOff = createReactComponent("outline", "building-off", "IconBuildingOff", [["path", { "d": "M3 21h18", "key": "svg-0" }], ["path", { "d": "M9 12h1", "key": "svg-1" }], ["path", { "d": "M9 16h1", "key": "svg-2" }], ["path", { "d": "M14 8h1", "key": "svg-3" }], ["path", { "d": "M14 16h1", "key": "svg-4" }], ["path", { "d": "M5 21v-16", "key": "svg-5" }], ["path", { "d": "M7 3h10c1 0 2 1 2 2v10", "key": "svg-6" }], ["path", { "d": "M19 19v2", "key": "svg-7" }], ["path", { "d": "M3 3l18 18", "key": "svg-8" }]]);

var IconBuildingOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingOff
});

var IconBuildingPavilion = createReactComponent("outline", "building-pavilion", "IconBuildingPavilion", [["path", { "d": "M3 21h7v-3a2 2 0 0 1 4 0v3h7", "key": "svg-0" }], ["path", { "d": "M6 21l0 -9", "key": "svg-1" }], ["path", { "d": "M18 21l0 -9", "key": "svg-2" }], ["path", { "d": "M6 12h12a3 3 0 0 0 3 -3a9 8 0 0 1 -9 -6a9 8 0 0 1 -9 6a3 3 0 0 0 3 3", "key": "svg-3" }]]);

var IconBuildingPavilion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingPavilion
});

var IconBuildingPlus = createReactComponent("outline", "building-plus", "IconBuildingPlus", [["path", { "d": "M3 21h9", "key": "svg-0" }], ["path", { "d": "M9 8h1", "key": "svg-1" }], ["path", { "d": "M9 12h1", "key": "svg-2" }], ["path", { "d": "M9 16h1", "key": "svg-3" }], ["path", { "d": "M14 8h1", "key": "svg-4" }], ["path", { "d": "M14 12h1", "key": "svg-5" }], ["path", { "d": "M5 21v-16c0 -.53 .211 -1.039 .586 -1.414c.375 -.375 .884 -.586 1.414 -.586h10c.53 0 1.039 .211 1.414 .586c.375 .375 .586 .884 .586 1.414v7", "key": "svg-6" }], ["path", { "d": "M16 19h6", "key": "svg-7" }], ["path", { "d": "M19 16v6", "key": "svg-8" }]]);

var IconBuildingPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingPlus
});

var IconBuildingSkyscraper = createReactComponent("outline", "building-skyscraper", "IconBuildingSkyscraper", [["path", { "d": "M3 21l18 0", "key": "svg-0" }], ["path", { "d": "M5 21v-14l8 -4v18", "key": "svg-1" }], ["path", { "d": "M19 21v-10l-6 -4", "key": "svg-2" }], ["path", { "d": "M9 9l0 .01", "key": "svg-3" }], ["path", { "d": "M9 12l0 .01", "key": "svg-4" }], ["path", { "d": "M9 15l0 .01", "key": "svg-5" }], ["path", { "d": "M9 18l0 .01", "key": "svg-6" }]]);

var IconBuildingSkyscraper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingSkyscraper
});

var IconBuildingStadium = createReactComponent("outline", "building-stadium", "IconBuildingStadium", [["path", { "d": "M12 12m-8 0a8 2 0 1 0 16 0a8 2 0 1 0 -16 0", "key": "svg-0" }], ["path", { "d": "M4 12v7c0 .94 2.51 1.785 6 2v-3h4v3c3.435 -.225 6 -1.07 6 -2v-7", "key": "svg-1" }], ["path", { "d": "M15 6h4v-3h-4v7", "key": "svg-2" }], ["path", { "d": "M7 6h4v-3h-4v7", "key": "svg-3" }]]);

var IconBuildingStadium$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingStadium
});

var IconBuildingStore = createReactComponent("outline", "building-store", "IconBuildingStore", [["path", { "d": "M3 21l18 0", "key": "svg-0" }], ["path", { "d": "M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4", "key": "svg-1" }], ["path", { "d": "M5 21l0 -10.15", "key": "svg-2" }], ["path", { "d": "M19 21l0 -10.15", "key": "svg-3" }], ["path", { "d": "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4", "key": "svg-4" }]]);

var IconBuildingStore$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingStore
});

var IconBuildingTunnel = createReactComponent("outline", "building-tunnel", "IconBuildingTunnel", [["path", { "d": "M5 21h14a2 2 0 0 0 2 -2v-7a9 9 0 0 0 -18 0v7a2 2 0 0 0 2 2z", "key": "svg-0" }], ["path", { "d": "M8 21v-9a4 4 0 1 1 8 0v9", "key": "svg-1" }], ["path", { "d": "M3 17h4", "key": "svg-2" }], ["path", { "d": "M17 17h4", "key": "svg-3" }], ["path", { "d": "M21 12h-4", "key": "svg-4" }], ["path", { "d": "M7 12h-4", "key": "svg-5" }], ["path", { "d": "M12 3v5", "key": "svg-6" }], ["path", { "d": "M6 6l3 3", "key": "svg-7" }], ["path", { "d": "M15 9l3 -3l-3 3z", "key": "svg-8" }]]);

var IconBuildingTunnel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingTunnel
});

var IconBuildingWarehouse = createReactComponent("outline", "building-warehouse", "IconBuildingWarehouse", [["path", { "d": "M3 21v-13l9 -4l9 4v13", "key": "svg-0" }], ["path", { "d": "M13 13h4v8h-10v-6h6", "key": "svg-1" }], ["path", { "d": "M13 21v-9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v3", "key": "svg-2" }]]);

var IconBuildingWarehouse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingWarehouse
});

var IconBuildingWindTurbine = createReactComponent("outline", "building-wind-turbine", "IconBuildingWindTurbine", [["path", { "d": "M12 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M10 11v-2.573c0 -.18 .013 -.358 .04 -.536l.716 -4.828c.064 -.597 .597 -1.063 1.244 -1.063s1.18 .466 1.244 1.063l.716 4.828c.027 .178 .04 .357 .04 .536v2.573", "key": "svg-1" }], ["path", { "d": "M13.01 9.28l2.235 1.276c.156 .09 .305 .19 .446 .3l3.836 2.911c.487 .352 .624 1.04 .3 1.596c-.325 .556 -1 .782 -1.548 .541l-4.555 -1.68a3.624 3.624 0 0 1 -.486 -.231l-2.235 -1.277", "key": "svg-2" }], ["path", { "d": "M13 12.716l-2.236 1.277a3.624 3.624 0 0 1 -.485 .23l-4.555 1.681c-.551 .241 -1.223 .015 -1.548 -.54c-.324 -.557 -.187 -1.245 .3 -1.597l3.836 -2.91a3.41 3.41 0 0 1 .446 -.3l2.235 -1.277", "key": "svg-3" }], ["path", { "d": "M7 21h10", "key": "svg-4" }], ["path", { "d": "M10 21l1 -7", "key": "svg-5" }], ["path", { "d": "M13 14l1 7", "key": "svg-6" }]]);

var IconBuildingWindTurbine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingWindTurbine
});

var IconBuilding = createReactComponent("outline", "building", "IconBuilding", [["path", { "d": "M3 21l18 0", "key": "svg-0" }], ["path", { "d": "M9 8l1 0", "key": "svg-1" }], ["path", { "d": "M9 12l1 0", "key": "svg-2" }], ["path", { "d": "M9 16l1 0", "key": "svg-3" }], ["path", { "d": "M14 8l1 0", "key": "svg-4" }], ["path", { "d": "M14 12l1 0", "key": "svg-5" }], ["path", { "d": "M14 16l1 0", "key": "svg-6" }], ["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16", "key": "svg-7" }]]);

var IconBuilding$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuilding
});

var IconBuildings = createReactComponent("outline", "buildings", "IconBuildings", [["path", { "d": "M4 21v-15c0 -1 1 -2 2 -2h5c1 0 2 1 2 2v15", "key": "svg-0" }], ["path", { "d": "M16 8h2c1 0 2 1 2 2v11", "key": "svg-1" }], ["path", { "d": "M3 21h18", "key": "svg-2" }], ["path", { "d": "M10 12v0", "key": "svg-3" }], ["path", { "d": "M10 16v0", "key": "svg-4" }], ["path", { "d": "M10 8v0", "key": "svg-5" }], ["path", { "d": "M7 12v0", "key": "svg-6" }], ["path", { "d": "M7 16v0", "key": "svg-7" }], ["path", { "d": "M7 8v0", "key": "svg-8" }], ["path", { "d": "M17 12v0", "key": "svg-9" }], ["path", { "d": "M17 16v0", "key": "svg-10" }]]);

var IconBuildings$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildings
});

var IconBulbOff = createReactComponent("outline", "bulb-off", "IconBulbOff", [["path", { "d": "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7", "key": "svg-0" }], ["path", { "d": "M11.089 7.083a5 5 0 0 1 5.826 5.84m-1.378 2.611a5.012 5.012 0 0 1 -.537 .466a3.5 3.5 0 0 0 -1 3a2 2 0 1 1 -4 0a3.5 3.5 0 0 0 -1 -3a5 5 0 0 1 -.528 -7.544", "key": "svg-1" }], ["path", { "d": "M9.7 17h4.6", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconBulbOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBulbOff
});

var IconBulb = createReactComponent("outline", "bulb", "IconBulb", [["path", { "d": "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7", "key": "svg-0" }], ["path", { "d": "M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3", "key": "svg-1" }], ["path", { "d": "M9.7 17l4.6 0", "key": "svg-2" }]]);

var IconBulb$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBulb
});

var IconBulldozer = createReactComponent("outline", "bulldozer", "IconBulldozer", [["path", { "d": "M2 17a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 17a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19 13v4a2 2 0 0 0 2 2h1", "key": "svg-2" }], ["path", { "d": "M14 19h-10", "key": "svg-3" }], ["path", { "d": "M4 15h10", "key": "svg-4" }], ["path", { "d": "M9 11v-5h2a3 3 0 0 1 3 3v6", "key": "svg-5" }], ["path", { "d": "M5 15v-3a1 1 0 0 1 1 -1h8", "key": "svg-6" }], ["path", { "d": "M19 17h-3", "key": "svg-7" }]]);

var IconBulldozer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBulldozer
});

var IconBurger = createReactComponent("outline", "burger", "IconBurger", [["path", { "d": "M4 15h16a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z", "key": "svg-0" }], ["path", { "d": "M12 4c3.783 0 6.953 2.133 7.786 5h-15.572c.833 -2.867 4.003 -5 7.786 -5z", "key": "svg-1" }], ["path", { "d": "M5 12h14", "key": "svg-2" }]]);

var IconBurger$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBurger
});

var IconBusOff = createReactComponent("outline", "bus-off", "IconBusOff", [["path", { "d": "M6 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M16.18 16.172a2 2 0 0 0 2.652 2.648", "key": "svg-1" }], ["path", { "d": "M4 17h-2v-11a1 1 0 0 1 1 -1h2m4 0h8c2.761 0 5 3.134 5 7v5h-1m-5 0h-8", "key": "svg-2" }], ["path", { "d": "M16 5l1.5 7h4.5", "key": "svg-3" }], ["path", { "d": "M2 10h8m4 0h3", "key": "svg-4" }], ["path", { "d": "M7 7v3", "key": "svg-5" }], ["path", { "d": "M12 5v3", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconBusOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBusOff
});

var IconBusStop = createReactComponent("outline", "bus-stop", "IconBusStop", [["path", { "d": "M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M10 5h7c2.761 0 5 3.134 5 7v5h-2", "key": "svg-2" }], ["path", { "d": "M16 17h-8", "key": "svg-3" }], ["path", { "d": "M16 5l1.5 7h4.5", "key": "svg-4" }], ["path", { "d": "M9.5 10h7.5", "key": "svg-5" }], ["path", { "d": "M12 5v5", "key": "svg-6" }], ["path", { "d": "M5 9v11", "key": "svg-7" }]]);

var IconBusStop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBusStop
});

var IconBus = createReactComponent("outline", "bus", "IconBus", [["path", { "d": "M6 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M4 17h-2v-11a1 1 0 0 1 1 -1h14a5 7 0 0 1 5 7v5h-2m-4 0h-8", "key": "svg-2" }], ["path", { "d": "M16 5l1.5 7l4.5 0", "key": "svg-3" }], ["path", { "d": "M2 10l15 0", "key": "svg-4" }], ["path", { "d": "M7 5l0 5", "key": "svg-5" }], ["path", { "d": "M12 5l0 5", "key": "svg-6" }]]);

var IconBus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBus
});

var IconBusinessplan = createReactComponent("outline", "businessplan", "IconBusinessplan", [["path", { "d": "M16 6m-5 0a5 3 0 1 0 10 0a5 3 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M11 6v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4", "key": "svg-1" }], ["path", { "d": "M11 10v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4", "key": "svg-2" }], ["path", { "d": "M11 14v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4", "key": "svg-3" }], ["path", { "d": "M7 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-4" }], ["path", { "d": "M5 15v1m0 -8v1", "key": "svg-5" }]]);

var IconBusinessplan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBusinessplan
});

var IconButterfly = createReactComponent("outline", "butterfly", "IconButterfly", [["path", { "d": "M12 18.176a3 3 0 1 1 -4.953 -2.449l-.025 .023a4.502 4.502 0 0 1 1.483 -8.75c1.414 0 2.675 .652 3.5 1.671a4.5 4.5 0 1 1 4.983 7.079a3 3 0 1 1 -4.983 2.25z", "key": "svg-0" }], ["path", { "d": "M12 19v-10", "key": "svg-1" }], ["path", { "d": "M9 3l3 2l3 -2", "key": "svg-2" }]]);

var IconButterfly$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconButterfly
});

var IconCactusOff = createReactComponent("outline", "cactus-off", "IconCactusOff", [["path", { "d": "M6 9v1a3 3 0 0 0 3 3h1", "key": "svg-0" }], ["path", { "d": "M18 8v5a3 3 0 0 1 -.129 .872m-2.014 2a3 3 0 0 1 -.857 .124h-1", "key": "svg-1" }], ["path", { "d": "M10 21v-11m0 -4v-1a2 2 0 1 1 4 0v5m0 4v7", "key": "svg-2" }], ["path", { "d": "M7 21h10", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconCactusOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCactusOff
});

var IconCactus = createReactComponent("outline", "cactus", "IconCactus", [["path", { "d": "M6 9v1a3 3 0 0 0 3 3h1", "key": "svg-0" }], ["path", { "d": "M18 8v5a3 3 0 0 1 -3 3h-1", "key": "svg-1" }], ["path", { "d": "M10 21v-16a2 2 0 1 1 4 0v16", "key": "svg-2" }], ["path", { "d": "M7 21h10", "key": "svg-3" }]]);

var IconCactus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCactus
});

var IconCakeOff = createReactComponent("outline", "cake-off", "IconCakeOff", [["path", { "d": "M21 17v-5a3 3 0 0 0 -3 -3h-5m-4 0h-3a3 3 0 0 0 -3 3v8h17", "key": "svg-0" }], ["path", { "d": "M3 14.803c.312 .135 .654 .204 1 .197a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1m4 0a2.4 2.4 0 0 0 2 1c.35 .007 .692 -.062 1 -.197", "key": "svg-1" }], ["path", { "d": "M10.172 6.188c.07 -.158 .163 -.31 .278 -.451l1.55 -1.737l1.465 1.638a2 2 0 0 1 -.65 3.19", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconCakeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCakeOff
});

var IconCakeRoll = createReactComponent("outline", "cake-roll", "IconCakeRoll", [["path", { "d": "M12 15c-4.97 0 -9 -2.462 -9 -5.5s4.03 -5.5 9 -5.5s9 2.462 9 5.5s-4.03 5.5 -9 5.5", "key": "svg-0" }], ["path", { "d": "M12 6.97c3 0 4 1.036 4 1.979c0 2.805 -8 2.969 -8 -.99c0 -2.11 1.5 -3.959 4 -3.959", "key": "svg-1" }], ["path", { "d": "M21 9.333v5.334c0 2.945 -4.03 5.333 -9 5.333s-9 -2.388 -9 -5.333v-5.334", "key": "svg-2" }]]);

var IconCakeRoll$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCakeRoll
});

var IconCake = createReactComponent("outline", "cake", "IconCake", [["path", { "d": "M3 20h18v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3v8z", "key": "svg-0" }], ["path", { "d": "M3 14.803c.312 .135 .654 .204 1 .197a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1c.35 .007 .692 -.062 1 -.197", "key": "svg-1" }], ["path", { "d": "M12 4l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z", "key": "svg-2" }]]);

var IconCake$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCake
});

var IconCalculatorOff = createReactComponent("outline", "calculator-off", "IconCalculatorOff", [["path", { "d": "M19.823 19.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-14c0 -.295 .064 -.575 .178 -.827m2.822 -1.173h11a2 2 0 0 1 2 2v11", "key": "svg-0" }], ["path", { "d": "M10 10h-1a1 1 0 0 1 -1 -1v-1m3 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1", "key": "svg-1" }], ["path", { "d": "M8 14v.01", "key": "svg-2" }], ["path", { "d": "M12 14v.01", "key": "svg-3" }], ["path", { "d": "M8 17v.01", "key": "svg-4" }], ["path", { "d": "M12 17v.01", "key": "svg-5" }], ["path", { "d": "M16 17v.01", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconCalculatorOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalculatorOff
});

var IconCalculator = createReactComponent("outline", "calculator", "IconCalculator", [["path", { "d": "M4 3m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 7m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M8 14l0 .01", "key": "svg-2" }], ["path", { "d": "M12 14l0 .01", "key": "svg-3" }], ["path", { "d": "M16 14l0 .01", "key": "svg-4" }], ["path", { "d": "M8 17l0 .01", "key": "svg-5" }], ["path", { "d": "M12 17l0 .01", "key": "svg-6" }], ["path", { "d": "M16 17l0 .01", "key": "svg-7" }]]);

var IconCalculator$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalculator
});

var IconCalendarBolt = createReactComponent("outline", "calendar-bolt", "IconCalendarBolt", [["path", { "d": "M13.5 21h-7.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-4" }]]);

var IconCalendarBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarBolt
});

var IconCalendarCancel = createReactComponent("outline", "calendar-cancel", "IconCalendarCancel", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }], ["path", { "d": "M17 21l4 -4", "key": "svg-5" }]]);

var IconCalendarCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarCancel
});

var IconCalendarCheck = createReactComponent("outline", "calendar-check", "IconCalendarCheck", [["path", { "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-4" }]]);

var IconCalendarCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarCheck
});

var IconCalendarClock = createReactComponent("outline", "calendar-clock", "IconCalendarClock", [["path", { "d": "M10.5 21h-4.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h10", "key": "svg-3" }], ["path", { "d": "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-4" }], ["path", { "d": "M18 16.5v1.5l.5 .5", "key": "svg-5" }]]);

var IconCalendarClock$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarClock
});

var IconCalendarCode = createReactComponent("outline", "calendar-code", "IconCalendarCode", [["path", { "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-4" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-5" }]]);

var IconCalendarCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarCode
});

var IconCalendarCog = createReactComponent("outline", "calendar-cog", "IconCalendarCog", [["path", { "d": "M12 21h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-5" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-6" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-7" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-8" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-9" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-10" }]]);

var IconCalendarCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarCog
});

var IconCalendarDollar = createReactComponent("outline", "calendar-dollar", "IconCalendarDollar", [["path", { "d": "M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h12.5", "key": "svg-3" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-4" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-5" }]]);

var IconCalendarDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarDollar
});

var IconCalendarDot = createReactComponent("outline", "calendar-dot", "IconCalendarDot", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }]]);

var IconCalendarDot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarDot
});

var IconCalendarDown = createReactComponent("outline", "calendar-down", "IconCalendarDown", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }], ["path", { "d": "M16 3v4", "key": "svg-3" }], ["path", { "d": "M8 3v4", "key": "svg-4" }], ["path", { "d": "M4 11h16", "key": "svg-5" }]]);

var IconCalendarDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarDown
});

var IconCalendarDue = createReactComponent("outline", "calendar-due", "IconCalendarDue", [["path", { "d": "M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }]]);

var IconCalendarDue$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarDue
});

var IconCalendarEvent = createReactComponent("outline", "calendar-event", "IconCalendarEvent", [["path", { "d": "M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M16 3l0 4", "key": "svg-1" }], ["path", { "d": "M8 3l0 4", "key": "svg-2" }], ["path", { "d": "M4 11l16 0", "key": "svg-3" }], ["path", { "d": "M8 15h2v2h-2z", "key": "svg-4" }]]);

var IconCalendarEvent$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarEvent
});

var IconCalendarExclamation = createReactComponent("outline", "calendar-exclamation", "IconCalendarExclamation", [["path", { "d": "M15 21h-9a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M11 15h1", "key": "svg-4" }], ["path", { "d": "M12 15v3", "key": "svg-5" }], ["path", { "d": "M19 16v3", "key": "svg-6" }], ["path", { "d": "M19 22v.01", "key": "svg-7" }]]);

var IconCalendarExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarExclamation
});

var IconCalendarHeart = createReactComponent("outline", "calendar-heart", "IconCalendarHeart", [["path", { "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-4" }]]);

var IconCalendarHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarHeart
});

var IconCalendarMinus = createReactComponent("outline", "calendar-minus", "IconCalendarMinus", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }]]);

var IconCalendarMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarMinus
});

var IconCalendarMonth = createReactComponent("outline", "calendar-month", "IconCalendarMonth", [["path", { "d": "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M8 14v4", "key": "svg-4" }], ["path", { "d": "M12 14v4", "key": "svg-5" }], ["path", { "d": "M16 14v4", "key": "svg-6" }]]);

var IconCalendarMonth$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarMonth
});

var IconCalendarOff = createReactComponent("outline", "calendar-off", "IconCalendarOff", [["path", { "d": "M9 5h9a2 2 0 0 1 2 2v9m-.184 3.839a2 2 0 0 1 -1.816 1.161h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 1.158 -1.815", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v1", "key": "svg-2" }], ["path", { "d": "M4 11h7m4 0h5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconCalendarOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarOff
});

var IconCalendarPause = createReactComponent("outline", "calendar-pause", "IconCalendarPause", [["path", { "d": "M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M17 17v5", "key": "svg-4" }], ["path", { "d": "M21 17v5", "key": "svg-5" }]]);

var IconCalendarPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarPause
});

var IconCalendarPin = createReactComponent("outline", "calendar-pin", "IconCalendarPin", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }], ["path", { "d": "M8 3v4", "key": "svg-4" }], ["path", { "d": "M4 11h16", "key": "svg-5" }]]);

var IconCalendarPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarPin
});

var IconCalendarPlus = createReactComponent("outline", "calendar-plus", "IconCalendarPlus", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16v6", "key": "svg-5" }]]);

var IconCalendarPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarPlus
});

var IconCalendarQuestion = createReactComponent("outline", "calendar-question", "IconCalendarQuestion", [["path", { "d": "M15 21h-9a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M19 22v.01", "key": "svg-4" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-5" }]]);

var IconCalendarQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarQuestion
});

var IconCalendarRepeat = createReactComponent("outline", "calendar-repeat", "IconCalendarRepeat", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h12", "key": "svg-3" }], ["path", { "d": "M20 14l2 2h-3", "key": "svg-4" }], ["path", { "d": "M20 18l2 -2", "key": "svg-5" }], ["path", { "d": "M19 16a3 3 0 1 0 2 5.236", "key": "svg-6" }]]);

var IconCalendarRepeat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarRepeat
});

var IconCalendarSad = createReactComponent("outline", "calendar-sad", "IconCalendarSad", [["path", { "d": "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12zm12 -4v4m-8 -4v4m-4 4h16m-9.995 3h.01m3.99 0h.01", "key": "svg-0" }], ["path", { "d": "M10 18a3.5 3.5 0 0 1 4 0", "key": "svg-1" }]]);

var IconCalendarSad$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarSad
});

var IconCalendarSearch = createReactComponent("outline", "calendar-search", "IconCalendarSearch", [["path", { "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4.5", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-5" }]]);

var IconCalendarSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarSearch
});

var IconCalendarShare = createReactComponent("outline", "calendar-share", "IconCalendarShare", [["path", { "d": "M12 21h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M16 22l5 -5", "key": "svg-4" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-5" }]]);

var IconCalendarShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarShare
});

var IconCalendarSmile = createReactComponent("outline", "calendar-smile", "IconCalendarSmile", [["path", { "d": "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12zm12 -4v4m-8 -4v4m-4 4h16m-9.995 3h.01m3.99 0h.01", "key": "svg-0" }], ["path", { "d": "M10.005 17a3.5 3.5 0 0 0 4 0", "key": "svg-1" }]]);

var IconCalendarSmile$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarSmile
});

var IconCalendarStar = createReactComponent("outline", "calendar-star", "IconCalendarStar", [["path", { "d": "M11 21h-5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h11", "key": "svg-3" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-4" }]]);

var IconCalendarStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarStar
});

var IconCalendarStats = createReactComponent("outline", "calendar-stats", "IconCalendarStats", [["path", { "d": "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M18 14v4h4", "key": "svg-1" }], ["path", { "d": "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-2" }], ["path", { "d": "M15 3v4", "key": "svg-3" }], ["path", { "d": "M7 3v4", "key": "svg-4" }], ["path", { "d": "M3 11h16", "key": "svg-5" }]]);

var IconCalendarStats$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarStats
});

var IconCalendarTime = createReactComponent("outline", "calendar-time", "IconCalendarTime", [["path", { "d": "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-1" }], ["path", { "d": "M15 3v4", "key": "svg-2" }], ["path", { "d": "M7 3v4", "key": "svg-3" }], ["path", { "d": "M3 11h16", "key": "svg-4" }], ["path", { "d": "M18 16.496v1.504l1 1", "key": "svg-5" }]]);

var IconCalendarTime$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarTime
});

var IconCalendarUp = createReactComponent("outline", "calendar-up", "IconCalendarUp", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M19 22v-6", "key": "svg-4" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-5" }]]);

var IconCalendarUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarUp
});

var IconCalendarUser = createReactComponent("outline", "calendar-user", "IconCalendarUser", [["path", { "d": "M12 21h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4.5", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M19 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M22 22a2 2 0 0 0 -2 -2h-2a2 2 0 0 0 -2 2", "key": "svg-5" }]]);

var IconCalendarUser$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarUser
});

var IconCalendarWeek = createReactComponent("outline", "calendar-week", "IconCalendarWeek", [["path", { "d": "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M7 14h.013", "key": "svg-4" }], ["path", { "d": "M10.01 14h.005", "key": "svg-5" }], ["path", { "d": "M13.01 14h.005", "key": "svg-6" }], ["path", { "d": "M16.015 14h.005", "key": "svg-7" }], ["path", { "d": "M13.015 17h.005", "key": "svg-8" }], ["path", { "d": "M7.01 17h.005", "key": "svg-9" }], ["path", { "d": "M10.01 17h.005", "key": "svg-10" }]]);

var IconCalendarWeek$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarWeek
});

var IconCalendarX = createReactComponent("outline", "calendar-x", "IconCalendarX", [["path", { "d": "M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6.5", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-4" }], ["path", { "d": "M17 22l5 -5", "key": "svg-5" }]]);

var IconCalendarX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarX
});

var IconCalendar = createReactComponent("outline", "calendar", "IconCalendar", [["path", { "d": "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z", "key": "svg-0" }], ["path", { "d": "M16 3v4", "key": "svg-1" }], ["path", { "d": "M8 3v4", "key": "svg-2" }], ["path", { "d": "M4 11h16", "key": "svg-3" }], ["path", { "d": "M11 15h1", "key": "svg-4" }], ["path", { "d": "M12 15v3", "key": "svg-5" }]]);

var IconCalendar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendar
});

var IconCameraAi = createReactComponent("outline", "camera-ai", "IconCameraAi", [["path", { "d": "M10 20h-5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v2", "key": "svg-0" }], ["path", { "d": "M14.362 11.15a3 3 0 1 0 -4.144 4.263", "key": "svg-1" }], ["path", { "d": "M14 21v-4a2 2 0 1 1 4 0v4", "key": "svg-2" }], ["path", { "d": "M14 19h4", "key": "svg-3" }], ["path", { "d": "M21 15v6", "key": "svg-4" }]]);

var IconCameraAi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraAi
});

var IconCameraBitcoin = createReactComponent("outline", "camera-bitcoin", "IconCameraBitcoin", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v1", "key": "svg-0" }], ["path", { "d": "M14.477 11.307a3 3 0 1 0 -2.477 4.693", "key": "svg-1" }], ["path", { "d": "M17 21v-6", "key": "svg-2" }], ["path", { "d": "M19 15v-1.5", "key": "svg-3" }], ["path", { "d": "M19 22.5v-1.5", "key": "svg-4" }], ["path", { "d": "M17 18h3", "key": "svg-5" }], ["path", { "d": "M19 18h.5a1.5 1.5 0 0 1 0 3h-3.5", "key": "svg-6" }], ["path", { "d": "M19 18h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-7" }]]);

var IconCameraBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraBitcoin
});

var IconCameraBolt = createReactComponent("outline", "camera-bolt", "IconCameraBolt", [["path", { "d": "M13 20h-8a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }]]);

var IconCameraBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraBolt
});

var IconCameraCancel = createReactComponent("outline", "camera-cancel", "IconCameraCancel", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M14.984 13.307a3 3 0 1 0 -2.32 2.62", "key": "svg-1" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M17 21l4 -4", "key": "svg-3" }]]);

var IconCameraCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraCancel
});

var IconCameraCheck = createReactComponent("outline", "camera-check", "IconCameraCheck", [["path", { "d": "M11 20h-6a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconCameraCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraCheck
});

var IconCameraCode = createReactComponent("outline", "camera-code", "IconCameraCode", [["path", { "d": "M11 20h-6a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M14.948 13.559a3 3 0 1 0 -2.58 2.419", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

var IconCameraCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraCode
});

var IconCameraCog = createReactComponent("outline", "camera-cog", "IconCameraCog", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3", "key": "svg-0" }], ["path", { "d": "M14.973 13.406a3 3 0 1 0 -2.973 2.594", "key": "svg-1" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-3" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-4" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-8" }]]);

var IconCameraCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraCog
});

var IconCameraDollar = createReactComponent("outline", "camera-dollar", "IconCameraDollar", [["path", { "d": "M13 20h-8a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v1.5", "key": "svg-0" }], ["path", { "d": "M14.935 12.375a3.001 3.001 0 1 0 -1.902 3.442", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconCameraDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraDollar
});

var IconCameraDown = createReactComponent("outline", "camera-down", "IconCameraDown", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-3" }]]);

var IconCameraDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraDown
});

var IconCameraExclamation = createReactComponent("outline", "camera-exclamation", "IconCameraExclamation", [["path", { "d": "M15 20h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconCameraExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraExclamation
});

var IconCameraHeart = createReactComponent("outline", "camera-heart", "IconCameraHeart", [["path", { "d": "M10.5 20h-5.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v2", "key": "svg-0" }], ["path", { "d": "M14.41 11.212a3 3 0 1 0 -4.15 4.231", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconCameraHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraHeart
});

var IconCameraMinus = createReactComponent("outline", "camera-minus", "IconCameraMinus", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-2" }]]);

var IconCameraMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraMinus
});

var IconCameraMoon = createReactComponent("outline", "camera-moon", "IconCameraMoon", [["path", { "d": "M11.5 20h-6.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M14.815 11.96a3.001 3.001 0 1 0 -3.398 3.983", "key": "svg-1" }], ["path", { "d": "M18.62 22c-2 0 -3.62 -1.58 -3.62 -3.53c0 -1.727 1.273 -3.165 2.954 -3.47a3.4 3.4 0 0 0 -.24 1.264c0 1.95 1.621 3.53 3.62 3.53q .342 0 .666 -.06c-.521 1.326 -1.838 2.266 -3.38 2.266", "key": "svg-2" }]]);

var IconCameraMoon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraMoon
});

var IconCameraOff = createReactComponent("outline", "camera-off", "IconCameraOff", [["path", { "d": "M8.297 4.289a.997 .997 0 0 1 .703 -.289h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v8m-1.187 2.828c-.249 .11 -.524 .172 -.813 .172h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1c.298 0 .58 -.065 .834 -.181", "key": "svg-0" }], ["path", { "d": "M10.422 10.448a3 3 0 1 0 4.15 4.098", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconCameraOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraOff
});

var IconCameraPause = createReactComponent("outline", "camera-pause", "IconCameraPause", [["path", { "d": "M13 20h-8a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M14.958 13.506a3 3 0 1 0 -1.735 2.235", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

var IconCameraPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraPause
});

var IconCameraPin = createReactComponent("outline", "camera-pin", "IconCameraPin", [["path", { "d": "M12.5 20h-7.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v2", "key": "svg-0" }], ["path", { "d": "M14.933 12.366a3.001 3.001 0 1 0 -2.933 3.634", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }]]);

var IconCameraPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraPin
});

var IconCameraPlus = createReactComponent("outline", "camera-plus", "IconCameraPlus", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-3" }]]);

var IconCameraPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraPlus
});

var IconCameraQuestion = createReactComponent("outline", "camera-question", "IconCameraQuestion", [["path", { "d": "M15 20h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v2.5", "key": "svg-0" }], ["path", { "d": "M14.975 12.612a3 3 0 1 0 -1.507 3.005", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }]]);

var IconCameraQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraQuestion
});

var IconCameraRotate = createReactComponent("outline", "camera-rotate", "IconCameraRotate", [["path", { "d": "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M11.245 15.904a3 3 0 0 0 3.755 -2.904m-2.25 -2.905a3 3 0 0 0 -3.75 2.905", "key": "svg-1" }], ["path", { "d": "M14 13h2v2", "key": "svg-2" }], ["path", { "d": "M10 13h-2v-2", "key": "svg-3" }]]);

var IconCameraRotate$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraRotate
});

var IconCameraSearch = createReactComponent("outline", "camera-search", "IconCameraSearch", [["path", { "d": "M11.5 20h-6.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v2.5", "key": "svg-0" }], ["path", { "d": "M14.757 11.815a3 3 0 1 0 -3.431 4.109", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconCameraSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraSearch
});

var IconCameraSelfie = createReactComponent("outline", "camera-selfie", "IconCameraSelfie", [["path", { "d": "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M9.5 15a3.5 3.5 0 0 0 5 0", "key": "svg-1" }], ["path", { "d": "M15 11l.01 0", "key": "svg-2" }], ["path", { "d": "M9 11l.01 0", "key": "svg-3" }]]);

var IconCameraSelfie$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraSelfie
});

var IconCameraShare = createReactComponent("outline", "camera-share", "IconCameraShare", [["path", { "d": "M12.5 20h-7.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M14.98 13.347a3 3 0 1 0 -2.39 2.595", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconCameraShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraShare
});

var IconCameraSpark = createReactComponent("outline", "camera-spark", "IconCameraSpark", [["path", { "d": "M11.5 20h-6.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3", "key": "svg-0" }], ["path", { "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-2" }]]);

var IconCameraSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraSpark
});

var IconCameraStar = createReactComponent("outline", "camera-star", "IconCameraStar", [["path", { "d": "M10.5 20h-5.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v2.5", "key": "svg-0" }], ["path", { "d": "M14.569 11.45a3 3 0 1 0 -4.518 3.83", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconCameraStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraStar
});

var IconCameraUp = createReactComponent("outline", "camera-up", "IconCameraUp", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M12 16a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }]]);

var IconCameraUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraUp
});

var IconCameraX = createReactComponent("outline", "camera-x", "IconCameraX", [["path", { "d": "M13.5 20h-8.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-2" }], ["path", { "d": "M17 22l5 -5", "key": "svg-3" }]]);

var IconCameraX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraX
});

var IconCamera = createReactComponent("outline", "camera", "IconCamera", [["path", { "d": "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }]]);

var IconCamera$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCamera
});

var IconCamper = createReactComponent("outline", "camper", "IconCamper", [["path", { "d": "M5 18a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M15 18a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 18h-1a1 1 0 0 1 -1 -1v-11a2 2 0 0 1 2 -2h12a4 4 0 0 1 4 4h-18", "key": "svg-2" }], ["path", { "d": "M9 18h6", "key": "svg-3" }], ["path", { "d": "M19 18h1a1 1 0 0 0 1 -1v-4l-3 -5", "key": "svg-4" }], ["path", { "d": "M21 13h-7", "key": "svg-5" }], ["path", { "d": "M14 8v10", "key": "svg-6" }]]);

var IconCamper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCamper
});

var IconCampfire = createReactComponent("outline", "campfire", "IconCampfire", [["path", { "d": "M4 21l16 -4", "key": "svg-0" }], ["path", { "d": "M20 21l-16 -4", "key": "svg-1" }], ["path", { "d": "M12 15a4 4 0 0 0 4 -4c0 -3 -2 -3 -2 -8c-4 2 -6 5 -6 8a4 4 0 0 0 4 4z", "key": "svg-2" }]]);

var IconCampfire$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCampfire
});

var IconCancel = createReactComponent("outline", "cancel", "IconCancel", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M18.364 5.636l-12.728 12.728", "key": "svg-1" }]]);

var IconCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCancel
});

var IconCandle = createReactComponent("outline", "candle", "IconCandle", [["path", { "d": "M9 21h6v-10a1 1 0 0 0 -1 -1h-4a1 1 0 0 0 -1 1z", "key": "svg-0" }], ["path", { "d": "M12 2l1.465 1.638a2 2 0 1 1 -3.015 .099z", "key": "svg-1" }]]);

var IconCandle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCandle
});

var IconCandyOff = createReactComponent("outline", "candy-off", "IconCandyOff", [["path", { "d": "M11.174 7.17l.119 -.12a2 2 0 0 1 2.828 0l2.829 2.83a2 2 0 0 1 0 2.828l-.124 .124m-2 2l-2.123 2.123a2 2 0 0 1 -2.828 0l-2.829 -2.831a2 2 0 0 1 0 -2.828l2.113 -2.112", "key": "svg-0" }], ["path", { "d": "M16.243 9.172l3.086 -.772a1.5 1.5 0 0 0 .697 -2.516l-2.216 -2.217a1.5 1.5 0 0 0 -2.44 .47l-1.248 2.913", "key": "svg-1" }], ["path", { "d": "M9.172 16.243l-.772 3.086a1.5 1.5 0 0 1 -2.516 .697l-2.217 -2.216a1.5 1.5 0 0 1 .47 -2.44l2.913 -1.248", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconCandyOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCandyOff
});

var IconCandy = createReactComponent("outline", "candy", "IconCandy", [["path", { "d": "M7.05 11.293l4.243 -4.243a2 2 0 0 1 2.828 0l2.829 2.83a2 2 0 0 1 0 2.828l-4.243 4.243a2 2 0 0 1 -2.828 0l-2.829 -2.831a2 2 0 0 1 0 -2.828z", "key": "svg-0" }], ["path", { "d": "M16.243 9.172l3.086 -.772a1.5 1.5 0 0 0 .697 -2.516l-2.216 -2.217a1.5 1.5 0 0 0 -2.44 .47l-1.248 2.913", "key": "svg-1" }], ["path", { "d": "M9.172 16.243l-.772 3.086a1.5 1.5 0 0 1 -2.516 .697l-2.217 -2.216a1.5 1.5 0 0 1 .47 -2.44l2.913 -1.248", "key": "svg-2" }]]);

var IconCandy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCandy
});

var IconCane = createReactComponent("outline", "cane", "IconCane", [["path", { "d": "M9 21l6.324 -11.69c.54 -.974 1.756 -4.104 -1.499 -5.762c-3.255 -1.657 -5.175 .863 -5.825 2.032", "key": "svg-0" }]]);

var IconCane$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCane
});

var IconCannabis = createReactComponent("outline", "cannabis", "IconCannabis", [["path", { "d": "M7 20s0 -2 1 -3.5c-1.5 0 -2 -.5 -4 -1.5c0 0 1.839 -1.38 5 -1c-1.789 -.97 -3.279 -2.03 -5 -6c0 0 3.98 -.3 6.5 3.5c-2.284 -4.9 1.5 -9.5 1.5 -9.5c2.734 5.47 2.389 7.5 1.5 9.5c2.531 -3.77 6.5 -3.5 6.5 -3.5c-1.721 3.97 -3.211 5.03 -5 6c3.161 -.38 5 1 5 1c-2 1 -2.5 1.5 -4 1.5c1 1.5 1 3.5 1 3.5c-2 0 -4.438 -2.22 -5 -3c-.563 .78 -3 3 -5 3z", "key": "svg-0" }], ["path", { "d": "M12 22v-5", "key": "svg-1" }]]);

var IconCannabis$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCannabis
});

var IconCapProjecting = createReactComponent("outline", "cap-projecting", "IconCapProjecting", [["path", { "d": "M20 6h-13a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h13", "key": "svg-0" }], ["path", { "d": "M13 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0", "key": "svg-1" }], ["path", { "d": "M13 12h7", "key": "svg-2" }]]);

var IconCapProjecting$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCapProjecting
});

var IconCapRounded = createReactComponent("outline", "cap-rounded", "IconCapRounded", [["path", { "d": "M20 6h-9a6 6 0 1 0 0 12h9", "key": "svg-0" }], ["path", { "d": "M13 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0", "key": "svg-1" }], ["path", { "d": "M13 12h7", "key": "svg-2" }]]);

var IconCapRounded$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCapRounded
});

var IconCapStraight = createReactComponent("outline", "cap-straight", "IconCapStraight", [["path", { "d": "M8 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0", "key": "svg-0" }], ["path", { "d": "M8 12h12", "key": "svg-1" }], ["path", { "d": "M20 6h-12a2 2 0 0 0 -2 2v2", "key": "svg-2" }], ["path", { "d": "M6 14v2a2 2 0 0 0 2 2h12", "key": "svg-3" }]]);

var IconCapStraight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCapStraight
});

var IconCapsuleHorizontal = createReactComponent("outline", "capsule-horizontal", "IconCapsuleHorizontal", [["path", { "d": "M3 6m0 6a6 6 0 0 1 6 -6h6a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-6a6 6 0 0 1 -6 -6z", "key": "svg-0" }]]);

var IconCapsuleHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCapsuleHorizontal
});

var IconCapsule = createReactComponent("outline", "capsule", "IconCapsule", [["path", { "d": "M6 3m0 6a6 6 0 0 1 6 -6h0a6 6 0 0 1 6 6v6a6 6 0 0 1 -6 6h0a6 6 0 0 1 -6 -6z", "key": "svg-0" }]]);

var IconCapsule$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCapsule
});

var IconCaptureOff = createReactComponent("outline", "capture-off", "IconCaptureOff", [["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-0" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-1" }], ["path", { "d": "M16 20h2c.554 0 1.055 -.225 1.417 -.589", "key": "svg-2" }], ["path", { "d": "M9.87 9.887a3 3 0 0 0 4.255 4.23m.58 -3.416a3.012 3.012 0 0 0 -1.4 -1.403", "key": "svg-3" }], ["path", { "d": "M4 8v-2c0 -.548 .22 -1.044 .577 -1.405", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconCaptureOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaptureOff
});

var IconCapture = createReactComponent("outline", "capture", "IconCapture", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }]]);

var IconCapture$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCapture
});

var IconCar4wd = createReactComponent("outline", "car-4wd", "IconCar4wd", [["path", { "d": "M5 3m0 2a2 2 0 0 1 2 -2h0a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h0a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M5 15m0 2a2 2 0 0 1 2 -2h0a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h0a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M15 3m0 2a2 2 0 0 1 2 -2h0a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h0a2 2 0 0 1 -2 -2z", "key": "svg-2" }], ["path", { "d": "M15 15m0 2a2 2 0 0 1 2 -2h0a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h0a2 2 0 0 1 -2 -2z", "key": "svg-3" }], ["path", { "d": "M9 18h6", "key": "svg-4" }], ["path", { "d": "M9 6h6", "key": "svg-5" }], ["path", { "d": "M12 6.5v-.5v12", "key": "svg-6" }]]);

var IconCar4wd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCar4wd
});

var IconCarCrane = createReactComponent("outline", "car-crane", "IconCarCrane", [["path", { "d": "M5 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M7 18h8m4 0h2v-6a5 5 0 0 0 -5 -5h-1l1.5 5h4.5", "key": "svg-2" }], ["path", { "d": "M12 18v-11h3", "key": "svg-3" }], ["path", { "d": "M3 17v-5h9", "key": "svg-4" }], ["path", { "d": "M4 12v-6l18 -3v2", "key": "svg-5" }], ["path", { "d": "M8 12v-4l-4 -2", "key": "svg-6" }]]);

var IconCarCrane$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarCrane
});

var IconCarCrash = createReactComponent("outline", "car-crash", "IconCarCrash", [["path", { "d": "M10 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M7 6l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-5m0 -6h8m-6 0v-5m2 0h-4", "key": "svg-1" }], ["path", { "d": "M14 8v-2", "key": "svg-2" }], ["path", { "d": "M19 12h2", "key": "svg-3" }], ["path", { "d": "M17.5 15.5l1.5 1.5", "key": "svg-4" }], ["path", { "d": "M17.5 8.5l1.5 -1.5", "key": "svg-5" }]]);

var IconCarCrash$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarCrash
});

var IconCarFan1 = createReactComponent("outline", "car-fan-1", "IconCarFan1", [["path", { "d": "M12 12v-9l4.912 1.914a1.7 1.7 0 0 1 .428 2.925z", "key": "svg-0" }], ["path", { "d": "M14.424 15.03l-2.424 -3.03h6", "key": "svg-1" }], ["path", { "d": "M12 12h-9l1.914 -4.912a1.7 1.7 0 0 1 2.925 -.428z", "key": "svg-2" }], ["path", { "d": "M12 12v9l-4.912 -1.914a1.7 1.7 0 0 1 -.428 -2.925z", "key": "svg-3" }], ["path", { "d": "M18 17l2 -2v6", "key": "svg-4" }]]);

var IconCarFan1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarFan1
});

var IconCarFan2 = createReactComponent("outline", "car-fan-2", "IconCarFan2", [["path", { "d": "M12 12v-9l4.912 1.914a1.7 1.7 0 0 1 .428 2.925z", "key": "svg-0" }], ["path", { "d": "M14.044 14.624l-2.044 -2.624h4", "key": "svg-1" }], ["path", { "d": "M12 12h-9l1.914 -4.912a1.7 1.7 0 0 1 2.925 -.428z", "key": "svg-2" }], ["path", { "d": "M12 12v9l-4.912 -1.914a1.7 1.7 0 0 1 -.428 -2.925z", "key": "svg-3" }], ["path", { "d": "M18 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2", "key": "svg-4" }]]);

var IconCarFan2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarFan2
});

var IconCarFan3 = createReactComponent("outline", "car-fan-3", "IconCarFan3", [["path", { "d": "M12 12v-9l4.912 1.914a1.7 1.7 0 0 1 .428 2.925z", "key": "svg-0" }], ["path", { "d": "M14.044 14.624l-2.044 -2.624h4", "key": "svg-1" }], ["path", { "d": "M12 12h-9l1.914 -4.912a1.7 1.7 0 0 1 2.925 -.428z", "key": "svg-2" }], ["path", { "d": "M12 12v9l-4.912 -1.914a1.7 1.7 0 0 1 -.428 -2.925z", "key": "svg-3" }], ["path", { "d": "M18 15.5a.5 .5 0 0 1 .5 -.5h1a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1a.5 .5 0 0 1 -.5 -.5", "key": "svg-4" }]]);

var IconCarFan3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarFan3
});

var IconCarFanAuto = createReactComponent("outline", "car-fan-auto", "IconCarFanAuto", [["path", { "d": "M12 12v-9l4.912 1.914a1.7 1.7 0 0 1 .428 2.925z", "key": "svg-0" }], ["path", { "d": "M14.044 14.624l-2.044 -2.624h4", "key": "svg-1" }], ["path", { "d": "M12 12h-9l1.914 -4.912a1.7 1.7 0 0 1 2.925 -.428z", "key": "svg-2" }], ["path", { "d": "M12 12v9l-4.912 -1.914a1.7 1.7 0 0 1 -.428 -2.925z", "key": "svg-3" }], ["path", { "d": "M17 21v-4a2 2 0 1 1 4 0v4", "key": "svg-4" }], ["path", { "d": "M17 19h4", "key": "svg-5" }]]);

var IconCarFanAuto$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarFanAuto
});

var IconCarFan = createReactComponent("outline", "car-fan", "IconCarFan", [["path", { "d": "M12 12v-9l4.912 1.914a1.7 1.7 0 0 1 .428 2.925z", "key": "svg-0" }], ["path", { "d": "M12 12h9l-1.914 4.912a1.7 1.7 0 0 1 -2.925 .428z", "key": "svg-1" }], ["path", { "d": "M12 12h-9l1.914 -4.912a1.7 1.7 0 0 1 2.925 -.428z", "key": "svg-2" }], ["path", { "d": "M12 12v9l-4.912 -1.914a1.7 1.7 0 0 1 -.428 -2.925z", "key": "svg-3" }]]);

var IconCarFan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarFan
});

var IconCarGarage = createReactComponent("outline", "car-garage", "IconCarGarage", [["path", { "d": "M5 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M15 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 20h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5", "key": "svg-2" }], ["path", { "d": "M3 6l9 -4l9 4", "key": "svg-3" }]]);

var IconCarGarage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarGarage
});

var IconCarOff = createReactComponent("outline", "car-off", "IconCarOff", [["path", { "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M15.584 15.588a2 2 0 0 0 2.828 2.83", "key": "svg-1" }], ["path", { "d": "M5 17h-2v-6l2 -5h1m4 0h4l4 5h1a2 2 0 0 1 2 2v4m-6 0h-6m-6 -6h8m4 0h3m-6 -3v-2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconCarOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarOff
});

var IconCarSuv = createReactComponent("outline", "car-suv", "IconCarSuv", [["path", { "d": "M5 17a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M16 17a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 9l2 -4h7.438a2 2 0 0 1 1.94 1.515l.622 2.485h3a2 2 0 0 1 2 2v3", "key": "svg-2" }], ["path", { "d": "M10 9v-4", "key": "svg-3" }], ["path", { "d": "M2 7v4", "key": "svg-4" }], ["path", { "d": "M22.001 14.001a4.992 4.992 0 0 0 -4.001 -2.001a4.992 4.992 0 0 0 -4 2h-3a4.998 4.998 0 0 0 -8.003 .003", "key": "svg-5" }], ["path", { "d": "M5 12v-3h13", "key": "svg-6" }]]);

var IconCarSuv$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarSuv
});

var IconCarTurbine = createReactComponent("outline", "car-turbine", "IconCarTurbine", [["path", { "d": "M11 13m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M18.86 11c.088 .66 .14 1.512 .14 2a8 8 0 1 1 -8 -8h6", "key": "svg-1" }], ["path", { "d": "M11 9c2.489 .108 4.489 .108 6 0", "key": "svg-2" }], ["path", { "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-3" }], ["path", { "d": "M11 13l-3.5 -1.5", "key": "svg-4" }], ["path", { "d": "M11 13l2.5 3", "key": "svg-5" }], ["path", { "d": "M8.5 16l2.5 -3", "key": "svg-6" }], ["path", { "d": "M11 13l3.5 -1.5", "key": "svg-7" }], ["path", { "d": "M11 9v4", "key": "svg-8" }]]);

var IconCarTurbine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarTurbine
});

var IconCar = createReactComponent("outline", "car", "IconCar", [["path", { "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5", "key": "svg-2" }]]);

var IconCar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCar
});

var IconCarambola = createReactComponent("outline", "carambola", "IconCarambola", [["path", { "d": "M17.286 21.09q -1.69 .001 -5.288 -2.615q -3.596 2.617 -5.288 2.616q -2.726 0 -.495 -6.8q -9.389 -6.775 2.135 -6.775h.076q 1.785 -5.516 3.574 -5.516q 1.785 0 3.574 5.516h.076q 11.525 0 2.133 6.774q 2.23 6.802 -.497 6.8", "key": "svg-0" }]]);

var IconCarambola$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarambola
});

var IconCaravan = createReactComponent("outline", "caravan", "IconCaravan", [["path", { "d": "M7 18a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M11 18h7a2 2 0 0 0 2 -2v-7a2 2 0 0 0 -2 -2h-9.5a5.5 5.5 0 0 0 -5.5 5.5v3.5a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M8 7l7 -3l1 3", "key": "svg-2" }], ["path", { "d": "M13 11m0 .5a.5 .5 0 0 1 .5 -.5h2a.5 .5 0 0 1 .5 .5v2a.5 .5 0 0 1 -.5 .5h-2a.5 .5 0 0 1 -.5 -.5z", "key": "svg-3" }], ["path", { "d": "M20 16h2", "key": "svg-4" }]]);

var IconCaravan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaravan
});

var IconCardboardsOff = createReactComponent("outline", "cardboards-off", "IconCardboardsOff", [["path", { "d": "M20.96 16.953c.026 -.147 .04 -.298 .04 -.453v-8.5a2 2 0 0 0 -2 -2h-9m-4 0h-1a2 2 0 0 0 -2 2v8.5a2.5 2.5 0 0 0 2.5 2.5h1.06a3 3 0 0 0 2.34 -1.13l1.54 -1.92a2 2 0 0 1 3.12 0l1.54 1.92a3 3 0 0 0 2.34 1.13h1.06c.155 0 .307 -.014 .454 -.041", "key": "svg-0" }], ["path", { "d": "M8 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M16.714 12.7a1 1 0 0 0 -1.417 -1.411l1.417 1.41z", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconCardboardsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCardboardsOff
});

var IconCardboards = createReactComponent("outline", "cardboards", "IconCardboards", [["path", { "d": "M3 8v8.5a2.5 2.5 0 0 0 2.5 2.5h1.06a3 3 0 0 0 2.34 -1.13l1.54 -1.92a2 2 0 0 1 3.12 0l1.54 1.92a3 3 0 0 0 2.34 1.13h1.06a2.5 2.5 0 0 0 2.5 -2.5v-8.5a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2z", "key": "svg-0" }], ["path", { "d": "M8 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M16 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }]]);

var IconCardboards$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCardboards
});

var IconCards = createReactComponent("outline", "cards", "IconCards", [["path", { "d": "M3.604 7.197l7.138 -3.109a.96 .96 0 0 1 1.27 .527l4.924 11.902a1 1 0 0 1 -.514 1.304l-7.137 3.109a.96 .96 0 0 1 -1.271 -.527l-4.924 -11.903a1 1 0 0 1 .514 -1.304z", "key": "svg-0" }], ["path", { "d": "M15 4h1a1 1 0 0 1 1 1v3.5", "key": "svg-1" }], ["path", { "d": "M20 6c.264 .112 .52 .217 .768 .315a1 1 0 0 1 .53 1.311l-2.298 5.374", "key": "svg-2" }]]);

var IconCards$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCards
});

var IconCaretDown = createReactComponent("outline", "caret-down", "IconCaretDown", [["path", { "d": "M6 10l6 6l6 -6h-12", "key": "svg-0" }]]);

var IconCaretDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaretDown
});

var IconCaretLeftRight = createReactComponent("outline", "caret-left-right", "IconCaretLeftRight", [["path", { "d": "M14 18l6 -6l-6 -6v12", "key": "svg-0" }], ["path", { "d": "M10 18l-6 -6l6 -6v12", "key": "svg-1" }]]);

var IconCaretLeftRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaretLeftRight
});

var IconCaretLeft = createReactComponent("outline", "caret-left", "IconCaretLeft", [["path", { "d": "M14 6l-6 6l6 6v-12", "key": "svg-0" }]]);

var IconCaretLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaretLeft
});

var IconCaretRight = createReactComponent("outline", "caret-right", "IconCaretRight", [["path", { "d": "M10 18l6 -6l-6 -6v12", "key": "svg-0" }]]);

var IconCaretRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaretRight
});

var IconCaretUpDown = createReactComponent("outline", "caret-up-down", "IconCaretUpDown", [["path", { "d": "M18 10l-6 -6l-6 6h12", "key": "svg-0" }], ["path", { "d": "M18 14l-6 6l-6 -6h12", "key": "svg-1" }]]);

var IconCaretUpDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaretUpDown
});

var IconCaretUp = createReactComponent("outline", "caret-up", "IconCaretUp", [["path", { "d": "M18 14l-6 -6l-6 6h12", "key": "svg-0" }]]);

var IconCaretUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaretUp
});

var IconCarouselHorizontal = createReactComponent("outline", "carousel-horizontal", "IconCarouselHorizontal", [["path", { "d": "M7 5m0 1a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M22 17h-1a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h1", "key": "svg-1" }], ["path", { "d": "M2 17h1a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1h-1", "key": "svg-2" }]]);

var IconCarouselHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarouselHorizontal
});

var IconCarouselVertical = createReactComponent("outline", "carousel-vertical", "IconCarouselVertical", [["path", { "d": "M19 8v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1z", "key": "svg-0" }], ["path", { "d": "M7 22v-1a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v1", "key": "svg-1" }], ["path", { "d": "M17 2v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1", "key": "svg-2" }]]);

var IconCarouselVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarouselVertical
});

var IconCarrotOff = createReactComponent("outline", "carrot-off", "IconCarrotOff", [["path", { "d": "M8.868 8.846c-2.756 3.382 -5.868 12.154 -5.868 12.154s8.75 -3.104 12.134 -5.85m1.667 -2.342a4.486 4.486 0 0 0 -5.589 -5.615", "key": "svg-0" }], ["path", { "d": "M9 13l-1.5 -1.5", "key": "svg-1" }], ["path", { "d": "M22 8s-1.14 -2 -3 -2c-1.406 0 -3 2 -3 2s1.14 2 3 2s3 -2 3 -2z", "key": "svg-2" }], ["path", { "d": "M16 2s-2 1.14 -2 3s2 3 2 3s2 -1.577 2 -3c0 -1.86 -2 -3 -2 -3z", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconCarrotOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarrotOff
});

var IconCarrot = createReactComponent("outline", "carrot", "IconCarrot", [["path", { "d": "M3 21s9.834 -3.489 12.684 -6.34a4.487 4.487 0 0 0 0 -6.344a4.483 4.483 0 0 0 -6.342 0c-2.86 2.861 -6.347 12.689 -6.347 12.689z", "key": "svg-0" }], ["path", { "d": "M9 13l-1.5 -1.5", "key": "svg-1" }], ["path", { "d": "M16 14l-2 -2", "key": "svg-2" }], ["path", { "d": "M22 8s-1.14 -2 -3 -2c-1.406 0 -3 2 -3 2s1.14 2 3 2s3 -2 3 -2z", "key": "svg-3" }], ["path", { "d": "M16 2s-2 1.14 -2 3s2 3 2 3s2 -1.577 2 -3c0 -1.86 -2 -3 -2 -3z", "key": "svg-4" }]]);

var IconCarrot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarrot
});

var IconCashBanknoteEdit = createReactComponent("outline", "cash-banknote-edit", "IconCashBanknoteEdit", [["path", { "d": "M11 18h-6a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v3", "key": "svg-0" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M6 12h.01", "key": "svg-2" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 1 1 2.97 2.97l-3.39 3.42h-3v-3z", "key": "svg-3" }]]);

var IconCashBanknoteEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashBanknoteEdit
});

var IconCashBanknoteHeart = createReactComponent("outline", "cash-banknote-heart", "IconCashBanknoteHeart", [["path", { "d": "M14.872 11.13a3.001 3.001 0 1 0 -4.29 3.514", "key": "svg-0" }], ["path", { "d": "M10 18h-5a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v3", "key": "svg-1" }], ["path", { "d": "M6 12h.01", "key": "svg-2" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.24 2.24 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.24 2.24 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071z", "key": "svg-3" }]]);

var IconCashBanknoteHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashBanknoteHeart
});

var IconCashBanknoteMinus = createReactComponent("outline", "cash-banknote-minus", "IconCashBanknoteMinus", [["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12 18h-7a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7", "key": "svg-1" }], ["path", { "d": "M18 12h.01", "key": "svg-2" }], ["path", { "d": "M6 12h.01", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }]]);

var IconCashBanknoteMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashBanknoteMinus
});

var IconCashBanknoteMoveBack = createReactComponent("outline", "cash-banknote-move-back", "IconCashBanknoteMoveBack", [["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12 18h-7a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5", "key": "svg-1" }], ["path", { "d": "M18 12h.01", "key": "svg-2" }], ["path", { "d": "M6 12h.01", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16l-3 3l3 3", "key": "svg-5" }]]);

var IconCashBanknoteMoveBack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashBanknoteMoveBack
});

var IconCashBanknoteMove = createReactComponent("outline", "cash-banknote-move", "IconCashBanknoteMove", [["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12 18h-7a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5", "key": "svg-1" }], ["path", { "d": "M18 12h.01", "key": "svg-2" }], ["path", { "d": "M6 12h.01", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16l3 3l-3 3", "key": "svg-5" }]]);

var IconCashBanknoteMove$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashBanknoteMove
});

var IconCashBanknoteOff = createReactComponent("outline", "cash-banknote-off", "IconCashBanknoteOff", [["path", { "d": "M9.88 9.878a3 3 0 1 0 4.242 4.243m.58 -3.425a3.012 3.012 0 0 0 -1.412 -1.405", "key": "svg-0" }], ["path", { "d": "M10 6h9a2 2 0 0 1 2 2v8c0 .294 -.064 .574 -.178 .825m-2.822 1.175h-13a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1", "key": "svg-1" }], ["path", { "d": "M18 12l.01 0", "key": "svg-2" }], ["path", { "d": "M6 12l.01 0", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconCashBanknoteOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashBanknoteOff
});

var IconCashBanknotePlus = createReactComponent("outline", "cash-banknote-plus", "IconCashBanknotePlus", [["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12.25 18h-7.25a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5", "key": "svg-1" }], ["path", { "d": "M18 12h.01", "key": "svg-2" }], ["path", { "d": "M6 12h.01", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16v6", "key": "svg-5" }]]);

var IconCashBanknotePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashBanknotePlus
});

var IconCashBanknote = createReactComponent("outline", "cash-banknote", "IconCashBanknote", [["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M3 8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M18 12h.01", "key": "svg-2" }], ["path", { "d": "M6 12h.01", "key": "svg-3" }]]);

var IconCashBanknote$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashBanknote
});

var IconCashEdit = createReactComponent("outline", "cash-edit", "IconCashEdit", [["path", { "d": "M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3", "key": "svg-0" }], ["path", { "d": "M11 19h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v1.25", "key": "svg-1" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 1 1 2.97 2.97l-3.39 3.42h-3v-3z", "key": "svg-2" }]]);

var IconCashEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashEdit
});

var IconCashHeart = createReactComponent("outline", "cash-heart", "IconCashHeart", [["path", { "d": "M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3", "key": "svg-0" }], ["path", { "d": "M10.25 19h-2.25a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v1.25", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.24 2.24 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.24 2.24 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071z", "key": "svg-2" }]]);

var IconCashHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashHeart
});

var IconCashMinus = createReactComponent("outline", "cash-minus", "IconCashMinus", [["path", { "d": "M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3", "key": "svg-0" }], ["path", { "d": "M12 19h-4a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v5", "key": "svg-1" }], ["path", { "d": "M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconCashMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashMinus
});

var IconCashMoveBack = createReactComponent("outline", "cash-move-back", "IconCashMoveBack", [["path", { "d": "M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3", "key": "svg-0" }], ["path", { "d": "M12 19h-4a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v2.5", "key": "svg-1" }], ["path", { "d": "M15.914 13.417a2 2 0 1 0 -2.447 2.511", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16l-3 3l3 3", "key": "svg-4" }]]);

var IconCashMoveBack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashMoveBack
});

var IconCashMove = createReactComponent("outline", "cash-move", "IconCashMove", [["path", { "d": "M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3", "key": "svg-0" }], ["path", { "d": "M12 19h-4a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v2.5", "key": "svg-1" }], ["path", { "d": "M15.92 13.437a2 2 0 1 0 -2.472 2.486", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16l3 3l-3 3", "key": "svg-4" }]]);

var IconCashMove$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashMove
});

var IconCashOff = createReactComponent("outline", "cash-off", "IconCashOff", [["path", { "d": "M13 9h6a2 2 0 0 1 2 2v6m-2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M12.582 12.59a2 2 0 0 0 2.83 2.826", "key": "svg-1" }], ["path", { "d": "M17 9v-2a2 2 0 0 0 -2 -2h-6m-4 0a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconCashOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashOff
});

var IconCashPlus = createReactComponent("outline", "cash-plus", "IconCashPlus", [["path", { "d": "M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3", "key": "svg-0" }], ["path", { "d": "M12 19h-4a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v2.5", "key": "svg-1" }], ["path", { "d": "M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconCashPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashPlus
});

var IconCashRegister = createReactComponent("outline", "cash-register", "IconCashRegister", [["path", { "d": "M21 15h-2.5c-.398 0 -.779 .158 -1.061 .439c-.281 .281 -.439 .663 -.439 1.061c0 .398 .158 .779 .439 1.061c.281 .281 .663 .439 1.061 .439h1c.398 0 .779 .158 1.061 .439c.281 .281 .439 .663 .439 1.061c0 .398 -.158 .779 -.439 1.061c-.281 .281 -.663 .439 -1.061 .439h-2.5", "key": "svg-0" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-1" }], ["path", { "d": "M13 21h-7c-.53 0 -1.039 -.211 -1.414 -.586c-.375 -.375 -.586 -.884 -.586 -1.414v-10c0 -.53 .211 -1.039 .586 -1.414c.375 -.375 .884 -.586 1.414 -.586h2m12 3.12v-1.12c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586h-2", "key": "svg-2" }], ["path", { "d": "M16 10v-6c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586h-4c-.53 0 -1.039 .211 -1.414 .586c-.375 .375 -.586 .884 -.586 1.414v6m8 0h-8m8 0h1m-9 0h-1", "key": "svg-3" }], ["path", { "d": "M8 14v.01", "key": "svg-4" }], ["path", { "d": "M8 17v.01", "key": "svg-5" }], ["path", { "d": "M12 13.99v.01", "key": "svg-6" }], ["path", { "d": "M12 17v.01", "key": "svg-7" }]]);

var IconCashRegister$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashRegister
});

var IconCash = createReactComponent("outline", "cash", "IconCash", [["path", { "d": "M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3", "key": "svg-0" }], ["path", { "d": "M7 9m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-2" }]]);

var IconCash$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCash
});

var IconCastOff = createReactComponent("outline", "cast-off", "IconCastOff", [["path", { "d": "M3 19h.01", "key": "svg-0" }], ["path", { "d": "M7 19a4 4 0 0 0 -4 -4", "key": "svg-1" }], ["path", { "d": "M11 19a8 8 0 0 0 -8 -8", "key": "svg-2" }], ["path", { "d": "M15 19h3a3 3 0 0 0 .875 -.13m2 -2a3 3 0 0 0 .128 -.868v-8a3 3 0 0 0 -3 -3h-9m-3.865 .136a3 3 0 0 0 -1.935 1.864", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconCastOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCastOff
});

var IconCast = createReactComponent("outline", "cast", "IconCast", [["path", { "d": "M3 19l.01 0", "key": "svg-0" }], ["path", { "d": "M7 19a4 4 0 0 0 -4 -4", "key": "svg-1" }], ["path", { "d": "M11 19a8 8 0 0 0 -8 -8", "key": "svg-2" }], ["path", { "d": "M15 19h3a3 3 0 0 0 3 -3v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -2.8 2", "key": "svg-3" }]]);

var IconCast$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCast
});

var IconCat = createReactComponent("outline", "cat", "IconCat", [["path", { "d": "M20 3v10a8 8 0 1 1 -16 0v-10l3.432 3.432a7.963 7.963 0 0 1 4.568 -1.432c1.769 0 3.403 .574 4.728 1.546l3.272 -3.546z", "key": "svg-0" }], ["path", { "d": "M2 16h5l-4 4", "key": "svg-1" }], ["path", { "d": "M22 16h-5l4 4", "key": "svg-2" }], ["path", { "d": "M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M9 11v.01", "key": "svg-4" }], ["path", { "d": "M15 11v.01", "key": "svg-5" }]]);

var IconCat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCat
});

var IconCategory2 = createReactComponent("outline", "category-2", "IconCategory2", [["path", { "d": "M14 4h6v6h-6z", "key": "svg-0" }], ["path", { "d": "M4 14h6v6h-6z", "key": "svg-1" }], ["path", { "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M7 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }]]);

var IconCategory2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCategory2
});

var IconCategoryMinus = createReactComponent("outline", "category-minus", "IconCategoryMinus", [["path", { "d": "M4 4h6v6h-6zm10 0h6v6h-6zm-10 10h6v6h-6zm10 3h6", "key": "svg-0" }]]);

var IconCategoryMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCategoryMinus
});

var IconCategoryPlus = createReactComponent("outline", "category-plus", "IconCategoryPlus", [["path", { "d": "M4 4h6v6h-6zm10 0h6v6h-6zm-10 10h6v6h-6zm10 3h6m-3 -3v6", "key": "svg-0" }]]);

var IconCategoryPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCategoryPlus
});

var IconCategory = createReactComponent("outline", "category", "IconCategory", [["path", { "d": "M4 4h6v6h-6z", "key": "svg-0" }], ["path", { "d": "M14 4h6v6h-6z", "key": "svg-1" }], ["path", { "d": "M4 14h6v6h-6z", "key": "svg-2" }], ["path", { "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }]]);

var IconCategory$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCategory
});

var IconCeOff = createReactComponent("outline", "ce-off", "IconCeOff", [["path", { "d": "M6.53 6.53a6.001 6.001 0 0 0 2.47 11.47", "key": "svg-0" }], ["path", { "d": "M21 6a6 6 0 0 0 -5.927 5.061l.927 .939", "key": "svg-1" }], ["path", { "d": "M16 12h5", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconCeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCeOff
});

var IconCe = createReactComponent("outline", "ce", "IconCe", [["path", { "d": "M9 6a6 6 0 1 0 0 12", "key": "svg-0" }], ["path", { "d": "M21 6a6 6 0 1 0 0 12", "key": "svg-1" }], ["path", { "d": "M15 12h6", "key": "svg-2" }]]);

var IconCe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCe
});

var IconCellSignal1 = createReactComponent("outline", "cell-signal-1", "IconCellSignal1", [["path", { "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z", "key": "svg-0" }]]);

var IconCellSignal1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCellSignal1
});

var IconCellSignal2 = createReactComponent("outline", "cell-signal-2", "IconCellSignal2", [["path", { "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z", "key": "svg-0" }], ["path", { "d": "M8 20v-5", "key": "svg-1" }]]);

var IconCellSignal2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCellSignal2
});

var IconCellSignal3 = createReactComponent("outline", "cell-signal-3", "IconCellSignal3", [["path", { "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z", "key": "svg-0" }], ["path", { "d": "M12 20v-9", "key": "svg-1" }]]);

var IconCellSignal3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCellSignal3
});

var IconCellSignal4 = createReactComponent("outline", "cell-signal-4", "IconCellSignal4", [["path", { "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z", "key": "svg-0" }], ["path", { "d": "M16 7v13", "key": "svg-1" }]]);

var IconCellSignal4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCellSignal4
});

var IconCellSignal5 = createReactComponent("outline", "cell-signal-5", "IconCellSignal5", [["path", { "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z", "key": "svg-0" }], ["path", { "d": "M16 7v13", "key": "svg-1" }], ["path", { "d": "M12 20v-9", "key": "svg-2" }], ["path", { "d": "M8 20v-5", "key": "svg-3" }]]);

var IconCellSignal5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCellSignal5
});

var IconCellSignalOff = createReactComponent("outline", "cell-signal-off", "IconCellSignalOff", [["path", { "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l7.265 -7.264m2 -2l5.272 -5.272a.731 .731 0 0 1 1.249 .517v11.269", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconCellSignalOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCellSignalOff
});

var IconCell = createReactComponent("outline", "cell", "IconCell", [["path", { "d": "M8 4l-4 2v5l4 2l4 -2v-5z", "key": "svg-0" }], ["path", { "d": "M12 11l4 2l4 -2v-5l-4 -2l-4 2", "key": "svg-1" }], ["path", { "d": "M8 13v5l4 2l4 -2v-5", "key": "svg-2" }]]);

var IconCell$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCell
});

var IconCertificate2Off = createReactComponent("outline", "certificate-2-off", "IconCertificate2Off", [["path", { "d": "M12 12a3 3 0 1 0 3 3", "key": "svg-0" }], ["path", { "d": "M11 7h3", "key": "svg-1" }], ["path", { "d": "M10 18v4l2 -1l2 1v-4", "key": "svg-2" }], ["path", { "d": "M10 19h-2a2 2 0 0 1 -2 -2v-11m1.18 -2.825c.25 -.112 .529 -.175 .82 -.175h8a2 2 0 0 1 2 2v9m-.175 3.82a2 2 0 0 1 -1.825 1.18h-2", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconCertificate2Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCertificate2Off
});

var IconCertificate2 = createReactComponent("outline", "certificate-2", "IconCertificate2", [["path", { "d": "M12 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M10 7h4", "key": "svg-1" }], ["path", { "d": "M10 18v4l2 -1l2 1v-4", "key": "svg-2" }], ["path", { "d": "M10 19h-2a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2", "key": "svg-3" }]]);

var IconCertificate2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCertificate2
});

var IconCertificateOff = createReactComponent("outline", "certificate-off", "IconCertificateOff", [["path", { "d": "M12.876 12.881a3 3 0 0 0 4.243 4.243m.588 -3.42a3.012 3.012 0 0 0 -1.437 -1.423", "key": "svg-0" }], ["path", { "d": "M13 17.5v4.5l2 -1.5l2 1.5v-4.5", "key": "svg-1" }], ["path", { "d": "M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2m4 0h10a2 2 0 0 1 2 2v10", "key": "svg-2" }], ["path", { "d": "M6 9h3m4 0h5", "key": "svg-3" }], ["path", { "d": "M6 12h3", "key": "svg-4" }], ["path", { "d": "M6 15h2", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconCertificateOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCertificateOff
});

var IconCertificate = createReactComponent("outline", "certificate", "IconCertificate", [["path", { "d": "M15 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M13 17.5v4.5l2 -1.5l2 1.5v-4.5", "key": "svg-1" }], ["path", { "d": "M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -1 1.73", "key": "svg-2" }], ["path", { "d": "M6 9l12 0", "key": "svg-3" }], ["path", { "d": "M6 12l3 0", "key": "svg-4" }], ["path", { "d": "M6 15l2 0", "key": "svg-5" }]]);

var IconCertificate$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCertificate
});

var IconChairDirector = createReactComponent("outline", "chair-director", "IconChairDirector", [["path", { "d": "M6 21l12 -9", "key": "svg-0" }], ["path", { "d": "M6 12l12 9", "key": "svg-1" }], ["path", { "d": "M5 12h14", "key": "svg-2" }], ["path", { "d": "M6 3v9", "key": "svg-3" }], ["path", { "d": "M18 3v9", "key": "svg-4" }], ["path", { "d": "M6 8h12", "key": "svg-5" }], ["path", { "d": "M6 5h12", "key": "svg-6" }]]);

var IconChairDirector$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChairDirector
});

var IconChalkboardOff = createReactComponent("outline", "chalkboard-off", "IconChalkboardOff", [["path", { "d": "M8 19h-3a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2m4 0h10a2 2 0 0 1 2 2v10", "key": "svg-0" }], ["path", { "d": "M17 17v1a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h4", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconChalkboardOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChalkboardOff
});

var IconChalkboard = createReactComponent("outline", "chalkboard", "IconChalkboard", [["path", { "d": "M8 19h-3a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v11a1 1 0 0 1 -1 1", "key": "svg-0" }], ["path", { "d": "M11 16m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-1" }]]);

var IconChalkboard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChalkboard
});

var IconChargingPile = createReactComponent("outline", "charging-pile", "IconChargingPile", [["path", { "d": "M18 7l-1 1", "key": "svg-0" }], ["path", { "d": "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3", "key": "svg-1" }], ["path", { "d": "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14", "key": "svg-2" }], ["path", { "d": "M9 11.5l-1.5 2.5h3l-1.5 2.5", "key": "svg-3" }], ["path", { "d": "M3 20l12 0", "key": "svg-4" }], ["path", { "d": "M4 8l10 0", "key": "svg-5" }]]);

var IconChargingPile$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChargingPile
});

var IconChartArcs3 = createReactComponent("outline", "chart-arcs-3", "IconChartArcs3", [["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M7 12a5 5 0 1 0 5 -5", "key": "svg-1" }], ["path", { "d": "M6.29 18.957a9 9 0 1 0 5.71 -15.957", "key": "svg-2" }]]);

var IconChartArcs3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartArcs3
});

var IconChartArcs = createReactComponent("outline", "chart-arcs", "IconChartArcs", [["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M16.924 11.132a5 5 0 1 0 -4.056 5.792", "key": "svg-1" }], ["path", { "d": "M3 12a9 9 0 1 0 9 -9", "key": "svg-2" }]]);

var IconChartArcs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartArcs
});

var IconChartAreaLine = createReactComponent("outline", "chart-area-line", "IconChartAreaLine", [["path", { "d": "M4 19l4 -6l4 2l4 -5l4 4l0 5l-16 0", "key": "svg-0" }], ["path", { "d": "M4 12l3 -4l4 2l5 -6l4 4", "key": "svg-1" }]]);

var IconChartAreaLine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartAreaLine
});

var IconChartArea = createReactComponent("outline", "chart-area", "IconChartArea", [["path", { "d": "M4 19l16 0", "key": "svg-0" }], ["path", { "d": "M4 15l4 -6l4 2l4 -5l4 4l0 5l-16 0", "key": "svg-1" }]]);

var IconChartArea$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartArea
});

var IconChartArrowsVertical = createReactComponent("outline", "chart-arrows-vertical", "IconChartArrowsVertical", [["path", { "d": "M18 21v-14", "key": "svg-0" }], ["path", { "d": "M9 15l3 -3l3 3", "key": "svg-1" }], ["path", { "d": "M15 10l3 -3l3 3", "key": "svg-2" }], ["path", { "d": "M3 21l18 0", "key": "svg-3" }], ["path", { "d": "M12 21l0 -9", "key": "svg-4" }], ["path", { "d": "M3 6l3 -3l3 3", "key": "svg-5" }], ["path", { "d": "M6 21v-18", "key": "svg-6" }]]);

var IconChartArrowsVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartArrowsVertical
});

var IconChartArrows = createReactComponent("outline", "chart-arrows", "IconChartArrows", [["path", { "d": "M3 18l14 0", "key": "svg-0" }], ["path", { "d": "M9 9l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M14 15l3 3l-3 3", "key": "svg-2" }], ["path", { "d": "M3 3l0 18", "key": "svg-3" }], ["path", { "d": "M3 12l9 0", "key": "svg-4" }], ["path", { "d": "M18 3l3 3l-3 3", "key": "svg-5" }], ["path", { "d": "M3 6l18 0", "key": "svg-6" }]]);

var IconChartArrows$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartArrows
});

var IconChartBarOff = createReactComponent("outline", "chart-bar-off", "IconChartBarOff", [["path", { "d": "M3 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M12 8h2a1 1 0 0 1 1 1v2m0 4v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-10", "key": "svg-1" }], ["path", { "d": "M15 11v-6a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v12m-1 3h-4a1 1 0 0 1 -1 -1v-4", "key": "svg-2" }], ["path", { "d": "M4 20h14", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconChartBarOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartBarOff
});

var IconChartBarPopular = createReactComponent("outline", "chart-bar-popular", "IconChartBarPopular", [["path", { "d": "M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M9 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M15 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M4 20h14", "key": "svg-3" }]]);

var IconChartBarPopular$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartBarPopular
});

var IconChartBar = createReactComponent("outline", "chart-bar", "IconChartBar", [["path", { "d": "M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M15 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M9 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M4 20h14", "key": "svg-3" }]]);

var IconChartBar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartBar
});

var IconChartBubble = createReactComponent("outline", "chart-bubble", "IconChartBubble", [["path", { "d": "M6 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M16 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M14.5 7.5m-4.5 0a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0", "key": "svg-2" }]]);

var IconChartBubble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartBubble
});

var IconChartCandle = createReactComponent("outline", "chart-candle", "IconChartCandle", [["path", { "d": "M4 6m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M6 4l0 2", "key": "svg-1" }], ["path", { "d": "M6 11l0 9", "key": "svg-2" }], ["path", { "d": "M10 14m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-3" }], ["path", { "d": "M12 4l0 10", "key": "svg-4" }], ["path", { "d": "M12 19l0 1", "key": "svg-5" }], ["path", { "d": "M16 5m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-6" }], ["path", { "d": "M18 4l0 1", "key": "svg-7" }], ["path", { "d": "M18 11l0 9", "key": "svg-8" }]]);

var IconChartCandle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartCandle
});

var IconChartCircles = createReactComponent("outline", "chart-circles", "IconChartCircles", [["path", { "d": "M9.5 9.5m-5.5 0a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0 -11 0", "key": "svg-0" }], ["path", { "d": "M14.5 14.5m-5.5 0a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0 -11 0", "key": "svg-1" }]]);

var IconChartCircles$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartCircles
});

var IconChartCohort = createReactComponent("outline", "chart-cohort", "IconChartCohort", [["path", { "d": "M3 9h18v-6h-18v18h6v-18", "key": "svg-0" }], ["path", { "d": "M3 15h12v-12", "key": "svg-1" }]]);

var IconChartCohort$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartCohort
});

var IconChartColumn = createReactComponent("outline", "chart-column", "IconChartColumn", [["path", { "d": "M4 20h3", "key": "svg-0" }], ["path", { "d": "M17 20h3", "key": "svg-1" }], ["path", { "d": "M10.5 20h3", "key": "svg-2" }], ["path", { "d": "M4 16h3", "key": "svg-3" }], ["path", { "d": "M17 16h3", "key": "svg-4" }], ["path", { "d": "M10.5 16h3", "key": "svg-5" }], ["path", { "d": "M4 12h3", "key": "svg-6" }], ["path", { "d": "M17 12h3", "key": "svg-7" }], ["path", { "d": "M10.5 12h3", "key": "svg-8" }], ["path", { "d": "M4 8h3", "key": "svg-9" }], ["path", { "d": "M17 8h3", "key": "svg-10" }], ["path", { "d": "M4 4h3", "key": "svg-11" }]]);

var IconChartColumn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartColumn
});

var IconChartCovariate = createReactComponent("outline", "chart-covariate", "IconChartCovariate", [["path", { "d": "M18 11h.009", "key": "svg-0" }], ["path", { "d": "M14 15h.009", "key": "svg-1" }], ["path", { "d": "M12 6h.009", "key": "svg-2" }], ["path", { "d": "M8 10h.009", "key": "svg-3" }], ["path", { "d": "M3 21l17 -17", "key": "svg-4" }], ["path", { "d": "M3 3v18h18", "key": "svg-5" }]]);

var IconChartCovariate$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartCovariate
});

var IconChartDonut2 = createReactComponent("outline", "chart-donut-2", "IconChartDonut2", [["path", { "d": "M12 3v5m4 4h5", "key": "svg-0" }], ["path", { "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-1" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-2" }]]);

var IconChartDonut2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartDonut2
});

var IconChartDonut3 = createReactComponent("outline", "chart-donut-3", "IconChartDonut3", [["path", { "d": "M12 3v5m4 4h5", "key": "svg-0" }], ["path", { "d": "M8.929 14.582l-3.429 2.918", "key": "svg-1" }], ["path", { "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-2" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-3" }]]);

var IconChartDonut3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartDonut3
});

var IconChartDonut4 = createReactComponent("outline", "chart-donut-4", "IconChartDonut4", [["path", { "d": "M8.848 14.667l-3.348 2.833", "key": "svg-0" }], ["path", { "d": "M12 3v5m4 4h5", "key": "svg-1" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-2" }], ["path", { "d": "M14.219 15.328l2.781 4.172", "key": "svg-3" }], ["path", { "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-4" }]]);

var IconChartDonut4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartDonut4
});

var IconChartDonut = createReactComponent("outline", "chart-donut", "IconChartDonut", [["path", { "d": "M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-3.8a4.1 4.1 0 1 1 -5 -5v-4a.9 .9 0 0 0 -1 -.8", "key": "svg-0" }], ["path", { "d": "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a9 9 0 0 0 -1 -1v-4.5", "key": "svg-1" }]]);

var IconChartDonut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartDonut
});

var IconChartDots2 = createReactComponent("outline", "chart-dots-2", "IconChartDots2", [["path", { "d": "M3 3v18h18", "key": "svg-0" }], ["path", { "d": "M9 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M13 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M18 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M21 3l-6 1.5", "key": "svg-4" }], ["path", { "d": "M14.113 6.65l2.771 3.695", "key": "svg-5" }], ["path", { "d": "M16 12.5l-5 2", "key": "svg-6" }]]);

var IconChartDots2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartDots2
});

var IconChartDots3 = createReactComponent("outline", "chart-dots-3", "IconChartDots3", [["path", { "d": "M5 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M16 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M6 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M9 17l5 -1.5", "key": "svg-4" }], ["path", { "d": "M6.5 8.5l7.81 5.37", "key": "svg-5" }], ["path", { "d": "M7 7l8 -1", "key": "svg-6" }]]);

var IconChartDots3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartDots3
});

var IconChartDots = createReactComponent("outline", "chart-dots", "IconChartDots", [["path", { "d": "M3 3v18h18", "key": "svg-0" }], ["path", { "d": "M9 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M14 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M10.16 10.62l2.34 2.88", "key": "svg-4" }], ["path", { "d": "M15.088 13.328l2.837 -4.586", "key": "svg-5" }]]);

var IconChartDots$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartDots
});

var IconChartFunnel = createReactComponent("outline", "chart-funnel", "IconChartFunnel", [["path", { "d": "M4.387 3h15.226a1 1 0 0 1 .948 1.316l-5.105 15.316a2 2 0 0 1 -1.898 1.368h-3.116a2 2 0 0 1 -1.898 -1.368l-5.104 -15.316a1 1 0 0 1 .947 -1.316", "key": "svg-0" }], ["path", { "d": "M5 9h14", "key": "svg-1" }], ["path", { "d": "M7 15h10", "key": "svg-2" }]]);

var IconChartFunnel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartFunnel
});

var IconChartGridDots = createReactComponent("outline", "chart-grid-dots", "IconChartGridDots", [["path", { "d": "M18 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M8 18h8", "key": "svg-4" }], ["path", { "d": "M18 20v1", "key": "svg-5" }], ["path", { "d": "M18 3v1", "key": "svg-6" }], ["path", { "d": "M6 20v1", "key": "svg-7" }], ["path", { "d": "M6 10v-7", "key": "svg-8" }], ["path", { "d": "M12 3v18", "key": "svg-9" }], ["path", { "d": "M18 8v8", "key": "svg-10" }], ["path", { "d": "M8 12h13", "key": "svg-11" }], ["path", { "d": "M21 6h-1", "key": "svg-12" }], ["path", { "d": "M16 6h-13", "key": "svg-13" }], ["path", { "d": "M3 12h1", "key": "svg-14" }], ["path", { "d": "M20 18h1", "key": "svg-15" }], ["path", { "d": "M3 18h1", "key": "svg-16" }], ["path", { "d": "M6 14v2", "key": "svg-17" }]]);

var IconChartGridDots$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartGridDots
});

var IconChartHistogram = createReactComponent("outline", "chart-histogram", "IconChartHistogram", [["path", { "d": "M3 3v18h18", "key": "svg-0" }], ["path", { "d": "M20 18v3", "key": "svg-1" }], ["path", { "d": "M16 16v5", "key": "svg-2" }], ["path", { "d": "M12 13v8", "key": "svg-3" }], ["path", { "d": "M8 16v5", "key": "svg-4" }], ["path", { "d": "M3 11c6 0 5 -5 9 -5s3 5 9 5", "key": "svg-5" }]]);

var IconChartHistogram$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartHistogram
});

var IconChartInfographic = createReactComponent("outline", "chart-infographic", "IconChartInfographic", [["path", { "d": "M7 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M7 3v4h4", "key": "svg-1" }], ["path", { "d": "M9 17l0 4", "key": "svg-2" }], ["path", { "d": "M17 14l0 7", "key": "svg-3" }], ["path", { "d": "M13 13l0 8", "key": "svg-4" }], ["path", { "d": "M21 12l0 9", "key": "svg-5" }]]);

var IconChartInfographic$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartInfographic
});

var IconChartLine = createReactComponent("outline", "chart-line", "IconChartLine", [["path", { "d": "M4 19l16 0", "key": "svg-0" }], ["path", { "d": "M4 15l4 -6l4 2l4 -5l4 4", "key": "svg-1" }]]);

var IconChartLine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartLine
});

var IconChartPie2 = createReactComponent("outline", "chart-pie-2", "IconChartPie2", [["path", { "d": "M12 3v9h9", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconChartPie2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartPie2
});

var IconChartPie3 = createReactComponent("outline", "chart-pie-3", "IconChartPie3", [["path", { "d": "M12 12l-6.5 5.5", "key": "svg-0" }], ["path", { "d": "M12 3v9h9", "key": "svg-1" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-2" }]]);

var IconChartPie3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartPie3
});

var IconChartPie4 = createReactComponent("outline", "chart-pie-4", "IconChartPie4", [["path", { "d": "M12 12l-6.5 5.5", "key": "svg-0" }], ["path", { "d": "M12 3v9h9", "key": "svg-1" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-2" }], ["path", { "d": "M12 12l5 7.5", "key": "svg-3" }]]);

var IconChartPie4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartPie4
});

var IconChartPieOff = createReactComponent("outline", "chart-pie-off", "IconChartPieOff", [["path", { "d": "M5.63 5.643a9 9 0 0 0 12.742 12.715m1.674 -2.29a9.03 9.03 0 0 0 .754 -2.068a1 1 0 0 0 -1 -1h-2.8m-4 0a2 2 0 0 1 -2 -2m0 -4v-3a.9 .9 0 0 0 -1 -.8a9 9 0 0 0 -2.057 .749", "key": "svg-0" }], ["path", { "d": "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a1 1 0 0 1 -1 -1v-4.5", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconChartPieOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartPieOff
});

var IconChartPie = createReactComponent("outline", "chart-pie", "IconChartPie", [["path", { "d": "M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-6.8a2 2 0 0 1 -2 -2v-7a.9 .9 0 0 0 -1 -.8", "key": "svg-0" }], ["path", { "d": "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a1 1 0 0 1 -1 -1v-4.5", "key": "svg-1" }]]);

var IconChartPie$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartPie
});

var IconChartPpf = createReactComponent("outline", "chart-ppf", "IconChartPpf", [["path", { "d": "M19 17c0 -6.075 -5.373 -11 -12 -11", "key": "svg-0" }], ["path", { "d": "M3 3v18h18", "key": "svg-1" }]]);

var IconChartPpf$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartPpf
});

var IconChartRadar = createReactComponent("outline", "chart-radar", "IconChartRadar", [["path", { "d": "M12 3l9.5 7l-3.5 11h-12l-3.5 -11z", "key": "svg-0" }], ["path", { "d": "M12 7.5l5.5 4l-2.5 5.5h-6.5l-2 -5.5z", "key": "svg-1" }], ["path", { "d": "M2.5 10l9.5 3l9.5 -3", "key": "svg-2" }], ["path", { "d": "M12 3v10l6 8", "key": "svg-3" }], ["path", { "d": "M6 21l6 -8", "key": "svg-4" }]]);

var IconChartRadar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartRadar
});

var IconChartSankey = createReactComponent("outline", "chart-sankey", "IconChartSankey", [["path", { "d": "M3 3v18h18", "key": "svg-0" }], ["path", { "d": "M3 6h18", "key": "svg-1" }], ["path", { "d": "M3 8c10 0 8 9 18 9", "key": "svg-2" }]]);

var IconChartSankey$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartSankey
});

var IconChartScatter3d = createReactComponent("outline", "chart-scatter-3d", "IconChartScatter3d", [["path", { "d": "M3 20l9 -7", "key": "svg-0" }], ["path", { "d": "M12 3v10l9 7", "key": "svg-1" }], ["path", { "d": "M17 12v.015", "key": "svg-2" }], ["path", { "d": "M17 4.015v.015", "key": "svg-3" }], ["path", { "d": "M21 8.015v.015", "key": "svg-4" }], ["path", { "d": "M12 19.015v.015", "key": "svg-5" }], ["path", { "d": "M3 12.015v.015", "key": "svg-6" }], ["path", { "d": "M7 8.015v.015", "key": "svg-7" }], ["path", { "d": "M3 4.015v.015", "key": "svg-8" }]]);

var IconChartScatter3d$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartScatter3d
});

var IconChartScatter = createReactComponent("outline", "chart-scatter", "IconChartScatter", [["path", { "d": "M3 3v18h18", "key": "svg-0" }], ["path", { "d": "M8 15.015v.015", "key": "svg-1" }], ["path", { "d": "M16 16.015v.015", "key": "svg-2" }], ["path", { "d": "M8 7.03v.015", "key": "svg-3" }], ["path", { "d": "M12 11.03v.015", "key": "svg-4" }], ["path", { "d": "M19 11.03v.015", "key": "svg-5" }]]);

var IconChartScatter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartScatter
});

var IconChartTreemap = createReactComponent("outline", "chart-treemap", "IconChartTreemap", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 4v16", "key": "svg-1" }], ["path", { "d": "M4 15h8", "key": "svg-2" }], ["path", { "d": "M12 12h8", "key": "svg-3" }], ["path", { "d": "M16 12v8", "key": "svg-4" }], ["path", { "d": "M16 16h4", "key": "svg-5" }]]);

var IconChartTreemap$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartTreemap
});

var IconCheck = createReactComponent("outline", "check", "IconCheck", [["path", { "d": "M5 12l5 5l10 -10", "key": "svg-0" }]]);

var IconCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCheck
});

var IconCheckbox = createReactComponent("outline", "checkbox", "IconCheckbox", [["path", { "d": "M9 11l3 3l8 -8", "key": "svg-0" }], ["path", { "d": "M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9", "key": "svg-1" }]]);

var IconCheckbox$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCheckbox
});

var IconChecklist = createReactComponent("outline", "checklist", "IconChecklist", [["path", { "d": "M9.615 20h-2.615a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M14 19l2 2l4 -4", "key": "svg-1" }], ["path", { "d": "M9 8h4", "key": "svg-2" }], ["path", { "d": "M9 12h2", "key": "svg-3" }]]);

var IconChecklist$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChecklist
});

var IconChecks = createReactComponent("outline", "checks", "IconChecks", [["path", { "d": "M7 12l5 5l10 -10", "key": "svg-0" }], ["path", { "d": "M2 12l5 5m5 -5l5 -5", "key": "svg-1" }]]);

var IconChecks$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChecks
});

var IconCheckupList = createReactComponent("outline", "checkup-list", "IconCheckupList", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M9 14h.01", "key": "svg-2" }], ["path", { "d": "M9 17h.01", "key": "svg-3" }], ["path", { "d": "M12 16l1 1l3 -3", "key": "svg-4" }]]);

var IconCheckupList$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCheckupList
});

var IconCheese = createReactComponent("outline", "cheese", "IconCheese", [["path", { "d": "M4.519 20.008l16.481 -.008v-3.5a2 2 0 1 1 0 -4v-3.5h-16.722", "key": "svg-0" }], ["path", { "d": "M21 9l-9.385 -4.992c-2.512 .12 -4.758 1.42 -6.327 3.425c-1.423 1.82 -2.288 4.221 -2.288 6.854c0 2.117 .56 4.085 1.519 5.721", "key": "svg-1" }], ["path", { "d": "M15 13v.01", "key": "svg-2" }], ["path", { "d": "M8 13v.01", "key": "svg-3" }], ["path", { "d": "M11 16v.01", "key": "svg-4" }]]);

var IconCheese$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCheese
});

var IconChefHatOff = createReactComponent("outline", "chef-hat-off", "IconChefHatOff", [["path", { "d": "M8.72 4.712a4 4 0 0 1 7.19 1.439a4 4 0 0 1 2.09 7.723v.126m0 4v3h-12v-7.126a4 4 0 0 1 .081 -7.796", "key": "svg-0" }], ["path", { "d": "M6.161 17.009l10.839 -.009", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconChefHatOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChefHatOff
});

var IconChefHat = createReactComponent("outline", "chef-hat", "IconChefHat", [["path", { "d": "M12 3c1.918 0 3.52 1.35 3.91 3.151a4 4 0 0 1 2.09 7.723l0 7.126h-12v-7.126a4 4 0 1 1 2.092 -7.723a4 4 0 0 1 3.908 -3.151z", "key": "svg-0" }], ["path", { "d": "M6.161 17.009l11.839 -.009", "key": "svg-1" }]]);

var IconChefHat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChefHat
});

var IconCherry = createReactComponent("outline", "cherry", "IconCherry", [["path", { "d": "M7.5 16.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0", "key": "svg-0" }], ["path", { "d": "M17 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M9 13c.366 -2 1.866 -3.873 4.5 -5.6", "key": "svg-2" }], ["path", { "d": "M17 15c-1.333 -2.333 -2.333 -5.333 -1 -9", "key": "svg-3" }], ["path", { "d": "M5 6c3.667 -2.667 7.333 -2.667 11 0c-3.667 2.667 -7.333 2.667 -11 0", "key": "svg-4" }]]);

var IconCherry$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCherry
});

var IconChessBishop = createReactComponent("outline", "chess-bishop", "IconChessBishop", [["path", { "d": "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z", "key": "svg-0" }], ["path", { "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M9.5 16c-1.667 0 -2.5 -1.669 -2.5 -3c0 -3.667 1.667 -6 5 -7c3.333 1 5 3.427 5 7c0 1.284 -.775 2.881 -2.325 3l-.175 0h-5z", "key": "svg-2" }], ["path", { "d": "M15 8l-3 3", "key": "svg-3" }], ["path", { "d": "M12 5v1", "key": "svg-4" }]]);

var IconChessBishop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChessBishop
});

var IconChessKing = createReactComponent("outline", "chess-king", "IconChessKing", [["path", { "d": "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z", "key": "svg-0" }], ["path", { "d": "M8.5 16a3.5 3.5 0 1 1 3.163 -5h.674a3.5 3.5 0 1 1 3.163 5z", "key": "svg-1" }], ["path", { "d": "M9 6h6", "key": "svg-2" }], ["path", { "d": "M12 3v8", "key": "svg-3" }]]);

var IconChessKing$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChessKing
});

var IconChessKnight = createReactComponent("outline", "chess-knight", "IconChessKnight", [["path", { "d": "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z", "key": "svg-0" }], ["path", { "d": "M9 3l1 3l-3.491 2.148a1 1 0 0 0 .524 1.852h2.967l-2.073 6h7.961l.112 -5c0 -3 -1.09 -5.983 -4 -7c-1.94 -.678 -2.94 -1.011 -3 -1z", "key": "svg-1" }]]);

var IconChessKnight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChessKnight
});

var IconChessQueen = createReactComponent("outline", "chess-queen", "IconChessQueen", [["path", { "d": "M16 16l2 -11l-4 4l-2 -5l-2 5l-4 -4l2 11", "key": "svg-0" }], ["path", { "d": "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z", "key": "svg-1" }], ["path", { "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M6 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M18 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }]]);

var IconChessQueen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChessQueen
});

var IconChessRook = createReactComponent("outline", "chess-rook", "IconChessRook", [["path", { "d": "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z", "key": "svg-0" }], ["path", { "d": "M8 16l1 -9h6l1 9", "key": "svg-1" }], ["path", { "d": "M6 4l.5 3h11l.5 -3", "key": "svg-2" }], ["path", { "d": "M10 4v3", "key": "svg-3" }], ["path", { "d": "M14 4v3", "key": "svg-4" }]]);

var IconChessRook$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChessRook
});

var IconChess = createReactComponent("outline", "chess", "IconChess", [["path", { "d": "M12 3a3 3 0 0 1 3 3c0 1.113 -.6 2.482 -1.5 3l1.5 7h-6l1.5 -7c-.9 -.518 -1.5 -1.887 -1.5 -3a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M8 9h8", "key": "svg-1" }], ["path", { "d": "M6.684 16.772a1 1 0 0 0 -.684 .949v1.279a1 1 0 0 0 1 1h10a1 1 0 0 0 1 -1v-1.28a1 1 0 0 0 -.684 -.948l-2.316 -.772h-6l-2.316 .772z", "key": "svg-2" }]]);

var IconChess$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChess
});

var IconChevronCompactDown = createReactComponent("outline", "chevron-compact-down", "IconChevronCompactDown", [["path", { "d": "M4 11l8 3l8 -3", "key": "svg-0" }]]);

var IconChevronCompactDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronCompactDown
});

var IconChevronCompactLeft = createReactComponent("outline", "chevron-compact-left", "IconChevronCompactLeft", [["path", { "d": "M13 20l-3 -8l3 -8", "key": "svg-0" }]]);

var IconChevronCompactLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronCompactLeft
});

var IconChevronCompactRight = createReactComponent("outline", "chevron-compact-right", "IconChevronCompactRight", [["path", { "d": "M11 4l3 8l-3 8", "key": "svg-0" }]]);

var IconChevronCompactRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronCompactRight
});

var IconChevronCompactUp = createReactComponent("outline", "chevron-compact-up", "IconChevronCompactUp", [["path", { "d": "M4 13l8 -3l8 3", "key": "svg-0" }]]);

var IconChevronCompactUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronCompactUp
});

var IconChevronDownLeft = createReactComponent("outline", "chevron-down-left", "IconChevronDownLeft", [["path", { "d": "M8 8v8h8", "key": "svg-0" }]]);

var IconChevronDownLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronDownLeft
});

var IconChevronDownRight = createReactComponent("outline", "chevron-down-right", "IconChevronDownRight", [["path", { "d": "M16 8v8h-8", "key": "svg-0" }]]);

var IconChevronDownRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronDownRight
});

var IconChevronDown = createReactComponent("outline", "chevron-down", "IconChevronDown", [["path", { "d": "M6 9l6 6l6 -6", "key": "svg-0" }]]);

var IconChevronDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronDown
});

var IconChevronLeftPipe = createReactComponent("outline", "chevron-left-pipe", "IconChevronLeftPipe", [["path", { "d": "M7 6v12", "key": "svg-0" }], ["path", { "d": "M18 6l-6 6l6 6", "key": "svg-1" }]]);

var IconChevronLeftPipe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronLeftPipe
});

var IconChevronLeft = createReactComponent("outline", "chevron-left", "IconChevronLeft", [["path", { "d": "M15 6l-6 6l6 6", "key": "svg-0" }]]);

var IconChevronLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronLeft
});

var IconChevronRightPipe = createReactComponent("outline", "chevron-right-pipe", "IconChevronRightPipe", [["path", { "d": "M6 6l6 6l-6 6", "key": "svg-0" }], ["path", { "d": "M17 5v13", "key": "svg-1" }]]);

var IconChevronRightPipe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronRightPipe
});

var IconChevronRight = createReactComponent("outline", "chevron-right", "IconChevronRight", [["path", { "d": "M9 6l6 6l-6 6", "key": "svg-0" }]]);

var IconChevronRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronRight
});

var IconChevronUpLeft = createReactComponent("outline", "chevron-up-left", "IconChevronUpLeft", [["path", { "d": "M8 16v-8h8", "key": "svg-0" }]]);

var IconChevronUpLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronUpLeft
});

var IconChevronUpRight = createReactComponent("outline", "chevron-up-right", "IconChevronUpRight", [["path", { "d": "M8 8h8v8", "key": "svg-0" }]]);

var IconChevronUpRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronUpRight
});

var IconChevronUp = createReactComponent("outline", "chevron-up", "IconChevronUp", [["path", { "d": "M6 15l6 -6l6 6", "key": "svg-0" }]]);

var IconChevronUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronUp
});

var IconChevronsDownLeft = createReactComponent("outline", "chevrons-down-left", "IconChevronsDownLeft", [["path", { "d": "M11 5v8h8", "key": "svg-0" }], ["path", { "d": "M7 9v8h8", "key": "svg-1" }]]);

var IconChevronsDownLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronsDownLeft
});

var IconChevronsDownRight = createReactComponent("outline", "chevrons-down-right", "IconChevronsDownRight", [["path", { "d": "M13 5v8h-8", "key": "svg-0" }], ["path", { "d": "M17 9v8h-8", "key": "svg-1" }]]);

var IconChevronsDownRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronsDownRight
});

var IconChevronsDown = createReactComponent("outline", "chevrons-down", "IconChevronsDown", [["path", { "d": "M7 7l5 5l5 -5", "key": "svg-0" }], ["path", { "d": "M7 13l5 5l5 -5", "key": "svg-1" }]]);

var IconChevronsDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronsDown
});

var IconChevronsLeft = createReactComponent("outline", "chevrons-left", "IconChevronsLeft", [["path", { "d": "M11 7l-5 5l5 5", "key": "svg-0" }], ["path", { "d": "M17 7l-5 5l5 5", "key": "svg-1" }]]);

var IconChevronsLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronsLeft
});

var IconChevronsRight = createReactComponent("outline", "chevrons-right", "IconChevronsRight", [["path", { "d": "M7 7l5 5l-5 5", "key": "svg-0" }], ["path", { "d": "M13 7l5 5l-5 5", "key": "svg-1" }]]);

var IconChevronsRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronsRight
});

var IconChevronsUpLeft = createReactComponent("outline", "chevrons-up-left", "IconChevronsUpLeft", [["path", { "d": "M7 15v-8h8", "key": "svg-0" }], ["path", { "d": "M11 19v-8h8", "key": "svg-1" }]]);

var IconChevronsUpLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronsUpLeft
});

var IconChevronsUpRight = createReactComponent("outline", "chevrons-up-right", "IconChevronsUpRight", [["path", { "d": "M9 7h8v8", "key": "svg-0" }], ["path", { "d": "M5 11h8v8", "key": "svg-1" }]]);

var IconChevronsUpRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronsUpRight
});

var IconChevronsUp = createReactComponent("outline", "chevrons-up", "IconChevronsUp", [["path", { "d": "M7 11l5 -5l5 5", "key": "svg-0" }], ["path", { "d": "M7 17l5 -5l5 5", "key": "svg-1" }]]);

var IconChevronsUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChevronsUp
});

var IconChisel = createReactComponent("outline", "chisel", "IconChisel", [["path", { "d": "M14 14l1.5 1.5", "key": "svg-0" }], ["path", { "d": "M18.347 15.575l2.08 2.079a1.96 1.96 0 0 1 -2.773 2.772l-2.08 -2.079a1.96 1.96 0 0 1 2.773 -2.772z", "key": "svg-1" }], ["path", { "d": "M3 6l3 -3l7.414 7.414a2 2 0 0 1 .586 1.414v2.172h-2.172a2 2 0 0 1 -1.414 -.586l-7.414 -7.414z", "key": "svg-2" }]]);

var IconChisel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChisel
});

var IconChristmasBall = createReactComponent("outline", "christmas-ball", "IconChristmasBall", [["path", { "d": "M12 13m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0", "key": "svg-0" }], ["path", { "d": "M11 5l1 -2l1 2", "key": "svg-1" }], ["path", { "d": "M4.512 10.161c2.496 -1.105 4.992 -.825 7.488 .839c2.627 1.752 5.255 1.97 7.882 .653", "key": "svg-2" }], ["path", { "d": "M4.315 15.252c2.561 -1.21 5.123 -.96 7.685 .748c2.293 1.528 4.585 1.889 6.878 1.081", "key": "svg-3" }]]);

var IconChristmasBall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChristmasBall
});

var IconChristmasTreeOff = createReactComponent("outline", "christmas-tree-off", "IconChristmasTreeOff", [["path", { "d": "M9.5 5.5l2.5 -2.5l4 4l-2 1l4 4l-1.5 .5m.5 4.5h-12l4 -4l-3 -1l3 -3", "key": "svg-0" }], ["path", { "d": "M14 17v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-3", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconChristmasTreeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChristmasTreeOff
});

var IconChristmasTree = createReactComponent("outline", "christmas-tree", "IconChristmasTree", [["path", { "d": "M12 3l4 4l-2 1l4 4l-3 1l4 4h-14l4 -4l-3 -1l4 -4l-2 -1z", "key": "svg-0" }], ["path", { "d": "M14 17v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-3", "key": "svg-1" }]]);

var IconChristmasTree$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChristmasTree
});

var IconCircleArrowDownLeft = createReactComponent("outline", "circle-arrow-down-left", "IconCircleArrowDownLeft", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M15 9l-6 6", "key": "svg-1" }], ["path", { "d": "M15 15h-6v-6", "key": "svg-2" }]]);

var IconCircleArrowDownLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowDownLeft
});

var IconCircleArrowDownRight = createReactComponent("outline", "circle-arrow-down-right", "IconCircleArrowDownRight", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M15 15h-6", "key": "svg-1" }], ["path", { "d": "M15 9v6l-6 -6", "key": "svg-2" }]]);

var IconCircleArrowDownRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowDownRight
});

var IconCircleArrowDown = createReactComponent("outline", "circle-arrow-down", "IconCircleArrowDown", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M8 12l4 4", "key": "svg-1" }], ["path", { "d": "M12 8v8", "key": "svg-2" }], ["path", { "d": "M16 12l-4 4", "key": "svg-3" }]]);

var IconCircleArrowDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowDown
});

var IconCircleArrowLeft = createReactComponent("outline", "circle-arrow-left", "IconCircleArrowLeft", [["path", { "d": "M12 21a9 9 0 1 0 0 -18a9 9 0 0 0 0 18", "key": "svg-0" }], ["path", { "d": "M8 12l4 4", "key": "svg-1" }], ["path", { "d": "M8 12h8", "key": "svg-2" }], ["path", { "d": "M12 8l-4 4", "key": "svg-3" }]]);

var IconCircleArrowLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowLeft
});

var IconCircleArrowRight = createReactComponent("outline", "circle-arrow-right", "IconCircleArrowRight", [["path", { "d": "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18", "key": "svg-0" }], ["path", { "d": "M16 12l-4 -4", "key": "svg-1" }], ["path", { "d": "M16 12h-8", "key": "svg-2" }], ["path", { "d": "M12 16l4 -4", "key": "svg-3" }]]);

var IconCircleArrowRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowRight
});

var IconCircleArrowUpLeft = createReactComponent("outline", "circle-arrow-up-left", "IconCircleArrowUpLeft", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 9l6 6", "key": "svg-1" }], ["path", { "d": "M15 9h-6v6", "key": "svg-2" }]]);

var IconCircleArrowUpLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowUpLeft
});

var IconCircleArrowUpRight = createReactComponent("outline", "circle-arrow-up-right", "IconCircleArrowUpRight", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M15 9l-6 6", "key": "svg-1" }], ["path", { "d": "M15 15v-6h-6", "key": "svg-2" }]]);

var IconCircleArrowUpRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowUpRight
});

var IconCircleArrowUp = createReactComponent("outline", "circle-arrow-up", "IconCircleArrowUp", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 8l-4 4", "key": "svg-1" }], ["path", { "d": "M12 8v8", "key": "svg-2" }], ["path", { "d": "M16 12l-4 -4", "key": "svg-3" }]]);

var IconCircleArrowUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowUp
});

var IconCircleCaretDown = createReactComponent("outline", "circle-caret-down", "IconCircleCaretDown", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 15l-4 -4h8z", "key": "svg-1" }]]);

var IconCircleCaretDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleCaretDown
});

var IconCircleCaretLeft = createReactComponent("outline", "circle-caret-left", "IconCircleCaretLeft", [["path", { "d": "M9 12l4 -4v8z", "key": "svg-0" }], ["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-1" }]]);

var IconCircleCaretLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleCaretLeft
});

var IconCircleCaretRight = createReactComponent("outline", "circle-caret-right", "IconCircleCaretRight", [["path", { "d": "M15 12l-4 -4v8z", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconCircleCaretRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleCaretRight
});

var IconCircleCaretUp = createReactComponent("outline", "circle-caret-up", "IconCircleCaretUp", [["path", { "d": "M12 9l4 4h-8z", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconCircleCaretUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleCaretUp
});

var IconCircleCheck = createReactComponent("outline", "circle-check", "IconCircleCheck", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 12l2 2l4 -4", "key": "svg-1" }]]);

var IconCircleCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleCheck
});

var IconCircleChevronDown = createReactComponent("outline", "circle-chevron-down", "IconCircleChevronDown", [["path", { "d": "M15 11l-3 3l-3 -3", "key": "svg-0" }], ["path", { "d": "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z", "key": "svg-1" }]]);

var IconCircleChevronDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronDown
});

var IconCircleChevronLeft = createReactComponent("outline", "circle-chevron-left", "IconCircleChevronLeft", [["path", { "d": "M13 15l-3 -3l3 -3", "key": "svg-0" }], ["path", { "d": "M21 12a9 9 0 1 0 -18 0a9 9 0 0 0 18 0z", "key": "svg-1" }]]);

var IconCircleChevronLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronLeft
});

var IconCircleChevronRight = createReactComponent("outline", "circle-chevron-right", "IconCircleChevronRight", [["path", { "d": "M11 9l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0z", "key": "svg-1" }]]);

var IconCircleChevronRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronRight
});

var IconCircleChevronUp = createReactComponent("outline", "circle-chevron-up", "IconCircleChevronUp", [["path", { "d": "M9 13l3 -3l3 3", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconCircleChevronUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronUp
});

var IconCircleChevronsDown = createReactComponent("outline", "circle-chevrons-down", "IconCircleChevronsDown", [["path", { "d": "M15 9l-3 3l-3 -3", "key": "svg-0" }], ["path", { "d": "M15 13l-3 3l-3 -3", "key": "svg-1" }], ["path", { "d": "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z", "key": "svg-2" }]]);

var IconCircleChevronsDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronsDown
});

var IconCircleChevronsLeft = createReactComponent("outline", "circle-chevrons-left", "IconCircleChevronsLeft", [["path", { "d": "M15 15l-3 -3l3 -3", "key": "svg-0" }], ["path", { "d": "M11 15l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M21 12a9 9 0 1 0 0 .265l0 -.265z", "key": "svg-2" }]]);

var IconCircleChevronsLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronsLeft
});

var IconCircleChevronsRight = createReactComponent("outline", "circle-chevrons-right", "IconCircleChevronsRight", [["path", { "d": "M9 9l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M13 9l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M3 12a9 9 0 1 0 0 -.265l0 .265z", "key": "svg-2" }]]);

var IconCircleChevronsRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronsRight
});

var IconCircleChevronsUp = createReactComponent("outline", "circle-chevrons-up", "IconCircleChevronsUp", [["path", { "d": "M9 15l3 -3l3 3", "key": "svg-0" }], ["path", { "d": "M9 11l3 -3l3 3", "key": "svg-1" }], ["path", { "d": "M12 21a9 9 0 1 0 -.265 0l.265 0z", "key": "svg-2" }]]);

var IconCircleChevronsUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronsUp
});

var IconCircleDashedCheck = createReactComponent("outline", "circle-dashed-check", "IconCircleDashedCheck", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M9 12l2 2l4 -4", "key": "svg-8" }]]);

var IconCircleDashedCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedCheck
});

var IconCircleDashedLetterA = createReactComponent("outline", "circle-dashed-letter-a", "IconCircleDashedLetterA", [["path", { "d": "M10 16v-6a2 2 0 1 1 4 0v6", "key": "svg-0" }], ["path", { "d": "M10 13h4", "key": "svg-1" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-2" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-3" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-4" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-5" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-6" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-7" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-8" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-9" }]]);

var IconCircleDashedLetterA$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterA
});

var IconCircleDashedLetterB = createReactComponent("outline", "circle-dashed-letter-b", "IconCircleDashedLetterB", [["path", { "d": "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2z", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterB$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterB
});

var IconCircleDashedLetterC = createReactComponent("outline", "circle-dashed-letter-c", "IconCircleDashedLetterC", [["path", { "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterC$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterC
});

var IconCircleDashedLetterD = createReactComponent("outline", "circle-dashed-letter-d", "IconCircleDashedLetterD", [["path", { "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterD$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterD
});

var IconCircleDashedLetterE = createReactComponent("outline", "circle-dashed-letter-e", "IconCircleDashedLetterE", [["path", { "d": "M14 8h-4v8h4", "key": "svg-0" }], ["path", { "d": "M10 12h2.5", "key": "svg-1" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-2" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-3" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-4" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-5" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-6" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-7" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-8" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-9" }]]);

var IconCircleDashedLetterE$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterE
});

var IconCircleDashedLetterF = createReactComponent("outline", "circle-dashed-letter-f", "IconCircleDashedLetterF", [["path", { "d": "M10 12h3", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8", "key": "svg-1" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-2" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-3" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-4" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-5" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-6" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-7" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-8" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-9" }]]);

var IconCircleDashedLetterF$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterF
});

var IconCircleDashedLetterG = createReactComponent("outline", "circle-dashed-letter-g", "IconCircleDashedLetterG", [["path", { "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterG$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterG
});

var IconCircleDashedLetterH = createReactComponent("outline", "circle-dashed-letter-h", "IconCircleDashedLetterH", [["path", { "d": "M10 16v-8m4 0v8", "key": "svg-0" }], ["path", { "d": "M10 12h4", "key": "svg-1" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-2" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-3" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-4" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-5" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-6" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-7" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-8" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-9" }]]);

var IconCircleDashedLetterH$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterH
});

var IconCircleDashedLetterI = createReactComponent("outline", "circle-dashed-letter-i", "IconCircleDashedLetterI", [["path", { "d": "M12 8v8", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterI$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterI
});

var IconCircleDashedLetterJ = createReactComponent("outline", "circle-dashed-letter-j", "IconCircleDashedLetterJ", [["path", { "d": "M10 8h4v6a2 2 0 1 1 -4 0", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterJ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterJ
});

var IconCircleDashedLetterK = createReactComponent("outline", "circle-dashed-letter-k", "IconCircleDashedLetterK", [["path", { "d": "M10 8v8", "key": "svg-0" }], ["path", { "d": "M14 8l-2.5 4l2.5 4", "key": "svg-1" }], ["path", { "d": "M10 12h1.5", "key": "svg-2" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-3" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-4" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-5" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-6" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-7" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-8" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-9" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-10" }]]);

var IconCircleDashedLetterK$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterK
});

var IconCircleDashedLetterL = createReactComponent("outline", "circle-dashed-letter-l", "IconCircleDashedLetterL", [["path", { "d": "M10 8v8h4", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterL$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterL
});

var IconCircleDashedLetterM = createReactComponent("outline", "circle-dashed-letter-m", "IconCircleDashedLetterM", [["path", { "d": "M9 16v-8l3 5l3 -5v8", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterM$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterM
});

var IconCircleDashedLetterN = createReactComponent("outline", "circle-dashed-letter-n", "IconCircleDashedLetterN", [["path", { "d": "M10 16v-8l4 8v-8", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterN$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterN
});

var IconCircleDashedLetterO = createReactComponent("outline", "circle-dashed-letter-o", "IconCircleDashedLetterO", [["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterO$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterO
});

var IconCircleDashedLetterP = createReactComponent("outline", "circle-dashed-letter-p", "IconCircleDashedLetterP", [["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterP$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterP
});

var IconCircleDashedLetterQ = createReactComponent("outline", "circle-dashed-letter-q", "IconCircleDashedLetterQ", [["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M13 15l1 1", "key": "svg-1" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-2" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-3" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-4" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-5" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-6" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-7" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-8" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-9" }]]);

var IconCircleDashedLetterQ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterQ
});

var IconCircleDashedLetterR = createReactComponent("outline", "circle-dashed-letter-r", "IconCircleDashedLetterR", [["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterR$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterR
});

var IconCircleDashedLetterS = createReactComponent("outline", "circle-dashed-letter-s", "IconCircleDashedLetterS", [["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterS$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterS
});

var IconCircleDashedLetterT = createReactComponent("outline", "circle-dashed-letter-t", "IconCircleDashedLetterT", [["path", { "d": "M10 8h4", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-2" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-3" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-4" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-5" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-6" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-7" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-8" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-9" }]]);

var IconCircleDashedLetterT$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterT
});

var IconCircleDashedLetterU = createReactComponent("outline", "circle-dashed-letter-u", "IconCircleDashedLetterU", [["path", { "d": "M10 8v6a2 2 0 1 0 4 0v-6", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterU$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterU
});

var IconCircleDashedLetterV = createReactComponent("outline", "circle-dashed-letter-v", "IconCircleDashedLetterV", [["path", { "d": "M10 8l2 8l2 -8", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterV$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterV
});

var IconCircleDashedLetterW = createReactComponent("outline", "circle-dashed-letter-w", "IconCircleDashedLetterW", [["path", { "d": "M9 8l1 8l2 -5l2 5l1 -8", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterW$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterW
});

var IconCircleDashedLetterX = createReactComponent("outline", "circle-dashed-letter-x", "IconCircleDashedLetterX", [["path", { "d": "M10 8l4 8", "key": "svg-0" }], ["path", { "d": "M10 16l4 -8", "key": "svg-1" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-2" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-3" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-4" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-5" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-6" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-7" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-8" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-9" }]]);

var IconCircleDashedLetterX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterX
});

var IconCircleDashedLetterY = createReactComponent("outline", "circle-dashed-letter-y", "IconCircleDashedLetterY", [["path", { "d": "M10 8l2 5l2 -5", "key": "svg-0" }], ["path", { "d": "M12 16v-3", "key": "svg-1" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-2" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-3" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-4" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-5" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-6" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-7" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-8" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-9" }]]);

var IconCircleDashedLetterY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterY
});

var IconCircleDashedLetterZ = createReactComponent("outline", "circle-dashed-letter-z", "IconCircleDashedLetterZ", [["path", { "d": "M10 8h4l-4 8h4", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }]]);

var IconCircleDashedLetterZ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedLetterZ
});

var IconCircleDashedMinus = createReactComponent("outline", "circle-dashed-minus", "IconCircleDashedMinus", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M9 12h6", "key": "svg-8" }]]);

var IconCircleDashedMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedMinus
});

var IconCircleDashedNumber0 = createReactComponent("outline", "circle-dashed-number-0", "IconCircleDashedNumber0", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", "key": "svg-8" }]]);

var IconCircleDashedNumber0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedNumber0
});

var IconCircleDashedNumber1 = createReactComponent("outline", "circle-dashed-number-1", "IconCircleDashedNumber1", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M10 10l2 -2v8", "key": "svg-8" }]]);

var IconCircleDashedNumber1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedNumber1
});

var IconCircleDashedNumber2 = createReactComponent("outline", "circle-dashed-number-2", "IconCircleDashedNumber2", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-8" }]]);

var IconCircleDashedNumber2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedNumber2
});

var IconCircleDashedNumber3 = createReactComponent("outline", "circle-dashed-number-3", "IconCircleDashedNumber3", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M10 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-8" }]]);

var IconCircleDashedNumber3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedNumber3
});

var IconCircleDashedNumber4 = createReactComponent("outline", "circle-dashed-number-4", "IconCircleDashedNumber4", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M10 8v3a1 1 0 0 0 1 1h3", "key": "svg-8" }], ["path", { "d": "M14 8v8", "key": "svg-9" }]]);

var IconCircleDashedNumber4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedNumber4
});

var IconCircleDashedNumber5 = createReactComponent("outline", "circle-dashed-number-5", "IconCircleDashedNumber5", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-8" }]]);

var IconCircleDashedNumber5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedNumber5
});

var IconCircleDashedNumber6 = createReactComponent("outline", "circle-dashed-number-6", "IconCircleDashedNumber6", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-8" }]]);

var IconCircleDashedNumber6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedNumber6
});

var IconCircleDashedNumber7 = createReactComponent("outline", "circle-dashed-number-7", "IconCircleDashedNumber7", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M10 8h4l-2 8", "key": "svg-8" }]]);

var IconCircleDashedNumber7$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedNumber7
});

var IconCircleDashedNumber8 = createReactComponent("outline", "circle-dashed-number-8", "IconCircleDashedNumber8", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-8" }]]);

var IconCircleDashedNumber8$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedNumber8
});

var IconCircleDashedNumber9 = createReactComponent("outline", "circle-dashed-number-9", "IconCircleDashedNumber9", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-8" }]]);

var IconCircleDashedNumber9$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedNumber9
});

var IconCircleDashedPercentage = createReactComponent("outline", "circle-dashed-percentage", "IconCircleDashedPercentage", [["path", { "d": "M9 15l6 -6", "key": "svg-0" }], ["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-1" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-2" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-3" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-4" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-5" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-6" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-7" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-8" }], ["path", { "d": "M9 9.03v.015", "key": "svg-9" }], ["path", { "d": "M15 15.045v.015", "key": "svg-10" }]]);

var IconCircleDashedPercentage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedPercentage
});

var IconCircleDashedPlus = createReactComponent("outline", "circle-dashed-plus", "IconCircleDashedPlus", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M9 12h6", "key": "svg-8" }], ["path", { "d": "M12 9v6", "key": "svg-9" }]]);

var IconCircleDashedPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedPlus
});

var IconCircleDashedX = createReactComponent("outline", "circle-dashed-x", "IconCircleDashedX", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M14 14l-4 -4", "key": "svg-8" }], ["path", { "d": "M10 14l4 -4", "key": "svg-9" }]]);

var IconCircleDashedX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashedX
});

var IconCircleDashed = createReactComponent("outline", "circle-dashed", "IconCircleDashed", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }]]);

var IconCircleDashed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDashed
});

var IconCircleDot = createReactComponent("outline", "circle-dot", "IconCircleDot", [["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconCircleDot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDot
});

var IconCircleDottedLetterA = createReactComponent("outline", "circle-dotted-letter-a", "IconCircleDottedLetterA", [["path", { "d": "M10 16v-6a2 2 0 1 1 4 0v6", "key": "svg-0" }], ["path", { "d": "M10 13h4", "key": "svg-1" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-2" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-3" }], ["path", { "d": "M3 12v.01", "key": "svg-4" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-5" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-6" }], ["path", { "d": "M12 21v.01", "key": "svg-7" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-8" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-9" }], ["path", { "d": "M21 12v.01", "key": "svg-10" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-11" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-12" }], ["path", { "d": "M12 3v.01", "key": "svg-13" }]]);

var IconCircleDottedLetterA$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterA
});

var IconCircleDottedLetterB = createReactComponent("outline", "circle-dotted-letter-b", "IconCircleDottedLetterB", [["path", { "d": "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2z", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterB$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterB
});

var IconCircleDottedLetterC = createReactComponent("outline", "circle-dotted-letter-c", "IconCircleDottedLetterC", [["path", { "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterC$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterC
});

var IconCircleDottedLetterD = createReactComponent("outline", "circle-dotted-letter-d", "IconCircleDottedLetterD", [["path", { "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterD$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterD
});

var IconCircleDottedLetterE = createReactComponent("outline", "circle-dotted-letter-e", "IconCircleDottedLetterE", [["path", { "d": "M14 8h-4v8h4", "key": "svg-0" }], ["path", { "d": "M10 12h2.5", "key": "svg-1" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-2" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-3" }], ["path", { "d": "M3 12v.01", "key": "svg-4" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-5" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-6" }], ["path", { "d": "M12 21v.01", "key": "svg-7" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-8" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-9" }], ["path", { "d": "M21 12v.01", "key": "svg-10" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-11" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-12" }], ["path", { "d": "M12 3v.01", "key": "svg-13" }]]);

var IconCircleDottedLetterE$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterE
});

var IconCircleDottedLetterF = createReactComponent("outline", "circle-dotted-letter-f", "IconCircleDottedLetterF", [["path", { "d": "M10 12h3", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8", "key": "svg-1" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-2" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-3" }], ["path", { "d": "M3 12v.01", "key": "svg-4" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-5" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-6" }], ["path", { "d": "M12 21v.01", "key": "svg-7" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-8" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-9" }], ["path", { "d": "M21 12v.01", "key": "svg-10" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-11" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-12" }], ["path", { "d": "M12 3v.01", "key": "svg-13" }]]);

var IconCircleDottedLetterF$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterF
});

var IconCircleDottedLetterG = createReactComponent("outline", "circle-dotted-letter-g", "IconCircleDottedLetterG", [["path", { "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterG$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterG
});

var IconCircleDottedLetterH = createReactComponent("outline", "circle-dotted-letter-h", "IconCircleDottedLetterH", [["path", { "d": "M10 16v-8m4 0v8", "key": "svg-0" }], ["path", { "d": "M10 12h4", "key": "svg-1" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-2" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-3" }], ["path", { "d": "M3 12v.01", "key": "svg-4" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-5" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-6" }], ["path", { "d": "M12 21v.01", "key": "svg-7" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-8" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-9" }], ["path", { "d": "M21 12v.01", "key": "svg-10" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-11" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-12" }], ["path", { "d": "M12 3v.01", "key": "svg-13" }]]);

var IconCircleDottedLetterH$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterH
});

var IconCircleDottedLetterI = createReactComponent("outline", "circle-dotted-letter-i", "IconCircleDottedLetterI", [["path", { "d": "M12 8v8", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterI$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterI
});

var IconCircleDottedLetterJ = createReactComponent("outline", "circle-dotted-letter-j", "IconCircleDottedLetterJ", [["path", { "d": "M10 8h4v6a2 2 0 1 1 -4 0", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterJ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterJ
});

var IconCircleDottedLetterK = createReactComponent("outline", "circle-dotted-letter-k", "IconCircleDottedLetterK", [["path", { "d": "M10 8v8", "key": "svg-0" }], ["path", { "d": "M14 8l-2.5 4l2.5 4", "key": "svg-1" }], ["path", { "d": "M10 12h1.5", "key": "svg-2" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-3" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-4" }], ["path", { "d": "M3 12v.01", "key": "svg-5" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-6" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M12 21v.01", "key": "svg-8" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-9" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-10" }], ["path", { "d": "M21 12v.01", "key": "svg-11" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-12" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-13" }], ["path", { "d": "M12 3v.01", "key": "svg-14" }]]);

var IconCircleDottedLetterK$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterK
});

var IconCircleDottedLetterL = createReactComponent("outline", "circle-dotted-letter-l", "IconCircleDottedLetterL", [["path", { "d": "M10 8v8h4", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterL$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterL
});

var IconCircleDottedLetterM = createReactComponent("outline", "circle-dotted-letter-m", "IconCircleDottedLetterM", [["path", { "d": "M9 16v-8l3 5l3 -5v8", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterM$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterM
});

var IconCircleDottedLetterN = createReactComponent("outline", "circle-dotted-letter-n", "IconCircleDottedLetterN", [["path", { "d": "M10 16v-8l4 8v-8", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterN$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterN
});

var IconCircleDottedLetterO = createReactComponent("outline", "circle-dotted-letter-o", "IconCircleDottedLetterO", [["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterO$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterO
});

var IconCircleDottedLetterP = createReactComponent("outline", "circle-dotted-letter-p", "IconCircleDottedLetterP", [["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterP$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterP
});

var IconCircleDottedLetterQ = createReactComponent("outline", "circle-dotted-letter-q", "IconCircleDottedLetterQ", [["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M13 15l1 1", "key": "svg-1" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-2" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-3" }], ["path", { "d": "M3 12v.01", "key": "svg-4" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-5" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-6" }], ["path", { "d": "M12 21v.01", "key": "svg-7" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-8" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-9" }], ["path", { "d": "M21 12v.01", "key": "svg-10" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-11" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-12" }], ["path", { "d": "M12 3v.01", "key": "svg-13" }]]);

var IconCircleDottedLetterQ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterQ
});

var IconCircleDottedLetterR = createReactComponent("outline", "circle-dotted-letter-r", "IconCircleDottedLetterR", [["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterR$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterR
});

var IconCircleDottedLetterS = createReactComponent("outline", "circle-dotted-letter-s", "IconCircleDottedLetterS", [["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterS$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterS
});

var IconCircleDottedLetterT = createReactComponent("outline", "circle-dotted-letter-t", "IconCircleDottedLetterT", [["path", { "d": "M10 8h4", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-2" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-3" }], ["path", { "d": "M3 12v.01", "key": "svg-4" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-5" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-6" }], ["path", { "d": "M12 21v.01", "key": "svg-7" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-8" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-9" }], ["path", { "d": "M21 12v.01", "key": "svg-10" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-11" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-12" }], ["path", { "d": "M12 3v.01", "key": "svg-13" }]]);

var IconCircleDottedLetterT$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterT
});

var IconCircleDottedLetterU = createReactComponent("outline", "circle-dotted-letter-u", "IconCircleDottedLetterU", [["path", { "d": "M10 8v6a2 2 0 1 0 4 0v-6", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterU$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterU
});

var IconCircleDottedLetterV = createReactComponent("outline", "circle-dotted-letter-v", "IconCircleDottedLetterV", [["path", { "d": "M10 8l2 8l2 -8", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterV$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterV
});

var IconCircleDottedLetterW = createReactComponent("outline", "circle-dotted-letter-w", "IconCircleDottedLetterW", [["path", { "d": "M9 8l1 8l2 -5l2 5l1 -8", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterW$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterW
});

var IconCircleDottedLetterX = createReactComponent("outline", "circle-dotted-letter-x", "IconCircleDottedLetterX", [["path", { "d": "M10 8l4 8", "key": "svg-0" }], ["path", { "d": "M10 16l4 -8", "key": "svg-1" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-2" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-3" }], ["path", { "d": "M3 12v.01", "key": "svg-4" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-5" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-6" }], ["path", { "d": "M12 21v.01", "key": "svg-7" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-8" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-9" }], ["path", { "d": "M21 12v.01", "key": "svg-10" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-11" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-12" }], ["path", { "d": "M12 3v.01", "key": "svg-13" }]]);

var IconCircleDottedLetterX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterX
});

var IconCircleDottedLetterY = createReactComponent("outline", "circle-dotted-letter-y", "IconCircleDottedLetterY", [["path", { "d": "M10 8l2 5l2 -5", "key": "svg-0" }], ["path", { "d": "M12 16v-3", "key": "svg-1" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-2" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-3" }], ["path", { "d": "M3 12v.01", "key": "svg-4" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-5" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-6" }], ["path", { "d": "M12 21v.01", "key": "svg-7" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-8" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-9" }], ["path", { "d": "M21 12v.01", "key": "svg-10" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-11" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-12" }], ["path", { "d": "M12 3v.01", "key": "svg-13" }]]);

var IconCircleDottedLetterY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterY
});

var IconCircleDottedLetterZ = createReactComponent("outline", "circle-dotted-letter-z", "IconCircleDottedLetterZ", [["path", { "d": "M10 8h4l-4 8h4", "key": "svg-0" }], ["path", { "d": "M7.5 4.21v.01", "key": "svg-1" }], ["path", { "d": "M4.21 7.5v.01", "key": "svg-2" }], ["path", { "d": "M3 12v.01", "key": "svg-3" }], ["path", { "d": "M4.21 16.5v.01", "key": "svg-4" }], ["path", { "d": "M7.5 19.79v.01", "key": "svg-5" }], ["path", { "d": "M12 21v.01", "key": "svg-6" }], ["path", { "d": "M16.5 19.79v.01", "key": "svg-7" }], ["path", { "d": "M19.79 16.5v.01", "key": "svg-8" }], ["path", { "d": "M21 12v.01", "key": "svg-9" }], ["path", { "d": "M19.79 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.21v.01", "key": "svg-11" }], ["path", { "d": "M12 3v.01", "key": "svg-12" }]]);

var IconCircleDottedLetterZ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDottedLetterZ
});

var IconCircleDotted = createReactComponent("outline", "circle-dotted", "IconCircleDotted", [["path", { "d": "M7.5 4.21l0 .01", "key": "svg-0" }], ["path", { "d": "M4.21 7.5l0 .01", "key": "svg-1" }], ["path", { "d": "M3 12l0 .01", "key": "svg-2" }], ["path", { "d": "M4.21 16.5l0 .01", "key": "svg-3" }], ["path", { "d": "M7.5 19.79l0 .01", "key": "svg-4" }], ["path", { "d": "M12 21l0 .01", "key": "svg-5" }], ["path", { "d": "M16.5 19.79l0 .01", "key": "svg-6" }], ["path", { "d": "M19.79 16.5l0 .01", "key": "svg-7" }], ["path", { "d": "M21 12l0 .01", "key": "svg-8" }], ["path", { "d": "M19.79 7.5l0 .01", "key": "svg-9" }], ["path", { "d": "M16.5 4.21l0 .01", "key": "svg-10" }], ["path", { "d": "M12 3l0 .01", "key": "svg-11" }]]);

var IconCircleDotted$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDotted
});

var IconCircleHalf2 = createReactComponent("outline", "circle-half-2", "IconCircleHalf2", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 3v18", "key": "svg-1" }], ["path", { "d": "M12 14l7 -7", "key": "svg-2" }], ["path", { "d": "M12 19l8.5 -8.5", "key": "svg-3" }], ["path", { "d": "M12 9l4.5 -4.5", "key": "svg-4" }]]);

var IconCircleHalf2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleHalf2
});

var IconCircleHalfVertical = createReactComponent("outline", "circle-half-vertical", "IconCircleHalfVertical", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M3 12h18", "key": "svg-1" }]]);

var IconCircleHalfVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleHalfVertical
});

var IconCircleHalf = createReactComponent("outline", "circle-half", "IconCircleHalf", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 3v18", "key": "svg-1" }]]);

var IconCircleHalf$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleHalf
});

var IconCircleKey = createReactComponent("outline", "circle-key", "IconCircleKey", [["path", { "d": "M14 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z", "key": "svg-1" }], ["path", { "d": "M12.5 11.5l-4 4l1.5 1.5", "key": "svg-2" }], ["path", { "d": "M12 15l-1.5 -1.5", "key": "svg-3" }]]);

var IconCircleKey$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleKey
});

var IconCircleLetterA = createReactComponent("outline", "circle-letter-a", "IconCircleLetterA", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 16v-6a2 2 0 1 1 4 0v6", "key": "svg-1" }], ["path", { "d": "M10 13h4", "key": "svg-2" }]]);

var IconCircleLetterA$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterA
});

var IconCircleLetterB = createReactComponent("outline", "circle-letter-b", "IconCircleLetterB", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z", "key": "svg-1" }]]);

var IconCircleLetterB$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterB
});

var IconCircleLetterC = createReactComponent("outline", "circle-letter-c", "IconCircleLetterC", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-1" }]]);

var IconCircleLetterC$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterC
});

var IconCircleLetterD = createReactComponent("outline", "circle-letter-d", "IconCircleLetterD", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", "key": "svg-1" }]]);

var IconCircleLetterD$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterD
});

var IconCircleLetterE = createReactComponent("outline", "circle-letter-e", "IconCircleLetterE", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8h4", "key": "svg-1" }], ["path", { "d": "M10 12h2.5", "key": "svg-2" }]]);

var IconCircleLetterE$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterE
});

var IconCircleLetterF = createReactComponent("outline", "circle-letter-f", "IconCircleLetterF", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 12h3", "key": "svg-1" }], ["path", { "d": "M14 8h-4v8", "key": "svg-2" }]]);

var IconCircleLetterF$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterF
});

var IconCircleLetterG = createReactComponent("outline", "circle-letter-g", "IconCircleLetterG", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-1" }]]);

var IconCircleLetterG$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterG
});

var IconCircleLetterH = createReactComponent("outline", "circle-letter-h", "IconCircleLetterH", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 16v-8m4 0v8", "key": "svg-1" }], ["path", { "d": "M10 12h4", "key": "svg-2" }]]);

var IconCircleLetterH$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterH
});

var IconCircleLetterI = createReactComponent("outline", "circle-letter-i", "IconCircleLetterI", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }]]);

var IconCircleLetterI$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterI
});

var IconCircleLetterJ = createReactComponent("outline", "circle-letter-j", "IconCircleLetterJ", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8h4v6a2 2 0 1 1 -4 0", "key": "svg-1" }]]);

var IconCircleLetterJ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterJ
});

var IconCircleLetterK = createReactComponent("outline", "circle-letter-k", "IconCircleLetterK", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8v8", "key": "svg-1" }], ["path", { "d": "M14 8l-2.5 4l2.5 4", "key": "svg-2" }], ["path", { "d": "M10 12h1.5", "key": "svg-3" }]]);

var IconCircleLetterK$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterK
});

var IconCircleLetterL = createReactComponent("outline", "circle-letter-l", "IconCircleLetterL", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8v8h4", "key": "svg-1" }]]);

var IconCircleLetterL$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterL
});

var IconCircleLetterM = createReactComponent("outline", "circle-letter-m", "IconCircleLetterM", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 16v-8l3 5l3 -5v8", "key": "svg-1" }]]);

var IconCircleLetterM$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterM
});

var IconCircleLetterN = createReactComponent("outline", "circle-letter-n", "IconCircleLetterN", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 16v-8l4 8v-8", "key": "svg-1" }]]);

var IconCircleLetterN$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterN
});

var IconCircleLetterO = createReactComponent("outline", "circle-letter-o", "IconCircleLetterO", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-1" }]]);

var IconCircleLetterO$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterO
});

var IconCircleLetterP = createReactComponent("outline", "circle-letter-p", "IconCircleLetterP", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-1" }]]);

var IconCircleLetterP$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterP
});

var IconCircleLetterQ = createReactComponent("outline", "circle-letter-q", "IconCircleLetterQ", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-1" }], ["path", { "d": "M13 15l1 1", "key": "svg-2" }]]);

var IconCircleLetterQ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterQ
});

var IconCircleLetterR = createReactComponent("outline", "circle-letter-r", "IconCircleLetterR", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4", "key": "svg-1" }]]);

var IconCircleLetterR$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterR
});

var IconCircleLetterS = createReactComponent("outline", "circle-letter-s", "IconCircleLetterS", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1", "key": "svg-1" }]]);

var IconCircleLetterS$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterS
});

var IconCircleLetterT = createReactComponent("outline", "circle-letter-t", "IconCircleLetterT", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8h4", "key": "svg-1" }], ["path", { "d": "M12 8v8", "key": "svg-2" }]]);

var IconCircleLetterT$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterT
});

var IconCircleLetterU = createReactComponent("outline", "circle-letter-u", "IconCircleLetterU", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8v6a2 2 0 1 0 4 0v-6", "key": "svg-1" }]]);

var IconCircleLetterU$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterU
});

var IconCircleLetterV = createReactComponent("outline", "circle-letter-v", "IconCircleLetterV", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8l2 8l2 -8", "key": "svg-1" }]]);

var IconCircleLetterV$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterV
});

var IconCircleLetterW = createReactComponent("outline", "circle-letter-w", "IconCircleLetterW", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 8l1 8l2 -5l2 5l1 -8", "key": "svg-1" }]]);

var IconCircleLetterW$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterW
});

var IconCircleLetterX = createReactComponent("outline", "circle-letter-x", "IconCircleLetterX", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8l4 8", "key": "svg-1" }], ["path", { "d": "M10 16l4 -8", "key": "svg-2" }]]);

var IconCircleLetterX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterX
});

var IconCircleLetterY = createReactComponent("outline", "circle-letter-y", "IconCircleLetterY", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8l2 5l2 -5", "key": "svg-1" }], ["path", { "d": "M12 16v-3", "key": "svg-2" }]]);

var IconCircleLetterY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterY
});

var IconCircleLetterZ = createReactComponent("outline", "circle-letter-z", "IconCircleLetterZ", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8h4l-4 8h4", "key": "svg-1" }]]);

var IconCircleLetterZ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterZ
});

var IconCircleMinus2 = createReactComponent("outline", "circle-minus-2", "IconCircleMinus2", [["path", { "d": "M20.475 15.029a9 9 0 1 0 -7.962 5.957", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconCircleMinus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleMinus2
});

var IconCircleMinus = createReactComponent("outline", "circle-minus", "IconCircleMinus", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 12l6 0", "key": "svg-1" }]]);

var IconCircleMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleMinus
});

var IconCircleNumber0 = createReactComponent("outline", "circle-number-0", "IconCircleNumber0", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", "key": "svg-1" }]]);

var IconCircleNumber0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber0
});

var IconCircleNumber1 = createReactComponent("outline", "circle-number-1", "IconCircleNumber1", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 10l2 -2v8", "key": "svg-1" }]]);

var IconCircleNumber1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber1
});

var IconCircleNumber2 = createReactComponent("outline", "circle-number-2", "IconCircleNumber2", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconCircleNumber2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber2
});

var IconCircleNumber3 = createReactComponent("outline", "circle-number-3", "IconCircleNumber3", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1", "key": "svg-1" }]]);

var IconCircleNumber3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber3
});

var IconCircleNumber4 = createReactComponent("outline", "circle-number-4", "IconCircleNumber4", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M14 8v8", "key": "svg-2" }]]);

var IconCircleNumber4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber4
});

var IconCircleNumber5 = createReactComponent("outline", "circle-number-5", "IconCircleNumber5", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconCircleNumber5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber5
});

var IconCircleNumber6 = createReactComponent("outline", "circle-number-6", "IconCircleNumber6", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconCircleNumber6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber6
});

var IconCircleNumber7 = createReactComponent("outline", "circle-number-7", "IconCircleNumber7", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8h4l-2 8", "key": "svg-1" }]]);

var IconCircleNumber7$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber7
});

var IconCircleNumber8 = createReactComponent("outline", "circle-number-8", "IconCircleNumber8", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconCircleNumber8$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber8
});

var IconCircleNumber9 = createReactComponent("outline", "circle-number-9", "IconCircleNumber9", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconCircleNumber9$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber9
});

var IconCircleOff = createReactComponent("outline", "circle-off", "IconCircleOff", [["path", { "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconCircleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleOff
});

var IconCirclePercentage = createReactComponent("outline", "circle-percentage", "IconCirclePercentage", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 15.075l6 -6", "key": "svg-1" }], ["path", { "d": "M9 9.105v.015", "key": "svg-2" }], ["path", { "d": "M15 15.12v.015", "key": "svg-3" }]]);

var IconCirclePercentage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCirclePercentage
});

var IconCirclePlus2 = createReactComponent("outline", "circle-plus-2", "IconCirclePlus2", [["path", { "d": "M20.985 12.522a9 9 0 1 0 -8.475 8.464", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconCirclePlus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCirclePlus2
});

var IconCirclePlus = createReactComponent("outline", "circle-plus", "IconCirclePlus", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 12h6", "key": "svg-1" }], ["path", { "d": "M12 9v6", "key": "svg-2" }]]);

var IconCirclePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCirclePlus
});

var IconCircleRectangleOff = createReactComponent("outline", "circle-rectangle-off", "IconCircleRectangleOff", [["path", { "d": "M14 10h3v3m-3 1h-7v-4h3", "key": "svg-0" }], ["path", { "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconCircleRectangleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleRectangleOff
});

var IconCircleRectangle = createReactComponent("outline", "circle-rectangle", "IconCircleRectangle", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M7 10h10v4h-10z", "key": "svg-1" }]]);

var IconCircleRectangle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleRectangle
});

var IconCircleSquare = createReactComponent("outline", "circle-square", "IconCircleSquare", [["path", { "d": "M9.5 9.5m-6.5 0a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0 -13 0", "key": "svg-0" }], ["path", { "d": "M10 10m0 2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconCircleSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleSquare
});

var IconCircleTriangle = createReactComponent("outline", "circle-triangle", "IconCircleTriangle", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 20l7 -12h-14z", "key": "svg-1" }]]);

var IconCircleTriangle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleTriangle
});

var IconCircleX = createReactComponent("outline", "circle-x", "IconCircleX", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 10l4 4m0 -4l-4 4", "key": "svg-1" }]]);

var IconCircleX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleX
});

var IconCircle = createReactComponent("outline", "circle", "IconCircle", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }]]);

var IconCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircle
});

var IconCirclesRelation = createReactComponent("outline", "circles-relation", "IconCirclesRelation", [["path", { "d": "M9.183 6.117a6 6 0 1 0 4.511 3.986", "key": "svg-0" }], ["path", { "d": "M14.813 17.883a6 6 0 1 0 -4.496 -3.954", "key": "svg-1" }]]);

var IconCirclesRelation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCirclesRelation
});

var IconCircles = createReactComponent("outline", "circles", "IconCircles", [["path", { "d": "M12 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6.5 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-1" }], ["path", { "d": "M17.5 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-2" }]]);

var IconCircles$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircles
});

var IconCircuitAmmeter = createReactComponent("outline", "circuit-ammeter", "IconCircuitAmmeter", [["path", { "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M5 12h-3", "key": "svg-1" }], ["path", { "d": "M19 12h3", "key": "svg-2" }], ["path", { "d": "M10 14v-3c0 -1.036 .895 -2 2 -2s2 .964 2 2v3", "key": "svg-3" }], ["path", { "d": "M14 12h-4", "key": "svg-4" }]]);

var IconCircuitAmmeter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitAmmeter
});

var IconCircuitBattery = createReactComponent("outline", "circuit-battery", "IconCircuitBattery", [["path", { "d": "M2 12h4", "key": "svg-0" }], ["path", { "d": "M18 12h4", "key": "svg-1" }], ["path", { "d": "M18 5v14", "key": "svg-2" }], ["path", { "d": "M14 9v6", "key": "svg-3" }], ["path", { "d": "M10 5v14", "key": "svg-4" }], ["path", { "d": "M6 9v6", "key": "svg-5" }]]);

var IconCircuitBattery$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitBattery
});

var IconCircuitBulb = createReactComponent("outline", "circuit-bulb", "IconCircuitBulb", [["path", { "d": "M2 12h5", "key": "svg-0" }], ["path", { "d": "M17 12h5", "key": "svg-1" }], ["path", { "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-2" }], ["path", { "d": "M8.5 8.5l7 7", "key": "svg-3" }], ["path", { "d": "M15.5 8.5l-7 7", "key": "svg-4" }]]);

var IconCircuitBulb$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitBulb
});

var IconCircuitCapacitorPolarized = createReactComponent("outline", "circuit-capacitor-polarized", "IconCircuitCapacitorPolarized", [["path", { "d": "M22 12h-8", "key": "svg-0" }], ["path", { "d": "M2 12h8", "key": "svg-1" }], ["path", { "d": "M10 7v10", "key": "svg-2" }], ["path", { "d": "M14 7v10", "key": "svg-3" }], ["path", { "d": "M17 5h4", "key": "svg-4" }], ["path", { "d": "M19 3v4", "key": "svg-5" }]]);

var IconCircuitCapacitorPolarized$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitCapacitorPolarized
});

var IconCircuitCapacitor = createReactComponent("outline", "circuit-capacitor", "IconCircuitCapacitor", [["path", { "d": "M22 12h-8", "key": "svg-0" }], ["path", { "d": "M2 12h8", "key": "svg-1" }], ["path", { "d": "M10 7v10", "key": "svg-2" }], ["path", { "d": "M14 7v10", "key": "svg-3" }]]);

var IconCircuitCapacitor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitCapacitor
});

var IconCircuitCellPlus = createReactComponent("outline", "circuit-cell-plus", "IconCircuitCellPlus", [["path", { "d": "M2 12h9", "key": "svg-0" }], ["path", { "d": "M15 12h7", "key": "svg-1" }], ["path", { "d": "M11 5v14", "key": "svg-2" }], ["path", { "d": "M15 9v6", "key": "svg-3" }], ["path", { "d": "M3 5h4", "key": "svg-4" }], ["path", { "d": "M5 3v4", "key": "svg-5" }]]);

var IconCircuitCellPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitCellPlus
});

var IconCircuitCell = createReactComponent("outline", "circuit-cell", "IconCircuitCell", [["path", { "d": "M2 12h8", "key": "svg-0" }], ["path", { "d": "M14 12h8", "key": "svg-1" }], ["path", { "d": "M10 5v14", "key": "svg-2" }], ["path", { "d": "M14 9v6", "key": "svg-3" }]]);

var IconCircuitCell$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitCell
});

var IconCircuitChangeover = createReactComponent("outline", "circuit-changeover", "IconCircuitChangeover", [["path", { "d": "M2 12h2", "key": "svg-0" }], ["path", { "d": "M20 7h2", "key": "svg-1" }], ["path", { "d": "M6 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M18 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M20 17h2", "key": "svg-4" }], ["path", { "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-5" }], ["path", { "d": "M7.5 10.5l8.5 -3.5", "key": "svg-6" }]]);

var IconCircuitChangeover$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitChangeover
});

var IconCircuitDiodeZener = createReactComponent("outline", "circuit-diode-zener", "IconCircuitDiodeZener", [["path", { "d": "M22 12h-6", "key": "svg-0" }], ["path", { "d": "M2 12h6", "key": "svg-1" }], ["path", { "d": "M8 7l8 5l-8 5z", "key": "svg-2" }], ["path", { "d": "M14 7h2v10h2", "key": "svg-3" }]]);

var IconCircuitDiodeZener$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitDiodeZener
});

var IconCircuitDiode = createReactComponent("outline", "circuit-diode", "IconCircuitDiode", [["path", { "d": "M22 12h-6", "key": "svg-0" }], ["path", { "d": "M2 12h6", "key": "svg-1" }], ["path", { "d": "M8 7l8 5l-8 5z", "key": "svg-2" }], ["path", { "d": "M16 7v10", "key": "svg-3" }]]);

var IconCircuitDiode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitDiode
});

var IconCircuitGroundDigital = createReactComponent("outline", "circuit-ground-digital", "IconCircuitGroundDigital", [["path", { "d": "M12 13v-10", "key": "svg-0" }], ["path", { "d": "M12 21l-6 -8h12z", "key": "svg-1" }]]);

var IconCircuitGroundDigital$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitGroundDigital
});

var IconCircuitGround = createReactComponent("outline", "circuit-ground", "IconCircuitGround", [["path", { "d": "M12 13v-8", "key": "svg-0" }], ["path", { "d": "M4 13h16", "key": "svg-1" }], ["path", { "d": "M7 16h10", "key": "svg-2" }], ["path", { "d": "M10 19h4", "key": "svg-3" }]]);

var IconCircuitGround$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitGround
});

var IconCircuitInductor = createReactComponent("outline", "circuit-inductor", "IconCircuitInductor", [["path", { "d": "M2 14h3v-2a2 2 0 1 1 4 0v2v-1.5a2.5 2.5 0 1 1 5 0v1.5v-1.5a2.5 2.5 0 1 1 5 0v1.5h3", "key": "svg-0" }]]);

var IconCircuitInductor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitInductor
});

var IconCircuitMotor = createReactComponent("outline", "circuit-motor", "IconCircuitMotor", [["path", { "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M5 12h-3", "key": "svg-1" }], ["path", { "d": "M19 12h3", "key": "svg-2" }], ["path", { "d": "M10 14v-4l2 2l2 -2v4", "key": "svg-3" }]]);

var IconCircuitMotor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitMotor
});

var IconCircuitPushbutton = createReactComponent("outline", "circuit-pushbutton", "IconCircuitPushbutton", [["path", { "d": "M2 17h2", "key": "svg-0" }], ["path", { "d": "M20 17h2", "key": "svg-1" }], ["path", { "d": "M6 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M6 11h12", "key": "svg-4" }], ["path", { "d": "M12 11v-6", "key": "svg-5" }]]);

var IconCircuitPushbutton$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitPushbutton
});

var IconCircuitResistor = createReactComponent("outline", "circuit-resistor", "IconCircuitResistor", [["path", { "d": "M2 12h2l2 -5l3 10l3 -10l3 10l3 -10l1.5 5h2.5", "key": "svg-0" }]]);

var IconCircuitResistor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitResistor
});

var IconCircuitSwitchClosed = createReactComponent("outline", "circuit-switch-closed", "IconCircuitSwitchClosed", [["path", { "d": "M2 12h2", "key": "svg-0" }], ["path", { "d": "M20 12h2", "key": "svg-1" }], ["path", { "d": "M6 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M18 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M8 12h8", "key": "svg-4" }]]);

var IconCircuitSwitchClosed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitSwitchClosed
});

var IconCircuitSwitchOpen = createReactComponent("outline", "circuit-switch-open", "IconCircuitSwitchOpen", [["path", { "d": "M2 12h2", "key": "svg-0" }], ["path", { "d": "M20 12h2", "key": "svg-1" }], ["path", { "d": "M6 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M18 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M7.5 10.5l7.5 -5.5", "key": "svg-4" }]]);

var IconCircuitSwitchOpen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitSwitchOpen
});

var IconCircuitVoltmeter = createReactComponent("outline", "circuit-voltmeter", "IconCircuitVoltmeter", [["path", { "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M5 12h-3", "key": "svg-1" }], ["path", { "d": "M19 12h3", "key": "svg-2" }], ["path", { "d": "M10 10l2 4l2 -4", "key": "svg-3" }]]);

var IconCircuitVoltmeter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircuitVoltmeter
});

var IconClearAll = createReactComponent("outline", "clear-all", "IconClearAll", [["path", { "d": "M8 6h12", "key": "svg-0" }], ["path", { "d": "M6 12h12", "key": "svg-1" }], ["path", { "d": "M4 18h12", "key": "svg-2" }]]);

var IconClearAll$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClearAll
});

var IconClearFormatting = createReactComponent("outline", "clear-formatting", "IconClearFormatting", [["path", { "d": "M17 15l4 4m0 -4l-4 4", "key": "svg-0" }], ["path", { "d": "M7 6v-1h11v1", "key": "svg-1" }], ["path", { "d": "M7 19l4 0", "key": "svg-2" }], ["path", { "d": "M13 5l-4 14", "key": "svg-3" }]]);

var IconClearFormatting$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClearFormatting
});

var IconClick = createReactComponent("outline", "click", "IconClick", [["path", { "d": "M3 12l3 0", "key": "svg-0" }], ["path", { "d": "M12 3l0 3", "key": "svg-1" }], ["path", { "d": "M7.8 7.8l-2.2 -2.2", "key": "svg-2" }], ["path", { "d": "M16.2 7.8l2.2 -2.2", "key": "svg-3" }], ["path", { "d": "M7.8 16.2l-2.2 2.2", "key": "svg-4" }], ["path", { "d": "M12 12l9 3l-4 2l-2 4l-3 -9", "key": "svg-5" }]]);

var IconClick$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClick
});

var IconCliffJumping = createReactComponent("outline", "cliff-jumping", "IconCliffJumping", [["path", { "d": "M14 7a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M10.5 18l2.5 2l2 -2", "key": "svg-1" }], ["path", { "d": "M18 21l3 -3l-4 -2l-1 -5", "key": "svg-2" }], ["path", { "d": "M10.5 7.5l2 3l3.5 .5l3 -2l.5 -3", "key": "svg-3" }], ["path", { "d": "M4 21v-1l2 -3l.5 -2.5l1.5 -2.5l-1 -5l1 -3l-1 -1l-2 .5l-2 -.5", "key": "svg-4" }]]);

var IconCliffJumping$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCliffJumping
});

var IconClipboardCheck = createReactComponent("outline", "clipboard-check", "IconClipboardCheck", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M9 14l2 2l4 -4", "key": "svg-2" }]]);

var IconClipboardCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardCheck
});

var IconClipboardCopy = createReactComponent("outline", "clipboard-copy", "IconClipboardCopy", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h3m9 -9v-5a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M13 17v-1a1 1 0 0 1 1 -1h1m3 0h1a1 1 0 0 1 1 1v1m0 3v1a1 1 0 0 1 -1 1h-1m-3 0h-1a1 1 0 0 1 -1 -1v-1", "key": "svg-1" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconClipboardCopy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardCopy
});

var IconClipboardData = createReactComponent("outline", "clipboard-data", "IconClipboardData", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M9 17v-4", "key": "svg-2" }], ["path", { "d": "M12 17v-1", "key": "svg-3" }], ["path", { "d": "M15 17v-2", "key": "svg-4" }], ["path", { "d": "M12 17v-1", "key": "svg-5" }]]);

var IconClipboardData$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardData
});

var IconClipboardHeart = createReactComponent("outline", "clipboard-heart", "IconClipboardHeart", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M11.993 16.75l2.747 -2.815a1.9 1.9 0 0 0 0 -2.632a1.775 1.775 0 0 0 -2.56 0l-.183 .188l-.183 -.189a1.775 1.775 0 0 0 -2.56 0a1.899 1.899 0 0 0 0 2.632l2.738 2.825z", "key": "svg-2" }]]);

var IconClipboardHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardHeart
});

var IconClipboardList = createReactComponent("outline", "clipboard-list", "IconClipboardList", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M9 12l.01 0", "key": "svg-2" }], ["path", { "d": "M13 12l2 0", "key": "svg-3" }], ["path", { "d": "M9 16l.01 0", "key": "svg-4" }], ["path", { "d": "M13 16l2 0", "key": "svg-5" }]]);

var IconClipboardList$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardList
});

var IconClipboardOff = createReactComponent("outline", "clipboard-off", "IconClipboardOff", [["path", { "d": "M5.575 5.597a2 2 0 0 0 -.575 1.403v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2m0 -4v-8a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 1 1 0 4h-2", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconClipboardOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardOff
});

var IconClipboardPlus = createReactComponent("outline", "clipboard-plus", "IconClipboardPlus", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M10 14h4", "key": "svg-2" }], ["path", { "d": "M12 12v4", "key": "svg-3" }]]);

var IconClipboardPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardPlus
});

var IconClipboardSearch = createReactComponent("outline", "clipboard-search", "IconClipboardSearch", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h4.5m7.5 -10v-4a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconClipboardSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardSearch
});

var IconClipboardSmile = createReactComponent("outline", "clipboard-smile", "IconClipboardSmile", [["path", { "d": "M10 13h.01", "key": "svg-0" }], ["path", { "d": "M14 13h.01", "key": "svg-1" }], ["path", { "d": "M10 16a3.5 3.5 0 0 0 4 0", "key": "svg-2" }], ["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-3" }], ["path", { "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-4" }]]);

var IconClipboardSmile$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardSmile
});

var IconClipboardText = createReactComponent("outline", "clipboard-text", "IconClipboardText", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M9 12h6", "key": "svg-2" }], ["path", { "d": "M9 16h6", "key": "svg-3" }]]);

var IconClipboardText$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardText
});

var IconClipboardTypography = createReactComponent("outline", "clipboard-typography", "IconClipboardTypography", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M9 12v-1h6v1", "key": "svg-2" }], ["path", { "d": "M12 11v6", "key": "svg-3" }], ["path", { "d": "M11 17h2", "key": "svg-4" }]]);

var IconClipboardTypography$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardTypography
});

var IconClipboardX = createReactComponent("outline", "clipboard-x", "IconClipboardX", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M10 12l4 4m0 -4l-4 4", "key": "svg-2" }]]);

var IconClipboardX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardX
});

var IconClipboard = createReactComponent("outline", "clipboard", "IconClipboard", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconClipboard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboard
});

var IconClock12 = createReactComponent("outline", "clock-12", "IconClock12", [["path", { "d": "M3 12a9 9 0 0 0 9 9m9 -9a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 7v5l.5 .5", "key": "svg-1" }], ["path", { "d": "M18 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2", "key": "svg-2" }], ["path", { "d": "M15 21v-6", "key": "svg-3" }]]);

var IconClock12$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClock12
});

var IconClock2 = createReactComponent("outline", "clock-2", "IconClock2", [["path", { "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M12 7v5l3 3", "key": "svg-1" }], ["path", { "d": "M4 12h1", "key": "svg-2" }], ["path", { "d": "M19 12h1", "key": "svg-3" }], ["path", { "d": "M12 19v1", "key": "svg-4" }]]);

var IconClock2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClock2
});

var IconClock24 = createReactComponent("outline", "clock-24", "IconClock24", [["path", { "d": "M3 12a9 9 0 0 0 5.998 8.485m12.002 -8.485a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 7v5", "key": "svg-1" }], ["path", { "d": "M12 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2", "key": "svg-2" }], ["path", { "d": "M18 15v2a1 1 0 0 0 1 1h1", "key": "svg-3" }], ["path", { "d": "M21 15v6", "key": "svg-4" }]]);

var IconClock24$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClock24
});

var IconClockBitcoin = createReactComponent("outline", "clock-bitcoin", "IconClockBitcoin", [["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-0" }], ["path", { "d": "M20.866 10.45a9 9 0 1 0 -7.815 10.488", "key": "svg-1" }], ["path", { "d": "M12 7v5l1.5 1.5", "key": "svg-2" }]]);

var IconClockBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockBitcoin
});

var IconClockBolt = createReactComponent("outline", "clock-bolt", "IconClockBolt", [["path", { "d": "M20.984 12.53a9 9 0 1 0 -7.552 8.355", "key": "svg-0" }], ["path", { "d": "M12 7v5l3 3", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }]]);

var IconClockBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockBolt
});

var IconClockCancel = createReactComponent("outline", "clock-cancel", "IconClockCancel", [["path", { "d": "M20.997 12.25a9 9 0 1 0 -8.718 8.745", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-3" }]]);

var IconClockCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockCancel
});

var IconClockCheck = createReactComponent("outline", "clock-check", "IconClockCheck", [["path", { "d": "M20.942 13.021a9 9 0 1 0 -9.407 7.967", "key": "svg-0" }], ["path", { "d": "M12 7v5l3 3", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconClockCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockCheck
});

var IconClockCode = createReactComponent("outline", "clock-code", "IconClockCode", [["path", { "d": "M20.931 13.111a9 9 0 1 0 -9.453 7.874", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-3" }]]);

var IconClockCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockCode
});

var IconClockCog = createReactComponent("outline", "clock-cog", "IconClockCog", [["path", { "d": "M21 12a9 9 0 1 0 -9.002 9", "key": "svg-0" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-2" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-3" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-7" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-8" }]]);

var IconClockCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockCog
});

var IconClockDollar = createReactComponent("outline", "clock-dollar", "IconClockDollar", [["path", { "d": "M20.866 10.45a9 9 0 1 0 -7.815 10.488", "key": "svg-0" }], ["path", { "d": "M12 7v5l1.5 1.5", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconClockDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockDollar
});

var IconClockDown = createReactComponent("outline", "clock-down", "IconClockDown", [["path", { "d": "M20.984 12.535a9 9 0 1 0 -8.431 8.448", "key": "svg-0" }], ["path", { "d": "M12 7v5l3 3", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-3" }]]);

var IconClockDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockDown
});

var IconClockEdit = createReactComponent("outline", "clock-edit", "IconClockEdit", [["path", { "d": "M21 12a9 9 0 1 0 -9.972 8.948c.32 .034 .644 .052 .972 .052", "key": "svg-0" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-1" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z", "key": "svg-2" }]]);

var IconClockEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockEdit
});

var IconClockExclamation = createReactComponent("outline", "clock-exclamation", "IconClockExclamation", [["path", { "d": "M20.986 12.502a9 9 0 1 0 -5.973 7.98", "key": "svg-0" }], ["path", { "d": "M12 7v5l3 3", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconClockExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockExclamation
});

var IconClockHeart = createReactComponent("outline", "clock-heart", "IconClockHeart", [["path", { "d": "M20.956 11.107a9 9 0 1 0 -9.579 9.871", "key": "svg-0" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-1" }], ["path", { "d": "M12 7v5l.5 .5", "key": "svg-2" }]]);

var IconClockHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHeart
});

var IconClockHour1 = createReactComponent("outline", "clock-hour-1", "IconClockHour1", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 7v5", "key": "svg-1" }], ["path", { "d": "M12 12l2 -3", "key": "svg-2" }]]);

var IconClockHour1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour1
});

var IconClockHour10 = createReactComponent("outline", "clock-hour-10", "IconClockHour10", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12l-3 -2", "key": "svg-1" }], ["path", { "d": "M12 7v5", "key": "svg-2" }]]);

var IconClockHour10$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour10
});

var IconClockHour11 = createReactComponent("outline", "clock-hour-11", "IconClockHour11", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12l-2 -3", "key": "svg-1" }], ["path", { "d": "M12 7v5", "key": "svg-2" }]]);

var IconClockHour11$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour11
});

var IconClockHour12 = createReactComponent("outline", "clock-hour-12", "IconClockHour12", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 7v5", "key": "svg-1" }]]);

var IconClockHour12$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour12
});

var IconClockHour2 = createReactComponent("outline", "clock-hour-2", "IconClockHour2", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12l3 -2", "key": "svg-1" }], ["path", { "d": "M12 7v5", "key": "svg-2" }]]);

var IconClockHour2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour2
});

var IconClockHour3 = createReactComponent("outline", "clock-hour-3", "IconClockHour3", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12h3.5", "key": "svg-1" }], ["path", { "d": "M12 7v5", "key": "svg-2" }]]);

var IconClockHour3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour3
});

var IconClockHour4 = createReactComponent("outline", "clock-hour-4", "IconClockHour4", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12l3 2", "key": "svg-1" }], ["path", { "d": "M12 7v5", "key": "svg-2" }]]);

var IconClockHour4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour4
});

var IconClockHour5 = createReactComponent("outline", "clock-hour-5", "IconClockHour5", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12l2 3", "key": "svg-1" }], ["path", { "d": "M12 7v5", "key": "svg-2" }]]);

var IconClockHour5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour5
});

var IconClockHour6 = createReactComponent("outline", "clock-hour-6", "IconClockHour6", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12v3.5", "key": "svg-1" }], ["path", { "d": "M12 7v5", "key": "svg-2" }]]);

var IconClockHour6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour6
});

var IconClockHour7 = createReactComponent("outline", "clock-hour-7", "IconClockHour7", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12l-2 3", "key": "svg-1" }], ["path", { "d": "M12 7v5", "key": "svg-2" }]]);

var IconClockHour7$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour7
});

var IconClockHour8 = createReactComponent("outline", "clock-hour-8", "IconClockHour8", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12l-3 2", "key": "svg-1" }], ["path", { "d": "M12 7v5", "key": "svg-2" }]]);

var IconClockHour8$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour8
});

var IconClockHour9 = createReactComponent("outline", "clock-hour-9", "IconClockHour9", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12h-3.5", "key": "svg-1" }], ["path", { "d": "M12 7v5", "key": "svg-2" }]]);

var IconClockHour9$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour9
});

var IconClockMinus = createReactComponent("outline", "clock-minus", "IconClockMinus", [["path", { "d": "M20.477 15.022a9 9 0 1 0 -7.998 5.965", "key": "svg-0" }], ["path", { "d": "M12 7v5l3 3", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconClockMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockMinus
});

var IconClockOff = createReactComponent("outline", "clock-off", "IconClockOff", [["path", { "d": "M5.633 5.64a9 9 0 1 0 12.735 12.72m1.674 -2.32a9 9 0 0 0 -12.082 -12.082", "key": "svg-0" }], ["path", { "d": "M12 7v1", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconClockOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockOff
});

var IconClockPause = createReactComponent("outline", "clock-pause", "IconClockPause", [["path", { "d": "M20.942 13.018a9 9 0 1 0 -7.909 7.922", "key": "svg-0" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

var IconClockPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockPause
});

var IconClockPin = createReactComponent("outline", "clock-pin", "IconClockPin", [["path", { "d": "M20.971 11.278a9 9 0 1 0 -8.313 9.698", "key": "svg-0" }], ["path", { "d": "M12 7v5l1.5 1.5", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }]]);

var IconClockPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockPin
});

var IconClockPlay = createReactComponent("outline", "clock-play", "IconClockPlay", [["path", { "d": "M12 7v5l2 2", "key": "svg-0" }], ["path", { "d": "M17 22l5 -3l-5 -3z", "key": "svg-1" }], ["path", { "d": "M13.017 20.943a9 9 0 1 1 7.831 -7.292", "key": "svg-2" }]]);

var IconClockPlay$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockPlay
});

var IconClockPlus = createReactComponent("outline", "clock-plus", "IconClockPlus", [["path", { "d": "M20.984 12.535a9 9 0 1 0 -8.468 8.45", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M12 7v5l3 3", "key": "svg-3" }]]);

var IconClockPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockPlus
});

var IconClockQuestion = createReactComponent("outline", "clock-question", "IconClockQuestion", [["path", { "d": "M20.975 11.33a9 9 0 1 0 -5.717 9.06", "key": "svg-0" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }]]);

var IconClockQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockQuestion
});

var IconClockRecord = createReactComponent("outline", "clock-record", "IconClockRecord", [["path", { "d": "M21 12.3a9 9 0 1 0 -8.683 8.694", "key": "svg-0" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-1" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }]]);

var IconClockRecord$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockRecord
});

var IconClockSearch = createReactComponent("outline", "clock-search", "IconClockSearch", [["path", { "d": "M20.993 11.646a9 9 0 1 0 -9.318 9.348", "key": "svg-0" }], ["path", { "d": "M12 7v5l1 1", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconClockSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockSearch
});

var IconClockShare = createReactComponent("outline", "clock-share", "IconClockShare", [["path", { "d": "M20.943 13.016a9 9 0 1 0 -8.915 7.984", "key": "svg-0" }], ["path", { "d": "M16 22l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-2" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-3" }]]);

var IconClockShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockShare
});

var IconClockShield = createReactComponent("outline", "clock-shield", "IconClockShield", [["path", { "d": "M21 12a9 9 0 1 0 -8.98 9", "key": "svg-0" }], ["path", { "d": "M12 7v5l1 1", "key": "svg-1" }], ["path", { "d": "M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5z", "key": "svg-2" }]]);

var IconClockShield$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockShield
});

var IconClockStar = createReactComponent("outline", "clock-star", "IconClockStar", [["path", { "d": "M20.982 11.436a9 9 0 1 0 -9.966 9.51", "key": "svg-0" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }], ["path", { "d": "M12 7v5l1 1", "key": "svg-2" }]]);

var IconClockStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockStar
});

var IconClockStop = createReactComponent("outline", "clock-stop", "IconClockStop", [["path", { "d": "M21 12a9 9 0 1 0 -9 9", "key": "svg-0" }], ["path", { "d": "M12 7v5l1 1", "key": "svg-1" }], ["path", { "d": "M16 16h6v6h-6z", "key": "svg-2" }]]);

var IconClockStop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockStop
});

var IconClockUp = createReactComponent("outline", "clock-up", "IconClockUp", [["path", { "d": "M20.983 12.548a9 9 0 1 0 -8.45 8.436", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }], ["path", { "d": "M12 7v5l2.5 2.5", "key": "svg-3" }]]);

var IconClockUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockUp
});

var IconClockX = createReactComponent("outline", "clock-x", "IconClockX", [["path", { "d": "M20.926 13.15a9 9 0 1 0 -7.835 7.784", "key": "svg-0" }], ["path", { "d": "M12 7v5l2 2", "key": "svg-1" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-2" }], ["path", { "d": "M17 22l5 -5", "key": "svg-3" }]]);

var IconClockX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockX
});

var IconClock = createReactComponent("outline", "clock", "IconClock", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 7v5l3 3", "key": "svg-1" }]]);

var IconClock$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClock
});

var IconClothesRackOff = createReactComponent("outline", "clothes-rack-off", "IconClothesRackOff", [["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 7v1m0 4v9", "key": "svg-1" }], ["path", { "d": "M9 21h6", "key": "svg-2" }], ["path", { "d": "M7.757 9.243a6 6 0 0 0 3.129 1.653m3.578 -.424a6 6 0 0 0 1.779 -1.229", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconClothesRackOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClothesRackOff
});

var IconClothesRack = createReactComponent("outline", "clothes-rack", "IconClothesRack", [["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 7v14", "key": "svg-1" }], ["path", { "d": "M9 21h6", "key": "svg-2" }], ["path", { "d": "M7.757 9.243a6 6 0 0 0 8.486 0", "key": "svg-3" }]]);

var IconClothesRack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClothesRack
});

var IconCloudBitcoin = createReactComponent("outline", "cloud-bitcoin", "IconCloudBitcoin", [["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-0" }], ["path", { "d": "M13.5 18.004h-6.843c-2.572 -.004 -4.657 -2.011 -4.657 -4.487s2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.28 1.023 1.957 2.51 1.873 4.027", "key": "svg-1" }]]);

var IconCloudBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudBitcoin
});

var IconCloudBolt = createReactComponent("outline", "cloud-bolt", "IconCloudBolt", [["path", { "d": "M13 18.004h-6.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.396 0 2.6 .831 3.148 2.03", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }]]);

var IconCloudBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudBolt
});

var IconCloudCancel = createReactComponent("outline", "cloud-cancel", "IconCloudCancel", [["path", { "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99a3.45 3.45 0 0 1 2.756 1.373", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }]]);

var IconCloudCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudCancel
});

var IconCloudCheck = createReactComponent("outline", "cloud-check", "IconCloudCheck", [["path", { "d": "M11 18.004h-4.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.388 0 2.585 .82 3.138 2.007", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }]]);

var IconCloudCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudCheck
});

var IconCloudCode = createReactComponent("outline", "cloud-code", "IconCloudCode", [["path", { "d": "M11 18.004h-4.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99a3.468 3.468 0 0 1 3.307 2.444", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }]]);

var IconCloudCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudCode
});

var IconCloudCog = createReactComponent("outline", "cloud-cog", "IconCloudCog", [["path", { "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c.956 0 1.822 .39 2.449 1.02", "key": "svg-0" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-2" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-3" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-7" }]]);

var IconCloudCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudCog
});

var IconCloudComputing = createReactComponent("outline", "cloud-computing", "IconCloudComputing", [["path", { "d": "M6.657 16c-2.572 0 -4.657 -2.007 -4.657 -4.483c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-11.878", "key": "svg-0" }], ["path", { "d": "M12 16v5", "key": "svg-1" }], ["path", { "d": "M16 16v4a1 1 0 0 0 1 1h4", "key": "svg-2" }], ["path", { "d": "M8 16v4a1 1 0 0 1 -1 1h-4", "key": "svg-3" }]]);

var IconCloudComputing$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudComputing
});

var IconCloudDataConnection = createReactComponent("outline", "cloud-data-connection", "IconCloudDataConnection", [["path", { "d": "M5 9.897c0 -1.714 1.46 -3.104 3.26 -3.104c.275 -1.22 1.255 -2.215 2.572 -2.611c1.317 -.397 2.77 -.134 3.811 .69c1.042 .822 1.514 2.08 1.239 3.3h.693a2.42 2.42 0 0 1 2.425 2.414a2.42 2.42 0 0 1 -2.425 2.414h-8.315c-1.8 0 -3.26 -1.39 -3.26 -3.103z", "key": "svg-0" }], ["path", { "d": "M12 13v3", "key": "svg-1" }], ["path", { "d": "M12 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M14 18h7", "key": "svg-3" }], ["path", { "d": "M3 18h7", "key": "svg-4" }]]);

var IconCloudDataConnection$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudDataConnection
});

var IconCloudDollar = createReactComponent("outline", "cloud-dollar", "IconCloudDollar", [["path", { "d": "M13.5 18.004h-6.843c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.28 1.023 1.957 2.51 1.873 4.027", "key": "svg-0" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-2" }]]);

var IconCloudDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudDollar
});

var IconCloudDown = createReactComponent("outline", "cloud-down", "IconCloudDown", [["path", { "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.38 0 2.573 .813 3.13 1.99", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }]]);

var IconCloudDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudDown
});

var IconCloudDownload = createReactComponent("outline", "cloud-download", "IconCloudDownload", [["path", { "d": "M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4", "key": "svg-0" }], ["path", { "d": "M12 13l0 9", "key": "svg-1" }], ["path", { "d": "M9 19l3 3l3 -3", "key": "svg-2" }]]);

var IconCloudDownload$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudDownload
});

var IconCloudExclamation = createReactComponent("outline", "cloud-exclamation", "IconCloudExclamation", [["path", { "d": "M15 18.004h-8.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.374 0 2.562 .805 3.121 1.972", "key": "svg-0" }], ["path", { "d": "M19 16v3", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }]]);

var IconCloudExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudExclamation
});

var IconCloudFog = createReactComponent("outline", "cloud-fog", "IconCloudFog", [["path", { "d": "M7 16a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-12", "key": "svg-0" }], ["path", { "d": "M5 20l14 0", "key": "svg-1" }]]);

var IconCloudFog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudFog
});

var IconCloudHeart = createReactComponent("outline", "cloud-heart", "IconCloudHeart", [["path", { "d": "M10 18.004h-3.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99", "key": "svg-0" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-1" }]]);

var IconCloudHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudHeart
});

var IconCloudLockOpen = createReactComponent("outline", "cloud-lock-open", "IconCloudLockOpen", [["path", { "d": "M19 18a3.5 3.5 0 0 0 0 -7h-1c.397 -1.768 -.285 -3.593 -1.788 -4.787c-1.503 -1.193 -3.6 -1.575 -5.5 -1s-3.315 2.019 -3.712 3.787c-2.199 -.088 -4.155 1.326 -4.666 3.373c-.512 2.047 .564 4.154 2.566 5.027", "key": "svg-0" }], ["path", { "d": "M8 15m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M10 15v-2a2 2 0 0 1 3.736 -1", "key": "svg-2" }]]);

var IconCloudLockOpen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudLockOpen
});

var IconCloudLock = createReactComponent("outline", "cloud-lock", "IconCloudLock", [["path", { "d": "M19 18a3.5 3.5 0 0 0 0 -7h-1c.397 -1.768 -.285 -3.593 -1.788 -4.787c-1.503 -1.193 -3.6 -1.575 -5.5 -1s-3.315 2.019 -3.712 3.787c-2.199 -.088 -4.155 1.326 -4.666 3.373c-.512 2.047 .564 4.154 2.566 5.027", "key": "svg-0" }], ["path", { "d": "M8 15m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M10 15v-2a2 2 0 1 1 4 0v2", "key": "svg-2" }]]);

var IconCloudLock$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudLock
});

var IconCloudMinus = createReactComponent("outline", "cloud-minus", "IconCloudMinus", [["path", { "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 .186 -.015 .37 -.042 .548", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconCloudMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudMinus
});

var IconCloudNetwork = createReactComponent("outline", "cloud-network", "IconCloudNetwork", [["path", { "d": "M3 20h7", "key": "svg-0" }], ["path", { "d": "M14 20h7", "key": "svg-1" }], ["path", { "d": "M10 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-2" }], ["path", { "d": "M12 16v2", "key": "svg-3" }], ["path", { "d": "M8 16.004h-1.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-2.535", "key": "svg-4" }]]);

var IconCloudNetwork$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudNetwork
});

var IconCloudOff = createReactComponent("outline", "cloud-off", "IconCloudOff", [["path", { "d": "M9.58 5.548c.24 -.11 .492 -.207 .752 -.286c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 .957 -.383 1.824 -1.003 2.454m-2.997 1.033h-11.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.13 -.582 .37 -1.128 .7 -1.62", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconCloudOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudOff
});

var IconCloudPause = createReactComponent("outline", "cloud-pause", "IconCloudPause", [["path", { "d": "M13 18.004h-6.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.406 0 2.617 .843 3.16 2.055", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }]]);

var IconCloudPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudPause
});

var IconCloudPin = createReactComponent("outline", "cloud-pin", "IconCloudPin", [["path", { "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }]]);

var IconCloudPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudPin
});

var IconCloudPlus = createReactComponent("outline", "cloud-plus", "IconCloudPlus", [["path", { "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99a3.46 3.46 0 0 1 3.085 1.9", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconCloudPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudPlus
});

var IconCloudQuestion = createReactComponent("outline", "cloud-question", "IconCloudQuestion", [["path", { "d": "M14.5 18.004h-7.843c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconCloudQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudQuestion
});

var IconCloudRain = createReactComponent("outline", "cloud-rain", "IconCloudRain", [["path", { "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7", "key": "svg-0" }], ["path", { "d": "M11 13v2m0 3v2m4 -5v2m0 3v2", "key": "svg-1" }]]);

var IconCloudRain$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudRain
});

var IconCloudSearch = createReactComponent("outline", "cloud-search", "IconCloudSearch", [["path", { "d": "M11 18.004h-4.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }]]);

var IconCloudSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudSearch
});

var IconCloudShare = createReactComponent("outline", "cloud-share", "IconCloudShare", [["path", { "d": "M12.5 18.004h-5.843c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.41 0 2.624 .848 3.164 2.065", "key": "svg-0" }], ["path", { "d": "M16 22l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-2" }]]);

var IconCloudShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudShare
});

var IconCloudSnow = createReactComponent("outline", "cloud-snow", "IconCloudSnow", [["path", { "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7", "key": "svg-0" }], ["path", { "d": "M11 15v.01m0 3v.01m0 3v.01m4 -4v.01m0 3v.01", "key": "svg-1" }]]);

var IconCloudSnow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudSnow
});

var IconCloudStar = createReactComponent("outline", "cloud-star", "IconCloudStar", [["path", { "d": "M9.5 18.004h-2.843c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.209 .967 1.88 2.347 1.88 3.776", "key": "svg-0" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }]]);

var IconCloudStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudStar
});

var IconCloudStorm = createReactComponent("outline", "cloud-storm", "IconCloudStorm", [["path", { "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1", "key": "svg-0" }], ["path", { "d": "M13 14l-2 4l3 0l-2 4", "key": "svg-1" }]]);

var IconCloudStorm$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudStorm
});

var IconCloudUp = createReactComponent("outline", "cloud-up", "IconCloudUp", [["path", { "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.38 0 2.57 .811 3.128 1.986", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }]]);

var IconCloudUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudUp
});

var IconCloudUpload = createReactComponent("outline", "cloud-upload", "IconCloudUpload", [["path", { "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1", "key": "svg-0" }], ["path", { "d": "M9 15l3 -3l3 3", "key": "svg-1" }], ["path", { "d": "M12 12l0 9", "key": "svg-2" }]]);

var IconCloudUpload$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudUpload
});

var IconCloudX = createReactComponent("outline", "cloud-x", "IconCloudX", [["path", { "d": "M13 18.004h-6.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.37 0 2.556 .8 3.117 1.964", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }]]);

var IconCloudX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudX
});

var IconCloud = createReactComponent("outline", "cloud", "IconCloud", [["path", { "d": "M6.657 18c-2.572 0 -4.657 -2.007 -4.657 -4.483c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-11.878", "key": "svg-0" }]]);

var IconCloud$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloud
});

var IconClover2 = createReactComponent("outline", "clover-2", "IconClover2", [["path", { "d": "M11 11l-3.397 -3.44a2.104 2.104 0 0 1 0 -2.95a2.04 2.04 0 0 1 2.912 0l.485 .39l.485 -.39a2.04 2.04 0 0 1 2.912 0a2.104 2.104 0 0 1 0 2.95l-3.397 3.44z", "key": "svg-0" }], ["path", { "d": "M11 11l-3.397 3.44a2.104 2.104 0 0 0 0 2.95a2.04 2.04 0 0 0 2.912 0l.485 -.39l.485 .39a2.04 2.04 0 0 0 2.912 0a2.104 2.104 0 0 0 0 -2.95l-3.397 -3.44z", "key": "svg-1" }], ["path", { "d": "M14.44 7.603a2.104 2.104 0 0 1 2.95 0a2.04 2.04 0 0 1 0 2.912l-.39 .485l.39 .485a2.04 2.04 0 0 1 0 2.912a2.104 2.104 0 0 1 -2.95 0", "key": "svg-2" }], ["path", { "d": "M7.56 7.603a2.104 2.104 0 0 0 -2.95 0a2.04 2.04 0 0 0 0 2.912l.39 .485l-.39 .485a2.04 2.04 0 0 0 0 2.912a2.104 2.104 0 0 0 2.95 0", "key": "svg-3" }], ["path", { "d": "M15 15l6 6", "key": "svg-4" }]]);

var IconClover2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClover2
});

var IconClover = createReactComponent("outline", "clover", "IconClover", [["path", { "d": "M12 10l-3.397 -3.44a2.104 2.104 0 0 1 0 -2.95a2.04 2.04 0 0 1 2.912 0l.485 .39l.485 -.39a2.04 2.04 0 0 1 2.912 0a2.104 2.104 0 0 1 0 2.95l-3.397 3.44z", "key": "svg-0" }], ["path", { "d": "M12 14l-3.397 3.44a2.104 2.104 0 0 0 0 2.95a2.04 2.04 0 0 0 2.912 0l.485 -.39l.485 .39a2.04 2.04 0 0 0 2.912 0a2.104 2.104 0 0 0 0 -2.95l-3.397 -3.44z", "key": "svg-1" }], ["path", { "d": "M14 12l3.44 -3.397a2.104 2.104 0 0 1 2.95 0a2.04 2.04 0 0 1 0 2.912l-.39 .485l.39 .485a2.04 2.04 0 0 1 0 2.912a2.104 2.104 0 0 1 -2.95 0l-3.44 -3.397z", "key": "svg-2" }], ["path", { "d": "M10 12l-3.44 -3.397a2.104 2.104 0 0 0 -2.95 0a2.04 2.04 0 0 0 0 2.912l.39 .485l-.39 .485a2.04 2.04 0 0 0 0 2.912a2.104 2.104 0 0 0 2.95 0l3.44 -3.397z", "key": "svg-3" }]]);

var IconClover$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClover
});

var IconClubs = createReactComponent("outline", "clubs", "IconClubs", [["path", { "d": "M12 3a4 4 0 0 1 3.164 6.447a4 4 0 1 1 -1.164 6.198v1.355l1 4h-6l1 -4l0 -1.355a4 4 0 1 1 -1.164 -6.199a4 4 0 0 1 3.163 -6.446z", "key": "svg-0" }]]);

var IconClubs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClubs
});

var IconCodeAsterisk = createReactComponent("outline", "code-asterisk", "IconCodeAsterisk", [["path", { "d": "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M12 11.875l3 -1.687", "key": "svg-1" }], ["path", { "d": "M12 11.875v3.375", "key": "svg-2" }], ["path", { "d": "M12 11.875l-3 -1.687", "key": "svg-3" }], ["path", { "d": "M12 11.875l3 1.688", "key": "svg-4" }], ["path", { "d": "M12 8.5v3.375", "key": "svg-5" }], ["path", { "d": "M12 11.875l-3 1.688", "key": "svg-6" }], ["path", { "d": "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2", "key": "svg-7" }]]);

var IconCodeAsterisk$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCodeAsterisk
});

var IconCodeCircle2 = createReactComponent("outline", "code-circle-2", "IconCodeCircle2", [["path", { "d": "M8.5 13.5l-1.5 -1.5l1.5 -1.5", "key": "svg-0" }], ["path", { "d": "M15.5 10.5l1.5 1.5l-1.5 1.5", "key": "svg-1" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-2" }], ["path", { "d": "M13 9.5l-2 5.5", "key": "svg-3" }]]);

var IconCodeCircle2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCodeCircle2
});

var IconCodeCircle = createReactComponent("outline", "code-circle", "IconCodeCircle", [["path", { "d": "M10 14l-2 -2l2 -2", "key": "svg-0" }], ["path", { "d": "M14 10l2 2l-2 2", "key": "svg-1" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-2" }]]);

var IconCodeCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCodeCircle
});

var IconCodeDots = createReactComponent("outline", "code-dots", "IconCodeDots", [["path", { "d": "M15 12h.01", "key": "svg-0" }], ["path", { "d": "M12 12h.01", "key": "svg-1" }], ["path", { "d": "M9 12h.01", "key": "svg-2" }], ["path", { "d": "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2", "key": "svg-3" }], ["path", { "d": "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2", "key": "svg-4" }]]);

var IconCodeDots$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCodeDots
});

var IconCodeMinus = createReactComponent("outline", "code-minus", "IconCodeMinus", [["path", { "d": "M9 12h6", "key": "svg-0" }], ["path", { "d": "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2", "key": "svg-1" }], ["path", { "d": "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2", "key": "svg-2" }]]);

var IconCodeMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCodeMinus
});

var IconCodeOff = createReactComponent("outline", "code-off", "IconCodeOff", [["path", { "d": "M7 8l-4 4l4 4", "key": "svg-0" }], ["path", { "d": "M17 8l4 4l-2.5 2.5", "key": "svg-1" }], ["path", { "d": "M14 4l-1.201 4.805m-.802 3.207l-2 7.988", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconCodeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCodeOff
});

var IconCodePlus = createReactComponent("outline", "code-plus", "IconCodePlus", [["path", { "d": "M9 12h6", "key": "svg-0" }], ["path", { "d": "M12 9v6", "key": "svg-1" }], ["path", { "d": "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2", "key": "svg-2" }], ["path", { "d": "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2", "key": "svg-3" }]]);

var IconCodePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCodePlus
});

var IconCodeVariableMinus = createReactComponent("outline", "code-variable-minus", "IconCodeVariableMinus", [["path", { "d": "M12.5 16h-6.5a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M16 18h6", "key": "svg-1" }]]);

var IconCodeVariableMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCodeVariableMinus
});

var IconCodeVariablePlus = createReactComponent("outline", "code-variable-plus", "IconCodeVariablePlus", [["path", { "d": "M13 16h-7a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v1", "key": "svg-0" }], ["path", { "d": "M16 18h6", "key": "svg-1" }], ["path", { "d": "M19 15v6", "key": "svg-2" }]]);

var IconCodeVariablePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCodeVariablePlus
});

var IconCodeVariable = createReactComponent("outline", "code-variable", "IconCodeVariable", [["path", { "d": "M4 8m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconCodeVariable$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCodeVariable
});

var IconCode = createReactComponent("outline", "code", "IconCode", [["path", { "d": "M7 8l-4 4l4 4", "key": "svg-0" }], ["path", { "d": "M17 8l4 4l-4 4", "key": "svg-1" }], ["path", { "d": "M14 4l-4 16", "key": "svg-2" }]]);

var IconCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCode
});

var IconCoffeeOff = createReactComponent("outline", "coffee-off", "IconCoffeeOff", [["path", { "d": "M3 14c.83 .642 2.077 1.017 3.5 1c1.423 .017 2.67 -.358 3.5 -1c.73 -.565 1.783 -.923 3 -.99", "key": "svg-0" }], ["path", { "d": "M8 3c-.194 .14 -.364 .305 -.506 .49", "key": "svg-1" }], ["path", { "d": "M12 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2", "key": "svg-2" }], ["path", { "d": "M14 10h3v3m-.257 3.743a6 6 0 0 1 -5.743 4.257h-2a6 6 0 0 1 -6 -6v-5h7", "key": "svg-3" }], ["path", { "d": "M20.116 16.124a3 3 0 0 0 -3.118 -4.953", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconCoffeeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoffeeOff
});

var IconCoffee = createReactComponent("outline", "coffee", "IconCoffee", [["path", { "d": "M3 14c.83 .642 2.077 1.017 3.5 1c1.423 .017 2.67 -.358 3.5 -1c.83 -.642 2.077 -1.017 3.5 -1c1.423 -.017 2.67 .358 3.5 1", "key": "svg-0" }], ["path", { "d": "M8 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2", "key": "svg-1" }], ["path", { "d": "M12 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2", "key": "svg-2" }], ["path", { "d": "M3 10h14v5a6 6 0 0 1 -6 6h-2a6 6 0 0 1 -6 -6v-5z", "key": "svg-3" }], ["path", { "d": "M16.746 16.726a3 3 0 1 0 .252 -5.555", "key": "svg-4" }]]);

var IconCoffee$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoffee
});

var IconCoffin = createReactComponent("outline", "coffin", "IconCoffin", [["path", { "d": "M7 3l-2 6l2 12h6l2 -12l-2 -6z", "key": "svg-0" }], ["path", { "d": "M10 7v5", "key": "svg-1" }], ["path", { "d": "M8 9h4", "key": "svg-2" }], ["path", { "d": "M13 21h4l2 -12l-2 -6h-4", "key": "svg-3" }]]);

var IconCoffin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoffin
});

var IconCoinBitcoin = createReactComponent("outline", "coin-bitcoin", "IconCoinBitcoin", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 8h4.09c1.055 0 1.91 .895 1.91 2s-.855 2 -1.91 2c1.055 0 1.91 .895 1.91 2s-.855 2 -1.91 2h-4.09", "key": "svg-1" }], ["path", { "d": "M10 12h4", "key": "svg-2" }], ["path", { "d": "M10 7v10v-9", "key": "svg-3" }], ["path", { "d": "M13 7v1", "key": "svg-4" }], ["path", { "d": "M13 16v1", "key": "svg-5" }]]);

var IconCoinBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinBitcoin
});

var IconCoinEuro = createReactComponent("outline", "coin-euro", "IconCoinEuro", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14.401 8c-.669 -.628 -1.5 -1 -2.401 -1c-2.21 0 -4 2.239 -4 5s1.79 5 4 5c.9 0 1.731 -.372 2.4 -1", "key": "svg-1" }], ["path", { "d": "M7 10.5h4", "key": "svg-2" }], ["path", { "d": "M7 13.5h4", "key": "svg-3" }]]);

var IconCoinEuro$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinEuro
});

var IconCoinMonero = createReactComponent("outline", "coin-monero", "IconCoinMonero", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M4 16h4v-7l4 4l4 -4v7h4", "key": "svg-1" }]]);

var IconCoinMonero$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinMonero
});

var IconCoinOff = createReactComponent("outline", "coin-off", "IconCoinOff", [["path", { "d": "M14.8 9a2 2 0 0 0 -1.8 -1h-1m-2.82 1.171a2 2 0 0 0 1.82 2.829h1m2.824 2.822a2 2 0 0 1 -1.824 1.178h-2a2 2 0 0 1 -1.8 -1", "key": "svg-0" }], ["path", { "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73", "key": "svg-1" }], ["path", { "d": "M12 6v2m0 8v2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconCoinOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinOff
});

var IconCoinPound = createReactComponent("outline", "coin-pound", "IconCoinPound", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M15 9a2 2 0 1 0 -4 0v5a2 2 0 0 1 -2 2h6", "key": "svg-1" }], ["path", { "d": "M9 12h4", "key": "svg-2" }]]);

var IconCoinPound$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinPound
});

var IconCoinRupee = createReactComponent("outline", "coin-rupee", "IconCoinRupee", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M15 8h-6h1a3 3 0 0 1 0 6h-1l3 3", "key": "svg-1" }], ["path", { "d": "M9 11h6", "key": "svg-2" }]]);

var IconCoinRupee$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinRupee
});

var IconCoinTaka = createReactComponent("outline", "coin-taka", "IconCoinTaka", [["path", { "d": "M8 8l.553 -.276a1 1 0 0 1 1.447 .894v6.382a2 2 0 0 0 2 2h.5a2.5 2.5 0 0 0 2.5 -2.5v-.5h-1", "key": "svg-0" }], ["path", { "d": "M8 11h7", "key": "svg-1" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-2" }]]);

var IconCoinTaka$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinTaka
});

var IconCoinYen = createReactComponent("outline", "coin-yen", "IconCoinYen", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 12h6", "key": "svg-1" }], ["path", { "d": "M9 15h6", "key": "svg-2" }], ["path", { "d": "M9 8l3 4.5", "key": "svg-3" }], ["path", { "d": "M15 8l-3 4.5v4.5", "key": "svg-4" }]]);

var IconCoinYen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinYen
});

var IconCoinYuan = createReactComponent("outline", "coin-yuan", "IconCoinYuan", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 13h6", "key": "svg-1" }], ["path", { "d": "M9 8l3 4.5", "key": "svg-2" }], ["path", { "d": "M15 8l-3 4.5v4.5", "key": "svg-3" }]]);

var IconCoinYuan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinYuan
});

var IconCoin = createReactComponent("outline", "coin", "IconCoin", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1", "key": "svg-1" }], ["path", { "d": "M12 7v10", "key": "svg-2" }]]);

var IconCoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoin
});

var IconCoins = createReactComponent("outline", "coins", "IconCoins", [["path", { "d": "M9 14c0 1.657 2.686 3 6 3s6 -1.343 6 -3s-2.686 -3 -6 -3s-6 1.343 -6 3z", "key": "svg-0" }], ["path", { "d": "M9 14v4c0 1.656 2.686 3 6 3s6 -1.344 6 -3v-4", "key": "svg-1" }], ["path", { "d": "M3 6c0 1.072 1.144 2.062 3 2.598s4.144 .536 6 0c1.856 -.536 3 -1.526 3 -2.598c0 -1.072 -1.144 -2.062 -3 -2.598s-4.144 -.536 -6 0c-1.856 .536 -3 1.526 -3 2.598z", "key": "svg-2" }], ["path", { "d": "M3 6v10c0 .888 .772 1.45 2 2", "key": "svg-3" }], ["path", { "d": "M3 11c0 .888 .772 1.45 2 2", "key": "svg-4" }]]);

var IconCoins$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoins
});

var IconColorFilter = createReactComponent("outline", "color-filter", "IconColorFilter", [["path", { "d": "M13.58 13.79c.27 .68 .42 1.43 .42 2.21c0 1.77 -.77 3.37 -2 4.46a5.93 5.93 0 0 1 -4 1.54c-3.31 0 -6 -2.69 -6 -6c0 -2.76 1.88 -5.1 4.42 -5.79", "key": "svg-0" }], ["path", { "d": "M17.58 10.21c2.54 .69 4.42 3.03 4.42 5.79c0 3.31 -2.69 6 -6 6a5.93 5.93 0 0 1 -4 -1.54", "key": "svg-1" }], ["path", { "d": "M12 8m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-2" }]]);

var IconColorFilter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColorFilter
});

var IconColorPickerOff = createReactComponent("outline", "color-picker-off", "IconColorPickerOff", [["path", { "d": "M11 7l6 6", "key": "svg-0" }], ["path", { "d": "M12 8l3.699 -3.699a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-3.702 3.702m-2 2l-6 6h-4v-4l6 -6", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconColorPickerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColorPickerOff
});

var IconColorPicker = createReactComponent("outline", "color-picker", "IconColorPicker", [["path", { "d": "M11 7l6 6", "key": "svg-0" }], ["path", { "d": "M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z", "key": "svg-1" }]]);

var IconColorPicker$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColorPicker
});

var IconColorSwatchOff = createReactComponent("outline", "color-swatch-off", "IconColorSwatchOff", [["path", { "d": "M13 13v4a4 4 0 0 0 6.832 2.825m1.168 -2.825v-12a2 2 0 0 0 -2 -2h-4a2 2 0 0 0 -2 2v4", "key": "svg-0" }], ["path", { "d": "M13 7.35l-2 -2a2 2 0 0 0 -2.11 -.461m-2.13 1.874l-1.416 1.415a2 2 0 0 0 0 2.828l9 9", "key": "svg-1" }], ["path", { "d": "M7.3 13h-2.3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h12", "key": "svg-2" }], ["path", { "d": "M17 17v.01", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconColorSwatchOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColorSwatchOff
});

var IconColorSwatch = createReactComponent("outline", "color-swatch", "IconColorSwatch", [["path", { "d": "M19 3h-4a2 2 0 0 0 -2 2v12a4 4 0 0 0 8 0v-12a2 2 0 0 0 -2 -2", "key": "svg-0" }], ["path", { "d": "M13 7.35l-2 -2a2 2 0 0 0 -2.828 0l-2.828 2.828a2 2 0 0 0 0 2.828l9 9", "key": "svg-1" }], ["path", { "d": "M7.3 13h-2.3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h12", "key": "svg-2" }], ["path", { "d": "M17 17l0 .01", "key": "svg-3" }]]);

var IconColorSwatch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColorSwatch
});

var IconColumnInsertLeft = createReactComponent("outline", "column-insert-left", "IconColumnInsertLeft", [["path", { "d": "M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M5 12l4 0", "key": "svg-1" }], ["path", { "d": "M7 10l0 4", "key": "svg-2" }]]);

var IconColumnInsertLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColumnInsertLeft
});

var IconColumnInsertRight = createReactComponent("outline", "column-insert-right", "IconColumnInsertRight", [["path", { "d": "M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M15 12l4 0", "key": "svg-1" }], ["path", { "d": "M17 10l0 4", "key": "svg-2" }]]);

var IconColumnInsertRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColumnInsertRight
});

var IconColumnRemove = createReactComponent("outline", "column-remove", "IconColumnRemove", [["path", { "d": "M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M16 10l4 4", "key": "svg-1" }], ["path", { "d": "M16 14l4 -4", "key": "svg-2" }]]);

var IconColumnRemove$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColumnRemove
});

var IconColumns1 = createReactComponent("outline", "columns-1", "IconColumns1", [["path", { "d": "M5 3m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z", "key": "svg-0" }]]);

var IconColumns1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColumns1
});

var IconColumns2 = createReactComponent("outline", "columns-2", "IconColumns2", [["path", { "d": "M3 3m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1zm9 -1v18", "key": "svg-0" }]]);

var IconColumns2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColumns2
});

var IconColumns3 = createReactComponent("outline", "columns-3", "IconColumns3", [["path", { "d": "M3 3m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1zm6 -1v18m6 -18v18", "key": "svg-0" }]]);

var IconColumns3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColumns3
});

var IconColumnsOff = createReactComponent("outline", "columns-off", "IconColumnsOff", [["path", { "d": "M4 6h2", "key": "svg-0" }], ["path", { "d": "M4 10h5.5", "key": "svg-1" }], ["path", { "d": "M4 14h5.5", "key": "svg-2" }], ["path", { "d": "M4 18h5.5", "key": "svg-3" }], ["path", { "d": "M14.5 6h5.5", "key": "svg-4" }], ["path", { "d": "M14.5 10h5.5", "key": "svg-5" }], ["path", { "d": "M18 14h2", "key": "svg-6" }], ["path", { "d": "M14.5 18h3.5", "key": "svg-7" }], ["path", { "d": "M3 3l18 18", "key": "svg-8" }]]);

var IconColumnsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColumnsOff
});

var IconColumns = createReactComponent("outline", "columns", "IconColumns", [["path", { "d": "M4 6l5.5 0", "key": "svg-0" }], ["path", { "d": "M4 10l5.5 0", "key": "svg-1" }], ["path", { "d": "M4 14l5.5 0", "key": "svg-2" }], ["path", { "d": "M4 18l5.5 0", "key": "svg-3" }], ["path", { "d": "M14.5 6l5.5 0", "key": "svg-4" }], ["path", { "d": "M14.5 10l5.5 0", "key": "svg-5" }], ["path", { "d": "M14.5 14l5.5 0", "key": "svg-6" }], ["path", { "d": "M14.5 18l5.5 0", "key": "svg-7" }]]);

var IconColumns$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconColumns
});

var IconComet = createReactComponent("outline", "comet", "IconComet", [["path", { "d": "M15.5 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z", "key": "svg-0" }], ["path", { "d": "M4 4l7 7", "key": "svg-1" }], ["path", { "d": "M9 4l3.5 3.5", "key": "svg-2" }], ["path", { "d": "M4 9l3.5 3.5", "key": "svg-3" }]]);

var IconComet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconComet
});

var IconCommandOff = createReactComponent("outline", "command-off", "IconCommandOff", [["path", { "d": "M9 9v8a2 2 0 1 1 -2 -2h8m3.411 3.417a2 2 0 0 1 -3.411 -1.417v-2m0 -4v-4a2 2 0 1 1 2 2h-4m-4 0h-2a2 2 0 0 1 -1.417 -3.411", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconCommandOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCommandOff
});

var IconCommand = createReactComponent("outline", "command", "IconCommand", [["path", { "d": "M7 9a2 2 0 1 1 2 -2v10a2 2 0 1 1 -2 -2h10a2 2 0 1 1 -2 2v-10a2 2 0 1 1 2 2h-10", "key": "svg-0" }]]);

var IconCommand$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCommand
});

var IconCompassOff = createReactComponent("outline", "compass-off", "IconCompassOff", [["path", { "d": "M13 9l3 -1l-1 3m-1 3l-6 2l2 -6", "key": "svg-0" }], ["path", { "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73", "key": "svg-1" }], ["path", { "d": "M12 3v2", "key": "svg-2" }], ["path", { "d": "M12 19v2", "key": "svg-3" }], ["path", { "d": "M3 12h2", "key": "svg-4" }], ["path", { "d": "M19 12h2", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconCompassOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCompassOff
});

var IconCompass = createReactComponent("outline", "compass", "IconCompass", [["path", { "d": "M8 16l2 -6l6 -2l-2 6l-6 2", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }], ["path", { "d": "M12 3l0 2", "key": "svg-2" }], ["path", { "d": "M12 19l0 2", "key": "svg-3" }], ["path", { "d": "M3 12l2 0", "key": "svg-4" }], ["path", { "d": "M19 12l2 0", "key": "svg-5" }]]);

var IconCompass$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCompass
});

var IconComponentsOff = createReactComponent("outline", "components-off", "IconComponentsOff", [["path", { "d": "M3 12l3 3l3 -3l-3 -3z", "key": "svg-0" }], ["path", { "d": "M18.5 14.5l2.5 -2.5l-3 -3l-2.5 2.5", "key": "svg-1" }], ["path", { "d": "M12.499 8.501l2.501 -2.501l-3 -3l-2.5 2.5", "key": "svg-2" }], ["path", { "d": "M9 18l3 3l3 -3l-3 -3z", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconComponentsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconComponentsOff
});

var IconComponents = createReactComponent("outline", "components", "IconComponents", [["path", { "d": "M3 12l3 3l3 -3l-3 -3z", "key": "svg-0" }], ["path", { "d": "M15 12l3 3l3 -3l-3 -3z", "key": "svg-1" }], ["path", { "d": "M9 6l3 3l3 -3l-3 -3z", "key": "svg-2" }], ["path", { "d": "M9 18l3 3l3 -3l-3 -3z", "key": "svg-3" }]]);

var IconComponents$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconComponents
});

var IconCone2 = createReactComponent("outline", "cone-2", "IconCone2", [["path", { "d": "M21 5.002v.5l-8.13 14.99a1 1 0 0 1 -1.74 0l-8.13 -14.989v-.5c0 -1.659 4.03 -3.003 9 -3.003s9 1.344 9 3.002", "key": "svg-0" }]]);

var IconCone2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCone2
});

var IconConeOff = createReactComponent("outline", "cone-off", "IconConeOff", [["path", { "d": "M20.396 16.384l-7.526 -13.877a1 1 0 0 0 -1.74 0l-1.626 2.998m-1.407 2.594l-5.097 9.398v.5c0 1.66 4.03 3.003 9 3.003c3.202 0 6.014 -.558 7.609 -1.398", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconConeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconConeOff
});

var IconConePlus = createReactComponent("outline", "cone-plus", "IconConePlus", [["path", { "d": "M18.03 12.022l-5.16 -9.515a1 1 0 0 0 -1.74 0l-8.13 14.99v.5c0 1.66 4.03 3.003 9 3.003c.17 0 .34 -.002 .508 -.005", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconConePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconConePlus
});

var IconCone = createReactComponent("outline", "cone", "IconCone", [["path", { "d": "M21 17.998v-.5l-8.13 -14.99a1 1 0 0 0 -1.74 0l-8.13 14.989v.5c0 1.659 4.03 3.003 9 3.003s9 -1.344 9 -3.002", "key": "svg-0" }]]);

var IconCone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCone
});

var IconConfettiOff = createReactComponent("outline", "confetti-off", "IconConfettiOff", [["path", { "d": "M4 5h1", "key": "svg-0" }], ["path", { "d": "M5 5v1", "key": "svg-1" }], ["path", { "d": "M11.5 4l-.5 2", "key": "svg-2" }], ["path", { "d": "M18 5h2", "key": "svg-3" }], ["path", { "d": "M19 4v2", "key": "svg-4" }], ["path", { "d": "M15 9l-1 1", "key": "svg-5" }], ["path", { "d": "M18 13l2 -.5", "key": "svg-6" }], ["path", { "d": "M18 19h1", "key": "svg-7" }], ["path", { "d": "M19 19v1", "key": "svg-8" }], ["path", { "d": "M14 16.518l-6.518 -6.518l-4.39 9.58a1 1 0 0 0 1.329 1.329l9.579 -4.39v0z", "key": "svg-9" }], ["path", { "d": "M3 3l18 18", "key": "svg-10" }]]);

var IconConfettiOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconConfettiOff
});

var IconConfetti = createReactComponent("outline", "confetti", "IconConfetti", [["path", { "d": "M4 5h2", "key": "svg-0" }], ["path", { "d": "M5 4v2", "key": "svg-1" }], ["path", { "d": "M11.5 4l-.5 2", "key": "svg-2" }], ["path", { "d": "M18 5h2", "key": "svg-3" }], ["path", { "d": "M19 4v2", "key": "svg-4" }], ["path", { "d": "M15 9l-1 1", "key": "svg-5" }], ["path", { "d": "M18 13l2 -.5", "key": "svg-6" }], ["path", { "d": "M18 19h2", "key": "svg-7" }], ["path", { "d": "M19 18v2", "key": "svg-8" }], ["path", { "d": "M14 16.518l-6.518 -6.518l-4.39 9.58a1 1 0 0 0 1.329 1.329l9.579 -4.39z", "key": "svg-9" }]]);

var IconConfetti$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconConfetti
});

var IconConfucius = createReactComponent("outline", "confucius", "IconConfucius", [["path", { "d": "M9 19l3 2v-18", "key": "svg-0" }], ["path", { "d": "M4 10l8 -2", "key": "svg-1" }], ["path", { "d": "M4 18l8 -10", "key": "svg-2" }], ["path", { "d": "M20 18l-8 -8l8 -4", "key": "svg-3" }]]);

var IconConfucius$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconConfucius
});

var IconCongruentTo = createReactComponent("outline", "congruent-to", "IconCongruentTo", [["path", { "d": "M5 13h14", "key": "svg-0" }], ["path", { "d": "M5 17h14", "key": "svg-1" }], ["path", { "d": "M5 7.686c2.333 -2.624 4.667 -1.856 7 .064s4.667 2.688 7 .064", "key": "svg-2" }]]);

var IconCongruentTo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCongruentTo
});

var IconContainerOff = createReactComponent("outline", "container-off", "IconContainerOff", [["path", { "d": "M20 4v.01", "key": "svg-0" }], ["path", { "d": "M20 20v.01", "key": "svg-1" }], ["path", { "d": "M20 16v.01", "key": "svg-2" }], ["path", { "d": "M20 12v.01", "key": "svg-3" }], ["path", { "d": "M20 8v.01", "key": "svg-4" }], ["path", { "d": "M8.297 4.289a1 1 0 0 1 .703 -.289h6a1 1 0 0 1 1 1v7m0 4v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-11", "key": "svg-5" }], ["path", { "d": "M4 4v.01", "key": "svg-6" }], ["path", { "d": "M4 20v.01", "key": "svg-7" }], ["path", { "d": "M4 16v.01", "key": "svg-8" }], ["path", { "d": "M4 12v.01", "key": "svg-9" }], ["path", { "d": "M4 8v.01", "key": "svg-10" }], ["path", { "d": "M3 3l18 18", "key": "svg-11" }]]);

var IconContainerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconContainerOff
});

var IconContainer = createReactComponent("outline", "container", "IconContainer", [["path", { "d": "M20 4v.01", "key": "svg-0" }], ["path", { "d": "M20 20v.01", "key": "svg-1" }], ["path", { "d": "M20 16v.01", "key": "svg-2" }], ["path", { "d": "M20 12v.01", "key": "svg-3" }], ["path", { "d": "M20 8v.01", "key": "svg-4" }], ["path", { "d": "M8 4m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-5" }], ["path", { "d": "M4 4v.01", "key": "svg-6" }], ["path", { "d": "M4 20v.01", "key": "svg-7" }], ["path", { "d": "M4 16v.01", "key": "svg-8" }], ["path", { "d": "M4 12v.01", "key": "svg-9" }], ["path", { "d": "M4 8v.01", "key": "svg-10" }]]);

var IconContainer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconContainer
});

var IconContract = createReactComponent("outline", "contract", "IconContract", [["path", { "d": "M8 21h-2a3 3 0 0 1 -3 -3v-1h5.5", "key": "svg-0" }], ["path", { "d": "M17 8.5v-3.5a2 2 0 1 1 2 2h-2", "key": "svg-1" }], ["path", { "d": "M19 3h-11a3 3 0 0 0 -3 3v11", "key": "svg-2" }], ["path", { "d": "M9 7h4", "key": "svg-3" }], ["path", { "d": "M9 11h4", "key": "svg-4" }], ["path", { "d": "M18.42 12.61a2.1 2.1 0 0 1 2.97 2.97l-6.39 6.42h-3v-3z", "key": "svg-5" }]]);

var IconContract$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconContract
});

var IconContrast2Off = createReactComponent("outline", "contrast-2-off", "IconContrast2Off", [["path", { "d": "M4 18h2a6 6 0 0 0 6 -6m.878 -3.126a6 6 0 0 1 5.122 -2.874h2", "key": "svg-0" }], ["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconContrast2Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconContrast2Off
});

var IconContrast2 = createReactComponent("outline", "contrast-2", "IconContrast2", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M3 19h2.25c3.728 0 6.75 -3.134 6.75 -7s3.022 -7 6.75 -7h2.25", "key": "svg-1" }]]);

var IconContrast2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconContrast2
});

var IconContrastOff = createReactComponent("outline", "contrast-off", "IconContrastOff", [["path", { "d": "M12 12v5a4.984 4.984 0 0 0 3.522 -1.45m1.392 -2.623a5 5 0 0 0 -4.914 -5.927v1", "key": "svg-0" }], ["path", { "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconContrastOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconContrastOff
});

var IconContrast = createReactComponent("outline", "contrast", "IconContrast", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 17a5 5 0 0 0 0 -10v10", "key": "svg-1" }]]);

var IconContrast$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconContrast
});

var IconCooker = createReactComponent("outline", "cooker", "IconCooker", [["path", { "d": "M12 7h.01", "key": "svg-0" }], ["path", { "d": "M15 7h.01", "key": "svg-1" }], ["path", { "d": "M9 7h.01", "key": "svg-2" }], ["path", { "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-3" }], ["path", { "d": "M9 15h6", "key": "svg-4" }], ["path", { "d": "M5 11h14", "key": "svg-5" }]]);

var IconCooker$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCooker
});

var IconCookieMan = createReactComponent("outline", "cookie-man", "IconCookieMan", [["path", { "d": "M12 2a5 5 0 0 1 2.845 9.112l.147 .369l1.755 -.803c.969 -.443 2.12 -.032 2.571 .918a1.88 1.88 0 0 1 -.787 2.447l-.148 .076l-2.383 1.089v2.02l1.426 1.425l.114 .125a1.96 1.96 0 0 1 -2.762 2.762l-.125 -.114l-2.079 -2.08l-.114 -.124a2 2 0 0 1 -.161 -.22h-.599q -.071 .114 -.16 .22l-.115 .125l-2.08 2.079a1.96 1.96 0 0 1 -2.886 -2.648l.114 -.125l1.427 -1.426v-2.019l-2.383 -1.09l-.148 -.075a1.88 1.88 0 0 1 -.787 -2.447c.429 -.902 1.489 -1.318 2.424 -.978l.147 .06l1.755 .803l.147 -.369a5 5 0 0 1 -2.15 -3.895v-.217a5 5 0 0 1 5 -5z", "key": "svg-1" }], ["path", { "d": "M12 16h.01", "key": "svg-2" }], ["path", { "d": "M12 13h.01", "key": "svg-3" }], ["path", { "d": "M10 7h.01", "key": "svg-4" }], ["path", { "d": "M14 7h.01", "key": "svg-5" }], ["path", { "d": "M12 9h.01", "key": "svg-6" }]]);

var IconCookieMan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCookieMan
});

var IconCookieOff = createReactComponent("outline", "cookie-off", "IconCookieOff", [["path", { "d": "M8 13v.01", "key": "svg-0" }], ["path", { "d": "M12 17v.01", "key": "svg-1" }], ["path", { "d": "M12 12v.01", "key": "svg-2" }], ["path", { "d": "M18.192 18.187a3 3 0 0 1 -.976 .652c-1.048 .263 -1.787 .483 -2.216 .661c-.475 .197 -1.092 .538 -1.852 1.024a3 3 0 0 1 -2.296 0c-.802 -.503 -1.419 -.844 -1.852 -1.024c-.471 -.195 -1.21 -.415 -2.216 -.66a3 3 0 0 1 -1.623 -1.624c-.265 -1.052 -.485 -1.79 -.661 -2.216c-.198 -.479 -.54 -1.096 -1.024 -1.852a3 3 0 0 1 0 -2.296c.48 -.744 .82 -1.361 1.024 -1.852c.171 -.413 .391 -1.152 .66 -2.216a3 3 0 0 1 .649 -.971m2.821 -1.174c.14 -.049 .263 -.095 .37 -.139c.458 -.19 1.075 -.531 1.852 -1.024a3 3 0 0 1 2.296 0l2.667 1.104a4 4 0 0 0 4.656 6.14l.053 .132a3 3 0 0 1 0 2.296c-.497 .786 -.838 1.404 -1.024 1.852a6.579 6.579 0 0 0 -.135 .36", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconCookieOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCookieOff
});

var IconCookie = createReactComponent("outline", "cookie", "IconCookie", [["path", { "d": "M8 13v.01", "key": "svg-1" }], ["path", { "d": "M12 17v.01", "key": "svg-2" }], ["path", { "d": "M12 12v.01", "key": "svg-3" }], ["path", { "d": "M16 14v.01", "key": "svg-4" }], ["path", { "d": "M11 8v.01", "key": "svg-5" }], ["path", { "d": "M13.148 3.476l2.667 1.104a4 4 0 0 0 4.656 6.14l.053 .132a3 3 0 0 1 0 2.296q -.745 1.18 -1.024 1.852q -.283 .684 -.66 2.216a3 3 0 0 1 -1.624 1.623q -1.572 .394 -2.216 .661q -.712 .295 -1.852 1.024a3 3 0 0 1 -2.296 0q -1.203 -.754 -1.852 -1.024q -.707 -.292 -2.216 -.66a3 3 0 0 1 -1.623 -1.624q -.397 -1.577 -.661 -2.216q -.298 -.718 -1.024 -1.852a3 3 0 0 1 0 -2.296q .719 -1.116 1.024 -1.852q .257 -.62 .66 -2.216a3 3 0 0 1 1.624 -1.623q 1.547 -.384 2.216 -.661q .687 -.285 1.852 -1.024a3 3 0 0 1 2.296 0", "key": "svg-6" }]]);

var IconCookie$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCookie
});

var IconCopyCheck = createReactComponent("outline", "copy-check", "IconCopyCheck", [["path", { "d": "M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-1" }], ["path", { "d": "M4.012 16.737a2 2 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1", "key": "svg-2" }], ["path", { "d": "M11 14l2 2l4 -4", "key": "svg-3" }]]);

var IconCopyCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyCheck
});

var IconCopyMinus = createReactComponent("outline", "copy-minus", "IconCopyMinus", [["path", { "d": "M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-1" }], ["path", { "d": "M4.012 16.737a2 2 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1", "key": "svg-2" }], ["path", { "d": "M11 14h6", "key": "svg-3" }]]);

var IconCopyMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyMinus
});

var IconCopyOff = createReactComponent("outline", "copy-off", "IconCopyOff", [["path", { "d": "M19.414 19.415a2 2 0 0 1 -1.414 .585h-8a2 2 0 0 1 -2 -2v-8c0 -.554 .225 -1.055 .589 -1.417m3.411 -.583h6a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M16 8v-2a2 2 0 0 0 -2 -2h-6m-3.418 .59c-.36 .36 -.582 .86 -.582 1.41v8a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconCopyOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyOff
});

var IconCopyPlus = createReactComponent("outline", "copy-plus", "IconCopyPlus", [["path", { "d": "M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-1" }], ["path", { "d": "M4.012 16.737a2 2 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1", "key": "svg-2" }], ["path", { "d": "M11 14h6", "key": "svg-3" }], ["path", { "d": "M14 11v6", "key": "svg-4" }]]);

var IconCopyPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyPlus
});

var IconCopyX = createReactComponent("outline", "copy-x", "IconCopyX", [["path", { "d": "M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-1" }], ["path", { "d": "M4.012 16.737a2 2 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1", "key": "svg-2" }], ["path", { "d": "M11.5 11.5l4.9 5", "key": "svg-3" }], ["path", { "d": "M16.5 11.5l-5.1 5", "key": "svg-4" }]]);

var IconCopyX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyX
});

var IconCopy = createReactComponent("outline", "copy", "IconCopy", [["path", { "d": "M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-0" }], ["path", { "d": "M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1", "key": "svg-1" }]]);

var IconCopy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopy
});

var IconCopyleftOff = createReactComponent("outline", "copyleft-off", "IconCopyleftOff", [["path", { "d": "M13.303 9.3a3.01 3.01 0 0 1 1.405 1.406m-.586 3.413a3.016 3.016 0 0 1 -4.122 .131", "key": "svg-0" }], ["path", { "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconCopyleftOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyleftOff
});

var IconCopyleft = createReactComponent("outline", "copyleft", "IconCopyleft", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 9.75a3.016 3.016 0 0 1 4.163 .173a2.993 2.993 0 0 1 0 4.154a3.016 3.016 0 0 1 -4.163 .173", "key": "svg-1" }]]);

var IconCopyleft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyleft
});

var IconCopyrightOff = createReactComponent("outline", "copyright-off", "IconCopyrightOff", [["path", { "d": "M14 9.75a3.016 3.016 0 0 0 -.711 -.466m-3.41 .596a2.993 2.993 0 0 0 -.042 4.197a3.016 3.016 0 0 0 4.163 .173", "key": "svg-0" }], ["path", { "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconCopyrightOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyrightOff
});

var IconCopyright = createReactComponent("outline", "copyright", "IconCopyright", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14 9.75a3.016 3.016 0 0 0 -4.163 .173a2.993 2.993 0 0 0 0 4.154a3.016 3.016 0 0 0 4.163 .173", "key": "svg-1" }]]);

var IconCopyright$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyright
});

var IconCornerDownLeftDouble = createReactComponent("outline", "corner-down-left-double", "IconCornerDownLeftDouble", [["path", { "d": "M19 5v6a3 3 0 0 1 -3 3h-7", "key": "svg-0" }], ["path", { "d": "M13 10l-4 4l4 4m-5 -8l-4 4l4 4", "key": "svg-1" }]]);

var IconCornerDownLeftDouble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerDownLeftDouble
});

var IconCornerDownLeft = createReactComponent("outline", "corner-down-left", "IconCornerDownLeft", [["path", { "d": "M18 6v6a3 3 0 0 1 -3 3h-10l4 -4m0 8l-4 -4", "key": "svg-0" }]]);

var IconCornerDownLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerDownLeft
});

var IconCornerDownRightDouble = createReactComponent("outline", "corner-down-right-double", "IconCornerDownRightDouble", [["path", { "d": "M4 5v6a3 3 0 0 0 3 3h7", "key": "svg-0" }], ["path", { "d": "M10 10l4 4l-4 4m5 -8l4 4l-4 4", "key": "svg-1" }]]);

var IconCornerDownRightDouble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerDownRightDouble
});

var IconCornerDownRight = createReactComponent("outline", "corner-down-right", "IconCornerDownRight", [["path", { "d": "M6 6v6a3 3 0 0 0 3 3h10l-4 -4m0 8l4 -4", "key": "svg-0" }]]);

var IconCornerDownRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerDownRight
});

var IconCornerLeftDownDouble = createReactComponent("outline", "corner-left-down-double", "IconCornerLeftDownDouble", [["path", { "d": "M18 4h-6a3 3 0 0 0 -3 3v7", "key": "svg-0" }], ["path", { "d": "M13 10l-4 4l-4 -4m8 5l-4 4l-4 -4", "key": "svg-1" }]]);

var IconCornerLeftDownDouble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerLeftDownDouble
});

var IconCornerLeftDown = createReactComponent("outline", "corner-left-down", "IconCornerLeftDown", [["path", { "d": "M18 6h-6a3 3 0 0 0 -3 3v10l-4 -4m8 0l-4 4", "key": "svg-0" }]]);

var IconCornerLeftDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerLeftDown
});

var IconCornerLeftUpDouble = createReactComponent("outline", "corner-left-up-double", "IconCornerLeftUpDouble", [["path", { "d": "M18 19h-6a3 3 0 0 1 -3 -3v-7", "key": "svg-0" }], ["path", { "d": "M13 13l-4 -4l-4 4m8 -5l-4 -4l-4 4", "key": "svg-1" }]]);

var IconCornerLeftUpDouble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerLeftUpDouble
});

var IconCornerLeftUp = createReactComponent("outline", "corner-left-up", "IconCornerLeftUp", [["path", { "d": "M18 18h-6a3 3 0 0 1 -3 -3v-10l-4 4m8 0l-4 -4", "key": "svg-0" }]]);

var IconCornerLeftUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerLeftUp
});

var IconCornerRightDownDouble = createReactComponent("outline", "corner-right-down-double", "IconCornerRightDownDouble", [["path", { "d": "M5 4h6a3 3 0 0 1 3 3v7", "key": "svg-0" }], ["path", { "d": "M10 10l4 4l4 -4m-8 5l4 4l4 -4", "key": "svg-1" }]]);

var IconCornerRightDownDouble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerRightDownDouble
});

var IconCornerRightDown = createReactComponent("outline", "corner-right-down", "IconCornerRightDown", [["path", { "d": "M6 6h6a3 3 0 0 1 3 3v10l-4 -4m8 0l-4 4", "key": "svg-0" }]]);

var IconCornerRightDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerRightDown
});

var IconCornerRightUpDouble = createReactComponent("outline", "corner-right-up-double", "IconCornerRightUpDouble", [["path", { "d": "M5 19h6a3 3 0 0 0 3 -3v-7", "key": "svg-0" }], ["path", { "d": "M10 13l4 -4l4 4m-8 -5l4 -4l4 4", "key": "svg-1" }]]);

var IconCornerRightUpDouble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerRightUpDouble
});

var IconCornerRightUp = createReactComponent("outline", "corner-right-up", "IconCornerRightUp", [["path", { "d": "M6 18h6a3 3 0 0 0 3 -3v-10l-4 4m8 0l-4 -4", "key": "svg-0" }]]);

var IconCornerRightUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerRightUp
});

var IconCornerUpLeftDouble = createReactComponent("outline", "corner-up-left-double", "IconCornerUpLeftDouble", [["path", { "d": "M19 18v-6a3 3 0 0 0 -3 -3h-7", "key": "svg-0" }], ["path", { "d": "M13 13l-4 -4l4 -4m-5 8l-4 -4l4 -4", "key": "svg-1" }]]);

var IconCornerUpLeftDouble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerUpLeftDouble
});

var IconCornerUpLeft = createReactComponent("outline", "corner-up-left", "IconCornerUpLeft", [["path", { "d": "M18 18v-6a3 3 0 0 0 -3 -3h-10l4 -4m0 8l-4 -4", "key": "svg-0" }]]);

var IconCornerUpLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerUpLeft
});

var IconCornerUpRightDouble = createReactComponent("outline", "corner-up-right-double", "IconCornerUpRightDouble", [["path", { "d": "M4 18v-6a3 3 0 0 1 3 -3h7", "key": "svg-0" }], ["path", { "d": "M10 13l4 -4l-4 -4m5 8l4 -4l-4 -4", "key": "svg-1" }]]);

var IconCornerUpRightDouble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerUpRightDouble
});

var IconCornerUpRight = createReactComponent("outline", "corner-up-right", "IconCornerUpRight", [["path", { "d": "M6 18v-6a3 3 0 0 1 3 -3h10l-4 -4m0 8l4 -4", "key": "svg-0" }]]);

var IconCornerUpRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCornerUpRight
});

var IconCpu2 = createReactComponent("outline", "cpu-2", "IconCpu2", [["path", { "d": "M5 5m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M8 10v-2h2m6 6v2h-2m-4 0h-2v-2m8 -4v-2h-2", "key": "svg-1" }], ["path", { "d": "M3 10h2", "key": "svg-2" }], ["path", { "d": "M3 14h2", "key": "svg-3" }], ["path", { "d": "M10 3v2", "key": "svg-4" }], ["path", { "d": "M14 3v2", "key": "svg-5" }], ["path", { "d": "M21 10h-2", "key": "svg-6" }], ["path", { "d": "M21 14h-2", "key": "svg-7" }], ["path", { "d": "M14 21v-2", "key": "svg-8" }], ["path", { "d": "M10 21v-2", "key": "svg-9" }]]);

var IconCpu2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCpu2
});

var IconCpuOff = createReactComponent("outline", "cpu-off", "IconCpuOff", [["path", { "d": "M9 5h9a1 1 0 0 1 1 1v9m-.292 3.706a1 1 0 0 1 -.708 .294h-12a1 1 0 0 1 -1 -1v-12c0 -.272 .108 -.518 .284 -.698", "key": "svg-0" }], ["path", { "d": "M13 9h2v2m0 4h-6v-6", "key": "svg-1" }], ["path", { "d": "M3 10h2", "key": "svg-2" }], ["path", { "d": "M3 14h2", "key": "svg-3" }], ["path", { "d": "M10 3v2", "key": "svg-4" }], ["path", { "d": "M14 3v2", "key": "svg-5" }], ["path", { "d": "M21 10h-2", "key": "svg-6" }], ["path", { "d": "M21 14h-2", "key": "svg-7" }], ["path", { "d": "M14 21v-2", "key": "svg-8" }], ["path", { "d": "M10 21v-2", "key": "svg-9" }], ["path", { "d": "M3 3l18 18", "key": "svg-10" }]]);

var IconCpuOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCpuOff
});

var IconCpu = createReactComponent("outline", "cpu", "IconCpu", [["path", { "d": "M5 5m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M9 9h6v6h-6z", "key": "svg-1" }], ["path", { "d": "M3 10h2", "key": "svg-2" }], ["path", { "d": "M3 14h2", "key": "svg-3" }], ["path", { "d": "M10 3v2", "key": "svg-4" }], ["path", { "d": "M14 3v2", "key": "svg-5" }], ["path", { "d": "M21 10h-2", "key": "svg-6" }], ["path", { "d": "M21 14h-2", "key": "svg-7" }], ["path", { "d": "M14 21v-2", "key": "svg-8" }], ["path", { "d": "M10 21v-2", "key": "svg-9" }]]);

var IconCpu$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCpu
});

var IconCraneOff = createReactComponent("outline", "crane-off", "IconCraneOff", [["path", { "d": "M6 21h6", "key": "svg-0" }], ["path", { "d": "M9 21v-12", "key": "svg-1" }], ["path", { "d": "M9 5v-2l-1 1", "key": "svg-2" }], ["path", { "d": "M6 6l-3 3h6", "key": "svg-3" }], ["path", { "d": "M13 9h8", "key": "svg-4" }], ["path", { "d": "M9 3l10 6", "key": "svg-5" }], ["path", { "d": "M17 9v4a2 2 0 0 1 2 2m-2 2a2 2 0 0 1 -2 -2", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconCraneOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCraneOff
});

var IconCrane = createReactComponent("outline", "crane", "IconCrane", [["path", { "d": "M6 21h6", "key": "svg-0" }], ["path", { "d": "M9 21v-18l-6 6h18", "key": "svg-1" }], ["path", { "d": "M9 3l10 6", "key": "svg-2" }], ["path", { "d": "M17 9v4a2 2 0 1 1 -2 2", "key": "svg-3" }]]);

var IconCrane$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrane
});

var IconCreativeCommonsBy = createReactComponent("outline", "creative-commons-by", "IconCreativeCommonsBy", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M9 13v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-.5l-.5 4h-2l-.5 -4h-.5a1 1 0 0 1 -1 -1z", "key": "svg-2" }]]);

var IconCreativeCommonsBy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCreativeCommonsBy
});

var IconCreativeCommonsNc = createReactComponent("outline", "creative-commons-nc", "IconCreativeCommonsNc", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M15 9h-4.5a1.5 1.5 0 0 0 0 3h3a1.5 1.5 0 0 1 0 3h-4.5", "key": "svg-1" }], ["path", { "d": "M12 7v2", "key": "svg-2" }], ["path", { "d": "M12 15v2", "key": "svg-3" }], ["path", { "d": "M6 6l3 3", "key": "svg-4" }], ["path", { "d": "M15 15l3 3", "key": "svg-5" }]]);

var IconCreativeCommonsNc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCreativeCommonsNc
});

var IconCreativeCommonsNd = createReactComponent("outline", "creative-commons-nd", "IconCreativeCommonsNd", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10h6", "key": "svg-1" }], ["path", { "d": "M9 14h6", "key": "svg-2" }]]);

var IconCreativeCommonsNd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCreativeCommonsNd
});

var IconCreativeCommonsOff = createReactComponent("outline", "creative-commons-off", "IconCreativeCommonsOff", [["path", { "d": "M5.638 5.634a9 9 0 1 0 12.723 12.733m1.686 -2.332a9 9 0 0 0 -12.093 -12.077", "key": "svg-0" }], ["path", { "d": "M10.5 10.5a2.187 2.187 0 0 0 -2.914 .116a1.928 1.928 0 0 0 0 2.768a2.188 2.188 0 0 0 2.914 .116", "key": "svg-1" }], ["path", { "d": "M16.5 10.5a2.194 2.194 0 0 0 -2.309 -.302", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconCreativeCommonsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCreativeCommonsOff
});

var IconCreativeCommonsSa = createReactComponent("outline", "creative-commons-sa", "IconCreativeCommonsSa", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 16a4 4 0 1 0 -4 -4v1", "key": "svg-1" }], ["path", { "d": "M6 12l2 2l2 -2", "key": "svg-2" }]]);

var IconCreativeCommonsSa$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCreativeCommonsSa
});

var IconCreativeCommonsZero = createReactComponent("outline", "creative-commons-zero", "IconCreativeCommonsZero", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-3 0a3 4 0 1 0 6 0a3 4 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M14 9l-4 6", "key": "svg-2" }]]);

var IconCreativeCommonsZero$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCreativeCommonsZero
});

var IconCreativeCommons = createReactComponent("outline", "creative-commons", "IconCreativeCommons", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116", "key": "svg-1" }], ["path", { "d": "M16.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116", "key": "svg-2" }]]);

var IconCreativeCommons$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCreativeCommons
});

var IconCreditCardOff = createReactComponent("outline", "credit-card-off", "IconCreditCardOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M9 5h9a3 3 0 0 1 3 3v8a3 3 0 0 1 -.128 .87", "key": "svg-1" }], ["path", { "d": "M18.87 18.872a3 3 0 0 1 -.87 .128h-12a3 3 0 0 1 -3 -3v-8c0 -1.352 .894 -2.495 2.124 -2.87", "key": "svg-2" }], ["path", { "d": "M3 11l8 0", "key": "svg-3" }], ["path", { "d": "M15 11l6 0", "key": "svg-4" }], ["path", { "d": "M7 15l.01 0", "key": "svg-5" }], ["path", { "d": "M11 15l2 0", "key": "svg-6" }]]);

var IconCreditCardOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCreditCardOff
});

var IconCreditCardPay = createReactComponent("outline", "credit-card-pay", "IconCreditCardPay", [["path", { "d": "M12 19h-6a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16l3 3l-3 3", "key": "svg-3" }], ["path", { "d": "M7.005 15h.005", "key": "svg-4" }], ["path", { "d": "M11 15h2", "key": "svg-5" }]]);

var IconCreditCardPay$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCreditCardPay
});

var IconCreditCardRefund = createReactComponent("outline", "credit-card-refund", "IconCreditCardRefund", [["path", { "d": "M12 19h-6a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M7 15h.01", "key": "svg-2" }], ["path", { "d": "M11 15h2", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16l-3 3l3 3", "key": "svg-5" }]]);

var IconCreditCardRefund$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCreditCardRefund
});

var IconCreditCard = createReactComponent("outline", "credit-card", "IconCreditCard", [["path", { "d": "M3 5m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M3 10l18 0", "key": "svg-1" }], ["path", { "d": "M7 15l.01 0", "key": "svg-2" }], ["path", { "d": "M11 15l2 0", "key": "svg-3" }]]);

var IconCreditCard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCreditCard
});

var IconCricket = createReactComponent("outline", "cricket", "IconCricket", [["path", { "d": "M11.105 18.79l-1 .992a4.159 4.159 0 0 1 -6.038 -5.715l.157 -.166l8.282 -8.401l1.5 1.5l3.45 -3.391a2.08 2.08 0 0 1 3.057 2.815l-.116 .126l-3.391 3.45l1.5 1.5l-3.668 3.617", "key": "svg-0" }], ["path", { "d": "M10.5 7.5l6 6", "key": "svg-1" }], ["path", { "d": "M14 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }]]);

var IconCricket$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCricket
});

var IconCrop11 = createReactComponent("outline", "crop-1-1", "IconCrop11", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconCrop11$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrop11
});

var IconCrop169 = createReactComponent("outline", "crop-16-9", "IconCrop169", [["path", { "d": "M4 8m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconCrop169$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrop169
});

var IconCrop32 = createReactComponent("outline", "crop-3-2", "IconCrop32", [["path", { "d": "M4 7m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconCrop32$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrop32
});

var IconCrop54 = createReactComponent("outline", "crop-5-4", "IconCrop54", [["path", { "d": "M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconCrop54$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrop54
});

var IconCrop75 = createReactComponent("outline", "crop-7-5", "IconCrop75", [["path", { "d": "M4 6m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconCrop75$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrop75
});

var IconCropLandscape = createReactComponent("outline", "crop-landscape", "IconCropLandscape", [["path", { "d": "M4 6m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconCropLandscape$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCropLandscape
});

var IconCropPortrait = createReactComponent("outline", "crop-portrait", "IconCropPortrait", [["path", { "d": "M6 4m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconCropPortrait$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCropPortrait
});

var IconCrop = createReactComponent("outline", "crop", "IconCrop", [["path", { "d": "M8 5v10a1 1 0 0 0 1 1h10", "key": "svg-0" }], ["path", { "d": "M5 8h10a1 1 0 0 1 1 1v10", "key": "svg-1" }]]);

var IconCrop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrop
});

var IconCrossOff = createReactComponent("outline", "cross-off", "IconCrossOff", [["path", { "d": "M16 12h3v-4h-5v-5h-4v3m-2 2h-3v4h5v9h4v-7", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconCrossOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrossOff
});

var IconCross = createReactComponent("outline", "cross", "IconCross", [["path", { "d": "M10 21h4v-9h5v-4h-5v-5h-4v5h-5v4h5z", "key": "svg-0" }]]);

var IconCross$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCross
});

var IconCrosshair = createReactComponent("outline", "crosshair", "IconCrosshair", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M9 12l6 0", "key": "svg-4" }], ["path", { "d": "M12 9l0 6", "key": "svg-5" }]]);

var IconCrosshair$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrosshair
});

var IconCrownOff = createReactComponent("outline", "crown-off", "IconCrownOff", [["path", { "d": "M18 18h-13l-1.865 -9.327a.25 .25 0 0 1 .4 -.244l4.465 3.571l1.6 -2.4m1.596 -2.394l.804 -1.206l4 6l4.464 -3.571a.25 .25 0 0 1 .401 .244l-1.363 6.818", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconCrownOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrownOff
});

var IconCrown = createReactComponent("outline", "crown", "IconCrown", [["path", { "d": "M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z", "key": "svg-0" }]]);

var IconCrown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrown
});

var IconCrutchesOff = createReactComponent("outline", "crutches-off", "IconCrutchesOff", [["path", { "d": "M8.178 4.174a2 2 0 0 1 1.822 -1.174h4a2 2 0 1 1 0 4h-3", "key": "svg-0" }], ["path", { "d": "M11 21h2", "key": "svg-1" }], ["path", { "d": "M12 21v-4.092a3 3 0 0 1 .504 -1.664l.992 -1.488a3 3 0 0 0 .097 -.155m.407 -3.601v-3", "key": "svg-2" }], ["path", { "d": "M12 21v-4.092a3 3 0 0 0 -.504 -1.664l-.992 -1.488a3 3 0 0 1 -.504 -1.664v-2.092", "key": "svg-3" }], ["path", { "d": "M10 11h1", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconCrutchesOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrutchesOff
});

var IconCrutches = createReactComponent("outline", "crutches", "IconCrutches", [["path", { "d": "M8 3m0 2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M11 21h2", "key": "svg-1" }], ["path", { "d": "M12 21v-4.092a3 3 0 0 1 .504 -1.664l.992 -1.488a3 3 0 0 0 .504 -1.664v-5.092", "key": "svg-2" }], ["path", { "d": "M12 21v-4.092a3 3 0 0 0 -.504 -1.664l-.992 -1.488a3 3 0 0 1 -.504 -1.664v-5.092", "key": "svg-3" }], ["path", { "d": "M10 11h4", "key": "svg-4" }]]);

var IconCrutches$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrutches
});

var IconCrystalBall = createReactComponent("outline", "crystal-ball", "IconCrystalBall", [["path", { "d": "M6.73 17.018a8 8 0 1 1 10.54 0", "key": "svg-0" }], ["path", { "d": "M5 19a2 2 0 0 0 2 2h10a2 2 0 1 0 0 -4h-10a2 2 0 0 0 -2 2z", "key": "svg-1" }], ["path", { "d": "M11 7a3 3 0 0 0 -3 3", "key": "svg-2" }]]);

var IconCrystalBall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrystalBall
});

var IconCsv = createReactComponent("outline", "csv", "IconCsv", [["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1", "key": "svg-0" }], ["path", { "d": "M17 8l2 8l2 -8", "key": "svg-1" }], ["path", { "d": "M7 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-2" }]]);

var IconCsv$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCsv
});

var IconCube3dSphereOff = createReactComponent("outline", "cube-3d-sphere-off", "IconCube3dSphereOff", [["path", { "d": "M6 17.6l-2 -1.1v-2.5", "key": "svg-0" }], ["path", { "d": "M4 10v-2.5l2 -1.1", "key": "svg-1" }], ["path", { "d": "M10 4.1l2 -1.1l2 1.1", "key": "svg-2" }], ["path", { "d": "M18 6.4l2 1.1v2.5", "key": "svg-3" }], ["path", { "d": "M20 14v2", "key": "svg-4" }], ["path", { "d": "M14 19.9l-2 1.1l-2 -1.1", "key": "svg-5" }], ["path", { "d": "M18 8.6l2 -1.1", "key": "svg-6" }], ["path", { "d": "M12 12v2.5", "key": "svg-7" }], ["path", { "d": "M12 18.5v2.5", "key": "svg-8" }], ["path", { "d": "M12 12l-2 -1.12", "key": "svg-9" }], ["path", { "d": "M6 8.6l-2 -1.1", "key": "svg-10" }], ["path", { "d": "M3 3l18 18", "key": "svg-11" }]]);

var IconCube3dSphereOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCube3dSphereOff
});

var IconCube3dSphere = createReactComponent("outline", "cube-3d-sphere", "IconCube3dSphere", [["path", { "d": "M6 17.6l-2 -1.1v-2.5", "key": "svg-0" }], ["path", { "d": "M4 10v-2.5l2 -1.1", "key": "svg-1" }], ["path", { "d": "M10 4.1l2 -1.1l2 1.1", "key": "svg-2" }], ["path", { "d": "M18 6.4l2 1.1v2.5", "key": "svg-3" }], ["path", { "d": "M20 14v2.5l-2 1.12", "key": "svg-4" }], ["path", { "d": "M14 19.9l-2 1.1l-2 -1.1", "key": "svg-5" }], ["path", { "d": "M12 12l2 -1.1", "key": "svg-6" }], ["path", { "d": "M18 8.6l2 -1.1", "key": "svg-7" }], ["path", { "d": "M12 12l0 2.5", "key": "svg-8" }], ["path", { "d": "M12 18.5l0 2.5", "key": "svg-9" }], ["path", { "d": "M12 12l-2 -1.12", "key": "svg-10" }], ["path", { "d": "M6 8.6l-2 -1.1", "key": "svg-11" }]]);

var IconCube3dSphere$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCube3dSphere
});

var IconCubeOff = createReactComponent("outline", "cube-off", "IconCubeOff", [["path", { "d": "M20.83 16.809c.11 -.248 .17 -.52 .17 -.801v-8.018a1.98 1.98 0 0 0 -1 -1.717l-7 -4.008a2.016 2.016 0 0 0 -2 0l-3.012 1.725m-2.547 1.458l-1.441 .825c-.619 .355 -1 1.01 -1 1.718v8.018c0 .709 .381 1.363 1 1.717l7 4.008a2.016 2.016 0 0 0 2 0l5.544 -3.174", "key": "svg-0" }], ["path", { "d": "M12 22v-10", "key": "svg-1" }], ["path", { "d": "M14.532 10.538l6.198 -3.578", "key": "svg-2" }], ["path", { "d": "M3.27 6.96l8.73 5.04", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconCubeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCubeOff
});

var IconCubePlus = createReactComponent("outline", "cube-plus", "IconCubePlus", [["path", { "d": "M21 12.5v-4.509a1.98 1.98 0 0 0 -1 -1.717l-7 -4.008a2.016 2.016 0 0 0 -2 0l-7 4.007c-.619 .355 -1 1.01 -1 1.718v8.018c0 .709 .381 1.363 1 1.717l7 4.008a2.016 2.016 0 0 0 2 0", "key": "svg-0" }], ["path", { "d": "M12 22v-10", "key": "svg-1" }], ["path", { "d": "M12 12l8.73 -5.04", "key": "svg-2" }], ["path", { "d": "M3.27 6.96l8.73 5.04", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16v6", "key": "svg-5" }]]);

var IconCubePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCubePlus
});

var IconCubeSend = createReactComponent("outline", "cube-send", "IconCubeSend", [["path", { "d": "M16 12.5l-5 -3l5 -3l5 3v5.5l-5 3z", "key": "svg-0" }], ["path", { "d": "M11 9.5v5.5l5 3", "key": "svg-1" }], ["path", { "d": "M16 12.545l5 -3.03", "key": "svg-2" }], ["path", { "d": "M7 9h-5", "key": "svg-3" }], ["path", { "d": "M7 12h-3", "key": "svg-4" }], ["path", { "d": "M7 15h-1", "key": "svg-5" }]]);

var IconCubeSend$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCubeSend
});

var IconCubeSpark = createReactComponent("outline", "cube-spark", "IconCubeSpark", [["path", { "d": "M21 12v-4.01a1.98 1.98 0 0 0 -1 -1.717l-7 -4.008a2.02 2.02 0 0 0 -2 0l-7 4.008c-.619 .355 -1 1.01 -1 1.718v8.018c0 .709 .381 1.363 1 1.717l7 4.008c.62 .354 1.38 .354 2 0", "key": "svg-0" }], ["path", { "d": "M12 22v-10", "key": "svg-1" }], ["path", { "d": "M12 12l8.73 -5.04", "key": "svg-2" }], ["path", { "d": "M3.27 6.96l8.73 5.04", "key": "svg-3" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-4" }]]);

var IconCubeSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCubeSpark
});

var IconCubeUnfolded = createReactComponent("outline", "cube-unfolded", "IconCubeUnfolded", [["path", { "d": "M2 15h10v5h5v-5h5v-5h-10v-5h-5v5h-5z", "key": "svg-0" }], ["path", { "d": "M7 15v-5h5v5h5v-5", "key": "svg-1" }]]);

var IconCubeUnfolded$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCubeUnfolded
});

var IconCube = createReactComponent("outline", "cube", "IconCube", [["path", { "d": "M21 16.008v-8.018a1.98 1.98 0 0 0 -1 -1.717l-7 -4.008a2.016 2.016 0 0 0 -2 0l-7 4.008c-.619 .355 -1 1.01 -1 1.718v8.018c0 .709 .381 1.363 1 1.717l7 4.008a2.016 2.016 0 0 0 2 0l7 -4.008c.619 -.355 1 -1.01 1 -1.718z", "key": "svg-0" }], ["path", { "d": "M12 22v-10", "key": "svg-1" }], ["path", { "d": "M12 12l8.73 -5.04", "key": "svg-2" }], ["path", { "d": "M3.27 6.96l8.73 5.04", "key": "svg-3" }]]);

var IconCube$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCube
});

var IconCupOff = createReactComponent("outline", "cup-off", "IconCupOff", [["path", { "d": "M8 8h-3v3h6m4 0h4v-3h-7", "key": "svg-0" }], ["path", { "d": "M17.5 11l-.323 2.154m-.525 3.497l-.652 4.349h-8l-1.5 -10", "key": "svg-1" }], ["path", { "d": "M6 8v-1c0 -.296 .064 -.577 .18 -.83m2.82 -1.17h7a2 2 0 0 1 2 2v1", "key": "svg-2" }], ["path", { "d": "M15 5v-2", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconCupOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCupOff
});

var IconCup = createReactComponent("outline", "cup", "IconCup", [["path", { "d": "M5 11h14v-3h-14z", "key": "svg-0" }], ["path", { "d": "M17.5 11l-1.5 10h-8l-1.5 -10", "key": "svg-1" }], ["path", { "d": "M6 8v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1", "key": "svg-2" }], ["path", { "d": "M15 5v-2", "key": "svg-3" }]]);

var IconCup$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCup
});

var IconCurling = createReactComponent("outline", "curling", "IconCurling", [["path", { "d": "M4 9m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v2a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z", "key": "svg-0" }], ["path", { "d": "M4 14h16", "key": "svg-1" }], ["path", { "d": "M8 5h6a2 2 0 0 1 2 2v2", "key": "svg-2" }]]);

var IconCurling$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurling
});

var IconCurlyLoop = createReactComponent("outline", "curly-loop", "IconCurlyLoop", [["path", { "d": "M21 8c-4 0 -7 2 -7 5a3 3 0 0 0 6 0c0 -3 -2.5 -5 -8 -5s-8 2 -8 5a3 3 0 0 0 6 0c0 -3 -3 -5 -7 -5", "key": "svg-0" }]]);

var IconCurlyLoop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurlyLoop
});

var IconCurrencyAfghani = createReactComponent("outline", "currency-afghani", "IconCurrencyAfghani", [["path", { "d": "M15 13h-3.5a3.5 3.5 0 1 1 3.5 -3.5v6.5h-7", "key": "svg-0" }], ["path", { "d": "M12 3v.01", "key": "svg-1" }], ["path", { "d": "M12 19v2", "key": "svg-2" }]]);

var IconCurrencyAfghani$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyAfghani
});

var IconCurrencyBahraini = createReactComponent("outline", "currency-bahraini", "IconCurrencyBahraini", [["path", { "d": "M3 10v1a4 4 0 0 0 4 4h2a2 2 0 0 0 2 -2v-3", "key": "svg-0" }], ["path", { "d": "M7 19.01v-.01", "key": "svg-1" }], ["path", { "d": "M14 15.01v-.01", "key": "svg-2" }], ["path", { "d": "M17 15h2a2 2 0 0 0 1.649 -3.131l-2.653 -3.869", "key": "svg-3" }]]);

var IconCurrencyBahraini$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyBahraini
});

var IconCurrencyBaht = createReactComponent("outline", "currency-baht", "IconCurrencyBaht", [["path", { "d": "M8 6h5a3 3 0 0 1 3 3v.143a2.857 2.857 0 0 1 -2.857 2.857h-5.143", "key": "svg-0" }], ["path", { "d": "M8 12h5a3 3 0 0 1 3 3v.143a2.857 2.857 0 0 1 -2.857 2.857h-5.143", "key": "svg-1" }], ["path", { "d": "M8 6v12", "key": "svg-2" }], ["path", { "d": "M11 4v2", "key": "svg-3" }], ["path", { "d": "M11 18v2", "key": "svg-4" }]]);

var IconCurrencyBaht$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyBaht
});

var IconCurrencyBitcoin = createReactComponent("outline", "currency-bitcoin", "IconCurrencyBitcoin", [["path", { "d": "M6 6h8a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-8", "key": "svg-0" }], ["path", { "d": "M8 6l0 12", "key": "svg-1" }], ["path", { "d": "M8 12l6 0", "key": "svg-2" }], ["path", { "d": "M9 3l0 3", "key": "svg-3" }], ["path", { "d": "M13 3l0 3", "key": "svg-4" }], ["path", { "d": "M9 18l0 3", "key": "svg-5" }], ["path", { "d": "M13 18l0 3", "key": "svg-6" }]]);

var IconCurrencyBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyBitcoin
});

var IconCurrencyCent = createReactComponent("outline", "currency-cent", "IconCurrencyCent", [["path", { "d": "M16.007 7.54a5.965 5.965 0 0 0 -4.008 -1.54a6 6 0 0 0 -5.992 6c0 3.314 2.682 6 5.992 6a5.965 5.965 0 0 0 4 -1.536", "key": "svg-0" }], ["path", { "d": "M12 20v-2", "key": "svg-1" }], ["path", { "d": "M12 6v-2", "key": "svg-2" }]]);

var IconCurrencyCent$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyCent
});

var IconCurrencyDinar = createReactComponent("outline", "currency-dinar", "IconCurrencyDinar", [["path", { "d": "M14 20.01v-.01", "key": "svg-0" }], ["path", { "d": "M6 13l2.386 -.9a1 1 0 0 0 -.095 -1.902l-1.514 -.404a1 1 0 0 1 -.102 -1.9l2.325 -.894", "key": "svg-1" }], ["path", { "d": "M3 14v1a3 3 0 0 0 3 3h4.161a3 3 0 0 0 2.983 -3.32l-1.144 -10.68", "key": "svg-2" }], ["path", { "d": "M16 17l1 1h2a2 2 0 0 0 1.649 -3.131l-2.653 -3.869", "key": "svg-3" }]]);

var IconCurrencyDinar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDinar
});

var IconCurrencyDirham = createReactComponent("outline", "currency-dirham", "IconCurrencyDirham", [["path", { "d": "M8.5 19h-3.5", "key": "svg-0" }], ["path", { "d": "M8.599 16.479a1.5 1.5 0 1 0 -1.099 2.521", "key": "svg-1" }], ["path", { "d": "M7 4v9", "key": "svg-2" }], ["path", { "d": "M15 13h1.888a1.5 1.5 0 0 0 1.296 -2.256l-2.184 -3.744", "key": "svg-3" }], ["path", { "d": "M11 13.01v-.01", "key": "svg-4" }]]);

var IconCurrencyDirham$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDirham
});

var IconCurrencyDogecoin = createReactComponent("outline", "currency-dogecoin", "IconCurrencyDogecoin", [["path", { "d": "M6 12h6", "key": "svg-0" }], ["path", { "d": "M9 6v12", "key": "svg-1" }], ["path", { "d": "M6 18h6a6 6 0 1 0 0 -12h-6", "key": "svg-2" }]]);

var IconCurrencyDogecoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDogecoin
});

var IconCurrencyDollarAustralian = createReactComponent("outline", "currency-dollar-australian", "IconCurrencyDollarAustralian", [["path", { "d": "M3 18l3.279 -11.476a.75 .75 0 0 1 1.442 0l3.279 11.476", "key": "svg-0" }], ["path", { "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4", "key": "svg-1" }], ["path", { "d": "M17 20v-2", "key": "svg-2" }], ["path", { "d": "M18 6v-2", "key": "svg-3" }], ["path", { "d": "M4.5 14h5", "key": "svg-4" }]]);

var IconCurrencyDollarAustralian$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDollarAustralian
});

var IconCurrencyDollarBrunei = createReactComponent("outline", "currency-dollar-brunei", "IconCurrencyDollarBrunei", [["path", { "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4", "key": "svg-0" }], ["path", { "d": "M17 20v-2", "key": "svg-1" }], ["path", { "d": "M18 6v-2", "key": "svg-2" }], ["path", { "d": "M3 6v12h4a3 3 0 0 0 0 -6h-4h4a3 3 0 0 0 0 -6h-4z", "key": "svg-3" }]]);

var IconCurrencyDollarBrunei$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDollarBrunei
});

var IconCurrencyDollarCanadian = createReactComponent("outline", "currency-dollar-canadian", "IconCurrencyDollarCanadian", [["path", { "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4", "key": "svg-0" }], ["path", { "d": "M10 18h-1a6 6 0 1 1 0 -12h1", "key": "svg-1" }], ["path", { "d": "M17 20v-2", "key": "svg-2" }], ["path", { "d": "M18 6v-2", "key": "svg-3" }]]);

var IconCurrencyDollarCanadian$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDollarCanadian
});

var IconCurrencyDollarGuyanese = createReactComponent("outline", "currency-dollar-guyanese", "IconCurrencyDollarGuyanese", [["path", { "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4", "key": "svg-0" }], ["path", { "d": "M10 6h-3a4 4 0 0 0 -4 4v4a4 4 0 0 0 4 4h3v-6h-2", "key": "svg-1" }], ["path", { "d": "M17 20v-2", "key": "svg-2" }], ["path", { "d": "M18 6v-2", "key": "svg-3" }]]);

var IconCurrencyDollarGuyanese$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDollarGuyanese
});

var IconCurrencyDollarOff = createReactComponent("outline", "currency-dollar-off", "IconCurrencyDollarOff", [["path", { "d": "M16.7 8a3 3 0 0 0 -2.7 -2h-4m-2.557 1.431a3 3 0 0 0 2.557 4.569h2m4.564 4.558a3 3 0 0 1 -2.564 1.442h-4a3 3 0 0 1 -2.7 -2", "key": "svg-0" }], ["path", { "d": "M12 3v3m0 12v3", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconCurrencyDollarOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDollarOff
});

var IconCurrencyDollarSingapore = createReactComponent("outline", "currency-dollar-singapore", "IconCurrencyDollarSingapore", [["path", { "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4", "key": "svg-0" }], ["path", { "d": "M10 6h-4a3 3 0 1 0 0 6h1a3 3 0 0 1 0 6h-4", "key": "svg-1" }], ["path", { "d": "M17 20v-2", "key": "svg-2" }], ["path", { "d": "M18 6v-2", "key": "svg-3" }]]);

var IconCurrencyDollarSingapore$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDollarSingapore
});

var IconCurrencyDollarZimbabwean = createReactComponent("outline", "currency-dollar-zimbabwean", "IconCurrencyDollarZimbabwean", [["path", { "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4", "key": "svg-0" }], ["path", { "d": "M17 20v-2", "key": "svg-1" }], ["path", { "d": "M18 6v-2", "key": "svg-2" }], ["path", { "d": "M3 6h7l-7 12h7", "key": "svg-3" }]]);

var IconCurrencyDollarZimbabwean$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDollarZimbabwean
});

var IconCurrencyDollar = createReactComponent("outline", "currency-dollar", "IconCurrencyDollar", [["path", { "d": "M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2", "key": "svg-0" }], ["path", { "d": "M12 3v3m0 12v3", "key": "svg-1" }]]);

var IconCurrencyDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDollar
});

var IconCurrencyDong = createReactComponent("outline", "currency-dong", "IconCurrencyDong", [["path", { "d": "M6 19h12", "key": "svg-0" }], ["path", { "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-1" }], ["path", { "d": "M16 16v-12", "key": "svg-2" }], ["path", { "d": "M17 5h-4", "key": "svg-3" }]]);

var IconCurrencyDong$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDong
});

var IconCurrencyDram = createReactComponent("outline", "currency-dram", "IconCurrencyDram", [["path", { "d": "M4 10a6 6 0 1 1 12 0v10", "key": "svg-0" }], ["path", { "d": "M12 16h8", "key": "svg-1" }], ["path", { "d": "M12 12h8", "key": "svg-2" }]]);

var IconCurrencyDram$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyDram
});

var IconCurrencyEthereum = createReactComponent("outline", "currency-ethereum", "IconCurrencyEthereum", [["path", { "d": "M6 12l6 -9l6 9l-6 9z", "key": "svg-0" }], ["path", { "d": "M6 12l6 -3l6 3l-6 2z", "key": "svg-1" }]]);

var IconCurrencyEthereum$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyEthereum
});

var IconCurrencyEuroOff = createReactComponent("outline", "currency-euro-off", "IconCurrencyEuroOff", [["path", { "d": "M17.2 7c-1.977 -2.26 -4.954 -2.602 -7.234 -1.04m-1.913 2.079c-1.604 2.72 -1.374 6.469 .69 8.894c2.292 2.691 6 2.758 8.356 .18", "key": "svg-0" }], ["path", { "d": "M10 10h-5m0 4h8", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconCurrencyEuroOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyEuroOff
});

var IconCurrencyEuro = createReactComponent("outline", "currency-euro", "IconCurrencyEuro", [["path", { "d": "M17.2 7a6 7 0 1 0 0 10", "key": "svg-0" }], ["path", { "d": "M13 10h-8m0 4h8", "key": "svg-1" }]]);

var IconCurrencyEuro$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyEuro
});

var IconCurrencyFlorin = createReactComponent("outline", "currency-florin", "IconCurrencyFlorin", [["path", { "d": "M8 12h8", "key": "svg-0" }], ["path", { "d": "M7 19c1.213 0 2.31 -.723 2.788 -1.838l4.424 -10.324a3.033 3.033 0 0 1 2.788 -1.838", "key": "svg-1" }]]);

var IconCurrencyFlorin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyFlorin
});

var IconCurrencyForint = createReactComponent("outline", "currency-forint", "IconCurrencyForint", [["path", { "d": "M11 4h-4a3 3 0 0 0 -3 3v12", "key": "svg-0" }], ["path", { "d": "M10 11h-6", "key": "svg-1" }], ["path", { "d": "M16 4v13a2 2 0 0 0 2 2h2", "key": "svg-2" }], ["path", { "d": "M19 9h-5", "key": "svg-3" }]]);

var IconCurrencyForint$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyForint
});

var IconCurrencyFrank = createReactComponent("outline", "currency-frank", "IconCurrencyFrank", [["path", { "d": "M17 5h-6a2 2 0 0 0 -2 2v12", "key": "svg-0" }], ["path", { "d": "M7 15h4", "key": "svg-1" }], ["path", { "d": "M9 11h7", "key": "svg-2" }]]);

var IconCurrencyFrank$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyFrank
});

var IconCurrencyGuarani = createReactComponent("outline", "currency-guarani", "IconCurrencyGuarani", [["path", { "d": "M16.007 7.54a5.965 5.965 0 0 0 -4.008 -1.54a6 6 0 0 0 -5.992 6c0 3.314 2.682 6 5.992 6a5.965 5.965 0 0 0 4 -1.536c.732 -.66 1.064 -2.148 1 -4.464h-5", "key": "svg-0" }], ["path", { "d": "M12 20v-16", "key": "svg-1" }]]);

var IconCurrencyGuarani$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyGuarani
});

var IconCurrencyHryvnia = createReactComponent("outline", "currency-hryvnia", "IconCurrencyHryvnia", [["path", { "d": "M8 7a2.64 2.64 0 0 1 2.562 -2h3.376a2.64 2.64 0 0 1 2.562 2a2.57 2.57 0 0 1 -1.344 2.922l-5.876 2.938a3.338 3.338 0 0 0 -1.78 3.64a3.11 3.11 0 0 0 3.05 2.5h2.888a2.64 2.64 0 0 0 2.562 -2", "key": "svg-0" }], ["path", { "d": "M6 10h12", "key": "svg-1" }], ["path", { "d": "M6 14h12", "key": "svg-2" }]]);

var IconCurrencyHryvnia$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyHryvnia
});

var IconCurrencyIranianRial = createReactComponent("outline", "currency-iranian-rial", "IconCurrencyIranianRial", [["path", { "d": "M9 4v9a2 2 0 0 1 -2 2h-1a3 3 0 0 1 -3 -3v-1", "key": "svg-0" }], ["path", { "d": "M12 5v8a1 1 0 0 0 1 1h1a2 2 0 0 0 2 -2v-1", "key": "svg-1" }], ["path", { "d": "M21 14v1.096a5 5 0 0 1 -3.787 4.85l-.213 .054", "key": "svg-2" }], ["path", { "d": "M11 18h.01", "key": "svg-3" }], ["path", { "d": "M14 18h.01", "key": "svg-4" }]]);

var IconCurrencyIranianRial$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyIranianRial
});

var IconCurrencyKip = createReactComponent("outline", "currency-kip", "IconCurrencyKip", [["path", { "d": "M6 12h12", "key": "svg-0" }], ["path", { "d": "M9 5v14", "key": "svg-1" }], ["path", { "d": "M16 19a7 7 0 0 0 -7 -7a7 7 0 0 0 7 -7", "key": "svg-2" }]]);

var IconCurrencyKip$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyKip
});

var IconCurrencyKroneCzech = createReactComponent("outline", "currency-krone-czech", "IconCurrencyKroneCzech", [["path", { "d": "M5 6v12", "key": "svg-0" }], ["path", { "d": "M5 12c3.5 0 6 -3 6 -6", "key": "svg-1" }], ["path", { "d": "M5 12c3.5 0 6 3 6 6", "key": "svg-2" }], ["path", { "d": "M19 6l-2 2l-2 -2", "key": "svg-3" }], ["path", { "d": "M19 12h-2a3 3 0 0 0 0 6h2", "key": "svg-4" }]]);

var IconCurrencyKroneCzech$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyKroneCzech
});

var IconCurrencyKroneDanish = createReactComponent("outline", "currency-krone-danish", "IconCurrencyKroneDanish", [["path", { "d": "M5 6v12", "key": "svg-0" }], ["path", { "d": "M5 12c3.5 0 6 -3 6 -6", "key": "svg-1" }], ["path", { "d": "M5 12c3.5 0 6 3 6 6", "key": "svg-2" }], ["path", { "d": "M15 10v8", "key": "svg-3" }], ["path", { "d": "M19 10a4 4 0 0 0 -4 4", "key": "svg-4" }], ["path", { "d": "M20 18.01v-.01", "key": "svg-5" }]]);

var IconCurrencyKroneDanish$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyKroneDanish
});

var IconCurrencyKroneSwedish = createReactComponent("outline", "currency-krone-swedish", "IconCurrencyKroneSwedish", [["path", { "d": "M5 6v12", "key": "svg-0" }], ["path", { "d": "M5 12c3.5 0 6 -3 6 -6", "key": "svg-1" }], ["path", { "d": "M5 12c3.5 0 6 3 6 6", "key": "svg-2" }], ["path", { "d": "M15 10v8", "key": "svg-3" }], ["path", { "d": "M19 10a4 4 0 0 0 -4 4", "key": "svg-4" }]]);

var IconCurrencyKroneSwedish$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyKroneSwedish
});

var IconCurrencyLari = createReactComponent("outline", "currency-lari", "IconCurrencyLari", [["path", { "d": "M18 13a6 6 0 1 0 -6 6", "key": "svg-0" }], ["path", { "d": "M6 19h12", "key": "svg-1" }], ["path", { "d": "M10 5v7", "key": "svg-2" }], ["path", { "d": "M14 12v-7", "key": "svg-3" }]]);

var IconCurrencyLari$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyLari
});

var IconCurrencyLeu = createReactComponent("outline", "currency-leu", "IconCurrencyLeu", [["path", { "d": "M17 18h-7a3 3 0 0 1 -3 -3v-10", "key": "svg-0" }]]);

var IconCurrencyLeu$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyLeu
});

var IconCurrencyLira = createReactComponent("outline", "currency-lira", "IconCurrencyLira", [["path", { "d": "M10 5v15a7 7 0 0 0 7 -7", "key": "svg-0" }], ["path", { "d": "M6 15l8 -4", "key": "svg-1" }], ["path", { "d": "M14 7l-8 4", "key": "svg-2" }]]);

var IconCurrencyLira$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyLira
});

var IconCurrencyLitecoin = createReactComponent("outline", "currency-litecoin", "IconCurrencyLitecoin", [["path", { "d": "M18 19h-8.194a2 2 0 0 1 -1.98 -2.283l1.674 -11.717", "key": "svg-0" }], ["path", { "d": "M14 9l-9 4", "key": "svg-1" }]]);

var IconCurrencyLitecoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyLitecoin
});

var IconCurrencyLyd = createReactComponent("outline", "currency-lyd", "IconCurrencyLyd", [["path", { "d": "M11 15h.01", "key": "svg-0" }], ["path", { "d": "M21 5v10a2 2 0 0 1 -2 2h-2.764a2 2 0 0 1 -1.789 -1.106l-.447 -.894", "key": "svg-1" }], ["path", { "d": "M5 8l2.773 4.687c.427 .697 .234 1.626 -.43 2.075a1.38 1.38 0 0 1 -.773 .238h-2.224a.93 .93 0 0 1 -.673 -.293l-.673 -.707", "key": "svg-2" }]]);

var IconCurrencyLyd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyLyd
});

var IconCurrencyManat = createReactComponent("outline", "currency-manat", "IconCurrencyManat", [["path", { "d": "M7 19v-7a5 5 0 1 1 10 0v7", "key": "svg-0" }], ["path", { "d": "M12 5v14", "key": "svg-1" }]]);

var IconCurrencyManat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyManat
});

var IconCurrencyMonero = createReactComponent("outline", "currency-monero", "IconCurrencyMonero", [["path", { "d": "M3 18h3v-11l6 7l6 -7v11h3", "key": "svg-0" }]]);

var IconCurrencyMonero$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyMonero
});

var IconCurrencyNaira = createReactComponent("outline", "currency-naira", "IconCurrencyNaira", [["path", { "d": "M7 18v-10.948a1.05 1.05 0 0 1 1.968 -.51l6.064 10.916a1.05 1.05 0 0 0 1.968 -.51v-10.948", "key": "svg-0" }], ["path", { "d": "M5 10h14", "key": "svg-1" }], ["path", { "d": "M5 14h14", "key": "svg-2" }]]);

var IconCurrencyNaira$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyNaira
});

var IconCurrencyNano = createReactComponent("outline", "currency-nano", "IconCurrencyNano", [["path", { "d": "M7 20l10 -16", "key": "svg-0" }], ["path", { "d": "M7 12h10", "key": "svg-1" }], ["path", { "d": "M7 16h10", "key": "svg-2" }], ["path", { "d": "M17 20l-10 -16", "key": "svg-3" }]]);

var IconCurrencyNano$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyNano
});

var IconCurrencyOff = createReactComponent("outline", "currency-off", "IconCurrencyOff", [["path", { "d": "M18.531 14.524a7 7 0 0 0 -9.06 -9.053m-2.422 1.582a7 7 0 0 0 9.903 9.896", "key": "svg-0" }], ["path", { "d": "M4 4l3 3", "key": "svg-1" }], ["path", { "d": "M20 4l-3 3", "key": "svg-2" }], ["path", { "d": "M4 20l3 -3", "key": "svg-3" }], ["path", { "d": "M20 20l-3 -3", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconCurrencyOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyOff
});

var IconCurrencyPaanga = createReactComponent("outline", "currency-paanga", "IconCurrencyPaanga", [["path", { "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4", "key": "svg-0" }], ["path", { "d": "M17 20v-2", "key": "svg-1" }], ["path", { "d": "M18 6v-2", "key": "svg-2" }], ["path", { "d": "M3 6h8", "key": "svg-3" }], ["path", { "d": "M7 6v12", "key": "svg-4" }]]);

var IconCurrencyPaanga$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyPaanga
});

var IconCurrencyPeso = createReactComponent("outline", "currency-peso", "IconCurrencyPeso", [["path", { "d": "M8 19v-14h3.5a4.5 4.5 0 1 1 0 9h-3.5", "key": "svg-0" }], ["path", { "d": "M18 8h-12", "key": "svg-1" }], ["path", { "d": "M18 11h-12", "key": "svg-2" }]]);

var IconCurrencyPeso$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyPeso
});

var IconCurrencyPoundOff = createReactComponent("outline", "currency-pound-off", "IconCurrencyPoundOff", [["path", { "d": "M17 18.5a6 6 0 0 1 -5 0a6 6 0 0 0 -5 .5a3 3 0 0 0 2 -2.5v-7.5m1.192 -2.825a4 4 0 0 1 6.258 .825m-3.45 6h-6", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconCurrencyPoundOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyPoundOff
});

var IconCurrencyPound = createReactComponent("outline", "currency-pound", "IconCurrencyPound", [["path", { "d": "M17 18.5a6 6 0 0 1 -5 0a6 6 0 0 0 -5 .5a3 3 0 0 0 2 -2.5v-7.5a4 4 0 0 1 7.45 -2m-2.55 6h-7", "key": "svg-0" }]]);

var IconCurrencyPound$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyPound
});

var IconCurrencyQuetzal = createReactComponent("outline", "currency-quetzal", "IconCurrencyQuetzal", [["path", { "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-0" }], ["path", { "d": "M13 13l5 5", "key": "svg-1" }]]);

var IconCurrencyQuetzal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyQuetzal
});

var IconCurrencyReal = createReactComponent("outline", "currency-real", "IconCurrencyReal", [["path", { "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4", "key": "svg-0" }], ["path", { "d": "M4 18v-12h3a3 3 0 1 1 0 6h-3c5.5 0 5 4 6 6", "key": "svg-1" }], ["path", { "d": "M18 6v-2", "key": "svg-2" }], ["path", { "d": "M17 20v-2", "key": "svg-3" }]]);

var IconCurrencyReal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyReal
});

var IconCurrencyRenminbi = createReactComponent("outline", "currency-renminbi", "IconCurrencyRenminbi", [["path", { "d": "M15 9v8a2 2 0 1 0 4 0", "key": "svg-0" }], ["path", { "d": "M19 9h-14", "key": "svg-1" }], ["path", { "d": "M19 5h-14", "key": "svg-2" }], ["path", { "d": "M9 9v4c0 2.5 -.667 4 -2 6", "key": "svg-3" }]]);

var IconCurrencyRenminbi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyRenminbi
});

var IconCurrencyRipple = createReactComponent("outline", "currency-ripple", "IconCurrencyRipple", [["path", { "d": "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M10 12h3l2 -2.5", "key": "svg-3" }], ["path", { "d": "M15 14.5l-2 -2.5", "key": "svg-4" }]]);

var IconCurrencyRipple$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyRipple
});

var IconCurrencyRiyal = createReactComponent("outline", "currency-riyal", "IconCurrencyRiyal", [["path", { "d": "M15 9v2a2 2 0 1 1 -4 0v-1v1a2 2 0 1 1 -4 0v-1v4a2 2 0 1 1 -4 0v-2", "key": "svg-0" }], ["path", { "d": "M18 12.01v-.01", "key": "svg-1" }], ["path", { "d": "M22 10v1a5 5 0 0 1 -5 5", "key": "svg-2" }]]);

var IconCurrencyRiyal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyRiyal
});

var IconCurrencyRubel = createReactComponent("outline", "currency-rubel", "IconCurrencyRubel", [["path", { "d": "M8 19v-14h6a3 3 0 0 1 0 6h-8", "key": "svg-0" }], ["path", { "d": "M14 15h-8", "key": "svg-1" }]]);

var IconCurrencyRubel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyRubel
});

var IconCurrencyRufiyaa = createReactComponent("outline", "currency-rufiyaa", "IconCurrencyRufiyaa", [["path", { "d": "M20 16h.01", "key": "svg-0" }], ["path", { "d": "M4 16c9.5 -4 11.5 -8 14 -9", "key": "svg-1" }], ["path", { "d": "M12 8l5 3", "key": "svg-2" }]]);

var IconCurrencyRufiyaa$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyRufiyaa
});

var IconCurrencyRupeeNepalese = createReactComponent("outline", "currency-rupee-nepalese", "IconCurrencyRupeeNepalese", [["path", { "d": "M15 5h-11h3a4 4 0 1 1 0 8h-3l6 6", "key": "svg-0" }], ["path", { "d": "M21 17l-4.586 -4.414a2 2 0 0 0 -2.828 2.828l.707 .707", "key": "svg-1" }]]);

var IconCurrencyRupeeNepalese$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyRupeeNepalese
});

var IconCurrencyRupee = createReactComponent("outline", "currency-rupee", "IconCurrencyRupee", [["path", { "d": "M18 5h-11h3a4 4 0 0 1 0 8h-3l6 6", "key": "svg-0" }], ["path", { "d": "M7 9l11 0", "key": "svg-1" }]]);

var IconCurrencyRupee$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyRupee
});

var IconCurrencyShekel = createReactComponent("outline", "currency-shekel", "IconCurrencyShekel", [["path", { "d": "M6 18v-12h4a4 4 0 0 1 4 4v4", "key": "svg-0" }], ["path", { "d": "M18 6v12h-4a4 4 0 0 1 -4 -4v-4", "key": "svg-1" }]]);

var IconCurrencyShekel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyShekel
});

var IconCurrencySolana = createReactComponent("outline", "currency-solana", "IconCurrencySolana", [["path", { "d": "M4 18h12l4 -4h-12z", "key": "svg-0" }], ["path", { "d": "M8 14l-4 -4h12l4 4", "key": "svg-1" }], ["path", { "d": "M16 10l4 -4h-12l-4 4", "key": "svg-2" }]]);

var IconCurrencySolana$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencySolana
});

var IconCurrencySom = createReactComponent("outline", "currency-som", "IconCurrencySom", [["path", { "d": "M10 18v-12h-5v10a2 2 0 0 1 -2 2", "key": "svg-0" }], ["path", { "d": "M14 6v12h4a3 3 0 0 0 0 -6h-4h4a3 3 0 0 0 0 -6h-4z", "key": "svg-1" }]]);

var IconCurrencySom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencySom
});

var IconCurrencyTaka = createReactComponent("outline", "currency-taka", "IconCurrencyTaka", [["path", { "d": "M16.5 15.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M7 7a2 2 0 1 1 4 0v9a3 3 0 0 0 6 0v-.5", "key": "svg-1" }], ["path", { "d": "M8 11h6", "key": "svg-2" }]]);

var IconCurrencyTaka$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyTaka
});

var IconCurrencyTenge = createReactComponent("outline", "currency-tenge", "IconCurrencyTenge", [["path", { "d": "M6 5h12", "key": "svg-0" }], ["path", { "d": "M6 9h12", "key": "svg-1" }], ["path", { "d": "M12 9v10", "key": "svg-2" }]]);

var IconCurrencyTenge$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyTenge
});

var IconCurrencyTugrik = createReactComponent("outline", "currency-tugrik", "IconCurrencyTugrik", [["path", { "d": "M7 6h10", "key": "svg-0" }], ["path", { "d": "M12 6v13", "key": "svg-1" }], ["path", { "d": "M8 17l8 -3", "key": "svg-2" }], ["path", { "d": "M16 10l-8 3", "key": "svg-3" }]]);

var IconCurrencyTugrik$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyTugrik
});

var IconCurrencyWon = createReactComponent("outline", "currency-won", "IconCurrencyWon", [["path", { "d": "M4 6l3.245 11.358a.85 .85 0 0 0 1.624 .035l3.131 -9.393l3.131 9.393a.85 .85 0 0 0 1.624 -.035l3.245 -11.358", "key": "svg-0" }], ["path", { "d": "M21 10h-18", "key": "svg-1" }], ["path", { "d": "M21 14h-18", "key": "svg-2" }]]);

var IconCurrencyWon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyWon
});

var IconCurrencyXrp = createReactComponent("outline", "currency-xrp", "IconCurrencyXrp", [["path", { "d": "M5 5l3.585 3.585a4.83 4.83 0 0 0 6.83 0l3.585 -3.585", "key": "svg-0" }], ["path", { "d": "M5 19l3.585 -3.585a4.83 4.83 0 0 1 6.83 0l3.585 3.584", "key": "svg-1" }]]);

var IconCurrencyXrp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyXrp
});

var IconCurrencyYenOff = createReactComponent("outline", "currency-yen-off", "IconCurrencyYenOff", [["path", { "d": "M12 19v-7m5 -7l-3.328 4.66", "key": "svg-0" }], ["path", { "d": "M8 17h8", "key": "svg-1" }], ["path", { "d": "M8 13h5", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconCurrencyYenOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyYenOff
});

var IconCurrencyYen = createReactComponent("outline", "currency-yen", "IconCurrencyYen", [["path", { "d": "M12 19v-7l-5 -7m10 0l-5 7", "key": "svg-0" }], ["path", { "d": "M8 17l8 0", "key": "svg-1" }], ["path", { "d": "M8 13l8 0", "key": "svg-2" }]]);

var IconCurrencyYen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyYen
});

var IconCurrencyYuan = createReactComponent("outline", "currency-yuan", "IconCurrencyYuan", [["path", { "d": "M12 19v-7l-5 -7", "key": "svg-0" }], ["path", { "d": "M17 5l-5 7", "key": "svg-1" }], ["path", { "d": "M8 13h8", "key": "svg-2" }]]);

var IconCurrencyYuan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyYuan
});

var IconCurrencyZloty = createReactComponent("outline", "currency-zloty", "IconCurrencyZloty", [["path", { "d": "M12 18h-7l7 -7h-7", "key": "svg-0" }], ["path", { "d": "M17 18v-13", "key": "svg-1" }], ["path", { "d": "M14 14.5l6 -3.5", "key": "svg-2" }]]);

var IconCurrencyZloty$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrencyZloty
});

var IconCurrency = createReactComponent("outline", "currency", "IconCurrency", [["path", { "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M4 4l3 3", "key": "svg-1" }], ["path", { "d": "M20 4l-3 3", "key": "svg-2" }], ["path", { "d": "M4 20l3 -3", "key": "svg-3" }], ["path", { "d": "M20 20l-3 -3", "key": "svg-4" }]]);

var IconCurrency$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrency
});

var IconCurrentLocationOff = createReactComponent("outline", "current-location-off", "IconCurrentLocationOff", [["path", { "d": "M14.685 10.661c-.3 -.6 -.795 -1.086 -1.402 -1.374m-3.397 .584a3 3 0 1 0 4.24 4.245", "key": "svg-0" }], ["path", { "d": "M6.357 6.33a8 8 0 1 0 11.301 11.326m1.642 -2.378a8 8 0 0 0 -10.597 -10.569", "key": "svg-1" }], ["path", { "d": "M12 2v2", "key": "svg-2" }], ["path", { "d": "M12 20v2", "key": "svg-3" }], ["path", { "d": "M20 12h2", "key": "svg-4" }], ["path", { "d": "M2 12h2", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconCurrentLocationOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrentLocationOff
});

var IconCurrentLocation = createReactComponent("outline", "current-location", "IconCurrentLocation", [["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0", "key": "svg-1" }], ["path", { "d": "M12 2l0 2", "key": "svg-2" }], ["path", { "d": "M12 20l0 2", "key": "svg-3" }], ["path", { "d": "M20 12l2 0", "key": "svg-4" }], ["path", { "d": "M2 12l2 0", "key": "svg-5" }]]);

var IconCurrentLocation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrentLocation
});

var IconCursorOff = createReactComponent("outline", "cursor-off", "IconCursorOff", [["path", { "d": "M9 4a3 3 0 0 1 3 3v1m0 9a3 3 0 0 1 -3 3", "key": "svg-0" }], ["path", { "d": "M15 4a3 3 0 0 0 -3 3v1m0 4v5a3 3 0 0 0 3 3", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconCursorOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCursorOff
});

var IconCursorText = createReactComponent("outline", "cursor-text", "IconCursorText", [["path", { "d": "M10 12h4", "key": "svg-0" }], ["path", { "d": "M9 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3", "key": "svg-1" }], ["path", { "d": "M15 4a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3", "key": "svg-2" }]]);

var IconCursorText$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCursorText
});

var IconCut = createReactComponent("outline", "cut", "IconCut", [["path", { "d": "M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M9.15 14.85l8.85 -10.85", "key": "svg-2" }], ["path", { "d": "M6 4l8.85 10.85", "key": "svg-3" }]]);

var IconCut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCut
});

var IconCylinderOff = createReactComponent("outline", "cylinder-off", "IconCylinderOff", [["path", { "d": "M5.23 5.233c-.15 .245 -.23 .502 -.23 .767c0 1.131 1.461 2.117 3.62 2.628m4.357 .343c3.404 -.204 6.023 -1.456 6.023 -2.971c0 -1.657 -3.134 -3 -7 -3c-1.645 0 -3.158 .243 -4.353 .65", "key": "svg-0" }], ["path", { "d": "M5 6v12c0 1.657 3.134 3 7 3c3.245 0 5.974 -.946 6.767 -2.23m.233 -3.77v-9", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconCylinderOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCylinderOff
});

var IconCylinderPlus = createReactComponent("outline", "cylinder-plus", "IconCylinderPlus", [["path", { "d": "M12 6m-7 0a7 3 0 1 0 14 0a7 3 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M5 6v12c0 1.657 3.134 3 7 3c.173 0 .345 -.003 .515 -.008m6.485 -8.992v-6", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconCylinderPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCylinderPlus
});

var IconCylinder = createReactComponent("outline", "cylinder", "IconCylinder", [["path", { "d": "M12 6m-7 0a7 3 0 1 0 14 0a7 3 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M5 6v12c0 1.657 3.134 3 7 3s7 -1.343 7 -3v-12", "key": "svg-1" }]]);

var IconCylinder$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCylinder
});

var IconDashboardOff = createReactComponent("outline", "dashboard-off", "IconDashboardOff", [["path", { "d": "M11.175 11.178a2 2 0 1 0 2.653 2.634", "key": "svg-0" }], ["path", { "d": "M14.5 10.5l1 -1", "key": "svg-1" }], ["path", { "d": "M8.621 4.612a9 9 0 0 1 11.721 11.72m-1.516 2.488a9.008 9.008 0 0 1 -1.226 1.18h-11.2a9 9 0 0 1 -.268 -13.87", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconDashboardOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDashboardOff
});

var IconDashboard = createReactComponent("outline", "dashboard", "IconDashboard", [["path", { "d": "M12 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13.45 11.55l2.05 -2.05", "key": "svg-1" }], ["path", { "d": "M6.4 20a9 9 0 1 1 11.2 0z", "key": "svg-2" }]]);

var IconDashboard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDashboard
});

var IconDatabaseCog = createReactComponent("outline", "database-cog", "IconDatabaseCog", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.657 3.582 3 8 3c.21 0 .42 -.003 .626 -.01", "key": "svg-1" }], ["path", { "d": "M20 11.5v-5.5", "key": "svg-2" }], ["path", { "d": "M4 12v6c0 1.657 3.582 3 8 3", "key": "svg-3" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-5" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-6" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-7" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-8" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-9" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-10" }]]);

var IconDatabaseCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseCog
});

var IconDatabaseDollar = createReactComponent("outline", "database-dollar", "IconDatabaseDollar", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.657 3.582 3 8 3c.415 0 .822 -.012 1.22 -.035", "key": "svg-1" }], ["path", { "d": "M20 10v-4", "key": "svg-2" }], ["path", { "d": "M4 12v6c0 1.657 3.582 3 8 3c.352 0 .698 -.009 1.037 -.025", "key": "svg-3" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-4" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-5" }]]);

var IconDatabaseDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseDollar
});

var IconDatabaseEdit = createReactComponent("outline", "database-edit", "IconDatabaseEdit", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.657 3.582 3 8 3c.478 0 .947 -.016 1.402 -.046", "key": "svg-1" }], ["path", { "d": "M20 12v-6", "key": "svg-2" }], ["path", { "d": "M4 12v6c0 1.526 3.04 2.786 6.972 2.975", "key": "svg-3" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z", "key": "svg-4" }]]);

var IconDatabaseEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseEdit
});

var IconDatabaseExclamation = createReactComponent("outline", "database-exclamation", "IconDatabaseExclamation", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.657 3.582 3 8 3c1.118 0 2.182 -.086 3.148 -.241m4.852 -2.759v-6", "key": "svg-1" }], ["path", { "d": "M4 12v6c0 1.657 3.582 3 8 3c1.064 0 2.079 -.078 3.007 -.22", "key": "svg-2" }], ["path", { "d": "M19 16v3", "key": "svg-3" }], ["path", { "d": "M19 22v.01", "key": "svg-4" }]]);

var IconDatabaseExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseExclamation
});

var IconDatabaseExport = createReactComponent("outline", "database-export", "IconDatabaseExport", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.657 3.582 3 8 3c1.118 0 2.183 -.086 3.15 -.241", "key": "svg-1" }], ["path", { "d": "M20 12v-6", "key": "svg-2" }], ["path", { "d": "M4 12v6c0 1.657 3.582 3 8 3c.157 0 .312 -.002 .466 -.005", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16l3 3l-3 3", "key": "svg-5" }]]);

var IconDatabaseExport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseExport
});

var IconDatabaseHeart = createReactComponent("outline", "database-heart", "IconDatabaseHeart", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.453 2.755 2.665 6.414 2.941", "key": "svg-1" }], ["path", { "d": "M20 11v-5", "key": "svg-2" }], ["path", { "d": "M4 12v6c0 1.579 3.253 2.873 7.383 2.991", "key": "svg-3" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-4" }]]);

var IconDatabaseHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseHeart
});

var IconDatabaseImport = createReactComponent("outline", "database-import", "IconDatabaseImport", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.657 3.582 3 8 3c.856 0 1.68 -.05 2.454 -.144m5.546 -2.856v-6", "key": "svg-1" }], ["path", { "d": "M4 12v6c0 1.657 3.582 3 8 3c.171 0 .341 -.002 .51 -.006", "key": "svg-2" }], ["path", { "d": "M19 22v-6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-4" }]]);

var IconDatabaseImport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseImport
});

var IconDatabaseLeak = createReactComponent("outline", "database-leak", "IconDatabaseLeak", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v12c0 1.657 3.582 3 8 3s8 -1.343 8 -3v-12", "key": "svg-1" }], ["path", { "d": "M4 15a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1", "key": "svg-2" }]]);

var IconDatabaseLeak$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseLeak
});

var IconDatabaseMinus = createReactComponent("outline", "database-minus", "IconDatabaseMinus", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.657 3.582 3 8 3s8 -1.343 8 -3v-6", "key": "svg-1" }], ["path", { "d": "M4 12v6c0 1.657 3.582 3 8 3c.164 0 .328 -.002 .49 -.006", "key": "svg-2" }], ["path", { "d": "M20 15v-3", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }]]);

var IconDatabaseMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseMinus
});

var IconDatabaseOff = createReactComponent("outline", "database-off", "IconDatabaseOff", [["path", { "d": "M12.983 8.978c3.955 -.182 7.017 -1.446 7.017 -2.978c0 -1.657 -3.582 -3 -8 -3c-1.661 0 -3.204 .19 -4.483 .515m-2.783 1.228c-.471 .382 -.734 .808 -.734 1.257c0 1.22 1.944 2.271 4.734 2.74", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.657 3.582 3 8 3c.986 0 1.93 -.067 2.802 -.19m3.187 -.82c1.251 -.53 2.011 -1.228 2.011 -1.99v-6", "key": "svg-1" }], ["path", { "d": "M4 12v6c0 1.657 3.582 3 8 3c3.217 0 5.991 -.712 7.261 -1.74m.739 -3.26v-4", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconDatabaseOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseOff
});

var IconDatabasePlus = createReactComponent("outline", "database-plus", "IconDatabasePlus", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.657 3.582 3 8 3c1.075 0 2.1 -.08 3.037 -.224", "key": "svg-1" }], ["path", { "d": "M20 12v-6", "key": "svg-2" }], ["path", { "d": "M4 12v6c0 1.657 3.582 3 8 3c.166 0 .331 -.002 .495 -.006", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16v6", "key": "svg-5" }]]);

var IconDatabasePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabasePlus
});

var IconDatabaseSearch = createReactComponent("outline", "database-search", "IconDatabaseSearch", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.657 3.582 3 8 3m8 -3.5v-5.5", "key": "svg-1" }], ["path", { "d": "M4 12v6c0 1.657 3.582 3 8 3", "key": "svg-2" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-4" }]]);

var IconDatabaseSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseSearch
});

var IconDatabaseShare = createReactComponent("outline", "database-share", "IconDatabaseShare", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.657 3.582 3 8 3c.361 0 .716 -.009 1.065 -.026", "key": "svg-1" }], ["path", { "d": "M20 13v-7", "key": "svg-2" }], ["path", { "d": "M4 12v6c0 1.657 3.582 3 8 3", "key": "svg-3" }], ["path", { "d": "M16 22l5 -5", "key": "svg-4" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-5" }]]);

var IconDatabaseShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseShare
});

var IconDatabaseSmile = createReactComponent("outline", "database-smile", "IconDatabaseSmile", [["path", { "d": "M10 14h.01", "key": "svg-0" }], ["path", { "d": "M14 14h.01", "key": "svg-1" }], ["path", { "d": "M10 17a3.5 3.5 0 0 0 4 0", "key": "svg-2" }], ["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-3" }], ["path", { "d": "M4 6v12c0 1.657 3.582 3 8 3s8 -1.343 8 -3v-12", "key": "svg-4" }]]);

var IconDatabaseSmile$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseSmile
});

var IconDatabaseStar = createReactComponent("outline", "database-star", "IconDatabaseStar", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.43 2.67 2.627 6.243 2.927", "key": "svg-1" }], ["path", { "d": "M20 10.5v-4.5", "key": "svg-2" }], ["path", { "d": "M4 12v6c0 1.546 3.12 2.82 7.128 2.982", "key": "svg-3" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-4" }]]);

var IconDatabaseStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseStar
});

var IconDatabaseX = createReactComponent("outline", "database-x", "IconDatabaseX", [["path", { "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3", "key": "svg-0" }], ["path", { "d": "M4 6v6c0 1.657 3.582 3 8 3c.537 0 1.062 -.02 1.57 -.058", "key": "svg-1" }], ["path", { "d": "M20 13.5v-7.5", "key": "svg-2" }], ["path", { "d": "M4 12v6c0 1.657 3.582 3 8 3c.384 0 .762 -.01 1.132 -.03", "key": "svg-3" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-4" }], ["path", { "d": "M17 22l5 -5", "key": "svg-5" }]]);

var IconDatabaseX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabaseX
});

var IconDatabase = createReactComponent("outline", "database", "IconDatabase", [["path", { "d": "M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0", "key": "svg-0" }], ["path", { "d": "M4 6v6a8 3 0 0 0 16 0v-6", "key": "svg-1" }], ["path", { "d": "M4 12v6a8 3 0 0 0 16 0v-6", "key": "svg-2" }]]);

var IconDatabase$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDatabase
});

var IconDecimal = createReactComponent("outline", "decimal", "IconDecimal", [["path", { "d": "M17 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-1" }], ["path", { "d": "M5 16h.01", "key": "svg-2" }]]);

var IconDecimal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDecimal
});

var IconDeer = createReactComponent("outline", "deer", "IconDeer", [["path", { "d": "M3 3c0 2 1 3 4 3c2 0 3 1 3 3", "key": "svg-0" }], ["path", { "d": "M21 3c0 2 -1 3 -4 3c-2 0 -3 .333 -3 3", "key": "svg-1" }], ["path", { "d": "M12 18c-1 0 -4 -3 -4 -6c0 -2 1.333 -3 4 -3s4 1 4 3c0 3 -3 6 -4 6", "key": "svg-2" }], ["path", { "d": "M15.185 14.889l.095 -.18a4 4 0 1 1 -6.56 0", "key": "svg-3" }], ["path", { "d": "M17 3c0 1.333 -.333 2.333 -1 3", "key": "svg-4" }], ["path", { "d": "M7 3c0 1.333 .333 2.333 1 3", "key": "svg-5" }], ["path", { "d": "M7 6c-2.667 .667 -4.333 1.667 -5 3", "key": "svg-6" }], ["path", { "d": "M17 6c2.667 .667 4.333 1.667 5 3", "key": "svg-7" }], ["path", { "d": "M8.5 10l-1.5 -1", "key": "svg-8" }], ["path", { "d": "M15.5 10l1.5 -1", "key": "svg-9" }], ["path", { "d": "M12 15h.01", "key": "svg-10" }]]);

var IconDeer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeer
});

var IconDelta = createReactComponent("outline", "delta", "IconDelta", [["path", { "d": "M4 20h16l-8 -16z", "key": "svg-0" }]]);

var IconDelta$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDelta
});

var IconDentalBroken = createReactComponent("outline", "dental-broken", "IconDentalBroken", [["path", { "d": "M12 5.5c-1.074 -.586 -2.583 -1.5 -4 -1.5c-2.1 0 -4 1.247 -4 5c0 4.899 1.056 8.41 2.671 10.537c.573 .756 1.97 .521 2.567 -.236c.398 -.505 .819 -1.439 1.262 -2.801c.292 -.771 .892 -1.504 1.5 -1.5c.602 0 1.21 .737 1.5 1.5c.443 1.362 .864 2.295 1.262 2.8c.597 .759 2 .993 2.567 .237c1.615 -2.127 2.671 -5.637 2.671 -10.537c0 -3.74 -1.908 -5 -4 -5c-1.423 0 -2.92 .911 -4 1.5z", "key": "svg-0" }], ["path", { "d": "M12 5.5l1 2.5l-2 2l2 2", "key": "svg-1" }]]);

var IconDentalBroken$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDentalBroken
});

var IconDentalOff = createReactComponent("outline", "dental-off", "IconDentalOff", [["path", { "d": "M19.277 15.281c.463 -1.75 .723 -3.844 .723 -6.281c0 -3.74 -1.908 -5 -4 -5c-1.423 0 -2.92 .911 -4 1.5c-1.074 -.586 -2.583 -1.5 -4 -1.5m-2.843 1.153c-.707 .784 -1.157 2.017 -1.157 3.847c0 4.899 1.056 8.41 2.671 10.537c.573 .756 1.97 .521 2.567 -.236c.398 -.505 .819 -1.439 1.262 -2.801c.292 -.771 .892 -1.504 1.5 -1.5c.602 0 1.21 .737 1.5 1.5c.443 1.362 .864 2.295 1.262 2.8c.597 .759 2 .993 2.567 .237c.305 -.402 .59 -.853 .852 -1.353", "key": "svg-0" }], ["path", { "d": "M12 5.5l3 1.5", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconDentalOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDentalOff
});

var IconDental = createReactComponent("outline", "dental", "IconDental", [["path", { "d": "M12 5.5c-1.074 -.586 -2.583 -1.5 -4 -1.5c-2.1 0 -4 1.247 -4 5c0 4.899 1.056 8.41 2.671 10.537c.573 .756 1.97 .521 2.567 -.236c.398 -.505 .819 -1.439 1.262 -2.801c.292 -.771 .892 -1.504 1.5 -1.5c.602 0 1.21 .737 1.5 1.5c.443 1.362 .864 2.295 1.262 2.8c.597 .759 2 .993 2.567 .237c1.615 -2.127 2.671 -5.637 2.671 -10.537c0 -3.74 -1.908 -5 -4 -5c-1.423 0 -2.92 .911 -4 1.5z", "key": "svg-0" }], ["path", { "d": "M12 5.5l3 1.5", "key": "svg-1" }]]);

var IconDental$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDental
});

var IconDeselect = createReactComponent("outline", "deselect", "IconDeselect", [["path", { "d": "M12 8h3a1 1 0 0 1 1 1v3", "key": "svg-0" }], ["path", { "d": "M16 16h-7a1 1 0 0 1 -1 -1v-7", "key": "svg-1" }], ["path", { "d": "M12 20v.01", "key": "svg-2" }], ["path", { "d": "M16 20v.01", "key": "svg-3" }], ["path", { "d": "M8 20v.01", "key": "svg-4" }], ["path", { "d": "M4 20v.01", "key": "svg-5" }], ["path", { "d": "M4 16v.01", "key": "svg-6" }], ["path", { "d": "M4 12v.01", "key": "svg-7" }], ["path", { "d": "M4 8v.01", "key": "svg-8" }], ["path", { "d": "M8 4v.01", "key": "svg-9" }], ["path", { "d": "M12 4v.01", "key": "svg-10" }], ["path", { "d": "M16 4v.01", "key": "svg-11" }], ["path", { "d": "M20 4v.01", "key": "svg-12" }], ["path", { "d": "M20 8v.01", "key": "svg-13" }], ["path", { "d": "M20 12v.01", "key": "svg-14" }], ["path", { "d": "M20 16v.01", "key": "svg-15" }], ["path", { "d": "M3 3l18 18", "key": "svg-16" }]]);

var IconDeselect$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeselect
});

var IconDesk = createReactComponent("outline", "desk", "IconDesk", [["path", { "d": "M3 6h18", "key": "svg-0" }], ["path", { "d": "M4 6v13", "key": "svg-1" }], ["path", { "d": "M20 19v-13", "key": "svg-2" }], ["path", { "d": "M4 10h16", "key": "svg-3" }], ["path", { "d": "M15 6v8a2 2 0 0 0 2 2h3", "key": "svg-4" }]]);

var IconDesk$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDesk
});

var IconDetailsOff = createReactComponent("outline", "details-off", "IconDetailsOff", [["path", { "d": "M5 19h14", "key": "svg-0" }], ["path", { "d": "M20.986 16.984a2 2 0 0 0 -.146 -.734l-7.1 -12.25a2 2 0 0 0 -3.5 0l-.821 1.417m-1.469 2.534l-4.81 8.299a2 2 0 0 0 1.75 2.75", "key": "svg-1" }], ["path", { "d": "M12 3v5m0 4v7", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconDetailsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDetailsOff
});

var IconDetails = createReactComponent("outline", "details", "IconDetails", [["path", { "d": "M11.999 3l.001 17", "key": "svg-0" }], ["path", { "d": "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z", "key": "svg-1" }]]);

var IconDetails$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDetails
});

var IconDeviceAirpodsCase = createReactComponent("outline", "device-airpods-case", "IconDeviceAirpodsCase", [["path", { "d": "M21 10h-18", "key": "svg-0" }], ["path", { "d": "M3 4m0 4a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4z", "key": "svg-1" }], ["path", { "d": "M7 10v1.5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5 -1.5v-1.5", "key": "svg-2" }]]);

var IconDeviceAirpodsCase$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceAirpodsCase
});

var IconDeviceAirpods = createReactComponent("outline", "device-airpods", "IconDeviceAirpods", [["path", { "d": "M6 4a4 4 0 0 1 4 3.8l0 .2v10.5a1.5 1.5 0 0 1 -3 0v-6.5h-1a4 4 0 0 1 -4 -3.8l0 -.2a4 4 0 0 1 4 -4z", "key": "svg-0" }], ["path", { "d": "M18 4a4 4 0 0 0 -4 3.8l0 .2v10.5a1.5 1.5 0 0 0 3 0v-6.5h1a4 4 0 0 0 4 -3.8l0 -.2a4 4 0 0 0 -4 -4z", "key": "svg-1" }]]);

var IconDeviceAirpods$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceAirpods
});

var IconDeviceAirtag = createReactComponent("outline", "device-airtag", "IconDeviceAirtag", [["path", { "d": "M4 12a8 8 0 1 0 16 0a8 8 0 0 0 -16 0", "key": "svg-0" }], ["path", { "d": "M9 15v.01", "key": "svg-1" }], ["path", { "d": "M15 15a6 6 0 0 0 -6 -6", "key": "svg-2" }], ["path", { "d": "M12 15a3 3 0 0 0 -3 -3", "key": "svg-3" }]]);

var IconDeviceAirtag$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceAirtag
});

var IconDeviceAnalytics = createReactComponent("outline", "device-analytics", "IconDeviceAnalytics", [["path", { "d": "M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M7 20l10 0", "key": "svg-1" }], ["path", { "d": "M9 16l0 4", "key": "svg-2" }], ["path", { "d": "M15 16l0 4", "key": "svg-3" }], ["path", { "d": "M8 12l3 -3l2 2l3 -3", "key": "svg-4" }]]);

var IconDeviceAnalytics$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceAnalytics
});

var IconDeviceAudioTape = createReactComponent("outline", "device-audio-tape", "IconDeviceAudioTape", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M3 17l4 -3h10l4 3", "key": "svg-1" }], ["circle", { "cx": "7.5", "cy": "9.5", "r": ".5", "fill": "currentColor", "key": "svg-2" }], ["circle", { "cx": "16.5", "cy": "9.5", "r": ".5", "fill": "currentColor", "key": "svg-3" }]]);

var IconDeviceAudioTape$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceAudioTape
});

var IconDeviceCameraPhone = createReactComponent("outline", "device-camera-phone", "IconDeviceCameraPhone", [["path", { "d": "M18.5 8.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-0" }], ["path", { "d": "M13 7h-8a2 2 0 0 0 -2 2v7a2 2 0 0 0 2 2h13a2 2 0 0 0 2 -2v-2", "key": "svg-1" }], ["path", { "d": "M17 15v-1", "key": "svg-2" }]]);

var IconDeviceCameraPhone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceCameraPhone
});

var IconDeviceCctvOff = createReactComponent("outline", "device-cctv-off", "IconDeviceCctvOff", [["path", { "d": "M7 7h-3a1 1 0 0 1 -1 -1v-2c0 -.275 .11 -.523 .29 -.704m3.71 -.296h13a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-9", "key": "svg-0" }], ["path", { "d": "M10.36 10.35a4 4 0 1 0 5.285 5.3", "key": "svg-1" }], ["path", { "d": "M19 7v7c0 .321 -.022 .637 -.064 .947m-1.095 2.913a7 7 0 0 1 -12.841 -3.86l0 -7", "key": "svg-2" }], ["path", { "d": "M12 14h.01", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconDeviceCctvOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceCctvOff
});

var IconDeviceCctv = createReactComponent("outline", "device-cctv", "IconDeviceCctv", [["path", { "d": "M3 3m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M12 14m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-1" }], ["path", { "d": "M19 7v7a7 7 0 0 1 -14 0v-7", "key": "svg-2" }], ["path", { "d": "M12 14l.01 0", "key": "svg-3" }]]);

var IconDeviceCctv$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceCctv
});

var IconDeviceComputerCameraOff = createReactComponent("outline", "device-computer-camera-off", "IconDeviceComputerCameraOff", [["path", { "d": "M6.15 6.153a7 7 0 0 0 9.696 9.696m2 -2a7 7 0 0 0 -9.699 -9.695", "key": "svg-0" }], ["path", { "d": "M9.13 9.122a3 3 0 0 0 3.743 3.749m2 -2a3 3 0 0 0 -3.737 -3.736", "key": "svg-1" }], ["path", { "d": "M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconDeviceComputerCameraOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceComputerCameraOff
});

var IconDeviceComputerCamera = createReactComponent("outline", "device-computer-camera", "IconDeviceComputerCamera", [["path", { "d": "M12 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486", "key": "svg-2" }]]);

var IconDeviceComputerCamera$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceComputerCamera
});

var IconDeviceDesktopAnalytics = createReactComponent("outline", "device-desktop-analytics", "IconDeviceDesktopAnalytics", [["path", { "d": "M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M7 20h10", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M15 16v4", "key": "svg-3" }], ["path", { "d": "M9 12v-4", "key": "svg-4" }], ["path", { "d": "M12 12v-1", "key": "svg-5" }], ["path", { "d": "M15 12v-2", "key": "svg-6" }], ["path", { "d": "M12 12v-1", "key": "svg-7" }]]);

var IconDeviceDesktopAnalytics$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopAnalytics
});

var IconDeviceDesktopBolt = createReactComponent("outline", "device-desktop-bolt", "IconDeviceDesktopBolt", [["path", { "d": "M14.5 16h-10.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5", "key": "svg-0" }], ["path", { "d": "M7 20h6", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-3" }]]);

var IconDeviceDesktopBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopBolt
});

var IconDeviceDesktopCancel = createReactComponent("outline", "device-desktop-cancel", "IconDeviceDesktopCancel", [["path", { "d": "M12.5 16h-8.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5", "key": "svg-0" }], ["path", { "d": "M7 20h5", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M17 21l4 -4", "key": "svg-4" }]]);

var IconDeviceDesktopCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopCancel
});

var IconDeviceDesktopCheck = createReactComponent("outline", "device-desktop-check", "IconDeviceDesktopCheck", [["path", { "d": "M12 16h-8a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }], ["path", { "d": "M7 20h4", "key": "svg-2" }], ["path", { "d": "M9 16v4", "key": "svg-3" }]]);

var IconDeviceDesktopCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopCheck
});

var IconDeviceDesktopCode = createReactComponent("outline", "device-desktop-code", "IconDeviceDesktopCode", [["path", { "d": "M12.5 16h-8.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M7 20h4", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-3" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-4" }]]);

var IconDeviceDesktopCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopCode
});

var IconDeviceDesktopCog = createReactComponent("outline", "device-desktop-cog", "IconDeviceDesktopCog", [["path", { "d": "M12 16h-8a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7", "key": "svg-0" }], ["path", { "d": "M7 20h5", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-4" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-5" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-6" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-7" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-8" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-9" }]]);

var IconDeviceDesktopCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopCog
});

var IconDeviceDesktopDollar = createReactComponent("outline", "device-desktop-dollar", "IconDeviceDesktopDollar", [["path", { "d": "M13 16h-9a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v5.5", "key": "svg-0" }], ["path", { "d": "M7 20h6.5", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-4" }]]);

var IconDeviceDesktopDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopDollar
});

var IconDeviceDesktopDown = createReactComponent("outline", "device-desktop-down", "IconDeviceDesktopDown", [["path", { "d": "M13.5 16h-9.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5", "key": "svg-0" }], ["path", { "d": "M7 20h5", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-4" }]]);

var IconDeviceDesktopDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopDown
});

var IconDeviceDesktopExclamation = createReactComponent("outline", "device-desktop-exclamation", "IconDeviceDesktopExclamation", [["path", { "d": "M15 16h-11a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7", "key": "svg-0" }], ["path", { "d": "M7 20h8", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M15 16v4", "key": "svg-3" }], ["path", { "d": "M19 16v3", "key": "svg-4" }], ["path", { "d": "M19 22v.01", "key": "svg-5" }]]);

var IconDeviceDesktopExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopExclamation
});

var IconDeviceDesktopHeart = createReactComponent("outline", "device-desktop-heart", "IconDeviceDesktopHeart", [["path", { "d": "M10 16h-6a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v6", "key": "svg-0" }], ["path", { "d": "M7 20h3.5", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-3" }]]);

var IconDeviceDesktopHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopHeart
});

var IconDeviceDesktopMinus = createReactComponent("outline", "device-desktop-minus", "IconDeviceDesktopMinus", [["path", { "d": "M13.5 16h-9.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10", "key": "svg-0" }], ["path", { "d": "M7 20h5", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconDeviceDesktopMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopMinus
});

var IconDeviceDesktopOff = createReactComponent("outline", "device-desktop-off", "IconDeviceDesktopOff", [["path", { "d": "M8 4h12a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1m-4 0h-12a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1", "key": "svg-0" }], ["path", { "d": "M7 20h10", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M15 16v4", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconDeviceDesktopOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopOff
});

var IconDeviceDesktopPause = createReactComponent("outline", "device-desktop-pause", "IconDeviceDesktopPause", [["path", { "d": "M13 16h-9a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }], ["path", { "d": "M7 20h6", "key": "svg-3" }], ["path", { "d": "M9 16v4", "key": "svg-4" }]]);

var IconDeviceDesktopPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopPause
});

var IconDeviceDesktopPin = createReactComponent("outline", "device-desktop-pin", "IconDeviceDesktopPin", [["path", { "d": "M12.5 16h-8.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v6", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }], ["path", { "d": "M7 20h5", "key": "svg-3" }], ["path", { "d": "M9 16v4", "key": "svg-4" }]]);

var IconDeviceDesktopPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopPin
});

var IconDeviceDesktopPlus = createReactComponent("outline", "device-desktop-plus", "IconDeviceDesktopPlus", [["path", { "d": "M13.5 16h-9.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5", "key": "svg-0" }], ["path", { "d": "M7 20h5", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconDeviceDesktopPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopPlus
});

var IconDeviceDesktopQuestion = createReactComponent("outline", "device-desktop-question", "IconDeviceDesktopQuestion", [["path", { "d": "M13.5 16h-9.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v6.5", "key": "svg-0" }], ["path", { "d": "M7 20h8", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-4" }]]);

var IconDeviceDesktopQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopQuestion
});

var IconDeviceDesktopSearch = createReactComponent("outline", "device-desktop-search", "IconDeviceDesktopSearch", [["path", { "d": "M11.5 16h-7.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v6.5", "key": "svg-0" }], ["path", { "d": "M7 20h4", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-4" }]]);

var IconDeviceDesktopSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopSearch
});

var IconDeviceDesktopShare = createReactComponent("outline", "device-desktop-share", "IconDeviceDesktopShare", [["path", { "d": "M12.5 16h-8.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M7 20h5.5", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M16 22l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-4" }]]);

var IconDeviceDesktopShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopShare
});

var IconDeviceDesktopStar = createReactComponent("outline", "device-desktop-star", "IconDeviceDesktopStar", [["path", { "d": "M10 16h-6a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v6.5", "key": "svg-0" }], ["path", { "d": "M7 20h3.5", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-3" }]]);

var IconDeviceDesktopStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopStar
});

var IconDeviceDesktopUp = createReactComponent("outline", "device-desktop-up", "IconDeviceDesktopUp", [["path", { "d": "M13.5 16h-9.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }], ["path", { "d": "M7 20h5", "key": "svg-3" }], ["path", { "d": "M9 16v4", "key": "svg-4" }]]);

var IconDeviceDesktopUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopUp
});

var IconDeviceDesktopX = createReactComponent("outline", "device-desktop-x", "IconDeviceDesktopX", [["path", { "d": "M13 16h-9a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M7 20h6.5", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-3" }], ["path", { "d": "M17 22l5 -5", "key": "svg-4" }]]);

var IconDeviceDesktopX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopX
});

var IconDeviceDesktop = createReactComponent("outline", "device-desktop", "IconDeviceDesktop", [["path", { "d": "M3 5a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10z", "key": "svg-0" }], ["path", { "d": "M7 20h10", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M15 16v4", "key": "svg-3" }]]);

var IconDeviceDesktop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktop
});

var IconDeviceFloppy = createReactComponent("outline", "device-floppy", "IconDeviceFloppy", [["path", { "d": "M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M14 4l0 4l-6 0l0 -4", "key": "svg-2" }]]);

var IconDeviceFloppy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceFloppy
});

var IconDeviceGamepad2 = createReactComponent("outline", "device-gamepad-2", "IconDeviceGamepad2", [["path", { "d": "M12 5h3.5a5 5 0 0 1 0 10h-5.5l-4.015 4.227a2.3 2.3 0 0 1 -3.923 -2.035l1.634 -8.173a5 5 0 0 1 4.904 -4.019h3.4z", "key": "svg-0" }], ["path", { "d": "M14 15l4.07 4.284a2.3 2.3 0 0 0 3.925 -2.023l-1.6 -8.232", "key": "svg-1" }], ["path", { "d": "M8 9v2", "key": "svg-2" }], ["path", { "d": "M7 10h2", "key": "svg-3" }], ["path", { "d": "M14 10h2", "key": "svg-4" }]]);

var IconDeviceGamepad2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceGamepad2
});

var IconDeviceGamepad3 = createReactComponent("outline", "device-gamepad-3", "IconDeviceGamepad3", [["path", { "d": "M9 12l-3 -3h-2a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h2z", "key": "svg-0" }], ["path", { "d": "M15 12l3 -3h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2z", "key": "svg-1" }], ["path", { "d": "M12 15l-3 3v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1v-2z", "key": "svg-2" }], ["path", { "d": "M12 9l-3 -3v-2a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v2z", "key": "svg-3" }]]);

var IconDeviceGamepad3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceGamepad3
});

var IconDeviceGamepad = createReactComponent("outline", "device-gamepad", "IconDeviceGamepad", [["path", { "d": "M2 6m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M6 12h4m-2 -2v4", "key": "svg-1" }], ["path", { "d": "M15 11l0 .01", "key": "svg-2" }], ["path", { "d": "M18 13l0 .01", "key": "svg-3" }]]);

var IconDeviceGamepad$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceGamepad
});

var IconDeviceHeartMonitor = createReactComponent("outline", "device-heart-monitor", "IconDeviceHeartMonitor", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 9h6l1 -2l2 4l1 -2h6", "key": "svg-1" }], ["path", { "d": "M4 14h16", "key": "svg-2" }], ["path", { "d": "M14 17v.01", "key": "svg-3" }], ["path", { "d": "M17 17v.01", "key": "svg-4" }]]);

var IconDeviceHeartMonitor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceHeartMonitor
});

var IconDeviceImacBolt = createReactComponent("outline", "device-imac-bolt", "IconDeviceImacBolt", [["path", { "d": "M13.5 17h-9.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8.5", "key": "svg-0" }], ["path", { "d": "M3 13h13", "key": "svg-1" }], ["path", { "d": "M8 21h5.5", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-4" }]]);

var IconDeviceImacBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacBolt
});

var IconDeviceImacCancel = createReactComponent("outline", "device-imac-cancel", "IconDeviceImacCancel", [["path", { "d": "M12.5 17h-8.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M3 13h12.5", "key": "svg-1" }], ["path", { "d": "M8 21h4.5", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }], ["path", { "d": "M17 21l4 -4", "key": "svg-5" }]]);

var IconDeviceImacCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacCancel
});

var IconDeviceImacCheck = createReactComponent("outline", "device-imac-check", "IconDeviceImacCheck", [["path", { "d": "M11.5 17h-7.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v9", "key": "svg-0" }], ["path", { "d": "M3 13h18", "key": "svg-1" }], ["path", { "d": "M8 21h3.5", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-4" }]]);

var IconDeviceImacCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacCheck
});

var IconDeviceImacCode = createReactComponent("outline", "device-imac-code", "IconDeviceImacCode", [["path", { "d": "M11.5 17h-7.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v9", "key": "svg-0" }], ["path", { "d": "M3 13h18", "key": "svg-1" }], ["path", { "d": "M8 21h3.5", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-4" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-5" }]]);

var IconDeviceImacCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacCode
});

var IconDeviceImacCog = createReactComponent("outline", "device-imac-cog", "IconDeviceImacCog", [["path", { "d": "M12 17h-8a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M3 13h13", "key": "svg-1" }], ["path", { "d": "M8 21h4", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-5" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-6" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-7" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-8" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-9" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-10" }]]);

var IconDeviceImacCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacCog
});

var IconDeviceImacDollar = createReactComponent("outline", "device-imac-dollar", "IconDeviceImacDollar", [["path", { "d": "M13 17h-9a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v6.5", "key": "svg-0" }], ["path", { "d": "M3 13h11", "key": "svg-1" }], ["path", { "d": "M8 21h5", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-4" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-5" }]]);

var IconDeviceImacDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacDollar
});

var IconDeviceImacDown = createReactComponent("outline", "device-imac-down", "IconDeviceImacDown", [["path", { "d": "M12.5 17h-8.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8.5", "key": "svg-0" }], ["path", { "d": "M3 13h13", "key": "svg-1" }], ["path", { "d": "M8 21h4.5", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-5" }]]);

var IconDeviceImacDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacDown
});

var IconDeviceImacExclamation = createReactComponent("outline", "device-imac-exclamation", "IconDeviceImacExclamation", [["path", { "d": "M15 17h-11a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8.5", "key": "svg-0" }], ["path", { "d": "M3 13h13", "key": "svg-1" }], ["path", { "d": "M8 21h7", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M14 17l.5 4", "key": "svg-4" }], ["path", { "d": "M19 16v3", "key": "svg-5" }], ["path", { "d": "M19 22v.01", "key": "svg-6" }]]);

var IconDeviceImacExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacExclamation
});

var IconDeviceImacHeart = createReactComponent("outline", "device-imac-heart", "IconDeviceImacHeart", [["path", { "d": "M10 17h-6a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7", "key": "svg-0" }], ["path", { "d": "M3 13h9", "key": "svg-1" }], ["path", { "d": "M8 21h3.5", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-4" }]]);

var IconDeviceImacHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacHeart
});

var IconDeviceImacMinus = createReactComponent("outline", "device-imac-minus", "IconDeviceImacMinus", [["path", { "d": "M12.5 17h-8.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v11", "key": "svg-0" }], ["path", { "d": "M3 13h18", "key": "svg-1" }], ["path", { "d": "M8 21h4.5", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }]]);

var IconDeviceImacMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacMinus
});

var IconDeviceImacOff = createReactComponent("outline", "device-imac-off", "IconDeviceImacOff", [["path", { "d": "M7 3h13a1 1 0 0 1 1 1v12c0 .28 -.115 .532 -.3 .713m-3.7 .287h-13a1 1 0 0 1 -1 -1v-12c0 -.276 .112 -.526 .293 -.707", "key": "svg-0" }], ["path", { "d": "M3 13h10m4 0h4", "key": "svg-1" }], ["path", { "d": "M8 21h8", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M14 17l.5 4", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconDeviceImacOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacOff
});

var IconDeviceImacPause = createReactComponent("outline", "device-imac-pause", "IconDeviceImacPause", [["path", { "d": "M13 17h-9a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v9", "key": "svg-0" }], ["path", { "d": "M3 13h18", "key": "svg-1" }], ["path", { "d": "M8 21h5", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M17 17v5", "key": "svg-4" }], ["path", { "d": "M21 17v5", "key": "svg-5" }]]);

var IconDeviceImacPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacPause
});

var IconDeviceImacPin = createReactComponent("outline", "device-imac-pin", "IconDeviceImacPin", [["path", { "d": "M12 17h-8a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }], ["path", { "d": "M3 13h11", "key": "svg-3" }], ["path", { "d": "M8 21h4.5", "key": "svg-4" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-5" }]]);

var IconDeviceImacPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacPin
});

var IconDeviceImacPlus = createReactComponent("outline", "device-imac-plus", "IconDeviceImacPlus", [["path", { "d": "M12.5 17h-8.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8.5", "key": "svg-0" }], ["path", { "d": "M3 13h13.5", "key": "svg-1" }], ["path", { "d": "M8 21h4.5", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16v6", "key": "svg-5" }]]);

var IconDeviceImacPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacPlus
});

var IconDeviceImacQuestion = createReactComponent("outline", "device-imac-question", "IconDeviceImacQuestion", [["path", { "d": "M14 17h-10a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5", "key": "svg-0" }], ["path", { "d": "M3 13h11.5", "key": "svg-1" }], ["path", { "d": "M8 21h7", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M14 17l.5 4", "key": "svg-4" }], ["path", { "d": "M19 22v.01", "key": "svg-5" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-6" }]]);

var IconDeviceImacQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacQuestion
});

var IconDeviceImacSearch = createReactComponent("outline", "device-imac-search", "IconDeviceImacSearch", [["path", { "d": "M11 17h-7a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M3 13h10", "key": "svg-1" }], ["path", { "d": "M8 21h4", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-5" }]]);

var IconDeviceImacSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacSearch
});

var IconDeviceImacShare = createReactComponent("outline", "device-imac-share", "IconDeviceImacShare", [["path", { "d": "M12.5 17h-8.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v9", "key": "svg-0" }], ["path", { "d": "M3 13h18", "key": "svg-1" }], ["path", { "d": "M8 21h4", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M16 22l5 -5", "key": "svg-4" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-5" }]]);

var IconDeviceImacShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacShare
});

var IconDeviceImacStar = createReactComponent("outline", "device-imac-star", "IconDeviceImacStar", [["path", { "d": "M10 17h-6a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5", "key": "svg-0" }], ["path", { "d": "M3 13h10", "key": "svg-1" }], ["path", { "d": "M8 21h3", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-4" }]]);

var IconDeviceImacStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacStar
});

var IconDeviceImacUp = createReactComponent("outline", "device-imac-up", "IconDeviceImacUp", [["path", { "d": "M12.5 17h-8.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8.5", "key": "svg-0" }], ["path", { "d": "M3 13h13", "key": "svg-1" }], ["path", { "d": "M8 21h4.5", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M19 22v-6", "key": "svg-4" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-5" }]]);

var IconDeviceImacUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacUp
});

var IconDeviceImacX = createReactComponent("outline", "device-imac-x", "IconDeviceImacX", [["path", { "d": "M13 17h-9a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v9", "key": "svg-0" }], ["path", { "d": "M3 13h18", "key": "svg-1" }], ["path", { "d": "M8 21h5", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-4" }], ["path", { "d": "M17 22l5 -5", "key": "svg-5" }]]);

var IconDeviceImacX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacX
});

var IconDeviceImac = createReactComponent("outline", "device-imac", "IconDeviceImac", [["path", { "d": "M3 4a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-12z", "key": "svg-0" }], ["path", { "d": "M3 13h18", "key": "svg-1" }], ["path", { "d": "M8 21h8", "key": "svg-2" }], ["path", { "d": "M10 17l-.5 4", "key": "svg-3" }], ["path", { "d": "M14 17l.5 4", "key": "svg-4" }]]);

var IconDeviceImac$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImac
});

var IconDeviceIpadBolt = createReactComponent("outline", "device-ipad-bolt", "IconDeviceIpadBolt", [["path", { "d": "M13.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M9 18h4", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }]]);

var IconDeviceIpadBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadBolt
});

var IconDeviceIpadCancel = createReactComponent("outline", "device-ipad-cancel", "IconDeviceIpadCancel", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M9 18h3", "key": "svg-1" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M17 21l4 -4", "key": "svg-3" }]]);

var IconDeviceIpadCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadCancel
});

var IconDeviceIpadCheck = createReactComponent("outline", "device-ipad-check", "IconDeviceIpadCheck", [["path", { "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M9 18h2", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconDeviceIpadCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadCheck
});

var IconDeviceIpadCode = createReactComponent("outline", "device-ipad-code", "IconDeviceIpadCode", [["path", { "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M9 18h2", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

var IconDeviceIpadCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadCode
});

var IconDeviceIpadCog = createReactComponent("outline", "device-ipad-cog", "IconDeviceIpadCog", [["path", { "d": "M12 21h-6a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6.5", "key": "svg-0" }], ["path", { "d": "M9 18h3", "key": "svg-1" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-3" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-4" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-8" }]]);

var IconDeviceIpadCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadCog
});

var IconDeviceIpadDollar = createReactComponent("outline", "device-ipad-dollar", "IconDeviceIpadDollar", [["path", { "d": "M13 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M9 18h4", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconDeviceIpadDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadDollar
});

var IconDeviceIpadDown = createReactComponent("outline", "device-ipad-down", "IconDeviceIpadDown", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M9 18h3", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-3" }]]);

var IconDeviceIpadDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadDown
});

var IconDeviceIpadExclamation = createReactComponent("outline", "device-ipad-exclamation", "IconDeviceIpadExclamation", [["path", { "d": "M15 21h-9a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M9 18h6", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconDeviceIpadExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadExclamation
});

var IconDeviceIpadHeart = createReactComponent("outline", "device-ipad-heart", "IconDeviceIpadHeart", [["path", { "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M9 18h1", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconDeviceIpadHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHeart
});

var IconDeviceIpadHorizontalBolt = createReactComponent("outline", "device-ipad-horizontal-bolt", "IconDeviceIpadHorizontalBolt", [["path", { "d": "M13 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5", "key": "svg-0" }], ["path", { "d": "M9 17h4.5", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }]]);

var IconDeviceIpadHorizontalBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalBolt
});

var IconDeviceIpadHorizontalCancel = createReactComponent("outline", "device-ipad-horizontal-cancel", "IconDeviceIpadHorizontalCancel", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5", "key": "svg-0" }], ["path", { "d": "M9 17h3.5", "key": "svg-1" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M17 21l4 -4", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalCancel
});

var IconDeviceIpadHorizontalCheck = createReactComponent("outline", "device-ipad-horizontal-check", "IconDeviceIpadHorizontalCheck", [["path", { "d": "M11 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }], ["path", { "d": "M9 17h2.5", "key": "svg-2" }]]);

var IconDeviceIpadHorizontalCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalCheck
});

var IconDeviceIpadHorizontalCode = createReactComponent("outline", "device-ipad-horizontal-code", "IconDeviceIpadHorizontalCode", [["path", { "d": "M11 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M9 17h2.5", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalCode
});

var IconDeviceIpadHorizontalCog = createReactComponent("outline", "device-ipad-horizontal-cog", "IconDeviceIpadHorizontalCog", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M9 17h3", "key": "svg-1" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-3" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-4" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-8" }]]);

var IconDeviceIpadHorizontalCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalCog
});

var IconDeviceIpadHorizontalDollar = createReactComponent("outline", "device-ipad-horizontal-dollar", "IconDeviceIpadHorizontalDollar", [["path", { "d": "M13 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5", "key": "svg-0" }], ["path", { "d": "M9 17h4", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalDollar
});

var IconDeviceIpadHorizontalDown = createReactComponent("outline", "device-ipad-horizontal-down", "IconDeviceIpadHorizontalDown", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5", "key": "svg-0" }], ["path", { "d": "M9 17h3.5", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalDown
});

var IconDeviceIpadHorizontalExclamation = createReactComponent("outline", "device-ipad-horizontal-exclamation", "IconDeviceIpadHorizontalExclamation", [["path", { "d": "M15 20h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M9 17h6", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalExclamation
});

var IconDeviceIpadHorizontalHeart = createReactComponent("outline", "device-ipad-horizontal-heart", "IconDeviceIpadHorizontalHeart", [["path", { "d": "M10.5 20h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M9 17h1", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconDeviceIpadHorizontalHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalHeart
});

var IconDeviceIpadHorizontalMinus = createReactComponent("outline", "device-ipad-horizontal-minus", "IconDeviceIpadHorizontalMinus", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9", "key": "svg-0" }], ["path", { "d": "M9 17h3.5", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconDeviceIpadHorizontalMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalMinus
});

var IconDeviceIpadHorizontalOff = createReactComponent("outline", "device-ipad-horizontal-off", "IconDeviceIpadHorizontalOff", [["path", { "d": "M8 4h12a2 2 0 0 1 2 2v12m-2 2h-16a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M9 17h6", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconDeviceIpadHorizontalOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalOff
});

var IconDeviceIpadHorizontalPause = createReactComponent("outline", "device-ipad-horizontal-pause", "IconDeviceIpadHorizontalPause", [["path", { "d": "M13 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M9 17h4", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalPause
});

var IconDeviceIpadHorizontalPin = createReactComponent("outline", "device-ipad-horizontal-pin", "IconDeviceIpadHorizontalPin", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M9 17h3", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalPin
});

var IconDeviceIpadHorizontalPlus = createReactComponent("outline", "device-ipad-horizontal-plus", "IconDeviceIpadHorizontalPlus", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5", "key": "svg-0" }], ["path", { "d": "M9 17h3.5", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalPlus
});

var IconDeviceIpadHorizontalQuestion = createReactComponent("outline", "device-ipad-horizontal-question", "IconDeviceIpadHorizontalQuestion", [["path", { "d": "M15 20h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M9 17h4.5", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalQuestion
});

var IconDeviceIpadHorizontalSearch = createReactComponent("outline", "device-ipad-horizontal-search", "IconDeviceIpadHorizontalSearch", [["path", { "d": "M11.5 20h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5", "key": "svg-0" }], ["path", { "d": "M9 17h2", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalSearch
});

var IconDeviceIpadHorizontalShare = createReactComponent("outline", "device-ipad-horizontal-share", "IconDeviceIpadHorizontalShare", [["path", { "d": "M12.5 20h-7.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M9 17h3", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalShare
});

var IconDeviceIpadHorizontalStar = createReactComponent("outline", "device-ipad-horizontal-star", "IconDeviceIpadHorizontalStar", [["path", { "d": "M10.5 20h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5", "key": "svg-0" }], ["path", { "d": "M9 17h1", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconDeviceIpadHorizontalStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalStar
});

var IconDeviceIpadHorizontalUp = createReactComponent("outline", "device-ipad-horizontal-up", "IconDeviceIpadHorizontalUp", [["path", { "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5", "key": "svg-0" }], ["path", { "d": "M9 17h3.5", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalUp
});

var IconDeviceIpadHorizontalX = createReactComponent("outline", "device-ipad-horizontal-x", "IconDeviceIpadHorizontalX", [["path", { "d": "M13.5 20h-8.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }], ["path", { "d": "M9 17h4", "key": "svg-3" }]]);

var IconDeviceIpadHorizontalX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontalX
});

var IconDeviceIpadHorizontal = createReactComponent("outline", "device-ipad-horizontal", "IconDeviceIpadHorizontal", [["path", { "d": "M3 6a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-12z", "key": "svg-0" }], ["path", { "d": "M9 17h6", "key": "svg-1" }]]);

var IconDeviceIpadHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadHorizontal
});

var IconDeviceIpadMinus = createReactComponent("outline", "device-ipad-minus", "IconDeviceIpadMinus", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v10", "key": "svg-0" }], ["path", { "d": "M9 18h3", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconDeviceIpadMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadMinus
});

var IconDeviceIpadOff = createReactComponent("outline", "device-ipad-off", "IconDeviceIpadOff", [["path", { "d": "M6 2h12a2 2 0 0 1 2 2v12m0 4a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-16", "key": "svg-0" }], ["path", { "d": "M9 19h6", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconDeviceIpadOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadOff
});

var IconDeviceIpadPause = createReactComponent("outline", "device-ipad-pause", "IconDeviceIpadPause", [["path", { "d": "M13 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M9 18h4", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

var IconDeviceIpadPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadPause
});

var IconDeviceIpadPin = createReactComponent("outline", "device-ipad-pin", "IconDeviceIpadPin", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M9 18h3", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }]]);

var IconDeviceIpadPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadPin
});

var IconDeviceIpadPlus = createReactComponent("outline", "device-ipad-plus", "IconDeviceIpadPlus", [["path", { "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M9 18h3", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconDeviceIpadPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadPlus
});

var IconDeviceIpadQuestion = createReactComponent("outline", "device-ipad-question", "IconDeviceIpadQuestion", [["path", { "d": "M15 21h-9a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M9 18h5", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }]]);

var IconDeviceIpadQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadQuestion
});

var IconDeviceIpadSearch = createReactComponent("outline", "device-ipad-search", "IconDeviceIpadSearch", [["path", { "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M9 18h2", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconDeviceIpadSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadSearch
});

var IconDeviceIpadShare = createReactComponent("outline", "device-ipad-share", "IconDeviceIpadShare", [["path", { "d": "M12 21h-6a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M9 18h3.5", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconDeviceIpadShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadShare
});

var IconDeviceIpadStar = createReactComponent("outline", "device-ipad-star", "IconDeviceIpadStar", [["path", { "d": "M11 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5.5", "key": "svg-0" }], ["path", { "d": "M9 18h1", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconDeviceIpadStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadStar
});

var IconDeviceIpadUp = createReactComponent("outline", "device-ipad-up", "IconDeviceIpadUp", [["path", { "d": "M9 18h3", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }], ["path", { "d": "M13.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7", "key": "svg-3" }]]);

var IconDeviceIpadUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadUp
});

var IconDeviceIpadX = createReactComponent("outline", "device-ipad-x", "IconDeviceIpadX", [["path", { "d": "M22 22l-5 -5", "key": "svg-0" }], ["path", { "d": "M17 22l5 -5", "key": "svg-1" }], ["path", { "d": "M13 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v9", "key": "svg-2" }], ["path", { "d": "M9 18h4", "key": "svg-3" }]]);

var IconDeviceIpadX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadX
});

var IconDeviceIpad = createReactComponent("outline", "device-ipad", "IconDeviceIpad", [["path", { "d": "M18 3a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M9 18h6", "key": "svg-1" }]]);

var IconDeviceIpad$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpad
});

var IconDeviceLandlinePhone = createReactComponent("outline", "device-landline-phone", "IconDeviceLandlinePhone", [["path", { "d": "M20 3h-2a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-14a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M16 4h-11a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h11", "key": "svg-1" }], ["path", { "d": "M12 8h-6v3h6z", "key": "svg-2" }], ["path", { "d": "M12 14v.01", "key": "svg-3" }], ["path", { "d": "M9 14v.01", "key": "svg-4" }], ["path", { "d": "M6 14v.01", "key": "svg-5" }], ["path", { "d": "M12 17v.01", "key": "svg-6" }], ["path", { "d": "M9 17v.01", "key": "svg-7" }], ["path", { "d": "M6 17v.01", "key": "svg-8" }]]);

var IconDeviceLandlinePhone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceLandlinePhone
});

var IconDeviceLaptopOff = createReactComponent("outline", "device-laptop-off", "IconDeviceLaptopOff", [["path", { "d": "M3 19h16", "key": "svg-0" }], ["path", { "d": "M10 6h8a1 1 0 0 1 1 1v8m-3 1h-10a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconDeviceLaptopOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceLaptopOff
});

var IconDeviceLaptop = createReactComponent("outline", "device-laptop", "IconDeviceLaptop", [["path", { "d": "M3 19l18 0", "key": "svg-0" }], ["path", { "d": "M5 6m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z", "key": "svg-1" }]]);

var IconDeviceLaptop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceLaptop
});

var IconDeviceMobileBolt = createReactComponent("outline", "device-mobile-bolt", "IconDeviceMobileBolt", [["path", { "d": "M13.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }], ["path", { "d": "M11 4h2", "key": "svg-2" }], ["path", { "d": "M12 17v.01", "key": "svg-3" }]]);

var IconDeviceMobileBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileBolt
});

var IconDeviceMobileCancel = createReactComponent("outline", "device-mobile-cancel", "IconDeviceMobileCancel", [["path", { "d": "M12 21h-4a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }], ["path", { "d": "M11 4h2", "key": "svg-3" }], ["path", { "d": "M12 17v.01", "key": "svg-4" }]]);

var IconDeviceMobileCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileCancel
});

var IconDeviceMobileCharging = createReactComponent("outline", "device-mobile-charging", "IconDeviceMobileCharging", [["path", { "d": "M6 3m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M12 9.5l-1 2.5h2l-1 2.5", "key": "svg-2" }]]);

var IconDeviceMobileCharging$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileCharging
});

var IconDeviceMobileCheck = createReactComponent("outline", "device-mobile-check", "IconDeviceMobileCheck", [["path", { "d": "M11.5 21h-3.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v9.5", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M12 17v.01", "key": "svg-2" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-3" }]]);

var IconDeviceMobileCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileCheck
});

var IconDeviceMobileCode = createReactComponent("outline", "device-mobile-code", "IconDeviceMobileCode", [["path", { "d": "M11.5 21h-3.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }], ["path", { "d": "M11 4h2", "key": "svg-3" }], ["path", { "d": "M12 17v.01", "key": "svg-4" }]]);

var IconDeviceMobileCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileCode
});

var IconDeviceMobileCog = createReactComponent("outline", "device-mobile-cog", "IconDeviceMobileCog", [["path", { "d": "M12 21h-4a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v6.5", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M12 17v.01", "key": "svg-2" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-4" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-5" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-6" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-7" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-8" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-9" }]]);

var IconDeviceMobileCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileCog
});

var IconDeviceMobileDollar = createReactComponent("outline", "device-mobile-dollar", "IconDeviceMobileDollar", [["path", { "d": "M13 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M12 17v.01", "key": "svg-2" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-4" }]]);

var IconDeviceMobileDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileDollar
});

var IconDeviceMobileDown = createReactComponent("outline", "device-mobile-down", "IconDeviceMobileDown", [["path", { "d": "M12.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M12 17v.01", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-4" }]]);

var IconDeviceMobileDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileDown
});

var IconDeviceMobileExclamation = createReactComponent("outline", "device-mobile-exclamation", "IconDeviceMobileExclamation", [["path", { "d": "M15 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M12 17v.01", "key": "svg-2" }], ["path", { "d": "M19 16v3", "key": "svg-3" }], ["path", { "d": "M19 22v.01", "key": "svg-4" }]]);

var IconDeviceMobileExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileExclamation
});

var IconDeviceMobileHeart = createReactComponent("outline", "device-mobile-heart", "IconDeviceMobileHeart", [["path", { "d": "M11.5 21h-3.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconDeviceMobileHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileHeart
});

var IconDeviceMobileMessage = createReactComponent("outline", "device-mobile-message", "IconDeviceMobileMessage", [["path", { "d": "M11 3h10v8h-3l-4 2v-2h-3z", "key": "svg-0" }], ["path", { "d": "M15 16v4a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h2", "key": "svg-1" }], ["path", { "d": "M10 18v.01", "key": "svg-2" }]]);

var IconDeviceMobileMessage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileMessage
});

var IconDeviceMobileMinus = createReactComponent("outline", "device-mobile-minus", "IconDeviceMobileMinus", [["path", { "d": "M12.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v10", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M12 17v.01", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconDeviceMobileMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileMinus
});

var IconDeviceMobileOff = createReactComponent("outline", "device-mobile-off", "IconDeviceMobileOff", [["path", { "d": "M7.159 3.185c.256 -.119 .54 -.185 .841 -.185h8a2 2 0 0 1 2 2v9m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-13", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }], ["path", { "d": "M12 17v.01", "key": "svg-3" }]]);

var IconDeviceMobileOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileOff
});

var IconDeviceMobilePause = createReactComponent("outline", "device-mobile-pause", "IconDeviceMobilePause", [["path", { "d": "M13 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }], ["path", { "d": "M11 4h2", "key": "svg-3" }], ["path", { "d": "M12 17v.01", "key": "svg-4" }]]);

var IconDeviceMobilePause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobilePause
});

var IconDeviceMobilePin = createReactComponent("outline", "device-mobile-pin", "IconDeviceMobilePin", [["path", { "d": "M12.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }], ["path", { "d": "M12 17v.01", "key": "svg-4" }]]);

var IconDeviceMobilePin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobilePin
});

var IconDeviceMobilePlus = createReactComponent("outline", "device-mobile-plus", "IconDeviceMobilePlus", [["path", { "d": "M12.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M11 4h2", "key": "svg-3" }], ["path", { "d": "M12 17v.01", "key": "svg-4" }]]);

var IconDeviceMobilePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobilePlus
});

var IconDeviceMobileQuestion = createReactComponent("outline", "device-mobile-question", "IconDeviceMobileQuestion", [["path", { "d": "M15 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }], ["path", { "d": "M11 4h2", "key": "svg-3" }], ["path", { "d": "M12 17v.01", "key": "svg-4" }]]);

var IconDeviceMobileQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileQuestion
});

var IconDeviceMobileRotated = createReactComponent("outline", "device-mobile-rotated", "IconDeviceMobileRotated", [["path", { "d": "M3 6m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M20 11v2", "key": "svg-1" }], ["path", { "d": "M7 12h-.01", "key": "svg-2" }]]);

var IconDeviceMobileRotated$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileRotated
});

var IconDeviceMobileSearch = createReactComponent("outline", "device-mobile-search", "IconDeviceMobileSearch", [["path", { "d": "M12 21h-4a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }], ["path", { "d": "M11 4h2", "key": "svg-3" }], ["path", { "d": "M12 17v.01", "key": "svg-4" }]]);

var IconDeviceMobileSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileSearch
});

var IconDeviceMobileShare = createReactComponent("outline", "device-mobile-share", "IconDeviceMobileShare", [["path", { "d": "M12 21h-4a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }], ["path", { "d": "M12 17v.01", "key": "svg-4" }]]);

var IconDeviceMobileShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileShare
});

var IconDeviceMobileStar = createReactComponent("outline", "device-mobile-star", "IconDeviceMobileStar", [["path", { "d": "M11 21h-3a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconDeviceMobileStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileStar
});

var IconDeviceMobileUp = createReactComponent("outline", "device-mobile-up", "IconDeviceMobileUp", [["path", { "d": "M12.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }], ["path", { "d": "M11 4h2", "key": "svg-3" }], ["path", { "d": "M12 17v.01", "key": "svg-4" }]]);

var IconDeviceMobileUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileUp
});

var IconDeviceMobileVibration = createReactComponent("outline", "device-mobile-vibration", "IconDeviceMobileVibration", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 4l2 0", "key": "svg-1" }], ["path", { "d": "M9 17l0 .01", "key": "svg-2" }], ["path", { "d": "M21 6l-2 3l2 3l-2 3l2 3", "key": "svg-3" }]]);

var IconDeviceMobileVibration$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileVibration
});

var IconDeviceMobileX = createReactComponent("outline", "device-mobile-x", "IconDeviceMobileX", [["path", { "d": "M13 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }], ["path", { "d": "M11 4h2", "key": "svg-3" }], ["path", { "d": "M12 17v.01", "key": "svg-4" }]]);

var IconDeviceMobileX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileX
});

var IconDeviceMobile = createReactComponent("outline", "device-mobile", "IconDeviceMobile", [["path", { "d": "M6 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M11 4h2", "key": "svg-1" }], ["path", { "d": "M12 17v.01", "key": "svg-2" }]]);

var IconDeviceMobile$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobile
});

var IconDeviceNintendoOff = createReactComponent("outline", "device-nintendo-off", "IconDeviceNintendoOff", [["path", { "d": "M4.713 4.718a4 4 0 0 0 -1.713 3.282v8a4 4 0 0 0 4 4h3v-10m0 -4v-2h-2", "key": "svg-0" }], ["path", { "d": "M14 10v-6h3a4 4 0 0 1 4 4v8c0 .308 -.035 .608 -.1 .896m-1.62 2.39a3.982 3.982 0 0 1 -2.28 .714h-3v-6", "key": "svg-1" }], ["path", { "d": "M6.5 8.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconDeviceNintendoOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceNintendoOff
});

var IconDeviceNintendo = createReactComponent("outline", "device-nintendo", "IconDeviceNintendo", [["path", { "d": "M10 20v-16h-3a4 4 0 0 0 -4 4v8a4 4 0 0 0 4 4h3z", "key": "svg-0" }], ["path", { "d": "M14 20v-16h3a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-3z", "key": "svg-1" }], ["circle", { "cx": "17.5", "cy": "15.5", "r": "1", "fill": "currentColor", "key": "svg-2" }], ["circle", { "cx": "6.5", "cy": "8.5", "r": "1", "fill": "currentColor", "key": "svg-3" }]]);

var IconDeviceNintendo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceNintendo
});

var IconDeviceProjector = createReactComponent("outline", "device-projector", "IconDeviceProjector", [["path", { "d": "M8 9a5 5 0 1 0 10 0a5 5 0 0 0 -10 0", "key": "svg-0" }], ["path", { "d": "M9 6h-4a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-8a2 2 0 0 0 -2 -2h-2", "key": "svg-1" }], ["path", { "d": "M6 15h1", "key": "svg-2" }], ["path", { "d": "M7 18l-1 2", "key": "svg-3" }], ["path", { "d": "M18 18l1 2", "key": "svg-4" }]]);

var IconDeviceProjector$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceProjector
});

var IconDeviceRemote = createReactComponent("outline", "device-remote", "IconDeviceRemote", [["path", { "d": "M12 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M12 3v2", "key": "svg-2" }], ["path", { "d": "M10 15v.01", "key": "svg-3" }], ["path", { "d": "M10 18v.01", "key": "svg-4" }], ["path", { "d": "M14 18v.01", "key": "svg-5" }], ["path", { "d": "M14 15v.01", "key": "svg-6" }]]);

var IconDeviceRemote$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceRemote
});

var IconDeviceSdCard = createReactComponent("outline", "device-sd-card", "IconDeviceSdCard", [["path", { "d": "M7 21h10a2 2 0 0 0 2 -2v-14a2 2 0 0 0 -2 -2h-6.172a2 2 0 0 0 -1.414 .586l-3.828 3.828a2 2 0 0 0 -.586 1.414v10.172a2 2 0 0 0 2 2z", "key": "svg-0" }], ["path", { "d": "M13 6v2", "key": "svg-1" }], ["path", { "d": "M16 6v2", "key": "svg-2" }], ["path", { "d": "M10 7v1", "key": "svg-3" }]]);

var IconDeviceSdCard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceSdCard
});

var IconDeviceSim1 = createReactComponent("outline", "device-sim-1", "IconDeviceSim1", [["path", { "d": "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M10 11l2 -2v8", "key": "svg-1" }]]);

var IconDeviceSim1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceSim1
});

var IconDeviceSim2 = createReactComponent("outline", "device-sim-2", "IconDeviceSim2", [["path", { "d": "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M10 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconDeviceSim2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceSim2
});

var IconDeviceSim3 = createReactComponent("outline", "device-sim-3", "IconDeviceSim3", [["path", { "d": "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M10 9h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconDeviceSim3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceSim3
});

var IconDeviceSim = createReactComponent("outline", "device-sim", "IconDeviceSim", [["path", { "d": "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M9 11h3v6", "key": "svg-1" }], ["path", { "d": "M15 17v.01", "key": "svg-2" }], ["path", { "d": "M15 14v.01", "key": "svg-3" }], ["path", { "d": "M15 11v.01", "key": "svg-4" }], ["path", { "d": "M9 14v.01", "key": "svg-5" }], ["path", { "d": "M9 17v.01", "key": "svg-6" }]]);

var IconDeviceSim$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceSim
});

var IconDeviceSpeakerOff = createReactComponent("outline", "device-speaker-off", "IconDeviceSpeakerOff", [["path", { "d": "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14", "key": "svg-0" }], ["path", { "d": "M11.114 11.133a3 3 0 1 0 3.754 3.751", "key": "svg-1" }], ["path", { "d": "M12 7v.01", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconDeviceSpeakerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceSpeakerOff
});

var IconDeviceSpeaker = createReactComponent("outline", "device-speaker", "IconDeviceSpeaker", [["path", { "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 14m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M12 7l0 .01", "key": "svg-2" }]]);

var IconDeviceSpeaker$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceSpeaker
});

var IconDeviceTabletBolt = createReactComponent("outline", "device-tablet-bolt", "IconDeviceTabletBolt", [["path", { "d": "M13.5 21h-7.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }], ["path", { "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-2" }]]);

var IconDeviceTabletBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletBolt
});

var IconDeviceTabletCancel = createReactComponent("outline", "device-tablet-cancel", "IconDeviceTabletCancel", [["path", { "d": "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }], ["path", { "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-3" }]]);

var IconDeviceTabletCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletCancel
});

var IconDeviceTabletCheck = createReactComponent("outline", "device-tablet-check", "IconDeviceTabletCheck", [["path", { "d": "M11.5 21h-5.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v9.5", "key": "svg-0" }], ["path", { "d": "M12.314 16.05a1 1 0 0 0 -1.042 1.635", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconDeviceTabletCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletCheck
});

var IconDeviceTabletCode = createReactComponent("outline", "device-tablet-code", "IconDeviceTabletCode", [["path", { "d": "M11.5 21h-5.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v9", "key": "svg-0" }], ["path", { "d": "M12.344 16.06a1 1 0 0 0 -1.07 1.627", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

var IconDeviceTabletCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletCode
});

var IconDeviceTabletCog = createReactComponent("outline", "device-tablet-cog", "IconDeviceTabletCog", [["path", { "d": "M12 21h-6a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v7.5", "key": "svg-0" }], ["path", { "d": "M12 16a1 1 0 0 0 0 2", "key": "svg-1" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-3" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-4" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-8" }]]);

var IconDeviceTabletCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletCog
});

var IconDeviceTabletDollar = createReactComponent("outline", "device-tablet-dollar", "IconDeviceTabletDollar", [["path", { "d": "M13 21h-7a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v6", "key": "svg-0" }], ["path", { "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconDeviceTabletDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletDollar
});

var IconDeviceTabletDown = createReactComponent("outline", "device-tablet-down", "IconDeviceTabletDown", [["path", { "d": "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }], ["path", { "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-3" }]]);

var IconDeviceTabletDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletDown
});

var IconDeviceTabletExclamation = createReactComponent("outline", "device-tablet-exclamation", "IconDeviceTabletExclamation", [["path", { "d": "M15 21h-9a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconDeviceTabletExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletExclamation
});

var IconDeviceTabletHeart = createReactComponent("outline", "device-tablet-heart", "IconDeviceTabletHeart", [["path", { "d": "M11.5 21h-5.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v7", "key": "svg-0" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-1" }]]);

var IconDeviceTabletHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletHeart
});

var IconDeviceTabletMinus = createReactComponent("outline", "device-tablet-minus", "IconDeviceTabletMinus", [["path", { "d": "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v11", "key": "svg-0" }], ["path", { "d": "M12.872 16.51a1 1 0 1 0 -.872 1.49", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconDeviceTabletMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletMinus
});

var IconDeviceTabletOff = createReactComponent("outline", "device-tablet-off", "IconDeviceTabletOff", [["path", { "d": "M7 3h11a1 1 0 0 1 1 1v11m0 4v1a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-15", "key": "svg-0" }], ["path", { "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconDeviceTabletOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletOff
});

var IconDeviceTabletPause = createReactComponent("outline", "device-tablet-pause", "IconDeviceTabletPause", [["path", { "d": "M13 21h-7a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v9.5", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }], ["path", { "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-3" }]]);

var IconDeviceTabletPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletPause
});

var IconDeviceTabletPin = createReactComponent("outline", "device-tablet-pin", "IconDeviceTabletPin", [["path", { "d": "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v7", "key": "svg-0" }], ["path", { "d": "M12 16a1 1 0 0 0 0 2", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }]]);

var IconDeviceTabletPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletPin
});

var IconDeviceTabletPlus = createReactComponent("outline", "device-tablet-plus", "IconDeviceTabletPlus", [["path", { "d": "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-3" }]]);

var IconDeviceTabletPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletPlus
});

var IconDeviceTabletQuestion = createReactComponent("outline", "device-tablet-question", "IconDeviceTabletQuestion", [["path", { "d": "M15 21h-9a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v7", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }], ["path", { "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-3" }]]);

var IconDeviceTabletQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletQuestion
});

var IconDeviceTabletSearch = createReactComponent("outline", "device-tablet-search", "IconDeviceTabletSearch", [["path", { "d": "M11.5 21h-5.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v7", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }]]);

var IconDeviceTabletSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletSearch
});

var IconDeviceTabletShare = createReactComponent("outline", "device-tablet-share", "IconDeviceTabletShare", [["path", { "d": "M12 21h-6a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v9", "key": "svg-0" }], ["path", { "d": "M12.57 16.178a1 1 0 1 0 .016 1.633", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconDeviceTabletShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletShare
});

var IconDeviceTabletStar = createReactComponent("outline", "device-tablet-star", "IconDeviceTabletStar", [["path", { "d": "M11 21h-5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v6", "key": "svg-0" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }]]);

var IconDeviceTabletStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletStar
});

var IconDeviceTabletUp = createReactComponent("outline", "device-tablet-up", "IconDeviceTabletUp", [["path", { "d": "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8", "key": "svg-0" }], ["path", { "d": "M12.906 16.576a1 1 0 1 0 -.906 1.424", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }]]);

var IconDeviceTabletUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletUp
});

var IconDeviceTabletX = createReactComponent("outline", "device-tablet-x", "IconDeviceTabletX", [["path", { "d": "M13 21h-7a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v9.5", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }], ["path", { "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-3" }]]);

var IconDeviceTabletX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletX
});

var IconDeviceTablet = createReactComponent("outline", "device-tablet", "IconDeviceTablet", [["path", { "d": "M5 4a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16z", "key": "svg-0" }], ["path", { "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }]]);

var IconDeviceTablet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTablet
});

var IconDeviceTvOff = createReactComponent("outline", "device-tv-off", "IconDeviceTvOff", [["path", { "d": "M11 7h8a2 2 0 0 1 2 2v8m-1.178 2.824c-.25 .113 -.529 .176 -.822 .176h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M16 3l-4 4l-4 -4", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconDeviceTvOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTvOff
});

var IconDeviceTvOld = createReactComponent("outline", "device-tv-old", "IconDeviceTvOld", [["path", { "d": "M3 7m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M16 3l-4 4l-4 -4", "key": "svg-1" }], ["path", { "d": "M15 7v13", "key": "svg-2" }], ["path", { "d": "M18 15v.01", "key": "svg-3" }], ["path", { "d": "M18 12v.01", "key": "svg-4" }]]);

var IconDeviceTvOld$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTvOld
});

var IconDeviceTv = createReactComponent("outline", "device-tv", "IconDeviceTv", [["path", { "d": "M3 7m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M16 3l-4 4l-4 -4", "key": "svg-1" }]]);

var IconDeviceTv$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTv
});

var IconDeviceUnknown = createReactComponent("outline", "device-unknown", "IconDeviceUnknown", [["path", { "d": "M5 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 16v.01", "key": "svg-1" }], ["path", { "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconDeviceUnknown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceUnknown
});

var IconDeviceUsb = createReactComponent("outline", "device-usb", "IconDeviceUsb", [["path", { "d": "M7 8h10v8a5 5 0 0 1 -10 0z", "key": "svg-0" }], ["path", { "d": "M9 8v-5h6v5", "key": "svg-1" }]]);

var IconDeviceUsb$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceUsb
});

var IconDeviceVisionPro = createReactComponent("outline", "device-vision-pro", "IconDeviceVisionPro", [["path", { "d": "M12 7c1.143 0 2.235 .035 3.275 .104c1.017 .068 1.95 .207 2.798 .42c.813 .203 1.52 .505 2.119 .909a3.903 3.903 0 0 1 1.328 1.531c.326 .657 .48 1.48 .48 2.466c0 1.006 -.189 1.91 -.574 2.707c-.375 .779 -.886 1.396 -1.537 1.848a3.696 3.696 0 0 1 -2.16 .66c-.509 0 -.97 -.068 -1.382 -.21a5.84 5.84 0 0 1 -1.17 -.548a18.45 18.45 0 0 1 -1.045 -.695a9.104 9.104 0 0 0 -1.001 -.63a2.376 2.376 0 0 0 -1.13 -.301c-.373 0 -.75 .097 -1.132 .3c-.316 .17 -.65 .38 -1 .63c-.322 .23 -.67 .462 -1.047 .695a5.78 5.78 0 0 1 -1.168 .548c-.413 .142 -.872 .21 -1.378 .21a3.706 3.706 0 0 1 -2.165 -.659c-.651 -.452 -1.162 -1.07 -1.537 -1.848c-.385 -.798 -.574 -1.7 -.574 -2.709c-.004 -.98 .15 -1.802 .477 -2.46a3.897 3.897 0 0 1 1.33 -1.531c.6 -.403 1.307 -.704 2.12 -.907a16.088 16.088 0 0 1 2.8 -.423c1.04 -.071 2.13 -.107 3.273 -.107z", "key": "svg-0" }]]);

var IconDeviceVisionPro$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceVisionPro
});

var IconDeviceWatchBolt = createReactComponent("outline", "device-watch-bolt", "IconDeviceWatchBolt", [["path", { "d": "M13 18h-4a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3", "key": "svg-0" }], ["path", { "d": "M9 18v3h4.5", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-3" }]]);

var IconDeviceWatchBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchBolt
});

var IconDeviceWatchCancel = createReactComponent("outline", "device-watch-cancel", "IconDeviceWatchCancel", [["path", { "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3", "key": "svg-0" }], ["path", { "d": "M9 18v3h3", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M17 21l4 -4", "key": "svg-4" }]]);

var IconDeviceWatchCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchCancel
});

var IconDeviceWatchCheck = createReactComponent("outline", "device-watch-check", "IconDeviceWatchCheck", [["path", { "d": "M11 18h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v5.5", "key": "svg-0" }], ["path", { "d": "M9 18v3h2.5", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-3" }]]);

var IconDeviceWatchCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchCheck
});

var IconDeviceWatchCode = createReactComponent("outline", "device-watch-code", "IconDeviceWatchCode", [["path", { "d": "M11 18h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v4", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }], ["path", { "d": "M9 18v3h3", "key": "svg-3" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-4" }]]);

var IconDeviceWatchCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchCode
});

var IconDeviceWatchCog = createReactComponent("outline", "device-watch-cog", "IconDeviceWatchCog", [["path", { "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v2.5", "key": "svg-0" }], ["path", { "d": "M9 18v3h3", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-4" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-5" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-6" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-7" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-8" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-9" }]]);

var IconDeviceWatchCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchCog
});

var IconDeviceWatchDollar = createReactComponent("outline", "device-watch-dollar", "IconDeviceWatchDollar", [["path", { "d": "M13 18h-4a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v1", "key": "svg-0" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-2" }], ["path", { "d": "M9 18v3h4", "key": "svg-3" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-4" }]]);

var IconDeviceWatchDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchDollar
});

var IconDeviceWatchDown = createReactComponent("outline", "device-watch-down", "IconDeviceWatchDown", [["path", { "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3", "key": "svg-0" }], ["path", { "d": "M9 18v3h3.5", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-4" }]]);

var IconDeviceWatchDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchDown
});

var IconDeviceWatchExclamation = createReactComponent("outline", "device-watch-exclamation", "IconDeviceWatchExclamation", [["path", { "d": "M15 18h-6a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3", "key": "svg-0" }], ["path", { "d": "M9 18v3h6v-3", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M19 16v3", "key": "svg-3" }], ["path", { "d": "M19 22v.01", "key": "svg-4" }]]);

var IconDeviceWatchExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchExclamation
});

var IconDeviceWatchHeart = createReactComponent("outline", "device-watch-heart", "IconDeviceWatchHeart", [["path", { "d": "M10 18h-1a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v2", "key": "svg-0" }], ["path", { "d": "M9 18v3h2.5", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-3" }]]);

var IconDeviceWatchHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchHeart
});

var IconDeviceWatchMinus = createReactComponent("outline", "device-watch-minus", "IconDeviceWatchMinus", [["path", { "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v6", "key": "svg-0" }], ["path", { "d": "M9 18v3h3.5", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconDeviceWatchMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchMinus
});

var IconDeviceWatchOff = createReactComponent("outline", "device-watch-off", "IconDeviceWatchOff", [["path", { "d": "M10 6h5a3 3 0 0 1 3 3v5m-.89 3.132a2.99 2.99 0 0 1 -2.11 .868h-6a3 3 0 0 1 -3 -3v-6c0 -.817 .327 -1.559 .857 -2.1", "key": "svg-0" }], ["path", { "d": "M9 18v3h6v-3", "key": "svg-1" }], ["path", { "d": "M9 5v-2h6v3", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconDeviceWatchOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchOff
});

var IconDeviceWatchPause = createReactComponent("outline", "device-watch-pause", "IconDeviceWatchPause", [["path", { "d": "M13 18h-4a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v4", "key": "svg-0" }], ["path", { "d": "M9 18v3h4", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M17 17v5", "key": "svg-3" }], ["path", { "d": "M21 17v5", "key": "svg-4" }]]);

var IconDeviceWatchPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchPause
});

var IconDeviceWatchPin = createReactComponent("outline", "device-watch-pin", "IconDeviceWatchPin", [["path", { "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v2", "key": "svg-0" }], ["path", { "d": "M9 18v3h3.5", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-3" }], ["path", { "d": "M19 18v.01", "key": "svg-4" }]]);

var IconDeviceWatchPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchPin
});

var IconDeviceWatchPlus = createReactComponent("outline", "device-watch-plus", "IconDeviceWatchPlus", [["path", { "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M9 18v3h3.5", "key": "svg-3" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-4" }]]);

var IconDeviceWatchPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchPlus
});

var IconDeviceWatchQuestion = createReactComponent("outline", "device-watch-question", "IconDeviceWatchQuestion", [["path", { "d": "M14 18h-5a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v2", "key": "svg-0" }], ["path", { "d": "M9 18v3h6v-2", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-4" }]]);

var IconDeviceWatchQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchQuestion
});

var IconDeviceWatchSearch = createReactComponent("outline", "device-watch-search", "IconDeviceWatchSearch", [["path", { "d": "M11 18h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v2", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }], ["path", { "d": "M9 18v3h3", "key": "svg-3" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-4" }]]);

var IconDeviceWatchSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchSearch
});

var IconDeviceWatchShare = createReactComponent("outline", "device-watch-share", "IconDeviceWatchShare", [["path", { "d": "M12.5 18h-3.5a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v4", "key": "svg-0" }], ["path", { "d": "M9 18v3h3", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M16 22l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-4" }]]);

var IconDeviceWatchShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchShare
});

var IconDeviceWatchStar = createReactComponent("outline", "device-watch-star", "IconDeviceWatchStar", [["path", { "d": "M10 18h-1a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v1", "key": "svg-0" }], ["path", { "d": "M9 18v3h2", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-3" }]]);

var IconDeviceWatchStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchStar
});

var IconDeviceWatchStats2 = createReactComponent("outline", "device-watch-stats-2", "IconDeviceWatchStats2", [["path", { "d": "M6 6m0 3a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M9 18v3h6v-3", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M12 10a2 2 0 1 0 2 2", "key": "svg-3" }]]);

var IconDeviceWatchStats2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchStats2
});

var IconDeviceWatchStats = createReactComponent("outline", "device-watch-stats", "IconDeviceWatchStats", [["path", { "d": "M6 6m0 3a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M9 18v3h6v-3", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M9 14v-4", "key": "svg-3" }], ["path", { "d": "M12 14v-1", "key": "svg-4" }], ["path", { "d": "M15 14v-3", "key": "svg-5" }]]);

var IconDeviceWatchStats$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchStats
});

var IconDeviceWatchUp = createReactComponent("outline", "device-watch-up", "IconDeviceWatchUp", [["path", { "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3", "key": "svg-0" }], ["path", { "d": "M9 18v3h3.5", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M19 22v-6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-4" }]]);

var IconDeviceWatchUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchUp
});

var IconDeviceWatchX = createReactComponent("outline", "device-watch-x", "IconDeviceWatchX", [["path", { "d": "M13 18h-4a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v4", "key": "svg-0" }], ["path", { "d": "M9 18v3h4", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-3" }], ["path", { "d": "M17 22l5 -5", "key": "svg-4" }]]);

var IconDeviceWatchX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchX
});

var IconDeviceWatch = createReactComponent("outline", "device-watch", "IconDeviceWatch", [["path", { "d": "M6 9a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3v-6z", "key": "svg-0" }], ["path", { "d": "M9 18v3h6v-3", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }]]);

var IconDeviceWatch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatch
});

var IconDevices2 = createReactComponent("outline", "devices-2", "IconDevices2", [["path", { "d": "M10 15h-6a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h6", "key": "svg-0" }], ["path", { "d": "M13 4m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M7 19l3 0", "key": "svg-2" }], ["path", { "d": "M17 8l0 .01", "key": "svg-3" }], ["path", { "d": "M17 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["path", { "d": "M9 15l0 4", "key": "svg-5" }]]);

var IconDevices2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevices2
});

var IconDevicesBolt = createReactComponent("outline", "devices-bolt", "IconDevicesBolt", [["path", { "d": "M13 19v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }], ["path", { "d": "M16 9h2", "key": "svg-3" }]]);

var IconDevicesBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesBolt
});

var IconDevicesCancel = createReactComponent("outline", "devices-cancel", "IconDevicesCancel", [["path", { "d": "M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8", "key": "svg-1" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M17 21l4 -4", "key": "svg-3" }], ["path", { "d": "M16 9h2", "key": "svg-4" }]]);

var IconDevicesCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesCancel
});

var IconDevicesCheck = createReactComponent("outline", "devices-check", "IconDevicesCheck", [["path", { "d": "M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7", "key": "svg-1" }], ["path", { "d": "M16 9h2", "key": "svg-2" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-3" }]]);

var IconDevicesCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesCheck
});

var IconDevicesCode = createReactComponent("outline", "devices-code", "IconDevicesCode", [["path", { "d": "M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4m0 6a1 1 0 0 1 -1 1", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }], ["path", { "d": "M16 9h2", "key": "svg-4" }]]);

var IconDevicesCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesCode
});

var IconDevicesCog = createReactComponent("outline", "devices-cog", "IconDevicesCog", [["path", { "d": "M13 14.5v-5.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8", "key": "svg-1" }], ["path", { "d": "M16 9h2", "key": "svg-2" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-4" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-5" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-6" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-7" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-8" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-9" }]]);

var IconDevicesCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesCog
});

var IconDevicesDollar = createReactComponent("outline", "devices-dollar", "IconDevicesDollar", [["path", { "d": "M13 19v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v1.5", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9", "key": "svg-1" }], ["path", { "d": "M16 9h2", "key": "svg-2" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-4" }]]);

var IconDevicesDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesDollar
});

var IconDevicesDown = createReactComponent("outline", "devices-down", "IconDevicesDown", [["path", { "d": "M13 16.5v-7.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-3" }], ["path", { "d": "M16 9h2", "key": "svg-4" }]]);

var IconDevicesDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesDown
});

var IconDevicesExclamation = createReactComponent("outline", "devices-exclamation", "IconDevicesExclamation", [["path", { "d": "M15 20h-1a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9", "key": "svg-1" }], ["path", { "d": "M16 9h2", "key": "svg-2" }], ["path", { "d": "M19 16v3", "key": "svg-3" }], ["path", { "d": "M19 22v.01", "key": "svg-4" }]]);

var IconDevicesExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesExclamation
});

var IconDevicesHeart = createReactComponent("outline", "devices-heart", "IconDevicesHeart", [["path", { "d": "M13 12v-3a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h6", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }], ["path", { "d": "M16 9h2", "key": "svg-3" }]]);

var IconDevicesHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesHeart
});

var IconDevicesMinus = createReactComponent("outline", "devices-minus", "IconDevicesMinus", [["path", { "d": "M13 16.5v-7.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v6", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M16 9h2", "key": "svg-3" }]]);

var IconDevicesMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesMinus
});

var IconDevicesOff = createReactComponent("outline", "devices-off", "IconDevicesOff", [["path", { "d": "M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v8m-1 3h-6a1 1 0 0 1 -1 -1v-6", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-9m-4 0a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9", "key": "svg-1" }], ["path", { "d": "M16 9h2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconDevicesOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesOff
});

var IconDevicesPause = createReactComponent("outline", "devices-pause", "IconDevicesPause", [["path", { "d": "M13 19v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }], ["path", { "d": "M16 9h2", "key": "svg-4" }]]);

var IconDevicesPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesPause
});

var IconDevicesPcOff = createReactComponent("outline", "devices-pc-off", "IconDevicesPcOff", [["path", { "d": "M9 9v10h-6v-14h2", "key": "svg-0" }], ["path", { "d": "M13 9h9v7h-2m-4 0h-4v-4", "key": "svg-1" }], ["path", { "d": "M14 19h5", "key": "svg-2" }], ["path", { "d": "M17 17v2", "key": "svg-3" }], ["path", { "d": "M6 13v.01", "key": "svg-4" }], ["path", { "d": "M6 16v.01", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconDevicesPcOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesPcOff
});

var IconDevicesPc = createReactComponent("outline", "devices-pc", "IconDevicesPc", [["path", { "d": "M3 5h6v14h-6z", "key": "svg-0" }], ["path", { "d": "M12 9h10v7h-10z", "key": "svg-1" }], ["path", { "d": "M14 19h6", "key": "svg-2" }], ["path", { "d": "M17 16v3", "key": "svg-3" }], ["path", { "d": "M6 13v.01", "key": "svg-4" }], ["path", { "d": "M6 16v.01", "key": "svg-5" }]]);

var IconDevicesPc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesPc
});

var IconDevicesPin = createReactComponent("outline", "devices-pin", "IconDevicesPin", [["path", { "d": "M13 14v-5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }], ["path", { "d": "M16 9h2", "key": "svg-4" }]]);

var IconDevicesPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesPin
});

var IconDevicesPlus = createReactComponent("outline", "devices-plus", "IconDevicesPlus", [["path", { "d": "M13 16.5v-7.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8", "key": "svg-1" }], ["path", { "d": "M16 9h2", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconDevicesPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesPlus
});

var IconDevicesQuestion = createReactComponent("outline", "devices-question", "IconDevicesQuestion", [["path", { "d": "M15 20h-1a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }], ["path", { "d": "M16 9h2", "key": "svg-4" }]]);

var IconDevicesQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesQuestion
});

var IconDevicesSearch = createReactComponent("outline", "devices-search", "IconDevicesSearch", [["path", { "d": "M13 13v-4a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2.5", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }], ["path", { "d": "M16 9h2", "key": "svg-4" }]]);

var IconDevicesSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesSearch
});

var IconDevicesShare = createReactComponent("outline", "devices-share", "IconDevicesShare", [["path", { "d": "M13 15v-6a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }], ["path", { "d": "M16 9h2", "key": "svg-4" }]]);

var IconDevicesShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesShare
});

var IconDevicesStar = createReactComponent("outline", "devices-star", "IconDevicesStar", [["path", { "d": "M13 13v-4a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2.5", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h5.5", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }], ["path", { "d": "M16 9h2", "key": "svg-3" }]]);

var IconDevicesStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesStar
});

var IconDevicesUp = createReactComponent("outline", "devices-up", "IconDevicesUp", [["path", { "d": "M13 16.5v-7.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }], ["path", { "d": "M16 9h2", "key": "svg-4" }]]);

var IconDevicesUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesUp
});

var IconDevicesX = createReactComponent("outline", "devices-x", "IconDevicesX", [["path", { "d": "M14 20a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9", "key": "svg-1" }], ["path", { "d": "M16 9h2", "key": "svg-2" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-3" }], ["path", { "d": "M17 22l5 -5", "key": "svg-4" }]]);

var IconDevicesX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevicesX
});

var IconDevices = createReactComponent("outline", "devices", "IconDevices", [["path", { "d": "M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-10z", "key": "svg-0" }], ["path", { "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9", "key": "svg-1" }], ["path", { "d": "M16 9h2", "key": "svg-2" }]]);

var IconDevices$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDevices
});

var IconDiaboloOff = createReactComponent("outline", "diabolo-off", "IconDiaboloOff", [["path", { "d": "M4.727 4.749c-.467 .38 -.727 .804 -.727 1.251c0 1.217 1.933 2.265 4.71 2.735m4.257 .243c3.962 -.178 7.033 -1.444 7.033 -2.978c0 -1.657 -3.582 -3 -8 -3c-1.66 0 -3.202 .19 -4.48 .514", "key": "svg-0" }], ["path", { "d": "M4 6v.143a1 1 0 0 0 .048 .307l1.952 5.55l-1.964 5.67a1 1 0 0 0 -.036 .265v.065c0 1.657 3.582 3 8 3c3.218 0 5.992 -.712 7.262 -1.74m-.211 -4.227l-1.051 -3.033l1.952 -5.55a1 1 0 0 0 .048 -.307v-.143", "key": "svg-1" }], ["path", { "d": "M6 12c0 1.105 2.686 2 6 2c.656 0 1.288 -.035 1.879 -.1m3.198 -.834c.585 -.308 .923 -.674 .923 -1.066", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconDiaboloOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiaboloOff
});

var IconDiaboloPlus = createReactComponent("outline", "diabolo-plus", "IconDiaboloPlus", [["path", { "d": "M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0", "key": "svg-0" }], ["path", { "d": "M4 6v.143a1 1 0 0 0 .048 .307l1.952 5.55l-1.964 5.67a1 1 0 0 0 -.036 .265v.065c0 1.657 3.582 3 8 3c.17 0 .34 -.002 .508 -.006m5.492 -8.994l1.952 -5.55a1 1 0 0 0 .048 -.307v-.143", "key": "svg-1" }], ["path", { "d": "M6 12c0 1.105 2.686 2 6 2s6 -.895 6 -2", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconDiaboloPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiaboloPlus
});

var IconDiabolo = createReactComponent("outline", "diabolo", "IconDiabolo", [["path", { "d": "M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0", "key": "svg-0" }], ["path", { "d": "M4 6v.143a1 1 0 0 0 .048 .307l1.952 5.55l-1.964 5.67a1 1 0 0 0 -.036 .265v.065c0 1.657 3.582 3 8 3s8 -1.343 8 -3v-.065a1 1 0 0 0 -.036 -.265l-1.964 -5.67l1.952 -5.55a1 1 0 0 0 .048 -.307v-.143", "key": "svg-1" }], ["path", { "d": "M6 12c0 1.105 2.686 2 6 2s6 -.895 6 -2", "key": "svg-2" }]]);

var IconDiabolo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiabolo
});

var IconDialpadOff = createReactComponent("outline", "dialpad-off", "IconDialpadOff", [["path", { "d": "M7 7h-4v-4", "key": "svg-0" }], ["path", { "d": "M17 3h4v4h-4z", "key": "svg-1" }], ["path", { "d": "M10 6v-3h4v4h-3", "key": "svg-2" }], ["path", { "d": "M3 10h4v4h-4z", "key": "svg-3" }], ["path", { "d": "M17 13v-3h4v4h-3", "key": "svg-4" }], ["path", { "d": "M14 14h-4v-4", "key": "svg-5" }], ["path", { "d": "M10 17h4v4h-4z", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconDialpadOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDialpadOff
});

var IconDialpad = createReactComponent("outline", "dialpad", "IconDialpad", [["path", { "d": "M4 3h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M18 3h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M11 3h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M4 10h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z", "key": "svg-3" }], ["path", { "d": "M18 10h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z", "key": "svg-4" }], ["path", { "d": "M11 10h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z", "key": "svg-5" }], ["path", { "d": "M11 17h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z", "key": "svg-6" }]]);

var IconDialpad$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDialpad
});

var IconDiamondOff = createReactComponent("outline", "diamond-off", "IconDiamondOff", [["path", { "d": "M9 5h9l3 5l-3.308 3.697m-1.883 2.104l-3.309 3.699a.7 .7 0 0 1 -1 0l-8.5 -9.5l2.62 -4.368", "key": "svg-0" }], ["path", { "d": "M10 12l-2 -2.2l.6 -1", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconDiamondOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiamondOff
});

var IconDiamond = createReactComponent("outline", "diamond", "IconDiamond", [["path", { "d": "M6 5h12l3 5l-8.5 9.5a.7 .7 0 0 1 -1 0l-8.5 -9.5l3 -5", "key": "svg-0" }], ["path", { "d": "M10 12l-2 -2.2l.6 -1", "key": "svg-1" }]]);

var IconDiamond$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiamond
});

var IconDiamonds = createReactComponent("outline", "diamonds", "IconDiamonds", [["path", { "d": "M10.831 20.413l-5.375 -6.91c-.608 -.783 -.608 -2.223 0 -3l5.375 -6.911a1.457 1.457 0 0 1 2.338 0l5.375 6.91c.608 .783 .608 2.223 0 3l-5.375 6.911a1.457 1.457 0 0 1 -2.338 0z", "key": "svg-0" }]]);

var IconDiamonds$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiamonds
});

var IconDiaper = createReactComponent("outline", "diaper", "IconDiaper", [["path", { "d": "M3 8.323c0 -.579 0 -.868 .044 -1.11a2.7 2.7 0 0 1 2.17 -2.169c.239 -.044 .529 -.044 1.109 -.044h11.353c.579 0 .868 0 1.11 .044a2.7 2.7 0 0 1 2.169 2.17c.044 .24 .044 .53 .044 1.11v2.676a9 9 0 0 1 -18 0z", "key": "svg-0" }], ["path", { "d": "M17 9h4", "key": "svg-1" }], ["path", { "d": "M3 9h4", "key": "svg-2" }], ["path", { "d": "M14.25 19.7v-1.4a6.3 6.3 0 0 1 6.3 -6.3", "key": "svg-3" }], ["path", { "d": "M9.75 19.7v-1.4a6.3 6.3 0 0 0 -6.3 -6.3", "key": "svg-4" }]]);

var IconDiaper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiaper
});

var IconDice1 = createReactComponent("outline", "dice-1", "IconDice1", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["circle", { "cx": "12", "cy": "12", "r": ".5", "fill": "currentColor", "key": "svg-1" }]]);

var IconDice1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice1
});

var IconDice2 = createReactComponent("outline", "dice-2", "IconDice2", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["circle", { "cx": "9.5", "cy": "9.5", "r": ".5", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "14.5", "cy": "14.5", "r": ".5", "fill": "currentColor", "key": "svg-2" }]]);

var IconDice2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice2
});

var IconDice3 = createReactComponent("outline", "dice-3", "IconDice3", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["circle", { "cx": "8.5", "cy": "8.5", "r": ".5", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "15.5", "cy": "15.5", "r": ".5", "fill": "currentColor", "key": "svg-2" }], ["circle", { "cx": "12", "cy": "12", "r": ".5", "fill": "currentColor", "key": "svg-3" }]]);

var IconDice3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice3
});

var IconDice4 = createReactComponent("outline", "dice-4", "IconDice4", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["circle", { "cx": "8.5", "cy": "8.5", "r": ".5", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "15.5", "cy": "8.5", "r": ".5", "fill": "currentColor", "key": "svg-2" }], ["circle", { "cx": "15.5", "cy": "15.5", "r": ".5", "fill": "currentColor", "key": "svg-3" }], ["circle", { "cx": "8.5", "cy": "15.5", "r": ".5", "fill": "currentColor", "key": "svg-4" }]]);

var IconDice4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice4
});

var IconDice5 = createReactComponent("outline", "dice-5", "IconDice5", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["circle", { "cx": "8.5", "cy": "8.5", "r": ".5", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "15.5", "cy": "8.5", "r": ".5", "fill": "currentColor", "key": "svg-2" }], ["circle", { "cx": "15.5", "cy": "15.5", "r": ".5", "fill": "currentColor", "key": "svg-3" }], ["circle", { "cx": "8.5", "cy": "15.5", "r": ".5", "fill": "currentColor", "key": "svg-4" }], ["circle", { "cx": "12", "cy": "12", "r": ".5", "fill": "currentColor", "key": "svg-5" }]]);

var IconDice5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice5
});

var IconDice6 = createReactComponent("outline", "dice-6", "IconDice6", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["circle", { "cx": "8.5", "cy": "7.5", "r": ".5", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "15.5", "cy": "7.5", "r": ".5", "fill": "currentColor", "key": "svg-2" }], ["circle", { "cx": "8.5", "cy": "12", "r": ".5", "fill": "currentColor", "key": "svg-3" }], ["circle", { "cx": "15.5", "cy": "12", "r": ".5", "fill": "currentColor", "key": "svg-4" }], ["circle", { "cx": "15.5", "cy": "16.5", "r": ".5", "fill": "currentColor", "key": "svg-5" }], ["circle", { "cx": "8.5", "cy": "16.5", "r": ".5", "fill": "currentColor", "key": "svg-6" }]]);

var IconDice6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice6
});

var IconDice = createReactComponent("outline", "dice", "IconDice", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["circle", { "cx": "8.5", "cy": "8.5", "r": ".5", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "15.5", "cy": "8.5", "r": ".5", "fill": "currentColor", "key": "svg-2" }], ["circle", { "cx": "15.5", "cy": "15.5", "r": ".5", "fill": "currentColor", "key": "svg-3" }], ["circle", { "cx": "8.5", "cy": "15.5", "r": ".5", "fill": "currentColor", "key": "svg-4" }]]);

var IconDice$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice
});

var IconDimensions = createReactComponent("outline", "dimensions", "IconDimensions", [["path", { "d": "M3 5h11", "key": "svg-0" }], ["path", { "d": "M12 7l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M5 3l-2 2l2 2", "key": "svg-2" }], ["path", { "d": "M19 10v11", "key": "svg-3" }], ["path", { "d": "M17 19l2 2l2 -2", "key": "svg-4" }], ["path", { "d": "M21 12l-2 -2l-2 2", "key": "svg-5" }], ["path", { "d": "M3 10m0 2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2z", "key": "svg-6" }]]);

var IconDimensions$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDimensions
});

var IconDirectionArrows = createReactComponent("outline", "direction-arrows", "IconDirectionArrows", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M8 11l-1 1l1 1", "key": "svg-1" }], ["path", { "d": "M11 8l1 -1l1 1", "key": "svg-2" }], ["path", { "d": "M16 11l1 1l-1 1", "key": "svg-3" }], ["path", { "d": "M11 16l1 1l1 -1", "key": "svg-4" }]]);

var IconDirectionArrows$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDirectionArrows
});

var IconDirectionHorizontal = createReactComponent("outline", "direction-horizontal", "IconDirectionHorizontal", [["path", { "d": "M10 9l-3 3l3 3", "key": "svg-0" }], ["path", { "d": "M14 9l3 3l-3 3", "key": "svg-1" }]]);

var IconDirectionHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDirectionHorizontal
});

var IconDirectionSignOff = createReactComponent("outline", "direction-sign-off", "IconDirectionSignOff", [["path", { "d": "M18.73 14.724l1.949 -1.95a1.095 1.095 0 0 0 0 -1.548l-7.905 -7.905a1.095 1.095 0 0 0 -1.548 0l-1.95 1.95m-2.01 2.01l-3.945 3.945a1.095 1.095 0 0 0 0 1.548l7.905 7.905c.427 .428 1.12 .428 1.548 0l3.95 -3.95", "key": "svg-0" }], ["path", { "d": "M8 12h4", "key": "svg-1" }], ["path", { "d": "M13.748 13.752l-1.748 1.748", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconDirectionSignOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDirectionSignOff
});

var IconDirectionSign = createReactComponent("outline", "direction-sign", "IconDirectionSign", [["path", { "d": "M3.32 12.774l7.906 7.905c.427 .428 1.12 .428 1.548 0l7.905 -7.905a1.095 1.095 0 0 0 0 -1.548l-7.905 -7.905a1.095 1.095 0 0 0 -1.548 0l-7.905 7.905a1.095 1.095 0 0 0 0 1.548z", "key": "svg-0" }], ["path", { "d": "M8 12h7.5", "key": "svg-1" }], ["path", { "d": "M12 8.5l3.5 3.5l-3.5 3.5", "key": "svg-2" }]]);

var IconDirectionSign$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDirectionSign
});

var IconDirection = createReactComponent("outline", "direction", "IconDirection", [["path", { "d": "M9 10l3 -3l3 3", "key": "svg-0" }], ["path", { "d": "M9 14l3 3l3 -3", "key": "svg-1" }]]);

var IconDirection$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDirection
});

var IconDirectionsOff = createReactComponent("outline", "directions-off", "IconDirectionsOff", [["path", { "d": "M12 21v-4", "key": "svg-0" }], ["path", { "d": "M12 13v-1", "key": "svg-1" }], ["path", { "d": "M12 5v-2", "key": "svg-2" }], ["path", { "d": "M10 21h4", "key": "svg-3" }], ["path", { "d": "M8 8v1h1m4 0h6l2 -2l-2 -2h-10", "key": "svg-4" }], ["path", { "d": "M14 14v3h-8l-2 -2l2 -2h7", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconDirectionsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDirectionsOff
});

var IconDirections = createReactComponent("outline", "directions", "IconDirections", [["path", { "d": "M12 21v-4", "key": "svg-0" }], ["path", { "d": "M12 13v-4", "key": "svg-1" }], ["path", { "d": "M12 5v-2", "key": "svg-2" }], ["path", { "d": "M10 21h4", "key": "svg-3" }], ["path", { "d": "M8 5v4h11l2 -2l-2 -2z", "key": "svg-4" }], ["path", { "d": "M14 13v4h-8l-2 -2l2 -2z", "key": "svg-5" }]]);

var IconDirections$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDirections
});

var IconDisabled2 = createReactComponent("outline", "disabled-2", "IconDisabled2", [["path", { "d": "M17 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M9 11a5 5 0 1 0 3.95 7.95", "key": "svg-1" }], ["path", { "d": "M19 20l-4 -5h-4l3 -5l-4 -3l-4 1", "key": "svg-2" }]]);

var IconDisabled2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDisabled2
});

var IconDisabledOff = createReactComponent("outline", "disabled-off", "IconDisabledOff", [["path", { "d": "M11 7a2 2 0 1 0 -2 -2", "key": "svg-0" }], ["path", { "d": "M11 11v4h4l4 5", "key": "svg-1" }], ["path", { "d": "M15 11h1", "key": "svg-2" }], ["path", { "d": "M7 11.5a5 5 0 1 0 6 7.5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconDisabledOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDisabledOff
});

var IconDisabled = createReactComponent("outline", "disabled", "IconDisabled", [["path", { "d": "M11 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M11 7l0 8l4 0l4 5", "key": "svg-1" }], ["path", { "d": "M11 11l5 0", "key": "svg-2" }], ["path", { "d": "M7 11.5a5 5 0 1 0 6 7.5", "key": "svg-3" }]]);

var IconDisabled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDisabled
});

var IconDiscGolf = createReactComponent("outline", "disc-golf", "IconDiscGolf", [["path", { "d": "M5 5h14", "key": "svg-0" }], ["path", { "d": "M6 5c.32 6.744 2.74 9.246 6 10", "key": "svg-1" }], ["path", { "d": "M18 5c-.32 6.744 -2.74 9.246 -6 10", "key": "svg-2" }], ["path", { "d": "M10 5c0 4.915 .552 7.082 2 10", "key": "svg-3" }], ["path", { "d": "M14 5c0 4.915 -.552 7.082 -2 10", "key": "svg-4" }], ["path", { "d": "M12 15v6", "key": "svg-5" }], ["path", { "d": "M12 3v2", "key": "svg-6" }], ["path", { "d": "M7 16c.64 .64 1.509 1 2.414 1h5.172c.905 0 1.774 -.36 2.414 -1", "key": "svg-7" }], ["path", { "d": "M11 21h2", "key": "svg-8" }]]);

var IconDiscGolf$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiscGolf
});

var IconDiscOff = createReactComponent("outline", "disc-off", "IconDiscOff", [["path", { "d": "M20.044 16.04a9 9 0 0 0 -12.082 -12.085m-2.333 1.688a9 9 0 0 0 6.371 15.357c2.491 0 4.73 -1 6.36 -2.631", "key": "svg-0" }], ["path", { "d": "M11.298 11.288a1 1 0 1 0 1.402 1.427", "key": "svg-1" }], ["path", { "d": "M7 12c0 -1.38 .559 -2.629 1.462 -3.534m2.607 -1.38c.302 -.056 .613 -.086 .931 -.086", "key": "svg-2" }], ["path", { "d": "M12 17a4.985 4.985 0 0 0 3.551 -1.48m1.362 -2.587c.057 -.302 .087 -.614 .087 -.933", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconDiscOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiscOff
});

var IconDisc = createReactComponent("outline", "disc", "IconDisc", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M7 12a5 5 0 0 1 5 -5", "key": "svg-2" }], ["path", { "d": "M12 17a5 5 0 0 0 5 -5", "key": "svg-3" }]]);

var IconDisc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDisc
});

var IconDiscountOff = createReactComponent("outline", "discount-off", "IconDiscountOff", [["path", { "d": "M9 15l3 -3m2 -2l1 -1", "key": "svg-0" }], ["path", { "d": "M9.148 9.145a.498 .498 0 0 0 .352 .855a.5 .5 0 0 0 .35 -.142", "key": "svg-1" }], ["path", { "d": "M14.148 14.145a.498 .498 0 0 0 .352 .855a.5 .5 0 0 0 .35 -.142", "key": "svg-2" }], ["path", { "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconDiscountOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiscountOff
});

var IconDiscount = createReactComponent("outline", "discount", "IconDiscount", [["path", { "d": "M9 15l6 -6", "key": "svg-0" }], ["circle", { "cx": "9.5", "cy": "9.5", "r": ".5", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "14.5", "cy": "14.5", "r": ".5", "fill": "currentColor", "key": "svg-2" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-3" }]]);

var IconDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiscount
});

var IconDivide = createReactComponent("outline", "divide", "IconDivide", [["circle", { "cx": "12", "cy": "6", "r": "1", "fill": "currentColor", "key": "svg-0" }], ["circle", { "cx": "12", "cy": "18", "r": "1", "fill": "currentColor", "key": "svg-1" }], ["path", { "d": "M5 12l14 0", "key": "svg-2" }]]);

var IconDivide$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDivide
});

var IconDna2Off = createReactComponent("outline", "dna-2-off", "IconDna2Off", [["path", { "d": "M17 3v1c-.007 2.46 -.91 4.554 -2.705 6.281m-2.295 1.719c-3.328 1.99 -5 4.662 -5.008 8.014v1", "key": "svg-0" }], ["path", { "d": "M17 21.014v-1c0 -1.44 -.315 -2.755 -.932 -3.944m-4.068 -4.07c-1.903 -1.138 -3.263 -2.485 -4.082 -4.068", "key": "svg-1" }], ["path", { "d": "M8 4h9", "key": "svg-2" }], ["path", { "d": "M7 20h10", "key": "svg-3" }], ["path", { "d": "M12 8h4", "key": "svg-4" }], ["path", { "d": "M8 16h8", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconDna2Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDna2Off
});

var IconDna2 = createReactComponent("outline", "dna-2", "IconDna2", [["path", { "d": "M17 3v1c-.01 3.352 -1.68 6.023 -5.008 8.014c-3.328 1.99 3.336 -2 .008 -.014c-3.328 1.99 -5 4.662 -5.008 8.014v1", "key": "svg-0" }], ["path", { "d": "M17 21.014v-1c-.01 -3.352 -1.68 -6.023 -5.008 -8.014c-3.328 -1.99 3.336 2 .008 .014c-3.328 -1.991 -5 -4.662 -5.008 -8.014v-1", "key": "svg-1" }], ["path", { "d": "M7 4h10", "key": "svg-2" }], ["path", { "d": "M7 20h10", "key": "svg-3" }], ["path", { "d": "M8 8h8", "key": "svg-4" }], ["path", { "d": "M8 16h8", "key": "svg-5" }]]);

var IconDna2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDna2
});

var IconDnaOff = createReactComponent("outline", "dna-off", "IconDnaOff", [["path", { "d": "M16 12a3.898 3.898 0 0 0 -1.172 -2.828a4.027 4.027 0 0 0 -2.828 -1.172m-2.828 1.172a4 4 0 1 0 5.656 5.656", "key": "svg-0" }], ["path", { "d": "M9.172 20.485a4 4 0 1 0 -5.657 -5.657", "key": "svg-1" }], ["path", { "d": "M14.828 3.515a4 4 0 1 0 5.657 5.657", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconDnaOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDnaOff
});

var IconDna = createReactComponent("outline", "dna", "IconDna", [["path", { "d": "M14.828 14.828a4 4 0 1 0 -5.656 -5.656a4 4 0 0 0 5.656 5.656z", "key": "svg-0" }], ["path", { "d": "M9.172 20.485a4 4 0 1 0 -5.657 -5.657", "key": "svg-1" }], ["path", { "d": "M14.828 3.515a4 4 0 0 0 5.657 5.657", "key": "svg-2" }]]);

var IconDna$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDna
});

var IconDogBowl = createReactComponent("outline", "dog-bowl", "IconDogBowl", [["path", { "d": "M10 15l5.586 -5.585a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-3.587 3.586", "key": "svg-0" }], ["path", { "d": "M12 13l-3.586 -3.585a2 2 0 1 0 -3.414 -1.415a2 2 0 1 0 1.413 3.414l3.587 3.586", "key": "svg-1" }], ["path", { "d": "M3 20h18c-.175 -1.671 -.046 -3.345 -2 -5h-14c-1.333 1 -2 2.667 -2 5z", "key": "svg-2" }]]);

var IconDogBowl$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDogBowl
});

var IconDog = createReactComponent("outline", "dog", "IconDog", [["path", { "d": "M11 5h2", "key": "svg-0" }], ["path", { "d": "M19 12c-.667 5.333 -2.333 8 -5 8h-4c-2.667 0 -4.333 -2.667 -5 -8", "key": "svg-1" }], ["path", { "d": "M11 16c0 .667 .333 1 1 1s1 -.333 1 -1h-2z", "key": "svg-2" }], ["path", { "d": "M12 18v2", "key": "svg-3" }], ["path", { "d": "M10 11v.01", "key": "svg-4" }], ["path", { "d": "M14 11v.01", "key": "svg-5" }], ["path", { "d": "M5 4l6 .97l-6.238 6.688a1.021 1.021 0 0 1 -1.41 .111a.953 .953 0 0 1 -.327 -.954l1.975 -6.815z", "key": "svg-6" }], ["path", { "d": "M19 4l-6 .97l6.238 6.688c.358 .408 .989 .458 1.41 .111a.953 .953 0 0 0 .327 -.954l-1.975 -6.815z", "key": "svg-7" }]]);

var IconDog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDog
});

var IconDoorEnter = createReactComponent("outline", "door-enter", "IconDoorEnter", [["path", { "d": "M13 12v.01", "key": "svg-0" }], ["path", { "d": "M3 21h18", "key": "svg-1" }], ["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h6m4 10.5v7.5", "key": "svg-2" }], ["path", { "d": "M21 7h-7m3 -3l-3 3l3 3", "key": "svg-3" }]]);

var IconDoorEnter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDoorEnter
});

var IconDoorExit = createReactComponent("outline", "door-exit", "IconDoorExit", [["path", { "d": "M13 12v.01", "key": "svg-0" }], ["path", { "d": "M3 21h18", "key": "svg-1" }], ["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h7.5m2.5 10.5v7.5", "key": "svg-2" }], ["path", { "d": "M14 7h7m-3 -3l3 3l-3 3", "key": "svg-3" }]]);

var IconDoorExit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDoorExit
});

var IconDoorOff = createReactComponent("outline", "door-off", "IconDoorOff", [["path", { "d": "M3 21h18", "key": "svg-0" }], ["path", { "d": "M6 21v-15", "key": "svg-1" }], ["path", { "d": "M7.18 3.175c.25 -.112 .528 -.175 .82 -.175h8a2 2 0 0 1 2 2v9", "key": "svg-2" }], ["path", { "d": "M18 18v3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconDoorOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDoorOff
});

var IconDoor = createReactComponent("outline", "door", "IconDoor", [["path", { "d": "M14 12v.01", "key": "svg-0" }], ["path", { "d": "M3 21h18", "key": "svg-1" }], ["path", { "d": "M6 21v-16a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v16", "key": "svg-2" }]]);

var IconDoor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDoor
});

var IconDotsCircleHorizontal = createReactComponent("outline", "dots-circle-horizontal", "IconDotsCircleHorizontal", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M8 12l0 .01", "key": "svg-1" }], ["path", { "d": "M12 12l0 .01", "key": "svg-2" }], ["path", { "d": "M16 12l0 .01", "key": "svg-3" }]]);

var IconDotsCircleHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDotsCircleHorizontal
});

var IconDotsDiagonal2 = createReactComponent("outline", "dots-diagonal-2", "IconDotsDiagonal2", [["path", { "d": "M7 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M17 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }]]);

var IconDotsDiagonal2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDotsDiagonal2
});

var IconDotsDiagonal = createReactComponent("outline", "dots-diagonal", "IconDotsDiagonal", [["path", { "d": "M7 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M17 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }]]);

var IconDotsDiagonal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDotsDiagonal
});

var IconDotsVertical = createReactComponent("outline", "dots-vertical", "IconDotsVertical", [["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }]]);

var IconDotsVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDotsVertical
});

var IconDots = createReactComponent("outline", "dots", "IconDots", [["path", { "d": "M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }]]);

var IconDots$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDots
});

var IconDownloadOff = createReactComponent("outline", "download-off", "IconDownloadOff", [["path", { "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 1.83 -1.19", "key": "svg-0" }], ["path", { "d": "M7 11l5 5l2 -2m2 -2l1 -1", "key": "svg-1" }], ["path", { "d": "M12 4v4m0 4v4", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconDownloadOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDownloadOff
});

var IconDownload = createReactComponent("outline", "download", "IconDownload", [["path", { "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2", "key": "svg-0" }], ["path", { "d": "M7 11l5 5l5 -5", "key": "svg-1" }], ["path", { "d": "M12 4l0 12", "key": "svg-2" }]]);

var IconDownload$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDownload
});

var IconDragDrop2 = createReactComponent("outline", "drag-drop-2", "IconDragDrop2", [["path", { "d": "M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 4l0 .01", "key": "svg-1" }], ["path", { "d": "M8 4l0 .01", "key": "svg-2" }], ["path", { "d": "M12 4l0 .01", "key": "svg-3" }], ["path", { "d": "M16 4l0 .01", "key": "svg-4" }], ["path", { "d": "M4 8l0 .01", "key": "svg-5" }], ["path", { "d": "M4 12l0 .01", "key": "svg-6" }], ["path", { "d": "M4 16l0 .01", "key": "svg-7" }]]);

var IconDragDrop2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDragDrop2
});

var IconDragDrop = createReactComponent("outline", "drag-drop", "IconDragDrop", [["path", { "d": "M19 11v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2", "key": "svg-0" }], ["path", { "d": "M13 13l9 3l-4 2l-2 4l-3 -9", "key": "svg-1" }], ["path", { "d": "M3 3l0 .01", "key": "svg-2" }], ["path", { "d": "M7 3l0 .01", "key": "svg-3" }], ["path", { "d": "M11 3l0 .01", "key": "svg-4" }], ["path", { "d": "M15 3l0 .01", "key": "svg-5" }], ["path", { "d": "M3 7l0 .01", "key": "svg-6" }], ["path", { "d": "M3 11l0 .01", "key": "svg-7" }], ["path", { "d": "M3 15l0 .01", "key": "svg-8" }]]);

var IconDragDrop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDragDrop
});

var IconDroneOff = createReactComponent("outline", "drone-off", "IconDroneOff", [["path", { "d": "M14 14h-4v-4", "key": "svg-0" }], ["path", { "d": "M10 10l-3.5 -3.5", "key": "svg-1" }], ["path", { "d": "M9.957 5.95a3.503 3.503 0 0 0 -2.917 -2.91m-3.02 .989a3.5 3.5 0 0 0 1.98 5.936", "key": "svg-2" }], ["path", { "d": "M14 10l3.5 -3.5", "key": "svg-3" }], ["path", { "d": "M18 9.965a3.5 3.5 0 1 0 -3.966 -3.965", "key": "svg-4" }], ["path", { "d": "M14 14l3.5 3.5", "key": "svg-5" }], ["path", { "d": "M14.035 18a3.5 3.5 0 0 0 5.936 1.98m.987 -3.026a3.503 3.503 0 0 0 -2.918 -2.913", "key": "svg-6" }], ["path", { "d": "M10 14l-3.5 3.5", "key": "svg-7" }], ["path", { "d": "M6 14.035a3.5 3.5 0 1 0 3.966 3.965", "key": "svg-8" }], ["path", { "d": "M3 3l18 18", "key": "svg-9" }]]);

var IconDroneOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDroneOff
});

var IconDrone = createReactComponent("outline", "drone", "IconDrone", [["path", { "d": "M10 10h4v4h-4z", "key": "svg-0" }], ["path", { "d": "M10 10l-3.5 -3.5", "key": "svg-1" }], ["path", { "d": "M9.96 6a3.5 3.5 0 1 0 -3.96 3.96", "key": "svg-2" }], ["path", { "d": "M14 10l3.5 -3.5", "key": "svg-3" }], ["path", { "d": "M18 9.96a3.5 3.5 0 1 0 -3.96 -3.96", "key": "svg-4" }], ["path", { "d": "M14 14l3.5 3.5", "key": "svg-5" }], ["path", { "d": "M14.04 18a3.5 3.5 0 1 0 3.96 -3.96", "key": "svg-6" }], ["path", { "d": "M10 14l-3.5 3.5", "key": "svg-7" }], ["path", { "d": "M6 14.04a3.5 3.5 0 1 0 3.96 3.96", "key": "svg-8" }]]);

var IconDrone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDrone
});

var IconDropCircle = createReactComponent("outline", "drop-circle", "IconDropCircle", [["path", { "d": "M10.07 15.34c1.115 .88 2.74 .88 3.855 0c1.115 -.88 1.398 -2.388 .671 -3.575l-2.596 -3.765l-2.602 3.765c-.726 1.187 -.443 2.694 .672 3.575z", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconDropCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropCircle
});

var IconDropletBolt = createReactComponent("outline", "droplet-bolt", "IconDropletBolt", [["path", { "d": "M18.628 12.076a6.653 6.653 0 0 0 -.564 -1.199l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546c1.7 1.375 3.906 1.852 5.958 1.431", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }]]);

var IconDropletBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletBolt
});

var IconDropletCancel = createReactComponent("outline", "droplet-cancel", "IconDropletCancel", [["path", { "d": "M18.606 12.014a6.659 6.659 0 0 0 -.542 -1.137l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.154 7.154 0 0 0 4.826 1.572", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }]]);

var IconDropletCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletCancel
});

var IconDropletCheck = createReactComponent("outline", "droplet-check", "IconDropletCheck", [["path", { "d": "M18.967 13.594a6.568 6.568 0 0 0 -.903 -2.717l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.125 7.125 0 0 0 4.04 1.565", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }]]);

var IconDropletCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletCheck
});

var IconDropletCode = createReactComponent("outline", "droplet-code", "IconDropletCode", [["path", { "d": "M18.907 13.147a6.586 6.586 0 0 0 -.843 -2.27l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.123 7.123 0 0 0 3.99 1.561", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }]]);

var IconDropletCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletCode
});

var IconDropletCog = createReactComponent("outline", "droplet-cog", "IconDropletCog", [["path", { "d": "M18.421 11.56a6.702 6.702 0 0 0 -.357 -.683l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.144 7.144 0 0 0 4.518 1.58", "key": "svg-0" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-2" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-3" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-7" }]]);

var IconDropletCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletCog
});

var IconDropletDollar = createReactComponent("outline", "droplet-dollar", "IconDropletDollar", [["path", { "d": "M17.668 10.29l-4.493 -6.673c-.421 -.625 -1.288 -.803 -1.937 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.175 7.175 0 0 0 5.493 1.51", "key": "svg-0" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-2" }]]);

var IconDropletDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletDollar
});

var IconDropletDown = createReactComponent("outline", "droplet-down", "IconDropletDown", [["path", { "d": "M18.602 12.003a6.66 6.66 0 0 0 -.538 -1.126l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.159 7.159 0 0 0 4.972 1.564", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }]]);

var IconDropletDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletDown
});

var IconDropletExclamation = createReactComponent("outline", "droplet-exclamation", "IconDropletExclamation", [["path", { "d": "M18.602 12.004a6.66 6.66 0 0 0 -.538 -1.127l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546c2.142 1.734 5.092 2.04 7.519 .919", "key": "svg-0" }], ["path", { "d": "M19 16v3", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }]]);

var IconDropletExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletExclamation
});

var IconDropletHalf2 = createReactComponent("outline", "droplet-half-2", "IconDropletHalf2", [["path", { "d": "M7.502 19.423c2.602 2.105 6.395 2.105 8.996 0c2.602 -2.105 3.262 -5.708 1.566 -8.546l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546z", "key": "svg-0" }], ["path", { "d": "M5 14h14", "key": "svg-1" }]]);

var IconDropletHalf2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletHalf2
});

var IconDropletHalf = createReactComponent("outline", "droplet-half", "IconDropletHalf", [["path", { "d": "M7.502 19.423c2.602 2.105 6.395 2.105 8.996 0c2.602 -2.105 3.262 -5.708 1.566 -8.546l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546z", "key": "svg-0" }], ["path", { "d": "M12 3v18", "key": "svg-1" }]]);

var IconDropletHalf$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletHalf
});

var IconDropletHeart = createReactComponent("outline", "droplet-heart", "IconDropletHeart", [["path", { "d": "M18.288 11.282a6.734 6.734 0 0 0 -.224 -.405l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.117 7.117 0 0 0 3.824 1.548", "key": "svg-0" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-1" }]]);

var IconDropletHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletHeart
});

var IconDropletMinus = createReactComponent("outline", "droplet-minus", "IconDropletMinus", [["path", { "d": "M18.946 15.083a6.538 6.538 0 0 0 -.882 -4.206l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.163 7.163 0 0 0 5.089 1.555", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconDropletMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletMinus
});

var IconDropletOff = createReactComponent("outline", "droplet-off", "IconDropletOff", [["path", { "d": "M18.963 14.938a6.54 6.54 0 0 0 -.899 -4.06l-4.89 -7.26c-.42 -.626 -1.287 -.804 -1.936 -.398a1.376 1.376 0 0 0 -.41 .397l-1.282 1.9m-1.625 2.415l-1.986 2.946c-1.695 2.837 -1.035 6.44 1.567 8.545c2.602 2.105 6.395 2.105 8.996 0a6.83 6.83 0 0 0 1.376 -1.499", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconDropletOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletOff
});

var IconDropletPause = createReactComponent("outline", "droplet-pause", "IconDropletPause", [["path", { "d": "M18.952 13.456a6.573 6.573 0 0 0 -.888 -2.579l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.176 7.176 0 0 0 5.517 1.507", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }]]);

var IconDropletPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletPause
});

var IconDropletPin = createReactComponent("outline", "droplet-pin", "IconDropletPin", [["path", { "d": "M18.064 10.877l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.163 7.163 0 0 0 5.102 1.554", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }]]);

var IconDropletPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletPin
});

var IconDropletPlus = createReactComponent("outline", "droplet-plus", "IconDropletPlus", [["path", { "d": "M18.602 12.004a6.66 6.66 0 0 0 -.538 -1.127l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.16 7.16 0 0 0 5.033 1.56", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconDropletPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletPlus
});

var IconDropletQuestion = createReactComponent("outline", "droplet-question", "IconDropletQuestion", [["path", { "d": "M18.064 10.877l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546c2.203 1.782 5.259 2.056 7.723 .82", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconDropletQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletQuestion
});

var IconDropletSearch = createReactComponent("outline", "droplet-search", "IconDropletSearch", [["path", { "d": "M18.064 10.877l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.13 7.13 0 0 0 4.168 1.572", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }]]);

var IconDropletSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletSearch
});

var IconDropletShare = createReactComponent("outline", "droplet-share", "IconDropletShare", [["path", { "d": "M18.884 13.025a6.591 6.591 0 0 0 -.82 -2.148l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.125 7.125 0 0 0 4.498 1.58", "key": "svg-0" }], ["path", { "d": "M16 22l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-2" }]]);

var IconDropletShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletShare
});

var IconDropletStar = createReactComponent("outline", "droplet-star", "IconDropletStar", [["path", { "d": "M17.496 10.034l-4.321 -6.417c-.421 -.625 -1.288 -.803 -1.937 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.106 7.106 0 0 0 3.547 1.517", "key": "svg-0" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }]]);

var IconDropletStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletStar
});

var IconDropletUp = createReactComponent("outline", "droplet-up", "IconDropletUp", [["path", { "d": "M18.6 11.998a6.66 6.66 0 0 0 -.536 -1.12l-4.89 -7.26c-.42 -.626 -1.287 -.804 -1.936 -.398a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.16 7.16 0 0 0 5.002 1.562", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }]]);

var IconDropletUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletUp
});

var IconDropletX = createReactComponent("outline", "droplet-x", "IconDropletX", [["path", { "d": "M18.953 13.467a6.572 6.572 0 0 0 -.889 -2.59l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.179 7.179 0 0 0 5.633 1.49", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }]]);

var IconDropletX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletX
});

var IconDroplet = createReactComponent("outline", "droplet", "IconDroplet", [["path", { "d": "M7.502 19.423c2.602 2.105 6.395 2.105 8.996 0c2.602 -2.105 3.262 -5.708 1.566 -8.546l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546z", "key": "svg-0" }]]);

var IconDroplet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDroplet
});

var IconDroplets = createReactComponent("outline", "droplets", "IconDroplets", [["path", { "d": "M4.072 20.3a2.999 2.999 0 0 0 3.856 0a3.002 3.002 0 0 0 .67 -3.798l-2.095 -3.227a.6 .6 0 0 0 -1.005 0l-2.098 3.227a3.003 3.003 0 0 0 .671 3.798z", "key": "svg-0" }], ["path", { "d": "M16.072 20.3a2.999 2.999 0 0 0 3.856 0a3.002 3.002 0 0 0 .67 -3.798l-2.095 -3.227a.6 .6 0 0 0 -1.005 0l-2.098 3.227a3.003 3.003 0 0 0 .671 3.798z", "key": "svg-1" }], ["path", { "d": "M10.072 10.3a2.999 2.999 0 0 0 3.856 0a3.002 3.002 0 0 0 .67 -3.798l-2.095 -3.227a.6 .6 0 0 0 -1.005 0l-2.098 3.227a3.003 3.003 0 0 0 .671 3.798z", "key": "svg-2" }]]);

var IconDroplets$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDroplets
});

var IconDualScreen = createReactComponent("outline", "dual-screen", "IconDualScreen", [["path", { "d": "M5 4l8 3v15l-8 -3z", "key": "svg-0" }], ["path", { "d": "M13 19h6v-15h-14", "key": "svg-1" }]]);

var IconDualScreen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDualScreen
});

var IconDumpling = createReactComponent("outline", "dumpling", "IconDumpling", [["path", { "d": "M5.532 5.532a2.53 2.53 0 0 1 2.56 -.623a2.532 2.532 0 0 1 4.604 -.717q .146 -.24 .356 -.45a2.532 2.532 0 0 1 4.318 1.637a2.53 2.53 0 0 1 2.844 .511l.358 .358c1.384 1.385 -.7 5.713 -4.655 9.669c-3.956 3.955 -8.284 6.04 -9.669 4.655l-.358 -.358l-.114 -.122a2.53 2.53 0 0 1 -.398 -2.724a2.532 2.532 0 0 1 -1.186 -4.675a2.532 2.532 0 0 1 .718 -4.603a2.53 2.53 0 0 1 .622 -2.558", "key": "svg-0" }]]);

var IconDumpling$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDumpling
});

var IconEPassport = createReactComponent("outline", "e-passport", "IconEPassport", [["path", { "d": "M2 5m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M9 12h-7", "key": "svg-2" }], ["path", { "d": "M15 12h7", "key": "svg-3" }]]);

var IconEPassport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEPassport
});

var IconEarOff = createReactComponent("outline", "ear-off", "IconEarOff", [["path", { "d": "M6 10c0 -1.146 .277 -2.245 .78 -3.219m1.792 -2.208a7 7 0 0 1 10.428 9.027a10 10 0 0 1 -.633 .762m-2.045 1.96a8 8 0 0 0 -1.322 2.278a4.5 4.5 0 0 1 -6.8 1.4", "key": "svg-0" }], ["path", { "d": "M11.42 7.414a3 3 0 0 1 4.131 4.13", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconEarOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEarOff
});

var IconEarScan = createReactComponent("outline", "ear-scan", "IconEarScan", [["path", { "d": "M15 15a2 2 0 0 1 -2 2c-.732 0 -1.555 -.247 -1.72 -.98c-.634 -2.8 -3.17 -2.628 -3.28 -5.02v-.5a3.5 3.5 0 0 1 6.671 -1.483", "key": "svg-0" }], ["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-2" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-3" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-4" }], ["path", { "d": "M13 12v.01", "key": "svg-5" }]]);

var IconEarScan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEarScan
});

var IconEar = createReactComponent("outline", "ear", "IconEar", [["path", { "d": "M6 10a7 7 0 1 1 13 3.6a10 10 0 0 1 -2 2a8 8 0 0 0 -2 3a4.5 4.5 0 0 1 -6.8 1.4", "key": "svg-0" }], ["path", { "d": "M10 10a3 3 0 1 1 5 2.2", "key": "svg-1" }]]);

var IconEar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEar
});

var IconEaseInControlPoint = createReactComponent("outline", "ease-in-control-point", "IconEaseInControlPoint", [["path", { "d": "M3 19c8 0 18 -16 18 -16", "key": "svg-0" }], ["path", { "d": "M17 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0z", "key": "svg-1" }], ["path", { "d": "M17 19h-2", "key": "svg-2" }], ["path", { "d": "M12 19h-2", "key": "svg-3" }]]);

var IconEaseInControlPoint$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEaseInControlPoint
});

var IconEaseInOutControlPoints = createReactComponent("outline", "ease-in-out-control-points", "IconEaseInOutControlPoints", [["path", { "d": "M17 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0z", "key": "svg-0" }], ["path", { "d": "M17 20h-2", "key": "svg-1" }], ["path", { "d": "M7 4a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z", "key": "svg-2" }], ["path", { "d": "M7 4h2", "key": "svg-3" }], ["path", { "d": "M14 4h-2", "key": "svg-4" }], ["path", { "d": "M12 20h-2", "key": "svg-5" }], ["path", { "d": "M3 20c8 0 10 -16 18 -16", "key": "svg-6" }]]);

var IconEaseInOutControlPoints$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEaseInOutControlPoints
});

var IconEaseInOut = createReactComponent("outline", "ease-in-out", "IconEaseInOut", [["path", { "d": "M3 20c8 0 10 -16 18 -16", "key": "svg-0" }]]);

var IconEaseInOut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEaseInOut
});

var IconEaseIn = createReactComponent("outline", "ease-in", "IconEaseIn", [["path", { "d": "M3 20c8 0 18 -16 18 -16", "key": "svg-0" }]]);

var IconEaseIn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEaseIn
});

var IconEaseOutControlPoint = createReactComponent("outline", "ease-out-control-point", "IconEaseOutControlPoint", [["path", { "d": "M3 21s10 -16 18 -16", "key": "svg-0" }], ["path", { "d": "M7 5a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z", "key": "svg-1" }], ["path", { "d": "M7 5h2", "key": "svg-2" }], ["path", { "d": "M14 5h-2", "key": "svg-3" }]]);

var IconEaseOutControlPoint$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEaseOutControlPoint
});

var IconEaseOut = createReactComponent("outline", "ease-out", "IconEaseOut", [["path", { "d": "M3 20s10 -16 18 -16", "key": "svg-0" }]]);

var IconEaseOut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEaseOut
});

var IconEditCircleOff = createReactComponent("outline", "edit-circle-off", "IconEditCircleOff", [["path", { "d": "M10.507 10.498l-1.507 1.502v3h3l1.493 -1.498m2 -2.01l4.89 -4.907a2.1 2.1 0 0 0 -2.97 -2.97l-4.913 4.896", "key": "svg-0" }], ["path", { "d": "M16 5l3 3", "key": "svg-1" }], ["path", { "d": "M7.476 7.471a7 7 0 0 0 2.524 13.529a7 7 0 0 0 6.53 -4.474", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconEditCircleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEditCircleOff
});

var IconEditCircle = createReactComponent("outline", "edit-circle", "IconEditCircle", [["path", { "d": "M12 15l8.385 -8.415a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3z", "key": "svg-0" }], ["path", { "d": "M16 5l3 3", "key": "svg-1" }], ["path", { "d": "M9 7.07a7 7 0 0 0 1 13.93a7 7 0 0 0 6.929 -6", "key": "svg-2" }]]);

var IconEditCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEditCircle
});

var IconEditOff = createReactComponent("outline", "edit-off", "IconEditOff", [["path", { "d": "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1", "key": "svg-0" }], ["path", { "d": "M10.507 10.498l-1.507 1.502v3h3l1.493 -1.498m2 -2.01l4.89 -4.907a2.1 2.1 0 0 0 -2.97 -2.97l-4.913 4.896", "key": "svg-1" }], ["path", { "d": "M16 5l3 3", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconEditOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEditOff
});

var IconEdit = createReactComponent("outline", "edit", "IconEdit", [["path", { "d": "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1", "key": "svg-0" }], ["path", { "d": "M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z", "key": "svg-1" }], ["path", { "d": "M16 5l3 3", "key": "svg-2" }]]);

var IconEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEdit
});

var IconEggCracked = createReactComponent("outline", "egg-cracked", "IconEggCracked", [["path", { "d": "M19 14.083c0 4.154 -2.966 6.74 -7 6.917c-4.2 0 -7 -2.763 -7 -6.917c0 -5.538 3.5 -11.09 7 -11.083c3.5 .007 7 5.545 7 11.083z", "key": "svg-0" }], ["path", { "d": "M12 3l-1.5 5l3.5 2.5l-2 3.5", "key": "svg-1" }]]);

var IconEggCracked$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEggCracked
});

var IconEggFried = createReactComponent("outline", "egg-fried", "IconEggFried", [["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M14 3a5 5 0 0 1 4.872 6.13a3 3 0 0 1 .178 5.681a3 3 0 1 1 -4.684 3.626a5 5 0 1 1 -8.662 -5a5 5 0 1 1 4.645 -8.856a4.982 4.982 0 0 1 3.651 -1.585z", "key": "svg-1" }]]);

var IconEggFried$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEggFried
});

var IconEggOff = createReactComponent("outline", "egg-off", "IconEggOff", [["path", { "d": "M17.927 17.934c-1.211 1.858 -3.351 2.953 -5.927 3.066c-4.2 0 -7 -2.763 -7 -6.917c0 -2.568 .753 -5.14 1.91 -7.158", "key": "svg-0" }], ["path", { "d": "M8.642 4.628c1.034 -1.02 2.196 -1.63 3.358 -1.628c3.5 .007 7 5.545 7 11.083c0 .298 -.015 .587 -.045 .868", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconEggOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEggOff
});

var IconEgg = createReactComponent("outline", "egg", "IconEgg", [["path", { "d": "M19 14.083c0 4.154 -2.966 6.74 -7 6.917c-4.2 0 -7 -2.763 -7 -6.917c0 -5.538 3.5 -11.09 7 -11.083c3.5 .007 7 5.545 7 11.083z", "key": "svg-0" }]]);

var IconEgg$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEgg
});

var IconEggs = createReactComponent("outline", "eggs", "IconEggs", [["path", { "d": "M13 22c-3 0 -4.868 -2.118 -5 -5c0 -3 2 -5 5 -5c4 0 8.01 2.5 8 5c0 2.5 -4 5 -8 5z", "key": "svg-0" }], ["path", { "d": "M8 18c-3.03 -.196 -5 -2.309 -5 -5.38c0 -4.307 2.75 -8.625 5.5 -8.62c2.614 0 5.248 3.915 5.5 8", "key": "svg-1" }]]);

var IconEggs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEggs
});

var IconElevatorOff = createReactComponent("outline", "elevator-off", "IconElevatorOff", [["path", { "d": "M8 4h10a1 1 0 0 1 1 1v10m0 4a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-14", "key": "svg-0" }], ["path", { "d": "M12 8l2 2", "key": "svg-1" }], ["path", { "d": "M10 14l2 2l2 -2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconElevatorOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconElevatorOff
});

var IconElevator = createReactComponent("outline", "elevator", "IconElevator", [["path", { "d": "M5 4m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M10 10l2 -2l2 2", "key": "svg-1" }], ["path", { "d": "M10 14l2 2l2 -2", "key": "svg-2" }]]);

var IconElevator$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconElevator
});

var IconEmergencyBed = createReactComponent("outline", "emergency-bed", "IconEmergencyBed", [["path", { "d": "M16 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M8 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M4 8l2.1 2.8a3 3 0 0 0 2.4 1.2h11.5", "key": "svg-2" }], ["path", { "d": "M10 6h4", "key": "svg-3" }], ["path", { "d": "M12 4v4", "key": "svg-4" }], ["path", { "d": "M12 12v2l-2.5 2.5", "key": "svg-5" }], ["path", { "d": "M14.5 16.5l-2.5 -2.5", "key": "svg-6" }]]);

var IconEmergencyBed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEmergencyBed
});

var IconEmpathizeOff = createReactComponent("outline", "empathize-off", "IconEmpathizeOff", [["path", { "d": "M12 8a2.5 2.5 0 1 0 -2.5 -2.5", "key": "svg-0" }], ["path", { "d": "M12.317 12.315l-.317 .317l-.728 -.727a3.088 3.088 0 1 0 -4.367 4.367l5.095 5.096l4.689 -4.69m1.324 -2.673a3.087 3.087 0 0 0 -3.021 -3.018", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconEmpathizeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEmpathizeOff
});

var IconEmpathize = createReactComponent("outline", "empathize", "IconEmpathize", [["path", { "d": "M12 5.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-0" }], ["path", { "d": "M12 21.368l5.095 -5.096a3.088 3.088 0 1 0 -4.367 -4.367l-.728 .727l-.728 -.727a3.088 3.088 0 1 0 -4.367 4.367l5.095 5.096z", "key": "svg-1" }]]);

var IconEmpathize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEmpathize
});

var IconEmphasis = createReactComponent("outline", "emphasis", "IconEmphasis", [["path", { "d": "M16 5h-8v10h8m-1 -5h-7", "key": "svg-0" }], ["path", { "d": "M6 20l0 .01", "key": "svg-1" }], ["path", { "d": "M10 20l0 .01", "key": "svg-2" }], ["path", { "d": "M14 20l0 .01", "key": "svg-3" }], ["path", { "d": "M18 20l0 .01", "key": "svg-4" }]]);

var IconEmphasis$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEmphasis
});

var IconEngineOff = createReactComponent("outline", "engine-off", "IconEngineOff", [["path", { "d": "M3 10v6", "key": "svg-0" }], ["path", { "d": "M12 5v3", "key": "svg-1" }], ["path", { "d": "M10 5h4", "key": "svg-2" }], ["path", { "d": "M5 13h-2", "key": "svg-3" }], ["path", { "d": "M16 16h-1v2a1 1 0 0 1 -1 1h-3.465a1 1 0 0 1 -.832 -.445l-1.703 -2.555h-2v-6h2l.99 -.99m3.01 -1.01h1.382a1 1 0 0 1 .894 .553l1.448 2.894a1 1 0 0 0 .894 .553h1.382v-2h2a1 1 0 0 1 1 1v6", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconEngineOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEngineOff
});

var IconEngine = createReactComponent("outline", "engine", "IconEngine", [["path", { "d": "M3 10v6", "key": "svg-0" }], ["path", { "d": "M12 5v3", "key": "svg-1" }], ["path", { "d": "M10 5h4", "key": "svg-2" }], ["path", { "d": "M5 13h-2", "key": "svg-3" }], ["path", { "d": "M6 10h2l2 -2h3.382a1 1 0 0 1 .894 .553l1.448 2.894a1 1 0 0 0 .894 .553h1.382v-2h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2v-2h-3v2a1 1 0 0 1 -1 1h-3.465a1 1 0 0 1 -.832 -.445l-1.703 -2.555h-2v-6z", "key": "svg-4" }]]);

var IconEngine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEngine
});

var IconEqualDouble = createReactComponent("outline", "equal-double", "IconEqualDouble", [["path", { "d": "M3 10h7", "key": "svg-0" }], ["path", { "d": "M3 14h7", "key": "svg-1" }], ["path", { "d": "M14 10h7", "key": "svg-2" }], ["path", { "d": "M14 14h7", "key": "svg-3" }]]);

var IconEqualDouble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEqualDouble
});

var IconEqualNot = createReactComponent("outline", "equal-not", "IconEqualNot", [["path", { "d": "M5 10h14", "key": "svg-0" }], ["path", { "d": "M5 14h14", "key": "svg-1" }], ["path", { "d": "M5 19l14 -14", "key": "svg-2" }]]);

var IconEqualNot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEqualNot
});

var IconEqual = createReactComponent("outline", "equal", "IconEqual", [["path", { "d": "M5 10h14", "key": "svg-0" }], ["path", { "d": "M5 14h14", "key": "svg-1" }]]);

var IconEqual$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEqual
});

var IconEraserOff = createReactComponent("outline", "eraser-off", "IconEraserOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l5 -4.993m2.009 -2.01l3 -3a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41c-1.417 1.431 -2.406 2.432 -2.97 3m-2.02 2.043l-4.211 4.256", "key": "svg-1" }], ["path", { "d": "M18 13.3l-6.3 -6.3", "key": "svg-2" }]]);

var IconEraserOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEraserOff
});

var IconEraser = createReactComponent("outline", "eraser", "IconEraser", [["path", { "d": "M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9.2 9.3", "key": "svg-0" }], ["path", { "d": "M18 13.3l-6.3 -6.3", "key": "svg-1" }]]);

var IconEraser$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEraser
});

var IconError404Off = createReactComponent("outline", "error-404-off", "IconError404Off", [["path", { "d": "M3 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M7 8v8", "key": "svg-1" }], ["path", { "d": "M17 8v3a1 1 0 0 0 1 1h3", "key": "svg-2" }], ["path", { "d": "M21 8v8", "key": "svg-3" }], ["path", { "d": "M10 10v4a2 2 0 1 0 4 0m0 -4a2 2 0 0 0 -2 -2", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconError404Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconError404Off
});

var IconError404 = createReactComponent("outline", "error-404", "IconError404", [["path", { "d": "M3 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M7 8v8", "key": "svg-1" }], ["path", { "d": "M17 8v3a1 1 0 0 0 1 1h3", "key": "svg-2" }], ["path", { "d": "M21 8v8", "key": "svg-3" }], ["path", { "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-4" }]]);

var IconError404$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconError404
});

var IconEscalatorDown = createReactComponent("outline", "escalator-down", "IconEscalatorDown", [["path", { "d": "M4.5 7h2.733a2 2 0 0 1 1.337 .513l9.43 8.487h1.5a2.5 2.5 0 1 1 0 5h-2.733a2 2 0 0 1 -1.337 -.513l-9.43 -8.487h-1.5a2.5 2.5 0 1 1 0 -5z", "key": "svg-0" }], ["path", { "d": "M18 3v7", "key": "svg-1" }], ["path", { "d": "M15 7l3 3l3 -3", "key": "svg-2" }]]);

var IconEscalatorDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEscalatorDown
});

var IconEscalatorUp = createReactComponent("outline", "escalator-up", "IconEscalatorUp", [["path", { "d": "M19.5 7h-2.672a2 2 0 0 0 -1.414 .586l-8.414 8.414h-2.5a2.5 2.5 0 1 0 0 5h3.672a2 2 0 0 0 1.414 -.586l8.414 -8.414h1.5a2.5 2.5 0 1 0 0 -5z", "key": "svg-0" }], ["path", { "d": "M6 10v-7", "key": "svg-1" }], ["path", { "d": "M3 6l3 -3l3 3", "key": "svg-2" }]]);

var IconEscalatorUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEscalatorUp
});

var IconEscalator = createReactComponent("outline", "escalator", "IconEscalator", [["path", { "d": "M19.5 5h-2.672a2 2 0 0 0 -1.414 .586l-8.414 8.414h-2.5a2.5 2.5 0 1 0 0 5h3.672a2 2 0 0 0 1.414 -.586l8.414 -8.414h1.5a2.5 2.5 0 0 0 0 -5z", "key": "svg-0" }]]);

var IconEscalator$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEscalator
});

var IconExchangeOff = createReactComponent("outline", "exchange-off", "IconExchangeOff", [["path", { "d": "M5 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19 8v5c0 .594 -.104 1.164 -.294 1.692m-1.692 2.298a4.978 4.978 0 0 1 -3.014 1.01h-3l3 -3", "key": "svg-2" }], ["path", { "d": "M14 21l-3 -3", "key": "svg-3" }], ["path", { "d": "M5 16v-5c0 -1.632 .782 -3.082 1.992 -4m3.008 -1h3l-3 -3", "key": "svg-4" }], ["path", { "d": "M11.501 7.499l1.499 -1.499", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconExchangeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExchangeOff
});

var IconExchange = createReactComponent("outline", "exchange", "IconExchange", [["path", { "d": "M5 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3", "key": "svg-2" }], ["path", { "d": "M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3", "key": "svg-3" }]]);

var IconExchange$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExchange
});

var IconExclamationCircle = createReactComponent("outline", "exclamation-circle", "IconExclamationCircle", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 9v4", "key": "svg-1" }], ["path", { "d": "M12 16v.01", "key": "svg-2" }]]);

var IconExclamationCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExclamationCircle
});

var IconExclamationMarkOff = createReactComponent("outline", "exclamation-mark-off", "IconExclamationMarkOff", [["path", { "d": "M12 19v.01", "key": "svg-0" }], ["path", { "d": "M12 15v-3m0 -4v-3", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconExclamationMarkOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExclamationMarkOff
});

var IconExclamationMark = createReactComponent("outline", "exclamation-mark", "IconExclamationMark", [["path", { "d": "M12 19v.01", "key": "svg-0" }], ["path", { "d": "M12 15v-10", "key": "svg-1" }]]);

var IconExclamationMark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExclamationMark
});

var IconExplicitOff = createReactComponent("outline", "explicit-off", "IconExplicitOff", [["path", { "d": "M14 8h-2m-2 2v6h4", "key": "svg-0" }], ["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405", "key": "svg-1" }], ["path", { "d": "M12 12h-2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconExplicitOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExplicitOff
});

var IconExplicit = createReactComponent("outline", "explicit", "IconExplicit", [["path", { "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8h4", "key": "svg-1" }], ["path", { "d": "M14 12h-4", "key": "svg-2" }]]);

var IconExplicit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExplicit
});

var IconExposure0 = createReactComponent("outline", "exposure-0", "IconExposure0", [["path", { "d": "M12 19a4 4 0 0 0 4 -4v-6a4 4 0 1 0 -8 0v6a4 4 0 0 0 4 4z", "key": "svg-0" }]]);

var IconExposure0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExposure0
});

var IconExposureMinus1 = createReactComponent("outline", "exposure-minus-1", "IconExposureMinus1", [["path", { "d": "M3 12h6", "key": "svg-0" }], ["path", { "d": "M18 19v-14l-4 4", "key": "svg-1" }]]);

var IconExposureMinus1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExposureMinus1
});

var IconExposureMinus2 = createReactComponent("outline", "exposure-minus-2", "IconExposureMinus2", [["path", { "d": "M12 9a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 7.185h8", "key": "svg-0" }], ["path", { "d": "M3 12h6", "key": "svg-1" }]]);

var IconExposureMinus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExposureMinus2
});

var IconExposureOff = createReactComponent("outline", "exposure-off", "IconExposureOff", [["path", { "d": "M3.6 20.4l8.371 -8.371m2.04 -2.04l6.389 -6.389", "key": "svg-0" }], ["path", { "d": "M6 8h2m0 0v2", "key": "svg-1" }], ["path", { "d": "M14 16h2", "key": "svg-2" }], ["path", { "d": "M7 3h12a2 2 0 0 1 2 2v12m-.5 3.5c-.362 .36 -.95 .5 -1.5 .5h-14a2 2 0 0 1 -2 -2v-14c0 -.541 .215 -1.033 .565 -1.393", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconExposureOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExposureOff
});

var IconExposurePlus1 = createReactComponent("outline", "exposure-plus-1", "IconExposurePlus1", [["path", { "d": "M3 12h6", "key": "svg-0" }], ["path", { "d": "M6 9v6", "key": "svg-1" }], ["path", { "d": "M18 19v-14l-4 4", "key": "svg-2" }]]);

var IconExposurePlus1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExposurePlus1
});

var IconExposurePlus2 = createReactComponent("outline", "exposure-plus-2", "IconExposurePlus2", [["path", { "d": "M12 9a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 7.185h8", "key": "svg-0" }], ["path", { "d": "M3 12h6", "key": "svg-1" }], ["path", { "d": "M6 9v6", "key": "svg-2" }]]);

var IconExposurePlus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExposurePlus2
});

var IconExposure = createReactComponent("outline", "exposure", "IconExposure", [["path", { "d": "M3.6 20.4l16.8 -16.8", "key": "svg-0" }], ["path", { "d": "M6 8h4m-2 -2v4", "key": "svg-1" }], ["path", { "d": "M14 16h4", "key": "svg-2" }], ["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-3" }]]);

var IconExposure$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExposure
});

var IconExternalLinkOff = createReactComponent("outline", "external-link-off", "IconExternalLinkOff", [["path", { "d": "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1", "key": "svg-0" }], ["path", { "d": "M10 14l2 -2m2.007 -2.007l6 -6", "key": "svg-1" }], ["path", { "d": "M15 4h5v5", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconExternalLinkOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExternalLinkOff
});

var IconExternalLink = createReactComponent("outline", "external-link", "IconExternalLink", [["path", { "d": "M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6", "key": "svg-0" }], ["path", { "d": "M11 13l9 -9", "key": "svg-1" }], ["path", { "d": "M15 4h5v5", "key": "svg-2" }]]);

var IconExternalLink$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExternalLink
});

var IconEyeBitcoin = createReactComponent("outline", "eye-bitcoin", "IconEyeBitcoin", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13.193 17.924q -.585 .075 -1.193 .076q -5.4 0 -9 -6q 3.6 -6 9 -6q 4.508 0 7.761 4.181", "key": "svg-1" }], ["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-2" }]]);

var IconEyeBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeBitcoin
});

var IconEyeBolt = createReactComponent("outline", "eye-bolt", "IconEyeBolt", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13.1 17.936a9.28 9.28 0 0 1 -1.1 .064c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }]]);

var IconEyeBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeBolt
});

var IconEyeCancel = createReactComponent("outline", "eye-cancel", "IconEyeCancel", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6", "key": "svg-1" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M17 21l4 -4", "key": "svg-3" }]]);

var IconEyeCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeCancel
});

var IconEyeCheck = createReactComponent("outline", "eye-check", "IconEyeCheck", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M11.102 17.957c-3.204 -.307 -5.904 -2.294 -8.102 -5.957c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6a19.5 19.5 0 0 1 -.663 1.032", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconEyeCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeCheck
});

var IconEyeClosed = createReactComponent("outline", "eye-closed", "IconEyeClosed", [["path", { "d": "M21 9c-2.4 2.667 -5.4 4 -9 4c-3.6 0 -6.6 -1.333 -9 -4", "key": "svg-0" }], ["path", { "d": "M3 15l2.5 -3.8", "key": "svg-1" }], ["path", { "d": "M21 14.976l-2.492 -3.776", "key": "svg-2" }], ["path", { "d": "M9 17l.5 -4", "key": "svg-3" }], ["path", { "d": "M15 17l-.5 -4", "key": "svg-4" }]]);

var IconEyeClosed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeClosed
});

var IconEyeCode = createReactComponent("outline", "eye-code", "IconEyeCode", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M11.11 17.958c-3.209 -.307 -5.91 -2.293 -8.11 -5.958c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6c-.21 .352 -.427 .688 -.647 1.008", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

var IconEyeCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeCode
});

var IconEyeCog = createReactComponent("outline", "eye-cog", "IconEyeCog", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6", "key": "svg-1" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-3" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-4" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-8" }]]);

var IconEyeCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeCog
});

var IconEyeDiscount = createReactComponent("outline", "eye-discount", "IconEyeDiscount", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6", "key": "svg-1" }], ["path", { "d": "M16 21l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21v.01", "key": "svg-3" }], ["path", { "d": "M16 16v.01", "key": "svg-4" }]]);

var IconEyeDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeDiscount
});

var IconEyeDollar = createReactComponent("outline", "eye-dollar", "IconEyeDollar", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13.193 17.924c-.39 .05 -.788 .076 -1.193 .076c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.005 0 5.592 1.394 7.761 4.181", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconEyeDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeDollar
});

var IconEyeDotted = createReactComponent("outline", "eye-dotted", "IconEyeDotted", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M21 12h.01", "key": "svg-1" }], ["path", { "d": "M3 12h.01", "key": "svg-2" }], ["path", { "d": "M5 15h.01", "key": "svg-3" }], ["path", { "d": "M5 9h.01", "key": "svg-4" }], ["path", { "d": "M19 15h.01", "key": "svg-5" }], ["path", { "d": "M12 18h.01", "key": "svg-6" }], ["path", { "d": "M12 6h.01", "key": "svg-7" }], ["path", { "d": "M8 17h.01", "key": "svg-8" }], ["path", { "d": "M8 7h.01", "key": "svg-9" }], ["path", { "d": "M16 17h.01", "key": "svg-10" }], ["path", { "d": "M16 7h.01", "key": "svg-11" }], ["path", { "d": "M19 9h.01", "key": "svg-12" }]]);

var IconEyeDotted$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeDotted
});

var IconEyeDown = createReactComponent("outline", "eye-down", "IconEyeDown", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-3" }]]);

var IconEyeDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeDown
});

var IconEyeEdit = createReactComponent("outline", "eye-edit", "IconEyeEdit", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M11.192 17.966c-3.242 -.28 -5.972 -2.269 -8.192 -5.966c2.4 -4 5.4 -6 9 -6c3.326 0 6.14 1.707 8.442 5.122", "key": "svg-1" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z", "key": "svg-2" }]]);

var IconEyeEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeEdit
});

var IconEyeExclamation = createReactComponent("outline", "eye-exclamation", "IconEyeExclamation", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M15.03 17.478a8.797 8.797 0 0 1 -3.03 .522c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6a20.48 20.48 0 0 1 -.258 .419", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconEyeExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeExclamation
});

var IconEyeHeart = createReactComponent("outline", "eye-heart", "IconEyeHeart", [["path", { "d": "M13.905 11.39a2 2 0 1 0 -2.855 2.37", "key": "svg-0" }], ["path", { "d": "M9.992 17.779c-2.722 -.621 -5.053 -2.547 -6.992 -5.779c2.4 -4 5.4 -6 9 -6c3.332 0 6.15 1.714 8.454 5.14", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconEyeHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeHeart
});

var IconEyeMinus = createReactComponent("outline", "eye-minus", "IconEyeMinus", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6c-.713 1.188 -1.478 2.199 -2.296 3.034", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconEyeMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeMinus
});

var IconEyeOff = createReactComponent("outline", "eye-off", "IconEyeOff", [["path", { "d": "M10.585 10.587a2 2 0 0 0 2.829 2.828", "key": "svg-0" }], ["path", { "d": "M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconEyeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeOff
});

var IconEyePause = createReactComponent("outline", "eye-pause", "IconEyePause", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13.022 17.945a9.308 9.308 0 0 1 -1.022 .055c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6c-.195 .325 -.394 .636 -.596 .935", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

var IconEyePause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyePause
});

var IconEyePin = createReactComponent("outline", "eye-pin", "IconEyePin", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.362 0 6.202 1.745 8.517 5.234", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }]]);

var IconEyePin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyePin
});

var IconEyePlus = createReactComponent("outline", "eye-plus", "IconEyePlus", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconEyePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyePlus
});

var IconEyeQuestion = createReactComponent("outline", "eye-question", "IconEyeQuestion", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M14.071 17.764a8.989 8.989 0 0 1 -2.071 .236c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.346 0 6.173 1.727 8.482 5.182", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }]]);

var IconEyeQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeQuestion
});

var IconEyeSearch = createReactComponent("outline", "eye-search", "IconEyeSearch", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 18c-.328 0 -.652 -.017 -.97 -.05c-3.172 -.332 -5.85 -2.315 -8.03 -5.95c2.4 -4 5.4 -6 9 -6c3.465 0 6.374 1.853 8.727 5.558", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconEyeSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeSearch
});

var IconEyeShare = createReactComponent("outline", "eye-share", "IconEyeShare", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12.597 17.981a9.467 9.467 0 0 1 -.597 .019c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6c-.205 .342 -.415 .67 -.63 .983", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconEyeShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeShare
});

var IconEyeSpark = createReactComponent("outline", "eye-spark", "IconEyeSpark", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M11.669 17.994q -5.18 -.18 -8.669 -5.994q 3.6 -6 9 -6t 9 6", "key": "svg-1" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-2" }]]);

var IconEyeSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeSpark
});

var IconEyeStar = createReactComponent("outline", "eye-star", "IconEyeStar", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M9.608 17.682c-2.558 -.71 -4.76 -2.603 -6.608 -5.682c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconEyeStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeStar
});

var IconEyeTable = createReactComponent("outline", "eye-table", "IconEyeTable", [["path", { "d": "M8 18h-.011", "key": "svg-0" }], ["path", { "d": "M12 18h-.011", "key": "svg-1" }], ["path", { "d": "M16 18h-.011", "key": "svg-2" }], ["path", { "d": "M4 3h16", "key": "svg-3" }], ["path", { "d": "M5 3v17a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-17", "key": "svg-4" }], ["path", { "d": "M14 7h-4", "key": "svg-5" }], ["path", { "d": "M9 15h1", "key": "svg-6" }], ["path", { "d": "M14 15h1", "key": "svg-7" }], ["path", { "d": "M12 11v-4", "key": "svg-8" }]]);

var IconEyeTable$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeTable
});

var IconEyeUp = createReactComponent("outline", "eye-up", "IconEyeUp", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6c-.09 .15 -.18 .295 -.27 .439", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }]]);

var IconEyeUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeUp
});

var IconEyeX = createReactComponent("outline", "eye-x", "IconEyeX", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13.048 17.942a9.298 9.298 0 0 1 -1.048 .058c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6a17.986 17.986 0 0 1 -1.362 1.975", "key": "svg-1" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-2" }], ["path", { "d": "M17 22l5 -5", "key": "svg-3" }]]);

var IconEyeX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeX
});

var IconEye = createReactComponent("outline", "eye", "IconEye", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6", "key": "svg-1" }]]);

var IconEye$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEye
});

var IconEyeglass2 = createReactComponent("outline", "eyeglass-2", "IconEyeglass2", [["path", { "d": "M8 4h-2l-3 10v2.5", "key": "svg-0" }], ["path", { "d": "M16 4h2l3 10v2.5", "key": "svg-1" }], ["path", { "d": "M10 16l4 0", "key": "svg-2" }], ["path", { "d": "M17.5 16.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0", "key": "svg-3" }], ["path", { "d": "M6.5 16.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0", "key": "svg-4" }]]);

var IconEyeglass2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeglass2
});

var IconEyeglassOff = createReactComponent("outline", "eyeglass-off", "IconEyeglassOff", [["path", { "d": "M5.536 5.546l-2.536 8.454", "key": "svg-0" }], ["path", { "d": "M16 4h2l3 10", "key": "svg-1" }], ["path", { "d": "M10 16h4", "key": "svg-2" }], ["path", { "d": "M19.426 19.423a3.5 3.5 0 0 1 -5.426 -2.923v-2.5m4 0h3v2.5c0 .157 -.01 .312 -.03 .463", "key": "svg-3" }], ["path", { "d": "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconEyeglassOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeglassOff
});

var IconEyeglass = createReactComponent("outline", "eyeglass", "IconEyeglass", [["path", { "d": "M8 4h-2l-3 10", "key": "svg-0" }], ["path", { "d": "M16 4h2l3 10", "key": "svg-1" }], ["path", { "d": "M10 16l4 0", "key": "svg-2" }], ["path", { "d": "M21 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5", "key": "svg-3" }], ["path", { "d": "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5", "key": "svg-4" }]]);

var IconEyeglass$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeglass
});

var IconFaceIdError = createReactComponent("outline", "face-id-error", "IconFaceIdError", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M9 10h.01", "key": "svg-4" }], ["path", { "d": "M15 10h.01", "key": "svg-5" }], ["path", { "d": "M9.5 15.05a3.5 3.5 0 0 1 5 0", "key": "svg-6" }]]);

var IconFaceIdError$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFaceIdError
});

var IconFaceId = createReactComponent("outline", "face-id", "IconFaceId", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M9 10l.01 0", "key": "svg-4" }], ["path", { "d": "M15 10l.01 0", "key": "svg-5" }], ["path", { "d": "M9.5 15a3.5 3.5 0 0 0 5 0", "key": "svg-6" }]]);

var IconFaceId$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFaceId
});

var IconFaceMaskOff = createReactComponent("outline", "face-mask-off", "IconFaceMaskOff", [["path", { "d": "M5 14.5h-.222c-1.535 0 -2.778 -1.12 -2.778 -2.5s1.243 -2.5 2.778 -2.5h.222", "key": "svg-0" }], ["path", { "d": "M19 14.5h.222c1.534 0 2.778 -1.12 2.778 -2.5s-1.244 -2.5 -2.778 -2.5h-.222", "key": "svg-1" }], ["path", { "d": "M9 10h1m4 0h1", "key": "svg-2" }], ["path", { "d": "M9 14h5", "key": "svg-3" }], ["path", { "d": "M19 15v-6.49a2 2 0 0 0 -1.45 -1.923l-5 -1.429a2 2 0 0 0 -1.1 0l-1.788 .511m-3.118 .891l-.094 .027a2 2 0 0 0 -1.45 1.922v6.982a2 2 0 0 0 1.45 1.923l5 1.429a2 2 0 0 0 1.1 0l4.899 -1.4", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconFaceMaskOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFaceMaskOff
});

var IconFaceMask = createReactComponent("outline", "face-mask", "IconFaceMask", [["path", { "d": "M5 14.5h-.222c-1.535 0 -2.778 -1.12 -2.778 -2.5s1.243 -2.5 2.778 -2.5h.222", "key": "svg-0" }], ["path", { "d": "M19 14.5h.222c1.534 0 2.778 -1.12 2.778 -2.5s-1.244 -2.5 -2.778 -2.5h-.222", "key": "svg-1" }], ["path", { "d": "M9 10h6", "key": "svg-2" }], ["path", { "d": "M9 14h6", "key": "svg-3" }], ["path", { "d": "M12.55 18.843l5 -1.429a2 2 0 0 0 1.45 -1.923v-6.981a2 2 0 0 0 -1.45 -1.923l-5 -1.429a2 2 0 0 0 -1.1 0l-5 1.429a2 2 0 0 0 -1.45 1.922v6.982a2 2 0 0 0 1.45 1.923l5 1.429a2 2 0 0 0 1.1 0z", "key": "svg-4" }]]);

var IconFaceMask$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFaceMask
});

var IconFall = createReactComponent("outline", "fall", "IconFall", [["path", { "d": "M11 21l1 -5l-1 -4l-3 -4h4l3 -3", "key": "svg-0" }], ["path", { "d": "M6 16l-1 -4l3 -4", "key": "svg-1" }], ["path", { "d": "M6 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M13.5 12h2.5l4 2", "key": "svg-3" }]]);

var IconFall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFall
});

var IconFavicon = createReactComponent("outline", "favicon", "IconFavicon", [["path", { "d": "M2 5m0 3a3 3 0 0 1 3 -3h14a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M6 10v4", "key": "svg-1" }], ["path", { "d": "M11 10a2 2 0 1 0 0 4", "key": "svg-2" }], ["path", { "d": "M16 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }]]);

var IconFavicon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFavicon
});

var IconFeatherOff = createReactComponent("outline", "feather-off", "IconFeatherOff", [["path", { "d": "M4 20l8 -8", "key": "svg-0" }], ["path", { "d": "M14 5v5h5", "key": "svg-1" }], ["path", { "d": "M9 11v4h4", "key": "svg-2" }], ["path", { "d": "M6 13v5h5", "key": "svg-3" }], ["path", { "d": "M6 13l3.502 -3.502m2.023 -2.023l2.475 -2.475", "key": "svg-4" }], ["path", { "d": "M19 10c.638 -.636 1 -1.515 1 -2.486a3.515 3.515 0 0 0 -3.517 -3.514c-.97 0 -1.847 .367 -2.483 1", "key": "svg-5" }], ["path", { "d": "M11 18l3.499 -3.499m2.008 -2.008l2.493 -2.493", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconFeatherOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFeatherOff
});

var IconFeather = createReactComponent("outline", "feather", "IconFeather", [["path", { "d": "M4 20l10 -10m0 -5v5h5m-9 -1v5h5m-9 -1v5h5m-5 -5l4 -4l4 -4", "key": "svg-0" }], ["path", { "d": "M19 10c.638 -.636 1 -1.515 1 -2.486a3.515 3.515 0 0 0 -3.517 -3.514c-.97 0 -1.847 .367 -2.483 1m-3 13l4 -4l4 -4", "key": "svg-1" }]]);

var IconFeather$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFeather
});

var IconFenceOff = createReactComponent("outline", "fence-off", "IconFenceOff", [["path", { "d": "M12 12h-8v4h12m4 0v-4h-4", "key": "svg-0" }], ["path", { "d": "M6 16v4h4v-4", "key": "svg-1" }], ["path", { "d": "M10 12v-2m0 -4l-2 -2m-2 2v6", "key": "svg-2" }], ["path", { "d": "M14 16v4h4v-2", "key": "svg-3" }], ["path", { "d": "M18 12v-6l-2 -2l-2 2v4", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconFenceOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFenceOff
});

var IconFence = createReactComponent("outline", "fence", "IconFence", [["path", { "d": "M4 12v4h16v-4z", "key": "svg-0" }], ["path", { "d": "M6 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6", "key": "svg-1" }], ["path", { "d": "M14 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6", "key": "svg-2" }]]);

var IconFence$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFence
});

var IconFerry = createReactComponent("outline", "ferry", "IconFerry", [["path", { "d": "M2 18h15.293c1.02 0 1.972 -.503 2.536 -1.34l2.171 -3.66h-18.479z", "key": "svg-0" }], ["path", { "d": "M14 8l-1 -2", "key": "svg-1" }], ["path", { "d": "M6.107 12.675l1.384 -4.675h8l2.675 4.598", "key": "svg-2" }]]);

var IconFerry$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFerry
});

var IconFidgetSpinner = createReactComponent("outline", "fidget-spinner", "IconFidgetSpinner", [["path", { "d": "M18 16v.01", "key": "svg-0" }], ["path", { "d": "M6 16v.01", "key": "svg-1" }], ["path", { "d": "M12 5v.01", "key": "svg-2" }], ["path", { "d": "M12 12v.01", "key": "svg-3" }], ["path", { "d": "M12 1a4 4 0 0 1 2.001 7.464l.001 .072a3.998 3.998 0 0 1 1.987 3.758l.22 .128a3.978 3.978 0 0 1 1.591 -.417l.2 -.005a4 4 0 1 1 -3.994 3.77l-.28 -.16c-.522 .25 -1.108 .39 -1.726 .39c-.619 0 -1.205 -.14 -1.728 -.391l-.279 .16l.007 .231a4 4 0 1 1 -2.212 -3.579l.222 -.129a3.998 3.998 0 0 1 1.988 -3.756l.002 -.071a4 4 0 0 1 -1.995 -3.265l-.005 -.2a4 4 0 0 1 4 -4z", "key": "svg-4" }]]);

var IconFidgetSpinner$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFidgetSpinner
});

var IconFile3d = createReactComponent("outline", "file-3d", "IconFile3d", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 13.5l4 -1.5", "key": "svg-2" }], ["path", { "d": "M8 11.846l4 1.654v4.5l4 -1.846v-4.308l-4 -1.846z", "key": "svg-3" }], ["path", { "d": "M8 12v4.2l4 1.8", "key": "svg-4" }]]);

var IconFile3d$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFile3d
});

var IconFileAi = createReactComponent("outline", "file-ai", "IconFileAi", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M10 21h-3a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M14 21v-4a2 2 0 1 1 4 0v4", "key": "svg-2" }], ["path", { "d": "M14 19h4", "key": "svg-3" }], ["path", { "d": "M21 15v6", "key": "svg-4" }]]);

var IconFileAi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileAi
});

var IconFileAlert = createReactComponent("outline", "file-alert", "IconFileAlert", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 17l.01 0", "key": "svg-2" }], ["path", { "d": "M12 11l0 3", "key": "svg-3" }]]);

var IconFileAlert$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileAlert
});

var IconFileAnalytics = createReactComponent("outline", "file-analytics", "IconFileAnalytics", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M9 17l0 -5", "key": "svg-2" }], ["path", { "d": "M12 17l0 -1", "key": "svg-3" }], ["path", { "d": "M15 17l0 -3", "key": "svg-4" }]]);

var IconFileAnalytics$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileAnalytics
});

var IconFileArrowLeft = createReactComponent("outline", "file-arrow-left", "IconFileArrowLeft", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M15 15h-6", "key": "svg-2" }], ["path", { "d": "M11.5 17.5l-2.5 -2.5l2.5 -2.5", "key": "svg-3" }]]);

var IconFileArrowLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileArrowLeft
});

var IconFileArrowRight = createReactComponent("outline", "file-arrow-right", "IconFileArrowRight", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M9 15h6", "key": "svg-2" }], ["path", { "d": "M12.5 17.5l2.5 -2.5l-2.5 -2.5", "key": "svg-3" }]]);

var IconFileArrowRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileArrowRight
});

var IconFileBarcode = createReactComponent("outline", "file-barcode", "IconFileBarcode", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M8 13h1v3h-1z", "key": "svg-2" }], ["path", { "d": "M12 13v3", "key": "svg-3" }], ["path", { "d": "M15 13h1v3h-1z", "key": "svg-4" }]]);

var IconFileBarcode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileBarcode
});

var IconFileBitcoin = createReactComponent("outline", "file-bitcoin", "IconFileBitcoin", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v2", "key": "svg-1" }], ["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-2" }]]);

var IconFileBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileBitcoin
});

var IconFileBroken = createReactComponent("outline", "file-broken", "IconFileBroken", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 7v-2a2 2 0 0 1 2 -2h7l5 5v2", "key": "svg-1" }], ["path", { "d": "M19 19a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2", "key": "svg-2" }], ["path", { "d": "M5 16h.01", "key": "svg-3" }], ["path", { "d": "M5 13h.01", "key": "svg-4" }], ["path", { "d": "M5 10h.01", "key": "svg-5" }], ["path", { "d": "M19 13h.01", "key": "svg-6" }], ["path", { "d": "M19 16h.01", "key": "svg-7" }]]);

var IconFileBroken$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileBroken
});

var IconFileCertificate = createReactComponent("outline", "file-certificate", "IconFileCertificate", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 8v-3a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5", "key": "svg-1" }], ["path", { "d": "M6 14m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M4.5 17l-1.5 5l3 -1.5l3 1.5l-1.5 -5", "key": "svg-3" }]]);

var IconFileCertificate$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileCertificate
});

var IconFileChart = createReactComponent("outline", "file-chart", "IconFileChart", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 10v4h4", "key": "svg-2" }], ["path", { "d": "M12 14m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-3" }]]);

var IconFileChart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileChart
});

var IconFileCheck = createReactComponent("outline", "file-check", "IconFileCheck", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M9 15l2 2l4 -4", "key": "svg-2" }]]);

var IconFileCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileCheck
});

var IconFileCode2 = createReactComponent("outline", "file-code-2", "IconFileCode2", [["path", { "d": "M10 12h-1v5h1", "key": "svg-0" }], ["path", { "d": "M14 12h1v5h-1", "key": "svg-1" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-2" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-3" }]]);

var IconFileCode2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileCode2
});

var IconFileCode = createReactComponent("outline", "file-code", "IconFileCode", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M10 13l-1 2l1 2", "key": "svg-2" }], ["path", { "d": "M14 13l1 2l-1 2", "key": "svg-3" }]]);

var IconFileCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileCode
});

var IconFileCv = createReactComponent("outline", "file-cv", "IconFileCv", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M11 12.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0", "key": "svg-2" }], ["path", { "d": "M13 11l1.5 6l1.5 -6", "key": "svg-3" }]]);

var IconFileCv$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileCv
});

var IconFileDatabase = createReactComponent("outline", "file-database", "IconFileDatabase", [["path", { "d": "M12 12.75m-4 0a4 1.75 0 1 0 8 0a4 1.75 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M8 12.5v3.75c0 .966 1.79 1.75 4 1.75s4 -.784 4 -1.75v-3.75", "key": "svg-1" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-2" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-3" }]]);

var IconFileDatabase$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDatabase
});

var IconFileDelta = createReactComponent("outline", "file-delta", "IconFileDelta", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M9 17h6l-3 -6z", "key": "svg-2" }]]);

var IconFileDelta$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDelta
});

var IconFileDescription = createReactComponent("outline", "file-description", "IconFileDescription", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M9 17h6", "key": "svg-2" }], ["path", { "d": "M9 13h6", "key": "svg-3" }]]);

var IconFileDescription$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDescription
});

var IconFileDiff = createReactComponent("outline", "file-diff", "IconFileDiff", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 10l0 4", "key": "svg-2" }], ["path", { "d": "M10 12l4 0", "key": "svg-3" }], ["path", { "d": "M10 17l4 0", "key": "svg-4" }]]);

var IconFileDiff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDiff
});

var IconFileDigit = createReactComponent("outline", "file-digit", "IconFileDigit", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M9 12m0 1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-2" }], ["path", { "d": "M15 12v5", "key": "svg-3" }]]);

var IconFileDigit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDigit
});

var IconFileDislike = createReactComponent("outline", "file-dislike", "IconFileDislike", [["path", { "d": "M3 14m0 1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 1 1 -1h3.756a1 1 0 0 1 .958 .713l1.2 3c.09 .303 .133 .63 -.056 .884c-.188 .254 -.542 .403 -.858 .403h-2v2.467a1.1 1.1 0 0 1 -2.015 .61l-1.985 -3.077v-4z", "key": "svg-1" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-2" }], ["path", { "d": "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.5", "key": "svg-3" }]]);

var IconFileDislike$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDislike
});

var IconFileDollar = createReactComponent("outline", "file-dollar", "IconFileDollar", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M12 17v1m0 -8v1", "key": "svg-3" }]]);

var IconFileDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDollar
});

var IconFileDots = createReactComponent("outline", "file-dots", "IconFileDots", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M9 14v.01", "key": "svg-2" }], ["path", { "d": "M12 14v.01", "key": "svg-3" }], ["path", { "d": "M15 14v.01", "key": "svg-4" }]]);

var IconFileDots$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDots
});

var IconFileDownload = createReactComponent("outline", "file-download", "IconFileDownload", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 17v-6", "key": "svg-2" }], ["path", { "d": "M9.5 14.5l2.5 2.5l2.5 -2.5", "key": "svg-3" }]]);

var IconFileDownload$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDownload
});

var IconFileEuro = createReactComponent("outline", "file-euro", "IconFileEuro", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 14h-3", "key": "svg-2" }], ["path", { "d": "M14 11.172a3 3 0 1 0 0 5.656", "key": "svg-3" }]]);

var IconFileEuro$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileEuro
});

var IconFileExcel = createReactComponent("outline", "file-excel", "IconFileExcel", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2", "key": "svg-1" }], ["path", { "d": "M10 12l4 5", "key": "svg-2" }], ["path", { "d": "M10 17l4 -5", "key": "svg-3" }]]);

var IconFileExcel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileExcel
});

var IconFileExport = createReactComponent("outline", "file-export", "IconFileExport", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v5m-5 6h7m-3 -3l3 3l-3 3", "key": "svg-1" }]]);

var IconFileExport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileExport
});

var IconFileFunction = createReactComponent("outline", "file-function", "IconFileFunction", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M10.5 17h.333c.474 0 .87 -.323 .916 -.746l.502 -4.508c.047 -.423 .443 -.746 .916 -.746h.333", "key": "svg-2" }], ["path", { "d": "M10.5 14h3", "key": "svg-3" }]]);

var IconFileFunction$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileFunction
});

var IconFileHorizontal = createReactComponent("outline", "file-horizontal", "IconFileHorizontal", [["path", { "d": "M16 5v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z", "key": "svg-1" }]]);

var IconFileHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileHorizontal
});

var IconFileImport = createReactComponent("outline", "file-import", "IconFileImport", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 13v-8a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5.5m-9.5 -2h7m-3 -3l3 3l-3 3", "key": "svg-1" }]]);

var IconFileImport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileImport
});

var IconFileInfinity = createReactComponent("outline", "file-infinity", "IconFileInfinity", [["path", { "d": "M15.536 17.586a2.123 2.123 0 0 0 -2.929 0a1.951 1.951 0 0 0 0 2.828c.809 .781 2.12 .781 2.929 0c.809 -.781 -.805 .778 0 0l1.46 -1.41l1.46 -1.419", "key": "svg-0" }], ["path", { "d": "M15.54 17.582l1.46 1.42l1.46 1.41c.809 .78 -.805 -.779 0 0s2.12 .781 2.929 0a1.951 1.951 0 0 0 0 -2.828a2.123 2.123 0 0 0 -2.929 0", "key": "svg-1" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-2" }], ["path", { "d": "M9.5 21h-2.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v6", "key": "svg-3" }]]);

var IconFileInfinity$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileInfinity
});

var IconFileInfo = createReactComponent("outline", "file-info", "IconFileInfo", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M11 14h1v4h1", "key": "svg-2" }], ["path", { "d": "M12 11h.01", "key": "svg-3" }]]);

var IconFileInfo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileInfo
});

var IconFileInvoice = createReactComponent("outline", "file-invoice", "IconFileInvoice", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M9 7l1 0", "key": "svg-2" }], ["path", { "d": "M9 13l6 0", "key": "svg-3" }], ["path", { "d": "M13 17l2 0", "key": "svg-4" }]]);

var IconFileInvoice$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileInvoice
});

var IconFileIsr = createReactComponent("outline", "file-isr", "IconFileIsr", [["path", { "d": "M15 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M15 3v4a1 1 0 0 0 1 1h4", "key": "svg-1" }], ["path", { "d": "M6 8v-3a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7", "key": "svg-2" }], ["path", { "d": "M3 15l3 -3l3 3", "key": "svg-3" }]]);

var IconFileIsr$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileIsr
});

var IconFileLambda = createReactComponent("outline", "file-lambda", "IconFileLambda", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M10 17l2 -3", "key": "svg-2" }], ["path", { "d": "M15 17c-2.5 0 -2.5 -6 -5 -6", "key": "svg-3" }]]);

var IconFileLambda$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileLambda
});

var IconFileLike = createReactComponent("outline", "file-like", "IconFileLike", [["path", { "d": "M3 16m0 1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M6 20a1 1 0 0 0 1 1h3.756a1 1 0 0 0 .958 -.713l1.2 -3c.09 -.303 .133 -.63 -.056 -.884c-.188 -.254 -.542 -.403 -.858 -.403h-2v-2.467a1.1 1.1 0 0 0 -2.015 -.61l-1.985 3.077v4z", "key": "svg-1" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-2" }], ["path", { "d": "M5 12.1v-7.1a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.3", "key": "svg-3" }]]);

var IconFileLike$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileLike
});

var IconFileMinus = createReactComponent("outline", "file-minus", "IconFileMinus", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M9 14l6 0", "key": "svg-2" }]]);

var IconFileMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileMinus
});

var IconFileMusic = createReactComponent("outline", "file-music", "IconFileMusic", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M11 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M12 16l0 -5l2 1", "key": "svg-3" }]]);

var IconFileMusic$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileMusic
});

var IconFileNeutral = createReactComponent("outline", "file-neutral", "IconFileNeutral", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2zm-7 -7h.01m3.99 0h.01m-4.01 3h4", "key": "svg-1" }]]);

var IconFileNeutral$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileNeutral
});

var IconFileOff = createReactComponent("outline", "file-off", "IconFileOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M7 3h7l5 5v7m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14", "key": "svg-1" }]]);

var IconFileOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileOff
});

var IconFileOrientation = createReactComponent("outline", "file-orientation", "IconFileOrientation", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M10 21h-3a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v2", "key": "svg-1" }], ["path", { "d": "M13 20h5a2 2 0 0 0 2 -2v-5", "key": "svg-2" }], ["path", { "d": "M15 22l-2 -2l2 -2", "key": "svg-3" }], ["path", { "d": "M18 15l2 -2l2 2", "key": "svg-4" }]]);

var IconFileOrientation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileOrientation
});

var IconFilePencil = createReactComponent("outline", "file-pencil", "IconFilePencil", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M10 18l5 -5a1.414 1.414 0 0 0 -2 -2l-5 5v2h2z", "key": "svg-2" }]]);

var IconFilePencil$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilePencil
});

var IconFilePercent = createReactComponent("outline", "file-percent", "IconFilePercent", [["path", { "d": "M10 17l4 -4", "key": "svg-0" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-1" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-2" }], ["path", { "d": "M10 13h.01", "key": "svg-3" }], ["path", { "d": "M14 17h.01", "key": "svg-4" }]]);

var IconFilePercent$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilePercent
});

var IconFilePhone = createReactComponent("outline", "file-phone", "IconFilePhone", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M9 12a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1", "key": "svg-2" }]]);

var IconFilePhone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilePhone
});

var IconFilePlus = createReactComponent("outline", "file-plus", "IconFilePlus", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 11l0 6", "key": "svg-2" }], ["path", { "d": "M9 14l6 0", "key": "svg-3" }]]);

var IconFilePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilePlus
});

var IconFilePower = createReactComponent("outline", "file-power", "IconFilePower", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 11l-2 3h4l-2 3", "key": "svg-2" }]]);

var IconFilePower$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilePower
});

var IconFileReport = createReactComponent("outline", "file-report", "IconFileReport", [["path", { "d": "M17 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M17 13v4h4", "key": "svg-1" }], ["path", { "d": "M12 3v4a1 1 0 0 0 1 1h4", "key": "svg-2" }], ["path", { "d": "M11.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v2m0 3v4", "key": "svg-3" }]]);

var IconFileReport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileReport
});

var IconFileRss = createReactComponent("outline", "file-rss", "IconFileRss", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 17a3 3 0 0 0 -3 -3", "key": "svg-2" }], ["path", { "d": "M15 17a6 6 0 0 0 -6 -6", "key": "svg-3" }], ["path", { "d": "M9 17h.01", "key": "svg-4" }]]);

var IconFileRss$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileRss
});

var IconFileSad = createReactComponent("outline", "file-sad", "IconFileSad", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2zm-7 -7h.01m3.99 0h.01", "key": "svg-1" }], ["path", { "d": "M10 18a3.5 3.5 0 0 1 4 0", "key": "svg-2" }]]);

var IconFileSad$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileSad
});

var IconFileScissors = createReactComponent("outline", "file-scissors", "IconFileScissors", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M15 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M9 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M9 17l6 -6", "key": "svg-4" }], ["path", { "d": "M15 17l-6 -6", "key": "svg-5" }]]);

var IconFileScissors$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileScissors
});

var IconFileSearch = createReactComponent("outline", "file-search", "IconFileSearch", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v4.5", "key": "svg-1" }], ["path", { "d": "M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-2" }], ["path", { "d": "M18.5 19.5l2.5 2.5", "key": "svg-3" }]]);

var IconFileSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileSearch
});

var IconFileSettings = createReactComponent("outline", "file-settings", "IconFileSettings", [["path", { "d": "M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 10.5v1.5", "key": "svg-1" }], ["path", { "d": "M12 16v1.5", "key": "svg-2" }], ["path", { "d": "M15.031 12.25l-1.299 .75", "key": "svg-3" }], ["path", { "d": "M10.268 15l-1.3 .75", "key": "svg-4" }], ["path", { "d": "M15 15.803l-1.285 -.773", "key": "svg-5" }], ["path", { "d": "M10.285 12.97l-1.285 -.773", "key": "svg-6" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-7" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-8" }]]);

var IconFileSettings$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileSettings
});

var IconFileShredder = createReactComponent("outline", "file-shredder", "IconFileShredder", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M3 12l18 0", "key": "svg-2" }], ["path", { "d": "M6 16l0 2", "key": "svg-3" }], ["path", { "d": "M10 16l0 6", "key": "svg-4" }], ["path", { "d": "M14 16l0 2", "key": "svg-5" }], ["path", { "d": "M18 16l0 4", "key": "svg-6" }]]);

var IconFileShredder$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileShredder
});

var IconFileSignal = createReactComponent("outline", "file-signal", "IconFileSignal", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 14v.01", "key": "svg-2" }], ["path", { "d": "M9.525 11.525a3.5 3.5 0 0 0 0 4.95m4.95 0a3.5 3.5 0 0 0 0 -4.95", "key": "svg-3" }]]);

var IconFileSignal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileSignal
});

var IconFileSmile = createReactComponent("outline", "file-smile", "IconFileSmile", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2zm-7 -7h.01m3.99 0h.01", "key": "svg-1" }], ["path", { "d": "M10 17a3.5 3.5 0 0 0 4 0", "key": "svg-2" }]]);

var IconFileSmile$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileSmile
});

var IconFileSpark = createReactComponent("outline", "file-spark", "IconFileSpark", [["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-0" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-1" }], ["path", { "d": "M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v3.5", "key": "svg-2" }]]);

var IconFileSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileSpark
});

var IconFileSpreadsheet = createReactComponent("outline", "file-spreadsheet", "IconFileSpreadsheet", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M8 11h8v7h-8z", "key": "svg-2" }], ["path", { "d": "M8 15h8", "key": "svg-3" }], ["path", { "d": "M11 11v7", "key": "svg-4" }]]);

var IconFileSpreadsheet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileSpreadsheet
});

var IconFileStack = createReactComponent("outline", "file-stack", "IconFileStack", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M5 21h14", "key": "svg-2" }], ["path", { "d": "M5 18h14", "key": "svg-3" }], ["path", { "d": "M5 15h14", "key": "svg-4" }]]);

var IconFileStack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileStack
});

var IconFileStar = createReactComponent("outline", "file-star", "IconFileStar", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M11.8 16.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconFileStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileStar
});

var IconFileSymlink = createReactComponent("outline", "file-symlink", "IconFileSymlink", [["path", { "d": "M4 21v-4a3 3 0 0 1 3 -3h5", "key": "svg-0" }], ["path", { "d": "M9 17l3 -3l-3 -3", "key": "svg-1" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-2" }], ["path", { "d": "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-9.5", "key": "svg-3" }]]);

var IconFileSymlink$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileSymlink
});

var IconFileTextAi = createReactComponent("outline", "file-text-ai", "IconFileTextAi", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M10 21h-3a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v3.5", "key": "svg-1" }], ["path", { "d": "M9 9h1", "key": "svg-2" }], ["path", { "d": "M9 13h2.5", "key": "svg-3" }], ["path", { "d": "M9 17h1", "key": "svg-4" }], ["path", { "d": "M14 21v-4a2 2 0 1 1 4 0v4", "key": "svg-5" }], ["path", { "d": "M14 19h4", "key": "svg-6" }], ["path", { "d": "M21 15v6", "key": "svg-7" }]]);

var IconFileTextAi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTextAi
});

var IconFileTextShield = createReactComponent("outline", "file-text-shield", "IconFileTextShield", [["path", { "d": "M13 3v4a.997 .997 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M11 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v3.5", "key": "svg-1" }], ["path", { "d": "M8 9h1", "key": "svg-2" }], ["path", { "d": "M8 12.994l3 0", "key": "svg-3" }], ["path", { "d": "M8 16.997l2 0", "key": "svg-4" }], ["path", { "d": "M21 15.994c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5", "key": "svg-5" }]]);

var IconFileTextShield$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTextShield
});

var IconFileTextSpark = createReactComponent("outline", "file-text-spark", "IconFileTextSpark", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v3.5", "key": "svg-1" }], ["path", { "d": "M9 9h1", "key": "svg-2" }], ["path", { "d": "M9 13h6", "key": "svg-3" }], ["path", { "d": "M9 17h3", "key": "svg-4" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-5" }]]);

var IconFileTextSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTextSpark
});

var IconFileText = createReactComponent("outline", "file-text", "IconFileText", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M9 9l1 0", "key": "svg-2" }], ["path", { "d": "M9 13l6 0", "key": "svg-3" }], ["path", { "d": "M9 17l6 0", "key": "svg-4" }]]);

var IconFileText$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileText
});

var IconFileTime = createReactComponent("outline", "file-time", "IconFileTime", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 14m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-2" }], ["path", { "d": "M12 12.496v1.504l1 1", "key": "svg-3" }]]);

var IconFileTime$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTime
});

var IconFileTypeBmp = createReactComponent("outline", "file-type-bmp", "IconFileTypeBmp", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M18 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6", "key": "svg-2" }], ["path", { "d": "M4 21h1.5a1.5 1.5 0 0 0 0 -3h-1.5h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6z", "key": "svg-3" }], ["path", { "d": "M10 21v-6l2.5 3l2.5 -3v6", "key": "svg-4" }]]);

var IconFileTypeBmp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeBmp
});

var IconFileTypeCss = createReactComponent("outline", "file-type-css", "IconFileTypeCss", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M8 16.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0", "key": "svg-2" }], ["path", { "d": "M11 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-3" }], ["path", { "d": "M17 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-4" }]]);

var IconFileTypeCss$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeCss
});

var IconFileTypeCsv = createReactComponent("outline", "file-type-csv", "IconFileTypeCsv", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M7 16.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0", "key": "svg-2" }], ["path", { "d": "M10 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-3" }], ["path", { "d": "M16 15l2 6l2 -6", "key": "svg-4" }]]);

var IconFileTypeCsv$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeCsv
});

var IconFileTypeDoc = createReactComponent("outline", "file-type-doc", "IconFileTypeDoc", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M5 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z", "key": "svg-2" }], ["path", { "d": "M20 16.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0", "key": "svg-3" }], ["path", { "d": "M12.5 15a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1 -3 0v-3a1.5 1.5 0 0 1 1.5 -1.5z", "key": "svg-4" }]]);

var IconFileTypeDoc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeDoc
});

var IconFileTypeDocx = createReactComponent("outline", "file-type-docx", "IconFileTypeDocx", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M2 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z", "key": "svg-2" }], ["path", { "d": "M17 16.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0", "key": "svg-3" }], ["path", { "d": "M9.5 15a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1 -3 0v-3a1.5 1.5 0 0 1 1.5 -1.5z", "key": "svg-4" }], ["path", { "d": "M19.5 15l3 6", "key": "svg-5" }], ["path", { "d": "M19.5 21l3 -6", "key": "svg-6" }]]);

var IconFileTypeDocx$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeDocx
});

var IconFileTypeHtml = createReactComponent("outline", "file-type-html", "IconFileTypeHtml", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M2 21v-6", "key": "svg-2" }], ["path", { "d": "M5 15v6", "key": "svg-3" }], ["path", { "d": "M2 18h3", "key": "svg-4" }], ["path", { "d": "M20 15v6h2", "key": "svg-5" }], ["path", { "d": "M13 21v-6l2 3l2 -3v6", "key": "svg-6" }], ["path", { "d": "M7.5 15h3", "key": "svg-7" }], ["path", { "d": "M9 15v6", "key": "svg-8" }]]);

var IconFileTypeHtml$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeHtml
});

var IconFileTypeJpg = createReactComponent("outline", "file-type-jpg", "IconFileTypeJpg", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M11 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6", "key": "svg-2" }], ["path", { "d": "M20 15h-1a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h1v-3", "key": "svg-3" }], ["path", { "d": "M5 15h3v4.5a1.5 1.5 0 0 1 -3 0", "key": "svg-4" }]]);

var IconFileTypeJpg$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeJpg
});

var IconFileTypeJs = createReactComponent("outline", "file-type-js", "IconFileTypeJs", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M3 15h3v4.5a1.5 1.5 0 0 1 -3 0", "key": "svg-1" }], ["path", { "d": "M9 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-2" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1", "key": "svg-3" }]]);

var IconFileTypeJs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeJs
});

var IconFileTypeJsx = createReactComponent("outline", "file-type-jsx", "IconFileTypeJsx", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M4 15h3v4.5a1.5 1.5 0 0 1 -3 0", "key": "svg-2" }], ["path", { "d": "M10 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-3" }], ["path", { "d": "M16 15l4 6", "key": "svg-4" }], ["path", { "d": "M16 21l4 -6", "key": "svg-5" }]]);

var IconFileTypeJsx$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeJsx
});

var IconFileTypePdf = createReactComponent("outline", "file-type-pdf", "IconFileTypePdf", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6", "key": "svg-2" }], ["path", { "d": "M17 18h2", "key": "svg-3" }], ["path", { "d": "M20 15h-3v6", "key": "svg-4" }], ["path", { "d": "M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z", "key": "svg-5" }]]);

var IconFileTypePdf$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypePdf
});

var IconFileTypePhp = createReactComponent("outline", "file-type-php", "IconFileTypePhp", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6", "key": "svg-2" }], ["path", { "d": "M17 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6", "key": "svg-3" }], ["path", { "d": "M11 21v-6", "key": "svg-4" }], ["path", { "d": "M14 15v6", "key": "svg-5" }], ["path", { "d": "M11 18h3", "key": "svg-6" }]]);

var IconFileTypePhp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypePhp
});

var IconFileTypePng = createReactComponent("outline", "file-type-png", "IconFileTypePng", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M20 15h-1a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h1v-3", "key": "svg-2" }], ["path", { "d": "M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6", "key": "svg-3" }], ["path", { "d": "M11 21v-6l3 6v-6", "key": "svg-4" }]]);

var IconFileTypePng$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypePng
});

var IconFileTypePpt = createReactComponent("outline", "file-type-ppt", "IconFileTypePpt", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-1" }], ["path", { "d": "M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6", "key": "svg-2" }], ["path", { "d": "M11 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6", "key": "svg-3" }], ["path", { "d": "M16.5 15h3", "key": "svg-4" }], ["path", { "d": "M18 15v6", "key": "svg-5" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-6" }]]);

var IconFileTypePpt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypePpt
});

var IconFileTypeRs = createReactComponent("outline", "file-type-rs", "IconFileTypeRs", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-1" }], ["path", { "d": "M9 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-2" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1", "key": "svg-3" }], ["path", { "d": "M3 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6m3 0l-2 -3", "key": "svg-4" }]]);

var IconFileTypeRs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeRs
});

var IconFileTypeSql = createReactComponent("outline", "file-type-sql", "IconFileTypeSql", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-1" }], ["path", { "d": "M5 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-2" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-3" }], ["path", { "d": "M18 15v6h2", "key": "svg-4" }], ["path", { "d": "M13 15a2 2 0 0 1 2 2v2a2 2 0 1 1 -4 0v-2a2 2 0 0 1 2 -2z", "key": "svg-5" }], ["path", { "d": "M14 20l1.5 1.5", "key": "svg-6" }]]);

var IconFileTypeSql$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeSql
});

var IconFileTypeSvg = createReactComponent("outline", "file-type-svg", "IconFileTypeSvg", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M4 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-2" }], ["path", { "d": "M10 15l2 6l2 -6", "key": "svg-3" }], ["path", { "d": "M20 15h-1a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h1v-3", "key": "svg-4" }]]);

var IconFileTypeSvg$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeSvg
});

var IconFileTypeTs = createReactComponent("outline", "file-type-ts", "IconFileTypeTs", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1", "key": "svg-1" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-2" }], ["path", { "d": "M9 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-3" }], ["path", { "d": "M3.5 15h3", "key": "svg-4" }], ["path", { "d": "M5 15v6", "key": "svg-5" }]]);

var IconFileTypeTs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeTs
});

var IconFileTypeTsx = createReactComponent("outline", "file-type-tsx", "IconFileTypeTsx", [["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-0" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-1" }], ["path", { "d": "M16 15l4 6", "key": "svg-2" }], ["path", { "d": "M16 21l4 -6", "key": "svg-3" }], ["path", { "d": "M10 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-4" }], ["path", { "d": "M4.5 15h3", "key": "svg-5" }], ["path", { "d": "M6 15v6", "key": "svg-6" }]]);

var IconFileTypeTsx$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeTsx
});

var IconFileTypeTxt = createReactComponent("outline", "file-type-txt", "IconFileTypeTxt", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-1" }], ["path", { "d": "M16.5 15h3", "key": "svg-2" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-3" }], ["path", { "d": "M4.5 15h3", "key": "svg-4" }], ["path", { "d": "M6 15v6", "key": "svg-5" }], ["path", { "d": "M18 15v6", "key": "svg-6" }], ["path", { "d": "M10 15l4 6", "key": "svg-7" }], ["path", { "d": "M10 21l4 -6", "key": "svg-8" }]]);

var IconFileTypeTxt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeTxt
});

var IconFileTypeVue = createReactComponent("outline", "file-type-vue", "IconFileTypeVue", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M4 15l2 6l2 -6", "key": "svg-2" }], ["path", { "d": "M11 15v4.5a1.5 1.5 0 0 0 3 0v-4.5", "key": "svg-3" }], ["path", { "d": "M20 15h-3v6h3", "key": "svg-4" }], ["path", { "d": "M17 18h2", "key": "svg-5" }]]);

var IconFileTypeVue$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeVue
});

var IconFileTypeXls = createReactComponent("outline", "file-type-xls", "IconFileTypeXls", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M4 15l4 6", "key": "svg-2" }], ["path", { "d": "M4 21l4 -6", "key": "svg-3" }], ["path", { "d": "M17 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-4" }], ["path", { "d": "M11 15v6h3", "key": "svg-5" }]]);

var IconFileTypeXls$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeXls
});

var IconFileTypeXml = createReactComponent("outline", "file-type-xml", "IconFileTypeXml", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M4 15l4 6", "key": "svg-2" }], ["path", { "d": "M4 21l4 -6", "key": "svg-3" }], ["path", { "d": "M19 15v6h3", "key": "svg-4" }], ["path", { "d": "M11 21v-6l2.5 3l2.5 -3v6", "key": "svg-5" }]]);

var IconFileTypeXml$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeXml
});

var IconFileTypeZip = createReactComponent("outline", "file-type-zip", "IconFileTypeZip", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", "key": "svg-1" }], ["path", { "d": "M16 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6", "key": "svg-2" }], ["path", { "d": "M12 15v6", "key": "svg-3" }], ["path", { "d": "M5 15h3l-3 6h3", "key": "svg-4" }]]);

var IconFileTypeZip$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypeZip
});

var IconFileTypography = createReactComponent("outline", "file-typography", "IconFileTypography", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M11 18h2", "key": "svg-2" }], ["path", { "d": "M12 18v-7", "key": "svg-3" }], ["path", { "d": "M9 12v-1h6v1", "key": "svg-4" }]]);

var IconFileTypography$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTypography
});

var IconFileUnknown = createReactComponent("outline", "file-unknown", "IconFileUnknown", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 17v.01", "key": "svg-2" }], ["path", { "d": "M12 14a1.5 1.5 0 1 0 -1.14 -2.474", "key": "svg-3" }]]);

var IconFileUnknown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileUnknown
});

var IconFileUpload = createReactComponent("outline", "file-upload", "IconFileUpload", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M12 11v6", "key": "svg-2" }], ["path", { "d": "M9.5 13.5l2.5 -2.5l2.5 2.5", "key": "svg-3" }]]);

var IconFileUpload$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileUpload
});

var IconFileVector = createReactComponent("outline", "file-vector", "IconFileVector", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M9.5 16.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0", "key": "svg-1" }], ["path", { "d": "M14.5 12.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0", "key": "svg-2" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-3" }], ["path", { "d": "M9.5 15a2.5 2.5 0 0 1 2.5 -2.5h1", "key": "svg-4" }]]);

var IconFileVector$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileVector
});

var IconFileWord = createReactComponent("outline", "file-word", "IconFileWord", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2", "key": "svg-1" }], ["path", { "d": "M9 12l1.333 5l1.667 -4l1.667 4l1.333 -5", "key": "svg-2" }]]);

var IconFileWord$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileWord
});

var IconFileX = createReactComponent("outline", "file-x", "IconFileX", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M10 12l4 4m0 -4l-4 4", "key": "svg-2" }]]);

var IconFileX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileX
});

var IconFileZip = createReactComponent("outline", "file-zip", "IconFileZip", [["path", { "d": "M6 20.735a2 2 0 0 1 -1 -1.735v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1", "key": "svg-0" }], ["path", { "d": "M11 17a2 2 0 0 1 2 2v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a2 2 0 0 1 2 -2z", "key": "svg-1" }], ["path", { "d": "M11 5l-1 0", "key": "svg-2" }], ["path", { "d": "M13 7l-1 0", "key": "svg-3" }], ["path", { "d": "M11 9l-1 0", "key": "svg-4" }], ["path", { "d": "M13 11l-1 0", "key": "svg-5" }], ["path", { "d": "M11 13l-1 0", "key": "svg-6" }], ["path", { "d": "M13 15l-1 0", "key": "svg-7" }]]);

var IconFileZip$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileZip
});

var IconFile = createReactComponent("outline", "file", "IconFile", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z", "key": "svg-1" }]]);

var IconFile$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFile
});

var IconFilesOff = createReactComponent("outline", "files-off", "IconFilesOff", [["path", { "d": "M15 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M17 17h-6a2 2 0 0 1 -2 -2v-6m0 -4a2 2 0 0 1 2 -2h4l5 5v7c0 .294 -.063 .572 -.177 .823", "key": "svg-1" }], ["path", { "d": "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconFilesOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilesOff
});

var IconFiles = createReactComponent("outline", "files", "IconFiles", [["path", { "d": "M15 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M18 17h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h4l5 5v7a2 2 0 0 1 -2 2z", "key": "svg-1" }], ["path", { "d": "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-2" }]]);

var IconFiles$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFiles
});

var IconFilterBolt = createReactComponent("outline", "filter-bolt", "IconFilterBolt", [["path", { "d": "M12.991 19.67l-3.991 1.33v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v3", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }]]);

var IconFilterBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterBolt
});

var IconFilterCancel = createReactComponent("outline", "filter-cancel", "IconFilterCancel", [["path", { "d": "M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1.5", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }]]);

var IconFilterCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterCancel
});

var IconFilterCheck = createReactComponent("outline", "filter-check", "IconFilterCheck", [["path", { "d": "M11.18 20.274l-2.18 .726v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v3", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }]]);

var IconFilterCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterCheck
});

var IconFilterCode = createReactComponent("outline", "filter-code", "IconFilterCode", [["path", { "d": "M11.19 20.27l-2.19 .73v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1.5", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }]]);

var IconFilterCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterCode
});

var IconFilterCog = createReactComponent("outline", "filter-cog", "IconFilterCog", [["path", { "d": "M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1.5", "key": "svg-0" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-2" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-3" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-7" }]]);

var IconFilterCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterCog
});

var IconFilterDiscount = createReactComponent("outline", "filter-discount", "IconFilterDiscount", [["path", { "d": "M12.705 19.765l-3.705 1.235v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v.5", "key": "svg-0" }], ["path", { "d": "M16 21l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21v.01", "key": "svg-2" }], ["path", { "d": "M16 16v.01", "key": "svg-3" }]]);

var IconFilterDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterDiscount
});

var IconFilterDollar = createReactComponent("outline", "filter-dollar", "IconFilterDollar", [["path", { "d": "M13.25 19.583l-4.25 1.417v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414", "key": "svg-0" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-2" }]]);

var IconFilterDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterDollar
});

var IconFilterDown = createReactComponent("outline", "filter-down", "IconFilterDown", [["path", { "d": "M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v3", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }]]);

var IconFilterDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterDown
});

var IconFilterEdit = createReactComponent("outline", "filter-edit", "IconFilterEdit", [["path", { "d": "M10.97 20.344l-1.97 .656v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1.5", "key": "svg-0" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z", "key": "svg-1" }]]);

var IconFilterEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterEdit
});

var IconFilterExclamation = createReactComponent("outline", "filter-exclamation", "IconFilterExclamation", [["path", { "d": "M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z", "key": "svg-0" }], ["path", { "d": "M19 16v3", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }]]);

var IconFilterExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterExclamation
});

var IconFilterHeart = createReactComponent("outline", "filter-heart", "IconFilterHeart", [["path", { "d": "M10.888 20.37l-1.888 .63v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-3.503 3.503", "key": "svg-0" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-1" }]]);

var IconFilterHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterHeart
});

var IconFilterMinus = createReactComponent("outline", "filter-minus", "IconFilterMinus", [["path", { "d": "M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v3", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconFilterMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterMinus
});

var IconFilterOff = createReactComponent("outline", "filter-off", "IconFilterOff", [["path", { "d": "M8 4h12v2.172a2 2 0 0 1 -.586 1.414l-3.914 3.914m-.5 3.5v4l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconFilterOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterOff
});

var IconFilterPause = createReactComponent("outline", "filter-pause", "IconFilterPause", [["path", { "d": "M12.97 19.677l-3.97 1.323v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1.5", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }]]);

var IconFilterPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterPause
});

var IconFilterPin = createReactComponent("outline", "filter-pin", "IconFilterPin", [["path", { "d": "M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }]]);

var IconFilterPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterPin
});

var IconFilterPlus = createReactComponent("outline", "filter-plus", "IconFilterPlus", [["path", { "d": "M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v3", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconFilterPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterPlus
});

var IconFilterQuestion = createReactComponent("outline", "filter-question", "IconFilterQuestion", [["path", { "d": "M15 19l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconFilterQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterQuestion
});

var IconFilterSearch = createReactComponent("outline", "filter-search", "IconFilterSearch", [["path", { "d": "M11.36 20.213l-2.36 .787v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }]]);

var IconFilterSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterSearch
});

var IconFilterShare = createReactComponent("outline", "filter-share", "IconFilterShare", [["path", { "d": "M12.713 19.762l-3.713 1.238v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1", "key": "svg-0" }], ["path", { "d": "M16 22l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-2" }]]);

var IconFilterShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterShare
});

var IconFilterStar = createReactComponent("outline", "filter-star", "IconFilterStar", [["path", { "d": "M11.042 20.32l-2.042 .68v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414", "key": "svg-0" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }]]);

var IconFilterStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterStar
});

var IconFilterUp = createReactComponent("outline", "filter-up", "IconFilterUp", [["path", { "d": "M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v2", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }]]);

var IconFilterUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterUp
});

var IconFilterX = createReactComponent("outline", "filter-x", "IconFilterX", [["path", { "d": "M13.758 19.414l-4.758 1.586v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1.5", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }]]);

var IconFilterX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterX
});

var IconFilter = createReactComponent("outline", "filter", "IconFilter", [["path", { "d": "M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z", "key": "svg-0" }]]);

var IconFilter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilter
});

var IconFilters = createReactComponent("outline", "filters", "IconFilters", [["path", { "d": "M12 8m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M8 11a5 5 0 1 0 3.998 1.997", "key": "svg-1" }], ["path", { "d": "M12.002 19.003a5 5 0 1 0 3.998 -8.003", "key": "svg-2" }]]);

var IconFilters$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilters
});

var IconFingerprintOff = createReactComponent("outline", "fingerprint-off", "IconFingerprintOff", [["path", { "d": "M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3", "key": "svg-0" }], ["path", { "d": "M8 11c0 -.848 .264 -1.634 .713 -2.28m2.4 -1.621a4 4 0 0 1 4.887 3.901l0 1", "key": "svg-1" }], ["path", { "d": "M12 12v1a14 14 0 0 0 2.5 8", "key": "svg-2" }], ["path", { "d": "M8 15a18 18 0 0 0 1.8 6", "key": "svg-3" }], ["path", { "d": "M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 1.854 -5.143m2.176 -1.825a8 8 0 0 1 7.97 .018", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconFingerprintOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFingerprintOff
});

var IconFingerprintScan = createReactComponent("outline", "fingerprint-scan", "IconFingerprintScan", [["path", { "d": "M9 11a3 3 0 0 1 6 0c0 1.657 .612 3.082 1 4", "key": "svg-0" }], ["path", { "d": "M12 11v1.75c-.001 1.11 .661 2.206 1 3.25", "key": "svg-1" }], ["path", { "d": "M9 14.25c.068 .58 .358 1.186 .5 1.75", "key": "svg-2" }], ["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-3" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-4" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-5" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-6" }]]);

var IconFingerprintScan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFingerprintScan
});

var IconFingerprint = createReactComponent("outline", "fingerprint", "IconFingerprint", [["path", { "d": "M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3", "key": "svg-0" }], ["path", { "d": "M8 11a4 4 0 0 1 8 0v1a10 10 0 0 0 2 6", "key": "svg-1" }], ["path", { "d": "M12 11v2a14 14 0 0 0 2.5 8", "key": "svg-2" }], ["path", { "d": "M8 15a18 18 0 0 0 1.8 6", "key": "svg-3" }], ["path", { "d": "M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 12 -6.95", "key": "svg-4" }]]);

var IconFingerprint$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFingerprint
});

var IconFireExtinguisher = createReactComponent("outline", "fire-extinguisher", "IconFireExtinguisher", [["path", { "d": "M12 7a4 4 0 0 1 4 4v9a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-9a4 4 0 0 1 4 -4z", "key": "svg-0" }], ["path", { "d": "M9 16h6", "key": "svg-1" }], ["path", { "d": "M12 7v-3", "key": "svg-2" }], ["path", { "d": "M16 5l-4 -1l4 -1", "key": "svg-3" }], ["path", { "d": "M12 4h-3a3 3 0 0 0 -3 3", "key": "svg-4" }]]);

var IconFireExtinguisher$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFireExtinguisher
});

var IconFireHydrantOff = createReactComponent("outline", "fire-hydrant-off", "IconFireHydrantOff", [["path", { "d": "M5 21h14", "key": "svg-0" }], ["path", { "d": "M17 21v-4m2 -2v-2a1 1 0 0 0 -1 -1h-1v-4a5 5 0 0 0 -8.533 -3.538m-1.387 2.638a5.03 5.03 0 0 0 -.08 .9v4h-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h1v5", "key": "svg-1" }], ["path", { "d": "M12 12a2 2 0 1 0 2 2", "key": "svg-2" }], ["path", { "d": "M6 8h2m4 0h6", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconFireHydrantOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFireHydrantOff
});

var IconFireHydrant = createReactComponent("outline", "fire-hydrant", "IconFireHydrant", [["path", { "d": "M5 21h14", "key": "svg-0" }], ["path", { "d": "M17 21v-5h1a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-1v-4a5 5 0 0 0 -10 0v4h-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h1v5", "key": "svg-1" }], ["path", { "d": "M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M6 8h12", "key": "svg-3" }]]);

var IconFireHydrant$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFireHydrant
});

var IconFiretruck = createReactComponent("outline", "firetruck", "IconFiretruck", [["path", { "d": "M5 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M7 18h8m4 0h2v-6a5 5 0 0 0 -5 -5h-1l1.5 5h4.5", "key": "svg-2" }], ["path", { "d": "M12 18v-11h3", "key": "svg-3" }], ["path", { "d": "M3 17l0 -5l9 0", "key": "svg-4" }], ["path", { "d": "M3 9l18 -6", "key": "svg-5" }], ["path", { "d": "M6 12l0 -4", "key": "svg-6" }]]);

var IconFiretruck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFiretruck
});

var IconFirstAidKitOff = createReactComponent("outline", "first-aid-kit-off", "IconFirstAidKitOff", [["path", { "d": "M8.595 4.577a2 2 0 0 1 1.405 -.577h4a2 2 0 0 1 2 2v2", "key": "svg-0" }], ["path", { "d": "M12 8h6a2 2 0 0 1 2 2v6m-.576 3.405a2 2 0 0 1 -1.424 .595h-12a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M10 14h4", "key": "svg-2" }], ["path", { "d": "M12 12v4", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconFirstAidKitOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFirstAidKitOff
});

var IconFirstAidKit = createReactComponent("outline", "first-aid-kit", "IconFirstAidKit", [["path", { "d": "M8 8v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2", "key": "svg-0" }], ["path", { "d": "M4 8m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M10 14h4", "key": "svg-2" }], ["path", { "d": "M12 12v4", "key": "svg-3" }]]);

var IconFirstAidKit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFirstAidKit
});

var IconFishBone = createReactComponent("outline", "fish-bone", "IconFishBone", [["path", { "d": "M16.69 7.44a6.973 6.973 0 0 0 -1.69 4.56a6.97 6.97 0 0 0 1.699 4.571c1.914 -.684 3.691 -2.183 5.301 -4.565c-1.613 -2.384 -3.394 -3.883 -5.312 -4.565", "key": "svg-0" }], ["path", { "d": "M2 9.504a40.73 40.73 0 0 0 2.422 2.504a39.679 39.679 0 0 0 -2.422 2.498", "key": "svg-1" }], ["path", { "d": "M18 11v.01", "key": "svg-2" }], ["path", { "d": "M4.422 12h10.578", "key": "svg-3" }], ["path", { "d": "M7 10v4", "key": "svg-4" }], ["path", { "d": "M11 8v8", "key": "svg-5" }]]);

var IconFishBone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFishBone
});

var IconFishChristianity = createReactComponent("outline", "fish-christianity", "IconFishChristianity", [["path", { "d": "M22 7s-5.646 10 -12.308 10c-3.226 .025 -6.194 -1.905 -7.692 -5c1.498 -3.095 4.466 -5.025 7.692 -5c6.662 0 12.308 10 12.308 10", "key": "svg-0" }]]);

var IconFishChristianity$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFishChristianity
});

var IconFishHookOff = createReactComponent("outline", "fish-hook-off", "IconFishHookOff", [["path", { "d": "M16 9v3m-.085 3.924a5 5 0 0 1 -9.915 -.924v-4l3 3", "key": "svg-0" }], ["path", { "d": "M16 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M16 5v-2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconFishHookOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFishHookOff
});

var IconFishHook = createReactComponent("outline", "fish-hook", "IconFishHook", [["path", { "d": "M16 9v6a5 5 0 0 1 -10 0v-4l3 3", "key": "svg-0" }], ["path", { "d": "M16 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M16 5v-2", "key": "svg-2" }]]);

var IconFishHook$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFishHook
});

var IconFishOff = createReactComponent("outline", "fish-off", "IconFishOff", [["path", { "d": "M16.69 7.44a6.973 6.973 0 0 0 -1.63 3.635", "key": "svg-0" }], ["path", { "d": "M2 9.504c5.307 5.948 10.293 8.57 14.597 7.1m2.583 -1.449c.988 -.788 1.93 -1.836 2.82 -3.153c-3 -4.443 -6.596 -5.812 -10.564 -4.548m-2.764 1.266c-2.145 1.266 -4.378 3.215 -6.672 5.786", "key": "svg-1" }], ["path", { "d": "M18 11v.01", "key": "svg-2" }], ["path", { "d": "M11.153 11.169c-.287 .777 -.171 1.554 .347 2.331", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconFishOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFishOff
});

var IconFish = createReactComponent("outline", "fish", "IconFish", [["path", { "d": "M16.69 7.44a6.973 6.973 0 0 0 -1.69 4.56c0 1.747 .64 3.345 1.699 4.571", "key": "svg-0" }], ["path", { "d": "M2 9.504c7.715 8.647 14.75 10.265 20 2.498c-5.25 -7.761 -12.285 -6.142 -20 2.504", "key": "svg-1" }], ["path", { "d": "M18 11v.01", "key": "svg-2" }], ["path", { "d": "M11.5 10.5c-.667 1 -.667 2 0 3", "key": "svg-3" }]]);

var IconFish$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFish
});

var IconFlag2Off = createReactComponent("outline", "flag-2-off", "IconFlag2Off", [["path", { "d": "M5 14h9m4 0h1v-9h-10m-4 0v16", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconFlag2Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlag2Off
});

var IconFlag2 = createReactComponent("outline", "flag-2", "IconFlag2", [["path", { "d": "M5 14h14v-9h-14v16", "key": "svg-0" }]]);

var IconFlag2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlag2
});

var IconFlag3 = createReactComponent("outline", "flag-3", "IconFlag3", [["path", { "d": "M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16", "key": "svg-0" }]]);

var IconFlag3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlag3
});

var IconFlagBitcoin = createReactComponent("outline", "flag-bitcoin", "IconFlagBitcoin", [["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-0" }], ["path", { "d": "M13.222 14.882a5 5 0 0 1 -1.222 -.882a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v5", "key": "svg-1" }], ["path", { "d": "M5 21v-7", "key": "svg-2" }]]);

var IconFlagBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagBitcoin
});

var IconFlagBolt = createReactComponent("outline", "flag-bolt", "IconFlagBolt", [["path", { "d": "M14.673 15.36a4.978 4.978 0 0 1 -2.673 -1.36a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v7", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }]]);

var IconFlagBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagBolt
});

var IconFlagCancel = createReactComponent("outline", "flag-cancel", "IconFlagCancel", [["path", { "d": "M13.342 14.941a4.993 4.993 0 0 1 -1.342 -.941a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v7", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M17 21l4 -4", "key": "svg-3" }]]);

var IconFlagCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagCancel
});

var IconFlagCheck = createReactComponent("outline", "flag-check", "IconFlagCheck", [["path", { "d": "M13.767 15.12a4.983 4.983 0 0 1 -1.767 -1.12a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v8.5", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconFlagCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagCheck
});

var IconFlagCode = createReactComponent("outline", "flag-code", "IconFlagCode", [["path", { "d": "M13.41 14.973a4.991 4.991 0 0 1 -1.41 -.973a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v8", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

var IconFlagCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagCode
});

var IconFlagCog = createReactComponent("outline", "flag-cog", "IconFlagCog", [["path", { "d": "M12.901 14.702a5.014 5.014 0 0 1 -.901 -.702a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v6.5", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-3" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-4" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-8" }]]);

var IconFlagCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagCog
});

var IconFlagDiscount = createReactComponent("outline", "flag-discount", "IconFlagDiscount", [["path", { "d": "M12.804 14.641a5.02 5.02 0 0 1 -.804 -.641a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v8", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M16 21l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21v.01", "key": "svg-3" }], ["path", { "d": "M16 16v.01", "key": "svg-4" }]]);

var IconFlagDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagDiscount
});

var IconFlagDollar = createReactComponent("outline", "flag-dollar", "IconFlagDollar", [["path", { "d": "M13.222 14.882a4.998 4.998 0 0 1 -1.222 -.882a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v5", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconFlagDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagDollar
});

var IconFlagDown = createReactComponent("outline", "flag-down", "IconFlagDown", [["path", { "d": "M14.434 15.315a4.978 4.978 0 0 1 -2.434 -1.315a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v7", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-3" }]]);

var IconFlagDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagDown
});

var IconFlagExclamation = createReactComponent("outline", "flag-exclamation", "IconFlagExclamation", [["path", { "d": "M15.035 15.408a4.98 4.98 0 0 1 -3.035 -1.408a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v7", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconFlagExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagExclamation
});

var IconFlagHeart = createReactComponent("outline", "flag-heart", "IconFlagHeart", [["path", { "d": "M11.33 13.447a5.001 5.001 0 0 0 -6.33 .553v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v6", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconFlagHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagHeart
});

var IconFlagMinus = createReactComponent("outline", "flag-minus", "IconFlagMinus", [["path", { "d": "M14.373 15.301a4.978 4.978 0 0 1 -2.373 -1.301a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v9", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconFlagMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagMinus
});

var IconFlagOff = createReactComponent("outline", "flag-off", "IconFlagOff", [["path", { "d": "M5 5v16", "key": "svg-0" }], ["path", { "d": "M19 5v9", "key": "svg-1" }], ["path", { "d": "M7.641 3.645a5 5 0 0 1 4.359 1.355a5 5 0 0 0 7 0", "key": "svg-2" }], ["path", { "d": "M5 14a5 5 0 0 1 7 0a4.984 4.984 0 0 0 3.437 1.429m3.019 -.966c.19 -.14 .371 -.294 .544 -.463", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconFlagOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagOff
});

var IconFlagPause = createReactComponent("outline", "flag-pause", "IconFlagPause", [["path", { "d": "M13.536 15.029a4.987 4.987 0 0 1 -1.536 -1.029a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v8.5", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

var IconFlagPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagPause
});

var IconFlagPin = createReactComponent("outline", "flag-pin", "IconFlagPin", [["path", { "d": "M12.857 14.675a5.016 5.016 0 0 1 -.857 -.675a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v6", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }]]);

var IconFlagPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagPin
});

var IconFlagPlus = createReactComponent("outline", "flag-plus", "IconFlagPlus", [["path", { "d": "M14.433 15.315a4.978 4.978 0 0 1 -2.433 -1.315a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v7", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconFlagPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagPlus
});

var IconFlagQuestion = createReactComponent("outline", "flag-question", "IconFlagQuestion", [["path", { "d": "M13.5 15a4.914 4.914 0 0 1 -1.5 -1a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v6", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }]]);

var IconFlagQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagQuestion
});

var IconFlagSearch = createReactComponent("outline", "flag-search", "IconFlagSearch", [["path", { "d": "M12 14a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v6", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconFlagSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagSearch
});

var IconFlagShare = createReactComponent("outline", "flag-share", "IconFlagShare", [["path", { "d": "M13.13 14.833a5.002 5.002 0 0 1 -1.13 -.833a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v8", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconFlagShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagShare
});

var IconFlagSpark = createReactComponent("outline", "flag-spark", "IconFlagSpark", [["path", { "d": "M14.165 15.249a5 5 0 0 1 -2.165 -1.249a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v6.5", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-2" }]]);

var IconFlagSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagSpark
});

var IconFlagStar = createReactComponent("outline", "flag-star", "IconFlagStar", [["path", { "d": "M11.475 13.551a5.001 5.001 0 0 0 -6.475 .449v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v5", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconFlagStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagStar
});

var IconFlagUp = createReactComponent("outline", "flag-up", "IconFlagUp", [["path", { "d": "M14.138 15.241a4.979 4.979 0 0 1 -2.138 -1.241a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v7", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }]]);

var IconFlagUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagUp
});

var IconFlagX = createReactComponent("outline", "flag-x", "IconFlagX", [["path", { "d": "M13.533 15.028a4.988 4.988 0 0 1 -1.533 -1.028a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v8.5", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-2" }], ["path", { "d": "M17 22l5 -5", "key": "svg-3" }]]);

var IconFlagX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagX
});

var IconFlag = createReactComponent("outline", "flag", "IconFlag", [["path", { "d": "M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0v9a5 5 0 0 1 -7 0a5 5 0 0 0 -7 0v-9z", "key": "svg-0" }], ["path", { "d": "M5 21v-7", "key": "svg-1" }]]);

var IconFlag$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlag
});

var IconFlameOff = createReactComponent("outline", "flame-off", "IconFlameOff", [["path", { "d": "M8.973 8.974c-.335 .378 -.67 .716 -.973 1.026c-1.226 1.26 -2 3.24 -2 5a6 6 0 0 0 11.472 2.466m.383 -3.597c-.32 -1.409 -1.122 -3.045 -1.855 -3.869c-.281 .472 -.543 .87 -.79 1.202m-2.358 -2.35c-.068 -2.157 -1.182 -4.184 -1.852 -4.852c0 .968 -.18 1.801 -.465 2.527", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconFlameOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlameOff
});

var IconFlame = createReactComponent("outline", "flame", "IconFlame", [["path", { "d": "M12 10.941c2.333 -3.308 .167 -7.823 -1 -8.941c0 3.395 -2.235 5.299 -3.667 6.706c-1.43 1.408 -2.333 3.621 -2.333 5.588c0 3.704 3.134 6.706 7 6.706s7 -3.002 7 -6.706c0 -1.712 -1.232 -4.403 -2.333 -5.588c-2.084 3.353 -3.257 3.353 -4.667 2.235", "key": "svg-0" }]]);

var IconFlame$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlame
});

var IconFlare = createReactComponent("outline", "flare", "IconFlare", [["path", { "d": "M12 3l3 6l6 3l-6 3l-3 6l-3 -6l-6 -3l6 -3z", "key": "svg-0" }]]);

var IconFlare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlare
});

var IconFlask2Off = createReactComponent("outline", "flask-2-off", "IconFlask2Off", [["path", { "d": "M6.1 15h8.9", "key": "svg-0" }], ["path", { "d": "M17.742 17.741a6 6 0 0 1 -2.424 3.259h-6.635a6 6 0 0 1 1.317 -10.66v-.326m0 -4.014v-3h4v7m.613 .598a6 6 0 0 1 2.801 2.817", "key": "svg-1" }], ["path", { "d": "M9 3h6", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconFlask2Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlask2Off
});

var IconFlask2 = createReactComponent("outline", "flask-2", "IconFlask2", [["path", { "d": "M6.1 15h11.8", "key": "svg-0" }], ["path", { "d": "M14 3v7.342a6 6 0 0 1 1.318 10.658h-6.635a6 6 0 0 1 1.317 -10.66v-7.34h4z", "key": "svg-1" }], ["path", { "d": "M9 3h6", "key": "svg-2" }]]);

var IconFlask2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlask2
});

var IconFlaskOff = createReactComponent("outline", "flask-off", "IconFlaskOff", [["path", { "d": "M9 3h6", "key": "svg-0" }], ["path", { "d": "M13 9h1", "key": "svg-1" }], ["path", { "d": "M10 3v3m-.268 3.736l-3.732 10.264a.7 .7 0 0 0 .5 1h11a.7 .7 0 0 0 .5 -1l-1.143 -3.142m-2.288 -6.294l-.569 -1.564v-6", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconFlaskOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlaskOff
});

var IconFlask = createReactComponent("outline", "flask", "IconFlask", [["path", { "d": "M9 3l6 0", "key": "svg-0" }], ["path", { "d": "M10 9l4 0", "key": "svg-1" }], ["path", { "d": "M10 3v6l-4 11a.7 .7 0 0 0 .5 1h11a.7 .7 0 0 0 .5 -1l-4 -11v-6", "key": "svg-2" }]]);

var IconFlask$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlask
});

var IconFlipFlops = createReactComponent("outline", "flip-flops", "IconFlipFlops", [["path", { "d": "M18 4c2.21 0 4 1.682 4 3.758c0 .078 0 .156 -.008 .234l-.6 9.014c-.11 1.683 -1.596 3 -3.392 3s-3.28 -1.311 -3.392 -3l-.6 -9.014c-.138 -2.071 1.538 -3.855 3.743 -3.985a4.15 4.15 0 0 1 .25 -.007z", "key": "svg-0" }], ["path", { "d": "M14.5 14c1 -3.333 2.167 -5 3.5 -5c1.333 0 2.5 1.667 3.5 5", "key": "svg-1" }], ["path", { "d": "M18 16v1", "key": "svg-2" }], ["path", { "d": "M6 4c2.21 0 4 1.682 4 3.758c0 .078 0 .156 -.008 .234l-.6 9.014c-.11 1.683 -1.596 3 -3.392 3s-3.28 -1.311 -3.392 -3l-.6 -9.014c-.138 -2.071 1.538 -3.855 3.742 -3.985c.084 0 .167 -.007 .25 -.007z", "key": "svg-3" }], ["path", { "d": "M2.5 14c1 -3.333 2.167 -5 3.5 -5c1.333 0 2.5 1.667 3.5 5", "key": "svg-4" }], ["path", { "d": "M6 16v1", "key": "svg-5" }]]);

var IconFlipFlops$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlipFlops
});

var IconFlipHorizontal = createReactComponent("outline", "flip-horizontal", "IconFlipHorizontal", [["path", { "d": "M3 12l18 0", "key": "svg-0" }], ["path", { "d": "M7 16l10 0l-10 5l0 -5", "key": "svg-1" }], ["path", { "d": "M7 8l10 0l-10 -5l0 5", "key": "svg-2" }]]);

var IconFlipHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlipHorizontal
});

var IconFlipVertical = createReactComponent("outline", "flip-vertical", "IconFlipVertical", [["path", { "d": "M12 3l0 18", "key": "svg-0" }], ["path", { "d": "M16 7l0 10l5 0l-5 -10", "key": "svg-1" }], ["path", { "d": "M8 7l0 10l-5 0l5 -10", "key": "svg-2" }]]);

var IconFlipVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlipVertical
});

var IconFloatCenter = createReactComponent("outline", "float-center", "IconFloatCenter", [["path", { "d": "M9 5m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M4 7l1 0", "key": "svg-1" }], ["path", { "d": "M4 11l1 0", "key": "svg-2" }], ["path", { "d": "M19 7l1 0", "key": "svg-3" }], ["path", { "d": "M19 11l1 0", "key": "svg-4" }], ["path", { "d": "M4 15l16 0", "key": "svg-5" }], ["path", { "d": "M4 19l16 0", "key": "svg-6" }]]);

var IconFloatCenter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFloatCenter
});

var IconFloatLeft = createReactComponent("outline", "float-left", "IconFloatLeft", [["path", { "d": "M4 5m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M14 7l6 0", "key": "svg-1" }], ["path", { "d": "M14 11l6 0", "key": "svg-2" }], ["path", { "d": "M4 15l16 0", "key": "svg-3" }], ["path", { "d": "M4 19l16 0", "key": "svg-4" }]]);

var IconFloatLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFloatLeft
});

var IconFloatNone = createReactComponent("outline", "float-none", "IconFloatNone", [["path", { "d": "M4 5m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M4 15l16 0", "key": "svg-1" }], ["path", { "d": "M4 19l16 0", "key": "svg-2" }]]);

var IconFloatNone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFloatNone
});

var IconFloatRight = createReactComponent("outline", "float-right", "IconFloatRight", [["path", { "d": "M14 5m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M4 7l6 0", "key": "svg-1" }], ["path", { "d": "M4 11l6 0", "key": "svg-2" }], ["path", { "d": "M4 15l16 0", "key": "svg-3" }], ["path", { "d": "M4 19l16 0", "key": "svg-4" }]]);

var IconFloatRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFloatRight
});

var IconFlowerOff = createReactComponent("outline", "flower-off", "IconFlowerOff", [["path", { "d": "M9.875 9.882a3 3 0 0 0 4.247 4.238m.581 -3.423a3.012 3.012 0 0 0 -1.418 -1.409", "key": "svg-0" }], ["path", { "d": "M9 5a3 3 0 0 1 6 0c0 .562 -.259 1.442 -.776 2.64l-.724 1.36l1.76 -1.893c.499 -.6 .922 -1 1.27 -1.205a2.968 2.968 0 0 1 4.07 1.099a3.011 3.011 0 0 1 -1.09 4.098c-.374 .217 -.99 .396 -1.846 .535l-1.779 .244m.292 .282l1.223 .166c1 .145 1.698 .337 2.11 .576a3.011 3.011 0 0 1 1.226 3.832m-2.277 1.733a2.968 2.968 0 0 1 -1.929 -.369c-.348 -.202 -.771 -.604 -1.27 -1.205l-1.76 -1.893l.724 1.36c.516 1.199 .776 2.079 .776 2.64a3 3 0 0 1 -6 0c0 -.562 .259 -1.442 .776 -2.64l.724 -1.36l-1.76 1.893c-.499 .601 -.922 1 -1.27 1.205a2.968 2.968 0 0 1 -4.07 -1.098a3.011 3.011 0 0 1 1.09 -4.098c.374 -.218 .99 -.396 1.846 -.536l2.664 -.366l-2.4 -.325c-1 -.145 -1.698 -.337 -2.11 -.576a3.011 3.011 0 0 1 -1.09 -4.099a2.968 2.968 0 0 1 2.134 -1.467", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconFlowerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlowerOff
});

var IconFlower = createReactComponent("outline", "flower", "IconFlower", [["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12 2a3 3 0 0 1 3 3c0 .562 -.259 1.442 -.776 2.64l-.724 1.36l1.76 -1.893c.499 -.6 .922 -1 1.27 -1.205a2.968 2.968 0 0 1 4.07 1.099a3.011 3.011 0 0 1 -1.09 4.098c-.374 .217 -.99 .396 -1.846 .535l-2.664 .366l2.4 .326c1 .145 1.698 .337 2.11 .576a3.011 3.011 0 0 1 1.09 4.098a2.968 2.968 0 0 1 -4.07 1.098c-.348 -.202 -.771 -.604 -1.27 -1.205l-1.76 -1.893l.724 1.36c.516 1.199 .776 2.079 .776 2.64a3 3 0 0 1 -6 0c0 -.562 .259 -1.442 .776 -2.64l.724 -1.36l-1.76 1.893c-.499 .601 -.922 1 -1.27 1.205a2.968 2.968 0 0 1 -4.07 -1.098a3.011 3.011 0 0 1 1.09 -4.098c.374 -.218 .99 -.396 1.846 -.536l2.664 -.366l-2.4 -.325c-1 -.145 -1.698 -.337 -2.11 -.576a3.011 3.011 0 0 1 -1.09 -4.099a2.968 2.968 0 0 1 4.07 -1.099c.348 .203 .771 .604 1.27 1.205l1.76 1.894c-1 -2.292 -1.5 -3.625 -1.5 -4a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

var IconFlower$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlower
});

var IconFocus2 = createReactComponent("outline", "focus-2", "IconFocus2", [["circle", { "cx": "12", "cy": "12", "r": ".5", "fill": "currentColor", "key": "svg-0" }], ["path", { "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-1" }], ["path", { "d": "M12 3l0 2", "key": "svg-2" }], ["path", { "d": "M3 12l2 0", "key": "svg-3" }], ["path", { "d": "M12 19l0 2", "key": "svg-4" }], ["path", { "d": "M19 12l2 0", "key": "svg-5" }]]);

var IconFocus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFocus2
});

var IconFocusAuto = createReactComponent("outline", "focus-auto", "IconFocusAuto", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M10 15v-4a2 2 0 1 1 4 0v4", "key": "svg-4" }], ["path", { "d": "M10 13h4", "key": "svg-5" }]]);

var IconFocusAuto$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFocusAuto
});

var IconFocusCentered = createReactComponent("outline", "focus-centered", "IconFocusCentered", [["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-2" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-3" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-4" }]]);

var IconFocusCentered$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFocusCentered
});

var IconFocus = createReactComponent("outline", "focus", "IconFocus", [["circle", { "cx": "12", "cy": "12", "r": ".5", "fill": "currentColor", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconFocus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFocus
});

var IconFoldDown = createReactComponent("outline", "fold-down", "IconFoldDown", [["path", { "d": "M12 11v8l3 -3m-6 0l3 3", "key": "svg-0" }], ["path", { "d": "M9 7l1 0", "key": "svg-1" }], ["path", { "d": "M14 7l1 0", "key": "svg-2" }], ["path", { "d": "M19 7l1 0", "key": "svg-3" }], ["path", { "d": "M4 7l1 0", "key": "svg-4" }]]);

var IconFoldDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFoldDown
});

var IconFoldUp = createReactComponent("outline", "fold-up", "IconFoldUp", [["path", { "d": "M12 13v-8l-3 3m6 0l-3 -3", "key": "svg-0" }], ["path", { "d": "M9 17l1 0", "key": "svg-1" }], ["path", { "d": "M14 17l1 0", "key": "svg-2" }], ["path", { "d": "M19 17l1 0", "key": "svg-3" }], ["path", { "d": "M4 17l1 0", "key": "svg-4" }]]);

var IconFoldUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFoldUp
});

var IconFold = createReactComponent("outline", "fold", "IconFold", [["path", { "d": "M12 3v6l3 -3m-6 0l3 3", "key": "svg-0" }], ["path", { "d": "M12 21v-6l3 3m-6 0l3 -3", "key": "svg-1" }], ["path", { "d": "M4 12l1 0", "key": "svg-2" }], ["path", { "d": "M9 12l1 0", "key": "svg-3" }], ["path", { "d": "M14 12l1 0", "key": "svg-4" }], ["path", { "d": "M19 12l1 0", "key": "svg-5" }]]);

var IconFold$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFold
});

var IconFolderBolt = createReactComponent("outline", "folder-bolt", "IconFolderBolt", [["path", { "d": "M13 19h-8a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }]]);

var IconFolderBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderBolt
});

var IconFolderCancel = createReactComponent("outline", "folder-cancel", "IconFolderCancel", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }]]);

var IconFolderCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderCancel
});

var IconFolderCheck = createReactComponent("outline", "folder-check", "IconFolderCheck", [["path", { "d": "M11 19h-6a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }]]);

var IconFolderCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderCheck
});

var IconFolderCode = createReactComponent("outline", "folder-code", "IconFolderCode", [["path", { "d": "M11 19h-6a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }]]);

var IconFolderCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderCode
});

var IconFolderCog = createReactComponent("outline", "folder-cog", "IconFolderCog", [["path", { "d": "M12.5 19h-7.5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3", "key": "svg-0" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-2" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-3" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-7" }]]);

var IconFolderCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderCog
});

var IconFolderDollar = createReactComponent("outline", "folder-dollar", "IconFolderDollar", [["path", { "d": "M13.5 19h-8.5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v1.5", "key": "svg-0" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-2" }]]);

var IconFolderDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderDollar
});

var IconFolderDown = createReactComponent("outline", "folder-down", "IconFolderDown", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }]]);

var IconFolderDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderDown
});

var IconFolderExclamation = createReactComponent("outline", "folder-exclamation", "IconFolderExclamation", [["path", { "d": "M15 19h-10a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M19 16v3", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }]]);

var IconFolderExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderExclamation
});

var IconFolderHeart = createReactComponent("outline", "folder-heart", "IconFolderHeart", [["path", { "d": "M10.5 19h-5.5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2", "key": "svg-0" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-1" }]]);

var IconFolderHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderHeart
});

var IconFolderMinus = createReactComponent("outline", "folder-minus", "IconFolderMinus", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconFolderMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderMinus
});

var IconFolderOff = createReactComponent("outline", "folder-off", "IconFolderOff", [["path", { "d": "M8 4h1l3 3h7a2 2 0 0 1 2 2v8m-2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 1.189 -1.829", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconFolderOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderOff
});

var IconFolderOpen = createReactComponent("outline", "folder-open", "IconFolderOpen", [["path", { "d": "M5 19l2.757 -7.351a1 1 0 0 1 .936 -.649h12.307a1 1 0 0 1 .986 1.164l-.996 5.211a2 2 0 0 1 -1.964 1.625h-14.026a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2", "key": "svg-0" }]]);

var IconFolderOpen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderOpen
});

var IconFolderPause = createReactComponent("outline", "folder-pause", "IconFolderPause", [["path", { "d": "M13 19h-8a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }]]);

var IconFolderPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderPause
});

var IconFolderPin = createReactComponent("outline", "folder-pin", "IconFolderPin", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2.5", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }]]);

var IconFolderPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderPin
});

var IconFolderPlus = createReactComponent("outline", "folder-plus", "IconFolderPlus", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconFolderPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderPlus
});

var IconFolderQuestion = createReactComponent("outline", "folder-question", "IconFolderQuestion", [["path", { "d": "M15 19h-10a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2.5", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconFolderQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderQuestion
});

var IconFolderRoot = createReactComponent("outline", "folder-root", "IconFolderRoot", [["path", { "d": "M12 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 15v4", "key": "svg-1" }], ["path", { "d": "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2", "key": "svg-2" }]]);

var IconFolderRoot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderRoot
});

var IconFolderSearch = createReactComponent("outline", "folder-search", "IconFolderSearch", [["path", { "d": "M11 19h-6a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2.5", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }]]);

var IconFolderSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderSearch
});

var IconFolderShare = createReactComponent("outline", "folder-share", "IconFolderShare", [["path", { "d": "M13 19h-8a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M16 22l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-2" }]]);

var IconFolderShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderShare
});

var IconFolderStar = createReactComponent("outline", "folder-star", "IconFolderStar", [["path", { "d": "M10 19h-5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2.5", "key": "svg-0" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }]]);

var IconFolderStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderStar
});

var IconFolderSymlink = createReactComponent("outline", "folder-symlink", "IconFolderSymlink", [["path", { "d": "M3 21v-4a3 3 0 0 1 3 -3h5", "key": "svg-0" }], ["path", { "d": "M8 17l3 -3l-3 -3", "key": "svg-1" }], ["path", { "d": "M3 11v-5a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8", "key": "svg-2" }]]);

var IconFolderSymlink$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderSymlink
});

var IconFolderUp = createReactComponent("outline", "folder-up", "IconFolderUp", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }]]);

var IconFolderUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderUp
});

var IconFolderX = createReactComponent("outline", "folder-x", "IconFolderX", [["path", { "d": "M13.5 19h-8.5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }]]);

var IconFolderX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderX
});

var IconFolder = createReactComponent("outline", "folder", "IconFolder", [["path", { "d": "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2", "key": "svg-0" }]]);

var IconFolder$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolder
});

var IconFoldersOff = createReactComponent("outline", "folders-off", "IconFoldersOff", [["path", { "d": "M17 17h-8a2 2 0 0 1 -2 -2v-8m1.177 -2.823c.251 -.114 .53 -.177 .823 -.177h3l2 2h5a2 2 0 0 1 2 2v7c0 .55 -.223 1.05 -.583 1.411", "key": "svg-0" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconFoldersOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFoldersOff
});

var IconFolders = createReactComponent("outline", "folders", "IconFolders", [["path", { "d": "M9 3h3l2 2h5a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M17 16v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2", "key": "svg-1" }]]);

var IconFolders$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolders
});

var IconForbid2 = createReactComponent("outline", "forbid-2", "IconForbid2", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 15l6 -6", "key": "svg-1" }]]);

var IconForbid2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconForbid2
});

var IconForbid = createReactComponent("outline", "forbid", "IconForbid", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 9l6 6", "key": "svg-1" }]]);

var IconForbid$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconForbid
});

var IconForklift = createReactComponent("outline", "forklift", "IconForklift", [["path", { "d": "M5 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M14 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M7 17l5 0", "key": "svg-2" }], ["path", { "d": "M3 17v-6h13v6", "key": "svg-3" }], ["path", { "d": "M5 11v-4h4", "key": "svg-4" }], ["path", { "d": "M9 11v-6h4l3 6", "key": "svg-5" }], ["path", { "d": "M22 15h-3v-10", "key": "svg-6" }], ["path", { "d": "M16 13l3 0", "key": "svg-7" }]]);

var IconForklift$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconForklift
});

var IconForms = createReactComponent("outline", "forms", "IconForms", [["path", { "d": "M12 3a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3", "key": "svg-0" }], ["path", { "d": "M6 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3", "key": "svg-1" }], ["path", { "d": "M13 7h7a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-7", "key": "svg-2" }], ["path", { "d": "M5 7h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h1", "key": "svg-3" }], ["path", { "d": "M17 12h.01", "key": "svg-4" }], ["path", { "d": "M13 12h.01", "key": "svg-5" }]]);

var IconForms$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconForms
});

var IconFountainOff = createReactComponent("outline", "fountain-off", "IconFountainOff", [["path", { "d": "M9 16v-5a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M15 16v-1m0 -4a2 2 0 1 1 4 0", "key": "svg-1" }], ["path", { "d": "M12 16v-4m0 -4v-2a3 3 0 0 1 6 0", "key": "svg-2" }], ["path", { "d": "M7.451 3.43a3 3 0 0 1 4.549 2.57", "key": "svg-3" }], ["path", { "d": "M20 16h1v1m-.871 3.114a2.99 2.99 0 0 1 -2.129 .886h-12a3 3 0 0 1 -3 -3v-2h13", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconFountainOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFountainOff
});

var IconFountain = createReactComponent("outline", "fountain", "IconFountain", [["path", { "d": "M9 16v-5a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M15 16v-5a2 2 0 1 1 4 0", "key": "svg-1" }], ["path", { "d": "M12 16v-10a3 3 0 0 1 6 0", "key": "svg-2" }], ["path", { "d": "M6 6a3 3 0 0 1 6 0", "key": "svg-3" }], ["path", { "d": "M3 16h18v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-2z", "key": "svg-4" }]]);

var IconFountain$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFountain
});

var IconFrameOff = createReactComponent("outline", "frame-off", "IconFrameOff", [["path", { "d": "M4 7h3m4 0h9", "key": "svg-0" }], ["path", { "d": "M4 17h13", "key": "svg-1" }], ["path", { "d": "M7 7v13", "key": "svg-2" }], ["path", { "d": "M17 4v9m0 4v3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconFrameOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFrameOff
});

var IconFrame = createReactComponent("outline", "frame", "IconFrame", [["path", { "d": "M4 7l16 0", "key": "svg-0" }], ["path", { "d": "M4 17l16 0", "key": "svg-1" }], ["path", { "d": "M7 4l0 16", "key": "svg-2" }], ["path", { "d": "M17 4l0 16", "key": "svg-3" }]]);

var IconFrame$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFrame
});

var IconFreeRights = createReactComponent("outline", "free-rights", "IconFreeRights", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M13.867 9.75c-.246 -.48 -.708 -.769 -1.2 -.75h-1.334c-.736 0 -1.333 .67 -1.333 1.5c0 .827 .597 1.499 1.333 1.499h1.334c.736 0 1.333 .671 1.333 1.5c0 .828 -.597 1.499 -1.333 1.499h-1.334c-.492 .019 -.954 -.27 -1.2 -.75", "key": "svg-1" }], ["path", { "d": "M12 7v2", "key": "svg-2" }], ["path", { "d": "M12 15v2", "key": "svg-3" }], ["path", { "d": "M6 6l1.5 1.5", "key": "svg-4" }], ["path", { "d": "M16.5 16.5l1.5 1.5", "key": "svg-5" }]]);

var IconFreeRights$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFreeRights
});

var IconFreezeColumn = createReactComponent("outline", "freeze-column", "IconFreezeColumn", [["path", { "d": "M9 9.5l-6 6", "key": "svg-0" }], ["path", { "d": "M9 4l-6 6", "key": "svg-1" }], ["path", { "d": "M9 15l-5 5", "key": "svg-2" }], ["path", { "d": "M9 3v18", "key": "svg-3" }], ["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-4" }]]);

var IconFreezeColumn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFreezeColumn
});

var IconFreezeRowColumn = createReactComponent("outline", "freeze-row-column", "IconFreezeRowColumn", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M15 3l-12 12", "key": "svg-1" }], ["path", { "d": "M9.5 3l-6 6", "key": "svg-2" }], ["path", { "d": "M20 3.5l-5.5 5.5", "key": "svg-3" }], ["path", { "d": "M9 15l-5 5", "key": "svg-4" }], ["path", { "d": "M21 9h-12v12", "key": "svg-5" }]]);

var IconFreezeRowColumn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFreezeRowColumn
});

var IconFreezeRow = createReactComponent("outline", "freeze-row", "IconFreezeRow", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M21 9h-18", "key": "svg-1" }], ["path", { "d": "M15 3l-6 6", "key": "svg-2" }], ["path", { "d": "M9.5 3l-6 6", "key": "svg-3" }], ["path", { "d": "M20 3.5l-5.5 5.5", "key": "svg-4" }]]);

var IconFreezeRow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFreezeRow
});

var IconFridgeOff = createReactComponent("outline", "fridge-off", "IconFridgeOff", [["path", { "d": "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14", "key": "svg-0" }], ["path", { "d": "M5 10h5m4 0h5", "key": "svg-1" }], ["path", { "d": "M9 13v3", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconFridgeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFridgeOff
});

var IconFridge = createReactComponent("outline", "fridge", "IconFridge", [["path", { "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M5 10h14", "key": "svg-1" }], ["path", { "d": "M9 13v3", "key": "svg-2" }], ["path", { "d": "M9 6v1", "key": "svg-3" }]]);

var IconFridge$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFridge
});

var IconFriendsOff = createReactComponent("outline", "friends-off", "IconFriendsOff", [["path", { "d": "M5 5a2 2 0 0 0 2 2m2 -2a2 2 0 0 0 -2 -2", "key": "svg-0" }], ["path", { "d": "M5 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5", "key": "svg-1" }], ["path", { "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M15 22v-4h-2l1.254 -3.763m1.036 -2.942a1 1 0 0 1 .71 -.295h2a1 1 0 0 1 1 1l1.503 4.508m-1.503 2.492v3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconFriendsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFriendsOff
});

var IconFriends = createReactComponent("outline", "friends", "IconFriends", [["path", { "d": "M7 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M5 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5", "key": "svg-1" }], ["path", { "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M15 22v-4h-2l2 -6a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1l2 6h-2v4", "key": "svg-3" }]]);

var IconFriends$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFriends
});

var IconFrustumOff = createReactComponent("outline", "frustum-off", "IconFrustumOff", [["path", { "d": "M7.72 3.728l3.484 -1.558a1.95 1.95 0 0 1 1.59 0l4.496 2.01c.554 .246 .963 .736 1.112 1.328l2.538 10.158c.103 .412 .07 .832 -.075 1.206m-2.299 1.699l-5.725 2.738a1.945 1.945 0 0 1 -1.682 0l-7.035 -3.365a1.99 1.99 0 0 1 -1.064 -2.278l2.52 -10.08", "key": "svg-0" }], ["path", { "d": "M18 4.82l-5.198 2.324a1.963 1.963 0 0 1 -1.602 0", "key": "svg-1" }], ["path", { "d": "M12 7.32v.68m0 4v9.5", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconFrustumOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFrustumOff
});

var IconFrustumPlus = createReactComponent("outline", "frustum-plus", "IconFrustumPlus", [["path", { "d": "M12.841 21.309a1.945 1.945 0 0 1 -1.682 0l-7.035 -3.365a1.99 1.99 0 0 1 -1.064 -2.278l2.538 -10.158a1.98 1.98 0 0 1 1.11 -1.328l4.496 -2.01a1.95 1.95 0 0 1 1.59 0l4.496 2.01c.554 .246 .963 .736 1.112 1.328l1.67 6.683", "key": "svg-0" }], ["path", { "d": "M18 4.82l-5.198 2.324a1.963 1.963 0 0 1 -1.602 0l-5.2 -2.325", "key": "svg-1" }], ["path", { "d": "M12 7.32v14.18", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconFrustumPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFrustumPlus
});

var IconFrustum = createReactComponent("outline", "frustum", "IconFrustum", [["path", { "d": "M18.402 5.508l2.538 10.158a1.99 1.99 0 0 1 -1.064 2.278l-7.036 3.366a1.945 1.945 0 0 1 -1.682 0l-7.035 -3.365a1.99 1.99 0 0 1 -1.064 -2.278l2.539 -10.159a1.98 1.98 0 0 1 1.11 -1.328l4.496 -2.01a1.95 1.95 0 0 1 1.59 0l4.496 2.01c.554 .246 .963 .736 1.112 1.328z", "key": "svg-0" }], ["path", { "d": "M18 4.82l-5.198 2.324a1.963 1.963 0 0 1 -1.602 0l-5.2 -2.325", "key": "svg-1" }], ["path", { "d": "M12 7.32v14.18", "key": "svg-2" }]]);

var IconFrustum$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFrustum
});

var IconFunctionOff = createReactComponent("outline", "function-off", "IconFunctionOff", [["path", { "d": "M9 15.5v.25c0 .69 .56 1.25 1.25 1.25a1.38 1.38 0 0 0 1.374 -1.244l.376 -3.756m.363 -3.63l.013 -.126a1.38 1.38 0 0 1 1.374 -1.244c.69 0 1.25 .56 1.25 1.25v.25", "key": "svg-0" }], ["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405", "key": "svg-1" }], ["path", { "d": "M9 12h3", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconFunctionOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFunctionOff
});

var IconFunction = createReactComponent("outline", "function", "IconFunction", [["path", { "d": "M4 4m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-0" }], ["path", { "d": "M9 15.5v.25c0 .69 .56 1.25 1.25 1.25c.71 0 1.304 -.538 1.374 -1.244l.752 -7.512a1.381 1.381 0 0 1 1.374 -1.244c.69 0 1.25 .56 1.25 1.25v.25", "key": "svg-1" }], ["path", { "d": "M9 12h6", "key": "svg-2" }]]);

var IconFunction$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFunction
});

var IconGalaxy = createReactComponent("outline", "galaxy", "IconGalaxy", [["path", { "d": "M12 3c-1.333 1 -2 2.5 -2 4.5c0 3 2 4.5 2 4.5s2 1.5 2 4.5c0 2 -.667 3.5 -2 4.5", "key": "svg-0" }], ["path", { "d": "M19.794 16.5c-.2 -1.655 -1.165 -2.982 -2.897 -3.982c-2.597 -1.5 -4.897 -.518 -4.897 -.518s-2.299 .982 -4.897 -.518c-1.732 -1 -2.698 -2.327 -2.897 -3.982", "key": "svg-1" }], ["path", { "d": "M19.794 7.5c-1.532 -.655 -3.165 -.482 -4.897 .518c-2.597 1.5 -2.897 3.982 -2.897 3.982s-.299 2.482 -2.897 3.982c-1.732 1 -3.365 1.173 -4.897 .518", "key": "svg-2" }]]);

var IconGalaxy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGalaxy
});

var IconGardenCartOff = createReactComponent("outline", "garden-cart-off", "IconGardenCartOff", [["path", { "d": "M15.733 15.732a2.5 2.5 0 1 0 3.544 3.527", "key": "svg-0" }], ["path", { "d": "M6 8v11a1 1 0 0 0 1.806 .591l3.694 -5.091v.055", "key": "svg-1" }], ["path", { "d": "M6 8h2m4 0h9l-3 6.01m-3.319 .693l-4.276 -.45a4 4 0 0 1 -3.296 -2.493l-2.853 -7.13a1 1 0 0 0 -.928 -.63h-1.323", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconGardenCartOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGardenCartOff
});

var IconGardenCart = createReactComponent("outline", "garden-cart", "IconGardenCart", [["path", { "d": "M17.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-0" }], ["path", { "d": "M6 8v11a1 1 0 0 0 1.806 .591l3.694 -5.091v.055", "key": "svg-1" }], ["path", { "d": "M6 8h15l-3.5 7l-7.1 -.747a4 4 0 0 1 -3.296 -2.493l-2.853 -7.13a1 1 0 0 0 -.928 -.63h-1.323", "key": "svg-2" }]]);

var IconGardenCart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGardenCart
});

var IconGasStationOff = createReactComponent("outline", "gas-station-off", "IconGasStationOff", [["path", { "d": "M15 11a2 2 0 0 1 2 2m3 3v-7l-3 -3", "key": "svg-0" }], ["path", { "d": "M4 20v-14c0 -.548 .22 -1.044 .577 -1.405m3.423 -.595h4a2 2 0 0 1 2 2v4m0 4v6", "key": "svg-1" }], ["path", { "d": "M3 20h12", "key": "svg-2" }], ["path", { "d": "M18 7v1a1 1 0 0 0 1 1h1", "key": "svg-3" }], ["path", { "d": "M4 11h7", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconGasStationOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGasStationOff
});

var IconGasStation = createReactComponent("outline", "gas-station", "IconGasStation", [["path", { "d": "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3", "key": "svg-0" }], ["path", { "d": "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14", "key": "svg-1" }], ["path", { "d": "M3 20l12 0", "key": "svg-2" }], ["path", { "d": "M18 7v1a1 1 0 0 0 1 1h1", "key": "svg-3" }], ["path", { "d": "M4 11l10 0", "key": "svg-4" }]]);

var IconGasStation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGasStation
});

var IconGaugeOff = createReactComponent("outline", "gauge-off", "IconGaugeOff", [["path", { "d": "M20.038 16.052a9 9 0 0 0 -12.067 -12.102m-2.333 1.686a9 9 0 1 0 12.73 12.726", "key": "svg-0" }], ["path", { "d": "M11.283 11.303a1 1 0 0 0 1.419 1.41", "key": "svg-1" }], ["path", { "d": "M14 10l2 -2", "key": "svg-2" }], ["path", { "d": "M7 12c0 -1.386 .564 -2.64 1.475 -3.546m2.619 -1.372c.294 -.054 .597 -.082 .906 -.082", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconGaugeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGaugeOff
});

var IconGauge = createReactComponent("outline", "gauge", "IconGauge", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M13.41 10.59l2.59 -2.59", "key": "svg-2" }], ["path", { "d": "M7 12a5 5 0 0 1 5 -5", "key": "svg-3" }]]);

var IconGauge$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGauge
});

var IconGavel = createReactComponent("outline", "gavel", "IconGavel", [["path", { "d": "M13 10l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385", "key": "svg-0" }], ["path", { "d": "M6 9l4 4", "key": "svg-1" }], ["path", { "d": "M13 10l-4 -4", "key": "svg-2" }], ["path", { "d": "M3 21h7", "key": "svg-3" }], ["path", { "d": "M6.793 15.793l-3.586 -3.586a1 1 0 0 1 0 -1.414l2.293 -2.293l.5 .5l3 -3l-.5 -.5l2.293 -2.293a1 1 0 0 1 1.414 0l3.586 3.586a1 1 0 0 1 0 1.414l-2.293 2.293l-.5 -.5l-3 3l.5 .5l-2.293 2.293a1 1 0 0 1 -1.414 0z", "key": "svg-4" }]]);

var IconGavel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGavel
});

var IconGenderAgender = createReactComponent("outline", "gender-agender", "IconGenderAgender", [["path", { "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-0" }], ["path", { "d": "M7 12h11", "key": "svg-1" }]]);

var IconGenderAgender$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderAgender
});

var IconGenderAndrogyne = createReactComponent("outline", "gender-androgyne", "IconGenderAndrogyne", [["path", { "d": "M13 11l6 -6", "key": "svg-0" }], ["path", { "d": "M9 15m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-1" }], ["path", { "d": "M19 9v-4h-4", "key": "svg-2" }], ["path", { "d": "M16.5 10.5l-3 -3", "key": "svg-3" }]]);

var IconGenderAndrogyne$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderAndrogyne
});

var IconGenderBigender = createReactComponent("outline", "gender-bigender", "IconGenderBigender", [["path", { "d": "M11 11m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M19 3l-5 5", "key": "svg-1" }], ["path", { "d": "M15 3h4v4", "key": "svg-2" }], ["path", { "d": "M11 16v6", "key": "svg-3" }], ["path", { "d": "M8 19h6", "key": "svg-4" }]]);

var IconGenderBigender$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderBigender
});

var IconGenderDemiboy = createReactComponent("outline", "gender-demiboy", "IconGenderDemiboy", [["path", { "d": "M10 14m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M19 5l-5.4 5.4", "key": "svg-1" }], ["path", { "d": "M19 5h-5", "key": "svg-2" }]]);

var IconGenderDemiboy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderDemiboy
});

var IconGenderDemigirl = createReactComponent("outline", "gender-demigirl", "IconGenderDemigirl", [["path", { "d": "M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M12 14v7", "key": "svg-1" }], ["path", { "d": "M9 18h3", "key": "svg-2" }]]);

var IconGenderDemigirl$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderDemigirl
});

var IconGenderEpicene = createReactComponent("outline", "gender-epicene", "IconGenderEpicene", [["path", { "d": "M15.536 15.536a5 5 0 1 0 -7.072 -7.072a5 5 0 0 0 7.072 7.072z", "key": "svg-0" }], ["path", { "d": "M15.536 15.535l5.464 -5.535", "key": "svg-1" }], ["path", { "d": "M3 14l5.464 -5.535", "key": "svg-2" }], ["path", { "d": "M12 12h.01", "key": "svg-3" }]]);

var IconGenderEpicene$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderEpicene
});

var IconGenderFemale = createReactComponent("outline", "gender-female", "IconGenderFemale", [["path", { "d": "M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M12 14v7", "key": "svg-1" }], ["path", { "d": "M9 18h6", "key": "svg-2" }]]);

var IconGenderFemale$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderFemale
});

var IconGenderFemme = createReactComponent("outline", "gender-femme", "IconGenderFemme", [["path", { "d": "M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M12 14v7", "key": "svg-1" }], ["path", { "d": "M7 18h10", "key": "svg-2" }]]);

var IconGenderFemme$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderFemme
});

var IconGenderGenderfluid = createReactComponent("outline", "gender-genderfluid", "IconGenderGenderfluid", [["path", { "d": "M10 15.464a4 4 0 1 0 4 -6.928a4 4 0 0 0 -4 6.928z", "key": "svg-0" }], ["path", { "d": "M15.464 14l3 -5.196", "key": "svg-1" }], ["path", { "d": "M5.536 15.195l3 -5.196", "key": "svg-2" }], ["path", { "d": "M12 12h.01", "key": "svg-3" }], ["path", { "d": "M9 9l-6 -6", "key": "svg-4" }], ["path", { "d": "M5.5 8.5l3 -3", "key": "svg-5" }], ["path", { "d": "M21 21l-6 -6", "key": "svg-6" }], ["path", { "d": "M17 20l3 -3", "key": "svg-7" }], ["path", { "d": "M3 7v-4h4", "key": "svg-8" }]]);

var IconGenderGenderfluid$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderGenderfluid
});

var IconGenderGenderless = createReactComponent("outline", "gender-genderless", "IconGenderGenderless", [["path", { "d": "M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z", "key": "svg-0" }], ["path", { "d": "M12 10v-7", "key": "svg-1" }], ["path", { "d": "M7 15h10", "key": "svg-2" }]]);

var IconGenderGenderless$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderGenderless
});

var IconGenderGenderqueer = createReactComponent("outline", "gender-genderqueer", "IconGenderGenderqueer", [["path", { "d": "M12 11a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z", "key": "svg-0" }], ["path", { "d": "M12 11v-8", "key": "svg-1" }], ["path", { "d": "M14.5 4.5l-5 3", "key": "svg-2" }], ["path", { "d": "M9.5 4.5l5 3", "key": "svg-3" }]]);

var IconGenderGenderqueer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderGenderqueer
});

var IconGenderHermaphrodite = createReactComponent("outline", "gender-hermaphrodite", "IconGenderHermaphrodite", [["path", { "d": "M12 14v7", "key": "svg-0" }], ["path", { "d": "M9 18h6", "key": "svg-1" }], ["path", { "d": "M12 6a4 4 0 1 1 0 8a4 4 0 0 1 0 -8z", "key": "svg-2" }], ["path", { "d": "M15 3a3 3 0 1 1 -6 0", "key": "svg-3" }]]);

var IconGenderHermaphrodite$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderHermaphrodite
});

var IconGenderIntergender = createReactComponent("outline", "gender-intergender", "IconGenderIntergender", [["path", { "d": "M13.5 11.5l6.5 6.5v-4", "key": "svg-0" }], ["path", { "d": "M11.5 13.5l6.5 6.5", "key": "svg-1" }], ["path", { "d": "M9 4a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z", "key": "svg-2" }], ["path", { "d": "M14 20l2 -2", "key": "svg-3" }]]);

var IconGenderIntergender$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderIntergender
});

var IconGenderMale = createReactComponent("outline", "gender-male", "IconGenderMale", [["path", { "d": "M10 14m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M19 5l-5.4 5.4", "key": "svg-1" }], ["path", { "d": "M19 5h-5", "key": "svg-2" }], ["path", { "d": "M19 5v5", "key": "svg-3" }]]);

var IconGenderMale$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderMale
});

var IconGenderNeutrois = createReactComponent("outline", "gender-neutrois", "IconGenderNeutrois", [["path", { "d": "M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z", "key": "svg-0" }], ["path", { "d": "M12 10v-7", "key": "svg-1" }]]);

var IconGenderNeutrois$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderNeutrois
});

var IconGenderThird = createReactComponent("outline", "gender-third", "IconGenderThird", [["path", { "d": "M11 12a5 5 0 1 0 10 0a5 5 0 0 0 -10 0z", "key": "svg-0" }], ["path", { "d": "M11 12h-3", "key": "svg-1" }], ["path", { "d": "M8 12l-5 -4v8z", "key": "svg-2" }]]);

var IconGenderThird$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderThird
});

var IconGenderTransgender = createReactComponent("outline", "gender-transgender", "IconGenderTransgender", [["path", { "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M15 9l6 -6", "key": "svg-1" }], ["path", { "d": "M21 7v-4h-4", "key": "svg-2" }], ["path", { "d": "M9 9l-6 -6", "key": "svg-3" }], ["path", { "d": "M3 7v-4h4", "key": "svg-4" }], ["path", { "d": "M5.5 8.5l3 -3", "key": "svg-5" }], ["path", { "d": "M12 16v5", "key": "svg-6" }], ["path", { "d": "M9.5 19h5", "key": "svg-7" }]]);

var IconGenderTransgender$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderTransgender
});

var IconGenderTrasvesti = createReactComponent("outline", "gender-trasvesti", "IconGenderTrasvesti", [["path", { "d": "M15 20a5 5 0 1 1 0 -10a5 5 0 0 1 0 10z", "key": "svg-0" }], ["path", { "d": "M6 6l5.4 5.4", "key": "svg-1" }], ["path", { "d": "M4 8l4 -4", "key": "svg-2" }]]);

var IconGenderTrasvesti$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGenderTrasvesti
});

var IconGeometry = createReactComponent("outline", "geometry", "IconGeometry", [["path", { "d": "M7 21l4 -12m2 0l1.48 4.439m.949 2.847l1.571 4.714", "key": "svg-0" }], ["path", { "d": "M12 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M4 12c1.526 2.955 4.588 5 8 5c3.41 0 6.473 -2.048 8 -5", "key": "svg-2" }], ["path", { "d": "M12 5v-2", "key": "svg-3" }]]);

var IconGeometry$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGeometry
});

var IconGhost2 = createReactComponent("outline", "ghost-2", "IconGhost2", [["path", { "d": "M10 9h.01", "key": "svg-0" }], ["path", { "d": "M14 9h.01", "key": "svg-1" }], ["path", { "d": "M12 3a7 7 0 0 1 7 7v1l1 0a2 2 0 1 1 0 4l-1 0v3l2 3h-10a6 6 0 0 1 -6 -5.775l0 -.226l-1 0a2 2 0 0 1 0 -4l1 0v-1a7 7 0 0 1 7 -7z", "key": "svg-2" }], ["path", { "d": "M11 14h2a1 1 0 0 0 -2 0z", "key": "svg-3" }]]);

var IconGhost2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGhost2
});

var IconGhost3 = createReactComponent("outline", "ghost-3", "IconGhost3", [["path", { "d": "M5 11a7 7 0 0 1 14 0v7a1.78 1.78 0 0 1 -3.1 1.4a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-7", "key": "svg-0" }], ["path", { "d": "M10 10h.01", "key": "svg-1" }], ["path", { "d": "M14 10h.01", "key": "svg-2" }]]);

var IconGhost3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGhost3
});

var IconGhostOff = createReactComponent("outline", "ghost-off", "IconGhostOff", [["path", { "d": "M8.794 4.776a7 7 0 0 1 10.206 6.224v4m-.12 3.898a1.779 1.779 0 0 1 -2.98 .502a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-7c0 -1.683 .594 -3.227 1.583 -4.434", "key": "svg-0" }], ["path", { "d": "M14 10h.01", "key": "svg-1" }], ["path", { "d": "M10 14a3.5 3.5 0 0 0 4 0", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconGhostOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGhostOff
});

var IconGhost = createReactComponent("outline", "ghost", "IconGhost", [["path", { "d": "M5 11a7 7 0 0 1 14 0v7a1.78 1.78 0 0 1 -3.1 1.4a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-7", "key": "svg-0" }], ["path", { "d": "M10 10l.01 0", "key": "svg-1" }], ["path", { "d": "M14 10l.01 0", "key": "svg-2" }], ["path", { "d": "M10 14a3.5 3.5 0 0 0 4 0", "key": "svg-3" }]]);

var IconGhost$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGhost
});

var IconGif = createReactComponent("outline", "gif", "IconGif", [["path", { "d": "M8 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }], ["path", { "d": "M16 12h3", "key": "svg-2" }], ["path", { "d": "M20 8h-4v8", "key": "svg-3" }]]);

var IconGif$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGif
});

var IconGiftCard = createReactComponent("outline", "gift-card", "IconGiftCard", [["path", { "d": "M3 5m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M7 16l3 -3l3 3", "key": "svg-1" }], ["path", { "d": "M8 13c-.789 0 -2 -.672 -2 -1.5s.711 -1.5 1.5 -1.5c1.128 -.02 2.077 1.17 2.5 3c.423 -1.83 1.372 -3.02 2.5 -3c.789 0 1.5 .672 1.5 1.5s-1.211 1.5 -2 1.5h-4z", "key": "svg-2" }]]);

var IconGiftCard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGiftCard
});

var IconGiftOff = createReactComponent("outline", "gift-off", "IconGiftOff", [["path", { "d": "M12 8h8a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4m-4 0h-8a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h4", "key": "svg-0" }], ["path", { "d": "M12 12v9", "key": "svg-1" }], ["path", { "d": "M19 12v3m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7", "key": "svg-2" }], ["path", { "d": "M7.5 8a2.5 2.5 0 0 1 -2.457 -2.963m2.023 -2c.14 -.023 .286 -.037 .434 -.037c1.974 -.034 3.76 1.95 4.5 5c.74 -3.05 2.526 -5.034 4.5 -5a2.5 2.5 0 1 1 0 5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconGiftOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGiftOff
});

var IconGift = createReactComponent("outline", "gift", "IconGift", [["path", { "d": "M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M12 8l0 13", "key": "svg-1" }], ["path", { "d": "M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7", "key": "svg-2" }], ["path", { "d": "M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5", "key": "svg-3" }]]);

var IconGift$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGift
});

var IconGitBranchDeleted = createReactComponent("outline", "git-branch-deleted", "IconGitBranchDeleted", [["path", { "d": "M7 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M7 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M7 8v8", "key": "svg-2" }], ["path", { "d": "M9 18h6a2 2 0 0 0 2 -2v-5", "key": "svg-3" }], ["path", { "d": "M14 14l3 -3l3 3", "key": "svg-4" }], ["path", { "d": "M15 4l4 4", "key": "svg-5" }], ["path", { "d": "M15 8l4 -4", "key": "svg-6" }]]);

var IconGitBranchDeleted$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGitBranchDeleted
});

var IconGitBranch = createReactComponent("outline", "git-branch", "IconGitBranch", [["path", { "d": "M7 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M7 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M17 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M7 8l0 8", "key": "svg-3" }], ["path", { "d": "M9 18h6a2 2 0 0 0 2 -2v-5", "key": "svg-4" }], ["path", { "d": "M14 14l3 -3l3 3", "key": "svg-5" }]]);

var IconGitBranch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGitBranch
});

var IconGitCherryPick = createReactComponent("outline", "git-cherry-pick", "IconGitCherryPick", [["path", { "d": "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M7 3v6", "key": "svg-1" }], ["path", { "d": "M7 15v6", "key": "svg-2" }], ["path", { "d": "M13 7h2.5l1.5 5l-1.5 5h-2.5", "key": "svg-3" }], ["path", { "d": "M17 12h3", "key": "svg-4" }]]);

var IconGitCherryPick$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGitCherryPick
});

var IconGitCommit = createReactComponent("outline", "git-commit", "IconGitCommit", [["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12 3l0 6", "key": "svg-1" }], ["path", { "d": "M12 15l0 6", "key": "svg-2" }]]);

var IconGitCommit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGitCommit
});

var IconGitCompare = createReactComponent("outline", "git-compare", "IconGitCompare", [["path", { "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M11 6h5a2 2 0 0 1 2 2v8", "key": "svg-2" }], ["path", { "d": "M14 9l-3 -3l3 -3", "key": "svg-3" }], ["path", { "d": "M13 18h-5a2 2 0 0 1 -2 -2v-8", "key": "svg-4" }], ["path", { "d": "M10 15l3 3l-3 3", "key": "svg-5" }]]);

var IconGitCompare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGitCompare
});

var IconGitFork = createReactComponent("outline", "git-fork", "IconGitFork", [["path", { "d": "M12 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M7 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M17 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M7 8v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M12 12l0 4", "key": "svg-4" }]]);

var IconGitFork$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGitFork
});

var IconGitMerge = createReactComponent("outline", "git-merge", "IconGitMerge", [["path", { "d": "M7 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M7 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M17 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M7 8l0 8", "key": "svg-3" }], ["path", { "d": "M7 8a4 4 0 0 0 4 4h4", "key": "svg-4" }]]);

var IconGitMerge$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGitMerge
});

var IconGitPullRequestClosed = createReactComponent("outline", "git-pull-request-closed", "IconGitPullRequestClosed", [["path", { "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M6 8v8", "key": "svg-3" }], ["path", { "d": "M18 11v5", "key": "svg-4" }], ["path", { "d": "M16 4l4 4m0 -4l-4 4", "key": "svg-5" }]]);

var IconGitPullRequestClosed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGitPullRequestClosed
});

var IconGitPullRequestDraft = createReactComponent("outline", "git-pull-request-draft", "IconGitPullRequestDraft", [["path", { "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M6 8v8", "key": "svg-3" }], ["path", { "d": "M18 11h.01", "key": "svg-4" }], ["path", { "d": "M18 6h.01", "key": "svg-5" }]]);

var IconGitPullRequestDraft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGitPullRequestDraft
});

var IconGitPullRequest = createReactComponent("outline", "git-pull-request", "IconGitPullRequest", [["path", { "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M6 8l0 8", "key": "svg-3" }], ["path", { "d": "M11 6h5a2 2 0 0 1 2 2v8", "key": "svg-4" }], ["path", { "d": "M14 9l-3 -3l3 -3", "key": "svg-5" }]]);

var IconGitPullRequest$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGitPullRequest
});

var IconGizmo = createReactComponent("outline", "gizmo", "IconGizmo", [["path", { "d": "M20 19l-8 -5.5l-8 5.5", "key": "svg-0" }], ["path", { "d": "M12 4v9.5", "key": "svg-1" }], ["path", { "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M4 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M20 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }]]);

var IconGizmo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGizmo
});

var IconGlassChampagne = createReactComponent("outline", "glass-champagne", "IconGlassChampagne", [["path", { "d": "M9 21h6", "key": "svg-0" }], ["path", { "d": "M12 16v5", "key": "svg-1" }], ["path", { "d": "M12 5m-4 0a4 2 0 1 0 8 0a4 2 0 1 0 -8 0", "key": "svg-2" }], ["path", { "d": "M8 5c0 6.075 1.79 11 4 11s4 -4.925 4 -11", "key": "svg-3" }]]);

var IconGlassChampagne$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGlassChampagne
});

var IconGlassCocktail = createReactComponent("outline", "glass-cocktail", "IconGlassCocktail", [["path", { "d": "M8 21h8", "key": "svg-0" }], ["path", { "d": "M12 15v6", "key": "svg-1" }], ["path", { "d": "M12 5m-7 0a7 2 0 1 0 14 0a7 2 0 1 0 -14 0", "key": "svg-2" }], ["path", { "d": "M5 5v.388c0 .432 .126 .853 .362 1.206l5 7.509c.633 .951 1.88 1.183 2.785 .517c.191 -.141 .358 -.316 .491 -.517l5 -7.509c.236 -.353 .362 -.774 .362 -1.206v-.388", "key": "svg-3" }]]);

var IconGlassCocktail$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGlassCocktail
});

var IconGlassFull = createReactComponent("outline", "glass-full", "IconGlassFull", [["path", { "d": "M8 21l8 0", "key": "svg-0" }], ["path", { "d": "M12 15l0 6", "key": "svg-1" }], ["path", { "d": "M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z", "key": "svg-2" }], ["path", { "d": "M6 10a5 5 0 0 1 6 0a5 5 0 0 0 6 0", "key": "svg-3" }]]);

var IconGlassFull$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGlassFull
});

var IconGlassGin = createReactComponent("outline", "glass-gin", "IconGlassGin", [["path", { "d": "M8 21h8", "key": "svg-0" }], ["path", { "d": "M12 15v6", "key": "svg-1" }], ["path", { "d": "M12 5m-6.5 0a6.5 2 0 1 0 13 0a6.5 2 0 1 0 -13 0", "key": "svg-2" }], ["path", { "d": "M5.75 4.5c-.612 .75 -.75 2 -.75 3.5a7 7 0 0 0 14 0c0 -1.5 -.094 -2.75 -.75 -3.5", "key": "svg-3" }]]);

var IconGlassGin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGlassGin
});

var IconGlassOff = createReactComponent("outline", "glass-off", "IconGlassOff", [["path", { "d": "M8 21h8", "key": "svg-0" }], ["path", { "d": "M12 16v5", "key": "svg-1" }], ["path", { "d": "M17 5l1 6c0 .887 -.233 1.685 -.646 2.37m-2.083 1.886c-.941 .48 -2.064 .744 -3.271 .744c-3.314 0 -6 -1.988 -6 -5l.711 -4.268", "key": "svg-2" }], ["path", { "d": "M10.983 6.959c.329 .027 .669 .041 1.017 .041c2.761 0 5 -.895 5 -2s-2.239 -2 -5 -2c-1.716 0 -3.23 .346 -4.13 .872", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconGlassOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGlassOff
});

var IconGlass = createReactComponent("outline", "glass", "IconGlass", [["path", { "d": "M8 21h8", "key": "svg-0" }], ["path", { "d": "M12 16v5", "key": "svg-1" }], ["path", { "d": "M17 5l1 6c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -6", "key": "svg-2" }], ["path", { "d": "M12 5m-5 0a5 2 0 1 0 10 0a5 2 0 1 0 -10 0", "key": "svg-3" }]]);

var IconGlass$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGlass
});

var IconGlobeOff = createReactComponent("outline", "globe-off", "IconGlobeOff", [["path", { "d": "M7.353 7.355a4 4 0 0 0 5.29 5.293m2.007 -2.009a4 4 0 0 0 -5.3 -5.284", "key": "svg-0" }], ["path", { "d": "M5.75 15a8.015 8.015 0 0 0 9.792 .557m2.02 -1.998a8.015 8.015 0 0 0 -2.562 -11.559", "key": "svg-1" }], ["path", { "d": "M11 17v4", "key": "svg-2" }], ["path", { "d": "M7 21h8", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconGlobeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGlobeOff
});

var IconGlobe = createReactComponent("outline", "globe", "IconGlobe", [["path", { "d": "M7 9a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M5.75 15a8.015 8.015 0 1 0 9.25 -13", "key": "svg-1" }], ["path", { "d": "M11 17v4", "key": "svg-2" }], ["path", { "d": "M7 21h8", "key": "svg-3" }]]);

var IconGlobe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGlobe
});

var IconGoGame = createReactComponent("outline", "go-game", "IconGoGame", [["path", { "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M3 12h7m4 0h7", "key": "svg-4" }], ["path", { "d": "M3 6h1m4 0h13", "key": "svg-5" }], ["path", { "d": "M3 18h1m4 0h8m4 0h1", "key": "svg-6" }], ["path", { "d": "M6 3v1m0 4v8m0 4v1", "key": "svg-7" }], ["path", { "d": "M12 3v7m0 4v7", "key": "svg-8" }], ["path", { "d": "M18 3v13m0 4v1", "key": "svg-9" }]]);

var IconGoGame$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGoGame
});

var IconGolfOff = createReactComponent("outline", "golf-off", "IconGolfOff", [["path", { "d": "M12 18v-6m0 -4v-5l7 4l-5.07 2.897", "key": "svg-0" }], ["path", { "d": "M9 17.67c-.62 .36 -1 .82 -1 1.33c0 1.1 1.8 2 4 2s4 -.9 4 -2c0 -.5 -.38 -.97 -1 -1.33", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconGolfOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGolfOff
});

var IconGolf = createReactComponent("outline", "golf", "IconGolf", [["path", { "d": "M12 18v-15l7 4l-7 4", "key": "svg-0" }], ["path", { "d": "M9 17.67c-.62 .36 -1 .82 -1 1.33c0 1.1 1.8 2 4 2s4 -.9 4 -2c0 -.5 -.38 -.97 -1 -1.33", "key": "svg-1" }]]);

var IconGolf$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGolf
});

var IconGps = createReactComponent("outline", "gps", "IconGps", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 17l-1 -4l-4 -1l9 -4z", "key": "svg-1" }]]);

var IconGps$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGps
});

var IconGradienter = createReactComponent("outline", "gradienter", "IconGradienter", [["path", { "d": "M3.227 14c.917 4 4.497 7 8.773 7c4.277 0 7.858 -3 8.773 -7", "key": "svg-0" }], ["path", { "d": "M20.78 10a9 9 0 0 0 -8.78 -7a8.985 8.985 0 0 0 -8.782 7", "key": "svg-1" }], ["path", { "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }]]);

var IconGradienter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGradienter
});

var IconGrain = createReactComponent("outline", "grain", "IconGrain", [["path", { "d": "M4.5 9.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M9.5 4.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M9.5 14.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M4.5 19.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M14.5 9.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["path", { "d": "M19.5 4.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-5" }], ["path", { "d": "M14.5 19.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-6" }], ["path", { "d": "M19.5 14.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-7" }]]);

var IconGrain$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGrain
});

var IconGraphOff = createReactComponent("outline", "graph-off", "IconGraphOff", [["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405", "key": "svg-0" }], ["path", { "d": "M7 14l3 -3l2 2l.5 -.5m2 -2l.5 -.5l2 2", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconGraphOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGraphOff
});

var IconGraph = createReactComponent("outline", "graph", "IconGraph", [["path", { "d": "M4 18v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 14l3 -3l2 2l3 -3l2 2", "key": "svg-1" }]]);

var IconGraph$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGraph
});

var IconGrave2 = createReactComponent("outline", "grave-2", "IconGrave2", [["path", { "d": "M7 16.17v-9.17a3 3 0 0 1 3 -3h4a3 3 0 0 1 3 3v9.171", "key": "svg-0" }], ["path", { "d": "M12 7v5", "key": "svg-1" }], ["path", { "d": "M10 9h4", "key": "svg-2" }], ["path", { "d": "M5 21v-2a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v2h-14z", "key": "svg-3" }]]);

var IconGrave2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGrave2
});

var IconGrave = createReactComponent("outline", "grave", "IconGrave", [["path", { "d": "M5 21v-2a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v2h-14z", "key": "svg-0" }], ["path", { "d": "M10 16v-5h-4v-4h4v-4h4v4h4v4h-4v5", "key": "svg-1" }]]);

var IconGrave$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGrave
});

var IconGrid3x3 = createReactComponent("outline", "grid-3x3", "IconGrid3x3", [["path", { "d": "M3 8h18", "key": "svg-0" }], ["path", { "d": "M3 16h18", "key": "svg-1" }], ["path", { "d": "M8 3v18", "key": "svg-2" }], ["path", { "d": "M16 3v18", "key": "svg-3" }]]);

var IconGrid3x3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGrid3x3
});

var IconGrid4x4 = createReactComponent("outline", "grid-4x4", "IconGrid4x4", [["path", { "d": "M3 6h18", "key": "svg-0" }], ["path", { "d": "M3 12h18", "key": "svg-1" }], ["path", { "d": "M3 18h18", "key": "svg-2" }], ["path", { "d": "M6 3v18", "key": "svg-3" }], ["path", { "d": "M12 3v18", "key": "svg-4" }], ["path", { "d": "M18 3v18", "key": "svg-5" }]]);

var IconGrid4x4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGrid4x4
});

var IconGridDots = createReactComponent("outline", "grid-dots", "IconGridDots", [["path", { "d": "M5 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M19 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["path", { "d": "M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-5" }], ["path", { "d": "M5 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-6" }], ["path", { "d": "M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-7" }], ["path", { "d": "M19 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-8" }]]);

var IconGridDots$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGridDots
});

var IconGridGoldenratio = createReactComponent("outline", "grid-goldenratio", "IconGridGoldenratio", [["path", { "d": "M3 10h18", "key": "svg-0" }], ["path", { "d": "M3 14h18", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }], ["path", { "d": "M14 3v18", "key": "svg-3" }]]);

var IconGridGoldenratio$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGridGoldenratio
});

var IconGridPattern = createReactComponent("outline", "grid-pattern", "IconGridPattern", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8v8", "key": "svg-1" }], ["path", { "d": "M14 8v8", "key": "svg-2" }], ["path", { "d": "M8 10h8", "key": "svg-3" }], ["path", { "d": "M8 14h8", "key": "svg-4" }]]);

var IconGridPattern$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGridPattern
});

var IconGridScan = createReactComponent("outline", "grid-scan", "IconGridScan", [["path", { "d": "M10 8v8", "key": "svg-0" }], ["path", { "d": "M14 8v8", "key": "svg-1" }], ["path", { "d": "M8 10h8", "key": "svg-2" }], ["path", { "d": "M8 14h8", "key": "svg-3" }], ["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-4" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-5" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-6" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-7" }]]);

var IconGridScan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGridScan
});

var IconGrillFork = createReactComponent("outline", "grill-fork", "IconGrillFork", [["path", { "d": "M5 5l11.5 11.5", "key": "svg-0" }], ["path", { "d": "M19.347 16.575l1.08 1.079a1.96 1.96 0 0 1 -2.773 2.772l-1.08 -1.079a1.96 1.96 0 0 1 2.773 -2.772z", "key": "svg-1" }], ["path", { "d": "M3 7l3.05 3.15a2.9 2.9 0 0 0 4.1 -4.1l-3.15 -3.05", "key": "svg-2" }]]);

var IconGrillFork$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGrillFork
});

var IconGrillOff = createReactComponent("outline", "grill-off", "IconGrillOff", [["path", { "d": "M8 8h-3a6 6 0 0 0 6 6h2c.315 0 .624 -.024 .926 -.071m2.786 -1.214a5.99 5.99 0 0 0 2.284 -4.49l0 -.225h-7", "key": "svg-0" }], ["path", { "d": "M18.827 18.815a2 2 0 1 1 -2.663 -2.633", "key": "svg-1" }], ["path", { "d": "M9 14l-3 6", "key": "svg-2" }], ["path", { "d": "M15 18h-8", "key": "svg-3" }], ["path", { "d": "M15 5v-1", "key": "svg-4" }], ["path", { "d": "M12 5v-1", "key": "svg-5" }], ["path", { "d": "M9 5v-1", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconGrillOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGrillOff
});

var IconGrillSpatula = createReactComponent("outline", "grill-spatula", "IconGrillSpatula", [["path", { "d": "M10.2 10.2l6.3 6.3", "key": "svg-0" }], ["path", { "d": "M19.347 16.575l1.08 1.079a1.96 1.96 0 0 1 -2.773 2.772l-1.08 -1.079a1.96 1.96 0 0 1 2.773 -2.772z", "key": "svg-1" }], ["path", { "d": "M3 7l3.05 3.15a2.9 2.9 0 0 0 4.1 -4.1l-3.15 -3.05l-4 4z", "key": "svg-2" }]]);

var IconGrillSpatula$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGrillSpatula
});

var IconGrill = createReactComponent("outline", "grill", "IconGrill", [["path", { "d": "M19 8h-14a6 6 0 0 0 6 6h2a6 6 0 0 0 6 -5.775l0 -.225z", "key": "svg-0" }], ["path", { "d": "M17 20a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z", "key": "svg-1" }], ["path", { "d": "M15 14l1 2", "key": "svg-2" }], ["path", { "d": "M9 14l-3 6", "key": "svg-3" }], ["path", { "d": "M15 18h-8", "key": "svg-4" }], ["path", { "d": "M15 5v-1", "key": "svg-5" }], ["path", { "d": "M12 5v-1", "key": "svg-6" }], ["path", { "d": "M9 5v-1", "key": "svg-7" }]]);

var IconGrill$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGrill
});

var IconGripHorizontal = createReactComponent("outline", "grip-horizontal", "IconGripHorizontal", [["path", { "d": "M5 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M5 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M12 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M12 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M19 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["path", { "d": "M19 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-5" }]]);

var IconGripHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGripHorizontal
});

var IconGripVertical = createReactComponent("outline", "grip-vertical", "IconGripVertical", [["path", { "d": "M9 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M9 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M9 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M15 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M15 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["path", { "d": "M15 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-5" }]]);

var IconGripVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGripVertical
});

var IconGrowth = createReactComponent("outline", "growth", "IconGrowth", [["path", { "d": "M16.5 15a4.5 4.5 0 0 0 -4.5 4.5m4.5 -8.5a4.5 4.5 0 0 0 -4.5 4.5m4.5 -8.5a4.5 4.5 0 0 0 -4.5 4.5m-4 3.5c2.21 0 4 2.015 4 4.5m-4 -8.5c2.21 0 4 2.015 4 4.5m-4 -8.5c2.21 0 4 2.015 4 4.5m0 -7.5v6", "key": "svg-0" }]]);

var IconGrowth$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGrowth
});

var IconGuitarPick = createReactComponent("outline", "guitar-pick", "IconGuitarPick", [["path", { "d": "M16 18.5c2 -2.5 4 -6.5 4 -10.5c0 -2.946 -2.084 -4.157 -4.204 -4.654c-.864 -.23 -2.13 -.346 -3.796 -.346c-1.667 0 -2.932 .115 -3.796 .346c-2.12 .497 -4.204 1.708 -4.204 4.654c0 3.312 2 8 4 10.5c.297 .37 .618 .731 .963 1.081l.354 .347a3.9 3.9 0 0 0 5.364 0a14.05 14.05 0 0 0 1.319 -1.428z", "key": "svg-0" }]]);

var IconGuitarPick$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGuitarPick
});

var IconGymnastics = createReactComponent("outline", "gymnastics", "IconGymnastics", [["path", { "d": "M7 7a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M13 21l1 -9l7 -6", "key": "svg-1" }], ["path", { "d": "M3 11h6l5 1", "key": "svg-2" }], ["path", { "d": "M11.5 8.5l4.5 -3.5", "key": "svg-3" }]]);

var IconGymnastics$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGymnastics
});

var IconH1 = createReactComponent("outline", "h-1", "IconH1", [["path", { "d": "M19 18v-8l-2 2", "key": "svg-0" }], ["path", { "d": "M4 6v12", "key": "svg-1" }], ["path", { "d": "M12 6v12", "key": "svg-2" }], ["path", { "d": "M11 18h2", "key": "svg-3" }], ["path", { "d": "M3 18h2", "key": "svg-4" }], ["path", { "d": "M4 12h8", "key": "svg-5" }], ["path", { "d": "M3 6h2", "key": "svg-6" }], ["path", { "d": "M11 6h2", "key": "svg-7" }]]);

var IconH1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconH1
});

var IconH2 = createReactComponent("outline", "h-2", "IconH2", [["path", { "d": "M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0", "key": "svg-0" }], ["path", { "d": "M4 6v12", "key": "svg-1" }], ["path", { "d": "M12 6v12", "key": "svg-2" }], ["path", { "d": "M11 18h2", "key": "svg-3" }], ["path", { "d": "M3 18h2", "key": "svg-4" }], ["path", { "d": "M4 12h8", "key": "svg-5" }], ["path", { "d": "M3 6h2", "key": "svg-6" }], ["path", { "d": "M11 6h2", "key": "svg-7" }]]);

var IconH2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconH2
});

var IconH3 = createReactComponent("outline", "h-3", "IconH3", [["path", { "d": "M19 14a2 2 0 1 0 -2 -2", "key": "svg-0" }], ["path", { "d": "M17 16a2 2 0 1 0 2 -2", "key": "svg-1" }], ["path", { "d": "M4 6v12", "key": "svg-2" }], ["path", { "d": "M12 6v12", "key": "svg-3" }], ["path", { "d": "M11 18h2", "key": "svg-4" }], ["path", { "d": "M3 18h2", "key": "svg-5" }], ["path", { "d": "M4 12h8", "key": "svg-6" }], ["path", { "d": "M3 6h2", "key": "svg-7" }], ["path", { "d": "M11 6h2", "key": "svg-8" }]]);

var IconH3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconH3
});

var IconH4 = createReactComponent("outline", "h-4", "IconH4", [["path", { "d": "M20 18v-8l-4 6h5", "key": "svg-0" }], ["path", { "d": "M4 6v12", "key": "svg-1" }], ["path", { "d": "M12 6v12", "key": "svg-2" }], ["path", { "d": "M11 18h2", "key": "svg-3" }], ["path", { "d": "M3 18h2", "key": "svg-4" }], ["path", { "d": "M4 12h8", "key": "svg-5" }], ["path", { "d": "M3 6h2", "key": "svg-6" }], ["path", { "d": "M11 6h2", "key": "svg-7" }]]);

var IconH4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconH4
});

var IconH5 = createReactComponent("outline", "h-5", "IconH5", [["path", { "d": "M17 18h2a2 2 0 1 0 0 -4h-2v-4h4", "key": "svg-0" }], ["path", { "d": "M4 6v12", "key": "svg-1" }], ["path", { "d": "M12 6v12", "key": "svg-2" }], ["path", { "d": "M11 18h2", "key": "svg-3" }], ["path", { "d": "M3 18h2", "key": "svg-4" }], ["path", { "d": "M4 12h8", "key": "svg-5" }], ["path", { "d": "M3 6h2", "key": "svg-6" }], ["path", { "d": "M11 6h2", "key": "svg-7" }]]);

var IconH5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconH5
});

var IconH6 = createReactComponent("outline", "h-6", "IconH6", [["path", { "d": "M19 14a2 2 0 1 0 0 4a2 2 0 0 0 0 -4z", "key": "svg-0" }], ["path", { "d": "M21 12a2 2 0 1 0 -4 0v4", "key": "svg-1" }], ["path", { "d": "M4 6v12", "key": "svg-2" }], ["path", { "d": "M12 6v12", "key": "svg-3" }], ["path", { "d": "M11 18h2", "key": "svg-4" }], ["path", { "d": "M3 18h2", "key": "svg-5" }], ["path", { "d": "M4 12h8", "key": "svg-6" }], ["path", { "d": "M3 6h2", "key": "svg-7" }], ["path", { "d": "M11 6h2", "key": "svg-8" }]]);

var IconH6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconH6
});

var IconHammerOff = createReactComponent("outline", "hammer-off", "IconHammerOff", [["path", { "d": "M10.698 10.72l-6.668 6.698a2.091 2.091 0 0 0 0 2.967a2.11 2.11 0 0 0 2.976 0l6.696 -6.676", "key": "svg-0" }], ["path", { "d": "M18.713 14.702l2 -2a1 1 0 0 0 0 -1.414l-7.586 -7.586a1 1 0 0 0 -1.414 0l-2 2", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconHammerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHammerOff
});

var IconHammer = createReactComponent("outline", "hammer", "IconHammer", [["path", { "d": "M11.414 10l-7.383 7.418a2.091 2.091 0 0 0 0 2.967a2.11 2.11 0 0 0 2.976 0l7.407 -7.385", "key": "svg-0" }], ["path", { "d": "M18.121 15.293l2.586 -2.586a1 1 0 0 0 0 -1.414l-7.586 -7.586a1 1 0 0 0 -1.414 0l-2.586 2.586a1 1 0 0 0 0 1.414l7.586 7.586a1 1 0 0 0 1.414 0z", "key": "svg-1" }]]);

var IconHammer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHammer
});

var IconHandClickOff = createReactComponent("outline", "hand-click-off", "IconHandClickOff", [["path", { "d": "M8 13v-5", "key": "svg-0" }], ["path", { "d": "M8.06 4.077a1.5 1.5 0 0 1 2.94 .423v2.5m0 4v1", "key": "svg-1" }], ["path", { "d": "M12.063 8.065a1.5 1.5 0 0 1 1.937 1.435v.5", "key": "svg-2" }], ["path", { "d": "M14.06 10.082a1.5 1.5 0 0 1 2.94 .418v1.5", "key": "svg-3" }], ["path", { "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5m-.88 3.129a6 6 0 0 1 -5.12 2.871h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }], ["path", { "d": "M4 7h-1", "key": "svg-6" }], ["path", { "d": "M14 3l1 -1", "key": "svg-7" }], ["path", { "d": "M15 6h1", "key": "svg-8" }]]);

var IconHandClickOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandClickOff
});

var IconHandClick = createReactComponent("outline", "hand-click", "IconHandClick", [["path", { "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5", "key": "svg-0" }], ["path", { "d": "M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5", "key": "svg-1" }], ["path", { "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-2" }], ["path", { "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-3" }], ["path", { "d": "M5 3l-1 -1", "key": "svg-4" }], ["path", { "d": "M4 7h-1", "key": "svg-5" }], ["path", { "d": "M14 3l1 -1", "key": "svg-6" }], ["path", { "d": "M15 6h1", "key": "svg-7" }]]);

var IconHandClick$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandClick
});

var IconHandFingerDown = createReactComponent("outline", "hand-finger-down", "IconHandFingerDown", [["path", { "d": "M8 12v8.5a1.5 1.5 0 0 0 3 0v-7.5", "key": "svg-0" }], ["path", { "d": "M11 13.5v2a1.5 1.5 0 0 0 3 0v-2.5", "key": "svg-1" }], ["path", { "d": "M14 14.5a1.5 1.5 0 0 0 3 0v-1.5", "key": "svg-2" }], ["path", { "d": "M17 13.5a1.5 1.5 0 0 0 3 0v-4.5a6 6 0 0 0 -6 -6h-2h.208a6 6 0 0 0 -5.012 2.7l-.196 .3q -.468 .718 -3.286 5.728a1.5 1.5 0 0 0 .536 2.022c.734 .44 1.674 .325 2.28 -.28l1.47 -1.47", "key": "svg-3" }]]);

var IconHandFingerDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandFingerDown
});

var IconHandFingerLeft = createReactComponent("outline", "hand-finger-left", "IconHandFingerLeft", [["path", { "d": "M12 8h-8.5a1.5 1.5 0 0 0 0 3h7.5", "key": "svg-0" }], ["path", { "d": "M10.5 11h-2a1.5 1.5 0 1 0 0 3h2.5", "key": "svg-1" }], ["path", { "d": "M9.5 14a1.5 1.5 0 0 0 0 3h1.5", "key": "svg-2" }], ["path", { "d": "M10.5 17a1.5 1.5 0 0 0 0 3h4.5a6 6 0 0 0 6 -6v-2v.208a6 6 0 0 0 -2.7 -5.012l-.3 -.196q -.718 -.468 -5.728 -3.286a1.5 1.5 0 0 0 -2.022 .536a1.87 1.87 0 0 0 .28 2.28l1.47 1.47", "key": "svg-3" }]]);

var IconHandFingerLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandFingerLeft
});

var IconHandFingerOff = createReactComponent("outline", "hand-finger-off", "IconHandFingerOff", [["path", { "d": "M8 13v-5", "key": "svg-0" }], ["path", { "d": "M8.06 4.077a1.5 1.5 0 0 1 2.94 .423v2.5m0 4v1", "key": "svg-1" }], ["path", { "d": "M12.063 8.065a1.5 1.5 0 0 1 1.937 1.435v.5", "key": "svg-2" }], ["path", { "d": "M14.06 10.082a1.5 1.5 0 0 1 2.94 .418v1.5", "key": "svg-3" }], ["path", { "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5m-.88 3.129a6 6 0 0 1 -5.12 2.871h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconHandFingerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandFingerOff
});

var IconHandFingerRight = createReactComponent("outline", "hand-finger-right", "IconHandFingerRight", [["path", { "d": "M12 8h8.5a1.5 1.5 0 0 1 0 3h-7.5", "key": "svg-0" }], ["path", { "d": "M13.5 11h2a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M14.5 14a1.5 1.5 0 0 1 0 3h-1.5", "key": "svg-2" }], ["path", { "d": "M13.5 17a1.5 1.5 0 1 1 0 3h-4.5a6 6 0 0 1 -6 -6v-2v.208a6 6 0 0 1 2.7 -5.012l.3 -.196q .718 -.468 5.728 -3.286a1.5 1.5 0 0 1 2.022 .536c.44 .734 .325 1.674 -.28 2.28l-1.47 1.47", "key": "svg-3" }]]);

var IconHandFingerRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandFingerRight
});

var IconHandFinger = createReactComponent("outline", "hand-finger", "IconHandFinger", [["path", { "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5", "key": "svg-0" }], ["path", { "d": "M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5", "key": "svg-1" }], ["path", { "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-2" }], ["path", { "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-3" }]]);

var IconHandFinger$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandFinger
});

var IconHandGrab = createReactComponent("outline", "hand-grab", "IconHandGrab", [["path", { "d": "M8 11v-3.5a1.5 1.5 0 0 1 3 0v2.5", "key": "svg-0" }], ["path", { "d": "M11 9.5v-3a1.5 1.5 0 0 1 3 0v3.5", "key": "svg-1" }], ["path", { "d": "M14 7.5a1.5 1.5 0 0 1 3 0v2.5", "key": "svg-2" }], ["path", { "d": "M17 9.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-3" }]]);

var IconHandGrab$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandGrab
});

var IconHandLittleFinger = createReactComponent("outline", "hand-little-finger", "IconHandLittleFinger", [["path", { "d": "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-0" }], ["path", { "d": "M11 11.5v-1a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-1" }], ["path", { "d": "M17 12v-5.5a1.5 1.5 0 0 1 3 0v9.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-2" }], ["path", { "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-3" }]]);

var IconHandLittleFinger$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandLittleFinger
});

var IconHandLoveYou = createReactComponent("outline", "hand-love-you", "IconHandLoveYou", [["path", { "d": "M11 11.5v-1a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-0" }], ["path", { "d": "M17 12v-6.5a1.5 1.5 0 0 1 3 0v10.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-1" }], ["path", { "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-2" }], ["path", { "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5", "key": "svg-3" }]]);

var IconHandLoveYou$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandLoveYou
});

var IconHandMiddleFinger = createReactComponent("outline", "hand-middle-finger", "IconHandMiddleFinger", [["path", { "d": "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-0" }], ["path", { "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-1" }], ["path", { "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-2" }], ["path", { "d": "M11 11.5v-8a1.5 1.5 0 1 1 3 0v8.5", "key": "svg-3" }]]);

var IconHandMiddleFinger$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandMiddleFinger
});

var IconHandMove = createReactComponent("outline", "hand-move", "IconHandMove", [["path", { "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5", "key": "svg-0" }], ["path", { "d": "M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5", "key": "svg-1" }], ["path", { "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-2" }], ["path", { "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-3" }], ["path", { "d": "M2.541 5.594a13.487 13.487 0 0 1 2.46 -1.427", "key": "svg-4" }], ["path", { "d": "M14 3.458c1.32 .354 2.558 .902 3.685 1.612", "key": "svg-5" }]]);

var IconHandMove$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandMove
});

var IconHandOff = createReactComponent("outline", "hand-off", "IconHandOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M8 13.5v-5.5m.44 -3.562a1.5 1.5 0 0 1 2.56 1.062v1.5m0 4.008v.992m0 -6.5v-2a1.5 1.5 0 1 1 3 0v6.5m0 -4.5a1.5 1.5 0 0 1 3 0v6.5m0 -4.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2c-2.114 -.292 -3.956 -1.397 -5 -3l-2.7 -5.25a1.7 1.7 0 0 1 2.75 -2l.9 1.75", "key": "svg-1" }]]);

var IconHandOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandOff
});

var IconHandRingFinger = createReactComponent("outline", "hand-ring-finger", "IconHandRingFinger", [["path", { "d": "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-0" }], ["path", { "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-1" }], ["path", { "d": "M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5", "key": "svg-2" }], ["path", { "d": "M14 12v-6.5a1.5 1.5 0 0 1 3 0v6.5", "key": "svg-3" }]]);

var IconHandRingFinger$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandRingFinger
});

var IconHandSanitizer = createReactComponent("outline", "hand-sanitizer", "IconHandSanitizer", [["path", { "d": "M7 21h10v-10a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v10z", "key": "svg-0" }], ["path", { "d": "M15 3h-6a2 2 0 0 0 -2 2", "key": "svg-1" }], ["path", { "d": "M12 3v5", "key": "svg-2" }], ["path", { "d": "M12 11v4", "key": "svg-3" }], ["path", { "d": "M10 13h4", "key": "svg-4" }]]);

var IconHandSanitizer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandSanitizer
});

var IconHandStop = createReactComponent("outline", "hand-stop", "IconHandStop", [["path", { "d": "M8 13v-7.5a1.5 1.5 0 0 1 3 0v6.5", "key": "svg-0" }], ["path", { "d": "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5", "key": "svg-1" }], ["path", { "d": "M14 5.5a1.5 1.5 0 0 1 3 0v6.5", "key": "svg-2" }], ["path", { "d": "M17 7.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-3" }]]);

var IconHandStop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandStop
});

var IconHandThreeFingers = createReactComponent("outline", "hand-three-fingers", "IconHandThreeFingers", [["path", { "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5", "key": "svg-0" }], ["path", { "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-1" }], ["path", { "d": "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5", "key": "svg-2" }], ["path", { "d": "M14 5.5a1.5 1.5 0 0 1 3 0v6.5", "key": "svg-3" }]]);

var IconHandThreeFingers$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandThreeFingers
});

var IconHandTwoFingers = createReactComponent("outline", "hand-two-fingers", "IconHandTwoFingers", [["path", { "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5", "key": "svg-0" }], ["path", { "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-1" }], ["path", { "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-2" }], ["path", { "d": "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5", "key": "svg-3" }]]);

var IconHandTwoFingers$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHandTwoFingers
});

var IconHanger2 = createReactComponent("outline", "hanger-2", "IconHanger2", [["path", { "d": "M12 9l-7.971 4.428a2 2 0 0 0 -1.029 1.749v.823a2 2 0 0 0 2 2h1", "key": "svg-0" }], ["path", { "d": "M18 18h1a2 2 0 0 0 2 -2v-.823a2 2 0 0 0 -1.029 -1.749l-7.971 -4.428c-1.457 -.81 -1.993 -2.333 -2 -4a2 2 0 1 1 4 0", "key": "svg-1" }], ["path", { "d": "M6 16m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconHanger2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHanger2
});

var IconHangerOff = createReactComponent("outline", "hanger-off", "IconHangerOff", [["path", { "d": "M14 6a2 2 0 1 0 -4 0m6.506 6.506l3.461 1.922a2 2 0 0 1 1.029 1.749v.823m-2 2h-14a2 2 0 0 1 -2 -2v-.823a2 2 0 0 1 1.029 -1.749l6.673 -3.707", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconHangerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHangerOff
});

var IconHanger = createReactComponent("outline", "hanger", "IconHanger", [["path", { "d": "M14 6a2 2 0 1 0 -4 0c0 1.667 .67 3 2 4h-.008l7.971 4.428a2 2 0 0 1 1.029 1.749v.823a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-.823a2 2 0 0 1 1.029 -1.749l7.971 -4.428", "key": "svg-0" }]]);

var IconHanger$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHanger
});

var IconHash = createReactComponent("outline", "hash", "IconHash", [["path", { "d": "M5 9l14 0", "key": "svg-0" }], ["path", { "d": "M5 15l14 0", "key": "svg-1" }], ["path", { "d": "M11 4l-4 16", "key": "svg-2" }], ["path", { "d": "M17 4l-4 16", "key": "svg-3" }]]);

var IconHash$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHash
});

var IconHazeMoon = createReactComponent("outline", "haze-moon", "IconHazeMoon", [["path", { "d": "M3 16h18", "key": "svg-0" }], ["path", { "d": "M3 20h18", "key": "svg-1" }], ["path", { "d": "M8.296 16c-2.268 -1.4 -3.598 -4.087 -3.237 -6.916c.443 -3.48 3.308 -6.083 6.698 -6.084v.006h.296c-1.991 1.916 -2.377 5.03 -.918 7.405c1.459 2.374 4.346 3.33 6.865 2.275a6.888 6.888 0 0 1 -2.777 3.314", "key": "svg-2" }]]);

var IconHazeMoon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHazeMoon
});

var IconHaze = createReactComponent("outline", "haze", "IconHaze", [["path", { "d": "M3 12h1", "key": "svg-0" }], ["path", { "d": "M12 3v1", "key": "svg-1" }], ["path", { "d": "M20 12h1", "key": "svg-2" }], ["path", { "d": "M5.6 5.6l.7 .7", "key": "svg-3" }], ["path", { "d": "M18.4 5.6l-.7 .7", "key": "svg-4" }], ["path", { "d": "M8 12a4 4 0 1 1 8 0", "key": "svg-5" }], ["path", { "d": "M3 16h18", "key": "svg-6" }], ["path", { "d": "M3 20h18", "key": "svg-7" }]]);

var IconHaze$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHaze
});

var IconHdr = createReactComponent("outline", "hdr", "IconHdr", [["path", { "d": "M3 16v-8", "key": "svg-0" }], ["path", { "d": "M7 8v8", "key": "svg-1" }], ["path", { "d": "M3 12h4", "key": "svg-2" }], ["path", { "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", "key": "svg-3" }], ["path", { "d": "M17 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4", "key": "svg-4" }]]);

var IconHdr$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHdr
});

var IconHeadingOff = createReactComponent("outline", "heading-off", "IconHeadingOff", [["path", { "d": "M7 12h5m4 0h1", "key": "svg-0" }], ["path", { "d": "M7 7v12", "key": "svg-1" }], ["path", { "d": "M17 5v8m0 4v2", "key": "svg-2" }], ["path", { "d": "M15 19h4", "key": "svg-3" }], ["path", { "d": "M15 5h4", "key": "svg-4" }], ["path", { "d": "M5 19h4", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconHeadingOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeadingOff
});

var IconHeading = createReactComponent("outline", "heading", "IconHeading", [["path", { "d": "M7 12h10", "key": "svg-0" }], ["path", { "d": "M7 5v14", "key": "svg-1" }], ["path", { "d": "M17 5v14", "key": "svg-2" }], ["path", { "d": "M15 19h4", "key": "svg-3" }], ["path", { "d": "M15 5h4", "key": "svg-4" }], ["path", { "d": "M5 19h4", "key": "svg-5" }], ["path", { "d": "M5 5h4", "key": "svg-6" }]]);

var IconHeading$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeading
});

var IconHeadphonesOff = createReactComponent("outline", "headphones-off", "IconHeadphonesOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M4 13m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M17 13h1a2 2 0 0 1 2 2v1m-.589 3.417c-.361 .36 -.86 .583 -1.411 .583h-1a2 2 0 0 1 -2 -2v-3", "key": "svg-2" }], ["path", { "d": "M4 15v-3c0 -2.21 .896 -4.21 2.344 -5.658m2.369 -1.638a8 8 0 0 1 11.287 7.296v3", "key": "svg-3" }]]);

var IconHeadphonesOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeadphonesOff
});

var IconHeadphones = createReactComponent("outline", "headphones", "IconHeadphones", [["path", { "d": "M4 13m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M15 13m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M4 15v-3a8 8 0 0 1 16 0v3", "key": "svg-2" }]]);

var IconHeadphones$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeadphones
});

var IconHeadsetOff = createReactComponent("outline", "headset-off", "IconHeadsetOff", [["path", { "d": "M4 14v-3c0 -1.953 .7 -3.742 1.862 -5.13m2.182 -1.825a8 8 0 0 1 11.956 6.955v3", "key": "svg-0" }], ["path", { "d": "M18 19c0 1.657 -2.686 3 -6 3", "key": "svg-1" }], ["path", { "d": "M4 14a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2v-3z", "key": "svg-2" }], ["path", { "d": "M16.169 12.18c.253 -.115 .534 -.18 .831 -.18h1a2 2 0 0 1 2 2v2m-1.183 2.826c-.25 .112 -.526 .174 -.817 .174h-1a2 2 0 0 1 -2 -2v-2", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconHeadsetOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeadsetOff
});

var IconHeadset = createReactComponent("outline", "headset", "IconHeadset", [["path", { "d": "M4 14v-3a8 8 0 1 1 16 0v3", "key": "svg-0" }], ["path", { "d": "M18 19c0 1.657 -2.686 3 -6 3", "key": "svg-1" }], ["path", { "d": "M4 14a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2v-3z", "key": "svg-2" }], ["path", { "d": "M15 14a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2v-3z", "key": "svg-3" }]]);

var IconHeadset$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeadset
});

var IconHealthRecognition = createReactComponent("outline", "health-recognition", "IconHealthRecognition", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M8.603 9.61a2.04 2.04 0 0 1 2.912 0l.485 .39l.5 -.396a2.035 2.035 0 0 1 2.897 .007a2.104 2.104 0 0 1 0 2.949l-3.397 3.44l-3.397 -3.44a2.104 2.104 0 0 1 0 -2.95z", "key": "svg-4" }]]);

var IconHealthRecognition$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHealthRecognition
});

var IconHeartBitcoin = createReactComponent("outline", "heart-bitcoin", "IconHeartBitcoin", [["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-0" }], ["path", { "d": "M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.785 4.444", "key": "svg-1" }]]);

var IconHeartBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartBitcoin
});

var IconHeartBolt = createReactComponent("outline", "heart-bolt", "IconHeartBolt", [["path", { "d": "M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.003 5.997", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }]]);

var IconHeartBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartBolt
});

var IconHeartBroken = createReactComponent("outline", "heart-broken", "IconHeartBroken", [["path", { "d": "M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572", "key": "svg-0" }], ["path", { "d": "M12 6l-2 4l4 3l-2 4v3", "key": "svg-1" }]]);

var IconHeartBroken$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartBroken
});

var IconHeartCancel = createReactComponent("outline", "heart-cancel", "IconHeartCancel", [["path", { "d": "M12 20l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 7.993 6.01", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }]]);

var IconHeartCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartCancel
});

var IconHeartCheck = createReactComponent("outline", "heart-check", "IconHeartCheck", [["path", { "d": "M19.5 12.572l-3 2.928m-5.5 3.5a8916.99 8916.99 0 0 0 -6.5 -6.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }]]);

var IconHeartCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartCheck
});

var IconHeartCode = createReactComponent("outline", "heart-code", "IconHeartCode", [["path", { "d": "M19.5 12.572l-.536 .53m-7.91 5.96l-6.554 -6.489a5 5 0 1 1 7.5 -6.567a5 5 0 1 1 7.5 6.572", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }]]);

var IconHeartCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartCode
});

var IconHeartCog = createReactComponent("outline", "heart-cog", "IconHeartCog", [["path", { "d": "M12 20l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.21 5.697", "key": "svg-0" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-2" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-3" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-7" }]]);

var IconHeartCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartCog
});

var IconHeartDiscount = createReactComponent("outline", "heart-discount", "IconHeartDiscount", [["path", { "d": "M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572", "key": "svg-0" }], ["path", { "d": "M16 21l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21v.01", "key": "svg-2" }], ["path", { "d": "M16 16v.01", "key": "svg-3" }]]);

var IconHeartDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartDiscount
});

var IconHeartDollar = createReactComponent("outline", "heart-dollar", "IconHeartDollar", [["path", { "d": "M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.785 4.444", "key": "svg-0" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-2" }]]);

var IconHeartDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartDollar
});

var IconHeartDown = createReactComponent("outline", "heart-down", "IconHeartDown", [["path", { "d": "M12 20l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.907 6.12", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }]]);

var IconHeartDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartDown
});

var IconHeartExclamation = createReactComponent("outline", "heart-exclamation", "IconHeartExclamation", [["path", { "d": "M15.03 17l-3.03 3l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.922 6.102", "key": "svg-0" }], ["path", { "d": "M19 16v3", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }]]);

var IconHeartExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartExclamation
});

var IconHeartHandshake = createReactComponent("outline", "heart-handshake", "IconHeartHandshake", [["path", { "d": "M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572", "key": "svg-0" }], ["path", { "d": "M12 6l-3.293 3.293a1 1 0 0 0 0 1.414l.543 .543c.69 .69 1.81 .69 2.5 0l1 -1a3.182 3.182 0 0 1 4.5 0l2.25 2.25", "key": "svg-1" }], ["path", { "d": "M12.5 15.5l2 2", "key": "svg-2" }], ["path", { "d": "M15 13l2 2", "key": "svg-3" }]]);

var IconHeartHandshake$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartHandshake
});

var IconHeartMinus = createReactComponent("outline", "heart-minus", "IconHeartMinus", [["path", { "d": "M19.5 12.572l-2.494 2.47m-5.006 4.958l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconHeartMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartMinus
});

var IconHeartOff = createReactComponent("outline", "heart-off", "IconHeartOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M19.5 12.572l-1.5 1.428m-2 2l-4 4l-7.5 -7.428a5 5 0 0 1 -1.288 -5.068a4.976 4.976 0 0 1 1.788 -2.504m3 -1c1.56 0 3.05 .727 4 2a5 5 0 1 1 7.5 6.572", "key": "svg-1" }]]);

var IconHeartOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartOff
});

var IconHeartPause = createReactComponent("outline", "heart-pause", "IconHeartPause", [["path", { "d": "M19.5 12.572l-.784 .777m-5.725 5.67l-.991 .981l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }]]);

var IconHeartPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartPause
});

var IconHeartPin = createReactComponent("outline", "heart-pin", "IconHeartPin", [["path", { "d": "M12 20l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.5 5.179", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }]]);

var IconHeartPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartPin
});

var IconHeartPlus = createReactComponent("outline", "heart-plus", "IconHeartPlus", [["path", { "d": "M12 20l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.96 6.053", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconHeartPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartPlus
});

var IconHeartQuestion = createReactComponent("outline", "heart-question", "IconHeartQuestion", [["path", { "d": "M14.105 17.915l-2.105 2.085l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.524 5.127", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconHeartQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartQuestion
});

var IconHeartRateMonitor = createReactComponent("outline", "heart-rate-monitor", "IconHeartRateMonitor", [["path", { "d": "M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M7 20h10", "key": "svg-1" }], ["path", { "d": "M9 16v4", "key": "svg-2" }], ["path", { "d": "M15 16v4", "key": "svg-3" }], ["path", { "d": "M7 10h2l2 3l2 -6l1 3h3", "key": "svg-4" }]]);

var IconHeartRateMonitor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartRateMonitor
});

var IconHeartSearch = createReactComponent("outline", "heart-search", "IconHeartSearch", [["path", { "d": "M12 20l-.975 -.966l-6.525 -6.462a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.37 5.428", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }]]);

var IconHeartSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartSearch
});

var IconHeartShare = createReactComponent("outline", "heart-share", "IconHeartShare", [["path", { "d": "M19.5 12.572l-.468 .464m-6.077 6.019l-.955 .945l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572", "key": "svg-0" }], ["path", { "d": "M16 22l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-2" }]]);

var IconHeartShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartShare
});

var IconHeartSpark = createReactComponent("outline", "heart-spark", "IconHeartSpark", [["path", { "d": "M11.537 19.542l-7.037 -6.97a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.212 5.693", "key": "svg-0" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-1" }]]);

var IconHeartSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartSpark
});

var IconHeartStar = createReactComponent("outline", "heart-star", "IconHeartStar", [["path", { "d": "M9.73 17.753l-5.23 -5.181a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.563 5.041", "key": "svg-0" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }]]);

var IconHeartStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartStar
});

var IconHeartUp = createReactComponent("outline", "heart-up", "IconHeartUp", [["path", { "d": "M12 20l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.893 6.139", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }]]);

var IconHeartUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartUp
});

var IconHeartX = createReactComponent("outline", "heart-x", "IconHeartX", [["path", { "d": "M19.5 12.572l-.5 .428m-6 6l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }]]);

var IconHeartX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartX
});

var IconHeart = createReactComponent("outline", "heart", "IconHeart", [["path", { "d": "M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572", "key": "svg-0" }]]);

var IconHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeart
});

var IconHeartbeat = createReactComponent("outline", "heartbeat", "IconHeartbeat", [["path", { "d": "M19.5 13.572l-7.5 7.428l-2.896 -2.868m-6.117 -8.104a5 5 0 0 1 9.013 -3.022a5 5 0 1 1 7.5 6.572", "key": "svg-0" }], ["path", { "d": "M3 13h2l2 3l2 -6l1 3h3", "key": "svg-1" }]]);

var IconHeartbeat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartbeat
});

var IconHeartsOff = createReactComponent("outline", "hearts-off", "IconHeartsOff", [["path", { "d": "M14.017 18l-2.017 2l-7.5 -7.428a5 5 0 0 1 .49 -7.586m3.01 -1a5 5 0 0 1 4 2.018a5 5 0 0 1 8.153 5.784", "key": "svg-0" }], ["path", { "d": "M11.814 11.814a2.81 2.81 0 0 0 -.007 3.948l4.182 4.238l2.01 -2.021m1.977 -1.99l.211 -.212a2.81 2.81 0 0 0 0 -3.948a2.747 2.747 0 0 0 -3.91 -.007l-.283 .178", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconHeartsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartsOff
});

var IconHearts = createReactComponent("outline", "hearts", "IconHearts", [["path", { "d": "M14.017 18l-2.017 2l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.153 5.784", "key": "svg-0" }], ["path", { "d": "M15.99 20l4.197 -4.223a2.81 2.81 0 0 0 0 -3.948a2.747 2.747 0 0 0 -3.91 -.007l-.28 .282l-.279 -.283a2.747 2.747 0 0 0 -3.91 -.007a2.81 2.81 0 0 0 -.007 3.948l4.182 4.238z", "key": "svg-1" }]]);

var IconHearts$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHearts
});

var IconHelicopterLanding = createReactComponent("outline", "helicopter-landing", "IconHelicopterLanding", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 8l0 8", "key": "svg-1" }], ["path", { "d": "M9 12l6 0", "key": "svg-2" }], ["path", { "d": "M15 8l0 8", "key": "svg-3" }]]);

var IconHelicopterLanding$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelicopterLanding
});

var IconHelicopter = createReactComponent("outline", "helicopter", "IconHelicopter", [["path", { "d": "M3 10l1 2h6", "key": "svg-0" }], ["path", { "d": "M12 9a2 2 0 0 0 -2 2v3c0 1.1 .9 2 2 2h7a2 2 0 0 0 2 -2c0 -3.31 -3.13 -5 -7 -5h-2z", "key": "svg-1" }], ["path", { "d": "M13 9l0 -3", "key": "svg-2" }], ["path", { "d": "M5 6l15 0", "key": "svg-3" }], ["path", { "d": "M15 9.1v3.9h5.5", "key": "svg-4" }], ["path", { "d": "M15 19l0 -3", "key": "svg-5" }], ["path", { "d": "M19 19l-8 0", "key": "svg-6" }]]);

var IconHelicopter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelicopter
});

var IconHelmetOff = createReactComponent("outline", "helmet-off", "IconHelmetOff", [["path", { "d": "M8.633 4.654a9 9 0 0 1 11.718 11.7m-1.503 2.486a9.008 9.008 0 0 1 -1.192 1.16h-11.312a9 9 0 0 1 -.185 -13.847", "key": "svg-0" }], ["path", { "d": "M20 9h-7m-2.768 1.246c.507 2 1.596 3.418 3.268 4.254c.524 .262 1.07 .49 1.64 .683", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconHelmetOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelmetOff
});

var IconHelmet = createReactComponent("outline", "helmet", "IconHelmet", [["path", { "d": "M12 4a9 9 0 0 1 5.656 16h-11.312a9 9 0 0 1 5.656 -16z", "key": "svg-0" }], ["path", { "d": "M20 9h-8.8a1 1 0 0 0 -.968 1.246c.507 2 1.596 3.418 3.268 4.254c2 1 4.333 1.5 7 1.5", "key": "svg-1" }]]);

var IconHelmet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelmet
});

var IconHelpCircle = createReactComponent("outline", "help-circle", "IconHelpCircle", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 16v.01", "key": "svg-1" }], ["path", { "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconHelpCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpCircle
});

var IconHelpHexagon = createReactComponent("outline", "help-hexagon", "IconHelpHexagon", [["path", { "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M12 16v.01", "key": "svg-1" }], ["path", { "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconHelpHexagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpHexagon
});

var IconHelpOctagon = createReactComponent("outline", "help-octagon", "IconHelpOctagon", [["path", { "d": "M12.802 2.165l5.575 2.389c.48 .206 .863 .589 1.07 1.07l2.388 5.574c.22 .512 .22 1.092 0 1.604l-2.389 5.575c-.206 .48 -.589 .863 -1.07 1.07l-5.574 2.388c-.512 .22 -1.092 .22 -1.604 0l-5.575 -2.389a2.036 2.036 0 0 1 -1.07 -1.07l-2.388 -5.574a2.036 2.036 0 0 1 0 -1.604l2.389 -5.575c.206 -.48 .589 -.863 1.07 -1.07l5.574 -2.388a2.036 2.036 0 0 1 1.604 0z", "key": "svg-0" }], ["path", { "d": "M12 16v.01", "key": "svg-1" }], ["path", { "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconHelpOctagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpOctagon
});

var IconHelpOff = createReactComponent("outline", "help-off", "IconHelpOff", [["path", { "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098", "key": "svg-0" }], ["path", { "d": "M12 17v.01", "key": "svg-1" }], ["path", { "d": "M12 13.5a1.5 1.5 0 0 1 .394 -1.1m2.106 -1.9a2.6 2.6 0 0 0 -3.347 -3.361", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconHelpOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpOff
});

var IconHelpSmall = createReactComponent("outline", "help-small", "IconHelpSmall", [["path", { "d": "M12 16v.01", "key": "svg-0" }], ["path", { "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-1" }]]);

var IconHelpSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpSmall
});

var IconHelpSquareRounded = createReactComponent("outline", "help-square-rounded", "IconHelpSquareRounded", [["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-0" }], ["path", { "d": "M12 16v.01", "key": "svg-1" }], ["path", { "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconHelpSquareRounded$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpSquareRounded
});

var IconHelpSquare = createReactComponent("outline", "help-square", "IconHelpSquare", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M12 16v.01", "key": "svg-1" }], ["path", { "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconHelpSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpSquare
});

var IconHelpTriangle = createReactComponent("outline", "help-triangle", "IconHelpTriangle", [["path", { "d": "M12 16v.01", "key": "svg-0" }], ["path", { "d": "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z", "key": "svg-1" }], ["path", { "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconHelpTriangle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpTriangle
});

var IconHelp = createReactComponent("outline", "help", "IconHelp", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 17l0 .01", "key": "svg-1" }], ["path", { "d": "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4", "key": "svg-2" }]]);

var IconHelp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelp
});

var IconHemisphereOff = createReactComponent("outline", "hemisphere-off", "IconHemisphereOff", [["path", { "d": "M6.588 6.603c-2.178 .547 -3.588 1.417 -3.588 2.397c0 1.657 4.03 3 9 3m3.72 -.267c3.114 -.473 5.28 -1.518 5.28 -2.733c0 -1.657 -4.03 -3 -9 -3c-.662 0 -1.308 .024 -1.93 .07", "key": "svg-0" }], ["path", { "d": "M3 9a9 9 0 0 0 13.677 7.69m2.165 -1.843a8.965 8.965 0 0 0 2.158 -5.847", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconHemisphereOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHemisphereOff
});

var IconHemispherePlus = createReactComponent("outline", "hemisphere-plus", "IconHemispherePlus", [["path", { "d": "M12 9m-9 0a9 3 0 1 0 18 0a9 3 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M3 9a9 9 0 0 0 9 9m8.396 -5.752a8.978 8.978 0 0 0 .604 -3.248", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconHemispherePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHemispherePlus
});

var IconHemisphere = createReactComponent("outline", "hemisphere", "IconHemisphere", [["path", { "d": "M12 9m-9 0a9 3 0 1 0 18 0a9 3 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M3 9a9 9 0 0 0 18 0", "key": "svg-1" }]]);

var IconHemisphere$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHemisphere
});

var IconHexagon3d = createReactComponent("outline", "hexagon-3d", "IconHexagon3d", [["path", { "d": "M19 6.844a2.007 2.007 0 0 1 1 1.752v6.555c0 .728 -.394 1.399 -1.03 1.753l-6 3.844a2 2 0 0 1 -1.942 0l-6 -3.844a2.007 2.007 0 0 1 -1.029 -1.752v-6.556c0 -.729 .394 -1.4 1.029 -1.753l6 -3.583a2.05 2.05 0 0 1 2 0l6 3.584h-.03z", "key": "svg-0" }], ["path", { "d": "M12 16.5v4.5", "key": "svg-1" }], ["path", { "d": "M4.5 7.5l3.5 2.5", "key": "svg-2" }], ["path", { "d": "M16 10l4 -2.5", "key": "svg-3" }], ["path", { "d": "M12 7.5v4.5l-4 2", "key": "svg-4" }], ["path", { "d": "M12 12l4 2", "key": "svg-5" }], ["path", { "d": "M12 16.5l4 -2.5v-4l-4 -2.5l-4 2.5v4z", "key": "svg-6" }]]);

var IconHexagon3d$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagon3d
});

var IconHexagonLetterA = createReactComponent("outline", "hexagon-letter-a", "IconHexagonLetterA", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 16v-6a2 2 0 1 1 4 0v6", "key": "svg-1" }], ["path", { "d": "M10 13h4", "key": "svg-2" }]]);

var IconHexagonLetterA$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterA
});

var IconHexagonLetterB = createReactComponent("outline", "hexagon-letter-b", "IconHexagonLetterB", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z", "key": "svg-1" }]]);

var IconHexagonLetterB$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterB
});

var IconHexagonLetterC = createReactComponent("outline", "hexagon-letter-c", "IconHexagonLetterC", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-1" }]]);

var IconHexagonLetterC$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterC
});

var IconHexagonLetterD = createReactComponent("outline", "hexagon-letter-d", "IconHexagonLetterD", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", "key": "svg-1" }]]);

var IconHexagonLetterD$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterD
});

var IconHexagonLetterE = createReactComponent("outline", "hexagon-letter-e", "IconHexagonLetterE", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8h4", "key": "svg-1" }], ["path", { "d": "M10 12h2.5", "key": "svg-2" }]]);

var IconHexagonLetterE$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterE
});

var IconHexagonLetterF = createReactComponent("outline", "hexagon-letter-f", "IconHexagonLetterF", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 12h3", "key": "svg-1" }], ["path", { "d": "M14 8h-4v8", "key": "svg-2" }]]);

var IconHexagonLetterF$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterF
});

var IconHexagonLetterG = createReactComponent("outline", "hexagon-letter-g", "IconHexagonLetterG", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-1" }]]);

var IconHexagonLetterG$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterG
});

var IconHexagonLetterH = createReactComponent("outline", "hexagon-letter-h", "IconHexagonLetterH", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 16v-8m4 0v8", "key": "svg-1" }], ["path", { "d": "M10 12h4", "key": "svg-2" }]]);

var IconHexagonLetterH$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterH
});

var IconHexagonLetterI = createReactComponent("outline", "hexagon-letter-i", "IconHexagonLetterI", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }]]);

var IconHexagonLetterI$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterI
});

var IconHexagonLetterJ = createReactComponent("outline", "hexagon-letter-j", "IconHexagonLetterJ", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 8h4v6a2 2 0 1 1 -4 0", "key": "svg-1" }]]);

var IconHexagonLetterJ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterJ
});

var IconHexagonLetterK = createReactComponent("outline", "hexagon-letter-k", "IconHexagonLetterK", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 8v8", "key": "svg-1" }], ["path", { "d": "M14 8l-2.5 4l2.5 4", "key": "svg-2" }], ["path", { "d": "M10 12h1.5", "key": "svg-3" }]]);

var IconHexagonLetterK$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterK
});

var IconHexagonLetterL = createReactComponent("outline", "hexagon-letter-l", "IconHexagonLetterL", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 8v8h4", "key": "svg-1" }]]);

var IconHexagonLetterL$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterL
});

var IconHexagonLetterM = createReactComponent("outline", "hexagon-letter-m", "IconHexagonLetterM", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M9 16v-8l3 5l3 -5v8", "key": "svg-1" }]]);

var IconHexagonLetterM$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterM
});

var IconHexagonLetterN = createReactComponent("outline", "hexagon-letter-n", "IconHexagonLetterN", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 16v-8l4 8v-8", "key": "svg-1" }]]);

var IconHexagonLetterN$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterN
});

var IconHexagonLetterO = createReactComponent("outline", "hexagon-letter-o", "IconHexagonLetterO", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-1" }]]);

var IconHexagonLetterO$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterO
});

var IconHexagonLetterP = createReactComponent("outline", "hexagon-letter-p", "IconHexagonLetterP", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-1" }]]);

var IconHexagonLetterP$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterP
});

var IconHexagonLetterQ = createReactComponent("outline", "hexagon-letter-q", "IconHexagonLetterQ", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-1" }], ["path", { "d": "M13 15l1 1", "key": "svg-2" }]]);

var IconHexagonLetterQ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterQ
});

var IconHexagonLetterR = createReactComponent("outline", "hexagon-letter-r", "IconHexagonLetterR", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4", "key": "svg-1" }]]);

var IconHexagonLetterR$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterR
});

var IconHexagonLetterS = createReactComponent("outline", "hexagon-letter-s", "IconHexagonLetterS", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1", "key": "svg-1" }]]);

var IconHexagonLetterS$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterS
});

var IconHexagonLetterT = createReactComponent("outline", "hexagon-letter-t", "IconHexagonLetterT", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 8h4", "key": "svg-1" }], ["path", { "d": "M12 8v8", "key": "svg-2" }]]);

var IconHexagonLetterT$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterT
});

var IconHexagonLetterU = createReactComponent("outline", "hexagon-letter-u", "IconHexagonLetterU", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 8v6a2 2 0 1 0 4 0v-6", "key": "svg-1" }]]);

var IconHexagonLetterU$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterU
});

var IconHexagonLetterV = createReactComponent("outline", "hexagon-letter-v", "IconHexagonLetterV", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 8l2 8l2 -8", "key": "svg-1" }]]);

var IconHexagonLetterV$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterV
});

var IconHexagonLetterW = createReactComponent("outline", "hexagon-letter-w", "IconHexagonLetterW", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M9 8l1 8l2 -5l2 5l1 -8", "key": "svg-1" }]]);

var IconHexagonLetterW$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterW
});

var IconHexagonLetterX = createReactComponent("outline", "hexagon-letter-x", "IconHexagonLetterX", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 8l4 8", "key": "svg-1" }], ["path", { "d": "M10 16l4 -8", "key": "svg-2" }]]);

var IconHexagonLetterX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterX
});

var IconHexagonLetterY = createReactComponent("outline", "hexagon-letter-y", "IconHexagonLetterY", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 8l2 5l2 -5", "key": "svg-1" }], ["path", { "d": "M12 16v-3", "key": "svg-2" }]]);

var IconHexagonLetterY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterY
});

var IconHexagonLetterZ = createReactComponent("outline", "hexagon-letter-z", "IconHexagonLetterZ", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 8h4l-4 8h4", "key": "svg-1" }]]);

var IconHexagonLetterZ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterZ
});

var IconHexagonMinus2 = createReactComponent("outline", "hexagon-minus-2", "IconHexagonMinus2", [["path", { "d": "M13.092 21.72a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033c.7 .398 1.13 1.143 1.125 1.948v6.782", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconHexagonMinus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonMinus2
});

var IconHexagonMinus = createReactComponent("outline", "hexagon-minus", "IconHexagonMinus", [["path", { "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M9 12h6", "key": "svg-1" }]]);

var IconHexagonMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonMinus
});

var IconHexagonNumber0 = createReactComponent("outline", "hexagon-number-0", "IconHexagonNumber0", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", "key": "svg-1" }]]);

var IconHexagonNumber0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber0
});

var IconHexagonNumber1 = createReactComponent("outline", "hexagon-number-1", "IconHexagonNumber1", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 10l2 -2v8", "key": "svg-1" }]]);

var IconHexagonNumber1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber1
});

var IconHexagonNumber2 = createReactComponent("outline", "hexagon-number-2", "IconHexagonNumber2", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconHexagonNumber2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber2
});

var IconHexagonNumber3 = createReactComponent("outline", "hexagon-number-3", "IconHexagonNumber3", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1", "key": "svg-1" }]]);

var IconHexagonNumber3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber3
});

var IconHexagonNumber4 = createReactComponent("outline", "hexagon-number-4", "IconHexagonNumber4", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M14 8v8", "key": "svg-2" }]]);

var IconHexagonNumber4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber4
});

var IconHexagonNumber5 = createReactComponent("outline", "hexagon-number-5", "IconHexagonNumber5", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconHexagonNumber5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber5
});

var IconHexagonNumber6 = createReactComponent("outline", "hexagon-number-6", "IconHexagonNumber6", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconHexagonNumber6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber6
});

var IconHexagonNumber7 = createReactComponent("outline", "hexagon-number-7", "IconHexagonNumber7", [["path", { "d": "M19.02 6.858a2 2 0 0 1 1 1.752v6.555c0 .728 -.395 1.4 -1.032 1.753l-6.017 3.844a2 2 0 0 1 -1.948 0l-6.016 -3.844a2 2 0 0 1 -1.032 -1.752v-6.556c0 -.728 .395 -1.4 1.032 -1.753l6.017 -3.582a2.062 2.062 0 0 1 2 0l6.017 3.583h-.029z", "key": "svg-0" }], ["path", { "d": "M10 8h4l-2 8", "key": "svg-1" }]]);

var IconHexagonNumber7$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber7
});

var IconHexagonNumber8 = createReactComponent("outline", "hexagon-number-8", "IconHexagonNumber8", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconHexagonNumber8$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber8
});

var IconHexagonNumber9 = createReactComponent("outline", "hexagon-number-9", "IconHexagonNumber9", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconHexagonNumber9$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber9
});

var IconHexagonOff = createReactComponent("outline", "hexagon-off", "IconHexagonOff", [["path", { "d": "M8.693 4.69l2.336 -1.39a2.056 2.056 0 0 1 2 0l6 3.573h-.029a2 2 0 0 1 1 1.747v6.536c0 .246 -.045 .485 -.13 .707m-2.16 1.847l-4.739 3.027a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l1.154 -.687", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconHexagonOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonOff
});

var IconHexagonPlus2 = createReactComponent("outline", "hexagon-plus-2", "IconHexagonPlus2", [["path", { "d": "M13.092 21.72a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033c.7 .398 1.13 1.143 1.125 1.948v4.282", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconHexagonPlus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonPlus2
});

var IconHexagonPlus = createReactComponent("outline", "hexagon-plus", "IconHexagonPlus", [["path", { "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M9 12h6", "key": "svg-1" }], ["path", { "d": "M12 9v6", "key": "svg-2" }]]);

var IconHexagonPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonPlus
});

var IconHexagon = createReactComponent("outline", "hexagon", "IconHexagon", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }]]);

var IconHexagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagon
});

var IconHexagonalPrismOff = createReactComponent("outline", "hexagonal-prism-off", "IconHexagonalPrismOff", [["path", { "d": "M20.792 6.996l-3.775 2.643a2.005 2.005 0 0 1 -1.147 .361h-1.87m-4 0h-1.87c-.41 0 -.81 -.126 -1.146 -.362l-3.774 -2.641", "key": "svg-0" }], ["path", { "d": "M8 10v11", "key": "svg-1" }], ["path", { "d": "M16 10v2m0 4v5", "key": "svg-2" }], ["path", { "d": "M20.972 16.968a2.01 2.01 0 0 0 .028 -.337v-9.262c0 -.655 -.318 -1.268 -.853 -1.643l-3.367 -2.363a2 2 0 0 0 -1.147 -.363h-7.266a1.99 1.99 0 0 0 -1.066 .309m-2.345 1.643l-1.103 .774a2.006 2.006 0 0 0 -.853 1.644v9.261c0 .655 .318 1.269 .853 1.644l3.367 2.363a2 2 0 0 0 1.147 .362h7.265c.41 0 .811 -.126 1.147 -.363l2.26 -1.587", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconHexagonalPrismOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonalPrismOff
});

var IconHexagonalPrismPlus = createReactComponent("outline", "hexagonal-prism-plus", "IconHexagonalPrismPlus", [["path", { "d": "M20.792 6.996l-3.775 2.643a2.005 2.005 0 0 1 -1.147 .361h-7.74c-.41 0 -.81 -.126 -1.146 -.362l-3.774 -2.641", "key": "svg-0" }], ["path", { "d": "M8 10v11", "key": "svg-1" }], ["path", { "d": "M16 10v3.5", "key": "svg-2" }], ["path", { "d": "M21 12.5v-5.131c0 -.655 -.318 -1.268 -.853 -1.643l-3.367 -2.363a2 2 0 0 0 -1.147 -.363h-7.266c-.41 0 -.811 .126 -1.147 .363l-3.367 2.363a2.006 2.006 0 0 0 -.853 1.644v9.261c0 .655 .318 1.269 .853 1.644l3.367 2.363a2 2 0 0 0 1.147 .362h4.133", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16v6", "key": "svg-5" }]]);

var IconHexagonalPrismPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonalPrismPlus
});

var IconHexagonalPrism = createReactComponent("outline", "hexagonal-prism", "IconHexagonalPrism", [["path", { "d": "M20.792 6.996l-3.775 2.643a2.005 2.005 0 0 1 -1.147 .361h-7.74c-.41 0 -.81 -.126 -1.146 -.362l-3.774 -2.641", "key": "svg-0" }], ["path", { "d": "M8 10v11", "key": "svg-1" }], ["path", { "d": "M16 10v11", "key": "svg-2" }], ["path", { "d": "M3.853 18.274l3.367 2.363a2 2 0 0 0 1.147 .363h7.265c.41 0 .811 -.126 1.147 -.363l3.367 -2.363c.536 -.375 .854 -.99 .854 -1.643v-9.262c0 -.655 -.318 -1.268 -.853 -1.643l-3.367 -2.363a2 2 0 0 0 -1.147 -.363h-7.266c-.41 0 -.811 .126 -1.147 .363l-3.367 2.363a2.006 2.006 0 0 0 -.853 1.644v9.261c0 .655 .318 1.269 .853 1.644z", "key": "svg-3" }]]);

var IconHexagonalPrism$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonalPrism
});

var IconHexagonalPyramidOff = createReactComponent("outline", "hexagonal-pyramid-off", "IconHexagonalPyramidOff", [["path", { "d": "M7.877 7.88l-4.56 7.53a1.988 1.988 0 0 0 .266 2.484l2.527 2.523c.374 .373 .88 .583 1.408 .583h8.964c.528 0 1.034 -.21 1.408 -.583l1.264 -1.263m1.792 -2.205a1.986 1.986 0 0 0 -.262 -1.538l-7.846 -12.954a.996 .996 0 0 0 -1.676 0l-1.772 2.926", "key": "svg-0" }], ["path", { "d": "M12 2l-1.254 4.742m-.841 3.177l-2.905 10.981", "key": "svg-1" }], ["path", { "d": "M12 2l2.153 8.14m1.444 5.457l1.403 5.303", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconHexagonalPyramidOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonalPyramidOff
});

var IconHexagonalPyramidPlus = createReactComponent("outline", "hexagonal-pyramid-plus", "IconHexagonalPyramidPlus", [["path", { "d": "M18.642 12.04l-5.804 -9.583a.996 .996 0 0 0 -1.676 0l-7.846 12.954a1.988 1.988 0 0 0 .267 2.483l2.527 2.523c.374 .373 .88 .583 1.408 .583h4.982", "key": "svg-0" }], ["path", { "d": "M12 2l-5 18.9", "key": "svg-1" }], ["path", { "d": "M12 2l3.304 12.489", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconHexagonalPyramidPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonalPyramidPlus
});

var IconHexagonalPyramid = createReactComponent("outline", "hexagonal-pyramid", "IconHexagonalPyramid", [["path", { "d": "M11.162 2.457l-7.846 12.954a1.988 1.988 0 0 0 .267 2.483l2.527 2.523c.374 .373 .88 .583 1.408 .583h8.964c.528 0 1.034 -.21 1.408 -.583l2.527 -2.523a1.988 1.988 0 0 0 .267 -2.483l-7.846 -12.954a.996 .996 0 0 0 -1.676 0z", "key": "svg-0" }], ["path", { "d": "M12 2l-5 18.9", "key": "svg-1" }], ["path", { "d": "M12 2l5 18.9", "key": "svg-2" }]]);

var IconHexagonalPyramid$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonalPyramid
});

var IconHexagonsOff = createReactComponent("outline", "hexagons-off", "IconHexagonsOff", [["path", { "d": "M4 18v-5l4 -2l4 2v5l-4 2z", "key": "svg-0" }], ["path", { "d": "M8 11v-3m1.332 -2.666l2.668 -1.334l4 2v5", "key": "svg-1" }], ["path", { "d": "M12 13l.661 -.331", "key": "svg-2" }], ["path", { "d": "M15.345 11.328l.655 -.328l4 2v3m-1.334 2.667l-2.666 1.333l-4 -2", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconHexagonsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonsOff
});

var IconHexagons = createReactComponent("outline", "hexagons", "IconHexagons", [["path", { "d": "M4 18v-5l4 -2l4 2v5l-4 2z", "key": "svg-0" }], ["path", { "d": "M8 11v-5l4 -2l4 2v5", "key": "svg-1" }], ["path", { "d": "M12 13l4 -2l4 2v5l-4 2l-4 -2", "key": "svg-2" }]]);

var IconHexagons$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagons
});

var IconHierarchy2 = createReactComponent("outline", "hierarchy-2", "IconHierarchy2", [["path", { "d": "M10 3h4v4h-4z", "key": "svg-0" }], ["path", { "d": "M3 17h4v4h-4z", "key": "svg-1" }], ["path", { "d": "M17 17h4v4h-4z", "key": "svg-2" }], ["path", { "d": "M7 17l5 -4l5 4", "key": "svg-3" }], ["path", { "d": "M12 7l0 6", "key": "svg-4" }]]);

var IconHierarchy2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHierarchy2
});

var IconHierarchy3 = createReactComponent("outline", "hierarchy-3", "IconHierarchy3", [["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M12 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M20 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M4 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M16 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-5" }], ["path", { "d": "M5 17l2 -3", "key": "svg-6" }], ["path", { "d": "M9 10l2 -3", "key": "svg-7" }], ["path", { "d": "M13 7l2 3", "key": "svg-8" }], ["path", { "d": "M17 14l2 3", "key": "svg-9" }], ["path", { "d": "M15 14l-2 3", "key": "svg-10" }], ["path", { "d": "M9 14l2 3", "key": "svg-11" }]]);

var IconHierarchy3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHierarchy3
});

var IconHierarchyOff = createReactComponent("outline", "hierarchy-off", "IconHierarchyOff", [["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M17.585 17.587a2 2 0 0 0 2.813 2.843", "key": "svg-2" }], ["path", { "d": "M6.5 17.5l5.5 -4.5l5.5 4.5", "key": "svg-3" }], ["path", { "d": "M12 7v1m0 4v1", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconHierarchyOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHierarchyOff
});

var IconHierarchy = createReactComponent("outline", "hierarchy", "IconHierarchy", [["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M6.5 17.5l5.5 -4.5l5.5 4.5", "key": "svg-3" }], ["path", { "d": "M12 7l0 6", "key": "svg-4" }]]);

var IconHierarchy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHierarchy
});

var IconHighlightOff = createReactComponent("outline", "highlight-off", "IconHighlightOff", [["path", { "d": "M9 9l-6 6v4h4l6 -6m2 -2l2.503 -2.503a2.828 2.828 0 1 0 -4 -4l-2.497 2.497", "key": "svg-0" }], ["path", { "d": "M12.5 5.5l4 4", "key": "svg-1" }], ["path", { "d": "M4.5 13.5l4 4", "key": "svg-2" }], ["path", { "d": "M19 15h2v2m-2 2h-6l3 -3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconHighlightOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHighlightOff
});

var IconHighlight = createReactComponent("outline", "highlight", "IconHighlight", [["path", { "d": "M3 19h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M12.5 5.5l4 4", "key": "svg-1" }], ["path", { "d": "M4.5 13.5l4 4", "key": "svg-2" }], ["path", { "d": "M21 15v4h-8l4 -4z", "key": "svg-3" }]]);

var IconHighlight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHighlight
});

var IconHistoryOff = createReactComponent("outline", "history-off", "IconHistoryOff", [["path", { "d": "M3.05 11a8.975 8.975 0 0 1 2.54 -5.403m2.314 -1.697a9 9 0 0 1 12.113 12.112m-1.695 2.312a9 9 0 0 1 -14.772 -3.324m-.5 5v-5h5", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconHistoryOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHistoryOff
});

var IconHistoryToggle = createReactComponent("outline", "history-toggle", "IconHistoryToggle", [["path", { "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969", "key": "svg-0" }], ["path", { "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554", "key": "svg-1" }], ["path", { "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592", "key": "svg-2" }], ["path", { "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305", "key": "svg-3" }], ["path", { "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356", "key": "svg-4" }], ["path", { "d": "M12 8v4l3 3", "key": "svg-5" }]]);

var IconHistoryToggle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHistoryToggle
});

var IconHistory = createReactComponent("outline", "history", "IconHistory", [["path", { "d": "M12 8l0 4l2 2", "key": "svg-0" }], ["path", { "d": "M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5", "key": "svg-1" }]]);

var IconHistory$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHistory
});

var IconHome2 = createReactComponent("outline", "home-2", "IconHome2", [["path", { "d": "M5 12l-2 0l9 -9l9 9l-2 0", "key": "svg-0" }], ["path", { "d": "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7", "key": "svg-1" }], ["path", { "d": "M10 12h4v4h-4z", "key": "svg-2" }]]);

var IconHome2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHome2
});

var IconHomeBitcoin = createReactComponent("outline", "home-bitcoin", "IconHomeBitcoin", [["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-0" }], ["path", { "d": "M19.5 10.5l-7.5 -7.5l-9 9h2v7a2 2 0 0 0 2 2h6", "key": "svg-1" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.387 0 .748 .11 1.054 .3", "key": "svg-2" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }]]);

var IconHomeBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeBitcoin
});

var IconHomeBolt = createReactComponent("outline", "home-bolt", "IconHomeBolt", [["path", { "d": "M19 10l-7 -7l-9 9h2v7a2 2 0 0 0 2 2h7.5", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.661 0 1.248 .32 1.612 .815", "key": "svg-1" }], ["path", { "d": "M19 14l-2 4h4l-2 4", "key": "svg-2" }]]);

var IconHomeBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeBolt
});

var IconHomeCancel = createReactComponent("outline", "home-cancel", "IconHomeCancel", [["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 21l4 -4", "key": "svg-1" }], ["path", { "d": "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5", "key": "svg-2" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.58 0 1.103 .247 1.468 .642", "key": "svg-3" }]]);

var IconHomeCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeCancel
});

var IconHomeCheck = createReactComponent("outline", "home-check", "IconHomeCheck", [["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M19 13.488v-1.488h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h4.525", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconHomeCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeCheck
});

var IconHomeCog = createReactComponent("outline", "home-cog", "IconHomeCog", [["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h1.6", "key": "svg-0" }], ["path", { "d": "M20 11l-8 -8l-9 9h2v7a2 2 0 0 0 2 2h4.159", "key": "svg-1" }], ["path", { "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M18 14.5v1.5", "key": "svg-3" }], ["path", { "d": "M18 20v1.5", "key": "svg-4" }], ["path", { "d": "M21.032 16.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M16.27 19l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M14.97 16.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M19.733 19l1.3 .75", "key": "svg-8" }]]);

var IconHomeCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeCog
});

var IconHomeDollar = createReactComponent("outline", "home-dollar", "IconHomeDollar", [["path", { "d": "M19 10l-7 -7l-9 9h2v7a2 2 0 0 0 2 2h6", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.387 0 .748 .11 1.054 .3", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconHomeDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeDollar
});

var IconHomeDot = createReactComponent("outline", "home-dot", "IconHomeDot", [["path", { "d": "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.641 0 1.212 .302 1.578 .771", "key": "svg-2" }]]);

var IconHomeDot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeDot
});

var IconHomeDown = createReactComponent("outline", "home-down", "IconHomeDown", [["path", { "d": "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-3" }]]);

var IconHomeDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeDown
});

var IconHomeEco = createReactComponent("outline", "home-eco", "IconHomeEco", [["path", { "d": "M20 11l-8 -8l-9 9h2v7a2 2 0 0 0 2 2h5", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.325 0 .631 .077 .902 .215", "key": "svg-1" }], ["path", { "d": "M16 22s0 -2 3 -4", "key": "svg-2" }], ["path", { "d": "M19 21a3 3 0 0 1 0 -6h3v3a3 3 0 0 1 -3 3z", "key": "svg-3" }]]);

var IconHomeEco$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeEco
});

var IconHomeEdit = createReactComponent("outline", "home-edit", "IconHomeEdit", [["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.645 0 1.218 .305 1.584 .78", "key": "svg-0" }], ["path", { "d": "M20 11l-8 -8l-9 9h2v7a2 2 0 0 0 2 2h4", "key": "svg-1" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z", "key": "svg-2" }]]);

var IconHomeEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeEdit
});

var IconHomeExclamation = createReactComponent("outline", "home-exclamation", "IconHomeExclamation", [["path", { "d": "M21 12l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h8", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 1.857 1.257", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconHomeExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeExclamation
});

var IconHomeHand = createReactComponent("outline", "home-hand", "IconHomeHand", [["path", { "d": "M18 9l-6 -6l-9 9h2v7a2 2 0 0 0 2 2h3.5", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M16 17.5l-.585 -.578a1.516 1.516 0 0 0 -2 0c-.477 .433 -.551 1.112 -.177 1.622l1.762 2.456c.37 .506 1.331 1 2 1h3c1.009 0 1.497 -.683 1.622 -1.593c.252 -.938 .378 -1.74 .378 -2.407c0 -1 -.939 -1.843 -2 -2h-1v-2.636c0 -.754 -.672 -1.364 -1.5 -1.364s-1.5 .61 -1.5 1.364v4.136z", "key": "svg-2" }]]);

var IconHomeHand$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeHand
});

var IconHomeHeart = createReactComponent("outline", "home-heart", "IconHomeHeart", [["path", { "d": "M21 12l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h6", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.39 0 .754 .112 1.061 .304", "key": "svg-1" }], ["path", { "d": "M19 21.5l2.518 -2.58a1.74 1.74 0 0 0 0 -2.413a1.627 1.627 0 0 0 -2.346 0l-.168 .172l-.168 -.172a1.627 1.627 0 0 0 -2.346 0a1.74 1.74 0 0 0 0 2.412l2.51 2.59z", "key": "svg-2" }]]);

var IconHomeHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeHeart
});

var IconHomeInfinity = createReactComponent("outline", "home-infinity", "IconHomeInfinity", [["path", { "d": "M19 14v-2h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h2.5", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 1.75 1.032", "key": "svg-1" }], ["path", { "d": "M15.536 17.586a2.123 2.123 0 0 0 -2.929 0a1.951 1.951 0 0 0 0 2.828c.809 .781 2.12 .781 2.929 0c.809 -.781 -.805 .778 0 0l1.46 -1.41l1.46 -1.419", "key": "svg-2" }], ["path", { "d": "M15.54 17.582l1.46 1.42l1.46 1.41c.809 .78 -.805 -.779 0 0s2.12 .781 2.929 0a1.951 1.951 0 0 0 0 -2.828a2.123 2.123 0 0 0 -2.929 0", "key": "svg-3" }]]);

var IconHomeInfinity$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeInfinity
});

var IconHomeLink = createReactComponent("outline", "home-link", "IconHomeLink", [["path", { "d": "M20.085 11.085l-8.085 -8.085l-9 9h2v7a2 2 0 0 0 2 2h4.5", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 1.807 1.143", "key": "svg-1" }], ["path", { "d": "M21 21m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M21 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M16 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["path", { "d": "M21 16l-5 3l5 2", "key": "svg-5" }]]);

var IconHomeLink$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeLink
});

var IconHomeMinus = createReactComponent("outline", "home-minus", "IconHomeMinus", [["path", { "d": "M19 15v-3h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2", "key": "svg-2" }]]);

var IconHomeMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeMinus
});

var IconHomeMove = createReactComponent("outline", "home-move", "IconHomeMove", [["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16l3 3l-3 3", "key": "svg-3" }]]);

var IconHomeMove$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeMove
});

var IconHomeOff = createReactComponent("outline", "home-off", "IconHomeOff", [["path", { "d": "M5 12h-2l4.497 -4.497m2 -2l2.504 -2.504l9 9h-2", "key": "svg-0" }], ["path", { "d": "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2m0 -4v-3", "key": "svg-1" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2m2 2v6", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconHomeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeOff
});

var IconHomePlus = createReactComponent("outline", "home-plus", "IconHomePlus", [["path", { "d": "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconHomePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomePlus
});

var IconHomeQuestion = createReactComponent("outline", "home-question", "IconHomeQuestion", [["path", { "d": "M20.136 11.136l-8.136 -8.136l-9 9h2v7a2 2 0 0 0 2 2h7", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.467 0 .896 .16 1.236 .428", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }]]);

var IconHomeQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeQuestion
});

var IconHomeRibbon = createReactComponent("outline", "home-ribbon", "IconHomeRibbon", [["path", { "d": "M16 15h5v7l-2.5 -1.5l-2.5 1.5z", "key": "svg-0" }], ["path", { "d": "M20 11l-8 -8l-9 9h2v7a2 2 0 0 0 2 2h5", "key": "svg-1" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h1.5", "key": "svg-2" }]]);

var IconHomeRibbon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeRibbon
});

var IconHomeSearch = createReactComponent("outline", "home-search", "IconHomeSearch", [["path", { "d": "M21 12l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h4.7", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconHomeSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeSearch
});

var IconHomeShare = createReactComponent("outline", "home-share", "IconHomeShare", [["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.247 0 .484 .045 .702 .127", "key": "svg-0" }], ["path", { "d": "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconHomeShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeShare
});

var IconHomeShield = createReactComponent("outline", "home-shield", "IconHomeShield", [["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h1.341", "key": "svg-0" }], ["path", { "d": "M19.682 10.682l-7.682 -7.682l-9 9h2v7a2 2 0 0 0 2 2h5", "key": "svg-1" }], ["path", { "d": "M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5z", "key": "svg-2" }]]);

var IconHomeShield$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeShield
});

var IconHomeSignal = createReactComponent("outline", "home-signal", "IconHomeSignal", [["path", { "d": "M15 22v-2", "key": "svg-0" }], ["path", { "d": "M18 22v-4", "key": "svg-1" }], ["path", { "d": "M21 22v-6", "key": "svg-2" }], ["path", { "d": "M19 12.494v-.494h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h4", "key": "svg-3" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v.5", "key": "svg-4" }]]);

var IconHomeSignal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeSignal
});

var IconHomeSpark = createReactComponent("outline", "home-spark", "IconHomeSpark", [["path", { "d": "M5 12h-2l9 -9l9 9h-2", "key": "svg-0" }], ["path", { "d": "M5 12v7a2 2 0 0 0 2 2h5", "key": "svg-1" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2", "key": "svg-2" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-3" }]]);

var IconHomeSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeSpark
});

var IconHomeStar = createReactComponent("outline", "home-star", "IconHomeStar", [["path", { "d": "M19.258 10.258l-7.258 -7.258l-9 9h2v7a2 2 0 0 0 2 2h4", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h1.5", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconHomeStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeStar
});

var IconHomeStats = createReactComponent("outline", "home-stats", "IconHomeStats", [["path", { "d": "M19 13v-1h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h2.5", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2", "key": "svg-1" }], ["path", { "d": "M13 22l3 -3l2 2l4 -4", "key": "svg-2" }], ["path", { "d": "M19 17h3v3", "key": "svg-3" }]]);

var IconHomeStats$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeStats
});

var IconHomeUp = createReactComponent("outline", "home-up", "IconHomeUp", [["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.641 0 1.212 .302 1.578 .771", "key": "svg-0" }], ["path", { "d": "M20.136 11.136l-8.136 -8.136l-9 9h2v7a2 2 0 0 0 2 2h6.344", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }]]);

var IconHomeUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeUp
});

var IconHomeX = createReactComponent("outline", "home-x", "IconHomeX", [["path", { "d": "M19 13.4v-1.4h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5", "key": "svg-0" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.402 0 .777 .119 1.091 .323", "key": "svg-1" }], ["path", { "d": "M21.5 21.5l-5 -5", "key": "svg-2" }], ["path", { "d": "M16.5 21.5l5 -5", "key": "svg-3" }]]);

var IconHomeX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeX
});

var IconHome = createReactComponent("outline", "home", "IconHome", [["path", { "d": "M5 12l-2 0l9 -9l9 9l-2 0", "key": "svg-0" }], ["path", { "d": "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7", "key": "svg-1" }], ["path", { "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6", "key": "svg-2" }]]);

var IconHome$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHome
});

var IconHorseToy = createReactComponent("outline", "horse-toy", "IconHorseToy", [["path", { "d": "M3.5 17.5c5.667 4.667 11.333 4.667 17 0", "key": "svg-0" }], ["path", { "d": "M19 18.5l-2 -8.5l1 -2l2 1l1.5 -1.5l-2.5 -4.5c-5.052 .218 -5.99 3.133 -7 6h-6a3 3 0 0 0 -3 3", "key": "svg-1" }], ["path", { "d": "M5 18.5l2 -9.5", "key": "svg-2" }], ["path", { "d": "M8 20l2 -5h4l2 5", "key": "svg-3" }]]);

var IconHorseToy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHorseToy
});

var IconHorse = createReactComponent("outline", "horse", "IconHorse", [["path", { "d": "M7 10l-.85 8.507a1.357 1.357 0 0 0 1.35 1.493h.146a2 2 0 0 0 1.857 -1.257l.994 -2.486a2 2 0 0 1 1.857 -1.257h1.292a2 2 0 0 1 1.857 1.257l.994 2.486a2 2 0 0 0 1.857 1.257h.146a1.37 1.37 0 0 0 1.364 -1.494l-.864 -9.506h-8c0 -3 -3 -5 -6 -5l-3 6l2 2l3 -2z", "key": "svg-0" }], ["path", { "d": "M22 14v-2a3 3 0 0 0 -3 -3", "key": "svg-1" }]]);

var IconHorse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHorse
});

var IconHorseshoe = createReactComponent("outline", "horseshoe", "IconHorseshoe", [["path", { "d": "M19 17c.5 -1.242 2 -2 2 -5s-1 -9 -9 -9s-9 6 -9 9s1.495 3.749 2 5l-2 1l2 3l2.406 -1.147c1.25 -.714 1.778 -2.08 1.203 -3.363c-1.078 -2.407 -1.609 -8.49 3.391 -8.49s4.469 6.083 3.39 8.49c-.574 1.284 -.045 2.649 1.204 3.363l2.406 1.147l2 -3l-2 -1z", "key": "svg-0" }]]);

var IconHorseshoe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHorseshoe
});

var IconHospitalCircle = createReactComponent("outline", "hospital-circle", "IconHospitalCircle", [["path", { "d": "M10 16v-8", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }], ["path", { "d": "M14 16v-8", "key": "svg-2" }], ["path", { "d": "M10 12h4", "key": "svg-3" }]]);

var IconHospitalCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHospitalCircle
});

var IconHospital = createReactComponent("outline", "hospital", "IconHospital", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M10 16v-8", "key": "svg-1" }], ["path", { "d": "M14 16v-8", "key": "svg-2" }], ["path", { "d": "M10 12h4", "key": "svg-3" }]]);

var IconHospital$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHospital
});

var IconHotelService = createReactComponent("outline", "hotel-service", "IconHotelService", [["path", { "d": "M8.5 10a1.5 1.5 0 0 1 -1.5 -1.5a5.5 5.5 0 0 1 11 0v10.5a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2c0 -1.38 .71 -2.444 1.88 -3.175l4.424 -2.765c1.055 -.66 1.696 -1.316 1.696 -2.56a2.5 2.5 0 1 0 -5 0a1.5 1.5 0 0 1 -1.5 1.5z", "key": "svg-0" }]]);

var IconHotelService$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHotelService
});

var IconHourglassEmpty = createReactComponent("outline", "hourglass-empty", "IconHourglassEmpty", [["path", { "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z", "key": "svg-1" }]]);

var IconHourglassEmpty$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHourglassEmpty
});

var IconHourglassHigh = createReactComponent("outline", "hourglass-high", "IconHourglassHigh", [["path", { "d": "M6.5 7h11", "key": "svg-0" }], ["path", { "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z", "key": "svg-2" }]]);

var IconHourglassHigh$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHourglassHigh
});

var IconHourglassLow = createReactComponent("outline", "hourglass-low", "IconHourglassLow", [["path", { "d": "M6.5 17h11", "key": "svg-0" }], ["path", { "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z", "key": "svg-2" }]]);

var IconHourglassLow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHourglassLow
});

var IconHourglassOff = createReactComponent("outline", "hourglass-off", "IconHourglassOff", [["path", { "d": "M18 18v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-2a6 6 0 0 1 6 -6", "key": "svg-0" }], ["path", { "d": "M6 6a6 6 0 0 0 6 6m3.13 -.88a6 6 0 0 0 2.87 -5.12v-2a1 1 0 0 0 -1 -1h-10", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconHourglassOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHourglassOff
});

var IconHourglass = createReactComponent("outline", "hourglass", "IconHourglass", [["path", { "d": "M6.5 7h11", "key": "svg-0" }], ["path", { "d": "M6.5 17h11", "key": "svg-1" }], ["path", { "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z", "key": "svg-3" }]]);

var IconHourglass$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHourglass
});

var IconHours12 = createReactComponent("outline", "hours-12", "IconHours12", [["path", { "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4", "key": "svg-0" }], ["path", { "d": "M4 13c.468 3.6 3.384 6.546 7 7", "key": "svg-1" }], ["path", { "d": "M18 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2", "key": "svg-2" }], ["path", { "d": "M15 21v-6", "key": "svg-3" }]]);

var IconHours12$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHours12
});

var IconHours24 = createReactComponent("outline", "hours-24", "IconHours24", [["path", { "d": "M4 13c.325 2.532 1.881 4.781 4 6", "key": "svg-0" }], ["path", { "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2", "key": "svg-1" }], ["path", { "d": "M4 5v4h4", "key": "svg-2" }], ["path", { "d": "M12 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2", "key": "svg-3" }], ["path", { "d": "M18 15v2a1 1 0 0 0 1 1h1", "key": "svg-4" }], ["path", { "d": "M21 15v6", "key": "svg-5" }]]);

var IconHours24$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHours24
});

var IconHtml = createReactComponent("outline", "html", "IconHtml", [["path", { "d": "M13 16v-8l2 5l2 -5v8", "key": "svg-0" }], ["path", { "d": "M1 16v-8", "key": "svg-1" }], ["path", { "d": "M5 8v8", "key": "svg-2" }], ["path", { "d": "M1 12h4", "key": "svg-3" }], ["path", { "d": "M7 8h4", "key": "svg-4" }], ["path", { "d": "M9 8v8", "key": "svg-5" }], ["path", { "d": "M20 8v8h3", "key": "svg-6" }]]);

var IconHtml$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHtml
});

var IconHttpConnectOff = createReactComponent("outline", "http-connect-off", "IconHttpConnectOff", [["path", { "d": "M7 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-0" }], ["path", { "d": "M17 13v-5l4 8v-8", "key": "svg-1" }], ["path", { "d": "M14 14a2 2 0 1 1 -4 0v-4m2 -2a2 2 0 0 1 2 2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconHttpConnectOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpConnectOff
});

var IconHttpConnect = createReactComponent("outline", "http-connect", "IconHttpConnect", [["path", { "d": "M7 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-0" }], ["path", { "d": "M17 16v-8l4 8v-8", "key": "svg-1" }], ["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2", "key": "svg-2" }]]);

var IconHttpConnect$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpConnect
});

var IconHttpDeleteOff = createReactComponent("outline", "http-delete-off", "IconHttpDeleteOff", [["path", { "d": "M3 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 8h-2m-2 2v6h4", "key": "svg-1" }], ["path", { "d": "M10 12h2", "key": "svg-2" }], ["path", { "d": "M17 8v5m3 3h1", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconHttpDeleteOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpDeleteOff
});

var IconHttpDelete = createReactComponent("outline", "http-delete", "IconHttpDelete", [["path", { "d": "M3 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8h4", "key": "svg-1" }], ["path", { "d": "M10 12h2.5", "key": "svg-2" }], ["path", { "d": "M17 8v8h4", "key": "svg-3" }]]);

var IconHttpDelete$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpDelete
});

var IconHttpGetOff = createReactComponent("outline", "http-get-off", "IconHttpGetOff", [["path", { "d": "M7 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }], ["path", { "d": "M14 8h-2m-2 2v6h4", "key": "svg-1" }], ["path", { "d": "M10 12h2", "key": "svg-2" }], ["path", { "d": "M17 8h4", "key": "svg-3" }], ["path", { "d": "M19 8v7", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconHttpGetOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpGetOff
});

var IconHttpGet = createReactComponent("outline", "http-get", "IconHttpGet", [["path", { "d": "M7 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8h4", "key": "svg-1" }], ["path", { "d": "M10 12h2.5", "key": "svg-2" }], ["path", { "d": "M17 8h4", "key": "svg-3" }], ["path", { "d": "M19 8v8", "key": "svg-4" }]]);

var IconHttpGet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpGet
});

var IconHttpHeadOff = createReactComponent("outline", "http-head-off", "IconHttpHeadOff", [["path", { "d": "M3 16v-8", "key": "svg-0" }], ["path", { "d": "M7 8v8", "key": "svg-1" }], ["path", { "d": "M3 12h4", "key": "svg-2" }], ["path", { "d": "M14 8h-2m-2 2v6h4", "key": "svg-3" }], ["path", { "d": "M10 12h2", "key": "svg-4" }], ["path", { "d": "M17 13v-3a2 2 0 1 1 4 0v6", "key": "svg-5" }], ["path", { "d": "M17 13h4", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconHttpHeadOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpHeadOff
});

var IconHttpHead = createReactComponent("outline", "http-head", "IconHttpHead", [["path", { "d": "M3 16v-8", "key": "svg-0" }], ["path", { "d": "M7 8v8", "key": "svg-1" }], ["path", { "d": "M3 12h4", "key": "svg-2" }], ["path", { "d": "M14 8h-4v8h4", "key": "svg-3" }], ["path", { "d": "M10 12h2.5", "key": "svg-4" }], ["path", { "d": "M17 16v-6a2 2 0 1 1 4 0v6", "key": "svg-5" }], ["path", { "d": "M17 13h4", "key": "svg-6" }]]);

var IconHttpHead$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpHead
});

var IconHttpOptionsOff = createReactComponent("outline", "http-options-off", "IconHttpOptionsOff", [["path", { "d": "M5 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M10 12h2m2 -2a2 2 0 0 0 -2 -2m-2 2v6", "key": "svg-1" }], ["path", { "d": "M17 8h4", "key": "svg-2" }], ["path", { "d": "M19 8v7", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconHttpOptionsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpOptionsOff
});

var IconHttpOptions = createReactComponent("outline", "http-options", "IconHttpOptions", [["path", { "d": "M5 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-1" }], ["path", { "d": "M17 8h4", "key": "svg-2" }], ["path", { "d": "M19 8v8", "key": "svg-3" }]]);

var IconHttpOptions$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpOptions
});

var IconHttpPatchOff = createReactComponent("outline", "http-patch-off", "IconHttpPatchOff", [["path", { "d": "M3 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-0" }], ["path", { "d": "M10 16v-6m2 -2a2 2 0 0 1 2 2m0 4v2", "key": "svg-1" }], ["path", { "d": "M10 13h3", "key": "svg-2" }], ["path", { "d": "M17 8h4", "key": "svg-3" }], ["path", { "d": "M19 8v7", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconHttpPatchOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpPatchOff
});

var IconHttpPatch = createReactComponent("outline", "http-patch", "IconHttpPatch", [["path", { "d": "M3 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-0" }], ["path", { "d": "M10 16v-6a2 2 0 1 1 4 0v6", "key": "svg-1" }], ["path", { "d": "M10 13h4", "key": "svg-2" }], ["path", { "d": "M17 8h4", "key": "svg-3" }], ["path", { "d": "M19 8v8", "key": "svg-4" }]]);

var IconHttpPatch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpPatch
});

var IconHttpPostOff = createReactComponent("outline", "http-post-off", "IconHttpPostOff", [["path", { "d": "M3 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-0" }], ["path", { "d": "M12 8a2 2 0 0 1 2 2m0 4a2 2 0 1 1 -4 0v-4", "key": "svg-1" }], ["path", { "d": "M20 16a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconHttpPostOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpPostOff
});

var IconHttpPost = createReactComponent("outline", "http-post", "IconHttpPost", [["path", { "d": "M3 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-0" }], ["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2", "key": "svg-1" }], ["path", { "d": "M17 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1", "key": "svg-2" }]]);

var IconHttpPost$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpPost
});

var IconHttpPutOff = createReactComponent("outline", "http-put-off", "IconHttpPutOff", [["path", { "d": "M3 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-0" }], ["path", { "d": "M17 8h4", "key": "svg-1" }], ["path", { "d": "M19 8v8", "key": "svg-2" }], ["path", { "d": "M10 10v4a2 2 0 1 0 4 0m0 -4v-2", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconHttpPutOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpPutOff
});

var IconHttpPut = createReactComponent("outline", "http-put", "IconHttpPut", [["path", { "d": "M3 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-0" }], ["path", { "d": "M17 8h4", "key": "svg-1" }], ["path", { "d": "M19 8v8", "key": "svg-2" }], ["path", { "d": "M10 8v6a2 2 0 1 0 4 0v-6", "key": "svg-3" }]]);

var IconHttpPut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpPut
});

var IconHttpQueOff = createReactComponent("outline", "http-que-off", "IconHttpQueOff", [["path", { "d": "M5 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M6 15l1 1", "key": "svg-1" }], ["path", { "d": "M21 8h-4v8h4", "key": "svg-2" }], ["path", { "d": "M17 12h2.5", "key": "svg-3" }], ["path", { "d": "M10 10v4a2 2 0 1 0 4 0m0 -4v-2", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconHttpQueOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpQueOff
});

var IconHttpQue = createReactComponent("outline", "http-que", "IconHttpQue", [["path", { "d": "M5 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M6 15l1 1", "key": "svg-1" }], ["path", { "d": "M21 8h-4v8h4", "key": "svg-2" }], ["path", { "d": "M17 12h2.5", "key": "svg-3" }], ["path", { "d": "M10 8v6a2 2 0 1 0 4 0v-6", "key": "svg-4" }]]);

var IconHttpQue$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpQue
});

var IconHttpTraceOff = createReactComponent("outline", "http-trace-off", "IconHttpTraceOff", [["path", { "d": "M3 8h4", "key": "svg-0" }], ["path", { "d": "M5 8v8", "key": "svg-1" }], ["path", { "d": "M10 12h2m2 -2a2 2 0 0 0 -2 -2m-2 2v6", "key": "svg-2" }], ["path", { "d": "M14 16l-3 -4", "key": "svg-3" }], ["path", { "d": "M17 13v-3a2 2 0 1 1 4 0v6", "key": "svg-4" }], ["path", { "d": "M17 13h4", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconHttpTraceOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpTraceOff
});

var IconHttpTrace = createReactComponent("outline", "http-trace", "IconHttpTrace", [["path", { "d": "M3 8h4", "key": "svg-0" }], ["path", { "d": "M5 8v8", "key": "svg-1" }], ["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-2" }], ["path", { "d": "M14 16l-3 -4", "key": "svg-3" }], ["path", { "d": "M17 16v-6a2 2 0 1 1 4 0v6", "key": "svg-4" }], ["path", { "d": "M17 13h4", "key": "svg-5" }]]);

var IconHttpTrace$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHttpTrace
});

var IconIceCream2 = createReactComponent("outline", "ice-cream-2", "IconIceCream2", [["path", { "d": "M17.657 11a6 6 0 1 0 -11.315 0", "key": "svg-0" }], ["path", { "d": "M6.342 11l5.658 11l5.657 -11z", "key": "svg-1" }]]);

var IconIceCream2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIceCream2
});

var IconIceCreamOff = createReactComponent("outline", "ice-cream-off", "IconIceCreamOff", [["path", { "d": "M12 21.5v-4.5", "key": "svg-0" }], ["path", { "d": "M8 8v9h8v-1m0 -4v-5a4 4 0 0 0 -7.277 -2.294", "key": "svg-1" }], ["path", { "d": "M8 10.5l1.74 -.76m2.79 -1.222l3.47 -1.518", "key": "svg-2" }], ["path", { "d": "M8 14.5l4.488 -1.964", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconIceCreamOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIceCreamOff
});

var IconIceCream = createReactComponent("outline", "ice-cream", "IconIceCream", [["path", { "d": "M12 21.5v-4.5", "key": "svg-0" }], ["path", { "d": "M8 17h8v-10a4 4 0 1 0 -8 0v10z", "key": "svg-1" }], ["path", { "d": "M8 10.5l8 -3.5", "key": "svg-2" }], ["path", { "d": "M8 14.5l8 -3.5", "key": "svg-3" }]]);

var IconIceCream$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIceCream
});

var IconIceSkating = createReactComponent("outline", "ice-skating", "IconIceSkating", [["path", { "d": "M5.905 5h3.418a1 1 0 0 1 .928 .629l1.143 2.856a3 3 0 0 0 2.207 1.83l4.717 .926a2.084 2.084 0 0 1 1.682 2.045v.714a1 1 0 0 1 -1 1h-13.895a1 1 0 0 1 -1 -1.1l.8 -8a1 1 0 0 1 1 -.9z", "key": "svg-0" }], ["path", { "d": "M3 19h17a1 1 0 0 0 1 -1", "key": "svg-1" }], ["path", { "d": "M9 15v4", "key": "svg-2" }], ["path", { "d": "M15 15v4", "key": "svg-3" }]]);

var IconIceSkating$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIceSkating
});

var IconIconsOff = createReactComponent("outline", "icons-off", "IconIconsOff", [["path", { "d": "M4.01 4.041a3.5 3.5 0 0 0 2.49 5.959c.975 0 1.865 -.357 2.5 -1m.958 -3.044a3.503 3.503 0 0 0 -2.905 -2.912", "key": "svg-0" }], ["path", { "d": "M2.5 21h8l-4 -7z", "key": "svg-1" }], ["path", { "d": "M14 3l7 7", "key": "svg-2" }], ["path", { "d": "M14 10l7 -7", "key": "svg-3" }], ["path", { "d": "M18 14h3v3m0 4h-7v-7", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconIconsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIconsOff
});

var IconIcons = createReactComponent("outline", "icons", "IconIcons", [["path", { "d": "M6.5 6.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0", "key": "svg-0" }], ["path", { "d": "M2.5 21h8l-4 -7z", "key": "svg-1" }], ["path", { "d": "M14 3l7 7", "key": "svg-2" }], ["path", { "d": "M14 10l7 -7", "key": "svg-3" }], ["path", { "d": "M14 14h7v7h-7z", "key": "svg-4" }]]);

var IconIcons$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIcons
});

var IconIdBadge2 = createReactComponent("outline", "id-badge-2", "IconIdBadge2", [["path", { "d": "M7 12h3v4h-3z", "key": "svg-0" }], ["path", { "d": "M10 6h-6a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1h-6", "key": "svg-1" }], ["path", { "d": "M10 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M14 16h2", "key": "svg-3" }], ["path", { "d": "M14 12h4", "key": "svg-4" }]]);

var IconIdBadge2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIdBadge2
});

var IconIdBadgeOff = createReactComponent("outline", "id-badge-off", "IconIdBadgeOff", [["path", { "d": "M7.141 3.125a3 3 0 0 1 .859 -.125h8a3 3 0 0 1 3 3v9m-.13 3.874a3 3 0 0 1 -2.87 2.126h-8a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 .128 -.869", "key": "svg-0" }], ["path", { "d": "M11.179 11.176a2 2 0 1 0 2.635 2.667", "key": "svg-1" }], ["path", { "d": "M10 6h4", "key": "svg-2" }], ["path", { "d": "M9 18h6", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconIdBadgeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIdBadgeOff
});

var IconIdBadge = createReactComponent("outline", "id-badge", "IconIdBadge", [["path", { "d": "M5 3m0 3a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M12 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M10 6h4", "key": "svg-2" }], ["path", { "d": "M9 18h6", "key": "svg-3" }]]);

var IconIdBadge$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIdBadge
});

var IconIdOff = createReactComponent("outline", "id-off", "IconIdOff", [["path", { "d": "M8 4h10a3 3 0 0 1 3 3v10m-1.437 2.561c-.455 .279 -.99 .439 -1.563 .439h-12a3 3 0 0 1 -3 -3v-10c0 -1.083 .573 -2.031 1.433 -2.559", "key": "svg-0" }], ["path", { "d": "M8.175 8.178a2 2 0 1 0 2.646 2.65", "key": "svg-1" }], ["path", { "d": "M15 8h2", "key": "svg-2" }], ["path", { "d": "M16 12h1", "key": "svg-3" }], ["path", { "d": "M7 16h9", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconIdOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIdOff
});

var IconId = createReactComponent("outline", "id", "IconId", [["path", { "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M9 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M15 8l2 0", "key": "svg-2" }], ["path", { "d": "M15 12l2 0", "key": "svg-3" }], ["path", { "d": "M7 16l10 0", "key": "svg-4" }]]);

var IconId$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconId
});

var IconIkosaedr = createReactComponent("outline", "ikosaedr", "IconIkosaedr", [["path", { "d": "M21 8.007v7.986a2 2 0 0 1 -1.006 1.735l-7 4.007a2 2 0 0 1 -1.988 0l-7 -4.007a2 2 0 0 1 -1.006 -1.735v-7.986a2 2 0 0 1 1.006 -1.735l7 -4.007a2 2 0 0 1 1.988 0l7 4.007a2 2 0 0 1 1.006 1.735", "key": "svg-0" }], ["path", { "d": "M3.29 6.97l4.21 2.03", "key": "svg-1" }], ["path", { "d": "M20.71 6.97l-4.21 2.03", "key": "svg-2" }], ["path", { "d": "M20.7 17h-17.4", "key": "svg-3" }], ["path", { "d": "M11.76 2.03l-4.26 6.97l-4.3 7.84", "key": "svg-4" }], ["path", { "d": "M12.24 2.03q 2.797 4.44 4.26 6.97t 4.3 7.84", "key": "svg-5" }], ["path", { "d": "M12 17l-4.5 -8h9z", "key": "svg-6" }], ["path", { "d": "M12 17v5", "key": "svg-7" }]]);

var IconIkosaedr$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIkosaedr
});

var IconImageInPicture = createReactComponent("outline", "image-in-picture", "IconImageInPicture", [["path", { "d": "M13 15c-2 0 -5 1 -5 5", "key": "svg-0" }], ["path", { "d": "M4 11m0 2a2 2 0 0 1 2 -2h5a2 2 0 0 1 2 2v5a2 2 0 0 1 -2 2h-5a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M4 7v-2a1 1 0 0 1 1 -1h2", "key": "svg-2" }], ["path", { "d": "M11 4h2", "key": "svg-3" }], ["path", { "d": "M17 4h2a1 1 0 0 1 1 1v2", "key": "svg-4" }], ["path", { "d": "M20 11v2", "key": "svg-5" }], ["path", { "d": "M20 17v2a1 1 0 0 1 -1 1h-2", "key": "svg-6" }]]);

var IconImageInPicture$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconImageInPicture
});

var IconInboxOff = createReactComponent("outline", "inbox-off", "IconInboxOff", [["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.593 3.422a2 2 0 0 1 -1.407 .578h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.056 .59 -1.418", "key": "svg-0" }], ["path", { "d": "M4 13h3l3 3h4l.987 -.987m2.013 -2.013h3", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconInboxOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInboxOff
});

var IconInbox = createReactComponent("outline", "inbox", "IconInbox", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 13h3l3 3h4l3 -3h3", "key": "svg-1" }]]);

var IconInbox$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInbox
});

var IconIndentDecrease = createReactComponent("outline", "indent-decrease", "IconIndentDecrease", [["path", { "d": "M20 6l-7 0", "key": "svg-0" }], ["path", { "d": "M20 12l-9 0", "key": "svg-1" }], ["path", { "d": "M20 18l-7 0", "key": "svg-2" }], ["path", { "d": "M8 8l-4 4l4 4", "key": "svg-3" }]]);

var IconIndentDecrease$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIndentDecrease
});

var IconIndentIncrease = createReactComponent("outline", "indent-increase", "IconIndentIncrease", [["path", { "d": "M20 6l-11 0", "key": "svg-0" }], ["path", { "d": "M20 12l-7 0", "key": "svg-1" }], ["path", { "d": "M20 18l-11 0", "key": "svg-2" }], ["path", { "d": "M4 8l4 4l-4 4", "key": "svg-3" }]]);

var IconIndentIncrease$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIndentIncrease
});

var IconInfinityOff = createReactComponent("outline", "infinity-off", "IconInfinityOff", [["path", { "d": "M8.165 8.174a4 4 0 0 0 -5.166 3.826a4 4 0 0 0 6.829 2.828a10 10 0 0 0 2.172 -2.828m1.677 -2.347a10 10 0 0 1 .495 -.481a4 4 0 1 1 5.129 6.1m-3.521 .537a4 4 0 0 1 -1.608 -.981a10 10 0 0 1 -2.172 -2.828", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconInfinityOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfinityOff
});

var IconInfinity = createReactComponent("outline", "infinity", "IconInfinity", [["path", { "d": "M9.828 9.172a4 4 0 1 0 0 5.656a10 10 0 0 0 2.172 -2.828a10 10 0 0 1 2.172 -2.828a4 4 0 1 1 0 5.656a10 10 0 0 1 -2.172 -2.828a10 10 0 0 0 -2.172 -2.828", "key": "svg-0" }]]);

var IconInfinity$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfinity
});

var IconInfoCircle = createReactComponent("outline", "info-circle", "IconInfoCircle", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 9h.01", "key": "svg-1" }], ["path", { "d": "M11 12h1v4h1", "key": "svg-2" }]]);

var IconInfoCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoCircle
});

var IconInfoHexagon = createReactComponent("outline", "info-hexagon", "IconInfoHexagon", [["path", { "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M12 9h.01", "key": "svg-1" }], ["path", { "d": "M11 12h1v4h1", "key": "svg-2" }]]);

var IconInfoHexagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoHexagon
});

var IconInfoOctagon = createReactComponent("outline", "info-octagon", "IconInfoOctagon", [["path", { "d": "M12.802 2.165l5.575 2.389c.48 .206 .863 .589 1.07 1.07l2.388 5.574c.22 .512 .22 1.092 0 1.604l-2.389 5.575c-.206 .48 -.589 .863 -1.07 1.07l-5.574 2.388c-.512 .22 -1.092 .22 -1.604 0l-5.575 -2.389a2.036 2.036 0 0 1 -1.07 -1.07l-2.388 -5.574a2.036 2.036 0 0 1 0 -1.604l2.389 -5.575c.206 -.48 .589 -.863 1.07 -1.07l5.574 -2.388a2.036 2.036 0 0 1 1.604 0z", "key": "svg-0" }], ["path", { "d": "M12 9h.01", "key": "svg-1" }], ["path", { "d": "M11 12h1v4h1", "key": "svg-2" }]]);

var IconInfoOctagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoOctagon
});

var IconInfoSmall = createReactComponent("outline", "info-small", "IconInfoSmall", [["path", { "d": "M12 9h.01", "key": "svg-0" }], ["path", { "d": "M11 12h1v4h1", "key": "svg-1" }]]);

var IconInfoSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoSmall
});

var IconInfoSquareRounded = createReactComponent("outline", "info-square-rounded", "IconInfoSquareRounded", [["path", { "d": "M12 9h.01", "key": "svg-0" }], ["path", { "d": "M11 12h1v4h1", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconInfoSquareRounded$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoSquareRounded
});

var IconInfoSquare = createReactComponent("outline", "info-square", "IconInfoSquare", [["path", { "d": "M12 9h.01", "key": "svg-0" }], ["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-1" }], ["path", { "d": "M11 12h1v4h1", "key": "svg-2" }]]);

var IconInfoSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoSquare
});

var IconInfoTriangle = createReactComponent("outline", "info-triangle", "IconInfoTriangle", [["path", { "d": "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z", "key": "svg-0" }], ["path", { "d": "M12 9h.01", "key": "svg-1" }], ["path", { "d": "M11 12h1v4h1", "key": "svg-2" }]]);

var IconInfoTriangle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoTriangle
});

var IconInnerShadowBottomLeft = createReactComponent("outline", "inner-shadow-bottom-left", "IconInnerShadowBottomLeft", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M6 12a6 6 0 0 0 6 6", "key": "svg-1" }]]);

var IconInnerShadowBottomLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowBottomLeft
});

var IconInnerShadowBottomRight = createReactComponent("outline", "inner-shadow-bottom-right", "IconInnerShadowBottomRight", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M18 12a6 6 0 0 1 -6 6", "key": "svg-1" }]]);

var IconInnerShadowBottomRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowBottomRight
});

var IconInnerShadowBottom = createReactComponent("outline", "inner-shadow-bottom", "IconInnerShadowBottom", [["path", { "d": "M18.364 18.364a9 9 0 1 0 -12.728 -12.728a9 9 0 0 0 12.728 12.728z", "key": "svg-0" }], ["path", { "d": "M7.757 16.243a6 6 0 0 0 8.486 0", "key": "svg-1" }]]);

var IconInnerShadowBottom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowBottom
});

var IconInnerShadowLeft = createReactComponent("outline", "inner-shadow-left", "IconInnerShadowLeft", [["path", { "d": "M5.636 5.636a9 9 0 1 1 12.728 12.728a9 9 0 0 1 -12.728 -12.728z", "key": "svg-0" }], ["path", { "d": "M7.757 16.243a6 6 0 0 1 0 -8.486", "key": "svg-1" }]]);

var IconInnerShadowLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowLeft
});

var IconInnerShadowRight = createReactComponent("outline", "inner-shadow-right", "IconInnerShadowRight", [["path", { "d": "M18.364 18.364a9 9 0 1 1 -12.728 -12.728a9 9 0 0 1 12.728 12.728z", "key": "svg-0" }], ["path", { "d": "M16.243 7.757a6 6 0 0 1 0 8.486", "key": "svg-1" }]]);

var IconInnerShadowRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowRight
});

var IconInnerShadowTopLeft = createReactComponent("outline", "inner-shadow-top-left", "IconInnerShadowTopLeft", [["path", { "d": "M12 3a9 9 0 1 1 0 18a9 9 0 0 1 0 -18z", "key": "svg-0" }], ["path", { "d": "M6 12a6 6 0 0 1 6 -6", "key": "svg-1" }]]);

var IconInnerShadowTopLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowTopLeft
});

var IconInnerShadowTopRight = createReactComponent("outline", "inner-shadow-top-right", "IconInnerShadowTopRight", [["path", { "d": "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z", "key": "svg-0" }], ["path", { "d": "M18 12a6 6 0 0 0 -6 -6", "key": "svg-1" }]]);

var IconInnerShadowTopRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowTopRight
});

var IconInnerShadowTop = createReactComponent("outline", "inner-shadow-top", "IconInnerShadowTop", [["path", { "d": "M5.636 5.636a9 9 0 1 0 12.728 12.728a9 9 0 0 0 -12.728 -12.728z", "key": "svg-0" }], ["path", { "d": "M16.243 7.757a6 6 0 0 0 -8.486 0", "key": "svg-1" }]]);

var IconInnerShadowTop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowTop
});

var IconInputAi = createReactComponent("outline", "input-ai", "IconInputAi", [["path", { "d": "M20 11v-2a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h4", "key": "svg-0" }], ["path", { "d": "M14 21v-4a2 2 0 1 1 4 0v4", "key": "svg-1" }], ["path", { "d": "M14 19h4", "key": "svg-2" }], ["path", { "d": "M21 15v6", "key": "svg-3" }]]);

var IconInputAi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInputAi
});

var IconInputCheck = createReactComponent("outline", "input-check", "IconInputCheck", [["path", { "d": "M20 13v-4a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h6", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }]]);

var IconInputCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInputCheck
});

var IconInputSearch = createReactComponent("outline", "input-search", "IconInputSearch", [["path", { "d": "M20 11v-2a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }]]);

var IconInputSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInputSearch
});

var IconInputSpark = createReactComponent("outline", "input-spark", "IconInputSpark", [["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-0" }], ["path", { "d": "M20 11.5v-2.5a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h7", "key": "svg-1" }]]);

var IconInputSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInputSpark
});

var IconInputX = createReactComponent("outline", "input-x", "IconInputX", [["path", { "d": "M20 13v-4a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h7", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }]]);

var IconInputX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInputX
});

var IconInvoice = createReactComponent("outline", "invoice", "IconInvoice", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M19 12v7a1.78 1.78 0 0 1 -3.1 1.4a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-14a2 2 0 0 1 2 -2h7l5 5v4.25", "key": "svg-1" }]]);

var IconInvoice$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInvoice
});

var IconIroning1 = createReactComponent("outline", "ironing-1", "IconIroning1", [["path", { "d": "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8", "key": "svg-0" }], ["path", { "d": "M12 15h.01", "key": "svg-1" }]]);

var IconIroning1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIroning1
});

var IconIroning2 = createReactComponent("outline", "ironing-2", "IconIroning2", [["path", { "d": "M10 15h.01", "key": "svg-0" }], ["path", { "d": "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8", "key": "svg-1" }], ["path", { "d": "M14 15h.01", "key": "svg-2" }]]);

var IconIroning2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIroning2
});

var IconIroning3 = createReactComponent("outline", "ironing-3", "IconIroning3", [["path", { "d": "M12 15h.01", "key": "svg-0" }], ["path", { "d": "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8", "key": "svg-1" }], ["path", { "d": "M9 15h.01", "key": "svg-2" }], ["path", { "d": "M15 15h.01", "key": "svg-3" }]]);

var IconIroning3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIroning3
});

var IconIroningOff = createReactComponent("outline", "ironing-off", "IconIroningOff", [["path", { "d": "M10 6h6.459a3 3 0 0 1 2.959 2.507l.577 3.464l.804 4.821l.007 .044m-2.806 1.164h-15a7 7 0 0 1 7 -7h1m4 0h4.8", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconIroningOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIroningOff
});

var IconIroningSteamOff = createReactComponent("outline", "ironing-steam-off", "IconIroningSteamOff", [["path", { "d": "M9 4h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.821 1.15", "key": "svg-0" }], ["path", { "d": "M16 16h-13a7 7 0 0 1 6.056 -6.937", "key": "svg-1" }], ["path", { "d": "M13 9h6.8", "key": "svg-2" }], ["path", { "d": "M12 19v2", "key": "svg-3" }], ["path", { "d": "M8 19l-1 2", "key": "svg-4" }], ["path", { "d": "M16 19l1 2", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconIroningSteamOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIroningSteamOff
});

var IconIroningSteam = createReactComponent("outline", "ironing-steam", "IconIroningSteam", [["path", { "d": "M12 19v2", "key": "svg-0" }], ["path", { "d": "M9 4h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8", "key": "svg-1" }], ["path", { "d": "M8 19l-1 2", "key": "svg-2" }], ["path", { "d": "M16 19l1 2", "key": "svg-3" }]]);

var IconIroningSteam$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIroningSteam
});

var IconIroning = createReactComponent("outline", "ironing", "IconIroning", [["path", { "d": "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8", "key": "svg-0" }]]);

var IconIroning$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIroning
});

var IconIrregularPolyhedronOff = createReactComponent("outline", "irregular-polyhedron-off", "IconIrregularPolyhedronOff", [["path", { "d": "M4.706 4.73a1 1 0 0 0 -.458 1.14l1.752 6.13l-1.752 6.13a1 1 0 0 0 .592 1.205l6.282 2.503a2.46 2.46 0 0 0 1.756 0l6.282 -2.503c.04 -.016 .079 -.035 .116 -.055m-.474 -4.474l-.802 -2.806l1.752 -6.13a1 1 0 0 0 -.592 -1.205l-6.282 -2.503a2.46 2.46 0 0 0 -1.756 0l-3.544 1.412", "key": "svg-0" }], ["path", { "d": "M4.5 5.5c.661 .214 1.161 .38 1.5 .5m6 2c.29 -.003 .603 -.06 .878 -.17l6.622 -2.33", "key": "svg-1" }], ["path", { "d": "M6 12l5.21 1.862a2.34 2.34 0 0 0 1.58 0l.742 -.265m2.956 -1.057c.312 -.11 .816 -.291 1.512 -.54", "key": "svg-2" }], ["path", { "d": "M12 22v-10", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconIrregularPolyhedronOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIrregularPolyhedronOff
});

var IconIrregularPolyhedronPlus = createReactComponent("outline", "irregular-polyhedron-plus", "IconIrregularPolyhedronPlus", [["path", { "d": "M18 12l1.752 -6.13a1 1 0 0 0 -.592 -1.205l-6.282 -2.503a2.46 2.46 0 0 0 -1.756 0l-6.282 2.503a1 1 0 0 0 -.592 1.204l1.752 6.131l-1.752 6.13a1 1 0 0 0 .592 1.205l6.282 2.503a2.46 2.46 0 0 0 1.756 0l.221 -.088", "key": "svg-0" }], ["path", { "d": "M4.5 5.5l6.622 2.33a2.35 2.35 0 0 0 1.756 0l6.622 -2.33", "key": "svg-1" }], ["path", { "d": "M6 12l5.21 1.862a2.34 2.34 0 0 0 1.58 0l5.21 -1.862", "key": "svg-2" }], ["path", { "d": "M12 22v-14", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16v6", "key": "svg-5" }]]);

var IconIrregularPolyhedronPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIrregularPolyhedronPlus
});

var IconIrregularPolyhedron = createReactComponent("outline", "irregular-polyhedron", "IconIrregularPolyhedron", [["path", { "d": "M6 12l-1.752 6.13a1 1 0 0 0 .592 1.205l6.282 2.503a2.46 2.46 0 0 0 1.756 0l6.282 -2.503a1 1 0 0 0 .592 -1.204l-1.752 -6.131l1.752 -6.13a1 1 0 0 0 -.592 -1.205l-6.282 -2.503a2.46 2.46 0 0 0 -1.756 0l-6.282 2.503a1 1 0 0 0 -.592 1.204l1.752 6.131z", "key": "svg-0" }], ["path", { "d": "M4.5 5.5l6.622 2.33a2.35 2.35 0 0 0 1.756 0l6.622 -2.33", "key": "svg-1" }], ["path", { "d": "M6 12l5.21 1.862a2.34 2.34 0 0 0 1.58 0l5.21 -1.862", "key": "svg-2" }], ["path", { "d": "M12 22v-14", "key": "svg-3" }]]);

var IconIrregularPolyhedron$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIrregularPolyhedron
});

var IconItalic = createReactComponent("outline", "italic", "IconItalic", [["path", { "d": "M11 5l6 0", "key": "svg-0" }], ["path", { "d": "M7 19l6 0", "key": "svg-1" }], ["path", { "d": "M14 5l-4 14", "key": "svg-2" }]]);

var IconItalic$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconItalic
});

var IconJacket = createReactComponent("outline", "jacket", "IconJacket", [["path", { "d": "M16 3l-4 5l-4 -5", "key": "svg-0" }], ["path", { "d": "M12 19a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-8.172a2 2 0 0 1 .586 -1.414l.828 -.828a2 2 0 0 0 .586 -1.414v-2.172a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2.172a2 2 0 0 0 .586 1.414l.828 .828a2 2 0 0 1 .586 1.414v8.172a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M20 13h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-2" }], ["path", { "d": "M4 17h3a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-3" }], ["path", { "d": "M12 19v-11", "key": "svg-4" }]]);

var IconJacket$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconJacket
});

var IconJetpack = createReactComponent("outline", "jetpack", "IconJetpack", [["path", { "d": "M10 6a3 3 0 1 0 -6 0v7h6v-7z", "key": "svg-0" }], ["path", { "d": "M14 13h6v-7a3 3 0 0 0 -6 0v7z", "key": "svg-1" }], ["path", { "d": "M5 16c0 2.333 .667 4 2 5c1.333 -1 2 -2.667 2 -5", "key": "svg-2" }], ["path", { "d": "M15 16c0 2.333 .667 4 2 5c1.333 -1 2 -2.667 2 -5", "key": "svg-3" }], ["path", { "d": "M10 8h4", "key": "svg-4" }], ["path", { "d": "M10 11h4", "key": "svg-5" }]]);

var IconJetpack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconJetpack
});

var IconJewishStar = createReactComponent("outline", "jewish-star", "IconJewishStar", [["path", { "d": "M12 2l3 5h6l-3 5l3 5h-6l-3 5l-3 -5h-6l3 -5l-3 -5h6z", "key": "svg-0" }]]);

var IconJewishStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconJewishStar
});

var IconJoinBevel = createReactComponent("outline", "join-bevel", "IconJoinBevel", [["path", { "d": "M6 4h3a2 2 0 0 1 2 2v6a1 1 0 0 0 1 1h6a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-6.586a1 1 0 0 1 -.707 -.293l-6.414 -6.414a1 1 0 0 1 -.293 -.707v-6.586a2 2 0 0 1 2 -2", "key": "svg-0" }]]);

var IconJoinBevel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconJoinBevel
});

var IconJoinRound = createReactComponent("outline", "join-round", "IconJoinRound", [["path", { "d": "M6 4h3a2 2 0 0 1 2 2v6a1 1 0 0 0 1 1h6a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-6a8 8 0 0 1 -8 -8v-6a2 2 0 0 1 2 -2", "key": "svg-0" }]]);

var IconJoinRound$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconJoinRound
});

var IconJoinStraight = createReactComponent("outline", "join-straight", "IconJoinStraight", [["path", { "d": "M6 4h3a2 2 0 0 1 2 2v6a1 1 0 0 0 1 1h6a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2", "key": "svg-0" }]]);

var IconJoinStraight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconJoinStraight
});

var IconJoker = createReactComponent("outline", "joker", "IconJoker", [["path", { "d": "M5 16m0 1.5a1.5 1.5 0 0 1 1.5 -1.5h11a1.5 1.5 0 0 1 1.5 1.5v0a1.5 1.5 0 0 1 -1.5 1.5h-11a1.5 1.5 0 0 1 -1.5 -1.5z", "key": "svg-0" }], ["path", { "d": "M12 16q -2.5 -8 -6 -8q -2.5 0 -3 2c2.953 .31 3.308 3.33 4 6", "key": "svg-1" }], ["path", { "d": "M12 16q 2.5 -8 6 -8q 2.5 0 3 2c-2.953 .31 -3.308 3.33 -4 6", "key": "svg-2" }], ["path", { "d": "M9 9.5q 2 -3.5 3 -3.5t 3 3.5", "key": "svg-3" }]]);

var IconJoker$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconJoker
});

var IconJpg = createReactComponent("outline", "jpg", "IconJpg", [["path", { "d": "M21 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }], ["path", { "d": "M10 16v-8h2a2 2 0 1 1 0 4h-2", "key": "svg-1" }], ["path", { "d": "M3 8h4v6a2 2 0 0 1 -2 2h-1.5a.5 .5 0 0 1 -.5 -.5v-.5", "key": "svg-2" }]]);

var IconJpg$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconJpg
});

var IconJson = createReactComponent("outline", "json", "IconJson", [["path", { "d": "M20 16v-8l3 8v-8", "key": "svg-0" }], ["path", { "d": "M15 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-1" }], ["path", { "d": "M1 8h3v6.5a1.5 1.5 0 0 1 -3 0v-.5", "key": "svg-2" }], ["path", { "d": "M7 15a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1", "key": "svg-3" }]]);

var IconJson$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconJson
});

var IconJumpRope = createReactComponent("outline", "jump-rope", "IconJumpRope", [["path", { "d": "M6 14v-6a3 3 0 1 1 6 0v8a3 3 0 0 0 6 0v-6", "key": "svg-0" }], ["path", { "d": "M16 3m0 2a2 2 0 0 1 2 -2h0a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h0a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M4 14m0 2a2 2 0 0 1 2 -2h0a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h0a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconJumpRope$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconJumpRope
});

var IconKarate = createReactComponent("outline", "karate", "IconKarate", [["path", { "d": "M18 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M3 9l4.5 1l3 2.5", "key": "svg-1" }], ["path", { "d": "M13 21v-8l3 -5.5", "key": "svg-2" }], ["path", { "d": "M8 4.5l4 2l4 1l4 3.5l-2 3.5", "key": "svg-3" }]]);

var IconKarate$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKarate
});

var IconKayak = createReactComponent("outline", "kayak", "IconKayak", [["path", { "d": "M6.414 6.414a2 2 0 0 0 0 -2.828l-1.414 -1.414l-2.828 2.828l1.414 1.414a2 2 0 0 0 2.828 0z", "key": "svg-0" }], ["path", { "d": "M17.586 17.586a2 2 0 0 0 0 2.828l1.414 1.414l2.828 -2.828l-1.414 -1.414a2 2 0 0 0 -2.828 0z", "key": "svg-1" }], ["path", { "d": "M6.5 6.5l11 11", "key": "svg-2" }], ["path", { "d": "M22 2.5c-9.983 2.601 -17.627 7.952 -20 19.5c9.983 -2.601 17.627 -7.952 20 -19.5z", "key": "svg-3" }], ["path", { "d": "M6.5 12.5l5 5", "key": "svg-4" }], ["path", { "d": "M12.5 6.5l5 5", "key": "svg-5" }]]);

var IconKayak$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKayak
});

var IconKerning = createReactComponent("outline", "kerning", "IconKerning", [["path", { "d": "M16 15v-3.5a2.5 2.5 0 1 1 5 0v3.5m0 -2h-5", "key": "svg-0" }], ["path", { "d": "M3 9l3 6l3 -6", "key": "svg-1" }], ["path", { "d": "M9 20l6 -16", "key": "svg-2" }]]);

var IconKerning$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKerning
});

var IconKeyOff = createReactComponent("outline", "key-off", "IconKeyOff", [["path", { "d": "M10.17 6.159l2.316 -2.316a2.877 2.877 0 0 1 4.069 0l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.33 2.33", "key": "svg-0" }], ["path", { "d": "M14.931 14.948a2.863 2.863 0 0 1 -1.486 -.79l-.301 -.302l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.863 2.863 0 0 1 -.794 -1.504", "key": "svg-1" }], ["path", { "d": "M15 9h.01", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconKeyOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyOff
});

var IconKey = createReactComponent("outline", "key", "IconKey", [["path", { "d": "M16.555 3.843l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.643 2.643a2.877 2.877 0 0 1 -4.069 0l-.301 -.301l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.877 2.877 0 0 1 0 -4.069l2.643 -2.643a2.877 2.877 0 0 1 4.069 0z", "key": "svg-0" }], ["path", { "d": "M15 9h.01", "key": "svg-1" }]]);

var IconKey$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKey
});

var IconKeyboardHide = createReactComponent("outline", "keyboard-hide", "IconKeyboardHide", [["path", { "d": "M2 3m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M6 7l0 .01", "key": "svg-1" }], ["path", { "d": "M10 7l0 .01", "key": "svg-2" }], ["path", { "d": "M14 7l0 .01", "key": "svg-3" }], ["path", { "d": "M18 7l0 .01", "key": "svg-4" }], ["path", { "d": "M6 11l0 .01", "key": "svg-5" }], ["path", { "d": "M18 11l0 .01", "key": "svg-6" }], ["path", { "d": "M10 11l4 0", "key": "svg-7" }], ["path", { "d": "M10 21l2 -2l2 2", "key": "svg-8" }]]);

var IconKeyboardHide$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyboardHide
});

var IconKeyboardOff = createReactComponent("outline", "keyboard-off", "IconKeyboardOff", [["path", { "d": "M18 18h-14a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2m4 0h10a2 2 0 0 1 2 2v8c0 .554 -.226 1.056 -.59 1.418", "key": "svg-0" }], ["path", { "d": "M6 10l0 .01", "key": "svg-1" }], ["path", { "d": "M10 10l0 .01", "key": "svg-2" }], ["path", { "d": "M14 10l0 .01", "key": "svg-3" }], ["path", { "d": "M18 10l0 .01", "key": "svg-4" }], ["path", { "d": "M6 14l0 .01", "key": "svg-5" }], ["path", { "d": "M18 14l0 .01", "key": "svg-6" }], ["path", { "d": "M10 14l4 0", "key": "svg-7" }], ["path", { "d": "M3 3l18 18", "key": "svg-8" }]]);

var IconKeyboardOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyboardOff
});

var IconKeyboardShow = createReactComponent("outline", "keyboard-show", "IconKeyboardShow", [["path", { "d": "M2 3m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M6 7l0 .01", "key": "svg-1" }], ["path", { "d": "M10 7l0 .01", "key": "svg-2" }], ["path", { "d": "M14 7l0 .01", "key": "svg-3" }], ["path", { "d": "M18 7l0 .01", "key": "svg-4" }], ["path", { "d": "M6 11l0 .01", "key": "svg-5" }], ["path", { "d": "M18 11l0 .01", "key": "svg-6" }], ["path", { "d": "M10 11l4 0", "key": "svg-7" }], ["path", { "d": "M10 19l2 2l2 -2", "key": "svg-8" }]]);

var IconKeyboardShow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyboardShow
});

var IconKeyboard = createReactComponent("outline", "keyboard", "IconKeyboard", [["path", { "d": "M2 6m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M6 10l0 .01", "key": "svg-1" }], ["path", { "d": "M10 10l0 .01", "key": "svg-2" }], ["path", { "d": "M14 10l0 .01", "key": "svg-3" }], ["path", { "d": "M18 10l0 .01", "key": "svg-4" }], ["path", { "d": "M6 14l0 .01", "key": "svg-5" }], ["path", { "d": "M18 14l0 .01", "key": "svg-6" }], ["path", { "d": "M10 14l4 .01", "key": "svg-7" }]]);

var IconKeyboard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyboard
});

var IconKeyframeAlignCenter = createReactComponent("outline", "keyframe-align-center", "IconKeyframeAlignCenter", [["path", { "d": "M12 20v2", "key": "svg-0" }], ["path", { "d": "M12.816 16.58c-.207 .267 -.504 .42 -.816 .42c-.312 0 -.61 -.153 -.816 -.42l-2.908 -3.748a1.39 1.39 0 0 1 0 -1.664l2.908 -3.748c.207 -.267 .504 -.42 .816 -.42c.312 0 .61 .153 .816 .42l2.908 3.748a1.39 1.39 0 0 1 0 1.664l-2.908 3.748z", "key": "svg-1" }], ["path", { "d": "M12 2v2", "key": "svg-2" }], ["path", { "d": "M3 12h2", "key": "svg-3" }], ["path", { "d": "M19 12h2", "key": "svg-4" }]]);

var IconKeyframeAlignCenter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyframeAlignCenter
});

var IconKeyframeAlignHorizontal = createReactComponent("outline", "keyframe-align-horizontal", "IconKeyframeAlignHorizontal", [["path", { "d": "M12.816 16.58c-.207 .267 -.504 .42 -.816 .42c-.312 0 -.61 -.153 -.816 -.42l-2.908 -3.748a1.39 1.39 0 0 1 0 -1.664l2.908 -3.748c.207 -.267 .504 -.42 .816 -.42c.312 0 .61 .153 .816 .42l2.908 3.748a1.39 1.39 0 0 1 0 1.664l-2.908 3.748z", "key": "svg-0" }], ["path", { "d": "M3 12h2", "key": "svg-1" }], ["path", { "d": "M19 12h2", "key": "svg-2" }]]);

var IconKeyframeAlignHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyframeAlignHorizontal
});

var IconKeyframeAlignVertical = createReactComponent("outline", "keyframe-align-vertical", "IconKeyframeAlignVertical", [["path", { "d": "M12 2v2", "key": "svg-0" }], ["path", { "d": "M12.816 16.58c-.207 .267 -.504 .42 -.816 .42c-.312 0 -.61 -.153 -.816 -.42l-2.908 -3.748a1.39 1.39 0 0 1 0 -1.664l2.908 -3.748c.207 -.267 .504 -.42 .816 -.42c.312 0 .61 .153 .816 .42l2.908 3.748a1.39 1.39 0 0 1 0 1.664l-2.908 3.748z", "key": "svg-1" }], ["path", { "d": "M12 20v2", "key": "svg-2" }]]);

var IconKeyframeAlignVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyframeAlignVertical
});

var IconKeyframe = createReactComponent("outline", "keyframe", "IconKeyframe", [["path", { "d": "M13.225 18.412a1.595 1.595 0 0 1 -1.225 .588c-.468 0 -.914 -.214 -1.225 -.588l-4.361 -5.248a1.844 1.844 0 0 1 0 -2.328l4.361 -5.248a1.595 1.595 0 0 1 1.225 -.588c.468 0 .914 .214 1.225 .588l4.361 5.248a1.844 1.844 0 0 1 0 2.328l-4.361 5.248z", "key": "svg-0" }]]);

var IconKeyframe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyframe
});

var IconKeyframes = createReactComponent("outline", "keyframes", "IconKeyframes", [["path", { "d": "M9.225 18.412a1.595 1.595 0 0 1 -1.225 .588c-.468 0 -.914 -.214 -1.225 -.588l-4.361 -5.248a1.844 1.844 0 0 1 0 -2.328l4.361 -5.248a1.595 1.595 0 0 1 1.225 -.588c.468 0 .914 .214 1.225 .588l4.361 5.248a1.844 1.844 0 0 1 0 2.328l-4.361 5.248z", "key": "svg-0" }], ["path", { "d": "M17 5l4.586 5.836a1.844 1.844 0 0 1 0 2.328l-4.586 5.836", "key": "svg-1" }], ["path", { "d": "M13 5l4.586 5.836a1.844 1.844 0 0 1 0 2.328l-4.586 5.836", "key": "svg-2" }]]);

var IconKeyframes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyframes
});

var IconLabelImportant = createReactComponent("outline", "label-important", "IconLabelImportant", [["path", { "d": "M16.52 7h-12.52l4 5l-4 5h12.52a1 1 0 0 0 .78 -.375l3.7 -4.625l-3.7 -4.625a1 1 0 0 0 -.78 -.375", "key": "svg-0" }]]);

var IconLabelImportant$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLabelImportant
});

var IconLabelOff = createReactComponent("outline", "label-off", "IconLabelOff", [["path", { "d": "M7 7h-1a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h10.52a1 1 0 0 0 .394 -.081m1.86 -2.137l2.226 -2.782l-3.7 -4.625a1 1 0 0 0 -.78 -.375h-5.52", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconLabelOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLabelOff
});

var IconLabel = createReactComponent("outline", "label", "IconLabel", [["path", { "d": "M16.52 7h-10.52a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h10.52a1 1 0 0 0 .78 -.375l3.7 -4.625l-3.7 -4.625a1 1 0 0 0 -.78 -.375", "key": "svg-0" }]]);

var IconLabel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLabel
});

var IconLadderOff = createReactComponent("outline", "ladder-off", "IconLadderOff", [["path", { "d": "M8 3v1m0 4v13", "key": "svg-0" }], ["path", { "d": "M16 3v9m0 4v5", "key": "svg-1" }], ["path", { "d": "M8 14h6", "key": "svg-2" }], ["path", { "d": "M8 10h2m4 0h2", "key": "svg-3" }], ["path", { "d": "M10 6h6", "key": "svg-4" }], ["path", { "d": "M8 18h8", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconLadderOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLadderOff
});

var IconLadder = createReactComponent("outline", "ladder", "IconLadder", [["path", { "d": "M8 3v18", "key": "svg-0" }], ["path", { "d": "M16 3v18", "key": "svg-1" }], ["path", { "d": "M8 14h8", "key": "svg-2" }], ["path", { "d": "M8 10h8", "key": "svg-3" }], ["path", { "d": "M8 6h8", "key": "svg-4" }], ["path", { "d": "M8 18h8", "key": "svg-5" }]]);

var IconLadder$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLadder
});

var IconLadle = createReactComponent("outline", "ladle", "IconLadle", [["path", { "d": "M3 14v1a6 6 0 1 0 12 0v-9a3 3 0 0 1 6 0", "key": "svg-0" }], ["path", { "d": "M9 16c-.663 0 -1.3 -.036 -1.896 -.102l-.5 -.064c-2.123 -.308 -3.604 -1.013 -3.604 -1.834c0 -.82 1.482 -1.526 3.603 -1.834l.5 -.064a17.27 17.27 0 0 1 1.897 -.102c.663 0 1.3 .036 1.896 .102l.5 .064c2.123 .308 3.604 1.013 3.604 1.834c0 .82 -1.482 1.526 -3.603 1.834l-.5 .064a17.27 17.27 0 0 1 -1.897 .102z", "key": "svg-1" }]]);

var IconLadle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLadle
});

var IconLambda = createReactComponent("outline", "lambda", "IconLambda", [["path", { "d": "M6 20l6.5 -9", "key": "svg-0" }], ["path", { "d": "M19 20c-6 0 -6 -16 -12 -16", "key": "svg-1" }]]);

var IconLambda$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLambda
});

var IconLamp2 = createReactComponent("outline", "lamp-2", "IconLamp2", [["path", { "d": "M5 21h9", "key": "svg-0" }], ["path", { "d": "M10 21l-7 -8l8.5 -5.5", "key": "svg-1" }], ["path", { "d": "M13 14c-2.148 -2.148 -2.148 -5.852 0 -8c2.088 -2.088 5.842 -1.972 8 0l-8 8z", "key": "svg-2" }], ["path", { "d": "M11.742 7.574l-1.156 -1.156a2 2 0 0 1 2.828 -2.829l1.144 1.144", "key": "svg-3" }], ["path", { "d": "M15.5 12l.208 .274a2.527 2.527 0 0 0 3.556 0c.939 -.933 .98 -2.42 .122 -3.4l-.366 -.369", "key": "svg-4" }]]);

var IconLamp2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLamp2
});

var IconLampOff = createReactComponent("outline", "lamp-off", "IconLampOff", [["path", { "d": "M9 20h6", "key": "svg-0" }], ["path", { "d": "M12 20v-8", "key": "svg-1" }], ["path", { "d": "M7.325 7.35l-2.325 4.65h7m4 0h3l-4 -8h-6l-.338 .676", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconLampOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLampOff
});

var IconLamp = createReactComponent("outline", "lamp", "IconLamp", [["path", { "d": "M9 20h6", "key": "svg-0" }], ["path", { "d": "M12 20v-8", "key": "svg-1" }], ["path", { "d": "M5 12h14l-4 -8h-6z", "key": "svg-2" }]]);

var IconLamp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLamp
});

var IconLane = createReactComponent("outline", "lane", "IconLane", [["path", { "d": "M4 6v13", "key": "svg-0" }], ["path", { "d": "M20 6v13", "key": "svg-1" }]]);

var IconLane$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLane
});

var IconLanguageHiragana = createReactComponent("outline", "language-hiragana", "IconLanguageHiragana", [["path", { "d": "M4 5h7", "key": "svg-0" }], ["path", { "d": "M7 4c0 4.846 0 7 .5 8", "key": "svg-1" }], ["path", { "d": "M10 8.5c0 2.286 -2 4.5 -3.5 4.5s-2.5 -1.135 -2.5 -2c0 -2 1 -3 3 -3s5 .57 5 2.857c0 1.524 -.667 2.571 -2 3.143", "key": "svg-2" }], ["path", { "d": "M12 20l4 -9l4 9", "key": "svg-3" }], ["path", { "d": "M19.1 18h-6.2", "key": "svg-4" }]]);

var IconLanguageHiragana$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLanguageHiragana
});

var IconLanguageKatakana = createReactComponent("outline", "language-katakana", "IconLanguageKatakana", [["path", { "d": "M5 5h6.586a1 1 0 0 1 .707 1.707l-1.293 1.293", "key": "svg-0" }], ["path", { "d": "M8 8c0 1.5 .5 3 -2 5", "key": "svg-1" }], ["path", { "d": "M12 20l4 -9l4 9", "key": "svg-2" }], ["path", { "d": "M19.1 18h-6.2", "key": "svg-3" }]]);

var IconLanguageKatakana$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLanguageKatakana
});

var IconLanguageOff = createReactComponent("outline", "language-off", "IconLanguageOff", [["path", { "d": "M4 5h1m4 0h2", "key": "svg-0" }], ["path", { "d": "M9 3v2m-.508 3.517c-.814 2.655 -2.52 4.483 -4.492 4.483", "key": "svg-1" }], ["path", { "d": "M5 9c0 2.144 2.952 3.908 6.7 4", "key": "svg-2" }], ["path", { "d": "M12 20l2.463 -5.541m1.228 -2.764l.309 -.695l.8 1.8", "key": "svg-3" }], ["path", { "d": "M18 18h-5.1", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconLanguageOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLanguageOff
});

var IconLanguage = createReactComponent("outline", "language", "IconLanguage", [["path", { "d": "M4 5h7", "key": "svg-0" }], ["path", { "d": "M9 3v2c0 4.418 -2.239 8 -5 8", "key": "svg-1" }], ["path", { "d": "M5 9c0 2.144 2.952 3.908 6.7 4", "key": "svg-2" }], ["path", { "d": "M12 20l4 -9l4 9", "key": "svg-3" }], ["path", { "d": "M19.1 18h-6.2", "key": "svg-4" }]]);

var IconLanguage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLanguage
});

var IconLassoOff = createReactComponent("outline", "lasso-off", "IconLassoOff", [["path", { "d": "M4.028 13.252c-.657 -.972 -1.028 -2.078 -1.028 -3.252c0 -1.804 .878 -3.449 2.319 -4.69m2.49 -1.506a11.066 11.066 0 0 1 4.191 -.804c4.97 0 9 3.134 9 7c0 1.799 -.873 3.44 -2.307 4.68m-2.503 1.517a11.066 11.066 0 0 1 -4.19 .803c-1.913 0 -3.686 -.464 -5.144 -1.255", "key": "svg-0" }], ["path", { "d": "M5 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 17c0 1.42 .316 2.805 1 4", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconLassoOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLassoOff
});

var IconLassoPolygon = createReactComponent("outline", "lasso-polygon", "IconLassoPolygon", [["path", { "d": "M4.028 13.252l-1.028 -3.252l2 -7l7 5l8 -3l1 9l-9 3l-5.144 -1.255", "key": "svg-0" }], ["path", { "d": "M5 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 17c0 1.42 .316 2.805 1 4", "key": "svg-2" }]]);

var IconLassoPolygon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLassoPolygon
});

var IconLasso = createReactComponent("outline", "lasso", "IconLasso", [["path", { "d": "M4.028 13.252c-.657 -.972 -1.028 -2.078 -1.028 -3.252c0 -3.866 4.03 -7 9 -7s9 3.134 9 7s-4.03 7 -9 7c-1.913 0 -3.686 -.464 -5.144 -1.255", "key": "svg-0" }], ["path", { "d": "M5 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 17c0 1.42 .316 2.805 1 4", "key": "svg-2" }]]);

var IconLasso$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLasso
});

var IconLaurelWreath1 = createReactComponent("outline", "laurel-wreath-1", "IconLaurelWreath1", [["path", { "d": "M6.436 8a8.6 8.6 0 0 0 -.436 2.727c0 4.017 2.686 7.273 6 7.273s6 -3.256 6 -7.273a8.6 8.6 0 0 0 -.436 -2.727", "key": "svg-0" }], ["path", { "d": "M14.5 21s-.682 -3 -2.5 -3s-2.5 3 -2.5 3", "key": "svg-1" }], ["path", { "d": "M18.52 5.23c.292 1.666 -1.02 2.77 -1.02 2.77s-1.603 -.563 -1.895 -2.23c-.292 -1.666 1.02 -2.77 1.02 -2.77s1.603 .563 1.895 2.23", "key": "svg-2" }], ["path", { "d": "M21.094 12.14c-1.281 1.266 -3.016 .76 -3.016 .76s-.454 -1.772 .828 -3.04c1.28 -1.266 3.016 -.76 3.016 -.76s.454 1.772 -.828 3.04", "key": "svg-3" }], ["path", { "d": "M17.734 18.826c-1.5 -.575 -1.734 -2.19 -1.734 -2.19s1.267 -1.038 2.767 -.462c1.5 .575 1.733 2.19 1.733 2.19s-1.267 1.038 -2.767 .462", "key": "svg-4" }], ["path", { "d": "M6.267 18.826c1.5 -.575 1.733 -2.19 1.733 -2.19s-1.267 -1.038 -2.767 -.462c-1.5 .575 -1.733 2.19 -1.733 2.19s1.267 1.038 2.767 .462", "key": "svg-5" }], ["path", { "d": "M2.906 12.14c1.281 1.266 3.016 .76 3.016 .76s.454 -1.772 -.828 -3.04c-1.281 -1.265 -3.016 -.76 -3.016 -.76s-.454 1.772 .828 3.04", "key": "svg-6" }], ["path", { "d": "M5.48 5.23c-.292 1.666 1.02 2.77 1.02 2.77s1.603 -.563 1.895 -2.23c.292 -1.666 -1.02 -2.77 -1.02 -2.77s-1.603 .563 -1.895 2.23", "key": "svg-7" }], ["path", { "d": "M11 9l1 -1v6", "key": "svg-8" }]]);

var IconLaurelWreath1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLaurelWreath1
});

var IconLaurelWreath2 = createReactComponent("outline", "laurel-wreath-2", "IconLaurelWreath2", [["path", { "d": "M6.436 8a8.6 8.6 0 0 0 -.436 2.727c0 4.017 2.686 7.273 6 7.273s6 -3.256 6 -7.273a8.6 8.6 0 0 0 -.436 -2.727", "key": "svg-0" }], ["path", { "d": "M14.5 21s-.682 -3 -2.5 -3s-2.5 3 -2.5 3", "key": "svg-1" }], ["path", { "d": "M18.52 5.23c.292 1.666 -1.02 2.77 -1.02 2.77s-1.603 -.563 -1.895 -2.23c-.292 -1.666 1.02 -2.77 1.02 -2.77s1.603 .563 1.895 2.23", "key": "svg-2" }], ["path", { "d": "M21.094 12.14c-1.281 1.266 -3.016 .76 -3.016 .76s-.454 -1.772 .828 -3.04c1.28 -1.266 3.016 -.76 3.016 -.76s.454 1.772 -.828 3.04", "key": "svg-3" }], ["path", { "d": "M17.734 18.826c-1.5 -.575 -1.734 -2.19 -1.734 -2.19s1.267 -1.038 2.767 -.462c1.5 .575 1.733 2.19 1.733 2.19s-1.267 1.038 -2.767 .462", "key": "svg-4" }], ["path", { "d": "M6.267 18.826c1.5 -.575 1.733 -2.19 1.733 -2.19s-1.267 -1.038 -2.767 -.462c-1.5 .575 -1.733 2.19 -1.733 2.19s1.267 1.038 2.767 .462", "key": "svg-5" }], ["path", { "d": "M2.906 12.14c1.281 1.266 3.016 .76 3.016 .76s.454 -1.772 -.828 -3.04c-1.281 -1.265 -3.016 -.76 -3.016 -.76s-.454 1.772 .828 3.04", "key": "svg-6" }], ["path", { "d": "M5.48 5.23c-.292 1.666 1.02 2.77 1.02 2.77s1.603 -.563 1.895 -2.23c.292 -1.666 -1.02 -2.77 -1.02 -2.77s-1.603 .563 -1.895 2.23", "key": "svg-7" }], ["path", { "d": "M10.6 8h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2", "key": "svg-8" }]]);

var IconLaurelWreath2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLaurelWreath2
});

var IconLaurelWreath3 = createReactComponent("outline", "laurel-wreath-3", "IconLaurelWreath3", [["path", { "d": "M6.436 8a8.6 8.6 0 0 0 -.436 2.727c0 4.017 2.686 7.273 6 7.273s6 -3.256 6 -7.273a8.6 8.6 0 0 0 -.436 -2.727", "key": "svg-0" }], ["path", { "d": "M14.5 21s-.682 -3 -2.5 -3s-2.5 3 -2.5 3", "key": "svg-1" }], ["path", { "d": "M18.52 5.23c.292 1.666 -1.02 2.77 -1.02 2.77s-1.603 -.563 -1.895 -2.23c-.292 -1.666 1.02 -2.77 1.02 -2.77s1.603 .563 1.895 2.23", "key": "svg-2" }], ["path", { "d": "M21.094 12.14c-1.281 1.266 -3.016 .76 -3.016 .76s-.454 -1.772 .828 -3.04c1.28 -1.266 3.016 -.76 3.016 -.76s.454 1.772 -.828 3.04", "key": "svg-3" }], ["path", { "d": "M17.734 18.826c-1.5 -.575 -1.734 -2.19 -1.734 -2.19s1.267 -1.038 2.767 -.462c1.5 .575 1.733 2.19 1.733 2.19s-1.267 1.038 -2.767 .462", "key": "svg-4" }], ["path", { "d": "M6.267 18.826c1.5 -.575 1.733 -2.19 1.733 -2.19s-1.267 -1.038 -2.767 -.462c-1.5 .575 -1.733 2.19 -1.733 2.19s1.267 1.038 2.767 .462", "key": "svg-5" }], ["path", { "d": "M2.906 12.14c1.281 1.266 3.016 .76 3.016 .76s.454 -1.772 -.828 -3.04c-1.281 -1.265 -3.016 -.76 -3.016 -.76s-.454 1.772 .828 3.04", "key": "svg-6" }], ["path", { "d": "M5.48 5.23c-.292 1.666 1.02 2.77 1.02 2.77s1.603 -.563 1.895 -2.23c.292 -1.666 -1.02 -2.77 -1.02 -2.77s-1.603 .563 -1.895 2.23", "key": "svg-7" }], ["path", { "d": "M10.5 8h1.5a1.5 1.5 0 0 1 0 3h-1h1a1.5 1.5 0 0 1 0 3h-1.5", "key": "svg-8" }]]);

var IconLaurelWreath3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLaurelWreath3
});

var IconLaurelWreath = createReactComponent("outline", "laurel-wreath", "IconLaurelWreath", [["path", { "d": "M6.436 8a8.6 8.6 0 0 0 -.436 2.727c0 4.017 2.686 7.273 6 7.273s6 -3.256 6 -7.273a8.6 8.6 0 0 0 -.436 -2.727", "key": "svg-0" }], ["path", { "d": "M14.5 21s-.682 -3 -2.5 -3s-2.5 3 -2.5 3", "key": "svg-1" }], ["path", { "d": "M18.52 5.23c.292 1.666 -1.02 2.77 -1.02 2.77s-1.603 -.563 -1.895 -2.23c-.292 -1.666 1.02 -2.77 1.02 -2.77s1.603 .563 1.895 2.23", "key": "svg-2" }], ["path", { "d": "M21.094 12.14c-1.281 1.266 -3.016 .76 -3.016 .76s-.454 -1.772 .828 -3.04c1.28 -1.266 3.016 -.76 3.016 -.76s.454 1.772 -.828 3.04", "key": "svg-3" }], ["path", { "d": "M17.734 18.826c-1.5 -.575 -1.734 -2.19 -1.734 -2.19s1.267 -1.038 2.767 -.462c1.5 .575 1.733 2.19 1.733 2.19s-1.267 1.038 -2.767 .462", "key": "svg-4" }], ["path", { "d": "M6.267 18.826c1.5 -.575 1.733 -2.19 1.733 -2.19s-1.267 -1.038 -2.767 -.462c-1.5 .575 -1.733 2.19 -1.733 2.19s1.267 1.038 2.767 .462", "key": "svg-5" }], ["path", { "d": "M2.906 12.14c1.281 1.266 3.016 .76 3.016 .76s.454 -1.772 -.828 -3.04c-1.281 -1.265 -3.016 -.76 -3.016 -.76s-.454 1.772 .828 3.04", "key": "svg-6" }], ["path", { "d": "M5.48 5.23c-.292 1.666 1.02 2.77 1.02 2.77s1.603 -.563 1.895 -2.23c.292 -1.666 -1.02 -2.77 -1.02 -2.77s-1.603 .563 -1.895 2.23", "key": "svg-7" }]]);

var IconLaurelWreath$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLaurelWreath
});

var IconLayersDifference = createReactComponent("outline", "layers-difference", "IconLayersDifference", [["path", { "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2", "key": "svg-0" }], ["path", { "d": "M10 8l-2 0l0 2", "key": "svg-1" }], ["path", { "d": "M8 14l0 2l2 0", "key": "svg-2" }], ["path", { "d": "M14 8l2 0l0 2", "key": "svg-3" }], ["path", { "d": "M16 14l0 2l-2 0", "key": "svg-4" }]]);

var IconLayersDifference$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayersDifference
});

var IconLayersIntersect2 = createReactComponent("outline", "layers-intersect-2", "IconLayersIntersect2", [["path", { "d": "M8 4m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M9 15l6 -6", "key": "svg-2" }]]);

var IconLayersIntersect2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayersIntersect2
});

var IconLayersIntersect = createReactComponent("outline", "layers-intersect", "IconLayersIntersect", [["path", { "d": "M8 4m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconLayersIntersect$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayersIntersect
});

var IconLayersLinked = createReactComponent("outline", "layers-linked", "IconLayersLinked", [["path", { "d": "M19 8.268a2 2 0 0 1 1 1.732v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h3", "key": "svg-0" }], ["path", { "d": "M5 15.734a2 2 0 0 1 -1 -1.734v-8a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-3", "key": "svg-1" }]]);

var IconLayersLinked$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayersLinked
});

var IconLayersOff = createReactComponent("outline", "layers-off", "IconLayersOff", [["path", { "d": "M8.59 4.581c.362 -.359 .86 -.581 1.41 -.581h8a2 2 0 0 1 2 2v8c0 .556 -.227 1.06 -.594 1.422m-3.406 .578h-6a2 2 0 0 1 -2 -2v-6", "key": "svg-0" }], ["path", { "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconLayersOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayersOff
});

var IconLayersSelectedBottom = createReactComponent("outline", "layers-selected-bottom", "IconLayersSelectedBottom", [["path", { "d": "M4 14.5l4 -4", "key": "svg-0" }], ["path", { "d": "M9.496 20l4.004 -4z", "key": "svg-1" }], ["path", { "d": "M4.586 19.414l3.914 -3.914", "key": "svg-2" }], ["path", { "d": "M8 6a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-3" }], ["path", { "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2", "key": "svg-4" }]]);

var IconLayersSelectedBottom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayersSelectedBottom
});

var IconLayersSelected = createReactComponent("outline", "layers-selected", "IconLayersSelected", [["path", { "d": "M8 10.5l6.492 -6.492", "key": "svg-0" }], ["path", { "d": "M13.496 16l6.504 -6.504z", "key": "svg-1" }], ["path", { "d": "M8.586 15.414l10.827 -10.827", "key": "svg-2" }], ["path", { "d": "M8 6a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-3" }], ["path", { "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2", "key": "svg-4" }]]);

var IconLayersSelected$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayersSelected
});

var IconLayersSubtract = createReactComponent("outline", "layers-subtract", "IconLayersSubtract", [["path", { "d": "M8 4m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2", "key": "svg-1" }]]);

var IconLayersSubtract$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayersSubtract
});

var IconLayersUnion = createReactComponent("outline", "layers-union", "IconLayersUnion", [["path", { "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2", "key": "svg-0" }]]);

var IconLayersUnion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayersUnion
});

var IconLayout2 = createReactComponent("outline", "layout-2", "IconLayout2", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 13m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M14 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-2" }], ["path", { "d": "M14 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-3" }]]);

var IconLayout2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayout2
});

var IconLayoutAlignBottom = createReactComponent("outline", "layout-align-bottom", "IconLayoutAlignBottom", [["path", { "d": "M4 20l16 0", "key": "svg-0" }], ["path", { "d": "M9 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconLayoutAlignBottom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutAlignBottom
});

var IconLayoutAlignCenter = createReactComponent("outline", "layout-align-center", "IconLayoutAlignCenter", [["path", { "d": "M12 4l0 5", "key": "svg-0" }], ["path", { "d": "M12 15l0 5", "key": "svg-1" }], ["path", { "d": "M6 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconLayoutAlignCenter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutAlignCenter
});

var IconLayoutAlignLeft = createReactComponent("outline", "layout-align-left", "IconLayoutAlignLeft", [["path", { "d": "M4 4l0 16", "key": "svg-0" }], ["path", { "d": "M8 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconLayoutAlignLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutAlignLeft
});

var IconLayoutAlignMiddle = createReactComponent("outline", "layout-align-middle", "IconLayoutAlignMiddle", [["path", { "d": "M4 12l5 0", "key": "svg-0" }], ["path", { "d": "M15 12l5 0", "key": "svg-1" }], ["path", { "d": "M9 6m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconLayoutAlignMiddle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutAlignMiddle
});

var IconLayoutAlignRight = createReactComponent("outline", "layout-align-right", "IconLayoutAlignRight", [["path", { "d": "M20 4l0 16", "key": "svg-0" }], ["path", { "d": "M4 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconLayoutAlignRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutAlignRight
});

var IconLayoutAlignTop = createReactComponent("outline", "layout-align-top", "IconLayoutAlignTop", [["path", { "d": "M4 4l16 0", "key": "svg-0" }], ["path", { "d": "M9 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconLayoutAlignTop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutAlignTop
});

var IconLayoutBoardSplit = createReactComponent("outline", "layout-board-split", "IconLayoutBoardSplit", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 12h8", "key": "svg-1" }], ["path", { "d": "M12 15h8", "key": "svg-2" }], ["path", { "d": "M12 9h8", "key": "svg-3" }], ["path", { "d": "M12 4v16", "key": "svg-4" }]]);

var IconLayoutBoardSplit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutBoardSplit
});

var IconLayoutBoard = createReactComponent("outline", "layout-board", "IconLayoutBoard", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 9h8", "key": "svg-1" }], ["path", { "d": "M12 15h8", "key": "svg-2" }], ["path", { "d": "M12 4v16", "key": "svg-3" }]]);

var IconLayoutBoard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutBoard
});

var IconLayoutBottombarCollapse = createReactComponent("outline", "layout-bottombar-collapse", "IconLayoutBottombarCollapse", [["path", { "d": "M20 6v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2z", "key": "svg-0" }], ["path", { "d": "M20 15h-16", "key": "svg-1" }], ["path", { "d": "M14 8l-2 2l-2 -2", "key": "svg-2" }]]);

var IconLayoutBottombarCollapse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutBottombarCollapse
});

var IconLayoutBottombarExpand = createReactComponent("outline", "layout-bottombar-expand", "IconLayoutBottombarExpand", [["path", { "d": "M20 6v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2z", "key": "svg-0" }], ["path", { "d": "M20 15h-16", "key": "svg-1" }], ["path", { "d": "M14 10l-2 -2l-2 2", "key": "svg-2" }]]);

var IconLayoutBottombarExpand$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutBottombarExpand
});

var IconLayoutBottombarInactive = createReactComponent("outline", "layout-bottombar-inactive", "IconLayoutBottombarInactive", [["path", { "d": "M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z", "key": "svg-0" }], ["path", { "d": "M4 15h1", "key": "svg-1" }], ["path", { "d": "M19 15h1", "key": "svg-2" }], ["path", { "d": "M9 15h1", "key": "svg-3" }], ["path", { "d": "M14 15h1", "key": "svg-4" }]]);

var IconLayoutBottombarInactive$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutBottombarInactive
});

var IconLayoutBottombar = createReactComponent("outline", "layout-bottombar", "IconLayoutBottombar", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 15l16 0", "key": "svg-1" }]]);

var IconLayoutBottombar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutBottombar
});

var IconLayoutCards = createReactComponent("outline", "layout-cards", "IconLayoutCards", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconLayoutCards$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutCards
});

var IconLayoutCollage = createReactComponent("outline", "layout-collage", "IconLayoutCollage", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 4l4 16", "key": "svg-1" }], ["path", { "d": "M12 12l-8 2", "key": "svg-2" }]]);

var IconLayoutCollage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutCollage
});

var IconLayoutColumns = createReactComponent("outline", "layout-columns", "IconLayoutColumns", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 4l0 16", "key": "svg-1" }]]);

var IconLayoutColumns$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutColumns
});

var IconLayoutDashboard = createReactComponent("outline", "layout-dashboard", "IconLayoutDashboard", [["path", { "d": "M5 4h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1", "key": "svg-0" }], ["path", { "d": "M5 16h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1", "key": "svg-1" }], ["path", { "d": "M15 12h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1", "key": "svg-2" }], ["path", { "d": "M15 4h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1", "key": "svg-3" }]]);

var IconLayoutDashboard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutDashboard
});

var IconLayoutDistributeHorizontal = createReactComponent("outline", "layout-distribute-horizontal", "IconLayoutDistributeHorizontal", [["path", { "d": "M4 4l16 0", "key": "svg-0" }], ["path", { "d": "M4 20l16 0", "key": "svg-1" }], ["path", { "d": "M6 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconLayoutDistributeHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutDistributeHorizontal
});

var IconLayoutDistributeVertical = createReactComponent("outline", "layout-distribute-vertical", "IconLayoutDistributeVertical", [["path", { "d": "M4 4l0 16", "key": "svg-0" }], ["path", { "d": "M20 4l0 16", "key": "svg-1" }], ["path", { "d": "M9 6m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconLayoutDistributeVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutDistributeVertical
});

var IconLayoutGridAdd = createReactComponent("outline", "layout-grid-add", "IconLayoutGridAdd", [["path", { "d": "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M14 17h6m-3 -3v6", "key": "svg-3" }]]);

var IconLayoutGridAdd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutGridAdd
});

var IconLayoutGridRemove = createReactComponent("outline", "layout-grid-remove", "IconLayoutGridRemove", [["path", { "d": "M4 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z", "key": "svg-0" }], ["path", { "d": "M14 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z", "key": "svg-1" }], ["path", { "d": "M4 15a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z", "key": "svg-2" }], ["path", { "d": "M14 17h6", "key": "svg-3" }]]);

var IconLayoutGridRemove$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutGridRemove
});

var IconLayoutGrid = createReactComponent("outline", "layout-grid", "IconLayoutGrid", [["path", { "d": "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-3" }]]);

var IconLayoutGrid$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutGrid
});

var IconLayoutKanban = createReactComponent("outline", "layout-kanban", "IconLayoutKanban", [["path", { "d": "M4 4l6 0", "key": "svg-0" }], ["path", { "d": "M14 4l6 0", "key": "svg-1" }], ["path", { "d": "M4 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-2" }], ["path", { "d": "M14 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-3" }]]);

var IconLayoutKanban$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutKanban
});

var IconLayoutList = createReactComponent("outline", "layout-list", "IconLayoutList", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 14m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconLayoutList$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutList
});

var IconLayoutNavbarCollapse = createReactComponent("outline", "layout-navbar-collapse", "IconLayoutNavbarCollapse", [["path", { "d": "M4 18v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 9h16", "key": "svg-1" }], ["path", { "d": "M10 16l2 -2l2 2", "key": "svg-2" }]]);

var IconLayoutNavbarCollapse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutNavbarCollapse
});

var IconLayoutNavbarExpand = createReactComponent("outline", "layout-navbar-expand", "IconLayoutNavbarExpand", [["path", { "d": "M4 18v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 9h16", "key": "svg-1" }], ["path", { "d": "M10 14l2 2l2 -2", "key": "svg-2" }]]);

var IconLayoutNavbarExpand$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutNavbarExpand
});

var IconLayoutNavbarInactive = createReactComponent("outline", "layout-navbar-inactive", "IconLayoutNavbarInactive", [["path", { "d": "M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z", "key": "svg-0" }], ["path", { "d": "M4 9h1", "key": "svg-1" }], ["path", { "d": "M19 9h1", "key": "svg-2" }], ["path", { "d": "M9 9h1", "key": "svg-3" }], ["path", { "d": "M14 9h1", "key": "svg-4" }]]);

var IconLayoutNavbarInactive$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutNavbarInactive
});

var IconLayoutNavbar = createReactComponent("outline", "layout-navbar", "IconLayoutNavbar", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 9l16 0", "key": "svg-1" }]]);

var IconLayoutNavbar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutNavbar
});

var IconLayoutOff = createReactComponent("outline", "layout-off", "IconLayoutOff", [["path", { "d": "M8 4a2 2 0 0 1 2 2m-1.162 2.816a1.993 1.993 0 0 1 -.838 .184h-2a2 2 0 0 1 -2 -2v-1c0 -.549 .221 -1.046 .58 -1.407", "key": "svg-0" }], ["path", { "d": "M4 13m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M14 10v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v10m-.595 3.423a2 2 0 0 1 -1.405 .577h-2a2 2 0 0 1 -2 -2v-4", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconLayoutOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutOff
});

var IconLayoutRows = createReactComponent("outline", "layout-rows", "IconLayoutRows", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 12l16 0", "key": "svg-1" }]]);

var IconLayoutRows$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutRows
});

var IconLayoutSidebarInactive = createReactComponent("outline", "layout-sidebar-inactive", "IconLayoutSidebarInactive", [["path", { "d": "M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z", "key": "svg-0" }], ["path", { "d": "M9 4v1", "key": "svg-1" }], ["path", { "d": "M9 9v1", "key": "svg-2" }], ["path", { "d": "M9 14v1", "key": "svg-3" }], ["path", { "d": "M9 19v1", "key": "svg-4" }]]);

var IconLayoutSidebarInactive$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarInactive
});

var IconLayoutSidebarLeftCollapse = createReactComponent("outline", "layout-sidebar-left-collapse", "IconLayoutSidebarLeftCollapse", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 4v16", "key": "svg-1" }], ["path", { "d": "M15 10l-2 2l2 2", "key": "svg-2" }]]);

var IconLayoutSidebarLeftCollapse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarLeftCollapse
});

var IconLayoutSidebarLeftExpand = createReactComponent("outline", "layout-sidebar-left-expand", "IconLayoutSidebarLeftExpand", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 4v16", "key": "svg-1" }], ["path", { "d": "M14 10l2 2l-2 2", "key": "svg-2" }]]);

var IconLayoutSidebarLeftExpand$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarLeftExpand
});

var IconLayoutSidebarRightCollapse = createReactComponent("outline", "layout-sidebar-right-collapse", "IconLayoutSidebarRightCollapse", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M15 4v16", "key": "svg-1" }], ["path", { "d": "M9 10l2 2l-2 2", "key": "svg-2" }]]);

var IconLayoutSidebarRightCollapse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarRightCollapse
});

var IconLayoutSidebarRightExpand = createReactComponent("outline", "layout-sidebar-right-expand", "IconLayoutSidebarRightExpand", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M15 4v16", "key": "svg-1" }], ["path", { "d": "M10 10l-2 2l2 2", "key": "svg-2" }]]);

var IconLayoutSidebarRightExpand$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarRightExpand
});

var IconLayoutSidebarRightInactive = createReactComponent("outline", "layout-sidebar-right-inactive", "IconLayoutSidebarRightInactive", [["path", { "d": "M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z", "key": "svg-0" }], ["path", { "d": "M15 4v1", "key": "svg-1" }], ["path", { "d": "M15 9v1", "key": "svg-2" }], ["path", { "d": "M15 14v1", "key": "svg-3" }], ["path", { "d": "M15 19v1", "key": "svg-4" }]]);

var IconLayoutSidebarRightInactive$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarRightInactive
});

var IconLayoutSidebarRight = createReactComponent("outline", "layout-sidebar-right", "IconLayoutSidebarRight", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M15 4l0 16", "key": "svg-1" }]]);

var IconLayoutSidebarRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarRight
});

var IconLayoutSidebar = createReactComponent("outline", "layout-sidebar", "IconLayoutSidebar", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 4l0 16", "key": "svg-1" }]]);

var IconLayoutSidebar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebar
});

var IconLayout = createReactComponent("outline", "layout", "IconLayout", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 13m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M14 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconLayout$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayout
});

var IconLeaf2 = createReactComponent("outline", "leaf-2", "IconLeaf2", [["path", { "d": "M5 21c.5 -4.5 2.5 -8 7 -10", "key": "svg-0" }], ["path", { "d": "M7.5 15q -3.5 0 -4.5 -6a8.4 8.4 0 0 1 3.438 .402a12 12 0 0 1 -.052 -.793c0 -3.606 3.204 -5.609 3.204 -5.609s2.003 1.252 2.842 3.557q 2.568 -1.557 6.568 -1.557q .396 3.775 -1.557 6.568c2.305 .839 3.557 2.842 3.557 2.842s-3 2.59 -7 2.59c0 1 0 1 .5 3q -6 0 -7 -5", "key": "svg-1" }]]);

var IconLeaf2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLeaf2
});

var IconLeafOff = createReactComponent("outline", "leaf-off", "IconLeafOff", [["path", { "d": "M5 21c.475 -4.27 2.3 -7.64 6.331 -9.683", "key": "svg-0" }], ["path", { "d": "M6.618 6.623c-1.874 1.625 -2.625 3.877 -2.632 6.377c0 1 0 3 2 5h3.014c2.733 0 5.092 -.635 6.92 -2.087m1.899 -2.099c1.224 -1.872 1.987 -4.434 2.181 -7.814v-2h-4.014c-2.863 0 -5.118 .405 -6.861 1.118", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconLeafOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLeafOff
});

var IconLeaf = createReactComponent("outline", "leaf", "IconLeaf", [["path", { "d": "M5 21c.5 -4.5 2.5 -8 7 -10", "key": "svg-0" }], ["path", { "d": "M9 18c6.218 0 10.5 -3.288 11 -12v-2h-4.014c-9 0 -11.986 4 -12 9c0 1 0 3 2 5h3z", "key": "svg-1" }]]);

var IconLeaf$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLeaf
});

var IconLegoOff = createReactComponent("outline", "lego-off", "IconLegoOff", [["path", { "d": "M9.5 11h.01", "key": "svg-0" }], ["path", { "d": "M9.5 15a3.5 3.5 0 0 0 5 0", "key": "svg-1" }], ["path", { "d": "M8 4v-1h8v2h1a3 3 0 0 1 3 3v8m-.884 3.127a2.99 2.99 0 0 1 -2.116 .873v1h-10v-1a3 3 0 0 1 -3 -3v-9c0 -1.083 .574 -2.032 1.435 -2.56", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconLegoOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLegoOff
});

var IconLego = createReactComponent("outline", "lego", "IconLego", [["path", { "d": "M9.5 11l.01 0", "key": "svg-0" }], ["path", { "d": "M14.5 11l.01 0", "key": "svg-1" }], ["path", { "d": "M9.5 15a3.5 3.5 0 0 0 5 0", "key": "svg-2" }], ["path", { "d": "M7 5h1v-2h8v2h1a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3v1h-10v-1a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3", "key": "svg-3" }]]);

var IconLego$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLego
});

var IconLemon2 = createReactComponent("outline", "lemon-2", "IconLemon2", [["path", { "d": "M18 4a2 2 0 0 1 1.185 3.611c1.55 2.94 .873 6.917 -1.892 9.682c-2.765 2.765 -6.743 3.442 -9.682 1.892a2 2 0 1 1 -2.796 -2.796c-1.55 -2.94 -.873 -6.917 1.892 -9.682c2.765 -2.765 6.743 -3.442 9.682 -1.892a2 2 0 0 1 1.611 -.815z", "key": "svg-0" }]]);

var IconLemon2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLemon2
});

var IconLemon = createReactComponent("outline", "lemon", "IconLemon", [["path", { "d": "M17.536 3.393c3.905 3.906 3.905 10.237 0 14.143c-3.906 3.905 -10.237 3.905 -14.143 0l14.143 -14.143", "key": "svg-0" }], ["path", { "d": "M5.868 15.06a6.5 6.5 0 0 0 9.193 -9.192", "key": "svg-1" }], ["path", { "d": "M10.464 10.464l4.597 4.597", "key": "svg-2" }], ["path", { "d": "M10.464 10.464v6.364", "key": "svg-3" }], ["path", { "d": "M10.464 10.464h6.364", "key": "svg-4" }]]);

var IconLemon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLemon
});

var IconLetterASmall = createReactComponent("outline", "letter-a-small", "IconLetterASmall", [["path", { "d": "M10 16v-6a2 2 0 1 1 4 0v6", "key": "svg-0" }], ["path", { "d": "M10 13h4", "key": "svg-1" }]]);

var IconLetterASmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterASmall
});

var IconLetterA = createReactComponent("outline", "letter-a", "IconLetterA", [["path", { "d": "M7 20v-12a4 4 0 0 1 4 -4h2a4 4 0 0 1 4 4v12", "key": "svg-0" }], ["path", { "d": "M7 13l10 0", "key": "svg-1" }]]);

var IconLetterA$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterA
});

var IconLetterBSmall = createReactComponent("outline", "letter-b-small", "IconLetterBSmall", [["path", { "d": "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z", "key": "svg-0" }]]);

var IconLetterBSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterBSmall
});

var IconLetterB = createReactComponent("outline", "letter-b", "IconLetterB", [["path", { "d": "M7 20v-16h6a4 4 0 0 1 0 8a4 4 0 0 1 0 8h-6", "key": "svg-0" }], ["path", { "d": "M7 12l6 0", "key": "svg-1" }]]);

var IconLetterB$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterB
});

var IconLetterCSmall = createReactComponent("outline", "letter-c-small", "IconLetterCSmall", [["path", { "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-0" }]]);

var IconLetterCSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterCSmall
});

var IconLetterC = createReactComponent("outline", "letter-c", "IconLetterC", [["path", { "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5", "key": "svg-0" }]]);

var IconLetterC$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterC
});

var IconLetterCaseLower = createReactComponent("outline", "letter-case-lower", "IconLetterCaseLower", [["path", { "d": "M6.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0", "key": "svg-0" }], ["path", { "d": "M10 12v7", "key": "svg-1" }], ["path", { "d": "M17.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0", "key": "svg-2" }], ["path", { "d": "M21 12v7", "key": "svg-3" }]]);

var IconLetterCaseLower$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterCaseLower
});

var IconLetterCaseToggle = createReactComponent("outline", "letter-case-toggle", "IconLetterCaseToggle", [["path", { "d": "M6.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0", "key": "svg-0" }], ["path", { "d": "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5", "key": "svg-1" }], ["path", { "d": "M14 13h7", "key": "svg-2" }], ["path", { "d": "M10 12v7", "key": "svg-3" }]]);

var IconLetterCaseToggle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterCaseToggle
});

var IconLetterCaseUpper = createReactComponent("outline", "letter-case-upper", "IconLetterCaseUpper", [["path", { "d": "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5", "key": "svg-0" }], ["path", { "d": "M3 13h7", "key": "svg-1" }], ["path", { "d": "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5", "key": "svg-2" }], ["path", { "d": "M14 13h7", "key": "svg-3" }]]);

var IconLetterCaseUpper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterCaseUpper
});

var IconLetterCase = createReactComponent("outline", "letter-case", "IconLetterCase", [["path", { "d": "M17.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0", "key": "svg-0" }], ["path", { "d": "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5", "key": "svg-1" }], ["path", { "d": "M3 13h7", "key": "svg-2" }], ["path", { "d": "M21 12v7", "key": "svg-3" }]]);

var IconLetterCase$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterCase
});

var IconLetterDSmall = createReactComponent("outline", "letter-d-small", "IconLetterDSmall", [["path", { "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", "key": "svg-0" }]]);

var IconLetterDSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterDSmall
});

var IconLetterD = createReactComponent("outline", "letter-d", "IconLetterD", [["path", { "d": "M7 4h6a5 5 0 0 1 5 5v6a5 5 0 0 1 -5 5h-6v-16", "key": "svg-0" }]]);

var IconLetterD$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterD
});

var IconLetterESmall = createReactComponent("outline", "letter-e-small", "IconLetterESmall", [["path", { "d": "M14 8h-4v8h4", "key": "svg-0" }], ["path", { "d": "M10 12h2.5", "key": "svg-1" }]]);

var IconLetterESmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterESmall
});

var IconLetterE = createReactComponent("outline", "letter-e", "IconLetterE", [["path", { "d": "M17 4h-10v16h10", "key": "svg-0" }], ["path", { "d": "M7 12l8 0", "key": "svg-1" }]]);

var IconLetterE$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterE
});

var IconLetterFSmall = createReactComponent("outline", "letter-f-small", "IconLetterFSmall", [["path", { "d": "M10 12h3", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8", "key": "svg-1" }]]);

var IconLetterFSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterFSmall
});

var IconLetterF = createReactComponent("outline", "letter-f", "IconLetterF", [["path", { "d": "M17 4h-10v16", "key": "svg-0" }], ["path", { "d": "M7 12l8 0", "key": "svg-1" }]]);

var IconLetterF$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterF
});

var IconLetterGSmall = createReactComponent("outline", "letter-g-small", "IconLetterGSmall", [["path", { "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }]]);

var IconLetterGSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterGSmall
});

var IconLetterG = createReactComponent("outline", "letter-g", "IconLetterG", [["path", { "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-2h-4", "key": "svg-0" }]]);

var IconLetterG$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterG
});

var IconLetterHSmall = createReactComponent("outline", "letter-h-small", "IconLetterHSmall", [["path", { "d": "M10 16v-8", "key": "svg-0" }], ["path", { "d": "M14 8v8", "key": "svg-1" }], ["path", { "d": "M10 12h4", "key": "svg-2" }]]);

var IconLetterHSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterHSmall
});

var IconLetterH = createReactComponent("outline", "letter-h", "IconLetterH", [["path", { "d": "M17 4l0 16", "key": "svg-0" }], ["path", { "d": "M7 12l10 0", "key": "svg-1" }], ["path", { "d": "M7 4l0 16", "key": "svg-2" }]]);

var IconLetterH$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterH
});

var IconLetterISmall = createReactComponent("outline", "letter-i-small", "IconLetterISmall", [["path", { "d": "M12 8v8", "key": "svg-0" }]]);

var IconLetterISmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterISmall
});

var IconLetterI = createReactComponent("outline", "letter-i", "IconLetterI", [["path", { "d": "M12 4l0 16", "key": "svg-0" }]]);

var IconLetterI$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterI
});

var IconLetterJSmall = createReactComponent("outline", "letter-j-small", "IconLetterJSmall", [["path", { "d": "M10 8h4v6a2 2 0 1 1 -4 0", "key": "svg-0" }]]);

var IconLetterJSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterJSmall
});

var IconLetterJ = createReactComponent("outline", "letter-j", "IconLetterJ", [["path", { "d": "M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4", "key": "svg-0" }]]);

var IconLetterJ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterJ
});

var IconLetterKSmall = createReactComponent("outline", "letter-k-small", "IconLetterKSmall", [["path", { "d": "M10.5 8v8", "key": "svg-0" }], ["path", { "d": "M14.5 8l-3 4l3 4", "key": "svg-1" }], ["path", { "d": "M10.5 12h1", "key": "svg-2" }]]);

var IconLetterKSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterKSmall
});

var IconLetterK = createReactComponent("outline", "letter-k", "IconLetterK", [["path", { "d": "M7 4l0 16", "key": "svg-0" }], ["path", { "d": "M7 12h2l8 -8", "key": "svg-1" }], ["path", { "d": "M9 12l8 8", "key": "svg-2" }]]);

var IconLetterK$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterK
});

var IconLetterLSmall = createReactComponent("outline", "letter-l-small", "IconLetterLSmall", [["path", { "d": "M10 8v8h4", "key": "svg-0" }]]);

var IconLetterLSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterLSmall
});

var IconLetterL = createReactComponent("outline", "letter-l", "IconLetterL", [["path", { "d": "M7 4v16h10", "key": "svg-0" }]]);

var IconLetterL$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterL
});

var IconLetterMSmall = createReactComponent("outline", "letter-m-small", "IconLetterMSmall", [["path", { "d": "M9 16v-8l3 5l3 -5v8", "key": "svg-0" }]]);

var IconLetterMSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterMSmall
});

var IconLetterM = createReactComponent("outline", "letter-m", "IconLetterM", [["path", { "d": "M6 20v-16l6 14l6 -14v16", "key": "svg-0" }]]);

var IconLetterM$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterM
});

var IconLetterNSmall = createReactComponent("outline", "letter-n-small", "IconLetterNSmall", [["path", { "d": "M10 16v-8l4 8v-8", "key": "svg-0" }]]);

var IconLetterNSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterNSmall
});

var IconLetterN = createReactComponent("outline", "letter-n", "IconLetterN", [["path", { "d": "M7 20v-16l10 16v-16", "key": "svg-0" }]]);

var IconLetterN$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterN
});

var IconLetterOSmall = createReactComponent("outline", "letter-o-small", "IconLetterOSmall", [["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-0" }]]);

var IconLetterOSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterOSmall
});

var IconLetterO = createReactComponent("outline", "letter-o", "IconLetterO", [["path", { "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6", "key": "svg-0" }]]);

var IconLetterO$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterO
});

var IconLetterPSmall = createReactComponent("outline", "letter-p-small", "IconLetterPSmall", [["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-0" }]]);

var IconLetterPSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterPSmall
});

var IconLetterP = createReactComponent("outline", "letter-p", "IconLetterP", [["path", { "d": "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5", "key": "svg-0" }]]);

var IconLetterP$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterP
});

var IconLetterQSmall = createReactComponent("outline", "letter-q-small", "IconLetterQSmall", [["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M13 15l1 1", "key": "svg-1" }]]);

var IconLetterQSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterQSmall
});

var IconLetterQ = createReactComponent("outline", "letter-q", "IconLetterQ", [["path", { "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6", "key": "svg-0" }], ["path", { "d": "M13 15l5 5", "key": "svg-1" }]]);

var IconLetterQ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterQ
});

var IconLetterRSmall = createReactComponent("outline", "letter-r-small", "IconLetterRSmall", [["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4", "key": "svg-0" }]]);

var IconLetterRSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterRSmall
});

var IconLetterR = createReactComponent("outline", "letter-r", "IconLetterR", [["path", { "d": "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5", "key": "svg-0" }], ["path", { "d": "M12 13l5 7", "key": "svg-1" }]]);

var IconLetterR$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterR
});

var IconLetterSSmall = createReactComponent("outline", "letter-s-small", "IconLetterSSmall", [["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1", "key": "svg-0" }]]);

var IconLetterSSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterSSmall
});

var IconLetterS = createReactComponent("outline", "letter-s", "IconLetterS", [["path", { "d": "M17 8a4 4 0 0 0 -4 -4h-2a4 4 0 0 0 0 8h2a4 4 0 0 1 0 8h-2a4 4 0 0 1 -4 -4", "key": "svg-0" }]]);

var IconLetterS$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterS
});

var IconLetterSpacing = createReactComponent("outline", "letter-spacing", "IconLetterSpacing", [["path", { "d": "M5 12v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5", "key": "svg-0" }], ["path", { "d": "M13 4l3 8l3 -8", "key": "svg-1" }], ["path", { "d": "M5 18h14", "key": "svg-2" }], ["path", { "d": "M17 20l2 -2l-2 -2", "key": "svg-3" }], ["path", { "d": "M7 16l-2 2l2 2", "key": "svg-4" }]]);

var IconLetterSpacing$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterSpacing
});

var IconLetterTSmall = createReactComponent("outline", "letter-t-small", "IconLetterTSmall", [["path", { "d": "M10 8h4", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }]]);

var IconLetterTSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterTSmall
});

var IconLetterT = createReactComponent("outline", "letter-t", "IconLetterT", [["path", { "d": "M6 4l12 0", "key": "svg-0" }], ["path", { "d": "M12 4l0 16", "key": "svg-1" }]]);

var IconLetterT$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterT
});

var IconLetterUSmall = createReactComponent("outline", "letter-u-small", "IconLetterUSmall", [["path", { "d": "M10 8v6a2 2 0 1 0 4 0v-6", "key": "svg-0" }]]);

var IconLetterUSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterUSmall
});

var IconLetterU = createReactComponent("outline", "letter-u", "IconLetterU", [["path", { "d": "M6 4v11a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-11", "key": "svg-0" }]]);

var IconLetterU$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterU
});

var IconLetterVSmall = createReactComponent("outline", "letter-v-small", "IconLetterVSmall", [["path", { "d": "M10 8l2 8l2 -8", "key": "svg-0" }]]);

var IconLetterVSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterVSmall
});

var IconLetterV = createReactComponent("outline", "letter-v", "IconLetterV", [["path", { "d": "M6 4l6 16l6 -16", "key": "svg-0" }]]);

var IconLetterV$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterV
});

var IconLetterWSmall = createReactComponent("outline", "letter-w-small", "IconLetterWSmall", [["path", { "d": "M9 8l1 8l2 -5l2 5l1 -8", "key": "svg-0" }]]);

var IconLetterWSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterWSmall
});

var IconLetterW = createReactComponent("outline", "letter-w", "IconLetterW", [["path", { "d": "M4 4l4 16l4 -14l4 14l4 -16", "key": "svg-0" }]]);

var IconLetterW$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterW
});

var IconLetterXSmall = createReactComponent("outline", "letter-x-small", "IconLetterXSmall", [["path", { "d": "M10 8l4 8", "key": "svg-0" }], ["path", { "d": "M10 16l4 -8", "key": "svg-1" }]]);

var IconLetterXSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterXSmall
});

var IconLetterX = createReactComponent("outline", "letter-x", "IconLetterX", [["path", { "d": "M7 4l10 16", "key": "svg-0" }], ["path", { "d": "M17 4l-10 16", "key": "svg-1" }]]);

var IconLetterX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterX
});

var IconLetterYSmall = createReactComponent("outline", "letter-y-small", "IconLetterYSmall", [["path", { "d": "M10 8l2 5l2 -5", "key": "svg-0" }], ["path", { "d": "M12 16v-3", "key": "svg-1" }]]);

var IconLetterYSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterYSmall
});

var IconLetterY = createReactComponent("outline", "letter-y", "IconLetterY", [["path", { "d": "M7 4l5 9l5 -9", "key": "svg-0" }], ["path", { "d": "M12 13l0 7", "key": "svg-1" }]]);

var IconLetterY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterY
});

var IconLetterZSmall = createReactComponent("outline", "letter-z-small", "IconLetterZSmall", [["path", { "d": "M10 8h4l-4 8h4", "key": "svg-0" }]]);

var IconLetterZSmall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterZSmall
});

var IconLetterZ = createReactComponent("outline", "letter-z", "IconLetterZ", [["path", { "d": "M7 4h10l-10 16h10", "key": "svg-0" }]]);

var IconLetterZ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLetterZ
});

var IconLibraryMinus = createReactComponent("outline", "library-minus", "IconLibraryMinus", [["path", { "d": "M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-0" }], ["path", { "d": "M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1", "key": "svg-1" }], ["path", { "d": "M11 10h6", "key": "svg-2" }]]);

var IconLibraryMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLibraryMinus
});

var IconLibraryPhoto = createReactComponent("outline", "library-photo", "IconLibraryPhoto", [["path", { "d": "M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-0" }], ["path", { "d": "M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1", "key": "svg-1" }], ["path", { "d": "M17 7h.01", "key": "svg-2" }], ["path", { "d": "M7 13l3.644 -3.644a1.21 1.21 0 0 1 1.712 0l3.644 3.644", "key": "svg-3" }], ["path", { "d": "M15 12l1.644 -1.644a1.21 1.21 0 0 1 1.712 0l2.644 2.644", "key": "svg-4" }]]);

var IconLibraryPhoto$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLibraryPhoto
});

var IconLibraryPlus = createReactComponent("outline", "library-plus", "IconLibraryPlus", [["path", { "d": "M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-0" }], ["path", { "d": "M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1", "key": "svg-1" }], ["path", { "d": "M11 10h6", "key": "svg-2" }], ["path", { "d": "M14 7v6", "key": "svg-3" }]]);

var IconLibraryPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLibraryPlus
});

var IconLibrary = createReactComponent("outline", "library", "IconLibrary", [["path", { "d": "M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-0" }], ["path", { "d": "M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1", "key": "svg-1" }], ["path", { "d": "M11 7h5", "key": "svg-2" }], ["path", { "d": "M11 10h6", "key": "svg-3" }], ["path", { "d": "M11 13h3", "key": "svg-4" }]]);

var IconLibrary$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLibrary
});

var IconLicenseOff = createReactComponent("outline", "license-off", "IconLicenseOff", [["path", { "d": "M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 1 0 4 0v-2m0 -4v-8a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -.864 .126m-2.014 2.025a3 3 0 0 0 -.122 .849v11", "key": "svg-0" }], ["path", { "d": "M11 7h2", "key": "svg-1" }], ["path", { "d": "M9 11h2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconLicenseOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLicenseOff
});

var IconLicense = createReactComponent("outline", "license", "IconLicense", [["path", { "d": "M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 0 0 4 0v-14a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -3 3v11", "key": "svg-0" }], ["path", { "d": "M9 7l4 0", "key": "svg-1" }], ["path", { "d": "M9 11l4 0", "key": "svg-2" }]]);

var IconLicense$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLicense
});

var IconLifebuoyOff = createReactComponent("outline", "lifebuoy-off", "IconLifebuoyOff", [["path", { "d": "M9.171 9.172a4 4 0 0 0 5.65 5.663m1.179 -2.835a4 4 0 0 0 -4 -4", "key": "svg-0" }], ["path", { "d": "M5.64 5.632a9 9 0 1 0 12.73 12.725m1.667 -2.301a9 9 0 0 0 -12.077 -12.1", "key": "svg-1" }], ["path", { "d": "M15 15l3.35 3.35", "key": "svg-2" }], ["path", { "d": "M9 15l-3.35 3.35", "key": "svg-3" }], ["path", { "d": "M5.65 5.65l3.35 3.35", "key": "svg-4" }], ["path", { "d": "M18.35 5.65l-3.35 3.35", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconLifebuoyOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLifebuoyOff
});

var IconLifebuoy = createReactComponent("outline", "lifebuoy", "IconLifebuoy", [["path", { "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }], ["path", { "d": "M15 15l3.35 3.35", "key": "svg-2" }], ["path", { "d": "M9 15l-3.35 3.35", "key": "svg-3" }], ["path", { "d": "M5.65 5.65l3.35 3.35", "key": "svg-4" }], ["path", { "d": "M18.35 5.65l-3.35 3.35", "key": "svg-5" }]]);

var IconLifebuoy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLifebuoy
});

var IconLighter = createReactComponent("outline", "lighter", "IconLighter", [["path", { "d": "M10 3v16a2 2 0 0 0 2 2h5a2 2 0 0 0 2 -2v-7h-12a2 2 0 0 1 -2 -2v-5a2 2 0 0 1 2 -2h3z", "key": "svg-0" }], ["path", { "d": "M16 4l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z", "key": "svg-1" }]]);

var IconLighter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLighter
});

var IconLineDashed = createReactComponent("outline", "line-dashed", "IconLineDashed", [["path", { "d": "M5 12h2", "key": "svg-0" }], ["path", { "d": "M17 12h2", "key": "svg-1" }], ["path", { "d": "M11 12h2", "key": "svg-2" }]]);

var IconLineDashed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLineDashed
});

var IconLineDotted = createReactComponent("outline", "line-dotted", "IconLineDotted", [["path", { "d": "M4 12v.01", "key": "svg-0" }], ["path", { "d": "M8 12v.01", "key": "svg-1" }], ["path", { "d": "M12 12v.01", "key": "svg-2" }], ["path", { "d": "M16 12v.01", "key": "svg-3" }], ["path", { "d": "M20 12v.01", "key": "svg-4" }]]);

var IconLineDotted$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLineDotted
});

var IconLineHeight = createReactComponent("outline", "line-height", "IconLineHeight", [["path", { "d": "M3 8l3 -3l3 3", "key": "svg-0" }], ["path", { "d": "M3 16l3 3l3 -3", "key": "svg-1" }], ["path", { "d": "M6 5l0 14", "key": "svg-2" }], ["path", { "d": "M13 6l7 0", "key": "svg-3" }], ["path", { "d": "M13 12l7 0", "key": "svg-4" }], ["path", { "d": "M13 18l7 0", "key": "svg-5" }]]);

var IconLineHeight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLineHeight
});

var IconLineScan = createReactComponent("outline", "line-scan", "IconLineScan", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M7 12h10", "key": "svg-4" }]]);

var IconLineScan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLineScan
});

var IconLine = createReactComponent("outline", "line", "IconLine", [["path", { "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M18 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M7.5 16.5l9 -9", "key": "svg-2" }]]);

var IconLine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLine
});

var IconLinkMinus = createReactComponent("outline", "link-minus", "IconLinkMinus", [["path", { "d": "M9 15l6 -6", "key": "svg-0" }], ["path", { "d": "M11 6l.463 -.536a5 5 0 1 1 7.071 7.072l-.534 .464", "key": "svg-1" }], ["path", { "d": "M12.603 18.534a5.07 5.07 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconLinkMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLinkMinus
});

var IconLinkOff = createReactComponent("outline", "link-off", "IconLinkOff", [["path", { "d": "M9 15l3 -3m2 -2l1 -1", "key": "svg-0" }], ["path", { "d": "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }], ["path", { "d": "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463", "key": "svg-3" }]]);

var IconLinkOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLinkOff
});

var IconLinkPlus = createReactComponent("outline", "link-plus", "IconLinkPlus", [["path", { "d": "M9 15l6 -6", "key": "svg-0" }], ["path", { "d": "M11 6l.463 -.536a5 5 0 0 1 7.072 0a4.993 4.993 0 0 1 -.001 7.072", "key": "svg-1" }], ["path", { "d": "M12.603 18.534a5.07 5.07 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconLinkPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLinkPlus
});

var IconLink = createReactComponent("outline", "link", "IconLink", [["path", { "d": "M9 15l6 -6", "key": "svg-0" }], ["path", { "d": "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464", "key": "svg-1" }], ["path", { "d": "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463", "key": "svg-2" }]]);

var IconLink$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLink
});

var IconListCheck = createReactComponent("outline", "list-check", "IconListCheck", [["path", { "d": "M3.5 5.5l1.5 1.5l2.5 -2.5", "key": "svg-0" }], ["path", { "d": "M3.5 11.5l1.5 1.5l2.5 -2.5", "key": "svg-1" }], ["path", { "d": "M3.5 17.5l1.5 1.5l2.5 -2.5", "key": "svg-2" }], ["path", { "d": "M11 6l9 0", "key": "svg-3" }], ["path", { "d": "M11 12l9 0", "key": "svg-4" }], ["path", { "d": "M11 18l9 0", "key": "svg-5" }]]);

var IconListCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconListCheck
});

var IconListDetails = createReactComponent("outline", "list-details", "IconListDetails", [["path", { "d": "M13 5h8", "key": "svg-0" }], ["path", { "d": "M13 9h5", "key": "svg-1" }], ["path", { "d": "M13 15h8", "key": "svg-2" }], ["path", { "d": "M13 19h5", "key": "svg-3" }], ["path", { "d": "M3 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-4" }], ["path", { "d": "M3 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-5" }]]);

var IconListDetails$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconListDetails
});

var IconListLetters = createReactComponent("outline", "list-letters", "IconListLetters", [["path", { "d": "M11 6h9", "key": "svg-0" }], ["path", { "d": "M11 12h9", "key": "svg-1" }], ["path", { "d": "M11 18h9", "key": "svg-2" }], ["path", { "d": "M4 10v-4.5a1.5 1.5 0 0 1 3 0v4.5", "key": "svg-3" }], ["path", { "d": "M4 8h3", "key": "svg-4" }], ["path", { "d": "M4 20h1.5a1.5 1.5 0 0 0 0 -3h-1.5h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6z", "key": "svg-5" }]]);

var IconListLetters$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconListLetters
});

var IconListNumbers = createReactComponent("outline", "list-numbers", "IconListNumbers", [["path", { "d": "M11 6h9", "key": "svg-0" }], ["path", { "d": "M11 12h9", "key": "svg-1" }], ["path", { "d": "M12 18h8", "key": "svg-2" }], ["path", { "d": "M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4", "key": "svg-3" }], ["path", { "d": "M6 10v-6l-2 2", "key": "svg-4" }]]);

var IconListNumbers$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconListNumbers
});

var IconListSearch = createReactComponent("outline", "list-search", "IconListSearch", [["path", { "d": "M15 15m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M18.5 18.5l2.5 2.5", "key": "svg-1" }], ["path", { "d": "M4 6h16", "key": "svg-2" }], ["path", { "d": "M4 12h4", "key": "svg-3" }], ["path", { "d": "M4 18h4", "key": "svg-4" }]]);

var IconListSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconListSearch
});

var IconListTree = createReactComponent("outline", "list-tree", "IconListTree", [["path", { "d": "M9 6h11", "key": "svg-0" }], ["path", { "d": "M12 12h8", "key": "svg-1" }], ["path", { "d": "M15 18h5", "key": "svg-2" }], ["path", { "d": "M5 6v.01", "key": "svg-3" }], ["path", { "d": "M8 12v.01", "key": "svg-4" }], ["path", { "d": "M11 18v.01", "key": "svg-5" }]]);

var IconListTree$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconListTree
});

var IconList = createReactComponent("outline", "list", "IconList", [["path", { "d": "M9 6l11 0", "key": "svg-0" }], ["path", { "d": "M9 12l11 0", "key": "svg-1" }], ["path", { "d": "M9 18l11 0", "key": "svg-2" }], ["path", { "d": "M5 6l0 .01", "key": "svg-3" }], ["path", { "d": "M5 12l0 .01", "key": "svg-4" }], ["path", { "d": "M5 18l0 .01", "key": "svg-5" }]]);

var IconList$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconList
});

var IconLivePhotoOff = createReactComponent("outline", "live-photo-off", "IconLivePhotoOff", [["path", { "d": "M11.296 11.29a1 1 0 1 0 1.414 1.415", "key": "svg-0" }], ["path", { "d": "M8.473 8.456a5 5 0 1 0 7.076 7.066m1.365 -2.591a5 5 0 0 0 -5.807 -5.851", "key": "svg-1" }], ["path", { "d": "M15.9 20.11v.01", "key": "svg-2" }], ["path", { "d": "M19.04 17.61v.01", "key": "svg-3" }], ["path", { "d": "M20.77 14v.01", "key": "svg-4" }], ["path", { "d": "M20.77 10v.01", "key": "svg-5" }], ["path", { "d": "M19.04 6.39v.01", "key": "svg-6" }], ["path", { "d": "M15.9 3.89v.01", "key": "svg-7" }], ["path", { "d": "M12 3v.01", "key": "svg-8" }], ["path", { "d": "M8.1 3.89v.01", "key": "svg-9" }], ["path", { "d": "M4.96 6.39v.01", "key": "svg-10" }], ["path", { "d": "M3.23 10v.01", "key": "svg-11" }], ["path", { "d": "M3.23 14v.01", "key": "svg-12" }], ["path", { "d": "M4.96 17.61v.01", "key": "svg-13" }], ["path", { "d": "M8.1 20.11v.01", "key": "svg-14" }], ["path", { "d": "M12 21v.01", "key": "svg-15" }], ["path", { "d": "M3 3l18 18", "key": "svg-16" }]]);

var IconLivePhotoOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLivePhotoOff
});

var IconLivePhoto = createReactComponent("outline", "live-photo", "IconLivePhoto", [["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-1" }], ["path", { "d": "M15.9 20.11l0 .01", "key": "svg-2" }], ["path", { "d": "M19.04 17.61l0 .01", "key": "svg-3" }], ["path", { "d": "M20.77 14l0 .01", "key": "svg-4" }], ["path", { "d": "M20.77 10l0 .01", "key": "svg-5" }], ["path", { "d": "M19.04 6.39l0 .01", "key": "svg-6" }], ["path", { "d": "M15.9 3.89l0 .01", "key": "svg-7" }], ["path", { "d": "M12 3l0 .01", "key": "svg-8" }], ["path", { "d": "M8.1 3.89l0 .01", "key": "svg-9" }], ["path", { "d": "M4.96 6.39l0 .01", "key": "svg-10" }], ["path", { "d": "M3.23 10l0 .01", "key": "svg-11" }], ["path", { "d": "M3.23 14l0 .01", "key": "svg-12" }], ["path", { "d": "M4.96 17.61l0 .01", "key": "svg-13" }], ["path", { "d": "M8.1 20.11l0 .01", "key": "svg-14" }], ["path", { "d": "M12 21l0 .01", "key": "svg-15" }]]);

var IconLivePhoto$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLivePhoto
});

var IconLiveView = createReactComponent("outline", "live-view", "IconLiveView", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M12 11l0 .01", "key": "svg-4" }], ["path", { "d": "M12 18l-3.5 -5a4 4 0 1 1 7 0l-3.5 5", "key": "svg-5" }]]);

var IconLiveView$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLiveView
});

var IconLoadBalancer = createReactComponent("outline", "load-balancer", "IconLoadBalancer", [["path", { "d": "M12 13m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M12 16v3", "key": "svg-2" }], ["path", { "d": "M12 10v-7", "key": "svg-3" }], ["path", { "d": "M9 6l3 -3l3 3", "key": "svg-4" }], ["path", { "d": "M12 10v-7", "key": "svg-5" }], ["path", { "d": "M9 6l3 -3l3 3", "key": "svg-6" }], ["path", { "d": "M14.894 12.227l6.11 -2.224", "key": "svg-7" }], ["path", { "d": "M17.159 8.21l3.845 1.793l-1.793 3.845", "key": "svg-8" }], ["path", { "d": "M9.101 12.214l-6.075 -2.211", "key": "svg-9" }], ["path", { "d": "M6.871 8.21l-3.845 1.793l1.793 3.845", "key": "svg-10" }]]);

var IconLoadBalancer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLoadBalancer
});

var IconLoader2 = createReactComponent("outline", "loader-2", "IconLoader2", [["path", { "d": "M12 3a9 9 0 1 0 9 9", "key": "svg-0" }]]);

var IconLoader2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLoader2
});

var IconLoader3 = createReactComponent("outline", "loader-3", "IconLoader3", [["path", { "d": "M3 12a9 9 0 0 0 9 9a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9", "key": "svg-0" }], ["path", { "d": "M17 12a5 5 0 1 0 -5 5", "key": "svg-1" }]]);

var IconLoader3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLoader3
});

var IconLoaderQuarter = createReactComponent("outline", "loader-quarter", "IconLoaderQuarter", [["path", { "d": "M12 6l0 -3", "key": "svg-0" }], ["path", { "d": "M6 12l-3 0", "key": "svg-1" }], ["path", { "d": "M7.75 7.75l-2.15 -2.15", "key": "svg-2" }]]);

var IconLoaderQuarter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLoaderQuarter
});

var IconLoader = createReactComponent("outline", "loader", "IconLoader", [["path", { "d": "M12 6l0 -3", "key": "svg-0" }], ["path", { "d": "M16.25 7.75l2.15 -2.15", "key": "svg-1" }], ["path", { "d": "M18 12l3 0", "key": "svg-2" }], ["path", { "d": "M16.25 16.25l2.15 2.15", "key": "svg-3" }], ["path", { "d": "M12 18l0 3", "key": "svg-4" }], ["path", { "d": "M7.75 16.25l-2.15 2.15", "key": "svg-5" }], ["path", { "d": "M6 12l-3 0", "key": "svg-6" }], ["path", { "d": "M7.75 7.75l-2.15 -2.15", "key": "svg-7" }]]);

var IconLoader$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLoader
});

var IconLocationBolt = createReactComponent("outline", "location-bolt", "IconLocationBolt", [["path", { "d": "M13.05 20.1l-3.05 -6.1l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.312 9.173", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }]]);

var IconLocationBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationBolt
});

var IconLocationBroken = createReactComponent("outline", "location-broken", "IconLocationBroken", [["path", { "d": "M12.896 19.792l-2.896 -5.792l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.487 9.657", "key": "svg-0" }], ["path", { "d": "M21.5 21.5l-5 -5", "key": "svg-1" }], ["path", { "d": "M16.5 21.5l5 -5", "key": "svg-2" }]]);

var IconLocationBroken$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationBroken
});

var IconLocationCancel = createReactComponent("outline", "location-cancel", "IconLocationCancel", [["path", { "d": "M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.305 9.151", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }]]);

var IconLocationCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationCancel
});

var IconLocationCheck = createReactComponent("outline", "location-check", "IconLocationCheck", [["path", { "d": "M11.512 17.023l-1.512 -3.023l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-4.45 12.324", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }]]);

var IconLocationCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationCheck
});

var IconLocationCode = createReactComponent("outline", "location-code", "IconLocationCode", [["path", { "d": "M11.505 17.01l-1.505 -3.01l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.677 10.184", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }]]);

var IconLocationCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationCode
});

var IconLocationCog = createReactComponent("outline", "location-cog", "IconLocationCog", [["path", { "d": "M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.14 8.697", "key": "svg-0" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-2" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-3" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-7" }]]);

var IconLocationCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationCog
});

var IconLocationDiscount = createReactComponent("outline", "location-discount", "IconLocationDiscount", [["path", { "d": "M12.797 19.595l-2.797 -5.595l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.548 9.826", "key": "svg-0" }], ["path", { "d": "M16 21l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21v.01", "key": "svg-2" }], ["path", { "d": "M16 16v.01", "key": "svg-3" }]]);

var IconLocationDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationDiscount
});

var IconLocationDollar = createReactComponent("outline", "location-dollar", "IconLocationDollar", [["path", { "d": "M13.08 20.162l-3.08 -6.162l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-2.55 7.063", "key": "svg-0" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-2" }]]);

var IconLocationDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationDollar
});

var IconLocationDown = createReactComponent("outline", "location-down", "IconLocationDown", [["path", { "d": "M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.328 9.217", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }]]);

var IconLocationDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationDown
});

var IconLocationExclamation = createReactComponent("outline", "location-exclamation", "IconLocationExclamation", [["path", { "d": "M15.024 19.55l-.524 1.45a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.317 9.186", "key": "svg-0" }], ["path", { "d": "M19 16v3", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }]]);

var IconLocationExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationExclamation
});

var IconLocationHeart = createReactComponent("outline", "location-heart", "IconLocationHeart", [["path", { "d": "M10.365 14.73l-.365 -.73l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.024 8.373", "key": "svg-0" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-1" }]]);

var IconLocationHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationHeart
});

var IconLocationMinus = createReactComponent("outline", "location-minus", "IconLocationMinus", [["path", { "d": "M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-4.347 12.038", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconLocationMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationMinus
});

var IconLocationOff = createReactComponent("outline", "location-off", "IconLocationOff", [["path", { "d": "M10.72 6.712l10.28 -3.712l-3.724 10.313m-1.056 2.925l-1.72 4.762a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l4.775 -1.724", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconLocationOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationOff
});

var IconLocationPause = createReactComponent("outline", "location-pause", "IconLocationPause", [["path", { "d": "M13.02 20.04l-3.02 -6.04l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.634 10.062", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }]]);

var IconLocationPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationPause
});

var IconLocationPin = createReactComponent("outline", "location-pin", "IconLocationPin", [["path", { "d": "M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-2.901 8.034", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }]]);

var IconLocationPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationPin
});

var IconLocationPlus = createReactComponent("outline", "location-plus", "IconLocationPlus", [["path", { "d": "M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.361 9.308", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconLocationPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationPlus
});

var IconLocationQuestion = createReactComponent("outline", "location-question", "IconLocationQuestion", [["path", { "d": "M14.5 21a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-2.967 8.215", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconLocationQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationQuestion
});

var IconLocationSearch = createReactComponent("outline", "location-search", "IconLocationSearch", [["path", { "d": "M11 16l-1 -2l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-2.916 8.076", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }]]);

var IconLocationSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationSearch
});

var IconLocationShare = createReactComponent("outline", "location-share", "IconLocationShare", [["path", { "d": "M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.616 10.015", "key": "svg-0" }], ["path", { "d": "M16 22l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-2" }]]);

var IconLocationShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationShare
});

var IconLocationStar = createReactComponent("outline", "location-star", "IconLocationStar", [["path", { "d": "M10.336 14.672l-.336 -.672l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-2.565 7.104", "key": "svg-0" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }]]);

var IconLocationStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationStar
});

var IconLocationUp = createReactComponent("outline", "location-up", "IconLocationUp", [["path", { "d": "M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.251 9.003", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }]]);

var IconLocationUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationUp
});

var IconLocationX = createReactComponent("outline", "location-x", "IconLocationX", [["path", { "d": "M13.5 21l-.224 -.448l-3.276 -6.552l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.622 10.03", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }]]);

var IconLocationX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationX
});

var IconLocation = createReactComponent("outline", "location", "IconLocation", [["path", { "d": "M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5", "key": "svg-0" }]]);

var IconLocation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocation
});

var IconLockAccessOff = createReactComponent("outline", "lock-access-off", "IconLockAccessOff", [["path", { "d": "M4 8v-2c0 -.554 .225 -1.055 .588 -1.417", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2c.55 0 1.05 -.222 1.41 -.582", "key": "svg-3" }], ["path", { "d": "M15 11a1 1 0 0 1 1 1m-.29 3.704a1 1 0 0 1 -.71 .296h-6a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h2", "key": "svg-4" }], ["path", { "d": "M10 11v-1m1.182 -2.826a2 2 0 0 1 2.818 1.826v1", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconLockAccessOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockAccessOff
});

var IconLockAccess = createReactComponent("outline", "lock-access", "IconLockAccess", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M8 11m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-4" }], ["path", { "d": "M10 11v-2a2 2 0 1 1 4 0v2", "key": "svg-5" }]]);

var IconLockAccess$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockAccess
});

var IconLockBitcoin = createReactComponent("outline", "lock-bitcoin", "IconLockBitcoin", [["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-0" }], ["path", { "d": "M13 21h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10", "key": "svg-1" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-2" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-3" }]]);

var IconLockBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockBitcoin
});

var IconLockBolt = createReactComponent("outline", "lock-bolt", "IconLockBolt", [["path", { "d": "M13.5 21h-6.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.74 1.012", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-3" }]]);

var IconLockBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockBolt
});

var IconLockCancel = createReactComponent("outline", "lock-cancel", "IconLockCancel", [["path", { "d": "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.749 1.028", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M17 21l4 -4", "key": "svg-4" }]]);

var IconLockCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockCancel
});

var IconLockCheck = createReactComponent("outline", "lock-check", "IconLockCheck", [["path", { "d": "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v.5", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-3" }]]);

var IconLockCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockCheck
});

var IconLockCode = createReactComponent("outline", "lock-code", "IconLockCode", [["path", { "d": "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-3" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-4" }]]);

var IconLockCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockCode
});

var IconLockCog = createReactComponent("outline", "lock-cog", "IconLockCog", [["path", { "d": "M12 21h-5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10c.564 0 1.074 .234 1.437 .61", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-4" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-5" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-6" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-7" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-8" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-9" }]]);

var IconLockCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockCog
});

var IconLockDollar = createReactComponent("outline", "lock-dollar", "IconLockDollar", [["path", { "d": "M13 21h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-4" }]]);

var IconLockDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockDollar
});

var IconLockDown = createReactComponent("outline", "lock-down", "IconLockDown", [["path", { "d": "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.74 1.015", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-4" }]]);

var IconLockDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockDown
});

var IconLockExclamation = createReactComponent("outline", "lock-exclamation", "IconLockExclamation", [["path", { "d": "M15 21h-8a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.734 1.002", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M19 16v3", "key": "svg-3" }], ["path", { "d": "M19 22v.01", "key": "svg-4" }]]);

var IconLockExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockExclamation
});

var IconLockHeart = createReactComponent("outline", "lock-heart", "IconLockHeart", [["path", { "d": "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10c.38 0 .734 .106 1.037 .29", "key": "svg-0" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconLockHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockHeart
});

var IconLockMinus = createReactComponent("outline", "lock-minus", "IconLockMinus", [["path", { "d": "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v2", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconLockMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockMinus
});

var IconLockOff = createReactComponent("outline", "lock-off", "IconLockOff", [["path", { "d": "M15 11h2a2 2 0 0 1 2 2v2m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h4", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-3m.719 -3.289a4 4 0 0 1 7.281 2.289v4", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconLockOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockOff
});

var IconLockOpen2 = createReactComponent("outline", "lock-open-2", "IconLockOpen2", [["path", { "d": "M3 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M13 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }]]);

var IconLockOpen2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockOpen2
});

var IconLockOpenOff = createReactComponent("outline", "lock-open-off", "IconLockOpenOff", [["path", { "d": "M15 11h2a2 2 0 0 1 2 2v2m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h4", "key": "svg-0" }], ["path", { "d": "M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-3m.347 -3.631a4 4 0 0 1 7.653 1.631", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconLockOpenOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockOpenOff
});

var IconLockOpen = createReactComponent("outline", "lock-open", "IconLockOpen", [["path", { "d": "M5 11m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-5a4 4 0 0 1 8 0", "key": "svg-2" }]]);

var IconLockOpen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockOpen
});

var IconLockPassword = createReactComponent("outline", "lock-password", "IconLockPassword", [["path", { "d": "M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-1" }], ["path", { "d": "M15 16h.01", "key": "svg-2" }], ["path", { "d": "M12.01 16h.01", "key": "svg-3" }], ["path", { "d": "M9.02 16h.01", "key": "svg-4" }]]);

var IconLockPassword$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockPassword
});

var IconLockPause = createReactComponent("outline", "lock-pause", "IconLockPause", [["path", { "d": "M13 21h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v.5", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M17 17v5", "key": "svg-3" }], ["path", { "d": "M21 17v5", "key": "svg-4" }]]);

var IconLockPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockPause
});

var IconLockPin = createReactComponent("outline", "lock-pin", "IconLockPin", [["path", { "d": "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10c.24 0 .47 .042 .683 .12", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-3" }], ["path", { "d": "M19 18v.01", "key": "svg-4" }]]);

var IconLockPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockPin
});

var IconLockPlus = createReactComponent("outline", "lock-plus", "IconLockPlus", [["path", { "d": "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.74 1.012", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconLockPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockPlus
});

var IconLockQuestion = createReactComponent("outline", "lock-question", "IconLockQuestion", [["path", { "d": "M15 21h-8a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10c.265 0 .518 .052 .75 .145", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-4" }]]);

var IconLockQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockQuestion
});

var IconLockSearch = createReactComponent("outline", "lock-search", "IconLockSearch", [["path", { "d": "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10", "key": "svg-0" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconLockSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockSearch
});

var IconLockShare = createReactComponent("outline", "lock-share", "IconLockShare", [["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M12 21h-5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M16 22l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-4" }]]);

var IconLockShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockShare
});

var IconLockSquareRounded = createReactComponent("outline", "lock-square-rounded", "IconLockSquareRounded", [["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-0" }], ["path", { "d": "M8 11m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M10 11v-2a2 2 0 1 1 4 0v2", "key": "svg-2" }]]);

var IconLockSquareRounded$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockSquareRounded
});

var IconLockSquare = createReactComponent("outline", "lock-square", "IconLockSquare", [["path", { "d": "M8 11m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M10 11v-2a2 2 0 1 1 4 0v2", "key": "svg-1" }], ["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconLockSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockSquare
});

var IconLockStar = createReactComponent("outline", "lock-star", "IconLockStar", [["path", { "d": "M11 21h-4a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h9", "key": "svg-0" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconLockStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockStar
});

var IconLockUp = createReactComponent("outline", "lock-up", "IconLockUp", [["path", { "d": "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.739 1.01", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M19 22v-6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-4" }]]);

var IconLockUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockUp
});

var IconLockX = createReactComponent("outline", "lock-x", "IconLockX", [["path", { "d": "M13 21h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v.5", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-3" }], ["path", { "d": "M17 22l5 -5", "key": "svg-4" }]]);

var IconLockX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockX
});

var IconLock = createReactComponent("outline", "lock", "IconLock", [["path", { "d": "M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }]]);

var IconLock$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLock
});

var IconLogicAnd = createReactComponent("outline", "logic-and", "IconLogicAnd", [["path", { "d": "M22 12h-5", "key": "svg-0" }], ["path", { "d": "M2 9h5", "key": "svg-1" }], ["path", { "d": "M2 15h5", "key": "svg-2" }], ["path", { "d": "M9 5c6 0 8 3.5 8 7s-2 7 -8 7h-2v-14h2z", "key": "svg-3" }]]);

var IconLogicAnd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogicAnd
});

var IconLogicBuffer = createReactComponent("outline", "logic-buffer", "IconLogicBuffer", [["path", { "d": "M22 12h-5", "key": "svg-0" }], ["path", { "d": "M2 9h5", "key": "svg-1" }], ["path", { "d": "M2 15h5", "key": "svg-2" }], ["path", { "d": "M7 5l10 7l-10 7z", "key": "svg-3" }]]);

var IconLogicBuffer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogicBuffer
});

var IconLogicNand = createReactComponent("outline", "logic-nand", "IconLogicNand", [["path", { "d": "M22 12h-3", "key": "svg-0" }], ["path", { "d": "M2 9h3", "key": "svg-1" }], ["path", { "d": "M2 15h3", "key": "svg-2" }], ["path", { "d": "M7 5c6 0 8 3.5 8 7s-2 7 -8 7h-2v-14h2z", "key": "svg-3" }], ["path", { "d": "M17 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }]]);

var IconLogicNand$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogicNand
});

var IconLogicNor = createReactComponent("outline", "logic-nor", "IconLogicNor", [["path", { "d": "M22 12h-4", "key": "svg-0" }], ["path", { "d": "M2 9h5", "key": "svg-1" }], ["path", { "d": "M2 15h5", "key": "svg-2" }], ["path", { "d": "M6 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z", "key": "svg-3" }], ["path", { "d": "M16 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }]]);

var IconLogicNor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogicNor
});

var IconLogicNot = createReactComponent("outline", "logic-not", "IconLogicNot", [["path", { "d": "M22 12h-3", "key": "svg-0" }], ["path", { "d": "M2 9h3", "key": "svg-1" }], ["path", { "d": "M2 15h3", "key": "svg-2" }], ["path", { "d": "M5 5l10 7l-10 7z", "key": "svg-3" }], ["path", { "d": "M17 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }]]);

var IconLogicNot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogicNot
});

var IconLogicOr = createReactComponent("outline", "logic-or", "IconLogicOr", [["path", { "d": "M22 12h-6", "key": "svg-0" }], ["path", { "d": "M2 9h7", "key": "svg-1" }], ["path", { "d": "M2 15h7", "key": "svg-2" }], ["path", { "d": "M8 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z", "key": "svg-3" }]]);

var IconLogicOr$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogicOr
});

var IconLogicXnor = createReactComponent("outline", "logic-xnor", "IconLogicXnor", [["path", { "d": "M22 12h-2", "key": "svg-0" }], ["path", { "d": "M2 9h4", "key": "svg-1" }], ["path", { "d": "M2 15h4", "key": "svg-2" }], ["path", { "d": "M5 19c1.778 -4.667 1.778 -9.333 0 -14", "key": "svg-3" }], ["path", { "d": "M8 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z", "key": "svg-4" }], ["path", { "d": "M18 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-5" }]]);

var IconLogicXnor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogicXnor
});

var IconLogicXor = createReactComponent("outline", "logic-xor", "IconLogicXor", [["path", { "d": "M22 12h-4", "key": "svg-0" }], ["path", { "d": "M2 9h6", "key": "svg-1" }], ["path", { "d": "M2 15h6", "key": "svg-2" }], ["path", { "d": "M7 19c1.778 -4.667 1.778 -9.333 0 -14", "key": "svg-3" }], ["path", { "d": "M10 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z", "key": "svg-4" }]]);

var IconLogicXor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogicXor
});

var IconLogin2 = createReactComponent("outline", "login-2", "IconLogin2", [["path", { "d": "M9 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2", "key": "svg-0" }], ["path", { "d": "M3 12h13l-3 -3", "key": "svg-1" }], ["path", { "d": "M13 15l3 -3", "key": "svg-2" }]]);

var IconLogin2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogin2
});

var IconLogin = createReactComponent("outline", "login", "IconLogin", [["path", { "d": "M15 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2", "key": "svg-0" }], ["path", { "d": "M21 12h-13l3 -3", "key": "svg-1" }], ["path", { "d": "M11 15l-3 -3", "key": "svg-2" }]]);

var IconLogin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogin
});

var IconLogout2 = createReactComponent("outline", "logout-2", "IconLogout2", [["path", { "d": "M10 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2", "key": "svg-0" }], ["path", { "d": "M15 12h-12l3 -3", "key": "svg-1" }], ["path", { "d": "M6 15l-3 -3", "key": "svg-2" }]]);

var IconLogout2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogout2
});

var IconLogout = createReactComponent("outline", "logout", "IconLogout", [["path", { "d": "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2", "key": "svg-0" }], ["path", { "d": "M9 12h12l-3 -3", "key": "svg-1" }], ["path", { "d": "M18 15l3 -3", "key": "svg-2" }]]);

var IconLogout$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogout
});

var IconLogs = createReactComponent("outline", "logs", "IconLogs", [["path", { "d": "M4 12h.01", "key": "svg-0" }], ["path", { "d": "M4 6h.01", "key": "svg-1" }], ["path", { "d": "M4 18h.01", "key": "svg-2" }], ["path", { "d": "M8 18h2", "key": "svg-3" }], ["path", { "d": "M8 12h2", "key": "svg-4" }], ["path", { "d": "M8 6h2", "key": "svg-5" }], ["path", { "d": "M14 6h6", "key": "svg-6" }], ["path", { "d": "M14 12h6", "key": "svg-7" }], ["path", { "d": "M14 18h6", "key": "svg-8" }]]);

var IconLogs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLogs
});

var IconLollipopOff = createReactComponent("outline", "lollipop-off", "IconLollipopOff", [["path", { "d": "M7.462 7.493a7 7 0 0 0 9.06 9.039m2.416 -1.57a7 7 0 1 0 -9.884 -9.915", "key": "svg-0" }], ["path", { "d": "M21 10a3.5 3.5 0 0 0 -7 0", "key": "svg-1" }], ["path", { "d": "M12.71 12.715a3.5 3.5 0 0 1 -5.71 -2.715", "key": "svg-2" }], ["path", { "d": "M14 17c.838 0 1.607 -.294 2.209 -.785m1.291 -2.715a3.5 3.5 0 0 0 -3.5 -3.5", "key": "svg-3" }], ["path", { "d": "M14 3a3.5 3.5 0 0 0 -3.5 3.5", "key": "svg-4" }], ["path", { "d": "M3 21l6 -6", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconLollipopOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLollipopOff
});

var IconLollipop = createReactComponent("outline", "lollipop", "IconLollipop", [["path", { "d": "M14 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M21 10a3.5 3.5 0 0 0 -7 0", "key": "svg-1" }], ["path", { "d": "M14 10a3.5 3.5 0 0 1 -7 0", "key": "svg-2" }], ["path", { "d": "M14 17a3.5 3.5 0 0 0 0 -7", "key": "svg-3" }], ["path", { "d": "M14 3a3.5 3.5 0 0 0 0 7", "key": "svg-4" }], ["path", { "d": "M3 21l6 -6", "key": "svg-5" }]]);

var IconLollipop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLollipop
});

var IconLuggageOff = createReactComponent("outline", "luggage-off", "IconLuggageOff", [["path", { "d": "M10 6h6a2 2 0 0 1 2 2v6m0 4a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-10c0 -.546 .218 -1.04 .573 -1.4", "key": "svg-0" }], ["path", { "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1", "key": "svg-1" }], ["path", { "d": "M6 10h4m4 0h4", "key": "svg-2" }], ["path", { "d": "M6 16h10", "key": "svg-3" }], ["path", { "d": "M9 20v1", "key": "svg-4" }], ["path", { "d": "M15 20v1", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconLuggageOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLuggageOff
});

var IconLuggage = createReactComponent("outline", "luggage", "IconLuggage", [["path", { "d": "M6 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 6v-1a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1", "key": "svg-1" }], ["path", { "d": "M6 10h12", "key": "svg-2" }], ["path", { "d": "M6 16h12", "key": "svg-3" }], ["path", { "d": "M9 20v1", "key": "svg-4" }], ["path", { "d": "M15 20v1", "key": "svg-5" }]]);

var IconLuggage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLuggage
});

var IconLungsOff = createReactComponent("outline", "lungs-off", "IconLungsOff", [["path", { "d": "M6.583 6.608c-1.206 1.058 -2.07 2.626 -2.933 5.449c-.42 1.37 -.636 2.962 -.648 4.775c-.012 1.675 1.261 3.054 2.877 3.161l.203 .007c1.611 0 2.918 -1.335 2.918 -2.98v-8.02", "key": "svg-0" }], ["path", { "d": "M15 11v-3.743c0 -.694 .552 -1.257 1.233 -1.257c.204 0 .405 .052 .584 .15l.13 .083c1.46 1.059 2.432 2.647 3.405 5.824c.42 1.37 .636 2.962 .648 4.775c0 .063 0 .125 0 .187m-1.455 2.51c-.417 .265 -.9 .43 -1.419 .464l-.202 .007c-1.613 0 -2.92 -1.335 -2.92 -2.98v-2.02", "key": "svg-1" }], ["path", { "d": "M9 12a2.99 2.99 0 0 0 2.132 -.89", "key": "svg-2" }], ["path", { "d": "M12 4v4", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconLungsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLungsOff
});

var IconLungs = createReactComponent("outline", "lungs", "IconLungs", [["path", { "d": "M6.081 20c1.612 0 2.919 -1.335 2.919 -2.98v-9.763c0 -.694 -.552 -1.257 -1.232 -1.257c-.205 0 -.405 .052 -.584 .15l-.13 .083c-1.46 1.059 -2.432 2.647 -3.404 5.824c-.42 1.37 -.636 2.962 -.648 4.775c-.012 1.675 1.261 3.054 2.877 3.161l.203 .007z", "key": "svg-0" }], ["path", { "d": "M17.92 20c-1.613 0 -2.92 -1.335 -2.92 -2.98v-9.763c0 -.694 .552 -1.257 1.233 -1.257c.204 0 .405 .052 .584 .15l.13 .083c1.46 1.059 2.432 2.647 3.405 5.824c.42 1.37 .636 2.962 .648 4.775c.012 1.675 -1.261 3.054 -2.878 3.161l-.202 .007z", "key": "svg-1" }], ["path", { "d": "M9 12a3 3 0 0 0 3 -3a3 3 0 0 0 3 3", "key": "svg-2" }], ["path", { "d": "M12 4v5", "key": "svg-3" }]]);

var IconLungs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLungs
});

var IconMacroOff = createReactComponent("outline", "macro-off", "IconMacroOff", [["path", { "d": "M6 15a6 6 0 0 0 11.47 2.467", "key": "svg-0" }], ["path", { "d": "M15.53 15.53a6 6 0 0 0 -3.53 5.47", "key": "svg-1" }], ["path", { "d": "M12 21a6 6 0 0 0 -6 -6", "key": "svg-2" }], ["path", { "d": "M12 21v-10", "key": "svg-3" }], ["path", { "d": "M10.866 10.87a5.007 5.007 0 0 1 -3.734 -3.723m-.132 -4.147l3 2l2 -2l2 2l3 -2v3a5 5 0 0 1 -2.604 4.389", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconMacroOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMacroOff
});

var IconMacro = createReactComponent("outline", "macro", "IconMacro", [["path", { "d": "M6 15a6 6 0 1 0 12 0", "key": "svg-0" }], ["path", { "d": "M18 15a6 6 0 0 0 -6 6", "key": "svg-1" }], ["path", { "d": "M12 21a6 6 0 0 0 -6 -6", "key": "svg-2" }], ["path", { "d": "M12 21v-10", "key": "svg-3" }], ["path", { "d": "M12 11a5 5 0 0 1 -5 -5v-3l3 2l2 -2l2 2l3 -2v3a5 5 0 0 1 -5 5z", "key": "svg-4" }]]);

var IconMacro$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMacro
});

var IconMagnetOff = createReactComponent("outline", "magnet-off", "IconMagnetOff", [["path", { "d": "M7 3a2 2 0 0 1 2 2m0 4v4a3 3 0 0 0 5.552 1.578m.448 -3.578v-6a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a7.99 7.99 0 0 1 -.424 2.577m-1.463 2.584a8 8 0 0 1 -14.113 -5.161v-8c0 -.297 .065 -.58 .181 -.833", "key": "svg-0" }], ["path", { "d": "M4 8h4", "key": "svg-1" }], ["path", { "d": "M15 8h4", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconMagnetOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMagnetOff
});

var IconMagnet = createReactComponent("outline", "magnet", "IconMagnet", [["path", { "d": "M4 13v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a2 2 0 0 0 6 0v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a8 8 0 0 1 -16 0", "key": "svg-0" }], ["path", { "d": "M4 8l5 0", "key": "svg-1" }], ["path", { "d": "M15 8l4 0", "key": "svg-2" }]]);

var IconMagnet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMagnet
});

var IconMagnetic = createReactComponent("outline", "magnetic", "IconMagnetic", [["path", { "d": "M12 3v18", "key": "svg-0" }], ["path", { "d": "M18 7c-.633 -1.255 -1.538 -2 -2.5 -2c-1.933 0 -3.5 3.134 -3.5 7s1.567 7 3.5 7s3.5 -3.134 3.5 -7v-1", "key": "svg-1" }], ["path", { "d": "M6 7c.633 -1.255 1.538 -2 2.5 -2c1.933 0 3.5 3.134 3.5 7s-1.567 7 -3.5 7s-3.5 -3.134 -3.5 -7v-1", "key": "svg-2" }], ["path", { "d": "M3 13l2 -2l2 2", "key": "svg-3" }], ["path", { "d": "M17 13l2 -2l2 2", "key": "svg-4" }]]);

var IconMagnetic$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMagnetic
});

var IconMailAi = createReactComponent("outline", "mail-ai", "IconMailAi", [["path", { "d": "M10 19h-5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M3 7l8 5.345m4 -1.345l6 -4", "key": "svg-1" }], ["path", { "d": "M14 21v-4a2 2 0 1 1 4 0v4", "key": "svg-2" }], ["path", { "d": "M14 19h4", "key": "svg-3" }], ["path", { "d": "M21 15v6", "key": "svg-4" }]]);

var IconMailAi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailAi
});

var IconMailBitcoin = createReactComponent("outline", "mail-bitcoin", "IconMailBitcoin", [["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-0" }], ["path", { "d": "M13.5 19h-8.5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4", "key": "svg-1" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-2" }]]);

var IconMailBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailBitcoin
});

var IconMailBolt = createReactComponent("outline", "mail-bolt", "IconMailBolt", [["path", { "d": "M13 19h-8a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }]]);

var IconMailBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailBolt
});

var IconMailCancel = createReactComponent("outline", "mail-cancel", "IconMailCancel", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-3" }]]);

var IconMailCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailCancel
});

var IconMailCheck = createReactComponent("outline", "mail-check", "IconMailCheck", [["path", { "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconMailCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailCheck
});

var IconMailCode = createReactComponent("outline", "mail-code", "IconMailCode", [["path", { "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

var IconMailCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailCode
});

var IconMailCog = createReactComponent("outline", "mail-cog", "IconMailCog", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-3" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-4" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-8" }]]);

var IconMailCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailCog
});

var IconMailDollar = createReactComponent("outline", "mail-dollar", "IconMailDollar", [["path", { "d": "M13.5 19h-8.5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v3.5", "key": "svg-0" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-2" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-3" }]]);

var IconMailDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailDollar
});

var IconMailDown = createReactComponent("outline", "mail-down", "IconMailDown", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-3" }]]);

var IconMailDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailDown
});

var IconMailExclamation = createReactComponent("outline", "mail-exclamation", "IconMailExclamation", [["path", { "d": "M15 19h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconMailExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailExclamation
});

var IconMailFast = createReactComponent("outline", "mail-fast", "IconMailFast", [["path", { "d": "M3 7h3", "key": "svg-0" }], ["path", { "d": "M3 11h2", "key": "svg-1" }], ["path", { "d": "M9.02 8.801l-.6 6a2 2 0 0 0 1.99 2.199h7.98a2 2 0 0 0 1.99 -1.801l.6 -6a2 2 0 0 0 -1.99 -2.199h-7.98a2 2 0 0 0 -1.99 1.801z", "key": "svg-2" }], ["path", { "d": "M9.8 7.5l2.982 3.28a3 3 0 0 0 4.238 .202l3.28 -2.982", "key": "svg-3" }]]);

var IconMailFast$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailFast
});

var IconMailForward = createReactComponent("outline", "mail-forward", "IconMailForward", [["path", { "d": "M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5", "key": "svg-0" }], ["path", { "d": "M3 6l9 6l9 -6", "key": "svg-1" }], ["path", { "d": "M15 18h6", "key": "svg-2" }], ["path", { "d": "M18 15l3 3l-3 3", "key": "svg-3" }]]);

var IconMailForward$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailForward
});

var IconMailHeart = createReactComponent("outline", "mail-heart", "IconMailHeart", [["path", { "d": "M10.5 19h-5.5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l2.983 -1.989l6.017 -4.011", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconMailHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailHeart
});

var IconMailMinus = createReactComponent("outline", "mail-minus", "IconMailMinus", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-2" }]]);

var IconMailMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailMinus
});

var IconMailOff = createReactComponent("outline", "mail-off", "IconMailOff", [["path", { "d": "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l.565 -.377m2.435 -1.623l6 -4", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconMailOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailOff
});

var IconMailOpened = createReactComponent("outline", "mail-opened", "IconMailOpened", [["path", { "d": "M3 9l9 6l9 -6l-9 -6l-9 6", "key": "svg-0" }], ["path", { "d": "M21 9v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10", "key": "svg-1" }], ["path", { "d": "M3 19l6 -6", "key": "svg-2" }], ["path", { "d": "M15 13l6 6", "key": "svg-3" }]]);

var IconMailOpened$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailOpened
});

var IconMailPause = createReactComponent("outline", "mail-pause", "IconMailPause", [["path", { "d": "M13 19h-8a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

var IconMailPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailPause
});

var IconMailPin = createReactComponent("outline", "mail-pin", "IconMailPin", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-3" }]]);

var IconMailPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailPin
});

var IconMailPlus = createReactComponent("outline", "mail-plus", "IconMailPlus", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-3" }]]);

var IconMailPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailPlus
});

var IconMailQuestion = createReactComponent("outline", "mail-question", "IconMailQuestion", [["path", { "d": "M15 19h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-3" }]]);

var IconMailQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailQuestion
});

var IconMailSearch = createReactComponent("outline", "mail-search", "IconMailSearch", [["path", { "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-3" }]]);

var IconMailSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailSearch
});

var IconMailShare = createReactComponent("outline", "mail-share", "IconMailShare", [["path", { "d": "M13 19h-8a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconMailShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailShare
});

var IconMailSpark = createReactComponent("outline", "mail-spark", "IconMailSpark", [["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-0" }], ["path", { "d": "M11.5 19h-6.5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5", "key": "svg-1" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-2" }]]);

var IconMailSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailSpark
});

var IconMailStar = createReactComponent("outline", "mail-star", "IconMailStar", [["path", { "d": "M10 19h-5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconMailStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailStar
});

var IconMailUp = createReactComponent("outline", "mail-up", "IconMailUp", [["path", { "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-3" }]]);

var IconMailUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailUp
});

var IconMailX = createReactComponent("outline", "mail-x", "IconMailX", [["path", { "d": "M13.5 19h-8.5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-2" }], ["path", { "d": "M17 22l5 -5", "key": "svg-3" }]]);

var IconMailX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailX
});

var IconMail = createReactComponent("outline", "mail", "IconMail", [["path", { "d": "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z", "key": "svg-0" }], ["path", { "d": "M3 7l9 6l9 -6", "key": "svg-1" }]]);

var IconMail$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMail
});

var IconMailboxOff = createReactComponent("outline", "mailbox-off", "IconMailboxOff", [["path", { "d": "M10 21v-6.5a3.5 3.5 0 0 0 -7 0v6.5h18m0 -4v-2a4 4 0 0 0 -4 -4h-2m-4 0h-4.5", "key": "svg-0" }], ["path", { "d": "M12 8v-5h4l2 2l-2 2h-4", "key": "svg-1" }], ["path", { "d": "M6 15h1", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconMailboxOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailboxOff
});

var IconMailbox = createReactComponent("outline", "mailbox", "IconMailbox", [["path", { "d": "M10 21v-6.5a3.5 3.5 0 0 0 -7 0v6.5h18v-6a4 4 0 0 0 -4 -4h-10.5", "key": "svg-0" }], ["path", { "d": "M12 11v-8h4l2 2l-2 2h-4", "key": "svg-1" }], ["path", { "d": "M6 15h1", "key": "svg-2" }]]);

var IconMailbox$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailbox
});

var IconMan = createReactComponent("outline", "man", "IconMan", [["path", { "d": "M10 16v5", "key": "svg-0" }], ["path", { "d": "M14 16v5", "key": "svg-1" }], ["path", { "d": "M9 9h6l-1 7h-4z", "key": "svg-2" }], ["path", { "d": "M5 11c1.333 -1.333 2.667 -2 4 -2", "key": "svg-3" }], ["path", { "d": "M19 11c-1.333 -1.333 -2.667 -2 -4 -2", "key": "svg-4" }], ["path", { "d": "M12 4m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-5" }]]);

var IconMan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMan
});

var IconManualGearbox = createReactComponent("outline", "manual-gearbox", "IconManualGearbox", [["path", { "d": "M5 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M5 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M12 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M5 8l0 8", "key": "svg-5" }], ["path", { "d": "M12 8l0 8", "key": "svg-6" }], ["path", { "d": "M19 8v2a2 2 0 0 1 -2 2h-12", "key": "svg-7" }]]);

var IconManualGearbox$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconManualGearbox
});

var IconMap2 = createReactComponent("outline", "map-2", "IconMap2", [["path", { "d": "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v7.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v5.5", "key": "svg-2" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-3" }], ["path", { "d": "M19 18v.01", "key": "svg-4" }]]);

var IconMap2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMap2
});

var IconMapBolt = createReactComponent("outline", "map-bolt", "IconMapBolt", [["path", { "d": "M13 19l-4 -2l-6 3v-13l6 -3l6 3l6 -3v8.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v7.5", "key": "svg-2" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-3" }]]);

var IconMapBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapBolt
});

var IconMapCancel = createReactComponent("outline", "map-cancel", "IconMapCancel", [["path", { "d": "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v8", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v6", "key": "svg-2" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M17 21l4 -4", "key": "svg-4" }]]);

var IconMapCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapCancel
});

var IconMapCheck = createReactComponent("outline", "map-check", "IconMapCheck", [["path", { "d": "M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v9", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v8", "key": "svg-2" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-3" }]]);

var IconMapCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapCheck
});

var IconMapCode = createReactComponent("outline", "map-code", "IconMapCode", [["path", { "d": "M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v9", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v6.5", "key": "svg-2" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-3" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-4" }]]);

var IconMapCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapCode
});

var IconMapCog = createReactComponent("outline", "map-cog", "IconMapCog", [["path", { "d": "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v8", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v6.5", "key": "svg-2" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-4" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-5" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-6" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-7" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-8" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-9" }]]);

var IconMapCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapCog
});

var IconMapDiscount = createReactComponent("outline", "map-discount", "IconMapDiscount", [["path", { "d": "M13 19l-4 -2l-6 3v-13l6 -3l6 3l6 -3v8.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v5.5", "key": "svg-2" }], ["path", { "d": "M16 21l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21v.01", "key": "svg-4" }], ["path", { "d": "M16 16v.01", "key": "svg-5" }]]);

var IconMapDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapDiscount
});

var IconMapDollar = createReactComponent("outline", "map-dollar", "IconMapDollar", [["path", { "d": "M13 19l-4 -2l-6 3v-13l6 -3l6 3l6 -3v6.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v5", "key": "svg-2" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-4" }]]);

var IconMapDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapDollar
});

var IconMapDown = createReactComponent("outline", "map-down", "IconMapDown", [["path", { "d": "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v8.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v8", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-4" }]]);

var IconMapDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapDown
});

var IconMapEast = createReactComponent("outline", "map-east", "IconMapEast", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14 9h-4v6h4", "key": "svg-1" }], ["path", { "d": "M10 12h2.5", "key": "svg-2" }]]);

var IconMapEast$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapEast
});

var IconMapExclamation = createReactComponent("outline", "map-exclamation", "IconMapExclamation", [["path", { "d": "M15 20l-6 -3l-6 3v-13l6 -3l6 3l6 -3v8.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v13", "key": "svg-2" }], ["path", { "d": "M19 16v3", "key": "svg-3" }], ["path", { "d": "M19 22v.01", "key": "svg-4" }]]);

var IconMapExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapExclamation
});

var IconMapHeart = createReactComponent("outline", "map-heart", "IconMapHeart", [["path", { "d": "M10 17.5l-1 -.5l-6 3v-13l6 -3l6 3l6 -3v7", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v4", "key": "svg-2" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-3" }]]);

var IconMapHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapHeart
});

var IconMapMinus = createReactComponent("outline", "map-minus", "IconMapMinus", [["path", { "d": "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v11", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v8", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconMapMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapMinus
});

var IconMapNorth = createReactComponent("outline", "map-north", "IconMapNorth", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 15v-6l4 6v-6", "key": "svg-1" }]]);

var IconMapNorth$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapNorth
});

var IconMapOff = createReactComponent("outline", "map-off", "IconMapOff", [["path", { "d": "M8.32 4.34l.68 -.34l6 3l6 -3v13m-2.67 1.335l-3.33 1.665l-6 -3l-6 3v-13l2.665 -1.333", "key": "svg-0" }], ["path", { "d": "M9 4v1m0 4v8", "key": "svg-1" }], ["path", { "d": "M15 7v4m0 4v5", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconMapOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapOff
});

var IconMapPause = createReactComponent("outline", "map-pause", "IconMapPause", [["path", { "d": "M13 19l-4 -2l-6 3v-13l6 -3l6 3l6 -3v9", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v6.5", "key": "svg-2" }], ["path", { "d": "M17 17v5", "key": "svg-3" }], ["path", { "d": "M21 17v5", "key": "svg-4" }]]);

var IconMapPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPause
});

var IconMapPin2 = createReactComponent("outline", "map-pin-2", "IconMapPin2", [["path", { "d": "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v7", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v5", "key": "svg-2" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-3" }], ["path", { "d": "M19 18v.01", "key": "svg-4" }]]);

var IconMapPin2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPin2
});

var IconMapPinBolt = createReactComponent("outline", "map-pin-bolt", "IconMapPinBolt", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M13.414 20.9a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 13.591 -4.629", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }]]);

var IconMapPinBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinBolt
});

var IconMapPinCancel = createReactComponent("outline", "map-pin-cancel", "IconMapPinCancel", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12.463 21.431a1.999 1.999 0 0 1 -1.876 -.531l-4.244 -4.243a8 8 0 1 1 13.594 -4.655", "key": "svg-1" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M17 21l4 -4", "key": "svg-3" }]]);

var IconMapPinCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinCancel
});

var IconMapPinCheck = createReactComponent("outline", "map-pin-check", "IconMapPinCheck", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M11.87 21.48a1.992 1.992 0 0 1 -1.283 -.58l-4.244 -4.243a8 8 0 1 1 13.355 -3.474", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconMapPinCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinCheck
});

var IconMapPinCode = createReactComponent("outline", "map-pin-code", "IconMapPinCode", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M11.85 21.48a1.992 1.992 0 0 1 -1.263 -.58l-4.244 -4.243a8 8 0 1 1 13.385 -3.585", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

var IconMapPinCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinCode
});

var IconMapPinCog = createReactComponent("outline", "map-pin-cog", "IconMapPinCog", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12.005 21.485a1.994 1.994 0 0 1 -1.418 -.585l-4.244 -4.243a8 8 0 1 1 13.634 -5.05", "key": "svg-1" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-3" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-4" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-8" }]]);

var IconMapPinCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinCog
});

var IconMapPinDollar = createReactComponent("outline", "map-pin-dollar", "IconMapPinDollar", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M13.02 21.206a2 2 0 0 1 -2.433 -.306l-4.244 -4.243a8 8 0 1 1 13.607 -6.555", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconMapPinDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinDollar
});

var IconMapPinDown = createReactComponent("outline", "map-pin-down", "IconMapPinDown", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12.736 21.345a2 2 0 0 1 -2.149 -.445l-4.244 -4.243a8 8 0 1 1 13.59 -4.624", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-3" }]]);

var IconMapPinDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinDown
});

var IconMapPinExclamation = createReactComponent("outline", "map-pin-exclamation", "IconMapPinExclamation", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M15.005 19.31l-1.591 1.59a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 13.592 -4.638", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconMapPinExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinExclamation
});

var IconMapPinHeart = createReactComponent("outline", "map-pin-heart", "IconMapPinHeart", [["path", { "d": "M15 11a3 3 0 1 0 -3.973 2.839", "key": "svg-0" }], ["path", { "d": "M11.76 21.47a1.991 1.991 0 0 1 -1.173 -.57l-4.244 -4.243a8 8 0 1 1 13.657 -5.588", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconMapPinHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinHeart
});

var IconMapPinMinus = createReactComponent("outline", "map-pin-minus", "IconMapPinMinus", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12.758 21.337a2 2 0 0 1 -2.171 -.437l-4.244 -4.243a8 8 0 1 1 12.585 -1.652", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconMapPinMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinMinus
});

var IconMapPinOff = createReactComponent("outline", "map-pin-off", "IconMapPinOff", [["path", { "d": "M9.442 9.432a3 3 0 0 0 4.113 4.134m1.445 -2.566a3 3 0 0 0 -3 -3", "key": "svg-0" }], ["path", { "d": "M17.152 17.162l-3.738 3.738a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 0 1 -.476 -10.794m2.18 -1.82a8.003 8.003 0 0 1 10.91 10.912", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconMapPinOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinOff
});

var IconMapPinPause = createReactComponent("outline", "map-pin-pause", "IconMapPinPause", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M13.414 20.9a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 13.337 -3.413", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

var IconMapPinPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinPause
});

var IconMapPinPin = createReactComponent("outline", "map-pin-pin", "IconMapPinPin", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12.783 21.326a2 2 0 0 1 -2.196 -.426l-4.244 -4.243a8 8 0 1 1 13.657 -5.62", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }]]);

var IconMapPinPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinPin
});

var IconMapPinPlus = createReactComponent("outline", "map-pin-plus", "IconMapPinPlus", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12.794 21.322a2 2 0 0 1 -2.207 -.422l-4.244 -4.243a8 8 0 1 1 13.59 -4.616", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconMapPinPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinPlus
});

var IconMapPinQuestion = createReactComponent("outline", "map-pin-question", "IconMapPinQuestion", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M14.997 19.317l-1.583 1.583a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 13.657 -5.584", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }]]);

var IconMapPinQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinQuestion
});

var IconMapPinSearch = createReactComponent("outline", "map-pin-search", "IconMapPinSearch", [["path", { "d": "M14.916 11.707a3 3 0 1 0 -2.916 2.293", "key": "svg-0" }], ["path", { "d": "M11.991 21.485a1.994 1.994 0 0 1 -1.404 -.585l-4.244 -4.243a8 8 0 1 1 13.651 -5.351", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconMapPinSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinSearch
});

var IconMapPinShare = createReactComponent("outline", "map-pin-share", "IconMapPinShare", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12.02 21.485a1.996 1.996 0 0 1 -1.433 -.585l-4.244 -4.243a8 8 0 1 1 13.403 -3.651", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconMapPinShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinShare
});

var IconMapPinStar = createReactComponent("outline", "map-pin-star", "IconMapPinStar", [["path", { "d": "M15 11a3 3 0 1 0 -3.908 2.86", "key": "svg-0" }], ["path", { "d": "M11.059 21.25a2 2 0 0 1 -.472 -.35l-4.244 -4.243a8 8 0 1 1 13.646 -6.079", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconMapPinStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinStar
});

var IconMapPinUp = createReactComponent("outline", "map-pin-up", "IconMapPinUp", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12.789 21.324a2 2 0 0 1 -2.202 -.424l-4.244 -4.243a8 8 0 1 1 13.59 -4.626", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }]]);

var IconMapPinUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinUp
});

var IconMapPinX = createReactComponent("outline", "map-pin-x", "IconMapPinX", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M13.024 21.204a2 2 0 0 1 -2.437 -.304l-4.244 -4.243a8 8 0 1 1 13.119 -2.766", "key": "svg-1" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-2" }], ["path", { "d": "M17 22l5 -5", "key": "svg-3" }]]);

var IconMapPinX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinX
});

var IconMapPin = createReactComponent("outline", "map-pin", "IconMapPin", [["path", { "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z", "key": "svg-1" }]]);

var IconMapPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPin
});

var IconMapPins = createReactComponent("outline", "map-pins", "IconMapPins", [["path", { "d": "M10.828 9.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z", "key": "svg-0" }], ["path", { "d": "M8 7l0 .01", "key": "svg-1" }], ["path", { "d": "M18.828 17.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z", "key": "svg-2" }], ["path", { "d": "M16 15l0 .01", "key": "svg-3" }]]);

var IconMapPins$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPins
});

var IconMapPlus = createReactComponent("outline", "map-plus", "IconMapPlus", [["path", { "d": "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v8.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v8", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconMapPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPlus
});

var IconMapQuestion = createReactComponent("outline", "map-question", "IconMapQuestion", [["path", { "d": "M15 20l-6 -3l-6 3v-13l6 -3l6 3l6 -3v7.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v5.5", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-4" }]]);

var IconMapQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapQuestion
});

var IconMapRoute = createReactComponent("outline", "map-route", "IconMapRoute", [["path", { "d": "M3 7l6 -3l6 3l6 -3v13l-6 3l-6 -3l-6 3v-13", "key": "svg-0" }], ["path", { "d": "M9 12v.01", "key": "svg-1" }], ["path", { "d": "M6 13v.01", "key": "svg-2" }], ["path", { "d": "M17 15l-4 -4", "key": "svg-3" }], ["path", { "d": "M13 15l4 -4", "key": "svg-4" }]]);

var IconMapRoute$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapRoute
});

var IconMapSearch = createReactComponent("outline", "map-search", "IconMapSearch", [["path", { "d": "M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v7.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v5", "key": "svg-2" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-4" }]]);

var IconMapSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapSearch
});

var IconMapShare = createReactComponent("outline", "map-share", "IconMapShare", [["path", { "d": "M13 19l-4 -2l-6 3v-13l6 -3l6 3l6 -3v9", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v6.5", "key": "svg-2" }], ["path", { "d": "M16 22l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-4" }]]);

var IconMapShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapShare
});

var IconMapSouth = createReactComponent("outline", "map-south", "IconMapSouth", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 14.25c0 .414 .336 .75 .75 .75h2.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h2.25a.75 .75 0 0 1 .75 .75", "key": "svg-1" }]]);

var IconMapSouth$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapSouth
});

var IconMapStar = createReactComponent("outline", "map-star", "IconMapStar", [["path", { "d": "M9.718 17.359l-.718 -.359l-6 3v-13l6 -3l6 3l6 -3v7.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v4", "key": "svg-2" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-3" }]]);

var IconMapStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapStar
});

var IconMapUp = createReactComponent("outline", "map-up", "IconMapUp", [["path", { "d": "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v8.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v7.5", "key": "svg-2" }], ["path", { "d": "M19 22v-6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-4" }]]);

var IconMapUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapUp
});

var IconMapWest = createReactComponent("outline", "map-west", "IconMapWest", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 9l1 6l2 -3.75l2 3.75l1 -6", "key": "svg-1" }]]);

var IconMapWest$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapWest
});

var IconMapX = createReactComponent("outline", "map-x", "IconMapX", [["path", { "d": "M14 19.5l-5 -2.5l-6 3v-13l6 -3l6 3l6 -3v9", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v6.5", "key": "svg-2" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-3" }], ["path", { "d": "M17 22l5 -5", "key": "svg-4" }]]);

var IconMapX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapX
});

var IconMap = createReactComponent("outline", "map", "IconMap", [["path", { "d": "M3 7l6 -3l6 3l6 -3v13l-6 3l-6 -3l-6 3v-13", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v13", "key": "svg-2" }]]);

var IconMap$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMap
});

var IconMarkdownOff = createReactComponent("outline", "markdown-off", "IconMarkdownOff", [["path", { "d": "M9 5h10a2 2 0 0 1 2 2v10", "key": "svg-0" }], ["path", { "d": "M19 19h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 1.85 -2", "key": "svg-1" }], ["path", { "d": "M7 15v-6l2 2l1 -1m1 1v4", "key": "svg-2" }], ["path", { "d": "M17.5 13.5l.5 -.5m-2 -1v-3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconMarkdownOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMarkdownOff
});

var IconMarkdown = createReactComponent("outline", "markdown", "IconMarkdown", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 15v-6l2 2l2 -2v6", "key": "svg-1" }], ["path", { "d": "M14 13l2 2l2 -2m-2 2v-6", "key": "svg-2" }]]);

var IconMarkdown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMarkdown
});

var IconMarquee2 = createReactComponent("outline", "marquee-2", "IconMarquee2", [["path", { "d": "M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2", "key": "svg-0" }]]);

var IconMarquee2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMarquee2
});

var IconMarqueeOff = createReactComponent("outline", "marquee-off", "IconMarqueeOff", [["path", { "d": "M4 6c0 -.556 .227 -1.059 .593 -1.421", "key": "svg-0" }], ["path", { "d": "M9 4h1.5", "key": "svg-1" }], ["path", { "d": "M13.5 4h1.5", "key": "svg-2" }], ["path", { "d": "M18 4a2 2 0 0 1 2 2", "key": "svg-3" }], ["path", { "d": "M20 9v1.5", "key": "svg-4" }], ["path", { "d": "M20 13.5v1.5", "key": "svg-5" }], ["path", { "d": "M19.402 19.426a1.993 1.993 0 0 1 -1.402 .574", "key": "svg-6" }], ["path", { "d": "M15 20h-1.5", "key": "svg-7" }], ["path", { "d": "M10.5 20h-1.5", "key": "svg-8" }], ["path", { "d": "M6 20a2 2 0 0 1 -2 -2", "key": "svg-9" }], ["path", { "d": "M4 15v-1.5", "key": "svg-10" }], ["path", { "d": "M4 10.5v-1.5", "key": "svg-11" }], ["path", { "d": "M3 3l18 18", "key": "svg-12" }]]);

var IconMarqueeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMarqueeOff
});

var IconMarquee = createReactComponent("outline", "marquee", "IconMarquee", [["path", { "d": "M4 6a2 2 0 0 1 2 -2m3 0h1.5m3 0h1.5m3 0a2 2 0 0 1 2 2m0 3v1.5m0 3v1.5m0 3a2 2 0 0 1 -2 2m-3 0h-1.5m-3 0h-1.5m-3 0a2 2 0 0 1 -2 -2m0 -3v-1.5m0 -3v-1.5m0 -3", "key": "svg-0" }]]);

var IconMarquee$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMarquee
});

var IconMars = createReactComponent("outline", "mars", "IconMars", [["path", { "d": "M10 14m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M19 5l-5.4 5.4", "key": "svg-1" }], ["path", { "d": "M19 5l-5 0", "key": "svg-2" }], ["path", { "d": "M19 5l0 5", "key": "svg-3" }]]);

var IconMars$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMars
});

var IconMaskOff = createReactComponent("outline", "mask-off", "IconMaskOff", [["path", { "d": "M19.42 19.41a2 2 0 0 1 -1.42 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.055 .588 -1.417m3.412 -.583h10a2 2 0 0 1 2 2v10", "key": "svg-0" }], ["path", { "d": "M9.885 9.872a3 3 0 1 0 4.245 4.24m.582 -3.396a3.012 3.012 0 0 0 -1.438 -1.433", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconMaskOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMaskOff
});

var IconMask = createReactComponent("outline", "mask", "IconMask", [["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconMask$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMask
});

var IconMasksTheaterOff = createReactComponent("outline", "masks-theater-off", "IconMasksTheaterOff", [["path", { "d": "M13 9c.058 0 .133 0 .192 0h6.616a2 2 0 0 1 1.992 2.183l-.554 6.041m-1.286 2.718a3.99 3.99 0 0 1 -2.71 1.058h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182", "key": "svg-0" }], ["path", { "d": "M18 13h.01", "key": "svg-1" }], ["path", { "d": "M15 16.5c.657 .438 1.313 .588 1.97 .451", "key": "svg-2" }], ["path", { "d": "M8.632 15.982a4.05 4.05 0 0 1 -.382 .018h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182a2 2 0 0 1 .514 -1.531a1.99 1.99 0 0 1 1.286 -.652m4 0h2.808a2 2 0 0 1 2 2", "key": "svg-3" }], ["path", { "d": "M6 8h.01", "key": "svg-4" }], ["path", { "d": "M6 12c.764 -.51 1.528 -.63 2.291 -.36", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconMasksTheaterOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMasksTheaterOff
});

var IconMasksTheater = createReactComponent("outline", "masks-theater", "IconMasksTheater", [["path", { "d": "M13.192 9h6.616a2 2 0 0 1 1.992 2.183l-.567 6.182a4 4 0 0 1 -3.983 3.635h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182a2 2 0 0 1 1.992 -2.183z", "key": "svg-0" }], ["path", { "d": "M15 13h.01", "key": "svg-1" }], ["path", { "d": "M18 13h.01", "key": "svg-2" }], ["path", { "d": "M15 16.5c1 .667 2 .667 3 0", "key": "svg-3" }], ["path", { "d": "M8.632 15.982a4.037 4.037 0 0 1 -.382 .018h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182a2 2 0 0 1 1.992 -2.183h6.616a2 2 0 0 1 2 2", "key": "svg-4" }], ["path", { "d": "M6 8h.01", "key": "svg-5" }], ["path", { "d": "M9 8h.01", "key": "svg-6" }], ["path", { "d": "M6 12c.764 -.51 1.528 -.63 2.291 -.36", "key": "svg-7" }]]);

var IconMasksTheater$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMasksTheater
});

var IconMassage = createReactComponent("outline", "massage", "IconMassage", [["path", { "d": "M4 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M9 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M4 22l4 -2v-3h12", "key": "svg-2" }], ["path", { "d": "M11 20h9", "key": "svg-3" }], ["path", { "d": "M8 14l3 -2l1 -4c3 1 3 4 3 6", "key": "svg-4" }]]);

var IconMassage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMassage
});

var IconMatchstick = createReactComponent("outline", "matchstick", "IconMatchstick", [["path", { "d": "M3 21l14 -9", "key": "svg-0" }], ["path", { "d": "M17 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M17 3l3.62 7.29a4.007 4.007 0 0 1 -.764 4.51a4 4 0 0 1 -6.493 -4.464l3.637 -7.336z", "key": "svg-2" }]]);

var IconMatchstick$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMatchstick
});

var IconMath1Divide2 = createReactComponent("outline", "math-1-divide-2", "IconMath1Divide2", [["path", { "d": "M5 12h14", "key": "svg-0" }], ["path", { "d": "M10 15h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M10 5l2 -2v6", "key": "svg-2" }]]);

var IconMath1Divide2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMath1Divide2
});

var IconMath1Divide3 = createReactComponent("outline", "math-1-divide-3", "IconMath1Divide3", [["path", { "d": "M10 15.5a.5 .5 0 0 1 .5 -.5h2a1.5 1.5 0 0 1 0 3h-1.167h1.167a1.5 1.5 0 0 1 0 3h-2a.5 .5 0 0 1 -.5 -.5", "key": "svg-0" }], ["path", { "d": "M5 12h14", "key": "svg-1" }], ["path", { "d": "M10 5l2 -2v6", "key": "svg-2" }]]);

var IconMath1Divide3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMath1Divide3
});

var IconMathAvg = createReactComponent("outline", "math-avg", "IconMathAvg", [["path", { "d": "M3 21l18 -18", "key": "svg-0" }], ["path", { "d": "M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0", "key": "svg-1" }]]);

var IconMathAvg$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathAvg
});

var IconMathCos = createReactComponent("outline", "math-cos", "IconMathCos", [["path", { "d": "M7 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-0" }], ["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2", "key": "svg-1" }], ["path", { "d": "M17 15c.345 .6 1.258 1 2 1a2 2 0 1 0 0 -4a2 2 0 1 1 0 -4c.746 0 1.656 .394 2 1", "key": "svg-2" }]]);

var IconMathCos$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathCos
});

var IconMathCtg = createReactComponent("outline", "math-ctg", "IconMathCtg", [["path", { "d": "M10 8h4", "key": "svg-0" }], ["path", { "d": "M21 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-1" }], ["path", { "d": "M12 8v8", "key": "svg-2" }], ["path", { "d": "M7 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-3" }]]);

var IconMathCtg$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathCtg
});

var IconMathEqualGreater = createReactComponent("outline", "math-equal-greater", "IconMathEqualGreater", [["path", { "d": "M5 18l14 -4", "key": "svg-0" }], ["path", { "d": "M5 14l14 -4l-14 -4", "key": "svg-1" }]]);

var IconMathEqualGreater$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathEqualGreater
});

var IconMathEqualLower = createReactComponent("outline", "math-equal-lower", "IconMathEqualLower", [["path", { "d": "M19 18l-14 -4", "key": "svg-0" }], ["path", { "d": "M19 14l-14 -4l14 -4", "key": "svg-1" }]]);

var IconMathEqualLower$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathEqualLower
});

var IconMathFunctionOff = createReactComponent("outline", "math-function-off", "IconMathFunctionOff", [["path", { "d": "M14 10h1c.882 0 .986 .777 1.694 2.692", "key": "svg-0" }], ["path", { "d": "M13 17c.864 0 1.727 -.663 2.495 -1.512m1.717 -2.302c.993 -1.45 2.39 -3.186 3.788 -3.186", "key": "svg-1" }], ["path", { "d": "M3 19c0 1.5 .5 2 2 2s2 -4 3 -9c.237 -1.186 .446 -2.317 .647 -3.35m.727 -3.248c.423 -1.492 .91 -2.402 1.626 -2.402c1.5 0 2 .5 2 2", "key": "svg-2" }], ["path", { "d": "M5 12h6", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconMathFunctionOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathFunctionOff
});

var IconMathFunctionY = createReactComponent("outline", "math-function-y", "IconMathFunctionY", [["path", { "d": "M3 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M5 12h6", "key": "svg-1" }], ["path", { "d": "M15 12l3 5.063", "key": "svg-2" }], ["path", { "d": "M21 12l-4.8 9", "key": "svg-3" }]]);

var IconMathFunctionY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathFunctionY
});

var IconMathFunction = createReactComponent("outline", "math-function", "IconMathFunction", [["path", { "d": "M3 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M5 12h6", "key": "svg-1" }], ["path", { "d": "M15 12l6 6", "key": "svg-2" }], ["path", { "d": "M15 18l6 -6", "key": "svg-3" }]]);

var IconMathFunction$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathFunction
});

var IconMathGreater = createReactComponent("outline", "math-greater", "IconMathGreater", [["path", { "d": "M5 18l14 -6l-14 -6", "key": "svg-0" }]]);

var IconMathGreater$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathGreater
});

var IconMathIntegralX = createReactComponent("outline", "math-integral-x", "IconMathIntegralX", [["path", { "d": "M3 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M14 12l6 6", "key": "svg-1" }], ["path", { "d": "M14 18l6 -6", "key": "svg-2" }]]);

var IconMathIntegralX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathIntegralX
});

var IconMathIntegral = createReactComponent("outline", "math-integral", "IconMathIntegral", [["path", { "d": "M7 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2", "key": "svg-0" }]]);

var IconMathIntegral$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathIntegral
});

var IconMathIntegrals = createReactComponent("outline", "math-integrals", "IconMathIntegrals", [["path", { "d": "M3 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M11 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2", "key": "svg-1" }]]);

var IconMathIntegrals$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathIntegrals
});

var IconMathLower = createReactComponent("outline", "math-lower", "IconMathLower", [["path", { "d": "M19 18l-14 -6l14 -6", "key": "svg-0" }]]);

var IconMathLower$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathLower
});

var IconMathMaxMin = createReactComponent("outline", "math-max-min", "IconMathMaxMin", [["path", { "d": "M15 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-1" }], ["path", { "d": "M3 14s.605 -5.44 2.284 -7.862m3.395 .026c2.137 2.652 4.547 9.113 6.68 11.719", "key": "svg-2" }], ["path", { "d": "M18.748 18.038c.702 -.88 1.452 -3.56 2.252 -8.038", "key": "svg-3" }]]);

var IconMathMaxMin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathMaxMin
});

var IconMathMax = createReactComponent("outline", "math-max", "IconMathMax", [["path", { "d": "M5 6a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M3 15s.616 -5.544 2.332 -7.93", "key": "svg-1" }], ["path", { "d": "M8.637 7.112c2.717 3.313 5.882 12.888 8.363 12.888c2 0 3.333 -3 4 -9", "key": "svg-2" }]]);

var IconMathMax$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathMax
});

var IconMathMin = createReactComponent("outline", "math-min", "IconMathMin", [["path", { "d": "M15 18a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M3 13s1 -9 4 -9c2.48 0 5.643 9.565 8.36 12.883", "key": "svg-1" }], ["path", { "d": "M18.748 17.038c.702 -.88 1.452 -3.56 2.252 -8.038", "key": "svg-2" }]]);

var IconMathMin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathMin
});

var IconMathNot = createReactComponent("outline", "math-not", "IconMathNot", [["path", { "d": "M5 12h14v4", "key": "svg-0" }]]);

var IconMathNot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathNot
});

var IconMathOff = createReactComponent("outline", "math-off", "IconMathOff", [["path", { "d": "M14 19l2.5 -2.5", "key": "svg-0" }], ["path", { "d": "M18.5 14.5l1.5 -1.5", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }], ["path", { "d": "M19 5h-7l-.646 2.262", "key": "svg-3" }], ["path", { "d": "M10.448 10.431l-2.448 8.569l-3 -6h-2", "key": "svg-4" }]]);

var IconMathOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathOff
});

var IconMathPiDivide2 = createReactComponent("outline", "math-pi-divide-2", "IconMathPiDivide2", [["path", { "d": "M10 15h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M5 12h14", "key": "svg-1" }], ["path", { "d": "M10 9v-6", "key": "svg-2" }], ["path", { "d": "M14 3v6", "key": "svg-3" }], ["path", { "d": "M15 3h-6", "key": "svg-4" }]]);

var IconMathPiDivide2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathPiDivide2
});

var IconMathPi = createReactComponent("outline", "math-pi", "IconMathPi", [["path", { "d": "M7 20v-16", "key": "svg-0" }], ["path", { "d": "M17 4v16", "key": "svg-1" }], ["path", { "d": "M20 4h-16", "key": "svg-2" }]]);

var IconMathPi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathPi
});

var IconMathSec = createReactComponent("outline", "math-sec", "IconMathSec", [["path", { "d": "M3 15c.345 .6 1.258 1 2 1a2 2 0 1 0 0 -4a2 2 0 1 1 0 -4c.746 0 1.656 .394 2 1", "key": "svg-0" }], ["path", { "d": "M21 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-1" }], ["path", { "d": "M14 8h-4v8h4", "key": "svg-2" }], ["path", { "d": "M10 12h2.5", "key": "svg-3" }]]);

var IconMathSec$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathSec
});

var IconMathSin = createReactComponent("outline", "math-sin", "IconMathSin", [["path", { "d": "M4 15c.345 .6 1.258 1 2 1a2 2 0 1 0 0 -4a2 2 0 1 1 0 -4c.746 0 1.656 .394 2 1", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }], ["path", { "d": "M16 16v-8l4 8v-8", "key": "svg-2" }]]);

var IconMathSin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathSin
});

var IconMathSymbols = createReactComponent("outline", "math-symbols", "IconMathSymbols", [["path", { "d": "M3 12l18 0", "key": "svg-0" }], ["path", { "d": "M12 3l0 18", "key": "svg-1" }], ["path", { "d": "M16.5 4.5l3 3", "key": "svg-2" }], ["path", { "d": "M19.5 4.5l-3 3", "key": "svg-3" }], ["path", { "d": "M6 4l0 4", "key": "svg-4" }], ["path", { "d": "M4 6l4 0", "key": "svg-5" }], ["path", { "d": "M18 16l.01 0", "key": "svg-6" }], ["path", { "d": "M18 20l.01 0", "key": "svg-7" }], ["path", { "d": "M4 18l4 0", "key": "svg-8" }]]);

var IconMathSymbols$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathSymbols
});

var IconMathTg = createReactComponent("outline", "math-tg", "IconMathTg", [["path", { "d": "M7 8h4", "key": "svg-0" }], ["path", { "d": "M9 8v8", "key": "svg-1" }], ["path", { "d": "M18 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-2" }]]);

var IconMathTg$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathTg
});

var IconMathXDivide2 = createReactComponent("outline", "math-x-divide-2", "IconMathXDivide2", [["path", { "d": "M10 15h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M5 12h14", "key": "svg-1" }], ["path", { "d": "M9 3l6 6", "key": "svg-2" }], ["path", { "d": "M9 9l6 -6", "key": "svg-3" }]]);

var IconMathXDivide2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathXDivide2
});

var IconMathXDivideY2 = createReactComponent("outline", "math-x-divide-y-2", "IconMathXDivideY2", [["path", { "d": "M3 21l18 -18", "key": "svg-0" }], ["path", { "d": "M15 14l3 4.5", "key": "svg-1" }], ["path", { "d": "M21 14l-4.5 7", "key": "svg-2" }], ["path", { "d": "M3 4l6 6", "key": "svg-3" }], ["path", { "d": "M3 10l6 -6", "key": "svg-4" }]]);

var IconMathXDivideY2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathXDivideY2
});

var IconMathXDivideY = createReactComponent("outline", "math-x-divide-y", "IconMathXDivideY", [["path", { "d": "M9 3l6 6", "key": "svg-0" }], ["path", { "d": "M9 9l6 -6", "key": "svg-1" }], ["path", { "d": "M9 15l3 4.5", "key": "svg-2" }], ["path", { "d": "M15 15l-4.5 7", "key": "svg-3" }], ["path", { "d": "M5 12h14", "key": "svg-4" }]]);

var IconMathXDivideY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathXDivideY
});

var IconMathXFloorDivideY = createReactComponent("outline", "math-x-floor-divide-y", "IconMathXFloorDivideY", [["path", { "d": "M1.5 19l18 -18", "key": "svg-0" }], ["path", { "d": "M4.5 22l18 -18", "key": "svg-1" }], ["path", { "d": "M18 15l3 4", "key": "svg-2" }], ["path", { "d": "M23 15l-4.5 8", "key": "svg-3" }], ["path", { "d": "M1 1l6 6", "key": "svg-4" }], ["path", { "d": "M1 7l6 -6", "key": "svg-5" }]]);

var IconMathXFloorDivideY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathXFloorDivideY
});

var IconMathXMinusX = createReactComponent("outline", "math-x-minus-x", "IconMathXMinusX", [["path", { "d": "M2 9l6 6", "key": "svg-0" }], ["path", { "d": "M2 15l6 -6", "key": "svg-1" }], ["path", { "d": "M16 9l6 6", "key": "svg-2" }], ["path", { "d": "M16 15l6 -6", "key": "svg-3" }], ["path", { "d": "M10 12h4", "key": "svg-4" }]]);

var IconMathXMinusX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathXMinusX
});

var IconMathXMinusY = createReactComponent("outline", "math-x-minus-y", "IconMathXMinusY", [["path", { "d": "M2 9l6 6", "key": "svg-0" }], ["path", { "d": "M2 15l6 -6", "key": "svg-1" }], ["path", { "d": "M16 9l3 5.063", "key": "svg-2" }], ["path", { "d": "M22 9l-4.8 9", "key": "svg-3" }], ["path", { "d": "M10 12h4", "key": "svg-4" }]]);

var IconMathXMinusY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathXMinusY
});

var IconMathXPlusX = createReactComponent("outline", "math-x-plus-x", "IconMathXPlusX", [["path", { "d": "M2 9l6 6", "key": "svg-0" }], ["path", { "d": "M2 15l6 -6", "key": "svg-1" }], ["path", { "d": "M16 9l6 6", "key": "svg-2" }], ["path", { "d": "M16 15l6 -6", "key": "svg-3" }], ["path", { "d": "M10 12h4", "key": "svg-4" }], ["path", { "d": "M12 10v4", "key": "svg-5" }]]);

var IconMathXPlusX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathXPlusX
});

var IconMathXPlusY = createReactComponent("outline", "math-x-plus-y", "IconMathXPlusY", [["path", { "d": "M16 9l3 5.063", "key": "svg-0" }], ["path", { "d": "M2 9l6 6", "key": "svg-1" }], ["path", { "d": "M2 15l6 -6", "key": "svg-2" }], ["path", { "d": "M22 9l-4.8 9", "key": "svg-3" }], ["path", { "d": "M10 12h4", "key": "svg-4" }], ["path", { "d": "M12 10v4", "key": "svg-5" }]]);

var IconMathXPlusY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathXPlusY
});

var IconMathXy = createReactComponent("outline", "math-xy", "IconMathXy", [["path", { "d": "M14 9l3 5.063", "key": "svg-0" }], ["path", { "d": "M4 9l6 6", "key": "svg-1" }], ["path", { "d": "M4 15l6 -6", "key": "svg-2" }], ["path", { "d": "M20 9l-4.8 9", "key": "svg-3" }]]);

var IconMathXy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathXy
});

var IconMathYMinusY = createReactComponent("outline", "math-y-minus-y", "IconMathYMinusY", [["path", { "d": "M2 9l3 5.063", "key": "svg-0" }], ["path", { "d": "M8 9l-4.8 9", "key": "svg-1" }], ["path", { "d": "M16 9l3 5.063", "key": "svg-2" }], ["path", { "d": "M22 9l-4.8 9", "key": "svg-3" }], ["path", { "d": "M10 12h4", "key": "svg-4" }]]);

var IconMathYMinusY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathYMinusY
});

var IconMathYPlusY = createReactComponent("outline", "math-y-plus-y", "IconMathYPlusY", [["path", { "d": "M2 9l3 5.063", "key": "svg-0" }], ["path", { "d": "M8 9l-4.8 9", "key": "svg-1" }], ["path", { "d": "M16 9l3 5.063", "key": "svg-2" }], ["path", { "d": "M22 9l-4.8 9", "key": "svg-3" }], ["path", { "d": "M10 12h4", "key": "svg-4" }], ["path", { "d": "M12 10v4", "key": "svg-5" }]]);

var IconMathYPlusY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMathYPlusY
});

var IconMath = createReactComponent("outline", "math", "IconMath", [["path", { "d": "M19 5h-7l-4 14l-3 -6h-2", "key": "svg-0" }], ["path", { "d": "M14 13l6 6", "key": "svg-1" }], ["path", { "d": "M14 19l6 -6", "key": "svg-2" }]]);

var IconMath$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMath
});

var IconMatrix = createReactComponent("outline", "matrix", "IconMatrix", [["path", { "d": "M8 16h.013", "key": "svg-0" }], ["path", { "d": "M12.01 16h.005", "key": "svg-1" }], ["path", { "d": "M16.015 16h.005", "key": "svg-2" }], ["path", { "d": "M16.015 12h.005", "key": "svg-3" }], ["path", { "d": "M8.01 12h.005", "key": "svg-4" }], ["path", { "d": "M12.01 12h.005", "key": "svg-5" }], ["path", { "d": "M16.02 8h.005", "key": "svg-6" }], ["path", { "d": "M8.015 8h.005", "key": "svg-7" }], ["path", { "d": "M12.015 8h.005", "key": "svg-8" }], ["path", { "d": "M7 4h-1a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h1", "key": "svg-9" }], ["path", { "d": "M17 4h1a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-1", "key": "svg-10" }]]);

var IconMatrix$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMatrix
});

var IconMaximizeOff = createReactComponent("outline", "maximize-off", "IconMaximizeOff", [["path", { "d": "M4 8v-2c0 -.551 .223 -1.05 .584 -1.412", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2c.545 0 1.04 -.218 1.4 -.572", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconMaximizeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMaximizeOff
});

var IconMaximize = createReactComponent("outline", "maximize", "IconMaximize", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }]]);

var IconMaximize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMaximize
});

var IconMeatOff = createReactComponent("outline", "meat-off", "IconMeatOff", [["path", { "d": "M13.62 8.382l1.966 -1.967a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-1.82 1.821", "key": "svg-0" }], ["path", { "d": "M5.904 18.596c2.733 2.734 5.9 4 7.07 2.829c1.172 -1.172 -.094 -4.338 -2.828 -7.071c-2.733 -2.734 -5.9 -4 -7.07 -2.829c-1.172 1.172 .094 4.338 2.828 7.071z", "key": "svg-1" }], ["path", { "d": "M7.5 16l1 1", "key": "svg-2" }], ["path", { "d": "M12.975 21.425c1.582 -1.582 2.679 -3.407 3.242 -5.2", "key": "svg-3" }], ["path", { "d": "M16.6 12.6c-.16 -1.238 -.653 -2.345 -1.504 -3.195c-.85 -.85 -1.955 -1.344 -3.192 -1.503", "key": "svg-4" }], ["path", { "d": "M8.274 8.284c-1.792 .563 -3.616 1.66 -5.198 3.242", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconMeatOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMeatOff
});

var IconMeat = createReactComponent("outline", "meat", "IconMeat", [["path", { "d": "M13.62 8.382l1.966 -1.967a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-1.82 1.821", "key": "svg-0" }], ["path", { "d": "M5.904 18.596c2.733 2.734 5.9 4 7.07 2.829c1.172 -1.172 -.094 -4.338 -2.828 -7.071c-2.733 -2.734 -5.9 -4 -7.07 -2.829c-1.172 1.172 .094 4.338 2.828 7.071z", "key": "svg-1" }], ["path", { "d": "M7.5 16l1 1", "key": "svg-2" }], ["path", { "d": "M12.975 21.425c3.905 -3.906 4.855 -9.288 2.121 -12.021c-2.733 -2.734 -8.115 -1.784 -12.02 2.121", "key": "svg-3" }]]);

var IconMeat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMeat
});

var IconMedal2 = createReactComponent("outline", "medal-2", "IconMedal2", [["path", { "d": "M9 3h6l3 7l-6 2l-6 -2z", "key": "svg-0" }], ["path", { "d": "M12 12l-3 -9", "key": "svg-1" }], ["path", { "d": "M15 11l-3 -8", "key": "svg-2" }], ["path", { "d": "M12 19.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z", "key": "svg-3" }]]);

var IconMedal2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMedal2
});

var IconMedal = createReactComponent("outline", "medal", "IconMedal", [["path", { "d": "M12 4v3m-4 -3v6m8 -6v6", "key": "svg-0" }], ["path", { "d": "M12 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z", "key": "svg-1" }]]);

var IconMedal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMedal
});

var IconMedicalCrossCircle = createReactComponent("outline", "medical-cross-circle", "IconMedicalCrossCircle", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }], ["path", { "d": "M15.5 10l-7 4", "key": "svg-2" }], ["path", { "d": "M15.5 14l-7 -4", "key": "svg-3" }]]);

var IconMedicalCrossCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMedicalCrossCircle
});

var IconMedicalCrossOff = createReactComponent("outline", "medical-cross-off", "IconMedicalCrossOff", [["path", { "d": "M17.928 17.733l-.574 -.331l-3.354 -1.938v4.536a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-4.536l-3.928 2.268a1 1 0 0 1 -1.366 -.366l-1 -1.732a1 1 0 0 1 .366 -1.366l3.927 -2.268l-3.927 -2.268a1 1 0 0 1 -.366 -1.366l1 -1.732a1 1 0 0 1 1.366 -.366l.333 .192m3.595 -.46v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4.535l3.928 -2.267a1 1 0 0 1 1.366 .366l1 1.732a1 1 0 0 1 -.366 1.366l-3.927 2.268l3.927 2.269a1 1 0 0 1 .366 1.366l-.24 .416", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconMedicalCrossOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMedicalCrossOff
});

var IconMedicalCross = createReactComponent("outline", "medical-cross", "IconMedicalCross", [["path", { "d": "M13 3a1 1 0 0 1 1 1v4.535l3.928 -2.267a1 1 0 0 1 1.366 .366l1 1.732a1 1 0 0 1 -.366 1.366l-3.927 2.268l3.927 2.269a1 1 0 0 1 .366 1.366l-1 1.732a1 1 0 0 1 -1.366 .366l-3.928 -2.269v4.536a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-4.536l-3.928 2.268a1 1 0 0 1 -1.366 -.366l-1 -1.732a1 1 0 0 1 .366 -1.366l3.927 -2.268l-3.927 -2.268a1 1 0 0 1 -.366 -1.366l1 -1.732a1 1 0 0 1 1.366 -.366l3.928 2.267v-4.535a1 1 0 0 1 1 -1h2z", "key": "svg-0" }]]);

var IconMedicalCross$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMedicalCross
});

var IconMedicineSyrup = createReactComponent("outline", "medicine-syrup", "IconMedicineSyrup", [["path", { "d": "M8 21h8a1 1 0 0 0 1 -1v-10a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v10a1 1 0 0 0 1 1z", "key": "svg-0" }], ["path", { "d": "M10 14h4", "key": "svg-1" }], ["path", { "d": "M12 12v4", "key": "svg-2" }], ["path", { "d": "M10 7v-3a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3", "key": "svg-3" }]]);

var IconMedicineSyrup$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMedicineSyrup
});

var IconMeeple = createReactComponent("outline", "meeple", "IconMeeple", [["path", { "d": "M9 20h-5a1 1 0 0 1 -1 -1c0 -2 3.378 -4.907 4 -6c-1 0 -4 -.5 -4 -2c0 -2 4 -3.5 6 -4c0 -1.5 .5 -4 3 -4s3 2.5 3 4c2 .5 6 2 6 4c0 1.5 -3 2 -4 2c.622 1.093 4 4 4 6a1 1 0 0 1 -1 1h-5c-1 0 -2 -4 -3 -4s-2 4 -3 4z", "key": "svg-0" }]]);

var IconMeeple$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMeeple
});

var IconMelon = createReactComponent("outline", "melon", "IconMelon", [["path", { "d": "M20 10c0 5.523 -4.477 10 -10 10a9.967 9.967 0 0 1 -6.984 -2.842l4.343 -4.153a4 4 0 0 0 5.76 -5.51l4.342 -4.153a9.963 9.963 0 0 1 2.539 6.658z", "key": "svg-0" }]]);

var IconMelon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMelon
});

var IconMenorah = createReactComponent("outline", "menorah", "IconMenorah", [["path", { "d": "M12 4v16", "key": "svg-0" }], ["path", { "d": "M8 4v2a4 4 0 1 0 8 0v-2", "key": "svg-1" }], ["path", { "d": "M4 4v2a8 8 0 1 0 16 0v-2", "key": "svg-2" }], ["path", { "d": "M10 20h4", "key": "svg-3" }]]);

var IconMenorah$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMenorah
});

var IconMenu2 = createReactComponent("outline", "menu-2", "IconMenu2", [["path", { "d": "M4 6l16 0", "key": "svg-0" }], ["path", { "d": "M4 12l16 0", "key": "svg-1" }], ["path", { "d": "M4 18l16 0", "key": "svg-2" }]]);

var IconMenu2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMenu2
});

var IconMenu3 = createReactComponent("outline", "menu-3", "IconMenu3", [["path", { "d": "M10 6h10", "key": "svg-0" }], ["path", { "d": "M4 12h16", "key": "svg-1" }], ["path", { "d": "M7 12h13", "key": "svg-2" }], ["path", { "d": "M4 18h10", "key": "svg-3" }]]);

var IconMenu3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMenu3
});

var IconMenu4 = createReactComponent("outline", "menu-4", "IconMenu4", [["path", { "d": "M7 6h10", "key": "svg-0" }], ["path", { "d": "M4 12h16", "key": "svg-1" }], ["path", { "d": "M7 12h13", "key": "svg-2" }], ["path", { "d": "M7 18h10", "key": "svg-3" }]]);

var IconMenu4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMenu4
});

var IconMenuDeep = createReactComponent("outline", "menu-deep", "IconMenuDeep", [["path", { "d": "M4 6h16", "key": "svg-0" }], ["path", { "d": "M7 12h13", "key": "svg-1" }], ["path", { "d": "M10 18h10", "key": "svg-2" }]]);

var IconMenuDeep$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMenuDeep
});

var IconMenuOrder = createReactComponent("outline", "menu-order", "IconMenuOrder", [["path", { "d": "M4 10h16", "key": "svg-0" }], ["path", { "d": "M4 14h16", "key": "svg-1" }], ["path", { "d": "M9 18l3 3l3 -3", "key": "svg-2" }], ["path", { "d": "M9 6l3 -3l3 3", "key": "svg-3" }]]);

var IconMenuOrder$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMenuOrder
});

var IconMenu = createReactComponent("outline", "menu", "IconMenu", [["path", { "d": "M4 8l16 0", "key": "svg-0" }], ["path", { "d": "M4 16l16 0", "key": "svg-1" }]]);

var IconMenu$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMenu
});

var IconMessage2Bolt = createReactComponent("outline", "message-2-bolt", "IconMessage2Bolt", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M13 20l-1 1l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-2" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-3" }]]);

var IconMessage2Bolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Bolt
});

var IconMessage2Cancel = createReactComponent("outline", "message-2-cancel", "IconMessage2Cancel", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12 21l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5", "key": "svg-2" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M17 21l4 -4", "key": "svg-4" }]]);

var IconMessage2Cancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Cancel
});

var IconMessage2Check = createReactComponent("outline", "message-2-check", "IconMessage2Check", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12 21l-1 -1l-2 -2h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-2" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-3" }]]);

var IconMessage2Check$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Check
});

var IconMessage2Code = createReactComponent("outline", "message-2-code", "IconMessage2Code", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12 21l-1 -1l-2 -2h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-2" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-3" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-4" }]]);

var IconMessage2Code$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Code
});

var IconMessage2Cog = createReactComponent("outline", "message-2-cog", "IconMessage2Cog", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12 21l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5", "key": "svg-2" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-4" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-5" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-6" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-7" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-8" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-9" }]]);

var IconMessage2Cog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Cog
});

var IconMessage2Dollar = createReactComponent("outline", "message-2-dollar", "IconMessage2Dollar", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M13.5 19.5l-1.5 1.5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v3.5", "key": "svg-2" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-4" }]]);

var IconMessage2Dollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Dollar
});

var IconMessage2Down = createReactComponent("outline", "message-2-down", "IconMessage2Down", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12.5 20.5l-.5 .5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-4" }]]);

var IconMessage2Down$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Down
});

var IconMessage2Exclamation = createReactComponent("outline", "message-2-exclamation", "IconMessage2Exclamation", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M15 18l-3 3l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-2" }], ["path", { "d": "M19 16v3", "key": "svg-3" }], ["path", { "d": "M19 22v.01", "key": "svg-4" }]]);

var IconMessage2Exclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Exclamation
});

var IconMessage2Heart = createReactComponent("outline", "message-2-heart", "IconMessage2Heart", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h3.5", "key": "svg-1" }], ["path", { "d": "M10.5 19.5l-1.5 -1.5h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4", "key": "svg-2" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-3" }]]);

var IconMessage2Heart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Heart
});

var IconMessage2Minus = createReactComponent("outline", "message-2-minus", "IconMessage2Minus", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12 21l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconMessage2Minus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Minus
});

var IconMessage2Off = createReactComponent("outline", "message-2-off", "IconMessage2Off", [["path", { "d": "M8 9h1m4 0h3", "key": "svg-0" }], ["path", { "d": "M8 13h5", "key": "svg-1" }], ["path", { "d": "M8 4h10a3 3 0 0 1 3 3v8c0 .57 -.16 1.104 -.436 1.558m-2.564 1.442h-3l-3 3l-3 -3h-3a3 3 0 0 1 -3 -3v-8c0 -1.084 .575 -2.034 1.437 -2.561", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconMessage2Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Off
});

var IconMessage2Pause = createReactComponent("outline", "message-2-pause", "IconMessage2Pause", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M13 20l-1 1l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-2" }], ["path", { "d": "M17 17v5", "key": "svg-3" }], ["path", { "d": "M21 17v5", "key": "svg-4" }]]);

var IconMessage2Pause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Pause
});

var IconMessage2Pin = createReactComponent("outline", "message-2-pin", "IconMessage2Pin", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12.5 20.5l-.5 .5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4", "key": "svg-2" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-3" }], ["path", { "d": "M19 18v.01", "key": "svg-4" }]]);

var IconMessage2Pin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Pin
});

var IconMessage2Plus = createReactComponent("outline", "message-2-plus", "IconMessage2Plus", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12.5 20.5l-.5 .5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconMessage2Plus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Plus
});

var IconMessage2Question = createReactComponent("outline", "message-2-question", "IconMessage2Question", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M14.5 18.5l-2.5 2.5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-4" }]]);

var IconMessage2Question$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Question
});

var IconMessage2Search = createReactComponent("outline", "message-2-search", "IconMessage2Search", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h5", "key": "svg-1" }], ["path", { "d": "M12 21l-.5 -.5l-2.5 -2.5h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5", "key": "svg-2" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-4" }]]);

var IconMessage2Search$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Search
});

var IconMessage2Share = createReactComponent("outline", "message-2-share", "IconMessage2Share", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12 21l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-2" }], ["path", { "d": "M16 22l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-4" }]]);

var IconMessage2Share$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Share
});

var IconMessage2Star = createReactComponent("outline", "message-2-star", "IconMessage2Star", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h4.5", "key": "svg-1" }], ["path", { "d": "M10 19l-1 -1h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5", "key": "svg-2" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-3" }]]);

var IconMessage2Star$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Star
});

var IconMessage2Up = createReactComponent("outline", "message-2-up", "IconMessage2Up", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12.354 20.646l-.354 .354l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-2" }], ["path", { "d": "M19 22v-6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-4" }]]);

var IconMessage2Up$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Up
});

var IconMessage2X = createReactComponent("outline", "message-2-x", "IconMessage2X", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M13.5 19.5l-1.5 1.5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-2" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-3" }], ["path", { "d": "M17 22l5 -5", "key": "svg-4" }]]);

var IconMessage2X$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2X
});

var IconMessage2 = createReactComponent("outline", "message-2", "IconMessage2", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M9 18h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-3l-3 3l-3 -3z", "key": "svg-2" }]]);

var IconMessage2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2
});

var IconMessageBolt = createReactComponent("outline", "message-bolt", "IconMessageBolt", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-2" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-3" }]]);

var IconMessageBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageBolt
});

var IconMessageCancel = createReactComponent("outline", "message-cancel", "IconMessageCancel", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M11.995 18.603l-3.995 2.397v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-2" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M17 21l4 -4", "key": "svg-4" }]]);

var IconMessageCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCancel
});

var IconMessageChatbot = createReactComponent("outline", "message-chatbot", "IconMessageChatbot", [["path", { "d": "M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z", "key": "svg-0" }], ["path", { "d": "M9.5 9h.01", "key": "svg-1" }], ["path", { "d": "M14.5 9h.01", "key": "svg-2" }], ["path", { "d": "M9.5 13a3.5 3.5 0 0 0 5 0", "key": "svg-3" }]]);

var IconMessageChatbot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageChatbot
});

var IconMessageCheck = createReactComponent("outline", "message-check", "IconMessageCheck", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M10.99 19.206l-2.99 1.794v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-2" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-3" }]]);

var IconMessageCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCheck
});

var IconMessageCircleBolt = createReactComponent("outline", "message-circle-bolt", "IconMessageCircleBolt", [["path", { "d": "M13.038 19.927a9.933 9.933 0 0 1 -5.338 -.927l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.993 1.7 2.93 4.043 2.746 6.346", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }]]);

var IconMessageCircleBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleBolt
});

var IconMessageCircleCancel = createReactComponent("outline", "message-circle-cancel", "IconMessageCircleCancel", [["path", { "d": "M12.015 19.98a9.87 9.87 0 0 1 -4.315 -.98l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.927 1.644 2.867 3.887 2.761 6.114", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }]]);

var IconMessageCircleCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleCancel
});

var IconMessageCircleCheck = createReactComponent("outline", "message-circle-check", "IconMessageCircleCheck", [["path", { "d": "M11.042 19.933a9.798 9.798 0 0 1 -3.342 -.933l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c2.127 1.814 3.052 4.36 2.694 6.808", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }]]);

var IconMessageCircleCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleCheck
});

var IconMessageCircleCode = createReactComponent("outline", "message-circle-code", "IconMessageCircleCode", [["path", { "d": "M11.036 19.933a9.798 9.798 0 0 1 -3.336 -.933l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c2.128 1.815 3.053 4.361 2.694 6.81", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }]]);

var IconMessageCircleCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleCode
});

var IconMessageCircleCog = createReactComponent("outline", "message-circle-cog", "IconMessageCircleCog", [["path", { "d": "M11.996 19.98a9.868 9.868 0 0 1 -4.296 -.98l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.842 1.572 2.783 3.691 2.77 5.821", "key": "svg-0" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-2" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-3" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-7" }]]);

var IconMessageCircleCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleCog
});

var IconMessageCircleDollar = createReactComponent("outline", "message-circle-dollar", "IconMessageCircleDollar", [["path", { "d": "M13.16 19.914a9.94 9.94 0 0 1 -5.46 -.914l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.384 1.181 2.26 2.672 2.603 4.243", "key": "svg-0" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-2" }]]);

var IconMessageCircleDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleDollar
});

var IconMessageCircleDown = createReactComponent("outline", "message-circle-down", "IconMessageCircleDown", [["path", { "d": "M12.006 19.98a9.869 9.869 0 0 1 -4.306 -.98l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.993 1.7 2.93 4.041 2.746 6.344", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }]]);

var IconMessageCircleDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleDown
});

var IconMessageCircleExclamation = createReactComponent("outline", "message-circle-exclamation", "IconMessageCircleExclamation", [["path", { "d": "M15.02 19.52c-2.34 .736 -5 .606 -7.32 -.52l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.96 1.671 2.898 3.963 2.755 6.227", "key": "svg-0" }], ["path", { "d": "M19 16v3", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }]]);

var IconMessageCircleExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleExclamation
});

var IconMessageCircleHeart = createReactComponent("outline", "message-circle-heart", "IconMessageCircleHeart", [["path", { "d": "M10.59 19.88a9.763 9.763 0 0 1 -2.89 -.88l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.565 1.335 2.479 3.065 2.71 4.861", "key": "svg-0" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-1" }]]);

var IconMessageCircleHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleHeart
});

var IconMessageCircleMinus = createReactComponent("outline", "message-circle-minus", "IconMessageCircleMinus", [["path", { "d": "M12.023 19.98a9.87 9.87 0 0 1 -4.323 -.98l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c2.718 2.319 3.473 5.832 2.096 8.811", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconMessageCircleMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleMinus
});

var IconMessageCircleOff = createReactComponent("outline", "message-circle-off", "IconMessageCircleOff", [["path", { "d": "M8.595 4.577c3.223 -1.176 7.025 -.61 9.65 1.63c2.982 2.543 3.601 6.523 1.636 9.66m-1.908 2.109c-2.787 2.19 -6.89 2.666 -10.273 1.024l-4.7 1l1.3 -3.9c-2.229 -3.296 -1.494 -7.511 1.68 -10.057", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconMessageCircleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleOff
});

var IconMessageCirclePause = createReactComponent("outline", "message-circle-pause", "IconMessageCirclePause", [["path", { "d": "M12.989 19.932a9.93 9.93 0 0 1 -5.289 -.932l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c2.131 1.818 3.056 4.37 2.692 6.824", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }]]);

var IconMessageCirclePause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCirclePause
});

var IconMessageCirclePin = createReactComponent("outline", "message-circle-pin", "IconMessageCirclePin", [["path", { "d": "M12.337 19.974a9.891 9.891 0 0 1 -4.637 -.974l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.63 1.39 2.554 3.21 2.736 5.085", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }]]);

var IconMessageCirclePin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCirclePin
});

var IconMessageCirclePlus = createReactComponent("outline", "message-circle-plus", "IconMessageCirclePlus", [["path", { "d": "M12.007 19.98a9.869 9.869 0 0 1 -4.307 -.98l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.992 1.7 2.93 4.04 2.747 6.34", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconMessageCirclePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCirclePlus
});

var IconMessageCircleQuestion = createReactComponent("outline", "message-circle-question", "IconMessageCircleQuestion", [["path", { "d": "M15.02 19.52c-2.341 .736 -5 .606 -7.32 -.52l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.649 1.407 2.575 3.253 2.742 5.152", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconMessageCircleQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleQuestion
});

var IconMessageCircleSearch = createReactComponent("outline", "message-circle-search", "IconMessageCircleSearch", [["path", { "d": "M11.303 19.955a9.818 9.818 0 0 1 -3.603 -.955l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.73 1.476 2.665 3.435 2.76 5.433", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }]]);

var IconMessageCircleSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleSearch
});

var IconMessageCircleShare = createReactComponent("outline", "message-circle-share", "IconMessageCircleShare", [["path", { "d": "M12.58 19.963a9.906 9.906 0 0 1 -4.88 -.963l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c2.13 1.817 3.055 4.368 2.692 6.82", "key": "svg-0" }], ["path", { "d": "M16 22l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-2" }]]);

var IconMessageCircleShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleShare
});

var IconMessageCircleStar = createReactComponent("outline", "message-circle-star", "IconMessageCircleStar", [["path", { "d": "M10.517 19.869a9.757 9.757 0 0 1 -2.817 -.869l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.666 1.421 2.594 3.29 2.747 5.21", "key": "svg-0" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }]]);

var IconMessageCircleStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleStar
});

var IconMessageCircleUp = createReactComponent("outline", "message-circle-up", "IconMessageCircleUp", [["path", { "d": "M12.004 19.98a9.869 9.869 0 0 1 -4.304 -.98l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.994 1.701 2.932 4.045 2.746 6.349", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }]]);

var IconMessageCircleUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleUp
});

var IconMessageCircleUser = createReactComponent("outline", "message-circle-user", "IconMessageCircleUser", [["path", { "d": "M19 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M22 22a2 2 0 0 0 -2 -2h-2a2 2 0 0 0 -2 2", "key": "svg-1" }], ["path", { "d": "M12.454 19.97a9.9 9.9 0 0 1 -4.754 -.97l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.667 1.423 2.596 3.294 2.747 5.216", "key": "svg-2" }]]);

var IconMessageCircleUser$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleUser
});

var IconMessageCircleX = createReactComponent("outline", "message-circle-x", "IconMessageCircleX", [["path", { "d": "M13.593 19.855a9.96 9.96 0 0 1 -5.893 -.855l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c2.128 1.816 3.053 4.363 2.693 6.813", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }]]);

var IconMessageCircleX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleX
});

var IconMessageCircle = createReactComponent("outline", "message-circle", "IconMessageCircle", [["path", { "d": "M3 20l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c3.255 2.777 3.695 7.266 1.029 10.501c-2.666 3.235 -7.615 4.215 -11.574 2.293l-4.7 1", "key": "svg-0" }]]);

var IconMessageCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircle
});

var IconMessageCode = createReactComponent("outline", "message-code", "IconMessageCode", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M11.012 19.193l-3.012 1.807v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-2" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-3" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-4" }]]);

var IconMessageCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCode
});

var IconMessageCog = createReactComponent("outline", "message-cog", "IconMessageCog", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12.031 18.581l-4.031 2.419v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5", "key": "svg-2" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-4" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-5" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-6" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-7" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-8" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-9" }]]);

var IconMessageCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCog
});

var IconMessageDollar = createReactComponent("outline", "message-dollar", "IconMessageDollar", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v3.5", "key": "svg-2" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-4" }]]);

var IconMessageDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageDollar
});

var IconMessageDots = createReactComponent("outline", "message-dots", "IconMessageDots", [["path", { "d": "M12 11v.01", "key": "svg-0" }], ["path", { "d": "M8 11v.01", "key": "svg-1" }], ["path", { "d": "M16 11v.01", "key": "svg-2" }], ["path", { "d": "M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z", "key": "svg-3" }]]);

var IconMessageDots$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageDots
});

var IconMessageDown = createReactComponent("outline", "message-down", "IconMessageDown", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M11.998 18.601l-3.998 2.399v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-4" }]]);

var IconMessageDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageDown
});

var IconMessageExclamation = createReactComponent("outline", "message-exclamation", "IconMessageExclamation", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M15 18h-2l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-2" }], ["path", { "d": "M19 16v3", "key": "svg-3" }], ["path", { "d": "M19 22v.01", "key": "svg-4" }]]);

var IconMessageExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageExclamation
});

var IconMessageForward = createReactComponent("outline", "message-forward", "IconMessageForward", [["path", { "d": "M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z", "key": "svg-0" }], ["path", { "d": "M13 8l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M16 11h-8", "key": "svg-2" }]]);

var IconMessageForward$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageForward
});

var IconMessageHeart = createReactComponent("outline", "message-heart", "IconMessageHeart", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h3.5", "key": "svg-1" }], ["path", { "d": "M10.48 19.512l-2.48 1.488v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4", "key": "svg-2" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-3" }]]);

var IconMessageHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageHeart
});

var IconMessageLanguage = createReactComponent("outline", "message-language", "IconMessageLanguage", [["path", { "d": "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4", "key": "svg-0" }], ["path", { "d": "M10 14v-4a2 2 0 1 1 4 0v4", "key": "svg-1" }], ["path", { "d": "M14 12h-4", "key": "svg-2" }]]);

var IconMessageLanguage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageLanguage
});

var IconMessageMinus = createReactComponent("outline", "message-minus", "IconMessageMinus", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M11.976 18.614l-3.976 2.386v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconMessageMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageMinus
});

var IconMessageOff = createReactComponent("outline", "message-off", "IconMessageOff", [["path", { "d": "M8 9h1m4 0h3", "key": "svg-0" }], ["path", { "d": "M8 13h5", "key": "svg-1" }], ["path", { "d": "M8 4h10a3 3 0 0 1 3 3v8c0 .577 -.163 1.116 -.445 1.573m-2.555 1.427h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8c0 -1.085 .576 -2.036 1.439 -2.562", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconMessageOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageOff
});

var IconMessagePause = createReactComponent("outline", "message-pause", "IconMessagePause", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-2" }], ["path", { "d": "M17 17v5", "key": "svg-3" }], ["path", { "d": "M21 17v5", "key": "svg-4" }]]);

var IconMessagePause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessagePause
});

var IconMessagePin = createReactComponent("outline", "message-pin", "IconMessagePin", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12.007 18.596l-4.007 2.404v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5", "key": "svg-2" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-3" }], ["path", { "d": "M19 18v.01", "key": "svg-4" }]]);

var IconMessagePin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessagePin
});

var IconMessagePlus = createReactComponent("outline", "message-plus", "IconMessagePlus", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M12.01 18.594l-4.01 2.406v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconMessagePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessagePlus
});

var IconMessageQuestion = createReactComponent("outline", "message-question", "IconMessageQuestion", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M14 18h-1l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-4" }]]);

var IconMessageQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageQuestion
});

var IconMessageReply = createReactComponent("outline", "message-reply", "IconMessageReply", [["path", { "d": "M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z", "key": "svg-0" }], ["path", { "d": "M11 8l-3 3l3 3", "key": "svg-1" }], ["path", { "d": "M16 11h-8", "key": "svg-2" }]]);

var IconMessageReply$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageReply
});

var IconMessageReport = createReactComponent("outline", "message-report", "IconMessageReport", [["path", { "d": "M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z", "key": "svg-0" }], ["path", { "d": "M12 8v3", "key": "svg-1" }], ["path", { "d": "M12 14v.01", "key": "svg-2" }]]);

var IconMessageReport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageReport
});

var IconMessageSearch = createReactComponent("outline", "message-search", "IconMessageSearch", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h5", "key": "svg-1" }], ["path", { "d": "M11.008 19.195l-3.008 1.805v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5", "key": "svg-2" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-4" }]]);

var IconMessageSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageSearch
});

var IconMessageShare = createReactComponent("outline", "message-share", "IconMessageShare", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-2" }], ["path", { "d": "M16 22l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-4" }]]);

var IconMessageShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageShare
});

var IconMessageStar = createReactComponent("outline", "message-star", "IconMessageStar", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h4.5", "key": "svg-1" }], ["path", { "d": "M10.325 19.605l-2.325 1.395v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5", "key": "svg-2" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-3" }]]);

var IconMessageStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageStar
});

var IconMessageUp = createReactComponent("outline", "message-up", "IconMessageUp", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M11.99 18.606l-3.99 2.394v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-2" }], ["path", { "d": "M19 22v-6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-4" }]]);

var IconMessageUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageUp
});

var IconMessageUser = createReactComponent("outline", "message-user", "IconMessageUser", [["path", { "d": "M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5", "key": "svg-0" }], ["path", { "d": "M19 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M22 22a2 2 0 0 0 -2 -2h-2a2 2 0 0 0 -2 2", "key": "svg-2" }]]);

var IconMessageUser$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageUser
});

var IconMessageX = createReactComponent("outline", "message-x", "IconMessageX", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-2" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-3" }], ["path", { "d": "M17 22l5 -5", "key": "svg-4" }]]);

var IconMessageX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageX
});

var IconMessage = createReactComponent("outline", "message", "IconMessage", [["path", { "d": "M8 9h8", "key": "svg-0" }], ["path", { "d": "M8 13h6", "key": "svg-1" }], ["path", { "d": "M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z", "key": "svg-2" }]]);

var IconMessage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage
});

var IconMessagesOff = createReactComponent("outline", "messages-off", "IconMessagesOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M11 11a1 1 0 0 1 -1 -1m0 -3.968v-2.032a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10l-3 -3h-3", "key": "svg-1" }], ["path", { "d": "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2", "key": "svg-2" }]]);

var IconMessagesOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessagesOff
});

var IconMessages = createReactComponent("outline", "messages", "IconMessages", [["path", { "d": "M21 14l-3 -3h-7a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10", "key": "svg-0" }], ["path", { "d": "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2", "key": "svg-1" }]]);

var IconMessages$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessages
});

var IconMeteorOff = createReactComponent("outline", "meteor-off", "IconMeteorOff", [["path", { "d": "M9.75 5.761l3.25 -2.761l-1 5l9 -5l-5 9h5l-2.467 2.536m-1.983 2.04l-2.441 2.51a6.5 6.5 0 1 1 -8.855 -9.506l2.322 -1.972", "key": "svg-0" }], ["path", { "d": "M9.5 14.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconMeteorOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMeteorOff
});

var IconMeteor = createReactComponent("outline", "meteor", "IconMeteor", [["path", { "d": "M21 3l-5 9h5l-6.891 7.086a6.5 6.5 0 1 1 -8.855 -9.506l7.746 -6.58l-1 5l9 -5z", "key": "svg-0" }], ["path", { "d": "M9.5 14.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-1" }]]);

var IconMeteor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMeteor
});

var IconMeterCube = createReactComponent("outline", "meter-cube", "IconMeterCube", [["path", { "d": "M17 5h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5", "key": "svg-0" }], ["path", { "d": "M4 12v6", "key": "svg-1" }], ["path", { "d": "M4 14a2 2 0 0 1 2 -2h.5a2.5 2.5 0 0 1 2.5 2.5v3.5", "key": "svg-2" }], ["path", { "d": "M9 15.5v-1a2.5 2.5 0 1 1 5 0v3.5", "key": "svg-3" }]]);

var IconMeterCube$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMeterCube
});

var IconMeterSquare = createReactComponent("outline", "meter-square", "IconMeterSquare", [["path", { "d": "M17 5h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2", "key": "svg-0" }], ["path", { "d": "M4 12v6", "key": "svg-1" }], ["path", { "d": "M4 14a2 2 0 0 1 2 -2h.5a2.5 2.5 0 0 1 2.5 2.5v3.5", "key": "svg-2" }], ["path", { "d": "M9 15.5v-1a2.5 2.5 0 1 1 5 0v3.5", "key": "svg-3" }]]);

var IconMeterSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMeterSquare
});

var IconMetronome = createReactComponent("outline", "metronome", "IconMetronome", [["path", { "d": "M14.153 8.188l-.72 -3.236a2.493 2.493 0 0 0 -4.867 0l-3.025 13.614a2 2 0 0 0 1.952 2.434h7.014a2 2 0 0 0 1.952 -2.434l-.524 -2.357m-4.935 1.791l9 -13", "key": "svg-0" }], ["path", { "d": "M20 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }]]);

var IconMetronome$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMetronome
});

var IconMichelinBibGourmand = createReactComponent("outline", "michelin-bib-gourmand", "IconMichelinBibGourmand", [["path", { "d": "M4.97 20c-2.395 -1.947 -4.763 -5.245 -1.005 -8c-.52 -4 3.442 -7.5 5.524 -7.5c.347 -1 1.499 -1.5 2.54 -1.5c1.04 0 2.135 .5 2.482 1.5c2.082 0 6.044 3.5 5.524 7.5c3.758 2.755 1.39 6.053 -1.005 8", "key": "svg-0" }], ["path", { "d": "M9 11m-1 0a1 2 0 1 0 2 0a1 2 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M15 11m-1 0a1 2 0 1 0 2 0a1 2 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M8 17.085c3.5 2.712 6.5 2.712 9 -1.085", "key": "svg-3" }], ["path", { "d": "M13 18.5c.815 -2.337 1.881 -1.472 2 -.55", "key": "svg-4" }]]);

var IconMichelinBibGourmand$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMichelinBibGourmand
});

var IconMichelinStarGreen = createReactComponent("outline", "michelin-star-green", "IconMichelinStarGreen", [["path", { "d": "M12.432 17.949c.863 1.544 2.589 1.976 4.13 1.112c1.54 -.865 1.972 -2.594 1.048 -4.138c-.185 -.309 -.309 -.556 -.494 -.74c.247 .06 .555 .06 .925 .06c1.726 0 2.959 -1.234 2.959 -2.963c0 -1.73 -1.233 -2.965 -3.02 -2.965c-.37 0 -.617 0 -.925 .062c.185 -.185 .308 -.432 .493 -.74c.863 -1.545 .431 -3.274 -1.048 -4.138c-1.541 -.865 -3.205 -.433 -4.13 1.111c-.185 .309 -.308 .556 -.432 .803c-.123 -.247 -.246 -.494 -.431 -.803c-.802 -1.605 -2.528 -2.038 -4.007 -1.173c-1.541 .865 -1.973 2.594 -1.048 4.137c.185 .31 .308 .556 .493 .741c-.246 -.061 -.555 -.061 -.924 -.061c-1.788 0 -3.021 1.235 -3.021 2.964c0 1.729 1.233 2.964 3.02 2.964", "key": "svg-0" }], ["path", { "d": "M4.073 21c4.286 -2.756 5.9 -5.254 7.927 -9", "key": "svg-1" }]]);

var IconMichelinStarGreen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMichelinStarGreen
});

var IconMichelinStar = createReactComponent("outline", "michelin-star", "IconMichelinStar", [["path", { "d": "M14.792 17.063c0 .337 .057 .618 .057 .9c0 1.8 -1.238 3.037 -2.982 3.037c-1.8 0 -2.98 -1.238 -2.98 -3.206v-.731c-.957 .675 -1.576 .9 -2.42 .9c-1.518 0 -2.925 -1.463 -2.925 -3.094c0 -1.181 .844 -2.194 2.082 -2.756l.28 -.113c-1.574 -.787 -2.362 -1.688 -2.362 -2.925c0 -1.687 1.294 -3.094 2.925 -3.094c.675 0 1.52 .338 2.138 .788l.281 .112c0 -.337 -.056 -.619 -.056 -.844c0 -1.8 1.237 -3.037 2.98 -3.037c1.8 0 2.981 1.237 2.981 3.206v.394l-.056 .281c.956 -.675 1.575 -.9 2.419 -.9c1.519 0 2.925 1.463 2.925 3.094c0 1.181 -.844 2.194 -2.081 2.756l-.282 .169c1.575 .787 2.363 1.688 2.363 2.925c0 1.688 -1.294 3.094 -2.925 3.094c-.675 0 -1.575 -.281 -2.138 -.788l-.225 -.169z", "key": "svg-0" }]]);

var IconMichelinStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMichelinStar
});

var IconMickey = createReactComponent("outline", "mickey", "IconMickey", [["path", { "d": "M5.5 3a3.5 3.5 0 0 1 3.25 4.8a7.017 7.017 0 0 0 -2.424 2.1a3.5 3.5 0 1 1 -.826 -6.9z", "key": "svg-0" }], ["path", { "d": "M18.5 3a3.5 3.5 0 1 1 -.826 6.902a7.013 7.013 0 0 0 -2.424 -2.103a3.5 3.5 0 0 1 3.25 -4.799z", "key": "svg-1" }], ["path", { "d": "M12 14m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-2" }]]);

var IconMickey$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMickey
});

var IconMicrophone2Off = createReactComponent("outline", "microphone-2-off", "IconMicrophone2Off", [["path", { "d": "M16.908 12.917a5 5 0 1 0 -5.827 -5.819", "key": "svg-0" }], ["path", { "d": "M10.116 10.125l-6.529 7.46a2 2 0 1 0 2.827 2.83l7.461 -6.529", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconMicrophone2Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMicrophone2Off
});

var IconMicrophone2 = createReactComponent("outline", "microphone-2", "IconMicrophone2", [["path", { "d": "M15 12.9a5 5 0 1 0 -3.902 -3.9", "key": "svg-0" }], ["path", { "d": "M15 12.9l-3.902 -3.899l-7.513 8.584a2 2 0 1 0 2.827 2.83l8.588 -7.515z", "key": "svg-1" }]]);

var IconMicrophone2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMicrophone2
});

var IconMicrophoneOff = createReactComponent("outline", "microphone-off", "IconMicrophoneOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M9 5a3 3 0 0 1 6 0v5a3 3 0 0 1 -.13 .874m-2 2a3 3 0 0 1 -3.87 -2.872v-1", "key": "svg-1" }], ["path", { "d": "M5 10a7 7 0 0 0 10.846 5.85m2 -2a6.967 6.967 0 0 0 1.152 -3.85", "key": "svg-2" }], ["path", { "d": "M8 21l8 0", "key": "svg-3" }], ["path", { "d": "M12 17l0 4", "key": "svg-4" }]]);

var IconMicrophoneOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMicrophoneOff
});

var IconMicrophone = createReactComponent("outline", "microphone", "IconMicrophone", [["path", { "d": "M9 2m0 3a3 3 0 0 1 3 -3h0a3 3 0 0 1 3 3v5a3 3 0 0 1 -3 3h0a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M5 10a7 7 0 0 0 14 0", "key": "svg-1" }], ["path", { "d": "M8 21l8 0", "key": "svg-2" }], ["path", { "d": "M12 17l0 4", "key": "svg-3" }]]);

var IconMicrophone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMicrophone
});

var IconMicroscopeOff = createReactComponent("outline", "microscope-off", "IconMicroscopeOff", [["path", { "d": "M5 21h14", "key": "svg-0" }], ["path", { "d": "M6 18h2", "key": "svg-1" }], ["path", { "d": "M7 18v3", "key": "svg-2" }], ["path", { "d": "M10 10l-1 1l3 3l1 -1m2 -2l3 -3l-3 -3l-3 3", "key": "svg-3" }], ["path", { "d": "M10.5 12.5l-1.5 1.5", "key": "svg-4" }], ["path", { "d": "M17 3l3 3", "key": "svg-5" }], ["path", { "d": "M12 21a6 6 0 0 0 5.457 -3.505m.441 -3.599a6 6 0 0 0 -2.183 -3.608", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconMicroscopeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMicroscopeOff
});

var IconMicroscope = createReactComponent("outline", "microscope", "IconMicroscope", [["path", { "d": "M5 21h14", "key": "svg-0" }], ["path", { "d": "M6 18h2", "key": "svg-1" }], ["path", { "d": "M7 18v3", "key": "svg-2" }], ["path", { "d": "M9 11l3 3l6 -6l-3 -3z", "key": "svg-3" }], ["path", { "d": "M10.5 12.5l-1.5 1.5", "key": "svg-4" }], ["path", { "d": "M17 3l3 3", "key": "svg-5" }], ["path", { "d": "M12 21a6 6 0 0 0 3.715 -10.712", "key": "svg-6" }]]);

var IconMicroscope$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMicroscope
});

var IconMicrowaveOff = createReactComponent("outline", "microwave-off", "IconMicrowaveOff", [["path", { "d": "M18 18h-14a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h2m4 0h10a1 1 0 0 1 1 1v10", "key": "svg-0" }], ["path", { "d": "M15 6v5m0 4v3", "key": "svg-1" }], ["path", { "d": "M18 12h.01", "key": "svg-2" }], ["path", { "d": "M18 9h.01", "key": "svg-3" }], ["path", { "d": "M6.5 10.5c1 -.667 1.5 -.667 2.5 0c.636 .265 1.272 .665 1.907 .428", "key": "svg-4" }], ["path", { "d": "M6.5 13.5c1 -.667 1.5 -.667 2.5 0c.833 .347 1.667 .926 2.5 0", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconMicrowaveOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMicrowaveOff
});

var IconMicrowave = createReactComponent("outline", "microwave", "IconMicrowave", [["path", { "d": "M3 6m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M15 6v12", "key": "svg-1" }], ["path", { "d": "M18 12h.01", "key": "svg-2" }], ["path", { "d": "M18 15h.01", "key": "svg-3" }], ["path", { "d": "M18 9h.01", "key": "svg-4" }], ["path", { "d": "M6.5 10.5c1 -.667 1.5 -.667 2.5 0c.833 .347 1.667 .926 2.5 0", "key": "svg-5" }], ["path", { "d": "M6.5 13.5c1 -.667 1.5 -.667 2.5 0c.833 .347 1.667 .926 2.5 0", "key": "svg-6" }]]);

var IconMicrowave$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMicrowave
});

var IconMilitaryAward = createReactComponent("outline", "military-award", "IconMilitaryAward", [["path", { "d": "M12 13m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M8.5 10.5l-1 -2.5h-5.5l2.48 5.788a2 2 0 0 0 1.84 1.212h2.18", "key": "svg-1" }], ["path", { "d": "M15.5 10.5l1 -2.5h5.5l-2.48 5.788a2 2 0 0 1 -1.84 1.212h-2.18", "key": "svg-2" }]]);

var IconMilitaryAward$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMilitaryAward
});

var IconMilitaryRank = createReactComponent("outline", "military-rank", "IconMilitaryRank", [["path", { "d": "M18 7v12a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-12l6 -4z", "key": "svg-0" }], ["path", { "d": "M10 13l2 -1l2 1", "key": "svg-1" }], ["path", { "d": "M10 17l2 -1l2 1", "key": "svg-2" }], ["path", { "d": "M10 9l2 -1l2 1", "key": "svg-3" }]]);

var IconMilitaryRank$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMilitaryRank
});

var IconMilkOff = createReactComponent("outline", "milk-off", "IconMilkOff", [["path", { "d": "M10 6h6v-2a1 1 0 0 0 -1 -1h-6a1 1 0 0 0 -1 1", "key": "svg-0" }], ["path", { "d": "M16 6l1.094 1.759a6 6 0 0 1 .906 3.17v3.071m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8.071a6 6 0 0 1 .906 -3.17l.327 -.525", "key": "svg-1" }], ["path", { "d": "M12 16m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconMilkOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMilkOff
});

var IconMilk = createReactComponent("outline", "milk", "IconMilk", [["path", { "d": "M8 6h8v-2a1 1 0 0 0 -1 -1h-6a1 1 0 0 0 -1 1v2z", "key": "svg-0" }], ["path", { "d": "M16 6l1.094 1.759a6 6 0 0 1 .906 3.17v8.071a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8.071a6 6 0 0 1 .906 -3.17l1.094 -1.759", "key": "svg-1" }], ["path", { "d": "M12 16m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M10 10h4", "key": "svg-3" }]]);

var IconMilk$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMilk
});

var IconMilkshake = createReactComponent("outline", "milkshake", "IconMilkshake", [["path", { "d": "M17 10a5 5 0 0 0 -10 0", "key": "svg-0" }], ["path", { "d": "M6 10m0 1a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M7 13l1.81 7.243a1 1 0 0 0 .97 .757h4.44a1 1 0 0 0 .97 -.757l1.81 -7.243", "key": "svg-2" }], ["path", { "d": "M12 5v-2", "key": "svg-3" }]]);

var IconMilkshake$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMilkshake
});

var IconMinimize = createReactComponent("outline", "minimize", "IconMinimize", [["path", { "d": "M15 19v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M15 5v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M5 15h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M5 9h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }]]);

var IconMinimize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMinimize
});

var IconMinusVertical = createReactComponent("outline", "minus-vertical", "IconMinusVertical", [["path", { "d": "M12 5v14", "key": "svg-0" }]]);

var IconMinusVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMinusVertical
});

var IconMinus = createReactComponent("outline", "minus", "IconMinus", [["path", { "d": "M5 12l14 0", "key": "svg-0" }]]);

var IconMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMinus
});

var IconMistOff = createReactComponent("outline", "mist-off", "IconMistOff", [["path", { "d": "M12 5h9", "key": "svg-0" }], ["path", { "d": "M3 10h7", "key": "svg-1" }], ["path", { "d": "M18 10h1", "key": "svg-2" }], ["path", { "d": "M5 15h5", "key": "svg-3" }], ["path", { "d": "M14 15h1m4 0h2", "key": "svg-4" }], ["path", { "d": "M3 20h9m4 0h3", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconMistOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMistOff
});

var IconMist = createReactComponent("outline", "mist", "IconMist", [["path", { "d": "M5 5h3m4 0h9", "key": "svg-0" }], ["path", { "d": "M3 10h11m4 0h1", "key": "svg-1" }], ["path", { "d": "M5 15h5m4 0h7", "key": "svg-2" }], ["path", { "d": "M3 20h9m4 0h3", "key": "svg-3" }]]);

var IconMist$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMist
});

var IconMobiledataOff = createReactComponent("outline", "mobiledata-off", "IconMobiledataOff", [["path", { "d": "M16 12v-8", "key": "svg-0" }], ["path", { "d": "M8 20v-8", "key": "svg-1" }], ["path", { "d": "M13 7l3 -3l3 3", "key": "svg-2" }], ["path", { "d": "M5 17l3 3l3 -3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconMobiledataOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMobiledataOff
});

var IconMobiledata = createReactComponent("outline", "mobiledata", "IconMobiledata", [["path", { "d": "M16 12v-8", "key": "svg-0" }], ["path", { "d": "M8 20v-8", "key": "svg-1" }], ["path", { "d": "M13 7l3 -3l3 3", "key": "svg-2" }], ["path", { "d": "M5 17l3 3l3 -3", "key": "svg-3" }]]);

var IconMobiledata$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMobiledata
});

var IconMoneybagEdit = createReactComponent("outline", "moneybag-edit", "IconMoneybagEdit", [["path", { "d": "M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5", "key": "svg-0" }], ["path", { "d": "M11 21h-3a4 4 0 0 1 -4 -4v-1a8 8 0 0 1 14.376 -4.833", "key": "svg-1" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 1 1 2.97 2.97l-3.39 3.42h-3v-3z", "key": "svg-2" }]]);

var IconMoneybagEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoneybagEdit
});

var IconMoneybagHeart = createReactComponent("outline", "moneybag-heart", "IconMoneybagHeart", [["path", { "d": "M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5", "key": "svg-0" }], ["path", { "d": "M11.5 21h-3.5a4 4 0 0 1 -4 -4v-1a8 8 0 0 1 14.376 -4.833", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.24 2.24 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.24 2.24 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071z", "key": "svg-2" }]]);

var IconMoneybagHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoneybagHeart
});

var IconMoneybagMinus = createReactComponent("outline", "moneybag-minus", "IconMoneybagMinus", [["path", { "d": "M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5", "key": "svg-0" }], ["path", { "d": "M12.5 21h-4.5a4 4 0 0 1 -4 -4v-1a8 8 0 0 1 15.943 -.958", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconMoneybagMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoneybagMinus
});

var IconMoneybagMoveBack = createReactComponent("outline", "moneybag-move-back", "IconMoneybagMoveBack", [["path", { "d": "M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5", "key": "svg-0" }], ["path", { "d": "M12.5 21h-4.5a4 4 0 0 1 -4 -4v-1a8 8 0 0 1 14.953 -3.959", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16l-3 3l3 3", "key": "svg-3" }]]);

var IconMoneybagMoveBack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoneybagMoveBack
});

var IconMoneybagMove = createReactComponent("outline", "moneybag-move", "IconMoneybagMove", [["path", { "d": "M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5", "key": "svg-0" }], ["path", { "d": "M12.5 21h-4.5a4 4 0 0 1 -4 -4v-1a8 8 0 0 1 14.946 -3.971", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16l3 3l-3 3", "key": "svg-3" }]]);

var IconMoneybagMove$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoneybagMove
});

var IconMoneybagPlus = createReactComponent("outline", "moneybag-plus", "IconMoneybagPlus", [["path", { "d": "M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5", "key": "svg-0" }], ["path", { "d": "M12.5 21h-4.5a4 4 0 0 1 -4 -4v-1a8 8 0 0 1 14.935 -3.991", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconMoneybagPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoneybagPlus
});

var IconMoneybag = createReactComponent("outline", "moneybag", "IconMoneybag", [["path", { "d": "M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5", "key": "svg-0" }], ["path", { "d": "M4 17v-1a8 8 0 1 1 16 0v1a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4", "key": "svg-1" }]]);

var IconMoneybag$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoneybag
});

var IconMonkeybar = createReactComponent("outline", "monkeybar", "IconMonkeybar", [["path", { "d": "M3 21v-15l5 -3l5 3v15", "key": "svg-0" }], ["path", { "d": "M8 21v-7", "key": "svg-1" }], ["path", { "d": "M3 14h10", "key": "svg-2" }], ["path", { "d": "M6 10a2 2 0 1 1 4 0", "key": "svg-3" }], ["path", { "d": "M13 13c6 0 3 8 8 8", "key": "svg-4" }]]);

var IconMonkeybar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMonkeybar
});

var IconMoodAngry = createReactComponent("outline", "mood-angry", "IconMoodAngry", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M8 9l2 1", "key": "svg-1" }], ["path", { "d": "M16 9l-2 1", "key": "svg-2" }], ["path", { "d": "M14.5 16.05a3.5 3.5 0 0 0 -5 0", "key": "svg-3" }]]);

var IconMoodAngry$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodAngry
});

var IconMoodAnnoyed2 = createReactComponent("outline", "mood-annoyed-2", "IconMoodAnnoyed2", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M15 14c-2 0 -3 1 -3.5 2.05", "key": "svg-1" }], ["path", { "d": "M10 9.25c-.5 1 -2.5 1 -3 0", "key": "svg-2" }], ["path", { "d": "M17 9.25c-.5 1 -2.5 1 -3 0", "key": "svg-3" }]]);

var IconMoodAnnoyed2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodAnnoyed2
});

var IconMoodAnnoyed = createReactComponent("outline", "mood-annoyed", "IconMoodAnnoyed", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M15 14c-2 0 -3 1 -3.5 2.05", "key": "svg-1" }], ["path", { "d": "M9 10h-.01", "key": "svg-2" }], ["path", { "d": "M15 10h-.01", "key": "svg-3" }]]);

var IconMoodAnnoyed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodAnnoyed
});

var IconMoodBitcoin = createReactComponent("outline", "mood-bitcoin", "IconMoodBitcoin", [["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-0" }], ["path", { "d": "M20.87 10.48a9 9 0 1 0 -7.876 10.465", "key": "svg-1" }], ["path", { "d": "M9 10h.01", "key": "svg-2" }], ["path", { "d": "M15 10h.01", "key": "svg-3" }], ["path", { "d": "M9.5 15c.658 .64 1.56 1 2.5 1c.357 0 .709 -.052 1.043 -.151", "key": "svg-4" }]]);

var IconMoodBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodBitcoin
});

var IconMoodBoy = createReactComponent("outline", "mood-boy", "IconMoodBoy", [["path", { "d": "M17 4.5a9 9 0 0 1 3.864 5.89a2.5 2.5 0 0 1 -.29 4.36a9 9 0 0 1 -17.137 0a2.5 2.5 0 0 1 -.29 -4.36a9 9 0 0 1 3.746 -5.81", "key": "svg-0" }], ["path", { "d": "M9.5 16a3.5 3.5 0 0 0 5 0", "key": "svg-1" }], ["path", { "d": "M8.5 2c1.5 1 2.5 3.5 2.5 5", "key": "svg-2" }], ["path", { "d": "M12.5 2c1.5 2 2 3.5 2 5", "key": "svg-3" }], ["path", { "d": "M9 12l.01 0", "key": "svg-4" }], ["path", { "d": "M15 12l.01 0", "key": "svg-5" }]]);

var IconMoodBoy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodBoy
});

var IconMoodCheck = createReactComponent("outline", "mood-check", "IconMoodCheck", [["path", { "d": "M20.925 13.163a8.998 8.998 0 0 0 -8.925 -10.163a9 9 0 0 0 0 18", "key": "svg-0" }], ["path", { "d": "M9 10h.01", "key": "svg-1" }], ["path", { "d": "M15 10h.01", "key": "svg-2" }], ["path", { "d": "M9.5 15c.658 .64 1.56 1 2.5 1s1.842 -.36 2.5 -1", "key": "svg-3" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-4" }]]);

var IconMoodCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodCheck
});

var IconMoodCog = createReactComponent("outline", "mood-cog", "IconMoodCog", [["path", { "d": "M21 12a9 9 0 1 0 -8.983 9", "key": "svg-0" }], ["path", { "d": "M18.001 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M18.001 14.5v1.5", "key": "svg-2" }], ["path", { "d": "M18.001 20v1.5", "key": "svg-3" }], ["path", { "d": "M21.032 16.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M16.27 19l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M14.97 16.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M19.733 19l1.3 .75", "key": "svg-7" }], ["path", { "d": "M9 10h.01", "key": "svg-8" }], ["path", { "d": "M15 10h.01", "key": "svg-9" }], ["path", { "d": "M9.5 15c.658 .64 1.56 1 2.5 1", "key": "svg-10" }]]);

var IconMoodCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodCog
});

var IconMoodConfuzed = createReactComponent("outline", "mood-confuzed", "IconMoodConfuzed", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10l.01 0", "key": "svg-1" }], ["path", { "d": "M15 10l.01 0", "key": "svg-2" }], ["path", { "d": "M9.5 16a10 10 0 0 1 6 -1.5", "key": "svg-3" }]]);

var IconMoodConfuzed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodConfuzed
});

var IconMoodCrazyHappy = createReactComponent("outline", "mood-crazy-happy", "IconMoodCrazyHappy", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M7 8.5l3 3", "key": "svg-1" }], ["path", { "d": "M7 11.5l3 -3", "key": "svg-2" }], ["path", { "d": "M14 8.5l3 3", "key": "svg-3" }], ["path", { "d": "M14 11.5l3 -3", "key": "svg-4" }], ["path", { "d": "M9.5 15a3.5 3.5 0 0 0 5 0", "key": "svg-5" }]]);

var IconMoodCrazyHappy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodCrazyHappy
});

var IconMoodCry = createReactComponent("outline", "mood-cry", "IconMoodCry", [["path", { "d": "M9 10l.01 0", "key": "svg-0" }], ["path", { "d": "M15 10l.01 0", "key": "svg-1" }], ["path", { "d": "M9.5 15.25a3.5 3.5 0 0 1 5 0", "key": "svg-2" }], ["path", { "d": "M17.566 17.606a2 2 0 1 0 2.897 .03l-1.463 -1.636l-1.434 1.606z", "key": "svg-3" }], ["path", { "d": "M20.865 13.517a8.937 8.937 0 0 0 .135 -1.517a9 9 0 1 0 -9 9c.69 0 1.36 -.076 2 -.222", "key": "svg-4" }]]);

var IconMoodCry$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodCry
});

var IconMoodDollar = createReactComponent("outline", "mood-dollar", "IconMoodDollar", [["path", { "d": "M20.87 10.48a9 9 0 1 0 -7.876 10.465", "key": "svg-0" }], ["path", { "d": "M9 10h.01", "key": "svg-1" }], ["path", { "d": "M15 10h.01", "key": "svg-2" }], ["path", { "d": "M9.5 15c.658 .64 1.56 1 2.5 1c.357 0 .709 -.052 1.043 -.151", "key": "svg-3" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-4" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-5" }]]);

var IconMoodDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodDollar
});

var IconMoodEdit = createReactComponent("outline", "mood-edit", "IconMoodEdit", [["path", { "d": "M20.955 11.104a9 9 0 1 0 -9.895 9.847", "key": "svg-0" }], ["path", { "d": "M9 10h.01", "key": "svg-1" }], ["path", { "d": "M15 10h.01", "key": "svg-2" }], ["path", { "d": "M9.5 15c.658 .672 1.56 1 2.5 1c.126 0 .251 -.006 .376 -.018", "key": "svg-3" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z", "key": "svg-4" }]]);

var IconMoodEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodEdit
});

var IconMoodEmpty = createReactComponent("outline", "mood-empty", "IconMoodEmpty", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10l.01 0", "key": "svg-1" }], ["path", { "d": "M15 10l.01 0", "key": "svg-2" }], ["path", { "d": "M9 15l6 0", "key": "svg-3" }]]);

var IconMoodEmpty$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodEmpty
});

var IconMoodHappy = createReactComponent("outline", "mood-happy", "IconMoodHappy", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 9l.01 0", "key": "svg-1" }], ["path", { "d": "M15 9l.01 0", "key": "svg-2" }], ["path", { "d": "M8 13a4 4 0 1 0 8 0h-8", "key": "svg-3" }]]);

var IconMoodHappy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodHappy
});

var IconMoodHeart = createReactComponent("outline", "mood-heart", "IconMoodHeart", [["path", { "d": "M21 12a9 9 0 1 0 -8.012 8.946", "key": "svg-0" }], ["path", { "d": "M9 10h.01", "key": "svg-1" }], ["path", { "d": "M15 10h.01", "key": "svg-2" }], ["path", { "d": "M9.5 15a3.59 3.59 0 0 0 2.774 .99", "key": "svg-3" }], ["path", { "d": "M18.994 21.5l2.518 -2.58a1.74 1.74 0 0 0 .004 -2.413a1.627 1.627 0 0 0 -2.346 -.005l-.168 .172l-.168 -.172a1.627 1.627 0 0 0 -2.346 -.004a1.74 1.74 0 0 0 -.004 2.412l2.51 2.59z", "key": "svg-4" }]]);

var IconMoodHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodHeart
});

var IconMoodKid = createReactComponent("outline", "mood-kid", "IconMoodKid", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10l.01 0", "key": "svg-1" }], ["path", { "d": "M15 10l.01 0", "key": "svg-2" }], ["path", { "d": "M9.5 15a3.5 3.5 0 0 0 5 0", "key": "svg-3" }], ["path", { "d": "M12 3a2 2 0 0 0 0 4", "key": "svg-4" }]]);

var IconMoodKid$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodKid
});

var IconMoodLookDown = createReactComponent("outline", "mood-look-down", "IconMoodLookDown", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 13h.01", "key": "svg-1" }], ["path", { "d": "M15 13h.01", "key": "svg-2" }], ["path", { "d": "M11 17h2", "key": "svg-3" }]]);

var IconMoodLookDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodLookDown
});

var IconMoodLookLeft = createReactComponent("outline", "mood-look-left", "IconMoodLookLeft", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 9h.01", "key": "svg-1" }], ["path", { "d": "M4 15h4", "key": "svg-2" }]]);

var IconMoodLookLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodLookLeft
});

var IconMoodLookRight = createReactComponent("outline", "mood-look-right", "IconMoodLookRight", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M15 9h-.01", "key": "svg-1" }], ["path", { "d": "M20 15h-4", "key": "svg-2" }]]);

var IconMoodLookRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodLookRight
});

var IconMoodLookUp = createReactComponent("outline", "mood-look-up", "IconMoodLookUp", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 8h.01", "key": "svg-1" }], ["path", { "d": "M15 8h.01", "key": "svg-2" }], ["path", { "d": "M11 12h2", "key": "svg-3" }]]);

var IconMoodLookUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodLookUp
});

var IconMoodMinus = createReactComponent("outline", "mood-minus", "IconMoodMinus", [["path", { "d": "M20.48 15.014a9 9 0 1 0 -7.956 5.97", "key": "svg-0" }], ["path", { "d": "M9 10h.01", "key": "svg-1" }], ["path", { "d": "M15 10h.01", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M9.5 15c.658 .64 1.56 1 2.5 1s1.842 -.36 2.5 -1", "key": "svg-4" }]]);

var IconMoodMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodMinus
});

var IconMoodNerd = createReactComponent("outline", "mood-nerd", "IconMoodNerd", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M8 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M16 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M9.5 15a3.5 3.5 0 0 0 5 0", "key": "svg-3" }], ["path", { "d": "M3.5 9h2.5", "key": "svg-4" }], ["path", { "d": "M18 9h2.5", "key": "svg-5" }], ["path", { "d": "M10 9.5c1.333 -1.333 2.667 -1.333 4 0", "key": "svg-6" }]]);

var IconMoodNerd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodNerd
});

var IconMoodNervous = createReactComponent("outline", "mood-nervous", "IconMoodNervous", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10h.01", "key": "svg-1" }], ["path", { "d": "M15 10h.01", "key": "svg-2" }], ["path", { "d": "M8 16l2 -2l2 2l2 -2l2 2", "key": "svg-3" }]]);

var IconMoodNervous$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodNervous
});

var IconMoodNeutral = createReactComponent("outline", "mood-neutral", "IconMoodNeutral", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10l.01 0", "key": "svg-1" }], ["path", { "d": "M15 10l.01 0", "key": "svg-2" }]]);

var IconMoodNeutral$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodNeutral
});

var IconMoodOff = createReactComponent("outline", "mood-off", "IconMoodOff", [["path", { "d": "M5.634 5.638a9 9 0 0 0 12.732 12.724m1.679 -2.322a9 9 0 0 0 -12.08 -12.086", "key": "svg-0" }], ["path", { "d": "M9 10h.01", "key": "svg-1" }], ["path", { "d": "M15 10h.01", "key": "svg-2" }], ["path", { "d": "M9.5 15a3.5 3.5 0 0 0 5 0", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconMoodOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodOff
});

var IconMoodPin = createReactComponent("outline", "mood-pin", "IconMoodPin", [["path", { "d": "M21 12a9 9 0 1 0 -8.352 8.977", "key": "svg-0" }], ["path", { "d": "M9 10h.01", "key": "svg-1" }], ["path", { "d": "M15 10h.01", "key": "svg-2" }], ["path", { "d": "M9.5 15c.658 .672 1.56 1 2.5 1c.102 0 .203 -.004 .304 -.012", "key": "svg-3" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-4" }], ["path", { "d": "M19 18v.01", "key": "svg-5" }]]);

var IconMoodPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodPin
});

var IconMoodPlus = createReactComponent("outline", "mood-plus", "IconMoodPlus", [["path", { "d": "M20.985 12.528a9 9 0 1 0 -8.45 8.456", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M9 10h.01", "key": "svg-3" }], ["path", { "d": "M15 10h.01", "key": "svg-4" }], ["path", { "d": "M9.5 15c.658 .64 1.56 1 2.5 1s1.842 -.36 2.5 -1", "key": "svg-5" }]]);

var IconMoodPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodPlus
});

var IconMoodPuzzled = createReactComponent("outline", "mood-puzzled", "IconMoodPuzzled", [["path", { "d": "M14.986 3.51a9 9 0 1 0 1.514 16.284c2.489 -1.437 4.181 -3.978 4.5 -6.794", "key": "svg-0" }], ["path", { "d": "M10 10h.01", "key": "svg-1" }], ["path", { "d": "M14 8h.01", "key": "svg-2" }], ["path", { "d": "M12 15c1 -1.333 2 -2 3 -2", "key": "svg-3" }], ["path", { "d": "M20 9v.01", "key": "svg-4" }], ["path", { "d": "M20 6a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-5" }]]);

var IconMoodPuzzled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodPuzzled
});

var IconMoodSad2 = createReactComponent("outline", "mood-sad-2", "IconMoodSad2", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14.5 16.05a3.5 3.5 0 0 0 -5 0", "key": "svg-1" }], ["path", { "d": "M10 9.25c-.5 1 -2.5 1 -3 0", "key": "svg-2" }], ["path", { "d": "M17 9.25c-.5 1 -2.5 1 -3 0", "key": "svg-3" }]]);

var IconMoodSad2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSad2
});

var IconMoodSadDizzy = createReactComponent("outline", "mood-sad-dizzy", "IconMoodSadDizzy", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14.5 16.05a3.5 3.5 0 0 0 -5 0", "key": "svg-1" }], ["path", { "d": "M8 9l2 2", "key": "svg-2" }], ["path", { "d": "M10 9l-2 2", "key": "svg-3" }], ["path", { "d": "M14 9l2 2", "key": "svg-4" }], ["path", { "d": "M16 9l-2 2", "key": "svg-5" }]]);

var IconMoodSadDizzy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSadDizzy
});

var IconMoodSadSquint = createReactComponent("outline", "mood-sad-squint", "IconMoodSadSquint", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14.5 16.05a3.5 3.5 0 0 0 -5 0", "key": "svg-1" }], ["path", { "d": "M8.5 11.5l1.5 -1.5l-1.5 -1.5", "key": "svg-2" }], ["path", { "d": "M15.5 11.5l-1.5 -1.5l1.5 -1.5", "key": "svg-3" }]]);

var IconMoodSadSquint$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSadSquint
});

var IconMoodSad = createReactComponent("outline", "mood-sad", "IconMoodSad", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10l.01 0", "key": "svg-1" }], ["path", { "d": "M15 10l.01 0", "key": "svg-2" }], ["path", { "d": "M9.5 15.25a3.5 3.5 0 0 1 5 0", "key": "svg-3" }]]);

var IconMoodSad$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSad
});

var IconMoodSearch = createReactComponent("outline", "mood-search", "IconMoodSearch", [["path", { "d": "M21 12a9 9 0 1 0 -9 9", "key": "svg-0" }], ["path", { "d": "M9 10h.01", "key": "svg-1" }], ["path", { "d": "M15 10h.01", "key": "svg-2" }], ["path", { "d": "M9.5 15c.658 .672 1.56 1 2.5 1", "key": "svg-3" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-5" }]]);

var IconMoodSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSearch
});

var IconMoodShare = createReactComponent("outline", "mood-share", "IconMoodShare", [["path", { "d": "M20.942 13.018a9 9 0 1 0 -8.942 7.982", "key": "svg-0" }], ["path", { "d": "M9 10h.01", "key": "svg-1" }], ["path", { "d": "M15 10h.01", "key": "svg-2" }], ["path", { "d": "M9.5 15c.658 .672 1.56 1 2.5 1c.213 0 .424 -.017 .63 -.05", "key": "svg-3" }], ["path", { "d": "M16 22l5 -5", "key": "svg-4" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-5" }]]);

var IconMoodShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodShare
});

var IconMoodSick = createReactComponent("outline", "mood-sick", "IconMoodSick", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M9 10h-.01", "key": "svg-1" }], ["path", { "d": "M15 10h-.01", "key": "svg-2" }], ["path", { "d": "M8 16l1 -1l1.5 1l1.5 -1l1.5 1l1.5 -1l1 1", "key": "svg-3" }]]);

var IconMoodSick$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSick
});

var IconMoodSilence = createReactComponent("outline", "mood-silence", "IconMoodSilence", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M9 10h-.01", "key": "svg-1" }], ["path", { "d": "M15 10h-.01", "key": "svg-2" }], ["path", { "d": "M8 15h8", "key": "svg-3" }], ["path", { "d": "M9 14v2", "key": "svg-4" }], ["path", { "d": "M12 14v2", "key": "svg-5" }], ["path", { "d": "M15 14v2", "key": "svg-6" }]]);

var IconMoodSilence$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSilence
});

var IconMoodSing = createReactComponent("outline", "mood-sing", "IconMoodSing", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 9h.01", "key": "svg-1" }], ["path", { "d": "M15 9h.01", "key": "svg-2" }], ["path", { "d": "M15 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }]]);

var IconMoodSing$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSing
});

var IconMoodSmileBeam = createReactComponent("outline", "mood-smile-beam", "IconMoodSmileBeam", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M10 10c-.5 -1 -2.5 -1 -3 0", "key": "svg-1" }], ["path", { "d": "M17 10c-.5 -1 -2.5 -1 -3 0", "key": "svg-2" }], ["path", { "d": "M14.5 15a3.5 3.5 0 0 1 -5 0", "key": "svg-3" }]]);

var IconMoodSmileBeam$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSmileBeam
});

var IconMoodSmileDizzy = createReactComponent("outline", "mood-smile-dizzy", "IconMoodSmileDizzy", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14.5 15a3.5 3.5 0 0 1 -5 0", "key": "svg-1" }], ["path", { "d": "M8 9l2 2", "key": "svg-2" }], ["path", { "d": "M10 9l-2 2", "key": "svg-3" }], ["path", { "d": "M14 9l2 2", "key": "svg-4" }], ["path", { "d": "M16 9l-2 2", "key": "svg-5" }]]);

var IconMoodSmileDizzy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSmileDizzy
});

var IconMoodSmile = createReactComponent("outline", "mood-smile", "IconMoodSmile", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10l.01 0", "key": "svg-1" }], ["path", { "d": "M15 10l.01 0", "key": "svg-2" }], ["path", { "d": "M9.5 15a3.5 3.5 0 0 0 5 0", "key": "svg-3" }]]);

var IconMoodSmile$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSmile
});

var IconMoodSpark = createReactComponent("outline", "mood-spark", "IconMoodSpark", [["path", { "d": "M21 12a9 9 0 1 0 -8.994 9", "key": "svg-0" }], ["path", { "d": "M9 10h.01", "key": "svg-1" }], ["path", { "d": "M15 10h.01", "key": "svg-2" }], ["path", { "d": "M9.5 15a3.5 3.5 0 0 0 5 0", "key": "svg-3" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-4" }]]);

var IconMoodSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSpark
});

var IconMoodSurprised = createReactComponent("outline", "mood-surprised", "IconMoodSurprised", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 9l.01 0", "key": "svg-1" }], ["path", { "d": "M15 9l.01 0", "key": "svg-2" }], ["path", { "d": "M12 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }]]);

var IconMoodSurprised$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSurprised
});

var IconMoodTongueWink2 = createReactComponent("outline", "mood-tongue-wink-2", "IconMoodTongueWink2", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-1" }], ["path", { "d": "M15 10h-.01", "key": "svg-2" }], ["path", { "d": "M10 14v2a2 2 0 1 0 4 0v-2m1.5 0h-7", "key": "svg-3" }], ["path", { "d": "M7 10c.5 -1 2.5 -1 3 0", "key": "svg-4" }]]);

var IconMoodTongueWink2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodTongueWink2
});

var IconMoodTongueWink = createReactComponent("outline", "mood-tongue-wink", "IconMoodTongueWink", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }], ["path", { "d": "M9 10h.01", "key": "svg-2" }], ["path", { "d": "M10 14v2a2 2 0 0 0 4 0v-2", "key": "svg-3" }], ["path", { "d": "M15.5 14h-7", "key": "svg-4" }], ["path", { "d": "M17 10c-.5 -1 -2.5 -1 -3 0", "key": "svg-5" }]]);

var IconMoodTongueWink$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodTongueWink
});

var IconMoodTongue = createReactComponent("outline", "mood-tongue", "IconMoodTongue", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10l.01 0", "key": "svg-1" }], ["path", { "d": "M15 10l.01 0", "key": "svg-2" }], ["path", { "d": "M10 14v2a2 2 0 0 0 4 0v-2m1.5 0h-7", "key": "svg-3" }]]);

var IconMoodTongue$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodTongue
});

var IconMoodUnamused = createReactComponent("outline", "mood-unamused", "IconMoodUnamused", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M11 16l4 -1.5", "key": "svg-1" }], ["path", { "d": "M10 10c-.5 -1 -2.5 -1 -3 0", "key": "svg-2" }], ["path", { "d": "M17 10c-.5 -1 -2.5 -1 -3 0", "key": "svg-3" }]]);

var IconMoodUnamused$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodUnamused
});

var IconMoodUp = createReactComponent("outline", "mood-up", "IconMoodUp", [["path", { "d": "M20.984 12.536a9 9 0 1 0 -8.463 8.449", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }], ["path", { "d": "M9 10h.01", "key": "svg-3" }], ["path", { "d": "M15 10h.01", "key": "svg-4" }], ["path", { "d": "M9.5 15c.658 .64 1.56 1 2.5 1s1.842 -.36 2.5 -1", "key": "svg-5" }]]);

var IconMoodUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodUp
});

var IconMoodWink2 = createReactComponent("outline", "mood-wink-2", "IconMoodWink2", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M9 10h-.01", "key": "svg-1" }], ["path", { "d": "M14.5 15a3.5 3.5 0 0 1 -5 0", "key": "svg-2" }], ["path", { "d": "M15.5 8.5l-1.5 1.5l1.5 1.5", "key": "svg-3" }]]);

var IconMoodWink2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodWink2
});

var IconMoodWink = createReactComponent("outline", "mood-wink", "IconMoodWink", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M15 10h.01", "key": "svg-1" }], ["path", { "d": "M9.5 15a3.5 3.5 0 0 0 5 0", "key": "svg-2" }], ["path", { "d": "M8.5 8.5l1.5 1.5l-1.5 1.5", "key": "svg-3" }]]);

var IconMoodWink$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodWink
});

var IconMoodWrrr = createReactComponent("outline", "mood-wrrr", "IconMoodWrrr", [["path", { "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", "key": "svg-0" }], ["path", { "d": "M8 16l1 -1l1.5 1l1.5 -1l1.5 1l1.5 -1l1 1", "key": "svg-1" }], ["path", { "d": "M8.5 11.5l1.5 -1.5l-1.5 -1.5", "key": "svg-2" }], ["path", { "d": "M15.5 11.5l-1.5 -1.5l1.5 -1.5", "key": "svg-3" }]]);

var IconMoodWrrr$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodWrrr
});

var IconMoodX = createReactComponent("outline", "mood-x", "IconMoodX", [["path", { "d": "M20.983 12.556a9 9 0 1 0 -8.433 8.427", "key": "svg-0" }], ["path", { "d": "M9 10h.01", "key": "svg-1" }], ["path", { "d": "M15 10h.01", "key": "svg-2" }], ["path", { "d": "M9.5 15c.658 .64 1.56 1 2.5 1c.194 0 .386 -.015 .574 -.045", "key": "svg-3" }], ["path", { "d": "M21.5 21.5l-5 -5", "key": "svg-4" }], ["path", { "d": "M16.5 21.5l5 -5", "key": "svg-5" }]]);

var IconMoodX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodX
});

var IconMoodXd = createReactComponent("outline", "mood-xd", "IconMoodXd", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 14h6a3 3 0 0 1 -6 0z", "key": "svg-1" }], ["path", { "d": "M9 8l6 3", "key": "svg-2" }], ["path", { "d": "M9 11l6 -3", "key": "svg-3" }]]);

var IconMoodXd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodXd
});

var IconMoon2 = createReactComponent("outline", "moon-2", "IconMoon2", [["path", { "d": "M16.418 4.157a8 8 0 0 0 0 15.686", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconMoon2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoon2
});

var IconMoonOff = createReactComponent("outline", "moon-off", "IconMoonOff", [["path", { "d": "M7.962 3.949a8.97 8.97 0 0 1 4.038 -.957v.008h.393a7.478 7.478 0 0 0 -2.07 3.308m-.141 3.84c.186 .823 .514 1.626 .989 2.373a7.49 7.49 0 0 0 4.586 3.268m3.893 -.11c.223 -.067 .444 -.144 .663 -.233a9.088 9.088 0 0 1 -.274 .597m-1.695 2.337a9 9 0 0 1 -12.71 -12.749", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconMoonOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoonOff
});

var IconMoonStars = createReactComponent("outline", "moon-stars", "IconMoonStars", [["path", { "d": "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z", "key": "svg-0" }], ["path", { "d": "M17 4a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2", "key": "svg-1" }], ["path", { "d": "M19 11h2m-1 -1v2", "key": "svg-2" }]]);

var IconMoonStars$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoonStars
});

var IconMoon = createReactComponent("outline", "moon", "IconMoon", [["path", { "d": "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z", "key": "svg-0" }]]);

var IconMoon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoon
});

var IconMoped = createReactComponent("outline", "moped", "IconMoped", [["path", { "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M5 16v1a2 2 0 0 0 4 0v-5h-3a3 3 0 0 0 -3 3v1h10a6 6 0 0 1 5 -4v-5a2 2 0 0 0 -2 -2h-1", "key": "svg-1" }], ["path", { "d": "M6 9l3 0", "key": "svg-2" }]]);

var IconMoped$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoped
});

var IconMotorbike = createReactComponent("outline", "motorbike", "IconMotorbike", [["path", { "d": "M5 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M19 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M7.5 14h5l4 -4h-10.5m1.5 4l4 -4", "key": "svg-2" }], ["path", { "d": "M13 6h2l1.5 3l2 4", "key": "svg-3" }]]);

var IconMotorbike$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMotorbike
});

var IconMountainOff = createReactComponent("outline", "mountain-off", "IconMountainOff", [["path", { "d": "M18.281 14.26l-4.201 -8.872a2.3 2.3 0 0 0 -4.158 0l-.165 .349m-1.289 2.719l-5.468 11.544h17", "key": "svg-0" }], ["path", { "d": "M7.5 11l2 2.5l2 -2", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconMountainOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMountainOff
});

var IconMountain = createReactComponent("outline", "mountain", "IconMountain", [["path", { "d": "M3 20h18l-6.921 -14.612a2.3 2.3 0 0 0 -4.158 0l-6.921 14.612z", "key": "svg-0" }], ["path", { "d": "M7.5 11l2 2.5l2.5 -2.5l2 3l2.5 -2", "key": "svg-1" }]]);

var IconMountain$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMountain
});

var IconMouse2 = createReactComponent("outline", "mouse-2", "IconMouse2", [["path", { "d": "M6 3m0 4a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-4a4 4 0 0 1 -4 -4z", "key": "svg-0" }], ["path", { "d": "M12 3v7", "key": "svg-1" }], ["path", { "d": "M6 10h12", "key": "svg-2" }]]);

var IconMouse2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMouse2
});

var IconMouseOff = createReactComponent("outline", "mouse-off", "IconMouseOff", [["path", { "d": "M7.733 3.704a3.982 3.982 0 0 1 2.267 -.704h4a4 4 0 0 1 4 4v7m-.1 3.895a4 4 0 0 1 -3.9 3.105h-4a4 4 0 0 1 -4 -4v-10c0 -.3 .033 -.593 .096 -.874", "key": "svg-0" }], ["path", { "d": "M12 7v1", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconMouseOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMouseOff
});

var IconMouse = createReactComponent("outline", "mouse", "IconMouse", [["path", { "d": "M6 3m0 4a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-4a4 4 0 0 1 -4 -4z", "key": "svg-0" }], ["path", { "d": "M12 7l0 4", "key": "svg-1" }]]);

var IconMouse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMouse
});

var IconMoustache = createReactComponent("outline", "moustache", "IconMoustache", [["path", { "d": "M15 9a3 3 0 0 1 2.599 1.5h0c.933 1.333 2.133 1.556 3.126 1.556l.291 0l.77 -.044l.213 0c-.963 1.926 -3.163 2.925 -6.6 3l-.4 0l-.165 0a3 3 0 0 1 .165 -6z", "key": "svg-0" }], ["path", { "d": "M9 9a3 3 0 0 0 -2.599 1.5h0c-.933 1.333 -2.133 1.556 -3.126 1.556l-.291 0l-.77 -.044l-.213 0c.963 1.926 3.163 2.925 6.6 3l.4 0l.165 0a3 3 0 0 0 -.165 -6z", "key": "svg-1" }]]);

var IconMoustache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoustache
});

var IconMovieOff = createReactComponent("outline", "movie-off", "IconMovieOff", [["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.592 3.42c-.362 .359 -.859 .58 -1.408 .58h-12a2 2 0 0 1 -2 -2v-12c0 -.539 .213 -1.028 .56 -1.388", "key": "svg-0" }], ["path", { "d": "M8 8v12", "key": "svg-1" }], ["path", { "d": "M16 4v8m0 4v4", "key": "svg-2" }], ["path", { "d": "M4 8h4", "key": "svg-3" }], ["path", { "d": "M4 16h4", "key": "svg-4" }], ["path", { "d": "M4 12h8m4 0h4", "key": "svg-5" }], ["path", { "d": "M16 8h4", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconMovieOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMovieOff
});

var IconMovie = createReactComponent("outline", "movie", "IconMovie", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 4l0 16", "key": "svg-1" }], ["path", { "d": "M16 4l0 16", "key": "svg-2" }], ["path", { "d": "M4 8l4 0", "key": "svg-3" }], ["path", { "d": "M4 16l4 0", "key": "svg-4" }], ["path", { "d": "M4 12l16 0", "key": "svg-5" }], ["path", { "d": "M16 8l4 0", "key": "svg-6" }], ["path", { "d": "M16 16l4 0", "key": "svg-7" }]]);

var IconMovie$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMovie
});

var IconMugOff = createReactComponent("outline", "mug-off", "IconMugOff", [["path", { "d": "M9 5h5.917a1.08 1.08 0 0 1 1.083 1.077v5.923m-.167 3.88a4.33 4.33 0 0 1 -4.166 3.12h-4.334c-2.393 0 -4.333 -1.929 -4.333 -4.308v-8.615a1.08 1.08 0 0 1 1.083 -1.077h.917", "key": "svg-0" }], ["path", { "d": "M16 8h2.5c1.38 0 2.5 1.045 2.5 2.333v2.334c0 1.148 -.89 2.103 -2.06 2.297", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconMugOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMugOff
});

var IconMug = createReactComponent("outline", "mug", "IconMug", [["path", { "d": "M4.083 5h10.834a1.08 1.08 0 0 1 1.083 1.077v8.615c0 2.38 -1.94 4.308 -4.333 4.308h-4.334c-2.393 0 -4.333 -1.929 -4.333 -4.308v-8.615a1.08 1.08 0 0 1 1.083 -1.077", "key": "svg-0" }], ["path", { "d": "M16 8h2.5c1.38 0 2.5 1.045 2.5 2.333v2.334c0 1.288 -1.12 2.333 -2.5 2.333h-2.5", "key": "svg-1" }]]);

var IconMug$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMug
});

var IconMultiplier05x = createReactComponent("outline", "multiplier-0-5x", "IconMultiplier05x", [["path", { "d": "M8 16h2a2 2 0 1 0 0 -4h-2v-4h4", "key": "svg-0" }], ["path", { "d": "M5 16v.01", "key": "svg-1" }], ["path", { "d": "M15 16l4 -4", "key": "svg-2" }], ["path", { "d": "M19 16l-4 -4", "key": "svg-3" }]]);

var IconMultiplier05x$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMultiplier05x
});

var IconMultiplier15x = createReactComponent("outline", "multiplier-1-5x", "IconMultiplier15x", [["path", { "d": "M4 16v-8l-2 2", "key": "svg-0" }], ["path", { "d": "M10 16h2a2 2 0 1 0 0 -4h-2v-4h4", "key": "svg-1" }], ["path", { "d": "M7 16v.01", "key": "svg-2" }], ["path", { "d": "M17 16l4 -4", "key": "svg-3" }], ["path", { "d": "M21 16l-4 -4", "key": "svg-4" }]]);

var IconMultiplier15x$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMultiplier15x
});

var IconMultiplier1x = createReactComponent("outline", "multiplier-1x", "IconMultiplier1x", [["path", { "d": "M9 16v-8l-2 2", "key": "svg-0" }], ["path", { "d": "M13 16l4 -4", "key": "svg-1" }], ["path", { "d": "M17 16l-4 -4", "key": "svg-2" }]]);

var IconMultiplier1x$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMultiplier1x
});

var IconMultiplier2x = createReactComponent("outline", "multiplier-2x", "IconMultiplier2x", [["path", { "d": "M14 16l4 -4", "key": "svg-0" }], ["path", { "d": "M18 16l-4 -4", "key": "svg-1" }], ["path", { "d": "M6 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0", "key": "svg-2" }]]);

var IconMultiplier2x$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMultiplier2x
});

var IconMushroomOff = createReactComponent("outline", "mushroom-off", "IconMushroomOff", [["path", { "d": "M5.874 5.89a8.128 8.128 0 0 0 -1.874 5.21a.9 .9 0 0 0 .9 .9h7.1m4 0h3.1a.9 .9 0 0 0 .9 -.9c0 -4.474 -3.582 -8.1 -8 -8.1c-1.43 0 -2.774 .38 -3.936 1.047", "key": "svg-0" }], ["path", { "d": "M10 12v7a2 2 0 1 0 4 0v-5", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconMushroomOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMushroomOff
});

var IconMushroom = createReactComponent("outline", "mushroom", "IconMushroom", [["path", { "d": "M20 11.1c0 -4.474 -3.582 -8.1 -8 -8.1s-8 3.626 -8 8.1a.9 .9 0 0 0 .9 .9h14.2a.9 .9 0 0 0 .9 -.9z", "key": "svg-0" }], ["path", { "d": "M10 12v7a2 2 0 1 0 4 0v-7", "key": "svg-1" }]]);

var IconMushroom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMushroom
});

var IconMusicBolt = createReactComponent("outline", "music-bolt", "IconMusicBolt", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v8", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-3" }]]);

var IconMusicBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicBolt
});

var IconMusicCancel = createReactComponent("outline", "music-cancel", "IconMusicCancel", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v8", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M17 21l4 -4", "key": "svg-4" }]]);

var IconMusicCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicCancel
});

var IconMusicCheck = createReactComponent("outline", "music-check", "IconMusicCheck", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v9.5", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-3" }]]);

var IconMusicCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicCheck
});

var IconMusicCode = createReactComponent("outline", "music-code", "IconMusicCode", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v9", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-3" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-4" }]]);

var IconMusicCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicCode
});

var IconMusicCog = createReactComponent("outline", "music-cog", "IconMusicCog", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v7.5", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-4" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-5" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-6" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-7" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-8" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-9" }]]);

var IconMusicCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicCog
});

var IconMusicDiscount = createReactComponent("outline", "music-discount", "IconMusicDiscount", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v9", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M16 21l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21v.01", "key": "svg-4" }], ["path", { "d": "M16 16v.01", "key": "svg-5" }]]);

var IconMusicDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicDiscount
});

var IconMusicDollar = createReactComponent("outline", "music-dollar", "IconMusicDollar", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v6", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-4" }]]);

var IconMusicDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicDollar
});

var IconMusicDown = createReactComponent("outline", "music-down", "IconMusicDown", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v8", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-4" }]]);

var IconMusicDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicDown
});

var IconMusicExclamation = createReactComponent("outline", "music-exclamation", "IconMusicExclamation", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v8", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M19 16v3", "key": "svg-3" }], ["path", { "d": "M19 22v.01", "key": "svg-4" }]]);

var IconMusicExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicExclamation
});

var IconMusicHeart = createReactComponent("outline", "music-heart", "IconMusicHeart", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v7", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-3" }]]);

var IconMusicHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicHeart
});

var IconMusicMinus = createReactComponent("outline", "music-minus", "IconMusicMinus", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v11", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconMusicMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicMinus
});

var IconMusicOff = createReactComponent("outline", "music-off", "IconMusicOff", [["path", { "d": "M6 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M14.42 14.45a3 3 0 1 0 4.138 4.119", "key": "svg-1" }], ["path", { "d": "M9 17v-8m0 -4v-1h10v11", "key": "svg-2" }], ["path", { "d": "M12 8h7", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconMusicOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicOff
});

var IconMusicPause = createReactComponent("outline", "music-pause", "IconMusicPause", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v9", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M17 17v5", "key": "svg-3" }], ["path", { "d": "M21 17v5", "key": "svg-4" }]]);

var IconMusicPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicPause
});

var IconMusicPin = createReactComponent("outline", "music-pin", "IconMusicPin", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v7", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-3" }], ["path", { "d": "M19 18v.01", "key": "svg-4" }]]);

var IconMusicPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicPin
});

var IconMusicPlus = createReactComponent("outline", "music-plus", "IconMusicPlus", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v8", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconMusicPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicPlus
});

var IconMusicQuestion = createReactComponent("outline", "music-question", "IconMusicQuestion", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v7", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-4" }]]);

var IconMusicQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicQuestion
});

var IconMusicSearch = createReactComponent("outline", "music-search", "IconMusicSearch", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v7", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-4" }]]);

var IconMusicSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicSearch
});

var IconMusicShare = createReactComponent("outline", "music-share", "IconMusicShare", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v9", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M16 22l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-4" }]]);

var IconMusicShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicShare
});

var IconMusicStar = createReactComponent("outline", "music-star", "IconMusicStar", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v6", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-3" }]]);

var IconMusicStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicStar
});

var IconMusicUp = createReactComponent("outline", "music-up", "IconMusicUp", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v8", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M19 22v-6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-4" }]]);

var IconMusicUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicUp
});

var IconMusicX = createReactComponent("outline", "music-x", "IconMusicX", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v9", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-3" }], ["path", { "d": "M17 22l5 -5", "key": "svg-4" }]]);

var IconMusicX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusicX
});

var IconMusic = createReactComponent("outline", "music", "IconMusic", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M13 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M9 17v-13h10v13", "key": "svg-2" }], ["path", { "d": "M9 8h10", "key": "svg-3" }]]);

var IconMusic$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMusic
});

var IconNavigationBolt = createReactComponent("outline", "navigation-bolt", "IconNavigationBolt", [["path", { "d": "M16.559 12.882l-4.559 -9.882l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463l1.036 .351", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }]]);

var IconNavigationBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationBolt
});

var IconNavigationCancel = createReactComponent("outline", "navigation-cancel", "IconNavigationCancel", [["path", { "d": "M16.371 12.476l-4.371 -9.476l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }]]);

var IconNavigationCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationCancel
});

var IconNavigationCheck = createReactComponent("outline", "navigation-check", "IconNavigationCheck", [["path", { "d": "M17.487 14.894l-5.487 -11.894l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l6.275 -2.127", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }]]);

var IconNavigationCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationCheck
});

var IconNavigationCode = createReactComponent("outline", "navigation-code", "IconNavigationCode", [["path", { "d": "M16.653 13.086l-4.653 -10.086l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l6.246 -2.117", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }]]);

var IconNavigationCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationCode
});

var IconNavigationCog = createReactComponent("outline", "navigation-cog", "IconNavigationCog", [["path", { "d": "M16.387 12.51l-4.387 -9.51l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463", "key": "svg-0" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-2" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-3" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-7" }]]);

var IconNavigationCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationCog
});

var IconNavigationDiscount = createReactComponent("outline", "navigation-discount", "IconNavigationDiscount", [["path", { "d": "M16.43 12.603l-4.43 -9.603l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463l1.272 .431", "key": "svg-0" }], ["path", { "d": "M16 21l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21v.01", "key": "svg-2" }], ["path", { "d": "M16 16v.01", "key": "svg-3" }]]);

var IconNavigationDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationDiscount
});

var IconNavigationDollar = createReactComponent("outline", "navigation-dollar", "IconNavigationDollar", [["path", { "d": "M15.945 11.551l-3.945 -8.551l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463l1.594 .54", "key": "svg-0" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-2" }]]);

var IconNavigationDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationDollar
});

var IconNavigationDown = createReactComponent("outline", "navigation-down", "IconNavigationDown", [["path", { "d": "M16.528 12.815l-4.528 -9.815l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }]]);

var IconNavigationDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationDown
});

var IconNavigationEast = createReactComponent("outline", "navigation-east", "IconNavigationEast", [["path", { "d": "M14 3h-4v6h4", "key": "svg-0" }], ["path", { "d": "M10 6h2.5", "key": "svg-1" }], ["path", { "d": "M16 21l-4 -8l-4 8l4 -2z", "key": "svg-2" }]]);

var IconNavigationEast$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationEast
});

var IconNavigationExclamation = createReactComponent("outline", "navigation-exclamation", "IconNavigationExclamation", [["path", { "d": "M16.535 12.832l-4.535 -9.832l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463c1.38 .468 2.416 .82 3.107 1.053", "key": "svg-0" }], ["path", { "d": "M19 16v3", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }]]);

var IconNavigationExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationExclamation
});

var IconNavigationHeart = createReactComponent("outline", "navigation-heart", "IconNavigationHeart", [["path", { "d": "M15.721 11.067l-3.721 -8.067l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l5.614 -1.903", "key": "svg-0" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-1" }]]);

var IconNavigationHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationHeart
});

var IconNavigationMinus = createReactComponent("outline", "navigation-minus", "IconNavigationMinus", [["path", { "d": "M17.5 15c-1.232 -2.67 -3.065 -6.67 -5.5 -12l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconNavigationMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationMinus
});

var IconNavigationNorth = createReactComponent("outline", "navigation-north", "IconNavigationNorth", [["path", { "d": "M16 21l-4 -8l-4 8l4 -2z", "key": "svg-0" }], ["path", { "d": "M10 9v-6l4 6v-6", "key": "svg-1" }]]);

var IconNavigationNorth$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationNorth
});

var IconNavigationOff = createReactComponent("outline", "navigation-off", "IconNavigationOff", [["path", { "d": "M16.28 12.28c-.95 -2.064 -2.377 -5.157 -4.28 -9.28c-.7 1.515 -1.223 2.652 -1.573 3.41m-1.27 2.75c-.882 1.913 -2.59 5.618 -5.127 11.115c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463l7.265 2.463c.196 .077 .42 .032 .57 -.116a.548 .548 0 0 0 .134 -.572l-.26 -.563", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconNavigationOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationOff
});

var IconNavigationPause = createReactComponent("outline", "navigation-pause", "IconNavigationPause", [["path", { "d": "M16.666 13.114l-4.666 -10.114l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463l1.056 .358", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }]]);

var IconNavigationPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationPause
});

var IconNavigationPin = createReactComponent("outline", "navigation-pin", "IconNavigationPin", [["path", { "d": "M16.002 11.676l-4.002 -8.676l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }]]);

var IconNavigationPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationPin
});

var IconNavigationPlus = createReactComponent("outline", "navigation-plus", "IconNavigationPlus", [["path", { "d": "M16.573 12.914l-4.573 -9.914l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconNavigationPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationPlus
});

var IconNavigationQuestion = createReactComponent("outline", "navigation-question", "IconNavigationQuestion", [["path", { "d": "M16.081 11.847l-4.081 -8.847l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463c1.35 .458 2.362 .8 3.037 1.03", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconNavigationQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationQuestion
});

var IconNavigationSearch = createReactComponent("outline", "navigation-search", "IconNavigationSearch", [["path", { "d": "M15.876 11.403l-3.876 -8.403l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l6.29 -2.132", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }]]);

var IconNavigationSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationSearch
});

var IconNavigationShare = createReactComponent("outline", "navigation-share", "IconNavigationShare", [["path", { "d": "M16.633 13.043l-4.633 -10.043l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463l.955 .324", "key": "svg-0" }], ["path", { "d": "M16 22l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-2" }]]);

var IconNavigationShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationShare
});

var IconNavigationSouth = createReactComponent("outline", "navigation-south", "IconNavigationSouth", [["path", { "d": "M10 8.25c0 .414 .336 .75 .75 .75h2.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h2.25a.75 .75 0 0 1 .75 .75", "key": "svg-0" }], ["path", { "d": "M16 21l-4 -8l-4 8l4 -2z", "key": "svg-1" }]]);

var IconNavigationSouth$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationSouth
});

var IconNavigationStar = createReactComponent("outline", "navigation-star", "IconNavigationStar", [["path", { "d": "M15.574 10.747l-3.574 -7.747l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l5.454 -1.85", "key": "svg-0" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }]]);

var IconNavigationStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationStar
});

var IconNavigationTop = createReactComponent("outline", "navigation-top", "IconNavigationTop", [["path", { "d": "M16.54 19.977a.34 .34 0 0 0 .357 -.07a.33 .33 0 0 0 .084 -.35l-4.981 -10.557l-4.982 10.557a.33 .33 0 0 0 .084 .35a.34 .34 0 0 0 .357 .07l4.541 -1.477l4.54 1.477z", "key": "svg-0" }], ["path", { "d": "M12 3v2", "key": "svg-1" }]]);

var IconNavigationTop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationTop
});

var IconNavigationUp = createReactComponent("outline", "navigation-up", "IconNavigationUp", [["path", { "d": "M16.54 12.843l-4.54 -9.843l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }]]);

var IconNavigationUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationUp
});

var IconNavigationWest = createReactComponent("outline", "navigation-west", "IconNavigationWest", [["path", { "d": "M9 3l1 6l2 -3.75l2 3.75l1 -6", "key": "svg-0" }], ["path", { "d": "M16 21l-4 -8l-4 8l4 -2z", "key": "svg-1" }]]);

var IconNavigationWest$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationWest
});

var IconNavigationX = createReactComponent("outline", "navigation-x", "IconNavigationX", [["path", { "d": "M16.622 13.02l-4.622 -10.02l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463l1.563 .53", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }]]);

var IconNavigationX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationX
});

var IconNavigation = createReactComponent("outline", "navigation", "IconNavigation", [["path", { "d": "M12 18.5l7.265 2.463c.196 .077 .42 .032 .57 -.116a.548 .548 0 0 0 .134 -.572l-7.969 -17.275l-7.97 17.275c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463", "key": "svg-0" }]]);

var IconNavigation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigation
});

var IconNeedleThread = createReactComponent("outline", "needle-thread", "IconNeedleThread", [["path", { "d": "M3 21c-.667 -.667 3.262 -6.236 11.785 -16.709a3.5 3.5 0 1 1 5.078 4.791c-10.575 8.612 -16.196 12.585 -16.863 11.918z", "key": "svg-0" }], ["path", { "d": "M17.5 6.5l-1 1", "key": "svg-1" }], ["path", { "d": "M17 7c-2.333 -2.667 -3.5 -4 -5 -4s-2 1 -2 2c0 4 8.161 8.406 6 11c-1.056 1.268 -3.363 1.285 -5.75 .808", "key": "svg-2" }], ["path", { "d": "M5.739 15.425c-1.393 -.565 -3.739 -1.925 -3.739 -3.425", "key": "svg-3" }], ["path", { "d": "M19.5 9.5l1.5 1.5", "key": "svg-4" }]]);

var IconNeedleThread$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNeedleThread
});

var IconNeedle = createReactComponent("outline", "needle", "IconNeedle", [["path", { "d": "M3 21c-.667 -.667 3.262 -6.236 11.785 -16.709a3.5 3.5 0 1 1 5.078 4.791c-10.575 8.612 -16.196 12.585 -16.863 11.918z", "key": "svg-0" }], ["path", { "d": "M17.5 6.5l-1 1", "key": "svg-1" }]]);

var IconNeedle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNeedle
});

var IconNetworkOff = createReactComponent("outline", "network-off", "IconNetworkOff", [["path", { "d": "M6.528 6.536a6 6 0 0 0 7.942 7.933m2.247 -1.76a6 6 0 0 0 -8.427 -8.425", "key": "svg-0" }], ["path", { "d": "M12 3c1.333 .333 2 2.333 2 6c0 .337 -.006 .66 -.017 .968m-.55 3.473c-.333 .884 -.81 1.403 -1.433 1.559", "key": "svg-1" }], ["path", { "d": "M12 3c-.936 .234 -1.544 1.29 -1.822 3.167m-.16 3.838c.116 3.029 .776 4.695 1.982 4.995", "key": "svg-2" }], ["path", { "d": "M6 9h3m4 0h5", "key": "svg-3" }], ["path", { "d": "M3 20h7", "key": "svg-4" }], ["path", { "d": "M14 20h7", "key": "svg-5" }], ["path", { "d": "M10 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M12 15v3", "key": "svg-7" }], ["path", { "d": "M3 3l18 18", "key": "svg-8" }]]);

var IconNetworkOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNetworkOff
});

var IconNetwork = createReactComponent("outline", "network", "IconNetwork", [["path", { "d": "M6 9a6 6 0 1 0 12 0a6 6 0 0 0 -12 0", "key": "svg-0" }], ["path", { "d": "M12 3c1.333 .333 2 2.333 2 6s-.667 5.667 -2 6", "key": "svg-1" }], ["path", { "d": "M12 3c-1.333 .333 -2 2.333 -2 6s.667 5.667 2 6", "key": "svg-2" }], ["path", { "d": "M6 9h12", "key": "svg-3" }], ["path", { "d": "M3 20h7", "key": "svg-4" }], ["path", { "d": "M14 20h7", "key": "svg-5" }], ["path", { "d": "M10 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-6" }], ["path", { "d": "M12 15v3", "key": "svg-7" }]]);

var IconNetwork$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNetwork
});

var IconNewSection = createReactComponent("outline", "new-section", "IconNewSection", [["path", { "d": "M9 12l6 0", "key": "svg-0" }], ["path", { "d": "M12 9l0 6", "key": "svg-1" }], ["path", { "d": "M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2m0 -5", "key": "svg-2" }]]);

var IconNewSection$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNewSection
});

var IconNewsOff = createReactComponent("outline", "news-off", "IconNewsOff", [["path", { "d": "M16 6h3a1 1 0 0 1 1 1v9m-.606 3.435a2 2 0 0 1 -3.394 -1.435v-2m0 -4v-7a1 1 0 0 0 -1 -1h-7m-3.735 .321a1 1 0 0 0 -.265 .679v12a3 3 0 0 0 3 3h11", "key": "svg-0" }], ["path", { "d": "M8 12h4", "key": "svg-1" }], ["path", { "d": "M8 16h4", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconNewsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNewsOff
});

var IconNews = createReactComponent("outline", "news", "IconNews", [["path", { "d": "M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11", "key": "svg-0" }], ["path", { "d": "M8 8l4 0", "key": "svg-1" }], ["path", { "d": "M8 12l4 0", "key": "svg-2" }], ["path", { "d": "M8 16l4 0", "key": "svg-3" }]]);

var IconNews$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNews
});

var IconNfcOff = createReactComponent("outline", "nfc-off", "IconNfcOff", [["path", { "d": "M11 20a3 3 0 0 1 -3 -3v-9", "key": "svg-0" }], ["path", { "d": "M13 4a3 3 0 0 1 3 3v5m0 4v2l-5 -5", "key": "svg-1" }], ["path", { "d": "M8 4h9a3 3 0 0 1 3 3v9m-.873 3.116a2.99 2.99 0 0 1 -2.127 .884h-10a3 3 0 0 1 -3 -3v-10c0 -.83 .337 -1.582 .882 -2.125", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconNfcOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNfcOff
});

var IconNfc = createReactComponent("outline", "nfc", "IconNfc", [["path", { "d": "M11 20a3 3 0 0 1 -3 -3v-11l5 5", "key": "svg-0" }], ["path", { "d": "M13 4a3 3 0 0 1 3 3v11l-5 -5", "key": "svg-1" }], ["path", { "d": "M4 4m0 3a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3z", "key": "svg-2" }]]);

var IconNfc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNfc
});

var IconNoCopyright = createReactComponent("outline", "no-copyright", "IconNoCopyright", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14 9.75a3.016 3.016 0 0 0 -4.163 .173a2.993 2.993 0 0 0 0 4.154a3.016 3.016 0 0 0 4.163 .173", "key": "svg-1" }], ["path", { "d": "M6 6l1.5 1.5", "key": "svg-2" }], ["path", { "d": "M16.5 16.5l1.5 1.5", "key": "svg-3" }]]);

var IconNoCopyright$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNoCopyright
});

var IconNoCreativeCommons = createReactComponent("outline", "no-creative-commons", "IconNoCreativeCommons", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116", "key": "svg-1" }], ["path", { "d": "M16.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116", "key": "svg-2" }], ["path", { "d": "M6 6l1.5 1.5", "key": "svg-3" }], ["path", { "d": "M16.5 16.5l1.5 1.5", "key": "svg-4" }]]);

var IconNoCreativeCommons$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNoCreativeCommons
});

var IconNoDerivatives = createReactComponent("outline", "no-derivatives", "IconNoDerivatives", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10h6", "key": "svg-1" }], ["path", { "d": "M9 14h6", "key": "svg-2" }]]);

var IconNoDerivatives$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNoDerivatives
});

var IconNorthStar = createReactComponent("outline", "north-star", "IconNorthStar", [["path", { "d": "M3 12h18", "key": "svg-0" }], ["path", { "d": "M12 21v-18", "key": "svg-1" }], ["path", { "d": "M7.5 7.5l9 9", "key": "svg-2" }], ["path", { "d": "M7.5 16.5l9 -9", "key": "svg-3" }]]);

var IconNorthStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNorthStar
});

var IconNoteOff = createReactComponent("outline", "note-off", "IconNoteOff", [["path", { "d": "M13 20l3.505 -3.505m2 -2l1.501 -1.501", "key": "svg-0" }], ["path", { "d": "M17 13h3v-7a2 2 0 0 0 -2 -2h-10m-3.427 .6c-.355 .36 -.573 .853 -.573 1.4v12a2 2 0 0 0 2 2h7v-6c0 -.272 .109 -.519 .285 -.699", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconNoteOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNoteOff
});

var IconNote = createReactComponent("outline", "note", "IconNote", [["path", { "d": "M13 20l7 -7", "key": "svg-0" }], ["path", { "d": "M13 20v-6a1 1 0 0 1 1 -1h6v-7a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7", "key": "svg-1" }]]);

var IconNote$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNote
});

var IconNotebookOff = createReactComponent("outline", "notebook-off", "IconNotebookOff", [["path", { "d": "M8 4h9a2 2 0 0 1 2 2v9m-.179 3.828a2 2 0 0 1 -1.821 1.172h-11a1 1 0 0 1 -1 -1v-14m4 -1v1m0 4v13", "key": "svg-0" }], ["path", { "d": "M13 8h2", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconNotebookOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNotebookOff
});

var IconNotebook = createReactComponent("outline", "notebook", "IconNotebook", [["path", { "d": "M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18", "key": "svg-0" }], ["path", { "d": "M13 8l2 0", "key": "svg-1" }], ["path", { "d": "M13 12l2 0", "key": "svg-2" }]]);

var IconNotebook$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNotebook
});

var IconNotesOff = createReactComponent("outline", "notes-off", "IconNotesOff", [["path", { "d": "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14", "key": "svg-0" }], ["path", { "d": "M11 7h4", "key": "svg-1" }], ["path", { "d": "M9 11h2", "key": "svg-2" }], ["path", { "d": "M9 15h4", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconNotesOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNotesOff
});

var IconNotes = createReactComponent("outline", "notes", "IconNotes", [["path", { "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 7l6 0", "key": "svg-1" }], ["path", { "d": "M9 11l6 0", "key": "svg-2" }], ["path", { "d": "M9 15l4 0", "key": "svg-3" }]]);

var IconNotes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNotes
});

var IconNotificationOff = createReactComponent("outline", "notification-off", "IconNotificationOff", [["path", { "d": "M6.154 6.187a2 2 0 0 0 -1.154 1.813v9a2 2 0 0 0 2 2h9a2 2 0 0 0 1.811 -1.151", "key": "svg-0" }], ["path", { "d": "M17 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconNotificationOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNotificationOff
});

var IconNotification = createReactComponent("outline", "notification", "IconNotification", [["path", { "d": "M10 6h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3", "key": "svg-0" }], ["path", { "d": "M17 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }]]);

var IconNotification$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNotification
});

var IconNumber0Small = createReactComponent("outline", "number-0-small", "IconNumber0Small", [["path", { "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-0" }]]);

var IconNumber0Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber0Small
});

var IconNumber0 = createReactComponent("outline", "number-0", "IconNumber0", [["path", { "d": "M16 16v-8", "key": "svg-0" }], ["path", { "d": "M12 20a4 4 0 0 0 4 -4v-8a4 4 0 1 0 -8 0v8a4 4 0 0 0 4 4z", "key": "svg-1" }]]);

var IconNumber0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber0
});

var IconNumber1Small = createReactComponent("outline", "number-1-small", "IconNumber1Small", [["path", { "d": "M11 8h1v8", "key": "svg-0" }]]);

var IconNumber1Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber1Small
});

var IconNumber1 = createReactComponent("outline", "number-1", "IconNumber1", [["path", { "d": "M13 20v-16l-5 5", "key": "svg-0" }]]);

var IconNumber1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber1
});

var IconNumber10Small = createReactComponent("outline", "number-10-small", "IconNumber10Small", [["path", { "d": "M8 8h1v8", "key": "svg-0" }], ["path", { "d": "M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-1" }]]);

var IconNumber10Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber10Small
});

var IconNumber10 = createReactComponent("outline", "number-10", "IconNumber10", [["path", { "d": "M8 20v-16l-5 5", "key": "svg-0" }], ["path", { "d": "M16 20a4 4 0 0 0 4 -4v-8a4 4 0 1 0 -8 0v8a4 4 0 0 0 4 4", "key": "svg-1" }]]);

var IconNumber10$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber10
});

var IconNumber100Small = createReactComponent("outline", "number-100-small", "IconNumber100Small", [["path", { "d": "M4 8h1v8", "key": "svg-0" }], ["path", { "d": "M9 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M16 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-2" }]]);

var IconNumber100Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber100Small
});

var IconNumber11Small = createReactComponent("outline", "number-11-small", "IconNumber11Small", [["path", { "d": "M8 8h1v8", "key": "svg-0" }], ["path", { "d": "M14 8h1v8", "key": "svg-1" }]]);

var IconNumber11Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber11Small
});

var IconNumber11 = createReactComponent("outline", "number-11", "IconNumber11", [["path", { "d": "M8 20v-16l-5 5", "key": "svg-0" }], ["path", { "d": "M18 20v-16l-5 5", "key": "svg-1" }]]);

var IconNumber11$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber11
});

var IconNumber12Small = createReactComponent("outline", "number-12-small", "IconNumber12Small", [["path", { "d": "M8 8h1v8", "key": "svg-0" }], ["path", { "d": "M13 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber12Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber12Small
});

var IconNumber123 = createReactComponent("outline", "number-123", "IconNumber123", [["path", { "d": "M3 10l2 -2v8", "key": "svg-0" }], ["path", { "d": "M9 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M17 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-2" }]]);

var IconNumber123$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber123
});

var IconNumber13Small = createReactComponent("outline", "number-13-small", "IconNumber13Small", [["path", { "d": "M8 8h1v8", "key": "svg-0" }], ["path", { "d": "M13 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconNumber13Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber13Small
});

var IconNumber14Small = createReactComponent("outline", "number-14-small", "IconNumber14Small", [["path", { "d": "M8 8h1v8", "key": "svg-0" }], ["path", { "d": "M13 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M17 8v8", "key": "svg-2" }]]);

var IconNumber14Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber14Small
});

var IconNumber15Small = createReactComponent("outline", "number-15-small", "IconNumber15Small", [["path", { "d": "M8 8h1v8", "key": "svg-0" }], ["path", { "d": "M13 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconNumber15Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber15Small
});

var IconNumber16Small = createReactComponent("outline", "number-16-small", "IconNumber16Small", [["path", { "d": "M8 8h1v8", "key": "svg-0" }], ["path", { "d": "M17 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconNumber16Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber16Small
});

var IconNumber17Small = createReactComponent("outline", "number-17-small", "IconNumber17Small", [["path", { "d": "M8 8h1v8", "key": "svg-0" }], ["path", { "d": "M13 8h4l-2 8", "key": "svg-1" }]]);

var IconNumber17Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber17Small
});

var IconNumber18Small = createReactComponent("outline", "number-18-small", "IconNumber18Small", [["path", { "d": "M8 8h1v8", "key": "svg-0" }], ["path", { "d": "M15 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconNumber18Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber18Small
});

var IconNumber19Small = createReactComponent("outline", "number-19-small", "IconNumber19Small", [["path", { "d": "M8 8h1v8", "key": "svg-0" }], ["path", { "d": "M13 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber19Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber19Small
});

var IconNumber2Small = createReactComponent("outline", "number-2-small", "IconNumber2Small", [["path", { "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }]]);

var IconNumber2Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber2Small
});

var IconNumber2 = createReactComponent("outline", "number-2", "IconNumber2", [["path", { "d": "M8 8a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 9.185h8", "key": "svg-0" }]]);

var IconNumber2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber2
});

var IconNumber20Small = createReactComponent("outline", "number-20-small", "IconNumber20Small", [["path", { "d": "M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber20Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber20Small
});

var IconNumber21Small = createReactComponent("outline", "number-21-small", "IconNumber21Small", [["path", { "d": "M15 8h1v8", "key": "svg-0" }], ["path", { "d": "M7 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber21Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber21Small
});

var IconNumber22Small = createReactComponent("outline", "number-22-small", "IconNumber22Small", [["path", { "d": "M14 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber22Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber22Small
});

var IconNumber23Small = createReactComponent("outline", "number-23-small", "IconNumber23Small", [["path", { "d": "M14 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-0" }], ["path", { "d": "M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber23Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber23Small
});

var IconNumber24Small = createReactComponent("outline", "number-24-small", "IconNumber24Small", [["path", { "d": "M14 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M18 8v8", "key": "svg-1" }], ["path", { "d": "M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-2" }]]);

var IconNumber24Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber24Small
});

var IconNumber25Small = createReactComponent("outline", "number-25-small", "IconNumber25Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-0" }], ["path", { "d": "M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber25Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber25Small
});

var IconNumber26Small = createReactComponent("outline", "number-26-small", "IconNumber26Small", [["path", { "d": "M18 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-0" }], ["path", { "d": "M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber26Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber26Small
});

var IconNumber27Small = createReactComponent("outline", "number-27-small", "IconNumber27Small", [["path", { "d": "M14 8h4l-2 8", "key": "svg-0" }], ["path", { "d": "M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber27Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber27Small
});

var IconNumber28Small = createReactComponent("outline", "number-28-small", "IconNumber28Small", [["path", { "d": "M16 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-0" }], ["path", { "d": "M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber28Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber28Small
});

var IconNumber29Small = createReactComponent("outline", "number-29-small", "IconNumber29Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber29Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber29Small
});

var IconNumber3Small = createReactComponent("outline", "number-3-small", "IconNumber3Small", [["path", { "d": "M10 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-0" }]]);

var IconNumber3Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber3Small
});

var IconNumber3 = createReactComponent("outline", "number-3", "IconNumber3", [["path", { "d": "M12 12a4 4 0 1 0 -4 -4", "key": "svg-0" }], ["path", { "d": "M8 16a4 4 0 1 0 4 -4", "key": "svg-1" }]]);

var IconNumber3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber3
});

var IconNumber30Small = createReactComponent("outline", "number-30-small", "IconNumber30Small", [["path", { "d": "M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconNumber30Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber30Small
});

var IconNumber31Small = createReactComponent("outline", "number-31-small", "IconNumber31Small", [["path", { "d": "M15 8h1v8", "key": "svg-0" }], ["path", { "d": "M7 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconNumber31Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber31Small
});

var IconNumber32Small = createReactComponent("outline", "number-32-small", "IconNumber32Small", [["path", { "d": "M14 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M6 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconNumber32Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber32Small
});

var IconNumber33Small = createReactComponent("outline", "number-33-small", "IconNumber33Small", [["path", { "d": "M14 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-0" }], ["path", { "d": "M6 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconNumber33Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber33Small
});

var IconNumber34Small = createReactComponent("outline", "number-34-small", "IconNumber34Small", [["path", { "d": "M14 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M18 8v8", "key": "svg-1" }], ["path", { "d": "M6 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-2" }]]);

var IconNumber34Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber34Small
});

var IconNumber35Small = createReactComponent("outline", "number-35-small", "IconNumber35Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-0" }], ["path", { "d": "M6 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconNumber35Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber35Small
});

var IconNumber36Small = createReactComponent("outline", "number-36-small", "IconNumber36Small", [["path", { "d": "M18 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-0" }], ["path", { "d": "M6 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconNumber36Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber36Small
});

var IconNumber37Small = createReactComponent("outline", "number-37-small", "IconNumber37Small", [["path", { "d": "M14 8h4l-2 8", "key": "svg-0" }], ["path", { "d": "M6 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconNumber37Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber37Small
});

var IconNumber38Small = createReactComponent("outline", "number-38-small", "IconNumber38Small", [["path", { "d": "M16 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-0" }], ["path", { "d": "M6 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconNumber38Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber38Small
});

var IconNumber39Small = createReactComponent("outline", "number-39-small", "IconNumber39Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M6 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconNumber39Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber39Small
});

var IconNumber4Small = createReactComponent("outline", "number-4-small", "IconNumber4Small", [["path", { "d": "M10 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M14 8v8", "key": "svg-1" }]]);

var IconNumber4Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber4Small
});

var IconNumber4 = createReactComponent("outline", "number-4", "IconNumber4", [["path", { "d": "M15 20v-15l-8 11h10", "key": "svg-0" }]]);

var IconNumber4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber4
});

var IconNumber40Small = createReactComponent("outline", "number-40-small", "IconNumber40Small", [["path", { "d": "M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M10 8v8", "key": "svg-2" }]]);

var IconNumber40Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber40Small
});

var IconNumber41Small = createReactComponent("outline", "number-41-small", "IconNumber41Small", [["path", { "d": "M15 8h1v8", "key": "svg-0" }], ["path", { "d": "M6 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M10 8v8", "key": "svg-2" }]]);

var IconNumber41Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber41Small
});

var IconNumber42Small = createReactComponent("outline", "number-42-small", "IconNumber42Small", [["path", { "d": "M14 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M6 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M10 8v8", "key": "svg-2" }]]);

var IconNumber42Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber42Small
});

var IconNumber43Small = createReactComponent("outline", "number-43-small", "IconNumber43Small", [["path", { "d": "M14 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-0" }], ["path", { "d": "M6 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M10 8v8", "key": "svg-2" }]]);

var IconNumber43Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber43Small
});

var IconNumber44Small = createReactComponent("outline", "number-44-small", "IconNumber44Small", [["path", { "d": "M14 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M18 8v8", "key": "svg-1" }], ["path", { "d": "M6 8v3a1 1 0 0 0 1 1h3", "key": "svg-2" }], ["path", { "d": "M10 8v8", "key": "svg-3" }]]);

var IconNumber44Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber44Small
});

var IconNumber45Small = createReactComponent("outline", "number-45-small", "IconNumber45Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-0" }], ["path", { "d": "M6 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M10 8v8", "key": "svg-2" }]]);

var IconNumber45Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber45Small
});

var IconNumber46Small = createReactComponent("outline", "number-46-small", "IconNumber46Small", [["path", { "d": "M18 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-0" }], ["path", { "d": "M6 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M10 8v8", "key": "svg-2" }]]);

var IconNumber46Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber46Small
});

var IconNumber47Small = createReactComponent("outline", "number-47-small", "IconNumber47Small", [["path", { "d": "M14 8h4l-2 8", "key": "svg-0" }], ["path", { "d": "M6 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M10 8v8", "key": "svg-2" }]]);

var IconNumber47Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber47Small
});

var IconNumber48Small = createReactComponent("outline", "number-48-small", "IconNumber48Small", [["path", { "d": "M16 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-0" }], ["path", { "d": "M6 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M10 8v8", "key": "svg-2" }]]);

var IconNumber48Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber48Small
});

var IconNumber49Small = createReactComponent("outline", "number-49-small", "IconNumber49Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M6 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M10 8v8", "key": "svg-2" }]]);

var IconNumber49Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber49Small
});

var IconNumber5Small = createReactComponent("outline", "number-5-small", "IconNumber5Small", [["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-0" }]]);

var IconNumber5Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber5Small
});

var IconNumber5 = createReactComponent("outline", "number-5", "IconNumber5", [["path", { "d": "M8 20h4a4 4 0 1 0 0 -8h-4v-8h8", "key": "svg-0" }]]);

var IconNumber5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber5
});

var IconNumber50Small = createReactComponent("outline", "number-50-small", "IconNumber50Small", [["path", { "d": "M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconNumber50Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber50Small
});

var IconNumber51Small = createReactComponent("outline", "number-51-small", "IconNumber51Small", [["path", { "d": "M15 8h1v8", "key": "svg-0" }], ["path", { "d": "M7 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconNumber51Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber51Small
});

var IconNumber52Small = createReactComponent("outline", "number-52-small", "IconNumber52Small", [["path", { "d": "M14 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconNumber52Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber52Small
});

var IconNumber53Small = createReactComponent("outline", "number-53-small", "IconNumber53Small", [["path", { "d": "M14 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconNumber53Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber53Small
});

var IconNumber54Small = createReactComponent("outline", "number-54-small", "IconNumber54Small", [["path", { "d": "M14 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M18 8v8", "key": "svg-1" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-2" }]]);

var IconNumber54Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber54Small
});

var IconNumber55Small = createReactComponent("outline", "number-55-small", "IconNumber55Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconNumber55Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber55Small
});

var IconNumber56Small = createReactComponent("outline", "number-56-small", "IconNumber56Small", [["path", { "d": "M18 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconNumber56Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber56Small
});

var IconNumber57Small = createReactComponent("outline", "number-57-small", "IconNumber57Small", [["path", { "d": "M14 8h4l-2 8", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconNumber57Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber57Small
});

var IconNumber58Small = createReactComponent("outline", "number-58-small", "IconNumber58Small", [["path", { "d": "M16 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconNumber58Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber58Small
});

var IconNumber59Small = createReactComponent("outline", "number-59-small", "IconNumber59Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconNumber59Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber59Small
});

var IconNumber6Small = createReactComponent("outline", "number-6-small", "IconNumber6Small", [["path", { "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-0" }]]);

var IconNumber6Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber6Small
});

var IconNumber6 = createReactComponent("outline", "number-6", "IconNumber6", [["path", { "d": "M8 16a4 4 0 1 0 8 0v-1a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M16 8a4 4 0 1 0 -8 0v8", "key": "svg-1" }]]);

var IconNumber6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber6
});

var IconNumber60Small = createReactComponent("outline", "number-60-small", "IconNumber60Small", [["path", { "d": "M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M10 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconNumber60Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber60Small
});

var IconNumber61Small = createReactComponent("outline", "number-61-small", "IconNumber61Small", [["path", { "d": "M15 8h1v8", "key": "svg-0" }], ["path", { "d": "M11 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconNumber61Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber61Small
});

var IconNumber62Small = createReactComponent("outline", "number-62-small", "IconNumber62Small", [["path", { "d": "M14 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M10 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconNumber62Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber62Small
});

var IconNumber63Small = createReactComponent("outline", "number-63-small", "IconNumber63Small", [["path", { "d": "M14 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-0" }], ["path", { "d": "M10 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconNumber63Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber63Small
});

var IconNumber64Small = createReactComponent("outline", "number-64-small", "IconNumber64Small", [["path", { "d": "M14 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M18 8v8", "key": "svg-1" }], ["path", { "d": "M10 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-2" }]]);

var IconNumber64Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber64Small
});

var IconNumber65Small = createReactComponent("outline", "number-65-small", "IconNumber65Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-0" }], ["path", { "d": "M10 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconNumber65Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber65Small
});

var IconNumber66Small = createReactComponent("outline", "number-66-small", "IconNumber66Small", [["path", { "d": "M18 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-0" }], ["path", { "d": "M10 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconNumber66Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber66Small
});

var IconNumber67Small = createReactComponent("outline", "number-67-small", "IconNumber67Small", [["path", { "d": "M14 8h4l-2 8", "key": "svg-0" }], ["path", { "d": "M10 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconNumber67Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber67Small
});

var IconNumber68Small = createReactComponent("outline", "number-68-small", "IconNumber68Small", [["path", { "d": "M16 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-0" }], ["path", { "d": "M10 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconNumber68Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber68Small
});

var IconNumber69Small = createReactComponent("outline", "number-69-small", "IconNumber69Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M10 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconNumber69Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber69Small
});

var IconNumber7Small = createReactComponent("outline", "number-7-small", "IconNumber7Small", [["path", { "d": "M10 8h4l-2 8", "key": "svg-0" }]]);

var IconNumber7Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber7Small
});

var IconNumber7 = createReactComponent("outline", "number-7", "IconNumber7", [["path", { "d": "M8 4h8l-4 16", "key": "svg-0" }]]);

var IconNumber7$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber7
});

var IconNumber70Small = createReactComponent("outline", "number-70-small", "IconNumber70Small", [["path", { "d": "M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 8h4l-2 8", "key": "svg-1" }]]);

var IconNumber70Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber70Small
});

var IconNumber71Small = createReactComponent("outline", "number-71-small", "IconNumber71Small", [["path", { "d": "M15 8h1v8", "key": "svg-0" }], ["path", { "d": "M7 8h4l-2 8", "key": "svg-1" }]]);

var IconNumber71Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber71Small
});

var IconNumber72Small = createReactComponent("outline", "number-72-small", "IconNumber72Small", [["path", { "d": "M14 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M6 8h4l-2 8", "key": "svg-1" }]]);

var IconNumber72Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber72Small
});

var IconNumber73Small = createReactComponent("outline", "number-73-small", "IconNumber73Small", [["path", { "d": "M14 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-0" }], ["path", { "d": "M6 8h4l-2 8", "key": "svg-1" }]]);

var IconNumber73Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber73Small
});

var IconNumber74Small = createReactComponent("outline", "number-74-small", "IconNumber74Small", [["path", { "d": "M14 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M18 8v8", "key": "svg-1" }], ["path", { "d": "M6 8h4l-2 8", "key": "svg-2" }]]);

var IconNumber74Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber74Small
});

var IconNumber75Small = createReactComponent("outline", "number-75-small", "IconNumber75Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-0" }], ["path", { "d": "M6 8h4l-2 8", "key": "svg-1" }]]);

var IconNumber75Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber75Small
});

var IconNumber76Small = createReactComponent("outline", "number-76-small", "IconNumber76Small", [["path", { "d": "M18 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-0" }], ["path", { "d": "M6 8h4l-2 8", "key": "svg-1" }]]);

var IconNumber76Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber76Small
});

var IconNumber77Small = createReactComponent("outline", "number-77-small", "IconNumber77Small", [["path", { "d": "M14 8h4l-2 8", "key": "svg-0" }], ["path", { "d": "M6 8h4l-2 8", "key": "svg-1" }]]);

var IconNumber77Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber77Small
});

var IconNumber78Small = createReactComponent("outline", "number-78-small", "IconNumber78Small", [["path", { "d": "M16 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-0" }], ["path", { "d": "M6 8h4l-2 8", "key": "svg-1" }]]);

var IconNumber78Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber78Small
});

var IconNumber79Small = createReactComponent("outline", "number-79-small", "IconNumber79Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M6 8h4l-2 8", "key": "svg-1" }]]);

var IconNumber79Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber79Small
});

var IconNumber8Small = createReactComponent("outline", "number-8-small", "IconNumber8Small", [["path", { "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconNumber8Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber8Small
});

var IconNumber8 = createReactComponent("outline", "number-8", "IconNumber8", [["path", { "d": "M12 8m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M12 16m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-1" }]]);

var IconNumber8$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber8
});

var IconNumber80Small = createReactComponent("outline", "number-80-small", "IconNumber80Small", [["path", { "d": "M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M8 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconNumber80Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber80Small
});

var IconNumber81Small = createReactComponent("outline", "number-81-small", "IconNumber81Small", [["path", { "d": "M15 8h1v8", "key": "svg-0" }], ["path", { "d": "M9 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconNumber81Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber81Small
});

var IconNumber82Small = createReactComponent("outline", "number-82-small", "IconNumber82Small", [["path", { "d": "M14 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M8 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconNumber82Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber82Small
});

var IconNumber83Small = createReactComponent("outline", "number-83-small", "IconNumber83Small", [["path", { "d": "M14 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-0" }], ["path", { "d": "M8 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconNumber83Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber83Small
});

var IconNumber84Small = createReactComponent("outline", "number-84-small", "IconNumber84Small", [["path", { "d": "M14 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M18 8v8", "key": "svg-1" }], ["path", { "d": "M8 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-2" }]]);

var IconNumber84Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber84Small
});

var IconNumber85Small = createReactComponent("outline", "number-85-small", "IconNumber85Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-0" }], ["path", { "d": "M8 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconNumber85Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber85Small
});

var IconNumber86Small = createReactComponent("outline", "number-86-small", "IconNumber86Small", [["path", { "d": "M18 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-0" }], ["path", { "d": "M8 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconNumber86Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber86Small
});

var IconNumber87Small = createReactComponent("outline", "number-87-small", "IconNumber87Small", [["path", { "d": "M14 8h4l-2 8", "key": "svg-0" }], ["path", { "d": "M8 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconNumber87Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber87Small
});

var IconNumber88Small = createReactComponent("outline", "number-88-small", "IconNumber88Small", [["path", { "d": "M16 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-0" }], ["path", { "d": "M8 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconNumber88Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber88Small
});

var IconNumber89Small = createReactComponent("outline", "number-89-small", "IconNumber89Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M8 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconNumber89Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber89Small
});

var IconNumber9Small = createReactComponent("outline", "number-9-small", "IconNumber9Small", [["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }]]);

var IconNumber9Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber9Small
});

var IconNumber9 = createReactComponent("outline", "number-9", "IconNumber9", [["path", { "d": "M16 8a4 4 0 1 0 -8 0v1a4 4 0 1 0 8 0", "key": "svg-0" }], ["path", { "d": "M8 16a4 4 0 1 0 8 0v-8", "key": "svg-1" }]]);

var IconNumber9$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber9
});

var IconNumber90Small = createReactComponent("outline", "number-90-small", "IconNumber90Small", [["path", { "d": "M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber90Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber90Small
});

var IconNumber91Small = createReactComponent("outline", "number-91-small", "IconNumber91Small", [["path", { "d": "M15 8h1v8", "key": "svg-0" }], ["path", { "d": "M7 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber91Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber91Small
});

var IconNumber92Small = createReactComponent("outline", "number-92-small", "IconNumber92Small", [["path", { "d": "M14 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber92Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber92Small
});

var IconNumber93Small = createReactComponent("outline", "number-93-small", "IconNumber93Small", [["path", { "d": "M14 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber93Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber93Small
});

var IconNumber94Small = createReactComponent("outline", "number-94-small", "IconNumber94Small", [["path", { "d": "M14 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M18 8v8", "key": "svg-1" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-2" }]]);

var IconNumber94Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber94Small
});

var IconNumber95Small = createReactComponent("outline", "number-95-small", "IconNumber95Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber95Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber95Small
});

var IconNumber96Small = createReactComponent("outline", "number-96-small", "IconNumber96Small", [["path", { "d": "M18 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber96Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber96Small
});

var IconNumber97Small = createReactComponent("outline", "number-97-small", "IconNumber97Small", [["path", { "d": "M14 8h4l-2 8", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber97Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber97Small
});

var IconNumber98Small = createReactComponent("outline", "number-98-small", "IconNumber98Small", [["path", { "d": "M16 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1zh-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber98Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber98Small
});

var IconNumber99Small = createReactComponent("outline", "number-99-small", "IconNumber99Small", [["path", { "d": "M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconNumber99Small$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber99Small
});

var IconNumber = createReactComponent("outline", "number", "IconNumber", [["path", { "d": "M4 17v-10l7 10v-10", "key": "svg-0" }], ["path", { "d": "M15 17h5", "key": "svg-1" }], ["path", { "d": "M17.5 10m-2.5 0a2.5 3 0 1 0 5 0a2.5 3 0 1 0 -5 0", "key": "svg-2" }]]);

var IconNumber$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumber
});

var IconNumbers = createReactComponent("outline", "numbers", "IconNumbers", [["path", { "d": "M8 10v-7l-2 2", "key": "svg-0" }], ["path", { "d": "M6 16a2 2 0 1 1 4 0c0 .591 -.601 1.46 -1 2l-3 3h4", "key": "svg-1" }], ["path", { "d": "M15 14a2 2 0 1 0 2 -2a2 2 0 1 0 -2 -2", "key": "svg-2" }], ["path", { "d": "M6.5 10h3", "key": "svg-3" }]]);

var IconNumbers$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNumbers
});

var IconNurse = createReactComponent("outline", "nurse", "IconNurse", [["path", { "d": "M12 5c2.941 0 6.685 1.537 9 3l-2 11h-14l-2 -11c2.394 -1.513 6.168 -3.005 9 -3", "key": "svg-0" }], ["path", { "d": "M10 12h4", "key": "svg-1" }], ["path", { "d": "M12 10v4", "key": "svg-2" }]]);

var IconNurse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNurse
});

var IconNut = createReactComponent("outline", "nut", "IconNut", [["path", { "d": "M19 6.84a2.007 2.007 0 0 1 1 1.754v6.555c0 .728 -.394 1.4 -1.03 1.753l-6 3.844a1.995 1.995 0 0 1 -1.94 0l-6 -3.844a2.006 2.006 0 0 1 -1.03 -1.752v-6.557c0 -.728 .394 -1.399 1.03 -1.753l6 -3.582a2.049 2.049 0 0 1 2 0l6 3.582h-.03z", "key": "svg-0" }], ["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }]]);

var IconNut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNut
});

var IconObjectScan = createReactComponent("outline", "object-scan", "IconObjectScan", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M8 8m0 2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2z", "key": "svg-4" }]]);

var IconObjectScan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconObjectScan
});

var IconOctagonMinus2 = createReactComponent("outline", "octagon-minus-2", "IconOctagonMinus2", [["path", { "d": "M13.039 21.734l-.237 .101c-.512 .22 -1.092 .22 -1.604 0l-5.575 -2.389a2.036 2.036 0 0 1 -1.07 -1.07l-2.388 -5.574a2.036 2.036 0 0 1 0 -1.604l2.389 -5.575c.206 -.48 .589 -.863 1.07 -1.07l5.574 -2.388a2.036 2.036 0 0 1 1.604 0l5.575 2.389c.48 .206 .863 .589 1.07 1.07l2.388 5.574c.22 .512 .22 1.092 0 1.604l-.94 2.196", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconOctagonMinus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOctagonMinus2
});

var IconOctagonMinus = createReactComponent("outline", "octagon-minus", "IconOctagonMinus", [["path", { "d": "M12.802 2.165l5.575 2.389c.48 .206 .863 .589 1.07 1.07l2.388 5.574c.22 .512 .22 1.092 0 1.604l-2.389 5.575c-.206 .48 -.589 .863 -1.07 1.07l-5.574 2.388c-.512 .22 -1.092 .22 -1.604 0l-5.575 -2.389a2.036 2.036 0 0 1 -1.07 -1.07l-2.388 -5.574a2.036 2.036 0 0 1 0 -1.604l2.389 -5.575c.206 -.48 .589 -.863 1.07 -1.07l5.574 -2.388a2.036 2.036 0 0 1 1.604 0z", "key": "svg-0" }], ["path", { "d": "M9 12h6", "key": "svg-1" }]]);

var IconOctagonMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOctagonMinus
});

var IconOctagonOff = createReactComponent("outline", "octagon-off", "IconOctagonOff", [["path", { "d": "M19.027 19.002a2.03 2.03 0 0 1 -.65 .444l-5.575 2.39a2.04 2.04 0 0 1 -1.604 0l-5.575 -2.39a2.036 2.036 0 0 1 -1.07 -1.07l-2.388 -5.574a2.036 2.036 0 0 1 0 -1.604l2.389 -5.575c.103 -.24 .25 -.457 .433 -.639m2.689 -1.31l3.522 -1.51a2.036 2.036 0 0 1 1.604 0l5.575 2.39c.48 .206 .863 .589 1.07 1.07l2.388 5.574c.22 .512 .22 1.092 0 1.604l-1.509 3.522", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconOctagonOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOctagonOff
});

var IconOctagonPlus2 = createReactComponent("outline", "octagon-plus-2", "IconOctagonPlus2", [["path", { "d": "M13.023 21.74l-.221 .095c-.512 .22 -1.092 .22 -1.604 0l-5.575 -2.389a2.036 2.036 0 0 1 -1.07 -1.07l-2.388 -5.574a2.036 2.036 0 0 1 0 -1.604l2.389 -5.575c.206 -.48 .589 -.863 1.07 -1.07l5.574 -2.388a2.036 2.036 0 0 1 1.604 0l5.575 2.389c.48 .206 .863 .589 1.07 1.07l2.388 5.574c.22 .512 .22 1.092 0 1.604l-.081 .19", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconOctagonPlus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOctagonPlus2
});

var IconOctagonPlus = createReactComponent("outline", "octagon-plus", "IconOctagonPlus", [["path", { "d": "M12.802 2.165l5.575 2.389c.48 .206 .863 .589 1.07 1.07l2.388 5.574c.22 .512 .22 1.092 0 1.604l-2.389 5.575c-.206 .48 -.589 .863 -1.07 1.07l-5.574 2.388c-.512 .22 -1.092 .22 -1.604 0l-5.575 -2.389a2.036 2.036 0 0 1 -1.07 -1.07l-2.388 -5.574a2.036 2.036 0 0 1 0 -1.604l2.389 -5.575c.206 -.48 .589 -.863 1.07 -1.07l5.574 -2.388a2.036 2.036 0 0 1 1.604 0z", "key": "svg-0" }], ["path", { "d": "M9 12h6", "key": "svg-1" }], ["path", { "d": "M12 9v6", "key": "svg-2" }]]);

var IconOctagonPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOctagonPlus
});

var IconOctagon = createReactComponent("outline", "octagon", "IconOctagon", [["path", { "d": "M12.802 2.165l5.575 2.389c.48 .206 .863 .589 1.07 1.07l2.388 5.574c.22 .512 .22 1.092 0 1.604l-2.389 5.575c-.206 .48 -.589 .863 -1.07 1.07l-5.574 2.388c-.512 .22 -1.092 .22 -1.604 0l-5.575 -2.389a2.036 2.036 0 0 1 -1.07 -1.07l-2.388 -5.574a2.036 2.036 0 0 1 0 -1.604l2.389 -5.575c.206 -.48 .589 -.863 1.07 -1.07l5.574 -2.388a2.036 2.036 0 0 1 1.604 0z", "key": "svg-0" }]]);

var IconOctagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOctagon
});

var IconOctahedronOff = createReactComponent("outline", "octahedron-off", "IconOctahedronOff", [["path", { "d": "M6.771 6.77l-4.475 4.527a.984 .984 0 0 0 0 1.407l8.845 8.949a1.234 1.234 0 0 0 1.718 -.001l4.36 -4.412m2.002 -2.025l2.483 -2.512a.984 .984 0 0 0 0 -1.407l-8.845 -8.948a1.233 1.233 0 0 0 -1.718 0l-2.375 2.403", "key": "svg-0" }], ["path", { "d": "M2 12c.004 .086 .103 .178 .296 .246l8.845 2.632c.459 .163 1.259 .163 1.718 0l1.544 -.46m3.094 -.92l4.207 -1.252c.195 -.07 .294 -.156 .296 -.243", "key": "svg-1" }], ["path", { "d": "M12 2.12v5.88m0 4v9.88", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconOctahedronOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOctahedronOff
});

var IconOctahedronPlus = createReactComponent("outline", "octahedron-plus", "IconOctahedronPlus", [["path", { "d": "M21.498 12.911l.206 -.208a.984 .984 0 0 0 0 -1.407l-8.845 -8.948a1.233 1.233 0 0 0 -1.718 0l-8.845 8.949a.984 .984 0 0 0 0 1.407l8.845 8.949a1.234 1.234 0 0 0 1.718 -.001l.08 -.081", "key": "svg-0" }], ["path", { "d": "M2 12c.004 .086 .103 .178 .296 .246l8.845 2.632c.459 .163 1.259 .163 1.718 0l2.634 -.784m5.41 -1.61l.801 -.238c.195 -.07 .294 -.156 .296 -.243", "key": "svg-1" }], ["path", { "d": "M12 2.12v19.76", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconOctahedronPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOctahedronPlus
});

var IconOctahedron = createReactComponent("outline", "octahedron", "IconOctahedron", [["path", { "d": "M12.859 21.652l8.845 -8.949a.984 .984 0 0 0 0 -1.407l-8.845 -8.948a1.233 1.233 0 0 0 -1.718 0l-8.845 8.949a.984 .984 0 0 0 0 1.407l8.845 8.949a1.234 1.234 0 0 0 1.718 -.001z", "key": "svg-0" }], ["path", { "d": "M2 12c.004 .086 .103 .178 .296 .246l8.845 2.632c.459 .163 1.259 .163 1.718 0l8.845 -2.632c.195 -.07 .294 -.156 .296 -.243", "key": "svg-1" }], ["path", { "d": "M12 2.12v19.76", "key": "svg-2" }]]);

var IconOctahedron$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOctahedron
});

var IconOld = createReactComponent("outline", "old", "IconOld", [["path", { "d": "M11 21l-1 -4l-2 -3v-6", "key": "svg-0" }], ["path", { "d": "M5 14l-1 -3l4 -3l3 2l3 .5", "key": "svg-1" }], ["path", { "d": "M8 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M7 17l-2 4", "key": "svg-3" }], ["path", { "d": "M16 21v-8.5a1.5 1.5 0 0 1 3 0v.5", "key": "svg-4" }]]);

var IconOld$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOld
});

var IconOlympicsOff = createReactComponent("outline", "olympics-off", "IconOlympicsOff", [["path", { "d": "M6 6a3 3 0 1 0 3 3", "key": "svg-0" }], ["path", { "d": "M18 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M9 9a3 3 0 0 0 3 3m2.566 -1.445a3 3 0 0 0 -4.135 -4.113", "key": "svg-2" }], ["path", { "d": "M9 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M12.878 12.88a3 3 0 0 0 4.239 4.247m.586 -3.431a3.012 3.012 0 0 0 -1.43 -1.414", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconOlympicsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOlympicsOff
});

var IconOlympics = createReactComponent("outline", "olympics", "IconOlympics", [["path", { "d": "M6 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M18 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M12 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M9 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M15 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }]]);

var IconOlympics$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOlympics
});

var IconOm = createReactComponent("outline", "om", "IconOm", [["path", { "d": "M7 12c2.21 0 4 -1.567 4 -3.5s-1.79 -3.5 -4 -3.5c-1.594 0 -2.97 .816 -3.613 2", "key": "svg-0" }], ["path", { "d": "M3.423 14.483a4.944 4.944 0 0 0 -.423 2.017c0 2.485 1.79 4.5 4 4.5s4 -2.015 4 -4.5s-1.79 -4.5 -4 -4.5", "key": "svg-1" }], ["path", { "d": "M14.071 17.01c.327 2.277 1.739 3.99 3.429 3.99c1.933 0 3.5 -2.239 3.5 -5s-1.567 -5 -3.5 -5c-.96 0 -1.868 .606 -2.5 1.5c-.717 1.049 -1.76 1.7 -2.936 1.7c-.92 0 -1.766 -.406 -2.434 -1.087", "key": "svg-2" }], ["path", { "d": "M17 3l2 2", "key": "svg-3" }], ["path", { "d": "M12 3c1.667 3.667 4.667 5.333 9 5", "key": "svg-4" }]]);

var IconOm$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOm
});

var IconOmega = createReactComponent("outline", "omega", "IconOmega", [["path", { "d": "M4 19h5v-1a7.35 7.35 0 1 1 6 0v1h5", "key": "svg-0" }]]);

var IconOmega$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOmega
});

var IconOutbound = createReactComponent("outline", "outbound", "IconOutbound", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 15l6 -6", "key": "svg-1" }], ["path", { "d": "M11 9h4v4", "key": "svg-2" }]]);

var IconOutbound$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOutbound
});

var IconOutlet = createReactComponent("outline", "outlet", "IconOutlet", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["circle", { "cx": "9", "cy": "12", "r": ".5", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "15", "cy": "12", "r": ".5", "fill": "currentColor", "key": "svg-2" }]]);

var IconOutlet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOutlet
});

var IconOvalVertical = createReactComponent("outline", "oval-vertical", "IconOvalVertical", [["path", { "d": "M3 12c0 -3.314 4.03 -6 9 -6s9 2.686 9 6s-4.03 6 -9 6s-9 -2.686 -9 -6z", "key": "svg-0" }]]);

var IconOvalVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOvalVertical
});

var IconOval = createReactComponent("outline", "oval", "IconOval", [["path", { "d": "M12 12m-6 0a6 9 0 1 0 12 0a6 9 0 1 0 -12 0", "key": "svg-0" }]]);

var IconOval$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOval
});

var IconOverline = createReactComponent("outline", "overline", "IconOverline", [["path", { "d": "M7 9v5a5 5 0 0 0 10 0v-5", "key": "svg-0" }], ["path", { "d": "M5 5h14", "key": "svg-1" }]]);

var IconOverline$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOverline
});

var IconPackageExport = createReactComponent("outline", "package-export", "IconPackageExport", [["path", { "d": "M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5", "key": "svg-0" }], ["path", { "d": "M12 12l8 -4.5", "key": "svg-1" }], ["path", { "d": "M12 12v9", "key": "svg-2" }], ["path", { "d": "M12 12l-8 -4.5", "key": "svg-3" }], ["path", { "d": "M15 18h7", "key": "svg-4" }], ["path", { "d": "M19 15l3 3l-3 3", "key": "svg-5" }]]);

var IconPackageExport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPackageExport
});

var IconPackageImport = createReactComponent("outline", "package-import", "IconPackageImport", [["path", { "d": "M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5", "key": "svg-0" }], ["path", { "d": "M12 12l8 -4.5", "key": "svg-1" }], ["path", { "d": "M12 12v9", "key": "svg-2" }], ["path", { "d": "M12 12l-8 -4.5", "key": "svg-3" }], ["path", { "d": "M22 18h-7", "key": "svg-4" }], ["path", { "d": "M18 15l-3 3l3 3", "key": "svg-5" }]]);

var IconPackageImport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPackageImport
});

var IconPackageOff = createReactComponent("outline", "package-off", "IconPackageOff", [["path", { "d": "M8.812 4.793l3.188 -1.793l8 4.5v8.5m-2.282 1.784l-5.718 3.216l-8 -4.5v-9l2.223 -1.25", "key": "svg-0" }], ["path", { "d": "M14.543 10.57l5.457 -3.07", "key": "svg-1" }], ["path", { "d": "M12 12v9", "key": "svg-2" }], ["path", { "d": "M12 12l-8 -4.5", "key": "svg-3" }], ["path", { "d": "M16 5.25l-4.35 2.447m-2.564 1.442l-1.086 .611", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconPackageOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPackageOff
});

var IconPackage = createReactComponent("outline", "package", "IconPackage", [["path", { "d": "M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5", "key": "svg-0" }], ["path", { "d": "M12 12l8 -4.5", "key": "svg-1" }], ["path", { "d": "M12 12l0 9", "key": "svg-2" }], ["path", { "d": "M12 12l-8 -4.5", "key": "svg-3" }], ["path", { "d": "M16 5.25l-8 4.5", "key": "svg-4" }]]);

var IconPackage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPackage
});

var IconPackages = createReactComponent("outline", "packages", "IconPackages", [["path", { "d": "M7 16.5l-5 -3l5 -3l5 3v5.5l-5 3z", "key": "svg-0" }], ["path", { "d": "M2 13.5v5.5l5 3", "key": "svg-1" }], ["path", { "d": "M7 16.545l5 -3.03", "key": "svg-2" }], ["path", { "d": "M17 16.5l-5 -3l5 -3l5 3v5.5l-5 3z", "key": "svg-3" }], ["path", { "d": "M12 19l5 3", "key": "svg-4" }], ["path", { "d": "M17 16.5l5 -3", "key": "svg-5" }], ["path", { "d": "M12 13.5v-5.5l-5 -3l5 -3l5 3v5.5", "key": "svg-6" }], ["path", { "d": "M7 5.03v5.455", "key": "svg-7" }], ["path", { "d": "M12 8l5 -3", "key": "svg-8" }]]);

var IconPackages$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPackages
});

var IconPacman = createReactComponent("outline", "pacman", "IconPacman", [["path", { "d": "M5.636 5.636a9 9 0 0 1 13.397 .747l-5.619 5.617l5.619 5.617a9 9 0 1 1 -13.397 -11.981z", "key": "svg-0" }], ["circle", { "cx": "11.5", "cy": "7.5", "r": "1", "fill": "currentColor", "key": "svg-1" }]]);

var IconPacman$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPacman
});

var IconPageBreak = createReactComponent("outline", "page-break", "IconPageBreak", [["path", { "d": "M14 3v4a1 1 0 0 0 1 1h4", "key": "svg-0" }], ["path", { "d": "M19 18v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1", "key": "svg-1" }], ["path", { "d": "M3 14h3m4.5 0h3m4.5 0h3", "key": "svg-2" }], ["path", { "d": "M5 10v-5a2 2 0 0 1 2 -2h7l5 5v2", "key": "svg-3" }]]);

var IconPageBreak$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPageBreak
});

var IconPaintOff = createReactComponent("outline", "paint-off", "IconPaintOff", [["path", { "d": "M7 3h10a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-4m-4 0h-2a2 2 0 0 1 -2 -2v-2", "key": "svg-0" }], ["path", { "d": "M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5m-4 0h-1v2", "key": "svg-1" }], ["path", { "d": "M10 15m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconPaintOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPaintOff
});

var IconPaint = createReactComponent("outline", "paint", "IconPaint", [["path", { "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5l-5 0v2", "key": "svg-1" }], ["path", { "d": "M10 15m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }]]);

var IconPaint$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPaint
});

var IconPaletteOff = createReactComponent("outline", "palette-off", "IconPaletteOff", [["path", { "d": "M15 15h-1a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25a9 9 0 0 1 -6.372 -15.356", "key": "svg-0" }], ["path", { "d": "M8 4c1.236 -.623 2.569 -1 4 -1c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828a4.516 4.516 0 0 1 -1.127 .73", "key": "svg-1" }], ["path", { "d": "M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconPaletteOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPaletteOff
});

var IconPalette = createReactComponent("outline", "palette", "IconPalette", [["path", { "d": "M12 21a9 9 0 0 1 0 -18c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828c-.844 .75 -1.989 1.172 -3.182 1.172h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25", "key": "svg-0" }], ["path", { "d": "M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }]]);

var IconPalette$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPalette
});

var IconPanoramaHorizontalOff = createReactComponent("outline", "panorama-horizontal-off", "IconPanoramaHorizontalOff", [["path", { "d": "M10.95 6.952c2.901 .15 5.803 -.323 8.705 -1.42a1 1 0 0 1 1.345 .934v10.534m-3.212 .806c-4.483 -1.281 -8.966 -1.074 -13.449 .622a.993 .993 0 0 1 -1.339 -.935v-11.027a1 1 0 0 1 1.338 -.935c.588 .221 1.176 .418 1.764 .59", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconPanoramaHorizontalOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPanoramaHorizontalOff
});

var IconPanoramaHorizontal = createReactComponent("outline", "panorama-horizontal", "IconPanoramaHorizontal", [["path", { "d": "M4.338 5.53c5.106 1.932 10.211 1.932 15.317 0a1 1 0 0 1 1.345 .934v11c0 .692 -.692 1.2 -1.34 .962c-5.107 -1.932 -10.214 -1.932 -15.321 0c-.648 .246 -1.339 -.242 -1.339 -.935v-11.027a1 1 0 0 1 1.338 -.935z", "key": "svg-0" }]]);

var IconPanoramaHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPanoramaHorizontal
});

var IconPanoramaVerticalOff = createReactComponent("outline", "panorama-vertical-off", "IconPanoramaVerticalOff", [["path", { "d": "M7 3h10.53c.693 0 1.18 .691 .935 1.338c-1.098 2.898 -1.573 5.795 -1.425 8.692m.828 4.847c.172 .592 .37 1.185 .595 1.778a1 1 0 0 1 -.934 1.345h-11c-.692 0 -1.208 -.692 -.962 -1.34c1.697 -4.486 1.903 -8.973 .619 -13.46", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconPanoramaVerticalOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPanoramaVerticalOff
});

var IconPanoramaVertical = createReactComponent("outline", "panorama-vertical", "IconPanoramaVertical", [["path", { "d": "M18.463 4.338c-1.932 5.106 -1.932 10.211 0 15.317a1 1 0 0 1 -.934 1.345h-11c-.692 0 -1.208 -.692 -.962 -1.34c1.932 -5.107 1.932 -10.214 0 -15.321c-.246 -.648 .243 -1.339 .935 -1.339h11.028c.693 0 1.18 .691 .935 1.338z", "key": "svg-0" }]]);

var IconPanoramaVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPanoramaVertical
});

var IconPaperBagOff = createReactComponent("outline", "paper-bag-off", "IconPaperBagOff", [["path", { "d": "M7.158 3.185c.256 -.119 .542 -.185 .842 -.185h8a2 2 0 0 1 2 2v1.82a5 5 0 0 0 .528 2.236l.944 1.888a5 5 0 0 1 .528 2.236v2.82m-.177 3.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-5.82a5 5 0 0 1 .528 -2.236l1.472 -2.944v-2", "key": "svg-0" }], ["path", { "d": "M13.185 13.173a2 2 0 1 0 2.64 2.647", "key": "svg-1" }], ["path", { "d": "M6 21a2 2 0 0 0 2 -2v-5.82a5 5 0 0 0 -.528 -2.236l-1.472 -2.944", "key": "svg-2" }], ["path", { "d": "M11 7h2", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconPaperBagOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPaperBagOff
});

var IconPaperBag = createReactComponent("outline", "paper-bag", "IconPaperBag", [["path", { "d": "M8 3h8a2 2 0 0 1 2 2v1.82a5 5 0 0 0 .528 2.236l.944 1.888a5 5 0 0 1 .528 2.236v5.82a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-5.82a5 5 0 0 1 .528 -2.236l1.472 -2.944v-3a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M14 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M6 21a2 2 0 0 0 2 -2v-5.82a5 5 0 0 0 -.528 -2.236l-1.472 -2.944", "key": "svg-2" }], ["path", { "d": "M11 7h2", "key": "svg-3" }]]);

var IconPaperBag$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPaperBag
});

var IconPaperclip = createReactComponent("outline", "paperclip", "IconPaperclip", [["path", { "d": "M15 7l-6.5 6.5a1.5 1.5 0 0 0 3 3l6.5 -6.5a3 3 0 0 0 -6 -6l-6.5 6.5a4.5 4.5 0 0 0 9 9l6.5 -6.5", "key": "svg-0" }]]);

var IconPaperclip$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPaperclip
});

var IconParachuteOff = createReactComponent("outline", "parachute-off", "IconParachuteOff", [["path", { "d": "M22 12c0 -5.523 -4.477 -10 -10 -10c-1.737 0 -3.37 .443 -4.794 1.222m-2.28 1.71a9.969 9.969 0 0 0 -2.926 7.068", "key": "svg-0" }], ["path", { "d": "M22 12c0 -1.66 -1.46 -3 -3.25 -3c-1.63 0 -2.973 1.099 -3.212 2.54m-.097 -.09c-.23 -1.067 -1.12 -1.935 -2.29 -2.284m-3.445 .568c-.739 .55 -1.206 1.36 -1.206 2.266c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3", "key": "svg-1" }], ["path", { "d": "M2 12l10 10l-3.5 -10", "key": "svg-2" }], ["path", { "d": "M14.582 14.624l-2.582 7.376l4.992 -4.992m2.014 -2.014l3 -3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconParachuteOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconParachuteOff
});

var IconParachute = createReactComponent("outline", "parachute", "IconParachute", [["path", { "d": "M22 12a10 10 0 1 0 -20 0", "key": "svg-0" }], ["path", { "d": "M22 12c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3c0 -1.66 -1.57 -3 -3.5 -3s-3.5 1.34 -3.5 3c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3", "key": "svg-1" }], ["path", { "d": "M2 12l10 10l-3.5 -10", "key": "svg-2" }], ["path", { "d": "M15.5 12l-3.5 10l10 -10", "key": "svg-3" }]]);

var IconParachute$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconParachute
});

var IconParenthesesOff = createReactComponent("outline", "parentheses-off", "IconParenthesesOff", [["path", { "d": "M5.743 5.745a12.253 12.253 0 0 0 1.257 14.255", "key": "svg-0" }], ["path", { "d": "M17 4a12.25 12.25 0 0 1 2.474 11.467m-1.22 2.794a12.291 12.291 0 0 1 -1.254 1.739", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconParenthesesOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconParenthesesOff
});

var IconParentheses = createReactComponent("outline", "parentheses", "IconParentheses", [["path", { "d": "M7 4a12.25 12.25 0 0 0 0 16", "key": "svg-0" }], ["path", { "d": "M17 4a12.25 12.25 0 0 1 0 16", "key": "svg-1" }]]);

var IconParentheses$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconParentheses
});

var IconParkingCircle = createReactComponent("outline", "parking-circle", "IconParkingCircle", [["path", { "d": "M10 16v-8h3.334c.92 0 1.666 .895 1.666 2s-.746 2 -1.666 2h-3.334", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconParkingCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconParkingCircle
});

var IconParkingOff = createReactComponent("outline", "parking-off", "IconParkingOff", [["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.582 3.41c-.362 .365 -.864 .59 -1.418 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.056 .59 -1.418", "key": "svg-0" }], ["path", { "d": "M9 16v-7m3 -1h1a2 2 0 0 1 1.817 2.836m-2.817 1.164h-3", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconParkingOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconParkingOff
});

var IconParking = createReactComponent("outline", "parking", "IconParking", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M10 16v-8h2.667c.736 0 1.333 .895 1.333 2s-.597 2 -1.333 2h-2.667", "key": "svg-1" }]]);

var IconParking$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconParking
});

var IconPasswordFingerprint = createReactComponent("outline", "password-fingerprint", "IconPasswordFingerprint", [["path", { "d": "M17 8c.788 1 1 2 1 3v1", "key": "svg-0" }], ["path", { "d": "M9 11c0 -1.578 1.343 -3 3 -3s3 1.422 3 3v2", "key": "svg-1" }], ["path", { "d": "M12 11v2", "key": "svg-2" }], ["path", { "d": "M6 12v-1.397c-.006 -1.999 1.136 -3.849 2.993 -4.85a6.385 6.385 0 0 1 6.007 -.005", "key": "svg-3" }], ["path", { "d": "M12 17v4", "key": "svg-4" }], ["path", { "d": "M10 20l4 -2", "key": "svg-5" }], ["path", { "d": "M10 18l4 2", "key": "svg-6" }], ["path", { "d": "M5 17v4", "key": "svg-7" }], ["path", { "d": "M3 20l4 -2", "key": "svg-8" }], ["path", { "d": "M3 18l4 2", "key": "svg-9" }], ["path", { "d": "M19 17v4", "key": "svg-10" }], ["path", { "d": "M17 20l4 -2", "key": "svg-11" }], ["path", { "d": "M17 18l4 2", "key": "svg-12" }]]);

var IconPasswordFingerprint$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPasswordFingerprint
});

var IconPasswordMobilePhone = createReactComponent("outline", "password-mobile-phone", "IconPasswordMobilePhone", [["path", { "d": "M12 17v4", "key": "svg-0" }], ["path", { "d": "M10 20l4 -2", "key": "svg-1" }], ["path", { "d": "M10 18l4 2", "key": "svg-2" }], ["path", { "d": "M5 17v4", "key": "svg-3" }], ["path", { "d": "M3 20l4 -2", "key": "svg-4" }], ["path", { "d": "M3 18l4 2", "key": "svg-5" }], ["path", { "d": "M19 17v4", "key": "svg-6" }], ["path", { "d": "M17 20l4 -2", "key": "svg-7" }], ["path", { "d": "M17 18l4 2", "key": "svg-8" }], ["path", { "d": "M7 14v-8a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v8", "key": "svg-9" }], ["path", { "d": "M11 5h2", "key": "svg-10" }], ["path", { "d": "M12 17v.01", "key": "svg-11" }]]);

var IconPasswordMobilePhone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPasswordMobilePhone
});

var IconPasswordUser = createReactComponent("outline", "password-user", "IconPasswordUser", [["path", { "d": "M12 17v4", "key": "svg-0" }], ["path", { "d": "M10 20l4 -2", "key": "svg-1" }], ["path", { "d": "M10 18l4 2", "key": "svg-2" }], ["path", { "d": "M5 17v4", "key": "svg-3" }], ["path", { "d": "M3 20l4 -2", "key": "svg-4" }], ["path", { "d": "M3 18l4 2", "key": "svg-5" }], ["path", { "d": "M19 17v4", "key": "svg-6" }], ["path", { "d": "M17 20l4 -2", "key": "svg-7" }], ["path", { "d": "M17 18l4 2", "key": "svg-8" }], ["path", { "d": "M9 6a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-9" }], ["path", { "d": "M7 14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2", "key": "svg-10" }]]);

var IconPasswordUser$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPasswordUser
});

var IconPassword = createReactComponent("outline", "password", "IconPassword", [["path", { "d": "M12 10v4", "key": "svg-0" }], ["path", { "d": "M10 13l4 -2", "key": "svg-1" }], ["path", { "d": "M10 11l4 2", "key": "svg-2" }], ["path", { "d": "M5 10v4", "key": "svg-3" }], ["path", { "d": "M3 13l4 -2", "key": "svg-4" }], ["path", { "d": "M3 11l4 2", "key": "svg-5" }], ["path", { "d": "M19 10v4", "key": "svg-6" }], ["path", { "d": "M17 13l4 -2", "key": "svg-7" }], ["path", { "d": "M17 11l4 2", "key": "svg-8" }]]);

var IconPassword$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPassword
});

var IconPawOff = createReactComponent("outline", "paw-off", "IconPawOff", [["path", { "d": "M11.168 11.154c-.71 .31 -1.184 1.107 -2 2.593c-.942 1.703 -2.846 1.845 -3.321 3.291c-.097 .265 -.145 .677 -.143 .962c0 1.176 .787 2 1.8 2c1.259 0 3 -1 4.5 -1s3.241 1 4.5 1c.927 0 1.664 -.689 1.783 -1.708", "key": "svg-0" }], ["path", { "d": "M20.188 8.082a1.039 1.039 0 0 0 -.406 -.082h-.015c-.735 .012 -1.56 .75 -1.993 1.866c-.519 1.335 -.28 2.7 .538 3.052c.129 .055 .267 .082 .406 .082c.739 0 1.575 -.742 2.011 -1.866c.516 -1.335 .273 -2.7 -.54 -3.052h0z", "key": "svg-1" }], ["path", { "d": "M11 6.992a3.608 3.608 0 0 0 -.04 -.725c-.203 -1.297 -1.047 -2.267 -1.932 -2.267a1.237 1.237 0 0 0 -.758 .265", "key": "svg-2" }], ["path", { "d": "M16.456 6.733c.214 -1.376 -.375 -2.594 -1.32 -2.722a1.164 1.164 0 0 0 -.162 -.011c-.885 0 -1.728 .97 -1.93 2.267c-.214 1.376 .375 2.594 1.32 2.722c.054 .007 .108 .011 .162 .011c.885 0 1.73 -.974 1.93 -2.267z", "key": "svg-3" }], ["path", { "d": "M5.69 12.918c.816 -.352 1.054 -1.719 .536 -3.052c-.436 -1.124 -1.271 -1.866 -2.009 -1.866c-.14 0 -.277 .027 -.407 .082c-.816 .352 -1.054 1.719 -.536 3.052c.436 1.124 1.271 1.866 2.009 1.866c.14 0 .277 -.027 .407 -.082z", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconPawOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPawOff
});

var IconPaw = createReactComponent("outline", "paw", "IconPaw", [["path", { "d": "M14.7 13.5c-1.1 -2 -1.441 -2.5 -2.7 -2.5c-1.259 0 -1.736 .755 -2.836 2.747c-.942 1.703 -2.846 1.845 -3.321 3.291c-.097 .265 -.145 .677 -.143 .962c0 1.176 .787 2 1.8 2c1.259 0 3 -1 4.5 -1s3.241 1 4.5 1c1.013 0 1.8 -.823 1.8 -2c0 -.285 -.049 -.697 -.146 -.962c-.475 -1.451 -2.512 -1.835 -3.454 -3.538z", "key": "svg-0" }], ["path", { "d": "M20.188 8.082a1.039 1.039 0 0 0 -.406 -.082h-.015c-.735 .012 -1.56 .75 -1.993 1.866c-.519 1.335 -.28 2.7 .538 3.052c.129 .055 .267 .082 .406 .082c.739 0 1.575 -.742 2.011 -1.866c.516 -1.335 .273 -2.7 -.54 -3.052z", "key": "svg-1" }], ["path", { "d": "M9.474 9c.055 0 .109 0 .163 -.011c.944 -.128 1.533 -1.346 1.32 -2.722c-.203 -1.297 -1.047 -2.267 -1.932 -2.267c-.055 0 -.109 0 -.163 .011c-.944 .128 -1.533 1.346 -1.32 2.722c.204 1.293 1.048 2.267 1.933 2.267z", "key": "svg-2" }], ["path", { "d": "M16.456 6.733c.214 -1.376 -.375 -2.594 -1.32 -2.722a1.164 1.164 0 0 0 -.162 -.011c-.885 0 -1.728 .97 -1.93 2.267c-.214 1.376 .375 2.594 1.32 2.722c.054 .007 .108 .011 .162 .011c.885 0 1.73 -.974 1.93 -2.267z", "key": "svg-3" }], ["path", { "d": "M5.69 12.918c.816 -.352 1.054 -1.719 .536 -3.052c-.436 -1.124 -1.271 -1.866 -2.009 -1.866c-.14 0 -.277 .027 -.407 .082c-.816 .352 -1.054 1.719 -.536 3.052c.436 1.124 1.271 1.866 2.009 1.866c.14 0 .277 -.027 .407 -.082z", "key": "svg-4" }]]);

var IconPaw$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPaw
});

var IconPaywall = createReactComponent("outline", "paywall", "IconPaywall", [["path", { "d": "M13 21h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10", "key": "svg-0" }], ["path", { "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-1" }], ["path", { "d": "M8 11v-4a4 4 0 1 1 8 0v4", "key": "svg-2" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }], ["path", { "d": "M19 21v1", "key": "svg-4" }], ["path", { "d": "M19 14v1", "key": "svg-5" }]]);

var IconPaywall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPaywall
});

var IconPdf = createReactComponent("outline", "pdf", "IconPdf", [["path", { "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", "key": "svg-0" }], ["path", { "d": "M3 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-1" }], ["path", { "d": "M17 12h3", "key": "svg-2" }], ["path", { "d": "M21 8h-4v8", "key": "svg-3" }]]);

var IconPdf$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPdf
});

var IconPeace = createReactComponent("outline", "peace", "IconPeace", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 3l0 18", "key": "svg-1" }], ["path", { "d": "M12 12l6.3 6.3", "key": "svg-2" }], ["path", { "d": "M12 12l-6.3 6.3", "key": "svg-3" }]]);

var IconPeace$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPeace
});

var IconPencilBolt = createReactComponent("outline", "pencil-bolt", "IconPencilBolt", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }]]);

var IconPencilBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilBolt
});

var IconPencilCancel = createReactComponent("outline", "pencil-cancel", "IconPencilCancel", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M17 21l4 -4", "key": "svg-3" }]]);

var IconPencilCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilCancel
});

var IconPencilCheck = createReactComponent("outline", "pencil-check", "IconPencilCheck", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconPencilCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilCheck
});

var IconPencilCode = createReactComponent("outline", "pencil-code", "IconPencilCode", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

var IconPencilCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilCode
});

var IconPencilCog = createReactComponent("outline", "pencil-cog", "IconPencilCog", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-3" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-4" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-8" }]]);

var IconPencilCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilCog
});

var IconPencilDiscount = createReactComponent("outline", "pencil-discount", "IconPencilDiscount", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M16 21l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21v.01", "key": "svg-3" }], ["path", { "d": "M16 16v.01", "key": "svg-4" }]]);

var IconPencilDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilDiscount
});

var IconPencilDollar = createReactComponent("outline", "pencil-dollar", "IconPencilDollar", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconPencilDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilDollar
});

var IconPencilDown = createReactComponent("outline", "pencil-down", "IconPencilDown", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-3" }]]);

var IconPencilDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilDown
});

var IconPencilExclamation = createReactComponent("outline", "pencil-exclamation", "IconPencilExclamation", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconPencilExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilExclamation
});

var IconPencilHeart = createReactComponent("outline", "pencil-heart", "IconPencilHeart", [["path", { "d": "M17 11l1.5 -1.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4h4l2 -2", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconPencilHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilHeart
});

var IconPencilMinus = createReactComponent("outline", "pencil-minus", "IconPencilMinus", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconPencilMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilMinus
});

var IconPencilOff = createReactComponent("outline", "pencil-off", "IconPencilOff", [["path", { "d": "M10 10l-6 6v4h4l6 -6m1.99 -1.99l2.504 -2.504a2.828 2.828 0 1 0 -4 -4l-2.5 2.5", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconPencilOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilOff
});

var IconPencilPause = createReactComponent("outline", "pencil-pause", "IconPencilPause", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

var IconPencilPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilPause
});

var IconPencilPin = createReactComponent("outline", "pencil-pin", "IconPencilPin", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }]]);

var IconPencilPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilPin
});

var IconPencilPlus = createReactComponent("outline", "pencil-plus", "IconPencilPlus", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconPencilPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilPlus
});

var IconPencilQuestion = createReactComponent("outline", "pencil-question", "IconPencilQuestion", [["path", { "d": "M8 20l6 -6l3 -3l1.5 -1.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4h4z", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }]]);

var IconPencilQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilQuestion
});

var IconPencilSearch = createReactComponent("outline", "pencil-search", "IconPencilSearch", [["path", { "d": "M17 11l1.5 -1.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4h4l3 -3", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconPencilSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilSearch
});

var IconPencilShare = createReactComponent("outline", "pencil-share", "IconPencilShare", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconPencilShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilShare
});

var IconPencilStar = createReactComponent("outline", "pencil-star", "IconPencilStar", [["path", { "d": "M17.5 10.5l1 -1a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4h4l2 -2", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconPencilStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilStar
});

var IconPencilUp = createReactComponent("outline", "pencil-up", "IconPencilUp", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }]]);

var IconPencilUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilUp
});

var IconPencilX = createReactComponent("outline", "pencil-x", "IconPencilX", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-2" }], ["path", { "d": "M17 22l5 -5", "key": "svg-3" }]]);

var IconPencilX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencilX
});

var IconPencil = createReactComponent("outline", "pencil", "IconPencil", [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }]]);

var IconPencil$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPencil
});

var IconPennant2 = createReactComponent("outline", "pennant-2", "IconPennant2", [["path", { "d": "M16 21h-4", "key": "svg-0" }], ["path", { "d": "M14 21v-18", "key": "svg-1" }], ["path", { "d": "M14 4l-9 4l9 4", "key": "svg-2" }]]);

var IconPennant2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPennant2
});

var IconPennantOff = createReactComponent("outline", "pennant-off", "IconPennantOff", [["path", { "d": "M8 21h4", "key": "svg-0" }], ["path", { "d": "M10 21v-11m0 -4v-3", "key": "svg-1" }], ["path", { "d": "M10 4l9 4l-4.858 2.16m-2.764 1.227l-1.378 .613", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconPennantOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPennantOff
});

var IconPennant = createReactComponent("outline", "pennant", "IconPennant", [["path", { "d": "M8 21l4 0", "key": "svg-0" }], ["path", { "d": "M10 21l0 -18", "key": "svg-1" }], ["path", { "d": "M10 4l9 4l-9 4", "key": "svg-2" }]]);

var IconPennant$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPennant
});

var IconPentagonMinus = createReactComponent("outline", "pentagon-minus", "IconPentagonMinus", [["path", { "d": "M12.5 21q -1.82 0 -5.458 .005a1.98 1.98 0 0 1 -1.881 -1.367l-3.064 -9.43a1.98 1.98 0 0 1 .719 -2.212l8.021 -5.828a1.98 1.98 0 0 1 2.326 0l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-1.559 4.792", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconPentagonMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonMinus
});

var IconPentagonNumber0 = createReactComponent("outline", "pentagon-number-0", "IconPentagonNumber0", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", "key": "svg-1" }]]);

var IconPentagonNumber0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonNumber0
});

var IconPentagonNumber1 = createReactComponent("outline", "pentagon-number-1", "IconPentagonNumber1", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M10 10l2 -2v8", "key": "svg-1" }]]);

var IconPentagonNumber1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonNumber1
});

var IconPentagonNumber2 = createReactComponent("outline", "pentagon-number-2", "IconPentagonNumber2", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconPentagonNumber2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonNumber2
});

var IconPentagonNumber3 = createReactComponent("outline", "pentagon-number-3", "IconPentagonNumber3", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M10 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconPentagonNumber3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonNumber3
});

var IconPentagonNumber4 = createReactComponent("outline", "pentagon-number-4", "IconPentagonNumber4", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M10 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M14 8v8", "key": "svg-2" }]]);

var IconPentagonNumber4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonNumber4
});

var IconPentagonNumber5 = createReactComponent("outline", "pentagon-number-5", "IconPentagonNumber5", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconPentagonNumber5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonNumber5
});

var IconPentagonNumber6 = createReactComponent("outline", "pentagon-number-6", "IconPentagonNumber6", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconPentagonNumber6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonNumber6
});

var IconPentagonNumber7 = createReactComponent("outline", "pentagon-number-7", "IconPentagonNumber7", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M10 8h4l-2 8", "key": "svg-1" }]]);

var IconPentagonNumber7$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonNumber7
});

var IconPentagonNumber8 = createReactComponent("outline", "pentagon-number-8", "IconPentagonNumber8", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconPentagonNumber8$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonNumber8
});

var IconPentagonNumber9 = createReactComponent("outline", "pentagon-number-9", "IconPentagonNumber9", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconPentagonNumber9$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonNumber9
});

var IconPentagonOff = createReactComponent("outline", "pentagon-off", "IconPentagonOff", [["path", { "d": "M8.133 4.133l2.704 -1.965a1.978 1.978 0 0 1 2.326 0l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-1.887 5.808m-.981 3.02l-.196 .602a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l2.994 -2.176", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconPentagonOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonOff
});

var IconPentagonPlus = createReactComponent("outline", "pentagon-plus", "IconPentagonPlus", [["path", { "d": "M12.5 21.005h-5.458a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-.78 2.401", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconPentagonPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonPlus
});

var IconPentagonX = createReactComponent("outline", "pentagon-x", "IconPentagonX", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M14 14l-4 -4", "key": "svg-1" }], ["path", { "d": "M10 14l4 -4", "key": "svg-2" }]]);

var IconPentagonX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonX
});

var IconPentagon = createReactComponent("outline", "pentagon", "IconPentagon", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }]]);

var IconPentagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagon
});

var IconPentagram = createReactComponent("outline", "pentagram", "IconPentagram", [["path", { "d": "M5.636 5.636a9 9 0 1 1 12.728 12.728a9 9 0 0 1 -12.728 -12.728z", "key": "svg-0" }], ["path", { "d": "M15.236 11l5.264 4h-6.5l-2 6l-2 -6h-6.5l5.276 -4l-2.056 -6.28l5.28 3.78l5.28 -3.78z", "key": "svg-1" }]]);

var IconPentagram$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagram
});

var IconPepperOff = createReactComponent("outline", "pepper-off", "IconPepperOff", [["path", { "d": "M12.59 12.59c-.77 1.418 -2.535 2.41 -4.59 2.41c-2.761 0 -5 -1.79 -5 -4a8 8 0 0 0 13.643 5.67m1.64 -2.357a7.97 7.97 0 0 0 .717 -3.313a3 3 0 0 0 -5.545 -1.59", "key": "svg-0" }], ["path", { "d": "M16 8c0 -2 2 -4 4 -4", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconPepperOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPepperOff
});

var IconPepper = createReactComponent("outline", "pepper", "IconPepper", [["path", { "d": "M13 11c0 2.21 -2.239 4 -5 4s-5 -1.79 -5 -4a8 8 0 1 0 16 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M16 8c0 -2 2 -4 4 -4", "key": "svg-1" }]]);

var IconPepper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPepper
});

var IconPercentage0 = createReactComponent("outline", "percentage-0", "IconPercentage0", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }]]);

var IconPercentage0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage0
});

var IconPercentage10 = createReactComponent("outline", "percentage-10", "IconPercentage10", [["path", { "d": "M12 3c1.92 0 3.7 .601 5.16 1.626l-5.16 7.374z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage10$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage10
});

var IconPercentage100 = createReactComponent("outline", "percentage-100", "IconPercentage100", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "fill": "currentColor", "key": "svg-0" }]]);

var IconPercentage100$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage100
});

var IconPercentage20 = createReactComponent("outline", "percentage-20", "IconPercentage20", [["path", { "d": "M12 3a9 9 0 0 1 8.497 6.025l-8.497 2.975z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage20$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage20
});

var IconPercentage25 = createReactComponent("outline", "percentage-25", "IconPercentage25", [["path", { "d": "M21 12a9 9 0 0 0 -9 -9m0 0v9h9", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage25$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage25
});

var IconPercentage30 = createReactComponent("outline", "percentage-30", "IconPercentage30", [["path", { "d": "M12 3a9 9 0 0 1 8.495 11.973l-8.495 -2.973z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage30$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage30
});

var IconPercentage33 = createReactComponent("outline", "percentage-33", "IconPercentage33", [["path", { "d": "M12 3a9 9 0 0 1 7.794 13.5l-7.79 -4.497z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage33$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage33
});

var IconPercentage40 = createReactComponent("outline", "percentage-40", "IconPercentage40", [["path", { "d": "M12 3a9 9 0 0 1 5.162 16.372l-5.162 -7.372z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage40$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage40
});

var IconPercentage50 = createReactComponent("outline", "percentage-50", "IconPercentage50", [["path", { "d": "M12 21a9 9 0 0 0 0 -18m0 0v18", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage50$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage50
});

var IconPercentage60 = createReactComponent("outline", "percentage-60", "IconPercentage60", [["path", { "d": "M12 3a9 9 0 1 1 -5.162 16.373l5.162 -7.373z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage60$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage60
});

var IconPercentage66 = createReactComponent("outline", "percentage-66", "IconPercentage66", [["path", { "d": "M12 3a9 9 0 1 1 -7.795 13.498l7.795 -4.498z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage66$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage66
});

var IconPercentage70 = createReactComponent("outline", "percentage-70", "IconPercentage70", [["path", { "d": "M12 3a9 9 0 1 1 -8.495 11.973l8.495 -2.973z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage70$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage70
});

var IconPercentage75 = createReactComponent("outline", "percentage-75", "IconPercentage75", [["path", { "d": "M3 12a9 9 0 1 0 9 -9m0 0v9h-9", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage75$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage75
});

var IconPercentage80 = createReactComponent("outline", "percentage-80", "IconPercentage80", [["path", { "d": "M12 3a9 9 0 1 1 -8.497 6.025l8.497 2.975z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage80$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage80
});

var IconPercentage90 = createReactComponent("outline", "percentage-90", "IconPercentage90", [["path", { "d": "M12 3a9 9 0 1 1 -5.16 1.626l5.16 7.374z", "fill": "currentColor", "stroke": "none", "key": "svg-0" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-1" }]]);

var IconPercentage90$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage90
});

var IconPercentage = createReactComponent("outline", "percentage", "IconPercentage", [["path", { "d": "M17 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M7 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M6 18l12 -12", "key": "svg-2" }]]);

var IconPercentage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPercentage
});

var IconPerfume = createReactComponent("outline", "perfume", "IconPerfume", [["path", { "d": "M10 6v3", "key": "svg-0" }], ["path", { "d": "M14 6v3", "key": "svg-1" }], ["path", { "d": "M5 9m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-2" }], ["path", { "d": "M12 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M9 3h6v3h-6z", "key": "svg-4" }]]);

var IconPerfume$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPerfume
});

var IconPerspectiveOff = createReactComponent("outline", "perspective-off", "IconPerspectiveOff", [["path", { "d": "M8.511 4.502l9.63 1.375a1 1 0 0 1 .859 .99v8.133m-.859 3.123l-12 1.714a1 1 0 0 1 -1.141 -.99v-13.694a1 1 0 0 1 .01 -.137", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconPerspectiveOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPerspectiveOff
});

var IconPerspective = createReactComponent("outline", "perspective", "IconPerspective", [["path", { "d": "M6.141 4.163l12 1.714a1 1 0 0 1 .859 .99v10.266a1 1 0 0 1 -.859 .99l-12 1.714a1 1 0 0 1 -1.141 -.99v-13.694a1 1 0 0 1 1.141 -.99z", "key": "svg-0" }]]);

var IconPerspective$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPerspective
});

var IconPhoneCall = createReactComponent("outline", "phone-call", "IconPhoneCall", [["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M15 7a2 2 0 0 1 2 2", "key": "svg-1" }], ["path", { "d": "M15 3a6 6 0 0 1 6 6", "key": "svg-2" }]]);

var IconPhoneCall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoneCall
});

var IconPhoneCalling = createReactComponent("outline", "phone-calling", "IconPhoneCalling", [["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M15 7l0 .01", "key": "svg-1" }], ["path", { "d": "M18 7l0 .01", "key": "svg-2" }], ["path", { "d": "M21 7l0 .01", "key": "svg-3" }]]);

var IconPhoneCalling$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoneCalling
});

var IconPhoneCheck = createReactComponent("outline", "phone-check", "IconPhoneCheck", [["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M15 6l2 2l4 -4", "key": "svg-1" }]]);

var IconPhoneCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoneCheck
});

var IconPhoneDone = createReactComponent("outline", "phone-done", "IconPhoneDone", [["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2c-8.072 -.49 -14.51 -6.928 -15 -15a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M15 5l2 2l4 -4", "key": "svg-1" }]]);

var IconPhoneDone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoneDone
});

var IconPhoneEnd = createReactComponent("outline", "phone-end", "IconPhoneEnd", [["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2c-8.072 -.49 -14.51 -6.928 -15 -15a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M17 3l4 4", "key": "svg-1" }], ["path", { "d": "M21 3l-4 4", "key": "svg-2" }]]);

var IconPhoneEnd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoneEnd
});

var IconPhoneIncoming = createReactComponent("outline", "phone-incoming", "IconPhoneIncoming", [["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M15 9l5 -5", "key": "svg-1" }], ["path", { "d": "M15 5l0 4l4 0", "key": "svg-2" }]]);

var IconPhoneIncoming$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoneIncoming
});

var IconPhoneOff = createReactComponent("outline", "phone-off", "IconPhoneOff", [["path", { "d": "M3 21l18 -18", "key": "svg-0" }], ["path", { "d": "M5.831 14.161a15.946 15.946 0 0 1 -2.831 -8.161a2 2 0 0 1 2 -2h4l2 5l-2.5 1.5c.108 .22 .223 .435 .345 .645m1.751 2.277c.843 .84 1.822 1.544 2.904 2.078l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a15.963 15.963 0 0 1 -10.344 -4.657", "key": "svg-1" }]]);

var IconPhoneOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoneOff
});

var IconPhoneOutgoing = createReactComponent("outline", "phone-outgoing", "IconPhoneOutgoing", [["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2c-8.072 -.49 -14.51 -6.928 -15 -15a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M15 5h6", "key": "svg-1" }], ["path", { "d": "M18.5 7.5l2.5 -2.5l-2.5 -2.5", "key": "svg-2" }]]);

var IconPhoneOutgoing$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoneOutgoing
});

var IconPhonePause = createReactComponent("outline", "phone-pause", "IconPhonePause", [["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2c-8.072 -.49 -14.51 -6.928 -15 -15a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M17 3v5", "key": "svg-1" }], ["path", { "d": "M21 3v5", "key": "svg-2" }]]);

var IconPhonePause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhonePause
});

var IconPhonePlus = createReactComponent("outline", "phone-plus", "IconPhonePlus", [["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M15 6h6m-3 -3v6", "key": "svg-1" }]]);

var IconPhonePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhonePlus
});

var IconPhoneRinging = createReactComponent("outline", "phone-ringing", "IconPhoneRinging", [["path", { "d": "M20 4l-2 2", "key": "svg-0" }], ["path", { "d": "M22 10.5l-2.5 -.5", "key": "svg-1" }], ["path", { "d": "M13.5 2l.5 2.5", "key": "svg-2" }], ["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2c-8.072 -.49 -14.51 -6.928 -15 -15a2 2 0 0 1 2 -2", "key": "svg-3" }]]);

var IconPhoneRinging$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoneRinging
});

var IconPhoneSpark = createReactComponent("outline", "phone-spark", "IconPhoneSpark", [["path", { "d": "M11.584 19.225a16 16 0 0 1 -8.584 -13.225a2 2 0 0 1 2 -2h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l.65 .26", "key": "svg-0" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-1" }]]);

var IconPhoneSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoneSpark
});

var IconPhoneX = createReactComponent("outline", "phone-x", "IconPhoneX", [["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M16 4l4 4m0 -4l-4 4", "key": "svg-1" }]]);

var IconPhoneX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoneX
});

var IconPhone = createReactComponent("outline", "phone", "IconPhone", [["path", { "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2", "key": "svg-0" }]]);

var IconPhone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhone
});

var IconPhotoAi = createReactComponent("outline", "photo-ai", "IconPhotoAi", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M10 21h-4a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l1 1", "key": "svg-2" }], ["path", { "d": "M14 21v-4a2 2 0 1 1 4 0v4", "key": "svg-3" }], ["path", { "d": "M14 19h4", "key": "svg-4" }], ["path", { "d": "M21 15v6", "key": "svg-5" }]]);

var IconPhotoAi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoAi
});

var IconPhotoBitcoin = createReactComponent("outline", "photo-bitcoin", "IconPhotoBitcoin", [["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-0" }], ["path", { "d": "M15 8h.01", "key": "svg-1" }], ["path", { "d": "M13 21h-7a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5", "key": "svg-2" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l2.5 2.5", "key": "svg-3" }]]);

var IconPhotoBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoBitcoin
});

var IconPhotoBolt = createReactComponent("outline", "photo-bolt", "IconPhotoBolt", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M13.5 21h-7.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.5", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.669 -.643 1.45 -.823 2.18 -.54", "key": "svg-3" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-4" }]]);

var IconPhotoBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoBolt
});

var IconPhotoCancel = createReactComponent("outline", "photo-cancel", "IconPhotoCancel", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.5", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.616 -.593 1.328 -.792 2.008 -.598", "key": "svg-3" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }], ["path", { "d": "M17 21l4 -4", "key": "svg-5" }]]);

var IconPhotoCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoCancel
});

var IconPhotoCheck = createReactComponent("outline", "photo-check", "IconPhotoCheck", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M11.5 21h-5.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v7", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l.5 .5", "key": "svg-3" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-4" }]]);

var IconPhotoCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoCheck
});

var IconPhotoCircleMinus = createReactComponent("outline", "photo-circle-minus", "IconPhotoCircleMinus", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M20.475 15.035a9 9 0 0 0 -8.475 -12.035a9 9 0 0 0 -9 9a9 9 0 0 0 9.525 8.985", "key": "svg-1" }], ["path", { "d": "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l4 4", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l2 2", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }]]);

var IconPhotoCircleMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoCircleMinus
});

var IconPhotoCirclePlus = createReactComponent("outline", "photo-circle-plus", "IconPhotoCirclePlus", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M20.964 12.806a9 9 0 0 0 -8.964 -9.806a9 9 0 0 0 -9 9a9 9 0 0 0 9.397 8.991", "key": "svg-1" }], ["path", { "d": "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l4 4", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0", "key": "svg-3" }], ["path", { "d": "M16 19.33h6", "key": "svg-4" }], ["path", { "d": "M19 16.33v6", "key": "svg-5" }]]);

var IconPhotoCirclePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoCirclePlus
});

var IconPhotoCircle = createReactComponent("outline", "photo-circle", "IconPhotoCircle", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l5 5", "key": "svg-1" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l2 2", "key": "svg-2" }], ["path", { "d": "M3 12a9 9 0 0 0 9 9a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9", "key": "svg-3" }]]);

var IconPhotoCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoCircle
});

var IconPhotoCode = createReactComponent("outline", "photo-code", "IconPhotoCode", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M11.5 21h-5.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v7", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0", "key": "svg-3" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-4" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-5" }]]);

var IconPhotoCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoCode
});

var IconPhotoCog = createReactComponent("outline", "photo-cog", "IconPhotoCog", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M12 21h-6a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.48 -.461 1.016 -.684 1.551 -.67", "key": "svg-3" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-5" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-6" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-7" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-8" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-9" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-10" }]]);

var IconPhotoCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoCog
});

var IconPhotoDollar = createReactComponent("outline", "photo-dollar", "IconPhotoDollar", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M13 21h-7a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l2.5 2.5", "key": "svg-2" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-4" }]]);

var IconPhotoDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoDollar
});

var IconPhotoDown = createReactComponent("outline", "photo-down", "IconPhotoDown", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.5", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.653 -.629 1.413 -.815 2.13 -.559", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-5" }]]);

var IconPhotoDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoDown
});

var IconPhotoEdit = createReactComponent("outline", "photo-edit", "IconPhotoEdit", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M11 20h-4a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v4", "key": "svg-1" }], ["path", { "d": "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l3 3", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.31 -.298 .644 -.497 .987 -.596", "key": "svg-3" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z", "key": "svg-4" }]]);

var IconPhotoEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoEdit
});

var IconPhotoExclamation = createReactComponent("outline", "photo-exclamation", "IconPhotoExclamation", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M15 21h-9a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.665 -.64 1.44 -.821 2.167 -.545", "key": "svg-3" }], ["path", { "d": "M19 16v3", "key": "svg-4" }], ["path", { "d": "M19 22v.01", "key": "svg-5" }]]);

var IconPhotoExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoExclamation
});

var IconPhotoHeart = createReactComponent("outline", "photo-heart", "IconPhotoHeart", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M11.5 21h-5.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l1.5 1.5", "key": "svg-2" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-3" }]]);

var IconPhotoHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoHeart
});

var IconPhotoHexagon = createReactComponent("outline", "photo-hexagon", "IconPhotoHexagon", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-1" }], ["path", { "d": "M3.5 15.5l4.5 -4.5c.928 -.893 2.072 -.893 3 0l5 5", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l2.5 2.5", "key": "svg-3" }]]);

var IconPhotoHexagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoHexagon
});

var IconPhotoMinus = createReactComponent("outline", "photo-minus", "IconPhotoMinus", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v9", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l2 2", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }]]);

var IconPhotoMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoMinus
});

var IconPhotoOff = createReactComponent("outline", "photo-off", "IconPhotoOff", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M7 3h11a3 3 0 0 1 3 3v11m-.856 3.099a2.991 2.991 0 0 1 -2.144 .901h-12a3 3 0 0 1 -3 -3v-12c0 -.845 .349 -1.608 .91 -2.153", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5", "key": "svg-2" }], ["path", { "d": "M16.33 12.338c.574 -.054 1.155 .166 1.67 .662l3 3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconPhotoOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoOff
});

var IconPhotoPause = createReactComponent("outline", "photo-pause", "IconPhotoPause", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M13 21h-7a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v7", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0", "key": "svg-3" }], ["path", { "d": "M17 17v5", "key": "svg-4" }], ["path", { "d": "M21 17v5", "key": "svg-5" }]]);

var IconPhotoPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoPause
});

var IconPhotoPentagon = createReactComponent("outline", "photo-pentagon", "IconPhotoPentagon", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M15 8h.01", "key": "svg-1" }], ["path", { "d": "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l5 5", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l2 2", "key": "svg-3" }]]);

var IconPhotoPentagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoPentagon
});

var IconPhotoPin = createReactComponent("outline", "photo-pin", "IconPhotoPin", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l2.5 2.5", "key": "svg-2" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-3" }], ["path", { "d": "M19 18v.01", "key": "svg-4" }]]);

var IconPhotoPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoPin
});

var IconPhotoPlus = createReactComponent("outline", "photo-plus", "IconPhotoPlus", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.5", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.67 -.644 1.45 -.824 2.182 -.54", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16v6", "key": "svg-5" }]]);

var IconPhotoPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoPlus
});

var IconPhotoQuestion = createReactComponent("outline", "photo-question", "IconPhotoQuestion", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M15 21h-9a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-4" }]]);

var IconPhotoQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoQuestion
});

var IconPhotoScan = createReactComponent("outline", "photo-scan", "IconPhotoScan", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M6 13l2.644 -2.644a1.21 1.21 0 0 1 1.712 0l3.644 3.644", "key": "svg-1" }], ["path", { "d": "M13 13l1.644 -1.644a1.21 1.21 0 0 1 1.712 0l1.644 1.644", "key": "svg-2" }], ["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-3" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-4" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-5" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-6" }]]);

var IconPhotoScan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoScan
});

var IconPhotoSearch = createReactComponent("outline", "photo-search", "IconPhotoSearch", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M11.5 21h-5.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l2 2", "key": "svg-4" }]]);

var IconPhotoSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoSearch
});

var IconPhotoSensor2 = createReactComponent("outline", "photo-sensor-2", "IconPhotoSensor2", [["path", { "d": "M17 5h2a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-2", "key": "svg-0" }], ["path", { "d": "M7 19h-2a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-2" }]]);

var IconPhotoSensor2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoSensor2
});

var IconPhotoSensor3 = createReactComponent("outline", "photo-sensor-3", "IconPhotoSensor3", [["path", { "d": "M17 4h1a2 2 0 0 1 2 2v1", "key": "svg-0" }], ["path", { "d": "M20 17v1a2 2 0 0 1 -2 2h-1", "key": "svg-1" }], ["path", { "d": "M7 20h-1a2 2 0 0 1 -2 -2v-1", "key": "svg-2" }], ["path", { "d": "M4 7v-1a2 2 0 0 1 2 -2h1", "key": "svg-3" }], ["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-4" }], ["path", { "d": "M12 18v2", "key": "svg-5" }], ["path", { "d": "M4 12h2", "key": "svg-6" }], ["path", { "d": "M12 4v2", "key": "svg-7" }], ["path", { "d": "M20 12h-2", "key": "svg-8" }]]);

var IconPhotoSensor3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoSensor3
});

var IconPhotoSensor = createReactComponent("outline", "photo-sensor", "IconPhotoSensor", [["path", { "d": "M17 5h2a2 2 0 0 1 2 2v2", "key": "svg-0" }], ["path", { "d": "M21 15v2a2 2 0 0 1 -2 2h-2", "key": "svg-1" }], ["path", { "d": "M7 19h-2a2 2 0 0 1 -2 -2v-2", "key": "svg-2" }], ["path", { "d": "M3 9v-2a2 2 0 0 1 2 -2h2", "key": "svg-3" }], ["path", { "d": "M7 9m0 1a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1z", "key": "svg-4" }]]);

var IconPhotoSensor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoSensor
});

var IconPhotoShare = createReactComponent("outline", "photo-share", "IconPhotoShare", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M12 21h-6a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v7", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0", "key": "svg-3" }], ["path", { "d": "M16 22l5 -5", "key": "svg-4" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-5" }]]);

var IconPhotoShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoShare
});

var IconPhotoShield = createReactComponent("outline", "photo-shield", "IconPhotoShield", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M11.5 20h-4.5a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v4", "key": "svg-1" }], ["path", { "d": "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l1.5 1.5", "key": "svg-2" }], ["path", { "d": "M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5z", "key": "svg-3" }]]);

var IconPhotoShield$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoShield
});

var IconPhotoSpark = createReactComponent("outline", "photo-spark", "IconPhotoSpark", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M12 21h-6a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3.993 3.993", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.47 -.452 .995 -.675 1.52 -.67", "key": "svg-3" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-4" }]]);

var IconPhotoSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoSpark
});

var IconPhotoSquareRounded = createReactComponent("outline", "photo-square-rounded", "IconPhotoSquareRounded", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }], ["path", { "d": "M3.5 15.5l4.5 -4.5c.928 -.893 2.072 -.893 3 0l5 5", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l2.5 2.5", "key": "svg-3" }]]);

var IconPhotoSquareRounded$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoSquareRounded
});

var IconPhotoStar = createReactComponent("outline", "photo-star", "IconPhotoStar", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M11 21h-5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l2 2", "key": "svg-2" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-3" }]]);

var IconPhotoStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoStar
});

var IconPhotoUp = createReactComponent("outline", "photo-up", "IconPhotoUp", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.5", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3.5 3.5", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.679 -.653 1.473 -.829 2.214 -.526", "key": "svg-3" }], ["path", { "d": "M19 22v-6", "key": "svg-4" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-5" }]]);

var IconPhotoUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoUp
});

var IconPhotoVideo = createReactComponent("outline", "photo-video", "IconPhotoVideo", [["path", { "d": "M9 15h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3", "key": "svg-0" }], ["path", { "d": "M9 9m0 3a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3z", "key": "svg-1" }], ["path", { "d": "M3 12l2.296 -2.296a2.41 2.41 0 0 1 3.408 0l.296 .296", "key": "svg-2" }], ["path", { "d": "M14 13.5v3l2.5 -1.5z", "key": "svg-3" }], ["path", { "d": "M7 6v.01", "key": "svg-4" }]]);

var IconPhotoVideo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoVideo
});

var IconPhotoX = createReactComponent("outline", "photo-x", "IconPhotoX", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M13 21h-7a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v7", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0", "key": "svg-3" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-4" }], ["path", { "d": "M17 22l5 -5", "key": "svg-5" }]]);

var IconPhotoX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoX
});

var IconPhoto = createReactComponent("outline", "photo", "IconPhoto", [["path", { "d": "M15 8h.01", "key": "svg-0" }], ["path", { "d": "M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z", "key": "svg-1" }], ["path", { "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5", "key": "svg-2" }], ["path", { "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3", "key": "svg-3" }]]);

var IconPhoto$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoto
});

var IconPhysotherapist = createReactComponent("outline", "physotherapist", "IconPhysotherapist", [["path", { "d": "M9 15l-1 -3l4 -2l4 1h3.5", "key": "svg-0" }], ["path", { "d": "M4 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M12 6m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M12 17v-7", "key": "svg-3" }], ["path", { "d": "M8 20h7l1 -4l4 -2", "key": "svg-4" }], ["path", { "d": "M18 20h3", "key": "svg-5" }]]);

var IconPhysotherapist$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhysotherapist
});

var IconPiano = createReactComponent("outline", "piano", "IconPiano", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 19v-6", "key": "svg-1" }], ["path", { "d": "M8 5v8h2v-8", "key": "svg-2" }], ["path", { "d": "M15 19v-6", "key": "svg-3" }], ["path", { "d": "M14 5v8h2v-8", "key": "svg-4" }]]);

var IconPiano$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPiano
});

var IconPick = createReactComponent("outline", "pick", "IconPick", [["path", { "d": "M13 8l-9.383 9.418a2.091 2.091 0 0 0 0 2.967a2.11 2.11 0 0 0 2.976 0l9.407 -9.385", "key": "svg-0" }], ["path", { "d": "M9 3h4.586a1 1 0 0 1 .707 .293l6.414 6.414a1 1 0 0 1 .293 .707v4.586a2 2 0 1 1 -4 0v-3l-5 -5h-3a2 2 0 1 1 0 -4z", "key": "svg-1" }]]);

var IconPick$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPick
});

var IconPicnicTable = createReactComponent("outline", "picnic-table", "IconPicnicTable", [["path", { "d": "M16 7l2 9m-10 -9l-2 9m-1 -9h14m2 5h-18", "key": "svg-0" }]]);

var IconPicnicTable$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPicnicTable
});

var IconPictureInPictureOff = createReactComponent("outline", "picture-in-picture-off", "IconPictureInPictureOff", [["path", { "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M14 14m0 1a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M7 9l4 4", "key": "svg-2" }], ["path", { "d": "M7 12v-3h3", "key": "svg-3" }]]);

var IconPictureInPictureOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPictureInPictureOff
});

var IconPictureInPictureOn = createReactComponent("outline", "picture-in-picture-on", "IconPictureInPictureOn", [["path", { "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M14 14m0 1a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M7 9l4 4", "key": "svg-2" }], ["path", { "d": "M8 13h3v-3", "key": "svg-3" }]]);

var IconPictureInPictureOn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPictureInPictureOn
});

var IconPictureInPictureTop = createReactComponent("outline", "picture-in-picture-top", "IconPictureInPictureTop", [["path", { "d": "M11 5h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-4", "key": "svg-0" }], ["path", { "d": "M15 10h5a1 1 0 0 0 1 -1v-3a1 1 0 0 0 -1 -1h-5a1 1 0 0 0 -1 1v3a1 1 0 0 0 1 1z", "key": "svg-1" }]]);

var IconPictureInPictureTop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPictureInPictureTop
});

var IconPictureInPicture = createReactComponent("outline", "picture-in-picture", "IconPictureInPicture", [["path", { "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4", "key": "svg-0" }], ["path", { "d": "M14 14m0 1a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1z", "key": "svg-1" }]]);

var IconPictureInPicture$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPictureInPicture
});

var IconPigMoney = createReactComponent("outline", "pig-money", "IconPigMoney", [["path", { "d": "M15 11v.01", "key": "svg-0" }], ["path", { "d": "M5.173 8.378a3 3 0 1 1 4.656 -1.377", "key": "svg-1" }], ["path", { "d": "M16 4v3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342c-.336 .95 -.907 1.8 -1.658 2.473v2.027a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l0 -.027a6 6 0 0 1 4 -10.473h2.5l4.5 -3h0z", "key": "svg-2" }]]);

var IconPigMoney$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPigMoney
});

var IconPigOff = createReactComponent("outline", "pig-off", "IconPigOff", [["path", { "d": "M15 11v.01", "key": "svg-0" }], ["path", { "d": "M10 6h1.499l4.5 -3l0 3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342c-.057 .16 -.12 .318 -.19 .472m-1.467 2.528v1.5a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l0 -.027a6 6 0 0 1 1.5 -9.928", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconPigOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPigOff
});

var IconPig = createReactComponent("outline", "pig", "IconPig", [["path", { "d": "M15 11v.01", "key": "svg-0" }], ["path", { "d": "M16 3l0 3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342a6.008 6.008 0 0 1 -1.658 2.473v2.027a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l0 -.027a6 6 0 0 1 4 -10.473h2.5l4.5 -3z", "key": "svg-1" }]]);

var IconPig$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPig
});

var IconPilcrowLeft = createReactComponent("outline", "pilcrow-left", "IconPilcrowLeft", [["path", { "d": "M11 9h-2a3 3 0 1 1 0 -6h7", "key": "svg-0" }], ["path", { "d": "M11 3v11", "key": "svg-1" }], ["path", { "d": "M15 3v11", "key": "svg-2" }], ["path", { "d": "M3 18h18", "key": "svg-3" }], ["path", { "d": "M6 15l-3 3l3 3", "key": "svg-4" }]]);

var IconPilcrowLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPilcrowLeft
});

var IconPilcrowRight = createReactComponent("outline", "pilcrow-right", "IconPilcrowRight", [["path", { "d": "M11 9h-2a3 3 0 1 1 0 -6h7", "key": "svg-0" }], ["path", { "d": "M11 3v11", "key": "svg-1" }], ["path", { "d": "M15 3v11", "key": "svg-2" }], ["path", { "d": "M21 18h-18", "key": "svg-3" }], ["path", { "d": "M18 15l3 3l-3 3", "key": "svg-4" }]]);

var IconPilcrowRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPilcrowRight
});

var IconPilcrow = createReactComponent("outline", "pilcrow", "IconPilcrow", [["path", { "d": "M13 4v16", "key": "svg-0" }], ["path", { "d": "M17 4v16", "key": "svg-1" }], ["path", { "d": "M19 4h-9.5a4.5 4.5 0 0 0 0 9h3.5", "key": "svg-2" }]]);

var IconPilcrow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPilcrow
});

var IconPillOff = createReactComponent("outline", "pill-off", "IconPillOff", [["path", { "d": "M10.495 6.505l2 -2a4.95 4.95 0 0 1 7 7l-2 2m-2 2l-4 4a4.95 4.95 0 0 1 -7 -7l4 -4", "key": "svg-0" }], ["path", { "d": "M8.5 8.5l7 7", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconPillOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPillOff
});

var IconPill = createReactComponent("outline", "pill", "IconPill", [["path", { "d": "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7", "key": "svg-0" }], ["path", { "d": "M8.5 8.5l7 7", "key": "svg-1" }]]);

var IconPill$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPill
});

var IconPills = createReactComponent("outline", "pills", "IconPills", [["path", { "d": "M8 8m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M17 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-1" }], ["path", { "d": "M4.5 4.5l7 7", "key": "svg-2" }], ["path", { "d": "M19.5 14.5l-5 5", "key": "svg-3" }]]);

var IconPills$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPills
});

var IconPinEnd = createReactComponent("outline", "pin-end", "IconPinEnd", [["path", { "d": "M21 11v-5a1 1 0 0 0 -1 -1h-16a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9", "key": "svg-0" }], ["path", { "d": "M19 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M10 13v-4h4", "key": "svg-2" }], ["path", { "d": "M14 13l-4 -4", "key": "svg-3" }]]);

var IconPinEnd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPinEnd
});

var IconPinInvoke = createReactComponent("outline", "pin-invoke", "IconPinInvoke", [["path", { "d": "M21 13v5a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h9", "key": "svg-0" }], ["path", { "d": "M19 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M10 11h4v4", "key": "svg-2" }], ["path", { "d": "M10 15l4 -4", "key": "svg-3" }]]);

var IconPinInvoke$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPinInvoke
});

var IconPin = createReactComponent("outline", "pin", "IconPin", [["path", { "d": "M15 4.5l-4 4l-4 1.5l-1.5 1.5l7 7l1.5 -1.5l1.5 -4l4 -4", "key": "svg-0" }], ["path", { "d": "M9 15l-4.5 4.5", "key": "svg-1" }], ["path", { "d": "M14.5 4l5.5 5.5", "key": "svg-2" }]]);

var IconPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPin
});

var IconPingPong = createReactComponent("outline", "ping-pong", "IconPingPong", [["path", { "d": "M12.718 20.713a7.64 7.64 0 0 1 -7.48 -12.755l.72 -.72a7.643 7.643 0 0 1 9.105 -1.283l2.387 -2.345a2.08 2.08 0 0 1 3.057 2.815l-.116 .126l-2.346 2.387a7.644 7.644 0 0 1 -1.052 8.864", "key": "svg-0" }], ["path", { "d": "M14 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M9.3 5.3l9.4 9.4", "key": "svg-2" }]]);

var IconPingPong$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPingPong
});

var IconPinnedOff = createReactComponent("outline", "pinned-off", "IconPinnedOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M15 4.5l-3.249 3.249m-2.57 1.433l-2.181 .818l-1.5 1.5l7 7l1.5 -1.5l.82 -2.186m1.43 -2.563l3.25 -3.251", "key": "svg-1" }], ["path", { "d": "M9 15l-4.5 4.5", "key": "svg-2" }], ["path", { "d": "M14.5 4l5.5 5.5", "key": "svg-3" }]]);

var IconPinnedOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPinnedOff
});

var IconPinned = createReactComponent("outline", "pinned", "IconPinned", [["path", { "d": "M9 4v6l-2 4v2h10v-2l-2 -4v-6", "key": "svg-0" }], ["path", { "d": "M12 16l0 5", "key": "svg-1" }], ["path", { "d": "M8 4l8 0", "key": "svg-2" }]]);

var IconPinned$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPinned
});

var IconPizzaOff = createReactComponent("outline", "pizza-off", "IconPizzaOff", [["path", { "d": "M10.313 6.277l1.687 -3.277l5.34 10.376m2.477 6.463a19.093 19.093 0 0 1 -7.817 1.661c-3.04 0 -5.952 -.714 -8.5 -1.983l5.434 -10.559", "key": "svg-0" }], ["path", { "d": "M5.38 15.866a14.94 14.94 0 0 0 6.815 1.634c1.56 0 3.105 -.24 4.582 -.713", "key": "svg-1" }], ["path", { "d": "M11 14v-.01", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconPizzaOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPizzaOff
});

var IconPizza = createReactComponent("outline", "pizza", "IconPizza", [["path", { "d": "M12 21.5c-3.04 0 -5.952 -.714 -8.5 -1.983l8.5 -16.517l8.5 16.517a19.09 19.09 0 0 1 -8.5 1.983z", "key": "svg-0" }], ["path", { "d": "M5.38 15.866a14.94 14.94 0 0 0 6.815 1.634a14.944 14.944 0 0 0 6.502 -1.479", "key": "svg-1" }], ["path", { "d": "M13 11.01v-.01", "key": "svg-2" }], ["path", { "d": "M11 14v-.01", "key": "svg-3" }]]);

var IconPizza$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPizza
});

var IconPlaceholder = createReactComponent("outline", "placeholder", "IconPlaceholder", [["path", { "d": "M10 20.415a8 8 0 1 0 3 -15.415h-3", "key": "svg-0" }], ["path", { "d": "M13 8l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M7 17l4 -4l-4 -4l-4 4z", "key": "svg-2" }]]);

var IconPlaceholder$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaceholder
});

var IconPlaneArrival = createReactComponent("outline", "plane-arrival", "IconPlaneArrival", [["path", { "d": "M15.157 11.81l4.83 1.295a2 2 0 1 1 -1.036 3.863l-14.489 -3.882l-1.345 -6.572l2.898 .776l1.414 2.45l2.898 .776l-.12 -7.279l2.898 .777l2.052 7.797z", "key": "svg-0" }], ["path", { "d": "M3 21h18", "key": "svg-1" }]]);

var IconPlaneArrival$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaneArrival
});

var IconPlaneDeparture = createReactComponent("outline", "plane-departure", "IconPlaneDeparture", [["path", { "d": "M14.639 10.258l4.83 -1.294a2 2 0 1 1 1.035 3.863l-14.489 3.883l-4.45 -5.02l2.897 -.776l2.45 1.414l2.897 -.776l-3.743 -6.244l2.898 -.777l5.675 5.727z", "key": "svg-0" }], ["path", { "d": "M3 21h18", "key": "svg-1" }]]);

var IconPlaneDeparture$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaneDeparture
});

var IconPlaneInflight = createReactComponent("outline", "plane-inflight", "IconPlaneInflight", [["path", { "d": "M15 11.085h5a2 2 0 1 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3l4 7z", "key": "svg-0" }], ["path", { "d": "M3 21h18", "key": "svg-1" }]]);

var IconPlaneInflight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaneInflight
});

var IconPlaneOff = createReactComponent("outline", "plane-off", "IconPlaneOff", [["path", { "d": "M9.788 5.758l-.788 -2.758h3l4 7h4a2 2 0 1 1 0 4h-2m-2.718 1.256l-3.282 5.744h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h3", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconPlaneOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaneOff
});

var IconPlaneTilt = createReactComponent("outline", "plane-tilt", "IconPlaneTilt", [["path", { "d": "M14.5 6.5l3 -2.9a2.05 2.05 0 0 1 2.9 2.9l-2.9 3l2.5 7.5l-2.5 2.55l-3.5 -6.55l-3 3v3l-2 2l-1.5 -4.5l-4.5 -1.5l2 -2h3l3 -3l-6.5 -3.5l2.5 -2.5l7.5 2.5z", "key": "svg-0" }]]);

var IconPlaneTilt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaneTilt
});

var IconPlane = createReactComponent("outline", "plane", "IconPlane", [["path", { "d": "M16 10h4a2 2 0 0 1 0 4h-4l-4 7h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h4l-2 -7h3z", "key": "svg-0" }]]);

var IconPlane$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlane
});

var IconPlanetOff = createReactComponent("outline", "planet-off", "IconPlanetOff", [["path", { "d": "M18.816 13.58c1.956 1.825 3.157 3.449 3.184 4.445m-3.428 .593c-2.098 -.634 -4.944 -2.03 -7.919 -3.976c-5.47 -3.579 -9.304 -7.664 -8.56 -9.123c.32 -.628 1.591 -.6 3.294 -.113", "key": "svg-0" }], ["path", { "d": "M7.042 7.059a7 7 0 0 0 9.908 9.89m1.581 -2.425a7 7 0 0 0 -9.057 -9.054", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconPlanetOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlanetOff
});

var IconPlanet = createReactComponent("outline", "planet", "IconPlanet", [["path", { "d": "M18.816 13.58c2.292 2.138 3.546 4 3.092 4.9c-.745 1.46 -5.783 -.259 -11.255 -3.838c-5.47 -3.579 -9.304 -7.664 -8.56 -9.123c.464 -.91 2.926 -.444 5.803 .805", "key": "svg-0" }], ["path", { "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-1" }]]);

var IconPlanet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlanet
});

var IconPlant2Off = createReactComponent("outline", "plant-2-off", "IconPlant2Off", [["path", { "d": "M2 9c0 5.523 4.477 10 10 10a9.953 9.953 0 0 0 5.418 -1.593m2.137 -1.855a9.961 9.961 0 0 0 2.445 -6.552", "key": "svg-0" }], ["path", { "d": "M12 19c0 -1.988 .58 -3.84 1.58 -5.397m1.878 -2.167a9.961 9.961 0 0 1 6.542 -2.436", "key": "svg-1" }], ["path", { "d": "M2 9a10 10 0 0 1 10 10", "key": "svg-2" }], ["path", { "d": "M12 4a9.7 9.7 0 0 1 3 7.013", "key": "svg-3" }], ["path", { "d": "M9.01 11.5a9.696 9.696 0 0 1 .163 -2.318m1.082 -2.942a9.696 9.696 0 0 1 1.745 -2.24", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconPlant2Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlant2Off
});

var IconPlant2 = createReactComponent("outline", "plant-2", "IconPlant2", [["path", { "d": "M2 9a10 10 0 1 0 20 0", "key": "svg-0" }], ["path", { "d": "M12 19a10 10 0 0 1 10 -10", "key": "svg-1" }], ["path", { "d": "M2 9a10 10 0 0 1 10 10", "key": "svg-2" }], ["path", { "d": "M12 4a9.7 9.7 0 0 1 2.99 7.5", "key": "svg-3" }], ["path", { "d": "M9.01 11.5a9.7 9.7 0 0 1 2.99 -7.5", "key": "svg-4" }]]);

var IconPlant2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlant2
});

var IconPlantOff = createReactComponent("outline", "plant-off", "IconPlantOff", [["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4h8", "key": "svg-0" }], ["path", { "d": "M11.9 7.908a6 6 0 0 0 -4.79 -4.806m-4.11 -.102v2a6 6 0 0 0 6 6h2", "key": "svg-1" }], ["path", { "d": "M12.531 8.528a6 6 0 0 1 5.469 -3.528h3v1a6 6 0 0 1 -5.037 5.923", "key": "svg-2" }], ["path", { "d": "M12 15v-3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconPlantOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlantOff
});

var IconPlant = createReactComponent("outline", "plant", "IconPlant", [["path", { "d": "M7 15h10v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4z", "key": "svg-0" }], ["path", { "d": "M12 9a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3", "key": "svg-1" }], ["path", { "d": "M12 11a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3", "key": "svg-2" }], ["path", { "d": "M12 15l0 -6", "key": "svg-3" }]]);

var IconPlant$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlant
});

var IconPlayBasketball = createReactComponent("outline", "play-basketball", "IconPlayBasketball", [["path", { "d": "M10 4a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M5 21l3 -3l.75 -1.5", "key": "svg-1" }], ["path", { "d": "M14 21v-4l-4 -3l.5 -6", "key": "svg-2" }], ["path", { "d": "M5 12l1 -3l4.5 -1l3.5 3l4 1", "key": "svg-3" }], ["path", { "d": "M18.5 16a.5 .5 0 1 0 0 -1a.5 .5 0 0 0 0 1z", "fill": "currentColor", "key": "svg-4" }]]);

var IconPlayBasketball$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayBasketball
});

var IconPlayCard1 = createReactComponent("outline", "play-card-1", "IconPlayCard1", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M12 9v6", "key": "svg-3" }]]);

var IconPlayCard1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard1
});

var IconPlayCard10 = createReactComponent("outline", "play-card-10", "IconPlayCard10", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M9 9v6", "key": "svg-3" }], ["path", { "d": "M12 13c0 1.105 .672 2 1.5 2s1.5 -.895 1.5 -2v-2c0 -1.105 -.672 -2 -1.5 -2s-1.5 .895 -1.5 2z", "key": "svg-4" }]]);

var IconPlayCard10$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard10
});

var IconPlayCard2 = createReactComponent("outline", "play-card-2", "IconPlayCard2", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M10 9h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3", "key": "svg-3" }]]);

var IconPlayCard2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard2
});

var IconPlayCard3 = createReactComponent("outline", "play-card-3", "IconPlayCard3", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M10 9h2.5a1.5 1.5 0 0 1 0 3h-1.5h1.5a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }]]);

var IconPlayCard3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard3
});

var IconPlayCard4 = createReactComponent("outline", "play-card-4", "IconPlayCard4", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M10 9v2a1 1 0 0 0 1 1h3", "key": "svg-3" }], ["path", { "d": "M14 9v6", "key": "svg-4" }]]);

var IconPlayCard4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard4
});

var IconPlayCard5 = createReactComponent("outline", "play-card-5", "IconPlayCard5", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M10 15h3a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-3v-3h4", "key": "svg-3" }]]);

var IconPlayCard5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard5
});

var IconPlayCard6 = createReactComponent("outline", "play-card-6", "IconPlayCard6", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M14 9h-3a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-3", "key": "svg-3" }]]);

var IconPlayCard6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard6
});

var IconPlayCard7 = createReactComponent("outline", "play-card-7", "IconPlayCard7", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M10 9h4l-2 6", "key": "svg-1" }], ["path", { "d": "M8 6h.01", "key": "svg-2" }], ["path", { "d": "M16 18h.01", "key": "svg-3" }]]);

var IconPlayCard7$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard7
});

var IconPlayCard8 = createReactComponent("outline", "play-card-8", "IconPlayCard8", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M12 12h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1z", "key": "svg-3" }], ["path", { "d": "M12 12h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1", "key": "svg-4" }]]);

var IconPlayCard8$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard8
});

var IconPlayCard9 = createReactComponent("outline", "play-card-9", "IconPlayCard9", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M10 15h3a1 1 0 0 0 1 -1v-4a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3", "key": "svg-3" }]]);

var IconPlayCard9$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard9
});

var IconPlayCardA = createReactComponent("outline", "play-card-a", "IconPlayCardA", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M10 15v-4a2 2 0 1 1 4 0v4", "key": "svg-3" }], ["path", { "d": "M10 13h4", "key": "svg-4" }]]);

var IconPlayCardA$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCardA
});

var IconPlayCardJ = createReactComponent("outline", "play-card-j", "IconPlayCardJ", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M10 9h4v4a2 2 0 1 1 -4 0", "key": "svg-3" }]]);

var IconPlayCardJ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCardJ
});

var IconPlayCardK = createReactComponent("outline", "play-card-k", "IconPlayCardK", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M10 9v6", "key": "svg-3" }], ["path", { "d": "M14 9l-3 3l3 3", "key": "svg-4" }], ["path", { "d": "M10 12h1", "key": "svg-5" }]]);

var IconPlayCardK$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCardK
});

var IconPlayCardOff = createReactComponent("outline", "play-card-off", "IconPlayCardOff", [["path", { "d": "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14", "key": "svg-0" }], ["path", { "d": "M16 18h.01", "key": "svg-1" }], ["path", { "d": "M13.716 13.712l-1.716 2.288l-3 -4l1.29 -1.72", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconPlayCardOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCardOff
});

var IconPlayCardQ = createReactComponent("outline", "play-card-q", "IconPlayCardQ", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M12 9a2 2 0 0 1 2 2v2a2 2 0 1 1 -4 0v-2a2 2 0 0 1 2 -2", "key": "svg-3" }], ["path", { "d": "M13 14l1.5 1.5", "key": "svg-4" }]]);

var IconPlayCardQ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCardQ
});

var IconPlayCardStar = createReactComponent("outline", "play-card-star", "IconPlayCardStar", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M11.75 14.112l-1.63 .853a.294 .294 0 0 1 -.425 -.307l.31 -1.808l-1.317 -1.28a.292 .292 0 0 1 .163 -.499l1.82 -.264l.815 -1.644a.294 .294 0 0 1 .527 0l.814 1.644l1.82 .264a.292 .292 0 0 1 .164 .499l-1.318 1.28l.31 1.807a.292 .292 0 0 1 -.425 .308z", "key": "svg-3" }]]);

var IconPlayCardStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCardStar
});

var IconPlayCard = createReactComponent("outline", "play-card", "IconPlayCard", [["path", { "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z", "key": "svg-0" }], ["path", { "d": "M8 6h.01", "key": "svg-1" }], ["path", { "d": "M16 18h.01", "key": "svg-2" }], ["path", { "d": "M12 16l-3 -4l3 -4l3 4z", "key": "svg-3" }]]);

var IconPlayCard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard
});

var IconPlayFootball = createReactComponent("outline", "play-football", "IconPlayFootball", [["path", { "d": "M11 4a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M3 17l5 1l.75 -1.5", "key": "svg-1" }], ["path", { "d": "M14 21v-4l-4 -3l1 -6", "key": "svg-2" }], ["path", { "d": "M6 12v-3l5 -1l3 3l3 1", "key": "svg-3" }], ["path", { "d": "M19.5 20a.5 .5 0 1 0 0 -1a.5 .5 0 0 0 0 1z", "fill": "currentColor", "key": "svg-4" }]]);

var IconPlayFootball$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayFootball
});

var IconPlayHandball = createReactComponent("outline", "play-handball", "IconPlayHandball", [["path", { "d": "M13 21l3.5 -2l-4.5 -4l2 -4.5", "key": "svg-0" }], ["path", { "d": "M7 6l2 4l5 .5l4 2.5l2.5 3", "key": "svg-1" }], ["path", { "d": "M4 20l5 -1l1.5 -2", "key": "svg-2" }], ["path", { "d": "M15 7a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-3" }], ["path", { "d": "M9.5 5a.5 .5 0 1 0 0 -1a.5 .5 0 0 0 0 1z", "fill": "currentColor", "key": "svg-4" }]]);

var IconPlayHandball$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayHandball
});

var IconPlayVolleyball = createReactComponent("outline", "play-volleyball", "IconPlayVolleyball", [["path", { "d": "M13 4a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M20.5 10a.5 .5 0 1 0 0 -1a.5 .5 0 0 0 0 1z", "fill": "currentColor", "key": "svg-1" }], ["path", { "d": "M2 16l5 1l.5 -2.5", "key": "svg-2" }], ["path", { "d": "M11.5 21l2.5 -5.5l-5.5 -3.5l3.5 -4l3 4l4 2", "key": "svg-3" }]]);

var IconPlayVolleyball$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayVolleyball
});

var IconPlayerEject = createReactComponent("outline", "player-eject", "IconPlayerEject", [["path", { "d": "M5 12h14l-7 -8z", "key": "svg-0" }], ["path", { "d": "M5 16m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z", "key": "svg-1" }]]);

var IconPlayerEject$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerEject
});

var IconPlayerPause = createReactComponent("outline", "player-pause", "IconPlayerPause", [["path", { "d": "M6 5m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M14 5m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }]]);

var IconPlayerPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerPause
});

var IconPlayerPlay = createReactComponent("outline", "player-play", "IconPlayerPlay", [["path", { "d": "M7 4v16l13 -8z", "key": "svg-0" }]]);

var IconPlayerPlay$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerPlay
});

var IconPlayerRecord = createReactComponent("outline", "player-record", "IconPlayerRecord", [["path", { "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }]]);

var IconPlayerRecord$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerRecord
});

var IconPlayerSkipBack = createReactComponent("outline", "player-skip-back", "IconPlayerSkipBack", [["path", { "d": "M20 5v14l-12 -7z", "key": "svg-0" }], ["path", { "d": "M4 5l0 14", "key": "svg-1" }]]);

var IconPlayerSkipBack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerSkipBack
});

var IconPlayerSkipForward = createReactComponent("outline", "player-skip-forward", "IconPlayerSkipForward", [["path", { "d": "M4 5v14l12 -7z", "key": "svg-0" }], ["path", { "d": "M20 5l0 14", "key": "svg-1" }]]);

var IconPlayerSkipForward$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerSkipForward
});

var IconPlayerStop = createReactComponent("outline", "player-stop", "IconPlayerStop", [["path", { "d": "M5 5m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconPlayerStop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerStop
});

var IconPlayerTrackNext = createReactComponent("outline", "player-track-next", "IconPlayerTrackNext", [["path", { "d": "M3 5v14l8 -7z", "key": "svg-0" }], ["path", { "d": "M14 5v14l8 -7z", "key": "svg-1" }]]);

var IconPlayerTrackNext$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerTrackNext
});

var IconPlayerTrackPrev = createReactComponent("outline", "player-track-prev", "IconPlayerTrackPrev", [["path", { "d": "M21 5v14l-8 -7z", "key": "svg-0" }], ["path", { "d": "M10 5v14l-8 -7z", "key": "svg-1" }]]);

var IconPlayerTrackPrev$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerTrackPrev
});

var IconPlaylistAdd = createReactComponent("outline", "playlist-add", "IconPlaylistAdd", [["path", { "d": "M19 8h-14", "key": "svg-0" }], ["path", { "d": "M5 12h9", "key": "svg-1" }], ["path", { "d": "M11 16h-6", "key": "svg-2" }], ["path", { "d": "M15 16h6", "key": "svg-3" }], ["path", { "d": "M18 13v6", "key": "svg-4" }]]);

var IconPlaylistAdd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaylistAdd
});

var IconPlaylistOff = createReactComponent("outline", "playlist-off", "IconPlaylistOff", [["path", { "d": "M14 14a3 3 0 1 0 3 3", "key": "svg-0" }], ["path", { "d": "M17 13v-9h4", "key": "svg-1" }], ["path", { "d": "M13 5h-4m-4 0h-2", "key": "svg-2" }], ["path", { "d": "M3 9h6", "key": "svg-3" }], ["path", { "d": "M9 13h-6", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconPlaylistOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaylistOff
});

var IconPlaylistX = createReactComponent("outline", "playlist-x", "IconPlaylistX", [["path", { "d": "M19 8h-14", "key": "svg-0" }], ["path", { "d": "M5 12h7", "key": "svg-1" }], ["path", { "d": "M12 16h-7", "key": "svg-2" }], ["path", { "d": "M16 14l4 4", "key": "svg-3" }], ["path", { "d": "M20 14l-4 4", "key": "svg-4" }]]);

var IconPlaylistX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaylistX
});

var IconPlaylist = createReactComponent("outline", "playlist", "IconPlaylist", [["path", { "d": "M14 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 17v-13h4", "key": "svg-1" }], ["path", { "d": "M13 5h-10", "key": "svg-2" }], ["path", { "d": "M3 9l10 0", "key": "svg-3" }], ["path", { "d": "M9 13h-6", "key": "svg-4" }]]);

var IconPlaylist$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaylist
});

var IconPlaystationCircle = createReactComponent("outline", "playstation-circle", "IconPlaystationCircle", [["path", { "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z", "key": "svg-0" }], ["path", { "d": "M12 12m-4.5 0a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0", "key": "svg-1" }]]);

var IconPlaystationCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaystationCircle
});

var IconPlaystationSquare = createReactComponent("outline", "playstation-square", "IconPlaystationSquare", [["path", { "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z", "key": "svg-0" }], ["path", { "d": "M8 8m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-1" }]]);

var IconPlaystationSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaystationSquare
});

var IconPlaystationTriangle = createReactComponent("outline", "playstation-triangle", "IconPlaystationTriangle", [["path", { "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z", "key": "svg-0" }], ["path", { "d": "M7.5 15h9l-4.5 -8z", "key": "svg-1" }]]);

var IconPlaystationTriangle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaystationTriangle
});

var IconPlaystationX = createReactComponent("outline", "playstation-x", "IconPlaystationX", [["path", { "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z", "key": "svg-0" }], ["path", { "d": "M8.5 8.5l7 7", "key": "svg-1" }], ["path", { "d": "M8.5 15.5l7 -7", "key": "svg-2" }]]);

var IconPlaystationX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlaystationX
});

var IconPlugConnectedX = createReactComponent("outline", "plug-connected-x", "IconPlugConnectedX", [["path", { "d": "M20 16l-4 4", "key": "svg-0" }], ["path", { "d": "M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z", "key": "svg-1" }], ["path", { "d": "M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z", "key": "svg-2" }], ["path", { "d": "M3 21l2.5 -2.5", "key": "svg-3" }], ["path", { "d": "M18.5 5.5l2.5 -2.5", "key": "svg-4" }], ["path", { "d": "M10 11l-2 2", "key": "svg-5" }], ["path", { "d": "M13 14l-2 2", "key": "svg-6" }], ["path", { "d": "M16 16l4 4", "key": "svg-7" }]]);

var IconPlugConnectedX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlugConnectedX
});

var IconPlugConnected = createReactComponent("outline", "plug-connected", "IconPlugConnected", [["path", { "d": "M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z", "key": "svg-0" }], ["path", { "d": "M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z", "key": "svg-1" }], ["path", { "d": "M3 21l2.5 -2.5", "key": "svg-2" }], ["path", { "d": "M18.5 5.5l2.5 -2.5", "key": "svg-3" }], ["path", { "d": "M10 11l-2 2", "key": "svg-4" }], ["path", { "d": "M13 14l-2 2", "key": "svg-5" }]]);

var IconPlugConnected$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlugConnected
});

var IconPlugOff = createReactComponent("outline", "plug-off", "IconPlugOff", [["path", { "d": "M16.123 16.092l-.177 .177a5.81 5.81 0 1 1 -8.215 -8.215l.159 -.159", "key": "svg-0" }], ["path", { "d": "M4 20l3.5 -3.5", "key": "svg-1" }], ["path", { "d": "M15 4l-3.5 3.5", "key": "svg-2" }], ["path", { "d": "M20 9l-3.5 3.5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconPlugOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlugOff
});

var IconPlugX = createReactComponent("outline", "plug-x", "IconPlugX", [["path", { "d": "M13.55 17.733a5.806 5.806 0 0 1 -7.356 -4.052a5.81 5.81 0 0 1 1.537 -5.627l2.054 -2.054l7.165 7.165", "key": "svg-0" }], ["path", { "d": "M4 20l3.5 -3.5", "key": "svg-1" }], ["path", { "d": "M15 4l-3.5 3.5", "key": "svg-2" }], ["path", { "d": "M20 9l-3.5 3.5", "key": "svg-3" }], ["path", { "d": "M16 16l4 4", "key": "svg-4" }], ["path", { "d": "M20 16l-4 4", "key": "svg-5" }]]);

var IconPlugX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlugX
});

var IconPlug = createReactComponent("outline", "plug", "IconPlug", [["path", { "d": "M9.785 6l8.215 8.215l-2.054 2.054a5.81 5.81 0 1 1 -8.215 -8.215l2.054 -2.054z", "key": "svg-0" }], ["path", { "d": "M4 20l3.5 -3.5", "key": "svg-1" }], ["path", { "d": "M15 4l-3.5 3.5", "key": "svg-2" }], ["path", { "d": "M20 9l-3.5 3.5", "key": "svg-3" }]]);

var IconPlug$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlug
});

var IconPlusEqual = createReactComponent("outline", "plus-equal", "IconPlusEqual", [["path", { "d": "M4 7h6", "key": "svg-0" }], ["path", { "d": "M7 4v6", "key": "svg-1" }], ["path", { "d": "M20 16h-6", "key": "svg-2" }], ["path", { "d": "M20 19h-6", "key": "svg-3" }], ["path", { "d": "M5 19l14 -14", "key": "svg-4" }]]);

var IconPlusEqual$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlusEqual
});

var IconPlusMinus = createReactComponent("outline", "plus-minus", "IconPlusMinus", [["path", { "d": "M4 7h6", "key": "svg-0" }], ["path", { "d": "M7 4v6", "key": "svg-1" }], ["path", { "d": "M20 18h-6", "key": "svg-2" }], ["path", { "d": "M5 19l14 -14", "key": "svg-3" }]]);

var IconPlusMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlusMinus
});

var IconPlus = createReactComponent("outline", "plus", "IconPlus", [["path", { "d": "M12 5l0 14", "key": "svg-0" }], ["path", { "d": "M5 12l14 0", "key": "svg-1" }]]);

var IconPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlus
});

var IconPng = createReactComponent("outline", "png", "IconPng", [["path", { "d": "M21 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }], ["path", { "d": "M3 16v-8h2a2 2 0 1 1 0 4h-2", "key": "svg-1" }], ["path", { "d": "M10 16v-8l4 8v-8", "key": "svg-2" }]]);

var IconPng$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPng
});

var IconPodiumOff = createReactComponent("outline", "podium-off", "IconPodiumOff", [["path", { "d": "M12 8h7l-.621 2.485a2 2 0 0 1 -1.94 1.515h-.439m-4 0h-4.439a2 2 0 0 1 -1.94 -1.515l-.621 -2.485h3", "key": "svg-0" }], ["path", { "d": "M7 8v-1m.864 -3.106a2.99 2.99 0 0 1 2.136 -.894", "key": "svg-1" }], ["path", { "d": "M8 12l1 9", "key": "svg-2" }], ["path", { "d": "M15.599 15.613l-.599 5.387", "key": "svg-3" }], ["path", { "d": "M7 21h10", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconPodiumOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPodiumOff
});

var IconPodium = createReactComponent("outline", "podium", "IconPodium", [["path", { "d": "M5 8h14l-.621 2.485a2 2 0 0 1 -1.94 1.515h-8.878a2 2 0 0 1 -1.94 -1.515l-.621 -2.485z", "key": "svg-0" }], ["path", { "d": "M7 8v-2a3 3 0 0 1 3 -3", "key": "svg-1" }], ["path", { "d": "M8 12l1 9", "key": "svg-2" }], ["path", { "d": "M16 12l-1 9", "key": "svg-3" }], ["path", { "d": "M7 21h10", "key": "svg-4" }]]);

var IconPodium$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPodium
});

var IconPointOff = createReactComponent("outline", "point-off", "IconPointOff", [["path", { "d": "M9.15 9.194a4 4 0 0 0 5.697 5.617m1.153 -2.811a4 4 0 0 0 -4 -4", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconPointOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointOff
});

var IconPoint = createReactComponent("outline", "point", "IconPoint", [["path", { "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }]]);

var IconPoint$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPoint
});

var IconPointerBolt = createReactComponent("outline", "pointer-bolt", "IconPointerBolt", [["path", { "d": "M16.044 13.488l-1.266 -1.266l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.678 1.678", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }]]);

var IconPointerBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerBolt
});

var IconPointerCancel = createReactComponent("outline", "pointer-cancel", "IconPointerCancel", [["path", { "d": "M15.526 12.97l-.748 -.748l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.714 .714", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }]]);

var IconPointerCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerCancel
});

var IconPointerCheck = createReactComponent("outline", "pointer-check", "IconPointerCheck", [["path", { "d": "M17.487 14.93l-2.709 -2.708l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.785 .785", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }]]);

var IconPointerCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerCheck
});

var IconPointerCode = createReactComponent("outline", "pointer-code", "IconPointerCode", [["path", { "d": "M15.76 13.203l-.982 -.981l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.67 .67", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }]]);

var IconPointerCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerCode
});

var IconPointerCog = createReactComponent("outline", "pointer-cog", "IconPointerCog", [["path", { "d": "M15.774 13.218l-.996 -.996l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.343 .343", "key": "svg-0" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-2" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-3" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-7" }]]);

var IconPointerCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerCog
});

var IconPointerDollar = createReactComponent("outline", "pointer-dollar", "IconPointerDollar", [["path", { "d": "M14.778 12.222l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.787 .787", "key": "svg-0" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-2" }]]);

var IconPointerDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerDollar
});

var IconPointerDown = createReactComponent("outline", "pointer-down", "IconPointerDown", [["path", { "d": "M15.992 13.436l-1.214 -1.214l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.171 1.171", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }]]);

var IconPointerDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerDown
});

var IconPointerExclamation = createReactComponent("outline", "pointer-exclamation", "IconPointerExclamation", [["path", { "d": "M15.97 13.414l-1.192 -1.192l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l2.778 2.778", "key": "svg-0" }], ["path", { "d": "M19 16v3", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }]]);

var IconPointerExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerExclamation
});

var IconPointerHeart = createReactComponent("outline", "pointer-heart", "IconPointerHeart", [["path", { "d": "M16.571 11.018l1.32 -.886a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308", "key": "svg-0" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-1" }]]);

var IconPointerHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerHeart
});

var IconPointerMinus = createReactComponent("outline", "pointer-minus", "IconPointerMinus", [["path", { "d": "M17.6 15.043l-2.822 -2.821l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.188 1.188", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconPointerMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerMinus
});

var IconPointerOff = createReactComponent("outline", "pointer-off", "IconPointerOff", [["path", { "d": "M15.662 11.628l2.229 -1.496a1.2 1.2 0 0 0 -.309 -2.228l-8.013 -2.303m-5.569 -1.601l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l4.907 4.907a1.067 1.067 0 0 0 1.509 0l.524 -.524", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconPointerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerOff
});

var IconPointerPause = createReactComponent("outline", "pointer-pause", "IconPointerPause", [["path", { "d": "M15.72 13.163l-.942 -.941l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.969 .969", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }]]);

var IconPointerPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerPause
});

var IconPointerPin = createReactComponent("outline", "pointer-pin", "IconPointerPin", [["path", { "d": "M14.778 12.222l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.381 .381", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }]]);

var IconPointerPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerPin
});

var IconPointerPlus = createReactComponent("outline", "pointer-plus", "IconPointerPlus", [["path", { "d": "M15.941 13.385l-1.163 -1.163l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.23 1.23", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconPointerPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerPlus
});

var IconPointerQuestion = createReactComponent("outline", "pointer-question", "IconPointerQuestion", [["path", { "d": "M15.062 12.506l-.284 -.284l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.278 1.278", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconPointerQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerQuestion
});

var IconPointerSearch = createReactComponent("outline", "pointer-search", "IconPointerSearch", [["path", { "d": "M14.778 12.222l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }]]);

var IconPointerSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerSearch
});

var IconPointerShare = createReactComponent("outline", "pointer-share", "IconPointerShare", [["path", { "d": "M15.646 13.09l-.868 -.868l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.607 .607", "key": "svg-0" }], ["path", { "d": "M16 22l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-2" }]]);

var IconPointerShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerShare
});

var IconPointerStar = createReactComponent("outline", "pointer-star", "IconPointerStar", [["path", { "d": "M17.891 10.132a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308", "key": "svg-0" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }]]);

var IconPointerStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerStar
});

var IconPointerUp = createReactComponent("outline", "pointer-up", "IconPointerUp", [["path", { "d": "M15.984 13.428l-1.206 -1.206l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.217 1.217", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }]]);

var IconPointerUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerUp
});

var IconPointerX = createReactComponent("outline", "pointer-x", "IconPointerX", [["path", { "d": "M15.768 13.212l-.99 -.99l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.908 .908", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }]]);

var IconPointerX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerX
});

var IconPointer = createReactComponent("outline", "pointer", "IconPointer", [["path", { "d": "M7.904 17.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l4.907 4.907a1.067 1.067 0 0 0 1.509 0l1.047 -1.047a1.067 1.067 0 0 0 0 -1.509l-4.907 -4.907l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563z", "key": "svg-0" }]]);

var IconPointer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointer
});

var IconPokeballOff = createReactComponent("outline", "pokeball-off", "IconPokeballOff", [["path", { "d": "M20.04 16.048a9 9 0 0 0 -12.083 -12.09m-2.32 1.678a9 9 0 1 0 12.737 12.719", "key": "svg-0" }], ["path", { "d": "M9.884 9.874a3 3 0 1 0 4.24 4.246m.57 -3.441a3.012 3.012 0 0 0 -1.41 -1.39", "key": "svg-1" }], ["path", { "d": "M3 12h6m7 0h5", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconPokeballOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPokeballOff
});

var IconPokeball = createReactComponent("outline", "pokeball", "IconPokeball", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M3 12h6", "key": "svg-2" }], ["path", { "d": "M15 12h6", "key": "svg-3" }]]);

var IconPokeball$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPokeball
});

var IconPokerChip = createReactComponent("outline", "poker-chip", "IconPokerChip", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-1" }], ["path", { "d": "M12 3v4", "key": "svg-2" }], ["path", { "d": "M12 17v4", "key": "svg-3" }], ["path", { "d": "M3 12h4", "key": "svg-4" }], ["path", { "d": "M17 12h4", "key": "svg-5" }], ["path", { "d": "M18.364 5.636l-2.828 2.828", "key": "svg-6" }], ["path", { "d": "M8.464 15.536l-2.828 2.828", "key": "svg-7" }], ["path", { "d": "M5.636 5.636l2.828 2.828", "key": "svg-8" }], ["path", { "d": "M15.536 15.536l2.828 2.828", "key": "svg-9" }]]);

var IconPokerChip$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPokerChip
});

var IconPolaroid = createReactComponent("outline", "polaroid", "IconPolaroid", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 16l16 0", "key": "svg-1" }], ["path", { "d": "M4 12l3 -3c.928 -.893 2.072 -.893 3 0l4 4", "key": "svg-2" }], ["path", { "d": "M13 12l2 -2c.928 -.893 2.072 -.893 3 0l2 2", "key": "svg-3" }], ["path", { "d": "M14 7l.01 0", "key": "svg-4" }]]);

var IconPolaroid$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPolaroid
});

var IconPolygonOff = createReactComponent("outline", "polygon-off", "IconPolygonOff", [["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M19 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M15 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M6.5 9.5l1.546 -1.311", "key": "svg-4" }], ["path", { "d": "M14 5.5l3 1.5", "key": "svg-5" }], ["path", { "d": "M18.5 10l-1.185 3.318m-1.062 2.972l-.253 .71", "key": "svg-6" }], ["path", { "d": "M13.5 17.5l-7 -5", "key": "svg-7" }], ["path", { "d": "M3 3l18 18", "key": "svg-8" }]]);

var IconPolygonOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPolygonOff
});

var IconPolygon = createReactComponent("outline", "polygon", "IconPolygon", [["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M19 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M15 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M6.5 9.5l3.5 -3", "key": "svg-4" }], ["path", { "d": "M14 5.5l3 1.5", "key": "svg-5" }], ["path", { "d": "M18.5 10l-2.5 7", "key": "svg-6" }], ["path", { "d": "M13.5 17.5l-7 -5", "key": "svg-7" }]]);

var IconPolygon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPolygon
});

var IconPoo = createReactComponent("outline", "poo", "IconPoo", [["path", { "d": "M10 12h.01", "key": "svg-0" }], ["path", { "d": "M14 12h.01", "key": "svg-1" }], ["path", { "d": "M10 16a3.5 3.5 0 0 0 4 0", "key": "svg-2" }], ["path", { "d": "M11 4c2 0 3.5 1.5 3.5 4l.164 0a2.5 2.5 0 0 1 2.196 3.32a3 3 0 0 1 1.615 3.063a3 3 0 0 1 -1.299 5.607l-.176 0h-10a3 3 0 0 1 -1.474 -5.613a3 3 0 0 1 1.615 -3.062a2.5 2.5 0 0 1 2.195 -3.32l.164 0c1.5 0 2.5 -2 1.5 -4z", "key": "svg-3" }]]);

var IconPoo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPoo
});

var IconPoolOff = createReactComponent("outline", "pool-off", "IconPoolOff", [["path", { "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1c.303 0 .6 -.045 .876 -.146", "key": "svg-0" }], ["path", { "d": "M2 16a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1.13 -.856m5.727 1.717a2.4 2.4 0 0 0 1.143 -.861", "key": "svg-1" }], ["path", { "d": "M15 11v-6.5a1.5 1.5 0 0 1 3 0", "key": "svg-2" }], ["path", { "d": "M9 12v-3m0 -4v-.5a1.5 1.5 0 0 0 -1.936 -1.436", "key": "svg-3" }], ["path", { "d": "M15 5h-6", "key": "svg-4" }], ["path", { "d": "M9 10h1m4 0h1", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconPoolOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPoolOff
});

var IconPool = createReactComponent("outline", "pool", "IconPool", [["path", { "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1", "key": "svg-0" }], ["path", { "d": "M2 16a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1", "key": "svg-1" }], ["path", { "d": "M15 12v-7.5a1.5 1.5 0 0 1 3 0", "key": "svg-2" }], ["path", { "d": "M9 12v-7.5a1.5 1.5 0 0 0 -3 0", "key": "svg-3" }], ["path", { "d": "M15 5l-6 0", "key": "svg-4" }], ["path", { "d": "M9 10l6 0", "key": "svg-5" }]]);

var IconPool$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPool
});

var IconPower = createReactComponent("outline", "power", "IconPower", [["path", { "d": "M7 6a7.75 7.75 0 1 0 10 0", "key": "svg-0" }], ["path", { "d": "M12 4l0 8", "key": "svg-1" }]]);

var IconPower$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPower
});

var IconPray = createReactComponent("outline", "pray", "IconPray", [["path", { "d": "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M7 20h8l-4 -4v-7l4 3l2 -2", "key": "svg-1" }]]);

var IconPray$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPray
});

var IconPremiumRights = createReactComponent("outline", "premium-rights", "IconPremiumRights", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M13.867 9.75c-.246 -.48 -.708 -.769 -1.2 -.75h-1.334c-.736 0 -1.333 .67 -1.333 1.5c0 .827 .597 1.499 1.333 1.499h1.334c.736 0 1.333 .671 1.333 1.5c0 .828 -.597 1.499 -1.333 1.499h-1.334c-.492 .019 -.954 -.27 -1.2 -.75", "key": "svg-1" }], ["path", { "d": "M12 7v2", "key": "svg-2" }], ["path", { "d": "M12 15v2", "key": "svg-3" }]]);

var IconPremiumRights$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPremiumRights
});

var IconPrescription = createReactComponent("outline", "prescription", "IconPrescription", [["path", { "d": "M6 19v-16h4.5a4.5 4.5 0 1 1 0 9h-4.5", "key": "svg-0" }], ["path", { "d": "M19 21l-9 -9", "key": "svg-1" }], ["path", { "d": "M13 21l6 -6", "key": "svg-2" }]]);

var IconPrescription$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPrescription
});

var IconPresentationAnalytics = createReactComponent("outline", "presentation-analytics", "IconPresentationAnalytics", [["path", { "d": "M9 12v-4", "key": "svg-0" }], ["path", { "d": "M15 12v-2", "key": "svg-1" }], ["path", { "d": "M12 12v-1", "key": "svg-2" }], ["path", { "d": "M3 4h18", "key": "svg-3" }], ["path", { "d": "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10", "key": "svg-4" }], ["path", { "d": "M12 16v4", "key": "svg-5" }], ["path", { "d": "M9 20h6", "key": "svg-6" }]]);

var IconPresentationAnalytics$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPresentationAnalytics
});

var IconPresentationOff = createReactComponent("outline", "presentation-off", "IconPresentationOff", [["path", { "d": "M3 4h1m4 0h13", "key": "svg-0" }], ["path", { "d": "M4 4v10a2 2 0 0 0 2 2h10m3.42 -.592c.359 -.362 .58 -.859 .58 -1.408v-10", "key": "svg-1" }], ["path", { "d": "M12 16v4", "key": "svg-2" }], ["path", { "d": "M9 20h6", "key": "svg-3" }], ["path", { "d": "M8 12l2 -2m4 0l2 -2", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconPresentationOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPresentationOff
});

var IconPresentation = createReactComponent("outline", "presentation", "IconPresentation", [["path", { "d": "M3 4l18 0", "key": "svg-0" }], ["path", { "d": "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10", "key": "svg-1" }], ["path", { "d": "M12 16l0 4", "key": "svg-2" }], ["path", { "d": "M9 20l6 0", "key": "svg-3" }], ["path", { "d": "M8 12l3 -3l2 2l3 -3", "key": "svg-4" }]]);

var IconPresentation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPresentation
});

var IconPrinterOff = createReactComponent("outline", "printer-off", "IconPrinterOff", [["path", { "d": "M20.412 16.416c.363 -.362 .588 -.863 .588 -1.416v-4a2 2 0 0 0 -2 -2h-6m-4 0h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2", "key": "svg-0" }], ["path", { "d": "M17 9v-4a2 2 0 0 0 -2 -2h-6c-.551 0 -1.05 .223 -1.412 .584m-.588 3.416v2", "key": "svg-1" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h4", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconPrinterOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPrinterOff
});

var IconPrinter = createReactComponent("outline", "printer", "IconPrinter", [["path", { "d": "M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2", "key": "svg-0" }], ["path", { "d": "M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4", "key": "svg-1" }], ["path", { "d": "M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconPrinter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPrinter
});

var IconPrismLight = createReactComponent("outline", "prism-light", "IconPrismLight", [["path", { "d": "M4.731 19h11.539a1 1 0 0 0 .866 -1.5l-5.769 -10a1 1 0 0 0 -1.732 0l-5.769 10a1 1 0 0 0 .865 1.5", "key": "svg-0" }], ["path", { "d": "M2 13h4.45", "key": "svg-1" }], ["path", { "d": "M18 5l-4.5 6", "key": "svg-2" }], ["path", { "d": "M22 9l-7.75 3.25", "key": "svg-3" }], ["path", { "d": "M22 15l-7 -1.5", "key": "svg-4" }]]);

var IconPrismLight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPrismLight
});

var IconPrismOff = createReactComponent("outline", "prism-off", "IconPrismOff", [["path", { "d": "M12 12v10", "key": "svg-0" }], ["path", { "d": "M17.957 17.952l-4.937 3.703a1.7 1.7 0 0 1 -2.04 0l-5.98 -4.485a2.5 2.5 0 0 1 -1 -2v-11.17m3 -1h12a1 1 0 0 1 1 1v11.17c0 .25 -.037 .495 -.109 .729", "key": "svg-1" }], ["path", { "d": "M12.688 8.7a1.7 1.7 0 0 0 .357 -.214l6.655 -5.186", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconPrismOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPrismOff
});

var IconPrismPlus = createReactComponent("outline", "prism-plus", "IconPrismPlus", [["path", { "d": "M12 9v13", "key": "svg-0" }], ["path", { "d": "M13.02 21.655a1.7 1.7 0 0 1 -2.04 0l-5.98 -4.485a2.5 2.5 0 0 1 -1 -2v-11.17a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v8", "key": "svg-1" }], ["path", { "d": "M4.3 3.3l6.655 5.186a1.7 1.7 0 0 0 2.09 0l6.655 -5.186", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconPrismPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPrismPlus
});

var IconPrism = createReactComponent("outline", "prism", "IconPrism", [["path", { "d": "M12 9v13", "key": "svg-0" }], ["path", { "d": "M19 17.17l-5.98 4.485a1.7 1.7 0 0 1 -2.04 0l-5.98 -4.485a2.5 2.5 0 0 1 -1 -2v-11.17a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v11.17a2.5 2.5 0 0 1 -1 2z", "key": "svg-1" }], ["path", { "d": "M4.3 3.3l6.655 5.186a1.7 1.7 0 0 0 2.09 0l6.655 -5.186", "key": "svg-2" }]]);

var IconPrism$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPrism
});

var IconPrison = createReactComponent("outline", "prison", "IconPrison", [["path", { "d": "M18 4v16", "key": "svg-0" }], ["path", { "d": "M14 4v16", "key": "svg-1" }], ["path", { "d": "M6 4v5", "key": "svg-2" }], ["path", { "d": "M6 15v5", "key": "svg-3" }], ["path", { "d": "M10 4v5", "key": "svg-4" }], ["path", { "d": "M11 9h-6v6h6z", "key": "svg-5" }], ["path", { "d": "M10 15v5", "key": "svg-6" }], ["path", { "d": "M8 12h-.01", "key": "svg-7" }]]);

var IconPrison$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPrison
});

var IconProgressAlert = createReactComponent("outline", "progress-alert", "IconProgressAlert", [["path", { "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969", "key": "svg-0" }], ["path", { "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554", "key": "svg-1" }], ["path", { "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592", "key": "svg-2" }], ["path", { "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305", "key": "svg-3" }], ["path", { "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356", "key": "svg-4" }], ["path", { "d": "M12 8v4", "key": "svg-5" }], ["path", { "d": "M12 16v.01", "key": "svg-6" }]]);

var IconProgressAlert$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconProgressAlert
});

var IconProgressBolt = createReactComponent("outline", "progress-bolt", "IconProgressBolt", [["path", { "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969", "key": "svg-0" }], ["path", { "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554", "key": "svg-1" }], ["path", { "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592", "key": "svg-2" }], ["path", { "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305", "key": "svg-3" }], ["path", { "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356", "key": "svg-4" }], ["path", { "d": "M12 9l-2 3h4l-2 3", "key": "svg-5" }]]);

var IconProgressBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconProgressBolt
});

var IconProgressCheck = createReactComponent("outline", "progress-check", "IconProgressCheck", [["path", { "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969", "key": "svg-0" }], ["path", { "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554", "key": "svg-1" }], ["path", { "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592", "key": "svg-2" }], ["path", { "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305", "key": "svg-3" }], ["path", { "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356", "key": "svg-4" }], ["path", { "d": "M9 12l2 2l4 -4", "key": "svg-5" }]]);

var IconProgressCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconProgressCheck
});

var IconProgressDown = createReactComponent("outline", "progress-down", "IconProgressDown", [["path", { "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969", "key": "svg-0" }], ["path", { "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554", "key": "svg-1" }], ["path", { "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592", "key": "svg-2" }], ["path", { "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305", "key": "svg-3" }], ["path", { "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356", "key": "svg-4" }], ["path", { "d": "M12 9v6", "key": "svg-5" }], ["path", { "d": "M15 12l-3 3l-3 -3", "key": "svg-6" }]]);

var IconProgressDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconProgressDown
});

var IconProgressHelp = createReactComponent("outline", "progress-help", "IconProgressHelp", [["path", { "d": "M12 16v.01", "key": "svg-0" }], ["path", { "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-1" }], ["path", { "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969", "key": "svg-2" }], ["path", { "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554", "key": "svg-3" }], ["path", { "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592", "key": "svg-4" }], ["path", { "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305", "key": "svg-5" }], ["path", { "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356", "key": "svg-6" }]]);

var IconProgressHelp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconProgressHelp
});

var IconProgressX = createReactComponent("outline", "progress-x", "IconProgressX", [["path", { "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969", "key": "svg-0" }], ["path", { "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554", "key": "svg-1" }], ["path", { "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592", "key": "svg-2" }], ["path", { "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305", "key": "svg-3" }], ["path", { "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356", "key": "svg-4" }], ["path", { "d": "M14 14l-4 -4", "key": "svg-5" }], ["path", { "d": "M10 14l4 -4", "key": "svg-6" }]]);

var IconProgressX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconProgressX
});

var IconProgress = createReactComponent("outline", "progress", "IconProgress", [["path", { "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969", "key": "svg-0" }], ["path", { "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554", "key": "svg-1" }], ["path", { "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592", "key": "svg-2" }], ["path", { "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305", "key": "svg-3" }], ["path", { "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356", "key": "svg-4" }]]);

var IconProgress$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconProgress
});

var IconPrompt = createReactComponent("outline", "prompt", "IconPrompt", [["path", { "d": "M5 7l5 5l-5 5", "key": "svg-0" }], ["path", { "d": "M13 17l6 0", "key": "svg-1" }]]);

var IconPrompt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPrompt
});

var IconProng = createReactComponent("outline", "prong", "IconProng", [["path", { "d": "M10.2 10.2l6.3 6.3", "key": "svg-0" }], ["path", { "d": "M19.347 16.575l1.08 1.079a1.96 1.96 0 0 1 -2.773 2.772l-1.08 -1.079a1.96 1.96 0 0 1 2.773 -2.772z", "key": "svg-1" }], ["path", { "d": "M3 7l3.05 3.15a2.9 2.9 0 0 0 4.1 -4.1l-3.15 -3.05", "key": "svg-2" }]]);

var IconProng$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconProng
});

var IconPropellerOff = createReactComponent("outline", "propeller-off", "IconPropellerOff", [["path", { "d": "M10.448 10.432a3 3 0 1 0 4.106 4.143", "key": "svg-0" }], ["path", { "d": "M14.272 10.272c.66 -1.459 1.058 -2.888 1.198 -4.286c.22 -1.63 -.762 -2.986 -3.47 -2.986c-1.94 0 -3 .696 -3.355 1.69m.697 4.653c.145 .384 .309 .77 .491 1.157", "key": "svg-1" }], ["path", { "d": "M13.169 16.751c.97 1.395 2.057 2.523 3.257 3.386c1.02 .789 2.265 .853 3.408 -.288m1.479 -2.493c.492 -1.634 -.19 -2.726 -1.416 -3.229c-.82 -.37 -1.703 -.654 -2.65 -.852", "key": "svg-2" }], ["path", { "d": "M8.664 13c-1.693 .143 -3.213 .52 -4.56 1.128c-1.522 .623 -2.206 2.153 -.852 4.498s3.02 2.517 4.321 1.512c1.2 -.863 2.287 -1.991 3.258 -3.386", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconPropellerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPropellerOff
});

var IconPropeller = createReactComponent("outline", "propeller", "IconPropeller", [["path", { "d": "M12 13m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M14.167 10.5c.722 -1.538 1.156 -3.043 1.303 -4.514c.22 -1.63 -.762 -2.986 -3.47 -2.986s-3.69 1.357 -3.47 2.986c.147 1.471 .581 2.976 1.303 4.514", "key": "svg-1" }], ["path", { "d": "M13.169 16.751c.97 1.395 2.057 2.523 3.257 3.386c1.3 1 2.967 .833 4.321 -1.512c1.354 -2.345 .67 -3.874 -.85 -4.498c-1.348 -.608 -2.868 -.985 -4.562 -1.128", "key": "svg-2" }], ["path", { "d": "M8.664 13c-1.693 .143 -3.213 .52 -4.56 1.128c-1.522 .623 -2.206 2.153 -.852 4.498s3.02 2.517 4.321 1.512c1.2 -.863 2.287 -1.991 3.258 -3.386", "key": "svg-3" }]]);

var IconPropeller$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPropeller
});

var IconProtocol = createReactComponent("outline", "protocol", "IconProtocol", [["path", { "d": "M15 6l-7 12", "key": "svg-0" }], ["path", { "d": "M20 6l-7 12", "key": "svg-1" }], ["path", { "d": "M5 14v.015", "key": "svg-2" }], ["path", { "d": "M5 10.015v.015", "key": "svg-3" }]]);

var IconProtocol$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconProtocol
});

var IconPumpkinScary = createReactComponent("outline", "pumpkin-scary", "IconPumpkinScary", [["path", { "d": "M9 15l1.5 1l1.5 -1l1.5 1l1.5 -1", "key": "svg-0" }], ["path", { "d": "M10 11h.01", "key": "svg-1" }], ["path", { "d": "M14 11h.01", "key": "svg-2" }], ["path", { "d": "M17 6.082c2.609 .588 3.627 4.162 2.723 7.983c-.903 3.82 -2.75 6.44 -5.359 5.853a3.355 3.355 0 0 1 -.774 -.279a3.728 3.728 0 0 1 -1.59 .361c-.556 0 -1.09 -.127 -1.59 -.362a3.296 3.296 0 0 1 -.774 .28c-2.609 .588 -4.456 -2.033 -5.36 -5.853c-.903 -3.82 .115 -7.395 2.724 -7.983c1.085 -.244 1.575 .066 2.585 .787c.716 -.554 1.54 -.869 2.415 -.869c.876 0 1.699 .315 2.415 .87c1.01 -.722 1.5 -1.032 2.585 -.788z", "key": "svg-3" }], ["path", { "d": "M12 6c0 -1.226 .693 -2.346 1.789 -2.894l.211 -.106", "key": "svg-4" }]]);

var IconPumpkinScary$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPumpkinScary
});

var IconPuzzle2 = createReactComponent("outline", "puzzle-2", "IconPuzzle2", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 4v2.5a.5 .5 0 0 1 -.5 .5a1.5 1.5 0 0 0 0 3a.5 .5 0 0 1 .5 .5v1.5", "key": "svg-1" }], ["path", { "d": "M12 12v1.5a.5 .5 0 0 0 .5 .5a1.5 1.5 0 0 1 0 3a.5 .5 0 0 0 -.5 .5v2.5", "key": "svg-2" }], ["path", { "d": "M20 12h-2.5a.5 .5 0 0 1 -.5 -.5a1.5 1.5 0 0 0 -3 0a.5 .5 0 0 1 -.5 .5h-1.5", "key": "svg-3" }], ["path", { "d": "M12 12h-1.5a.5 .5 0 0 0 -.5 .5a1.5 1.5 0 0 1 -3 0a.5 .5 0 0 0 -.5 -.5h-2.5", "key": "svg-4" }]]);

var IconPuzzle2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPuzzle2
});

var IconPuzzleOff = createReactComponent("outline", "puzzle-off", "IconPuzzleOff", [["path", { "d": "M8.18 4.171a2 2 0 0 1 3.82 .829v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 .819 3.825m-2.819 1.175v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 1 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 1 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconPuzzleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPuzzleOff
});

var IconPuzzle = createReactComponent("outline", "puzzle", "IconPuzzle", [["path", { "d": "M4 7h3a1 1 0 0 0 1 -1v-1a2 2 0 0 1 4 0v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 0 4h-1a1 1 0 0 0 -1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 0 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 0 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1", "key": "svg-0" }]]);

var IconPuzzle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPuzzle
});

var IconPyramidOff = createReactComponent("outline", "pyramid-off", "IconPyramidOff", [["path", { "d": "M21.384 17.373a1.004 1.004 0 0 0 -.013 -1.091l-8.54 -13.836a.999 .999 0 0 0 -1.664 0l-1.8 2.917m-1.531 2.48l-5.209 8.439a1.005 1.005 0 0 0 .386 1.452l8.092 4.054a1.994 1.994 0 0 0 1.789 0l5.903 -2.958", "key": "svg-0" }], ["path", { "d": "M12 2v6m0 4v10", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconPyramidOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPyramidOff
});

var IconPyramidPlus = createReactComponent("outline", "pyramid-plus", "IconPyramidPlus", [["path", { "d": "M18.719 11.985l-5.889 -9.539a.999 .999 0 0 0 -1.664 0l-8.54 13.836a1.005 1.005 0 0 0 .386 1.452l8.092 4.054a1.994 1.994 0 0 0 1.789 0l.149 -.074", "key": "svg-0" }], ["path", { "d": "M12 2v20", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconPyramidPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPyramidPlus
});

var IconPyramid = createReactComponent("outline", "pyramid", "IconPyramid", [["path", { "d": "M11.105 21.788a1.994 1.994 0 0 0 1.789 0l8.092 -4.054c.538 -.27 .718 -.951 .385 -1.452l-8.54 -13.836a.999 .999 0 0 0 -1.664 0l-8.54 13.836a1.005 1.005 0 0 0 .386 1.452l8.092 4.054z", "key": "svg-0" }], ["path", { "d": "M12 2v20", "key": "svg-1" }]]);

var IconPyramid$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPyramid
});

var IconQrcodeOff = createReactComponent("outline", "qrcode-off", "IconQrcodeOff", [["path", { "d": "M8 4h1a1 1 0 0 1 1 1v1m-.297 3.711a1 1 0 0 1 -.703 .289h-4a1 1 0 0 1 -1 -1v-4c0 -.275 .11 -.524 .29 -.705", "key": "svg-0" }], ["path", { "d": "M7 17v.01", "key": "svg-1" }], ["path", { "d": "M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M7 7v.01", "key": "svg-3" }], ["path", { "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-4" }], ["path", { "d": "M17 7v.01", "key": "svg-5" }], ["path", { "d": "M20 14v.01", "key": "svg-6" }], ["path", { "d": "M14 14v3", "key": "svg-7" }], ["path", { "d": "M14 20h3", "key": "svg-8" }], ["path", { "d": "M3 3l18 18", "key": "svg-9" }]]);

var IconQrcodeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconQrcodeOff
});

var IconQrcode = createReactComponent("outline", "qrcode", "IconQrcode", [["path", { "d": "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M7 17l0 .01", "key": "svg-1" }], ["path", { "d": "M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M7 7l0 .01", "key": "svg-3" }], ["path", { "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-4" }], ["path", { "d": "M17 7l0 .01", "key": "svg-5" }], ["path", { "d": "M14 14l3 0", "key": "svg-6" }], ["path", { "d": "M20 14l0 .01", "key": "svg-7" }], ["path", { "d": "M14 14l0 3", "key": "svg-8" }], ["path", { "d": "M14 20l3 0", "key": "svg-9" }], ["path", { "d": "M17 17l3 0", "key": "svg-10" }], ["path", { "d": "M20 17l0 3", "key": "svg-11" }]]);

var IconQrcode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconQrcode
});

var IconQuestionMark = createReactComponent("outline", "question-mark", "IconQuestionMark", [["path", { "d": "M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4", "key": "svg-0" }], ["path", { "d": "M12 19l0 .01", "key": "svg-1" }]]);

var IconQuestionMark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconQuestionMark
});

var IconQuoteOff = createReactComponent("outline", "quote-off", "IconQuoteOff", [["path", { "d": "M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1m4 4v3c0 2.667 -1.333 4.333 -4 5", "key": "svg-0" }], ["path", { "d": "M19 11h-4m-1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 .66 -.082 1.26 -.245 1.798m-1.653 2.29c-.571 .4 -1.272 .704 -2.102 .912", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconQuoteOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconQuoteOff
});

var IconQuote = createReactComponent("outline", "quote", "IconQuote", [["path", { "d": "M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5", "key": "svg-0" }], ["path", { "d": "M19 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5", "key": "svg-1" }]]);

var IconQuote$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconQuote
});

var IconQuotes = createReactComponent("outline", "quotes", "IconQuotes", [["path", { "d": "M4 12c-1.333 -1.854 -1.333 -4.146 0 -6", "key": "svg-0" }], ["path", { "d": "M8 12c-1.333 -1.854 -1.333 -4.146 0 -6", "key": "svg-1" }], ["path", { "d": "M16 18c1.333 -1.854 1.333 -4.146 0 -6", "key": "svg-2" }], ["path", { "d": "M20 18c1.333 -1.854 1.333 -4.146 0 -6", "key": "svg-3" }]]);

var IconQuotes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconQuotes
});

var IconRadar2 = createReactComponent("outline", "radar-2", "IconRadar2", [["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M15.51 15.56a5 5 0 1 0 -3.51 1.44", "key": "svg-1" }], ["path", { "d": "M18.832 17.86a9 9 0 1 0 -6.832 3.14", "key": "svg-2" }], ["path", { "d": "M12 12v9", "key": "svg-3" }]]);

var IconRadar2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadar2
});

var IconRadarOff = createReactComponent("outline", "radar-off", "IconRadarOff", [["path", { "d": "M11.291 11.295a1 1 0 0 0 .709 1.705v8c2.488 0 4.74 -1.01 6.37 -2.642m1.675 -2.319a8.962 8.962 0 0 0 .955 -4.039h-5", "key": "svg-0" }], ["path", { "d": "M16 9a5 5 0 0 0 -5.063 -1.88m-2.466 1.347a5 5 0 0 0 .53 7.535", "key": "svg-1" }], ["path", { "d": "M20.486 9a9 9 0 0 0 -12.525 -5.032m-2.317 1.675a9 9 0 0 0 3.36 14.852", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconRadarOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadarOff
});

var IconRadar = createReactComponent("outline", "radar", "IconRadar", [["path", { "d": "M21 12h-8a1 1 0 1 0 -1 1v8a9 9 0 0 0 9 -9", "key": "svg-0" }], ["path", { "d": "M16 9a5 5 0 1 0 -7 7", "key": "svg-1" }], ["path", { "d": "M20.486 9a9 9 0 1 0 -11.482 11.495", "key": "svg-2" }]]);

var IconRadar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadar
});

var IconRadioOff = createReactComponent("outline", "radio-off", "IconRadioOff", [["path", { "d": "M14 3l-4.986 2m-2.875 1.15l-1.51 .604a1 1 0 0 0 -.629 .928v11.323a1 1 0 0 0 1 1h14a1 1 0 0 0 .708 -.294m.292 -3.706v-8a1 1 0 0 0 -1 -1h-8m-4 0h-2.5", "key": "svg-0" }], ["path", { "d": "M4 12h8m4 0h4", "key": "svg-1" }], ["path", { "d": "M7 12v-2", "key": "svg-2" }], ["path", { "d": "M13 16v.01", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconRadioOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadioOff
});

var IconRadio = createReactComponent("outline", "radio", "IconRadio", [["path", { "d": "M14 3l-9.371 3.749a1 1 0 0 0 -.629 .928v11.323a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-11a1 1 0 0 0 -1 -1h-14.5", "key": "svg-0" }], ["path", { "d": "M4 12h16", "key": "svg-1" }], ["path", { "d": "M7 12v-2", "key": "svg-2" }], ["path", { "d": "M17 16v.01", "key": "svg-3" }], ["path", { "d": "M13 16v.01", "key": "svg-4" }]]);

var IconRadio$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadio
});

var IconRadioactiveOff = createReactComponent("outline", "radioactive-off", "IconRadioactiveOff", [["path", { "d": "M14.118 14.127c-.182 .181 -.39 .341 -.618 .473l3 5.19a9 9 0 0 0 1.856 -1.423m1.68 -2.32a8.993 8.993 0 0 0 .964 -4.047h-5", "key": "svg-0" }], ["path", { "d": "M13.5 9.4l3 -5.19a9 9 0 0 0 -8.536 -.25", "key": "svg-1" }], ["path", { "d": "M10.5 14.6l-3 5.19a9 9 0 0 1 -4.5 -7.79h6a3 3 0 0 0 1.5 2.6", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconRadioactiveOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadioactiveOff
});

var IconRadioactive = createReactComponent("outline", "radioactive", "IconRadioactive", [["path", { "d": "M13.5 14.6l3 5.19a9 9 0 0 0 4.5 -7.79h-6a3 3 0 0 1 -1.5 2.6", "key": "svg-0" }], ["path", { "d": "M13.5 9.4l3 -5.19a9 9 0 0 0 -9 0l3 5.19a3 3 0 0 1 3 0", "key": "svg-1" }], ["path", { "d": "M10.5 14.6l-3 5.19a9 9 0 0 1 -4.5 -7.79h6a3 3 0 0 0 1.5 2.6", "key": "svg-2" }]]);

var IconRadioactive$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadioactive
});

var IconRadiusBottomLeft = createReactComponent("outline", "radius-bottom-left", "IconRadiusBottomLeft", [["path", { "d": "M19 19h-6a8 8 0 0 1 -8 -8v-6", "key": "svg-0" }]]);

var IconRadiusBottomLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadiusBottomLeft
});

var IconRadiusBottomRight = createReactComponent("outline", "radius-bottom-right", "IconRadiusBottomRight", [["path", { "d": "M19 5v6a8 8 0 0 1 -8 8h-6", "key": "svg-0" }]]);

var IconRadiusBottomRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadiusBottomRight
});

var IconRadiusTopLeft = createReactComponent("outline", "radius-top-left", "IconRadiusTopLeft", [["path", { "d": "M5 19v-6a8 8 0 0 1 8 -8h6", "key": "svg-0" }]]);

var IconRadiusTopLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadiusTopLeft
});

var IconRadiusTopRight = createReactComponent("outline", "radius-top-right", "IconRadiusTopRight", [["path", { "d": "M5 5h6a8 8 0 0 1 8 8v6", "key": "svg-0" }]]);

var IconRadiusTopRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadiusTopRight
});

var IconRainbowOff = createReactComponent("outline", "rainbow-off", "IconRainbowOff", [["path", { "d": "M22 17c0 -5.523 -4.477 -10 -10 -10c-.308 0 -.613 .014 -.914 .041m-3.208 .845a10 10 0 0 0 -5.878 9.114", "key": "svg-0" }], ["path", { "d": "M11.088 11.069a6 6 0 0 0 -5.088 5.931", "key": "svg-1" }], ["path", { "d": "M14 17a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconRainbowOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRainbowOff
});

var IconRainbow = createReactComponent("outline", "rainbow", "IconRainbow", [["path", { "d": "M22 17c0 -5.523 -4.477 -10 -10 -10s-10 4.477 -10 10", "key": "svg-0" }], ["path", { "d": "M18 17a6 6 0 1 0 -12 0", "key": "svg-1" }], ["path", { "d": "M14 17a2 2 0 1 0 -4 0", "key": "svg-2" }]]);

var IconRainbow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRainbow
});

var IconRating12Plus = createReactComponent("outline", "rating-12-plus", "IconRating12Plus", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M7 15v-6", "key": "svg-1" }], ["path", { "d": "M15.5 12h3", "key": "svg-2" }], ["path", { "d": "M17 10.5v3", "key": "svg-3" }], ["path", { "d": "M10 10.5a1.5 1.5 0 0 1 3 0c0 .443 -.313 .989 -.612 1.393l-2.388 3.107h3", "key": "svg-4" }]]);

var IconRating12Plus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRating12Plus
});

var IconRating14Plus = createReactComponent("outline", "rating-14-plus", "IconRating14Plus", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M7 15v-6", "key": "svg-1" }], ["path", { "d": "M15.5 12h3", "key": "svg-2" }], ["path", { "d": "M17 10.5v3", "key": "svg-3" }], ["path", { "d": "M12.5 15v-6m-2.5 0v4h3", "key": "svg-4" }]]);

var IconRating14Plus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRating14Plus
});

var IconRating16Plus = createReactComponent("outline", "rating-16-plus", "IconRating16Plus", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M11.5 13.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0", "key": "svg-1" }], ["path", { "d": "M7 15v-6", "key": "svg-2" }], ["path", { "d": "M15.5 12h3", "key": "svg-3" }], ["path", { "d": "M17 10.5v3", "key": "svg-4" }], ["path", { "d": "M10 13.5v-3a1.5 1.5 0 0 1 1.5 -1.5h1", "key": "svg-5" }]]);

var IconRating16Plus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRating16Plus
});

var IconRating18Plus = createReactComponent("outline", "rating-18-plus", "IconRating18Plus", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M11.5 10.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0", "key": "svg-1" }], ["path", { "d": "M11.5 13.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0", "key": "svg-2" }], ["path", { "d": "M7 15v-6", "key": "svg-3" }], ["path", { "d": "M15.5 12h3", "key": "svg-4" }], ["path", { "d": "M17 10.5v3", "key": "svg-5" }]]);

var IconRating18Plus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRating18Plus
});

var IconRating21Plus = createReactComponent("outline", "rating-21-plus", "IconRating21Plus", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M13 15v-6", "key": "svg-1" }], ["path", { "d": "M15.5 12h3", "key": "svg-2" }], ["path", { "d": "M17 10.5v3", "key": "svg-3" }], ["path", { "d": "M7 10.5a1.5 1.5 0 0 1 3 0c0 .443 -.313 .989 -.612 1.393l-2.388 3.107h3", "key": "svg-4" }]]);

var IconRating21Plus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRating21Plus
});

var IconRazorElectric = createReactComponent("outline", "razor-electric", "IconRazorElectric", [["path", { "d": "M8 3v2", "key": "svg-0" }], ["path", { "d": "M12 3v2", "key": "svg-1" }], ["path", { "d": "M16 3v2", "key": "svg-2" }], ["path", { "d": "M9 12v6a3 3 0 0 0 6 0v-6h-6z", "key": "svg-3" }], ["path", { "d": "M8 5h8l-1 4h-6z", "key": "svg-4" }], ["path", { "d": "M12 17v1", "key": "svg-5" }]]);

var IconRazorElectric$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRazorElectric
});

var IconRazor = createReactComponent("outline", "razor", "IconRazor", [["path", { "d": "M7 3h10v4h-10z", "key": "svg-0" }], ["path", { "d": "M12 7v4", "key": "svg-1" }], ["path", { "d": "M12 11a2 2 0 0 1 2 2v6a2 2 0 1 1 -4 0v-6a2 2 0 0 1 2 -2z", "key": "svg-2" }]]);

var IconRazor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRazor
});

var IconReceipt2 = createReactComponent("outline", "receipt-2", "IconReceipt2", [["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2", "key": "svg-0" }], ["path", { "d": "M14 8h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5m2 0v1.5m0 -9v1.5", "key": "svg-1" }]]);

var IconReceipt2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceipt2
});

var IconReceiptBitcoin = createReactComponent("outline", "receipt-bitcoin", "IconReceiptBitcoin", [["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2", "key": "svg-0" }], ["path", { "d": "M9 7h4.09c1.055 0 1.91 .895 1.91 2s-.855 2 -1.91 2c1.055 0 1.91 .895 1.91 2s-.855 2 -1.91 2h-4.09", "key": "svg-1" }], ["path", { "d": "M10 11h4", "key": "svg-2" }], ["path", { "d": "M10 6v10v-9", "key": "svg-3" }], ["path", { "d": "M13 6v1", "key": "svg-4" }], ["path", { "d": "M13 15v1", "key": "svg-5" }]]);

var IconReceiptBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceiptBitcoin
});

var IconReceiptDollar = createReactComponent("outline", "receipt-dollar", "IconReceiptDollar", [["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2", "key": "svg-0" }], ["path", { "d": "M14.8 8a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1", "key": "svg-1" }], ["path", { "d": "M12 6v10", "key": "svg-2" }]]);

var IconReceiptDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceiptDollar
});

var IconReceiptEuro = createReactComponent("outline", "receipt-euro", "IconReceiptEuro", [["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2", "key": "svg-0" }], ["path", { "d": "M15 7.8c-.523 -.502 -1.172 -.8 -1.875 -.8c-1.727 0 -3.125 1.791 -3.125 4s1.398 4 3.125 4c.703 0 1.352 -.298 1.874 -.8", "key": "svg-1" }], ["path", { "d": "M9 11h4", "key": "svg-2" }]]);

var IconReceiptEuro$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceiptEuro
});

var IconReceiptOff = createReactComponent("outline", "receipt-off", "IconReceiptOff", [["path", { "d": "M5 21v-16m2 -2h10a2 2 0 0 1 2 2v10m0 4.01v1.99l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2", "key": "svg-0" }], ["path", { "d": "M11 7l4 0", "key": "svg-1" }], ["path", { "d": "M9 11l2 0", "key": "svg-2" }], ["path", { "d": "M13 15l2 0", "key": "svg-3" }], ["path", { "d": "M15 11l0 .01", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconReceiptOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceiptOff
});

var IconReceiptPound = createReactComponent("outline", "receipt-pound", "IconReceiptPound", [["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2", "key": "svg-0" }], ["path", { "d": "M15 9a2 2 0 1 0 -4 0v4a2 2 0 0 1 -2 2h6", "key": "svg-1" }], ["path", { "d": "M9 12h4", "key": "svg-2" }]]);

var IconReceiptPound$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceiptPound
});

var IconReceiptRefund = createReactComponent("outline", "receipt-refund", "IconReceiptRefund", [["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2", "key": "svg-0" }], ["path", { "d": "M15 14v-2a2 2 0 0 0 -2 -2h-4l2 -2m0 4l-2 -2", "key": "svg-1" }]]);

var IconReceiptRefund$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceiptRefund
});

var IconReceiptRupee = createReactComponent("outline", "receipt-rupee", "IconReceiptRupee", [["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2", "key": "svg-0" }], ["path", { "d": "M15 7h-6h1a3 3 0 0 1 0 6h-1l3 3", "key": "svg-1" }], ["path", { "d": "M9 10h6", "key": "svg-2" }]]);

var IconReceiptRupee$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceiptRupee
});

var IconReceiptTax = createReactComponent("outline", "receipt-tax", "IconReceiptTax", [["path", { "d": "M9 14l6 -6", "key": "svg-0" }], ["circle", { "cx": "9.5", "cy": "8.5", "r": ".5", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "14.5", "cy": "13.5", "r": ".5", "fill": "currentColor", "key": "svg-2" }], ["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2", "key": "svg-3" }]]);

var IconReceiptTax$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceiptTax
});

var IconReceiptYen = createReactComponent("outline", "receipt-yen", "IconReceiptYen", [["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2", "key": "svg-0" }], ["path", { "d": "M9 11h6", "key": "svg-1" }], ["path", { "d": "M9 14h6", "key": "svg-2" }], ["path", { "d": "M9 7l3 4.5", "key": "svg-3" }], ["path", { "d": "M15 7l-3 4.5v4.5", "key": "svg-4" }]]);

var IconReceiptYen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceiptYen
});

var IconReceiptYuan = createReactComponent("outline", "receipt-yuan", "IconReceiptYuan", [["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2", "key": "svg-0" }], ["path", { "d": "M9 12h6", "key": "svg-1" }], ["path", { "d": "M9 7l3 4.5", "key": "svg-2" }], ["path", { "d": "M15 7l-3 4.5v4.5", "key": "svg-3" }]]);

var IconReceiptYuan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceiptYuan
});

var IconReceipt = createReactComponent("outline", "receipt", "IconReceipt", [["path", { "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2m4 -14h6m-6 4h6m-2 4h2", "key": "svg-0" }]]);

var IconReceipt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceipt
});

var IconRecharging = createReactComponent("outline", "recharging", "IconRecharging", [["path", { "d": "M7.038 4.5a9 9 0 0 0 -2.495 2.47", "key": "svg-0" }], ["path", { "d": "M3.186 10.209a9 9 0 0 0 0 3.508", "key": "svg-1" }], ["path", { "d": "M4.5 16.962a9 9 0 0 0 2.47 2.495", "key": "svg-2" }], ["path", { "d": "M10.209 20.814a9 9 0 0 0 3.5 0", "key": "svg-3" }], ["path", { "d": "M16.962 19.5a9 9 0 0 0 2.495 -2.47", "key": "svg-4" }], ["path", { "d": "M20.814 13.791a9 9 0 0 0 0 -3.508", "key": "svg-5" }], ["path", { "d": "M19.5 7.038a9 9 0 0 0 -2.47 -2.495", "key": "svg-6" }], ["path", { "d": "M13.791 3.186a9 9 0 0 0 -3.508 -.02", "key": "svg-7" }], ["path", { "d": "M12 8l-2 4h4l-2 4", "key": "svg-8" }], ["path", { "d": "M12 21a9 9 0 0 0 0 -18", "key": "svg-9" }]]);

var IconRecharging$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRecharging
});

var IconRecordMailOff = createReactComponent("outline", "record-mail-off", "IconRecordMailOff", [["path", { "d": "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M18.569 14.557a3 3 0 1 0 -4.113 -4.149", "key": "svg-1" }], ["path", { "d": "M7 15h8", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconRecordMailOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRecordMailOff
});

var IconRecordMail = createReactComponent("outline", "record-mail", "IconRecordMail", [["path", { "d": "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M7 15l10 0", "key": "svg-2" }]]);

var IconRecordMail$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRecordMail
});

var IconRectangleRoundedBottom = createReactComponent("outline", "rectangle-rounded-bottom", "IconRectangleRoundedBottom", [["path", { "d": "M9 18h6a6 6 0 0 0 6 -6v-5a1 1 0 0 0 -1 -1h-16a1 1 0 0 0 -1 1v5a6 6 0 0 0 6 6z", "key": "svg-0" }]]);

var IconRectangleRoundedBottom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRectangleRoundedBottom
});

var IconRectangleRoundedTop = createReactComponent("outline", "rectangle-rounded-top", "IconRectangleRoundedTop", [["path", { "d": "M9 6h6a6 6 0 0 1 6 6v5a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-5a6 6 0 0 1 6 -6z", "key": "svg-0" }]]);

var IconRectangleRoundedTop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRectangleRoundedTop
});

var IconRectangleVertical = createReactComponent("outline", "rectangle-vertical", "IconRectangleVertical", [["path", { "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconRectangleVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRectangleVertical
});

var IconRectangle = createReactComponent("outline", "rectangle", "IconRectangle", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconRectangle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRectangle
});

var IconRectangularPrismOff = createReactComponent("outline", "rectangular-prism-off", "IconRectangularPrismOff", [["path", { "d": "M8.18 8.18l-4.18 2.093c-.619 .355 -1 1.01 -1 1.718v5.018c0 .709 .381 1.363 1 1.717l4 2.008a2.016 2.016 0 0 0 2 0l7.146 -3.578m2.67 -1.337l.184 -.093c.619 -.355 1 -1.01 1 -1.718v-5.018a1.98 1.98 0 0 0 -1 -1.717l-4 -2.008a2.016 2.016 0 0 0 -2 0l-3.146 1.575", "key": "svg-0" }], ["path", { "d": "M9 21v-7.5", "key": "svg-1" }], ["path", { "d": "M9 13.5l3.048 -1.458m2.71 -1.296l5.742 -2.746", "key": "svg-2" }], ["path", { "d": "M3.5 11l5.5 2.5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconRectangularPrismOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRectangularPrismOff
});

var IconRectangularPrismPlus = createReactComponent("outline", "rectangular-prism-plus", "IconRectangularPrismPlus", [["path", { "d": "M21 12.5v-3.509a1.98 1.98 0 0 0 -1 -1.717l-4 -2.008a2.016 2.016 0 0 0 -2 0l-10 5.007c-.619 .355 -1 1.01 -1 1.718v5.018c0 .709 .381 1.363 1 1.717l4 2.008a2.016 2.016 0 0 0 2 0l2.062 -1.032", "key": "svg-0" }], ["path", { "d": "M9 21v-7.5", "key": "svg-1" }], ["path", { "d": "M9 13.5l11.5 -5.5", "key": "svg-2" }], ["path", { "d": "M3.5 11l5.5 2.5", "key": "svg-3" }], ["path", { "d": "M16 19h6", "key": "svg-4" }], ["path", { "d": "M19 16v6", "key": "svg-5" }]]);

var IconRectangularPrismPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRectangularPrismPlus
});

var IconRectangularPrism = createReactComponent("outline", "rectangular-prism", "IconRectangularPrism", [["path", { "d": "M21 14.008v-5.018a1.98 1.98 0 0 0 -1 -1.717l-4 -2.008a2.016 2.016 0 0 0 -2 0l-10 5.008c-.619 .355 -1 1.01 -1 1.718v5.018c0 .709 .381 1.363 1 1.717l4 2.008a2.016 2.016 0 0 0 2 0l10 -5.008c.619 -.355 1 -1.01 1 -1.718z", "key": "svg-0" }], ["path", { "d": "M9 21v-7.5", "key": "svg-1" }], ["path", { "d": "M9 13.5l11.5 -5.5", "key": "svg-2" }], ["path", { "d": "M3.5 11l5.5 2.5", "key": "svg-3" }]]);

var IconRectangularPrism$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRectangularPrism
});

var IconRecycleOff = createReactComponent("outline", "recycle-off", "IconRecycleOff", [["path", { "d": "M12 17l-2 2l2 2m-2 -2h9m1.896 -2.071a2 2 0 0 0 -.146 -.679l-.55 -1", "key": "svg-0" }], ["path", { "d": "M8.536 11l-.732 -2.732l-2.732 .732m2.732 -.732l-4.5 7.794a2 2 0 0 0 1.506 2.89l1.141 .024", "key": "svg-1" }], ["path", { "d": "M15.464 11l2.732 .732l.732 -2.732m-.732 2.732l-4.5 -7.794a2 2 0 0 0 -3.256 -.14l-.591 .976", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconRecycleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRecycleOff
});

var IconRecycle = createReactComponent("outline", "recycle", "IconRecycle", [["path", { "d": "M12 17l-2 2l2 2", "key": "svg-0" }], ["path", { "d": "M10 19h9a2 2 0 0 0 1.75 -2.75l-.55 -1", "key": "svg-1" }], ["path", { "d": "M8.536 11l-.732 -2.732l-2.732 .732", "key": "svg-2" }], ["path", { "d": "M7.804 8.268l-4.5 7.794a2 2 0 0 0 1.506 2.89l1.141 .024", "key": "svg-3" }], ["path", { "d": "M15.464 11l2.732 .732l.732 -2.732", "key": "svg-4" }], ["path", { "d": "M18.196 11.732l-4.5 -7.794a2 2 0 0 0 -3.256 -.14l-.591 .976", "key": "svg-5" }]]);

var IconRecycle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRecycle
});

var IconRefreshAlert = createReactComponent("outline", "refresh-alert", "IconRefreshAlert", [["path", { "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4", "key": "svg-0" }], ["path", { "d": "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4", "key": "svg-1" }], ["path", { "d": "M12 9l0 3", "key": "svg-2" }], ["path", { "d": "M12 15l.01 0", "key": "svg-3" }]]);

var IconRefreshAlert$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRefreshAlert
});

var IconRefreshDot = createReactComponent("outline", "refresh-dot", "IconRefreshDot", [["path", { "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4", "key": "svg-0" }], ["path", { "d": "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4", "key": "svg-1" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }]]);

var IconRefreshDot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRefreshDot
});

var IconRefreshOff = createReactComponent("outline", "refresh-off", "IconRefreshOff", [["path", { "d": "M20 11a8.1 8.1 0 0 0 -11.271 -6.305m-2.41 1.624a8.083 8.083 0 0 0 -1.819 2.681m-.5 -4v4h4", "key": "svg-0" }], ["path", { "d": "M4 13a8.1 8.1 0 0 0 13.671 4.691m2.329 -1.691v-1h-1", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconRefreshOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRefreshOff
});

var IconRefresh = createReactComponent("outline", "refresh", "IconRefresh", [["path", { "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4", "key": "svg-0" }], ["path", { "d": "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4", "key": "svg-1" }]]);

var IconRefresh$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRefresh
});

var IconRegexOff = createReactComponent("outline", "regex-off", "IconRegexOff", [["path", { "d": "M6.5 15a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0 -5z", "key": "svg-0" }], ["path", { "d": "M17 7.875l3 -1.687", "key": "svg-1" }], ["path", { "d": "M17 7.875v3.375", "key": "svg-2" }], ["path", { "d": "M17 7.875l-3 -1.687", "key": "svg-3" }], ["path", { "d": "M17 7.875l3 1.688", "key": "svg-4" }], ["path", { "d": "M17 4.5v3.375", "key": "svg-5" }], ["path", { "d": "M17 7.875l-3 1.688", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconRegexOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRegexOff
});

var IconRegex = createReactComponent("outline", "regex", "IconRegex", [["path", { "d": "M6.5 15a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0 -5z", "key": "svg-0" }], ["path", { "d": "M17 7.875l3 -1.687", "key": "svg-1" }], ["path", { "d": "M17 7.875v3.375", "key": "svg-2" }], ["path", { "d": "M17 7.875l-3 -1.687", "key": "svg-3" }], ["path", { "d": "M17 7.875l3 1.688", "key": "svg-4" }], ["path", { "d": "M17 4.5v3.375", "key": "svg-5" }], ["path", { "d": "M17 7.875l-3 1.688", "key": "svg-6" }]]);

var IconRegex$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRegex
});

var IconRegistered = createReactComponent("outline", "registered", "IconRegistered", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 15v-6h2a2 2 0 1 1 0 4h-2", "key": "svg-1" }], ["path", { "d": "M14 15l-2 -2", "key": "svg-2" }]]);

var IconRegistered$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRegistered
});

var IconRelationManyToMany = createReactComponent("outline", "relation-many-to-many", "IconRelationManyToMany", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M15 14v-4l3 4v-4", "key": "svg-1" }], ["path", { "d": "M6 14v-4l3 4v-4", "key": "svg-2" }], ["path", { "d": "M12 10.5l0 .01", "key": "svg-3" }], ["path", { "d": "M12 13.5l0 .01", "key": "svg-4" }]]);

var IconRelationManyToMany$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRelationManyToMany
});

var IconRelationOneToMany = createReactComponent("outline", "relation-one-to-many", "IconRelationOneToMany", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 10h1v4", "key": "svg-1" }], ["path", { "d": "M14 14v-4l3 4v-4", "key": "svg-2" }], ["path", { "d": "M11 10.5l0 .01", "key": "svg-3" }], ["path", { "d": "M11 13.5l0 .01", "key": "svg-4" }]]);

var IconRelationOneToMany$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRelationOneToMany
});

var IconRelationOneToOne = createReactComponent("outline", "relation-one-to-one", "IconRelationOneToOne", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 10h1v4", "key": "svg-1" }], ["path", { "d": "M15 10h1v4", "key": "svg-2" }], ["path", { "d": "M12 10.5l0 .01", "key": "svg-3" }], ["path", { "d": "M12 13.5l0 .01", "key": "svg-4" }]]);

var IconRelationOneToOne$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRelationOneToOne
});

var IconReload = createReactComponent("outline", "reload", "IconReload", [["path", { "d": "M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747", "key": "svg-0" }], ["path", { "d": "M20 4v5h-5", "key": "svg-1" }]]);

var IconReload$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReload
});

var IconReorder = createReactComponent("outline", "reorder", "IconReorder", [["path", { "d": "M3 15m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M10 15m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M17 15m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M5 11v-3a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v3", "key": "svg-3" }], ["path", { "d": "M16.5 8.5l2.5 2.5l2.5 -2.5", "key": "svg-4" }]]);

var IconReorder$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReorder
});

var IconRepeatOff = createReactComponent("outline", "repeat-off", "IconRepeatOff", [["path", { "d": "M4 12v-3c0 -1.336 .873 -2.468 2.08 -2.856m3.92 -.144h10m-3 -3l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M20 12v3a3 3 0 0 1 -.133 .886m-1.99 1.984a3 3 0 0 1 -.877 .13h-13m3 3l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconRepeatOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRepeatOff
});

var IconRepeatOnce = createReactComponent("outline", "repeat-once", "IconRepeatOnce", [["path", { "d": "M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M11 11l1 -1v4", "key": "svg-2" }]]);

var IconRepeatOnce$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRepeatOnce
});

var IconRepeat = createReactComponent("outline", "repeat", "IconRepeat", [["path", { "d": "M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3", "key": "svg-1" }]]);

var IconRepeat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRepeat
});

var IconReplaceOff = createReactComponent("outline", "replace-off", "IconReplaceOff", [["path", { "d": "M7 3h1a1 1 0 0 1 1 1v1m-.303 3.717a1 1 0 0 1 -.697 .283h-4a1 1 0 0 1 -1 -1v-4c0 -.28 .115 -.532 .3 -.714", "key": "svg-0" }], ["path", { "d": "M19 15h1a1 1 0 0 1 1 1v1m-.303 3.717a1 1 0 0 1 -.697 .283h-4a1 1 0 0 1 -1 -1v-4c0 -.28 .115 -.532 .3 -.714", "key": "svg-1" }], ["path", { "d": "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3", "key": "svg-2" }], ["path", { "d": "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconReplaceOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReplaceOff
});

var IconReplaceUser = createReactComponent("outline", "replace-user", "IconReplaceUser", [["path", { "d": "M21 11v-3c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586h-6m0 0l3 3m-3 -3l3 -3", "key": "svg-0" }], ["path", { "d": "M3 13.013v3c0 .53 .211 1.039 .586 1.414c.375 .375 .884 .586 1.414 .586h6m0 0l-3 -3m3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M16 16.502c0 .53 .211 1.039 .586 1.414c.375 .375 .884 .586 1.414 .586c.53 0 1.039 -.211 1.414 -.586c.375 -.375 .586 -.884 .586 -1.414c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586c-.53 0 -1.039 .211 -1.414 .586c-.375 .375 -.586 .884 -.586 1.414z", "key": "svg-2" }], ["path", { "d": "M4 4.502c0 .53 .211 1.039 .586 1.414c.375 .375 .884 .586 1.414 .586c.53 0 1.039 -.211 1.414 -.586c.375 -.375 .586 -.884 .586 -1.414c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586c-.53 0 -1.039 .211 -1.414 .586c-.375 .375 -.586 .884 -.586 1.414z", "key": "svg-3" }], ["path", { "d": "M21 21.499c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586h-2c-.53 0 -1.039 .211 -1.414 .586c-.375 .375 -.586 .884 -.586 1.414", "key": "svg-4" }], ["path", { "d": "M9 9.499c0 -.53 -.211 -1.039 -.586 -1.414c-.375 -.375 -.884 -.586 -1.414 -.586h-2c-.53 0 -1.039 .211 -1.414 .586c-.375 .375 -.586 .884 -.586 1.414", "key": "svg-5" }]]);

var IconReplaceUser$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReplaceUser
});

var IconReplace = createReactComponent("outline", "replace", "IconReplace", [["path", { "d": "M3 3m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M15 15m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3", "key": "svg-2" }], ["path", { "d": "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3", "key": "svg-3" }]]);

var IconReplace$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReplace
});

var IconReportAnalytics = createReactComponent("outline", "report-analytics", "IconReportAnalytics", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M9 17v-5", "key": "svg-2" }], ["path", { "d": "M12 17v-1", "key": "svg-3" }], ["path", { "d": "M15 17v-3", "key": "svg-4" }]]);

var IconReportAnalytics$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReportAnalytics
});

var IconReportMedical = createReactComponent("outline", "report-medical", "IconReportMedical", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M10 14l4 0", "key": "svg-2" }], ["path", { "d": "M12 12l0 4", "key": "svg-3" }]]);

var IconReportMedical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReportMedical
});

var IconReportMoney = createReactComponent("outline", "report-money", "IconReportMoney", [["path", { "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M12 17v1m0 -8v1", "key": "svg-3" }]]);

var IconReportMoney$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReportMoney
});

var IconReportOff = createReactComponent("outline", "report-off", "IconReportOff", [["path", { "d": "M5.576 5.595a2 2 0 0 0 -.576 1.405v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2m0 -4v-8a2 2 0 0 0 -2 -2h-2", "key": "svg-0" }], ["path", { "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 1 1 0 4h-2", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconReportOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReportOff
});

var IconReportSearch = createReactComponent("outline", "report-search", "IconReportSearch", [["path", { "d": "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697", "key": "svg-0" }], ["path", { "d": "M18 12v-5a2 2 0 0 0 -2 -2h-2", "key": "svg-1" }], ["path", { "d": "M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-2" }], ["path", { "d": "M8 11h4", "key": "svg-3" }], ["path", { "d": "M8 15h3", "key": "svg-4" }], ["path", { "d": "M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-5" }], ["path", { "d": "M18.5 19.5l2.5 2.5", "key": "svg-6" }]]);

var IconReportSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReportSearch
});

var IconReport = createReactComponent("outline", "report", "IconReport", [["path", { "d": "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697", "key": "svg-0" }], ["path", { "d": "M18 14v4h4", "key": "svg-1" }], ["path", { "d": "M18 11v-4a2 2 0 0 0 -2 -2h-2", "key": "svg-2" }], ["path", { "d": "M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-3" }], ["path", { "d": "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-4" }], ["path", { "d": "M8 11h4", "key": "svg-5" }], ["path", { "d": "M8 15h3", "key": "svg-6" }]]);

var IconReport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReport
});

var IconReservedLine = createReactComponent("outline", "reserved-line", "IconReservedLine", [["path", { "d": "M9 20h6", "key": "svg-0" }], ["path", { "d": "M12 14v6", "key": "svg-1" }], ["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-2" }], ["path", { "d": "M9 9h6", "key": "svg-3" }]]);

var IconReservedLine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReservedLine
});

var IconResize = createReactComponent("outline", "resize", "IconResize", [["path", { "d": "M4 11v8a1 1 0 0 0 1 1h8m-9 -14v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1", "key": "svg-0" }], ["path", { "d": "M4 12h7a1 1 0 0 1 1 1v7", "key": "svg-1" }]]);

var IconResize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconResize
});

var IconRestore = createReactComponent("outline", "restore", "IconRestore", [["path", { "d": "M3.06 13a9 9 0 1 0 .49 -4.087", "key": "svg-0" }], ["path", { "d": "M3 4.001v5h5", "key": "svg-1" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }]]);

var IconRestore$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRestore
});

var IconRewindBackward10 = createReactComponent("outline", "rewind-backward-10", "IconRewindBackward10", [["path", { "d": "M7 9l-3 -3l3 -3", "key": "svg-0" }], ["path", { "d": "M15.997 17.918a6.002 6.002 0 0 0 -.997 -11.918h-11", "key": "svg-1" }], ["path", { "d": "M6 14v6", "key": "svg-2" }], ["path", { "d": "M9 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-3" }]]);

var IconRewindBackward10$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindBackward10
});

var IconRewindBackward15 = createReactComponent("outline", "rewind-backward-15", "IconRewindBackward15", [["path", { "d": "M8 20h2a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2v-3h3", "key": "svg-0" }], ["path", { "d": "M15 18a6 6 0 1 0 0 -12h-11", "key": "svg-1" }], ["path", { "d": "M5 14v6", "key": "svg-2" }], ["path", { "d": "M7 9l-3 -3l3 -3", "key": "svg-3" }]]);

var IconRewindBackward15$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindBackward15
});

var IconRewindBackward20 = createReactComponent("outline", "rewind-backward-20", "IconRewindBackward20", [["path", { "d": "M19.007 16.466a6 6 0 0 0 -4.007 -10.466h-11", "key": "svg-0" }], ["path", { "d": "M7 9l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M12 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-2" }], ["path", { "d": "M6 14h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2", "key": "svg-3" }]]);

var IconRewindBackward20$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindBackward20
});

var IconRewindBackward30 = createReactComponent("outline", "rewind-backward-30", "IconRewindBackward30", [["path", { "d": "M19.007 16.466a6 6 0 0 0 -4.007 -10.466h-11", "key": "svg-0" }], ["path", { "d": "M12 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-1" }], ["path", { "d": "M6 14h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5", "key": "svg-2" }], ["path", { "d": "M7 9l-3 -3l3 -3", "key": "svg-3" }]]);

var IconRewindBackward30$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindBackward30
});

var IconRewindBackward40 = createReactComponent("outline", "rewind-backward-40", "IconRewindBackward40", [["path", { "d": "M19.007 16.466a6 6 0 0 0 -4.007 -10.466h-11", "key": "svg-0" }], ["path", { "d": "M12 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-1" }], ["path", { "d": "M6 14v2a1 1 0 0 0 1 1h1", "key": "svg-2" }], ["path", { "d": "M9 14v6", "key": "svg-3" }], ["path", { "d": "M7 9l-3 -3l3 -3", "key": "svg-4" }]]);

var IconRewindBackward40$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindBackward40
});

var IconRewindBackward5 = createReactComponent("outline", "rewind-backward-5", "IconRewindBackward5", [["path", { "d": "M15 18a6 6 0 1 0 0 -12h-11", "key": "svg-0" }], ["path", { "d": "M7 9l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M8 20h2a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2v-3h3", "key": "svg-2" }]]);

var IconRewindBackward5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindBackward5
});

var IconRewindBackward50 = createReactComponent("outline", "rewind-backward-50", "IconRewindBackward50", [["path", { "d": "M19.007 16.466a6 6 0 0 0 -4.007 -10.466h-11", "key": "svg-0" }], ["path", { "d": "M12 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-1" }], ["path", { "d": "M6 20h1.5a1.5 1.5 0 0 0 0 -3h-1.5v-3h3", "key": "svg-2" }], ["path", { "d": "M7 9l-3 -3l3 -3", "key": "svg-3" }]]);

var IconRewindBackward50$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindBackward50
});

var IconRewindBackward60 = createReactComponent("outline", "rewind-backward-60", "IconRewindBackward60", [["path", { "d": "M19.007 16.466a6 6 0 0 0 -4.007 -10.466h-11", "key": "svg-0" }], ["path", { "d": "M7 9l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M12 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-2" }], ["path", { "d": "M9 14h-2a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2", "key": "svg-3" }]]);

var IconRewindBackward60$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindBackward60
});

var IconRewindForward10 = createReactComponent("outline", "rewind-forward-10", "IconRewindForward10", [["path", { "d": "M17 9l3 -3l-3 -3", "key": "svg-0" }], ["path", { "d": "M8 17.918a5.997 5.997 0 0 1 -5 -5.918a6 6 0 0 1 6 -6h11", "key": "svg-1" }], ["path", { "d": "M12 14v6", "key": "svg-2" }], ["path", { "d": "M15 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-3" }]]);

var IconRewindForward10$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindForward10
});

var IconRewindForward15 = createReactComponent("outline", "rewind-forward-15", "IconRewindForward15", [["path", { "d": "M17 9l3 -3l-3 -3", "key": "svg-0" }], ["path", { "d": "M9 18a6 6 0 1 1 0 -12h11", "key": "svg-1" }], ["path", { "d": "M16 20h2a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2v-3h3", "key": "svg-2" }], ["path", { "d": "M13 14v6", "key": "svg-3" }]]);

var IconRewindForward15$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindForward15
});

var IconRewindForward20 = createReactComponent("outline", "rewind-forward-20", "IconRewindForward20", [["path", { "d": "M5.007 16.478a6 6 0 0 1 3.993 -10.478h11", "key": "svg-0" }], ["path", { "d": "M15 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-1" }], ["path", { "d": "M17 9l3 -3l-3 -3", "key": "svg-2" }], ["path", { "d": "M9 14h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2", "key": "svg-3" }]]);

var IconRewindForward20$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindForward20
});

var IconRewindForward30 = createReactComponent("outline", "rewind-forward-30", "IconRewindForward30", [["path", { "d": "M5.007 16.478a6 6 0 0 1 3.993 -10.478h11", "key": "svg-0" }], ["path", { "d": "M15 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-1" }], ["path", { "d": "M17 9l3 -3l-3 -3", "key": "svg-2" }], ["path", { "d": "M9 14h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5", "key": "svg-3" }]]);

var IconRewindForward30$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindForward30
});

var IconRewindForward40 = createReactComponent("outline", "rewind-forward-40", "IconRewindForward40", [["path", { "d": "M5.007 16.478a6 6 0 0 1 3.993 -10.478h11", "key": "svg-0" }], ["path", { "d": "M15 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-1" }], ["path", { "d": "M17 9l3 -3l-3 -3", "key": "svg-2" }], ["path", { "d": "M9 14v2a1 1 0 0 0 1 1h1", "key": "svg-3" }], ["path", { "d": "M12 14v6", "key": "svg-4" }]]);

var IconRewindForward40$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindForward40
});

var IconRewindForward5 = createReactComponent("outline", "rewind-forward-5", "IconRewindForward5", [["path", { "d": "M9 18a6 6 0 1 1 0 -12h11", "key": "svg-0" }], ["path", { "d": "M13 20h2a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2v-3h3", "key": "svg-1" }], ["path", { "d": "M17 9l3 -3l-3 -3", "key": "svg-2" }]]);

var IconRewindForward5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindForward5
});

var IconRewindForward50 = createReactComponent("outline", "rewind-forward-50", "IconRewindForward50", [["path", { "d": "M5.007 16.478a6 6 0 0 1 3.993 -10.478h11", "key": "svg-0" }], ["path", { "d": "M15 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-1" }], ["path", { "d": "M17 9l3 -3l-3 -3", "key": "svg-2" }], ["path", { "d": "M9 20h1.5a1.5 1.5 0 0 0 0 -3h-1.5v-3h3", "key": "svg-3" }]]);

var IconRewindForward50$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindForward50
});

var IconRewindForward60 = createReactComponent("outline", "rewind-forward-60", "IconRewindForward60", [["path", { "d": "M5.007 16.478a6 6 0 0 1 3.993 -10.478h11", "key": "svg-0" }], ["path", { "d": "M15 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-1" }], ["path", { "d": "M17 9l3 -3l-3 -3", "key": "svg-2" }], ["path", { "d": "M12 14h-2a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2", "key": "svg-3" }]]);

var IconRewindForward60$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRewindForward60
});

var IconRibbonHealth = createReactComponent("outline", "ribbon-health", "IconRibbonHealth", [["path", { "d": "M7 21s9.286 -9.841 9.286 -13.841a3.864 3.864 0 0 0 -1.182 -3.008a4.13 4.13 0 0 0 -3.104 -1.144a4.13 4.13 0 0 0 -3.104 1.143a3.864 3.864 0 0 0 -1.182 3.01c0 4 9.286 13.84 9.286 13.84", "key": "svg-0" }]]);

var IconRibbonHealth$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRibbonHealth
});

var IconRings = createReactComponent("outline", "rings", "IconRings", [["path", { "d": "M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M7 15v-11", "key": "svg-2" }], ["path", { "d": "M17 15v-11", "key": "svg-3" }], ["path", { "d": "M3 4h18", "key": "svg-4" }]]);

var IconRings$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRings
});

var IconRippleOff = createReactComponent("outline", "ripple-off", "IconRippleOff", [["path", { "d": "M3 7c.915 -.61 1.83 -1.034 2.746 -1.272m4.212 .22c.68 .247 1.361 .598 2.042 1.052c3 2 6 2 9 0", "key": "svg-0" }], ["path", { "d": "M3 17c3 -2 6 -2 9 0c2.092 1.395 4.184 1.817 6.276 1.266", "key": "svg-1" }], ["path", { "d": "M3 12c3 -2 6 -2 9 0m5.482 1.429c1.173 -.171 2.345 -.647 3.518 -1.429", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconRippleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRippleOff
});

var IconRipple = createReactComponent("outline", "ripple", "IconRipple", [["path", { "d": "M3 7c3 -2 6 -2 9 0s6 2 9 0", "key": "svg-0" }], ["path", { "d": "M3 17c3 -2 6 -2 9 0s6 2 9 0", "key": "svg-1" }], ["path", { "d": "M3 12c3 -2 6 -2 9 0s6 2 9 0", "key": "svg-2" }]]);

var IconRipple$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRipple
});

var IconRoadOff = createReactComponent("outline", "road-off", "IconRoadOff", [["path", { "d": "M4 19l3.332 -11.661", "key": "svg-0" }], ["path", { "d": "M16 5l2.806 9.823", "key": "svg-1" }], ["path", { "d": "M12 8v-2", "key": "svg-2" }], ["path", { "d": "M12 13v-1", "key": "svg-3" }], ["path", { "d": "M12 18v-2", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconRoadOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRoadOff
});

var IconRoadSign = createReactComponent("outline", "road-sign", "IconRoadSign", [["path", { "d": "M13.446 2.6l7.955 7.954a2.045 2.045 0 0 1 0 2.892l-7.955 7.955a2.045 2.045 0 0 1 -2.892 0l-7.955 -7.955a2.045 2.045 0 0 1 0 -2.892l7.955 -7.955a2.045 2.045 0 0 1 2.892 0z", "key": "svg-0" }], ["path", { "d": "M9 14v-2c0 -.59 .414 -1 1 -1h5", "key": "svg-1" }], ["path", { "d": "M13 9l2 2l-2 2", "key": "svg-2" }]]);

var IconRoadSign$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRoadSign
});

var IconRoad = createReactComponent("outline", "road", "IconRoad", [["path", { "d": "M4 19l4 -14", "key": "svg-0" }], ["path", { "d": "M16 5l4 14", "key": "svg-1" }], ["path", { "d": "M12 8v-2", "key": "svg-2" }], ["path", { "d": "M12 13v-2", "key": "svg-3" }], ["path", { "d": "M12 18v-2", "key": "svg-4" }]]);

var IconRoad$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRoad
});

var IconRobotFace = createReactComponent("outline", "robot-face", "IconRobotFace", [["path", { "d": "M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M9 16c1 .667 2 1 3 1s2 -.333 3 -1", "key": "svg-1" }], ["path", { "d": "M9 7l-1 -4", "key": "svg-2" }], ["path", { "d": "M15 7l1 -4", "key": "svg-3" }], ["path", { "d": "M9 12v-1", "key": "svg-4" }], ["path", { "d": "M15 12v-1", "key": "svg-5" }]]);

var IconRobotFace$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRobotFace
});

var IconRobotOff = createReactComponent("outline", "robot-off", "IconRobotOff", [["path", { "d": "M8 4h8a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2m-4 0h-4a2 2 0 0 1 -2 -2v-4", "key": "svg-0" }], ["path", { "d": "M12 2v2", "key": "svg-1" }], ["path", { "d": "M9 12v9", "key": "svg-2" }], ["path", { "d": "M15 15v6", "key": "svg-3" }], ["path", { "d": "M5 16l4 -2", "key": "svg-4" }], ["path", { "d": "M9 18h6", "key": "svg-5" }], ["path", { "d": "M14 8v.01", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconRobotOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRobotOff
});

var IconRobot = createReactComponent("outline", "robot", "IconRobot", [["path", { "d": "M6 4m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 2v2", "key": "svg-1" }], ["path", { "d": "M9 12v9", "key": "svg-2" }], ["path", { "d": "M15 12v9", "key": "svg-3" }], ["path", { "d": "M5 16l4 -2", "key": "svg-4" }], ["path", { "d": "M15 14l4 2", "key": "svg-5" }], ["path", { "d": "M9 18h6", "key": "svg-6" }], ["path", { "d": "M10 8v.01", "key": "svg-7" }], ["path", { "d": "M14 8v.01", "key": "svg-8" }]]);

var IconRobot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRobot
});

var IconRocketOff = createReactComponent("outline", "rocket-off", "IconRocketOff", [["path", { "d": "M9.29 9.275a9.03 9.03 0 0 0 -.29 .725a6 6 0 0 0 -5 3a8 8 0 0 1 7 7a6 6 0 0 0 3 -5c.241 -.085 .478 -.18 .708 -.283m2.428 -1.61a9 9 0 0 0 2.864 -6.107a3 3 0 0 0 -3 -3a9 9 0 0 0 -6.107 2.864", "key": "svg-0" }], ["path", { "d": "M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3", "key": "svg-1" }], ["path", { "d": "M15 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconRocketOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRocketOff
});

var IconRocket = createReactComponent("outline", "rocket", "IconRocket", [["path", { "d": "M4 13a8 8 0 0 1 7 7a6 6 0 0 0 3 -5a9 9 0 0 0 6 -8a3 3 0 0 0 -3 -3a9 9 0 0 0 -8 6a6 6 0 0 0 -5 3", "key": "svg-0" }], ["path", { "d": "M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3", "key": "svg-1" }], ["path", { "d": "M15 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }]]);

var IconRocket$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRocket
});

var IconRollerSkating = createReactComponent("outline", "roller-skating", "IconRollerSkating", [["path", { "d": "M5.905 5h3.418a1 1 0 0 1 .928 .629l1.143 2.856a3 3 0 0 0 2.207 1.83l4.717 .926a2.084 2.084 0 0 1 1.682 2.045v.714a1 1 0 0 1 -1 1h-13.895a1 1 0 0 1 -1 -1.1l.8 -8a1 1 0 0 1 1 -.9z", "key": "svg-0" }], ["path", { "d": "M8 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M16 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }]]);

var IconRollerSkating$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRollerSkating
});

var IconRollercoasterOff = createReactComponent("outline", "rollercoaster-off", "IconRollercoasterOff", [["path", { "d": "M3 21a5.55 5.55 0 0 0 5.265 -3.795l.735 -2.205a8.759 8.759 0 0 1 2.35 -3.652m2.403 -1.589a8.76 8.76 0 0 1 3.572 -.759h3.675", "key": "svg-0" }], ["path", { "d": "M20 9v7m0 4v1", "key": "svg-1" }], ["path", { "d": "M8 21v-3", "key": "svg-2" }], ["path", { "d": "M12 21v-9", "key": "svg-3" }], ["path", { "d": "M16 9.5v2.5m0 4v5", "key": "svg-4" }], ["path", { "d": "M15 3h5v3h-5z", "key": "svg-5" }], ["path", { "d": "M9.446 5.415l.554 -.415l2 2.5l-.285 .213m-2.268 1.702l-1.447 1.085l-1.8 -.5l-.2 -2l1.139 -.854", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconRollercoasterOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRollercoasterOff
});

var IconRollercoaster = createReactComponent("outline", "rollercoaster", "IconRollercoaster", [["path", { "d": "M3 21a5.55 5.55 0 0 0 5.265 -3.795l.735 -2.205a8.775 8.775 0 0 1 8.325 -6h3.675", "key": "svg-0" }], ["path", { "d": "M20 9v12", "key": "svg-1" }], ["path", { "d": "M8 21v-3", "key": "svg-2" }], ["path", { "d": "M12 21v-10", "key": "svg-3" }], ["path", { "d": "M16 9.5v11.5", "key": "svg-4" }], ["path", { "d": "M15 3h5v3h-5z", "key": "svg-5" }], ["path", { "d": "M6 8l4 -3l2 2.5l-4 3l-1.8 -.5z", "key": "svg-6" }]]);

var IconRollercoaster$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRollercoaster
});

var IconRosetteDiscountCheckOff = createReactComponent("outline", "rosette-discount-check-off", "IconRosetteDiscountCheckOff", [["path", { "d": "M9 12l2 2l1.5 -1.5m2 -2l.5 -.5", "key": "svg-0" }], ["path", { "d": "M8.887 4.89a2.2 2.2 0 0 0 .863 -.53l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.528 .858m-.757 3.248a2.193 2.193 0 0 1 -1.555 .644h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1c0 -.604 .244 -1.152 .638 -1.55", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconRosetteDiscountCheckOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteDiscountCheckOff
});

var IconRosetteDiscountCheck = createReactComponent("outline", "rosette-discount-check", "IconRosetteDiscountCheck", [["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-0" }], ["path", { "d": "M9 12l2 2l4 -4", "key": "svg-1" }]]);

var IconRosetteDiscountCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteDiscountCheck
});

var IconRosetteDiscountOff = createReactComponent("outline", "rosette-discount-off", "IconRosetteDiscountOff", [["path", { "d": "M9 15l3 -3m2 -2l1 -1", "key": "svg-0" }], ["path", { "d": "M9.148 9.145a.498 .498 0 0 0 .352 .855a.5 .5 0 0 0 .35 -.142", "key": "svg-1" }], ["path", { "d": "M14.148 14.145a.498 .498 0 0 0 .352 .855a.5 .5 0 0 0 .35 -.142", "key": "svg-2" }], ["path", { "d": "M8.887 4.89a2.2 2.2 0 0 0 .863 -.53l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.528 .858m-.757 3.248a2.193 2.193 0 0 1 -1.555 .644h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1c0 -.604 .244 -1.152 .638 -1.55", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconRosetteDiscountOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteDiscountOff
});

var IconRosetteDiscount = createReactComponent("outline", "rosette-discount", "IconRosetteDiscount", [["path", { "d": "M9 15l6 -6", "key": "svg-0" }], ["circle", { "cx": "9.5", "cy": "9.5", "r": ".5", "fill": "currentColor", "key": "svg-1" }], ["circle", { "cx": "14.5", "cy": "14.5", "r": ".5", "fill": "currentColor", "key": "svg-2" }], ["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-3" }]]);

var IconRosetteDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteDiscount
});

var IconRosetteNumber0 = createReactComponent("outline", "rosette-number-0", "IconRosetteNumber0", [["path", { "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", "key": "svg-0" }], ["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-1" }]]);

var IconRosetteNumber0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteNumber0
});

var IconRosetteNumber1 = createReactComponent("outline", "rosette-number-1", "IconRosetteNumber1", [["path", { "d": "M10 10l2 -2v8", "key": "svg-0" }], ["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-1" }]]);

var IconRosetteNumber1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteNumber1
});

var IconRosetteNumber2 = createReactComponent("outline", "rosette-number-2", "IconRosetteNumber2", [["path", { "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-1" }]]);

var IconRosetteNumber2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteNumber2
});

var IconRosetteNumber3 = createReactComponent("outline", "rosette-number-3", "IconRosetteNumber3", [["path", { "d": "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1", "key": "svg-0" }], ["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-1" }]]);

var IconRosetteNumber3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteNumber3
});

var IconRosetteNumber4 = createReactComponent("outline", "rosette-number-4", "IconRosetteNumber4", [["path", { "d": "M10 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M14 8v8", "key": "svg-1" }], ["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-2" }]]);

var IconRosetteNumber4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteNumber4
});

var IconRosetteNumber5 = createReactComponent("outline", "rosette-number-5", "IconRosetteNumber5", [["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-0" }], ["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-1" }]]);

var IconRosetteNumber5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteNumber5
});

var IconRosetteNumber6 = createReactComponent("outline", "rosette-number-6", "IconRosetteNumber6", [["path", { "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-0" }], ["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-1" }]]);

var IconRosetteNumber6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteNumber6
});

var IconRosetteNumber7 = createReactComponent("outline", "rosette-number-7", "IconRosetteNumber7", [["path", { "d": "M10 8h4l-2 8", "key": "svg-0" }], ["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-1" }]]);

var IconRosetteNumber7$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteNumber7
});

var IconRosetteNumber8 = createReactComponent("outline", "rosette-number-8", "IconRosetteNumber8", [["path", { "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-0" }], ["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-1" }]]);

var IconRosetteNumber8$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteNumber8
});

var IconRosetteNumber9 = createReactComponent("outline", "rosette-number-9", "IconRosetteNumber9", [["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-1" }]]);

var IconRosetteNumber9$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteNumber9
});

var IconRosette = createReactComponent("outline", "rosette", "IconRosette", [["path", { "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1", "key": "svg-0" }]]);

var IconRosette$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosette
});

var IconRotate2 = createReactComponent("outline", "rotate-2", "IconRotate2", [["path", { "d": "M15 4.55a8 8 0 0 0 -6 14.9m0 -4.45v5h-5", "key": "svg-0" }], ["path", { "d": "M18.37 7.16l0 .01", "key": "svg-1" }], ["path", { "d": "M13 19.94l0 .01", "key": "svg-2" }], ["path", { "d": "M16.84 18.37l0 .01", "key": "svg-3" }], ["path", { "d": "M19.37 15.1l0 .01", "key": "svg-4" }], ["path", { "d": "M19.94 11l0 .01", "key": "svg-5" }]]);

var IconRotate2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRotate2
});

var IconRotate360 = createReactComponent("outline", "rotate-360", "IconRotate360", [["path", { "d": "M12 16h4v4", "key": "svg-0" }], ["path", { "d": "M19.458 11.042c.86 -2.366 .722 -4.58 -.6 -5.9c-2.272 -2.274 -7.185 -1.045 -10.973 2.743c-3.788 3.788 -5.017 8.701 -2.744 10.974c2.227 2.226 6.987 1.093 10.74 -2.515", "key": "svg-1" }]]);

var IconRotate360$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRotate360
});

var IconRotate3d = createReactComponent("outline", "rotate-3d", "IconRotate3d", [["path", { "d": "M12 3a7 7 0 0 1 7 7v4l-3 -3", "key": "svg-0" }], ["path", { "d": "M22 11l-3 3", "key": "svg-1" }], ["path", { "d": "M8 15.5l-5 -3l5 -3l5 3v5.5l-5 3z", "key": "svg-2" }], ["path", { "d": "M3 12.5v5.5l5 3", "key": "svg-3" }], ["path", { "d": "M8 15.545l5 -3.03", "key": "svg-4" }]]);

var IconRotate3d$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRotate3d
});

var IconRotateClockwise2 = createReactComponent("outline", "rotate-clockwise-2", "IconRotateClockwise2", [["path", { "d": "M9 4.55a8 8 0 0 1 6 14.9m0 -4.45v5h5", "key": "svg-0" }], ["path", { "d": "M5.63 7.16l0 .01", "key": "svg-1" }], ["path", { "d": "M4.06 11l0 .01", "key": "svg-2" }], ["path", { "d": "M4.63 15.1l0 .01", "key": "svg-3" }], ["path", { "d": "M7.16 18.37l0 .01", "key": "svg-4" }], ["path", { "d": "M11 19.94l0 .01", "key": "svg-5" }]]);

var IconRotateClockwise2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRotateClockwise2
});

var IconRotateClockwise = createReactComponent("outline", "rotate-clockwise", "IconRotateClockwise", [["path", { "d": "M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5", "key": "svg-0" }]]);

var IconRotateClockwise$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRotateClockwise
});

var IconRotateDot = createReactComponent("outline", "rotate-dot", "IconRotateDot", [["path", { "d": "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5", "key": "svg-0" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }]]);

var IconRotateDot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRotateDot
});

var IconRotateRectangle = createReactComponent("outline", "rotate-rectangle", "IconRotateRectangle", [["path", { "d": "M10.09 4.01l.496 -.495a2 2 0 0 1 2.828 0l7.071 7.07a2 2 0 0 1 0 2.83l-7.07 7.07a2 2 0 0 1 -2.83 0l-7.07 -7.07a2 2 0 0 1 0 -2.83l3.535 -3.535h-3.988", "key": "svg-0" }], ["path", { "d": "M7.05 11.038v-3.988", "key": "svg-1" }]]);

var IconRotateRectangle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRotateRectangle
});

var IconRotate = createReactComponent("outline", "rotate", "IconRotate", [["path", { "d": "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5", "key": "svg-0" }]]);

var IconRotate$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRotate
});

var IconRoute2 = createReactComponent("outline", "route-2", "IconRoute2", [["path", { "d": "M3 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M19 7a2 2 0 1 0 0 -4a2 2 0 0 0 0 4z", "key": "svg-1" }], ["path", { "d": "M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2", "key": "svg-2" }]]);

var IconRoute2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRoute2
});

var IconRouteAltLeft = createReactComponent("outline", "route-alt-left", "IconRouteAltLeft", [["path", { "d": "M8 3h-5v5", "key": "svg-0" }], ["path", { "d": "M16 3h5v5", "key": "svg-1" }], ["path", { "d": "M3 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93", "key": "svg-2" }], ["path", { "d": "M18 6.01v-.01", "key": "svg-3" }], ["path", { "d": "M16 8.02v-.01", "key": "svg-4" }], ["path", { "d": "M14 10v.01", "key": "svg-5" }]]);

var IconRouteAltLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRouteAltLeft
});

var IconRouteAltRight = createReactComponent("outline", "route-alt-right", "IconRouteAltRight", [["path", { "d": "M16 3h5v5", "key": "svg-0" }], ["path", { "d": "M8 3h-5v5", "key": "svg-1" }], ["path", { "d": "M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93", "key": "svg-2" }], ["path", { "d": "M6 6.01v-.01", "key": "svg-3" }], ["path", { "d": "M8 8.02v-.01", "key": "svg-4" }], ["path", { "d": "M10 10v.01", "key": "svg-5" }]]);

var IconRouteAltRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRouteAltRight
});

var IconRouteOff = createReactComponent("outline", "route-off", "IconRouteOff", [["path", { "d": "M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M18 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M12 19h4.5c.71 0 1.372 -.212 1.924 -.576m1.545 -2.459a3.5 3.5 0 0 0 -3.469 -3.965h-.499m-4 0h-3.501a3.5 3.5 0 0 1 -2.477 -5.972m2.477 -1.028h3.5", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconRouteOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRouteOff
});

var IconRouteScan = createReactComponent("outline", "route-scan", "IconRouteScan", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M7 12v-3h3", "key": "svg-4" }], ["path", { "d": "M14 9h3v3", "key": "svg-5" }], ["path", { "d": "M7 9l4.414 4.414a2 2 0 0 1 .586 1.414v2.172", "key": "svg-6" }], ["path", { "d": "M17 9l-4.414 4.414a2 2 0 0 0 -.586 1.414v2.172", "key": "svg-7" }]]);

var IconRouteScan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRouteScan
});

var IconRouteSquare2 = createReactComponent("outline", "route-square-2", "IconRouteSquare2", [["path", { "d": "M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2", "key": "svg-0" }], ["path", { "d": "M3 17h4v4h-4z", "key": "svg-1" }], ["path", { "d": "M17 3h4v4h-4z", "key": "svg-2" }]]);

var IconRouteSquare2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRouteSquare2
});

var IconRouteSquare = createReactComponent("outline", "route-square", "IconRouteSquare", [["path", { "d": "M3 17h4v4h-4z", "key": "svg-0" }], ["path", { "d": "M17 3h4v4h-4z", "key": "svg-1" }], ["path", { "d": "M11 19h5.5a3.5 3.5 0 0 0 0 -7h-8a3.5 3.5 0 0 1 0 -7h4.5", "key": "svg-2" }]]);

var IconRouteSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRouteSquare
});

var IconRouteX2 = createReactComponent("outline", "route-x-2", "IconRouteX2", [["path", { "d": "M3 17l4 4", "key": "svg-0" }], ["path", { "d": "M7 17l-4 4", "key": "svg-1" }], ["path", { "d": "M17 3l4 4", "key": "svg-2" }], ["path", { "d": "M21 3l-4 4", "key": "svg-3" }], ["path", { "d": "M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2", "key": "svg-4" }]]);

var IconRouteX2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRouteX2
});

var IconRouteX = createReactComponent("outline", "route-x", "IconRouteX", [["path", { "d": "M3 17l4 4", "key": "svg-0" }], ["path", { "d": "M7 17l-4 4", "key": "svg-1" }], ["path", { "d": "M17 3l4 4", "key": "svg-2" }], ["path", { "d": "M21 3l-4 4", "key": "svg-3" }], ["path", { "d": "M11 19h5.5a3.5 3.5 0 0 0 0 -7h-8a3.5 3.5 0 0 1 0 -7h4.5", "key": "svg-4" }]]);

var IconRouteX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRouteX
});

var IconRoute = createReactComponent("outline", "route", "IconRoute", [["path", { "d": "M3 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M19 7a2 2 0 1 0 0 -4a2 2 0 0 0 0 4z", "key": "svg-1" }], ["path", { "d": "M11 19h5.5a3.5 3.5 0 0 0 0 -7h-8a3.5 3.5 0 0 1 0 -7h4.5", "key": "svg-2" }]]);

var IconRoute$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRoute
});

var IconRouterOff = createReactComponent("outline", "router-off", "IconRouterOff", [["path", { "d": "M17 13h2a2 2 0 0 1 2 2v2m-.588 3.417c-.362 .36 -.861 .583 -1.412 .583h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h8", "key": "svg-0" }], ["path", { "d": "M17 17v.01", "key": "svg-1" }], ["path", { "d": "M13 17v.01", "key": "svg-2" }], ["path", { "d": "M12.226 8.2a4 4 0 0 1 6.024 .55", "key": "svg-3" }], ["path", { "d": "M9.445 5.407a8 8 0 0 1 12.055 1.093", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconRouterOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRouterOff
});

var IconRouter = createReactComponent("outline", "router", "IconRouter", [["path", { "d": "M3 13m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M17 17l0 .01", "key": "svg-1" }], ["path", { "d": "M13 17l0 .01", "key": "svg-2" }], ["path", { "d": "M15 13l0 -2", "key": "svg-3" }], ["path", { "d": "M11.75 8.75a4 4 0 0 1 6.5 0", "key": "svg-4" }], ["path", { "d": "M8.5 6.5a8 8 0 0 1 13 0", "key": "svg-5" }]]);

var IconRouter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRouter
});

var IconRowInsertBottom = createReactComponent("outline", "row-insert-bottom", "IconRowInsertBottom", [["path", { "d": "M20 6v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1z", "key": "svg-0" }], ["path", { "d": "M12 15l0 4", "key": "svg-1" }], ["path", { "d": "M14 17l-4 0", "key": "svg-2" }]]);

var IconRowInsertBottom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRowInsertBottom
});

var IconRowInsertTop = createReactComponent("outline", "row-insert-top", "IconRowInsertTop", [["path", { "d": "M4 18v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M12 9v-4", "key": "svg-1" }], ["path", { "d": "M10 7l4 0", "key": "svg-2" }]]);

var IconRowInsertTop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRowInsertTop
});

var IconRowRemove = createReactComponent("outline", "row-remove", "IconRowRemove", [["path", { "d": "M20 6v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1z", "key": "svg-0" }], ["path", { "d": "M10 16l4 4", "key": "svg-1" }], ["path", { "d": "M10 20l4 -4", "key": "svg-2" }]]);

var IconRowRemove$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRowRemove
});

var IconRss = createReactComponent("outline", "rss", "IconRss", [["path", { "d": "M5 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M4 4a16 16 0 0 1 16 16", "key": "svg-1" }], ["path", { "d": "M4 11a9 9 0 0 1 9 9", "key": "svg-2" }]]);

var IconRss$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRss
});

var IconRubberStampOff = createReactComponent("outline", "rubber-stamp-off", "IconRubberStampOff", [["path", { "d": "M8.273 8.273c.805 2.341 2.857 5.527 -1.484 5.527c-2.368 0 -3.789 0 -3.789 4.05h14.85", "key": "svg-0" }], ["path", { "d": "M5 21h14", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }], ["path", { "d": "M8.712 4.722a3.99 3.99 0 0 1 3.288 -1.722a4 4 0 0 1 4 4c0 .992 -.806 2.464 -1.223 3.785m6.198 6.196c-.182 -2.883 -1.332 -3.153 -3.172 -3.178", "key": "svg-3" }]]);

var IconRubberStampOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRubberStampOff
});

var IconRubberStamp = createReactComponent("outline", "rubber-stamp", "IconRubberStamp", [["path", { "d": "M21 17.85h-18c0 -4.05 1.421 -4.05 3.79 -4.05c5.21 0 1.21 -4.59 1.21 -6.8a4 4 0 1 1 8 0c0 2.21 -4 6.8 1.21 6.8c2.369 0 3.79 0 3.79 4.05z", "key": "svg-0" }], ["path", { "d": "M5 21h14", "key": "svg-1" }]]);

var IconRubberStamp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRubberStamp
});

var IconRuler2Off = createReactComponent("outline", "ruler-2-off", "IconRuler2Off", [["path", { "d": "M12.03 7.97l4.97 -4.97l4 4l-5 5m-2 2l-7 7l-4 -4l7 -7", "key": "svg-0" }], ["path", { "d": "M16 7l-1.5 -1.5", "key": "svg-1" }], ["path", { "d": "M10 13l-1.5 -1.5", "key": "svg-2" }], ["path", { "d": "M7 16l-1.5 -1.5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconRuler2Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRuler2Off
});

var IconRuler2 = createReactComponent("outline", "ruler-2", "IconRuler2", [["path", { "d": "M17 3l4 4l-14 14l-4 -4z", "key": "svg-0" }], ["path", { "d": "M16 7l-1.5 -1.5", "key": "svg-1" }], ["path", { "d": "M13 10l-1.5 -1.5", "key": "svg-2" }], ["path", { "d": "M10 13l-1.5 -1.5", "key": "svg-3" }], ["path", { "d": "M7 16l-1.5 -1.5", "key": "svg-4" }]]);

var IconRuler2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRuler2
});

var IconRuler3 = createReactComponent("outline", "ruler-3", "IconRuler3", [["path", { "d": "M19.875 8c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z", "key": "svg-0" }], ["path", { "d": "M9 8v2", "key": "svg-1" }], ["path", { "d": "M6 8v3", "key": "svg-2" }], ["path", { "d": "M12 8v3", "key": "svg-3" }], ["path", { "d": "M18 8v3", "key": "svg-4" }], ["path", { "d": "M15 8v2", "key": "svg-5" }]]);

var IconRuler3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRuler3
});

var IconRulerMeasure2 = createReactComponent("outline", "ruler-measure-2", "IconRulerMeasure2", [["path", { "d": "M12 19.875c0 .621 -.512 1.125 -1.143 1.125h-5.714a1.134 1.134 0 0 1 -1.143 -1.125v-15.875a1 1 0 0 1 1 -1h5.857c.631 0 1.143 .504 1.143 1.125z", "key": "svg-0" }], ["path", { "d": "M12 9h-2", "key": "svg-1" }], ["path", { "d": "M12 6h-3", "key": "svg-2" }], ["path", { "d": "M12 12h-3", "key": "svg-3" }], ["path", { "d": "M12 18h-3", "key": "svg-4" }], ["path", { "d": "M12 15h-2", "key": "svg-5" }], ["path", { "d": "M21 3h-4", "key": "svg-6" }], ["path", { "d": "M19 3v18", "key": "svg-7" }], ["path", { "d": "M21 21h-4", "key": "svg-8" }]]);

var IconRulerMeasure2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRulerMeasure2
});

var IconRulerMeasure = createReactComponent("outline", "ruler-measure", "IconRulerMeasure", [["path", { "d": "M19.875 12c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z", "key": "svg-0" }], ["path", { "d": "M9 12v2", "key": "svg-1" }], ["path", { "d": "M6 12v3", "key": "svg-2" }], ["path", { "d": "M12 12v3", "key": "svg-3" }], ["path", { "d": "M18 12v3", "key": "svg-4" }], ["path", { "d": "M15 12v2", "key": "svg-5" }], ["path", { "d": "M3 3v4", "key": "svg-6" }], ["path", { "d": "M3 5h18", "key": "svg-7" }], ["path", { "d": "M21 3v4", "key": "svg-8" }]]);

var IconRulerMeasure$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRulerMeasure
});

var IconRulerOff = createReactComponent("outline", "ruler-off", "IconRulerOff", [["path", { "d": "M8 4h11a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-4m-3.713 .299a1 1 0 0 0 -.287 .701v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14c0 -.284 .118 -.54 .308 -.722", "key": "svg-0" }], ["path", { "d": "M4 8h2", "key": "svg-1" }], ["path", { "d": "M4 12h3", "key": "svg-2" }], ["path", { "d": "M4 16h2", "key": "svg-3" }], ["path", { "d": "M12 4v3", "key": "svg-4" }], ["path", { "d": "M16 4v2", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconRulerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRulerOff
});

var IconRuler = createReactComponent("outline", "ruler", "IconRuler", [["path", { "d": "M5 4h14a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-7a1 1 0 0 0 -1 1v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1", "key": "svg-0" }], ["path", { "d": "M4 8l2 0", "key": "svg-1" }], ["path", { "d": "M4 12l3 0", "key": "svg-2" }], ["path", { "d": "M4 16l2 0", "key": "svg-3" }], ["path", { "d": "M8 4l0 2", "key": "svg-4" }], ["path", { "d": "M12 4l0 3", "key": "svg-5" }], ["path", { "d": "M16 4l0 2", "key": "svg-6" }]]);

var IconRuler$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRuler
});

var IconRun = createReactComponent("outline", "run", "IconRun", [["path", { "d": "M13 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M4 17l5 1l.75 -1.5", "key": "svg-1" }], ["path", { "d": "M15 21l0 -4l-4 -3l1 -6", "key": "svg-2" }], ["path", { "d": "M7 12l0 -3l5 -1l3 3l3 1", "key": "svg-3" }]]);

var IconRun$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRun
});

var IconRvTruck = createReactComponent("outline", "rv-truck", "IconRvTruck", [["path", { "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M9 17h6", "key": "svg-2" }], ["path", { "d": "M19 17h1a1 1 0 0 0 1 -1v-4.528a2 2 0 0 0 -.211 -.894l-.96 -1.92a3 3 0 0 0 -2.683 -1.658h-11.146a3 3 0 0 0 -3 3v6a1 1 0 0 0 1 1h1", "key": "svg-3" }], ["path", { "d": "M3 12h18", "key": "svg-4" }], ["path", { "d": "M15 12v-5", "key": "svg-5" }], ["path", { "d": "M6 4m0 1.5a1.5 1.5 0 0 1 1.5 -1.5h7a1.5 1.5 0 0 1 1.5 1.5v0a1.5 1.5 0 0 1 -1.5 1.5h-7a1.5 1.5 0 0 1 -1.5 -1.5z", "key": "svg-6" }]]);

var IconRvTruck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRvTruck
});

var IconSTurnDown = createReactComponent("outline", "s-turn-down", "IconSTurnDown", [["path", { "d": "M7 5a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z", "key": "svg-0" }], ["path", { "d": "M5 7v9.5a3.5 3.5 0 0 0 7 0v-9a3.5 3.5 0 0 1 7 0v13.5", "key": "svg-1" }], ["path", { "d": "M16 18l3 3l3 -3", "key": "svg-2" }]]);

var IconSTurnDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSTurnDown
});

var IconSTurnLeft = createReactComponent("outline", "s-turn-left", "IconSTurnLeft", [["path", { "d": "M19 7a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z", "key": "svg-0" }], ["path", { "d": "M17 5h-9.5a3.5 3.5 0 0 0 0 7h9a3.5 3.5 0 0 1 0 7h-13.5", "key": "svg-1" }], ["path", { "d": "M6 16l-3 3l3 3", "key": "svg-2" }]]);

var IconSTurnLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSTurnLeft
});

var IconSTurnRight = createReactComponent("outline", "s-turn-right", "IconSTurnRight", [["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M7 5h9.5a3.5 3.5 0 0 1 0 7h-9a3.5 3.5 0 0 0 0 7h13.5", "key": "svg-1" }], ["path", { "d": "M18 16l3 3l-3 3", "key": "svg-2" }]]);

var IconSTurnRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSTurnRight
});

var IconSTurnUp = createReactComponent("outline", "s-turn-up", "IconSTurnUp", [["path", { "d": "M7 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M5 17v-9.5a3.5 3.5 0 0 1 7 0v9a3.5 3.5 0 0 0 7 0v-13.5", "key": "svg-1" }], ["path", { "d": "M16 6l3 -3l3 3", "key": "svg-2" }]]);

var IconSTurnUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSTurnUp
});

var IconSailboat2 = createReactComponent("outline", "sailboat-2", "IconSailboat2", [["path", { "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1", "key": "svg-0" }], ["path", { "d": "M4 18l-1 -3h18l-1 3", "key": "svg-1" }], ["path", { "d": "M12 11v4", "key": "svg-2" }], ["path", { "d": "M7 3c1.333 2.667 1.333 5.333 0 8h10c1.333 -2.667 1.333 -5.333 0 -8", "key": "svg-3" }], ["path", { "d": "M6 3h12", "key": "svg-4" }]]);

var IconSailboat2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSailboat2
});

var IconSailboatOff = createReactComponent("outline", "sailboat-off", "IconSailboatOff", [["path", { "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1", "key": "svg-0" }], ["path", { "d": "M4 18l-1 -3h12m4 0h2l-.506 1.517", "key": "svg-1" }], ["path", { "d": "M11 11v1h1m4 0h2l-7 -9v4", "key": "svg-2" }], ["path", { "d": "M7.713 7.718l-1.713 4.282", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconSailboatOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSailboatOff
});

var IconSailboat = createReactComponent("outline", "sailboat", "IconSailboat", [["path", { "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1", "key": "svg-0" }], ["path", { "d": "M4 18l-1 -3h18l-1 3", "key": "svg-1" }], ["path", { "d": "M11 12h7l-7 -9v9", "key": "svg-2" }], ["path", { "d": "M8 7l-2 5", "key": "svg-3" }]]);

var IconSailboat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSailboat
});

var IconSalad = createReactComponent("outline", "salad", "IconSalad", [["path", { "d": "M4 11h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M18.5 11c.351 -1.017 .426 -2.236 .5 -3.714v-1.286h-2.256c-2.83 0 -4.616 .804 -5.64 2.076", "key": "svg-1" }], ["path", { "d": "M5.255 11.008a12.204 12.204 0 0 1 -.255 -2.008v-1h1.755c.98 0 1.801 .124 2.479 .35", "key": "svg-2" }], ["path", { "d": "M8 8l1 -4l4 2.5", "key": "svg-3" }], ["path", { "d": "M13 11v-.5a2.5 2.5 0 1 0 -5 0v.5", "key": "svg-4" }]]);

var IconSalad$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSalad
});

var IconSalt = createReactComponent("outline", "salt", "IconSalt", [["path", { "d": "M12 13v.01", "key": "svg-0" }], ["path", { "d": "M10 16v.01", "key": "svg-1" }], ["path", { "d": "M14 16v.01", "key": "svg-2" }], ["path", { "d": "M7.5 8h9l-.281 -2.248a2 2 0 0 0 -1.985 -1.752h-4.468a2 2 0 0 0 -1.986 1.752l-.28 2.248z", "key": "svg-3" }], ["path", { "d": "M7.5 8l-1.612 9.671a2 2 0 0 0 1.973 2.329h8.278a2 2 0 0 0 1.973 -2.329l-1.612 -9.671", "key": "svg-4" }]]);

var IconSalt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSalt
});

var IconSandbox = createReactComponent("outline", "sandbox", "IconSandbox", [["path", { "d": "M19.953 8.017l1.047 6.983v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-2l1.245 -8.297a2 2 0 0 1 1.977 -1.703h3.778", "key": "svg-0" }], ["path", { "d": "M3 15h18", "key": "svg-1" }], ["path", { "d": "M13 3l5.5 1.5", "key": "svg-2" }], ["path", { "d": "M15.75 3.75l-2 7", "key": "svg-3" }], ["path", { "d": "M7 10.5c1.667 -.667 3.333 -.667 5 0c1.667 .667 3.333 .667 5 0", "key": "svg-4" }]]);

var IconSandbox$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSandbox
});

var IconSatelliteOff = createReactComponent("outline", "satellite-off", "IconSatelliteOff", [["path", { "d": "M7.707 3.707l5.586 5.586m-1.293 2.707l-1.293 1.293a1 1 0 0 1 -1.414 0l-5.586 -5.586a1 1 0 0 1 0 -1.414l1.293 -1.293", "key": "svg-0" }], ["path", { "d": "M6 10l-3 3l3 3l3 -3", "key": "svg-1" }], ["path", { "d": "M10 6l3 -3l3 3l-3 3", "key": "svg-2" }], ["path", { "d": "M12 12l1.5 1.5", "key": "svg-3" }], ["path", { "d": "M14.5 17c.69 0 1.316 -.28 1.769 -.733", "key": "svg-4" }], ["path", { "d": "M15 21c1.654 0 3.151 -.67 4.237 -1.752m1.507 -2.507a6 6 0 0 0 .256 -1.741", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconSatelliteOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSatelliteOff
});

var IconSatellite = createReactComponent("outline", "satellite", "IconSatellite", [["path", { "d": "M3.707 6.293l2.586 -2.586a1 1 0 0 1 1.414 0l5.586 5.586a1 1 0 0 1 0 1.414l-2.586 2.586a1 1 0 0 1 -1.414 0l-5.586 -5.586a1 1 0 0 1 0 -1.414z", "key": "svg-0" }], ["path", { "d": "M6 10l-3 3l3 3l3 -3", "key": "svg-1" }], ["path", { "d": "M10 6l3 -3l3 3l-3 3", "key": "svg-2" }], ["path", { "d": "M12 12l1.5 1.5", "key": "svg-3" }], ["path", { "d": "M14.5 17a2.5 2.5 0 0 0 2.5 -2.5", "key": "svg-4" }], ["path", { "d": "M15 21a6 6 0 0 0 6 -6", "key": "svg-5" }]]);

var IconSatellite$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSatellite
});

var IconSausage = createReactComponent("outline", "sausage", "IconSausage", [["path", { "d": "M5.5 5.5a2.5 2.5 0 0 0 -2.5 2.5c0 7.18 5.82 13 13 13a2.5 2.5 0 1 0 0 -5a8 8 0 0 1 -8 -8a2.5 2.5 0 0 0 -2.5 -2.5z", "key": "svg-0" }], ["path", { "d": "M5.195 5.519l-1.243 -1.989a1 1 0 0 1 .848 -1.53h1.392a1 1 0 0 1 .848 1.53l-1.245 1.99", "key": "svg-1" }], ["path", { "d": "M18.482 18.225l1.989 -1.243a1 1 0 0 1 1.53 .848v1.392a1 1 0 0 1 -1.53 .848l-1.991 -1.245", "key": "svg-2" }]]);

var IconSausage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSausage
});

var IconScaleOff = createReactComponent("outline", "scale-off", "IconScaleOff", [["path", { "d": "M7 20h10", "key": "svg-0" }], ["path", { "d": "M9.452 5.425l2.548 -.425l6 1", "key": "svg-1" }], ["path", { "d": "M12 3v5m0 4v8", "key": "svg-2" }], ["path", { "d": "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0", "key": "svg-3" }], ["path", { "d": "M18.873 14.871a3 3 0 0 0 2.127 -2.871l-3 -6l-2.677 5.355", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconScaleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScaleOff
});

var IconScaleOutlineOff = createReactComponent("outline", "scale-outline-off", "IconScaleOutlineOff", [["path", { "d": "M7 3h10a4 4 0 0 1 4 4v10m-1.173 2.83a3.987 3.987 0 0 1 -2.827 1.17h-10a4 4 0 0 1 -4 -4v-10c0 -1.104 .447 -2.103 1.17 -2.827", "key": "svg-0" }], ["path", { "d": "M11.062 7.062c.31 -.041 .622 -.062 .938 -.062c1.956 0 3.724 .802 5 2.095a142.85 142.85 0 0 0 -2 1.905m-3.723 .288a3 3 0 0 0 -1.315 .71l-2.956 -2.903a6.977 6.977 0 0 1 1.142 -.942", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconScaleOutlineOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScaleOutlineOff
});

var IconScaleOutline = createReactComponent("outline", "scale-outline", "IconScaleOutline", [["path", { "d": "M3 3m0 4a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4z", "key": "svg-0" }], ["path", { "d": "M12 7c1.956 0 3.724 .802 5 2.095l-2.956 2.904a3 3 0 0 0 -2.038 -.799a3 3 0 0 0 -2.038 .798l-2.956 -2.903a6.979 6.979 0 0 1 5 -2.095z", "key": "svg-1" }]]);

var IconScaleOutline$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScaleOutline
});

var IconScale = createReactComponent("outline", "scale", "IconScale", [["path", { "d": "M7 20l10 0", "key": "svg-0" }], ["path", { "d": "M6 6l6 -1l6 1", "key": "svg-1" }], ["path", { "d": "M12 3l0 17", "key": "svg-2" }], ["path", { "d": "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0", "key": "svg-3" }], ["path", { "d": "M21 12l-3 -6l-3 6a3 3 0 0 0 6 0", "key": "svg-4" }]]);

var IconScale$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScale
});

var IconScanEye = createReactComponent("outline", "scan-eye", "IconScanEye", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M7 12c3.333 -4.667 6.667 -4.667 10 0", "key": "svg-4" }], ["path", { "d": "M7 12c3.333 4.667 6.667 4.667 10 0", "key": "svg-5" }], ["path", { "d": "M12 12h-.01", "key": "svg-6" }]]);

var IconScanEye$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScanEye
});

var IconScanPosition = createReactComponent("outline", "scan-position", "IconScanPosition", [["path", { "d": "M4 7v-1a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 17v1a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v1", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-1", "key": "svg-3" }], ["path", { "d": "M12 17l3 -8l-8 3l3.5 1.5z", "key": "svg-4" }]]);

var IconScanPosition$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScanPosition
});

var IconScan = createReactComponent("outline", "scan", "IconScan", [["path", { "d": "M4 7v-1a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 17v1a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v1", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-1", "key": "svg-3" }], ["path", { "d": "M5 12l14 0", "key": "svg-4" }]]);

var IconScan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScan
});

var IconSchemaOff = createReactComponent("outline", "schema-off", "IconSchemaOff", [["path", { "d": "M6 2h4v4m-4 0h-1v-1", "key": "svg-0" }], ["path", { "d": "M15 11v-1h5v4h-2", "key": "svg-1" }], ["path", { "d": "M5 18h5v4h-5z", "key": "svg-2" }], ["path", { "d": "M5 10h5v4h-5z", "key": "svg-3" }], ["path", { "d": "M10 12h2", "key": "svg-4" }], ["path", { "d": "M7.5 7.5v2.5", "key": "svg-5" }], ["path", { "d": "M7.5 14v4", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconSchemaOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSchemaOff
});

var IconSchema = createReactComponent("outline", "schema", "IconSchema", [["path", { "d": "M5 2h5v4h-5z", "key": "svg-0" }], ["path", { "d": "M15 10h5v4h-5z", "key": "svg-1" }], ["path", { "d": "M5 18h5v4h-5z", "key": "svg-2" }], ["path", { "d": "M5 10h5v4h-5z", "key": "svg-3" }], ["path", { "d": "M10 12h5", "key": "svg-4" }], ["path", { "d": "M7.5 6v4", "key": "svg-5" }], ["path", { "d": "M7.5 14v4", "key": "svg-6" }]]);

var IconSchema$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSchema
});

var IconSchoolBell = createReactComponent("outline", "school-bell", "IconSchoolBell", [["path", { "d": "M4 17a3 3 0 0 0 3 3", "key": "svg-0" }], ["path", { "d": "M14.805 6.37l2.783 -2.784a2 2 0 1 1 2.829 2.828l-2.784 2.786", "key": "svg-1" }], ["path", { "d": "M16.505 7.495a5.105 5.105 0 0 1 .176 7.035l-.176 .184l-1.867 1.867a3.48 3.48 0 0 0 -1.013 2.234l-.008 .23v.934c0 .327 -.13 .64 -.36 .871a.51 .51 0 0 1 -.652 .06l-.07 -.06l-9.385 -9.384a.51 .51 0 0 1 0 -.722c.198 -.198 .456 -.322 .732 -.353l.139 -.008h.933c.848 0 1.663 -.309 2.297 -.864l.168 -.157l1.867 -1.867l.16 -.153a5.105 5.105 0 0 1 7.059 .153z", "key": "svg-2" }]]);

var IconSchoolBell$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSchoolBell
});

var IconSchoolOff = createReactComponent("outline", "school-off", "IconSchoolOff", [["path", { "d": "M22 9l-10 -4l-2.136 .854m-2.864 1.146l-5 2l10 4l.697 -.279m2.878 -1.151l6.425 -2.57v6", "key": "svg-0" }], ["path", { "d": "M6 10.6v5.4c0 1.657 2.686 3 6 3c2.334 0 4.357 -.666 5.35 -1.64m.65 -3.36v-3.4", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconSchoolOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSchoolOff
});

var IconSchool = createReactComponent("outline", "school", "IconSchool", [["path", { "d": "M22 9l-10 -4l-10 4l10 4l10 -4v6", "key": "svg-0" }], ["path", { "d": "M6 10.6v5.4a6 3 0 0 0 12 0v-5.4", "key": "svg-1" }]]);

var IconSchool$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSchool
});

var IconScissorsOff = createReactComponent("outline", "scissors-off", "IconScissorsOff", [["path", { "d": "M4.432 4.442a3 3 0 1 0 4.114 4.146", "key": "svg-0" }], ["path", { "d": "M6 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M8.6 15.4l3.4 -3.4m2 -2l5 -5", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconScissorsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScissorsOff
});

var IconScissors = createReactComponent("outline", "scissors", "IconScissors", [["path", { "d": "M6 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M6 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M8.6 8.6l10.4 10.4", "key": "svg-2" }], ["path", { "d": "M8.6 15.4l10.4 -10.4", "key": "svg-3" }]]);

var IconScissors$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScissors
});

var IconScooterElectric = createReactComponent("outline", "scooter-electric", "IconScooterElectric", [["path", { "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1", "key": "svg-2" }], ["path", { "d": "M10 4l-2 4h3l-2 4", "key": "svg-3" }]]);

var IconScooterElectric$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScooterElectric
});

var IconScooter = createReactComponent("outline", "scooter", "IconScooter", [["path", { "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1", "key": "svg-2" }]]);

var IconScooter$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScooter
});

var IconScoreboard = createReactComponent("outline", "scoreboard", "IconScoreboard", [["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 5v2", "key": "svg-1" }], ["path", { "d": "M12 10v1", "key": "svg-2" }], ["path", { "d": "M12 14v1", "key": "svg-3" }], ["path", { "d": "M12 18v1", "key": "svg-4" }], ["path", { "d": "M7 3v2", "key": "svg-5" }], ["path", { "d": "M17 3v2", "key": "svg-6" }], ["path", { "d": "M15 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-7" }], ["path", { "d": "M6 9h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5", "key": "svg-8" }]]);

var IconScoreboard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScoreboard
});

var IconScreenShareOff = createReactComponent("outline", "screen-share-off", "IconScreenShareOff", [["path", { "d": "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9", "key": "svg-0" }], ["path", { "d": "M7 20l10 0", "key": "svg-1" }], ["path", { "d": "M9 16l0 4", "key": "svg-2" }], ["path", { "d": "M15 16l0 4", "key": "svg-3" }], ["path", { "d": "M17 8l4 -4m-4 0l4 4", "key": "svg-4" }]]);

var IconScreenShareOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScreenShareOff
});

var IconScreenShare = createReactComponent("outline", "screen-share", "IconScreenShare", [["path", { "d": "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9", "key": "svg-0" }], ["path", { "d": "M7 20l10 0", "key": "svg-1" }], ["path", { "d": "M9 16l0 4", "key": "svg-2" }], ["path", { "d": "M15 16l0 4", "key": "svg-3" }], ["path", { "d": "M17 4h4v4", "key": "svg-4" }], ["path", { "d": "M16 9l5 -5", "key": "svg-5" }]]);

var IconScreenShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScreenShare
});

var IconScreenshot = createReactComponent("outline", "screenshot", "IconScreenshot", [["path", { "d": "M7 19a2 2 0 0 1 -2 -2", "key": "svg-0" }], ["path", { "d": "M5 13v-2", "key": "svg-1" }], ["path", { "d": "M5 7a2 2 0 0 1 2 -2", "key": "svg-2" }], ["path", { "d": "M11 5h2", "key": "svg-3" }], ["path", { "d": "M17 5a2 2 0 0 1 2 2", "key": "svg-4" }], ["path", { "d": "M19 11v2", "key": "svg-5" }], ["path", { "d": "M19 17v4", "key": "svg-6" }], ["path", { "d": "M21 19h-4", "key": "svg-7" }], ["path", { "d": "M13 19h-2", "key": "svg-8" }]]);

var IconScreenshot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScreenshot
});

var IconScribbleOff = createReactComponent("outline", "scribble-off", "IconScribbleOff", [["path", { "d": "M3 15c2 3 4 4 7 4c1.95 0 4.324 -1.268 5.746 -3.256m1.181 -2.812a5.97 5.97 0 0 0 .073 -.932c0 -4 -3 -7 -6 -7c-.642 0 -1.239 .069 -1.78 .201m-2.492 1.515c-.47 .617 -.728 1.386 -.728 2.284c0 2.5 2 5 6 5c.597 0 1.203 -.055 1.808 -.156m3.102 -.921c2.235 -.953 4.152 -2.423 5.09 -3.923", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconScribbleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScribbleOff
});

var IconScribble = createReactComponent("outline", "scribble", "IconScribble", [["path", { "d": "M3 15c2 3 4 4 7 4s7 -3 7 -7s-3 -7 -6 -7s-5 1.5 -5 4s2 5 6 5s8.408 -2.453 10 -5", "key": "svg-0" }]]);

var IconScribble$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScribble
});

var IconScriptMinus = createReactComponent("outline", "script-minus", "IconScriptMinus", [["path", { "d": "M17 19h4", "key": "svg-0" }], ["path", { "d": "M14 20h-8a3 3 0 0 1 0 -6h11a3 3 0 0 0 -3 3m7 -2v-9a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8", "key": "svg-1" }]]);

var IconScriptMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScriptMinus
});

var IconScriptPlus = createReactComponent("outline", "script-plus", "IconScriptPlus", [["path", { "d": "M17 19h4", "key": "svg-0" }], ["path", { "d": "M14 20h-8a3 3 0 0 1 0 -6h11a3 3 0 0 0 -3 3m7 -3v-8a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8", "key": "svg-1" }], ["path", { "d": "M19 17v4", "key": "svg-2" }]]);

var IconScriptPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScriptPlus
});

var IconScriptX = createReactComponent("outline", "script-x", "IconScriptX", [["path", { "d": "M14 20h-8a3 3 0 0 1 0 -6h11a3 3 0 0 0 -3 3m7 -3v-8a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8", "key": "svg-0" }], ["path", { "d": "M17 17l4 4m0 -4l-4 4", "key": "svg-1" }]]);

var IconScriptX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScriptX
});

var IconScript = createReactComponent("outline", "script", "IconScript", [["path", { "d": "M17 20h-11a3 3 0 0 1 0 -6h11a3 3 0 0 0 0 6h1a3 3 0 0 0 3 -3v-11a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8", "key": "svg-0" }]]);

var IconScript$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScript
});

var IconScubaDivingTank = createReactComponent("outline", "scuba-diving-tank", "IconScubaDivingTank", [["path", { "d": "M8 11a4 4 0 1 1 8 0v5h-8z", "key": "svg-0" }], ["path", { "d": "M8 16v3a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-3", "key": "svg-1" }], ["path", { "d": "M9 4h6", "key": "svg-2" }], ["path", { "d": "M12 7v-3", "key": "svg-3" }], ["path", { "d": "M8 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["circle", { "cx": "12", "cy": "4", "r": ".5", "fill": "currentColor", "key": "svg-5" }]]);

var IconScubaDivingTank$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScubaDivingTank
});

var IconScubaDiving = createReactComponent("outline", "scuba-diving", "IconScubaDiving", [["path", { "d": "M19 12a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M2 2l3 3l1.5 4l3.5 2l6 2l1 4l2.5 3", "key": "svg-1" }], ["path", { "d": "M11 8l4.5 1.5", "key": "svg-2" }]]);

var IconScubaDiving$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScubaDiving
});

var IconScubaMaskOff = createReactComponent("outline", "scuba-mask-off", "IconScubaMaskOff", [["path", { "d": "M11 7h5a1 1 0 0 1 1 1v4.5c0 .154 -.014 .304 -.04 .45m-2 2.007c-.15 .028 -.305 .043 -.463 .043h-.5a2 2 0 0 1 -2 -2a2 2 0 1 0 -4 0a2 2 0 0 1 -2 2h-.5a2.5 2.5 0 0 1 -2.5 -2.5v-4.5a1 1 0 0 1 1 -1h3", "key": "svg-0" }], ["path", { "d": "M10 17a2 2 0 0 0 2 2h3.5a5.475 5.475 0 0 0 2.765 -.744m2 -2c.47 -.81 .739 -1.752 .739 -2.756v-9.5", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconScubaMaskOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScubaMaskOff
});

var IconScubaMask = createReactComponent("outline", "scuba-mask", "IconScubaMask", [["path", { "d": "M4 7h12a1 1 0 0 1 1 1v4.5a2.5 2.5 0 0 1 -2.5 2.5h-.5a2 2 0 0 1 -2 -2a2 2 0 1 0 -4 0a2 2 0 0 1 -2 2h-.5a2.5 2.5 0 0 1 -2.5 -2.5v-4.5a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M10 17a2 2 0 0 0 2 2h3.5a5.5 5.5 0 0 0 5.5 -5.5v-9.5", "key": "svg-1" }]]);

var IconScubaMask$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScubaMask
});

var IconSdk = createReactComponent("outline", "sdk", "IconSdk", [["path", { "d": "M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3", "key": "svg-0" }], ["path", { "d": "M17 8v8", "key": "svg-1" }], ["path", { "d": "M21 8l-3 4l3 4", "key": "svg-2" }], ["path", { "d": "M17 12h1", "key": "svg-3" }], ["path", { "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", "key": "svg-4" }]]);

var IconSdk$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSdk
});

var IconSearchOff = createReactComponent("outline", "search-off", "IconSearchOff", [["path", { "d": "M5.039 5.062a7 7 0 0 0 9.91 9.89m1.584 -2.434a7 7 0 0 0 -9.038 -9.057", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconSearchOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSearchOff
});

var IconSearch = createReactComponent("outline", "search", "IconSearch", [["path", { "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M21 21l-6 -6", "key": "svg-1" }]]);

var IconSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSearch
});

var IconSectionSign = createReactComponent("outline", "section-sign", "IconSectionSign", [["path", { "d": "M9.172 19a3 3 0 1 0 2.828 -4", "key": "svg-0" }], ["path", { "d": "M14.83 5a3 3 0 1 0 -2.83 4", "key": "svg-1" }], ["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }]]);

var IconSectionSign$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSectionSign
});

var IconSection = createReactComponent("outline", "section", "IconSection", [["path", { "d": "M20 20h.01", "key": "svg-0" }], ["path", { "d": "M4 20h.01", "key": "svg-1" }], ["path", { "d": "M8 20h.01", "key": "svg-2" }], ["path", { "d": "M12 20h.01", "key": "svg-3" }], ["path", { "d": "M16 20h.01", "key": "svg-4" }], ["path", { "d": "M20 4h.01", "key": "svg-5" }], ["path", { "d": "M4 4h.01", "key": "svg-6" }], ["path", { "d": "M8 4h.01", "key": "svg-7" }], ["path", { "d": "M12 4h.01", "key": "svg-8" }], ["path", { "d": "M16 4l0 .01", "key": "svg-9" }], ["path", { "d": "M4 8m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z", "key": "svg-10" }]]);

var IconSection$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSection
});

var IconSeedlingOff = createReactComponent("outline", "seedling-off", "IconSeedlingOff", [["path", { "d": "M11.412 7.407a6.025 6.025 0 0 0 -2.82 -2.82m-4.592 -.587h-1v2a6 6 0 0 0 6 6h3", "key": "svg-0" }], ["path", { "d": "M12 14a6 6 0 0 1 .255 -1.736m1.51 -2.514a5.981 5.981 0 0 1 4.235 -1.75h3v1c0 2.158 -1.14 4.05 -2.85 5.107m-3.15 .893h-3", "key": "svg-1" }], ["path", { "d": "M12 20v-8", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconSeedlingOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSeedlingOff
});

var IconSeedling = createReactComponent("outline", "seedling", "IconSeedling", [["path", { "d": "M12 10a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3", "key": "svg-0" }], ["path", { "d": "M12 14a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3", "key": "svg-1" }], ["path", { "d": "M12 20l0 -10", "key": "svg-2" }]]);

var IconSeedling$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSeedling
});

var IconSelectAll = createReactComponent("outline", "select-all", "IconSelectAll", [["path", { "d": "M8 8m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M12 20v.01", "key": "svg-1" }], ["path", { "d": "M16 20v.01", "key": "svg-2" }], ["path", { "d": "M8 20v.01", "key": "svg-3" }], ["path", { "d": "M4 20v.01", "key": "svg-4" }], ["path", { "d": "M4 16v.01", "key": "svg-5" }], ["path", { "d": "M4 12v.01", "key": "svg-6" }], ["path", { "d": "M4 8v.01", "key": "svg-7" }], ["path", { "d": "M4 4v.01", "key": "svg-8" }], ["path", { "d": "M8 4v.01", "key": "svg-9" }], ["path", { "d": "M12 4v.01", "key": "svg-10" }], ["path", { "d": "M16 4v.01", "key": "svg-11" }], ["path", { "d": "M20 4v.01", "key": "svg-12" }], ["path", { "d": "M20 8v.01", "key": "svg-13" }], ["path", { "d": "M20 12v.01", "key": "svg-14" }], ["path", { "d": "M20 16v.01", "key": "svg-15" }], ["path", { "d": "M20 20v.01", "key": "svg-16" }]]);

var IconSelectAll$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSelectAll
});

var IconSelect = createReactComponent("outline", "select", "IconSelect", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 11l3 3l3 -3", "key": "svg-1" }]]);

var IconSelect$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSelect
});

var IconSelector = createReactComponent("outline", "selector", "IconSelector", [["path", { "d": "M8 9l4 -4l4 4", "key": "svg-0" }], ["path", { "d": "M16 15l-4 4l-4 -4", "key": "svg-1" }]]);

var IconSelector$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSelector
});

var IconSend2 = createReactComponent("outline", "send-2", "IconSend2", [["path", { "d": "M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124z", "key": "svg-0" }], ["path", { "d": "M6.5 12h14.5", "key": "svg-1" }]]);

var IconSend2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSend2
});

var IconSendOff = createReactComponent("outline", "send-off", "IconSendOff", [["path", { "d": "M10 14l2 -2m2 -2l7 -7", "key": "svg-0" }], ["path", { "d": "M10.718 6.713l10.282 -3.713l-3.715 10.289m-1.063 2.941l-1.722 4.77a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l4.772 -1.723", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconSendOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSendOff
});

var IconSend = createReactComponent("outline", "send", "IconSend", [["path", { "d": "M10 14l11 -11", "key": "svg-0" }], ["path", { "d": "M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5", "key": "svg-1" }]]);

var IconSend$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSend
});

var IconSeo = createReactComponent("outline", "seo", "IconSeo", [["path", { "d": "M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3", "key": "svg-0" }], ["path", { "d": "M14 16h-4v-8h4", "key": "svg-1" }], ["path", { "d": "M11 12h2", "key": "svg-2" }], ["path", { "d": "M17 8m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-3" }]]);

var IconSeo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSeo
});

var IconSeparatorHorizontal = createReactComponent("outline", "separator-horizontal", "IconSeparatorHorizontal", [["path", { "d": "M4 12l16 0", "key": "svg-0" }], ["path", { "d": "M8 8l4 -4l4 4", "key": "svg-1" }], ["path", { "d": "M16 16l-4 4l-4 -4", "key": "svg-2" }]]);

var IconSeparatorHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSeparatorHorizontal
});

var IconSeparatorVertical = createReactComponent("outline", "separator-vertical", "IconSeparatorVertical", [["path", { "d": "M12 4l0 16", "key": "svg-0" }], ["path", { "d": "M8 8l-4 4l4 4", "key": "svg-1" }], ["path", { "d": "M16 16l4 -4l-4 -4", "key": "svg-2" }]]);

var IconSeparatorVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSeparatorVertical
});

var IconSeparator = createReactComponent("outline", "separator", "IconSeparator", [["path", { "d": "M3 12l0 .01", "key": "svg-0" }], ["path", { "d": "M7 12l10 0", "key": "svg-1" }], ["path", { "d": "M21 12l0 .01", "key": "svg-2" }]]);

var IconSeparator$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSeparator
});

var IconServer2 = createReactComponent("outline", "server-2", "IconServer2", [["path", { "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M3 12m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-1" }], ["path", { "d": "M7 8l0 .01", "key": "svg-2" }], ["path", { "d": "M7 16l0 .01", "key": "svg-3" }], ["path", { "d": "M11 8h6", "key": "svg-4" }], ["path", { "d": "M11 16h6", "key": "svg-5" }]]);

var IconServer2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconServer2
});

var IconServerBolt = createReactComponent("outline", "server-bolt", "IconServerBolt", [["path", { "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M15 20h-9a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h12", "key": "svg-1" }], ["path", { "d": "M7 8v.01", "key": "svg-2" }], ["path", { "d": "M7 16v.01", "key": "svg-3" }], ["path", { "d": "M20 15l-2 3h3l-2 3", "key": "svg-4" }]]);

var IconServerBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconServerBolt
});

var IconServerCog = createReactComponent("outline", "server-cog", "IconServerCog", [["path", { "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M12 20h-6a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h10.5", "key": "svg-1" }], ["path", { "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M18 14.5v1.5", "key": "svg-3" }], ["path", { "d": "M18 20v1.5", "key": "svg-4" }], ["path", { "d": "M21.032 16.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M16.27 19l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M14.97 16.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M19.733 19l1.3 .75", "key": "svg-8" }], ["path", { "d": "M7 8v.01", "key": "svg-9" }], ["path", { "d": "M7 16v.01", "key": "svg-10" }]]);

var IconServerCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconServerCog
});

var IconServerOff = createReactComponent("outline", "server-off", "IconServerOff", [["path", { "d": "M12 12h-6a3 3 0 0 1 -3 -3v-2c0 -1.083 .574 -2.033 1.435 -2.56m3.565 -.44h10a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-2", "key": "svg-0" }], ["path", { "d": "M16 12h2a3 3 0 0 1 3 3v2m-1.448 2.568a2.986 2.986 0 0 1 -1.552 .432h-12a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h6", "key": "svg-1" }], ["path", { "d": "M7 8v.01", "key": "svg-2" }], ["path", { "d": "M7 16v.01", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconServerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconServerOff
});

var IconServerSpark = createReactComponent("outline", "server-spark", "IconServerSpark", [["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-0" }], ["path", { "d": "M3 7a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-1" }], ["path", { "d": "M12 20h-6a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h10.5", "key": "svg-2" }], ["path", { "d": "M7 8v.01", "key": "svg-3" }], ["path", { "d": "M7 16v.01", "key": "svg-4" }]]);

var IconServerSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconServerSpark
});

var IconServer = createReactComponent("outline", "server", "IconServer", [["path", { "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M3 12m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-1" }], ["path", { "d": "M7 8l0 .01", "key": "svg-2" }], ["path", { "d": "M7 16l0 .01", "key": "svg-3" }]]);

var IconServer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconServer
});

var IconServicemark = createReactComponent("outline", "servicemark", "IconServicemark", [["path", { "d": "M9 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-0" }], ["path", { "d": "M13 15v-6l3 4l3 -4v6", "key": "svg-1" }]]);

var IconServicemark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconServicemark
});

var IconSettings2 = createReactComponent("outline", "settings-2", "IconSettings2", [["path", { "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-0" }], ["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }]]);

var IconSettings2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettings2
});

var IconSettingsAutomation = createReactComponent("outline", "settings-automation", "IconSettingsAutomation", [["path", { "d": "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z", "key": "svg-0" }], ["path", { "d": "M10 9v6l5 -3z", "key": "svg-1" }]]);

var IconSettingsAutomation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsAutomation
});

var IconSettingsBolt = createReactComponent("outline", "settings-bolt", "IconSettingsBolt", [["path", { "d": "M13.256 20.473c-.855 .907 -2.583 .643 -2.931 -.79a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.07 .26 1.488 1.29 1.254 2.15", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-2" }]]);

var IconSettingsBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsBolt
});

var IconSettingsCancel = createReactComponent("outline", "settings-cancel", "IconSettingsCancel", [["path", { "d": "M12.29 20.977c-.818 .132 -1.724 -.3 -1.965 -1.294a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c.983 .238 1.416 1.126 1.298 1.937", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-3" }]]);

var IconSettingsCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsCancel
});

var IconSettingsCheck = createReactComponent("outline", "settings-check", "IconSettingsCheck", [["path", { "d": "M11.445 20.913a1.665 1.665 0 0 1 -1.12 -1.23a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.31 .318 1.643 1.79 .997 2.694", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-2" }]]);

var IconSettingsCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsCheck
});

var IconSettingsCode = createReactComponent("outline", "settings-code", "IconSettingsCode", [["path", { "d": "M11.482 20.924a1.666 1.666 0 0 1 -1.157 -1.241a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.312 .318 1.644 1.794 .995 2.697", "key": "svg-0" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

var IconSettingsCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsCode
});

var IconSettingsCog = createReactComponent("outline", "settings-cog", "IconSettingsCog", [["path", { "d": "M12.003 21c-.732 .001 -1.465 -.438 -1.678 -1.317a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c.886 .215 1.325 .957 1.318 1.694", "key": "svg-0" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-3" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-4" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-8" }]]);

var IconSettingsCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsCog
});

var IconSettingsDollar = createReactComponent("outline", "settings-dollar", "IconSettingsDollar", [["path", { "d": "M13.038 20.666c-.902 .665 -2.393 .337 -2.713 -.983a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 .402 2.248", "key": "svg-0" }], ["path", { "d": "M15 12a3 3 0 1 0 -1.724 2.716", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconSettingsDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsDollar
});

var IconSettingsDown = createReactComponent("outline", "settings-down", "IconSettingsDown", [["path", { "d": "M12.52 20.924c-.87 .262 -1.93 -.152 -2.195 -1.241a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.088 .264 1.502 1.323 1.242 2.192", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-3" }]]);

var IconSettingsDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsDown
});

var IconSettingsExclamation = createReactComponent("outline", "settings-exclamation", "IconSettingsExclamation", [["path", { "d": "M15.004 18.401a1.724 1.724 0 0 0 -1.329 1.282c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.079 .262 1.495 1.305 1.248 2.17", "key": "svg-0" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconSettingsExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsExclamation
});

var IconSettingsHeart = createReactComponent("outline", "settings-heart", "IconSettingsHeart", [["path", { "d": "M11.231 20.828a1.668 1.668 0 0 1 -.906 -1.145a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c.509 .123 .87 .421 1.084 .792", "key": "svg-0" }], ["path", { "d": "M14.882 11.165a3.001 3.001 0 1 0 -4.31 3.474", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconSettingsHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsHeart
});

var IconSettingsMinus = createReactComponent("outline", "settings-minus", "IconSettingsMinus", [["path", { "d": "M12.488 20.933c-.863 .243 -1.902 -.174 -2.163 -1.25a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35c-.535 .13 -.976 .507 -1.187 1.016c-.049 .118 -.084 .185 -.106 .309", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-2" }]]);

var IconSettingsMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsMinus
});

var IconSettingsOff = createReactComponent("outline", "settings-off", "IconSettingsOff", [["path", { "d": "M9.451 5.437c.418 -.218 .75 -.609 .874 -1.12c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35c-.486 .118 -.894 .44 -1.123 .878m-.188 3.803c-.517 .523 -1.349 .734 -2.125 .262a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.472 -.774 -.262 -1.604 .259 -2.121", "key": "svg-0" }], ["path", { "d": "M9.889 9.869a3 3 0 1 0 4.226 4.26m.592 -3.424a3.012 3.012 0 0 0 -1.419 -1.415", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconSettingsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsOff
});

var IconSettingsPause = createReactComponent("outline", "settings-pause", "IconSettingsPause", [["path", { "d": "M13.004 20.69c-.905 .632 -2.363 .296 -2.679 -1.007a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.314 .319 1.645 1.798 .992 2.701", "key": "svg-0" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

var IconSettingsPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsPause
});

var IconSettingsPin = createReactComponent("outline", "settings-pin", "IconSettingsPin", [["path", { "d": "M12.578 20.905c-.88 .299 -1.983 -.109 -2.253 -1.222a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c.574 .14 .96 .5 1.16 .937", "key": "svg-0" }], ["path", { "d": "M14.99 12.256a3 3 0 1 0 -2.33 2.671", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }]]);

var IconSettingsPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsPin
});

var IconSettingsPlus = createReactComponent("outline", "settings-plus", "IconSettingsPlus", [["path", { "d": "M12.483 20.935c-.862 .239 -1.898 -.178 -2.158 -1.252a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.08 .262 1.496 1.308 1.247 2.173", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-3" }]]);

var IconSettingsPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsPlus
});

var IconSettingsQuestion = createReactComponent("outline", "settings-question", "IconSettingsQuestion", [["path", { "d": "M14.69 18.498c-.508 .21 -.885 .65 -1.015 1.185c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572a1.67 1.67 0 0 1 1.179 .982", "key": "svg-0" }], ["path", { "d": "M14.95 12.553a3 3 0 1 0 -1.211 1.892", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }]]);

var IconSettingsQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsQuestion
});

var IconSettingsSearch = createReactComponent("outline", "settings-search", "IconSettingsSearch", [["path", { "d": "M11.646 20.965a1.67 1.67 0 0 1 -1.321 -1.282a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c.728 .177 1.154 .71 1.279 1.303", "key": "svg-0" }], ["path", { "d": "M14.985 11.694a3 3 0 1 0 -3.29 3.29", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconSettingsSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsSearch
});

var IconSettingsShare = createReactComponent("outline", "settings-share", "IconSettingsShare", [["path", { "d": "M12.004 21c-.732 .002 -1.466 -.437 -1.679 -1.317a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.306 .317 1.64 1.78 1.004 2.684", "key": "svg-0" }], ["path", { "d": "M12 15a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconSettingsShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsShare
});

var IconSettingsSpark = createReactComponent("outline", "settings-spark", "IconSettingsSpark", [["path", { "d": "M11.992 21c-.728 -.003 -1.455 -.442 -1.667 -1.317a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c.882 .214 1.32 .95 1.317 1.684", "key": "svg-0" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-2" }]]);

var IconSettingsSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsSpark
});

var IconSettingsStar = createReactComponent("outline", "settings-star", "IconSettingsStar", [["path", { "d": "M10.325 19.683a1.723 1.723 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572a1.67 1.67 0 0 1 1.106 .831", "key": "svg-0" }], ["path", { "d": "M14.89 11.195a3.001 3.001 0 1 0 -4.457 3.364", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconSettingsStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsStar
});

var IconSettingsUp = createReactComponent("outline", "settings-up", "IconSettingsUp", [["path", { "d": "M12.501 20.93c-.866 .25 -1.914 -.166 -2.176 -1.247a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.074 .26 1.49 1.296 1.252 2.158", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-3" }]]);

var IconSettingsUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsUp
});

var IconSettingsX = createReactComponent("outline", "settings-x", "IconSettingsX", [["path", { "d": "M13.675 19.683c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.66 1.66 0 0 0 -.324 .114", "key": "svg-0" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-2" }], ["path", { "d": "M17 22l5 -5", "key": "svg-3" }]]);

var IconSettingsX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsX
});

var IconSettings = createReactComponent("outline", "settings", "IconSettings", [["path", { "d": "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z", "key": "svg-0" }], ["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-1" }]]);

var IconSettings$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettings
});

var IconShadowOff = createReactComponent("outline", "shadow-off", "IconShadowOff", [["path", { "d": "M5.634 5.638a9 9 0 0 0 12.728 12.727m1.68 -2.32a9 9 0 0 0 -12.086 -12.088", "key": "svg-0" }], ["path", { "d": "M16 12h2", "key": "svg-1" }], ["path", { "d": "M13 15h2", "key": "svg-2" }], ["path", { "d": "M13 18h1", "key": "svg-3" }], ["path", { "d": "M13 9h4", "key": "svg-4" }], ["path", { "d": "M13 6h1", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconShadowOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShadowOff
});

var IconShadow = createReactComponent("outline", "shadow", "IconShadow", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M13 12h5", "key": "svg-1" }], ["path", { "d": "M13 15h4", "key": "svg-2" }], ["path", { "d": "M13 18h1", "key": "svg-3" }], ["path", { "d": "M13 9h4", "key": "svg-4" }], ["path", { "d": "M13 6h1", "key": "svg-5" }]]);

var IconShadow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShadow
});

var IconShape2 = createReactComponent("outline", "shape-2", "IconShape2", [["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M6.5 17.5l11 -11m-12.5 .5v10m14 -10v10", "key": "svg-4" }]]);

var IconShape2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShape2
});

var IconShape3 = createReactComponent("outline", "shape-3", "IconShape3", [["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M7 5h10m-12 2v10m14 -10v10", "key": "svg-4" }]]);

var IconShape3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShape3
});

var IconShapeOff = createReactComponent("outline", "shape-off", "IconShapeOff", [["path", { "d": "M3.575 3.597a2 2 0 0 0 2.849 2.808", "key": "svg-0" }], ["path", { "d": "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M17.574 17.598a2 2 0 0 0 2.826 2.83", "key": "svg-3" }], ["path", { "d": "M5 7v10", "key": "svg-4" }], ["path", { "d": "M9 5h8", "key": "svg-5" }], ["path", { "d": "M7 19h10", "key": "svg-6" }], ["path", { "d": "M19 7v8", "key": "svg-7" }], ["path", { "d": "M3 3l18 18", "key": "svg-8" }]]);

var IconShapeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShapeOff
});

var IconShape = createReactComponent("outline", "shape", "IconShape", [["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M5 7l0 10", "key": "svg-4" }], ["path", { "d": "M7 5l10 0", "key": "svg-5" }], ["path", { "d": "M7 19l10 0", "key": "svg-6" }], ["path", { "d": "M19 7l0 10", "key": "svg-7" }]]);

var IconShape$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShape
});

var IconShare2 = createReactComponent("outline", "share-2", "IconShare2", [["path", { "d": "M8 9h-1a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-8a2 2 0 0 0 -2 -2h-1", "key": "svg-0" }], ["path", { "d": "M12 14v-11", "key": "svg-1" }], ["path", { "d": "M9 6l3 -3l3 3", "key": "svg-2" }]]);

var IconShare2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShare2
});

var IconShare3 = createReactComponent("outline", "share-3", "IconShare3", [["path", { "d": "M13 4v4c-6.575 1.028 -9.02 6.788 -10 12c-.037 .206 5.384 -5.962 10 -6v4l8 -7l-8 -7z", "key": "svg-0" }]]);

var IconShare3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShare3
});

var IconShareOff = createReactComponent("outline", "share-off", "IconShareOff", [["path", { "d": "M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M15.861 15.896a3 3 0 0 0 4.265 4.22m.578 -3.417a3.012 3.012 0 0 0 -1.507 -1.45", "key": "svg-2" }], ["path", { "d": "M8.7 10.7l1.336 -.688m2.624 -1.352l2.64 -1.36", "key": "svg-3" }], ["path", { "d": "M8.7 13.3l6.6 3.4", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconShareOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShareOff
});

var IconShare = createReactComponent("outline", "share", "IconShare", [["path", { "d": "M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M8.7 10.7l6.6 -3.4", "key": "svg-3" }], ["path", { "d": "M8.7 13.3l6.6 3.4", "key": "svg-4" }]]);

var IconShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShare
});

var IconShareplay = createReactComponent("outline", "shareplay", "IconShareplay", [["path", { "d": "M18 18a3 3 0 0 0 3 -3v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3v8a3 3 0 0 0 3 3", "key": "svg-0" }], ["path", { "d": "M9 20h6l-3 -5z", "key": "svg-1" }]]);

var IconShareplay$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShareplay
});

var IconShieldBolt = createReactComponent("outline", "shield-bolt", "IconShieldBolt", [["path", { "d": "M13.342 20.566c-.436 .17 -.884 .315 -1.342 .434a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .117 6.34", "key": "svg-0" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-1" }]]);

var IconShieldBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldBolt
});

var IconShieldCancel = createReactComponent("outline", "shield-cancel", "IconShieldCancel", [["path", { "d": "M12.277 20.925c-.092 .026 -.184 .051 -.277 .075a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .145 6.232", "key": "svg-0" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 21l4 -4", "key": "svg-2" }]]);

var IconShieldCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldCancel
});

var IconShieldCheck = createReactComponent("outline", "shield-check", "IconShieldCheck", [["path", { "d": "M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06", "key": "svg-0" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-1" }]]);

var IconShieldCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldCheck
});

var IconShieldCheckered = createReactComponent("outline", "shield-checkered", "IconShieldCheckered", [["path", { "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3", "key": "svg-0" }], ["path", { "d": "M12 3v18", "key": "svg-1" }], ["path", { "d": "M3.5 12h17", "key": "svg-2" }]]);

var IconShieldCheckered$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldCheckered
});

var IconShieldChevron = createReactComponent("outline", "shield-chevron", "IconShieldChevron", [["path", { "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3", "key": "svg-0" }], ["path", { "d": "M4 14l8 -3l8 3", "key": "svg-1" }]]);

var IconShieldChevron$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldChevron
});

var IconShieldCode = createReactComponent("outline", "shield-code", "IconShieldCode", [["path", { "d": "M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.078 7.024", "key": "svg-0" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-2" }]]);

var IconShieldCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldCode
});

var IconShieldCog = createReactComponent("outline", "shield-cog", "IconShieldCog", [["path", { "d": "M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.568 1.933 .635 3.957 .223 5.89", "key": "svg-0" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-2" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-3" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-4" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-5" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-6" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-7" }]]);

var IconShieldCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldCog
});

var IconShieldDollar = createReactComponent("outline", "shield-dollar", "IconShieldDollar", [["path", { "d": "M13.018 20.687c-.333 .119 -.673 .223 -1.018 .313a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.433 1.472 .575 2.998 .436 4.495", "key": "svg-0" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-1" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-2" }]]);

var IconShieldDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldDollar
});

var IconShieldDown = createReactComponent("outline", "shield-down", "IconShieldDown", [["path", { "d": "M12.444 20.876c-.147 .044 -.295 .085 -.444 .124a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .117 6.343", "key": "svg-0" }], ["path", { "d": "M19 16v6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-2" }]]);

var IconShieldDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldDown
});

var IconShieldExclamation = createReactComponent("outline", "shield-exclamation", "IconShieldExclamation", [["path", { "d": "M15.04 19.745c-.942 .551 -1.964 .976 -3.04 1.255a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .195 6.015", "key": "svg-0" }], ["path", { "d": "M19 16v3", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }]]);

var IconShieldExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldExclamation
});

var IconShieldHalf = createReactComponent("outline", "shield-half", "IconShieldHalf", [["path", { "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3", "key": "svg-0" }], ["path", { "d": "M12 3v18", "key": "svg-1" }]]);

var IconShieldHalf$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldHalf
});

var IconShieldHeart = createReactComponent("outline", "shield-heart", "IconShieldHeart", [["path", { "d": "M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12.01 12.01 0 0 1 .378 5", "key": "svg-0" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-1" }]]);

var IconShieldHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldHeart
});

var IconShieldLock = createReactComponent("outline", "shield-lock", "IconShieldLock", [["path", { "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3", "key": "svg-0" }], ["path", { "d": "M12 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M12 12l0 2.5", "key": "svg-2" }]]);

var IconShieldLock$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldLock
});

var IconShieldMinus = createReactComponent("outline", "shield-minus", "IconShieldMinus", [["path", { "d": "M12.46 20.871c-.153 .046 -.306 .089 -.46 .129a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.916 9.015", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconShieldMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldMinus
});

var IconShieldOff = createReactComponent("outline", "shield-off", "IconShieldOff", [["path", { "d": "M17.67 17.667a12 12 0 0 1 -5.67 3.333a12 12 0 0 1 -8.5 -15c.794 .036 1.583 -.006 2.357 -.124m3.128 -.926a11.997 11.997 0 0 0 3.015 -1.95a12 12 0 0 0 8.5 3a12 12 0 0 1 -1.116 9.376", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconShieldOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldOff
});

var IconShieldPause = createReactComponent("outline", "shield-pause", "IconShieldPause", [["path", { "d": "M13.004 20.692c-.329 .117 -.664 .22 -1.004 .308a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.081 7.034", "key": "svg-0" }], ["path", { "d": "M17 17v5", "key": "svg-1" }], ["path", { "d": "M21 17v5", "key": "svg-2" }]]);

var IconShieldPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldPause
});

var IconShieldPin = createReactComponent("outline", "shield-pin", "IconShieldPin", [["path", { "d": "M12.597 20.829a12 12 0 0 1 -.597 .171a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.506 1.72 .614 3.512 .342 5.248", "key": "svg-0" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-1" }], ["path", { "d": "M19 18v.01", "key": "svg-2" }]]);

var IconShieldPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldPin
});

var IconShieldPlus = createReactComponent("outline", "shield-plus", "IconShieldPlus", [["path", { "d": "M12.462 20.87c-.153 .047 -.307 .09 -.462 .13a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .11 6.37", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconShieldPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldPlus
});

var IconShieldQuestion = createReactComponent("outline", "shield-question", "IconShieldQuestion", [["path", { "d": "M15.065 19.732c-.95 .557 -1.98 .986 -3.065 1.268a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.51 1.738 .617 3.55 .333 5.303", "key": "svg-0" }], ["path", { "d": "M19 22v.01", "key": "svg-1" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-2" }]]);

var IconShieldQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldQuestion
});

var IconShieldSearch = createReactComponent("outline", "shield-search", "IconShieldSearch", [["path", { "d": "M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.539 1.832 .627 3.747 .283 5.588", "key": "svg-0" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-2" }]]);

var IconShieldSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldSearch
});

var IconShieldShare = createReactComponent("outline", "shield-share", "IconShieldShare", [["path", { "d": "M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .193 6.025", "key": "svg-0" }], ["path", { "d": "M16 22l5 -5", "key": "svg-1" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-2" }]]);

var IconShieldShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldShare
});

var IconShieldStar = createReactComponent("outline", "shield-star", "IconShieldStar", [["path", { "d": "M11.143 20.743a12 12 0 0 1 -7.643 -14.743a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.504 1.716 .614 3.505 .343 5.237", "key": "svg-0" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }]]);

var IconShieldStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldStar
});

var IconShieldUp = createReactComponent("outline", "shield-up", "IconShieldUp", [["path", { "d": "M12.442 20.876a13.12 13.12 0 0 1 -.442 .124a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .119 6.336", "key": "svg-0" }], ["path", { "d": "M19 22v-6", "key": "svg-1" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-2" }]]);

var IconShieldUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldUp
});

var IconShieldX = createReactComponent("outline", "shield-x", "IconShieldX", [["path", { "d": "M13.252 20.601c-.408 .155 -.826 .288 -1.252 .399a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.19 7.357", "key": "svg-0" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-1" }], ["path", { "d": "M17 22l5 -5", "key": "svg-2" }]]);

var IconShieldX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldX
});

var IconShield = createReactComponent("outline", "shield", "IconShield", [["path", { "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3", "key": "svg-0" }]]);

var IconShield$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShield
});

var IconShipOff = createReactComponent("outline", "ship-off", "IconShipOff", [["path", { "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1", "key": "svg-0" }], ["path", { "d": "M4 18l-1 -5h10m4 0h4l-1.334 2.668", "key": "svg-1" }], ["path", { "d": "M5 13v-6h2m4 0h2l4 6", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconShipOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShipOff
});

var IconShip = createReactComponent("outline", "ship", "IconShip", [["path", { "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1", "key": "svg-0" }], ["path", { "d": "M4 18l-1 -5h18l-2 4", "key": "svg-1" }], ["path", { "d": "M5 13v-6h8l4 6", "key": "svg-2" }], ["path", { "d": "M7 7v-4h-1", "key": "svg-3" }]]);

var IconShip$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShip
});

var IconShirtOff = createReactComponent("outline", "shirt-off", "IconShirtOff", [["path", { "d": "M8.243 4.252l.757 -.252c0 .43 .09 .837 .252 1.206m1.395 1.472a3 3 0 0 0 4.353 -2.678l6 2v5h-3v3m0 4v1a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l2.26 -.753", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconShirtOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShirtOff
});

var IconShirtSport = createReactComponent("outline", "shirt-sport", "IconShirtSport", [["path", { "d": "M15 4l6 2v5h-3v8a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l6 -2a3 3 0 0 0 6 0", "key": "svg-0" }], ["path", { "d": "M10.5 11h2.5l-1.5 5", "key": "svg-1" }]]);

var IconShirtSport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShirtSport
});

var IconShirt = createReactComponent("outline", "shirt", "IconShirt", [["path", { "d": "M15 4l6 2v5h-3v8a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l6 -2a3 3 0 0 0 6 0", "key": "svg-0" }]]);

var IconShirt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShirt
});

var IconShoeOff = createReactComponent("outline", "shoe-off", "IconShoeOff", [["path", { "d": "M13.846 9.868l4.08 .972a4 4 0 0 1 3.074 3.89v2.27m-3 1h-14a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h2", "key": "svg-0" }], ["path", { "d": "M8 18v-1a4 4 0 0 0 -4 -4h-1", "key": "svg-1" }], ["path", { "d": "M10 12l.663 -1.327", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconShoeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoeOff
});

var IconShoe = createReactComponent("outline", "shoe", "IconShoe", [["path", { "d": "M4 6h5.426a1 1 0 0 1 .863 .496l1.064 1.823a3 3 0 0 0 1.896 1.407l4.677 1.114a4 4 0 0 1 3.074 3.89v2.27a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M14 13l1 -2", "key": "svg-1" }], ["path", { "d": "M8 18v-1a4 4 0 0 0 -4 -4h-1", "key": "svg-2" }], ["path", { "d": "M10 12l1.5 -3", "key": "svg-3" }]]);

var IconShoe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoe
});

var IconShoppingBagCheck = createReactComponent("outline", "shopping-bag-check", "IconShoppingBagCheck", [["path", { "d": "M11.5 21h-2.926a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304l-.5 3.248", "key": "svg-0" }], ["path", { "d": "M9 11v-5a3 3 0 0 1 6 0v5", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconShoppingBagCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingBagCheck
});

var IconShoppingBagDiscount = createReactComponent("outline", "shopping-bag-discount", "IconShoppingBagDiscount", [["path", { "d": "M12.5 21h-3.926a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304l-.416 2.7", "key": "svg-0" }], ["path", { "d": "M9 11v-5a3 3 0 0 1 6 0v5", "key": "svg-1" }], ["path", { "d": "M16 21l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21v.01", "key": "svg-3" }], ["path", { "d": "M16 16v.01", "key": "svg-4" }]]);

var IconShoppingBagDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingBagDiscount
});

var IconShoppingBagEdit = createReactComponent("outline", "shopping-bag-edit", "IconShoppingBagEdit", [["path", { "d": "M11 21h-2.426a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304l-.109 .707", "key": "svg-0" }], ["path", { "d": "M9 11v-5a3 3 0 0 1 6 0v5", "key": "svg-1" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z", "key": "svg-2" }]]);

var IconShoppingBagEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingBagEdit
});

var IconShoppingBagExclamation = createReactComponent("outline", "shopping-bag-exclamation", "IconShoppingBagExclamation", [["path", { "d": "M15 21h-6.426a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304l-.258 1.678", "key": "svg-0" }], ["path", { "d": "M9 11v-5a3 3 0 0 1 6 0v5", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconShoppingBagExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingBagExclamation
});

var IconShoppingBagHeart = createReactComponent("outline", "shopping-bag-heart", "IconShoppingBagHeart", [["path", { "d": "M11.5 21h-2.926a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304c-.057 .368 -.1 .644 -.127 .828", "key": "svg-0" }], ["path", { "d": "M9 11v-5a3 3 0 0 1 6 0v5", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconShoppingBagHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingBagHeart
});

var IconShoppingBagMinus = createReactComponent("outline", "shopping-bag-minus", "IconShoppingBagMinus", [["path", { "d": "M12.5 21h-3.926a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304l-.73 4.744", "key": "svg-0" }], ["path", { "d": "M9 11v-5a3 3 0 0 1 6 0v5", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconShoppingBagMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingBagMinus
});

var IconShoppingBagPlus = createReactComponent("outline", "shopping-bag-plus", "IconShoppingBagPlus", [["path", { "d": "M12.5 21h-3.926a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304l-.263 1.708", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M9 11v-5a3 3 0 0 1 6 0v5", "key": "svg-3" }]]);

var IconShoppingBagPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingBagPlus
});

var IconShoppingBagSearch = createReactComponent("outline", "shopping-bag-search", "IconShoppingBagSearch", [["path", { "d": "M11.5 21h-2.926a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304l-.117 .761", "key": "svg-0" }], ["path", { "d": "M9 11v-5a3 3 0 0 1 6 0v5", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconShoppingBagSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingBagSearch
});

var IconShoppingBagX = createReactComponent("outline", "shopping-bag-x", "IconShoppingBagX", [["path", { "d": "M13 21h-4.426a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304l-.506 3.287", "key": "svg-0" }], ["path", { "d": "M9 11v-5a3 3 0 0 1 6 0v5", "key": "svg-1" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-2" }], ["path", { "d": "M17 22l5 -5", "key": "svg-3" }]]);

var IconShoppingBagX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingBagX
});

var IconShoppingBag = createReactComponent("outline", "shopping-bag", "IconShoppingBag", [["path", { "d": "M6.331 8h11.339a2 2 0 0 1 1.977 2.304l-1.255 8.152a3 3 0 0 1 -2.966 2.544h-6.852a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304z", "key": "svg-0" }], ["path", { "d": "M9 11v-5a3 3 0 0 1 6 0v5", "key": "svg-1" }]]);

var IconShoppingBag$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingBag
});

var IconShoppingCartBolt = createReactComponent("outline", "shopping-cart-bolt", "IconShoppingCartBolt", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13.5 17h-7.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.858 6.004m-2.642 .996h-10.5", "key": "svg-2" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-3" }]]);

var IconShoppingCartBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartBolt
});

var IconShoppingCartCancel = createReactComponent("outline", "shopping-cart-cancel", "IconShoppingCartCancel", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 17h-6v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.857 5.998m-3.643 1.002h-9.5", "key": "svg-2" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M17 21l4 -4", "key": "svg-4" }]]);

var IconShoppingCartCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartCancel
});

var IconShoppingCartCheck = createReactComponent("outline", "shopping-cart-check", "IconShoppingCartCheck", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M11.5 17h-5.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-1 7h-13", "key": "svg-2" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-3" }]]);

var IconShoppingCartCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartCheck
});

var IconShoppingCartCode = createReactComponent("outline", "shopping-cart-code", "IconShoppingCartCode", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M11.5 17h-5.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-1 7h-13", "key": "svg-2" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-3" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-4" }]]);

var IconShoppingCartCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartCode
});

var IconShoppingCartCog = createReactComponent("outline", "shopping-cart-cog", "IconShoppingCartCog", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 17h-6v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.79 5.526m-3.21 1.474h-10", "key": "svg-2" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-4" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-5" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-6" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-7" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-8" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-9" }]]);

var IconShoppingCartCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartCog
});

var IconShoppingCartCopy = createReactComponent("outline", "shopping-cart-copy", "IconShoppingCartCopy", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M11.5 17h-5.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-1 7h-13", "key": "svg-2" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-3" }]]);

var IconShoppingCartCopy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartCopy
});

var IconShoppingCartDiscount = createReactComponent("outline", "shopping-cart-discount", "IconShoppingCartDiscount", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12.5 17h-6.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.859 6.011m-6.141 .989h-7", "key": "svg-2" }], ["path", { "d": "M16 21l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21v.01", "key": "svg-4" }], ["path", { "d": "M16 16v.01", "key": "svg-5" }]]);

var IconShoppingCartDiscount$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartDiscount
});

var IconShoppingCartDollar = createReactComponent("outline", "shopping-cart-dollar", "IconShoppingCartDollar", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13 17h-7v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.575 4.022m-4.925 2.978h-8.5", "key": "svg-2" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-3" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-4" }]]);

var IconShoppingCartDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartDollar
});

var IconShoppingCartDown = createReactComponent("outline", "shopping-cart-down", "IconShoppingCartDown", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12.5 17h-6.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.859 6.011m-2.641 .989h-10.5", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-4" }]]);

var IconShoppingCartDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartDown
});

var IconShoppingCartExclamation = createReactComponent("outline", "shopping-cart-exclamation", "IconShoppingCartExclamation", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M15 17h-9v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.854 5.976m-2.646 1.024h-10.5", "key": "svg-2" }], ["path", { "d": "M19 16v3", "key": "svg-3" }], ["path", { "d": "M19 22v.01", "key": "svg-4" }]]);

var IconShoppingCartExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartExclamation
});

var IconShoppingCartHeart = createReactComponent("outline", "shopping-cart-heart", "IconShoppingCartHeart", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M10 17h-4v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.717 5.016m-7.783 1.984h-5.5", "key": "svg-2" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-3" }]]);

var IconShoppingCartHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartHeart
});

var IconShoppingCartMinus = createReactComponent("outline", "shopping-cart-minus", "IconShoppingCartMinus", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12.5 17h-6.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-1 7h-13", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconShoppingCartMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartMinus
});

var IconShoppingCartOff = createReactComponent("outline", "shopping-cart-off", "IconShoppingCartOff", [["path", { "d": "M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 17a2 2 0 1 0 2 2", "key": "svg-1" }], ["path", { "d": "M17 17h-11v-11", "key": "svg-2" }], ["path", { "d": "M9.239 5.231l10.761 .769l-1 7h-2m-4 0h-7", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconShoppingCartOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartOff
});

var IconShoppingCartPause = createReactComponent("outline", "shopping-cart-pause", "IconShoppingCartPause", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13 17h-7v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-1 7h-13", "key": "svg-2" }], ["path", { "d": "M17 17v5", "key": "svg-3" }], ["path", { "d": "M21 17v5", "key": "svg-4" }]]);

var IconShoppingCartPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartPause
});

var IconShoppingCartPin = createReactComponent("outline", "shopping-cart-pin", "IconShoppingCartPin", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 17h-6v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.716 5.011m-5.284 1.989h-8", "key": "svg-2" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-3" }], ["path", { "d": "M19 18v.01", "key": "svg-4" }]]);

var IconShoppingCartPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartPin
});

var IconShoppingCartPlus = createReactComponent("outline", "shopping-cart-plus", "IconShoppingCartPlus", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12.5 17h-6.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.86 6.017m-2.64 .983h-10.5", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconShoppingCartPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartPlus
});

var IconShoppingCartQuestion = createReactComponent("outline", "shopping-cart-question", "IconShoppingCartQuestion", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13.5 17h-7.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.714 5m-4.786 2h-8.5", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-4" }]]);

var IconShoppingCartQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartQuestion
});

var IconShoppingCartSearch = createReactComponent("outline", "shopping-cart-search", "IconShoppingCartSearch", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M11 17h-5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.718 5.023m-6.282 1.977h-7", "key": "svg-2" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-4" }]]);

var IconShoppingCartSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartSearch
});

var IconShoppingCartShare = createReactComponent("outline", "shopping-cart-share", "IconShoppingCartShare", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12.5 17h-6.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-1 7h-13", "key": "svg-2" }], ["path", { "d": "M16 22l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-4" }]]);

var IconShoppingCartShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartShare
});

var IconShoppingCartStar = createReactComponent("outline", "shopping-cart-star", "IconShoppingCartStar", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M9.5 17h-3.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.615 4.302m-6.885 2.698h-6.5", "key": "svg-2" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-3" }]]);

var IconShoppingCartStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartStar
});

var IconShoppingCartUp = createReactComponent("outline", "shopping-cart-up", "IconShoppingCartUp", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12.5 17h-6.5v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-.854 5.977m-2.646 1.023h-10.5", "key": "svg-2" }], ["path", { "d": "M19 22v-6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-4" }]]);

var IconShoppingCartUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartUp
});

var IconShoppingCartX = createReactComponent("outline", "shopping-cart-x", "IconShoppingCartX", [["path", { "d": "M4 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13 17h-7v-14h-2", "key": "svg-1" }], ["path", { "d": "M6 5l14 1l-1 7h-13", "key": "svg-2" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-3" }], ["path", { "d": "M17 22l5 -5", "key": "svg-4" }]]);

var IconShoppingCartX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartX
});

var IconShoppingCart = createReactComponent("outline", "shopping-cart", "IconShoppingCart", [["path", { "d": "M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M17 17h-11v-14h-2", "key": "svg-2" }], ["path", { "d": "M6 5l14 1l-1 7h-13", "key": "svg-3" }]]);

var IconShoppingCart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCart
});

var IconShovelPitchforks = createReactComponent("outline", "shovel-pitchforks", "IconShovelPitchforks", [["path", { "d": "M5 3h4", "key": "svg-0" }], ["path", { "d": "M7 3v12", "key": "svg-1" }], ["path", { "d": "M4 15h6v3a3 3 0 0 1 -6 0v-3z", "key": "svg-2" }], ["path", { "d": "M14 21v-3a3 3 0 0 1 6 0v3", "key": "svg-3" }], ["path", { "d": "M17 21v-18", "key": "svg-4" }]]);

var IconShovelPitchforks$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShovelPitchforks
});

var IconShovel = createReactComponent("outline", "shovel", "IconShovel", [["path", { "d": "M17 4l3 3", "key": "svg-0" }], ["path", { "d": "M18.5 5.5l-8 8", "key": "svg-1" }], ["path", { "d": "M8.276 11.284l4.44 4.44a.968 .968 0 0 1 0 1.369l-2.704 2.704a4.108 4.108 0 0 1 -5.809 -5.81l2.704 -2.703a.968 .968 0 0 1 1.37 0z", "key": "svg-2" }]]);

var IconShovel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShovel
});

var IconShredder = createReactComponent("outline", "shredder", "IconShredder", [["path", { "d": "M4 10m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M17 10v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4m5 5v5m4 -5v2m-8 -2v3", "key": "svg-1" }]]);

var IconShredder$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShredder
});

var IconSignLeft = createReactComponent("outline", "sign-left", "IconSignLeft", [["path", { "d": "M16 21h-4", "key": "svg-0" }], ["path", { "d": "M14 21v-10", "key": "svg-1" }], ["path", { "d": "M14 6v-3", "key": "svg-2" }], ["path", { "d": "M18 6h-10l-2 2.5l2 2.5h10z", "key": "svg-3" }]]);

var IconSignLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignLeft
});

var IconSignRight = createReactComponent("outline", "sign-right", "IconSignRight", [["path", { "d": "M8 21h4", "key": "svg-0" }], ["path", { "d": "M10 21v-10", "key": "svg-1" }], ["path", { "d": "M10 6v-3", "key": "svg-2" }], ["path", { "d": "M6 6h10l2 2.5l-2 2.5h-10z", "key": "svg-3" }]]);

var IconSignRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignRight
});

var IconSignal2g = createReactComponent("outline", "signal-2g", "IconSignal2g", [["path", { "d": "M19 8h-3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3v-4h-1", "key": "svg-0" }], ["path", { "d": "M5 8h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h4", "key": "svg-1" }]]);

var IconSignal2g$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignal2g
});

var IconSignal3g = createReactComponent("outline", "signal-3g", "IconSignal3g", [["path", { "d": "M17 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }], ["path", { "d": "M6 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }]]);

var IconSignal3g$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignal3g
});

var IconSignal4gPlus = createReactComponent("outline", "signal-4g-plus", "IconSignal4gPlus", [["path", { "d": "M17 12h4", "key": "svg-0" }], ["path", { "d": "M3 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M7 8v8", "key": "svg-2" }], ["path", { "d": "M19 10v4", "key": "svg-3" }], ["path", { "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-4" }]]);

var IconSignal4gPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignal4gPlus
});

var IconSignal4g = createReactComponent("outline", "signal-4g", "IconSignal4g", [["path", { "d": "M6 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M10 8v8", "key": "svg-1" }], ["path", { "d": "M17 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-2" }]]);

var IconSignal4g$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignal4g
});

var IconSignal5g = createReactComponent("outline", "signal-5g", "IconSignal5g", [["path", { "d": "M18 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }], ["path", { "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconSignal5g$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignal5g
});

var IconSignal6g = createReactComponent("outline", "signal-6g", "IconSignal6g", [["path", { "d": "M18 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }], ["path", { "d": "M10 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconSignal6g$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignal6g
});

var IconSignalE = createReactComponent("outline", "signal-e", "IconSignalE", [["path", { "d": "M14 8h-4v8h4", "key": "svg-0" }], ["path", { "d": "M10 12h2.5", "key": "svg-1" }]]);

var IconSignalE$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignalE
});

var IconSignalG = createReactComponent("outline", "signal-g", "IconSignalG", [["path", { "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }]]);

var IconSignalG$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignalG
});

var IconSignalHPlus = createReactComponent("outline", "signal-h-plus", "IconSignalHPlus", [["path", { "d": "M7 16v-8", "key": "svg-0" }], ["path", { "d": "M11 8v8", "key": "svg-1" }], ["path", { "d": "M7 12h4", "key": "svg-2" }], ["path", { "d": "M14 12h4", "key": "svg-3" }], ["path", { "d": "M16 10v4", "key": "svg-4" }]]);

var IconSignalHPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignalHPlus
});

var IconSignalH = createReactComponent("outline", "signal-h", "IconSignalH", [["path", { "d": "M10 16v-8", "key": "svg-0" }], ["path", { "d": "M14 8v8", "key": "svg-1" }], ["path", { "d": "M10 12h4", "key": "svg-2" }]]);

var IconSignalH$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignalH
});

var IconSignalLte = createReactComponent("outline", "signal-lte", "IconSignalLte", [["path", { "d": "M21 8h-4v8h4", "key": "svg-0" }], ["path", { "d": "M17 12h2.5", "key": "svg-1" }], ["path", { "d": "M4 8v8h4", "key": "svg-2" }], ["path", { "d": "M10 8h4", "key": "svg-3" }], ["path", { "d": "M12 8v8", "key": "svg-4" }]]);

var IconSignalLte$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignalLte
});

var IconSignatureOff = createReactComponent("outline", "signature-off", "IconSignatureOff", [["path", { "d": "M3 17c3.333 -3.333 5 -6 5 -8c0 -.394 -.017 -.735 -.05 -1.033m-1.95 -1.967c-1 0 -2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.219 0 .708 -.341 1.231 -.742m3.769 -.258c.303 .245 .64 .677 1 1", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconSignatureOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignatureOff
});

var IconSignature = createReactComponent("outline", "signature", "IconSignature", [["path", { "d": "M3 17c3.333 -3.333 5 -6 5 -8c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.53 0 2.639 -2 3 -2c.517 0 1.517 .667 3 2", "key": "svg-0" }]]);

var IconSignature$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignature
});

var IconSitemapOff = createReactComponent("outline", "sitemap-off", "IconSitemapOff", [["path", { "d": "M3 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M19 15a2 2 0 0 1 2 2m-.591 3.42c-.362 .358 -.86 .58 -1.409 .58h-2a2 2 0 0 1 -2 -2v-2c0 -.549 .221 -1.046 .579 -1.407", "key": "svg-1" }], ["path", { "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2", "key": "svg-2" }], ["path", { "d": "M6 15v-1a2 2 0 0 1 2 -2h4m4 0a2 2 0 0 1 2 2", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconSitemapOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSitemapOff
});

var IconSitemap = createReactComponent("outline", "sitemap", "IconSitemap", [["path", { "d": "M3 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M15 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z", "key": "svg-2" }], ["path", { "d": "M6 15v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1", "key": "svg-3" }], ["path", { "d": "M12 9l0 3", "key": "svg-4" }]]);

var IconSitemap$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSitemap
});

var IconSkateboardOff = createReactComponent("outline", "skateboard-off", "IconSkateboardOff", [["path", { "d": "M7 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M15 15a2 2 0 0 0 2 2m2 -2a2 2 0 0 0 -2 -2", "key": "svg-1" }], ["path", { "d": "M3 9c0 .552 .895 1 2 1h5m4 0h5c1.105 0 2 -.448 2 -1", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconSkateboardOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSkateboardOff
});

var IconSkateboard = createReactComponent("outline", "skateboard", "IconSkateboard", [["path", { "d": "M7 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M3 9a2 1 0 0 0 2 1h14a2 1 0 0 0 2 -1", "key": "svg-2" }]]);

var IconSkateboard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSkateboard
});

var IconSkateboarding = createReactComponent("outline", "skateboarding", "IconSkateboarding", [["path", { "d": "M16 4a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M5.5 15h3.5l.75 -1.5", "key": "svg-1" }], ["path", { "d": "M14 19v-5l-2.5 -3l2.5 -4", "key": "svg-2" }], ["path", { "d": "M8 8l3 -1h4l1 3h3", "key": "svg-3" }], ["path", { "d": "M17.5 21a.5 .5 0 1 0 0 -1a.5 .5 0 0 0 0 1z", "fill": "currentColor", "key": "svg-4" }], ["path", { "d": "M3 18c0 .552 .895 1 2 1h14c1.105 0 2 -.448 2 -1", "key": "svg-5" }], ["path", { "d": "M6.5 21a.5 .5 0 1 0 0 -1a.5 .5 0 0 0 0 1z", "fill": "currentColor", "key": "svg-6" }]]);

var IconSkateboarding$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSkateboarding
});

var IconSkewX = createReactComponent("outline", "skew-x", "IconSkewX", [["path", { "d": "M4 5.205v13.59a1 1 0 0 0 1.184 .983l14 -2.625a1 1 0 0 0 .816 -.983v-8.34a1 1 0 0 0 -.816 -.983l-14 -2.625a1 1 0 0 0 -1.184 .983z", "key": "svg-0" }]]);

var IconSkewX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSkewX
});

var IconSkewY = createReactComponent("outline", "skew-y", "IconSkewY", [["path", { "d": "M4.326 19h15.348a1 1 0 0 0 .962 -1.275l-3.429 -12a1 1 0 0 0 -.961 -.725h-8.492a1 1 0 0 0 -.961 .725l-3.429 12a1 1 0 0 0 .962 1.275z", "key": "svg-0" }]]);

var IconSkewY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSkewY
});

var IconSkiJumping = createReactComponent("outline", "ski-jumping", "IconSkiJumping", [["path", { "d": "M11 3a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M17 17.5l-5 -4.5v-6l5 4", "key": "svg-1" }], ["path", { "d": "M7 17.5l5 -4.5", "key": "svg-2" }], ["path", { "d": "M15.103 21.58l6.762 -14.502a2 2 0 0 0 -.968 -2.657", "key": "svg-3" }], ["path", { "d": "M8.897 21.58l-6.762 -14.503a2 2 0 0 1 .968 -2.657", "key": "svg-4" }], ["path", { "d": "M7 11l5 -4", "key": "svg-5" }]]);

var IconSkiJumping$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSkiJumping
});

var IconSkull = createReactComponent("outline", "skull", "IconSkull", [["path", { "d": "M12 4c4.418 0 8 3.358 8 7.5c0 1.901 -.755 3.637 -2 4.96l0 2.54a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-2.54c-1.245 -1.322 -2 -3.058 -2 -4.96c0 -4.142 3.582 -7.5 8 -7.5z", "key": "svg-0" }], ["path", { "d": "M10 17v3", "key": "svg-1" }], ["path", { "d": "M14 17v3", "key": "svg-2" }], ["path", { "d": "M9 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M15 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }]]);

var IconSkull$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSkull
});

var IconSlash = createReactComponent("outline", "slash", "IconSlash", [["path", { "d": "M17 5l-10 14", "key": "svg-0" }]]);

var IconSlash$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSlash
});

var IconSlashes = createReactComponent("outline", "slashes", "IconSlashes", [["path", { "d": "M14 5l-10 14", "key": "svg-0" }], ["path", { "d": "M20 5l-10 14", "key": "svg-1" }]]);

var IconSlashes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSlashes
});

var IconSleigh = createReactComponent("outline", "sleigh", "IconSleigh", [["path", { "d": "M3 19h15a4 4 0 0 0 4 -4", "key": "svg-0" }], ["path", { "d": "M16 15h-9a4 4 0 0 1 -4 -4v-6l1.243 1.243a6 6 0 0 0 4.242 1.757h3.515v2a2 2 0 0 0 2 2h.5a1.5 1.5 0 0 0 1.5 -1.5a1.5 1.5 0 0 1 3 0v1.5a3 3 0 0 1 -3 3z", "key": "svg-1" }], ["path", { "d": "M15 15v4", "key": "svg-2" }], ["path", { "d": "M7 15v4", "key": "svg-3" }]]);

var IconSleigh$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSleigh
});

var IconSlice = createReactComponent("outline", "slice", "IconSlice", [["path", { "d": "M3 19l15 -15l3 3l-6 6l2 2a14 14 0 0 1 -14 4", "key": "svg-0" }]]);

var IconSlice$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSlice
});

var IconSlideshow = createReactComponent("outline", "slideshow", "IconSlideshow", [["path", { "d": "M15 6l.01 0", "key": "svg-0" }], ["path", { "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-1" }], ["path", { "d": "M3 13l4 -4a3 5 0 0 1 3 0l4 4", "key": "svg-2" }], ["path", { "d": "M13 12l2 -2a3 5 0 0 1 3 0l3 3", "key": "svg-3" }], ["path", { "d": "M8 21l.01 0", "key": "svg-4" }], ["path", { "d": "M12 21l.01 0", "key": "svg-5" }], ["path", { "d": "M16 21l.01 0", "key": "svg-6" }]]);

var IconSlideshow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSlideshow
});

var IconSmartHomeOff = createReactComponent("outline", "smart-home-off", "IconSmartHomeOff", [["path", { "d": "M7.097 7.125l-2.037 1.585a2.665 2.665 0 0 0 -1.029 2.105v7.2a2 2 0 0 0 2 2h12c.559 0 1.064 -.229 1.427 -.598m.572 -3.417v-5.185c0 -.823 -.38 -1.6 -1.03 -2.105l-5.333 -4.148a2.666 2.666 0 0 0 -3.274 0l-1.029 .8", "key": "svg-0" }], ["path", { "d": "M15.332 15.345c-2.213 .976 -5.335 .86 -7.332 -.345", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconSmartHomeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSmartHomeOff
});

var IconSmartHome = createReactComponent("outline", "smart-home", "IconSmartHome", [["path", { "d": "M19 8.71l-5.333 -4.148a2.666 2.666 0 0 0 -3.274 0l-5.334 4.148a2.665 2.665 0 0 0 -1.029 2.105v7.2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-7.2c0 -.823 -.38 -1.6 -1.03 -2.105", "key": "svg-0" }], ["path", { "d": "M16 15c-2.21 1.333 -5.792 1.333 -8 0", "key": "svg-1" }]]);

var IconSmartHome$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSmartHome
});

var IconSmokingNo = createReactComponent("outline", "smoking-no", "IconSmokingNo", [["path", { "d": "M8 13l0 4", "key": "svg-0" }], ["path", { "d": "M16 5v.5a2 2 0 0 0 2 2a2 2 0 0 1 2 2v.5", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }], ["path", { "d": "M17 13h3a1 1 0 0 1 1 1v2c0 .28 -.115 .533 -.3 .714m-3.7 .286h-13a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h9", "key": "svg-3" }]]);

var IconSmokingNo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSmokingNo
});

var IconSmoking = createReactComponent("outline", "smoking", "IconSmoking", [["path", { "d": "M3 13m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M8 13l0 4", "key": "svg-1" }], ["path", { "d": "M16 5v.5a2 2 0 0 0 2 2a2 2 0 0 1 2 2v.5", "key": "svg-2" }]]);

var IconSmoking$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSmoking
});

var IconSnowboarding = createReactComponent("outline", "snowboarding", "IconSnowboarding", [["path", { "d": "M15 3a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M7 19l4 -2.5l-.5 -1.5", "key": "svg-1" }], ["path", { "d": "M16 21l-1 -6l-4.5 -3l3.5 -6", "key": "svg-2" }], ["path", { "d": "M7 9l1.5 -3h5.5l2 4l3 1", "key": "svg-3" }], ["path", { "d": "M3 17c.399 1.154 .899 1.805 1.5 1.951c6 1.464 10.772 2.262 13.5 2.927c1.333 .325 2.333 0 3 -.976", "key": "svg-4" }]]);

var IconSnowboarding$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSnowboarding
});

var IconSnowflakeOff = createReactComponent("outline", "snowflake-off", "IconSnowflakeOff", [["path", { "d": "M10 4l2 1l2 -1", "key": "svg-0" }], ["path", { "d": "M12 2v6m1.196 1.186l1.804 1.034", "key": "svg-1" }], ["path", { "d": "M17.928 6.268l.134 2.232l1.866 1.232", "key": "svg-2" }], ["path", { "d": "M20.66 7l-5.629 3.25l-.031 .75", "key": "svg-3" }], ["path", { "d": "M19.928 14.268l-1.015 .67", "key": "svg-4" }], ["path", { "d": "M14.212 14.226l-2.171 1.262", "key": "svg-5" }], ["path", { "d": "M14 20l-2 -1l-2 1", "key": "svg-6" }], ["path", { "d": "M12 22v-6.5l-3 -1.72", "key": "svg-7" }], ["path", { "d": "M6.072 17.732l-.134 -2.232l-1.866 -1.232", "key": "svg-8" }], ["path", { "d": "M3.34 17l5.629 -3.25l-.01 -3.458", "key": "svg-9" }], ["path", { "d": "M4.072 9.732l1.866 -1.232l.134 -2.232", "key": "svg-10" }], ["path", { "d": "M3.34 7l5.629 3.25l.802 -.466", "key": "svg-11" }], ["path", { "d": "M3 3l18 18", "key": "svg-12" }]]);

var IconSnowflakeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSnowflakeOff
});

var IconSnowflake = createReactComponent("outline", "snowflake", "IconSnowflake", [["path", { "d": "M10 4l2 1l2 -1", "key": "svg-0" }], ["path", { "d": "M12 2v6.5l3 1.72", "key": "svg-1" }], ["path", { "d": "M17.928 6.268l.134 2.232l1.866 1.232", "key": "svg-2" }], ["path", { "d": "M20.66 7l-5.629 3.25l.01 3.458", "key": "svg-3" }], ["path", { "d": "M19.928 14.268l-1.866 1.232l-.134 2.232", "key": "svg-4" }], ["path", { "d": "M20.66 17l-5.629 -3.25l-2.99 1.738", "key": "svg-5" }], ["path", { "d": "M14 20l-2 -1l-2 1", "key": "svg-6" }], ["path", { "d": "M12 22v-6.5l-3 -1.72", "key": "svg-7" }], ["path", { "d": "M6.072 17.732l-.134 -2.232l-1.866 -1.232", "key": "svg-8" }], ["path", { "d": "M3.34 17l5.629 -3.25l-.01 -3.458", "key": "svg-9" }], ["path", { "d": "M4.072 9.732l1.866 -1.232l.134 -2.232", "key": "svg-10" }], ["path", { "d": "M3.34 7l5.629 3.25l2.99 -1.738", "key": "svg-11" }]]);

var IconSnowflake$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSnowflake
});

var IconSnowman = createReactComponent("outline", "snowman", "IconSnowman", [["path", { "d": "M12 3a4 4 0 0 1 2.906 6.75a6 6 0 1 1 -5.81 0a4 4 0 0 1 2.904 -6.75z", "key": "svg-0" }], ["path", { "d": "M17.5 11.5l2.5 -1.5", "key": "svg-1" }], ["path", { "d": "M6.5 11.5l-2.5 -1.5", "key": "svg-2" }], ["path", { "d": "M12 13h.01", "key": "svg-3" }], ["path", { "d": "M12 16h.01", "key": "svg-4" }]]);

var IconSnowman$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSnowman
});

var IconSoccerField = createReactComponent("outline", "soccer-field", "IconSoccerField", [["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M3 9h3v6h-3z", "key": "svg-1" }], ["path", { "d": "M18 9h3v6h-3z", "key": "svg-2" }], ["path", { "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-3" }], ["path", { "d": "M12 5l0 14", "key": "svg-4" }]]);

var IconSoccerField$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSoccerField
});

var IconSocialOff = createReactComponent("outline", "social-off", "IconSocialOff", [["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M17.57 17.602a2 2 0 0 0 2.83 2.827", "key": "svg-2" }], ["path", { "d": "M11.113 11.133a3 3 0 1 0 3.765 3.715", "key": "svg-3" }], ["path", { "d": "M12 7v1", "key": "svg-4" }], ["path", { "d": "M6.7 17.8l2.8 -2", "key": "svg-5" }], ["path", { "d": "M17.3 17.8l-2.8 -2", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconSocialOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSocialOff
});

var IconSocial = createReactComponent("outline", "social", "IconSocial", [["path", { "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M12 14m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M12 7l0 4", "key": "svg-4" }], ["path", { "d": "M6.7 17.8l2.8 -2", "key": "svg-5" }], ["path", { "d": "M17.3 17.8l-2.8 -2", "key": "svg-6" }]]);

var IconSocial$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSocial
});

var IconSock = createReactComponent("outline", "sock", "IconSock", [["path", { "d": "M13 3v6l4.798 5.142a4 4 0 0 1 -5.441 5.86l-6.736 -6.41a2 2 0 0 1 -.621 -1.451v-9.141h8z", "key": "svg-0" }], ["path", { "d": "M7.895 15.768c.708 -.721 1.105 -1.677 1.105 -2.768a4 4 0 0 0 -4 -4", "key": "svg-1" }]]);

var IconSock$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSock
});

var IconSofaOff = createReactComponent("outline", "sofa-off", "IconSofaOff", [["path", { "d": "M18 14v-1a2 2 0 1 1 4 0v5m-3 1h-16a1 1 0 0 1 -1 -1v-5a2 2 0 1 1 4 0v1h8", "key": "svg-0" }], ["path", { "d": "M4 11v-3c0 -1.082 .573 -2.03 1.432 -2.558m3.568 -.442h8a3 3 0 0 1 3 3v3", "key": "svg-1" }], ["path", { "d": "M12 5v3m0 4v2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconSofaOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSofaOff
});

var IconSofa = createReactComponent("outline", "sofa", "IconSofa", [["path", { "d": "M4 11a2 2 0 0 1 2 2v1h12v-1a2 2 0 1 1 4 0v5a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1 -1v-5a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M4 11v-3a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v3", "key": "svg-1" }], ["path", { "d": "M12 5v9", "key": "svg-2" }]]);

var IconSofa$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSofa
});

var IconSolarElectricity = createReactComponent("outline", "solar-electricity", "IconSolarElectricity", [["path", { "d": "M4 6.28v11.44a1 1 0 0 0 1.243 .97l6 -1.5a1 1 0 0 0 .757 -.97v-8.44a1 1 0 0 0 -.757 -.97l-6 -1.5a1 1 0 0 0 -1.243 .97z", "key": "svg-0" }], ["path", { "d": "M8 6v12", "key": "svg-1" }], ["path", { "d": "M12 12h-8", "key": "svg-2" }], ["path", { "d": "M20 7l-3 5h4l-3 5", "key": "svg-3" }]]);

var IconSolarElectricity$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSolarElectricity
});

var IconSolarPanel2 = createReactComponent("outline", "solar-panel-2", "IconSolarPanel2", [["path", { "d": "M8 2a4 4 0 1 0 8 0", "key": "svg-0" }], ["path", { "d": "M4 3h1", "key": "svg-1" }], ["path", { "d": "M19 3h1", "key": "svg-2" }], ["path", { "d": "M12 9v1", "key": "svg-3" }], ["path", { "d": "M17.2 7.2l.707 .707", "key": "svg-4" }], ["path", { "d": "M6.8 7.2l-.7 .7", "key": "svg-5" }], ["path", { "d": "M4.28 21h15.44a1 1 0 0 0 .97 -1.243l-1.5 -6a1 1 0 0 0 -.97 -.757h-12.44a1 1 0 0 0 -.97 .757l-1.5 6a1 1 0 0 0 .97 1.243z", "key": "svg-6" }], ["path", { "d": "M4 17h16", "key": "svg-7" }], ["path", { "d": "M10 13l-1 8", "key": "svg-8" }], ["path", { "d": "M14 13l1 8", "key": "svg-9" }]]);

var IconSolarPanel2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSolarPanel2
});

var IconSolarPanel = createReactComponent("outline", "solar-panel", "IconSolarPanel", [["path", { "d": "M4.28 14h15.44a1 1 0 0 0 .97 -1.243l-1.5 -6a1 1 0 0 0 -.97 -.757h-12.44a1 1 0 0 0 -.97 .757l-1.5 6a1 1 0 0 0 .97 1.243z", "key": "svg-0" }], ["path", { "d": "M4 10h16", "key": "svg-1" }], ["path", { "d": "M10 6l-1 8", "key": "svg-2" }], ["path", { "d": "M14 6l1 8", "key": "svg-3" }], ["path", { "d": "M12 14v4", "key": "svg-4" }], ["path", { "d": "M7 18h10", "key": "svg-5" }]]);

var IconSolarPanel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSolarPanel
});

var IconSort09 = createReactComponent("outline", "sort-0-9", "IconSort09", [["path", { "d": "M11 12h2", "key": "svg-0" }], ["path", { "d": "M4 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", "key": "svg-1" }], ["path", { "d": "M16 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-2" }]]);

var IconSort09$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSort09
});

var IconSort90 = createReactComponent("outline", "sort-9-0", "IconSort90", [["path", { "d": "M4 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M16 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", "key": "svg-1" }], ["path", { "d": "M11 12h2", "key": "svg-2" }]]);

var IconSort90$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSort90
});

var IconSortAZ = createReactComponent("outline", "sort-a-z", "IconSortAZ", [["path", { "d": "M16 8h4l-4 8h4", "key": "svg-0" }], ["path", { "d": "M4 16v-6a2 2 0 1 1 4 0v6", "key": "svg-1" }], ["path", { "d": "M4 13h4", "key": "svg-2" }], ["path", { "d": "M11 12h2", "key": "svg-3" }]]);

var IconSortAZ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortAZ
});

var IconSortAscending2 = createReactComponent("outline", "sort-ascending-2", "IconSortAscending2", [["path", { "d": "M14 9l3 -3l3 3", "key": "svg-0" }], ["path", { "d": "M5 5m0 .5a.5 .5 0 0 1 .5 -.5h4a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-4a.5 .5 0 0 1 -.5 -.5z", "key": "svg-1" }], ["path", { "d": "M5 14m0 .5a.5 .5 0 0 1 .5 -.5h4a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-4a.5 .5 0 0 1 -.5 -.5z", "key": "svg-2" }], ["path", { "d": "M17 6v12", "key": "svg-3" }]]);

var IconSortAscending2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortAscending2
});

var IconSortAscendingLetters = createReactComponent("outline", "sort-ascending-letters", "IconSortAscendingLetters", [["path", { "d": "M15 10v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4", "key": "svg-0" }], ["path", { "d": "M19 21h-4l4 -7h-4", "key": "svg-1" }], ["path", { "d": "M4 15l3 3l3 -3", "key": "svg-2" }], ["path", { "d": "M7 6v12", "key": "svg-3" }]]);

var IconSortAscendingLetters$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortAscendingLetters
});

var IconSortAscendingNumbers = createReactComponent("outline", "sort-ascending-numbers", "IconSortAscendingNumbers", [["path", { "d": "M4 15l3 3l3 -3", "key": "svg-0" }], ["path", { "d": "M7 6v12", "key": "svg-1" }], ["path", { "d": "M17 3a2 2 0 0 1 2 2v3a2 2 0 1 1 -4 0v-3a2 2 0 0 1 2 -2z", "key": "svg-2" }], ["path", { "d": "M17 16m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19 16v3a2 2 0 0 1 -2 2h-1.5", "key": "svg-4" }]]);

var IconSortAscendingNumbers$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortAscendingNumbers
});

var IconSortAscendingShapes = createReactComponent("outline", "sort-ascending-shapes", "IconSortAscendingShapes", [["path", { "d": "M4 15l3 3l3 -3", "key": "svg-0" }], ["path", { "d": "M7 6v12", "key": "svg-1" }], ["path", { "d": "M14 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z", "key": "svg-2" }], ["path", { "d": "M17 14l-3.5 6h7z", "key": "svg-3" }]]);

var IconSortAscendingShapes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortAscendingShapes
});

var IconSortAscendingSmallBig = createReactComponent("outline", "sort-ascending-small-big", "IconSortAscendingSmallBig", [["path", { "d": "M4 15l3 3l3 -3", "key": "svg-0" }], ["path", { "d": "M7 6v12", "key": "svg-1" }], ["path", { "d": "M14 5.667c0 -.369 .298 -.667 .667 -.667h2.666c.369 0 .667 .298 .667 .667v2.666a.667 .667 0 0 1 -.667 .667h-2.666a.667 .667 0 0 1 -.667 -.667v-2.666z", "key": "svg-2" }], ["path", { "d": "M14 13.167c0 -.645 .522 -1.167 1.167 -1.167h4.666c.645 0 1.167 .522 1.167 1.167v4.666c0 .645 -.522 1.167 -1.167 1.167h-4.666a1.167 1.167 0 0 1 -1.167 -1.167v-4.666z", "key": "svg-3" }]]);

var IconSortAscendingSmallBig$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortAscendingSmallBig
});

var IconSortAscending = createReactComponent("outline", "sort-ascending", "IconSortAscending", [["path", { "d": "M4 6l7 0", "key": "svg-0" }], ["path", { "d": "M4 12l7 0", "key": "svg-1" }], ["path", { "d": "M4 18l9 0", "key": "svg-2" }], ["path", { "d": "M15 9l3 -3l3 3", "key": "svg-3" }], ["path", { "d": "M18 6l0 12", "key": "svg-4" }]]);

var IconSortAscending$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortAscending
});

var IconSortDescending2 = createReactComponent("outline", "sort-descending-2", "IconSortDescending2", [["path", { "d": "M5 5m0 .5a.5 .5 0 0 1 .5 -.5h4a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-4a.5 .5 0 0 1 -.5 -.5z", "key": "svg-0" }], ["path", { "d": "M5 14m0 .5a.5 .5 0 0 1 .5 -.5h4a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-4a.5 .5 0 0 1 -.5 -.5z", "key": "svg-1" }], ["path", { "d": "M14 15l3 3l3 -3", "key": "svg-2" }], ["path", { "d": "M17 18v-12", "key": "svg-3" }]]);

var IconSortDescending2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortDescending2
});

var IconSortDescendingLetters = createReactComponent("outline", "sort-descending-letters", "IconSortDescendingLetters", [["path", { "d": "M15 21v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4", "key": "svg-0" }], ["path", { "d": "M19 10h-4l4 -7h-4", "key": "svg-1" }], ["path", { "d": "M4 15l3 3l3 -3", "key": "svg-2" }], ["path", { "d": "M7 6v12", "key": "svg-3" }]]);

var IconSortDescendingLetters$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortDescendingLetters
});

var IconSortDescendingNumbers = createReactComponent("outline", "sort-descending-numbers", "IconSortDescendingNumbers", [["path", { "d": "M4 15l3 3l3 -3", "key": "svg-0" }], ["path", { "d": "M7 6v12", "key": "svg-1" }], ["path", { "d": "M17 14a2 2 0 0 1 2 2v3a2 2 0 1 1 -4 0v-3a2 2 0 0 1 2 -2z", "key": "svg-2" }], ["path", { "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19 5v3a2 2 0 0 1 -2 2h-1.5", "key": "svg-4" }]]);

var IconSortDescendingNumbers$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortDescendingNumbers
});

var IconSortDescendingShapes = createReactComponent("outline", "sort-descending-shapes", "IconSortDescendingShapes", [["path", { "d": "M4 15l3 3l3 -3", "key": "svg-0" }], ["path", { "d": "M7 6v12", "key": "svg-1" }], ["path", { "d": "M14 15a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z", "key": "svg-2" }], ["path", { "d": "M17 4l-3.5 6h7z", "key": "svg-3" }]]);

var IconSortDescendingShapes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortDescendingShapes
});

var IconSortDescendingSmallBig = createReactComponent("outline", "sort-descending-small-big", "IconSortDescendingSmallBig", [["path", { "d": "M10 15l-3 3l-3 -3", "key": "svg-0" }], ["path", { "d": "M7 6v12", "key": "svg-1" }], ["path", { "d": "M14 18.333c0 .369 .298 .667 .667 .667h2.666a.667 .667 0 0 0 .667 -.667v-2.666a.667 .667 0 0 0 -.667 -.667h-2.666a.667 .667 0 0 0 -.667 .667v2.666z", "key": "svg-2" }], ["path", { "d": "M14 10.833c0 .645 .522 1.167 1.167 1.167h4.666c.645 0 1.167 -.522 1.167 -1.167v-4.666c0 -.645 -.522 -1.167 -1.167 -1.167h-4.666c-.645 0 -1.167 .522 -1.167 1.167v4.666z", "key": "svg-3" }]]);

var IconSortDescendingSmallBig$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortDescendingSmallBig
});

var IconSortDescending = createReactComponent("outline", "sort-descending", "IconSortDescending", [["path", { "d": "M4 6l9 0", "key": "svg-0" }], ["path", { "d": "M4 12l7 0", "key": "svg-1" }], ["path", { "d": "M4 18l7 0", "key": "svg-2" }], ["path", { "d": "M15 15l3 3l3 -3", "key": "svg-3" }], ["path", { "d": "M18 6l0 12", "key": "svg-4" }]]);

var IconSortDescending$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortDescending
});

var IconSortZA = createReactComponent("outline", "sort-z-a", "IconSortZA", [["path", { "d": "M4 8h4l-4 8h4", "key": "svg-0" }], ["path", { "d": "M16 16v-6a2 2 0 1 1 4 0v6", "key": "svg-1" }], ["path", { "d": "M16 13h4", "key": "svg-2" }], ["path", { "d": "M11 12h2", "key": "svg-3" }]]);

var IconSortZA$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortZA
});

var IconSos = createReactComponent("outline", "sos", "IconSos", [["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M17 15c.345 .6 1.258 1 2 1a2 2 0 1 0 0 -4a2 2 0 1 1 0 -4c.746 0 1.656 .394 2 1", "key": "svg-1" }], ["path", { "d": "M3 15c.345 .6 1.258 1 2 1a2 2 0 1 0 0 -4a2 2 0 1 1 0 -4c.746 0 1.656 .394 2 1", "key": "svg-2" }]]);

var IconSos$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSos
});

var IconSoupOff = createReactComponent("outline", "soup-off", "IconSoupOff", [["path", { "d": "M3 19h16", "key": "svg-0" }], ["path", { "d": "M15 11h6c0 1.691 -.525 3.26 -1.42 4.552m-2.034 2.032a7.963 7.963 0 0 1 -4.546 1.416h-2a8 8 0 0 1 -8 -8h8", "key": "svg-1" }], ["path", { "d": "M12 5v3", "key": "svg-2" }], ["path", { "d": "M15 5v3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconSoupOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSoupOff
});

var IconSoup = createReactComponent("outline", "soup", "IconSoup", [["path", { "d": "M4 11h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M12 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2", "key": "svg-1" }], ["path", { "d": "M16 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2", "key": "svg-2" }], ["path", { "d": "M8 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2", "key": "svg-3" }]]);

var IconSoup$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSoup
});

var IconSourceCode = createReactComponent("outline", "source-code", "IconSourceCode", [["path", { "d": "M14.5 4h2.5a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-5", "key": "svg-0" }], ["path", { "d": "M6 5l-2 2l2 2", "key": "svg-1" }], ["path", { "d": "M10 9l2 -2l-2 -2", "key": "svg-2" }]]);

var IconSourceCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSourceCode
});

var IconSpaceOff = createReactComponent("outline", "space-off", "IconSpaceOff", [["path", { "d": "M4 10v3a1 1 0 0 0 1 1h9m4 0h1a1 1 0 0 0 1 -1v-3", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconSpaceOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpaceOff
});

var IconSpace = createReactComponent("outline", "space", "IconSpace", [["path", { "d": "M4 10v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-3", "key": "svg-0" }]]);

var IconSpace$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpace
});

var IconSpaces = createReactComponent("outline", "spaces", "IconSpaces", [["path", { "d": "M6.045 9.777a6 6 0 1 0 5.951 .023", "key": "svg-0" }], ["path", { "d": "M11.997 20.196a6 6 0 1 0 -2.948 -5.97", "key": "svg-1" }], ["path", { "d": "M17.95 9.785q .05 -.386 .05 -.785a6 6 0 1 0 -3.056 5.23", "key": "svg-2" }]]);

var IconSpaces$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpaces
});

var IconSpacingHorizontal = createReactComponent("outline", "spacing-horizontal", "IconSpacingHorizontal", [["path", { "d": "M20 20h-2a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 20h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2", "key": "svg-1" }], ["path", { "d": "M12 8v8", "key": "svg-2" }]]);

var IconSpacingHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpacingHorizontal
});

var IconSpacingVertical = createReactComponent("outline", "spacing-vertical", "IconSpacingVertical", [["path", { "d": "M4 20v-2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2", "key": "svg-0" }], ["path", { "d": "M4 4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2", "key": "svg-1" }], ["path", { "d": "M16 12h-8", "key": "svg-2" }]]);

var IconSpacingVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpacingVertical
});

var IconSpade = createReactComponent("outline", "spade", "IconSpade", [["path", { "d": "M12 3l4.919 4.5c.61 .587 1.177 1.177 1.703 1.771a5.527 5.527 0 0 1 .264 6.979c-1.18 1.56 -3.338 1.92 -4.886 .75v1l1 3h-6l1 -3v-1c-1.54 1.07 -3.735 .772 -4.886 -.75a5.527 5.527 0 0 1 .264 -6.979a30.883 30.883 0 0 1 1.703 -1.771a1541.72 1541.72 0 0 1 4.919 -4.5z", "key": "svg-0" }]]);

var IconSpade$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpade
});

var IconSparkles = createReactComponent("outline", "sparkles", "IconSparkles", [["path", { "d": "M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z", "key": "svg-0" }]]);

var IconSparkles$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSparkles
});

var IconSpeakerphone = createReactComponent("outline", "speakerphone", "IconSpeakerphone", [["path", { "d": "M18 8a3 3 0 0 1 0 6", "key": "svg-0" }], ["path", { "d": "M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5", "key": "svg-1" }], ["path", { "d": "M12 8h0l4.524 -3.77a.9 .9 0 0 1 1.476 .692v12.156a.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8", "key": "svg-2" }]]);

var IconSpeakerphone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpeakerphone
});

var IconSpeedboat = createReactComponent("outline", "speedboat", "IconSpeedboat", [["path", { "d": "M2 17h14.4a3 3 0 0 0 2.5 -1.34l3.1 -4.66h-6.23a4 4 0 0 0 -1.49 .29l-3.56 1.42a4 4 0 0 1 -1.49 .29h-5.73z", "key": "svg-0" }], ["path", { "d": "M6 13l1.5 -5", "key": "svg-1" }], ["path", { "d": "M6 8h8l2 3", "key": "svg-2" }]]);

var IconSpeedboat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpeedboat
});

var IconSphereOff = createReactComponent("outline", "sphere-off", "IconSphereOff", [["path", { "d": "M3 12c0 1.657 4.03 3 9 3c.987 0 1.936 -.053 2.825 -.15m3.357 -.67c1.735 -.547 2.818 -1.32 2.818 -2.18", "key": "svg-0" }], ["path", { "d": "M20.051 16.027a9 9 0 0 0 -12.083 -12.075m-2.34 1.692a9 9 0 0 0 12.74 12.716", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconSphereOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSphereOff
});

var IconSpherePlus = createReactComponent("outline", "sphere-plus", "IconSpherePlus", [["path", { "d": "M3 12c0 1.657 4.03 3 9 3c1.116 0 2.185 -.068 3.172 -.192m5.724 -2.35a1.1 1.1 0 0 0 .104 -.458", "key": "svg-0" }], ["path", { "d": "M20.984 12.546a9 9 0 1 0 -8.442 8.438", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconSpherePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpherePlus
});

var IconSphere = createReactComponent("outline", "sphere", "IconSphere", [["path", { "d": "M3 12c0 1.657 4.03 3 9 3s9 -1.343 9 -3", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

var IconSphere$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSphere
});

var IconSpider = createReactComponent("outline", "spider", "IconSpider", [["path", { "d": "M5 4v2l5 5", "key": "svg-0" }], ["path", { "d": "M2.5 9.5l1.5 1.5h6", "key": "svg-1" }], ["path", { "d": "M4 19v-2l6 -6", "key": "svg-2" }], ["path", { "d": "M19 4v2l-5 5", "key": "svg-3" }], ["path", { "d": "M21.5 9.5l-1.5 1.5h-6", "key": "svg-4" }], ["path", { "d": "M20 19v-2l-6 -6", "key": "svg-5" }], ["path", { "d": "M12 15m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-6" }], ["path", { "d": "M12 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-7" }]]);

var IconSpider$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpider
});

var IconSpiralOff = createReactComponent("outline", "spiral-off", "IconSpiralOff", [["path", { "d": "M10 12.057a1.9 1.9 0 0 0 .614 .743c.682 .459 1.509 .374 2.164 -.02m1.103 -2.92a3.298 3.298 0 0 0 -1.749 -2.059a3.6 3.6 0 0 0 -.507 -.195m-3.385 .634a4.154 4.154 0 0 0 -1.347 1.646c-1.095 2.432 .29 5.248 2.71 6.246c1.955 .806 4.097 .35 5.65 -.884m1.745 -2.268l.043 -.103c1.36 -3.343 -.557 -7.134 -3.896 -8.41c-1.593 -.61 -3.27 -.599 -4.79 -.113m-2.579 1.408a7.574 7.574 0 0 0 -2.268 3.128c-1.63 4.253 .823 9.024 5.082 10.576c3.211 1.17 6.676 .342 9.124 -1.738m1.869 -2.149a9.354 9.354 0 0 0 1.417 -4.516", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconSpiralOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpiralOff
});

var IconSpiral = createReactComponent("outline", "spiral", "IconSpiral", [["path", { "d": "M10 12.057a1.9 1.9 0 0 0 .614 .743c1.06 .713 2.472 .112 3.043 -.919c.839 -1.513 -.022 -3.368 -1.525 -4.08c-2 -.95 -4.371 .154 -5.24 2.086c-1.095 2.432 .29 5.248 2.71 6.246c2.931 1.208 6.283 -.418 7.438 -3.255c1.36 -3.343 -.557 -7.134 -3.896 -8.41c-3.855 -1.474 -8.2 .68 -9.636 4.422c-1.63 4.253 .823 9.024 5.082 10.576c4.778 1.74 10.118 -.941 11.833 -5.59a9.354 9.354 0 0 0 .577 -2.813", "key": "svg-0" }]]);

var IconSpiral$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpiral
});

var IconSportBillard = createReactComponent("outline", "sport-billard", "IconSportBillard", [["path", { "d": "M12 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0", "key": "svg-2" }]]);

var IconSportBillard$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSportBillard
});

var IconSpray = createReactComponent("outline", "spray", "IconSpray", [["path", { "d": "M4 10m0 2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M6 10v-4a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4", "key": "svg-1" }], ["path", { "d": "M15 7h.01", "key": "svg-2" }], ["path", { "d": "M18 9h.01", "key": "svg-3" }], ["path", { "d": "M18 5h.01", "key": "svg-4" }], ["path", { "d": "M21 3h.01", "key": "svg-5" }], ["path", { "d": "M21 7h.01", "key": "svg-6" }], ["path", { "d": "M21 11h.01", "key": "svg-7" }], ["path", { "d": "M10 7h1", "key": "svg-8" }]]);

var IconSpray$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpray
});

var IconSpyOff = createReactComponent("outline", "spy-off", "IconSpyOff", [["path", { "d": "M3 11h8m4 0h6", "key": "svg-0" }], ["path", { "d": "M5 11v-4c0 -.571 .16 -1.105 .437 -1.56m2.563 -1.44h8a3 3 0 0 1 3 3v4", "key": "svg-1" }], ["path", { "d": "M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M14.88 14.877a3 3 0 1 0 4.239 4.247m.59 -3.414a3.012 3.012 0 0 0 -1.425 -1.422", "key": "svg-3" }], ["path", { "d": "M10 17h4", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconSpyOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpyOff
});

var IconSpy = createReactComponent("outline", "spy", "IconSpy", [["path", { "d": "M3 11h18", "key": "svg-0" }], ["path", { "d": "M5 11v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4", "key": "svg-1" }], ["path", { "d": "M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-3" }], ["path", { "d": "M10 17h4", "key": "svg-4" }]]);

var IconSpy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpy
});

var IconSql = createReactComponent("outline", "sql", "IconSql", [["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M17 8v8h4", "key": "svg-1" }], ["path", { "d": "M13 15l1 1", "key": "svg-2" }], ["path", { "d": "M3 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1", "key": "svg-3" }]]);

var IconSql$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSql
});

var IconSquareArrowDown = createReactComponent("outline", "square-arrow-down", "IconSquareArrowDown", [["path", { "d": "M8 12l4 4l4 -4", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }], ["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconSquareArrowDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareArrowDown
});

var IconSquareArrowLeft = createReactComponent("outline", "square-arrow-left", "IconSquareArrowLeft", [["path", { "d": "M12 8l-4 4l4 4", "key": "svg-0" }], ["path", { "d": "M16 12h-8", "key": "svg-1" }], ["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconSquareArrowLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareArrowLeft
});

var IconSquareArrowRight = createReactComponent("outline", "square-arrow-right", "IconSquareArrowRight", [["path", { "d": "M12 16l4 -4l-4 -4", "key": "svg-0" }], ["path", { "d": "M8 12h8", "key": "svg-1" }], ["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconSquareArrowRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareArrowRight
});

var IconSquareArrowUp = createReactComponent("outline", "square-arrow-up", "IconSquareArrowUp", [["path", { "d": "M16 12l-4 -4l-4 4", "key": "svg-0" }], ["path", { "d": "M12 16v-8", "key": "svg-1" }], ["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconSquareArrowUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareArrowUp
});

var IconSquareAsterisk = createReactComponent("outline", "square-asterisk", "IconSquareAsterisk", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 8.5v7", "key": "svg-1" }], ["path", { "d": "M9 10l6 4", "key": "svg-2" }], ["path", { "d": "M9 14l6 -4", "key": "svg-3" }]]);

var IconSquareAsterisk$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareAsterisk
});

var IconSquareCheck = createReactComponent("outline", "square-check", "IconSquareCheck", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 12l2 2l4 -4", "key": "svg-1" }]]);

var IconSquareCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareCheck
});

var IconSquareChevronDown = createReactComponent("outline", "square-chevron-down", "IconSquareChevronDown", [["path", { "d": "M15 11l-3 3l-3 -3", "key": "svg-0" }], ["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconSquareChevronDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronDown
});

var IconSquareChevronLeft = createReactComponent("outline", "square-chevron-left", "IconSquareChevronLeft", [["path", { "d": "M13 15l-3 -3l3 -3", "key": "svg-0" }], ["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconSquareChevronLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronLeft
});

var IconSquareChevronRight = createReactComponent("outline", "square-chevron-right", "IconSquareChevronRight", [["path", { "d": "M11 9l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconSquareChevronRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronRight
});

var IconSquareChevronUp = createReactComponent("outline", "square-chevron-up", "IconSquareChevronUp", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 13l3 -3l3 3", "key": "svg-1" }]]);

var IconSquareChevronUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronUp
});

var IconSquareChevronsDown = createReactComponent("outline", "square-chevrons-down", "IconSquareChevronsDown", [["path", { "d": "M15 8l-3 3l-3 -3", "key": "svg-0" }], ["path", { "d": "M15 13l-3 3l-3 -3", "key": "svg-1" }], ["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-2" }]]);

var IconSquareChevronsDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronsDown
});

var IconSquareChevronsLeft = createReactComponent("outline", "square-chevrons-left", "IconSquareChevronsLeft", [["path", { "d": "M16 15l-3 -3l3 -3", "key": "svg-0" }], ["path", { "d": "M11 15l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-2" }]]);

var IconSquareChevronsLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronsLeft
});

var IconSquareChevronsRight = createReactComponent("outline", "square-chevrons-right", "IconSquareChevronsRight", [["path", { "d": "M8 9l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M13 9l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-2" }]]);

var IconSquareChevronsRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronsRight
});

var IconSquareChevronsUp = createReactComponent("outline", "square-chevrons-up", "IconSquareChevronsUp", [["path", { "d": "M9 16l3 -3l3 3", "key": "svg-0" }], ["path", { "d": "M9 11l3 -3l3 3", "key": "svg-1" }], ["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-2" }]]);

var IconSquareChevronsUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronsUp
});

var IconSquareDashed = createReactComponent("outline", "square-dashed", "IconSquareDashed", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconSquareDashed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareDashed
});

var IconSquareDot = createReactComponent("outline", "square-dot", "IconSquareDot", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }]]);

var IconSquareDot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareDot
});

var IconSquareF0 = createReactComponent("outline", "square-f0", "IconSquareF0", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M13 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-1" }], ["path", { "d": "M8 12h2", "key": "svg-2" }], ["path", { "d": "M10 9h-2v6", "key": "svg-3" }]]);

var IconSquareF0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF0
});

var IconSquareF1 = createReactComponent("outline", "square-f1", "IconSquareF1", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M13 11l2 -2v6", "key": "svg-1" }], ["path", { "d": "M8 12h2", "key": "svg-2" }], ["path", { "d": "M10 9h-2v6", "key": "svg-3" }]]);

var IconSquareF1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF1
});

var IconSquareF2 = createReactComponent("outline", "square-f2", "IconSquareF2", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M13 9h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2", "key": "svg-1" }], ["path", { "d": "M8 12h2", "key": "svg-2" }], ["path", { "d": "M10 9h-2v6", "key": "svg-3" }]]);

var IconSquareF2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF2
});

var IconSquareF3 = createReactComponent("outline", "square-f3", "IconSquareF3", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M13 9.5a.5 .5 0 0 1 .5 -.5h1a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1a.5 .5 0 0 1 -.5 -.5", "key": "svg-1" }], ["path", { "d": "M8 12h2", "key": "svg-2" }], ["path", { "d": "M10 9h-2v6", "key": "svg-3" }]]);

var IconSquareF3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF3
});

var IconSquareF4 = createReactComponent("outline", "square-f4", "IconSquareF4", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M13 9v2a1 1 0 0 0 1 1h1", "key": "svg-1" }], ["path", { "d": "M16 9v6", "key": "svg-2" }], ["path", { "d": "M8 12h2", "key": "svg-3" }], ["path", { "d": "M10 9h-2v6", "key": "svg-4" }]]);

var IconSquareF4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF4
});

var IconSquareF5 = createReactComponent("outline", "square-f5", "IconSquareF5", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M13 14.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2v-3h3", "key": "svg-1" }], ["path", { "d": "M8 12h2", "key": "svg-2" }], ["path", { "d": "M10 9h-2v6", "key": "svg-3" }]]);

var IconSquareF5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF5
});

var IconSquareF6 = createReactComponent("outline", "square-f6", "IconSquareF6", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M16 9.75a.75 .75 0 0 0 -.75 -.75h-1.25a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2", "key": "svg-1" }], ["path", { "d": "M8 12h2", "key": "svg-2" }], ["path", { "d": "M10 9h-2v6", "key": "svg-3" }]]);

var IconSquareF6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF6
});

var IconSquareF7 = createReactComponent("outline", "square-f7", "IconSquareF7", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M13 9h3l-1.5 6", "key": "svg-1" }], ["path", { "d": "M8 12h2", "key": "svg-2" }], ["path", { "d": "M10 9h-2v6", "key": "svg-3" }]]);

var IconSquareF7$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF7
});

var IconSquareF8 = createReactComponent("outline", "square-f8", "IconSquareF8", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14.5 12h-.5a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1", "key": "svg-1" }], ["path", { "d": "M8 12h2", "key": "svg-2" }], ["path", { "d": "M10 9h-2v6", "key": "svg-3" }]]);

var IconSquareF8$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF8
});

var IconSquareF9 = createReactComponent("outline", "square-f9", "IconSquareF9", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M13 14.25c0 .414 .336 .75 .75 .75h1.5a.75 .75 0 0 0 .75 -.75v-4.5a.75 .75 0 0 0 -.75 -.75h-1.5a.75 .75 0 0 0 -.75 .75v1.5c0 .414 .336 .75 .75 .75h2.25", "key": "svg-1" }], ["path", { "d": "M8 12h2", "key": "svg-2" }], ["path", { "d": "M10 9h-2v6", "key": "svg-3" }]]);

var IconSquareF9$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF9
});

var IconSquareForbid2 = createReactComponent("outline", "square-forbid-2", "IconSquareForbid2", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 15l6 -6", "key": "svg-1" }]]);

var IconSquareForbid2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareForbid2
});

var IconSquareForbid = createReactComponent("outline", "square-forbid", "IconSquareForbid", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 9l6 6", "key": "svg-1" }]]);

var IconSquareForbid$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareForbid
});

var IconSquareHalf = createReactComponent("outline", "square-half", "IconSquareHalf", [["path", { "d": "M12 4v16", "key": "svg-0" }], ["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M12 13l7.5 -7.5", "key": "svg-2" }], ["path", { "d": "M12 18l8 -8", "key": "svg-3" }], ["path", { "d": "M15 20l5 -5", "key": "svg-4" }], ["path", { "d": "M12 8l4 -4", "key": "svg-5" }]]);

var IconSquareHalf$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareHalf
});

var IconSquareKey = createReactComponent("outline", "square-key", "IconSquareKey", [["path", { "d": "M14 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12.5 11.5l-4 4l1.5 1.5", "key": "svg-1" }], ["path", { "d": "M12 15l-1.5 -1.5", "key": "svg-2" }], ["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-3" }]]);

var IconSquareKey$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareKey
});

var IconSquareLetterA = createReactComponent("outline", "square-letter-a", "IconSquareLetterA", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 16v-6a2 2 0 1 1 4 0v6", "key": "svg-1" }], ["path", { "d": "M10 13h4", "key": "svg-2" }]]);

var IconSquareLetterA$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterA
});

var IconSquareLetterB = createReactComponent("outline", "square-letter-b", "IconSquareLetterB", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z", "key": "svg-1" }]]);

var IconSquareLetterB$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterB
});

var IconSquareLetterC = createReactComponent("outline", "square-letter-c", "IconSquareLetterC", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-1" }]]);

var IconSquareLetterC$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterC
});

var IconSquareLetterD = createReactComponent("outline", "square-letter-d", "IconSquareLetterD", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", "key": "svg-1" }]]);

var IconSquareLetterD$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterD
});

var IconSquareLetterE = createReactComponent("outline", "square-letter-e", "IconSquareLetterE", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8h4", "key": "svg-1" }], ["path", { "d": "M10 12h2.5", "key": "svg-2" }]]);

var IconSquareLetterE$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterE
});

var IconSquareLetterF = createReactComponent("outline", "square-letter-f", "IconSquareLetterF", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 12h3", "key": "svg-1" }], ["path", { "d": "M14 8h-4v8", "key": "svg-2" }]]);

var IconSquareLetterF$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterF
});

var IconSquareLetterG = createReactComponent("outline", "square-letter-g", "IconSquareLetterG", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-1" }]]);

var IconSquareLetterG$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterG
});

var IconSquareLetterH = createReactComponent("outline", "square-letter-h", "IconSquareLetterH", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 16v-8m4 0v8", "key": "svg-1" }], ["path", { "d": "M10 12h4", "key": "svg-2" }]]);

var IconSquareLetterH$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterH
});

var IconSquareLetterI = createReactComponent("outline", "square-letter-i", "IconSquareLetterI", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }]]);

var IconSquareLetterI$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterI
});

var IconSquareLetterJ = createReactComponent("outline", "square-letter-j", "IconSquareLetterJ", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8h4v6a2 2 0 1 1 -4 0", "key": "svg-1" }]]);

var IconSquareLetterJ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterJ
});

var IconSquareLetterK = createReactComponent("outline", "square-letter-k", "IconSquareLetterK", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8v8", "key": "svg-1" }], ["path", { "d": "M14 8l-2.5 4l2.5 4", "key": "svg-2" }], ["path", { "d": "M10 12h1.5", "key": "svg-3" }]]);

var IconSquareLetterK$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterK
});

var IconSquareLetterL = createReactComponent("outline", "square-letter-l", "IconSquareLetterL", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8v8h4", "key": "svg-1" }]]);

var IconSquareLetterL$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterL
});

var IconSquareLetterM = createReactComponent("outline", "square-letter-m", "IconSquareLetterM", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 16v-8l3 5l3 -5v8", "key": "svg-1" }]]);

var IconSquareLetterM$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterM
});

var IconSquareLetterN = createReactComponent("outline", "square-letter-n", "IconSquareLetterN", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 16v-8l4 8v-8", "key": "svg-1" }]]);

var IconSquareLetterN$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterN
});

var IconSquareLetterO = createReactComponent("outline", "square-letter-o", "IconSquareLetterO", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-1" }]]);

var IconSquareLetterO$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterO
});

var IconSquareLetterP = createReactComponent("outline", "square-letter-p", "IconSquareLetterP", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-1" }]]);

var IconSquareLetterP$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterP
});

var IconSquareLetterQ = createReactComponent("outline", "square-letter-q", "IconSquareLetterQ", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-1" }], ["path", { "d": "M13 15l1 1", "key": "svg-2" }]]);

var IconSquareLetterQ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterQ
});

var IconSquareLetterR = createReactComponent("outline", "square-letter-r", "IconSquareLetterR", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4", "key": "svg-1" }]]);

var IconSquareLetterR$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterR
});

var IconSquareLetterS = createReactComponent("outline", "square-letter-s", "IconSquareLetterS", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1", "key": "svg-1" }]]);

var IconSquareLetterS$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterS
});

var IconSquareLetterT = createReactComponent("outline", "square-letter-t", "IconSquareLetterT", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8h4", "key": "svg-1" }], ["path", { "d": "M12 8v8", "key": "svg-2" }]]);

var IconSquareLetterT$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterT
});

var IconSquareLetterU = createReactComponent("outline", "square-letter-u", "IconSquareLetterU", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8v6a2 2 0 1 0 4 0v-6", "key": "svg-1" }]]);

var IconSquareLetterU$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterU
});

var IconSquareLetterV = createReactComponent("outline", "square-letter-v", "IconSquareLetterV", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8l2 8l2 -8", "key": "svg-1" }]]);

var IconSquareLetterV$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterV
});

var IconSquareLetterW = createReactComponent("outline", "square-letter-w", "IconSquareLetterW", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 8l1 8l2 -5l2 5l1 -8", "key": "svg-1" }]]);

var IconSquareLetterW$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterW
});

var IconSquareLetterX = createReactComponent("outline", "square-letter-x", "IconSquareLetterX", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8l4 8", "key": "svg-1" }], ["path", { "d": "M10 16l4 -8", "key": "svg-2" }]]);

var IconSquareLetterX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterX
});

var IconSquareLetterY = createReactComponent("outline", "square-letter-y", "IconSquareLetterY", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8l2 5l2 -5", "key": "svg-1" }], ["path", { "d": "M12 16v-3", "key": "svg-2" }]]);

var IconSquareLetterY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterY
});

var IconSquareLetterZ = createReactComponent("outline", "square-letter-z", "IconSquareLetterZ", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8h4l-4 8h4", "key": "svg-1" }]]);

var IconSquareLetterZ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterZ
});

var IconSquareMinus = createReactComponent("outline", "square-minus", "IconSquareMinus", [["path", { "d": "M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconSquareMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareMinus
});

var IconSquareNumber0 = createReactComponent("outline", "square-number-0", "IconSquareNumber0", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", "key": "svg-1" }]]);

var IconSquareNumber0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber0
});

var IconSquareNumber1 = createReactComponent("outline", "square-number-1", "IconSquareNumber1", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 10l2 -2v8", "key": "svg-1" }]]);

var IconSquareNumber1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber1
});

var IconSquareNumber2 = createReactComponent("outline", "square-number-2", "IconSquareNumber2", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconSquareNumber2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber2
});

var IconSquareNumber3 = createReactComponent("outline", "square-number-3", "IconSquareNumber3", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1", "key": "svg-1" }]]);

var IconSquareNumber3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber3
});

var IconSquareNumber4 = createReactComponent("outline", "square-number-4", "IconSquareNumber4", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8v3a1 1 0 0 0 1 1h3", "key": "svg-1" }], ["path", { "d": "M14 8v8", "key": "svg-2" }]]);

var IconSquareNumber4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber4
});

var IconSquareNumber5 = createReactComponent("outline", "square-number-5", "IconSquareNumber5", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-1" }]]);

var IconSquareNumber5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber5
});

var IconSquareNumber6 = createReactComponent("outline", "square-number-6", "IconSquareNumber6", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-1" }]]);

var IconSquareNumber6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber6
});

var IconSquareNumber7 = createReactComponent("outline", "square-number-7", "IconSquareNumber7", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 8h4l-2 8", "key": "svg-1" }]]);

var IconSquareNumber7$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber7
});

var IconSquareNumber8 = createReactComponent("outline", "square-number-8", "IconSquareNumber8", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-1" }]]);

var IconSquareNumber8$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber8
});

var IconSquareNumber9 = createReactComponent("outline", "square-number-9", "IconSquareNumber9", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

var IconSquareNumber9$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber9
});

var IconSquareOff = createReactComponent("outline", "square-off", "IconSquareOff", [["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.584 3.412a2 2 0 0 1 -1.416 .588h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.052 .586 -1.414", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconSquareOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareOff
});

var IconSquarePercentage = createReactComponent("outline", "square-percentage", "IconSquarePercentage", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M9 15.037l6 -6", "key": "svg-1" }], ["path", { "d": "M9 9.068v.014", "key": "svg-2" }], ["path", { "d": "M15 15.082v.016", "key": "svg-3" }]]);

var IconSquarePercentage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquarePercentage
});

var IconSquarePlus2 = createReactComponent("outline", "square-plus-2", "IconSquarePlus2", [["path", { "d": "M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconSquarePlus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquarePlus2
});

var IconSquarePlus = createReactComponent("outline", "square-plus", "IconSquarePlus", [["path", { "d": "M9 12h6", "key": "svg-0" }], ["path", { "d": "M12 9v6", "key": "svg-1" }], ["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-2" }]]);

var IconSquarePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquarePlus
});

var IconSquareRoot2 = createReactComponent("outline", "square-root-2", "IconSquareRoot2", [["path", { "d": "M13 12h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1", "key": "svg-0" }], ["path", { "d": "M12 19c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5", "key": "svg-1" }], ["path", { "d": "M3 12h1l3 8l3 -16h10", "key": "svg-2" }]]);

var IconSquareRoot2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoot2
});

var IconSquareRoot = createReactComponent("outline", "square-root", "IconSquareRoot", [["path", { "d": "M3 12h2l4 8l4 -16h8", "key": "svg-0" }]]);

var IconSquareRoot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoot
});

var IconSquareRotatedForbid2 = createReactComponent("outline", "square-rotated-forbid-2", "IconSquareRotatedForbid2", [["path", { "d": "M13.446 2.6l7.955 7.954a2.045 2.045 0 0 1 0 2.892l-7.955 7.955a2.045 2.045 0 0 1 -2.892 0l-7.955 -7.955a2.045 2.045 0 0 1 0 -2.892l7.955 -7.955a2.045 2.045 0 0 1 2.892 0z", "key": "svg-0" }], ["path", { "d": "M9.5 9.5l5 5", "key": "svg-1" }]]);

var IconSquareRotatedForbid2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRotatedForbid2
});

var IconSquareRotatedForbid = createReactComponent("outline", "square-rotated-forbid", "IconSquareRotatedForbid", [["path", { "d": "M13.446 2.6l7.955 7.954a2.045 2.045 0 0 1 0 2.892l-7.955 7.955a2.045 2.045 0 0 1 -2.892 0l-7.955 -7.955a2.045 2.045 0 0 1 0 -2.892l7.955 -7.955a2.045 2.045 0 0 1 2.892 0z", "key": "svg-0" }], ["path", { "d": "M9.5 14.5l5 -5", "key": "svg-1" }]]);

var IconSquareRotatedForbid$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRotatedForbid
});

var IconSquareRotatedOff = createReactComponent("outline", "square-rotated-off", "IconSquareRotatedOff", [["path", { "d": "M16.964 16.952l-3.462 3.461c-.782 .783 -2.222 .783 -3 0l-6.911 -6.91c-.783 -.783 -.783 -2.223 0 -3l3.455 -3.456m2 -2l1.453 -1.452c.782 -.783 2.222 -.783 3 0l6.911 6.91c.783 .783 .783 2.223 0 3l-1.448 1.45", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconSquareRotatedOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRotatedOff
});

var IconSquareRotated = createReactComponent("outline", "square-rotated", "IconSquareRotated", [["path", { "d": "M13.446 2.6l7.955 7.954a2.045 2.045 0 0 1 0 2.892l-7.955 7.955a2.045 2.045 0 0 1 -2.892 0l-7.955 -7.955a2.045 2.045 0 0 1 0 -2.892l7.955 -7.955a2.045 2.045 0 0 1 2.892 0z", "key": "svg-0" }]]);

var IconSquareRotated$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRotated
});

var IconSquareRoundedArrowDown = createReactComponent("outline", "square-rounded-arrow-down", "IconSquareRoundedArrowDown", [["path", { "d": "M8 12l4 4l4 -4", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedArrowDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedArrowDown
});

var IconSquareRoundedArrowLeft = createReactComponent("outline", "square-rounded-arrow-left", "IconSquareRoundedArrowLeft", [["path", { "d": "M12 8l-4 4l4 4", "key": "svg-0" }], ["path", { "d": "M16 12h-8", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedArrowLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedArrowLeft
});

var IconSquareRoundedArrowRight = createReactComponent("outline", "square-rounded-arrow-right", "IconSquareRoundedArrowRight", [["path", { "d": "M12 16l4 -4l-4 -4", "key": "svg-0" }], ["path", { "d": "M8 12h8", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedArrowRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedArrowRight
});

var IconSquareRoundedArrowUp = createReactComponent("outline", "square-rounded-arrow-up", "IconSquareRoundedArrowUp", [["path", { "d": "M16 12l-4 -4l-4 4", "key": "svg-0" }], ["path", { "d": "M12 16v-8", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedArrowUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedArrowUp
});

var IconSquareRoundedCheck = createReactComponent("outline", "square-rounded-check", "IconSquareRoundedCheck", [["path", { "d": "M9 12l2 2l4 -4", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedCheck
});

var IconSquareRoundedChevronDown = createReactComponent("outline", "square-rounded-chevron-down", "IconSquareRoundedChevronDown", [["path", { "d": "M15 11l-3 3l-3 -3", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedChevronDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronDown
});

var IconSquareRoundedChevronLeft = createReactComponent("outline", "square-rounded-chevron-left", "IconSquareRoundedChevronLeft", [["path", { "d": "M13 15l-3 -3l3 -3", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedChevronLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronLeft
});

var IconSquareRoundedChevronRight = createReactComponent("outline", "square-rounded-chevron-right", "IconSquareRoundedChevronRight", [["path", { "d": "M11 9l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedChevronRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronRight
});

var IconSquareRoundedChevronUp = createReactComponent("outline", "square-rounded-chevron-up", "IconSquareRoundedChevronUp", [["path", { "d": "M9 13l3 -3l3 3", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedChevronUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronUp
});

var IconSquareRoundedChevronsDown = createReactComponent("outline", "square-rounded-chevrons-down", "IconSquareRoundedChevronsDown", [["path", { "d": "M15 9l-3 3l-3 -3", "key": "svg-0" }], ["path", { "d": "M15 13l-3 3l-3 -3", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedChevronsDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronsDown
});

var IconSquareRoundedChevronsLeft = createReactComponent("outline", "square-rounded-chevrons-left", "IconSquareRoundedChevronsLeft", [["path", { "d": "M15 15l-3 -3l3 -3", "key": "svg-0" }], ["path", { "d": "M11 15l-3 -3l3 -3", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedChevronsLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronsLeft
});

var IconSquareRoundedChevronsRight = createReactComponent("outline", "square-rounded-chevrons-right", "IconSquareRoundedChevronsRight", [["path", { "d": "M9 9l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M13 9l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedChevronsRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronsRight
});

var IconSquareRoundedChevronsUp = createReactComponent("outline", "square-rounded-chevrons-up", "IconSquareRoundedChevronsUp", [["path", { "d": "M9 15l3 -3l3 3", "key": "svg-0" }], ["path", { "d": "M9 11l3 -3l3 3", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedChevronsUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronsUp
});

var IconSquareRoundedLetterA = createReactComponent("outline", "square-rounded-letter-a", "IconSquareRoundedLetterA", [["path", { "d": "M10 16v-6a2 2 0 1 1 4 0v6", "key": "svg-0" }], ["path", { "d": "M10 13h4", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedLetterA$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterA
});

var IconSquareRoundedLetterB = createReactComponent("outline", "square-rounded-letter-b", "IconSquareRoundedLetterB", [["path", { "d": "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterB$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterB
});

var IconSquareRoundedLetterC = createReactComponent("outline", "square-rounded-letter-c", "IconSquareRoundedLetterC", [["path", { "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterC$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterC
});

var IconSquareRoundedLetterD = createReactComponent("outline", "square-rounded-letter-d", "IconSquareRoundedLetterD", [["path", { "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterD$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterD
});

var IconSquareRoundedLetterE = createReactComponent("outline", "square-rounded-letter-e", "IconSquareRoundedLetterE", [["path", { "d": "M14 8h-4v8h4", "key": "svg-0" }], ["path", { "d": "M10 12h2.5", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedLetterE$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterE
});

var IconSquareRoundedLetterF = createReactComponent("outline", "square-rounded-letter-f", "IconSquareRoundedLetterF", [["path", { "d": "M10 12h3", "key": "svg-0" }], ["path", { "d": "M14 8h-4v8", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedLetterF$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterF
});

var IconSquareRoundedLetterG = createReactComponent("outline", "square-rounded-letter-g", "IconSquareRoundedLetterG", [["path", { "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterG$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterG
});

var IconSquareRoundedLetterH = createReactComponent("outline", "square-rounded-letter-h", "IconSquareRoundedLetterH", [["path", { "d": "M10 16v-8m4 0v8", "key": "svg-0" }], ["path", { "d": "M10 12h4", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedLetterH$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterH
});

var IconSquareRoundedLetterI = createReactComponent("outline", "square-rounded-letter-i", "IconSquareRoundedLetterI", [["path", { "d": "M12 8v8", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterI$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterI
});

var IconSquareRoundedLetterJ = createReactComponent("outline", "square-rounded-letter-j", "IconSquareRoundedLetterJ", [["path", { "d": "M10 8h4v6a2 2 0 1 1 -4 0", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterJ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterJ
});

var IconSquareRoundedLetterK = createReactComponent("outline", "square-rounded-letter-k", "IconSquareRoundedLetterK", [["path", { "d": "M10 8v8", "key": "svg-0" }], ["path", { "d": "M14 8l-2.5 4l2.5 4", "key": "svg-1" }], ["path", { "d": "M10 12h1.5", "key": "svg-2" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-3" }]]);

var IconSquareRoundedLetterK$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterK
});

var IconSquareRoundedLetterL = createReactComponent("outline", "square-rounded-letter-l", "IconSquareRoundedLetterL", [["path", { "d": "M10 8v8h4", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterL$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterL
});

var IconSquareRoundedLetterM = createReactComponent("outline", "square-rounded-letter-m", "IconSquareRoundedLetterM", [["path", { "d": "M9 16v-8l3 5l3 -5v8", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterM$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterM
});

var IconSquareRoundedLetterN = createReactComponent("outline", "square-rounded-letter-n", "IconSquareRoundedLetterN", [["path", { "d": "M10 16v-8l4 8v-8", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterN$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterN
});

var IconSquareRoundedLetterO = createReactComponent("outline", "square-rounded-letter-o", "IconSquareRoundedLetterO", [["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterO$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterO
});

var IconSquareRoundedLetterP = createReactComponent("outline", "square-rounded-letter-p", "IconSquareRoundedLetterP", [["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterP$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterP
});

var IconSquareRoundedLetterQ = createReactComponent("outline", "square-rounded-letter-q", "IconSquareRoundedLetterQ", [["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M13 15l1 1", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedLetterQ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterQ
});

var IconSquareRoundedLetterR = createReactComponent("outline", "square-rounded-letter-r", "IconSquareRoundedLetterR", [["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterR$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterR
});

var IconSquareRoundedLetterS = createReactComponent("outline", "square-rounded-letter-s", "IconSquareRoundedLetterS", [["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterS$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterS
});

var IconSquareRoundedLetterT = createReactComponent("outline", "square-rounded-letter-t", "IconSquareRoundedLetterT", [["path", { "d": "M10 8h4", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedLetterT$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterT
});

var IconSquareRoundedLetterU = createReactComponent("outline", "square-rounded-letter-u", "IconSquareRoundedLetterU", [["path", { "d": "M10 8v6a2 2 0 1 0 4 0v-6", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterU$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterU
});

var IconSquareRoundedLetterV = createReactComponent("outline", "square-rounded-letter-v", "IconSquareRoundedLetterV", [["path", { "d": "M10 8l2 8l2 -8", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterV$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterV
});

var IconSquareRoundedLetterW = createReactComponent("outline", "square-rounded-letter-w", "IconSquareRoundedLetterW", [["path", { "d": "M9 8l1 8l2 -5l2 5l1 -8", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterW$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterW
});

var IconSquareRoundedLetterX = createReactComponent("outline", "square-rounded-letter-x", "IconSquareRoundedLetterX", [["path", { "d": "M10 8l4 8", "key": "svg-0" }], ["path", { "d": "M10 16l4 -8", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedLetterX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterX
});

var IconSquareRoundedLetterY = createReactComponent("outline", "square-rounded-letter-y", "IconSquareRoundedLetterY", [["path", { "d": "M10 8l2 5l2 -5", "key": "svg-0" }], ["path", { "d": "M12 16v-3", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedLetterY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterY
});

var IconSquareRoundedLetterZ = createReactComponent("outline", "square-rounded-letter-z", "IconSquareRoundedLetterZ", [["path", { "d": "M10 8h4l-4 8h4", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedLetterZ$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterZ
});

var IconSquareRoundedMinus2 = createReactComponent("outline", "square-rounded-minus-2", "IconSquareRoundedMinus2", [["path", { "d": "M12.5 21c-.18 .002 -.314 0 -.5 0c-7.2 0 -9 -1.8 -9 -9s1.8 -9 9 -9s9 1.8 9 9c0 1.136 -.046 2.138 -.152 3.02", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconSquareRoundedMinus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedMinus2
});

var IconSquareRoundedMinus = createReactComponent("outline", "square-rounded-minus", "IconSquareRoundedMinus", [["path", { "d": "M9 12h6", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedMinus
});

var IconSquareRoundedNumber0 = createReactComponent("outline", "square-rounded-number-0", "IconSquareRoundedNumber0", [["path", { "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedNumber0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber0
});

var IconSquareRoundedNumber1 = createReactComponent("outline", "square-rounded-number-1", "IconSquareRoundedNumber1", [["path", { "d": "M10 10l2 -2v8", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedNumber1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber1
});

var IconSquareRoundedNumber2 = createReactComponent("outline", "square-rounded-number-2", "IconSquareRoundedNumber2", [["path", { "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedNumber2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber2
});

var IconSquareRoundedNumber3 = createReactComponent("outline", "square-rounded-number-3", "IconSquareRoundedNumber3", [["path", { "d": "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedNumber3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber3
});

var IconSquareRoundedNumber4 = createReactComponent("outline", "square-rounded-number-4", "IconSquareRoundedNumber4", [["path", { "d": "M10 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M14 8v8", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

var IconSquareRoundedNumber4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber4
});

var IconSquareRoundedNumber5 = createReactComponent("outline", "square-rounded-number-5", "IconSquareRoundedNumber5", [["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedNumber5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber5
});

var IconSquareRoundedNumber6 = createReactComponent("outline", "square-rounded-number-6", "IconSquareRoundedNumber6", [["path", { "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedNumber6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber6
});

var IconSquareRoundedNumber7 = createReactComponent("outline", "square-rounded-number-7", "IconSquareRoundedNumber7", [["path", { "d": "M10 8h4l-2 8", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedNumber7$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber7
});

var IconSquareRoundedNumber8 = createReactComponent("outline", "square-rounded-number-8", "IconSquareRoundedNumber8", [["path", { "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedNumber8$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber8
});

var IconSquareRoundedNumber9 = createReactComponent("outline", "square-rounded-number-9", "IconSquareRoundedNumber9", [["path", { "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedNumber9$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber9
});

var IconSquareRoundedPercentage = createReactComponent("outline", "square-rounded-percentage", "IconSquareRoundedPercentage", [["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-0" }], ["path", { "d": "M9 15.075l6 -6", "key": "svg-1" }], ["path", { "d": "M9 9.105v.015", "key": "svg-2" }], ["path", { "d": "M15 15.12v.015", "key": "svg-3" }]]);

var IconSquareRoundedPercentage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedPercentage
});

var IconSquareRoundedPlus2 = createReactComponent("outline", "square-rounded-plus-2", "IconSquareRoundedPlus2", [["path", { "d": "M12.54 20.996c-.176 .004 -.356 .004 -.54 .004c-7.2 0 -9 -1.8 -9 -9s1.8 -9 9 -9s9 1.8 9 9c0 .185 -.001 .366 -.004 .544", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconSquareRoundedPlus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedPlus2
});

var IconSquareRoundedPlus = createReactComponent("outline", "square-rounded-plus", "IconSquareRoundedPlus", [["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-0" }], ["path", { "d": "M15 12h-6", "key": "svg-1" }], ["path", { "d": "M12 9v6", "key": "svg-2" }]]);

var IconSquareRoundedPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedPlus
});

var IconSquareRoundedX = createReactComponent("outline", "square-rounded-x", "IconSquareRoundedX", [["path", { "d": "M10 10l4 4m0 -4l-4 4", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }]]);

var IconSquareRoundedX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedX
});

var IconSquareRounded = createReactComponent("outline", "square-rounded", "IconSquareRounded", [["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-0" }]]);

var IconSquareRounded$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRounded
});

var IconSquareToggleHorizontal = createReactComponent("outline", "square-toggle-horizontal", "IconSquareToggleHorizontal", [["path", { "d": "M22 12h-20", "key": "svg-0" }], ["path", { "d": "M4 14v-8a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8", "key": "svg-1" }], ["path", { "d": "M18 20a2 2 0 0 0 2 -2", "key": "svg-2" }], ["path", { "d": "M4 18a2 2 0 0 0 2 2", "key": "svg-3" }], ["path", { "d": "M14 20l-4 0", "key": "svg-4" }]]);

var IconSquareToggleHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareToggleHorizontal
});

var IconSquareToggle = createReactComponent("outline", "square-toggle", "IconSquareToggle", [["path", { "d": "M12 2l0 20", "key": "svg-0" }], ["path", { "d": "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8", "key": "svg-1" }], ["path", { "d": "M20 6a2 2 0 0 0 -2 -2", "key": "svg-2" }], ["path", { "d": "M18 20a2 2 0 0 0 2 -2", "key": "svg-3" }], ["path", { "d": "M20 10l0 4", "key": "svg-4" }]]);

var IconSquareToggle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareToggle
});

var IconSquareX = createReactComponent("outline", "square-x", "IconSquareX", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M9 9l6 6m0 -6l-6 6", "key": "svg-1" }]]);

var IconSquareX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareX
});

var IconSquare = createReactComponent("outline", "square", "IconSquare", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }]]);

var IconSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquare
});

var IconSquaresDiagonal = createReactComponent("outline", "squares-diagonal", "IconSquaresDiagonal", [["path", { "d": "M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M8.586 19.414l10.827 -10.827", "key": "svg-2" }]]);

var IconSquaresDiagonal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquaresDiagonal
});

var IconSquaresSelected = createReactComponent("outline", "squares-selected", "IconSquaresSelected", [["path", { "d": "M8 10a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 14.5l6.492 -6.492", "key": "svg-1" }], ["path", { "d": "M13.496 20l6.504 -6.504z", "key": "svg-2" }], ["path", { "d": "M8.586 19.414l10.827 -10.827", "key": "svg-3" }], ["path", { "d": "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2", "key": "svg-4" }]]);

var IconSquaresSelected$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquaresSelected
});

var IconSquares = createReactComponent("outline", "squares", "IconSquares", [["path", { "d": "M8 10a2 2 0 0 1 2 -2h9a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-9a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M16 8v-3a2 2 0 0 0 -2 -2h-9a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h3", "key": "svg-1" }]]);

var IconSquares$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquares
});

var IconStack2 = createReactComponent("outline", "stack-2", "IconStack2", [["path", { "d": "M12 4l-8 4l8 4l8 -4l-8 -4", "key": "svg-0" }], ["path", { "d": "M4 12l8 4l8 -4", "key": "svg-1" }], ["path", { "d": "M4 16l8 4l8 -4", "key": "svg-2" }]]);

var IconStack2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStack2
});

var IconStack3 = createReactComponent("outline", "stack-3", "IconStack3", [["path", { "d": "M12 2l-8 4l8 4l8 -4l-8 -4", "key": "svg-0" }], ["path", { "d": "M4 10l8 4l8 -4", "key": "svg-1" }], ["path", { "d": "M4 18l8 4l8 -4", "key": "svg-2" }], ["path", { "d": "M4 14l8 4l8 -4", "key": "svg-3" }]]);

var IconStack3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStack3
});

var IconStackBack = createReactComponent("outline", "stack-back", "IconStackBack", [["path", { "d": "M4 8l8 4l8 -4l-8 -4z", "key": "svg-0" }], ["path", { "d": "M12 16l-4 -2l-4 2l8 4l8 -4l-4 -2l-4 2z", "fill": "currentColor", "key": "svg-1" }], ["path", { "d": "M8 10l-4 2l4 2m8 0l4 -2l-4 -2", "key": "svg-2" }]]);

var IconStackBack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStackBack
});

var IconStackBackward = createReactComponent("outline", "stack-backward", "IconStackBackward", [["path", { "d": "M14 12l6 -3l-8 -4l-8 4l6 3", "key": "svg-0" }], ["path", { "d": "M10 12l-6 3l8 4l8 -4l-6 -3l-2 1z", "fill": "currentColor", "key": "svg-1" }]]);

var IconStackBackward$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStackBackward
});

var IconStackForward = createReactComponent("outline", "stack-forward", "IconStackForward", [["path", { "d": "M12 5l-8 4l8 4l8 -4l-8 -4", "fill": "currentColor", "key": "svg-0" }], ["path", { "d": "M10 12l-6 3l8 4l8 -4l-6 -3", "key": "svg-1" }]]);

var IconStackForward$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStackForward
});

var IconStackFront = createReactComponent("outline", "stack-front", "IconStackFront", [["path", { "d": "M12 4l-8 4l8 4l8 -4l-8 -4", "fill": "currentColor", "key": "svg-0" }], ["path", { "d": "M8 14l-4 2l8 4l8 -4l-4 -2", "key": "svg-1" }], ["path", { "d": "M8 10l-4 2l8 4l8 -4l-4 -2", "key": "svg-2" }]]);

var IconStackFront$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStackFront
});

var IconStackMiddle = createReactComponent("outline", "stack-middle", "IconStackMiddle", [["path", { "d": "M16 10l4 -2l-8 -4l-8 4l4 2", "key": "svg-0" }], ["path", { "d": "M12 12l-4 -2l-4 2l8 4l8 -4l-4 -2l-4 2z", "fill": "currentColor", "key": "svg-1" }], ["path", { "d": "M8 14l-4 2l8 4l8 -4l-4 -2", "key": "svg-2" }]]);

var IconStackMiddle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStackMiddle
});

var IconStackPop = createReactComponent("outline", "stack-pop", "IconStackPop", [["path", { "d": "M7 9.5l-3 1.5l8 4l8 -4l-3 -1.5", "key": "svg-0" }], ["path", { "d": "M4 15l8 4l8 -4", "key": "svg-1" }], ["path", { "d": "M12 11v-7", "key": "svg-2" }], ["path", { "d": "M9 7l3 -3l3 3", "key": "svg-3" }]]);

var IconStackPop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStackPop
});

var IconStackPush = createReactComponent("outline", "stack-push", "IconStackPush", [["path", { "d": "M6 10l-2 1l8 4l8 -4l-2 -1", "key": "svg-0" }], ["path", { "d": "M4 15l8 4l8 -4", "key": "svg-1" }], ["path", { "d": "M12 4v7", "key": "svg-2" }], ["path", { "d": "M15 8l-3 3l-3 -3", "key": "svg-3" }]]);

var IconStackPush$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStackPush
});

var IconStack = createReactComponent("outline", "stack", "IconStack", [["path", { "d": "M12 6l-8 4l8 4l8 -4l-8 -4", "key": "svg-0" }], ["path", { "d": "M4 14l8 4l8 -4", "key": "svg-1" }]]);

var IconStack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStack
});

var IconStairsDown = createReactComponent("outline", "stairs-down", "IconStairsDown", [["path", { "d": "M22 21h-5v-5h-5v-5h-5v-5h-5", "key": "svg-0" }], ["path", { "d": "M18 3v7", "key": "svg-1" }], ["path", { "d": "M15 7l3 3l3 -3", "key": "svg-2" }]]);

var IconStairsDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStairsDown
});

var IconStairsUp = createReactComponent("outline", "stairs-up", "IconStairsUp", [["path", { "d": "M22 6h-5v5h-5v5h-5v5h-5", "key": "svg-0" }], ["path", { "d": "M6 10v-7", "key": "svg-1" }], ["path", { "d": "M3 6l3 -3l3 3", "key": "svg-2" }]]);

var IconStairsUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStairsUp
});

var IconStairs = createReactComponent("outline", "stairs", "IconStairs", [["path", { "d": "M22 5h-5v5h-5v5h-5v5h-5", "key": "svg-0" }]]);

var IconStairs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStairs
});

var IconStarHalf = createReactComponent("outline", "star-half", "IconStarHalf", [["path", { "d": "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253z", "key": "svg-0" }]]);

var IconStarHalf$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStarHalf
});

var IconStarOff = createReactComponent("outline", "star-off", "IconStarOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M10.012 6.016l1.981 -4.014l3.086 6.253l6.9 1l-4.421 4.304m.012 4.01l.588 3.426l-6.158 -3.245l-6.172 3.245l1.179 -6.873l-5 -4.867l6.327 -.917", "key": "svg-1" }]]);

var IconStarOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStarOff
});

var IconStar = createReactComponent("outline", "star", "IconStar", [["path", { "d": "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z", "key": "svg-0" }]]);

var IconStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStar
});

var IconStarsOff = createReactComponent("outline", "stars-off", "IconStarsOff", [["path", { "d": "M17.373 13.371l.076 -.154a.392 .392 0 0 1 .702 0l.907 1.831m.367 .39c.498 .071 1.245 .18 2.24 .324a.39 .39 0 0 1 .217 .665c-.326 .316 -.57 .553 -.732 .712m-.611 3.405a.39 .39 0 0 1 -.567 .411l-2.172 -1.138l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l1.601 -.232", "key": "svg-0" }], ["path", { "d": "M6.2 19.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }], ["path", { "d": "M9.557 5.556l1 -.146l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.014 .187m-4.153 -.166l-.744 .39a.392 .392 0 0 1 -.568 -.41l.188 -1.093", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconStarsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStarsOff
});

var IconStars = createReactComponent("outline", "stars", "IconStars", [["path", { "d": "M17.8 19.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-0" }], ["path", { "d": "M6.2 19.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-1" }], ["path", { "d": "M12 9.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconStars$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStars
});

var IconStatusChange = createReactComponent("outline", "status-change", "IconStatusChange", [["path", { "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M6 12v-2a6 6 0 1 1 12 0v2", "key": "svg-2" }], ["path", { "d": "M15 9l3 3l3 -3", "key": "svg-3" }]]);

var IconStatusChange$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStatusChange
});

var IconSteam = createReactComponent("outline", "steam", "IconSteam", [["path", { "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M4 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M20 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M5.5 5.5l3 3", "key": "svg-4" }], ["path", { "d": "M15.5 15.5l3 3", "key": "svg-5" }], ["path", { "d": "M18.5 5.5l-3 3", "key": "svg-6" }], ["path", { "d": "M8.5 15.5l-3 3", "key": "svg-7" }]]);

var IconSteam$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSteam
});

var IconSteeringWheelOff = createReactComponent("outline", "steering-wheel-off", "IconSteeringWheelOff", [["path", { "d": "M20.04 16.048a9 9 0 0 0 -12.083 -12.09m-2.32 1.678a9 9 0 1 0 12.737 12.719", "key": "svg-0" }], ["path", { "d": "M10.595 10.576a2 2 0 1 0 2.827 2.83", "key": "svg-1" }], ["path", { "d": "M12 14v7", "key": "svg-2" }], ["path", { "d": "M10 12l-6.75 -2", "key": "svg-3" }], ["path", { "d": "M15.542 11.543l5.208 -1.543", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconSteeringWheelOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSteeringWheelOff
});

var IconSteeringWheel = createReactComponent("outline", "steering-wheel", "IconSteeringWheel", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M12 14l0 7", "key": "svg-2" }], ["path", { "d": "M10 12l-6.75 -2", "key": "svg-3" }], ["path", { "d": "M14 12l6.75 -2", "key": "svg-4" }]]);

var IconSteeringWheel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSteeringWheel
});

var IconStepInto = createReactComponent("outline", "step-into", "IconStepInto", [["path", { "d": "M12 3l0 12", "key": "svg-0" }], ["path", { "d": "M16 11l-4 4", "key": "svg-1" }], ["path", { "d": "M8 11l4 4", "key": "svg-2" }], ["path", { "d": "M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }]]);

var IconStepInto$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStepInto
});

var IconStepOut = createReactComponent("outline", "step-out", "IconStepOut", [["path", { "d": "M12 3l0 12", "key": "svg-0" }], ["path", { "d": "M16 7l-4 -4", "key": "svg-1" }], ["path", { "d": "M8 7l4 -4", "key": "svg-2" }], ["path", { "d": "M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }]]);

var IconStepOut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStepOut
});

var IconStereoGlasses = createReactComponent("outline", "stereo-glasses", "IconStereoGlasses", [["path", { "d": "M8 3h-2l-3 9", "key": "svg-0" }], ["path", { "d": "M16 3h2l3 9", "key": "svg-1" }], ["path", { "d": "M3 12v7a1 1 0 0 0 1 1h4.586a1 1 0 0 0 .707 -.293l2 -2a1 1 0 0 1 1.414 0l2 2a1 1 0 0 0 .707 .293h4.586a1 1 0 0 0 1 -1v-7h-18z", "key": "svg-2" }], ["path", { "d": "M7 16h1", "key": "svg-3" }], ["path", { "d": "M16 16h1", "key": "svg-4" }]]);

var IconStereoGlasses$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStereoGlasses
});

var IconStethoscopeOff = createReactComponent("outline", "stethoscope-off", "IconStethoscopeOff", [["path", { "d": "M4.172 4.179a2 2 0 0 0 -1.172 1.821v3.5a5.5 5.5 0 0 0 9.856 3.358m1.144 -2.858v-4a2 2 0 0 0 -2 -2h-1", "key": "svg-0" }], ["path", { "d": "M8 15a6 6 0 0 0 10.714 3.712m1.216 -2.798c.046 -.3 .07 -.605 .07 -.914v-3", "key": "svg-1" }], ["path", { "d": "M11 3v2", "key": "svg-2" }], ["path", { "d": "M20 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconStethoscopeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStethoscopeOff
});

var IconStethoscope = createReactComponent("outline", "stethoscope", "IconStethoscope", [["path", { "d": "M6 4h-1a2 2 0 0 0 -2 2v3.5h0a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0 -2 -2h-1", "key": "svg-0" }], ["path", { "d": "M8 15a6 6 0 1 0 12 0v-3", "key": "svg-1" }], ["path", { "d": "M11 3v2", "key": "svg-2" }], ["path", { "d": "M6 3v2", "key": "svg-3" }], ["path", { "d": "M20 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }]]);

var IconStethoscope$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStethoscope
});

var IconSticker2 = createReactComponent("outline", "sticker-2", "IconSticker2", [["path", { "d": "M6 4h12a2 2 0 0 1 2 2v7h-5a2 2 0 0 0 -2 2v5h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M20 13v.172a2 2 0 0 1 -.586 1.414l-4.828 4.828a2 2 0 0 1 -1.414 .586h-.172", "key": "svg-1" }]]);

var IconSticker2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSticker2
});

var IconSticker = createReactComponent("outline", "sticker", "IconSticker", [["path", { "d": "M20 12l-2 .5a6 6 0 0 1 -6.5 -6.5l.5 -2l8 8", "key": "svg-0" }], ["path", { "d": "M20 12a8 8 0 1 1 -8 -8", "key": "svg-1" }]]);

var IconSticker$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSticker
});

var IconStopwatch = createReactComponent("outline", "stopwatch", "IconStopwatch", [["path", { "d": "M5 13a7 7 0 1 0 14 0a7 7 0 0 0 -14 0z", "key": "svg-0" }], ["path", { "d": "M14.5 10.5l-2.5 2.5", "key": "svg-1" }], ["path", { "d": "M17 8l1 -1", "key": "svg-2" }], ["path", { "d": "M14 3h-4", "key": "svg-3" }]]);

var IconStopwatch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStopwatch
});

var IconStormOff = createReactComponent("outline", "storm-off", "IconStormOff", [["path", { "d": "M9.884 9.874a3 3 0 1 0 4.24 4.246m.57 -3.441a3.012 3.012 0 0 0 -1.41 -1.39", "key": "svg-0" }], ["path", { "d": "M7.037 7.063a7 7 0 0 0 9.907 9.892m1.585 -2.426a7 7 0 0 0 -9.058 -9.059", "key": "svg-1" }], ["path", { "d": "M5.369 14.236c-1.605 -3.428 -1.597 -6.673 -1 -9.849", "key": "svg-2" }], ["path", { "d": "M18.63 9.76a14.323 14.323 0 0 1 1.368 6.251m-.37 3.608c-.087 .46 -.187 .92 -.295 1.377", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconStormOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStormOff
});

var IconStorm = createReactComponent("outline", "storm", "IconStorm", [["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-1" }], ["path", { "d": "M5.369 14.236c-1.839 -3.929 -1.561 -7.616 -.704 -11.236", "key": "svg-2" }], ["path", { "d": "M18.63 9.76c1.837 3.928 1.561 7.615 .703 11.236", "key": "svg-3" }]]);

var IconStorm$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStorm
});

var IconStretching2 = createReactComponent("outline", "stretching-2", "IconStretching2", [["path", { "d": "M11 4a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M6.5 21l3.5 -5", "key": "svg-1" }], ["path", { "d": "M5 11l7 -2", "key": "svg-2" }], ["path", { "d": "M16 21l-4 -7v-5l7 -4", "key": "svg-3" }]]);

var IconStretching2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStretching2
});

var IconStretching = createReactComponent("outline", "stretching", "IconStretching", [["path", { "d": "M16 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M5 20l5 -.5l1 -2", "key": "svg-1" }], ["path", { "d": "M18 20v-5h-5.5l2.5 -6.5l-5.5 1l1.5 2", "key": "svg-2" }]]);

var IconStretching$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStretching
});

var IconStrikethrough = createReactComponent("outline", "strikethrough", "IconStrikethrough", [["path", { "d": "M5 12l14 0", "key": "svg-0" }], ["path", { "d": "M16 6.5a4 2 0 0 0 -4 -1.5h-1a3.5 3.5 0 0 0 0 7h2a3.5 3.5 0 0 1 0 7h-1.5a4 2 0 0 1 -4 -1.5", "key": "svg-1" }]]);

var IconStrikethrough$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStrikethrough
});

var IconSubmarine = createReactComponent("outline", "submarine", "IconSubmarine", [["path", { "d": "M3 11v6h2l1 -1.5l3 1.5h10a3 3 0 0 0 0 -6h-10h0l-3 1.5l-1 -1.5h-2z", "key": "svg-0" }], ["path", { "d": "M17 11l-1 -3h-5l-1 3", "key": "svg-1" }], ["path", { "d": "M13 8v-2a1 1 0 0 1 1 -1h1", "key": "svg-2" }]]);

var IconSubmarine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSubmarine
});

var IconSubscript = createReactComponent("outline", "subscript", "IconSubscript", [["path", { "d": "M5 7l8 10m-8 0l8 -10", "key": "svg-0" }], ["path", { "d": "M21 20h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2", "key": "svg-1" }]]);

var IconSubscript$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSubscript
});

var IconSubtask = createReactComponent("outline", "subtask", "IconSubtask", [["path", { "d": "M6 9l6 0", "key": "svg-0" }], ["path", { "d": "M4 5l4 0", "key": "svg-1" }], ["path", { "d": "M6 5v11a1 1 0 0 0 1 1h5", "key": "svg-2" }], ["path", { "d": "M12 7m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-3" }], ["path", { "d": "M12 15m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z", "key": "svg-4" }]]);

var IconSubtask$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSubtask
});

var IconSumOff = createReactComponent("outline", "sum-off", "IconSumOff", [["path", { "d": "M18 18a1 1 0 0 1 -1 1h-11l6 -7m-3 -7h8a1 1 0 0 1 1 1v2", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconSumOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSumOff
});

var IconSum = createReactComponent("outline", "sum", "IconSum", [["path", { "d": "M18 16v2a1 1 0 0 1 -1 1h-11l6 -7l-6 -7h11a1 1 0 0 1 1 1v2", "key": "svg-0" }]]);

var IconSum$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSum
});

var IconSunElectricity = createReactComponent("outline", "sun-electricity", "IconSunElectricity", [["path", { "d": "M8 12a4 4 0 0 0 4 4m0 -8a4 4 0 0 0 -4 4", "key": "svg-0" }], ["path", { "d": "M3 12h1", "key": "svg-1" }], ["path", { "d": "M12 3v1", "key": "svg-2" }], ["path", { "d": "M12 20v1", "key": "svg-3" }], ["path", { "d": "M5.6 5.6l.7 .7", "key": "svg-4" }], ["path", { "d": "M6.3 17.7l-.7 .7", "key": "svg-5" }], ["path", { "d": "M20 7l-3 5h4l-3 5", "key": "svg-6" }]]);

var IconSunElectricity$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunElectricity
});

var IconSunHigh = createReactComponent("outline", "sun-high", "IconSunHigh", [["path", { "d": "M14.828 14.828a4 4 0 1 0 -5.656 -5.656a4 4 0 0 0 5.656 5.656z", "key": "svg-0" }], ["path", { "d": "M6.343 17.657l-1.414 1.414", "key": "svg-1" }], ["path", { "d": "M6.343 6.343l-1.414 -1.414", "key": "svg-2" }], ["path", { "d": "M17.657 6.343l1.414 -1.414", "key": "svg-3" }], ["path", { "d": "M17.657 17.657l1.414 1.414", "key": "svg-4" }], ["path", { "d": "M4 12h-2", "key": "svg-5" }], ["path", { "d": "M12 4v-2", "key": "svg-6" }], ["path", { "d": "M20 12h2", "key": "svg-7" }], ["path", { "d": "M12 20v2", "key": "svg-8" }]]);

var IconSunHigh$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunHigh
});

var IconSunLow = createReactComponent("outline", "sun-low", "IconSunLow", [["path", { "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M4 12h.01", "key": "svg-1" }], ["path", { "d": "M12 4v.01", "key": "svg-2" }], ["path", { "d": "M20 12h.01", "key": "svg-3" }], ["path", { "d": "M12 20v.01", "key": "svg-4" }], ["path", { "d": "M6.31 6.31l-.01 -.01", "key": "svg-5" }], ["path", { "d": "M17.71 6.31l-.01 -.01", "key": "svg-6" }], ["path", { "d": "M17.7 17.7l.01 .01", "key": "svg-7" }], ["path", { "d": "M6.3 17.7l.01 .01", "key": "svg-8" }]]);

var IconSunLow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunLow
});

var IconSunMoon = createReactComponent("outline", "sun-moon", "IconSunMoon", [["path", { "d": "M9.173 14.83a4 4 0 1 1 5.657 -5.657", "key": "svg-0" }], ["path", { "d": "M11.294 12.707l.174 .247a7.5 7.5 0 0 0 8.845 2.492a9 9 0 0 1 -14.671 2.914", "key": "svg-1" }], ["path", { "d": "M3 12h1", "key": "svg-2" }], ["path", { "d": "M12 3v1", "key": "svg-3" }], ["path", { "d": "M5.6 5.6l.7 .7", "key": "svg-4" }], ["path", { "d": "M3 21l18 -18", "key": "svg-5" }]]);

var IconSunMoon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunMoon
});

var IconSunOff = createReactComponent("outline", "sun-off", "IconSunOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M16 12a4 4 0 0 0 -4 -4m-2.834 1.177a4 4 0 0 0 5.66 5.654", "key": "svg-1" }], ["path", { "d": "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7", "key": "svg-2" }]]);

var IconSunOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunOff
});

var IconSunWind = createReactComponent("outline", "sun-wind", "IconSunWind", [["path", { "d": "M14.468 10a4 4 0 1 0 -5.466 5.46", "key": "svg-0" }], ["path", { "d": "M2 12h1", "key": "svg-1" }], ["path", { "d": "M11 3v1", "key": "svg-2" }], ["path", { "d": "M11 20v1", "key": "svg-3" }], ["path", { "d": "M4.6 5.6l.7 .7", "key": "svg-4" }], ["path", { "d": "M17.4 5.6l-.7 .7", "key": "svg-5" }], ["path", { "d": "M5.3 17.7l-.7 .7", "key": "svg-6" }], ["path", { "d": "M15 13h5a2 2 0 1 0 0 -4", "key": "svg-7" }], ["path", { "d": "M12 16h5.714l.253 0a2 2 0 0 1 2.033 2a2 2 0 0 1 -2 2h-.286", "key": "svg-8" }]]);

var IconSunWind$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunWind
});

var IconSun = createReactComponent("outline", "sun", "IconSun", [["path", { "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7", "key": "svg-1" }]]);

var IconSun$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSun
});

var IconSunglasses = createReactComponent("outline", "sunglasses", "IconSunglasses", [["path", { "d": "M8 4h-2l-3 10", "key": "svg-0" }], ["path", { "d": "M16 4h2l3 10", "key": "svg-1" }], ["path", { "d": "M10 16h4", "key": "svg-2" }], ["path", { "d": "M21 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5", "key": "svg-3" }], ["path", { "d": "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5", "key": "svg-4" }], ["path", { "d": "M4 14l4.5 4.5", "key": "svg-5" }], ["path", { "d": "M15 14l4.5 4.5", "key": "svg-6" }]]);

var IconSunglasses$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunglasses
});

var IconSunrise = createReactComponent("outline", "sunrise", "IconSunrise", [["path", { "d": "M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0", "key": "svg-0" }], ["path", { "d": "M3 21l18 0", "key": "svg-1" }], ["path", { "d": "M12 9v-6l3 3m-6 0l3 -3", "key": "svg-2" }]]);

var IconSunrise$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunrise
});

var IconSunset2 = createReactComponent("outline", "sunset-2", "IconSunset2", [["path", { "d": "M3 13h1", "key": "svg-0" }], ["path", { "d": "M20 13h1", "key": "svg-1" }], ["path", { "d": "M5.6 6.6l.7 .7", "key": "svg-2" }], ["path", { "d": "M18.4 6.6l-.7 .7", "key": "svg-3" }], ["path", { "d": "M8 13a4 4 0 1 1 8 0", "key": "svg-4" }], ["path", { "d": "M3 17h18", "key": "svg-5" }], ["path", { "d": "M7 20h5", "key": "svg-6" }], ["path", { "d": "M16 20h1", "key": "svg-7" }], ["path", { "d": "M12 5v-1", "key": "svg-8" }]]);

var IconSunset2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunset2
});

var IconSunset = createReactComponent("outline", "sunset", "IconSunset", [["path", { "d": "M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0", "key": "svg-0" }], ["path", { "d": "M3 21l18 0", "key": "svg-1" }], ["path", { "d": "M12 3v6l3 -3m-6 0l3 3", "key": "svg-2" }]]);

var IconSunset$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunset
});

var IconSuperscript = createReactComponent("outline", "superscript", "IconSuperscript", [["path", { "d": "M5 7l8 10m-8 0l8 -10", "key": "svg-0" }], ["path", { "d": "M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2", "key": "svg-1" }]]);

var IconSuperscript$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSuperscript
});

var IconSvg = createReactComponent("outline", "svg", "IconSvg", [["path", { "d": "M21 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-0" }], ["path", { "d": "M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3", "key": "svg-1" }], ["path", { "d": "M10 8l1.5 8h1l1.5 -8", "key": "svg-2" }]]);

var IconSvg$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSvg
});

var IconSwimming = createReactComponent("outline", "swimming", "IconSwimming", [["path", { "d": "M16 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M6 11l4 -2l3.5 3l-1.5 2", "key": "svg-1" }], ["path", { "d": "M3 16.75a2.4 2.4 0 0 0 1 .25a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 1 -.25", "key": "svg-2" }]]);

var IconSwimming$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwimming
});

var IconSwipeDown = createReactComponent("outline", "swipe-down", "IconSwipeDown", [["path", { "d": "M12 4a4 4 0 1 1 0 8a4 4 0 0 1 0 -8z", "key": "svg-0" }], ["path", { "d": "M12 12v8", "key": "svg-1" }], ["path", { "d": "M9 17l3 3l3 -3", "key": "svg-2" }]]);

var IconSwipeDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwipeDown
});

var IconSwipeLeft = createReactComponent("outline", "swipe-left", "IconSwipeLeft", [["path", { "d": "M20 12a4 4 0 1 0 -8 0a4 4 0 0 0 8 0z", "key": "svg-0" }], ["path", { "d": "M12 12h-8", "key": "svg-1" }], ["path", { "d": "M7 15l-3 -3l3 -3", "key": "svg-2" }]]);

var IconSwipeLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwipeLeft
});

var IconSwipeRight = createReactComponent("outline", "swipe-right", "IconSwipeRight", [["path", { "d": "M4 12a4 4 0 1 1 8 0a4 4 0 0 1 -8 0z", "key": "svg-0" }], ["path", { "d": "M12 12h8", "key": "svg-1" }], ["path", { "d": "M17 15l3 -3l-3 -3", "key": "svg-2" }]]);

var IconSwipeRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwipeRight
});

var IconSwipeUp = createReactComponent("outline", "swipe-up", "IconSwipeUp", [["path", { "d": "M12 16m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M12 12v-8", "key": "svg-1" }], ["path", { "d": "M9 7l3 -3l3 3", "key": "svg-2" }]]);

var IconSwipeUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwipeUp
});

var IconSwipe = createReactComponent("outline", "swipe", "IconSwipe", [["path", { "d": "M15 16.572v2.42a2.01 2.01 0 0 1 -2.009 2.008h-7.981a2.01 2.01 0 0 1 -2.01 -2.009v-7.981a2.01 2.01 0 0 1 2.009 -2.01h2.954", "key": "svg-0" }], ["path", { "d": "M9.167 4.511a2.04 2.04 0 0 1 2.496 -1.441l7.826 2.097a2.04 2.04 0 0 1 1.441 2.496l-2.097 7.826a2.04 2.04 0 0 1 -2.496 1.441l-7.827 -2.097a2.04 2.04 0 0 1 -1.441 -2.496l2.098 -7.827z", "key": "svg-1" }]]);

var IconSwipe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwipe
});

var IconSwitch2 = createReactComponent("outline", "switch-2", "IconSwitch2", [["path", { "d": "M3 17h5l1.67 -2.386m3.66 -5.227l1.67 -2.387h6", "key": "svg-0" }], ["path", { "d": "M18 4l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M3 7h5l7 10h6", "key": "svg-2" }], ["path", { "d": "M18 20l3 -3l-3 -3", "key": "svg-3" }]]);

var IconSwitch2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwitch2
});

var IconSwitch3 = createReactComponent("outline", "switch-3", "IconSwitch3", [["path", { "d": "M3 17h2.397a5 5 0 0 0 4.096 -2.133l.177 -.253m3.66 -5.227l.177 -.254a5 5 0 0 1 4.096 -2.133h3.397", "key": "svg-0" }], ["path", { "d": "M18 4l3 3l-3 3", "key": "svg-1" }], ["path", { "d": "M3 7h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397", "key": "svg-2" }], ["path", { "d": "M18 20l3 -3l-3 -3", "key": "svg-3" }]]);

var IconSwitch3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwitch3
});

var IconSwitchHorizontal = createReactComponent("outline", "switch-horizontal", "IconSwitchHorizontal", [["path", { "d": "M16 3l4 4l-4 4", "key": "svg-0" }], ["path", { "d": "M10 7l10 0", "key": "svg-1" }], ["path", { "d": "M8 13l-4 4l4 4", "key": "svg-2" }], ["path", { "d": "M4 17l9 0", "key": "svg-3" }]]);

var IconSwitchHorizontal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwitchHorizontal
});

var IconSwitchVertical = createReactComponent("outline", "switch-vertical", "IconSwitchVertical", [["path", { "d": "M3 8l4 -4l4 4", "key": "svg-0" }], ["path", { "d": "M7 4l0 9", "key": "svg-1" }], ["path", { "d": "M13 16l4 4l4 -4", "key": "svg-2" }], ["path", { "d": "M17 10l0 10", "key": "svg-3" }]]);

var IconSwitchVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwitchVertical
});

var IconSwitch = createReactComponent("outline", "switch", "IconSwitch", [["path", { "d": "M15 4l4 0l0 4", "key": "svg-0" }], ["path", { "d": "M14.75 9.25l4.25 -5.25", "key": "svg-1" }], ["path", { "d": "M5 19l4 -4", "key": "svg-2" }], ["path", { "d": "M15 19l4 0l0 -4", "key": "svg-3" }], ["path", { "d": "M5 5l14 14", "key": "svg-4" }]]);

var IconSwitch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwitch
});

var IconSwordOff = createReactComponent("outline", "sword-off", "IconSwordOff", [["path", { "d": "M11.938 7.937l3.062 -3.937h5v5l-3.928 3.055m-2.259 1.757l-2.813 2.188l-4 4l-3 -3l4 -4l2.19 -2.815", "key": "svg-0" }], ["path", { "d": "M6.5 11.5l6 6", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconSwordOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwordOff
});

var IconSword = createReactComponent("outline", "sword", "IconSword", [["path", { "d": "M20 4v5l-9 7l-4 4l-3 -3l4 -4l7 -9z", "key": "svg-0" }], ["path", { "d": "M6.5 11.5l6 6", "key": "svg-1" }]]);

var IconSword$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSword
});

var IconSwords = createReactComponent("outline", "swords", "IconSwords", [["path", { "d": "M21 3v5l-11 9l-4 4l-3 -3l4 -4l9 -11z", "key": "svg-0" }], ["path", { "d": "M5 13l6 6", "key": "svg-1" }], ["path", { "d": "M14.32 17.32l3.68 3.68l3 -3l-3.365 -3.365", "key": "svg-2" }], ["path", { "d": "M10 5.5l-2 -2.5h-5v5l3 2.5", "key": "svg-3" }]]);

var IconSwords$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwords
});

var IconTableAlias = createReactComponent("outline", "table-alias", "IconTableAlias", [["path", { "d": "M3 12v-7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-7", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M10 3v10", "key": "svg-2" }], ["path", { "d": "M2 17a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z", "key": "svg-3" }]]);

var IconTableAlias$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableAlias
});

var IconTableColumn = createReactComponent("outline", "table-column", "IconTableColumn", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M10 10h11", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }], ["path", { "d": "M9 3l-6 6", "key": "svg-3" }], ["path", { "d": "M10 7l-7 7", "key": "svg-4" }], ["path", { "d": "M10 12l-7 7", "key": "svg-5" }], ["path", { "d": "M10 17l-4 4", "key": "svg-6" }]]);

var IconTableColumn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableColumn
});

var IconTableDashed = createReactComponent("outline", "table-dashed", "IconTableDashed", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }]]);

var IconTableDashed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableDashed
});

var IconTableDown = createReactComponent("outline", "table-down", "IconTableDown", [["path", { "d": "M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-4" }]]);

var IconTableDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableDown
});

var IconTableExport = createReactComponent("outline", "table-export", "IconTableExport", [["path", { "d": "M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16l3 3l-3 3", "key": "svg-4" }]]);

var IconTableExport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableExport
});

var IconTableHeart = createReactComponent("outline", "table-heart", "IconTableHeart", [["path", { "d": "M11.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-3" }]]);

var IconTableHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableHeart
});

var IconTableImport = createReactComponent("outline", "table-import", "IconTableImport", [["path", { "d": "M12 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }], ["path", { "d": "M19 22v-6", "key": "svg-3" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-4" }]]);

var IconTableImport$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableImport
});

var IconTableMinus = createReactComponent("outline", "table-minus", "IconTableMinus", [["path", { "d": "M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconTableMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableMinus
});

var IconTableOff = createReactComponent("outline", "table-off", "IconTableOff", [["path", { "d": "M7 3h12a2 2 0 0 1 2 2v12m-.585 3.413a1.994 1.994 0 0 1 -1.415 .587h-14a2 2 0 0 1 -2 -2v-14c0 -.55 .223 -1.05 .583 -1.412", "key": "svg-0" }], ["path", { "d": "M3 10h7m4 0h7", "key": "svg-1" }], ["path", { "d": "M10 3v3m0 4v11", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconTableOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableOff
});

var IconTableOptions = createReactComponent("outline", "table-options", "IconTableOptions", [["path", { "d": "M12 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-4" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-5" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-6" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-7" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-8" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-9" }]]);

var IconTableOptions$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableOptions
});

var IconTablePlus = createReactComponent("outline", "table-plus", "IconTablePlus", [["path", { "d": "M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconTablePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTablePlus
});

var IconTableRow = createReactComponent("outline", "table-row", "IconTableRow", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M9 3l-6 6", "key": "svg-1" }], ["path", { "d": "M14 3l-7 7", "key": "svg-2" }], ["path", { "d": "M19 3l-7 7", "key": "svg-3" }], ["path", { "d": "M21 6l-4 4", "key": "svg-4" }], ["path", { "d": "M3 10h18", "key": "svg-5" }], ["path", { "d": "M10 10v11", "key": "svg-6" }]]);

var IconTableRow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableRow
});

var IconTableShare = createReactComponent("outline", "table-share", "IconTableShare", [["path", { "d": "M12 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }], ["path", { "d": "M16 22l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-4" }]]);

var IconTableShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableShare
});

var IconTableShortcut = createReactComponent("outline", "table-shortcut", "IconTableShortcut", [["path", { "d": "M3 13v-8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M10 3v11", "key": "svg-2" }], ["path", { "d": "M2 22l5 -5", "key": "svg-3" }], ["path", { "d": "M7 21.5v-4.5h-4.5", "key": "svg-4" }]]);

var IconTableShortcut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableShortcut
});

var IconTableSpark = createReactComponent("outline", "table-spark", "IconTableSpark", [["path", { "d": "M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5", "key": "svg-0" }], ["path", { "d": "M12 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7", "key": "svg-1" }], ["path", { "d": "M3 10h18", "key": "svg-2" }], ["path", { "d": "M10 3v18", "key": "svg-3" }]]);

var IconTableSpark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableSpark
});

var IconTable = createReactComponent("outline", "table", "IconTable", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-0" }], ["path", { "d": "M3 10h18", "key": "svg-1" }], ["path", { "d": "M10 3v18", "key": "svg-2" }]]);

var IconTable$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTable
});

var IconTagMinus = createReactComponent("outline", "tag-minus", "IconTagMinus", [["path", { "d": "M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M18.898 16.102l.699 -.699l.699 -.699c.941 -.941 .941 -2.467 0 -3.408l-7.71 -7.71c-.375 -.375 -.884 -.586 -1.414 -.586h-5.172c-1.657 0 -3 1.343 -3 3v5.172c0 .53 .211 1.039 .586 1.414l7.71 7.71c.471 .47 1.087 .706 1.704 .706", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconTagMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTagMinus
});

var IconTagOff = createReactComponent("outline", "tag-off", "IconTagOff", [["path", { "d": "M7.149 7.144a.498 .498 0 0 0 .351 .856a.498 .498 0 0 0 .341 -.135", "key": "svg-0" }], ["path", { "d": "M3.883 3.875a2.99 2.99 0 0 0 -.883 2.125v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l2.796 -2.796m2.005 -2.005l.79 -.79a2.41 2.41 0 0 0 0 -3.41l-7.71 -7.71a2 2 0 0 0 -1.412 -.585h-4.173", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconTagOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTagOff
});

var IconTagPlus = createReactComponent("outline", "tag-plus", "IconTagPlus", [["path", { "d": "M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M21.002 13c0 -.617 -.235 -1.233 -.706 -1.704l-7.71 -7.71c-.375 -.375 -.884 -.586 -1.414 -.586h-5.172c-1.657 0 -3 1.343 -3 3v5.172c0 .53 .211 1.039 .586 1.414l7.71 7.71c.471 .47 1.087 .706 1.704 .706", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconTagPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTagPlus
});

var IconTagStarred = createReactComponent("outline", "tag-starred", "IconTagStarred", [["path", { "d": "M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z", "key": "svg-1" }], ["path", { "d": "M12.5 13.847l-1.5 1.153l.532 -1.857l-1.532 -1.143h1.902l.598 -1.8l.598 1.8h1.902l-1.532 1.143l.532 1.857z", "key": "svg-2" }]]);

var IconTagStarred$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTagStarred
});

var IconTag = createReactComponent("outline", "tag", "IconTag", [["path", { "d": "M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z", "key": "svg-1" }]]);

var IconTag$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTag
});

var IconTagsOff = createReactComponent("outline", "tags-off", "IconTagsOff", [["path", { "d": "M16.296 12.296l-5.71 -5.71", "key": "svg-0" }], ["path", { "d": "M6 6h-1a2 2 0 0 0 -2 2v4.172a2 2 0 0 0 .586 1.414l5.71 5.71a2.41 2.41 0 0 0 3.408 0l3.278 -3.278", "key": "svg-1" }], ["path", { "d": "M18 19l.496 -.496", "key": "svg-2" }], ["path", { "d": "M20.384 16.367a4.822 4.822 0 0 0 -.792 -5.775l-4.592 -4.592", "key": "svg-3" }], ["path", { "d": "M7 10h-.01", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconTagsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTagsOff
});

var IconTags = createReactComponent("outline", "tags", "IconTags", [["path", { "d": "M3 8v4.172a2 2 0 0 0 .586 1.414l5.71 5.71a2.41 2.41 0 0 0 3.408 0l3.592 -3.592a2.41 2.41 0 0 0 0 -3.408l-5.71 -5.71a2 2 0 0 0 -1.414 -.586h-4.172a2 2 0 0 0 -2 2z", "key": "svg-0" }], ["path", { "d": "M18 19l1.592 -1.592a4.82 4.82 0 0 0 0 -6.816l-4.592 -4.592", "key": "svg-1" }], ["path", { "d": "M7 10h-.01", "key": "svg-2" }]]);

var IconTags$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTags
});

var IconTallymark1 = createReactComponent("outline", "tallymark-1", "IconTallymark1", [["path", { "d": "M12 5l0 14", "key": "svg-0" }]]);

var IconTallymark1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTallymark1
});

var IconTallymark2 = createReactComponent("outline", "tallymark-2", "IconTallymark2", [["path", { "d": "M10 5l0 14", "key": "svg-0" }], ["path", { "d": "M14 5l0 14", "key": "svg-1" }]]);

var IconTallymark2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTallymark2
});

var IconTallymark3 = createReactComponent("outline", "tallymark-3", "IconTallymark3", [["path", { "d": "M8 5l0 14", "key": "svg-0" }], ["path", { "d": "M12 5l0 14", "key": "svg-1" }], ["path", { "d": "M16 5l0 14", "key": "svg-2" }]]);

var IconTallymark3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTallymark3
});

var IconTallymark4 = createReactComponent("outline", "tallymark-4", "IconTallymark4", [["path", { "d": "M6 5l0 14", "key": "svg-0" }], ["path", { "d": "M10 5l0 14", "key": "svg-1" }], ["path", { "d": "M14 5l0 14", "key": "svg-2" }], ["path", { "d": "M18 5l0 14", "key": "svg-3" }]]);

var IconTallymark4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTallymark4
});

var IconTallymarks = createReactComponent("outline", "tallymarks", "IconTallymarks", [["path", { "d": "M6 5l0 14", "key": "svg-0" }], ["path", { "d": "M10 5l0 14", "key": "svg-1" }], ["path", { "d": "M14 5l0 14", "key": "svg-2" }], ["path", { "d": "M18 5l0 14", "key": "svg-3" }], ["path", { "d": "M3 17l18 -10", "key": "svg-4" }]]);

var IconTallymarks$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTallymarks
});

var IconTank = createReactComponent("outline", "tank", "IconTank", [["path", { "d": "M2 12m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v0a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M6 12l1 -5h5l3 5", "key": "svg-1" }], ["path", { "d": "M21 9l-7.8 0", "key": "svg-2" }]]);

var IconTank$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTank
});

var IconTargetArrow = createReactComponent("outline", "target-arrow", "IconTargetArrow", [["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M12 7a5 5 0 1 0 5 5", "key": "svg-1" }], ["path", { "d": "M13 3.055a9 9 0 1 0 7.941 7.945", "key": "svg-2" }], ["path", { "d": "M15 6v3h3l3 -3h-3v-3z", "key": "svg-3" }], ["path", { "d": "M15 9l-3 3", "key": "svg-4" }]]);

var IconTargetArrow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTargetArrow
});

var IconTargetOff = createReactComponent("outline", "target-off", "IconTargetOff", [["path", { "d": "M11.286 11.3a1 1 0 0 0 1.41 1.419", "key": "svg-0" }], ["path", { "d": "M8.44 8.49a5 5 0 0 0 7.098 7.044m1.377 -2.611a5 5 0 0 0 -5.846 -5.836", "key": "svg-1" }], ["path", { "d": "M5.649 5.623a9 9 0 1 0 12.698 12.758m1.683 -2.313a9 9 0 0 0 -12.076 -12.11", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconTargetOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTargetOff
});

var IconTarget = createReactComponent("outline", "target", "IconTarget", [["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-1" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-2" }]]);

var IconTarget$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTarget
});

var IconTaxEuro = createReactComponent("outline", "tax-euro", "IconTaxEuro", [["path", { "d": "M8.487 21h7.026a4 4 0 0 0 3.808 -5.224l-1.706 -5.306a5 5 0 0 0 -4.76 -3.47h-1.71a5 5 0 0 0 -4.76 3.47l-1.706 5.306a4 4 0 0 0 3.808 5.224", "key": "svg-0" }], ["path", { "d": "M15 3q -1 4 -3 4t -3 -4z", "key": "svg-1" }], ["path", { "d": "M12 14h-3", "key": "svg-2" }], ["path", { "d": "M14 11.172a3 3 0 1 0 0 5.656", "key": "svg-3" }]]);

var IconTaxEuro$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTaxEuro
});

var IconTaxPound = createReactComponent("outline", "tax-pound", "IconTaxPound", [["path", { "d": "M8.487 21h7.026a4 4 0 0 0 3.808 -5.224l-1.706 -5.306a5 5 0 0 0 -4.76 -3.47h-1.71a5 5 0 0 0 -4.76 3.47l-1.706 5.306a4 4 0 0 0 3.808 5.224", "key": "svg-0" }], ["path", { "d": "M15 3q -1 4 -3 4t -3 -4z", "key": "svg-1" }], ["path", { "d": "M14 11h-1a2 2 0 0 0 -2 2v2c0 1.105 -.395 2 -1.5 2h4.5", "key": "svg-2" }], ["path", { "d": "M10 14h3", "key": "svg-3" }]]);

var IconTaxPound$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTaxPound
});

var IconTax = createReactComponent("outline", "tax", "IconTax", [["path", { "d": "M8.487 21h7.026a4 4 0 0 0 3.808 -5.224l-1.706 -5.306a5 5 0 0 0 -4.76 -3.47h-1.71a5 5 0 0 0 -4.76 3.47l-1.706 5.306a4 4 0 0 0 3.808 5.224", "key": "svg-0" }], ["path", { "d": "M15 3q -1 4 -3 4t -3 -4z", "key": "svg-1" }], ["path", { "d": "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M12 10v1", "key": "svg-3" }], ["path", { "d": "M12 17v1", "key": "svg-4" }]]);

var IconTax$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTax
});

var IconTeapot = createReactComponent("outline", "teapot", "IconTeapot", [["path", { "d": "M10.29 3h3.42a2 2 0 0 1 1.988 1.78l1.555 14a2 2 0 0 1 -1.988 2.22h-6.53a2 2 0 0 1 -1.988 -2.22l1.555 -14a2 2 0 0 1 1.988 -1.78z", "key": "svg-0" }], ["path", { "d": "M7.47 12.5l-4.257 -5.019a.899 .899 0 0 1 .69 -1.481h13.09a3 3 0 0 1 3.007 3v3c0 1.657 -1.346 3 -3.007 3", "key": "svg-1" }], ["path", { "d": "M7 17h10", "key": "svg-2" }]]);

var IconTeapot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTeapot
});

var IconTelescopeOff = createReactComponent("outline", "telescope-off", "IconTelescopeOff", [["path", { "d": "M6 21l6 -5l6 5", "key": "svg-0" }], ["path", { "d": "M12 13v8", "key": "svg-1" }], ["path", { "d": "M8.238 8.264l-4.183 2.51c-1.02 .614 -1.357 1.898 -.76 2.906l.165 .28c.52 .88 1.624 1.266 2.605 .91l6.457 -2.34m2.907 -1.055l4.878 -1.77a1.023 1.023 0 0 0 .565 -1.455l-2.62 -4.705a1.087 1.087 0 0 0 -1.447 -.42l-.056 .032l-6.016 3.61", "key": "svg-2" }], ["path", { "d": "M14 5l3 5.5", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconTelescopeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTelescopeOff
});

var IconTelescope = createReactComponent("outline", "telescope", "IconTelescope", [["path", { "d": "M6 21l6 -5l6 5", "key": "svg-0" }], ["path", { "d": "M12 13v8", "key": "svg-1" }], ["path", { "d": "M3.294 13.678l.166 .281c.52 .88 1.624 1.265 2.605 .91l14.242 -5.165a1.023 1.023 0 0 0 .565 -1.456l-2.62 -4.705a1.087 1.087 0 0 0 -1.447 -.42l-.056 .032l-12.694 7.618c-1.02 .613 -1.357 1.897 -.76 2.905z", "key": "svg-2" }], ["path", { "d": "M14 5l3 5.5", "key": "svg-3" }]]);

var IconTelescope$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTelescope
});

var IconTemperatureCelsius = createReactComponent("outline", "temperature-celsius", "IconTemperatureCelsius", [["path", { "d": "M6 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M20 9a3 3 0 0 0 -3 -3h-1a3 3 0 0 0 -3 3v6a3 3 0 0 0 3 3h1a3 3 0 0 0 3 -3", "key": "svg-1" }]]);

var IconTemperatureCelsius$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTemperatureCelsius
});

var IconTemperatureFahrenheit = createReactComponent("outline", "temperature-fahrenheit", "IconTemperatureFahrenheit", [["path", { "d": "M6 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13 12l5 0", "key": "svg-1" }], ["path", { "d": "M20 6h-6a1 1 0 0 0 -1 1v11", "key": "svg-2" }]]);

var IconTemperatureFahrenheit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTemperatureFahrenheit
});

var IconTemperatureMinus = createReactComponent("outline", "temperature-minus", "IconTemperatureMinus", [["path", { "d": "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5", "key": "svg-0" }], ["path", { "d": "M8 9l4 0", "key": "svg-1" }], ["path", { "d": "M16 9l6 0", "key": "svg-2" }]]);

var IconTemperatureMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTemperatureMinus
});

var IconTemperatureOff = createReactComponent("outline", "temperature-off", "IconTemperatureOff", [["path", { "d": "M10 10v3.5a4 4 0 1 0 5.836 2.33m-1.836 -5.83v-5a2 2 0 1 0 -4 0v1", "key": "svg-0" }], ["path", { "d": "M13 9h1", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconTemperatureOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTemperatureOff
});

var IconTemperaturePlus = createReactComponent("outline", "temperature-plus", "IconTemperaturePlus", [["path", { "d": "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5", "key": "svg-0" }], ["path", { "d": "M8 9l4 0", "key": "svg-1" }], ["path", { "d": "M16 9l6 0", "key": "svg-2" }], ["path", { "d": "M19 6l0 6", "key": "svg-3" }]]);

var IconTemperaturePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTemperaturePlus
});

var IconTemperatureSnow = createReactComponent("outline", "temperature-snow", "IconTemperatureSnow", [["path", { "d": "M4 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 1 0 -4 0v8.5", "key": "svg-0" }], ["path", { "d": "M4 9h4", "key": "svg-1" }], ["path", { "d": "M14.75 4l1 2h2.25", "key": "svg-2" }], ["path", { "d": "M17 4l-3 5l2 3", "key": "svg-3" }], ["path", { "d": "M20.25 10l-1.25 2l1.25 2", "key": "svg-4" }], ["path", { "d": "M22 12h-6l-2 3", "key": "svg-5" }], ["path", { "d": "M18 18h-2.25l-1 2", "key": "svg-6" }], ["path", { "d": "M17 20l-3 -5h-1", "key": "svg-7" }], ["path", { "d": "M12 9l2.088 .008", "key": "svg-8" }]]);

var IconTemperatureSnow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTemperatureSnow
});

var IconTemperatureSun = createReactComponent("outline", "temperature-sun", "IconTemperatureSun", [["path", { "d": "M4 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 1 0 -4 0v8.5", "key": "svg-0" }], ["path", { "d": "M4 9h4", "key": "svg-1" }], ["path", { "d": "M13 16a4 4 0 1 0 0 -8a4.07 4.07 0 0 0 -1 .124", "key": "svg-2" }], ["path", { "d": "M13 3v1", "key": "svg-3" }], ["path", { "d": "M21 12h1", "key": "svg-4" }], ["path", { "d": "M13 20v1", "key": "svg-5" }], ["path", { "d": "M19.4 5.6l-.7 .7", "key": "svg-6" }], ["path", { "d": "M18.7 17.7l.7 .7", "key": "svg-7" }]]);

var IconTemperatureSun$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTemperatureSun
});

var IconTemperature = createReactComponent("outline", "temperature", "IconTemperature", [["path", { "d": "M10 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5", "key": "svg-0" }], ["path", { "d": "M10 9l4 0", "key": "svg-1" }]]);

var IconTemperature$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTemperature
});

var IconTemplateOff = createReactComponent("outline", "template-off", "IconTemplateOff", [["path", { "d": "M8 4h11a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-7m-4 0h-3a1 1 0 0 1 -1 -1v-2c0 -.271 .108 -.517 .283 -.697", "key": "svg-0" }], ["path", { "d": "M4 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M16 12h4", "key": "svg-2" }], ["path", { "d": "M14 16h2", "key": "svg-3" }], ["path", { "d": "M14 20h6", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconTemplateOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTemplateOff
});

var IconTemplate = createReactComponent("outline", "template", "IconTemplate", [["path", { "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M4 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M14 12l6 0", "key": "svg-2" }], ["path", { "d": "M14 16l6 0", "key": "svg-3" }], ["path", { "d": "M14 20l6 0", "key": "svg-4" }]]);

var IconTemplate$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTemplate
});

var IconTentOff = createReactComponent("outline", "tent-off", "IconTentOff", [["path", { "d": "M11 14l4 6h5m-2.863 -6.868l-5.137 -9.132l-1.44 2.559m-1.44 2.563l-6.12 10.878h6l4 -6", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconTentOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTentOff
});

var IconTent = createReactComponent("outline", "tent", "IconTent", [["path", { "d": "M11 14l4 6h6l-9 -16l-9 16h6l4 -6", "key": "svg-0" }]]);

var IconTent$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTent
});

var IconTerminal2 = createReactComponent("outline", "terminal-2", "IconTerminal2", [["path", { "d": "M8 9l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M13 15l3 0", "key": "svg-1" }], ["path", { "d": "M3 4m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-2" }]]);

var IconTerminal2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTerminal2
});

var IconTerminal = createReactComponent("outline", "terminal", "IconTerminal", [["path", { "d": "M5 7l5 5l-5 5", "key": "svg-0" }], ["path", { "d": "M12 19l7 0", "key": "svg-1" }]]);

var IconTerminal$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTerminal
});

var IconTestPipe2 = createReactComponent("outline", "test-pipe-2", "IconTestPipe2", [["path", { "d": "M15 3v15a3 3 0 0 1 -6 0v-15", "key": "svg-0" }], ["path", { "d": "M9 12h6", "key": "svg-1" }], ["path", { "d": "M8 3h8", "key": "svg-2" }]]);

var IconTestPipe2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTestPipe2
});

var IconTestPipeOff = createReactComponent("outline", "test-pipe-off", "IconTestPipeOff", [["path", { "d": "M20 8.04a803.533 803.533 0 0 0 -4 3.96m-2 2c-1.085 1.085 -3.125 3.14 -6.122 6.164a2.857 2.857 0 0 1 -4.041 -4.04c3.018 -3 5.073 -5.037 6.163 -6.124m2 -2c.872 -.872 2.191 -2.205 3.959 -4", "key": "svg-0" }], ["path", { "d": "M7 13h6", "key": "svg-1" }], ["path", { "d": "M19 15l1.5 1.6m-.74 3.173a2 2 0 0 1 -2.612 -2.608", "key": "svg-2" }], ["path", { "d": "M15 3l6 6", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconTestPipeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTestPipeOff
});

var IconTestPipe = createReactComponent("outline", "test-pipe", "IconTestPipe", [["path", { "d": "M20 8.04l-12.122 12.124a2.857 2.857 0 1 1 -4.041 -4.04l12.122 -12.124", "key": "svg-0" }], ["path", { "d": "M7 13h8", "key": "svg-1" }], ["path", { "d": "M19 15l1.5 1.6a2 2 0 1 1 -3 0l1.5 -1.6z", "key": "svg-2" }], ["path", { "d": "M15 3l6 6", "key": "svg-3" }]]);

var IconTestPipe$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTestPipe
});

var IconTex = createReactComponent("outline", "tex", "IconTex", [["path", { "d": "M9 8v-1h-6v1", "key": "svg-0" }], ["path", { "d": "M6 15v-8", "key": "svg-1" }], ["path", { "d": "M21 15l-5 -8", "key": "svg-2" }], ["path", { "d": "M16 15l5 -8", "key": "svg-3" }], ["path", { "d": "M14 11h-4v8h4", "key": "svg-4" }], ["path", { "d": "M10 15h3", "key": "svg-5" }]]);

var IconTex$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTex
});

var IconTextCaption = createReactComponent("outline", "text-caption", "IconTextCaption", [["path", { "d": "M4 15h16", "key": "svg-0" }], ["path", { "d": "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M4 20h12", "key": "svg-2" }]]);

var IconTextCaption$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextCaption
});

var IconTextColor = createReactComponent("outline", "text-color", "IconTextColor", [["path", { "d": "M9 15v-7a3 3 0 0 1 6 0v7", "key": "svg-0" }], ["path", { "d": "M9 11h6", "key": "svg-1" }], ["path", { "d": "M5 19h14", "key": "svg-2" }]]);

var IconTextColor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextColor
});

var IconTextDecrease = createReactComponent("outline", "text-decrease", "IconTextDecrease", [["path", { "d": "M4 19v-10.5a3.5 3.5 0 1 1 7 0v10.5", "key": "svg-0" }], ["path", { "d": "M4 13h7", "key": "svg-1" }], ["path", { "d": "M21 12h-6", "key": "svg-2" }]]);

var IconTextDecrease$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextDecrease
});

var IconTextDirectionLtr = createReactComponent("outline", "text-direction-ltr", "IconTextDirectionLtr", [["path", { "d": "M5 19h14", "key": "svg-0" }], ["path", { "d": "M17 21l2 -2l-2 -2", "key": "svg-1" }], ["path", { "d": "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5", "key": "svg-2" }], ["path", { "d": "M14 15v-11", "key": "svg-3" }], ["path", { "d": "M10 15v-11", "key": "svg-4" }]]);

var IconTextDirectionLtr$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextDirectionLtr
});

var IconTextDirectionRtl = createReactComponent("outline", "text-direction-rtl", "IconTextDirectionRtl", [["path", { "d": "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5", "key": "svg-0" }], ["path", { "d": "M14 15v-11", "key": "svg-1" }], ["path", { "d": "M10 15v-11", "key": "svg-2" }], ["path", { "d": "M5 19h14", "key": "svg-3" }], ["path", { "d": "M7 21l-2 -2l2 -2", "key": "svg-4" }]]);

var IconTextDirectionRtl$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextDirectionRtl
});

var IconTextGrammar = createReactComponent("outline", "text-grammar", "IconTextGrammar", [["path", { "d": "M14 9a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M4 12v-5a3 3 0 1 1 6 0v5", "key": "svg-1" }], ["path", { "d": "M4 9h6", "key": "svg-2" }], ["path", { "d": "M20 6v6", "key": "svg-3" }], ["path", { "d": "M4 16h12", "key": "svg-4" }], ["path", { "d": "M4 20h6", "key": "svg-5" }], ["path", { "d": "M14 20l2 2l5 -5", "key": "svg-6" }]]);

var IconTextGrammar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextGrammar
});

var IconTextIncrease = createReactComponent("outline", "text-increase", "IconTextIncrease", [["path", { "d": "M4 19v-10.5a3.5 3.5 0 1 1 7 0v10.5", "key": "svg-0" }], ["path", { "d": "M4 13h7", "key": "svg-1" }], ["path", { "d": "M18 9v6", "key": "svg-2" }], ["path", { "d": "M21 12h-6", "key": "svg-3" }]]);

var IconTextIncrease$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextIncrease
});

var IconTextOrientation = createReactComponent("outline", "text-orientation", "IconTextOrientation", [["path", { "d": "M9 15l-5 -5c-1.367 -1.367 -1.367 -3.633 0 -5s3.633 -1.367 5 0l5 5", "key": "svg-0" }], ["path", { "d": "M5.5 11.5l5 -5", "key": "svg-1" }], ["path", { "d": "M21 12l-9 9", "key": "svg-2" }], ["path", { "d": "M21 12v4", "key": "svg-3" }], ["path", { "d": "M21 12h-4", "key": "svg-4" }]]);

var IconTextOrientation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextOrientation
});

var IconTextPlus = createReactComponent("outline", "text-plus", "IconTextPlus", [["path", { "d": "M19 10h-14", "key": "svg-0" }], ["path", { "d": "M5 6h14", "key": "svg-1" }], ["path", { "d": "M14 14h-9", "key": "svg-2" }], ["path", { "d": "M5 18h6", "key": "svg-3" }], ["path", { "d": "M18 15v6", "key": "svg-4" }], ["path", { "d": "M15 18h6", "key": "svg-5" }]]);

var IconTextPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextPlus
});

var IconTextRecognition = createReactComponent("outline", "text-recognition", "IconTextRecognition", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M12 16v-7", "key": "svg-4" }], ["path", { "d": "M9 9h6", "key": "svg-5" }]]);

var IconTextRecognition$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextRecognition
});

var IconTextResize = createReactComponent("outline", "text-resize", "IconTextResize", [["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M5 7v10", "key": "svg-4" }], ["path", { "d": "M7 5h10", "key": "svg-5" }], ["path", { "d": "M7 19h10", "key": "svg-6" }], ["path", { "d": "M19 7v10", "key": "svg-7" }], ["path", { "d": "M10 10h4", "key": "svg-8" }], ["path", { "d": "M12 14v-4", "key": "svg-9" }]]);

var IconTextResize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextResize
});

var IconTextScan2 = createReactComponent("outline", "text-scan-2", "IconTextScan2", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M8 12h8", "key": "svg-4" }], ["path", { "d": "M8 9h6", "key": "svg-5" }], ["path", { "d": "M8 15h4", "key": "svg-6" }]]);

var IconTextScan2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextScan2
});

var IconTextSize = createReactComponent("outline", "text-size", "IconTextSize", [["path", { "d": "M3 7v-2h13v2", "key": "svg-0" }], ["path", { "d": "M10 5v14", "key": "svg-1" }], ["path", { "d": "M12 19h-4", "key": "svg-2" }], ["path", { "d": "M15 13v-1h6v1", "key": "svg-3" }], ["path", { "d": "M18 12v7", "key": "svg-4" }], ["path", { "d": "M17 19h2", "key": "svg-5" }]]);

var IconTextSize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextSize
});

var IconTextSpellcheck = createReactComponent("outline", "text-spellcheck", "IconTextSpellcheck", [["path", { "d": "M5 15v-7.5a3.5 3.5 0 0 1 7 0v7.5", "key": "svg-0" }], ["path", { "d": "M5 10h7", "key": "svg-1" }], ["path", { "d": "M10 18l3 3l7 -7", "key": "svg-2" }]]);

var IconTextSpellcheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextSpellcheck
});

var IconTextWrapColumn = createReactComponent("outline", "text-wrap-column", "IconTextWrapColumn", [["path", { "d": "M7 9h7a3 3 0 0 1 0 6h-4l2 -2", "key": "svg-0" }], ["path", { "d": "M12 17l-2 -2", "key": "svg-1" }], ["path", { "d": "M3 3v18", "key": "svg-2" }], ["path", { "d": "M21 3v18", "key": "svg-3" }]]);

var IconTextWrapColumn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextWrapColumn
});

var IconTextWrapDisabled = createReactComponent("outline", "text-wrap-disabled", "IconTextWrapDisabled", [["path", { "d": "M4 6l10 0", "key": "svg-0" }], ["path", { "d": "M4 18l10 0", "key": "svg-1" }], ["path", { "d": "M4 12h17l-3 -3m0 6l3 -3", "key": "svg-2" }]]);

var IconTextWrapDisabled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextWrapDisabled
});

var IconTextWrap = createReactComponent("outline", "text-wrap", "IconTextWrap", [["path", { "d": "M4 6l16 0", "key": "svg-0" }], ["path", { "d": "M4 18l5 0", "key": "svg-1" }], ["path", { "d": "M4 12h13a3 3 0 0 1 0 6h-4l2 -2m0 4l-2 -2", "key": "svg-2" }]]);

var IconTextWrap$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTextWrap
});

var IconTexture = createReactComponent("outline", "texture", "IconTexture", [["path", { "d": "M6 3l-3 3", "key": "svg-0" }], ["path", { "d": "M21 18l-3 3", "key": "svg-1" }], ["path", { "d": "M11 3l-8 8", "key": "svg-2" }], ["path", { "d": "M16 3l-13 13", "key": "svg-3" }], ["path", { "d": "M21 3l-18 18", "key": "svg-4" }], ["path", { "d": "M21 8l-13 13", "key": "svg-5" }], ["path", { "d": "M21 13l-8 8", "key": "svg-6" }]]);

var IconTexture$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTexture
});

var IconTheater = createReactComponent("outline", "theater", "IconTheater", [["path", { "d": "M4 20h16", "key": "svg-0" }], ["path", { "d": "M20 16v-10a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v10l4 -6c2.667 1.333 5.333 1.333 8 0l4 6z", "key": "svg-1" }]]);

var IconTheater$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTheater
});

var IconThermometer = createReactComponent("outline", "thermometer", "IconThermometer", [["path", { "d": "M19 5a2.828 2.828 0 0 1 0 4l-8 8h-4v-4l8 -8a2.828 2.828 0 0 1 4 0z", "key": "svg-0" }], ["path", { "d": "M16 7l-1.5 -1.5", "key": "svg-1" }], ["path", { "d": "M13 10l-1.5 -1.5", "key": "svg-2" }], ["path", { "d": "M10 13l-1.5 -1.5", "key": "svg-3" }], ["path", { "d": "M7 17l-3 3", "key": "svg-4" }]]);

var IconThermometer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconThermometer
});

var IconThumbDownOff = createReactComponent("outline", "thumb-down-off", "IconThumbDownOff", [["path", { "d": "M7 13v-6m-3 -3a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 1 0 4 0v-3m2 -2h1a2 2 0 0 0 2 -2l-1 -5c-.295 -1.26 -1.11 -2.076 -2 -2h-7c-.57 0 -1.102 .159 -1.556 .434", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconThumbDownOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconThumbDownOff
});

var IconThumbDown = createReactComponent("outline", "thumb-down", "IconThumbDown", [["path", { "d": "M7 13v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 0 0 4 0v-5h3a2 2 0 0 0 2 -2l-1 -5a2 3 0 0 0 -2 -2h-7a3 3 0 0 0 -3 3", "key": "svg-0" }]]);

var IconThumbDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconThumbDown
});

var IconThumbUpOff = createReactComponent("outline", "thumb-up-off", "IconThumbUpOff", [["path", { "d": "M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a3.987 3.987 0 0 0 2.828 -1.172m1.172 -2.828v-1a2 2 0 1 1 4 0v5h3a2 2 0 0 1 2 2c-.222 1.112 -.39 1.947 -.5 2.503m-.758 3.244c-.392 .823 -1.044 1.312 -1.742 1.253h-7a3 3 0 0 1 -3 -3", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconThumbUpOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconThumbUpOff
});

var IconThumbUp = createReactComponent("outline", "thumb-up", "IconThumbUp", [["path", { "d": "M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3", "key": "svg-0" }]]);

var IconThumbUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconThumbUp
});

var IconTicTac = createReactComponent("outline", "tic-tac", "IconTicTac", [["path", { "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M3 12h18", "key": "svg-1" }], ["path", { "d": "M12 3v18", "key": "svg-2" }], ["path", { "d": "M4 16l4 4", "key": "svg-3" }], ["path", { "d": "M4 20l4 -4", "key": "svg-4" }], ["path", { "d": "M16 4l4 4", "key": "svg-5" }], ["path", { "d": "M16 8l4 -4", "key": "svg-6" }], ["path", { "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-7" }]]);

var IconTicTac$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTicTac
});

var IconTicketOff = createReactComponent("outline", "ticket-off", "IconTicketOff", [["path", { "d": "M15 5v2", "key": "svg-0" }], ["path", { "d": "M15 17v2", "key": "svg-1" }], ["path", { "d": "M9 5h10a2 2 0 0 1 2 2v3a2 2 0 1 0 0 4v3m-2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 1 0 0 -4v-3a2 2 0 0 1 2 -2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconTicketOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTicketOff
});

var IconTicket = createReactComponent("outline", "ticket", "IconTicket", [["path", { "d": "M15 5l0 2", "key": "svg-0" }], ["path", { "d": "M15 11l0 2", "key": "svg-1" }], ["path", { "d": "M15 17l0 2", "key": "svg-2" }], ["path", { "d": "M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2", "key": "svg-3" }]]);

var IconTicket$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTicket
});

var IconTie = createReactComponent("outline", "tie", "IconTie", [["path", { "d": "M12 22l4 -4l-2.5 -11l.993 -2.649a1 1 0 0 0 -.936 -1.351h-3.114a1 1 0 0 0 -.936 1.351l.993 2.649l-2.5 11l4 4z", "key": "svg-0" }], ["path", { "d": "M10.5 7h3l5 5.5", "key": "svg-1" }]]);

var IconTie$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTie
});

var IconTilde = createReactComponent("outline", "tilde", "IconTilde", [["path", { "d": "M4 12c0 -1.657 1.592 -3 3.556 -3c1.963 0 3.11 1.5 4.444 3c1.333 1.5 2.48 3 4.444 3s3.556 -1.343 3.556 -3", "key": "svg-0" }]]);

var IconTilde$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTilde
});

var IconTiltShiftOff = createReactComponent("outline", "tilt-shift-off", "IconTiltShiftOff", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -.577 .263", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M10.57 10.602a2 2 0 0 0 2.862 2.795", "key": "svg-8" }], ["path", { "d": "M3 3l18 18", "key": "svg-9" }]]);

var IconTiltShiftOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTiltShiftOff
});

var IconTiltShift = createReactComponent("outline", "tilt-shift", "IconTiltShift", [["path", { "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95", "key": "svg-0" }], ["path", { "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44", "key": "svg-1" }], ["path", { "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92", "key": "svg-2" }], ["path", { "d": "M8.56 20.31a9 9 0 0 0 3.44 .69", "key": "svg-3" }], ["path", { "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95", "key": "svg-4" }], ["path", { "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44", "key": "svg-5" }], ["path", { "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92", "key": "svg-6" }], ["path", { "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69", "key": "svg-7" }], ["path", { "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-8" }]]);

var IconTiltShift$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTiltShift
});

var IconTimeDuration0 = createReactComponent("outline", "time-duration-0", "IconTimeDuration0", [["path", { "d": "M3 12v.01", "key": "svg-0" }], ["path", { "d": "M21 12v.01", "key": "svg-1" }], ["path", { "d": "M12 21v.01", "key": "svg-2" }], ["path", { "d": "M12 3v.01", "key": "svg-3" }], ["path", { "d": "M7.5 4.2v.01", "key": "svg-4" }], ["path", { "d": "M16.5 4.2v.01", "key": "svg-5" }], ["path", { "d": "M16.5 19.8v.01", "key": "svg-6" }], ["path", { "d": "M7.5 19.8v.01", "key": "svg-7" }], ["path", { "d": "M4.2 16.5v.01", "key": "svg-8" }], ["path", { "d": "M19.8 16.5v.01", "key": "svg-9" }], ["path", { "d": "M19.8 7.5v.01", "key": "svg-10" }], ["path", { "d": "M4.2 7.5v.01", "key": "svg-11" }], ["path", { "d": "M10 11v2a2 2 0 1 0 4 0v-2a2 2 0 1 0 -4 0z", "key": "svg-12" }]]);

var IconTimeDuration0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimeDuration0
});

var IconTimeDuration10 = createReactComponent("outline", "time-duration-10", "IconTimeDuration10", [["path", { "d": "M9 9v6", "key": "svg-0" }], ["path", { "d": "M12 11v2a2 2 0 1 0 4 0v-2a2 2 0 1 0 -4 0z", "key": "svg-1" }], ["path", { "d": "M3 12v.01", "key": "svg-2" }], ["path", { "d": "M21 12v.01", "key": "svg-3" }], ["path", { "d": "M12 21v.01", "key": "svg-4" }], ["path", { "d": "M7.5 4.2v.01", "key": "svg-5" }], ["path", { "d": "M16.5 19.8v.01", "key": "svg-6" }], ["path", { "d": "M7.5 19.8v.01", "key": "svg-7" }], ["path", { "d": "M4.2 16.5v.01", "key": "svg-8" }], ["path", { "d": "M19.8 16.5v.01", "key": "svg-9" }], ["path", { "d": "M4.2 7.5v.01", "key": "svg-10" }], ["path", { "d": "M19.81 7.527a8.994 8.994 0 0 0 -7.81 -4.527", "key": "svg-11" }]]);

var IconTimeDuration10$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimeDuration10
});

var IconTimeDuration15 = createReactComponent("outline", "time-duration-15", "IconTimeDuration15", [["path", { "d": "M12 15h2a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2v-3h3", "key": "svg-0" }], ["path", { "d": "M9 9v6", "key": "svg-1" }], ["path", { "d": "M3 12v.01", "key": "svg-2" }], ["path", { "d": "M12 21v.01", "key": "svg-3" }], ["path", { "d": "M7.5 4.2v.01", "key": "svg-4" }], ["path", { "d": "M16.5 19.8v.01", "key": "svg-5" }], ["path", { "d": "M7.5 19.8v.01", "key": "svg-6" }], ["path", { "d": "M4.2 16.5v.01", "key": "svg-7" }], ["path", { "d": "M19.8 16.5v.01", "key": "svg-8" }], ["path", { "d": "M4.2 7.5v.01", "key": "svg-9" }], ["path", { "d": "M21 12a9 9 0 0 0 -9 -9", "key": "svg-10" }]]);

var IconTimeDuration15$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimeDuration15
});

var IconTimeDuration30 = createReactComponent("outline", "time-duration-30", "IconTimeDuration30", [["path", { "d": "M14 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-0" }], ["path", { "d": "M8 9h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5", "key": "svg-1" }], ["path", { "d": "M3 12v.01", "key": "svg-2" }], ["path", { "d": "M7.5 4.2v.01", "key": "svg-3" }], ["path", { "d": "M7.5 19.8v.01", "key": "svg-4" }], ["path", { "d": "M4.2 16.5v.01", "key": "svg-5" }], ["path", { "d": "M4.2 7.5v.01", "key": "svg-6" }], ["path", { "d": "M12 21a9 9 0 0 0 0 -18", "key": "svg-7" }]]);

var IconTimeDuration30$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimeDuration30
});

var IconTimeDuration45 = createReactComponent("outline", "time-duration-45", "IconTimeDuration45", [["path", { "d": "M13 15h2a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2v-3h3", "key": "svg-0" }], ["path", { "d": "M7 9v2a1 1 0 0 0 1 1h1", "key": "svg-1" }], ["path", { "d": "M10 9v6", "key": "svg-2" }], ["path", { "d": "M7.5 4.2v.01", "key": "svg-3" }], ["path", { "d": "M4.2 7.5v.01", "key": "svg-4" }], ["path", { "d": "M3 12a9 9 0 1 0 9 -9", "key": "svg-5" }]]);

var IconTimeDuration45$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimeDuration45
});

var IconTimeDuration5 = createReactComponent("outline", "time-duration-5", "IconTimeDuration5", [["path", { "d": "M10 15h2a1.5 1.5 0 0 0 0 -3h-2v-3h3.5", "key": "svg-0" }], ["path", { "d": "M3 12v.01", "key": "svg-1" }], ["path", { "d": "M21 12v.01", "key": "svg-2" }], ["path", { "d": "M12 21v.01", "key": "svg-3" }], ["path", { "d": "M7.5 4.2v.01", "key": "svg-4" }], ["path", { "d": "M16.5 19.8v.01", "key": "svg-5" }], ["path", { "d": "M7.5 19.8v.01", "key": "svg-6" }], ["path", { "d": "M4.2 16.5v.01", "key": "svg-7" }], ["path", { "d": "M19.8 16.5v.01", "key": "svg-8" }], ["path", { "d": "M19.8 7.5v.01", "key": "svg-9" }], ["path", { "d": "M4.2 7.5v.01", "key": "svg-10" }], ["path", { "d": "M16.5 4.206a9.042 9.042 0 0 0 -4.5 -1.206", "key": "svg-11" }]]);

var IconTimeDuration5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimeDuration5
});

var IconTimeDuration60 = createReactComponent("outline", "time-duration-60", "IconTimeDuration60", [["path", { "d": "M14 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-0" }], ["path", { "d": "M11 9h-2a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2", "key": "svg-1" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-2" }]]);

var IconTimeDuration60$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimeDuration60
});

var IconTimeDuration90 = createReactComponent("outline", "time-duration-90", "IconTimeDuration90", [["path", { "d": "M8 14.25c0 .414 .336 .75 .75 .75h1.5a.75 .75 0 0 0 .75 -.75v-4.5a.75 .75 0 0 0 -.75 -.75h-1.5a.75 .75 0 0 0 -.75 .75v1.5c0 .414 .336 .75 .75 .75h2.25", "key": "svg-0" }], ["path", { "d": "M14 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z", "key": "svg-1" }], ["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-2" }]]);

var IconTimeDuration90$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimeDuration90
});

var IconTimeDurationOff = createReactComponent("outline", "time-duration-off", "IconTimeDurationOff", [["path", { "d": "M3 12v.01", "key": "svg-0" }], ["path", { "d": "M7.5 19.8v.01", "key": "svg-1" }], ["path", { "d": "M4.2 16.5v.01", "key": "svg-2" }], ["path", { "d": "M4.2 7.5v.01", "key": "svg-3" }], ["path", { "d": "M12 21a8.994 8.994 0 0 0 6.362 -2.634m1.685 -2.336a9 9 0 0 0 -8.047 -13.03", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconTimeDurationOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimeDurationOff
});

var IconTimelineEventExclamation = createReactComponent("outline", "timeline-event-exclamation", "IconTimelineEventExclamation", [["path", { "d": "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M10 20h-6", "key": "svg-1" }], ["path", { "d": "M14 20h6", "key": "svg-2" }], ["path", { "d": "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z", "key": "svg-3" }], ["path", { "d": "M12 6v2", "key": "svg-4" }], ["path", { "d": "M12 11v.01", "key": "svg-5" }]]);

var IconTimelineEventExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimelineEventExclamation
});

var IconTimelineEventMinus = createReactComponent("outline", "timeline-event-minus", "IconTimelineEventMinus", [["path", { "d": "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M10 20h-6", "key": "svg-1" }], ["path", { "d": "M14 20h6", "key": "svg-2" }], ["path", { "d": "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z", "key": "svg-3" }], ["path", { "d": "M10 8h4", "key": "svg-4" }]]);

var IconTimelineEventMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimelineEventMinus
});

var IconTimelineEventPlus = createReactComponent("outline", "timeline-event-plus", "IconTimelineEventPlus", [["path", { "d": "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M10 20h-6", "key": "svg-1" }], ["path", { "d": "M14 20h6", "key": "svg-2" }], ["path", { "d": "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z", "key": "svg-3" }], ["path", { "d": "M10 8h4", "key": "svg-4" }], ["path", { "d": "M12 6v4", "key": "svg-5" }]]);

var IconTimelineEventPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimelineEventPlus
});

var IconTimelineEventText = createReactComponent("outline", "timeline-event-text", "IconTimelineEventText", [["path", { "d": "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M10 20h-6", "key": "svg-1" }], ["path", { "d": "M14 20h6", "key": "svg-2" }], ["path", { "d": "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z", "key": "svg-3" }], ["path", { "d": "M9 6h6", "key": "svg-4" }], ["path", { "d": "M9 9h3", "key": "svg-5" }]]);

var IconTimelineEventText$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimelineEventText
});

var IconTimelineEventX = createReactComponent("outline", "timeline-event-x", "IconTimelineEventX", [["path", { "d": "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M10 20h-6", "key": "svg-1" }], ["path", { "d": "M14 20h6", "key": "svg-2" }], ["path", { "d": "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z", "key": "svg-3" }], ["path", { "d": "M13.5 9.5l-3 -3", "key": "svg-4" }], ["path", { "d": "M10.5 9.5l3 -3", "key": "svg-5" }]]);

var IconTimelineEventX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimelineEventX
});

var IconTimelineEvent = createReactComponent("outline", "timeline-event", "IconTimelineEvent", [["path", { "d": "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M10 20h-6", "key": "svg-1" }], ["path", { "d": "M14 20h6", "key": "svg-2" }], ["path", { "d": "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z", "key": "svg-3" }]]);

var IconTimelineEvent$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimelineEvent
});

var IconTimeline = createReactComponent("outline", "timeline", "IconTimeline", [["path", { "d": "M4 16l6 -7l5 5l5 -6", "key": "svg-0" }], ["path", { "d": "M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M10 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M4 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }]]);

var IconTimeline$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimeline
});

var IconTimezone = createReactComponent("outline", "timezone", "IconTimezone", [["path", { "d": "M20.884 10.554a9 9 0 1 0 -10.337 10.328", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h6.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 -1.502 14.954", "key": "svg-3" }], ["path", { "d": "M12.5 3a17 17 0 0 1 2.52 7.603", "key": "svg-4" }], ["path", { "d": "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-5" }], ["path", { "d": "M18 16.5v1.5l.5 .5", "key": "svg-6" }]]);

var IconTimezone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimezone
});

var IconTipJarEuro = createReactComponent("outline", "tip-jar-euro", "IconTipJarEuro", [["path", { "d": "M17 4v1.882c0 .685 .387 1.312 1 1.618s1 .933 1 1.618v8.882a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-8.882c0 -.685 .387 -1.312 1 -1.618s1 -.933 1 -1.618v-1.882", "key": "svg-0" }], ["path", { "d": "M6 4h12z", "key": "svg-1" }], ["path", { "d": "M12 13h-3", "key": "svg-2" }], ["path", { "d": "M14 10.172a3 3 0 1 0 0 5.656", "key": "svg-3" }]]);

var IconTipJarEuro$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTipJarEuro
});

var IconTipJarPound = createReactComponent("outline", "tip-jar-pound", "IconTipJarPound", [["path", { "d": "M17 4v1.882c0 .685 .387 1.312 1 1.618s1 .933 1 1.618v8.882a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-8.882c0 -.685 .387 -1.312 1 -1.618s1 -.933 1 -1.618v-1.882", "key": "svg-0" }], ["path", { "d": "M6 4h12z", "key": "svg-1" }], ["path", { "d": "M14 10h-1a2 2 0 0 0 -2 2v2c0 1.105 -.395 2 -1.5 2h4.5", "key": "svg-2" }], ["path", { "d": "M10 13h3", "key": "svg-3" }]]);

var IconTipJarPound$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTipJarPound
});

var IconTipJar = createReactComponent("outline", "tip-jar", "IconTipJar", [["path", { "d": "M14 10h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-0" }], ["path", { "d": "M12 9v1", "key": "svg-1" }], ["path", { "d": "M12 16v1", "key": "svg-2" }], ["path", { "d": "M17 4v1.882c0 .685 .387 1.312 1 1.618s1 .933 1 1.618v8.882a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-8.882c0 -.685 .387 -1.312 1 -1.618s1 -.933 1 -1.618v-1.882", "key": "svg-3" }], ["path", { "d": "M6 4h12z", "key": "svg-4" }]]);

var IconTipJar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTipJar
});

var IconTir = createReactComponent("outline", "tir", "IconTir", [["path", { "d": "M5 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M7 18h8m4 0h2v-6a5 7 0 0 0 -5 -7h-1l1.5 7h4.5", "key": "svg-2" }], ["path", { "d": "M12 18v-13h3", "key": "svg-3" }], ["path", { "d": "M3 17l0 -5l9 0", "key": "svg-4" }]]);

var IconTir$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTir
});

var IconToggleLeft = createReactComponent("outline", "toggle-left", "IconToggleLeft", [["path", { "d": "M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M2 6m0 6a6 6 0 0 1 6 -6h8a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-8a6 6 0 0 1 -6 -6z", "key": "svg-1" }]]);

var IconToggleLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToggleLeft
});

var IconToggleRight = createReactComponent("outline", "toggle-right", "IconToggleRight", [["path", { "d": "M16 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M2 6m0 6a6 6 0 0 1 6 -6h8a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-8a6 6 0 0 1 -6 -6z", "key": "svg-1" }]]);

var IconToggleRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToggleRight
});

var IconToiletPaperOff = createReactComponent("outline", "toilet-paper-off", "IconToiletPaperOff", [["path", { "d": "M4.27 4.28c-.768 1.27 -1.27 3.359 -1.27 5.72c0 3.866 1.343 7 3 7s3 -3.134 3 -7c0 -.34 -.01 -.672 -.03 -1", "key": "svg-0" }], ["path", { "d": "M21 10c0 -3.866 -1.343 -7 -3 -7", "key": "svg-1" }], ["path", { "d": "M7 3h11", "key": "svg-2" }], ["path", { "d": "M21 10v7m-1.513 2.496l-1.487 -.496l-3 2l-3 -3l-3 2v-10", "key": "svg-3" }], ["path", { "d": "M6 10h.01", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconToiletPaperOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToiletPaperOff
});

var IconToiletPaper = createReactComponent("outline", "toilet-paper", "IconToiletPaper", [["path", { "d": "M6 10m-3 0a3 7 0 1 0 6 0a3 7 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M21 10c0 -3.866 -1.343 -7 -3 -7", "key": "svg-1" }], ["path", { "d": "M6 3h12", "key": "svg-2" }], ["path", { "d": "M21 10v10l-3 -1l-3 2l-3 -3l-3 2v-10", "key": "svg-3" }], ["path", { "d": "M6 10h.01", "key": "svg-4" }]]);

var IconToiletPaper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToiletPaper
});

var IconToml = createReactComponent("outline", "toml", "IconToml", [["path", { "d": "M1.499 8h3", "key": "svg-0" }], ["path", { "d": "M2.999 8v8", "key": "svg-1" }], ["path", { "d": "M8.5 8a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1 -3 0v-5a1.5 1.5 0 0 1 1.5 -1.5z", "key": "svg-2" }], ["path", { "d": "M13 16v-8l2 5l2 -5v8", "key": "svg-3" }], ["path", { "d": "M20 8v8h2.5", "key": "svg-4" }]]);

var IconToml$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToml
});

var IconTool = createReactComponent("outline", "tool", "IconTool", [["path", { "d": "M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5", "key": "svg-0" }]]);

var IconTool$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTool
});

var IconToolsKitchen2Off = createReactComponent("outline", "tools-kitchen-2-off", "IconToolsKitchen2Off", [["path", { "d": "M14.386 10.409c.53 -2.28 1.766 -4.692 4.614 -7.409v12m-4 0h-1c0 -.313 0 -.627 0 -.941", "key": "svg-0" }], ["path", { "d": "M19 19v2h-1v-3", "key": "svg-1" }], ["path", { "d": "M8 8v13", "key": "svg-2" }], ["path", { "d": "M5 5v2a3 3 0 0 0 4.546 2.572m1.454 -2.572v-3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconToolsKitchen2Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToolsKitchen2Off
});

var IconToolsKitchen2 = createReactComponent("outline", "tools-kitchen-2", "IconToolsKitchen2", [["path", { "d": "M19 3v12h-5c-.023 -3.681 .184 -7.406 5 -12zm0 12v6h-1v-3m-10 -14v17m-3 -17v3a3 3 0 1 0 6 0v-3", "key": "svg-0" }]]);

var IconToolsKitchen2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToolsKitchen2
});

var IconToolsKitchen3 = createReactComponent("outline", "tools-kitchen-3", "IconToolsKitchen3", [["path", { "d": "M7 4v17m-3 -17v3a3 3 0 1 0 6 0v-3", "key": "svg-0" }], ["path", { "d": "M17 8m-3 0a3 4 0 1 0 6 0a3 4 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M17 12v9", "key": "svg-2" }]]);

var IconToolsKitchen3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToolsKitchen3
});

var IconToolsKitchenOff = createReactComponent("outline", "tools-kitchen-off", "IconToolsKitchenOff", [["path", { "d": "M7 3h5l-.5 4.5m-.4 3.595l-.1 .905h-6l-.875 -7.874", "key": "svg-0" }], ["path", { "d": "M7 18h2v3h-2z", "key": "svg-1" }], ["path", { "d": "M15.225 11.216c.42 -2.518 1.589 -5.177 4.775 -8.216v12h-1", "key": "svg-2" }], ["path", { "d": "M20 15v1m0 4v1h-1v-2", "key": "svg-3" }], ["path", { "d": "M8 12v6", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconToolsKitchenOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToolsKitchenOff
});

var IconToolsKitchen = createReactComponent("outline", "tools-kitchen", "IconToolsKitchen", [["path", { "d": "M4 3h8l-1 9h-6z", "key": "svg-0" }], ["path", { "d": "M7 18h2v3h-2z", "key": "svg-1" }], ["path", { "d": "M20 3v12h-5c-.023 -3.681 .184 -7.406 5 -12z", "key": "svg-2" }], ["path", { "d": "M20 15v6h-1v-3", "key": "svg-3" }], ["path", { "d": "M8 12l0 6", "key": "svg-4" }]]);

var IconToolsKitchen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToolsKitchen
});

var IconToolsOff = createReactComponent("outline", "tools-off", "IconToolsOff", [["path", { "d": "M16 12l4 -4a2.828 2.828 0 1 0 -4 -4l-4 4m-2 2l-7 7v4h4l7 -7", "key": "svg-0" }], ["path", { "d": "M14.5 5.5l4 4", "key": "svg-1" }], ["path", { "d": "M12 8l-5 -5m-2 2l-2 2l5 5", "key": "svg-2" }], ["path", { "d": "M7 8l-1.5 1.5", "key": "svg-3" }], ["path", { "d": "M16 12l5 5m-2 2l-2 2l-5 -5", "key": "svg-4" }], ["path", { "d": "M16 17l-1.5 1.5", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconToolsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToolsOff
});

var IconTools = createReactComponent("outline", "tools", "IconTools", [["path", { "d": "M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4", "key": "svg-0" }], ["path", { "d": "M14.5 5.5l4 4", "key": "svg-1" }], ["path", { "d": "M12 8l-5 -5l-4 4l5 5", "key": "svg-2" }], ["path", { "d": "M7 8l-1.5 1.5", "key": "svg-3" }], ["path", { "d": "M16 12l5 5l-4 4l-5 -5", "key": "svg-4" }], ["path", { "d": "M16 17l-1.5 1.5", "key": "svg-5" }]]);

var IconTools$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTools
});

var IconTooltip = createReactComponent("outline", "tooltip", "IconTooltip", [["path", { "d": "M12 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 13l-1.707 -1.707a1 1 0 0 0 -.707 -.293h-2.586a2 2 0 0 1 -2 -2v-3a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2.586a1 1 0 0 0 -.707 .293l-1.707 1.707z", "key": "svg-1" }]]);

var IconTooltip$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTooltip
});

var IconTopologyBus = createReactComponent("outline", "topology-bus", "IconTopologyBus", [["path", { "d": "M14 10a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M6 10a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M22 10a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M2 16h20", "key": "svg-3" }], ["path", { "d": "M4 12v4", "key": "svg-4" }], ["path", { "d": "M12 12v4", "key": "svg-5" }], ["path", { "d": "M20 12v4", "key": "svg-6" }]]);

var IconTopologyBus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyBus
});

var IconTopologyComplex = createReactComponent("outline", "topology-complex", "IconTopologyComplex", [["path", { "d": "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-4" }], ["path", { "d": "M7.5 7.5l3 3", "key": "svg-5" }], ["path", { "d": "M6 8v8", "key": "svg-6" }], ["path", { "d": "M18 16v-8", "key": "svg-7" }], ["path", { "d": "M8 6h8", "key": "svg-8" }], ["path", { "d": "M16 18h-8", "key": "svg-9" }]]);

var IconTopologyComplex$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyComplex
});

var IconTopologyFullHierarchy = createReactComponent("outline", "topology-full-hierarchy", "IconTopologyFullHierarchy", [["path", { "d": "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-4" }], ["path", { "d": "M6 8v8", "key": "svg-5" }], ["path", { "d": "M18 16v-8", "key": "svg-6" }], ["path", { "d": "M8 6h8", "key": "svg-7" }], ["path", { "d": "M16 18h-8", "key": "svg-8" }], ["path", { "d": "M7.5 7.5l3 3", "key": "svg-9" }], ["path", { "d": "M13.5 13.5l3 3", "key": "svg-10" }], ["path", { "d": "M16.5 7.5l-3 3", "key": "svg-11" }], ["path", { "d": "M10.5 13.5l-3 3", "key": "svg-12" }]]);

var IconTopologyFullHierarchy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyFullHierarchy
});

var IconTopologyFull = createReactComponent("outline", "topology-full", "IconTopologyFull", [["path", { "d": "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M6 8v8", "key": "svg-4" }], ["path", { "d": "M18 16v-8", "key": "svg-5" }], ["path", { "d": "M8 6h8", "key": "svg-6" }], ["path", { "d": "M16 18h-8", "key": "svg-7" }], ["path", { "d": "M7.5 7.5l9 9", "key": "svg-8" }], ["path", { "d": "M7.5 16.5l9 -9", "key": "svg-9" }]]);

var IconTopologyFull$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyFull
});

var IconTopologyRing2 = createReactComponent("outline", "topology-ring-2", "IconTopologyRing2", [["path", { "d": "M14 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M7 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M21 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M7 18h10", "key": "svg-3" }], ["path", { "d": "M18 16l-5 -8", "key": "svg-4" }], ["path", { "d": "M11 8l-5 8", "key": "svg-5" }]]);

var IconTopologyRing2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyRing2
});

var IconTopologyRing3 = createReactComponent("outline", "topology-ring-3", "IconTopologyRing3", [["path", { "d": "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M6 8v8", "key": "svg-4" }], ["path", { "d": "M18 16v-8", "key": "svg-5" }], ["path", { "d": "M8 6h8", "key": "svg-6" }], ["path", { "d": "M16 18h-8", "key": "svg-7" }]]);

var IconTopologyRing3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyRing3
});

var IconTopologyRing = createReactComponent("outline", "topology-ring", "IconTopologyRing", [["path", { "d": "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M13.5 5.5l5 5", "key": "svg-4" }], ["path", { "d": "M5.5 13.5l5 5", "key": "svg-5" }], ["path", { "d": "M13.5 18.5l5 -5", "key": "svg-6" }], ["path", { "d": "M10.5 5.5l-5 5", "key": "svg-7" }]]);

var IconTopologyRing$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyRing
});

var IconTopologyStar2 = createReactComponent("outline", "topology-star-2", "IconTopologyStar2", [["path", { "d": "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-4" }], ["path", { "d": "M6 12h4", "key": "svg-5" }], ["path", { "d": "M14 12h4", "key": "svg-6" }], ["path", { "d": "M12 6v4", "key": "svg-7" }], ["path", { "d": "M12 14v4", "key": "svg-8" }]]);

var IconTopologyStar2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyStar2
});

var IconTopologyStar3 = createReactComponent("outline", "topology-star-3", "IconTopologyStar3", [["path", { "d": "M10 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M18 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M10 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M18 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-4" }], ["path", { "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-5" }], ["path", { "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-6" }], ["path", { "d": "M6 12h4", "key": "svg-7" }], ["path", { "d": "M14 12h4", "key": "svg-8" }], ["path", { "d": "M15 7l-2 3", "key": "svg-9" }], ["path", { "d": "M9 7l2 3", "key": "svg-10" }], ["path", { "d": "M11 14l-2 3", "key": "svg-11" }], ["path", { "d": "M13 14l2 3", "key": "svg-12" }]]);

var IconTopologyStar3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyStar3
});

var IconTopologyStarRing2 = createReactComponent("outline", "topology-star-ring-2", "IconTopologyStarRing2", [["path", { "d": "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-4" }], ["path", { "d": "M6 12h4", "key": "svg-5" }], ["path", { "d": "M14 12h4", "key": "svg-6" }], ["path", { "d": "M12 6v4", "key": "svg-7" }], ["path", { "d": "M12 14v4", "key": "svg-8" }], ["path", { "d": "M5.5 10.5l5 -5", "key": "svg-9" }], ["path", { "d": "M13.5 5.5l5 5", "key": "svg-10" }], ["path", { "d": "M18.5 13.5l-5 5", "key": "svg-11" }], ["path", { "d": "M10.5 18.5l-5 -5", "key": "svg-12" }]]);

var IconTopologyStarRing2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyStarRing2
});

var IconTopologyStarRing3 = createReactComponent("outline", "topology-star-ring-3", "IconTopologyStarRing3", [["path", { "d": "M10 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M18 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M10 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M18 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-4" }], ["path", { "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-5" }], ["path", { "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-6" }], ["path", { "d": "M6 12h4", "key": "svg-7" }], ["path", { "d": "M14 12h4", "key": "svg-8" }], ["path", { "d": "M15 7l-2 3", "key": "svg-9" }], ["path", { "d": "M9 7l2 3", "key": "svg-10" }], ["path", { "d": "M11 14l-2 3", "key": "svg-11" }], ["path", { "d": "M13 14l2 3", "key": "svg-12" }], ["path", { "d": "M10 5h4", "key": "svg-13" }], ["path", { "d": "M10 19h4", "key": "svg-14" }], ["path", { "d": "M17 17l2 -3", "key": "svg-15" }], ["path", { "d": "M19 10l-2 -3", "key": "svg-16" }], ["path", { "d": "M7 7l-2 3", "key": "svg-17" }], ["path", { "d": "M5 14l2 3", "key": "svg-18" }]]);

var IconTopologyStarRing3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyStarRing3
});

var IconTopologyStarRing = createReactComponent("outline", "topology-star-ring", "IconTopologyStarRing", [["path", { "d": "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-4" }], ["path", { "d": "M6 12h4", "key": "svg-5" }], ["path", { "d": "M14 12h4", "key": "svg-6" }], ["path", { "d": "M13.5 5.5l5 5", "key": "svg-7" }], ["path", { "d": "M5.5 13.5l5 5", "key": "svg-8" }], ["path", { "d": "M13.5 18.5l5 -5", "key": "svg-9" }], ["path", { "d": "M10.5 5.5l-5 5", "key": "svg-10" }], ["path", { "d": "M12 6v4", "key": "svg-11" }], ["path", { "d": "M12 14v4", "key": "svg-12" }]]);

var IconTopologyStarRing$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyStarRing
});

var IconTopologyStar = createReactComponent("outline", "topology-star", "IconTopologyStar", [["path", { "d": "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-1" }], ["path", { "d": "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-2" }], ["path", { "d": "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-3" }], ["path", { "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-4" }], ["path", { "d": "M7.5 7.5l3 3", "key": "svg-5" }], ["path", { "d": "M7.5 16.5l3 -3", "key": "svg-6" }], ["path", { "d": "M13.5 13.5l3 3", "key": "svg-7" }], ["path", { "d": "M16.5 7.5l-3 3", "key": "svg-8" }]]);

var IconTopologyStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTopologyStar
});

var IconTorii = createReactComponent("outline", "torii", "IconTorii", [["path", { "d": "M4 4c5.333 1.333 10.667 1.333 16 0", "key": "svg-0" }], ["path", { "d": "M4 8h16", "key": "svg-1" }], ["path", { "d": "M12 5v3", "key": "svg-2" }], ["path", { "d": "M18 4.5v15.5", "key": "svg-3" }], ["path", { "d": "M6 4.5v15.5", "key": "svg-4" }]]);

var IconTorii$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTorii
});

var IconTornado = createReactComponent("outline", "tornado", "IconTornado", [["path", { "d": "M21 4l-18 0", "key": "svg-0" }], ["path", { "d": "M13 16l-6 0", "key": "svg-1" }], ["path", { "d": "M11 20l4 0", "key": "svg-2" }], ["path", { "d": "M6 8l14 0", "key": "svg-3" }], ["path", { "d": "M4 12l12 0", "key": "svg-4" }]]);

var IconTornado$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTornado
});

var IconTournament = createReactComponent("outline", "tournament", "IconTournament", [["path", { "d": "M4 4m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M20 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M4 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M4 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M6 12h3a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-3", "key": "svg-4" }], ["path", { "d": "M6 4h7a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-2", "key": "svg-5" }], ["path", { "d": "M14 10h4", "key": "svg-6" }]]);

var IconTournament$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTournament
});

var IconTowerOff = createReactComponent("outline", "tower-off", "IconTowerOff", [["path", { "d": "M10 6v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2h3v-2a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v4.394a2 2 0 0 1 -.336 1.11l-1.328 1.992a2 2 0 0 0 -.336 1.11v1.394m0 4v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-7.394a2 2 0 0 0 -.336 -1.11l-1.328 -1.992a2 2 0 0 1 -.336 -1.11v-4.394", "key": "svg-0" }], ["path", { "d": "M10 21v-5a2 2 0 1 1 4 0v5", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconTowerOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTowerOff
});

var IconTower = createReactComponent("outline", "tower", "IconTower", [["path", { "d": "M5 3h1a1 1 0 0 1 1 1v2h3v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2h3v-2a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v4.394a2 2 0 0 1 -.336 1.11l-1.328 1.992a2 2 0 0 0 -.336 1.11v7.394a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-7.394a2 2 0 0 0 -.336 -1.11l-1.328 -1.992a2 2 0 0 1 -.336 -1.11v-4.394a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M10 21v-5a2 2 0 1 1 4 0v5", "key": "svg-1" }]]);

var IconTower$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTower
});

var IconTrack = createReactComponent("outline", "track", "IconTrack", [["path", { "d": "M4 15l11 -11m5 5l-11 11m-4 -8l7 7m-3.5 -10.5l7 7m-3.5 -10.5l7 7", "key": "svg-0" }]]);

var IconTrack$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrack
});

var IconTractor = createReactComponent("outline", "tractor", "IconTractor", [["path", { "d": "M7 15m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M7 15l0 .01", "key": "svg-1" }], ["path", { "d": "M19 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M10.5 17l6.5 0", "key": "svg-3" }], ["path", { "d": "M20 15.2v-4.2a1 1 0 0 0 -1 -1h-6l-2 -5h-6v6.5", "key": "svg-4" }], ["path", { "d": "M18 5h-1a1 1 0 0 0 -1 1v4", "key": "svg-5" }]]);

var IconTractor$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTractor
});

var IconTrademark = createReactComponent("outline", "trademark", "IconTrademark", [["path", { "d": "M4.5 9h5m-2.5 0v6", "key": "svg-0" }], ["path", { "d": "M13 15v-6l3 4l3 -4v6", "key": "svg-1" }]]);

var IconTrademark$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrademark
});

var IconTrafficConeOff = createReactComponent("outline", "traffic-cone-off", "IconTrafficConeOff", [["path", { "d": "M4 20h16", "key": "svg-0" }], ["path", { "d": "M9.4 10h.6m4 0h.6", "key": "svg-1" }], ["path", { "d": "M7.8 15h7.2", "key": "svg-2" }], ["path", { "d": "M6 20l3.5 -10.5", "key": "svg-3" }], ["path", { "d": "M10.5 6.5l.5 -1.5h2l2 6m2 6l1 3", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconTrafficConeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrafficConeOff
});

var IconTrafficCone = createReactComponent("outline", "traffic-cone", "IconTrafficCone", [["path", { "d": "M4 20l16 0", "key": "svg-0" }], ["path", { "d": "M9.4 10l5.2 0", "key": "svg-1" }], ["path", { "d": "M7.8 15l8.4 0", "key": "svg-2" }], ["path", { "d": "M6 20l5 -15h2l5 15", "key": "svg-3" }]]);

var IconTrafficCone$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrafficCone
});

var IconTrafficLightsOff = createReactComponent("outline", "traffic-lights-off", "IconTrafficLightsOff", [["path", { "d": "M8 4c.912 -1.219 2.36 -2 4 -2a5 5 0 0 1 5 5v6m0 4a5 5 0 0 1 -10 0v-10", "key": "svg-0" }], ["path", { "d": "M12 8a1 1 0 1 0 -1 -1", "key": "svg-1" }], ["path", { "d": "M11.291 11.295a1 1 0 0 0 1.418 1.41", "key": "svg-2" }], ["path", { "d": "M12 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconTrafficLightsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrafficLightsOff
});

var IconTrafficLights = createReactComponent("outline", "traffic-lights", "IconTrafficLights", [["path", { "d": "M7 2m0 5a5 5 0 0 1 5 -5h0a5 5 0 0 1 5 5v10a5 5 0 0 1 -5 5h0a5 5 0 0 1 -5 -5z", "key": "svg-0" }], ["path", { "d": "M12 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M12 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }]]);

var IconTrafficLights$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrafficLights
});

var IconTrain = createReactComponent("outline", "train", "IconTrain", [["path", { "d": "M21 13c0 -3.87 -3.37 -7 -10 -7h-8", "key": "svg-0" }], ["path", { "d": "M3 15h16a2 2 0 0 0 2 -2", "key": "svg-1" }], ["path", { "d": "M3 6v5h17.5", "key": "svg-2" }], ["path", { "d": "M3 11v4", "key": "svg-3" }], ["path", { "d": "M8 11v-5", "key": "svg-4" }], ["path", { "d": "M13 11v-4.5", "key": "svg-5" }], ["path", { "d": "M3 19h18", "key": "svg-6" }]]);

var IconTrain$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrain
});

var IconTransactionBitcoin = createReactComponent("outline", "transaction-bitcoin", "IconTransactionBitcoin", [["path", { "d": "M15 12h4.09c1.055 0 1.91 .895 1.91 2s-.855 2 -1.91 2c1.055 0 1.91 .895 1.91 2s-.855 2 -1.91 2h-4.09", "key": "svg-0" }], ["path", { "d": "M16 16h4", "key": "svg-1" }], ["path", { "d": "M16 11v10v-9", "key": "svg-2" }], ["path", { "d": "M19 11v1", "key": "svg-3" }], ["path", { "d": "M19 20v1", "key": "svg-4" }], ["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-5" }], ["path", { "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-6" }], ["path", { "d": "M7 5h8", "key": "svg-7" }], ["path", { "d": "M7 5v8a3 3 0 0 0 3 3h1", "key": "svg-8" }]]);

var IconTransactionBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransactionBitcoin
});

var IconTransactionDollar = createReactComponent("outline", "transaction-dollar", "IconTransactionDollar", [["path", { "d": "M20.8 13a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1", "key": "svg-0" }], ["path", { "d": "M18 11v10", "key": "svg-1" }], ["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M7 5h8", "key": "svg-4" }], ["path", { "d": "M7 5v8a3 3 0 0 0 3 3h1", "key": "svg-5" }]]);

var IconTransactionDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransactionDollar
});

var IconTransactionEuro = createReactComponent("outline", "transaction-euro", "IconTransactionEuro", [["path", { "d": "M21 12.8c-.523 -.502 -1.172 -.8 -1.875 -.8c-1.727 0 -3.125 1.791 -3.125 4s1.398 4 3.125 4c.703 0 1.352 -.298 1.874 -.8", "key": "svg-0" }], ["path", { "d": "M15 16h4", "key": "svg-1" }], ["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M7 5h8", "key": "svg-4" }], ["path", { "d": "M7 5v8a3 3 0 0 0 3 3h1", "key": "svg-5" }]]);

var IconTransactionEuro$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransactionEuro
});

var IconTransactionPound = createReactComponent("outline", "transaction-pound", "IconTransactionPound", [["path", { "d": "M21 14a2 2 0 1 0 -4 0v4a2 2 0 0 1 -2 2h6", "key": "svg-0" }], ["path", { "d": "M15 17h4", "key": "svg-1" }], ["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M7 5h8", "key": "svg-4" }], ["path", { "d": "M7 5v8a3 3 0 0 0 3 3h1", "key": "svg-5" }]]);

var IconTransactionPound$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransactionPound
});

var IconTransactionRupee = createReactComponent("outline", "transaction-rupee", "IconTransactionRupee", [["path", { "d": "M21 12h-6h1a3 3 0 0 1 0 6h-1l3 3", "key": "svg-0" }], ["path", { "d": "M15 15h6", "key": "svg-1" }], ["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M7 5h8", "key": "svg-4" }], ["path", { "d": "M7 5v8a3 3 0 0 0 3 3h1", "key": "svg-5" }]]);

var IconTransactionRupee$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransactionRupee
});

var IconTransactionYen = createReactComponent("outline", "transaction-yen", "IconTransactionYen", [["path", { "d": "M15 16h6", "key": "svg-0" }], ["path", { "d": "M15 12l3 4.5", "key": "svg-1" }], ["path", { "d": "M21 12l-3 4.5v4.5", "key": "svg-2" }], ["path", { "d": "M15 19h6", "key": "svg-3" }], ["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-5" }], ["path", { "d": "M7 5h8", "key": "svg-6" }], ["path", { "d": "M7 5v8a3 3 0 0 0 3 3h1", "key": "svg-7" }]]);

var IconTransactionYen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransactionYen
});

var IconTransactionYuan = createReactComponent("outline", "transaction-yuan", "IconTransactionYuan", [["path", { "d": "M15 17h6", "key": "svg-0" }], ["path", { "d": "M15 12l3 4.5", "key": "svg-1" }], ["path", { "d": "M21 12l-3 4.5v4.5", "key": "svg-2" }], ["path", { "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }], ["path", { "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M7 5h8", "key": "svg-5" }], ["path", { "d": "M7 5v8a3 3 0 0 0 3 3h1", "key": "svg-6" }]]);

var IconTransactionYuan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransactionYuan
});

var IconTransferIn = createReactComponent("outline", "transfer-in", "IconTransferIn", [["path", { "d": "M4 18v3h16v-14l-8 -4l-8 4v3", "key": "svg-0" }], ["path", { "d": "M4 14h9", "key": "svg-1" }], ["path", { "d": "M10 11l3 3l-3 3", "key": "svg-2" }]]);

var IconTransferIn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransferIn
});

var IconTransferOut = createReactComponent("outline", "transfer-out", "IconTransferOut", [["path", { "d": "M4 19v2h16v-14l-8 -4l-8 4v2", "key": "svg-0" }], ["path", { "d": "M13 14h-9", "key": "svg-1" }], ["path", { "d": "M7 11l-3 3l3 3", "key": "svg-2" }]]);

var IconTransferOut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransferOut
});

var IconTransferVertical = createReactComponent("outline", "transfer-vertical", "IconTransferVertical", [["path", { "d": "M10 4v16l-6 -5.5", "key": "svg-0" }], ["path", { "d": "M14 20v-16l6 5.5", "key": "svg-1" }]]);

var IconTransferVertical$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransferVertical
});

var IconTransfer = createReactComponent("outline", "transfer", "IconTransfer", [["path", { "d": "M20 10h-16l5.5 -6", "key": "svg-0" }], ["path", { "d": "M4 14h16l-5.5 6", "key": "svg-1" }]]);

var IconTransfer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransfer
});

var IconTransformPointBottomLeft = createReactComponent("outline", "transform-point-bottom-left", "IconTransformPointBottomLeft", [["path", { "d": "M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "fill": "currentColor", "key": "svg-1" }], ["path", { "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-3" }], ["path", { "d": "M11 5h2", "key": "svg-4" }], ["path", { "d": "M5 11v2", "key": "svg-5" }], ["path", { "d": "M19 11v2", "key": "svg-6" }], ["path", { "d": "M11 19h2", "key": "svg-7" }]]);

var IconTransformPointBottomLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransformPointBottomLeft
});

var IconTransformPointBottomRight = createReactComponent("outline", "transform-point-bottom-right", "IconTransformPointBottomRight", [["path", { "d": "M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "fill": "currentColor", "key": "svg-3" }], ["path", { "d": "M11 5h2", "key": "svg-4" }], ["path", { "d": "M5 11v2", "key": "svg-5" }], ["path", { "d": "M19 11v2", "key": "svg-6" }], ["path", { "d": "M11 19h2", "key": "svg-7" }]]);

var IconTransformPointBottomRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransformPointBottomRight
});

var IconTransformPointTopLeft = createReactComponent("outline", "transform-point-top-left", "IconTransformPointTopLeft", [["path", { "d": "M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "fill": "currentColor", "key": "svg-0" }], ["path", { "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-3" }], ["path", { "d": "M11 5h2", "key": "svg-4" }], ["path", { "d": "M5 11v2", "key": "svg-5" }], ["path", { "d": "M19 11v2", "key": "svg-6" }], ["path", { "d": "M11 19h2", "key": "svg-7" }]]);

var IconTransformPointTopLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransformPointTopLeft
});

var IconTransformPointTopRight = createReactComponent("outline", "transform-point-top-right", "IconTransformPointTopRight", [["path", { "d": "M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "fill": "currentColor", "key": "svg-2" }], ["path", { "d": "M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-3" }], ["path", { "d": "M11 5h2", "key": "svg-4" }], ["path", { "d": "M5 11v2", "key": "svg-5" }], ["path", { "d": "M19 11v2", "key": "svg-6" }], ["path", { "d": "M11 19h2", "key": "svg-7" }]]);

var IconTransformPointTopRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransformPointTopRight
});

var IconTransformPoint = createReactComponent("outline", "transform-point", "IconTransformPoint", [["path", { "d": "M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-3" }], ["path", { "d": "M11 5h2", "key": "svg-4" }], ["path", { "d": "M5 11v2", "key": "svg-5" }], ["path", { "d": "M19 11v2", "key": "svg-6" }], ["path", { "d": "M11 19h2", "key": "svg-7" }]]);

var IconTransformPoint$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransformPoint
});

var IconTransform = createReactComponent("outline", "transform", "IconTransform", [["path", { "d": "M3 6a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3", "key": "svg-1" }], ["path", { "d": "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3", "key": "svg-2" }], ["path", { "d": "M15 18a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-3" }]]);

var IconTransform$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransform
});

var IconTransitionBottom = createReactComponent("outline", "transition-bottom", "IconTransitionBottom", [["path", { "d": "M21 18a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3", "key": "svg-0" }], ["path", { "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v0a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-1" }], ["path", { "d": "M12 9v8", "key": "svg-2" }], ["path", { "d": "M9 14l3 3l3 -3", "key": "svg-3" }]]);

var IconTransitionBottom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransitionBottom
});

var IconTransitionLeft = createReactComponent("outline", "transition-left", "IconTransitionLeft", [["path", { "d": "M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3", "key": "svg-0" }], ["path", { "d": "M21 6v12a3 3 0 0 1 -6 0v-12a3 3 0 0 1 6 0z", "key": "svg-1" }], ["path", { "d": "M15 12h-8", "key": "svg-2" }], ["path", { "d": "M10 9l-3 3l3 3", "key": "svg-3" }]]);

var IconTransitionLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransitionLeft
});

var IconTransitionRight = createReactComponent("outline", "transition-right", "IconTransitionRight", [["path", { "d": "M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3", "key": "svg-0" }], ["path", { "d": "M3 18v-12a3 3 0 1 1 6 0v12a3 3 0 0 1 -6 0z", "key": "svg-1" }], ["path", { "d": "M9 12h8", "key": "svg-2" }], ["path", { "d": "M14 15l3 -3l-3 -3", "key": "svg-3" }]]);

var IconTransitionRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransitionRight
});

var IconTransitionTop = createReactComponent("outline", "transition-top", "IconTransitionTop", [["path", { "d": "M21 6a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3", "key": "svg-0" }], ["path", { "d": "M6 21h12a3 3 0 0 0 0 -6h-12a3 3 0 0 0 0 6z", "key": "svg-1" }], ["path", { "d": "M12 15v-8", "key": "svg-2" }], ["path", { "d": "M9 10l3 -3l3 3", "key": "svg-3" }]]);

var IconTransitionTop$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransitionTop
});

var IconTrashOff = createReactComponent("outline", "trash-off", "IconTrashOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M4 7h3m4 0h9", "key": "svg-1" }], ["path", { "d": "M10 11l0 6", "key": "svg-2" }], ["path", { "d": "M14 14l0 3", "key": "svg-3" }], ["path", { "d": "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l.077 -.923", "key": "svg-4" }], ["path", { "d": "M18.384 14.373l.616 -7.373", "key": "svg-5" }], ["path", { "d": "M9 5v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3", "key": "svg-6" }]]);

var IconTrashOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrashOff
});

var IconTrashX = createReactComponent("outline", "trash-x", "IconTrashX", [["path", { "d": "M4 7h16", "key": "svg-0" }], ["path", { "d": "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12", "key": "svg-1" }], ["path", { "d": "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3", "key": "svg-2" }], ["path", { "d": "M10 12l4 4m0 -4l-4 4", "key": "svg-3" }]]);

var IconTrashX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrashX
});

var IconTrash = createReactComponent("outline", "trash", "IconTrash", [["path", { "d": "M4 7l16 0", "key": "svg-0" }], ["path", { "d": "M10 11l0 6", "key": "svg-1" }], ["path", { "d": "M14 11l0 6", "key": "svg-2" }], ["path", { "d": "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12", "key": "svg-3" }], ["path", { "d": "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3", "key": "svg-4" }]]);

var IconTrash$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrash
});

var IconTreadmill = createReactComponent("outline", "treadmill", "IconTreadmill", [["path", { "d": "M10 3a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M3 14l4 1l.5 -.5", "key": "svg-1" }], ["path", { "d": "M12 18v-3l-3 -2.923l.75 -5.077", "key": "svg-2" }], ["path", { "d": "M6 10v-2l4 -1l2.5 2.5l2.5 .5", "key": "svg-3" }], ["path", { "d": "M21 22a1 1 0 0 0 -1 -1h-16a1 1 0 0 0 -1 1", "key": "svg-4" }], ["path", { "d": "M18 21l1 -11l2 -1", "key": "svg-5" }]]);

var IconTreadmill$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTreadmill
});

var IconTree = createReactComponent("outline", "tree", "IconTree", [["path", { "d": "M12 13l-2 -2", "key": "svg-0" }], ["path", { "d": "M12 12l2 -2", "key": "svg-1" }], ["path", { "d": "M12 21v-13", "key": "svg-2" }], ["path", { "d": "M9.824 16a3 3 0 0 1 -2.743 -3.69a3 3 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a3 3 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4z", "key": "svg-3" }]]);

var IconTree$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTree
});

var IconTrees = createReactComponent("outline", "trees", "IconTrees", [["path", { "d": "M16 5l3 3l-2 1l4 4l-3 1l4 4h-9", "key": "svg-0" }], ["path", { "d": "M15 21l0 -3", "key": "svg-1" }], ["path", { "d": "M8 13l-2 -2", "key": "svg-2" }], ["path", { "d": "M8 12l2 -2", "key": "svg-3" }], ["path", { "d": "M8 21v-13", "key": "svg-4" }], ["path", { "d": "M5.824 16a3 3 0 0 1 -2.743 -3.69a3 3 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a3 3 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4z", "key": "svg-5" }]]);

var IconTrees$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrees
});

var IconTrekking = createReactComponent("outline", "trekking", "IconTrekking", [["path", { "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M7 21l2 -4", "key": "svg-1" }], ["path", { "d": "M13 21v-4l-3 -3l1 -6l3 4l3 2", "key": "svg-2" }], ["path", { "d": "M10 14l-1.827 -1.218a2 2 0 0 1 -.831 -2.15l.28 -1.117a2 2 0 0 1 1.939 -1.515h1.439l4 1l3 -2", "key": "svg-3" }], ["path", { "d": "M17 12v9", "key": "svg-4" }], ["path", { "d": "M16 20h2", "key": "svg-5" }]]);

var IconTrekking$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrekking
});

var IconTrendingDown2 = createReactComponent("outline", "trending-down-2", "IconTrendingDown2", [["path", { "d": "M3 6h5l7 10h6", "key": "svg-0" }], ["path", { "d": "M18 19l3 -3l-3 -3", "key": "svg-1" }]]);

var IconTrendingDown2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrendingDown2
});

var IconTrendingDown3 = createReactComponent("outline", "trending-down-3", "IconTrendingDown3", [["path", { "d": "M3 6h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397", "key": "svg-0" }], ["path", { "d": "M18 19l3 -3l-3 -3", "key": "svg-1" }]]);

var IconTrendingDown3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrendingDown3
});

var IconTrendingDown = createReactComponent("outline", "trending-down", "IconTrendingDown", [["path", { "d": "M3 7l6 6l4 -4l8 8", "key": "svg-0" }], ["path", { "d": "M21 10l0 7l-7 0", "key": "svg-1" }]]);

var IconTrendingDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrendingDown
});

var IconTrendingUp2 = createReactComponent("outline", "trending-up-2", "IconTrendingUp2", [["path", { "d": "M18 5l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M3 18h5l7 -10h6", "key": "svg-1" }]]);

var IconTrendingUp2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrendingUp2
});

var IconTrendingUp3 = createReactComponent("outline", "trending-up-3", "IconTrendingUp3", [["path", { "d": "M18 5l3 3l-3 3", "key": "svg-0" }], ["path", { "d": "M3 18h2.397a5 5 0 0 0 4.096 -2.133l4.014 -5.734a5 5 0 0 1 4.096 -2.133h3.397", "key": "svg-1" }]]);

var IconTrendingUp3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrendingUp3
});

var IconTrendingUp = createReactComponent("outline", "trending-up", "IconTrendingUp", [["path", { "d": "M3 17l6 -6l4 4l8 -8", "key": "svg-0" }], ["path", { "d": "M14 7l7 0l0 7", "key": "svg-1" }]]);

var IconTrendingUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrendingUp
});

var IconTriangleInverted = createReactComponent("outline", "triangle-inverted", "IconTriangleInverted", [["path", { "d": "M10.363 20.405l-8.106 -13.534a1.914 1.914 0 0 1 1.636 -2.871h16.214a1.914 1.914 0 0 1 1.636 2.871l-8.106 13.534a1.914 1.914 0 0 1 -3.274 0z", "key": "svg-0" }]]);

var IconTriangleInverted$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTriangleInverted
});

var IconTriangleMinus2 = createReactComponent("outline", "triangle-minus-2", "IconTriangleMinus2", [["path", { "d": "M20.48 15.016l-6.843 -11.426a1.914 1.914 0 0 0 -3.274 0l-8.106 13.535a1.914 1.914 0 0 0 1.636 2.871h8.107", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

var IconTriangleMinus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTriangleMinus2
});

var IconTriangleMinus = createReactComponent("outline", "triangle-minus", "IconTriangleMinus", [["path", { "d": "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0v.001z", "key": "svg-0" }], ["path", { "d": "M9 13h6", "key": "svg-1" }]]);

var IconTriangleMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTriangleMinus
});

var IconTriangleOff = createReactComponent("outline", "triangle-off", "IconTriangleOff", [["path", { "d": "M7.825 7.83l-5.568 9.295a1.914 1.914 0 0 0 1.636 2.871h16.107m1.998 -1.99a1.913 1.913 0 0 0 -.255 -.88l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0l-1.028 1.718", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconTriangleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTriangleOff
});

var IconTrianglePlus2 = createReactComponent("outline", "triangle-plus-2", "IconTrianglePlus2", [["path", { "d": "M18.69 12.027l-5.054 -8.437a1.914 1.914 0 0 0 -3.274 0l-8.105 13.535a1.914 1.914 0 0 0 1.636 2.871h8.107", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }]]);

var IconTrianglePlus2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrianglePlus2
});

var IconTrianglePlus = createReactComponent("outline", "triangle-plus", "IconTrianglePlus", [["path", { "d": "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0v.001z", "key": "svg-0" }], ["path", { "d": "M9 13h6", "key": "svg-1" }], ["path", { "d": "M12 10v6", "key": "svg-2" }]]);

var IconTrianglePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrianglePlus
});

var IconTriangleSquareCircle = createReactComponent("outline", "triangle-square-circle", "IconTriangleSquareCircle", [["path", { "d": "M12 3l-4 7h8z", "key": "svg-0" }], ["path", { "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-2" }]]);

var IconTriangleSquareCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTriangleSquareCircle
});

var IconTriangle = createReactComponent("outline", "triangle", "IconTriangle", [["path", { "d": "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z", "key": "svg-0" }]]);

var IconTriangle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTriangle
});

var IconTriangles = createReactComponent("outline", "triangles", "IconTriangles", [["path", { "d": "M9.974 21h8.052a.975 .975 0 0 0 .81 -1.517l-4.025 -6.048a.973 .973 0 0 0 -1.622 0l-4.025 6.048a.977 .977 0 0 0 .81 1.517z", "key": "svg-0" }], ["path", { "d": "M4.98 16h14.04c.542 0 .98 -.443 .98 -.989a1 1 0 0 0 -.156 -.534l-7.02 -11.023a.974 .974 0 0 0 -1.648 0l-7.02 11.023a1 1 0 0 0 .294 1.366a.973 .973 0 0 0 .53 .157z", "key": "svg-1" }]]);

var IconTriangles$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTriangles
});

var IconTrident = createReactComponent("outline", "trident", "IconTrident", [["path", { "d": "M3 6l2 -2v3a7 7 0 0 0 14 0v-3l2 2", "key": "svg-0" }], ["path", { "d": "M12 21v-18l-2 2m4 0l-2 -2", "key": "svg-1" }]]);

var IconTrident$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrident
});

var IconTrolley = createReactComponent("outline", "trolley", "IconTrolley", [["path", { "d": "M11 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M6 16l3 2", "key": "svg-1" }], ["path", { "d": "M12 17l8 -12", "key": "svg-2" }], ["path", { "d": "M17 10l2 1", "key": "svg-3" }], ["path", { "d": "M9.592 4.695l3.306 2.104a1.3 1.3 0 0 1 .396 1.8l-3.094 4.811a1.3 1.3 0 0 1 -1.792 .394l-3.306 -2.104a1.3 1.3 0 0 1 -.396 -1.8l3.094 -4.81a1.3 1.3 0 0 1 1.792 -.394z", "key": "svg-4" }]]);

var IconTrolley$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrolley
});

var IconTrophyOff = createReactComponent("outline", "trophy-off", "IconTrophyOff", [["path", { "d": "M8 21h8", "key": "svg-0" }], ["path", { "d": "M12 17v4", "key": "svg-1" }], ["path", { "d": "M8 4h9", "key": "svg-2" }], ["path", { "d": "M17 4v8c0 .31 -.028 .612 -.082 .905m-1.384 2.632a5 5 0 0 1 -8.534 -3.537v-5", "key": "svg-3" }], ["path", { "d": "M5 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M19 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconTrophyOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrophyOff
});

var IconTrophy = createReactComponent("outline", "trophy", "IconTrophy", [["path", { "d": "M8 21l8 0", "key": "svg-0" }], ["path", { "d": "M12 17l0 4", "key": "svg-1" }], ["path", { "d": "M7 4l10 0", "key": "svg-2" }], ["path", { "d": "M17 4v8a5 5 0 0 1 -10 0v-8", "key": "svg-3" }], ["path", { "d": "M5 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-4" }], ["path", { "d": "M19 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-5" }]]);

var IconTrophy$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrophy
});

var IconTrowel = createReactComponent("outline", "trowel", "IconTrowel", [["path", { "d": "M14.42 9.058l-5.362 5.363a1.978 1.978 0 0 1 -3.275 -.773l-2.682 -8.044a1.978 1.978 0 0 1 2.502 -2.502l8.045 2.682a1.978 1.978 0 0 1 .773 3.274z", "key": "svg-0" }], ["path", { "d": "M10 10l6.5 6.5", "key": "svg-1" }], ["path", { "d": "M19.347 16.575l1.08 1.079a1.96 1.96 0 0 1 -2.773 2.772l-1.08 -1.079a1.96 1.96 0 0 1 2.773 -2.772z", "key": "svg-2" }]]);

var IconTrowel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrowel
});

var IconTruckDelivery = createReactComponent("outline", "truck-delivery", "IconTruckDelivery", [["path", { "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5", "key": "svg-2" }], ["path", { "d": "M3 9l4 0", "key": "svg-3" }]]);

var IconTruckDelivery$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTruckDelivery
});

var IconTruckLoading = createReactComponent("outline", "truck-loading", "IconTruckLoading", [["path", { "d": "M2 3h1a2 2 0 0 1 2 2v10a2 2 0 0 0 2 2h15", "key": "svg-0" }], ["path", { "d": "M9 6m0 3a3 3 0 0 1 3 -3h4a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-4a3 3 0 0 1 -3 -3z", "key": "svg-1" }], ["path", { "d": "M9 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M18 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-3" }]]);

var IconTruckLoading$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTruckLoading
});

var IconTruckOff = createReactComponent("outline", "truck-off", "IconTruckOff", [["path", { "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M15.585 15.586a2 2 0 0 0 2.826 2.831", "key": "svg-1" }], ["path", { "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h1m3.96 0h4.04v4m0 4v4m-4 0h6m6 0v-6h-6m-2 -5h5l3 5", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconTruckOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTruckOff
});

var IconTruckReturn = createReactComponent("outline", "truck-return", "IconTruckReturn", [["path", { "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h9v6h-5l2 2m0 -4l-2 2", "key": "svg-2" }], ["path", { "d": "M9 17l6 0", "key": "svg-3" }], ["path", { "d": "M13 6h5l3 5v6h-2", "key": "svg-4" }]]);

var IconTruckReturn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTruckReturn
});

var IconTruck = createReactComponent("outline", "truck", "IconTruck", [["path", { "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5", "key": "svg-2" }]]);

var IconTruck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTruck
});

var IconTxt = createReactComponent("outline", "txt", "IconTxt", [["path", { "d": "M3 8h4", "key": "svg-0" }], ["path", { "d": "M5 8v8", "key": "svg-1" }], ["path", { "d": "M17 8h4", "key": "svg-2" }], ["path", { "d": "M19 8v8", "key": "svg-3" }], ["path", { "d": "M10 8l4 8", "key": "svg-4" }], ["path", { "d": "M10 16l4 -8", "key": "svg-5" }]]);

var IconTxt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTxt
});

var IconTypeface = createReactComponent("outline", "typeface", "IconTypeface", [["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M17 17a2 2 0 0 1 -2 -2v-8h-5a2 2 0 0 0 -2 2", "key": "svg-1" }], ["path", { "d": "M7 17a2.775 2.775 0 0 0 2.632 -1.897l.368 -1.103a13.4 13.4 0 0 1 3.236 -5.236l1.764 -1.764", "key": "svg-2" }], ["path", { "d": "M10 14h5", "key": "svg-3" }]]);

var IconTypeface$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTypeface
});

var IconTypographyOff = createReactComponent("outline", "typography-off", "IconTypographyOff", [["path", { "d": "M4 20h3", "key": "svg-0" }], ["path", { "d": "M14 20h6", "key": "svg-1" }], ["path", { "d": "M6.9 15h6.9", "key": "svg-2" }], ["path", { "d": "M13 13l3 7", "key": "svg-3" }], ["path", { "d": "M5 20l4.09 -10.906", "key": "svg-4" }], ["path", { "d": "M10.181 6.183l.819 -2.183h2l3.904 8.924", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconTypographyOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTypographyOff
});

var IconTypography = createReactComponent("outline", "typography", "IconTypography", [["path", { "d": "M4 20l3 0", "key": "svg-0" }], ["path", { "d": "M14 20l7 0", "key": "svg-1" }], ["path", { "d": "M6.9 15l6.9 0", "key": "svg-2" }], ["path", { "d": "M10.2 6.3l5.8 13.7", "key": "svg-3" }], ["path", { "d": "M5 20l6 -16l2 0l7 16", "key": "svg-4" }]]);

var IconTypography$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTypography
});

var IconUTurnLeft = createReactComponent("outline", "u-turn-left", "IconUTurnLeft", [["path", { "d": "M17 20v-11.5a4.5 4.5 0 1 0 -9 0v8.5", "key": "svg-0" }], ["path", { "d": "M11 14l-3 3l-3 -3", "key": "svg-1" }]]);

var IconUTurnLeft$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUTurnLeft
});

var IconUTurnRight = createReactComponent("outline", "u-turn-right", "IconUTurnRight", [["path", { "d": "M7 20v-11.5a4.5 4.5 0 0 1 9 0v8.5", "key": "svg-0" }], ["path", { "d": "M13 14l3 3l3 -3", "key": "svg-1" }]]);

var IconUTurnRight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUTurnRight
});

var IconUfoOff = createReactComponent("outline", "ufo-off", "IconUfoOff", [["path", { "d": "M16.95 9.01c3.02 .739 5.05 2.123 5.05 3.714c0 1.08 -.931 2.063 -2.468 2.814m-3 1c-1.36 .295 -2.9 .462 -4.531 .462c-5.52 0 -10 -1.909 -10 -4.276c0 -1.59 2.04 -2.985 5.07 -3.724", "key": "svg-0" }], ["path", { "d": "M14.69 10.686c1.388 -.355 2.31 -.976 2.31 -1.686v-.035c0 -2.742 -2.239 -4.965 -5 -4.965c-1.125 0 -2.164 .37 -3 .992m-1.707 2.297a4.925 4.925 0 0 0 -.293 1.676v.035c0 .961 1.696 1.764 3.956 1.956", "key": "svg-1" }], ["path", { "d": "M15 17l2 3", "key": "svg-2" }], ["path", { "d": "M8.5 17l-1.5 3", "key": "svg-3" }], ["path", { "d": "M12 14h.01", "key": "svg-4" }], ["path", { "d": "M7 13h.01", "key": "svg-5" }], ["path", { "d": "M17 13h.01", "key": "svg-6" }], ["path", { "d": "M3 3l18 18", "key": "svg-7" }]]);

var IconUfoOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUfoOff
});

var IconUfo = createReactComponent("outline", "ufo", "IconUfo", [["path", { "d": "M16.95 9.01c3.02 .739 5.05 2.123 5.05 3.714c0 2.367 -4.48 4.276 -10 4.276s-10 -1.909 -10 -4.276c0 -1.59 2.04 -2.985 5.07 -3.724", "key": "svg-0" }], ["path", { "d": "M7 9c0 1.105 2.239 2 5 2s5 -.895 5 -2v-.035c0 -2.742 -2.239 -4.965 -5 -4.965s-5 2.223 -5 4.965v.035", "key": "svg-1" }], ["path", { "d": "M15 17l2 3", "key": "svg-2" }], ["path", { "d": "M8.5 17l-1.5 3", "key": "svg-3" }], ["path", { "d": "M12 14h.01", "key": "svg-4" }], ["path", { "d": "M7 13h.01", "key": "svg-5" }], ["path", { "d": "M17 13h.01", "key": "svg-6" }]]);

var IconUfo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUfo
});

var IconUhd = createReactComponent("outline", "uhd", "IconUhd", [["path", { "d": "M10 16v-8", "key": "svg-0" }], ["path", { "d": "M10 12h4", "key": "svg-1" }], ["path", { "d": "M14 8v8", "key": "svg-2" }], ["path", { "d": "M17 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z", "key": "svg-3" }], ["path", { "d": "M3 8v6a2 2 0 1 0 4 0v-6", "key": "svg-4" }]]);

var IconUhd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUhd
});

var IconUmbrella2 = createReactComponent("outline", "umbrella-2", "IconUmbrella2", [["path", { "d": "M5.343 7.343a8 8 0 1 1 11.314 11.314z", "key": "svg-0" }], ["path", { "d": "M10.828 13.34l-4.242 4.243a2 2 0 1 0 2.828 2.828", "key": "svg-1" }]]);

var IconUmbrella2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUmbrella2
});

var IconUmbrellaClosed2 = createReactComponent("outline", "umbrella-closed-2", "IconUmbrellaClosed2", [["path", { "d": "M6.697 12.071l11.313 -7.071l-7.07 11.314z", "key": "svg-0" }], ["path", { "d": "M8.743 14.475l-2.121 2.121c-1.886 1.886 .943 4.715 2.828 2.829", "key": "svg-1" }]]);

var IconUmbrellaClosed2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUmbrellaClosed2
});

var IconUmbrellaClosed = createReactComponent("outline", "umbrella-closed", "IconUmbrellaClosed", [["path", { "d": "M9 16l3 -13l3 13z", "key": "svg-0" }], ["path", { "d": "M12 16v3c0 2.667 4 2.667 4 0", "key": "svg-1" }]]);

var IconUmbrellaClosed$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUmbrellaClosed
});

var IconUmbrellaOff = createReactComponent("outline", "umbrella-off", "IconUmbrellaOff", [["path", { "d": "M12 12h-8c0 -2.209 .895 -4.208 2.342 -5.656m2.382 -1.645a8 8 0 0 1 11.276 7.301l-4 0", "key": "svg-0" }], ["path", { "d": "M12 12v6a2 2 0 1 0 4 0", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconUmbrellaOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUmbrellaOff
});

var IconUmbrella = createReactComponent("outline", "umbrella", "IconUmbrella", [["path", { "d": "M4 12a8 8 0 0 1 16 0z", "key": "svg-0" }], ["path", { "d": "M12 12v6a2 2 0 0 0 4 0", "key": "svg-1" }]]);

var IconUmbrella$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUmbrella
});

var IconUnderline = createReactComponent("outline", "underline", "IconUnderline", [["path", { "d": "M7 5v5a5 5 0 0 0 10 0v-5", "key": "svg-0" }], ["path", { "d": "M5 19h14", "key": "svg-1" }]]);

var IconUnderline$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUnderline
});

var IconUniverse = createReactComponent("outline", "universe", "IconUniverse", [["path", { "d": "M7.027 11.477a5 5 0 1 0 5.496 -4.45a4.951 4.951 0 0 0 -3.088 .681", "key": "svg-0" }], ["path", { "d": "M5.636 5.636a9 9 0 1 0 3.555 -2.188", "key": "svg-1" }], ["path", { "d": "M18 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-3" }], ["path", { "d": "M9 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }]]);

var IconUniverse$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUniverse
});

var IconUnlink = createReactComponent("outline", "unlink", "IconUnlink", [["path", { "d": "M17 22v-2", "key": "svg-0" }], ["path", { "d": "M9 15l6 -6", "key": "svg-1" }], ["path", { "d": "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464", "key": "svg-2" }], ["path", { "d": "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463", "key": "svg-3" }], ["path", { "d": "M20 17h2", "key": "svg-4" }], ["path", { "d": "M2 7h2", "key": "svg-5" }], ["path", { "d": "M7 2v2", "key": "svg-6" }]]);

var IconUnlink$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUnlink
});

var IconUpload = createReactComponent("outline", "upload", "IconUpload", [["path", { "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2", "key": "svg-0" }], ["path", { "d": "M7 9l5 -5l5 5", "key": "svg-1" }], ["path", { "d": "M12 4l0 12", "key": "svg-2" }]]);

var IconUpload$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUpload
});

var IconUrgent = createReactComponent("outline", "urgent", "IconUrgent", [["path", { "d": "M8 16v-4a4 4 0 0 1 8 0v4", "key": "svg-0" }], ["path", { "d": "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7", "key": "svg-1" }], ["path", { "d": "M6 16m0 1a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z", "key": "svg-2" }]]);

var IconUrgent$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUrgent
});

var IconUsb = createReactComponent("outline", "usb", "IconUsb", [["path", { "d": "M12 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 17v-11.5", "key": "svg-1" }], ["path", { "d": "M7 10v3l5 3", "key": "svg-2" }], ["path", { "d": "M12 14.5l5 -2v-2.5", "key": "svg-3" }], ["path", { "d": "M16 10h2v-2h-2z", "key": "svg-4" }], ["path", { "d": "M7 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-5" }], ["path", { "d": "M10 5.5h4l-2 -2.5z", "key": "svg-6" }]]);

var IconUsb$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUsb
});

var IconUserBitcoin = createReactComponent("outline", "user-bitcoin", "IconUserBitcoin", [["path", { "d": "M17 21v-6m2 0v-1.5m0 9v-1.5m-2 -3h3m-1 0h.5a1.5 1.5 0 0 1 0 3h-3.5m3 -3h.5a1.5 1.5 0 0 0 0 -3h-3.5", "key": "svg-0" }], ["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-1" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h3", "key": "svg-2" }]]);

var IconUserBitcoin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserBitcoin
});

var IconUserBolt = createReactComponent("outline", "user-bolt", "IconUserBolt", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h4c.267 0 .529 .026 .781 .076", "key": "svg-1" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-2" }]]);

var IconUserBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserBolt
});

var IconUserCancel = createReactComponent("outline", "user-cancel", "IconUserCancel", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5", "key": "svg-1" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M17 21l4 -4", "key": "svg-3" }]]);

var IconUserCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserCancel
});

var IconUserCheck = createReactComponent("outline", "user-check", "IconUserCheck", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h4", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

var IconUserCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserCheck
});

var IconUserCircle = createReactComponent("outline", "user-circle", "IconUserCircle", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855", "key": "svg-2" }]]);

var IconUserCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserCircle
});

var IconUserCode = createReactComponent("outline", "user-code", "IconUserCode", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

var IconUserCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserCode
});

var IconUserCog = createReactComponent("outline", "user-cog", "IconUserCog", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h2.5", "key": "svg-1" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-3" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-4" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-5" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-6" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-7" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-8" }]]);

var IconUserCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserCog
});

var IconUserDollar = createReactComponent("outline", "user-dollar", "IconUserDollar", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h3", "key": "svg-1" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-3" }]]);

var IconUserDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserDollar
});

var IconUserDown = createReactComponent("outline", "user-down", "IconUserDown", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h4c.342 0 .674 .043 .99 .124", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-3" }]]);

var IconUserDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserDown
});

var IconUserEdit = createReactComponent("outline", "user-edit", "IconUserEdit", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5", "key": "svg-1" }], ["path", { "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z", "key": "svg-2" }]]);

var IconUserEdit$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserEdit
});

var IconUserExclamation = createReactComponent("outline", "user-exclamation", "IconUserExclamation", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h4c.348 0 .686 .045 1.008 .128", "key": "svg-1" }], ["path", { "d": "M19 16v3", "key": "svg-2" }], ["path", { "d": "M19 22v.01", "key": "svg-3" }]]);

var IconUserExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserExclamation
});

var IconUserHeart = createReactComponent("outline", "user-heart", "IconUserHeart", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h.5", "key": "svg-1" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-2" }]]);

var IconUserHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserHeart
});

var IconUserHexagon = createReactComponent("outline", "user-hexagon", "IconUserHexagon", [["path", { "d": "M12 13a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z", "key": "svg-0" }], ["path", { "d": "M6.201 18.744a4 4 0 0 1 3.799 -2.744h4a4 4 0 0 1 3.798 2.741", "key": "svg-1" }], ["path", { "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z", "key": "svg-2" }]]);

var IconUserHexagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserHexagon
});

var IconUserMinus = createReactComponent("outline", "user-minus", "IconUserMinus", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h4c.348 0 .686 .045 1.009 .128", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

var IconUserMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserMinus
});

var IconUserOff = createReactComponent("outline", "user-off", "IconUserOff", [["path", { "d": "M8.18 8.189a4.01 4.01 0 0 0 2.616 2.627m3.507 -.545a4 4 0 1 0 -5.59 -5.552", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h4c.412 0 .81 .062 1.183 .178m2.633 2.618c.12 .38 .184 .785 .184 1.204v2", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconUserOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserOff
});

var IconUserPause = createReactComponent("outline", "user-pause", "IconUserPause", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5", "key": "svg-1" }], ["path", { "d": "M17 17v5", "key": "svg-2" }], ["path", { "d": "M21 17v5", "key": "svg-3" }]]);

var IconUserPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserPause
});

var IconUserPentagon = createReactComponent("outline", "user-pentagon", "IconUserPentagon", [["path", { "d": "M13.163 2.168l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-3.064 9.43a1.978 1.978 0 0 1 -1.881 1.367h-9.916a1.978 1.978 0 0 1 -1.881 -1.367l-3.064 -9.43a1.978 1.978 0 0 1 .719 -2.212l8.021 -5.828a1.978 1.978 0 0 1 2.326 0z", "key": "svg-0" }], ["path", { "d": "M12 13a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z", "key": "svg-1" }], ["path", { "d": "M6 20.703v-.703a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v.707", "key": "svg-2" }]]);

var IconUserPentagon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserPentagon
});

var IconUserPin = createReactComponent("outline", "user-pin", "IconUserPin", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h2.5", "key": "svg-1" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-2" }], ["path", { "d": "M19 18v.01", "key": "svg-3" }]]);

var IconUserPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserPin
});

var IconUserPlus = createReactComponent("outline", "user-plus", "IconUserPlus", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }], ["path", { "d": "M19 16v6", "key": "svg-2" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h4", "key": "svg-3" }]]);

var IconUserPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserPlus
});

var IconUserQuestion = createReactComponent("outline", "user-question", "IconUserQuestion", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-3" }]]);

var IconUserQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserQuestion
});

var IconUserScan = createReactComponent("outline", "user-scan", "IconUserScan", [["path", { "d": "M10 9a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-2" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-3" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-4" }], ["path", { "d": "M8 16a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2", "key": "svg-5" }]]);

var IconUserScan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserScan
});

var IconUserScreen = createReactComponent("outline", "user-screen", "IconUserScreen", [["path", { "d": "M19.03 17.818a3 3 0 0 0 1.97 -2.818v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3v8c0 1.317 .85 2.436 2.03 2.84", "key": "svg-0" }], ["path", { "d": "M10 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-1" }], ["path", { "d": "M8 21a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2", "key": "svg-2" }]]);

var IconUserScreen$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserScreen
});

var IconUserSearch = createReactComponent("outline", "user-search", "IconUserSearch", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h1.5", "key": "svg-1" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-3" }]]);

var IconUserSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserSearch
});

var IconUserShare = createReactComponent("outline", "user-share", "IconUserShare", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h3", "key": "svg-1" }], ["path", { "d": "M16 22l5 -5", "key": "svg-2" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-3" }]]);

var IconUserShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserShare
});

var IconUserShield = createReactComponent("outline", "user-shield", "IconUserShield", [["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h2", "key": "svg-0" }], ["path", { "d": "M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5z", "key": "svg-1" }], ["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-2" }]]);

var IconUserShield$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserShield
});

var IconUserSquareRounded = createReactComponent("outline", "user-square-rounded", "IconUserSquareRounded", [["path", { "d": "M12 13a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z", "key": "svg-0" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-1" }], ["path", { "d": "M6 20.05v-.05a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v.05", "key": "svg-2" }]]);

var IconUserSquareRounded$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserSquareRounded
});

var IconUserSquare = createReactComponent("outline", "user-square", "IconUserSquare", [["path", { "d": "M9 10a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M6 21v-1a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v1", "key": "svg-1" }], ["path", { "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z", "key": "svg-2" }]]);

var IconUserSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserSquare
});

var IconUserStar = createReactComponent("outline", "user-star", "IconUserStar", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h.5", "key": "svg-1" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-2" }]]);

var IconUserStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserStar
});

var IconUserUp = createReactComponent("outline", "user-up", "IconUserUp", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h4", "key": "svg-1" }], ["path", { "d": "M19 22v-6", "key": "svg-2" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-3" }]]);

var IconUserUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserUp
});

var IconUserX = createReactComponent("outline", "user-x", "IconUserX", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5", "key": "svg-1" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-2" }], ["path", { "d": "M17 22l5 -5", "key": "svg-3" }]]);

var IconUserX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserX
});

var IconUser = createReactComponent("outline", "user", "IconUser", [["path", { "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2", "key": "svg-1" }]]);

var IconUser$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUser
});

var IconUsersGroup = createReactComponent("outline", "users-group", "IconUsersGroup", [["path", { "d": "M10 13a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M8 21v-1a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v1", "key": "svg-1" }], ["path", { "d": "M15 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-2" }], ["path", { "d": "M17 10h2a2 2 0 0 1 2 2v1", "key": "svg-3" }], ["path", { "d": "M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-4" }], ["path", { "d": "M3 13v-1a2 2 0 0 1 2 -2h2", "key": "svg-5" }]]);

var IconUsersGroup$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUsersGroup
});

var IconUsersMinus = createReactComponent("outline", "users-minus", "IconUsersMinus", [["path", { "d": "M5 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M3 21v-2a4 4 0 0 1 4 -4h4c.948 0 1.818 .33 2.504 .88", "key": "svg-1" }], ["path", { "d": "M16 3.13a4 4 0 0 1 0 7.75", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconUsersMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUsersMinus
});

var IconUsersPlus = createReactComponent("outline", "users-plus", "IconUsersPlus", [["path", { "d": "M5 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", "key": "svg-0" }], ["path", { "d": "M3 21v-2a4 4 0 0 1 4 -4h4c.96 0 1.84 .338 2.53 .901", "key": "svg-1" }], ["path", { "d": "M16 3.13a4 4 0 0 1 0 7.75", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }], ["path", { "d": "M19 16v6", "key": "svg-4" }]]);

var IconUsersPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUsersPlus
});

var IconUsers = createReactComponent("outline", "users", "IconUsers", [["path", { "d": "M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-0" }], ["path", { "d": "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2", "key": "svg-1" }], ["path", { "d": "M16 3.13a4 4 0 0 1 0 7.75", "key": "svg-2" }], ["path", { "d": "M21 21v-2a4 4 0 0 0 -3 -3.85", "key": "svg-3" }]]);

var IconUsers$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUsers
});

var IconUvIndex = createReactComponent("outline", "uv-index", "IconUvIndex", [["path", { "d": "M3 12h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 1 1 8 0", "key": "svg-0" }], ["path", { "d": "M12 4v-1", "key": "svg-1" }], ["path", { "d": "M13 16l2 5h1l2 -5", "key": "svg-2" }], ["path", { "d": "M6 16v3a2 2 0 1 0 4 0v-3", "key": "svg-3" }]]);

var IconUvIndex$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUvIndex
});

var IconUxCircle = createReactComponent("outline", "ux-circle", "IconUxCircle", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M7 10v2a2 2 0 1 0 4 0v-2", "key": "svg-1" }], ["path", { "d": "M14 10l3 4", "key": "svg-2" }], ["path", { "d": "M14 14l3 -4", "key": "svg-3" }]]);

var IconUxCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUxCircle
});

var IconVaccineBottleOff = createReactComponent("outline", "vaccine-bottle-off", "IconVaccineBottleOff", [["path", { "d": "M9 5v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-4", "key": "svg-0" }], ["path", { "d": "M8.7 8.705a1.806 1.806 0 0 1 -.2 .045c-.866 .144 -1.5 .893 -1.5 1.77v8.48a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-2m0 -4v-2.48c0 -.877 -.634 -1.626 -1.5 -1.77a1.795 1.795 0 0 1 -1.5 -1.77v-.98", "key": "svg-1" }], ["path", { "d": "M7 12h5m4 0h1", "key": "svg-2" }], ["path", { "d": "M7 18h10", "key": "svg-3" }], ["path", { "d": "M11 15h2", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconVaccineBottleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVaccineBottleOff
});

var IconVaccineBottle = createReactComponent("outline", "vaccine-bottle", "IconVaccineBottle", [["path", { "d": "M9 3m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M10 6v.98c0 .877 -.634 1.626 -1.5 1.77c-.866 .144 -1.5 .893 -1.5 1.77v8.48a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-8.48c0 -.877 -.634 -1.626 -1.5 -1.77a1.795 1.795 0 0 1 -1.5 -1.77v-.98", "key": "svg-1" }], ["path", { "d": "M7 12h10", "key": "svg-2" }], ["path", { "d": "M7 18h10", "key": "svg-3" }], ["path", { "d": "M11 15h2", "key": "svg-4" }]]);

var IconVaccineBottle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVaccineBottle
});

var IconVaccineOff = createReactComponent("outline", "vaccine-off", "IconVaccineOff", [["path", { "d": "M17 3l4 4", "key": "svg-0" }], ["path", { "d": "M19 5l-4.5 4.5", "key": "svg-1" }], ["path", { "d": "M11.5 6.5l6 6", "key": "svg-2" }], ["path", { "d": "M16.5 11.5l-.5 .5m-2 2l-4 4h-4v-4l4 -4m2 -2l.5 -.5", "key": "svg-3" }], ["path", { "d": "M7.5 12.5l1.5 1.5", "key": "svg-4" }], ["path", { "d": "M3 21l3 -3", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconVaccineOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVaccineOff
});

var IconVaccine = createReactComponent("outline", "vaccine", "IconVaccine", [["path", { "d": "M17 3l4 4", "key": "svg-0" }], ["path", { "d": "M19 5l-4.5 4.5", "key": "svg-1" }], ["path", { "d": "M11.5 6.5l6 6", "key": "svg-2" }], ["path", { "d": "M16.5 11.5l-6.5 6.5h-4v-4l6.5 -6.5", "key": "svg-3" }], ["path", { "d": "M7.5 12.5l1.5 1.5", "key": "svg-4" }], ["path", { "d": "M10.5 9.5l1.5 1.5", "key": "svg-5" }], ["path", { "d": "M3 21l3 -3", "key": "svg-6" }]]);

var IconVaccine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVaccine
});

var IconVacuumCleaner = createReactComponent("outline", "vacuum-cleaner", "IconVacuumCleaner", [["path", { "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z", "key": "svg-0" }], ["path", { "d": "M14 9a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z", "key": "svg-1" }], ["path", { "d": "M12 16h.01", "key": "svg-2" }]]);

var IconVacuumCleaner$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVacuumCleaner
});

var IconVariableMinus = createReactComponent("outline", "variable-minus", "IconVariableMinus", [["path", { "d": "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5", "key": "svg-0" }], ["path", { "d": "M5 4c-2.5 5 -2.5 10 0 16m14 -16c1.775 3.55 2.29 7.102 1.544 11.01m-11.544 -6.01h1c1 0 1 1 2.016 3.527c.782 1.966 .943 3 1.478 3.343", "key": "svg-1" }], ["path", { "d": "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5", "key": "svg-2" }], ["path", { "d": "M16 19h6", "key": "svg-3" }]]);

var IconVariableMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVariableMinus
});

var IconVariableOff = createReactComponent("outline", "variable-off", "IconVariableOff", [["path", { "d": "M4.675 4.68c-2.17 4.776 -2.062 9.592 .325 15.32", "key": "svg-0" }], ["path", { "d": "M19 4c1.959 3.917 2.383 7.834 1.272 12.232m-.983 3.051c-.093 .238 -.189 .477 -.289 .717", "key": "svg-1" }], ["path", { "d": "M11.696 11.696c.095 .257 .2 .533 .32 .831c.984 2.473 .984 3.473 1.984 3.473h1", "key": "svg-2" }], ["path", { "d": "M8 16c1.5 0 3 -2 4 -3.5m2.022 -2.514c.629 -.582 1.304 -.986 1.978 -.986", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconVariableOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVariableOff
});

var IconVariablePlus = createReactComponent("outline", "variable-plus", "IconVariablePlus", [["path", { "d": "M5 4c-2.5 5 -2.5 10 0 16m14 -16c1.38 2.76 2 5.52 1.855 8.448m-11.855 -3.448h1c1 0 1 1 2.016 3.527c.785 1.972 .944 3.008 1.483 3.346", "key": "svg-0" }], ["path", { "d": "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }], ["path", { "d": "M19 16v6", "key": "svg-3" }]]);

var IconVariablePlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVariablePlus
});

var IconVariable = createReactComponent("outline", "variable", "IconVariable", [["path", { "d": "M5 4c-2.5 5 -2.5 10 0 16m14 -16c2.5 5 2.5 10 0 16m-10 -11h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1", "key": "svg-0" }], ["path", { "d": "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5", "key": "svg-1" }]]);

var IconVariable$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVariable
});

var IconVectorBezier2 = createReactComponent("outline", "vector-bezier-2", "IconVectorBezier2", [["path", { "d": "M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M7 5l7 0", "key": "svg-2" }], ["path", { "d": "M10 19l7 0", "key": "svg-3" }], ["path", { "d": "M9 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-4" }], ["path", { "d": "M15 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-5" }], ["path", { "d": "M7 5.5a5 6.5 0 0 1 5 6.5a5 6.5 0 0 0 5 6.5", "key": "svg-6" }]]);

var IconVectorBezier2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVectorBezier2
});

var IconVectorBezierArc = createReactComponent("outline", "vector-bezier-arc", "IconVectorBezierArc", [["path", { "d": "M3 10m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M17 10m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M10 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M10 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-3" }], ["path", { "d": "M19 10a5 5 0 0 0 -5 -5", "key": "svg-4" }], ["path", { "d": "M5 14a5 5 0 0 0 5 5", "key": "svg-5" }], ["path", { "d": "M5 10a5 5 0 0 1 5 -5", "key": "svg-6" }]]);

var IconVectorBezierArc$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVectorBezierArc
});

var IconVectorBezierCircle = createReactComponent("outline", "vector-bezier-circle", "IconVectorBezierCircle", [["path", { "d": "M3 10m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M17 10m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M10 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M10 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-3" }], ["path", { "d": "M19 10a5 5 0 0 0 -5 -5", "key": "svg-4" }], ["path", { "d": "M19 14a5 5 0 0 1 -5 5", "key": "svg-5" }], ["path", { "d": "M5 14a5 5 0 0 0 5 5", "key": "svg-6" }], ["path", { "d": "M5 10a5 5 0 0 1 5 -5", "key": "svg-7" }]]);

var IconVectorBezierCircle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVectorBezierCircle
});

var IconVectorBezier = createReactComponent("outline", "vector-bezier", "IconVectorBezier", [["path", { "d": "M3 14m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M17 14m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M10 6m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M10 8.5a6 6 0 0 0 -5 5.5", "key": "svg-3" }], ["path", { "d": "M14 8.5a6 6 0 0 1 5 5.5", "key": "svg-4" }], ["path", { "d": "M10 8l-6 0", "key": "svg-5" }], ["path", { "d": "M20 8l-6 0", "key": "svg-6" }], ["path", { "d": "M3 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-7" }], ["path", { "d": "M21 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-8" }]]);

var IconVectorBezier$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVectorBezier
});

var IconVectorOff = createReactComponent("outline", "vector-off", "IconVectorOff", [["path", { "d": "M6.68 6.733a1 1 0 0 1 -.68 .267h-2a1 1 0 0 1 -1 -1v-2c0 -.276 .112 -.527 .293 -.708", "key": "svg-0" }], ["path", { "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M20.72 20.693a1 1 0 0 1 -.72 .307h-2a1 1 0 0 1 -1 -1v-2c0 -.282 .116 -.536 .304 -.718", "key": "svg-2" }], ["path", { "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-3" }], ["path", { "d": "M5 7v10", "key": "svg-4" }], ["path", { "d": "M19 7v8", "key": "svg-5" }], ["path", { "d": "M9 5h8", "key": "svg-6" }], ["path", { "d": "M7 19h10", "key": "svg-7" }], ["path", { "d": "M3 3l18 18", "key": "svg-8" }]]);

var IconVectorOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVectorOff
});

var IconVectorSpline = createReactComponent("outline", "vector-spline", "IconVectorSpline", [["path", { "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M17 5c-6.627 0 -12 5.373 -12 12", "key": "svg-2" }]]);

var IconVectorSpline$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVectorSpline
});

var IconVectorTriangleOff = createReactComponent("outline", "vector-triangle-off", "IconVectorTriangleOff", [["path", { "d": "M10 6v-1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1", "key": "svg-0" }], ["path", { "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M20.705 20.709a1 1 0 0 1 -.705 .291h-2a1 1 0 0 1 -1 -1v-2c0 -.28 .115 -.532 .3 -.714", "key": "svg-2" }], ["path", { "d": "M6.5 17.1l3.749 -6.823", "key": "svg-3" }], ["path", { "d": "M13.158 9.197l-.658 -1.197", "key": "svg-4" }], ["path", { "d": "M7 19h10", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconVectorTriangleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVectorTriangleOff
});

var IconVectorTriangle = createReactComponent("outline", "vector-triangle", "IconVectorTriangle", [["path", { "d": "M10 4m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M6.5 17.1l5 -9.1", "key": "svg-3" }], ["path", { "d": "M17.5 17.1l-5 -9.1", "key": "svg-4" }], ["path", { "d": "M7 19l10 0", "key": "svg-5" }]]);

var IconVectorTriangle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVectorTriangle
});

var IconVector = createReactComponent("outline", "vector", "IconVector", [["path", { "d": "M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-1" }], ["path", { "d": "M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-2" }], ["path", { "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z", "key": "svg-3" }], ["path", { "d": "M5 7l0 10", "key": "svg-4" }], ["path", { "d": "M19 7l0 10", "key": "svg-5" }], ["path", { "d": "M7 5l10 0", "key": "svg-6" }], ["path", { "d": "M7 19l10 0", "key": "svg-7" }]]);

var IconVector$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVector
});

var IconVenus = createReactComponent("outline", "venus", "IconVenus", [["path", { "d": "M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M12 14l0 7", "key": "svg-1" }], ["path", { "d": "M9 18l6 0", "key": "svg-2" }]]);

var IconVenus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVenus
});

var IconVersionsOff = createReactComponent("outline", "versions-off", "IconVersionsOff", [["path", { "d": "M10.184 6.162a2 2 0 0 1 1.816 -1.162h6a2 2 0 0 1 2 2v9m-1.185 2.827a1.993 1.993 0 0 1 -.815 .173h-6a2 2 0 0 1 -2 -2v-7", "key": "svg-0" }], ["path", { "d": "M7 7v10", "key": "svg-1" }], ["path", { "d": "M4 8v8", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconVersionsOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVersionsOff
});

var IconVersions = createReactComponent("outline", "versions", "IconVersions", [["path", { "d": "M10 5m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M7 7l0 10", "key": "svg-1" }], ["path", { "d": "M4 8l0 8", "key": "svg-2" }]]);

var IconVersions$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVersions
});

var IconVideoMinus = createReactComponent("outline", "video-minus", "IconVideoMinus", [["path", { "d": "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z", "key": "svg-0" }], ["path", { "d": "M3 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M7 12l4 0", "key": "svg-2" }]]);

var IconVideoMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVideoMinus
});

var IconVideoOff = createReactComponent("outline", "video-off", "IconVideoOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M15 11v-1l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -.675 .946", "key": "svg-1" }], ["path", { "d": "M10 6h3a2 2 0 0 1 2 2v3m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1", "key": "svg-2" }]]);

var IconVideoOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVideoOff
});

var IconVideoPlus = createReactComponent("outline", "video-plus", "IconVideoPlus", [["path", { "d": "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z", "key": "svg-0" }], ["path", { "d": "M3 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-1" }], ["path", { "d": "M7 12l4 0", "key": "svg-2" }], ["path", { "d": "M9 10l0 4", "key": "svg-3" }]]);

var IconVideoPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVideoPlus
});

var IconVideo = createReactComponent("outline", "video", "IconVideo", [["path", { "d": "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z", "key": "svg-0" }], ["path", { "d": "M3 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-1" }]]);

var IconVideo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVideo
});

var IconView360Arrow = createReactComponent("outline", "view-360-arrow", "IconView360Arrow", [["path", { "d": "M17 15.328c2.414 -.718 4 -1.94 4 -3.328c0 -2.21 -4.03 -4 -9 -4s-9 1.79 -9 4s4.03 4 9 4", "key": "svg-0" }], ["path", { "d": "M9 13l3 3l-3 3", "key": "svg-1" }]]);

var IconView360Arrow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconView360Arrow
});

var IconView360Number = createReactComponent("outline", "view-360-number", "IconView360Number", [["path", { "d": "M14 6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3", "key": "svg-0" }], ["path", { "d": "M3 5h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5", "key": "svg-1" }], ["path", { "d": "M17 7v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z", "key": "svg-2" }], ["path", { "d": "M3 16c0 1.657 4.03 3 9 3s9 -1.343 9 -3", "key": "svg-3" }]]);

var IconView360Number$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconView360Number
});

var IconView360Off = createReactComponent("outline", "view-360-off", "IconView360Off", [["path", { "d": "M8.335 8.388a19 19 0 0 0 -.335 3.612c0 4.97 1.79 9 4 9c1.622 0 3.018 -2.172 3.646 -5.294m.354 -3.706c0 -4.97 -1.79 -9 -4 -9c-1.035 0 -1.979 .885 -2.689 2.337", "key": "svg-0" }], ["path", { "d": "M5.65 5.623a9 9 0 1 0 12.71 12.745m1.684 -2.328a9 9 0 0 0 -12.094 -12.08", "key": "svg-1" }], ["path", { "d": "M8.32 8.349c-3.136 .625 -5.32 2.025 -5.32 3.651c0 2.21 4.03 4 9 4c1.286 0 2.51 -.12 3.616 -.336m3.059 -.98c1.445 -.711 2.325 -1.653 2.325 -2.684c0 -2.21 -4.03 -4 -9 -4", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconView360Off$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconView360Off
});

var IconView360 = createReactComponent("outline", "view-360", "IconView360", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-4 0a4 9 0 1 0 8 0a4 9 0 1 0 -8 0", "key": "svg-1" }], ["path", { "d": "M3 12c0 2.21 4.03 4 9 4s9 -1.79 9 -4s-4.03 -4 -9 -4s-9 1.79 -9 4z", "key": "svg-2" }]]);

var IconView360$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconView360
});

var IconViewfinderOff = createReactComponent("outline", "viewfinder-off", "IconViewfinderOff", [["path", { "d": "M5.65 5.623a9 9 0 1 0 12.71 12.745m1.684 -2.328a9 9 0 0 0 -12.094 -12.08", "key": "svg-0" }], ["path", { "d": "M12 3v4", "key": "svg-1" }], ["path", { "d": "M12 21v-3", "key": "svg-2" }], ["path", { "d": "M3 12h4", "key": "svg-3" }], ["path", { "d": "M21 12h-3", "key": "svg-4" }], ["path", { "d": "M12 12v.01", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconViewfinderOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconViewfinderOff
});

var IconViewfinder = createReactComponent("outline", "viewfinder", "IconViewfinder", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 3l0 4", "key": "svg-1" }], ["path", { "d": "M12 21l0 -3", "key": "svg-2" }], ["path", { "d": "M3 12l4 0", "key": "svg-3" }], ["path", { "d": "M21 12l-3 0", "key": "svg-4" }], ["path", { "d": "M12 12l0 .01", "key": "svg-5" }]]);

var IconViewfinder$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconViewfinder
});

var IconViewportNarrow = createReactComponent("outline", "viewport-narrow", "IconViewportNarrow", [["path", { "d": "M3 12h7l-3 -3", "key": "svg-0" }], ["path", { "d": "M7 15l3 -3", "key": "svg-1" }], ["path", { "d": "M21 12h-7l3 -3", "key": "svg-2" }], ["path", { "d": "M17 15l-3 -3", "key": "svg-3" }], ["path", { "d": "M9 6v-1a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1", "key": "svg-4" }], ["path", { "d": "M9 18v1a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-1", "key": "svg-5" }]]);

var IconViewportNarrow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconViewportNarrow
});

var IconViewportShort = createReactComponent("outline", "viewport-short", "IconViewportShort", [["path", { "d": "M12 3v7l3 -3", "key": "svg-0" }], ["path", { "d": "M9 7l3 3", "key": "svg-1" }], ["path", { "d": "M12 21v-7l3 3", "key": "svg-2" }], ["path", { "d": "M9 17l3 -3", "key": "svg-3" }], ["path", { "d": "M18 9h1a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-1", "key": "svg-4" }], ["path", { "d": "M6 9h-1a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h1", "key": "svg-5" }]]);

var IconViewportShort$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconViewportShort
});

var IconViewportTall = createReactComponent("outline", "viewport-tall", "IconViewportTall", [["path", { "d": "M12 10v-7l3 3", "key": "svg-0" }], ["path", { "d": "M9 6l3 -3", "key": "svg-1" }], ["path", { "d": "M12 14v7l3 -3", "key": "svg-2" }], ["path", { "d": "M9 18l3 3", "key": "svg-3" }], ["path", { "d": "M18 3h1a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-1", "key": "svg-4" }], ["path", { "d": "M6 3h-1a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h1", "key": "svg-5" }]]);

var IconViewportTall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconViewportTall
});

var IconViewportWide = createReactComponent("outline", "viewport-wide", "IconViewportWide", [["path", { "d": "M10 12h-7l3 -3", "key": "svg-0" }], ["path", { "d": "M6 15l-3 -3", "key": "svg-1" }], ["path", { "d": "M14 12h7l-3 -3", "key": "svg-2" }], ["path", { "d": "M18 15l3 -3", "key": "svg-3" }], ["path", { "d": "M3 6v-1a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v1", "key": "svg-4" }], ["path", { "d": "M3 18v1a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-1", "key": "svg-5" }]]);

var IconViewportWide$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconViewportWide
});

var IconVinyl = createReactComponent("outline", "vinyl", "IconVinyl", [["path", { "d": "M16 3.937a9 9 0 1 0 5 8.063", "key": "svg-0" }], ["path", { "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-1" }], ["path", { "d": "M20 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M20 4l-3.5 10l-2.5 2", "key": "svg-3" }]]);

var IconVinyl$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVinyl
});

var IconVipOff = createReactComponent("outline", "vip-off", "IconVipOff", [["path", { "d": "M3 5h2m4 0h12", "key": "svg-0" }], ["path", { "d": "M3 19h16", "key": "svg-1" }], ["path", { "d": "M4 9l2 6h1l2 -6", "key": "svg-2" }], ["path", { "d": "M12 12v3", "key": "svg-3" }], ["path", { "d": "M16 12v-3h2a2 2 0 1 1 0 4h-1", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconVipOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVipOff
});

var IconVip = createReactComponent("outline", "vip", "IconVip", [["path", { "d": "M3 5h18", "key": "svg-0" }], ["path", { "d": "M3 19h18", "key": "svg-1" }], ["path", { "d": "M4 9l2 6h1l2 -6", "key": "svg-2" }], ["path", { "d": "M12 9v6", "key": "svg-3" }], ["path", { "d": "M16 15v-6h2a2 2 0 1 1 0 4h-2", "key": "svg-4" }]]);

var IconVip$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVip
});

var IconVirusOff = createReactComponent("outline", "virus-off", "IconVirusOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M8.469 8.46a5 5 0 0 0 7.058 7.084", "key": "svg-1" }], ["path", { "d": "M16.913 12.936a5 5 0 0 0 -5.826 -5.853", "key": "svg-2" }], ["path", { "d": "M12 7v-4", "key": "svg-3" }], ["path", { "d": "M11 3h2", "key": "svg-4" }], ["path", { "d": "M15.536 8.464l2.828 -2.828", "key": "svg-5" }], ["path", { "d": "M17.657 4.929l1.414 1.414", "key": "svg-6" }], ["path", { "d": "M17 12h4", "key": "svg-7" }], ["path", { "d": "M21 11v2", "key": "svg-8" }], ["path", { "d": "M18.364 18.363l-.707 .707", "key": "svg-9" }], ["path", { "d": "M12 17v4", "key": "svg-10" }], ["path", { "d": "M13 21h-2", "key": "svg-11" }], ["path", { "d": "M8.465 15.536l-2.829 2.828", "key": "svg-12" }], ["path", { "d": "M6.343 19.071l-1.413 -1.414", "key": "svg-13" }], ["path", { "d": "M7 12h-4", "key": "svg-14" }], ["path", { "d": "M3 13v-2", "key": "svg-15" }], ["path", { "d": "M5.636 5.637l-.707 .707", "key": "svg-16" }]]);

var IconVirusOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVirusOff
});

var IconVirusSearch = createReactComponent("outline", "virus-search", "IconVirusSearch", [["path", { "d": "M17 12a5 5 0 1 0 -5 5", "key": "svg-0" }], ["path", { "d": "M12 7v-4", "key": "svg-1" }], ["path", { "d": "M11 3h2", "key": "svg-2" }], ["path", { "d": "M15.536 8.464l2.828 -2.828", "key": "svg-3" }], ["path", { "d": "M17.657 4.929l1.414 1.414", "key": "svg-4" }], ["path", { "d": "M17 12h4", "key": "svg-5" }], ["path", { "d": "M21 11v2", "key": "svg-6" }], ["path", { "d": "M12 17v4", "key": "svg-7" }], ["path", { "d": "M13 21h-2", "key": "svg-8" }], ["path", { "d": "M8.465 15.536l-2.829 2.828", "key": "svg-9" }], ["path", { "d": "M6.343 19.071l-1.413 -1.414", "key": "svg-10" }], ["path", { "d": "M7 12h-4", "key": "svg-11" }], ["path", { "d": "M3 13v-2", "key": "svg-12" }], ["path", { "d": "M8.464 8.464l-2.828 -2.828", "key": "svg-13" }], ["path", { "d": "M4.929 6.343l1.414 -1.413", "key": "svg-14" }], ["path", { "d": "M17.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0", "key": "svg-15" }], ["path", { "d": "M19.5 19.5l2.5 2.5", "key": "svg-16" }]]);

var IconVirusSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVirusSearch
});

var IconVirus = createReactComponent("outline", "virus", "IconVirus", [["path", { "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M12 7v-4", "key": "svg-1" }], ["path", { "d": "M11 3h2", "key": "svg-2" }], ["path", { "d": "M15.536 8.464l2.828 -2.828", "key": "svg-3" }], ["path", { "d": "M17.657 4.929l1.414 1.414", "key": "svg-4" }], ["path", { "d": "M17 12h4", "key": "svg-5" }], ["path", { "d": "M21 11v2", "key": "svg-6" }], ["path", { "d": "M15.535 15.536l2.829 2.828", "key": "svg-7" }], ["path", { "d": "M19.071 17.657l-1.414 1.414", "key": "svg-8" }], ["path", { "d": "M12 17v4", "key": "svg-9" }], ["path", { "d": "M13 21h-2", "key": "svg-10" }], ["path", { "d": "M8.465 15.536l-2.829 2.828", "key": "svg-11" }], ["path", { "d": "M6.343 19.071l-1.413 -1.414", "key": "svg-12" }], ["path", { "d": "M7 12h-4", "key": "svg-13" }], ["path", { "d": "M3 13v-2", "key": "svg-14" }], ["path", { "d": "M8.464 8.464l-2.828 -2.828", "key": "svg-15" }], ["path", { "d": "M4.929 6.343l1.414 -1.413", "key": "svg-16" }]]);

var IconVirus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVirus
});

var IconVocabularyOff = createReactComponent("outline", "vocabulary-off", "IconVocabularyOff", [["path", { "d": "M7 3h3a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v13m-2 2h-5a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2h-6a1 1 0 0 1 -1 -1v-14c0 -.279 .114 -.53 .298 -.712", "key": "svg-0" }], ["path", { "d": "M12 5v3m0 4v9", "key": "svg-1" }], ["path", { "d": "M7 11h1", "key": "svg-2" }], ["path", { "d": "M16 7h1", "key": "svg-3" }], ["path", { "d": "M16 11h1", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconVocabularyOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVocabularyOff
});

var IconVocabulary = createReactComponent("outline", "vocabulary", "IconVocabulary", [["path", { "d": "M10 19h-6a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h6a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 5v16", "key": "svg-1" }], ["path", { "d": "M7 7h1", "key": "svg-2" }], ["path", { "d": "M7 11h1", "key": "svg-3" }], ["path", { "d": "M16 7h1", "key": "svg-4" }], ["path", { "d": "M16 11h1", "key": "svg-5" }], ["path", { "d": "M16 15h1", "key": "svg-6" }]]);

var IconVocabulary$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVocabulary
});

var IconVolcano = createReactComponent("outline", "volcano", "IconVolcano", [["path", { "d": "M9 8v-1a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M15 8v-1a2 2 0 1 1 4 0", "key": "svg-1" }], ["path", { "d": "M4 20l3.472 -7.812a2 2 0 0 1 1.828 -1.188h5.4a2 2 0 0 1 1.828 1.188l3.472 7.812", "key": "svg-2" }], ["path", { "d": "M6.192 15.064a2.14 2.14 0 0 1 .475 -.064c.527 -.009 1.026 .178 1.333 .5c.307 .32 .806 .507 1.333 .5c.527 .007 1.026 -.18 1.334 -.5c.307 -.322 .806 -.509 1.333 -.5c.527 -.009 1.026 .178 1.333 .5c.308 .32 .807 .507 1.334 .5c.527 .007 1.026 -.18 1.333 -.5c.307 -.322 .806 -.509 1.333 -.5c.161 .003 .32 .025 .472 .064", "key": "svg-3" }], ["path", { "d": "M12 8v-4", "key": "svg-4" }]]);

var IconVolcano$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVolcano
});

var IconVolume2 = createReactComponent("outline", "volume-2", "IconVolume2", [["path", { "d": "M15 8a5 5 0 0 1 0 8", "key": "svg-0" }], ["path", { "d": "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a.8 .8 0 0 1 1.5 .5v14a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5", "key": "svg-1" }]]);

var IconVolume2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVolume2
});

var IconVolume3 = createReactComponent("outline", "volume-3", "IconVolume3", [["path", { "d": "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a.8 .8 0 0 1 1.5 .5v14a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5", "key": "svg-0" }], ["path", { "d": "M16 10l4 4m0 -4l-4 4", "key": "svg-1" }]]);

var IconVolume3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVolume3
});

var IconVolumeOff = createReactComponent("outline", "volume-off", "IconVolumeOff", [["path", { "d": "M15 8a5 5 0 0 1 1.912 4.934m-1.377 2.602a5 5 0 0 1 -.535 .464", "key": "svg-0" }], ["path", { "d": "M17.7 5a9 9 0 0 1 2.362 11.086m-1.676 2.299a9 9 0 0 1 -.686 .615", "key": "svg-1" }], ["path", { "d": "M9.069 5.054l.431 -.554a.8 .8 0 0 1 1.5 .5v2m0 4v8a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l1.294 -1.664", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconVolumeOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVolumeOff
});

var IconVolume = createReactComponent("outline", "volume", "IconVolume", [["path", { "d": "M15 8a5 5 0 0 1 0 8", "key": "svg-0" }], ["path", { "d": "M17.7 5a9 9 0 0 1 0 14", "key": "svg-1" }], ["path", { "d": "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a.8 .8 0 0 1 1.5 .5v14a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5", "key": "svg-2" }]]);

var IconVolume$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVolume
});

var IconVs = createReactComponent("outline", "vs", "IconVs", [["path", { "d": "M2 12c0 5.523 4.477 10 10 10s10 -4.477 10 -10s-4.477 -10 -10 -10s-10 4.477 -10 10", "key": "svg-0" }], ["path", { "d": "M14 14.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75", "key": "svg-1" }], ["path", { "d": "M7 9l2 6l2 -6", "key": "svg-2" }]]);

var IconVs$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVs
});

var IconWalk = createReactComponent("outline", "walk", "IconWalk", [["path", { "d": "M13 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M7 21l3 -4", "key": "svg-1" }], ["path", { "d": "M16 21l-2 -4l-3 -3l1 -6", "key": "svg-2" }], ["path", { "d": "M6 12l2 -3l4 -1l3 3l3 1", "key": "svg-3" }]]);

var IconWalk$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWalk
});

var IconWallOff = createReactComponent("outline", "wall-off", "IconWallOff", [["path", { "d": "M8 4h10a2 2 0 0 1 2 2v10m-.589 3.417c-.361 .36 -.86 .583 -1.411 .583h-12a2 2 0 0 1 -2 -2v-12c0 -.55 .222 -1.047 .58 -1.409", "key": "svg-0" }], ["path", { "d": "M4 8h4m4 0h8", "key": "svg-1" }], ["path", { "d": "M20 12h-4m-4 0h-8", "key": "svg-2" }], ["path", { "d": "M4 16h12", "key": "svg-3" }], ["path", { "d": "M9 4v1", "key": "svg-4" }], ["path", { "d": "M14 8v2", "key": "svg-5" }], ["path", { "d": "M8 12v4", "key": "svg-6" }], ["path", { "d": "M11 16v4", "key": "svg-7" }], ["path", { "d": "M3 3l18 18", "key": "svg-8" }]]);

var IconWallOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWallOff
});

var IconWall = createReactComponent("outline", "wall", "IconWall", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 8h16", "key": "svg-1" }], ["path", { "d": "M20 12h-16", "key": "svg-2" }], ["path", { "d": "M4 16h16", "key": "svg-3" }], ["path", { "d": "M9 4v4", "key": "svg-4" }], ["path", { "d": "M14 8v4", "key": "svg-5" }], ["path", { "d": "M8 12v4", "key": "svg-6" }], ["path", { "d": "M16 12v4", "key": "svg-7" }], ["path", { "d": "M11 16v4", "key": "svg-8" }]]);

var IconWall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWall
});

var IconWalletOff = createReactComponent("outline", "wallet-off", "IconWalletOff", [["path", { "d": "M17 8v-3a1 1 0 0 0 -1 -1h-8m-3.413 .584a2 2 0 0 0 1.413 3.416h2m4 0h6a1 1 0 0 1 1 1v3", "key": "svg-0" }], ["path", { "d": "M19 19a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12", "key": "svg-1" }], ["path", { "d": "M16 12h4v4m-4 0a2 2 0 0 1 -2 -2", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconWalletOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWalletOff
});

var IconWallet = createReactComponent("outline", "wallet", "IconWallet", [["path", { "d": "M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12", "key": "svg-0" }], ["path", { "d": "M20 12v4h-4a2 2 0 0 1 0 -4h4", "key": "svg-1" }]]);

var IconWallet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWallet
});

var IconWallpaperOff = createReactComponent("outline", "wallpaper-off", "IconWallpaperOff", [["path", { "d": "M10 6h8a2 2 0 0 1 2 2v8m-.58 3.409a2 2 0 0 1 -1.42 .591h-12", "key": "svg-0" }], ["path", { "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M8 18v-10m-3.427 -3.402c-.353 .362 -.573 .856 -.573 1.402v12", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconWallpaperOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWallpaperOff
});

var IconWallpaper = createReactComponent("outline", "wallpaper", "IconWallpaper", [["path", { "d": "M8 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-12", "key": "svg-0" }], ["path", { "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M8 18v-12a2 2 0 1 0 -4 0v12", "key": "svg-2" }]]);

var IconWallpaper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWallpaper
});

var IconWandOff = createReactComponent("outline", "wand-off", "IconWandOff", [["path", { "d": "M10.5 10.5l-7.5 7.5l3 3l7.5 -7.5m2 -2l5.5 -5.5l-3 -3l-5.5 5.5", "key": "svg-0" }], ["path", { "d": "M15 6l3 3", "key": "svg-1" }], ["path", { "d": "M8.433 4.395c.35 -.36 .567 -.852 .567 -1.395a2 2 0 0 0 2 2c-.554 0 -1.055 .225 -1.417 .589", "key": "svg-2" }], ["path", { "d": "M18.418 14.41c.36 -.36 .582 -.86 .582 -1.41a2 2 0 0 0 2 2c-.555 0 -1.056 .226 -1.419 .59", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconWandOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWandOff
});

var IconWand = createReactComponent("outline", "wand", "IconWand", [["path", { "d": "M6 21l15 -15l-3 -3l-15 15l3 3", "key": "svg-0" }], ["path", { "d": "M15 6l3 3", "key": "svg-1" }], ["path", { "d": "M9 3a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2", "key": "svg-2" }], ["path", { "d": "M19 13a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2", "key": "svg-3" }]]);

var IconWand$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWand
});

var IconWashDry1 = createReactComponent("outline", "wash-dry-1", "IconWashDry1", [["path", { "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-1" }], ["path", { "d": "M12 12h.01", "key": "svg-2" }]]);

var IconWashDry1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDry1
});

var IconWashDry2 = createReactComponent("outline", "wash-dry-2", "IconWashDry2", [["path", { "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-1" }], ["path", { "d": "M10 12h.01", "key": "svg-2" }], ["path", { "d": "M14 12h.01", "key": "svg-3" }]]);

var IconWashDry2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDry2
});

var IconWashDry3 = createReactComponent("outline", "wash-dry-3", "IconWashDry3", [["path", { "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-1" }], ["path", { "d": "M12 12h.01", "key": "svg-2" }], ["path", { "d": "M9 12h.01", "key": "svg-3" }], ["path", { "d": "M15 12h.01", "key": "svg-4" }]]);

var IconWashDry3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDry3
});

var IconWashDryA = createReactComponent("outline", "wash-dry-a", "IconWashDryA", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 16v-4.8c0 -1.657 1.343 -3.2 3 -3.2s3 1.543 3 3.2v4.8", "key": "svg-1" }], ["path", { "d": "M15 13h-6", "key": "svg-2" }]]);

var IconWashDryA$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDryA
});

var IconWashDryDip = createReactComponent("outline", "wash-dry-dip", "IconWashDryDip", [["path", { "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M12 7v10", "key": "svg-1" }], ["path", { "d": "M16 7v10", "key": "svg-2" }], ["path", { "d": "M8 7v10", "key": "svg-3" }]]);

var IconWashDryDip$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDryDip
});

var IconWashDryF = createReactComponent("outline", "wash-dry-f", "IconWashDryF", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 16v-8h4", "key": "svg-1" }], ["path", { "d": "M13 12h-3", "key": "svg-2" }]]);

var IconWashDryF$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDryF
});

var IconWashDryFlat = createReactComponent("outline", "wash-dry-flat", "IconWashDryFlat", [["path", { "d": "M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z", "key": "svg-0" }], ["path", { "d": "M7 12h10", "key": "svg-1" }]]);

var IconWashDryFlat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDryFlat
});

var IconWashDryHang = createReactComponent("outline", "wash-dry-hang", "IconWashDryHang", [["path", { "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M4 4.01c5.333 5.323 10.667 5.32 16 -.01", "key": "svg-1" }]]);

var IconWashDryHang$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDryHang
});

var IconWashDryOff = createReactComponent("outline", "wash-dry-off", "IconWashDryOff", [["path", { "d": "M20.116 20.127a2.99 2.99 0 0 1 -2.116 .873h-12a3 3 0 0 1 -3 -3v-12c0 -.827 .335 -1.576 .877 -2.12m3.123 -.88h11a3 3 0 0 1 3 3v11", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconWashDryOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDryOff
});

var IconWashDryP = createReactComponent("outline", "wash-dry-p", "IconWashDryP", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 16v-8h2.5a2.5 2.5 0 1 1 0 5h-2.5", "key": "svg-1" }]]);

var IconWashDryP$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDryP
});

var IconWashDryShade = createReactComponent("outline", "wash-dry-shade", "IconWashDryShade", [["path", { "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M3 11l8 -8", "key": "svg-1" }], ["path", { "d": "M3 17l14 -14", "key": "svg-2" }]]);

var IconWashDryShade$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDryShade
});

var IconWashDryW = createReactComponent("outline", "wash-dry-w", "IconWashDryW", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M8 8l1.5 8h1l1.5 -6l1.5 6h1l1.5 -8", "key": "svg-1" }]]);

var IconWashDryW$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDryW
});

var IconWashDry = createReactComponent("outline", "wash-dry", "IconWashDry", [["path", { "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }]]);

var IconWashDry$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDry
});

var IconWashDrycleanOff = createReactComponent("outline", "wash-dryclean-off", "IconWashDrycleanOff", [["path", { "d": "M20.048 16.033a9 9 0 0 0 -12.094 -12.075m-2.321 1.682a9 9 0 0 0 12.733 12.723", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

var IconWashDrycleanOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDrycleanOff
});

var IconWashDryclean = createReactComponent("outline", "wash-dryclean", "IconWashDryclean", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }]]);

var IconWashDryclean$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashDryclean
});

var IconWashEco = createReactComponent("outline", "wash-eco", "IconWashEco", [["path", { "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h5.306m8.162 -6.972l.838 -5.028", "key": "svg-0" }], ["path", { "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034", "key": "svg-1" }], ["path", { "d": "M16 22s0 -2 3 -4", "key": "svg-2" }], ["path", { "d": "M19 21a3 3 0 0 1 0 -6h3v3a3 3 0 0 1 -3 3z", "key": "svg-3" }]]);

var IconWashEco$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashEco
});

var IconWashGentle = createReactComponent("outline", "wash-gentle", "IconWashGentle", [["path", { "d": "M3.486 5.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034", "key": "svg-0" }], ["path", { "d": "M3 3l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329", "key": "svg-1" }], ["path", { "d": "M5 18h14", "key": "svg-2" }], ["path", { "d": "M5 21h14", "key": "svg-3" }]]);

var IconWashGentle$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashGentle
});

var IconWashHand = createReactComponent("outline", "wash-hand", "IconWashHand", [["path", { "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.426 -.296 .777 -.5 1.5 -.5h1", "key": "svg-0" }], ["path", { "d": "M16 8l.615 .034c.552 .067 1.046 .23 1.385 .466c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034", "key": "svg-1" }], ["path", { "d": "M14 10.5l.586 .578a1.516 1.516 0 0 0 2 0c.476 -.433 .55 -1.112 .176 -1.622l-1.762 -2.456c-.37 -.506 -1.331 -1 -2 -1h-3.117a1 1 0 0 0 -.992 .876l-.499 3.986a3.857 3.857 0 0 0 2.608 4.138a2.28 2.28 0 0 0 3 -2.162v-2.338z", "key": "svg-2" }], ["path", { "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329", "key": "svg-3" }]]);

var IconWashHand$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashHand
});

var IconWashMachine = createReactComponent("outline", "wash-machine", "IconWashMachine", [["path", { "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M12 14m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-1" }], ["path", { "d": "M8 6h.01", "key": "svg-2" }], ["path", { "d": "M11 6h.01", "key": "svg-3" }], ["path", { "d": "M14 6h2", "key": "svg-4" }], ["path", { "d": "M8 14c1.333 -.667 2.667 -.667 4 0c1.333 .667 2.667 .667 4 0", "key": "svg-5" }]]);

var IconWashMachine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashMachine
});

var IconWashOff = createReactComponent("outline", "wash-off", "IconWashOff", [["path", { "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612c.208 0 .41 -.032 .6 -.092m1.521 -2.472l1.573 -9.436", "key": "svg-0" }], ["path", { "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5m4.92 .919c.428 -.083 .805 -.227 1.08 -.418c.461 -.322 1.21 -.508 2 -.5c.79 -.008 1.539 .178 2 .5c.461 .32 1.21 .508 2 .5c.17 0 .339 -.015 .503 -.035", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconWashOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashOff
});

var IconWashPress = createReactComponent("outline", "wash-press", "IconWashPress", [["path", { "d": "M3.486 7.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034", "key": "svg-0" }], ["path", { "d": "M3 5l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329", "key": "svg-1" }], ["path", { "d": "M5 20h14", "key": "svg-2" }]]);

var IconWashPress$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashPress
});

var IconWashTemperature1 = createReactComponent("outline", "wash-temperature-1", "IconWashTemperature1", [["path", { "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329", "key": "svg-0" }], ["path", { "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034", "key": "svg-1" }], ["path", { "d": "M12 13h.01", "key": "svg-2" }]]);

var IconWashTemperature1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashTemperature1
});

var IconWashTemperature2 = createReactComponent("outline", "wash-temperature-2", "IconWashTemperature2", [["path", { "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034", "key": "svg-0" }], ["path", { "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329", "key": "svg-1" }], ["path", { "d": "M14 13h.01", "key": "svg-2" }], ["path", { "d": "M10 13h.01", "key": "svg-3" }]]);

var IconWashTemperature2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashTemperature2
});

var IconWashTemperature3 = createReactComponent("outline", "wash-temperature-3", "IconWashTemperature3", [["path", { "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034", "key": "svg-0" }], ["path", { "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329", "key": "svg-1" }], ["path", { "d": "M12 13h.01", "key": "svg-2" }], ["path", { "d": "M15 13h.01", "key": "svg-3" }], ["path", { "d": "M9 13h.01", "key": "svg-4" }]]);

var IconWashTemperature3$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashTemperature3
});

var IconWashTemperature4 = createReactComponent("outline", "wash-temperature-4", "IconWashTemperature4", [["path", { "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034", "key": "svg-0" }], ["path", { "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329", "key": "svg-1" }], ["path", { "d": "M10 15h.01", "key": "svg-2" }], ["path", { "d": "M14 15h.01", "key": "svg-3" }], ["path", { "d": "M14 12h.01", "key": "svg-4" }], ["path", { "d": "M10 12h.01", "key": "svg-5" }]]);

var IconWashTemperature4$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashTemperature4
});

var IconWashTemperature5 = createReactComponent("outline", "wash-temperature-5", "IconWashTemperature5", [["path", { "d": "M10 15h.01", "key": "svg-0" }], ["path", { "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329", "key": "svg-1" }], ["path", { "d": "M14 15h.01", "key": "svg-2" }], ["path", { "d": "M15 12h.01", "key": "svg-3" }], ["path", { "d": "M12 12h.01", "key": "svg-4" }], ["path", { "d": "M9 12h.01", "key": "svg-5" }], ["path", { "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034", "key": "svg-6" }]]);

var IconWashTemperature5$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashTemperature5
});

var IconWashTemperature6 = createReactComponent("outline", "wash-temperature-6", "IconWashTemperature6", [["path", { "d": "M9 15h.01", "key": "svg-0" }], ["path", { "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329", "key": "svg-1" }], ["path", { "d": "M12 15h.01", "key": "svg-2" }], ["path", { "d": "M15 15h.01", "key": "svg-3" }], ["path", { "d": "M15 12h.01", "key": "svg-4" }], ["path", { "d": "M12 12h.01", "key": "svg-5" }], ["path", { "d": "M9 12h.01", "key": "svg-6" }], ["path", { "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034", "key": "svg-7" }]]);

var IconWashTemperature6$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashTemperature6
});

var IconWashTumbleDry = createReactComponent("outline", "wash-tumble-dry", "IconWashTumbleDry", [["path", { "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-1" }]]);

var IconWashTumbleDry$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashTumbleDry
});

var IconWashTumbleOff = createReactComponent("outline", "wash-tumble-off", "IconWashTumbleOff", [["path", { "d": "M20.116 20.127a2.99 2.99 0 0 1 -2.116 .873h-12a3 3 0 0 1 -3 -3v-12c0 -.827 .335 -1.576 .877 -2.12m3.123 -.88h11a3 3 0 0 1 3 3v11", "key": "svg-0" }], ["path", { "d": "M17.744 13.74a6 6 0 0 0 -7.486 -7.482m-2.499 1.497a6 6 0 1 0 8.48 8.49", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconWashTumbleOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWashTumbleOff
});

var IconWash = createReactComponent("outline", "wash", "IconWash", [["path", { "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034", "key": "svg-0" }], ["path", { "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329", "key": "svg-1" }]]);

var IconWash$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWash
});

var IconWaterpolo = createReactComponent("outline", "waterpolo", "IconWaterpolo", [["path", { "d": "M12 9a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", "key": "svg-0" }], ["path", { "d": "M5 8l3 4l4.5 1l7.5 -1", "key": "svg-1" }], ["path", { "d": "M3 18.75a2.4 2.4 0 0 0 1 .25a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 1 -.25", "key": "svg-2" }], ["path", { "d": "M12 16l.5 -3", "key": "svg-3" }], ["path", { "d": "M6.5 5a.5 .5 0 1 0 0 -1a.5 .5 0 0 0 0 1z", "fill": "currentColor", "key": "svg-4" }]]);

var IconWaterpolo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWaterpolo
});

var IconWaveSawTool = createReactComponent("outline", "wave-saw-tool", "IconWaveSawTool", [["path", { "d": "M3 12h5l4 8v-16l4 8h5", "key": "svg-0" }]]);

var IconWaveSawTool$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWaveSawTool
});

var IconWaveSine = createReactComponent("outline", "wave-sine", "IconWaveSine", [["path", { "d": "M21 12h-2c-.894 0 -1.662 -.857 -1.761 -2c-.296 -3.45 -.749 -6 -2.749 -6s-2.5 3.582 -2.5 8s-.5 8 -2.5 8s-2.452 -2.547 -2.749 -6c-.1 -1.147 -.867 -2 -1.763 -2h-2", "key": "svg-0" }]]);

var IconWaveSine$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWaveSine
});

var IconWaveSquare = createReactComponent("outline", "wave-square", "IconWaveSquare", [["path", { "d": "M3 12h5v8h4v-16h4v8h5", "key": "svg-0" }]]);

var IconWaveSquare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWaveSquare
});

var IconWavesElectricity = createReactComponent("outline", "waves-electricity", "IconWavesElectricity", [["path", { "d": "M3 12c.576 -.643 1.512 -1.017 2.5 -1c.988 -.017 1.924 .357 2.5 1c.576 .643 1.512 1.017 2.5 1c.988 .017 1.924 -.357 2.5 -1", "key": "svg-0" }], ["path", { "d": "M3 16c.576 -.643 1.512 -1.017 2.5 -1c.988 -.017 1.924 .357 2.5 1c.576 .643 1.512 1.017 2.5 1c.988 .017 1.924 -.357 2.5 -1", "key": "svg-1" }], ["path", { "d": "M3 8c.576 -.643 1.512 -1.017 2.5 -1c.988 -.017 1.924 .357 2.5 1c.576 .643 1.512 1.017 2.5 1c.988 .017 1.924 -.357 2.5 -1", "key": "svg-2" }], ["path", { "d": "M20 7l-3 5h4l-3 5", "key": "svg-3" }]]);

var IconWavesElectricity$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWavesElectricity
});

var IconWebhookOff = createReactComponent("outline", "webhook-off", "IconWebhookOff", [["path", { "d": "M4.876 13.61a4 4 0 1 0 6.124 3.39h6", "key": "svg-0" }], ["path", { "d": "M15.066 20.502a4 4 0 0 0 4.763 -.675m1.171 -2.827a4 4 0 0 0 -4 -4", "key": "svg-1" }], ["path", { "d": "M16 8a4 4 0 0 0 -6.824 -2.833m-1.176 2.833c0 1.506 .77 2.818 2 3.5l-3 5.5", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconWebhookOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWebhookOff
});

var IconWebhook = createReactComponent("outline", "webhook", "IconWebhook", [["path", { "d": "M4.876 13.61a4 4 0 1 0 6.124 3.39h6", "key": "svg-0" }], ["path", { "d": "M15.066 20.502a4 4 0 1 0 1.934 -7.502c-.706 0 -1.424 .179 -2 .5l-3 -5.5", "key": "svg-1" }], ["path", { "d": "M16 8a4 4 0 1 0 -8 0c0 1.506 .77 2.818 2 3.5l-3 5.5", "key": "svg-2" }]]);

var IconWebhook$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWebhook
});

var IconWeight = createReactComponent("outline", "weight", "IconWeight", [["path", { "d": "M12 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M6.835 9h10.33a1 1 0 0 1 .984 .821l1.637 9a1 1 0 0 1 -.984 1.179h-13.604a1 1 0 0 1 -.984 -1.179l1.637 -9a1 1 0 0 1 .984 -.821z", "key": "svg-1" }]]);

var IconWeight$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWeight
});

var IconWheatOff = createReactComponent("outline", "wheat-off", "IconWheatOff", [["path", { "d": "M3 3l18 18", "key": "svg-0" }], ["path", { "d": "M12 21.5v-3.75", "key": "svg-1" }], ["path", { "d": "M5.916 9.49l-.43 1.604c-.712 2.659 .866 5.392 3.524 6.104c.997 .268 1.994 .535 2.99 .802v-3.44c-.164 -2.105 -1.637 -3.879 -3.677 -4.426l-2.407 -.644z", "key": "svg-2" }], ["path", { "d": "M10.249 4.251c.007 -.007 .014 -.014 .021 -.021l1.73 -1.73", "key": "svg-3" }], ["path", { "d": "M10.27 11.15c-.589 -.589 -1.017 -1.318 -1.246 -2.118", "key": "svg-4" }], ["path", { "d": "M14.988 8.988c.229 -.834 .234 -1.713 .013 -2.549c-.221 -.836 -.659 -1.598 -1.271 -2.209l-1.73 -1.73", "key": "svg-5" }], ["path", { "d": "M16.038 10.037l2.046 -.547l.431 1.604c.142 .53 .193 1.063 .162 1.583", "key": "svg-6" }], ["path", { "d": "M16.506 16.505c-.45 .307 -.959 .544 -1.516 .694c-.997 .268 -1.994 .535 -2.99 .801v-3.44c.055 -.708 .259 -1.379 .582 -1.978", "key": "svg-7" }]]);

var IconWheatOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWheatOff
});

var IconWheat = createReactComponent("outline", "wheat", "IconWheat", [["path", { "d": "M12.014 21.514v-3.75", "key": "svg-0" }], ["path", { "d": "M5.93 9.504l-.43 1.604c-.712 2.659 .866 5.391 3.524 6.105c.997 .268 1.993 .535 2.99 .801v-3.44c-.164 -2.105 -1.637 -3.879 -3.676 -4.426l-2.408 -.644z", "key": "svg-1" }], ["path", { "d": "M13.744 11.164c.454 -.454 .815 -.994 1.061 -1.587c.246 -.594 .372 -1.23 .372 -1.873c0 -.643 -.126 -1.279 -.372 -1.872c-.246 -.594 -.606 -1.133 -1.061 -1.588l-1.73 -1.73l-1.73 1.73c-.454 .454 -.815 .994 -1.06 1.588c-.246 .594 -.372 1.23 -.373 1.872c0 .643 .127 1.279 .373 1.873c.246 .594 .606 1.133 1.06 1.587", "key": "svg-2" }], ["path", { "d": "M18.099 9.504l.43 1.604c.712 2.659 -.866 5.391 -3.525 6.105c-.997 .268 -1.994 .535 -2.99 .801v-3.44c.164 -2.105 1.637 -3.879 3.677 -4.426l2.408 -.644z", "key": "svg-3" }]]);

var IconWheat$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWheat
});

var IconWheel = createReactComponent("outline", "wheel", "IconWheel", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M3 12h6", "key": "svg-2" }], ["path", { "d": "M15 12h6", "key": "svg-3" }], ["path", { "d": "M13.6 9.4l3.4 -4.8", "key": "svg-4" }], ["path", { "d": "M10.4 14.6l-3.4 4.8", "key": "svg-5" }], ["path", { "d": "M7 4.6l3.4 4.8", "key": "svg-6" }], ["path", { "d": "M13.6 14.6l3.4 4.8", "key": "svg-7" }]]);

var IconWheel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWheel
});

var IconWheelchairOff = createReactComponent("outline", "wheelchair-off", "IconWheelchairOff", [["path", { "d": "M8 16m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M17.582 17.59a2 2 0 0 0 2.833 2.824", "key": "svg-1" }], ["path", { "d": "M14 14h-1.4", "key": "svg-2" }], ["path", { "d": "M6 6v5", "key": "svg-3" }], ["path", { "d": "M6 8h2m4 0h5", "key": "svg-4" }], ["path", { "d": "M15 8v3", "key": "svg-5" }], ["path", { "d": "M3 3l18 18", "key": "svg-6" }]]);

var IconWheelchairOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWheelchairOff
});

var IconWheelchair = createReactComponent("outline", "wheelchair", "IconWheelchair", [["path", { "d": "M8 16m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M19 17a3 3 0 0 0 -3 -3h-3.4", "key": "svg-2" }], ["path", { "d": "M3 3h1a2 2 0 0 1 2 2v6", "key": "svg-3" }], ["path", { "d": "M6 8h11", "key": "svg-4" }], ["path", { "d": "M15 8v6", "key": "svg-5" }]]);

var IconWheelchair$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWheelchair
});

var IconWhirl = createReactComponent("outline", "whirl", "IconWhirl", [["path", { "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z", "key": "svg-0" }], ["path", { "d": "M12 21c-3.314 0 -6 -2.462 -6 -5.5s2.686 -5.5 6 -5.5", "key": "svg-1" }], ["path", { "d": "M21 12c0 3.314 -2.462 6 -5.5 6s-5.5 -2.686 -5.5 -6", "key": "svg-2" }], ["path", { "d": "M12 14c3.314 0 6 -2.462 6 -5.5s-2.686 -5.5 -6 -5.5", "key": "svg-3" }], ["path", { "d": "M14 12c0 -3.314 -2.462 -6 -5.5 -6s-5.5 2.686 -5.5 6", "key": "svg-4" }]]);

var IconWhirl$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWhirl
});

var IconWifi0 = createReactComponent("outline", "wifi-0", "IconWifi0", [["path", { "d": "M12 18l.01 0", "key": "svg-0" }]]);

var IconWifi0$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWifi0
});

var IconWifi1 = createReactComponent("outline", "wifi-1", "IconWifi1", [["path", { "d": "M12 18l.01 0", "key": "svg-0" }], ["path", { "d": "M9.172 15.172a4 4 0 0 1 5.656 0", "key": "svg-1" }]]);

var IconWifi1$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWifi1
});

var IconWifi2 = createReactComponent("outline", "wifi-2", "IconWifi2", [["path", { "d": "M12 18l.01 0", "key": "svg-0" }], ["path", { "d": "M9.172 15.172a4 4 0 0 1 5.656 0", "key": "svg-1" }], ["path", { "d": "M6.343 12.343a8 8 0 0 1 11.314 0", "key": "svg-2" }]]);

var IconWifi2$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWifi2
});

var IconWifiOff = createReactComponent("outline", "wifi-off", "IconWifiOff", [["path", { "d": "M12 18l.01 0", "key": "svg-0" }], ["path", { "d": "M9.172 15.172a4 4 0 0 1 5.656 0", "key": "svg-1" }], ["path", { "d": "M6.343 12.343a7.963 7.963 0 0 1 3.864 -2.14m4.163 .155a7.965 7.965 0 0 1 3.287 2", "key": "svg-2" }], ["path", { "d": "M3.515 9.515a12 12 0 0 1 3.544 -2.455m3.101 -.92a12 12 0 0 1 10.325 3.374", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconWifiOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWifiOff
});

var IconWifi = createReactComponent("outline", "wifi", "IconWifi", [["path", { "d": "M12 18l.01 0", "key": "svg-0" }], ["path", { "d": "M9.172 15.172a4 4 0 0 1 5.656 0", "key": "svg-1" }], ["path", { "d": "M6.343 12.343a8 8 0 0 1 11.314 0", "key": "svg-2" }], ["path", { "d": "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0", "key": "svg-3" }]]);

var IconWifi$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWifi
});

var IconWindElectricity = createReactComponent("outline", "wind-electricity", "IconWindElectricity", [["path", { "d": "M20 7l-3 5h4l-3 5", "key": "svg-0" }], ["path", { "d": "M3 16h4a2 2 0 1 1 0 4", "key": "svg-1" }], ["path", { "d": "M3 12h8a2 2 0 1 0 0 -4", "key": "svg-2" }], ["path", { "d": "M3 8h3a2 2 0 1 0 0 -4", "key": "svg-3" }]]);

var IconWindElectricity$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWindElectricity
});

var IconWindOff = createReactComponent("outline", "wind-off", "IconWindOff", [["path", { "d": "M5 8h3m4 0h1.5a2.5 2.5 0 1 0 -2.34 -3.24", "key": "svg-0" }], ["path", { "d": "M3 12h9", "key": "svg-1" }], ["path", { "d": "M16 12h2.5a2.5 2.5 0 0 1 1.801 4.282", "key": "svg-2" }], ["path", { "d": "M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconWindOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWindOff
});

var IconWind = createReactComponent("outline", "wind", "IconWind", [["path", { "d": "M5 8h8.5a2.5 2.5 0 1 0 -2.34 -3.24", "key": "svg-0" }], ["path", { "d": "M3 12h15.5a2.5 2.5 0 1 1 -2.34 3.24", "key": "svg-1" }], ["path", { "d": "M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24", "key": "svg-2" }]]);

var IconWind$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWind
});

var IconWindmillOff = createReactComponent("outline", "windmill-off", "IconWindmillOff", [["path", { "d": "M15.061 11.06c1.18 -.824 1.939 -2.11 1.939 -3.56c0 -2.49 -2.24 -4.5 -5 -4.5v5", "key": "svg-0" }], ["path", { "d": "M12 12c0 2.76 2.01 5 4.5 5c.166 0 .33 -.01 .49 -.03m2.624 -1.36c.856 -.91 1.386 -2.19 1.386 -3.61h-5", "key": "svg-1" }], ["path", { "d": "M12 12c-2.76 0 -5 2.01 -5 4.5s2.24 4.5 5 4.5v-9z", "key": "svg-2" }], ["path", { "d": "M6.981 7.033c-2.244 .285 -3.981 2.402 -3.981 4.967h9", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

var IconWindmillOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWindmillOff
});

var IconWindmill = createReactComponent("outline", "windmill", "IconWindmill", [["path", { "d": "M12 12c2.76 0 5 -2.01 5 -4.5s-2.24 -4.5 -5 -4.5v9z", "key": "svg-0" }], ["path", { "d": "M12 12c0 2.76 2.01 5 4.5 5s4.5 -2.24 4.5 -5h-9z", "key": "svg-1" }], ["path", { "d": "M12 12c-2.76 0 -5 2.01 -5 4.5s2.24 4.5 5 4.5v-9z", "key": "svg-2" }], ["path", { "d": "M12 12c0 -2.76 -2.01 -5 -4.5 -5s-4.5 2.24 -4.5 5h9z", "key": "svg-3" }]]);

var IconWindmill$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWindmill
});

var IconWindowMaximize = createReactComponent("outline", "window-maximize", "IconWindowMaximize", [["path", { "d": "M3 16m0 1a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6", "key": "svg-1" }], ["path", { "d": "M12 8h4v4", "key": "svg-2" }], ["path", { "d": "M16 8l-5 5", "key": "svg-3" }]]);

var IconWindowMaximize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWindowMaximize
});

var IconWindowMinimize = createReactComponent("outline", "window-minimize", "IconWindowMinimize", [["path", { "d": "M3 16m0 1a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6", "key": "svg-1" }], ["path", { "d": "M15 13h-4v-4", "key": "svg-2" }], ["path", { "d": "M11 13l5 -5", "key": "svg-3" }]]);

var IconWindowMinimize$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWindowMinimize
});

var IconWindowOff = createReactComponent("outline", "window-off", "IconWindowOff", [["path", { "d": "M6.166 6.19a6.903 6.903 0 0 0 -1.166 3.81v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-1m0 -4v-5c0 -3.728 -3.134 -7 -7 -7a6.86 6.86 0 0 0 -3.804 1.158", "key": "svg-0" }], ["path", { "d": "M5 13h8m4 0h2", "key": "svg-1" }], ["path", { "d": "M12 3v5m0 4v9", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconWindowOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWindowOff
});

var IconWindow = createReactComponent("outline", "window", "IconWindow", [["path", { "d": "M12 3c-3.866 0 -7 3.272 -7 7v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-10c0 -3.728 -3.134 -7 -7 -7z", "key": "svg-0" }], ["path", { "d": "M5 13l14 0", "key": "svg-1" }], ["path", { "d": "M12 3l0 18", "key": "svg-2" }]]);

var IconWindow$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWindow
});

var IconWindsock = createReactComponent("outline", "windsock", "IconWindsock", [["path", { "d": "M6 3v18", "key": "svg-0" }], ["path", { "d": "M6 11l12 -1v-4l-12 -1", "key": "svg-1" }], ["path", { "d": "M10 5.5v5", "key": "svg-2" }], ["path", { "d": "M14 6v4", "key": "svg-3" }], ["path", { "d": "M4 21h4", "key": "svg-4" }]]);

var IconWindsock$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWindsock
});

var IconWiperWash = createReactComponent("outline", "wiper-wash", "IconWiperWash", [["path", { "d": "M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M3 11l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0", "key": "svg-1" }], ["path", { "d": "M12 20l0 -14", "key": "svg-2" }], ["path", { "d": "M4 6a4 4 0 0 1 .4 -1.8", "key": "svg-3" }], ["path", { "d": "M7 2.1a4 4 0 0 1 2 0", "key": "svg-4" }], ["path", { "d": "M12 6a4 4 0 0 0 -.4 -1.8", "key": "svg-5" }], ["path", { "d": "M12 6a4 4 0 0 1 .4 -1.8", "key": "svg-6" }], ["path", { "d": "M15 2.1a4 4 0 0 1 2 0", "key": "svg-7" }], ["path", { "d": "M20 6a4 4 0 0 0 -.4 -1.8", "key": "svg-8" }]]);

var IconWiperWash$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWiperWash
});

var IconWiper = createReactComponent("outline", "wiper", "IconWiper", [["path", { "d": "M12 18m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M3 9l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0", "key": "svg-1" }], ["path", { "d": "M12 18l-2.2 -12.8", "key": "svg-2" }]]);

var IconWiper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWiper
});

var IconWoman = createReactComponent("outline", "woman", "IconWoman", [["path", { "d": "M10 16v5", "key": "svg-0" }], ["path", { "d": "M14 16v5", "key": "svg-1" }], ["path", { "d": "M8 16h8l-2 -7h-4z", "key": "svg-2" }], ["path", { "d": "M5 11c1.667 -1.333 3.333 -2 5 -2", "key": "svg-3" }], ["path", { "d": "M19 11c-1.667 -1.333 -3.333 -2 -5 -2", "key": "svg-4" }], ["path", { "d": "M12 4m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-5" }]]);

var IconWoman$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWoman
});

var IconWood = createReactComponent("outline", "wood", "IconWood", [["path", { "d": "M12 5.5m-6 0a6 2.5 0 1 0 12 0a6 2.5 0 1 0 -12 0", "key": "svg-0" }], ["path", { "d": "M18 5.5v4.626a1.415 1.415 0 0 1 1.683 2.18l-.097 .108l-1.586 1.586v4c0 1.61 -2.54 2.925 -5.725 3l-.275 0c-3.314 0 -6 -1.343 -6 -3v-2l-1.586 -1.586a1.414 1.414 0 0 1 1.586 -2.287v-6.627", "key": "svg-1" }], ["path", { "d": "M10 12.5v1.5", "key": "svg-2" }], ["path", { "d": "M14 16v1", "key": "svg-3" }]]);

var IconWood$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWood
});

var IconWorldBolt = createReactComponent("outline", "world-bolt", "IconWorldBolt", [["path", { "d": "M20.985 12.52a9 9 0 1 0 -7.52 8.36", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h10.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3c2.313 3.706 3.07 7.856 2.27 12", "key": "svg-4" }], ["path", { "d": "M19 16l-2 3h4l-2 3", "key": "svg-5" }]]);

var IconWorldBolt$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldBolt
});

var IconWorldCancel = createReactComponent("outline", "world-cancel", "IconWorldCancel", [["path", { "d": "M21 12a9 9 0 1 0 -8.985 9", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h9.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.991 16.991 0 0 1 2.53 10.275", "key": "svg-4" }], ["path", { "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-5" }], ["path", { "d": "M17 21l4 -4", "key": "svg-6" }]]);

var IconWorldCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldCancel
});

var IconWorldCheck = createReactComponent("outline", "world-check", "IconWorldCheck", [["path", { "d": "M20.946 12.99a9 9 0 1 0 -9.46 7.995", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h13.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.997 16.997 0 0 1 2.311 12.001", "key": "svg-4" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-5" }]]);

var IconWorldCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldCheck
});

var IconWorldCode = createReactComponent("outline", "world-code", "IconWorldCode", [["path", { "d": "M20.942 13.02a9 9 0 1 0 -9.47 7.964", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h9.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3c2 3.206 2.837 6.913 2.508 10.537", "key": "svg-4" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-5" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-6" }]]);

var IconWorldCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldCode
});

var IconWorldCog = createReactComponent("outline", "world-cog", "IconWorldCog", [["path", { "d": "M21 12a9 9 0 1 0 -8.979 9", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h8.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.992 16.992 0 0 1 2.522 10.376", "key": "svg-4" }], ["path", { "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-5" }], ["path", { "d": "M19.001 15.5v1.5", "key": "svg-6" }], ["path", { "d": "M19.001 21v1.5", "key": "svg-7" }], ["path", { "d": "M22.032 17.25l-1.299 .75", "key": "svg-8" }], ["path", { "d": "M17.27 20l-1.3 .75", "key": "svg-9" }], ["path", { "d": "M15.97 17.25l1.3 .75", "key": "svg-10" }], ["path", { "d": "M20.733 20l1.3 .75", "key": "svg-11" }]]);

var IconWorldCog$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldCog
});

var IconWorldDollar = createReactComponent("outline", "world-dollar", "IconWorldDollar", [["path", { "d": "M20.876 10.51a9 9 0 1 0 -7.839 10.43", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h9.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.986 16.986 0 0 1 2.578 9.02", "key": "svg-4" }], ["path", { "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-5" }], ["path", { "d": "M19 21v1m0 -8v1", "key": "svg-6" }]]);

var IconWorldDollar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldDollar
});

var IconWorldDown = createReactComponent("outline", "world-down", "IconWorldDown", [["path", { "d": "M20.986 12.509a9 9 0 1 0 -8.455 8.476", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h10.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3c2.313 3.706 3.07 7.857 2.27 12", "key": "svg-4" }], ["path", { "d": "M19 16v6", "key": "svg-5" }], ["path", { "d": "M22 19l-3 3l-3 -3", "key": "svg-6" }]]);

var IconWorldDown$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldDown
});

var IconWorldDownload = createReactComponent("outline", "world-download", "IconWorldDownload", [["path", { "d": "M21 12a9 9 0 1 0 -9 9", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h8.4", "key": "svg-2" }], ["path", { "d": "M11.578 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3c1.719 2.755 2.5 5.876 2.5 9", "key": "svg-4" }], ["path", { "d": "M18 14v7m-3 -3l3 3l3 -3", "key": "svg-5" }]]);

var IconWorldDownload$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldDownload
});

var IconWorldExclamation = createReactComponent("outline", "world-exclamation", "IconWorldExclamation", [["path", { "d": "M20.986 12.51a9 9 0 1 0 -5.71 7.873", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h10.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a17 17 0 0 1 0 18", "key": "svg-4" }], ["path", { "d": "M19 16v3", "key": "svg-5" }], ["path", { "d": "M19 22v.01", "key": "svg-6" }]]);

var IconWorldExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldExclamation
});

var IconWorldHeart = createReactComponent("outline", "world-heart", "IconWorldHeart", [["path", { "d": "M21 12a9 9 0 1 0 -9.679 8.974", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h6.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.983 16.983 0 0 1 2.556 8.136", "key": "svg-4" }], ["path", { "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z", "key": "svg-5" }]]);

var IconWorldHeart$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldHeart
});

var IconWorldLatitude = createReactComponent("outline", "world-latitude", "IconWorldLatitude", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M4.6 7l14.8 0", "key": "svg-1" }], ["path", { "d": "M3 12l18 0", "key": "svg-2" }], ["path", { "d": "M4.6 17l14.8 0", "key": "svg-3" }]]);

var IconWorldLatitude$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldLatitude
});

var IconWorldLongitude = createReactComponent("outline", "world-longitude", "IconWorldLongitude", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M11.5 3a11.2 11.2 0 0 0 0 18", "key": "svg-1" }], ["path", { "d": "M12.5 3a11.2 11.2 0 0 1 0 18", "key": "svg-2" }], ["path", { "d": "M12 3l0 18", "key": "svg-3" }]]);

var IconWorldLongitude$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldLongitude
});

var IconWorldMinus = createReactComponent("outline", "world-minus", "IconWorldMinus", [["path", { "d": "M20.483 15.006a9 9 0 1 0 -7.958 5.978", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h16.8", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.94 16.94 0 0 1 2.307 12", "key": "svg-4" }], ["path", { "d": "M16 19h6", "key": "svg-5" }]]);

var IconWorldMinus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldMinus
});

var IconWorldOff = createReactComponent("outline", "world-off", "IconWorldOff", [["path", { "d": "M5.657 5.615a9 9 0 1 0 12.717 12.739m1.672 -2.322a9 9 0 0 0 -12.066 -12.084", "key": "svg-0" }], ["path", { "d": "M3.6 9h5.4m4 0h7.4", "key": "svg-1" }], ["path", { "d": "M3.6 15h11.4m4 0h1.4", "key": "svg-2" }], ["path", { "d": "M11.5 3a17.001 17.001 0 0 0 -1.493 3.022m-.847 3.145c-.68 4.027 .1 8.244 2.34 11.833", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.982 16.982 0 0 1 2.549 8.005m-.207 3.818a16.979 16.979 0 0 1 -2.342 6.177", "key": "svg-4" }], ["path", { "d": "M3 3l18 18", "key": "svg-5" }]]);

var IconWorldOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldOff
});

var IconWorldPause = createReactComponent("outline", "world-pause", "IconWorldPause", [["path", { "d": "M20.945 12.997a9 9 0 1 0 -7.928 7.945", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h9.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.992 16.992 0 0 1 2.51 10.526", "key": "svg-4" }], ["path", { "d": "M17 17v5", "key": "svg-5" }], ["path", { "d": "M21 17v5", "key": "svg-6" }]]);

var IconWorldPause$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldPause
});

var IconWorldPin = createReactComponent("outline", "world-pin", "IconWorldPin", [["path", { "d": "M20.972 11.291a9 9 0 1 0 -8.322 9.686", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h8.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.986 16.986 0 0 1 2.578 9.018", "key": "svg-4" }], ["path", { "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z", "key": "svg-5" }], ["path", { "d": "M19 18v.01", "key": "svg-6" }]]);

var IconWorldPin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldPin
});

var IconWorldPlus = createReactComponent("outline", "world-plus", "IconWorldPlus", [["path", { "d": "M20.985 12.518a9 9 0 1 0 -8.45 8.466", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h11.4", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.998 16.998 0 0 1 2.283 12.157", "key": "svg-4" }], ["path", { "d": "M16 19h6", "key": "svg-5" }], ["path", { "d": "M19 16v6", "key": "svg-6" }]]);

var IconWorldPlus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldPlus
});

var IconWorldQuestion = createReactComponent("outline", "world-question", "IconWorldQuestion", [["path", { "d": "M20.975 11.33a9 9 0 1 0 -5.673 9.043", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h9.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.988 16.988 0 0 1 2.57 9.518m-1.056 5.403a17 17 0 0 1 -1.514 3.079", "key": "svg-4" }], ["path", { "d": "M19 22v.01", "key": "svg-5" }], ["path", { "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483", "key": "svg-6" }]]);

var IconWorldQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldQuestion
});

var IconWorldSearch = createReactComponent("outline", "world-search", "IconWorldSearch", [["path", { "d": "M21 12a9 9 0 1 0 -9 9", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h7.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.984 16.984 0 0 1 2.574 8.62", "key": "svg-4" }], ["path", { "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-5" }], ["path", { "d": "M20.2 20.2l1.8 1.8", "key": "svg-6" }]]);

var IconWorldSearch$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldSearch
});

var IconWorldShare = createReactComponent("outline", "world-share", "IconWorldShare", [["path", { "d": "M20.94 13.045a9 9 0 1 0 -8.953 7.955", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h9.4", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.991 16.991 0 0 1 2.529 10.294", "key": "svg-4" }], ["path", { "d": "M16 22l5 -5", "key": "svg-5" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-6" }]]);

var IconWorldShare$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldShare
});

var IconWorldStar = createReactComponent("outline", "world-star", "IconWorldStar", [["path", { "d": "M21 12a9 9 0 1 0 -9.968 8.948", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h6.4", "key": "svg-2" }], ["path", { "d": "M11.5 3a17.001 17.001 0 0 0 -1.886 13.802", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.982 16.982 0 0 1 2.549 8.01", "key": "svg-4" }], ["path", { "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z", "key": "svg-5" }]]);

var IconWorldStar$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldStar
});

var IconWorldUp = createReactComponent("outline", "world-up", "IconWorldUp", [["path", { "d": "M20.985 12.52a9 9 0 1 0 -8.451 8.463", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h10.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.996 16.996 0 0 1 2.391 11.512", "key": "svg-4" }], ["path", { "d": "M19 22v-6", "key": "svg-5" }], ["path", { "d": "M22 19l-3 -3l-3 3", "key": "svg-6" }]]);

var IconWorldUp$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldUp
});

var IconWorldUpload = createReactComponent("outline", "world-upload", "IconWorldUpload", [["path", { "d": "M21 12a9 9 0 1 0 -9 9", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h8.4", "key": "svg-2" }], ["path", { "d": "M11.578 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3c1.719 2.755 2.5 5.876 2.5 9", "key": "svg-4" }], ["path", { "d": "M18 21v-7m3 3l-3 -3l-3 3", "key": "svg-5" }]]);

var IconWorldUpload$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldUpload
});

var IconWorldWww = createReactComponent("outline", "world-www", "IconWorldWww", [["path", { "d": "M19.5 7a9 9 0 0 0 -7.5 -4a8.991 8.991 0 0 0 -7.484 4", "key": "svg-0" }], ["path", { "d": "M11.5 3a16.989 16.989 0 0 0 -1.826 4", "key": "svg-1" }], ["path", { "d": "M12.5 3a16.989 16.989 0 0 1 1.828 4", "key": "svg-2" }], ["path", { "d": "M19.5 17a9 9 0 0 1 -7.5 4a8.991 8.991 0 0 1 -7.484 -4", "key": "svg-3" }], ["path", { "d": "M11.5 21a16.989 16.989 0 0 1 -1.826 -4", "key": "svg-4" }], ["path", { "d": "M12.5 21a16.989 16.989 0 0 0 1.828 -4", "key": "svg-5" }], ["path", { "d": "M2 10l1 4l1.5 -4l1.5 4l1 -4", "key": "svg-6" }], ["path", { "d": "M17 10l1 4l1.5 -4l1.5 4l1 -4", "key": "svg-7" }], ["path", { "d": "M9.5 10l1 4l1.5 -4l1.5 4l1 -4", "key": "svg-8" }]]);

var IconWorldWww$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldWww
});

var IconWorldX = createReactComponent("outline", "world-x", "IconWorldX", [["path", { "d": "M20.929 13.131a9 9 0 1 0 -8.931 7.869", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h9.9", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a16.992 16.992 0 0 1 2.505 10.573", "key": "svg-4" }], ["path", { "d": "M22 22l-5 -5", "key": "svg-5" }], ["path", { "d": "M17 22l5 -5", "key": "svg-6" }]]);

var IconWorldX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorldX
});

var IconWorld = createReactComponent("outline", "world", "IconWorld", [["path", { "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", "key": "svg-0" }], ["path", { "d": "M3.6 9h16.8", "key": "svg-1" }], ["path", { "d": "M3.6 15h16.8", "key": "svg-2" }], ["path", { "d": "M11.5 3a17 17 0 0 0 0 18", "key": "svg-3" }], ["path", { "d": "M12.5 3a17 17 0 0 1 0 18", "key": "svg-4" }]]);

var IconWorld$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWorld
});

var IconWreckingBall = createReactComponent("outline", "wrecking-ball", "IconWreckingBall", [["path", { "d": "M19 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M4 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M13 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-2" }], ["path", { "d": "M13 19l-9 0", "key": "svg-3" }], ["path", { "d": "M4 15l9 0", "key": "svg-4" }], ["path", { "d": "M8 12v-5h2a3 3 0 0 1 3 3v5", "key": "svg-5" }], ["path", { "d": "M5 15v-2a1 1 0 0 1 1 -1h7", "key": "svg-6" }], ["path", { "d": "M19 11v-7l-6 7", "key": "svg-7" }]]);

var IconWreckingBall$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWreckingBall
});

var IconWritingOff = createReactComponent("outline", "writing-off", "IconWritingOff", [["path", { "d": "M16 7h4", "key": "svg-0" }], ["path", { "d": "M16 16v1l2 2l.5 -.5m1.5 -2.5v-11c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v7", "key": "svg-1" }], ["path", { "d": "M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconWritingOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWritingOff
});

var IconWritingSignOff = createReactComponent("outline", "writing-sign-off", "IconWritingSignOff", [["path", { "d": "M3 19c3.333 -2 5 -4 5 -6c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 2.877 2.5 4c1.5 2 2.5 2.5 3.5 1c.667 -1 1.167 -1.833 1.5 -2.5c1 2.333 2.333 3.5 4 3.5h2.5", "key": "svg-0" }], ["path", { "d": "M16 16v1l2 2l.5 -.5m1.5 -2.5v-11c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v7", "key": "svg-1" }], ["path", { "d": "M16 7h4", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

var IconWritingSignOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWritingSignOff
});

var IconWritingSign = createReactComponent("outline", "writing-sign", "IconWritingSign", [["path", { "d": "M3 19c3.333 -2 5 -4 5 -6c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 2.877 2.5 4c1.5 2 2.5 2.5 3.5 1c.667 -1 1.167 -1.833 1.5 -2.5c1 2.333 2.333 3.5 4 3.5h2.5", "key": "svg-0" }], ["path", { "d": "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z", "key": "svg-1" }], ["path", { "d": "M16 7h4", "key": "svg-2" }]]);

var IconWritingSign$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWritingSign
});

var IconWriting = createReactComponent("outline", "writing", "IconWriting", [["path", { "d": "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z", "key": "svg-0" }], ["path", { "d": "M16 7h4", "key": "svg-1" }], ["path", { "d": "M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3", "key": "svg-2" }]]);

var IconWriting$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWriting
});

var IconXPowerY = createReactComponent("outline", "x-power-y", "IconXPowerY", [["path", { "d": "M15 3l3 5.063", "key": "svg-0" }], ["path", { "d": "M5 12l6 6", "key": "svg-1" }], ["path", { "d": "M5 18l6 -6", "key": "svg-2" }], ["path", { "d": "M21 3l-4.8 9", "key": "svg-3" }]]);

var IconXPowerY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconXPowerY
});

var IconX = createReactComponent("outline", "x", "IconX", [["path", { "d": "M18 6l-12 12", "key": "svg-0" }], ["path", { "d": "M6 6l12 12", "key": "svg-1" }]]);

var IconX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconX
});

var IconXboxA = createReactComponent("outline", "xbox-a", "IconXboxA", [["path", { "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z", "key": "svg-0" }], ["path", { "d": "M15 16l-3 -8l-3 8", "key": "svg-1" }], ["path", { "d": "M14 14h-4", "key": "svg-2" }]]);

var IconXboxA$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconXboxA
});

var IconXboxB = createReactComponent("outline", "xbox-b", "IconXboxB", [["path", { "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z", "key": "svg-0" }], ["path", { "d": "M13 12a2 2 0 1 1 0 4h-3v-4", "key": "svg-1" }], ["path", { "d": "M13 12h-3", "key": "svg-2" }], ["path", { "d": "M13 12a2 2 0 1 0 0 -4h-3v4", "key": "svg-3" }]]);

var IconXboxB$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconXboxB
});

var IconXboxX = createReactComponent("outline", "xbox-x", "IconXboxX", [["path", { "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z", "key": "svg-0" }], ["path", { "d": "M9 8l6 8", "key": "svg-1" }], ["path", { "d": "M15 8l-6 8", "key": "svg-2" }]]);

var IconXboxX$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconXboxX
});

var IconXboxY = createReactComponent("outline", "xbox-y", "IconXboxY", [["path", { "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z", "key": "svg-0" }], ["path", { "d": "M9 8l3 4", "key": "svg-1" }], ["path", { "d": "M15 8l-2.988 3.984l-.012 4.016", "key": "svg-2" }]]);

var IconXboxY$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconXboxY
});

var IconXd = createReactComponent("outline", "xd", "IconXd", [["path", { "d": "M6 8l4 8", "key": "svg-0" }], ["path", { "d": "M6 16l4 -8", "key": "svg-1" }], ["path", { "d": "M14 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", "key": "svg-2" }]]);

var IconXd$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconXd
});

var IconXxx = createReactComponent("outline", "xxx", "IconXxx", [["path", { "d": "M10 8l4 8", "key": "svg-0" }], ["path", { "d": "M10 16l4 -8", "key": "svg-1" }], ["path", { "d": "M17 8l4 8", "key": "svg-2" }], ["path", { "d": "M17 16l4 -8", "key": "svg-3" }], ["path", { "d": "M3 8l4 8", "key": "svg-4" }], ["path", { "d": "M3 16l4 -8", "key": "svg-5" }]]);

var IconXxx$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconXxx
});

var IconYinYang = createReactComponent("outline", "yin-yang", "IconYinYang", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 3a4.5 4.5 0 0 0 0 9a4.5 4.5 0 0 1 0 9", "key": "svg-1" }], ["circle", { "cx": "12", "cy": "7.5", "r": ".5", "fill": "currentColor", "key": "svg-2" }], ["circle", { "cx": "12", "cy": "16.5", "r": ".5", "fill": "currentColor", "key": "svg-3" }]]);

var IconYinYang$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconYinYang
});

var IconYoga = createReactComponent("outline", "yoga", "IconYoga", [["path", { "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M4 20h4l1.5 -3", "key": "svg-1" }], ["path", { "d": "M17 20l-1 -5h-5l1 -7", "key": "svg-2" }], ["path", { "d": "M4 10l4 -1l4 -1l4 1.5l4 1.5", "key": "svg-3" }]]);

var IconYoga$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconYoga
});

var IconZeppelinOff = createReactComponent("outline", "zeppelin-off", "IconZeppelinOff", [["path", { "d": "M15.773 15.783c-.723 .141 -1.486 .217 -2.273 .217c-2.13 0 -4.584 -.926 -7.364 -2.777l-2.136 1.777v-3.33a46.07 46.07 0 0 1 -2 -1.67a46.07 46.07 0 0 1 2 -1.67v-3.33l2.135 1.778c.13 -.087 .261 -.172 .39 -.256m2.564 -1.42c1.601 -.735 3.071 -1.102 4.411 -1.102c4.694 0 8.5 2.686 8.5 6c0 1.919 -1.276 3.627 -3.261 4.725", "key": "svg-0" }], ["path", { "d": "M10 15.5v4.5h6v-4", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconZeppelinOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZeppelinOff
});

var IconZeppelin = createReactComponent("outline", "zeppelin", "IconZeppelin", [["path", { "d": "M13.5 4c4.694 0 8.5 2.686 8.5 6s-3.806 6 -8.5 6c-2.13 0 -4.584 -.926 -7.364 -2.777l-2.136 1.777v-3.33a46.07 46.07 0 0 1 -2 -1.67a46.07 46.07 0 0 1 2 -1.67v-3.33l2.135 1.778c2.78 -1.852 5.235 -2.778 7.365 -2.778z", "key": "svg-0" }], ["path", { "d": "M10 15.5v4.5h6v-4", "key": "svg-1" }]]);

var IconZeppelin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZeppelin
});

var IconZip = createReactComponent("outline", "zip", "IconZip", [["path", { "d": "M16 16v-8h2a2 2 0 1 1 0 4h-2", "key": "svg-0" }], ["path", { "d": "M12 8v8", "key": "svg-1" }], ["path", { "d": "M4 8h4l-4 8h4", "key": "svg-2" }]]);

var IconZip$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZip
});

var IconZodiacAquarius = createReactComponent("outline", "zodiac-aquarius", "IconZodiacAquarius", [["path", { "d": "M3 10l3 -3l3 3l3 -3l3 3l3 -3l3 3", "key": "svg-0" }], ["path", { "d": "M3 17l3 -3l3 3l3 -3l3 3l3 -3l3 3", "key": "svg-1" }]]);

var IconZodiacAquarius$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZodiacAquarius
});

var IconZodiacAries = createReactComponent("outline", "zodiac-aries", "IconZodiacAries", [["path", { "d": "M12 5a5 5 0 1 0 -4 8", "key": "svg-0" }], ["path", { "d": "M16 13a5 5 0 1 0 -4 -8", "key": "svg-1" }], ["path", { "d": "M12 21l0 -16", "key": "svg-2" }]]);

var IconZodiacAries$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZodiacAries
});

var IconZodiacCancer = createReactComponent("outline", "zodiac-cancer", "IconZodiacCancer", [["path", { "d": "M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M18 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M3 12a10 6.5 0 0 1 14 -6.5", "key": "svg-2" }], ["path", { "d": "M21 12a10 6.5 0 0 1 -14 6.5", "key": "svg-3" }]]);

var IconZodiacCancer$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZodiacCancer
});

var IconZodiacCapricorn = createReactComponent("outline", "zodiac-capricorn", "IconZodiacCapricorn", [["path", { "d": "M4 4a3 3 0 0 1 3 3v9", "key": "svg-0" }], ["path", { "d": "M7 7a3 3 0 0 1 6 0v11a3 3 0 0 1 -3 3", "key": "svg-1" }], ["path", { "d": "M16 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-2" }]]);

var IconZodiacCapricorn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZodiacCapricorn
});

var IconZodiacGemini = createReactComponent("outline", "zodiac-gemini", "IconZodiacGemini", [["path", { "d": "M3 3a21 21 0 0 0 18 0", "key": "svg-0" }], ["path", { "d": "M3 21a21 21 0 0 1 18 0", "key": "svg-1" }], ["path", { "d": "M7 4.5l0 15", "key": "svg-2" }], ["path", { "d": "M17 4.5l0 15", "key": "svg-3" }]]);

var IconZodiacGemini$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZodiacGemini
});

var IconZodiacLeo = createReactComponent("outline", "zodiac-leo", "IconZodiacLeo", [["path", { "d": "M13 17a4 4 0 1 0 8 0", "key": "svg-0" }], ["path", { "d": "M6 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M11 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "key": "svg-2" }], ["path", { "d": "M7 7c0 3 2 5 2 9", "key": "svg-3" }], ["path", { "d": "M15 7c0 4 -2 6 -2 10", "key": "svg-4" }]]);

var IconZodiacLeo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZodiacLeo
});

var IconZodiacLibra = createReactComponent("outline", "zodiac-libra", "IconZodiacLibra", [["path", { "d": "M5 20l14 0", "key": "svg-0" }], ["path", { "d": "M5 17h5v-.3a7 7 0 1 1 4 0v.3h5", "key": "svg-1" }]]);

var IconZodiacLibra$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZodiacLibra
});

var IconZodiacPisces = createReactComponent("outline", "zodiac-pisces", "IconZodiacPisces", [["path", { "d": "M5 3a21 21 0 0 1 0 18", "key": "svg-0" }], ["path", { "d": "M19 3a21 21 0 0 0 0 18", "key": "svg-1" }], ["path", { "d": "M5 12l14 0", "key": "svg-2" }]]);

var IconZodiacPisces$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZodiacPisces
});

var IconZodiacSagittarius = createReactComponent("outline", "zodiac-sagittarius", "IconZodiacSagittarius", [["path", { "d": "M4 20l16 -16", "key": "svg-0" }], ["path", { "d": "M13 4h7v7", "key": "svg-1" }], ["path", { "d": "M6.5 12.5l5 5", "key": "svg-2" }]]);

var IconZodiacSagittarius$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZodiacSagittarius
});

var IconZodiacScorpio = createReactComponent("outline", "zodiac-scorpio", "IconZodiacScorpio", [["path", { "d": "M3 4a2 2 0 0 1 2 2v9", "key": "svg-0" }], ["path", { "d": "M5 6a2 2 0 0 1 4 0v9", "key": "svg-1" }], ["path", { "d": "M9 6a2 2 0 0 1 4 0v10a3 3 0 0 0 3 3h5l-3 -3m0 6l3 -3", "key": "svg-2" }]]);

var IconZodiacScorpio$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZodiacScorpio
});

var IconZodiacTaurus = createReactComponent("outline", "zodiac-taurus", "IconZodiacTaurus", [["path", { "d": "M6 3a6 6 0 0 0 12 0", "key": "svg-0" }], ["path", { "d": "M12 15m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", "key": "svg-1" }]]);

var IconZodiacTaurus$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZodiacTaurus
});

var IconZodiacVirgo = createReactComponent("outline", "zodiac-virgo", "IconZodiacVirgo", [["path", { "d": "M3 4a2 2 0 0 1 2 2v9", "key": "svg-0" }], ["path", { "d": "M5 6a2 2 0 0 1 4 0v9", "key": "svg-1" }], ["path", { "d": "M9 6a2 2 0 0 1 4 0v10a7 5 0 0 0 7 5", "key": "svg-2" }], ["path", { "d": "M12 21a7 5 0 0 0 7 -5v-2a3 3 0 0 0 -6 0", "key": "svg-3" }]]);

var IconZodiacVirgo$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZodiacVirgo
});

var IconZoomCancel = createReactComponent("outline", "zoom-cancel", "IconZoomCancel", [["path", { "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M8 8l4 4", "key": "svg-1" }], ["path", { "d": "M12 8l-4 4", "key": "svg-2" }], ["path", { "d": "M21 21l-6 -6", "key": "svg-3" }]]);

var IconZoomCancel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomCancel
});

var IconZoomCheck = createReactComponent("outline", "zoom-check", "IconZoomCheck", [["path", { "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M21 21l-6 -6", "key": "svg-1" }], ["path", { "d": "M7 10l2 2l4 -4", "key": "svg-2" }]]);

var IconZoomCheck$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomCheck
});

var IconZoomCode = createReactComponent("outline", "zoom-code", "IconZoomCode", [["path", { "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M21 21l-6 -6", "key": "svg-1" }], ["path", { "d": "M8 8l-2 2l2 2", "key": "svg-2" }], ["path", { "d": "M12 8l2 2l-2 2", "key": "svg-3" }]]);

var IconZoomCode$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomCode
});

var IconZoomExclamation = createReactComponent("outline", "zoom-exclamation", "IconZoomExclamation", [["path", { "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M21 21l-6 -6", "key": "svg-1" }], ["path", { "d": "M10 13v.01", "key": "svg-2" }], ["path", { "d": "M10 7v3", "key": "svg-3" }]]);

var IconZoomExclamation$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomExclamation
});

var IconZoomInArea = createReactComponent("outline", "zoom-in-area", "IconZoomInArea", [["path", { "d": "M15 13v4", "key": "svg-0" }], ["path", { "d": "M13 15h4", "key": "svg-1" }], ["path", { "d": "M15 15m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-2" }], ["path", { "d": "M22 22l-3 -3", "key": "svg-3" }], ["path", { "d": "M6 18h-1a2 2 0 0 1 -2 -2v-1", "key": "svg-4" }], ["path", { "d": "M3 11v-1", "key": "svg-5" }], ["path", { "d": "M3 6v-1a2 2 0 0 1 2 -2h1", "key": "svg-6" }], ["path", { "d": "M10 3h1", "key": "svg-7" }], ["path", { "d": "M15 3h1a2 2 0 0 1 2 2v1", "key": "svg-8" }]]);

var IconZoomInArea$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomInArea
});

var IconZoomIn = createReactComponent("outline", "zoom-in", "IconZoomIn", [["path", { "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M7 10l6 0", "key": "svg-1" }], ["path", { "d": "M10 7l0 6", "key": "svg-2" }], ["path", { "d": "M21 21l-6 -6", "key": "svg-3" }]]);

var IconZoomIn$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomIn
});

var IconZoomMoney = createReactComponent("outline", "zoom-money", "IconZoomMoney", [["path", { "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M21 21l-6 -6", "key": "svg-1" }], ["path", { "d": "M12 7h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5", "key": "svg-2" }], ["path", { "d": "M10 13v1m0 -8v1", "key": "svg-3" }]]);

var IconZoomMoney$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomMoney
});

var IconZoomOutArea = createReactComponent("outline", "zoom-out-area", "IconZoomOutArea", [["path", { "d": "M13 15h4", "key": "svg-0" }], ["path", { "d": "M15 15m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-1" }], ["path", { "d": "M22 22l-3 -3", "key": "svg-2" }], ["path", { "d": "M6 18h-1a2 2 0 0 1 -2 -2v-1", "key": "svg-3" }], ["path", { "d": "M3 11v-1", "key": "svg-4" }], ["path", { "d": "M3 6v-1a2 2 0 0 1 2 -2h1", "key": "svg-5" }], ["path", { "d": "M10 3h1", "key": "svg-6" }], ["path", { "d": "M15 3h1a2 2 0 0 1 2 2v1", "key": "svg-7" }]]);

var IconZoomOutArea$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomOutArea
});

var IconZoomOut = createReactComponent("outline", "zoom-out", "IconZoomOut", [["path", { "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M7 10l6 0", "key": "svg-1" }], ["path", { "d": "M21 21l-6 -6", "key": "svg-2" }]]);

var IconZoomOut$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomOut
});

var IconZoomPan = createReactComponent("outline", "zoom-pan", "IconZoomPan", [["path", { "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 17l-2.5 -2.5", "key": "svg-1" }], ["path", { "d": "M10 4l2 -2l2 2", "key": "svg-2" }], ["path", { "d": "M20 10l2 2l-2 2", "key": "svg-3" }], ["path", { "d": "M4 10l-2 2l2 2", "key": "svg-4" }], ["path", { "d": "M10 20l2 2l2 -2", "key": "svg-5" }]]);

var IconZoomPan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomPan
});

var IconZoomQuestion = createReactComponent("outline", "zoom-question", "IconZoomQuestion", [["path", { "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M21 21l-6 -6", "key": "svg-1" }], ["path", { "d": "M10 13l0 .01", "key": "svg-2" }], ["path", { "d": "M10 10a1.5 1.5 0 1 0 -1.14 -2.474", "key": "svg-3" }]]);

var IconZoomQuestion$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomQuestion
});

var IconZoomReplace = createReactComponent("outline", "zoom-replace", "IconZoomReplace", [["path", { "d": "M21 21l-6 -6", "key": "svg-0" }], ["path", { "d": "M3.291 8a7 7 0 0 1 5.077 -4.806a7.021 7.021 0 0 1 8.242 4.403", "key": "svg-1" }], ["path", { "d": "M17 4v4h-4", "key": "svg-2" }], ["path", { "d": "M16.705 12a7 7 0 0 1 -5.074 4.798a7.021 7.021 0 0 1 -8.241 -4.403", "key": "svg-3" }], ["path", { "d": "M3 16v-4h4", "key": "svg-4" }]]);

var IconZoomReplace$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomReplace
});

var IconZoomReset = createReactComponent("outline", "zoom-reset", "IconZoomReset", [["path", { "d": "M21 21l-6 -6", "key": "svg-0" }], ["path", { "d": "M3.268 12.043a7.017 7.017 0 0 0 6.634 4.957a7.012 7.012 0 0 0 7.043 -6.131a7 7 0 0 0 -5.314 -7.672a7.021 7.021 0 0 0 -8.241 4.403", "key": "svg-1" }], ["path", { "d": "M3 4v4h4", "key": "svg-2" }]]);

var IconZoomReset$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomReset
});

var IconZoomScan = createReactComponent("outline", "zoom-scan", "IconZoomScan", [["path", { "d": "M4 8v-2a2 2 0 0 1 2 -2h2", "key": "svg-0" }], ["path", { "d": "M4 16v2a2 2 0 0 0 2 2h2", "key": "svg-1" }], ["path", { "d": "M16 4h2a2 2 0 0 1 2 2v2", "key": "svg-2" }], ["path", { "d": "M16 20h2a2 2 0 0 0 2 -2v-2", "key": "svg-3" }], ["path", { "d": "M8 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-4" }], ["path", { "d": "M16 16l-2.5 -2.5", "key": "svg-5" }]]);

var IconZoomScan$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomScan
});

var IconZoom = createReactComponent("outline", "zoom", "IconZoom", [["path", { "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", "key": "svg-0" }], ["path", { "d": "M21 21l-6 -6", "key": "svg-1" }]]);

var IconZoom$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoom
});

var IconZzzOff = createReactComponent("outline", "zzz-off", "IconZzzOff", [["path", { "d": "M4 12h6l-6 8h6", "key": "svg-0" }], ["path", { "d": "M14 4h6l-5.146 6.862m1.146 1.138h4", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

var IconZzzOff$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZzzOff
});

var IconZzz = createReactComponent("outline", "zzz", "IconZzz", [["path", { "d": "M4 12h6l-6 8h6", "key": "svg-0" }], ["path", { "d": "M14 4h6l-6 8h6", "key": "svg-1" }]]);

var IconZzz$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZzz
});

var IconAccessibleFilled = createReactComponent("filled", "accessible-filled", "IconAccessibleFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.051 6.844a1 1 0 0 0 -1.152 -.663l-.113 .03l-2.684 .895l-2.684 -.895l-.113 -.03a1 1 0 0 0 -.628 1.884l.109 .044l2.316 .771v.976l-1.832 2.75l-.06 .1a1 1 0 0 0 .237 1.21l.1 .076l.101 .06a1 1 0 0 0 1.21 -.237l.076 -.1l1.168 -1.752l1.168 1.752l.07 .093a1 1 0 0 0 1.653 -1.102l-.059 -.1l-1.832 -2.75v-.977l2.316 -.771l.109 -.044a1 1 0 0 0 .524 -1.221zm-3.949 -4.184a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z", "key": "svg-0" }]]);

var IconAccessibleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAccessibleFilled
});

var IconAdCircleFilled = createReactComponent("filled", "ad-circle-filled", "IconAdCircleFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10c-5.43 0 -9.848 -4.327 -9.996 -9.72l-.004 -.28l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm-3.5 6a2.5 2.5 0 0 0 -2.495 2.336l-.005 .164v4.5l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-1h1v1l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4.5l-.005 -.164a2.5 2.5 0 0 0 -2.495 -2.336zm6.5 0h-1a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h1a3 3 0 0 0 3 -3v-2a3 3 0 0 0 -3 -3zm0 2a1 1 0 0 1 1 1v2a1 1 0 0 1 -.883 .993l-.117 .007v-4zm-6.5 0a.5 .5 0 0 1 .492 .41l.008 .09v1.5h-1v-1.5l.008 -.09a.5 .5 0 0 1 .492 -.41z", "key": "svg-0" }]]);

var IconAdCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdCircleFilled
});

var IconAdFilled = createReactComponent("filled", "ad-filled", "IconAdFilled", [["path", { "d": "M19 4h-14a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3zm-10 4a3 3 0 0 1 2.995 2.824l.005 .176v4a1 1 0 0 1 -1.993 .117l-.007 -.117v-1h-2v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-4a3 3 0 0 1 3 -3zm0 2a1 1 0 0 0 -.993 .883l-.007 .117v1h2v-1a1 1 0 0 0 -1 -1zm8 -2a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -.883 .993l-.117 .007h-1.5a2.5 2.5 0 1 1 .326 -4.979l.174 .029v-2.05a1 1 0 0 1 .883 -.993l.117 -.007zm-1.41 5.008l-.09 -.008a.5 .5 0 0 0 -.09 .992l.09 .008h.5v-.5l-.008 -.09a.5 .5 0 0 0 -.318 -.379l-.084 -.023z", "key": "svg-0" }]]);

var IconAdFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdFilled
});

var IconAdjustmentsFilled = createReactComponent("filled", "adjustments-filled", "IconAdjustmentsFilled", [["path", { "d": "M6 3a1 1 0 0 1 .993 .883l.007 .117v3.171a3.001 3.001 0 0 1 0 5.658v7.171a1 1 0 0 1 -1.993 .117l-.007 -.117v-7.17a3.002 3.002 0 0 1 -1.995 -2.654l-.005 -.176l.005 -.176a3.002 3.002 0 0 1 1.995 -2.654v-3.17a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M12 3a1 1 0 0 1 .993 .883l.007 .117v9.171a3.001 3.001 0 0 1 0 5.658v1.171a1 1 0 0 1 -1.993 .117l-.007 -.117v-1.17a3.002 3.002 0 0 1 -1.995 -2.654l-.005 -.176l.005 -.176a3.002 3.002 0 0 1 1.995 -2.654v-9.17a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M18 3a1 1 0 0 1 .993 .883l.007 .117v.171a3.001 3.001 0 0 1 0 5.658v10.171a1 1 0 0 1 -1.993 .117l-.007 -.117v-10.17a3.002 3.002 0 0 1 -1.995 -2.654l-.005 -.176l.005 -.176a3.002 3.002 0 0 1 1.995 -2.654v-.17a1 1 0 0 1 1 -1z", "key": "svg-2" }]]);

var IconAdjustmentsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAdjustmentsFilled
});

var IconAerialLiftFilled = createReactComponent("filled", "aerial-lift-filled", "IconAerialLiftFilled", [["path", { "d": "M19.876 2.008a1 1 0 1 1 .248 1.984l-7.124 .891v2.117h4.2a1 1 0 0 1 .688 .274l.087 .093c2.79 3.417 2.717 9.963 -.226 13.295a1 1 0 0 1 -.749 .338h-10.106a1 1 0 0 1 -.763 -.353c-2.86 -3.373 -2.86 -9.92 0 -13.294a1 1 0 0 1 .763 -.353h4.106v-1.867l-6.876 .86a1 1 0 0 1 -1.095 -.754l-.021 -.115a1 1 0 0 1 .868 -1.116l7.996 -1l.011 -.001l.008 -.001zm-8.876 6.992h-3.617l-.051 .072c-.718 1.042 -1.149 2.41 -1.292 3.844l-.008 .084h4.968zm5.698 0h-3.698v4h4.979l-.005 -.072c-.123 -1.436 -.533 -2.811 -1.232 -3.864z", "key": "svg-0" }]]);

var IconAerialLiftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAerialLiftFilled
});

var IconAffiliateFilled = createReactComponent("filled", "affiliate-filled", "IconAffiliateFilled", [["path", { "d": "M18.5 3a2.5 2.5 0 1 1 -.912 4.828l-4.556 4.555a5.475 5.475 0 0 1 .936 3.714l2.624 .787a2.5 2.5 0 1 1 -.575 1.916l-2.623 -.788a5.5 5.5 0 0 1 -10.39 -2.29l-.004 -.222l.004 -.221a5.5 5.5 0 0 1 2.984 -4.673l-.788 -2.624a2.498 2.498 0 0 1 -2.194 -2.304l-.006 -.178l.005 -.164a2.5 2.5 0 1 1 4.111 2.071l.787 2.625a5.475 5.475 0 0 1 3.714 .936l4.555 -4.556a2.487 2.487 0 0 1 -.167 -.748l-.005 -.164l.005 -.164a2.5 2.5 0 0 1 2.495 -2.336z", "key": "svg-0" }]]);

var IconAffiliateFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAffiliateFilled
});

var IconAirBalloonFilled = createReactComponent("filled", "air-balloon-filled", "IconAirBalloonFilled", [["path", { "d": "M13 18a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2v-1a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M12 1a7 7 0 0 1 7 7c0 4.185 -3.297 9 -7 9s-7 -4.815 -7 -9a7 7 0 0 1 7 -7", "key": "svg-1" }]]);

var IconAirBalloonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAirBalloonFilled
});

var IconAlarmMinusFilled = createReactComponent("filled", "alarm-minus-filled", "IconAlarmMinusFilled", [["path", { "d": "M16 6.072a8 8 0 1 1 -11.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-2 5.928h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }], ["path", { "d": "M6.412 3.191a1 1 0 0 1 1.273 1.539l-.097 .08l-2.75 2a1 1 0 0 1 -1.273 -1.54l.097 -.08l2.75 -2z", "key": "svg-1" }], ["path", { "d": "M16.191 3.412a1 1 0 0 1 1.291 -.288l.106 .067l2.75 2a1 1 0 0 1 -1.07 1.685l-.106 -.067l-2.75 -2a1 1 0 0 1 -.22 -1.397z", "key": "svg-2" }]]);

var IconAlarmMinusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlarmMinusFilled
});

var IconAlarmPlusFilled = createReactComponent("filled", "alarm-plus-filled", "IconAlarmPlusFilled", [["path", { "d": "M16 6.072a8 8 0 1 1 -11.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-4 3.928a1 1 0 0 0 -1 1v1h-1l-.117 .007a1 1 0 0 0 .117 1.993h1v1l.007 .117a1 1 0 0 0 1.993 -.117v-1h1l.117 -.007a1 1 0 0 0 -.117 -1.993h-1v-1l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }], ["path", { "d": "M6.412 3.191a1 1 0 0 1 1.273 1.539l-.097 .08l-2.75 2a1 1 0 0 1 -1.273 -1.54l.097 -.08l2.75 -2z", "key": "svg-1" }], ["path", { "d": "M16.191 3.412a1 1 0 0 1 1.291 -.288l.106 .067l2.75 2a1 1 0 0 1 -1.07 1.685l-.106 -.067l-2.75 -2a1 1 0 0 1 -.22 -1.397z", "key": "svg-2" }]]);

var IconAlarmPlusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlarmPlusFilled
});

var IconAlarmSnoozeFilled = createReactComponent("filled", "alarm-snooze-filled", "IconAlarmSnoozeFilled", [["path", { "d": "M16 6.072a8 8 0 1 1 -11.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-2 3.928h-4l-.117 .007a1 1 0 0 0 -.883 .993l.007 .117a1 1 0 0 0 .993 .883h1.584l-2.291 2.293l-.076 .084c-.514 .637 -.07 1.623 .783 1.623h4l.117 -.007a1 1 0 0 0 .883 -.993l-.007 -.117a1 1 0 0 0 -.993 -.883h-1.586l2.293 -2.293l.076 -.084c.514 -.637 .07 -1.623 -.783 -1.623z", "key": "svg-0" }], ["path", { "d": "M6.412 3.191a1 1 0 0 1 1.273 1.539l-.097 .08l-2.75 2a1 1 0 0 1 -1.273 -1.54l.097 -.08l2.75 -2z", "key": "svg-1" }], ["path", { "d": "M16.191 3.412a1 1 0 0 1 1.291 -.288l.106 .067l2.75 2a1 1 0 0 1 -1.07 1.685l-.106 -.067l-2.75 -2a1 1 0 0 1 -.22 -1.397z", "key": "svg-2" }]]);

var IconAlarmSnoozeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlarmSnoozeFilled
});

var IconAlarmFilled = createReactComponent("filled", "alarm-filled", "IconAlarmFilled", [["path", { "d": "M16 6.072a8 8 0 1 1 -11.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-4 2.928a1 1 0 0 0 -1 1v3l.007 .117a1 1 0 0 0 .993 .883h2l.117 -.007a1 1 0 0 0 .883 -.993l-.007 -.117a1 1 0 0 0 -.993 -.883h-1v-2l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }], ["path", { "d": "M6.412 3.191a1 1 0 0 1 1.273 1.539l-.097 .08l-2.75 2a1 1 0 0 1 -1.273 -1.54l.097 -.08l2.75 -2z", "key": "svg-1" }], ["path", { "d": "M16.191 3.412a1 1 0 0 1 1.291 -.288l.106 .067l2.75 2a1 1 0 0 1 -1.07 1.685l-.106 -.067l-2.75 -2a1 1 0 0 1 -.22 -1.397z", "key": "svg-2" }]]);

var IconAlarmFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlarmFilled
});

var IconAlertCircleFilled = createReactComponent("filled", "alert-circle-filled", "IconAlertCircleFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconAlertCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertCircleFilled
});

var IconAlertHexagonFilled = createReactComponent("filled", "alert-hexagon-filled", "IconAlertHexagonFilled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.026 -.097l.19 .097l6.775 3.995l.096 .063l.092 .077l.107 .075a3.224 3.224 0 0 1 1.266 2.188l.018 .202l.005 .204v7.284c0 1.106 -.57 2.129 -1.454 2.693l-.17 .1l-6.803 4.302c-.918 .504 -2.019 .535 -3.004 .068l-.196 -.1l-6.695 -4.237a3.225 3.225 0 0 1 -1.671 -2.619l-.007 -.207v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098zm1.585 13.586l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconAlertHexagonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertHexagonFilled
});

var IconAlertOctagonFilled = createReactComponent("filled", "alert-octagon-filled", "IconAlertOctagonFilled", [["path", { "d": "M14.897 1a4 4 0 0 1 2.664 1.016l.165 .156l4.1 4.1a4 4 0 0 1 1.168 2.605l.006 .227v5.794a4 4 0 0 1 -1.016 2.664l-.156 .165l-4.1 4.1a4 4 0 0 1 -2.603 1.168l-.227 .006h-5.795a3.999 3.999 0 0 1 -2.664 -1.017l-.165 -.156l-4.1 -4.1a4 4 0 0 1 -1.168 -2.604l-.006 -.227v-5.794a4 4 0 0 1 1.016 -2.664l.156 -.165l4.1 -4.1a4 4 0 0 1 2.605 -1.168l.227 -.006h5.793zm-2.887 14l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconAlertOctagonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertOctagonFilled
});

var IconAlertSquareRoundedFilled = createReactComponent("filled", "alert-square-rounded-filled", "IconAlertSquareRoundedFilled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconAlertSquareRoundedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertSquareRoundedFilled
});

var IconAlertSquareFilled = createReactComponent("filled", "alert-square-filled", "IconAlertSquareFilled", [["path", { "d": "M19 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h14zm-6.99 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconAlertSquareFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertSquareFilled
});

var IconAlertTriangleFilled = createReactComponent("filled", "alert-triangle-filled", "IconAlertTriangleFilled", [["path", { "d": "M12 1.67c.955 0 1.845 .467 2.39 1.247l.105 .16l8.114 13.548a2.914 2.914 0 0 1 -2.307 4.363l-.195 .008h-16.225a2.914 2.914 0 0 1 -2.582 -4.2l.099 -.185l8.11 -13.538a2.914 2.914 0 0 1 2.491 -1.403zm.01 13.33l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -7a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconAlertTriangleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlertTriangleFilled
});

var IconAlienFilled = createReactComponent("filled", "alien-filled", "IconAlienFilled", [["path", { "d": "M12.004 2c4.942 0 8.288 2.503 8.85 6.444a12.884 12.884 0 0 1 -2.163 9.308a11.794 11.794 0 0 1 -3.51 3.356c-1.982 1.19 -4.376 1.19 -6.373 -.008a11.763 11.763 0 0 1 -3.489 -3.34a12.808 12.808 0 0 1 -2.171 -9.306c.564 -3.95 3.91 -6.454 8.856 -6.454zm1.913 14.6a1 1 0 0 0 -1.317 -.517l-.146 .055a1.5 1.5 0 0 1 -1.054 -.055l-.11 -.04a1 1 0 0 0 -.69 1.874a3.5 3.5 0 0 0 2.8 0a1 1 0 0 0 .517 -1.317zm-5.304 -6.39a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -1.497l-2 -2zm8.094 .083a1 1 0 0 0 -1.414 0l-2 2l-.083 .094a1 1 0 0 0 1.497 1.32l2 -2l.083 -.094a1 1 0 0 0 -.083 -1.32z", "key": "svg-0" }]]);

var IconAlienFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlienFilled
});

var IconAlignBoxBottomCenterFilled = createReactComponent("filled", "align-box-bottom-center-filled", "IconAlignBoxBottomCenterFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-9.333 13a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 -4a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 2a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconAlignBoxBottomCenterFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxBottomCenterFilled
});

var IconAlignBoxBottomLeftFilled = createReactComponent("filled", "align-box-bottom-left-filled", "IconAlignBoxBottomLeftFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-12.333 13a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 -4a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 2a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconAlignBoxBottomLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxBottomLeftFilled
});

var IconAlignBoxBottomRightFilled = createReactComponent("filled", "align-box-bottom-right-filled", "IconAlignBoxBottomRightFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-6.333 13a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 -4a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 2a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconAlignBoxBottomRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxBottomRightFilled
});

var IconAlignBoxCenterMiddleFilled = createReactComponent("filled", "align-box-center-middle-filled", "IconAlignBoxCenterMiddleFilled", [["path", { "d": "M19 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.993 -2.802l-.007 -.198v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h14zm-6 12h-2l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h2l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm2 -3h-6l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h6l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-1 -3h-4l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h4l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconAlignBoxCenterMiddleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxCenterMiddleFilled
});

var IconAlignBoxLeftBottomFilled = createReactComponent("filled", "align-box-left-bottom-filled", "IconAlignBoxLeftBottomFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-10.333 15h-2l-.117 .007a1 1 0 0 0 .117 1.993h2l.117 -.007a1 1 0 0 0 -.117 -1.993zm4 -3h-6l-.117 .007a1 1 0 0 0 .117 1.993h6l.117 -.007a1 1 0 0 0 -.117 -1.993zm-2 -3h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconAlignBoxLeftBottomFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxLeftBottomFilled
});

var IconAlignBoxLeftMiddleFilled = createReactComponent("filled", "align-box-left-middle-filled", "IconAlignBoxLeftMiddleFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-10.333 12h-2l-.117 .007a1 1 0 0 0 .117 1.993h2l.117 -.007a1 1 0 0 0 -.117 -1.993zm4 -3h-6l-.117 .007a1 1 0 0 0 .117 1.993h6l.117 -.007a1 1 0 0 0 -.117 -1.993zm-2 -3h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconAlignBoxLeftMiddleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxLeftMiddleFilled
});

var IconAlignBoxLeftTopFilled = createReactComponent("filled", "align-box-left-top-filled", "IconAlignBoxLeftTopFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-10.333 9h-2l-.117 .007a1 1 0 0 0 .117 1.993h2l.117 -.007a1 1 0 0 0 -.117 -1.993zm4 -3h-6l-.117 .007a1 1 0 0 0 .117 1.993h6l.117 -.007a1 1 0 0 0 -.117 -1.993zm-2 -3h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconAlignBoxLeftTopFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxLeftTopFilled
});

var IconAlignBoxRightBottomFilled = createReactComponent("filled", "align-box-right-bottom-filled", "IconAlignBoxRightBottomFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-.333 15h-2l-.117 .007a1 1 0 0 0 .117 1.993h2l.117 -.007a1 1 0 0 0 -.117 -1.993zm0 -3h-6l-.117 .007a1 1 0 0 0 .117 1.993h6l.117 -.007a1 1 0 0 0 -.117 -1.993zm0 -3h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconAlignBoxRightBottomFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxRightBottomFilled
});

var IconAlignBoxRightMiddleFilled = createReactComponent("filled", "align-box-right-middle-filled", "IconAlignBoxRightMiddleFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-.333 12h-2l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h2l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm0 -3h-6l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h6l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm0 -3h-4l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h4l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconAlignBoxRightMiddleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxRightMiddleFilled
});

var IconAlignBoxRightTopFilled = createReactComponent("filled", "align-box-right-top-filled", "IconAlignBoxRightTopFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-.333 9h-2l-.117 .007a1 1 0 0 0 .117 1.993h2l.117 -.007a1 1 0 0 0 -.117 -1.993zm0 -3h-6l-.117 .007a1 1 0 0 0 .117 1.993h6l.117 -.007a1 1 0 0 0 -.117 -1.993zm0 -3h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconAlignBoxRightTopFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxRightTopFilled
});

var IconAlignBoxTopCenterFilled = createReactComponent("filled", "align-box-top-center-filled", "IconAlignBoxTopCenterFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-6.333 3a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm-6 0a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconAlignBoxTopCenterFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxTopCenterFilled
});

var IconAlignBoxTopLeftFilled = createReactComponent("filled", "align-box-top-left-filled", "IconAlignBoxTopLeftFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-9.333 3a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm-6 0a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconAlignBoxTopLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxTopLeftFilled
});

var IconAlignBoxTopRightFilled = createReactComponent("filled", "align-box-top-right-filled", "IconAlignBoxTopRightFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.333 3a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm-6 0a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconAlignBoxTopRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAlignBoxTopRightFilled
});

var IconAnalyzeFilled = createReactComponent("filled", "analyze-filled", "IconAnalyzeFilled", [["path", { "d": "M4.99 12.862a7.1 7.1 0 0 0 12.171 3.924a1.956 1.956 0 0 1 -.156 -.637l-.005 -.149l.005 -.15a2 2 0 1 1 1.769 2.137a9.099 9.099 0 0 1 -15.764 -4.85a1 1 0 0 1 1.98 -.275z", "key": "svg-0" }], ["path", { "d": "M12 8a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z", "key": "svg-1" }], ["path", { "d": "M13.142 3.09a9.1 9.1 0 0 1 7.848 7.772a1 1 0 0 1 -1.98 .276a7.1 7.1 0 0 0 -6.125 -6.064a7.096 7.096 0 0 0 -6.048 2.136a2 2 0 1 1 -3.831 .939l-.006 -.149l.005 -.15a2 2 0 0 1 2.216 -1.838a9.094 9.094 0 0 1 7.921 -2.922z", "key": "svg-2" }]]);

var IconAnalyzeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAnalyzeFilled
});

var IconAppWindowFilled = createReactComponent("filled", "app-window-filled", "IconAppWindowFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-12.99 3l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm3 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconAppWindowFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAppWindowFilled
});

var IconAppleFilled = createReactComponent("filled", "apple-filled", "IconAppleFilled", [["path", { "d": "M15 2a1 1 0 0 1 .117 1.993l-.117 .007c-.693 0 -1.33 .694 -1.691 1.552a5.1 5.1 0 0 1 1.982 -.544l.265 -.008c2.982 0 5.444 3.053 5.444 6.32c0 3.547 -.606 5.862 -2.423 8.578c-1.692 2.251 -4.092 2.753 -6.41 1.234a.31 .31 0 0 0 -.317 -.01c-2.335 1.528 -4.735 1.027 -6.46 -1.27c-1.783 -2.668 -2.39 -4.984 -2.39 -8.532l.004 -.222c.108 -3.181 2.526 -6.098 5.44 -6.098c.94 0 1.852 .291 2.688 .792c.419 -1.95 1.818 -3.792 3.868 -3.792m-7.034 6.154c-1.36 .858 -1.966 2.06 -1.966 3.846a1 1 0 0 0 2 0c0 -1.125 .28 -1.678 1.034 -2.154a1 1 0 1 0 -1.068 -1.692", "key": "svg-0" }]]);

var IconAppleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAppleFilled
});

var IconAppsFilled = createReactComponent("filled", "apps-filled", "IconAppsFilled", [["path", { "d": "M9 3h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 13h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z", "key": "svg-1" }], ["path", { "d": "M19 13h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z", "key": "svg-2" }], ["path", { "d": "M17 3a1 1 0 0 1 .993 .883l.007 .117v2h2a1 1 0 0 1 .117 1.993l-.117 .007h-2v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2v-2a1 1 0 0 1 1 -1z", "key": "svg-3" }]]);

var IconAppsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAppsFilled
});

var IconArchiveFilled = createReactComponent("filled", "archive-filled", "IconArchiveFilled", [["path", { "d": "M2 3m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M19 9c.513 0 .936 .463 .993 1.06l.007 .14v7.2c0 1.917 -1.249 3.484 -2.824 3.594l-.176 .006h-10c-1.598 0 -2.904 -1.499 -2.995 -3.388l-.005 -.212v-7.2c0 -.663 .448 -1.2 1 -1.2h14zm-5 2h-4l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h4l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-1" }]]);

var IconArchiveFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArchiveFilled
});

var IconArrowAutofitContentFilled = createReactComponent("filled", "arrow-autofit-content-filled", "IconArrowAutofitContentFilled", [["path", { "d": "M6.707 3.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.292 1.293h4.585a1 1 0 0 1 .117 1.993l-.117 .007h-4.585l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.32 .083l-.094 -.083l-3 -3a1.008 1.008 0 0 1 -.097 -.112l-.071 -.11l-.054 -.114l-.035 -.105l-.025 -.118l-.007 -.058l-.004 -.09l.003 -.075l.017 -.126l.03 -.111l.044 -.111l.052 -.098l.064 -.092l.083 -.094l3 -3a1 1 0 0 1 1.414 0z", "key": "svg-0" }], ["path", { "d": "M18.613 3.21l.094 .083l3 3a.927 .927 0 0 1 .097 .112l.071 .11l.054 .114l.035 .105l.03 .148l.006 .118l-.003 .075l-.017 .126l-.03 .111l-.044 .111l-.052 .098l-.074 .104l-.073 .082l-3 3a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.292 -1.293h-4.585a1 1 0 0 1 -.117 -1.993l.117 -.007h4.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083z", "key": "svg-1" }], ["path", { "d": "M18 13h-12a3 3 0 0 0 -3 3v2a3 3 0 0 0 3 3h12a3 3 0 0 0 3 -3v-2a3 3 0 0 0 -3 -3z", "key": "svg-2" }]]);

var IconArrowAutofitContentFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitContentFilled
});

var IconArrowAutofitDownFilled = createReactComponent("filled", "arrow-autofit-down-filled", "IconArrowAutofitDownFilled", [["path", { "d": "M14 3a1 1 0 0 1 1 1v11.001h-.092a3 3 0 0 0 -2.03 5.12a.515 .515 0 0 1 -.363 .879h-6.515a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M18 3a1 1 0 0 1 1 1v14.584l1.293 -1.291a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.096 -.067l-.09 -.08l-3 -3a1 1 0 0 1 1.414 -1.414l1.293 1.293v-14.586a1 1 0 0 1 1 -1", "key": "svg-1" }]]);

var IconArrowAutofitDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitDownFilled
});

var IconArrowAutofitHeightFilled = createReactComponent("filled", "arrow-autofit-height-filled", "IconArrowAutofitHeightFilled", [["path", { "d": "M12.879 3.879a3 3 0 0 0 0 4.242l.09 .085l.094 .083l.096 .08l.158 .115a3 3 0 0 0 1.59 .515l.093 -.001v6.003h-.092a3 3 0 0 0 -2.03 5.12a.514 .514 0 0 1 -.363 .878l-6.515 .001a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h6.514a.515 .515 0 0 1 .365 .879", "key": "svg-0" }], ["path", { "d": "M18 13a1 1 0 0 1 1 1v4.584l1.293 -1.291a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.096 -.067l-.09 -.08l-3 -3a1 1 0 0 1 1.414 -1.414l1.293 1.293v-4.586a1 1 0 0 1 1 -1", "key": "svg-1" }], ["path", { "d": "M17.852 2.011l.058 -.007l.09 -.004l.075 .003l.126 .017l.111 .03l.111 .044l.098 .052l.104 .074l.082 .073l3 3a1 1 0 1 1 -1.414 1.414l-1.293 -1.292v4.585a1 1 0 0 1 -2 0v-4.585l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 0 -1.414l3 -3q .053 -.054 .112 -.097l.11 -.071l.114 -.054l.105 -.035z", "key": "svg-2" }]]);

var IconArrowAutofitHeightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitHeightFilled
});

var IconArrowAutofitLeftFilled = createReactComponent("filled", "arrow-autofit-left-filled", "IconArrowAutofitLeftFilled", [["path", { "d": "M21 14a1 1 0 0 1 -1 1h-11.001v-.092a3 3 0 0 0 -5.12 -2.03a.515 .515 0 0 1 -.879 -.363v-6.515a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3z", "key": "svg-0" }], ["path", { "d": "M21 18a1 1 0 0 1 -1 1h-14.584l1.291 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.414 0l-3 -3a1 1 0 0 1 -.097 -.112l-.071 -.11l-.054 -.114l-.035 -.105l-.03 -.149l-.006 -.117l.003 -.075l.017 -.126l.03 -.111l.044 -.111l.052 -.098l.067 -.096l.08 -.09l3 -3a1 1 0 1 1 1.414 1.414l-1.293 1.293h14.586a1 1 0 0 1 1 1", "key": "svg-1" }]]);

var IconArrowAutofitLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitLeftFilled
});

var IconArrowAutofitRightFilled = createReactComponent("filled", "arrow-autofit-right-filled", "IconArrowAutofitRightFilled", [["path", { "d": "M3 14a1 1 0 0 0 1 1h11.001v-.092a3 3 0 0 1 5.12 -2.03a.515 .515 0 0 0 .879 -.363v-6.515a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3z", "key": "svg-0" }], ["path", { "d": "M3 18a1 1 0 0 0 1 1h14.584l-1.291 1.293a1 1 0 0 0 -.083 1.32l.083 .094a1 1 0 0 0 1.414 0l3 -3q .054 -.053 .097 -.112l.071 -.11l.054 -.114l.035 -.105l.03 -.149l.006 -.117l-.003 -.075l-.017 -.126l-.03 -.111l-.044 -.111l-.052 -.098l-.067 -.096l-.08 -.09l-3 -3a1 1 0 0 0 -1.414 1.414l1.293 1.293h-14.586a1 1 0 0 0 -1 1", "key": "svg-1" }]]);

var IconArrowAutofitRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitRightFilled
});

var IconArrowAutofitUpFilled = createReactComponent("filled", "arrow-autofit-up-filled", "IconArrowAutofitUpFilled", [["path", { "d": "M14 21a1 1 0 0 0 1 -1v-11.001h-.092a3 3 0 0 1 -2.03 -5.12a.515 .515 0 0 0 -.363 -.879h-6.515a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3z", "key": "svg-0" }], ["path", { "d": "M18 21a1 1 0 0 0 1 -1v-14.584l1.293 1.291a1 1 0 0 0 1.32 .083l.094 -.083a1 1 0 0 0 0 -1.414l-3 -3a1 1 0 0 0 -.112 -.097l-.11 -.071l-.114 -.054l-.105 -.035l-.149 -.03l-.117 -.006l-.075 .003l-.126 .017l-.111 .03l-.111 .044l-.098 .052l-.096 .067l-.09 .08l-3 3a1 1 0 1 0 1.414 1.414l1.293 -1.293v14.586a1 1 0 0 0 1 1", "key": "svg-1" }]]);

var IconArrowAutofitUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitUpFilled
});

var IconArrowAutofitWidthFilled = createReactComponent("filled", "arrow-autofit-width-filled", "IconArrowAutofitWidthFilled", [["path", { "d": "M20.121 12.879a3 3 0 0 0 -4.242 0l-.085 .09l-.083 .094l-.08 .096l-.115 .158a3 3 0 0 0 -.515 1.59l.001 .093h-6.003v-.092a3 3 0 0 0 -5.12 -2.03a.514 .514 0 0 1 -.878 -.363l-.001 -6.515a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.514a.515 .515 0 0 1 -.879 .365", "key": "svg-0" }], ["path", { "d": "M11 18a1 1 0 0 1 -1 1h-4.584l1.291 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.414 0l-3 -3a1 1 0 0 1 -.097 -.112l-.071 -.11l-.054 -.114l-.035 -.105l-.03 -.149l-.006 -.117l.003 -.075l.017 -.126l.03 -.111l.044 -.111l.052 -.098l.067 -.096l.08 -.09l3 -3a1 1 0 0 1 1.414 1.414l-1.293 1.293h4.586a1 1 0 0 1 1 1m10.989 -.148l.007 .058l.004 .09l-.003 .075l-.017 .126l-.03 .111l-.044 .111l-.052 .098l-.074 .104l-.073 .082l-3 3a1 1 0 1 1 -1.414 -1.414l1.292 -1.293h-4.585a1 1 0 0 1 0 -2h4.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.414 0l3 3q .054 .053 .097 .112l.071 .11l.054 .114l.035 .105z", "key": "svg-1" }]]);

var IconArrowAutofitWidthFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowAutofitWidthFilled
});

var IconArrowBadgeDownFilled = createReactComponent("filled", "arrow-badge-down-filled", "IconArrowBadgeDownFilled", [["path", { "d": "M16.375 6.22l-4.375 3.498l-4.375 -3.5a1 1 0 0 0 -1.625 .782v6a1 1 0 0 0 .375 .78l5 4a1 1 0 0 0 1.25 0l5 -4a1 1 0 0 0 .375 -.78v-6a1 1 0 0 0 -1.625 -.78z", "key": "svg-0" }]]);

var IconArrowBadgeDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBadgeDownFilled
});

var IconArrowBadgeLeftFilled = createReactComponent("filled", "arrow-badge-left-filled", "IconArrowBadgeLeftFilled", [["path", { "d": "M17 6h-6a1 1 0 0 0 -.78 .375l-4 5a1 1 0 0 0 0 1.25l4 5a1 1 0 0 0 .78 .375h6l.112 -.006a1 1 0 0 0 .669 -1.619l-3.501 -4.375l3.5 -4.375a1 1 0 0 0 -.78 -1.625z", "key": "svg-0" }]]);

var IconArrowBadgeLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBadgeLeftFilled
});

var IconArrowBadgeRightFilled = createReactComponent("filled", "arrow-badge-right-filled", "IconArrowBadgeRightFilled", [["path", { "d": "M7 6l-.112 .006a1 1 0 0 0 -.669 1.619l3.501 4.375l-3.5 4.375a1 1 0 0 0 .78 1.625h6a1 1 0 0 0 .78 -.375l4 -5a1 1 0 0 0 0 -1.25l-4 -5a1 1 0 0 0 -.78 -.375h-6z", "key": "svg-0" }]]);

var IconArrowBadgeRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBadgeRightFilled
});

var IconArrowBadgeUpFilled = createReactComponent("filled", "arrow-badge-up-filled", "IconArrowBadgeUpFilled", [["path", { "d": "M11.375 6.22l-5 4a1 1 0 0 0 -.375 .78v6l.006 .112a1 1 0 0 0 1.619 .669l4.375 -3.501l4.375 3.5a1 1 0 0 0 1.625 -.78v-6a1 1 0 0 0 -.375 -.78l-5 -4a1 1 0 0 0 -1.25 0z", "key": "svg-0" }]]);

var IconArrowBadgeUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBadgeUpFilled
});

var IconArrowBigDownLineFilled = createReactComponent("filled", "arrow-big-down-line-filled", "IconArrowBigDownLineFilled", [["path", { "d": "M9 5l-.117 .007a1 1 0 0 0 -.883 .993v4.999l-2.586 .001a2 2 0 0 0 -1.414 3.414l6.586 6.586a2 2 0 0 0 2.828 0l6.586 -6.586a2 2 0 0 0 .434 -2.18l-.068 -.145a2 2 0 0 0 -1.78 -1.089l-2.586 -.001v-4.999a1 1 0 0 0 -1 -1h-6z", "key": "svg-0" }], ["path", { "d": "M15 2a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z", "key": "svg-1" }]]);

var IconArrowBigDownLineFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigDownLineFilled
});

var IconArrowBigDownLinesFilled = createReactComponent("filled", "arrow-big-down-lines-filled", "IconArrowBigDownLinesFilled", [["path", { "d": "M9 8l-.117 .007a1 1 0 0 0 -.883 .993v1.999l-2.586 .001a2 2 0 0 0 -1.414 3.414l6.586 6.586a2 2 0 0 0 2.828 0l6.586 -6.586a2 2 0 0 0 .434 -2.18l-.068 -.145a2 2 0 0 0 -1.78 -1.089l-2.586 -.001v-1.999a1 1 0 0 0 -1 -1h-6z", "key": "svg-0" }], ["path", { "d": "M15 2a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z", "key": "svg-1" }], ["path", { "d": "M15 5a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z", "key": "svg-2" }]]);

var IconArrowBigDownLinesFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigDownLinesFilled
});

var IconArrowBigDownFilled = createReactComponent("filled", "arrow-big-down-filled", "IconArrowBigDownFilled", [["path", { "d": "M10 2l-.15 .005a2 2 0 0 0 -1.85 1.995v6.999l-2.586 .001a2 2 0 0 0 -1.414 3.414l6.586 6.586a2 2 0 0 0 2.828 0l6.586 -6.586a2 2 0 0 0 .434 -2.18l-.068 -.145a2 2 0 0 0 -1.78 -1.089l-2.586 -.001v-6.999a2 2 0 0 0 -2 -2h-4z", "key": "svg-0" }]]);

var IconArrowBigDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigDownFilled
});

var IconArrowBigLeftLineFilled = createReactComponent("filled", "arrow-big-left-line-filled", "IconArrowBigLeftLineFilled", [["path", { "d": "M9.586 4l-6.586 6.586a2 2 0 0 0 0 2.828l6.586 6.586a2 2 0 0 0 2.18 .434l.145 -.068a2 2 0 0 0 1.089 -1.78v-2.586h5a1 1 0 0 0 1 -1v-6l-.007 -.117a1 1 0 0 0 -.993 -.883l-5 -.001v-2.585a2 2 0 0 0 -3.414 -1.414z", "key": "svg-0" }], ["path", { "d": "M4.415 12l6.585 -6.586v3.586l.007 .117a1 1 0 0 0 .993 .883l5 -.001v4l-5 .001a1 1 0 0 0 -1 1v3.586l-6.585 -6.586z", "key": "svg-1" }], ["path", { "d": "M21 8a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -1.993 .117l-.007 -.117v-6a1 1 0 0 1 1 -1z", "key": "svg-2" }]]);

var IconArrowBigLeftLineFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigLeftLineFilled
});

var IconArrowBigLeftLinesFilled = createReactComponent("filled", "arrow-big-left-lines-filled", "IconArrowBigLeftLinesFilled", [["path", { "d": "M9.586 4l-6.586 6.586a2 2 0 0 0 0 2.828l6.586 6.586a2 2 0 0 0 2.18 .434l.145 -.068a2 2 0 0 0 1.089 -1.78v-2.586h2a1 1 0 0 0 1 -1v-6l-.007 -.117a1 1 0 0 0 -.993 -.883l-2 -.001v-2.585a2 2 0 0 0 -3.414 -1.414z", "key": "svg-0" }], ["path", { "d": "M21 8a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -1.993 .117l-.007 -.117v-6a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M18 8a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -1.993 .117l-.007 -.117v-6a1 1 0 0 1 1 -1z", "key": "svg-2" }]]);

var IconArrowBigLeftLinesFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigLeftLinesFilled
});

var IconArrowBigLeftFilled = createReactComponent("filled", "arrow-big-left-filled", "IconArrowBigLeftFilled", [["path", { "d": "M9.586 4l-6.586 6.586a2 2 0 0 0 0 2.828l6.586 6.586a2 2 0 0 0 2.18 .434l.145 -.068a2 2 0 0 0 1.089 -1.78v-2.586h7a2 2 0 0 0 2 -2v-4l-.005 -.15a2 2 0 0 0 -1.995 -1.85l-7 -.001v-2.585a2 2 0 0 0 -3.414 -1.414z", "key": "svg-0" }]]);

var IconArrowBigLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigLeftFilled
});

var IconArrowBigRightLineFilled = createReactComponent("filled", "arrow-big-right-line-filled", "IconArrowBigRightLineFilled", [["path", { "d": "M12.089 3.634a2 2 0 0 0 -1.089 1.78l-.001 2.586h-4.999a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 .993 .883l4.999 -.001l.001 2.587a2 2 0 0 0 3.414 1.414l6.586 -6.586a2 2 0 0 0 0 -2.828l-6.586 -6.586a2 2 0 0 0 -2.18 -.434l-.145 .068z", "key": "svg-0" }], ["path", { "d": "M3 8a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -1.993 .117l-.007 -.117v-6a1 1 0 0 1 1 -1z", "key": "svg-1" }]]);

var IconArrowBigRightLineFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigRightLineFilled
});

var IconArrowBigRightLinesFilled = createReactComponent("filled", "arrow-big-right-lines-filled", "IconArrowBigRightLinesFilled", [["path", { "d": "M12.089 3.634a2 2 0 0 0 -1.089 1.78l-.001 2.585l-1.999 .001a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 .993 .883l1.999 -.001l.001 2.587a2 2 0 0 0 3.414 1.414l6.586 -6.586a2 2 0 0 0 0 -2.828l-6.586 -6.586a2 2 0 0 0 -2.18 -.434l-.145 .068z", "key": "svg-0" }], ["path", { "d": "M3 8a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -1.993 .117l-.007 -.117v-6a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M6 8a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -1.993 .117l-.007 -.117v-6a1 1 0 0 1 1 -1z", "key": "svg-2" }]]);

var IconArrowBigRightLinesFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigRightLinesFilled
});

var IconArrowBigRightFilled = createReactComponent("filled", "arrow-big-right-filled", "IconArrowBigRightFilled", [["path", { "d": "M12.089 3.634a2 2 0 0 0 -1.089 1.78l-.001 2.586h-6.999a2 2 0 0 0 -2 2v4l.005 .15a2 2 0 0 0 1.995 1.85l6.999 -.001l.001 2.587a2 2 0 0 0 3.414 1.414l6.586 -6.586a2 2 0 0 0 0 -2.828l-6.586 -6.586a2 2 0 0 0 -2.18 -.434l-.145 .068z", "key": "svg-0" }]]);

var IconArrowBigRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigRightFilled
});

var IconArrowBigUpLineFilled = createReactComponent("filled", "arrow-big-up-line-filled", "IconArrowBigUpLineFilled", [["path", { "d": "M10.586 3l-6.586 6.586a2 2 0 0 0 -.434 2.18l.068 .145a2 2 0 0 0 1.78 1.089h2.586v5a1 1 0 0 0 1 1h6l.117 -.007a1 1 0 0 0 .883 -.993l-.001 -5h2.587a2 2 0 0 0 1.414 -3.414l-6.586 -6.586a2 2 0 0 0 -2.828 0z", "key": "svg-0" }], ["path", { "d": "M15 20a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z", "key": "svg-1" }]]);

var IconArrowBigUpLineFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigUpLineFilled
});

var IconArrowBigUpLinesFilled = createReactComponent("filled", "arrow-big-up-lines-filled", "IconArrowBigUpLinesFilled", [["path", { "d": "M10.586 3l-6.586 6.586a2 2 0 0 0 -.434 2.18l.068 .145a2 2 0 0 0 1.78 1.089h2.586v2a1 1 0 0 0 1 1h6l.117 -.007a1 1 0 0 0 .883 -.993l-.001 -2h2.587a2 2 0 0 0 1.414 -3.414l-6.586 -6.586a2 2 0 0 0 -2.828 0z", "key": "svg-0" }], ["path", { "d": "M15 20a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z", "key": "svg-1" }], ["path", { "d": "M15 17a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z", "key": "svg-2" }]]);

var IconArrowBigUpLinesFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigUpLinesFilled
});

var IconArrowBigUpFilled = createReactComponent("filled", "arrow-big-up-filled", "IconArrowBigUpFilled", [["path", { "d": "M10.586 3l-6.586 6.586a2 2 0 0 0 -.434 2.18l.068 .145a2 2 0 0 0 1.78 1.089h2.586v7a2 2 0 0 0 2 2h4l.15 -.005a2 2 0 0 0 1.85 -1.995l-.001 -7h2.587a2 2 0 0 0 1.414 -3.414l-6.586 -6.586a2 2 0 0 0 -2.828 0z", "key": "svg-0" }]]);

var IconArrowBigUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowBigUpFilled
});

var IconArrowDownCircleFilled = createReactComponent("filled", "arrow-down-circle-filled", "IconArrowDownCircleFilled", [["path", { "d": "M12 2a3 3 0 0 1 1 5.829v10.755l1.293 -1.291a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.096 -.067l-.09 -.08l-3 -3a1 1 0 0 1 1.414 -1.414l1.293 1.293v-10.757a3.001 3.001 0 0 1 1 -5.829", "key": "svg-0" }]]);

var IconArrowDownCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownCircleFilled
});

var IconArrowDownRhombusFilled = createReactComponent("filled", "arrow-down-rhombus-filled", "IconArrowDownRhombusFilled", [["path", { "d": "M12.707 2.293l2.5 2.5a1 1 0 0 1 0 1.414l-2.207 2.207v10.17l1.293 -1.291a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.096 -.067l-.09 -.08l-3 -3a1 1 0 0 1 1.414 -1.414l1.293 1.293v-10.171l-2.207 -2.208a1 1 0 0 1 0 -1.414l2.5 -2.5a1 1 0 0 1 1.414 0", "key": "svg-0" }]]);

var IconArrowDownRhombusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownRhombusFilled
});

var IconArrowDownSquareFilled = createReactComponent("filled", "arrow-down-square-filled", "IconArrowDownSquareFilled", [["path", { "d": "M14 2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-1v10.584l1.293 -1.291a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.096 -.067l-.09 -.08l-3 -3a1 1 0 0 1 1.414 -1.414l1.293 1.293v-10.586h-1a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconArrowDownSquareFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowDownSquareFilled
});

var IconArrowGuideFilled = createReactComponent("filled", "arrow-guide-filled", "IconArrowGuideFilled", [["path", { "d": "M18.707 3.293l3 3q .054 .053 .097 .112l.071 .11l.054 .114l.035 .105l.03 .148l.006 .118l-.003 .075l-.017 .126l-.03 .111l-.044 .111l-.052 .098l-.067 .096l-.08 .09l-3 3a1 1 0 0 1 -1.414 -1.414l1.292 -1.293h-4.585a1 1 0 0 0 -1 1v8a3 3 0 0 1 -3 3h-2.171a3.001 3.001 0 0 1 -5.829 -1l.005 -.176a3 3 0 0 1 5.825 -.824h2.17a1 1 0 0 0 1 -1v-8a3 3 0 0 1 3 -3h4.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.414 0", "key": "svg-0" }]]);

var IconArrowGuideFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowGuideFilled
});

var IconArrowLeftCircleFilled = createReactComponent("filled", "arrow-left-circle-filled", "IconArrowLeftCircleFilled", [["path", { "d": "M6.707 8.293a1 1 0 0 1 0 1.414l-1.292 1.293h10.756a3.001 3.001 0 1 1 0 2h-10.756l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.414 0l-3 -3a1 1 0 0 1 -.097 -.112l-.071 -.11l-.054 -.114l-.035 -.105l-.025 -.118l-.007 -.058l-.004 -.09l.003 -.075l.017 -.126l.03 -.111l.044 -.111l.052 -.098l.067 -.096l.08 -.09l3 -3a1 1 0 0 1 1.414 0", "key": "svg-0" }]]);

var IconArrowLeftCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeftCircleFilled
});

var IconArrowLeftRhombusFilled = createReactComponent("filled", "arrow-left-rhombus-filled", "IconArrowLeftRhombusFilled", [["path", { "d": "M6.707 8.293a1 1 0 0 1 0 1.414l-1.292 1.293h10.169l2.209 -2.207a1 1 0 0 1 1.414 0l2.5 2.5a1 1 0 0 1 0 1.414l-2.5 2.5a1 1 0 0 1 -1.414 0l-2.208 -2.207h-10.17l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.414 0l-3 -3a1 1 0 0 1 -.097 -.112l-.071 -.11l-.054 -.114l-.035 -.105l-.025 -.118l-.007 -.058l-.004 -.09l.003 -.075l.017 -.126l.03 -.111l.044 -.111l.052 -.098l.067 -.096l.08 -.09l3 -3a1 1 0 0 1 1.414 0", "key": "svg-0" }]]);

var IconArrowLeftRhombusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeftRhombusFilled
});

var IconArrowLeftSquareFilled = createReactComponent("filled", "arrow-left-square-filled", "IconArrowLeftSquareFilled", [["path", { "d": "M6.707 8.293a1 1 0 0 1 0 1.414l-1.292 1.293h10.585v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-1h-10.585l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.414 0l-3 -3a1 1 0 0 1 -.097 -.112l-.071 -.11l-.054 -.114l-.035 -.105l-.025 -.118l-.007 -.058l-.004 -.09l.003 -.075l.017 -.126l.03 -.111l.044 -.111l.052 -.098l.067 -.096l.08 -.09l3 -3a1 1 0 0 1 1.414 0", "key": "svg-0" }]]);

var IconArrowLeftSquareFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowLeftSquareFilled
});

var IconArrowMoveDownFilled = createReactComponent("filled", "arrow-move-down-filled", "IconArrowMoveDownFilled", [["path", { "d": "M12 10a1 1 0 0 1 1 1v7.584l1.293 -1.291a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.096 -.067l-.09 -.08l-3 -3a1 1 0 0 1 1.414 -1.414l1.293 1.293v-7.586a1 1 0 0 1 1 -1m0 -8a3 3 0 1 1 -3 3l.005 -.176a3 3 0 0 1 2.995 -2.824", "key": "svg-0" }]]);

var IconArrowMoveDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMoveDownFilled
});

var IconArrowMoveLeftFilled = createReactComponent("filled", "arrow-move-left-filled", "IconArrowMoveLeftFilled", [["path", { "d": "M6.707 8.293a1 1 0 0 1 0 1.414l-1.292 1.293h7.585a1 1 0 0 1 0 2h-7.585l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.414 0l-3 -3a1 1 0 0 1 -.097 -.112l-.071 -.11l-.054 -.114l-.035 -.105l-.025 -.118l-.007 -.058l-.004 -.09l.003 -.075l.017 -.126l.03 -.111l.044 -.111l.052 -.098l.067 -.096l.08 -.09l3 -3a1 1 0 0 1 1.414 0m12.293 .707a3 3 0 1 1 0 6a3 3 0 0 1 0 -6", "key": "svg-0" }]]);

var IconArrowMoveLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMoveLeftFilled
});

var IconArrowMoveRightFilled = createReactComponent("filled", "arrow-move-right-filled", "IconArrowMoveRightFilled", [["path", { "d": "M18.707 8.293l3 3q .054 .053 .097 .112l.071 .11l.054 .114l.035 .105l.03 .148l.006 .118l-.003 .075l-.017 .126l-.03 .111l-.044 .111l-.052 .098l-.074 .104l-.073 .082l-3 3a1 1 0 0 1 -1.414 -1.414l1.292 -1.293h-7.585a1 1 0 0 1 0 -2h7.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.414 0m-13.707 .707a3 3 0 1 1 0 6a3 3 0 0 1 0 -6", "key": "svg-0" }]]);

var IconArrowMoveRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMoveRightFilled
});

var IconArrowMoveUpFilled = createReactComponent("filled", "arrow-move-up-filled", "IconArrowMoveUpFilled", [["path", { "d": "M11.852 2.011l.058 -.007l.09 -.004l.075 .003l.126 .017l.111 .03l.111 .044l.098 .052l.104 .074l.082 .073l3 3a1 1 0 1 1 -1.414 1.414l-1.293 -1.292v7.585a1 1 0 0 1 -2 0v-7.585l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 0 -1.414l3 -3q .053 -.054 .112 -.097l.11 -.071l.114 -.054l.105 -.035z", "key": "svg-0" }], ["path", { "d": "M12 16a3 3 0 1 1 0 6a3 3 0 0 1 0 -6", "key": "svg-1" }]]);

var IconArrowMoveUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowMoveUpFilled
});

var IconArrowRightCircleFilled = createReactComponent("filled", "arrow-right-circle-filled", "IconArrowRightCircleFilled", [["path", { "d": "M5 15a3 3 0 0 1 -3 -3l.005 -.176a3 3 0 0 1 5.825 -.824h10.756l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.414 0l3 3l.097 .112l.071 .11l.031 .062l.034 .081l.024 .076l.03 .148l.005 .118l-.004 .085l-.016 .116l-.03 .111l-.044 .111l-.052 .098l-.074 .104l-.073 .082l-3 3a1 1 0 0 1 -1.414 -1.414l1.292 -1.293h-10.756a3 3 0 0 1 -2.829 2", "key": "svg-0" }]]);

var IconArrowRightCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRightCircleFilled
});

var IconArrowRightRhombusFilled = createReactComponent("filled", "arrow-right-rhombus-filled", "IconArrowRightRhombusFilled", [["path", { "d": "M18.707 8.293l3 3l.097 .112l.071 .11l.031 .062l.034 .081l.024 .076l.03 .148l.006 .118l-.004 .085l-.016 .116l-.03 .111l-.044 .111l-.052 .098l-.074 .104l-.073 .082l-3 3a1 1 0 0 1 -1.414 -1.414l1.292 -1.293h-10.171l-2.207 2.207a1 1 0 0 1 -1.414 0l-2.5 -2.5a1 1 0 0 1 0 -1.414l2.5 -2.5a1 1 0 0 1 1.414 0l2.208 2.207h10.17l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.414 0", "key": "svg-0" }]]);

var IconArrowRightRhombusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRightRhombusFilled
});

var IconArrowRightSquareFilled = createReactComponent("filled", "arrow-right-square-filled", "IconArrowRightSquareFilled", [["path", { "d": "M18.707 8.293l3 3q .054 .053 .097 .112l.071 .11l.054 .114l.035 .105l.03 .148l.006 .118l-.003 .075l-.017 .126l-.03 .111l-.044 .111l-.052 .098l-.074 .104l-.073 .082l-3 3a1 1 0 0 1 -1.414 -1.414l1.292 -1.293h-10.585v1a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v1h10.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.414 0", "key": "svg-0" }]]);

var IconArrowRightSquareFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowRightSquareFilled
});

var IconArrowUpCircleFilled = createReactComponent("filled", "arrow-up-circle-filled", "IconArrowUpCircleFilled", [["path", { "d": "M11.852 2.011l.058 -.007l.09 -.004l.075 .003l.126 .017l.111 .03l.111 .044l.098 .052l.104 .074l.082 .073l3 3a1 1 0 1 1 -1.414 1.414l-1.293 -1.292v10.756a3.001 3.001 0 1 1 -2 0v-10.756l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 0 -1.414l3 -3q .053 -.054 .112 -.097l.11 -.071l.114 -.054l.105 -.035z", "key": "svg-0" }]]);

var IconArrowUpCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpCircleFilled
});

var IconArrowUpRhombusFilled = createReactComponent("filled", "arrow-up-rhombus-filled", "IconArrowUpRhombusFilled", [["path", { "d": "M12 2l.081 .003l.12 .017l.111 .03l.111 .044l.098 .052l.104 .074l.082 .073l3 3a1 1 0 1 1 -1.414 1.414l-1.293 -1.292v10.17l2.207 2.208a1 1 0 0 1 0 1.414l-2.5 2.5a1 1 0 0 1 -1.414 0l-2.5 -2.5a1 1 0 0 1 0 -1.414l2.207 -2.209v-10.169l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 0 -1.414l3 -3l.112 -.097l.11 -.071l.062 -.031l.081 -.034l.076 -.024l.118 -.025l.058 -.007z", "key": "svg-0" }]]);

var IconArrowUpRhombusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpRhombusFilled
});

var IconArrowUpSquareFilled = createReactComponent("filled", "arrow-up-square-filled", "IconArrowUpSquareFilled", [["path", { "d": "M11.852 2.011l.058 -.007l.09 -.004l.075 .003l.126 .017l.111 .03l.111 .044l.098 .052l.104 .074l.082 .073l3 3a1 1 0 1 1 -1.414 1.414l-1.293 -1.292v10.585h1a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h1v-10.585l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 0 -1.414l3 -3q .053 -.054 .112 -.097l.11 -.071l.114 -.054l.105 -.035z", "key": "svg-0" }]]);

var IconArrowUpSquareFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArrowUpSquareFilled
});

var IconArtboardFilled = createReactComponent("filled", "artboard-filled", "IconArtboardFilled", [["path", { "d": "M15 7h-6a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-6a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 7a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-1" }], ["path", { "d": "M4 15a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-2" }], ["path", { "d": "M8 2a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z", "key": "svg-3" }], ["path", { "d": "M16 2a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z", "key": "svg-4" }], ["path", { "d": "M21 7a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-5" }], ["path", { "d": "M21 15a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-6" }], ["path", { "d": "M8 19a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z", "key": "svg-7" }], ["path", { "d": "M16 19a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z", "key": "svg-8" }]]);

var IconArtboardFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArtboardFilled
});

var IconArticleFilled = createReactComponent("filled", "article-filled", "IconArticleFilled", [["path", { "d": "M19 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h14zm-2 12h-10l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h10l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm0 -4h-10l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h10l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm0 -4h-10l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h10l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconArticleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconArticleFilled
});

var IconAspectRatioFilled = createReactComponent("filled", "aspect-ratio-filled", "IconAspectRatioFilled", [["path", { "d": "M19 4h-14a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3zm-10 3a1 1 0 0 1 .117 1.993l-.117 .007h-2v2a1 1 0 0 1 -.883 .993l-.117 .007a1 1 0 0 1 -.993 -.883l-.007 -.117v-3a1 1 0 0 1 .883 -.993l.117 -.007h3zm9 5a1 1 0 0 1 .993 .883l.007 .117v3a1 1 0 0 1 -.883 .993l-.117 .007h-3a1 1 0 0 1 -.117 -1.993l.117 -.007h2v-2a1 1 0 0 1 .883 -.993l.117 -.007z", "key": "svg-0" }]]);

var IconAspectRatioFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAspectRatioFilled
});

var IconAssemblyFilled = createReactComponent("filled", "assembly-filled", "IconAssemblyFilled", [["path", { "d": "M13.666 1.429l6.75 3.98q .1 .06 .18 .133l.009 .008l.106 .075a3.22 3.22 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808l6.775 -3.995a3.34 3.34 0 0 1 3.24 .015m-.64 5.343a2.03 2.03 0 0 0 -2 -.014l-3.023 1.804a1.99 1.99 0 0 0 -1.002 1.736v3.278a2 2 0 0 0 1.03 1.75l2.946 1.89c.657 .367 1.39 .367 1.994 .033l3.054 -1.955c.582 -.322 .976 -.992 .976 -1.719v-3.277l-.005 -.164a2 2 0 0 0 -.725 -1.391l-.092 -.07l-.056 -.047a1 1 0 0 0 -.096 -.064z", "key": "svg-0" }]]);

var IconAssemblyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAssemblyFilled
});

var IconAssetFilled = createReactComponent("filled", "asset-filled", "IconAssetFilled", [["path", { "d": "M19 2a3 3 0 0 1 2.86 3.91l-.107 .291l-.046 .093q -.061 .128 -.134 .25l-6.476 11.909a1 1 0 0 1 -.066 .104a7 7 0 0 1 -13.031 -3.557l.004 -.24a7 7 0 0 1 3.342 -5.732l.256 -.15l11.705 -6.355q .18 -.123 .378 -.22l.215 -.096l.136 -.048c.302 -.103 .627 -.159 .964 -.159m-10 10a3 3 0 0 0 -2.995 2.824l-.005 .176a3 3 0 1 0 3 -3m7.04 -6.512l-5.12 2.778a7.01 7.01 0 0 1 4.816 4.824l2.788 -5.128a3 3 0 0 1 -2.485 -2.474m2.961 -1.488a1 1 0 0 0 -.317 .051l-.31 .17a1 1 0 1 0 1.465 1.325l.072 -.13a1 1 0 0 0 -.91 -1.416", "key": "svg-0" }]]);

var IconAssetFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAssetFilled
});

var IconAtom2Filled = createReactComponent("filled", "atom-2-filled", "IconAtom2Filled", [["path", { "d": "M12 8a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z", "key": "svg-0" }], ["path", { "d": "M12 20a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M3 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M21 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-3" }], ["path", { "d": "M2.89 12.006a1 1 0 0 1 1.104 .884a8 8 0 0 0 4.444 6.311a1 1 0 1 1 -.876 1.799a10 10 0 0 1 -5.556 -7.89a1 1 0 0 1 .884 -1.103z", "key": "svg-4" }], ["path", { "d": "M20.993 12l.117 .006a1 1 0 0 1 .884 1.104a10 10 0 0 1 -5.556 7.889a1 1 0 1 1 -.876 -1.798a8 8 0 0 0 4.444 -6.31a1 1 0 0 1 .987 -.891z", "key": "svg-5" }], ["path", { "d": "M5.567 4.226a10 10 0 0 1 12.666 0a1 1 0 1 1 -1.266 1.548a8 8 0 0 0 -10.134 0a1 1 0 1 1 -1.266 -1.548z", "key": "svg-6" }]]);

var IconAtom2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAtom2Filled
});

var IconAutomaticGearboxFilled = createReactComponent("filled", "automatic-gearbox-filled", "IconAutomaticGearboxFilled", [["path", { "d": "M18 16a3 3 0 0 1 0 6h-1a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1zm0 4l.117 -.007a1 1 0 0 0 -.117 -1.993zm.5 -13a2.5 2.5 0 1 1 0 5h-.5v1a1 1 0 0 1 -.883 .993l-.117 .007a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1zm-.5 3h.5a.5 .5 0 1 0 0 -1h-.5zm-5 0a1 1 0 0 1 0 2h-3v6h3a1 1 0 0 1 0 2h-3a2 2 0 0 1 -2 -2v-6h-2a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-2.17a3 3 0 0 1 -2 -2.83l.005 -.176a3 3 0 1 1 3.996 3.005l-.001 2.171z", "key": "svg-0" }]]);

var IconAutomaticGearboxFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAutomaticGearboxFilled
});

var IconAwardFilled = createReactComponent("filled", "award-filled", "IconAwardFilled", [["path", { "d": "M19.496 13.983l1.966 3.406a1.001 1.001 0 0 1 -.705 1.488l-.113 .011l-.112 -.001l-2.933 -.19l-1.303 2.636a1.001 1.001 0 0 1 -1.608 .26l-.082 -.094l-.072 -.11l-1.968 -3.407a8.994 8.994 0 0 0 6.93 -3.999z", "key": "svg-0" }], ["path", { "d": "M11.43 17.982l-1.966 3.408a1.001 1.001 0 0 1 -1.622 .157l-.076 -.1l-.064 -.114l-1.304 -2.635l-2.931 .19a1.001 1.001 0 0 1 -1.022 -1.29l.04 -.107l.05 -.1l1.968 -3.409a8.994 8.994 0 0 0 6.927 4.001z", "key": "svg-1" }], ["path", { "d": "M12 2l.24 .004a7 7 0 0 1 6.76 6.996l-.003 .193l-.007 .192l-.018 .245l-.026 .242l-.024 .178a6.985 6.985 0 0 1 -.317 1.268l-.116 .308l-.153 .348a7.001 7.001 0 0 1 -12.688 -.028l-.13 -.297l-.052 -.133l-.08 -.217l-.095 -.294a6.96 6.96 0 0 1 -.093 -.344l-.06 -.271l-.049 -.271l-.02 -.139l-.039 -.323l-.024 -.365l-.006 -.292a7 7 0 0 1 6.76 -6.996l.24 -.004z", "key": "svg-2" }]]);

var IconAwardFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconAwardFilled
});

var IconBabyCarriageFilled = createReactComponent("filled", "baby-carriage-filled", "IconBabyCarriageFilled", [["path", { "d": "M14.5 2a6.5 6.5 0 0 1 6.49 6.858a1.04 1.04 0 0 1 -.04 .456a6.51 6.51 0 0 1 -3.757 5.103l.532 1.595q .135 -.012 .275 -.012a3 3 0 1 1 -3 3l.005 -.176a3 3 0 0 1 .894 -1.966l-.634 -1.903q -.377 .045 -.765 .045h-2.675q -.547 0 -1.076 -.083l-.648 1.941a3 3 0 1 1 -5.101 2.142l.004 -.176a3 3 0 0 1 3.27 -2.812l.56 -1.682a7 7 0 0 1 -3.652 -4.117l-1.402 -4.213h-1.78a1 1 0 0 1 -.993 -.883l-.007 -.117a1 1 0 0 1 1 -1h2.5a1 1 0 0 1 .949 .684l1.104 3.316h6.447v-5a1 1 0 0 1 1 -1zm-6.5 16a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m10 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconBabyCarriageFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBabyCarriageFilled
});

var IconBackspaceFilled = createReactComponent("filled", "backspace-filled", "IconBackspaceFilled", [["path", { "d": "M20 5a2 2 0 0 1 1.995 1.85l.005 .15v10a2 2 0 0 1 -1.85 1.995l-.15 .005h-11a1 1 0 0 1 -.608 -.206l-.1 -.087l-5.037 -5.04c-.809 -.904 -.847 -2.25 -.083 -3.23l.12 -.144l5 -5a1 1 0 0 1 .577 -.284l.131 -.009h11zm-7.489 4.14a1 1 0 0 0 -1.301 1.473l.083 .094l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.403 1.403l.094 -.083l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.403 -1.403l-.083 -.094l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.403 -1.403l-.094 .083l-1.293 1.292l-1.293 -1.292l-.094 -.083l-.102 -.07z", "key": "svg-0" }]]);

var IconBackspaceFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBackspaceFilled
});

var IconBadge3dFilled = createReactComponent("filled", "badge-3d-filled", "IconBadge3dFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-10.5 4h-1.5a1 1 0 1 0 0 2h1.5a.5 .5 0 0 1 .09 .992l-.09 .008h-.5c-1.287 0 -1.332 1.864 -.133 1.993l.133 .007h.5a.5 .5 0 1 1 0 1h-1.5a1 1 0 0 0 0 2h1.5a2.5 2.5 0 0 0 2.5 -2.5l-.005 -.164a2.5 2.5 0 0 0 -.477 -1.312l-.019 -.024l.019 -.024a2.5 2.5 0 0 0 -2.018 -3.976m6.5 0h-1a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h1a3 3 0 0 0 3 -3v-2a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v2a1 1 0 0 1 -.883 .993l-.117 .007z", "key": "svg-0" }]]);

var IconBadge3dFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadge3dFilled
});

var IconBadge4kFilled = createReactComponent("filled", "badge-4k-filled", "IconBadge4kFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-9 4a1 1 0 0 0 -1 1v2h-1v-2a1 1 0 1 0 -2 0v2a2 2 0 0 0 2 2h1v2a1 1 0 0 0 2 0v-6a1 1 0 0 0 -1 -1m7.555 .168a1 1 0 0 0 -1.387 .277l-1.168 1.751v-1.196a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v6a1 1 0 0 0 2 0v-1.196l1.168 1.75a1 1 0 0 0 1.286 .337l.1 -.059l.094 -.07a1 1 0 0 0 .184 -1.317l-1.63 -2.445l1.63 -2.445a1 1 0 0 0 -.277 -1.387", "key": "svg-0" }]]);

var IconBadge4kFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadge4kFilled
});

var IconBadge8kFilled = createReactComponent("filled", "badge-8k-filled", "IconBadge8kFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-1.445 4.168a1 1 0 0 0 -1.387 .277l-1.168 1.751v-1.196a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v6a1 1 0 0 0 2 0v-1.196l1.168 1.75a1 1 0 0 0 1.286 .337l.1 -.059l.094 -.07a1 1 0 0 0 .184 -1.317l-1.63 -2.445l1.63 -2.445a1 1 0 0 0 -.277 -1.387m-8.555 -.168h-1a2 2 0 0 0 -2 2v1l.005 .15c.022 .295 .108 .573 .245 .819l.019 .031l-.02 .031a2 2 0 0 0 -.249 .969v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2 -2v-1l-.005 -.15a2 2 0 0 0 -.245 -.819l-.019 -.031l.02 -.031c.158 -.287 .249 -.618 .249 -.969v-1a2 2 0 0 0 -2 -2m0 5v1h-1v-1zm0 -3v1h-1v-1z", "key": "svg-0" }]]);

var IconBadge8kFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadge8kFilled
});

var IconBadgeAdFilled = createReactComponent("filled", "badge-ad-filled", "IconBadgeAdFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-4 4h-1a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h1a3 3 0 0 0 3 -3v-2a3 3 0 0 0 -3 -3m-6.5 0a2.5 2.5 0 0 0 -2.5 2.5v4.5a1 1 0 0 0 2 0v-1h1v1a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-4.5a2.5 2.5 0 0 0 -2.5 -2.5m6.5 2a1 1 0 0 1 1 1v2a1 1 0 0 1 -.883 .993l-.117 .007zm-6.5 0a.5 .5 0 0 1 .5 .5v1.5h-1v-1.5a.5 .5 0 0 1 .41 -.492z", "key": "svg-0" }]]);

var IconBadgeAdFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeAdFilled
});

var IconBadgeArFilled = createReactComponent("filled", "badge-ar-filled", "IconBadgeArFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-10.5 4a2.5 2.5 0 0 0 -2.5 2.5v4.5a1 1 0 0 0 2 0v-1h1v1a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-4.5a2.5 2.5 0 0 0 -2.5 -2.5m7 0h-1.5a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-1.196l1.168 1.75a1 1 0 0 0 1.387 .278l.093 -.07a1 1 0 0 0 .184 -1.317l-1.159 -1.738l.044 -.023a2.5 2.5 0 0 0 -1.217 -4.684m-7 2a.5 .5 0 0 1 .5 .5v1.5h-1v-1.5a.5 .5 0 0 1 .41 -.492zm7 0a.5 .5 0 1 1 0 1h-.5v-1z", "key": "svg-0" }]]);

var IconBadgeArFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeArFilled
});

var IconBadgeCcFilled = createReactComponent("filled", "badge-cc-filled", "IconBadgeCcFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-10.5 4a2.5 2.5 0 0 0 -2.5 2.5v3a2.5 2.5 0 1 0 5 0a1 1 0 0 0 -2 0a.5 .5 0 1 1 -1 0v-3a.5 .5 0 1 1 1 0a1 1 0 0 0 2 0a2.5 2.5 0 0 0 -2.5 -2.5m7 0a2.5 2.5 0 0 0 -2.5 2.5v3a2.5 2.5 0 1 0 5 0a1 1 0 0 0 -2 0a.5 .5 0 1 1 -1 0v-3a.5 .5 0 1 1 1 0a1 1 0 0 0 2 0a2.5 2.5 0 0 0 -2.5 -2.5", "key": "svg-0" }]]);

var IconBadgeCcFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeCcFilled
});

var IconBadgeHdFilled = createReactComponent("filled", "badge-hd-filled", "IconBadgeHdFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-4 4h-1a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h1a3 3 0 0 0 3 -3v-2a3 3 0 0 0 -3 -3m-5 0a1 1 0 0 0 -1 1v2h-1v-2a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v6a1 1 0 0 0 2 0v-2h1v2a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1m5 2a1 1 0 0 1 1 1v2a1 1 0 0 1 -.883 .993l-.117 .007z", "key": "svg-0" }]]);

var IconBadgeHdFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeHdFilled
});

var IconBadgeSdFilled = createReactComponent("filled", "badge-sd-filled", "IconBadgeSdFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-4 4h-1a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h1a3 3 0 0 0 3 -3v-2a3 3 0 0 0 -3 -3m-5.75 0h-1.25a2 2 0 0 0 -2 2v1a2 2 0 0 0 2 2h1v1h-1.033l-.025 -.087a1 1 0 0 0 -1.942 .337c0 .966 .784 1.75 1.75 1.75h1.25a2 2 0 0 0 2 -2v-1a2 2 0 0 0 -2 -2h-1v-1h1.032l.026 .087a1 1 0 0 0 1.942 -.337a1.75 1.75 0 0 0 -1.75 -1.75m5.75 2a1 1 0 0 1 1 1v2a1 1 0 0 1 -.883 .993l-.117 .007z", "key": "svg-0" }]]);

var IconBadgeSdFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeSdFilled
});

var IconBadgeTmFilled = createReactComponent("filled", "badge-tm-filled", "IconBadgeTmFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-9 4h-4a1 1 0 1 0 0 2h1v5a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-5h1a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1m8 1c0 -.99 -1.283 -1.378 -1.832 -.555l-1.168 1.752l-1.168 -1.752c-.549 -.823 -1.832 -.434 -1.832 .555v6a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-2.697l.168 .252l.08 .104a1 1 0 0 0 1.584 -.104l.168 -.253v2.698a1 1 0 0 0 2 0z", "key": "svg-0" }]]);

var IconBadgeTmFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeTmFilled
});

var IconBadgeVoFilled = createReactComponent("filled", "badge-vo-filled", "IconBadgeVoFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-3.5 4a2.5 2.5 0 0 0 -2.5 2.5v3a2.5 2.5 0 1 0 5 0v-3a2.5 2.5 0 0 0 -2.5 -2.5m-4.184 .051a1 1 0 0 0 -1.265 .633l-1.051 3.154l-1.051 -3.154a1 1 0 0 0 -1.898 .632l2 6c.304 .912 1.594 .912 1.898 0l2 -6a1 1 0 0 0 -.633 -1.265m4.184 1.949a.5 .5 0 0 1 .5 .5v3a.5 .5 0 1 1 -1 0v-3a.5 .5 0 0 1 .5 -.5", "key": "svg-0" }]]);

var IconBadgeVoFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeVoFilled
});

var IconBadgeVrFilled = createReactComponent("filled", "badge-vr-filled", "IconBadgeVrFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-3.5 4h-1.5a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-1.196l1.168 1.75a1 1 0 0 0 1.387 .278l.093 -.07a1 1 0 0 0 .184 -1.317l-1.159 -1.738l.044 -.023a2.5 2.5 0 0 0 -1.217 -4.684m-4.184 .051a1 1 0 0 0 -1.265 .633l-1.051 3.154l-1.051 -3.154a1 1 0 0 0 -1.898 .632l2 6c.304 .912 1.594 .912 1.898 0l2 -6a1 1 0 0 0 -.633 -1.265m4.184 1.949a.5 .5 0 1 1 0 1h-.5v-1z", "key": "svg-0" }]]);

var IconBadgeVrFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeVrFilled
});

var IconBadgeWcFilled = createReactComponent("filled", "badge-wc-filled", "IconBadgeWcFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-7.534 4a1 1 0 0 0 -.963 .917l-.204 2.445l-.405 -.81l-.063 -.11a1 1 0 0 0 -1.725 .11l-.406 .81l-.203 -2.445a1 1 0 0 0 -.963 -.917l-.117 .003a1 1 0 0 0 -.914 1.08l.5 6l.016 .117c.175 .91 1.441 1.115 1.875 .247l1.106 -2.211l1.106 2.211c.452 .904 1.807 .643 1.89 -.364l.5 -6a1 1 0 0 0 -.913 -1.08zm4.034 0a2.5 2.5 0 0 0 -2.5 2.5v3a2.5 2.5 0 1 0 5 0a1 1 0 0 0 -2 0a.5 .5 0 1 1 -1 0v-3a.5 .5 0 1 1 1 0a1 1 0 0 0 2 0a2.5 2.5 0 0 0 -2.5 -2.5", "key": "svg-0" }]]);

var IconBadgeWcFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeWcFilled
});

var IconBadgeFilled = createReactComponent("filled", "badge-filled", "IconBadgeFilled", [["path", { "d": "M16.486 3.143l-4.486 2.69l-4.486 -2.69a1 1 0 0 0 -1.514 .857v13a1 1 0 0 0 .486 .857l5 3a1 1 0 0 0 1.028 0l5 -3a1 1 0 0 0 .486 -.857v-13a1 1 0 0 0 -1.514 -.857z", "key": "svg-0" }]]);

var IconBadgeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgeFilled
});

var IconBadgesFilled = createReactComponent("filled", "badges-filled", "IconBadgesFilled", [["path", { "d": "M16.486 12.143l-4.486 2.69l-4.486 -2.69a1 1 0 0 0 -1.514 .857v4a1 1 0 0 0 .486 .857l5 3a1 1 0 0 0 1.028 0l5 -3a1 1 0 0 0 .486 -.857v-4a1 1 0 0 0 -1.514 -.857z", "key": "svg-0" }], ["path", { "d": "M16.486 3.143l-4.486 2.69l-4.486 -2.69a1 1 0 0 0 -1.514 .857v4a1 1 0 0 0 .486 .857l5 3a1 1 0 0 0 1.028 0l5 -3a1 1 0 0 0 .486 -.857v-4a1 1 0 0 0 -1.514 -.857z", "key": "svg-1" }]]);

var IconBadgesFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBadgesFilled
});

var IconBalloonFilled = createReactComponent("filled", "balloon-filled", "IconBalloonFilled", [["path", { "d": "M12 1a7 7 0 0 1 7 7c0 5.457 -3.028 10 -7 10c-3.9 0 -6.89 -4.379 -6.997 -9.703l-.003 -.297l.004 -.24a7 7 0 0 1 6.996 -6.76zm0 4a1 1 0 0 0 0 2l.117 .007a1 1 0 0 1 .883 .993l.007 .117a1 1 0 0 0 1.993 -.117a3 3 0 0 0 -3 -3z", "key": "svg-0" }], ["path", { "d": "M12 16a1 1 0 0 1 .993 .883l.007 .117v1a3 3 0 0 1 -2.824 2.995l-.176 .005h-3a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 1 -2 0a3 3 0 0 1 2.824 -2.995l.176 -.005h3a1 1 0 0 0 .993 -.883l.007 -.117v-1a1 1 0 0 1 1 -1z", "key": "svg-1" }]]);

var IconBalloonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBalloonFilled
});

var IconBallpenFilled = createReactComponent("filled", "ballpen-filled", "IconBallpenFilled", [["path", { "d": "M17.828 2a3 3 0 0 1 1.977 .743l.145 .136l1.171 1.17a3 3 0 0 1 .136 4.1l-.136 .144l-1.706 1.707l2.292 2.293a1 1 0 0 1 .083 1.32l-.083 .094l-4 4a1 1 0 0 1 -1.497 -1.32l.083 -.094l3.292 -3.293l-1.586 -1.585l-7.464 7.464a3.828 3.828 0 0 1 -2.474 1.114l-.233 .008c-.674 0 -1.33 -.178 -1.905 -.508l-1.216 1.214a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.214 -1.216a3.828 3.828 0 0 1 .454 -4.442l.16 -.17l10.586 -10.586a3 3 0 0 1 1.923 -.873l.198 -.006zm0 2a1 1 0 0 0 -.608 .206l-.099 .087l-1.707 1.707l2.586 2.585l1.707 -1.706a1 1 0 0 0 .284 -.576l.01 -.131a1 1 0 0 0 -.207 -.609l-.087 -.099l-1.171 -1.171a1 1 0 0 0 -.708 -.293z", "key": "svg-0" }]]);

var IconBallpenFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBallpenFilled
});

var IconBandageFilled = createReactComponent("filled", "bandage-filled", "IconBandageFilled", [["path", { "d": "M20.207 3.793a5.95 5.95 0 0 1 .179 8.228l-.179 .186l-8 8a5.95 5.95 0 0 1 -8.593 -8.228l.179 -.186l8 -8a5.95 5.95 0 0 1 8.414 0zm-8.207 9.207a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm2 -2a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm-4 0a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm2 -2a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconBandageFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBandageFilled
});

var IconBarbellFilled = createReactComponent("filled", "barbell-filled", "IconBarbellFilled", [["path", { "d": "M4 7a1 1 0 0 1 1 1v8a1 1 0 0 1 -2 0v-3h-1a1 1 0 0 1 0 -2h1v-3a1 1 0 0 1 1 -1", "key": "svg-0" }], ["path", { "d": "M20 7a1 1 0 0 1 1 1v3h1a1 1 0 0 1 0 2h-1v3a1 1 0 0 1 -2 0v-8a1 1 0 0 1 1 -1", "key": "svg-1" }], ["path", { "d": "M16 5a2 2 0 0 1 2 2v10a2 2 0 1 1 -4 0v-4h-4v4a2 2 0 1 1 -4 0v-10a2 2 0 1 1 4 0v4h4v-4a2 2 0 0 1 2 -2", "key": "svg-2" }]]);

var IconBarbellFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBarbellFilled
});

var IconBarrierBlockFilled = createReactComponent("filled", "barrier-block-filled", "IconBarrierBlockFilled", [["path", { "d": "M15 21a1 1 0 0 1 0 -2h1v-2h-8v2h1a1 1 0 0 1 0 2h-4a1 1 0 0 1 0 -2h1v-2h-1a2 2 0 0 1 -2 -2v-7a2 2 0 0 1 2 -2h1v-1a1 1 0 1 1 2 0v1h8v-1a1 1 0 0 1 2 0v1h1a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-1v2h1a1 1 0 0 1 0 2zm-2.086 -13l-7 7h4.17l6.916 -7zm6.086 2.914l-4.086 4.086h4.086zm-10.916 -2.914h-3.084v3.084z", "key": "svg-0" }]]);

var IconBarrierBlockFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBarrierBlockFilled
});

var IconBasketFilled = createReactComponent("filled", "basket-filled", "IconBasketFilled", [["path", { "d": "M15.949 3.684l1.104 3.316h1.947a3 3 0 0 1 2.962 3.477l-1.252 7.131a4 4 0 0 1 -3.954 3.392h-9.512a3.994 3.994 0 0 1 -3.95 -3.371l-1.258 -7.173a3 3 0 0 1 2.964 -3.456h1.945l1.105 -3.316a1 1 0 0 1 1.898 .632l-.895 2.684h5.893l-.895 -2.684a1 1 0 1 1 1.898 -.632m-3.949 7.316a3 3 0 0 0 -2.995 2.824l-.005 .176a3 3 0 1 0 3 -3", "key": "svg-0" }]]);

var IconBasketFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBasketFilled
});

var IconBathFilled = createReactComponent("filled", "bath-filled", "IconBathFilled", [["path", { "d": "M11 2a1 1 0 0 1 .993 .883l.007 .117v2.25a1 1 0 0 1 -1.993 .117l-.007 -.117v-1.25h-2a1 1 0 0 0 -.993 .883l-.007 .117v6h13a2 2 0 0 1 1.995 1.85l.005 .15v3c0 1.475 -.638 2.8 -1.654 3.715l.486 .73a1 1 0 0 1 -1.594 1.203l-.07 -.093l-.55 -.823a4.98 4.98 0 0 1 -1.337 .26l-.281 .008h-10a4.994 4.994 0 0 1 -1.619 -.268l-.549 .823a1 1 0 0 1 -1.723 -1.009l.059 -.1l.486 -.73a4.987 4.987 0 0 1 -1.647 -3.457l-.007 -.259v-3a2 2 0 0 1 1.85 -1.995l.15 -.005h1v-6a3 3 0 0 1 2.824 -2.995l.176 -.005h3z", "key": "svg-0" }]]);

var IconBathFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBathFilled
});

var IconBattery1Filled = createReactComponent("filled", "battery-1-filled", "IconBattery1Filled", [["path", { "d": "M17 6a3 3 0 0 1 2.995 2.824l.005 .176v.086l.052 .019a1.5 1.5 0 0 1 .941 1.25l.007 .145v3a1.5 1.5 0 0 1 -.948 1.395l-.052 .018v.087a3 3 0 0 1 -2.824 2.995l-.176 .005h-11a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a3 3 0 0 1 2.824 -2.995l.176 -.005h11zm-10 3a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconBattery1Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBattery1Filled
});

var IconBattery2Filled = createReactComponent("filled", "battery-2-filled", "IconBattery2Filled", [["path", { "d": "M17 6a3 3 0 0 1 2.995 2.824l.005 .176v.086l.052 .019a1.5 1.5 0 0 1 .941 1.25l.007 .145v3a1.5 1.5 0 0 1 -.948 1.395l-.052 .018v.087a3 3 0 0 1 -2.824 2.995l-.176 .005h-11a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a3 3 0 0 1 2.824 -2.995l.176 -.005h11zm-10 3a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconBattery2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBattery2Filled
});

var IconBattery3Filled = createReactComponent("filled", "battery-3-filled", "IconBattery3Filled", [["path", { "d": "M17 6a3 3 0 0 1 2.995 2.824l.005 .176v.086l.052 .019a1.5 1.5 0 0 1 .941 1.25l.007 .145v3a1.5 1.5 0 0 1 -.948 1.395l-.052 .018v.087a3 3 0 0 1 -2.824 2.995l-.176 .005h-11a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a3 3 0 0 1 2.824 -2.995l.176 -.005h11zm-10 3a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconBattery3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBattery3Filled
});

var IconBattery4Filled = createReactComponent("filled", "battery-4-filled", "IconBattery4Filled", [["path", { "d": "M17 6a3 3 0 0 1 2.995 2.824l.005 .176v.086l.052 .019a1.5 1.5 0 0 1 .941 1.25l.007 .145v3a1.5 1.5 0 0 1 -.948 1.395l-.052 .018v.087a3 3 0 0 1 -2.824 2.995l-.176 .005h-11a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a3 3 0 0 1 2.824 -2.995l.176 -.005h11zm-10 3a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconBattery4Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBattery4Filled
});

var IconBatteryAutomotiveFilled = createReactComponent("filled", "battery-automotive-filled", "IconBatteryAutomotiveFilled", [["path", { "d": "M18 2a1 1 0 0 1 1 1v1a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3v-1a1 1 0 1 1 2 0v1h10v-1a1 1 0 0 1 1 -1m-2 7.5a1 1 0 0 0 -1 1v.5h-.5a1 1 0 0 0 0 2h.5v.5a1 1 0 0 0 2 0v-.5h.5a1 1 0 0 0 0 -2h-.5v-.5a1 1 0 0 0 -1 -1m-6.5 1.5h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconBatteryAutomotiveFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryAutomotiveFilled
});

var IconBatteryVertical1Filled = createReactComponent("filled", "battery-vertical-1-filled", "IconBatteryVertical1Filled", [["path", { "d": "M13.5 3a1.5 1.5 0 0 1 1.395 .948l.018 .052h.087a3 3 0 0 1 2.995 2.824l.005 .176v11a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3v-11a3 3 0 0 1 3 -3h.086l.019 -.052a1.5 1.5 0 0 1 1.25 -.941l.145 -.007zm.5 13h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconBatteryVertical1Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVertical1Filled
});

var IconBatteryVertical2Filled = createReactComponent("filled", "battery-vertical-2-filled", "IconBatteryVertical2Filled", [["path", { "d": "M13.5 3a1.5 1.5 0 0 1 1.395 .948l.018 .052h.087a3 3 0 0 1 2.995 2.824l.005 .176v11a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3v-11a3 3 0 0 1 3 -3h.086l.019 -.052a1.5 1.5 0 0 1 1.25 -.941l.145 -.007zm.5 13h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2m0 -3h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconBatteryVertical2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVertical2Filled
});

var IconBatteryVertical3Filled = createReactComponent("filled", "battery-vertical-3-filled", "IconBatteryVertical3Filled", [["path", { "d": "M13.5 3a1.5 1.5 0 0 1 1.395 .948l.018 .052h.087a3 3 0 0 1 2.995 2.824l.005 .176v11a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3v-11a3 3 0 0 1 3 -3h.086l.019 -.052a1.5 1.5 0 0 1 1.25 -.941l.145 -.007zm.5 13h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2m0 -3h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2m0 -3h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconBatteryVertical3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVertical3Filled
});

var IconBatteryVertical4Filled = createReactComponent("filled", "battery-vertical-4-filled", "IconBatteryVertical4Filled", [["path", { "d": "M13.5 3a1.5 1.5 0 0 1 1.395 .948l.018 .052h.087a3 3 0 0 1 2.995 2.824l.005 .176v11a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3v-11a3 3 0 0 1 3 -3h.086l.019 -.052a1.5 1.5 0 0 1 1.25 -.941l.145 -.007zm.5 13h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2m0 -3h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2m0 -3h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2m0 -3h-4a1 1 0 1 0 0 2h4a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconBatteryVertical4Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVertical4Filled
});

var IconBatteryVerticalFilled = createReactComponent("filled", "battery-vertical-filled", "IconBatteryVerticalFilled", [["path", { "d": "M13.5 3a1.5 1.5 0 0 1 1.395 .948l.018 .052h.087a3 3 0 0 1 2.995 2.824l.005 .176v11a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3v-11a3 3 0 0 1 3 -3h.086l.019 -.052a1.5 1.5 0 0 1 1.25 -.941l.145 -.007z", "key": "svg-0" }]]);

var IconBatteryVerticalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryVerticalFilled
});

var IconBatteryFilled = createReactComponent("filled", "battery-filled", "IconBatteryFilled", [["path", { "d": "M17 6a3 3 0 0 1 2.995 2.824l.005 .176v.086l.052 .019a1.5 1.5 0 0 1 .941 1.25l.007 .145v3a1.5 1.5 0 0 1 -.948 1.395l-.052 .018v.087a3 3 0 0 1 -2.824 2.995l-.176 .005h-11a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a3 3 0 0 1 2.824 -2.995l.176 -.005h11z", "key": "svg-0" }]]);

var IconBatteryFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBatteryFilled
});

var IconBedFlatFilled = createReactComponent("filled", "bed-flat-filled", "IconBedFlatFilled", [["path", { "d": "M5 8a3 3 0 1 1 -3 3l.005 -.176a3 3 0 0 1 2.995 -2.824", "key": "svg-0" }], ["path", { "d": "M18 7a4 4 0 0 1 4 4v2a1 1 0 0 1 -1 1h-11a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M21 15a1 1 0 0 1 0 2h-18a1 1 0 0 1 0 -2z", "key": "svg-2" }]]);

var IconBedFlatFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBedFlatFilled
});

var IconBedFilled = createReactComponent("filled", "bed-filled", "IconBedFilled", [["path", { "d": "M3 6a1 1 0 0 1 .993 .883l.007 .117v6h6v-5a1 1 0 0 1 .883 -.993l.117 -.007h8a3 3 0 0 1 2.995 2.824l.005 .176v8a1 1 0 0 1 -1.993 .117l-.007 -.117v-3h-16v3a1 1 0 0 1 -1.993 .117l-.007 -.117v-11a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M7 8a2 2 0 1 1 -1.995 2.15l-.005 -.15l.005 -.15a2 2 0 0 1 1.995 -1.85z", "key": "svg-1" }]]);

var IconBedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBedFilled
});

var IconBeerFilled = createReactComponent("filled", "beer-filled", "IconBeerFilled", [["path", { "d": "M17 2a2 2 0 0 1 1.995 1.85l.005 .15v4c0 1.335 -.229 2.386 -.774 3.692l-.157 .363l-.31 .701a8.902 8.902 0 0 0 -.751 3.242l-.008 .377v3.625a2 2 0 0 1 -1.85 1.995l-.15 .005h-6a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3.625c0 -1.132 -.21 -2.25 -.617 -3.28l-.142 -.34l-.31 -.699c-.604 -1.358 -.883 -2.41 -.925 -3.698l-.006 -.358v-4a2 2 0 0 1 1.85 -1.995l.15 -.005h10zm0 2h-10v3h10v-3z", "key": "svg-0" }]]);

var IconBeerFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBeerFilled
});

var IconBellMinusFilled = createReactComponent("filled", "bell-minus-filled", "IconBellMinusFilled", [["path", { "d": "M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z", "key": "svg-0" }], ["path", { "d": "M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004zm2 8h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-1" }]]);

var IconBellMinusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellMinusFilled
});

var IconBellPlusFilled = createReactComponent("filled", "bell-plus-filled", "IconBellPlusFilled", [["path", { "d": "M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z", "key": "svg-0" }], ["path", { "d": "M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004zm0 6a1 1 0 0 0 -1 1v1h-1l-.117 .007a1 1 0 0 0 .117 1.993h1v1l.007 .117a1 1 0 0 0 1.993 -.117v-1h1l.117 -.007a1 1 0 0 0 -.117 -1.993h-1v-1l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-1" }]]);

var IconBellPlusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellPlusFilled
});

var IconBellRinging2Filled = createReactComponent("filled", "bell-ringing-2-filled", "IconBellRinging2Filled", [["path", { "d": "M9.63 17.531c.612 .611 .211 1.658 -.652 1.706a3.992 3.992 0 0 1 -3.05 -1.166a3.992 3.992 0 0 1 -1.165 -3.049c.046 -.826 1.005 -1.228 1.624 -.726l.082 .074l3.161 3.16z", "key": "svg-0" }], ["path", { "d": "M20.071 3.929c.96 .96 1.134 2.41 .52 3.547l-.09 .153l-.024 .036a8.013 8.013 0 0 1 -1.446 7.137l-.183 .223l-.191 .218l-2.073 2.072l-.08 .112a3 3 0 0 0 -.499 2.113l.035 .201l.045 .185c.264 .952 -.853 1.645 -1.585 1.051l-.086 -.078l-11.313 -11.313c-.727 -.727 -.017 -1.945 .973 -1.671a3 3 0 0 0 2.5 -.418l.116 -.086l2.101 -2.1a8 8 0 0 1 7.265 -1.86l.278 .071l.037 -.023a3.003 3.003 0 0 1 3.432 .192l.14 .117l.128 .12z", "key": "svg-1" }]]);

var IconBellRinging2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellRinging2Filled
});

var IconBellRingingFilled = createReactComponent("filled", "bell-ringing-filled", "IconBellRingingFilled", [["path", { "d": "M17.451 2.344a1 1 0 0 1 1.41 -.099a12.05 12.05 0 0 1 3.048 4.064a1 1 0 1 1 -1.818 .836a10.05 10.05 0 0 0 -2.54 -3.39a1 1 0 0 1 -.1 -1.41z", "key": "svg-0" }], ["path", { "d": "M5.136 2.245a1 1 0 0 1 1.312 1.51a10.05 10.05 0 0 0 -2.54 3.39a1 1 0 1 1 -1.817 -.835a12.05 12.05 0 0 1 3.045 -4.065z", "key": "svg-1" }], ["path", { "d": "M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z", "key": "svg-2" }], ["path", { "d": "M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004z", "key": "svg-3" }]]);

var IconBellRingingFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellRingingFilled
});

var IconBellXFilled = createReactComponent("filled", "bell-x-filled", "IconBellXFilled", [["path", { "d": "M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z", "key": "svg-0" }], ["path", { "d": "M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004zm-1.489 6.14a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z", "key": "svg-1" }]]);

var IconBellXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellXFilled
});

var IconBellZFilled = createReactComponent("filled", "bell-z-filled", "IconBellZFilled", [["path", { "d": "M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z", "key": "svg-0" }], ["path", { "d": "M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004zm2 6h-4l-.117 .007a1 1 0 0 0 -.883 .993l.007 .117a1 1 0 0 0 .993 .883h1.584l-2.291 2.293l-.076 .084c-.514 .637 -.07 1.623 .783 1.623h4l.117 -.007a1 1 0 0 0 .883 -.993l-.007 -.117a1 1 0 0 0 -.993 -.883h-1.586l2.293 -2.293l.076 -.084c.514 -.637 .07 -1.623 -.783 -1.623z", "key": "svg-1" }]]);

var IconBellZFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellZFilled
});

var IconBellFilled = createReactComponent("filled", "bell-filled", "IconBellFilled", [["path", { "d": "M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z", "key": "svg-0" }], ["path", { "d": "M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004z", "key": "svg-1" }]]);

var IconBellFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBellFilled
});

var IconBikeFilled = createReactComponent("filled", "bike-filled", "IconBikeFilled", [["path", { "d": "M5 14a4 4 0 1 1 -4 4l.005 -.2a4 4 0 0 1 3.995 -3.8", "key": "svg-0" }], ["path", { "d": "M19 14a4 4 0 1 1 -4 4l.005 -.2a4 4 0 0 1 3.995 -3.8", "key": "svg-1" }], ["path", { "d": "M14.832 7.445l1.703 2.555h2.465a1 1 0 0 1 .993 .883l.007 .117a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -.832 -.445l-1.396 -2.093l-3.275 2.62l2.21 2.21a1 1 0 0 1 .284 .577l.009 .131v4a1 1 0 0 1 -2 0v-3.585l-2.707 -2.708a1 1 0 0 1 -.01 -1.403l.092 -.085l5 -4a1 1 0 0 1 1.457 .226", "key": "svg-2" }], ["path", { "d": "M17 3a2 2 0 1 1 -2 2l.005 -.15a2 2 0 0 1 1.995 -1.85", "key": "svg-3" }]]);

var IconBikeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBikeFilled
});

var IconBinaryTree2Filled = createReactComponent("filled", "binary-tree-2-filled", "IconBinaryTree2Filled", [["path", { "d": "M12 3a3 3 0 0 1 2.616 4.47l3.274 3.742a3 3 0 1 1 -1.505 1.318l-3.275 -3.743l-.11 .042v6.342a3.001 3.001 0 1 1 -2 0v-6.342l-.111 -.041l-3.274 3.742a3 3 0 1 1 -1.505 -1.318l3.273 -3.742a3 3 0 0 1 2.617 -4.47", "key": "svg-0" }]]);

var IconBinaryTree2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBinaryTree2Filled
});

var IconBinaryTreeFilled = createReactComponent("filled", "binary-tree-filled", "IconBinaryTreeFilled", [["path", { "d": "M14 1a3 3 0 0 1 2.348 4.868l2 3.203q .317 -.071 .652 -.071a3 3 0 1 1 -2.347 1.132l-2 -3.203a3 3 0 0 1 -1.304 0l-2.001 3.203c.408 .513 .652 1.162 .652 1.868s-.244 1.356 -.653 1.868l2.002 3.203q .315 -.071 .651 -.071a3 3 0 1 1 -2.347 1.132l-2.003 -3.203a3 3 0 0 1 -1.302 0l-2.002 3.203a3 3 0 1 1 -1.696 -1.06l2.002 -3.204a3 3 0 0 1 2.998 -4.798l2.002 -3.202a3 3 0 0 1 2.348 -4.868", "key": "svg-0" }]]);

var IconBinaryTreeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBinaryTreeFilled
});

var IconBinocularsFilled = createReactComponent("filled", "binoculars-filled", "IconBinocularsFilled", [["path", { "d": "M8.887 6.748c-.163 0 -.337 .016 -.506 .057c-.172 .041 -.582 .165 -.838 .562l-.014 .02l-.607 1.05c-.307 .205 -.534 .46 -.693 .717l-.014 .02l-2.572 4.65a4.009 4.009 0 0 0 -.274 .494l-.006 .01a3.99 3.99 0 0 0 -.363 1.672a4 4 0 0 0 8 0v-1h2v1a4 4 0 1 0 7.635 -1.67l-.004 -.012a4.008 4.008 0 0 0 -.274 -.494l-2.572 -4.65l-.014 -.02a2.337 2.337 0 0 0 -.693 -.716l-.607 -1.051l-.014 -.02c-.256 -.397 -.667 -.52 -.838 -.562a2.225 2.225 0 0 0 -.664 -.051a2.06 2.06 0 0 0 -.68 .156c-.184 .081 -.638 .327 -.754 .889l-.007 .037l-.14 1.1c-.22 .283 -.374 .64 -.374 1.064v1h-2v-1c0 -.424 -.154 -.781 -.373 -1.064l-.14 -1.1l-.008 -.037c-.116 -.562 -.57 -.808 -.754 -.889a2.06 2.06 0 0 0 -.68 -.156a2.374 2.374 0 0 0 -.158 -.006zm-1.887 7.252a2 2 0 1 1 -1.838 1.209l.19 -.342c.36 -.523 .964 -.867 1.648 -.867zm10 0c.684 0 1.288 .344 1.648 .867l.19 .342a2 2 0 1 1 -1.838 -1.209z", "key": "svg-0" }]]);

var IconBinocularsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBinocularsFilled
});

var IconBiohazardFilled = createReactComponent("filled", "biohazard-filled", "IconBiohazardFilled", [["path", { "d": "M16.41 2.072a6.25 6.25 0 0 1 1.514 6.387l-.051 .137l.223 .044q .325 .072 .645 .18l.318 .117l.25 .105c2.155 .97 3.572 3.067 3.681 5.483v.217a1.5 1.5 0 1 1 -3 -.003l.002 -.145a3.25 3.25 0 0 0 -4.412 -2.886l-.091 .037l.004 .038l.007 .217a3.5 3.5 0 0 1 -1.817 3.07l-.16 .082l.014 .11c.082 .511 .285 .997 .595 1.416l.14 .175a3.25 3.25 0 0 0 2.27 1.136l.203 .006a1.5 1.5 0 0 1 0 3a6.25 6.25 0 0 1 -4.575 -1.991l-.177 -.199l-.078 .092a6.3 6.3 0 0 1 -3.921 2.054l-.273 .028l-.259 .016h-.217a1.5 1.5 0 1 1 .003 -3l.145 .002a3.25 3.25 0 0 0 3.074 -2.82l.003 -.03l-.161 -.083a3.5 3.5 0 0 1 -1.804 -2.883l-.005 -.195l.006 -.191l.003 -.043l-.075 -.032a3.25 3.25 0 0 0 -2.398 .008l-.191 .084a3.25 3.25 0 0 0 -1.85 2.933a1.5 1.5 0 0 1 -3 0a6.25 6.25 0 0 1 5.036 -6.13l.077 -.014l-.05 -.143l-.08 -.26l-.066 -.25a6.27 6.27 0 0 1 1.47 -5.678l.163 -.172a1.5 1.5 0 1 1 2.171 2.07l-.137 .143a3.25 3.25 0 0 0 .386 4.723l.084 .062l.05 -.034a3.5 3.5 0 0 1 1.673 -.555l.228 -.007c.683 0 1.336 .197 1.894 .556l.048 .033l.067 -.048a3.25 3.25 0 0 0 1.111 -1.669l.05 -.2a3.25 3.25 0 0 0 -.74 -2.828l-.141 -.15a1.5 1.5 0 1 1 2.12 -2.122", "key": "svg-0" }]]);

var IconBiohazardFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBiohazardFilled
});

var IconBladeFilled = createReactComponent("filled", "blade-filled", "IconBladeFilled", [["path", { "d": "M11.586 3a2 2 0 0 1 2.828 0l.586 .585l.586 -.585a2 2 0 0 1 2.7 -.117l.128 .117l2.586 2.586a2 2 0 0 1 0 2.828l-.586 .586l.586 .586a2 2 0 0 1 0 2.828l-8.586 8.586a2 2 0 0 1 -2.828 0l-.586 -.586l-.586 .586a2 2 0 0 1 -2.828 0l-2.586 -2.586a2 2 0 0 1 0 -2.828l.585 -.587l-.585 -.585a2 2 0 0 1 -.117 -2.7l.117 -.129zm3.027 4.21a1 1 0 0 0 -1.32 1.497l.292 .293l-1.068 1.067a2.003 2.003 0 0 0 -2.512 1.784l-.005 .149l.005 .15c.01 .125 .03 .248 .062 .367l-1.067 1.068l-.293 -.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l.292 .293l-.292 .293l-.083 .094a1 1 0 0 0 1.497 1.32l.293 -.292l.293 .292l.094 .083a1 1 0 0 0 1.32 -1.497l-.292 -.293l1.069 -1.067a2.003 2.003 0 0 0 2.449 -2.45l1.067 -1.068l.293 .292l.094 .083a1 1 0 0 0 1.32 -1.497l-.292 -.293l.292 -.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-.293 .292l-.293 -.292z", "key": "svg-0" }]]);

var IconBladeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBladeFilled
});

var IconBlenderFilled = createReactComponent("filled", "blender-filled", "IconBlenderFilled", [["path", { "d": "M15 14c.899 0 1.728 .296 2.396 .797l-.12 -.086q .101 .069 .196 .144l-.076 -.058q .07 .053 .14 .109l-.064 -.05q .072 .055 .14 .115l-.077 -.065a4 4 0 0 1 .565 .566l-.065 -.078q .061 .072 .12 .147l-.055 -.07q .057 .071 .111 .144l-.056 -.074q .066 .084 .127 .172l-.07 -.098q .058 .078 .112 .16l-.042 -.062q .054 .078 .104 .157l-.062 -.096q .06 .09 .117 .185l-.055 -.089l.09 .15l-.035 -.061a4 4 0 0 1 .338 .727l-.055 -.15q .039 .1 .073 .201l-.018 -.051q .033 .093 .06 .188l-.042 -.137q .033 .1 .061 .204l-.019 -.067q .027 .091 .05 .184l-.03 -.117q .03 .114 .055 .23l-.025 -.113q .026 .107 .045 .215l-.02 -.101q .021 .1 .037 .201l-.017 -.1q .018 .095 .03 .19l-.013 -.09a4 4 0 0 1 .026 .196l.017 .205l.006 .226v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-2q 0 -.273 .036 -.537l-.013 .105a4 4 0 0 1 .026 -.194l-.013 .09a4 4 0 0 1 .03 -.191l-.017 .1q .015 -.1 .037 -.2l-.02 .1q .02 -.108 .046 -.215l-.026 .114q .024 -.117 .056 -.23l-.03 .116a4 4 0 0 1 .049 -.184l-.02 .067q .03 -.104 .062 -.204l-.042 .137q .027 -.096 .06 -.188l-.018 .051a4 4 0 0 1 .32 -.717l-.064 .117q .048 -.09 .1 -.178l-.035 .06l.09 -.15l-.055 .09q .055 -.094 .117 -.185l-.062 .096q .05 -.08 .104 -.157l-.042 .061q .054 -.08 .113 -.16l-.071 .1q .06 -.09 .127 -.173l-.056 .074q .054 -.073 .111 -.143l-.055 .069a4 4 0 0 1 .542 -.57l-.072 .064q .073 -.066 .15 -.129l-.078 .065a4 4 0 0 1 .14 -.116l-.062 .051q .068 -.056 .139 -.11l-.076 .06q .096 -.076 .195 -.145l-.12 .086q .07 -.053 .142 -.101l-.022 .015q .072 -.05 .145 -.096a4 4 0 0 1 2.132 -.615zm-2 3a1 1 0 0 0 -.993 .883l-.007 .127a1 1 0 0 0 1.993 .117l.007 -.127a1 1 0 0 0 -1 -1m1 -15a1 1 0 0 1 1 .999l1.802 .001a2 2 0 0 1 1.968 2.358l-1.49 8.191a5 5 0 0 0 -2.28 -.549h-4c-.822 0 -1.597 .198 -2.28 .55l-.464 -2.551l-2.256 .001a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2l5 -.001l.007 -.116a1 1 0 0 1 .993 -.883zm-6.835 2.999l-1.165 .001v4l1.893 -.001z", "key": "svg-0" }]]);

var IconBlenderFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBlenderFilled
});

var IconBlobFilled = createReactComponent("filled", "blob-filled", "IconBlobFilled", [["path", { "d": "M12 3c2.779 0 5.349 1.556 7.243 4.082c1.728 2.306 2.757 5.259 2.757 8.016c0 1.47 -.293 2.718 -.903 3.745c-.603 1.014 -1.479 1.758 -2.582 2.257c-1.593 .718 -3.335 .9 -6.515 .9c-3.175 0 -4.92 -.183 -6.514 -.9c-1.012 -.457 -1.833 -1.12 -2.426 -2.01l-.157 -.247c-.61 -1.028 -.903 -2.274 -.903 -3.745c0 -2.757 1.03 -5.71 2.757 -8.016c1.893 -2.526 4.463 -4.082 7.243 -4.082", "key": "svg-0" }]]);

var IconBlobFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBlobFilled
});

var IconBoltFilled = createReactComponent("filled", "bolt-filled", "IconBoltFilled", [["path", { "d": "M13 2l.018 .001l.016 .001l.083 .005l.011 .002h.011l.038 .009l.052 .008l.016 .006l.011 .001l.029 .011l.052 .014l.019 .009l.015 .004l.028 .014l.04 .017l.021 .012l.022 .01l.023 .015l.031 .017l.034 .024l.018 .011l.013 .012l.024 .017l.038 .034l.022 .017l.008 .01l.014 .012l.036 .041l.026 .027l.006 .009c.12 .147 .196 .322 .218 .513l.001 .012l.002 .041l.004 .064v6h5a1 1 0 0 1 .868 1.497l-.06 .091l-8 11c-.568 .783 -1.808 .38 -1.808 -.588v-6h-5a1 1 0 0 1 -.868 -1.497l.06 -.091l8 -11l.01 -.013l.018 -.024l.033 -.038l.018 -.022l.009 -.008l.013 -.014l.04 -.036l.028 -.026l.008 -.006a1 1 0 0 1 .402 -.199l.011 -.001l.027 -.005l.074 -.013l.011 -.001l.041 -.002z", "key": "svg-0" }]]);

var IconBoltFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoltFilled
});

var IconBombFilled = createReactComponent("filled", "bomb-filled", "IconBombFilled", [["path", { "d": "M14.499 3.996a2.2 2.2 0 0 1 1.556 .645l3.302 3.301a2.2 2.2 0 0 1 0 3.113l-.567 .567l.043 .192a8.5 8.5 0 0 1 -3.732 8.83l-.23 .144a8.5 8.5 0 1 1 -2.687 -15.623l.192 .042l.567 -.566a2.2 2.2 0 0 1 1.362 -.636zm-4.499 5.004a4 4 0 0 0 -4 4a1 1 0 0 0 2 0a2 2 0 0 1 2 -2a1 1 0 0 0 0 -2z", "key": "svg-0" }], ["path", { "d": "M21 2a1 1 0 0 1 .117 1.993l-.117 .007h-1c0 .83 -.302 1.629 -.846 2.25l-.154 .163l-1.293 1.293a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.293 -1.292c.232 -.232 .375 -.537 .407 -.86l.007 -.14a2 2 0 0 1 1.85 -1.995l.15 -.005h1z", "key": "svg-1" }]]);

var IconBombFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBombFilled
});

var IconBoneFilled = createReactComponent("filled", "bone-filled", "IconBoneFilled", [["path", { "d": "M15 2a4 4 0 0 1 3.881 3.03l.016 .072l.08 .019a4 4 0 0 1 2.83 2.65l.057 .193a4 4 0 0 1 -5.847 4.51l-.047 -.029l-3.525 3.525l.042 .07a4 4 0 0 1 .117 3.696l-.102 .197a4 4 0 0 1 -4.386 1.969a3.99 3.99 0 0 1 -2.982 -2.904l-.023 -.095l-.138 -.033a4 4 0 0 1 -2.82 -2.783l-.05 -.199a4 4 0 0 1 5.865 -4.368l.068 .04l3.524 -3.524l-.036 -.061a4 4 0 0 1 -.293 -3.295l.079 -.205a4 4 0 0 1 3.695 -2.47l-.139 .004l.02 -.003z", "key": "svg-0" }]]);

var IconBoneFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoneFilled
});

var IconBongFilled = createReactComponent("filled", "bong-filled", "IconBongFilled", [["path", { "d": "M14 2a1 1 0 0 1 0 2v5.587l2.293 -2.294a1 1 0 0 1 1.32 -.083l.094 .083l2 2a1 1 0 0 1 0 1.414l-3.116 3.115l.086 .233c.311 .907 .396 1.865 .263 2.794l-.062 .36l-.012 .052a6 6 0 0 1 -1.121 2.41l-.16 .199a6 6 0 0 1 -10.396 -2.378l-.068 -.288l-.009 -.046a6 6 0 0 1 2.833 -6.324l.055 -.031v-6.803a1 1 0 1 1 0 -2zm-2 2h-2v7.416a1 1 0 0 1 -.483 .856l-.117 .06a4 4 0 0 0 -2.4 3.668h8a4 4 0 0 0 -.486 -1.914a1 1 0 0 1 .17 -1.185l2.902 -2.901l-.586 -.586l-2.9 2.902a1 1 0 0 1 -1.067 .226l-.12 -.056a4 4 0 0 0 -.316 -.155a1 1 0 0 1 -.597 -.915z", "key": "svg-0" }]]);

var IconBongFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBongFilled
});

var IconBookFilled = createReactComponent("filled", "book-filled", "IconBookFilled", [["path", { "d": "M12.088 4.82a10 10 0 0 1 9.412 .314a1 1 0 0 1 .493 .748l.007 .118v13a1 1 0 0 1 -1.5 .866a8 8 0 0 0 -8 0a1 1 0 0 1 -1 0a8 8 0 0 0 -7.733 -.148l-.327 .18l-.103 .044l-.049 .016l-.11 .026l-.061 .01l-.117 .006h-.042l-.11 -.012l-.077 -.014l-.108 -.032l-.126 -.056l-.095 -.056l-.089 -.067l-.06 -.056l-.073 -.082l-.064 -.089l-.022 -.036l-.032 -.06l-.044 -.103l-.016 -.049l-.026 -.11l-.01 -.061l-.004 -.049l-.002 -.068v-13a1 1 0 0 1 .5 -.866a10 10 0 0 1 9.412 -.314l.088 .044l.088 -.044z", "key": "svg-0" }]]);

var IconBookFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookFilled
});

var IconBookmarkFilled = createReactComponent("filled", "bookmark-filled", "IconBookmarkFilled", [["path", { "d": "M14 2a5 5 0 0 1 5 5v14a1 1 0 0 1 -1.555 .832l-5.445 -3.63l-5.444 3.63a1 1 0 0 1 -1.55 -.72l-.006 -.112v-14a5 5 0 0 1 5 -5h4z", "key": "svg-0" }]]);

var IconBookmarkFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookmarkFilled
});

var IconBookmarksFilled = createReactComponent("filled", "bookmarks-filled", "IconBookmarksFilled", [["path", { "d": "M12 6a4 4 0 0 1 4 4v11a1 1 0 0 1 -1.514 .857l-4.486 -2.691l-4.486 2.691a1 1 0 0 1 -1.508 -.743l-.006 -.114v-11a4 4 0 0 1 4 -4h4z", "key": "svg-0" }], ["path", { "d": "M16 2a4 4 0 0 1 4 4v11a1 1 0 0 1 -2 0v-11a2 2 0 0 0 -2 -2h-5a1 1 0 0 1 0 -2h5z", "key": "svg-1" }]]);

var IconBookmarksFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBookmarksFilled
});

var IconBoomFilled = createReactComponent("filled", "boom-filled", "IconBoomFilled", [["path", { "d": "M7.514 3.836c.151 -.909 1.346 -1.147 1.834 -.366c2.294 3.67 4.275 4.048 5.758 1.083c.471 -.944 1.894 -.608 1.894 .447c0 2.448 1.552 4 4 4c.89 0 1.337 1.077 .707 1.707c-1.61 1.61 -1.61 2.975 0 4.581c.63 .63 .185 1.707 -.706 1.708c-2.448 .003 -3.001 .556 -3.001 3.004c0 .961 -1.223 1.369 -1.8 .6c-2.325 -3.1 -5.494 -2.856 -7.368 -.045c-.503 .754 -1.67 .504 -1.818 -.39c-.365 -2.188 -1.04 -2.656 -4.178 -3.179a1 1 0 0 1 -.543 -1.693c1.618 -1.618 1.618 -3.027 -.053 -4.981l-.009 -.013l-.013 -.014l-.044 -.062l-.01 -.011l-.006 -.013l-.038 -.066l-.017 -.028l-.001 -.004l-.027 -.066l-.019 -.041a1 1 0 0 1 -.051 -.233l-.002 -.045l-.003 -.068a1 1 0 0 1 .06 -.328l.009 -.023l.023 -.049l.011 -.029l.009 -.015l.007 -.016l.019 -.029l.02 -.035l.012 -.017l.013 -.022l.027 -.034l.011 -.016l.018 -.02l.02 -.025l.021 -.02l.015 -.017l.035 -.032l.02 -.019l.009 -.007l.018 -.015l.055 -.039l.018 -.015l.008 -.004l.01 -.007l.061 -.034l.028 -.016l.004 -.002l.063 -.026l.044 -.019a1 1 0 0 1 .115 -.032l.004 -.002l.267 -.063c2.39 -.613 3.934 -2.19 4.411 -4.523z", "key": "svg-0" }]]);

var IconBoomFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoomFilled
});

var IconBottleFilled = createReactComponent("filled", "bottle-filled", "IconBottleFilled", [["path", { "d": "M13 1a2 2 0 0 1 1.995 1.85l.005 .15v.5c0 1.317 .381 2.604 1.094 3.705l.17 .25l.05 .072a9.093 9.093 0 0 1 1.68 4.92l.006 .354v6.199a3 3 0 0 1 -2.824 2.995l-.176 .005h-6a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6.2a9.1 9.1 0 0 1 1.486 -4.982l.2 -.292l.05 -.069a6.823 6.823 0 0 0 1.264 -3.957v-.5a2 2 0 0 1 1.85 -1.995l.15 -.005h2zm.362 5h-2.724a8.827 8.827 0 0 1 -1.08 2.334l-.194 .284l-.05 .069a7.091 7.091 0 0 0 -1.307 3.798l-.003 .125a3.33 3.33 0 0 1 1.975 -.61a3.4 3.4 0 0 1 2.833 1.417c.27 .375 .706 .593 1.209 .583a1.4 1.4 0 0 0 1.166 -.583a3.4 3.4 0 0 1 .81 -.8l.003 .183c0 -1.37 -.396 -2.707 -1.137 -3.852l-.228 -.332a8.827 8.827 0 0 1 -1.273 -2.616z", "key": "svg-0" }]]);

var IconBottleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBottleFilled
});

var IconBounceLeftFilled = createReactComponent("filled", "bounce-left-filled", "IconBounceLeftFilled", [["path", { "d": "M8.486 11.143a1 1 0 0 1 1.371 .343c1.045 1.74 1.83 3.443 2.392 5.237l.172 .581l.092 -.13c2.093 -2.921 4.48 -3.653 7.565 -2.7l.238 .077a1 1 0 1 1 -.632 1.898c-2.932 -.978 -4.73 -.122 -6.79 3.998c-.433 .866 -1.721 .673 -1.88 -.283c-.46 -2.76 -1.369 -5.145 -2.871 -7.65a1 1 0 0 1 .343 -1.371z", "key": "svg-0" }], ["path", { "d": "M6 4a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z", "key": "svg-1" }]]);

var IconBounceLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBounceLeftFilled
});

var IconBounceRightFilled = createReactComponent("filled", "bounce-right-filled", "IconBounceRightFilled", [["path", { "d": "M14.143 11.486a1 1 0 0 1 1.714 1.028c-1.502 2.505 -2.41 4.89 -2.87 7.65c-.16 .956 -1.448 1.15 -1.881 .283c-2.06 -4.12 -3.858 -4.976 -6.79 -3.998a1 1 0 1 1 -.632 -1.898c3.2 -1.067 5.656 -.373 7.803 2.623l.091 .13l.011 -.04c.522 -1.828 1.267 -3.55 2.273 -5.3l.28 -.478z", "key": "svg-0" }], ["path", { "d": "M18 4a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z", "key": "svg-1" }]]);

var IconBounceRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBounceRightFilled
});

var IconBowFilled = createReactComponent("filled", "bow-filled", "IconBowFilled", [["path", { "d": "M21 2l.081 .003l.12 .017l.111 .03l.111 .044l.098 .052l.096 .067l.09 .08q .054 .053 .097 .112l.071 .11l.031 .062l.034 .081l.024 .076l.03 .148l.006 .118v4a1 1 0 0 1 -2 0v-1.586l-2.07 2.07c1.301 1.624 2.07 3.706 2.07 6.016c0 2.703 -1.047 5.462 -2.793 7.207a1 1 0 0 1 -1.414 0l-5.543 -5.542l-3.25 3.249v2.586a1 1 0 0 1 -2 0v-2h-2a1 1 0 0 1 -.993 -.883l-.007 -.117a1 1 0 0 1 1 -1h2.584l3.251 -3.25l-5.542 -5.543a1 1 0 0 1 -.002 -1.412c1.745 -1.755 4.489 -2.795 7.209 -2.795c2.31 0 4.393 .768 6.015 2.07l2.069 -2.07h-1.584a1 1 0 0 1 -.993 -.883l-.007 -.117a1 1 0 0 1 1 -1zm-4.495 6.91l-4.09 4.09l4.595 4.594a9.1 9.1 0 0 0 .985 -3.795l.005 -.299c0 -1.754 -.55 -3.336 -1.495 -4.59m-6.005 -2.91c-1.44 0 -2.89 .36 -4.098 .987l4.598 4.598l4.09 -4.09c-1.254 -.945 -2.836 -1.495 -4.59 -1.495", "key": "svg-0" }]]);

var IconBowFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBowFilled
});

var IconBowlChopsticksFilled = createReactComponent("filled", "bowl-chopsticks-filled", "IconBowlChopsticksFilled", [["path", { "d": "M20 10a2 2 0 0 1 2 2v.5c0 1.694 -2.247 5.49 -3.983 6.983l-.017 .013v.504a2 2 0 0 1 -1.85 1.995l-.15 .005h-8a2 2 0 0 1 -2 -2v-.496l-.065 -.053c-1.76 -1.496 -3.794 -4.965 -3.928 -6.77l-.007 -.181v-.5a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M18.929 6.003a1 1 0 1 1 .142 1.994l-14 1a1 1 0 1 1 -.142 -1.994z", "key": "svg-1" }], ["path", { "d": "M18.79 1.022a1 1 0 1 1 .42 1.956l-14 3a1 1 0 1 1 -.42 -1.956z", "key": "svg-2" }]]);

var IconBowlChopsticksFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBowlChopsticksFilled
});

var IconBowlSpoonFilled = createReactComponent("filled", "bowl-spoon-filled", "IconBowlSpoonFilled", [["path", { "d": "M20 10a2 2 0 0 1 2 2v.5c0 1.694 -2.247 5.49 -3.983 6.983l-.017 .013v.504a2 2 0 0 1 -1.85 1.995l-.15 .005h-8a2 2 0 0 1 -2 -2v-.496l-.065 -.053c-1.76 -1.496 -3.794 -4.965 -3.928 -6.77l-.007 -.181v-.5a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M8 2c1.71 0 3.237 .787 3.785 2h8.215a1 1 0 0 1 0 2l-8.216 .001c-.548 1.213 -2.074 1.999 -3.784 1.999c-2.144 0 -4 -1.237 -4 -3s1.856 -3 4 -3", "key": "svg-1" }]]);

var IconBowlSpoonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBowlSpoonFilled
});

var IconBowlFilled = createReactComponent("filled", "bowl-filled", "IconBowlFilled", [["path", { "d": "M20 7a2 2 0 0 1 2 2v.5c0 1.694 -2.247 5.49 -3.983 6.983l-.017 .013v.504a2 2 0 0 1 -1.85 1.995l-.15 .005h-8a2 2 0 0 1 -2 -2v-.496l-.065 -.053c-1.76 -1.496 -3.794 -4.965 -3.928 -6.77l-.007 -.181v-.5a2 2 0 0 1 2 -2z", "key": "svg-0" }]]);

var IconBowlFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBowlFilled
});

var IconBoxAlignBottomLeftFilled = createReactComponent("filled", "box-align-bottom-left-filled", "IconBoxAlignBottomLeftFilled", [["path", { "d": "M10 12h-5a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2 -2v-5a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M4 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M9 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-3" }], ["path", { "d": "M15 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-4" }], ["path", { "d": "M15 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-5" }], ["path", { "d": "M20 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-6" }], ["path", { "d": "M20 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-7" }], ["path", { "d": "M20 14a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-8" }], ["path", { "d": "M20 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-9" }]]);

var IconBoxAlignBottomLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignBottomLeftFilled
});

var IconBoxAlignBottomRightFilled = createReactComponent("filled", "box-align-bottom-right-filled", "IconBoxAlignBottomRightFilled", [["path", { "d": "M19 12h-5a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2 -2v-5a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M20 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M20 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M15 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-3" }], ["path", { "d": "M9 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-4" }], ["path", { "d": "M9 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-5" }], ["path", { "d": "M4 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-6" }], ["path", { "d": "M4 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-7" }], ["path", { "d": "M4 14a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-8" }], ["path", { "d": "M4 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-9" }]]);

var IconBoxAlignBottomRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignBottomRightFilled
});

var IconBoxAlignBottomFilled = createReactComponent("filled", "box-align-bottom-filled", "IconBoxAlignBottomFilled", [["path", { "d": "M20 13h-16a1 1 0 0 0 -1 1v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-5a1 1 0 0 0 -1 -1z", "key": "svg-0" }], ["path", { "d": "M4 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M4 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M9 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-3" }], ["path", { "d": "M15 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-4" }], ["path", { "d": "M20 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-5" }], ["path", { "d": "M20 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-6" }]]);

var IconBoxAlignBottomFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignBottomFilled
});

var IconBoxAlignLeftFilled = createReactComponent("filled", "box-align-left-filled", "IconBoxAlignLeftFilled", [["path", { "d": "M10.002 3.003h-5a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h5a1 1 0 0 0 1 -1v-16a1 1 0 0 0 -1 -1z", "key": "svg-0" }], ["path", { "d": "M15.002 19.003a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-1" }], ["path", { "d": "M20.003 19.003a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z", "key": "svg-2" }], ["path", { "d": "M20.003 14.002a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z", "key": "svg-3" }], ["path", { "d": "M20.003 8.002a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z", "key": "svg-4" }], ["path", { "d": "M20.003 3.002a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z", "key": "svg-5" }], ["path", { "d": "M15.002 3.002a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-6" }]]);

var IconBoxAlignLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignLeftFilled
});

var IconBoxAlignRightFilled = createReactComponent("filled", "box-align-right-filled", "IconBoxAlignRightFilled", [["path", { "d": "M18.998 3.003h-5a1 1 0 0 0 -1 1v16a1 1 0 0 0 1 1h5a2 2 0 0 0 2 -2v-14a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9.008 19.003a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-1" }], ["path", { "d": "M4.008 19.003a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z", "key": "svg-2" }], ["path", { "d": "M4.008 14.002a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z", "key": "svg-3" }], ["path", { "d": "M4.008 8.002a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z", "key": "svg-4" }], ["path", { "d": "M4.008 3.002a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z", "key": "svg-5" }], ["path", { "d": "M9.008 3.002a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-6" }]]);

var IconBoxAlignRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignRightFilled
});

var IconBoxAlignTopLeftFilled = createReactComponent("filled", "box-align-top-left-filled", "IconBoxAlignTopLeftFilled", [["path", { "d": "M10 3h-5a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2 -2v-5a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M15 3a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-1" }], ["path", { "d": "M20 3a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-2" }], ["path", { "d": "M20 8a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-3" }], ["path", { "d": "M20 14a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-4" }], ["path", { "d": "M4 14a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-5" }], ["path", { "d": "M20 19a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-6" }], ["path", { "d": "M15 19a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-7" }], ["path", { "d": "M9 19a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-8" }], ["path", { "d": "M4 19a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-9" }]]);

var IconBoxAlignTopLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignTopLeftFilled
});

var IconBoxAlignTopRightFilled = createReactComponent("filled", "box-align-top-right-filled", "IconBoxAlignTopRightFilled", [["path", { "d": "M19 3.01h-5a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2 -2v-5a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M20 14a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M20 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M15 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-3" }], ["path", { "d": "M9 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-4" }], ["path", { "d": "M9 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-5" }], ["path", { "d": "M4 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-6" }], ["path", { "d": "M4 14a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-7" }], ["path", { "d": "M4 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-8" }], ["path", { "d": "M4 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-9" }]]);

var IconBoxAlignTopRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignTopRightFilled
});

var IconBoxAlignTopFilled = createReactComponent("filled", "box-align-top-filled", "IconBoxAlignTopFilled", [["path", { "d": "M19 3.005h-14a2 2 0 0 0 -2 2v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1 -1v-5a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M4 13.995a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M4 18.995a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M9 18.995a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-3" }], ["path", { "d": "M15 18.995a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-4" }], ["path", { "d": "M20 18.995a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-5" }], ["path", { "d": "M20 13.995a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-6" }]]);

var IconBoxAlignTopFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxAlignTopFilled
});

var IconBoxMultipleFilled = createReactComponent("filled", "box-multiple-filled", "IconBoxMultipleFilled", [["path", { "d": "M6 5.667a3.667 3.667 0 0 1 3.667 -3.667h8.666a3.667 3.667 0 0 1 3.667 3.667v8.666a3.667 3.667 0 0 1 -3.667 3.667h-8.666a3.667 3.667 0 0 1 -3.667 -3.667z", "key": "svg-0" }], ["path", { "d": "M2 9c0 -1.094 .533 -1.828 1.514 -2.374a1 1 0 1 1 .972 1.748c-.398 .221 -.486 .342 -.486 .626v10c0 .548 .452 1 1 1h9.998c.32 0 .618 -.154 .805 -.407l.065 -.1a1 1 0 1 1 1.738 .99a3 3 0 0 1 -2.606 1.517h-10c-1.652 0 -3 -1.348 -3 -3z", "key": "svg-1" }]]);

var IconBoxMultipleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBoxMultipleFilled
});

var IconBrandAngularFilled = createReactComponent("filled", "brand-angular-filled", "IconBrandAngularFilled", [["path", { "d": "M12.665 2.174l7.4 2.612a2 2 0 0 1 1.316 2.156l-1.323 9.703a2 2 0 0 1 -.99 1.468l-6.076 3.471a2 2 0 0 1 -1.984 0l-6.076 -3.47a2 2 0 0 1 -.96 -1.3l-.03 -.167l-1.322 -9.704a2 2 0 0 1 1.316 -2.156l7.4 -2.613a2 2 0 0 1 1.33 0m.271 4.475c-.324 -.865 -1.548 -.865 -1.872 0l-3 8a1 1 0 0 0 .585 1.287l.111 .035a1 1 0 0 0 1.176 -.62l.506 -1.351h3.113l.508 1.352a1 1 0 0 0 1.176 .62l.111 -.035a1 1 0 0 0 .585 -1.287zm-.937 3.199l.807 2.151h-1.614z", "key": "svg-0" }]]);

var IconBrandAngularFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAngularFilled
});

var IconBrandAppleFilled = createReactComponent("filled", "brand-apple-filled", "IconBrandAppleFilled", [["path", { "d": "M15.079 5.999l.239 .012c1.43 .097 3.434 1.013 4.508 2.586a1 1 0 0 1 -.344 1.44c-.05 .028 -.372 .158 -.497 .217a4.15 4.15 0 0 0 -.722 .431c-.614 .461 -.948 1.009 -.942 1.694c.01 .885 .339 1.454 .907 1.846c.208 .143 .436 .253 .666 .33c.126 .043 .426 .116 .444 .122a1 1 0 0 1 .662 .942c0 2.621 -3.04 6.381 -5.286 6.381c-.79 0 -1.272 -.091 -1.983 -.315l-.098 -.031c-.463 -.146 -.702 -.192 -1.133 -.192c-.52 0 -.863 .06 -1.518 .237l-.197 .053c-.575 .153 -.964 .226 -1.5 .248c-2.749 0 -5.285 -5.093 -5.285 -9.072c0 -3.87 1.786 -6.92 5.286 -6.92c.297 0 .598 .045 .909 .128c.403 .107 .774 .26 1.296 .508c.787 .374 .948 .44 1.009 .44h.016c.03 -.003 .128 -.047 1.056 -.457c1.061 -.467 1.864 -.685 2.746 -.616l-.24 -.012z", "key": "svg-0" }], ["path", { "d": "M14 1a1 1 0 0 1 1 1a3 3 0 0 1 -3 3a1 1 0 0 1 -1 -1a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

var IconBrandAppleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandAppleFilled
});

var IconBrandBitbucketFilled = createReactComponent("filled", "brand-bitbucket-filled", "IconBrandBitbucketFilled", [["path", { "d": "M3.661 3l16.68 .007c.484 -.005 .946 .203 1.262 .57c.316 .368 .454 .856 .364 1.396l-3.338 14.651a1.64 1.64 0 0 1 -1.629 1.376h-10.01c-.906 -.009 -1.678 -.668 -1.82 -1.517l-3.148 -14.576a1.64 1.64 0 0 1 1.639 -1.907m11.339 5h-6a1 1 0 0 0 -.986 1.164l1 6a1 1 0 0 0 .986 .836h4a1 1 0 0 0 .986 -.836l1 -6a1 1 0 0 0 -.986 -1.164", "key": "svg-0" }]]);

var IconBrandBitbucketFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandBitbucketFilled
});

var IconBrandDiscordFilled = createReactComponent("filled", "brand-discord-filled", "IconBrandDiscordFilled", [["path", { "d": "M14.983 3l.123 .006c2.014 .214 3.527 .672 4.966 1.673a1 1 0 0 1 .371 .488c1.876 5.315 2.373 9.987 1.451 12.28c-1.003 2.005 -2.606 3.553 -4.394 3.553c-.732 0 -1.693 -.968 -2.328 -2.045a21.512 21.512 0 0 0 2.103 -.493a1 1 0 1 0 -.55 -1.924c-3.32 .95 -6.13 .95 -9.45 0a1 1 0 0 0 -.55 1.924c.717 .204 1.416 .37 2.103 .494c-.635 1.075 -1.596 2.044 -2.328 2.044c-1.788 0 -3.391 -1.548 -4.428 -3.629c-.888 -2.217 -.39 -6.89 1.485 -12.204a1 1 0 0 1 .371 -.488c1.439 -1.001 2.952 -1.459 4.966 -1.673a1 1 0 0 1 .935 .435l.063 .107l.651 1.285l.137 -.016a12.97 12.97 0 0 1 2.643 0l.134 .016l.65 -1.284a1 1 0 0 1 .754 -.54l.122 -.009zm-5.983 7a2 2 0 0 0 -1.977 1.697l-.018 .154l-.005 .149l.005 .15a2 2 0 1 0 1.995 -2.15zm6 0a2 2 0 0 0 -1.977 1.697l-.018 .154l-.005 .149l.005 .15a2 2 0 1 0 1.995 -2.15z", "key": "svg-0" }]]);

var IconBrandDiscordFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDiscordFilled
});

var IconBrandDribbbleFilled = createReactComponent("filled", "brand-dribbble-filled", "IconBrandDribbbleFilled", [["path", { "d": "M14.384 14.38a22.877 22.877 0 0 1 1.056 4.863l.064 .644l.126 1.431a10 10 0 0 1 -9.15 -.98l2.08 -2.087l.246 -.24c1.793 -1.728 3.41 -2.875 5.387 -3.566l.191 -.065zm6.09 -.783l.414 .003l.981 .014a9.997 9.997 0 0 1 -4.319 6.704l-.054 -.605c-.18 -2.057 -.55 -3.958 -1.163 -5.814c1.044 -.182 2.203 -.278 3.529 -.298l.611 -.004zm-7.869 -3.181a24.91 24.91 0 0 1 1.052 2.098c-2.276 .77 -4.142 2.053 -6.144 3.967l-.355 .344l-2.236 2.24a10 10 0 0 1 -2.917 -6.741l-.005 -.324l.004 -.25h1.096l.467 -.002c3.547 -.026 6.356 -.367 8.938 -1.295l.1 -.037zm9.388 1.202l-1.515 -.02c-1.86 -.003 -3.45 .124 -4.865 .402a26.112 26.112 0 0 0 -1.163 -2.38c1.393 -.695 2.757 -1.597 4.179 -2.75l.428 -.354l.816 -.682a10 10 0 0 1 2.098 5.409l.022 .375zm-14.663 -8.46l1.266 1.522c1.145 1.398 2.121 2.713 2.949 3.985c-2.26 .766 -4.739 1.052 -7.883 1.081l-.562 .004h-.844a10 10 0 0 1 5.074 -6.593zm9.67 .182c.53 .306 1.026 .657 1.483 1.046l-1.025 .857c-1.379 1.128 -2.688 1.993 -4.034 2.649c-.89 -1.398 -1.943 -2.836 -3.182 -4.358l-.474 -.574l-.485 -.584a10 10 0 0 1 7.717 .964z", "key": "svg-0" }]]);

var IconBrandDribbbleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandDribbbleFilled
});

var IconBrandFacebookFilled = createReactComponent("filled", "brand-facebook-filled", "IconBrandFacebookFilled", [["path", { "d": "M18 2a1 1 0 0 1 .993 .883l.007 .117v4a1 1 0 0 1 -.883 .993l-.117 .007h-3v1h3a1 1 0 0 1 .991 1.131l-.02 .112l-1 4a1 1 0 0 1 -.858 .75l-.113 .007h-2v6a1 1 0 0 1 -.883 .993l-.117 .007h-4a1 1 0 0 1 -.993 -.883l-.007 -.117v-6h-2a1 1 0 0 1 -.993 -.883l-.007 -.117v-4a1 1 0 0 1 .883 -.993l.117 -.007h2v-1a6 6 0 0 1 5.775 -5.996l.225 -.004h3z", "key": "svg-0" }]]);

var IconBrandFacebookFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandFacebookFilled
});

var IconBrandGithubFilled = createReactComponent("filled", "brand-github-filled", "IconBrandGithubFilled", [["path", { "d": "M5.315 2.1c.791 -.113 1.9 .145 3.333 .966l.272 .161l.16 .1l.397 -.083a13.3 13.3 0 0 1 4.59 -.08l.456 .08l.396 .083l.161 -.1c1.385 -.84 2.487 -1.17 3.322 -1.148l.164 .008l.147 .017l.076 .014l.05 .011l.144 .047a1 1 0 0 1 .53 .514a5.2 5.2 0 0 1 .397 2.91l-.047 .267l-.046 .196l.123 .163c.574 .795 .93 1.728 1.03 2.707l.023 .295l.007 .272c0 3.855 -1.659 5.883 -4.644 6.68l-.245 .061l-.132 .029l.014 .161l.008 .157l.004 .365l-.002 .213l-.003 3.834a1 1 0 0 1 -.883 .993l-.117 .007h-6a1 1 0 0 1 -.993 -.883l-.007 -.117v-.734c-1.818 .26 -3.03 -.424 -4.11 -1.878l-.535 -.766c-.28 -.396 -.455 -.579 -.589 -.644l-.048 -.019a1 1 0 0 1 .564 -1.918c.642 .188 1.074 .568 1.57 1.239l.538 .769c.76 1.079 1.36 1.459 2.609 1.191l.001 -.678l-.018 -.168a5.03 5.03 0 0 1 -.021 -.824l.017 -.185l.019 -.12l-.108 -.024c-2.976 -.71 -4.703 -2.573 -4.875 -6.139l-.01 -.31l-.004 -.292a5.6 5.6 0 0 1 .908 -3.051l.152 -.222l.122 -.163l-.045 -.196a5.2 5.2 0 0 1 .145 -2.642l.1 -.282l.106 -.253a1 1 0 0 1 .529 -.514l.144 -.047l.154 -.03z", "key": "svg-0" }]]);

var IconBrandGithubFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGithubFilled
});

var IconBrandGoogleFilled = createReactComponent("filled", "brand-google-filled", "IconBrandGoogleFilled", [["path", { "d": "M12 2a9.96 9.96 0 0 1 6.29 2.226a1 1 0 0 1 .04 1.52l-1.51 1.362a1 1 0 0 1 -1.265 .06a6 6 0 1 0 2.103 6.836l.001 -.004h-3.66a1 1 0 0 1 -.992 -.883l-.007 -.117v-2a1 1 0 0 1 1 -1h6.945a1 1 0 0 1 .994 .89c.04 .367 .061 .737 .061 1.11c0 5.523 -4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10z", "key": "svg-0" }]]);

var IconBrandGoogleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandGoogleFilled
});

var IconBrandInstagramFilled = createReactComponent("filled", "brand-instagram-filled", "IconBrandInstagramFilled", [["path", { "d": "M16 3a5 5 0 0 1 5 5v8a5 5 0 0 1 -5 5h-8a5 5 0 0 1 -5 -5v-8a5 5 0 0 1 5 -5zm-4 5a4 4 0 0 0 -3.995 3.8l-.005 .2a4 4 0 1 0 4 -4m4.5 -1.5a1 1 0 0 0 -.993 .883l-.007 .127a1 1 0 0 0 1.993 .117l.007 -.127a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconBrandInstagramFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandInstagramFilled
});

var IconBrandKickFilled = createReactComponent("filled", "brand-kick-filled", "IconBrandKickFilled", [["path", { "d": "M9 3a1 1 0 0 1 1 1v3h1v-1a1 1 0 0 1 .883 -.993l.117 -.007h1v-1a1 1 0 0 1 .883 -.993l.117 -.007h6a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-1v1a1 1 0 0 1 -.883 .993l-.117 .007h-1v2h1a1 1 0 0 1 .993 .883l.007 .117v1h1a1 1 0 0 1 .993 .883l.007 .117v4a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-1h-1a1 1 0 0 1 -.993 -.883l-.007 -.117v-1h-1v3a1 1 0 0 1 -.883 .993l-.117 .007h-5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconBrandKickFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandKickFilled
});

var IconBrandLinkedinFilled = createReactComponent("filled", "brand-linkedin-filled", "IconBrandLinkedinFilled", [["path", { "d": "M17 2a5 5 0 0 1 5 5v10a5 5 0 0 1 -5 5h-10a5 5 0 0 1 -5 -5v-10a5 5 0 0 1 5 -5zm-9 8a1 1 0 0 0 -1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0 -1 -1m6 0a3 3 0 0 0 -1.168 .236l-.125 .057a1 1 0 0 0 -1.707 .707v5a1 1 0 0 0 2 0v-3a1 1 0 0 1 2 0v3a1 1 0 0 0 2 0v-3a3 3 0 0 0 -3 -3m-6 -3a1 1 0 0 0 -.993 .883l-.007 .127a1 1 0 0 0 1.993 .117l.007 -.127a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconBrandLinkedinFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandLinkedinFilled
});

var IconBrandMessengerFilled = createReactComponent("filled", "brand-messenger-filled", "IconBrandMessengerFilled", [["path", { "d": "M18.894 5.446c3.667 3.127 4.168 8.238 1.152 11.897c-2.842 3.447 -7.965 4.583 -12.231 2.805l-.233 -.101l-4.374 .931l-.033 .005l-.042 .008l-.031 .002l-.01 .003h-.018l-.052 .004l-.024 -.001l-.02 .001l-.033 -.003h-.035l-.022 -.004l-.022 -.002l-.035 -.007l-.034 -.005l-.016 -.004l-.024 -.005l-.049 -.016l-.024 -.005l-.011 -.005l-.022 -.007l-.045 -.02l-.03 -.012l-.011 -.006l-.014 -.006l-.031 -.018l-.045 -.024l-.016 -.011l-.037 -.026l-.04 -.027l-.015 -.013l-.043 -.04l-.025 -.02l-.062 -.07l-.013 -.013l-.011 -.014l-.027 -.04l-.026 -.035a1 1 0 0 1 -.054 -.095l-.006 -.013l-.019 -.045l-.02 -.042l-.004 -.016l-.004 -.01l-.011 -.04l-.013 -.04l-.002 -.014l-.005 -.019l-.005 -.033l-.008 -.042l-.002 -.031l-.003 -.026l-.004 -.054l.001 -.036l.001 -.023l.002 -.053l.004 -.025v-.019l.008 -.036l.005 -.033l.004 -.017l.005 -.023l.018 -.06l.003 -.013l1.15 -3.45l-.022 -.037c-2.21 -3.747 -1.209 -8.392 2.411 -11.118l.23 -.168c3.898 -2.766 9.469 -2.54 13.073 .535m-2.062 5a1 1 0 0 0 -1.387 -.278l-2.318 1.544l-1.42 -1.42a1 1 0 0 0 -1.262 -.124l-3 2a1 1 0 0 0 -.277 1.387l.07 .093a1 1 0 0 0 1.317 .184l2.317 -1.545l1.42 1.42a1 1 0 0 0 1.263 .125l3 -2a1 1 0 0 0 .277 -1.387", "key": "svg-0" }]]);

var IconBrandMessengerFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandMessengerFilled
});

var IconBrandOpenSourceFilled = createReactComponent("filled", "brand-open-source-filled", "IconBrandOpenSourceFilled", [["path", { "d": "M12.283 2.004a10 10 0 0 1 3.736 19.155a1 1 0 0 1 -1.332 -.551l-2.193 -5.602a1 1 0 0 1 .456 -1.245a2 2 0 1 0 -1.9 0a1 1 0 0 1 .457 1.244l-2.193 5.603a1 1 0 0 1 -1.332 .552a10 10 0 0 1 4.018 -19.16z", "key": "svg-0" }]]);

var IconBrandOpenSourceFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandOpenSourceFilled
});

var IconBrandOperaFilled = createReactComponent("filled", "brand-opera-filled", "IconBrandOperaFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5 2.66c-2.285 0 -3.915 2.619 -3.997 5.752l-.003 .248c0 3.242 1.655 6 4 6s4 -2.758 4 -6s-1.655 -6 -4 -6", "key": "svg-0" }]]);

var IconBrandOperaFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandOperaFilled
});

var IconBrandPatreonFilled = createReactComponent("filled", "brand-patreon-filled", "IconBrandPatreonFilled", [["path", { "d": "M7.462 3.1c2.615 -1.268 6.226 -1.446 9.063 -.503c2.568 .853 4.471 3.175 4.475 5.81c.004 3.061 -1.942 5.492 -4.896 6.243c-1.693 .43 -2.338 .75 -2.942 1.582c-.238 .328 -.45 .745 -.796 1.533l-.22 .5c-1.146 2.601 -2.156 3.762 -4.236 3.735c-2.232 -.03 -3.603 -1.742 -4.313 -4.48c-.458 -1.768 -.617 -3.808 -.594 -5.876c.044 -3.993 1.42 -7.072 4.46 -8.545z", "key": "svg-0" }]]);

var IconBrandPatreonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPatreonFilled
});

var IconBrandPaypalFilled = createReactComponent("filled", "brand-paypal-filled", "IconBrandPaypalFilled", [["path", { "d": "M12.5 2c3.113 0 5.309 1.785 5.863 4.565c1.725 1.185 2.637 3.152 2.637 5.435c0 2.933 -2.748 5.384 -5.783 5.496l-.217 .004h-1.754l-.466 2.8a1.998 1.998 0 0 1 -1.823 1.597l-.157 .003h-2.68a1.5 1.5 0 0 1 -1.182 -.54a1.495 1.495 0 0 1 -.348 -1.07l.042 -.29h-1.632c-1.004 0 -1.914 -.864 -1.994 -1.857l-.006 -.143l.01 -.141l1.993 -13.954l.003 -.048c.072 -.894 .815 -1.682 1.695 -1.832l.156 -.02l.143 -.005h5.5zm5.812 7.35l-.024 .087c-.706 2.403 -3.072 4.436 -5.555 4.557l-.233 .006h-2.503v.05l-.025 .183l-1.2 5a1.007 1.007 0 0 1 -.019 .07l-.088 .597h2.154l.595 -3.564a1 1 0 0 1 .865 -.829l.121 -.007h2.6c2.073 0 4 -1.67 4 -3.5c0 -1.022 -.236 -1.924 -.688 -2.65z", "key": "svg-0" }]]);

var IconBrandPaypalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPaypalFilled
});

var IconBrandPinterestFilled = createReactComponent("filled", "brand-pinterest-filled", "IconBrandPinterestFilled", [["path", { "d": "M17 3.34a10 10 0 0 1 -8.512 18.023l2.364 -5.315a3.5 3.5 0 0 0 2.398 .952c2.708 0 4.75 -2.089 4.75 -5a6 6 0 1 0 -11.64 2.041a1 1 0 1 0 1.88 -.682a4 4 0 1 1 7.76 -1.36c0 1.818 -1.156 3.001 -2.75 3.001c-.609 0 -1.153 -.361 -1.478 -1.022l1.142 -2.572a1 1 0 0 0 -1.828 -.812l-4.392 9.882a10 10 0 0 1 -4.694 -8.476l.005 -.324a10 10 0 0 1 14.995 -8.336", "key": "svg-0" }]]);

var IconBrandPinterestFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandPinterestFilled
});

var IconBrandSketchFilled = createReactComponent("filled", "brand-sketch-filled", "IconBrandSketchFilled", [["path", { "d": "M7.554 3.004h8.929a2 2 0 0 1 1.647 .873l3.536 5.193a2.006 2.006 0 0 1 -.173 2.48l-8 8.79a2.007 2.007 0 0 1 -2.97 0l-8 -8.789a1 1 0 0 1 -.13 -.175l-.012 -.026l-.051 -.072a2.01 2.01 0 0 1 -.056 -2.063l.09 -.146l3.541 -5.193c.372 -.544 .987 -.87 1.649 -.872", "key": "svg-0" }]]);

var IconBrandSketchFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSketchFilled
});

var IconBrandSnapchatFilled = createReactComponent("filled", "brand-snapchat-filled", "IconBrandSnapchatFilled", [["path", { "d": "M12 1.96a5.88 5.88 0 0 1 5.882 5.882c0 .618 .008 1.174 .03 1.678l.008 .21l.084 -.115q .46 -.627 1.102 -1.29l.187 -.19a1 1 0 0 1 1.414 1.415c-2.637 2.637 -2.51 3.795 .76 5.527l.048 .025a.98 .98 0 0 1 .46 .636l.004 .022l.003 .013l.006 .043l.006 .032v.009l.003 .025l.001 .051l.002 .026l-.001 .009v.025l-.003 .042l-.002 .034l-.002 .015l-.002 .02l-.004 .016l-.01 .06l-.007 .026l-.006 .02l-.016 .06l-.013 .029l-.005 .013l-.024 .062a1 1 0 0 1 -.197 .28l-.03 .025l-.016 .014l-.043 .039l-.013 .007l-.018 .015l-.051 .033l-.02 .014l-.008 .003l-.014 .01a1 1 0 0 1 -.098 .049l-.013 .003l-.146 .066c-.576 .255 -.81 .365 -1.008 .474l-.053 .03c-.27 .155 -.398 .277 -.558 .525c-.156 .245 -.293 .516 -.715 1.41a1 1 0 0 1 -.904 .573c-1.067 0 -1.798 .25 -2.879 .868l-.426 .246c-.176 .102 -.311 .178 -.447 .25c-.794 .423 -1.464 .636 -2.248 .636s-1.454 -.213 -2.248 -.636a15 15 0 0 1 -.447 -.25l-.426 -.246c-1.081 -.618 -1.812 -.868 -2.879 -.868a1 1 0 0 1 -.904 -.573c-.422 -.894 -.559 -1.165 -.715 -1.41a1.4 1.4 0 0 0 -.558 -.525c-.228 -.13 -.47 -.243 -1.227 -.577l.02 .007l-.013 -.003a1 1 0 0 1 -.098 -.05l-.014 -.009l-.028 -.017l-.051 -.033l-.018 -.015l-.013 -.007l-.043 -.039l-.012 -.01l-.004 -.004l-.03 -.025a1 1 0 0 1 -.197 -.28l-.024 -.062l-.005 -.013l-.013 -.028l-.016 -.061l-.005 -.012l-.008 -.035l-.01 -.059l-.004 -.016l-.002 -.02l-.002 -.015l-.002 -.035l-.004 -.041l.001 -.025l-.001 -.01l.002 -.025l.001 -.05l.003 -.026v-.01l.006 -.03l.006 -.044l.004 -.014l.002 -.021a.98 .98 0 0 1 .461 -.636l.048 -.025l.204 -.11c3.003 -1.635 3.132 -2.785 .72 -5.25l-.164 -.167a1 1 0 0 1 1.414 -1.414q .764 .763 1.289 1.479l.083 .115l.01 -.21q .025 -.628 .028 -1.374l.001 -.304a5.88 5.88 0 0 1 5.882 -5.882", "key": "svg-0" }]]);

var IconBrandSnapchatFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSnapchatFilled
});

var IconBrandSpotifyFilled = createReactComponent("filled", "brand-spotify-filled", "IconBrandSpotifyFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-2.168 11.605c-1.285 -1.927 -4.354 -2.132 -6.387 -.777a1 1 0 0 0 1.11 1.664c1.195 -.797 3.014 -.675 3.613 .223a1 1 0 1 0 1.664 -1.11m1.268 -3.245c-2.469 -1.852 -5.895 -2.187 -8.608 -.589a1 1 0 0 0 1.016 1.724c1.986 -1.171 4.544 -.92 6.392 .465a1 1 0 0 0 1.2 -1.6m1.43 -3.048c-3.677 -2.298 -7.766 -2.152 -10.977 -.546a1 1 0 0 0 .894 1.788c2.635 -1.317 5.997 -1.437 9.023 .454a1 1 0 1 0 1.06 -1.696", "key": "svg-0" }]]);

var IconBrandSpotifyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSpotifyFilled
});

var IconBrandSteamFilled = createReactComponent("filled", "brand-steam-filled", "IconBrandSteamFilled", [["path", { "d": "M16.5 4a5.5 5.5 0 1 1 -.309 10.992l-.078 -.007l-3.646 2.524l-.011 .094c-.267 1.775 -1.707 3.18 -3.571 3.38l-.209 .017h-.176a4 4 0 0 1 -3.756 -2.623l-.016 -.048l-2.122 -.91a1 1 0 0 1 -.599 -.8l-.007 -.119v-3.5a1 1 0 0 1 1.447 -.894l2.964 1.481l.174 -.1a4 4 0 0 1 2.15 -.482l.166 .014l2.126 -2.977l-.01 -.098a5.5 5.5 0 0 1 1.092 -3.758l.169 -.212a5.5 5.5 0 0 1 4.222 -1.974m0 3.5a2 2 0 1 0 0 4a2 2 0 0 0 0 -4", "key": "svg-0" }]]);

var IconBrandSteamFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandSteamFilled
});

var IconBrandStripeFilled = createReactComponent("filled", "brand-stripe-filled", "IconBrandStripeFilled", [["path", { "d": "M12.5 2c2.45 0 4.543 .44 5.928 1.096a1 1 0 0 1 .564 1.028l-.5 4a1 1 0 0 1 -1.429 .776c-1.047 -.509 -2.618 -.823 -4.168 -.823q -.206 .001 -.332 .026l.028 .024l.07 .047c.314 .207 .832 .437 1.672 .746c3.824 1.351 5.667 3.24 5.667 6.58c0 2.13 -.758 3.732 -2.295 4.924c-1.293 1.023 -3.422 1.576 -5.705 1.576c-2.4 0 -4.72 -.644 -6.486 -1.626a1 1 0 0 1 -.506 -.998l.5 -4a1 1 0 0 1 1.494 -.741c1.292 .75 3.64 1.365 4.998 1.365c.39 0 .704 -.147 .87 -.295l.035 -.035l-.09 -.035c-.167 -.06 -1.583 -.493 -2.153 -.694c-3.626 -1.304 -5.662 -3.609 -5.662 -6.941c0 -1.887 .882 -3.563 2.37 -4.777c1.22 -.987 2.517 -1.223 5.13 -1.223", "key": "svg-0" }]]);

var IconBrandStripeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandStripeFilled
});

var IconBrandTablerFilled = createReactComponent("filled", "brand-tabler-filled", "IconBrandTablerFilled", [["path", { "d": "M17 2a5 5 0 0 1 5 5v10a5 5 0 0 1 -5 5h-10a5 5 0 0 1 -5 -5v-10a5 5 0 0 1 5 -5zm-1 12h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0 -2m-7.293 -5.707a1 1 0 0 0 -1.414 0l-.083 .094a1 1 0 0 0 .083 1.32l2.292 2.293l-2.292 2.293a1 1 0 0 0 1.414 1.414l3 -3a1 1 0 0 0 0 -1.414z", "key": "svg-0" }]]);

var IconBrandTablerFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTablerFilled
});

var IconBrandTiktokFilled = createReactComponent("filled", "brand-tiktok-filled", "IconBrandTiktokFilled", [["path", { "d": "M16.083 2h-4.083a1 1 0 0 0 -1 1v11.5a1.5 1.5 0 1 1 -2.519 -1.1l.12 -.1a1 1 0 0 0 .399 -.8v-4.326a1 1 0 0 0 -1.23 -.974a7.5 7.5 0 0 0 1.73 14.8l.243 -.005a7.5 7.5 0 0 0 7.257 -7.495v-2.7l.311 .153c1.122 .53 2.333 .868 3.59 .993a1 1 0 0 0 1.099 -.996v-4.033a1 1 0 0 0 -.834 -.986a5.005 5.005 0 0 1 -4.097 -4.096a1 1 0 0 0 -.986 -.835z", "key": "svg-0" }]]);

var IconBrandTiktokFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTiktokFilled
});

var IconBrandTinderFilled = createReactComponent("filled", "brand-tinder-filled", "IconBrandTinderFilled", [["path", { "d": "M11.595 2.13a1 1 0 0 1 1.455 -1.016c3.11 1.625 5.41 3.797 6.77 6.627l-.013 -.024l.01 .019l.115 .232c2.751 5.7 .088 12.587 -5.913 13.76l-.267 .049c-8.719 1.91 -14.455 -8.74 -7.97 -14.918c.466 -.46 1.28 -1.196 1.636 -1.45a1 1 0 0 1 1.582 .813c0 .311 .086 1.117 .205 1.694q .046 .215 .093 .383l.017 .058l.1 -.02c1.562 -.396 2.522 -3.021 2.21 -5.955z", "key": "svg-0" }]]);

var IconBrandTinderFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTinderFilled
});

var IconBrandTumblrFilled = createReactComponent("filled", "brand-tumblr-filled", "IconBrandTumblrFilled", [["path", { "d": "M14 2a1 1 0 0 1 1 1v3h3a1 1 0 0 1 .993 .883l.007 .117v4a1 1 0 0 1 -1 1h-3v4h3a1 1 0 0 1 .993 .883l.007 .117v4a1 1 0 0 1 -1 1h-4a5 5 0 0 1 -5 -5v-5h-3a1 1 0 0 1 -.993 -.883l-.007 -.117v-4a1 1 0 0 1 1 -1h1a2 2 0 0 0 2 -2v-1a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconBrandTumblrFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTumblrFilled
});

var IconBrandTwitterFilled = createReactComponent("filled", "brand-twitter-filled", "IconBrandTwitterFilled", [["path", { "d": "M14.058 3.41c-1.807 .767 -2.995 2.453 -3.056 4.38l-.002 .182l-.243 -.023c-2.392 -.269 -4.498 -1.512 -5.944 -3.531a1 1 0 0 0 -1.685 .092l-.097 .186l-.049 .099c-.719 1.485 -1.19 3.29 -1.017 5.203l.03 .273c.283 2.263 1.5 4.215 3.779 5.679l.173 .107l-.081 .043c-1.315 .663 -2.518 .952 -3.827 .9c-1.056 -.04 -1.446 1.372 -.518 1.878c3.598 1.961 7.461 2.566 10.792 1.6c4.06 -1.18 7.152 -4.223 8.335 -8.433l.127 -.495c.238 -.993 .372 -2.006 .401 -3.024l.003 -.332l.393 -.779l.44 -.862l.214 -.434l.118 -.247c.265 -.565 .456 -1.033 .574 -1.43l.014 -.056l.008 -.018c.22 -.593 -.166 -1.358 -.941 -1.358l-.122 .007a.997 .997 0 0 0 -.231 .057l-.086 .038a7.46 7.46 0 0 1 -.88 .36l-.356 .115l-.271 .08l-.772 .214c-1.336 -1.118 -3.144 -1.254 -5.012 -.554l-.211 .084z", "key": "svg-0" }]]);

var IconBrandTwitterFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandTwitterFilled
});

var IconBrandVercelFilled = createReactComponent("filled", "brand-vercel-filled", "IconBrandVercelFilled", [["path", { "d": "M11.143 3.486a1 1 0 0 1 1.714 0l9 15a1 1 0 0 1 -.857 1.514h-18a1 1 0 0 1 -.857 -1.514z", "key": "svg-0" }]]);

var IconBrandVercelFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVercelFilled
});

var IconBrandVimeoFilled = createReactComponent("filled", "brand-vimeo-filled", "IconBrandVimeoFilled", [["path", { "d": "M18.5 3c2.38 0 3.985 2.174 3.486 5.164c-.535 3.21 -2.25 6.074 -4.808 8.675c-1.277 1.298 -2.211 2.061 -4.112 3.485c-2.323 1.597 -4.408 .365 -5.47 -1.897c-.292 -.618 -.586 -1.724 -1.248 -4.477l-.03 -.126c-.483 -2.01 -.819 -3.319 -.982 -3.878l-.016 -.052l-.031 .013l-.13 .06l-.137 .07a4 4 0 0 0 -.43 .269a1 1 0 0 1 -1.3 -.099l-1 -1a1 1 0 0 1 -.124 -1.262a20 20 0 0 1 1.918 -2.382c.98 -1.037 1.955 -1.816 2.928 -2.233c.5 -.214 .996 -.33 1.486 -.33c2.237 0 3.02 1.588 3.567 4.963c.03 .183 .057 .359 .112 .709c.123 .784 .197 1.198 .292 1.588c.292 1.185 .528 1.984 .735 2.483l-.016 -.039l.096 -.107c.354 -.411 .757 -1.014 1.172 -1.771l.157 -.291c.391 -.745 .505 -1.528 .363 -1.9c-.028 -.073 .007 -.065 -.456 .218a1 1 0 0 1 -1.51 -1.013c.496 -3.053 2.745 -4.84 5.488 -4.84", "key": "svg-0" }]]);

var IconBrandVimeoFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandVimeoFilled
});

var IconBrandWeiboFilled = createReactComponent("filled", "brand-weibo-filled", "IconBrandWeiboFilled", [["path", { "d": "M4.972 8.183c2.81 -2.987 6.162 -4.207 8.006 -2.24c.298 .316 .554 .773 .736 1.266l.127 -.031c2.064 -.469 4 1.287 3.817 3.544l-.005 .036l.15 .057c1.46 .574 2.14 1.355 2.193 3.081l.004 .231c0 3.776 -4.107 6.873 -9 6.873c-4.854 0 -9 -2.72 -9 -6.565c0 -2.04 1.068 -4.222 2.972 -6.252", "key": "svg-0" }], ["path", { "d": "M16 3a6 6 0 0 1 6 6v1a1 1 0 0 1 -2 0v-1a4 4 0 0 0 -4 -4h-1a1 1 0 0 1 0 -2z", "key": "svg-1" }]]);

var IconBrandWeiboFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWeiboFilled
});

var IconBrandWhatsappFilled = createReactComponent("filled", "brand-whatsapp-filled", "IconBrandWhatsappFilled", [["path", { "d": "M18.497 4.409a10 10 0 0 1 -10.36 16.828l-.223 -.098l-4.759 .849l-.11 .011a1 1 0 0 1 -.11 0l-.102 -.013l-.108 -.024l-.105 -.037l-.099 -.047l-.093 -.058l-.014 -.011l-.012 -.007l-.086 -.073l-.077 -.08l-.067 -.088l-.056 -.094l-.034 -.07l-.04 -.108l-.028 -.128l-.012 -.102a1 1 0 0 1 0 -.125l.012 -.1l.024 -.11l.045 -.122l1.433 -3.304l-.009 -.014a10 10 0 0 1 1.549 -12.454l.215 -.203a10 10 0 0 1 13.226 -.217m-8.997 3.09a1.5 1.5 0 0 0 -1.5 1.5v1a6 6 0 0 0 6 6h1a1.5 1.5 0 0 0 0 -3h-1l-.144 .007a1.5 1.5 0 0 0 -1.128 .697l-.042 .074l-.022 -.007a4.01 4.01 0 0 1 -2.435 -2.435l-.008 -.023l.075 -.041a1.5 1.5 0 0 0 .704 -1.272v-1a1.5 1.5 0 0 0 -1.5 -1.5", "key": "svg-0" }]]);

var IconBrandWhatsappFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWhatsappFilled
});

var IconBrandWindowsFilled = createReactComponent("filled", "brand-windows-filled", "IconBrandWindowsFilled", [["path", { "d": "M21 13v5c0 1.57 -1.248 2.832 -2.715 2.923l-.113 .003l-.042 .018a1 1 0 0 1 -.336 .056l-.118 -.008l-4.676 -.585v-7.407zm-10 0v7.157l-5.3 -.662c-1.514 -.151 -2.7 -1.383 -2.7 -2.895v-3.6zm0 -9.158v7.158h-8v-3.6c0 -1.454 1.096 -2.648 2.505 -2.87zm10 2.058v5.1h-8v-7.409l4.717 -.589c1.759 -.145 3.283 1.189 3.283 2.898", "key": "svg-0" }]]);

var IconBrandWindowsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandWindowsFilled
});

var IconBrandXFilled = createReactComponent("filled", "brand-x-filled", "IconBrandXFilled", [["path", { "d": "M8.267 3a1 1 0 0 1 .73 .317l.076 .092l4.274 5.828l5.946 -5.944a1 1 0 0 1 1.497 1.32l-.083 .094l-6.163 6.162l6.262 8.54a1 1 0 0 1 -.697 1.585l-.109 .006h-4.267a1 1 0 0 1 -.73 -.317l-.076 -.092l-4.276 -5.829l-5.944 5.945a1 1 0 0 1 -1.497 -1.32l.083 -.094l6.161 -6.163l-6.26 -8.539a1 1 0 0 1 .697 -1.585l.109 -.006h4.267z", "key": "svg-0" }]]);

var IconBrandXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandXFilled
});

var IconBrandYoutubeFilled = createReactComponent("filled", "brand-youtube-filled", "IconBrandYoutubeFilled", [["path", { "d": "M18 3a5 5 0 0 1 5 5v8a5 5 0 0 1 -5 5h-12a5 5 0 0 1 -5 -5v-8a5 5 0 0 1 5 -5zm-9 6v6a1 1 0 0 0 1.514 .857l5 -3a1 1 0 0 0 0 -1.714l-5 -3a1 1 0 0 0 -1.514 .857z", "key": "svg-0" }]]);

var IconBrandYoutubeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrandYoutubeFilled
});

var IconBreadFilled = createReactComponent("filled", "bread-filled", "IconBreadFilled", [["path", { "d": "M18 3a4 4 0 0 1 3.109 6.516l-.11 .126l.001 8.358a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -3 -3v-8.356l-.116 -.136a4 4 0 0 1 -.728 -3.616l.067 -.21c.532 -1.525 1.93 -2.58 3.601 -2.677l12.079 .001z", "key": "svg-0" }]]);

var IconBreadFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBreadFilled
});

var IconBriefcase2Filled = createReactComponent("filled", "briefcase-2-filled", "IconBriefcase2Filled", [["path", { "d": "M14 2a3 3 0 0 1 3 3v1h2a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3h2v-1a3 3 0 0 1 3 -3zm0 2h-4a1 1 0 0 0 -1 1v1h6v-1a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconBriefcase2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBriefcase2Filled
});

var IconBriefcaseFilled = createReactComponent("filled", "briefcase-filled", "IconBriefcaseFilled", [["path", { "d": "M22 13.478v4.522a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-4.522l.553 .277a20.999 20.999 0 0 0 18.897 -.002l.55 -.275zm-8 -11.478a3 3 0 0 1 3 3v1h2a3 3 0 0 1 3 3v2.242l-1.447 .724a19.002 19.002 0 0 1 -16.726 .186l-.647 -.32l-1.18 -.59v-2.242a3 3 0 0 1 3 -3h2v-1a3 3 0 0 1 3 -3h4zm-2 8a1 1 0 0 0 -1 1a1 1 0 1 0 2 .01c0 -.562 -.448 -1.01 -1 -1.01zm2 -6h-4a1 1 0 0 0 -1 1v1h6v-1a1 1 0 0 0 -1 -1z", "key": "svg-0" }]]);

var IconBriefcaseFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBriefcaseFilled
});

var IconBrightnessAutoFilled = createReactComponent("filled", "brightness-auto-filled", "IconBrightnessAutoFilled", [["path", { "d": "M12.707 2.793l2.208 2.207h3.085a1 1 0 0 1 .993 .883l.007 .117v3.085l2.207 2.208a1 1 0 0 1 .083 1.32l-.083 .094l-2.207 2.207v3.086a1 1 0 0 1 -.883 .993l-.117 .007h-3.086l-2.207 2.207a1 1 0 0 1 -1.32 .083l-.094 -.083l-2.208 -2.207h-3.085a1 1 0 0 1 -.993 -.883l-.007 -.117v-3.085l-2.207 -2.208a1 1 0 0 1 -.083 -1.32l.083 -.094l2.207 -2.209v-3.084a1 1 0 0 1 .883 -.993l.117 -.007h3.084l2.209 -2.207a1 1 0 0 1 1.414 0m-.707 5.207a3 3 0 0 0 -3 3v3.5a1 1 0 0 0 2 0v-.5h2v.5a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-3.5a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v1h-2v-1a1 1 0 0 1 .883 -.993z", "key": "svg-0" }]]);

var IconBrightnessAutoFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrightnessAutoFilled
});

var IconBrightnessDownFilled = createReactComponent("filled", "brightness-down-filled", "IconBrightnessDownFilled", [["path", { "d": "M12 8a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z", "key": "svg-0" }], ["path", { "d": "M12 4a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M17 6a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M19 11a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-3" }], ["path", { "d": "M17 16a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-4" }], ["path", { "d": "M12 18a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-5" }], ["path", { "d": "M7 16a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-6" }], ["path", { "d": "M5 11a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-7" }], ["path", { "d": "M7 6a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z", "key": "svg-8" }]]);

var IconBrightnessDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrightnessDownFilled
});

var IconBrightnessUpFilled = createReactComponent("filled", "brightness-up-filled", "IconBrightnessUpFilled", [["path", { "d": "M12 8a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z", "key": "svg-0" }], ["path", { "d": "M12 2a1 1 0 0 1 .993 .883l.007 .117v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M17.693 4.893a1 1 0 0 1 1.497 1.32l-.083 .094l-1.4 1.4a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.4 -1.4z", "key": "svg-2" }], ["path", { "d": "M21 11a1 1 0 0 1 .117 1.993l-.117 .007h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2z", "key": "svg-3" }], ["path", { "d": "M16.293 16.293a1 1 0 0 1 1.32 -.083l.094 .083l1.4 1.4a1 1 0 0 1 -1.32 1.497l-.094 -.083l-1.4 -1.4a1 1 0 0 1 0 -1.414z", "key": "svg-4" }], ["path", { "d": "M12 18a1 1 0 0 1 .993 .883l.007 .117v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a1 1 0 0 1 1 -1z", "key": "svg-5" }], ["path", { "d": "M6.293 16.293a1 1 0 0 1 1.497 1.32l-.083 .094l-1.4 1.4a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.4 -1.4z", "key": "svg-6" }], ["path", { "d": "M6 11a1 1 0 0 1 .117 1.993l-.117 .007h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2z", "key": "svg-7" }], ["path", { "d": "M4.893 4.893a1 1 0 0 1 1.32 -.083l.094 .083l1.4 1.4a1 1 0 0 1 -1.32 1.497l-.094 -.083l-1.4 -1.4a1 1 0 0 1 0 -1.414z", "key": "svg-8" }]]);

var IconBrightnessUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrightnessUpFilled
});

var IconBrightnessFilled = createReactComponent("filled", "brightness-filled", "IconBrightnessFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-9 1.732a8 8 0 0 0 4.001 14.928l-.001 -16a8 8 0 0 0 -4 1.072", "key": "svg-0" }]]);

var IconBrightnessFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBrightnessFilled
});

var IconBubbleTextFilled = createReactComponent("filled", "bubble-text-filled", "IconBubbleTextFilled", [["path", { "d": "M12.4 2l.253 .005a6.34 6.34 0 0 1 5.235 3.166l.089 .163l.178 .039a6.33 6.33 0 0 1 4.254 3.406l.105 .228a6.334 6.334 0 0 1 -5.74 8.865l-.144 -.002l-.037 .052a5.26 5.26 0 0 1 -5.458 1.926l-.186 -.051l-3.435 2.06a1 1 0 0 1 -1.508 -.743l-.006 -.114v-2.435l-.055 -.026a3.67 3.67 0 0 1 -1.554 -1.498l-.102 -.199a3.67 3.67 0 0 1 -.312 -2.14l.038 -.21l-.116 -.092a5.8 5.8 0 0 1 -1.887 -6.025l.071 -.238a5.8 5.8 0 0 1 5.42 -4.004h.157l.15 -.165a6.33 6.33 0 0 1 4.33 -1.963zm1.6 11h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0 -2m3 -4h-10a1 1 0 1 0 0 2h10a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconBubbleTextFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBubbleTextFilled
});

var IconBubbleFilled = createReactComponent("filled", "bubble-filled", "IconBubbleFilled", [["path", { "d": "M12.4 2a6.33 6.33 0 0 1 5.491 3.176l.09 .162l.126 .027a6.335 6.335 0 0 1 4.889 5.934l.004 .234a6.333 6.333 0 0 1 -6.333 6.334l-.035 -.002l-.035 .05a5.26 5.26 0 0 1 -3.958 2.08l-.239 .005q -.722 0 -1.404 -.19l-.047 -.014l-3.434 2.061a1 1 0 0 1 -1.509 -.743l-.006 -.114v-2.434l-.121 -.06a3.67 3.67 0 0 1 -1.94 -3.042l-.006 -.197q 0 -.365 .07 -.717l.013 -.058l-.113 -.09a5.8 5.8 0 0 1 -2.098 -4.218l-.005 -.25a5.8 5.8 0 0 1 5.8 -5.8l.058 .001l.15 -.163a6.32 6.32 0 0 1 4.328 -1.967z", "key": "svg-0" }]]);

var IconBubbleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBubbleFilled
});

var IconBugFilled = createReactComponent("filled", "bug-filled", "IconBugFilled", [["path", { "d": "M12 4a4 4 0 0 1 3.995 3.8l.005 .2a1 1 0 0 1 .428 .096l3.033 -1.938a1 1 0 1 1 1.078 1.684l-3.015 1.931a7.17 7.17 0 0 1 .476 2.227h3a1 1 0 0 1 0 2h-3v1a6.01 6.01 0 0 1 -.195 1.525l2.708 1.616a1 1 0 1 1 -1.026 1.718l-2.514 -1.501a6.002 6.002 0 0 1 -3.973 2.56v-5.918a1 1 0 0 0 -2 0v5.917a6.002 6.002 0 0 1 -3.973 -2.56l-2.514 1.503a1 1 0 1 1 -1.026 -1.718l2.708 -1.616a6.01 6.01 0 0 1 -.195 -1.526v-1h-3a1 1 0 0 1 0 -2h3.001v-.055a7 7 0 0 1 .474 -2.173l-3.014 -1.93a1 1 0 1 1 1.078 -1.684l3.032 1.939l.024 -.012l.068 -.027l.019 -.005l.016 -.006l.032 -.008l.04 -.013l.034 -.007l.034 -.004l.045 -.008l.015 -.001l.015 -.002l.087 -.004a4 4 0 0 1 4 -4zm0 2a2 2 0 0 0 -2 2h4a2 2 0 0 0 -2 -2z", "key": "svg-0" }]]);

var IconBugFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBugFilled
});

var IconBuildingBroadcastTowerFilled = createReactComponent("filled", "building-broadcast-tower-filled", "IconBuildingBroadcastTowerFilled", [["path", { "d": "M12 10a2 2 0 0 1 1.497 3.327l2.452 7.357a1 1 0 1 1 -1.898 .632l-.44 -1.316h-3.224l-.438 1.317a1 1 0 0 1 -1.152 .663l-.113 -.03a1 1 0 0 1 -.633 -1.265l2.452 -7.357a2 2 0 0 1 -.503 -1.328l.005 -.15a2 2 0 0 1 1.995 -1.85", "key": "svg-0" }], ["path", { "d": "M18.093 4.078a10 10 0 0 1 3.137 11.776a1 1 0 0 1 -1.846 -.77a8 8 0 1 0 -14.769 0a1 1 0 0 1 -1.846 .77a10 10 0 0 1 15.324 -11.776", "key": "svg-1" }], ["path", { "d": "M15.657 7.243a6 6 0 0 1 1.882 7.066a1 1 0 1 1 -1.846 -.77a4 4 0 1 0 -7.384 0a1 1 0 1 1 -1.846 .77a6 6 0 0 1 9.194 -7.066", "key": "svg-2" }]]);

var IconBuildingBroadcastTowerFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBuildingBroadcastTowerFilled
});

var IconBulbFilled = createReactComponent("filled", "bulb-filled", "IconBulbFilled", [["path", { "d": "M4 11a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-0" }], ["path", { "d": "M12 2a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M21 11a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-2" }], ["path", { "d": "M4.893 4.893a1 1 0 0 1 1.32 -.083l.094 .083l.7 .7a1 1 0 0 1 -1.32 1.497l-.094 -.083l-.7 -.7a1 1 0 0 1 0 -1.414z", "key": "svg-3" }], ["path", { "d": "M17.693 4.893a1 1 0 0 1 1.497 1.32l-.083 .094l-.7 .7a1 1 0 0 1 -1.497 -1.32l.083 -.094l.7 -.7z", "key": "svg-4" }], ["path", { "d": "M14 18a1 1 0 0 1 1 1a3 3 0 0 1 -6 0a1 1 0 0 1 .883 -.993l.117 -.007h4z", "key": "svg-5" }], ["path", { "d": "M12 6a6 6 0 0 1 3.6 10.8a1 1 0 0 1 -.471 .192l-.129 .008h-6a1 1 0 0 1 -.6 -.2a6 6 0 0 1 3.6 -10.8z", "key": "svg-6" }]]);

var IconBulbFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBulbFilled
});

var IconBusFilled = createReactComponent("filled", "bus-filled", "IconBusFilled", [["path", { "d": "M17 4c3.4 0 6 3.64 6 8v5a1 1 0 0 1 -1 1h-1.171a3.001 3.001 0 0 1 -5.658 0h-6.342a3.001 3.001 0 0 1 -5.658 0h-1.171a1 1 0 0 1 -1 -1v-11a2 2 0 0 1 2 -2zm-11 12a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m12 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m-.76 -9.989l1.068 4.989h2.636c-.313 -2.756 -1.895 -4.82 -3.704 -4.989m-11.24 -.011h-3v3h3zm5 0h-3v3h3zm4.191 0h-2.191v3h2.834z", "key": "svg-0" }]]);

var IconBusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconBusFilled
});

var IconButterflyFilled = createReactComponent("filled", "butterfly-filled", "IconButterflyFilled", [["path", { "d": "M17.117 6.244l.228 .076a5.5 5.5 0 0 1 1.24 9.738l-.063 .039l.02 .034a4 4 0 0 1 .101 3.533l-.093 .19a4 4 0 0 1 -5.55 1.608v-14.857a5.5 5.5 0 0 1 4.118 -.36", "key": "svg-0" }], ["path", { "d": "M8.505 6c.885 0 1.736 .21 2.495 .597v14.87a4 4 0 0 1 -1.012 .41l-.196 .045a4 4 0 0 1 -4.424 -5.587l.118 -.238l-.035 -.023a5.5 5.5 0 0 1 -2.397 -5.258l.034 -.233a5.5 5.5 0 0 1 5.417 -4.583", "key": "svg-1" }], ["path", { "d": "M14.445 2.168a1 1 0 0 1 1.11 1.664l-3 2a1 1 0 0 1 -1.11 0l-3 -2a1 1 0 0 1 1.11 -1.664l2.444 1.63z", "key": "svg-2" }]]);

var IconButterflyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconButterflyFilled
});

var IconCactusFilled = createReactComponent("filled", "cactus-filled", "IconCactusFilled", [["path", { "d": "M7 22a1 1 0 0 1 -.117 -1.993l.117 -.007h2v-6a4 4 0 0 1 -3.995 -3.8l-.005 -.2v-1a1 1 0 0 1 1.993 -.117l.007 .117v1a2 2 0 0 0 1.85 1.995l.15 .005v-7a3 3 0 0 1 5.995 -.176l.005 .176v10a2 2 0 0 0 1.995 -1.85l.005 -.15v-5a1 1 0 0 1 1.993 -.117l.007 .117v5a4 4 0 0 1 -3.8 3.995l-.2 .005v3h2a1 1 0 0 1 .117 1.993l-.117 .007h-10z", "key": "svg-0" }]]);

var IconCactusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCactusFilled
});

var IconCalculatorFilled = createReactComponent("filled", "calculator-filled", "IconCalculatorFilled", [["path", { "d": "M18 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-10 15a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm4 0a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm4 0a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm-8 -4a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm4 0a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm4 0a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm-1 -7h-6a2 2 0 0 0 -2 2v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-1a2 2 0 0 0 -2 -2z", "key": "svg-0" }]]);

var IconCalculatorFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalculatorFilled
});

var IconCalendarEventFilled = createReactComponent("filled", "calendar-event-filled", "IconCalendarEventFilled", [["path", { "d": "M16 2a1 1 0 0 1 .993 .883l.007 .117v1h1a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h1v-1a1 1 0 0 1 1.993 -.117l.007 .117v1h6v-1a1 1 0 0 1 1 -1m3 7h-14v9.625c0 .705 .386 1.286 .883 1.366l.117 .009h12c.513 0 .936 -.53 .993 -1.215l.007 -.16z", "key": "svg-0" }], ["path", { "d": "M8 14h2v2h-2z", "key": "svg-1" }]]);

var IconCalendarEventFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarEventFilled
});

var IconCalendarMonthFilled = createReactComponent("filled", "calendar-month-filled", "IconCalendarMonthFilled", [["path", { "d": "M8 12a1 1 0 0 1 1 1v4a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1 -1", "key": "svg-0" }], ["path", { "d": "M12 12a1 1 0 0 1 1 1v4a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1 -1", "key": "svg-1" }], ["path", { "d": "M16 12a1 1 0 0 1 1 1v4a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1 -1", "key": "svg-2" }], ["path", { "d": "M16 2a1 1 0 0 1 .993 .883l.007 .117v1h1a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h1v-1a1 1 0 0 1 1.993 -.117l.007 .117v1h6v-1a1 1 0 0 1 1 -1m3 7h-14v9.625c0 .705 .386 1.286 .883 1.366l.117 .009h12c.513 0 .936 -.53 .993 -1.215l.007 -.16z", "key": "svg-3" }]]);

var IconCalendarMonthFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarMonthFilled
});

var IconCalendarWeekFilled = createReactComponent("filled", "calendar-week-filled", "IconCalendarWeekFilled", [["path", { "d": "M16 2c.183 0 .355 .05 .502 .135l.033 .02c.28 .177 .465 .49 .465 .845v1h1a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h1v-1a1 1 0 0 1 .514 -.874l.093 -.046l.066 -.025l.1 -.029l.107 -.019l.12 -.007q .083 0 .161 .013l.122 .029l.04 .012l.06 .023c.328 .135 .568 .44 .61 .806l.007 .117v1h6v-1a1 1 0 0 1 1 -1m3 7h-14v9.625c0 .705 .386 1.286 .883 1.366l.117 .009h12c.513 0 .936 -.53 .993 -1.215l.007 -.16z", "key": "svg-0" }], ["path", { "d": "M9.015 13a1 1 0 0 1 -1 1a1.001 1.001 0 1 1 -.005 -2c.557 0 1.005 .448 1.005 1", "key": "svg-1" }], ["path", { "d": "M13.015 13a1 1 0 0 1 -1 1a1.001 1.001 0 1 1 -.005 -2c.557 0 1.005 .448 1.005 1", "key": "svg-2" }], ["path", { "d": "M17.02 13a1 1 0 0 1 -1 1a1.001 1.001 0 1 1 -.005 -2c.557 0 1.005 .448 1.005 1", "key": "svg-3" }], ["path", { "d": "M12.02 15a1 1 0 0 1 0 2a1.001 1.001 0 1 1 -.005 -2z", "key": "svg-4" }], ["path", { "d": "M9.015 16a1 1 0 0 1 -1 1a1.001 1.001 0 1 1 -.005 -2c.557 0 1.005 .448 1.005 1", "key": "svg-5" }]]);

var IconCalendarWeekFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarWeekFilled
});

var IconCalendarFilled = createReactComponent("filled", "calendar-filled", "IconCalendarFilled", [["path", { "d": "M16 2a1 1 0 0 1 .993 .883l.007 .117v1h1a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h1v-1a1 1 0 0 1 1.993 -.117l.007 .117v1h6v-1a1 1 0 0 1 1 -1zm3 7h-14v9.625c0 .705 .386 1.286 .883 1.366l.117 .009h12c.513 0 .936 -.53 .993 -1.215l.007 -.16v-9.625z", "key": "svg-0" }], ["path", { "d": "M12 12a1 1 0 0 1 .993 .883l.007 .117v3a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-1" }]]);

var IconCalendarFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCalendarFilled
});

var IconCameraFilled = createReactComponent("filled", "camera-filled", "IconCameraFilled", [["path", { "d": "M15 3a2 2 0 0 1 1.995 1.85l.005 .15a1 1 0 0 0 .883 .993l.117 .007h1a3 3 0 0 1 2.995 2.824l.005 .176v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-9a3 3 0 0 1 2.824 -2.995l.176 -.005h1a1 1 0 0 0 1 -1a2 2 0 0 1 1.85 -1.995l.15 -.005h6zm-3 7a3 3 0 0 0 -2.985 2.698l-.011 .152l-.004 .15l.004 .15a3 3 0 1 0 2.996 -3.15z", "key": "svg-0" }]]);

var IconCameraFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCameraFilled
});

var IconCampfireFilled = createReactComponent("filled", "campfire-filled", "IconCampfireFilled", [["path", { "d": "M19.757 16.03a1 1 0 0 1 .597 1.905l-.111 .035l-16 4a1 1 0 0 1 -.597 -1.905l.111 -.035l16 -4z", "key": "svg-0" }], ["path", { "d": "M3.03 16.757a1 1 0 0 1 1.098 -.749l.115 .022l16 4a1 1 0 0 1 -.37 1.962l-.116 -.022l-16 -4a1 1 0 0 1 -.727 -1.213z", "key": "svg-1" }], ["path", { "d": "M13.553 2.106c-4.174 2.086 -6.553 5.358 -6.553 8.894a5 5 0 0 0 10 0c0 -1.047 -.188 -1.808 -.606 -2.705l-.169 -.345l-.33 -.647c-.621 -1.24 -.895 -2.338 -.895 -4.303a1 1 0 0 0 -1.447 -.894z", "key": "svg-2" }]]);

var IconCampfireFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCampfireFilled
});

var IconCandleFilled = createReactComponent("filled", "candle-filled", "IconCandleFilled", [["path", { "d": "M14 9a2 2 0 0 1 2 2v10a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-10a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M11.254 1.334a1 1 0 0 1 1.491 0l1.452 1.623a3 3 0 0 1 -4.196 4.28c-1.195 -1.07 -1.339 -2.889 -.297 -4.166z", "key": "svg-1" }]]);

var IconCandleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCandleFilled
});

var IconCannabisFilled = createReactComponent("filled", "cannabis-filled", "IconCannabisFilled", [["path", { "d": "M12.894 1.553c1.472 2.945 2.17 5.028 2.244 6.812l.001 .091l.032 -.022a8.7 8.7 0 0 1 2.73 -1.191l.352 -.079a8 8 0 0 1 1.562 -.169l.253 .007a1 1 0 0 1 .85 1.396c-.949 2.187 -1.818 3.595 -2.902 4.664l-.061 .058l.25 .055q .45 .108 .869 .259l.276 .104c.586 .235 1.006 .479 1.25 .662a1 1 0 0 1 -.042 1.63l-.199 .112l-1.133 .587c-.567 .289 -1.166 .584 -1.404 .67q -.123 .045 -.244 .083l-.074 .019l.016 .042c.327 .912 .456 1.789 .477 2.462l.003 .195a1 1 0 0 1 -1 1c-1.257 0 -2.77 -.729 -4.001 -1.647l.001 2.647a1 1 0 0 1 -2 0v-2.647c-1.16 .866 -2.57 1.563 -3.781 1.64l-.219 .007a1 1 0 0 1 -1 -1c0 -.624 .098 -1.464 .379 -2.358l.116 -.341l-.073 -.02l-.244 -.081c-.343 -.125 -1.442 -.686 -2.106 -1.032l-.52 -.274a1 1 0 0 1 -.152 -1.694c.244 -.183 .664 -.427 1.25 -.662a8 8 0 0 1 1.145 -.363l.249 -.055l-.06 -.058c-1.024 -1.01 -1.856 -2.322 -2.744 -4.307l-.157 -.357a1 1 0 0 1 .724 -1.38l.149 -.017l.058 -.003a7.5 7.5 0 0 1 1.744 .159a8.6 8.6 0 0 1 2.727 1.045l.27 .169v-.037c-.028 -1.594 .375 -3.18 1.095 -4.704l.139 -.285c.455 -.908 .914 -1.586 1.238 -1.98a1 1 0 0 1 1.666 .189", "key": "svg-0" }]]);

var IconCannabisFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCannabisFilled
});

var IconCapsuleHorizontalFilled = createReactComponent("filled", "capsule-horizontal-filled", "IconCapsuleHorizontalFilled", [["path", { "d": "M15 5h-6a7 7 0 1 0 0 14h6a7 7 0 0 0 7 -7l-.007 -.303a7 7 0 0 0 -6.993 -6.697z", "key": "svg-0" }]]);

var IconCapsuleHorizontalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCapsuleHorizontalFilled
});

var IconCapsuleFilled = createReactComponent("filled", "capsule-filled", "IconCapsuleFilled", [["path", { "d": "M12 2l-.243 .004a7.004 7.004 0 0 0 -6.757 6.996v6a7 7 0 0 0 7 7l.243 -.004a7.004 7.004 0 0 0 6.757 -6.996v-6a7 7 0 0 0 -7 -7z", "key": "svg-0" }]]);

var IconCapsuleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCapsuleFilled
});

var IconCaptureFilled = createReactComponent("filled", "capture-filled", "IconCaptureFilled", [["path", { "d": "M8 3a1 1 0 0 1 .117 1.993l-.117 .007h-2a1 1 0 0 0 -.993 .883l-.007 .117v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a3 3 0 0 1 2.824 -2.995l.176 -.005h2z", "key": "svg-0" }], ["path", { "d": "M4 15a1 1 0 0 1 .993 .883l.007 .117v2a1 1 0 0 0 .883 .993l.117 .007h2a1 1 0 0 1 .117 1.993l-.117 .007h-2a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-2a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a1 1 0 0 0 -.883 -.993l-.117 -.007h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2z", "key": "svg-2" }], ["path", { "d": "M20 15a1 1 0 0 1 .993 .883l.007 .117v2a3 3 0 0 1 -2.824 2.995l-.176 .005h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2a1 1 0 0 0 .993 -.883l.007 -.117v-2a1 1 0 0 1 1 -1z", "key": "svg-3" }], ["path", { "d": "M12 8a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z", "key": "svg-4" }]]);

var IconCaptureFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaptureFilled
});

var IconCar4wdFilled = createReactComponent("filled", "car-4wd-filled", "IconCar4wdFilled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v2a3 3 0 0 1 -6 0h-1v10h1a3 3 0 0 1 6 0v2a3 3 0 0 1 -6 0h-4a3 3 0 0 1 -6 0v-2a3 3 0 0 1 6 0h1v-10h-1a3 3 0 1 1 -6 0v-2a3 3 0 1 1 6 0h4a3 3 0 0 1 3 -3", "key": "svg-0" }]]);

var IconCar4wdFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCar4wdFilled
});

var IconCarCraneFilled = createReactComponent("filled", "car-crane-filled", "IconCarCraneFilled", [["path", { "d": "M3.06 5.66l.035 -.085l.07 -.125l.033 -.048l.063 -.075l.064 -.065l.098 -.079l.106 -.065l.067 -.033l.048 -.02l.139 -.041l18.053 -3.01a1 1 0 0 1 1.164 .986v2a1 1 0 0 1 -2 0v-.82l-13.802 2.3l1.25 .626a1 1 0 0 1 .552 .894l-.001 3h2.001v-4a1 1 0 0 1 1 -1h4a6 6 0 0 1 6 6v5a1 1 0 0 1 -1 1h-1.17a3.001 3.001 0 0 1 -5.66 0h-6.34a3.001 3.001 0 0 1 -5.83 -1v-5a1 1 0 0 1 1 -1v-4.99a1 1 0 0 1 .06 -.35m1.94 10.34a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m12 0a1 1 0 1 0 .992 1.124l.008 -.132l-.007 -.109a1 1 0 0 0 -.993 -.883m-.652 -7.985l.895 2.985h2.63l-.042 -.155a4 4 0 0 0 -3.223 -2.8z", "key": "svg-0" }]]);

var IconCarCraneFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarCraneFilled
});

var IconCarFanFilled = createReactComponent("filled", "car-fan-filled", "IconCarFanFilled", [["path", { "d": "M12.363 2.068l4.912 1.914a2.7 2.7 0 0 1 .68 4.646l-3.045 2.371l6.09 .001a1 1 0 0 1 .932 1.363l-1.914 4.912a2.7 2.7 0 0 1 -4.646 .68l-2.372 -3.047v6.092a1 1 0 0 1 -1.363 .932l-4.912 -1.914a2.7 2.7 0 0 1 -.68 -4.646l3.045 -2.372h-6.09a1 1 0 0 1 -.932 -1.363l1.914 -4.912a2.7 2.7 0 0 1 4.646 -.68l2.371 3.044l.001 -6.089a1 1 0 0 1 1.363 -.932", "key": "svg-0" }]]);

var IconCarFanFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarFanFilled
});

var IconCarSuvFilled = createReactComponent("filled", "car-suv-filled", "IconCarSuvFilled", [["path", { "d": "M7 14a3 3 0 1 1 -3 3l.005 -.176a3 3 0 0 1 2.995 -2.824m11 0a3 3 0 1 1 -3 3l.005 -.176a3 3 0 0 1 2.995 -2.824m-11 2a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m11 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m-3.562 -12a3 3 0 0 1 2.91 2.272l.433 1.728h2.219a3 3 0 0 1 2.995 2.824l.005 .176v3.02l-.01 .117a1 1 0 0 1 -.286 .575l-.107 .091l-.07 .049l-.076 .042l-.106 .046l-.017 .005l-.047 .016l-.108 .025l-.118 .013l-.08 .002l-.122 -.012l-.148 -.033l-.063 -.022a1 1 0 0 1 -.362 -.24l-.08 -.094a4 4 0 0 0 -3.2 -1.6a4 4 0 0 0 -3.2 1.6a1 1 0 0 1 -.8 .4h-3a1 1 0 0 1 -.8 -.4a3.998 3.998 0 0 0 -6.402 .002a1 1 0 1 1 -1.602 -1.198c.493 -.66 1.11 -1.2 1.804 -1.602v-2.792a1 1 0 0 1 .06 -.35l.042 -.1l2.004 -4.007a1 1 0 0 1 .894 -.553zm-12.438 2a1 1 0 0 1 1 1v4a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1 -1m12.438 0h-3.438v2h4.718l-.31 -1.243a1 1 0 0 0 -.97 -.757m-5.438 0h-1.382l-1.001 2h2.383z", "key": "svg-0" }]]);

var IconCarSuvFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarSuvFilled
});

var IconCarFilled = createReactComponent("filled", "car-filled", "IconCarFilled", [["path", { "d": "M14 5a1 1 0 0 1 .694 .28l.087 .095l3.699 4.625h.52a3 3 0 0 1 2.995 2.824l.005 .176v4a1 1 0 0 1 -1 1h-1.171a3.001 3.001 0 0 1 -5.658 0h-4.342a3.001 3.001 0 0 1 -5.658 0h-1.171a1 1 0 0 1 -1 -1v-6l.007 -.117l.008 -.056l.017 -.078l.012 -.036l.014 -.05l2.014 -5.034a1 1 0 0 1 .928 -.629zm-7 11a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m10 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m-6 -9h-5.324l-1.2 3h6.524zm2.52 0h-.52v3h2.92z", "key": "svg-0" }]]);

var IconCarFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarFilled
});

var IconCarambolaFilled = createReactComponent("filled", "carambola-filled", "IconCarambolaFilled", [["path", { "d": "M17.108 22.085c-1.266 -.068 -2.924 -.859 -5.071 -2.355l-.04 -.027l-.037 .027c-2.147 1.497 -3.804 2.288 -5.072 2.356l-.178 .005c-2.747 0 -3.097 -2.64 -1.718 -7.244l.054 -.178l-.1 -.075c-6.056 -4.638 -5.046 -7.848 2.554 -8.066l.202 -.005l.115 -.326c1.184 -3.33 2.426 -5.085 4.027 -5.192l.156 -.005c1.674 0 2.957 1.76 4.182 5.197l.114 .326l.204 .005c7.6 .218 8.61 3.428 2.553 8.065l-.102 .075l.055 .178c1.35 4.512 1.04 7.137 -1.556 7.24l-.163 .003z", "key": "svg-0" }]]);

var IconCarambolaFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarambolaFilled
});

var IconCaravanFilled = createReactComponent("filled", "caravan-filled", "IconCaravanFilled", [["path", { "d": "M15.949 3.684l.771 2.316h1.28a3 3 0 0 1 3 3v6h1a1 1 0 0 1 0 2h-1.17a3 3 0 0 1 -2.83 2h-6.17a3.001 3.001 0 0 1 -5.66 0h-1.17a3 3 0 0 1 -3 -3v-3.5a6.5 6.5 0 0 1 5.672 -6.448l6.934 -2.971a1 1 0 0 1 1.343 .603m-6.949 13.316a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m5.5 -7h-1a1.5 1.5 0 0 0 -1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h1a1.5 1.5 0 0 0 1.5 -1.5v-1a1.5 1.5 0 0 0 -1.5 -1.5m-.105 -4.653l-1.524 .653h1.742z", "key": "svg-0" }]]);

var IconCaravanFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaravanFilled
});

var IconCardboardsFilled = createReactComponent("filled", "cardboards-filled", "IconCardboardsFilled", [["path", { "d": "M19 5a3 3 0 0 1 3 3v8.5a3.5 3.5 0 0 1 -3.5 3.5h-1.062a4 4 0 0 1 -3.118 -1.504l-1.54 -1.92a1 1 0 0 0 -1.56 0l-1.538 1.917a4 4 0 0 1 -3.122 1.507h-1.06a3.5 3.5 0 0 1 -3.5 -3.5v-8.5a3 3 0 0 1 3 -3zm-11 5a2 2 0 0 0 -1.995 1.85l-.005 .15a2 2 0 1 0 2 -2m8 0a2 2 0 0 0 -1.995 1.85l-.005 .15a2 2 0 1 0 2 -2", "key": "svg-0" }]]);

var IconCardboardsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCardboardsFilled
});

var IconCardsFilled = createReactComponent("filled", "cards-filled", "IconCardsFilled", [["path", { "d": "M10.348 3.169l-7.15 3.113a2 2 0 0 0 -1.03 2.608l4.92 11.895a1.96 1.96 0 0 0 2.59 1.063l7.142 -3.11a2.002 2.002 0 0 0 1.036 -2.611l-4.92 -11.894a1.96 1.96 0 0 0 -2.588 -1.064z", "key": "svg-0" }], ["path", { "d": "M16 3a2 2 0 0 1 1.995 1.85l.005 .15v3.5a1 1 0 0 1 -1.993 .117l-.007 -.117v-3.5h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-1" }], ["path", { "d": "M19.08 5.61a1 1 0 0 1 1.31 -.53c.257 .108 .505 .21 .769 .314a2 2 0 0 1 1.114 2.479l-.056 .146l-2.298 5.374a1 1 0 0 1 -1.878 -.676l.04 -.11l2.296 -5.371l-.366 -.148l-.402 -.167a1 1 0 0 1 -.53 -1.312z", "key": "svg-2" }]]);

var IconCardsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCardsFilled
});

var IconCaretDownFilled = createReactComponent("filled", "caret-down-filled", "IconCaretDownFilled", [["path", { "d": "M18 9c.852 0 1.297 .986 .783 1.623l-.076 .084l-6 6a1 1 0 0 1 -1.32 .083l-.094 -.083l-6 -6l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057v-.118l.005 -.058l.009 -.06l.01 -.052l.032 -.108l.027 -.067l.07 -.132l.065 -.09l.073 -.081l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01l.057 -.004l12.059 -.002z", "key": "svg-0" }]]);

var IconCaretDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaretDownFilled
});

var IconCaretLeftRightFilled = createReactComponent("filled", "caret-left-right-filled", "IconCaretLeftRightFilled", [["path", { "d": "M13 6c0 -.89 1.077 -1.337 1.707 -.707l6 6a1 1 0 0 1 0 1.414l-6 6a.95 .95 0 0 1 -.082 .073l-.009 .006l-.022 .016l-.058 .042l-.016 .009l-.009 .007l-.028 .014l-.043 .024l-.018 .007l-.018 .01l-.034 .012l-.033 .015l-.026 .007l-.02 .008l-.026 .005l-.036 .012l-.029 .004l-.024 .006l-.028 .003l-.031 .006l-.032 .002l-.026 .003h-.026l-.033 .002l-.033 -.002h-.026l-.026 -.003l-.032 -.002l-.031 -.006l-.028 -.003l-.024 -.006l-.03 -.004l-.035 -.012l-.027 -.005l-.019 -.008l-.026 -.007l-.033 -.015l-.034 -.012l-.018 -.01l-.018 -.007l-.043 -.024l-.028 -.014l-.009 -.007l-.016 -.009l-.058 -.042l-.019 -.012l-.003 -.004l-.01 -.006a1.006 1.006 0 0 1 -.154 -.155l-.006 -.009l-.016 -.022l-.042 -.058l-.009 -.016l-.007 -.009l-.014 -.028l-.024 -.043l-.007 -.018l-.01 -.018l-.012 -.034l-.015 -.033l-.007 -.026l-.008 -.02l-.005 -.026l-.012 -.036l-.004 -.029l-.006 -.024l-.003 -.028l-.006 -.031l-.002 -.032l-.003 -.026v-.026l-.002 -.033v-12z", "key": "svg-0" }], ["path", { "d": "M9.293 5.293c.63 -.63 1.707 -.184 1.707 .707v12l-.002 .033v.026l-.003 .026l-.002 .032l-.006 .031l-.003 .028l-.006 .024l-.004 .03l-.012 .035l-.005 .027l-.008 .019l-.007 .026l-.015 .033l-.012 .034l-.01 .018l-.007 .018l-.024 .043l-.014 .028l-.007 .009l-.009 .016l-.042 .058l-.012 .019l-.004 .003l-.006 .01a1.006 1.006 0 0 1 -.155 .154l-.009 .006l-.022 .016l-.058 .042l-.016 .009l-.009 .007l-.028 .014l-.043 .024l-.018 .007l-.018 .01l-.034 .012l-.033 .015l-.026 .007l-.02 .008l-.026 .005l-.036 .012l-.029 .004l-.024 .006l-.028 .003l-.031 .006l-.032 .002l-.026 .003h-.026l-.033 .002l-.033 -.002h-.026l-.028 -.003l-.03 -.002l-.032 -.006l-.027 -.003l-.025 -.006l-.028 -.004l-.037 -.012l-.026 -.005l-.02 -.008l-.025 -.007l-.034 -.015l-.033 -.012l-.019 -.01l-.017 -.007l-.044 -.024l-.027 -.014l-.01 -.007l-.015 -.009l-.059 -.042l-.018 -.012l-.004 -.004l-.008 -.006a1.006 1.006 0 0 1 -.082 -.073l-6 -6a1 1 0 0 1 0 -1.414l6 -6z", "key": "svg-1" }]]);

var IconCaretLeftRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaretLeftRightFilled
});

var IconCaretLeftFilled = createReactComponent("filled", "caret-left-filled", "IconCaretLeftFilled", [["path", { "d": "M13.883 5.007l.058 -.005h.118l.058 .005l.06 .009l.052 .01l.108 .032l.067 .027l.132 .07l.09 .065l.081 .073l.083 .094l.054 .077l.054 .096l.017 .036l.027 .067l.032 .108l.01 .053l.01 .06l.004 .057l.002 .059v12c0 .852 -.986 1.297 -1.623 .783l-.084 -.076l-6 -6a1 1 0 0 1 -.083 -1.32l.083 -.094l6 -6l.094 -.083l.077 -.054l.096 -.054l.036 -.017l.067 -.027l.108 -.032l.053 -.01l.06 -.01z", "key": "svg-0" }]]);

var IconCaretLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaretLeftFilled
});

var IconCaretRightFilled = createReactComponent("filled", "caret-right-filled", "IconCaretRightFilled", [["path", { "d": "M9 6c0 -.852 .986 -1.297 1.623 -.783l.084 .076l6 6a1 1 0 0 1 .083 1.32l-.083 .094l-6 6l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002l-.059 -.002l-.058 -.005l-.06 -.009l-.052 -.01l-.108 -.032l-.067 -.027l-.132 -.07l-.09 -.065l-.081 -.073l-.083 -.094l-.054 -.077l-.054 -.096l-.017 -.036l-.027 -.067l-.032 -.108l-.01 -.053l-.01 -.06l-.004 -.057l-.002 -12.059z", "key": "svg-0" }]]);

var IconCaretRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaretRightFilled
});

var IconCaretUpDownFilled = createReactComponent("filled", "caret-up-down-filled", "IconCaretUpDownFilled", [["path", { "d": "M11.293 3.293a1 1 0 0 1 1.414 0l6 6a.95 .95 0 0 1 .073 .082l.006 .008l.016 .022l.042 .059l.009 .015l.007 .01l.014 .027l.024 .044l.007 .017l.01 .02l.012 .032l.015 .034l.007 .025l.008 .02l.005 .026l.012 .037l.004 .028l.006 .025l.003 .026l.006 .033l.002 .03l.003 .028v.026l.002 .033l-.002 .033v.026l-.003 .026l-.002 .032l-.005 .029l-.004 .03l-.006 .024l-.004 .03l-.012 .035l-.005 .027l-.008 .019l-.007 .026l-.015 .033l-.012 .034l-.01 .018l-.007 .018l-.024 .043l-.014 .028l-.007 .009l-.009 .016l-.042 .058l-.012 .019l-.004 .003l-.006 .01a1.006 1.006 0 0 1 -.155 .154l-.009 .006l-.022 .016l-.058 .042l-.016 .009l-.009 .007l-.028 .014l-.043 .024l-.018 .007l-.018 .01l-.034 .012l-.033 .015l-.024 .006l-.021 .009l-.027 .005l-.036 .012l-.029 .004l-.024 .006l-.028 .003l-.031 .006l-.032 .002l-.026 .003h-.026l-.033 .002h-12c-.89 0 -1.337 -1.077 -.707 -1.707l6 -6z", "key": "svg-0" }], ["path", { "d": "M18 13l.033 .002h.026l.026 .003l.032 .002l.031 .006l.028 .003l.024 .006l.03 .004l.035 .012l.027 .005l.019 .008l.026 .007l.033 .015l.034 .012l.018 .01l.018 .007l.043 .024l.028 .014l.009 .007l.016 .009l.051 .037l.026 .017l.003 .004l.01 .006a.982 .982 0 0 1 .154 .155l.006 .009l.015 .02l.043 .06l.009 .016l.007 .009l.014 .028l.024 .043l.005 .013l.012 .023l.012 .034l.015 .033l.007 .026l.008 .02l.005 .026l.012 .036l.004 .029l.006 .024l.003 .028l.006 .031l.002 .032l.003 .026v.026l.002 .033l-.002 .033v.026l-.003 .026l-.002 .032l-.006 .031l-.003 .028l-.006 .024l-.004 .03l-.012 .035l-.005 .027l-.008 .019l-.007 .026l-.015 .033l-.012 .034l-.01 .018l-.007 .018l-.024 .043l-.014 .028l-.007 .009l-.009 .016l-.042 .058l-.012 .019l-.004 .003l-.006 .01l-.073 .081l-6 6a1 1 0 0 1 -1.414 0l-6 -6c-.63 -.63 -.184 -1.707 .707 -1.707h12z", "key": "svg-1" }]]);

var IconCaretUpDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaretUpDownFilled
});

var IconCaretUpFilled = createReactComponent("filled", "caret-up-filled", "IconCaretUpFilled", [["path", { "d": "M11.293 7.293a1 1 0 0 1 1.32 -.083l.094 .083l6 6l.083 .094l.054 .077l.054 .096l.017 .036l.027 .067l.032 .108l.01 .053l.01 .06l.004 .057l.002 .059l-.002 .059l-.005 .058l-.009 .06l-.01 .052l-.032 .108l-.027 .067l-.07 .132l-.065 .09l-.073 .081l-.094 .083l-.077 .054l-.096 .054l-.036 .017l-.067 .027l-.108 .032l-.053 .01l-.06 .01l-.057 .004l-.059 .002h-12c-.852 0 -1.297 -.986 -.783 -1.623l.076 -.084l6 -6z", "key": "svg-0" }]]);

var IconCaretUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCaretUpFilled
});

var IconCarouselHorizontalFilled = createReactComponent("filled", "carousel-horizontal-filled", "IconCarouselHorizontalFilled", [["path", { "d": "M16 4h-8a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M22 6a1 1 0 0 1 .117 1.993l-.117 .007h-1v8h1a1 1 0 0 1 .117 1.993l-.117 .007h-1a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-8a2 2 0 0 1 1.85 -1.995l.15 -.005h1z", "key": "svg-1" }], ["path", { "d": "M3 6a2 2 0 0 1 1.995 1.85l.005 .15v8a2 2 0 0 1 -1.85 1.995l-.15 .005h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1v-8h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-2" }]]);

var IconCarouselHorizontalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarouselHorizontalFilled
});

var IconCarouselVerticalFilled = createReactComponent("filled", "carousel-vertical-filled", "IconCarouselVerticalFilled", [["path", { "d": "M18 6h-12a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-8a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M16 19a2 2 0 0 1 1.995 1.85l.005 .15v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1h-8v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a2 2 0 0 1 1.85 -1.995l.15 -.005h8z", "key": "svg-1" }], ["path", { "d": "M17 1a1 1 0 0 1 .993 .883l.007 .117v1a2 2 0 0 1 -1.85 1.995l-.15 .005h-8a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-1a1 1 0 0 1 1.993 -.117l.007 .117v1h8v-1a1 1 0 0 1 1 -1z", "key": "svg-2" }]]);

var IconCarouselVerticalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCarouselVerticalFilled
});

var IconCashBanknoteFilled = createReactComponent("filled", "cash-banknote-filled", "IconCashBanknoteFilled", [["path", { "d": "M19 5a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3zm-7 4a3 3 0 0 0 -2.996 2.85l-.004 .15a3 3 0 1 0 3 -3m6.01 2h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m-12 0h-.01a1 1 0 1 0 .01 2a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconCashBanknoteFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCashBanknoteFilled
});

var IconCategoryFilled = createReactComponent("filled", "category-filled", "IconCategoryFilled", [["path", { "d": "M10 3h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1z", "key": "svg-0" }], ["path", { "d": "M20 3h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1z", "key": "svg-1" }], ["path", { "d": "M10 13h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1z", "key": "svg-2" }], ["path", { "d": "M17 13a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z", "key": "svg-3" }]]);

var IconCategoryFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCategoryFilled
});

var IconChargingPileFilled = createReactComponent("filled", "charging-pile-filled", "IconChargingPileFilled", [["path", { "d": "M12 3a3 3 0 0 1 3 3v4a3 3 0 0 1 3 3v3a.5 .5 0 1 0 1 0v-6.585l-1 -1l-.293 .292a1 1 0 0 1 -1.414 -1.414l.292 -.293l-.292 -.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 .293 .707v7a2.5 2.5 0 1 1 -5 0v-3a1 1 0 0 0 -1 -1v7a1 1 0 0 1 0 2h-12a1 1 0 0 1 0 -2v-13a3 3 0 0 1 3 -3zm-2.486 7.643a1 1 0 0 0 -1.371 .343l-1.5 2.5l-.054 .1a1 1 0 0 0 .911 1.414h1.233l-.59 .986a1 1 0 0 0 1.714 1.028l1.5 -2.5l.054 -.1a1 1 0 0 0 -.911 -1.414h-1.235l.592 -.986a1 1 0 0 0 -.343 -1.371m2.486 -5.643h-6a1 1 0 0 0 -1 1v1h8v-1a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconChargingPileFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChargingPileFilled
});

var IconChartAreaLineFilled = createReactComponent("filled", "chart-area-line-filled", "IconChartAreaLineFilled", [["path", { "d": "M15.22 9.375a1 1 0 0 1 1.393 -.165l.094 .083l4 4a1 1 0 0 1 .284 .576l.009 .131v5a1 1 0 0 1 -.883 .993l-.117 .007h-16.022l-.11 -.009l-.11 -.02l-.107 -.034l-.105 -.046l-.1 -.059l-.094 -.07l-.06 -.055l-.072 -.082l-.064 -.089l-.054 -.096l-.016 -.035l-.04 -.103l-.027 -.106l-.015 -.108l-.004 -.11l.009 -.11l.019 -.105c.01 -.04 .022 -.077 .035 -.112l.046 -.105l.059 -.1l4 -6a1 1 0 0 1 1.165 -.39l.114 .05l3.277 1.638l3.495 -4.369z", "key": "svg-0" }], ["path", { "d": "M15.232 3.36a1 1 0 0 1 1.382 -.15l.093 .083l4 4a1 1 0 0 1 -1.32 1.497l-.094 -.083l-3.226 -3.225l-4.299 5.158a1 1 0 0 1 -1.1 .303l-.115 -.049l-3.254 -1.626l-2.499 3.332a1 1 0 0 1 -1.295 .269l-.105 -.069a1 1 0 0 1 -.269 -1.295l.069 -.105l3 -4a1 1 0 0 1 1.137 -.341l.11 .047l3.291 1.645l4.494 -5.391z", "key": "svg-1" }]]);

var IconChartAreaLineFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartAreaLineFilled
});

var IconChartAreaFilled = createReactComponent("filled", "chart-area-filled", "IconChartAreaFilled", [["path", { "d": "M20 18a1 1 0 0 1 .117 1.993l-.117 .007h-16a1 1 0 0 1 -.117 -1.993l.117 -.007h16z", "key": "svg-0" }], ["path", { "d": "M15.22 5.375a1 1 0 0 1 1.393 -.165l.094 .083l4 4a1 1 0 0 1 .284 .576l.009 .131v5a1 1 0 0 1 -.883 .993l-.117 .007h-16.022l-.11 -.009l-.11 -.02l-.107 -.034l-.105 -.046l-.1 -.059l-.094 -.07l-.06 -.055l-.072 -.082l-.064 -.089l-.054 -.096l-.016 -.035l-.04 -.103l-.027 -.106l-.015 -.108l-.004 -.11l.009 -.11l.019 -.105c.01 -.04 .022 -.077 .035 -.112l.046 -.105l.059 -.1l4 -6a1 1 0 0 1 1.165 -.39l.114 .05l3.277 1.638l3.495 -4.369z", "key": "svg-1" }]]);

var IconChartAreaFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartAreaFilled
});

var IconChartBubbleFilled = createReactComponent("filled", "chart-bubble-filled", "IconChartBubbleFilled", [["path", { "d": "M6 12a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z", "key": "svg-0" }], ["path", { "d": "M16 16a3 3 0 1 1 -2.995 3.176l-.005 -.176l.005 -.176a3 3 0 0 1 2.995 -2.824z", "key": "svg-1" }], ["path", { "d": "M14.5 2a5.5 5.5 0 1 1 -5.496 5.721l-.004 -.221l.004 -.221a5.5 5.5 0 0 1 5.496 -5.279z", "key": "svg-2" }]]);

var IconChartBubbleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartBubbleFilled
});

var IconChartCandleFilled = createReactComponent("filled", "chart-candle-filled", "IconChartCandleFilled", [["path", { "d": "M6 3a1 1 0 0 1 .993 .883l.007 .117v1a2 2 0 0 1 1.995 1.85l.005 .15v3a2 2 0 0 1 -1.85 1.995l-.15 .005v8a1 1 0 0 1 -1.993 .117l-.007 -.117v-8a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 1.85 -1.995l.15 -.005v-1a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M12 3a1 1 0 0 1 .993 .883l.007 .117v9a2 2 0 0 1 1.995 1.85l.005 .15v3a2 2 0 0 1 -1.85 1.995l-.15 .005a1 1 0 0 1 -1.993 .117l-.007 -.117l-.15 -.005a2 2 0 0 1 -1.844 -1.838l-.006 -.157v-3a2 2 0 0 1 1.85 -1.995l.15 -.005v-9a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M18 3a1 1 0 0 1 .993 .883l.007 .117a2 2 0 0 1 1.995 1.85l.005 .15v4a2 2 0 0 1 -1.85 1.995l-.15 .005v8a1 1 0 0 1 -1.993 .117l-.007 -.117v-8a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-4a2 2 0 0 1 1.85 -1.995l.15 -.005a1 1 0 0 1 1 -1z", "key": "svg-2" }]]);

var IconChartCandleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartCandleFilled
});

var IconChartDonutFilled = createReactComponent("filled", "chart-donut-filled", "IconChartDonutFilled", [["path", { "d": "M11.292 2.61c.396 .318 .65 .78 .703 1.286l.005 .104v4a1 1 0 0 1 -.748 .968a3.1 3.1 0 1 0 3.78 3.78a1 1 0 0 1 .968 -.748h3.8a2 2 0 0 1 2 2a1 1 0 0 1 -.026 .226a10 10 0 1 1 -12 -12l.057 -.01l.052 -.01a1.9 1.9 0 0 1 1.409 .404m3.703 -.11l.045 .002l.067 .004l.081 .014l.032 .004l.072 .022l.04 .01a10 10 0 0 1 6.003 5.818l.108 .294a1 1 0 0 1 -.943 1.332h-4.5a1 1 0 0 1 -.76 -.35a8 8 0 0 0 -.89 -.89a1 1 0 0 1 -.35 -.76v-4.5q .001 -.119 .026 -.23l.03 -.102a1 1 0 0 1 .168 -.299l.03 -.033l.039 -.043a1 1 0 0 1 .089 -.08l.051 -.034l.03 -.023l.045 -.025l.052 -.03a1 1 0 0 1 .435 -.101", "key": "svg-0" }]]);

var IconChartDonutFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartDonutFilled
});

var IconChartDots2Filled = createReactComponent("filled", "chart-dots-2-filled", "IconChartDots2Filled", [["path", { "d": "M3 2a1 1 0 0 1 1 1v17h17a1 1 0 0 1 .993 .883l.007 .117a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1 -1v-18a1 1 0 0 1 1 -1m18.97 .757a1 1 0 0 1 -.727 1.213l-5.256 1.314a3 3 0 0 1 -.55 1.465l1.768 2.358a3.003 3.003 0 0 1 3.795 2.893a3 3 0 0 1 -5.436 1.751l-3.57 1.428a3 3 0 0 1 -5.994 -.179l.005 -.176a3 3 0 0 1 5.43 -1.576l3.57 -1.428l.015 -.17c.06 -.518 .253 -.996 .542 -1.4l-1.767 -2.357a3.003 3.003 0 0 1 -3.795 -2.893l.005 -.176a3 3 0 0 1 5.497 -1.48l5.255 -1.314a1 1 0 0 1 1.213 .727", "key": "svg-0" }]]);

var IconChartDots2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartDots2Filled
});

var IconChartDots3Filled = createReactComponent("filled", "chart-dots-3-filled", "IconChartDots3Filled", [["path", { "d": "M18 2a4 4 0 1 1 -3.843 5.114l-6.295 .786a3 3 0 0 1 -.094 .257l6.446 4.431a3 3 0 1 1 -.695 4.099l-3.527 1.058q .008 .127 .008 .255a4 4 0 1 1 -8 0l.005 -.2a4 4 0 0 1 7.366 -1.954l3.64 -1.094l.01 -.102q .023 -.204 .074 -.4l-6.688 -4.6a3 3 0 0 1 -4.407 -2.65l.005 -.176a3 3 0 0 1 5.784 -.931l6.312 -.79a4 4 0 0 1 3.899 -3.103", "key": "svg-0" }]]);

var IconChartDots3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartDots3Filled
});

var IconChartDotsFilled = createReactComponent("filled", "chart-dots-filled", "IconChartDotsFilled", [["path", { "d": "M3 2a1 1 0 0 1 1 1v17h17a1 1 0 0 1 .993 .883l.007 .117a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1 -1v-18a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M19 4a3 3 0 1 1 -.651 5.93l-2.002 3.202a3 3 0 1 1 -4.927 .337l-1.378 -1.655a3 3 0 1 1 1.538 -1.282l1.378 1.654a2.994 2.994 0 0 1 1.693 -.115l2.002 -3.203a3 3 0 0 1 2.347 -4.868z", "key": "svg-1" }]]);

var IconChartDotsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartDotsFilled
});

var IconChartFunnelFilled = createReactComponent("filled", "chart-funnel-filled", "IconChartFunnelFilled", [["path", { "d": "M17.72 16l-1.315 3.948a3 3 0 0 1 -2.847 2.052h-3.116a3 3 0 0 1 -2.847 -2.052l-1.315 -3.948zm2 -6l-1.333 4h-12.774l-1.333 -4zm-.106 -8a2 2 0 0 1 1.896 2.632l-1.123 3.368h-16.774l-1.123 -3.368a2 2 0 0 1 1.72 -2.624l.177 -.008z", "key": "svg-0" }]]);

var IconChartFunnelFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartFunnelFilled
});

var IconChartGridDotsFilled = createReactComponent("filled", "chart-grid-dots-filled", "IconChartGridDotsFilled", [["path", { "d": "M18 2a1 1 0 0 1 1 1v.171a3.008 3.008 0 0 1 1.83 1.83l.17 -.001a1 1 0 0 1 0 2h-.171a3.008 3.008 0 0 1 -1.828 1.829l-.001 2.171h2a1 1 0 0 1 0 2h-2v2.171a3.008 3.008 0 0 1 1.83 1.83l.17 -.001a1 1 0 0 1 0 2h-.171a3.008 3.008 0 0 1 -1.828 1.829l-.001 .171a1 1 0 0 1 -2 0v-.17a3.008 3.008 0 0 1 -1.829 -1.83h-2.171v2a1 1 0 0 1 -2 0v-2h-2.171a3.008 3.008 0 0 1 -1.828 1.829l-.001 .171a1 1 0 0 1 -2 0v-.17a3.008 3.008 0 0 1 -1.829 -1.83h-.171a1 1 0 0 1 0 -2h.17a3.008 3.008 0 0 1 1.83 -1.83v-.34a3.008 3.008 0 0 1 -1.829 -1.83h-.171a1 1 0 0 1 0 -2h.17a3.008 3.008 0 0 1 1.83 -1.83v-2.17h-2a1 1 0 1 1 0 -2h2v-2a1 1 0 1 1 2 0v2h4v-2a1 1 0 0 1 2 0v2h2.17a3.008 3.008 0 0 1 1.83 -1.83v-.17a1 1 0 0 1 1 -1zm-7 11h-2.171a3.008 3.008 0 0 1 -1.828 1.829v.342a3.008 3.008 0 0 1 1.828 1.829h2.171v-4zm6 0h-4v4h2.17a3.008 3.008 0 0 1 1.83 -1.83v-2.17zm-6 -6h-4v2.171a3.008 3.008 0 0 1 1.83 1.83l2.17 -.001v-4zm4.171 0h-2.171v4h4v-2.17a3.008 3.008 0 0 1 -1.829 -1.83z", "key": "svg-0" }]]);

var IconChartGridDotsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartGridDotsFilled
});

var IconChartPie2Filled = createReactComponent("filled", "chart-pie-2-filled", "IconChartPie2Filled", [["path", { "d": "M11 2.05v9.95a1 1 0 0 0 1 1h9.95a10 10 0 0 1 -19.95 -1l.005 -.324a10 10 0 0 1 8.995 -9.626m6 1.29a10 10 0 0 1 4.95 7.66h-8.95v-8.95a10 10 0 0 1 4 1.29", "key": "svg-0" }]]);

var IconChartPie2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartPie2Filled
});

var IconChartPie3Filled = createReactComponent("filled", "chart-pie-3-filled", "IconChartPie3Filled", [["path", { "d": "M17 20.66a10 10 0 0 1 -11.328 -.917l6.742 -6.743h9.536a10 10 0 0 1 -4.95 7.66m-6 -18.61v9.534l-6.743 6.744a10 10 0 0 1 -2.257 -6.328l.005 -.324a10 10 0 0 1 8.995 -9.626m6 1.29a10 10 0 0 1 4.95 7.66h-8.95v-8.95a10 10 0 0 1 4 1.29", "key": "svg-0" }]]);

var IconChartPie3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartPie3Filled
});

var IconChartPie4Filled = createReactComponent("filled", "chart-pie-4-filled", "IconChartPie4Filled", [["path", { "d": "M11.844 13.57l4.843 7.264a10 10 0 0 1 -11.015 -1.09zm6.507 6.154l-4.481 -6.724h8.081a10 10 0 0 1 -3.348 6.511zm-7.35 -17.674v9.534l-6.744 6.744a10 10 0 0 1 -2.257 -6.328l.005 -.324a10 10 0 0 1 8.995 -9.626m6 1.29a10 10 0 0 1 4.95 7.66h-8.95v-8.95a10 10 0 0 1 4 1.29", "key": "svg-0" }]]);

var IconChartPie4Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartPie4Filled
});

var IconChartPieFilled = createReactComponent("filled", "chart-pie-filled", "IconChartPieFilled", [["path", { "d": "M9.883 2.207a1.9 1.9 0 0 1 2.087 1.522l.025 .167l.005 .104v7a1 1 0 0 0 .883 .993l.117 .007h6.8a2 2 0 0 1 2 2a1 1 0 0 1 -.026 .226a10 10 0 1 1 -12.27 -11.933l.27 -.067l.11 -.02z", "key": "svg-0" }], ["path", { "d": "M14 3.5v5.5a1 1 0 0 0 1 1h5.5a1 1 0 0 0 .943 -1.332a10 10 0 0 0 -6.11 -6.111a1 1 0 0 0 -1.333 .943z", "key": "svg-1" }]]);

var IconChartPieFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChartPieFilled
});

var IconChefHatFilled = createReactComponent("filled", "chef-hat-filled", "IconChefHatFilled", [["path", { "d": "M19 19.002v1.998a1 1 0 0 1 -.883 .993l-.117 .007h-12a1 1 0 0 1 -1 -1v-1.994a1 1 0 0 1 1 -1l12 -.004a1 1 0 0 1 1 1", "key": "svg-0" }], ["path", { "d": "M12 2a5 5 0 0 1 4.533 2.888l.06 .137l.136 -.009a5 5 0 0 1 4.99 3.477l.063 .213a5 5 0 0 1 -2.696 5.831l-.087 .037v1.428a1 1 0 0 1 -1 1l-12 .004a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.433l-.123 -.055a5 5 0 0 1 -2.6 -3.001l-.064 -.223a5 5 0 0 1 5.193 -6.27l.066 -.142a5 5 0 0 1 4.302 -2.877z", "key": "svg-1" }]]);

var IconChefHatFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChefHatFilled
});

var IconCherryFilled = createReactComponent("filled", "cherry-filled", "IconCherryFilled", [["path", { "d": "M16.588 5.191l.058 .045l.078 .074l.072 .084l.013 .018a.998 .998 0 0 1 .182 .727l-.022 .111l-.03 .092c-.99 2.725 -.666 5.158 .679 7.706a4 4 0 1 1 -4.613 4.152l-.005 -.2l.005 -.2a4.002 4.002 0 0 1 2.5 -3.511c-.947 -2.03 -1.342 -4.065 -1.052 -6.207c-.166 .077 -.332 .15 -.499 .218l.094 -.064c-2.243 1.47 -3.552 3.004 -3.98 4.57a4.5 4.5 0 1 1 -7.064 3.906l-.004 -.212l.005 -.212a4.5 4.5 0 0 1 5.2 -4.233c.332 -1.073 .945 -2.096 1.83 -3.069c-1.794 -.096 -3.586 -.759 -5.355 -1.986l-.268 -.19l-.051 -.04l-.046 -.04l-.044 -.044l-.04 -.046l-.04 -.05l-.032 -.047l-.035 -.06l-.053 -.11l-.038 -.116l-.023 -.117l-.005 -.042l-.005 -.118l.01 -.118l.023 -.117l.038 -.115l.03 -.066l.023 -.045l.035 -.06l.032 -.046l.04 -.051l.04 -.046l.044 -.044l.046 -.04l.05 -.04c4.018 -2.922 8.16 -2.922 12.177 0z", "key": "svg-0" }]]);

var IconCherryFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCherryFilled
});

var IconChessBishopFilled = createReactComponent("filled", "chess-bishop-filled", "IconChessBishopFilled", [["path", { "d": "M12 2a2 2 0 0 1 1.386 3.442c.646 .28 1.226 .62 1.74 1.017l-3.833 3.834l-.083 .094a1 1 0 0 0 1.403 1.403l.094 -.083l3.814 -3.813c.977 1.35 1.479 3.07 1.479 5.106c0 1.913 -1.178 3.722 -3.089 3.973l-.2 .02l-.211 .007h-5c-2.126 0 -3.5 -1.924 -3.5 -4c0 -3.68 1.57 -6.255 4.613 -7.56a2 2 0 0 1 1.387 -3.44z", "key": "svg-0" }], ["path", { "d": "M12 5v1", "key": "svg-1" }], ["path", { "d": "M18 18h-12a1 1 0 0 0 -1 1a2 2 0 0 0 2 2h10a2 2 0 0 0 1.987 -1.768l.011 -.174a1 1 0 0 0 -.998 -1.058z", "key": "svg-2" }]]);

var IconChessBishopFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChessBishopFilled
});

var IconChessKingFilled = createReactComponent("filled", "chess-king-filled", "IconChessKingFilled", [["path", { "d": "M12 2a1 1 0 0 1 .993 .883l.007 .117v2h2a1 1 0 0 1 .117 1.993l-.117 .007h-2v1.758a4.49 4.49 0 0 1 2.033 -.734l.24 -.018l.227 -.006a4.5 4.5 0 0 1 4.5 4.5a4.504 4.504 0 0 1 -4.064 4.478l-.217 .016l-.219 .006h-7a4.5 4.5 0 1 1 2.501 -8.241l-.001 -1.759h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2v-2a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M18 18h-12a1 1 0 0 0 -1 1a2 2 0 0 0 2 2h10a2 2 0 0 0 1.987 -1.768l.011 -.174a1 1 0 0 0 -.998 -1.058z", "key": "svg-1" }]]);

var IconChessKingFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChessKingFilled
});

var IconChessKnightFilled = createReactComponent("filled", "chess-knight-filled", "IconChessKnightFilled", [["path", { "d": "M8.959 1.99l-.147 .028l-.115 .029a1 1 0 0 0 -.646 1.27l.749 2.245l-2.815 1.735a2 2 0 0 0 -.655 2.751l.089 .133a2 2 0 0 0 1.614 .819l1.563 -.001l-1.614 4.674a1 1 0 0 0 .945 1.327h7.961a1 1 0 0 0 1 -.978l.112 -5c0 -3.827 -1.555 -6.878 -4.67 -7.966l-2.399 -.83l-.375 -.121l-.258 -.074l-.135 -.031l-.101 -.013l-.055 -.001l-.048 .003z", "key": "svg-0" }], ["path", { "d": "M18 18h-12a1 1 0 0 0 -1 1a2 2 0 0 0 2 2h10a2 2 0 0 0 1.987 -1.768l.011 -.174a1 1 0 0 0 -.998 -1.058z", "key": "svg-1" }]]);

var IconChessKnightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChessKnightFilled
});

var IconChessQueenFilled = createReactComponent("filled", "chess-queen-filled", "IconChessQueenFilled", [["path", { "d": "M12 2a2 2 0 0 1 1.572 3.236l.793 1.983l1.702 -1.702a2.003 2.003 0 0 1 1.933 -2.517a2 2 0 0 1 .674 3.884l-1.69 9.295a1 1 0 0 1 -.865 .814l-.119 .007h-8a1 1 0 0 1 -.956 -.705l-.028 -.116l-1.69 -9.295a2 2 0 1 1 2.607 -1.367l1.701 1.702l.794 -1.983a2 2 0 0 1 1.572 -3.236z", "key": "svg-0" }], ["path", { "d": "M18 18h-12a1 1 0 0 0 -1 1a2 2 0 0 0 2 2h10a2 2 0 0 0 1.987 -1.768l.011 -.174a1 1 0 0 0 -.998 -1.058z", "key": "svg-1" }]]);

var IconChessQueenFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChessQueenFilled
});

var IconChessRookFilled = createReactComponent("filled", "chess-rook-filled", "IconChessRookFilled", [["path", { "d": "M14 3a1 1 0 0 1 .993 .883l.007 .117v2h1.652l.362 -2.164a1 1 0 0 1 1.034 -.836l.116 .013a1 1 0 0 1 .836 1.035l-.013 .116l-.5 3a1 1 0 0 1 -.865 .829l-.122 .007h-1.383l.877 7.89a1 1 0 0 1 -.877 1.103l-.117 .007h-8a1 1 0 0 1 -1 -.993l.006 -.117l.877 -7.89h-1.383a1 1 0 0 1 -.96 -.718l-.026 -.118l-.5 -3a1 1 0 0 1 1.947 -.442l.025 .114l.361 2.164h1.653v-2a1 1 0 0 1 1.993 -.117l.007 .117v2h2v-2a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M18 18h-12a1 1 0 0 0 -1 1a2 2 0 0 0 2 2h10a2 2 0 0 0 1.987 -1.768l.011 -.174a1 1 0 0 0 -.998 -1.058z", "key": "svg-1" }]]);

var IconChessRookFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChessRookFilled
});

var IconChessFilled = createReactComponent("filled", "chess-filled", "IconChessFilled", [["path", { "d": "M12 2a4 4 0 0 1 4 4a5.03 5.03 0 0 1 -.438 2.001l.438 -.001a1 1 0 0 1 .117 1.993l-.117 .007h-1.263l1.24 5.79a1 1 0 0 1 -.747 1.184l-.113 .02l-.117 .006h-6a1 1 0 0 1 -.996 -1.093l.018 -.117l1.24 -5.79h-1.262a1 1 0 0 1 -.117 -1.993l.117 -.007h.438a5.154 5.154 0 0 1 -.412 -1.525l-.02 -.259l-.006 -.216a4 4 0 0 1 4 -4z", "key": "svg-0" }], ["path", { "d": "M18 18h-12a1 1 0 0 0 -1 1a2 2 0 0 0 2 2h10a2 2 0 0 0 1.987 -1.768l.011 -.174a1 1 0 0 0 -.998 -1.058z", "key": "svg-1" }]]);

var IconChessFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChessFilled
});

var IconChristmasTreeFilled = createReactComponent("filled", "christmas-tree-filled", "IconChristmasTreeFilled", [["path", { "d": "M15 19v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2v-1zm-10 -1c-.89 0 -1.337 -1.077 -.707 -1.707l2.855 -2.857l-1.464 -.487a1 1 0 0 1 -.472 -1.565l.08 -.091l3.019 -3.02l-.758 -.379a1 1 0 0 1 -.343 -1.507l.083 -.094l4 -4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 -.26 1.601l-.759 .379l3.02 3.02a1 1 0 0 1 -.279 1.61l-.113 .046l-1.465 .487l2.856 2.857c.603 .602 .22 1.614 -.593 1.701l-.114 .006z", "key": "svg-0" }]]);

var IconChristmasTreeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconChristmasTreeFilled
});

var IconCircleArrowDownLeftFilled = createReactComponent("filled", "circle-arrow-down-left-filled", "IconCircleArrowDownLeftFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-8 4.66a1 1 0 0 0 -1 1v6l.007 .117l.029 .149l.035 .105l.054 .113l.071 .111c.03 .04 .061 .077 .097 .112l.09 .08l.096 .067l.098 .052l.11 .044l.112 .03l.126 .017l6.075 .003l.117 -.007a1 1 0 0 0 .883 -.993l-.007 -.117a1 1 0 0 0 -.993 -.883h-3.586l4.293 -4.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-4.293 4.291v-3.584l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconCircleArrowDownLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowDownLeftFilled
});

var IconCircleArrowDownRightFilled = createReactComponent("filled", "circle-arrow-down-right-filled", "IconCircleArrowDownRightFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 4.66l-.117 .007a1 1 0 0 0 -.883 .993v3.585l-4.293 -4.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l4.292 4.293h-3.585l-.117 .007a1 1 0 0 0 .117 1.993l6.034 .001a.998 .998 0 0 0 .186 -.025l.053 -.014l.066 -.02l.13 -.059l.093 -.055a.98 .98 0 0 0 .438 -.828v-6l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconCircleArrowDownRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowDownRightFilled
});

var IconCircleArrowDownFilled = createReactComponent("filled", "circle-arrow-down-filled", "IconCircleArrowDownFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 3.66a1 1 0 0 0 -1 1v5.585l-2.293 -2.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l4 4c.028 .028 .057 .054 .094 .083l.092 .064l.098 .052l.081 .034l.113 .034l.112 .02l.117 .006l.115 -.007l.114 -.02l.142 -.044l.113 -.054l.111 -.071a.939 .939 0 0 0 .112 -.097l4 -4l.083 -.094a1 1 0 0 0 -1.497 -1.32l-2.293 2.291v-5.584l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconCircleArrowDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowDownFilled
});

var IconCircleArrowLeftFilled = createReactComponent("filled", "circle-arrow-left-filled", "IconCircleArrowLeftFilled", [["path", { "d": "M12 2a10 10 0 0 1 .324 19.995l-.324 .005l-.324 -.005a10 10 0 0 1 .324 -19.995zm.707 5.293a1 1 0 0 0 -1.414 0l-4 4a1.048 1.048 0 0 0 -.083 .094l-.064 .092l-.052 .098l-.044 .11l-.03 .112l-.017 .126l-.003 .075l.004 .09l.007 .058l.025 .118l.035 .105l.054 .113l.043 .07l.071 .095l.054 .058l4 4l.094 .083a1 1 0 0 0 1.32 -1.497l-2.292 -2.293h5.585l.117 -.007a1 1 0 0 0 -.117 -1.993h-5.586l2.293 -2.293l.083 -.094a1 1 0 0 0 -.083 -1.32z", "key": "svg-0" }]]);

var IconCircleArrowLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowLeftFilled
});

var IconCircleArrowRightFilled = createReactComponent("filled", "circle-arrow-right-filled", "IconCircleArrowRightFilled", [["path", { "d": "M12 2l.324 .005a10 10 0 1 1 -.648 0l.324 -.005zm.613 5.21a1 1 0 0 0 -1.32 1.497l2.291 2.293h-5.584l-.117 .007a1 1 0 0 0 .117 1.993h5.584l-2.291 2.293l-.083 .094a1 1 0 0 0 1.497 1.32l4 -4l.073 -.082l.064 -.089l.062 -.113l.044 -.11l.03 -.112l.017 -.126l.003 -.075l-.007 -.118l-.029 -.148l-.035 -.105l-.054 -.113l-.071 -.111a1.008 1.008 0 0 0 -.097 -.112l-4 -4z", "key": "svg-0" }]]);

var IconCircleArrowRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowRightFilled
});

var IconCircleArrowUpLeftFilled = createReactComponent("filled", "circle-arrow-up-left-filled", "IconCircleArrowUpLeftFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 4.66h-6l-.117 .007l-.149 .029l-.105 .035l-.113 .054l-.111 .071a1.01 1.01 0 0 0 -.112 .097l-.08 .09l-.067 .096l-.052 .098l-.044 .11l-.03 .112l-.017 .126l-.003 6.075l.007 .117a1 1 0 0 0 .993 .883l.117 -.007a1 1 0 0 0 .883 -.993v-3.585l4.293 4.292l.094 .083a1 1 0 0 0 1.32 -1.497l-4.292 -4.293h3.585l.117 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconCircleArrowUpLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowUpLeftFilled
});

var IconCircleArrowUpRightFilled = createReactComponent("filled", "circle-arrow-up-right-filled", "IconCircleArrowUpRightFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 4.66h-6l-.117 .007a1 1 0 0 0 -.883 .993l.007 .117a1 1 0 0 0 .993 .883h3.584l-4.291 4.293l-.083 .094a1 1 0 0 0 1.497 1.32l4.293 -4.293v3.586l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117l-.029 -.149l-.035 -.105l-.054 -.113l-.071 -.111a1.01 1.01 0 0 0 -.097 -.112l-.09 -.08l-.096 -.067l-.098 -.052l-.11 -.044l-.112 -.03l-.126 -.017l-.075 -.003z", "key": "svg-0" }]]);

var IconCircleArrowUpRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowUpRightFilled
});

var IconCircleArrowUpFilled = createReactComponent("filled", "circle-arrow-up-filled", "IconCircleArrowUpFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-4.98 3.66l-.163 .01l-.086 .016l-.142 .045l-.113 .054l-.07 .043l-.095 .071l-.058 .054l-4 4l-.083 .094a1 1 0 0 0 1.497 1.32l2.293 -2.293v5.586l.007 .117a1 1 0 0 0 1.993 -.117v-5.585l2.293 2.292l.094 .083a1 1 0 0 0 1.32 -1.497l-4 -4l-.082 -.073l-.089 -.064l-.113 -.062l-.081 -.034l-.113 -.034l-.112 -.02l-.098 -.006z", "key": "svg-0" }]]);

var IconCircleArrowUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleArrowUpFilled
});

var IconCircleCaretDownFilled = createReactComponent("filled", "circle-caret-down-filled", "IconCircleCaretDownFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-2 6.66h-6a1 1 0 0 0 -.708 1.707l3 3a1 1 0 0 0 1.415 0l3 -3a1 1 0 0 0 0 -1.414l-.094 -.083a1 1 0 0 0 -.613 -.21", "key": "svg-0" }]]);

var IconCircleCaretDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleCaretDownFilled
});

var IconCircleCaretLeftFilled = createReactComponent("filled", "circle-caret-left-filled", "IconCircleCaretLeftFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10a10 10 0 1 1 0 -20m2 13v-6a1 1 0 0 0 -1.707 -.708l-3 3a1 1 0 0 0 0 1.415l3 3a1 1 0 0 0 1.414 0l.083 -.094c.14 -.18 .21 -.396 .21 -.613", "key": "svg-0" }]]);

var IconCircleCaretLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleCaretLeftFilled
});

var IconCircleCaretRightFilled = createReactComponent("filled", "circle-caret-right-filled", "IconCircleCaretRightFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5.293 4.953a1 1 0 0 0 -1.707 .707v6c0 .217 .07 .433 .21 .613l.083 .094a1 1 0 0 0 1.414 0l3 -3a1 1 0 0 0 0 -1.414z", "key": "svg-0" }]]);

var IconCircleCaretRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleCaretRightFilled
});

var IconCircleCaretUpFilled = createReactComponent("filled", "circle-caret-up-filled", "IconCircleCaretUpFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-4.293 5.953a1 1 0 0 0 -1.414 0l-3 3a1 1 0 0 0 .707 1.707h6c.217 0 .433 -.07 .613 -.21l.094 -.083a1 1 0 0 0 0 -1.414z", "key": "svg-0" }]]);

var IconCircleCaretUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleCaretUpFilled
});

var IconCircleCheckFilled = createReactComponent("filled", "circle-check-filled", "IconCircleCheckFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z", "key": "svg-0" }]]);

var IconCircleCheckFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleCheckFilled
});

var IconCircleChevronDownFilled = createReactComponent("filled", "circle-chevron-down-filled", "IconCircleChevronDownFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10a10 10 0 1 1 0 -20m-2.293 8.293a1 1 0 0 0 -1.414 1.414l3 3a1 1 0 0 0 1.414 0l3 -3a1 1 0 0 0 0 -1.414l-.094 -.083a1 1 0 0 0 -1.32 .083l-2.294 2.292z", "key": "svg-0" }]]);

var IconCircleChevronDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronDownFilled
});

var IconCircleChevronLeftFilled = createReactComponent("filled", "circle-chevron-left-filled", "IconCircleChevronLeftFilled", [["path", { "d": "M17 3.34a10 10 0 0 1 5 8.66c0 5.523 -4.477 10 -10 10s-10 -4.477 -10 -10a10 10 0 0 1 15 -8.66m-3.293 4.953a1 1 0 0 0 -1.414 0l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414 0l.083 -.094a1 1 0 0 0 -.083 -1.32l-2.292 -2.293l2.292 -2.293a1 1 0 0 0 0 -1.414", "key": "svg-0" }]]);

var IconCircleChevronLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronLeftFilled
});

var IconCircleChevronRightFilled = createReactComponent("filled", "circle-chevron-right-filled", "IconCircleChevronRightFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -20 0c0 -5.523 4.477 -10 10 -10m-.293 6.293a1 1 0 0 0 -1.414 0l-.083 .094a1 1 0 0 0 .083 1.32l2.292 2.293l-2.292 2.293a1 1 0 0 0 1.414 1.414l3 -3a1 1 0 0 0 0 -1.414z", "key": "svg-0" }]]);

var IconCircleChevronRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronRightFilled
});

var IconCircleChevronUpFilled = createReactComponent("filled", "circle-chevron-up-filled", "IconCircleChevronUpFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-4.293 5.953a1 1 0 0 0 -1.414 0l-3 3a1 1 0 0 0 0 1.414l.094 .083a1 1 0 0 0 1.32 -.083l2.293 -2.292l2.293 2.292a1 1 0 0 0 1.414 -1.414z", "key": "svg-0" }]]);

var IconCircleChevronUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronUpFilled
});

var IconCircleChevronsDownFilled = createReactComponent("filled", "circle-chevrons-down-filled", "IconCircleChevronsDownFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10a10 10 0 1 1 0 -20m-2.293 10.293a1 1 0 1 0 -1.414 1.414l3 3a1 1 0 0 0 1.414 0l3 -3a1 1 0 0 0 0 -1.414l-.094 -.083a1 1 0 0 0 -1.32 .083l-2.294 2.292zm0 -4a1 1 0 0 0 -1.414 1.414l3 3a1 1 0 0 0 1.414 0l3 -3a1 1 0 0 0 0 -1.414l-.094 -.083a1 1 0 0 0 -1.32 .083l-2.294 2.292z", "key": "svg-0" }]]);

var IconCircleChevronsDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronsDownFilled
});

var IconCircleChevronsLeftFilled = createReactComponent("filled", "circle-chevrons-left-filled", "IconCircleChevronsLeftFilled", [["path", { "d": "M11.927 2.133c5.494 -.04 9.992 4.359 10.073 9.852v.295c-.081 5.493 -4.579 9.893 -10.073 9.852c-5.494 -.04 -9.926 -4.505 -9.926 -10c0 -5.494 4.432 -9.959 9.926 -10m3.78 6.16a1 1 0 0 0 -1.414 0l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414 0l.083 -.094a1 1 0 0 0 -.083 -1.32l-2.292 -2.292l2.292 -2.293a1 1 0 0 0 0 -1.414m-4 0a1 1 0 0 0 -1.414 0l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414 0l.083 -.094a1 1 0 0 0 -.083 -1.32l-2.292 -2.293l2.292 -2.293a1 1 0 0 0 0 -1.414", "key": "svg-0" }]]);

var IconCircleChevronsLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronsLeftFilled
});

var IconCircleChevronsRightFilled = createReactComponent("filled", "circle-chevrons-right-filled", "IconCircleChevronsRightFilled", [["path", { "d": "M12.073 1.868c5.494 .04 9.926 4.505 9.926 10c0 5.494 -4.432 9.959 -9.926 10c-5.494 .04 -9.992 -4.36 -10.073 -9.853v-.295c.081 -5.493 4.579 -9.893 10.073 -9.852m-2.366 6.425a1 1 0 0 0 -1.414 0l-.083 .094a1 1 0 0 0 .083 1.32l2.292 2.293l-2.292 2.293a1 1 0 0 0 1.414 1.414l3 -3a1 1 0 0 0 0 -1.414zm4 0a1 1 0 0 0 -1.414 0l-.083 .094a1 1 0 0 0 .083 1.32l2.292 2.293l-2.292 2.293a1 1 0 0 0 1.414 1.414l3 -3a1 1 0 0 0 0 -1.414z", "key": "svg-0" }]]);

var IconCircleChevronsRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronsRightFilled
});

var IconCircleChevronsUpFilled = createReactComponent("filled", "circle-chevrons-up-filled", "IconCircleChevronsUpFilled", [["path", { "d": "M11.867 2.001c5.495 0 9.96 4.432 10 9.926s-4.359 9.993 -9.852 10.073h-.295c-5.493 -.081 -9.893 -4.579 -9.852 -10.073c.04 -5.494 4.505 -9.926 10 -9.926m.84 9.292a1 1 0 0 0 -1.414 0l-3 3a1 1 0 0 0 0 1.414l.094 .083a1 1 0 0 0 1.32 -.083l2.292 -2.292l2.293 2.292a1 1 0 0 0 1.414 -1.414zm0 -4a1 1 0 0 0 -1.414 0l-3 3a1 1 0 0 0 0 1.414l.094 .083a1 1 0 0 0 1.32 -.083l2.292 -2.292l2.293 2.292a1 1 0 0 0 1.414 -1.414z", "key": "svg-0" }]]);

var IconCircleChevronsUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleChevronsUpFilled
});

var IconCircleDotFilled = createReactComponent("filled", "circle-dot-filled", "IconCircleDotFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 6.66a2 2 0 0 0 -1.977 1.697l-.018 .154l-.005 .149l.005 .15a2 2 0 1 0 1.995 -2.15z", "key": "svg-0" }]]);

var IconCircleDotFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleDotFilled
});

var IconCircleKeyFilled = createReactComponent("filled", "circle-key-filled", "IconCircleKeyFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -20 0c0 -5.523 4.477 -10 10 -10zm2 5a3 3 0 0 0 -2.98 2.65l-.015 .174l-.005 .176l.005 .176c.019 .319 .087 .624 .197 .908l.09 .209l-3.5 3.5l-.082 .094a1 1 0 0 0 0 1.226l.083 .094l1.5 1.5l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l.083 -.094a1 1 0 0 0 0 -1.226l-.083 -.094l-.792 -.793l.585 -.585l.793 .792l.094 .083a1 1 0 0 0 1.403 -1.403l-.083 -.094l-.792 -.793l.792 -.792a3 3 0 1 0 1.293 -5.708zm0 2a1 1 0 1 1 0 2a1 1 0 0 1 0 -2z", "key": "svg-0" }]]);

var IconCircleKeyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleKeyFilled
});

var IconCircleLetterAFilled = createReactComponent("filled", "circle-letter-a-filled", "IconCircleLetterAFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m0 5a3 3 0 0 0 -3 3v6a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-6a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v2h-2v-2a1 1 0 0 1 .883 -.993z", "key": "svg-0" }]]);

var IconCircleLetterAFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterAFilled
});

var IconCircleLetterBFilled = createReactComponent("filled", "circle-letter-b-filled", "IconCircleLetterBFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m0 5h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h2a3 3 0 0 0 3 -3l-.005 -.176a3 3 0 0 0 -.654 -1.7l-.106 -.124l.106 -.124a3 3 0 0 0 -2.341 -4.876m0 6a1 1 0 0 1 0 2h-1v-2zm0 -4a1 1 0 0 1 0 2h-1v-2z", "key": "svg-0" }]]);

var IconCircleLetterBFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterBFilled
});

var IconCircleLetterCFilled = createReactComponent("filled", "circle-letter-c-filled", "IconCircleLetterCFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m0 5a3 3 0 0 0 -3 3v4a3 3 0 0 0 6 0a1 1 0 0 0 -1.993 -.117l-.007 .117a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1.993 -.117l.007 .117a1 1 0 0 0 2 0a3 3 0 0 0 -3 -3", "key": "svg-0" }]]);

var IconCircleLetterCFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterCFilled
});

var IconCircleLetterDFilled = createReactComponent("filled", "circle-letter-d-filled", "IconCircleLetterDFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m0 5h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h2a3 3 0 0 0 3 -3v-4a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-1v-6z", "key": "svg-0" }]]);

var IconCircleLetterDFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterDFilled
});

var IconCircleLetterEFilled = createReactComponent("filled", "circle-letter-e-filled", "IconCircleLetterEFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2 5h-4a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-3v-2h1.5a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-1.5v-2h3a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconCircleLetterEFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterEFilled
});

var IconCircleLetterFFilled = createReactComponent("filled", "circle-letter-f-filled", "IconCircleLetterFFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2 5h-4a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3h2a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-2v-2h3a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconCircleLetterFFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterFFilled
});

var IconCircleLetterGFilled = createReactComponent("filled", "circle-letter-g-filled", "IconCircleLetterGFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2 5h-2a3 3 0 0 0 -3 3v4a3 3 0 0 0 3 3h2a1 1 0 0 0 1 -1v-4a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883v2h-1a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconCircleLetterGFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterGFilled
});

var IconCircleLetterHFilled = createReactComponent("filled", "circle-letter-h-filled", "IconCircleLetterHFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2 5a1 1 0 0 0 -1 1v3h-2v-3a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-3h2v3a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconCircleLetterHFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterHFilled
});

var IconCircleLetterIFilled = createReactComponent("filled", "circle-letter-i-filled", "IconCircleLetterIFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m0 5a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconCircleLetterIFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterIFilled
});

var IconCircleLetterJFilled = createReactComponent("filled", "circle-letter-j-filled", "IconCircleLetterJFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2 5h-4a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883h3v5a1 1 0 0 1 -1.993 .117l-.007 -.117a1 1 0 0 0 -2 0a3 3 0 0 0 6 0v-6a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconCircleLetterJFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterJFilled
});

var IconCircleLetterKFilled = createReactComponent("filled", "circle-letter-k-filled", "IconCircleLetterKFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2.53 5.152a1 1 0 0 0 -1.378 .318l-2.152 3.443v-2.913a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-2.914l2.152 3.444a1 1 0 0 0 1.276 .374l.102 -.056l.095 -.068a1 1 0 0 0 .223 -1.31l-2.17 -3.47l2.17 -3.47a1 1 0 0 0 -.318 -1.378", "key": "svg-0" }]]);

var IconCircleLetterKFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterKFilled
});

var IconCircleLetterLFilled = createReactComponent("filled", "circle-letter-l-filled", "IconCircleLetterLFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m-2 5a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-3v-7a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconCircleLetterLFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterLFilled
});

var IconCircleLetterMFilled = createReactComponent("filled", "circle-letter-m-filled", "IconCircleLetterMFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m4 6c0 -1.014 -1.336 -1.384 -1.857 -.514l-2.143 3.57l-2.143 -3.57c-.521 -.87 -1.857 -.5 -1.857 .514v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-4.39l1.143 1.904l.074 .108a1 1 0 0 0 1.64 -.108l1.143 -1.904v4.39a1 1 0 0 0 2 0z", "key": "svg-0" }]]);

var IconCircleLetterMFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterMFilled
});

var IconCircleLetterNFilled = createReactComponent("filled", "circle-letter-n-filled", "IconCircleLetterNFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m-1.106 5.553c-.471 -.944 -1.894 -.608 -1.894 .447v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3.764l2.106 4.211c.471 .944 1.894 .608 1.894 -.447v-8a1 1 0 0 0 -1 -1l-.117 .007a1 1 0 0 0 -.883 .993v3.764z", "key": "svg-0" }]]);

var IconCircleLetterNFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterNFilled
});

var IconCircleLetterOFilled = createReactComponent("filled", "circle-letter-o-filled", "IconCircleLetterOFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m0 5a3 3 0 0 0 -3 3v4a3 3 0 0 0 6 0v-4a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v4a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1 -1", "key": "svg-0" }]]);

var IconCircleLetterOFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterOFilled
});

var IconCircleLetterPFilled = createReactComponent("filled", "circle-letter-p-filled", "IconCircleLetterPFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m0 5h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3h1a3 3 0 0 0 0 -6m0 2a1 1 0 0 1 0 2h-1v-2z", "key": "svg-0" }]]);

var IconCircleLetterPFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterPFilled
});

var IconCircleLetterQFilled = createReactComponent("filled", "circle-letter-q-filled", "IconCircleLetterQFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m0 5a3 3 0 0 0 -3 3v4a3 3 0 0 0 4.168 2.764l.125 -.057a1 1 0 0 0 1.414 -1.414l.057 -.125a3 3 0 0 0 .236 -1.168v-4a3 3 0 0 0 -3 -3m1 7.001h-.059a.996 .996 0 0 0 -.941 1a1 1 0 0 1 -1 -1.001v-4a1 1 0 0 1 2 0z", "key": "svg-0" }]]);

var IconCircleLetterQFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterQFilled
});

var IconCircleLetterRFilled = createReactComponent("filled", "circle-letter-r-filled", "IconCircleLetterRFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m0 5h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-2.332l2.2 2.932a1 1 0 0 0 1.4 .2l.096 -.081a1 1 0 0 0 .104 -1.319l-1.903 -2.538l.115 -.037a3.001 3.001 0 0 0 -1.012 -5.825m0 2a1 1 0 0 1 0 2h-1v-2z", "key": "svg-0" }]]);

var IconCircleLetterRFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterRFilled
});

var IconCircleLetterSFilled = createReactComponent("filled", "circle-letter-s-filled", "IconCircleLetterSFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m1 5h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2v2h-2a1 1 0 0 0 -2 0a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-2v-2h2l.007 .117a1 1 0 0 0 1.993 -.117a2 2 0 0 0 -2 -2", "key": "svg-0" }]]);

var IconCircleLetterSFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterSFilled
});

var IconCircleLetterTFilled = createReactComponent("filled", "circle-letter-t-filled", "IconCircleLetterTFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2 5h-4a1 1 0 1 0 0 2h1v7a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-7h1a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconCircleLetterTFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterTFilled
});

var IconCircleLetterUFilled = createReactComponent("filled", "circle-letter-u-filled", "IconCircleLetterUFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2 5a1 1 0 0 0 -1 1v6a1 1 0 0 1 -2 0v-6a1 1 0 0 0 -2 0v6a3 3 0 0 0 6 0v-6a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconCircleLetterUFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterUFilled
});

var IconCircleLetterVFilled = createReactComponent("filled", "circle-letter-v-filled", "IconCircleLetterVFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2.243 5.03a1 1 0 0 0 -1.213 .727l-1.03 4.118l-1.03 -4.118a1 1 0 1 0 -1.94 .486l2 8c.252 1.01 1.688 1.01 1.94 0l2 -8a1 1 0 0 0 -.727 -1.213", "key": "svg-0" }]]);

var IconCircleLetterVFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterVFilled
});

var IconCircleLetterWFilled = createReactComponent("filled", "circle-letter-w-filled", "IconCircleLetterWFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2.008 5.876l-.52 4.153l-.56 -1.4c-.319 -.799 -1.41 -.837 -1.803 -.114l-.053 .114l-.561 1.4l-.519 -4.153a1 1 0 0 0 -1 -.876l-.116 .008a1 1 0 0 0 -.868 1.116l1 8c.128 1.025 1.537 1.207 1.92 .247l1.072 -2.678l1.072 2.678c.383 .96 1.792 .778 1.92 -.247l1 -8a1 1 0 0 0 -1.984 -.248", "key": "svg-0" }]]);

var IconCircleLetterWFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterWFilled
});

var IconCircleLetterXFilled = createReactComponent("filled", "circle-letter-x-filled", "IconCircleLetterXFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2.447 5.106a1 1 0 0 0 -1.341 .447l-1.106 2.21l-1.106 -2.21a1 1 0 0 0 -1.234 -.494l-.107 .047a1 1 0 0 0 -.447 1.341l1.774 3.553l-1.775 3.553a1 1 0 0 0 .345 1.283l.102 .058a1 1 0 0 0 1.341 -.447l1.107 -2.211l1.106 2.211a1 1 0 0 0 1.234 .494l.107 -.047a1 1 0 0 0 .447 -1.341l-1.776 -3.553l1.776 -3.553a1 1 0 0 0 -.345 -1.283z", "key": "svg-0" }]]);

var IconCircleLetterXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterXFilled
});

var IconCircleLetterYFilled = createReactComponent("filled", "circle-letter-y-filled", "IconCircleLetterYFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2.371 5.072a1 1 0 0 0 -1.3 .557l-1.071 2.678l-1.072 -2.678a1 1 0 0 0 -1.856 .742l1.928 4.823v2.806a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-2.809l1.928 -4.82a1 1 0 0 0 -.45 -1.25z", "key": "svg-0" }]]);

var IconCircleLetterYFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterYFilled
});

var IconCircleLetterZFilled = createReactComponent("filled", "circle-letter-z-filled", "IconCircleLetterZFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m2 5h-4a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883h2.382l-3.276 6.553a1 1 0 0 0 .894 1.447h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-2.382l3.276 -6.553a1 1 0 0 0 -.894 -1.447", "key": "svg-0" }]]);

var IconCircleLetterZFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleLetterZFilled
});

var IconCircleNumber0Filled = createReactComponent("filled", "circle-number-0-filled", "IconCircleNumber0Filled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm0 5a3 3 0 0 0 -2.995 2.824l-.005 .176v4l.005 .176a3 3 0 0 0 5.99 0l.005 -.176v-4l-.005 -.176a3 3 0 0 0 -2.995 -2.824zm0 2a1 1 0 0 1 .993 .883l.007 .117v4l-.007 .117a1 1 0 0 1 -1.986 0l-.007 -.117v-4l.007 -.117a1 1 0 0 1 .993 -.883z", "key": "svg-0" }]]);

var IconCircleNumber0Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber0Filled
});

var IconCircleNumber1Filled = createReactComponent("filled", "circle-number-1-filled", "IconCircleNumber1Filled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm.994 5.886c-.083 -.777 -1.008 -1.16 -1.617 -.67l-.084 .077l-2 2l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l.293 -.293v5.586l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.006 -.114z", "key": "svg-0" }]]);

var IconCircleNumber1Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber1Filled
});

var IconCircleNumber2Filled = createReactComponent("filled", "circle-number-2-filled", "IconCircleNumber2Filled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm1 5h-3l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h3v2h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h3l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-3v-2h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z", "key": "svg-0" }]]);

var IconCircleNumber2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber2Filled
});

var IconCircleNumber3Filled = createReactComponent("filled", "circle-number-3-filled", "IconCircleNumber3Filled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm1 5h-2l-.15 .005a2 2 0 0 0 -1.85 1.995a1 1 0 0 0 1.974 .23l.02 -.113l.006 -.117h2v2h-2l-.133 .007c-1.111 .12 -1.154 1.73 -.128 1.965l.128 .021l.133 .007h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z", "key": "svg-0" }]]);

var IconCircleNumber3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber3Filled
});

var IconCircleNumber4Filled = createReactComponent("filled", "circle-number-4-filled", "IconCircleNumber4Filled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm2 5a1 1 0 0 0 -.993 .883l-.007 .117v3h-2v-3l-.007 -.117a1 1 0 0 0 -1.986 0l-.007 .117v3l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v3l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconCircleNumber4Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber4Filled
});

var IconCircleNumber5Filled = createReactComponent("filled", "circle-number-5-filled", "IconCircleNumber5Filled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm2 5h-4a1 1 0 0 0 -.993 .883l-.007 .117v4a1 1 0 0 0 .883 .993l.117 .007h3v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2a2 2 0 0 0 1.995 -1.85l.005 -.15v-2a2 2 0 0 0 -1.85 -1.995l-.15 -.005h-2v-2h3a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -.883 -.993l-.117 -.007z", "key": "svg-0" }]]);

var IconCircleNumber5Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber5Filled
});

var IconCircleNumber6Filled = createReactComponent("filled", "circle-number-6-filled", "IconCircleNumber6Filled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm1 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v6l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006h-2v-2h2l.007 .117a1 1 0 0 0 1.993 -.117a2 2 0 0 0 -1.85 -1.995l-.15 -.005zm0 6v2h-2v-2h2z", "key": "svg-0" }]]);

var IconCircleNumber6Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber6Filled
});

var IconCircleNumber7Filled = createReactComponent("filled", "circle-number-7-filled", "IconCircleNumber7Filled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm2 5h-4l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117l.007 .117a1 1 0 0 0 .876 .876l.117 .007h2.718l-1.688 6.757l-.022 .115a1 1 0 0 0 1.927 .482l.035 -.111l2 -8l.021 -.112a1 1 0 0 0 -.878 -1.125l-.113 -.006z", "key": "svg-0" }]]);

var IconCircleNumber7Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber7Filled
});

var IconCircleNumber8Filled = createReactComponent("filled", "circle-number-8-filled", "IconCircleNumber8Filled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm1 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15c.018 .236 .077 .46 .17 .667l.075 .152l.018 .03l-.018 .032c-.133 .24 -.218 .509 -.243 .795l-.007 .174v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 6v2h-2v-2h2zm0 -4v2h-2v-2h2z", "key": "svg-0" }]]);

var IconCircleNumber8Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber8Filled
});

var IconCircleNumber9Filled = createReactComponent("filled", "circle-number-9-filled", "IconCircleNumber9Filled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm1 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-6l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 2v2h-2v-2h2z", "key": "svg-0" }]]);

var IconCircleNumber9Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleNumber9Filled
});

var IconCirclePercentageFilled = createReactComponent("filled", "circle-percentage-filled", "IconCirclePercentageFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -20 0l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72m3 12.12a1 1 0 0 0 -1 1v.015a1 1 0 0 0 2 0v-.015a1 1 0 0 0 -1 -1m.707 -5.752a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.707 -.263a1 1 0 0 0 -1 1v.015a1 1 0 1 0 2 0v-.015a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconCirclePercentageFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCirclePercentageFilled
});

var IconCirclePlusFilled = createReactComponent("filled", "circle-plus-filled", "IconCirclePlusFilled", [["path", { "d": "M4.929 4.929a10 10 0 1 1 14.141 14.141a10 10 0 0 1 -14.14 -14.14zm8.071 4.071a1 1 0 1 0 -2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0 -2h-2v-2z", "key": "svg-0" }]]);

var IconCirclePlusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCirclePlusFilled
});

var IconCircleRectangleFilled = createReactComponent("filled", "circle-rectangle-filled", "IconCircleRectangleFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m0 5.66h-10a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1 -1v-4a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconCircleRectangleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleRectangleFilled
});

var IconCircleXFilled = createReactComponent("filled", "circle-x-filled", "IconCircleXFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-6.489 5.8a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z", "key": "svg-0" }]]);

var IconCircleXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleXFilled
});

var IconCircleFilled = createReactComponent("filled", "circle-filled", "IconCircleFilled", [["path", { "d": "M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z", "key": "svg-0" }]]);

var IconCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCircleFilled
});

var IconCirclesFilled = createReactComponent("filled", "circles-filled", "IconCirclesFilled", [["path", { "d": "M6.5 12a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z", "key": "svg-0" }], ["path", { "d": "M17.5 12a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z", "key": "svg-1" }], ["path", { "d": "M12 2a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z", "key": "svg-2" }]]);

var IconCirclesFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCirclesFilled
});

var IconClipboardCheckFilled = createReactComponent("filled", "clipboard-check-filled", "IconClipboardCheckFilled", [["path", { "d": "M17.997 4.17a3 3 0 0 1 2.003 2.83v12a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 2.003 -2.83a4 4 0 0 0 3.997 3.83h4a4 4 0 0 0 3.98 -3.597zm-3.704 7.123l-3.293 3.292l-1.293 -1.292a1 1 0 1 0 -1.414 1.414l2 2a1 1 0 0 0 1.414 0l4 -4a1 1 0 0 0 -1.414 -1.414m-.293 -9.293a2 2 0 1 1 0 4h-4a2 2 0 1 1 0 -4z", "key": "svg-0" }]]);

var IconClipboardCheckFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardCheckFilled
});

var IconClipboardDataFilled = createReactComponent("filled", "clipboard-data-filled", "IconClipboardDataFilled", [["path", { "d": "M17.997 4.17a3 3 0 0 1 2.003 2.83v12a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 2.003 -2.83a4 4 0 0 0 3.997 3.83h4a4 4 0 0 0 3.98 -3.597zm-8.997 7.83a1 1 0 0 0 -1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0 -1 -1m3 3a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-1a1 1 0 0 0 -1 -1m3 -1a1 1 0 0 0 -1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0 -1 -1m-1 -12a2 2 0 1 1 0 4h-4a2 2 0 1 1 0 -4z", "key": "svg-0" }]]);

var IconClipboardDataFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardDataFilled
});

var IconClipboardListFilled = createReactComponent("filled", "clipboard-list-filled", "IconClipboardListFilled", [["path", { "d": "M17.997 4.17a3 3 0 0 1 2.003 2.83v12a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 2.003 -2.83a4 4 0 0 0 3.997 3.83h4a4 4 0 0 0 3.98 -3.597zm-8.987 10.83h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m5.99 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0 -2m-5.99 -4h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m5.99 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0 -2m-1 -9a2 2 0 1 1 0 4h-4a2 2 0 1 1 0 -4z", "key": "svg-0" }]]);

var IconClipboardListFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardListFilled
});

var IconClipboardTextFilled = createReactComponent("filled", "clipboard-text-filled", "IconClipboardTextFilled", [["path", { "d": "M17.997 4.17a3 3 0 0 1 2.003 2.83v12a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 2.003 -2.83a4 4 0 0 0 3.997 3.83h4a4 4 0 0 0 3.98 -3.597zm-2.997 10.83h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2m0 -4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2m-1 -9a2 2 0 1 1 0 4h-4a2 2 0 1 1 0 -4z", "key": "svg-0" }]]);

var IconClipboardTextFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardTextFilled
});

var IconClipboardTypographyFilled = createReactComponent("filled", "clipboard-typography-filled", "IconClipboardTypographyFilled", [["path", { "d": "M17.997 4.17a3 3 0 0 1 2.003 2.83v12a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 2.003 -2.83a4 4 0 0 0 3.997 3.83h4a4 4 0 0 0 3.98 -3.597zm-2.997 5.83h-6a1 1 0 0 0 -1 1v1a1 1 0 0 0 2 0h1v4a1 1 0 0 0 0 2h2a1 1 0 0 0 0 -2v-4h1a1 1 0 0 0 2 0v-1a1 1 0 0 0 -1 -1m-1 -8a2 2 0 1 1 0 4h-4a2 2 0 1 1 0 -4z", "key": "svg-0" }]]);

var IconClipboardTypographyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardTypographyFilled
});

var IconClipboardXFilled = createReactComponent("filled", "clipboard-x-filled", "IconClipboardXFilled", [["path", { "d": "M17.997 4.17a3 3 0 0 1 2.003 2.83v12a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 2.003 -2.83a4 4 0 0 0 3.997 3.83h4a4 4 0 0 0 3.98 -3.597zm-7.29 7.123a1 1 0 0 0 -1.414 0l-.083 .094a1 1 0 0 0 .083 1.32l1.292 1.293l-1.292 1.293a1 1 0 0 0 0 1.414l.094 .083a1 1 0 0 0 1.32 -.083l1.293 -1.293l1.293 1.293a1 1 0 0 0 1.414 0l.083 -.094a1 1 0 0 0 -.083 -1.32l-1.293 -1.293l1.293 -1.293a1 1 0 0 0 0 -1.414l-.094 -.083a1 1 0 0 0 -1.32 .083l-1.293 1.292zm3.293 -9.293a2 2 0 1 1 0 4h-4a2 2 0 1 1 0 -4z", "key": "svg-0" }]]);

var IconClipboardXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardXFilled
});

var IconClipboardFilled = createReactComponent("filled", "clipboard-filled", "IconClipboardFilled", [["path", { "d": "M17.997 4.17a3 3 0 0 1 2.003 2.83v12a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 2.003 -2.83a4 4 0 0 0 3.997 3.83h4a4 4 0 0 0 3.98 -3.597zm-3.997 -2.17a2 2 0 1 1 0 4h-4a2 2 0 1 1 0 -4z", "key": "svg-0" }]]);

var IconClipboardFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClipboardFilled
});

var IconClockHour1Filled = createReactComponent("filled", "clock-hour-1-filled", "IconClockHour1Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5.401 9.576l.052 .021l.08 .026l.08 .019l.072 .011l.117 .007l.076 -.003l.135 -.02l.082 -.02l.103 -.039l.073 -.035l.078 -.046l.06 -.042l.08 -.069l.083 -.088l.062 -.083l2 -3a1 1 0 1 0 -1.664 -1.11l-.168 .251v-1.696a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v5.026l.009 .105l.02 .107l.04 .129l.048 .102l.046 .078l.042 .06l.069 .08l.088 .083l.083 .062l.09 .053z", "key": "svg-0" }]]);

var IconClockHour1Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour1Filled
});

var IconClockHour10Filled = createReactComponent("filled", "clock-hour-10-filled", "IconClockHour10Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5.401 9.576l.052 .021l.08 .026l.08 .019l.072 .011l.117 .007l.076 -.003l.135 -.02l.082 -.02l.103 -.039l.073 -.035l.078 -.046l.06 -.042l.08 -.069l.083 -.088l.062 -.083l.053 -.09l.031 -.064l.032 -.081l.03 -.109l.015 -.094l.007 -.117v-5a1 1 0 0 0 -2 0v3.131l-1.445 -.963a1 1 0 0 0 -1.317 .184l-.07 .093a1 1 0 0 0 .277 1.387l3.038 2.024z", "key": "svg-0" }]]);

var IconClockHour10Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour10Filled
});

var IconClockHour11Filled = createReactComponent("filled", "clock-hour-11-filled", "IconClockHour11Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-4.952 9.659l.069 -.006l.096 -.016l.089 -.023l.099 -.038l.082 -.04l.113 -.073l.073 -.06l.074 -.074l.075 -.094l.052 -.08l.035 -.07l.051 -.132l.031 -.135l.01 -.082l.003 -.076v-5a1 1 0 0 0 -2 0v1.697l-.168 -.252a1 1 0 0 0 -1.286 -.336l-.1 .059a1 1 0 0 0 -.278 1.387l2.018 3.027l.07 .087l.075 .074l.094 .075l.08 .052l.07 .035l.132 .051l.135 .031l.082 .01z", "key": "svg-0" }]]);

var IconClockHour11Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour11Filled
});

var IconClockHour12Filled = createReactComponent("filled", "clock-hour-12-filled", "IconClockHour12Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5 2.66a1 1 0 0 0 -1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconClockHour12Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour12Filled
});

var IconClockHour2Filled = createReactComponent("filled", "clock-hour-2-filled", "IconClockHour2Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-6 3.66v5.022l.003 .054l.02 .135l.005 .025a1 1 0 0 0 .056 .165l.04 .082l.062 .099l.07 .087l.075 .074l.094 .075l.08 .052l.07 .035l.132 .051l.135 .031l.082 .01l.124 .002l.113 -.012l.108 -.024l.106 -.036l.108 -.051l.065 -.04l3.007 -2.004a1 1 0 1 0 -1.11 -1.664l-1.445 .962v-3.13a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1", "key": "svg-0" }]]);

var IconClockHour2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour2Filled
});

var IconClockHour3Filled = createReactComponent("filled", "clock-hour-3-filled", "IconClockHour3Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5 2.66a1 1 0 0 0 -1 1v5a1 1 0 0 0 1 1h3.5a1 1 0 0 0 0 -2h-2.5v-4a1 1 0 0 0 -.883 -.993z", "key": "svg-0" }]]);

var IconClockHour3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour3Filled
});

var IconClockHour4Filled = createReactComponent("filled", "clock-hour-4-filled", "IconClockHour4Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5 2.66a1 1 0 0 0 -1 1v5.026l.009 .105l.02 .107l.04 .129l.048 .102l.046 .078l.042 .06l.069 .08l.088 .083l.083 .062l3 2a1 1 0 1 0 1.11 -1.664l-2.555 -1.704v-4.464a1 1 0 0 0 -.883 -.993z", "key": "svg-0" }]]);

var IconClockHour4Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour4Filled
});

var IconClockHour5Filled = createReactComponent("filled", "clock-hour-5-filled", "IconClockHour5Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-6 3.66v5.022l.003 .054l.02 .135l.005 .025a1 1 0 0 0 .056 .165l.04 .082l.04 .065l2.004 3.007a1 1 0 1 0 1.664 -1.11l-1.832 -2.748v-4.697a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1", "key": "svg-0" }]]);

var IconClockHour5Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour5Filled
});

var IconClockHour6Filled = createReactComponent("filled", "clock-hour-6-filled", "IconClockHour6Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-6 12.16a1 1 0 0 0 2 0v-8.5a1 1 0 0 0 -2 0z", "key": "svg-0" }]]);

var IconClockHour6Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour6Filled
});

var IconClockHour7Filled = createReactComponent("filled", "clock-hour-7-filled", "IconClockHour7Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-4.007 8.777l.007 -.117v-5a1 1 0 0 0 -2 0v4.696l-1.832 2.75a1 1 0 0 0 .184 1.316l.093 .07a1 1 0 0 0 1.387 -.277l2.024 -3.038l.06 -.116l.032 -.081l.03 -.109z", "key": "svg-0" }]]);

var IconClockHour7Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour7Filled
});

var IconClockHour8Filled = createReactComponent("filled", "clock-hour-8-filled", "IconClockHour8Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5 2.66a1 1 0 0 0 -1 1v4.464l-2.555 1.704a1 1 0 0 0 -.336 1.286l.059 .1a1 1 0 0 0 1.387 .278l3.027 -2.018l.087 -.07l.074 -.075l.075 -.094l.052 -.08l.035 -.07l.051 -.132l.031 -.135l.01 -.082l.003 -.076v-5a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconClockHour8Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour8Filled
});

var IconClockHour9Filled = createReactComponent("filled", "clock-hour-9-filled", "IconClockHour9Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-4.883 9.653a1 1 0 0 0 .883 -.993v-5a1 1 0 0 0 -2 0v4h-2.5a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 0 1 1h3.5z", "key": "svg-0" }]]);

var IconClockHour9Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockHour9Filled
});

var IconClockFilled = createReactComponent("filled", "clock-filled", "IconClockFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 2.66a1 1 0 0 0 -.993 .883l-.007 .117v5l.009 .131a1 1 0 0 0 .197 .477l.087 .1l3 3l.094 .082a1 1 0 0 0 1.226 0l.094 -.083l.083 -.094a1 1 0 0 0 0 -1.226l-.083 -.094l-2.707 -2.708v-4.585l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconClockFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClockFilled
});

var IconCloudComputingFilled = createReactComponent("filled", "cloud-computing-filled", "IconCloudComputingFilled", [["path", { "d": "M9 20a2 2 0 0 1 -2 2h-4a1 1 0 0 1 0 -2h4v-2.997l-.343 .001a1 1 0 0 1 -.117 -.007l-.105 -.001c-2.94 -.11 -5.317 -2.399 -5.43 -5.263l-.005 -.216c0 -2.747 2.08 -5.01 4.784 -5.417l.114 -.016l.07 -.181c.663 -1.62 2.056 -2.906 3.829 -3.518l.244 -.08c2.194 -.667 4.614 -.224 6.36 1.176c1.385 1.108 2.187 2.686 2.25 4.34l.004 .212l.091 .003c2.3 .107 4.143 1.961 4.25 4.27l.004 .211c0 2.478 -1.997 4.487 -4.465 4.487h-1.535v2.996h4a1 1 0 0 1 0 2h-4a2 2 0 0 1 -2 -2v-2.997h-2v3.997a1 1 0 0 1 -2 0v-3.997h-2z", "key": "svg-0" }]]);

var IconCloudComputingFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudComputingFilled
});

var IconCloudDataConnectionFilled = createReactComponent("filled", "cloud-data-connection-filled", "IconCloudDataConnectionFilled", [["path", { "d": "M15.262 4.087c.974 .768 1.566 1.848 1.678 2.997l.007 .107l.18 .025a3.42 3.42 0 0 1 2.867 3.184l.006 .188a3.42 3.42 0 0 1 -3.425 3.412h-3.575l.001 1.171a3 3 0 0 1 1.829 1.829h6.17a1 1 0 0 1 0 2h-6.17a3.001 3.001 0 0 1 -5.66 0h-6.17a1 1 0 0 1 0 -2h6.171a3 3 0 0 1 1.829 -1.83v-1.17h-2.74c-2.341 0 -4.26 -1.826 -4.26 -4.103c0 -2.001 1.481 -3.655 3.43 -4.026l.086 -.015l.049 -.112c.514 -1.124 1.508 -2.01 2.756 -2.447l.222 -.072c1.627 -.49 3.42 -.166 4.72 .862", "key": "svg-0" }]]);

var IconCloudDataConnectionFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudDataConnectionFilled
});

var IconCloudFilled = createReactComponent("filled", "cloud-filled", "IconCloudFilled", [["path", { "d": "M10.04 4.305c2.195 -.667 4.615 -.224 6.36 1.176c1.386 1.108 2.188 2.686 2.252 4.34l.003 .212l.091 .003c2.3 .107 4.143 1.961 4.25 4.27l.004 .211c0 2.407 -1.885 4.372 -4.255 4.482l-.21 .005h-11.878l-.222 -.008c-2.94 -.11 -5.317 -2.399 -5.43 -5.263l-.005 -.216c0 -2.747 2.08 -5.01 4.784 -5.417l.114 -.016l.07 -.181c.663 -1.62 2.056 -2.906 3.829 -3.518l.244 -.08z", "key": "svg-0" }]]);

var IconCloudFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloudFilled
});

var IconCloverFilled = createReactComponent("filled", "clover-filled", "IconCloverFilled", [["path", { "d": "M12.712 13.297l3.398 3.442a3.104 3.104 0 0 1 0 4.351a3.04 3.04 0 0 1 -4.036 .27l-.075 -.062l-.073 .062a3.04 3.04 0 0 1 -1.664 .634l-.203 .007a3.04 3.04 0 0 1 -2.17 -.91a3.104 3.104 0 0 1 .002 -4.354l3.397 -3.44a1 1 0 0 1 1.424 0m8.378 -5.407a3.04 3.04 0 0 1 .27 4.037l-.062 .073l.062 .075a3.04 3.04 0 0 1 .634 1.664l.007 .203a3.04 3.04 0 0 1 -.91 2.17a3.104 3.104 0 0 1 -4.354 -.002l-3.44 -3.397a1 1 0 0 1 0 -1.424l3.443 -3.399a3.104 3.104 0 0 1 4.351 0m-13.827 .002l3.44 3.397a1 1 0 0 1 0 1.424l-3.444 3.397a3.104 3.104 0 0 1 -4.351 0a3.04 3.04 0 0 1 -.27 -4.036l.062 -.075l-.062 -.073a3.04 3.04 0 0 1 -.634 -1.664l-.007 -.203c0 -.816 .328 -1.598 .91 -2.17a3.104 3.104 0 0 1 4.354 .002m6.678 -5.891a3.04 3.04 0 0 1 2.17 .91a3.104 3.104 0 0 1 -.002 4.354l-3.397 3.44a1 1 0 0 1 -1.424 0l-3.397 -3.444a3.104 3.104 0 0 1 0 -4.351a3.04 3.04 0 0 1 4.036 -.27l.073 .062l.075 -.062a3.04 3.04 0 0 1 1.664 -.634z", "key": "svg-0" }]]);

var IconCloverFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCloverFilled
});

var IconClubsFilled = createReactComponent("filled", "clubs-filled", "IconClubsFilled", [["path", { "d": "M12 2a5 5 0 0 0 -4.488 2.797l-.103 .225a4.998 4.998 0 0 0 -.334 2.837l.027 .14a5 5 0 0 0 -3.091 9.009l.198 .14a4.998 4.998 0 0 0 4.42 .58l.174 -.066l-.773 3.095a1 1 0 0 0 .97 1.243h6l.113 -.006a1 1 0 0 0 .857 -1.237l-.774 -3.095l.174 .065a5 5 0 1 0 1.527 -9.727l.028 -.14a4.997 4.997 0 0 0 -4.925 -5.86z", "key": "svg-0" }]]);

var IconClubsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconClubsFilled
});

var IconCodeCircle2Filled = createReactComponent("filled", "code-circle-2-filled", "IconCodeCircle2Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-3.658 5.22a1 1 0 0 0 -1.282 .598l-2 5.5a1 1 0 0 0 1.88 .684l2 -5.5a1 1 0 0 0 -.598 -1.282m-4.135 1.233a1 1 0 0 0 -1.414 0l-1.5 1.5a1 1 0 0 0 0 1.414l1.5 1.5a1 1 0 0 0 1.414 0l.083 -.094a1 1 0 0 0 -.083 -1.32l-.792 -.793l.792 -.793a1 1 0 0 0 0 -1.414m7 0a1 1 0 0 0 -1.414 0l-.083 .094a1 1 0 0 0 .083 1.32l.792 .793l-.792 .793a1 1 0 0 0 1.414 1.414l1.5 -1.5a1 1 0 0 0 0 -1.414z", "key": "svg-0" }]]);

var IconCodeCircle2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCodeCircle2Filled
});

var IconCodeCircleFilled = createReactComponent("filled", "code-circle-filled", "IconCodeCircleFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-6.293 5.953a1 1 0 0 0 -1.414 0l-2 2a1 1 0 0 0 0 1.414l2 2a1 1 0 0 0 1.414 0l.083 -.094a1 1 0 0 0 -.083 -1.32l-1.292 -1.293l1.292 -1.293a1 1 0 0 0 0 -1.414m4 0a1 1 0 0 0 -1.414 0l-.083 .094a1 1 0 0 0 .083 1.32l1.292 1.293l-1.292 1.293a1 1 0 0 0 1.414 1.414l2 -2a1 1 0 0 0 0 -1.414z", "key": "svg-0" }]]);

var IconCodeCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCodeCircleFilled
});

var IconCoinBitcoinFilled = createReactComponent("filled", "coin-bitcoin-filled", "IconCoinBitcoinFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336zm-4 2.66a1 1 0 0 0 -1 1h-1a1 1 0 0 0 -2 0a1 1 0 1 0 0 2v6a1 1 0 0 0 0 2c0 1.333 2 1.333 2 0h1a1 1 0 0 0 2 0v-.15c1.167 -.394 2 -1.527 2 -2.85l-.005 -.175a3.063 3.063 0 0 0 -.734 -1.827c.46 -.532 .739 -1.233 .739 -1.998c0 -1.323 -.833 -2.456 -2 -2.85v-.15a1 1 0 0 0 -1 -1zm.09 7c.492 0 .91 .437 .91 1s-.418 1 -.91 1h-2.09v-2h2.09zm0 -4c.492 0 .91 .437 .91 1c0 .522 -.36 .937 -.806 .993l-.104 .007h-2.09v-2h2.09z", "key": "svg-0" }]]);

var IconCoinBitcoinFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinBitcoinFilled
});

var IconCoinEuroFilled = createReactComponent("filled", "coin-euro-filled", "IconCoinEuroFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 2.66c-2.052 0 -3.768 1.449 -4.549 3.5h-.451a1 1 0 0 0 -.117 1.993l.134 .007a7.298 7.298 0 0 0 0 1h-.017a1 1 0 0 0 0 2h.452c.78 2.053 2.496 3.5 4.548 3.5c1.141 0 2.217 -.457 3.084 -1.27a1 1 0 0 0 -1.368 -1.46c-.509 .478 -1.102 .73 -1.716 .73c-.922 0 -1.776 -.578 -2.335 -1.499l1.335 -.001a1 1 0 0 0 0 -2h-1.977a5.342 5.342 0 0 1 0 -1h1.977a1 1 0 0 0 0 -2h-1.336c.56 -.921 1.414 -1.5 2.336 -1.5c.615 0 1.208 .252 1.717 .73a1 1 0 0 0 1.368 -1.46c-.867 -.812 -1.943 -1.27 -3.085 -1.27z", "key": "svg-0" }]]);

var IconCoinEuroFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinEuroFilled
});

var IconCoinMoneroFilled = createReactComponent("filled", "coin-monero-filled", "IconCoinMoneroFilled", [["path", { "d": "M15 11.414v4.586a1 1 0 0 0 1 1l4.66 .001a10 10 0 0 1 -17.32 0l4.66 -.001l.117 -.007a1 1 0 0 0 .883 -.993v-4.585l2.293 2.292l.094 .083a1 1 0 0 0 1.32 -.083l2.293 -2.293zm2 -8.074a10 10 0 0 1 4.54 11.66h-4.54v-6c0 -.89 -1.077 -1.337 -1.707 -.707l-3.293 3.292l-3.293 -3.292l-.084 -.076c-.637 -.514 -1.623 -.07 -1.623 .783v6h-4.54a9.991 9.991 0 0 1 -.46 -3l.005 -.324a10 10 0 0 1 14.995 -8.336z", "key": "svg-0" }]]);

var IconCoinMoneroFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinMoneroFilled
});

var IconCoinPoundFilled = createReactComponent("filled", "coin-pound-filled", "IconCoinPoundFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336zm-4 2.66a3 3 0 0 0 -3 3v2h-1a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 0 1 1h1v1a1 1 0 0 1 -.77 .974l-.113 .02l-.117 .006c-1.287 0 -1.332 1.864 -.133 1.993l.133 .007h6a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-3.171l.048 -.148a3 3 0 0 0 .123 -.852v-1h1a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-1v-2a1 1 0 0 1 .883 -.993l.117 -.007a1 1 0 0 1 .993 .883l.007 .117a1 1 0 0 0 2 0a3 3 0 0 0 -3 -3z", "key": "svg-0" }]]);

var IconCoinPoundFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinPoundFilled
});

var IconCoinRupeeFilled = createReactComponent("filled", "coin-rupee-filled", "IconCoinRupeeFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 3.66h-6c-1.287 0 -1.332 1.864 -.133 1.993l.133 .007h1a2 2 0 0 1 1.732 1h-2.732a1 1 0 0 0 0 2l2.732 .001a2 2 0 0 1 -1.732 .999h-1c-.89 0 -1.337 1.077 -.707 1.707l3 3a1 1 0 0 0 1.414 0l.083 -.094a1 1 0 0 0 -.083 -1.32l-1.484 -1.485l.113 -.037a4.009 4.009 0 0 0 2.538 -2.77l1.126 -.001a1 1 0 0 0 0 -2h-1.126a3.973 3.973 0 0 0 -.33 -.855l-.079 -.145h1.535a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconCoinRupeeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinRupeeFilled
});

var IconCoinTakaFilled = createReactComponent("filled", "coin-taka-filled", "IconCoinTakaFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336zm-6.211 4.384a2 2 0 0 0 -2.683 -.895l-.553 .277a1 1 0 0 0 .894 1.788l.553 -.276l-.001 1.382h-.999a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 0 1 1h.999l.001 3a3 3 0 0 0 2.824 2.995l.176 .005h.5a3.5 3.5 0 0 0 3.5 -3.5v-.5a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .876 .876l.032 .002l-.02 .057a1.5 1.5 0 0 1 -1.395 .948h-.5a1 1 0 0 1 -1 -1l-.001 -3h4.001a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-4.001l.001 -1.382a2 2 0 0 0 -.136 -.725l-.075 -.17z", "key": "svg-0" }]]);

var IconCoinTakaFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinTakaFilled
});

var IconCoinYenFilled = createReactComponent("filled", "coin-yen-filled", "IconCoinYenFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.445 3.828a1 1 0 0 0 -1.387 .277l-2.168 3.251l-2.168 -3.25a1 1 0 0 0 -1.286 -.337l-.1 .059a1 1 0 0 0 -.278 1.387l1.63 2.445h-.798a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 0 1 1h2v1h-2a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 0 1 1h2v1a1 1 0 0 0 .883 .993l.117 .007l.117 -.007a1 1 0 0 0 .883 -.993v-1h2a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-2v-1h2a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-.799l1.631 -2.445a1 1 0 0 0 -.184 -1.317l-.093 -.07z", "key": "svg-0" }]]);

var IconCoinYenFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinYenFilled
});

var IconCoinYuanFilled = createReactComponent("filled", "coin-yuan-filled", "IconCoinYuanFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.445 3.828a1 1 0 0 0 -1.387 .277l-2.168 3.251l-2.168 -3.25a1 1 0 0 0 -1.286 -.337l-.1 .059a1 1 0 0 0 -.278 1.387l2.296 3.445h-1.464a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 0 1 1h2v3a1 1 0 0 0 .883 .993l.117 .007l.117 -.007a1 1 0 0 0 .883 -.993v-3h2a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-1.465l2.297 -3.445a1 1 0 0 0 -.184 -1.317l-.093 -.07z", "key": "svg-0" }]]);

var IconCoinYuanFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinYuanFilled
});

var IconCoinFilled = createReactComponent("filled", "coin-filled", "IconCoinFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 2.66a1 1 0 0 0 -1 1a3 3 0 1 0 0 6v2a1.024 1.024 0 0 1 -.866 -.398l-.068 -.101a1 1 0 0 0 -1.732 .998a3 3 0 0 0 2.505 1.5h.161a1 1 0 0 0 .883 .994l.117 .007a1 1 0 0 0 1 -1l.176 -.005a3 3 0 0 0 -.176 -5.995v-2c.358 -.012 .671 .14 .866 .398l.068 .101a1 1 0 0 0 1.732 -.998a3 3 0 0 0 -2.505 -1.501h-.161a1 1 0 0 0 -1 -1zm1 7a1 1 0 0 1 0 2v-2zm-2 -4v2a1 1 0 0 1 0 -2z", "key": "svg-0" }]]);

var IconCoinFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCoinFilled
});

var IconCompassFilled = createReactComponent("filled", "compass-filled", "IconCompassFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 14.66a1 1 0 1 0 0 2a1 1 0 0 0 0 -2zm3.684 -10.949l-6 2a1 1 0 0 0 -.633 .633l-2.007 6.026l-.023 .086l-.017 .113l-.004 .068v.044l.009 .111l.012 .07l.04 .144l.045 .1l.054 .095l.064 .09l.069 .075l.084 .074l.098 .07l.1 .054l.078 .033l.105 .033l.109 .02l.043 .005l.068 .004h.044l.111 -.009l.07 -.012l.02 -.006l.019 -.002l.074 -.022l6 -2a1 1 0 0 0 .633 -.633l2 -6a1 1 0 0 0 -1.265 -1.265zm-1.265 2.529l-1.21 3.629l-3.629 1.21l1.21 -3.629l3.629 -1.21zm-9.419 1.42a1 1 0 1 0 0 2a1 1 0 0 0 0 -2zm14 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2zm-7 -7a1 1 0 1 0 0 2a1 1 0 0 0 0 -2z", "key": "svg-0" }]]);

var IconCompassFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCompassFilled
});

var IconCone2Filled = createReactComponent("filled", "cone-2-filled", "IconCone2Filled", [["path", { "d": "M12 1c5.52 0 10 1.494 10 4.002v.5a1 1 0 0 1 -.121 .477l-8.139 15.006a2 2 0 0 1 -3.489 -.016l-8.13 -14.99a1 1 0 0 1 -.121 -.475v-.5c0 -2.509 4.48 -4.004 10 -4.004", "key": "svg-0" }]]);

var IconCone2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCone2Filled
});

var IconConeFilled = createReactComponent("filled", "cone-filled", "IconConeFilled", [["path", { "d": "M12 1.001c.72 0 1.385 .387 1.749 1.03l8.13 14.99a1 1 0 0 1 .121 .477v.498c0 2.46 -4.306 3.945 -9.677 4.002l-.323 .002c-5.52 0 -10 -1.495 -10 -4.003v-.5a1 1 0 0 1 .121 -.477l8.139 -15.005a2 2 0 0 1 1.74 -1.015", "key": "svg-0" }]]);

var IconConeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconConeFilled
});

var IconContrast2Filled = createReactComponent("filled", "contrast-2-filled", "IconContrast2Filled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm0 2h-14a1 1 0 0 0 -1 1v14a1 1 0 0 0 .769 .973c3.499 -.347 7.082 -4.127 7.226 -7.747l.005 -.226c0 -3.687 3.66 -7.619 7.232 -7.974a1 1 0 0 0 -.232 -.026", "key": "svg-0" }]]);

var IconContrast2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconContrast2Filled
});

var IconContrastFilled = createReactComponent("filled", "contrast-filled", "IconContrastFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-9 1.732a8 8 0 0 0 4.001 14.928l-.001 -16a8 8 0 0 0 -4 1.072", "key": "svg-0" }]]);

var IconContrastFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconContrastFilled
});

var IconCookieManFilled = createReactComponent("filled", "cookie-man-filled", "IconCookieManFilled", [["path", { "d": "M12.007 1l.238 .005a6 6 0 0 1 5.405 3.974l.078 .233a6 6 0 0 1 -.182 4.08l-.093 .21l.05 -.002a2.94 2.94 0 0 1 2.638 1.511l.081 .158a2.887 2.887 0 0 1 -1.234 3.764l-.19 .096l-1.798 .821v.963l1.166 1.166l.14 .154a2.96 2.96 0 0 1 -.17 4.002c-1.087 1.088 -2.827 1.161 -4.03 .144l-.16 -.146l-1.946 -1.948l-1.946 1.947a2.96 2.96 0 0 1 -3.95 .22l-.15 -.128c-1.17 -1.073 -1.284 -2.879 -.234 -4.12l.146 -.158l1.134 -1.134v-.962l-1.834 -.84l-.181 -.093a2.88 2.88 0 0 1 -1.205 -3.75a2.93 2.93 0 0 1 2.646 -1.661l.13 .003l-.03 -.064a6.1 6.1 0 0 1 -.503 -1.968l-.017 -.26v-.217a6 6 0 0 1 5.775 -5.996l.224 -.004zm.003 15h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m0 -3h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m0 -5h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m-2 -3h-.01a1 1 0 1 0 0 2h.01a1 1 0 0 0 0 -2m4 0h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconCookieManFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCookieManFilled
});

var IconCookieFilled = createReactComponent("filled", "cookie-filled", "IconCookieFilled", [["path", { "d": "M13.53 2.552l2.667 1.104a1 1 0 0 1 .414 1.53a3 3 0 0 0 3.492 4.604a1 1 0 0 1 1.296 .557l.049 .122a4 4 0 0 1 0 3.062l-.079 .151c-.467 .74 -.785 1.314 -.945 1.7c-.166 .4 -.373 1.097 -.613 2.073l-.047 .144a4 4 0 0 1 -2.166 2.164l-.139 .046c-1.006 .253 -1.705 .461 -2.076 .615c-.412 .17 -.982 .486 -1.696 .942l-.156 .082a4 4 0 0 1 -3.062 0l-.148 -.077c-.759 -.475 -1.333 -.793 -1.704 -.947c-.413 -.171 -1.109 -.378 -2.07 -.612l-.146 -.048a4 4 0 0 1 -2.164 -2.166l-.046 -.138c-.254 -1.009 -.463 -1.709 -.615 -2.078q -.256 -.621 -.942 -1.695l-.082 -.156a4 4 0 0 1 0 -3.062l.084 -.16c.447 -.692 .761 -1.262 .94 -1.692c.147 -.355 .356 -1.057 .615 -2.078l.045 -.138a4 4 0 0 1 2.166 -2.164l.141 -.047c.988 -.245 1.686 -.453 2.074 -.614c.395 -.164 .967 -.48 1.7 -.944l.152 -.08a4 4 0 0 1 3.062 0m-1.531 13.448a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m4 -3a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m-8 -1a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m4 -1a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m-1 -4c-.552 0 -1 .448 -1 1.01a1 1 0 1 0 2 -.01a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconCookieFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCookieFilled
});

var IconCopyCheckFilled = createReactComponent("filled", "copy-check-filled", "IconCopyCheckFilled", [["path", { "d": "M18.333 6a3.667 3.667 0 0 1 3.667 3.667v8.666a3.667 3.667 0 0 1 -3.667 3.667h-8.666a3.667 3.667 0 0 1 -3.667 -3.667v-8.666a3.667 3.667 0 0 1 3.667 -3.667zm-3.333 -4c1.094 0 1.828 .533 2.374 1.514a1 1 0 1 1 -1.748 .972c-.221 -.398 -.342 -.486 -.626 -.486h-10c-.548 0 -1 .452 -1 1v9.998c0 .32 .154 .618 .407 .805l.1 .065a1 1 0 1 1 -.99 1.738a3 3 0 0 1 -1.517 -2.606v-10c0 -1.652 1.348 -3 3 -3zm1.293 9.293l-3.293 3.292l-1.293 -1.292a1 1 0 0 0 -1.414 1.414l2 2a1 1 0 0 0 1.414 0l4 -4a1 1 0 0 0 -1.414 -1.414", "key": "svg-0" }]]);

var IconCopyCheckFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyCheckFilled
});

var IconCopyMinusFilled = createReactComponent("filled", "copy-minus-filled", "IconCopyMinusFilled", [["path", { "d": "M18.333 6a3.667 3.667 0 0 1 3.667 3.667v8.666a3.667 3.667 0 0 1 -3.667 3.667h-8.666a3.667 3.667 0 0 1 -3.667 -3.667v-8.666a3.667 3.667 0 0 1 3.667 -3.667zm-3.333 -4c1.094 0 1.828 .533 2.374 1.514a1 1 0 1 1 -1.748 .972c-.221 -.398 -.342 -.486 -.626 -.486h-10c-.548 0 -1 .452 -1 1v9.998c0 .32 .154 .618 .407 .805l.1 .065a1 1 0 1 1 -.99 1.738a3 3 0 0 1 -1.517 -2.606v-10c0 -1.652 1.348 -3 3 -3zm2 11h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconCopyMinusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyMinusFilled
});

var IconCopyPlusFilled = createReactComponent("filled", "copy-plus-filled", "IconCopyPlusFilled", [["path", { "d": "M18.333 6a3.667 3.667 0 0 1 3.667 3.667v8.666a3.667 3.667 0 0 1 -3.667 3.667h-8.666a3.667 3.667 0 0 1 -3.667 -3.667v-8.666a3.667 3.667 0 0 1 3.667 -3.667zm-4.333 4a1 1 0 0 0 -1 1v2h-2a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 0 1 1h2v2a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-2h2a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-2v-2a1 1 0 0 0 -.883 -.993zm1 -8c1.094 0 1.828 .533 2.374 1.514a1 1 0 1 1 -1.748 .972c-.221 -.398 -.342 -.486 -.626 -.486h-10c-.548 0 -1 .452 -1 1v9.998c0 .32 .154 .618 .407 .805l.1 .065a1 1 0 1 1 -.99 1.738a3 3 0 0 1 -1.517 -2.606v-10c0 -1.652 1.348 -3 3 -3z", "key": "svg-0" }]]);

var IconCopyPlusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyPlusFilled
});

var IconCopyXFilled = createReactComponent("filled", "copy-x-filled", "IconCopyXFilled", [["path", { "d": "M18.333 6a3.667 3.667 0 0 1 3.667 3.667v8.666a3.667 3.667 0 0 1 -3.667 3.667h-8.666a3.667 3.667 0 0 1 -3.667 -3.667v-8.666a3.667 3.667 0 0 1 3.667 -3.667zm-3.333 -4c1.094 0 1.828 .533 2.374 1.514a1 1 0 1 1 -1.748 .972c-.221 -.398 -.342 -.486 -.626 -.486h-10c-.548 0 -1 .452 -1 1v9.998c0 .32 .154 .618 .407 .805l.1 .065a1 1 0 1 1 -.99 1.738a3 3 0 0 1 -1.517 -2.606v-10c0 -1.652 1.348 -3 3 -3zm.8 8.786l-1.837 1.799l-1.749 -1.785a1 1 0 0 0 -1.319 -.096l-.095 .082a1 1 0 0 0 -.014 1.414l1.749 1.785l-1.835 1.8a1 1 0 0 0 -.096 1.32l.082 .095a1 1 0 0 0 1.414 .014l1.836 -1.8l1.75 1.786a1 1 0 0 0 1.319 .096l.095 -.082a1 1 0 0 0 .014 -1.414l-1.75 -1.786l1.836 -1.8a1 1 0 0 0 .096 -1.319l-.082 -.095a1 1 0 0 0 -1.414 -.014", "key": "svg-0" }]]);

var IconCopyXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyXFilled
});

var IconCopyleftFilled = createReactComponent("filled", "copyleft-filled", "IconCopyleftFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2.117 5.889a4.016 4.016 0 0 0 -5.543 -.23a1 1 0 0 0 1.32 1.502a2.016 2.016 0 0 1 2.783 .116a1.993 1.993 0 0 1 0 2.766a2.016 2.016 0 0 1 -2.783 .116a1 1 0 0 0 -1.32 1.501a4.016 4.016 0 0 0 5.543 -.23a3.993 3.993 0 0 0 0 -5.542z", "key": "svg-0" }]]);

var IconCopyleftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyleftFilled
});

var IconCopyrightFilled = createReactComponent("filled", "copyright-filled", "IconCopyrightFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2.34 5.659a4.016 4.016 0 0 0 -5.543 .23a3.993 3.993 0 0 0 0 5.542a4.016 4.016 0 0 0 5.543 .23a1 1 0 0 0 -1.32 -1.502c-.81 .711 -2.035 .66 -2.783 -.116a1.993 1.993 0 0 1 0 -2.766a2.016 2.016 0 0 1 2.783 -.116a1 1 0 0 0 1.32 -1.501z", "key": "svg-0" }]]);

var IconCopyrightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCopyrightFilled
});

var IconCreditCardFilled = createReactComponent("filled", "credit-card-filled", "IconCreditCardFilled", [["path", { "d": "M22 10v6a4 4 0 0 1 -4 4h-12a4 4 0 0 1 -4 -4v-6h20zm-14.99 4h-.01a1 1 0 1 0 .01 2a1 1 0 0 0 0 -2zm5.99 0h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0 -2zm5 -10a4 4 0 0 1 4 4h-20a4 4 0 0 1 4 -4h12z", "key": "svg-0" }]]);

var IconCreditCardFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCreditCardFilled
});

var IconCrop11Filled = createReactComponent("filled", "crop-1-1-filled", "IconCrop11Filled", [["path", { "d": "M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

var IconCrop11Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrop11Filled
});

var IconCrop169Filled = createReactComponent("filled", "crop-16-9-filled", "IconCrop169Filled", [["path", { "d": "M18 7a3 3 0 0 1 3 3v4a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-4a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

var IconCrop169Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrop169Filled
});

var IconCrop32Filled = createReactComponent("filled", "crop-3-2-filled", "IconCrop32Filled", [["path", { "d": "M18 6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

var IconCrop32Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrop32Filled
});

var IconCrop54Filled = createReactComponent("filled", "crop-5-4-filled", "IconCrop54Filled", [["path", { "d": "M18 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

var IconCrop54Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrop54Filled
});

var IconCrop75Filled = createReactComponent("filled", "crop-7-5-filled", "IconCrop75Filled", [["path", { "d": "M18 5a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

var IconCrop75Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrop75Filled
});

var IconCropLandscapeFilled = createReactComponent("filled", "crop-landscape-filled", "IconCropLandscapeFilled", [["path", { "d": "M18 5a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

var IconCropLandscapeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCropLandscapeFilled
});

var IconCropPortraitFilled = createReactComponent("filled", "crop-portrait-filled", "IconCropPortraitFilled", [["path", { "d": "M16 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

var IconCropPortraitFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCropPortraitFilled
});

var IconCrossFilled = createReactComponent("filled", "cross-filled", "IconCrossFilled", [["path", { "d": "M10 2l-.117 .007a1 1 0 0 0 -.883 .993v4h-4a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 .993 .883h4v8a1 1 0 0 0 1 1h4l.117 -.007a1 1 0 0 0 .883 -.993v-8h4a1 1 0 0 0 1 -1v-4l-.007 -.117a1 1 0 0 0 -.993 -.883h-4v-4a1 1 0 0 0 -1 -1h-4z", "key": "svg-0" }]]);

var IconCrossFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCrossFilled
});

var IconCurrentLocationFilled = createReactComponent("filled", "current-location-filled", "IconCurrentLocationFilled", [["path", { "d": "M12 1a1 1 0 0 1 1 1v1.055a9.004 9.004 0 0 1 7.946 7.945h1.054a1 1 0 0 1 0 2h-1.055a9.004 9.004 0 0 1 -7.944 7.945l-.001 1.055a1 1 0 0 1 -2 0v-1.055a9.004 9.004 0 0 1 -7.945 -7.944l-1.055 -.001a1 1 0 0 1 0 -2h1.055a9.004 9.004 0 0 1 7.945 -7.945v-1.055a1 1 0 0 1 1 -1m0 4a7 7 0 1 0 0 14a7 7 0 0 0 0 -14m0 3a4 4 0 1 1 -4 4l.005 -.2a4 4 0 0 1 3.995 -3.8", "key": "svg-0" }]]);

var IconCurrentLocationFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconCurrentLocationFilled
});

var IconDashboardFilled = createReactComponent("filled", "dashboard-filled", "IconDashboardFilled", [["path", { "d": "M12 2.954a10 10 0 0 1 6.222 17.829a1 1 0 0 1 -.622 .217h-11.2a1 1 0 0 1 -.622 -.217a10 10 0 0 1 6.222 -17.829m4.207 5.839a1 1 0 0 0 -1.414 0l-2.276 2.274a2.003 2.003 0 0 0 -2.514 1.815l-.003 .118a2 2 0 1 0 3.933 -.517l2.274 -2.276a1 1 0 0 0 0 -1.414", "key": "svg-0" }]]);

var IconDashboardFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDashboardFilled
});

var IconDeviceCctvFilled = createReactComponent("filled", "device-cctv-filled", "IconDeviceCctvFilled", [["path", { "d": "M20 8v6a8 8 0 1 1 -16 0v-6zm-8 2a4 4 0 0 0 -3.996 3.826l-.004 .174a4 4 0 1 0 4 -4m.01 3a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993zm-10.01 -8v-1a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2", "key": "svg-0" }]]);

var IconDeviceCctvFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceCctvFilled
});

var IconDeviceDesktopFilled = createReactComponent("filled", "device-desktop-filled", "IconDeviceDesktopFilled", [["path", { "d": "M7 21a1 1 0 0 1 0 -2h1v-2h-4a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-4v2h1a1 1 0 0 1 0 2zm7 -4h-4v2h4z", "key": "svg-0" }]]);

var IconDeviceDesktopFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceDesktopFilled
});

var IconDeviceGamepad3Filled = createReactComponent("filled", "device-gamepad-3-filled", "IconDeviceGamepad3Filled", [["path", { "d": "M12.707 14.293l3 3a1 1 0 0 1 .293 .707v2a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-2a1 1 0 0 1 .293 -.707l3 -3a1 1 0 0 1 1.414 0m-6.707 -6.293a1 1 0 0 1 .707 .293l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1 -.707 .293h-2a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2zm14 0a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-2a1 1 0 0 1 -.707 -.293l-3 -3a1 1 0 0 1 0 -1.414l3 -3a1 1 0 0 1 .707 -.293zm-6 -6a2 2 0 0 1 2 2v2a1 1 0 0 1 -.293 .707l-3 3a1 1 0 0 1 -1.414 0l-3 -3a1 1 0 0 1 -.293 -.707v-2a2 2 0 0 1 2 -2z", "key": "svg-0" }]]);

var IconDeviceGamepad3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceGamepad3Filled
});

var IconDeviceHeartMonitorFilled = createReactComponent("filled", "device-heart-monitor-filled", "IconDeviceHeartMonitorFilled", [["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm-4 13a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm-6 -6.764l-.106 .211a1 1 0 0 1 -.77 .545l-.124 .008l-5 -.001v3.001h14v-3.001l-4.382 .001l-.724 1.447a1 1 0 0 1 -1.725 .11l-.063 -.11l-1.106 -2.211zm7 -4.236h-12a1 1 0 0 0 -.993 .883l-.007 .117v1.999l4.381 .001l.725 -1.447a1 1 0 0 1 1.725 -.11l.063 .11l1.106 2.21l.106 -.21a1 1 0 0 1 .77 -.545l.124 -.008l5 -.001v-1.999a1 1 0 0 0 -.883 -.993l-.117 -.007z", "key": "svg-0" }]]);

var IconDeviceHeartMonitorFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceHeartMonitorFilled
});

var IconDeviceImacFilled = createReactComponent("filled", "device-imac-filled", "IconDeviceImacFilled", [["path", { "d": "M8 22a1 1 0 0 1 0 -2h.616l.25 -2h-4.866a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-4.867l.25 2h.617a1 1 0 0 1 0 2zm5.116 -4h-2.233l-.25 2h2.733z", "key": "svg-0" }]]);

var IconDeviceImacFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceImacFilled
});

var IconDeviceIpadFilled = createReactComponent("filled", "device-ipad-filled", "IconDeviceIpadFilled", [["path", { "d": "M18 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-3 16h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconDeviceIpadFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceIpadFilled
});

var IconDeviceMobileFilled = createReactComponent("filled", "device-mobile-filled", "IconDeviceMobileFilled", [["path", { "d": "M16 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-8a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h8zm-4 14a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1 -12h-2l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h2l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconDeviceMobileFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceMobileFilled
});

var IconDeviceRemoteFilled = createReactComponent("filled", "device-remote-filled", "IconDeviceRemoteFilled", [["path", { "d": "M15 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3h2v1a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-1zm-5 15a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883m4 0a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883m-4 -3a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883m4 0a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883m-2 -7a3 3 0 0 0 -2.995 2.824l-.005 .176a3 3 0 1 0 3 -3", "key": "svg-0" }]]);

var IconDeviceRemoteFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceRemoteFilled
});

var IconDeviceSpeakerFilled = createReactComponent("filled", "device-speaker-filled", "IconDeviceSpeakerFilled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-5 9a4 4 0 0 0 -3.995 3.8l-.005 .2a4 4 0 1 0 4 -4m0 -5a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconDeviceSpeakerFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceSpeakerFilled
});

var IconDeviceTabletFilled = createReactComponent("filled", "device-tablet-filled", "IconDeviceTabletFilled", [["path", { "d": "M18 2a2 2 0 0 1 1.995 1.85l.005 .15v16a2 2 0 0 1 -1.85 1.995l-.15 .005h-12a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-16a2 2 0 0 1 1.85 -1.995l.15 -.005h12zm-6 13a2 2 0 0 0 -1.977 1.697l-.018 .154l-.005 .149l.005 .15a2 2 0 1 0 1.995 -2.15z", "key": "svg-0" }]]);

var IconDeviceTabletFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTabletFilled
});

var IconDeviceTvOldFilled = createReactComponent("filled", "device-tv-old-filled", "IconDeviceTvOldFilled", [["path", { "d": "M8.707 2.293l3.293 3.292l3.293 -3.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-2.293 2.293h4.586a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3h4.585l-2.292 -2.293a1 1 0 0 1 1.414 -1.414m10.293 5.707h-2a1 1 0 0 0 -1 1v9a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-9a1 1 0 0 0 -1 -1", "key": "svg-0" }], ["path", { "d": "M18 14a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1", "key": "svg-1" }], ["path", { "d": "M18 11a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1", "key": "svg-2" }]]);

var IconDeviceTvOldFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTvOldFilled
});

var IconDeviceTvFilled = createReactComponent("filled", "device-tv-filled", "IconDeviceTvFilled", [["path", { "d": "M8.707 2.293l3.293 3.292l3.293 -3.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-2.293 2.293h4.586a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3h4.585l-2.292 -2.293a1 1 0 0 1 1.414 -1.414", "key": "svg-0" }]]);

var IconDeviceTvFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceTvFilled
});

var IconDeviceUnknownFilled = createReactComponent("filled", "device-unknown-filled", "IconDeviceUnknownFilled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-5 13a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.526 1.292a.98 .98 0 0 1 1.195 -.239a1 1 0 0 1 -.455 1.892a1 1 0 0 0 -.006 2a3 3 0 0 0 1.371 -5.673", "key": "svg-0" }]]);

var IconDeviceUnknownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceUnknownFilled
});

var IconDeviceUsbFilled = createReactComponent("filled", "device-usb-filled", "IconDeviceUsbFilled", [["path", { "d": "M15 2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 1 1v8a6 6 0 1 1 -12 0v-8a1 1 0 0 1 1 -1h1v-4a1 1 0 0 1 1 -1zm-1 2h-4v3h4z", "key": "svg-0" }]]);

var IconDeviceUsbFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceUsbFilled
});

var IconDeviceVisionProFilled = createReactComponent("filled", "device-vision-pro-filled", "IconDeviceVisionProFilled", [["path", { "d": "M12 6q 1.74 0 3.342 .106q 1.619 .107 2.973 .448q 1.388 .345 2.436 1.05a4.9 4.9 0 0 1 1.665 1.916c.397 .801 .584 1.769 .584 2.91c0 1.156 -.222 2.208 -.673 3.14c-.45 .934 -1.073 1.685 -1.868 2.236a4.7 4.7 0 0 1 -2.73 .839q -.932 .001 -1.703 -.263a7 7 0 0 1 -1.374 -.644a20 20 0 0 1 -1.107 -.736a8 8 0 0 0 -.901 -.567a1.4 1.4 0 0 0 -.643 -.174c-.209 0 -.426 .057 -.658 .18q -.42 .226 -.893 .564a20 20 0 0 1 -1.105 .733a6.8 6.8 0 0 1 -1.366 .642a5.2 5.2 0 0 1 -1.688 .264a4.7 4.7 0 0 1 -2.75 -.838c-.794 -.55 -1.418 -1.302 -1.868 -2.234q -.675 -1.407 -.673 -3.14c-.005 -1.135 .182 -2.105 .577 -2.9a4.9 4.9 0 0 1 1.673 -1.926c.699 -.47 1.511 -.816 2.442 -1.049a17 17 0 0 1 2.968 -.447q 1.599 -.11 3.34 -.11", "key": "svg-0" }]]);

var IconDeviceVisionProFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceVisionProFilled
});

var IconDeviceWatchFilled = createReactComponent("filled", "device-watch-filled", "IconDeviceWatchFilled", [["path", { "d": "M15 2a1 1 0 0 1 1 1v2.126c1.726 .445 3 2.01 3 3.874v6a4 4 0 0 1 -3 3.874v2.126a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-2.126a4 4 0 0 1 -3 -3.874v-6a4 4 0 0 1 3 -3.874v-2.126a1 1 0 0 1 1 -1zm-1 17h-4v1h4zm0 -15h-4v1h4z", "key": "svg-0" }]]);

var IconDeviceWatchFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDeviceWatchFilled
});

var IconDialpadFilled = createReactComponent("filled", "dialpad-filled", "IconDialpadFilled", [["path", { "d": "M6 2h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M20 2h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z", "key": "svg-1" }], ["path", { "d": "M13 2h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z", "key": "svg-2" }], ["path", { "d": "M6 9h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z", "key": "svg-3" }], ["path", { "d": "M20 9h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z", "key": "svg-4" }], ["path", { "d": "M13 9h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z", "key": "svg-5" }], ["path", { "d": "M13 16h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z", "key": "svg-6" }]]);

var IconDialpadFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDialpadFilled
});

var IconDiamondFilled = createReactComponent("filled", "diamond-filled", "IconDiamondFilled", [["path", { "d": "M18 4a1 1 0 0 1 .783 .378l.074 .108l3 5a1 1 0 0 1 -.032 1.078l-.08 .103l-8.53 9.533a1.7 1.7 0 0 1 -1.215 .51c-.4 0 -.785 -.14 -1.11 -.417l-.135 -.126l-8.5 -9.5a1 1 0 0 1 -.172 -1.067l.06 -.115l3.013 -5.022l.064 -.09a.982 .982 0 0 1 .155 -.154l.089 -.064l.088 -.05l.05 -.023l.06 -.025l.109 -.032l.112 -.02l.117 -.005h12zm-8.886 3.943a1 1 0 0 0 -1.371 .343l-.6 1l-.06 .116a1 1 0 0 0 .177 1.07l2 2.2l.09 .088a1 1 0 0 0 1.323 -.02l.087 -.09a1 1 0 0 0 -.02 -1.323l-1.501 -1.65l.218 -.363l.055 -.103a1 1 0 0 0 -.398 -1.268z", "key": "svg-0" }]]);

var IconDiamondFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiamondFilled
});

var IconDiamondsFilled = createReactComponent("filled", "diamonds-filled", "IconDiamondsFilled", [["path", { "d": "M12 2.005c-.777 0 -1.508 .367 -1.971 .99l-5.362 6.895c-.89 1.136 -.89 3.083 0 4.227l5.375 6.911a2.457 2.457 0 0 0 3.93 -.017l5.361 -6.894c.89 -1.136 .89 -3.083 0 -4.227l-5.375 -6.911a2.446 2.446 0 0 0 -1.958 -.974z", "key": "svg-0" }]]);

var IconDiamondsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiamondsFilled
});

var IconDice1Filled = createReactComponent("filled", "dice-1-filled", "IconDice1Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-6.333 8.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z", "key": "svg-0" }]]);

var IconDice1Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice1Filled
});

var IconDice2Filled = createReactComponent("filled", "dice-2-filled", "IconDice2Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.833 11a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-5 -5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z", "key": "svg-0" }]]);

var IconDice2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice2Filled
});

var IconDice3Filled = createReactComponent("filled", "dice-3-filled", "IconDice3Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.833 12a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-3.5 -3.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-3.5 -3.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z", "key": "svg-0" }]]);

var IconDice3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice3Filled
});

var IconDice4Filled = createReactComponent("filled", "dice-4-filled", "IconDice4Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.833 12a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm0 -7a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z", "key": "svg-0" }]]);

var IconDice4Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice4Filled
});

var IconDice5Filled = createReactComponent("filled", "dice-5-filled", "IconDice5Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.833 12a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm3.5 -3.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-3.5 -3.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z", "key": "svg-0" }]]);

var IconDice5Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice5Filled
});

var IconDice6Filled = createReactComponent("filled", "dice-6-filled", "IconDice6Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.833 13a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm0 -4.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-7 -4.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z", "key": "svg-0" }]]);

var IconDice6Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDice6Filled
});

var IconDiceFilled = createReactComponent("filled", "dice-filled", "IconDiceFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.833 12a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm0 -7a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z", "key": "svg-0" }]]);

var IconDiceFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiceFilled
});

var IconDirectionArrowsFilled = createReactComponent("filled", "direction-arrows-filled", "IconDirectionArrowsFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -20 0l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72m-.293 13.293a1 1 0 0 0 -1.414 1.414l1 1a1 1 0 0 0 1.414 0l1 -1a1 1 0 0 0 0 -1.414l-.094 -.083a1 1 0 0 0 -1.32 .083l-.293 .292zm-3 -5a1 1 0 0 0 -1.414 0l-1 1a1 1 0 0 0 0 1.414l1 1a1 1 0 0 0 1.414 0l.083 -.094a1 1 0 0 0 -.083 -1.32l-.292 -.293l.292 -.293a1 1 0 0 0 0 -1.414m8 0a1 1 0 0 0 -1.414 0l-.083 .094a1 1 0 0 0 .083 1.32l.292 .292l-.292 .294a1 1 0 0 0 1.414 1.414l1 -1a1 1 0 0 0 0 -1.414zm-4 -4a1 1 0 0 0 -1.414 0l-1 1a1 1 0 0 0 0 1.414l.094 .083a1 1 0 0 0 1.32 -.083l.293 -.292l.293 .292a1 1 0 0 0 1.414 -1.414z", "key": "svg-0" }]]);

var IconDirectionArrowsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDirectionArrowsFilled
});

var IconDirectionSignFilled = createReactComponent("filled", "direction-sign-filled", "IconDirectionSignFilled", [["path", { "d": "M10.52 2.614a2.095 2.095 0 0 1 2.835 -.117l.126 .117l7.905 7.905c.777 .777 .816 2.013 .117 2.836l-.117 .126l-7.905 7.905a2.094 2.094 0 0 1 -2.836 .117l-.126 -.117l-7.907 -7.906a2.096 2.096 0 0 1 -.115 -2.835l.117 -.126l7.905 -7.905zm5.969 9.535l.01 -.116l-.003 -.12l-.016 -.114l-.03 -.11l-.044 -.112l-.052 -.098l-.076 -.105l-.07 -.081l-3.5 -3.5l-.095 -.083a1 1 0 0 0 -1.226 0l-.094 .083l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l1.792 1.793h-5.085l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h5.085l-1.792 1.793l-.083 .094a1 1 0 0 0 1.403 1.403l.094 -.083l3.5 -3.5l.097 -.112l.05 -.074l.037 -.067l.05 -.112l.023 -.076l.025 -.117z", "key": "svg-0" }]]);

var IconDirectionSignFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDirectionSignFilled
});

var IconDirectionsFilled = createReactComponent("filled", "directions-filled", "IconDirectionsFilled", [["path", { "d": "M10 22a1 1 0 0 1 0 -2h1v-2.001l-5 .001a1 1 0 0 1 -.707 -.293l-2 -2a1 1 0 0 1 0 -1.414l2 -2a1 1 0 0 1 .707 -.293l5 -.001v-1.999h-3a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h3v-1a1 1 0 0 1 2 0v1h6a1 1 0 0 1 .707 .293l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1 -.707 .293h-6v1.999l1 .001a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1l-1 -.001v2.001h1a1 1 0 0 1 0 2z", "key": "svg-0" }]]);

var IconDirectionsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDirectionsFilled
});

var IconDiscFilled = createReactComponent("filled", "disc-filled", "IconDiscFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m0 7.66a1 1 0 0 0 -1 1a4 4 0 0 1 -4 4a1 1 0 0 0 0 2a6 6 0 0 0 6 -6a1 1 0 0 0 -1 -1m-5 -1a2 2 0 0 0 -1.995 1.85l-.005 .15a2 2 0 1 0 2 -2m0 -4a6 6 0 0 0 -6 6a1 1 0 0 0 2 0a4 4 0 0 1 4 -4a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconDiscFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiscFilled
});

var IconDiscountFilled = createReactComponent("filled", "discount-filled", "IconDiscountFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-2.5 9.66a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3", "key": "svg-0" }]]);

var IconDiscountFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDiscountFilled
});

var IconDropCircleFilled = createReactComponent("filled", "drop-circle-filled", "IconDropCircleFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-4.177 4.092a1 1 0 0 0 -1.646 0l-2.602 3.764c-1.022 1.67 -.634 3.736 .875 4.929a4.144 4.144 0 0 0 5.095 0c1.51 -1.191 1.897 -3.26 .904 -4.882z", "key": "svg-0" }]]);

var IconDropCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropCircleFilled
});

var IconDropletHalf2Filled = createReactComponent("filled", "droplet-half-2-filled", "IconDropletHalf2Filled", [["path", { "d": "M13.905 2.923l.098 .135l4.92 7.306a7.566 7.566 0 0 1 1.043 3.167l.024 .326c.007 .047 .01 .094 .01 .143l-.002 .06c.056 2.3 -.944 4.582 -2.87 6.14c-2.969 2.402 -7.286 2.402 -10.255 0c-1.904 -1.54 -2.904 -3.787 -2.865 -6.071a1.052 1.052 0 0 1 .013 -.333a7.66 7.66 0 0 1 .913 -3.176l.172 -.302l4.893 -7.26c.185 -.275 .426 -.509 .709 -.686c1.055 -.66 2.446 -.413 3.197 .55zm-2.06 1.107l-.077 .038l-.041 .03l-.037 .036l-.033 .042l-4.863 7.214a5.607 5.607 0 0 0 -.651 1.61h11.723a5.444 5.444 0 0 0 -.49 -1.313l-.141 -.251l-4.891 -7.261a.428 .428 0 0 0 -.5 -.145z", "key": "svg-0" }]]);

var IconDropletHalf2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletHalf2Filled
});

var IconDropletHalfFilled = createReactComponent("filled", "droplet-half-filled", "IconDropletHalfFilled", [["path", { "d": "M12 2l.07 .003a2.41 2.41 0 0 1 1.825 .907l.108 .148l4.92 7.306c1.952 3.267 1.191 7.42 -1.796 9.836c-2.968 2.402 -7.285 2.402 -10.254 0c-2.917 -2.36 -3.711 -6.376 -1.901 -9.65l.134 -.232l4.893 -7.26c.185 -.275 .426 -.509 .709 -.686a2.426 2.426 0 0 1 1.066 -.36l.226 -.012zm-1 3.149l-4.206 6.24c-1.44 2.41 -.88 5.463 1.337 7.257a6.101 6.101 0 0 0 2.869 1.276v-14.773z", "key": "svg-0" }]]);

var IconDropletHalfFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletHalfFilled
});

var IconDropletFilled = createReactComponent("filled", "droplet-filled", "IconDropletFilled", [["path", { "d": "M10.708 2.372a2.382 2.382 0 0 0 -.71 .686l-4.892 7.26c-1.981 3.314 -1.22 7.466 1.767 9.882c2.969 2.402 7.286 2.402 10.254 0c2.987 -2.416 3.748 -6.569 1.795 -9.836l-4.919 -7.306c-.722 -1.075 -2.192 -1.376 -3.295 -.686z", "key": "svg-0" }]]);

var IconDropletFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletFilled
});

var IconDropletsFilled = createReactComponent("filled", "droplets-filled", "IconDropletsFilled", [["path", { "d": "M6 12.003c.541 0 1.045 .273 1.342 .727l2.122 3.273a3.999 3.999 0 0 1 -6.035 5.063c-1.487 -1.248 -1.864 -3.382 -.867 -5.11l2.098 -3.226a1.6 1.6 0 0 1 1.34 -.727", "key": "svg-0" }], ["path", { "d": "M18 12.003c.541 0 1.045 .273 1.342 .727l2.122 3.273a3.999 3.999 0 0 1 -6.035 5.063c-1.487 -1.248 -1.864 -3.382 -.867 -5.11l2.098 -3.227a1.6 1.6 0 0 1 1.34 -.726", "key": "svg-1" }], ["path", { "d": "M12 2.003c.541 0 1.045 .273 1.342 .727l2.122 3.273a3.999 3.999 0 0 1 -6.035 5.063c-1.487 -1.248 -1.864 -3.382 -.867 -5.11l2.098 -3.226a1.6 1.6 0 0 1 1.34 -.727", "key": "svg-2" }]]);

var IconDropletsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDropletsFilled
});

var IconDualScreenFilled = createReactComponent("filled", "dual-screen-filled", "IconDualScreenFilled", [["path", { "d": "M19 3a1 1 0 0 1 1 1v15a1 1 0 0 1 -1 1h-5v2a1 1 0 0 1 -1.351 .936l-8 -3a1 1 0 0 1 -.649 -.936v-15a1 1 0 0 1 .212 -.616l.068 -.079l.078 -.072l.066 -.05l.092 -.058l.065 -.033l.1 -.04l.099 -.028l.046 -.01l.108 -.013l.066 -.001zm-5.649 3.064a1 1 0 0 1 .649 .936v11h4v-13h-7.486z", "key": "svg-0" }]]);

var IconDualScreenFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDualScreenFilled
});

var IconDumplingFilled = createReactComponent("filled", "dumpling-filled", "IconDumplingFilled", [["path", { "d": "M10.003 2.04a3.53 3.53 0 0 1 2.602 .62l.09 .07l.149 -.11a3.53 3.53 0 0 1 3.044 -.462l.207 .072a3.53 3.53 0 0 1 1.99 1.903l.014 .031l.045 -.004a3.53 3.53 0 0 1 2.624 .879l.153 .144l.358 .358c1.976 1.977 -.32 6.748 -4.655 11.083c-4.336 4.335 -9.106 6.632 -11.083 4.655l-.382 -.382l-.135 -.145a3.53 3.53 0 0 1 -.87 -2.556l.01 -.1l-.162 -.072a3.53 3.53 0 0 1 -1.838 -2.124l-.055 -.192a3.53 3.53 0 0 1 .56 -2.937l.062 -.079l-.07 -.092a3.53 3.53 0 0 1 -.644 -2.401l.025 -.2a3.53 3.53 0 0 1 1.707 -2.505l.046 -.026l-.005 -.14a3.53 3.53 0 0 1 .885 -2.345l.15 -.16l.159 -.149a3.53 3.53 0 0 1 2.346 -.884l.14 .004l.026 -.046a3.53 3.53 0 0 1 2.308 -1.67z", "key": "svg-0" }]]);

var IconDumplingFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconDumplingFilled
});

var IconEggCrackedFilled = createReactComponent("filled", "egg-cracked-filled", "IconEggCrackedFilled", [["path", { "d": "M11.236 2.066l-1.694 5.647l-.029 .123a1 1 0 0 0 .406 .978l2.764 1.974l-1.551 2.716a1 1 0 1 0 1.736 .992l2 -3.5l.052 -.105a1 1 0 0 0 -.339 -1.205l-2.918 -2.085l1.623 -5.41c3.641 1.074 6.714 6.497 6.714 11.892c0 4.59 -3.273 7.71 -8 7.917c-4.75 0 -8 -3.21 -8 -7.917c0 -5.654 3.372 -11.344 7.236 -12.017", "key": "svg-0" }]]);

var IconEggCrackedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEggCrackedFilled
});

var IconEggFriedFilled = createReactComponent("filled", "egg-fried-filled", "IconEggFriedFilled", [["path", { "d": "M14.001 1.996q .06 0 .117 .007l.155 .003a6 6 0 0 1 4.25 2.05l.176 .21a6 6 0 0 1 1.296 4.014l-.018 .244l.106 .06a4 4 0 0 1 1.904 3.087l.011 .204a4 4 0 0 1 -1.392 3.161l-.085 .069l.083 .16a4 4 0 0 1 .239 2.848l-.065 .204a4 4 0 0 1 -6.257 1.824l-.115 -.096l-.092 .1a6 6 0 0 1 -4.022 1.787l-.257 .006a6 6 0 0 1 -5.644 -8.04l.034 -.089l-.155 -.12a6 6 0 0 1 -1.662 -7.256l.105 -.211a6 6 0 0 1 7.246 -2.894l.188 .068l.073 -.06a6 6 0 0 1 3.505 -1.334zm-2.001 7.004a3 3 0 0 0 -2.996 2.85l-.004 .15a3 3 0 1 0 3 -3", "key": "svg-0" }]]);

var IconEggFriedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEggFriedFilled
});

var IconEggFilled = createReactComponent("filled", "egg-filled", "IconEggFilled", [["path", { "d": "M12.002 2c-4.173 -.008 -8.002 6.058 -8.002 12.083c0 4.708 3.25 7.917 8 7.917c4.727 -.206 8 -3.328 8 -7.917c0 -6.02 -3.825 -12.075 -7.998 -12.083z", "key": "svg-0" }]]);

var IconEggFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEggFilled
});

var IconElevatorFilled = createReactComponent("filled", "elevator-filled", "IconElevatorFilled", [["path", { "d": "M18 3a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2zm-7.293 10.293a1 1 0 1 0 -1.414 1.414l2 2a1 1 0 0 0 1.414 0l2 -2a1 1 0 0 0 0 -1.414l-.094 -.083a1 1 0 0 0 -1.32 .083l-1.294 1.292zm2 -6a1 1 0 0 0 -1.414 0l-2 2a1 1 0 0 0 0 1.414l.094 .083a1 1 0 0 0 1.32 -.083l1.293 -1.292l1.293 1.292a1 1 0 0 0 1.414 -1.414z", "key": "svg-0" }]]);

var IconElevatorFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconElevatorFilled
});

var IconEngineFilled = createReactComponent("filled", "engine-filled", "IconEngineFilled", [["path", { "d": "M14 4a1 1 0 0 1 0 2h-1v1h.383a2 2 0 0 1 1.787 1.106l1.45 2.894h.38v-1a1 1 0 0 1 .883 -.993l.117 -.007h2a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-2a1 1 0 0 1 -1 -1v-1h-1v1a2 2 0 0 1 -1.85 1.995l-.15 .005h-3.465a2 2 0 0 1 -1.664 -.89l-1.407 -2.11h-1.464a1 1 0 0 1 -.993 -.883l-.007 -.117v-2h-1v2a1 1 0 0 1 -2 0v-6a1 1 0 1 1 2 0v2h1v-2a1 1 0 0 1 1 -1h1.584l1.709 -1.707a1 1 0 0 1 .576 -.284l.131 -.009h1v-1h-1a1 1 0 1 1 0 -2z", "key": "svg-0" }]]);

var IconEngineFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEngineFilled
});

var IconEscalatorDownFilled = createReactComponent("filled", "escalator-down-filled", "IconEscalatorDownFilled", [["path", { "d": "M7.233 6a3 3 0 0 1 2.006 .77l9.145 8.23h1.116a3.5 3.5 0 0 1 3.495 3.308l.005 .192a3.5 3.5 0 0 1 -3.5 3.5h-2.733a3 3 0 0 1 -2.006 -.77l-9.144 -8.23h-1.117a3.5 3.5 0 0 1 -3.495 -3.308l-.005 -.192a3.5 3.5 0 0 1 3.5 -3.5z", "key": "svg-0" }], ["path", { "d": "M18 2a1 1 0 0 1 1 1v4.584l1.293 -1.291a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.096 -.067l-.09 -.08l-3 -3a1 1 0 1 1 1.414 -1.414l1.293 1.293v-4.586a1 1 0 0 1 1 -1", "key": "svg-1" }]]);

var IconEscalatorDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEscalatorDownFilled
});

var IconEscalatorUpFilled = createReactComponent("filled", "escalator-up-filled", "IconEscalatorUpFilled", [["path", { "d": "M19.5 6a3.5 3.5 0 0 1 0 7h-1.086l-8.12 8.121a3 3 0 0 1 -1.924 .872l-.198 .007h-3.672a3.5 3.5 0 0 1 0 -7h2.084l8.123 -8.121a3 3 0 0 1 1.923 -.872l.198 -.007z", "key": "svg-0" }], ["path", { "d": "M19.5 8h-2.672a1 1 0 0 0 -.707 .293l-8.414 8.414a1 1 0 0 1 -.707 .293h-2.5a1.5 1.5 0 0 0 0 3h3.672a1 1 0 0 0 .707 -.293l8.414 -8.414a1 1 0 0 1 .707 -.293h1.5a1.5 1.5 0 0 0 0 -3", "key": "svg-1" }], ["path", { "d": "M5.852 2.011l.058 -.007l.09 -.004l.075 .003l.126 .017l.111 .03l.111 .044l.098 .052l.104 .074l.082 .073l3 3a1 1 0 1 1 -1.414 1.414l-1.293 -1.292v4.585a1 1 0 0 1 -2 0v-4.585l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 0 -1.414l3 -3q .053 -.054 .112 -.097l.11 -.071l.114 -.054l.105 -.035z", "key": "svg-2" }]]);

var IconEscalatorUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEscalatorUpFilled
});

var IconEscalatorFilled = createReactComponent("filled", "escalator-filled", "IconEscalatorFilled", [["path", { "d": "M19.5 4a3.5 3.5 0 0 1 0 7h-1.086l-8.12 8.121a3 3 0 0 1 -1.924 .872l-.198 .007h-3.672a3.5 3.5 0 0 1 0 -7h2.084l8.123 -8.121a3 3 0 0 1 1.923 -.872l.198 -.007z", "key": "svg-0" }]]);

var IconEscalatorFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEscalatorFilled
});

var IconExchangeFilled = createReactComponent("filled", "exchange-filled", "IconExchangeFilled", [["path", { "d": "M19 3a3 3 0 0 1 1 5.83v4.17a6 6 0 0 1 -6 6h-.585l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.414 0l-2.959 -2.959a1 1 0 0 1 -.238 -.32l-.038 -.091l-.028 -.094a.98 .98 0 0 1 .187 -.866l.076 -.084l3 -3a1 1 0 0 1 1.414 1.414l-1.293 1.293h.586a4 4 0 0 0 3.995 -3.8l.005 -.2v-4.171a3 3 0 0 1 -2 -2.829l.005 -.176a3 3 0 0 1 2.995 -2.824m-8.293 -.707l3 3a.98 .98 0 0 1 .263 .95l-.01 .031l-.003 .018l-.008 .018l-.007 .027l-.016 .035l-.01 .032l-.007 .01l-.005 .014a1 1 0 0 1 -.232 .316l-2.965 2.963a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 0 -1.414l1.291 -1.293h-.584a4 4 0 0 0 -3.995 3.8l-.005 .2v4.171a3.001 3.001 0 1 1 -4 2.829l.005 -.176a3 3 0 0 1 1.995 -2.654v-4.17a6 6 0 0 1 6 -6h.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.414 0", "key": "svg-0" }]]);

var IconExchangeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExchangeFilled
});

var IconExclamationCircleFilled = createReactComponent("filled", "exclamation-circle-filled", "IconExclamationCircleFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-5 11.66a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m0 -7a1 1 0 0 0 -1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconExclamationCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExclamationCircleFilled
});

var IconExplicitFilled = createReactComponent("filled", "explicit-filled", "IconExplicitFilled", [["path", { "d": "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2zm-5 4h-4a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-3v-2h3a1 1 0 0 0 0 -2h-3v-2h3a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconExplicitFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExplicitFilled
});

var IconExposureFilled = createReactComponent("filled", "exposure-filled", "IconExposureFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm0 2h-14a1 1 0 0 0 -1 1v14c0 .29 .123 .55 .321 .732l1.61 -1.584a973 973 0 0 0 6.69 -6.675l7.094 -7.173a1 1 0 0 0 -.715 -.3m-1 11h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2m-10 -10a1 1 0 0 1 1 1v1h1a1 1 0 0 1 .993 .883l.007 .117a1 1 0 0 1 -1 1h-1v1a1 1 0 0 1 -.883 .993l-.117 .007a1 1 0 0 1 -1 -1v-1h-1a1 1 0 0 1 -.993 -.883l-.007 -.117a1 1 0 0 1 1 -1h1v-1a1 1 0 0 1 .883 -.993z", "key": "svg-0" }]]);

var IconExposureFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconExposureFilled
});

var IconEyeTableFilled = createReactComponent("filled", "eye-table-filled", "IconEyeTableFilled", [["path", { "d": "M20 2a1 1 0 0 1 0 2v16a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-16a1 1 0 1 1 0 -2zm-12 15l-.128 .007a1 1 0 0 0 .118 1.993l.128 -.007a1 1 0 0 0 -.118 -1.993m4 0l-.128 .007a1 1 0 0 0 .118 1.993l.128 -.007a1 1 0 0 0 -.118 -1.993m4 0l-.128 .007a1 1 0 0 0 .118 1.993l.128 -.007a1 1 0 0 0 -.118 -1.993m-6 -3h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0 -2m5 0h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0 -2m-1 -8h-4a1 1 0 1 0 0 2h1v3a1 1 0 0 0 2 0v-3h1a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconEyeTableFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeTableFilled
});

var IconEyeFilled = createReactComponent("filled", "eye-filled", "IconEyeFilled", [["path", { "d": "M12 4c4.29 0 7.863 2.429 10.665 7.154l.22 .379l.045 .1l.03 .083l.014 .055l.014 .082l.011 .1v.11l-.014 .111a.992 .992 0 0 1 -.026 .11l-.039 .108l-.036 .075l-.016 .03c-2.764 4.836 -6.3 7.38 -10.555 7.499l-.313 .004c-4.396 0 -8.037 -2.549 -10.868 -7.504a1 1 0 0 1 0 -.992c2.831 -4.955 6.472 -7.504 10.868 -7.504zm0 5a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z", "key": "svg-0" }]]);

var IconEyeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeFilled
});

var IconEyeglass2Filled = createReactComponent("filled", "eyeglass-2-filled", "IconEyeglass2Filled", [["path", { "d": "M8 3a1 1 0 1 1 0 2h-1.257l-2.24 7.467a4.5 4.5 0 0 1 6.24 2.533h2.513a4.502 4.502 0 0 1 6.241 -2.534l-2.241 -7.466h-1.256a1 1 0 0 1 -.993 -.883l-.007 -.117a1 1 0 0 1 1 -1h2a1 1 0 0 1 .958 .713l3 10a1 1 0 0 1 .042 .287v2.5a4.5 4.5 0 0 1 -8.972 .5h-2.056a4.5 4.5 0 0 1 -8.972 -.5v-2.5a1 1 0 0 1 .042 -.287l3 -10a1 1 0 0 1 .958 -.713z", "key": "svg-0" }]]);

var IconEyeglass2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeglass2Filled
});

var IconEyeglassFilled = createReactComponent("filled", "eyeglass-filled", "IconEyeglassFilled", [["path", { "d": "M6.5 21a4.5 4.5 0 0 1 -4.5 -4.5v-2.518l.004 -.071l.014 -.103l.018 -.076l3.006 -10.02a1 1 0 0 1 .958 -.712h2a1 1 0 1 1 0 2h-1.257l-2.4 8h5.657a1 1 0 0 1 1 1v1h2v-1a1 1 0 0 1 1 -1h5.656l-2.4 -8h-1.256a1 1 0 0 1 -.993 -.883l-.007 -.117a1 1 0 0 1 1 -1h2a1 1 0 0 1 .958 .713l3.01 10.036l.022 .112l.008 .08l.002 2.559a4.5 4.5 0 0 1 -8.972 .5h-2.056a4.5 4.5 0 0 1 -4.472 4", "key": "svg-0" }]]);

var IconEyeglassFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconEyeglassFilled
});

var IconFaceMaskFilled = createReactComponent("filled", "face-mask-filled", "IconFaceMaskFilled", [["path", { "d": "M12.825 4.196l5 1.43a3 3 0 0 1 2.175 2.884v.065c1.7 .33 3 1.72 3 3.425s-1.3 3.095 -3 3.425v.066a3 3 0 0 1 -2.175 2.885l-5 1.428a3 3 0 0 1 -1.65 0l-5 -1.429a3 3 0 0 1 -2.17 -2.702l-.005 -.247c-1.7 -.33 -3 -1.72 -3 -3.426c0 -1.705 1.3 -3.096 3 -3.426v-.064a3 3 0 0 1 2.175 -2.884l5 -1.428a3 3 0 0 1 1.65 0m2.175 8.802h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2m-11 -2.349c-.6 .248 -1 .77 -1 1.349c0 .578 .4 1.101 1 1.349zm16.001 0v2.697c.599 -.248 .999 -.77 .999 -1.348s-.4 -1.1 -.999 -1.348m-5.001 -1.652h-6a1 1 0 1 0 0 2h6a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconFaceMaskFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFaceMaskFilled
});

var IconFaviconFilled = createReactComponent("filled", "favicon-filled", "IconFaviconFilled", [["path", { "d": "M19 4a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-14a4 4 0 0 1 -4 -4v-8a4 4 0 0 1 4 -4zm-13 5a1 1 0 0 0 -1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0 -1 -1m5 0a3 3 0 0 0 0 6a1 1 0 0 0 .117 -1.993l-.117 -.007a1 1 0 0 1 -.117 -1.993l.117 -.007a1 1 0 0 0 0 -2m5 0a3 3 0 0 0 -2.995 2.824l-.005 .176a3 3 0 1 0 3 -3", "key": "svg-0" }], ["path", { "d": "M16 11a1 1 0 1 0 0 2a1 1 0 0 0 0 -2", "key": "svg-1" }]]);

var IconFaviconFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFaviconFilled
});

var IconFeatherFilled = createReactComponent("filled", "feather-filled", "IconFeatherFilled", [["path", { "d": "M8 9.585v6.415h6.414l-2.707 2.707a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006h-4.586l-1.707 1.707a1 1 0 1 1 -1.414 -1.414l1.707 -1.709v-4.584l.003 -.075l.017 -.126l.03 -.111l.044 -.111l.052 -.098l.067 -.096l.08 -.09z", "key": "svg-0" }], ["path", { "d": "M19.414 11l-3 3h-4.914l2.914 -3z", "key": "svg-1" }], ["path", { "d": "M13 4.586v4.998l-3 3v-4.999z", "key": "svg-2" }], ["path", { "d": "M16.482 3a4.515 4.515 0 0 1 4.518 4.514a4.7 4.7 0 0 1 -.239 1.487l-5.761 -.001v-5.76c.469 -.158 .968 -.24 1.482 -.24", "key": "svg-3" }]]);

var IconFeatherFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFeatherFilled
});

var IconFenceFilled = createReactComponent("filled", "fence-filled", "IconFenceFilled", [["path", { "d": "M19 17v3a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-3z", "key": "svg-0" }], ["path", { "d": "M11 17v3a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-3z", "key": "svg-1" }], ["path", { "d": "M20 12a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M8.707 3.293l2 2a1 1 0 0 1 .293 .707v5h-6v-5a1 1 0 0 1 .293 -.707l2 -2a1 1 0 0 1 1.414 0", "key": "svg-3" }], ["path", { "d": "M16.707 3.293l2 2a1 1 0 0 1 .293 .707v5h-6v-5a1 1 0 0 1 .293 -.707l2 -2a1 1 0 0 1 1.414 0", "key": "svg-4" }]]);

var IconFenceFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFenceFilled
});

var IconFerryFilled = createReactComponent("filled", "ferry-filled", "IconFerryFilled", [["path", { "d": "M22 12a1 1 0 0 1 .86 1.51l-2.202 3.709a4.06 4.06 0 0 1 -3.365 1.781h-15.293a1 1 0 0 1 -.957 -1.291l1.521 -5a1 1 0 0 1 .957 -.709zm-3 1a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m-5.106 -7.447l.723 1.447h.874a1 1 0 0 1 .864 .497l2.037 3.503h-12.832l.973 -3.284a1 1 0 0 1 .958 -.716h4.89l-.275 -.553a1 1 0 0 1 1.788 -.894", "key": "svg-0" }]]);

var IconFerryFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFerryFilled
});

var IconFidgetSpinnerFilled = createReactComponent("filled", "fidget-spinner-filled", "IconFidgetSpinnerFilled", [["path", { "d": "M12 0a5 5 0 0 1 3.584 8.488l-.012 .012a5 5 0 0 1 1.33 2.517l.018 .101l.251 -.048q .15 -.025 .3 -.041l.304 -.024l.225 -.005a5 5 0 1 1 -4.89 6.046l-.032 -.164l-.24 .048a5 5 0 0 1 -.556 .062l-.282 .008q -.427 0 -.84 -.07l-.239 -.048l-.004 .025a5 5 0 0 1 -3.331 3.834l-.22 .068a5 5 0 1 1 -.461 -9.728l.173 .036l.019 -.102c.19 -.95 .653 -1.824 1.331 -2.516l-.05 -.052a5.02 5.02 0 0 1 -1.355 -2.978l-.018 -.244l-.005 -.225a5 5 0 0 1 5 -5m6 15a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m-12 0a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m6 -4.995c-1.1 0 -1.99 .891 -1.99 1.99v.02a1.99 1.99 0 0 0 3.98 0v-.02a1.99 1.99 0 0 0 -1.99 -1.99m0 -6.005a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconFidgetSpinnerFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFidgetSpinnerFilled
});

var IconFileCheckFilled = createReactComponent("filled", "file-check-filled", "IconFileCheckFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm3.707 10.293a1 1 0 0 0 -1.414 0l-3.293 3.292l-1.293 -1.292a1 1 0 1 0 -1.414 1.414l2 2a1 1 0 0 0 1.414 0l4 -4a1 1 0 0 0 0 -1.414m-.707 -9.294l4 4.001h-4z", "key": "svg-0" }]]);

var IconFileCheckFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileCheckFilled
});

var IconFileCode2Filled = createReactComponent("filled", "file-code-2-filled", "IconFileCode2Filled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm-2 9h-1a1 1 0 0 0 -1 1v5a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007v-3a1 1 0 0 0 0 -2m5 0h-1a1 1 0 0 0 0 2v3a1 1 0 0 0 0 2h1a1 1 0 0 0 1 -1v-5a1 1 0 0 0 -1 -1m-.001 -8.001l4.001 4.001h-4z", "key": "svg-0" }]]);

var IconFileCode2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileCode2Filled
});

var IconFileCvFilled = createReactComponent("filled", "file-cv-filled", "IconFileCvFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm-2.5 8a2.5 2.5 0 0 0 -2.5 2.5v3a2.5 2.5 0 1 0 5 0a1 1 0 0 0 -2 0a.5 .5 0 1 1 -1 0v-3a.5 .5 0 1 1 1 0a1 1 0 0 0 2 0a2.5 2.5 0 0 0 -2.5 -2.5m6.743 .03a1 1 0 0 0 -1.213 .727l-.53 2.119l-.53 -2.119a1 1 0 1 0 -1.94 .486l1.5 6c.252 1.01 1.688 1.01 1.94 0l1.5 -6a1 1 0 0 0 -.727 -1.213m-1.244 -7.031l4.001 4.001h-4z", "key": "svg-0" }]]);

var IconFileCvFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileCvFilled
});

var IconFileDeltaFilled = createReactComponent("filled", "file-delta-filled", "IconFileDeltaFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm.894 8.553a1 1 0 0 0 -1.788 0l-3 6a1 1 0 0 0 .894 1.447h6a1 1 0 0 0 .894 -1.447zm-.894 2.683l1.381 2.764h-2.763zm2.999 -10.237l4.001 4.001h-4z", "key": "svg-0" }]]);

var IconFileDeltaFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDeltaFilled
});

var IconFileDescriptionFilled = createReactComponent("filled", "file-description-filled", "IconFileDescriptionFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm3 14h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2m0 -4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2", "key": "svg-0" }], ["path", { "d": "M19 7h-4l-.001 -4.001z", "key": "svg-1" }]]);

var IconFileDescriptionFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDescriptionFilled
});

var IconFileDigitFilled = createReactComponent("filled", "file-digit-filled", "IconFileDigitFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm-1 9h-1a2 2 0 0 0 -2 2v3a2 2 0 0 0 2 2h1a2 2 0 0 0 2 -2v-3a2 2 0 0 0 -2 -2m4 0a1 1 0 0 0 -1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0 -1 -1m-4 2v3h-1v-3z", "key": "svg-0" }], ["path", { "d": "M19 7h-4l-.001 -4.001z", "key": "svg-1" }]]);

var IconFileDigitFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDigitFilled
});

var IconFileDownloadFilled = createReactComponent("filled", "file-download-filled", "IconFileDownloadFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm0 8a1 1 0 0 0 -1 1v3.585l-.793 -.792a1 1 0 0 0 -1.32 -.083l-.094 .083a1 1 0 0 0 0 1.414l2.5 2.5l.044 .042l.068 .055l.11 .071l.114 .054l.105 .035l.15 .03l.116 .006l.117 -.007l.117 -.02l.108 -.033l.081 -.034l.098 -.052l.092 -.064l.094 -.083l2.5 -2.5a1 1 0 0 0 0 -1.414l-.094 -.083a1 1 0 0 0 -1.32 .083l-.793 .791v-3.584a1 1 0 0 0 -.883 -.993zm2.999 -7.001l4.001 4.001h-4z", "key": "svg-0" }]]);

var IconFileDownloadFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileDownloadFilled
});

var IconFileHorizontalFilled = createReactComponent("filled", "file-horizontal-filled", "IconFileHorizontalFilled", [["path", { "d": "M22 12l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007h-4l-.15 -.005a2 2 0 0 1 -1.844 -1.838l-.006 -.157v-4l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007h-9a3 3 0 0 0 -2.995 2.824l-.005 .176v10a3 3 0 0 0 2.824 2.995l.176 .005h14a3 3 0 0 0 2.995 -2.824l.005 -.176z", "key": "svg-0" }], ["path", { "d": "M17 5v4l4.001 .001z", "key": "svg-1" }]]);

var IconFileHorizontalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileHorizontalFilled
});

var IconFileInvoiceFilled = createReactComponent("filled", "file-invoice-filled", "IconFileInvoiceFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm4 15h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0 -2m0 -4h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0 -2m-7 -7h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0 -2", "key": "svg-0" }], ["path", { "d": "M19 7h-4l-.001 -4.001z", "key": "svg-1" }]]);

var IconFileInvoiceFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileInvoiceFilled
});

var IconFileLambdaFilled = createReactComponent("filled", "file-lambda-filled", "IconFileLambdaFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm-2 8a1 1 0 0 0 -.117 1.993l.117 .007c.342 0 .662 .362 1.166 1.445l-1.998 3a1 1 0 0 0 1.664 1.11l1.29 -1.934c.825 1.738 1.508 2.379 2.878 2.379a1 1 0 0 0 .117 -1.993l-.117 -.007c-.39 0 -.75 -.47 -1.387 -1.938l-.415 -.976c-.985 -2.274 -1.656 -3.086 -3.198 -3.086m4.999 -7.001l4.001 4.001h-4z", "key": "svg-0" }]]);

var IconFileLambdaFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileLambdaFilled
});

var IconFileMinusFilled = createReactComponent("filled", "file-minus-filled", "IconFileMinusFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm3 11h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2", "key": "svg-0" }], ["path", { "d": "M19 7h-4l-.001 -4.001z", "key": "svg-1" }]]);

var IconFileMinusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileMinusFilled
});

var IconFileNeutralFilled = createReactComponent("filled", "file-neutral-filled", "IconFileNeutralFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm2 14h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2m-3.995 -4h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m4 0h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2", "key": "svg-0" }], ["path", { "d": "M19 7h-4l-.001 -4.001z", "key": "svg-1" }]]);

var IconFileNeutralFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileNeutralFilled
});

var IconFilePercentFilled = createReactComponent("filled", "file-percent-filled", "IconFilePercentFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm2.01 14h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m.697 -3.707a1 1 0 0 0 -1.414 0l-4 4a1 1 0 0 0 1.414 1.414l4 -4a1 1 0 0 0 0 -1.414m-4.697 -.293h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m4.989 -9.001l4.001 4.001h-4z", "key": "svg-0" }]]);

var IconFilePercentFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilePercentFilled
});

var IconFilePhoneFilled = createReactComponent("filled", "file-phone-filled", "IconFilePhoneFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm-2.5 7.5a1.5 1.5 0 0 0 -1.5 1.5v1a6 6 0 0 0 6 6h1a1.5 1.5 0 0 0 0 -3h-1l-.144 .007a1.5 1.5 0 0 0 -1.128 .697l-.042 .074l-.022 -.007a4.01 4.01 0 0 1 -2.435 -2.435l-.008 -.023l.075 -.041a1.5 1.5 0 0 0 .704 -1.272v-1a1.5 1.5 0 0 0 -1.5 -1.5m5.499 -6.501l4.001 4.001h-4z", "key": "svg-0" }]]);

var IconFilePhoneFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilePhoneFilled
});

var IconFilePowerFilled = createReactComponent("filled", "file-power-filled", "IconFilePowerFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm.555 9.168a1 1 0 0 0 -1.387 .277l-2 3l-.057 .097a1 1 0 0 0 .889 1.458h2.13l-.962 1.445a1 1 0 1 0 1.664 1.11l2 -3l.057 -.097a1 1 0 0 0 -.889 -1.458h-2.132l.964 -1.445a1 1 0 0 0 -.277 -1.387", "key": "svg-0" }], ["path", { "d": "M19 7h-4l-.001 -4.001z", "key": "svg-1" }]]);

var IconFilePowerFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilePowerFilled
});

var IconFileRssFilled = createReactComponent("filled", "file-rss-filled", "IconFileRssFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm-3 11a1 1 0 0 0 0 2a2 2 0 0 1 1.995 1.85l.005 .15a1 1 0 0 0 2 0a4 4 0 0 0 -4 -4m0 -3a1 1 0 0 0 0 2a5 5 0 0 1 5 5a1 1 0 0 0 2 0a7 7 0 0 0 -7 -7m.01 6h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m5.989 -13.001l4.001 4.001h-4z", "key": "svg-0" }]]);

var IconFileRssFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileRssFilled
});

var IconFileSadFilled = createReactComponent("filled", "file-sad-filled", "IconFileSadFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm2.571 15.18a4.5 4.5 0 0 0 -5.142 0a1 1 0 1 0 1.142 1.64a2.5 2.5 0 0 1 2.858 0a1 1 0 0 0 1.142 -1.64m-4.565 -5.18h-.011a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m4 0h-.011a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2", "key": "svg-0" }], ["path", { "d": "M19 7h-4l-.001 -4.001z", "key": "svg-1" }]]);

var IconFileSadFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileSadFilled
});

var IconFileSmileFilled = createReactComponent("filled", "file-smile-filled", "IconFileSmileFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm2.82 14.429a1 1 0 0 0 -1.391 -.25a2.5 2.5 0 0 1 -2.858 0a1 1 0 0 0 -1.142 1.642a4.5 4.5 0 0 0 5.142 0a1 1 0 0 0 .25 -1.392m-4.815 -4.429h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m4 0h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2", "key": "svg-0" }], ["path", { "d": "M19 7h-4l-.001 -4.001z", "key": "svg-1" }]]);

var IconFileSmileFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileSmileFilled
});

var IconFileStarFilled = createReactComponent("filled", "file-star-filled", "IconFileStarFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm-.2 9a.39 .39 0 0 0 -.351 .217l-1.086 2.193l-2.428 .352a.389 .389 0 0 0 -.217 .665l1.757 1.707l-.415 2.411a.392 .392 0 0 0 .568 .41l2.172 -1.138l2.172 1.138a.39 .39 0 0 0 .567 -.411l-.414 -2.41l1.757 -1.707a.39 .39 0 0 0 -.217 -.665l-2.428 -.352l-1.086 -2.193a.39 .39 0 0 0 -.351 -.217", "key": "svg-0" }], ["path", { "d": "M19 7h-4l-.001 -4.001z", "key": "svg-1" }]]);

var IconFileStarFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileStarFilled
});

var IconFileTextFilled = createReactComponent("filled", "file-text-filled", "IconFileTextFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005zm3 14h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2m0 -4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2m-5 -4h-1a1 1 0 1 0 0 2h1a1 1 0 0 0 0 -2", "key": "svg-0" }], ["path", { "d": "M19 7h-4l-.001 -4.001z", "key": "svg-1" }]]);

var IconFileTextFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileTextFilled
});

var IconFileXFilled = createReactComponent("filled", "file-x-filled", "IconFileXFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h5zm-1.489 9.14a1 1 0 0 0 -1.301 1.473l.083 .094l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.403 1.403l.094 -.083l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.403 -1.403l-.083 -.094l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.403 -1.403l-.094 .083l-1.293 1.292l-1.293 -1.292l-.094 -.083l-.102 -.07z", "key": "svg-0" }], ["path", { "d": "M19 7h-4l-.001 -4.001z", "key": "svg-1" }]]);

var IconFileXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileXFilled
});

var IconFileFilled = createReactComponent("filled", "file-filled", "IconFileFilled", [["path", { "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h5z", "key": "svg-0" }], ["path", { "d": "M19 7h-4l-.001 -4.001z", "key": "svg-1" }]]);

var IconFileFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFileFilled
});

var IconFilterFilled = createReactComponent("filled", "filter-filled", "IconFilterFilled", [["path", { "d": "M20 3h-16a1 1 0 0 0 -1 1v2.227l.008 .223a3 3 0 0 0 .772 1.795l4.22 4.641v8.114a1 1 0 0 0 1.316 .949l6 -2l.108 -.043a1 1 0 0 0 .576 -.906v-6.586l4.121 -4.12a3 3 0 0 0 .879 -2.123v-2.171a1 1 0 0 0 -1 -1z", "key": "svg-0" }]]);

var IconFilterFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFilterFilled
});

var IconFiltersFilled = createReactComponent("filled", "filters-filled", "IconFiltersFilled", [["path", { "d": "M19.396 11.056a6 6 0 0 1 -5.647 10.506q .206 -.21 .396 -.44a8 8 0 0 0 1.789 -6.155a8.02 8.02 0 0 0 3.462 -3.911", "key": "svg-0" }], ["path", { "d": "M4.609 11.051a7.99 7.99 0 0 0 9.386 4.698a6 6 0 1 1 -9.534 -4.594z", "key": "svg-1" }], ["path", { "d": "M12 2a6 6 0 1 1 -6 6l.004 -.225a6 6 0 0 1 5.996 -5.775", "key": "svg-2" }]]);

var IconFiltersFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFiltersFilled
});

var IconFishBoneFilled = createReactComponent("filled", "fish-bone-filled", "IconFishBoneFilled", [["path", { "d": "M16.675 6.44l.118 .005a1 1 0 0 1 .232 .052l.032 .015l.273 .103c1.936 .771 3.69 2.27 5.253 4.476l.245 .355a1 1 0 0 1 0 1.12c-1.702 2.519 -3.636 4.176 -5.792 4.947a1 1 0 0 1 -1.093 -.288a7.97 7.97 0 0 1 -1.883 -4.225h-2.06v3a1 1 0 0 1 -2 0v-3h-2v1a1 1 0 0 1 -2 0v-1h-1.166l-.335 .324a39 39 0 0 0 -1.751 1.846a1 1 0 0 1 -1.496 -1.328q .593 -.667 1.214 -1.308l.522 -.528l-.523 -.529a42 42 0 0 1 -.613 -.648l-.6 -.661a1 1 0 1 1 1.496 -1.328a40 40 0 0 0 2.069 2.161l1.183 -.001v-1a1 1 0 1 1 2 0v1h2v-3a1 1 0 0 1 2 0v3h2.062a7.97 7.97 0 0 1 1.656 -3.953l.196 -.24l.075 -.081l.105 -.088l.068 -.048l.097 -.052l.069 -.03l.138 -.042l.091 -.017q .059 -.007 .118 -.009m1.325 3.56a1 1 0 0 0 -.993 .883l-.007 .127a1 1 0 0 0 1.993 .117l.007 -.127a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconFishBoneFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFishBoneFilled
});

var IconFlag2Filled = createReactComponent("filled", "flag-2-filled", "IconFlag2Filled", [["path", { "d": "M19 4a1 1 0 0 1 .993 .883l.007 .117v9a1 1 0 0 1 -.883 .993l-.117 .007h-13v6a1 1 0 0 1 -.883 .993l-.117 .007a1 1 0 0 1 -.993 -.883l-.007 -.117v-16a1 1 0 0 1 .883 -.993l.117 -.007h14z", "key": "svg-0" }]]);

var IconFlag2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlag2Filled
});

var IconFlag3Filled = createReactComponent("filled", "flag-3-filled", "IconFlag3Filled", [["path", { "d": "M19 4c.852 0 1.297 .986 .783 1.623l-.076 .084l-3.792 3.793l3.792 3.793c.603 .602 .22 1.614 -.593 1.701l-.114 .006h-13v6a1 1 0 0 1 -.883 .993l-.117 .007a1 1 0 0 1 -.993 -.883l-.007 -.117v-16a1 1 0 0 1 .883 -.993l.117 -.007h14z", "key": "svg-0" }]]);

var IconFlag3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlag3Filled
});

var IconFlagFilled = createReactComponent("filled", "flag-filled", "IconFlagFilled", [["path", { "d": "M4 5a1 1 0 0 1 .3 -.714a6 6 0 0 1 8.213 -.176l.351 .328a4 4 0 0 0 5.272 0l.249 -.227c.61 -.483 1.527 -.097 1.61 .676l.005 .113v9a1 1 0 0 1 -.3 .714a6 6 0 0 1 -8.213 .176l-.351 -.328a4 4 0 0 0 -5.136 -.114v6.552a1 1 0 0 1 -1.993 .117l-.007 -.117v-16z", "key": "svg-0" }]]);

var IconFlagFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlagFilled
});

var IconFlameFilled = createReactComponent("filled", "flame-filled", "IconFlameFilled", [["path", { "d": "M10 2c0 -.88 1.056 -1.331 1.692 -.722c1.958 1.876 3.096 5.995 1.75 9.12l-.08 .174l.012 .003c.625 .133 1.203 -.43 2.303 -2.173l.14 -.224a1 1 0 0 1 1.582 -.153c1.334 1.435 2.601 4.377 2.601 6.27c0 4.265 -3.591 7.705 -8 7.705s-8 -3.44 -8 -7.706c0 -2.252 1.022 -4.716 2.632 -6.301l.605 -.589c.241 -.236 .434 -.43 .618 -.624c1.43 -1.512 2.145 -2.924 2.145 -4.78", "key": "svg-0" }]]);

var IconFlameFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlameFilled
});

var IconFlareFilled = createReactComponent("filled", "flare-filled", "IconFlareFilled", [["path", { "d": "M11.106 2.553a1 1 0 0 1 1.788 0l2.851 5.701l5.702 2.852a1 1 0 0 1 .11 1.725l-.11 .063l-5.702 2.851l-2.85 5.702a1 1 0 0 1 -1.726 .11l-.063 -.11l-2.852 -5.702l-5.701 -2.85a1 1 0 0 1 -.11 -1.726l.11 -.063l5.701 -2.852z", "key": "svg-0" }]]);

var IconFlareFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlareFilled
});

var IconFlask2Filled = createReactComponent("filled", "flask-2-filled", "IconFlask2Filled", [["path", { "d": "M15 2a1 1 0 0 1 0 2v5.674l.062 .03a7 7 0 0 1 3.85 5.174l.037 .262a7 7 0 0 1 -3.078 6.693a1 1 0 0 1 -.553 .167h-6.635a1 1 0 0 1 -.552 -.166a7 7 0 0 1 .807 -12.134l.062 -.028v-5.672a1 1 0 1 1 0 -2h6zm-2 2h-2v6.34a1 1 0 0 1 -.551 .894l-.116 .049a5 5 0 0 0 -2.92 2.717h9.172a5 5 0 0 0 -2.918 -2.715a1 1 0 0 1 -.667 -.943v-6.342z", "key": "svg-0" }]]);

var IconFlask2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlask2Filled
});

var IconFlaskFilled = createReactComponent("filled", "flask-filled", "IconFlaskFilled", [["path", { "d": "M15 2a1 1 0 0 1 0 2v4.826l3.932 10.814l.034 .077a1.7 1.7 0 0 1 -.002 1.193l-.07 .162a1.7 1.7 0 0 1 -1.213 .911l-.181 .017h-11l-.181 -.017a1.7 1.7 0 0 1 -1.285 -2.266l.039 -.09l3.927 -10.804v-4.823a1 1 0 1 1 0 -2h6zm-2 2h-2v4h2v-4z", "key": "svg-0" }]]);

var IconFlaskFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlaskFilled
});

var IconFlowerFilled = createReactComponent("filled", "flower-filled", "IconFlowerFilled", [["path", { "d": "M12 1a4 4 0 0 1 4 4l-.002 .055l.03 -.018a3.97 3.97 0 0 1 2.79 -.455l.237 .056a3.97 3.97 0 0 1 2.412 1.865a4.01 4.01 0 0 1 -1.455 5.461l-.068 .036l.071 .039a4.01 4.01 0 0 1 1.555 5.27l-.101 .186a3.97 3.97 0 0 1 -5.441 1.468l-.03 -.02l.002 .057a4 4 0 0 1 -3.8 3.995l-.2 .005a4 4 0 0 1 -4 -4l.001 -.056l-.029 .019a3.97 3.97 0 0 1 -2.79 .456l-.236 -.056a3.97 3.97 0 0 1 -2.413 -1.865a4.01 4.01 0 0 1 1.453 -5.46l.07 -.038l-.071 -.038a4.01 4.01 0 0 1 -1.555 -5.27l.1 -.187a3.97 3.97 0 0 1 5.444 -1.468l.026 .018v-.055a4 4 0 0 1 3.8 -3.995zm0 8a3 3 0 1 0 0 6a3 3 0 0 0 0 -6", "key": "svg-0" }]]);

var IconFlowerFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFlowerFilled
});

var IconFolderFilled = createReactComponent("filled", "folder-filled", "IconFolderFilled", [["path", { "d": "M9 3a1 1 0 0 1 .608 .206l.1 .087l2.706 2.707h6.586a3 3 0 0 1 2.995 2.824l.005 .176v8a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-11a3 3 0 0 1 2.824 -2.995l.176 -.005h4z", "key": "svg-0" }]]);

var IconFolderFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFolderFilled
});

var IconFoldersFilled = createReactComponent("filled", "folders-filled", "IconFoldersFilled", [["path", { "d": "M12 2a1 1 0 0 1 .707 .293l1.708 1.707h4.585a3 3 0 0 1 2.995 2.824l.005 .176v7a3 3 0 0 1 -3 3h-1v1a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3h1v-1a3 3 0 0 1 3 -3zm-6 6h-1a1 1 0 0 0 -1 1v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1 -1v-1h-7a3 3 0 0 1 -3 -3z", "key": "svg-0" }]]);

var IconFoldersFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFoldersFilled
});

var IconForbid2Filled = createReactComponent("filled", "forbid-2-filled", "IconForbid2Filled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 4.953a1 1 0 0 0 -1.414 0l-6 6l-.083 .094a1 1 0 0 0 1.497 1.32l6 -6l.083 -.094a1 1 0 0 0 -.083 -1.32z", "key": "svg-0" }]]);

var IconForbid2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconForbid2Filled
});

var IconForbidFilled = createReactComponent("filled", "forbid-filled", "IconForbidFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-7.387 4.87a1 1 0 0 0 -1.32 1.497l6 6l.094 .083a1 1 0 0 0 1.32 -1.497l-6 -6z", "key": "svg-0" }]]);

var IconForbidFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconForbidFilled
});

var IconFountainFilled = createReactComponent("filled", "fountain-filled", "IconFountainFilled", [["path", { "d": "M15 2a4 4 0 0 1 4 4a1 1 0 0 1 -1.993 .117l-.007 -.117a2 2 0 0 0 -3.995 -.15l-.005 .15v9h1v-4a3 3 0 0 1 6 0a1 1 0 0 1 -1.993 .117l-.007 -.117a1 1 0 0 0 -1.993 -.117l-.007 .117v4h5a1 1 0 0 1 .993 .883l.007 .117v2a4 4 0 0 1 -3.8 3.995l-.2 .005h-12a4 4 0 0 1 -3.995 -3.8l-.005 -.2v-2a1 1 0 0 1 .883 -.993l.117 -.007h5v-4a1 1 0 0 0 -1.993 -.117l-.007 .117a1 1 0 0 1 -2 0a3 3 0 0 1 5.995 -.176l.005 .176v4h1v-9a2 2 0 1 0 -4 0a1 1 0 1 1 -2 0a4 4 0 0 1 7.001 -2.645a3.983 3.983 0 0 1 2.999 -1.355z", "key": "svg-0" }]]);

var IconFountainFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFountainFilled
});

var IconFunctionFilled = createReactComponent("filled", "function-filled", "IconFunctionFilled", [["path", { "d": "M17.333 3a3.667 3.667 0 0 1 3.667 3.667v10.666a3.667 3.667 0 0 1 -3.667 3.667h-10.666a3.667 3.667 0 0 1 -3.667 -3.667v-10.666a3.667 3.667 0 0 1 3.667 -3.667zm-3.583 3a2.38 2.38 0 0 0 -2.37 2.145l-.285 2.855h-2.095l-.117 .007a1 1 0 0 0 .117 1.993h1.894l-.265 2.656l-.014 .071a.38 .38 0 0 1 -.365 .273a.25 .25 0 0 1 -.25 -.25v-.25l-.007 -.117a1 1 0 0 0 -1.993 .117v.25l.005 .154a2.25 2.25 0 0 0 2.245 2.096a2.38 2.38 0 0 0 2.37 -2.145l.284 -2.855h2.096l.117 -.007a1 1 0 0 0 -.117 -1.993h-1.895l.266 -2.656l.014 -.071a.381 .381 0 0 1 .365 -.273a.25 .25 0 0 1 .25 .25v.25l.007 .117a1 1 0 0 0 1.993 -.117v-.25l-.005 -.154a2.25 2.25 0 0 0 -2.245 -2.096z", "key": "svg-0" }]]);

var IconFunctionFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconFunctionFilled
});

var IconGardenCartFilled = createReactComponent("filled", "garden-cart-filled", "IconGardenCartFilled", [["path", { "d": "M3.324 3a2 2 0 0 1 1.855 1.258l1.097 2.742h14.724a1 1 0 0 1 .94 1.341l-.046 .106l-2.934 5.871a3.5 3.5 0 1 1 -4.96 3.182l.005 -.192a3.5 3.5 0 0 1 .499 -1.618l-2.446 -.258l-3.446 4.75a2 2 0 0 1 -2.08 .762l-.154 -.044a2 2 0 0 1 -1.378 -1.9v-9.804l-1.679 -4.196h-1.321a1 1 0 0 1 -.993 -.883l-.007 -.117a1 1 0 0 1 1 -1zm14.176 13a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m-10.5 -2.498l-.002 5.498l2.783 -3.833a5 5 0 0 1 -2.614 -1.474z", "key": "svg-0" }]]);

var IconGardenCartFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGardenCartFilled
});

var IconGasStationFilled = createReactComponent("filled", "gas-station-filled", "IconGasStationFilled", [["path", { "d": "M3 21a1 1 0 0 1 0 -2v-13a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v4a3 3 0 0 1 3 3v3a.5 .5 0 1 0 1 0v-6a2 2 0 0 1 -2 -2v-.585l-.707 -.708a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.414 0l3.003 3.002l.095 .112l.028 .04l.044 .073l.052 .11l.031 .09l.02 .076l.012 .078l.008 .126v7a2.5 2.5 0 1 1 -5 0v-3a1 1 0 0 0 -1 -1v7a1 1 0 0 1 0 2zm9 -16h-6a1 1 0 0 0 -1 1v4h8v-4a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconGasStationFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGasStationFilled
});

var IconGaugeFilled = createReactComponent("filled", "gauge-filled", "IconGaugeFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-.293 3.953a1 1 0 0 0 -1.414 0l-2.59 2.59l-.083 .094l-.068 .1a2.001 2.001 0 0 0 -2.547 1.774l-.005 .149l.005 .15a2 2 0 1 0 3.917 -.701a.968 .968 0 0 0 .195 -.152l2.59 -2.59l.083 -.094a1 1 0 0 0 -.083 -1.32zm-4.707 -1.293a6 6 0 0 0 -6 6a1 1 0 0 0 2 0a4 4 0 0 1 4 -4a1 1 0 0 0 0 -2z", "key": "svg-0" }]]);

var IconGaugeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGaugeFilled
});

var IconGhost2Filled = createReactComponent("filled", "ghost-2-filled", "IconGhost2Filled", [["path", { "d": "M12 1.999l.041 .002l.208 .003a8 8 0 0 1 7.747 7.747l.003 .248l.177 .006a3 3 0 0 1 2.819 2.819l.005 .176a3 3 0 0 1 -3 3l-.001 1.696l1.833 2.75a1 1 0 0 1 -.72 1.548l-.112 .006h-10c-3.445 .002 -6.327 -2.49 -6.901 -5.824l-.028 -.178l-.071 .001a3 3 0 0 1 -2.995 -2.824l-.005 -.175a3 3 0 0 1 3 -3l.004 -.25a8 8 0 0 1 7.996 -7.75zm0 10.001a2 2 0 0 0 -2 2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1a2 2 0 0 0 -2 -2zm-1.99 -4l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm4 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconGhost2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGhost2Filled
});

var IconGhost3Filled = createReactComponent("filled", "ghost-3-filled", "IconGhost3Filled", [["path", { "d": "M12 3a8 8 0 0 1 8 8v6.954l.009 .103a2.78 2.78 0 0 1 -1.468 2.618l-.163 .08c-1.111 .502 -2.42 .22 -3.266 -.74a.65 .65 0 0 0 -1.024 0a2.65 2.65 0 0 1 -4.176 0a.65 .65 0 0 0 -.512 -.249c-.2 0 -.389 .092 -.55 .296a2.78 2.78 0 0 1 -4.859 -2.005l.01 -.104l.007 -.077l-.008 .074v-6.95l.004 -.25a8 8 0 0 1 7.747 -7.746zm-1.99 6h-.01a1 1 0 1 0 0 2h.01a1 1 0 0 0 0 -2m4 0h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconGhost3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGhost3Filled
});

var IconGhostFilled = createReactComponent("filled", "ghost-filled", "IconGhostFilled", [["path", { "d": "M12 3a8 8 0 0 1 7.996 7.75l.004 .25l-.001 6.954l.01 .103a2.78 2.78 0 0 1 -1.468 2.618l-.163 .08c-1.053 .475 -2.283 .248 -3.129 -.593l-.137 -.146a.65 .65 0 0 0 -1.024 0a2.65 2.65 0 0 1 -4.176 0a.65 .65 0 0 0 -.512 -.25c-.2 0 -.389 .092 -.55 .296a2.78 2.78 0 0 1 -4.859 -2.005l.008 -.091l.001 -6.966l.004 -.25a8 8 0 0 1 7.996 -7.75zm2.82 10.429a1 1 0 0 0 -1.391 -.25a2.5 2.5 0 0 1 -2.858 0a1 1 0 0 0 -1.142 1.642a4.5 4.5 0 0 0 5.142 0a1 1 0 0 0 .25 -1.392zm-4.81 -4.429l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm4 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconGhostFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGhostFilled
});

var IconGiftCardFilled = createReactComponent("filled", "gift-card-filled", "IconGiftCardFilled", [["path", { "d": "M18 4a4 4 0 0 1 3.995 3.8l.005 .2v8a4 4 0 0 1 -3.8 3.995l-.2 .005h-12a4 4 0 0 1 -3.995 -3.8l-.005 -.2v-8a4 4 0 0 1 3.8 -3.995l.2 -.005h12zm-5.493 5l-.19 .004c-.928 .052 -1.719 .583 -2.317 1.444c-.56 -.805 -1.288 -1.322 -2.139 -1.428l-.198 -.017l-.164 -.003l-.16 .005c-1.28 .086 -2.339 1.179 -2.339 2.495c0 1.226 1.222 2.211 2.453 2.447l.16 .026l-1.32 1.32l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l2.293 -2.292l2.293 2.292l.094 .083a1 1 0 0 0 1.403 -1.403l-.083 -.094l-1.32 -1.32c1.229 -.169 2.502 -1.11 2.606 -2.315l.007 -.158l-.005 -.163c-.08 -1.189 -1.02 -2.162 -2.175 -2.316l-.159 -.016l-.154 -.005zm-.025 2l.102 .009c.194 .04 .367 .21 .407 .406l.009 .085l-.012 .031l-.034 .04c-.13 .135 -.513 .369 -.836 .42l-.118 .009h-.602l.052 -.1l.088 -.156c.27 -.444 .574 -.696 .852 -.738l.092 -.006zm-4.964 0l.084 .005l.094 .02c.254 .077 .523 .32 .765 .718l.09 .157l.05 .1h-.601l-.106 -.008c-.398 -.057 -.894 -.4 -.894 -.492c0 -.23 .194 -.446 .416 -.491l.102 -.01z", "key": "svg-0" }]]);

var IconGiftCardFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGiftCardFilled
});

var IconGiftFilled = createReactComponent("filled", "gift-filled", "IconGiftFilled", [["path", { "d": "M11 14v8h-4a3 3 0 0 1 -3 -3v-4a1 1 0 0 1 1 -1h6zm8 0a1 1 0 0 1 1 1v4a3 3 0 0 1 -3 3h-4v-8h6zm-2.5 -12a3.5 3.5 0 0 1 3.163 5h.337a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-7v-5h-2v5h-7a2 2 0 0 1 -2 -2v-1a2 2 0 0 1 2 -2h.337a3.486 3.486 0 0 1 -.337 -1.5c0 -1.933 1.567 -3.5 3.483 -3.5c1.755 -.03 3.312 1.092 4.381 2.934l.136 .243c1.033 -1.914 2.56 -3.114 4.291 -3.175l.209 -.002zm-9 2a1.5 1.5 0 0 0 0 3h3.143c-.741 -1.905 -1.949 -3.02 -3.143 -3zm8.983 0c-1.18 -.02 -2.385 1.096 -3.126 3h3.143a1.5 1.5 0 1 0 -.017 -3z", "key": "svg-0" }]]);

var IconGiftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGiftFilled
});

var IconGlassFullFilled = createReactComponent("filled", "glass-full-filled", "IconGlassFullFilled", [["path", { "d": "M5.004 10.229l-.003 -.186l.001 -.113l.008 -.071l1 -7a1 1 0 0 1 .877 -.853l.113 -.006h10a1 1 0 0 1 .968 .747l.022 .112l1.006 7.05l.004 .091c0 3.226 -2.56 5.564 -6 5.945v4.055h3a1 1 0 0 1 .117 1.993l-.117 .007h-8a1 1 0 0 1 -.117 -1.993l.117 -.007h3v-4.055c-3.358 -.371 -5.878 -2.609 -5.996 -5.716zm11.129 -6.229h-8.267l-.607 4.258a6.001 6.001 0 0 1 5.125 .787l.216 .155a4 4 0 0 0 4.32 .31l-.787 -5.51z", "key": "svg-0" }]]);

var IconGlassFullFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGlassFullFilled
});

var IconGlassFilled = createReactComponent("filled", "glass-filled", "IconGlassFilled", [["path", { "d": "M12 2c3.205 0 5.894 1.05 5.997 2.89l.99 5.946l.013 .164c0 3.226 -2.56 5.564 -6 5.945v3.055h3a1 1 0 0 1 0 2h-8a1 1 0 0 1 0 -2h3v-3.055c-3.44 -.38 -6 -2.719 -6 -5.945l.014 -.164l.991 -5.955l.001 -.038c.146 -1.81 2.817 -2.843 5.994 -2.843m0 2c-1.224 0 -2.359 .192 -3.164 .514c-.594 .238 -.836 .467 -.836 .486c0 .02 .242 .248 .836 .486c.804 .322 1.94 .514 3.164 .514s2.359 -.192 3.164 -.514c.594 -.238 .836 -.467 .836 -.486l-.02 -.026c-.07 -.07 -.321 -.262 -.816 -.46c-.804 -.322 -1.94 -.514 -3.164 -.514", "key": "svg-0" }]]);

var IconGlassFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGlassFilled
});

var IconGlobeFilled = createReactComponent("filled", "globe-filled", "IconGlobeFilled", [["path", { "d": "M11 4a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z", "key": "svg-0" }], ["path", { "d": "M14.133 1.502a1 1 0 0 1 1.365 -.369a9.015 9.015 0 1 1 -10.404 14.622a1 1 0 1 1 1.312 -1.51a7.015 7.015 0 1 0 8.096 -11.378a1 1 0 0 1 -.369 -1.365z", "key": "svg-1" }], ["path", { "d": "M11 16a1 1 0 0 1 .993 .883l.007 .117v4a1 1 0 0 1 -1.993 .117l-.007 -.117v-4a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M15 20a1 1 0 0 1 .117 1.993l-.117 .007h-8a1 1 0 0 1 -.117 -1.993l.117 -.007h8z", "key": "svg-3" }]]);

var IconGlobeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGlobeFilled
});

var IconGolfFilled = createReactComponent("filled", "golf-filled", "IconGolfFilled", [["path", { "d": "M11 3a1 1 0 0 1 1.496 -.868l7 4a1 1 0 0 1 0 1.736l-6.496 3.712v6.42a1 1 0 0 1 -.883 .993l-.117 .007a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M14.135 17.168a1 1 0 0 1 1.367 -.363c.916 .532 1.498 1.291 1.498 2.195c0 1.84 -2.319 3 -5 3s-5 -1.16 -5 -3c0 -.911 .577 -1.66 1.498 -2.195a1 1 0 1 1 1.004 1.73c-.365 .212 -.502 .39 -.502 .465c0 .086 .179 .296 .622 .518c.6 .3 1.456 .482 2.378 .482s1.777 -.182 2.378 -.482c.443 -.222 .622 -.432 .622 -.518c0 -.07 -.142 -.256 -.502 -.465a1 1 0 0 1 -.363 -1.367", "key": "svg-1" }]]);

var IconGolfFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGolfFilled
});

var IconGpsFilled = createReactComponent("filled", "gps-filled", "IconGpsFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-.086 5.066c.372 -.837 -.483 -1.692 -1.32 -1.32l-9 4l-.108 .055c-.75 .44 -.611 1.609 .271 1.83l3.418 .853l.855 3.419c.23 .922 1.498 1.032 1.884 .163z", "key": "svg-0" }]]);

var IconGpsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGpsFilled
});

var IconGraphFilled = createReactComponent("filled", "graph-filled", "IconGraphFilled", [["path", { "d": "M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12zm-2.293 6.293a1 1 0 0 0 -1.414 0l-2.293 2.292l-1.293 -1.292a1 1 0 0 0 -1.414 0l-3 3a1 1 0 0 0 0 1.414l.094 .083a1 1 0 0 0 1.32 -.083l2.293 -2.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -.083l2.293 -2.292l1.293 1.292a1 1 0 0 0 1.414 -1.414l-2 -2z", "key": "svg-0" }]]);

var IconGraphFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGraphFilled
});

var IconGridPatternFilled = createReactComponent("filled", "grid-pattern-filled", "IconGridPatternFilled", [["path", { "d": "M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3zm-4 4a1 1 0 0 0 -1 1v1h-2v-1a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v1h-1a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 0 1 1h1v2h-1a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 0 1 1h1v1a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-1h2v1a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-1h1a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-1v-2h1a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-1v-1a1 1 0 0 0 -.883 -.993zm-1 4v2h-2v-2z", "key": "svg-0" }]]);

var IconGridPatternFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGridPatternFilled
});

var IconGuitarPickFilled = createReactComponent("filled", "guitar-pick-filled", "IconGuitarPickFilled", [["path", { "d": "M12 2c-1.613 0 -2.882 .104 -3.825 .323l-.23 .057c-3.019 .708 -4.945 2.503 -4.945 5.62c0 3.367 1.939 8.274 4.22 11.125c.32 .4 .664 .786 1.03 1.158l.367 .36a4.904 4.904 0 0 0 6.752 .011a15.04 15.04 0 0 0 1.41 -1.528c2.491 -3.113 4.221 -7.294 4.221 -11.126c0 -3.025 -1.813 -4.806 -4.71 -5.562l-.266 -.066c-.936 -.25 -2.281 -.372 -4.024 -.372z", "key": "svg-0" }]]);

var IconGuitarPickFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconGuitarPickFilled
});

var IconHanger2Filled = createReactComponent("filled", "hanger-2-filled", "IconHanger2Filled", [["path", { "d": "M12 2a3 3 0 0 1 3 3a1 1 0 0 1 -1.993 .117l-.007 -.117a1 1 0 0 0 -2 -.004c.006 1.516 .495 2.579 1.486 3.13l7.97 4.428a3 3 0 0 1 1.544 2.623v.823a3 3 0 0 1 -2.824 2.995l-.176 .005a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3a3 3 0 0 1 -3 -3v-.823a3 3 0 0 1 1.543 -2.623l6.695 -3.72c-.832 -.976 -1.232 -2.296 -1.238 -3.834a3 3 0 0 1 3 -3m0 8.144l-7.486 4.158a1 1 0 0 0 -.514 .875v.823a1 1 0 0 0 1 1h.17a3 3 0 0 1 2.83 -2h8c1.306 0 2.418 .835 2.83 2h.17a1 1 0 0 0 1 -1v-.823a1 1 0 0 0 -.515 -.875z", "key": "svg-0" }]]);

var IconHanger2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHanger2Filled
});

var IconHeadphonesFilled = createReactComponent("filled", "headphones-filled", "IconHeadphonesFilled", [["path", { "d": "M21 18a3 3 0 0 1 -2.824 2.995l-.176 .005h-1a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-3a3 3 0 0 1 2.824 -2.995l.176 -.005h1c.351 0 .688 .06 1 .171v-.171a7 7 0 0 0 -13.996 -.24l-.004 .24v.17c.25 -.088 .516 -.144 .791 -.163l.209 -.007h1a3 3 0 0 1 2.995 2.824l.005 .176v3a3 3 0 0 1 -2.824 2.995l-.176 .005h-1a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a9 9 0 0 1 17.996 -.265l.004 .265v6z", "key": "svg-0" }]]);

var IconHeadphonesFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeadphonesFilled
});

var IconHeartFilled = createReactComponent("filled", "heart-filled", "IconHeartFilled", [["path", { "d": "M6.979 3.074a6 6 0 0 1 4.988 1.425l.037 .033l.034 -.03a6 6 0 0 1 4.733 -1.44l.246 .036a6 6 0 0 1 3.364 10.008l-.18 .185l-.048 .041l-7.45 7.379a1 1 0 0 1 -1.313 .082l-.094 -.082l-7.493 -7.422a6 6 0 0 1 3.176 -10.215z", "key": "svg-0" }]]);

var IconHeartFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHeartFilled
});

var IconHelicopterLandingFilled = createReactComponent("filled", "helicopter-landing-filled", "IconHelicopterLandingFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-4 5a1 1 0 0 0 -1 1v3h-4v-3a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-3h4v3a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconHelicopterLandingFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelicopterLandingFilled
});

var IconHelicopterFilled = createReactComponent("filled", "helicopter-filled", "IconHelicopterFilled", [["path", { "d": "M20 5a1 1 0 0 1 0 2h-6v1c4.642 0 8 2.218 8 6a3 3 0 0 1 -3 3h-3v1h3a1 1 0 0 1 0 2h-8a1 1 0 0 1 0 -2h3v-1h-2c-1.652 0 -3 -1.348 -3 -3v-1.001l-6 .001a1 1 0 0 1 -.894 -.553l-1 -2a1 1 0 0 1 1.788 -.894l.724 1.447l5.382 -.001l.005 -.175a3 3 0 0 1 2.995 -2.824v-1h-7a1 1 0 1 1 0 -2zm-3.999 5.174l-.001 1.826h3.36c-.665 -.906 -1.825 -1.539 -3.359 -1.826", "key": "svg-0" }]]);

var IconHelicopterFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelicopterFilled
});

var IconHelpCircleFilled = createReactComponent("filled", "help-circle-filled", "IconHelpCircleFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 13a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z", "key": "svg-0" }]]);

var IconHelpCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpCircleFilled
});

var IconHelpHexagonFilled = createReactComponent("filled", "help-hexagon-filled", "IconHelpHexagonFilled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.026 -.097l.19 .097l6.775 3.995l.096 .063l.092 .077l.107 .075a3.224 3.224 0 0 1 1.266 2.188l.018 .202l.005 .204v7.284c0 1.106 -.57 2.129 -1.454 2.693l-.17 .1l-6.803 4.302c-.918 .504 -2.019 .535 -3.004 .068l-.196 -.1l-6.695 -4.237a3.225 3.225 0 0 1 -1.671 -2.619l-.007 -.207v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098zm1.575 13.586a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z", "key": "svg-0" }]]);

var IconHelpHexagonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpHexagonFilled
});

var IconHelpOctagonFilled = createReactComponent("filled", "help-octagon-filled", "IconHelpOctagonFilled", [["path", { "d": "M14.897 1a4 4 0 0 1 2.664 1.016l.165 .156l4.1 4.1a4 4 0 0 1 1.168 2.605l.006 .227v5.794a4 4 0 0 1 -1.016 2.664l-.156 .165l-4.1 4.1a4 4 0 0 1 -2.603 1.168l-.227 .006h-5.795a3.999 3.999 0 0 1 -2.664 -1.017l-.165 -.156l-4.1 -4.1a4 4 0 0 1 -1.168 -2.604l-.006 -.227v-5.794a4 4 0 0 1 1.016 -2.664l.156 -.165l4.1 -4.1a4 4 0 0 1 2.605 -1.168l.227 -.006h5.793zm-2.897 14a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z", "key": "svg-0" }]]);

var IconHelpOctagonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpOctagonFilled
});

var IconHelpSquareRoundedFilled = createReactComponent("filled", "help-square-rounded-filled", "IconHelpSquareRoundedFilled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm0 13a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z", "key": "svg-0" }]]);

var IconHelpSquareRoundedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpSquareRoundedFilled
});

var IconHelpSquareFilled = createReactComponent("filled", "help-square-filled", "IconHelpSquareFilled", [["path", { "d": "M19 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h14zm-7 13a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z", "key": "svg-0" }]]);

var IconHelpSquareFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpSquareFilled
});

var IconHelpTriangleFilled = createReactComponent("filled", "help-triangle-filled", "IconHelpTriangleFilled", [["path", { "d": "M12 1.67c.955 0 1.845 .467 2.39 1.247l.105 .16l8.114 13.548a2.914 2.914 0 0 1 -2.307 4.363l-.195 .008h-16.225a2.914 2.914 0 0 1 -2.582 -4.2l.099 -.185l8.11 -13.538a2.914 2.914 0 0 1 2.491 -1.403zm0 13.33a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z", "key": "svg-0" }]]);

var IconHelpTriangleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHelpTriangleFilled
});

var IconHexagonLetterAFilled = createReactComponent("filled", "hexagon-letter-a-filled", "IconHexagonLetterAFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-1.666 5.571a3 3 0 0 0 -3 3v6a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-6a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v2h-2v-2a1 1 0 0 1 .883 -.993z", "key": "svg-0" }]]);

var IconHexagonLetterAFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterAFilled
});

var IconHexagonLetterBFilled = createReactComponent("filled", "hexagon-letter-b-filled", "IconHexagonLetterBFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-1.666 5.571h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h2a3 3 0 0 0 3 -3l-.005 -.176a3 3 0 0 0 -.654 -1.7l-.106 -.124l.106 -.124a3 3 0 0 0 -2.341 -4.876m0 6a1 1 0 0 1 0 2h-1v-2zm0 -4a1 1 0 0 1 0 2h-1v-2z", "key": "svg-0" }]]);

var IconHexagonLetterBFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterBFilled
});

var IconHexagonLetterCFilled = createReactComponent("filled", "hexagon-letter-c-filled", "IconHexagonLetterCFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-1.666 5.571a3 3 0 0 0 -3 3v4a3 3 0 0 0 6 0a1 1 0 0 0 -1.993 -.117l-.007 .117a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1.993 -.117l.007 .117a1 1 0 0 0 2 0a3 3 0 0 0 -3 -3", "key": "svg-0" }]]);

var IconHexagonLetterCFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterCFilled
});

var IconHexagonLetterDFilled = createReactComponent("filled", "hexagon-letter-d-filled", "IconHexagonLetterDFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-1.666 5.571h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h2a3 3 0 0 0 3 -3v-4a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-1v-6z", "key": "svg-0" }]]);

var IconHexagonLetterDFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterDFilled
});

var IconHexagonLetterEFilled = createReactComponent("filled", "hexagon-letter-e-filled", "IconHexagonLetterEFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.334 5.571h-4a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-3v-2h1.5a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-1.5v-2h3a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconHexagonLetterEFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterEFilled
});

var IconHexagonLetterFFilled = createReactComponent("filled", "hexagon-letter-f-filled", "IconHexagonLetterFFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.334 5.571h-4a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3h2a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-2v-2h3a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconHexagonLetterFFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterFFilled
});

var IconHexagonLetterGFilled = createReactComponent("filled", "hexagon-letter-g-filled", "IconHexagonLetterGFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.334 5.571h-2a3 3 0 0 0 -3 3v4a3 3 0 0 0 3 3h2a1 1 0 0 0 1 -1v-4a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883v2h-1a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconHexagonLetterGFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterGFilled
});

var IconHexagonLetterHFilled = createReactComponent("filled", "hexagon-letter-h-filled", "IconHexagonLetterHFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.334 5.571a1 1 0 0 0 -1 1v3h-2v-3a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-3h2v3a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconHexagonLetterHFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterHFilled
});

var IconHexagonLetterIFilled = createReactComponent("filled", "hexagon-letter-i-filled", "IconHexagonLetterIFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-1.666 5.571a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconHexagonLetterIFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterIFilled
});

var IconHexagonLetterJFilled = createReactComponent("filled", "hexagon-letter-j-filled", "IconHexagonLetterJFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.334 5.571h-4a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883h3v5a1 1 0 0 1 -1.993 .117l-.007 -.117a1 1 0 0 0 -2 0a3 3 0 0 0 6 0v-6a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconHexagonLetterJFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterJFilled
});

var IconHexagonLetterKFilled = createReactComponent("filled", "hexagon-letter-k-filled", "IconHexagonLetterKFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.864 5.723a1 1 0 0 0 -1.378 .318l-2.152 3.442v-2.912a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-2.914l2.152 3.444a1 1 0 0 0 1.276 .374l.102 -.056l.095 -.068a1 1 0 0 0 .223 -1.31l-2.17 -3.47l2.17 -3.47a1 1 0 0 0 -.318 -1.378", "key": "svg-0" }]]);

var IconHexagonLetterKFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterKFilled
});

var IconHexagonLetterLFilled = createReactComponent("filled", "hexagon-letter-l-filled", "IconHexagonLetterLFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-3.666 5.571a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-3v-7a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconHexagonLetterLFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterLFilled
});

var IconHexagonLetterMFilled = createReactComponent("filled", "hexagon-letter-m-filled", "IconHexagonLetterMFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m2.334 6.571c0 -1.014 -1.336 -1.384 -1.857 -.514l-2.143 3.57l-2.143 -3.57c-.521 -.87 -1.857 -.5 -1.857 .514v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-4.39l1.143 1.904l.074 .108a1 1 0 0 0 1.64 -.108l1.143 -1.904v4.39a1 1 0 0 0 2 0z", "key": "svg-0" }]]);

var IconHexagonLetterMFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterMFilled
});

var IconHexagonLetterNFilled = createReactComponent("filled", "hexagon-letter-n-filled", "IconHexagonLetterNFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-2.772 6.124c-.471 -.944 -1.894 -.608 -1.894 .447v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3.764l2.106 4.211c.471 .944 1.894 .608 1.894 -.447v-8a1 1 0 0 0 -1 -1l-.117 .007a1 1 0 0 0 -.883 .993v3.764z", "key": "svg-0" }]]);

var IconHexagonLetterNFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterNFilled
});

var IconHexagonLetterOFilled = createReactComponent("filled", "hexagon-letter-o-filled", "IconHexagonLetterOFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-1.666 5.571a3 3 0 0 0 -3 3v4a3 3 0 0 0 6 0v-4a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v4a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1 -1", "key": "svg-0" }]]);

var IconHexagonLetterOFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterOFilled
});

var IconHexagonLetterPFilled = createReactComponent("filled", "hexagon-letter-p-filled", "IconHexagonLetterPFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-1.666 5.571h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3h1a3 3 0 0 0 0 -6m0 2a1 1 0 0 1 0 2h-1v-2z", "key": "svg-0" }]]);

var IconHexagonLetterPFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterPFilled
});

var IconHexagonLetterQFilled = createReactComponent("filled", "hexagon-letter-q-filled", "IconHexagonLetterQFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-1.666 5.571a3 3 0 0 0 -3 3v4a3 3 0 0 0 4.168 2.764l.125 -.057a1 1 0 0 0 1.414 -1.414l.057 -.125a3 3 0 0 0 .236 -1.168v-4a3 3 0 0 0 -3 -3m1 7.002h-.059a.996 .996 0 0 0 -.941 .998a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 2 0z", "key": "svg-0" }]]);

var IconHexagonLetterQFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterQFilled
});

var IconHexagonLetterRFilled = createReactComponent("filled", "hexagon-letter-r-filled", "IconHexagonLetterRFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-1.666 5.571h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-2.332l2.2 2.932a1 1 0 0 0 1.4 .2l.096 -.081a1 1 0 0 0 .104 -1.319l-1.903 -2.538l.115 -.037a3.001 3.001 0 0 0 -1.012 -5.825m0 2a1 1 0 0 1 0 2h-1v-2z", "key": "svg-0" }]]);

var IconHexagonLetterRFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterRFilled
});

var IconHexagonLetterSFilled = createReactComponent("filled", "hexagon-letter-s-filled", "IconHexagonLetterSFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-.666 5.571h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2v2h-2a1 1 0 0 0 -2 0a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-2v-2h2l.007 .117a1 1 0 0 0 1.993 -.117a2 2 0 0 0 -2 -2", "key": "svg-0" }]]);

var IconHexagonLetterSFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterSFilled
});

var IconHexagonLetterTFilled = createReactComponent("filled", "hexagon-letter-t-filled", "IconHexagonLetterTFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.334 5.571h-4a1 1 0 1 0 0 2h1v7a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-7h1a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconHexagonLetterTFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterTFilled
});

var IconHexagonLetterUFilled = createReactComponent("filled", "hexagon-letter-u-filled", "IconHexagonLetterUFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.334 5.571a1 1 0 0 0 -1 1v6a1 1 0 0 1 -2 0v-6a1 1 0 0 0 -2 0v6a3 3 0 0 0 6 0v-6a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconHexagonLetterUFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterUFilled
});

var IconHexagonLetterVFilled = createReactComponent("filled", "hexagon-letter-v-filled", "IconHexagonLetterVFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.577 5.6a1 1 0 0 0 -1.213 .728l-1.03 4.118l-1.03 -4.118a1 1 0 1 0 -1.94 .486l2 8c.252 1.01 1.688 1.01 1.94 0l2 -8a1 1 0 0 0 -.727 -1.213", "key": "svg-0" }]]);

var IconHexagonLetterVFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterVFilled
});

var IconHexagonLetterWFilled = createReactComponent("filled", "hexagon-letter-w-filled", "IconHexagonLetterWFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.342 6.447l-.52 4.153l-.56 -1.4c-.319 -.799 -1.41 -.837 -1.803 -.114l-.053 .114l-.561 1.4l-.519 -4.153a1 1 0 0 0 -1 -.876l-.116 .008a1 1 0 0 0 -.868 1.116l1 8c.128 1.025 1.537 1.207 1.92 .247l1.072 -2.678l1.072 2.678c.383 .96 1.792 .778 1.92 -.247l1 -8a1 1 0 0 0 -1.984 -.248", "key": "svg-0" }]]);

var IconHexagonLetterWFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterWFilled
});

var IconHexagonLetterXFilled = createReactComponent("filled", "hexagon-letter-x-filled", "IconHexagonLetterXFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.781 5.677a1 1 0 0 0 -1.341 .447l-1.106 2.21l-1.106 -2.21a1 1 0 0 0 -1.234 -.494l-.107 .047a1 1 0 0 0 -.447 1.341l1.774 3.553l-1.775 3.553a1 1 0 0 0 .345 1.283l.102 .058a1 1 0 0 0 1.341 -.447l1.107 -2.21l1.106 2.21a1 1 0 0 0 1.234 .494l.107 -.047a1 1 0 0 0 .447 -1.341l-1.776 -3.553l1.776 -3.553a1 1 0 0 0 -.345 -1.283z", "key": "svg-0" }]]);

var IconHexagonLetterXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterXFilled
});

var IconHexagonLetterYFilled = createReactComponent("filled", "hexagon-letter-y-filled", "IconHexagonLetterYFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.705 5.643a1 1 0 0 0 -1.3 .557l-1.071 2.678l-1.072 -2.678a1 1 0 0 0 -1.856 .742l1.928 4.823v2.806a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-2.809l1.928 -4.82a1 1 0 0 0 -.45 -1.25z", "key": "svg-0" }]]);

var IconHexagonLetterYFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterYFilled
});

var IconHexagonLetterZFilled = createReactComponent("filled", "hexagon-letter-z-filled", "IconHexagonLetterZFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m.334 5.571h-4a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883h2.382l-3.276 6.553a1 1 0 0 0 .894 1.447h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-2.382l3.276 -6.553a1 1 0 0 0 -.894 -1.447", "key": "svg-0" }]]);

var IconHexagonLetterZFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonLetterZFilled
});

var IconHexagonMinusFilled = createReactComponent("filled", "hexagon-minus-filled", "IconHexagonMinusFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m1.334 9.571h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconHexagonMinusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonMinusFilled
});

var IconHexagonNumber0Filled = createReactComponent("filled", "hexagon-number-0-filled", "IconHexagonNumber0Filled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm1.575 5.586a3 3 0 0 0 -2.995 2.824l-.005 .176v4l.005 .176a3 3 0 0 0 5.99 0l.005 -.176v-4l-.005 -.176a3 3 0 0 0 -2.995 -2.824zm0 2a1 1 0 0 1 .993 .883l.007 .117v4l-.007 .117a1 1 0 0 1 -1.986 0l-.007 -.117v-4l.007 -.117a1 1 0 0 1 .993 -.883z", "key": "svg-0" }]]);

var IconHexagonNumber0Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber0Filled
});

var IconHexagonNumber1Filled = createReactComponent("filled", "hexagon-number-1-filled", "IconHexagonNumber1Filled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm.952 5.803l-.084 .076l-2 2l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l.293 -.293v5.586l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.006 -.114c-.083 -.777 -1.008 -1.16 -1.617 -.67z", "key": "svg-0" }]]);

var IconHexagonNumber1Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber1Filled
});

var IconHexagonNumber2Filled = createReactComponent("filled", "hexagon-number-2-filled", "IconHexagonNumber2Filled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm2.575 5.586h-3l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h3v2h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h3l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-3v-2h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z", "key": "svg-0" }]]);

var IconHexagonNumber2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber2Filled
});

var IconHexagonNumber3Filled = createReactComponent("filled", "hexagon-number-3-filled", "IconHexagonNumber3Filled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm2.575 5.586h-2l-.15 .005a2 2 0 0 0 -1.85 1.995a1 1 0 0 0 1.974 .23l.02 -.113l.006 -.117h2v2h-2l-.133 .007c-1.111 .12 -1.154 1.73 -.128 1.965l.128 .021l.133 .007h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z", "key": "svg-0" }]]);

var IconHexagonNumber3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber3Filled
});

var IconHexagonNumber4Filled = createReactComponent("filled", "hexagon-number-4-filled", "IconHexagonNumber4Filled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm3.575 5.586a1 1 0 0 0 -.993 .883l-.007 .117v3h-2v-3l-.007 -.117a1 1 0 0 0 -1.986 0l-.007 .117v3l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v3l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconHexagonNumber4Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber4Filled
});

var IconHexagonNumber5Filled = createReactComponent("filled", "hexagon-number-5-filled", "IconHexagonNumber5Filled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm3.575 5.586h-4a1 1 0 0 0 -.993 .883l-.007 .117v4a1 1 0 0 0 .883 .993l.117 .007h3v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2a2 2 0 0 0 1.995 -1.85l.005 -.15v-2a2 2 0 0 0 -1.85 -1.995l-.15 -.005h-2v-2h3a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -.883 -.993l-.117 -.007z", "key": "svg-0" }]]);

var IconHexagonNumber5Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber5Filled
});

var IconHexagonNumber6Filled = createReactComponent("filled", "hexagon-number-6-filled", "IconHexagonNumber6Filled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm2.575 5.586h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v6l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006h-2v-2h2l.007 .117a1 1 0 0 0 1.993 -.117a2 2 0 0 0 -1.85 -1.995l-.15 -.005zm0 6v2h-2v-2h2z", "key": "svg-0" }]]);

var IconHexagonNumber6Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber6Filled
});

var IconHexagonNumber7Filled = createReactComponent("filled", "hexagon-number-7-filled", "IconHexagonNumber7Filled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm3.575 5.586h-4l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117l.007 .117a1 1 0 0 0 .876 .876l.117 .007h2.718l-1.688 6.757l-.022 .115a1 1 0 0 0 1.927 .482l.035 -.111l2 -8l.021 -.112a1 1 0 0 0 -.878 -1.125l-.113 -.006z", "key": "svg-0" }]]);

var IconHexagonNumber7Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber7Filled
});

var IconHexagonNumber8Filled = createReactComponent("filled", "hexagon-number-8-filled", "IconHexagonNumber8Filled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm2.575 5.586h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15c.018 .236 .077 .46 .17 .667l.075 .152l.018 .03l-.018 .032c-.133 .24 -.218 .509 -.243 .795l-.007 .174v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 6v2h-2v-2h2zm0 -4v2h-2v-2h2z", "key": "svg-0" }]]);

var IconHexagonNumber8Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber8Filled
});

var IconHexagonNumber9Filled = createReactComponent("filled", "hexagon-number-9-filled", "IconHexagonNumber9Filled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm2.575 5.586h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-6l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 2v2h-2v-2h2z", "key": "svg-0" }]]);

var IconHexagonNumber9Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonNumber9Filled
});

var IconHexagonPlusFilled = createReactComponent("filled", "hexagon-plus-filled", "IconHexagonPlusFilled", [["path", { "d": "M13.666 1.429l6.75 3.98l.096 .063l.093 .078l.106 .074a3.22 3.22 0 0 1 1.284 2.39l.005 .204v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.23 3.23 0 0 1 -1.678 -2.826v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098c1 -.552 2.214 -.552 3.24 .015m-1.666 6.571a1 1 0 0 0 -1 1v2h-2a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 0 1 1h2v2a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-2h2a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-2v-2a1 1 0 0 0 -.883 -.993z", "key": "svg-0" }]]);

var IconHexagonPlusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonPlusFilled
});

var IconHexagonFilled = createReactComponent("filled", "hexagon-filled", "IconHexagonFilled", [["path", { "d": "M10.425 1.414l-6.775 3.996a3.21 3.21 0 0 0 -1.65 2.807v7.285a3.226 3.226 0 0 0 1.678 2.826l6.695 4.237c1.034 .57 2.22 .57 3.2 .032l6.804 -4.302c.98 -.537 1.623 -1.618 1.623 -2.793v-7.284l-.005 -.204a3.223 3.223 0 0 0 -1.284 -2.39l-.107 -.075l-.007 -.007a1.074 1.074 0 0 0 -.181 -.133l-6.776 -3.995a3.33 3.33 0 0 0 -3.216 0z", "key": "svg-0" }]]);

var IconHexagonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHexagonFilled
});

var IconHomeFilled = createReactComponent("filled", "home-filled", "IconHomeFilled", [["path", { "d": "M12.707 2.293l9 9c.63 .63 .184 1.707 -.707 1.707h-1v6a3 3 0 0 1 -3 3h-1v-7a3 3 0 0 0 -2.824 -2.995l-.176 -.005h-2a3 3 0 0 0 -3 3v7h-1a3 3 0 0 1 -3 -3v-6h-1c-.89 0 -1.337 -1.077 -.707 -1.707l9 -9a1 1 0 0 1 1.414 0m.293 11.707a1 1 0 0 1 1 1v7h-4v-7a1 1 0 0 1 .883 -.993l.117 -.007z", "key": "svg-0" }]]);

var IconHomeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHomeFilled
});

var IconHospitalCircleFilled = createReactComponent("filled", "hospital-circle-filled", "IconHospitalCircleFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -20 0l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72m2 5a1 1 0 0 0 -1 1v2.999h-2v-2.999a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-3.001h2v3.001a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconHospitalCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHospitalCircleFilled
});

var IconHourglassFilled = createReactComponent("filled", "hourglass-filled", "IconHourglassFilled", [["path", { "d": "M17 2a2 2 0 0 1 1.995 1.85l.005 .15v2a6.996 6.996 0 0 1 -3.393 6a6.994 6.994 0 0 1 3.388 5.728l.005 .272v2a2 2 0 0 1 -1.85 1.995l-.15 .005h-10a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-2a6.996 6.996 0 0 1 3.393 -6a6.994 6.994 0 0 1 -3.388 -5.728l-.005 -.272v-2a2 2 0 0 1 1.85 -1.995l.15 -.005h10z", "key": "svg-0" }]]);

var IconHourglassFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconHourglassFilled
});

var IconIconsFilled = createReactComponent("filled", "icons-filled", "IconIconsFilled", [["path", { "d": "M4.25 2.603a4.5 4.5 0 1 1 -2.25 3.897l.006 -.229a4.5 4.5 0 0 1 2.244 -3.668", "key": "svg-0" }], ["path", { "d": "M5.632 13.504a1 1 0 0 1 1.736 0l4 7a1 1 0 0 1 -.868 1.496h-8a1 1 0 0 1 -.868 -1.496z", "key": "svg-1" }], ["path", { "d": "M13.293 2.293a1 1 0 0 1 1.414 0l7 7a1 1 0 1 1 -1.414 1.414l-7 -7a1 1 0 0 1 0 -1.414", "key": "svg-2" }], ["path", { "d": "M20.293 2.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1 -1.414 -1.414z", "key": "svg-3" }], ["path", { "d": "M21 13a1 1 0 0 1 1 1v7a1 1 0 0 1 -1 1h-7a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1z", "key": "svg-4" }]]);

var IconIconsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIconsFilled
});

var IconInfoCircleFilled = createReactComponent("filled", "info-circle-filled", "IconInfoCircleFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconInfoCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoCircleFilled
});

var IconInfoHexagonFilled = createReactComponent("filled", "info-hexagon-filled", "IconInfoHexagonFilled", [["path", { "d": "M10.425 1.414a3.33 3.33 0 0 1 3.026 -.097l.19 .097l6.775 3.995l.096 .063l.092 .077l.107 .075a3.224 3.224 0 0 1 1.266 2.188l.018 .202l.005 .204v7.284c0 1.106 -.57 2.129 -1.454 2.693l-.17 .1l-6.803 4.302c-.918 .504 -2.019 .535 -3.004 .068l-.196 -.1l-6.695 -4.237a3.225 3.225 0 0 1 -1.671 -2.619l-.007 -.207v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098zm1.575 9.586h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconInfoHexagonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoHexagonFilled
});

var IconInfoOctagonFilled = createReactComponent("filled", "info-octagon-filled", "IconInfoOctagonFilled", [["path", { "d": "M14.897 1a4 4 0 0 1 2.664 1.016l.165 .156l4.1 4.1a4 4 0 0 1 1.168 2.605l.006 .227v5.794a4 4 0 0 1 -1.016 2.664l-.156 .165l-4.1 4.1a4 4 0 0 1 -2.603 1.168l-.227 .006h-5.795a3.999 3.999 0 0 1 -2.664 -1.017l-.165 -.156l-4.1 -4.1a4 4 0 0 1 -1.168 -2.604l-.006 -.227v-5.794a4 4 0 0 1 1.016 -2.664l.156 -.165l4.1 -4.1a4 4 0 0 1 2.605 -1.168l.227 -.006h5.793zm-2.897 10h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconInfoOctagonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoOctagonFilled
});

var IconInfoSquareRoundedFilled = createReactComponent("filled", "info-square-rounded-filled", "IconInfoSquareRoundedFilled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconInfoSquareRoundedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoSquareRoundedFilled
});

var IconInfoSquareFilled = createReactComponent("filled", "info-square-filled", "IconInfoSquareFilled", [["path", { "d": "M19 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h14zm-7 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconInfoSquareFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoSquareFilled
});

var IconInfoTriangleFilled = createReactComponent("filled", "info-triangle-filled", "IconInfoTriangleFilled", [["path", { "d": "M12 1.67c.955 0 1.845 .467 2.39 1.247l.105 .16l8.114 13.548a2.914 2.914 0 0 1 -2.307 4.363l-.195 .008h-16.225a2.914 2.914 0 0 1 -2.582 -4.2l.099 -.185l8.11 -13.538a2.914 2.914 0 0 1 2.491 -1.403zm0 9.33h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconInfoTriangleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInfoTriangleFilled
});

var IconInnerShadowBottomLeftFilled = createReactComponent("filled", "inner-shadow-bottom-left-filled", "IconInnerShadowBottomLeftFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm-6 9a1 1 0 0 0 -1 1a7 7 0 0 0 7 7a1 1 0 0 0 0 -2a5 5 0 0 1 -5 -5a1 1 0 0 0 -1 -1z", "key": "svg-0" }]]);

var IconInnerShadowBottomLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowBottomLeftFilled
});

var IconInnerShadowBottomRightFilled = createReactComponent("filled", "inner-shadow-bottom-right-filled", "IconInnerShadowBottomRightFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm6 9a1 1 0 0 0 -1 1a5 5 0 0 1 -5 5a1 1 0 0 0 0 2a7 7 0 0 0 7 -7a1 1 0 0 0 -1 -1z", "key": "svg-0" }]]);

var IconInnerShadowBottomRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowBottomRightFilled
});

var IconInnerShadowBottomFilled = createReactComponent("filled", "inner-shadow-bottom-filled", "IconInnerShadowBottomFilled", [["path", { "d": "M5.144 4.72c3.92 -3.695 10.093 -3.625 13.927 .209c3.905 3.905 3.905 10.237 0 14.142c-3.905 3.905 -10.237 3.905 -14.142 0c-3.905 -3.905 -3.905 -10.237 0 -14.142zm3.32 10.816a1 1 0 1 0 -1.414 1.414a7 7 0 0 0 9.9 0a1 1 0 0 0 -1.414 -1.414a5 5 0 0 1 -7.072 0z", "key": "svg-0" }]]);

var IconInnerShadowBottomFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowBottomFilled
});

var IconInnerShadowLeftFilled = createReactComponent("filled", "inner-shadow-left-filled", "IconInnerShadowLeftFilled", [["path", { "d": "M4.929 4.929c3.905 -3.905 10.237 -3.905 14.142 0c3.905 3.905 3.905 10.237 0 14.142c-3.905 3.905 -10.237 3.905 -14.142 0c-3.905 -3.905 -3.905 -10.237 0 -14.142zm3.535 2.121a1 1 0 0 0 -1.414 0a7 7 0 0 0 0 9.9a1 1 0 1 0 1.414 -1.414a5 5 0 0 1 0 -7.072a1 1 0 0 0 0 -1.414z", "key": "svg-0" }]]);

var IconInnerShadowLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowLeftFilled
});

var IconInnerShadowRightFilled = createReactComponent("filled", "inner-shadow-right-filled", "IconInnerShadowRightFilled", [["path", { "d": "M4.929 4.929c3.905 -3.905 10.237 -3.905 14.142 0c3.905 3.905 3.905 10.237 0 14.142c-3.905 3.905 -10.237 3.905 -14.142 0c-3.905 -3.905 -3.905 -10.237 0 -14.142zm12.02 2.121a1 1 0 0 0 -1.413 1.414a5 5 0 0 1 0 7.072a1 1 0 0 0 1.414 1.414a7 7 0 0 0 0 -9.9z", "key": "svg-0" }]]);

var IconInnerShadowRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowRightFilled
});

var IconInnerShadowTopLeftFilled = createReactComponent("filled", "inner-shadow-top-left-filled", "IconInnerShadowTopLeftFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm0 3a7 7 0 0 0 -7 7a1 1 0 0 0 2 0a5 5 0 0 1 5 -5a1 1 0 0 0 0 -2z", "key": "svg-0" }]]);

var IconInnerShadowTopLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowTopLeftFilled
});

var IconInnerShadowTopRightFilled = createReactComponent("filled", "inner-shadow-top-right-filled", "IconInnerShadowTopRightFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm0 3a1 1 0 0 0 0 2a5 5 0 0 1 5 5a1 1 0 0 0 2 0a7 7 0 0 0 -7 -7z", "key": "svg-0" }]]);

var IconInnerShadowTopRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowTopRightFilled
});

var IconInnerShadowTopFilled = createReactComponent("filled", "inner-shadow-top-filled", "IconInnerShadowTopFilled", [["path", { "d": "M4.929 4.929c3.905 -3.905 10.237 -3.905 14.142 0c3.905 3.905 3.905 10.237 0 14.142c-3.905 3.905 -10.237 3.905 -14.142 0c-3.905 -3.905 -3.905 -10.237 0 -14.142zm12.02 2.121a7 7 0 0 0 -9.899 0a1 1 0 0 0 1.414 1.414a5 5 0 0 1 7.072 0a1 1 0 0 0 1.414 -1.414z", "key": "svg-0" }]]);

var IconInnerShadowTopFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconInnerShadowTopFilled
});

var IconIroning1Filled = createReactComponent("filled", "ironing-1-filled", "IconIroning1Filled", [["path", { "d": "M16.459 5a4 4 0 0 1 3.945 3.343l1.387 8.329a2 2 0 0 1 -1.971 2.328h-16.82a1 1 0 0 1 -1 -1a8 8 0 0 1 8 -8h8.652l-.22 -1.329a2 2 0 0 0 -1.811 -1.665l-.162 -.006h-7.459a1 1 0 1 1 0 -2zm-4.449 9h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconIroning1Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIroning1Filled
});

var IconIroning2Filled = createReactComponent("filled", "ironing-2-filled", "IconIroning2Filled", [["path", { "d": "M16.459 5a4 4 0 0 1 3.945 3.343l1.387 8.329a2 2 0 0 1 -1.971 2.328h-16.82a1 1 0 0 1 -1 -1a8 8 0 0 1 8 -8h8.652l-.22 -1.329a2 2 0 0 0 -1.811 -1.665l-.162 -.006h-7.459a1 1 0 1 1 0 -2zm-6.449 9h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m4 0h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconIroning2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIroning2Filled
});

var IconIroning3Filled = createReactComponent("filled", "ironing-3-filled", "IconIroning3Filled", [["path", { "d": "M16.459 5a4 4 0 0 1 3.945 3.343l1.387 8.329a2 2 0 0 1 -1.971 2.328h-16.82a1 1 0 0 1 -1 -1a8 8 0 0 1 8 -8h8.652l-.22 -1.329a2 2 0 0 0 -1.811 -1.665l-.162 -.006h-7.459a1 1 0 1 1 0 -2zm-4.449 9h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m-3 0h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m6 0h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconIroning3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIroning3Filled
});

var IconIroningSteamFilled = createReactComponent("filled", "ironing-steam-filled", "IconIroningSteamFilled", [["path", { "d": "M12 18a1 1 0 0 1 1 1v2a1 1 0 0 1 -2 0v-2a1 1 0 0 1 1 -1", "key": "svg-0" }], ["path", { "d": "M16.459 3a4 4 0 0 1 3.945 3.343l.577 3.464l.81 4.865a2 2 0 0 1 -1.971 2.328h-16.82a1 1 0 0 1 -1 -1a8 8 0 0 1 8 -8h8.652l-.22 -1.329a2 2 0 0 0 -1.811 -1.665l-.162 -.006h-7.459a1 1 0 1 1 0 -2z", "key": "svg-1" }], ["path", { "d": "M7.106 18.553a1 1 0 0 1 1.788 .894l-1 2a1 1 0 0 1 -1.788 -.894z", "key": "svg-2" }], ["path", { "d": "M15.553 18.106a1 1 0 0 1 1.341 .447l1 2a1 1 0 0 1 -1.788 .894l-1 -2a1 1 0 0 1 .447 -1.341", "key": "svg-3" }]]);

var IconIroningSteamFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIroningSteamFilled
});

var IconIroningFilled = createReactComponent("filled", "ironing-filled", "IconIroningFilled", [["path", { "d": "M16.459 5a4 4 0 0 1 3.945 3.343l.577 3.464l.81 4.865a2 2 0 0 1 -1.971 2.328h-16.82a1 1 0 0 1 -1 -1a8 8 0 0 1 8 -8h8.652l-.22 -1.329a2 2 0 0 0 -1.811 -1.665l-.162 -.006h-7.459a1 1 0 1 1 0 -2z", "key": "svg-0" }]]);

var IconIroningFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconIroningFilled
});

var IconJetpackFilled = createReactComponent("filled", "jetpack-filled", "IconJetpackFilled", [["path", { "d": "M17 2a4 4 0 0 1 4 4v7a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-1h-2v1a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-7a4 4 0 0 1 8 0v1h2v-1a4 4 0 0 1 4 -4m-4 8v-1h-2v1zm-4 5a1 1 0 0 1 1 1c0 2.623 -.787 4.59 -2.4 5.8a1 1 0 0 1 -1.2 0c-1.613 -1.21 -2.4 -3.177 -2.4 -5.8a1 1 0 0 1 2 0c0 1.532 .308 2.684 .906 3.498l.094 .119l.094 -.12c.558 -.759 .864 -1.813 .902 -3.196l.004 -.301a1 1 0 0 1 1 -1m10 0a1 1 0 0 1 1 1c0 2.623 -.787 4.59 -2.4 5.8a1 1 0 0 1 -1.2 0c-1.613 -1.21 -2.4 -3.177 -2.4 -5.8a1 1 0 0 1 2 0c0 1.532 .308 2.684 .906 3.498l.094 .119l.094 -.12c.558 -.759 .864 -1.813 .902 -3.196l.004 -.301a1 1 0 0 1 1 -1", "key": "svg-0" }]]);

var IconJetpackFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconJetpackFilled
});

var IconJewishStarFilled = createReactComponent("filled", "jewish-star-filled", "IconJewishStarFilled", [["path", { "d": "M8.433 6h-5.433l-.114 .006a1 1 0 0 0 -.743 1.508l2.69 4.486l-2.69 4.486l-.054 .1a1 1 0 0 0 .911 1.414h5.434l2.709 4.514l.074 .108a1 1 0 0 0 1.64 -.108l2.708 -4.514h5.435l.114 -.006a1 1 0 0 0 .743 -1.508l-2.691 -4.486l2.691 -4.486l.054 -.1a1 1 0 0 0 -.911 -1.414h-5.434l-2.709 -4.514a1 1 0 0 0 -1.714 0l-2.71 4.514z", "key": "svg-0" }]]);

var IconJewishStarFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconJewishStarFilled
});

var IconKeyFilled = createReactComponent("filled", "key-filled", "IconKeyFilled", [["path", { "d": "M14.52 2c1.029 0 2.015 .409 2.742 1.136l3.602 3.602a3.877 3.877 0 0 1 0 5.483l-2.643 2.643a3.88 3.88 0 0 1 -4.941 .452l-.105 -.078l-5.882 5.883a3 3 0 0 1 -1.68 .843l-.22 .027l-.221 .009h-1.172c-1.014 0 -1.867 -.759 -1.991 -1.823l-.009 -.177v-1.172c0 -.704 .248 -1.386 .73 -1.96l.149 -.161l.414 -.414a1 1 0 0 1 .707 -.293h1v-1a1 1 0 0 1 .883 -.993l.117 -.007h1v-1a1 1 0 0 1 .206 -.608l.087 -.1l1.468 -1.469l-.076 -.103a3.9 3.9 0 0 1 -.678 -1.963l-.007 -.236c0 -1.029 .409 -2.015 1.136 -2.742l2.643 -2.643a3.88 3.88 0 0 1 2.741 -1.136m.495 5h-.02a2 2 0 1 0 0 4h.02a2 2 0 1 0 0 -4", "key": "svg-0" }]]);

var IconKeyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyFilled
});

var IconKeyboardFilled = createReactComponent("filled", "keyboard-filled", "IconKeyboardFilled", [["path", { "d": "M20 5a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-16a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3zm-14 8a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m12 0a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m-7.998 0a1 1 0 0 0 -.004 2l4 .01a1 1 0 0 0 .005 -2zm-4.002 -4a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m4 0a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m4 0a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m4 0a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconKeyboardFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyboardFilled
});

var IconKeyframeAlignCenterFilled = createReactComponent("filled", "keyframe-align-center-filled", "IconKeyframeAlignCenterFilled", [["path", { "d": "M12 19a1 1 0 0 1 .993 .883l.007 .117v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M12 6c-.629 0 -1.214 .301 -1.606 .807l-2.908 3.748a2.395 2.395 0 0 0 -.011 2.876l2.919 3.762c.39 .505 .977 .807 1.606 .807c.629 0 1.214 -.301 1.606 -.807l2.908 -3.748a2.395 2.395 0 0 0 .011 -2.876l-2.919 -3.762a2.032 2.032 0 0 0 -1.606 -.807z", "key": "svg-1" }], ["path", { "d": "M12 1a1 1 0 0 1 .993 .883l.007 .117v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M5 11a1 1 0 0 1 .117 1.993l-.117 .007h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2z", "key": "svg-3" }], ["path", { "d": "M21 11a1 1 0 0 1 .117 1.993l-.117 .007h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2z", "key": "svg-4" }]]);

var IconKeyframeAlignCenterFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyframeAlignCenterFilled
});

var IconKeyframeAlignHorizontalFilled = createReactComponent("filled", "keyframe-align-horizontal-filled", "IconKeyframeAlignHorizontalFilled", [["path", { "d": "M12 6c-.629 0 -1.214 .301 -1.606 .807l-2.908 3.748a2.395 2.395 0 0 0 -.011 2.876l2.919 3.762c.39 .505 .977 .807 1.606 .807c.629 0 1.214 -.301 1.606 -.807l2.908 -3.748a2.395 2.395 0 0 0 .011 -2.876l-2.919 -3.762a2.032 2.032 0 0 0 -1.606 -.807z", "key": "svg-0" }], ["path", { "d": "M5 11a1 1 0 0 1 .117 1.993l-.117 .007h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2z", "key": "svg-1" }], ["path", { "d": "M21 11a1 1 0 0 1 .117 1.993l-.117 .007h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2z", "key": "svg-2" }]]);

var IconKeyframeAlignHorizontalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyframeAlignHorizontalFilled
});

var IconKeyframeAlignVerticalFilled = createReactComponent("filled", "keyframe-align-vertical-filled", "IconKeyframeAlignVerticalFilled", [["path", { "d": "M12 1a1 1 0 0 1 .993 .883l.007 .117v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M12 6c-.629 0 -1.214 .301 -1.606 .807l-2.908 3.748a2.395 2.395 0 0 0 -.011 2.876l2.919 3.762c.39 .505 .977 .807 1.606 .807c.629 0 1.214 -.301 1.606 -.807l2.908 -3.748a2.395 2.395 0 0 0 .011 -2.876l-2.919 -3.762a2.032 2.032 0 0 0 -1.606 -.807z", "key": "svg-1" }], ["path", { "d": "M12 19a1 1 0 0 1 .993 .883l.007 .117v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a1 1 0 0 1 1 -1z", "key": "svg-2" }]]);

var IconKeyframeAlignVerticalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyframeAlignVerticalFilled
});

var IconKeyframeFilled = createReactComponent("filled", "keyframe-filled", "IconKeyframeFilled", [["path", { "d": "M12 4a2.599 2.599 0 0 0 -2 .957l-4.355 5.24a2.847 2.847 0 0 0 -.007 3.598l4.368 5.256c.499 .6 1.225 .949 1.994 .949a2.599 2.599 0 0 0 2 -.957l4.355 -5.24a2.847 2.847 0 0 0 .007 -3.598l-4.368 -5.256a2.593 2.593 0 0 0 -1.994 -.949z", "key": "svg-0" }]]);

var IconKeyframeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyframeFilled
});

var IconKeyframesFilled = createReactComponent("filled", "keyframes-filled", "IconKeyframesFilled", [["path", { "d": "M8 4a2.599 2.599 0 0 0 -2 .957l-4.355 5.24a2.847 2.847 0 0 0 -.007 3.598l4.368 5.256c.499 .6 1.224 .949 1.994 .949a2.599 2.599 0 0 0 2 -.957l4.355 -5.24a2.847 2.847 0 0 0 .007 -3.598l-4.368 -5.256a2.593 2.593 0 0 0 -1.994 -.949z", "key": "svg-0" }], ["path", { "d": "M16.382 4.214a1 1 0 0 1 1.32 .074l.084 .094l4.576 5.823c.808 .993 .848 2.396 .13 3.419l-.12 .158l-4.586 5.836a1 1 0 0 1 -1.644 -1.132l.072 -.104l4.596 -5.85a.845 .845 0 0 0 .06 -.978l-.07 -.1l-4.586 -5.836a1 1 0 0 1 .168 -1.404z", "key": "svg-1" }], ["path", { "d": "M12.382 4.214a1 1 0 0 1 1.32 .074l.084 .094l4.576 5.823c.808 .993 .848 2.396 .13 3.419l-.12 .158l-4.586 5.836a1 1 0 0 1 -1.644 -1.132l.072 -.104l4.596 -5.85a.845 .845 0 0 0 .06 -.978l-.07 -.1l-4.586 -5.836a1 1 0 0 1 .168 -1.404z", "key": "svg-2" }]]);

var IconKeyframesFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconKeyframesFilled
});

var IconLabelImportantFilled = createReactComponent("filled", "label-important-filled", "IconLabelImportantFilled", [["path", { "d": "M16.52 6a2 2 0 0 1 1.561 .75l3.7 4.625a1 1 0 0 1 0 1.25l-3.7 4.624a2 2 0 0 1 -1.561 .751h-12.52a1 1 0 0 1 -.78 -1.625l3.5 -4.375l-3.5 -4.375a1 1 0 0 1 .668 -1.62l.112 -.005z", "key": "svg-0" }]]);

var IconLabelImportantFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLabelImportantFilled
});

var IconLabelFilled = createReactComponent("filled", "label-filled", "IconLabelFilled", [["path", { "d": "M16.52 6a2 2 0 0 1 1.561 .75l3.7 4.625a1 1 0 0 1 0 1.25l-3.7 4.624a2 2 0 0 1 -1.561 .751h-10.52a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

var IconLabelFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLabelFilled
});

var IconLassoPolygonFilled = createReactComponent("filled", "lasso-polygon-filled", "IconLassoPolygonFilled", [["path", { "d": "M5.581 2.186l6.566 4.69l7.502 -2.812a1 1 0 0 1 1.326 .714l.019 .112l1 9a1 1 0 0 1 -.678 1.059l-9 3a1 1 0 0 1 -.553 .023l-4.434 -1.082a3 3 0 0 1 -1.287 .923c.095 .986 .374 1.9 .826 2.69a1 1 0 0 1 -1.736 .993c-.624 -1.09 -.99 -2.335 -1.098 -3.656a3 3 0 0 1 -2.034 -2.84l.005 -.176a3 3 0 0 1 .86 -1.932l-.818 -2.59a1 1 0 0 1 -.009 -.577l2 -7a1 1 0 0 1 1.543 -.539m-.009 2.451l-1.528 5.348l.642 2.031q .155 -.016 .314 -.016a3 3 0 0 1 3 2.995l3.957 .965l7.96 -2.654l-.769 -6.919l-6.797 2.55a1 1 0 0 1 -.827 -.058l-.105 -.065z", "key": "svg-0" }]]);

var IconLassoPolygonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLassoPolygonFilled
});

var IconLaurelWreathFilled = createReactComponent("filled", "laurel-wreath-filled", "IconLaurelWreathFilled", [["path", { "d": "M16.956 2.057c.355 .124 .829 .375 1.303 .796a3.77 3.77 0 0 1 1.246 2.204c.173 .989 -.047 1.894 -.519 2.683l-.123 .194q -.097 .147 -.196 .272q .066 .234 .117 .471q .26 -.178 .545 -.307c.851 -.389 1.727 -.442 2.527 -.306q .226 .04 .346 .076a1 1 0 0 1 .689 .712l.029 .13q .015 .08 .03 .18a4.45 4.45 0 0 1 -.324 2.496a3.94 3.94 0 0 1 -1.71 1.85l-.242 .12a4.23 4.23 0 0 1 -2.234 .349a9 9 0 0 1 -.443 1.023c.37 .016 .748 .093 1.128 .24c.732 .28 1.299 .758 1.711 1.367a3.95 3.95 0 0 1 .654 1.613a1 1 0 0 1 -.356 .917a3.8 3.8 0 0 1 -.716 .443c-.933 .455 -1.978 .588 -3.043 .179l-.032 -.015l-.205 -.086a3.6 3.6 0 0 1 -1.33 -1.069l-.143 -.197a4 4 0 0 1 -.26 -.433a6 6 0 0 1 -.927 .511q .18 .262 .337 .56a7.4 7.4 0 0 1 .66 1.747a1 1 0 0 1 -1.95 .444l-.028 -.11a6 6 0 0 0 -.449 -1.143c-.342 -.645 -.71 -.968 -1.048 -.968s-.706 .323 -1.048 .969a5.6 5.6 0 0 0 -.367 .874l-.082 .269l-.028 .11a1 1 0 0 1 -1.95 -.444a7.3 7.3 0 0 1 .66 -1.747q .158 -.298 .337 -.561a6.4 6.4 0 0 1 -.93 -.508a4 4 0 0 1 -.256 .43c-.366 .541 -.855 .98 -1.473 1.267l-.238 .1c-.994 .382 -1.97 .292 -2.855 -.091l-.188 -.087a3.8 3.8 0 0 1 -.716 -.443a1 1 0 0 1 -.356 -.917a3.95 3.95 0 0 1 .654 -1.613a3.6 3.6 0 0 1 1.71 -1.368c.38 -.146 .758 -.223 1.13 -.24a9 9 0 0 1 -.445 -1.023a4.23 4.23 0 0 1 -2.233 -.348a4 4 0 0 1 -.916 -.587l-.207 -.191a4 4 0 0 1 -.724 -.977l-.105 -.216a4.45 4.45 0 0 1 -.265 -2.806a1 1 0 0 1 .69 -.712q .119 -.036 .345 -.076c.801 -.135 1.678 -.082 2.53 .308q .283 .129 .545 .304q .048 -.235 .112 -.47a5 5 0 0 1 -.194 -.272c-.556 -.832 -.83 -1.806 -.642 -2.877l.05 -.242a3.75 3.75 0 0 1 1.027 -1.803l.169 -.159a4 4 0 0 1 1.303 -.796a1 1 0 0 1 .975 .178c.2 .168 .462 .446 .719 .83c.556 .833 .83 1.807 .642 2.878a3.77 3.77 0 0 1 -1.246 2.204c-.303 .27 -.607 .47 -.879 .61a7.5 7.5 0 0 0 -.255 1.971c0 3.502 2.285 6.272 5 6.272s5 -2.77 5 -6.276a7.6 7.6 0 0 0 -.253 -1.967a4.3 4.3 0 0 1 -.881 -.61a3.77 3.77 0 0 1 -1.246 -2.204c-.188 -1.07 .086 -2.045 .642 -2.877c.257 -.385 .52 -.663 .72 -.831a1 1 0 0 1 .974 -.178", "key": "svg-0" }]]);

var IconLaurelWreathFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLaurelWreathFilled
});

var IconLayout2Filled = createReactComponent("filled", "layout-2-filled", "IconLayout2Filled", [["path", { "d": "M8 3a3 3 0 0 1 3 3v1a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-1a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M8 12a3 3 0 0 1 3 3v3a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-3a3 3 0 0 1 3 -3z", "key": "svg-1" }], ["path", { "d": "M18 3a3 3 0 0 1 3 3v3a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-3a3 3 0 0 1 3 -3z", "key": "svg-2" }], ["path", { "d": "M18 14a3 3 0 0 1 3 3v1a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-1a3 3 0 0 1 3 -3z", "key": "svg-3" }]]);

var IconLayout2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayout2Filled
});

var IconLayoutAlignBottomFilled = createReactComponent("filled", "layout-align-bottom-filled", "IconLayoutAlignBottomFilled", [["path", { "d": "M20 19a1 1 0 0 1 0 2h-16a1 1 0 0 1 0 -2z", "key": "svg-0" }], ["path", { "d": "M13 3a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

var IconLayoutAlignBottomFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutAlignBottomFilled
});

var IconLayoutAlignCenterFilled = createReactComponent("filled", "layout-align-center-filled", "IconLayoutAlignCenterFilled", [["path", { "d": "M12 3a1 1 0 0 1 1 1v4h3a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-3v4a1 1 0 0 1 -2 0v-4h-3a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h3v-4a1 1 0 0 1 1 -1", "key": "svg-0" }]]);

var IconLayoutAlignCenterFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutAlignCenterFilled
});

var IconLayoutAlignLeftFilled = createReactComponent("filled", "layout-align-left-filled", "IconLayoutAlignLeftFilled", [["path", { "d": "M4 3a1 1 0 0 1 1 1v16a1 1 0 0 1 -2 0v-16a1 1 0 0 1 1 -1", "key": "svg-0" }], ["path", { "d": "M18 8a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

var IconLayoutAlignLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutAlignLeftFilled
});

var IconLayoutAlignMiddleFilled = createReactComponent("filled", "layout-align-middle-filled", "IconLayoutAlignMiddleFilled", [["path", { "d": "M13 5a3 3 0 0 1 3 3v3h4a1 1 0 0 1 0 2h-4v3a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-3h-4a1 1 0 0 1 0 -2h4v-3a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

var IconLayoutAlignMiddleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutAlignMiddleFilled
});

var IconLayoutAlignRightFilled = createReactComponent("filled", "layout-align-right-filled", "IconLayoutAlignRightFilled", [["path", { "d": "M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1 -2 0v-16a1 1 0 0 1 1 -1", "key": "svg-0" }], ["path", { "d": "M14 8a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

var IconLayoutAlignRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutAlignRightFilled
});

var IconLayoutAlignTopFilled = createReactComponent("filled", "layout-align-top-filled", "IconLayoutAlignTopFilled", [["path", { "d": "M20 3a1 1 0 0 1 0 2h-16a1 1 0 1 1 0 -2z", "key": "svg-0" }], ["path", { "d": "M13 7a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

var IconLayoutAlignTopFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutAlignTopFilled
});

var IconLayoutBottombarCollapseFilled = createReactComponent("filled", "layout-bottombar-collapse-filled", "IconLayoutBottombarCollapseFilled", [["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm0 2h-12a1 1 0 0 0 -.993 .883l-.007 .117v9h14v-9a1 1 0 0 0 -.883 -.993l-.117 -.007zm-7.387 3.21l.094 .083l1.293 1.292l1.293 -1.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 .083 1.32l-.083 .094l-2 2a1 1 0 0 1 -1.32 .083l-.094 -.083l-2 -2a1 1 0 0 1 1.32 -1.497z", "key": "svg-0" }]]);

var IconLayoutBottombarCollapseFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutBottombarCollapseFilled
});

var IconLayoutBottombarExpandFilled = createReactComponent("filled", "layout-bottombar-expand-filled", "IconLayoutBottombarExpandFilled", [["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm0 2h-12a1 1 0 0 0 -.993 .883l-.007 .117v9h14v-9a1 1 0 0 0 -.883 -.993l-.117 -.007zm-5.387 3.21l.094 .083l2 2a1 1 0 0 1 -1.32 1.497l-.094 -.083l-1.293 -1.292l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 -.083 -1.32l.083 -.094l2 -2a1 1 0 0 1 1.32 -.083z", "key": "svg-0" }]]);

var IconLayoutBottombarExpandFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutBottombarExpandFilled
});

var IconLayoutBottombarFilled = createReactComponent("filled", "layout-bottombar-filled", "IconLayoutBottombarFilled", [["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm0 2h-12a1 1 0 0 0 -.993 .883l-.007 .117v9h14v-9a1 1 0 0 0 -.883 -.993l-.117 -.007z", "key": "svg-0" }]]);

var IconLayoutBottombarFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutBottombarFilled
});

var IconLayoutCardsFilled = createReactComponent("filled", "layout-cards-filled", "IconLayoutCardsFilled", [["path", { "d": "M8 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M18 3a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

var IconLayoutCardsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutCardsFilled
});

var IconLayoutDashboardFilled = createReactComponent("filled", "layout-dashboard-filled", "IconLayoutDashboardFilled", [["path", { "d": "M9 3a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2zm0 12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-2a2 2 0 0 1 2 -2zm10 -4a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2zm0 -8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-2a2 2 0 0 1 2 -2z", "key": "svg-0" }]]);

var IconLayoutDashboardFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutDashboardFilled
});

var IconLayoutDistributeHorizontalFilled = createReactComponent("filled", "layout-distribute-horizontal-filled", "IconLayoutDistributeHorizontalFilled", [["path", { "d": "M20 3a1 1 0 0 1 0 2h-16a1 1 0 1 1 0 -2z", "key": "svg-0" }], ["path", { "d": "M20 19a1 1 0 0 1 0 2h-16a1 1 0 0 1 0 -2z", "key": "svg-1" }], ["path", { "d": "M16 8a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z", "key": "svg-2" }]]);

var IconLayoutDistributeHorizontalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutDistributeHorizontalFilled
});

var IconLayoutDistributeVerticalFilled = createReactComponent("filled", "layout-distribute-vertical-filled", "IconLayoutDistributeVerticalFilled", [["path", { "d": "M4 3a1 1 0 0 1 1 1v16a1 1 0 0 1 -2 0v-16a1 1 0 0 1 1 -1", "key": "svg-0" }], ["path", { "d": "M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1 -2 0v-16a1 1 0 0 1 1 -1", "key": "svg-1" }], ["path", { "d": "M13 5a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z", "key": "svg-2" }]]);

var IconLayoutDistributeVerticalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutDistributeVerticalFilled
});

var IconLayoutGridFilled = createReactComponent("filled", "layout-grid-filled", "IconLayoutGridFilled", [["path", { "d": "M9 3a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M19 3a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z", "key": "svg-1" }], ["path", { "d": "M9 13a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z", "key": "svg-2" }], ["path", { "d": "M19 13a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z", "key": "svg-3" }]]);

var IconLayoutGridFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutGridFilled
});

var IconLayoutKanbanFilled = createReactComponent("filled", "layout-kanban-filled", "IconLayoutKanbanFilled", [["path", { "d": "M10 3a1 1 0 0 1 0 2h-6a1 1 0 1 1 0 -2z", "key": "svg-0" }], ["path", { "d": "M20 3a1 1 0 0 1 0 2h-6a1 1 0 0 1 0 -2z", "key": "svg-1" }], ["path", { "d": "M8 7a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z", "key": "svg-2" }], ["path", { "d": "M18 7a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z", "key": "svg-3" }]]);

var IconLayoutKanbanFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutKanbanFilled
});

var IconLayoutListFilled = createReactComponent("filled", "layout-list-filled", "IconLayoutListFilled", [["path", { "d": "M18 3a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M18 13a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

var IconLayoutListFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutListFilled
});

var IconLayoutNavbarCollapseFilled = createReactComponent("filled", "layout-navbar-collapse-filled", "IconLayoutNavbarCollapseFilled", [["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm1 6h-14v9a1 1 0 0 0 .883 .993l.117 .007h12a1 1 0 0 0 .993 -.883l.007 -.117v-9zm-6.387 3.21l.094 .083l2 2a1 1 0 0 1 -1.32 1.497l-.094 -.083l-1.293 -1.292l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 -.083 -1.32l.083 -.094l2 -2a1 1 0 0 1 1.32 -.083z", "key": "svg-0" }]]);

var IconLayoutNavbarCollapseFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutNavbarCollapseFilled
});

var IconLayoutNavbarExpandFilled = createReactComponent("filled", "layout-navbar-expand-filled", "IconLayoutNavbarExpandFilled", [["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm1 6h-14v9a1 1 0 0 0 .883 .993l.117 .007h12a1 1 0 0 0 .993 -.883l.007 -.117v-9zm-8.387 3.21l.094 .083l1.293 1.292l1.293 -1.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 .083 1.32l-.083 .094l-2 2a1 1 0 0 1 -1.32 .083l-.094 -.083l-2 -2a1 1 0 0 1 1.32 -1.497z", "key": "svg-0" }]]);

var IconLayoutNavbarExpandFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutNavbarExpandFilled
});

var IconLayoutNavbarFilled = createReactComponent("filled", "layout-navbar-filled", "IconLayoutNavbarFilled", [["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm1 6h-14v9a1 1 0 0 0 .883 .993l.117 .007h12a1 1 0 0 0 .993 -.883l.007 -.117v-9z", "key": "svg-0" }]]);

var IconLayoutNavbarFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutNavbarFilled
});

var IconLayoutSidebarLeftCollapseFilled = createReactComponent("filled", "layout-sidebar-left-collapse-filled", "IconLayoutSidebarLeftCollapseFilled", [["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm0 2h-9v14h9a1 1 0 0 0 .993 -.883l.007 -.117v-12a1 1 0 0 0 -.883 -.993l-.117 -.007zm-2.293 4.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.292 1.293l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.32 .083l-.094 -.083l-2 -2a1 1 0 0 1 -.083 -1.32l.083 -.094l2 -2a1 1 0 0 1 1.414 0z", "key": "svg-0" }]]);

var IconLayoutSidebarLeftCollapseFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarLeftCollapseFilled
});

var IconLayoutSidebarLeftExpandFilled = createReactComponent("filled", "layout-sidebar-left-expand-filled", "IconLayoutSidebarLeftExpandFilled", [["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm0 2h-9v14h9a1 1 0 0 0 .993 -.883l.007 -.117v-12a1 1 0 0 0 -.883 -.993l-.117 -.007zm-4.387 4.21l.094 .083l2 2a1 1 0 0 1 .083 1.32l-.083 .094l-2 2a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.292 -1.293l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083z", "key": "svg-0" }]]);

var IconLayoutSidebarLeftExpandFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarLeftExpandFilled
});

var IconLayoutSidebarRightCollapseFilled = createReactComponent("filled", "layout-sidebar-right-collapse-filled", "IconLayoutSidebarRightCollapseFilled", [["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm-3 2h-9a1 1 0 0 0 -.993 .883l-.007 .117v12a1 1 0 0 0 .883 .993l.117 .007h9v-14zm-5.387 4.21l.094 .083l2 2a1 1 0 0 1 .083 1.32l-.083 .094l-2 2a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.292 -1.293l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083z", "key": "svg-0" }]]);

var IconLayoutSidebarRightCollapseFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarRightCollapseFilled
});

var IconLayoutSidebarRightExpandFilled = createReactComponent("filled", "layout-sidebar-right-expand-filled", "IconLayoutSidebarRightExpandFilled", [["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm-3 2h-9a1 1 0 0 0 -.993 .883l-.007 .117v12a1 1 0 0 0 .883 .993l.117 .007h9v-14zm-3.293 4.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.292 1.293l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.32 .083l-.094 -.083l-2 -2a1 1 0 0 1 -.083 -1.32l.083 -.094l2 -2a1 1 0 0 1 1.414 0z", "key": "svg-0" }]]);

var IconLayoutSidebarRightExpandFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarRightExpandFilled
});

var IconLayoutSidebarRightFilled = createReactComponent("filled", "layout-sidebar-right-filled", "IconLayoutSidebarRightFilled", [["path", { "d": "M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3zm8 -16h-8a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8z", "key": "svg-0" }]]);

var IconLayoutSidebarRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarRightFilled
});

var IconLayoutSidebarFilled = createReactComponent("filled", "layout-sidebar-filled", "IconLayoutSidebarFilled", [["path", { "d": "M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3zm12 -16h-8v14h8a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconLayoutSidebarFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutSidebarFilled
});

var IconLayoutFilled = createReactComponent("filled", "layout-filled", "IconLayoutFilled", [["path", { "d": "M8 3a3 3 0 0 1 3 3v1a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-1a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M8 12a3 3 0 0 1 3 3v3a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-3a3 3 0 0 1 3 -3z", "key": "svg-1" }], ["path", { "d": "M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3z", "key": "svg-2" }]]);

var IconLayoutFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLayoutFilled
});

var IconLegoFilled = createReactComponent("filled", "lego-filled", "IconLegoFilled", [["path", { "d": "M16 2a1 1 0 0 1 1 1v1l.2 .005a4 4 0 0 1 3.795 3.795l.005 .2v9a4 4 0 0 1 -2.845 3.83l-.155 .043v.127a1 1 0 0 1 -.883 .993l-.117 .007h-10a1 1 0 0 1 -1 -1v-.127l-.155 -.042a4 4 0 0 1 -2.84 -3.631l-.005 -.2v-9a4 4 0 0 1 4 -4v-1a1 1 0 0 1 1 -1zm-.8 12.286a1 1 0 0 0 -1.414 .014a2.5 2.5 0 0 1 -3.572 0a1 1 0 0 0 -1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0 -.014 -1.414m-5.69 -4.286h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m5 0h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconLegoFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLegoFilled
});

var IconLemon2Filled = createReactComponent("filled", "lemon-2-filled", "IconLemon2Filled", [["path", { "d": "M18 3a3 3 0 0 1 2.443 4.742l-.06 .076l.037 .087c1.269 3.187 .428 7.084 -2.203 9.872l-.217 .223c-2.8 2.8 -6.823 3.723 -10.095 2.42l-.087 -.036l-.133 .098a3 3 0 0 1 -2.11 .488l-.205 -.036a3 3 0 0 1 -1.852 -4.62l.098 -.134l-.036 -.085c-1.269 -3.187 -.428 -7.084 2.203 -9.872l.217 -.223c2.8 -2.8 6.823 -3.723 10.095 -2.42l.085 .037l.124 -.091a3 3 0 0 1 1.493 -.52z", "key": "svg-0" }]]);

var IconLemon2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLemon2Filled
});

var IconLifebuoyFilled = createReactComponent("filled", "lifebuoy-filled", "IconLifebuoyFilled", [["path", { "d": "M14.757 16.172l3.571 3.571a10.004 10.004 0 0 1 -12.656 0l3.57 -3.571a5 5 0 0 0 2.758 .828c1.02 0 1.967 -.305 2.757 -.828m-10.5 -10.5l3.571 3.57a5 5 0 0 0 -.828 2.758c0 1.02 .305 1.967 .828 2.757l-3.57 3.572a10 10 0 0 1 -2.258 -6.329l.005 -.324a10 10 0 0 1 2.252 -6.005m17.743 6.329c0 2.343 -.82 4.57 -2.257 6.328l-3.571 -3.57a5 5 0 0 0 .828 -2.758c0 -1.02 -.305 -1.967 -.828 -2.757l3.571 -3.57a10 10 0 0 1 2.257 6.327m-5 -8.66q .707 .41 1.33 .918l-3.573 3.57a5 5 0 0 0 -2.757 -.828c-1.02 0 -1.967 .305 -2.757 .828l-3.573 -3.57a10 10 0 0 1 11.33 -.918", "key": "svg-0" }]]);

var IconLifebuoyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLifebuoyFilled
});

var IconLivePhotoFilled = createReactComponent("filled", "live-photo-filled", "IconLivePhotoFilled", [["path", { "d": "M12 6a6 6 0 1 1 -6 6l.004 -.225a6 6 0 0 1 5.996 -5.775m0 4a2 2 0 0 0 -1.995 1.85l-.005 .15a2 2 0 1 0 2 -2m3.9 9.11a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1m3.14 -2.5a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1m1.73 -3.61a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1m0 -4a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1m-1.73 -3.61a1 1 0 0 1 1 1a1 1 0 1 1 -2 .01c0 -.562 .448 -1.01 1 -1.01m-3.14 -2.5a1 1 0 0 1 1 1a1 1 0 1 1 -2 .01c0 -.562 .448 -1.01 1 -1.01m-3.9 -.89a1 1 0 0 1 1 1a1 1 0 1 1 -2 .01c0 -.562 .448 -1.01 1 -1.01m-3.9 .89a1 1 0 0 1 1 1a1 1 0 1 1 -2 .01c0 -.562 .448 -1.01 1 -1.01m-3.14 2.5a1 1 0 0 1 1 1a1 1 0 1 1 -2 .01c0 -.562 .448 -1.01 1 -1.01m-1.73 3.61a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1m0 4a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1m1.73 3.61a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1m3.14 2.5a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1m3.9 .89a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1", "key": "svg-0" }]]);

var IconLivePhotoFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLivePhotoFilled
});

var IconLiveViewFilled = createReactComponent("filled", "live-view-filled", "IconLiveViewFilled", [["path", { "d": "M8 3a1 1 0 1 1 0 2h-2a1 1 0 0 0 -1 1v2a1 1 0 1 1 -2 0v-2a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M4 15a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 0 2h-2a3 3 0 0 1 -3 -3v-2a1 1 0 0 1 1 -1", "key": "svg-1" }], ["path", { "d": "M18 3a3 3 0 0 1 3 3v2a1 1 0 0 1 -2 0v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 0 -2z", "key": "svg-2" }], ["path", { "d": "M20 15a1 1 0 0 1 1 1v2a3 3 0 0 1 -3 3h-2a1 1 0 0 1 0 -2h2a1 1 0 0 0 1 -1v-2a1 1 0 0 1 1 -1", "key": "svg-3" }], ["path", { "d": "M15.19 7.214a5 5 0 0 1 1.185 6.27l-.056 .09l-3.484 4.976a1 1 0 0 1 -.077 .103l-.017 .019l-.057 .056l-.012 .013l-.019 .017a1 1 0 0 1 -.096 .073l-.053 .03l-.038 .024l-.011 .005a1 1 0 0 1 -.223 .083l-.045 .008l-.066 .012a1 1 0 0 1 -.242 0l-.061 -.011l-.05 -.01a1 1 0 0 1 -.234 -.087l-.047 -.028l-.044 -.026l-.011 -.008l-.032 -.025l-.053 -.04l-.01 -.01l-.009 -.007l-.034 -.035l-.035 -.034l-.007 -.01l-.01 -.009l-.037 -.05l-.024 -.03l-3.5 -5l-.056 -.089a5 5 0 0 1 7.566 -6.27m-3.191 2.786a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1", "key": "svg-4" }]]);

var IconLiveViewFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLiveViewFilled
});

var IconLocationFilled = createReactComponent("filled", "location-filled", "IconLocationFilled", [["path", { "d": "M20.891 2.006l.106 -.006l.13 .008l.09 .016l.123 .035l.107 .046l.1 .057l.09 .067l.082 .075l.052 .059l.082 .116l.052 .096c.047 .1 .077 .206 .09 .316l.005 .106c0 .075 -.008 .149 -.024 .22l-.035 .123l-6.532 18.077a1.55 1.55 0 0 1 -1.409 .903a1.547 1.547 0 0 1 -1.329 -.747l-.065 -.127l-3.352 -6.702l-6.67 -3.336a1.55 1.55 0 0 1 -.898 -1.259l-.006 -.149c0 -.56 .301 -1.072 .841 -1.37l.14 -.07l18.017 -6.506l.106 -.03l.108 -.018z", "key": "svg-0" }]]);

var IconLocationFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLocationFilled
});

var IconLockSquareRoundedFilled = createReactComponent("filled", "lock-square-rounded-filled", "IconLockSquareRoundedFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm0 4a3 3 0 0 1 2.995 2.824l.005 .176v1a2 2 0 0 1 1.995 1.85l.005 .15v3a2 2 0 0 1 -1.85 1.995l-.15 .005h-6a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 1.85 -1.995l.15 -.005v-1a3 3 0 0 1 3 -3zm3 6h-6v3h6v-3zm-3 -4a1 1 0 0 0 -.993 .883l-.007 .117v1h2v-1a1 1 0 0 0 -1 -1z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconLockSquareRoundedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockSquareRoundedFilled
});

var IconLockFilled = createReactComponent("filled", "lock-filled", "IconLockFilled", [["path", { "d": "M12 2a5 5 0 0 1 5 5v3a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3v-3a5 5 0 0 1 5 -5m0 12a2 2 0 0 0 -1.995 1.85l-.005 .15a2 2 0 1 0 2 -2m0 -10a3 3 0 0 0 -3 3v3h6v-3a3 3 0 0 0 -3 -3", "key": "svg-0" }]]);

var IconLockFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLockFilled
});

var IconLungsFilled = createReactComponent("filled", "lungs-filled", "IconLungsFilled", [["path", { "d": "M12 3a1 1 0 0 1 1 1v5a2 2 0 0 0 1 1.732v-3.475c0 -1.242 .995 -2.257 2.233 -2.257c.372 0 .738 .094 1.122 .307l.18 .117c1.695 1.23 2.76 3.035 3.773 6.34q .674 2.204 .692 5.06c.016 2.195 -1.657 4.024 -3.843 4.168l-.237 .008c-2.17 0 -3.92 -1.787 -3.92 -3.98v-4.146a4 4 0 0 1 -1.893 -1.112l-.107 -.118l-.107 .118a4 4 0 0 1 -1.892 1.112l-.001 4.146c0 2.193 -1.75 3.98 -3.919 3.98l-.268 -.01c-2.155 -.142 -3.827 -1.971 -3.811 -4.165q .018 -2.858 .692 -5.06c1.011 -3.307 2.076 -5.112 3.822 -6.375l.188 -.117a2.2 2.2 0 0 1 1.064 -.273c1.237 0 2.232 1.015 2.232 2.257l.001 3.475a2 2 0 0 0 .999 -1.732v-5a1 1 0 0 1 1 -1", "key": "svg-0" }]]);

var IconLungsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconLungsFilled
});

var IconMacroFilled = createReactComponent("filled", "macro-filled", "IconMacroFilled", [["path", { "d": "M17.994 2.888l.006 .112v3a6 6 0 0 1 -5 5.916v4.186a6.98 6.98 0 0 1 5 -2.102a1 1 0 0 1 1 1a7 7 0 0 1 -14 0a1 1 0 0 1 1 -1c1.96 0 3.731 .805 5.002 2.103l-.002 -4.186a6 6 0 0 1 -5 -5.917v-3a1 1 0 0 1 1.555 -.832l2.317 1.544l1.42 -1.42a1 1 0 0 1 1.32 -.082l.095 .083l1.42 1.419l2.318 -1.544a1 1 0 0 1 1.55 .72m-10.865 13.24l.03 .134a5.01 5.01 0 0 0 3.71 3.61a5 5 0 0 0 -3.74 -3.744m9.742 .002l-.134 .03a5.01 5.01 0 0 0 -3.61 3.71a5 5 0 0 0 3.744 -3.74", "key": "svg-0" }]]);

var IconMacroFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMacroFilled
});

var IconMagnetFilled = createReactComponent("filled", "magnet-filled", "IconMagnetFilled", [["path", { "d": "M21 9v4a9 9 0 0 1 -18 0v-4h7v4a2 2 0 1 0 4 0v-4zm-3 -7a3 3 0 0 1 3 3v2h-7v-2a3 3 0 0 1 3 -3zm-11 0a3 3 0 0 1 3 3v2h-7v-2a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

var IconMagnetFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMagnetFilled
});

var IconMailOpenedFilled = createReactComponent("filled", "mail-opened-filled", "IconMailOpenedFilled", [["path", { "d": "M14.872 14.287l6.522 6.52a2.996 2.996 0 0 1 -2.218 1.188l-.176 .005h-14a2.995 2.995 0 0 1 -2.394 -1.191l6.521 -6.522l2.318 1.545l.116 .066a1 1 0 0 0 .878 0l.116 -.066l2.317 -1.545z", "key": "svg-0" }], ["path", { "d": "M2 9.535l5.429 3.62l-5.429 5.43z", "key": "svg-1" }], ["path", { "d": "M22 9.535v9.05l-5.43 -5.43z", "key": "svg-2" }], ["path", { "d": "M12.44 2.102l.115 .066l8.444 5.629l-8.999 6l-9 -6l8.445 -5.63a1 1 0 0 1 .994 -.065z", "key": "svg-3" }]]);

var IconMailOpenedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailOpenedFilled
});

var IconMailFilled = createReactComponent("filled", "mail-filled", "IconMailFilled", [["path", { "d": "M22 7.535v9.465a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-9.465l9.445 6.297l.116 .066a1 1 0 0 0 .878 0l.116 -.066l9.445 -6.297z", "key": "svg-0" }], ["path", { "d": "M19 4c1.08 0 2.027 .57 2.555 1.427l-9.555 6.37l-9.555 -6.37a2.999 2.999 0 0 1 2.354 -1.42l.201 -.007h14z", "key": "svg-1" }]]);

var IconMailFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMailFilled
});

var IconManFilled = createReactComponent("filled", "man-filled", "IconManFilled", [["path", { "d": "M15 8c1.628 0 3.2 .787 4.707 2.293a1 1 0 0 1 -1.414 1.414c-.848 -.848 -1.662 -1.369 -2.444 -1.587l-.849 5.944v4.936a1 1 0 0 1 -2 0v-4h-2v4a1 1 0 0 1 -2 0v-4.929l-.85 -5.951c-.781 .218 -1.595 .739 -2.443 1.587a1 1 0 1 1 -1.414 -1.414c1.506 -1.506 3.08 -2.293 4.707 -2.293z", "key": "svg-0" }], ["path", { "d": "M12 1a3 3 0 1 1 -3 3l.005 -.176a3 3 0 0 1 2.995 -2.824", "key": "svg-1" }]]);

var IconManFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconManFilled
});

var IconManualGearboxFilled = createReactComponent("filled", "manual-gearbox-filled", "IconManualGearboxFilled", [["path", { "d": "M19 3a3 3 0 0 1 1 5.829v1.171a3 3 0 0 1 -3 3h-4v2.171a3.001 3.001 0 1 1 -4 2.829l.005 -.176a3 3 0 0 1 1.995 -2.654v-2.17h-5v2.171a3.001 3.001 0 1 1 -4 2.829l.005 -.176a3 3 0 0 1 1.995 -2.654v-6.341a3 3 0 0 1 -2 -2.829l.005 -.176a3 3 0 1 1 3.996 3.005l-.001 2.171h5v-2.17a3 3 0 0 1 -2 -2.83l.005 -.176a3 3 0 1 1 3.996 3.005l-.001 2.171h4a1 1 0 0 0 1 -1v-1.17a3 3 0 0 1 -2 -2.83l.005 -.176a3 3 0 0 1 2.995 -2.824", "key": "svg-0" }]]);

var IconManualGearboxFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconManualGearboxFilled
});

var IconMapPinFilled = createReactComponent("filled", "map-pin-filled", "IconMapPinFilled", [["path", { "d": "M18.364 4.636a9 9 0 0 1 .203 12.519l-.203 .21l-4.243 4.242a3 3 0 0 1 -4.097 .135l-.144 -.135l-4.244 -4.243a9 9 0 0 1 12.728 -12.728zm-6.364 3.364a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z", "key": "svg-0" }]]);

var IconMapPinFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMapPinFilled
});

var IconMedicalCrossFilled = createReactComponent("filled", "medical-cross-filled", "IconMedicalCrossFilled", [["path", { "d": "M11 2l-.15 .005a2 2 0 0 0 -1.85 1.995v2.803l-2.428 -1.401a2 2 0 0 0 -2.732 .732l-1 1.732l-.073 .138a2 2 0 0 0 .805 2.594l2.427 1.402l-2.427 1.402a2 2 0 0 0 -.732 2.732l1 1.732l.083 .132a2 2 0 0 0 2.649 .6l2.428 -1.402v2.804a2 2 0 0 0 2 2h2l.15 -.005a2 2 0 0 0 1.85 -1.995v-2.804l2.428 1.403a2 2 0 0 0 2.732 -.732l1 -1.732l.073 -.138a2 2 0 0 0 -.805 -2.594l-2.428 -1.403l2.428 -1.402a2 2 0 0 0 .732 -2.732l-1 -1.732l-.083 -.132a2 2 0 0 0 -2.649 -.6l-2.428 1.4v-2.802a2 2 0 0 0 -2 -2h-2z", "key": "svg-0" }]]);

var IconMedicalCrossFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMedicalCrossFilled
});

var IconMeepleFilled = createReactComponent("filled", "meeple-filled", "IconMeepleFilled", [["path", { "d": "M12 2c2.486 0 3.713 1.766 3.955 4.1l.01 .124l.129 .036c3.17 .928 5.754 2.487 5.9 4.556l.006 .184c0 1.427 -1.297 2.322 -2.871 2.733l-.201 .049l.026 .03c.244 .276 .532 .603 .7 .797l.057 .066c.49 .573 .884 1.073 1.216 1.56c.69 1.01 1.073 1.904 1.073 2.765a2 2 0 0 1 -2 2h-5c-1.043 0 -1.344 -.453 -2.394 -2.553c-.29 -.58 -.448 -.882 -.593 -1.118l-.013 -.022l-.013 .022c-.129 .21 -.268 .472 -.5 .935l-.093 .183c-1.05 2.1 -1.351 2.553 -2.394 2.553h-5a2 2 0 0 1 -2 -2c0 -.86 .384 -1.755 1.073 -2.765a18 18 0 0 1 1.216 -1.56c.152 -.178 .482 -.553 .757 -.863l.025 -.03l-.2 -.049c-1.506 -.393 -2.758 -1.23 -2.864 -2.55l-.007 -.183c0 -2.16 2.643 -3.785 5.906 -4.74l.128 -.036l.011 -.124c.235 -2.26 1.394 -3.99 3.726 -4.095z", "key": "svg-0" }]]);

var IconMeepleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMeepleFilled
});

var IconMelonFilled = createReactComponent("filled", "melon-filled", "IconMelonFilled", [["path", { "d": "M16.77 2.62a1 1 0 0 1 1.436 .055a10.96 10.96 0 0 1 2.794 7.326c0 6.074 -4.925 10.999 -10.999 10.999a10.97 10.97 0 0 1 -7.684 -3.127a1 1 0 0 1 .008 -1.438l4.343 -4.153a1 1 0 0 1 1.352 -.027a3 3 0 0 0 4.32 -4.133a1 1 0 0 1 .088 -1.35z", "key": "svg-0" }]]);

var IconMelonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMelonFilled
});

var IconMessage2Filled = createReactComponent("filled", "message-2-filled", "IconMessage2Filled", [["path", { "d": "M18 3a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-2.586l-2.707 2.707a1 1 0 0 1 -1.32 .083l-.094 -.083l-2.708 -2.707h-2.585a4 4 0 0 1 -3.995 -3.8l-.005 -.2v-8a4 4 0 0 1 4 -4zm-4 9h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2m2 -4h-8a1 1 0 1 0 0 2h8a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconMessage2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessage2Filled
});

var IconMessageChatbotFilled = createReactComponent("filled", "message-chatbot-filled", "IconMessageChatbotFilled", [["path", { "d": "M18 3a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-4.724l-4.762 2.857a1 1 0 0 1 -1.508 -.743l-.006 -.114v-2h-1a4 4 0 0 1 -3.995 -3.8l-.005 -.2v-8a4 4 0 0 1 4 -4zm-2.8 9.286a1 1 0 0 0 -1.414 .014a2.5 2.5 0 0 1 -3.572 0a1 1 0 0 0 -1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0 -.014 -1.414m-5.69 -4.286h-.01a1 1 0 1 0 0 2h.01a1 1 0 0 0 0 -2m5 0h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconMessageChatbotFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageChatbotFilled
});

var IconMessageCircleFilled = createReactComponent("filled", "message-circle-filled", "IconMessageCircleFilled", [["path", { "d": "M5.821 4.91c3.899 -2.765 9.468 -2.539 13.073 .535c3.667 3.129 4.168 8.238 1.152 11.898c-2.841 3.447 -7.965 4.583 -12.231 2.805l-.233 -.101l-4.374 .931l-.04 .006l-.035 .007h-.018l-.022 .005h-.038l-.033 .004l-.021 -.001l-.023 .001l-.033 -.003h-.035l-.022 -.004l-.022 -.002l-.035 -.007l-.034 -.005l-.016 -.004l-.024 -.005l-.049 -.016l-.024 -.005l-.011 -.005l-.022 -.007l-.045 -.02l-.03 -.012l-.011 -.006l-.014 -.006l-.031 -.018l-.045 -.024l-.016 -.011l-.037 -.026l-.04 -.027l-.002 -.004l-.013 -.009l-.043 -.04l-.025 -.02l-.006 -.007l-.056 -.062l-.013 -.014l-.011 -.014l-.039 -.056l-.014 -.019l-.005 -.01l-.042 -.073l-.007 -.012l-.004 -.008l-.007 -.012l-.014 -.038l-.02 -.042l-.004 -.016l-.004 -.01l-.017 -.061l-.007 -.018l-.002 -.015l-.005 -.019l-.005 -.033l-.008 -.042l-.002 -.031l-.003 -.01v-.016l-.004 -.054l.001 -.036l.001 -.023l.002 -.053l.004 -.025v-.019l.008 -.035l.005 -.034l.005 -.02l.004 -.02l.018 -.06l.003 -.013l1.15 -3.45l-.022 -.037c-2.21 -3.747 -1.209 -8.391 2.413 -11.119z", "key": "svg-0" }]]);

var IconMessageCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageCircleFilled
});

var IconMessageReportFilled = createReactComponent("filled", "message-report-filled", "IconMessageReportFilled", [["path", { "d": "M18 3a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-4.724l-4.762 2.857a1 1 0 0 1 -1.508 -.743l-.006 -.114v-2h-1a4 4 0 0 1 -3.995 -3.8l-.005 -.2v-8a4 4 0 0 1 4 -4zm-6 10a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m0 -6a1 1 0 0 0 -1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconMessageReportFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageReportFilled
});

var IconMessageFilled = createReactComponent("filled", "message-filled", "IconMessageFilled", [["path", { "d": "M18 3a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-4.724l-4.762 2.857a1 1 0 0 1 -1.508 -.743l-.006 -.114v-2h-1a4 4 0 0 1 -3.995 -3.8l-.005 -.2v-8a4 4 0 0 1 4 -4zm-4 9h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2m2 -4h-8a1 1 0 1 0 0 2h8a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconMessageFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMessageFilled
});

var IconMeteorFilled = createReactComponent("filled", "meteor-filled", "IconMeteorFilled", [["path", { "d": "M21.874 3.486l-4.174 7.514h3.3c.846 0 1.293 .973 .791 1.612l-.074 .085l-6.9 7.095a7.5 7.5 0 1 1 -10.21 -10.974l7.746 -6.58c.722 -.614 1.814 .028 1.628 .958l-.577 2.879l7.11 -3.95c.88 -.488 1.849 .481 1.36 1.36m-12.374 7.515a3.5 3.5 0 0 0 -3.495 3.308l-.005 .192a3.5 3.5 0 1 0 3.5 -3.5", "key": "svg-0" }]]);

var IconMeteorFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMeteorFilled
});

var IconMichelinStarFilled = createReactComponent("filled", "michelin-star-filled", "IconMichelinStarFilled", [["path", { "d": "M11.81 2c2.018 0 3.478 1.232 3.874 3.129l.016 .089l.172 -.057c.34 -.104 .684 -.16 1.055 -.175l.227 -.005c2.09 0 3.925 1.93 3.925 4.094c0 1.095 -.51 2.087 -1.364 2.835l-.118 .098l.06 .048c.88 .737 1.36 1.605 1.416 2.656l.006 .213c0 2.24 -1.739 4.094 -3.925 4.094c-.445 0 -.923 -.084 -1.374 -.233l-.043 .193c-.395 1.736 -1.806 2.933 -3.662 3.016l-.208 .005c-2.018 0 -3.477 -1.232 -3.873 -3.13l-.03 -.161l-.011 .006a4.1 4.1 0 0 1 -1.26 .243l-.226 .005c-2.09 0 -3.925 -1.93 -3.925 -4.094c0 -1.096 .51 -2.087 1.378 -2.84l.073 -.062l-.03 -.023c-.88 -.737 -1.359 -1.605 -1.415 -2.656l-.006 -.213c0 -2.239 1.74 -4.094 3.925 -4.094c.44 0 .92 .098 1.391 .27l.036 .013l.008 -.048c.331 -1.84 1.776 -3.125 3.7 -3.211z", "key": "svg-0" }]]);

var IconMichelinStarFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMichelinStarFilled
});

var IconMickeyFilled = createReactComponent("filled", "mickey-filled", "IconMickeyFilled", [["path", { "d": "M18.501 2a4.5 4.5 0 0 1 .878 8.913a8 8 0 1 1 -15.374 3.372l-.005 -.285l.005 -.285a7.991 7.991 0 0 1 .615 -2.803a4.5 4.5 0 0 1 -3.187 -6.348a4.505 4.505 0 0 1 3.596 -2.539l.225 -.018l.281 -.007l.244 .009a4.5 4.5 0 0 1 4.215 4.247a8.001 8.001 0 0 1 4.013 0a4.5 4.5 0 0 1 4.493 -4.256z", "key": "svg-0" }]]);

var IconMickeyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMickeyFilled
});

var IconMicrophoneFilled = createReactComponent("filled", "microphone-filled", "IconMicrophoneFilled", [["path", { "d": "M19 9a1 1 0 0 1 1 1a8 8 0 0 1 -6.999 7.938l-.001 2.062h3a1 1 0 0 1 0 2h-8a1 1 0 0 1 0 -2h3v-2.062a8 8 0 0 1 -7 -7.938a1 1 0 1 1 2 0a6 6 0 0 0 12 0a1 1 0 0 1 1 -1m-7 -8a4 4 0 0 1 4 4v5a4 4 0 1 1 -8 0v-5a4 4 0 0 1 4 -4", "key": "svg-0" }]]);

var IconMicrophoneFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMicrophoneFilled
});

var IconMicrowaveFilled = createReactComponent("filled", "microwave-filled", "IconMicrowaveFilled", [["path", { "d": "M20 5a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2zm-6 2h-10v10h10zm4.01 7h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m0 -3h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m0 -3h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2", "key": "svg-0" }], ["path", { "d": "M5.945 9.668c1.336 -.891 2.274 -.891 3.61 0l-.089 -.056l.04 .017l.146 .064l.095 .044c.378 .171 .533 .23 .674 .255c.133 .023 .186 .005 .336 -.16a1 1 0 1 1 1.486 1.337c-.613 .681 -1.358 .934 -2.164 .794c-.368 -.064 -.621 -.161 -1.158 -.405a10 10 0 0 0 -.306 -.135l-.17 -.091c-.664 -.443 -.726 -.443 -1.39 0a1 1 0 1 1 -1.11 -1.664", "key": "svg-1" }], ["path", { "d": "M5.945 12.668c1.336 -.891 2.274 -.891 3.61 0l-.089 -.056l.04 .017l.146 .064l.095 .044c.378 .171 .533 .23 .674 .255c.133 .023 .186 .005 .336 -.16a1 1 0 0 1 1.486 1.337c-.613 .681 -1.358 .934 -2.164 .794c-.368 -.064 -.621 -.161 -1.158 -.405a10 10 0 0 0 -.306 -.135l-.17 -.091c-.664 -.443 -.726 -.443 -1.39 0a1 1 0 1 1 -1.11 -1.664", "key": "svg-2" }]]);

var IconMicrowaveFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMicrowaveFilled
});

var IconMilitaryRankFilled = createReactComponent("filled", "military-rank-filled", "IconMilitaryRankFilled", [["path", { "d": "M12.555 2.168l6 4a1 1 0 0 1 .445 .832v12a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-12a1 1 0 0 1 .445 -.832l6 -4a1 1 0 0 1 1.11 0m-.108 12.938a1 1 0 0 0 -.894 0l-2 1a1 1 0 0 0 -.447 1.341l.058 .102a1 1 0 0 0 1.283 .345l1.553 -.776l1.553 .776a1 1 0 0 0 .894 -1.788zm0 -4a1 1 0 0 0 -.894 0l-2 1a1 1 0 0 0 -.447 1.341l.058 .102a1 1 0 0 0 1.283 .345l1.553 -.776l1.553 .776a1 1 0 0 0 .894 -1.788zm0 -4a1 1 0 0 0 -.894 0l-2 1a1 1 0 0 0 -.447 1.341l.058 .102a1 1 0 0 0 1.283 .345l1.553 -.776l1.553 .776a1 1 0 0 0 .894 -1.788z", "key": "svg-0" }]]);

var IconMilitaryRankFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMilitaryRankFilled
});

var IconMilkFilled = createReactComponent("filled", "milk-filled", "IconMilkFilled", [["path", { "d": "M17.799 7l.144 .23a7 7 0 0 1 1.057 3.7v8.07a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-8.071a7 7 0 0 1 1.057 -3.698l.142 -.231zm-5.799 6a3 3 0 0 0 -2.995 2.824l-.005 .176a3 3 0 1 0 3 -3m0 2a1 1 0 1 1 0 2a1 1 0 0 1 0 -2m2 -6h-4a1 1 0 1 0 0 2h4a1 1 0 0 0 0 -2m1 -7a2 2 0 0 1 2 2v1h-10v-1a2 2 0 0 1 2 -2z", "key": "svg-0" }]]);

var IconMilkFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMilkFilled
});

var IconMoodAngryFilled = createReactComponent("filled", "mood-angry-filled", "IconMoodAngryFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10a10 10 0 1 1 0 -20m0 12a4.5 4.5 0 0 0 -3.214 1.35a1 1 0 1 0 1.428 1.4a2.5 2.5 0 0 1 3.572 0a1 1 0 0 0 1.428 -1.4a4.5 4.5 0 0 0 -3.214 -1.35m-3.553 -5.895a1 1 0 0 0 -.894 1.788l2 1a1 1 0 0 0 .894 -1.788zm8.447 .447a1 1 0 0 0 -1.341 -.447l-2 1a1 1 0 0 0 .894 1.788l2 -1a1 1 0 0 0 .447 -1.341", "key": "svg-0" }]]);

var IconMoodAngryFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodAngryFilled
});

var IconMoodConfuzedFilled = createReactComponent("filled", "mood-confuzed-filled", "IconMoodConfuzedFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.43 10.162a11 11 0 0 0 -6.6 1.65a1 1 0 0 0 1.06 1.696a9 9 0 0 1 5.4 -1.35a1 1 0 0 0 .14 -1.996zm-6.56 -4.502l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm6 0l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconMoodConfuzedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodConfuzedFilled
});

var IconMoodCrazyHappyFilled = createReactComponent("filled", "mood-crazy-happy-filled", "IconMoodCrazyHappyFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-1.8 10.946a1 1 0 0 0 -1.414 .014a2.5 2.5 0 0 1 -3.572 0a1 1 0 0 0 -1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0 -.014 -1.414m-7.493 -6.493a1 1 0 0 0 -1.414 1.414l.792 .793l-.792 .793a1 1 0 0 0 1.414 1.414l.793 -.792l.793 .792a1 1 0 1 0 1.414 -1.414l-.792 -.793l.792 -.793a1 1 0 1 0 -1.414 -1.414l-.793 .792zm7 0a1 1 0 0 0 -1.414 1.414l.792 .793l-.792 .793a1 1 0 0 0 1.414 1.414l.793 -.792l.793 .792a1 1 0 0 0 1.414 -1.414l-.792 -.793l.792 -.793a1 1 0 1 0 -1.414 -1.414l-.793 .792z", "key": "svg-0" }]]);

var IconMoodCrazyHappyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodCrazyHappyFilled
});

var IconMoodEmptyFilled = createReactComponent("filled", "mood-empty-filled", "IconMoodEmptyFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 10.66h-6l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h6l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-5.99 -5l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm6 0l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconMoodEmptyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodEmptyFilled
});

var IconMoodHappyFilled = createReactComponent("filled", "mood-happy-filled", "IconMoodHappyFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 9.66h-6a1 1 0 0 0 -1 1v.05a3.975 3.975 0 0 0 3.777 3.97l.227 .005a4.026 4.026 0 0 0 3.99 -3.79l.006 -.206a1 1 0 0 0 -1 -1.029zm-5.99 -5l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm6 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconMoodHappyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodHappyFilled
});

var IconMoodKidFilled = createReactComponent("filled", "mood-kid-filled", "IconMoodKidFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 7.046 -9.232a3 3 0 0 0 2.949 3.556a1 1 0 0 0 0 -2l-.117 -.007a1 1 0 0 1 .117 -1.993c1.726 0 3.453 .447 5 1.34zm-1.8 10.946a1 1 0 0 0 -1.414 .014a2.5 2.5 0 0 1 -3.572 0a1 1 0 0 0 -1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0 -.014 -1.414zm-6.19 -5.286l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm6 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconMoodKidFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodKidFilled
});

var IconMoodNeutralFilled = createReactComponent("filled", "mood-neutral-filled", "IconMoodNeutralFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-7.99 5.66l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm6 0l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconMoodNeutralFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodNeutralFilled
});

var IconMoodSadFilled = createReactComponent("filled", "mood-sad-filled", "IconMoodSadFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 9.86a4.5 4.5 0 0 0 -3.214 1.35a1 1 0 1 0 1.428 1.4a2.5 2.5 0 0 1 3.572 0a1 1 0 0 0 1.428 -1.4a4.5 4.5 0 0 0 -3.214 -1.35zm-2.99 -4.2l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm6 0l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconMoodSadFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSadFilled
});

var IconMoodSmileFilled = createReactComponent("filled", "mood-smile-filled", "IconMoodSmileFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.8 10.946a1 1 0 0 0 -1.414 .014a2.5 2.5 0 0 1 -3.572 0a1 1 0 0 0 -1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0 -.014 -1.414zm-6.19 -5.286l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm6 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconMoodSmileFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodSmileFilled
});

var IconMoodWrrrFilled = createReactComponent("filled", "mood-wrrr-filled", "IconMoodWrrrFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10a10 10 0 1 1 0 -20m3.707 12.293a1 1 0 0 0 -1.262 -.125l-.945 .63l-.945 -.63l-.116 -.066a1 1 0 0 0 -.994 .066l-.945 .63l-.945 -.63a1 1 0 0 0 -1.262 .125l-1 1a1 1 0 0 0 0 1.414l.094 .083a1 1 0 0 0 1.32 -.083l.42 -.42l.818 .545l.116 .066a1 1 0 0 0 .994 -.066l.945 -.63l.945 .63l.116 .066a1 1 0 0 0 .994 -.066l.817 -.545l.42 .42a1 1 0 0 0 1.415 -1.414zm-6.5 -6.5a1 1 0 0 0 -1.414 0l-.083 .094a1 1 0 0 0 .083 1.32l.792 .793l-.792 .793a1 1 0 0 0 1.414 1.414l1.5 -1.5a1 1 0 0 0 0 -1.414zm7 0a1 1 0 0 0 -1.414 0l-1.5 1.5a1 1 0 0 0 0 1.414l1.5 1.5a1 1 0 0 0 1.414 0l.083 -.094a1 1 0 0 0 -.083 -1.32l-.792 -.793l.792 -.793a1 1 0 0 0 0 -1.414", "key": "svg-0" }]]);

var IconMoodWrrrFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoodWrrrFilled
});

var IconMoonFilled = createReactComponent("filled", "moon-filled", "IconMoonFilled", [["path", { "d": "M12 1.992a10 10 0 1 0 9.236 13.838c.341 -.82 -.476 -1.644 -1.298 -1.31a6.5 6.5 0 0 1 -6.864 -10.787l.077 -.08c.551 -.63 .113 -1.653 -.758 -1.653h-.266l-.068 -.006l-.06 -.002z", "key": "svg-0" }]]);

var IconMoonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMoonFilled
});

var IconMotorbikeFilled = createReactComponent("filled", "motorbike-filled", "IconMotorbikeFilled", [["path", { "d": "M15 5a1 1 0 0 1 .894 .553l3.225 6.449l.08 .003a4 4 0 1 1 -4.199 3.995l.005 -.2a4 4 0 0 1 2.111 -3.33l-.557 -1.115l-3.352 3.352a1 1 0 0 1 -.707 .293h-3.626q .124 .481 .126 1a4 4 0 1 1 -8 0l.005 -.2a4 4 0 0 1 6.33 -3.049l1.749 -1.751h-3.084a1 1 0 0 1 -.993 -.883l-.007 -.117a1 1 0 0 1 1 -1h9.381l-1 -2h-1.381a1 1 0 0 1 -.993 -.883l-.007 -.117a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconMotorbikeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMotorbikeFilled
});

var IconMountainFilled = createReactComponent("filled", "mountain-filled", "IconMountainFilled", [["path", { "d": "M6.18 10.95l2.54 3.175l.084 .093a1 1 0 0 0 1.403 -.01l1.637 -1.638l1.324 1.985a1 1 0 0 0 1.457 .226l3.632 -2.906l3.647 7.697a1 1 0 0 1 -.904 1.428h-18a1 1 0 0 1 -.904 -1.428zm5.82 -7.878a3.3 3.3 0 0 1 2.983 1.888l2.394 5.057l-3.15 2.52l-1.395 -2.092l-.075 -.099a1 1 0 0 0 -1.464 -.053l-1.711 1.709l-1.301 -1.627l-1.151 -1.435l1.888 -3.98a3.3 3.3 0 0 1 2.982 -1.888", "key": "svg-0" }]]);

var IconMountainFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMountainFilled
});

var IconMouseFilled = createReactComponent("filled", "mouse-filled", "IconMouseFilled", [["path", { "d": "M14 2a5 5 0 0 1 5 5v10a5 5 0 0 1 -5 5h-4a5 5 0 0 1 -5 -5v-10a5 5 0 0 1 5 -5zm-2 4a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconMouseFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMouseFilled
});

var IconMugFilled = createReactComponent("filled", "mug-filled", "IconMugFilled", [["path", { "d": "M3.903 4.008l.183 -.008h10.828a2.08 2.08 0 0 1 2.086 2.077v.923h1.5c1.917 0 3.5 1.477 3.5 3.333v2.334c0 1.856 -1.583 3.333 -3.5 3.333h-1.663a5.33 5.33 0 0 1 -5.17 4h-4.334c-2.944 0 -5.333 -2.375 -5.333 -5.308v-8.618a2.08 2.08 0 0 1 1.903 -2.066m13.097 9.992h1.5c.843 0 1.5 -.613 1.5 -1.333v-2.334c0 -.72 -.657 -1.333 -1.5 -1.333h-1.5z", "key": "svg-0" }]]);

var IconMugFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMugFilled
});

var IconMushroomFilled = createReactComponent("filled", "mushroom-filled", "IconMushroomFilled", [["path", { "d": "M15 15v4a3 3 0 0 1 -5.995 .176l-.005 -.176v-4h6zm-10.1 -2a1.9 1.9 0 0 1 -1.894 -1.752l-.006 -.148c0 -5.023 4.027 -9.1 9 -9.1s9 4.077 9 9.1a1.9 1.9 0 0 1 -1.752 1.894l-.148 .006h-14.2z", "key": "svg-0" }]]);

var IconMushroomFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconMushroomFilled
});

var IconNavigationFilled = createReactComponent("filled", "navigation-filled", "IconNavigationFilled", [["path", { "d": "M11.092 2.581a1 1 0 0 1 1.754 -.116l.062 .116l8.005 17.365c.198 .566 .05 1.196 -.378 1.615a1.53 1.53 0 0 1 -1.459 .393l-7.077 -2.398l-6.899 2.338a1.535 1.535 0 0 1 -1.52 -.231l-.112 -.1c-.398 -.386 -.556 -.954 -.393 -1.556l.047 -.15l7.97 -17.276z", "key": "svg-0" }]]);

var IconNavigationFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNavigationFilled
});

var IconNurseFilled = createReactComponent("filled", "nurse-filled", "IconNurseFilled", [["path", { "d": "M12.002 4c2.866 0 6.7 1.365 9.532 3.155a1 1 0 0 1 .45 1.024l-2 11a1 1 0 0 1 -.984 .821h-14a1 1 0 0 1 -.984 -.821l-2 -11a1 1 0 0 1 .45 -1.024c2.834 -1.792 6.724 -3.16 9.536 -3.155m-.002 5a1 1 0 0 0 -1 1v1h-1a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 0 1 1h1v1a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-1h1a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-1v-1a1 1 0 0 0 -.883 -.993z", "key": "svg-0" }]]);

var IconNurseFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconNurseFilled
});

var IconOctagonFilled = createReactComponent("filled", "octagon-filled", "IconOctagonFilled", [["path", { "d": "M15.3 2h-6.6c-.562 0 -1.016 .201 -1.407 .593l-4.7 4.7a1.894 1.894 0 0 0 -.593 1.407v6.6c0 .562 .201 1.016 .593 1.407l4.7 4.7c.391 .392 .845 .593 1.407 .593h6.6c.562 0 1.016 -.201 1.407 -.593l4.7 -4.7c.392 -.391 .593 -.845 .593 -1.407v-6.6c0 -.562 -.201 -1.016 -.593 -1.407l-4.7 -4.7a1.894 1.894 0 0 0 -1.407 -.593z", "key": "svg-0" }]]);

var IconOctagonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOctagonFilled
});

var IconOvalVerticalFilled = createReactComponent("filled", "oval-vertical-filled", "IconOvalVerticalFilled", [["path", { "d": "M12 5c-5.457 0 -10 3.028 -10 7s4.543 7 10 7s10 -3.028 10 -7s-4.543 -7 -10 -7z", "key": "svg-0" }]]);

var IconOvalVerticalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOvalVerticalFilled
});

var IconOvalFilled = createReactComponent("filled", "oval-filled", "IconOvalFilled", [["path", { "d": "M12 2c3.972 0 7 4.542 7 10s-3.028 10 -7 10c-3.9 0 -6.89 -4.379 -6.997 -9.703l-.003 -.297l.003 -.297c.107 -5.323 3.097 -9.703 6.997 -9.703z", "key": "svg-0" }]]);

var IconOvalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconOvalFilled
});

var IconPaintFilled = createReactComponent("filled", "paint-filled", "IconPaintFilled", [["path", { "d": "M17 2a3 3 0 0 1 2.995 2.824l.005 .176a3 3 0 0 1 3 3a6 6 0 0 1 -5.775 5.996l-.225 .004h-4l.15 .005a2 2 0 0 1 1.844 1.838l.006 .157v4a2 2 0 0 1 -1.85 1.995l-.15 .005h-2a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-4a2 2 0 0 1 1.85 -1.995l.15 -.005v-1a1 1 0 0 1 .883 -.993l.117 -.007h5a4 4 0 0 0 4 -4a1 1 0 0 0 -.883 -.993l-.117 -.007l-.005 .176a3 3 0 0 1 -2.819 2.819l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-2a3 3 0 0 1 2.824 -2.995l.176 -.005h10z", "key": "svg-0" }]]);

var IconPaintFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPaintFilled
});

var IconPaletteFilled = createReactComponent("filled", "palette-filled", "IconPaletteFilled", [["path", { "d": "M12 2c5.498 0 10 4.002 10 9c0 1.351 -.6 2.64 -1.654 3.576c-1.03 .914 -2.412 1.424 -3.846 1.424h-2.516a1 1 0 0 0 -.5 1.875a1 1 0 0 1 .194 .14a2.3 2.3 0 0 1 -1.597 3.99l-.156 -.009l.068 .004l-.273 -.004c-5.3 -.146 -9.57 -4.416 -9.716 -9.716l-.004 -.28c0 -5.523 4.477 -10 10 -10m-3.5 6.5a2 2 0 0 0 -1.995 1.85l-.005 .15a2 2 0 1 0 2 -2m8 0a2 2 0 0 0 -1.995 1.85l-.005 .15a2 2 0 1 0 2 -2m-4 -3a2 2 0 0 0 -1.995 1.85l-.005 .15a2 2 0 1 0 2 -2", "key": "svg-0" }]]);

var IconPaletteFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPaletteFilled
});

var IconPanoramaHorizontalFilled = createReactComponent("filled", "panorama-horizontal-filled", "IconPanoramaHorizontalFilled", [["path", { "d": "M19.31 4.591a2 2 0 0 1 2.69 1.873v11c0 1.382 -1.38 2.38 -2.694 1.897c-4.879 -1.845 -9.734 -1.845 -14.612 0c-1.304 .495 -2.694 -.481 -2.694 -1.871v-11.032a2 2 0 0 1 2.676 -1.87l.025 .012l.448 .162c4.572 1.623 9.123 1.622 13.703 -.003z", "key": "svg-0" }]]);

var IconPanoramaHorizontalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPanoramaHorizontalFilled
});

var IconPanoramaVerticalFilled = createReactComponent("filled", "panorama-vertical-filled", "IconPanoramaVerticalFilled", [["path", { "d": "M17.53 2c1.39 0 2.364 1.389 1.87 2.692l-.013 .026l-.156 .431c-1.623 4.572 -1.622 9.123 .003 13.703l.168 .458a2 2 0 0 1 -1.873 2.69h-11c-1.386 0 -2.394 -1.386 -1.897 -2.694c1.845 -4.879 1.845 -9.734 0 -14.612c-.495 -1.304 .48 -2.694 1.87 -2.694z", "key": "svg-0" }]]);

var IconPanoramaVerticalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPanoramaVerticalFilled
});

var IconParkingCircleFilled = createReactComponent("filled", "parking-circle-filled", "IconParkingCircleFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -20 0l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72m1.334 5h-3.334a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3h2.334c1.516 0 2.666 -1.38 2.666 -3s-1.15 -3 -2.666 -3m0 2c.323 0 .666 .411 .666 1s-.343 1 -.666 1h-2.334v-2z", "key": "svg-0" }]]);

var IconParkingCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconParkingCircleFilled
});

var IconPawFilled = createReactComponent("filled", "paw-filled", "IconPawFilled", [["path", { "d": "M12 10c-1.32 0 -1.983 .421 -2.931 1.924l-.244 .398l-.395 .688a50.89 50.89 0 0 0 -.141 .254c-.24 .434 -.571 .753 -1.139 1.142l-.55 .365c-.94 .627 -1.432 1.118 -1.707 1.955c-.124 .338 -.196 .853 -.193 1.28c0 1.687 1.198 2.994 2.8 2.994l.242 -.006c.119 -.006 .234 -.017 .354 -.034l.248 -.043l.132 -.028l.291 -.073l.162 -.045l.57 -.17l.763 -.243l.455 -.136c.53 -.15 .94 -.222 1.283 -.222c.344 0 .753 .073 1.283 .222l.455 .136l.764 .242l.569 .171l.312 .084c.097 .024 .187 .045 .273 .062l.248 .043c.12 .017 .235 .028 .354 .034l.242 .006c1.602 0 2.8 -1.307 2.8 -3c0 -.427 -.073 -.939 -.207 -1.306c-.236 -.724 -.677 -1.223 -1.48 -1.83l-.257 -.19l-.528 -.38c-.642 -.47 -1.003 -.826 -1.253 -1.278l-.27 -.485l-.252 -.432c-1.011 -1.696 -1.618 -2.099 -3.053 -2.099z", "key": "svg-0" }], ["path", { "d": "M19.78 7h-.03c-1.219 .02 -2.35 1.066 -2.908 2.504c-.69 1.775 -.348 3.72 1.075 4.333c.256 .109 .527 .163 .801 .163c1.231 0 2.38 -1.053 2.943 -2.504c.686 -1.774 .34 -3.72 -1.076 -4.332a2.05 2.05 0 0 0 -.804 -.164z", "key": "svg-1" }], ["path", { "d": "M9.025 3c-.112 0 -.185 .002 -.27 .015l-.093 .016c-1.532 .206 -2.397 1.989 -2.108 3.855c.272 1.725 1.462 3.114 2.92 3.114l.187 -.005a1.26 1.26 0 0 0 .084 -.01l.092 -.016c1.533 -.206 2.397 -1.989 2.108 -3.855c-.27 -1.727 -1.46 -3.114 -2.92 -3.114z", "key": "svg-2" }], ["path", { "d": "M14.972 3c-1.459 0 -2.647 1.388 -2.916 3.113c-.29 1.867 .574 3.65 2.174 3.867c.103 .013 .2 .02 .296 .02c1.39 0 2.543 -1.265 2.877 -2.883l.041 -.23c.29 -1.867 -.574 -3.65 -2.174 -3.867a2.154 2.154 0 0 0 -.298 -.02z", "key": "svg-3" }], ["path", { "d": "M4.217 7c-.274 0 -.544 .054 -.797 .161c-1.426 .615 -1.767 2.562 -1.078 4.335c.563 1.451 1.71 2.504 2.941 2.504c.274 0 .544 -.054 .797 -.161c1.426 -.615 1.767 -2.562 1.078 -4.335c-.563 -1.451 -1.71 -2.504 -2.941 -2.504z", "key": "svg-4" }]]);

var IconPawFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPawFilled
});

var IconPennant2Filled = createReactComponent("filled", "pennant-2-filled", "IconPennant2Filled", [["path", { "d": "M14 2a1 1 0 0 1 .993 .883l.007 .117v17h1a1 1 0 0 1 .117 1.993l-.117 .007h-4a1 1 0 0 1 -.117 -1.993l.117 -.007h1v-7.351l-8.406 -3.735c-.752 -.335 -.79 -1.365 -.113 -1.77l.113 -.058l8.406 -3.736v-.35a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconPennant2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPennant2Filled
});

var IconPennantFilled = createReactComponent("filled", "pennant-filled", "IconPennantFilled", [["path", { "d": "M10 2a1 1 0 0 1 .993 .883l.007 .117v.35l8.406 3.736c.752 .335 .79 1.365 .113 1.77l-.113 .058l-8.406 3.735v7.351h1a1 1 0 0 1 .117 1.993l-.117 .007h-4a1 1 0 0 1 -.117 -1.993l.117 -.007h1v-17a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconPennantFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPennantFilled
});

var IconPentagonFilled = createReactComponent("filled", "pentagon-filled", "IconPentagonFilled", [["path", { "d": "M10.205 2.6l-6.96 5.238a3 3 0 0 0 -1.045 3.338l2.896 8.765a3 3 0 0 0 2.85 2.059h8.12a3 3 0 0 0 2.841 -2.037l2.973 -8.764a3 3 0 0 0 -1.05 -3.37l-7.033 -5.237l-.091 -.061l-.018 -.01l-.106 -.07a3 3 0 0 0 -3.377 .148z", "key": "svg-0" }]]);

var IconPentagonFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPentagonFilled
});

var IconPhoneFilled = createReactComponent("filled", "phone-filled", "IconPhoneFilled", [["path", { "d": "M9 3a1 1 0 0 1 .877 .519l.051 .11l2 5a1 1 0 0 1 -.313 1.16l-.1 .068l-1.674 1.004l.063 .103a10 10 0 0 0 3.132 3.132l.102 .062l1.005 -1.672a1 1 0 0 1 1.113 -.453l.115 .039l5 2a1 1 0 0 1 .622 .807l.007 .121v4c0 1.657 -1.343 3 -3.06 2.998c-8.579 -.521 -15.418 -7.36 -15.94 -15.998a3 3 0 0 1 2.824 -2.995l.176 -.005h4z", "key": "svg-0" }]]);

var IconPhoneFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhoneFilled
});

var IconPhotoFilled = createReactComponent("filled", "photo-filled", "IconPhotoFilled", [["path", { "d": "M8.813 11.612c.457 -.38 .918 -.38 1.386 .011l.108 .098l4.986 4.986l.094 .083a1 1 0 0 0 1.403 -1.403l-.083 -.094l-1.292 -1.293l.292 -.293l.106 -.095c.457 -.38 .918 -.38 1.386 .011l.108 .098l4.674 4.675a4 4 0 0 1 -3.775 3.599l-.206 .005h-12a4 4 0 0 1 -3.98 -3.603l6.687 -6.69l.106 -.095zm9.187 -9.612a4 4 0 0 1 3.995 3.8l.005 .2v9.585l-3.293 -3.292l-.15 -.137c-1.256 -1.095 -2.85 -1.097 -4.096 -.017l-.154 .14l-.307 .306l-2.293 -2.292l-.15 -.137c-1.256 -1.095 -2.85 -1.097 -4.096 -.017l-.154 .14l-5.307 5.306v-9.585a4 4 0 0 1 3.8 -3.995l.2 -.005h12zm-2.99 5l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconPhotoFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPhotoFilled
});

var IconPictureInPictureTopFilled = createReactComponent("filled", "picture-in-picture-top-filled", "IconPictureInPictureTopFilled", [["path", { "d": "M11 4a1 1 0 0 1 0 2h-6a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-4a1 1 0 0 1 2 0v4a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M20 4a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-5a2 2 0 0 1 -2 -2v-3a2 2 0 0 1 2 -2z", "key": "svg-1" }]]);

var IconPictureInPictureTopFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPictureInPictureTopFilled
});

var IconPictureInPictureFilled = createReactComponent("filled", "picture-in-picture-filled", "IconPictureInPictureFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v4a1 1 0 0 1 -2 0v-4a1 1 0 0 0 -1 -1h-14a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1h6a1 1 0 0 1 0 2h-6a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M20 13a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-5a2 2 0 0 1 -2 -2v-3a2 2 0 0 1 2 -2z", "key": "svg-1" }]]);

var IconPictureInPictureFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPictureInPictureFilled
});

var IconPigFilled = createReactComponent("filled", "pig-filled", "IconPigFilled", [["path", { "d": "M15.999 2a1 1 0 0 1 1.001 1v3.255l.026 .018a7 7 0 0 1 2.204 2.537l.092 .19h.676a2 2 0 0 1 1.995 1.85l.005 .15v2a2 2 0 0 1 -2 2h-.676l-.104 .213a7 7 0 0 1 -1.097 1.558l-.123 .125v1.604a2.5 2.5 0 0 1 -2.336 2.495l-.162 .005c-1.16 0 -2.135 -.79 -2.418 -1.86l-.032 -.141l-4.05 .001l-.05 -.002l-.032 .141a2.5 2.5 0 0 1 -2.254 1.856l-.164 .005a2.5 2.5 0 0 1 -2.5 -2.5v-1.602l-.056 -.055a7 7 0 0 1 -1.576 -7.085l.092 -.256a7 7 0 0 1 6.539 -4.502h2.196l4.25 -2.832a1 1 0 0 1 .436 -.161zm-.999 8a1 1 0 0 0 -.993 .883l-.007 .127a1 1 0 0 0 1.993 .117l.007 -.127a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconPigFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPigFilled
});

var IconPillFilled = createReactComponent("filled", "pill-filled", "IconPillFilled", [["path", { "d": "M20.207 3.793a5.95 5.95 0 0 1 0 8.414l-8 8a5.95 5.95 0 0 1 -8.414 -8.414l8 -8a5.95 5.95 0 0 1 8.414 0m-7 1.414l-4.294 4.293l5.586 5.586l4.294 -4.292a3.95 3.95 0 1 0 -5.586 -5.586", "key": "svg-0" }]]);

var IconPillFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPillFilled
});

var IconPinFilled = createReactComponent("filled", "pin-filled", "IconPinFilled", [["path", { "d": "M15.113 3.21l.094 .083l5.5 5.5a1 1 0 0 1 -1.175 1.59l-3.172 3.171l-1.424 3.797a1 1 0 0 1 -.158 .277l-.07 .08l-1.5 1.5a1 1 0 0 1 -1.32 .082l-.095 -.083l-2.793 -2.792l-3.793 3.792a1 1 0 0 1 -1.497 -1.32l.083 -.094l3.792 -3.793l-2.792 -2.793a1 1 0 0 1 -.083 -1.32l.083 -.094l1.5 -1.5a1 1 0 0 1 .258 -.187l.098 -.042l3.796 -1.425l3.171 -3.17a1 1 0 0 1 1.497 -1.26z", "key": "svg-0" }]]);

var IconPinFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPinFilled
});

var IconPinnedFilled = createReactComponent("filled", "pinned-filled", "IconPinnedFilled", [["path", { "d": "M16 3a1 1 0 0 1 .117 1.993l-.117 .007v4.764l1.894 3.789a1 1 0 0 1 .1 .331l.006 .116v2a1 1 0 0 1 -.883 .993l-.117 .007h-4v4a1 1 0 0 1 -1.993 .117l-.007 -.117v-4h-4a1 1 0 0 1 -.993 -.883l-.007 -.117v-2a1 1 0 0 1 .06 -.34l.046 -.107l1.894 -3.791v-4.762a1 1 0 0 1 -.117 -1.993l.117 -.007h8z", "key": "svg-0" }]]);

var IconPinnedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPinnedFilled
});

var IconPizzaFilled = createReactComponent("filled", "pizza-filled", "IconPizzaFilled", [["path", { "d": "M12.89 2.542l8.5 16.517a1 1 0 0 1 -.446 1.354a20.1 20.1 0 0 1 -8.945 2.087l-.522 -.007a20.1 20.1 0 0 1 -8.423 -2.08a1 1 0 0 1 -.443 -1.354l8.5 -16.517a1 1 0 0 1 1.778 0m-7.064 14.64l-.96 1.865l.409 .17a18.2 18.2 0 0 0 6.226 1.276l.5 .007a18.1 18.1 0 0 0 6.708 -1.279l.424 -.176l-.89 -1.728a15.9 15.9 0 0 1 -6.046 1.183a15.9 15.9 0 0 1 -6.37 -1.318m5.174 -4.192a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883m2 -2.99a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883", "key": "svg-0" }]]);

var IconPizzaFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPizzaFilled
});

var IconPlayCard1Filled = createReactComponent("filled", "play-card-1-filled", "IconPlayCard1Filled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m-5.01 -10a1 1 0 0 0 -1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0 -1 -1m-4.99 -4h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCard1Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard1Filled
});

var IconPlayCard10Filled = createReactComponent("filled", "play-card-10-filled", "IconPlayCard10Filled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m-8.01 -10a1 1 0 0 0 -1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0 -1 -1m4.5 0c-1.453 0 -2.5 1.395 -2.5 3v2c0 1.605 1.047 3 2.5 3s2.5 -1.395 2.5 -3v-2c0 -1.605 -1.047 -3 -2.5 -3m0 2c.203 0 .5 .395 .5 1v2c0 .605 -.297 1 -.5 1s-.5 -.395 -.5 -1v-2c0 -.605 .297 -1 .5 -1m-6.49 -6h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCard10Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard10Filled
});

var IconPlayCard2Filled = createReactComponent("filled", "play-card-2-filled", "IconPlayCard2Filled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m-4.01 -10h-3a1 1 0 1 0 0 2h3v1h-2a2 2 0 0 0 -2 2v1a2 2 0 0 0 2 2h3a1 1 0 0 0 0 -2h-3v-1h2a2 2 0 0 0 2 -2v-1a2 2 0 0 0 -2 -2m-5.99 -4h-.01a1 1 0 1 0 0 2h.01a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCard2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard2Filled
});

var IconPlayCard3Filled = createReactComponent("filled", "play-card-3-filled", "IconPlayCard3Filled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m-4.51 -10h-2.5a1 1 0 1 0 0 2h2.5a.5 .5 0 0 1 .09 .992l-.09 .008h-1.5c-1.287 0 -1.332 1.864 -.133 1.993l.133 .007h1.5a.5 .5 0 1 1 0 1h-2.5a1 1 0 0 0 0 2h2.5a2.5 2.5 0 0 0 2.5 -2.5l-.005 -.164a2.5 2.5 0 0 0 -.477 -1.312l-.019 -.024l.019 -.024a2.5 2.5 0 0 0 -2.018 -3.976m-5.49 -4h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCard3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard3Filled
});

var IconPlayCard4Filled = createReactComponent("filled", "play-card-4-filled", "IconPlayCard4Filled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m-3.01 -10a1 1 0 0 0 -1 1v2h-2v-2a1 1 0 0 0 -2 0v2a2 2 0 0 0 2 2h2v2a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1m-6.99 -4h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCard4Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard4Filled
});

var IconPlayCard5Filled = createReactComponent("filled", "play-card-5-filled", "IconPlayCard5Filled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m-3.01 -10h-4a1 1 0 0 0 -1 1v3a1 1 0 0 0 1 1h3v1h-3a1 1 0 0 0 0 2h3a2 2 0 0 0 2 -2v-1l-.005 -.15a2 2 0 0 0 -1.995 -1.85h-2v-1h3a1 1 0 0 0 0 -2m-6.99 -4h-.01a1 1 0 1 0 0 2h.01a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCard5Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard5Filled
});

var IconPlayCard6Filled = createReactComponent("filled", "play-card-6-filled", "IconPlayCard6Filled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m-3.01 -10h-3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-1l-.005 -.15a2 2 0 0 0 -1.995 -1.85h-2v-1h3a1 1 0 0 0 0 -2m-1 5v1h-2v-1zm-5.99 -9h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCard6Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard6Filled
});

var IconPlayCard7Filled = createReactComponent("filled", "play-card-7-filled", "IconPlayCard7Filled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m-3.01 -10h-4a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883h2.612l-1.56 4.684a1 1 0 1 0 1.897 .632l2 -6a1 1 0 0 0 -.949 -1.316m-6.99 -4h-.01a1 1 0 1 0 0 2h.01a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCard7Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard7Filled
});

var IconPlayCard8Filled = createReactComponent("filled", "play-card-8-filled", "IconPlayCard8Filled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m-4.01 -10h-2a2 2 0 0 0 -2 2v1c0 .365 .098 .707 .268 1.001c-.17 .293 -.268 .635 -.268 .999v1a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-1a2 2 0 0 0 -.268 -1c.17 -.293 .268 -.635 .268 -1v-1a2 2 0 0 0 -2 -2m0 5v1h-2v-1zm0 -3v1h-2v-1zm-5.99 -6h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCard8Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard8Filled
});

var IconPlayCard9Filled = createReactComponent("filled", "play-card-9-filled", "IconPlayCard9Filled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m-4.01 -10h-2a2 2 0 0 0 -2 2v1l.005 .15a2 2 0 0 0 1.995 1.85h2v1h-3a1 1 0 0 0 0 2h3a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2m0 2v1h-2v-1zm-5.99 -6h-.01a1 1 0 1 0 0 2h.01a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCard9Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCard9Filled
});

var IconPlayCardAFilled = createReactComponent("filled", "play-card-a-filled", "IconPlayCardAFilled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m-5.01 -10a3 3 0 0 0 -3 3v4a1 1 0 0 0 2 0v-1h2v1a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-4a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v1h-2v-1a1 1 0 0 1 .883 -.993zm-4.99 -6h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCardAFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCardAFilled
});

var IconPlayCardJFilled = createReactComponent("filled", "play-card-j-filled", "IconPlayCardJFilled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m-3.01 -10h-4a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883h3v3a1 1 0 0 1 -2 0a1 1 0 0 0 -2 0a3 3 0 0 0 6 0v-4a1 1 0 0 0 -1 -1m-6.99 -4h-.01a1 1 0 1 0 0 2h.01a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCardJFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCardJFilled
});

var IconPlayCardKFilled = createReactComponent("filled", "play-card-k-filled", "IconPlayCardKFilled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m-7.01 -10a1 1 0 0 0 -1 1v6a1 1 0 0 0 2 0v-1.585l2.293 2.292a1 1 0 0 0 1.32 .083l.094 -.083l.083 -.094a1 1 0 0 0 -.083 -1.32l-2.292 -2.293l2.292 -2.293a1 1 0 1 0 -1.414 -1.414l-2.293 2.291v-1.584a1 1 0 0 0 -.883 -.993zm-2.99 -4h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCardKFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCardKFilled
});

var IconPlayCardQFilled = createReactComponent("filled", "play-card-q-filled", "IconPlayCardQFilled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m-5.01 -10a3 3 0 0 0 -3 3v2a3 3 0 0 0 4.293 2.708l.5 .5a1 1 0 0 0 1.414 -1.415l-.499 -.5c.187 -.392 .292 -.83 .292 -1.293v-2a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v2a1 1 0 0 1 -2 0v-2a1 1 0 0 1 1 -1m-4.99 -6h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCardQFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCardQFilled
});

var IconPlayCardStarFilled = createReactComponent("filled", "play-card-star-filled", "IconPlayCardStarFilled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm.01 16h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 0 0 0 -2m-4.98 -9.5l-.115 .005c-.384 .04 -.724 .273 -.898 .623l-.51 1.027l-1.138 .166c-.423 .059 -.78 .357 -.914 .768l-.033 .125a1.13 1.13 0 0 0 .322 1.039l.82 .797l-.194 1.127c-.07 .432 .107 .857 .454 1.108l.107 .068a1.13 1.13 0 0 0 1.078 .018l1.022 -.536l1.019 .535c.377 .2 .84 .168 1.19 -.086l.1 -.08c.281 -.259 .416 -.645 .35 -1.028l-.194 -1.126l.823 -.799c.31 -.302 .42 -.752 .287 -1.161l-.042 -.11a1.13 1.13 0 0 0 -.873 -.659l-1.138 -.166l-.508 -1.026a1.13 1.13 0 0 0 -1.014 -.63m-5.021 -4.499h-.01a1 1 0 0 0 -.117 1.993l.127 .007a1 1 0 1 0 0 -2", "key": "svg-0" }]]);

var IconPlayCardStarFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayCardStarFilled
});

var IconPlayerEjectFilled = createReactComponent("filled", "player-eject-filled", "IconPlayerEjectFilled", [["path", { "d": "M11.247 3.341l-7 8c-.565 .647 -.106 1.659 .753 1.659h14c.86 0 1.318 -1.012 .753 -1.659l-7 -8a1 1 0 0 0 -1.506 0z", "key": "svg-0" }], ["path", { "d": "M18 15h-12a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z", "key": "svg-1" }]]);

var IconPlayerEjectFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerEjectFilled
});

var IconPlayerPauseFilled = createReactComponent("filled", "player-pause-filled", "IconPlayerPauseFilled", [["path", { "d": "M9 4h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M17 4h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z", "key": "svg-1" }]]);

var IconPlayerPauseFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerPauseFilled
});

var IconPlayerPlayFilled = createReactComponent("filled", "player-play-filled", "IconPlayerPlayFilled", [["path", { "d": "M6 4v16a1 1 0 0 0 1.524 .852l13 -8a1 1 0 0 0 0 -1.704l-13 -8a1 1 0 0 0 -1.524 .852z", "key": "svg-0" }]]);

var IconPlayerPlayFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerPlayFilled
});

var IconPlayerRecordFilled = createReactComponent("filled", "player-record-filled", "IconPlayerRecordFilled", [["path", { "d": "M8 5.072a8 8 0 1 1 -3.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 3.995 -6.643z", "key": "svg-0" }]]);

var IconPlayerRecordFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerRecordFilled
});

var IconPlayerSkipBackFilled = createReactComponent("filled", "player-skip-back-filled", "IconPlayerSkipBackFilled", [["path", { "d": "M19.496 4.136l-12 7a1 1 0 0 0 0 1.728l12 7a1 1 0 0 0 1.504 -.864v-14a1 1 0 0 0 -1.504 -.864z", "key": "svg-0" }], ["path", { "d": "M4 4a1 1 0 0 1 .993 .883l.007 .117v14a1 1 0 0 1 -1.993 .117l-.007 -.117v-14a1 1 0 0 1 1 -1z", "key": "svg-1" }]]);

var IconPlayerSkipBackFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerSkipBackFilled
});

var IconPlayerSkipForwardFilled = createReactComponent("filled", "player-skip-forward-filled", "IconPlayerSkipForwardFilled", [["path", { "d": "M3 5v14a1 1 0 0 0 1.504 .864l12 -7a1 1 0 0 0 0 -1.728l-12 -7a1 1 0 0 0 -1.504 .864z", "key": "svg-0" }], ["path", { "d": "M20 4a1 1 0 0 1 .993 .883l.007 .117v14a1 1 0 0 1 -1.993 .117l-.007 -.117v-14a1 1 0 0 1 1 -1z", "key": "svg-1" }]]);

var IconPlayerSkipForwardFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerSkipForwardFilled
});

var IconPlayerStopFilled = createReactComponent("filled", "player-stop-filled", "IconPlayerStopFilled", [["path", { "d": "M17 4h-10a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z", "key": "svg-0" }]]);

var IconPlayerStopFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerStopFilled
});

var IconPlayerTrackNextFilled = createReactComponent("filled", "player-track-next-filled", "IconPlayerTrackNextFilled", [["path", { "d": "M2 5v14c0 .86 1.012 1.318 1.659 .753l8 -7a1 1 0 0 0 0 -1.506l-8 -7c-.647 -.565 -1.659 -.106 -1.659 .753z", "key": "svg-0" }], ["path", { "d": "M13 5v14c0 .86 1.012 1.318 1.659 .753l8 -7a1 1 0 0 0 0 -1.506l-8 -7c-.647 -.565 -1.659 -.106 -1.659 .753z", "key": "svg-1" }]]);

var IconPlayerTrackNextFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerTrackNextFilled
});

var IconPlayerTrackPrevFilled = createReactComponent("filled", "player-track-prev-filled", "IconPlayerTrackPrevFilled", [["path", { "d": "M20.341 4.247l-8 7a1 1 0 0 0 0 1.506l8 7c.647 .565 1.659 .106 1.659 -.753v-14c0 -.86 -1.012 -1.318 -1.659 -.753z", "key": "svg-0" }], ["path", { "d": "M9.341 4.247l-8 7a1 1 0 0 0 0 1.506l8 7c.647 .565 1.659 .106 1.659 -.753v-14c0 -.86 -1.012 -1.318 -1.659 -.753z", "key": "svg-1" }]]);

var IconPlayerTrackPrevFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPlayerTrackPrevFilled
});

var IconPointFilled = createReactComponent("filled", "point-filled", "IconPointFilled", [["path", { "d": "M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z", "key": "svg-0" }]]);

var IconPointFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointFilled
});

var IconPointerFilled = createReactComponent("filled", "pointer-filled", "IconPointerFilled", [["path", { "d": "M3.039 4.277l3.904 13.563c.185 .837 .92 1.516 1.831 1.642l.17 .016a2.2 2.2 0 0 0 1.982 -1.006l.045 -.078l1.4 -2.072l4.05 4.05a2.067 2.067 0 0 0 2.924 0l1.047 -1.047c.388 -.388 .606 -.913 .606 -1.461l-.008 -.182a2.067 2.067 0 0 0 -.598 -1.28l-4.047 -4.048l2.103 -1.412c.726 -.385 1.18 -1.278 1.053 -2.189a2.2 2.2 0 0 0 -1.701 -1.845l-13.524 -3.89a1 1 0 0 0 -1.236 1.24z", "key": "svg-0" }]]);

var IconPointerFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPointerFilled
});

var IconPolaroidFilled = createReactComponent("filled", "polaroid-filled", "IconPolaroidFilled", [["path", { "d": "M9.199 9.623l.108 .098l3.986 3.986l.094 .083a1 1 0 0 0 1.403 -1.403l-.083 -.094l-.292 -.293l1.292 -1.293l.106 -.095c.457 -.38 .918 -.38 1.386 .011l.108 .098l4.502 4.503a4.003 4.003 0 0 1 -3.596 2.77l-.213 .006h-12a4.002 4.002 0 0 1 -3.809 -2.775l5.516 -5.518l.106 -.095c.457 -.38 .918 -.38 1.386 .011zm8.801 -7.623a4 4 0 0 1 3.995 3.8l.005 .2v6.585l-3.293 -3.292l-.15 -.137c-1.256 -1.095 -2.85 -1.097 -4.096 -.017l-.154 .14l-1.307 1.306l-2.293 -2.292l-.15 -.137c-1.256 -1.095 -2.85 -1.097 -4.096 -.017l-.154 .14l-4.307 4.306v-6.585a4 4 0 0 1 3.8 -3.995l.2 -.005h12zm-2.99 3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }], ["path", { "d": "M8.01 20a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-1" }], ["path", { "d": "M12.01 20a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-2" }], ["path", { "d": "M16.01 20a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z", "key": "svg-3" }]]);

var IconPolaroidFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPolaroidFilled
});

var IconPooFilled = createReactComponent("filled", "poo-filled", "IconPooFilled", [["path", { "d": "M11.063 2.995l.086 .009h.07c2.237 .098 3.87 1.686 4.214 4.046l.01 .075l.133 .04a3.5 3.5 0 0 1 1.718 1.22l.125 .179a3.5 3.5 0 0 1 .567 2.243l-.006 .049l.032 .025a4 4 0 0 1 1.476 2.8l.01 .191l.15 .125a4 4 0 0 1 1.29 3.693l-.042 .208c-.4 1.728 -1.89 2.986 -3.72 3.092h-10.176a4 4 0 0 1 -2.638 -7.008l.14 -.118l.011 -.19a4 4 0 0 1 1.476 -2.798l.032 -.025l-.006 -.048a3.5 3.5 0 0 1 .452 -2.058l.114 -.186c.603 -.912 1.598 -1.49 2.755 -1.564h.164c.743 0 1.26 -1.242 .606 -2.553l.006 .015l-.01 -.017a1 1 0 0 1 -.095 -.323l-.007 -.117c0 -.654 .539 -1.031 1.063 -1.005m3.758 12.434a1 1 0 0 0 -1.392 -.25a2.5 2.5 0 0 1 -2.858 0a1 1 0 0 0 -1.142 1.642a4.5 4.5 0 0 0 5.142 0a1 1 0 0 0 .25 -1.392m-4.811 -4.429h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2m4 0h-.01a1 1 0 0 0 0 2h.01a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconPooFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPooFilled
});

var IconPresentationAnalyticsFilled = createReactComponent("filled", "presentation-analytics-filled", "IconPresentationAnalyticsFilled", [["path", { "d": "M21 3a1 1 0 0 1 0 2v9a3 3 0 0 1 -3 3h-5v2h2a1 1 0 0 1 0 2h-6a1 1 0 0 1 0 -2h2v-2h-5a3 3 0 0 1 -3 -3v-9a1 1 0 1 1 0 -2zm-12 4a1 1 0 0 0 -1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0 -1 -1m6 2a1 1 0 0 0 -1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0 -1 -1m-3 1a1 1 0 0 0 -1 1v1a1 1 0 0 0 2 0v-1a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconPresentationAnalyticsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPresentationAnalyticsFilled
});

var IconPresentationFilled = createReactComponent("filled", "presentation-filled", "IconPresentationFilled", [["path", { "d": "M21 3a1 1 0 0 1 0 2v9a3 3 0 0 1 -3 3h-5v2h2a1 1 0 0 1 0 2h-6a1 1 0 0 1 0 -2h2v-2h-5a3 3 0 0 1 -3 -3v-9a1 1 0 1 1 0 -2zm-4.293 4.293a1 1 0 0 0 -1.414 0l-2.293 2.292l-1.293 -1.292a1 1 0 0 0 -1.414 0l-3 3a1 1 0 0 0 0 1.414l.094 .083a1 1 0 0 0 1.32 -.083l2.293 -2.292l1.293 1.292a1 1 0 0 0 1.414 0l3 -3a1 1 0 0 0 0 -1.414", "key": "svg-0" }]]);

var IconPresentationFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPresentationFilled
});

var IconPuzzleFilled = createReactComponent("filled", "puzzle-filled", "IconPuzzleFilled", [["path", { "d": "M10 2a3 3 0 0 1 2.995 2.824l.005 .176v1h3a2 2 0 0 1 1.995 1.85l.005 .15v3h1a3 3 0 0 1 .176 5.995l-.176 .005h-1v3a2 2 0 0 1 -1.85 1.995l-.15 .005h-3a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-1a1 1 0 0 0 -1.993 -.117l-.007 .117v1a2 2 0 0 1 -1.85 1.995l-.15 .005h-3a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 1.85 -1.995l.15 -.005h1a1 1 0 0 0 .117 -1.993l-.117 -.007h-1a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 1.85 -1.995l.15 -.005h3v-1a3 3 0 0 1 3 -3z", "key": "svg-0" }]]);

var IconPuzzleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconPuzzleFilled
});

var IconQuoteFilled = createReactComponent("filled", "quote-filled", "IconQuoteFilled", [["path", { "d": "M9 5a2 2 0 0 1 2 2v6c0 3.13 -1.65 5.193 -4.757 5.97a1 1 0 1 1 -.486 -1.94c2.227 -.557 3.243 -1.827 3.243 -4.03v-1h-3a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M18 5a2 2 0 0 1 2 2v6c0 3.13 -1.65 5.193 -4.757 5.97a1 1 0 1 1 -.486 -1.94c2.227 -.557 3.243 -1.827 3.243 -4.03v-1h-3a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 2 -2z", "key": "svg-1" }]]);

var IconQuoteFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconQuoteFilled
});

var IconRadarFilled = createReactComponent("filled", "radar-filled", "IconRadarFilled", [["path", { "d": "M12 10a2 2 0 0 1 1.678 .911l.053 .089h7.269l.117 .007a1 1 0 0 1 .883 .993c0 5.523 -4.477 10 -10 10a1 1 0 0 1 -1 -1v-7.269l-.089 -.053a2 2 0 0 1 -.906 -1.529l-.005 -.149a2 2 0 0 1 2 -2m9.428 -1.334a1 1 0 0 1 -1.884 .668a8 8 0 1 0 -10.207 10.218a1 1 0 0 1 -.666 1.886a10 10 0 1 1 12.757 -12.772m-4.628 -.266a1 1 0 0 1 -1.6 1.2a4 4 0 1 0 -5.6 5.6a1 1 0 0 1 -1.2 1.6a6 6 0 1 1 8.4 -8.4", "key": "svg-0" }]]);

var IconRadarFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadarFilled
});

var IconRadioactiveFilled = createReactComponent("filled", "radioactive-filled", "IconRadioactiveFilled", [["path", { "d": "M21 11a1 1 0 0 1 1 1a10 10 0 0 1 -5 8.656a1 1 0 0 1 -1.302 -.268l-.064 -.098l-3 -5.19a.995 .995 0 0 1 -.133 -.542l.01 -.11l.023 -.106l.034 -.106l.046 -.1l.056 -.094l.067 -.089a.994 .994 0 0 1 .165 -.155l.098 -.064a2 2 0 0 0 .993 -1.57l.007 -.163a1 1 0 0 1 .883 -.994l.117 -.007h6z", "key": "svg-0" }], ["path", { "d": "M7 3.344a10 10 0 0 1 10 0a1 1 0 0 1 .418 1.262l-.052 .104l-3 5.19l-.064 .098a.994 .994 0 0 1 -.155 .165l-.089 .067a1 1 0 0 1 -.195 .102l-.105 .034l-.107 .022a1.003 1.003 0 0 1 -.547 -.07l-.104 -.052a2 2 0 0 0 -1.842 -.082l-.158 .082a1 1 0 0 1 -1.302 -.268l-.064 -.098l-3 -5.19a1 1 0 0 1 .366 -1.366z", "key": "svg-1" }], ["path", { "d": "M9 11a1 1 0 0 1 .993 .884l.007 .117a2 2 0 0 0 .861 1.645l.237 .152a.994 .994 0 0 1 .165 .155l.067 .089l.056 .095l.045 .099c.014 .036 .026 .07 .035 .106l.022 .107l.011 .11a.994 .994 0 0 1 -.08 .437l-.053 .104l-3 5.19a1 1 0 0 1 -1.366 .366a10 10 0 0 1 -5 -8.656a1 1 0 0 1 .883 -.993l.117 -.007h6z", "key": "svg-2" }]]);

var IconRadioactiveFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRadioactiveFilled
});

var IconReceiptFilled = createReactComponent("filled", "receipt-filled", "IconReceiptFilled", [["path", { "d": "M17 2a3 3 0 0 1 3 3v16a1 1 0 0 1 -1.555 .832l-2.318 -1.545l-1.42 1.42a1 1 0 0 1 -1.32 .083l-.094 -.083l-1.293 -1.292l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083l-1.421 -1.42l-2.317 1.545l-.019 .012l-.054 .03l-.028 .017l-.054 .023l-.05 .023l-.049 .015l-.06 .019l-.052 .009l-.057 .011l-.084 .006l-.026 .003h-.022l-.049 -.003h-.039l-.013 -.003h-.016l-.041 -.008l-.038 -.005l-.015 -.005l-.018 -.002l-.034 -.011l-.04 -.01l-.019 -.007l-.015 -.004l-.029 -.013l-.04 -.015l-.021 -.011l-.013 -.005l-.028 -.016l-.036 -.018l-.014 -.01l-.018 -.01l-.038 -.027l-.022 -.014l-.01 -.009l-.02 -.014l-.045 -.041l-.012 -.008l-.024 -.024l-.035 -.039l-.02 -.02l-.007 -.011l-.011 -.012l-.032 -.045l-.02 -.025l-.012 -.019l-.03 -.054l-.017 -.028l-.023 -.054l-.023 -.05a1 1 0 0 1 -.034 -.108l-.01 -.057l-.01 -.053l-.009 -.132v-16a3 3 0 0 1 3 -3zm-2 12h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0 -2m0 -4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2m0 -4h-6a1 1 0 1 0 0 2h6a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconReceiptFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReceiptFilled
});

var IconRectangleVerticalFilled = createReactComponent("filled", "rectangle-vertical-filled", "IconRectangleVerticalFilled", [["path", { "d": "M17 2h-10a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3z", "key": "svg-0" }]]);

var IconRectangleVerticalFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRectangleVerticalFilled
});

var IconRectangleFilled = createReactComponent("filled", "rectangle-filled", "IconRectangleFilled", [["path", { "d": "M19 4h-14a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z", "key": "svg-0" }]]);

var IconRectangleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRectangleFilled
});

var IconRelationManyToManyFilled = createReactComponent("filled", "relation-many-to-many-filled", "IconRelationManyToManyFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-3.2 5.4c-.577 -.769 -1.8 -.361 -1.8 .6v4a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-1l1.2 1.6c.577 .769 1.8 .361 1.8 -.6v-4a1 1 0 0 0 -1 -1l-.117 .007a1 1 0 0 0 -.883 .993v1zm-9 0c-.577 -.769 -1.8 -.361 -1.8 .6v4a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-1l1.2 1.6c.577 .769 1.8 .361 1.8 -.6v-4a1 1 0 0 0 -1 -1l-.117 .007a1 1 0 0 0 -.883 .993v1zm5.2 3.1a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m0 -3a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconRelationManyToManyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRelationManyToManyFilled
});

var IconRelationOneToManyFilled = createReactComponent("filled", "relation-one-to-many-filled", "IconRelationOneToManyFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-4.2 5.4c-.577 -.769 -1.8 -.361 -1.8 .6v4a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-1l1.2 1.6c.577 .769 1.8 .361 1.8 -.6v-4a1 1 0 0 0 -1 -1l-.117 .007a1 1 0 0 0 -.883 .993v1zm-6.8 -.4h-1a1 1 0 1 0 0 2v3a1 1 0 0 0 2 0v-4a1 1 0 0 0 -1 -1m3 3.5a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m0 -3a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconRelationOneToManyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRelationOneToManyFilled
});

var IconRelationOneToOneFilled = createReactComponent("filled", "relation-one-to-one-filled", "IconRelationOneToOneFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-10 5h-1a1 1 0 1 0 0 2v3a1 1 0 0 0 2 0v-4a1 1 0 0 0 -1 -1m7 0h-1a1 1 0 0 0 0 2v3a1 1 0 0 0 2 0v-4a1 1 0 0 0 -1 -1m-4 3.5a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1m0 -3a1 1 0 0 0 -1 1v.01a1 1 0 0 0 2 0v-.01a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconRelationOneToOneFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRelationOneToOneFilled
});

var IconReplaceFilled = createReactComponent("filled", "replace-filled", "IconReplaceFilled", [["path", { "d": "M8 2h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z", "key": "svg-0" }], ["path", { "d": "M20 14h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z", "key": "svg-1" }], ["path", { "d": "M16.707 2.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.293 1.293h3.586a3 3 0 0 1 2.995 2.824l.005 .176v3a1 1 0 0 1 -1.993 .117l-.007 -.117v-3a1 1 0 0 0 -.883 -.993l-.117 -.007h-3.585l1.292 1.293a1 1 0 0 1 -1.32 1.497l-.094 -.083l-3 -3a.98 .98 0 0 1 -.28 -.872l.036 -.146l.04 -.104c.058 -.126 .14 -.24 .245 -.334l2.959 -2.958a1 1 0 0 1 1.414 0z", "key": "svg-2" }], ["path", { "d": "M3 12a1 1 0 0 1 .993 .883l.007 .117v3a1 1 0 0 0 .883 .993l.117 .007h3.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083l.094 .083l3 3a.98 .98 0 0 1 .28 .872l-.036 .146l-.04 .104a1.02 1.02 0 0 1 -.245 .334l-2.959 2.958a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.291 -1.293h-3.584a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-3a1 1 0 0 1 1 -1z", "key": "svg-3" }]]);

var IconReplaceFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconReplaceFilled
});

var IconRollercoasterFilled = createReactComponent("filled", "rollercoaster-filled", "IconRollercoasterFilled", [["path", { "d": "M21 8a1 1 0 0 1 0 2v11a1 1 0 0 1 -2 0v-11h-1.675q -.163 0 -.325 .007v10.993a1 1 0 0 1 -2 0v-10.645a7.8 7.8 0 0 0 -2 .959v9.686a1 1 0 0 1 -2 0v-7.748a7.8 7.8 0 0 0 -1.051 2.064l-.735 2.205a7 7 0 0 1 -.213 .553l-.001 2.926a1 1 0 0 1 -2 0l.001 -.364a6.54 6.54 0 0 1 -4.001 1.364a1 1 0 0 1 0 -2a4.55 4.55 0 0 0 4.316 -3.111l.735 -2.205a9.775 9.775 0 0 1 9.274 -6.684zm-10.22 -3.625l2 2.5a1 1 0 0 1 -.18 1.425l-4 3a1 1 0 0 1 -.868 .164l-1.8 -.5a1 1 0 0 1 -.727 -.864l-.2 -2a1 1 0 0 1 .395 -.9l4 -3a1 1 0 0 1 1.38 .175m9.22 -2.375a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconRollercoasterFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRollercoasterFilled
});

var IconRosetteDiscountCheckFilled = createReactComponent("filled", "rosette-discount-check-filled", "IconRosetteDiscountCheckFilled", [["path", { "d": "M12.01 2.011a3.2 3.2 0 0 1 2.113 .797l.154 .145l.698 .698a1.2 1.2 0 0 0 .71 .341l.135 .008h1a3.2 3.2 0 0 1 3.195 3.018l.005 .182v1c0 .27 .092 .533 .258 .743l.09 .1l.697 .698a3.2 3.2 0 0 1 .147 4.382l-.145 .154l-.698 .698a1.2 1.2 0 0 0 -.341 .71l-.008 .135v1a3.2 3.2 0 0 1 -3.018 3.195l-.182 .005h-1a1.2 1.2 0 0 0 -.743 .258l-.1 .09l-.698 .697a3.2 3.2 0 0 1 -4.382 .147l-.154 -.145l-.698 -.698a1.2 1.2 0 0 0 -.71 -.341l-.135 -.008h-1a3.2 3.2 0 0 1 -3.195 -3.018l-.005 -.182v-1a1.2 1.2 0 0 0 -.258 -.743l-.09 -.1l-.697 -.698a3.2 3.2 0 0 1 -.147 -4.382l.145 -.154l.698 -.698a1.2 1.2 0 0 0 .341 -.71l.008 -.135v-1l.005 -.182a3.2 3.2 0 0 1 3.013 -3.013l.182 -.005h1a1.2 1.2 0 0 0 .743 -.258l.1 -.09l.698 -.697a3.2 3.2 0 0 1 2.269 -.944zm3.697 7.282a1 1 0 0 0 -1.414 0l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z", "key": "svg-0" }]]);

var IconRosetteDiscountCheckFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteDiscountCheckFilled
});

var IconRosetteDiscountFilled = createReactComponent("filled", "rosette-discount-filled", "IconRosetteDiscountFilled", [["path", { "d": "M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3", "key": "svg-0" }]]);

var IconRosetteDiscountFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteDiscountFilled
});

var IconRosetteFilled = createReactComponent("filled", "rosette-filled", "IconRosetteFilled", [["path", { "d": "M12.01 2.011a3.2 3.2 0 0 1 2.113 .797l.154 .145l.698 .698a1.2 1.2 0 0 0 .71 .341l.135 .008h1a3.2 3.2 0 0 1 3.195 3.018l.005 .182v1c0 .27 .092 .533 .258 .743l.09 .1l.697 .698a3.2 3.2 0 0 1 .147 4.382l-.145 .154l-.698 .698a1.2 1.2 0 0 0 -.341 .71l-.008 .135v1a3.2 3.2 0 0 1 -3.018 3.195l-.182 .005h-1a1.2 1.2 0 0 0 -.743 .258l-.1 .09l-.698 .697a3.2 3.2 0 0 1 -4.382 .147l-.154 -.145l-.698 -.698a1.2 1.2 0 0 0 -.71 -.341l-.135 -.008h-1a3.2 3.2 0 0 1 -3.195 -3.018l-.005 -.182v-1a1.2 1.2 0 0 0 -.258 -.743l-.09 -.1l-.697 -.698a3.2 3.2 0 0 1 -.147 -4.382l.145 -.154l.698 -.698a1.2 1.2 0 0 0 .341 -.71l.008 -.135v-1l.005 -.182a3.2 3.2 0 0 1 3.013 -3.013l.182 -.005h1a1.2 1.2 0 0 0 .743 -.258l.1 -.09l.698 -.697a3.2 3.2 0 0 1 2.269 -.944z", "key": "svg-0" }]]);

var IconRosetteFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconRosetteFilled
});

var IconSaladFilled = createReactComponent("filled", "salad-filled", "IconSaladFilled", [["path", { "d": "M9.53 3.152l3.742 2.339q 1.492 -.491 3.472 -.491h2.256a1 1 0 0 1 1 1l-.001 1.336l-.05 .895l-.042 .585c-.037 .457 -.08 .84 -.134 1.185l.227 -.001a2 2 0 0 1 2 2v.5c0 1.694 -2.247 5.49 -3.983 6.983l-.017 .013v.504a2 2 0 0 1 -1.85 1.995l-.15 .005h-8a2 2 0 0 1 -2 -2v-.496l-.065 -.053c-1.76 -1.496 -3.794 -4.965 -3.928 -6.77l-.007 -.181v-.5a2 2 0 0 1 2 -2h.078a14 14 0 0 1 -.078 -1v-1a1 1 0 0 1 1 -1h1.755c.138 0 .287 .034 .44 .092l.835 -3.335a1 1 0 0 1 1.5 -.605m-2.193 5.847l-1.335 .001l.027 .42q .025 .292 .064 .58h.942q .078 -.533 .302 -1.001m10.663 -1.999h-1.256c-1.712 0 -3.003 .31 -3.922 .88a3.5 3.5 0 0 1 1.143 2.12h3.774c.127 -.615 .194 -1.4 .261 -2.714zm-7.5 2a1.5 1.5 0 0 0 -1.414 1h2.828a1.5 1.5 0 0 0 -.845 -.888l-.166 -.056a1.5 1.5 0 0 0 -.403 -.056m-.864 -3.424l-.415 1.665a3.5 3.5 0 0 1 1.502 -.234a6 6 0 0 1 .497 -.442z", "key": "svg-0" }]]);

var IconSaladFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSaladFilled
});

var IconScubaDivingTankFilled = createReactComponent("filled", "scuba-diving-tank-filled", "IconScubaDivingTankFilled", [["path", { "d": "M17 17v2a3 3 0 0 1 -3 3h-4a3 3 0 0 1 -3 -3v-2z", "key": "svg-0" }], ["path", { "d": "M8 2a2 2 0 0 1 1.732 1h1.15a1.496 1.496 0 0 1 2.236 0h1.882a1 1 0 0 1 0 2l-1.883 .001a2 2 0 0 1 -.115 .116v.983a5 5 0 0 1 3.998 4.9v4h-10v-4a5 5 0 0 1 4 -4.9v-.983a2 2 0 0 1 -.117 -.116h-1.151a2 2 0 1 1 -1.732 -3.001", "key": "svg-1" }]]);

var IconScubaDivingTankFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconScubaDivingTankFilled
});

var IconSectionFilled = createReactComponent("filled", "section-filled", "IconSectionFilled", [["path", { "d": "M20.01 19a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993zm-16 0a1 1 0 0 1 0 2a1 1 0 0 1 -.127 -1.993zm4 0a1 1 0 0 1 0 2a1 1 0 0 1 -.127 -1.993zm4 0a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993zm4 0a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993zm4 -16a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993zm-16 0a1 1 0 1 1 0 2a1 1 0 0 1 -.127 -1.993zm4 0a1 1 0 1 1 0 2a1 1 0 0 1 -.127 -1.993zm4 0a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993zm3.99 0a1 1 0 0 1 1 1a1 1 0 1 1 -2 .01c0 -.562 .448 -1.01 1 -1.01m3 4a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2z", "key": "svg-0" }]]);

var IconSectionFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSectionFilled
});

var IconSeedlingFilled = createReactComponent("filled", "seedling-filled", "IconSeedlingFilled", [["path", { "d": "M6 3a7 7 0 0 1 6.95 6.155a6.97 6.97 0 0 1 5.05 -2.155h3a1 1 0 0 1 1 1v1a7 7 0 0 1 -7 7h-2v4a1 1 0 0 1 -2 0v-7h-2a7 7 0 0 1 -7 -7v-2a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconSeedlingFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSeedlingFilled
});

var IconSettingsFilled = createReactComponent("filled", "settings-filled", "IconSettingsFilled", [["path", { "d": "M14.647 4.081a.724 .724 0 0 0 1.08 .448c2.439 -1.485 5.23 1.305 3.745 3.744a.724 .724 0 0 0 .447 1.08c2.775 .673 2.775 4.62 0 5.294a.724 .724 0 0 0 -.448 1.08c1.485 2.439 -1.305 5.23 -3.744 3.745a.724 .724 0 0 0 -1.08 .447c-.673 2.775 -4.62 2.775 -5.294 0a.724 .724 0 0 0 -1.08 -.448c-2.439 1.485 -5.23 -1.305 -3.745 -3.744a.724 .724 0 0 0 -.447 -1.08c-2.775 -.673 -2.775 -4.62 0 -5.294a.724 .724 0 0 0 .448 -1.08c-1.485 -2.439 1.305 -5.23 3.744 -3.745a.722 .722 0 0 0 1.08 -.447c.673 -2.775 4.62 -2.775 5.294 0zm-2.647 4.919a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z", "key": "svg-0" }]]);

var IconSettingsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSettingsFilled
});

var IconShieldCheckFilled = createReactComponent("filled", "shield-check-filled", "IconShieldCheckFilled", [["path", { "d": "M11.998 2l.118 .007l.059 .008l.061 .013l.111 .034a.993 .993 0 0 1 .217 .112l.104 .082l.255 .218a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.531 -2.527l.263 -.225l.096 -.075a.993 .993 0 0 1 .217 -.112l.112 -.034a.97 .97 0 0 1 .119 -.021l.115 -.007zm3.71 7.293a1 1 0 0 0 -1.415 0l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z", "key": "svg-0" }]]);

var IconShieldCheckFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldCheckFilled
});

var IconShieldCheckeredFilled = createReactComponent("filled", "shield-checkered-filled", "IconShieldCheckeredFilled", [["path", { "d": "M11.013 12v9.754a13 13 0 0 1 -8.733 -9.754h8.734zm9.284 3.794a13 13 0 0 1 -7.283 5.951l-.001 -9.745h8.708a12.96 12.96 0 0 1 -1.424 3.794zm-9.283 -13.268l-.001 7.474h-8.986c-.068 -1.432 .101 -2.88 .514 -4.282a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.192 -2.256l.276 -.219zm1.999 7.474v-7.453l-.09 -.073a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717c.413 1.403 .582 2.85 .514 4.282h-8.96z", "key": "svg-0" }]]);

var IconShieldCheckeredFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldCheckeredFilled
});

var IconShieldHalfFilled = createReactComponent("filled", "shield-half-filled", "IconShieldHalfFilled", [["path", { "d": "M11.998 2l.032 .002l.086 .005a1 1 0 0 1 .342 .104l.105 .062l.097 .076l.016 .015l.247 .21a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.791 -2.75l.046 -.036l.053 -.041a1 1 0 0 1 .217 -.112l.075 -.023l.036 -.01a1 1 0 0 1 .12 -.022l.086 -.005zm.002 2.296l-.176 .135a13 13 0 0 1 -7.288 2.572l-.264 .006l-.064 .31a11 11 0 0 0 1.064 7.175l.17 .314a11 11 0 0 0 6.49 5.136l.068 .019z", "key": "svg-0" }]]);

var IconShieldHalfFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldHalfFilled
});

var IconShieldLockFilled = createReactComponent("filled", "shield-lock-filled", "IconShieldLockFilled", [["path", { "d": "M11.998 2l.118 .007l.059 .008l.061 .013l.111 .034a.993 .993 0 0 1 .217 .112l.104 .082l.255 .218a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.531 -2.527l.263 -.225l.096 -.075a.993 .993 0 0 1 .217 -.112l.112 -.034a.97 .97 0 0 1 .119 -.021l.115 -.007zm.002 7a2 2 0 0 0 -1.995 1.85l-.005 .15l.005 .15a2 2 0 0 0 .995 1.581v1.769l.007 .117a1 1 0 0 0 1.993 -.117l.001 -1.768a2 2 0 0 0 -1.001 -3.732z", "key": "svg-0" }]]);

var IconShieldLockFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldLockFilled
});

var IconShieldFilled = createReactComponent("filled", "shield-filled", "IconShieldFilled", [["path", { "d": "M11.884 2.007l.114 -.007l.118 .007l.059 .008l.061 .013l.111 .034a.993 .993 0 0 1 .217 .112l.104 .082l.255 .218a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.531 -2.527l.263 -.225l.096 -.075a.993 .993 0 0 1 .217 -.112l.112 -.034a.97 .97 0 0 1 .119 -.021z", "key": "svg-0" }]]);

var IconShieldFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShieldFilled
});

var IconShirtFilled = createReactComponent("filled", "shirt-filled", "IconShirtFilled", [["path", { "d": "M14.883 3.007l.095 -.007l.112 .004l.113 .017l.113 .03l6 2a1 1 0 0 1 .677 .833l.007 .116v5a1 1 0 0 1 -.883 .993l-.117 .007h-2v7a2 2 0 0 1 -1.85 1.995l-.15 .005h-10a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-7h-2a1 1 0 0 1 -.993 -.883l-.007 -.117v-5a1 1 0 0 1 .576 -.906l.108 -.043l6 -2a1 1 0 0 1 1.316 .949a2 2 0 0 0 3.995 .15l.009 -.24l.017 -.113l.037 -.134l.044 -.103l.05 -.092l.068 -.093l.069 -.08c.056 -.054 .113 -.1 .175 -.14l.096 -.053l.103 -.044l.108 -.032l.112 -.02z", "key": "svg-0" }]]);

var IconShirtFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShirtFilled
});

var IconShoppingCartFilled = createReactComponent("filled", "shopping-cart-filled", "IconShoppingCartFilled", [["path", { "d": "M6 2a1 1 0 0 1 .993 .883l.007 .117v1.068l13.071 .935a1 1 0 0 1 .929 1.024l-.01 .114l-1 7a1 1 0 0 1 -.877 .853l-.113 .006h-12v2h10a3 3 0 1 1 -2.995 3.176l-.005 -.176l.005 -.176c.017 -.288 .074 -.564 .166 -.824h-5.342a3 3 0 1 1 -5.824 1.176l-.005 -.176l.005 -.176a3.002 3.002 0 0 1 1.995 -2.654v-12.17h-1a1 1 0 0 1 -.993 -.883l-.007 -.117a1 1 0 0 1 .883 -.993l.117 -.007h2zm0 16a1 1 0 1 0 0 2a1 1 0 0 0 0 -2zm11 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2z", "key": "svg-0" }]]);

var IconShoppingCartFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconShoppingCartFilled
});

var IconSignLeftFilled = createReactComponent("filled", "sign-left-filled", "IconSignLeftFilled", [["path", { "d": "M14 2a1 1 0 0 1 .993 .883l.007 .117v2h3a1 1 0 0 1 .993 .883l.007 .117v5a1 1 0 0 1 -.883 .993l-.117 .007h-3v8h1a1 1 0 0 1 .117 1.993l-.117 .007h-4a1 1 0 0 1 -.117 -1.993l.117 -.007h1v-8h-5a1 1 0 0 1 -.694 -.28l-.087 -.095l-2 -2.5a1 1 0 0 1 -.072 -1.147l.072 -.103l2 -2.5a1 1 0 0 1 .652 -.367l.129 -.008h5v-2a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconSignLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignLeftFilled
});

var IconSignRightFilled = createReactComponent("filled", "sign-right-filled", "IconSignRightFilled", [["path", { "d": "M10 2a1 1 0 0 1 .993 .883l.007 .117v2h5a1 1 0 0 1 .694 .28l.087 .095l2 2.5a1 1 0 0 1 .072 1.147l-.072 .103l-2 2.5a1 1 0 0 1 -.652 .367l-.129 .008h-5v8h1a1 1 0 0 1 .117 1.993l-.117 .007h-4a1 1 0 0 1 -.117 -1.993l.117 -.007h1v-8h-3a1 1 0 0 1 -.993 -.883l-.007 -.117v-5a1 1 0 0 1 .883 -.993l.117 -.007h3v-2a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconSignRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSignRightFilled
});

var IconSitemapFilled = createReactComponent("filled", "sitemap-filled", "IconSitemapFilled", [["path", { "d": "M2 16.667a2.667 2.667 0 0 1 2.667 -2.667h2.666a2.667 2.667 0 0 1 2.667 2.667v2.666a2.667 2.667 0 0 1 -2.667 2.667h-2.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-0" }], ["path", { "d": "M14 16.667a2.667 2.667 0 0 1 2.667 -2.667h2.666a2.667 2.667 0 0 1 2.667 2.667v2.666a2.667 2.667 0 0 1 -2.667 2.667h-2.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-1" }], ["path", { "d": "M8 4.667a2.667 2.667 0 0 1 2.667 -2.667h2.666a2.667 2.667 0 0 1 2.667 2.667v2.666a2.667 2.667 0 0 1 -2.667 2.667h-2.666a2.667 2.667 0 0 1 -2.667 -2.667z", "key": "svg-2" }], ["path", { "d": "M12 8a1 1 0 0 0 -1 1v2h-3c-1.645 0 -3 1.355 -3 3v1a1 1 0 0 0 1 1a1 1 0 0 0 1 -1v-1c0 -.564 .436 -1 1 -1h8c.564 0 1 .436 1 1v1a1 1 0 0 0 1 1a1 1 0 0 0 1 -1v-1c0 -1.645 -1.355 -3 -3 -3h-3v-2a1 1 0 0 0 -1 -1z", "key": "svg-3" }]]);

var IconSitemapFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSitemapFilled
});

var IconSortAscending2Filled = createReactComponent("filled", "sort-ascending-2-filled", "IconSortAscending2Filled", [["path", { "d": "M16.852 5.011l.058 -.007l.09 -.004l.075 .003l.126 .017l.111 .03l.111 .044l.098 .052l.104 .074l.082 .073l3 3a1 1 0 1 1 -1.414 1.414l-1.293 -1.292v9.585a1 1 0 0 1 -2 0v-9.585l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 0 -1.414l3 -3q .053 -.054 .112 -.097l.11 -.071l.114 -.054l.105 -.035z", "key": "svg-0" }], ["path", { "d": "M9.5 4a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1 -1.5 1.5h-4a1.5 1.5 0 0 1 -1.5 -1.5v-4a1.5 1.5 0 0 1 1.5 -1.5z", "key": "svg-1" }], ["path", { "d": "M9.5 13a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1 -1.5 1.5h-4a1.5 1.5 0 0 1 -1.5 -1.5v-4a1.5 1.5 0 0 1 1.5 -1.5z", "key": "svg-2" }]]);

var IconSortAscending2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortAscending2Filled
});

var IconSortAscendingShapesFilled = createReactComponent("filled", "sort-ascending-shapes-filled", "IconSortAscendingShapesFilled", [["path", { "d": "M7 5a1 1 0 0 1 1 1v9.584l1.293 -1.291a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.096 -.067l-.09 -.08l-3 -3a1 1 0 0 1 1.414 -1.414l1.293 1.293v-9.586a1 1 0 0 1 1 -1m12 -2a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2zm-1.136 10.496l3.5 6a1 1 0 0 1 -.864 1.504h-7a1 1 0 0 1 -.864 -1.504l3.5 -6a1 1 0 0 1 1.728 0", "key": "svg-0" }]]);

var IconSortAscendingShapesFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortAscendingShapesFilled
});

var IconSortDescending2Filled = createReactComponent("filled", "sort-descending-2-filled", "IconSortDescending2Filled", [["path", { "d": "M9.5 4a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1 -1.5 1.5h-4a1.5 1.5 0 0 1 -1.5 -1.5v-4a1.5 1.5 0 0 1 1.5 -1.5z", "key": "svg-0" }], ["path", { "d": "M9.5 13a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1 -1.5 1.5h-4a1.5 1.5 0 0 1 -1.5 -1.5v-4a1.5 1.5 0 0 1 1.5 -1.5z", "key": "svg-1" }], ["path", { "d": "M17 5a1 1 0 0 1 1 1v9.584l1.293 -1.291a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.096 -.067l-.09 -.08l-3 -3a1 1 0 0 1 1.414 -1.414l1.293 1.293v-9.586a1 1 0 0 1 1 -1", "key": "svg-2" }]]);

var IconSortDescending2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortDescending2Filled
});

var IconSortDescendingShapesFilled = createReactComponent("filled", "sort-descending-shapes-filled", "IconSortDescendingShapesFilled", [["path", { "d": "M7 5a1 1 0 0 1 1 1v9.584l1.293 -1.291a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.096 -.067l-.09 -.08l-3 -3a1 1 0 0 1 1.414 -1.414l1.293 1.293v-9.586a1 1 0 0 1 1 -1m12 8a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2zm-1.136 -9.504l3.5 6a1 1 0 0 1 -.864 1.504h-7a1 1 0 0 1 -.864 -1.504l3.5 -6a1 1 0 0 1 1.728 0", "key": "svg-0" }]]);

var IconSortDescendingShapesFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSortDescendingShapesFilled
});

var IconSoupFilled = createReactComponent("filled", "soup-filled", "IconSoupFilled", [["path", { "d": "M20 10a2 2 0 0 1 2 2v.5c0 1.694 -2.247 5.49 -3.983 6.983l-.017 .013v.504a2 2 0 0 1 -1.85 1.995l-.15 .005h-8a2 2 0 0 1 -2 -2v-.496l-.065 -.053c-1.76 -1.496 -3.794 -4.965 -3.928 -6.77l-.007 -.181v-.5a2 2 0 0 1 2 -2z", "key": "svg-0" }], ["path", { "d": "M11.417 3.188a1 1 0 1 1 1.166 1.624c-.375 .27 -.593 .706 -.583 1.209a1.4 1.4 0 0 0 .583 1.167a1 1 0 1 1 -1.166 1.624a3.38 3.38 0 0 1 -1.417 -2.791a3.4 3.4 0 0 1 1.417 -2.833", "key": "svg-1" }], ["path", { "d": "M15.417 3.188a1 1 0 1 1 1.166 1.624c-.375 .27 -.593 .706 -.583 1.209a1.4 1.4 0 0 0 .583 1.167a1 1 0 1 1 -1.166 1.624a3.38 3.38 0 0 1 -1.417 -2.791a3.4 3.4 0 0 1 1.417 -2.833", "key": "svg-2" }], ["path", { "d": "M7.417 3.188a1 1 0 1 1 1.166 1.624c-.375 .27 -.593 .706 -.583 1.209a1.4 1.4 0 0 0 .583 1.167a1 1 0 1 1 -1.166 1.624a3.38 3.38 0 0 1 -1.417 -2.791a3.4 3.4 0 0 1 1.417 -2.833", "key": "svg-3" }]]);

var IconSoupFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSoupFilled
});

var IconSpadeFilled = createReactComponent("filled", "spade-filled", "IconSpadeFilled", [["path", { "d": "M11.327 2.26a1395.065 1395.065 0 0 0 -4.923 4.504c-.626 .6 -1.212 1.21 -1.774 1.843a6.528 6.528 0 0 0 -.314 8.245l.14 .177c1.012 1.205 2.561 1.755 4.055 1.574l.246 -.037l-.706 2.118a1 1 0 0 0 .949 1.316h6l.118 -.007a1 1 0 0 0 .83 -1.31l-.688 -2.065l.104 .02c1.589 .25 3.262 -.387 4.32 -1.785a6.527 6.527 0 0 0 -.311 -8.243a31.787 31.787 0 0 0 -1.76 -1.83l-4.938 -4.518a1 1 0 0 0 -1.348 -.001z", "key": "svg-0" }]]);

var IconSpadeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpadeFilled
});

var IconSpeedboatFilled = createReactComponent("filled", "speedboat-filled", "IconSpeedboatFilled", [["path", { "d": "M14 7a1 1 0 0 1 .832 .445l1.702 2.555h5.466a1 1 0 0 1 .833 1.554l-3.1 4.66a4 4 0 0 1 -3.333 1.786h-14.4a1 1 0 0 1 -.936 -1.351l1.5 -4a1 1 0 0 1 .936 -.649h1.756l.9 -3h-.156a1 1 0 0 1 -.993 -.883l-.007 -.117a1 1 0 0 1 1 -1zm-6.657 5h1.887c.383 0 .762 -.074 1.12 -.219l3.557 -1.418q .186 -.075 .377 -.135l-.82 -1.228h-5.22z", "key": "svg-0" }]]);

var IconSpeedboatFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpeedboatFilled
});

var IconSpiderFilled = createReactComponent("filled", "spider-filled", "IconSpiderFilled", [["path", { "d": "M19 3a1 1 0 0 1 1 1v2a1 1 0 0 1 -.293 .707l-3.293 3.293h3.17l1.209 -1.207a1 1 0 0 1 1.414 1.414l-1.5 1.5a1 1 0 0 1 -.707 .293h-3.585l4.292 4.293a1 1 0 0 1 .293 .707v2a1 1 0 0 1 -2 0v-1.585l-2.016 -2.016a5 5 0 0 1 -9.968 0l-2.016 2.015v1.586a1 1 0 0 1 -.883 .993l-.117 .007a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 .293 -.707l4.291 -4.293h-3.584a1 1 0 0 1 -.707 -.293l-1.5 -1.5a1 1 0 0 1 1.414 -1.414l1.208 1.207h3.17l-3.292 -3.293a1 1 0 0 1 -.293 -.707v-2a1 1 0 1 1 2 0v1.585l3.025 3.025a3 3 0 0 1 5.95 0l3.025 -3.026v-1.584a1 1 0 0 1 .883 -.993z", "key": "svg-0" }]]);

var IconSpiderFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSpiderFilled
});

var IconSquareArrowDownFilled = createReactComponent("filled", "square-arrow-down-filled", "IconSquareArrowDownFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5a1 1 0 0 0 -1 1v5.585l-2.293 -2.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l4 4l.094 .083l.092 .064l.098 .052l.11 .044l.112 .03l.126 .017l.075 .003l.117 -.007l.149 -.029l.105 -.035l.113 -.054l.111 -.071a.939 .939 0 0 0 .112 -.097l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32l-.094 -.083a1 1 0 0 0 -1.32 .083l-2.293 2.292v-5.585l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconSquareArrowDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareArrowDownFilled
});

var IconSquareArrowLeftFilled = createReactComponent("filled", "square-arrow-left-filled", "IconSquareArrowLeftFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-6.293 5.293a1 1 0 0 0 -1.414 0l-4 4l-.083 .094l-.064 .092l-.052 .098l-.044 .11l-.03 .112l-.017 .126l-.003 .075l.004 .09l.007 .058l.025 .118l.035 .105l.054 .113l.071 .111c.03 .04 .061 .077 .097 .112l4 4l.094 .083a1 1 0 0 0 1.32 -.083l.083 -.094a1 1 0 0 0 -.083 -1.32l-2.292 -2.293h5.585l.117 -.007a1 1 0 0 0 -.117 -1.993h-5.585l2.292 -2.293l.083 -.094a1 1 0 0 0 -.083 -1.32z", "key": "svg-0" }]]);

var IconSquareArrowLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareArrowLeftFilled
});

var IconSquareArrowRightFilled = createReactComponent("filled", "square-arrow-right-filled", "IconSquareArrowRightFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-6.387 5.21a1 1 0 0 0 -1.32 .083l-.083 .094a1 1 0 0 0 .083 1.32l2.292 2.293h-5.585l-.117 .007a1 1 0 0 0 .117 1.993h5.585l-2.292 2.293l-.083 .094a1 1 0 0 0 1.497 1.32l4 -4l.073 -.082l.074 -.104l.052 -.098l.044 -.11l.03 -.112l.017 -.126l.003 -.075l-.007 -.118l-.029 -.148l-.035 -.105l-.054 -.113l-.071 -.111a1.008 1.008 0 0 0 -.097 -.112l-4 -4z", "key": "svg-0" }]]);

var IconSquareArrowRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareArrowRightFilled
});

var IconSquareArrowUpFilled = createReactComponent("filled", "square-arrow-up-filled", "IconSquareArrowUpFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5l-.09 .004l-.058 .007l-.118 .025l-.105 .035l-.113 .054l-.111 .071a1.008 1.008 0 0 0 -.112 .097l-4 4l-.083 .094a1 1 0 0 0 .083 1.32l.094 .083a1 1 0 0 0 1.32 -.083l2.293 -2.292v5.585l.007 .117a1 1 0 0 0 1.993 -.117v-5.585l2.293 2.292l.094 .083a1 1 0 0 0 1.32 -1.497l-4 -4l-.082 -.073l-.104 -.074l-.098 -.052l-.11 -.044l-.112 -.03l-.126 -.017l-.075 -.003z", "key": "svg-0" }]]);

var IconSquareArrowUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareArrowUpFilled
});

var IconSquareAsteriskFilled = createReactComponent("filled", "square-asterisk-filled", "IconSquareAsteriskFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5.5a1 1 0 0 0 -1 1v1.631l-1.445 -.963l-.101 -.06a1 1 0 0 0 -1.009 1.724l1.75 1.168l-1.75 1.169l-.093 .07a1 1 0 0 0 1.203 1.594l1.445 -.965v1.632l.007 .117a1 1 0 0 0 1.993 -.117v-1.631l1.445 .963l.101 .06a1 1 0 0 0 1.009 -1.724l-1.752 -1.169l1.752 -1.167l.093 -.07a1 1 0 0 0 -1.203 -1.594l-1.445 .962v-1.63l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconSquareAsteriskFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareAsteriskFilled
});

var IconSquareCheckFilled = createReactComponent("filled", "square-check-filled", "IconSquareCheckFilled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.626 7.293a1 1 0 0 0 -1.414 0l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z", "key": "svg-0" }]]);

var IconSquareCheckFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareCheckFilled
});

var IconSquareChevronDownFilled = createReactComponent("filled", "square-chevron-down-filled", "IconSquareChevronDownFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-9.387 8.21a1 1 0 0 0 -1.32 1.497l3 3l.094 .083a1 1 0 0 0 1.32 -.083l3 -3l.083 -.094a1 1 0 0 0 -.083 -1.32l-.094 -.083a1 1 0 0 0 -1.32 .083l-2.293 2.292l-2.293 -2.292z", "key": "svg-0" }]]);

var IconSquareChevronDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronDownFilled
});

var IconSquareChevronLeftFilled = createReactComponent("filled", "square-chevron-left-filled", "IconSquareChevronLeftFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-5.293 6.293a1 1 0 0 0 -1.414 0l-3 3l-.083 .094a1 1 0 0 0 .083 1.32l3 3l.094 .083a1 1 0 0 0 1.32 -.083l.083 -.094a1 1 0 0 0 -.083 -1.32l-2.292 -2.293l2.292 -2.293l.083 -.094a1 1 0 0 0 -.083 -1.32z", "key": "svg-0" }]]);

var IconSquareChevronLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronLeftFilled
});

var IconSquareChevronRightFilled = createReactComponent("filled", "square-chevron-right-filled", "IconSquareChevronRightFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7.387 6.21a1 1 0 0 0 -1.32 .083l-.083 .094a1 1 0 0 0 .083 1.32l2.292 2.293l-2.292 2.293l-.083 .094a1 1 0 0 0 1.497 1.32l3 -3l.083 -.094a1 1 0 0 0 -.083 -1.32l-3 -3z", "key": "svg-0" }]]);

var IconSquareChevronRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronRightFilled
});

var IconSquareChevronUpFilled = createReactComponent("filled", "square-chevron-up-filled", "IconSquareChevronUpFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-6.387 7.21a1 1 0 0 0 -1.32 .083l-3 3l-.083 .094a1 1 0 0 0 .083 1.32l.094 .083a1 1 0 0 0 1.32 -.083l2.293 -2.292l2.293 2.292l.094 .083a1 1 0 0 0 1.32 -1.497l-3 -3z", "key": "svg-0" }]]);

var IconSquareChevronUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronUpFilled
});

var IconSquareChevronsDownFilled = createReactComponent("filled", "square-chevrons-down-filled", "IconSquareChevronsDownFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-9.387 10.21a1 1 0 0 0 -1.32 1.497l3 3l.094 .083a1 1 0 0 0 1.32 -.083l3 -3l.083 -.094a1 1 0 0 0 -.083 -1.32l-.094 -.083a1 1 0 0 0 -1.32 .083l-2.293 2.292l-2.293 -2.292zm0 -5a1 1 0 0 0 -1.32 1.497l3 3l.094 .083a1 1 0 0 0 1.32 -.083l3 -3l.083 -.094a1 1 0 0 0 -.083 -1.32l-.094 -.083a1 1 0 0 0 -1.32 .083l-2.293 2.292l-2.293 -2.292z", "key": "svg-0" }]]);

var IconSquareChevronsDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronsDownFilled
});

var IconSquareChevronsLeftFilled = createReactComponent("filled", "square-chevrons-left-filled", "IconSquareChevronsLeftFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-2.293 6.293a1 1 0 0 0 -1.414 0l-3 3l-.083 .094a1 1 0 0 0 .083 1.32l3 3l.094 .083a1 1 0 0 0 1.32 -.083l.083 -.094a1 1 0 0 0 -.083 -1.32l-2.292 -2.293l2.292 -2.293l.083 -.094a1 1 0 0 0 -.083 -1.32zm-5 0a1 1 0 0 0 -1.414 0l-3 3l-.083 .094a1 1 0 0 0 .083 1.32l3 3l.094 .083a1 1 0 0 0 1.32 -.083l.083 -.094a1 1 0 0 0 -.083 -1.32l-2.292 -2.293l2.292 -2.293l.083 -.094a1 1 0 0 0 -.083 -1.32z", "key": "svg-0" }]]);

var IconSquareChevronsLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronsLeftFilled
});

var IconSquareChevronsRightFilled = createReactComponent("filled", "square-chevrons-right-filled", "IconSquareChevronsRightFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-10.387 6.21a1 1 0 0 0 -1.32 .083l-.083 .094a1 1 0 0 0 .083 1.32l2.292 2.293l-2.292 2.293l-.083 .094a1 1 0 0 0 1.497 1.32l3 -3l.083 -.094a1 1 0 0 0 -.083 -1.32l-3 -3zm5 0a1 1 0 0 0 -1.32 .083l-.083 .094a1 1 0 0 0 .083 1.32l2.292 2.293l-2.292 2.293l-.083 .094a1 1 0 0 0 1.497 1.32l3 -3l.083 -.094a1 1 0 0 0 -.083 -1.32l-3 -3z", "key": "svg-0" }]]);

var IconSquareChevronsRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronsRightFilled
});

var IconSquareChevronsUpFilled = createReactComponent("filled", "square-chevrons-up-filled", "IconSquareChevronsUpFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-6.387 10.21a1 1 0 0 0 -1.32 .083l-3 3l-.083 .094a1 1 0 0 0 .083 1.32l.094 .083a1 1 0 0 0 1.32 -.083l2.293 -2.292l2.293 2.292l.094 .083a1 1 0 0 0 1.32 -1.497l-3 -3zm0 -5a1 1 0 0 0 -1.32 .083l-3 3l-.083 .094a1 1 0 0 0 .083 1.32l.094 .083a1 1 0 0 0 1.32 -.083l2.293 -2.292l2.293 2.292l.094 .083a1 1 0 0 0 1.32 -1.497l-3 -3z", "key": "svg-0" }]]);

var IconSquareChevronsUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareChevronsUpFilled
});

var IconSquareDotFilled = createReactComponent("filled", "square-dot-filled", "IconSquareDotFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 8a2 2 0 0 0 -1.995 1.85l-.005 .15l.005 .15a2 2 0 1 0 1.995 -2.15z", "key": "svg-0" }]]);

var IconSquareDotFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareDotFilled
});

var IconSquareF0Filled = createReactComponent("filled", "square-f0-filled", "IconSquareF0Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.833 6a2.5 2.5 0 0 0 -2.495 2.336l-.005 .164v3l.005 .164a2.5 2.5 0 0 0 4.99 0l.005 -.164v-3l-.005 -.164a2.5 2.5 0 0 0 -2.495 -2.336zm-4.5 0h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm4.5 2a.5 .5 0 0 1 .492 .41l.008 .09v3l-.008 .09a.5 .5 0 0 1 -.984 0l-.008 -.09v-3l.008 -.09a.5 .5 0 0 1 .492 -.41z", "key": "svg-0" }]]);

var IconSquareF0Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF0Filled
});

var IconSquareF1Filled = createReactComponent("filled", "square-f1-filled", "IconSquareF1Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-8.333 6h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm5.994 .886c-.083 -.777 -1.008 -1.16 -1.617 -.67l-.084 .077l-2 2l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l.293 -.293v3.586l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-6l-.006 -.114z", "key": "svg-0" }]]);

var IconSquareF1Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF1Filled
});

var IconSquareF2Filled = createReactComponent("filled", "square-f2-filled", "IconSquareF2Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.333 6h-2l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h2v1h-1l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v1l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-2v-1h1l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-1l-.005 -.15a2 2 0 0 0 -1.995 -1.85zm-5 0h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconSquareF2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF2Filled
});

var IconSquareF3Filled = createReactComponent("filled", "square-f3-filled", "IconSquareF3Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.833 6h-1l-.144 .007a1.5 1.5 0 0 0 -1.356 1.493a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .727 -.457l.02 -.036h.636l.09 .008a.5 .5 0 0 1 0 .984l-.09 .008h-.5l-.133 .007c-1.156 .124 -1.156 1.862 0 1.986l.133 .007h.5l.09 .008a.5 .5 0 0 1 .41 .492l-.008 .09a.5 .5 0 0 1 -.492 .41h-.635l-.02 -.036a1 1 0 0 0 -1.845 .536a1.5 1.5 0 0 0 1.5 1.5h1l.164 -.005a2.5 2.5 0 0 0 2.336 -2.495l-.005 -.164a2.487 2.487 0 0 0 -.477 -1.312l-.019 -.024l.126 -.183a2.5 2.5 0 0 0 -2.125 -3.817zm-4.5 0h-2l-.117 .007a1 1 0 0 0 -.883 .993v6l.007 .117a1 1 0 0 0 .993 .883l.117 -.007a1 1 0 0 0 .883 -.993v-2h1l.117 -.007a1 1 0 0 0 -.117 -1.993h-1v-1h1l.117 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconSquareF3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF3Filled
});

var IconSquareF4Filled = createReactComponent("filled", "square-f4-filled", "IconSquareF4Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.333 6a1 1 0 0 0 -.993 .883l-.007 .117v2h-1v-2l-.007 -.117a1 1 0 0 0 -1.986 0l-.007 .117v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h1v2l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm-6 0h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconSquareF4Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF4Filled
});

var IconSquareF5Filled = createReactComponent("filled", "square-f5-filled", "IconSquareF5Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.333 6h-3l-.117 .007a1 1 0 0 0 -.857 .764l-.02 .112l-.006 .117v3l.007 .117a1 1 0 0 0 .764 .857l.112 .02l.117 .006h2v1h-1.033l-.025 -.087l-.049 -.113a1 1 0 0 0 -1.893 .45c0 .867 .63 1.587 1.458 1.726l.148 .018l.144 .006h1.25l.157 -.006a2 2 0 0 0 1.819 -1.683l.019 -.162l.005 -.149v-1l-.006 -.157a2 2 0 0 0 -1.683 -1.819l-.162 -.019l-.149 -.005h-1v-1h2l.117 -.007a1 1 0 0 0 .857 -.764l.02 -.112l.006 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006zm-6 0h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconSquareF5Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF5Filled
});

var IconSquareF6Filled = createReactComponent("filled", "square-f6-filled", "IconSquareF6Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.083 6h-1.25l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h1l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-1l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006h-1v-1h1.032l.026 .087a1 1 0 0 0 1.942 -.337a1.75 1.75 0 0 0 -1.606 -1.744l-.144 -.006zm-5.25 0h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm5 5v1h-1v-1h1z", "key": "svg-0" }]]);

var IconSquareF6Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF6Filled
});

var IconSquareF7Filled = createReactComponent("filled", "square-f7-filled", "IconSquareF7Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.333 6h-3l-.117 .007a1 1 0 0 0 -.883 .993l.007 .117a1 1 0 0 0 .993 .883h1.718l-1.188 4.757l-.022 .115a1 1 0 0 0 1.962 .37l1.5 -6l.021 -.11a1 1 0 0 0 -.991 -1.132zm-6 0h-2l-.117 .007a1 1 0 0 0 -.883 .993v6l.007 .117a1 1 0 0 0 .993 .883l.117 -.007a1 1 0 0 0 .883 -.993v-2h1l.117 -.007a1 1 0 0 0 -.117 -1.993h-1v-1h1l.117 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconSquareF7Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF7Filled
});

var IconSquareF8Filled = createReactComponent("filled", "square-f8-filled", "IconSquareF8Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.333 6h-1l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v1l.005 .15c.018 .236 .077 .46 .17 .667l.075 .152l.018 .03l-.018 .032c-.133 .24 -.218 .509 -.243 .795l-.007 .174v1l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h1l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-1l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-1l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm-5 0h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm5 5v1h-1v-1h1zm0 -3v1h-1v-1h1z", "key": "svg-0" }]]);

var IconSquareF8Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF8Filled
});

var IconSquareF9Filled = createReactComponent("filled", "square-f9-filled", "IconSquareF9Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.083 6h-1.5l-.144 .006a1.75 1.75 0 0 0 -1.606 1.744v1.5l.006 .144a1.75 1.75 0 0 0 1.744 1.606h1.25v1h-1.033l-.025 -.087a1 1 0 0 0 -1.942 .337c0 .966 .784 1.75 1.75 1.75h1.5l.144 -.006a1.75 1.75 0 0 0 1.606 -1.744v-4.5l-.006 -.144a1.75 1.75 0 0 0 -1.744 -1.606zm-5.25 0h-2l-.117 .007a1 1 0 0 0 -.883 .993v6l.007 .117a1 1 0 0 0 .993 .883l.117 -.007a1 1 0 0 0 .883 -.993v-2h1l.117 -.007a1 1 0 0 0 -.117 -1.993h-1v-1h1l.117 -.007a1 1 0 0 0 -.117 -1.993zm5 2v1h-1v-1h1z", "key": "svg-0" }]]);

var IconSquareF9Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareF9Filled
});

var IconSquareLetterAFilled = createReactComponent("filled", "square-letter-a-filled", "IconSquareLetterAFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5a3 3 0 0 0 -3 3v6a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-6a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v2h-2v-2a1 1 0 0 1 .883 -.993z", "key": "svg-0" }]]);

var IconSquareLetterAFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterAFilled
});

var IconSquareLetterBFilled = createReactComponent("filled", "square-letter-b-filled", "IconSquareLetterBFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h2a3 3 0 0 0 3 -3l-.005 -.176a3 3 0 0 0 -.654 -1.7l-.106 -.124l.106 -.124a3 3 0 0 0 -2.341 -4.876m0 6a1 1 0 0 1 0 2h-1v-2zm0 -4a1 1 0 0 1 0 2h-1v-2z", "key": "svg-0" }]]);

var IconSquareLetterBFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterBFilled
});

var IconSquareLetterCFilled = createReactComponent("filled", "square-letter-c-filled", "IconSquareLetterCFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5a3 3 0 0 0 -3 3v4a3 3 0 0 0 6 0a1 1 0 0 0 -1.993 -.117l-.007 .117a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1.993 -.117l.007 .117a1 1 0 0 0 2 0a3 3 0 0 0 -3 -3", "key": "svg-0" }]]);

var IconSquareLetterCFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterCFilled
});

var IconSquareLetterDFilled = createReactComponent("filled", "square-letter-d-filled", "IconSquareLetterDFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h2a3 3 0 0 0 3 -3v-4a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-1v-6z", "key": "svg-0" }]]);

var IconSquareLetterDFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterDFilled
});

var IconSquareLetterEFilled = createReactComponent("filled", "square-letter-e-filled", "IconSquareLetterEFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-5 5h-4a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-3v-2h1.5a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-1.5v-2h3a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconSquareLetterEFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterEFilled
});

var IconSquareLetterFFilled = createReactComponent("filled", "square-letter-f-filled", "IconSquareLetterFFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-5 5h-4a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3h2a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-2v-2h3a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconSquareLetterFFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterFFilled
});

var IconSquareLetterGFilled = createReactComponent("filled", "square-letter-g-filled", "IconSquareLetterGFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-5 5h-2a3 3 0 0 0 -3 3v4a3 3 0 0 0 3 3h2a1 1 0 0 0 1 -1v-4a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883v2h-1a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconSquareLetterGFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterGFilled
});

var IconSquareLetterHFilled = createReactComponent("filled", "square-letter-h-filled", "IconSquareLetterHFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-5 5a1 1 0 0 0 -1 1v3h-2v-3a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-3h2v3a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconSquareLetterHFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterHFilled
});

var IconSquareLetterIFilled = createReactComponent("filled", "square-letter-i-filled", "IconSquareLetterIFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconSquareLetterIFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterIFilled
});

var IconSquareLetterJFilled = createReactComponent("filled", "square-letter-j-filled", "IconSquareLetterJFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-5 5h-4a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883h3v5a1 1 0 0 1 -1.993 .117l-.007 -.117a1 1 0 0 0 -2 0a3 3 0 0 0 6 0v-6a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconSquareLetterJFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterJFilled
});

var IconSquareLetterKFilled = createReactComponent("filled", "square-letter-k-filled", "IconSquareLetterKFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-4.47 5.152a1 1 0 0 0 -1.378 .318l-2.152 3.443v-2.913a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-2.914l2.152 3.444a1 1 0 0 0 1.276 .374l.102 -.056l.095 -.068a1 1 0 0 0 .223 -1.31l-2.17 -3.47l2.17 -3.47a1 1 0 0 0 -.318 -1.378", "key": "svg-0" }]]);

var IconSquareLetterKFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterKFilled
});

var IconSquareLetterLFilled = createReactComponent("filled", "square-letter-l-filled", "IconSquareLetterLFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-9 5a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-3v-7a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconSquareLetterLFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterLFilled
});

var IconSquareLetterMFilled = createReactComponent("filled", "square-letter-m-filled", "IconSquareLetterMFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-3 6c0 -1.014 -1.336 -1.384 -1.857 -.514l-2.143 3.57l-2.143 -3.57c-.521 -.87 -1.857 -.5 -1.857 .514v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-4.39l1.143 1.904l.074 .108a1 1 0 0 0 1.64 -.108l1.143 -1.904v4.39a1 1 0 0 0 2 0z", "key": "svg-0" }]]);

var IconSquareLetterMFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterMFilled
});

var IconSquareLetterNFilled = createReactComponent("filled", "square-letter-n-filled", "IconSquareLetterNFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-8.106 5.553c-.471 -.944 -1.894 -.608 -1.894 .447v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3.764l2.106 4.211c.471 .944 1.894 .608 1.894 -.447v-8a1 1 0 0 0 -1 -1l-.117 .007a1 1 0 0 0 -.883 .993v3.764z", "key": "svg-0" }]]);

var IconSquareLetterNFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterNFilled
});

var IconSquareLetterOFilled = createReactComponent("filled", "square-letter-o-filled", "IconSquareLetterOFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5a3 3 0 0 0 -3 3v4a3 3 0 0 0 6 0v-4a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v4a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1 -1", "key": "svg-0" }]]);

var IconSquareLetterOFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterOFilled
});

var IconSquareLetterPFilled = createReactComponent("filled", "square-letter-p-filled", "IconSquareLetterPFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3h1a3 3 0 0 0 0 -6m0 2a1 1 0 0 1 0 2h-1v-2z", "key": "svg-0" }]]);

var IconSquareLetterPFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterPFilled
});

var IconSquareLetterQFilled = createReactComponent("filled", "square-letter-q-filled", "IconSquareLetterQFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5a3 3 0 0 0 -3 3v4a3 3 0 0 0 4.168 2.764l.125 -.057a1 1 0 0 0 1.414 -1.414l.057 -.125a3 3 0 0 0 .236 -1.168v-4a3 3 0 0 0 -3 -3m1 7.001h-.059a.996 .996 0 0 0 -.941 1a1 1 0 0 1 -1 -1.001v-4a1 1 0 0 1 2 0z", "key": "svg-0" }]]);

var IconSquareLetterQFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterQFilled
});

var IconSquareLetterRFilled = createReactComponent("filled", "square-letter-r-filled", "IconSquareLetterRFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-7 5h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-2.332l2.2 2.932a1 1 0 0 0 1.4 .2l.096 -.081a1 1 0 0 0 .104 -1.319l-1.903 -2.538l.115 -.037a3.001 3.001 0 0 0 -1.012 -5.825m0 2a1 1 0 0 1 0 2h-1v-2z", "key": "svg-0" }]]);

var IconSquareLetterRFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterRFilled
});

var IconSquareLetterSFilled = createReactComponent("filled", "square-letter-s-filled", "IconSquareLetterSFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-6 5h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2v2h-2a1 1 0 0 0 -2 0a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-2v-2h2l.007 .117a1 1 0 0 0 1.993 -.117a2 2 0 0 0 -2 -2", "key": "svg-0" }]]);

var IconSquareLetterSFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterSFilled
});

var IconSquareLetterTFilled = createReactComponent("filled", "square-letter-t-filled", "IconSquareLetterTFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-5 5h-4a1 1 0 1 0 0 2h1v7a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-7h1a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconSquareLetterTFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterTFilled
});

var IconSquareLetterUFilled = createReactComponent("filled", "square-letter-u-filled", "IconSquareLetterUFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-5 5a1 1 0 0 0 -1 1v6a1 1 0 0 1 -2 0v-6a1 1 0 0 0 -2 0v6a3 3 0 0 0 6 0v-6a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconSquareLetterUFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterUFilled
});

var IconSquareLetterVFilled = createReactComponent("filled", "square-letter-v-filled", "IconSquareLetterVFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-4.757 5.03a1 1 0 0 0 -1.213 .727l-1.03 4.118l-1.03 -4.118a1 1 0 1 0 -1.94 .486l2 8c.252 1.01 1.688 1.01 1.94 0l2 -8a1 1 0 0 0 -.727 -1.213", "key": "svg-0" }]]);

var IconSquareLetterVFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterVFilled
});

var IconSquareLetterWFilled = createReactComponent("filled", "square-letter-w-filled", "IconSquareLetterWFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-4.992 5.876l-.52 4.153l-.56 -1.4c-.319 -.799 -1.41 -.837 -1.803 -.114l-.053 .114l-.561 1.4l-.519 -4.153a1 1 0 0 0 -1 -.876l-.116 .008a1 1 0 0 0 -.868 1.116l1 8c.128 1.025 1.537 1.207 1.92 .247l1.072 -2.678l1.072 2.678c.383 .96 1.792 .778 1.92 -.247l1 -8a1 1 0 0 0 -1.984 -.248", "key": "svg-0" }]]);

var IconSquareLetterWFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterWFilled
});

var IconSquareLetterXFilled = createReactComponent("filled", "square-letter-x-filled", "IconSquareLetterXFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-4.553 5.106a1 1 0 0 0 -1.341 .447l-1.106 2.21l-1.106 -2.21a1 1 0 0 0 -1.234 -.494l-.107 .047a1 1 0 0 0 -.447 1.341l1.774 3.553l-1.775 3.553a1 1 0 0 0 .345 1.283l.102 .058a1 1 0 0 0 1.341 -.447l1.107 -2.211l1.106 2.211a1 1 0 0 0 1.234 .494l.107 -.047a1 1 0 0 0 .447 -1.341l-1.776 -3.553l1.776 -3.553a1 1 0 0 0 -.345 -1.283z", "key": "svg-0" }]]);

var IconSquareLetterXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterXFilled
});

var IconSquareLetterYFilled = createReactComponent("filled", "square-letter-y-filled", "IconSquareLetterYFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-4.629 5.072a1 1 0 0 0 -1.3 .557l-1.071 2.678l-1.072 -2.678a1 1 0 0 0 -1.856 .742l1.928 4.823v2.806a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-2.809l1.928 -4.82a1 1 0 0 0 -.45 -1.25z", "key": "svg-0" }]]);

var IconSquareLetterYFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterYFilled
});

var IconSquareLetterZFilled = createReactComponent("filled", "square-letter-z-filled", "IconSquareLetterZFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-5 5h-4a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883h2.382l-3.276 6.553a1 1 0 0 0 .894 1.447h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-2.382l3.276 -6.553a1 1 0 0 0 -.894 -1.447", "key": "svg-0" }]]);

var IconSquareLetterZFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareLetterZFilled
});

var IconSquareMinusFilled = createReactComponent("filled", "square-minus-filled", "IconSquareMinusFilled", [["path", { "d": "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-4 9h-6l-.117 .007a1 1 0 0 0 .117 1.993h6l.117 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconSquareMinusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareMinusFilled
});

var IconSquareNumber0Filled = createReactComponent("filled", "square-number-0-filled", "IconSquareNumber0Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-6.333 5a3 3 0 0 0 -2.995 2.824l-.005 .176v4l.005 .176a3 3 0 0 0 5.99 0l.005 -.176v-4l-.005 -.176a3 3 0 0 0 -2.995 -2.824zm0 2a1 1 0 0 1 .993 .883l.007 .117v4l-.007 .117a1 1 0 0 1 -1.986 0l-.007 -.117v-4l.007 -.117a1 1 0 0 1 .993 -.883z", "key": "svg-0" }]]);

var IconSquareNumber0Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber0Filled
});

var IconSquareNumber1Filled = createReactComponent("filled", "square-number-1-filled", "IconSquareNumber1Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-5.339 5.886c-.083 -.777 -1.008 -1.16 -1.617 -.67l-.084 .077l-2 2l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l.293 -.293v5.586l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.006 -.114z", "key": "svg-0" }]]);

var IconSquareNumber1Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber1Filled
});

var IconSquareNumber2Filled = createReactComponent("filled", "square-number-2-filled", "IconSquareNumber2Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-5.333 5h-3l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h3v2h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h3l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-3v-2h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z", "key": "svg-0" }]]);

var IconSquareNumber2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber2Filled
});

var IconSquareNumber3Filled = createReactComponent("filled", "square-number-3-filled", "IconSquareNumber3Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-5.333 5h-2l-.15 .005a2 2 0 0 0 -1.85 1.995a1 1 0 0 0 1.974 .23l.02 -.113l.006 -.117h2v2h-2l-.133 .007c-1.111 .12 -1.154 1.73 -.128 1.965l.128 .021l.133 .007h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z", "key": "svg-0" }]]);

var IconSquareNumber3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber3Filled
});

var IconSquareNumber4Filled = createReactComponent("filled", "square-number-4-filled", "IconSquareNumber4Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-4.333 5a1 1 0 0 0 -.993 .883l-.007 .117v3h-2v-3l-.007 -.117a1 1 0 0 0 -1.986 0l-.007 .117v3l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v3l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconSquareNumber4Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber4Filled
});

var IconSquareNumber5Filled = createReactComponent("filled", "square-number-5-filled", "IconSquareNumber5Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-4.333 5h-4a1 1 0 0 0 -.993 .883l-.007 .117v4a1 1 0 0 0 .883 .993l.117 .007h3v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2a2 2 0 0 0 1.995 -1.85l.005 -.15v-2a2 2 0 0 0 -1.85 -1.995l-.15 -.005h-2v-2h3a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -.883 -.993l-.117 -.007z", "key": "svg-0" }]]);

var IconSquareNumber5Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber5Filled
});

var IconSquareNumber6Filled = createReactComponent("filled", "square-number-6-filled", "IconSquareNumber6Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-5.333 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v6l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006h-2v-2h2l.007 .117a1 1 0 0 0 1.993 -.117a2 2 0 0 0 -1.85 -1.995l-.15 -.005zm0 6v2h-2v-2h2z", "key": "svg-0" }]]);

var IconSquareNumber6Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber6Filled
});

var IconSquareNumber7Filled = createReactComponent("filled", "square-number-7-filled", "IconSquareNumber7Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-4.333 5h-4l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117l.007 .117a1 1 0 0 0 .876 .876l.117 .007h2.718l-1.688 6.757l-.022 .115a1 1 0 0 0 1.927 .482l.035 -.111l2 -8l.021 -.112a1 1 0 0 0 -.878 -1.125l-.113 -.006z", "key": "svg-0" }]]);

var IconSquareNumber7Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber7Filled
});

var IconSquareNumber8Filled = createReactComponent("filled", "square-number-8-filled", "IconSquareNumber8Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-5.333 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15c.018 .236 .077 .46 .17 .667l.075 .152l.018 .03l-.018 .032c-.133 .24 -.218 .509 -.243 .795l-.007 .174v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 6v2h-2v-2h2zm0 -4v2h-2v-2h2z", "key": "svg-0" }]]);

var IconSquareNumber8Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber8Filled
});

var IconSquareNumber9Filled = createReactComponent("filled", "square-number-9-filled", "IconSquareNumber9Filled", [["path", { "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-5.333 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-6l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 2v2h-2v-2h2z", "key": "svg-0" }]]);

var IconSquareNumber9Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareNumber9Filled
});

var IconSquareRotatedFilled = createReactComponent("filled", "square-rotated-filled", "IconSquareRotatedFilled", [["path", { "d": "M9.793 2.893l-6.9 6.9c-1.172 1.171 -1.172 3.243 0 4.414l6.9 6.9c1.171 1.172 3.243 1.172 4.414 0l6.9 -6.9c1.172 -1.171 1.172 -3.243 0 -4.414l-6.9 -6.9c-1.171 -1.172 -3.243 -1.172 -4.414 0z", "key": "svg-0" }]]);

var IconSquareRotatedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRotatedFilled
});

var IconSquareRoundedArrowDownFilled = createReactComponent("filled", "square-rounded-arrow-down-filled", "IconSquareRoundedArrowDownFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm0 5a1 1 0 0 1 .993 .883l.007 .117v5.585l2.293 -2.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 .083 1.32l-.083 .094l-4 4a1.008 1.008 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.092 -.064l-.094 -.083l-4 -4a1 1 0 0 1 1.32 -1.497l.094 .083l2.293 2.292v-5.585a1 1 0 0 1 1 -1z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedArrowDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedArrowDownFilled
});

var IconSquareRoundedArrowLeftFilled = createReactComponent("filled", "square-rounded-arrow-left-filled", "IconSquareRoundedArrowLeftFilled", [["path", { "d": "M12 2l.324 .001l.318 .004l.616 .017l.299 .013l.579 .034l.553 .046c4.785 .464 6.732 2.411 7.196 7.196l.046 .553l.034 .579c.005 .098 .01 .198 .013 .299l.017 .616l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.464 4.785 -2.411 6.732 -7.196 7.196l-.553 .046l-.579 .034c-.098 .005 -.198 .01 -.299 .013l-.616 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.785 -.464 -6.732 -2.411 -7.196 -7.196l-.046 -.553l-.034 -.579a28.058 28.058 0 0 1 -.013 -.299l-.017 -.616c-.003 -.21 -.005 -.424 -.005 -.642l.001 -.324l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.464 -4.785 2.411 -6.732 7.196 -7.196l.553 -.046l.579 -.034c.098 -.005 .198 -.01 .299 -.013l.616 -.017c.21 -.003 .424 -.005 .642 -.005zm.707 5.293a1 1 0 0 0 -1.414 0l-4 4a1.037 1.037 0 0 0 -.2 .284l-.022 .052a.95 .95 0 0 0 -.06 .222l-.008 .067l-.002 .063v-.035v.073a1.034 1.034 0 0 0 .07 .352l.023 .052l.03 .061l.022 .037a1.2 1.2 0 0 0 .05 .074l.024 .03l.073 .082l4 4l.094 .083a1 1 0 0 0 1.32 -.083l.083 -.094a1 1 0 0 0 -.083 -1.32l-2.292 -2.293h5.585l.117 -.007a1 1 0 0 0 -.117 -1.993h-5.585l2.292 -2.293l.083 -.094a1 1 0 0 0 -.083 -1.32z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedArrowLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedArrowLeftFilled
});

var IconSquareRoundedArrowRightFilled = createReactComponent("filled", "square-rounded-arrow-right-filled", "IconSquareRoundedArrowRightFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm.613 5.21l.094 .083l4 4a.927 .927 0 0 1 .097 .112l.071 .11l.054 .114l.035 .105l.03 .148l.006 .118l-.003 .075l-.017 .126l-.03 .111l-.044 .111l-.052 .098l-.074 .104l-.073 .082l-4 4a1 1 0 0 1 -1.497 -1.32l.083 -.094l2.292 -2.293h-5.585a1 1 0 0 1 -.117 -1.993l.117 -.007h5.585l-2.292 -2.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedArrowRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedArrowRightFilled
});

var IconSquareRoundedArrowUpFilled = createReactComponent("filled", "square-rounded-arrow-up-filled", "IconSquareRoundedArrowUpFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-.148 5.011l.058 -.007l.09 -.004l.075 .003l.126 .017l.111 .03l.111 .044l.098 .052l.104 .074l.082 .073l4 4a1 1 0 0 1 -1.32 1.497l-.094 -.083l-2.293 -2.292v5.585a1 1 0 0 1 -1.993 .117l-.007 -.117v-5.585l-2.293 2.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 -.083 -1.32l.083 -.094l4 -4a.927 .927 0 0 1 .112 -.097l.11 -.071l.114 -.054l.105 -.035l.118 -.025z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedArrowUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedArrowUpFilled
});

var IconSquareRoundedCheckFilled = createReactComponent("filled", "square-rounded-check-filled", "IconSquareRoundedCheckFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm2.293 7.293a1 1 0 0 1 1.497 1.32l-.083 .094l-4 4a1 1 0 0 1 -1.32 .083l-.094 -.083l-2 -2a1 1 0 0 1 1.32 -1.497l.094 .083l1.293 1.292l3.293 -3.292z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedCheckFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedCheckFilled
});

var IconSquareRoundedChevronDownFilled = createReactComponent("filled", "square-rounded-chevron-down-filled", "IconSquareRoundedChevronDownFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-3.707 8.293a1 1 0 0 1 1.32 -.083l.094 .083l2.293 2.292l2.293 -2.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 .083 1.32l-.083 .094l-3 3a1 1 0 0 1 -1.32 .083l-.094 -.083l-3 -3a1 1 0 0 1 0 -1.414z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedChevronDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronDownFilled
});

var IconSquareRoundedChevronLeftFilled = createReactComponent("filled", "square-rounded-chevron-left-filled", "IconSquareRoundedChevronLeftFilled", [["path", { "d": "M12 2l.324 .001l.318 .004l.616 .017l.299 .013l.579 .034l.553 .046c4.785 .464 6.732 2.411 7.196 7.196l.046 .553l.034 .579c.005 .098 .01 .198 .013 .299l.017 .616l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.464 4.785 -2.411 6.732 -7.196 7.196l-.553 .046l-.579 .034c-.098 .005 -.198 .01 -.299 .013l-.616 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.785 -.464 -6.732 -2.411 -7.196 -7.196l-.046 -.553l-.034 -.579a28.058 28.058 0 0 1 -.013 -.299l-.017 -.616c-.003 -.21 -.005 -.424 -.005 -.642l.001 -.324l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.464 -4.785 2.411 -6.732 7.196 -7.196l.553 -.046l.579 -.034c.098 -.005 .198 -.01 .299 -.013l.616 -.017c.21 -.003 .424 -.005 .642 -.005zm1.707 6.293a1 1 0 0 0 -1.414 0l-3 3l-.083 .094a1 1 0 0 0 .083 1.32l3 3l.094 .083a1 1 0 0 0 1.32 -.083l.083 -.094a1 1 0 0 0 -.083 -1.32l-2.292 -2.293l2.292 -2.293l.083 -.094a1 1 0 0 0 -.083 -1.32z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedChevronLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronLeftFilled
});

var IconSquareRoundedChevronRightFilled = createReactComponent("filled", "square-rounded-chevron-right-filled", "IconSquareRoundedChevronRightFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-1.707 6.293a1 1 0 0 1 1.32 -.083l.094 .083l3 3a1 1 0 0 1 .083 1.32l-.083 .094l-3 3a1 1 0 0 1 -1.497 -1.32l.083 -.094l2.292 -2.293l-2.292 -2.293a1 1 0 0 1 -.083 -1.32l.083 -.094z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedChevronRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronRightFilled
});

var IconSquareRoundedChevronUpFilled = createReactComponent("filled", "square-rounded-chevron-up-filled", "IconSquareRoundedChevronUpFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-.707 7.293a1 1 0 0 1 1.32 -.083l.094 .083l3 3a1 1 0 0 1 -1.32 1.497l-.094 -.083l-2.293 -2.292l-2.293 2.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 -.083 -1.32l.083 -.094l3 -3z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedChevronUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronUpFilled
});

var IconSquareRoundedChevronsDownFilled = createReactComponent("filled", "square-rounded-chevrons-down-filled", "IconSquareRoundedChevronsDownFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-3.707 6.293a1 1 0 0 1 1.32 -.083l.094 .083l2.293 2.292l2.293 -2.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 .083 1.32l-.083 .094l-3 3a1 1 0 0 1 -1.32 .083l-.094 -.083l-3 -3a1 1 0 0 1 0 -1.414zm0 4a1 1 0 0 1 1.32 -.083l.094 .083l2.293 2.292l2.293 -2.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 .083 1.32l-.083 .094l-3 3a1 1 0 0 1 -1.32 .083l-.094 -.083l-3 -3a1 1 0 0 1 0 -1.414z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedChevronsDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronsDownFilled
});

var IconSquareRoundedChevronsLeftFilled = createReactComponent("filled", "square-rounded-chevrons-left-filled", "IconSquareRoundedChevronsLeftFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm2.293 6.293a1 1 0 0 1 1.497 1.32l-.083 .094l-2.292 2.293l2.292 2.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.32 .083l-.094 -.083l-3 -3a1 1 0 0 1 -.083 -1.32l.083 -.094l3 -3zm-4 0a1 1 0 0 1 1.497 1.32l-.083 .094l-2.292 2.293l2.292 2.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.32 .083l-.094 -.083l-3 -3a1 1 0 0 1 -.083 -1.32l.083 -.094l3 -3z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedChevronsLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronsLeftFilled
});

var IconSquareRoundedChevronsRightFilled = createReactComponent("filled", "square-rounded-chevrons-right-filled", "IconSquareRoundedChevronsRightFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-3.707 6.293a1 1 0 0 1 1.32 -.083l.094 .083l3 3a1 1 0 0 1 .083 1.32l-.083 .094l-3 3a1 1 0 0 1 -1.497 -1.32l.083 -.094l2.292 -2.293l-2.292 -2.293a1 1 0 0 1 -.083 -1.32l.083 -.094zm4 0a1 1 0 0 1 1.32 -.083l.094 .083l3 3a1 1 0 0 1 .083 1.32l-.083 .094l-3 3a1 1 0 0 1 -1.497 -1.32l.083 -.094l2.292 -2.293l-2.292 -2.293a1 1 0 0 1 -.083 -1.32l.083 -.094z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedChevronsRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronsRightFilled
});

var IconSquareRoundedChevronsUpFilled = createReactComponent("filled", "square-rounded-chevrons-up-filled", "IconSquareRoundedChevronsUpFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-.707 9.293a1 1 0 0 1 1.32 -.083l.094 .083l3 3a1 1 0 0 1 -1.32 1.497l-.094 -.083l-2.293 -2.292l-2.293 2.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 -.083 -1.32l.083 -.094l3 -3zm0 -4a1 1 0 0 1 1.32 -.083l.094 .083l3 3a1 1 0 0 1 -1.32 1.497l-.094 -.083l-2.293 -2.292l-2.293 2.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 -.083 -1.32l.083 -.094l3 -3z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedChevronsUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedChevronsUpFilled
});

var IconSquareRoundedLetterAFilled = createReactComponent("filled", "square-rounded-letter-a-filled", "IconSquareRoundedLetterAFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m.324 4.999a3 3 0 0 0 -3 3v6a1 1 0 0 0 2 0v-2h2v2a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-6a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v2h-2v-2a1 1 0 0 1 .883 -.993z", "key": "svg-0" }]]);

var IconSquareRoundedLetterAFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterAFilled
});

var IconSquareRoundedLetterBFilled = createReactComponent("filled", "square-rounded-letter-b-filled", "IconSquareRoundedLetterBFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m.324 4.999h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h2a3 3 0 0 0 3 -3l-.005 -.176a3 3 0 0 0 -.654 -1.7l-.106 -.124l.106 -.124a3 3 0 0 0 -2.341 -4.876m0 6a1 1 0 0 1 0 2h-1v-2zm0 -4a1 1 0 0 1 0 2h-1v-2z", "key": "svg-0" }]]);

var IconSquareRoundedLetterBFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterBFilled
});

var IconSquareRoundedLetterCFilled = createReactComponent("filled", "square-rounded-letter-c-filled", "IconSquareRoundedLetterCFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m.324 4.999a3 3 0 0 0 -3 3v4a3 3 0 0 0 6 0a1 1 0 0 0 -1.993 -.117l-.007 .117a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1.993 -.117l.007 .117a1 1 0 0 0 2 0a3 3 0 0 0 -3 -3", "key": "svg-0" }]]);

var IconSquareRoundedLetterCFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterCFilled
});

var IconSquareRoundedLetterDFilled = createReactComponent("filled", "square-rounded-letter-d-filled", "IconSquareRoundedLetterDFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m.324 4.999h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h2a3 3 0 0 0 3 -3v-4a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-1v-6z", "key": "svg-0" }]]);

var IconSquareRoundedLetterDFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterDFilled
});

var IconSquareRoundedLetterEFilled = createReactComponent("filled", "square-rounded-letter-e-filled", "IconSquareRoundedLetterEFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.324 4.999h-4a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-3v-2h1.5a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-1.5v-2h3a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconSquareRoundedLetterEFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterEFilled
});

var IconSquareRoundedLetterFFilled = createReactComponent("filled", "square-rounded-letter-f-filled", "IconSquareRoundedLetterFFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.324 4.999h-4a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3h2a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1h-2v-2h3a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconSquareRoundedLetterFFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterFFilled
});

var IconSquareRoundedLetterGFilled = createReactComponent("filled", "square-rounded-letter-g-filled", "IconSquareRoundedLetterGFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.324 4.999h-2a3 3 0 0 0 -3 3v4a3 3 0 0 0 3 3h2a1 1 0 0 0 1 -1v-4a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883v2h-1a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconSquareRoundedLetterGFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterGFilled
});

var IconSquareRoundedLetterHFilled = createReactComponent("filled", "square-rounded-letter-h-filled", "IconSquareRoundedLetterHFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.324 4.999a1 1 0 0 0 -1 1v3h-2v-3a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-3h2v3a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconSquareRoundedLetterHFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterHFilled
});

var IconSquareRoundedLetterIFilled = createReactComponent("filled", "square-rounded-letter-i-filled", "IconSquareRoundedLetterIFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m.324 4.999a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconSquareRoundedLetterIFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterIFilled
});

var IconSquareRoundedLetterJFilled = createReactComponent("filled", "square-rounded-letter-j-filled", "IconSquareRoundedLetterJFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.324 4.999h-4a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883h3v5a1 1 0 0 1 -1.993 .117l-.007 -.117a1 1 0 0 0 -2 0a3 3 0 0 0 6 0v-6a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconSquareRoundedLetterJFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterJFilled
});

var IconSquareRoundedLetterKFilled = createReactComponent("filled", "square-rounded-letter-k-filled", "IconSquareRoundedLetterKFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.854 5.151a1 1 0 0 0 -1.378 .318l-2.152 3.443v-2.913a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-2.914l2.152 3.444a1 1 0 0 0 1.276 .374l.102 -.056l.095 -.068a1 1 0 0 0 .223 -1.31l-2.17 -3.47l2.17 -3.47a1 1 0 0 0 -.318 -1.378", "key": "svg-0" }]]);

var IconSquareRoundedLetterKFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterKFilled
});

var IconSquareRoundedLetterLFilled = createReactComponent("filled", "square-rounded-letter-l-filled", "IconSquareRoundedLetterLFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m-1.676 4.999a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-3v-7a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconSquareRoundedLetterLFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterLFilled
});

var IconSquareRoundedLetterMFilled = createReactComponent("filled", "square-rounded-letter-m-filled", "IconSquareRoundedLetterMFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m4.324 5.999c0 -1.014 -1.336 -1.384 -1.857 -.514l-2.143 3.57l-2.143 -3.57c-.521 -.87 -1.857 -.5 -1.857 .514v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-4.39l1.143 1.904l.074 .108a1 1 0 0 0 1.64 -.108l1.143 -1.904v4.39a1 1 0 0 0 2 0z", "key": "svg-0" }]]);

var IconSquareRoundedLetterMFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterMFilled
});

var IconSquareRoundedLetterNFilled = createReactComponent("filled", "square-rounded-letter-n-filled", "IconSquareRoundedLetterNFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m-.782 5.552c-.471 -.944 -1.894 -.608 -1.894 .447v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3.764l2.106 4.211c.471 .944 1.894 .608 1.894 -.447v-8a1 1 0 0 0 -1 -1l-.117 .007a1 1 0 0 0 -.883 .993v3.764z", "key": "svg-0" }]]);

var IconSquareRoundedLetterNFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterNFilled
});

var IconSquareRoundedLetterOFilled = createReactComponent("filled", "square-rounded-letter-o-filled", "IconSquareRoundedLetterOFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m.324 4.999a3 3 0 0 0 -3 3v4a3 3 0 0 0 6 0v-4a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v4a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1 -1", "key": "svg-0" }]]);

var IconSquareRoundedLetterOFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterOFilled
});

var IconSquareRoundedLetterPFilled = createReactComponent("filled", "square-rounded-letter-p-filled", "IconSquareRoundedLetterPFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m.324 4.999h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-3h1a3 3 0 0 0 0 -6m0 2a1 1 0 0 1 0 2h-1v-2z", "key": "svg-0" }]]);

var IconSquareRoundedLetterPFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterPFilled
});

var IconSquareRoundedLetterQFilled = createReactComponent("filled", "square-rounded-letter-q-filled", "IconSquareRoundedLetterQFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m.324 4.999a3 3 0 0 0 -3 3v4a3 3 0 0 0 4.168 2.764l.125 -.057a1 1 0 0 0 1.414 -1.414l.057 -.125a3 3 0 0 0 .236 -1.168v-4a3 3 0 0 0 -3 -3m1 7.001h-.059a.996 .996 0 0 0 -.941 1a1 1 0 0 1 -1 -1.001v-4a1 1 0 0 1 2 0z", "key": "svg-0" }]]);

var IconSquareRoundedLetterQFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterQFilled
});

var IconSquareRoundedLetterRFilled = createReactComponent("filled", "square-rounded-letter-r-filled", "IconSquareRoundedLetterRFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m.324 4.999h-2a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .883 -.993v-2.332l2.2 2.932a1 1 0 0 0 1.4 .2l.096 -.081a1 1 0 0 0 .104 -1.319l-1.903 -2.538l.115 -.037a3.001 3.001 0 0 0 -1.012 -5.825m0 2a1 1 0 0 1 0 2h-1v-2z", "key": "svg-0" }]]);

var IconSquareRoundedLetterRFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterRFilled
});

var IconSquareRoundedLetterSFilled = createReactComponent("filled", "square-rounded-letter-s-filled", "IconSquareRoundedLetterSFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m1.324 4.999h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2v2h-2a1 1 0 0 0 -2 0a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-2v-2h2l.007 .117a1 1 0 0 0 1.993 -.117a2 2 0 0 0 -2 -2", "key": "svg-0" }]]);

var IconSquareRoundedLetterSFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterSFilled
});

var IconSquareRoundedLetterTFilled = createReactComponent("filled", "square-rounded-letter-t-filled", "IconSquareRoundedLetterTFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.324 4.999h-4a1 1 0 1 0 0 2h1v7a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-7h1a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconSquareRoundedLetterTFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterTFilled
});

var IconSquareRoundedLetterUFilled = createReactComponent("filled", "square-rounded-letter-u-filled", "IconSquareRoundedLetterUFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.324 4.999a1 1 0 0 0 -1 1v6a1 1 0 0 1 -2 0v-6a1 1 0 0 0 -2 0v6a3 3 0 0 0 6 0v-6a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconSquareRoundedLetterUFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterUFilled
});

var IconSquareRoundedLetterVFilled = createReactComponent("filled", "square-rounded-letter-v-filled", "IconSquareRoundedLetterVFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.567 5.029a1 1 0 0 0 -1.213 .727l-1.03 4.118l-1.03 -4.118a1 1 0 1 0 -1.94 .486l2 8c.252 1.01 1.688 1.01 1.94 0l2 -8a1 1 0 0 0 -.727 -1.213", "key": "svg-0" }]]);

var IconSquareRoundedLetterVFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterVFilled
});

var IconSquareRoundedLetterWFilled = createReactComponent("filled", "square-rounded-letter-w-filled", "IconSquareRoundedLetterWFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.332 5.875l-.52 4.153l-.56 -1.4c-.319 -.799 -1.41 -.837 -1.803 -.114l-.053 .114l-.561 1.4l-.519 -4.153a1 1 0 0 0 -1 -.876l-.116 .008a1 1 0 0 0 -.868 1.116l1 8c.128 1.025 1.537 1.207 1.92 .247l1.072 -2.678l1.072 2.678c.383 .96 1.792 .778 1.92 -.247l1 -8a1 1 0 0 0 -1.984 -.248", "key": "svg-0" }]]);

var IconSquareRoundedLetterWFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterWFilled
});

var IconSquareRoundedLetterXFilled = createReactComponent("filled", "square-rounded-letter-x-filled", "IconSquareRoundedLetterXFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.771 5.105a1 1 0 0 0 -1.341 .447l-1.106 2.21l-1.106 -2.21a1 1 0 0 0 -1.234 -.494l-.107 .047a1 1 0 0 0 -.447 1.341l1.774 3.553l-1.775 3.553a1 1 0 0 0 .345 1.283l.102 .058a1 1 0 0 0 1.341 -.447l1.107 -2.211l1.106 2.211a1 1 0 0 0 1.234 .494l.107 -.047a1 1 0 0 0 .447 -1.341l-1.776 -3.553l1.776 -3.553a1 1 0 0 0 -.345 -1.283z", "key": "svg-0" }]]);

var IconSquareRoundedLetterXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterXFilled
});

var IconSquareRoundedLetterYFilled = createReactComponent("filled", "square-rounded-letter-y-filled", "IconSquareRoundedLetterYFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.695 5.07a1 1 0 0 0 -1.3 .558l-1.071 2.678l-1.072 -2.678a1 1 0 0 0 -1.856 .742l1.928 4.823v2.806a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-2.809l1.928 -4.82a1 1 0 0 0 -.45 -1.25z", "key": "svg-0" }]]);

var IconSquareRoundedLetterYFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterYFilled
});

var IconSquareRoundedLetterZFilled = createReactComponent("filled", "square-rounded-letter-z-filled", "IconSquareRoundedLetterZFilled", [["path", { "d": "M11.676 2.001l.324 -.001c7.752 0 10 2.248 10 10l-.005 .642c-.126 7.235 -2.461 9.358 -9.995 9.358l-.642 -.005c-7.13 -.125 -9.295 -2.395 -9.358 -9.67v-.325c0 -7.643 2.185 -9.936 9.676 -9.999m2.324 4.999h-4a1 1 0 0 0 -1 1l.007 .117a1 1 0 0 0 .993 .883h2.382l-3.276 6.553a1 1 0 0 0 .894 1.447h4a1 1 0 0 0 1 -1l-.007 -.117a1 1 0 0 0 -.993 -.883h-2.382l3.276 -6.553a1 1 0 0 0 -.894 -1.447", "key": "svg-0" }]]);

var IconSquareRoundedLetterZFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedLetterZFilled
});

var IconSquareRoundedMinusFilled = createReactComponent("filled", "square-rounded-minus-filled", "IconSquareRoundedMinusFilled", [["path", { "d": "M12 2l.324 .001l.318 .004l.616 .017l.299 .013l.579 .034l.553 .046c4.785 .464 6.732 2.411 7.196 7.196l.046 .553l.034 .579c.005 .098 .01 .198 .013 .299l.017 .616l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.464 4.785 -2.411 6.732 -7.196 7.196l-.553 .046l-.579 .034c-.098 .005 -.198 .01 -.299 .013l-.616 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.785 -.464 -6.732 -2.411 -7.196 -7.196l-.046 -.553l-.034 -.579a28.058 28.058 0 0 1 -.013 -.299l-.017 -.616c-.003 -.21 -.005 -.424 -.005 -.642l.001 -.324l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.464 -4.785 2.411 -6.732 7.196 -7.196l.553 -.046l.579 -.034c.098 -.005 .198 -.01 .299 -.013l.616 -.017c.21 -.003 .424 -.005 .642 -.005zm3 9h-6l-.117 .007a1 1 0 0 0 .117 1.993h6l.117 -.007a1 1 0 0 0 -.117 -1.993z", "key": "svg-0" }]]);

var IconSquareRoundedMinusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedMinusFilled
});

var IconSquareRoundedNumber0Filled = createReactComponent("filled", "square-rounded-number-0-filled", "IconSquareRoundedNumber0Filled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm0 5a3 3 0 0 0 -3 3v4a3 3 0 0 0 6 0v-4a3 3 0 0 0 -3 -3zm0 2a1 1 0 0 1 1 1v4a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconSquareRoundedNumber0Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber0Filled
});

var IconSquareRoundedNumber1Filled = createReactComponent("filled", "square-rounded-number-1-filled", "IconSquareRoundedNumber1Filled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm.994 5.886c-.083 -.777 -1.008 -1.16 -1.617 -.67l-.084 .077l-2 2l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l.293 -.293v5.586l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.006 -.114z", "key": "svg-0" }]]);

var IconSquareRoundedNumber1Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber1Filled
});

var IconSquareRoundedNumber2Filled = createReactComponent("filled", "square-rounded-number-2-filled", "IconSquareRoundedNumber2Filled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm1 5h-3l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h3v2h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h3l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-3v-2h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z", "key": "svg-0" }]]);

var IconSquareRoundedNumber2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber2Filled
});

var IconSquareRoundedNumber3Filled = createReactComponent("filled", "square-rounded-number-3-filled", "IconSquareRoundedNumber3Filled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm1 5h-2l-.15 .005a2 2 0 0 0 -1.85 1.995a1 1 0 0 0 1.974 .23l.02 -.113l.006 -.117h2v2h-2l-.133 .007c-1.111 .12 -1.154 1.73 -.128 1.965l.128 .021l.133 .007h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z", "key": "svg-0" }]]);

var IconSquareRoundedNumber3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber3Filled
});

var IconSquareRoundedNumber4Filled = createReactComponent("filled", "square-rounded-number-4-filled", "IconSquareRoundedNumber4Filled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm2 5a1 1 0 0 0 -.993 .883l-.007 .117v3h-2v-3l-.007 -.117a1 1 0 0 0 -1.986 0l-.007 .117v3l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v3l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconSquareRoundedNumber4Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber4Filled
});

var IconSquareRoundedNumber5Filled = createReactComponent("filled", "square-rounded-number-5-filled", "IconSquareRoundedNumber5Filled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm2 5h-4a1 1 0 0 0 -.993 .883l-.007 .117v4a1 1 0 0 0 .883 .993l.117 .007h3v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2a2 2 0 0 0 1.995 -1.85l.005 -.15v-2a2 2 0 0 0 -1.85 -1.995l-.15 -.005h-2v-2h3a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -.883 -.993l-.117 -.007z", "key": "svg-0" }]]);

var IconSquareRoundedNumber5Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber5Filled
});

var IconSquareRoundedNumber6Filled = createReactComponent("filled", "square-rounded-number-6-filled", "IconSquareRoundedNumber6Filled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm1 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v6l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006h-2v-2h2l.007 .117a1 1 0 0 0 1.993 -.117a2 2 0 0 0 -1.85 -1.995l-.15 -.005zm0 6v2h-2v-2h2z", "key": "svg-0" }]]);

var IconSquareRoundedNumber6Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber6Filled
});

var IconSquareRoundedNumber7Filled = createReactComponent("filled", "square-rounded-number-7-filled", "IconSquareRoundedNumber7Filled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm2 5h-4l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117l.007 .117a1 1 0 0 0 .876 .876l.117 .007h2.718l-1.688 6.757l-.022 .115a1 1 0 0 0 1.927 .482l.035 -.111l2 -8l.021 -.112a1 1 0 0 0 -.878 -1.125l-.113 -.006z", "key": "svg-0" }]]);

var IconSquareRoundedNumber7Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber7Filled
});

var IconSquareRoundedNumber8Filled = createReactComponent("filled", "square-rounded-number-8-filled", "IconSquareRoundedNumber8Filled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm1 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15c.018 .236 .077 .46 .17 .667l.075 .152l.018 .03l-.018 .032c-.133 .24 -.218 .509 -.243 .795l-.007 .174v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 6v2h-2v-2h2zm0 -4v2h-2v-2h2z", "key": "svg-0" }]]);

var IconSquareRoundedNumber8Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber8Filled
});

var IconSquareRoundedNumber9Filled = createReactComponent("filled", "square-rounded-number-9-filled", "IconSquareRoundedNumber9Filled", [["path", { "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm1 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-6l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 2v2h-2v-2h2z", "key": "svg-0" }]]);

var IconSquareRoundedNumber9Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedNumber9Filled
});

var IconSquareRoundedPlusFilled = createReactComponent("filled", "square-rounded-plus-filled", "IconSquareRoundedPlusFilled", [["path", { "d": "M12 2l.324 .001l.318 .004l.616 .017l.299 .013l.579 .034l.553 .046c4.785 .464 6.732 2.411 7.196 7.196l.046 .553l.034 .579c.005 .098 .01 .198 .013 .299l.017 .616l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.464 4.785 -2.411 6.732 -7.196 7.196l-.553 .046l-.579 .034c-.098 .005 -.198 .01 -.299 .013l-.616 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.785 -.464 -6.732 -2.411 -7.196 -7.196l-.046 -.553l-.034 -.579a28.058 28.058 0 0 1 -.013 -.299l-.017 -.616c-.003 -.21 -.005 -.424 -.005 -.642l.001 -.324l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.464 -4.785 2.411 -6.732 7.196 -7.196l.553 -.046l.579 -.034c.098 -.005 .198 -.01 .299 -.013l.616 -.017c.21 -.003 .424 -.005 .642 -.005zm0 6a1 1 0 0 0 -1 1v2h-2l-.117 .007a1 1 0 0 0 .117 1.993h2v2l.007 .117a1 1 0 0 0 1.993 -.117v-2h2l.117 -.007a1 1 0 0 0 -.117 -1.993h-2v-2l-.007 -.117a1 1 0 0 0 -.993 -.883z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedPlusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedPlusFilled
});

var IconSquareRoundedXFilled = createReactComponent("filled", "square-rounded-x-filled", "IconSquareRoundedXFilled", [["path", { "d": "M12 2l.324 .001l.318 .004l.616 .017l.299 .013l.579 .034l.553 .046c4.785 .464 6.732 2.411 7.196 7.196l.046 .553l.034 .579c.005 .098 .01 .198 .013 .299l.017 .616l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.464 4.785 -2.411 6.732 -7.196 7.196l-.553 .046l-.579 .034c-.098 .005 -.198 .01 -.299 .013l-.616 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.785 -.464 -6.732 -2.411 -7.196 -7.196l-.046 -.553l-.034 -.579a28.058 28.058 0 0 1 -.013 -.299l-.017 -.616c-.003 -.21 -.005 -.424 -.005 -.642l.001 -.324l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.464 -4.785 2.411 -6.732 7.196 -7.196l.553 -.046l.579 -.034c.098 -.005 .198 -.01 .299 -.013l.616 -.017c.21 -.003 .424 -.005 .642 -.005zm-1.489 7.14a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z", "fill": "currentColor", "key": "svg-0", "strokeWidth": "0" }]]);

var IconSquareRoundedXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedXFilled
});

var IconSquareRoundedFilled = createReactComponent("filled", "square-rounded-filled", "IconSquareRoundedFilled", [["path", { "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001z", "key": "svg-0" }]]);

var IconSquareRoundedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareRoundedFilled
});

var IconSquareXFilled = createReactComponent("filled", "square-x-filled", "IconSquareXFilled", [["path", { "d": "M19 2h-14a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3zm-9.387 6.21l.094 .083l2.293 2.292l2.293 -2.292a1 1 0 0 1 1.497 1.32l-.083 .094l-2.292 2.293l2.292 2.293a1 1 0 0 1 -1.32 1.497l-.094 -.083l-2.293 -2.292l-2.293 2.292a1 1 0 0 1 -1.497 -1.32l.083 -.094l2.292 -2.293l-2.292 -2.293a1 1 0 0 1 1.32 -1.497z", "key": "svg-0" }]]);

var IconSquareXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareXFilled
});

var IconSquareFilled = createReactComponent("filled", "square-filled", "IconSquareFilled", [["path", { "d": "M19 2h-14a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3z", "key": "svg-0" }]]);

var IconSquareFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquareFilled
});

var IconSquaresFilled = createReactComponent("filled", "squares-filled", "IconSquaresFilled", [["path", { "d": "M19 7a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3h-9a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M14 2a3 3 0 0 1 3 2.999l-7 .001a5 5 0 0 0 -5 5l-.001 7l-.175 -.005a3 3 0 0 1 -2.824 -2.995v-9a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

var IconSquaresFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSquaresFilled
});

var IconStack2Filled = createReactComponent("filled", "stack-2-filled", "IconStack2Filled", [["path", { "d": "M20.894 15.553a1 1 0 0 1 -.447 1.341l-8 4a1 1 0 0 1 -.894 0l-8 -4a1 1 0 0 1 .894 -1.788l7.553 3.774l7.554 -3.775a1 1 0 0 1 1.341 .447m0 -4a1 1 0 0 1 -.447 1.341l-8 4a1 1 0 0 1 -.894 0l-8 -4a1 1 0 0 1 .894 -1.788l7.552 3.775l7.554 -3.775a1 1 0 0 1 1.341 .447m-8.887 -8.552q .056 0 .111 .007l.111 .02l.086 .024l.012 .006l.012 .002l.029 .014l.05 .019l.016 .009l.012 .005l8 4a1 1 0 0 1 0 1.788l-8 4a1 1 0 0 1 -.894 0l-8 -4a1 1 0 0 1 0 -1.788l8 -4l.011 -.005l.018 -.01l.078 -.032l.011 -.002l.013 -.006l.086 -.024l.11 -.02l.056 -.005z", "key": "svg-0" }]]);

var IconStack2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStack2Filled
});

var IconStack3Filled = createReactComponent("filled", "stack-3-filled", "IconStack3Filled", [["path", { "d": "M20.894 17.553a1 1 0 0 1 -.447 1.341l-8 4a1 1 0 0 1 -.894 0l-8 -4a1 1 0 0 1 .894 -1.788l7.553 3.774l7.554 -3.775a1 1 0 0 1 1.341 .447m0 -4a1 1 0 0 1 -.447 1.341l-8 4a1 1 0 0 1 -.894 0l-8 -4a1 1 0 0 1 .894 -1.788l7.552 3.775l7.554 -3.775a1 1 0 0 1 1.341 .447m0 -4a1 1 0 0 1 -.447 1.341l-8 4a1 1 0 0 1 -.894 0l-8 -4a1 1 0 0 1 .894 -1.788l7.552 3.775l7.554 -3.775a1 1 0 0 1 1.341 .447m-8.887 -8.552q .056 0 .111 .007l.111 .02l.086 .024l.012 .006l.012 .002l.029 .014l.05 .019l.016 .009l.012 .005l8 4a1 1 0 0 1 0 1.788l-8 4a1 1 0 0 1 -.894 0l-8 -4a1 1 0 0 1 0 -1.788l8 -4l.011 -.005l.018 -.01l.078 -.032l.011 -.002l.013 -.006l.086 -.024l.11 -.02l.056 -.005z", "key": "svg-0" }]]);

var IconStack3Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStack3Filled
});

var IconStackFilled = createReactComponent("filled", "stack-filled", "IconStackFilled", [["path", { "d": "M20.894 13.553a1 1 0 0 1 -.447 1.341l-8 4a1 1 0 0 1 -.894 0l-8 -4a1 1 0 0 1 .894 -1.788l7.553 3.774l7.554 -3.775a1 1 0 0 1 1.341 .447m-8.887 -8.552q .056 0 .111 .007l.111 .02l.086 .024l.012 .006l.012 .002l.029 .014l.05 .019l.016 .009l.012 .005l8 4a1 1 0 0 1 0 1.788l-8 4a1 1 0 0 1 -.894 0l-8 -4a1 1 0 0 1 0 -1.788l8 -4l.011 -.005l.018 -.01l.078 -.032l.011 -.002l.013 -.006l.086 -.024l.11 -.02l.056 -.005z", "key": "svg-0" }]]);

var IconStackFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStackFilled
});

var IconStarHalfFilled = createReactComponent("filled", "star-half-filled", "IconStarHalfFilled", [["path", { "d": "M12 1a.993 .993 0 0 1 .823 .443l.067 .116l2.852 5.781l6.38 .925c.741 .108 1.08 .94 .703 1.526l-.07 .095l-.078 .086l-4.624 4.499l1.09 6.355a1.001 1.001 0 0 1 -1.249 1.135l-.101 -.035l-.101 -.046l-5.693 -3l-5.706 3c-.105 .055 -.212 .09 -.32 .106l-.106 .01a1.003 1.003 0 0 1 -1.038 -1.06l.013 -.11l1.09 -6.355l-4.623 -4.5a1.001 1.001 0 0 1 .328 -1.647l.113 -.036l.114 -.023l6.379 -.925l2.853 -5.78a.968 .968 0 0 1 .904 -.56zm0 3.274v12.476a1 1 0 0 1 .239 .029l.115 .036l.112 .05l4.363 2.299l-.836 -4.873a1 1 0 0 1 .136 -.696l.07 -.099l.082 -.09l3.546 -3.453l-4.891 -.708a1 1 0 0 1 -.62 -.344l-.073 -.097l-.06 -.106l-2.183 -4.424z", "key": "svg-0" }]]);

var IconStarHalfFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStarHalfFilled
});

var IconStarFilled = createReactComponent("filled", "star-filled", "IconStarFilled", [["path", { "d": "M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z", "key": "svg-0" }]]);

var IconStarFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStarFilled
});

var IconStarsFilled = createReactComponent("filled", "stars-filled", "IconStarsFilled", [["path", { "d": "M17.657 12.007a1.39 1.39 0 0 0 -1.103 .765l-.855 1.723l-1.907 .277c-.52 .072 -.96 .44 -1.124 .944l-.038 .14c-.1 .465 .046 .954 .393 1.29l1.377 1.337l-.326 1.892a1.393 1.393 0 0 0 2.018 1.465l1.708 -.895l1.708 .896a1.388 1.388 0 0 0 1.462 -.105l.112 -.09a1.39 1.39 0 0 0 .442 -1.272l-.325 -1.891l1.38 -1.339c.38 -.371 .516 -.924 .352 -1.427l-.051 -.134a1.39 1.39 0 0 0 -1.073 -.81l-1.907 -.278l-.853 -1.722a1.393 1.393 0 0 0 -1.247 -.773l-.143 .007z", "key": "svg-0" }], ["path", { "d": "M6.057 12.007a1.39 1.39 0 0 0 -1.103 .765l-.855 1.723l-1.907 .277c-.52 .072 -.96 .44 -1.124 .944l-.038 .14c-.1 .465 .046 .954 .393 1.29l1.377 1.337l-.326 1.892a1.393 1.393 0 0 0 2.018 1.465l1.708 -.895l1.708 .896a1.388 1.388 0 0 0 1.462 -.105l.112 -.09a1.39 1.39 0 0 0 .442 -1.272l-.324 -1.891l1.38 -1.339c.38 -.371 .516 -.924 .352 -1.427l-.051 -.134a1.39 1.39 0 0 0 -1.073 -.81l-1.908 -.279l-.853 -1.722a1.393 1.393 0 0 0 -1.247 -.772l-.143 .007z", "key": "svg-1" }], ["path", { "d": "M11.857 2.007a1.39 1.39 0 0 0 -1.103 .765l-.855 1.723l-1.907 .277c-.52 .072 -.96 .44 -1.124 .944l-.038 .14c-.1 .465 .046 .954 .393 1.29l1.377 1.337l-.326 1.892a1.393 1.393 0 0 0 2.018 1.465l1.708 -.894l1.709 .896a1.388 1.388 0 0 0 1.462 -.105l.112 -.09a1.39 1.39 0 0 0 .442 -1.272l-.325 -1.892l1.38 -1.339c.38 -.371 .516 -.924 .352 -1.427l-.051 -.134a1.39 1.39 0 0 0 -1.073 -.81l-1.908 -.279l-.853 -1.722a1.393 1.393 0 0 0 -1.247 -.772l-.143 .007z", "key": "svg-2" }]]);

var IconStarsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconStarsFilled
});

var IconSteeringWheelFilled = createReactComponent("filled", "steering-wheel-filled", "IconSteeringWheelFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-13 8.66a8 8 0 0 0 7 7.937v-5.107a3 3 0 0 1 -1.898 -2.05l-5.07 -1.504q -.031 .36 -.032 .725m15.967 -.725l-5.069 1.503a3 3 0 0 1 -1.897 2.051v5.108a8 8 0 0 0 6.985 -8.422zm-11.967 -6.204a8 8 0 0 0 -3.536 4.244l4.812 1.426a3 3 0 0 1 5.448 0l4.812 -1.426a8 8 0 0 0 -11.536 -4.244", "key": "svg-0" }]]);

var IconSteeringWheelFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSteeringWheelFilled
});

var IconSunHighFilled = createReactComponent("filled", "sun-high-filled", "IconSunHighFilled", [["path", { "d": "M12 19a1 1 0 0 1 1 1v2a1 1 0 0 1 -2 0v-2a1 1 0 0 1 1 -1m-4.95 -2.05a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 1 1 -1.414 -1.414l1.414 -1.414a1 1 0 0 1 1.414 0m11.314 0l1.414 1.414a1 1 0 0 1 -1.414 1.414l-1.414 -1.414a1 1 0 0 1 1.414 -1.414m-5.049 -9.836a5 5 0 1 1 -2.532 9.674a5 5 0 0 1 2.532 -9.674m-9.315 3.886a1 1 0 0 1 0 2h-2a1 1 0 0 1 0 -2zm18 0a1 1 0 0 1 0 2h-2a1 1 0 0 1 0 -2zm-16.364 -6.778l1.414 1.414a1 1 0 0 1 -1.414 1.414l-1.414 -1.414a1 1 0 0 1 1.414 -1.414m14.142 0a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1 -1.414 -1.414l1.414 -1.414a1 1 0 0 1 1.414 0m-7.778 -3.222a1 1 0 0 1 1 1v2a1 1 0 0 1 -2 0v-2a1 1 0 0 1 1 -1", "key": "svg-0" }]]);

var IconSunHighFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunHighFilled
});

var IconSunLowFilled = createReactComponent("filled", "sun-low-filled", "IconSunLowFilled", [["path", { "d": "M18.407 16.993l.01 .01a1 1 0 0 1 -1.32 1.497l-.104 -.093a1 1 0 0 1 1.414 -1.414m-11.4 0l.01 .01a1 1 0 0 1 -1.32 1.497l-.104 -.093a1 1 0 0 1 1.414 -1.414m4.993 -9.993a5 5 0 1 1 -5 5l.005 -.217a5 5 0 0 1 4.995 -4.783m-4.993 -1.407l.01 .01a1 1 0 0 1 -1.32 1.497l-.104 -.093a1 1 0 0 1 1.414 -1.414m11.4 0l.01 .01a1 1 0 0 1 -1.32 1.497l-.104 -.093a1 1 0 1 1 1.414 -1.414m-14.397 5.407a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993zm7.99 -8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1m8.01 8a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993zm-8.01 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1", "key": "svg-0" }]]);

var IconSunLowFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunLowFilled
});

var IconSunFilled = createReactComponent("filled", "sun-filled", "IconSunFilled", [["path", { "d": "M12 19a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M18.313 16.91l.094 .083l.7 .7a1 1 0 0 1 -1.32 1.497l-.094 -.083l-.7 -.7a1 1 0 0 1 1.218 -1.567l.102 .07z", "key": "svg-1" }], ["path", { "d": "M7.007 16.993a1 1 0 0 1 .083 1.32l-.083 .094l-.7 .7a1 1 0 0 1 -1.497 -1.32l.083 -.094l.7 -.7a1 1 0 0 1 1.414 0z", "key": "svg-2" }], ["path", { "d": "M4 11a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-3" }], ["path", { "d": "M21 11a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-4" }], ["path", { "d": "M6.213 4.81l.094 .083l.7 .7a1 1 0 0 1 -1.32 1.497l-.094 -.083l-.7 -.7a1 1 0 0 1 1.217 -1.567l.102 .07z", "key": "svg-5" }], ["path", { "d": "M19.107 4.893a1 1 0 0 1 .083 1.32l-.083 .094l-.7 .7a1 1 0 0 1 -1.497 -1.32l.083 -.094l.7 -.7a1 1 0 0 1 1.414 0z", "key": "svg-6" }], ["path", { "d": "M12 2a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z", "key": "svg-7" }], ["path", { "d": "M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z", "key": "svg-8" }]]);

var IconSunFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunFilled
});

var IconSunglassesFilled = createReactComponent("filled", "sunglasses-filled", "IconSunglassesFilled", [["path", { "d": "M8 3a1 1 0 1 1 0 2h-1.257l-2.4 8h5.657a1 1 0 0 1 1 1v1h2v-1a1 1 0 0 1 1 -1h5.656l-2.4 -8h-1.256a1 1 0 0 1 -.993 -.883l-.007 -.117a1 1 0 0 1 1 -1h2a1 1 0 0 1 .958 .713l3.01 10.036l.022 .112l.008 .08l.002 2.559a4.5 4.5 0 0 1 -8.972 .5h-2.056a4.5 4.5 0 0 1 -8.972 -.5v-2.518l.004 -.071l.014 -.103l.018 -.076l3.006 -10.02a1 1 0 0 1 .958 -.712z", "key": "svg-0" }]]);

var IconSunglassesFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunglassesFilled
});

var IconSunriseFilled = createReactComponent("filled", "sunrise-filled", "IconSunriseFilled", [["path", { "d": "M4 16a1 1 0 0 1 0 2h-1a1 1 0 0 1 0 -2z", "key": "svg-0" }], ["path", { "d": "M12 12a5 5 0 0 1 5 5a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1a5 5 0 0 1 5 -5", "key": "svg-1" }], ["path", { "d": "M21 16a1 1 0 0 1 0 2h-1a1 1 0 0 1 0 -2z", "key": "svg-2" }], ["path", { "d": "M6.307 9.893l.7 .7a1 1 0 0 1 -1.414 1.414l-.7 -.7a1 1 0 0 1 1.414 -1.414", "key": "svg-3" }], ["path", { "d": "M19.107 9.893a1 1 0 0 1 0 1.414l-.7 .7a1 1 0 0 1 -1.414 -1.414l.7 -.7a1 1 0 0 1 1.414 0", "key": "svg-4" }], ["path", { "d": "M12.707 2.293l3 3a1 1 0 1 1 -1.414 1.414l-1.293 -1.292v3.585a1 1 0 0 1 -.883 .993l-.117 .007a1 1 0 0 1 -1 -1v-3.586l-1.293 1.293a1 1 0 0 1 -1.414 -1.414l2.958 -2.96a1 1 0 0 1 .15 -.135l.127 -.08l.068 -.033l.11 -.041l.12 -.029c.3 -.055 .627 .024 .881 .278", "key": "svg-5" }], ["path", { "d": "M3 20h18a1 1 0 0 1 0 2h-18a1 1 0 0 1 0 -2", "key": "svg-6" }], ["path", { "d": "M12 12a5 5 0 0 1 4.583 7.002h-9.166a5 5 0 0 1 4.583 -7.002", "key": "svg-7" }]]);

var IconSunriseFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunriseFilled
});

var IconSunset2Filled = createReactComponent("filled", "sunset-2-filled", "IconSunset2Filled", [["path", { "d": "M4 12a1 1 0 0 1 0 2h-1a1 1 0 0 1 0 -2z", "key": "svg-0" }], ["path", { "d": "M21 12a1 1 0 0 1 0 2h-1a1 1 0 0 1 0 -2z", "key": "svg-1" }], ["path", { "d": "M6.307 5.893l.7 .7a1 1 0 0 1 -1.414 1.414l-.7 -.7a1 1 0 0 1 1.414 -1.414", "key": "svg-2" }], ["path", { "d": "M19.107 5.893a1 1 0 0 1 0 1.414l-.7 .7a1 1 0 0 1 -1.414 -1.414l.7 -.7a1 1 0 0 1 1.414 0", "key": "svg-3" }], ["path", { "d": "M12 3a1 1 0 0 1 1 1v1a1 1 0 0 1 -2 0v-1a1 1 0 0 1 1 -1", "key": "svg-4" }], ["path", { "d": "M3 16h18a1 1 0 0 1 0 2h-18a1 1 0 0 1 0 -2", "key": "svg-5" }], ["path", { "d": "M12 8a5 5 0 0 1 4.583 7.002h-9.166a5 5 0 0 1 4.583 -7.002", "key": "svg-6" }], ["path", { "d": "M12 19a1 1 0 0 1 0 2h-5a1 1 0 0 1 0 -2z", "key": "svg-7" }], ["path", { "d": "M17 19a1 1 0 0 1 0 2h-1a1 1 0 0 1 0 -2z", "key": "svg-8" }]]);

var IconSunset2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunset2Filled
});

var IconSunsetFilled = createReactComponent("filled", "sunset-filled", "IconSunsetFilled", [["path", { "d": "M4 16a1 1 0 0 1 0 2h-1a1 1 0 0 1 0 -2z", "key": "svg-0" }], ["path", { "d": "M21 16a1 1 0 0 1 0 2h-1a1 1 0 0 1 0 -2z", "key": "svg-1" }], ["path", { "d": "M6.307 9.893l.7 .7a1 1 0 0 1 -1.414 1.414l-.7 -.7a1 1 0 0 1 1.414 -1.414", "key": "svg-2" }], ["path", { "d": "M19.107 9.893a1 1 0 0 1 0 1.414l-.7 .7a1 1 0 0 1 -1.414 -1.414l.7 -.7a1 1 0 0 1 1.414 0", "key": "svg-3" }], ["path", { "d": "M12 2a1 1 0 0 1 1 1v3.584l1.293 -1.291a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3a.98 .98 0 0 1 -.767 .293l-.124 -.017l-.127 -.032l-.104 -.04l-.115 -.063a1 1 0 0 1 -.151 -.114l-3.026 -3.027a1 1 0 0 1 1.414 -1.414l1.293 1.292v-3.585a1 1 0 0 1 1 -1", "key": "svg-4" }], ["path", { "d": "M3 20h18a1 1 0 0 1 0 2h-18a1 1 0 0 1 0 -2", "key": "svg-5" }], ["path", { "d": "M12 12a5 5 0 0 1 4.583 7.002h-9.166a5 5 0 0 1 4.583 -7.002", "key": "svg-6" }]]);

var IconSunsetFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSunsetFilled
});

var IconSwipeDownFilled = createReactComponent("filled", "swipe-down-filled", "IconSwipeDownFilled", [["path", { "d": "M12 3a5 5 0 0 1 1.001 9.9l-.001 4.684l1.293 -1.291a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.096 -.067l-.09 -.08l-3 -3a1 1 0 0 1 1.414 -1.414l1.293 1.292v-4.685a5.002 5.002 0 0 1 1 -9.9", "key": "svg-0" }]]);

var IconSwipeDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwipeDownFilled
});

var IconSwipeLeftFilled = createReactComponent("filled", "swipe-left-filled", "IconSwipeLeftFilled", [["path", { "d": "M16 7a5 5 0 1 1 -4.9 6.001l-4.685 -.001l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.414 0l-3 -3a1 1 0 0 1 -.097 -.112l-.071 -.11l-.054 -.114l-.035 -.105l-.025 -.118l-.007 -.058l-.004 -.09l.003 -.075l.017 -.126l.03 -.111l.044 -.111l.052 -.098l.067 -.096l.08 -.09l3 -3a1 1 0 0 1 1.414 1.414l-1.292 1.293h4.685a5 5 0 0 1 4.9 -4", "key": "svg-0" }]]);

var IconSwipeLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwipeLeftFilled
});

var IconSwipeRightFilled = createReactComponent("filled", "swipe-right-filled", "IconSwipeRightFilled", [["path", { "d": "M8 7a5 5 0 0 1 4.9 4h4.685l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.414 0l3 3q .054 .053 .097 .112l.071 .11l.054 .114l.035 .105l.03 .148l.006 .118l-.003 .075l-.017 .126l-.03 .111l-.044 .111l-.052 .098l-.074 .104l-.073 .082l-3 3a1 1 0 0 1 -1.414 -1.414l1.291 -1.293l-4.684 .001a5.002 5.002 0 0 1 -9.9 -1.001a5 5 0 0 1 5 -5", "key": "svg-0" }]]);

var IconSwipeRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwipeRightFilled
});

var IconSwipeUpFilled = createReactComponent("filled", "swipe-up-filled", "IconSwipeUpFilled", [["path", { "d": "M11.852 3.011l.058 -.007l.09 -.004l.075 .003l.126 .017l.111 .03l.111 .044l.098 .052l.104 .074l.082 .073l3 3a1 1 0 1 1 -1.414 1.414l-1.293 -1.292l.001 4.685a5.002 5.002 0 0 1 -1.001 9.9a5 5 0 0 1 -5 -5l.005 -.217a5 5 0 0 1 3.995 -4.683v-4.685l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 0 -1.414l3 -3q .053 -.054 .112 -.097l.11 -.071l.114 -.054l.105 -.035z", "key": "svg-0" }]]);

var IconSwipeUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconSwipeUpFilled
});

var IconTableFilled = createReactComponent("filled", "table-filled", "IconTableFilled", [["path", { "d": "M4 11h4a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-2a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M21 12v6a3 3 0 0 1 -2.824 2.995l-.176 .005h-6a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1z", "key": "svg-1" }], ["path", { "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v2a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h6z", "key": "svg-2" }], ["path", { "d": "M9 4v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a3 3 0 0 1 2.824 -2.995l.176 -.005h2a1 1 0 0 1 1 1z", "key": "svg-3" }]]);

var IconTableFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTableFilled
});

var IconTagFilled = createReactComponent("filled", "tag-filled", "IconTagFilled", [["path", { "d": "M11.172 2a3 3 0 0 1 2.121 .879l7.71 7.71a3.41 3.41 0 0 1 0 4.822l-5.592 5.592a3.41 3.41 0 0 1 -4.822 0l-7.71 -7.71a3 3 0 0 1 -.879 -2.121v-5.172a4 4 0 0 1 4 -4zm-3.672 3.5a2 2 0 0 0 -1.995 1.85l-.005 .15a2 2 0 1 0 2 -2", "key": "svg-0" }]]);

var IconTagFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTagFilled
});

var IconTagsFilled = createReactComponent("filled", "tags-filled", "IconTagsFilled", [["path", { "d": "M9.172 5a3 3 0 0 1 2.121 .879l5.71 5.71a3.41 3.41 0 0 1 0 4.822l-3.592 3.592a3.41 3.41 0 0 1 -4.822 0l-5.71 -5.71a3 3 0 0 1 -.879 -2.121v-4.172a3 3 0 0 1 3 -3zm-2.172 4h-.01a1 1 0 1 0 .01 2a1 1 0 0 0 0 -2", "key": "svg-0" }], ["path", { "d": "M14.293 5.293a1 1 0 0 1 1.414 0l4.593 4.592a5.82 5.82 0 0 1 0 8.23l-1.592 1.592a1 1 0 0 1 -1.414 -1.414l1.592 -1.592a3.82 3.82 0 0 0 0 -5.402l-4.592 -4.592a1 1 0 0 1 0 -1.414", "key": "svg-1" }]]);

var IconTagsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTagsFilled
});

var IconTemperatureMinusFilled = createReactComponent("filled", "temperature-minus-filled", "IconTemperatureMinusFilled", [["path", { "d": "M10 2a3 3 0 0 1 3 3v7.965l.075 .056a5 5 0 0 1 1.81 5.01l-.055 .227a5 5 0 1 1 -7.905 -5.237l.075 -.056v-7.965a3 3 0 0 1 2.824 -2.995zm12 6a1 1 0 0 1 0 2h-6a1 1 0 0 1 0 -2zm-12 -4a1 1 0 0 0 -1 1v4h2v-4a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconTemperatureMinusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTemperatureMinusFilled
});

var IconTemperaturePlusFilled = createReactComponent("filled", "temperature-plus-filled", "IconTemperaturePlusFilled", [["path", { "d": "M10 2a3 3 0 0 1 3 3v7.965l.075 .056a5 5 0 0 1 1.81 5.01l-.055 .227a5 5 0 1 1 -7.905 -5.237l.075 -.056v-7.965a3 3 0 0 1 2.824 -2.995zm9 3a1 1 0 0 1 1 1v2h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1 -2 0v-2h-2a1 1 0 0 1 0 -2h2v-2a1 1 0 0 1 1 -1m-9 -1a1 1 0 0 0 -1 1v4h2v-4a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconTemperaturePlusFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTemperaturePlusFilled
});

var IconTestPipe2Filled = createReactComponent("filled", "test-pipe-2-filled", "IconTestPipe2Filled", [["path", { "d": "M16 2a1 1 0 0 1 0 2v14a4 4 0 1 1 -8 0v-14a1 1 0 1 1 0 -2zm-2 2h-4v7h4z", "key": "svg-0" }]]);

var IconTestPipe2Filled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTestPipe2Filled
});

var IconThumbDownFilled = createReactComponent("filled", "thumb-down-filled", "IconThumbDownFilled", [["path", { "d": "M13 21.008a3 3 0 0 0 2.995 -2.823l.005 -.177v-4h2a3 3 0 0 0 2.98 -2.65l.015 -.173l.005 -.177l-.02 -.196l-1.006 -5.032c-.381 -1.625 -1.502 -2.796 -2.81 -2.78l-.164 .008h-8a1 1 0 0 0 -.993 .884l-.007 .116l.001 9.536a1 1 0 0 0 .5 .866a2.998 2.998 0 0 1 1.492 2.396l.007 .202v1a3 3 0 0 0 3 3z", "key": "svg-0" }], ["path", { "d": "M5 14.008a1 1 0 0 0 .993 -.883l.007 -.117v-9a1 1 0 0 0 -.883 -.993l-.117 -.007h-1a2 2 0 0 0 -1.995 1.852l-.005 .15v7a2 2 0 0 0 1.85 1.994l.15 .005h1z", "key": "svg-1" }]]);

var IconThumbDownFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconThumbDownFilled
});

var IconThumbUpFilled = createReactComponent("filled", "thumb-up-filled", "IconThumbUpFilled", [["path", { "d": "M13 3a3 3 0 0 1 2.995 2.824l.005 .176v4h2a3 3 0 0 1 2.98 2.65l.015 .174l.005 .176l-.02 .196l-1.006 5.032c-.381 1.626 -1.502 2.796 -2.81 2.78l-.164 -.008h-8a1 1 0 0 1 -.993 -.883l-.007 -.117l.001 -9.536a1 1 0 0 1 .5 -.865a2.998 2.998 0 0 0 1.492 -2.397l.007 -.202v-1a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M5 10a1 1 0 0 1 .993 .883l.007 .117v9a1 1 0 0 1 -.883 .993l-.117 .007h-1a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-7a2 2 0 0 1 1.85 -1.995l.15 -.005h1z", "key": "svg-1" }]]);

var IconThumbUpFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconThumbUpFilled
});

var IconTiltShiftFilled = createReactComponent("filled", "tilt-shift-filled", "IconTiltShiftFilled", [["path", { "d": "M8.178 2.766a1 1 0 1 1 .764 1.848a8 8 0 0 0 -2.595 1.733a1 1 0 1 1 -1.414 -1.414a10 10 0 0 1 3.245 -2.167", "key": "svg-0" }], ["path", { "d": "M2.767 8.176a1 1 0 1 1 1.846 .768a8 8 0 0 0 -.613 3.058a1 1 0 0 1 -2 -.004a10 10 0 0 1 .767 -3.822", "key": "svg-1" }], ["path", { "d": "M3.308 14.516a1 1 0 0 1 1.306 .542a8 8 0 0 0 1.733 2.595a1 1 0 1 1 -1.414 1.414a10 10 0 0 1 -2.167 -3.245a1 1 0 0 1 .542 -1.306", "key": "svg-2" }], ["path", { "d": "M7.637 19.926a1 1 0 0 1 1.307 -.54a8 8 0 0 0 3.058 .614a1 1 0 0 1 -.004 2a10 10 0 0 1 -3.822 -.767a1 1 0 0 1 -.54 -1.307", "key": "svg-3" }], ["path", { "d": "M17.653 17.653a1 1 0 1 1 1.414 1.414a10 10 0 0 1 -3.245 2.167a1 1 0 1 1 -.764 -1.848a8 8 0 0 0 2.595 -1.733", "key": "svg-4" }], ["path", { "d": "M21.002 11a1 1 0 0 1 .998 1.002a10 10 0 0 1 -.767 3.822a1 1 0 1 1 -1.846 -.768a8 8 0 0 0 .613 -3.058a1 1 0 0 1 1.002 -.998", "key": "svg-5" }], ["path", { "d": "M17.653 4.933a1 1 0 0 1 1.414 0a10 10 0 0 1 2.167 3.245a1 1 0 1 1 -1.848 .764a8 8 0 0 0 -1.733 -2.595a1 1 0 0 1 0 -1.414", "key": "svg-6" }], ["path", { "d": "M12.002 2a10 10 0 0 1 3.822 .767a1 1 0 1 1 -.768 1.846a8 8 0 0 0 -3.058 -.613a1 1 0 0 1 .004 -2", "key": "svg-7" }], ["path", { "d": "M12 9a3 3 0 1 1 -3 3l.005 -.176a3 3 0 0 1 2.995 -2.824", "key": "svg-8" }]]);

var IconTiltShiftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTiltShiftFilled
});

var IconTimelineEventFilled = createReactComponent("filled", "timeline-event-filled", "IconTimelineEventFilled", [["path", { "d": "M12 17c1.306 0 2.418 .835 2.83 2h5.17a1 1 0 0 1 0 2h-5.171a3.001 3.001 0 0 1 -5.658 0h-5.171a1 1 0 0 1 0 -2h5.17a3.001 3.001 0 0 1 2.83 -2z", "key": "svg-0" }], ["path", { "d": "M17 2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2.586l-1.707 1.707a1 1 0 0 1 -1.32 .083l-.094 -.083l-1.708 -1.707h-2.585a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-8a2 2 0 0 1 2 -2h10z", "key": "svg-1" }]]);

var IconTimelineEventFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTimelineEventFilled
});

var IconToggleLeftFilled = createReactComponent("filled", "toggle-left-filled", "IconToggleLeftFilled", [["path", { "d": "M8 9a3 3 0 1 1 -3 3l.005 -.176a3 3 0 0 1 2.995 -2.824", "key": "svg-0" }], ["path", { "d": "M16 5a7 7 0 0 1 0 14h-8a7 7 0 0 1 0 -14zm0 2h-8a5 5 0 1 0 0 10h8a5 5 0 0 0 0 -10", "key": "svg-1" }]]);

var IconToggleLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToggleLeftFilled
});

var IconToggleRightFilled = createReactComponent("filled", "toggle-right-filled", "IconToggleRightFilled", [["path", { "d": "M16 9a3 3 0 1 1 -3 3l.005 -.176a3 3 0 0 1 2.995 -2.824", "key": "svg-0" }], ["path", { "d": "M16 5a7 7 0 0 1 0 14h-8a7 7 0 0 1 0 -14zm0 2h-8a5 5 0 1 0 0 10h8a5 5 0 0 0 0 -10", "key": "svg-1" }]]);

var IconToggleRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconToggleRightFilled
});

var IconTrainFilled = createReactComponent("filled", "train-filled", "IconTrainFilled", [["path", { "d": "M11 5c6.634 0 10.853 3.11 10.996 7.754l.004 .246a3 3 0 0 1 -3 3h-16a1 1 0 0 1 -1 -1v-9a1 1 0 0 1 1 -1zm-4 2h-3v3h3zm4 0h-2v3h3v-2.974a19 19 0 0 0 -1 -.026m3.001 .257l-.001 2.743h5.04c-.979 -1.337 -2.689 -2.306 -5.039 -2.743m6.999 10.743a1 1 0 0 1 0 2h-18a1 1 0 0 1 0 -2z", "key": "svg-0" }]]);

var IconTrainFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrainFilled
});

var IconTransformFilled = createReactComponent("filled", "transform-filled", "IconTransformFilled", [["path", { "d": "M18 14a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z", "key": "svg-0" }], ["path", { "d": "M16.707 2.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.293 1.293h3.586a3 3 0 0 1 2.995 2.824l.005 .176v3a1 1 0 0 1 -1.993 .117l-.007 -.117v-3a1 1 0 0 0 -.883 -.993l-.117 -.007h-3.585l1.292 1.293a1 1 0 0 1 -1.32 1.497l-.094 -.083l-3 -3a.98 .98 0 0 1 -.28 -.872l.036 -.146l.04 -.104c.058 -.126 .14 -.24 .245 -.334l2.959 -2.958a1 1 0 0 1 1.414 0z", "key": "svg-1" }], ["path", { "d": "M3 12a1 1 0 0 1 .993 .883l.007 .117v3a1 1 0 0 0 .883 .993l.117 .007h3.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083l.094 .083l3 3a.98 .98 0 0 1 .28 .872l-.036 .146l-.04 .104a1.02 1.02 0 0 1 -.245 .334l-2.959 2.958a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.291 -1.293h-3.584a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-3a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M6 2a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z", "key": "svg-3" }]]);

var IconTransformFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransformFilled
});

var IconTransitionBottomFilled = createReactComponent("filled", "transition-bottom-filled", "IconTransitionBottomFilled", [["path", { "d": "M21 17a1 1 0 0 1 1 1a4 4 0 0 1 -4 4h-12a4 4 0 0 1 -4 -4a1 1 0 0 1 2 0a2 2 0 0 0 2 2h12a2 2 0 0 0 1.995 -1.85l.005 -.15a1 1 0 0 1 1 -1m-9 1l-.082 -.004l-.119 -.016l-.111 -.03l-.111 -.044l-.098 -.052l-.096 -.067l-.09 -.08l-3 -3a1 1 0 0 1 1.414 -1.414l1.293 1.293v-4.586h-5a4 4 0 1 1 0 -8h12a4 4 0 1 1 0 8h-5v4.583l1.293 -1.29a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-3 3l-.112 .097l-.11 .071l-.062 .031l-.081 .034l-.076 .024l-.149 .03z", "key": "svg-0" }]]);

var IconTransitionBottomFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransitionBottomFilled
});

var IconTransitionLeftFilled = createReactComponent("filled", "transition-left-filled", "IconTransitionLeftFilled", [["path", { "d": "M6 2a1 1 0 1 1 0 2a2 2 0 0 0 -2 2v12a2 2 0 0 0 1.85 1.995l.15 .005a1 1 0 0 1 0 2a4 4 0 0 1 -4 -4v-12a4 4 0 0 1 4 -4m12 0a4 4 0 0 1 4 4v12a4 4 0 1 1 -8 0v-5h-4.585l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.414 0l-3 -3l-.097 -.112l-.071 -.11l-.031 -.062l-.034 -.081l-.024 -.076l-.025 -.118l-.007 -.058l-.004 -.108l.003 -.064l.017 -.119l.03 -.111l.044 -.111l.052 -.098l.067 -.096l.08 -.09l3 -3a1 1 0 0 1 1.414 1.414l-1.292 1.293h4.585v-5a4 4 0 0 1 4 -4", "key": "svg-0" }]]);

var IconTransitionLeftFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransitionLeftFilled
});

var IconTransitionRightFilled = createReactComponent("filled", "transition-right-filled", "IconTransitionRightFilled", [["path", { "d": "M18 2a4 4 0 0 1 4 4v12a4 4 0 0 1 -4 4a1 1 0 0 1 -.117 -1.993l.117 -.007a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2a1 1 0 0 1 0 -2m-8 16a4 4 0 1 1 -8 0v-12a4 4 0 1 1 8 0v5h4.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.414 0l3 3l.097 .112l.071 .11l.031 .062l.034 .081l.024 .076l.03 .148l.006 .118l-.004 .085l-.016 .116l-.03 .111l-.044 .111l-.052 .098l-.074 .104l-.073 .082l-3 3a1 1 0 0 1 -1.414 -1.414l1.292 -1.293h-4.585z", "key": "svg-0" }]]);

var IconTransitionRightFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransitionRightFilled
});

var IconTransitionTopFilled = createReactComponent("filled", "transition-top-filled", "IconTransitionTopFilled", [["path", { "d": "M12 6l.081 .003l.12 .017l.111 .03l.111 .044l.098 .052l.104 .074l.082 .073l3 3a1 1 0 1 1 -1.414 1.414l-1.293 -1.292v4.585h5a4 4 0 1 1 0 8h-12a4 4 0 1 1 0 -8h5v-4.585l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 0 -1.414l3 -3l.112 -.097l.11 -.071l.062 -.031l.081 -.034l.076 -.024l.118 -.025l.058 -.007zm6 -4a4 4 0 0 1 4 4a1 1 0 0 1 -1.993 .117l-.007 -.117a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2a1 1 0 1 1 -2 0a4 4 0 0 1 4 -4z", "key": "svg-0" }]]);

var IconTransitionTopFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTransitionTopFilled
});

var IconTrashXFilled = createReactComponent("filled", "trash-x-filled", "IconTrashXFilled", [["path", { "d": "M20 6a1 1 0 0 1 .117 1.993l-.117 .007h-.081l-.919 11a3 3 0 0 1 -2.824 2.995l-.176 .005h-8c-1.598 0 -2.904 -1.249 -2.992 -2.75l-.005 -.167l-.923 -11.083h-.08a1 1 0 0 1 -.117 -1.993l.117 -.007h16zm-9.489 5.14a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z", "key": "svg-0" }], ["path", { "d": "M14 2a2 2 0 0 1 2 2a1 1 0 0 1 -1.993 .117l-.007 -.117h-4l-.007 .117a1 1 0 0 1 -1.993 -.117a2 2 0 0 1 1.85 -1.995l.15 -.005h4z", "key": "svg-1" }]]);

var IconTrashXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrashXFilled
});

var IconTrashFilled = createReactComponent("filled", "trash-filled", "IconTrashFilled", [["path", { "d": "M20 6a1 1 0 0 1 .117 1.993l-.117 .007h-.081l-.919 11a3 3 0 0 1 -2.824 2.995l-.176 .005h-8c-1.598 0 -2.904 -1.249 -2.992 -2.75l-.005 -.167l-.923 -11.083h-.08a1 1 0 0 1 -.117 -1.993l.117 -.007h16z", "key": "svg-0" }], ["path", { "d": "M14 2a2 2 0 0 1 2 2a1 1 0 0 1 -1.993 .117l-.007 -.117h-4l-.007 .117a1 1 0 0 1 -1.993 -.117a2 2 0 0 1 1.85 -1.995l.15 -.005h4z", "key": "svg-1" }]]);

var IconTrashFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrashFilled
});

var IconTriangleInvertedFilled = createReactComponent("filled", "triangle-inverted-filled", "IconTriangleInvertedFilled", [["path", { "d": "M20.118 3h-16.225a2.914 2.914 0 0 0 -2.503 4.371l8.116 13.549a2.917 2.917 0 0 0 4.987 .005l8.11 -13.539a2.914 2.914 0 0 0 -2.486 -4.386z", "key": "svg-0" }]]);

var IconTriangleInvertedFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTriangleInvertedFilled
});

var IconTriangleSquareCircleFilled = createReactComponent("filled", "triangle-square-circle-filled", "IconTriangleSquareCircleFilled", [["path", { "d": "M11.132 2.504l-4 7a1 1 0 0 0 .868 1.496h8a1 1 0 0 0 .868 -1.496l-4 -7a1 1 0 0 0 -1.736 0z", "key": "svg-0" }], ["path", { "d": "M17 13a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z", "key": "svg-1" }], ["path", { "d": "M9 13h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z", "key": "svg-2" }]]);

var IconTriangleSquareCircleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTriangleSquareCircleFilled
});

var IconTriangleFilled = createReactComponent("filled", "triangle-filled", "IconTriangleFilled", [["path", { "d": "M12 1.67a2.914 2.914 0 0 0 -2.492 1.403l-8.11 13.537a2.914 2.914 0 0 0 2.484 4.385h16.225a2.914 2.914 0 0 0 2.503 -4.371l-8.116 -13.546a2.917 2.917 0 0 0 -2.494 -1.408z", "key": "svg-0" }]]);

var IconTriangleFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTriangleFilled
});

var IconTrolleyFilled = createReactComponent("filled", "trolley-filled", "IconTrolleyFilled", [["path", { "d": "M20.555 4.168a1 1 0 0 1 .277 1.387l-2.621 3.932l1.236 .619a1 1 0 0 1 -.894 1.788l-1.46 -.73l-3.876 5.815a3 3 0 1 1 -5.217 2.021l.005 -.176q .008 -.135 .027 -.267l-2.587 -1.725a1 1 0 0 1 1.11 -1.664l2.424 1.615a2.99 2.99 0 0 1 2.464 -.75l7.725 -11.588a1 1 0 0 1 1.387 -.277m-10.567 -.399l.14 .082l3.307 2.104a2.3 2.3 0 0 1 .7 3.185l-3.094 4.81a2.3 2.3 0 0 1 -3.17 .698l-3.306 -2.104a2.3 2.3 0 0 1 -.7 -3.185l3.094 -4.81a2.3 2.3 0 0 1 3.029 -.78", "key": "svg-0" }]]);

var IconTrolleyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrolleyFilled
});

var IconTrophyFilled = createReactComponent("filled", "trophy-filled", "IconTrophyFilled", [["path", { "d": "M17 3a1 1 0 0 1 .993 .883l.007 .117v2.17a3 3 0 1 1 0 5.659v.171a6.002 6.002 0 0 1 -5 5.917v2.083h3a1 1 0 0 1 .117 1.993l-.117 .007h-8a1 1 0 0 1 -.117 -1.993l.117 -.007h3v-2.083a6.002 6.002 0 0 1 -4.996 -5.692l-.004 -.225v-.171a3 3 0 0 1 -3.996 -2.653l-.003 -.176l.005 -.176a3 3 0 0 1 3.995 -2.654l-.001 -2.17a1 1 0 0 1 1 -1h10zm-12 5a1 1 0 1 0 0 2a1 1 0 0 0 0 -2zm14 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2z", "key": "svg-0" }]]);

var IconTrophyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTrophyFilled
});

var IconTruckFilled = createReactComponent("filled", "truck-filled", "IconTruckFilled", [["path", { "d": "M13 4a1 1 0 0 1 1 1h4a1 1 0 0 1 .783 .378l.074 .108l3 5l.055 .103l.04 .107l.029 .109l.016 .11l.003 .085v6a1 1 0 0 1 -1 1h-1.171a3.001 3.001 0 0 1 -5.658 0h-4.342a3.001 3.001 0 0 1 -5.658 0h-1.171a1 1 0 0 1 -1 -1v-11a2 2 0 0 1 2 -2zm-6 12a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m10 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2m.434 -9h-3.434v3h5.234z", "key": "svg-0" }]]);

var IconTruckFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconTruckFilled
});

var IconUmbrellaFilled = createReactComponent("filled", "umbrella-filled", "IconUmbrellaFilled", [["path", { "d": "M12 3a9 9 0 0 1 9 9a1 1 0 0 1 -.883 .993l-.117 .007h-7v5a1 1 0 0 0 1.993 .117l.007 -.117a1 1 0 0 1 2 0a3 3 0 0 1 -5.995 .176l-.005 -.176v-5h-7a1 1 0 0 1 -.993 -.883l-.007 -.117a9 9 0 0 1 9 -9z", "key": "svg-0" }]]);

var IconUmbrellaFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUmbrellaFilled
});

var IconUserFilled = createReactComponent("filled", "user-filled", "IconUserFilled", [["path", { "d": "M12 2a5 5 0 1 1 -5 5l.005 -.217a5 5 0 0 1 4.995 -4.783z", "key": "svg-0" }], ["path", { "d": "M14 14a5 5 0 0 1 5 5v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1a5 5 0 0 1 5 -5h4z", "key": "svg-1" }]]);

var IconUserFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconUserFilled
});

var IconVersionsFilled = createReactComponent("filled", "versions-filled", "IconVersionsFilled", [["path", { "d": "M18 4h-6a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z", "key": "svg-0" }], ["path", { "d": "M7 6a1 1 0 0 1 .993 .883l.007 .117v10a1 1 0 0 1 -1.993 .117l-.007 -.117v-10a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M4 7a1 1 0 0 1 .993 .883l.007 .117v8a1 1 0 0 1 -1.993 .117l-.007 -.117v-8a1 1 0 0 1 1 -1z", "key": "svg-2" }]]);

var IconVersionsFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVersionsFilled
});

var IconVideoFilled = createReactComponent("filled", "video-filled", "IconVideoFilled", [["path", { "d": "M20.117 7.625a1 1 0 0 0 -.564 .1l-4.553 2.275v4l4.553 2.275a1 1 0 0 0 1.447 -.892v-6.766a1 1 0 0 0 -.883 -.992z", "key": "svg-0" }], ["path", { "d": "M5 5c-1.645 0 -3 1.355 -3 3v8c0 1.645 1.355 3 3 3h8c1.645 0 3 -1.355 3 -3v-8c0 -1.645 -1.355 -3 -3 -3z", "key": "svg-1" }]]);

var IconVideoFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconVideoFilled
});

var IconWindmillFilled = createReactComponent("filled", "windmill-filled", "IconWindmillFilled", [["path", { "d": "M12 2c3.292 0 6 2.435 6 5.5c0 1.337 -.515 2.554 -1.369 3.5h4.369a1 1 0 0 1 1 1c0 3.292 -2.435 6 -5.5 6c-1.336 0 -2.553 -.515 -3.5 -1.368v4.368a1 1 0 0 1 -1 1c-3.292 0 -6 -2.435 -6 -5.5c0 -1.336 .515 -2.553 1.368 -3.5h-4.368a1 1 0 0 1 -1 -1c0 -3.292 2.435 -6 5.5 -6c1.337 0 2.554 .515 3.5 1.369v-4.369a1 1 0 0 1 1 -1z", "key": "svg-0" }]]);

var IconWindmillFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWindmillFilled
});

var IconWindsockFilled = createReactComponent("filled", "windsock-filled", "IconWindsockFilled", [["path", { "d": "M6 2a1 1 0 0 1 1 1v1.079l11.083 .924a1 1 0 0 1 .917 .997v4a1 1 0 0 1 -.917 .997l-11.083 .923v8.08h1a1 1 0 0 1 0 2h-4a1 1 0 0 1 0 -2h1v-17a1 1 0 0 1 1 -1m1 4.086v3.827l3 -.25v-3.327zm7 .584v2.659l3 -.25v-2.159z", "key": "svg-0" }]]);

var IconWindsockFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWindsockFilled
});

var IconWomanFilled = createReactComponent("filled", "woman-filled", "IconWomanFilled", [["path", { "d": "M14 8c1.91 0 3.79 .752 5.625 2.219a1 1 0 1 1 -1.25 1.562c-1.019 -.815 -2.016 -1.345 -2.997 -1.6l1.584 5.544a1 1 0 0 1 -.962 1.275h-1v4a1 1 0 0 1 -2 0v-4h-2v4a1 1 0 0 1 -2 0v-4h-1a1 1 0 0 1 -.962 -1.275l1.584 -5.545c-.98 .256 -1.978 .786 -2.997 1.601a1 1 0 1 1 -1.25 -1.562c1.733 -1.386 3.506 -2.133 5.307 -2.212l.335 -.007z", "key": "svg-0" }], ["path", { "d": "M12 1a3 3 0 1 1 -3 3l.005 -.176a3 3 0 0 1 2.995 -2.824", "key": "svg-1" }]]);

var IconWomanFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconWomanFilled
});

var IconXboxAFilled = createReactComponent("filled", "xbox-a-filled", "IconXboxAFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m.936 5.649c-.324 -.865 -1.548 -.865 -1.872 0l-3 8a1 1 0 0 0 .585 1.287l.111 .035a1 1 0 0 0 1.176 -.62l.507 -1.351h3.114l.507 1.351a1 1 0 1 0 1.872 -.702zm-.936 3.199l.807 2.152h-1.614z", "key": "svg-0" }]]);

var IconXboxAFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconXboxAFilled
});

var IconXboxBFilled = createReactComponent("filled", "xbox-b-filled", "IconXboxBFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m1 5h-3a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h3a3 3 0 0 0 2.235 -5a3 3 0 0 0 -2.235 -5m0 6a1 1 0 0 1 1 1l-.007 .117a1 1 0 0 1 -.993 .883h-2v-2zm0 -4a1 1 0 0 1 0 2h-2v-2z", "key": "svg-0" }]]);

var IconXboxBFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconXboxBFilled
});

var IconXboxXFilled = createReactComponent("filled", "xbox-x-filled", "IconXboxXFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m3.6 5.2a1 1 0 0 0 -1.4 .2l-2.2 2.933l-2.2 -2.933a1 1 0 1 0 -1.6 1.2l2.55 3.4l-2.55 3.4a1 1 0 1 0 1.6 1.2l2.2 -2.933l2.2 2.933a1 1 0 0 0 1.6 -1.2l-2.55 -3.4l2.55 -3.4a1 1 0 0 0 -.2 -1.4", "key": "svg-0" }]]);

var IconXboxXFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconXboxXFilled
});

var IconXboxYFilled = createReactComponent("filled", "xbox-y-filled", "IconXboxYFilled", [["path", { "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10m3.6 5.2a1 1 0 0 0 -1.4 .2l-2.2 2.933l-2.2 -2.933a1 1 0 1 0 -1.6 1.2l2.81 3.748l-.01 3.649a1 1 0 0 0 .997 1.003l.117 -.006a1 1 0 0 0 .886 -.991l.01 -3.683l2.79 -3.72a1 1 0 0 0 -.2 -1.4", "key": "svg-0" }]]);

var IconXboxYFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconXboxYFilled
});

var IconYinYangFilled = createReactComponent("filled", "yin-yang-filled", "IconYinYangFilled", [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-9 1.732a8 8 0 0 0 4 14.928l.2 -.005a4 4 0 0 0 0 -7.99l-.2 -.005a4 4 0 0 1 -.2 -7.995l.2 -.005a7.995 7.995 0 0 0 -4 1.072zm4 1.428a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z", "key": "svg-0" }], ["path", { "d": "M12 14.5a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0 -3z", "key": "svg-1" }]]);

var IconYinYangFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconYinYangFilled
});

var IconZeppelinFilled = createReactComponent("filled", "zeppelin-filled", "IconZeppelinFilled", [["path", { "d": "M13.5 3c5.187 0 9.5 3.044 9.5 7c0 3.017 -2.508 5.503 -6 6.514v3.486a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-4.046a21 21 0 0 1 -2.66 -1.411l-.13 -.082l-1.57 1.308a1 1 0 0 1 -1.634 -.656l-.006 -.113v-2.851l-.31 -.25a47 47 0 0 1 -.682 -.568l-.67 -.582a1 1 0 0 1 0 -1.498a47 47 0 0 1 1.351 -1.151l.311 -.25v-2.85a1 1 0 0 1 1.55 -.836l.09 .068l1.57 1.307l.128 -.08c2.504 -1.553 4.784 -2.378 6.853 -2.453zm-2.499 13.657l-.001 2.343h4l.001 -2.086q -.735 .086 -1.501 .086a9.6 9.6 0 0 1 -2.13 -.252z", "key": "svg-0" }]]);

var IconZeppelinFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZeppelinFilled
});

var IconZoomCancelFilled = createReactComponent("filled", "zoom-cancel-filled", "IconZoomCancelFilled", [["path", { "d": "M14 3.072a8 8 0 0 1 2.32 11.834l5.387 5.387a1 1 0 0 1 -1.414 1.414l-5.388 -5.387a8 8 0 0 1 -12.905 -6.32l.005 -.285a8 8 0 0 1 11.995 -6.643m-5.293 4.22a1 1 0 0 0 -1.414 1.415l1.292 1.293l-1.292 1.293a1 1 0 0 0 1.414 1.414l1.293 -1.292l1.293 1.292a1 1 0 0 0 1.414 -1.414l-1.292 -1.293l1.292 -1.293a1 1 0 1 0 -1.414 -1.414l-1.293 1.292z", "key": "svg-0" }]]);

var IconZoomCancelFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomCancelFilled
});

var IconZoomCheckFilled = createReactComponent("filled", "zoom-check-filled", "IconZoomCheckFilled", [["path", { "d": "M14 3.072a8 8 0 0 1 2.617 11.424l4.944 4.943a1.5 1.5 0 0 1 -2.008 2.225l-.114 -.103l-4.943 -4.944a8 8 0 0 1 -12.49 -6.332l-.006 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-.293 4.22a1 1 0 0 0 -1.414 0l-3.293 3.294l-1.293 -1.293l-.094 -.083a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z", "key": "svg-0" }]]);

var IconZoomCheckFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomCheckFilled
});

var IconZoomCodeFilled = createReactComponent("filled", "zoom-code-filled", "IconZoomCodeFilled", [["path", { "d": "M14 3.072a8 8 0 0 1 2.32 11.834l5.387 5.387a1 1 0 0 1 -1.414 1.414l-5.388 -5.387a8 8 0 0 1 -12.905 -6.32l.005 -.285a8 8 0 0 1 11.995 -6.643m-5.293 4.22a1 1 0 0 0 -1.414 0l-2 2a1 1 0 0 0 0 1.415l2 2a1 1 0 0 0 1.414 0l.083 -.094a1 1 0 0 0 -.083 -1.32l-1.292 -1.293l1.292 -1.293a1 1 0 0 0 0 -1.414m4 0a1 1 0 0 0 -1.414 0l-.083 .095a1 1 0 0 0 .083 1.32l1.292 1.292l-1.292 1.293a1 1 0 0 0 1.414 1.414l2 -2a1 1 0 0 0 0 -1.414z", "key": "svg-0" }]]);

var IconZoomCodeFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomCodeFilled
});

var IconZoomExclamationFilled = createReactComponent("filled", "zoom-exclamation-filled", "IconZoomExclamationFilled", [["path", { "d": "M14 3.072a8 8 0 0 1 2.32 11.834l5.387 5.387a1 1 0 0 1 -1.414 1.414l-5.388 -5.387a8 8 0 0 1 -12.905 -6.32l.005 -.285a8 8 0 0 1 11.995 -6.643m-4 8.928a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883m0 -6a1 1 0 0 0 -1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0 -1 -1", "key": "svg-0" }]]);

var IconZoomExclamationFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomExclamationFilled
});

var IconZoomInAreaFilled = createReactComponent("filled", "zoom-in-area-filled", "IconZoomInAreaFilled", [["path", { "d": "M15 9a6 6 0 0 1 4.891 9.476l2.816 2.817a1 1 0 0 1 -1.32 1.497l-.094 -.083l-2.817 -2.816a6 6 0 0 1 -9.472 -4.666l-.004 -.225l.004 -.225a6 6 0 0 1 5.996 -5.775zm0 3a1 1 0 0 0 -.993 .883l-.007 .117v1h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h1v1l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }], ["path", { "d": "M3 14a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 0 .883 .993l.117 .007h1a1 1 0 0 1 .117 1.993l-.117 .007h-1a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-1a1 1 0 0 1 1 -1z", "key": "svg-1" }], ["path", { "d": "M3 9a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z", "key": "svg-2" }], ["path", { "d": "M6 2a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 0 -.993 .883l-.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a3 3 0 0 1 2.824 -2.995l.176 -.005h1z", "key": "svg-3" }], ["path", { "d": "M11 2a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-4" }], ["path", { "d": "M16 2a3 3 0 0 1 2.995 2.824l.005 .176v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 0 -.883 -.993l-.117 -.007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z", "key": "svg-5" }]]);

var IconZoomInAreaFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomInAreaFilled
});

var IconZoomInFilled = createReactComponent("filled", "zoom-in-filled", "IconZoomInFilled", [["path", { "d": "M14 3.072a8 8 0 0 1 2.617 11.424l4.944 4.943a1.5 1.5 0 0 1 -2.008 2.225l-.114 -.103l-4.943 -4.944a8 8 0 0 1 -12.49 -6.332l-.006 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-4 2.928a1 1 0 0 0 -.993 .883l-.007 .117v2h-2l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h2v2l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-2h2l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-2v-2l-.007 -.117a1 1 0 0 0 -.993 -.883z", "key": "svg-0" }]]);

var IconZoomInFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomInFilled
});

var IconZoomMoneyFilled = createReactComponent("filled", "zoom-money-filled", "IconZoomMoneyFilled", [["path", { "d": "M14 3.072a8 8 0 0 1 2.32 11.834l5.387 5.387a1 1 0 0 1 -1.414 1.414l-5.388 -5.387a8 8 0 0 1 -12.905 -6.32l.005 -.285a8 8 0 0 1 11.995 -6.643m-2 2.928h-2.5a2.5 2.5 0 0 0 0 5h1a.5 .5 0 1 1 0 1h-2.5a1 1 0 0 0 0 2h2.5a2.5 2.5 0 1 0 0 -5h-1a.5 .5 0 0 1 0 -1h2.5a1 1 0 0 0 0 -2", "key": "svg-0" }]]);

var IconZoomMoneyFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomMoneyFilled
});

var IconZoomOutAreaFilled = createReactComponent("filled", "zoom-out-area-filled", "IconZoomOutAreaFilled", [["path", { "d": "M15 9a6 6 0 0 1 4.891 9.476l2.816 2.817a1 1 0 0 1 -1.414 1.414l-2.817 -2.816a6 6 0 0 1 -9.476 -4.891l.004 -.225a6 6 0 0 1 5.996 -5.775m2 5h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0 -2m-14 0a1 1 0 0 1 1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 1 0 2h-1a3 3 0 0 1 -3 -3v-1a1 1 0 0 1 1 -1m0 -5a1 1 0 0 1 1 1v1a1 1 0 0 1 -2 0v-1a1 1 0 0 1 1 -1m3 -7a1 1 0 1 1 0 2h-1a1 1 0 0 0 -1 1v1a1 1 0 1 1 -2 0v-1a3 3 0 0 1 3 -3zm5 0a1 1 0 0 1 0 2h-1a1 1 0 1 1 0 -2zm5 0a3 3 0 0 1 3 3v1a1 1 0 0 1 -2 0v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 0 -2z", "key": "svg-0" }]]);

var IconZoomOutAreaFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomOutAreaFilled
});

var IconZoomOutFilled = createReactComponent("filled", "zoom-out-filled", "IconZoomOutFilled", [["path", { "d": "M14 3.072a8 8 0 0 1 2.617 11.424l4.944 4.943a1.5 1.5 0 0 1 -2.008 2.225l-.114 -.103l-4.943 -4.944a8 8 0 0 1 -12.49 -6.332l-.006 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-1 5.928h-6l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h6l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", "key": "svg-0" }]]);

var IconZoomOutFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomOutFilled
});

var IconZoomPanFilled = createReactComponent("filled", "zoom-pan-filled", "IconZoomPanFilled", [["path", { "d": "M12 8a4 4 0 0 1 3.447 6.031l2.26 2.262a1 1 0 0 1 -1.414 1.414l-2.262 -2.26a4 4 0 0 1 -6.031 -3.447l.005 -.2a4 4 0 0 1 3.995 -3.8", "key": "svg-0" }], ["path", { "d": "M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 1 1 -1.414 1.414l-1.293 -1.292l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 0 -1.414z", "key": "svg-1" }], ["path", { "d": "M19.293 9.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1 -1.414 -1.414l1.292 -1.293l-1.292 -1.293a1 1 0 0 1 -.083 -1.32z", "key": "svg-2" }], ["path", { "d": "M3.293 9.293a1 1 0 1 1 1.414 1.414l-1.292 1.293l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.414 0l-2 -2a1 1 0 0 1 0 -1.414z", "key": "svg-3" }], ["path", { "d": "M9.293 19.293a1 1 0 0 1 1.414 0l1.293 1.292l1.294 -1.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1 -1.414 0l-2 -2a1 1 0 0 1 0 -1.414", "key": "svg-4" }]]);

var IconZoomPanFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomPanFilled
});

var IconZoomQuestionFilled = createReactComponent("filled", "zoom-question-filled", "IconZoomQuestionFilled", [["path", { "d": "M14 3.072a8 8 0 0 1 2.32 11.834l5.387 5.387a1 1 0 0 1 -1.414 1.414l-5.388 -5.387a8 8 0 0 1 -12.905 -6.32l.005 -.285a8 8 0 0 1 11.995 -6.643m-4 8.928a1 1 0 0 0 -.993 .883l-.007 .127a1 1 0 0 0 1.993 .117l.007 -.127a1 1 0 0 0 -1 -1m-1.9 -5.123a1 1 0 0 0 1.433 1.389l.088 -.09a.5 .5 0 1 1 .379 .824a1 1 0 0 0 -.002 2a2.5 2.5 0 1 0 -1.9 -4.123", "key": "svg-0" }]]);

var IconZoomQuestionFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomQuestionFilled
});

var IconZoomScanFilled = createReactComponent("filled", "zoom-scan-filled", "IconZoomScanFilled", [["path", { "d": "M4 15a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 0 2h-2a3 3 0 0 1 -3 -3v-2a1 1 0 0 1 1 -1", "key": "svg-0" }], ["path", { "d": "M20 15a1 1 0 0 1 1 1v2a3 3 0 0 1 -3 3h-2a1 1 0 0 1 0 -2h2a1 1 0 0 0 1 -1v-2a1 1 0 0 1 1 -1", "key": "svg-1" }], ["path", { "d": "M11 7a4 4 0 0 1 3.446 6.031l2.261 2.262a1 1 0 0 1 -1.414 1.414l-2.262 -2.26l-.031 .017a4 4 0 0 1 -6 -3.464l.005 -.2a4 4 0 0 1 3.995 -3.8", "key": "svg-2" }], ["path", { "d": "M8 3a1 1 0 1 1 0 2h-2a1 1 0 0 0 -1 1v2a1 1 0 1 1 -2 0v-2a3 3 0 0 1 3 -3z", "key": "svg-3" }], ["path", { "d": "M18 3a3 3 0 0 1 3 3v2a1 1 0 0 1 -2 0v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 0 -2z", "key": "svg-4" }]]);

var IconZoomScanFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomScanFilled
});

var IconZoomFilled = createReactComponent("filled", "zoom-filled", "IconZoomFilled", [["path", { "d": "M14 3.072a8 8 0 0 1 2.617 11.424l4.944 4.943a1.5 1.5 0 0 1 -2.008 2.225l-.114 -.103l-4.943 -4.944a8 8 0 0 1 -12.49 -6.332l-.006 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643z", "key": "svg-0" }]]);

var IconZoomFilled$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: IconZoomFilled
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  IconAB: IconAB,
  IconAB2: IconAB2,
  IconABOff: IconABOff,
  IconAbacus: IconAbacus,
  IconAbacusOff: IconAbacusOff,
  IconAbc: IconAbc,
  IconAccessPoint: IconAccessPoint,
  IconAccessPointOff: IconAccessPointOff,
  IconAccessible: IconAccessible,
  IconAccessibleFilled: IconAccessibleFilled,
  IconAccessibleOff: IconAccessibleOff,
  IconActivity: IconActivity,
  IconActivityHeartbeat: IconActivityHeartbeat,
  IconAd: IconAd,
  IconAd2: IconAd2,
  IconAdCircle: IconAdCircle,
  IconAdCircleFilled: IconAdCircleFilled,
  IconAdCircleOff: IconAdCircleOff,
  IconAdFilled: IconAdFilled,
  IconAdOff: IconAdOff,
  IconAddressBook: IconAddressBook,
  IconAddressBookOff: IconAddressBookOff,
  IconAdjustments: IconAdjustments,
  IconAdjustmentsAlt: IconAdjustmentsAlt,
  IconAdjustmentsBolt: IconAdjustmentsBolt,
  IconAdjustmentsCancel: IconAdjustmentsCancel,
  IconAdjustmentsCheck: IconAdjustmentsCheck,
  IconAdjustmentsCode: IconAdjustmentsCode,
  IconAdjustmentsCog: IconAdjustmentsCog,
  IconAdjustmentsDollar: IconAdjustmentsDollar,
  IconAdjustmentsDown: IconAdjustmentsDown,
  IconAdjustmentsExclamation: IconAdjustmentsExclamation,
  IconAdjustmentsFilled: IconAdjustmentsFilled,
  IconAdjustmentsHeart: IconAdjustmentsHeart,
  IconAdjustmentsHorizontal: IconAdjustmentsHorizontal,
  IconAdjustmentsMinus: IconAdjustmentsMinus,
  IconAdjustmentsOff: IconAdjustmentsOff,
  IconAdjustmentsPause: IconAdjustmentsPause,
  IconAdjustmentsPin: IconAdjustmentsPin,
  IconAdjustmentsPlus: IconAdjustmentsPlus,
  IconAdjustmentsQuestion: IconAdjustmentsQuestion,
  IconAdjustmentsSearch: IconAdjustmentsSearch,
  IconAdjustmentsShare: IconAdjustmentsShare,
  IconAdjustmentsSpark: IconAdjustmentsSpark,
  IconAdjustmentsStar: IconAdjustmentsStar,
  IconAdjustmentsUp: IconAdjustmentsUp,
  IconAdjustmentsX: IconAdjustmentsX,
  IconAerialLift: IconAerialLift,
  IconAerialLiftFilled: IconAerialLiftFilled,
  IconAffiliate: IconAffiliate,
  IconAffiliateFilled: IconAffiliateFilled,
  IconAi: IconAi,
  IconAirBalloon: IconAirBalloon,
  IconAirBalloonFilled: IconAirBalloonFilled,
  IconAirConditioning: IconAirConditioning,
  IconAirConditioningDisabled: IconAirConditioningDisabled,
  IconAirTrafficControl: IconAirTrafficControl,
  IconAlarm: IconAlarm,
  IconAlarmAverage: IconAlarmAverage,
  IconAlarmFilled: IconAlarmFilled,
  IconAlarmMinus: IconAlarmMinus,
  IconAlarmMinusFilled: IconAlarmMinusFilled,
  IconAlarmOff: IconAlarmOff,
  IconAlarmPlus: IconAlarmPlus,
  IconAlarmPlusFilled: IconAlarmPlusFilled,
  IconAlarmSmoke: IconAlarmSmoke,
  IconAlarmSnooze: IconAlarmSnooze,
  IconAlarmSnoozeFilled: IconAlarmSnoozeFilled,
  IconAlbum: IconAlbum,
  IconAlbumOff: IconAlbumOff,
  IconAlertCircle: IconAlertCircle,
  IconAlertCircleFilled: IconAlertCircleFilled,
  IconAlertCircleOff: IconAlertCircleOff,
  IconAlertHexagon: IconAlertHexagon,
  IconAlertHexagonFilled: IconAlertHexagonFilled,
  IconAlertHexagonOff: IconAlertHexagonOff,
  IconAlertOctagon: IconAlertOctagon,
  IconAlertOctagonFilled: IconAlertOctagonFilled,
  IconAlertSmall: IconAlertSmall,
  IconAlertSmallOff: IconAlertSmallOff,
  IconAlertSquare: IconAlertSquare,
  IconAlertSquareFilled: IconAlertSquareFilled,
  IconAlertSquareRounded: IconAlertSquareRounded,
  IconAlertSquareRoundedFilled: IconAlertSquareRoundedFilled,
  IconAlertSquareRoundedOff: IconAlertSquareRoundedOff,
  IconAlertTriangle: IconAlertTriangle,
  IconAlertTriangleFilled: IconAlertTriangleFilled,
  IconAlertTriangleOff: IconAlertTriangleOff,
  IconAlien: IconAlien,
  IconAlienFilled: IconAlienFilled,
  IconAlignBoxBottomCenter: IconAlignBoxBottomCenter,
  IconAlignBoxBottomCenterFilled: IconAlignBoxBottomCenterFilled,
  IconAlignBoxBottomLeft: IconAlignBoxBottomLeft,
  IconAlignBoxBottomLeftFilled: IconAlignBoxBottomLeftFilled,
  IconAlignBoxBottomRight: IconAlignBoxBottomRight,
  IconAlignBoxBottomRightFilled: IconAlignBoxBottomRightFilled,
  IconAlignBoxCenterBottom: IconAlignBoxCenterBottom,
  IconAlignBoxCenterMiddle: IconAlignBoxCenterMiddle,
  IconAlignBoxCenterMiddleFilled: IconAlignBoxCenterMiddleFilled,
  IconAlignBoxCenterStretch: IconAlignBoxCenterStretch,
  IconAlignBoxCenterTop: IconAlignBoxCenterTop,
  IconAlignBoxLeftBottom: IconAlignBoxLeftBottom,
  IconAlignBoxLeftBottomFilled: IconAlignBoxLeftBottomFilled,
  IconAlignBoxLeftMiddle: IconAlignBoxLeftMiddle,
  IconAlignBoxLeftMiddleFilled: IconAlignBoxLeftMiddleFilled,
  IconAlignBoxLeftStretch: IconAlignBoxLeftStretch,
  IconAlignBoxLeftTop: IconAlignBoxLeftTop,
  IconAlignBoxLeftTopFilled: IconAlignBoxLeftTopFilled,
  IconAlignBoxRightBottom: IconAlignBoxRightBottom,
  IconAlignBoxRightBottomFilled: IconAlignBoxRightBottomFilled,
  IconAlignBoxRightMiddle: IconAlignBoxRightMiddle,
  IconAlignBoxRightMiddleFilled: IconAlignBoxRightMiddleFilled,
  IconAlignBoxRightStretch: IconAlignBoxRightStretch,
  IconAlignBoxRightTop: IconAlignBoxRightTop,
  IconAlignBoxRightTopFilled: IconAlignBoxRightTopFilled,
  IconAlignBoxTopCenter: IconAlignBoxTopCenter,
  IconAlignBoxTopCenterFilled: IconAlignBoxTopCenterFilled,
  IconAlignBoxTopLeft: IconAlignBoxTopLeft,
  IconAlignBoxTopLeftFilled: IconAlignBoxTopLeftFilled,
  IconAlignBoxTopRight: IconAlignBoxTopRight,
  IconAlignBoxTopRightFilled: IconAlignBoxTopRightFilled,
  IconAlignCenter: IconAlignCenter,
  IconAlignJustified: IconAlignJustified,
  IconAlignLeft: IconAlignLeft,
  IconAlignLeft2: IconAlignLeft2,
  IconAlignRight: IconAlignRight,
  IconAlignRight2: IconAlignRight2,
  IconAlpha: IconAlpha,
  IconAlphabetArabic: IconAlphabetArabic,
  IconAlphabetBangla: IconAlphabetBangla,
  IconAlphabetCyrillic: IconAlphabetCyrillic,
  IconAlphabetGreek: IconAlphabetGreek,
  IconAlphabetHebrew: IconAlphabetHebrew,
  IconAlphabetKorean: IconAlphabetKorean,
  IconAlphabetLatin: IconAlphabetLatin,
  IconAlphabetThai: IconAlphabetThai,
  IconAlt: IconAlt,
  IconAmbulance: IconAmbulance,
  IconAmpersand: IconAmpersand,
  IconAnalyze: IconAnalyze,
  IconAnalyzeFilled: IconAnalyzeFilled,
  IconAnalyzeOff: IconAnalyzeOff,
  IconAnchor: IconAnchor,
  IconAnchorOff: IconAnchorOff,
  IconAngle: IconAngle,
  IconAnkh: IconAnkh,
  IconAntenna: IconAntenna,
  IconAntennaBars1: IconAntennaBars1,
  IconAntennaBars2: IconAntennaBars2,
  IconAntennaBars3: IconAntennaBars3,
  IconAntennaBars4: IconAntennaBars4,
  IconAntennaBars5: IconAntennaBars5,
  IconAntennaBarsOff: IconAntennaBarsOff,
  IconAntennaOff: IconAntennaOff,
  IconAperture: IconAperture,
  IconApertureOff: IconApertureOff,
  IconApi: IconApi,
  IconApiApp: IconApiApp,
  IconApiAppOff: IconApiAppOff,
  IconApiOff: IconApiOff,
  IconAppWindow: IconAppWindow,
  IconAppWindowFilled: IconAppWindowFilled,
  IconApple: IconApple,
  IconAppleFilled: IconAppleFilled,
  IconApps: IconApps,
  IconAppsFilled: IconAppsFilled,
  IconAppsOff: IconAppsOff,
  IconArcheryArrow: IconArcheryArrow,
  IconArchive: IconArchive,
  IconArchiveFilled: IconArchiveFilled,
  IconArchiveOff: IconArchiveOff,
  IconArmchair: IconArmchair,
  IconArmchair2: IconArmchair2,
  IconArmchair2Off: IconArmchair2Off,
  IconArmchairOff: IconArmchairOff,
  IconArrowAutofitContent: IconArrowAutofitContent,
  IconArrowAutofitContentFilled: IconArrowAutofitContentFilled,
  IconArrowAutofitDown: IconArrowAutofitDown,
  IconArrowAutofitDownFilled: IconArrowAutofitDownFilled,
  IconArrowAutofitHeight: IconArrowAutofitHeight,
  IconArrowAutofitHeightFilled: IconArrowAutofitHeightFilled,
  IconArrowAutofitLeft: IconArrowAutofitLeft,
  IconArrowAutofitLeftFilled: IconArrowAutofitLeftFilled,
  IconArrowAutofitRight: IconArrowAutofitRight,
  IconArrowAutofitRightFilled: IconArrowAutofitRightFilled,
  IconArrowAutofitUp: IconArrowAutofitUp,
  IconArrowAutofitUpFilled: IconArrowAutofitUpFilled,
  IconArrowAutofitWidth: IconArrowAutofitWidth,
  IconArrowAutofitWidthFilled: IconArrowAutofitWidthFilled,
  IconArrowBack: IconArrowBack,
  IconArrowBackUp: IconArrowBackUp,
  IconArrowBackUpDouble: IconArrowBackUpDouble,
  IconArrowBadgeDown: IconArrowBadgeDown,
  IconArrowBadgeDownFilled: IconArrowBadgeDownFilled,
  IconArrowBadgeLeft: IconArrowBadgeLeft,
  IconArrowBadgeLeftFilled: IconArrowBadgeLeftFilled,
  IconArrowBadgeRight: IconArrowBadgeRight,
  IconArrowBadgeRightFilled: IconArrowBadgeRightFilled,
  IconArrowBadgeUp: IconArrowBadgeUp,
  IconArrowBadgeUpFilled: IconArrowBadgeUpFilled,
  IconArrowBarBoth: IconArrowBarBoth,
  IconArrowBarDown: IconArrowBarDown,
  IconArrowBarLeft: IconArrowBarLeft,
  IconArrowBarRight: IconArrowBarRight,
  IconArrowBarToDown: IconArrowBarToDown,
  IconArrowBarToLeft: IconArrowBarToLeft,
  IconArrowBarToRight: IconArrowBarToRight,
  IconArrowBarToUp: IconArrowBarToUp,
  IconArrowBarUp: IconArrowBarUp,
  IconArrowBearLeft: IconArrowBearLeft,
  IconArrowBearLeft2: IconArrowBearLeft2,
  IconArrowBearRight: IconArrowBearRight,
  IconArrowBearRight2: IconArrowBearRight2,
  IconArrowBigDown: IconArrowBigDown,
  IconArrowBigDownFilled: IconArrowBigDownFilled,
  IconArrowBigDownLine: IconArrowBigDownLine,
  IconArrowBigDownLineFilled: IconArrowBigDownLineFilled,
  IconArrowBigDownLines: IconArrowBigDownLines,
  IconArrowBigDownLinesFilled: IconArrowBigDownLinesFilled,
  IconArrowBigLeft: IconArrowBigLeft,
  IconArrowBigLeftFilled: IconArrowBigLeftFilled,
  IconArrowBigLeftLine: IconArrowBigLeftLine,
  IconArrowBigLeftLineFilled: IconArrowBigLeftLineFilled,
  IconArrowBigLeftLines: IconArrowBigLeftLines,
  IconArrowBigLeftLinesFilled: IconArrowBigLeftLinesFilled,
  IconArrowBigRight: IconArrowBigRight,
  IconArrowBigRightFilled: IconArrowBigRightFilled,
  IconArrowBigRightLine: IconArrowBigRightLine,
  IconArrowBigRightLineFilled: IconArrowBigRightLineFilled,
  IconArrowBigRightLines: IconArrowBigRightLines,
  IconArrowBigRightLinesFilled: IconArrowBigRightLinesFilled,
  IconArrowBigUp: IconArrowBigUp,
  IconArrowBigUpFilled: IconArrowBigUpFilled,
  IconArrowBigUpLine: IconArrowBigUpLine,
  IconArrowBigUpLineFilled: IconArrowBigUpLineFilled,
  IconArrowBigUpLines: IconArrowBigUpLines,
  IconArrowBigUpLinesFilled: IconArrowBigUpLinesFilled,
  IconArrowBounce: IconArrowBounce,
  IconArrowCapsule: IconArrowCapsule,
  IconArrowCurveLeft: IconArrowCurveLeft,
  IconArrowCurveRight: IconArrowCurveRight,
  IconArrowDown: IconArrowDown,
  IconArrowDownBar: IconArrowDownBar,
  IconArrowDownCircle: IconArrowDownCircle,
  IconArrowDownCircleFilled: IconArrowDownCircleFilled,
  IconArrowDownDashed: IconArrowDownDashed,
  IconArrowDownFromArc: IconArrowDownFromArc,
  IconArrowDownLeft: IconArrowDownLeft,
  IconArrowDownLeftCircle: IconArrowDownLeftCircle,
  IconArrowDownRhombus: IconArrowDownRhombus,
  IconArrowDownRhombusFilled: IconArrowDownRhombusFilled,
  IconArrowDownRight: IconArrowDownRight,
  IconArrowDownRightCircle: IconArrowDownRightCircle,
  IconArrowDownSquare: IconArrowDownSquare,
  IconArrowDownSquareFilled: IconArrowDownSquareFilled,
  IconArrowDownTail: IconArrowDownTail,
  IconArrowDownToArc: IconArrowDownToArc,
  IconArrowElbowLeft: IconArrowElbowLeft,
  IconArrowElbowRight: IconArrowElbowRight,
  IconArrowFork: IconArrowFork,
  IconArrowForward: IconArrowForward,
  IconArrowForwardUp: IconArrowForwardUp,
  IconArrowForwardUpDouble: IconArrowForwardUpDouble,
  IconArrowGuide: IconArrowGuide,
  IconArrowGuideFilled: IconArrowGuideFilled,
  IconArrowIteration: IconArrowIteration,
  IconArrowLeft: IconArrowLeft,
  IconArrowLeftBar: IconArrowLeftBar,
  IconArrowLeftCircle: IconArrowLeftCircle,
  IconArrowLeftCircleFilled: IconArrowLeftCircleFilled,
  IconArrowLeftDashed: IconArrowLeftDashed,
  IconArrowLeftFromArc: IconArrowLeftFromArc,
  IconArrowLeftRhombus: IconArrowLeftRhombus,
  IconArrowLeftRhombusFilled: IconArrowLeftRhombusFilled,
  IconArrowLeftRight: IconArrowLeftRight,
  IconArrowLeftSquare: IconArrowLeftSquare,
  IconArrowLeftSquareFilled: IconArrowLeftSquareFilled,
  IconArrowLeftTail: IconArrowLeftTail,
  IconArrowLeftToArc: IconArrowLeftToArc,
  IconArrowLoopLeft: IconArrowLoopLeft,
  IconArrowLoopLeft2: IconArrowLoopLeft2,
  IconArrowLoopRight: IconArrowLoopRight,
  IconArrowLoopRight2: IconArrowLoopRight2,
  IconArrowMerge: IconArrowMerge,
  IconArrowMergeAltLeft: IconArrowMergeAltLeft,
  IconArrowMergeAltRight: IconArrowMergeAltRight,
  IconArrowMergeBoth: IconArrowMergeBoth,
  IconArrowMergeLeft: IconArrowMergeLeft,
  IconArrowMergeRight: IconArrowMergeRight,
  IconArrowMoveDown: IconArrowMoveDown,
  IconArrowMoveDownFilled: IconArrowMoveDownFilled,
  IconArrowMoveLeft: IconArrowMoveLeft,
  IconArrowMoveLeftFilled: IconArrowMoveLeftFilled,
  IconArrowMoveRight: IconArrowMoveRight,
  IconArrowMoveRightFilled: IconArrowMoveRightFilled,
  IconArrowMoveUp: IconArrowMoveUp,
  IconArrowMoveUpFilled: IconArrowMoveUpFilled,
  IconArrowNarrowDown: IconArrowNarrowDown,
  IconArrowNarrowDownDashed: IconArrowNarrowDownDashed,
  IconArrowNarrowLeft: IconArrowNarrowLeft,
  IconArrowNarrowLeftDashed: IconArrowNarrowLeftDashed,
  IconArrowNarrowRight: IconArrowNarrowRight,
  IconArrowNarrowRightDashed: IconArrowNarrowRightDashed,
  IconArrowNarrowUp: IconArrowNarrowUp,
  IconArrowNarrowUpDashed: IconArrowNarrowUpDashed,
  IconArrowRampLeft: IconArrowRampLeft,
  IconArrowRampLeft2: IconArrowRampLeft2,
  IconArrowRampLeft3: IconArrowRampLeft3,
  IconArrowRampRight: IconArrowRampRight,
  IconArrowRampRight2: IconArrowRampRight2,
  IconArrowRampRight3: IconArrowRampRight3,
  IconArrowRight: IconArrowRight,
  IconArrowRightBar: IconArrowRightBar,
  IconArrowRightCircle: IconArrowRightCircle,
  IconArrowRightCircleFilled: IconArrowRightCircleFilled,
  IconArrowRightDashed: IconArrowRightDashed,
  IconArrowRightFromArc: IconArrowRightFromArc,
  IconArrowRightRhombus: IconArrowRightRhombus,
  IconArrowRightRhombusFilled: IconArrowRightRhombusFilled,
  IconArrowRightSquare: IconArrowRightSquare,
  IconArrowRightSquareFilled: IconArrowRightSquareFilled,
  IconArrowRightTail: IconArrowRightTail,
  IconArrowRightToArc: IconArrowRightToArc,
  IconArrowRotaryFirstLeft: IconArrowRotaryFirstLeft,
  IconArrowRotaryFirstRight: IconArrowRotaryFirstRight,
  IconArrowRotaryLastLeft: IconArrowRotaryLastLeft,
  IconArrowRotaryLastRight: IconArrowRotaryLastRight,
  IconArrowRotaryLeft: IconArrowRotaryLeft,
  IconArrowRotaryRight: IconArrowRotaryRight,
  IconArrowRotaryStraight: IconArrowRotaryStraight,
  IconArrowRoundaboutLeft: IconArrowRoundaboutLeft,
  IconArrowRoundaboutRight: IconArrowRoundaboutRight,
  IconArrowSharpTurnLeft: IconArrowSharpTurnLeft,
  IconArrowSharpTurnRight: IconArrowSharpTurnRight,
  IconArrowUp: IconArrowUp,
  IconArrowUpBar: IconArrowUpBar,
  IconArrowUpCircle: IconArrowUpCircle,
  IconArrowUpCircleFilled: IconArrowUpCircleFilled,
  IconArrowUpDashed: IconArrowUpDashed,
  IconArrowUpFromArc: IconArrowUpFromArc,
  IconArrowUpLeft: IconArrowUpLeft,
  IconArrowUpLeftCircle: IconArrowUpLeftCircle,
  IconArrowUpRhombus: IconArrowUpRhombus,
  IconArrowUpRhombusFilled: IconArrowUpRhombusFilled,
  IconArrowUpRight: IconArrowUpRight,
  IconArrowUpRightCircle: IconArrowUpRightCircle,
  IconArrowUpSquare: IconArrowUpSquare,
  IconArrowUpSquareFilled: IconArrowUpSquareFilled,
  IconArrowUpTail: IconArrowUpTail,
  IconArrowUpToArc: IconArrowUpToArc,
  IconArrowWaveLeftDown: IconArrowWaveLeftDown,
  IconArrowWaveLeftUp: IconArrowWaveLeftUp,
  IconArrowWaveRightDown: IconArrowWaveRightDown,
  IconArrowWaveRightUp: IconArrowWaveRightUp,
  IconArrowZigZag: IconArrowZigZag,
  IconArrowsCross: IconArrowsCross,
  IconArrowsDiagonal: IconArrowsDiagonal,
  IconArrowsDiagonal2: IconArrowsDiagonal2,
  IconArrowsDiagonalMinimize: IconArrowsDiagonalMinimize,
  IconArrowsDiagonalMinimize2: IconArrowsDiagonalMinimize2,
  IconArrowsDiff: IconArrowsDiff,
  IconArrowsDoubleNeSw: IconArrowsDoubleNeSw,
  IconArrowsDoubleNwSe: IconArrowsDoubleNwSe,
  IconArrowsDoubleSeNw: IconArrowsDoubleSeNw,
  IconArrowsDoubleSwNe: IconArrowsDoubleSwNe,
  IconArrowsDown: IconArrowsDown,
  IconArrowsDownUp: IconArrowsDownUp,
  IconArrowsExchange: IconArrowsExchange,
  IconArrowsExchange2: IconArrowsExchange2,
  IconArrowsHorizontal: IconArrowsHorizontal,
  IconArrowsJoin: IconArrowsJoin,
  IconArrowsJoin2: IconArrowsJoin2,
  IconArrowsLeft: IconArrowsLeft,
  IconArrowsLeftDown: IconArrowsLeftDown,
  IconArrowsLeftRight: IconArrowsLeftRight,
  IconArrowsMaximize: IconArrowsMaximize,
  IconArrowsMinimize: IconArrowsMinimize,
  IconArrowsMove: IconArrowsMove,
  IconArrowsMoveHorizontal: IconArrowsMoveHorizontal,
  IconArrowsMoveVertical: IconArrowsMoveVertical,
  IconArrowsRandom: IconArrowsRandom,
  IconArrowsRight: IconArrowsRight,
  IconArrowsRightDown: IconArrowsRightDown,
  IconArrowsRightLeft: IconArrowsRightLeft,
  IconArrowsShuffle: IconArrowsShuffle,
  IconArrowsShuffle2: IconArrowsShuffle2,
  IconArrowsSort: IconArrowsSort,
  IconArrowsSplit: IconArrowsSplit,
  IconArrowsSplit2: IconArrowsSplit2,
  IconArrowsTransferDown: IconArrowsTransferDown,
  IconArrowsTransferUp: IconArrowsTransferUp,
  IconArrowsTransferUpDown: IconArrowsTransferUpDown,
  IconArrowsUp: IconArrowsUp,
  IconArrowsUpDown: IconArrowsUpDown,
  IconArrowsUpLeft: IconArrowsUpLeft,
  IconArrowsUpRight: IconArrowsUpRight,
  IconArrowsVertical: IconArrowsVertical,
  IconArtboard: IconArtboard,
  IconArtboardFilled: IconArtboardFilled,
  IconArtboardOff: IconArtboardOff,
  IconArticle: IconArticle,
  IconArticleFilled: IconArticleFilled,
  IconArticleOff: IconArticleOff,
  IconAspectRatio: IconAspectRatio,
  IconAspectRatioFilled: IconAspectRatioFilled,
  IconAspectRatioOff: IconAspectRatioOff,
  IconAssembly: IconAssembly,
  IconAssemblyFilled: IconAssemblyFilled,
  IconAssemblyOff: IconAssemblyOff,
  IconAsset: IconAsset,
  IconAssetFilled: IconAssetFilled,
  IconAsterisk: IconAsterisk,
  IconAsteriskSimple: IconAsteriskSimple,
  IconAt: IconAt,
  IconAtOff: IconAtOff,
  IconAtom: IconAtom,
  IconAtom2: IconAtom2,
  IconAtom2Filled: IconAtom2Filled,
  IconAtomOff: IconAtomOff,
  IconAugmentedReality: IconAugmentedReality,
  IconAugmentedReality2: IconAugmentedReality2,
  IconAugmentedRealityOff: IconAugmentedRealityOff,
  IconAuth2fa: IconAuth2fa,
  IconAutomaticGearbox: IconAutomaticGearbox,
  IconAutomaticGearboxFilled: IconAutomaticGearboxFilled,
  IconAutomation: IconAutomation,
  IconAvocado: IconAvocado,
  IconAward: IconAward,
  IconAwardFilled: IconAwardFilled,
  IconAwardOff: IconAwardOff,
  IconAxe: IconAxe,
  IconAxisX: IconAxisX,
  IconAxisY: IconAxisY,
  IconBabyBottle: IconBabyBottle,
  IconBabyCarriage: IconBabyCarriage,
  IconBabyCarriageFilled: IconBabyCarriageFilled,
  IconBackground: IconBackground,
  IconBackhoe: IconBackhoe,
  IconBackpack: IconBackpack,
  IconBackpackOff: IconBackpackOff,
  IconBackslash: IconBackslash,
  IconBackspace: IconBackspace,
  IconBackspaceFilled: IconBackspaceFilled,
  IconBadge: IconBadge,
  IconBadge2k: IconBadge2k,
  IconBadge3d: IconBadge3d,
  IconBadge3dFilled: IconBadge3dFilled,
  IconBadge3k: IconBadge3k,
  IconBadge4k: IconBadge4k,
  IconBadge4kFilled: IconBadge4kFilled,
  IconBadge5k: IconBadge5k,
  IconBadge8k: IconBadge8k,
  IconBadge8kFilled: IconBadge8kFilled,
  IconBadgeAd: IconBadgeAd,
  IconBadgeAdFilled: IconBadgeAdFilled,
  IconBadgeAdOff: IconBadgeAdOff,
  IconBadgeAr: IconBadgeAr,
  IconBadgeArFilled: IconBadgeArFilled,
  IconBadgeCc: IconBadgeCc,
  IconBadgeCcFilled: IconBadgeCcFilled,
  IconBadgeFilled: IconBadgeFilled,
  IconBadgeHd: IconBadgeHd,
  IconBadgeHdFilled: IconBadgeHdFilled,
  IconBadgeOff: IconBadgeOff,
  IconBadgeSd: IconBadgeSd,
  IconBadgeSdFilled: IconBadgeSdFilled,
  IconBadgeTm: IconBadgeTm,
  IconBadgeTmFilled: IconBadgeTmFilled,
  IconBadgeVo: IconBadgeVo,
  IconBadgeVoFilled: IconBadgeVoFilled,
  IconBadgeVr: IconBadgeVr,
  IconBadgeVrFilled: IconBadgeVrFilled,
  IconBadgeWc: IconBadgeWc,
  IconBadgeWcFilled: IconBadgeWcFilled,
  IconBadges: IconBadges,
  IconBadgesFilled: IconBadgesFilled,
  IconBadgesOff: IconBadgesOff,
  IconBaguette: IconBaguette,
  IconBallAmericanFootball: IconBallAmericanFootball,
  IconBallAmericanFootballOff: IconBallAmericanFootballOff,
  IconBallBaseball: IconBallBaseball,
  IconBallBasketball: IconBallBasketball,
  IconBallBowling: IconBallBowling,
  IconBallFootball: IconBallFootball,
  IconBallFootballOff: IconBallFootballOff,
  IconBallTennis: IconBallTennis,
  IconBallVolleyball: IconBallVolleyball,
  IconBalloon: IconBalloon,
  IconBalloonFilled: IconBalloonFilled,
  IconBalloonOff: IconBalloonOff,
  IconBallpen: IconBallpen,
  IconBallpenFilled: IconBallpenFilled,
  IconBallpenOff: IconBallpenOff,
  IconBan: IconBan,
  IconBandage: IconBandage,
  IconBandageFilled: IconBandageFilled,
  IconBandageOff: IconBandageOff,
  IconBarbell: IconBarbell,
  IconBarbellFilled: IconBarbellFilled,
  IconBarbellOff: IconBarbellOff,
  IconBarcode: IconBarcode,
  IconBarcodeOff: IconBarcodeOff,
  IconBarrel: IconBarrel,
  IconBarrelOff: IconBarrelOff,
  IconBarrierBlock: IconBarrierBlock,
  IconBarrierBlockFilled: IconBarrierBlockFilled,
  IconBarrierBlockOff: IconBarrierBlockOff,
  IconBaseline: IconBaseline,
  IconBaselineDensityLarge: IconBaselineDensityLarge,
  IconBaselineDensityMedium: IconBaselineDensityMedium,
  IconBaselineDensitySmall: IconBaselineDensitySmall,
  IconBasket: IconBasket,
  IconBasketBolt: IconBasketBolt,
  IconBasketCancel: IconBasketCancel,
  IconBasketCheck: IconBasketCheck,
  IconBasketCode: IconBasketCode,
  IconBasketCog: IconBasketCog,
  IconBasketDiscount: IconBasketDiscount,
  IconBasketDollar: IconBasketDollar,
  IconBasketDown: IconBasketDown,
  IconBasketExclamation: IconBasketExclamation,
  IconBasketFilled: IconBasketFilled,
  IconBasketHeart: IconBasketHeart,
  IconBasketMinus: IconBasketMinus,
  IconBasketOff: IconBasketOff,
  IconBasketPause: IconBasketPause,
  IconBasketPin: IconBasketPin,
  IconBasketPlus: IconBasketPlus,
  IconBasketQuestion: IconBasketQuestion,
  IconBasketSearch: IconBasketSearch,
  IconBasketShare: IconBasketShare,
  IconBasketStar: IconBasketStar,
  IconBasketUp: IconBasketUp,
  IconBasketX: IconBasketX,
  IconBat: IconBat,
  IconBath: IconBath,
  IconBathFilled: IconBathFilled,
  IconBathOff: IconBathOff,
  IconBattery: IconBattery,
  IconBattery1: IconBattery1,
  IconBattery1Filled: IconBattery1Filled,
  IconBattery2: IconBattery2,
  IconBattery2Filled: IconBattery2Filled,
  IconBattery3: IconBattery3,
  IconBattery3Filled: IconBattery3Filled,
  IconBattery4: IconBattery4,
  IconBattery4Filled: IconBattery4Filled,
  IconBatteryAutomotive: IconBatteryAutomotive,
  IconBatteryAutomotiveFilled: IconBatteryAutomotiveFilled,
  IconBatteryCharging: IconBatteryCharging,
  IconBatteryCharging2: IconBatteryCharging2,
  IconBatteryEco: IconBatteryEco,
  IconBatteryExclamation: IconBatteryExclamation,
  IconBatteryFilled: IconBatteryFilled,
  IconBatteryOff: IconBatteryOff,
  IconBatterySpark: IconBatterySpark,
  IconBatteryVertical: IconBatteryVertical,
  IconBatteryVertical1: IconBatteryVertical1,
  IconBatteryVertical1Filled: IconBatteryVertical1Filled,
  IconBatteryVertical2: IconBatteryVertical2,
  IconBatteryVertical2Filled: IconBatteryVertical2Filled,
  IconBatteryVertical3: IconBatteryVertical3,
  IconBatteryVertical3Filled: IconBatteryVertical3Filled,
  IconBatteryVertical4: IconBatteryVertical4,
  IconBatteryVertical4Filled: IconBatteryVertical4Filled,
  IconBatteryVerticalCharging: IconBatteryVerticalCharging,
  IconBatteryVerticalCharging2: IconBatteryVerticalCharging2,
  IconBatteryVerticalEco: IconBatteryVerticalEco,
  IconBatteryVerticalExclamation: IconBatteryVerticalExclamation,
  IconBatteryVerticalFilled: IconBatteryVerticalFilled,
  IconBatteryVerticalOff: IconBatteryVerticalOff,
  IconBeach: IconBeach,
  IconBeachOff: IconBeachOff,
  IconBed: IconBed,
  IconBedFilled: IconBedFilled,
  IconBedFlat: IconBedFlat,
  IconBedFlatFilled: IconBedFlatFilled,
  IconBedOff: IconBedOff,
  IconBeer: IconBeer,
  IconBeerFilled: IconBeerFilled,
  IconBeerOff: IconBeerOff,
  IconBell: IconBell,
  IconBellBolt: IconBellBolt,
  IconBellCancel: IconBellCancel,
  IconBellCheck: IconBellCheck,
  IconBellCode: IconBellCode,
  IconBellCog: IconBellCog,
  IconBellDollar: IconBellDollar,
  IconBellDown: IconBellDown,
  IconBellExclamation: IconBellExclamation,
  IconBellFilled: IconBellFilled,
  IconBellHeart: IconBellHeart,
  IconBellMinus: IconBellMinus,
  IconBellMinusFilled: IconBellMinusFilled,
  IconBellOff: IconBellOff,
  IconBellPause: IconBellPause,
  IconBellPin: IconBellPin,
  IconBellPlus: IconBellPlus,
  IconBellPlusFilled: IconBellPlusFilled,
  IconBellQuestion: IconBellQuestion,
  IconBellRinging: IconBellRinging,
  IconBellRinging2: IconBellRinging2,
  IconBellRinging2Filled: IconBellRinging2Filled,
  IconBellRingingFilled: IconBellRingingFilled,
  IconBellSchool: IconBellSchool,
  IconBellSearch: IconBellSearch,
  IconBellShare: IconBellShare,
  IconBellStar: IconBellStar,
  IconBellUp: IconBellUp,
  IconBellX: IconBellX,
  IconBellXFilled: IconBellXFilled,
  IconBellZ: IconBellZ,
  IconBellZFilled: IconBellZFilled,
  IconBeta: IconBeta,
  IconBible: IconBible,
  IconBike: IconBike,
  IconBikeFilled: IconBikeFilled,
  IconBikeOff: IconBikeOff,
  IconBinary: IconBinary,
  IconBinaryOff: IconBinaryOff,
  IconBinaryTree: IconBinaryTree,
  IconBinaryTree2: IconBinaryTree2,
  IconBinaryTree2Filled: IconBinaryTree2Filled,
  IconBinaryTreeFilled: IconBinaryTreeFilled,
  IconBinoculars: IconBinoculars,
  IconBinocularsFilled: IconBinocularsFilled,
  IconBiohazard: IconBiohazard,
  IconBiohazardFilled: IconBiohazardFilled,
  IconBiohazardOff: IconBiohazardOff,
  IconBlade: IconBlade,
  IconBladeFilled: IconBladeFilled,
  IconBleach: IconBleach,
  IconBleachChlorine: IconBleachChlorine,
  IconBleachNoChlorine: IconBleachNoChlorine,
  IconBleachOff: IconBleachOff,
  IconBlendMode: IconBlendMode,
  IconBlender: IconBlender,
  IconBlenderFilled: IconBlenderFilled,
  IconBlob: IconBlob,
  IconBlobFilled: IconBlobFilled,
  IconBlockquote: IconBlockquote,
  IconBlocks: IconBlocks,
  IconBluetooth: IconBluetooth,
  IconBluetoothConnected: IconBluetoothConnected,
  IconBluetoothOff: IconBluetoothOff,
  IconBluetoothX: IconBluetoothX,
  IconBlur: IconBlur,
  IconBlurOff: IconBlurOff,
  IconBmp: IconBmp,
  IconBodyScan: IconBodyScan,
  IconBold: IconBold,
  IconBoldOff: IconBoldOff,
  IconBolt: IconBolt,
  IconBoltFilled: IconBoltFilled,
  IconBoltOff: IconBoltOff,
  IconBomb: IconBomb,
  IconBombFilled: IconBombFilled,
  IconBone: IconBone,
  IconBoneFilled: IconBoneFilled,
  IconBoneOff: IconBoneOff,
  IconBong: IconBong,
  IconBongFilled: IconBongFilled,
  IconBongOff: IconBongOff,
  IconBook: IconBook,
  IconBook2: IconBook2,
  IconBookDownload: IconBookDownload,
  IconBookFilled: IconBookFilled,
  IconBookOff: IconBookOff,
  IconBookUpload: IconBookUpload,
  IconBookmark: IconBookmark,
  IconBookmarkAi: IconBookmarkAi,
  IconBookmarkEdit: IconBookmarkEdit,
  IconBookmarkFilled: IconBookmarkFilled,
  IconBookmarkMinus: IconBookmarkMinus,
  IconBookmarkOff: IconBookmarkOff,
  IconBookmarkPlus: IconBookmarkPlus,
  IconBookmarkQuestion: IconBookmarkQuestion,
  IconBookmarks: IconBookmarks,
  IconBookmarksFilled: IconBookmarksFilled,
  IconBookmarksOff: IconBookmarksOff,
  IconBooks: IconBooks,
  IconBooksOff: IconBooksOff,
  IconBoom: IconBoom,
  IconBoomFilled: IconBoomFilled,
  IconBorderAll: IconBorderAll,
  IconBorderBottom: IconBorderBottom,
  IconBorderBottomPlus: IconBorderBottomPlus,
  IconBorderCornerIos: IconBorderCornerIos,
  IconBorderCornerPill: IconBorderCornerPill,
  IconBorderCornerRounded: IconBorderCornerRounded,
  IconBorderCornerSquare: IconBorderCornerSquare,
  IconBorderCorners: IconBorderCorners,
  IconBorderHorizontal: IconBorderHorizontal,
  IconBorderInner: IconBorderInner,
  IconBorderLeft: IconBorderLeft,
  IconBorderLeftPlus: IconBorderLeftPlus,
  IconBorderNone: IconBorderNone,
  IconBorderOuter: IconBorderOuter,
  IconBorderRadius: IconBorderRadius,
  IconBorderRight: IconBorderRight,
  IconBorderRightPlus: IconBorderRightPlus,
  IconBorderSides: IconBorderSides,
  IconBorderStyle: IconBorderStyle,
  IconBorderStyle2: IconBorderStyle2,
  IconBorderTop: IconBorderTop,
  IconBorderTopPlus: IconBorderTopPlus,
  IconBorderVertical: IconBorderVertical,
  IconBottle: IconBottle,
  IconBottleFilled: IconBottleFilled,
  IconBottleOff: IconBottleOff,
  IconBounceLeft: IconBounceLeft,
  IconBounceLeftFilled: IconBounceLeftFilled,
  IconBounceRight: IconBounceRight,
  IconBounceRightFilled: IconBounceRightFilled,
  IconBow: IconBow,
  IconBowFilled: IconBowFilled,
  IconBowl: IconBowl,
  IconBowlChopsticks: IconBowlChopsticks,
  IconBowlChopsticksFilled: IconBowlChopsticksFilled,
  IconBowlFilled: IconBowlFilled,
  IconBowlSpoon: IconBowlSpoon,
  IconBowlSpoonFilled: IconBowlSpoonFilled,
  IconBowling: IconBowling,
  IconBox: IconBox,
  IconBoxAlignBottom: IconBoxAlignBottom,
  IconBoxAlignBottomFilled: IconBoxAlignBottomFilled,
  IconBoxAlignBottomLeft: IconBoxAlignBottomLeft,
  IconBoxAlignBottomLeftFilled: IconBoxAlignBottomLeftFilled,
  IconBoxAlignBottomRight: IconBoxAlignBottomRight,
  IconBoxAlignBottomRightFilled: IconBoxAlignBottomRightFilled,
  IconBoxAlignLeft: IconBoxAlignLeft,
  IconBoxAlignLeftFilled: IconBoxAlignLeftFilled,
  IconBoxAlignRight: IconBoxAlignRight,
  IconBoxAlignRightFilled: IconBoxAlignRightFilled,
  IconBoxAlignTop: IconBoxAlignTop,
  IconBoxAlignTopFilled: IconBoxAlignTopFilled,
  IconBoxAlignTopLeft: IconBoxAlignTopLeft,
  IconBoxAlignTopLeftFilled: IconBoxAlignTopLeftFilled,
  IconBoxAlignTopRight: IconBoxAlignTopRight,
  IconBoxAlignTopRightFilled: IconBoxAlignTopRightFilled,
  IconBoxMargin: IconBoxMargin,
  IconBoxModel: IconBoxModel,
  IconBoxModel2: IconBoxModel2,
  IconBoxModel2Off: IconBoxModel2Off,
  IconBoxModelOff: IconBoxModelOff,
  IconBoxMultiple: IconBoxMultiple,
  IconBoxMultiple0: IconBoxMultiple0,
  IconBoxMultiple1: IconBoxMultiple1,
  IconBoxMultiple2: IconBoxMultiple2,
  IconBoxMultiple3: IconBoxMultiple3,
  IconBoxMultiple4: IconBoxMultiple4,
  IconBoxMultiple5: IconBoxMultiple5,
  IconBoxMultiple6: IconBoxMultiple6,
  IconBoxMultiple7: IconBoxMultiple7,
  IconBoxMultiple8: IconBoxMultiple8,
  IconBoxMultiple9: IconBoxMultiple9,
  IconBoxMultipleFilled: IconBoxMultipleFilled,
  IconBoxOff: IconBoxOff,
  IconBoxPadding: IconBoxPadding,
  IconBraces: IconBraces,
  IconBracesOff: IconBracesOff,
  IconBrackets: IconBrackets,
  IconBracketsAngle: IconBracketsAngle,
  IconBracketsAngleOff: IconBracketsAngleOff,
  IconBracketsContain: IconBracketsContain,
  IconBracketsContainEnd: IconBracketsContainEnd,
  IconBracketsContainStart: IconBracketsContainStart,
  IconBracketsOff: IconBracketsOff,
  IconBraille: IconBraille,
  IconBrain: IconBrain,
  IconBrand4chan: IconBrand4chan,
  IconBrandAbstract: IconBrandAbstract,
  IconBrandAdobe: IconBrandAdobe,
  IconBrandAdobeAfterEffect: IconBrandAdobeAfterEffect,
  IconBrandAdobeIllustrator: IconBrandAdobeIllustrator,
  IconBrandAdobeIndesign: IconBrandAdobeIndesign,
  IconBrandAdobePhotoshop: IconBrandAdobePhotoshop,
  IconBrandAdobePremier: IconBrandAdobePremier,
  IconBrandAdobeXd: IconBrandAdobeXd,
  IconBrandAdonisJs: IconBrandAdonisJs,
  IconBrandAirbnb: IconBrandAirbnb,
  IconBrandAirtable: IconBrandAirtable,
  IconBrandAlgolia: IconBrandAlgolia,
  IconBrandAlipay: IconBrandAlipay,
  IconBrandAlpineJs: IconBrandAlpineJs,
  IconBrandAmazon: IconBrandAmazon,
  IconBrandAmd: IconBrandAmd,
  IconBrandAmie: IconBrandAmie,
  IconBrandAmigo: IconBrandAmigo,
  IconBrandAmongUs: IconBrandAmongUs,
  IconBrandAndroid: IconBrandAndroid,
  IconBrandAngular: IconBrandAngular,
  IconBrandAngularFilled: IconBrandAngularFilled,
  IconBrandAnsible: IconBrandAnsible,
  IconBrandAo3: IconBrandAo3,
  IconBrandAppgallery: IconBrandAppgallery,
  IconBrandApple: IconBrandApple,
  IconBrandAppleArcade: IconBrandAppleArcade,
  IconBrandAppleFilled: IconBrandAppleFilled,
  IconBrandAppleNews: IconBrandAppleNews,
  IconBrandApplePodcast: IconBrandApplePodcast,
  IconBrandAppstore: IconBrandAppstore,
  IconBrandArc: IconBrandArc,
  IconBrandAsana: IconBrandAsana,
  IconBrandAstro: IconBrandAstro,
  IconBrandAuth0: IconBrandAuth0,
  IconBrandAws: IconBrandAws,
  IconBrandAzure: IconBrandAzure,
  IconBrandBackbone: IconBrandBackbone,
  IconBrandBadoo: IconBrandBadoo,
  IconBrandBaidu: IconBrandBaidu,
  IconBrandBandcamp: IconBrandBandcamp,
  IconBrandBandlab: IconBrandBandlab,
  IconBrandBeats: IconBrandBeats,
  IconBrandBebo: IconBrandBebo,
  IconBrandBehance: IconBrandBehance,
  IconBrandBilibili: IconBrandBilibili,
  IconBrandBinance: IconBrandBinance,
  IconBrandBing: IconBrandBing,
  IconBrandBitbucket: IconBrandBitbucket,
  IconBrandBitbucketFilled: IconBrandBitbucketFilled,
  IconBrandBlackberry: IconBrandBlackberry,
  IconBrandBlender: IconBrandBlender,
  IconBrandBlogger: IconBrandBlogger,
  IconBrandBluesky: IconBrandBluesky,
  IconBrandBooking: IconBrandBooking,
  IconBrandBootstrap: IconBrandBootstrap,
  IconBrandBulma: IconBrandBulma,
  IconBrandBumble: IconBrandBumble,
  IconBrandBunpo: IconBrandBunpo,
  IconBrandCSharp: IconBrandCSharp,
  IconBrandCake: IconBrandCake,
  IconBrandCakephp: IconBrandCakephp,
  IconBrandCampaignmonitor: IconBrandCampaignmonitor,
  IconBrandCarbon: IconBrandCarbon,
  IconBrandCashapp: IconBrandCashapp,
  IconBrandChrome: IconBrandChrome,
  IconBrandCinema4d: IconBrandCinema4d,
  IconBrandCitymapper: IconBrandCitymapper,
  IconBrandCloudflare: IconBrandCloudflare,
  IconBrandCodecov: IconBrandCodecov,
  IconBrandCodepen: IconBrandCodepen,
  IconBrandCodesandbox: IconBrandCodesandbox,
  IconBrandCohost: IconBrandCohost,
  IconBrandCoinbase: IconBrandCoinbase,
  IconBrandComedyCentral: IconBrandComedyCentral,
  IconBrandCoreos: IconBrandCoreos,
  IconBrandCouchdb: IconBrandCouchdb,
  IconBrandCouchsurfing: IconBrandCouchsurfing,
  IconBrandCpp: IconBrandCpp,
  IconBrandCraft: IconBrandCraft,
  IconBrandCrunchbase: IconBrandCrunchbase,
  IconBrandCss3: IconBrandCss3,
  IconBrandCtemplar: IconBrandCtemplar,
  IconBrandCucumber: IconBrandCucumber,
  IconBrandCupra: IconBrandCupra,
  IconBrandCypress: IconBrandCypress,
  IconBrandD3: IconBrandD3,
  IconBrandDatabricks: IconBrandDatabricks,
  IconBrandDaysCounter: IconBrandDaysCounter,
  IconBrandDcos: IconBrandDcos,
  IconBrandDebian: IconBrandDebian,
  IconBrandDeezer: IconBrandDeezer,
  IconBrandDeliveroo: IconBrandDeliveroo,
  IconBrandDeno: IconBrandDeno,
  IconBrandDenodo: IconBrandDenodo,
  IconBrandDeviantart: IconBrandDeviantart,
  IconBrandDigg: IconBrandDigg,
  IconBrandDingtalk: IconBrandDingtalk,
  IconBrandDiscord: IconBrandDiscord,
  IconBrandDiscordFilled: IconBrandDiscordFilled,
  IconBrandDisney: IconBrandDisney,
  IconBrandDisqus: IconBrandDisqus,
  IconBrandDjango: IconBrandDjango,
  IconBrandDocker: IconBrandDocker,
  IconBrandDoctrine: IconBrandDoctrine,
  IconBrandDolbyDigital: IconBrandDolbyDigital,
  IconBrandDouban: IconBrandDouban,
  IconBrandDribbble: IconBrandDribbble,
  IconBrandDribbbleFilled: IconBrandDribbbleFilled,
  IconBrandDrops: IconBrandDrops,
  IconBrandDrupal: IconBrandDrupal,
  IconBrandEdge: IconBrandEdge,
  IconBrandElastic: IconBrandElastic,
  IconBrandElectronicArts: IconBrandElectronicArts,
  IconBrandEmber: IconBrandEmber,
  IconBrandEnvato: IconBrandEnvato,
  IconBrandEtsy: IconBrandEtsy,
  IconBrandEvernote: IconBrandEvernote,
  IconBrandFacebook: IconBrandFacebook,
  IconBrandFacebookFilled: IconBrandFacebookFilled,
  IconBrandFeedly: IconBrandFeedly,
  IconBrandFigma: IconBrandFigma,
  IconBrandFilezilla: IconBrandFilezilla,
  IconBrandFinder: IconBrandFinder,
  IconBrandFirebase: IconBrandFirebase,
  IconBrandFirefox: IconBrandFirefox,
  IconBrandFiverr: IconBrandFiverr,
  IconBrandFlickr: IconBrandFlickr,
  IconBrandFlightradar24: IconBrandFlightradar24,
  IconBrandFlipboard: IconBrandFlipboard,
  IconBrandFlutter: IconBrandFlutter,
  IconBrandFortnite: IconBrandFortnite,
  IconBrandFoursquare: IconBrandFoursquare,
  IconBrandFramer: IconBrandFramer,
  IconBrandFramerMotion: IconBrandFramerMotion,
  IconBrandFunimation: IconBrandFunimation,
  IconBrandGatsby: IconBrandGatsby,
  IconBrandGit: IconBrandGit,
  IconBrandGithub: IconBrandGithub,
  IconBrandGithubCopilot: IconBrandGithubCopilot,
  IconBrandGithubFilled: IconBrandGithubFilled,
  IconBrandGitlab: IconBrandGitlab,
  IconBrandGmail: IconBrandGmail,
  IconBrandGolang: IconBrandGolang,
  IconBrandGoogle: IconBrandGoogle,
  IconBrandGoogleAnalytics: IconBrandGoogleAnalytics,
  IconBrandGoogleBigQuery: IconBrandGoogleBigQuery,
  IconBrandGoogleDrive: IconBrandGoogleDrive,
  IconBrandGoogleFilled: IconBrandGoogleFilled,
  IconBrandGoogleFit: IconBrandGoogleFit,
  IconBrandGoogleHome: IconBrandGoogleHome,
  IconBrandGoogleMaps: IconBrandGoogleMaps,
  IconBrandGoogleOne: IconBrandGoogleOne,
  IconBrandGooglePhotos: IconBrandGooglePhotos,
  IconBrandGooglePlay: IconBrandGooglePlay,
  IconBrandGooglePodcasts: IconBrandGooglePodcasts,
  IconBrandGrammarly: IconBrandGrammarly,
  IconBrandGraphql: IconBrandGraphql,
  IconBrandGravatar: IconBrandGravatar,
  IconBrandGrindr: IconBrandGrindr,
  IconBrandGuardian: IconBrandGuardian,
  IconBrandGumroad: IconBrandGumroad,
  IconBrandHackerrank: IconBrandHackerrank,
  IconBrandHbo: IconBrandHbo,
  IconBrandHeadlessui: IconBrandHeadlessui,
  IconBrandHexo: IconBrandHexo,
  IconBrandHipchat: IconBrandHipchat,
  IconBrandHtml5: IconBrandHtml5,
  IconBrandInertia: IconBrandInertia,
  IconBrandInstagram: IconBrandInstagram,
  IconBrandInstagramFilled: IconBrandInstagramFilled,
  IconBrandIntercom: IconBrandIntercom,
  IconBrandItch: IconBrandItch,
  IconBrandJavascript: IconBrandJavascript,
  IconBrandJuejin: IconBrandJuejin,
  IconBrandKakoTalk: IconBrandKakoTalk,
  IconBrandKbin: IconBrandKbin,
  IconBrandKick: IconBrandKick,
  IconBrandKickFilled: IconBrandKickFilled,
  IconBrandKickstarter: IconBrandKickstarter,
  IconBrandKotlin: IconBrandKotlin,
  IconBrandLaravel: IconBrandLaravel,
  IconBrandLastfm: IconBrandLastfm,
  IconBrandLeetcode: IconBrandLeetcode,
  IconBrandLetterboxd: IconBrandLetterboxd,
  IconBrandLine: IconBrandLine,
  IconBrandLinkedin: IconBrandLinkedin,
  IconBrandLinkedinFilled: IconBrandLinkedinFilled,
  IconBrandLinktree: IconBrandLinktree,
  IconBrandLinqpad: IconBrandLinqpad,
  IconBrandLivewire: IconBrandLivewire,
  IconBrandLoom: IconBrandLoom,
  IconBrandMailgun: IconBrandMailgun,
  IconBrandMantine: IconBrandMantine,
  IconBrandMastercard: IconBrandMastercard,
  IconBrandMastodon: IconBrandMastodon,
  IconBrandMatrix: IconBrandMatrix,
  IconBrandMcdonalds: IconBrandMcdonalds,
  IconBrandMedium: IconBrandMedium,
  IconBrandMeetup: IconBrandMeetup,
  IconBrandMercedes: IconBrandMercedes,
  IconBrandMessenger: IconBrandMessenger,
  IconBrandMessengerFilled: IconBrandMessengerFilled,
  IconBrandMeta: IconBrandMeta,
  IconBrandMetabrainz: IconBrandMetabrainz,
  IconBrandMinecraft: IconBrandMinecraft,
  IconBrandMiniprogram: IconBrandMiniprogram,
  IconBrandMixpanel: IconBrandMixpanel,
  IconBrandMonday: IconBrandMonday,
  IconBrandMongodb: IconBrandMongodb,
  IconBrandMyOppo: IconBrandMyOppo,
  IconBrandMysql: IconBrandMysql,
  IconBrandNationalGeographic: IconBrandNationalGeographic,
  IconBrandNem: IconBrandNem,
  IconBrandNetbeans: IconBrandNetbeans,
  IconBrandNeteaseMusic: IconBrandNeteaseMusic,
  IconBrandNetflix: IconBrandNetflix,
  IconBrandNexo: IconBrandNexo,
  IconBrandNextcloud: IconBrandNextcloud,
  IconBrandNextjs: IconBrandNextjs,
  IconBrandNodejs: IconBrandNodejs,
  IconBrandNordVpn: IconBrandNordVpn,
  IconBrandNotion: IconBrandNotion,
  IconBrandNpm: IconBrandNpm,
  IconBrandNuxt: IconBrandNuxt,
  IconBrandNytimes: IconBrandNytimes,
  IconBrandOauth: IconBrandOauth,
  IconBrandOffice: IconBrandOffice,
  IconBrandOkRu: IconBrandOkRu,
  IconBrandOnedrive: IconBrandOnedrive,
  IconBrandOnlyfans: IconBrandOnlyfans,
  IconBrandOpenSource: IconBrandOpenSource,
  IconBrandOpenSourceFilled: IconBrandOpenSourceFilled,
  IconBrandOpenai: IconBrandOpenai,
  IconBrandOpenvpn: IconBrandOpenvpn,
  IconBrandOpera: IconBrandOpera,
  IconBrandOperaFilled: IconBrandOperaFilled,
  IconBrandPagekit: IconBrandPagekit,
  IconBrandParsinta: IconBrandParsinta,
  IconBrandPatreon: IconBrandPatreon,
  IconBrandPatreonFilled: IconBrandPatreonFilled,
  IconBrandPaypal: IconBrandPaypal,
  IconBrandPaypalFilled: IconBrandPaypalFilled,
  IconBrandPaypay: IconBrandPaypay,
  IconBrandPeanut: IconBrandPeanut,
  IconBrandPepsi: IconBrandPepsi,
  IconBrandPhp: IconBrandPhp,
  IconBrandPicsart: IconBrandPicsart,
  IconBrandPinterest: IconBrandPinterest,
  IconBrandPinterestFilled: IconBrandPinterestFilled,
  IconBrandPlanetscale: IconBrandPlanetscale,
  IconBrandPnpm: IconBrandPnpm,
  IconBrandPocket: IconBrandPocket,
  IconBrandPolymer: IconBrandPolymer,
  IconBrandPowershell: IconBrandPowershell,
  IconBrandPrintables: IconBrandPrintables,
  IconBrandPrisma: IconBrandPrisma,
  IconBrandProducthunt: IconBrandProducthunt,
  IconBrandPushbullet: IconBrandPushbullet,
  IconBrandPushover: IconBrandPushover,
  IconBrandPython: IconBrandPython,
  IconBrandQq: IconBrandQq,
  IconBrandRadixUi: IconBrandRadixUi,
  IconBrandReact: IconBrandReact,
  IconBrandReactNative: IconBrandReactNative,
  IconBrandReason: IconBrandReason,
  IconBrandReddit: IconBrandReddit,
  IconBrandRedhat: IconBrandRedhat,
  IconBrandRedux: IconBrandRedux,
  IconBrandRevolut: IconBrandRevolut,
  IconBrandRumble: IconBrandRumble,
  IconBrandRust: IconBrandRust,
  IconBrandSafari: IconBrandSafari,
  IconBrandSamsungpass: IconBrandSamsungpass,
  IconBrandSass: IconBrandSass,
  IconBrandSentry: IconBrandSentry,
  IconBrandSharik: IconBrandSharik,
  IconBrandShazam: IconBrandShazam,
  IconBrandShopee: IconBrandShopee,
  IconBrandSketch: IconBrandSketch,
  IconBrandSketchFilled: IconBrandSketchFilled,
  IconBrandSkype: IconBrandSkype,
  IconBrandSlack: IconBrandSlack,
  IconBrandSnapchat: IconBrandSnapchat,
  IconBrandSnapchatFilled: IconBrandSnapchatFilled,
  IconBrandSnapseed: IconBrandSnapseed,
  IconBrandSnowflake: IconBrandSnowflake,
  IconBrandSocketIo: IconBrandSocketIo,
  IconBrandSolidjs: IconBrandSolidjs,
  IconBrandSoundcloud: IconBrandSoundcloud,
  IconBrandSpacehey: IconBrandSpacehey,
  IconBrandSpeedtest: IconBrandSpeedtest,
  IconBrandSpotify: IconBrandSpotify,
  IconBrandSpotifyFilled: IconBrandSpotifyFilled,
  IconBrandStackoverflow: IconBrandStackoverflow,
  IconBrandStackshare: IconBrandStackshare,
  IconBrandSteam: IconBrandSteam,
  IconBrandSteamFilled: IconBrandSteamFilled,
  IconBrandStocktwits: IconBrandStocktwits,
  IconBrandStorj: IconBrandStorj,
  IconBrandStorybook: IconBrandStorybook,
  IconBrandStorytel: IconBrandStorytel,
  IconBrandStrava: IconBrandStrava,
  IconBrandStripe: IconBrandStripe,
  IconBrandStripeFilled: IconBrandStripeFilled,
  IconBrandSublimeText: IconBrandSublimeText,
  IconBrandSugarizer: IconBrandSugarizer,
  IconBrandSupabase: IconBrandSupabase,
  IconBrandSuperhuman: IconBrandSuperhuman,
  IconBrandSupernova: IconBrandSupernova,
  IconBrandSurfshark: IconBrandSurfshark,
  IconBrandSvelte: IconBrandSvelte,
  IconBrandSwift: IconBrandSwift,
  IconBrandSymfony: IconBrandSymfony,
  IconBrandTabler: IconBrandTabler,
  IconBrandTablerFilled: IconBrandTablerFilled,
  IconBrandTailwind: IconBrandTailwind,
  IconBrandTaobao: IconBrandTaobao,
  IconBrandTeams: IconBrandTeams,
  IconBrandTed: IconBrandTed,
  IconBrandTelegram: IconBrandTelegram,
  IconBrandTerraform: IconBrandTerraform,
  IconBrandTesla: IconBrandTesla,
  IconBrandTether: IconBrandTether,
  IconBrandThingiverse: IconBrandThingiverse,
  IconBrandThreads: IconBrandThreads,
  IconBrandThreejs: IconBrandThreejs,
  IconBrandTidal: IconBrandTidal,
  IconBrandTiktok: IconBrandTiktok,
  IconBrandTiktokFilled: IconBrandTiktokFilled,
  IconBrandTinder: IconBrandTinder,
  IconBrandTinderFilled: IconBrandTinderFilled,
  IconBrandTopbuzz: IconBrandTopbuzz,
  IconBrandTorchain: IconBrandTorchain,
  IconBrandToyota: IconBrandToyota,
  IconBrandTrello: IconBrandTrello,
  IconBrandTripadvisor: IconBrandTripadvisor,
  IconBrandTumblr: IconBrandTumblr,
  IconBrandTumblrFilled: IconBrandTumblrFilled,
  IconBrandTwilio: IconBrandTwilio,
  IconBrandTwitch: IconBrandTwitch,
  IconBrandTwitter: IconBrandTwitter,
  IconBrandTwitterFilled: IconBrandTwitterFilled,
  IconBrandTypescript: IconBrandTypescript,
  IconBrandUber: IconBrandUber,
  IconBrandUbuntu: IconBrandUbuntu,
  IconBrandUnity: IconBrandUnity,
  IconBrandUnsplash: IconBrandUnsplash,
  IconBrandUpwork: IconBrandUpwork,
  IconBrandValorant: IconBrandValorant,
  IconBrandVercel: IconBrandVercel,
  IconBrandVercelFilled: IconBrandVercelFilled,
  IconBrandVimeo: IconBrandVimeo,
  IconBrandVimeoFilled: IconBrandVimeoFilled,
  IconBrandVinted: IconBrandVinted,
  IconBrandVisa: IconBrandVisa,
  IconBrandVisualStudio: IconBrandVisualStudio,
  IconBrandVite: IconBrandVite,
  IconBrandVivaldi: IconBrandVivaldi,
  IconBrandVk: IconBrandVk,
  IconBrandVlc: IconBrandVlc,
  IconBrandVolkswagen: IconBrandVolkswagen,
  IconBrandVsco: IconBrandVsco,
  IconBrandVscode: IconBrandVscode,
  IconBrandVue: IconBrandVue,
  IconBrandWalmart: IconBrandWalmart,
  IconBrandWaze: IconBrandWaze,
  IconBrandWebflow: IconBrandWebflow,
  IconBrandWechat: IconBrandWechat,
  IconBrandWeibo: IconBrandWeibo,
  IconBrandWeiboFilled: IconBrandWeiboFilled,
  IconBrandWhatsapp: IconBrandWhatsapp,
  IconBrandWhatsappFilled: IconBrandWhatsappFilled,
  IconBrandWikipedia: IconBrandWikipedia,
  IconBrandWindows: IconBrandWindows,
  IconBrandWindowsFilled: IconBrandWindowsFilled,
  IconBrandWindy: IconBrandWindy,
  IconBrandWish: IconBrandWish,
  IconBrandWix: IconBrandWix,
  IconBrandWordpress: IconBrandWordpress,
  IconBrandX: IconBrandX,
  IconBrandXFilled: IconBrandXFilled,
  IconBrandXamarin: IconBrandXamarin,
  IconBrandXbox: IconBrandXbox,
  IconBrandXdeep: IconBrandXdeep,
  IconBrandXing: IconBrandXing,
  IconBrandYahoo: IconBrandYahoo,
  IconBrandYandex: IconBrandYandex,
  IconBrandYarn: IconBrandYarn,
  IconBrandYatse: IconBrandYatse,
  IconBrandYcombinator: IconBrandYcombinator,
  IconBrandYoutube: IconBrandYoutube,
  IconBrandYoutubeFilled: IconBrandYoutubeFilled,
  IconBrandYoutubeKids: IconBrandYoutubeKids,
  IconBrandZalando: IconBrandZalando,
  IconBrandZapier: IconBrandZapier,
  IconBrandZeit: IconBrandZeit,
  IconBrandZhihu: IconBrandZhihu,
  IconBrandZoom: IconBrandZoom,
  IconBrandZulip: IconBrandZulip,
  IconBrandZwift: IconBrandZwift,
  IconBread: IconBread,
  IconBreadFilled: IconBreadFilled,
  IconBreadOff: IconBreadOff,
  IconBriefcase: IconBriefcase,
  IconBriefcase2: IconBriefcase2,
  IconBriefcase2Filled: IconBriefcase2Filled,
  IconBriefcaseFilled: IconBriefcaseFilled,
  IconBriefcaseOff: IconBriefcaseOff,
  IconBrightness: IconBrightness,
  IconBrightness2: IconBrightness2,
  IconBrightnessAuto: IconBrightnessAuto,
  IconBrightnessAutoFilled: IconBrightnessAutoFilled,
  IconBrightnessDown: IconBrightnessDown,
  IconBrightnessDownFilled: IconBrightnessDownFilled,
  IconBrightnessFilled: IconBrightnessFilled,
  IconBrightnessHalf: IconBrightnessHalf,
  IconBrightnessOff: IconBrightnessOff,
  IconBrightnessUp: IconBrightnessUp,
  IconBrightnessUpFilled: IconBrightnessUpFilled,
  IconBroadcast: IconBroadcast,
  IconBroadcastOff: IconBroadcastOff,
  IconBrowser: IconBrowser,
  IconBrowserCheck: IconBrowserCheck,
  IconBrowserMaximize: IconBrowserMaximize,
  IconBrowserMinus: IconBrowserMinus,
  IconBrowserOff: IconBrowserOff,
  IconBrowserPlus: IconBrowserPlus,
  IconBrowserShare: IconBrowserShare,
  IconBrowserX: IconBrowserX,
  IconBrush: IconBrush,
  IconBrushOff: IconBrushOff,
  IconBubble: IconBubble,
  IconBubbleFilled: IconBubbleFilled,
  IconBubbleMinus: IconBubbleMinus,
  IconBubblePlus: IconBubblePlus,
  IconBubbleTea: IconBubbleTea,
  IconBubbleTea2: IconBubbleTea2,
  IconBubbleText: IconBubbleText,
  IconBubbleTextFilled: IconBubbleTextFilled,
  IconBubbleX: IconBubbleX,
  IconBucket: IconBucket,
  IconBucketDroplet: IconBucketDroplet,
  IconBucketOff: IconBucketOff,
  IconBug: IconBug,
  IconBugFilled: IconBugFilled,
  IconBugOff: IconBugOff,
  IconBuilding: IconBuilding,
  IconBuildingAirport: IconBuildingAirport,
  IconBuildingArch: IconBuildingArch,
  IconBuildingBank: IconBuildingBank,
  IconBuildingBridge: IconBuildingBridge,
  IconBuildingBridge2: IconBuildingBridge2,
  IconBuildingBroadcastTower: IconBuildingBroadcastTower,
  IconBuildingBroadcastTowerFilled: IconBuildingBroadcastTowerFilled,
  IconBuildingBurjAlArab: IconBuildingBurjAlArab,
  IconBuildingCarousel: IconBuildingCarousel,
  IconBuildingCastle: IconBuildingCastle,
  IconBuildingChurch: IconBuildingChurch,
  IconBuildingCircus: IconBuildingCircus,
  IconBuildingCog: IconBuildingCog,
  IconBuildingCommunity: IconBuildingCommunity,
  IconBuildingCottage: IconBuildingCottage,
  IconBuildingEstate: IconBuildingEstate,
  IconBuildingFactory: IconBuildingFactory,
  IconBuildingFactory2: IconBuildingFactory2,
  IconBuildingFortress: IconBuildingFortress,
  IconBuildingHospital: IconBuildingHospital,
  IconBuildingLighthouse: IconBuildingLighthouse,
  IconBuildingMinus: IconBuildingMinus,
  IconBuildingMonument: IconBuildingMonument,
  IconBuildingMosque: IconBuildingMosque,
  IconBuildingOff: IconBuildingOff,
  IconBuildingPavilion: IconBuildingPavilion,
  IconBuildingPlus: IconBuildingPlus,
  IconBuildingSkyscraper: IconBuildingSkyscraper,
  IconBuildingStadium: IconBuildingStadium,
  IconBuildingStore: IconBuildingStore,
  IconBuildingTunnel: IconBuildingTunnel,
  IconBuildingWarehouse: IconBuildingWarehouse,
  IconBuildingWindTurbine: IconBuildingWindTurbine,
  IconBuildings: IconBuildings,
  IconBulb: IconBulb,
  IconBulbFilled: IconBulbFilled,
  IconBulbOff: IconBulbOff,
  IconBulldozer: IconBulldozer,
  IconBurger: IconBurger,
  IconBus: IconBus,
  IconBusFilled: IconBusFilled,
  IconBusOff: IconBusOff,
  IconBusStop: IconBusStop,
  IconBusinessplan: IconBusinessplan,
  IconButterfly: IconButterfly,
  IconButterflyFilled: IconButterflyFilled,
  IconCactus: IconCactus,
  IconCactusFilled: IconCactusFilled,
  IconCactusOff: IconCactusOff,
  IconCake: IconCake,
  IconCakeOff: IconCakeOff,
  IconCakeRoll: IconCakeRoll,
  IconCalculator: IconCalculator,
  IconCalculatorFilled: IconCalculatorFilled,
  IconCalculatorOff: IconCalculatorOff,
  IconCalendar: IconCalendar,
  IconCalendarBolt: IconCalendarBolt,
  IconCalendarCancel: IconCalendarCancel,
  IconCalendarCheck: IconCalendarCheck,
  IconCalendarClock: IconCalendarClock,
  IconCalendarCode: IconCalendarCode,
  IconCalendarCog: IconCalendarCog,
  IconCalendarDollar: IconCalendarDollar,
  IconCalendarDot: IconCalendarDot,
  IconCalendarDown: IconCalendarDown,
  IconCalendarDue: IconCalendarDue,
  IconCalendarEvent: IconCalendarEvent,
  IconCalendarEventFilled: IconCalendarEventFilled,
  IconCalendarExclamation: IconCalendarExclamation,
  IconCalendarFilled: IconCalendarFilled,
  IconCalendarHeart: IconCalendarHeart,
  IconCalendarMinus: IconCalendarMinus,
  IconCalendarMonth: IconCalendarMonth,
  IconCalendarMonthFilled: IconCalendarMonthFilled,
  IconCalendarOff: IconCalendarOff,
  IconCalendarPause: IconCalendarPause,
  IconCalendarPin: IconCalendarPin,
  IconCalendarPlus: IconCalendarPlus,
  IconCalendarQuestion: IconCalendarQuestion,
  IconCalendarRepeat: IconCalendarRepeat,
  IconCalendarSad: IconCalendarSad,
  IconCalendarSearch: IconCalendarSearch,
  IconCalendarShare: IconCalendarShare,
  IconCalendarSmile: IconCalendarSmile,
  IconCalendarStar: IconCalendarStar,
  IconCalendarStats: IconCalendarStats,
  IconCalendarTime: IconCalendarTime,
  IconCalendarUp: IconCalendarUp,
  IconCalendarUser: IconCalendarUser,
  IconCalendarWeek: IconCalendarWeek,
  IconCalendarWeekFilled: IconCalendarWeekFilled,
  IconCalendarX: IconCalendarX,
  IconCamera: IconCamera,
  IconCameraAi: IconCameraAi,
  IconCameraBitcoin: IconCameraBitcoin,
  IconCameraBolt: IconCameraBolt,
  IconCameraCancel: IconCameraCancel,
  IconCameraCheck: IconCameraCheck,
  IconCameraCode: IconCameraCode,
  IconCameraCog: IconCameraCog,
  IconCameraDollar: IconCameraDollar,
  IconCameraDown: IconCameraDown,
  IconCameraExclamation: IconCameraExclamation,
  IconCameraFilled: IconCameraFilled,
  IconCameraHeart: IconCameraHeart,
  IconCameraMinus: IconCameraMinus,
  IconCameraMoon: IconCameraMoon,
  IconCameraOff: IconCameraOff,
  IconCameraPause: IconCameraPause,
  IconCameraPin: IconCameraPin,
  IconCameraPlus: IconCameraPlus,
  IconCameraQuestion: IconCameraQuestion,
  IconCameraRotate: IconCameraRotate,
  IconCameraSearch: IconCameraSearch,
  IconCameraSelfie: IconCameraSelfie,
  IconCameraShare: IconCameraShare,
  IconCameraSpark: IconCameraSpark,
  IconCameraStar: IconCameraStar,
  IconCameraUp: IconCameraUp,
  IconCameraX: IconCameraX,
  IconCamper: IconCamper,
  IconCampfire: IconCampfire,
  IconCampfireFilled: IconCampfireFilled,
  IconCancel: IconCancel,
  IconCandle: IconCandle,
  IconCandleFilled: IconCandleFilled,
  IconCandy: IconCandy,
  IconCandyOff: IconCandyOff,
  IconCane: IconCane,
  IconCannabis: IconCannabis,
  IconCannabisFilled: IconCannabisFilled,
  IconCapProjecting: IconCapProjecting,
  IconCapRounded: IconCapRounded,
  IconCapStraight: IconCapStraight,
  IconCapsule: IconCapsule,
  IconCapsuleFilled: IconCapsuleFilled,
  IconCapsuleHorizontal: IconCapsuleHorizontal,
  IconCapsuleHorizontalFilled: IconCapsuleHorizontalFilled,
  IconCapture: IconCapture,
  IconCaptureFilled: IconCaptureFilled,
  IconCaptureOff: IconCaptureOff,
  IconCar: IconCar,
  IconCar4wd: IconCar4wd,
  IconCar4wdFilled: IconCar4wdFilled,
  IconCarCrane: IconCarCrane,
  IconCarCraneFilled: IconCarCraneFilled,
  IconCarCrash: IconCarCrash,
  IconCarFan: IconCarFan,
  IconCarFan1: IconCarFan1,
  IconCarFan2: IconCarFan2,
  IconCarFan3: IconCarFan3,
  IconCarFanAuto: IconCarFanAuto,
  IconCarFanFilled: IconCarFanFilled,
  IconCarFilled: IconCarFilled,
  IconCarGarage: IconCarGarage,
  IconCarOff: IconCarOff,
  IconCarSuv: IconCarSuv,
  IconCarSuvFilled: IconCarSuvFilled,
  IconCarTurbine: IconCarTurbine,
  IconCarambola: IconCarambola,
  IconCarambolaFilled: IconCarambolaFilled,
  IconCaravan: IconCaravan,
  IconCaravanFilled: IconCaravanFilled,
  IconCardboards: IconCardboards,
  IconCardboardsFilled: IconCardboardsFilled,
  IconCardboardsOff: IconCardboardsOff,
  IconCards: IconCards,
  IconCardsFilled: IconCardsFilled,
  IconCaretDown: IconCaretDown,
  IconCaretDownFilled: IconCaretDownFilled,
  IconCaretLeft: IconCaretLeft,
  IconCaretLeftFilled: IconCaretLeftFilled,
  IconCaretLeftRight: IconCaretLeftRight,
  IconCaretLeftRightFilled: IconCaretLeftRightFilled,
  IconCaretRight: IconCaretRight,
  IconCaretRightFilled: IconCaretRightFilled,
  IconCaretUp: IconCaretUp,
  IconCaretUpDown: IconCaretUpDown,
  IconCaretUpDownFilled: IconCaretUpDownFilled,
  IconCaretUpFilled: IconCaretUpFilled,
  IconCarouselHorizontal: IconCarouselHorizontal,
  IconCarouselHorizontalFilled: IconCarouselHorizontalFilled,
  IconCarouselVertical: IconCarouselVertical,
  IconCarouselVerticalFilled: IconCarouselVerticalFilled,
  IconCarrot: IconCarrot,
  IconCarrotOff: IconCarrotOff,
  IconCash: IconCash,
  IconCashBanknote: IconCashBanknote,
  IconCashBanknoteEdit: IconCashBanknoteEdit,
  IconCashBanknoteFilled: IconCashBanknoteFilled,
  IconCashBanknoteHeart: IconCashBanknoteHeart,
  IconCashBanknoteMinus: IconCashBanknoteMinus,
  IconCashBanknoteMove: IconCashBanknoteMove,
  IconCashBanknoteMoveBack: IconCashBanknoteMoveBack,
  IconCashBanknoteOff: IconCashBanknoteOff,
  IconCashBanknotePlus: IconCashBanknotePlus,
  IconCashEdit: IconCashEdit,
  IconCashHeart: IconCashHeart,
  IconCashMinus: IconCashMinus,
  IconCashMove: IconCashMove,
  IconCashMoveBack: IconCashMoveBack,
  IconCashOff: IconCashOff,
  IconCashPlus: IconCashPlus,
  IconCashRegister: IconCashRegister,
  IconCast: IconCast,
  IconCastOff: IconCastOff,
  IconCat: IconCat,
  IconCategory: IconCategory,
  IconCategory2: IconCategory2,
  IconCategoryFilled: IconCategoryFilled,
  IconCategoryMinus: IconCategoryMinus,
  IconCategoryPlus: IconCategoryPlus,
  IconCe: IconCe,
  IconCeOff: IconCeOff,
  IconCell: IconCell,
  IconCellSignal1: IconCellSignal1,
  IconCellSignal2: IconCellSignal2,
  IconCellSignal3: IconCellSignal3,
  IconCellSignal4: IconCellSignal4,
  IconCellSignal5: IconCellSignal5,
  IconCellSignalOff: IconCellSignalOff,
  IconCertificate: IconCertificate,
  IconCertificate2: IconCertificate2,
  IconCertificate2Off: IconCertificate2Off,
  IconCertificateOff: IconCertificateOff,
  IconChairDirector: IconChairDirector,
  IconChalkboard: IconChalkboard,
  IconChalkboardOff: IconChalkboardOff,
  IconChargingPile: IconChargingPile,
  IconChargingPileFilled: IconChargingPileFilled,
  IconChartArcs: IconChartArcs,
  IconChartArcs3: IconChartArcs3,
  IconChartArea: IconChartArea,
  IconChartAreaFilled: IconChartAreaFilled,
  IconChartAreaLine: IconChartAreaLine,
  IconChartAreaLineFilled: IconChartAreaLineFilled,
  IconChartArrows: IconChartArrows,
  IconChartArrowsVertical: IconChartArrowsVertical,
  IconChartBar: IconChartBar,
  IconChartBarOff: IconChartBarOff,
  IconChartBarPopular: IconChartBarPopular,
  IconChartBubble: IconChartBubble,
  IconChartBubbleFilled: IconChartBubbleFilled,
  IconChartCandle: IconChartCandle,
  IconChartCandleFilled: IconChartCandleFilled,
  IconChartCircles: IconChartCircles,
  IconChartCohort: IconChartCohort,
  IconChartColumn: IconChartColumn,
  IconChartCovariate: IconChartCovariate,
  IconChartDonut: IconChartDonut,
  IconChartDonut2: IconChartDonut2,
  IconChartDonut3: IconChartDonut3,
  IconChartDonut4: IconChartDonut4,
  IconChartDonutFilled: IconChartDonutFilled,
  IconChartDots: IconChartDots,
  IconChartDots2: IconChartDots2,
  IconChartDots2Filled: IconChartDots2Filled,
  IconChartDots3: IconChartDots3,
  IconChartDots3Filled: IconChartDots3Filled,
  IconChartDotsFilled: IconChartDotsFilled,
  IconChartFunnel: IconChartFunnel,
  IconChartFunnelFilled: IconChartFunnelFilled,
  IconChartGridDots: IconChartGridDots,
  IconChartGridDotsFilled: IconChartGridDotsFilled,
  IconChartHistogram: IconChartHistogram,
  IconChartInfographic: IconChartInfographic,
  IconChartLine: IconChartLine,
  IconChartPie: IconChartPie,
  IconChartPie2: IconChartPie2,
  IconChartPie2Filled: IconChartPie2Filled,
  IconChartPie3: IconChartPie3,
  IconChartPie3Filled: IconChartPie3Filled,
  IconChartPie4: IconChartPie4,
  IconChartPie4Filled: IconChartPie4Filled,
  IconChartPieFilled: IconChartPieFilled,
  IconChartPieOff: IconChartPieOff,
  IconChartPpf: IconChartPpf,
  IconChartRadar: IconChartRadar,
  IconChartSankey: IconChartSankey,
  IconChartScatter: IconChartScatter,
  IconChartScatter3d: IconChartScatter3d,
  IconChartTreemap: IconChartTreemap,
  IconCheck: IconCheck,
  IconCheckbox: IconCheckbox,
  IconChecklist: IconChecklist,
  IconChecks: IconChecks,
  IconCheckupList: IconCheckupList,
  IconCheese: IconCheese,
  IconChefHat: IconChefHat,
  IconChefHatFilled: IconChefHatFilled,
  IconChefHatOff: IconChefHatOff,
  IconCherry: IconCherry,
  IconCherryFilled: IconCherryFilled,
  IconChess: IconChess,
  IconChessBishop: IconChessBishop,
  IconChessBishopFilled: IconChessBishopFilled,
  IconChessFilled: IconChessFilled,
  IconChessKing: IconChessKing,
  IconChessKingFilled: IconChessKingFilled,
  IconChessKnight: IconChessKnight,
  IconChessKnightFilled: IconChessKnightFilled,
  IconChessQueen: IconChessQueen,
  IconChessQueenFilled: IconChessQueenFilled,
  IconChessRook: IconChessRook,
  IconChessRookFilled: IconChessRookFilled,
  IconChevronCompactDown: IconChevronCompactDown,
  IconChevronCompactLeft: IconChevronCompactLeft,
  IconChevronCompactRight: IconChevronCompactRight,
  IconChevronCompactUp: IconChevronCompactUp,
  IconChevronDown: IconChevronDown,
  IconChevronDownLeft: IconChevronDownLeft,
  IconChevronDownRight: IconChevronDownRight,
  IconChevronLeft: IconChevronLeft,
  IconChevronLeftPipe: IconChevronLeftPipe,
  IconChevronRight: IconChevronRight,
  IconChevronRightPipe: IconChevronRightPipe,
  IconChevronUp: IconChevronUp,
  IconChevronUpLeft: IconChevronUpLeft,
  IconChevronUpRight: IconChevronUpRight,
  IconChevronsDown: IconChevronsDown,
  IconChevronsDownLeft: IconChevronsDownLeft,
  IconChevronsDownRight: IconChevronsDownRight,
  IconChevronsLeft: IconChevronsLeft,
  IconChevronsRight: IconChevronsRight,
  IconChevronsUp: IconChevronsUp,
  IconChevronsUpLeft: IconChevronsUpLeft,
  IconChevronsUpRight: IconChevronsUpRight,
  IconChisel: IconChisel,
  IconChristmasBall: IconChristmasBall,
  IconChristmasTree: IconChristmasTree,
  IconChristmasTreeFilled: IconChristmasTreeFilled,
  IconChristmasTreeOff: IconChristmasTreeOff,
  IconCircle: IconCircle,
  IconCircleArrowDown: IconCircleArrowDown,
  IconCircleArrowDownFilled: IconCircleArrowDownFilled,
  IconCircleArrowDownLeft: IconCircleArrowDownLeft,
  IconCircleArrowDownLeftFilled: IconCircleArrowDownLeftFilled,
  IconCircleArrowDownRight: IconCircleArrowDownRight,
  IconCircleArrowDownRightFilled: IconCircleArrowDownRightFilled,
  IconCircleArrowLeft: IconCircleArrowLeft,
  IconCircleArrowLeftFilled: IconCircleArrowLeftFilled,
  IconCircleArrowRight: IconCircleArrowRight,
  IconCircleArrowRightFilled: IconCircleArrowRightFilled,
  IconCircleArrowUp: IconCircleArrowUp,
  IconCircleArrowUpFilled: IconCircleArrowUpFilled,
  IconCircleArrowUpLeft: IconCircleArrowUpLeft,
  IconCircleArrowUpLeftFilled: IconCircleArrowUpLeftFilled,
  IconCircleArrowUpRight: IconCircleArrowUpRight,
  IconCircleArrowUpRightFilled: IconCircleArrowUpRightFilled,
  IconCircleCaretDown: IconCircleCaretDown,
  IconCircleCaretDownFilled: IconCircleCaretDownFilled,
  IconCircleCaretLeft: IconCircleCaretLeft,
  IconCircleCaretLeftFilled: IconCircleCaretLeftFilled,
  IconCircleCaretRight: IconCircleCaretRight,
  IconCircleCaretRightFilled: IconCircleCaretRightFilled,
  IconCircleCaretUp: IconCircleCaretUp,
  IconCircleCaretUpFilled: IconCircleCaretUpFilled,
  IconCircleCheck: IconCircleCheck,
  IconCircleCheckFilled: IconCircleCheckFilled,
  IconCircleChevronDown: IconCircleChevronDown,
  IconCircleChevronDownFilled: IconCircleChevronDownFilled,
  IconCircleChevronLeft: IconCircleChevronLeft,
  IconCircleChevronLeftFilled: IconCircleChevronLeftFilled,
  IconCircleChevronRight: IconCircleChevronRight,
  IconCircleChevronRightFilled: IconCircleChevronRightFilled,
  IconCircleChevronUp: IconCircleChevronUp,
  IconCircleChevronUpFilled: IconCircleChevronUpFilled,
  IconCircleChevronsDown: IconCircleChevronsDown,
  IconCircleChevronsDownFilled: IconCircleChevronsDownFilled,
  IconCircleChevronsLeft: IconCircleChevronsLeft,
  IconCircleChevronsLeftFilled: IconCircleChevronsLeftFilled,
  IconCircleChevronsRight: IconCircleChevronsRight,
  IconCircleChevronsRightFilled: IconCircleChevronsRightFilled,
  IconCircleChevronsUp: IconCircleChevronsUp,
  IconCircleChevronsUpFilled: IconCircleChevronsUpFilled,
  IconCircleDashed: IconCircleDashed,
  IconCircleDashedCheck: IconCircleDashedCheck,
  IconCircleDashedLetterA: IconCircleDashedLetterA,
  IconCircleDashedLetterB: IconCircleDashedLetterB,
  IconCircleDashedLetterC: IconCircleDashedLetterC,
  IconCircleDashedLetterD: IconCircleDashedLetterD,
  IconCircleDashedLetterE: IconCircleDashedLetterE,
  IconCircleDashedLetterF: IconCircleDashedLetterF,
  IconCircleDashedLetterG: IconCircleDashedLetterG,
  IconCircleDashedLetterH: IconCircleDashedLetterH,
  IconCircleDashedLetterI: IconCircleDashedLetterI,
  IconCircleDashedLetterJ: IconCircleDashedLetterJ,
  IconCircleDashedLetterK: IconCircleDashedLetterK,
  IconCircleDashedLetterL: IconCircleDashedLetterL,
  IconCircleDashedLetterM: IconCircleDashedLetterM,
  IconCircleDashedLetterN: IconCircleDashedLetterN,
  IconCircleDashedLetterO: IconCircleDashedLetterO,
  IconCircleDashedLetterP: IconCircleDashedLetterP,
  IconCircleDashedLetterQ: IconCircleDashedLetterQ,
  IconCircleDashedLetterR: IconCircleDashedLetterR,
  IconCircleDashedLetterS: IconCircleDashedLetterS,
  IconCircleDashedLetterT: IconCircleDashedLetterT,
  IconCircleDashedLetterU: IconCircleDashedLetterU,
  IconCircleDashedLetterV: IconCircleDashedLetterV,
  IconCircleDashedLetterW: IconCircleDashedLetterW,
  IconCircleDashedLetterX: IconCircleDashedLetterX,
  IconCircleDashedLetterY: IconCircleDashedLetterY,
  IconCircleDashedLetterZ: IconCircleDashedLetterZ,
  IconCircleDashedMinus: IconCircleDashedMinus,
  IconCircleDashedNumber0: IconCircleDashedNumber0,
  IconCircleDashedNumber1: IconCircleDashedNumber1,
  IconCircleDashedNumber2: IconCircleDashedNumber2,
  IconCircleDashedNumber3: IconCircleDashedNumber3,
  IconCircleDashedNumber4: IconCircleDashedNumber4,
  IconCircleDashedNumber5: IconCircleDashedNumber5,
  IconCircleDashedNumber6: IconCircleDashedNumber6,
  IconCircleDashedNumber7: IconCircleDashedNumber7,
  IconCircleDashedNumber8: IconCircleDashedNumber8,
  IconCircleDashedNumber9: IconCircleDashedNumber9,
  IconCircleDashedPercentage: IconCircleDashedPercentage,
  IconCircleDashedPlus: IconCircleDashedPlus,
  IconCircleDashedX: IconCircleDashedX,
  IconCircleDot: IconCircleDot,
  IconCircleDotFilled: IconCircleDotFilled,
  IconCircleDotted: IconCircleDotted,
  IconCircleDottedLetterA: IconCircleDottedLetterA,
  IconCircleDottedLetterB: IconCircleDottedLetterB,
  IconCircleDottedLetterC: IconCircleDottedLetterC,
  IconCircleDottedLetterD: IconCircleDottedLetterD,
  IconCircleDottedLetterE: IconCircleDottedLetterE,
  IconCircleDottedLetterF: IconCircleDottedLetterF,
  IconCircleDottedLetterG: IconCircleDottedLetterG,
  IconCircleDottedLetterH: IconCircleDottedLetterH,
  IconCircleDottedLetterI: IconCircleDottedLetterI,
  IconCircleDottedLetterJ: IconCircleDottedLetterJ,
  IconCircleDottedLetterK: IconCircleDottedLetterK,
  IconCircleDottedLetterL: IconCircleDottedLetterL,
  IconCircleDottedLetterM: IconCircleDottedLetterM,
  IconCircleDottedLetterN: IconCircleDottedLetterN,
  IconCircleDottedLetterO: IconCircleDottedLetterO,
  IconCircleDottedLetterP: IconCircleDottedLetterP,
  IconCircleDottedLetterQ: IconCircleDottedLetterQ,
  IconCircleDottedLetterR: IconCircleDottedLetterR,
  IconCircleDottedLetterS: IconCircleDottedLetterS,
  IconCircleDottedLetterT: IconCircleDottedLetterT,
  IconCircleDottedLetterU: IconCircleDottedLetterU,
  IconCircleDottedLetterV: IconCircleDottedLetterV,
  IconCircleDottedLetterW: IconCircleDottedLetterW,
  IconCircleDottedLetterX: IconCircleDottedLetterX,
  IconCircleDottedLetterY: IconCircleDottedLetterY,
  IconCircleDottedLetterZ: IconCircleDottedLetterZ,
  IconCircleFilled: IconCircleFilled,
  IconCircleHalf: IconCircleHalf,
  IconCircleHalf2: IconCircleHalf2,
  IconCircleHalfVertical: IconCircleHalfVertical,
  IconCircleKey: IconCircleKey,
  IconCircleKeyFilled: IconCircleKeyFilled,
  IconCircleLetterA: IconCircleLetterA,
  IconCircleLetterAFilled: IconCircleLetterAFilled,
  IconCircleLetterB: IconCircleLetterB,
  IconCircleLetterBFilled: IconCircleLetterBFilled,
  IconCircleLetterC: IconCircleLetterC,
  IconCircleLetterCFilled: IconCircleLetterCFilled,
  IconCircleLetterD: IconCircleLetterD,
  IconCircleLetterDFilled: IconCircleLetterDFilled,
  IconCircleLetterE: IconCircleLetterE,
  IconCircleLetterEFilled: IconCircleLetterEFilled,
  IconCircleLetterF: IconCircleLetterF,
  IconCircleLetterFFilled: IconCircleLetterFFilled,
  IconCircleLetterG: IconCircleLetterG,
  IconCircleLetterGFilled: IconCircleLetterGFilled,
  IconCircleLetterH: IconCircleLetterH,
  IconCircleLetterHFilled: IconCircleLetterHFilled,
  IconCircleLetterI: IconCircleLetterI,
  IconCircleLetterIFilled: IconCircleLetterIFilled,
  IconCircleLetterJ: IconCircleLetterJ,
  IconCircleLetterJFilled: IconCircleLetterJFilled,
  IconCircleLetterK: IconCircleLetterK,
  IconCircleLetterKFilled: IconCircleLetterKFilled,
  IconCircleLetterL: IconCircleLetterL,
  IconCircleLetterLFilled: IconCircleLetterLFilled,
  IconCircleLetterM: IconCircleLetterM,
  IconCircleLetterMFilled: IconCircleLetterMFilled,
  IconCircleLetterN: IconCircleLetterN,
  IconCircleLetterNFilled: IconCircleLetterNFilled,
  IconCircleLetterO: IconCircleLetterO,
  IconCircleLetterOFilled: IconCircleLetterOFilled,
  IconCircleLetterP: IconCircleLetterP,
  IconCircleLetterPFilled: IconCircleLetterPFilled,
  IconCircleLetterQ: IconCircleLetterQ,
  IconCircleLetterQFilled: IconCircleLetterQFilled,
  IconCircleLetterR: IconCircleLetterR,
  IconCircleLetterRFilled: IconCircleLetterRFilled,
  IconCircleLetterS: IconCircleLetterS,
  IconCircleLetterSFilled: IconCircleLetterSFilled,
  IconCircleLetterT: IconCircleLetterT,
  IconCircleLetterTFilled: IconCircleLetterTFilled,
  IconCircleLetterU: IconCircleLetterU,
  IconCircleLetterUFilled: IconCircleLetterUFilled,
  IconCircleLetterV: IconCircleLetterV,
  IconCircleLetterVFilled: IconCircleLetterVFilled,
  IconCircleLetterW: IconCircleLetterW,
  IconCircleLetterWFilled: IconCircleLetterWFilled,
  IconCircleLetterX: IconCircleLetterX,
  IconCircleLetterXFilled: IconCircleLetterXFilled,
  IconCircleLetterY: IconCircleLetterY,
  IconCircleLetterYFilled: IconCircleLetterYFilled,
  IconCircleLetterZ: IconCircleLetterZ,
  IconCircleLetterZFilled: IconCircleLetterZFilled,
  IconCircleMinus: IconCircleMinus,
  IconCircleMinus2: IconCircleMinus2,
  IconCircleNumber0: IconCircleNumber0,
  IconCircleNumber0Filled: IconCircleNumber0Filled,
  IconCircleNumber1: IconCircleNumber1,
  IconCircleNumber1Filled: IconCircleNumber1Filled,
  IconCircleNumber2: IconCircleNumber2,
  IconCircleNumber2Filled: IconCircleNumber2Filled,
  IconCircleNumber3: IconCircleNumber3,
  IconCircleNumber3Filled: IconCircleNumber3Filled,
  IconCircleNumber4: IconCircleNumber4,
  IconCircleNumber4Filled: IconCircleNumber4Filled,
  IconCircleNumber5: IconCircleNumber5,
  IconCircleNumber5Filled: IconCircleNumber5Filled,
  IconCircleNumber6: IconCircleNumber6,
  IconCircleNumber6Filled: IconCircleNumber6Filled,
  IconCircleNumber7: IconCircleNumber7,
  IconCircleNumber7Filled: IconCircleNumber7Filled,
  IconCircleNumber8: IconCircleNumber8,
  IconCircleNumber8Filled: IconCircleNumber8Filled,
  IconCircleNumber9: IconCircleNumber9,
  IconCircleNumber9Filled: IconCircleNumber9Filled,
  IconCircleOff: IconCircleOff,
  IconCirclePercentage: IconCirclePercentage,
  IconCirclePercentageFilled: IconCirclePercentageFilled,
  IconCirclePlus: IconCirclePlus,
  IconCirclePlus2: IconCirclePlus2,
  IconCirclePlusFilled: IconCirclePlusFilled,
  IconCircleRectangle: IconCircleRectangle,
  IconCircleRectangleFilled: IconCircleRectangleFilled,
  IconCircleRectangleOff: IconCircleRectangleOff,
  IconCircleSquare: IconCircleSquare,
  IconCircleTriangle: IconCircleTriangle,
  IconCircleX: IconCircleX,
  IconCircleXFilled: IconCircleXFilled,
  IconCircles: IconCircles,
  IconCirclesFilled: IconCirclesFilled,
  IconCirclesRelation: IconCirclesRelation,
  IconCircuitAmmeter: IconCircuitAmmeter,
  IconCircuitBattery: IconCircuitBattery,
  IconCircuitBulb: IconCircuitBulb,
  IconCircuitCapacitor: IconCircuitCapacitor,
  IconCircuitCapacitorPolarized: IconCircuitCapacitorPolarized,
  IconCircuitCell: IconCircuitCell,
  IconCircuitCellPlus: IconCircuitCellPlus,
  IconCircuitChangeover: IconCircuitChangeover,
  IconCircuitDiode: IconCircuitDiode,
  IconCircuitDiodeZener: IconCircuitDiodeZener,
  IconCircuitGround: IconCircuitGround,
  IconCircuitGroundDigital: IconCircuitGroundDigital,
  IconCircuitInductor: IconCircuitInductor,
  IconCircuitMotor: IconCircuitMotor,
  IconCircuitPushbutton: IconCircuitPushbutton,
  IconCircuitResistor: IconCircuitResistor,
  IconCircuitSwitchClosed: IconCircuitSwitchClosed,
  IconCircuitSwitchOpen: IconCircuitSwitchOpen,
  IconCircuitVoltmeter: IconCircuitVoltmeter,
  IconClearAll: IconClearAll,
  IconClearFormatting: IconClearFormatting,
  IconClick: IconClick,
  IconCliffJumping: IconCliffJumping,
  IconClipboard: IconClipboard,
  IconClipboardCheck: IconClipboardCheck,
  IconClipboardCheckFilled: IconClipboardCheckFilled,
  IconClipboardCopy: IconClipboardCopy,
  IconClipboardData: IconClipboardData,
  IconClipboardDataFilled: IconClipboardDataFilled,
  IconClipboardFilled: IconClipboardFilled,
  IconClipboardHeart: IconClipboardHeart,
  IconClipboardList: IconClipboardList,
  IconClipboardListFilled: IconClipboardListFilled,
  IconClipboardOff: IconClipboardOff,
  IconClipboardPlus: IconClipboardPlus,
  IconClipboardSearch: IconClipboardSearch,
  IconClipboardSmile: IconClipboardSmile,
  IconClipboardText: IconClipboardText,
  IconClipboardTextFilled: IconClipboardTextFilled,
  IconClipboardTypography: IconClipboardTypography,
  IconClipboardTypographyFilled: IconClipboardTypographyFilled,
  IconClipboardX: IconClipboardX,
  IconClipboardXFilled: IconClipboardXFilled,
  IconClock: IconClock,
  IconClock12: IconClock12,
  IconClock2: IconClock2,
  IconClock24: IconClock24,
  IconClockBitcoin: IconClockBitcoin,
  IconClockBolt: IconClockBolt,
  IconClockCancel: IconClockCancel,
  IconClockCheck: IconClockCheck,
  IconClockCode: IconClockCode,
  IconClockCog: IconClockCog,
  IconClockDollar: IconClockDollar,
  IconClockDown: IconClockDown,
  IconClockEdit: IconClockEdit,
  IconClockExclamation: IconClockExclamation,
  IconClockFilled: IconClockFilled,
  IconClockHeart: IconClockHeart,
  IconClockHour1: IconClockHour1,
  IconClockHour10: IconClockHour10,
  IconClockHour10Filled: IconClockHour10Filled,
  IconClockHour11: IconClockHour11,
  IconClockHour11Filled: IconClockHour11Filled,
  IconClockHour12: IconClockHour12,
  IconClockHour12Filled: IconClockHour12Filled,
  IconClockHour1Filled: IconClockHour1Filled,
  IconClockHour2: IconClockHour2,
  IconClockHour2Filled: IconClockHour2Filled,
  IconClockHour3: IconClockHour3,
  IconClockHour3Filled: IconClockHour3Filled,
  IconClockHour4: IconClockHour4,
  IconClockHour4Filled: IconClockHour4Filled,
  IconClockHour5: IconClockHour5,
  IconClockHour5Filled: IconClockHour5Filled,
  IconClockHour6: IconClockHour6,
  IconClockHour6Filled: IconClockHour6Filled,
  IconClockHour7: IconClockHour7,
  IconClockHour7Filled: IconClockHour7Filled,
  IconClockHour8: IconClockHour8,
  IconClockHour8Filled: IconClockHour8Filled,
  IconClockHour9: IconClockHour9,
  IconClockHour9Filled: IconClockHour9Filled,
  IconClockMinus: IconClockMinus,
  IconClockOff: IconClockOff,
  IconClockPause: IconClockPause,
  IconClockPin: IconClockPin,
  IconClockPlay: IconClockPlay,
  IconClockPlus: IconClockPlus,
  IconClockQuestion: IconClockQuestion,
  IconClockRecord: IconClockRecord,
  IconClockSearch: IconClockSearch,
  IconClockShare: IconClockShare,
  IconClockShield: IconClockShield,
  IconClockStar: IconClockStar,
  IconClockStop: IconClockStop,
  IconClockUp: IconClockUp,
  IconClockX: IconClockX,
  IconClothesRack: IconClothesRack,
  IconClothesRackOff: IconClothesRackOff,
  IconCloud: IconCloud,
  IconCloudBitcoin: IconCloudBitcoin,
  IconCloudBolt: IconCloudBolt,
  IconCloudCancel: IconCloudCancel,
  IconCloudCheck: IconCloudCheck,
  IconCloudCode: IconCloudCode,
  IconCloudCog: IconCloudCog,
  IconCloudComputing: IconCloudComputing,
  IconCloudComputingFilled: IconCloudComputingFilled,
  IconCloudDataConnection: IconCloudDataConnection,
  IconCloudDataConnectionFilled: IconCloudDataConnectionFilled,
  IconCloudDollar: IconCloudDollar,
  IconCloudDown: IconCloudDown,
  IconCloudDownload: IconCloudDownload,
  IconCloudExclamation: IconCloudExclamation,
  IconCloudFilled: IconCloudFilled,
  IconCloudFog: IconCloudFog,
  IconCloudHeart: IconCloudHeart,
  IconCloudLock: IconCloudLock,
  IconCloudLockOpen: IconCloudLockOpen,
  IconCloudMinus: IconCloudMinus,
  IconCloudNetwork: IconCloudNetwork,
  IconCloudOff: IconCloudOff,
  IconCloudPause: IconCloudPause,
  IconCloudPin: IconCloudPin,
  IconCloudPlus: IconCloudPlus,
  IconCloudQuestion: IconCloudQuestion,
  IconCloudRain: IconCloudRain,
  IconCloudSearch: IconCloudSearch,
  IconCloudShare: IconCloudShare,
  IconCloudSnow: IconCloudSnow,
  IconCloudStar: IconCloudStar,
  IconCloudStorm: IconCloudStorm,
  IconCloudUp: IconCloudUp,
  IconCloudUpload: IconCloudUpload,
  IconCloudX: IconCloudX,
  IconClover: IconClover,
  IconClover2: IconClover2,
  IconCloverFilled: IconCloverFilled,
  IconClubs: IconClubs,
  IconClubsFilled: IconClubsFilled,
  IconCode: IconCode,
  IconCodeAsterisk: IconCodeAsterisk,
  IconCodeCircle: IconCodeCircle,
  IconCodeCircle2: IconCodeCircle2,
  IconCodeCircle2Filled: IconCodeCircle2Filled,
  IconCodeCircleFilled: IconCodeCircleFilled,
  IconCodeDots: IconCodeDots,
  IconCodeMinus: IconCodeMinus,
  IconCodeOff: IconCodeOff,
  IconCodePlus: IconCodePlus,
  IconCodeVariable: IconCodeVariable,
  IconCodeVariableMinus: IconCodeVariableMinus,
  IconCodeVariablePlus: IconCodeVariablePlus,
  IconCoffee: IconCoffee,
  IconCoffeeOff: IconCoffeeOff,
  IconCoffin: IconCoffin,
  IconCoin: IconCoin,
  IconCoinBitcoin: IconCoinBitcoin,
  IconCoinBitcoinFilled: IconCoinBitcoinFilled,
  IconCoinEuro: IconCoinEuro,
  IconCoinEuroFilled: IconCoinEuroFilled,
  IconCoinFilled: IconCoinFilled,
  IconCoinMonero: IconCoinMonero,
  IconCoinMoneroFilled: IconCoinMoneroFilled,
  IconCoinOff: IconCoinOff,
  IconCoinPound: IconCoinPound,
  IconCoinPoundFilled: IconCoinPoundFilled,
  IconCoinRupee: IconCoinRupee,
  IconCoinRupeeFilled: IconCoinRupeeFilled,
  IconCoinTaka: IconCoinTaka,
  IconCoinTakaFilled: IconCoinTakaFilled,
  IconCoinYen: IconCoinYen,
  IconCoinYenFilled: IconCoinYenFilled,
  IconCoinYuan: IconCoinYuan,
  IconCoinYuanFilled: IconCoinYuanFilled,
  IconCoins: IconCoins,
  IconColorFilter: IconColorFilter,
  IconColorPicker: IconColorPicker,
  IconColorPickerOff: IconColorPickerOff,
  IconColorSwatch: IconColorSwatch,
  IconColorSwatchOff: IconColorSwatchOff,
  IconColumnInsertLeft: IconColumnInsertLeft,
  IconColumnInsertRight: IconColumnInsertRight,
  IconColumnRemove: IconColumnRemove,
  IconColumns: IconColumns,
  IconColumns1: IconColumns1,
  IconColumns2: IconColumns2,
  IconColumns3: IconColumns3,
  IconColumnsOff: IconColumnsOff,
  IconComet: IconComet,
  IconCommand: IconCommand,
  IconCommandOff: IconCommandOff,
  IconCompass: IconCompass,
  IconCompassFilled: IconCompassFilled,
  IconCompassOff: IconCompassOff,
  IconComponents: IconComponents,
  IconComponentsOff: IconComponentsOff,
  IconCone: IconCone,
  IconCone2: IconCone2,
  IconCone2Filled: IconCone2Filled,
  IconConeFilled: IconConeFilled,
  IconConeOff: IconConeOff,
  IconConePlus: IconConePlus,
  IconConfetti: IconConfetti,
  IconConfettiOff: IconConfettiOff,
  IconConfucius: IconConfucius,
  IconCongruentTo: IconCongruentTo,
  IconContainer: IconContainer,
  IconContainerOff: IconContainerOff,
  IconContract: IconContract,
  IconContrast: IconContrast,
  IconContrast2: IconContrast2,
  IconContrast2Filled: IconContrast2Filled,
  IconContrast2Off: IconContrast2Off,
  IconContrastFilled: IconContrastFilled,
  IconContrastOff: IconContrastOff,
  IconCooker: IconCooker,
  IconCookie: IconCookie,
  IconCookieFilled: IconCookieFilled,
  IconCookieMan: IconCookieMan,
  IconCookieManFilled: IconCookieManFilled,
  IconCookieOff: IconCookieOff,
  IconCopy: IconCopy,
  IconCopyCheck: IconCopyCheck,
  IconCopyCheckFilled: IconCopyCheckFilled,
  IconCopyMinus: IconCopyMinus,
  IconCopyMinusFilled: IconCopyMinusFilled,
  IconCopyOff: IconCopyOff,
  IconCopyPlus: IconCopyPlus,
  IconCopyPlusFilled: IconCopyPlusFilled,
  IconCopyX: IconCopyX,
  IconCopyXFilled: IconCopyXFilled,
  IconCopyleft: IconCopyleft,
  IconCopyleftFilled: IconCopyleftFilled,
  IconCopyleftOff: IconCopyleftOff,
  IconCopyright: IconCopyright,
  IconCopyrightFilled: IconCopyrightFilled,
  IconCopyrightOff: IconCopyrightOff,
  IconCornerDownLeft: IconCornerDownLeft,
  IconCornerDownLeftDouble: IconCornerDownLeftDouble,
  IconCornerDownRight: IconCornerDownRight,
  IconCornerDownRightDouble: IconCornerDownRightDouble,
  IconCornerLeftDown: IconCornerLeftDown,
  IconCornerLeftDownDouble: IconCornerLeftDownDouble,
  IconCornerLeftUp: IconCornerLeftUp,
  IconCornerLeftUpDouble: IconCornerLeftUpDouble,
  IconCornerRightDown: IconCornerRightDown,
  IconCornerRightDownDouble: IconCornerRightDownDouble,
  IconCornerRightUp: IconCornerRightUp,
  IconCornerRightUpDouble: IconCornerRightUpDouble,
  IconCornerUpLeft: IconCornerUpLeft,
  IconCornerUpLeftDouble: IconCornerUpLeftDouble,
  IconCornerUpRight: IconCornerUpRight,
  IconCornerUpRightDouble: IconCornerUpRightDouble,
  IconCpu: IconCpu,
  IconCpu2: IconCpu2,
  IconCpuOff: IconCpuOff,
  IconCrane: IconCrane,
  IconCraneOff: IconCraneOff,
  IconCreativeCommons: IconCreativeCommons,
  IconCreativeCommonsBy: IconCreativeCommonsBy,
  IconCreativeCommonsNc: IconCreativeCommonsNc,
  IconCreativeCommonsNd: IconCreativeCommonsNd,
  IconCreativeCommonsOff: IconCreativeCommonsOff,
  IconCreativeCommonsSa: IconCreativeCommonsSa,
  IconCreativeCommonsZero: IconCreativeCommonsZero,
  IconCreditCard: IconCreditCard,
  IconCreditCardFilled: IconCreditCardFilled,
  IconCreditCardOff: IconCreditCardOff,
  IconCreditCardPay: IconCreditCardPay,
  IconCreditCardRefund: IconCreditCardRefund,
  IconCricket: IconCricket,
  IconCrop: IconCrop,
  IconCrop11: IconCrop11,
  IconCrop11Filled: IconCrop11Filled,
  IconCrop169: IconCrop169,
  IconCrop169Filled: IconCrop169Filled,
  IconCrop32: IconCrop32,
  IconCrop32Filled: IconCrop32Filled,
  IconCrop54: IconCrop54,
  IconCrop54Filled: IconCrop54Filled,
  IconCrop75: IconCrop75,
  IconCrop75Filled: IconCrop75Filled,
  IconCropLandscape: IconCropLandscape,
  IconCropLandscapeFilled: IconCropLandscapeFilled,
  IconCropPortrait: IconCropPortrait,
  IconCropPortraitFilled: IconCropPortraitFilled,
  IconCross: IconCross,
  IconCrossFilled: IconCrossFilled,
  IconCrossOff: IconCrossOff,
  IconCrosshair: IconCrosshair,
  IconCrown: IconCrown,
  IconCrownOff: IconCrownOff,
  IconCrutches: IconCrutches,
  IconCrutchesOff: IconCrutchesOff,
  IconCrystalBall: IconCrystalBall,
  IconCsv: IconCsv,
  IconCube: IconCube,
  IconCube3dSphere: IconCube3dSphere,
  IconCube3dSphereOff: IconCube3dSphereOff,
  IconCubeOff: IconCubeOff,
  IconCubePlus: IconCubePlus,
  IconCubeSend: IconCubeSend,
  IconCubeSpark: IconCubeSpark,
  IconCubeUnfolded: IconCubeUnfolded,
  IconCup: IconCup,
  IconCupOff: IconCupOff,
  IconCurling: IconCurling,
  IconCurlyLoop: IconCurlyLoop,
  IconCurrency: IconCurrency,
  IconCurrencyAfghani: IconCurrencyAfghani,
  IconCurrencyBahraini: IconCurrencyBahraini,
  IconCurrencyBaht: IconCurrencyBaht,
  IconCurrencyBitcoin: IconCurrencyBitcoin,
  IconCurrencyCent: IconCurrencyCent,
  IconCurrencyDinar: IconCurrencyDinar,
  IconCurrencyDirham: IconCurrencyDirham,
  IconCurrencyDogecoin: IconCurrencyDogecoin,
  IconCurrencyDollar: IconCurrencyDollar,
  IconCurrencyDollarAustralian: IconCurrencyDollarAustralian,
  IconCurrencyDollarBrunei: IconCurrencyDollarBrunei,
  IconCurrencyDollarCanadian: IconCurrencyDollarCanadian,
  IconCurrencyDollarGuyanese: IconCurrencyDollarGuyanese,
  IconCurrencyDollarOff: IconCurrencyDollarOff,
  IconCurrencyDollarSingapore: IconCurrencyDollarSingapore,
  IconCurrencyDollarZimbabwean: IconCurrencyDollarZimbabwean,
  IconCurrencyDong: IconCurrencyDong,
  IconCurrencyDram: IconCurrencyDram,
  IconCurrencyEthereum: IconCurrencyEthereum,
  IconCurrencyEuro: IconCurrencyEuro,
  IconCurrencyEuroOff: IconCurrencyEuroOff,
  IconCurrencyFlorin: IconCurrencyFlorin,
  IconCurrencyForint: IconCurrencyForint,
  IconCurrencyFrank: IconCurrencyFrank,
  IconCurrencyGuarani: IconCurrencyGuarani,
  IconCurrencyHryvnia: IconCurrencyHryvnia,
  IconCurrencyIranianRial: IconCurrencyIranianRial,
  IconCurrencyKip: IconCurrencyKip,
  IconCurrencyKroneCzech: IconCurrencyKroneCzech,
  IconCurrencyKroneDanish: IconCurrencyKroneDanish,
  IconCurrencyKroneSwedish: IconCurrencyKroneSwedish,
  IconCurrencyLari: IconCurrencyLari,
  IconCurrencyLeu: IconCurrencyLeu,
  IconCurrencyLira: IconCurrencyLira,
  IconCurrencyLitecoin: IconCurrencyLitecoin,
  IconCurrencyLyd: IconCurrencyLyd,
  IconCurrencyManat: IconCurrencyManat,
  IconCurrencyMonero: IconCurrencyMonero,
  IconCurrencyNaira: IconCurrencyNaira,
  IconCurrencyNano: IconCurrencyNano,
  IconCurrencyOff: IconCurrencyOff,
  IconCurrencyPaanga: IconCurrencyPaanga,
  IconCurrencyPeso: IconCurrencyPeso,
  IconCurrencyPound: IconCurrencyPound,
  IconCurrencyPoundOff: IconCurrencyPoundOff,
  IconCurrencyQuetzal: IconCurrencyQuetzal,
  IconCurrencyReal: IconCurrencyReal,
  IconCurrencyRenminbi: IconCurrencyRenminbi,
  IconCurrencyRipple: IconCurrencyRipple,
  IconCurrencyRiyal: IconCurrencyRiyal,
  IconCurrencyRubel: IconCurrencyRubel,
  IconCurrencyRufiyaa: IconCurrencyRufiyaa,
  IconCurrencyRupee: IconCurrencyRupee,
  IconCurrencyRupeeNepalese: IconCurrencyRupeeNepalese,
  IconCurrencyShekel: IconCurrencyShekel,
  IconCurrencySolana: IconCurrencySolana,
  IconCurrencySom: IconCurrencySom,
  IconCurrencyTaka: IconCurrencyTaka,
  IconCurrencyTenge: IconCurrencyTenge,
  IconCurrencyTugrik: IconCurrencyTugrik,
  IconCurrencyWon: IconCurrencyWon,
  IconCurrencyXrp: IconCurrencyXrp,
  IconCurrencyYen: IconCurrencyYen,
  IconCurrencyYenOff: IconCurrencyYenOff,
  IconCurrencyYuan: IconCurrencyYuan,
  IconCurrencyZloty: IconCurrencyZloty,
  IconCurrentLocation: IconCurrentLocation,
  IconCurrentLocationFilled: IconCurrentLocationFilled,
  IconCurrentLocationOff: IconCurrentLocationOff,
  IconCursorOff: IconCursorOff,
  IconCursorText: IconCursorText,
  IconCut: IconCut,
  IconCylinder: IconCylinder,
  IconCylinderOff: IconCylinderOff,
  IconCylinderPlus: IconCylinderPlus,
  IconDashboard: IconDashboard,
  IconDashboardFilled: IconDashboardFilled,
  IconDashboardOff: IconDashboardOff,
  IconDatabase: IconDatabase,
  IconDatabaseCog: IconDatabaseCog,
  IconDatabaseDollar: IconDatabaseDollar,
  IconDatabaseEdit: IconDatabaseEdit,
  IconDatabaseExclamation: IconDatabaseExclamation,
  IconDatabaseExport: IconDatabaseExport,
  IconDatabaseHeart: IconDatabaseHeart,
  IconDatabaseImport: IconDatabaseImport,
  IconDatabaseLeak: IconDatabaseLeak,
  IconDatabaseMinus: IconDatabaseMinus,
  IconDatabaseOff: IconDatabaseOff,
  IconDatabasePlus: IconDatabasePlus,
  IconDatabaseSearch: IconDatabaseSearch,
  IconDatabaseShare: IconDatabaseShare,
  IconDatabaseSmile: IconDatabaseSmile,
  IconDatabaseStar: IconDatabaseStar,
  IconDatabaseX: IconDatabaseX,
  IconDecimal: IconDecimal,
  IconDeer: IconDeer,
  IconDelta: IconDelta,
  IconDental: IconDental,
  IconDentalBroken: IconDentalBroken,
  IconDentalOff: IconDentalOff,
  IconDeselect: IconDeselect,
  IconDesk: IconDesk,
  IconDetails: IconDetails,
  IconDetailsOff: IconDetailsOff,
  IconDeviceAirpods: IconDeviceAirpods,
  IconDeviceAirpodsCase: IconDeviceAirpodsCase,
  IconDeviceAirtag: IconDeviceAirtag,
  IconDeviceAnalytics: IconDeviceAnalytics,
  IconDeviceAudioTape: IconDeviceAudioTape,
  IconDeviceCameraPhone: IconDeviceCameraPhone,
  IconDeviceCctv: IconDeviceCctv,
  IconDeviceCctvFilled: IconDeviceCctvFilled,
  IconDeviceCctvOff: IconDeviceCctvOff,
  IconDeviceComputerCamera: IconDeviceComputerCamera,
  IconDeviceComputerCameraOff: IconDeviceComputerCameraOff,
  IconDeviceDesktop: IconDeviceDesktop,
  IconDeviceDesktopAnalytics: IconDeviceDesktopAnalytics,
  IconDeviceDesktopBolt: IconDeviceDesktopBolt,
  IconDeviceDesktopCancel: IconDeviceDesktopCancel,
  IconDeviceDesktopCheck: IconDeviceDesktopCheck,
  IconDeviceDesktopCode: IconDeviceDesktopCode,
  IconDeviceDesktopCog: IconDeviceDesktopCog,
  IconDeviceDesktopDollar: IconDeviceDesktopDollar,
  IconDeviceDesktopDown: IconDeviceDesktopDown,
  IconDeviceDesktopExclamation: IconDeviceDesktopExclamation,
  IconDeviceDesktopFilled: IconDeviceDesktopFilled,
  IconDeviceDesktopHeart: IconDeviceDesktopHeart,
  IconDeviceDesktopMinus: IconDeviceDesktopMinus,
  IconDeviceDesktopOff: IconDeviceDesktopOff,
  IconDeviceDesktopPause: IconDeviceDesktopPause,
  IconDeviceDesktopPin: IconDeviceDesktopPin,
  IconDeviceDesktopPlus: IconDeviceDesktopPlus,
  IconDeviceDesktopQuestion: IconDeviceDesktopQuestion,
  IconDeviceDesktopSearch: IconDeviceDesktopSearch,
  IconDeviceDesktopShare: IconDeviceDesktopShare,
  IconDeviceDesktopStar: IconDeviceDesktopStar,
  IconDeviceDesktopUp: IconDeviceDesktopUp,
  IconDeviceDesktopX: IconDeviceDesktopX,
  IconDeviceFloppy: IconDeviceFloppy,
  IconDeviceGamepad: IconDeviceGamepad,
  IconDeviceGamepad2: IconDeviceGamepad2,
  IconDeviceGamepad3: IconDeviceGamepad3,
  IconDeviceGamepad3Filled: IconDeviceGamepad3Filled,
  IconDeviceHeartMonitor: IconDeviceHeartMonitor,
  IconDeviceHeartMonitorFilled: IconDeviceHeartMonitorFilled,
  IconDeviceImac: IconDeviceImac,
  IconDeviceImacBolt: IconDeviceImacBolt,
  IconDeviceImacCancel: IconDeviceImacCancel,
  IconDeviceImacCheck: IconDeviceImacCheck,
  IconDeviceImacCode: IconDeviceImacCode,
  IconDeviceImacCog: IconDeviceImacCog,
  IconDeviceImacDollar: IconDeviceImacDollar,
  IconDeviceImacDown: IconDeviceImacDown,
  IconDeviceImacExclamation: IconDeviceImacExclamation,
  IconDeviceImacFilled: IconDeviceImacFilled,
  IconDeviceImacHeart: IconDeviceImacHeart,
  IconDeviceImacMinus: IconDeviceImacMinus,
  IconDeviceImacOff: IconDeviceImacOff,
  IconDeviceImacPause: IconDeviceImacPause,
  IconDeviceImacPin: IconDeviceImacPin,
  IconDeviceImacPlus: IconDeviceImacPlus,
  IconDeviceImacQuestion: IconDeviceImacQuestion,
  IconDeviceImacSearch: IconDeviceImacSearch,
  IconDeviceImacShare: IconDeviceImacShare,
  IconDeviceImacStar: IconDeviceImacStar,
  IconDeviceImacUp: IconDeviceImacUp,
  IconDeviceImacX: IconDeviceImacX,
  IconDeviceIpad: IconDeviceIpad,
  IconDeviceIpadBolt: IconDeviceIpadBolt,
  IconDeviceIpadCancel: IconDeviceIpadCancel,
  IconDeviceIpadCheck: IconDeviceIpadCheck,
  IconDeviceIpadCode: IconDeviceIpadCode,
  IconDeviceIpadCog: IconDeviceIpadCog,
  IconDeviceIpadDollar: IconDeviceIpadDollar,
  IconDeviceIpadDown: IconDeviceIpadDown,
  IconDeviceIpadExclamation: IconDeviceIpadExclamation,
  IconDeviceIpadFilled: IconDeviceIpadFilled,
  IconDeviceIpadHeart: IconDeviceIpadHeart,
  IconDeviceIpadHorizontal: IconDeviceIpadHorizontal,
  IconDeviceIpadHorizontalBolt: IconDeviceIpadHorizontalBolt,
  IconDeviceIpadHorizontalCancel: IconDeviceIpadHorizontalCancel,
  IconDeviceIpadHorizontalCheck: IconDeviceIpadHorizontalCheck,
  IconDeviceIpadHorizontalCode: IconDeviceIpadHorizontalCode,
  IconDeviceIpadHorizontalCog: IconDeviceIpadHorizontalCog,
  IconDeviceIpadHorizontalDollar: IconDeviceIpadHorizontalDollar,
  IconDeviceIpadHorizontalDown: IconDeviceIpadHorizontalDown,
  IconDeviceIpadHorizontalExclamation: IconDeviceIpadHorizontalExclamation,
  IconDeviceIpadHorizontalHeart: IconDeviceIpadHorizontalHeart,
  IconDeviceIpadHorizontalMinus: IconDeviceIpadHorizontalMinus,
  IconDeviceIpadHorizontalOff: IconDeviceIpadHorizontalOff,
  IconDeviceIpadHorizontalPause: IconDeviceIpadHorizontalPause,
  IconDeviceIpadHorizontalPin: IconDeviceIpadHorizontalPin,
  IconDeviceIpadHorizontalPlus: IconDeviceIpadHorizontalPlus,
  IconDeviceIpadHorizontalQuestion: IconDeviceIpadHorizontalQuestion,
  IconDeviceIpadHorizontalSearch: IconDeviceIpadHorizontalSearch,
  IconDeviceIpadHorizontalShare: IconDeviceIpadHorizontalShare,
  IconDeviceIpadHorizontalStar: IconDeviceIpadHorizontalStar,
  IconDeviceIpadHorizontalUp: IconDeviceIpadHorizontalUp,
  IconDeviceIpadHorizontalX: IconDeviceIpadHorizontalX,
  IconDeviceIpadMinus: IconDeviceIpadMinus,
  IconDeviceIpadOff: IconDeviceIpadOff,
  IconDeviceIpadPause: IconDeviceIpadPause,
  IconDeviceIpadPin: IconDeviceIpadPin,
  IconDeviceIpadPlus: IconDeviceIpadPlus,
  IconDeviceIpadQuestion: IconDeviceIpadQuestion,
  IconDeviceIpadSearch: IconDeviceIpadSearch,
  IconDeviceIpadShare: IconDeviceIpadShare,
  IconDeviceIpadStar: IconDeviceIpadStar,
  IconDeviceIpadUp: IconDeviceIpadUp,
  IconDeviceIpadX: IconDeviceIpadX,
  IconDeviceLandlinePhone: IconDeviceLandlinePhone,
  IconDeviceLaptop: IconDeviceLaptop,
  IconDeviceLaptopOff: IconDeviceLaptopOff,
  IconDeviceMobile: IconDeviceMobile,
  IconDeviceMobileBolt: IconDeviceMobileBolt,
  IconDeviceMobileCancel: IconDeviceMobileCancel,
  IconDeviceMobileCharging: IconDeviceMobileCharging,
  IconDeviceMobileCheck: IconDeviceMobileCheck,
  IconDeviceMobileCode: IconDeviceMobileCode,
  IconDeviceMobileCog: IconDeviceMobileCog,
  IconDeviceMobileDollar: IconDeviceMobileDollar,
  IconDeviceMobileDown: IconDeviceMobileDown,
  IconDeviceMobileExclamation: IconDeviceMobileExclamation,
  IconDeviceMobileFilled: IconDeviceMobileFilled,
  IconDeviceMobileHeart: IconDeviceMobileHeart,
  IconDeviceMobileMessage: IconDeviceMobileMessage,
  IconDeviceMobileMinus: IconDeviceMobileMinus,
  IconDeviceMobileOff: IconDeviceMobileOff,
  IconDeviceMobilePause: IconDeviceMobilePause,
  IconDeviceMobilePin: IconDeviceMobilePin,
  IconDeviceMobilePlus: IconDeviceMobilePlus,
  IconDeviceMobileQuestion: IconDeviceMobileQuestion,
  IconDeviceMobileRotated: IconDeviceMobileRotated,
  IconDeviceMobileSearch: IconDeviceMobileSearch,
  IconDeviceMobileShare: IconDeviceMobileShare,
  IconDeviceMobileStar: IconDeviceMobileStar,
  IconDeviceMobileUp: IconDeviceMobileUp,
  IconDeviceMobileVibration: IconDeviceMobileVibration,
  IconDeviceMobileX: IconDeviceMobileX,
  IconDeviceNintendo: IconDeviceNintendo,
  IconDeviceNintendoOff: IconDeviceNintendoOff,
  IconDeviceProjector: IconDeviceProjector,
  IconDeviceRemote: IconDeviceRemote,
  IconDeviceRemoteFilled: IconDeviceRemoteFilled,
  IconDeviceSdCard: IconDeviceSdCard,
  IconDeviceSim: IconDeviceSim,
  IconDeviceSim1: IconDeviceSim1,
  IconDeviceSim2: IconDeviceSim2,
  IconDeviceSim3: IconDeviceSim3,
  IconDeviceSpeaker: IconDeviceSpeaker,
  IconDeviceSpeakerFilled: IconDeviceSpeakerFilled,
  IconDeviceSpeakerOff: IconDeviceSpeakerOff,
  IconDeviceTablet: IconDeviceTablet,
  IconDeviceTabletBolt: IconDeviceTabletBolt,
  IconDeviceTabletCancel: IconDeviceTabletCancel,
  IconDeviceTabletCheck: IconDeviceTabletCheck,
  IconDeviceTabletCode: IconDeviceTabletCode,
  IconDeviceTabletCog: IconDeviceTabletCog,
  IconDeviceTabletDollar: IconDeviceTabletDollar,
  IconDeviceTabletDown: IconDeviceTabletDown,
  IconDeviceTabletExclamation: IconDeviceTabletExclamation,
  IconDeviceTabletFilled: IconDeviceTabletFilled,
  IconDeviceTabletHeart: IconDeviceTabletHeart,
  IconDeviceTabletMinus: IconDeviceTabletMinus,
  IconDeviceTabletOff: IconDeviceTabletOff,
  IconDeviceTabletPause: IconDeviceTabletPause,
  IconDeviceTabletPin: IconDeviceTabletPin,
  IconDeviceTabletPlus: IconDeviceTabletPlus,
  IconDeviceTabletQuestion: IconDeviceTabletQuestion,
  IconDeviceTabletSearch: IconDeviceTabletSearch,
  IconDeviceTabletShare: IconDeviceTabletShare,
  IconDeviceTabletStar: IconDeviceTabletStar,
  IconDeviceTabletUp: IconDeviceTabletUp,
  IconDeviceTabletX: IconDeviceTabletX,
  IconDeviceTv: IconDeviceTv,
  IconDeviceTvFilled: IconDeviceTvFilled,
  IconDeviceTvOff: IconDeviceTvOff,
  IconDeviceTvOld: IconDeviceTvOld,
  IconDeviceTvOldFilled: IconDeviceTvOldFilled,
  IconDeviceUnknown: IconDeviceUnknown,
  IconDeviceUnknownFilled: IconDeviceUnknownFilled,
  IconDeviceUsb: IconDeviceUsb,
  IconDeviceUsbFilled: IconDeviceUsbFilled,
  IconDeviceVisionPro: IconDeviceVisionPro,
  IconDeviceVisionProFilled: IconDeviceVisionProFilled,
  IconDeviceWatch: IconDeviceWatch,
  IconDeviceWatchBolt: IconDeviceWatchBolt,
  IconDeviceWatchCancel: IconDeviceWatchCancel,
  IconDeviceWatchCheck: IconDeviceWatchCheck,
  IconDeviceWatchCode: IconDeviceWatchCode,
  IconDeviceWatchCog: IconDeviceWatchCog,
  IconDeviceWatchDollar: IconDeviceWatchDollar,
  IconDeviceWatchDown: IconDeviceWatchDown,
  IconDeviceWatchExclamation: IconDeviceWatchExclamation,
  IconDeviceWatchFilled: IconDeviceWatchFilled,
  IconDeviceWatchHeart: IconDeviceWatchHeart,
  IconDeviceWatchMinus: IconDeviceWatchMinus,
  IconDeviceWatchOff: IconDeviceWatchOff,
  IconDeviceWatchPause: IconDeviceWatchPause,
  IconDeviceWatchPin: IconDeviceWatchPin,
  IconDeviceWatchPlus: IconDeviceWatchPlus,
  IconDeviceWatchQuestion: IconDeviceWatchQuestion,
  IconDeviceWatchSearch: IconDeviceWatchSearch,
  IconDeviceWatchShare: IconDeviceWatchShare,
  IconDeviceWatchStar: IconDeviceWatchStar,
  IconDeviceWatchStats: IconDeviceWatchStats,
  IconDeviceWatchStats2: IconDeviceWatchStats2,
  IconDeviceWatchUp: IconDeviceWatchUp,
  IconDeviceWatchX: IconDeviceWatchX,
  IconDevices: IconDevices,
  IconDevices2: IconDevices2,
  IconDevicesBolt: IconDevicesBolt,
  IconDevicesCancel: IconDevicesCancel,
  IconDevicesCheck: IconDevicesCheck,
  IconDevicesCode: IconDevicesCode,
  IconDevicesCog: IconDevicesCog,
  IconDevicesDollar: IconDevicesDollar,
  IconDevicesDown: IconDevicesDown,
  IconDevicesExclamation: IconDevicesExclamation,
  IconDevicesHeart: IconDevicesHeart,
  IconDevicesMinus: IconDevicesMinus,
  IconDevicesOff: IconDevicesOff,
  IconDevicesPause: IconDevicesPause,
  IconDevicesPc: IconDevicesPc,
  IconDevicesPcOff: IconDevicesPcOff,
  IconDevicesPin: IconDevicesPin,
  IconDevicesPlus: IconDevicesPlus,
  IconDevicesQuestion: IconDevicesQuestion,
  IconDevicesSearch: IconDevicesSearch,
  IconDevicesShare: IconDevicesShare,
  IconDevicesStar: IconDevicesStar,
  IconDevicesUp: IconDevicesUp,
  IconDevicesX: IconDevicesX,
  IconDiabolo: IconDiabolo,
  IconDiaboloOff: IconDiaboloOff,
  IconDiaboloPlus: IconDiaboloPlus,
  IconDialpad: IconDialpad,
  IconDialpadFilled: IconDialpadFilled,
  IconDialpadOff: IconDialpadOff,
  IconDiamond: IconDiamond,
  IconDiamondFilled: IconDiamondFilled,
  IconDiamondOff: IconDiamondOff,
  IconDiamonds: IconDiamonds,
  IconDiamondsFilled: IconDiamondsFilled,
  IconDiaper: IconDiaper,
  IconDice: IconDice,
  IconDice1: IconDice1,
  IconDice1Filled: IconDice1Filled,
  IconDice2: IconDice2,
  IconDice2Filled: IconDice2Filled,
  IconDice3: IconDice3,
  IconDice3Filled: IconDice3Filled,
  IconDice4: IconDice4,
  IconDice4Filled: IconDice4Filled,
  IconDice5: IconDice5,
  IconDice5Filled: IconDice5Filled,
  IconDice6: IconDice6,
  IconDice6Filled: IconDice6Filled,
  IconDiceFilled: IconDiceFilled,
  IconDimensions: IconDimensions,
  IconDirection: IconDirection,
  IconDirectionArrows: IconDirectionArrows,
  IconDirectionArrowsFilled: IconDirectionArrowsFilled,
  IconDirectionHorizontal: IconDirectionHorizontal,
  IconDirectionSign: IconDirectionSign,
  IconDirectionSignFilled: IconDirectionSignFilled,
  IconDirectionSignOff: IconDirectionSignOff,
  IconDirections: IconDirections,
  IconDirectionsFilled: IconDirectionsFilled,
  IconDirectionsOff: IconDirectionsOff,
  IconDisabled: IconDisabled,
  IconDisabled2: IconDisabled2,
  IconDisabledOff: IconDisabledOff,
  IconDisc: IconDisc,
  IconDiscFilled: IconDiscFilled,
  IconDiscGolf: IconDiscGolf,
  IconDiscOff: IconDiscOff,
  IconDiscount: IconDiscount,
  IconDiscountFilled: IconDiscountFilled,
  IconDiscountOff: IconDiscountOff,
  IconDivide: IconDivide,
  IconDna: IconDna,
  IconDna2: IconDna2,
  IconDna2Off: IconDna2Off,
  IconDnaOff: IconDnaOff,
  IconDog: IconDog,
  IconDogBowl: IconDogBowl,
  IconDoor: IconDoor,
  IconDoorEnter: IconDoorEnter,
  IconDoorExit: IconDoorExit,
  IconDoorOff: IconDoorOff,
  IconDots: IconDots,
  IconDotsCircleHorizontal: IconDotsCircleHorizontal,
  IconDotsDiagonal: IconDotsDiagonal,
  IconDotsDiagonal2: IconDotsDiagonal2,
  IconDotsVertical: IconDotsVertical,
  IconDownload: IconDownload,
  IconDownloadOff: IconDownloadOff,
  IconDragDrop: IconDragDrop,
  IconDragDrop2: IconDragDrop2,
  IconDrone: IconDrone,
  IconDroneOff: IconDroneOff,
  IconDropCircle: IconDropCircle,
  IconDropCircleFilled: IconDropCircleFilled,
  IconDroplet: IconDroplet,
  IconDropletBolt: IconDropletBolt,
  IconDropletCancel: IconDropletCancel,
  IconDropletCheck: IconDropletCheck,
  IconDropletCode: IconDropletCode,
  IconDropletCog: IconDropletCog,
  IconDropletDollar: IconDropletDollar,
  IconDropletDown: IconDropletDown,
  IconDropletExclamation: IconDropletExclamation,
  IconDropletFilled: IconDropletFilled,
  IconDropletHalf: IconDropletHalf,
  IconDropletHalf2: IconDropletHalf2,
  IconDropletHalf2Filled: IconDropletHalf2Filled,
  IconDropletHalfFilled: IconDropletHalfFilled,
  IconDropletHeart: IconDropletHeart,
  IconDropletMinus: IconDropletMinus,
  IconDropletOff: IconDropletOff,
  IconDropletPause: IconDropletPause,
  IconDropletPin: IconDropletPin,
  IconDropletPlus: IconDropletPlus,
  IconDropletQuestion: IconDropletQuestion,
  IconDropletSearch: IconDropletSearch,
  IconDropletShare: IconDropletShare,
  IconDropletStar: IconDropletStar,
  IconDropletUp: IconDropletUp,
  IconDropletX: IconDropletX,
  IconDroplets: IconDroplets,
  IconDropletsFilled: IconDropletsFilled,
  IconDualScreen: IconDualScreen,
  IconDualScreenFilled: IconDualScreenFilled,
  IconDumpling: IconDumpling,
  IconDumplingFilled: IconDumplingFilled,
  IconEPassport: IconEPassport,
  IconEar: IconEar,
  IconEarOff: IconEarOff,
  IconEarScan: IconEarScan,
  IconEaseIn: IconEaseIn,
  IconEaseInControlPoint: IconEaseInControlPoint,
  IconEaseInOut: IconEaseInOut,
  IconEaseInOutControlPoints: IconEaseInOutControlPoints,
  IconEaseOut: IconEaseOut,
  IconEaseOutControlPoint: IconEaseOutControlPoint,
  IconEdit: IconEdit,
  IconEditCircle: IconEditCircle,
  IconEditCircleOff: IconEditCircleOff,
  IconEditOff: IconEditOff,
  IconEgg: IconEgg,
  IconEggCracked: IconEggCracked,
  IconEggCrackedFilled: IconEggCrackedFilled,
  IconEggFilled: IconEggFilled,
  IconEggFried: IconEggFried,
  IconEggFriedFilled: IconEggFriedFilled,
  IconEggOff: IconEggOff,
  IconEggs: IconEggs,
  IconElevator: IconElevator,
  IconElevatorFilled: IconElevatorFilled,
  IconElevatorOff: IconElevatorOff,
  IconEmergencyBed: IconEmergencyBed,
  IconEmpathize: IconEmpathize,
  IconEmpathizeOff: IconEmpathizeOff,
  IconEmphasis: IconEmphasis,
  IconEngine: IconEngine,
  IconEngineFilled: IconEngineFilled,
  IconEngineOff: IconEngineOff,
  IconEqual: IconEqual,
  IconEqualDouble: IconEqualDouble,
  IconEqualNot: IconEqualNot,
  IconEraser: IconEraser,
  IconEraserOff: IconEraserOff,
  IconError404: IconError404,
  IconError404Off: IconError404Off,
  IconEscalator: IconEscalator,
  IconEscalatorDown: IconEscalatorDown,
  IconEscalatorDownFilled: IconEscalatorDownFilled,
  IconEscalatorFilled: IconEscalatorFilled,
  IconEscalatorUp: IconEscalatorUp,
  IconEscalatorUpFilled: IconEscalatorUpFilled,
  IconExchange: IconExchange,
  IconExchangeFilled: IconExchangeFilled,
  IconExchangeOff: IconExchangeOff,
  IconExclamationCircle: IconExclamationCircle,
  IconExclamationCircleFilled: IconExclamationCircleFilled,
  IconExclamationMark: IconExclamationMark,
  IconExclamationMarkOff: IconExclamationMarkOff,
  IconExplicit: IconExplicit,
  IconExplicitFilled: IconExplicitFilled,
  IconExplicitOff: IconExplicitOff,
  IconExposure: IconExposure,
  IconExposure0: IconExposure0,
  IconExposureFilled: IconExposureFilled,
  IconExposureMinus1: IconExposureMinus1,
  IconExposureMinus2: IconExposureMinus2,
  IconExposureOff: IconExposureOff,
  IconExposurePlus1: IconExposurePlus1,
  IconExposurePlus2: IconExposurePlus2,
  IconExternalLink: IconExternalLink,
  IconExternalLinkOff: IconExternalLinkOff,
  IconEye: IconEye,
  IconEyeBitcoin: IconEyeBitcoin,
  IconEyeBolt: IconEyeBolt,
  IconEyeCancel: IconEyeCancel,
  IconEyeCheck: IconEyeCheck,
  IconEyeClosed: IconEyeClosed,
  IconEyeCode: IconEyeCode,
  IconEyeCog: IconEyeCog,
  IconEyeDiscount: IconEyeDiscount,
  IconEyeDollar: IconEyeDollar,
  IconEyeDotted: IconEyeDotted,
  IconEyeDown: IconEyeDown,
  IconEyeEdit: IconEyeEdit,
  IconEyeExclamation: IconEyeExclamation,
  IconEyeFilled: IconEyeFilled,
  IconEyeHeart: IconEyeHeart,
  IconEyeMinus: IconEyeMinus,
  IconEyeOff: IconEyeOff,
  IconEyePause: IconEyePause,
  IconEyePin: IconEyePin,
  IconEyePlus: IconEyePlus,
  IconEyeQuestion: IconEyeQuestion,
  IconEyeSearch: IconEyeSearch,
  IconEyeShare: IconEyeShare,
  IconEyeSpark: IconEyeSpark,
  IconEyeStar: IconEyeStar,
  IconEyeTable: IconEyeTable,
  IconEyeTableFilled: IconEyeTableFilled,
  IconEyeUp: IconEyeUp,
  IconEyeX: IconEyeX,
  IconEyeglass: IconEyeglass,
  IconEyeglass2: IconEyeglass2,
  IconEyeglass2Filled: IconEyeglass2Filled,
  IconEyeglassFilled: IconEyeglassFilled,
  IconEyeglassOff: IconEyeglassOff,
  IconFaceId: IconFaceId,
  IconFaceIdError: IconFaceIdError,
  IconFaceMask: IconFaceMask,
  IconFaceMaskFilled: IconFaceMaskFilled,
  IconFaceMaskOff: IconFaceMaskOff,
  IconFall: IconFall,
  IconFavicon: IconFavicon,
  IconFaviconFilled: IconFaviconFilled,
  IconFeather: IconFeather,
  IconFeatherFilled: IconFeatherFilled,
  IconFeatherOff: IconFeatherOff,
  IconFence: IconFence,
  IconFenceFilled: IconFenceFilled,
  IconFenceOff: IconFenceOff,
  IconFerry: IconFerry,
  IconFerryFilled: IconFerryFilled,
  IconFidgetSpinner: IconFidgetSpinner,
  IconFidgetSpinnerFilled: IconFidgetSpinnerFilled,
  IconFile: IconFile,
  IconFile3d: IconFile3d,
  IconFileAi: IconFileAi,
  IconFileAlert: IconFileAlert,
  IconFileAnalytics: IconFileAnalytics,
  IconFileArrowLeft: IconFileArrowLeft,
  IconFileArrowRight: IconFileArrowRight,
  IconFileBarcode: IconFileBarcode,
  IconFileBitcoin: IconFileBitcoin,
  IconFileBroken: IconFileBroken,
  IconFileCertificate: IconFileCertificate,
  IconFileChart: IconFileChart,
  IconFileCheck: IconFileCheck,
  IconFileCheckFilled: IconFileCheckFilled,
  IconFileCode: IconFileCode,
  IconFileCode2: IconFileCode2,
  IconFileCode2Filled: IconFileCode2Filled,
  IconFileCv: IconFileCv,
  IconFileCvFilled: IconFileCvFilled,
  IconFileDatabase: IconFileDatabase,
  IconFileDelta: IconFileDelta,
  IconFileDeltaFilled: IconFileDeltaFilled,
  IconFileDescription: IconFileDescription,
  IconFileDescriptionFilled: IconFileDescriptionFilled,
  IconFileDiff: IconFileDiff,
  IconFileDigit: IconFileDigit,
  IconFileDigitFilled: IconFileDigitFilled,
  IconFileDislike: IconFileDislike,
  IconFileDollar: IconFileDollar,
  IconFileDots: IconFileDots,
  IconFileDownload: IconFileDownload,
  IconFileDownloadFilled: IconFileDownloadFilled,
  IconFileEuro: IconFileEuro,
  IconFileExcel: IconFileExcel,
  IconFileExport: IconFileExport,
  IconFileFilled: IconFileFilled,
  IconFileFunction: IconFileFunction,
  IconFileHorizontal: IconFileHorizontal,
  IconFileHorizontalFilled: IconFileHorizontalFilled,
  IconFileImport: IconFileImport,
  IconFileInfinity: IconFileInfinity,
  IconFileInfo: IconFileInfo,
  IconFileInvoice: IconFileInvoice,
  IconFileInvoiceFilled: IconFileInvoiceFilled,
  IconFileIsr: IconFileIsr,
  IconFileLambda: IconFileLambda,
  IconFileLambdaFilled: IconFileLambdaFilled,
  IconFileLike: IconFileLike,
  IconFileMinus: IconFileMinus,
  IconFileMinusFilled: IconFileMinusFilled,
  IconFileMusic: IconFileMusic,
  IconFileNeutral: IconFileNeutral,
  IconFileNeutralFilled: IconFileNeutralFilled,
  IconFileOff: IconFileOff,
  IconFileOrientation: IconFileOrientation,
  IconFilePencil: IconFilePencil,
  IconFilePercent: IconFilePercent,
  IconFilePercentFilled: IconFilePercentFilled,
  IconFilePhone: IconFilePhone,
  IconFilePhoneFilled: IconFilePhoneFilled,
  IconFilePlus: IconFilePlus,
  IconFilePower: IconFilePower,
  IconFilePowerFilled: IconFilePowerFilled,
  IconFileReport: IconFileReport,
  IconFileRss: IconFileRss,
  IconFileRssFilled: IconFileRssFilled,
  IconFileSad: IconFileSad,
  IconFileSadFilled: IconFileSadFilled,
  IconFileScissors: IconFileScissors,
  IconFileSearch: IconFileSearch,
  IconFileSettings: IconFileSettings,
  IconFileShredder: IconFileShredder,
  IconFileSignal: IconFileSignal,
  IconFileSmile: IconFileSmile,
  IconFileSmileFilled: IconFileSmileFilled,
  IconFileSpark: IconFileSpark,
  IconFileSpreadsheet: IconFileSpreadsheet,
  IconFileStack: IconFileStack,
  IconFileStar: IconFileStar,
  IconFileStarFilled: IconFileStarFilled,
  IconFileSymlink: IconFileSymlink,
  IconFileText: IconFileText,
  IconFileTextAi: IconFileTextAi,
  IconFileTextFilled: IconFileTextFilled,
  IconFileTextShield: IconFileTextShield,
  IconFileTextSpark: IconFileTextSpark,
  IconFileTime: IconFileTime,
  IconFileTypeBmp: IconFileTypeBmp,
  IconFileTypeCss: IconFileTypeCss,
  IconFileTypeCsv: IconFileTypeCsv,
  IconFileTypeDoc: IconFileTypeDoc,
  IconFileTypeDocx: IconFileTypeDocx,
  IconFileTypeHtml: IconFileTypeHtml,
  IconFileTypeJpg: IconFileTypeJpg,
  IconFileTypeJs: IconFileTypeJs,
  IconFileTypeJsx: IconFileTypeJsx,
  IconFileTypePdf: IconFileTypePdf,
  IconFileTypePhp: IconFileTypePhp,
  IconFileTypePng: IconFileTypePng,
  IconFileTypePpt: IconFileTypePpt,
  IconFileTypeRs: IconFileTypeRs,
  IconFileTypeSql: IconFileTypeSql,
  IconFileTypeSvg: IconFileTypeSvg,
  IconFileTypeTs: IconFileTypeTs,
  IconFileTypeTsx: IconFileTypeTsx,
  IconFileTypeTxt: IconFileTypeTxt,
  IconFileTypeVue: IconFileTypeVue,
  IconFileTypeXls: IconFileTypeXls,
  IconFileTypeXml: IconFileTypeXml,
  IconFileTypeZip: IconFileTypeZip,
  IconFileTypography: IconFileTypography,
  IconFileUnknown: IconFileUnknown,
  IconFileUpload: IconFileUpload,
  IconFileVector: IconFileVector,
  IconFileWord: IconFileWord,
  IconFileX: IconFileX,
  IconFileXFilled: IconFileXFilled,
  IconFileZip: IconFileZip,
  IconFiles: IconFiles,
  IconFilesOff: IconFilesOff,
  IconFilter: IconFilter,
  IconFilterBolt: IconFilterBolt,
  IconFilterCancel: IconFilterCancel,
  IconFilterCheck: IconFilterCheck,
  IconFilterCode: IconFilterCode,
  IconFilterCog: IconFilterCog,
  IconFilterDiscount: IconFilterDiscount,
  IconFilterDollar: IconFilterDollar,
  IconFilterDown: IconFilterDown,
  IconFilterEdit: IconFilterEdit,
  IconFilterExclamation: IconFilterExclamation,
  IconFilterFilled: IconFilterFilled,
  IconFilterHeart: IconFilterHeart,
  IconFilterMinus: IconFilterMinus,
  IconFilterOff: IconFilterOff,
  IconFilterPause: IconFilterPause,
  IconFilterPin: IconFilterPin,
  IconFilterPlus: IconFilterPlus,
  IconFilterQuestion: IconFilterQuestion,
  IconFilterSearch: IconFilterSearch,
  IconFilterShare: IconFilterShare,
  IconFilterStar: IconFilterStar,
  IconFilterUp: IconFilterUp,
  IconFilterX: IconFilterX,
  IconFilters: IconFilters,
  IconFiltersFilled: IconFiltersFilled,
  IconFingerprint: IconFingerprint,
  IconFingerprintOff: IconFingerprintOff,
  IconFingerprintScan: IconFingerprintScan,
  IconFireExtinguisher: IconFireExtinguisher,
  IconFireHydrant: IconFireHydrant,
  IconFireHydrantOff: IconFireHydrantOff,
  IconFiretruck: IconFiretruck,
  IconFirstAidKit: IconFirstAidKit,
  IconFirstAidKitOff: IconFirstAidKitOff,
  IconFish: IconFish,
  IconFishBone: IconFishBone,
  IconFishBoneFilled: IconFishBoneFilled,
  IconFishChristianity: IconFishChristianity,
  IconFishHook: IconFishHook,
  IconFishHookOff: IconFishHookOff,
  IconFishOff: IconFishOff,
  IconFlag: IconFlag,
  IconFlag2: IconFlag2,
  IconFlag2Filled: IconFlag2Filled,
  IconFlag2Off: IconFlag2Off,
  IconFlag3: IconFlag3,
  IconFlag3Filled: IconFlag3Filled,
  IconFlagBitcoin: IconFlagBitcoin,
  IconFlagBolt: IconFlagBolt,
  IconFlagCancel: IconFlagCancel,
  IconFlagCheck: IconFlagCheck,
  IconFlagCode: IconFlagCode,
  IconFlagCog: IconFlagCog,
  IconFlagDiscount: IconFlagDiscount,
  IconFlagDollar: IconFlagDollar,
  IconFlagDown: IconFlagDown,
  IconFlagExclamation: IconFlagExclamation,
  IconFlagFilled: IconFlagFilled,
  IconFlagHeart: IconFlagHeart,
  IconFlagMinus: IconFlagMinus,
  IconFlagOff: IconFlagOff,
  IconFlagPause: IconFlagPause,
  IconFlagPin: IconFlagPin,
  IconFlagPlus: IconFlagPlus,
  IconFlagQuestion: IconFlagQuestion,
  IconFlagSearch: IconFlagSearch,
  IconFlagShare: IconFlagShare,
  IconFlagSpark: IconFlagSpark,
  IconFlagStar: IconFlagStar,
  IconFlagUp: IconFlagUp,
  IconFlagX: IconFlagX,
  IconFlame: IconFlame,
  IconFlameFilled: IconFlameFilled,
  IconFlameOff: IconFlameOff,
  IconFlare: IconFlare,
  IconFlareFilled: IconFlareFilled,
  IconFlask: IconFlask,
  IconFlask2: IconFlask2,
  IconFlask2Filled: IconFlask2Filled,
  IconFlask2Off: IconFlask2Off,
  IconFlaskFilled: IconFlaskFilled,
  IconFlaskOff: IconFlaskOff,
  IconFlipFlops: IconFlipFlops,
  IconFlipHorizontal: IconFlipHorizontal,
  IconFlipVertical: IconFlipVertical,
  IconFloatCenter: IconFloatCenter,
  IconFloatLeft: IconFloatLeft,
  IconFloatNone: IconFloatNone,
  IconFloatRight: IconFloatRight,
  IconFlower: IconFlower,
  IconFlowerFilled: IconFlowerFilled,
  IconFlowerOff: IconFlowerOff,
  IconFocus: IconFocus,
  IconFocus2: IconFocus2,
  IconFocusAuto: IconFocusAuto,
  IconFocusCentered: IconFocusCentered,
  IconFold: IconFold,
  IconFoldDown: IconFoldDown,
  IconFoldUp: IconFoldUp,
  IconFolder: IconFolder,
  IconFolderBolt: IconFolderBolt,
  IconFolderCancel: IconFolderCancel,
  IconFolderCheck: IconFolderCheck,
  IconFolderCode: IconFolderCode,
  IconFolderCog: IconFolderCog,
  IconFolderDollar: IconFolderDollar,
  IconFolderDown: IconFolderDown,
  IconFolderExclamation: IconFolderExclamation,
  IconFolderFilled: IconFolderFilled,
  IconFolderHeart: IconFolderHeart,
  IconFolderMinus: IconFolderMinus,
  IconFolderOff: IconFolderOff,
  IconFolderOpen: IconFolderOpen,
  IconFolderPause: IconFolderPause,
  IconFolderPin: IconFolderPin,
  IconFolderPlus: IconFolderPlus,
  IconFolderQuestion: IconFolderQuestion,
  IconFolderRoot: IconFolderRoot,
  IconFolderSearch: IconFolderSearch,
  IconFolderShare: IconFolderShare,
  IconFolderStar: IconFolderStar,
  IconFolderSymlink: IconFolderSymlink,
  IconFolderUp: IconFolderUp,
  IconFolderX: IconFolderX,
  IconFolders: IconFolders,
  IconFoldersFilled: IconFoldersFilled,
  IconFoldersOff: IconFoldersOff,
  IconForbid: IconForbid,
  IconForbid2: IconForbid2,
  IconForbid2Filled: IconForbid2Filled,
  IconForbidFilled: IconForbidFilled,
  IconForklift: IconForklift,
  IconForms: IconForms,
  IconFountain: IconFountain,
  IconFountainFilled: IconFountainFilled,
  IconFountainOff: IconFountainOff,
  IconFrame: IconFrame,
  IconFrameOff: IconFrameOff,
  IconFreeRights: IconFreeRights,
  IconFreezeColumn: IconFreezeColumn,
  IconFreezeRow: IconFreezeRow,
  IconFreezeRowColumn: IconFreezeRowColumn,
  IconFridge: IconFridge,
  IconFridgeOff: IconFridgeOff,
  IconFriends: IconFriends,
  IconFriendsOff: IconFriendsOff,
  IconFrustum: IconFrustum,
  IconFrustumOff: IconFrustumOff,
  IconFrustumPlus: IconFrustumPlus,
  IconFunction: IconFunction,
  IconFunctionFilled: IconFunctionFilled,
  IconFunctionOff: IconFunctionOff,
  IconGalaxy: IconGalaxy,
  IconGardenCart: IconGardenCart,
  IconGardenCartFilled: IconGardenCartFilled,
  IconGardenCartOff: IconGardenCartOff,
  IconGasStation: IconGasStation,
  IconGasStationFilled: IconGasStationFilled,
  IconGasStationOff: IconGasStationOff,
  IconGauge: IconGauge,
  IconGaugeFilled: IconGaugeFilled,
  IconGaugeOff: IconGaugeOff,
  IconGavel: IconGavel,
  IconGenderAgender: IconGenderAgender,
  IconGenderAndrogyne: IconGenderAndrogyne,
  IconGenderBigender: IconGenderBigender,
  IconGenderDemiboy: IconGenderDemiboy,
  IconGenderDemigirl: IconGenderDemigirl,
  IconGenderEpicene: IconGenderEpicene,
  IconGenderFemale: IconGenderFemale,
  IconGenderFemme: IconGenderFemme,
  IconGenderGenderfluid: IconGenderGenderfluid,
  IconGenderGenderless: IconGenderGenderless,
  IconGenderGenderqueer: IconGenderGenderqueer,
  IconGenderHermaphrodite: IconGenderHermaphrodite,
  IconGenderIntergender: IconGenderIntergender,
  IconGenderMale: IconGenderMale,
  IconGenderNeutrois: IconGenderNeutrois,
  IconGenderThird: IconGenderThird,
  IconGenderTransgender: IconGenderTransgender,
  IconGenderTrasvesti: IconGenderTrasvesti,
  IconGeometry: IconGeometry,
  IconGhost: IconGhost,
  IconGhost2: IconGhost2,
  IconGhost2Filled: IconGhost2Filled,
  IconGhost3: IconGhost3,
  IconGhost3Filled: IconGhost3Filled,
  IconGhostFilled: IconGhostFilled,
  IconGhostOff: IconGhostOff,
  IconGif: IconGif,
  IconGift: IconGift,
  IconGiftCard: IconGiftCard,
  IconGiftCardFilled: IconGiftCardFilled,
  IconGiftFilled: IconGiftFilled,
  IconGiftOff: IconGiftOff,
  IconGitBranch: IconGitBranch,
  IconGitBranchDeleted: IconGitBranchDeleted,
  IconGitCherryPick: IconGitCherryPick,
  IconGitCommit: IconGitCommit,
  IconGitCompare: IconGitCompare,
  IconGitFork: IconGitFork,
  IconGitMerge: IconGitMerge,
  IconGitPullRequest: IconGitPullRequest,
  IconGitPullRequestClosed: IconGitPullRequestClosed,
  IconGitPullRequestDraft: IconGitPullRequestDraft,
  IconGizmo: IconGizmo,
  IconGlass: IconGlass,
  IconGlassChampagne: IconGlassChampagne,
  IconGlassCocktail: IconGlassCocktail,
  IconGlassFilled: IconGlassFilled,
  IconGlassFull: IconGlassFull,
  IconGlassFullFilled: IconGlassFullFilled,
  IconGlassGin: IconGlassGin,
  IconGlassOff: IconGlassOff,
  IconGlobe: IconGlobe,
  IconGlobeFilled: IconGlobeFilled,
  IconGlobeOff: IconGlobeOff,
  IconGoGame: IconGoGame,
  IconGolf: IconGolf,
  IconGolfFilled: IconGolfFilled,
  IconGolfOff: IconGolfOff,
  IconGps: IconGps,
  IconGpsFilled: IconGpsFilled,
  IconGradienter: IconGradienter,
  IconGrain: IconGrain,
  IconGraph: IconGraph,
  IconGraphFilled: IconGraphFilled,
  IconGraphOff: IconGraphOff,
  IconGrave: IconGrave,
  IconGrave2: IconGrave2,
  IconGrid3x3: IconGrid3x3,
  IconGrid4x4: IconGrid4x4,
  IconGridDots: IconGridDots,
  IconGridGoldenratio: IconGridGoldenratio,
  IconGridPattern: IconGridPattern,
  IconGridPatternFilled: IconGridPatternFilled,
  IconGridScan: IconGridScan,
  IconGrill: IconGrill,
  IconGrillFork: IconGrillFork,
  IconGrillOff: IconGrillOff,
  IconGrillSpatula: IconGrillSpatula,
  IconGripHorizontal: IconGripHorizontal,
  IconGripVertical: IconGripVertical,
  IconGrowth: IconGrowth,
  IconGuitarPick: IconGuitarPick,
  IconGuitarPickFilled: IconGuitarPickFilled,
  IconGymnastics: IconGymnastics,
  IconH1: IconH1,
  IconH2: IconH2,
  IconH3: IconH3,
  IconH4: IconH4,
  IconH5: IconH5,
  IconH6: IconH6,
  IconHammer: IconHammer,
  IconHammerOff: IconHammerOff,
  IconHandClick: IconHandClick,
  IconHandClickOff: IconHandClickOff,
  IconHandFinger: IconHandFinger,
  IconHandFingerDown: IconHandFingerDown,
  IconHandFingerLeft: IconHandFingerLeft,
  IconHandFingerOff: IconHandFingerOff,
  IconHandFingerRight: IconHandFingerRight,
  IconHandGrab: IconHandGrab,
  IconHandLittleFinger: IconHandLittleFinger,
  IconHandLoveYou: IconHandLoveYou,
  IconHandMiddleFinger: IconHandMiddleFinger,
  IconHandMove: IconHandMove,
  IconHandOff: IconHandOff,
  IconHandRingFinger: IconHandRingFinger,
  IconHandSanitizer: IconHandSanitizer,
  IconHandStop: IconHandStop,
  IconHandThreeFingers: IconHandThreeFingers,
  IconHandTwoFingers: IconHandTwoFingers,
  IconHanger: IconHanger,
  IconHanger2: IconHanger2,
  IconHanger2Filled: IconHanger2Filled,
  IconHangerOff: IconHangerOff,
  IconHash: IconHash,
  IconHaze: IconHaze,
  IconHazeMoon: IconHazeMoon,
  IconHdr: IconHdr,
  IconHeading: IconHeading,
  IconHeadingOff: IconHeadingOff,
  IconHeadphones: IconHeadphones,
  IconHeadphonesFilled: IconHeadphonesFilled,
  IconHeadphonesOff: IconHeadphonesOff,
  IconHeadset: IconHeadset,
  IconHeadsetOff: IconHeadsetOff,
  IconHealthRecognition: IconHealthRecognition,
  IconHeart: IconHeart,
  IconHeartBitcoin: IconHeartBitcoin,
  IconHeartBolt: IconHeartBolt,
  IconHeartBroken: IconHeartBroken,
  IconHeartCancel: IconHeartCancel,
  IconHeartCheck: IconHeartCheck,
  IconHeartCode: IconHeartCode,
  IconHeartCog: IconHeartCog,
  IconHeartDiscount: IconHeartDiscount,
  IconHeartDollar: IconHeartDollar,
  IconHeartDown: IconHeartDown,
  IconHeartExclamation: IconHeartExclamation,
  IconHeartFilled: IconHeartFilled,
  IconHeartHandshake: IconHeartHandshake,
  IconHeartMinus: IconHeartMinus,
  IconHeartOff: IconHeartOff,
  IconHeartPause: IconHeartPause,
  IconHeartPin: IconHeartPin,
  IconHeartPlus: IconHeartPlus,
  IconHeartQuestion: IconHeartQuestion,
  IconHeartRateMonitor: IconHeartRateMonitor,
  IconHeartSearch: IconHeartSearch,
  IconHeartShare: IconHeartShare,
  IconHeartSpark: IconHeartSpark,
  IconHeartStar: IconHeartStar,
  IconHeartUp: IconHeartUp,
  IconHeartX: IconHeartX,
  IconHeartbeat: IconHeartbeat,
  IconHearts: IconHearts,
  IconHeartsOff: IconHeartsOff,
  IconHelicopter: IconHelicopter,
  IconHelicopterFilled: IconHelicopterFilled,
  IconHelicopterLanding: IconHelicopterLanding,
  IconHelicopterLandingFilled: IconHelicopterLandingFilled,
  IconHelmet: IconHelmet,
  IconHelmetOff: IconHelmetOff,
  IconHelp: IconHelp,
  IconHelpCircle: IconHelpCircle,
  IconHelpCircleFilled: IconHelpCircleFilled,
  IconHelpHexagon: IconHelpHexagon,
  IconHelpHexagonFilled: IconHelpHexagonFilled,
  IconHelpOctagon: IconHelpOctagon,
  IconHelpOctagonFilled: IconHelpOctagonFilled,
  IconHelpOff: IconHelpOff,
  IconHelpSmall: IconHelpSmall,
  IconHelpSquare: IconHelpSquare,
  IconHelpSquareFilled: IconHelpSquareFilled,
  IconHelpSquareRounded: IconHelpSquareRounded,
  IconHelpSquareRoundedFilled: IconHelpSquareRoundedFilled,
  IconHelpTriangle: IconHelpTriangle,
  IconHelpTriangleFilled: IconHelpTriangleFilled,
  IconHemisphere: IconHemisphere,
  IconHemisphereOff: IconHemisphereOff,
  IconHemispherePlus: IconHemispherePlus,
  IconHexagon: IconHexagon,
  IconHexagon3d: IconHexagon3d,
  IconHexagonFilled: IconHexagonFilled,
  IconHexagonLetterA: IconHexagonLetterA,
  IconHexagonLetterAFilled: IconHexagonLetterAFilled,
  IconHexagonLetterB: IconHexagonLetterB,
  IconHexagonLetterBFilled: IconHexagonLetterBFilled,
  IconHexagonLetterC: IconHexagonLetterC,
  IconHexagonLetterCFilled: IconHexagonLetterCFilled,
  IconHexagonLetterD: IconHexagonLetterD,
  IconHexagonLetterDFilled: IconHexagonLetterDFilled,
  IconHexagonLetterE: IconHexagonLetterE,
  IconHexagonLetterEFilled: IconHexagonLetterEFilled,
  IconHexagonLetterF: IconHexagonLetterF,
  IconHexagonLetterFFilled: IconHexagonLetterFFilled,
  IconHexagonLetterG: IconHexagonLetterG,
  IconHexagonLetterGFilled: IconHexagonLetterGFilled,
  IconHexagonLetterH: IconHexagonLetterH,
  IconHexagonLetterHFilled: IconHexagonLetterHFilled,
  IconHexagonLetterI: IconHexagonLetterI,
  IconHexagonLetterIFilled: IconHexagonLetterIFilled,
  IconHexagonLetterJ: IconHexagonLetterJ,
  IconHexagonLetterJFilled: IconHexagonLetterJFilled,
  IconHexagonLetterK: IconHexagonLetterK,
  IconHexagonLetterKFilled: IconHexagonLetterKFilled,
  IconHexagonLetterL: IconHexagonLetterL,
  IconHexagonLetterLFilled: IconHexagonLetterLFilled,
  IconHexagonLetterM: IconHexagonLetterM,
  IconHexagonLetterMFilled: IconHexagonLetterMFilled,
  IconHexagonLetterN: IconHexagonLetterN,
  IconHexagonLetterNFilled: IconHexagonLetterNFilled,
  IconHexagonLetterO: IconHexagonLetterO,
  IconHexagonLetterOFilled: IconHexagonLetterOFilled,
  IconHexagonLetterP: IconHexagonLetterP,
  IconHexagonLetterPFilled: IconHexagonLetterPFilled,
  IconHexagonLetterQ: IconHexagonLetterQ,
  IconHexagonLetterQFilled: IconHexagonLetterQFilled,
  IconHexagonLetterR: IconHexagonLetterR,
  IconHexagonLetterRFilled: IconHexagonLetterRFilled,
  IconHexagonLetterS: IconHexagonLetterS,
  IconHexagonLetterSFilled: IconHexagonLetterSFilled,
  IconHexagonLetterT: IconHexagonLetterT,
  IconHexagonLetterTFilled: IconHexagonLetterTFilled,
  IconHexagonLetterU: IconHexagonLetterU,
  IconHexagonLetterUFilled: IconHexagonLetterUFilled,
  IconHexagonLetterV: IconHexagonLetterV,
  IconHexagonLetterVFilled: IconHexagonLetterVFilled,
  IconHexagonLetterW: IconHexagonLetterW,
  IconHexagonLetterWFilled: IconHexagonLetterWFilled,
  IconHexagonLetterX: IconHexagonLetterX,
  IconHexagonLetterXFilled: IconHexagonLetterXFilled,
  IconHexagonLetterY: IconHexagonLetterY,
  IconHexagonLetterYFilled: IconHexagonLetterYFilled,
  IconHexagonLetterZ: IconHexagonLetterZ,
  IconHexagonLetterZFilled: IconHexagonLetterZFilled,
  IconHexagonMinus: IconHexagonMinus,
  IconHexagonMinus2: IconHexagonMinus2,
  IconHexagonMinusFilled: IconHexagonMinusFilled,
  IconHexagonNumber0: IconHexagonNumber0,
  IconHexagonNumber0Filled: IconHexagonNumber0Filled,
  IconHexagonNumber1: IconHexagonNumber1,
  IconHexagonNumber1Filled: IconHexagonNumber1Filled,
  IconHexagonNumber2: IconHexagonNumber2,
  IconHexagonNumber2Filled: IconHexagonNumber2Filled,
  IconHexagonNumber3: IconHexagonNumber3,
  IconHexagonNumber3Filled: IconHexagonNumber3Filled,
  IconHexagonNumber4: IconHexagonNumber4,
  IconHexagonNumber4Filled: IconHexagonNumber4Filled,
  IconHexagonNumber5: IconHexagonNumber5,
  IconHexagonNumber5Filled: IconHexagonNumber5Filled,
  IconHexagonNumber6: IconHexagonNumber6,
  IconHexagonNumber6Filled: IconHexagonNumber6Filled,
  IconHexagonNumber7: IconHexagonNumber7,
  IconHexagonNumber7Filled: IconHexagonNumber7Filled,
  IconHexagonNumber8: IconHexagonNumber8,
  IconHexagonNumber8Filled: IconHexagonNumber8Filled,
  IconHexagonNumber9: IconHexagonNumber9,
  IconHexagonNumber9Filled: IconHexagonNumber9Filled,
  IconHexagonOff: IconHexagonOff,
  IconHexagonPlus: IconHexagonPlus,
  IconHexagonPlus2: IconHexagonPlus2,
  IconHexagonPlusFilled: IconHexagonPlusFilled,
  IconHexagonalPrism: IconHexagonalPrism,
  IconHexagonalPrismOff: IconHexagonalPrismOff,
  IconHexagonalPrismPlus: IconHexagonalPrismPlus,
  IconHexagonalPyramid: IconHexagonalPyramid,
  IconHexagonalPyramidOff: IconHexagonalPyramidOff,
  IconHexagonalPyramidPlus: IconHexagonalPyramidPlus,
  IconHexagons: IconHexagons,
  IconHexagonsOff: IconHexagonsOff,
  IconHierarchy: IconHierarchy,
  IconHierarchy2: IconHierarchy2,
  IconHierarchy3: IconHierarchy3,
  IconHierarchyOff: IconHierarchyOff,
  IconHighlight: IconHighlight,
  IconHighlightOff: IconHighlightOff,
  IconHistory: IconHistory,
  IconHistoryOff: IconHistoryOff,
  IconHistoryToggle: IconHistoryToggle,
  IconHome: IconHome,
  IconHome2: IconHome2,
  IconHomeBitcoin: IconHomeBitcoin,
  IconHomeBolt: IconHomeBolt,
  IconHomeCancel: IconHomeCancel,
  IconHomeCheck: IconHomeCheck,
  IconHomeCog: IconHomeCog,
  IconHomeDollar: IconHomeDollar,
  IconHomeDot: IconHomeDot,
  IconHomeDown: IconHomeDown,
  IconHomeEco: IconHomeEco,
  IconHomeEdit: IconHomeEdit,
  IconHomeExclamation: IconHomeExclamation,
  IconHomeFilled: IconHomeFilled,
  IconHomeHand: IconHomeHand,
  IconHomeHeart: IconHomeHeart,
  IconHomeInfinity: IconHomeInfinity,
  IconHomeLink: IconHomeLink,
  IconHomeMinus: IconHomeMinus,
  IconHomeMove: IconHomeMove,
  IconHomeOff: IconHomeOff,
  IconHomePlus: IconHomePlus,
  IconHomeQuestion: IconHomeQuestion,
  IconHomeRibbon: IconHomeRibbon,
  IconHomeSearch: IconHomeSearch,
  IconHomeShare: IconHomeShare,
  IconHomeShield: IconHomeShield,
  IconHomeSignal: IconHomeSignal,
  IconHomeSpark: IconHomeSpark,
  IconHomeStar: IconHomeStar,
  IconHomeStats: IconHomeStats,
  IconHomeUp: IconHomeUp,
  IconHomeX: IconHomeX,
  IconHorse: IconHorse,
  IconHorseToy: IconHorseToy,
  IconHorseshoe: IconHorseshoe,
  IconHospital: IconHospital,
  IconHospitalCircle: IconHospitalCircle,
  IconHospitalCircleFilled: IconHospitalCircleFilled,
  IconHotelService: IconHotelService,
  IconHourglass: IconHourglass,
  IconHourglassEmpty: IconHourglassEmpty,
  IconHourglassFilled: IconHourglassFilled,
  IconHourglassHigh: IconHourglassHigh,
  IconHourglassLow: IconHourglassLow,
  IconHourglassOff: IconHourglassOff,
  IconHours12: IconHours12,
  IconHours24: IconHours24,
  IconHtml: IconHtml,
  IconHttpConnect: IconHttpConnect,
  IconHttpConnectOff: IconHttpConnectOff,
  IconHttpDelete: IconHttpDelete,
  IconHttpDeleteOff: IconHttpDeleteOff,
  IconHttpGet: IconHttpGet,
  IconHttpGetOff: IconHttpGetOff,
  IconHttpHead: IconHttpHead,
  IconHttpHeadOff: IconHttpHeadOff,
  IconHttpOptions: IconHttpOptions,
  IconHttpOptionsOff: IconHttpOptionsOff,
  IconHttpPatch: IconHttpPatch,
  IconHttpPatchOff: IconHttpPatchOff,
  IconHttpPost: IconHttpPost,
  IconHttpPostOff: IconHttpPostOff,
  IconHttpPut: IconHttpPut,
  IconHttpPutOff: IconHttpPutOff,
  IconHttpQue: IconHttpQue,
  IconHttpQueOff: IconHttpQueOff,
  IconHttpTrace: IconHttpTrace,
  IconHttpTraceOff: IconHttpTraceOff,
  IconIceCream: IconIceCream,
  IconIceCream2: IconIceCream2,
  IconIceCreamOff: IconIceCreamOff,
  IconIceSkating: IconIceSkating,
  IconIcons: IconIcons,
  IconIconsFilled: IconIconsFilled,
  IconIconsOff: IconIconsOff,
  IconId: IconId,
  IconIdBadge: IconIdBadge,
  IconIdBadge2: IconIdBadge2,
  IconIdBadgeOff: IconIdBadgeOff,
  IconIdOff: IconIdOff,
  IconIkosaedr: IconIkosaedr,
  IconImageInPicture: IconImageInPicture,
  IconInbox: IconInbox,
  IconInboxOff: IconInboxOff,
  IconIndentDecrease: IconIndentDecrease,
  IconIndentIncrease: IconIndentIncrease,
  IconInfinity: IconInfinity,
  IconInfinityOff: IconInfinityOff,
  IconInfoCircle: IconInfoCircle,
  IconInfoCircleFilled: IconInfoCircleFilled,
  IconInfoHexagon: IconInfoHexagon,
  IconInfoHexagonFilled: IconInfoHexagonFilled,
  IconInfoOctagon: IconInfoOctagon,
  IconInfoOctagonFilled: IconInfoOctagonFilled,
  IconInfoSmall: IconInfoSmall,
  IconInfoSquare: IconInfoSquare,
  IconInfoSquareFilled: IconInfoSquareFilled,
  IconInfoSquareRounded: IconInfoSquareRounded,
  IconInfoSquareRoundedFilled: IconInfoSquareRoundedFilled,
  IconInfoTriangle: IconInfoTriangle,
  IconInfoTriangleFilled: IconInfoTriangleFilled,
  IconInnerShadowBottom: IconInnerShadowBottom,
  IconInnerShadowBottomFilled: IconInnerShadowBottomFilled,
  IconInnerShadowBottomLeft: IconInnerShadowBottomLeft,
  IconInnerShadowBottomLeftFilled: IconInnerShadowBottomLeftFilled,
  IconInnerShadowBottomRight: IconInnerShadowBottomRight,
  IconInnerShadowBottomRightFilled: IconInnerShadowBottomRightFilled,
  IconInnerShadowLeft: IconInnerShadowLeft,
  IconInnerShadowLeftFilled: IconInnerShadowLeftFilled,
  IconInnerShadowRight: IconInnerShadowRight,
  IconInnerShadowRightFilled: IconInnerShadowRightFilled,
  IconInnerShadowTop: IconInnerShadowTop,
  IconInnerShadowTopFilled: IconInnerShadowTopFilled,
  IconInnerShadowTopLeft: IconInnerShadowTopLeft,
  IconInnerShadowTopLeftFilled: IconInnerShadowTopLeftFilled,
  IconInnerShadowTopRight: IconInnerShadowTopRight,
  IconInnerShadowTopRightFilled: IconInnerShadowTopRightFilled,
  IconInputAi: IconInputAi,
  IconInputCheck: IconInputCheck,
  IconInputSearch: IconInputSearch,
  IconInputSpark: IconInputSpark,
  IconInputX: IconInputX,
  IconInvoice: IconInvoice,
  IconIroning: IconIroning,
  IconIroning1: IconIroning1,
  IconIroning1Filled: IconIroning1Filled,
  IconIroning2: IconIroning2,
  IconIroning2Filled: IconIroning2Filled,
  IconIroning3: IconIroning3,
  IconIroning3Filled: IconIroning3Filled,
  IconIroningFilled: IconIroningFilled,
  IconIroningOff: IconIroningOff,
  IconIroningSteam: IconIroningSteam,
  IconIroningSteamFilled: IconIroningSteamFilled,
  IconIroningSteamOff: IconIroningSteamOff,
  IconIrregularPolyhedron: IconIrregularPolyhedron,
  IconIrregularPolyhedronOff: IconIrregularPolyhedronOff,
  IconIrregularPolyhedronPlus: IconIrregularPolyhedronPlus,
  IconItalic: IconItalic,
  IconJacket: IconJacket,
  IconJetpack: IconJetpack,
  IconJetpackFilled: IconJetpackFilled,
  IconJewishStar: IconJewishStar,
  IconJewishStarFilled: IconJewishStarFilled,
  IconJoinBevel: IconJoinBevel,
  IconJoinRound: IconJoinRound,
  IconJoinStraight: IconJoinStraight,
  IconJoker: IconJoker,
  IconJpg: IconJpg,
  IconJson: IconJson,
  IconJumpRope: IconJumpRope,
  IconKarate: IconKarate,
  IconKayak: IconKayak,
  IconKerning: IconKerning,
  IconKey: IconKey,
  IconKeyFilled: IconKeyFilled,
  IconKeyOff: IconKeyOff,
  IconKeyboard: IconKeyboard,
  IconKeyboardFilled: IconKeyboardFilled,
  IconKeyboardHide: IconKeyboardHide,
  IconKeyboardOff: IconKeyboardOff,
  IconKeyboardShow: IconKeyboardShow,
  IconKeyframe: IconKeyframe,
  IconKeyframeAlignCenter: IconKeyframeAlignCenter,
  IconKeyframeAlignCenterFilled: IconKeyframeAlignCenterFilled,
  IconKeyframeAlignHorizontal: IconKeyframeAlignHorizontal,
  IconKeyframeAlignHorizontalFilled: IconKeyframeAlignHorizontalFilled,
  IconKeyframeAlignVertical: IconKeyframeAlignVertical,
  IconKeyframeAlignVerticalFilled: IconKeyframeAlignVerticalFilled,
  IconKeyframeFilled: IconKeyframeFilled,
  IconKeyframes: IconKeyframes,
  IconKeyframesFilled: IconKeyframesFilled,
  IconLabel: IconLabel,
  IconLabelFilled: IconLabelFilled,
  IconLabelImportant: IconLabelImportant,
  IconLabelImportantFilled: IconLabelImportantFilled,
  IconLabelOff: IconLabelOff,
  IconLadder: IconLadder,
  IconLadderOff: IconLadderOff,
  IconLadle: IconLadle,
  IconLambda: IconLambda,
  IconLamp: IconLamp,
  IconLamp2: IconLamp2,
  IconLampOff: IconLampOff,
  IconLane: IconLane,
  IconLanguage: IconLanguage,
  IconLanguageHiragana: IconLanguageHiragana,
  IconLanguageKatakana: IconLanguageKatakana,
  IconLanguageOff: IconLanguageOff,
  IconLasso: IconLasso,
  IconLassoOff: IconLassoOff,
  IconLassoPolygon: IconLassoPolygon,
  IconLassoPolygonFilled: IconLassoPolygonFilled,
  IconLaurelWreath: IconLaurelWreath,
  IconLaurelWreath1: IconLaurelWreath1,
  IconLaurelWreath2: IconLaurelWreath2,
  IconLaurelWreath3: IconLaurelWreath3,
  IconLaurelWreathFilled: IconLaurelWreathFilled,
  IconLayersDifference: IconLayersDifference,
  IconLayersIntersect: IconLayersIntersect,
  IconLayersIntersect2: IconLayersIntersect2,
  IconLayersLinked: IconLayersLinked,
  IconLayersOff: IconLayersOff,
  IconLayersSelected: IconLayersSelected,
  IconLayersSelectedBottom: IconLayersSelectedBottom,
  IconLayersSubtract: IconLayersSubtract,
  IconLayersUnion: IconLayersUnion,
  IconLayout: IconLayout,
  IconLayout2: IconLayout2,
  IconLayout2Filled: IconLayout2Filled,
  IconLayoutAlignBottom: IconLayoutAlignBottom,
  IconLayoutAlignBottomFilled: IconLayoutAlignBottomFilled,
  IconLayoutAlignCenter: IconLayoutAlignCenter,
  IconLayoutAlignCenterFilled: IconLayoutAlignCenterFilled,
  IconLayoutAlignLeft: IconLayoutAlignLeft,
  IconLayoutAlignLeftFilled: IconLayoutAlignLeftFilled,
  IconLayoutAlignMiddle: IconLayoutAlignMiddle,
  IconLayoutAlignMiddleFilled: IconLayoutAlignMiddleFilled,
  IconLayoutAlignRight: IconLayoutAlignRight,
  IconLayoutAlignRightFilled: IconLayoutAlignRightFilled,
  IconLayoutAlignTop: IconLayoutAlignTop,
  IconLayoutAlignTopFilled: IconLayoutAlignTopFilled,
  IconLayoutBoard: IconLayoutBoard,
  IconLayoutBoardSplit: IconLayoutBoardSplit,
  IconLayoutBottombar: IconLayoutBottombar,
  IconLayoutBottombarCollapse: IconLayoutBottombarCollapse,
  IconLayoutBottombarCollapseFilled: IconLayoutBottombarCollapseFilled,
  IconLayoutBottombarExpand: IconLayoutBottombarExpand,
  IconLayoutBottombarExpandFilled: IconLayoutBottombarExpandFilled,
  IconLayoutBottombarFilled: IconLayoutBottombarFilled,
  IconLayoutBottombarInactive: IconLayoutBottombarInactive,
  IconLayoutCards: IconLayoutCards,
  IconLayoutCardsFilled: IconLayoutCardsFilled,
  IconLayoutCollage: IconLayoutCollage,
  IconLayoutColumns: IconLayoutColumns,
  IconLayoutDashboard: IconLayoutDashboard,
  IconLayoutDashboardFilled: IconLayoutDashboardFilled,
  IconLayoutDistributeHorizontal: IconLayoutDistributeHorizontal,
  IconLayoutDistributeHorizontalFilled: IconLayoutDistributeHorizontalFilled,
  IconLayoutDistributeVertical: IconLayoutDistributeVertical,
  IconLayoutDistributeVerticalFilled: IconLayoutDistributeVerticalFilled,
  IconLayoutFilled: IconLayoutFilled,
  IconLayoutGrid: IconLayoutGrid,
  IconLayoutGridAdd: IconLayoutGridAdd,
  IconLayoutGridFilled: IconLayoutGridFilled,
  IconLayoutGridRemove: IconLayoutGridRemove,
  IconLayoutKanban: IconLayoutKanban,
  IconLayoutKanbanFilled: IconLayoutKanbanFilled,
  IconLayoutList: IconLayoutList,
  IconLayoutListFilled: IconLayoutListFilled,
  IconLayoutNavbar: IconLayoutNavbar,
  IconLayoutNavbarCollapse: IconLayoutNavbarCollapse,
  IconLayoutNavbarCollapseFilled: IconLayoutNavbarCollapseFilled,
  IconLayoutNavbarExpand: IconLayoutNavbarExpand,
  IconLayoutNavbarExpandFilled: IconLayoutNavbarExpandFilled,
  IconLayoutNavbarFilled: IconLayoutNavbarFilled,
  IconLayoutNavbarInactive: IconLayoutNavbarInactive,
  IconLayoutOff: IconLayoutOff,
  IconLayoutRows: IconLayoutRows,
  IconLayoutSidebar: IconLayoutSidebar,
  IconLayoutSidebarFilled: IconLayoutSidebarFilled,
  IconLayoutSidebarInactive: IconLayoutSidebarInactive,
  IconLayoutSidebarLeftCollapse: IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftCollapseFilled: IconLayoutSidebarLeftCollapseFilled,
  IconLayoutSidebarLeftExpand: IconLayoutSidebarLeftExpand,
  IconLayoutSidebarLeftExpandFilled: IconLayoutSidebarLeftExpandFilled,
  IconLayoutSidebarRight: IconLayoutSidebarRight,
  IconLayoutSidebarRightCollapse: IconLayoutSidebarRightCollapse,
  IconLayoutSidebarRightCollapseFilled: IconLayoutSidebarRightCollapseFilled,
  IconLayoutSidebarRightExpand: IconLayoutSidebarRightExpand,
  IconLayoutSidebarRightExpandFilled: IconLayoutSidebarRightExpandFilled,
  IconLayoutSidebarRightFilled: IconLayoutSidebarRightFilled,
  IconLayoutSidebarRightInactive: IconLayoutSidebarRightInactive,
  IconLeaf: IconLeaf,
  IconLeaf2: IconLeaf2,
  IconLeafOff: IconLeafOff,
  IconLego: IconLego,
  IconLegoFilled: IconLegoFilled,
  IconLegoOff: IconLegoOff,
  IconLemon: IconLemon,
  IconLemon2: IconLemon2,
  IconLemon2Filled: IconLemon2Filled,
  IconLetterA: IconLetterA,
  IconLetterASmall: IconLetterASmall,
  IconLetterB: IconLetterB,
  IconLetterBSmall: IconLetterBSmall,
  IconLetterC: IconLetterC,
  IconLetterCSmall: IconLetterCSmall,
  IconLetterCase: IconLetterCase,
  IconLetterCaseLower: IconLetterCaseLower,
  IconLetterCaseToggle: IconLetterCaseToggle,
  IconLetterCaseUpper: IconLetterCaseUpper,
  IconLetterD: IconLetterD,
  IconLetterDSmall: IconLetterDSmall,
  IconLetterE: IconLetterE,
  IconLetterESmall: IconLetterESmall,
  IconLetterF: IconLetterF,
  IconLetterFSmall: IconLetterFSmall,
  IconLetterG: IconLetterG,
  IconLetterGSmall: IconLetterGSmall,
  IconLetterH: IconLetterH,
  IconLetterHSmall: IconLetterHSmall,
  IconLetterI: IconLetterI,
  IconLetterISmall: IconLetterISmall,
  IconLetterJ: IconLetterJ,
  IconLetterJSmall: IconLetterJSmall,
  IconLetterK: IconLetterK,
  IconLetterKSmall: IconLetterKSmall,
  IconLetterL: IconLetterL,
  IconLetterLSmall: IconLetterLSmall,
  IconLetterM: IconLetterM,
  IconLetterMSmall: IconLetterMSmall,
  IconLetterN: IconLetterN,
  IconLetterNSmall: IconLetterNSmall,
  IconLetterO: IconLetterO,
  IconLetterOSmall: IconLetterOSmall,
  IconLetterP: IconLetterP,
  IconLetterPSmall: IconLetterPSmall,
  IconLetterQ: IconLetterQ,
  IconLetterQSmall: IconLetterQSmall,
  IconLetterR: IconLetterR,
  IconLetterRSmall: IconLetterRSmall,
  IconLetterS: IconLetterS,
  IconLetterSSmall: IconLetterSSmall,
  IconLetterSpacing: IconLetterSpacing,
  IconLetterT: IconLetterT,
  IconLetterTSmall: IconLetterTSmall,
  IconLetterU: IconLetterU,
  IconLetterUSmall: IconLetterUSmall,
  IconLetterV: IconLetterV,
  IconLetterVSmall: IconLetterVSmall,
  IconLetterW: IconLetterW,
  IconLetterWSmall: IconLetterWSmall,
  IconLetterX: IconLetterX,
  IconLetterXSmall: IconLetterXSmall,
  IconLetterY: IconLetterY,
  IconLetterYSmall: IconLetterYSmall,
  IconLetterZ: IconLetterZ,
  IconLetterZSmall: IconLetterZSmall,
  IconLibrary: IconLibrary,
  IconLibraryMinus: IconLibraryMinus,
  IconLibraryPhoto: IconLibraryPhoto,
  IconLibraryPlus: IconLibraryPlus,
  IconLicense: IconLicense,
  IconLicenseOff: IconLicenseOff,
  IconLifebuoy: IconLifebuoy,
  IconLifebuoyFilled: IconLifebuoyFilled,
  IconLifebuoyOff: IconLifebuoyOff,
  IconLighter: IconLighter,
  IconLine: IconLine,
  IconLineDashed: IconLineDashed,
  IconLineDotted: IconLineDotted,
  IconLineHeight: IconLineHeight,
  IconLineScan: IconLineScan,
  IconLink: IconLink,
  IconLinkMinus: IconLinkMinus,
  IconLinkOff: IconLinkOff,
  IconLinkPlus: IconLinkPlus,
  IconList: IconList,
  IconListCheck: IconListCheck,
  IconListDetails: IconListDetails,
  IconListLetters: IconListLetters,
  IconListNumbers: IconListNumbers,
  IconListSearch: IconListSearch,
  IconListTree: IconListTree,
  IconLivePhoto: IconLivePhoto,
  IconLivePhotoFilled: IconLivePhotoFilled,
  IconLivePhotoOff: IconLivePhotoOff,
  IconLiveView: IconLiveView,
  IconLiveViewFilled: IconLiveViewFilled,
  IconLoadBalancer: IconLoadBalancer,
  IconLoader: IconLoader,
  IconLoader2: IconLoader2,
  IconLoader3: IconLoader3,
  IconLoaderQuarter: IconLoaderQuarter,
  IconLocation: IconLocation,
  IconLocationBolt: IconLocationBolt,
  IconLocationBroken: IconLocationBroken,
  IconLocationCancel: IconLocationCancel,
  IconLocationCheck: IconLocationCheck,
  IconLocationCode: IconLocationCode,
  IconLocationCog: IconLocationCog,
  IconLocationDiscount: IconLocationDiscount,
  IconLocationDollar: IconLocationDollar,
  IconLocationDown: IconLocationDown,
  IconLocationExclamation: IconLocationExclamation,
  IconLocationFilled: IconLocationFilled,
  IconLocationHeart: IconLocationHeart,
  IconLocationMinus: IconLocationMinus,
  IconLocationOff: IconLocationOff,
  IconLocationPause: IconLocationPause,
  IconLocationPin: IconLocationPin,
  IconLocationPlus: IconLocationPlus,
  IconLocationQuestion: IconLocationQuestion,
  IconLocationSearch: IconLocationSearch,
  IconLocationShare: IconLocationShare,
  IconLocationStar: IconLocationStar,
  IconLocationUp: IconLocationUp,
  IconLocationX: IconLocationX,
  IconLock: IconLock,
  IconLockAccess: IconLockAccess,
  IconLockAccessOff: IconLockAccessOff,
  IconLockBitcoin: IconLockBitcoin,
  IconLockBolt: IconLockBolt,
  IconLockCancel: IconLockCancel,
  IconLockCheck: IconLockCheck,
  IconLockCode: IconLockCode,
  IconLockCog: IconLockCog,
  IconLockDollar: IconLockDollar,
  IconLockDown: IconLockDown,
  IconLockExclamation: IconLockExclamation,
  IconLockFilled: IconLockFilled,
  IconLockHeart: IconLockHeart,
  IconLockMinus: IconLockMinus,
  IconLockOff: IconLockOff,
  IconLockOpen: IconLockOpen,
  IconLockOpen2: IconLockOpen2,
  IconLockOpenOff: IconLockOpenOff,
  IconLockPassword: IconLockPassword,
  IconLockPause: IconLockPause,
  IconLockPin: IconLockPin,
  IconLockPlus: IconLockPlus,
  IconLockQuestion: IconLockQuestion,
  IconLockSearch: IconLockSearch,
  IconLockShare: IconLockShare,
  IconLockSquare: IconLockSquare,
  IconLockSquareRounded: IconLockSquareRounded,
  IconLockSquareRoundedFilled: IconLockSquareRoundedFilled,
  IconLockStar: IconLockStar,
  IconLockUp: IconLockUp,
  IconLockX: IconLockX,
  IconLogicAnd: IconLogicAnd,
  IconLogicBuffer: IconLogicBuffer,
  IconLogicNand: IconLogicNand,
  IconLogicNor: IconLogicNor,
  IconLogicNot: IconLogicNot,
  IconLogicOr: IconLogicOr,
  IconLogicXnor: IconLogicXnor,
  IconLogicXor: IconLogicXor,
  IconLogin: IconLogin,
  IconLogin2: IconLogin2,
  IconLogout: IconLogout,
  IconLogout2: IconLogout2,
  IconLogs: IconLogs,
  IconLollipop: IconLollipop,
  IconLollipopOff: IconLollipopOff,
  IconLuggage: IconLuggage,
  IconLuggageOff: IconLuggageOff,
  IconLungs: IconLungs,
  IconLungsFilled: IconLungsFilled,
  IconLungsOff: IconLungsOff,
  IconMacro: IconMacro,
  IconMacroFilled: IconMacroFilled,
  IconMacroOff: IconMacroOff,
  IconMagnet: IconMagnet,
  IconMagnetFilled: IconMagnetFilled,
  IconMagnetOff: IconMagnetOff,
  IconMagnetic: IconMagnetic,
  IconMail: IconMail,
  IconMailAi: IconMailAi,
  IconMailBitcoin: IconMailBitcoin,
  IconMailBolt: IconMailBolt,
  IconMailCancel: IconMailCancel,
  IconMailCheck: IconMailCheck,
  IconMailCode: IconMailCode,
  IconMailCog: IconMailCog,
  IconMailDollar: IconMailDollar,
  IconMailDown: IconMailDown,
  IconMailExclamation: IconMailExclamation,
  IconMailFast: IconMailFast,
  IconMailFilled: IconMailFilled,
  IconMailForward: IconMailForward,
  IconMailHeart: IconMailHeart,
  IconMailMinus: IconMailMinus,
  IconMailOff: IconMailOff,
  IconMailOpened: IconMailOpened,
  IconMailOpenedFilled: IconMailOpenedFilled,
  IconMailPause: IconMailPause,
  IconMailPin: IconMailPin,
  IconMailPlus: IconMailPlus,
  IconMailQuestion: IconMailQuestion,
  IconMailSearch: IconMailSearch,
  IconMailShare: IconMailShare,
  IconMailSpark: IconMailSpark,
  IconMailStar: IconMailStar,
  IconMailUp: IconMailUp,
  IconMailX: IconMailX,
  IconMailbox: IconMailbox,
  IconMailboxOff: IconMailboxOff,
  IconMan: IconMan,
  IconManFilled: IconManFilled,
  IconManualGearbox: IconManualGearbox,
  IconManualGearboxFilled: IconManualGearboxFilled,
  IconMap: IconMap,
  IconMap2: IconMap2,
  IconMapBolt: IconMapBolt,
  IconMapCancel: IconMapCancel,
  IconMapCheck: IconMapCheck,
  IconMapCode: IconMapCode,
  IconMapCog: IconMapCog,
  IconMapDiscount: IconMapDiscount,
  IconMapDollar: IconMapDollar,
  IconMapDown: IconMapDown,
  IconMapEast: IconMapEast,
  IconMapExclamation: IconMapExclamation,
  IconMapHeart: IconMapHeart,
  IconMapMinus: IconMapMinus,
  IconMapNorth: IconMapNorth,
  IconMapOff: IconMapOff,
  IconMapPause: IconMapPause,
  IconMapPin: IconMapPin,
  IconMapPin2: IconMapPin2,
  IconMapPinBolt: IconMapPinBolt,
  IconMapPinCancel: IconMapPinCancel,
  IconMapPinCheck: IconMapPinCheck,
  IconMapPinCode: IconMapPinCode,
  IconMapPinCog: IconMapPinCog,
  IconMapPinDollar: IconMapPinDollar,
  IconMapPinDown: IconMapPinDown,
  IconMapPinExclamation: IconMapPinExclamation,
  IconMapPinFilled: IconMapPinFilled,
  IconMapPinHeart: IconMapPinHeart,
  IconMapPinMinus: IconMapPinMinus,
  IconMapPinOff: IconMapPinOff,
  IconMapPinPause: IconMapPinPause,
  IconMapPinPin: IconMapPinPin,
  IconMapPinPlus: IconMapPinPlus,
  IconMapPinQuestion: IconMapPinQuestion,
  IconMapPinSearch: IconMapPinSearch,
  IconMapPinShare: IconMapPinShare,
  IconMapPinStar: IconMapPinStar,
  IconMapPinUp: IconMapPinUp,
  IconMapPinX: IconMapPinX,
  IconMapPins: IconMapPins,
  IconMapPlus: IconMapPlus,
  IconMapQuestion: IconMapQuestion,
  IconMapRoute: IconMapRoute,
  IconMapSearch: IconMapSearch,
  IconMapShare: IconMapShare,
  IconMapSouth: IconMapSouth,
  IconMapStar: IconMapStar,
  IconMapUp: IconMapUp,
  IconMapWest: IconMapWest,
  IconMapX: IconMapX,
  IconMarkdown: IconMarkdown,
  IconMarkdownOff: IconMarkdownOff,
  IconMarquee: IconMarquee,
  IconMarquee2: IconMarquee2,
  IconMarqueeOff: IconMarqueeOff,
  IconMars: IconMars,
  IconMask: IconMask,
  IconMaskOff: IconMaskOff,
  IconMasksTheater: IconMasksTheater,
  IconMasksTheaterOff: IconMasksTheaterOff,
  IconMassage: IconMassage,
  IconMatchstick: IconMatchstick,
  IconMath: IconMath,
  IconMath1Divide2: IconMath1Divide2,
  IconMath1Divide3: IconMath1Divide3,
  IconMathAvg: IconMathAvg,
  IconMathCos: IconMathCos,
  IconMathCtg: IconMathCtg,
  IconMathEqualGreater: IconMathEqualGreater,
  IconMathEqualLower: IconMathEqualLower,
  IconMathFunction: IconMathFunction,
  IconMathFunctionOff: IconMathFunctionOff,
  IconMathFunctionY: IconMathFunctionY,
  IconMathGreater: IconMathGreater,
  IconMathIntegral: IconMathIntegral,
  IconMathIntegralX: IconMathIntegralX,
  IconMathIntegrals: IconMathIntegrals,
  IconMathLower: IconMathLower,
  IconMathMax: IconMathMax,
  IconMathMaxMin: IconMathMaxMin,
  IconMathMin: IconMathMin,
  IconMathNot: IconMathNot,
  IconMathOff: IconMathOff,
  IconMathPi: IconMathPi,
  IconMathPiDivide2: IconMathPiDivide2,
  IconMathSec: IconMathSec,
  IconMathSin: IconMathSin,
  IconMathSymbols: IconMathSymbols,
  IconMathTg: IconMathTg,
  IconMathXDivide2: IconMathXDivide2,
  IconMathXDivideY: IconMathXDivideY,
  IconMathXDivideY2: IconMathXDivideY2,
  IconMathXFloorDivideY: IconMathXFloorDivideY,
  IconMathXMinusX: IconMathXMinusX,
  IconMathXMinusY: IconMathXMinusY,
  IconMathXPlusX: IconMathXPlusX,
  IconMathXPlusY: IconMathXPlusY,
  IconMathXy: IconMathXy,
  IconMathYMinusY: IconMathYMinusY,
  IconMathYPlusY: IconMathYPlusY,
  IconMatrix: IconMatrix,
  IconMaximize: IconMaximize,
  IconMaximizeOff: IconMaximizeOff,
  IconMeat: IconMeat,
  IconMeatOff: IconMeatOff,
  IconMedal: IconMedal,
  IconMedal2: IconMedal2,
  IconMedicalCross: IconMedicalCross,
  IconMedicalCrossCircle: IconMedicalCrossCircle,
  IconMedicalCrossFilled: IconMedicalCrossFilled,
  IconMedicalCrossOff: IconMedicalCrossOff,
  IconMedicineSyrup: IconMedicineSyrup,
  IconMeeple: IconMeeple,
  IconMeepleFilled: IconMeepleFilled,
  IconMelon: IconMelon,
  IconMelonFilled: IconMelonFilled,
  IconMenorah: IconMenorah,
  IconMenu: IconMenu,
  IconMenu2: IconMenu2,
  IconMenu3: IconMenu3,
  IconMenu4: IconMenu4,
  IconMenuDeep: IconMenuDeep,
  IconMenuOrder: IconMenuOrder,
  IconMessage: IconMessage,
  IconMessage2: IconMessage2,
  IconMessage2Bolt: IconMessage2Bolt,
  IconMessage2Cancel: IconMessage2Cancel,
  IconMessage2Check: IconMessage2Check,
  IconMessage2Code: IconMessage2Code,
  IconMessage2Cog: IconMessage2Cog,
  IconMessage2Dollar: IconMessage2Dollar,
  IconMessage2Down: IconMessage2Down,
  IconMessage2Exclamation: IconMessage2Exclamation,
  IconMessage2Filled: IconMessage2Filled,
  IconMessage2Heart: IconMessage2Heart,
  IconMessage2Minus: IconMessage2Minus,
  IconMessage2Off: IconMessage2Off,
  IconMessage2Pause: IconMessage2Pause,
  IconMessage2Pin: IconMessage2Pin,
  IconMessage2Plus: IconMessage2Plus,
  IconMessage2Question: IconMessage2Question,
  IconMessage2Search: IconMessage2Search,
  IconMessage2Share: IconMessage2Share,
  IconMessage2Star: IconMessage2Star,
  IconMessage2Up: IconMessage2Up,
  IconMessage2X: IconMessage2X,
  IconMessageBolt: IconMessageBolt,
  IconMessageCancel: IconMessageCancel,
  IconMessageChatbot: IconMessageChatbot,
  IconMessageChatbotFilled: IconMessageChatbotFilled,
  IconMessageCheck: IconMessageCheck,
  IconMessageCircle: IconMessageCircle,
  IconMessageCircleBolt: IconMessageCircleBolt,
  IconMessageCircleCancel: IconMessageCircleCancel,
  IconMessageCircleCheck: IconMessageCircleCheck,
  IconMessageCircleCode: IconMessageCircleCode,
  IconMessageCircleCog: IconMessageCircleCog,
  IconMessageCircleDollar: IconMessageCircleDollar,
  IconMessageCircleDown: IconMessageCircleDown,
  IconMessageCircleExclamation: IconMessageCircleExclamation,
  IconMessageCircleFilled: IconMessageCircleFilled,
  IconMessageCircleHeart: IconMessageCircleHeart,
  IconMessageCircleMinus: IconMessageCircleMinus,
  IconMessageCircleOff: IconMessageCircleOff,
  IconMessageCirclePause: IconMessageCirclePause,
  IconMessageCirclePin: IconMessageCirclePin,
  IconMessageCirclePlus: IconMessageCirclePlus,
  IconMessageCircleQuestion: IconMessageCircleQuestion,
  IconMessageCircleSearch: IconMessageCircleSearch,
  IconMessageCircleShare: IconMessageCircleShare,
  IconMessageCircleStar: IconMessageCircleStar,
  IconMessageCircleUp: IconMessageCircleUp,
  IconMessageCircleUser: IconMessageCircleUser,
  IconMessageCircleX: IconMessageCircleX,
  IconMessageCode: IconMessageCode,
  IconMessageCog: IconMessageCog,
  IconMessageDollar: IconMessageDollar,
  IconMessageDots: IconMessageDots,
  IconMessageDown: IconMessageDown,
  IconMessageExclamation: IconMessageExclamation,
  IconMessageFilled: IconMessageFilled,
  IconMessageForward: IconMessageForward,
  IconMessageHeart: IconMessageHeart,
  IconMessageLanguage: IconMessageLanguage,
  IconMessageMinus: IconMessageMinus,
  IconMessageOff: IconMessageOff,
  IconMessagePause: IconMessagePause,
  IconMessagePin: IconMessagePin,
  IconMessagePlus: IconMessagePlus,
  IconMessageQuestion: IconMessageQuestion,
  IconMessageReply: IconMessageReply,
  IconMessageReport: IconMessageReport,
  IconMessageReportFilled: IconMessageReportFilled,
  IconMessageSearch: IconMessageSearch,
  IconMessageShare: IconMessageShare,
  IconMessageStar: IconMessageStar,
  IconMessageUp: IconMessageUp,
  IconMessageUser: IconMessageUser,
  IconMessageX: IconMessageX,
  IconMessages: IconMessages,
  IconMessagesOff: IconMessagesOff,
  IconMeteor: IconMeteor,
  IconMeteorFilled: IconMeteorFilled,
  IconMeteorOff: IconMeteorOff,
  IconMeterCube: IconMeterCube,
  IconMeterSquare: IconMeterSquare,
  IconMetronome: IconMetronome,
  IconMichelinBibGourmand: IconMichelinBibGourmand,
  IconMichelinStar: IconMichelinStar,
  IconMichelinStarFilled: IconMichelinStarFilled,
  IconMichelinStarGreen: IconMichelinStarGreen,
  IconMickey: IconMickey,
  IconMickeyFilled: IconMickeyFilled,
  IconMicrophone: IconMicrophone,
  IconMicrophone2: IconMicrophone2,
  IconMicrophone2Off: IconMicrophone2Off,
  IconMicrophoneFilled: IconMicrophoneFilled,
  IconMicrophoneOff: IconMicrophoneOff,
  IconMicroscope: IconMicroscope,
  IconMicroscopeOff: IconMicroscopeOff,
  IconMicrowave: IconMicrowave,
  IconMicrowaveFilled: IconMicrowaveFilled,
  IconMicrowaveOff: IconMicrowaveOff,
  IconMilitaryAward: IconMilitaryAward,
  IconMilitaryRank: IconMilitaryRank,
  IconMilitaryRankFilled: IconMilitaryRankFilled,
  IconMilk: IconMilk,
  IconMilkFilled: IconMilkFilled,
  IconMilkOff: IconMilkOff,
  IconMilkshake: IconMilkshake,
  IconMinimize: IconMinimize,
  IconMinus: IconMinus,
  IconMinusVertical: IconMinusVertical,
  IconMist: IconMist,
  IconMistOff: IconMistOff,
  IconMobiledata: IconMobiledata,
  IconMobiledataOff: IconMobiledataOff,
  IconMoneybag: IconMoneybag,
  IconMoneybagEdit: IconMoneybagEdit,
  IconMoneybagHeart: IconMoneybagHeart,
  IconMoneybagMinus: IconMoneybagMinus,
  IconMoneybagMove: IconMoneybagMove,
  IconMoneybagMoveBack: IconMoneybagMoveBack,
  IconMoneybagPlus: IconMoneybagPlus,
  IconMonkeybar: IconMonkeybar,
  IconMoodAngry: IconMoodAngry,
  IconMoodAngryFilled: IconMoodAngryFilled,
  IconMoodAnnoyed: IconMoodAnnoyed,
  IconMoodAnnoyed2: IconMoodAnnoyed2,
  IconMoodBitcoin: IconMoodBitcoin,
  IconMoodBoy: IconMoodBoy,
  IconMoodCheck: IconMoodCheck,
  IconMoodCog: IconMoodCog,
  IconMoodConfuzed: IconMoodConfuzed,
  IconMoodConfuzedFilled: IconMoodConfuzedFilled,
  IconMoodCrazyHappy: IconMoodCrazyHappy,
  IconMoodCrazyHappyFilled: IconMoodCrazyHappyFilled,
  IconMoodCry: IconMoodCry,
  IconMoodDollar: IconMoodDollar,
  IconMoodEdit: IconMoodEdit,
  IconMoodEmpty: IconMoodEmpty,
  IconMoodEmptyFilled: IconMoodEmptyFilled,
  IconMoodHappy: IconMoodHappy,
  IconMoodHappyFilled: IconMoodHappyFilled,
  IconMoodHeart: IconMoodHeart,
  IconMoodKid: IconMoodKid,
  IconMoodKidFilled: IconMoodKidFilled,
  IconMoodLookDown: IconMoodLookDown,
  IconMoodLookLeft: IconMoodLookLeft,
  IconMoodLookRight: IconMoodLookRight,
  IconMoodLookUp: IconMoodLookUp,
  IconMoodMinus: IconMoodMinus,
  IconMoodNerd: IconMoodNerd,
  IconMoodNervous: IconMoodNervous,
  IconMoodNeutral: IconMoodNeutral,
  IconMoodNeutralFilled: IconMoodNeutralFilled,
  IconMoodOff: IconMoodOff,
  IconMoodPin: IconMoodPin,
  IconMoodPlus: IconMoodPlus,
  IconMoodPuzzled: IconMoodPuzzled,
  IconMoodSad: IconMoodSad,
  IconMoodSad2: IconMoodSad2,
  IconMoodSadDizzy: IconMoodSadDizzy,
  IconMoodSadFilled: IconMoodSadFilled,
  IconMoodSadSquint: IconMoodSadSquint,
  IconMoodSearch: IconMoodSearch,
  IconMoodShare: IconMoodShare,
  IconMoodSick: IconMoodSick,
  IconMoodSilence: IconMoodSilence,
  IconMoodSing: IconMoodSing,
  IconMoodSmile: IconMoodSmile,
  IconMoodSmileBeam: IconMoodSmileBeam,
  IconMoodSmileDizzy: IconMoodSmileDizzy,
  IconMoodSmileFilled: IconMoodSmileFilled,
  IconMoodSpark: IconMoodSpark,
  IconMoodSurprised: IconMoodSurprised,
  IconMoodTongue: IconMoodTongue,
  IconMoodTongueWink: IconMoodTongueWink,
  IconMoodTongueWink2: IconMoodTongueWink2,
  IconMoodUnamused: IconMoodUnamused,
  IconMoodUp: IconMoodUp,
  IconMoodWink: IconMoodWink,
  IconMoodWink2: IconMoodWink2,
  IconMoodWrrr: IconMoodWrrr,
  IconMoodWrrrFilled: IconMoodWrrrFilled,
  IconMoodX: IconMoodX,
  IconMoodXd: IconMoodXd,
  IconMoon: IconMoon,
  IconMoon2: IconMoon2,
  IconMoonFilled: IconMoonFilled,
  IconMoonOff: IconMoonOff,
  IconMoonStars: IconMoonStars,
  IconMoped: IconMoped,
  IconMotorbike: IconMotorbike,
  IconMotorbikeFilled: IconMotorbikeFilled,
  IconMountain: IconMountain,
  IconMountainFilled: IconMountainFilled,
  IconMountainOff: IconMountainOff,
  IconMouse: IconMouse,
  IconMouse2: IconMouse2,
  IconMouseFilled: IconMouseFilled,
  IconMouseOff: IconMouseOff,
  IconMoustache: IconMoustache,
  IconMovie: IconMovie,
  IconMovieOff: IconMovieOff,
  IconMug: IconMug,
  IconMugFilled: IconMugFilled,
  IconMugOff: IconMugOff,
  IconMultiplier05x: IconMultiplier05x,
  IconMultiplier15x: IconMultiplier15x,
  IconMultiplier1x: IconMultiplier1x,
  IconMultiplier2x: IconMultiplier2x,
  IconMushroom: IconMushroom,
  IconMushroomFilled: IconMushroomFilled,
  IconMushroomOff: IconMushroomOff,
  IconMusic: IconMusic,
  IconMusicBolt: IconMusicBolt,
  IconMusicCancel: IconMusicCancel,
  IconMusicCheck: IconMusicCheck,
  IconMusicCode: IconMusicCode,
  IconMusicCog: IconMusicCog,
  IconMusicDiscount: IconMusicDiscount,
  IconMusicDollar: IconMusicDollar,
  IconMusicDown: IconMusicDown,
  IconMusicExclamation: IconMusicExclamation,
  IconMusicHeart: IconMusicHeart,
  IconMusicMinus: IconMusicMinus,
  IconMusicOff: IconMusicOff,
  IconMusicPause: IconMusicPause,
  IconMusicPin: IconMusicPin,
  IconMusicPlus: IconMusicPlus,
  IconMusicQuestion: IconMusicQuestion,
  IconMusicSearch: IconMusicSearch,
  IconMusicShare: IconMusicShare,
  IconMusicStar: IconMusicStar,
  IconMusicUp: IconMusicUp,
  IconMusicX: IconMusicX,
  IconNavigation: IconNavigation,
  IconNavigationBolt: IconNavigationBolt,
  IconNavigationCancel: IconNavigationCancel,
  IconNavigationCheck: IconNavigationCheck,
  IconNavigationCode: IconNavigationCode,
  IconNavigationCog: IconNavigationCog,
  IconNavigationDiscount: IconNavigationDiscount,
  IconNavigationDollar: IconNavigationDollar,
  IconNavigationDown: IconNavigationDown,
  IconNavigationEast: IconNavigationEast,
  IconNavigationExclamation: IconNavigationExclamation,
  IconNavigationFilled: IconNavigationFilled,
  IconNavigationHeart: IconNavigationHeart,
  IconNavigationMinus: IconNavigationMinus,
  IconNavigationNorth: IconNavigationNorth,
  IconNavigationOff: IconNavigationOff,
  IconNavigationPause: IconNavigationPause,
  IconNavigationPin: IconNavigationPin,
  IconNavigationPlus: IconNavigationPlus,
  IconNavigationQuestion: IconNavigationQuestion,
  IconNavigationSearch: IconNavigationSearch,
  IconNavigationShare: IconNavigationShare,
  IconNavigationSouth: IconNavigationSouth,
  IconNavigationStar: IconNavigationStar,
  IconNavigationTop: IconNavigationTop,
  IconNavigationUp: IconNavigationUp,
  IconNavigationWest: IconNavigationWest,
  IconNavigationX: IconNavigationX,
  IconNeedle: IconNeedle,
  IconNeedleThread: IconNeedleThread,
  IconNetwork: IconNetwork,
  IconNetworkOff: IconNetworkOff,
  IconNewSection: IconNewSection,
  IconNews: IconNews,
  IconNewsOff: IconNewsOff,
  IconNfc: IconNfc,
  IconNfcOff: IconNfcOff,
  IconNoCopyright: IconNoCopyright,
  IconNoCreativeCommons: IconNoCreativeCommons,
  IconNoDerivatives: IconNoDerivatives,
  IconNorthStar: IconNorthStar,
  IconNote: IconNote,
  IconNoteOff: IconNoteOff,
  IconNotebook: IconNotebook,
  IconNotebookOff: IconNotebookOff,
  IconNotes: IconNotes,
  IconNotesOff: IconNotesOff,
  IconNotification: IconNotification,
  IconNotificationOff: IconNotificationOff,
  IconNumber: IconNumber,
  IconNumber0: IconNumber0,
  IconNumber0Small: IconNumber0Small,
  IconNumber1: IconNumber1,
  IconNumber10: IconNumber10,
  IconNumber100Small: IconNumber100Small,
  IconNumber10Small: IconNumber10Small,
  IconNumber11: IconNumber11,
  IconNumber11Small: IconNumber11Small,
  IconNumber123: IconNumber123,
  IconNumber12Small: IconNumber12Small,
  IconNumber13Small: IconNumber13Small,
  IconNumber14Small: IconNumber14Small,
  IconNumber15Small: IconNumber15Small,
  IconNumber16Small: IconNumber16Small,
  IconNumber17Small: IconNumber17Small,
  IconNumber18Small: IconNumber18Small,
  IconNumber19Small: IconNumber19Small,
  IconNumber1Small: IconNumber1Small,
  IconNumber2: IconNumber2,
  IconNumber20Small: IconNumber20Small,
  IconNumber21Small: IconNumber21Small,
  IconNumber22Small: IconNumber22Small,
  IconNumber23Small: IconNumber23Small,
  IconNumber24Small: IconNumber24Small,
  IconNumber25Small: IconNumber25Small,
  IconNumber26Small: IconNumber26Small,
  IconNumber27Small: IconNumber27Small,
  IconNumber28Small: IconNumber28Small,
  IconNumber29Small: IconNumber29Small,
  IconNumber2Small: IconNumber2Small,
  IconNumber3: IconNumber3,
  IconNumber30Small: IconNumber30Small,
  IconNumber31Small: IconNumber31Small,
  IconNumber32Small: IconNumber32Small,
  IconNumber33Small: IconNumber33Small,
  IconNumber34Small: IconNumber34Small,
  IconNumber35Small: IconNumber35Small,
  IconNumber36Small: IconNumber36Small,
  IconNumber37Small: IconNumber37Small,
  IconNumber38Small: IconNumber38Small,
  IconNumber39Small: IconNumber39Small,
  IconNumber3Small: IconNumber3Small,
  IconNumber4: IconNumber4,
  IconNumber40Small: IconNumber40Small,
  IconNumber41Small: IconNumber41Small,
  IconNumber42Small: IconNumber42Small,
  IconNumber43Small: IconNumber43Small,
  IconNumber44Small: IconNumber44Small,
  IconNumber45Small: IconNumber45Small,
  IconNumber46Small: IconNumber46Small,
  IconNumber47Small: IconNumber47Small,
  IconNumber48Small: IconNumber48Small,
  IconNumber49Small: IconNumber49Small,
  IconNumber4Small: IconNumber4Small,
  IconNumber5: IconNumber5,
  IconNumber50Small: IconNumber50Small,
  IconNumber51Small: IconNumber51Small,
  IconNumber52Small: IconNumber52Small,
  IconNumber53Small: IconNumber53Small,
  IconNumber54Small: IconNumber54Small,
  IconNumber55Small: IconNumber55Small,
  IconNumber56Small: IconNumber56Small,
  IconNumber57Small: IconNumber57Small,
  IconNumber58Small: IconNumber58Small,
  IconNumber59Small: IconNumber59Small,
  IconNumber5Small: IconNumber5Small,
  IconNumber6: IconNumber6,
  IconNumber60Small: IconNumber60Small,
  IconNumber61Small: IconNumber61Small,
  IconNumber62Small: IconNumber62Small,
  IconNumber63Small: IconNumber63Small,
  IconNumber64Small: IconNumber64Small,
  IconNumber65Small: IconNumber65Small,
  IconNumber66Small: IconNumber66Small,
  IconNumber67Small: IconNumber67Small,
  IconNumber68Small: IconNumber68Small,
  IconNumber69Small: IconNumber69Small,
  IconNumber6Small: IconNumber6Small,
  IconNumber7: IconNumber7,
  IconNumber70Small: IconNumber70Small,
  IconNumber71Small: IconNumber71Small,
  IconNumber72Small: IconNumber72Small,
  IconNumber73Small: IconNumber73Small,
  IconNumber74Small: IconNumber74Small,
  IconNumber75Small: IconNumber75Small,
  IconNumber76Small: IconNumber76Small,
  IconNumber77Small: IconNumber77Small,
  IconNumber78Small: IconNumber78Small,
  IconNumber79Small: IconNumber79Small,
  IconNumber7Small: IconNumber7Small,
  IconNumber8: IconNumber8,
  IconNumber80Small: IconNumber80Small,
  IconNumber81Small: IconNumber81Small,
  IconNumber82Small: IconNumber82Small,
  IconNumber83Small: IconNumber83Small,
  IconNumber84Small: IconNumber84Small,
  IconNumber85Small: IconNumber85Small,
  IconNumber86Small: IconNumber86Small,
  IconNumber87Small: IconNumber87Small,
  IconNumber88Small: IconNumber88Small,
  IconNumber89Small: IconNumber89Small,
  IconNumber8Small: IconNumber8Small,
  IconNumber9: IconNumber9,
  IconNumber90Small: IconNumber90Small,
  IconNumber91Small: IconNumber91Small,
  IconNumber92Small: IconNumber92Small,
  IconNumber93Small: IconNumber93Small,
  IconNumber94Small: IconNumber94Small,
  IconNumber95Small: IconNumber95Small,
  IconNumber96Small: IconNumber96Small,
  IconNumber97Small: IconNumber97Small,
  IconNumber98Small: IconNumber98Small,
  IconNumber99Small: IconNumber99Small,
  IconNumber9Small: IconNumber9Small,
  IconNumbers: IconNumbers,
  IconNurse: IconNurse,
  IconNurseFilled: IconNurseFilled,
  IconNut: IconNut,
  IconObjectScan: IconObjectScan,
  IconOctagon: IconOctagon,
  IconOctagonFilled: IconOctagonFilled,
  IconOctagonMinus: IconOctagonMinus,
  IconOctagonMinus2: IconOctagonMinus2,
  IconOctagonOff: IconOctagonOff,
  IconOctagonPlus: IconOctagonPlus,
  IconOctagonPlus2: IconOctagonPlus2,
  IconOctahedron: IconOctahedron,
  IconOctahedronOff: IconOctahedronOff,
  IconOctahedronPlus: IconOctahedronPlus,
  IconOld: IconOld,
  IconOlympics: IconOlympics,
  IconOlympicsOff: IconOlympicsOff,
  IconOm: IconOm,
  IconOmega: IconOmega,
  IconOutbound: IconOutbound,
  IconOutlet: IconOutlet,
  IconOval: IconOval,
  IconOvalFilled: IconOvalFilled,
  IconOvalVertical: IconOvalVertical,
  IconOvalVerticalFilled: IconOvalVerticalFilled,
  IconOverline: IconOverline,
  IconPackage: IconPackage,
  IconPackageExport: IconPackageExport,
  IconPackageImport: IconPackageImport,
  IconPackageOff: IconPackageOff,
  IconPackages: IconPackages,
  IconPacman: IconPacman,
  IconPageBreak: IconPageBreak,
  IconPaint: IconPaint,
  IconPaintFilled: IconPaintFilled,
  IconPaintOff: IconPaintOff,
  IconPalette: IconPalette,
  IconPaletteFilled: IconPaletteFilled,
  IconPaletteOff: IconPaletteOff,
  IconPanoramaHorizontal: IconPanoramaHorizontal,
  IconPanoramaHorizontalFilled: IconPanoramaHorizontalFilled,
  IconPanoramaHorizontalOff: IconPanoramaHorizontalOff,
  IconPanoramaVertical: IconPanoramaVertical,
  IconPanoramaVerticalFilled: IconPanoramaVerticalFilled,
  IconPanoramaVerticalOff: IconPanoramaVerticalOff,
  IconPaperBag: IconPaperBag,
  IconPaperBagOff: IconPaperBagOff,
  IconPaperclip: IconPaperclip,
  IconParachute: IconParachute,
  IconParachuteOff: IconParachuteOff,
  IconParentheses: IconParentheses,
  IconParenthesesOff: IconParenthesesOff,
  IconParking: IconParking,
  IconParkingCircle: IconParkingCircle,
  IconParkingCircleFilled: IconParkingCircleFilled,
  IconParkingOff: IconParkingOff,
  IconPassword: IconPassword,
  IconPasswordFingerprint: IconPasswordFingerprint,
  IconPasswordMobilePhone: IconPasswordMobilePhone,
  IconPasswordUser: IconPasswordUser,
  IconPaw: IconPaw,
  IconPawFilled: IconPawFilled,
  IconPawOff: IconPawOff,
  IconPaywall: IconPaywall,
  IconPdf: IconPdf,
  IconPeace: IconPeace,
  IconPencil: IconPencil,
  IconPencilBolt: IconPencilBolt,
  IconPencilCancel: IconPencilCancel,
  IconPencilCheck: IconPencilCheck,
  IconPencilCode: IconPencilCode,
  IconPencilCog: IconPencilCog,
  IconPencilDiscount: IconPencilDiscount,
  IconPencilDollar: IconPencilDollar,
  IconPencilDown: IconPencilDown,
  IconPencilExclamation: IconPencilExclamation,
  IconPencilHeart: IconPencilHeart,
  IconPencilMinus: IconPencilMinus,
  IconPencilOff: IconPencilOff,
  IconPencilPause: IconPencilPause,
  IconPencilPin: IconPencilPin,
  IconPencilPlus: IconPencilPlus,
  IconPencilQuestion: IconPencilQuestion,
  IconPencilSearch: IconPencilSearch,
  IconPencilShare: IconPencilShare,
  IconPencilStar: IconPencilStar,
  IconPencilUp: IconPencilUp,
  IconPencilX: IconPencilX,
  IconPennant: IconPennant,
  IconPennant2: IconPennant2,
  IconPennant2Filled: IconPennant2Filled,
  IconPennantFilled: IconPennantFilled,
  IconPennantOff: IconPennantOff,
  IconPentagon: IconPentagon,
  IconPentagonFilled: IconPentagonFilled,
  IconPentagonMinus: IconPentagonMinus,
  IconPentagonNumber0: IconPentagonNumber0,
  IconPentagonNumber1: IconPentagonNumber1,
  IconPentagonNumber2: IconPentagonNumber2,
  IconPentagonNumber3: IconPentagonNumber3,
  IconPentagonNumber4: IconPentagonNumber4,
  IconPentagonNumber5: IconPentagonNumber5,
  IconPentagonNumber6: IconPentagonNumber6,
  IconPentagonNumber7: IconPentagonNumber7,
  IconPentagonNumber8: IconPentagonNumber8,
  IconPentagonNumber9: IconPentagonNumber9,
  IconPentagonOff: IconPentagonOff,
  IconPentagonPlus: IconPentagonPlus,
  IconPentagonX: IconPentagonX,
  IconPentagram: IconPentagram,
  IconPepper: IconPepper,
  IconPepperOff: IconPepperOff,
  IconPercentage: IconPercentage,
  IconPercentage0: IconPercentage0,
  IconPercentage10: IconPercentage10,
  IconPercentage100: IconPercentage100,
  IconPercentage20: IconPercentage20,
  IconPercentage25: IconPercentage25,
  IconPercentage30: IconPercentage30,
  IconPercentage33: IconPercentage33,
  IconPercentage40: IconPercentage40,
  IconPercentage50: IconPercentage50,
  IconPercentage60: IconPercentage60,
  IconPercentage66: IconPercentage66,
  IconPercentage70: IconPercentage70,
  IconPercentage75: IconPercentage75,
  IconPercentage80: IconPercentage80,
  IconPercentage90: IconPercentage90,
  IconPerfume: IconPerfume,
  IconPerspective: IconPerspective,
  IconPerspectiveOff: IconPerspectiveOff,
  IconPhone: IconPhone,
  IconPhoneCall: IconPhoneCall,
  IconPhoneCalling: IconPhoneCalling,
  IconPhoneCheck: IconPhoneCheck,
  IconPhoneDone: IconPhoneDone,
  IconPhoneEnd: IconPhoneEnd,
  IconPhoneFilled: IconPhoneFilled,
  IconPhoneIncoming: IconPhoneIncoming,
  IconPhoneOff: IconPhoneOff,
  IconPhoneOutgoing: IconPhoneOutgoing,
  IconPhonePause: IconPhonePause,
  IconPhonePlus: IconPhonePlus,
  IconPhoneRinging: IconPhoneRinging,
  IconPhoneSpark: IconPhoneSpark,
  IconPhoneX: IconPhoneX,
  IconPhoto: IconPhoto,
  IconPhotoAi: IconPhotoAi,
  IconPhotoBitcoin: IconPhotoBitcoin,
  IconPhotoBolt: IconPhotoBolt,
  IconPhotoCancel: IconPhotoCancel,
  IconPhotoCheck: IconPhotoCheck,
  IconPhotoCircle: IconPhotoCircle,
  IconPhotoCircleMinus: IconPhotoCircleMinus,
  IconPhotoCirclePlus: IconPhotoCirclePlus,
  IconPhotoCode: IconPhotoCode,
  IconPhotoCog: IconPhotoCog,
  IconPhotoDollar: IconPhotoDollar,
  IconPhotoDown: IconPhotoDown,
  IconPhotoEdit: IconPhotoEdit,
  IconPhotoExclamation: IconPhotoExclamation,
  IconPhotoFilled: IconPhotoFilled,
  IconPhotoHeart: IconPhotoHeart,
  IconPhotoHexagon: IconPhotoHexagon,
  IconPhotoMinus: IconPhotoMinus,
  IconPhotoOff: IconPhotoOff,
  IconPhotoPause: IconPhotoPause,
  IconPhotoPentagon: IconPhotoPentagon,
  IconPhotoPin: IconPhotoPin,
  IconPhotoPlus: IconPhotoPlus,
  IconPhotoQuestion: IconPhotoQuestion,
  IconPhotoScan: IconPhotoScan,
  IconPhotoSearch: IconPhotoSearch,
  IconPhotoSensor: IconPhotoSensor,
  IconPhotoSensor2: IconPhotoSensor2,
  IconPhotoSensor3: IconPhotoSensor3,
  IconPhotoShare: IconPhotoShare,
  IconPhotoShield: IconPhotoShield,
  IconPhotoSpark: IconPhotoSpark,
  IconPhotoSquareRounded: IconPhotoSquareRounded,
  IconPhotoStar: IconPhotoStar,
  IconPhotoUp: IconPhotoUp,
  IconPhotoVideo: IconPhotoVideo,
  IconPhotoX: IconPhotoX,
  IconPhysotherapist: IconPhysotherapist,
  IconPiano: IconPiano,
  IconPick: IconPick,
  IconPicnicTable: IconPicnicTable,
  IconPictureInPicture: IconPictureInPicture,
  IconPictureInPictureFilled: IconPictureInPictureFilled,
  IconPictureInPictureOff: IconPictureInPictureOff,
  IconPictureInPictureOn: IconPictureInPictureOn,
  IconPictureInPictureTop: IconPictureInPictureTop,
  IconPictureInPictureTopFilled: IconPictureInPictureTopFilled,
  IconPig: IconPig,
  IconPigFilled: IconPigFilled,
  IconPigMoney: IconPigMoney,
  IconPigOff: IconPigOff,
  IconPilcrow: IconPilcrow,
  IconPilcrowLeft: IconPilcrowLeft,
  IconPilcrowRight: IconPilcrowRight,
  IconPill: IconPill,
  IconPillFilled: IconPillFilled,
  IconPillOff: IconPillOff,
  IconPills: IconPills,
  IconPin: IconPin,
  IconPinEnd: IconPinEnd,
  IconPinFilled: IconPinFilled,
  IconPinInvoke: IconPinInvoke,
  IconPingPong: IconPingPong,
  IconPinned: IconPinned,
  IconPinnedFilled: IconPinnedFilled,
  IconPinnedOff: IconPinnedOff,
  IconPizza: IconPizza,
  IconPizzaFilled: IconPizzaFilled,
  IconPizzaOff: IconPizzaOff,
  IconPlaceholder: IconPlaceholder,
  IconPlane: IconPlane,
  IconPlaneArrival: IconPlaneArrival,
  IconPlaneDeparture: IconPlaneDeparture,
  IconPlaneInflight: IconPlaneInflight,
  IconPlaneOff: IconPlaneOff,
  IconPlaneTilt: IconPlaneTilt,
  IconPlanet: IconPlanet,
  IconPlanetOff: IconPlanetOff,
  IconPlant: IconPlant,
  IconPlant2: IconPlant2,
  IconPlant2Off: IconPlant2Off,
  IconPlantOff: IconPlantOff,
  IconPlayBasketball: IconPlayBasketball,
  IconPlayCard: IconPlayCard,
  IconPlayCard1: IconPlayCard1,
  IconPlayCard10: IconPlayCard10,
  IconPlayCard10Filled: IconPlayCard10Filled,
  IconPlayCard1Filled: IconPlayCard1Filled,
  IconPlayCard2: IconPlayCard2,
  IconPlayCard2Filled: IconPlayCard2Filled,
  IconPlayCard3: IconPlayCard3,
  IconPlayCard3Filled: IconPlayCard3Filled,
  IconPlayCard4: IconPlayCard4,
  IconPlayCard4Filled: IconPlayCard4Filled,
  IconPlayCard5: IconPlayCard5,
  IconPlayCard5Filled: IconPlayCard5Filled,
  IconPlayCard6: IconPlayCard6,
  IconPlayCard6Filled: IconPlayCard6Filled,
  IconPlayCard7: IconPlayCard7,
  IconPlayCard7Filled: IconPlayCard7Filled,
  IconPlayCard8: IconPlayCard8,
  IconPlayCard8Filled: IconPlayCard8Filled,
  IconPlayCard9: IconPlayCard9,
  IconPlayCard9Filled: IconPlayCard9Filled,
  IconPlayCardA: IconPlayCardA,
  IconPlayCardAFilled: IconPlayCardAFilled,
  IconPlayCardJ: IconPlayCardJ,
  IconPlayCardJFilled: IconPlayCardJFilled,
  IconPlayCardK: IconPlayCardK,
  IconPlayCardKFilled: IconPlayCardKFilled,
  IconPlayCardOff: IconPlayCardOff,
  IconPlayCardQ: IconPlayCardQ,
  IconPlayCardQFilled: IconPlayCardQFilled,
  IconPlayCardStar: IconPlayCardStar,
  IconPlayCardStarFilled: IconPlayCardStarFilled,
  IconPlayFootball: IconPlayFootball,
  IconPlayHandball: IconPlayHandball,
  IconPlayVolleyball: IconPlayVolleyball,
  IconPlayerEject: IconPlayerEject,
  IconPlayerEjectFilled: IconPlayerEjectFilled,
  IconPlayerPause: IconPlayerPause,
  IconPlayerPauseFilled: IconPlayerPauseFilled,
  IconPlayerPlay: IconPlayerPlay,
  IconPlayerPlayFilled: IconPlayerPlayFilled,
  IconPlayerRecord: IconPlayerRecord,
  IconPlayerRecordFilled: IconPlayerRecordFilled,
  IconPlayerSkipBack: IconPlayerSkipBack,
  IconPlayerSkipBackFilled: IconPlayerSkipBackFilled,
  IconPlayerSkipForward: IconPlayerSkipForward,
  IconPlayerSkipForwardFilled: IconPlayerSkipForwardFilled,
  IconPlayerStop: IconPlayerStop,
  IconPlayerStopFilled: IconPlayerStopFilled,
  IconPlayerTrackNext: IconPlayerTrackNext,
  IconPlayerTrackNextFilled: IconPlayerTrackNextFilled,
  IconPlayerTrackPrev: IconPlayerTrackPrev,
  IconPlayerTrackPrevFilled: IconPlayerTrackPrevFilled,
  IconPlaylist: IconPlaylist,
  IconPlaylistAdd: IconPlaylistAdd,
  IconPlaylistOff: IconPlaylistOff,
  IconPlaylistX: IconPlaylistX,
  IconPlaystationCircle: IconPlaystationCircle,
  IconPlaystationSquare: IconPlaystationSquare,
  IconPlaystationTriangle: IconPlaystationTriangle,
  IconPlaystationX: IconPlaystationX,
  IconPlug: IconPlug,
  IconPlugConnected: IconPlugConnected,
  IconPlugConnectedX: IconPlugConnectedX,
  IconPlugOff: IconPlugOff,
  IconPlugX: IconPlugX,
  IconPlus: IconPlus,
  IconPlusEqual: IconPlusEqual,
  IconPlusMinus: IconPlusMinus,
  IconPng: IconPng,
  IconPodium: IconPodium,
  IconPodiumOff: IconPodiumOff,
  IconPoint: IconPoint,
  IconPointFilled: IconPointFilled,
  IconPointOff: IconPointOff,
  IconPointer: IconPointer,
  IconPointerBolt: IconPointerBolt,
  IconPointerCancel: IconPointerCancel,
  IconPointerCheck: IconPointerCheck,
  IconPointerCode: IconPointerCode,
  IconPointerCog: IconPointerCog,
  IconPointerDollar: IconPointerDollar,
  IconPointerDown: IconPointerDown,
  IconPointerExclamation: IconPointerExclamation,
  IconPointerFilled: IconPointerFilled,
  IconPointerHeart: IconPointerHeart,
  IconPointerMinus: IconPointerMinus,
  IconPointerOff: IconPointerOff,
  IconPointerPause: IconPointerPause,
  IconPointerPin: IconPointerPin,
  IconPointerPlus: IconPointerPlus,
  IconPointerQuestion: IconPointerQuestion,
  IconPointerSearch: IconPointerSearch,
  IconPointerShare: IconPointerShare,
  IconPointerStar: IconPointerStar,
  IconPointerUp: IconPointerUp,
  IconPointerX: IconPointerX,
  IconPokeball: IconPokeball,
  IconPokeballOff: IconPokeballOff,
  IconPokerChip: IconPokerChip,
  IconPolaroid: IconPolaroid,
  IconPolaroidFilled: IconPolaroidFilled,
  IconPolygon: IconPolygon,
  IconPolygonOff: IconPolygonOff,
  IconPoo: IconPoo,
  IconPooFilled: IconPooFilled,
  IconPool: IconPool,
  IconPoolOff: IconPoolOff,
  IconPower: IconPower,
  IconPray: IconPray,
  IconPremiumRights: IconPremiumRights,
  IconPrescription: IconPrescription,
  IconPresentation: IconPresentation,
  IconPresentationAnalytics: IconPresentationAnalytics,
  IconPresentationAnalyticsFilled: IconPresentationAnalyticsFilled,
  IconPresentationFilled: IconPresentationFilled,
  IconPresentationOff: IconPresentationOff,
  IconPrinter: IconPrinter,
  IconPrinterOff: IconPrinterOff,
  IconPrism: IconPrism,
  IconPrismLight: IconPrismLight,
  IconPrismOff: IconPrismOff,
  IconPrismPlus: IconPrismPlus,
  IconPrison: IconPrison,
  IconProgress: IconProgress,
  IconProgressAlert: IconProgressAlert,
  IconProgressBolt: IconProgressBolt,
  IconProgressCheck: IconProgressCheck,
  IconProgressDown: IconProgressDown,
  IconProgressHelp: IconProgressHelp,
  IconProgressX: IconProgressX,
  IconPrompt: IconPrompt,
  IconProng: IconProng,
  IconPropeller: IconPropeller,
  IconPropellerOff: IconPropellerOff,
  IconProtocol: IconProtocol,
  IconPumpkinScary: IconPumpkinScary,
  IconPuzzle: IconPuzzle,
  IconPuzzle2: IconPuzzle2,
  IconPuzzleFilled: IconPuzzleFilled,
  IconPuzzleOff: IconPuzzleOff,
  IconPyramid: IconPyramid,
  IconPyramidOff: IconPyramidOff,
  IconPyramidPlus: IconPyramidPlus,
  IconQrcode: IconQrcode,
  IconQrcodeOff: IconQrcodeOff,
  IconQuestionMark: IconQuestionMark,
  IconQuote: IconQuote,
  IconQuoteFilled: IconQuoteFilled,
  IconQuoteOff: IconQuoteOff,
  IconQuotes: IconQuotes,
  IconRadar: IconRadar,
  IconRadar2: IconRadar2,
  IconRadarFilled: IconRadarFilled,
  IconRadarOff: IconRadarOff,
  IconRadio: IconRadio,
  IconRadioOff: IconRadioOff,
  IconRadioactive: IconRadioactive,
  IconRadioactiveFilled: IconRadioactiveFilled,
  IconRadioactiveOff: IconRadioactiveOff,
  IconRadiusBottomLeft: IconRadiusBottomLeft,
  IconRadiusBottomRight: IconRadiusBottomRight,
  IconRadiusTopLeft: IconRadiusTopLeft,
  IconRadiusTopRight: IconRadiusTopRight,
  IconRainbow: IconRainbow,
  IconRainbowOff: IconRainbowOff,
  IconRating12Plus: IconRating12Plus,
  IconRating14Plus: IconRating14Plus,
  IconRating16Plus: IconRating16Plus,
  IconRating18Plus: IconRating18Plus,
  IconRating21Plus: IconRating21Plus,
  IconRazor: IconRazor,
  IconRazorElectric: IconRazorElectric,
  IconReceipt: IconReceipt,
  IconReceipt2: IconReceipt2,
  IconReceiptBitcoin: IconReceiptBitcoin,
  IconReceiptDollar: IconReceiptDollar,
  IconReceiptEuro: IconReceiptEuro,
  IconReceiptFilled: IconReceiptFilled,
  IconReceiptOff: IconReceiptOff,
  IconReceiptPound: IconReceiptPound,
  IconReceiptRefund: IconReceiptRefund,
  IconReceiptRupee: IconReceiptRupee,
  IconReceiptTax: IconReceiptTax,
  IconReceiptYen: IconReceiptYen,
  IconReceiptYuan: IconReceiptYuan,
  IconRecharging: IconRecharging,
  IconRecordMail: IconRecordMail,
  IconRecordMailOff: IconRecordMailOff,
  IconRectangle: IconRectangle,
  IconRectangleFilled: IconRectangleFilled,
  IconRectangleRoundedBottom: IconRectangleRoundedBottom,
  IconRectangleRoundedTop: IconRectangleRoundedTop,
  IconRectangleVertical: IconRectangleVertical,
  IconRectangleVerticalFilled: IconRectangleVerticalFilled,
  IconRectangularPrism: IconRectangularPrism,
  IconRectangularPrismOff: IconRectangularPrismOff,
  IconRectangularPrismPlus: IconRectangularPrismPlus,
  IconRecycle: IconRecycle,
  IconRecycleOff: IconRecycleOff,
  IconRefresh: IconRefresh,
  IconRefreshAlert: IconRefreshAlert,
  IconRefreshDot: IconRefreshDot,
  IconRefreshOff: IconRefreshOff,
  IconRegex: IconRegex,
  IconRegexOff: IconRegexOff,
  IconRegistered: IconRegistered,
  IconRelationManyToMany: IconRelationManyToMany,
  IconRelationManyToManyFilled: IconRelationManyToManyFilled,
  IconRelationOneToMany: IconRelationOneToMany,
  IconRelationOneToManyFilled: IconRelationOneToManyFilled,
  IconRelationOneToOne: IconRelationOneToOne,
  IconRelationOneToOneFilled: IconRelationOneToOneFilled,
  IconReload: IconReload,
  IconReorder: IconReorder,
  IconRepeat: IconRepeat,
  IconRepeatOff: IconRepeatOff,
  IconRepeatOnce: IconRepeatOnce,
  IconReplace: IconReplace,
  IconReplaceFilled: IconReplaceFilled,
  IconReplaceOff: IconReplaceOff,
  IconReplaceUser: IconReplaceUser,
  IconReport: IconReport,
  IconReportAnalytics: IconReportAnalytics,
  IconReportMedical: IconReportMedical,
  IconReportMoney: IconReportMoney,
  IconReportOff: IconReportOff,
  IconReportSearch: IconReportSearch,
  IconReservedLine: IconReservedLine,
  IconResize: IconResize,
  IconRestore: IconRestore,
  IconRewindBackward10: IconRewindBackward10,
  IconRewindBackward15: IconRewindBackward15,
  IconRewindBackward20: IconRewindBackward20,
  IconRewindBackward30: IconRewindBackward30,
  IconRewindBackward40: IconRewindBackward40,
  IconRewindBackward5: IconRewindBackward5,
  IconRewindBackward50: IconRewindBackward50,
  IconRewindBackward60: IconRewindBackward60,
  IconRewindForward10: IconRewindForward10,
  IconRewindForward15: IconRewindForward15,
  IconRewindForward20: IconRewindForward20,
  IconRewindForward30: IconRewindForward30,
  IconRewindForward40: IconRewindForward40,
  IconRewindForward5: IconRewindForward5,
  IconRewindForward50: IconRewindForward50,
  IconRewindForward60: IconRewindForward60,
  IconRibbonHealth: IconRibbonHealth,
  IconRings: IconRings,
  IconRipple: IconRipple,
  IconRippleOff: IconRippleOff,
  IconRoad: IconRoad,
  IconRoadOff: IconRoadOff,
  IconRoadSign: IconRoadSign,
  IconRobot: IconRobot,
  IconRobotFace: IconRobotFace,
  IconRobotOff: IconRobotOff,
  IconRocket: IconRocket,
  IconRocketOff: IconRocketOff,
  IconRollerSkating: IconRollerSkating,
  IconRollercoaster: IconRollercoaster,
  IconRollercoasterFilled: IconRollercoasterFilled,
  IconRollercoasterOff: IconRollercoasterOff,
  IconRosette: IconRosette,
  IconRosetteDiscount: IconRosetteDiscount,
  IconRosetteDiscountCheck: IconRosetteDiscountCheck,
  IconRosetteDiscountCheckFilled: IconRosetteDiscountCheckFilled,
  IconRosetteDiscountCheckOff: IconRosetteDiscountCheckOff,
  IconRosetteDiscountFilled: IconRosetteDiscountFilled,
  IconRosetteDiscountOff: IconRosetteDiscountOff,
  IconRosetteFilled: IconRosetteFilled,
  IconRosetteNumber0: IconRosetteNumber0,
  IconRosetteNumber1: IconRosetteNumber1,
  IconRosetteNumber2: IconRosetteNumber2,
  IconRosetteNumber3: IconRosetteNumber3,
  IconRosetteNumber4: IconRosetteNumber4,
  IconRosetteNumber5: IconRosetteNumber5,
  IconRosetteNumber6: IconRosetteNumber6,
  IconRosetteNumber7: IconRosetteNumber7,
  IconRosetteNumber8: IconRosetteNumber8,
  IconRosetteNumber9: IconRosetteNumber9,
  IconRotate: IconRotate,
  IconRotate2: IconRotate2,
  IconRotate360: IconRotate360,
  IconRotate3d: IconRotate3d,
  IconRotateClockwise: IconRotateClockwise,
  IconRotateClockwise2: IconRotateClockwise2,
  IconRotateDot: IconRotateDot,
  IconRotateRectangle: IconRotateRectangle,
  IconRoute: IconRoute,
  IconRoute2: IconRoute2,
  IconRouteAltLeft: IconRouteAltLeft,
  IconRouteAltRight: IconRouteAltRight,
  IconRouteOff: IconRouteOff,
  IconRouteScan: IconRouteScan,
  IconRouteSquare: IconRouteSquare,
  IconRouteSquare2: IconRouteSquare2,
  IconRouteX: IconRouteX,
  IconRouteX2: IconRouteX2,
  IconRouter: IconRouter,
  IconRouterOff: IconRouterOff,
  IconRowInsertBottom: IconRowInsertBottom,
  IconRowInsertTop: IconRowInsertTop,
  IconRowRemove: IconRowRemove,
  IconRss: IconRss,
  IconRubberStamp: IconRubberStamp,
  IconRubberStampOff: IconRubberStampOff,
  IconRuler: IconRuler,
  IconRuler2: IconRuler2,
  IconRuler2Off: IconRuler2Off,
  IconRuler3: IconRuler3,
  IconRulerMeasure: IconRulerMeasure,
  IconRulerMeasure2: IconRulerMeasure2,
  IconRulerOff: IconRulerOff,
  IconRun: IconRun,
  IconRvTruck: IconRvTruck,
  IconSTurnDown: IconSTurnDown,
  IconSTurnLeft: IconSTurnLeft,
  IconSTurnRight: IconSTurnRight,
  IconSTurnUp: IconSTurnUp,
  IconSailboat: IconSailboat,
  IconSailboat2: IconSailboat2,
  IconSailboatOff: IconSailboatOff,
  IconSalad: IconSalad,
  IconSaladFilled: IconSaladFilled,
  IconSalt: IconSalt,
  IconSandbox: IconSandbox,
  IconSatellite: IconSatellite,
  IconSatelliteOff: IconSatelliteOff,
  IconSausage: IconSausage,
  IconScale: IconScale,
  IconScaleOff: IconScaleOff,
  IconScaleOutline: IconScaleOutline,
  IconScaleOutlineOff: IconScaleOutlineOff,
  IconScan: IconScan,
  IconScanEye: IconScanEye,
  IconScanPosition: IconScanPosition,
  IconSchema: IconSchema,
  IconSchemaOff: IconSchemaOff,
  IconSchool: IconSchool,
  IconSchoolBell: IconSchoolBell,
  IconSchoolOff: IconSchoolOff,
  IconScissors: IconScissors,
  IconScissorsOff: IconScissorsOff,
  IconScooter: IconScooter,
  IconScooterElectric: IconScooterElectric,
  IconScoreboard: IconScoreboard,
  IconScreenShare: IconScreenShare,
  IconScreenShareOff: IconScreenShareOff,
  IconScreenshot: IconScreenshot,
  IconScribble: IconScribble,
  IconScribbleOff: IconScribbleOff,
  IconScript: IconScript,
  IconScriptMinus: IconScriptMinus,
  IconScriptPlus: IconScriptPlus,
  IconScriptX: IconScriptX,
  IconScubaDiving: IconScubaDiving,
  IconScubaDivingTank: IconScubaDivingTank,
  IconScubaDivingTankFilled: IconScubaDivingTankFilled,
  IconScubaMask: IconScubaMask,
  IconScubaMaskOff: IconScubaMaskOff,
  IconSdk: IconSdk,
  IconSearch: IconSearch,
  IconSearchOff: IconSearchOff,
  IconSection: IconSection,
  IconSectionFilled: IconSectionFilled,
  IconSectionSign: IconSectionSign,
  IconSeedling: IconSeedling,
  IconSeedlingFilled: IconSeedlingFilled,
  IconSeedlingOff: IconSeedlingOff,
  IconSelect: IconSelect,
  IconSelectAll: IconSelectAll,
  IconSelector: IconSelector,
  IconSend: IconSend,
  IconSend2: IconSend2,
  IconSendOff: IconSendOff,
  IconSeo: IconSeo,
  IconSeparator: IconSeparator,
  IconSeparatorHorizontal: IconSeparatorHorizontal,
  IconSeparatorVertical: IconSeparatorVertical,
  IconServer: IconServer,
  IconServer2: IconServer2,
  IconServerBolt: IconServerBolt,
  IconServerCog: IconServerCog,
  IconServerOff: IconServerOff,
  IconServerSpark: IconServerSpark,
  IconServicemark: IconServicemark,
  IconSettings: IconSettings,
  IconSettings2: IconSettings2,
  IconSettingsAutomation: IconSettingsAutomation,
  IconSettingsBolt: IconSettingsBolt,
  IconSettingsCancel: IconSettingsCancel,
  IconSettingsCheck: IconSettingsCheck,
  IconSettingsCode: IconSettingsCode,
  IconSettingsCog: IconSettingsCog,
  IconSettingsDollar: IconSettingsDollar,
  IconSettingsDown: IconSettingsDown,
  IconSettingsExclamation: IconSettingsExclamation,
  IconSettingsFilled: IconSettingsFilled,
  IconSettingsHeart: IconSettingsHeart,
  IconSettingsMinus: IconSettingsMinus,
  IconSettingsOff: IconSettingsOff,
  IconSettingsPause: IconSettingsPause,
  IconSettingsPin: IconSettingsPin,
  IconSettingsPlus: IconSettingsPlus,
  IconSettingsQuestion: IconSettingsQuestion,
  IconSettingsSearch: IconSettingsSearch,
  IconSettingsShare: IconSettingsShare,
  IconSettingsSpark: IconSettingsSpark,
  IconSettingsStar: IconSettingsStar,
  IconSettingsUp: IconSettingsUp,
  IconSettingsX: IconSettingsX,
  IconShadow: IconShadow,
  IconShadowOff: IconShadowOff,
  IconShape: IconShape,
  IconShape2: IconShape2,
  IconShape3: IconShape3,
  IconShapeOff: IconShapeOff,
  IconShare: IconShare,
  IconShare2: IconShare2,
  IconShare3: IconShare3,
  IconShareOff: IconShareOff,
  IconShareplay: IconShareplay,
  IconShield: IconShield,
  IconShieldBolt: IconShieldBolt,
  IconShieldCancel: IconShieldCancel,
  IconShieldCheck: IconShieldCheck,
  IconShieldCheckFilled: IconShieldCheckFilled,
  IconShieldCheckered: IconShieldCheckered,
  IconShieldCheckeredFilled: IconShieldCheckeredFilled,
  IconShieldChevron: IconShieldChevron,
  IconShieldCode: IconShieldCode,
  IconShieldCog: IconShieldCog,
  IconShieldDollar: IconShieldDollar,
  IconShieldDown: IconShieldDown,
  IconShieldExclamation: IconShieldExclamation,
  IconShieldFilled: IconShieldFilled,
  IconShieldHalf: IconShieldHalf,
  IconShieldHalfFilled: IconShieldHalfFilled,
  IconShieldHeart: IconShieldHeart,
  IconShieldLock: IconShieldLock,
  IconShieldLockFilled: IconShieldLockFilled,
  IconShieldMinus: IconShieldMinus,
  IconShieldOff: IconShieldOff,
  IconShieldPause: IconShieldPause,
  IconShieldPin: IconShieldPin,
  IconShieldPlus: IconShieldPlus,
  IconShieldQuestion: IconShieldQuestion,
  IconShieldSearch: IconShieldSearch,
  IconShieldShare: IconShieldShare,
  IconShieldStar: IconShieldStar,
  IconShieldUp: IconShieldUp,
  IconShieldX: IconShieldX,
  IconShip: IconShip,
  IconShipOff: IconShipOff,
  IconShirt: IconShirt,
  IconShirtFilled: IconShirtFilled,
  IconShirtOff: IconShirtOff,
  IconShirtSport: IconShirtSport,
  IconShoe: IconShoe,
  IconShoeOff: IconShoeOff,
  IconShoppingBag: IconShoppingBag,
  IconShoppingBagCheck: IconShoppingBagCheck,
  IconShoppingBagDiscount: IconShoppingBagDiscount,
  IconShoppingBagEdit: IconShoppingBagEdit,
  IconShoppingBagExclamation: IconShoppingBagExclamation,
  IconShoppingBagHeart: IconShoppingBagHeart,
  IconShoppingBagMinus: IconShoppingBagMinus,
  IconShoppingBagPlus: IconShoppingBagPlus,
  IconShoppingBagSearch: IconShoppingBagSearch,
  IconShoppingBagX: IconShoppingBagX,
  IconShoppingCart: IconShoppingCart,
  IconShoppingCartBolt: IconShoppingCartBolt,
  IconShoppingCartCancel: IconShoppingCartCancel,
  IconShoppingCartCheck: IconShoppingCartCheck,
  IconShoppingCartCode: IconShoppingCartCode,
  IconShoppingCartCog: IconShoppingCartCog,
  IconShoppingCartCopy: IconShoppingCartCopy,
  IconShoppingCartDiscount: IconShoppingCartDiscount,
  IconShoppingCartDollar: IconShoppingCartDollar,
  IconShoppingCartDown: IconShoppingCartDown,
  IconShoppingCartExclamation: IconShoppingCartExclamation,
  IconShoppingCartFilled: IconShoppingCartFilled,
  IconShoppingCartHeart: IconShoppingCartHeart,
  IconShoppingCartMinus: IconShoppingCartMinus,
  IconShoppingCartOff: IconShoppingCartOff,
  IconShoppingCartPause: IconShoppingCartPause,
  IconShoppingCartPin: IconShoppingCartPin,
  IconShoppingCartPlus: IconShoppingCartPlus,
  IconShoppingCartQuestion: IconShoppingCartQuestion,
  IconShoppingCartSearch: IconShoppingCartSearch,
  IconShoppingCartShare: IconShoppingCartShare,
  IconShoppingCartStar: IconShoppingCartStar,
  IconShoppingCartUp: IconShoppingCartUp,
  IconShoppingCartX: IconShoppingCartX,
  IconShovel: IconShovel,
  IconShovelPitchforks: IconShovelPitchforks,
  IconShredder: IconShredder,
  IconSignLeft: IconSignLeft,
  IconSignLeftFilled: IconSignLeftFilled,
  IconSignRight: IconSignRight,
  IconSignRightFilled: IconSignRightFilled,
  IconSignal2g: IconSignal2g,
  IconSignal3g: IconSignal3g,
  IconSignal4g: IconSignal4g,
  IconSignal4gPlus: IconSignal4gPlus,
  IconSignal5g: IconSignal5g,
  IconSignal6g: IconSignal6g,
  IconSignalE: IconSignalE,
  IconSignalG: IconSignalG,
  IconSignalH: IconSignalH,
  IconSignalHPlus: IconSignalHPlus,
  IconSignalLte: IconSignalLte,
  IconSignature: IconSignature,
  IconSignatureOff: IconSignatureOff,
  IconSitemap: IconSitemap,
  IconSitemapFilled: IconSitemapFilled,
  IconSitemapOff: IconSitemapOff,
  IconSkateboard: IconSkateboard,
  IconSkateboardOff: IconSkateboardOff,
  IconSkateboarding: IconSkateboarding,
  IconSkewX: IconSkewX,
  IconSkewY: IconSkewY,
  IconSkiJumping: IconSkiJumping,
  IconSkull: IconSkull,
  IconSlash: IconSlash,
  IconSlashes: IconSlashes,
  IconSleigh: IconSleigh,
  IconSlice: IconSlice,
  IconSlideshow: IconSlideshow,
  IconSmartHome: IconSmartHome,
  IconSmartHomeOff: IconSmartHomeOff,
  IconSmoking: IconSmoking,
  IconSmokingNo: IconSmokingNo,
  IconSnowboarding: IconSnowboarding,
  IconSnowflake: IconSnowflake,
  IconSnowflakeOff: IconSnowflakeOff,
  IconSnowman: IconSnowman,
  IconSoccerField: IconSoccerField,
  IconSocial: IconSocial,
  IconSocialOff: IconSocialOff,
  IconSock: IconSock,
  IconSofa: IconSofa,
  IconSofaOff: IconSofaOff,
  IconSolarElectricity: IconSolarElectricity,
  IconSolarPanel: IconSolarPanel,
  IconSolarPanel2: IconSolarPanel2,
  IconSort09: IconSort09,
  IconSort90: IconSort90,
  IconSortAZ: IconSortAZ,
  IconSortAscending: IconSortAscending,
  IconSortAscending2: IconSortAscending2,
  IconSortAscending2Filled: IconSortAscending2Filled,
  IconSortAscendingLetters: IconSortAscendingLetters,
  IconSortAscendingNumbers: IconSortAscendingNumbers,
  IconSortAscendingShapes: IconSortAscendingShapes,
  IconSortAscendingShapesFilled: IconSortAscendingShapesFilled,
  IconSortAscendingSmallBig: IconSortAscendingSmallBig,
  IconSortDescending: IconSortDescending,
  IconSortDescending2: IconSortDescending2,
  IconSortDescending2Filled: IconSortDescending2Filled,
  IconSortDescendingLetters: IconSortDescendingLetters,
  IconSortDescendingNumbers: IconSortDescendingNumbers,
  IconSortDescendingShapes: IconSortDescendingShapes,
  IconSortDescendingShapesFilled: IconSortDescendingShapesFilled,
  IconSortDescendingSmallBig: IconSortDescendingSmallBig,
  IconSortZA: IconSortZA,
  IconSos: IconSos,
  IconSoup: IconSoup,
  IconSoupFilled: IconSoupFilled,
  IconSoupOff: IconSoupOff,
  IconSourceCode: IconSourceCode,
  IconSpace: IconSpace,
  IconSpaceOff: IconSpaceOff,
  IconSpaces: IconSpaces,
  IconSpacingHorizontal: IconSpacingHorizontal,
  IconSpacingVertical: IconSpacingVertical,
  IconSpade: IconSpade,
  IconSpadeFilled: IconSpadeFilled,
  IconSparkles: IconSparkles,
  IconSpeakerphone: IconSpeakerphone,
  IconSpeedboat: IconSpeedboat,
  IconSpeedboatFilled: IconSpeedboatFilled,
  IconSphere: IconSphere,
  IconSphereOff: IconSphereOff,
  IconSpherePlus: IconSpherePlus,
  IconSpider: IconSpider,
  IconSpiderFilled: IconSpiderFilled,
  IconSpiral: IconSpiral,
  IconSpiralOff: IconSpiralOff,
  IconSportBillard: IconSportBillard,
  IconSpray: IconSpray,
  IconSpy: IconSpy,
  IconSpyOff: IconSpyOff,
  IconSql: IconSql,
  IconSquare: IconSquare,
  IconSquareArrowDown: IconSquareArrowDown,
  IconSquareArrowDownFilled: IconSquareArrowDownFilled,
  IconSquareArrowLeft: IconSquareArrowLeft,
  IconSquareArrowLeftFilled: IconSquareArrowLeftFilled,
  IconSquareArrowRight: IconSquareArrowRight,
  IconSquareArrowRightFilled: IconSquareArrowRightFilled,
  IconSquareArrowUp: IconSquareArrowUp,
  IconSquareArrowUpFilled: IconSquareArrowUpFilled,
  IconSquareAsterisk: IconSquareAsterisk,
  IconSquareAsteriskFilled: IconSquareAsteriskFilled,
  IconSquareCheck: IconSquareCheck,
  IconSquareCheckFilled: IconSquareCheckFilled,
  IconSquareChevronDown: IconSquareChevronDown,
  IconSquareChevronDownFilled: IconSquareChevronDownFilled,
  IconSquareChevronLeft: IconSquareChevronLeft,
  IconSquareChevronLeftFilled: IconSquareChevronLeftFilled,
  IconSquareChevronRight: IconSquareChevronRight,
  IconSquareChevronRightFilled: IconSquareChevronRightFilled,
  IconSquareChevronUp: IconSquareChevronUp,
  IconSquareChevronUpFilled: IconSquareChevronUpFilled,
  IconSquareChevronsDown: IconSquareChevronsDown,
  IconSquareChevronsDownFilled: IconSquareChevronsDownFilled,
  IconSquareChevronsLeft: IconSquareChevronsLeft,
  IconSquareChevronsLeftFilled: IconSquareChevronsLeftFilled,
  IconSquareChevronsRight: IconSquareChevronsRight,
  IconSquareChevronsRightFilled: IconSquareChevronsRightFilled,
  IconSquareChevronsUp: IconSquareChevronsUp,
  IconSquareChevronsUpFilled: IconSquareChevronsUpFilled,
  IconSquareDashed: IconSquareDashed,
  IconSquareDot: IconSquareDot,
  IconSquareDotFilled: IconSquareDotFilled,
  IconSquareF0: IconSquareF0,
  IconSquareF0Filled: IconSquareF0Filled,
  IconSquareF1: IconSquareF1,
  IconSquareF1Filled: IconSquareF1Filled,
  IconSquareF2: IconSquareF2,
  IconSquareF2Filled: IconSquareF2Filled,
  IconSquareF3: IconSquareF3,
  IconSquareF3Filled: IconSquareF3Filled,
  IconSquareF4: IconSquareF4,
  IconSquareF4Filled: IconSquareF4Filled,
  IconSquareF5: IconSquareF5,
  IconSquareF5Filled: IconSquareF5Filled,
  IconSquareF6: IconSquareF6,
  IconSquareF6Filled: IconSquareF6Filled,
  IconSquareF7: IconSquareF7,
  IconSquareF7Filled: IconSquareF7Filled,
  IconSquareF8: IconSquareF8,
  IconSquareF8Filled: IconSquareF8Filled,
  IconSquareF9: IconSquareF9,
  IconSquareF9Filled: IconSquareF9Filled,
  IconSquareFilled: IconSquareFilled,
  IconSquareForbid: IconSquareForbid,
  IconSquareForbid2: IconSquareForbid2,
  IconSquareHalf: IconSquareHalf,
  IconSquareKey: IconSquareKey,
  IconSquareLetterA: IconSquareLetterA,
  IconSquareLetterAFilled: IconSquareLetterAFilled,
  IconSquareLetterB: IconSquareLetterB,
  IconSquareLetterBFilled: IconSquareLetterBFilled,
  IconSquareLetterC: IconSquareLetterC,
  IconSquareLetterCFilled: IconSquareLetterCFilled,
  IconSquareLetterD: IconSquareLetterD,
  IconSquareLetterDFilled: IconSquareLetterDFilled,
  IconSquareLetterE: IconSquareLetterE,
  IconSquareLetterEFilled: IconSquareLetterEFilled,
  IconSquareLetterF: IconSquareLetterF,
  IconSquareLetterFFilled: IconSquareLetterFFilled,
  IconSquareLetterG: IconSquareLetterG,
  IconSquareLetterGFilled: IconSquareLetterGFilled,
  IconSquareLetterH: IconSquareLetterH,
  IconSquareLetterHFilled: IconSquareLetterHFilled,
  IconSquareLetterI: IconSquareLetterI,
  IconSquareLetterIFilled: IconSquareLetterIFilled,
  IconSquareLetterJ: IconSquareLetterJ,
  IconSquareLetterJFilled: IconSquareLetterJFilled,
  IconSquareLetterK: IconSquareLetterK,
  IconSquareLetterKFilled: IconSquareLetterKFilled,
  IconSquareLetterL: IconSquareLetterL,
  IconSquareLetterLFilled: IconSquareLetterLFilled,
  IconSquareLetterM: IconSquareLetterM,
  IconSquareLetterMFilled: IconSquareLetterMFilled,
  IconSquareLetterN: IconSquareLetterN,
  IconSquareLetterNFilled: IconSquareLetterNFilled,
  IconSquareLetterO: IconSquareLetterO,
  IconSquareLetterOFilled: IconSquareLetterOFilled,
  IconSquareLetterP: IconSquareLetterP,
  IconSquareLetterPFilled: IconSquareLetterPFilled,
  IconSquareLetterQ: IconSquareLetterQ,
  IconSquareLetterQFilled: IconSquareLetterQFilled,
  IconSquareLetterR: IconSquareLetterR,
  IconSquareLetterRFilled: IconSquareLetterRFilled,
  IconSquareLetterS: IconSquareLetterS,
  IconSquareLetterSFilled: IconSquareLetterSFilled,
  IconSquareLetterT: IconSquareLetterT,
  IconSquareLetterTFilled: IconSquareLetterTFilled,
  IconSquareLetterU: IconSquareLetterU,
  IconSquareLetterUFilled: IconSquareLetterUFilled,
  IconSquareLetterV: IconSquareLetterV,
  IconSquareLetterVFilled: IconSquareLetterVFilled,
  IconSquareLetterW: IconSquareLetterW,
  IconSquareLetterWFilled: IconSquareLetterWFilled,
  IconSquareLetterX: IconSquareLetterX,
  IconSquareLetterXFilled: IconSquareLetterXFilled,
  IconSquareLetterY: IconSquareLetterY,
  IconSquareLetterYFilled: IconSquareLetterYFilled,
  IconSquareLetterZ: IconSquareLetterZ,
  IconSquareLetterZFilled: IconSquareLetterZFilled,
  IconSquareMinus: IconSquareMinus,
  IconSquareMinusFilled: IconSquareMinusFilled,
  IconSquareNumber0: IconSquareNumber0,
  IconSquareNumber0Filled: IconSquareNumber0Filled,
  IconSquareNumber1: IconSquareNumber1,
  IconSquareNumber1Filled: IconSquareNumber1Filled,
  IconSquareNumber2: IconSquareNumber2,
  IconSquareNumber2Filled: IconSquareNumber2Filled,
  IconSquareNumber3: IconSquareNumber3,
  IconSquareNumber3Filled: IconSquareNumber3Filled,
  IconSquareNumber4: IconSquareNumber4,
  IconSquareNumber4Filled: IconSquareNumber4Filled,
  IconSquareNumber5: IconSquareNumber5,
  IconSquareNumber5Filled: IconSquareNumber5Filled,
  IconSquareNumber6: IconSquareNumber6,
  IconSquareNumber6Filled: IconSquareNumber6Filled,
  IconSquareNumber7: IconSquareNumber7,
  IconSquareNumber7Filled: IconSquareNumber7Filled,
  IconSquareNumber8: IconSquareNumber8,
  IconSquareNumber8Filled: IconSquareNumber8Filled,
  IconSquareNumber9: IconSquareNumber9,
  IconSquareNumber9Filled: IconSquareNumber9Filled,
  IconSquareOff: IconSquareOff,
  IconSquarePercentage: IconSquarePercentage,
  IconSquarePlus: IconSquarePlus,
  IconSquarePlus2: IconSquarePlus2,
  IconSquareRoot: IconSquareRoot,
  IconSquareRoot2: IconSquareRoot2,
  IconSquareRotated: IconSquareRotated,
  IconSquareRotatedFilled: IconSquareRotatedFilled,
  IconSquareRotatedForbid: IconSquareRotatedForbid,
  IconSquareRotatedForbid2: IconSquareRotatedForbid2,
  IconSquareRotatedOff: IconSquareRotatedOff,
  IconSquareRounded: IconSquareRounded,
  IconSquareRoundedArrowDown: IconSquareRoundedArrowDown,
  IconSquareRoundedArrowDownFilled: IconSquareRoundedArrowDownFilled,
  IconSquareRoundedArrowLeft: IconSquareRoundedArrowLeft,
  IconSquareRoundedArrowLeftFilled: IconSquareRoundedArrowLeftFilled,
  IconSquareRoundedArrowRight: IconSquareRoundedArrowRight,
  IconSquareRoundedArrowRightFilled: IconSquareRoundedArrowRightFilled,
  IconSquareRoundedArrowUp: IconSquareRoundedArrowUp,
  IconSquareRoundedArrowUpFilled: IconSquareRoundedArrowUpFilled,
  IconSquareRoundedCheck: IconSquareRoundedCheck,
  IconSquareRoundedCheckFilled: IconSquareRoundedCheckFilled,
  IconSquareRoundedChevronDown: IconSquareRoundedChevronDown,
  IconSquareRoundedChevronDownFilled: IconSquareRoundedChevronDownFilled,
  IconSquareRoundedChevronLeft: IconSquareRoundedChevronLeft,
  IconSquareRoundedChevronLeftFilled: IconSquareRoundedChevronLeftFilled,
  IconSquareRoundedChevronRight: IconSquareRoundedChevronRight,
  IconSquareRoundedChevronRightFilled: IconSquareRoundedChevronRightFilled,
  IconSquareRoundedChevronUp: IconSquareRoundedChevronUp,
  IconSquareRoundedChevronUpFilled: IconSquareRoundedChevronUpFilled,
  IconSquareRoundedChevronsDown: IconSquareRoundedChevronsDown,
  IconSquareRoundedChevronsDownFilled: IconSquareRoundedChevronsDownFilled,
  IconSquareRoundedChevronsLeft: IconSquareRoundedChevronsLeft,
  IconSquareRoundedChevronsLeftFilled: IconSquareRoundedChevronsLeftFilled,
  IconSquareRoundedChevronsRight: IconSquareRoundedChevronsRight,
  IconSquareRoundedChevronsRightFilled: IconSquareRoundedChevronsRightFilled,
  IconSquareRoundedChevronsUp: IconSquareRoundedChevronsUp,
  IconSquareRoundedChevronsUpFilled: IconSquareRoundedChevronsUpFilled,
  IconSquareRoundedFilled: IconSquareRoundedFilled,
  IconSquareRoundedLetterA: IconSquareRoundedLetterA,
  IconSquareRoundedLetterAFilled: IconSquareRoundedLetterAFilled,
  IconSquareRoundedLetterB: IconSquareRoundedLetterB,
  IconSquareRoundedLetterBFilled: IconSquareRoundedLetterBFilled,
  IconSquareRoundedLetterC: IconSquareRoundedLetterC,
  IconSquareRoundedLetterCFilled: IconSquareRoundedLetterCFilled,
  IconSquareRoundedLetterD: IconSquareRoundedLetterD,
  IconSquareRoundedLetterDFilled: IconSquareRoundedLetterDFilled,
  IconSquareRoundedLetterE: IconSquareRoundedLetterE,
  IconSquareRoundedLetterEFilled: IconSquareRoundedLetterEFilled,
  IconSquareRoundedLetterF: IconSquareRoundedLetterF,
  IconSquareRoundedLetterFFilled: IconSquareRoundedLetterFFilled,
  IconSquareRoundedLetterG: IconSquareRoundedLetterG,
  IconSquareRoundedLetterGFilled: IconSquareRoundedLetterGFilled,
  IconSquareRoundedLetterH: IconSquareRoundedLetterH,
  IconSquareRoundedLetterHFilled: IconSquareRoundedLetterHFilled,
  IconSquareRoundedLetterI: IconSquareRoundedLetterI,
  IconSquareRoundedLetterIFilled: IconSquareRoundedLetterIFilled,
  IconSquareRoundedLetterJ: IconSquareRoundedLetterJ,
  IconSquareRoundedLetterJFilled: IconSquareRoundedLetterJFilled,
  IconSquareRoundedLetterK: IconSquareRoundedLetterK,
  IconSquareRoundedLetterKFilled: IconSquareRoundedLetterKFilled,
  IconSquareRoundedLetterL: IconSquareRoundedLetterL,
  IconSquareRoundedLetterLFilled: IconSquareRoundedLetterLFilled,
  IconSquareRoundedLetterM: IconSquareRoundedLetterM,
  IconSquareRoundedLetterMFilled: IconSquareRoundedLetterMFilled,
  IconSquareRoundedLetterN: IconSquareRoundedLetterN,
  IconSquareRoundedLetterNFilled: IconSquareRoundedLetterNFilled,
  IconSquareRoundedLetterO: IconSquareRoundedLetterO,
  IconSquareRoundedLetterOFilled: IconSquareRoundedLetterOFilled,
  IconSquareRoundedLetterP: IconSquareRoundedLetterP,
  IconSquareRoundedLetterPFilled: IconSquareRoundedLetterPFilled,
  IconSquareRoundedLetterQ: IconSquareRoundedLetterQ,
  IconSquareRoundedLetterQFilled: IconSquareRoundedLetterQFilled,
  IconSquareRoundedLetterR: IconSquareRoundedLetterR,
  IconSquareRoundedLetterRFilled: IconSquareRoundedLetterRFilled,
  IconSquareRoundedLetterS: IconSquareRoundedLetterS,
  IconSquareRoundedLetterSFilled: IconSquareRoundedLetterSFilled,
  IconSquareRoundedLetterT: IconSquareRoundedLetterT,
  IconSquareRoundedLetterTFilled: IconSquareRoundedLetterTFilled,
  IconSquareRoundedLetterU: IconSquareRoundedLetterU,
  IconSquareRoundedLetterUFilled: IconSquareRoundedLetterUFilled,
  IconSquareRoundedLetterV: IconSquareRoundedLetterV,
  IconSquareRoundedLetterVFilled: IconSquareRoundedLetterVFilled,
  IconSquareRoundedLetterW: IconSquareRoundedLetterW,
  IconSquareRoundedLetterWFilled: IconSquareRoundedLetterWFilled,
  IconSquareRoundedLetterX: IconSquareRoundedLetterX,
  IconSquareRoundedLetterXFilled: IconSquareRoundedLetterXFilled,
  IconSquareRoundedLetterY: IconSquareRoundedLetterY,
  IconSquareRoundedLetterYFilled: IconSquareRoundedLetterYFilled,
  IconSquareRoundedLetterZ: IconSquareRoundedLetterZ,
  IconSquareRoundedLetterZFilled: IconSquareRoundedLetterZFilled,
  IconSquareRoundedMinus: IconSquareRoundedMinus,
  IconSquareRoundedMinus2: IconSquareRoundedMinus2,
  IconSquareRoundedMinusFilled: IconSquareRoundedMinusFilled,
  IconSquareRoundedNumber0: IconSquareRoundedNumber0,
  IconSquareRoundedNumber0Filled: IconSquareRoundedNumber0Filled,
  IconSquareRoundedNumber1: IconSquareRoundedNumber1,
  IconSquareRoundedNumber1Filled: IconSquareRoundedNumber1Filled,
  IconSquareRoundedNumber2: IconSquareRoundedNumber2,
  IconSquareRoundedNumber2Filled: IconSquareRoundedNumber2Filled,
  IconSquareRoundedNumber3: IconSquareRoundedNumber3,
  IconSquareRoundedNumber3Filled: IconSquareRoundedNumber3Filled,
  IconSquareRoundedNumber4: IconSquareRoundedNumber4,
  IconSquareRoundedNumber4Filled: IconSquareRoundedNumber4Filled,
  IconSquareRoundedNumber5: IconSquareRoundedNumber5,
  IconSquareRoundedNumber5Filled: IconSquareRoundedNumber5Filled,
  IconSquareRoundedNumber6: IconSquareRoundedNumber6,
  IconSquareRoundedNumber6Filled: IconSquareRoundedNumber6Filled,
  IconSquareRoundedNumber7: IconSquareRoundedNumber7,
  IconSquareRoundedNumber7Filled: IconSquareRoundedNumber7Filled,
  IconSquareRoundedNumber8: IconSquareRoundedNumber8,
  IconSquareRoundedNumber8Filled: IconSquareRoundedNumber8Filled,
  IconSquareRoundedNumber9: IconSquareRoundedNumber9,
  IconSquareRoundedNumber9Filled: IconSquareRoundedNumber9Filled,
  IconSquareRoundedPercentage: IconSquareRoundedPercentage,
  IconSquareRoundedPlus: IconSquareRoundedPlus,
  IconSquareRoundedPlus2: IconSquareRoundedPlus2,
  IconSquareRoundedPlusFilled: IconSquareRoundedPlusFilled,
  IconSquareRoundedX: IconSquareRoundedX,
  IconSquareRoundedXFilled: IconSquareRoundedXFilled,
  IconSquareToggle: IconSquareToggle,
  IconSquareToggleHorizontal: IconSquareToggleHorizontal,
  IconSquareX: IconSquareX,
  IconSquareXFilled: IconSquareXFilled,
  IconSquares: IconSquares,
  IconSquaresDiagonal: IconSquaresDiagonal,
  IconSquaresFilled: IconSquaresFilled,
  IconSquaresSelected: IconSquaresSelected,
  IconStack: IconStack,
  IconStack2: IconStack2,
  IconStack2Filled: IconStack2Filled,
  IconStack3: IconStack3,
  IconStack3Filled: IconStack3Filled,
  IconStackBack: IconStackBack,
  IconStackBackward: IconStackBackward,
  IconStackFilled: IconStackFilled,
  IconStackForward: IconStackForward,
  IconStackFront: IconStackFront,
  IconStackMiddle: IconStackMiddle,
  IconStackPop: IconStackPop,
  IconStackPush: IconStackPush,
  IconStairs: IconStairs,
  IconStairsDown: IconStairsDown,
  IconStairsUp: IconStairsUp,
  IconStar: IconStar,
  IconStarFilled: IconStarFilled,
  IconStarHalf: IconStarHalf,
  IconStarHalfFilled: IconStarHalfFilled,
  IconStarOff: IconStarOff,
  IconStars: IconStars,
  IconStarsFilled: IconStarsFilled,
  IconStarsOff: IconStarsOff,
  IconStatusChange: IconStatusChange,
  IconSteam: IconSteam,
  IconSteeringWheel: IconSteeringWheel,
  IconSteeringWheelFilled: IconSteeringWheelFilled,
  IconSteeringWheelOff: IconSteeringWheelOff,
  IconStepInto: IconStepInto,
  IconStepOut: IconStepOut,
  IconStereoGlasses: IconStereoGlasses,
  IconStethoscope: IconStethoscope,
  IconStethoscopeOff: IconStethoscopeOff,
  IconSticker: IconSticker,
  IconSticker2: IconSticker2,
  IconStopwatch: IconStopwatch,
  IconStorm: IconStorm,
  IconStormOff: IconStormOff,
  IconStretching: IconStretching,
  IconStretching2: IconStretching2,
  IconStrikethrough: IconStrikethrough,
  IconSubmarine: IconSubmarine,
  IconSubscript: IconSubscript,
  IconSubtask: IconSubtask,
  IconSum: IconSum,
  IconSumOff: IconSumOff,
  IconSun: IconSun,
  IconSunElectricity: IconSunElectricity,
  IconSunFilled: IconSunFilled,
  IconSunHigh: IconSunHigh,
  IconSunHighFilled: IconSunHighFilled,
  IconSunLow: IconSunLow,
  IconSunLowFilled: IconSunLowFilled,
  IconSunMoon: IconSunMoon,
  IconSunOff: IconSunOff,
  IconSunWind: IconSunWind,
  IconSunglasses: IconSunglasses,
  IconSunglassesFilled: IconSunglassesFilled,
  IconSunrise: IconSunrise,
  IconSunriseFilled: IconSunriseFilled,
  IconSunset: IconSunset,
  IconSunset2: IconSunset2,
  IconSunset2Filled: IconSunset2Filled,
  IconSunsetFilled: IconSunsetFilled,
  IconSuperscript: IconSuperscript,
  IconSvg: IconSvg,
  IconSwimming: IconSwimming,
  IconSwipe: IconSwipe,
  IconSwipeDown: IconSwipeDown,
  IconSwipeDownFilled: IconSwipeDownFilled,
  IconSwipeLeft: IconSwipeLeft,
  IconSwipeLeftFilled: IconSwipeLeftFilled,
  IconSwipeRight: IconSwipeRight,
  IconSwipeRightFilled: IconSwipeRightFilled,
  IconSwipeUp: IconSwipeUp,
  IconSwipeUpFilled: IconSwipeUpFilled,
  IconSwitch: IconSwitch,
  IconSwitch2: IconSwitch2,
  IconSwitch3: IconSwitch3,
  IconSwitchHorizontal: IconSwitchHorizontal,
  IconSwitchVertical: IconSwitchVertical,
  IconSword: IconSword,
  IconSwordOff: IconSwordOff,
  IconSwords: IconSwords,
  IconTable: IconTable,
  IconTableAlias: IconTableAlias,
  IconTableColumn: IconTableColumn,
  IconTableDashed: IconTableDashed,
  IconTableDown: IconTableDown,
  IconTableExport: IconTableExport,
  IconTableFilled: IconTableFilled,
  IconTableHeart: IconTableHeart,
  IconTableImport: IconTableImport,
  IconTableMinus: IconTableMinus,
  IconTableOff: IconTableOff,
  IconTableOptions: IconTableOptions,
  IconTablePlus: IconTablePlus,
  IconTableRow: IconTableRow,
  IconTableShare: IconTableShare,
  IconTableShortcut: IconTableShortcut,
  IconTableSpark: IconTableSpark,
  IconTag: IconTag,
  IconTagFilled: IconTagFilled,
  IconTagMinus: IconTagMinus,
  IconTagOff: IconTagOff,
  IconTagPlus: IconTagPlus,
  IconTagStarred: IconTagStarred,
  IconTags: IconTags,
  IconTagsFilled: IconTagsFilled,
  IconTagsOff: IconTagsOff,
  IconTallymark1: IconTallymark1,
  IconTallymark2: IconTallymark2,
  IconTallymark3: IconTallymark3,
  IconTallymark4: IconTallymark4,
  IconTallymarks: IconTallymarks,
  IconTank: IconTank,
  IconTarget: IconTarget,
  IconTargetArrow: IconTargetArrow,
  IconTargetOff: IconTargetOff,
  IconTax: IconTax,
  IconTaxEuro: IconTaxEuro,
  IconTaxPound: IconTaxPound,
  IconTeapot: IconTeapot,
  IconTelescope: IconTelescope,
  IconTelescopeOff: IconTelescopeOff,
  IconTemperature: IconTemperature,
  IconTemperatureCelsius: IconTemperatureCelsius,
  IconTemperatureFahrenheit: IconTemperatureFahrenheit,
  IconTemperatureMinus: IconTemperatureMinus,
  IconTemperatureMinusFilled: IconTemperatureMinusFilled,
  IconTemperatureOff: IconTemperatureOff,
  IconTemperaturePlus: IconTemperaturePlus,
  IconTemperaturePlusFilled: IconTemperaturePlusFilled,
  IconTemperatureSnow: IconTemperatureSnow,
  IconTemperatureSun: IconTemperatureSun,
  IconTemplate: IconTemplate,
  IconTemplateOff: IconTemplateOff,
  IconTent: IconTent,
  IconTentOff: IconTentOff,
  IconTerminal: IconTerminal,
  IconTerminal2: IconTerminal2,
  IconTestPipe: IconTestPipe,
  IconTestPipe2: IconTestPipe2,
  IconTestPipe2Filled: IconTestPipe2Filled,
  IconTestPipeOff: IconTestPipeOff,
  IconTex: IconTex,
  IconTextCaption: IconTextCaption,
  IconTextColor: IconTextColor,
  IconTextDecrease: IconTextDecrease,
  IconTextDirectionLtr: IconTextDirectionLtr,
  IconTextDirectionRtl: IconTextDirectionRtl,
  IconTextGrammar: IconTextGrammar,
  IconTextIncrease: IconTextIncrease,
  IconTextOrientation: IconTextOrientation,
  IconTextPlus: IconTextPlus,
  IconTextRecognition: IconTextRecognition,
  IconTextResize: IconTextResize,
  IconTextScan2: IconTextScan2,
  IconTextSize: IconTextSize,
  IconTextSpellcheck: IconTextSpellcheck,
  IconTextWrap: IconTextWrap,
  IconTextWrapColumn: IconTextWrapColumn,
  IconTextWrapDisabled: IconTextWrapDisabled,
  IconTexture: IconTexture,
  IconTheater: IconTheater,
  IconThermometer: IconThermometer,
  IconThumbDown: IconThumbDown,
  IconThumbDownFilled: IconThumbDownFilled,
  IconThumbDownOff: IconThumbDownOff,
  IconThumbUp: IconThumbUp,
  IconThumbUpFilled: IconThumbUpFilled,
  IconThumbUpOff: IconThumbUpOff,
  IconTicTac: IconTicTac,
  IconTicket: IconTicket,
  IconTicketOff: IconTicketOff,
  IconTie: IconTie,
  IconTilde: IconTilde,
  IconTiltShift: IconTiltShift,
  IconTiltShiftFilled: IconTiltShiftFilled,
  IconTiltShiftOff: IconTiltShiftOff,
  IconTimeDuration0: IconTimeDuration0,
  IconTimeDuration10: IconTimeDuration10,
  IconTimeDuration15: IconTimeDuration15,
  IconTimeDuration30: IconTimeDuration30,
  IconTimeDuration45: IconTimeDuration45,
  IconTimeDuration5: IconTimeDuration5,
  IconTimeDuration60: IconTimeDuration60,
  IconTimeDuration90: IconTimeDuration90,
  IconTimeDurationOff: IconTimeDurationOff,
  IconTimeline: IconTimeline,
  IconTimelineEvent: IconTimelineEvent,
  IconTimelineEventExclamation: IconTimelineEventExclamation,
  IconTimelineEventFilled: IconTimelineEventFilled,
  IconTimelineEventMinus: IconTimelineEventMinus,
  IconTimelineEventPlus: IconTimelineEventPlus,
  IconTimelineEventText: IconTimelineEventText,
  IconTimelineEventX: IconTimelineEventX,
  IconTimezone: IconTimezone,
  IconTipJar: IconTipJar,
  IconTipJarEuro: IconTipJarEuro,
  IconTipJarPound: IconTipJarPound,
  IconTir: IconTir,
  IconToggleLeft: IconToggleLeft,
  IconToggleLeftFilled: IconToggleLeftFilled,
  IconToggleRight: IconToggleRight,
  IconToggleRightFilled: IconToggleRightFilled,
  IconToiletPaper: IconToiletPaper,
  IconToiletPaperOff: IconToiletPaperOff,
  IconToml: IconToml,
  IconTool: IconTool,
  IconTools: IconTools,
  IconToolsKitchen: IconToolsKitchen,
  IconToolsKitchen2: IconToolsKitchen2,
  IconToolsKitchen2Off: IconToolsKitchen2Off,
  IconToolsKitchen3: IconToolsKitchen3,
  IconToolsKitchenOff: IconToolsKitchenOff,
  IconToolsOff: IconToolsOff,
  IconTooltip: IconTooltip,
  IconTopologyBus: IconTopologyBus,
  IconTopologyComplex: IconTopologyComplex,
  IconTopologyFull: IconTopologyFull,
  IconTopologyFullHierarchy: IconTopologyFullHierarchy,
  IconTopologyRing: IconTopologyRing,
  IconTopologyRing2: IconTopologyRing2,
  IconTopologyRing3: IconTopologyRing3,
  IconTopologyStar: IconTopologyStar,
  IconTopologyStar2: IconTopologyStar2,
  IconTopologyStar3: IconTopologyStar3,
  IconTopologyStarRing: IconTopologyStarRing,
  IconTopologyStarRing2: IconTopologyStarRing2,
  IconTopologyStarRing3: IconTopologyStarRing3,
  IconTorii: IconTorii,
  IconTornado: IconTornado,
  IconTournament: IconTournament,
  IconTower: IconTower,
  IconTowerOff: IconTowerOff,
  IconTrack: IconTrack,
  IconTractor: IconTractor,
  IconTrademark: IconTrademark,
  IconTrafficCone: IconTrafficCone,
  IconTrafficConeOff: IconTrafficConeOff,
  IconTrafficLights: IconTrafficLights,
  IconTrafficLightsOff: IconTrafficLightsOff,
  IconTrain: IconTrain,
  IconTrainFilled: IconTrainFilled,
  IconTransactionBitcoin: IconTransactionBitcoin,
  IconTransactionDollar: IconTransactionDollar,
  IconTransactionEuro: IconTransactionEuro,
  IconTransactionPound: IconTransactionPound,
  IconTransactionRupee: IconTransactionRupee,
  IconTransactionYen: IconTransactionYen,
  IconTransactionYuan: IconTransactionYuan,
  IconTransfer: IconTransfer,
  IconTransferIn: IconTransferIn,
  IconTransferOut: IconTransferOut,
  IconTransferVertical: IconTransferVertical,
  IconTransform: IconTransform,
  IconTransformFilled: IconTransformFilled,
  IconTransformPoint: IconTransformPoint,
  IconTransformPointBottomLeft: IconTransformPointBottomLeft,
  IconTransformPointBottomRight: IconTransformPointBottomRight,
  IconTransformPointTopLeft: IconTransformPointTopLeft,
  IconTransformPointTopRight: IconTransformPointTopRight,
  IconTransitionBottom: IconTransitionBottom,
  IconTransitionBottomFilled: IconTransitionBottomFilled,
  IconTransitionLeft: IconTransitionLeft,
  IconTransitionLeftFilled: IconTransitionLeftFilled,
  IconTransitionRight: IconTransitionRight,
  IconTransitionRightFilled: IconTransitionRightFilled,
  IconTransitionTop: IconTransitionTop,
  IconTransitionTopFilled: IconTransitionTopFilled,
  IconTrash: IconTrash,
  IconTrashFilled: IconTrashFilled,
  IconTrashOff: IconTrashOff,
  IconTrashX: IconTrashX,
  IconTrashXFilled: IconTrashXFilled,
  IconTreadmill: IconTreadmill,
  IconTree: IconTree,
  IconTrees: IconTrees,
  IconTrekking: IconTrekking,
  IconTrendingDown: IconTrendingDown,
  IconTrendingDown2: IconTrendingDown2,
  IconTrendingDown3: IconTrendingDown3,
  IconTrendingUp: IconTrendingUp,
  IconTrendingUp2: IconTrendingUp2,
  IconTrendingUp3: IconTrendingUp3,
  IconTriangle: IconTriangle,
  IconTriangleFilled: IconTriangleFilled,
  IconTriangleInverted: IconTriangleInverted,
  IconTriangleInvertedFilled: IconTriangleInvertedFilled,
  IconTriangleMinus: IconTriangleMinus,
  IconTriangleMinus2: IconTriangleMinus2,
  IconTriangleOff: IconTriangleOff,
  IconTrianglePlus: IconTrianglePlus,
  IconTrianglePlus2: IconTrianglePlus2,
  IconTriangleSquareCircle: IconTriangleSquareCircle,
  IconTriangleSquareCircleFilled: IconTriangleSquareCircleFilled,
  IconTriangles: IconTriangles,
  IconTrident: IconTrident,
  IconTrolley: IconTrolley,
  IconTrolleyFilled: IconTrolleyFilled,
  IconTrophy: IconTrophy,
  IconTrophyFilled: IconTrophyFilled,
  IconTrophyOff: IconTrophyOff,
  IconTrowel: IconTrowel,
  IconTruck: IconTruck,
  IconTruckDelivery: IconTruckDelivery,
  IconTruckFilled: IconTruckFilled,
  IconTruckLoading: IconTruckLoading,
  IconTruckOff: IconTruckOff,
  IconTruckReturn: IconTruckReturn,
  IconTxt: IconTxt,
  IconTypeface: IconTypeface,
  IconTypography: IconTypography,
  IconTypographyOff: IconTypographyOff,
  IconUTurnLeft: IconUTurnLeft,
  IconUTurnRight: IconUTurnRight,
  IconUfo: IconUfo,
  IconUfoOff: IconUfoOff,
  IconUhd: IconUhd,
  IconUmbrella: IconUmbrella,
  IconUmbrella2: IconUmbrella2,
  IconUmbrellaClosed: IconUmbrellaClosed,
  IconUmbrellaClosed2: IconUmbrellaClosed2,
  IconUmbrellaFilled: IconUmbrellaFilled,
  IconUmbrellaOff: IconUmbrellaOff,
  IconUnderline: IconUnderline,
  IconUniverse: IconUniverse,
  IconUnlink: IconUnlink,
  IconUpload: IconUpload,
  IconUrgent: IconUrgent,
  IconUsb: IconUsb,
  IconUser: IconUser,
  IconUserBitcoin: IconUserBitcoin,
  IconUserBolt: IconUserBolt,
  IconUserCancel: IconUserCancel,
  IconUserCheck: IconUserCheck,
  IconUserCircle: IconUserCircle,
  IconUserCode: IconUserCode,
  IconUserCog: IconUserCog,
  IconUserDollar: IconUserDollar,
  IconUserDown: IconUserDown,
  IconUserEdit: IconUserEdit,
  IconUserExclamation: IconUserExclamation,
  IconUserFilled: IconUserFilled,
  IconUserHeart: IconUserHeart,
  IconUserHexagon: IconUserHexagon,
  IconUserMinus: IconUserMinus,
  IconUserOff: IconUserOff,
  IconUserPause: IconUserPause,
  IconUserPentagon: IconUserPentagon,
  IconUserPin: IconUserPin,
  IconUserPlus: IconUserPlus,
  IconUserQuestion: IconUserQuestion,
  IconUserScan: IconUserScan,
  IconUserScreen: IconUserScreen,
  IconUserSearch: IconUserSearch,
  IconUserShare: IconUserShare,
  IconUserShield: IconUserShield,
  IconUserSquare: IconUserSquare,
  IconUserSquareRounded: IconUserSquareRounded,
  IconUserStar: IconUserStar,
  IconUserUp: IconUserUp,
  IconUserX: IconUserX,
  IconUsers: IconUsers,
  IconUsersGroup: IconUsersGroup,
  IconUsersMinus: IconUsersMinus,
  IconUsersPlus: IconUsersPlus,
  IconUvIndex: IconUvIndex,
  IconUxCircle: IconUxCircle,
  IconVaccine: IconVaccine,
  IconVaccineBottle: IconVaccineBottle,
  IconVaccineBottleOff: IconVaccineBottleOff,
  IconVaccineOff: IconVaccineOff,
  IconVacuumCleaner: IconVacuumCleaner,
  IconVariable: IconVariable,
  IconVariableMinus: IconVariableMinus,
  IconVariableOff: IconVariableOff,
  IconVariablePlus: IconVariablePlus,
  IconVector: IconVector,
  IconVectorBezier: IconVectorBezier,
  IconVectorBezier2: IconVectorBezier2,
  IconVectorBezierArc: IconVectorBezierArc,
  IconVectorBezierCircle: IconVectorBezierCircle,
  IconVectorOff: IconVectorOff,
  IconVectorSpline: IconVectorSpline,
  IconVectorTriangle: IconVectorTriangle,
  IconVectorTriangleOff: IconVectorTriangleOff,
  IconVenus: IconVenus,
  IconVersions: IconVersions,
  IconVersionsFilled: IconVersionsFilled,
  IconVersionsOff: IconVersionsOff,
  IconVideo: IconVideo,
  IconVideoFilled: IconVideoFilled,
  IconVideoMinus: IconVideoMinus,
  IconVideoOff: IconVideoOff,
  IconVideoPlus: IconVideoPlus,
  IconView360: IconView360,
  IconView360Arrow: IconView360Arrow,
  IconView360Number: IconView360Number,
  IconView360Off: IconView360Off,
  IconViewfinder: IconViewfinder,
  IconViewfinderOff: IconViewfinderOff,
  IconViewportNarrow: IconViewportNarrow,
  IconViewportShort: IconViewportShort,
  IconViewportTall: IconViewportTall,
  IconViewportWide: IconViewportWide,
  IconVinyl: IconVinyl,
  IconVip: IconVip,
  IconVipOff: IconVipOff,
  IconVirus: IconVirus,
  IconVirusOff: IconVirusOff,
  IconVirusSearch: IconVirusSearch,
  IconVocabulary: IconVocabulary,
  IconVocabularyOff: IconVocabularyOff,
  IconVolcano: IconVolcano,
  IconVolume: IconVolume,
  IconVolume2: IconVolume2,
  IconVolume3: IconVolume3,
  IconVolumeOff: IconVolumeOff,
  IconVs: IconVs,
  IconWalk: IconWalk,
  IconWall: IconWall,
  IconWallOff: IconWallOff,
  IconWallet: IconWallet,
  IconWalletOff: IconWalletOff,
  IconWallpaper: IconWallpaper,
  IconWallpaperOff: IconWallpaperOff,
  IconWand: IconWand,
  IconWandOff: IconWandOff,
  IconWash: IconWash,
  IconWashDry: IconWashDry,
  IconWashDry1: IconWashDry1,
  IconWashDry2: IconWashDry2,
  IconWashDry3: IconWashDry3,
  IconWashDryA: IconWashDryA,
  IconWashDryDip: IconWashDryDip,
  IconWashDryF: IconWashDryF,
  IconWashDryFlat: IconWashDryFlat,
  IconWashDryHang: IconWashDryHang,
  IconWashDryOff: IconWashDryOff,
  IconWashDryP: IconWashDryP,
  IconWashDryShade: IconWashDryShade,
  IconWashDryW: IconWashDryW,
  IconWashDryclean: IconWashDryclean,
  IconWashDrycleanOff: IconWashDrycleanOff,
  IconWashEco: IconWashEco,
  IconWashGentle: IconWashGentle,
  IconWashHand: IconWashHand,
  IconWashMachine: IconWashMachine,
  IconWashOff: IconWashOff,
  IconWashPress: IconWashPress,
  IconWashTemperature1: IconWashTemperature1,
  IconWashTemperature2: IconWashTemperature2,
  IconWashTemperature3: IconWashTemperature3,
  IconWashTemperature4: IconWashTemperature4,
  IconWashTemperature5: IconWashTemperature5,
  IconWashTemperature6: IconWashTemperature6,
  IconWashTumbleDry: IconWashTumbleDry,
  IconWashTumbleOff: IconWashTumbleOff,
  IconWaterpolo: IconWaterpolo,
  IconWaveSawTool: IconWaveSawTool,
  IconWaveSine: IconWaveSine,
  IconWaveSquare: IconWaveSquare,
  IconWavesElectricity: IconWavesElectricity,
  IconWebhook: IconWebhook,
  IconWebhookOff: IconWebhookOff,
  IconWeight: IconWeight,
  IconWheat: IconWheat,
  IconWheatOff: IconWheatOff,
  IconWheel: IconWheel,
  IconWheelchair: IconWheelchair,
  IconWheelchairOff: IconWheelchairOff,
  IconWhirl: IconWhirl,
  IconWifi: IconWifi,
  IconWifi0: IconWifi0,
  IconWifi1: IconWifi1,
  IconWifi2: IconWifi2,
  IconWifiOff: IconWifiOff,
  IconWind: IconWind,
  IconWindElectricity: IconWindElectricity,
  IconWindOff: IconWindOff,
  IconWindmill: IconWindmill,
  IconWindmillFilled: IconWindmillFilled,
  IconWindmillOff: IconWindmillOff,
  IconWindow: IconWindow,
  IconWindowMaximize: IconWindowMaximize,
  IconWindowMinimize: IconWindowMinimize,
  IconWindowOff: IconWindowOff,
  IconWindsock: IconWindsock,
  IconWindsockFilled: IconWindsockFilled,
  IconWiper: IconWiper,
  IconWiperWash: IconWiperWash,
  IconWoman: IconWoman,
  IconWomanFilled: IconWomanFilled,
  IconWood: IconWood,
  IconWorld: IconWorld,
  IconWorldBolt: IconWorldBolt,
  IconWorldCancel: IconWorldCancel,
  IconWorldCheck: IconWorldCheck,
  IconWorldCode: IconWorldCode,
  IconWorldCog: IconWorldCog,
  IconWorldDollar: IconWorldDollar,
  IconWorldDown: IconWorldDown,
  IconWorldDownload: IconWorldDownload,
  IconWorldExclamation: IconWorldExclamation,
  IconWorldHeart: IconWorldHeart,
  IconWorldLatitude: IconWorldLatitude,
  IconWorldLongitude: IconWorldLongitude,
  IconWorldMinus: IconWorldMinus,
  IconWorldOff: IconWorldOff,
  IconWorldPause: IconWorldPause,
  IconWorldPin: IconWorldPin,
  IconWorldPlus: IconWorldPlus,
  IconWorldQuestion: IconWorldQuestion,
  IconWorldSearch: IconWorldSearch,
  IconWorldShare: IconWorldShare,
  IconWorldStar: IconWorldStar,
  IconWorldUp: IconWorldUp,
  IconWorldUpload: IconWorldUpload,
  IconWorldWww: IconWorldWww,
  IconWorldX: IconWorldX,
  IconWreckingBall: IconWreckingBall,
  IconWriting: IconWriting,
  IconWritingOff: IconWritingOff,
  IconWritingSign: IconWritingSign,
  IconWritingSignOff: IconWritingSignOff,
  IconX: IconX,
  IconXPowerY: IconXPowerY,
  IconXboxA: IconXboxA,
  IconXboxAFilled: IconXboxAFilled,
  IconXboxB: IconXboxB,
  IconXboxBFilled: IconXboxBFilled,
  IconXboxX: IconXboxX,
  IconXboxXFilled: IconXboxXFilled,
  IconXboxY: IconXboxY,
  IconXboxYFilled: IconXboxYFilled,
  IconXd: IconXd,
  IconXxx: IconXxx,
  IconYinYang: IconYinYang,
  IconYinYangFilled: IconYinYangFilled,
  IconYoga: IconYoga,
  IconZeppelin: IconZeppelin,
  IconZeppelinFilled: IconZeppelinFilled,
  IconZeppelinOff: IconZeppelinOff,
  IconZip: IconZip,
  IconZodiacAquarius: IconZodiacAquarius,
  IconZodiacAries: IconZodiacAries,
  IconZodiacCancer: IconZodiacCancer,
  IconZodiacCapricorn: IconZodiacCapricorn,
  IconZodiacGemini: IconZodiacGemini,
  IconZodiacLeo: IconZodiacLeo,
  IconZodiacLibra: IconZodiacLibra,
  IconZodiacPisces: IconZodiacPisces,
  IconZodiacSagittarius: IconZodiacSagittarius,
  IconZodiacScorpio: IconZodiacScorpio,
  IconZodiacTaurus: IconZodiacTaurus,
  IconZodiacVirgo: IconZodiacVirgo,
  IconZoom: IconZoom,
  IconZoomCancel: IconZoomCancel,
  IconZoomCancelFilled: IconZoomCancelFilled,
  IconZoomCheck: IconZoomCheck,
  IconZoomCheckFilled: IconZoomCheckFilled,
  IconZoomCode: IconZoomCode,
  IconZoomCodeFilled: IconZoomCodeFilled,
  IconZoomExclamation: IconZoomExclamation,
  IconZoomExclamationFilled: IconZoomExclamationFilled,
  IconZoomFilled: IconZoomFilled,
  IconZoomIn: IconZoomIn,
  IconZoomInArea: IconZoomInArea,
  IconZoomInAreaFilled: IconZoomInAreaFilled,
  IconZoomInFilled: IconZoomInFilled,
  IconZoomMoney: IconZoomMoney,
  IconZoomMoneyFilled: IconZoomMoneyFilled,
  IconZoomOut: IconZoomOut,
  IconZoomOutArea: IconZoomOutArea,
  IconZoomOutAreaFilled: IconZoomOutAreaFilled,
  IconZoomOutFilled: IconZoomOutFilled,
  IconZoomPan: IconZoomPan,
  IconZoomPanFilled: IconZoomPanFilled,
  IconZoomQuestion: IconZoomQuestion,
  IconZoomQuestionFilled: IconZoomQuestionFilled,
  IconZoomReplace: IconZoomReplace,
  IconZoomReset: IconZoomReset,
  IconZoomScan: IconZoomScan,
  IconZoomScanFilled: IconZoomScanFilled,
  IconZzz: IconZzz,
  IconZzzOff: IconZzzOff
});

var iconsList = [
  "a-b-2",
  "a-b-off",
  "a-b",
  "abacus-off",
  "abacus",
  "abc",
  "access-point-off",
  "access-point",
  "accessible-off",
  "accessible",
  "activity-heartbeat",
  "activity",
  "ad-2",
  "ad-circle-off",
  "ad-circle",
  "ad-off",
  "ad",
  "address-book-off",
  "address-book",
  "adjustments-alt",
  "adjustments-bolt",
  "adjustments-cancel",
  "adjustments-check",
  "adjustments-code",
  "adjustments-cog",
  "adjustments-dollar",
  "adjustments-down",
  "adjustments-exclamation",
  "adjustments-heart",
  "adjustments-horizontal",
  "adjustments-minus",
  "adjustments-off",
  "adjustments-pause",
  "adjustments-pin",
  "adjustments-plus",
  "adjustments-question",
  "adjustments-search",
  "adjustments-share",
  "adjustments-spark",
  "adjustments-star",
  "adjustments-up",
  "adjustments-x",
  "adjustments",
  "aerial-lift",
  "affiliate",
  "ai",
  "air-balloon",
  "air-conditioning-disabled",
  "air-conditioning",
  "air-traffic-control",
  "alarm-average",
  "alarm-minus",
  "alarm-off",
  "alarm-plus",
  "alarm-smoke",
  "alarm-snooze",
  "alarm",
  "album-off",
  "album",
  "alert-circle-off",
  "alert-circle",
  "alert-hexagon-off",
  "alert-hexagon",
  "alert-octagon",
  "alert-small-off",
  "alert-small",
  "alert-square-rounded-off",
  "alert-square-rounded",
  "alert-square",
  "alert-triangle-off",
  "alert-triangle",
  "alien",
  "align-box-bottom-center",
  "align-box-bottom-left",
  "align-box-bottom-right",
  "align-box-center-bottom",
  "align-box-center-middle",
  "align-box-center-stretch",
  "align-box-center-top",
  "align-box-left-bottom",
  "align-box-left-middle",
  "align-box-left-stretch",
  "align-box-left-top",
  "align-box-right-bottom",
  "align-box-right-middle",
  "align-box-right-stretch",
  "align-box-right-top",
  "align-box-top-center",
  "align-box-top-left",
  "align-box-top-right",
  "align-center",
  "align-justified",
  "align-left-2",
  "align-left",
  "align-right-2",
  "align-right",
  "alpha",
  "alphabet-arabic",
  "alphabet-bangla",
  "alphabet-cyrillic",
  "alphabet-greek",
  "alphabet-hebrew",
  "alphabet-korean",
  "alphabet-latin",
  "alphabet-thai",
  "alt",
  "ambulance",
  "ampersand",
  "analyze-off",
  "analyze",
  "anchor-off",
  "anchor",
  "angle",
  "ankh",
  "antenna-bars-1",
  "antenna-bars-2",
  "antenna-bars-3",
  "antenna-bars-4",
  "antenna-bars-5",
  "antenna-bars-off",
  "antenna-off",
  "antenna",
  "aperture-off",
  "aperture",
  "api-app-off",
  "api-app",
  "api-off",
  "api",
  "app-window",
  "apple",
  "apps-off",
  "apps",
  "archery-arrow",
  "archive-off",
  "archive",
  "armchair-2-off",
  "armchair-2",
  "armchair-off",
  "armchair",
  "arrow-autofit-content",
  "arrow-autofit-down",
  "arrow-autofit-height",
  "arrow-autofit-left",
  "arrow-autofit-right",
  "arrow-autofit-up",
  "arrow-autofit-width",
  "arrow-back-up-double",
  "arrow-back-up",
  "arrow-back",
  "arrow-badge-down",
  "arrow-badge-left",
  "arrow-badge-right",
  "arrow-badge-up",
  "arrow-bar-both",
  "arrow-bar-down",
  "arrow-bar-left",
  "arrow-bar-right",
  "arrow-bar-to-down",
  "arrow-bar-to-left",
  "arrow-bar-to-right",
  "arrow-bar-to-up",
  "arrow-bar-up",
  "arrow-bear-left-2",
  "arrow-bear-left",
  "arrow-bear-right-2",
  "arrow-bear-right",
  "arrow-big-down-line",
  "arrow-big-down-lines",
  "arrow-big-down",
  "arrow-big-left-line",
  "arrow-big-left-lines",
  "arrow-big-left",
  "arrow-big-right-line",
  "arrow-big-right-lines",
  "arrow-big-right",
  "arrow-big-up-line",
  "arrow-big-up-lines",
  "arrow-big-up",
  "arrow-bounce",
  "arrow-capsule",
  "arrow-curve-left",
  "arrow-curve-right",
  "arrow-down-bar",
  "arrow-down-circle",
  "arrow-down-dashed",
  "arrow-down-from-arc",
  "arrow-down-left-circle",
  "arrow-down-left",
  "arrow-down-rhombus",
  "arrow-down-right-circle",
  "arrow-down-right",
  "arrow-down-square",
  "arrow-down-tail",
  "arrow-down-to-arc",
  "arrow-down",
  "arrow-elbow-left",
  "arrow-elbow-right",
  "arrow-fork",
  "arrow-forward-up-double",
  "arrow-forward-up",
  "arrow-forward",
  "arrow-guide",
  "arrow-iteration",
  "arrow-left-bar",
  "arrow-left-circle",
  "arrow-left-dashed",
  "arrow-left-from-arc",
  "arrow-left-rhombus",
  "arrow-left-right",
  "arrow-left-square",
  "arrow-left-tail",
  "arrow-left-to-arc",
  "arrow-left",
  "arrow-loop-left-2",
  "arrow-loop-left",
  "arrow-loop-right-2",
  "arrow-loop-right",
  "arrow-merge-alt-left",
  "arrow-merge-alt-right",
  "arrow-merge-both",
  "arrow-merge-left",
  "arrow-merge-right",
  "arrow-merge",
  "arrow-move-down",
  "arrow-move-left",
  "arrow-move-right",
  "arrow-move-up",
  "arrow-narrow-down-dashed",
  "arrow-narrow-down",
  "arrow-narrow-left-dashed",
  "arrow-narrow-left",
  "arrow-narrow-right-dashed",
  "arrow-narrow-right",
  "arrow-narrow-up-dashed",
  "arrow-narrow-up",
  "arrow-ramp-left-2",
  "arrow-ramp-left-3",
  "arrow-ramp-left",
  "arrow-ramp-right-2",
  "arrow-ramp-right-3",
  "arrow-ramp-right",
  "arrow-right-bar",
  "arrow-right-circle",
  "arrow-right-dashed",
  "arrow-right-from-arc",
  "arrow-right-rhombus",
  "arrow-right-square",
  "arrow-right-tail",
  "arrow-right-to-arc",
  "arrow-right",
  "arrow-rotary-first-left",
  "arrow-rotary-first-right",
  "arrow-rotary-last-left",
  "arrow-rotary-last-right",
  "arrow-rotary-left",
  "arrow-rotary-right",
  "arrow-rotary-straight",
  "arrow-roundabout-left",
  "arrow-roundabout-right",
  "arrow-sharp-turn-left",
  "arrow-sharp-turn-right",
  "arrow-up-bar",
  "arrow-up-circle",
  "arrow-up-dashed",
  "arrow-up-from-arc",
  "arrow-up-left-circle",
  "arrow-up-left",
  "arrow-up-rhombus",
  "arrow-up-right-circle",
  "arrow-up-right",
  "arrow-up-square",
  "arrow-up-tail",
  "arrow-up-to-arc",
  "arrow-up",
  "arrow-wave-left-down",
  "arrow-wave-left-up",
  "arrow-wave-right-down",
  "arrow-wave-right-up",
  "arrow-zig-zag",
  "arrows-cross",
  "arrows-diagonal-2",
  "arrows-diagonal-minimize-2",
  "arrows-diagonal-minimize",
  "arrows-diagonal",
  "arrows-diff",
  "arrows-double-ne-sw",
  "arrows-double-nw-se",
  "arrows-double-se-nw",
  "arrows-double-sw-ne",
  "arrows-down-up",
  "arrows-down",
  "arrows-exchange-2",
  "arrows-exchange",
  "arrows-horizontal",
  "arrows-join-2",
  "arrows-join",
  "arrows-left-down",
  "arrows-left-right",
  "arrows-left",
  "arrows-maximize",
  "arrows-minimize",
  "arrows-move-horizontal",
  "arrows-move-vertical",
  "arrows-move",
  "arrows-random",
  "arrows-right-down",
  "arrows-right-left",
  "arrows-right",
  "arrows-shuffle-2",
  "arrows-shuffle",
  "arrows-sort",
  "arrows-split-2",
  "arrows-split",
  "arrows-transfer-down",
  "arrows-transfer-up-down",
  "arrows-transfer-up",
  "arrows-up-down",
  "arrows-up-left",
  "arrows-up-right",
  "arrows-up",
  "arrows-vertical",
  "artboard-off",
  "artboard",
  "article-off",
  "article",
  "aspect-ratio-off",
  "aspect-ratio",
  "assembly-off",
  "assembly",
  "asset",
  "asterisk-simple",
  "asterisk",
  "at-off",
  "at",
  "atom-2",
  "atom-off",
  "atom",
  "augmented-reality-2",
  "augmented-reality-off",
  "augmented-reality",
  "auth-2fa",
  "automatic-gearbox",
  "automation",
  "avocado",
  "award-off",
  "award",
  "axe",
  "axis-x",
  "axis-y",
  "baby-bottle",
  "baby-carriage",
  "background",
  "backhoe",
  "backpack-off",
  "backpack",
  "backslash",
  "backspace",
  "badge-2k",
  "badge-3d",
  "badge-3k",
  "badge-4k",
  "badge-5k",
  "badge-8k",
  "badge-ad-off",
  "badge-ad",
  "badge-ar",
  "badge-cc",
  "badge-hd",
  "badge-off",
  "badge-sd",
  "badge-tm",
  "badge-vo",
  "badge-vr",
  "badge-wc",
  "badge",
  "badges-off",
  "badges",
  "baguette",
  "ball-american-football-off",
  "ball-american-football",
  "ball-baseball",
  "ball-basketball",
  "ball-bowling",
  "ball-football-off",
  "ball-football",
  "ball-tennis",
  "ball-volleyball",
  "balloon-off",
  "balloon",
  "ballpen-off",
  "ballpen",
  "ban",
  "bandage-off",
  "bandage",
  "barbell-off",
  "barbell",
  "barcode-off",
  "barcode",
  "barrel-off",
  "barrel",
  "barrier-block-off",
  "barrier-block",
  "baseline-density-large",
  "baseline-density-medium",
  "baseline-density-small",
  "baseline",
  "basket-bolt",
  "basket-cancel",
  "basket-check",
  "basket-code",
  "basket-cog",
  "basket-discount",
  "basket-dollar",
  "basket-down",
  "basket-exclamation",
  "basket-heart",
  "basket-minus",
  "basket-off",
  "basket-pause",
  "basket-pin",
  "basket-plus",
  "basket-question",
  "basket-search",
  "basket-share",
  "basket-star",
  "basket-up",
  "basket-x",
  "basket",
  "bat",
  "bath-off",
  "bath",
  "battery-1",
  "battery-2",
  "battery-3",
  "battery-4",
  "battery-automotive",
  "battery-charging-2",
  "battery-charging",
  "battery-eco",
  "battery-exclamation",
  "battery-off",
  "battery-spark",
  "battery-vertical-1",
  "battery-vertical-2",
  "battery-vertical-3",
  "battery-vertical-4",
  "battery-vertical-charging-2",
  "battery-vertical-charging",
  "battery-vertical-eco",
  "battery-vertical-exclamation",
  "battery-vertical-off",
  "battery-vertical",
  "battery",
  "beach-off",
  "beach",
  "bed-flat",
  "bed-off",
  "bed",
  "beer-off",
  "beer",
  "bell-bolt",
  "bell-cancel",
  "bell-check",
  "bell-code",
  "bell-cog",
  "bell-dollar",
  "bell-down",
  "bell-exclamation",
  "bell-heart",
  "bell-minus",
  "bell-off",
  "bell-pause",
  "bell-pin",
  "bell-plus",
  "bell-question",
  "bell-ringing-2",
  "bell-ringing",
  "bell-school",
  "bell-search",
  "bell-share",
  "bell-star",
  "bell-up",
  "bell-x",
  "bell-z",
  "bell",
  "beta",
  "bible",
  "bike-off",
  "bike",
  "binary-off",
  "binary-tree-2",
  "binary-tree",
  "binary",
  "binoculars",
  "biohazard-off",
  "biohazard",
  "blade",
  "bleach-chlorine",
  "bleach-no-chlorine",
  "bleach-off",
  "bleach",
  "blend-mode",
  "blender",
  "blob",
  "blockquote",
  "blocks",
  "bluetooth-connected",
  "bluetooth-off",
  "bluetooth-x",
  "bluetooth",
  "blur-off",
  "blur",
  "bmp",
  "body-scan",
  "bold-off",
  "bold",
  "bolt-off",
  "bolt",
  "bomb",
  "bone-off",
  "bone",
  "bong-off",
  "bong",
  "book-2",
  "book-download",
  "book-off",
  "book-upload",
  "book",
  "bookmark-ai",
  "bookmark-edit",
  "bookmark-minus",
  "bookmark-off",
  "bookmark-plus",
  "bookmark-question",
  "bookmark",
  "bookmarks-off",
  "bookmarks",
  "books-off",
  "books",
  "boom",
  "border-all",
  "border-bottom-plus",
  "border-bottom",
  "border-corner-ios",
  "border-corner-pill",
  "border-corner-rounded",
  "border-corner-square",
  "border-corners",
  "border-horizontal",
  "border-inner",
  "border-left-plus",
  "border-left",
  "border-none",
  "border-outer",
  "border-radius",
  "border-right-plus",
  "border-right",
  "border-sides",
  "border-style-2",
  "border-style",
  "border-top-plus",
  "border-top",
  "border-vertical",
  "bottle-off",
  "bottle",
  "bounce-left",
  "bounce-right",
  "bow",
  "bowl-chopsticks",
  "bowl-spoon",
  "bowl",
  "bowling",
  "box-align-bottom-left",
  "box-align-bottom-right",
  "box-align-bottom",
  "box-align-left",
  "box-align-right",
  "box-align-top-left",
  "box-align-top-right",
  "box-align-top",
  "box-margin",
  "box-model-2-off",
  "box-model-2",
  "box-model-off",
  "box-model",
  "box-multiple-0",
  "box-multiple-1",
  "box-multiple-2",
  "box-multiple-3",
  "box-multiple-4",
  "box-multiple-5",
  "box-multiple-6",
  "box-multiple-7",
  "box-multiple-8",
  "box-multiple-9",
  "box-multiple",
  "box-off",
  "box-padding",
  "box",
  "braces-off",
  "braces",
  "brackets-angle-off",
  "brackets-angle",
  "brackets-contain-end",
  "brackets-contain-start",
  "brackets-contain",
  "brackets-off",
  "brackets",
  "braille",
  "brain",
  "brand-4chan",
  "brand-abstract",
  "brand-adobe-after-effect",
  "brand-adobe-illustrator",
  "brand-adobe-indesign",
  "brand-adobe-photoshop",
  "brand-adobe-premier",
  "brand-adobe-xd",
  "brand-adobe",
  "brand-adonis-js",
  "brand-airbnb",
  "brand-airtable",
  "brand-algolia",
  "brand-alipay",
  "brand-alpine-js",
  "brand-amazon",
  "brand-amd",
  "brand-amie",
  "brand-amigo",
  "brand-among-us",
  "brand-android",
  "brand-angular",
  "brand-ansible",
  "brand-ao3",
  "brand-appgallery",
  "brand-apple-arcade",
  "brand-apple-news",
  "brand-apple-podcast",
  "brand-apple",
  "brand-appstore",
  "brand-arc",
  "brand-asana",
  "brand-astro",
  "brand-auth0",
  "brand-aws",
  "brand-azure",
  "brand-backbone",
  "brand-badoo",
  "brand-baidu",
  "brand-bandcamp",
  "brand-bandlab",
  "brand-beats",
  "brand-bebo",
  "brand-behance",
  "brand-bilibili",
  "brand-binance",
  "brand-bing",
  "brand-bitbucket",
  "brand-blackberry",
  "brand-blender",
  "brand-blogger",
  "brand-bluesky",
  "brand-booking",
  "brand-bootstrap",
  "brand-bulma",
  "brand-bumble",
  "brand-bunpo",
  "brand-c-sharp",
  "brand-cake",
  "brand-cakephp",
  "brand-campaignmonitor",
  "brand-carbon",
  "brand-cashapp",
  "brand-chrome",
  "brand-cinema-4d",
  "brand-citymapper",
  "brand-cloudflare",
  "brand-codecov",
  "brand-codepen",
  "brand-codesandbox",
  "brand-cohost",
  "brand-coinbase",
  "brand-comedy-central",
  "brand-coreos",
  "brand-couchdb",
  "brand-couchsurfing",
  "brand-cpp",
  "brand-craft",
  "brand-crunchbase",
  "brand-css3",
  "brand-ctemplar",
  "brand-cucumber",
  "brand-cupra",
  "brand-cypress",
  "brand-d3",
  "brand-databricks",
  "brand-days-counter",
  "brand-dcos",
  "brand-debian",
  "brand-deezer",
  "brand-deliveroo",
  "brand-deno",
  "brand-denodo",
  "brand-deviantart",
  "brand-digg",
  "brand-dingtalk",
  "brand-discord",
  "brand-disney",
  "brand-disqus",
  "brand-django",
  "brand-docker",
  "brand-doctrine",
  "brand-dolby-digital",
  "brand-douban",
  "brand-dribbble",
  "brand-drops",
  "brand-drupal",
  "brand-edge",
  "brand-elastic",
  "brand-electronic-arts",
  "brand-ember",
  "brand-envato",
  "brand-etsy",
  "brand-evernote",
  "brand-facebook",
  "brand-feedly",
  "brand-figma",
  "brand-filezilla",
  "brand-finder",
  "brand-firebase",
  "brand-firefox",
  "brand-fiverr",
  "brand-flickr",
  "brand-flightradar24",
  "brand-flipboard",
  "brand-flutter",
  "brand-fortnite",
  "brand-foursquare",
  "brand-framer-motion",
  "brand-framer",
  "brand-funimation",
  "brand-gatsby",
  "brand-git",
  "brand-github-copilot",
  "brand-github",
  "brand-gitlab",
  "brand-gmail",
  "brand-golang",
  "brand-google-analytics",
  "brand-google-big-query",
  "brand-google-drive",
  "brand-google-fit",
  "brand-google-home",
  "brand-google-maps",
  "brand-google-one",
  "brand-google-photos",
  "brand-google-play",
  "brand-google-podcasts",
  "brand-google",
  "brand-grammarly",
  "brand-graphql",
  "brand-gravatar",
  "brand-grindr",
  "brand-guardian",
  "brand-gumroad",
  "brand-hackerrank",
  "brand-hbo",
  "brand-headlessui",
  "brand-hexo",
  "brand-hipchat",
  "brand-html5",
  "brand-inertia",
  "brand-instagram",
  "brand-intercom",
  "brand-itch",
  "brand-javascript",
  "brand-juejin",
  "brand-kako-talk",
  "brand-kbin",
  "brand-kick",
  "brand-kickstarter",
  "brand-kotlin",
  "brand-laravel",
  "brand-lastfm",
  "brand-leetcode",
  "brand-letterboxd",
  "brand-line",
  "brand-linkedin",
  "brand-linktree",
  "brand-linqpad",
  "brand-livewire",
  "brand-loom",
  "brand-mailgun",
  "brand-mantine",
  "brand-mastercard",
  "brand-mastodon",
  "brand-matrix",
  "brand-mcdonalds",
  "brand-medium",
  "brand-meetup",
  "brand-mercedes",
  "brand-messenger",
  "brand-meta",
  "brand-metabrainz",
  "brand-minecraft",
  "brand-miniprogram",
  "brand-mixpanel",
  "brand-monday",
  "brand-mongodb",
  "brand-my-oppo",
  "brand-mysql",
  "brand-national-geographic",
  "brand-nem",
  "brand-netbeans",
  "brand-netease-music",
  "brand-netflix",
  "brand-nexo",
  "brand-nextcloud",
  "brand-nextjs",
  "brand-nodejs",
  "brand-nord-vpn",
  "brand-notion",
  "brand-npm",
  "brand-nuxt",
  "brand-nytimes",
  "brand-oauth",
  "brand-office",
  "brand-ok-ru",
  "brand-onedrive",
  "brand-onlyfans",
  "brand-open-source",
  "brand-openai",
  "brand-openvpn",
  "brand-opera",
  "brand-pagekit",
  "brand-parsinta",
  "brand-patreon",
  "brand-paypal",
  "brand-paypay",
  "brand-peanut",
  "brand-pepsi",
  "brand-php",
  "brand-picsart",
  "brand-pinterest",
  "brand-planetscale",
  "brand-pnpm",
  "brand-pocket",
  "brand-polymer",
  "brand-powershell",
  "brand-printables",
  "brand-prisma",
  "brand-producthunt",
  "brand-pushbullet",
  "brand-pushover",
  "brand-python",
  "brand-qq",
  "brand-radix-ui",
  "brand-react-native",
  "brand-react",
  "brand-reason",
  "brand-reddit",
  "brand-redhat",
  "brand-redux",
  "brand-revolut",
  "brand-rumble",
  "brand-rust",
  "brand-safari",
  "brand-samsungpass",
  "brand-sass",
  "brand-sentry",
  "brand-sharik",
  "brand-shazam",
  "brand-shopee",
  "brand-sketch",
  "brand-skype",
  "brand-slack",
  "brand-snapchat",
  "brand-snapseed",
  "brand-snowflake",
  "brand-socket-io",
  "brand-solidjs",
  "brand-soundcloud",
  "brand-spacehey",
  "brand-speedtest",
  "brand-spotify",
  "brand-stackoverflow",
  "brand-stackshare",
  "brand-steam",
  "brand-stocktwits",
  "brand-storj",
  "brand-storybook",
  "brand-storytel",
  "brand-strava",
  "brand-stripe",
  "brand-sublime-text",
  "brand-sugarizer",
  "brand-supabase",
  "brand-superhuman",
  "brand-supernova",
  "brand-surfshark",
  "brand-svelte",
  "brand-swift",
  "brand-symfony",
  "brand-tabler",
  "brand-tailwind",
  "brand-taobao",
  "brand-teams",
  "brand-ted",
  "brand-telegram",
  "brand-terraform",
  "brand-tesla",
  "brand-tether",
  "brand-thingiverse",
  "brand-threads",
  "brand-threejs",
  "brand-tidal",
  "brand-tiktok",
  "brand-tinder",
  "brand-topbuzz",
  "brand-torchain",
  "brand-toyota",
  "brand-trello",
  "brand-tripadvisor",
  "brand-tumblr",
  "brand-twilio",
  "brand-twitch",
  "brand-twitter",
  "brand-typescript",
  "brand-uber",
  "brand-ubuntu",
  "brand-unity",
  "brand-unsplash",
  "brand-upwork",
  "brand-valorant",
  "brand-vercel",
  "brand-vimeo",
  "brand-vinted",
  "brand-visa",
  "brand-visual-studio",
  "brand-vite",
  "brand-vivaldi",
  "brand-vk",
  "brand-vlc",
  "brand-volkswagen",
  "brand-vsco",
  "brand-vscode",
  "brand-vue",
  "brand-walmart",
  "brand-waze",
  "brand-webflow",
  "brand-wechat",
  "brand-weibo",
  "brand-whatsapp",
  "brand-wikipedia",
  "brand-windows",
  "brand-windy",
  "brand-wish",
  "brand-wix",
  "brand-wordpress",
  "brand-x",
  "brand-xamarin",
  "brand-xbox",
  "brand-xdeep",
  "brand-xing",
  "brand-yahoo",
  "brand-yandex",
  "brand-yarn",
  "brand-yatse",
  "brand-ycombinator",
  "brand-youtube-kids",
  "brand-youtube",
  "brand-zalando",
  "brand-zapier",
  "brand-zeit",
  "brand-zhihu",
  "brand-zoom",
  "brand-zulip",
  "brand-zwift",
  "bread-off",
  "bread",
  "briefcase-2",
  "briefcase-off",
  "briefcase",
  "brightness-2",
  "brightness-auto",
  "brightness-down",
  "brightness-half",
  "brightness-off",
  "brightness-up",
  "brightness",
  "broadcast-off",
  "broadcast",
  "browser-check",
  "browser-maximize",
  "browser-minus",
  "browser-off",
  "browser-plus",
  "browser-share",
  "browser-x",
  "browser",
  "brush-off",
  "brush",
  "bubble-minus",
  "bubble-plus",
  "bubble-tea-2",
  "bubble-tea",
  "bubble-text",
  "bubble-x",
  "bubble",
  "bucket-droplet",
  "bucket-off",
  "bucket",
  "bug-off",
  "bug",
  "building-airport",
  "building-arch",
  "building-bank",
  "building-bridge-2",
  "building-bridge",
  "building-broadcast-tower",
  "building-burj-al-arab",
  "building-carousel",
  "building-castle",
  "building-church",
  "building-circus",
  "building-cog",
  "building-community",
  "building-cottage",
  "building-estate",
  "building-factory-2",
  "building-factory",
  "building-fortress",
  "building-hospital",
  "building-lighthouse",
  "building-minus",
  "building-monument",
  "building-mosque",
  "building-off",
  "building-pavilion",
  "building-plus",
  "building-skyscraper",
  "building-stadium",
  "building-store",
  "building-tunnel",
  "building-warehouse",
  "building-wind-turbine",
  "building",
  "buildings",
  "bulb-off",
  "bulb",
  "bulldozer",
  "burger",
  "bus-off",
  "bus-stop",
  "bus",
  "businessplan",
  "butterfly",
  "cactus-off",
  "cactus",
  "cake-off",
  "cake-roll",
  "cake",
  "calculator-off",
  "calculator",
  "calendar-bolt",
  "calendar-cancel",
  "calendar-check",
  "calendar-clock",
  "calendar-code",
  "calendar-cog",
  "calendar-dollar",
  "calendar-dot",
  "calendar-down",
  "calendar-due",
  "calendar-event",
  "calendar-exclamation",
  "calendar-heart",
  "calendar-minus",
  "calendar-month",
  "calendar-off",
  "calendar-pause",
  "calendar-pin",
  "calendar-plus",
  "calendar-question",
  "calendar-repeat",
  "calendar-sad",
  "calendar-search",
  "calendar-share",
  "calendar-smile",
  "calendar-star",
  "calendar-stats",
  "calendar-time",
  "calendar-up",
  "calendar-user",
  "calendar-week",
  "calendar-x",
  "calendar",
  "camera-ai",
  "camera-bitcoin",
  "camera-bolt",
  "camera-cancel",
  "camera-check",
  "camera-code",
  "camera-cog",
  "camera-dollar",
  "camera-down",
  "camera-exclamation",
  "camera-heart",
  "camera-minus",
  "camera-moon",
  "camera-off",
  "camera-pause",
  "camera-pin",
  "camera-plus",
  "camera-question",
  "camera-rotate",
  "camera-search",
  "camera-selfie",
  "camera-share",
  "camera-spark",
  "camera-star",
  "camera-up",
  "camera-x",
  "camera",
  "camper",
  "campfire",
  "cancel",
  "candle",
  "candy-off",
  "candy",
  "cane",
  "cannabis",
  "cap-projecting",
  "cap-rounded",
  "cap-straight",
  "capsule-horizontal",
  "capsule",
  "capture-off",
  "capture",
  "car-4wd",
  "car-crane",
  "car-crash",
  "car-fan-1",
  "car-fan-2",
  "car-fan-3",
  "car-fan-auto",
  "car-fan",
  "car-garage",
  "car-off",
  "car-suv",
  "car-turbine",
  "car",
  "carambola",
  "caravan",
  "cardboards-off",
  "cardboards",
  "cards",
  "caret-down",
  "caret-left-right",
  "caret-left",
  "caret-right",
  "caret-up-down",
  "caret-up",
  "carousel-horizontal",
  "carousel-vertical",
  "carrot-off",
  "carrot",
  "cash-banknote-edit",
  "cash-banknote-heart",
  "cash-banknote-minus",
  "cash-banknote-move-back",
  "cash-banknote-move",
  "cash-banknote-off",
  "cash-banknote-plus",
  "cash-banknote",
  "cash-edit",
  "cash-heart",
  "cash-minus",
  "cash-move-back",
  "cash-move",
  "cash-off",
  "cash-plus",
  "cash-register",
  "cash",
  "cast-off",
  "cast",
  "cat",
  "category-2",
  "category-minus",
  "category-plus",
  "category",
  "ce-off",
  "ce",
  "cell-signal-1",
  "cell-signal-2",
  "cell-signal-3",
  "cell-signal-4",
  "cell-signal-5",
  "cell-signal-off",
  "cell",
  "certificate-2-off",
  "certificate-2",
  "certificate-off",
  "certificate",
  "chair-director",
  "chalkboard-off",
  "chalkboard",
  "charging-pile",
  "chart-arcs-3",
  "chart-arcs",
  "chart-area-line",
  "chart-area",
  "chart-arrows-vertical",
  "chart-arrows",
  "chart-bar-off",
  "chart-bar-popular",
  "chart-bar",
  "chart-bubble",
  "chart-candle",
  "chart-circles",
  "chart-cohort",
  "chart-column",
  "chart-covariate",
  "chart-donut-2",
  "chart-donut-3",
  "chart-donut-4",
  "chart-donut",
  "chart-dots-2",
  "chart-dots-3",
  "chart-dots",
  "chart-funnel",
  "chart-grid-dots",
  "chart-histogram",
  "chart-infographic",
  "chart-line",
  "chart-pie-2",
  "chart-pie-3",
  "chart-pie-4",
  "chart-pie-off",
  "chart-pie",
  "chart-ppf",
  "chart-radar",
  "chart-sankey",
  "chart-scatter-3d",
  "chart-scatter",
  "chart-treemap",
  "check",
  "checkbox",
  "checklist",
  "checks",
  "checkup-list",
  "cheese",
  "chef-hat-off",
  "chef-hat",
  "cherry",
  "chess-bishop",
  "chess-king",
  "chess-knight",
  "chess-queen",
  "chess-rook",
  "chess",
  "chevron-compact-down",
  "chevron-compact-left",
  "chevron-compact-right",
  "chevron-compact-up",
  "chevron-down-left",
  "chevron-down-right",
  "chevron-down",
  "chevron-left-pipe",
  "chevron-left",
  "chevron-right-pipe",
  "chevron-right",
  "chevron-up-left",
  "chevron-up-right",
  "chevron-up",
  "chevrons-down-left",
  "chevrons-down-right",
  "chevrons-down",
  "chevrons-left",
  "chevrons-right",
  "chevrons-up-left",
  "chevrons-up-right",
  "chevrons-up",
  "chisel",
  "christmas-ball",
  "christmas-tree-off",
  "christmas-tree",
  "circle-arrow-down-left",
  "circle-arrow-down-right",
  "circle-arrow-down",
  "circle-arrow-left",
  "circle-arrow-right",
  "circle-arrow-up-left",
  "circle-arrow-up-right",
  "circle-arrow-up",
  "circle-caret-down",
  "circle-caret-left",
  "circle-caret-right",
  "circle-caret-up",
  "circle-check",
  "circle-chevron-down",
  "circle-chevron-left",
  "circle-chevron-right",
  "circle-chevron-up",
  "circle-chevrons-down",
  "circle-chevrons-left",
  "circle-chevrons-right",
  "circle-chevrons-up",
  "circle-dashed-check",
  "circle-dashed-letter-a",
  "circle-dashed-letter-b",
  "circle-dashed-letter-c",
  "circle-dashed-letter-d",
  "circle-dashed-letter-e",
  "circle-dashed-letter-f",
  "circle-dashed-letter-g",
  "circle-dashed-letter-h",
  "circle-dashed-letter-i",
  "circle-dashed-letter-j",
  "circle-dashed-letter-k",
  "circle-dashed-letter-l",
  "circle-dashed-letter-m",
  "circle-dashed-letter-n",
  "circle-dashed-letter-o",
  "circle-dashed-letter-p",
  "circle-dashed-letter-q",
  "circle-dashed-letter-r",
  "circle-dashed-letter-s",
  "circle-dashed-letter-t",
  "circle-dashed-letter-u",
  "circle-dashed-letter-v",
  "circle-dashed-letter-w",
  "circle-dashed-letter-x",
  "circle-dashed-letter-y",
  "circle-dashed-letter-z",
  "circle-dashed-minus",
  "circle-dashed-number-0",
  "circle-dashed-number-1",
  "circle-dashed-number-2",
  "circle-dashed-number-3",
  "circle-dashed-number-4",
  "circle-dashed-number-5",
  "circle-dashed-number-6",
  "circle-dashed-number-7",
  "circle-dashed-number-8",
  "circle-dashed-number-9",
  "circle-dashed-percentage",
  "circle-dashed-plus",
  "circle-dashed-x",
  "circle-dashed",
  "circle-dot",
  "circle-dotted-letter-a",
  "circle-dotted-letter-b",
  "circle-dotted-letter-c",
  "circle-dotted-letter-d",
  "circle-dotted-letter-e",
  "circle-dotted-letter-f",
  "circle-dotted-letter-g",
  "circle-dotted-letter-h",
  "circle-dotted-letter-i",
  "circle-dotted-letter-j",
  "circle-dotted-letter-k",
  "circle-dotted-letter-l",
  "circle-dotted-letter-m",
  "circle-dotted-letter-n",
  "circle-dotted-letter-o",
  "circle-dotted-letter-p",
  "circle-dotted-letter-q",
  "circle-dotted-letter-r",
  "circle-dotted-letter-s",
  "circle-dotted-letter-t",
  "circle-dotted-letter-u",
  "circle-dotted-letter-v",
  "circle-dotted-letter-w",
  "circle-dotted-letter-x",
  "circle-dotted-letter-y",
  "circle-dotted-letter-z",
  "circle-dotted",
  "circle-half-2",
  "circle-half-vertical",
  "circle-half",
  "circle-key",
  "circle-letter-a",
  "circle-letter-b",
  "circle-letter-c",
  "circle-letter-d",
  "circle-letter-e",
  "circle-letter-f",
  "circle-letter-g",
  "circle-letter-h",
  "circle-letter-i",
  "circle-letter-j",
  "circle-letter-k",
  "circle-letter-l",
  "circle-letter-m",
  "circle-letter-n",
  "circle-letter-o",
  "circle-letter-p",
  "circle-letter-q",
  "circle-letter-r",
  "circle-letter-s",
  "circle-letter-t",
  "circle-letter-u",
  "circle-letter-v",
  "circle-letter-w",
  "circle-letter-x",
  "circle-letter-y",
  "circle-letter-z",
  "circle-minus-2",
  "circle-minus",
  "circle-number-0",
  "circle-number-1",
  "circle-number-2",
  "circle-number-3",
  "circle-number-4",
  "circle-number-5",
  "circle-number-6",
  "circle-number-7",
  "circle-number-8",
  "circle-number-9",
  "circle-off",
  "circle-percentage",
  "circle-plus-2",
  "circle-plus",
  "circle-rectangle-off",
  "circle-rectangle",
  "circle-square",
  "circle-triangle",
  "circle-x",
  "circle",
  "circles-relation",
  "circles",
  "circuit-ammeter",
  "circuit-battery",
  "circuit-bulb",
  "circuit-capacitor-polarized",
  "circuit-capacitor",
  "circuit-cell-plus",
  "circuit-cell",
  "circuit-changeover",
  "circuit-diode-zener",
  "circuit-diode",
  "circuit-ground-digital",
  "circuit-ground",
  "circuit-inductor",
  "circuit-motor",
  "circuit-pushbutton",
  "circuit-resistor",
  "circuit-switch-closed",
  "circuit-switch-open",
  "circuit-voltmeter",
  "clear-all",
  "clear-formatting",
  "click",
  "cliff-jumping",
  "clipboard-check",
  "clipboard-copy",
  "clipboard-data",
  "clipboard-heart",
  "clipboard-list",
  "clipboard-off",
  "clipboard-plus",
  "clipboard-search",
  "clipboard-smile",
  "clipboard-text",
  "clipboard-typography",
  "clipboard-x",
  "clipboard",
  "clock-12",
  "clock-2",
  "clock-24",
  "clock-bitcoin",
  "clock-bolt",
  "clock-cancel",
  "clock-check",
  "clock-code",
  "clock-cog",
  "clock-dollar",
  "clock-down",
  "clock-edit",
  "clock-exclamation",
  "clock-heart",
  "clock-hour-1",
  "clock-hour-10",
  "clock-hour-11",
  "clock-hour-12",
  "clock-hour-2",
  "clock-hour-3",
  "clock-hour-4",
  "clock-hour-5",
  "clock-hour-6",
  "clock-hour-7",
  "clock-hour-8",
  "clock-hour-9",
  "clock-minus",
  "clock-off",
  "clock-pause",
  "clock-pin",
  "clock-play",
  "clock-plus",
  "clock-question",
  "clock-record",
  "clock-search",
  "clock-share",
  "clock-shield",
  "clock-star",
  "clock-stop",
  "clock-up",
  "clock-x",
  "clock",
  "clothes-rack-off",
  "clothes-rack",
  "cloud-bitcoin",
  "cloud-bolt",
  "cloud-cancel",
  "cloud-check",
  "cloud-code",
  "cloud-cog",
  "cloud-computing",
  "cloud-data-connection",
  "cloud-dollar",
  "cloud-down",
  "cloud-download",
  "cloud-exclamation",
  "cloud-fog",
  "cloud-heart",
  "cloud-lock-open",
  "cloud-lock",
  "cloud-minus",
  "cloud-network",
  "cloud-off",
  "cloud-pause",
  "cloud-pin",
  "cloud-plus",
  "cloud-question",
  "cloud-rain",
  "cloud-search",
  "cloud-share",
  "cloud-snow",
  "cloud-star",
  "cloud-storm",
  "cloud-up",
  "cloud-upload",
  "cloud-x",
  "cloud",
  "clover-2",
  "clover",
  "clubs",
  "code-asterisk",
  "code-circle-2",
  "code-circle",
  "code-dots",
  "code-minus",
  "code-off",
  "code-plus",
  "code-variable-minus",
  "code-variable-plus",
  "code-variable",
  "code",
  "coffee-off",
  "coffee",
  "coffin",
  "coin-bitcoin",
  "coin-euro",
  "coin-monero",
  "coin-off",
  "coin-pound",
  "coin-rupee",
  "coin-taka",
  "coin-yen",
  "coin-yuan",
  "coin",
  "coins",
  "color-filter",
  "color-picker-off",
  "color-picker",
  "color-swatch-off",
  "color-swatch",
  "column-insert-left",
  "column-insert-right",
  "column-remove",
  "columns-1",
  "columns-2",
  "columns-3",
  "columns-off",
  "columns",
  "comet",
  "command-off",
  "command",
  "compass-off",
  "compass",
  "components-off",
  "components",
  "cone-2",
  "cone-off",
  "cone-plus",
  "cone",
  "confetti-off",
  "confetti",
  "confucius",
  "congruent-to",
  "container-off",
  "container",
  "contract",
  "contrast-2-off",
  "contrast-2",
  "contrast-off",
  "contrast",
  "cooker",
  "cookie-man",
  "cookie-off",
  "cookie",
  "copy-check",
  "copy-minus",
  "copy-off",
  "copy-plus",
  "copy-x",
  "copy",
  "copyleft-off",
  "copyleft",
  "copyright-off",
  "copyright",
  "corner-down-left-double",
  "corner-down-left",
  "corner-down-right-double",
  "corner-down-right",
  "corner-left-down-double",
  "corner-left-down",
  "corner-left-up-double",
  "corner-left-up",
  "corner-right-down-double",
  "corner-right-down",
  "corner-right-up-double",
  "corner-right-up",
  "corner-up-left-double",
  "corner-up-left",
  "corner-up-right-double",
  "corner-up-right",
  "cpu-2",
  "cpu-off",
  "cpu",
  "crane-off",
  "crane",
  "creative-commons-by",
  "creative-commons-nc",
  "creative-commons-nd",
  "creative-commons-off",
  "creative-commons-sa",
  "creative-commons-zero",
  "creative-commons",
  "credit-card-off",
  "credit-card-pay",
  "credit-card-refund",
  "credit-card",
  "cricket",
  "crop-1-1",
  "crop-16-9",
  "crop-3-2",
  "crop-5-4",
  "crop-7-5",
  "crop-landscape",
  "crop-portrait",
  "crop",
  "cross-off",
  "cross",
  "crosshair",
  "crown-off",
  "crown",
  "crutches-off",
  "crutches",
  "crystal-ball",
  "csv",
  "cube-3d-sphere-off",
  "cube-3d-sphere",
  "cube-off",
  "cube-plus",
  "cube-send",
  "cube-spark",
  "cube-unfolded",
  "cube",
  "cup-off",
  "cup",
  "curling",
  "curly-loop",
  "currency-afghani",
  "currency-bahraini",
  "currency-baht",
  "currency-bitcoin",
  "currency-cent",
  "currency-dinar",
  "currency-dirham",
  "currency-dogecoin",
  "currency-dollar-australian",
  "currency-dollar-brunei",
  "currency-dollar-canadian",
  "currency-dollar-guyanese",
  "currency-dollar-off",
  "currency-dollar-singapore",
  "currency-dollar-zimbabwean",
  "currency-dollar",
  "currency-dong",
  "currency-dram",
  "currency-ethereum",
  "currency-euro-off",
  "currency-euro",
  "currency-florin",
  "currency-forint",
  "currency-frank",
  "currency-guarani",
  "currency-hryvnia",
  "currency-iranian-rial",
  "currency-kip",
  "currency-krone-czech",
  "currency-krone-danish",
  "currency-krone-swedish",
  "currency-lari",
  "currency-leu",
  "currency-lira",
  "currency-litecoin",
  "currency-lyd",
  "currency-manat",
  "currency-monero",
  "currency-naira",
  "currency-nano",
  "currency-off",
  "currency-paanga",
  "currency-peso",
  "currency-pound-off",
  "currency-pound",
  "currency-quetzal",
  "currency-real",
  "currency-renminbi",
  "currency-ripple",
  "currency-riyal",
  "currency-rubel",
  "currency-rufiyaa",
  "currency-rupee-nepalese",
  "currency-rupee",
  "currency-shekel",
  "currency-solana",
  "currency-som",
  "currency-taka",
  "currency-tenge",
  "currency-tugrik",
  "currency-won",
  "currency-xrp",
  "currency-yen-off",
  "currency-yen",
  "currency-yuan",
  "currency-zloty",
  "currency",
  "current-location-off",
  "current-location",
  "cursor-off",
  "cursor-text",
  "cut",
  "cylinder-off",
  "cylinder-plus",
  "cylinder",
  "dashboard-off",
  "dashboard",
  "database-cog",
  "database-dollar",
  "database-edit",
  "database-exclamation",
  "database-export",
  "database-heart",
  "database-import",
  "database-leak",
  "database-minus",
  "database-off",
  "database-plus",
  "database-search",
  "database-share",
  "database-smile",
  "database-star",
  "database-x",
  "database",
  "decimal",
  "deer",
  "delta",
  "dental-broken",
  "dental-off",
  "dental",
  "deselect",
  "desk",
  "details-off",
  "details",
  "device-airpods-case",
  "device-airpods",
  "device-airtag",
  "device-analytics",
  "device-audio-tape",
  "device-camera-phone",
  "device-cctv-off",
  "device-cctv",
  "device-computer-camera-off",
  "device-computer-camera",
  "device-desktop-analytics",
  "device-desktop-bolt",
  "device-desktop-cancel",
  "device-desktop-check",
  "device-desktop-code",
  "device-desktop-cog",
  "device-desktop-dollar",
  "device-desktop-down",
  "device-desktop-exclamation",
  "device-desktop-heart",
  "device-desktop-minus",
  "device-desktop-off",
  "device-desktop-pause",
  "device-desktop-pin",
  "device-desktop-plus",
  "device-desktop-question",
  "device-desktop-search",
  "device-desktop-share",
  "device-desktop-star",
  "device-desktop-up",
  "device-desktop-x",
  "device-desktop",
  "device-floppy",
  "device-gamepad-2",
  "device-gamepad-3",
  "device-gamepad",
  "device-heart-monitor",
  "device-imac-bolt",
  "device-imac-cancel",
  "device-imac-check",
  "device-imac-code",
  "device-imac-cog",
  "device-imac-dollar",
  "device-imac-down",
  "device-imac-exclamation",
  "device-imac-heart",
  "device-imac-minus",
  "device-imac-off",
  "device-imac-pause",
  "device-imac-pin",
  "device-imac-plus",
  "device-imac-question",
  "device-imac-search",
  "device-imac-share",
  "device-imac-star",
  "device-imac-up",
  "device-imac-x",
  "device-imac",
  "device-ipad-bolt",
  "device-ipad-cancel",
  "device-ipad-check",
  "device-ipad-code",
  "device-ipad-cog",
  "device-ipad-dollar",
  "device-ipad-down",
  "device-ipad-exclamation",
  "device-ipad-heart",
  "device-ipad-horizontal-bolt",
  "device-ipad-horizontal-cancel",
  "device-ipad-horizontal-check",
  "device-ipad-horizontal-code",
  "device-ipad-horizontal-cog",
  "device-ipad-horizontal-dollar",
  "device-ipad-horizontal-down",
  "device-ipad-horizontal-exclamation",
  "device-ipad-horizontal-heart",
  "device-ipad-horizontal-minus",
  "device-ipad-horizontal-off",
  "device-ipad-horizontal-pause",
  "device-ipad-horizontal-pin",
  "device-ipad-horizontal-plus",
  "device-ipad-horizontal-question",
  "device-ipad-horizontal-search",
  "device-ipad-horizontal-share",
  "device-ipad-horizontal-star",
  "device-ipad-horizontal-up",
  "device-ipad-horizontal-x",
  "device-ipad-horizontal",
  "device-ipad-minus",
  "device-ipad-off",
  "device-ipad-pause",
  "device-ipad-pin",
  "device-ipad-plus",
  "device-ipad-question",
  "device-ipad-search",
  "device-ipad-share",
  "device-ipad-star",
  "device-ipad-up",
  "device-ipad-x",
  "device-ipad",
  "device-landline-phone",
  "device-laptop-off",
  "device-laptop",
  "device-mobile-bolt",
  "device-mobile-cancel",
  "device-mobile-charging",
  "device-mobile-check",
  "device-mobile-code",
  "device-mobile-cog",
  "device-mobile-dollar",
  "device-mobile-down",
  "device-mobile-exclamation",
  "device-mobile-heart",
  "device-mobile-message",
  "device-mobile-minus",
  "device-mobile-off",
  "device-mobile-pause",
  "device-mobile-pin",
  "device-mobile-plus",
  "device-mobile-question",
  "device-mobile-rotated",
  "device-mobile-search",
  "device-mobile-share",
  "device-mobile-star",
  "device-mobile-up",
  "device-mobile-vibration",
  "device-mobile-x",
  "device-mobile",
  "device-nintendo-off",
  "device-nintendo",
  "device-projector",
  "device-remote",
  "device-sd-card",
  "device-sim-1",
  "device-sim-2",
  "device-sim-3",
  "device-sim",
  "device-speaker-off",
  "device-speaker",
  "device-tablet-bolt",
  "device-tablet-cancel",
  "device-tablet-check",
  "device-tablet-code",
  "device-tablet-cog",
  "device-tablet-dollar",
  "device-tablet-down",
  "device-tablet-exclamation",
  "device-tablet-heart",
  "device-tablet-minus",
  "device-tablet-off",
  "device-tablet-pause",
  "device-tablet-pin",
  "device-tablet-plus",
  "device-tablet-question",
  "device-tablet-search",
  "device-tablet-share",
  "device-tablet-star",
  "device-tablet-up",
  "device-tablet-x",
  "device-tablet",
  "device-tv-off",
  "device-tv-old",
  "device-tv",
  "device-unknown",
  "device-usb",
  "device-vision-pro",
  "device-watch-bolt",
  "device-watch-cancel",
  "device-watch-check",
  "device-watch-code",
  "device-watch-cog",
  "device-watch-dollar",
  "device-watch-down",
  "device-watch-exclamation",
  "device-watch-heart",
  "device-watch-minus",
  "device-watch-off",
  "device-watch-pause",
  "device-watch-pin",
  "device-watch-plus",
  "device-watch-question",
  "device-watch-search",
  "device-watch-share",
  "device-watch-star",
  "device-watch-stats-2",
  "device-watch-stats",
  "device-watch-up",
  "device-watch-x",
  "device-watch",
  "devices-2",
  "devices-bolt",
  "devices-cancel",
  "devices-check",
  "devices-code",
  "devices-cog",
  "devices-dollar",
  "devices-down",
  "devices-exclamation",
  "devices-heart",
  "devices-minus",
  "devices-off",
  "devices-pause",
  "devices-pc-off",
  "devices-pc",
  "devices-pin",
  "devices-plus",
  "devices-question",
  "devices-search",
  "devices-share",
  "devices-star",
  "devices-up",
  "devices-x",
  "devices",
  "diabolo-off",
  "diabolo-plus",
  "diabolo",
  "dialpad-off",
  "dialpad",
  "diamond-off",
  "diamond",
  "diamonds",
  "diaper",
  "dice-1",
  "dice-2",
  "dice-3",
  "dice-4",
  "dice-5",
  "dice-6",
  "dice",
  "dimensions",
  "direction-arrows",
  "direction-horizontal",
  "direction-sign-off",
  "direction-sign",
  "direction",
  "directions-off",
  "directions",
  "disabled-2",
  "disabled-off",
  "disabled",
  "disc-golf",
  "disc-off",
  "disc",
  "discount-off",
  "discount",
  "divide",
  "dna-2-off",
  "dna-2",
  "dna-off",
  "dna",
  "dog-bowl",
  "dog",
  "door-enter",
  "door-exit",
  "door-off",
  "door",
  "dots-circle-horizontal",
  "dots-diagonal-2",
  "dots-diagonal",
  "dots-vertical",
  "dots",
  "download-off",
  "download",
  "drag-drop-2",
  "drag-drop",
  "drone-off",
  "drone",
  "drop-circle",
  "droplet-bolt",
  "droplet-cancel",
  "droplet-check",
  "droplet-code",
  "droplet-cog",
  "droplet-dollar",
  "droplet-down",
  "droplet-exclamation",
  "droplet-half-2",
  "droplet-half",
  "droplet-heart",
  "droplet-minus",
  "droplet-off",
  "droplet-pause",
  "droplet-pin",
  "droplet-plus",
  "droplet-question",
  "droplet-search",
  "droplet-share",
  "droplet-star",
  "droplet-up",
  "droplet-x",
  "droplet",
  "droplets",
  "dual-screen",
  "dumpling",
  "e-passport",
  "ear-off",
  "ear-scan",
  "ear",
  "ease-in-control-point",
  "ease-in-out-control-points",
  "ease-in-out",
  "ease-in",
  "ease-out-control-point",
  "ease-out",
  "edit-circle-off",
  "edit-circle",
  "edit-off",
  "edit",
  "egg-cracked",
  "egg-fried",
  "egg-off",
  "egg",
  "eggs",
  "elevator-off",
  "elevator",
  "emergency-bed",
  "empathize-off",
  "empathize",
  "emphasis",
  "engine-off",
  "engine",
  "equal-double",
  "equal-not",
  "equal",
  "eraser-off",
  "eraser",
  "error-404-off",
  "error-404",
  "escalator-down",
  "escalator-up",
  "escalator",
  "exchange-off",
  "exchange",
  "exclamation-circle",
  "exclamation-mark-off",
  "exclamation-mark",
  "explicit-off",
  "explicit",
  "exposure-0",
  "exposure-minus-1",
  "exposure-minus-2",
  "exposure-off",
  "exposure-plus-1",
  "exposure-plus-2",
  "exposure",
  "external-link-off",
  "external-link",
  "eye-bitcoin",
  "eye-bolt",
  "eye-cancel",
  "eye-check",
  "eye-closed",
  "eye-code",
  "eye-cog",
  "eye-discount",
  "eye-dollar",
  "eye-dotted",
  "eye-down",
  "eye-edit",
  "eye-exclamation",
  "eye-heart",
  "eye-minus",
  "eye-off",
  "eye-pause",
  "eye-pin",
  "eye-plus",
  "eye-question",
  "eye-search",
  "eye-share",
  "eye-spark",
  "eye-star",
  "eye-table",
  "eye-up",
  "eye-x",
  "eye",
  "eyeglass-2",
  "eyeglass-off",
  "eyeglass",
  "face-id-error",
  "face-id",
  "face-mask-off",
  "face-mask",
  "fall",
  "favicon",
  "feather-off",
  "feather",
  "fence-off",
  "fence",
  "ferry",
  "fidget-spinner",
  "file-3d",
  "file-ai",
  "file-alert",
  "file-analytics",
  "file-arrow-left",
  "file-arrow-right",
  "file-barcode",
  "file-bitcoin",
  "file-broken",
  "file-certificate",
  "file-chart",
  "file-check",
  "file-code-2",
  "file-code",
  "file-cv",
  "file-database",
  "file-delta",
  "file-description",
  "file-diff",
  "file-digit",
  "file-dislike",
  "file-dollar",
  "file-dots",
  "file-download",
  "file-euro",
  "file-excel",
  "file-export",
  "file-function",
  "file-horizontal",
  "file-import",
  "file-infinity",
  "file-info",
  "file-invoice",
  "file-isr",
  "file-lambda",
  "file-like",
  "file-minus",
  "file-music",
  "file-neutral",
  "file-off",
  "file-orientation",
  "file-pencil",
  "file-percent",
  "file-phone",
  "file-plus",
  "file-power",
  "file-report",
  "file-rss",
  "file-sad",
  "file-scissors",
  "file-search",
  "file-settings",
  "file-shredder",
  "file-signal",
  "file-smile",
  "file-spark",
  "file-spreadsheet",
  "file-stack",
  "file-star",
  "file-symlink",
  "file-text-ai",
  "file-text-shield",
  "file-text-spark",
  "file-text",
  "file-time",
  "file-type-bmp",
  "file-type-css",
  "file-type-csv",
  "file-type-doc",
  "file-type-docx",
  "file-type-html",
  "file-type-jpg",
  "file-type-js",
  "file-type-jsx",
  "file-type-pdf",
  "file-type-php",
  "file-type-png",
  "file-type-ppt",
  "file-type-rs",
  "file-type-sql",
  "file-type-svg",
  "file-type-ts",
  "file-type-tsx",
  "file-type-txt",
  "file-type-vue",
  "file-type-xls",
  "file-type-xml",
  "file-type-zip",
  "file-typography",
  "file-unknown",
  "file-upload",
  "file-vector",
  "file-word",
  "file-x",
  "file-zip",
  "file",
  "files-off",
  "files",
  "filter-bolt",
  "filter-cancel",
  "filter-check",
  "filter-code",
  "filter-cog",
  "filter-discount",
  "filter-dollar",
  "filter-down",
  "filter-edit",
  "filter-exclamation",
  "filter-heart",
  "filter-minus",
  "filter-off",
  "filter-pause",
  "filter-pin",
  "filter-plus",
  "filter-question",
  "filter-search",
  "filter-share",
  "filter-star",
  "filter-up",
  "filter-x",
  "filter",
  "filters",
  "fingerprint-off",
  "fingerprint-scan",
  "fingerprint",
  "fire-extinguisher",
  "fire-hydrant-off",
  "fire-hydrant",
  "firetruck",
  "first-aid-kit-off",
  "first-aid-kit",
  "fish-bone",
  "fish-christianity",
  "fish-hook-off",
  "fish-hook",
  "fish-off",
  "fish",
  "flag-2-off",
  "flag-2",
  "flag-3",
  "flag-bitcoin",
  "flag-bolt",
  "flag-cancel",
  "flag-check",
  "flag-code",
  "flag-cog",
  "flag-discount",
  "flag-dollar",
  "flag-down",
  "flag-exclamation",
  "flag-heart",
  "flag-minus",
  "flag-off",
  "flag-pause",
  "flag-pin",
  "flag-plus",
  "flag-question",
  "flag-search",
  "flag-share",
  "flag-spark",
  "flag-star",
  "flag-up",
  "flag-x",
  "flag",
  "flame-off",
  "flame",
  "flare",
  "flask-2-off",
  "flask-2",
  "flask-off",
  "flask",
  "flip-flops",
  "flip-horizontal",
  "flip-vertical",
  "float-center",
  "float-left",
  "float-none",
  "float-right",
  "flower-off",
  "flower",
  "focus-2",
  "focus-auto",
  "focus-centered",
  "focus",
  "fold-down",
  "fold-up",
  "fold",
  "folder-bolt",
  "folder-cancel",
  "folder-check",
  "folder-code",
  "folder-cog",
  "folder-dollar",
  "folder-down",
  "folder-exclamation",
  "folder-heart",
  "folder-minus",
  "folder-off",
  "folder-open",
  "folder-pause",
  "folder-pin",
  "folder-plus",
  "folder-question",
  "folder-root",
  "folder-search",
  "folder-share",
  "folder-star",
  "folder-symlink",
  "folder-up",
  "folder-x",
  "folder",
  "folders-off",
  "folders",
  "forbid-2",
  "forbid",
  "forklift",
  "forms",
  "fountain-off",
  "fountain",
  "frame-off",
  "frame",
  "free-rights",
  "freeze-column",
  "freeze-row-column",
  "freeze-row",
  "fridge-off",
  "fridge",
  "friends-off",
  "friends",
  "frustum-off",
  "frustum-plus",
  "frustum",
  "function-off",
  "function",
  "galaxy",
  "garden-cart-off",
  "garden-cart",
  "gas-station-off",
  "gas-station",
  "gauge-off",
  "gauge",
  "gavel",
  "gender-agender",
  "gender-androgyne",
  "gender-bigender",
  "gender-demiboy",
  "gender-demigirl",
  "gender-epicene",
  "gender-female",
  "gender-femme",
  "gender-genderfluid",
  "gender-genderless",
  "gender-genderqueer",
  "gender-hermaphrodite",
  "gender-intergender",
  "gender-male",
  "gender-neutrois",
  "gender-third",
  "gender-transgender",
  "gender-trasvesti",
  "geometry",
  "ghost-2",
  "ghost-3",
  "ghost-off",
  "ghost",
  "gif",
  "gift-card",
  "gift-off",
  "gift",
  "git-branch-deleted",
  "git-branch",
  "git-cherry-pick",
  "git-commit",
  "git-compare",
  "git-fork",
  "git-merge",
  "git-pull-request-closed",
  "git-pull-request-draft",
  "git-pull-request",
  "gizmo",
  "glass-champagne",
  "glass-cocktail",
  "glass-full",
  "glass-gin",
  "glass-off",
  "glass",
  "globe-off",
  "globe",
  "go-game",
  "golf-off",
  "golf",
  "gps",
  "gradienter",
  "grain",
  "graph-off",
  "graph",
  "grave-2",
  "grave",
  "grid-3x3",
  "grid-4x4",
  "grid-dots",
  "grid-goldenratio",
  "grid-pattern",
  "grid-scan",
  "grill-fork",
  "grill-off",
  "grill-spatula",
  "grill",
  "grip-horizontal",
  "grip-vertical",
  "growth",
  "guitar-pick",
  "gymnastics",
  "h-1",
  "h-2",
  "h-3",
  "h-4",
  "h-5",
  "h-6",
  "hammer-off",
  "hammer",
  "hand-click-off",
  "hand-click",
  "hand-finger-down",
  "hand-finger-left",
  "hand-finger-off",
  "hand-finger-right",
  "hand-finger",
  "hand-grab",
  "hand-little-finger",
  "hand-love-you",
  "hand-middle-finger",
  "hand-move",
  "hand-off",
  "hand-ring-finger",
  "hand-sanitizer",
  "hand-stop",
  "hand-three-fingers",
  "hand-two-fingers",
  "hanger-2",
  "hanger-off",
  "hanger",
  "hash",
  "haze-moon",
  "haze",
  "hdr",
  "heading-off",
  "heading",
  "headphones-off",
  "headphones",
  "headset-off",
  "headset",
  "health-recognition",
  "heart-bitcoin",
  "heart-bolt",
  "heart-broken",
  "heart-cancel",
  "heart-check",
  "heart-code",
  "heart-cog",
  "heart-discount",
  "heart-dollar",
  "heart-down",
  "heart-exclamation",
  "heart-handshake",
  "heart-minus",
  "heart-off",
  "heart-pause",
  "heart-pin",
  "heart-plus",
  "heart-question",
  "heart-rate-monitor",
  "heart-search",
  "heart-share",
  "heart-spark",
  "heart-star",
  "heart-up",
  "heart-x",
  "heart",
  "heartbeat",
  "hearts-off",
  "hearts",
  "helicopter-landing",
  "helicopter",
  "helmet-off",
  "helmet",
  "help-circle",
  "help-hexagon",
  "help-octagon",
  "help-off",
  "help-small",
  "help-square-rounded",
  "help-square",
  "help-triangle",
  "help",
  "hemisphere-off",
  "hemisphere-plus",
  "hemisphere",
  "hexagon-3d",
  "hexagon-letter-a",
  "hexagon-letter-b",
  "hexagon-letter-c",
  "hexagon-letter-d",
  "hexagon-letter-e",
  "hexagon-letter-f",
  "hexagon-letter-g",
  "hexagon-letter-h",
  "hexagon-letter-i",
  "hexagon-letter-j",
  "hexagon-letter-k",
  "hexagon-letter-l",
  "hexagon-letter-m",
  "hexagon-letter-n",
  "hexagon-letter-o",
  "hexagon-letter-p",
  "hexagon-letter-q",
  "hexagon-letter-r",
  "hexagon-letter-s",
  "hexagon-letter-t",
  "hexagon-letter-u",
  "hexagon-letter-v",
  "hexagon-letter-w",
  "hexagon-letter-x",
  "hexagon-letter-y",
  "hexagon-letter-z",
  "hexagon-minus-2",
  "hexagon-minus",
  "hexagon-number-0",
  "hexagon-number-1",
  "hexagon-number-2",
  "hexagon-number-3",
  "hexagon-number-4",
  "hexagon-number-5",
  "hexagon-number-6",
  "hexagon-number-7",
  "hexagon-number-8",
  "hexagon-number-9",
  "hexagon-off",
  "hexagon-plus-2",
  "hexagon-plus",
  "hexagon",
  "hexagonal-prism-off",
  "hexagonal-prism-plus",
  "hexagonal-prism",
  "hexagonal-pyramid-off",
  "hexagonal-pyramid-plus",
  "hexagonal-pyramid",
  "hexagons-off",
  "hexagons",
  "hierarchy-2",
  "hierarchy-3",
  "hierarchy-off",
  "hierarchy",
  "highlight-off",
  "highlight",
  "history-off",
  "history-toggle",
  "history",
  "home-2",
  "home-bitcoin",
  "home-bolt",
  "home-cancel",
  "home-check",
  "home-cog",
  "home-dollar",
  "home-dot",
  "home-down",
  "home-eco",
  "home-edit",
  "home-exclamation",
  "home-hand",
  "home-heart",
  "home-infinity",
  "home-link",
  "home-minus",
  "home-move",
  "home-off",
  "home-plus",
  "home-question",
  "home-ribbon",
  "home-search",
  "home-share",
  "home-shield",
  "home-signal",
  "home-spark",
  "home-star",
  "home-stats",
  "home-up",
  "home-x",
  "home",
  "horse-toy",
  "horse",
  "horseshoe",
  "hospital-circle",
  "hospital",
  "hotel-service",
  "hourglass-empty",
  "hourglass-high",
  "hourglass-low",
  "hourglass-off",
  "hourglass",
  "hours-12",
  "hours-24",
  "html",
  "http-connect-off",
  "http-connect",
  "http-delete-off",
  "http-delete",
  "http-get-off",
  "http-get",
  "http-head-off",
  "http-head",
  "http-options-off",
  "http-options",
  "http-patch-off",
  "http-patch",
  "http-post-off",
  "http-post",
  "http-put-off",
  "http-put",
  "http-que-off",
  "http-que",
  "http-trace-off",
  "http-trace",
  "ice-cream-2",
  "ice-cream-off",
  "ice-cream",
  "ice-skating",
  "icons-off",
  "icons",
  "id-badge-2",
  "id-badge-off",
  "id-badge",
  "id-off",
  "id",
  "ikosaedr",
  "image-in-picture",
  "inbox-off",
  "inbox",
  "indent-decrease",
  "indent-increase",
  "infinity-off",
  "infinity",
  "info-circle",
  "info-hexagon",
  "info-octagon",
  "info-small",
  "info-square-rounded",
  "info-square",
  "info-triangle",
  "inner-shadow-bottom-left",
  "inner-shadow-bottom-right",
  "inner-shadow-bottom",
  "inner-shadow-left",
  "inner-shadow-right",
  "inner-shadow-top-left",
  "inner-shadow-top-right",
  "inner-shadow-top",
  "input-ai",
  "input-check",
  "input-search",
  "input-spark",
  "input-x",
  "invoice",
  "ironing-1",
  "ironing-2",
  "ironing-3",
  "ironing-off",
  "ironing-steam-off",
  "ironing-steam",
  "ironing",
  "irregular-polyhedron-off",
  "irregular-polyhedron-plus",
  "irregular-polyhedron",
  "italic",
  "jacket",
  "jetpack",
  "jewish-star",
  "join-bevel",
  "join-round",
  "join-straight",
  "joker",
  "jpg",
  "json",
  "jump-rope",
  "karate",
  "kayak",
  "kerning",
  "key-off",
  "key",
  "keyboard-hide",
  "keyboard-off",
  "keyboard-show",
  "keyboard",
  "keyframe-align-center",
  "keyframe-align-horizontal",
  "keyframe-align-vertical",
  "keyframe",
  "keyframes",
  "label-important",
  "label-off",
  "label",
  "ladder-off",
  "ladder",
  "ladle",
  "lambda",
  "lamp-2",
  "lamp-off",
  "lamp",
  "lane",
  "language-hiragana",
  "language-katakana",
  "language-off",
  "language",
  "lasso-off",
  "lasso-polygon",
  "lasso",
  "laurel-wreath-1",
  "laurel-wreath-2",
  "laurel-wreath-3",
  "laurel-wreath",
  "layers-difference",
  "layers-intersect-2",
  "layers-intersect",
  "layers-linked",
  "layers-off",
  "layers-selected-bottom",
  "layers-selected",
  "layers-subtract",
  "layers-union",
  "layout-2",
  "layout-align-bottom",
  "layout-align-center",
  "layout-align-left",
  "layout-align-middle",
  "layout-align-right",
  "layout-align-top",
  "layout-board-split",
  "layout-board",
  "layout-bottombar-collapse",
  "layout-bottombar-expand",
  "layout-bottombar-inactive",
  "layout-bottombar",
  "layout-cards",
  "layout-collage",
  "layout-columns",
  "layout-dashboard",
  "layout-distribute-horizontal",
  "layout-distribute-vertical",
  "layout-grid-add",
  "layout-grid-remove",
  "layout-grid",
  "layout-kanban",
  "layout-list",
  "layout-navbar-collapse",
  "layout-navbar-expand",
  "layout-navbar-inactive",
  "layout-navbar",
  "layout-off",
  "layout-rows",
  "layout-sidebar-inactive",
  "layout-sidebar-left-collapse",
  "layout-sidebar-left-expand",
  "layout-sidebar-right-collapse",
  "layout-sidebar-right-expand",
  "layout-sidebar-right-inactive",
  "layout-sidebar-right",
  "layout-sidebar",
  "layout",
  "leaf-2",
  "leaf-off",
  "leaf",
  "lego-off",
  "lego",
  "lemon-2",
  "lemon",
  "letter-a-small",
  "letter-a",
  "letter-b-small",
  "letter-b",
  "letter-c-small",
  "letter-c",
  "letter-case-lower",
  "letter-case-toggle",
  "letter-case-upper",
  "letter-case",
  "letter-d-small",
  "letter-d",
  "letter-e-small",
  "letter-e",
  "letter-f-small",
  "letter-f",
  "letter-g-small",
  "letter-g",
  "letter-h-small",
  "letter-h",
  "letter-i-small",
  "letter-i",
  "letter-j-small",
  "letter-j",
  "letter-k-small",
  "letter-k",
  "letter-l-small",
  "letter-l",
  "letter-m-small",
  "letter-m",
  "letter-n-small",
  "letter-n",
  "letter-o-small",
  "letter-o",
  "letter-p-small",
  "letter-p",
  "letter-q-small",
  "letter-q",
  "letter-r-small",
  "letter-r",
  "letter-s-small",
  "letter-s",
  "letter-spacing",
  "letter-t-small",
  "letter-t",
  "letter-u-small",
  "letter-u",
  "letter-v-small",
  "letter-v",
  "letter-w-small",
  "letter-w",
  "letter-x-small",
  "letter-x",
  "letter-y-small",
  "letter-y",
  "letter-z-small",
  "letter-z",
  "library-minus",
  "library-photo",
  "library-plus",
  "library",
  "license-off",
  "license",
  "lifebuoy-off",
  "lifebuoy",
  "lighter",
  "line-dashed",
  "line-dotted",
  "line-height",
  "line-scan",
  "line",
  "link-minus",
  "link-off",
  "link-plus",
  "link",
  "list-check",
  "list-details",
  "list-letters",
  "list-numbers",
  "list-search",
  "list-tree",
  "list",
  "live-photo-off",
  "live-photo",
  "live-view",
  "load-balancer",
  "loader-2",
  "loader-3",
  "loader-quarter",
  "loader",
  "location-bolt",
  "location-broken",
  "location-cancel",
  "location-check",
  "location-code",
  "location-cog",
  "location-discount",
  "location-dollar",
  "location-down",
  "location-exclamation",
  "location-heart",
  "location-minus",
  "location-off",
  "location-pause",
  "location-pin",
  "location-plus",
  "location-question",
  "location-search",
  "location-share",
  "location-star",
  "location-up",
  "location-x",
  "location",
  "lock-access-off",
  "lock-access",
  "lock-bitcoin",
  "lock-bolt",
  "lock-cancel",
  "lock-check",
  "lock-code",
  "lock-cog",
  "lock-dollar",
  "lock-down",
  "lock-exclamation",
  "lock-heart",
  "lock-minus",
  "lock-off",
  "lock-open-2",
  "lock-open-off",
  "lock-open",
  "lock-password",
  "lock-pause",
  "lock-pin",
  "lock-plus",
  "lock-question",
  "lock-search",
  "lock-share",
  "lock-square-rounded",
  "lock-square",
  "lock-star",
  "lock-up",
  "lock-x",
  "lock",
  "logic-and",
  "logic-buffer",
  "logic-nand",
  "logic-nor",
  "logic-not",
  "logic-or",
  "logic-xnor",
  "logic-xor",
  "login-2",
  "login",
  "logout-2",
  "logout",
  "logs",
  "lollipop-off",
  "lollipop",
  "luggage-off",
  "luggage",
  "lungs-off",
  "lungs",
  "macro-off",
  "macro",
  "magnet-off",
  "magnet",
  "magnetic",
  "mail-ai",
  "mail-bitcoin",
  "mail-bolt",
  "mail-cancel",
  "mail-check",
  "mail-code",
  "mail-cog",
  "mail-dollar",
  "mail-down",
  "mail-exclamation",
  "mail-fast",
  "mail-forward",
  "mail-heart",
  "mail-minus",
  "mail-off",
  "mail-opened",
  "mail-pause",
  "mail-pin",
  "mail-plus",
  "mail-question",
  "mail-search",
  "mail-share",
  "mail-spark",
  "mail-star",
  "mail-up",
  "mail-x",
  "mail",
  "mailbox-off",
  "mailbox",
  "man",
  "manual-gearbox",
  "map-2",
  "map-bolt",
  "map-cancel",
  "map-check",
  "map-code",
  "map-cog",
  "map-discount",
  "map-dollar",
  "map-down",
  "map-east",
  "map-exclamation",
  "map-heart",
  "map-minus",
  "map-north",
  "map-off",
  "map-pause",
  "map-pin-2",
  "map-pin-bolt",
  "map-pin-cancel",
  "map-pin-check",
  "map-pin-code",
  "map-pin-cog",
  "map-pin-dollar",
  "map-pin-down",
  "map-pin-exclamation",
  "map-pin-heart",
  "map-pin-minus",
  "map-pin-off",
  "map-pin-pause",
  "map-pin-pin",
  "map-pin-plus",
  "map-pin-question",
  "map-pin-search",
  "map-pin-share",
  "map-pin-star",
  "map-pin-up",
  "map-pin-x",
  "map-pin",
  "map-pins",
  "map-plus",
  "map-question",
  "map-route",
  "map-search",
  "map-share",
  "map-south",
  "map-star",
  "map-up",
  "map-west",
  "map-x",
  "map",
  "markdown-off",
  "markdown",
  "marquee-2",
  "marquee-off",
  "marquee",
  "mars",
  "mask-off",
  "mask",
  "masks-theater-off",
  "masks-theater",
  "massage",
  "matchstick",
  "math-1-divide-2",
  "math-1-divide-3",
  "math-avg",
  "math-cos",
  "math-ctg",
  "math-equal-greater",
  "math-equal-lower",
  "math-function-off",
  "math-function-y",
  "math-function",
  "math-greater",
  "math-integral-x",
  "math-integral",
  "math-integrals",
  "math-lower",
  "math-max-min",
  "math-max",
  "math-min",
  "math-not",
  "math-off",
  "math-pi-divide-2",
  "math-pi",
  "math-sec",
  "math-sin",
  "math-symbols",
  "math-tg",
  "math-x-divide-2",
  "math-x-divide-y-2",
  "math-x-divide-y",
  "math-x-floor-divide-y",
  "math-x-minus-x",
  "math-x-minus-y",
  "math-x-plus-x",
  "math-x-plus-y",
  "math-xy",
  "math-y-minus-y",
  "math-y-plus-y",
  "math",
  "matrix",
  "maximize-off",
  "maximize",
  "meat-off",
  "meat",
  "medal-2",
  "medal",
  "medical-cross-circle",
  "medical-cross-off",
  "medical-cross",
  "medicine-syrup",
  "meeple",
  "melon",
  "menorah",
  "menu-2",
  "menu-3",
  "menu-4",
  "menu-deep",
  "menu-order",
  "menu",
  "message-2-bolt",
  "message-2-cancel",
  "message-2-check",
  "message-2-code",
  "message-2-cog",
  "message-2-dollar",
  "message-2-down",
  "message-2-exclamation",
  "message-2-heart",
  "message-2-minus",
  "message-2-off",
  "message-2-pause",
  "message-2-pin",
  "message-2-plus",
  "message-2-question",
  "message-2-search",
  "message-2-share",
  "message-2-star",
  "message-2-up",
  "message-2-x",
  "message-2",
  "message-bolt",
  "message-cancel",
  "message-chatbot",
  "message-check",
  "message-circle-bolt",
  "message-circle-cancel",
  "message-circle-check",
  "message-circle-code",
  "message-circle-cog",
  "message-circle-dollar",
  "message-circle-down",
  "message-circle-exclamation",
  "message-circle-heart",
  "message-circle-minus",
  "message-circle-off",
  "message-circle-pause",
  "message-circle-pin",
  "message-circle-plus",
  "message-circle-question",
  "message-circle-search",
  "message-circle-share",
  "message-circle-star",
  "message-circle-up",
  "message-circle-user",
  "message-circle-x",
  "message-circle",
  "message-code",
  "message-cog",
  "message-dollar",
  "message-dots",
  "message-down",
  "message-exclamation",
  "message-forward",
  "message-heart",
  "message-language",
  "message-minus",
  "message-off",
  "message-pause",
  "message-pin",
  "message-plus",
  "message-question",
  "message-reply",
  "message-report",
  "message-search",
  "message-share",
  "message-star",
  "message-up",
  "message-user",
  "message-x",
  "message",
  "messages-off",
  "messages",
  "meteor-off",
  "meteor",
  "meter-cube",
  "meter-square",
  "metronome",
  "michelin-bib-gourmand",
  "michelin-star-green",
  "michelin-star",
  "mickey",
  "microphone-2-off",
  "microphone-2",
  "microphone-off",
  "microphone",
  "microscope-off",
  "microscope",
  "microwave-off",
  "microwave",
  "military-award",
  "military-rank",
  "milk-off",
  "milk",
  "milkshake",
  "minimize",
  "minus-vertical",
  "minus",
  "mist-off",
  "mist",
  "mobiledata-off",
  "mobiledata",
  "moneybag-edit",
  "moneybag-heart",
  "moneybag-minus",
  "moneybag-move-back",
  "moneybag-move",
  "moneybag-plus",
  "moneybag",
  "monkeybar",
  "mood-angry",
  "mood-annoyed-2",
  "mood-annoyed",
  "mood-bitcoin",
  "mood-boy",
  "mood-check",
  "mood-cog",
  "mood-confuzed",
  "mood-crazy-happy",
  "mood-cry",
  "mood-dollar",
  "mood-edit",
  "mood-empty",
  "mood-happy",
  "mood-heart",
  "mood-kid",
  "mood-look-down",
  "mood-look-left",
  "mood-look-right",
  "mood-look-up",
  "mood-minus",
  "mood-nerd",
  "mood-nervous",
  "mood-neutral",
  "mood-off",
  "mood-pin",
  "mood-plus",
  "mood-puzzled",
  "mood-sad-2",
  "mood-sad-dizzy",
  "mood-sad-squint",
  "mood-sad",
  "mood-search",
  "mood-share",
  "mood-sick",
  "mood-silence",
  "mood-sing",
  "mood-smile-beam",
  "mood-smile-dizzy",
  "mood-smile",
  "mood-spark",
  "mood-surprised",
  "mood-tongue-wink-2",
  "mood-tongue-wink",
  "mood-tongue",
  "mood-unamused",
  "mood-up",
  "mood-wink-2",
  "mood-wink",
  "mood-wrrr",
  "mood-x",
  "mood-xd",
  "moon-2",
  "moon-off",
  "moon-stars",
  "moon",
  "moped",
  "motorbike",
  "mountain-off",
  "mountain",
  "mouse-2",
  "mouse-off",
  "mouse",
  "moustache",
  "movie-off",
  "movie",
  "mug-off",
  "mug",
  "multiplier-0-5x",
  "multiplier-1-5x",
  "multiplier-1x",
  "multiplier-2x",
  "mushroom-off",
  "mushroom",
  "music-bolt",
  "music-cancel",
  "music-check",
  "music-code",
  "music-cog",
  "music-discount",
  "music-dollar",
  "music-down",
  "music-exclamation",
  "music-heart",
  "music-minus",
  "music-off",
  "music-pause",
  "music-pin",
  "music-plus",
  "music-question",
  "music-search",
  "music-share",
  "music-star",
  "music-up",
  "music-x",
  "music",
  "navigation-bolt",
  "navigation-cancel",
  "navigation-check",
  "navigation-code",
  "navigation-cog",
  "navigation-discount",
  "navigation-dollar",
  "navigation-down",
  "navigation-east",
  "navigation-exclamation",
  "navigation-heart",
  "navigation-minus",
  "navigation-north",
  "navigation-off",
  "navigation-pause",
  "navigation-pin",
  "navigation-plus",
  "navigation-question",
  "navigation-search",
  "navigation-share",
  "navigation-south",
  "navigation-star",
  "navigation-top",
  "navigation-up",
  "navigation-west",
  "navigation-x",
  "navigation",
  "needle-thread",
  "needle",
  "network-off",
  "network",
  "new-section",
  "news-off",
  "news",
  "nfc-off",
  "nfc",
  "no-copyright",
  "no-creative-commons",
  "no-derivatives",
  "north-star",
  "note-off",
  "note",
  "notebook-off",
  "notebook",
  "notes-off",
  "notes",
  "notification-off",
  "notification",
  "number-0-small",
  "number-0",
  "number-1-small",
  "number-1",
  "number-10-small",
  "number-10",
  "number-100-small",
  "number-11-small",
  "number-11",
  "number-12-small",
  "number-123",
  "number-13-small",
  "number-14-small",
  "number-15-small",
  "number-16-small",
  "number-17-small",
  "number-18-small",
  "number-19-small",
  "number-2-small",
  "number-2",
  "number-20-small",
  "number-21-small",
  "number-22-small",
  "number-23-small",
  "number-24-small",
  "number-25-small",
  "number-26-small",
  "number-27-small",
  "number-28-small",
  "number-29-small",
  "number-3-small",
  "number-3",
  "number-30-small",
  "number-31-small",
  "number-32-small",
  "number-33-small",
  "number-34-small",
  "number-35-small",
  "number-36-small",
  "number-37-small",
  "number-38-small",
  "number-39-small",
  "number-4-small",
  "number-4",
  "number-40-small",
  "number-41-small",
  "number-42-small",
  "number-43-small",
  "number-44-small",
  "number-45-small",
  "number-46-small",
  "number-47-small",
  "number-48-small",
  "number-49-small",
  "number-5-small",
  "number-5",
  "number-50-small",
  "number-51-small",
  "number-52-small",
  "number-53-small",
  "number-54-small",
  "number-55-small",
  "number-56-small",
  "number-57-small",
  "number-58-small",
  "number-59-small",
  "number-6-small",
  "number-6",
  "number-60-small",
  "number-61-small",
  "number-62-small",
  "number-63-small",
  "number-64-small",
  "number-65-small",
  "number-66-small",
  "number-67-small",
  "number-68-small",
  "number-69-small",
  "number-7-small",
  "number-7",
  "number-70-small",
  "number-71-small",
  "number-72-small",
  "number-73-small",
  "number-74-small",
  "number-75-small",
  "number-76-small",
  "number-77-small",
  "number-78-small",
  "number-79-small",
  "number-8-small",
  "number-8",
  "number-80-small",
  "number-81-small",
  "number-82-small",
  "number-83-small",
  "number-84-small",
  "number-85-small",
  "number-86-small",
  "number-87-small",
  "number-88-small",
  "number-89-small",
  "number-9-small",
  "number-9",
  "number-90-small",
  "number-91-small",
  "number-92-small",
  "number-93-small",
  "number-94-small",
  "number-95-small",
  "number-96-small",
  "number-97-small",
  "number-98-small",
  "number-99-small",
  "number",
  "numbers",
  "nurse",
  "nut",
  "object-scan",
  "octagon-minus-2",
  "octagon-minus",
  "octagon-off",
  "octagon-plus-2",
  "octagon-plus",
  "octagon",
  "octahedron-off",
  "octahedron-plus",
  "octahedron",
  "old",
  "olympics-off",
  "olympics",
  "om",
  "omega",
  "outbound",
  "outlet",
  "oval-vertical",
  "oval",
  "overline",
  "package-export",
  "package-import",
  "package-off",
  "package",
  "packages",
  "pacman",
  "page-break",
  "paint-off",
  "paint",
  "palette-off",
  "palette",
  "panorama-horizontal-off",
  "panorama-horizontal",
  "panorama-vertical-off",
  "panorama-vertical",
  "paper-bag-off",
  "paper-bag",
  "paperclip",
  "parachute-off",
  "parachute",
  "parentheses-off",
  "parentheses",
  "parking-circle",
  "parking-off",
  "parking",
  "password-fingerprint",
  "password-mobile-phone",
  "password-user",
  "password",
  "paw-off",
  "paw",
  "paywall",
  "pdf",
  "peace",
  "pencil-bolt",
  "pencil-cancel",
  "pencil-check",
  "pencil-code",
  "pencil-cog",
  "pencil-discount",
  "pencil-dollar",
  "pencil-down",
  "pencil-exclamation",
  "pencil-heart",
  "pencil-minus",
  "pencil-off",
  "pencil-pause",
  "pencil-pin",
  "pencil-plus",
  "pencil-question",
  "pencil-search",
  "pencil-share",
  "pencil-star",
  "pencil-up",
  "pencil-x",
  "pencil",
  "pennant-2",
  "pennant-off",
  "pennant",
  "pentagon-minus",
  "pentagon-number-0",
  "pentagon-number-1",
  "pentagon-number-2",
  "pentagon-number-3",
  "pentagon-number-4",
  "pentagon-number-5",
  "pentagon-number-6",
  "pentagon-number-7",
  "pentagon-number-8",
  "pentagon-number-9",
  "pentagon-off",
  "pentagon-plus",
  "pentagon-x",
  "pentagon",
  "pentagram",
  "pepper-off",
  "pepper",
  "percentage-0",
  "percentage-10",
  "percentage-100",
  "percentage-20",
  "percentage-25",
  "percentage-30",
  "percentage-33",
  "percentage-40",
  "percentage-50",
  "percentage-60",
  "percentage-66",
  "percentage-70",
  "percentage-75",
  "percentage-80",
  "percentage-90",
  "percentage",
  "perfume",
  "perspective-off",
  "perspective",
  "phone-call",
  "phone-calling",
  "phone-check",
  "phone-done",
  "phone-end",
  "phone-incoming",
  "phone-off",
  "phone-outgoing",
  "phone-pause",
  "phone-plus",
  "phone-ringing",
  "phone-spark",
  "phone-x",
  "phone",
  "photo-ai",
  "photo-bitcoin",
  "photo-bolt",
  "photo-cancel",
  "photo-check",
  "photo-circle-minus",
  "photo-circle-plus",
  "photo-circle",
  "photo-code",
  "photo-cog",
  "photo-dollar",
  "photo-down",
  "photo-edit",
  "photo-exclamation",
  "photo-heart",
  "photo-hexagon",
  "photo-minus",
  "photo-off",
  "photo-pause",
  "photo-pentagon",
  "photo-pin",
  "photo-plus",
  "photo-question",
  "photo-scan",
  "photo-search",
  "photo-sensor-2",
  "photo-sensor-3",
  "photo-sensor",
  "photo-share",
  "photo-shield",
  "photo-spark",
  "photo-square-rounded",
  "photo-star",
  "photo-up",
  "photo-video",
  "photo-x",
  "photo",
  "physotherapist",
  "piano",
  "pick",
  "picnic-table",
  "picture-in-picture-off",
  "picture-in-picture-on",
  "picture-in-picture-top",
  "picture-in-picture",
  "pig-money",
  "pig-off",
  "pig",
  "pilcrow-left",
  "pilcrow-right",
  "pilcrow",
  "pill-off",
  "pill",
  "pills",
  "pin-end",
  "pin-invoke",
  "pin",
  "ping-pong",
  "pinned-off",
  "pinned",
  "pizza-off",
  "pizza",
  "placeholder",
  "plane-arrival",
  "plane-departure",
  "plane-inflight",
  "plane-off",
  "plane-tilt",
  "plane",
  "planet-off",
  "planet",
  "plant-2-off",
  "plant-2",
  "plant-off",
  "plant",
  "play-basketball",
  "play-card-1",
  "play-card-10",
  "play-card-2",
  "play-card-3",
  "play-card-4",
  "play-card-5",
  "play-card-6",
  "play-card-7",
  "play-card-8",
  "play-card-9",
  "play-card-a",
  "play-card-j",
  "play-card-k",
  "play-card-off",
  "play-card-q",
  "play-card-star",
  "play-card",
  "play-football",
  "play-handball",
  "play-volleyball",
  "player-eject",
  "player-pause",
  "player-play",
  "player-record",
  "player-skip-back",
  "player-skip-forward",
  "player-stop",
  "player-track-next",
  "player-track-prev",
  "playlist-add",
  "playlist-off",
  "playlist-x",
  "playlist",
  "playstation-circle",
  "playstation-square",
  "playstation-triangle",
  "playstation-x",
  "plug-connected-x",
  "plug-connected",
  "plug-off",
  "plug-x",
  "plug",
  "plus-equal",
  "plus-minus",
  "plus",
  "png",
  "podium-off",
  "podium",
  "point-off",
  "point",
  "pointer-bolt",
  "pointer-cancel",
  "pointer-check",
  "pointer-code",
  "pointer-cog",
  "pointer-dollar",
  "pointer-down",
  "pointer-exclamation",
  "pointer-heart",
  "pointer-minus",
  "pointer-off",
  "pointer-pause",
  "pointer-pin",
  "pointer-plus",
  "pointer-question",
  "pointer-search",
  "pointer-share",
  "pointer-star",
  "pointer-up",
  "pointer-x",
  "pointer",
  "pokeball-off",
  "pokeball",
  "poker-chip",
  "polaroid",
  "polygon-off",
  "polygon",
  "poo",
  "pool-off",
  "pool",
  "power",
  "pray",
  "premium-rights",
  "prescription",
  "presentation-analytics",
  "presentation-off",
  "presentation",
  "printer-off",
  "printer",
  "prism-light",
  "prism-off",
  "prism-plus",
  "prism",
  "prison",
  "progress-alert",
  "progress-bolt",
  "progress-check",
  "progress-down",
  "progress-help",
  "progress-x",
  "progress",
  "prompt",
  "prong",
  "propeller-off",
  "propeller",
  "protocol",
  "pumpkin-scary",
  "puzzle-2",
  "puzzle-off",
  "puzzle",
  "pyramid-off",
  "pyramid-plus",
  "pyramid",
  "qrcode-off",
  "qrcode",
  "question-mark",
  "quote-off",
  "quote",
  "quotes",
  "radar-2",
  "radar-off",
  "radar",
  "radio-off",
  "radio",
  "radioactive-off",
  "radioactive",
  "radius-bottom-left",
  "radius-bottom-right",
  "radius-top-left",
  "radius-top-right",
  "rainbow-off",
  "rainbow",
  "rating-12-plus",
  "rating-14-plus",
  "rating-16-plus",
  "rating-18-plus",
  "rating-21-plus",
  "razor-electric",
  "razor",
  "receipt-2",
  "receipt-bitcoin",
  "receipt-dollar",
  "receipt-euro",
  "receipt-off",
  "receipt-pound",
  "receipt-refund",
  "receipt-rupee",
  "receipt-tax",
  "receipt-yen",
  "receipt-yuan",
  "receipt",
  "recharging",
  "record-mail-off",
  "record-mail",
  "rectangle-rounded-bottom",
  "rectangle-rounded-top",
  "rectangle-vertical",
  "rectangle",
  "rectangular-prism-off",
  "rectangular-prism-plus",
  "rectangular-prism",
  "recycle-off",
  "recycle",
  "refresh-alert",
  "refresh-dot",
  "refresh-off",
  "refresh",
  "regex-off",
  "regex",
  "registered",
  "relation-many-to-many",
  "relation-one-to-many",
  "relation-one-to-one",
  "reload",
  "reorder",
  "repeat-off",
  "repeat-once",
  "repeat",
  "replace-off",
  "replace-user",
  "replace",
  "report-analytics",
  "report-medical",
  "report-money",
  "report-off",
  "report-search",
  "report",
  "reserved-line",
  "resize",
  "restore",
  "rewind-backward-10",
  "rewind-backward-15",
  "rewind-backward-20",
  "rewind-backward-30",
  "rewind-backward-40",
  "rewind-backward-5",
  "rewind-backward-50",
  "rewind-backward-60",
  "rewind-forward-10",
  "rewind-forward-15",
  "rewind-forward-20",
  "rewind-forward-30",
  "rewind-forward-40",
  "rewind-forward-5",
  "rewind-forward-50",
  "rewind-forward-60",
  "ribbon-health",
  "rings",
  "ripple-off",
  "ripple",
  "road-off",
  "road-sign",
  "road",
  "robot-face",
  "robot-off",
  "robot",
  "rocket-off",
  "rocket",
  "roller-skating",
  "rollercoaster-off",
  "rollercoaster",
  "rosette-discount-check-off",
  "rosette-discount-check",
  "rosette-discount-off",
  "rosette-discount",
  "rosette-number-0",
  "rosette-number-1",
  "rosette-number-2",
  "rosette-number-3",
  "rosette-number-4",
  "rosette-number-5",
  "rosette-number-6",
  "rosette-number-7",
  "rosette-number-8",
  "rosette-number-9",
  "rosette",
  "rotate-2",
  "rotate-360",
  "rotate-3d",
  "rotate-clockwise-2",
  "rotate-clockwise",
  "rotate-dot",
  "rotate-rectangle",
  "rotate",
  "route-2",
  "route-alt-left",
  "route-alt-right",
  "route-off",
  "route-scan",
  "route-square-2",
  "route-square",
  "route-x-2",
  "route-x",
  "route",
  "router-off",
  "router",
  "row-insert-bottom",
  "row-insert-top",
  "row-remove",
  "rss",
  "rubber-stamp-off",
  "rubber-stamp",
  "ruler-2-off",
  "ruler-2",
  "ruler-3",
  "ruler-measure-2",
  "ruler-measure",
  "ruler-off",
  "ruler",
  "run",
  "rv-truck",
  "s-turn-down",
  "s-turn-left",
  "s-turn-right",
  "s-turn-up",
  "sailboat-2",
  "sailboat-off",
  "sailboat",
  "salad",
  "salt",
  "sandbox",
  "satellite-off",
  "satellite",
  "sausage",
  "scale-off",
  "scale-outline-off",
  "scale-outline",
  "scale",
  "scan-eye",
  "scan-position",
  "scan",
  "schema-off",
  "schema",
  "school-bell",
  "school-off",
  "school",
  "scissors-off",
  "scissors",
  "scooter-electric",
  "scooter",
  "scoreboard",
  "screen-share-off",
  "screen-share",
  "screenshot",
  "scribble-off",
  "scribble",
  "script-minus",
  "script-plus",
  "script-x",
  "script",
  "scuba-diving-tank",
  "scuba-diving",
  "scuba-mask-off",
  "scuba-mask",
  "sdk",
  "search-off",
  "search",
  "section-sign",
  "section",
  "seedling-off",
  "seedling",
  "select-all",
  "select",
  "selector",
  "send-2",
  "send-off",
  "send",
  "seo",
  "separator-horizontal",
  "separator-vertical",
  "separator",
  "server-2",
  "server-bolt",
  "server-cog",
  "server-off",
  "server-spark",
  "server",
  "servicemark",
  "settings-2",
  "settings-automation",
  "settings-bolt",
  "settings-cancel",
  "settings-check",
  "settings-code",
  "settings-cog",
  "settings-dollar",
  "settings-down",
  "settings-exclamation",
  "settings-heart",
  "settings-minus",
  "settings-off",
  "settings-pause",
  "settings-pin",
  "settings-plus",
  "settings-question",
  "settings-search",
  "settings-share",
  "settings-spark",
  "settings-star",
  "settings-up",
  "settings-x",
  "settings",
  "shadow-off",
  "shadow",
  "shape-2",
  "shape-3",
  "shape-off",
  "shape",
  "share-2",
  "share-3",
  "share-off",
  "share",
  "shareplay",
  "shield-bolt",
  "shield-cancel",
  "shield-check",
  "shield-checkered",
  "shield-chevron",
  "shield-code",
  "shield-cog",
  "shield-dollar",
  "shield-down",
  "shield-exclamation",
  "shield-half",
  "shield-heart",
  "shield-lock",
  "shield-minus",
  "shield-off",
  "shield-pause",
  "shield-pin",
  "shield-plus",
  "shield-question",
  "shield-search",
  "shield-share",
  "shield-star",
  "shield-up",
  "shield-x",
  "shield",
  "ship-off",
  "ship",
  "shirt-off",
  "shirt-sport",
  "shirt",
  "shoe-off",
  "shoe",
  "shopping-bag-check",
  "shopping-bag-discount",
  "shopping-bag-edit",
  "shopping-bag-exclamation",
  "shopping-bag-heart",
  "shopping-bag-minus",
  "shopping-bag-plus",
  "shopping-bag-search",
  "shopping-bag-x",
  "shopping-bag",
  "shopping-cart-bolt",
  "shopping-cart-cancel",
  "shopping-cart-check",
  "shopping-cart-code",
  "shopping-cart-cog",
  "shopping-cart-copy",
  "shopping-cart-discount",
  "shopping-cart-dollar",
  "shopping-cart-down",
  "shopping-cart-exclamation",
  "shopping-cart-heart",
  "shopping-cart-minus",
  "shopping-cart-off",
  "shopping-cart-pause",
  "shopping-cart-pin",
  "shopping-cart-plus",
  "shopping-cart-question",
  "shopping-cart-search",
  "shopping-cart-share",
  "shopping-cart-star",
  "shopping-cart-up",
  "shopping-cart-x",
  "shopping-cart",
  "shovel-pitchforks",
  "shovel",
  "shredder",
  "sign-left",
  "sign-right",
  "signal-2g",
  "signal-3g",
  "signal-4g-plus",
  "signal-4g",
  "signal-5g",
  "signal-6g",
  "signal-e",
  "signal-g",
  "signal-h-plus",
  "signal-h",
  "signal-lte",
  "signature-off",
  "signature",
  "sitemap-off",
  "sitemap",
  "skateboard-off",
  "skateboard",
  "skateboarding",
  "skew-x",
  "skew-y",
  "ski-jumping",
  "skull",
  "slash",
  "slashes",
  "sleigh",
  "slice",
  "slideshow",
  "smart-home-off",
  "smart-home",
  "smoking-no",
  "smoking",
  "snowboarding",
  "snowflake-off",
  "snowflake",
  "snowman",
  "soccer-field",
  "social-off",
  "social",
  "sock",
  "sofa-off",
  "sofa",
  "solar-electricity",
  "solar-panel-2",
  "solar-panel",
  "sort-0-9",
  "sort-9-0",
  "sort-a-z",
  "sort-ascending-2",
  "sort-ascending-letters",
  "sort-ascending-numbers",
  "sort-ascending-shapes",
  "sort-ascending-small-big",
  "sort-ascending",
  "sort-descending-2",
  "sort-descending-letters",
  "sort-descending-numbers",
  "sort-descending-shapes",
  "sort-descending-small-big",
  "sort-descending",
  "sort-z-a",
  "sos",
  "soup-off",
  "soup",
  "source-code",
  "space-off",
  "space",
  "spaces",
  "spacing-horizontal",
  "spacing-vertical",
  "spade",
  "sparkles",
  "speakerphone",
  "speedboat",
  "sphere-off",
  "sphere-plus",
  "sphere",
  "spider",
  "spiral-off",
  "spiral",
  "sport-billard",
  "spray",
  "spy-off",
  "spy",
  "sql",
  "square-arrow-down",
  "square-arrow-left",
  "square-arrow-right",
  "square-arrow-up",
  "square-asterisk",
  "square-check",
  "square-chevron-down",
  "square-chevron-left",
  "square-chevron-right",
  "square-chevron-up",
  "square-chevrons-down",
  "square-chevrons-left",
  "square-chevrons-right",
  "square-chevrons-up",
  "square-dashed",
  "square-dot",
  "square-f0",
  "square-f1",
  "square-f2",
  "square-f3",
  "square-f4",
  "square-f5",
  "square-f6",
  "square-f7",
  "square-f8",
  "square-f9",
  "square-forbid-2",
  "square-forbid",
  "square-half",
  "square-key",
  "square-letter-a",
  "square-letter-b",
  "square-letter-c",
  "square-letter-d",
  "square-letter-e",
  "square-letter-f",
  "square-letter-g",
  "square-letter-h",
  "square-letter-i",
  "square-letter-j",
  "square-letter-k",
  "square-letter-l",
  "square-letter-m",
  "square-letter-n",
  "square-letter-o",
  "square-letter-p",
  "square-letter-q",
  "square-letter-r",
  "square-letter-s",
  "square-letter-t",
  "square-letter-u",
  "square-letter-v",
  "square-letter-w",
  "square-letter-x",
  "square-letter-y",
  "square-letter-z",
  "square-minus",
  "square-number-0",
  "square-number-1",
  "square-number-2",
  "square-number-3",
  "square-number-4",
  "square-number-5",
  "square-number-6",
  "square-number-7",
  "square-number-8",
  "square-number-9",
  "square-off",
  "square-percentage",
  "square-plus-2",
  "square-plus",
  "square-root-2",
  "square-root",
  "square-rotated-forbid-2",
  "square-rotated-forbid",
  "square-rotated-off",
  "square-rotated",
  "square-rounded-arrow-down",
  "square-rounded-arrow-left",
  "square-rounded-arrow-right",
  "square-rounded-arrow-up",
  "square-rounded-check",
  "square-rounded-chevron-down",
  "square-rounded-chevron-left",
  "square-rounded-chevron-right",
  "square-rounded-chevron-up",
  "square-rounded-chevrons-down",
  "square-rounded-chevrons-left",
  "square-rounded-chevrons-right",
  "square-rounded-chevrons-up",
  "square-rounded-letter-a",
  "square-rounded-letter-b",
  "square-rounded-letter-c",
  "square-rounded-letter-d",
  "square-rounded-letter-e",
  "square-rounded-letter-f",
  "square-rounded-letter-g",
  "square-rounded-letter-h",
  "square-rounded-letter-i",
  "square-rounded-letter-j",
  "square-rounded-letter-k",
  "square-rounded-letter-l",
  "square-rounded-letter-m",
  "square-rounded-letter-n",
  "square-rounded-letter-o",
  "square-rounded-letter-p",
  "square-rounded-letter-q",
  "square-rounded-letter-r",
  "square-rounded-letter-s",
  "square-rounded-letter-t",
  "square-rounded-letter-u",
  "square-rounded-letter-v",
  "square-rounded-letter-w",
  "square-rounded-letter-x",
  "square-rounded-letter-y",
  "square-rounded-letter-z",
  "square-rounded-minus-2",
  "square-rounded-minus",
  "square-rounded-number-0",
  "square-rounded-number-1",
  "square-rounded-number-2",
  "square-rounded-number-3",
  "square-rounded-number-4",
  "square-rounded-number-5",
  "square-rounded-number-6",
  "square-rounded-number-7",
  "square-rounded-number-8",
  "square-rounded-number-9",
  "square-rounded-percentage",
  "square-rounded-plus-2",
  "square-rounded-plus",
  "square-rounded-x",
  "square-rounded",
  "square-toggle-horizontal",
  "square-toggle",
  "square-x",
  "square",
  "squares-diagonal",
  "squares-selected",
  "squares",
  "stack-2",
  "stack-3",
  "stack-back",
  "stack-backward",
  "stack-forward",
  "stack-front",
  "stack-middle",
  "stack-pop",
  "stack-push",
  "stack",
  "stairs-down",
  "stairs-up",
  "stairs",
  "star-half",
  "star-off",
  "star",
  "stars-off",
  "stars",
  "status-change",
  "steam",
  "steering-wheel-off",
  "steering-wheel",
  "step-into",
  "step-out",
  "stereo-glasses",
  "stethoscope-off",
  "stethoscope",
  "sticker-2",
  "sticker",
  "stopwatch",
  "storm-off",
  "storm",
  "stretching-2",
  "stretching",
  "strikethrough",
  "submarine",
  "subscript",
  "subtask",
  "sum-off",
  "sum",
  "sun-electricity",
  "sun-high",
  "sun-low",
  "sun-moon",
  "sun-off",
  "sun-wind",
  "sun",
  "sunglasses",
  "sunrise",
  "sunset-2",
  "sunset",
  "superscript",
  "svg",
  "swimming",
  "swipe-down",
  "swipe-left",
  "swipe-right",
  "swipe-up",
  "swipe",
  "switch-2",
  "switch-3",
  "switch-horizontal",
  "switch-vertical",
  "switch",
  "sword-off",
  "sword",
  "swords",
  "table-alias",
  "table-column",
  "table-dashed",
  "table-down",
  "table-export",
  "table-heart",
  "table-import",
  "table-minus",
  "table-off",
  "table-options",
  "table-plus",
  "table-row",
  "table-share",
  "table-shortcut",
  "table-spark",
  "table",
  "tag-minus",
  "tag-off",
  "tag-plus",
  "tag-starred",
  "tag",
  "tags-off",
  "tags",
  "tallymark-1",
  "tallymark-2",
  "tallymark-3",
  "tallymark-4",
  "tallymarks",
  "tank",
  "target-arrow",
  "target-off",
  "target",
  "tax-euro",
  "tax-pound",
  "tax",
  "teapot",
  "telescope-off",
  "telescope",
  "temperature-celsius",
  "temperature-fahrenheit",
  "temperature-minus",
  "temperature-off",
  "temperature-plus",
  "temperature-snow",
  "temperature-sun",
  "temperature",
  "template-off",
  "template",
  "tent-off",
  "tent",
  "terminal-2",
  "terminal",
  "test-pipe-2",
  "test-pipe-off",
  "test-pipe",
  "tex",
  "text-caption",
  "text-color",
  "text-decrease",
  "text-direction-ltr",
  "text-direction-rtl",
  "text-grammar",
  "text-increase",
  "text-orientation",
  "text-plus",
  "text-recognition",
  "text-resize",
  "text-scan-2",
  "text-size",
  "text-spellcheck",
  "text-wrap-column",
  "text-wrap-disabled",
  "text-wrap",
  "texture",
  "theater",
  "thermometer",
  "thumb-down-off",
  "thumb-down",
  "thumb-up-off",
  "thumb-up",
  "tic-tac",
  "ticket-off",
  "ticket",
  "tie",
  "tilde",
  "tilt-shift-off",
  "tilt-shift",
  "time-duration-0",
  "time-duration-10",
  "time-duration-15",
  "time-duration-30",
  "time-duration-45",
  "time-duration-5",
  "time-duration-60",
  "time-duration-90",
  "time-duration-off",
  "timeline-event-exclamation",
  "timeline-event-minus",
  "timeline-event-plus",
  "timeline-event-text",
  "timeline-event-x",
  "timeline-event",
  "timeline",
  "timezone",
  "tip-jar-euro",
  "tip-jar-pound",
  "tip-jar",
  "tir",
  "toggle-left",
  "toggle-right",
  "toilet-paper-off",
  "toilet-paper",
  "toml",
  "tool",
  "tools-kitchen-2-off",
  "tools-kitchen-2",
  "tools-kitchen-3",
  "tools-kitchen-off",
  "tools-kitchen",
  "tools-off",
  "tools",
  "tooltip",
  "topology-bus",
  "topology-complex",
  "topology-full-hierarchy",
  "topology-full",
  "topology-ring-2",
  "topology-ring-3",
  "topology-ring",
  "topology-star-2",
  "topology-star-3",
  "topology-star-ring-2",
  "topology-star-ring-3",
  "topology-star-ring",
  "topology-star",
  "torii",
  "tornado",
  "tournament",
  "tower-off",
  "tower",
  "track",
  "tractor",
  "trademark",
  "traffic-cone-off",
  "traffic-cone",
  "traffic-lights-off",
  "traffic-lights",
  "train",
  "transaction-bitcoin",
  "transaction-dollar",
  "transaction-euro",
  "transaction-pound",
  "transaction-rupee",
  "transaction-yen",
  "transaction-yuan",
  "transfer-in",
  "transfer-out",
  "transfer-vertical",
  "transfer",
  "transform-point-bottom-left",
  "transform-point-bottom-right",
  "transform-point-top-left",
  "transform-point-top-right",
  "transform-point",
  "transform",
  "transition-bottom",
  "transition-left",
  "transition-right",
  "transition-top",
  "trash-off",
  "trash-x",
  "trash",
  "treadmill",
  "tree",
  "trees",
  "trekking",
  "trending-down-2",
  "trending-down-3",
  "trending-down",
  "trending-up-2",
  "trending-up-3",
  "trending-up",
  "triangle-inverted",
  "triangle-minus-2",
  "triangle-minus",
  "triangle-off",
  "triangle-plus-2",
  "triangle-plus",
  "triangle-square-circle",
  "triangle",
  "triangles",
  "trident",
  "trolley",
  "trophy-off",
  "trophy",
  "trowel",
  "truck-delivery",
  "truck-loading",
  "truck-off",
  "truck-return",
  "truck",
  "txt",
  "typeface",
  "typography-off",
  "typography",
  "u-turn-left",
  "u-turn-right",
  "ufo-off",
  "ufo",
  "uhd",
  "umbrella-2",
  "umbrella-closed-2",
  "umbrella-closed",
  "umbrella-off",
  "umbrella",
  "underline",
  "universe",
  "unlink",
  "upload",
  "urgent",
  "usb",
  "user-bitcoin",
  "user-bolt",
  "user-cancel",
  "user-check",
  "user-circle",
  "user-code",
  "user-cog",
  "user-dollar",
  "user-down",
  "user-edit",
  "user-exclamation",
  "user-heart",
  "user-hexagon",
  "user-minus",
  "user-off",
  "user-pause",
  "user-pentagon",
  "user-pin",
  "user-plus",
  "user-question",
  "user-scan",
  "user-screen",
  "user-search",
  "user-share",
  "user-shield",
  "user-square-rounded",
  "user-square",
  "user-star",
  "user-up",
  "user-x",
  "user",
  "users-group",
  "users-minus",
  "users-plus",
  "users",
  "uv-index",
  "ux-circle",
  "vaccine-bottle-off",
  "vaccine-bottle",
  "vaccine-off",
  "vaccine",
  "vacuum-cleaner",
  "variable-minus",
  "variable-off",
  "variable-plus",
  "variable",
  "vector-bezier-2",
  "vector-bezier-arc",
  "vector-bezier-circle",
  "vector-bezier",
  "vector-off",
  "vector-spline",
  "vector-triangle-off",
  "vector-triangle",
  "vector",
  "venus",
  "versions-off",
  "versions",
  "video-minus",
  "video-off",
  "video-plus",
  "video",
  "view-360-arrow",
  "view-360-number",
  "view-360-off",
  "view-360",
  "viewfinder-off",
  "viewfinder",
  "viewport-narrow",
  "viewport-short",
  "viewport-tall",
  "viewport-wide",
  "vinyl",
  "vip-off",
  "vip",
  "virus-off",
  "virus-search",
  "virus",
  "vocabulary-off",
  "vocabulary",
  "volcano",
  "volume-2",
  "volume-3",
  "volume-off",
  "volume",
  "vs",
  "walk",
  "wall-off",
  "wall",
  "wallet-off",
  "wallet",
  "wallpaper-off",
  "wallpaper",
  "wand-off",
  "wand",
  "wash-dry-1",
  "wash-dry-2",
  "wash-dry-3",
  "wash-dry-a",
  "wash-dry-dip",
  "wash-dry-f",
  "wash-dry-flat",
  "wash-dry-hang",
  "wash-dry-off",
  "wash-dry-p",
  "wash-dry-shade",
  "wash-dry-w",
  "wash-dry",
  "wash-dryclean-off",
  "wash-dryclean",
  "wash-eco",
  "wash-gentle",
  "wash-hand",
  "wash-machine",
  "wash-off",
  "wash-press",
  "wash-temperature-1",
  "wash-temperature-2",
  "wash-temperature-3",
  "wash-temperature-4",
  "wash-temperature-5",
  "wash-temperature-6",
  "wash-tumble-dry",
  "wash-tumble-off",
  "wash",
  "waterpolo",
  "wave-saw-tool",
  "wave-sine",
  "wave-square",
  "waves-electricity",
  "webhook-off",
  "webhook",
  "weight",
  "wheat-off",
  "wheat",
  "wheel",
  "wheelchair-off",
  "wheelchair",
  "whirl",
  "wifi-0",
  "wifi-1",
  "wifi-2",
  "wifi-off",
  "wifi",
  "wind-electricity",
  "wind-off",
  "wind",
  "windmill-off",
  "windmill",
  "window-maximize",
  "window-minimize",
  "window-off",
  "window",
  "windsock",
  "wiper-wash",
  "wiper",
  "woman",
  "wood",
  "world-bolt",
  "world-cancel",
  "world-check",
  "world-code",
  "world-cog",
  "world-dollar",
  "world-down",
  "world-download",
  "world-exclamation",
  "world-heart",
  "world-latitude",
  "world-longitude",
  "world-minus",
  "world-off",
  "world-pause",
  "world-pin",
  "world-plus",
  "world-question",
  "world-search",
  "world-share",
  "world-star",
  "world-up",
  "world-upload",
  "world-www",
  "world-x",
  "world",
  "wrecking-ball",
  "writing-off",
  "writing-sign-off",
  "writing-sign",
  "writing",
  "x-power-y",
  "x",
  "xbox-a",
  "xbox-b",
  "xbox-x",
  "xbox-y",
  "xd",
  "xxx",
  "yin-yang",
  "yoga",
  "zeppelin-off",
  "zeppelin",
  "zip",
  "zodiac-aquarius",
  "zodiac-aries",
  "zodiac-cancer",
  "zodiac-capricorn",
  "zodiac-gemini",
  "zodiac-leo",
  "zodiac-libra",
  "zodiac-pisces",
  "zodiac-sagittarius",
  "zodiac-scorpio",
  "zodiac-taurus",
  "zodiac-virgo",
  "zoom-cancel",
  "zoom-check",
  "zoom-code",
  "zoom-exclamation",
  "zoom-in-area",
  "zoom-in",
  "zoom-money",
  "zoom-out-area",
  "zoom-out",
  "zoom-pan",
  "zoom-question",
  "zoom-replace",
  "zoom-reset",
  "zoom-scan",
  "zoom",
  "zzz-off",
  "zzz",
  "accessible-filled",
  "ad-circle-filled",
  "ad-filled",
  "adjustments-filled",
  "aerial-lift-filled",
  "affiliate-filled",
  "air-balloon-filled",
  "alarm-minus-filled",
  "alarm-plus-filled",
  "alarm-snooze-filled",
  "alarm-filled",
  "alert-circle-filled",
  "alert-hexagon-filled",
  "alert-octagon-filled",
  "alert-square-rounded-filled",
  "alert-square-filled",
  "alert-triangle-filled",
  "alien-filled",
  "align-box-bottom-center-filled",
  "align-box-bottom-left-filled",
  "align-box-bottom-right-filled",
  "align-box-center-middle-filled",
  "align-box-left-bottom-filled",
  "align-box-left-middle-filled",
  "align-box-left-top-filled",
  "align-box-right-bottom-filled",
  "align-box-right-middle-filled",
  "align-box-right-top-filled",
  "align-box-top-center-filled",
  "align-box-top-left-filled",
  "align-box-top-right-filled",
  "analyze-filled",
  "app-window-filled",
  "apple-filled",
  "apps-filled",
  "archive-filled",
  "arrow-autofit-content-filled",
  "arrow-autofit-down-filled",
  "arrow-autofit-height-filled",
  "arrow-autofit-left-filled",
  "arrow-autofit-right-filled",
  "arrow-autofit-up-filled",
  "arrow-autofit-width-filled",
  "arrow-badge-down-filled",
  "arrow-badge-left-filled",
  "arrow-badge-right-filled",
  "arrow-badge-up-filled",
  "arrow-big-down-line-filled",
  "arrow-big-down-lines-filled",
  "arrow-big-down-filled",
  "arrow-big-left-line-filled",
  "arrow-big-left-lines-filled",
  "arrow-big-left-filled",
  "arrow-big-right-line-filled",
  "arrow-big-right-lines-filled",
  "arrow-big-right-filled",
  "arrow-big-up-line-filled",
  "arrow-big-up-lines-filled",
  "arrow-big-up-filled",
  "arrow-down-circle-filled",
  "arrow-down-rhombus-filled",
  "arrow-down-square-filled",
  "arrow-guide-filled",
  "arrow-left-circle-filled",
  "arrow-left-rhombus-filled",
  "arrow-left-square-filled",
  "arrow-move-down-filled",
  "arrow-move-left-filled",
  "arrow-move-right-filled",
  "arrow-move-up-filled",
  "arrow-right-circle-filled",
  "arrow-right-rhombus-filled",
  "arrow-right-square-filled",
  "arrow-up-circle-filled",
  "arrow-up-rhombus-filled",
  "arrow-up-square-filled",
  "artboard-filled",
  "article-filled",
  "aspect-ratio-filled",
  "assembly-filled",
  "asset-filled",
  "atom-2-filled",
  "automatic-gearbox-filled",
  "award-filled",
  "baby-carriage-filled",
  "backspace-filled",
  "badge-3d-filled",
  "badge-4k-filled",
  "badge-8k-filled",
  "badge-ad-filled",
  "badge-ar-filled",
  "badge-cc-filled",
  "badge-hd-filled",
  "badge-sd-filled",
  "badge-tm-filled",
  "badge-vo-filled",
  "badge-vr-filled",
  "badge-wc-filled",
  "badge-filled",
  "badges-filled",
  "balloon-filled",
  "ballpen-filled",
  "bandage-filled",
  "barbell-filled",
  "barrier-block-filled",
  "basket-filled",
  "bath-filled",
  "battery-1-filled",
  "battery-2-filled",
  "battery-3-filled",
  "battery-4-filled",
  "battery-automotive-filled",
  "battery-vertical-1-filled",
  "battery-vertical-2-filled",
  "battery-vertical-3-filled",
  "battery-vertical-4-filled",
  "battery-vertical-filled",
  "battery-filled",
  "bed-flat-filled",
  "bed-filled",
  "beer-filled",
  "bell-minus-filled",
  "bell-plus-filled",
  "bell-ringing-2-filled",
  "bell-ringing-filled",
  "bell-x-filled",
  "bell-z-filled",
  "bell-filled",
  "bike-filled",
  "binary-tree-2-filled",
  "binary-tree-filled",
  "binoculars-filled",
  "biohazard-filled",
  "blade-filled",
  "blender-filled",
  "blob-filled",
  "bolt-filled",
  "bomb-filled",
  "bone-filled",
  "bong-filled",
  "book-filled",
  "bookmark-filled",
  "bookmarks-filled",
  "boom-filled",
  "bottle-filled",
  "bounce-left-filled",
  "bounce-right-filled",
  "bow-filled",
  "bowl-chopsticks-filled",
  "bowl-spoon-filled",
  "bowl-filled",
  "box-align-bottom-left-filled",
  "box-align-bottom-right-filled",
  "box-align-bottom-filled",
  "box-align-left-filled",
  "box-align-right-filled",
  "box-align-top-left-filled",
  "box-align-top-right-filled",
  "box-align-top-filled",
  "box-multiple-filled",
  "brand-angular-filled",
  "brand-apple-filled",
  "brand-bitbucket-filled",
  "brand-discord-filled",
  "brand-dribbble-filled",
  "brand-facebook-filled",
  "brand-github-filled",
  "brand-google-filled",
  "brand-instagram-filled",
  "brand-kick-filled",
  "brand-linkedin-filled",
  "brand-messenger-filled",
  "brand-open-source-filled",
  "brand-opera-filled",
  "brand-patreon-filled",
  "brand-paypal-filled",
  "brand-pinterest-filled",
  "brand-sketch-filled",
  "brand-snapchat-filled",
  "brand-spotify-filled",
  "brand-steam-filled",
  "brand-stripe-filled",
  "brand-tabler-filled",
  "brand-tiktok-filled",
  "brand-tinder-filled",
  "brand-tumblr-filled",
  "brand-twitter-filled",
  "brand-vercel-filled",
  "brand-vimeo-filled",
  "brand-weibo-filled",
  "brand-whatsapp-filled",
  "brand-windows-filled",
  "brand-x-filled",
  "brand-youtube-filled",
  "bread-filled",
  "briefcase-2-filled",
  "briefcase-filled",
  "brightness-auto-filled",
  "brightness-down-filled",
  "brightness-up-filled",
  "brightness-filled",
  "bubble-text-filled",
  "bubble-filled",
  "bug-filled",
  "building-broadcast-tower-filled",
  "bulb-filled",
  "bus-filled",
  "butterfly-filled",
  "cactus-filled",
  "calculator-filled",
  "calendar-event-filled",
  "calendar-month-filled",
  "calendar-week-filled",
  "calendar-filled",
  "camera-filled",
  "campfire-filled",
  "candle-filled",
  "cannabis-filled",
  "capsule-horizontal-filled",
  "capsule-filled",
  "capture-filled",
  "car-4wd-filled",
  "car-crane-filled",
  "car-fan-filled",
  "car-suv-filled",
  "car-filled",
  "carambola-filled",
  "caravan-filled",
  "cardboards-filled",
  "cards-filled",
  "caret-down-filled",
  "caret-left-right-filled",
  "caret-left-filled",
  "caret-right-filled",
  "caret-up-down-filled",
  "caret-up-filled",
  "carousel-horizontal-filled",
  "carousel-vertical-filled",
  "cash-banknote-filled",
  "category-filled",
  "charging-pile-filled",
  "chart-area-line-filled",
  "chart-area-filled",
  "chart-bubble-filled",
  "chart-candle-filled",
  "chart-donut-filled",
  "chart-dots-2-filled",
  "chart-dots-3-filled",
  "chart-dots-filled",
  "chart-funnel-filled",
  "chart-grid-dots-filled",
  "chart-pie-2-filled",
  "chart-pie-3-filled",
  "chart-pie-4-filled",
  "chart-pie-filled",
  "chef-hat-filled",
  "cherry-filled",
  "chess-bishop-filled",
  "chess-king-filled",
  "chess-knight-filled",
  "chess-queen-filled",
  "chess-rook-filled",
  "chess-filled",
  "christmas-tree-filled",
  "circle-arrow-down-left-filled",
  "circle-arrow-down-right-filled",
  "circle-arrow-down-filled",
  "circle-arrow-left-filled",
  "circle-arrow-right-filled",
  "circle-arrow-up-left-filled",
  "circle-arrow-up-right-filled",
  "circle-arrow-up-filled",
  "circle-caret-down-filled",
  "circle-caret-left-filled",
  "circle-caret-right-filled",
  "circle-caret-up-filled",
  "circle-check-filled",
  "circle-chevron-down-filled",
  "circle-chevron-left-filled",
  "circle-chevron-right-filled",
  "circle-chevron-up-filled",
  "circle-chevrons-down-filled",
  "circle-chevrons-left-filled",
  "circle-chevrons-right-filled",
  "circle-chevrons-up-filled",
  "circle-dot-filled",
  "circle-key-filled",
  "circle-letter-a-filled",
  "circle-letter-b-filled",
  "circle-letter-c-filled",
  "circle-letter-d-filled",
  "circle-letter-e-filled",
  "circle-letter-f-filled",
  "circle-letter-g-filled",
  "circle-letter-h-filled",
  "circle-letter-i-filled",
  "circle-letter-j-filled",
  "circle-letter-k-filled",
  "circle-letter-l-filled",
  "circle-letter-m-filled",
  "circle-letter-n-filled",
  "circle-letter-o-filled",
  "circle-letter-p-filled",
  "circle-letter-q-filled",
  "circle-letter-r-filled",
  "circle-letter-s-filled",
  "circle-letter-t-filled",
  "circle-letter-u-filled",
  "circle-letter-v-filled",
  "circle-letter-w-filled",
  "circle-letter-x-filled",
  "circle-letter-y-filled",
  "circle-letter-z-filled",
  "circle-number-0-filled",
  "circle-number-1-filled",
  "circle-number-2-filled",
  "circle-number-3-filled",
  "circle-number-4-filled",
  "circle-number-5-filled",
  "circle-number-6-filled",
  "circle-number-7-filled",
  "circle-number-8-filled",
  "circle-number-9-filled",
  "circle-percentage-filled",
  "circle-plus-filled",
  "circle-rectangle-filled",
  "circle-x-filled",
  "circle-filled",
  "circles-filled",
  "clipboard-check-filled",
  "clipboard-data-filled",
  "clipboard-list-filled",
  "clipboard-text-filled",
  "clipboard-typography-filled",
  "clipboard-x-filled",
  "clipboard-filled",
  "clock-hour-1-filled",
  "clock-hour-10-filled",
  "clock-hour-11-filled",
  "clock-hour-12-filled",
  "clock-hour-2-filled",
  "clock-hour-3-filled",
  "clock-hour-4-filled",
  "clock-hour-5-filled",
  "clock-hour-6-filled",
  "clock-hour-7-filled",
  "clock-hour-8-filled",
  "clock-hour-9-filled",
  "clock-filled",
  "cloud-computing-filled",
  "cloud-data-connection-filled",
  "cloud-filled",
  "clover-filled",
  "clubs-filled",
  "code-circle-2-filled",
  "code-circle-filled",
  "coin-bitcoin-filled",
  "coin-euro-filled",
  "coin-monero-filled",
  "coin-pound-filled",
  "coin-rupee-filled",
  "coin-taka-filled",
  "coin-yen-filled",
  "coin-yuan-filled",
  "coin-filled",
  "compass-filled",
  "cone-2-filled",
  "cone-filled",
  "contrast-2-filled",
  "contrast-filled",
  "cookie-man-filled",
  "cookie-filled",
  "copy-check-filled",
  "copy-minus-filled",
  "copy-plus-filled",
  "copy-x-filled",
  "copyleft-filled",
  "copyright-filled",
  "credit-card-filled",
  "crop-1-1-filled",
  "crop-16-9-filled",
  "crop-3-2-filled",
  "crop-5-4-filled",
  "crop-7-5-filled",
  "crop-landscape-filled",
  "crop-portrait-filled",
  "cross-filled",
  "current-location-filled",
  "dashboard-filled",
  "device-cctv-filled",
  "device-desktop-filled",
  "device-gamepad-3-filled",
  "device-heart-monitor-filled",
  "device-imac-filled",
  "device-ipad-filled",
  "device-mobile-filled",
  "device-remote-filled",
  "device-speaker-filled",
  "device-tablet-filled",
  "device-tv-old-filled",
  "device-tv-filled",
  "device-unknown-filled",
  "device-usb-filled",
  "device-vision-pro-filled",
  "device-watch-filled",
  "dialpad-filled",
  "diamond-filled",
  "diamonds-filled",
  "dice-1-filled",
  "dice-2-filled",
  "dice-3-filled",
  "dice-4-filled",
  "dice-5-filled",
  "dice-6-filled",
  "dice-filled",
  "direction-arrows-filled",
  "direction-sign-filled",
  "directions-filled",
  "disc-filled",
  "discount-filled",
  "drop-circle-filled",
  "droplet-half-2-filled",
  "droplet-half-filled",
  "droplet-filled",
  "droplets-filled",
  "dual-screen-filled",
  "dumpling-filled",
  "egg-cracked-filled",
  "egg-fried-filled",
  "egg-filled",
  "elevator-filled",
  "engine-filled",
  "escalator-down-filled",
  "escalator-up-filled",
  "escalator-filled",
  "exchange-filled",
  "exclamation-circle-filled",
  "explicit-filled",
  "exposure-filled",
  "eye-table-filled",
  "eye-filled",
  "eyeglass-2-filled",
  "eyeglass-filled",
  "face-mask-filled",
  "favicon-filled",
  "feather-filled",
  "fence-filled",
  "ferry-filled",
  "fidget-spinner-filled",
  "file-check-filled",
  "file-code-2-filled",
  "file-cv-filled",
  "file-delta-filled",
  "file-description-filled",
  "file-digit-filled",
  "file-download-filled",
  "file-horizontal-filled",
  "file-invoice-filled",
  "file-lambda-filled",
  "file-minus-filled",
  "file-neutral-filled",
  "file-percent-filled",
  "file-phone-filled",
  "file-power-filled",
  "file-rss-filled",
  "file-sad-filled",
  "file-smile-filled",
  "file-star-filled",
  "file-text-filled",
  "file-x-filled",
  "file-filled",
  "filter-filled",
  "filters-filled",
  "fish-bone-filled",
  "flag-2-filled",
  "flag-3-filled",
  "flag-filled",
  "flame-filled",
  "flare-filled",
  "flask-2-filled",
  "flask-filled",
  "flower-filled",
  "folder-filled",
  "folders-filled",
  "forbid-2-filled",
  "forbid-filled",
  "fountain-filled",
  "function-filled",
  "garden-cart-filled",
  "gas-station-filled",
  "gauge-filled",
  "ghost-2-filled",
  "ghost-3-filled",
  "ghost-filled",
  "gift-card-filled",
  "gift-filled",
  "glass-full-filled",
  "glass-filled",
  "globe-filled",
  "golf-filled",
  "gps-filled",
  "graph-filled",
  "grid-pattern-filled",
  "guitar-pick-filled",
  "hanger-2-filled",
  "headphones-filled",
  "heart-filled",
  "helicopter-landing-filled",
  "helicopter-filled",
  "help-circle-filled",
  "help-hexagon-filled",
  "help-octagon-filled",
  "help-square-rounded-filled",
  "help-square-filled",
  "help-triangle-filled",
  "hexagon-letter-a-filled",
  "hexagon-letter-b-filled",
  "hexagon-letter-c-filled",
  "hexagon-letter-d-filled",
  "hexagon-letter-e-filled",
  "hexagon-letter-f-filled",
  "hexagon-letter-g-filled",
  "hexagon-letter-h-filled",
  "hexagon-letter-i-filled",
  "hexagon-letter-j-filled",
  "hexagon-letter-k-filled",
  "hexagon-letter-l-filled",
  "hexagon-letter-m-filled",
  "hexagon-letter-n-filled",
  "hexagon-letter-o-filled",
  "hexagon-letter-p-filled",
  "hexagon-letter-q-filled",
  "hexagon-letter-r-filled",
  "hexagon-letter-s-filled",
  "hexagon-letter-t-filled",
  "hexagon-letter-u-filled",
  "hexagon-letter-v-filled",
  "hexagon-letter-w-filled",
  "hexagon-letter-x-filled",
  "hexagon-letter-y-filled",
  "hexagon-letter-z-filled",
  "hexagon-minus-filled",
  "hexagon-number-0-filled",
  "hexagon-number-1-filled",
  "hexagon-number-2-filled",
  "hexagon-number-3-filled",
  "hexagon-number-4-filled",
  "hexagon-number-5-filled",
  "hexagon-number-6-filled",
  "hexagon-number-7-filled",
  "hexagon-number-8-filled",
  "hexagon-number-9-filled",
  "hexagon-plus-filled",
  "hexagon-filled",
  "home-filled",
  "hospital-circle-filled",
  "hourglass-filled",
  "icons-filled",
  "info-circle-filled",
  "info-hexagon-filled",
  "info-octagon-filled",
  "info-square-rounded-filled",
  "info-square-filled",
  "info-triangle-filled",
  "inner-shadow-bottom-left-filled",
  "inner-shadow-bottom-right-filled",
  "inner-shadow-bottom-filled",
  "inner-shadow-left-filled",
  "inner-shadow-right-filled",
  "inner-shadow-top-left-filled",
  "inner-shadow-top-right-filled",
  "inner-shadow-top-filled",
  "ironing-1-filled",
  "ironing-2-filled",
  "ironing-3-filled",
  "ironing-steam-filled",
  "ironing-filled",
  "jetpack-filled",
  "jewish-star-filled",
  "key-filled",
  "keyboard-filled",
  "keyframe-align-center-filled",
  "keyframe-align-horizontal-filled",
  "keyframe-align-vertical-filled",
  "keyframe-filled",
  "keyframes-filled",
  "label-important-filled",
  "label-filled",
  "lasso-polygon-filled",
  "laurel-wreath-filled",
  "layout-2-filled",
  "layout-align-bottom-filled",
  "layout-align-center-filled",
  "layout-align-left-filled",
  "layout-align-middle-filled",
  "layout-align-right-filled",
  "layout-align-top-filled",
  "layout-bottombar-collapse-filled",
  "layout-bottombar-expand-filled",
  "layout-bottombar-filled",
  "layout-cards-filled",
  "layout-dashboard-filled",
  "layout-distribute-horizontal-filled",
  "layout-distribute-vertical-filled",
  "layout-grid-filled",
  "layout-kanban-filled",
  "layout-list-filled",
  "layout-navbar-collapse-filled",
  "layout-navbar-expand-filled",
  "layout-navbar-filled",
  "layout-sidebar-left-collapse-filled",
  "layout-sidebar-left-expand-filled",
  "layout-sidebar-right-collapse-filled",
  "layout-sidebar-right-expand-filled",
  "layout-sidebar-right-filled",
  "layout-sidebar-filled",
  "layout-filled",
  "lego-filled",
  "lemon-2-filled",
  "lifebuoy-filled",
  "live-photo-filled",
  "live-view-filled",
  "location-filled",
  "lock-square-rounded-filled",
  "lock-filled",
  "lungs-filled",
  "macro-filled",
  "magnet-filled",
  "mail-opened-filled",
  "mail-filled",
  "man-filled",
  "manual-gearbox-filled",
  "map-pin-filled",
  "medical-cross-filled",
  "meeple-filled",
  "melon-filled",
  "message-2-filled",
  "message-chatbot-filled",
  "message-circle-filled",
  "message-report-filled",
  "message-filled",
  "meteor-filled",
  "michelin-star-filled",
  "mickey-filled",
  "microphone-filled",
  "microwave-filled",
  "military-rank-filled",
  "milk-filled",
  "mood-angry-filled",
  "mood-confuzed-filled",
  "mood-crazy-happy-filled",
  "mood-empty-filled",
  "mood-happy-filled",
  "mood-kid-filled",
  "mood-neutral-filled",
  "mood-sad-filled",
  "mood-smile-filled",
  "mood-wrrr-filled",
  "moon-filled",
  "motorbike-filled",
  "mountain-filled",
  "mouse-filled",
  "mug-filled",
  "mushroom-filled",
  "navigation-filled",
  "nurse-filled",
  "octagon-filled",
  "oval-vertical-filled",
  "oval-filled",
  "paint-filled",
  "palette-filled",
  "panorama-horizontal-filled",
  "panorama-vertical-filled",
  "parking-circle-filled",
  "paw-filled",
  "pennant-2-filled",
  "pennant-filled",
  "pentagon-filled",
  "phone-filled",
  "photo-filled",
  "picture-in-picture-top-filled",
  "picture-in-picture-filled",
  "pig-filled",
  "pill-filled",
  "pin-filled",
  "pinned-filled",
  "pizza-filled",
  "play-card-1-filled",
  "play-card-10-filled",
  "play-card-2-filled",
  "play-card-3-filled",
  "play-card-4-filled",
  "play-card-5-filled",
  "play-card-6-filled",
  "play-card-7-filled",
  "play-card-8-filled",
  "play-card-9-filled",
  "play-card-a-filled",
  "play-card-j-filled",
  "play-card-k-filled",
  "play-card-q-filled",
  "play-card-star-filled",
  "player-eject-filled",
  "player-pause-filled",
  "player-play-filled",
  "player-record-filled",
  "player-skip-back-filled",
  "player-skip-forward-filled",
  "player-stop-filled",
  "player-track-next-filled",
  "player-track-prev-filled",
  "point-filled",
  "pointer-filled",
  "polaroid-filled",
  "poo-filled",
  "presentation-analytics-filled",
  "presentation-filled",
  "puzzle-filled",
  "quote-filled",
  "radar-filled",
  "radioactive-filled",
  "receipt-filled",
  "rectangle-vertical-filled",
  "rectangle-filled",
  "relation-many-to-many-filled",
  "relation-one-to-many-filled",
  "relation-one-to-one-filled",
  "replace-filled",
  "rollercoaster-filled",
  "rosette-discount-check-filled",
  "rosette-discount-filled",
  "rosette-filled",
  "salad-filled",
  "scuba-diving-tank-filled",
  "section-filled",
  "seedling-filled",
  "settings-filled",
  "shield-check-filled",
  "shield-checkered-filled",
  "shield-half-filled",
  "shield-lock-filled",
  "shield-filled",
  "shirt-filled",
  "shopping-cart-filled",
  "sign-left-filled",
  "sign-right-filled",
  "sitemap-filled",
  "sort-ascending-2-filled",
  "sort-ascending-shapes-filled",
  "sort-descending-2-filled",
  "sort-descending-shapes-filled",
  "soup-filled",
  "spade-filled",
  "speedboat-filled",
  "spider-filled",
  "square-arrow-down-filled",
  "square-arrow-left-filled",
  "square-arrow-right-filled",
  "square-arrow-up-filled",
  "square-asterisk-filled",
  "square-check-filled",
  "square-chevron-down-filled",
  "square-chevron-left-filled",
  "square-chevron-right-filled",
  "square-chevron-up-filled",
  "square-chevrons-down-filled",
  "square-chevrons-left-filled",
  "square-chevrons-right-filled",
  "square-chevrons-up-filled",
  "square-dot-filled",
  "square-f0-filled",
  "square-f1-filled",
  "square-f2-filled",
  "square-f3-filled",
  "square-f4-filled",
  "square-f5-filled",
  "square-f6-filled",
  "square-f7-filled",
  "square-f8-filled",
  "square-f9-filled",
  "square-letter-a-filled",
  "square-letter-b-filled",
  "square-letter-c-filled",
  "square-letter-d-filled",
  "square-letter-e-filled",
  "square-letter-f-filled",
  "square-letter-g-filled",
  "square-letter-h-filled",
  "square-letter-i-filled",
  "square-letter-j-filled",
  "square-letter-k-filled",
  "square-letter-l-filled",
  "square-letter-m-filled",
  "square-letter-n-filled",
  "square-letter-o-filled",
  "square-letter-p-filled",
  "square-letter-q-filled",
  "square-letter-r-filled",
  "square-letter-s-filled",
  "square-letter-t-filled",
  "square-letter-u-filled",
  "square-letter-v-filled",
  "square-letter-w-filled",
  "square-letter-x-filled",
  "square-letter-y-filled",
  "square-letter-z-filled",
  "square-minus-filled",
  "square-number-0-filled",
  "square-number-1-filled",
  "square-number-2-filled",
  "square-number-3-filled",
  "square-number-4-filled",
  "square-number-5-filled",
  "square-number-6-filled",
  "square-number-7-filled",
  "square-number-8-filled",
  "square-number-9-filled",
  "square-rotated-filled",
  "square-rounded-arrow-down-filled",
  "square-rounded-arrow-left-filled",
  "square-rounded-arrow-right-filled",
  "square-rounded-arrow-up-filled",
  "square-rounded-check-filled",
  "square-rounded-chevron-down-filled",
  "square-rounded-chevron-left-filled",
  "square-rounded-chevron-right-filled",
  "square-rounded-chevron-up-filled",
  "square-rounded-chevrons-down-filled",
  "square-rounded-chevrons-left-filled",
  "square-rounded-chevrons-right-filled",
  "square-rounded-chevrons-up-filled",
  "square-rounded-letter-a-filled",
  "square-rounded-letter-b-filled",
  "square-rounded-letter-c-filled",
  "square-rounded-letter-d-filled",
  "square-rounded-letter-e-filled",
  "square-rounded-letter-f-filled",
  "square-rounded-letter-g-filled",
  "square-rounded-letter-h-filled",
  "square-rounded-letter-i-filled",
  "square-rounded-letter-j-filled",
  "square-rounded-letter-k-filled",
  "square-rounded-letter-l-filled",
  "square-rounded-letter-m-filled",
  "square-rounded-letter-n-filled",
  "square-rounded-letter-o-filled",
  "square-rounded-letter-p-filled",
  "square-rounded-letter-q-filled",
  "square-rounded-letter-r-filled",
  "square-rounded-letter-s-filled",
  "square-rounded-letter-t-filled",
  "square-rounded-letter-u-filled",
  "square-rounded-letter-v-filled",
  "square-rounded-letter-w-filled",
  "square-rounded-letter-x-filled",
  "square-rounded-letter-y-filled",
  "square-rounded-letter-z-filled",
  "square-rounded-minus-filled",
  "square-rounded-number-0-filled",
  "square-rounded-number-1-filled",
  "square-rounded-number-2-filled",
  "square-rounded-number-3-filled",
  "square-rounded-number-4-filled",
  "square-rounded-number-5-filled",
  "square-rounded-number-6-filled",
  "square-rounded-number-7-filled",
  "square-rounded-number-8-filled",
  "square-rounded-number-9-filled",
  "square-rounded-plus-filled",
  "square-rounded-x-filled",
  "square-rounded-filled",
  "square-x-filled",
  "square-filled",
  "squares-filled",
  "stack-2-filled",
  "stack-3-filled",
  "stack-filled",
  "star-half-filled",
  "star-filled",
  "stars-filled",
  "steering-wheel-filled",
  "sun-high-filled",
  "sun-low-filled",
  "sun-filled",
  "sunglasses-filled",
  "sunrise-filled",
  "sunset-2-filled",
  "sunset-filled",
  "swipe-down-filled",
  "swipe-left-filled",
  "swipe-right-filled",
  "swipe-up-filled",
  "table-filled",
  "tag-filled",
  "tags-filled",
  "temperature-minus-filled",
  "temperature-plus-filled",
  "test-pipe-2-filled",
  "thumb-down-filled",
  "thumb-up-filled",
  "tilt-shift-filled",
  "timeline-event-filled",
  "toggle-left-filled",
  "toggle-right-filled",
  "train-filled",
  "transform-filled",
  "transition-bottom-filled",
  "transition-left-filled",
  "transition-right-filled",
  "transition-top-filled",
  "trash-x-filled",
  "trash-filled",
  "triangle-inverted-filled",
  "triangle-square-circle-filled",
  "triangle-filled",
  "trolley-filled",
  "trophy-filled",
  "truck-filled",
  "umbrella-filled",
  "user-filled",
  "versions-filled",
  "video-filled",
  "windmill-filled",
  "windsock-filled",
  "woman-filled",
  "xbox-a-filled",
  "xbox-b-filled",
  "xbox-x-filled",
  "xbox-y-filled",
  "yin-yang-filled",
  "zeppelin-filled",
  "zoom-cancel-filled",
  "zoom-check-filled",
  "zoom-code-filled",
  "zoom-exclamation-filled",
  "zoom-in-area-filled",
  "zoom-in-filled",
  "zoom-money-filled",
  "zoom-out-area-filled",
  "zoom-out-filled",
  "zoom-pan-filled",
  "zoom-question-filled",
  "zoom-scan-filled",
  "zoom-filled"
];

var iconsList$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: iconsList
});

var dynamicImports = {
  "a-b-2": () => Promise.resolve().then(function () { return IconAB2$1; }),
  "a-b-off": () => Promise.resolve().then(function () { return IconABOff$1; }),
  "a-b": () => Promise.resolve().then(function () { return IconAB$1; }),
  "abacus-off": () => Promise.resolve().then(function () { return IconAbacusOff$1; }),
  "abacus": () => Promise.resolve().then(function () { return IconAbacus$1; }),
  "abc": () => Promise.resolve().then(function () { return IconAbc$1; }),
  "access-point-off": () => Promise.resolve().then(function () { return IconAccessPointOff$1; }),
  "access-point": () => Promise.resolve().then(function () { return IconAccessPoint$1; }),
  "accessible-off": () => Promise.resolve().then(function () { return IconAccessibleOff$1; }),
  "accessible": () => Promise.resolve().then(function () { return IconAccessible$1; }),
  "activity-heartbeat": () => Promise.resolve().then(function () { return IconActivityHeartbeat$1; }),
  "activity": () => Promise.resolve().then(function () { return IconActivity$1; }),
  "ad-2": () => Promise.resolve().then(function () { return IconAd2$1; }),
  "ad-circle-off": () => Promise.resolve().then(function () { return IconAdCircleOff$1; }),
  "ad-circle": () => Promise.resolve().then(function () { return IconAdCircle$1; }),
  "ad-off": () => Promise.resolve().then(function () { return IconAdOff$1; }),
  "ad": () => Promise.resolve().then(function () { return IconAd$1; }),
  "address-book-off": () => Promise.resolve().then(function () { return IconAddressBookOff$1; }),
  "address-book": () => Promise.resolve().then(function () { return IconAddressBook$1; }),
  "adjustments-alt": () => Promise.resolve().then(function () { return IconAdjustmentsAlt$1; }),
  "adjustments-bolt": () => Promise.resolve().then(function () { return IconAdjustmentsBolt$1; }),
  "adjustments-cancel": () => Promise.resolve().then(function () { return IconAdjustmentsCancel$1; }),
  "adjustments-check": () => Promise.resolve().then(function () { return IconAdjustmentsCheck$1; }),
  "adjustments-code": () => Promise.resolve().then(function () { return IconAdjustmentsCode$1; }),
  "adjustments-cog": () => Promise.resolve().then(function () { return IconAdjustmentsCog$1; }),
  "adjustments-dollar": () => Promise.resolve().then(function () { return IconAdjustmentsDollar$1; }),
  "adjustments-down": () => Promise.resolve().then(function () { return IconAdjustmentsDown$1; }),
  "adjustments-exclamation": () => Promise.resolve().then(function () { return IconAdjustmentsExclamation$1; }),
  "adjustments-heart": () => Promise.resolve().then(function () { return IconAdjustmentsHeart$1; }),
  "adjustments-horizontal": () => Promise.resolve().then(function () { return IconAdjustmentsHorizontal$1; }),
  "adjustments-minus": () => Promise.resolve().then(function () { return IconAdjustmentsMinus$1; }),
  "adjustments-off": () => Promise.resolve().then(function () { return IconAdjustmentsOff$1; }),
  "adjustments-pause": () => Promise.resolve().then(function () { return IconAdjustmentsPause$1; }),
  "adjustments-pin": () => Promise.resolve().then(function () { return IconAdjustmentsPin$1; }),
  "adjustments-plus": () => Promise.resolve().then(function () { return IconAdjustmentsPlus$1; }),
  "adjustments-question": () => Promise.resolve().then(function () { return IconAdjustmentsQuestion$1; }),
  "adjustments-search": () => Promise.resolve().then(function () { return IconAdjustmentsSearch$1; }),
  "adjustments-share": () => Promise.resolve().then(function () { return IconAdjustmentsShare$1; }),
  "adjustments-spark": () => Promise.resolve().then(function () { return IconAdjustmentsSpark$1; }),
  "adjustments-star": () => Promise.resolve().then(function () { return IconAdjustmentsStar$1; }),
  "adjustments-up": () => Promise.resolve().then(function () { return IconAdjustmentsUp$1; }),
  "adjustments-x": () => Promise.resolve().then(function () { return IconAdjustmentsX$1; }),
  "adjustments": () => Promise.resolve().then(function () { return IconAdjustments$1; }),
  "aerial-lift": () => Promise.resolve().then(function () { return IconAerialLift$1; }),
  "affiliate": () => Promise.resolve().then(function () { return IconAffiliate$1; }),
  "ai": () => Promise.resolve().then(function () { return IconAi$1; }),
  "air-balloon": () => Promise.resolve().then(function () { return IconAirBalloon$1; }),
  "air-conditioning-disabled": () => Promise.resolve().then(function () { return IconAirConditioningDisabled$1; }),
  "air-conditioning": () => Promise.resolve().then(function () { return IconAirConditioning$1; }),
  "air-traffic-control": () => Promise.resolve().then(function () { return IconAirTrafficControl$1; }),
  "alarm-average": () => Promise.resolve().then(function () { return IconAlarmAverage$1; }),
  "alarm-minus": () => Promise.resolve().then(function () { return IconAlarmMinus$1; }),
  "alarm-off": () => Promise.resolve().then(function () { return IconAlarmOff$1; }),
  "alarm-plus": () => Promise.resolve().then(function () { return IconAlarmPlus$1; }),
  "alarm-smoke": () => Promise.resolve().then(function () { return IconAlarmSmoke$1; }),
  "alarm-snooze": () => Promise.resolve().then(function () { return IconAlarmSnooze$1; }),
  "alarm": () => Promise.resolve().then(function () { return IconAlarm$1; }),
  "album-off": () => Promise.resolve().then(function () { return IconAlbumOff$1; }),
  "album": () => Promise.resolve().then(function () { return IconAlbum$1; }),
  "alert-circle-off": () => Promise.resolve().then(function () { return IconAlertCircleOff$1; }),
  "alert-circle": () => Promise.resolve().then(function () { return IconAlertCircle$1; }),
  "alert-hexagon-off": () => Promise.resolve().then(function () { return IconAlertHexagonOff$1; }),
  "alert-hexagon": () => Promise.resolve().then(function () { return IconAlertHexagon$1; }),
  "alert-octagon": () => Promise.resolve().then(function () { return IconAlertOctagon$1; }),
  "alert-small-off": () => Promise.resolve().then(function () { return IconAlertSmallOff$1; }),
  "alert-small": () => Promise.resolve().then(function () { return IconAlertSmall$1; }),
  "alert-square-rounded-off": () => Promise.resolve().then(function () { return IconAlertSquareRoundedOff$1; }),
  "alert-square-rounded": () => Promise.resolve().then(function () { return IconAlertSquareRounded$1; }),
  "alert-square": () => Promise.resolve().then(function () { return IconAlertSquare$1; }),
  "alert-triangle-off": () => Promise.resolve().then(function () { return IconAlertTriangleOff$1; }),
  "alert-triangle": () => Promise.resolve().then(function () { return IconAlertTriangle$1; }),
  "alien": () => Promise.resolve().then(function () { return IconAlien$1; }),
  "align-box-bottom-center": () => Promise.resolve().then(function () { return IconAlignBoxBottomCenter$1; }),
  "align-box-bottom-left": () => Promise.resolve().then(function () { return IconAlignBoxBottomLeft$1; }),
  "align-box-bottom-right": () => Promise.resolve().then(function () { return IconAlignBoxBottomRight$1; }),
  "align-box-center-bottom": () => Promise.resolve().then(function () { return IconAlignBoxCenterBottom$1; }),
  "align-box-center-middle": () => Promise.resolve().then(function () { return IconAlignBoxCenterMiddle$1; }),
  "align-box-center-stretch": () => Promise.resolve().then(function () { return IconAlignBoxCenterStretch$1; }),
  "align-box-center-top": () => Promise.resolve().then(function () { return IconAlignBoxCenterTop$1; }),
  "align-box-left-bottom": () => Promise.resolve().then(function () { return IconAlignBoxLeftBottom$1; }),
  "align-box-left-middle": () => Promise.resolve().then(function () { return IconAlignBoxLeftMiddle$1; }),
  "align-box-left-stretch": () => Promise.resolve().then(function () { return IconAlignBoxLeftStretch$1; }),
  "align-box-left-top": () => Promise.resolve().then(function () { return IconAlignBoxLeftTop$1; }),
  "align-box-right-bottom": () => Promise.resolve().then(function () { return IconAlignBoxRightBottom$1; }),
  "align-box-right-middle": () => Promise.resolve().then(function () { return IconAlignBoxRightMiddle$1; }),
  "align-box-right-stretch": () => Promise.resolve().then(function () { return IconAlignBoxRightStretch$1; }),
  "align-box-right-top": () => Promise.resolve().then(function () { return IconAlignBoxRightTop$1; }),
  "align-box-top-center": () => Promise.resolve().then(function () { return IconAlignBoxTopCenter$1; }),
  "align-box-top-left": () => Promise.resolve().then(function () { return IconAlignBoxTopLeft$1; }),
  "align-box-top-right": () => Promise.resolve().then(function () { return IconAlignBoxTopRight$1; }),
  "align-center": () => Promise.resolve().then(function () { return IconAlignCenter$1; }),
  "align-justified": () => Promise.resolve().then(function () { return IconAlignJustified$1; }),
  "align-left-2": () => Promise.resolve().then(function () { return IconAlignLeft2$1; }),
  "align-left": () => Promise.resolve().then(function () { return IconAlignLeft$1; }),
  "align-right-2": () => Promise.resolve().then(function () { return IconAlignRight2$1; }),
  "align-right": () => Promise.resolve().then(function () { return IconAlignRight$1; }),
  "alpha": () => Promise.resolve().then(function () { return IconAlpha$1; }),
  "alphabet-arabic": () => Promise.resolve().then(function () { return IconAlphabetArabic$1; }),
  "alphabet-bangla": () => Promise.resolve().then(function () { return IconAlphabetBangla$1; }),
  "alphabet-cyrillic": () => Promise.resolve().then(function () { return IconAlphabetCyrillic$1; }),
  "alphabet-greek": () => Promise.resolve().then(function () { return IconAlphabetGreek$1; }),
  "alphabet-hebrew": () => Promise.resolve().then(function () { return IconAlphabetHebrew$1; }),
  "alphabet-korean": () => Promise.resolve().then(function () { return IconAlphabetKorean$1; }),
  "alphabet-latin": () => Promise.resolve().then(function () { return IconAlphabetLatin$1; }),
  "alphabet-thai": () => Promise.resolve().then(function () { return IconAlphabetThai$1; }),
  "alt": () => Promise.resolve().then(function () { return IconAlt$1; }),
  "ambulance": () => Promise.resolve().then(function () { return IconAmbulance$1; }),
  "ampersand": () => Promise.resolve().then(function () { return IconAmpersand$1; }),
  "analyze-off": () => Promise.resolve().then(function () { return IconAnalyzeOff$1; }),
  "analyze": () => Promise.resolve().then(function () { return IconAnalyze$1; }),
  "anchor-off": () => Promise.resolve().then(function () { return IconAnchorOff$1; }),
  "anchor": () => Promise.resolve().then(function () { return IconAnchor$1; }),
  "angle": () => Promise.resolve().then(function () { return IconAngle$1; }),
  "ankh": () => Promise.resolve().then(function () { return IconAnkh$1; }),
  "antenna-bars-1": () => Promise.resolve().then(function () { return IconAntennaBars1$1; }),
  "antenna-bars-2": () => Promise.resolve().then(function () { return IconAntennaBars2$1; }),
  "antenna-bars-3": () => Promise.resolve().then(function () { return IconAntennaBars3$1; }),
  "antenna-bars-4": () => Promise.resolve().then(function () { return IconAntennaBars4$1; }),
  "antenna-bars-5": () => Promise.resolve().then(function () { return IconAntennaBars5$1; }),
  "antenna-bars-off": () => Promise.resolve().then(function () { return IconAntennaBarsOff$1; }),
  "antenna-off": () => Promise.resolve().then(function () { return IconAntennaOff$1; }),
  "antenna": () => Promise.resolve().then(function () { return IconAntenna$1; }),
  "aperture-off": () => Promise.resolve().then(function () { return IconApertureOff$1; }),
  "aperture": () => Promise.resolve().then(function () { return IconAperture$1; }),
  "api-app-off": () => Promise.resolve().then(function () { return IconApiAppOff$1; }),
  "api-app": () => Promise.resolve().then(function () { return IconApiApp$1; }),
  "api-off": () => Promise.resolve().then(function () { return IconApiOff$1; }),
  "api": () => Promise.resolve().then(function () { return IconApi$1; }),
  "app-window": () => Promise.resolve().then(function () { return IconAppWindow$1; }),
  "apple": () => Promise.resolve().then(function () { return IconApple$1; }),
  "apps-off": () => Promise.resolve().then(function () { return IconAppsOff$1; }),
  "apps": () => Promise.resolve().then(function () { return IconApps$1; }),
  "archery-arrow": () => Promise.resolve().then(function () { return IconArcheryArrow$1; }),
  "archive-off": () => Promise.resolve().then(function () { return IconArchiveOff$1; }),
  "archive": () => Promise.resolve().then(function () { return IconArchive$1; }),
  "armchair-2-off": () => Promise.resolve().then(function () { return IconArmchair2Off$1; }),
  "armchair-2": () => Promise.resolve().then(function () { return IconArmchair2$1; }),
  "armchair-off": () => Promise.resolve().then(function () { return IconArmchairOff$1; }),
  "armchair": () => Promise.resolve().then(function () { return IconArmchair$1; }),
  "arrow-autofit-content": () => Promise.resolve().then(function () { return IconArrowAutofitContent$1; }),
  "arrow-autofit-down": () => Promise.resolve().then(function () { return IconArrowAutofitDown$1; }),
  "arrow-autofit-height": () => Promise.resolve().then(function () { return IconArrowAutofitHeight$1; }),
  "arrow-autofit-left": () => Promise.resolve().then(function () { return IconArrowAutofitLeft$1; }),
  "arrow-autofit-right": () => Promise.resolve().then(function () { return IconArrowAutofitRight$1; }),
  "arrow-autofit-up": () => Promise.resolve().then(function () { return IconArrowAutofitUp$1; }),
  "arrow-autofit-width": () => Promise.resolve().then(function () { return IconArrowAutofitWidth$1; }),
  "arrow-back-up-double": () => Promise.resolve().then(function () { return IconArrowBackUpDouble$1; }),
  "arrow-back-up": () => Promise.resolve().then(function () { return IconArrowBackUp$1; }),
  "arrow-back": () => Promise.resolve().then(function () { return IconArrowBack$1; }),
  "arrow-badge-down": () => Promise.resolve().then(function () { return IconArrowBadgeDown$1; }),
  "arrow-badge-left": () => Promise.resolve().then(function () { return IconArrowBadgeLeft$1; }),
  "arrow-badge-right": () => Promise.resolve().then(function () { return IconArrowBadgeRight$1; }),
  "arrow-badge-up": () => Promise.resolve().then(function () { return IconArrowBadgeUp$1; }),
  "arrow-bar-both": () => Promise.resolve().then(function () { return IconArrowBarBoth$1; }),
  "arrow-bar-down": () => Promise.resolve().then(function () { return IconArrowBarDown$1; }),
  "arrow-bar-left": () => Promise.resolve().then(function () { return IconArrowBarLeft$1; }),
  "arrow-bar-right": () => Promise.resolve().then(function () { return IconArrowBarRight$1; }),
  "arrow-bar-to-down": () => Promise.resolve().then(function () { return IconArrowBarToDown$1; }),
  "arrow-bar-to-left": () => Promise.resolve().then(function () { return IconArrowBarToLeft$1; }),
  "arrow-bar-to-right": () => Promise.resolve().then(function () { return IconArrowBarToRight$1; }),
  "arrow-bar-to-up": () => Promise.resolve().then(function () { return IconArrowBarToUp$1; }),
  "arrow-bar-up": () => Promise.resolve().then(function () { return IconArrowBarUp$1; }),
  "arrow-bear-left-2": () => Promise.resolve().then(function () { return IconArrowBearLeft2$1; }),
  "arrow-bear-left": () => Promise.resolve().then(function () { return IconArrowBearLeft$1; }),
  "arrow-bear-right-2": () => Promise.resolve().then(function () { return IconArrowBearRight2$1; }),
  "arrow-bear-right": () => Promise.resolve().then(function () { return IconArrowBearRight$1; }),
  "arrow-big-down-line": () => Promise.resolve().then(function () { return IconArrowBigDownLine$1; }),
  "arrow-big-down-lines": () => Promise.resolve().then(function () { return IconArrowBigDownLines$1; }),
  "arrow-big-down": () => Promise.resolve().then(function () { return IconArrowBigDown$1; }),
  "arrow-big-left-line": () => Promise.resolve().then(function () { return IconArrowBigLeftLine$1; }),
  "arrow-big-left-lines": () => Promise.resolve().then(function () { return IconArrowBigLeftLines$1; }),
  "arrow-big-left": () => Promise.resolve().then(function () { return IconArrowBigLeft$1; }),
  "arrow-big-right-line": () => Promise.resolve().then(function () { return IconArrowBigRightLine$1; }),
  "arrow-big-right-lines": () => Promise.resolve().then(function () { return IconArrowBigRightLines$1; }),
  "arrow-big-right": () => Promise.resolve().then(function () { return IconArrowBigRight$1; }),
  "arrow-big-up-line": () => Promise.resolve().then(function () { return IconArrowBigUpLine$1; }),
  "arrow-big-up-lines": () => Promise.resolve().then(function () { return IconArrowBigUpLines$1; }),
  "arrow-big-up": () => Promise.resolve().then(function () { return IconArrowBigUp$1; }),
  "arrow-bounce": () => Promise.resolve().then(function () { return IconArrowBounce$1; }),
  "arrow-capsule": () => Promise.resolve().then(function () { return IconArrowCapsule$1; }),
  "arrow-curve-left": () => Promise.resolve().then(function () { return IconArrowCurveLeft$1; }),
  "arrow-curve-right": () => Promise.resolve().then(function () { return IconArrowCurveRight$1; }),
  "arrow-down-bar": () => Promise.resolve().then(function () { return IconArrowDownBar$1; }),
  "arrow-down-circle": () => Promise.resolve().then(function () { return IconArrowDownCircle$1; }),
  "arrow-down-dashed": () => Promise.resolve().then(function () { return IconArrowDownDashed$1; }),
  "arrow-down-from-arc": () => Promise.resolve().then(function () { return IconArrowDownFromArc$1; }),
  "arrow-down-left-circle": () => Promise.resolve().then(function () { return IconArrowDownLeftCircle$1; }),
  "arrow-down-left": () => Promise.resolve().then(function () { return IconArrowDownLeft$1; }),
  "arrow-down-rhombus": () => Promise.resolve().then(function () { return IconArrowDownRhombus$1; }),
  "arrow-down-right-circle": () => Promise.resolve().then(function () { return IconArrowDownRightCircle$1; }),
  "arrow-down-right": () => Promise.resolve().then(function () { return IconArrowDownRight$1; }),
  "arrow-down-square": () => Promise.resolve().then(function () { return IconArrowDownSquare$1; }),
  "arrow-down-tail": () => Promise.resolve().then(function () { return IconArrowDownTail$1; }),
  "arrow-down-to-arc": () => Promise.resolve().then(function () { return IconArrowDownToArc$1; }),
  "arrow-down": () => Promise.resolve().then(function () { return IconArrowDown$1; }),
  "arrow-elbow-left": () => Promise.resolve().then(function () { return IconArrowElbowLeft$1; }),
  "arrow-elbow-right": () => Promise.resolve().then(function () { return IconArrowElbowRight$1; }),
  "arrow-fork": () => Promise.resolve().then(function () { return IconArrowFork$1; }),
  "arrow-forward-up-double": () => Promise.resolve().then(function () { return IconArrowForwardUpDouble$1; }),
  "arrow-forward-up": () => Promise.resolve().then(function () { return IconArrowForwardUp$1; }),
  "arrow-forward": () => Promise.resolve().then(function () { return IconArrowForward$1; }),
  "arrow-guide": () => Promise.resolve().then(function () { return IconArrowGuide$1; }),
  "arrow-iteration": () => Promise.resolve().then(function () { return IconArrowIteration$1; }),
  "arrow-left-bar": () => Promise.resolve().then(function () { return IconArrowLeftBar$1; }),
  "arrow-left-circle": () => Promise.resolve().then(function () { return IconArrowLeftCircle$1; }),
  "arrow-left-dashed": () => Promise.resolve().then(function () { return IconArrowLeftDashed$1; }),
  "arrow-left-from-arc": () => Promise.resolve().then(function () { return IconArrowLeftFromArc$1; }),
  "arrow-left-rhombus": () => Promise.resolve().then(function () { return IconArrowLeftRhombus$1; }),
  "arrow-left-right": () => Promise.resolve().then(function () { return IconArrowLeftRight$1; }),
  "arrow-left-square": () => Promise.resolve().then(function () { return IconArrowLeftSquare$1; }),
  "arrow-left-tail": () => Promise.resolve().then(function () { return IconArrowLeftTail$1; }),
  "arrow-left-to-arc": () => Promise.resolve().then(function () { return IconArrowLeftToArc$1; }),
  "arrow-left": () => Promise.resolve().then(function () { return IconArrowLeft$1; }),
  "arrow-loop-left-2": () => Promise.resolve().then(function () { return IconArrowLoopLeft2$1; }),
  "arrow-loop-left": () => Promise.resolve().then(function () { return IconArrowLoopLeft$1; }),
  "arrow-loop-right-2": () => Promise.resolve().then(function () { return IconArrowLoopRight2$1; }),
  "arrow-loop-right": () => Promise.resolve().then(function () { return IconArrowLoopRight$1; }),
  "arrow-merge-alt-left": () => Promise.resolve().then(function () { return IconArrowMergeAltLeft$1; }),
  "arrow-merge-alt-right": () => Promise.resolve().then(function () { return IconArrowMergeAltRight$1; }),
  "arrow-merge-both": () => Promise.resolve().then(function () { return IconArrowMergeBoth$1; }),
  "arrow-merge-left": () => Promise.resolve().then(function () { return IconArrowMergeLeft$1; }),
  "arrow-merge-right": () => Promise.resolve().then(function () { return IconArrowMergeRight$1; }),
  "arrow-merge": () => Promise.resolve().then(function () { return IconArrowMerge$1; }),
  "arrow-move-down": () => Promise.resolve().then(function () { return IconArrowMoveDown$1; }),
  "arrow-move-left": () => Promise.resolve().then(function () { return IconArrowMoveLeft$1; }),
  "arrow-move-right": () => Promise.resolve().then(function () { return IconArrowMoveRight$1; }),
  "arrow-move-up": () => Promise.resolve().then(function () { return IconArrowMoveUp$1; }),
  "arrow-narrow-down-dashed": () => Promise.resolve().then(function () { return IconArrowNarrowDownDashed$1; }),
  "arrow-narrow-down": () => Promise.resolve().then(function () { return IconArrowNarrowDown$1; }),
  "arrow-narrow-left-dashed": () => Promise.resolve().then(function () { return IconArrowNarrowLeftDashed$1; }),
  "arrow-narrow-left": () => Promise.resolve().then(function () { return IconArrowNarrowLeft$1; }),
  "arrow-narrow-right-dashed": () => Promise.resolve().then(function () { return IconArrowNarrowRightDashed$1; }),
  "arrow-narrow-right": () => Promise.resolve().then(function () { return IconArrowNarrowRight$1; }),
  "arrow-narrow-up-dashed": () => Promise.resolve().then(function () { return IconArrowNarrowUpDashed$1; }),
  "arrow-narrow-up": () => Promise.resolve().then(function () { return IconArrowNarrowUp$1; }),
  "arrow-ramp-left-2": () => Promise.resolve().then(function () { return IconArrowRampLeft2$1; }),
  "arrow-ramp-left-3": () => Promise.resolve().then(function () { return IconArrowRampLeft3$1; }),
  "arrow-ramp-left": () => Promise.resolve().then(function () { return IconArrowRampLeft$1; }),
  "arrow-ramp-right-2": () => Promise.resolve().then(function () { return IconArrowRampRight2$1; }),
  "arrow-ramp-right-3": () => Promise.resolve().then(function () { return IconArrowRampRight3$1; }),
  "arrow-ramp-right": () => Promise.resolve().then(function () { return IconArrowRampRight$1; }),
  "arrow-right-bar": () => Promise.resolve().then(function () { return IconArrowRightBar$1; }),
  "arrow-right-circle": () => Promise.resolve().then(function () { return IconArrowRightCircle$1; }),
  "arrow-right-dashed": () => Promise.resolve().then(function () { return IconArrowRightDashed$1; }),
  "arrow-right-from-arc": () => Promise.resolve().then(function () { return IconArrowRightFromArc$1; }),
  "arrow-right-rhombus": () => Promise.resolve().then(function () { return IconArrowRightRhombus$1; }),
  "arrow-right-square": () => Promise.resolve().then(function () { return IconArrowRightSquare$1; }),
  "arrow-right-tail": () => Promise.resolve().then(function () { return IconArrowRightTail$1; }),
  "arrow-right-to-arc": () => Promise.resolve().then(function () { return IconArrowRightToArc$1; }),
  "arrow-right": () => Promise.resolve().then(function () { return IconArrowRight$1; }),
  "arrow-rotary-first-left": () => Promise.resolve().then(function () { return IconArrowRotaryFirstLeft$1; }),
  "arrow-rotary-first-right": () => Promise.resolve().then(function () { return IconArrowRotaryFirstRight$1; }),
  "arrow-rotary-last-left": () => Promise.resolve().then(function () { return IconArrowRotaryLastLeft$1; }),
  "arrow-rotary-last-right": () => Promise.resolve().then(function () { return IconArrowRotaryLastRight$1; }),
  "arrow-rotary-left": () => Promise.resolve().then(function () { return IconArrowRotaryLeft$1; }),
  "arrow-rotary-right": () => Promise.resolve().then(function () { return IconArrowRotaryRight$1; }),
  "arrow-rotary-straight": () => Promise.resolve().then(function () { return IconArrowRotaryStraight$1; }),
  "arrow-roundabout-left": () => Promise.resolve().then(function () { return IconArrowRoundaboutLeft$1; }),
  "arrow-roundabout-right": () => Promise.resolve().then(function () { return IconArrowRoundaboutRight$1; }),
  "arrow-sharp-turn-left": () => Promise.resolve().then(function () { return IconArrowSharpTurnLeft$1; }),
  "arrow-sharp-turn-right": () => Promise.resolve().then(function () { return IconArrowSharpTurnRight$1; }),
  "arrow-up-bar": () => Promise.resolve().then(function () { return IconArrowUpBar$1; }),
  "arrow-up-circle": () => Promise.resolve().then(function () { return IconArrowUpCircle$1; }),
  "arrow-up-dashed": () => Promise.resolve().then(function () { return IconArrowUpDashed$1; }),
  "arrow-up-from-arc": () => Promise.resolve().then(function () { return IconArrowUpFromArc$1; }),
  "arrow-up-left-circle": () => Promise.resolve().then(function () { return IconArrowUpLeftCircle$1; }),
  "arrow-up-left": () => Promise.resolve().then(function () { return IconArrowUpLeft$1; }),
  "arrow-up-rhombus": () => Promise.resolve().then(function () { return IconArrowUpRhombus$1; }),
  "arrow-up-right-circle": () => Promise.resolve().then(function () { return IconArrowUpRightCircle$1; }),
  "arrow-up-right": () => Promise.resolve().then(function () { return IconArrowUpRight$1; }),
  "arrow-up-square": () => Promise.resolve().then(function () { return IconArrowUpSquare$1; }),
  "arrow-up-tail": () => Promise.resolve().then(function () { return IconArrowUpTail$1; }),
  "arrow-up-to-arc": () => Promise.resolve().then(function () { return IconArrowUpToArc$1; }),
  "arrow-up": () => Promise.resolve().then(function () { return IconArrowUp$1; }),
  "arrow-wave-left-down": () => Promise.resolve().then(function () { return IconArrowWaveLeftDown$1; }),
  "arrow-wave-left-up": () => Promise.resolve().then(function () { return IconArrowWaveLeftUp$1; }),
  "arrow-wave-right-down": () => Promise.resolve().then(function () { return IconArrowWaveRightDown$1; }),
  "arrow-wave-right-up": () => Promise.resolve().then(function () { return IconArrowWaveRightUp$1; }),
  "arrow-zig-zag": () => Promise.resolve().then(function () { return IconArrowZigZag$1; }),
  "arrows-cross": () => Promise.resolve().then(function () { return IconArrowsCross$1; }),
  "arrows-diagonal-2": () => Promise.resolve().then(function () { return IconArrowsDiagonal2$1; }),
  "arrows-diagonal-minimize-2": () => Promise.resolve().then(function () { return IconArrowsDiagonalMinimize2$1; }),
  "arrows-diagonal-minimize": () => Promise.resolve().then(function () { return IconArrowsDiagonalMinimize$1; }),
  "arrows-diagonal": () => Promise.resolve().then(function () { return IconArrowsDiagonal$1; }),
  "arrows-diff": () => Promise.resolve().then(function () { return IconArrowsDiff$1; }),
  "arrows-double-ne-sw": () => Promise.resolve().then(function () { return IconArrowsDoubleNeSw$1; }),
  "arrows-double-nw-se": () => Promise.resolve().then(function () { return IconArrowsDoubleNwSe$1; }),
  "arrows-double-se-nw": () => Promise.resolve().then(function () { return IconArrowsDoubleSeNw$1; }),
  "arrows-double-sw-ne": () => Promise.resolve().then(function () { return IconArrowsDoubleSwNe$1; }),
  "arrows-down-up": () => Promise.resolve().then(function () { return IconArrowsDownUp$1; }),
  "arrows-down": () => Promise.resolve().then(function () { return IconArrowsDown$1; }),
  "arrows-exchange-2": () => Promise.resolve().then(function () { return IconArrowsExchange2$1; }),
  "arrows-exchange": () => Promise.resolve().then(function () { return IconArrowsExchange$1; }),
  "arrows-horizontal": () => Promise.resolve().then(function () { return IconArrowsHorizontal$1; }),
  "arrows-join-2": () => Promise.resolve().then(function () { return IconArrowsJoin2$1; }),
  "arrows-join": () => Promise.resolve().then(function () { return IconArrowsJoin$1; }),
  "arrows-left-down": () => Promise.resolve().then(function () { return IconArrowsLeftDown$1; }),
  "arrows-left-right": () => Promise.resolve().then(function () { return IconArrowsLeftRight$1; }),
  "arrows-left": () => Promise.resolve().then(function () { return IconArrowsLeft$1; }),
  "arrows-maximize": () => Promise.resolve().then(function () { return IconArrowsMaximize$1; }),
  "arrows-minimize": () => Promise.resolve().then(function () { return IconArrowsMinimize$1; }),
  "arrows-move-horizontal": () => Promise.resolve().then(function () { return IconArrowsMoveHorizontal$1; }),
  "arrows-move-vertical": () => Promise.resolve().then(function () { return IconArrowsMoveVertical$1; }),
  "arrows-move": () => Promise.resolve().then(function () { return IconArrowsMove$1; }),
  "arrows-random": () => Promise.resolve().then(function () { return IconArrowsRandom$1; }),
  "arrows-right-down": () => Promise.resolve().then(function () { return IconArrowsRightDown$1; }),
  "arrows-right-left": () => Promise.resolve().then(function () { return IconArrowsRightLeft$1; }),
  "arrows-right": () => Promise.resolve().then(function () { return IconArrowsRight$1; }),
  "arrows-shuffle-2": () => Promise.resolve().then(function () { return IconArrowsShuffle2$1; }),
  "arrows-shuffle": () => Promise.resolve().then(function () { return IconArrowsShuffle$1; }),
  "arrows-sort": () => Promise.resolve().then(function () { return IconArrowsSort$1; }),
  "arrows-split-2": () => Promise.resolve().then(function () { return IconArrowsSplit2$1; }),
  "arrows-split": () => Promise.resolve().then(function () { return IconArrowsSplit$1; }),
  "arrows-transfer-down": () => Promise.resolve().then(function () { return IconArrowsTransferDown$1; }),
  "arrows-transfer-up-down": () => Promise.resolve().then(function () { return IconArrowsTransferUpDown$1; }),
  "arrows-transfer-up": () => Promise.resolve().then(function () { return IconArrowsTransferUp$1; }),
  "arrows-up-down": () => Promise.resolve().then(function () { return IconArrowsUpDown$1; }),
  "arrows-up-left": () => Promise.resolve().then(function () { return IconArrowsUpLeft$1; }),
  "arrows-up-right": () => Promise.resolve().then(function () { return IconArrowsUpRight$1; }),
  "arrows-up": () => Promise.resolve().then(function () { return IconArrowsUp$1; }),
  "arrows-vertical": () => Promise.resolve().then(function () { return IconArrowsVertical$1; }),
  "artboard-off": () => Promise.resolve().then(function () { return IconArtboardOff$1; }),
  "artboard": () => Promise.resolve().then(function () { return IconArtboard$1; }),
  "article-off": () => Promise.resolve().then(function () { return IconArticleOff$1; }),
  "article": () => Promise.resolve().then(function () { return IconArticle$1; }),
  "aspect-ratio-off": () => Promise.resolve().then(function () { return IconAspectRatioOff$1; }),
  "aspect-ratio": () => Promise.resolve().then(function () { return IconAspectRatio$1; }),
  "assembly-off": () => Promise.resolve().then(function () { return IconAssemblyOff$1; }),
  "assembly": () => Promise.resolve().then(function () { return IconAssembly$1; }),
  "asset": () => Promise.resolve().then(function () { return IconAsset$1; }),
  "asterisk-simple": () => Promise.resolve().then(function () { return IconAsteriskSimple$1; }),
  "asterisk": () => Promise.resolve().then(function () { return IconAsterisk$1; }),
  "at-off": () => Promise.resolve().then(function () { return IconAtOff$1; }),
  "at": () => Promise.resolve().then(function () { return IconAt$1; }),
  "atom-2": () => Promise.resolve().then(function () { return IconAtom2$1; }),
  "atom-off": () => Promise.resolve().then(function () { return IconAtomOff$1; }),
  "atom": () => Promise.resolve().then(function () { return IconAtom$1; }),
  "augmented-reality-2": () => Promise.resolve().then(function () { return IconAugmentedReality2$1; }),
  "augmented-reality-off": () => Promise.resolve().then(function () { return IconAugmentedRealityOff$1; }),
  "augmented-reality": () => Promise.resolve().then(function () { return IconAugmentedReality$1; }),
  "auth-2fa": () => Promise.resolve().then(function () { return IconAuth2fa$1; }),
  "automatic-gearbox": () => Promise.resolve().then(function () { return IconAutomaticGearbox$1; }),
  "automation": () => Promise.resolve().then(function () { return IconAutomation$1; }),
  "avocado": () => Promise.resolve().then(function () { return IconAvocado$1; }),
  "award-off": () => Promise.resolve().then(function () { return IconAwardOff$1; }),
  "award": () => Promise.resolve().then(function () { return IconAward$1; }),
  "axe": () => Promise.resolve().then(function () { return IconAxe$1; }),
  "axis-x": () => Promise.resolve().then(function () { return IconAxisX$1; }),
  "axis-y": () => Promise.resolve().then(function () { return IconAxisY$1; }),
  "baby-bottle": () => Promise.resolve().then(function () { return IconBabyBottle$1; }),
  "baby-carriage": () => Promise.resolve().then(function () { return IconBabyCarriage$1; }),
  "background": () => Promise.resolve().then(function () { return IconBackground$1; }),
  "backhoe": () => Promise.resolve().then(function () { return IconBackhoe$1; }),
  "backpack-off": () => Promise.resolve().then(function () { return IconBackpackOff$1; }),
  "backpack": () => Promise.resolve().then(function () { return IconBackpack$1; }),
  "backslash": () => Promise.resolve().then(function () { return IconBackslash$1; }),
  "backspace": () => Promise.resolve().then(function () { return IconBackspace$1; }),
  "badge-2k": () => Promise.resolve().then(function () { return IconBadge2k$1; }),
  "badge-3d": () => Promise.resolve().then(function () { return IconBadge3d$1; }),
  "badge-3k": () => Promise.resolve().then(function () { return IconBadge3k$1; }),
  "badge-4k": () => Promise.resolve().then(function () { return IconBadge4k$1; }),
  "badge-5k": () => Promise.resolve().then(function () { return IconBadge5k$1; }),
  "badge-8k": () => Promise.resolve().then(function () { return IconBadge8k$1; }),
  "badge-ad-off": () => Promise.resolve().then(function () { return IconBadgeAdOff$1; }),
  "badge-ad": () => Promise.resolve().then(function () { return IconBadgeAd$1; }),
  "badge-ar": () => Promise.resolve().then(function () { return IconBadgeAr$1; }),
  "badge-cc": () => Promise.resolve().then(function () { return IconBadgeCc$1; }),
  "badge-hd": () => Promise.resolve().then(function () { return IconBadgeHd$1; }),
  "badge-off": () => Promise.resolve().then(function () { return IconBadgeOff$1; }),
  "badge-sd": () => Promise.resolve().then(function () { return IconBadgeSd$1; }),
  "badge-tm": () => Promise.resolve().then(function () { return IconBadgeTm$1; }),
  "badge-vo": () => Promise.resolve().then(function () { return IconBadgeVo$1; }),
  "badge-vr": () => Promise.resolve().then(function () { return IconBadgeVr$1; }),
  "badge-wc": () => Promise.resolve().then(function () { return IconBadgeWc$1; }),
  "badge": () => Promise.resolve().then(function () { return IconBadge$1; }),
  "badges-off": () => Promise.resolve().then(function () { return IconBadgesOff$1; }),
  "badges": () => Promise.resolve().then(function () { return IconBadges$1; }),
  "baguette": () => Promise.resolve().then(function () { return IconBaguette$1; }),
  "ball-american-football-off": () => Promise.resolve().then(function () { return IconBallAmericanFootballOff$1; }),
  "ball-american-football": () => Promise.resolve().then(function () { return IconBallAmericanFootball$1; }),
  "ball-baseball": () => Promise.resolve().then(function () { return IconBallBaseball$1; }),
  "ball-basketball": () => Promise.resolve().then(function () { return IconBallBasketball$1; }),
  "ball-bowling": () => Promise.resolve().then(function () { return IconBallBowling$1; }),
  "ball-football-off": () => Promise.resolve().then(function () { return IconBallFootballOff$1; }),
  "ball-football": () => Promise.resolve().then(function () { return IconBallFootball$1; }),
  "ball-tennis": () => Promise.resolve().then(function () { return IconBallTennis$1; }),
  "ball-volleyball": () => Promise.resolve().then(function () { return IconBallVolleyball$1; }),
  "balloon-off": () => Promise.resolve().then(function () { return IconBalloonOff$1; }),
  "balloon": () => Promise.resolve().then(function () { return IconBalloon$1; }),
  "ballpen-off": () => Promise.resolve().then(function () { return IconBallpenOff$1; }),
  "ballpen": () => Promise.resolve().then(function () { return IconBallpen$1; }),
  "ban": () => Promise.resolve().then(function () { return IconBan$1; }),
  "bandage-off": () => Promise.resolve().then(function () { return IconBandageOff$1; }),
  "bandage": () => Promise.resolve().then(function () { return IconBandage$1; }),
  "barbell-off": () => Promise.resolve().then(function () { return IconBarbellOff$1; }),
  "barbell": () => Promise.resolve().then(function () { return IconBarbell$1; }),
  "barcode-off": () => Promise.resolve().then(function () { return IconBarcodeOff$1; }),
  "barcode": () => Promise.resolve().then(function () { return IconBarcode$1; }),
  "barrel-off": () => Promise.resolve().then(function () { return IconBarrelOff$1; }),
  "barrel": () => Promise.resolve().then(function () { return IconBarrel$1; }),
  "barrier-block-off": () => Promise.resolve().then(function () { return IconBarrierBlockOff$1; }),
  "barrier-block": () => Promise.resolve().then(function () { return IconBarrierBlock$1; }),
  "baseline-density-large": () => Promise.resolve().then(function () { return IconBaselineDensityLarge$1; }),
  "baseline-density-medium": () => Promise.resolve().then(function () { return IconBaselineDensityMedium$1; }),
  "baseline-density-small": () => Promise.resolve().then(function () { return IconBaselineDensitySmall$1; }),
  "baseline": () => Promise.resolve().then(function () { return IconBaseline$1; }),
  "basket-bolt": () => Promise.resolve().then(function () { return IconBasketBolt$1; }),
  "basket-cancel": () => Promise.resolve().then(function () { return IconBasketCancel$1; }),
  "basket-check": () => Promise.resolve().then(function () { return IconBasketCheck$1; }),
  "basket-code": () => Promise.resolve().then(function () { return IconBasketCode$1; }),
  "basket-cog": () => Promise.resolve().then(function () { return IconBasketCog$1; }),
  "basket-discount": () => Promise.resolve().then(function () { return IconBasketDiscount$1; }),
  "basket-dollar": () => Promise.resolve().then(function () { return IconBasketDollar$1; }),
  "basket-down": () => Promise.resolve().then(function () { return IconBasketDown$1; }),
  "basket-exclamation": () => Promise.resolve().then(function () { return IconBasketExclamation$1; }),
  "basket-heart": () => Promise.resolve().then(function () { return IconBasketHeart$1; }),
  "basket-minus": () => Promise.resolve().then(function () { return IconBasketMinus$1; }),
  "basket-off": () => Promise.resolve().then(function () { return IconBasketOff$1; }),
  "basket-pause": () => Promise.resolve().then(function () { return IconBasketPause$1; }),
  "basket-pin": () => Promise.resolve().then(function () { return IconBasketPin$1; }),
  "basket-plus": () => Promise.resolve().then(function () { return IconBasketPlus$1; }),
  "basket-question": () => Promise.resolve().then(function () { return IconBasketQuestion$1; }),
  "basket-search": () => Promise.resolve().then(function () { return IconBasketSearch$1; }),
  "basket-share": () => Promise.resolve().then(function () { return IconBasketShare$1; }),
  "basket-star": () => Promise.resolve().then(function () { return IconBasketStar$1; }),
  "basket-up": () => Promise.resolve().then(function () { return IconBasketUp$1; }),
  "basket-x": () => Promise.resolve().then(function () { return IconBasketX$1; }),
  "basket": () => Promise.resolve().then(function () { return IconBasket$1; }),
  "bat": () => Promise.resolve().then(function () { return IconBat$1; }),
  "bath-off": () => Promise.resolve().then(function () { return IconBathOff$1; }),
  "bath": () => Promise.resolve().then(function () { return IconBath$1; }),
  "battery-1": () => Promise.resolve().then(function () { return IconBattery1$1; }),
  "battery-2": () => Promise.resolve().then(function () { return IconBattery2$1; }),
  "battery-3": () => Promise.resolve().then(function () { return IconBattery3$1; }),
  "battery-4": () => Promise.resolve().then(function () { return IconBattery4$1; }),
  "battery-automotive": () => Promise.resolve().then(function () { return IconBatteryAutomotive$1; }),
  "battery-charging-2": () => Promise.resolve().then(function () { return IconBatteryCharging2$1; }),
  "battery-charging": () => Promise.resolve().then(function () { return IconBatteryCharging$1; }),
  "battery-eco": () => Promise.resolve().then(function () { return IconBatteryEco$1; }),
  "battery-exclamation": () => Promise.resolve().then(function () { return IconBatteryExclamation$1; }),
  "battery-off": () => Promise.resolve().then(function () { return IconBatteryOff$1; }),
  "battery-spark": () => Promise.resolve().then(function () { return IconBatterySpark$1; }),
  "battery-vertical-1": () => Promise.resolve().then(function () { return IconBatteryVertical1$1; }),
  "battery-vertical-2": () => Promise.resolve().then(function () { return IconBatteryVertical2$1; }),
  "battery-vertical-3": () => Promise.resolve().then(function () { return IconBatteryVertical3$1; }),
  "battery-vertical-4": () => Promise.resolve().then(function () { return IconBatteryVertical4$1; }),
  "battery-vertical-charging-2": () => Promise.resolve().then(function () { return IconBatteryVerticalCharging2$1; }),
  "battery-vertical-charging": () => Promise.resolve().then(function () { return IconBatteryVerticalCharging$1; }),
  "battery-vertical-eco": () => Promise.resolve().then(function () { return IconBatteryVerticalEco$1; }),
  "battery-vertical-exclamation": () => Promise.resolve().then(function () { return IconBatteryVerticalExclamation$1; }),
  "battery-vertical-off": () => Promise.resolve().then(function () { return IconBatteryVerticalOff$1; }),
  "battery-vertical": () => Promise.resolve().then(function () { return IconBatteryVertical$1; }),
  "battery": () => Promise.resolve().then(function () { return IconBattery$1; }),
  "beach-off": () => Promise.resolve().then(function () { return IconBeachOff$1; }),
  "beach": () => Promise.resolve().then(function () { return IconBeach$1; }),
  "bed-flat": () => Promise.resolve().then(function () { return IconBedFlat$1; }),
  "bed-off": () => Promise.resolve().then(function () { return IconBedOff$1; }),
  "bed": () => Promise.resolve().then(function () { return IconBed$1; }),
  "beer-off": () => Promise.resolve().then(function () { return IconBeerOff$1; }),
  "beer": () => Promise.resolve().then(function () { return IconBeer$1; }),
  "bell-bolt": () => Promise.resolve().then(function () { return IconBellBolt$1; }),
  "bell-cancel": () => Promise.resolve().then(function () { return IconBellCancel$1; }),
  "bell-check": () => Promise.resolve().then(function () { return IconBellCheck$1; }),
  "bell-code": () => Promise.resolve().then(function () { return IconBellCode$1; }),
  "bell-cog": () => Promise.resolve().then(function () { return IconBellCog$1; }),
  "bell-dollar": () => Promise.resolve().then(function () { return IconBellDollar$1; }),
  "bell-down": () => Promise.resolve().then(function () { return IconBellDown$1; }),
  "bell-exclamation": () => Promise.resolve().then(function () { return IconBellExclamation$1; }),
  "bell-heart": () => Promise.resolve().then(function () { return IconBellHeart$1; }),
  "bell-minus": () => Promise.resolve().then(function () { return IconBellMinus$1; }),
  "bell-off": () => Promise.resolve().then(function () { return IconBellOff$1; }),
  "bell-pause": () => Promise.resolve().then(function () { return IconBellPause$1; }),
  "bell-pin": () => Promise.resolve().then(function () { return IconBellPin$1; }),
  "bell-plus": () => Promise.resolve().then(function () { return IconBellPlus$1; }),
  "bell-question": () => Promise.resolve().then(function () { return IconBellQuestion$1; }),
  "bell-ringing-2": () => Promise.resolve().then(function () { return IconBellRinging2$1; }),
  "bell-ringing": () => Promise.resolve().then(function () { return IconBellRinging$1; }),
  "bell-school": () => Promise.resolve().then(function () { return IconBellSchool$1; }),
  "bell-search": () => Promise.resolve().then(function () { return IconBellSearch$1; }),
  "bell-share": () => Promise.resolve().then(function () { return IconBellShare$1; }),
  "bell-star": () => Promise.resolve().then(function () { return IconBellStar$1; }),
  "bell-up": () => Promise.resolve().then(function () { return IconBellUp$1; }),
  "bell-x": () => Promise.resolve().then(function () { return IconBellX$1; }),
  "bell-z": () => Promise.resolve().then(function () { return IconBellZ$1; }),
  "bell": () => Promise.resolve().then(function () { return IconBell$1; }),
  "beta": () => Promise.resolve().then(function () { return IconBeta$1; }),
  "bible": () => Promise.resolve().then(function () { return IconBible$1; }),
  "bike-off": () => Promise.resolve().then(function () { return IconBikeOff$1; }),
  "bike": () => Promise.resolve().then(function () { return IconBike$1; }),
  "binary-off": () => Promise.resolve().then(function () { return IconBinaryOff$1; }),
  "binary-tree-2": () => Promise.resolve().then(function () { return IconBinaryTree2$1; }),
  "binary-tree": () => Promise.resolve().then(function () { return IconBinaryTree$1; }),
  "binary": () => Promise.resolve().then(function () { return IconBinary$1; }),
  "binoculars": () => Promise.resolve().then(function () { return IconBinoculars$1; }),
  "biohazard-off": () => Promise.resolve().then(function () { return IconBiohazardOff$1; }),
  "biohazard": () => Promise.resolve().then(function () { return IconBiohazard$1; }),
  "blade": () => Promise.resolve().then(function () { return IconBlade$1; }),
  "bleach-chlorine": () => Promise.resolve().then(function () { return IconBleachChlorine$1; }),
  "bleach-no-chlorine": () => Promise.resolve().then(function () { return IconBleachNoChlorine$1; }),
  "bleach-off": () => Promise.resolve().then(function () { return IconBleachOff$1; }),
  "bleach": () => Promise.resolve().then(function () { return IconBleach$1; }),
  "blend-mode": () => Promise.resolve().then(function () { return IconBlendMode$1; }),
  "blender": () => Promise.resolve().then(function () { return IconBlender$1; }),
  "blob": () => Promise.resolve().then(function () { return IconBlob$1; }),
  "blockquote": () => Promise.resolve().then(function () { return IconBlockquote$1; }),
  "blocks": () => Promise.resolve().then(function () { return IconBlocks$1; }),
  "bluetooth-connected": () => Promise.resolve().then(function () { return IconBluetoothConnected$1; }),
  "bluetooth-off": () => Promise.resolve().then(function () { return IconBluetoothOff$1; }),
  "bluetooth-x": () => Promise.resolve().then(function () { return IconBluetoothX$1; }),
  "bluetooth": () => Promise.resolve().then(function () { return IconBluetooth$1; }),
  "blur-off": () => Promise.resolve().then(function () { return IconBlurOff$1; }),
  "blur": () => Promise.resolve().then(function () { return IconBlur$1; }),
  "bmp": () => Promise.resolve().then(function () { return IconBmp$1; }),
  "body-scan": () => Promise.resolve().then(function () { return IconBodyScan$1; }),
  "bold-off": () => Promise.resolve().then(function () { return IconBoldOff$1; }),
  "bold": () => Promise.resolve().then(function () { return IconBold$1; }),
  "bolt-off": () => Promise.resolve().then(function () { return IconBoltOff$1; }),
  "bolt": () => Promise.resolve().then(function () { return IconBolt$1; }),
  "bomb": () => Promise.resolve().then(function () { return IconBomb$1; }),
  "bone-off": () => Promise.resolve().then(function () { return IconBoneOff$1; }),
  "bone": () => Promise.resolve().then(function () { return IconBone$1; }),
  "bong-off": () => Promise.resolve().then(function () { return IconBongOff$1; }),
  "bong": () => Promise.resolve().then(function () { return IconBong$1; }),
  "book-2": () => Promise.resolve().then(function () { return IconBook2$1; }),
  "book-download": () => Promise.resolve().then(function () { return IconBookDownload$1; }),
  "book-off": () => Promise.resolve().then(function () { return IconBookOff$1; }),
  "book-upload": () => Promise.resolve().then(function () { return IconBookUpload$1; }),
  "book": () => Promise.resolve().then(function () { return IconBook$1; }),
  "bookmark-ai": () => Promise.resolve().then(function () { return IconBookmarkAi$1; }),
  "bookmark-edit": () => Promise.resolve().then(function () { return IconBookmarkEdit$1; }),
  "bookmark-minus": () => Promise.resolve().then(function () { return IconBookmarkMinus$1; }),
  "bookmark-off": () => Promise.resolve().then(function () { return IconBookmarkOff$1; }),
  "bookmark-plus": () => Promise.resolve().then(function () { return IconBookmarkPlus$1; }),
  "bookmark-question": () => Promise.resolve().then(function () { return IconBookmarkQuestion$1; }),
  "bookmark": () => Promise.resolve().then(function () { return IconBookmark$1; }),
  "bookmarks-off": () => Promise.resolve().then(function () { return IconBookmarksOff$1; }),
  "bookmarks": () => Promise.resolve().then(function () { return IconBookmarks$1; }),
  "books-off": () => Promise.resolve().then(function () { return IconBooksOff$1; }),
  "books": () => Promise.resolve().then(function () { return IconBooks$1; }),
  "boom": () => Promise.resolve().then(function () { return IconBoom$1; }),
  "border-all": () => Promise.resolve().then(function () { return IconBorderAll$1; }),
  "border-bottom-plus": () => Promise.resolve().then(function () { return IconBorderBottomPlus$1; }),
  "border-bottom": () => Promise.resolve().then(function () { return IconBorderBottom$1; }),
  "border-corner-ios": () => Promise.resolve().then(function () { return IconBorderCornerIos$1; }),
  "border-corner-pill": () => Promise.resolve().then(function () { return IconBorderCornerPill$1; }),
  "border-corner-rounded": () => Promise.resolve().then(function () { return IconBorderCornerRounded$1; }),
  "border-corner-square": () => Promise.resolve().then(function () { return IconBorderCornerSquare$1; }),
  "border-corners": () => Promise.resolve().then(function () { return IconBorderCorners$1; }),
  "border-horizontal": () => Promise.resolve().then(function () { return IconBorderHorizontal$1; }),
  "border-inner": () => Promise.resolve().then(function () { return IconBorderInner$1; }),
  "border-left-plus": () => Promise.resolve().then(function () { return IconBorderLeftPlus$1; }),
  "border-left": () => Promise.resolve().then(function () { return IconBorderLeft$1; }),
  "border-none": () => Promise.resolve().then(function () { return IconBorderNone$1; }),
  "border-outer": () => Promise.resolve().then(function () { return IconBorderOuter$1; }),
  "border-radius": () => Promise.resolve().then(function () { return IconBorderRadius$1; }),
  "border-right-plus": () => Promise.resolve().then(function () { return IconBorderRightPlus$1; }),
  "border-right": () => Promise.resolve().then(function () { return IconBorderRight$1; }),
  "border-sides": () => Promise.resolve().then(function () { return IconBorderSides$1; }),
  "border-style-2": () => Promise.resolve().then(function () { return IconBorderStyle2$1; }),
  "border-style": () => Promise.resolve().then(function () { return IconBorderStyle$1; }),
  "border-top-plus": () => Promise.resolve().then(function () { return IconBorderTopPlus$1; }),
  "border-top": () => Promise.resolve().then(function () { return IconBorderTop$1; }),
  "border-vertical": () => Promise.resolve().then(function () { return IconBorderVertical$1; }),
  "bottle-off": () => Promise.resolve().then(function () { return IconBottleOff$1; }),
  "bottle": () => Promise.resolve().then(function () { return IconBottle$1; }),
  "bounce-left": () => Promise.resolve().then(function () { return IconBounceLeft$1; }),
  "bounce-right": () => Promise.resolve().then(function () { return IconBounceRight$1; }),
  "bow": () => Promise.resolve().then(function () { return IconBow$1; }),
  "bowl-chopsticks": () => Promise.resolve().then(function () { return IconBowlChopsticks$1; }),
  "bowl-spoon": () => Promise.resolve().then(function () { return IconBowlSpoon$1; }),
  "bowl": () => Promise.resolve().then(function () { return IconBowl$1; }),
  "bowling": () => Promise.resolve().then(function () { return IconBowling$1; }),
  "box-align-bottom-left": () => Promise.resolve().then(function () { return IconBoxAlignBottomLeft$1; }),
  "box-align-bottom-right": () => Promise.resolve().then(function () { return IconBoxAlignBottomRight$1; }),
  "box-align-bottom": () => Promise.resolve().then(function () { return IconBoxAlignBottom$1; }),
  "box-align-left": () => Promise.resolve().then(function () { return IconBoxAlignLeft$1; }),
  "box-align-right": () => Promise.resolve().then(function () { return IconBoxAlignRight$1; }),
  "box-align-top-left": () => Promise.resolve().then(function () { return IconBoxAlignTopLeft$1; }),
  "box-align-top-right": () => Promise.resolve().then(function () { return IconBoxAlignTopRight$1; }),
  "box-align-top": () => Promise.resolve().then(function () { return IconBoxAlignTop$1; }),
  "box-margin": () => Promise.resolve().then(function () { return IconBoxMargin$1; }),
  "box-model-2-off": () => Promise.resolve().then(function () { return IconBoxModel2Off$1; }),
  "box-model-2": () => Promise.resolve().then(function () { return IconBoxModel2$1; }),
  "box-model-off": () => Promise.resolve().then(function () { return IconBoxModelOff$1; }),
  "box-model": () => Promise.resolve().then(function () { return IconBoxModel$1; }),
  "box-multiple-0": () => Promise.resolve().then(function () { return IconBoxMultiple0$1; }),
  "box-multiple-1": () => Promise.resolve().then(function () { return IconBoxMultiple1$1; }),
  "box-multiple-2": () => Promise.resolve().then(function () { return IconBoxMultiple2$1; }),
  "box-multiple-3": () => Promise.resolve().then(function () { return IconBoxMultiple3$1; }),
  "box-multiple-4": () => Promise.resolve().then(function () { return IconBoxMultiple4$1; }),
  "box-multiple-5": () => Promise.resolve().then(function () { return IconBoxMultiple5$1; }),
  "box-multiple-6": () => Promise.resolve().then(function () { return IconBoxMultiple6$1; }),
  "box-multiple-7": () => Promise.resolve().then(function () { return IconBoxMultiple7$1; }),
  "box-multiple-8": () => Promise.resolve().then(function () { return IconBoxMultiple8$1; }),
  "box-multiple-9": () => Promise.resolve().then(function () { return IconBoxMultiple9$1; }),
  "box-multiple": () => Promise.resolve().then(function () { return IconBoxMultiple$1; }),
  "box-off": () => Promise.resolve().then(function () { return IconBoxOff$1; }),
  "box-padding": () => Promise.resolve().then(function () { return IconBoxPadding$1; }),
  "box": () => Promise.resolve().then(function () { return IconBox$1; }),
  "braces-off": () => Promise.resolve().then(function () { return IconBracesOff$1; }),
  "braces": () => Promise.resolve().then(function () { return IconBraces$1; }),
  "brackets-angle-off": () => Promise.resolve().then(function () { return IconBracketsAngleOff$1; }),
  "brackets-angle": () => Promise.resolve().then(function () { return IconBracketsAngle$1; }),
  "brackets-contain-end": () => Promise.resolve().then(function () { return IconBracketsContainEnd$1; }),
  "brackets-contain-start": () => Promise.resolve().then(function () { return IconBracketsContainStart$1; }),
  "brackets-contain": () => Promise.resolve().then(function () { return IconBracketsContain$1; }),
  "brackets-off": () => Promise.resolve().then(function () { return IconBracketsOff$1; }),
  "brackets": () => Promise.resolve().then(function () { return IconBrackets$1; }),
  "braille": () => Promise.resolve().then(function () { return IconBraille$1; }),
  "brain": () => Promise.resolve().then(function () { return IconBrain$1; }),
  "brand-4chan": () => Promise.resolve().then(function () { return IconBrand4chan$1; }),
  "brand-abstract": () => Promise.resolve().then(function () { return IconBrandAbstract$1; }),
  "brand-adobe-after-effect": () => Promise.resolve().then(function () { return IconBrandAdobeAfterEffect$1; }),
  "brand-adobe-illustrator": () => Promise.resolve().then(function () { return IconBrandAdobeIllustrator$1; }),
  "brand-adobe-indesign": () => Promise.resolve().then(function () { return IconBrandAdobeIndesign$1; }),
  "brand-adobe-photoshop": () => Promise.resolve().then(function () { return IconBrandAdobePhotoshop$1; }),
  "brand-adobe-premier": () => Promise.resolve().then(function () { return IconBrandAdobePremier$1; }),
  "brand-adobe-xd": () => Promise.resolve().then(function () { return IconBrandAdobeXd$1; }),
  "brand-adobe": () => Promise.resolve().then(function () { return IconBrandAdobe$1; }),
  "brand-adonis-js": () => Promise.resolve().then(function () { return IconBrandAdonisJs$1; }),
  "brand-airbnb": () => Promise.resolve().then(function () { return IconBrandAirbnb$1; }),
  "brand-airtable": () => Promise.resolve().then(function () { return IconBrandAirtable$1; }),
  "brand-algolia": () => Promise.resolve().then(function () { return IconBrandAlgolia$1; }),
  "brand-alipay": () => Promise.resolve().then(function () { return IconBrandAlipay$1; }),
  "brand-alpine-js": () => Promise.resolve().then(function () { return IconBrandAlpineJs$1; }),
  "brand-amazon": () => Promise.resolve().then(function () { return IconBrandAmazon$1; }),
  "brand-amd": () => Promise.resolve().then(function () { return IconBrandAmd$1; }),
  "brand-amie": () => Promise.resolve().then(function () { return IconBrandAmie$1; }),
  "brand-amigo": () => Promise.resolve().then(function () { return IconBrandAmigo$1; }),
  "brand-among-us": () => Promise.resolve().then(function () { return IconBrandAmongUs$1; }),
  "brand-android": () => Promise.resolve().then(function () { return IconBrandAndroid$1; }),
  "brand-angular": () => Promise.resolve().then(function () { return IconBrandAngular$1; }),
  "brand-ansible": () => Promise.resolve().then(function () { return IconBrandAnsible$1; }),
  "brand-ao3": () => Promise.resolve().then(function () { return IconBrandAo3$1; }),
  "brand-appgallery": () => Promise.resolve().then(function () { return IconBrandAppgallery$1; }),
  "brand-apple-arcade": () => Promise.resolve().then(function () { return IconBrandAppleArcade$1; }),
  "brand-apple-news": () => Promise.resolve().then(function () { return IconBrandAppleNews$1; }),
  "brand-apple-podcast": () => Promise.resolve().then(function () { return IconBrandApplePodcast$1; }),
  "brand-apple": () => Promise.resolve().then(function () { return IconBrandApple$1; }),
  "brand-appstore": () => Promise.resolve().then(function () { return IconBrandAppstore$1; }),
  "brand-arc": () => Promise.resolve().then(function () { return IconBrandArc$1; }),
  "brand-asana": () => Promise.resolve().then(function () { return IconBrandAsana$1; }),
  "brand-astro": () => Promise.resolve().then(function () { return IconBrandAstro$1; }),
  "brand-auth0": () => Promise.resolve().then(function () { return IconBrandAuth0$1; }),
  "brand-aws": () => Promise.resolve().then(function () { return IconBrandAws$1; }),
  "brand-azure": () => Promise.resolve().then(function () { return IconBrandAzure$1; }),
  "brand-backbone": () => Promise.resolve().then(function () { return IconBrandBackbone$1; }),
  "brand-badoo": () => Promise.resolve().then(function () { return IconBrandBadoo$1; }),
  "brand-baidu": () => Promise.resolve().then(function () { return IconBrandBaidu$1; }),
  "brand-bandcamp": () => Promise.resolve().then(function () { return IconBrandBandcamp$1; }),
  "brand-bandlab": () => Promise.resolve().then(function () { return IconBrandBandlab$1; }),
  "brand-beats": () => Promise.resolve().then(function () { return IconBrandBeats$1; }),
  "brand-bebo": () => Promise.resolve().then(function () { return IconBrandBebo$1; }),
  "brand-behance": () => Promise.resolve().then(function () { return IconBrandBehance$1; }),
  "brand-bilibili": () => Promise.resolve().then(function () { return IconBrandBilibili$1; }),
  "brand-binance": () => Promise.resolve().then(function () { return IconBrandBinance$1; }),
  "brand-bing": () => Promise.resolve().then(function () { return IconBrandBing$1; }),
  "brand-bitbucket": () => Promise.resolve().then(function () { return IconBrandBitbucket$1; }),
  "brand-blackberry": () => Promise.resolve().then(function () { return IconBrandBlackberry$1; }),
  "brand-blender": () => Promise.resolve().then(function () { return IconBrandBlender$1; }),
  "brand-blogger": () => Promise.resolve().then(function () { return IconBrandBlogger$1; }),
  "brand-bluesky": () => Promise.resolve().then(function () { return IconBrandBluesky$1; }),
  "brand-booking": () => Promise.resolve().then(function () { return IconBrandBooking$1; }),
  "brand-bootstrap": () => Promise.resolve().then(function () { return IconBrandBootstrap$1; }),
  "brand-bulma": () => Promise.resolve().then(function () { return IconBrandBulma$1; }),
  "brand-bumble": () => Promise.resolve().then(function () { return IconBrandBumble$1; }),
  "brand-bunpo": () => Promise.resolve().then(function () { return IconBrandBunpo$1; }),
  "brand-c-sharp": () => Promise.resolve().then(function () { return IconBrandCSharp$1; }),
  "brand-cake": () => Promise.resolve().then(function () { return IconBrandCake$1; }),
  "brand-cakephp": () => Promise.resolve().then(function () { return IconBrandCakephp$1; }),
  "brand-campaignmonitor": () => Promise.resolve().then(function () { return IconBrandCampaignmonitor$1; }),
  "brand-carbon": () => Promise.resolve().then(function () { return IconBrandCarbon$1; }),
  "brand-cashapp": () => Promise.resolve().then(function () { return IconBrandCashapp$1; }),
  "brand-chrome": () => Promise.resolve().then(function () { return IconBrandChrome$1; }),
  "brand-cinema-4d": () => Promise.resolve().then(function () { return IconBrandCinema4d$1; }),
  "brand-citymapper": () => Promise.resolve().then(function () { return IconBrandCitymapper$1; }),
  "brand-cloudflare": () => Promise.resolve().then(function () { return IconBrandCloudflare$1; }),
  "brand-codecov": () => Promise.resolve().then(function () { return IconBrandCodecov$1; }),
  "brand-codepen": () => Promise.resolve().then(function () { return IconBrandCodepen$1; }),
  "brand-codesandbox": () => Promise.resolve().then(function () { return IconBrandCodesandbox$1; }),
  "brand-cohost": () => Promise.resolve().then(function () { return IconBrandCohost$1; }),
  "brand-coinbase": () => Promise.resolve().then(function () { return IconBrandCoinbase$1; }),
  "brand-comedy-central": () => Promise.resolve().then(function () { return IconBrandComedyCentral$1; }),
  "brand-coreos": () => Promise.resolve().then(function () { return IconBrandCoreos$1; }),
  "brand-couchdb": () => Promise.resolve().then(function () { return IconBrandCouchdb$1; }),
  "brand-couchsurfing": () => Promise.resolve().then(function () { return IconBrandCouchsurfing$1; }),
  "brand-cpp": () => Promise.resolve().then(function () { return IconBrandCpp$1; }),
  "brand-craft": () => Promise.resolve().then(function () { return IconBrandCraft$1; }),
  "brand-crunchbase": () => Promise.resolve().then(function () { return IconBrandCrunchbase$1; }),
  "brand-css3": () => Promise.resolve().then(function () { return IconBrandCss3$1; }),
  "brand-ctemplar": () => Promise.resolve().then(function () { return IconBrandCtemplar$1; }),
  "brand-cucumber": () => Promise.resolve().then(function () { return IconBrandCucumber$1; }),
  "brand-cupra": () => Promise.resolve().then(function () { return IconBrandCupra$1; }),
  "brand-cypress": () => Promise.resolve().then(function () { return IconBrandCypress$1; }),
  "brand-d3": () => Promise.resolve().then(function () { return IconBrandD3$1; }),
  "brand-databricks": () => Promise.resolve().then(function () { return IconBrandDatabricks$1; }),
  "brand-days-counter": () => Promise.resolve().then(function () { return IconBrandDaysCounter$1; }),
  "brand-dcos": () => Promise.resolve().then(function () { return IconBrandDcos$1; }),
  "brand-debian": () => Promise.resolve().then(function () { return IconBrandDebian$1; }),
  "brand-deezer": () => Promise.resolve().then(function () { return IconBrandDeezer$1; }),
  "brand-deliveroo": () => Promise.resolve().then(function () { return IconBrandDeliveroo$1; }),
  "brand-deno": () => Promise.resolve().then(function () { return IconBrandDeno$1; }),
  "brand-denodo": () => Promise.resolve().then(function () { return IconBrandDenodo$1; }),
  "brand-deviantart": () => Promise.resolve().then(function () { return IconBrandDeviantart$1; }),
  "brand-digg": () => Promise.resolve().then(function () { return IconBrandDigg$1; }),
  "brand-dingtalk": () => Promise.resolve().then(function () { return IconBrandDingtalk$1; }),
  "brand-discord": () => Promise.resolve().then(function () { return IconBrandDiscord$1; }),
  "brand-disney": () => Promise.resolve().then(function () { return IconBrandDisney$1; }),
  "brand-disqus": () => Promise.resolve().then(function () { return IconBrandDisqus$1; }),
  "brand-django": () => Promise.resolve().then(function () { return IconBrandDjango$1; }),
  "brand-docker": () => Promise.resolve().then(function () { return IconBrandDocker$1; }),
  "brand-doctrine": () => Promise.resolve().then(function () { return IconBrandDoctrine$1; }),
  "brand-dolby-digital": () => Promise.resolve().then(function () { return IconBrandDolbyDigital$1; }),
  "brand-douban": () => Promise.resolve().then(function () { return IconBrandDouban$1; }),
  "brand-dribbble": () => Promise.resolve().then(function () { return IconBrandDribbble$1; }),
  "brand-drops": () => Promise.resolve().then(function () { return IconBrandDrops$1; }),
  "brand-drupal": () => Promise.resolve().then(function () { return IconBrandDrupal$1; }),
  "brand-edge": () => Promise.resolve().then(function () { return IconBrandEdge$1; }),
  "brand-elastic": () => Promise.resolve().then(function () { return IconBrandElastic$1; }),
  "brand-electronic-arts": () => Promise.resolve().then(function () { return IconBrandElectronicArts$1; }),
  "brand-ember": () => Promise.resolve().then(function () { return IconBrandEmber$1; }),
  "brand-envato": () => Promise.resolve().then(function () { return IconBrandEnvato$1; }),
  "brand-etsy": () => Promise.resolve().then(function () { return IconBrandEtsy$1; }),
  "brand-evernote": () => Promise.resolve().then(function () { return IconBrandEvernote$1; }),
  "brand-facebook": () => Promise.resolve().then(function () { return IconBrandFacebook$1; }),
  "brand-feedly": () => Promise.resolve().then(function () { return IconBrandFeedly$1; }),
  "brand-figma": () => Promise.resolve().then(function () { return IconBrandFigma$1; }),
  "brand-filezilla": () => Promise.resolve().then(function () { return IconBrandFilezilla$1; }),
  "brand-finder": () => Promise.resolve().then(function () { return IconBrandFinder$1; }),
  "brand-firebase": () => Promise.resolve().then(function () { return IconBrandFirebase$1; }),
  "brand-firefox": () => Promise.resolve().then(function () { return IconBrandFirefox$1; }),
  "brand-fiverr": () => Promise.resolve().then(function () { return IconBrandFiverr$1; }),
  "brand-flickr": () => Promise.resolve().then(function () { return IconBrandFlickr$1; }),
  "brand-flightradar24": () => Promise.resolve().then(function () { return IconBrandFlightradar24$1; }),
  "brand-flipboard": () => Promise.resolve().then(function () { return IconBrandFlipboard$1; }),
  "brand-flutter": () => Promise.resolve().then(function () { return IconBrandFlutter$1; }),
  "brand-fortnite": () => Promise.resolve().then(function () { return IconBrandFortnite$1; }),
  "brand-foursquare": () => Promise.resolve().then(function () { return IconBrandFoursquare$1; }),
  "brand-framer-motion": () => Promise.resolve().then(function () { return IconBrandFramerMotion$1; }),
  "brand-framer": () => Promise.resolve().then(function () { return IconBrandFramer$1; }),
  "brand-funimation": () => Promise.resolve().then(function () { return IconBrandFunimation$1; }),
  "brand-gatsby": () => Promise.resolve().then(function () { return IconBrandGatsby$1; }),
  "brand-git": () => Promise.resolve().then(function () { return IconBrandGit$1; }),
  "brand-github-copilot": () => Promise.resolve().then(function () { return IconBrandGithubCopilot$1; }),
  "brand-github": () => Promise.resolve().then(function () { return IconBrandGithub$1; }),
  "brand-gitlab": () => Promise.resolve().then(function () { return IconBrandGitlab$1; }),
  "brand-gmail": () => Promise.resolve().then(function () { return IconBrandGmail$1; }),
  "brand-golang": () => Promise.resolve().then(function () { return IconBrandGolang$1; }),
  "brand-google-analytics": () => Promise.resolve().then(function () { return IconBrandGoogleAnalytics$1; }),
  "brand-google-big-query": () => Promise.resolve().then(function () { return IconBrandGoogleBigQuery$1; }),
  "brand-google-drive": () => Promise.resolve().then(function () { return IconBrandGoogleDrive$1; }),
  "brand-google-fit": () => Promise.resolve().then(function () { return IconBrandGoogleFit$1; }),
  "brand-google-home": () => Promise.resolve().then(function () { return IconBrandGoogleHome$1; }),
  "brand-google-maps": () => Promise.resolve().then(function () { return IconBrandGoogleMaps$1; }),
  "brand-google-one": () => Promise.resolve().then(function () { return IconBrandGoogleOne$1; }),
  "brand-google-photos": () => Promise.resolve().then(function () { return IconBrandGooglePhotos$1; }),
  "brand-google-play": () => Promise.resolve().then(function () { return IconBrandGooglePlay$1; }),
  "brand-google-podcasts": () => Promise.resolve().then(function () { return IconBrandGooglePodcasts$1; }),
  "brand-google": () => Promise.resolve().then(function () { return IconBrandGoogle$1; }),
  "brand-grammarly": () => Promise.resolve().then(function () { return IconBrandGrammarly$1; }),
  "brand-graphql": () => Promise.resolve().then(function () { return IconBrandGraphql$1; }),
  "brand-gravatar": () => Promise.resolve().then(function () { return IconBrandGravatar$1; }),
  "brand-grindr": () => Promise.resolve().then(function () { return IconBrandGrindr$1; }),
  "brand-guardian": () => Promise.resolve().then(function () { return IconBrandGuardian$1; }),
  "brand-gumroad": () => Promise.resolve().then(function () { return IconBrandGumroad$1; }),
  "brand-hackerrank": () => Promise.resolve().then(function () { return IconBrandHackerrank$1; }),
  "brand-hbo": () => Promise.resolve().then(function () { return IconBrandHbo$1; }),
  "brand-headlessui": () => Promise.resolve().then(function () { return IconBrandHeadlessui$1; }),
  "brand-hexo": () => Promise.resolve().then(function () { return IconBrandHexo$1; }),
  "brand-hipchat": () => Promise.resolve().then(function () { return IconBrandHipchat$1; }),
  "brand-html5": () => Promise.resolve().then(function () { return IconBrandHtml5$1; }),
  "brand-inertia": () => Promise.resolve().then(function () { return IconBrandInertia$1; }),
  "brand-instagram": () => Promise.resolve().then(function () { return IconBrandInstagram$1; }),
  "brand-intercom": () => Promise.resolve().then(function () { return IconBrandIntercom$1; }),
  "brand-itch": () => Promise.resolve().then(function () { return IconBrandItch$1; }),
  "brand-javascript": () => Promise.resolve().then(function () { return IconBrandJavascript$1; }),
  "brand-juejin": () => Promise.resolve().then(function () { return IconBrandJuejin$1; }),
  "brand-kako-talk": () => Promise.resolve().then(function () { return IconBrandKakoTalk$1; }),
  "brand-kbin": () => Promise.resolve().then(function () { return IconBrandKbin$1; }),
  "brand-kick": () => Promise.resolve().then(function () { return IconBrandKick$1; }),
  "brand-kickstarter": () => Promise.resolve().then(function () { return IconBrandKickstarter$1; }),
  "brand-kotlin": () => Promise.resolve().then(function () { return IconBrandKotlin$1; }),
  "brand-laravel": () => Promise.resolve().then(function () { return IconBrandLaravel$1; }),
  "brand-lastfm": () => Promise.resolve().then(function () { return IconBrandLastfm$1; }),
  "brand-leetcode": () => Promise.resolve().then(function () { return IconBrandLeetcode$1; }),
  "brand-letterboxd": () => Promise.resolve().then(function () { return IconBrandLetterboxd$1; }),
  "brand-line": () => Promise.resolve().then(function () { return IconBrandLine$1; }),
  "brand-linkedin": () => Promise.resolve().then(function () { return IconBrandLinkedin$1; }),
  "brand-linktree": () => Promise.resolve().then(function () { return IconBrandLinktree$1; }),
  "brand-linqpad": () => Promise.resolve().then(function () { return IconBrandLinqpad$1; }),
  "brand-livewire": () => Promise.resolve().then(function () { return IconBrandLivewire$1; }),
  "brand-loom": () => Promise.resolve().then(function () { return IconBrandLoom$1; }),
  "brand-mailgun": () => Promise.resolve().then(function () { return IconBrandMailgun$1; }),
  "brand-mantine": () => Promise.resolve().then(function () { return IconBrandMantine$1; }),
  "brand-mastercard": () => Promise.resolve().then(function () { return IconBrandMastercard$1; }),
  "brand-mastodon": () => Promise.resolve().then(function () { return IconBrandMastodon$1; }),
  "brand-matrix": () => Promise.resolve().then(function () { return IconBrandMatrix$1; }),
  "brand-mcdonalds": () => Promise.resolve().then(function () { return IconBrandMcdonalds$1; }),
  "brand-medium": () => Promise.resolve().then(function () { return IconBrandMedium$1; }),
  "brand-meetup": () => Promise.resolve().then(function () { return IconBrandMeetup$1; }),
  "brand-mercedes": () => Promise.resolve().then(function () { return IconBrandMercedes$1; }),
  "brand-messenger": () => Promise.resolve().then(function () { return IconBrandMessenger$1; }),
  "brand-meta": () => Promise.resolve().then(function () { return IconBrandMeta$1; }),
  "brand-metabrainz": () => Promise.resolve().then(function () { return IconBrandMetabrainz$1; }),
  "brand-minecraft": () => Promise.resolve().then(function () { return IconBrandMinecraft$1; }),
  "brand-miniprogram": () => Promise.resolve().then(function () { return IconBrandMiniprogram$1; }),
  "brand-mixpanel": () => Promise.resolve().then(function () { return IconBrandMixpanel$1; }),
  "brand-monday": () => Promise.resolve().then(function () { return IconBrandMonday$1; }),
  "brand-mongodb": () => Promise.resolve().then(function () { return IconBrandMongodb$1; }),
  "brand-my-oppo": () => Promise.resolve().then(function () { return IconBrandMyOppo$1; }),
  "brand-mysql": () => Promise.resolve().then(function () { return IconBrandMysql$1; }),
  "brand-national-geographic": () => Promise.resolve().then(function () { return IconBrandNationalGeographic$1; }),
  "brand-nem": () => Promise.resolve().then(function () { return IconBrandNem$1; }),
  "brand-netbeans": () => Promise.resolve().then(function () { return IconBrandNetbeans$1; }),
  "brand-netease-music": () => Promise.resolve().then(function () { return IconBrandNeteaseMusic$1; }),
  "brand-netflix": () => Promise.resolve().then(function () { return IconBrandNetflix$1; }),
  "brand-nexo": () => Promise.resolve().then(function () { return IconBrandNexo$1; }),
  "brand-nextcloud": () => Promise.resolve().then(function () { return IconBrandNextcloud$1; }),
  "brand-nextjs": () => Promise.resolve().then(function () { return IconBrandNextjs$1; }),
  "brand-nodejs": () => Promise.resolve().then(function () { return IconBrandNodejs$1; }),
  "brand-nord-vpn": () => Promise.resolve().then(function () { return IconBrandNordVpn$1; }),
  "brand-notion": () => Promise.resolve().then(function () { return IconBrandNotion$1; }),
  "brand-npm": () => Promise.resolve().then(function () { return IconBrandNpm$1; }),
  "brand-nuxt": () => Promise.resolve().then(function () { return IconBrandNuxt$1; }),
  "brand-nytimes": () => Promise.resolve().then(function () { return IconBrandNytimes$1; }),
  "brand-oauth": () => Promise.resolve().then(function () { return IconBrandOauth$1; }),
  "brand-office": () => Promise.resolve().then(function () { return IconBrandOffice$1; }),
  "brand-ok-ru": () => Promise.resolve().then(function () { return IconBrandOkRu$1; }),
  "brand-onedrive": () => Promise.resolve().then(function () { return IconBrandOnedrive$1; }),
  "brand-onlyfans": () => Promise.resolve().then(function () { return IconBrandOnlyfans$1; }),
  "brand-open-source": () => Promise.resolve().then(function () { return IconBrandOpenSource$1; }),
  "brand-openai": () => Promise.resolve().then(function () { return IconBrandOpenai$1; }),
  "brand-openvpn": () => Promise.resolve().then(function () { return IconBrandOpenvpn$1; }),
  "brand-opera": () => Promise.resolve().then(function () { return IconBrandOpera$1; }),
  "brand-pagekit": () => Promise.resolve().then(function () { return IconBrandPagekit$1; }),
  "brand-parsinta": () => Promise.resolve().then(function () { return IconBrandParsinta$1; }),
  "brand-patreon": () => Promise.resolve().then(function () { return IconBrandPatreon$1; }),
  "brand-paypal": () => Promise.resolve().then(function () { return IconBrandPaypal$1; }),
  "brand-paypay": () => Promise.resolve().then(function () { return IconBrandPaypay$1; }),
  "brand-peanut": () => Promise.resolve().then(function () { return IconBrandPeanut$1; }),
  "brand-pepsi": () => Promise.resolve().then(function () { return IconBrandPepsi$1; }),
  "brand-php": () => Promise.resolve().then(function () { return IconBrandPhp$1; }),
  "brand-picsart": () => Promise.resolve().then(function () { return IconBrandPicsart$1; }),
  "brand-pinterest": () => Promise.resolve().then(function () { return IconBrandPinterest$1; }),
  "brand-planetscale": () => Promise.resolve().then(function () { return IconBrandPlanetscale$1; }),
  "brand-pnpm": () => Promise.resolve().then(function () { return IconBrandPnpm$1; }),
  "brand-pocket": () => Promise.resolve().then(function () { return IconBrandPocket$1; }),
  "brand-polymer": () => Promise.resolve().then(function () { return IconBrandPolymer$1; }),
  "brand-powershell": () => Promise.resolve().then(function () { return IconBrandPowershell$1; }),
  "brand-printables": () => Promise.resolve().then(function () { return IconBrandPrintables$1; }),
  "brand-prisma": () => Promise.resolve().then(function () { return IconBrandPrisma$1; }),
  "brand-producthunt": () => Promise.resolve().then(function () { return IconBrandProducthunt$1; }),
  "brand-pushbullet": () => Promise.resolve().then(function () { return IconBrandPushbullet$1; }),
  "brand-pushover": () => Promise.resolve().then(function () { return IconBrandPushover$1; }),
  "brand-python": () => Promise.resolve().then(function () { return IconBrandPython$1; }),
  "brand-qq": () => Promise.resolve().then(function () { return IconBrandQq$1; }),
  "brand-radix-ui": () => Promise.resolve().then(function () { return IconBrandRadixUi$1; }),
  "brand-react-native": () => Promise.resolve().then(function () { return IconBrandReactNative$1; }),
  "brand-react": () => Promise.resolve().then(function () { return IconBrandReact$1; }),
  "brand-reason": () => Promise.resolve().then(function () { return IconBrandReason$1; }),
  "brand-reddit": () => Promise.resolve().then(function () { return IconBrandReddit$1; }),
  "brand-redhat": () => Promise.resolve().then(function () { return IconBrandRedhat$1; }),
  "brand-redux": () => Promise.resolve().then(function () { return IconBrandRedux$1; }),
  "brand-revolut": () => Promise.resolve().then(function () { return IconBrandRevolut$1; }),
  "brand-rumble": () => Promise.resolve().then(function () { return IconBrandRumble$1; }),
  "brand-rust": () => Promise.resolve().then(function () { return IconBrandRust$1; }),
  "brand-safari": () => Promise.resolve().then(function () { return IconBrandSafari$1; }),
  "brand-samsungpass": () => Promise.resolve().then(function () { return IconBrandSamsungpass$1; }),
  "brand-sass": () => Promise.resolve().then(function () { return IconBrandSass$1; }),
  "brand-sentry": () => Promise.resolve().then(function () { return IconBrandSentry$1; }),
  "brand-sharik": () => Promise.resolve().then(function () { return IconBrandSharik$1; }),
  "brand-shazam": () => Promise.resolve().then(function () { return IconBrandShazam$1; }),
  "brand-shopee": () => Promise.resolve().then(function () { return IconBrandShopee$1; }),
  "brand-sketch": () => Promise.resolve().then(function () { return IconBrandSketch$1; }),
  "brand-skype": () => Promise.resolve().then(function () { return IconBrandSkype$1; }),
  "brand-slack": () => Promise.resolve().then(function () { return IconBrandSlack$1; }),
  "brand-snapchat": () => Promise.resolve().then(function () { return IconBrandSnapchat$1; }),
  "brand-snapseed": () => Promise.resolve().then(function () { return IconBrandSnapseed$1; }),
  "brand-snowflake": () => Promise.resolve().then(function () { return IconBrandSnowflake$1; }),
  "brand-socket-io": () => Promise.resolve().then(function () { return IconBrandSocketIo$1; }),
  "brand-solidjs": () => Promise.resolve().then(function () { return IconBrandSolidjs$1; }),
  "brand-soundcloud": () => Promise.resolve().then(function () { return IconBrandSoundcloud$1; }),
  "brand-spacehey": () => Promise.resolve().then(function () { return IconBrandSpacehey$1; }),
  "brand-speedtest": () => Promise.resolve().then(function () { return IconBrandSpeedtest$1; }),
  "brand-spotify": () => Promise.resolve().then(function () { return IconBrandSpotify$1; }),
  "brand-stackoverflow": () => Promise.resolve().then(function () { return IconBrandStackoverflow$1; }),
  "brand-stackshare": () => Promise.resolve().then(function () { return IconBrandStackshare$1; }),
  "brand-steam": () => Promise.resolve().then(function () { return IconBrandSteam$1; }),
  "brand-stocktwits": () => Promise.resolve().then(function () { return IconBrandStocktwits$1; }),
  "brand-storj": () => Promise.resolve().then(function () { return IconBrandStorj$1; }),
  "brand-storybook": () => Promise.resolve().then(function () { return IconBrandStorybook$1; }),
  "brand-storytel": () => Promise.resolve().then(function () { return IconBrandStorytel$1; }),
  "brand-strava": () => Promise.resolve().then(function () { return IconBrandStrava$1; }),
  "brand-stripe": () => Promise.resolve().then(function () { return IconBrandStripe$1; }),
  "brand-sublime-text": () => Promise.resolve().then(function () { return IconBrandSublimeText$1; }),
  "brand-sugarizer": () => Promise.resolve().then(function () { return IconBrandSugarizer$1; }),
  "brand-supabase": () => Promise.resolve().then(function () { return IconBrandSupabase$1; }),
  "brand-superhuman": () => Promise.resolve().then(function () { return IconBrandSuperhuman$1; }),
  "brand-supernova": () => Promise.resolve().then(function () { return IconBrandSupernova$1; }),
  "brand-surfshark": () => Promise.resolve().then(function () { return IconBrandSurfshark$1; }),
  "brand-svelte": () => Promise.resolve().then(function () { return IconBrandSvelte$1; }),
  "brand-swift": () => Promise.resolve().then(function () { return IconBrandSwift$1; }),
  "brand-symfony": () => Promise.resolve().then(function () { return IconBrandSymfony$1; }),
  "brand-tabler": () => Promise.resolve().then(function () { return IconBrandTabler$1; }),
  "brand-tailwind": () => Promise.resolve().then(function () { return IconBrandTailwind$1; }),
  "brand-taobao": () => Promise.resolve().then(function () { return IconBrandTaobao$1; }),
  "brand-teams": () => Promise.resolve().then(function () { return IconBrandTeams$1; }),
  "brand-ted": () => Promise.resolve().then(function () { return IconBrandTed$1; }),
  "brand-telegram": () => Promise.resolve().then(function () { return IconBrandTelegram$1; }),
  "brand-terraform": () => Promise.resolve().then(function () { return IconBrandTerraform$1; }),
  "brand-tesla": () => Promise.resolve().then(function () { return IconBrandTesla$1; }),
  "brand-tether": () => Promise.resolve().then(function () { return IconBrandTether$1; }),
  "brand-thingiverse": () => Promise.resolve().then(function () { return IconBrandThingiverse$1; }),
  "brand-threads": () => Promise.resolve().then(function () { return IconBrandThreads$1; }),
  "brand-threejs": () => Promise.resolve().then(function () { return IconBrandThreejs$1; }),
  "brand-tidal": () => Promise.resolve().then(function () { return IconBrandTidal$1; }),
  "brand-tiktok": () => Promise.resolve().then(function () { return IconBrandTiktok$1; }),
  "brand-tinder": () => Promise.resolve().then(function () { return IconBrandTinder$1; }),
  "brand-topbuzz": () => Promise.resolve().then(function () { return IconBrandTopbuzz$1; }),
  "brand-torchain": () => Promise.resolve().then(function () { return IconBrandTorchain$1; }),
  "brand-toyota": () => Promise.resolve().then(function () { return IconBrandToyota$1; }),
  "brand-trello": () => Promise.resolve().then(function () { return IconBrandTrello$1; }),
  "brand-tripadvisor": () => Promise.resolve().then(function () { return IconBrandTripadvisor$1; }),
  "brand-tumblr": () => Promise.resolve().then(function () { return IconBrandTumblr$1; }),
  "brand-twilio": () => Promise.resolve().then(function () { return IconBrandTwilio$1; }),
  "brand-twitch": () => Promise.resolve().then(function () { return IconBrandTwitch$1; }),
  "brand-twitter": () => Promise.resolve().then(function () { return IconBrandTwitter$1; }),
  "brand-typescript": () => Promise.resolve().then(function () { return IconBrandTypescript$1; }),
  "brand-uber": () => Promise.resolve().then(function () { return IconBrandUber$1; }),
  "brand-ubuntu": () => Promise.resolve().then(function () { return IconBrandUbuntu$1; }),
  "brand-unity": () => Promise.resolve().then(function () { return IconBrandUnity$1; }),
  "brand-unsplash": () => Promise.resolve().then(function () { return IconBrandUnsplash$1; }),
  "brand-upwork": () => Promise.resolve().then(function () { return IconBrandUpwork$1; }),
  "brand-valorant": () => Promise.resolve().then(function () { return IconBrandValorant$1; }),
  "brand-vercel": () => Promise.resolve().then(function () { return IconBrandVercel$1; }),
  "brand-vimeo": () => Promise.resolve().then(function () { return IconBrandVimeo$1; }),
  "brand-vinted": () => Promise.resolve().then(function () { return IconBrandVinted$1; }),
  "brand-visa": () => Promise.resolve().then(function () { return IconBrandVisa$1; }),
  "brand-visual-studio": () => Promise.resolve().then(function () { return IconBrandVisualStudio$1; }),
  "brand-vite": () => Promise.resolve().then(function () { return IconBrandVite$1; }),
  "brand-vivaldi": () => Promise.resolve().then(function () { return IconBrandVivaldi$1; }),
  "brand-vk": () => Promise.resolve().then(function () { return IconBrandVk$1; }),
  "brand-vlc": () => Promise.resolve().then(function () { return IconBrandVlc$1; }),
  "brand-volkswagen": () => Promise.resolve().then(function () { return IconBrandVolkswagen$1; }),
  "brand-vsco": () => Promise.resolve().then(function () { return IconBrandVsco$1; }),
  "brand-vscode": () => Promise.resolve().then(function () { return IconBrandVscode$1; }),
  "brand-vue": () => Promise.resolve().then(function () { return IconBrandVue$1; }),
  "brand-walmart": () => Promise.resolve().then(function () { return IconBrandWalmart$1; }),
  "brand-waze": () => Promise.resolve().then(function () { return IconBrandWaze$1; }),
  "brand-webflow": () => Promise.resolve().then(function () { return IconBrandWebflow$1; }),
  "brand-wechat": () => Promise.resolve().then(function () { return IconBrandWechat$1; }),
  "brand-weibo": () => Promise.resolve().then(function () { return IconBrandWeibo$1; }),
  "brand-whatsapp": () => Promise.resolve().then(function () { return IconBrandWhatsapp$1; }),
  "brand-wikipedia": () => Promise.resolve().then(function () { return IconBrandWikipedia$1; }),
  "brand-windows": () => Promise.resolve().then(function () { return IconBrandWindows$1; }),
  "brand-windy": () => Promise.resolve().then(function () { return IconBrandWindy$1; }),
  "brand-wish": () => Promise.resolve().then(function () { return IconBrandWish$1; }),
  "brand-wix": () => Promise.resolve().then(function () { return IconBrandWix$1; }),
  "brand-wordpress": () => Promise.resolve().then(function () { return IconBrandWordpress$1; }),
  "brand-x": () => Promise.resolve().then(function () { return IconBrandX$1; }),
  "brand-xamarin": () => Promise.resolve().then(function () { return IconBrandXamarin$1; }),
  "brand-xbox": () => Promise.resolve().then(function () { return IconBrandXbox$1; }),
  "brand-xdeep": () => Promise.resolve().then(function () { return IconBrandXdeep$1; }),
  "brand-xing": () => Promise.resolve().then(function () { return IconBrandXing$1; }),
  "brand-yahoo": () => Promise.resolve().then(function () { return IconBrandYahoo$1; }),
  "brand-yandex": () => Promise.resolve().then(function () { return IconBrandYandex$1; }),
  "brand-yarn": () => Promise.resolve().then(function () { return IconBrandYarn$1; }),
  "brand-yatse": () => Promise.resolve().then(function () { return IconBrandYatse$1; }),
  "brand-ycombinator": () => Promise.resolve().then(function () { return IconBrandYcombinator$1; }),
  "brand-youtube-kids": () => Promise.resolve().then(function () { return IconBrandYoutubeKids$1; }),
  "brand-youtube": () => Promise.resolve().then(function () { return IconBrandYoutube$1; }),
  "brand-zalando": () => Promise.resolve().then(function () { return IconBrandZalando$1; }),
  "brand-zapier": () => Promise.resolve().then(function () { return IconBrandZapier$1; }),
  "brand-zeit": () => Promise.resolve().then(function () { return IconBrandZeit$1; }),
  "brand-zhihu": () => Promise.resolve().then(function () { return IconBrandZhihu$1; }),
  "brand-zoom": () => Promise.resolve().then(function () { return IconBrandZoom$1; }),
  "brand-zulip": () => Promise.resolve().then(function () { return IconBrandZulip$1; }),
  "brand-zwift": () => Promise.resolve().then(function () { return IconBrandZwift$1; }),
  "bread-off": () => Promise.resolve().then(function () { return IconBreadOff$1; }),
  "bread": () => Promise.resolve().then(function () { return IconBread$1; }),
  "briefcase-2": () => Promise.resolve().then(function () { return IconBriefcase2$1; }),
  "briefcase-off": () => Promise.resolve().then(function () { return IconBriefcaseOff$1; }),
  "briefcase": () => Promise.resolve().then(function () { return IconBriefcase$1; }),
  "brightness-2": () => Promise.resolve().then(function () { return IconBrightness2$1; }),
  "brightness-auto": () => Promise.resolve().then(function () { return IconBrightnessAuto$1; }),
  "brightness-down": () => Promise.resolve().then(function () { return IconBrightnessDown$1; }),
  "brightness-half": () => Promise.resolve().then(function () { return IconBrightnessHalf$1; }),
  "brightness-off": () => Promise.resolve().then(function () { return IconBrightnessOff$1; }),
  "brightness-up": () => Promise.resolve().then(function () { return IconBrightnessUp$1; }),
  "brightness": () => Promise.resolve().then(function () { return IconBrightness$1; }),
  "broadcast-off": () => Promise.resolve().then(function () { return IconBroadcastOff$1; }),
  "broadcast": () => Promise.resolve().then(function () { return IconBroadcast$1; }),
  "browser-check": () => Promise.resolve().then(function () { return IconBrowserCheck$1; }),
  "browser-maximize": () => Promise.resolve().then(function () { return IconBrowserMaximize$1; }),
  "browser-minus": () => Promise.resolve().then(function () { return IconBrowserMinus$1; }),
  "browser-off": () => Promise.resolve().then(function () { return IconBrowserOff$1; }),
  "browser-plus": () => Promise.resolve().then(function () { return IconBrowserPlus$1; }),
  "browser-share": () => Promise.resolve().then(function () { return IconBrowserShare$1; }),
  "browser-x": () => Promise.resolve().then(function () { return IconBrowserX$1; }),
  "browser": () => Promise.resolve().then(function () { return IconBrowser$1; }),
  "brush-off": () => Promise.resolve().then(function () { return IconBrushOff$1; }),
  "brush": () => Promise.resolve().then(function () { return IconBrush$1; }),
  "bubble-minus": () => Promise.resolve().then(function () { return IconBubbleMinus$1; }),
  "bubble-plus": () => Promise.resolve().then(function () { return IconBubblePlus$1; }),
  "bubble-tea-2": () => Promise.resolve().then(function () { return IconBubbleTea2$1; }),
  "bubble-tea": () => Promise.resolve().then(function () { return IconBubbleTea$1; }),
  "bubble-text": () => Promise.resolve().then(function () { return IconBubbleText$1; }),
  "bubble-x": () => Promise.resolve().then(function () { return IconBubbleX$1; }),
  "bubble": () => Promise.resolve().then(function () { return IconBubble$1; }),
  "bucket-droplet": () => Promise.resolve().then(function () { return IconBucketDroplet$1; }),
  "bucket-off": () => Promise.resolve().then(function () { return IconBucketOff$1; }),
  "bucket": () => Promise.resolve().then(function () { return IconBucket$1; }),
  "bug-off": () => Promise.resolve().then(function () { return IconBugOff$1; }),
  "bug": () => Promise.resolve().then(function () { return IconBug$1; }),
  "building-airport": () => Promise.resolve().then(function () { return IconBuildingAirport$1; }),
  "building-arch": () => Promise.resolve().then(function () { return IconBuildingArch$1; }),
  "building-bank": () => Promise.resolve().then(function () { return IconBuildingBank$1; }),
  "building-bridge-2": () => Promise.resolve().then(function () { return IconBuildingBridge2$1; }),
  "building-bridge": () => Promise.resolve().then(function () { return IconBuildingBridge$1; }),
  "building-broadcast-tower": () => Promise.resolve().then(function () { return IconBuildingBroadcastTower$1; }),
  "building-burj-al-arab": () => Promise.resolve().then(function () { return IconBuildingBurjAlArab$1; }),
  "building-carousel": () => Promise.resolve().then(function () { return IconBuildingCarousel$1; }),
  "building-castle": () => Promise.resolve().then(function () { return IconBuildingCastle$1; }),
  "building-church": () => Promise.resolve().then(function () { return IconBuildingChurch$1; }),
  "building-circus": () => Promise.resolve().then(function () { return IconBuildingCircus$1; }),
  "building-cog": () => Promise.resolve().then(function () { return IconBuildingCog$1; }),
  "building-community": () => Promise.resolve().then(function () { return IconBuildingCommunity$1; }),
  "building-cottage": () => Promise.resolve().then(function () { return IconBuildingCottage$1; }),
  "building-estate": () => Promise.resolve().then(function () { return IconBuildingEstate$1; }),
  "building-factory-2": () => Promise.resolve().then(function () { return IconBuildingFactory2$1; }),
  "building-factory": () => Promise.resolve().then(function () { return IconBuildingFactory$1; }),
  "building-fortress": () => Promise.resolve().then(function () { return IconBuildingFortress$1; }),
  "building-hospital": () => Promise.resolve().then(function () { return IconBuildingHospital$1; }),
  "building-lighthouse": () => Promise.resolve().then(function () { return IconBuildingLighthouse$1; }),
  "building-minus": () => Promise.resolve().then(function () { return IconBuildingMinus$1; }),
  "building-monument": () => Promise.resolve().then(function () { return IconBuildingMonument$1; }),
  "building-mosque": () => Promise.resolve().then(function () { return IconBuildingMosque$1; }),
  "building-off": () => Promise.resolve().then(function () { return IconBuildingOff$1; }),
  "building-pavilion": () => Promise.resolve().then(function () { return IconBuildingPavilion$1; }),
  "building-plus": () => Promise.resolve().then(function () { return IconBuildingPlus$1; }),
  "building-skyscraper": () => Promise.resolve().then(function () { return IconBuildingSkyscraper$1; }),
  "building-stadium": () => Promise.resolve().then(function () { return IconBuildingStadium$1; }),
  "building-store": () => Promise.resolve().then(function () { return IconBuildingStore$1; }),
  "building-tunnel": () => Promise.resolve().then(function () { return IconBuildingTunnel$1; }),
  "building-warehouse": () => Promise.resolve().then(function () { return IconBuildingWarehouse$1; }),
  "building-wind-turbine": () => Promise.resolve().then(function () { return IconBuildingWindTurbine$1; }),
  "building": () => Promise.resolve().then(function () { return IconBuilding$1; }),
  "buildings": () => Promise.resolve().then(function () { return IconBuildings$1; }),
  "bulb-off": () => Promise.resolve().then(function () { return IconBulbOff$1; }),
  "bulb": () => Promise.resolve().then(function () { return IconBulb$1; }),
  "bulldozer": () => Promise.resolve().then(function () { return IconBulldozer$1; }),
  "burger": () => Promise.resolve().then(function () { return IconBurger$1; }),
  "bus-off": () => Promise.resolve().then(function () { return IconBusOff$1; }),
  "bus-stop": () => Promise.resolve().then(function () { return IconBusStop$1; }),
  "bus": () => Promise.resolve().then(function () { return IconBus$1; }),
  "businessplan": () => Promise.resolve().then(function () { return IconBusinessplan$1; }),
  "butterfly": () => Promise.resolve().then(function () { return IconButterfly$1; }),
  "cactus-off": () => Promise.resolve().then(function () { return IconCactusOff$1; }),
  "cactus": () => Promise.resolve().then(function () { return IconCactus$1; }),
  "cake-off": () => Promise.resolve().then(function () { return IconCakeOff$1; }),
  "cake-roll": () => Promise.resolve().then(function () { return IconCakeRoll$1; }),
  "cake": () => Promise.resolve().then(function () { return IconCake$1; }),
  "calculator-off": () => Promise.resolve().then(function () { return IconCalculatorOff$1; }),
  "calculator": () => Promise.resolve().then(function () { return IconCalculator$1; }),
  "calendar-bolt": () => Promise.resolve().then(function () { return IconCalendarBolt$1; }),
  "calendar-cancel": () => Promise.resolve().then(function () { return IconCalendarCancel$1; }),
  "calendar-check": () => Promise.resolve().then(function () { return IconCalendarCheck$1; }),
  "calendar-clock": () => Promise.resolve().then(function () { return IconCalendarClock$1; }),
  "calendar-code": () => Promise.resolve().then(function () { return IconCalendarCode$1; }),
  "calendar-cog": () => Promise.resolve().then(function () { return IconCalendarCog$1; }),
  "calendar-dollar": () => Promise.resolve().then(function () { return IconCalendarDollar$1; }),
  "calendar-dot": () => Promise.resolve().then(function () { return IconCalendarDot$1; }),
  "calendar-down": () => Promise.resolve().then(function () { return IconCalendarDown$1; }),
  "calendar-due": () => Promise.resolve().then(function () { return IconCalendarDue$1; }),
  "calendar-event": () => Promise.resolve().then(function () { return IconCalendarEvent$1; }),
  "calendar-exclamation": () => Promise.resolve().then(function () { return IconCalendarExclamation$1; }),
  "calendar-heart": () => Promise.resolve().then(function () { return IconCalendarHeart$1; }),
  "calendar-minus": () => Promise.resolve().then(function () { return IconCalendarMinus$1; }),
  "calendar-month": () => Promise.resolve().then(function () { return IconCalendarMonth$1; }),
  "calendar-off": () => Promise.resolve().then(function () { return IconCalendarOff$1; }),
  "calendar-pause": () => Promise.resolve().then(function () { return IconCalendarPause$1; }),
  "calendar-pin": () => Promise.resolve().then(function () { return IconCalendarPin$1; }),
  "calendar-plus": () => Promise.resolve().then(function () { return IconCalendarPlus$1; }),
  "calendar-question": () => Promise.resolve().then(function () { return IconCalendarQuestion$1; }),
  "calendar-repeat": () => Promise.resolve().then(function () { return IconCalendarRepeat$1; }),
  "calendar-sad": () => Promise.resolve().then(function () { return IconCalendarSad$1; }),
  "calendar-search": () => Promise.resolve().then(function () { return IconCalendarSearch$1; }),
  "calendar-share": () => Promise.resolve().then(function () { return IconCalendarShare$1; }),
  "calendar-smile": () => Promise.resolve().then(function () { return IconCalendarSmile$1; }),
  "calendar-star": () => Promise.resolve().then(function () { return IconCalendarStar$1; }),
  "calendar-stats": () => Promise.resolve().then(function () { return IconCalendarStats$1; }),
  "calendar-time": () => Promise.resolve().then(function () { return IconCalendarTime$1; }),
  "calendar-up": () => Promise.resolve().then(function () { return IconCalendarUp$1; }),
  "calendar-user": () => Promise.resolve().then(function () { return IconCalendarUser$1; }),
  "calendar-week": () => Promise.resolve().then(function () { return IconCalendarWeek$1; }),
  "calendar-x": () => Promise.resolve().then(function () { return IconCalendarX$1; }),
  "calendar": () => Promise.resolve().then(function () { return IconCalendar$1; }),
  "camera-ai": () => Promise.resolve().then(function () { return IconCameraAi$1; }),
  "camera-bitcoin": () => Promise.resolve().then(function () { return IconCameraBitcoin$1; }),
  "camera-bolt": () => Promise.resolve().then(function () { return IconCameraBolt$1; }),
  "camera-cancel": () => Promise.resolve().then(function () { return IconCameraCancel$1; }),
  "camera-check": () => Promise.resolve().then(function () { return IconCameraCheck$1; }),
  "camera-code": () => Promise.resolve().then(function () { return IconCameraCode$1; }),
  "camera-cog": () => Promise.resolve().then(function () { return IconCameraCog$1; }),
  "camera-dollar": () => Promise.resolve().then(function () { return IconCameraDollar$1; }),
  "camera-down": () => Promise.resolve().then(function () { return IconCameraDown$1; }),
  "camera-exclamation": () => Promise.resolve().then(function () { return IconCameraExclamation$1; }),
  "camera-heart": () => Promise.resolve().then(function () { return IconCameraHeart$1; }),
  "camera-minus": () => Promise.resolve().then(function () { return IconCameraMinus$1; }),
  "camera-moon": () => Promise.resolve().then(function () { return IconCameraMoon$1; }),
  "camera-off": () => Promise.resolve().then(function () { return IconCameraOff$1; }),
  "camera-pause": () => Promise.resolve().then(function () { return IconCameraPause$1; }),
  "camera-pin": () => Promise.resolve().then(function () { return IconCameraPin$1; }),
  "camera-plus": () => Promise.resolve().then(function () { return IconCameraPlus$1; }),
  "camera-question": () => Promise.resolve().then(function () { return IconCameraQuestion$1; }),
  "camera-rotate": () => Promise.resolve().then(function () { return IconCameraRotate$1; }),
  "camera-search": () => Promise.resolve().then(function () { return IconCameraSearch$1; }),
  "camera-selfie": () => Promise.resolve().then(function () { return IconCameraSelfie$1; }),
  "camera-share": () => Promise.resolve().then(function () { return IconCameraShare$1; }),
  "camera-spark": () => Promise.resolve().then(function () { return IconCameraSpark$1; }),
  "camera-star": () => Promise.resolve().then(function () { return IconCameraStar$1; }),
  "camera-up": () => Promise.resolve().then(function () { return IconCameraUp$1; }),
  "camera-x": () => Promise.resolve().then(function () { return IconCameraX$1; }),
  "camera": () => Promise.resolve().then(function () { return IconCamera$1; }),
  "camper": () => Promise.resolve().then(function () { return IconCamper$1; }),
  "campfire": () => Promise.resolve().then(function () { return IconCampfire$1; }),
  "cancel": () => Promise.resolve().then(function () { return IconCancel$1; }),
  "candle": () => Promise.resolve().then(function () { return IconCandle$1; }),
  "candy-off": () => Promise.resolve().then(function () { return IconCandyOff$1; }),
  "candy": () => Promise.resolve().then(function () { return IconCandy$1; }),
  "cane": () => Promise.resolve().then(function () { return IconCane$1; }),
  "cannabis": () => Promise.resolve().then(function () { return IconCannabis$1; }),
  "cap-projecting": () => Promise.resolve().then(function () { return IconCapProjecting$1; }),
  "cap-rounded": () => Promise.resolve().then(function () { return IconCapRounded$1; }),
  "cap-straight": () => Promise.resolve().then(function () { return IconCapStraight$1; }),
  "capsule-horizontal": () => Promise.resolve().then(function () { return IconCapsuleHorizontal$1; }),
  "capsule": () => Promise.resolve().then(function () { return IconCapsule$1; }),
  "capture-off": () => Promise.resolve().then(function () { return IconCaptureOff$1; }),
  "capture": () => Promise.resolve().then(function () { return IconCapture$1; }),
  "car-4wd": () => Promise.resolve().then(function () { return IconCar4wd$1; }),
  "car-crane": () => Promise.resolve().then(function () { return IconCarCrane$1; }),
  "car-crash": () => Promise.resolve().then(function () { return IconCarCrash$1; }),
  "car-fan-1": () => Promise.resolve().then(function () { return IconCarFan1$1; }),
  "car-fan-2": () => Promise.resolve().then(function () { return IconCarFan2$1; }),
  "car-fan-3": () => Promise.resolve().then(function () { return IconCarFan3$1; }),
  "car-fan-auto": () => Promise.resolve().then(function () { return IconCarFanAuto$1; }),
  "car-fan": () => Promise.resolve().then(function () { return IconCarFan$1; }),
  "car-garage": () => Promise.resolve().then(function () { return IconCarGarage$1; }),
  "car-off": () => Promise.resolve().then(function () { return IconCarOff$1; }),
  "car-suv": () => Promise.resolve().then(function () { return IconCarSuv$1; }),
  "car-turbine": () => Promise.resolve().then(function () { return IconCarTurbine$1; }),
  "car": () => Promise.resolve().then(function () { return IconCar$1; }),
  "carambola": () => Promise.resolve().then(function () { return IconCarambola$1; }),
  "caravan": () => Promise.resolve().then(function () { return IconCaravan$1; }),
  "cardboards-off": () => Promise.resolve().then(function () { return IconCardboardsOff$1; }),
  "cardboards": () => Promise.resolve().then(function () { return IconCardboards$1; }),
  "cards": () => Promise.resolve().then(function () { return IconCards$1; }),
  "caret-down": () => Promise.resolve().then(function () { return IconCaretDown$1; }),
  "caret-left-right": () => Promise.resolve().then(function () { return IconCaretLeftRight$1; }),
  "caret-left": () => Promise.resolve().then(function () { return IconCaretLeft$1; }),
  "caret-right": () => Promise.resolve().then(function () { return IconCaretRight$1; }),
  "caret-up-down": () => Promise.resolve().then(function () { return IconCaretUpDown$1; }),
  "caret-up": () => Promise.resolve().then(function () { return IconCaretUp$1; }),
  "carousel-horizontal": () => Promise.resolve().then(function () { return IconCarouselHorizontal$1; }),
  "carousel-vertical": () => Promise.resolve().then(function () { return IconCarouselVertical$1; }),
  "carrot-off": () => Promise.resolve().then(function () { return IconCarrotOff$1; }),
  "carrot": () => Promise.resolve().then(function () { return IconCarrot$1; }),
  "cash-banknote-edit": () => Promise.resolve().then(function () { return IconCashBanknoteEdit$1; }),
  "cash-banknote-heart": () => Promise.resolve().then(function () { return IconCashBanknoteHeart$1; }),
  "cash-banknote-minus": () => Promise.resolve().then(function () { return IconCashBanknoteMinus$1; }),
  "cash-banknote-move-back": () => Promise.resolve().then(function () { return IconCashBanknoteMoveBack$1; }),
  "cash-banknote-move": () => Promise.resolve().then(function () { return IconCashBanknoteMove$1; }),
  "cash-banknote-off": () => Promise.resolve().then(function () { return IconCashBanknoteOff$1; }),
  "cash-banknote-plus": () => Promise.resolve().then(function () { return IconCashBanknotePlus$1; }),
  "cash-banknote": () => Promise.resolve().then(function () { return IconCashBanknote$1; }),
  "cash-edit": () => Promise.resolve().then(function () { return IconCashEdit$1; }),
  "cash-heart": () => Promise.resolve().then(function () { return IconCashHeart$1; }),
  "cash-minus": () => Promise.resolve().then(function () { return IconCashMinus$1; }),
  "cash-move-back": () => Promise.resolve().then(function () { return IconCashMoveBack$1; }),
  "cash-move": () => Promise.resolve().then(function () { return IconCashMove$1; }),
  "cash-off": () => Promise.resolve().then(function () { return IconCashOff$1; }),
  "cash-plus": () => Promise.resolve().then(function () { return IconCashPlus$1; }),
  "cash-register": () => Promise.resolve().then(function () { return IconCashRegister$1; }),
  "cash": () => Promise.resolve().then(function () { return IconCash$1; }),
  "cast-off": () => Promise.resolve().then(function () { return IconCastOff$1; }),
  "cast": () => Promise.resolve().then(function () { return IconCast$1; }),
  "cat": () => Promise.resolve().then(function () { return IconCat$1; }),
  "category-2": () => Promise.resolve().then(function () { return IconCategory2$1; }),
  "category-minus": () => Promise.resolve().then(function () { return IconCategoryMinus$1; }),
  "category-plus": () => Promise.resolve().then(function () { return IconCategoryPlus$1; }),
  "category": () => Promise.resolve().then(function () { return IconCategory$1; }),
  "ce-off": () => Promise.resolve().then(function () { return IconCeOff$1; }),
  "ce": () => Promise.resolve().then(function () { return IconCe$1; }),
  "cell-signal-1": () => Promise.resolve().then(function () { return IconCellSignal1$1; }),
  "cell-signal-2": () => Promise.resolve().then(function () { return IconCellSignal2$1; }),
  "cell-signal-3": () => Promise.resolve().then(function () { return IconCellSignal3$1; }),
  "cell-signal-4": () => Promise.resolve().then(function () { return IconCellSignal4$1; }),
  "cell-signal-5": () => Promise.resolve().then(function () { return IconCellSignal5$1; }),
  "cell-signal-off": () => Promise.resolve().then(function () { return IconCellSignalOff$1; }),
  "cell": () => Promise.resolve().then(function () { return IconCell$1; }),
  "certificate-2-off": () => Promise.resolve().then(function () { return IconCertificate2Off$1; }),
  "certificate-2": () => Promise.resolve().then(function () { return IconCertificate2$1; }),
  "certificate-off": () => Promise.resolve().then(function () { return IconCertificateOff$1; }),
  "certificate": () => Promise.resolve().then(function () { return IconCertificate$1; }),
  "chair-director": () => Promise.resolve().then(function () { return IconChairDirector$1; }),
  "chalkboard-off": () => Promise.resolve().then(function () { return IconChalkboardOff$1; }),
  "chalkboard": () => Promise.resolve().then(function () { return IconChalkboard$1; }),
  "charging-pile": () => Promise.resolve().then(function () { return IconChargingPile$1; }),
  "chart-arcs-3": () => Promise.resolve().then(function () { return IconChartArcs3$1; }),
  "chart-arcs": () => Promise.resolve().then(function () { return IconChartArcs$1; }),
  "chart-area-line": () => Promise.resolve().then(function () { return IconChartAreaLine$1; }),
  "chart-area": () => Promise.resolve().then(function () { return IconChartArea$1; }),
  "chart-arrows-vertical": () => Promise.resolve().then(function () { return IconChartArrowsVertical$1; }),
  "chart-arrows": () => Promise.resolve().then(function () { return IconChartArrows$1; }),
  "chart-bar-off": () => Promise.resolve().then(function () { return IconChartBarOff$1; }),
  "chart-bar-popular": () => Promise.resolve().then(function () { return IconChartBarPopular$1; }),
  "chart-bar": () => Promise.resolve().then(function () { return IconChartBar$1; }),
  "chart-bubble": () => Promise.resolve().then(function () { return IconChartBubble$1; }),
  "chart-candle": () => Promise.resolve().then(function () { return IconChartCandle$1; }),
  "chart-circles": () => Promise.resolve().then(function () { return IconChartCircles$1; }),
  "chart-cohort": () => Promise.resolve().then(function () { return IconChartCohort$1; }),
  "chart-column": () => Promise.resolve().then(function () { return IconChartColumn$1; }),
  "chart-covariate": () => Promise.resolve().then(function () { return IconChartCovariate$1; }),
  "chart-donut-2": () => Promise.resolve().then(function () { return IconChartDonut2$1; }),
  "chart-donut-3": () => Promise.resolve().then(function () { return IconChartDonut3$1; }),
  "chart-donut-4": () => Promise.resolve().then(function () { return IconChartDonut4$1; }),
  "chart-donut": () => Promise.resolve().then(function () { return IconChartDonut$1; }),
  "chart-dots-2": () => Promise.resolve().then(function () { return IconChartDots2$1; }),
  "chart-dots-3": () => Promise.resolve().then(function () { return IconChartDots3$1; }),
  "chart-dots": () => Promise.resolve().then(function () { return IconChartDots$1; }),
  "chart-funnel": () => Promise.resolve().then(function () { return IconChartFunnel$1; }),
  "chart-grid-dots": () => Promise.resolve().then(function () { return IconChartGridDots$1; }),
  "chart-histogram": () => Promise.resolve().then(function () { return IconChartHistogram$1; }),
  "chart-infographic": () => Promise.resolve().then(function () { return IconChartInfographic$1; }),
  "chart-line": () => Promise.resolve().then(function () { return IconChartLine$1; }),
  "chart-pie-2": () => Promise.resolve().then(function () { return IconChartPie2$1; }),
  "chart-pie-3": () => Promise.resolve().then(function () { return IconChartPie3$1; }),
  "chart-pie-4": () => Promise.resolve().then(function () { return IconChartPie4$1; }),
  "chart-pie-off": () => Promise.resolve().then(function () { return IconChartPieOff$1; }),
  "chart-pie": () => Promise.resolve().then(function () { return IconChartPie$1; }),
  "chart-ppf": () => Promise.resolve().then(function () { return IconChartPpf$1; }),
  "chart-radar": () => Promise.resolve().then(function () { return IconChartRadar$1; }),
  "chart-sankey": () => Promise.resolve().then(function () { return IconChartSankey$1; }),
  "chart-scatter-3d": () => Promise.resolve().then(function () { return IconChartScatter3d$1; }),
  "chart-scatter": () => Promise.resolve().then(function () { return IconChartScatter$1; }),
  "chart-treemap": () => Promise.resolve().then(function () { return IconChartTreemap$1; }),
  "check": () => Promise.resolve().then(function () { return IconCheck$1; }),
  "checkbox": () => Promise.resolve().then(function () { return IconCheckbox$1; }),
  "checklist": () => Promise.resolve().then(function () { return IconChecklist$1; }),
  "checks": () => Promise.resolve().then(function () { return IconChecks$1; }),
  "checkup-list": () => Promise.resolve().then(function () { return IconCheckupList$1; }),
  "cheese": () => Promise.resolve().then(function () { return IconCheese$1; }),
  "chef-hat-off": () => Promise.resolve().then(function () { return IconChefHatOff$1; }),
  "chef-hat": () => Promise.resolve().then(function () { return IconChefHat$1; }),
  "cherry": () => Promise.resolve().then(function () { return IconCherry$1; }),
  "chess-bishop": () => Promise.resolve().then(function () { return IconChessBishop$1; }),
  "chess-king": () => Promise.resolve().then(function () { return IconChessKing$1; }),
  "chess-knight": () => Promise.resolve().then(function () { return IconChessKnight$1; }),
  "chess-queen": () => Promise.resolve().then(function () { return IconChessQueen$1; }),
  "chess-rook": () => Promise.resolve().then(function () { return IconChessRook$1; }),
  "chess": () => Promise.resolve().then(function () { return IconChess$1; }),
  "chevron-compact-down": () => Promise.resolve().then(function () { return IconChevronCompactDown$1; }),
  "chevron-compact-left": () => Promise.resolve().then(function () { return IconChevronCompactLeft$1; }),
  "chevron-compact-right": () => Promise.resolve().then(function () { return IconChevronCompactRight$1; }),
  "chevron-compact-up": () => Promise.resolve().then(function () { return IconChevronCompactUp$1; }),
  "chevron-down-left": () => Promise.resolve().then(function () { return IconChevronDownLeft$1; }),
  "chevron-down-right": () => Promise.resolve().then(function () { return IconChevronDownRight$1; }),
  "chevron-down": () => Promise.resolve().then(function () { return IconChevronDown$1; }),
  "chevron-left-pipe": () => Promise.resolve().then(function () { return IconChevronLeftPipe$1; }),
  "chevron-left": () => Promise.resolve().then(function () { return IconChevronLeft$1; }),
  "chevron-right-pipe": () => Promise.resolve().then(function () { return IconChevronRightPipe$1; }),
  "chevron-right": () => Promise.resolve().then(function () { return IconChevronRight$1; }),
  "chevron-up-left": () => Promise.resolve().then(function () { return IconChevronUpLeft$1; }),
  "chevron-up-right": () => Promise.resolve().then(function () { return IconChevronUpRight$1; }),
  "chevron-up": () => Promise.resolve().then(function () { return IconChevronUp$1; }),
  "chevrons-down-left": () => Promise.resolve().then(function () { return IconChevronsDownLeft$1; }),
  "chevrons-down-right": () => Promise.resolve().then(function () { return IconChevronsDownRight$1; }),
  "chevrons-down": () => Promise.resolve().then(function () { return IconChevronsDown$1; }),
  "chevrons-left": () => Promise.resolve().then(function () { return IconChevronsLeft$1; }),
  "chevrons-right": () => Promise.resolve().then(function () { return IconChevronsRight$1; }),
  "chevrons-up-left": () => Promise.resolve().then(function () { return IconChevronsUpLeft$1; }),
  "chevrons-up-right": () => Promise.resolve().then(function () { return IconChevronsUpRight$1; }),
  "chevrons-up": () => Promise.resolve().then(function () { return IconChevronsUp$1; }),
  "chisel": () => Promise.resolve().then(function () { return IconChisel$1; }),
  "christmas-ball": () => Promise.resolve().then(function () { return IconChristmasBall$1; }),
  "christmas-tree-off": () => Promise.resolve().then(function () { return IconChristmasTreeOff$1; }),
  "christmas-tree": () => Promise.resolve().then(function () { return IconChristmasTree$1; }),
  "circle-arrow-down-left": () => Promise.resolve().then(function () { return IconCircleArrowDownLeft$1; }),
  "circle-arrow-down-right": () => Promise.resolve().then(function () { return IconCircleArrowDownRight$1; }),
  "circle-arrow-down": () => Promise.resolve().then(function () { return IconCircleArrowDown$1; }),
  "circle-arrow-left": () => Promise.resolve().then(function () { return IconCircleArrowLeft$1; }),
  "circle-arrow-right": () => Promise.resolve().then(function () { return IconCircleArrowRight$1; }),
  "circle-arrow-up-left": () => Promise.resolve().then(function () { return IconCircleArrowUpLeft$1; }),
  "circle-arrow-up-right": () => Promise.resolve().then(function () { return IconCircleArrowUpRight$1; }),
  "circle-arrow-up": () => Promise.resolve().then(function () { return IconCircleArrowUp$1; }),
  "circle-caret-down": () => Promise.resolve().then(function () { return IconCircleCaretDown$1; }),
  "circle-caret-left": () => Promise.resolve().then(function () { return IconCircleCaretLeft$1; }),
  "circle-caret-right": () => Promise.resolve().then(function () { return IconCircleCaretRight$1; }),
  "circle-caret-up": () => Promise.resolve().then(function () { return IconCircleCaretUp$1; }),
  "circle-check": () => Promise.resolve().then(function () { return IconCircleCheck$1; }),
  "circle-chevron-down": () => Promise.resolve().then(function () { return IconCircleChevronDown$1; }),
  "circle-chevron-left": () => Promise.resolve().then(function () { return IconCircleChevronLeft$1; }),
  "circle-chevron-right": () => Promise.resolve().then(function () { return IconCircleChevronRight$1; }),
  "circle-chevron-up": () => Promise.resolve().then(function () { return IconCircleChevronUp$1; }),
  "circle-chevrons-down": () => Promise.resolve().then(function () { return IconCircleChevronsDown$1; }),
  "circle-chevrons-left": () => Promise.resolve().then(function () { return IconCircleChevronsLeft$1; }),
  "circle-chevrons-right": () => Promise.resolve().then(function () { return IconCircleChevronsRight$1; }),
  "circle-chevrons-up": () => Promise.resolve().then(function () { return IconCircleChevronsUp$1; }),
  "circle-dashed-check": () => Promise.resolve().then(function () { return IconCircleDashedCheck$1; }),
  "circle-dashed-letter-a": () => Promise.resolve().then(function () { return IconCircleDashedLetterA$1; }),
  "circle-dashed-letter-b": () => Promise.resolve().then(function () { return IconCircleDashedLetterB$1; }),
  "circle-dashed-letter-c": () => Promise.resolve().then(function () { return IconCircleDashedLetterC$1; }),
  "circle-dashed-letter-d": () => Promise.resolve().then(function () { return IconCircleDashedLetterD$1; }),
  "circle-dashed-letter-e": () => Promise.resolve().then(function () { return IconCircleDashedLetterE$1; }),
  "circle-dashed-letter-f": () => Promise.resolve().then(function () { return IconCircleDashedLetterF$1; }),
  "circle-dashed-letter-g": () => Promise.resolve().then(function () { return IconCircleDashedLetterG$1; }),
  "circle-dashed-letter-h": () => Promise.resolve().then(function () { return IconCircleDashedLetterH$1; }),
  "circle-dashed-letter-i": () => Promise.resolve().then(function () { return IconCircleDashedLetterI$1; }),
  "circle-dashed-letter-j": () => Promise.resolve().then(function () { return IconCircleDashedLetterJ$1; }),
  "circle-dashed-letter-k": () => Promise.resolve().then(function () { return IconCircleDashedLetterK$1; }),
  "circle-dashed-letter-l": () => Promise.resolve().then(function () { return IconCircleDashedLetterL$1; }),
  "circle-dashed-letter-m": () => Promise.resolve().then(function () { return IconCircleDashedLetterM$1; }),
  "circle-dashed-letter-n": () => Promise.resolve().then(function () { return IconCircleDashedLetterN$1; }),
  "circle-dashed-letter-o": () => Promise.resolve().then(function () { return IconCircleDashedLetterO$1; }),
  "circle-dashed-letter-p": () => Promise.resolve().then(function () { return IconCircleDashedLetterP$1; }),
  "circle-dashed-letter-q": () => Promise.resolve().then(function () { return IconCircleDashedLetterQ$1; }),
  "circle-dashed-letter-r": () => Promise.resolve().then(function () { return IconCircleDashedLetterR$1; }),
  "circle-dashed-letter-s": () => Promise.resolve().then(function () { return IconCircleDashedLetterS$1; }),
  "circle-dashed-letter-t": () => Promise.resolve().then(function () { return IconCircleDashedLetterT$1; }),
  "circle-dashed-letter-u": () => Promise.resolve().then(function () { return IconCircleDashedLetterU$1; }),
  "circle-dashed-letter-v": () => Promise.resolve().then(function () { return IconCircleDashedLetterV$1; }),
  "circle-dashed-letter-w": () => Promise.resolve().then(function () { return IconCircleDashedLetterW$1; }),
  "circle-dashed-letter-x": () => Promise.resolve().then(function () { return IconCircleDashedLetterX$1; }),
  "circle-dashed-letter-y": () => Promise.resolve().then(function () { return IconCircleDashedLetterY$1; }),
  "circle-dashed-letter-z": () => Promise.resolve().then(function () { return IconCircleDashedLetterZ$1; }),
  "circle-dashed-minus": () => Promise.resolve().then(function () { return IconCircleDashedMinus$1; }),
  "circle-dashed-number-0": () => Promise.resolve().then(function () { return IconCircleDashedNumber0$1; }),
  "circle-dashed-number-1": () => Promise.resolve().then(function () { return IconCircleDashedNumber1$1; }),
  "circle-dashed-number-2": () => Promise.resolve().then(function () { return IconCircleDashedNumber2$1; }),
  "circle-dashed-number-3": () => Promise.resolve().then(function () { return IconCircleDashedNumber3$1; }),
  "circle-dashed-number-4": () => Promise.resolve().then(function () { return IconCircleDashedNumber4$1; }),
  "circle-dashed-number-5": () => Promise.resolve().then(function () { return IconCircleDashedNumber5$1; }),
  "circle-dashed-number-6": () => Promise.resolve().then(function () { return IconCircleDashedNumber6$1; }),
  "circle-dashed-number-7": () => Promise.resolve().then(function () { return IconCircleDashedNumber7$1; }),
  "circle-dashed-number-8": () => Promise.resolve().then(function () { return IconCircleDashedNumber8$1; }),
  "circle-dashed-number-9": () => Promise.resolve().then(function () { return IconCircleDashedNumber9$1; }),
  "circle-dashed-percentage": () => Promise.resolve().then(function () { return IconCircleDashedPercentage$1; }),
  "circle-dashed-plus": () => Promise.resolve().then(function () { return IconCircleDashedPlus$1; }),
  "circle-dashed-x": () => Promise.resolve().then(function () { return IconCircleDashedX$1; }),
  "circle-dashed": () => Promise.resolve().then(function () { return IconCircleDashed$1; }),
  "circle-dot": () => Promise.resolve().then(function () { return IconCircleDot$1; }),
  "circle-dotted-letter-a": () => Promise.resolve().then(function () { return IconCircleDottedLetterA$1; }),
  "circle-dotted-letter-b": () => Promise.resolve().then(function () { return IconCircleDottedLetterB$1; }),
  "circle-dotted-letter-c": () => Promise.resolve().then(function () { return IconCircleDottedLetterC$1; }),
  "circle-dotted-letter-d": () => Promise.resolve().then(function () { return IconCircleDottedLetterD$1; }),
  "circle-dotted-letter-e": () => Promise.resolve().then(function () { return IconCircleDottedLetterE$1; }),
  "circle-dotted-letter-f": () => Promise.resolve().then(function () { return IconCircleDottedLetterF$1; }),
  "circle-dotted-letter-g": () => Promise.resolve().then(function () { return IconCircleDottedLetterG$1; }),
  "circle-dotted-letter-h": () => Promise.resolve().then(function () { return IconCircleDottedLetterH$1; }),
  "circle-dotted-letter-i": () => Promise.resolve().then(function () { return IconCircleDottedLetterI$1; }),
  "circle-dotted-letter-j": () => Promise.resolve().then(function () { return IconCircleDottedLetterJ$1; }),
  "circle-dotted-letter-k": () => Promise.resolve().then(function () { return IconCircleDottedLetterK$1; }),
  "circle-dotted-letter-l": () => Promise.resolve().then(function () { return IconCircleDottedLetterL$1; }),
  "circle-dotted-letter-m": () => Promise.resolve().then(function () { return IconCircleDottedLetterM$1; }),
  "circle-dotted-letter-n": () => Promise.resolve().then(function () { return IconCircleDottedLetterN$1; }),
  "circle-dotted-letter-o": () => Promise.resolve().then(function () { return IconCircleDottedLetterO$1; }),
  "circle-dotted-letter-p": () => Promise.resolve().then(function () { return IconCircleDottedLetterP$1; }),
  "circle-dotted-letter-q": () => Promise.resolve().then(function () { return IconCircleDottedLetterQ$1; }),
  "circle-dotted-letter-r": () => Promise.resolve().then(function () { return IconCircleDottedLetterR$1; }),
  "circle-dotted-letter-s": () => Promise.resolve().then(function () { return IconCircleDottedLetterS$1; }),
  "circle-dotted-letter-t": () => Promise.resolve().then(function () { return IconCircleDottedLetterT$1; }),
  "circle-dotted-letter-u": () => Promise.resolve().then(function () { return IconCircleDottedLetterU$1; }),
  "circle-dotted-letter-v": () => Promise.resolve().then(function () { return IconCircleDottedLetterV$1; }),
  "circle-dotted-letter-w": () => Promise.resolve().then(function () { return IconCircleDottedLetterW$1; }),
  "circle-dotted-letter-x": () => Promise.resolve().then(function () { return IconCircleDottedLetterX$1; }),
  "circle-dotted-letter-y": () => Promise.resolve().then(function () { return IconCircleDottedLetterY$1; }),
  "circle-dotted-letter-z": () => Promise.resolve().then(function () { return IconCircleDottedLetterZ$1; }),
  "circle-dotted": () => Promise.resolve().then(function () { return IconCircleDotted$1; }),
  "circle-half-2": () => Promise.resolve().then(function () { return IconCircleHalf2$1; }),
  "circle-half-vertical": () => Promise.resolve().then(function () { return IconCircleHalfVertical$1; }),
  "circle-half": () => Promise.resolve().then(function () { return IconCircleHalf$1; }),
  "circle-key": () => Promise.resolve().then(function () { return IconCircleKey$1; }),
  "circle-letter-a": () => Promise.resolve().then(function () { return IconCircleLetterA$1; }),
  "circle-letter-b": () => Promise.resolve().then(function () { return IconCircleLetterB$1; }),
  "circle-letter-c": () => Promise.resolve().then(function () { return IconCircleLetterC$1; }),
  "circle-letter-d": () => Promise.resolve().then(function () { return IconCircleLetterD$1; }),
  "circle-letter-e": () => Promise.resolve().then(function () { return IconCircleLetterE$1; }),
  "circle-letter-f": () => Promise.resolve().then(function () { return IconCircleLetterF$1; }),
  "circle-letter-g": () => Promise.resolve().then(function () { return IconCircleLetterG$1; }),
  "circle-letter-h": () => Promise.resolve().then(function () { return IconCircleLetterH$1; }),
  "circle-letter-i": () => Promise.resolve().then(function () { return IconCircleLetterI$1; }),
  "circle-letter-j": () => Promise.resolve().then(function () { return IconCircleLetterJ$1; }),
  "circle-letter-k": () => Promise.resolve().then(function () { return IconCircleLetterK$1; }),
  "circle-letter-l": () => Promise.resolve().then(function () { return IconCircleLetterL$1; }),
  "circle-letter-m": () => Promise.resolve().then(function () { return IconCircleLetterM$1; }),
  "circle-letter-n": () => Promise.resolve().then(function () { return IconCircleLetterN$1; }),
  "circle-letter-o": () => Promise.resolve().then(function () { return IconCircleLetterO$1; }),
  "circle-letter-p": () => Promise.resolve().then(function () { return IconCircleLetterP$1; }),
  "circle-letter-q": () => Promise.resolve().then(function () { return IconCircleLetterQ$1; }),
  "circle-letter-r": () => Promise.resolve().then(function () { return IconCircleLetterR$1; }),
  "circle-letter-s": () => Promise.resolve().then(function () { return IconCircleLetterS$1; }),
  "circle-letter-t": () => Promise.resolve().then(function () { return IconCircleLetterT$1; }),
  "circle-letter-u": () => Promise.resolve().then(function () { return IconCircleLetterU$1; }),
  "circle-letter-v": () => Promise.resolve().then(function () { return IconCircleLetterV$1; }),
  "circle-letter-w": () => Promise.resolve().then(function () { return IconCircleLetterW$1; }),
  "circle-letter-x": () => Promise.resolve().then(function () { return IconCircleLetterX$1; }),
  "circle-letter-y": () => Promise.resolve().then(function () { return IconCircleLetterY$1; }),
  "circle-letter-z": () => Promise.resolve().then(function () { return IconCircleLetterZ$1; }),
  "circle-minus-2": () => Promise.resolve().then(function () { return IconCircleMinus2$1; }),
  "circle-minus": () => Promise.resolve().then(function () { return IconCircleMinus$1; }),
  "circle-number-0": () => Promise.resolve().then(function () { return IconCircleNumber0$1; }),
  "circle-number-1": () => Promise.resolve().then(function () { return IconCircleNumber1$1; }),
  "circle-number-2": () => Promise.resolve().then(function () { return IconCircleNumber2$1; }),
  "circle-number-3": () => Promise.resolve().then(function () { return IconCircleNumber3$1; }),
  "circle-number-4": () => Promise.resolve().then(function () { return IconCircleNumber4$1; }),
  "circle-number-5": () => Promise.resolve().then(function () { return IconCircleNumber5$1; }),
  "circle-number-6": () => Promise.resolve().then(function () { return IconCircleNumber6$1; }),
  "circle-number-7": () => Promise.resolve().then(function () { return IconCircleNumber7$1; }),
  "circle-number-8": () => Promise.resolve().then(function () { return IconCircleNumber8$1; }),
  "circle-number-9": () => Promise.resolve().then(function () { return IconCircleNumber9$1; }),
  "circle-off": () => Promise.resolve().then(function () { return IconCircleOff$1; }),
  "circle-percentage": () => Promise.resolve().then(function () { return IconCirclePercentage$1; }),
  "circle-plus-2": () => Promise.resolve().then(function () { return IconCirclePlus2$1; }),
  "circle-plus": () => Promise.resolve().then(function () { return IconCirclePlus$1; }),
  "circle-rectangle-off": () => Promise.resolve().then(function () { return IconCircleRectangleOff$1; }),
  "circle-rectangle": () => Promise.resolve().then(function () { return IconCircleRectangle$1; }),
  "circle-square": () => Promise.resolve().then(function () { return IconCircleSquare$1; }),
  "circle-triangle": () => Promise.resolve().then(function () { return IconCircleTriangle$1; }),
  "circle-x": () => Promise.resolve().then(function () { return IconCircleX$1; }),
  "circle": () => Promise.resolve().then(function () { return IconCircle$1; }),
  "circles-relation": () => Promise.resolve().then(function () { return IconCirclesRelation$1; }),
  "circles": () => Promise.resolve().then(function () { return IconCircles$1; }),
  "circuit-ammeter": () => Promise.resolve().then(function () { return IconCircuitAmmeter$1; }),
  "circuit-battery": () => Promise.resolve().then(function () { return IconCircuitBattery$1; }),
  "circuit-bulb": () => Promise.resolve().then(function () { return IconCircuitBulb$1; }),
  "circuit-capacitor-polarized": () => Promise.resolve().then(function () { return IconCircuitCapacitorPolarized$1; }),
  "circuit-capacitor": () => Promise.resolve().then(function () { return IconCircuitCapacitor$1; }),
  "circuit-cell-plus": () => Promise.resolve().then(function () { return IconCircuitCellPlus$1; }),
  "circuit-cell": () => Promise.resolve().then(function () { return IconCircuitCell$1; }),
  "circuit-changeover": () => Promise.resolve().then(function () { return IconCircuitChangeover$1; }),
  "circuit-diode-zener": () => Promise.resolve().then(function () { return IconCircuitDiodeZener$1; }),
  "circuit-diode": () => Promise.resolve().then(function () { return IconCircuitDiode$1; }),
  "circuit-ground-digital": () => Promise.resolve().then(function () { return IconCircuitGroundDigital$1; }),
  "circuit-ground": () => Promise.resolve().then(function () { return IconCircuitGround$1; }),
  "circuit-inductor": () => Promise.resolve().then(function () { return IconCircuitInductor$1; }),
  "circuit-motor": () => Promise.resolve().then(function () { return IconCircuitMotor$1; }),
  "circuit-pushbutton": () => Promise.resolve().then(function () { return IconCircuitPushbutton$1; }),
  "circuit-resistor": () => Promise.resolve().then(function () { return IconCircuitResistor$1; }),
  "circuit-switch-closed": () => Promise.resolve().then(function () { return IconCircuitSwitchClosed$1; }),
  "circuit-switch-open": () => Promise.resolve().then(function () { return IconCircuitSwitchOpen$1; }),
  "circuit-voltmeter": () => Promise.resolve().then(function () { return IconCircuitVoltmeter$1; }),
  "clear-all": () => Promise.resolve().then(function () { return IconClearAll$1; }),
  "clear-formatting": () => Promise.resolve().then(function () { return IconClearFormatting$1; }),
  "click": () => Promise.resolve().then(function () { return IconClick$1; }),
  "cliff-jumping": () => Promise.resolve().then(function () { return IconCliffJumping$1; }),
  "clipboard-check": () => Promise.resolve().then(function () { return IconClipboardCheck$1; }),
  "clipboard-copy": () => Promise.resolve().then(function () { return IconClipboardCopy$1; }),
  "clipboard-data": () => Promise.resolve().then(function () { return IconClipboardData$1; }),
  "clipboard-heart": () => Promise.resolve().then(function () { return IconClipboardHeart$1; }),
  "clipboard-list": () => Promise.resolve().then(function () { return IconClipboardList$1; }),
  "clipboard-off": () => Promise.resolve().then(function () { return IconClipboardOff$1; }),
  "clipboard-plus": () => Promise.resolve().then(function () { return IconClipboardPlus$1; }),
  "clipboard-search": () => Promise.resolve().then(function () { return IconClipboardSearch$1; }),
  "clipboard-smile": () => Promise.resolve().then(function () { return IconClipboardSmile$1; }),
  "clipboard-text": () => Promise.resolve().then(function () { return IconClipboardText$1; }),
  "clipboard-typography": () => Promise.resolve().then(function () { return IconClipboardTypography$1; }),
  "clipboard-x": () => Promise.resolve().then(function () { return IconClipboardX$1; }),
  "clipboard": () => Promise.resolve().then(function () { return IconClipboard$1; }),
  "clock-12": () => Promise.resolve().then(function () { return IconClock12$1; }),
  "clock-2": () => Promise.resolve().then(function () { return IconClock2$1; }),
  "clock-24": () => Promise.resolve().then(function () { return IconClock24$1; }),
  "clock-bitcoin": () => Promise.resolve().then(function () { return IconClockBitcoin$1; }),
  "clock-bolt": () => Promise.resolve().then(function () { return IconClockBolt$1; }),
  "clock-cancel": () => Promise.resolve().then(function () { return IconClockCancel$1; }),
  "clock-check": () => Promise.resolve().then(function () { return IconClockCheck$1; }),
  "clock-code": () => Promise.resolve().then(function () { return IconClockCode$1; }),
  "clock-cog": () => Promise.resolve().then(function () { return IconClockCog$1; }),
  "clock-dollar": () => Promise.resolve().then(function () { return IconClockDollar$1; }),
  "clock-down": () => Promise.resolve().then(function () { return IconClockDown$1; }),
  "clock-edit": () => Promise.resolve().then(function () { return IconClockEdit$1; }),
  "clock-exclamation": () => Promise.resolve().then(function () { return IconClockExclamation$1; }),
  "clock-heart": () => Promise.resolve().then(function () { return IconClockHeart$1; }),
  "clock-hour-1": () => Promise.resolve().then(function () { return IconClockHour1$1; }),
  "clock-hour-10": () => Promise.resolve().then(function () { return IconClockHour10$1; }),
  "clock-hour-11": () => Promise.resolve().then(function () { return IconClockHour11$1; }),
  "clock-hour-12": () => Promise.resolve().then(function () { return IconClockHour12$1; }),
  "clock-hour-2": () => Promise.resolve().then(function () { return IconClockHour2$1; }),
  "clock-hour-3": () => Promise.resolve().then(function () { return IconClockHour3$1; }),
  "clock-hour-4": () => Promise.resolve().then(function () { return IconClockHour4$1; }),
  "clock-hour-5": () => Promise.resolve().then(function () { return IconClockHour5$1; }),
  "clock-hour-6": () => Promise.resolve().then(function () { return IconClockHour6$1; }),
  "clock-hour-7": () => Promise.resolve().then(function () { return IconClockHour7$1; }),
  "clock-hour-8": () => Promise.resolve().then(function () { return IconClockHour8$1; }),
  "clock-hour-9": () => Promise.resolve().then(function () { return IconClockHour9$1; }),
  "clock-minus": () => Promise.resolve().then(function () { return IconClockMinus$1; }),
  "clock-off": () => Promise.resolve().then(function () { return IconClockOff$1; }),
  "clock-pause": () => Promise.resolve().then(function () { return IconClockPause$1; }),
  "clock-pin": () => Promise.resolve().then(function () { return IconClockPin$1; }),
  "clock-play": () => Promise.resolve().then(function () { return IconClockPlay$1; }),
  "clock-plus": () => Promise.resolve().then(function () { return IconClockPlus$1; }),
  "clock-question": () => Promise.resolve().then(function () { return IconClockQuestion$1; }),
  "clock-record": () => Promise.resolve().then(function () { return IconClockRecord$1; }),
  "clock-search": () => Promise.resolve().then(function () { return IconClockSearch$1; }),
  "clock-share": () => Promise.resolve().then(function () { return IconClockShare$1; }),
  "clock-shield": () => Promise.resolve().then(function () { return IconClockShield$1; }),
  "clock-star": () => Promise.resolve().then(function () { return IconClockStar$1; }),
  "clock-stop": () => Promise.resolve().then(function () { return IconClockStop$1; }),
  "clock-up": () => Promise.resolve().then(function () { return IconClockUp$1; }),
  "clock-x": () => Promise.resolve().then(function () { return IconClockX$1; }),
  "clock": () => Promise.resolve().then(function () { return IconClock$1; }),
  "clothes-rack-off": () => Promise.resolve().then(function () { return IconClothesRackOff$1; }),
  "clothes-rack": () => Promise.resolve().then(function () { return IconClothesRack$1; }),
  "cloud-bitcoin": () => Promise.resolve().then(function () { return IconCloudBitcoin$1; }),
  "cloud-bolt": () => Promise.resolve().then(function () { return IconCloudBolt$1; }),
  "cloud-cancel": () => Promise.resolve().then(function () { return IconCloudCancel$1; }),
  "cloud-check": () => Promise.resolve().then(function () { return IconCloudCheck$1; }),
  "cloud-code": () => Promise.resolve().then(function () { return IconCloudCode$1; }),
  "cloud-cog": () => Promise.resolve().then(function () { return IconCloudCog$1; }),
  "cloud-computing": () => Promise.resolve().then(function () { return IconCloudComputing$1; }),
  "cloud-data-connection": () => Promise.resolve().then(function () { return IconCloudDataConnection$1; }),
  "cloud-dollar": () => Promise.resolve().then(function () { return IconCloudDollar$1; }),
  "cloud-down": () => Promise.resolve().then(function () { return IconCloudDown$1; }),
  "cloud-download": () => Promise.resolve().then(function () { return IconCloudDownload$1; }),
  "cloud-exclamation": () => Promise.resolve().then(function () { return IconCloudExclamation$1; }),
  "cloud-fog": () => Promise.resolve().then(function () { return IconCloudFog$1; }),
  "cloud-heart": () => Promise.resolve().then(function () { return IconCloudHeart$1; }),
  "cloud-lock-open": () => Promise.resolve().then(function () { return IconCloudLockOpen$1; }),
  "cloud-lock": () => Promise.resolve().then(function () { return IconCloudLock$1; }),
  "cloud-minus": () => Promise.resolve().then(function () { return IconCloudMinus$1; }),
  "cloud-network": () => Promise.resolve().then(function () { return IconCloudNetwork$1; }),
  "cloud-off": () => Promise.resolve().then(function () { return IconCloudOff$1; }),
  "cloud-pause": () => Promise.resolve().then(function () { return IconCloudPause$1; }),
  "cloud-pin": () => Promise.resolve().then(function () { return IconCloudPin$1; }),
  "cloud-plus": () => Promise.resolve().then(function () { return IconCloudPlus$1; }),
  "cloud-question": () => Promise.resolve().then(function () { return IconCloudQuestion$1; }),
  "cloud-rain": () => Promise.resolve().then(function () { return IconCloudRain$1; }),
  "cloud-search": () => Promise.resolve().then(function () { return IconCloudSearch$1; }),
  "cloud-share": () => Promise.resolve().then(function () { return IconCloudShare$1; }),
  "cloud-snow": () => Promise.resolve().then(function () { return IconCloudSnow$1; }),
  "cloud-star": () => Promise.resolve().then(function () { return IconCloudStar$1; }),
  "cloud-storm": () => Promise.resolve().then(function () { return IconCloudStorm$1; }),
  "cloud-up": () => Promise.resolve().then(function () { return IconCloudUp$1; }),
  "cloud-upload": () => Promise.resolve().then(function () { return IconCloudUpload$1; }),
  "cloud-x": () => Promise.resolve().then(function () { return IconCloudX$1; }),
  "cloud": () => Promise.resolve().then(function () { return IconCloud$1; }),
  "clover-2": () => Promise.resolve().then(function () { return IconClover2$1; }),
  "clover": () => Promise.resolve().then(function () { return IconClover$1; }),
  "clubs": () => Promise.resolve().then(function () { return IconClubs$1; }),
  "code-asterisk": () => Promise.resolve().then(function () { return IconCodeAsterisk$1; }),
  "code-circle-2": () => Promise.resolve().then(function () { return IconCodeCircle2$1; }),
  "code-circle": () => Promise.resolve().then(function () { return IconCodeCircle$1; }),
  "code-dots": () => Promise.resolve().then(function () { return IconCodeDots$1; }),
  "code-minus": () => Promise.resolve().then(function () { return IconCodeMinus$1; }),
  "code-off": () => Promise.resolve().then(function () { return IconCodeOff$1; }),
  "code-plus": () => Promise.resolve().then(function () { return IconCodePlus$1; }),
  "code-variable-minus": () => Promise.resolve().then(function () { return IconCodeVariableMinus$1; }),
  "code-variable-plus": () => Promise.resolve().then(function () { return IconCodeVariablePlus$1; }),
  "code-variable": () => Promise.resolve().then(function () { return IconCodeVariable$1; }),
  "code": () => Promise.resolve().then(function () { return IconCode$1; }),
  "coffee-off": () => Promise.resolve().then(function () { return IconCoffeeOff$1; }),
  "coffee": () => Promise.resolve().then(function () { return IconCoffee$1; }),
  "coffin": () => Promise.resolve().then(function () { return IconCoffin$1; }),
  "coin-bitcoin": () => Promise.resolve().then(function () { return IconCoinBitcoin$1; }),
  "coin-euro": () => Promise.resolve().then(function () { return IconCoinEuro$1; }),
  "coin-monero": () => Promise.resolve().then(function () { return IconCoinMonero$1; }),
  "coin-off": () => Promise.resolve().then(function () { return IconCoinOff$1; }),
  "coin-pound": () => Promise.resolve().then(function () { return IconCoinPound$1; }),
  "coin-rupee": () => Promise.resolve().then(function () { return IconCoinRupee$1; }),
  "coin-taka": () => Promise.resolve().then(function () { return IconCoinTaka$1; }),
  "coin-yen": () => Promise.resolve().then(function () { return IconCoinYen$1; }),
  "coin-yuan": () => Promise.resolve().then(function () { return IconCoinYuan$1; }),
  "coin": () => Promise.resolve().then(function () { return IconCoin$1; }),
  "coins": () => Promise.resolve().then(function () { return IconCoins$1; }),
  "color-filter": () => Promise.resolve().then(function () { return IconColorFilter$1; }),
  "color-picker-off": () => Promise.resolve().then(function () { return IconColorPickerOff$1; }),
  "color-picker": () => Promise.resolve().then(function () { return IconColorPicker$1; }),
  "color-swatch-off": () => Promise.resolve().then(function () { return IconColorSwatchOff$1; }),
  "color-swatch": () => Promise.resolve().then(function () { return IconColorSwatch$1; }),
  "column-insert-left": () => Promise.resolve().then(function () { return IconColumnInsertLeft$1; }),
  "column-insert-right": () => Promise.resolve().then(function () { return IconColumnInsertRight$1; }),
  "column-remove": () => Promise.resolve().then(function () { return IconColumnRemove$1; }),
  "columns-1": () => Promise.resolve().then(function () { return IconColumns1$1; }),
  "columns-2": () => Promise.resolve().then(function () { return IconColumns2$1; }),
  "columns-3": () => Promise.resolve().then(function () { return IconColumns3$1; }),
  "columns-off": () => Promise.resolve().then(function () { return IconColumnsOff$1; }),
  "columns": () => Promise.resolve().then(function () { return IconColumns$1; }),
  "comet": () => Promise.resolve().then(function () { return IconComet$1; }),
  "command-off": () => Promise.resolve().then(function () { return IconCommandOff$1; }),
  "command": () => Promise.resolve().then(function () { return IconCommand$1; }),
  "compass-off": () => Promise.resolve().then(function () { return IconCompassOff$1; }),
  "compass": () => Promise.resolve().then(function () { return IconCompass$1; }),
  "components-off": () => Promise.resolve().then(function () { return IconComponentsOff$1; }),
  "components": () => Promise.resolve().then(function () { return IconComponents$1; }),
  "cone-2": () => Promise.resolve().then(function () { return IconCone2$1; }),
  "cone-off": () => Promise.resolve().then(function () { return IconConeOff$1; }),
  "cone-plus": () => Promise.resolve().then(function () { return IconConePlus$1; }),
  "cone": () => Promise.resolve().then(function () { return IconCone$1; }),
  "confetti-off": () => Promise.resolve().then(function () { return IconConfettiOff$1; }),
  "confetti": () => Promise.resolve().then(function () { return IconConfetti$1; }),
  "confucius": () => Promise.resolve().then(function () { return IconConfucius$1; }),
  "congruent-to": () => Promise.resolve().then(function () { return IconCongruentTo$1; }),
  "container-off": () => Promise.resolve().then(function () { return IconContainerOff$1; }),
  "container": () => Promise.resolve().then(function () { return IconContainer$1; }),
  "contract": () => Promise.resolve().then(function () { return IconContract$1; }),
  "contrast-2-off": () => Promise.resolve().then(function () { return IconContrast2Off$1; }),
  "contrast-2": () => Promise.resolve().then(function () { return IconContrast2$1; }),
  "contrast-off": () => Promise.resolve().then(function () { return IconContrastOff$1; }),
  "contrast": () => Promise.resolve().then(function () { return IconContrast$1; }),
  "cooker": () => Promise.resolve().then(function () { return IconCooker$1; }),
  "cookie-man": () => Promise.resolve().then(function () { return IconCookieMan$1; }),
  "cookie-off": () => Promise.resolve().then(function () { return IconCookieOff$1; }),
  "cookie": () => Promise.resolve().then(function () { return IconCookie$1; }),
  "copy-check": () => Promise.resolve().then(function () { return IconCopyCheck$1; }),
  "copy-minus": () => Promise.resolve().then(function () { return IconCopyMinus$1; }),
  "copy-off": () => Promise.resolve().then(function () { return IconCopyOff$1; }),
  "copy-plus": () => Promise.resolve().then(function () { return IconCopyPlus$1; }),
  "copy-x": () => Promise.resolve().then(function () { return IconCopyX$1; }),
  "copy": () => Promise.resolve().then(function () { return IconCopy$1; }),
  "copyleft-off": () => Promise.resolve().then(function () { return IconCopyleftOff$1; }),
  "copyleft": () => Promise.resolve().then(function () { return IconCopyleft$1; }),
  "copyright-off": () => Promise.resolve().then(function () { return IconCopyrightOff$1; }),
  "copyright": () => Promise.resolve().then(function () { return IconCopyright$1; }),
  "corner-down-left-double": () => Promise.resolve().then(function () { return IconCornerDownLeftDouble$1; }),
  "corner-down-left": () => Promise.resolve().then(function () { return IconCornerDownLeft$1; }),
  "corner-down-right-double": () => Promise.resolve().then(function () { return IconCornerDownRightDouble$1; }),
  "corner-down-right": () => Promise.resolve().then(function () { return IconCornerDownRight$1; }),
  "corner-left-down-double": () => Promise.resolve().then(function () { return IconCornerLeftDownDouble$1; }),
  "corner-left-down": () => Promise.resolve().then(function () { return IconCornerLeftDown$1; }),
  "corner-left-up-double": () => Promise.resolve().then(function () { return IconCornerLeftUpDouble$1; }),
  "corner-left-up": () => Promise.resolve().then(function () { return IconCornerLeftUp$1; }),
  "corner-right-down-double": () => Promise.resolve().then(function () { return IconCornerRightDownDouble$1; }),
  "corner-right-down": () => Promise.resolve().then(function () { return IconCornerRightDown$1; }),
  "corner-right-up-double": () => Promise.resolve().then(function () { return IconCornerRightUpDouble$1; }),
  "corner-right-up": () => Promise.resolve().then(function () { return IconCornerRightUp$1; }),
  "corner-up-left-double": () => Promise.resolve().then(function () { return IconCornerUpLeftDouble$1; }),
  "corner-up-left": () => Promise.resolve().then(function () { return IconCornerUpLeft$1; }),
  "corner-up-right-double": () => Promise.resolve().then(function () { return IconCornerUpRightDouble$1; }),
  "corner-up-right": () => Promise.resolve().then(function () { return IconCornerUpRight$1; }),
  "cpu-2": () => Promise.resolve().then(function () { return IconCpu2$1; }),
  "cpu-off": () => Promise.resolve().then(function () { return IconCpuOff$1; }),
  "cpu": () => Promise.resolve().then(function () { return IconCpu$1; }),
  "crane-off": () => Promise.resolve().then(function () { return IconCraneOff$1; }),
  "crane": () => Promise.resolve().then(function () { return IconCrane$1; }),
  "creative-commons-by": () => Promise.resolve().then(function () { return IconCreativeCommonsBy$1; }),
  "creative-commons-nc": () => Promise.resolve().then(function () { return IconCreativeCommonsNc$1; }),
  "creative-commons-nd": () => Promise.resolve().then(function () { return IconCreativeCommonsNd$1; }),
  "creative-commons-off": () => Promise.resolve().then(function () { return IconCreativeCommonsOff$1; }),
  "creative-commons-sa": () => Promise.resolve().then(function () { return IconCreativeCommonsSa$1; }),
  "creative-commons-zero": () => Promise.resolve().then(function () { return IconCreativeCommonsZero$1; }),
  "creative-commons": () => Promise.resolve().then(function () { return IconCreativeCommons$1; }),
  "credit-card-off": () => Promise.resolve().then(function () { return IconCreditCardOff$1; }),
  "credit-card-pay": () => Promise.resolve().then(function () { return IconCreditCardPay$1; }),
  "credit-card-refund": () => Promise.resolve().then(function () { return IconCreditCardRefund$1; }),
  "credit-card": () => Promise.resolve().then(function () { return IconCreditCard$1; }),
  "cricket": () => Promise.resolve().then(function () { return IconCricket$1; }),
  "crop-1-1": () => Promise.resolve().then(function () { return IconCrop11$1; }),
  "crop-16-9": () => Promise.resolve().then(function () { return IconCrop169$1; }),
  "crop-3-2": () => Promise.resolve().then(function () { return IconCrop32$1; }),
  "crop-5-4": () => Promise.resolve().then(function () { return IconCrop54$1; }),
  "crop-7-5": () => Promise.resolve().then(function () { return IconCrop75$1; }),
  "crop-landscape": () => Promise.resolve().then(function () { return IconCropLandscape$1; }),
  "crop-portrait": () => Promise.resolve().then(function () { return IconCropPortrait$1; }),
  "crop": () => Promise.resolve().then(function () { return IconCrop$1; }),
  "cross-off": () => Promise.resolve().then(function () { return IconCrossOff$1; }),
  "cross": () => Promise.resolve().then(function () { return IconCross$1; }),
  "crosshair": () => Promise.resolve().then(function () { return IconCrosshair$1; }),
  "crown-off": () => Promise.resolve().then(function () { return IconCrownOff$1; }),
  "crown": () => Promise.resolve().then(function () { return IconCrown$1; }),
  "crutches-off": () => Promise.resolve().then(function () { return IconCrutchesOff$1; }),
  "crutches": () => Promise.resolve().then(function () { return IconCrutches$1; }),
  "crystal-ball": () => Promise.resolve().then(function () { return IconCrystalBall$1; }),
  "csv": () => Promise.resolve().then(function () { return IconCsv$1; }),
  "cube-3d-sphere-off": () => Promise.resolve().then(function () { return IconCube3dSphereOff$1; }),
  "cube-3d-sphere": () => Promise.resolve().then(function () { return IconCube3dSphere$1; }),
  "cube-off": () => Promise.resolve().then(function () { return IconCubeOff$1; }),
  "cube-plus": () => Promise.resolve().then(function () { return IconCubePlus$1; }),
  "cube-send": () => Promise.resolve().then(function () { return IconCubeSend$1; }),
  "cube-spark": () => Promise.resolve().then(function () { return IconCubeSpark$1; }),
  "cube-unfolded": () => Promise.resolve().then(function () { return IconCubeUnfolded$1; }),
  "cube": () => Promise.resolve().then(function () { return IconCube$1; }),
  "cup-off": () => Promise.resolve().then(function () { return IconCupOff$1; }),
  "cup": () => Promise.resolve().then(function () { return IconCup$1; }),
  "curling": () => Promise.resolve().then(function () { return IconCurling$1; }),
  "curly-loop": () => Promise.resolve().then(function () { return IconCurlyLoop$1; }),
  "currency-afghani": () => Promise.resolve().then(function () { return IconCurrencyAfghani$1; }),
  "currency-bahraini": () => Promise.resolve().then(function () { return IconCurrencyBahraini$1; }),
  "currency-baht": () => Promise.resolve().then(function () { return IconCurrencyBaht$1; }),
  "currency-bitcoin": () => Promise.resolve().then(function () { return IconCurrencyBitcoin$1; }),
  "currency-cent": () => Promise.resolve().then(function () { return IconCurrencyCent$1; }),
  "currency-dinar": () => Promise.resolve().then(function () { return IconCurrencyDinar$1; }),
  "currency-dirham": () => Promise.resolve().then(function () { return IconCurrencyDirham$1; }),
  "currency-dogecoin": () => Promise.resolve().then(function () { return IconCurrencyDogecoin$1; }),
  "currency-dollar-australian": () => Promise.resolve().then(function () { return IconCurrencyDollarAustralian$1; }),
  "currency-dollar-brunei": () => Promise.resolve().then(function () { return IconCurrencyDollarBrunei$1; }),
  "currency-dollar-canadian": () => Promise.resolve().then(function () { return IconCurrencyDollarCanadian$1; }),
  "currency-dollar-guyanese": () => Promise.resolve().then(function () { return IconCurrencyDollarGuyanese$1; }),
  "currency-dollar-off": () => Promise.resolve().then(function () { return IconCurrencyDollarOff$1; }),
  "currency-dollar-singapore": () => Promise.resolve().then(function () { return IconCurrencyDollarSingapore$1; }),
  "currency-dollar-zimbabwean": () => Promise.resolve().then(function () { return IconCurrencyDollarZimbabwean$1; }),
  "currency-dollar": () => Promise.resolve().then(function () { return IconCurrencyDollar$1; }),
  "currency-dong": () => Promise.resolve().then(function () { return IconCurrencyDong$1; }),
  "currency-dram": () => Promise.resolve().then(function () { return IconCurrencyDram$1; }),
  "currency-ethereum": () => Promise.resolve().then(function () { return IconCurrencyEthereum$1; }),
  "currency-euro-off": () => Promise.resolve().then(function () { return IconCurrencyEuroOff$1; }),
  "currency-euro": () => Promise.resolve().then(function () { return IconCurrencyEuro$1; }),
  "currency-florin": () => Promise.resolve().then(function () { return IconCurrencyFlorin$1; }),
  "currency-forint": () => Promise.resolve().then(function () { return IconCurrencyForint$1; }),
  "currency-frank": () => Promise.resolve().then(function () { return IconCurrencyFrank$1; }),
  "currency-guarani": () => Promise.resolve().then(function () { return IconCurrencyGuarani$1; }),
  "currency-hryvnia": () => Promise.resolve().then(function () { return IconCurrencyHryvnia$1; }),
  "currency-iranian-rial": () => Promise.resolve().then(function () { return IconCurrencyIranianRial$1; }),
  "currency-kip": () => Promise.resolve().then(function () { return IconCurrencyKip$1; }),
  "currency-krone-czech": () => Promise.resolve().then(function () { return IconCurrencyKroneCzech$1; }),
  "currency-krone-danish": () => Promise.resolve().then(function () { return IconCurrencyKroneDanish$1; }),
  "currency-krone-swedish": () => Promise.resolve().then(function () { return IconCurrencyKroneSwedish$1; }),
  "currency-lari": () => Promise.resolve().then(function () { return IconCurrencyLari$1; }),
  "currency-leu": () => Promise.resolve().then(function () { return IconCurrencyLeu$1; }),
  "currency-lira": () => Promise.resolve().then(function () { return IconCurrencyLira$1; }),
  "currency-litecoin": () => Promise.resolve().then(function () { return IconCurrencyLitecoin$1; }),
  "currency-lyd": () => Promise.resolve().then(function () { return IconCurrencyLyd$1; }),
  "currency-manat": () => Promise.resolve().then(function () { return IconCurrencyManat$1; }),
  "currency-monero": () => Promise.resolve().then(function () { return IconCurrencyMonero$1; }),
  "currency-naira": () => Promise.resolve().then(function () { return IconCurrencyNaira$1; }),
  "currency-nano": () => Promise.resolve().then(function () { return IconCurrencyNano$1; }),
  "currency-off": () => Promise.resolve().then(function () { return IconCurrencyOff$1; }),
  "currency-paanga": () => Promise.resolve().then(function () { return IconCurrencyPaanga$1; }),
  "currency-peso": () => Promise.resolve().then(function () { return IconCurrencyPeso$1; }),
  "currency-pound-off": () => Promise.resolve().then(function () { return IconCurrencyPoundOff$1; }),
  "currency-pound": () => Promise.resolve().then(function () { return IconCurrencyPound$1; }),
  "currency-quetzal": () => Promise.resolve().then(function () { return IconCurrencyQuetzal$1; }),
  "currency-real": () => Promise.resolve().then(function () { return IconCurrencyReal$1; }),
  "currency-renminbi": () => Promise.resolve().then(function () { return IconCurrencyRenminbi$1; }),
  "currency-ripple": () => Promise.resolve().then(function () { return IconCurrencyRipple$1; }),
  "currency-riyal": () => Promise.resolve().then(function () { return IconCurrencyRiyal$1; }),
  "currency-rubel": () => Promise.resolve().then(function () { return IconCurrencyRubel$1; }),
  "currency-rufiyaa": () => Promise.resolve().then(function () { return IconCurrencyRufiyaa$1; }),
  "currency-rupee-nepalese": () => Promise.resolve().then(function () { return IconCurrencyRupeeNepalese$1; }),
  "currency-rupee": () => Promise.resolve().then(function () { return IconCurrencyRupee$1; }),
  "currency-shekel": () => Promise.resolve().then(function () { return IconCurrencyShekel$1; }),
  "currency-solana": () => Promise.resolve().then(function () { return IconCurrencySolana$1; }),
  "currency-som": () => Promise.resolve().then(function () { return IconCurrencySom$1; }),
  "currency-taka": () => Promise.resolve().then(function () { return IconCurrencyTaka$1; }),
  "currency-tenge": () => Promise.resolve().then(function () { return IconCurrencyTenge$1; }),
  "currency-tugrik": () => Promise.resolve().then(function () { return IconCurrencyTugrik$1; }),
  "currency-won": () => Promise.resolve().then(function () { return IconCurrencyWon$1; }),
  "currency-xrp": () => Promise.resolve().then(function () { return IconCurrencyXrp$1; }),
  "currency-yen-off": () => Promise.resolve().then(function () { return IconCurrencyYenOff$1; }),
  "currency-yen": () => Promise.resolve().then(function () { return IconCurrencyYen$1; }),
  "currency-yuan": () => Promise.resolve().then(function () { return IconCurrencyYuan$1; }),
  "currency-zloty": () => Promise.resolve().then(function () { return IconCurrencyZloty$1; }),
  "currency": () => Promise.resolve().then(function () { return IconCurrency$1; }),
  "current-location-off": () => Promise.resolve().then(function () { return IconCurrentLocationOff$1; }),
  "current-location": () => Promise.resolve().then(function () { return IconCurrentLocation$1; }),
  "cursor-off": () => Promise.resolve().then(function () { return IconCursorOff$1; }),
  "cursor-text": () => Promise.resolve().then(function () { return IconCursorText$1; }),
  "cut": () => Promise.resolve().then(function () { return IconCut$1; }),
  "cylinder-off": () => Promise.resolve().then(function () { return IconCylinderOff$1; }),
  "cylinder-plus": () => Promise.resolve().then(function () { return IconCylinderPlus$1; }),
  "cylinder": () => Promise.resolve().then(function () { return IconCylinder$1; }),
  "dashboard-off": () => Promise.resolve().then(function () { return IconDashboardOff$1; }),
  "dashboard": () => Promise.resolve().then(function () { return IconDashboard$1; }),
  "database-cog": () => Promise.resolve().then(function () { return IconDatabaseCog$1; }),
  "database-dollar": () => Promise.resolve().then(function () { return IconDatabaseDollar$1; }),
  "database-edit": () => Promise.resolve().then(function () { return IconDatabaseEdit$1; }),
  "database-exclamation": () => Promise.resolve().then(function () { return IconDatabaseExclamation$1; }),
  "database-export": () => Promise.resolve().then(function () { return IconDatabaseExport$1; }),
  "database-heart": () => Promise.resolve().then(function () { return IconDatabaseHeart$1; }),
  "database-import": () => Promise.resolve().then(function () { return IconDatabaseImport$1; }),
  "database-leak": () => Promise.resolve().then(function () { return IconDatabaseLeak$1; }),
  "database-minus": () => Promise.resolve().then(function () { return IconDatabaseMinus$1; }),
  "database-off": () => Promise.resolve().then(function () { return IconDatabaseOff$1; }),
  "database-plus": () => Promise.resolve().then(function () { return IconDatabasePlus$1; }),
  "database-search": () => Promise.resolve().then(function () { return IconDatabaseSearch$1; }),
  "database-share": () => Promise.resolve().then(function () { return IconDatabaseShare$1; }),
  "database-smile": () => Promise.resolve().then(function () { return IconDatabaseSmile$1; }),
  "database-star": () => Promise.resolve().then(function () { return IconDatabaseStar$1; }),
  "database-x": () => Promise.resolve().then(function () { return IconDatabaseX$1; }),
  "database": () => Promise.resolve().then(function () { return IconDatabase$1; }),
  "decimal": () => Promise.resolve().then(function () { return IconDecimal$1; }),
  "deer": () => Promise.resolve().then(function () { return IconDeer$1; }),
  "delta": () => Promise.resolve().then(function () { return IconDelta$1; }),
  "dental-broken": () => Promise.resolve().then(function () { return IconDentalBroken$1; }),
  "dental-off": () => Promise.resolve().then(function () { return IconDentalOff$1; }),
  "dental": () => Promise.resolve().then(function () { return IconDental$1; }),
  "deselect": () => Promise.resolve().then(function () { return IconDeselect$1; }),
  "desk": () => Promise.resolve().then(function () { return IconDesk$1; }),
  "details-off": () => Promise.resolve().then(function () { return IconDetailsOff$1; }),
  "details": () => Promise.resolve().then(function () { return IconDetails$1; }),
  "device-airpods-case": () => Promise.resolve().then(function () { return IconDeviceAirpodsCase$1; }),
  "device-airpods": () => Promise.resolve().then(function () { return IconDeviceAirpods$1; }),
  "device-airtag": () => Promise.resolve().then(function () { return IconDeviceAirtag$1; }),
  "device-analytics": () => Promise.resolve().then(function () { return IconDeviceAnalytics$1; }),
  "device-audio-tape": () => Promise.resolve().then(function () { return IconDeviceAudioTape$1; }),
  "device-camera-phone": () => Promise.resolve().then(function () { return IconDeviceCameraPhone$1; }),
  "device-cctv-off": () => Promise.resolve().then(function () { return IconDeviceCctvOff$1; }),
  "device-cctv": () => Promise.resolve().then(function () { return IconDeviceCctv$1; }),
  "device-computer-camera-off": () => Promise.resolve().then(function () { return IconDeviceComputerCameraOff$1; }),
  "device-computer-camera": () => Promise.resolve().then(function () { return IconDeviceComputerCamera$1; }),
  "device-desktop-analytics": () => Promise.resolve().then(function () { return IconDeviceDesktopAnalytics$1; }),
  "device-desktop-bolt": () => Promise.resolve().then(function () { return IconDeviceDesktopBolt$1; }),
  "device-desktop-cancel": () => Promise.resolve().then(function () { return IconDeviceDesktopCancel$1; }),
  "device-desktop-check": () => Promise.resolve().then(function () { return IconDeviceDesktopCheck$1; }),
  "device-desktop-code": () => Promise.resolve().then(function () { return IconDeviceDesktopCode$1; }),
  "device-desktop-cog": () => Promise.resolve().then(function () { return IconDeviceDesktopCog$1; }),
  "device-desktop-dollar": () => Promise.resolve().then(function () { return IconDeviceDesktopDollar$1; }),
  "device-desktop-down": () => Promise.resolve().then(function () { return IconDeviceDesktopDown$1; }),
  "device-desktop-exclamation": () => Promise.resolve().then(function () { return IconDeviceDesktopExclamation$1; }),
  "device-desktop-heart": () => Promise.resolve().then(function () { return IconDeviceDesktopHeart$1; }),
  "device-desktop-minus": () => Promise.resolve().then(function () { return IconDeviceDesktopMinus$1; }),
  "device-desktop-off": () => Promise.resolve().then(function () { return IconDeviceDesktopOff$1; }),
  "device-desktop-pause": () => Promise.resolve().then(function () { return IconDeviceDesktopPause$1; }),
  "device-desktop-pin": () => Promise.resolve().then(function () { return IconDeviceDesktopPin$1; }),
  "device-desktop-plus": () => Promise.resolve().then(function () { return IconDeviceDesktopPlus$1; }),
  "device-desktop-question": () => Promise.resolve().then(function () { return IconDeviceDesktopQuestion$1; }),
  "device-desktop-search": () => Promise.resolve().then(function () { return IconDeviceDesktopSearch$1; }),
  "device-desktop-share": () => Promise.resolve().then(function () { return IconDeviceDesktopShare$1; }),
  "device-desktop-star": () => Promise.resolve().then(function () { return IconDeviceDesktopStar$1; }),
  "device-desktop-up": () => Promise.resolve().then(function () { return IconDeviceDesktopUp$1; }),
  "device-desktop-x": () => Promise.resolve().then(function () { return IconDeviceDesktopX$1; }),
  "device-desktop": () => Promise.resolve().then(function () { return IconDeviceDesktop$1; }),
  "device-floppy": () => Promise.resolve().then(function () { return IconDeviceFloppy$1; }),
  "device-gamepad-2": () => Promise.resolve().then(function () { return IconDeviceGamepad2$1; }),
  "device-gamepad-3": () => Promise.resolve().then(function () { return IconDeviceGamepad3$1; }),
  "device-gamepad": () => Promise.resolve().then(function () { return IconDeviceGamepad$1; }),
  "device-heart-monitor": () => Promise.resolve().then(function () { return IconDeviceHeartMonitor$1; }),
  "device-imac-bolt": () => Promise.resolve().then(function () { return IconDeviceImacBolt$1; }),
  "device-imac-cancel": () => Promise.resolve().then(function () { return IconDeviceImacCancel$1; }),
  "device-imac-check": () => Promise.resolve().then(function () { return IconDeviceImacCheck$1; }),
  "device-imac-code": () => Promise.resolve().then(function () { return IconDeviceImacCode$1; }),
  "device-imac-cog": () => Promise.resolve().then(function () { return IconDeviceImacCog$1; }),
  "device-imac-dollar": () => Promise.resolve().then(function () { return IconDeviceImacDollar$1; }),
  "device-imac-down": () => Promise.resolve().then(function () { return IconDeviceImacDown$1; }),
  "device-imac-exclamation": () => Promise.resolve().then(function () { return IconDeviceImacExclamation$1; }),
  "device-imac-heart": () => Promise.resolve().then(function () { return IconDeviceImacHeart$1; }),
  "device-imac-minus": () => Promise.resolve().then(function () { return IconDeviceImacMinus$1; }),
  "device-imac-off": () => Promise.resolve().then(function () { return IconDeviceImacOff$1; }),
  "device-imac-pause": () => Promise.resolve().then(function () { return IconDeviceImacPause$1; }),
  "device-imac-pin": () => Promise.resolve().then(function () { return IconDeviceImacPin$1; }),
  "device-imac-plus": () => Promise.resolve().then(function () { return IconDeviceImacPlus$1; }),
  "device-imac-question": () => Promise.resolve().then(function () { return IconDeviceImacQuestion$1; }),
  "device-imac-search": () => Promise.resolve().then(function () { return IconDeviceImacSearch$1; }),
  "device-imac-share": () => Promise.resolve().then(function () { return IconDeviceImacShare$1; }),
  "device-imac-star": () => Promise.resolve().then(function () { return IconDeviceImacStar$1; }),
  "device-imac-up": () => Promise.resolve().then(function () { return IconDeviceImacUp$1; }),
  "device-imac-x": () => Promise.resolve().then(function () { return IconDeviceImacX$1; }),
  "device-imac": () => Promise.resolve().then(function () { return IconDeviceImac$1; }),
  "device-ipad-bolt": () => Promise.resolve().then(function () { return IconDeviceIpadBolt$1; }),
  "device-ipad-cancel": () => Promise.resolve().then(function () { return IconDeviceIpadCancel$1; }),
  "device-ipad-check": () => Promise.resolve().then(function () { return IconDeviceIpadCheck$1; }),
  "device-ipad-code": () => Promise.resolve().then(function () { return IconDeviceIpadCode$1; }),
  "device-ipad-cog": () => Promise.resolve().then(function () { return IconDeviceIpadCog$1; }),
  "device-ipad-dollar": () => Promise.resolve().then(function () { return IconDeviceIpadDollar$1; }),
  "device-ipad-down": () => Promise.resolve().then(function () { return IconDeviceIpadDown$1; }),
  "device-ipad-exclamation": () => Promise.resolve().then(function () { return IconDeviceIpadExclamation$1; }),
  "device-ipad-heart": () => Promise.resolve().then(function () { return IconDeviceIpadHeart$1; }),
  "device-ipad-horizontal-bolt": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalBolt$1; }),
  "device-ipad-horizontal-cancel": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalCancel$1; }),
  "device-ipad-horizontal-check": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalCheck$1; }),
  "device-ipad-horizontal-code": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalCode$1; }),
  "device-ipad-horizontal-cog": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalCog$1; }),
  "device-ipad-horizontal-dollar": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalDollar$1; }),
  "device-ipad-horizontal-down": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalDown$1; }),
  "device-ipad-horizontal-exclamation": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalExclamation$1; }),
  "device-ipad-horizontal-heart": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalHeart$1; }),
  "device-ipad-horizontal-minus": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalMinus$1; }),
  "device-ipad-horizontal-off": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalOff$1; }),
  "device-ipad-horizontal-pause": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalPause$1; }),
  "device-ipad-horizontal-pin": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalPin$1; }),
  "device-ipad-horizontal-plus": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalPlus$1; }),
  "device-ipad-horizontal-question": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalQuestion$1; }),
  "device-ipad-horizontal-search": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalSearch$1; }),
  "device-ipad-horizontal-share": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalShare$1; }),
  "device-ipad-horizontal-star": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalStar$1; }),
  "device-ipad-horizontal-up": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalUp$1; }),
  "device-ipad-horizontal-x": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontalX$1; }),
  "device-ipad-horizontal": () => Promise.resolve().then(function () { return IconDeviceIpadHorizontal$1; }),
  "device-ipad-minus": () => Promise.resolve().then(function () { return IconDeviceIpadMinus$1; }),
  "device-ipad-off": () => Promise.resolve().then(function () { return IconDeviceIpadOff$1; }),
  "device-ipad-pause": () => Promise.resolve().then(function () { return IconDeviceIpadPause$1; }),
  "device-ipad-pin": () => Promise.resolve().then(function () { return IconDeviceIpadPin$1; }),
  "device-ipad-plus": () => Promise.resolve().then(function () { return IconDeviceIpadPlus$1; }),
  "device-ipad-question": () => Promise.resolve().then(function () { return IconDeviceIpadQuestion$1; }),
  "device-ipad-search": () => Promise.resolve().then(function () { return IconDeviceIpadSearch$1; }),
  "device-ipad-share": () => Promise.resolve().then(function () { return IconDeviceIpadShare$1; }),
  "device-ipad-star": () => Promise.resolve().then(function () { return IconDeviceIpadStar$1; }),
  "device-ipad-up": () => Promise.resolve().then(function () { return IconDeviceIpadUp$1; }),
  "device-ipad-x": () => Promise.resolve().then(function () { return IconDeviceIpadX$1; }),
  "device-ipad": () => Promise.resolve().then(function () { return IconDeviceIpad$1; }),
  "device-landline-phone": () => Promise.resolve().then(function () { return IconDeviceLandlinePhone$1; }),
  "device-laptop-off": () => Promise.resolve().then(function () { return IconDeviceLaptopOff$1; }),
  "device-laptop": () => Promise.resolve().then(function () { return IconDeviceLaptop$1; }),
  "device-mobile-bolt": () => Promise.resolve().then(function () { return IconDeviceMobileBolt$1; }),
  "device-mobile-cancel": () => Promise.resolve().then(function () { return IconDeviceMobileCancel$1; }),
  "device-mobile-charging": () => Promise.resolve().then(function () { return IconDeviceMobileCharging$1; }),
  "device-mobile-check": () => Promise.resolve().then(function () { return IconDeviceMobileCheck$1; }),
  "device-mobile-code": () => Promise.resolve().then(function () { return IconDeviceMobileCode$1; }),
  "device-mobile-cog": () => Promise.resolve().then(function () { return IconDeviceMobileCog$1; }),
  "device-mobile-dollar": () => Promise.resolve().then(function () { return IconDeviceMobileDollar$1; }),
  "device-mobile-down": () => Promise.resolve().then(function () { return IconDeviceMobileDown$1; }),
  "device-mobile-exclamation": () => Promise.resolve().then(function () { return IconDeviceMobileExclamation$1; }),
  "device-mobile-heart": () => Promise.resolve().then(function () { return IconDeviceMobileHeart$1; }),
  "device-mobile-message": () => Promise.resolve().then(function () { return IconDeviceMobileMessage$1; }),
  "device-mobile-minus": () => Promise.resolve().then(function () { return IconDeviceMobileMinus$1; }),
  "device-mobile-off": () => Promise.resolve().then(function () { return IconDeviceMobileOff$1; }),
  "device-mobile-pause": () => Promise.resolve().then(function () { return IconDeviceMobilePause$1; }),
  "device-mobile-pin": () => Promise.resolve().then(function () { return IconDeviceMobilePin$1; }),
  "device-mobile-plus": () => Promise.resolve().then(function () { return IconDeviceMobilePlus$1; }),
  "device-mobile-question": () => Promise.resolve().then(function () { return IconDeviceMobileQuestion$1; }),
  "device-mobile-rotated": () => Promise.resolve().then(function () { return IconDeviceMobileRotated$1; }),
  "device-mobile-search": () => Promise.resolve().then(function () { return IconDeviceMobileSearch$1; }),
  "device-mobile-share": () => Promise.resolve().then(function () { return IconDeviceMobileShare$1; }),
  "device-mobile-star": () => Promise.resolve().then(function () { return IconDeviceMobileStar$1; }),
  "device-mobile-up": () => Promise.resolve().then(function () { return IconDeviceMobileUp$1; }),
  "device-mobile-vibration": () => Promise.resolve().then(function () { return IconDeviceMobileVibration$1; }),
  "device-mobile-x": () => Promise.resolve().then(function () { return IconDeviceMobileX$1; }),
  "device-mobile": () => Promise.resolve().then(function () { return IconDeviceMobile$1; }),
  "device-nintendo-off": () => Promise.resolve().then(function () { return IconDeviceNintendoOff$1; }),
  "device-nintendo": () => Promise.resolve().then(function () { return IconDeviceNintendo$1; }),
  "device-projector": () => Promise.resolve().then(function () { return IconDeviceProjector$1; }),
  "device-remote": () => Promise.resolve().then(function () { return IconDeviceRemote$1; }),
  "device-sd-card": () => Promise.resolve().then(function () { return IconDeviceSdCard$1; }),
  "device-sim-1": () => Promise.resolve().then(function () { return IconDeviceSim1$1; }),
  "device-sim-2": () => Promise.resolve().then(function () { return IconDeviceSim2$1; }),
  "device-sim-3": () => Promise.resolve().then(function () { return IconDeviceSim3$1; }),
  "device-sim": () => Promise.resolve().then(function () { return IconDeviceSim$1; }),
  "device-speaker-off": () => Promise.resolve().then(function () { return IconDeviceSpeakerOff$1; }),
  "device-speaker": () => Promise.resolve().then(function () { return IconDeviceSpeaker$1; }),
  "device-tablet-bolt": () => Promise.resolve().then(function () { return IconDeviceTabletBolt$1; }),
  "device-tablet-cancel": () => Promise.resolve().then(function () { return IconDeviceTabletCancel$1; }),
  "device-tablet-check": () => Promise.resolve().then(function () { return IconDeviceTabletCheck$1; }),
  "device-tablet-code": () => Promise.resolve().then(function () { return IconDeviceTabletCode$1; }),
  "device-tablet-cog": () => Promise.resolve().then(function () { return IconDeviceTabletCog$1; }),
  "device-tablet-dollar": () => Promise.resolve().then(function () { return IconDeviceTabletDollar$1; }),
  "device-tablet-down": () => Promise.resolve().then(function () { return IconDeviceTabletDown$1; }),
  "device-tablet-exclamation": () => Promise.resolve().then(function () { return IconDeviceTabletExclamation$1; }),
  "device-tablet-heart": () => Promise.resolve().then(function () { return IconDeviceTabletHeart$1; }),
  "device-tablet-minus": () => Promise.resolve().then(function () { return IconDeviceTabletMinus$1; }),
  "device-tablet-off": () => Promise.resolve().then(function () { return IconDeviceTabletOff$1; }),
  "device-tablet-pause": () => Promise.resolve().then(function () { return IconDeviceTabletPause$1; }),
  "device-tablet-pin": () => Promise.resolve().then(function () { return IconDeviceTabletPin$1; }),
  "device-tablet-plus": () => Promise.resolve().then(function () { return IconDeviceTabletPlus$1; }),
  "device-tablet-question": () => Promise.resolve().then(function () { return IconDeviceTabletQuestion$1; }),
  "device-tablet-search": () => Promise.resolve().then(function () { return IconDeviceTabletSearch$1; }),
  "device-tablet-share": () => Promise.resolve().then(function () { return IconDeviceTabletShare$1; }),
  "device-tablet-star": () => Promise.resolve().then(function () { return IconDeviceTabletStar$1; }),
  "device-tablet-up": () => Promise.resolve().then(function () { return IconDeviceTabletUp$1; }),
  "device-tablet-x": () => Promise.resolve().then(function () { return IconDeviceTabletX$1; }),
  "device-tablet": () => Promise.resolve().then(function () { return IconDeviceTablet$1; }),
  "device-tv-off": () => Promise.resolve().then(function () { return IconDeviceTvOff$1; }),
  "device-tv-old": () => Promise.resolve().then(function () { return IconDeviceTvOld$1; }),
  "device-tv": () => Promise.resolve().then(function () { return IconDeviceTv$1; }),
  "device-unknown": () => Promise.resolve().then(function () { return IconDeviceUnknown$1; }),
  "device-usb": () => Promise.resolve().then(function () { return IconDeviceUsb$1; }),
  "device-vision-pro": () => Promise.resolve().then(function () { return IconDeviceVisionPro$1; }),
  "device-watch-bolt": () => Promise.resolve().then(function () { return IconDeviceWatchBolt$1; }),
  "device-watch-cancel": () => Promise.resolve().then(function () { return IconDeviceWatchCancel$1; }),
  "device-watch-check": () => Promise.resolve().then(function () { return IconDeviceWatchCheck$1; }),
  "device-watch-code": () => Promise.resolve().then(function () { return IconDeviceWatchCode$1; }),
  "device-watch-cog": () => Promise.resolve().then(function () { return IconDeviceWatchCog$1; }),
  "device-watch-dollar": () => Promise.resolve().then(function () { return IconDeviceWatchDollar$1; }),
  "device-watch-down": () => Promise.resolve().then(function () { return IconDeviceWatchDown$1; }),
  "device-watch-exclamation": () => Promise.resolve().then(function () { return IconDeviceWatchExclamation$1; }),
  "device-watch-heart": () => Promise.resolve().then(function () { return IconDeviceWatchHeart$1; }),
  "device-watch-minus": () => Promise.resolve().then(function () { return IconDeviceWatchMinus$1; }),
  "device-watch-off": () => Promise.resolve().then(function () { return IconDeviceWatchOff$1; }),
  "device-watch-pause": () => Promise.resolve().then(function () { return IconDeviceWatchPause$1; }),
  "device-watch-pin": () => Promise.resolve().then(function () { return IconDeviceWatchPin$1; }),
  "device-watch-plus": () => Promise.resolve().then(function () { return IconDeviceWatchPlus$1; }),
  "device-watch-question": () => Promise.resolve().then(function () { return IconDeviceWatchQuestion$1; }),
  "device-watch-search": () => Promise.resolve().then(function () { return IconDeviceWatchSearch$1; }),
  "device-watch-share": () => Promise.resolve().then(function () { return IconDeviceWatchShare$1; }),
  "device-watch-star": () => Promise.resolve().then(function () { return IconDeviceWatchStar$1; }),
  "device-watch-stats-2": () => Promise.resolve().then(function () { return IconDeviceWatchStats2$1; }),
  "device-watch-stats": () => Promise.resolve().then(function () { return IconDeviceWatchStats$1; }),
  "device-watch-up": () => Promise.resolve().then(function () { return IconDeviceWatchUp$1; }),
  "device-watch-x": () => Promise.resolve().then(function () { return IconDeviceWatchX$1; }),
  "device-watch": () => Promise.resolve().then(function () { return IconDeviceWatch$1; }),
  "devices-2": () => Promise.resolve().then(function () { return IconDevices2$1; }),
  "devices-bolt": () => Promise.resolve().then(function () { return IconDevicesBolt$1; }),
  "devices-cancel": () => Promise.resolve().then(function () { return IconDevicesCancel$1; }),
  "devices-check": () => Promise.resolve().then(function () { return IconDevicesCheck$1; }),
  "devices-code": () => Promise.resolve().then(function () { return IconDevicesCode$1; }),
  "devices-cog": () => Promise.resolve().then(function () { return IconDevicesCog$1; }),
  "devices-dollar": () => Promise.resolve().then(function () { return IconDevicesDollar$1; }),
  "devices-down": () => Promise.resolve().then(function () { return IconDevicesDown$1; }),
  "devices-exclamation": () => Promise.resolve().then(function () { return IconDevicesExclamation$1; }),
  "devices-heart": () => Promise.resolve().then(function () { return IconDevicesHeart$1; }),
  "devices-minus": () => Promise.resolve().then(function () { return IconDevicesMinus$1; }),
  "devices-off": () => Promise.resolve().then(function () { return IconDevicesOff$1; }),
  "devices-pause": () => Promise.resolve().then(function () { return IconDevicesPause$1; }),
  "devices-pc-off": () => Promise.resolve().then(function () { return IconDevicesPcOff$1; }),
  "devices-pc": () => Promise.resolve().then(function () { return IconDevicesPc$1; }),
  "devices-pin": () => Promise.resolve().then(function () { return IconDevicesPin$1; }),
  "devices-plus": () => Promise.resolve().then(function () { return IconDevicesPlus$1; }),
  "devices-question": () => Promise.resolve().then(function () { return IconDevicesQuestion$1; }),
  "devices-search": () => Promise.resolve().then(function () { return IconDevicesSearch$1; }),
  "devices-share": () => Promise.resolve().then(function () { return IconDevicesShare$1; }),
  "devices-star": () => Promise.resolve().then(function () { return IconDevicesStar$1; }),
  "devices-up": () => Promise.resolve().then(function () { return IconDevicesUp$1; }),
  "devices-x": () => Promise.resolve().then(function () { return IconDevicesX$1; }),
  "devices": () => Promise.resolve().then(function () { return IconDevices$1; }),
  "diabolo-off": () => Promise.resolve().then(function () { return IconDiaboloOff$1; }),
  "diabolo-plus": () => Promise.resolve().then(function () { return IconDiaboloPlus$1; }),
  "diabolo": () => Promise.resolve().then(function () { return IconDiabolo$1; }),
  "dialpad-off": () => Promise.resolve().then(function () { return IconDialpadOff$1; }),
  "dialpad": () => Promise.resolve().then(function () { return IconDialpad$1; }),
  "diamond-off": () => Promise.resolve().then(function () { return IconDiamondOff$1; }),
  "diamond": () => Promise.resolve().then(function () { return IconDiamond$1; }),
  "diamonds": () => Promise.resolve().then(function () { return IconDiamonds$1; }),
  "diaper": () => Promise.resolve().then(function () { return IconDiaper$1; }),
  "dice-1": () => Promise.resolve().then(function () { return IconDice1$1; }),
  "dice-2": () => Promise.resolve().then(function () { return IconDice2$1; }),
  "dice-3": () => Promise.resolve().then(function () { return IconDice3$1; }),
  "dice-4": () => Promise.resolve().then(function () { return IconDice4$1; }),
  "dice-5": () => Promise.resolve().then(function () { return IconDice5$1; }),
  "dice-6": () => Promise.resolve().then(function () { return IconDice6$1; }),
  "dice": () => Promise.resolve().then(function () { return IconDice$1; }),
  "dimensions": () => Promise.resolve().then(function () { return IconDimensions$1; }),
  "direction-arrows": () => Promise.resolve().then(function () { return IconDirectionArrows$1; }),
  "direction-horizontal": () => Promise.resolve().then(function () { return IconDirectionHorizontal$1; }),
  "direction-sign-off": () => Promise.resolve().then(function () { return IconDirectionSignOff$1; }),
  "direction-sign": () => Promise.resolve().then(function () { return IconDirectionSign$1; }),
  "direction": () => Promise.resolve().then(function () { return IconDirection$1; }),
  "directions-off": () => Promise.resolve().then(function () { return IconDirectionsOff$1; }),
  "directions": () => Promise.resolve().then(function () { return IconDirections$1; }),
  "disabled-2": () => Promise.resolve().then(function () { return IconDisabled2$1; }),
  "disabled-off": () => Promise.resolve().then(function () { return IconDisabledOff$1; }),
  "disabled": () => Promise.resolve().then(function () { return IconDisabled$1; }),
  "disc-golf": () => Promise.resolve().then(function () { return IconDiscGolf$1; }),
  "disc-off": () => Promise.resolve().then(function () { return IconDiscOff$1; }),
  "disc": () => Promise.resolve().then(function () { return IconDisc$1; }),
  "discount-off": () => Promise.resolve().then(function () { return IconDiscountOff$1; }),
  "discount": () => Promise.resolve().then(function () { return IconDiscount$1; }),
  "divide": () => Promise.resolve().then(function () { return IconDivide$1; }),
  "dna-2-off": () => Promise.resolve().then(function () { return IconDna2Off$1; }),
  "dna-2": () => Promise.resolve().then(function () { return IconDna2$1; }),
  "dna-off": () => Promise.resolve().then(function () { return IconDnaOff$1; }),
  "dna": () => Promise.resolve().then(function () { return IconDna$1; }),
  "dog-bowl": () => Promise.resolve().then(function () { return IconDogBowl$1; }),
  "dog": () => Promise.resolve().then(function () { return IconDog$1; }),
  "door-enter": () => Promise.resolve().then(function () { return IconDoorEnter$1; }),
  "door-exit": () => Promise.resolve().then(function () { return IconDoorExit$1; }),
  "door-off": () => Promise.resolve().then(function () { return IconDoorOff$1; }),
  "door": () => Promise.resolve().then(function () { return IconDoor$1; }),
  "dots-circle-horizontal": () => Promise.resolve().then(function () { return IconDotsCircleHorizontal$1; }),
  "dots-diagonal-2": () => Promise.resolve().then(function () { return IconDotsDiagonal2$1; }),
  "dots-diagonal": () => Promise.resolve().then(function () { return IconDotsDiagonal$1; }),
  "dots-vertical": () => Promise.resolve().then(function () { return IconDotsVertical$1; }),
  "dots": () => Promise.resolve().then(function () { return IconDots$1; }),
  "download-off": () => Promise.resolve().then(function () { return IconDownloadOff$1; }),
  "download": () => Promise.resolve().then(function () { return IconDownload$1; }),
  "drag-drop-2": () => Promise.resolve().then(function () { return IconDragDrop2$1; }),
  "drag-drop": () => Promise.resolve().then(function () { return IconDragDrop$1; }),
  "drone-off": () => Promise.resolve().then(function () { return IconDroneOff$1; }),
  "drone": () => Promise.resolve().then(function () { return IconDrone$1; }),
  "drop-circle": () => Promise.resolve().then(function () { return IconDropCircle$1; }),
  "droplet-bolt": () => Promise.resolve().then(function () { return IconDropletBolt$1; }),
  "droplet-cancel": () => Promise.resolve().then(function () { return IconDropletCancel$1; }),
  "droplet-check": () => Promise.resolve().then(function () { return IconDropletCheck$1; }),
  "droplet-code": () => Promise.resolve().then(function () { return IconDropletCode$1; }),
  "droplet-cog": () => Promise.resolve().then(function () { return IconDropletCog$1; }),
  "droplet-dollar": () => Promise.resolve().then(function () { return IconDropletDollar$1; }),
  "droplet-down": () => Promise.resolve().then(function () { return IconDropletDown$1; }),
  "droplet-exclamation": () => Promise.resolve().then(function () { return IconDropletExclamation$1; }),
  "droplet-half-2": () => Promise.resolve().then(function () { return IconDropletHalf2$1; }),
  "droplet-half": () => Promise.resolve().then(function () { return IconDropletHalf$1; }),
  "droplet-heart": () => Promise.resolve().then(function () { return IconDropletHeart$1; }),
  "droplet-minus": () => Promise.resolve().then(function () { return IconDropletMinus$1; }),
  "droplet-off": () => Promise.resolve().then(function () { return IconDropletOff$1; }),
  "droplet-pause": () => Promise.resolve().then(function () { return IconDropletPause$1; }),
  "droplet-pin": () => Promise.resolve().then(function () { return IconDropletPin$1; }),
  "droplet-plus": () => Promise.resolve().then(function () { return IconDropletPlus$1; }),
  "droplet-question": () => Promise.resolve().then(function () { return IconDropletQuestion$1; }),
  "droplet-search": () => Promise.resolve().then(function () { return IconDropletSearch$1; }),
  "droplet-share": () => Promise.resolve().then(function () { return IconDropletShare$1; }),
  "droplet-star": () => Promise.resolve().then(function () { return IconDropletStar$1; }),
  "droplet-up": () => Promise.resolve().then(function () { return IconDropletUp$1; }),
  "droplet-x": () => Promise.resolve().then(function () { return IconDropletX$1; }),
  "droplet": () => Promise.resolve().then(function () { return IconDroplet$1; }),
  "droplets": () => Promise.resolve().then(function () { return IconDroplets$1; }),
  "dual-screen": () => Promise.resolve().then(function () { return IconDualScreen$1; }),
  "dumpling": () => Promise.resolve().then(function () { return IconDumpling$1; }),
  "e-passport": () => Promise.resolve().then(function () { return IconEPassport$1; }),
  "ear-off": () => Promise.resolve().then(function () { return IconEarOff$1; }),
  "ear-scan": () => Promise.resolve().then(function () { return IconEarScan$1; }),
  "ear": () => Promise.resolve().then(function () { return IconEar$1; }),
  "ease-in-control-point": () => Promise.resolve().then(function () { return IconEaseInControlPoint$1; }),
  "ease-in-out-control-points": () => Promise.resolve().then(function () { return IconEaseInOutControlPoints$1; }),
  "ease-in-out": () => Promise.resolve().then(function () { return IconEaseInOut$1; }),
  "ease-in": () => Promise.resolve().then(function () { return IconEaseIn$1; }),
  "ease-out-control-point": () => Promise.resolve().then(function () { return IconEaseOutControlPoint$1; }),
  "ease-out": () => Promise.resolve().then(function () { return IconEaseOut$1; }),
  "edit-circle-off": () => Promise.resolve().then(function () { return IconEditCircleOff$1; }),
  "edit-circle": () => Promise.resolve().then(function () { return IconEditCircle$1; }),
  "edit-off": () => Promise.resolve().then(function () { return IconEditOff$1; }),
  "edit": () => Promise.resolve().then(function () { return IconEdit$1; }),
  "egg-cracked": () => Promise.resolve().then(function () { return IconEggCracked$1; }),
  "egg-fried": () => Promise.resolve().then(function () { return IconEggFried$1; }),
  "egg-off": () => Promise.resolve().then(function () { return IconEggOff$1; }),
  "egg": () => Promise.resolve().then(function () { return IconEgg$1; }),
  "eggs": () => Promise.resolve().then(function () { return IconEggs$1; }),
  "elevator-off": () => Promise.resolve().then(function () { return IconElevatorOff$1; }),
  "elevator": () => Promise.resolve().then(function () { return IconElevator$1; }),
  "emergency-bed": () => Promise.resolve().then(function () { return IconEmergencyBed$1; }),
  "empathize-off": () => Promise.resolve().then(function () { return IconEmpathizeOff$1; }),
  "empathize": () => Promise.resolve().then(function () { return IconEmpathize$1; }),
  "emphasis": () => Promise.resolve().then(function () { return IconEmphasis$1; }),
  "engine-off": () => Promise.resolve().then(function () { return IconEngineOff$1; }),
  "engine": () => Promise.resolve().then(function () { return IconEngine$1; }),
  "equal-double": () => Promise.resolve().then(function () { return IconEqualDouble$1; }),
  "equal-not": () => Promise.resolve().then(function () { return IconEqualNot$1; }),
  "equal": () => Promise.resolve().then(function () { return IconEqual$1; }),
  "eraser-off": () => Promise.resolve().then(function () { return IconEraserOff$1; }),
  "eraser": () => Promise.resolve().then(function () { return IconEraser$1; }),
  "error-404-off": () => Promise.resolve().then(function () { return IconError404Off$1; }),
  "error-404": () => Promise.resolve().then(function () { return IconError404$1; }),
  "escalator-down": () => Promise.resolve().then(function () { return IconEscalatorDown$1; }),
  "escalator-up": () => Promise.resolve().then(function () { return IconEscalatorUp$1; }),
  "escalator": () => Promise.resolve().then(function () { return IconEscalator$1; }),
  "exchange-off": () => Promise.resolve().then(function () { return IconExchangeOff$1; }),
  "exchange": () => Promise.resolve().then(function () { return IconExchange$1; }),
  "exclamation-circle": () => Promise.resolve().then(function () { return IconExclamationCircle$1; }),
  "exclamation-mark-off": () => Promise.resolve().then(function () { return IconExclamationMarkOff$1; }),
  "exclamation-mark": () => Promise.resolve().then(function () { return IconExclamationMark$1; }),
  "explicit-off": () => Promise.resolve().then(function () { return IconExplicitOff$1; }),
  "explicit": () => Promise.resolve().then(function () { return IconExplicit$1; }),
  "exposure-0": () => Promise.resolve().then(function () { return IconExposure0$1; }),
  "exposure-minus-1": () => Promise.resolve().then(function () { return IconExposureMinus1$1; }),
  "exposure-minus-2": () => Promise.resolve().then(function () { return IconExposureMinus2$1; }),
  "exposure-off": () => Promise.resolve().then(function () { return IconExposureOff$1; }),
  "exposure-plus-1": () => Promise.resolve().then(function () { return IconExposurePlus1$1; }),
  "exposure-plus-2": () => Promise.resolve().then(function () { return IconExposurePlus2$1; }),
  "exposure": () => Promise.resolve().then(function () { return IconExposure$1; }),
  "external-link-off": () => Promise.resolve().then(function () { return IconExternalLinkOff$1; }),
  "external-link": () => Promise.resolve().then(function () { return IconExternalLink$1; }),
  "eye-bitcoin": () => Promise.resolve().then(function () { return IconEyeBitcoin$1; }),
  "eye-bolt": () => Promise.resolve().then(function () { return IconEyeBolt$1; }),
  "eye-cancel": () => Promise.resolve().then(function () { return IconEyeCancel$1; }),
  "eye-check": () => Promise.resolve().then(function () { return IconEyeCheck$1; }),
  "eye-closed": () => Promise.resolve().then(function () { return IconEyeClosed$1; }),
  "eye-code": () => Promise.resolve().then(function () { return IconEyeCode$1; }),
  "eye-cog": () => Promise.resolve().then(function () { return IconEyeCog$1; }),
  "eye-discount": () => Promise.resolve().then(function () { return IconEyeDiscount$1; }),
  "eye-dollar": () => Promise.resolve().then(function () { return IconEyeDollar$1; }),
  "eye-dotted": () => Promise.resolve().then(function () { return IconEyeDotted$1; }),
  "eye-down": () => Promise.resolve().then(function () { return IconEyeDown$1; }),
  "eye-edit": () => Promise.resolve().then(function () { return IconEyeEdit$1; }),
  "eye-exclamation": () => Promise.resolve().then(function () { return IconEyeExclamation$1; }),
  "eye-heart": () => Promise.resolve().then(function () { return IconEyeHeart$1; }),
  "eye-minus": () => Promise.resolve().then(function () { return IconEyeMinus$1; }),
  "eye-off": () => Promise.resolve().then(function () { return IconEyeOff$1; }),
  "eye-pause": () => Promise.resolve().then(function () { return IconEyePause$1; }),
  "eye-pin": () => Promise.resolve().then(function () { return IconEyePin$1; }),
  "eye-plus": () => Promise.resolve().then(function () { return IconEyePlus$1; }),
  "eye-question": () => Promise.resolve().then(function () { return IconEyeQuestion$1; }),
  "eye-search": () => Promise.resolve().then(function () { return IconEyeSearch$1; }),
  "eye-share": () => Promise.resolve().then(function () { return IconEyeShare$1; }),
  "eye-spark": () => Promise.resolve().then(function () { return IconEyeSpark$1; }),
  "eye-star": () => Promise.resolve().then(function () { return IconEyeStar$1; }),
  "eye-table": () => Promise.resolve().then(function () { return IconEyeTable$1; }),
  "eye-up": () => Promise.resolve().then(function () { return IconEyeUp$1; }),
  "eye-x": () => Promise.resolve().then(function () { return IconEyeX$1; }),
  "eye": () => Promise.resolve().then(function () { return IconEye$1; }),
  "eyeglass-2": () => Promise.resolve().then(function () { return IconEyeglass2$1; }),
  "eyeglass-off": () => Promise.resolve().then(function () { return IconEyeglassOff$1; }),
  "eyeglass": () => Promise.resolve().then(function () { return IconEyeglass$1; }),
  "face-id-error": () => Promise.resolve().then(function () { return IconFaceIdError$1; }),
  "face-id": () => Promise.resolve().then(function () { return IconFaceId$1; }),
  "face-mask-off": () => Promise.resolve().then(function () { return IconFaceMaskOff$1; }),
  "face-mask": () => Promise.resolve().then(function () { return IconFaceMask$1; }),
  "fall": () => Promise.resolve().then(function () { return IconFall$1; }),
  "favicon": () => Promise.resolve().then(function () { return IconFavicon$1; }),
  "feather-off": () => Promise.resolve().then(function () { return IconFeatherOff$1; }),
  "feather": () => Promise.resolve().then(function () { return IconFeather$1; }),
  "fence-off": () => Promise.resolve().then(function () { return IconFenceOff$1; }),
  "fence": () => Promise.resolve().then(function () { return IconFence$1; }),
  "ferry": () => Promise.resolve().then(function () { return IconFerry$1; }),
  "fidget-spinner": () => Promise.resolve().then(function () { return IconFidgetSpinner$1; }),
  "file-3d": () => Promise.resolve().then(function () { return IconFile3d$1; }),
  "file-ai": () => Promise.resolve().then(function () { return IconFileAi$1; }),
  "file-alert": () => Promise.resolve().then(function () { return IconFileAlert$1; }),
  "file-analytics": () => Promise.resolve().then(function () { return IconFileAnalytics$1; }),
  "file-arrow-left": () => Promise.resolve().then(function () { return IconFileArrowLeft$1; }),
  "file-arrow-right": () => Promise.resolve().then(function () { return IconFileArrowRight$1; }),
  "file-barcode": () => Promise.resolve().then(function () { return IconFileBarcode$1; }),
  "file-bitcoin": () => Promise.resolve().then(function () { return IconFileBitcoin$1; }),
  "file-broken": () => Promise.resolve().then(function () { return IconFileBroken$1; }),
  "file-certificate": () => Promise.resolve().then(function () { return IconFileCertificate$1; }),
  "file-chart": () => Promise.resolve().then(function () { return IconFileChart$1; }),
  "file-check": () => Promise.resolve().then(function () { return IconFileCheck$1; }),
  "file-code-2": () => Promise.resolve().then(function () { return IconFileCode2$1; }),
  "file-code": () => Promise.resolve().then(function () { return IconFileCode$1; }),
  "file-cv": () => Promise.resolve().then(function () { return IconFileCv$1; }),
  "file-database": () => Promise.resolve().then(function () { return IconFileDatabase$1; }),
  "file-delta": () => Promise.resolve().then(function () { return IconFileDelta$1; }),
  "file-description": () => Promise.resolve().then(function () { return IconFileDescription$1; }),
  "file-diff": () => Promise.resolve().then(function () { return IconFileDiff$1; }),
  "file-digit": () => Promise.resolve().then(function () { return IconFileDigit$1; }),
  "file-dislike": () => Promise.resolve().then(function () { return IconFileDislike$1; }),
  "file-dollar": () => Promise.resolve().then(function () { return IconFileDollar$1; }),
  "file-dots": () => Promise.resolve().then(function () { return IconFileDots$1; }),
  "file-download": () => Promise.resolve().then(function () { return IconFileDownload$1; }),
  "file-euro": () => Promise.resolve().then(function () { return IconFileEuro$1; }),
  "file-excel": () => Promise.resolve().then(function () { return IconFileExcel$1; }),
  "file-export": () => Promise.resolve().then(function () { return IconFileExport$1; }),
  "file-function": () => Promise.resolve().then(function () { return IconFileFunction$1; }),
  "file-horizontal": () => Promise.resolve().then(function () { return IconFileHorizontal$1; }),
  "file-import": () => Promise.resolve().then(function () { return IconFileImport$1; }),
  "file-infinity": () => Promise.resolve().then(function () { return IconFileInfinity$1; }),
  "file-info": () => Promise.resolve().then(function () { return IconFileInfo$1; }),
  "file-invoice": () => Promise.resolve().then(function () { return IconFileInvoice$1; }),
  "file-isr": () => Promise.resolve().then(function () { return IconFileIsr$1; }),
  "file-lambda": () => Promise.resolve().then(function () { return IconFileLambda$1; }),
  "file-like": () => Promise.resolve().then(function () { return IconFileLike$1; }),
  "file-minus": () => Promise.resolve().then(function () { return IconFileMinus$1; }),
  "file-music": () => Promise.resolve().then(function () { return IconFileMusic$1; }),
  "file-neutral": () => Promise.resolve().then(function () { return IconFileNeutral$1; }),
  "file-off": () => Promise.resolve().then(function () { return IconFileOff$1; }),
  "file-orientation": () => Promise.resolve().then(function () { return IconFileOrientation$1; }),
  "file-pencil": () => Promise.resolve().then(function () { return IconFilePencil$1; }),
  "file-percent": () => Promise.resolve().then(function () { return IconFilePercent$1; }),
  "file-phone": () => Promise.resolve().then(function () { return IconFilePhone$1; }),
  "file-plus": () => Promise.resolve().then(function () { return IconFilePlus$1; }),
  "file-power": () => Promise.resolve().then(function () { return IconFilePower$1; }),
  "file-report": () => Promise.resolve().then(function () { return IconFileReport$1; }),
  "file-rss": () => Promise.resolve().then(function () { return IconFileRss$1; }),
  "file-sad": () => Promise.resolve().then(function () { return IconFileSad$1; }),
  "file-scissors": () => Promise.resolve().then(function () { return IconFileScissors$1; }),
  "file-search": () => Promise.resolve().then(function () { return IconFileSearch$1; }),
  "file-settings": () => Promise.resolve().then(function () { return IconFileSettings$1; }),
  "file-shredder": () => Promise.resolve().then(function () { return IconFileShredder$1; }),
  "file-signal": () => Promise.resolve().then(function () { return IconFileSignal$1; }),
  "file-smile": () => Promise.resolve().then(function () { return IconFileSmile$1; }),
  "file-spark": () => Promise.resolve().then(function () { return IconFileSpark$1; }),
  "file-spreadsheet": () => Promise.resolve().then(function () { return IconFileSpreadsheet$1; }),
  "file-stack": () => Promise.resolve().then(function () { return IconFileStack$1; }),
  "file-star": () => Promise.resolve().then(function () { return IconFileStar$1; }),
  "file-symlink": () => Promise.resolve().then(function () { return IconFileSymlink$1; }),
  "file-text-ai": () => Promise.resolve().then(function () { return IconFileTextAi$1; }),
  "file-text-shield": () => Promise.resolve().then(function () { return IconFileTextShield$1; }),
  "file-text-spark": () => Promise.resolve().then(function () { return IconFileTextSpark$1; }),
  "file-text": () => Promise.resolve().then(function () { return IconFileText$1; }),
  "file-time": () => Promise.resolve().then(function () { return IconFileTime$1; }),
  "file-type-bmp": () => Promise.resolve().then(function () { return IconFileTypeBmp$1; }),
  "file-type-css": () => Promise.resolve().then(function () { return IconFileTypeCss$1; }),
  "file-type-csv": () => Promise.resolve().then(function () { return IconFileTypeCsv$1; }),
  "file-type-doc": () => Promise.resolve().then(function () { return IconFileTypeDoc$1; }),
  "file-type-docx": () => Promise.resolve().then(function () { return IconFileTypeDocx$1; }),
  "file-type-html": () => Promise.resolve().then(function () { return IconFileTypeHtml$1; }),
  "file-type-jpg": () => Promise.resolve().then(function () { return IconFileTypeJpg$1; }),
  "file-type-js": () => Promise.resolve().then(function () { return IconFileTypeJs$1; }),
  "file-type-jsx": () => Promise.resolve().then(function () { return IconFileTypeJsx$1; }),
  "file-type-pdf": () => Promise.resolve().then(function () { return IconFileTypePdf$1; }),
  "file-type-php": () => Promise.resolve().then(function () { return IconFileTypePhp$1; }),
  "file-type-png": () => Promise.resolve().then(function () { return IconFileTypePng$1; }),
  "file-type-ppt": () => Promise.resolve().then(function () { return IconFileTypePpt$1; }),
  "file-type-rs": () => Promise.resolve().then(function () { return IconFileTypeRs$1; }),
  "file-type-sql": () => Promise.resolve().then(function () { return IconFileTypeSql$1; }),
  "file-type-svg": () => Promise.resolve().then(function () { return IconFileTypeSvg$1; }),
  "file-type-ts": () => Promise.resolve().then(function () { return IconFileTypeTs$1; }),
  "file-type-tsx": () => Promise.resolve().then(function () { return IconFileTypeTsx$1; }),
  "file-type-txt": () => Promise.resolve().then(function () { return IconFileTypeTxt$1; }),
  "file-type-vue": () => Promise.resolve().then(function () { return IconFileTypeVue$1; }),
  "file-type-xls": () => Promise.resolve().then(function () { return IconFileTypeXls$1; }),
  "file-type-xml": () => Promise.resolve().then(function () { return IconFileTypeXml$1; }),
  "file-type-zip": () => Promise.resolve().then(function () { return IconFileTypeZip$1; }),
  "file-typography": () => Promise.resolve().then(function () { return IconFileTypography$1; }),
  "file-unknown": () => Promise.resolve().then(function () { return IconFileUnknown$1; }),
  "file-upload": () => Promise.resolve().then(function () { return IconFileUpload$1; }),
  "file-vector": () => Promise.resolve().then(function () { return IconFileVector$1; }),
  "file-word": () => Promise.resolve().then(function () { return IconFileWord$1; }),
  "file-x": () => Promise.resolve().then(function () { return IconFileX$1; }),
  "file-zip": () => Promise.resolve().then(function () { return IconFileZip$1; }),
  "file": () => Promise.resolve().then(function () { return IconFile$1; }),
  "files-off": () => Promise.resolve().then(function () { return IconFilesOff$1; }),
  "files": () => Promise.resolve().then(function () { return IconFiles$1; }),
  "filter-bolt": () => Promise.resolve().then(function () { return IconFilterBolt$1; }),
  "filter-cancel": () => Promise.resolve().then(function () { return IconFilterCancel$1; }),
  "filter-check": () => Promise.resolve().then(function () { return IconFilterCheck$1; }),
  "filter-code": () => Promise.resolve().then(function () { return IconFilterCode$1; }),
  "filter-cog": () => Promise.resolve().then(function () { return IconFilterCog$1; }),
  "filter-discount": () => Promise.resolve().then(function () { return IconFilterDiscount$1; }),
  "filter-dollar": () => Promise.resolve().then(function () { return IconFilterDollar$1; }),
  "filter-down": () => Promise.resolve().then(function () { return IconFilterDown$1; }),
  "filter-edit": () => Promise.resolve().then(function () { return IconFilterEdit$1; }),
  "filter-exclamation": () => Promise.resolve().then(function () { return IconFilterExclamation$1; }),
  "filter-heart": () => Promise.resolve().then(function () { return IconFilterHeart$1; }),
  "filter-minus": () => Promise.resolve().then(function () { return IconFilterMinus$1; }),
  "filter-off": () => Promise.resolve().then(function () { return IconFilterOff$1; }),
  "filter-pause": () => Promise.resolve().then(function () { return IconFilterPause$1; }),
  "filter-pin": () => Promise.resolve().then(function () { return IconFilterPin$1; }),
  "filter-plus": () => Promise.resolve().then(function () { return IconFilterPlus$1; }),
  "filter-question": () => Promise.resolve().then(function () { return IconFilterQuestion$1; }),
  "filter-search": () => Promise.resolve().then(function () { return IconFilterSearch$1; }),
  "filter-share": () => Promise.resolve().then(function () { return IconFilterShare$1; }),
  "filter-star": () => Promise.resolve().then(function () { return IconFilterStar$1; }),
  "filter-up": () => Promise.resolve().then(function () { return IconFilterUp$1; }),
  "filter-x": () => Promise.resolve().then(function () { return IconFilterX$1; }),
  "filter": () => Promise.resolve().then(function () { return IconFilter$1; }),
  "filters": () => Promise.resolve().then(function () { return IconFilters$1; }),
  "fingerprint-off": () => Promise.resolve().then(function () { return IconFingerprintOff$1; }),
  "fingerprint-scan": () => Promise.resolve().then(function () { return IconFingerprintScan$1; }),
  "fingerprint": () => Promise.resolve().then(function () { return IconFingerprint$1; }),
  "fire-extinguisher": () => Promise.resolve().then(function () { return IconFireExtinguisher$1; }),
  "fire-hydrant-off": () => Promise.resolve().then(function () { return IconFireHydrantOff$1; }),
  "fire-hydrant": () => Promise.resolve().then(function () { return IconFireHydrant$1; }),
  "firetruck": () => Promise.resolve().then(function () { return IconFiretruck$1; }),
  "first-aid-kit-off": () => Promise.resolve().then(function () { return IconFirstAidKitOff$1; }),
  "first-aid-kit": () => Promise.resolve().then(function () { return IconFirstAidKit$1; }),
  "fish-bone": () => Promise.resolve().then(function () { return IconFishBone$1; }),
  "fish-christianity": () => Promise.resolve().then(function () { return IconFishChristianity$1; }),
  "fish-hook-off": () => Promise.resolve().then(function () { return IconFishHookOff$1; }),
  "fish-hook": () => Promise.resolve().then(function () { return IconFishHook$1; }),
  "fish-off": () => Promise.resolve().then(function () { return IconFishOff$1; }),
  "fish": () => Promise.resolve().then(function () { return IconFish$1; }),
  "flag-2-off": () => Promise.resolve().then(function () { return IconFlag2Off$1; }),
  "flag-2": () => Promise.resolve().then(function () { return IconFlag2$1; }),
  "flag-3": () => Promise.resolve().then(function () { return IconFlag3$1; }),
  "flag-bitcoin": () => Promise.resolve().then(function () { return IconFlagBitcoin$1; }),
  "flag-bolt": () => Promise.resolve().then(function () { return IconFlagBolt$1; }),
  "flag-cancel": () => Promise.resolve().then(function () { return IconFlagCancel$1; }),
  "flag-check": () => Promise.resolve().then(function () { return IconFlagCheck$1; }),
  "flag-code": () => Promise.resolve().then(function () { return IconFlagCode$1; }),
  "flag-cog": () => Promise.resolve().then(function () { return IconFlagCog$1; }),
  "flag-discount": () => Promise.resolve().then(function () { return IconFlagDiscount$1; }),
  "flag-dollar": () => Promise.resolve().then(function () { return IconFlagDollar$1; }),
  "flag-down": () => Promise.resolve().then(function () { return IconFlagDown$1; }),
  "flag-exclamation": () => Promise.resolve().then(function () { return IconFlagExclamation$1; }),
  "flag-heart": () => Promise.resolve().then(function () { return IconFlagHeart$1; }),
  "flag-minus": () => Promise.resolve().then(function () { return IconFlagMinus$1; }),
  "flag-off": () => Promise.resolve().then(function () { return IconFlagOff$1; }),
  "flag-pause": () => Promise.resolve().then(function () { return IconFlagPause$1; }),
  "flag-pin": () => Promise.resolve().then(function () { return IconFlagPin$1; }),
  "flag-plus": () => Promise.resolve().then(function () { return IconFlagPlus$1; }),
  "flag-question": () => Promise.resolve().then(function () { return IconFlagQuestion$1; }),
  "flag-search": () => Promise.resolve().then(function () { return IconFlagSearch$1; }),
  "flag-share": () => Promise.resolve().then(function () { return IconFlagShare$1; }),
  "flag-spark": () => Promise.resolve().then(function () { return IconFlagSpark$1; }),
  "flag-star": () => Promise.resolve().then(function () { return IconFlagStar$1; }),
  "flag-up": () => Promise.resolve().then(function () { return IconFlagUp$1; }),
  "flag-x": () => Promise.resolve().then(function () { return IconFlagX$1; }),
  "flag": () => Promise.resolve().then(function () { return IconFlag$1; }),
  "flame-off": () => Promise.resolve().then(function () { return IconFlameOff$1; }),
  "flame": () => Promise.resolve().then(function () { return IconFlame$1; }),
  "flare": () => Promise.resolve().then(function () { return IconFlare$1; }),
  "flask-2-off": () => Promise.resolve().then(function () { return IconFlask2Off$1; }),
  "flask-2": () => Promise.resolve().then(function () { return IconFlask2$1; }),
  "flask-off": () => Promise.resolve().then(function () { return IconFlaskOff$1; }),
  "flask": () => Promise.resolve().then(function () { return IconFlask$1; }),
  "flip-flops": () => Promise.resolve().then(function () { return IconFlipFlops$1; }),
  "flip-horizontal": () => Promise.resolve().then(function () { return IconFlipHorizontal$1; }),
  "flip-vertical": () => Promise.resolve().then(function () { return IconFlipVertical$1; }),
  "float-center": () => Promise.resolve().then(function () { return IconFloatCenter$1; }),
  "float-left": () => Promise.resolve().then(function () { return IconFloatLeft$1; }),
  "float-none": () => Promise.resolve().then(function () { return IconFloatNone$1; }),
  "float-right": () => Promise.resolve().then(function () { return IconFloatRight$1; }),
  "flower-off": () => Promise.resolve().then(function () { return IconFlowerOff$1; }),
  "flower": () => Promise.resolve().then(function () { return IconFlower$1; }),
  "focus-2": () => Promise.resolve().then(function () { return IconFocus2$1; }),
  "focus-auto": () => Promise.resolve().then(function () { return IconFocusAuto$1; }),
  "focus-centered": () => Promise.resolve().then(function () { return IconFocusCentered$1; }),
  "focus": () => Promise.resolve().then(function () { return IconFocus$1; }),
  "fold-down": () => Promise.resolve().then(function () { return IconFoldDown$1; }),
  "fold-up": () => Promise.resolve().then(function () { return IconFoldUp$1; }),
  "fold": () => Promise.resolve().then(function () { return IconFold$1; }),
  "folder-bolt": () => Promise.resolve().then(function () { return IconFolderBolt$1; }),
  "folder-cancel": () => Promise.resolve().then(function () { return IconFolderCancel$1; }),
  "folder-check": () => Promise.resolve().then(function () { return IconFolderCheck$1; }),
  "folder-code": () => Promise.resolve().then(function () { return IconFolderCode$1; }),
  "folder-cog": () => Promise.resolve().then(function () { return IconFolderCog$1; }),
  "folder-dollar": () => Promise.resolve().then(function () { return IconFolderDollar$1; }),
  "folder-down": () => Promise.resolve().then(function () { return IconFolderDown$1; }),
  "folder-exclamation": () => Promise.resolve().then(function () { return IconFolderExclamation$1; }),
  "folder-heart": () => Promise.resolve().then(function () { return IconFolderHeart$1; }),
  "folder-minus": () => Promise.resolve().then(function () { return IconFolderMinus$1; }),
  "folder-off": () => Promise.resolve().then(function () { return IconFolderOff$1; }),
  "folder-open": () => Promise.resolve().then(function () { return IconFolderOpen$1; }),
  "folder-pause": () => Promise.resolve().then(function () { return IconFolderPause$1; }),
  "folder-pin": () => Promise.resolve().then(function () { return IconFolderPin$1; }),
  "folder-plus": () => Promise.resolve().then(function () { return IconFolderPlus$1; }),
  "folder-question": () => Promise.resolve().then(function () { return IconFolderQuestion$1; }),
  "folder-root": () => Promise.resolve().then(function () { return IconFolderRoot$1; }),
  "folder-search": () => Promise.resolve().then(function () { return IconFolderSearch$1; }),
  "folder-share": () => Promise.resolve().then(function () { return IconFolderShare$1; }),
  "folder-star": () => Promise.resolve().then(function () { return IconFolderStar$1; }),
  "folder-symlink": () => Promise.resolve().then(function () { return IconFolderSymlink$1; }),
  "folder-up": () => Promise.resolve().then(function () { return IconFolderUp$1; }),
  "folder-x": () => Promise.resolve().then(function () { return IconFolderX$1; }),
  "folder": () => Promise.resolve().then(function () { return IconFolder$1; }),
  "folders-off": () => Promise.resolve().then(function () { return IconFoldersOff$1; }),
  "folders": () => Promise.resolve().then(function () { return IconFolders$1; }),
  "forbid-2": () => Promise.resolve().then(function () { return IconForbid2$1; }),
  "forbid": () => Promise.resolve().then(function () { return IconForbid$1; }),
  "forklift": () => Promise.resolve().then(function () { return IconForklift$1; }),
  "forms": () => Promise.resolve().then(function () { return IconForms$1; }),
  "fountain-off": () => Promise.resolve().then(function () { return IconFountainOff$1; }),
  "fountain": () => Promise.resolve().then(function () { return IconFountain$1; }),
  "frame-off": () => Promise.resolve().then(function () { return IconFrameOff$1; }),
  "frame": () => Promise.resolve().then(function () { return IconFrame$1; }),
  "free-rights": () => Promise.resolve().then(function () { return IconFreeRights$1; }),
  "freeze-column": () => Promise.resolve().then(function () { return IconFreezeColumn$1; }),
  "freeze-row-column": () => Promise.resolve().then(function () { return IconFreezeRowColumn$1; }),
  "freeze-row": () => Promise.resolve().then(function () { return IconFreezeRow$1; }),
  "fridge-off": () => Promise.resolve().then(function () { return IconFridgeOff$1; }),
  "fridge": () => Promise.resolve().then(function () { return IconFridge$1; }),
  "friends-off": () => Promise.resolve().then(function () { return IconFriendsOff$1; }),
  "friends": () => Promise.resolve().then(function () { return IconFriends$1; }),
  "frustum-off": () => Promise.resolve().then(function () { return IconFrustumOff$1; }),
  "frustum-plus": () => Promise.resolve().then(function () { return IconFrustumPlus$1; }),
  "frustum": () => Promise.resolve().then(function () { return IconFrustum$1; }),
  "function-off": () => Promise.resolve().then(function () { return IconFunctionOff$1; }),
  "function": () => Promise.resolve().then(function () { return IconFunction$1; }),
  "galaxy": () => Promise.resolve().then(function () { return IconGalaxy$1; }),
  "garden-cart-off": () => Promise.resolve().then(function () { return IconGardenCartOff$1; }),
  "garden-cart": () => Promise.resolve().then(function () { return IconGardenCart$1; }),
  "gas-station-off": () => Promise.resolve().then(function () { return IconGasStationOff$1; }),
  "gas-station": () => Promise.resolve().then(function () { return IconGasStation$1; }),
  "gauge-off": () => Promise.resolve().then(function () { return IconGaugeOff$1; }),
  "gauge": () => Promise.resolve().then(function () { return IconGauge$1; }),
  "gavel": () => Promise.resolve().then(function () { return IconGavel$1; }),
  "gender-agender": () => Promise.resolve().then(function () { return IconGenderAgender$1; }),
  "gender-androgyne": () => Promise.resolve().then(function () { return IconGenderAndrogyne$1; }),
  "gender-bigender": () => Promise.resolve().then(function () { return IconGenderBigender$1; }),
  "gender-demiboy": () => Promise.resolve().then(function () { return IconGenderDemiboy$1; }),
  "gender-demigirl": () => Promise.resolve().then(function () { return IconGenderDemigirl$1; }),
  "gender-epicene": () => Promise.resolve().then(function () { return IconGenderEpicene$1; }),
  "gender-female": () => Promise.resolve().then(function () { return IconGenderFemale$1; }),
  "gender-femme": () => Promise.resolve().then(function () { return IconGenderFemme$1; }),
  "gender-genderfluid": () => Promise.resolve().then(function () { return IconGenderGenderfluid$1; }),
  "gender-genderless": () => Promise.resolve().then(function () { return IconGenderGenderless$1; }),
  "gender-genderqueer": () => Promise.resolve().then(function () { return IconGenderGenderqueer$1; }),
  "gender-hermaphrodite": () => Promise.resolve().then(function () { return IconGenderHermaphrodite$1; }),
  "gender-intergender": () => Promise.resolve().then(function () { return IconGenderIntergender$1; }),
  "gender-male": () => Promise.resolve().then(function () { return IconGenderMale$1; }),
  "gender-neutrois": () => Promise.resolve().then(function () { return IconGenderNeutrois$1; }),
  "gender-third": () => Promise.resolve().then(function () { return IconGenderThird$1; }),
  "gender-transgender": () => Promise.resolve().then(function () { return IconGenderTransgender$1; }),
  "gender-trasvesti": () => Promise.resolve().then(function () { return IconGenderTrasvesti$1; }),
  "geometry": () => Promise.resolve().then(function () { return IconGeometry$1; }),
  "ghost-2": () => Promise.resolve().then(function () { return IconGhost2$1; }),
  "ghost-3": () => Promise.resolve().then(function () { return IconGhost3$1; }),
  "ghost-off": () => Promise.resolve().then(function () { return IconGhostOff$1; }),
  "ghost": () => Promise.resolve().then(function () { return IconGhost$1; }),
  "gif": () => Promise.resolve().then(function () { return IconGif$1; }),
  "gift-card": () => Promise.resolve().then(function () { return IconGiftCard$1; }),
  "gift-off": () => Promise.resolve().then(function () { return IconGiftOff$1; }),
  "gift": () => Promise.resolve().then(function () { return IconGift$1; }),
  "git-branch-deleted": () => Promise.resolve().then(function () { return IconGitBranchDeleted$1; }),
  "git-branch": () => Promise.resolve().then(function () { return IconGitBranch$1; }),
  "git-cherry-pick": () => Promise.resolve().then(function () { return IconGitCherryPick$1; }),
  "git-commit": () => Promise.resolve().then(function () { return IconGitCommit$1; }),
  "git-compare": () => Promise.resolve().then(function () { return IconGitCompare$1; }),
  "git-fork": () => Promise.resolve().then(function () { return IconGitFork$1; }),
  "git-merge": () => Promise.resolve().then(function () { return IconGitMerge$1; }),
  "git-pull-request-closed": () => Promise.resolve().then(function () { return IconGitPullRequestClosed$1; }),
  "git-pull-request-draft": () => Promise.resolve().then(function () { return IconGitPullRequestDraft$1; }),
  "git-pull-request": () => Promise.resolve().then(function () { return IconGitPullRequest$1; }),
  "gizmo": () => Promise.resolve().then(function () { return IconGizmo$1; }),
  "glass-champagne": () => Promise.resolve().then(function () { return IconGlassChampagne$1; }),
  "glass-cocktail": () => Promise.resolve().then(function () { return IconGlassCocktail$1; }),
  "glass-full": () => Promise.resolve().then(function () { return IconGlassFull$1; }),
  "glass-gin": () => Promise.resolve().then(function () { return IconGlassGin$1; }),
  "glass-off": () => Promise.resolve().then(function () { return IconGlassOff$1; }),
  "glass": () => Promise.resolve().then(function () { return IconGlass$1; }),
  "globe-off": () => Promise.resolve().then(function () { return IconGlobeOff$1; }),
  "globe": () => Promise.resolve().then(function () { return IconGlobe$1; }),
  "go-game": () => Promise.resolve().then(function () { return IconGoGame$1; }),
  "golf-off": () => Promise.resolve().then(function () { return IconGolfOff$1; }),
  "golf": () => Promise.resolve().then(function () { return IconGolf$1; }),
  "gps": () => Promise.resolve().then(function () { return IconGps$1; }),
  "gradienter": () => Promise.resolve().then(function () { return IconGradienter$1; }),
  "grain": () => Promise.resolve().then(function () { return IconGrain$1; }),
  "graph-off": () => Promise.resolve().then(function () { return IconGraphOff$1; }),
  "graph": () => Promise.resolve().then(function () { return IconGraph$1; }),
  "grave-2": () => Promise.resolve().then(function () { return IconGrave2$1; }),
  "grave": () => Promise.resolve().then(function () { return IconGrave$1; }),
  "grid-3x3": () => Promise.resolve().then(function () { return IconGrid3x3$1; }),
  "grid-4x4": () => Promise.resolve().then(function () { return IconGrid4x4$1; }),
  "grid-dots": () => Promise.resolve().then(function () { return IconGridDots$1; }),
  "grid-goldenratio": () => Promise.resolve().then(function () { return IconGridGoldenratio$1; }),
  "grid-pattern": () => Promise.resolve().then(function () { return IconGridPattern$1; }),
  "grid-scan": () => Promise.resolve().then(function () { return IconGridScan$1; }),
  "grill-fork": () => Promise.resolve().then(function () { return IconGrillFork$1; }),
  "grill-off": () => Promise.resolve().then(function () { return IconGrillOff$1; }),
  "grill-spatula": () => Promise.resolve().then(function () { return IconGrillSpatula$1; }),
  "grill": () => Promise.resolve().then(function () { return IconGrill$1; }),
  "grip-horizontal": () => Promise.resolve().then(function () { return IconGripHorizontal$1; }),
  "grip-vertical": () => Promise.resolve().then(function () { return IconGripVertical$1; }),
  "growth": () => Promise.resolve().then(function () { return IconGrowth$1; }),
  "guitar-pick": () => Promise.resolve().then(function () { return IconGuitarPick$1; }),
  "gymnastics": () => Promise.resolve().then(function () { return IconGymnastics$1; }),
  "h-1": () => Promise.resolve().then(function () { return IconH1$1; }),
  "h-2": () => Promise.resolve().then(function () { return IconH2$1; }),
  "h-3": () => Promise.resolve().then(function () { return IconH3$1; }),
  "h-4": () => Promise.resolve().then(function () { return IconH4$1; }),
  "h-5": () => Promise.resolve().then(function () { return IconH5$1; }),
  "h-6": () => Promise.resolve().then(function () { return IconH6$1; }),
  "hammer-off": () => Promise.resolve().then(function () { return IconHammerOff$1; }),
  "hammer": () => Promise.resolve().then(function () { return IconHammer$1; }),
  "hand-click-off": () => Promise.resolve().then(function () { return IconHandClickOff$1; }),
  "hand-click": () => Promise.resolve().then(function () { return IconHandClick$1; }),
  "hand-finger-down": () => Promise.resolve().then(function () { return IconHandFingerDown$1; }),
  "hand-finger-left": () => Promise.resolve().then(function () { return IconHandFingerLeft$1; }),
  "hand-finger-off": () => Promise.resolve().then(function () { return IconHandFingerOff$1; }),
  "hand-finger-right": () => Promise.resolve().then(function () { return IconHandFingerRight$1; }),
  "hand-finger": () => Promise.resolve().then(function () { return IconHandFinger$1; }),
  "hand-grab": () => Promise.resolve().then(function () { return IconHandGrab$1; }),
  "hand-little-finger": () => Promise.resolve().then(function () { return IconHandLittleFinger$1; }),
  "hand-love-you": () => Promise.resolve().then(function () { return IconHandLoveYou$1; }),
  "hand-middle-finger": () => Promise.resolve().then(function () { return IconHandMiddleFinger$1; }),
  "hand-move": () => Promise.resolve().then(function () { return IconHandMove$1; }),
  "hand-off": () => Promise.resolve().then(function () { return IconHandOff$1; }),
  "hand-ring-finger": () => Promise.resolve().then(function () { return IconHandRingFinger$1; }),
  "hand-sanitizer": () => Promise.resolve().then(function () { return IconHandSanitizer$1; }),
  "hand-stop": () => Promise.resolve().then(function () { return IconHandStop$1; }),
  "hand-three-fingers": () => Promise.resolve().then(function () { return IconHandThreeFingers$1; }),
  "hand-two-fingers": () => Promise.resolve().then(function () { return IconHandTwoFingers$1; }),
  "hanger-2": () => Promise.resolve().then(function () { return IconHanger2$1; }),
  "hanger-off": () => Promise.resolve().then(function () { return IconHangerOff$1; }),
  "hanger": () => Promise.resolve().then(function () { return IconHanger$1; }),
  "hash": () => Promise.resolve().then(function () { return IconHash$1; }),
  "haze-moon": () => Promise.resolve().then(function () { return IconHazeMoon$1; }),
  "haze": () => Promise.resolve().then(function () { return IconHaze$1; }),
  "hdr": () => Promise.resolve().then(function () { return IconHdr$1; }),
  "heading-off": () => Promise.resolve().then(function () { return IconHeadingOff$1; }),
  "heading": () => Promise.resolve().then(function () { return IconHeading$1; }),
  "headphones-off": () => Promise.resolve().then(function () { return IconHeadphonesOff$1; }),
  "headphones": () => Promise.resolve().then(function () { return IconHeadphones$1; }),
  "headset-off": () => Promise.resolve().then(function () { return IconHeadsetOff$1; }),
  "headset": () => Promise.resolve().then(function () { return IconHeadset$1; }),
  "health-recognition": () => Promise.resolve().then(function () { return IconHealthRecognition$1; }),
  "heart-bitcoin": () => Promise.resolve().then(function () { return IconHeartBitcoin$1; }),
  "heart-bolt": () => Promise.resolve().then(function () { return IconHeartBolt$1; }),
  "heart-broken": () => Promise.resolve().then(function () { return IconHeartBroken$1; }),
  "heart-cancel": () => Promise.resolve().then(function () { return IconHeartCancel$1; }),
  "heart-check": () => Promise.resolve().then(function () { return IconHeartCheck$1; }),
  "heart-code": () => Promise.resolve().then(function () { return IconHeartCode$1; }),
  "heart-cog": () => Promise.resolve().then(function () { return IconHeartCog$1; }),
  "heart-discount": () => Promise.resolve().then(function () { return IconHeartDiscount$1; }),
  "heart-dollar": () => Promise.resolve().then(function () { return IconHeartDollar$1; }),
  "heart-down": () => Promise.resolve().then(function () { return IconHeartDown$1; }),
  "heart-exclamation": () => Promise.resolve().then(function () { return IconHeartExclamation$1; }),
  "heart-handshake": () => Promise.resolve().then(function () { return IconHeartHandshake$1; }),
  "heart-minus": () => Promise.resolve().then(function () { return IconHeartMinus$1; }),
  "heart-off": () => Promise.resolve().then(function () { return IconHeartOff$1; }),
  "heart-pause": () => Promise.resolve().then(function () { return IconHeartPause$1; }),
  "heart-pin": () => Promise.resolve().then(function () { return IconHeartPin$1; }),
  "heart-plus": () => Promise.resolve().then(function () { return IconHeartPlus$1; }),
  "heart-question": () => Promise.resolve().then(function () { return IconHeartQuestion$1; }),
  "heart-rate-monitor": () => Promise.resolve().then(function () { return IconHeartRateMonitor$1; }),
  "heart-search": () => Promise.resolve().then(function () { return IconHeartSearch$1; }),
  "heart-share": () => Promise.resolve().then(function () { return IconHeartShare$1; }),
  "heart-spark": () => Promise.resolve().then(function () { return IconHeartSpark$1; }),
  "heart-star": () => Promise.resolve().then(function () { return IconHeartStar$1; }),
  "heart-up": () => Promise.resolve().then(function () { return IconHeartUp$1; }),
  "heart-x": () => Promise.resolve().then(function () { return IconHeartX$1; }),
  "heart": () => Promise.resolve().then(function () { return IconHeart$1; }),
  "heartbeat": () => Promise.resolve().then(function () { return IconHeartbeat$1; }),
  "hearts-off": () => Promise.resolve().then(function () { return IconHeartsOff$1; }),
  "hearts": () => Promise.resolve().then(function () { return IconHearts$1; }),
  "helicopter-landing": () => Promise.resolve().then(function () { return IconHelicopterLanding$1; }),
  "helicopter": () => Promise.resolve().then(function () { return IconHelicopter$1; }),
  "helmet-off": () => Promise.resolve().then(function () { return IconHelmetOff$1; }),
  "helmet": () => Promise.resolve().then(function () { return IconHelmet$1; }),
  "help-circle": () => Promise.resolve().then(function () { return IconHelpCircle$1; }),
  "help-hexagon": () => Promise.resolve().then(function () { return IconHelpHexagon$1; }),
  "help-octagon": () => Promise.resolve().then(function () { return IconHelpOctagon$1; }),
  "help-off": () => Promise.resolve().then(function () { return IconHelpOff$1; }),
  "help-small": () => Promise.resolve().then(function () { return IconHelpSmall$1; }),
  "help-square-rounded": () => Promise.resolve().then(function () { return IconHelpSquareRounded$1; }),
  "help-square": () => Promise.resolve().then(function () { return IconHelpSquare$1; }),
  "help-triangle": () => Promise.resolve().then(function () { return IconHelpTriangle$1; }),
  "help": () => Promise.resolve().then(function () { return IconHelp$1; }),
  "hemisphere-off": () => Promise.resolve().then(function () { return IconHemisphereOff$1; }),
  "hemisphere-plus": () => Promise.resolve().then(function () { return IconHemispherePlus$1; }),
  "hemisphere": () => Promise.resolve().then(function () { return IconHemisphere$1; }),
  "hexagon-3d": () => Promise.resolve().then(function () { return IconHexagon3d$1; }),
  "hexagon-letter-a": () => Promise.resolve().then(function () { return IconHexagonLetterA$1; }),
  "hexagon-letter-b": () => Promise.resolve().then(function () { return IconHexagonLetterB$1; }),
  "hexagon-letter-c": () => Promise.resolve().then(function () { return IconHexagonLetterC$1; }),
  "hexagon-letter-d": () => Promise.resolve().then(function () { return IconHexagonLetterD$1; }),
  "hexagon-letter-e": () => Promise.resolve().then(function () { return IconHexagonLetterE$1; }),
  "hexagon-letter-f": () => Promise.resolve().then(function () { return IconHexagonLetterF$1; }),
  "hexagon-letter-g": () => Promise.resolve().then(function () { return IconHexagonLetterG$1; }),
  "hexagon-letter-h": () => Promise.resolve().then(function () { return IconHexagonLetterH$1; }),
  "hexagon-letter-i": () => Promise.resolve().then(function () { return IconHexagonLetterI$1; }),
  "hexagon-letter-j": () => Promise.resolve().then(function () { return IconHexagonLetterJ$1; }),
  "hexagon-letter-k": () => Promise.resolve().then(function () { return IconHexagonLetterK$1; }),
  "hexagon-letter-l": () => Promise.resolve().then(function () { return IconHexagonLetterL$1; }),
  "hexagon-letter-m": () => Promise.resolve().then(function () { return IconHexagonLetterM$1; }),
  "hexagon-letter-n": () => Promise.resolve().then(function () { return IconHexagonLetterN$1; }),
  "hexagon-letter-o": () => Promise.resolve().then(function () { return IconHexagonLetterO$1; }),
  "hexagon-letter-p": () => Promise.resolve().then(function () { return IconHexagonLetterP$1; }),
  "hexagon-letter-q": () => Promise.resolve().then(function () { return IconHexagonLetterQ$1; }),
  "hexagon-letter-r": () => Promise.resolve().then(function () { return IconHexagonLetterR$1; }),
  "hexagon-letter-s": () => Promise.resolve().then(function () { return IconHexagonLetterS$1; }),
  "hexagon-letter-t": () => Promise.resolve().then(function () { return IconHexagonLetterT$1; }),
  "hexagon-letter-u": () => Promise.resolve().then(function () { return IconHexagonLetterU$1; }),
  "hexagon-letter-v": () => Promise.resolve().then(function () { return IconHexagonLetterV$1; }),
  "hexagon-letter-w": () => Promise.resolve().then(function () { return IconHexagonLetterW$1; }),
  "hexagon-letter-x": () => Promise.resolve().then(function () { return IconHexagonLetterX$1; }),
  "hexagon-letter-y": () => Promise.resolve().then(function () { return IconHexagonLetterY$1; }),
  "hexagon-letter-z": () => Promise.resolve().then(function () { return IconHexagonLetterZ$1; }),
  "hexagon-minus-2": () => Promise.resolve().then(function () { return IconHexagonMinus2$1; }),
  "hexagon-minus": () => Promise.resolve().then(function () { return IconHexagonMinus$1; }),
  "hexagon-number-0": () => Promise.resolve().then(function () { return IconHexagonNumber0$1; }),
  "hexagon-number-1": () => Promise.resolve().then(function () { return IconHexagonNumber1$1; }),
  "hexagon-number-2": () => Promise.resolve().then(function () { return IconHexagonNumber2$1; }),
  "hexagon-number-3": () => Promise.resolve().then(function () { return IconHexagonNumber3$1; }),
  "hexagon-number-4": () => Promise.resolve().then(function () { return IconHexagonNumber4$1; }),
  "hexagon-number-5": () => Promise.resolve().then(function () { return IconHexagonNumber5$1; }),
  "hexagon-number-6": () => Promise.resolve().then(function () { return IconHexagonNumber6$1; }),
  "hexagon-number-7": () => Promise.resolve().then(function () { return IconHexagonNumber7$1; }),
  "hexagon-number-8": () => Promise.resolve().then(function () { return IconHexagonNumber8$1; }),
  "hexagon-number-9": () => Promise.resolve().then(function () { return IconHexagonNumber9$1; }),
  "hexagon-off": () => Promise.resolve().then(function () { return IconHexagonOff$1; }),
  "hexagon-plus-2": () => Promise.resolve().then(function () { return IconHexagonPlus2$1; }),
  "hexagon-plus": () => Promise.resolve().then(function () { return IconHexagonPlus$1; }),
  "hexagon": () => Promise.resolve().then(function () { return IconHexagon$1; }),
  "hexagonal-prism-off": () => Promise.resolve().then(function () { return IconHexagonalPrismOff$1; }),
  "hexagonal-prism-plus": () => Promise.resolve().then(function () { return IconHexagonalPrismPlus$1; }),
  "hexagonal-prism": () => Promise.resolve().then(function () { return IconHexagonalPrism$1; }),
  "hexagonal-pyramid-off": () => Promise.resolve().then(function () { return IconHexagonalPyramidOff$1; }),
  "hexagonal-pyramid-plus": () => Promise.resolve().then(function () { return IconHexagonalPyramidPlus$1; }),
  "hexagonal-pyramid": () => Promise.resolve().then(function () { return IconHexagonalPyramid$1; }),
  "hexagons-off": () => Promise.resolve().then(function () { return IconHexagonsOff$1; }),
  "hexagons": () => Promise.resolve().then(function () { return IconHexagons$1; }),
  "hierarchy-2": () => Promise.resolve().then(function () { return IconHierarchy2$1; }),
  "hierarchy-3": () => Promise.resolve().then(function () { return IconHierarchy3$1; }),
  "hierarchy-off": () => Promise.resolve().then(function () { return IconHierarchyOff$1; }),
  "hierarchy": () => Promise.resolve().then(function () { return IconHierarchy$1; }),
  "highlight-off": () => Promise.resolve().then(function () { return IconHighlightOff$1; }),
  "highlight": () => Promise.resolve().then(function () { return IconHighlight$1; }),
  "history-off": () => Promise.resolve().then(function () { return IconHistoryOff$1; }),
  "history-toggle": () => Promise.resolve().then(function () { return IconHistoryToggle$1; }),
  "history": () => Promise.resolve().then(function () { return IconHistory$1; }),
  "home-2": () => Promise.resolve().then(function () { return IconHome2$1; }),
  "home-bitcoin": () => Promise.resolve().then(function () { return IconHomeBitcoin$1; }),
  "home-bolt": () => Promise.resolve().then(function () { return IconHomeBolt$1; }),
  "home-cancel": () => Promise.resolve().then(function () { return IconHomeCancel$1; }),
  "home-check": () => Promise.resolve().then(function () { return IconHomeCheck$1; }),
  "home-cog": () => Promise.resolve().then(function () { return IconHomeCog$1; }),
  "home-dollar": () => Promise.resolve().then(function () { return IconHomeDollar$1; }),
  "home-dot": () => Promise.resolve().then(function () { return IconHomeDot$1; }),
  "home-down": () => Promise.resolve().then(function () { return IconHomeDown$1; }),
  "home-eco": () => Promise.resolve().then(function () { return IconHomeEco$1; }),
  "home-edit": () => Promise.resolve().then(function () { return IconHomeEdit$1; }),
  "home-exclamation": () => Promise.resolve().then(function () { return IconHomeExclamation$1; }),
  "home-hand": () => Promise.resolve().then(function () { return IconHomeHand$1; }),
  "home-heart": () => Promise.resolve().then(function () { return IconHomeHeart$1; }),
  "home-infinity": () => Promise.resolve().then(function () { return IconHomeInfinity$1; }),
  "home-link": () => Promise.resolve().then(function () { return IconHomeLink$1; }),
  "home-minus": () => Promise.resolve().then(function () { return IconHomeMinus$1; }),
  "home-move": () => Promise.resolve().then(function () { return IconHomeMove$1; }),
  "home-off": () => Promise.resolve().then(function () { return IconHomeOff$1; }),
  "home-plus": () => Promise.resolve().then(function () { return IconHomePlus$1; }),
  "home-question": () => Promise.resolve().then(function () { return IconHomeQuestion$1; }),
  "home-ribbon": () => Promise.resolve().then(function () { return IconHomeRibbon$1; }),
  "home-search": () => Promise.resolve().then(function () { return IconHomeSearch$1; }),
  "home-share": () => Promise.resolve().then(function () { return IconHomeShare$1; }),
  "home-shield": () => Promise.resolve().then(function () { return IconHomeShield$1; }),
  "home-signal": () => Promise.resolve().then(function () { return IconHomeSignal$1; }),
  "home-spark": () => Promise.resolve().then(function () { return IconHomeSpark$1; }),
  "home-star": () => Promise.resolve().then(function () { return IconHomeStar$1; }),
  "home-stats": () => Promise.resolve().then(function () { return IconHomeStats$1; }),
  "home-up": () => Promise.resolve().then(function () { return IconHomeUp$1; }),
  "home-x": () => Promise.resolve().then(function () { return IconHomeX$1; }),
  "home": () => Promise.resolve().then(function () { return IconHome$1; }),
  "horse-toy": () => Promise.resolve().then(function () { return IconHorseToy$1; }),
  "horse": () => Promise.resolve().then(function () { return IconHorse$1; }),
  "horseshoe": () => Promise.resolve().then(function () { return IconHorseshoe$1; }),
  "hospital-circle": () => Promise.resolve().then(function () { return IconHospitalCircle$1; }),
  "hospital": () => Promise.resolve().then(function () { return IconHospital$1; }),
  "hotel-service": () => Promise.resolve().then(function () { return IconHotelService$1; }),
  "hourglass-empty": () => Promise.resolve().then(function () { return IconHourglassEmpty$1; }),
  "hourglass-high": () => Promise.resolve().then(function () { return IconHourglassHigh$1; }),
  "hourglass-low": () => Promise.resolve().then(function () { return IconHourglassLow$1; }),
  "hourglass-off": () => Promise.resolve().then(function () { return IconHourglassOff$1; }),
  "hourglass": () => Promise.resolve().then(function () { return IconHourglass$1; }),
  "hours-12": () => Promise.resolve().then(function () { return IconHours12$1; }),
  "hours-24": () => Promise.resolve().then(function () { return IconHours24$1; }),
  "html": () => Promise.resolve().then(function () { return IconHtml$1; }),
  "http-connect-off": () => Promise.resolve().then(function () { return IconHttpConnectOff$1; }),
  "http-connect": () => Promise.resolve().then(function () { return IconHttpConnect$1; }),
  "http-delete-off": () => Promise.resolve().then(function () { return IconHttpDeleteOff$1; }),
  "http-delete": () => Promise.resolve().then(function () { return IconHttpDelete$1; }),
  "http-get-off": () => Promise.resolve().then(function () { return IconHttpGetOff$1; }),
  "http-get": () => Promise.resolve().then(function () { return IconHttpGet$1; }),
  "http-head-off": () => Promise.resolve().then(function () { return IconHttpHeadOff$1; }),
  "http-head": () => Promise.resolve().then(function () { return IconHttpHead$1; }),
  "http-options-off": () => Promise.resolve().then(function () { return IconHttpOptionsOff$1; }),
  "http-options": () => Promise.resolve().then(function () { return IconHttpOptions$1; }),
  "http-patch-off": () => Promise.resolve().then(function () { return IconHttpPatchOff$1; }),
  "http-patch": () => Promise.resolve().then(function () { return IconHttpPatch$1; }),
  "http-post-off": () => Promise.resolve().then(function () { return IconHttpPostOff$1; }),
  "http-post": () => Promise.resolve().then(function () { return IconHttpPost$1; }),
  "http-put-off": () => Promise.resolve().then(function () { return IconHttpPutOff$1; }),
  "http-put": () => Promise.resolve().then(function () { return IconHttpPut$1; }),
  "http-que-off": () => Promise.resolve().then(function () { return IconHttpQueOff$1; }),
  "http-que": () => Promise.resolve().then(function () { return IconHttpQue$1; }),
  "http-trace-off": () => Promise.resolve().then(function () { return IconHttpTraceOff$1; }),
  "http-trace": () => Promise.resolve().then(function () { return IconHttpTrace$1; }),
  "ice-cream-2": () => Promise.resolve().then(function () { return IconIceCream2$1; }),
  "ice-cream-off": () => Promise.resolve().then(function () { return IconIceCreamOff$1; }),
  "ice-cream": () => Promise.resolve().then(function () { return IconIceCream$1; }),
  "ice-skating": () => Promise.resolve().then(function () { return IconIceSkating$1; }),
  "icons-off": () => Promise.resolve().then(function () { return IconIconsOff$1; }),
  "icons": () => Promise.resolve().then(function () { return IconIcons$1; }),
  "id-badge-2": () => Promise.resolve().then(function () { return IconIdBadge2$1; }),
  "id-badge-off": () => Promise.resolve().then(function () { return IconIdBadgeOff$1; }),
  "id-badge": () => Promise.resolve().then(function () { return IconIdBadge$1; }),
  "id-off": () => Promise.resolve().then(function () { return IconIdOff$1; }),
  "id": () => Promise.resolve().then(function () { return IconId$1; }),
  "ikosaedr": () => Promise.resolve().then(function () { return IconIkosaedr$1; }),
  "image-in-picture": () => Promise.resolve().then(function () { return IconImageInPicture$1; }),
  "inbox-off": () => Promise.resolve().then(function () { return IconInboxOff$1; }),
  "inbox": () => Promise.resolve().then(function () { return IconInbox$1; }),
  "indent-decrease": () => Promise.resolve().then(function () { return IconIndentDecrease$1; }),
  "indent-increase": () => Promise.resolve().then(function () { return IconIndentIncrease$1; }),
  "infinity-off": () => Promise.resolve().then(function () { return IconInfinityOff$1; }),
  "infinity": () => Promise.resolve().then(function () { return IconInfinity$1; }),
  "info-circle": () => Promise.resolve().then(function () { return IconInfoCircle$1; }),
  "info-hexagon": () => Promise.resolve().then(function () { return IconInfoHexagon$1; }),
  "info-octagon": () => Promise.resolve().then(function () { return IconInfoOctagon$1; }),
  "info-small": () => Promise.resolve().then(function () { return IconInfoSmall$1; }),
  "info-square-rounded": () => Promise.resolve().then(function () { return IconInfoSquareRounded$1; }),
  "info-square": () => Promise.resolve().then(function () { return IconInfoSquare$1; }),
  "info-triangle": () => Promise.resolve().then(function () { return IconInfoTriangle$1; }),
  "inner-shadow-bottom-left": () => Promise.resolve().then(function () { return IconInnerShadowBottomLeft$1; }),
  "inner-shadow-bottom-right": () => Promise.resolve().then(function () { return IconInnerShadowBottomRight$1; }),
  "inner-shadow-bottom": () => Promise.resolve().then(function () { return IconInnerShadowBottom$1; }),
  "inner-shadow-left": () => Promise.resolve().then(function () { return IconInnerShadowLeft$1; }),
  "inner-shadow-right": () => Promise.resolve().then(function () { return IconInnerShadowRight$1; }),
  "inner-shadow-top-left": () => Promise.resolve().then(function () { return IconInnerShadowTopLeft$1; }),
  "inner-shadow-top-right": () => Promise.resolve().then(function () { return IconInnerShadowTopRight$1; }),
  "inner-shadow-top": () => Promise.resolve().then(function () { return IconInnerShadowTop$1; }),
  "input-ai": () => Promise.resolve().then(function () { return IconInputAi$1; }),
  "input-check": () => Promise.resolve().then(function () { return IconInputCheck$1; }),
  "input-search": () => Promise.resolve().then(function () { return IconInputSearch$1; }),
  "input-spark": () => Promise.resolve().then(function () { return IconInputSpark$1; }),
  "input-x": () => Promise.resolve().then(function () { return IconInputX$1; }),
  "invoice": () => Promise.resolve().then(function () { return IconInvoice$1; }),
  "ironing-1": () => Promise.resolve().then(function () { return IconIroning1$1; }),
  "ironing-2": () => Promise.resolve().then(function () { return IconIroning2$1; }),
  "ironing-3": () => Promise.resolve().then(function () { return IconIroning3$1; }),
  "ironing-off": () => Promise.resolve().then(function () { return IconIroningOff$1; }),
  "ironing-steam-off": () => Promise.resolve().then(function () { return IconIroningSteamOff$1; }),
  "ironing-steam": () => Promise.resolve().then(function () { return IconIroningSteam$1; }),
  "ironing": () => Promise.resolve().then(function () { return IconIroning$1; }),
  "irregular-polyhedron-off": () => Promise.resolve().then(function () { return IconIrregularPolyhedronOff$1; }),
  "irregular-polyhedron-plus": () => Promise.resolve().then(function () { return IconIrregularPolyhedronPlus$1; }),
  "irregular-polyhedron": () => Promise.resolve().then(function () { return IconIrregularPolyhedron$1; }),
  "italic": () => Promise.resolve().then(function () { return IconItalic$1; }),
  "jacket": () => Promise.resolve().then(function () { return IconJacket$1; }),
  "jetpack": () => Promise.resolve().then(function () { return IconJetpack$1; }),
  "jewish-star": () => Promise.resolve().then(function () { return IconJewishStar$1; }),
  "join-bevel": () => Promise.resolve().then(function () { return IconJoinBevel$1; }),
  "join-round": () => Promise.resolve().then(function () { return IconJoinRound$1; }),
  "join-straight": () => Promise.resolve().then(function () { return IconJoinStraight$1; }),
  "joker": () => Promise.resolve().then(function () { return IconJoker$1; }),
  "jpg": () => Promise.resolve().then(function () { return IconJpg$1; }),
  "json": () => Promise.resolve().then(function () { return IconJson$1; }),
  "jump-rope": () => Promise.resolve().then(function () { return IconJumpRope$1; }),
  "karate": () => Promise.resolve().then(function () { return IconKarate$1; }),
  "kayak": () => Promise.resolve().then(function () { return IconKayak$1; }),
  "kerning": () => Promise.resolve().then(function () { return IconKerning$1; }),
  "key-off": () => Promise.resolve().then(function () { return IconKeyOff$1; }),
  "key": () => Promise.resolve().then(function () { return IconKey$1; }),
  "keyboard-hide": () => Promise.resolve().then(function () { return IconKeyboardHide$1; }),
  "keyboard-off": () => Promise.resolve().then(function () { return IconKeyboardOff$1; }),
  "keyboard-show": () => Promise.resolve().then(function () { return IconKeyboardShow$1; }),
  "keyboard": () => Promise.resolve().then(function () { return IconKeyboard$1; }),
  "keyframe-align-center": () => Promise.resolve().then(function () { return IconKeyframeAlignCenter$1; }),
  "keyframe-align-horizontal": () => Promise.resolve().then(function () { return IconKeyframeAlignHorizontal$1; }),
  "keyframe-align-vertical": () => Promise.resolve().then(function () { return IconKeyframeAlignVertical$1; }),
  "keyframe": () => Promise.resolve().then(function () { return IconKeyframe$1; }),
  "keyframes": () => Promise.resolve().then(function () { return IconKeyframes$1; }),
  "label-important": () => Promise.resolve().then(function () { return IconLabelImportant$1; }),
  "label-off": () => Promise.resolve().then(function () { return IconLabelOff$1; }),
  "label": () => Promise.resolve().then(function () { return IconLabel$1; }),
  "ladder-off": () => Promise.resolve().then(function () { return IconLadderOff$1; }),
  "ladder": () => Promise.resolve().then(function () { return IconLadder$1; }),
  "ladle": () => Promise.resolve().then(function () { return IconLadle$1; }),
  "lambda": () => Promise.resolve().then(function () { return IconLambda$1; }),
  "lamp-2": () => Promise.resolve().then(function () { return IconLamp2$1; }),
  "lamp-off": () => Promise.resolve().then(function () { return IconLampOff$1; }),
  "lamp": () => Promise.resolve().then(function () { return IconLamp$1; }),
  "lane": () => Promise.resolve().then(function () { return IconLane$1; }),
  "language-hiragana": () => Promise.resolve().then(function () { return IconLanguageHiragana$1; }),
  "language-katakana": () => Promise.resolve().then(function () { return IconLanguageKatakana$1; }),
  "language-off": () => Promise.resolve().then(function () { return IconLanguageOff$1; }),
  "language": () => Promise.resolve().then(function () { return IconLanguage$1; }),
  "lasso-off": () => Promise.resolve().then(function () { return IconLassoOff$1; }),
  "lasso-polygon": () => Promise.resolve().then(function () { return IconLassoPolygon$1; }),
  "lasso": () => Promise.resolve().then(function () { return IconLasso$1; }),
  "laurel-wreath-1": () => Promise.resolve().then(function () { return IconLaurelWreath1$1; }),
  "laurel-wreath-2": () => Promise.resolve().then(function () { return IconLaurelWreath2$1; }),
  "laurel-wreath-3": () => Promise.resolve().then(function () { return IconLaurelWreath3$1; }),
  "laurel-wreath": () => Promise.resolve().then(function () { return IconLaurelWreath$1; }),
  "layers-difference": () => Promise.resolve().then(function () { return IconLayersDifference$1; }),
  "layers-intersect-2": () => Promise.resolve().then(function () { return IconLayersIntersect2$1; }),
  "layers-intersect": () => Promise.resolve().then(function () { return IconLayersIntersect$1; }),
  "layers-linked": () => Promise.resolve().then(function () { return IconLayersLinked$1; }),
  "layers-off": () => Promise.resolve().then(function () { return IconLayersOff$1; }),
  "layers-selected-bottom": () => Promise.resolve().then(function () { return IconLayersSelectedBottom$1; }),
  "layers-selected": () => Promise.resolve().then(function () { return IconLayersSelected$1; }),
  "layers-subtract": () => Promise.resolve().then(function () { return IconLayersSubtract$1; }),
  "layers-union": () => Promise.resolve().then(function () { return IconLayersUnion$1; }),
  "layout-2": () => Promise.resolve().then(function () { return IconLayout2$1; }),
  "layout-align-bottom": () => Promise.resolve().then(function () { return IconLayoutAlignBottom$1; }),
  "layout-align-center": () => Promise.resolve().then(function () { return IconLayoutAlignCenter$1; }),
  "layout-align-left": () => Promise.resolve().then(function () { return IconLayoutAlignLeft$1; }),
  "layout-align-middle": () => Promise.resolve().then(function () { return IconLayoutAlignMiddle$1; }),
  "layout-align-right": () => Promise.resolve().then(function () { return IconLayoutAlignRight$1; }),
  "layout-align-top": () => Promise.resolve().then(function () { return IconLayoutAlignTop$1; }),
  "layout-board-split": () => Promise.resolve().then(function () { return IconLayoutBoardSplit$1; }),
  "layout-board": () => Promise.resolve().then(function () { return IconLayoutBoard$1; }),
  "layout-bottombar-collapse": () => Promise.resolve().then(function () { return IconLayoutBottombarCollapse$1; }),
  "layout-bottombar-expand": () => Promise.resolve().then(function () { return IconLayoutBottombarExpand$1; }),
  "layout-bottombar-inactive": () => Promise.resolve().then(function () { return IconLayoutBottombarInactive$1; }),
  "layout-bottombar": () => Promise.resolve().then(function () { return IconLayoutBottombar$1; }),
  "layout-cards": () => Promise.resolve().then(function () { return IconLayoutCards$1; }),
  "layout-collage": () => Promise.resolve().then(function () { return IconLayoutCollage$1; }),
  "layout-columns": () => Promise.resolve().then(function () { return IconLayoutColumns$1; }),
  "layout-dashboard": () => Promise.resolve().then(function () { return IconLayoutDashboard$1; }),
  "layout-distribute-horizontal": () => Promise.resolve().then(function () { return IconLayoutDistributeHorizontal$1; }),
  "layout-distribute-vertical": () => Promise.resolve().then(function () { return IconLayoutDistributeVertical$1; }),
  "layout-grid-add": () => Promise.resolve().then(function () { return IconLayoutGridAdd$1; }),
  "layout-grid-remove": () => Promise.resolve().then(function () { return IconLayoutGridRemove$1; }),
  "layout-grid": () => Promise.resolve().then(function () { return IconLayoutGrid$1; }),
  "layout-kanban": () => Promise.resolve().then(function () { return IconLayoutKanban$1; }),
  "layout-list": () => Promise.resolve().then(function () { return IconLayoutList$1; }),
  "layout-navbar-collapse": () => Promise.resolve().then(function () { return IconLayoutNavbarCollapse$1; }),
  "layout-navbar-expand": () => Promise.resolve().then(function () { return IconLayoutNavbarExpand$1; }),
  "layout-navbar-inactive": () => Promise.resolve().then(function () { return IconLayoutNavbarInactive$1; }),
  "layout-navbar": () => Promise.resolve().then(function () { return IconLayoutNavbar$1; }),
  "layout-off": () => Promise.resolve().then(function () { return IconLayoutOff$1; }),
  "layout-rows": () => Promise.resolve().then(function () { return IconLayoutRows$1; }),
  "layout-sidebar-inactive": () => Promise.resolve().then(function () { return IconLayoutSidebarInactive$1; }),
  "layout-sidebar-left-collapse": () => Promise.resolve().then(function () { return IconLayoutSidebarLeftCollapse$1; }),
  "layout-sidebar-left-expand": () => Promise.resolve().then(function () { return IconLayoutSidebarLeftExpand$1; }),
  "layout-sidebar-right-collapse": () => Promise.resolve().then(function () { return IconLayoutSidebarRightCollapse$1; }),
  "layout-sidebar-right-expand": () => Promise.resolve().then(function () { return IconLayoutSidebarRightExpand$1; }),
  "layout-sidebar-right-inactive": () => Promise.resolve().then(function () { return IconLayoutSidebarRightInactive$1; }),
  "layout-sidebar-right": () => Promise.resolve().then(function () { return IconLayoutSidebarRight$1; }),
  "layout-sidebar": () => Promise.resolve().then(function () { return IconLayoutSidebar$1; }),
  "layout": () => Promise.resolve().then(function () { return IconLayout$1; }),
  "leaf-2": () => Promise.resolve().then(function () { return IconLeaf2$1; }),
  "leaf-off": () => Promise.resolve().then(function () { return IconLeafOff$1; }),
  "leaf": () => Promise.resolve().then(function () { return IconLeaf$1; }),
  "lego-off": () => Promise.resolve().then(function () { return IconLegoOff$1; }),
  "lego": () => Promise.resolve().then(function () { return IconLego$1; }),
  "lemon-2": () => Promise.resolve().then(function () { return IconLemon2$1; }),
  "lemon": () => Promise.resolve().then(function () { return IconLemon$1; }),
  "letter-a-small": () => Promise.resolve().then(function () { return IconLetterASmall$1; }),
  "letter-a": () => Promise.resolve().then(function () { return IconLetterA$1; }),
  "letter-b-small": () => Promise.resolve().then(function () { return IconLetterBSmall$1; }),
  "letter-b": () => Promise.resolve().then(function () { return IconLetterB$1; }),
  "letter-c-small": () => Promise.resolve().then(function () { return IconLetterCSmall$1; }),
  "letter-c": () => Promise.resolve().then(function () { return IconLetterC$1; }),
  "letter-case-lower": () => Promise.resolve().then(function () { return IconLetterCaseLower$1; }),
  "letter-case-toggle": () => Promise.resolve().then(function () { return IconLetterCaseToggle$1; }),
  "letter-case-upper": () => Promise.resolve().then(function () { return IconLetterCaseUpper$1; }),
  "letter-case": () => Promise.resolve().then(function () { return IconLetterCase$1; }),
  "letter-d-small": () => Promise.resolve().then(function () { return IconLetterDSmall$1; }),
  "letter-d": () => Promise.resolve().then(function () { return IconLetterD$1; }),
  "letter-e-small": () => Promise.resolve().then(function () { return IconLetterESmall$1; }),
  "letter-e": () => Promise.resolve().then(function () { return IconLetterE$1; }),
  "letter-f-small": () => Promise.resolve().then(function () { return IconLetterFSmall$1; }),
  "letter-f": () => Promise.resolve().then(function () { return IconLetterF$1; }),
  "letter-g-small": () => Promise.resolve().then(function () { return IconLetterGSmall$1; }),
  "letter-g": () => Promise.resolve().then(function () { return IconLetterG$1; }),
  "letter-h-small": () => Promise.resolve().then(function () { return IconLetterHSmall$1; }),
  "letter-h": () => Promise.resolve().then(function () { return IconLetterH$1; }),
  "letter-i-small": () => Promise.resolve().then(function () { return IconLetterISmall$1; }),
  "letter-i": () => Promise.resolve().then(function () { return IconLetterI$1; }),
  "letter-j-small": () => Promise.resolve().then(function () { return IconLetterJSmall$1; }),
  "letter-j": () => Promise.resolve().then(function () { return IconLetterJ$1; }),
  "letter-k-small": () => Promise.resolve().then(function () { return IconLetterKSmall$1; }),
  "letter-k": () => Promise.resolve().then(function () { return IconLetterK$1; }),
  "letter-l-small": () => Promise.resolve().then(function () { return IconLetterLSmall$1; }),
  "letter-l": () => Promise.resolve().then(function () { return IconLetterL$1; }),
  "letter-m-small": () => Promise.resolve().then(function () { return IconLetterMSmall$1; }),
  "letter-m": () => Promise.resolve().then(function () { return IconLetterM$1; }),
  "letter-n-small": () => Promise.resolve().then(function () { return IconLetterNSmall$1; }),
  "letter-n": () => Promise.resolve().then(function () { return IconLetterN$1; }),
  "letter-o-small": () => Promise.resolve().then(function () { return IconLetterOSmall$1; }),
  "letter-o": () => Promise.resolve().then(function () { return IconLetterO$1; }),
  "letter-p-small": () => Promise.resolve().then(function () { return IconLetterPSmall$1; }),
  "letter-p": () => Promise.resolve().then(function () { return IconLetterP$1; }),
  "letter-q-small": () => Promise.resolve().then(function () { return IconLetterQSmall$1; }),
  "letter-q": () => Promise.resolve().then(function () { return IconLetterQ$1; }),
  "letter-r-small": () => Promise.resolve().then(function () { return IconLetterRSmall$1; }),
  "letter-r": () => Promise.resolve().then(function () { return IconLetterR$1; }),
  "letter-s-small": () => Promise.resolve().then(function () { return IconLetterSSmall$1; }),
  "letter-s": () => Promise.resolve().then(function () { return IconLetterS$1; }),
  "letter-spacing": () => Promise.resolve().then(function () { return IconLetterSpacing$1; }),
  "letter-t-small": () => Promise.resolve().then(function () { return IconLetterTSmall$1; }),
  "letter-t": () => Promise.resolve().then(function () { return IconLetterT$1; }),
  "letter-u-small": () => Promise.resolve().then(function () { return IconLetterUSmall$1; }),
  "letter-u": () => Promise.resolve().then(function () { return IconLetterU$1; }),
  "letter-v-small": () => Promise.resolve().then(function () { return IconLetterVSmall$1; }),
  "letter-v": () => Promise.resolve().then(function () { return IconLetterV$1; }),
  "letter-w-small": () => Promise.resolve().then(function () { return IconLetterWSmall$1; }),
  "letter-w": () => Promise.resolve().then(function () { return IconLetterW$1; }),
  "letter-x-small": () => Promise.resolve().then(function () { return IconLetterXSmall$1; }),
  "letter-x": () => Promise.resolve().then(function () { return IconLetterX$1; }),
  "letter-y-small": () => Promise.resolve().then(function () { return IconLetterYSmall$1; }),
  "letter-y": () => Promise.resolve().then(function () { return IconLetterY$1; }),
  "letter-z-small": () => Promise.resolve().then(function () { return IconLetterZSmall$1; }),
  "letter-z": () => Promise.resolve().then(function () { return IconLetterZ$1; }),
  "library-minus": () => Promise.resolve().then(function () { return IconLibraryMinus$1; }),
  "library-photo": () => Promise.resolve().then(function () { return IconLibraryPhoto$1; }),
  "library-plus": () => Promise.resolve().then(function () { return IconLibraryPlus$1; }),
  "library": () => Promise.resolve().then(function () { return IconLibrary$1; }),
  "license-off": () => Promise.resolve().then(function () { return IconLicenseOff$1; }),
  "license": () => Promise.resolve().then(function () { return IconLicense$1; }),
  "lifebuoy-off": () => Promise.resolve().then(function () { return IconLifebuoyOff$1; }),
  "lifebuoy": () => Promise.resolve().then(function () { return IconLifebuoy$1; }),
  "lighter": () => Promise.resolve().then(function () { return IconLighter$1; }),
  "line-dashed": () => Promise.resolve().then(function () { return IconLineDashed$1; }),
  "line-dotted": () => Promise.resolve().then(function () { return IconLineDotted$1; }),
  "line-height": () => Promise.resolve().then(function () { return IconLineHeight$1; }),
  "line-scan": () => Promise.resolve().then(function () { return IconLineScan$1; }),
  "line": () => Promise.resolve().then(function () { return IconLine$1; }),
  "link-minus": () => Promise.resolve().then(function () { return IconLinkMinus$1; }),
  "link-off": () => Promise.resolve().then(function () { return IconLinkOff$1; }),
  "link-plus": () => Promise.resolve().then(function () { return IconLinkPlus$1; }),
  "link": () => Promise.resolve().then(function () { return IconLink$1; }),
  "list-check": () => Promise.resolve().then(function () { return IconListCheck$1; }),
  "list-details": () => Promise.resolve().then(function () { return IconListDetails$1; }),
  "list-letters": () => Promise.resolve().then(function () { return IconListLetters$1; }),
  "list-numbers": () => Promise.resolve().then(function () { return IconListNumbers$1; }),
  "list-search": () => Promise.resolve().then(function () { return IconListSearch$1; }),
  "list-tree": () => Promise.resolve().then(function () { return IconListTree$1; }),
  "list": () => Promise.resolve().then(function () { return IconList$1; }),
  "live-photo-off": () => Promise.resolve().then(function () { return IconLivePhotoOff$1; }),
  "live-photo": () => Promise.resolve().then(function () { return IconLivePhoto$1; }),
  "live-view": () => Promise.resolve().then(function () { return IconLiveView$1; }),
  "load-balancer": () => Promise.resolve().then(function () { return IconLoadBalancer$1; }),
  "loader-2": () => Promise.resolve().then(function () { return IconLoader2$1; }),
  "loader-3": () => Promise.resolve().then(function () { return IconLoader3$1; }),
  "loader-quarter": () => Promise.resolve().then(function () { return IconLoaderQuarter$1; }),
  "loader": () => Promise.resolve().then(function () { return IconLoader$1; }),
  "location-bolt": () => Promise.resolve().then(function () { return IconLocationBolt$1; }),
  "location-broken": () => Promise.resolve().then(function () { return IconLocationBroken$1; }),
  "location-cancel": () => Promise.resolve().then(function () { return IconLocationCancel$1; }),
  "location-check": () => Promise.resolve().then(function () { return IconLocationCheck$1; }),
  "location-code": () => Promise.resolve().then(function () { return IconLocationCode$1; }),
  "location-cog": () => Promise.resolve().then(function () { return IconLocationCog$1; }),
  "location-discount": () => Promise.resolve().then(function () { return IconLocationDiscount$1; }),
  "location-dollar": () => Promise.resolve().then(function () { return IconLocationDollar$1; }),
  "location-down": () => Promise.resolve().then(function () { return IconLocationDown$1; }),
  "location-exclamation": () => Promise.resolve().then(function () { return IconLocationExclamation$1; }),
  "location-heart": () => Promise.resolve().then(function () { return IconLocationHeart$1; }),
  "location-minus": () => Promise.resolve().then(function () { return IconLocationMinus$1; }),
  "location-off": () => Promise.resolve().then(function () { return IconLocationOff$1; }),
  "location-pause": () => Promise.resolve().then(function () { return IconLocationPause$1; }),
  "location-pin": () => Promise.resolve().then(function () { return IconLocationPin$1; }),
  "location-plus": () => Promise.resolve().then(function () { return IconLocationPlus$1; }),
  "location-question": () => Promise.resolve().then(function () { return IconLocationQuestion$1; }),
  "location-search": () => Promise.resolve().then(function () { return IconLocationSearch$1; }),
  "location-share": () => Promise.resolve().then(function () { return IconLocationShare$1; }),
  "location-star": () => Promise.resolve().then(function () { return IconLocationStar$1; }),
  "location-up": () => Promise.resolve().then(function () { return IconLocationUp$1; }),
  "location-x": () => Promise.resolve().then(function () { return IconLocationX$1; }),
  "location": () => Promise.resolve().then(function () { return IconLocation$1; }),
  "lock-access-off": () => Promise.resolve().then(function () { return IconLockAccessOff$1; }),
  "lock-access": () => Promise.resolve().then(function () { return IconLockAccess$1; }),
  "lock-bitcoin": () => Promise.resolve().then(function () { return IconLockBitcoin$1; }),
  "lock-bolt": () => Promise.resolve().then(function () { return IconLockBolt$1; }),
  "lock-cancel": () => Promise.resolve().then(function () { return IconLockCancel$1; }),
  "lock-check": () => Promise.resolve().then(function () { return IconLockCheck$1; }),
  "lock-code": () => Promise.resolve().then(function () { return IconLockCode$1; }),
  "lock-cog": () => Promise.resolve().then(function () { return IconLockCog$1; }),
  "lock-dollar": () => Promise.resolve().then(function () { return IconLockDollar$1; }),
  "lock-down": () => Promise.resolve().then(function () { return IconLockDown$1; }),
  "lock-exclamation": () => Promise.resolve().then(function () { return IconLockExclamation$1; }),
  "lock-heart": () => Promise.resolve().then(function () { return IconLockHeart$1; }),
  "lock-minus": () => Promise.resolve().then(function () { return IconLockMinus$1; }),
  "lock-off": () => Promise.resolve().then(function () { return IconLockOff$1; }),
  "lock-open-2": () => Promise.resolve().then(function () { return IconLockOpen2$1; }),
  "lock-open-off": () => Promise.resolve().then(function () { return IconLockOpenOff$1; }),
  "lock-open": () => Promise.resolve().then(function () { return IconLockOpen$1; }),
  "lock-password": () => Promise.resolve().then(function () { return IconLockPassword$1; }),
  "lock-pause": () => Promise.resolve().then(function () { return IconLockPause$1; }),
  "lock-pin": () => Promise.resolve().then(function () { return IconLockPin$1; }),
  "lock-plus": () => Promise.resolve().then(function () { return IconLockPlus$1; }),
  "lock-question": () => Promise.resolve().then(function () { return IconLockQuestion$1; }),
  "lock-search": () => Promise.resolve().then(function () { return IconLockSearch$1; }),
  "lock-share": () => Promise.resolve().then(function () { return IconLockShare$1; }),
  "lock-square-rounded": () => Promise.resolve().then(function () { return IconLockSquareRounded$1; }),
  "lock-square": () => Promise.resolve().then(function () { return IconLockSquare$1; }),
  "lock-star": () => Promise.resolve().then(function () { return IconLockStar$1; }),
  "lock-up": () => Promise.resolve().then(function () { return IconLockUp$1; }),
  "lock-x": () => Promise.resolve().then(function () { return IconLockX$1; }),
  "lock": () => Promise.resolve().then(function () { return IconLock$1; }),
  "logic-and": () => Promise.resolve().then(function () { return IconLogicAnd$1; }),
  "logic-buffer": () => Promise.resolve().then(function () { return IconLogicBuffer$1; }),
  "logic-nand": () => Promise.resolve().then(function () { return IconLogicNand$1; }),
  "logic-nor": () => Promise.resolve().then(function () { return IconLogicNor$1; }),
  "logic-not": () => Promise.resolve().then(function () { return IconLogicNot$1; }),
  "logic-or": () => Promise.resolve().then(function () { return IconLogicOr$1; }),
  "logic-xnor": () => Promise.resolve().then(function () { return IconLogicXnor$1; }),
  "logic-xor": () => Promise.resolve().then(function () { return IconLogicXor$1; }),
  "login-2": () => Promise.resolve().then(function () { return IconLogin2$1; }),
  "login": () => Promise.resolve().then(function () { return IconLogin$1; }),
  "logout-2": () => Promise.resolve().then(function () { return IconLogout2$1; }),
  "logout": () => Promise.resolve().then(function () { return IconLogout$1; }),
  "logs": () => Promise.resolve().then(function () { return IconLogs$1; }),
  "lollipop-off": () => Promise.resolve().then(function () { return IconLollipopOff$1; }),
  "lollipop": () => Promise.resolve().then(function () { return IconLollipop$1; }),
  "luggage-off": () => Promise.resolve().then(function () { return IconLuggageOff$1; }),
  "luggage": () => Promise.resolve().then(function () { return IconLuggage$1; }),
  "lungs-off": () => Promise.resolve().then(function () { return IconLungsOff$1; }),
  "lungs": () => Promise.resolve().then(function () { return IconLungs$1; }),
  "macro-off": () => Promise.resolve().then(function () { return IconMacroOff$1; }),
  "macro": () => Promise.resolve().then(function () { return IconMacro$1; }),
  "magnet-off": () => Promise.resolve().then(function () { return IconMagnetOff$1; }),
  "magnet": () => Promise.resolve().then(function () { return IconMagnet$1; }),
  "magnetic": () => Promise.resolve().then(function () { return IconMagnetic$1; }),
  "mail-ai": () => Promise.resolve().then(function () { return IconMailAi$1; }),
  "mail-bitcoin": () => Promise.resolve().then(function () { return IconMailBitcoin$1; }),
  "mail-bolt": () => Promise.resolve().then(function () { return IconMailBolt$1; }),
  "mail-cancel": () => Promise.resolve().then(function () { return IconMailCancel$1; }),
  "mail-check": () => Promise.resolve().then(function () { return IconMailCheck$1; }),
  "mail-code": () => Promise.resolve().then(function () { return IconMailCode$1; }),
  "mail-cog": () => Promise.resolve().then(function () { return IconMailCog$1; }),
  "mail-dollar": () => Promise.resolve().then(function () { return IconMailDollar$1; }),
  "mail-down": () => Promise.resolve().then(function () { return IconMailDown$1; }),
  "mail-exclamation": () => Promise.resolve().then(function () { return IconMailExclamation$1; }),
  "mail-fast": () => Promise.resolve().then(function () { return IconMailFast$1; }),
  "mail-forward": () => Promise.resolve().then(function () { return IconMailForward$1; }),
  "mail-heart": () => Promise.resolve().then(function () { return IconMailHeart$1; }),
  "mail-minus": () => Promise.resolve().then(function () { return IconMailMinus$1; }),
  "mail-off": () => Promise.resolve().then(function () { return IconMailOff$1; }),
  "mail-opened": () => Promise.resolve().then(function () { return IconMailOpened$1; }),
  "mail-pause": () => Promise.resolve().then(function () { return IconMailPause$1; }),
  "mail-pin": () => Promise.resolve().then(function () { return IconMailPin$1; }),
  "mail-plus": () => Promise.resolve().then(function () { return IconMailPlus$1; }),
  "mail-question": () => Promise.resolve().then(function () { return IconMailQuestion$1; }),
  "mail-search": () => Promise.resolve().then(function () { return IconMailSearch$1; }),
  "mail-share": () => Promise.resolve().then(function () { return IconMailShare$1; }),
  "mail-spark": () => Promise.resolve().then(function () { return IconMailSpark$1; }),
  "mail-star": () => Promise.resolve().then(function () { return IconMailStar$1; }),
  "mail-up": () => Promise.resolve().then(function () { return IconMailUp$1; }),
  "mail-x": () => Promise.resolve().then(function () { return IconMailX$1; }),
  "mail": () => Promise.resolve().then(function () { return IconMail$1; }),
  "mailbox-off": () => Promise.resolve().then(function () { return IconMailboxOff$1; }),
  "mailbox": () => Promise.resolve().then(function () { return IconMailbox$1; }),
  "man": () => Promise.resolve().then(function () { return IconMan$1; }),
  "manual-gearbox": () => Promise.resolve().then(function () { return IconManualGearbox$1; }),
  "map-2": () => Promise.resolve().then(function () { return IconMap2$1; }),
  "map-bolt": () => Promise.resolve().then(function () { return IconMapBolt$1; }),
  "map-cancel": () => Promise.resolve().then(function () { return IconMapCancel$1; }),
  "map-check": () => Promise.resolve().then(function () { return IconMapCheck$1; }),
  "map-code": () => Promise.resolve().then(function () { return IconMapCode$1; }),
  "map-cog": () => Promise.resolve().then(function () { return IconMapCog$1; }),
  "map-discount": () => Promise.resolve().then(function () { return IconMapDiscount$1; }),
  "map-dollar": () => Promise.resolve().then(function () { return IconMapDollar$1; }),
  "map-down": () => Promise.resolve().then(function () { return IconMapDown$1; }),
  "map-east": () => Promise.resolve().then(function () { return IconMapEast$1; }),
  "map-exclamation": () => Promise.resolve().then(function () { return IconMapExclamation$1; }),
  "map-heart": () => Promise.resolve().then(function () { return IconMapHeart$1; }),
  "map-minus": () => Promise.resolve().then(function () { return IconMapMinus$1; }),
  "map-north": () => Promise.resolve().then(function () { return IconMapNorth$1; }),
  "map-off": () => Promise.resolve().then(function () { return IconMapOff$1; }),
  "map-pause": () => Promise.resolve().then(function () { return IconMapPause$1; }),
  "map-pin-2": () => Promise.resolve().then(function () { return IconMapPin2$1; }),
  "map-pin-bolt": () => Promise.resolve().then(function () { return IconMapPinBolt$1; }),
  "map-pin-cancel": () => Promise.resolve().then(function () { return IconMapPinCancel$1; }),
  "map-pin-check": () => Promise.resolve().then(function () { return IconMapPinCheck$1; }),
  "map-pin-code": () => Promise.resolve().then(function () { return IconMapPinCode$1; }),
  "map-pin-cog": () => Promise.resolve().then(function () { return IconMapPinCog$1; }),
  "map-pin-dollar": () => Promise.resolve().then(function () { return IconMapPinDollar$1; }),
  "map-pin-down": () => Promise.resolve().then(function () { return IconMapPinDown$1; }),
  "map-pin-exclamation": () => Promise.resolve().then(function () { return IconMapPinExclamation$1; }),
  "map-pin-heart": () => Promise.resolve().then(function () { return IconMapPinHeart$1; }),
  "map-pin-minus": () => Promise.resolve().then(function () { return IconMapPinMinus$1; }),
  "map-pin-off": () => Promise.resolve().then(function () { return IconMapPinOff$1; }),
  "map-pin-pause": () => Promise.resolve().then(function () { return IconMapPinPause$1; }),
  "map-pin-pin": () => Promise.resolve().then(function () { return IconMapPinPin$1; }),
  "map-pin-plus": () => Promise.resolve().then(function () { return IconMapPinPlus$1; }),
  "map-pin-question": () => Promise.resolve().then(function () { return IconMapPinQuestion$1; }),
  "map-pin-search": () => Promise.resolve().then(function () { return IconMapPinSearch$1; }),
  "map-pin-share": () => Promise.resolve().then(function () { return IconMapPinShare$1; }),
  "map-pin-star": () => Promise.resolve().then(function () { return IconMapPinStar$1; }),
  "map-pin-up": () => Promise.resolve().then(function () { return IconMapPinUp$1; }),
  "map-pin-x": () => Promise.resolve().then(function () { return IconMapPinX$1; }),
  "map-pin": () => Promise.resolve().then(function () { return IconMapPin$1; }),
  "map-pins": () => Promise.resolve().then(function () { return IconMapPins$1; }),
  "map-plus": () => Promise.resolve().then(function () { return IconMapPlus$1; }),
  "map-question": () => Promise.resolve().then(function () { return IconMapQuestion$1; }),
  "map-route": () => Promise.resolve().then(function () { return IconMapRoute$1; }),
  "map-search": () => Promise.resolve().then(function () { return IconMapSearch$1; }),
  "map-share": () => Promise.resolve().then(function () { return IconMapShare$1; }),
  "map-south": () => Promise.resolve().then(function () { return IconMapSouth$1; }),
  "map-star": () => Promise.resolve().then(function () { return IconMapStar$1; }),
  "map-up": () => Promise.resolve().then(function () { return IconMapUp$1; }),
  "map-west": () => Promise.resolve().then(function () { return IconMapWest$1; }),
  "map-x": () => Promise.resolve().then(function () { return IconMapX$1; }),
  "map": () => Promise.resolve().then(function () { return IconMap$1; }),
  "markdown-off": () => Promise.resolve().then(function () { return IconMarkdownOff$1; }),
  "markdown": () => Promise.resolve().then(function () { return IconMarkdown$1; }),
  "marquee-2": () => Promise.resolve().then(function () { return IconMarquee2$1; }),
  "marquee-off": () => Promise.resolve().then(function () { return IconMarqueeOff$1; }),
  "marquee": () => Promise.resolve().then(function () { return IconMarquee$1; }),
  "mars": () => Promise.resolve().then(function () { return IconMars$1; }),
  "mask-off": () => Promise.resolve().then(function () { return IconMaskOff$1; }),
  "mask": () => Promise.resolve().then(function () { return IconMask$1; }),
  "masks-theater-off": () => Promise.resolve().then(function () { return IconMasksTheaterOff$1; }),
  "masks-theater": () => Promise.resolve().then(function () { return IconMasksTheater$1; }),
  "massage": () => Promise.resolve().then(function () { return IconMassage$1; }),
  "matchstick": () => Promise.resolve().then(function () { return IconMatchstick$1; }),
  "math-1-divide-2": () => Promise.resolve().then(function () { return IconMath1Divide2$1; }),
  "math-1-divide-3": () => Promise.resolve().then(function () { return IconMath1Divide3$1; }),
  "math-avg": () => Promise.resolve().then(function () { return IconMathAvg$1; }),
  "math-cos": () => Promise.resolve().then(function () { return IconMathCos$1; }),
  "math-ctg": () => Promise.resolve().then(function () { return IconMathCtg$1; }),
  "math-equal-greater": () => Promise.resolve().then(function () { return IconMathEqualGreater$1; }),
  "math-equal-lower": () => Promise.resolve().then(function () { return IconMathEqualLower$1; }),
  "math-function-off": () => Promise.resolve().then(function () { return IconMathFunctionOff$1; }),
  "math-function-y": () => Promise.resolve().then(function () { return IconMathFunctionY$1; }),
  "math-function": () => Promise.resolve().then(function () { return IconMathFunction$1; }),
  "math-greater": () => Promise.resolve().then(function () { return IconMathGreater$1; }),
  "math-integral-x": () => Promise.resolve().then(function () { return IconMathIntegralX$1; }),
  "math-integral": () => Promise.resolve().then(function () { return IconMathIntegral$1; }),
  "math-integrals": () => Promise.resolve().then(function () { return IconMathIntegrals$1; }),
  "math-lower": () => Promise.resolve().then(function () { return IconMathLower$1; }),
  "math-max-min": () => Promise.resolve().then(function () { return IconMathMaxMin$1; }),
  "math-max": () => Promise.resolve().then(function () { return IconMathMax$1; }),
  "math-min": () => Promise.resolve().then(function () { return IconMathMin$1; }),
  "math-not": () => Promise.resolve().then(function () { return IconMathNot$1; }),
  "math-off": () => Promise.resolve().then(function () { return IconMathOff$1; }),
  "math-pi-divide-2": () => Promise.resolve().then(function () { return IconMathPiDivide2$1; }),
  "math-pi": () => Promise.resolve().then(function () { return IconMathPi$1; }),
  "math-sec": () => Promise.resolve().then(function () { return IconMathSec$1; }),
  "math-sin": () => Promise.resolve().then(function () { return IconMathSin$1; }),
  "math-symbols": () => Promise.resolve().then(function () { return IconMathSymbols$1; }),
  "math-tg": () => Promise.resolve().then(function () { return IconMathTg$1; }),
  "math-x-divide-2": () => Promise.resolve().then(function () { return IconMathXDivide2$1; }),
  "math-x-divide-y-2": () => Promise.resolve().then(function () { return IconMathXDivideY2$1; }),
  "math-x-divide-y": () => Promise.resolve().then(function () { return IconMathXDivideY$1; }),
  "math-x-floor-divide-y": () => Promise.resolve().then(function () { return IconMathXFloorDivideY$1; }),
  "math-x-minus-x": () => Promise.resolve().then(function () { return IconMathXMinusX$1; }),
  "math-x-minus-y": () => Promise.resolve().then(function () { return IconMathXMinusY$1; }),
  "math-x-plus-x": () => Promise.resolve().then(function () { return IconMathXPlusX$1; }),
  "math-x-plus-y": () => Promise.resolve().then(function () { return IconMathXPlusY$1; }),
  "math-xy": () => Promise.resolve().then(function () { return IconMathXy$1; }),
  "math-y-minus-y": () => Promise.resolve().then(function () { return IconMathYMinusY$1; }),
  "math-y-plus-y": () => Promise.resolve().then(function () { return IconMathYPlusY$1; }),
  "math": () => Promise.resolve().then(function () { return IconMath$1; }),
  "matrix": () => Promise.resolve().then(function () { return IconMatrix$1; }),
  "maximize-off": () => Promise.resolve().then(function () { return IconMaximizeOff$1; }),
  "maximize": () => Promise.resolve().then(function () { return IconMaximize$1; }),
  "meat-off": () => Promise.resolve().then(function () { return IconMeatOff$1; }),
  "meat": () => Promise.resolve().then(function () { return IconMeat$1; }),
  "medal-2": () => Promise.resolve().then(function () { return IconMedal2$1; }),
  "medal": () => Promise.resolve().then(function () { return IconMedal$1; }),
  "medical-cross-circle": () => Promise.resolve().then(function () { return IconMedicalCrossCircle$1; }),
  "medical-cross-off": () => Promise.resolve().then(function () { return IconMedicalCrossOff$1; }),
  "medical-cross": () => Promise.resolve().then(function () { return IconMedicalCross$1; }),
  "medicine-syrup": () => Promise.resolve().then(function () { return IconMedicineSyrup$1; }),
  "meeple": () => Promise.resolve().then(function () { return IconMeeple$1; }),
  "melon": () => Promise.resolve().then(function () { return IconMelon$1; }),
  "menorah": () => Promise.resolve().then(function () { return IconMenorah$1; }),
  "menu-2": () => Promise.resolve().then(function () { return IconMenu2$1; }),
  "menu-3": () => Promise.resolve().then(function () { return IconMenu3$1; }),
  "menu-4": () => Promise.resolve().then(function () { return IconMenu4$1; }),
  "menu-deep": () => Promise.resolve().then(function () { return IconMenuDeep$1; }),
  "menu-order": () => Promise.resolve().then(function () { return IconMenuOrder$1; }),
  "menu": () => Promise.resolve().then(function () { return IconMenu$1; }),
  "message-2-bolt": () => Promise.resolve().then(function () { return IconMessage2Bolt$1; }),
  "message-2-cancel": () => Promise.resolve().then(function () { return IconMessage2Cancel$1; }),
  "message-2-check": () => Promise.resolve().then(function () { return IconMessage2Check$1; }),
  "message-2-code": () => Promise.resolve().then(function () { return IconMessage2Code$1; }),
  "message-2-cog": () => Promise.resolve().then(function () { return IconMessage2Cog$1; }),
  "message-2-dollar": () => Promise.resolve().then(function () { return IconMessage2Dollar$1; }),
  "message-2-down": () => Promise.resolve().then(function () { return IconMessage2Down$1; }),
  "message-2-exclamation": () => Promise.resolve().then(function () { return IconMessage2Exclamation$1; }),
  "message-2-heart": () => Promise.resolve().then(function () { return IconMessage2Heart$1; }),
  "message-2-minus": () => Promise.resolve().then(function () { return IconMessage2Minus$1; }),
  "message-2-off": () => Promise.resolve().then(function () { return IconMessage2Off$1; }),
  "message-2-pause": () => Promise.resolve().then(function () { return IconMessage2Pause$1; }),
  "message-2-pin": () => Promise.resolve().then(function () { return IconMessage2Pin$1; }),
  "message-2-plus": () => Promise.resolve().then(function () { return IconMessage2Plus$1; }),
  "message-2-question": () => Promise.resolve().then(function () { return IconMessage2Question$1; }),
  "message-2-search": () => Promise.resolve().then(function () { return IconMessage2Search$1; }),
  "message-2-share": () => Promise.resolve().then(function () { return IconMessage2Share$1; }),
  "message-2-star": () => Promise.resolve().then(function () { return IconMessage2Star$1; }),
  "message-2-up": () => Promise.resolve().then(function () { return IconMessage2Up$1; }),
  "message-2-x": () => Promise.resolve().then(function () { return IconMessage2X$1; }),
  "message-2": () => Promise.resolve().then(function () { return IconMessage2$1; }),
  "message-bolt": () => Promise.resolve().then(function () { return IconMessageBolt$1; }),
  "message-cancel": () => Promise.resolve().then(function () { return IconMessageCancel$1; }),
  "message-chatbot": () => Promise.resolve().then(function () { return IconMessageChatbot$1; }),
  "message-check": () => Promise.resolve().then(function () { return IconMessageCheck$1; }),
  "message-circle-bolt": () => Promise.resolve().then(function () { return IconMessageCircleBolt$1; }),
  "message-circle-cancel": () => Promise.resolve().then(function () { return IconMessageCircleCancel$1; }),
  "message-circle-check": () => Promise.resolve().then(function () { return IconMessageCircleCheck$1; }),
  "message-circle-code": () => Promise.resolve().then(function () { return IconMessageCircleCode$1; }),
  "message-circle-cog": () => Promise.resolve().then(function () { return IconMessageCircleCog$1; }),
  "message-circle-dollar": () => Promise.resolve().then(function () { return IconMessageCircleDollar$1; }),
  "message-circle-down": () => Promise.resolve().then(function () { return IconMessageCircleDown$1; }),
  "message-circle-exclamation": () => Promise.resolve().then(function () { return IconMessageCircleExclamation$1; }),
  "message-circle-heart": () => Promise.resolve().then(function () { return IconMessageCircleHeart$1; }),
  "message-circle-minus": () => Promise.resolve().then(function () { return IconMessageCircleMinus$1; }),
  "message-circle-off": () => Promise.resolve().then(function () { return IconMessageCircleOff$1; }),
  "message-circle-pause": () => Promise.resolve().then(function () { return IconMessageCirclePause$1; }),
  "message-circle-pin": () => Promise.resolve().then(function () { return IconMessageCirclePin$1; }),
  "message-circle-plus": () => Promise.resolve().then(function () { return IconMessageCirclePlus$1; }),
  "message-circle-question": () => Promise.resolve().then(function () { return IconMessageCircleQuestion$1; }),
  "message-circle-search": () => Promise.resolve().then(function () { return IconMessageCircleSearch$1; }),
  "message-circle-share": () => Promise.resolve().then(function () { return IconMessageCircleShare$1; }),
  "message-circle-star": () => Promise.resolve().then(function () { return IconMessageCircleStar$1; }),
  "message-circle-up": () => Promise.resolve().then(function () { return IconMessageCircleUp$1; }),
  "message-circle-user": () => Promise.resolve().then(function () { return IconMessageCircleUser$1; }),
  "message-circle-x": () => Promise.resolve().then(function () { return IconMessageCircleX$1; }),
  "message-circle": () => Promise.resolve().then(function () { return IconMessageCircle$1; }),
  "message-code": () => Promise.resolve().then(function () { return IconMessageCode$1; }),
  "message-cog": () => Promise.resolve().then(function () { return IconMessageCog$1; }),
  "message-dollar": () => Promise.resolve().then(function () { return IconMessageDollar$1; }),
  "message-dots": () => Promise.resolve().then(function () { return IconMessageDots$1; }),
  "message-down": () => Promise.resolve().then(function () { return IconMessageDown$1; }),
  "message-exclamation": () => Promise.resolve().then(function () { return IconMessageExclamation$1; }),
  "message-forward": () => Promise.resolve().then(function () { return IconMessageForward$1; }),
  "message-heart": () => Promise.resolve().then(function () { return IconMessageHeart$1; }),
  "message-language": () => Promise.resolve().then(function () { return IconMessageLanguage$1; }),
  "message-minus": () => Promise.resolve().then(function () { return IconMessageMinus$1; }),
  "message-off": () => Promise.resolve().then(function () { return IconMessageOff$1; }),
  "message-pause": () => Promise.resolve().then(function () { return IconMessagePause$1; }),
  "message-pin": () => Promise.resolve().then(function () { return IconMessagePin$1; }),
  "message-plus": () => Promise.resolve().then(function () { return IconMessagePlus$1; }),
  "message-question": () => Promise.resolve().then(function () { return IconMessageQuestion$1; }),
  "message-reply": () => Promise.resolve().then(function () { return IconMessageReply$1; }),
  "message-report": () => Promise.resolve().then(function () { return IconMessageReport$1; }),
  "message-search": () => Promise.resolve().then(function () { return IconMessageSearch$1; }),
  "message-share": () => Promise.resolve().then(function () { return IconMessageShare$1; }),
  "message-star": () => Promise.resolve().then(function () { return IconMessageStar$1; }),
  "message-up": () => Promise.resolve().then(function () { return IconMessageUp$1; }),
  "message-user": () => Promise.resolve().then(function () { return IconMessageUser$1; }),
  "message-x": () => Promise.resolve().then(function () { return IconMessageX$1; }),
  "message": () => Promise.resolve().then(function () { return IconMessage$1; }),
  "messages-off": () => Promise.resolve().then(function () { return IconMessagesOff$1; }),
  "messages": () => Promise.resolve().then(function () { return IconMessages$1; }),
  "meteor-off": () => Promise.resolve().then(function () { return IconMeteorOff$1; }),
  "meteor": () => Promise.resolve().then(function () { return IconMeteor$1; }),
  "meter-cube": () => Promise.resolve().then(function () { return IconMeterCube$1; }),
  "meter-square": () => Promise.resolve().then(function () { return IconMeterSquare$1; }),
  "metronome": () => Promise.resolve().then(function () { return IconMetronome$1; }),
  "michelin-bib-gourmand": () => Promise.resolve().then(function () { return IconMichelinBibGourmand$1; }),
  "michelin-star-green": () => Promise.resolve().then(function () { return IconMichelinStarGreen$1; }),
  "michelin-star": () => Promise.resolve().then(function () { return IconMichelinStar$1; }),
  "mickey": () => Promise.resolve().then(function () { return IconMickey$1; }),
  "microphone-2-off": () => Promise.resolve().then(function () { return IconMicrophone2Off$1; }),
  "microphone-2": () => Promise.resolve().then(function () { return IconMicrophone2$1; }),
  "microphone-off": () => Promise.resolve().then(function () { return IconMicrophoneOff$1; }),
  "microphone": () => Promise.resolve().then(function () { return IconMicrophone$1; }),
  "microscope-off": () => Promise.resolve().then(function () { return IconMicroscopeOff$1; }),
  "microscope": () => Promise.resolve().then(function () { return IconMicroscope$1; }),
  "microwave-off": () => Promise.resolve().then(function () { return IconMicrowaveOff$1; }),
  "microwave": () => Promise.resolve().then(function () { return IconMicrowave$1; }),
  "military-award": () => Promise.resolve().then(function () { return IconMilitaryAward$1; }),
  "military-rank": () => Promise.resolve().then(function () { return IconMilitaryRank$1; }),
  "milk-off": () => Promise.resolve().then(function () { return IconMilkOff$1; }),
  "milk": () => Promise.resolve().then(function () { return IconMilk$1; }),
  "milkshake": () => Promise.resolve().then(function () { return IconMilkshake$1; }),
  "minimize": () => Promise.resolve().then(function () { return IconMinimize$1; }),
  "minus-vertical": () => Promise.resolve().then(function () { return IconMinusVertical$1; }),
  "minus": () => Promise.resolve().then(function () { return IconMinus$1; }),
  "mist-off": () => Promise.resolve().then(function () { return IconMistOff$1; }),
  "mist": () => Promise.resolve().then(function () { return IconMist$1; }),
  "mobiledata-off": () => Promise.resolve().then(function () { return IconMobiledataOff$1; }),
  "mobiledata": () => Promise.resolve().then(function () { return IconMobiledata$1; }),
  "moneybag-edit": () => Promise.resolve().then(function () { return IconMoneybagEdit$1; }),
  "moneybag-heart": () => Promise.resolve().then(function () { return IconMoneybagHeart$1; }),
  "moneybag-minus": () => Promise.resolve().then(function () { return IconMoneybagMinus$1; }),
  "moneybag-move-back": () => Promise.resolve().then(function () { return IconMoneybagMoveBack$1; }),
  "moneybag-move": () => Promise.resolve().then(function () { return IconMoneybagMove$1; }),
  "moneybag-plus": () => Promise.resolve().then(function () { return IconMoneybagPlus$1; }),
  "moneybag": () => Promise.resolve().then(function () { return IconMoneybag$1; }),
  "monkeybar": () => Promise.resolve().then(function () { return IconMonkeybar$1; }),
  "mood-angry": () => Promise.resolve().then(function () { return IconMoodAngry$1; }),
  "mood-annoyed-2": () => Promise.resolve().then(function () { return IconMoodAnnoyed2$1; }),
  "mood-annoyed": () => Promise.resolve().then(function () { return IconMoodAnnoyed$1; }),
  "mood-bitcoin": () => Promise.resolve().then(function () { return IconMoodBitcoin$1; }),
  "mood-boy": () => Promise.resolve().then(function () { return IconMoodBoy$1; }),
  "mood-check": () => Promise.resolve().then(function () { return IconMoodCheck$1; }),
  "mood-cog": () => Promise.resolve().then(function () { return IconMoodCog$1; }),
  "mood-confuzed": () => Promise.resolve().then(function () { return IconMoodConfuzed$1; }),
  "mood-crazy-happy": () => Promise.resolve().then(function () { return IconMoodCrazyHappy$1; }),
  "mood-cry": () => Promise.resolve().then(function () { return IconMoodCry$1; }),
  "mood-dollar": () => Promise.resolve().then(function () { return IconMoodDollar$1; }),
  "mood-edit": () => Promise.resolve().then(function () { return IconMoodEdit$1; }),
  "mood-empty": () => Promise.resolve().then(function () { return IconMoodEmpty$1; }),
  "mood-happy": () => Promise.resolve().then(function () { return IconMoodHappy$1; }),
  "mood-heart": () => Promise.resolve().then(function () { return IconMoodHeart$1; }),
  "mood-kid": () => Promise.resolve().then(function () { return IconMoodKid$1; }),
  "mood-look-down": () => Promise.resolve().then(function () { return IconMoodLookDown$1; }),
  "mood-look-left": () => Promise.resolve().then(function () { return IconMoodLookLeft$1; }),
  "mood-look-right": () => Promise.resolve().then(function () { return IconMoodLookRight$1; }),
  "mood-look-up": () => Promise.resolve().then(function () { return IconMoodLookUp$1; }),
  "mood-minus": () => Promise.resolve().then(function () { return IconMoodMinus$1; }),
  "mood-nerd": () => Promise.resolve().then(function () { return IconMoodNerd$1; }),
  "mood-nervous": () => Promise.resolve().then(function () { return IconMoodNervous$1; }),
  "mood-neutral": () => Promise.resolve().then(function () { return IconMoodNeutral$1; }),
  "mood-off": () => Promise.resolve().then(function () { return IconMoodOff$1; }),
  "mood-pin": () => Promise.resolve().then(function () { return IconMoodPin$1; }),
  "mood-plus": () => Promise.resolve().then(function () { return IconMoodPlus$1; }),
  "mood-puzzled": () => Promise.resolve().then(function () { return IconMoodPuzzled$1; }),
  "mood-sad-2": () => Promise.resolve().then(function () { return IconMoodSad2$1; }),
  "mood-sad-dizzy": () => Promise.resolve().then(function () { return IconMoodSadDizzy$1; }),
  "mood-sad-squint": () => Promise.resolve().then(function () { return IconMoodSadSquint$1; }),
  "mood-sad": () => Promise.resolve().then(function () { return IconMoodSad$1; }),
  "mood-search": () => Promise.resolve().then(function () { return IconMoodSearch$1; }),
  "mood-share": () => Promise.resolve().then(function () { return IconMoodShare$1; }),
  "mood-sick": () => Promise.resolve().then(function () { return IconMoodSick$1; }),
  "mood-silence": () => Promise.resolve().then(function () { return IconMoodSilence$1; }),
  "mood-sing": () => Promise.resolve().then(function () { return IconMoodSing$1; }),
  "mood-smile-beam": () => Promise.resolve().then(function () { return IconMoodSmileBeam$1; }),
  "mood-smile-dizzy": () => Promise.resolve().then(function () { return IconMoodSmileDizzy$1; }),
  "mood-smile": () => Promise.resolve().then(function () { return IconMoodSmile$1; }),
  "mood-spark": () => Promise.resolve().then(function () { return IconMoodSpark$1; }),
  "mood-surprised": () => Promise.resolve().then(function () { return IconMoodSurprised$1; }),
  "mood-tongue-wink-2": () => Promise.resolve().then(function () { return IconMoodTongueWink2$1; }),
  "mood-tongue-wink": () => Promise.resolve().then(function () { return IconMoodTongueWink$1; }),
  "mood-tongue": () => Promise.resolve().then(function () { return IconMoodTongue$1; }),
  "mood-unamused": () => Promise.resolve().then(function () { return IconMoodUnamused$1; }),
  "mood-up": () => Promise.resolve().then(function () { return IconMoodUp$1; }),
  "mood-wink-2": () => Promise.resolve().then(function () { return IconMoodWink2$1; }),
  "mood-wink": () => Promise.resolve().then(function () { return IconMoodWink$1; }),
  "mood-wrrr": () => Promise.resolve().then(function () { return IconMoodWrrr$1; }),
  "mood-x": () => Promise.resolve().then(function () { return IconMoodX$1; }),
  "mood-xd": () => Promise.resolve().then(function () { return IconMoodXd$1; }),
  "moon-2": () => Promise.resolve().then(function () { return IconMoon2$1; }),
  "moon-off": () => Promise.resolve().then(function () { return IconMoonOff$1; }),
  "moon-stars": () => Promise.resolve().then(function () { return IconMoonStars$1; }),
  "moon": () => Promise.resolve().then(function () { return IconMoon$1; }),
  "moped": () => Promise.resolve().then(function () { return IconMoped$1; }),
  "motorbike": () => Promise.resolve().then(function () { return IconMotorbike$1; }),
  "mountain-off": () => Promise.resolve().then(function () { return IconMountainOff$1; }),
  "mountain": () => Promise.resolve().then(function () { return IconMountain$1; }),
  "mouse-2": () => Promise.resolve().then(function () { return IconMouse2$1; }),
  "mouse-off": () => Promise.resolve().then(function () { return IconMouseOff$1; }),
  "mouse": () => Promise.resolve().then(function () { return IconMouse$1; }),
  "moustache": () => Promise.resolve().then(function () { return IconMoustache$1; }),
  "movie-off": () => Promise.resolve().then(function () { return IconMovieOff$1; }),
  "movie": () => Promise.resolve().then(function () { return IconMovie$1; }),
  "mug-off": () => Promise.resolve().then(function () { return IconMugOff$1; }),
  "mug": () => Promise.resolve().then(function () { return IconMug$1; }),
  "multiplier-0-5x": () => Promise.resolve().then(function () { return IconMultiplier05x$1; }),
  "multiplier-1-5x": () => Promise.resolve().then(function () { return IconMultiplier15x$1; }),
  "multiplier-1x": () => Promise.resolve().then(function () { return IconMultiplier1x$1; }),
  "multiplier-2x": () => Promise.resolve().then(function () { return IconMultiplier2x$1; }),
  "mushroom-off": () => Promise.resolve().then(function () { return IconMushroomOff$1; }),
  "mushroom": () => Promise.resolve().then(function () { return IconMushroom$1; }),
  "music-bolt": () => Promise.resolve().then(function () { return IconMusicBolt$1; }),
  "music-cancel": () => Promise.resolve().then(function () { return IconMusicCancel$1; }),
  "music-check": () => Promise.resolve().then(function () { return IconMusicCheck$1; }),
  "music-code": () => Promise.resolve().then(function () { return IconMusicCode$1; }),
  "music-cog": () => Promise.resolve().then(function () { return IconMusicCog$1; }),
  "music-discount": () => Promise.resolve().then(function () { return IconMusicDiscount$1; }),
  "music-dollar": () => Promise.resolve().then(function () { return IconMusicDollar$1; }),
  "music-down": () => Promise.resolve().then(function () { return IconMusicDown$1; }),
  "music-exclamation": () => Promise.resolve().then(function () { return IconMusicExclamation$1; }),
  "music-heart": () => Promise.resolve().then(function () { return IconMusicHeart$1; }),
  "music-minus": () => Promise.resolve().then(function () { return IconMusicMinus$1; }),
  "music-off": () => Promise.resolve().then(function () { return IconMusicOff$1; }),
  "music-pause": () => Promise.resolve().then(function () { return IconMusicPause$1; }),
  "music-pin": () => Promise.resolve().then(function () { return IconMusicPin$1; }),
  "music-plus": () => Promise.resolve().then(function () { return IconMusicPlus$1; }),
  "music-question": () => Promise.resolve().then(function () { return IconMusicQuestion$1; }),
  "music-search": () => Promise.resolve().then(function () { return IconMusicSearch$1; }),
  "music-share": () => Promise.resolve().then(function () { return IconMusicShare$1; }),
  "music-star": () => Promise.resolve().then(function () { return IconMusicStar$1; }),
  "music-up": () => Promise.resolve().then(function () { return IconMusicUp$1; }),
  "music-x": () => Promise.resolve().then(function () { return IconMusicX$1; }),
  "music": () => Promise.resolve().then(function () { return IconMusic$1; }),
  "navigation-bolt": () => Promise.resolve().then(function () { return IconNavigationBolt$1; }),
  "navigation-cancel": () => Promise.resolve().then(function () { return IconNavigationCancel$1; }),
  "navigation-check": () => Promise.resolve().then(function () { return IconNavigationCheck$1; }),
  "navigation-code": () => Promise.resolve().then(function () { return IconNavigationCode$1; }),
  "navigation-cog": () => Promise.resolve().then(function () { return IconNavigationCog$1; }),
  "navigation-discount": () => Promise.resolve().then(function () { return IconNavigationDiscount$1; }),
  "navigation-dollar": () => Promise.resolve().then(function () { return IconNavigationDollar$1; }),
  "navigation-down": () => Promise.resolve().then(function () { return IconNavigationDown$1; }),
  "navigation-east": () => Promise.resolve().then(function () { return IconNavigationEast$1; }),
  "navigation-exclamation": () => Promise.resolve().then(function () { return IconNavigationExclamation$1; }),
  "navigation-heart": () => Promise.resolve().then(function () { return IconNavigationHeart$1; }),
  "navigation-minus": () => Promise.resolve().then(function () { return IconNavigationMinus$1; }),
  "navigation-north": () => Promise.resolve().then(function () { return IconNavigationNorth$1; }),
  "navigation-off": () => Promise.resolve().then(function () { return IconNavigationOff$1; }),
  "navigation-pause": () => Promise.resolve().then(function () { return IconNavigationPause$1; }),
  "navigation-pin": () => Promise.resolve().then(function () { return IconNavigationPin$1; }),
  "navigation-plus": () => Promise.resolve().then(function () { return IconNavigationPlus$1; }),
  "navigation-question": () => Promise.resolve().then(function () { return IconNavigationQuestion$1; }),
  "navigation-search": () => Promise.resolve().then(function () { return IconNavigationSearch$1; }),
  "navigation-share": () => Promise.resolve().then(function () { return IconNavigationShare$1; }),
  "navigation-south": () => Promise.resolve().then(function () { return IconNavigationSouth$1; }),
  "navigation-star": () => Promise.resolve().then(function () { return IconNavigationStar$1; }),
  "navigation-top": () => Promise.resolve().then(function () { return IconNavigationTop$1; }),
  "navigation-up": () => Promise.resolve().then(function () { return IconNavigationUp$1; }),
  "navigation-west": () => Promise.resolve().then(function () { return IconNavigationWest$1; }),
  "navigation-x": () => Promise.resolve().then(function () { return IconNavigationX$1; }),
  "navigation": () => Promise.resolve().then(function () { return IconNavigation$1; }),
  "needle-thread": () => Promise.resolve().then(function () { return IconNeedleThread$1; }),
  "needle": () => Promise.resolve().then(function () { return IconNeedle$1; }),
  "network-off": () => Promise.resolve().then(function () { return IconNetworkOff$1; }),
  "network": () => Promise.resolve().then(function () { return IconNetwork$1; }),
  "new-section": () => Promise.resolve().then(function () { return IconNewSection$1; }),
  "news-off": () => Promise.resolve().then(function () { return IconNewsOff$1; }),
  "news": () => Promise.resolve().then(function () { return IconNews$1; }),
  "nfc-off": () => Promise.resolve().then(function () { return IconNfcOff$1; }),
  "nfc": () => Promise.resolve().then(function () { return IconNfc$1; }),
  "no-copyright": () => Promise.resolve().then(function () { return IconNoCopyright$1; }),
  "no-creative-commons": () => Promise.resolve().then(function () { return IconNoCreativeCommons$1; }),
  "no-derivatives": () => Promise.resolve().then(function () { return IconNoDerivatives$1; }),
  "north-star": () => Promise.resolve().then(function () { return IconNorthStar$1; }),
  "note-off": () => Promise.resolve().then(function () { return IconNoteOff$1; }),
  "note": () => Promise.resolve().then(function () { return IconNote$1; }),
  "notebook-off": () => Promise.resolve().then(function () { return IconNotebookOff$1; }),
  "notebook": () => Promise.resolve().then(function () { return IconNotebook$1; }),
  "notes-off": () => Promise.resolve().then(function () { return IconNotesOff$1; }),
  "notes": () => Promise.resolve().then(function () { return IconNotes$1; }),
  "notification-off": () => Promise.resolve().then(function () { return IconNotificationOff$1; }),
  "notification": () => Promise.resolve().then(function () { return IconNotification$1; }),
  "number-0-small": () => Promise.resolve().then(function () { return IconNumber0Small$1; }),
  "number-0": () => Promise.resolve().then(function () { return IconNumber0$1; }),
  "number-1-small": () => Promise.resolve().then(function () { return IconNumber1Small$1; }),
  "number-1": () => Promise.resolve().then(function () { return IconNumber1$1; }),
  "number-10-small": () => Promise.resolve().then(function () { return IconNumber10Small$1; }),
  "number-10": () => Promise.resolve().then(function () { return IconNumber10$1; }),
  "number-100-small": () => Promise.resolve().then(function () { return IconNumber100Small$1; }),
  "number-11-small": () => Promise.resolve().then(function () { return IconNumber11Small$1; }),
  "number-11": () => Promise.resolve().then(function () { return IconNumber11$1; }),
  "number-12-small": () => Promise.resolve().then(function () { return IconNumber12Small$1; }),
  "number-123": () => Promise.resolve().then(function () { return IconNumber123$1; }),
  "number-13-small": () => Promise.resolve().then(function () { return IconNumber13Small$1; }),
  "number-14-small": () => Promise.resolve().then(function () { return IconNumber14Small$1; }),
  "number-15-small": () => Promise.resolve().then(function () { return IconNumber15Small$1; }),
  "number-16-small": () => Promise.resolve().then(function () { return IconNumber16Small$1; }),
  "number-17-small": () => Promise.resolve().then(function () { return IconNumber17Small$1; }),
  "number-18-small": () => Promise.resolve().then(function () { return IconNumber18Small$1; }),
  "number-19-small": () => Promise.resolve().then(function () { return IconNumber19Small$1; }),
  "number-2-small": () => Promise.resolve().then(function () { return IconNumber2Small$1; }),
  "number-2": () => Promise.resolve().then(function () { return IconNumber2$1; }),
  "number-20-small": () => Promise.resolve().then(function () { return IconNumber20Small$1; }),
  "number-21-small": () => Promise.resolve().then(function () { return IconNumber21Small$1; }),
  "number-22-small": () => Promise.resolve().then(function () { return IconNumber22Small$1; }),
  "number-23-small": () => Promise.resolve().then(function () { return IconNumber23Small$1; }),
  "number-24-small": () => Promise.resolve().then(function () { return IconNumber24Small$1; }),
  "number-25-small": () => Promise.resolve().then(function () { return IconNumber25Small$1; }),
  "number-26-small": () => Promise.resolve().then(function () { return IconNumber26Small$1; }),
  "number-27-small": () => Promise.resolve().then(function () { return IconNumber27Small$1; }),
  "number-28-small": () => Promise.resolve().then(function () { return IconNumber28Small$1; }),
  "number-29-small": () => Promise.resolve().then(function () { return IconNumber29Small$1; }),
  "number-3-small": () => Promise.resolve().then(function () { return IconNumber3Small$1; }),
  "number-3": () => Promise.resolve().then(function () { return IconNumber3$1; }),
  "number-30-small": () => Promise.resolve().then(function () { return IconNumber30Small$1; }),
  "number-31-small": () => Promise.resolve().then(function () { return IconNumber31Small$1; }),
  "number-32-small": () => Promise.resolve().then(function () { return IconNumber32Small$1; }),
  "number-33-small": () => Promise.resolve().then(function () { return IconNumber33Small$1; }),
  "number-34-small": () => Promise.resolve().then(function () { return IconNumber34Small$1; }),
  "number-35-small": () => Promise.resolve().then(function () { return IconNumber35Small$1; }),
  "number-36-small": () => Promise.resolve().then(function () { return IconNumber36Small$1; }),
  "number-37-small": () => Promise.resolve().then(function () { return IconNumber37Small$1; }),
  "number-38-small": () => Promise.resolve().then(function () { return IconNumber38Small$1; }),
  "number-39-small": () => Promise.resolve().then(function () { return IconNumber39Small$1; }),
  "number-4-small": () => Promise.resolve().then(function () { return IconNumber4Small$1; }),
  "number-4": () => Promise.resolve().then(function () { return IconNumber4$1; }),
  "number-40-small": () => Promise.resolve().then(function () { return IconNumber40Small$1; }),
  "number-41-small": () => Promise.resolve().then(function () { return IconNumber41Small$1; }),
  "number-42-small": () => Promise.resolve().then(function () { return IconNumber42Small$1; }),
  "number-43-small": () => Promise.resolve().then(function () { return IconNumber43Small$1; }),
  "number-44-small": () => Promise.resolve().then(function () { return IconNumber44Small$1; }),
  "number-45-small": () => Promise.resolve().then(function () { return IconNumber45Small$1; }),
  "number-46-small": () => Promise.resolve().then(function () { return IconNumber46Small$1; }),
  "number-47-small": () => Promise.resolve().then(function () { return IconNumber47Small$1; }),
  "number-48-small": () => Promise.resolve().then(function () { return IconNumber48Small$1; }),
  "number-49-small": () => Promise.resolve().then(function () { return IconNumber49Small$1; }),
  "number-5-small": () => Promise.resolve().then(function () { return IconNumber5Small$1; }),
  "number-5": () => Promise.resolve().then(function () { return IconNumber5$1; }),
  "number-50-small": () => Promise.resolve().then(function () { return IconNumber50Small$1; }),
  "number-51-small": () => Promise.resolve().then(function () { return IconNumber51Small$1; }),
  "number-52-small": () => Promise.resolve().then(function () { return IconNumber52Small$1; }),
  "number-53-small": () => Promise.resolve().then(function () { return IconNumber53Small$1; }),
  "number-54-small": () => Promise.resolve().then(function () { return IconNumber54Small$1; }),
  "number-55-small": () => Promise.resolve().then(function () { return IconNumber55Small$1; }),
  "number-56-small": () => Promise.resolve().then(function () { return IconNumber56Small$1; }),
  "number-57-small": () => Promise.resolve().then(function () { return IconNumber57Small$1; }),
  "number-58-small": () => Promise.resolve().then(function () { return IconNumber58Small$1; }),
  "number-59-small": () => Promise.resolve().then(function () { return IconNumber59Small$1; }),
  "number-6-small": () => Promise.resolve().then(function () { return IconNumber6Small$1; }),
  "number-6": () => Promise.resolve().then(function () { return IconNumber6$1; }),
  "number-60-small": () => Promise.resolve().then(function () { return IconNumber60Small$1; }),
  "number-61-small": () => Promise.resolve().then(function () { return IconNumber61Small$1; }),
  "number-62-small": () => Promise.resolve().then(function () { return IconNumber62Small$1; }),
  "number-63-small": () => Promise.resolve().then(function () { return IconNumber63Small$1; }),
  "number-64-small": () => Promise.resolve().then(function () { return IconNumber64Small$1; }),
  "number-65-small": () => Promise.resolve().then(function () { return IconNumber65Small$1; }),
  "number-66-small": () => Promise.resolve().then(function () { return IconNumber66Small$1; }),
  "number-67-small": () => Promise.resolve().then(function () { return IconNumber67Small$1; }),
  "number-68-small": () => Promise.resolve().then(function () { return IconNumber68Small$1; }),
  "number-69-small": () => Promise.resolve().then(function () { return IconNumber69Small$1; }),
  "number-7-small": () => Promise.resolve().then(function () { return IconNumber7Small$1; }),
  "number-7": () => Promise.resolve().then(function () { return IconNumber7$1; }),
  "number-70-small": () => Promise.resolve().then(function () { return IconNumber70Small$1; }),
  "number-71-small": () => Promise.resolve().then(function () { return IconNumber71Small$1; }),
  "number-72-small": () => Promise.resolve().then(function () { return IconNumber72Small$1; }),
  "number-73-small": () => Promise.resolve().then(function () { return IconNumber73Small$1; }),
  "number-74-small": () => Promise.resolve().then(function () { return IconNumber74Small$1; }),
  "number-75-small": () => Promise.resolve().then(function () { return IconNumber75Small$1; }),
  "number-76-small": () => Promise.resolve().then(function () { return IconNumber76Small$1; }),
  "number-77-small": () => Promise.resolve().then(function () { return IconNumber77Small$1; }),
  "number-78-small": () => Promise.resolve().then(function () { return IconNumber78Small$1; }),
  "number-79-small": () => Promise.resolve().then(function () { return IconNumber79Small$1; }),
  "number-8-small": () => Promise.resolve().then(function () { return IconNumber8Small$1; }),
  "number-8": () => Promise.resolve().then(function () { return IconNumber8$1; }),
  "number-80-small": () => Promise.resolve().then(function () { return IconNumber80Small$1; }),
  "number-81-small": () => Promise.resolve().then(function () { return IconNumber81Small$1; }),
  "number-82-small": () => Promise.resolve().then(function () { return IconNumber82Small$1; }),
  "number-83-small": () => Promise.resolve().then(function () { return IconNumber83Small$1; }),
  "number-84-small": () => Promise.resolve().then(function () { return IconNumber84Small$1; }),
  "number-85-small": () => Promise.resolve().then(function () { return IconNumber85Small$1; }),
  "number-86-small": () => Promise.resolve().then(function () { return IconNumber86Small$1; }),
  "number-87-small": () => Promise.resolve().then(function () { return IconNumber87Small$1; }),
  "number-88-small": () => Promise.resolve().then(function () { return IconNumber88Small$1; }),
  "number-89-small": () => Promise.resolve().then(function () { return IconNumber89Small$1; }),
  "number-9-small": () => Promise.resolve().then(function () { return IconNumber9Small$1; }),
  "number-9": () => Promise.resolve().then(function () { return IconNumber9$1; }),
  "number-90-small": () => Promise.resolve().then(function () { return IconNumber90Small$1; }),
  "number-91-small": () => Promise.resolve().then(function () { return IconNumber91Small$1; }),
  "number-92-small": () => Promise.resolve().then(function () { return IconNumber92Small$1; }),
  "number-93-small": () => Promise.resolve().then(function () { return IconNumber93Small$1; }),
  "number-94-small": () => Promise.resolve().then(function () { return IconNumber94Small$1; }),
  "number-95-small": () => Promise.resolve().then(function () { return IconNumber95Small$1; }),
  "number-96-small": () => Promise.resolve().then(function () { return IconNumber96Small$1; }),
  "number-97-small": () => Promise.resolve().then(function () { return IconNumber97Small$1; }),
  "number-98-small": () => Promise.resolve().then(function () { return IconNumber98Small$1; }),
  "number-99-small": () => Promise.resolve().then(function () { return IconNumber99Small$1; }),
  "number": () => Promise.resolve().then(function () { return IconNumber$1; }),
  "numbers": () => Promise.resolve().then(function () { return IconNumbers$1; }),
  "nurse": () => Promise.resolve().then(function () { return IconNurse$1; }),
  "nut": () => Promise.resolve().then(function () { return IconNut$1; }),
  "object-scan": () => Promise.resolve().then(function () { return IconObjectScan$1; }),
  "octagon-minus-2": () => Promise.resolve().then(function () { return IconOctagonMinus2$1; }),
  "octagon-minus": () => Promise.resolve().then(function () { return IconOctagonMinus$1; }),
  "octagon-off": () => Promise.resolve().then(function () { return IconOctagonOff$1; }),
  "octagon-plus-2": () => Promise.resolve().then(function () { return IconOctagonPlus2$1; }),
  "octagon-plus": () => Promise.resolve().then(function () { return IconOctagonPlus$1; }),
  "octagon": () => Promise.resolve().then(function () { return IconOctagon$1; }),
  "octahedron-off": () => Promise.resolve().then(function () { return IconOctahedronOff$1; }),
  "octahedron-plus": () => Promise.resolve().then(function () { return IconOctahedronPlus$1; }),
  "octahedron": () => Promise.resolve().then(function () { return IconOctahedron$1; }),
  "old": () => Promise.resolve().then(function () { return IconOld$1; }),
  "olympics-off": () => Promise.resolve().then(function () { return IconOlympicsOff$1; }),
  "olympics": () => Promise.resolve().then(function () { return IconOlympics$1; }),
  "om": () => Promise.resolve().then(function () { return IconOm$1; }),
  "omega": () => Promise.resolve().then(function () { return IconOmega$1; }),
  "outbound": () => Promise.resolve().then(function () { return IconOutbound$1; }),
  "outlet": () => Promise.resolve().then(function () { return IconOutlet$1; }),
  "oval-vertical": () => Promise.resolve().then(function () { return IconOvalVertical$1; }),
  "oval": () => Promise.resolve().then(function () { return IconOval$1; }),
  "overline": () => Promise.resolve().then(function () { return IconOverline$1; }),
  "package-export": () => Promise.resolve().then(function () { return IconPackageExport$1; }),
  "package-import": () => Promise.resolve().then(function () { return IconPackageImport$1; }),
  "package-off": () => Promise.resolve().then(function () { return IconPackageOff$1; }),
  "package": () => Promise.resolve().then(function () { return IconPackage$1; }),
  "packages": () => Promise.resolve().then(function () { return IconPackages$1; }),
  "pacman": () => Promise.resolve().then(function () { return IconPacman$1; }),
  "page-break": () => Promise.resolve().then(function () { return IconPageBreak$1; }),
  "paint-off": () => Promise.resolve().then(function () { return IconPaintOff$1; }),
  "paint": () => Promise.resolve().then(function () { return IconPaint$1; }),
  "palette-off": () => Promise.resolve().then(function () { return IconPaletteOff$1; }),
  "palette": () => Promise.resolve().then(function () { return IconPalette$1; }),
  "panorama-horizontal-off": () => Promise.resolve().then(function () { return IconPanoramaHorizontalOff$1; }),
  "panorama-horizontal": () => Promise.resolve().then(function () { return IconPanoramaHorizontal$1; }),
  "panorama-vertical-off": () => Promise.resolve().then(function () { return IconPanoramaVerticalOff$1; }),
  "panorama-vertical": () => Promise.resolve().then(function () { return IconPanoramaVertical$1; }),
  "paper-bag-off": () => Promise.resolve().then(function () { return IconPaperBagOff$1; }),
  "paper-bag": () => Promise.resolve().then(function () { return IconPaperBag$1; }),
  "paperclip": () => Promise.resolve().then(function () { return IconPaperclip$1; }),
  "parachute-off": () => Promise.resolve().then(function () { return IconParachuteOff$1; }),
  "parachute": () => Promise.resolve().then(function () { return IconParachute$1; }),
  "parentheses-off": () => Promise.resolve().then(function () { return IconParenthesesOff$1; }),
  "parentheses": () => Promise.resolve().then(function () { return IconParentheses$1; }),
  "parking-circle": () => Promise.resolve().then(function () { return IconParkingCircle$1; }),
  "parking-off": () => Promise.resolve().then(function () { return IconParkingOff$1; }),
  "parking": () => Promise.resolve().then(function () { return IconParking$1; }),
  "password-fingerprint": () => Promise.resolve().then(function () { return IconPasswordFingerprint$1; }),
  "password-mobile-phone": () => Promise.resolve().then(function () { return IconPasswordMobilePhone$1; }),
  "password-user": () => Promise.resolve().then(function () { return IconPasswordUser$1; }),
  "password": () => Promise.resolve().then(function () { return IconPassword$1; }),
  "paw-off": () => Promise.resolve().then(function () { return IconPawOff$1; }),
  "paw": () => Promise.resolve().then(function () { return IconPaw$1; }),
  "paywall": () => Promise.resolve().then(function () { return IconPaywall$1; }),
  "pdf": () => Promise.resolve().then(function () { return IconPdf$1; }),
  "peace": () => Promise.resolve().then(function () { return IconPeace$1; }),
  "pencil-bolt": () => Promise.resolve().then(function () { return IconPencilBolt$1; }),
  "pencil-cancel": () => Promise.resolve().then(function () { return IconPencilCancel$1; }),
  "pencil-check": () => Promise.resolve().then(function () { return IconPencilCheck$1; }),
  "pencil-code": () => Promise.resolve().then(function () { return IconPencilCode$1; }),
  "pencil-cog": () => Promise.resolve().then(function () { return IconPencilCog$1; }),
  "pencil-discount": () => Promise.resolve().then(function () { return IconPencilDiscount$1; }),
  "pencil-dollar": () => Promise.resolve().then(function () { return IconPencilDollar$1; }),
  "pencil-down": () => Promise.resolve().then(function () { return IconPencilDown$1; }),
  "pencil-exclamation": () => Promise.resolve().then(function () { return IconPencilExclamation$1; }),
  "pencil-heart": () => Promise.resolve().then(function () { return IconPencilHeart$1; }),
  "pencil-minus": () => Promise.resolve().then(function () { return IconPencilMinus$1; }),
  "pencil-off": () => Promise.resolve().then(function () { return IconPencilOff$1; }),
  "pencil-pause": () => Promise.resolve().then(function () { return IconPencilPause$1; }),
  "pencil-pin": () => Promise.resolve().then(function () { return IconPencilPin$1; }),
  "pencil-plus": () => Promise.resolve().then(function () { return IconPencilPlus$1; }),
  "pencil-question": () => Promise.resolve().then(function () { return IconPencilQuestion$1; }),
  "pencil-search": () => Promise.resolve().then(function () { return IconPencilSearch$1; }),
  "pencil-share": () => Promise.resolve().then(function () { return IconPencilShare$1; }),
  "pencil-star": () => Promise.resolve().then(function () { return IconPencilStar$1; }),
  "pencil-up": () => Promise.resolve().then(function () { return IconPencilUp$1; }),
  "pencil-x": () => Promise.resolve().then(function () { return IconPencilX$1; }),
  "pencil": () => Promise.resolve().then(function () { return IconPencil$1; }),
  "pennant-2": () => Promise.resolve().then(function () { return IconPennant2$1; }),
  "pennant-off": () => Promise.resolve().then(function () { return IconPennantOff$1; }),
  "pennant": () => Promise.resolve().then(function () { return IconPennant$1; }),
  "pentagon-minus": () => Promise.resolve().then(function () { return IconPentagonMinus$1; }),
  "pentagon-number-0": () => Promise.resolve().then(function () { return IconPentagonNumber0$1; }),
  "pentagon-number-1": () => Promise.resolve().then(function () { return IconPentagonNumber1$1; }),
  "pentagon-number-2": () => Promise.resolve().then(function () { return IconPentagonNumber2$1; }),
  "pentagon-number-3": () => Promise.resolve().then(function () { return IconPentagonNumber3$1; }),
  "pentagon-number-4": () => Promise.resolve().then(function () { return IconPentagonNumber4$1; }),
  "pentagon-number-5": () => Promise.resolve().then(function () { return IconPentagonNumber5$1; }),
  "pentagon-number-6": () => Promise.resolve().then(function () { return IconPentagonNumber6$1; }),
  "pentagon-number-7": () => Promise.resolve().then(function () { return IconPentagonNumber7$1; }),
  "pentagon-number-8": () => Promise.resolve().then(function () { return IconPentagonNumber8$1; }),
  "pentagon-number-9": () => Promise.resolve().then(function () { return IconPentagonNumber9$1; }),
  "pentagon-off": () => Promise.resolve().then(function () { return IconPentagonOff$1; }),
  "pentagon-plus": () => Promise.resolve().then(function () { return IconPentagonPlus$1; }),
  "pentagon-x": () => Promise.resolve().then(function () { return IconPentagonX$1; }),
  "pentagon": () => Promise.resolve().then(function () { return IconPentagon$1; }),
  "pentagram": () => Promise.resolve().then(function () { return IconPentagram$1; }),
  "pepper-off": () => Promise.resolve().then(function () { return IconPepperOff$1; }),
  "pepper": () => Promise.resolve().then(function () { return IconPepper$1; }),
  "percentage-0": () => Promise.resolve().then(function () { return IconPercentage0$1; }),
  "percentage-10": () => Promise.resolve().then(function () { return IconPercentage10$1; }),
  "percentage-100": () => Promise.resolve().then(function () { return IconPercentage100$1; }),
  "percentage-20": () => Promise.resolve().then(function () { return IconPercentage20$1; }),
  "percentage-25": () => Promise.resolve().then(function () { return IconPercentage25$1; }),
  "percentage-30": () => Promise.resolve().then(function () { return IconPercentage30$1; }),
  "percentage-33": () => Promise.resolve().then(function () { return IconPercentage33$1; }),
  "percentage-40": () => Promise.resolve().then(function () { return IconPercentage40$1; }),
  "percentage-50": () => Promise.resolve().then(function () { return IconPercentage50$1; }),
  "percentage-60": () => Promise.resolve().then(function () { return IconPercentage60$1; }),
  "percentage-66": () => Promise.resolve().then(function () { return IconPercentage66$1; }),
  "percentage-70": () => Promise.resolve().then(function () { return IconPercentage70$1; }),
  "percentage-75": () => Promise.resolve().then(function () { return IconPercentage75$1; }),
  "percentage-80": () => Promise.resolve().then(function () { return IconPercentage80$1; }),
  "percentage-90": () => Promise.resolve().then(function () { return IconPercentage90$1; }),
  "percentage": () => Promise.resolve().then(function () { return IconPercentage$1; }),
  "perfume": () => Promise.resolve().then(function () { return IconPerfume$1; }),
  "perspective-off": () => Promise.resolve().then(function () { return IconPerspectiveOff$1; }),
  "perspective": () => Promise.resolve().then(function () { return IconPerspective$1; }),
  "phone-call": () => Promise.resolve().then(function () { return IconPhoneCall$1; }),
  "phone-calling": () => Promise.resolve().then(function () { return IconPhoneCalling$1; }),
  "phone-check": () => Promise.resolve().then(function () { return IconPhoneCheck$1; }),
  "phone-done": () => Promise.resolve().then(function () { return IconPhoneDone$1; }),
  "phone-end": () => Promise.resolve().then(function () { return IconPhoneEnd$1; }),
  "phone-incoming": () => Promise.resolve().then(function () { return IconPhoneIncoming$1; }),
  "phone-off": () => Promise.resolve().then(function () { return IconPhoneOff$1; }),
  "phone-outgoing": () => Promise.resolve().then(function () { return IconPhoneOutgoing$1; }),
  "phone-pause": () => Promise.resolve().then(function () { return IconPhonePause$1; }),
  "phone-plus": () => Promise.resolve().then(function () { return IconPhonePlus$1; }),
  "phone-ringing": () => Promise.resolve().then(function () { return IconPhoneRinging$1; }),
  "phone-spark": () => Promise.resolve().then(function () { return IconPhoneSpark$1; }),
  "phone-x": () => Promise.resolve().then(function () { return IconPhoneX$1; }),
  "phone": () => Promise.resolve().then(function () { return IconPhone$1; }),
  "photo-ai": () => Promise.resolve().then(function () { return IconPhotoAi$1; }),
  "photo-bitcoin": () => Promise.resolve().then(function () { return IconPhotoBitcoin$1; }),
  "photo-bolt": () => Promise.resolve().then(function () { return IconPhotoBolt$1; }),
  "photo-cancel": () => Promise.resolve().then(function () { return IconPhotoCancel$1; }),
  "photo-check": () => Promise.resolve().then(function () { return IconPhotoCheck$1; }),
  "photo-circle-minus": () => Promise.resolve().then(function () { return IconPhotoCircleMinus$1; }),
  "photo-circle-plus": () => Promise.resolve().then(function () { return IconPhotoCirclePlus$1; }),
  "photo-circle": () => Promise.resolve().then(function () { return IconPhotoCircle$1; }),
  "photo-code": () => Promise.resolve().then(function () { return IconPhotoCode$1; }),
  "photo-cog": () => Promise.resolve().then(function () { return IconPhotoCog$1; }),
  "photo-dollar": () => Promise.resolve().then(function () { return IconPhotoDollar$1; }),
  "photo-down": () => Promise.resolve().then(function () { return IconPhotoDown$1; }),
  "photo-edit": () => Promise.resolve().then(function () { return IconPhotoEdit$1; }),
  "photo-exclamation": () => Promise.resolve().then(function () { return IconPhotoExclamation$1; }),
  "photo-heart": () => Promise.resolve().then(function () { return IconPhotoHeart$1; }),
  "photo-hexagon": () => Promise.resolve().then(function () { return IconPhotoHexagon$1; }),
  "photo-minus": () => Promise.resolve().then(function () { return IconPhotoMinus$1; }),
  "photo-off": () => Promise.resolve().then(function () { return IconPhotoOff$1; }),
  "photo-pause": () => Promise.resolve().then(function () { return IconPhotoPause$1; }),
  "photo-pentagon": () => Promise.resolve().then(function () { return IconPhotoPentagon$1; }),
  "photo-pin": () => Promise.resolve().then(function () { return IconPhotoPin$1; }),
  "photo-plus": () => Promise.resolve().then(function () { return IconPhotoPlus$1; }),
  "photo-question": () => Promise.resolve().then(function () { return IconPhotoQuestion$1; }),
  "photo-scan": () => Promise.resolve().then(function () { return IconPhotoScan$1; }),
  "photo-search": () => Promise.resolve().then(function () { return IconPhotoSearch$1; }),
  "photo-sensor-2": () => Promise.resolve().then(function () { return IconPhotoSensor2$1; }),
  "photo-sensor-3": () => Promise.resolve().then(function () { return IconPhotoSensor3$1; }),
  "photo-sensor": () => Promise.resolve().then(function () { return IconPhotoSensor$1; }),
  "photo-share": () => Promise.resolve().then(function () { return IconPhotoShare$1; }),
  "photo-shield": () => Promise.resolve().then(function () { return IconPhotoShield$1; }),
  "photo-spark": () => Promise.resolve().then(function () { return IconPhotoSpark$1; }),
  "photo-square-rounded": () => Promise.resolve().then(function () { return IconPhotoSquareRounded$1; }),
  "photo-star": () => Promise.resolve().then(function () { return IconPhotoStar$1; }),
  "photo-up": () => Promise.resolve().then(function () { return IconPhotoUp$1; }),
  "photo-video": () => Promise.resolve().then(function () { return IconPhotoVideo$1; }),
  "photo-x": () => Promise.resolve().then(function () { return IconPhotoX$1; }),
  "photo": () => Promise.resolve().then(function () { return IconPhoto$1; }),
  "physotherapist": () => Promise.resolve().then(function () { return IconPhysotherapist$1; }),
  "piano": () => Promise.resolve().then(function () { return IconPiano$1; }),
  "pick": () => Promise.resolve().then(function () { return IconPick$1; }),
  "picnic-table": () => Promise.resolve().then(function () { return IconPicnicTable$1; }),
  "picture-in-picture-off": () => Promise.resolve().then(function () { return IconPictureInPictureOff$1; }),
  "picture-in-picture-on": () => Promise.resolve().then(function () { return IconPictureInPictureOn$1; }),
  "picture-in-picture-top": () => Promise.resolve().then(function () { return IconPictureInPictureTop$1; }),
  "picture-in-picture": () => Promise.resolve().then(function () { return IconPictureInPicture$1; }),
  "pig-money": () => Promise.resolve().then(function () { return IconPigMoney$1; }),
  "pig-off": () => Promise.resolve().then(function () { return IconPigOff$1; }),
  "pig": () => Promise.resolve().then(function () { return IconPig$1; }),
  "pilcrow-left": () => Promise.resolve().then(function () { return IconPilcrowLeft$1; }),
  "pilcrow-right": () => Promise.resolve().then(function () { return IconPilcrowRight$1; }),
  "pilcrow": () => Promise.resolve().then(function () { return IconPilcrow$1; }),
  "pill-off": () => Promise.resolve().then(function () { return IconPillOff$1; }),
  "pill": () => Promise.resolve().then(function () { return IconPill$1; }),
  "pills": () => Promise.resolve().then(function () { return IconPills$1; }),
  "pin-end": () => Promise.resolve().then(function () { return IconPinEnd$1; }),
  "pin-invoke": () => Promise.resolve().then(function () { return IconPinInvoke$1; }),
  "pin": () => Promise.resolve().then(function () { return IconPin$1; }),
  "ping-pong": () => Promise.resolve().then(function () { return IconPingPong$1; }),
  "pinned-off": () => Promise.resolve().then(function () { return IconPinnedOff$1; }),
  "pinned": () => Promise.resolve().then(function () { return IconPinned$1; }),
  "pizza-off": () => Promise.resolve().then(function () { return IconPizzaOff$1; }),
  "pizza": () => Promise.resolve().then(function () { return IconPizza$1; }),
  "placeholder": () => Promise.resolve().then(function () { return IconPlaceholder$1; }),
  "plane-arrival": () => Promise.resolve().then(function () { return IconPlaneArrival$1; }),
  "plane-departure": () => Promise.resolve().then(function () { return IconPlaneDeparture$1; }),
  "plane-inflight": () => Promise.resolve().then(function () { return IconPlaneInflight$1; }),
  "plane-off": () => Promise.resolve().then(function () { return IconPlaneOff$1; }),
  "plane-tilt": () => Promise.resolve().then(function () { return IconPlaneTilt$1; }),
  "plane": () => Promise.resolve().then(function () { return IconPlane$1; }),
  "planet-off": () => Promise.resolve().then(function () { return IconPlanetOff$1; }),
  "planet": () => Promise.resolve().then(function () { return IconPlanet$1; }),
  "plant-2-off": () => Promise.resolve().then(function () { return IconPlant2Off$1; }),
  "plant-2": () => Promise.resolve().then(function () { return IconPlant2$1; }),
  "plant-off": () => Promise.resolve().then(function () { return IconPlantOff$1; }),
  "plant": () => Promise.resolve().then(function () { return IconPlant$1; }),
  "play-basketball": () => Promise.resolve().then(function () { return IconPlayBasketball$1; }),
  "play-card-1": () => Promise.resolve().then(function () { return IconPlayCard1$1; }),
  "play-card-10": () => Promise.resolve().then(function () { return IconPlayCard10$1; }),
  "play-card-2": () => Promise.resolve().then(function () { return IconPlayCard2$1; }),
  "play-card-3": () => Promise.resolve().then(function () { return IconPlayCard3$1; }),
  "play-card-4": () => Promise.resolve().then(function () { return IconPlayCard4$1; }),
  "play-card-5": () => Promise.resolve().then(function () { return IconPlayCard5$1; }),
  "play-card-6": () => Promise.resolve().then(function () { return IconPlayCard6$1; }),
  "play-card-7": () => Promise.resolve().then(function () { return IconPlayCard7$1; }),
  "play-card-8": () => Promise.resolve().then(function () { return IconPlayCard8$1; }),
  "play-card-9": () => Promise.resolve().then(function () { return IconPlayCard9$1; }),
  "play-card-a": () => Promise.resolve().then(function () { return IconPlayCardA$1; }),
  "play-card-j": () => Promise.resolve().then(function () { return IconPlayCardJ$1; }),
  "play-card-k": () => Promise.resolve().then(function () { return IconPlayCardK$1; }),
  "play-card-off": () => Promise.resolve().then(function () { return IconPlayCardOff$1; }),
  "play-card-q": () => Promise.resolve().then(function () { return IconPlayCardQ$1; }),
  "play-card-star": () => Promise.resolve().then(function () { return IconPlayCardStar$1; }),
  "play-card": () => Promise.resolve().then(function () { return IconPlayCard$1; }),
  "play-football": () => Promise.resolve().then(function () { return IconPlayFootball$1; }),
  "play-handball": () => Promise.resolve().then(function () { return IconPlayHandball$1; }),
  "play-volleyball": () => Promise.resolve().then(function () { return IconPlayVolleyball$1; }),
  "player-eject": () => Promise.resolve().then(function () { return IconPlayerEject$1; }),
  "player-pause": () => Promise.resolve().then(function () { return IconPlayerPause$1; }),
  "player-play": () => Promise.resolve().then(function () { return IconPlayerPlay$1; }),
  "player-record": () => Promise.resolve().then(function () { return IconPlayerRecord$1; }),
  "player-skip-back": () => Promise.resolve().then(function () { return IconPlayerSkipBack$1; }),
  "player-skip-forward": () => Promise.resolve().then(function () { return IconPlayerSkipForward$1; }),
  "player-stop": () => Promise.resolve().then(function () { return IconPlayerStop$1; }),
  "player-track-next": () => Promise.resolve().then(function () { return IconPlayerTrackNext$1; }),
  "player-track-prev": () => Promise.resolve().then(function () { return IconPlayerTrackPrev$1; }),
  "playlist-add": () => Promise.resolve().then(function () { return IconPlaylistAdd$1; }),
  "playlist-off": () => Promise.resolve().then(function () { return IconPlaylistOff$1; }),
  "playlist-x": () => Promise.resolve().then(function () { return IconPlaylistX$1; }),
  "playlist": () => Promise.resolve().then(function () { return IconPlaylist$1; }),
  "playstation-circle": () => Promise.resolve().then(function () { return IconPlaystationCircle$1; }),
  "playstation-square": () => Promise.resolve().then(function () { return IconPlaystationSquare$1; }),
  "playstation-triangle": () => Promise.resolve().then(function () { return IconPlaystationTriangle$1; }),
  "playstation-x": () => Promise.resolve().then(function () { return IconPlaystationX$1; }),
  "plug-connected-x": () => Promise.resolve().then(function () { return IconPlugConnectedX$1; }),
  "plug-connected": () => Promise.resolve().then(function () { return IconPlugConnected$1; }),
  "plug-off": () => Promise.resolve().then(function () { return IconPlugOff$1; }),
  "plug-x": () => Promise.resolve().then(function () { return IconPlugX$1; }),
  "plug": () => Promise.resolve().then(function () { return IconPlug$1; }),
  "plus-equal": () => Promise.resolve().then(function () { return IconPlusEqual$1; }),
  "plus-minus": () => Promise.resolve().then(function () { return IconPlusMinus$1; }),
  "plus": () => Promise.resolve().then(function () { return IconPlus$1; }),
  "png": () => Promise.resolve().then(function () { return IconPng$1; }),
  "podium-off": () => Promise.resolve().then(function () { return IconPodiumOff$1; }),
  "podium": () => Promise.resolve().then(function () { return IconPodium$1; }),
  "point-off": () => Promise.resolve().then(function () { return IconPointOff$1; }),
  "point": () => Promise.resolve().then(function () { return IconPoint$1; }),
  "pointer-bolt": () => Promise.resolve().then(function () { return IconPointerBolt$1; }),
  "pointer-cancel": () => Promise.resolve().then(function () { return IconPointerCancel$1; }),
  "pointer-check": () => Promise.resolve().then(function () { return IconPointerCheck$1; }),
  "pointer-code": () => Promise.resolve().then(function () { return IconPointerCode$1; }),
  "pointer-cog": () => Promise.resolve().then(function () { return IconPointerCog$1; }),
  "pointer-dollar": () => Promise.resolve().then(function () { return IconPointerDollar$1; }),
  "pointer-down": () => Promise.resolve().then(function () { return IconPointerDown$1; }),
  "pointer-exclamation": () => Promise.resolve().then(function () { return IconPointerExclamation$1; }),
  "pointer-heart": () => Promise.resolve().then(function () { return IconPointerHeart$1; }),
  "pointer-minus": () => Promise.resolve().then(function () { return IconPointerMinus$1; }),
  "pointer-off": () => Promise.resolve().then(function () { return IconPointerOff$1; }),
  "pointer-pause": () => Promise.resolve().then(function () { return IconPointerPause$1; }),
  "pointer-pin": () => Promise.resolve().then(function () { return IconPointerPin$1; }),
  "pointer-plus": () => Promise.resolve().then(function () { return IconPointerPlus$1; }),
  "pointer-question": () => Promise.resolve().then(function () { return IconPointerQuestion$1; }),
  "pointer-search": () => Promise.resolve().then(function () { return IconPointerSearch$1; }),
  "pointer-share": () => Promise.resolve().then(function () { return IconPointerShare$1; }),
  "pointer-star": () => Promise.resolve().then(function () { return IconPointerStar$1; }),
  "pointer-up": () => Promise.resolve().then(function () { return IconPointerUp$1; }),
  "pointer-x": () => Promise.resolve().then(function () { return IconPointerX$1; }),
  "pointer": () => Promise.resolve().then(function () { return IconPointer$1; }),
  "pokeball-off": () => Promise.resolve().then(function () { return IconPokeballOff$1; }),
  "pokeball": () => Promise.resolve().then(function () { return IconPokeball$1; }),
  "poker-chip": () => Promise.resolve().then(function () { return IconPokerChip$1; }),
  "polaroid": () => Promise.resolve().then(function () { return IconPolaroid$1; }),
  "polygon-off": () => Promise.resolve().then(function () { return IconPolygonOff$1; }),
  "polygon": () => Promise.resolve().then(function () { return IconPolygon$1; }),
  "poo": () => Promise.resolve().then(function () { return IconPoo$1; }),
  "pool-off": () => Promise.resolve().then(function () { return IconPoolOff$1; }),
  "pool": () => Promise.resolve().then(function () { return IconPool$1; }),
  "power": () => Promise.resolve().then(function () { return IconPower$1; }),
  "pray": () => Promise.resolve().then(function () { return IconPray$1; }),
  "premium-rights": () => Promise.resolve().then(function () { return IconPremiumRights$1; }),
  "prescription": () => Promise.resolve().then(function () { return IconPrescription$1; }),
  "presentation-analytics": () => Promise.resolve().then(function () { return IconPresentationAnalytics$1; }),
  "presentation-off": () => Promise.resolve().then(function () { return IconPresentationOff$1; }),
  "presentation": () => Promise.resolve().then(function () { return IconPresentation$1; }),
  "printer-off": () => Promise.resolve().then(function () { return IconPrinterOff$1; }),
  "printer": () => Promise.resolve().then(function () { return IconPrinter$1; }),
  "prism-light": () => Promise.resolve().then(function () { return IconPrismLight$1; }),
  "prism-off": () => Promise.resolve().then(function () { return IconPrismOff$1; }),
  "prism-plus": () => Promise.resolve().then(function () { return IconPrismPlus$1; }),
  "prism": () => Promise.resolve().then(function () { return IconPrism$1; }),
  "prison": () => Promise.resolve().then(function () { return IconPrison$1; }),
  "progress-alert": () => Promise.resolve().then(function () { return IconProgressAlert$1; }),
  "progress-bolt": () => Promise.resolve().then(function () { return IconProgressBolt$1; }),
  "progress-check": () => Promise.resolve().then(function () { return IconProgressCheck$1; }),
  "progress-down": () => Promise.resolve().then(function () { return IconProgressDown$1; }),
  "progress-help": () => Promise.resolve().then(function () { return IconProgressHelp$1; }),
  "progress-x": () => Promise.resolve().then(function () { return IconProgressX$1; }),
  "progress": () => Promise.resolve().then(function () { return IconProgress$1; }),
  "prompt": () => Promise.resolve().then(function () { return IconPrompt$1; }),
  "prong": () => Promise.resolve().then(function () { return IconProng$1; }),
  "propeller-off": () => Promise.resolve().then(function () { return IconPropellerOff$1; }),
  "propeller": () => Promise.resolve().then(function () { return IconPropeller$1; }),
  "protocol": () => Promise.resolve().then(function () { return IconProtocol$1; }),
  "pumpkin-scary": () => Promise.resolve().then(function () { return IconPumpkinScary$1; }),
  "puzzle-2": () => Promise.resolve().then(function () { return IconPuzzle2$1; }),
  "puzzle-off": () => Promise.resolve().then(function () { return IconPuzzleOff$1; }),
  "puzzle": () => Promise.resolve().then(function () { return IconPuzzle$1; }),
  "pyramid-off": () => Promise.resolve().then(function () { return IconPyramidOff$1; }),
  "pyramid-plus": () => Promise.resolve().then(function () { return IconPyramidPlus$1; }),
  "pyramid": () => Promise.resolve().then(function () { return IconPyramid$1; }),
  "qrcode-off": () => Promise.resolve().then(function () { return IconQrcodeOff$1; }),
  "qrcode": () => Promise.resolve().then(function () { return IconQrcode$1; }),
  "question-mark": () => Promise.resolve().then(function () { return IconQuestionMark$1; }),
  "quote-off": () => Promise.resolve().then(function () { return IconQuoteOff$1; }),
  "quote": () => Promise.resolve().then(function () { return IconQuote$1; }),
  "quotes": () => Promise.resolve().then(function () { return IconQuotes$1; }),
  "radar-2": () => Promise.resolve().then(function () { return IconRadar2$1; }),
  "radar-off": () => Promise.resolve().then(function () { return IconRadarOff$1; }),
  "radar": () => Promise.resolve().then(function () { return IconRadar$1; }),
  "radio-off": () => Promise.resolve().then(function () { return IconRadioOff$1; }),
  "radio": () => Promise.resolve().then(function () { return IconRadio$1; }),
  "radioactive-off": () => Promise.resolve().then(function () { return IconRadioactiveOff$1; }),
  "radioactive": () => Promise.resolve().then(function () { return IconRadioactive$1; }),
  "radius-bottom-left": () => Promise.resolve().then(function () { return IconRadiusBottomLeft$1; }),
  "radius-bottom-right": () => Promise.resolve().then(function () { return IconRadiusBottomRight$1; }),
  "radius-top-left": () => Promise.resolve().then(function () { return IconRadiusTopLeft$1; }),
  "radius-top-right": () => Promise.resolve().then(function () { return IconRadiusTopRight$1; }),
  "rainbow-off": () => Promise.resolve().then(function () { return IconRainbowOff$1; }),
  "rainbow": () => Promise.resolve().then(function () { return IconRainbow$1; }),
  "rating-12-plus": () => Promise.resolve().then(function () { return IconRating12Plus$1; }),
  "rating-14-plus": () => Promise.resolve().then(function () { return IconRating14Plus$1; }),
  "rating-16-plus": () => Promise.resolve().then(function () { return IconRating16Plus$1; }),
  "rating-18-plus": () => Promise.resolve().then(function () { return IconRating18Plus$1; }),
  "rating-21-plus": () => Promise.resolve().then(function () { return IconRating21Plus$1; }),
  "razor-electric": () => Promise.resolve().then(function () { return IconRazorElectric$1; }),
  "razor": () => Promise.resolve().then(function () { return IconRazor$1; }),
  "receipt-2": () => Promise.resolve().then(function () { return IconReceipt2$1; }),
  "receipt-bitcoin": () => Promise.resolve().then(function () { return IconReceiptBitcoin$1; }),
  "receipt-dollar": () => Promise.resolve().then(function () { return IconReceiptDollar$1; }),
  "receipt-euro": () => Promise.resolve().then(function () { return IconReceiptEuro$1; }),
  "receipt-off": () => Promise.resolve().then(function () { return IconReceiptOff$1; }),
  "receipt-pound": () => Promise.resolve().then(function () { return IconReceiptPound$1; }),
  "receipt-refund": () => Promise.resolve().then(function () { return IconReceiptRefund$1; }),
  "receipt-rupee": () => Promise.resolve().then(function () { return IconReceiptRupee$1; }),
  "receipt-tax": () => Promise.resolve().then(function () { return IconReceiptTax$1; }),
  "receipt-yen": () => Promise.resolve().then(function () { return IconReceiptYen$1; }),
  "receipt-yuan": () => Promise.resolve().then(function () { return IconReceiptYuan$1; }),
  "receipt": () => Promise.resolve().then(function () { return IconReceipt$1; }),
  "recharging": () => Promise.resolve().then(function () { return IconRecharging$1; }),
  "record-mail-off": () => Promise.resolve().then(function () { return IconRecordMailOff$1; }),
  "record-mail": () => Promise.resolve().then(function () { return IconRecordMail$1; }),
  "rectangle-rounded-bottom": () => Promise.resolve().then(function () { return IconRectangleRoundedBottom$1; }),
  "rectangle-rounded-top": () => Promise.resolve().then(function () { return IconRectangleRoundedTop$1; }),
  "rectangle-vertical": () => Promise.resolve().then(function () { return IconRectangleVertical$1; }),
  "rectangle": () => Promise.resolve().then(function () { return IconRectangle$1; }),
  "rectangular-prism-off": () => Promise.resolve().then(function () { return IconRectangularPrismOff$1; }),
  "rectangular-prism-plus": () => Promise.resolve().then(function () { return IconRectangularPrismPlus$1; }),
  "rectangular-prism": () => Promise.resolve().then(function () { return IconRectangularPrism$1; }),
  "recycle-off": () => Promise.resolve().then(function () { return IconRecycleOff$1; }),
  "recycle": () => Promise.resolve().then(function () { return IconRecycle$1; }),
  "refresh-alert": () => Promise.resolve().then(function () { return IconRefreshAlert$1; }),
  "refresh-dot": () => Promise.resolve().then(function () { return IconRefreshDot$1; }),
  "refresh-off": () => Promise.resolve().then(function () { return IconRefreshOff$1; }),
  "refresh": () => Promise.resolve().then(function () { return IconRefresh$1; }),
  "regex-off": () => Promise.resolve().then(function () { return IconRegexOff$1; }),
  "regex": () => Promise.resolve().then(function () { return IconRegex$1; }),
  "registered": () => Promise.resolve().then(function () { return IconRegistered$1; }),
  "relation-many-to-many": () => Promise.resolve().then(function () { return IconRelationManyToMany$1; }),
  "relation-one-to-many": () => Promise.resolve().then(function () { return IconRelationOneToMany$1; }),
  "relation-one-to-one": () => Promise.resolve().then(function () { return IconRelationOneToOne$1; }),
  "reload": () => Promise.resolve().then(function () { return IconReload$1; }),
  "reorder": () => Promise.resolve().then(function () { return IconReorder$1; }),
  "repeat-off": () => Promise.resolve().then(function () { return IconRepeatOff$1; }),
  "repeat-once": () => Promise.resolve().then(function () { return IconRepeatOnce$1; }),
  "repeat": () => Promise.resolve().then(function () { return IconRepeat$1; }),
  "replace-off": () => Promise.resolve().then(function () { return IconReplaceOff$1; }),
  "replace-user": () => Promise.resolve().then(function () { return IconReplaceUser$1; }),
  "replace": () => Promise.resolve().then(function () { return IconReplace$1; }),
  "report-analytics": () => Promise.resolve().then(function () { return IconReportAnalytics$1; }),
  "report-medical": () => Promise.resolve().then(function () { return IconReportMedical$1; }),
  "report-money": () => Promise.resolve().then(function () { return IconReportMoney$1; }),
  "report-off": () => Promise.resolve().then(function () { return IconReportOff$1; }),
  "report-search": () => Promise.resolve().then(function () { return IconReportSearch$1; }),
  "report": () => Promise.resolve().then(function () { return IconReport$1; }),
  "reserved-line": () => Promise.resolve().then(function () { return IconReservedLine$1; }),
  "resize": () => Promise.resolve().then(function () { return IconResize$1; }),
  "restore": () => Promise.resolve().then(function () { return IconRestore$1; }),
  "rewind-backward-10": () => Promise.resolve().then(function () { return IconRewindBackward10$1; }),
  "rewind-backward-15": () => Promise.resolve().then(function () { return IconRewindBackward15$1; }),
  "rewind-backward-20": () => Promise.resolve().then(function () { return IconRewindBackward20$1; }),
  "rewind-backward-30": () => Promise.resolve().then(function () { return IconRewindBackward30$1; }),
  "rewind-backward-40": () => Promise.resolve().then(function () { return IconRewindBackward40$1; }),
  "rewind-backward-5": () => Promise.resolve().then(function () { return IconRewindBackward5$1; }),
  "rewind-backward-50": () => Promise.resolve().then(function () { return IconRewindBackward50$1; }),
  "rewind-backward-60": () => Promise.resolve().then(function () { return IconRewindBackward60$1; }),
  "rewind-forward-10": () => Promise.resolve().then(function () { return IconRewindForward10$1; }),
  "rewind-forward-15": () => Promise.resolve().then(function () { return IconRewindForward15$1; }),
  "rewind-forward-20": () => Promise.resolve().then(function () { return IconRewindForward20$1; }),
  "rewind-forward-30": () => Promise.resolve().then(function () { return IconRewindForward30$1; }),
  "rewind-forward-40": () => Promise.resolve().then(function () { return IconRewindForward40$1; }),
  "rewind-forward-5": () => Promise.resolve().then(function () { return IconRewindForward5$1; }),
  "rewind-forward-50": () => Promise.resolve().then(function () { return IconRewindForward50$1; }),
  "rewind-forward-60": () => Promise.resolve().then(function () { return IconRewindForward60$1; }),
  "ribbon-health": () => Promise.resolve().then(function () { return IconRibbonHealth$1; }),
  "rings": () => Promise.resolve().then(function () { return IconRings$1; }),
  "ripple-off": () => Promise.resolve().then(function () { return IconRippleOff$1; }),
  "ripple": () => Promise.resolve().then(function () { return IconRipple$1; }),
  "road-off": () => Promise.resolve().then(function () { return IconRoadOff$1; }),
  "road-sign": () => Promise.resolve().then(function () { return IconRoadSign$1; }),
  "road": () => Promise.resolve().then(function () { return IconRoad$1; }),
  "robot-face": () => Promise.resolve().then(function () { return IconRobotFace$1; }),
  "robot-off": () => Promise.resolve().then(function () { return IconRobotOff$1; }),
  "robot": () => Promise.resolve().then(function () { return IconRobot$1; }),
  "rocket-off": () => Promise.resolve().then(function () { return IconRocketOff$1; }),
  "rocket": () => Promise.resolve().then(function () { return IconRocket$1; }),
  "roller-skating": () => Promise.resolve().then(function () { return IconRollerSkating$1; }),
  "rollercoaster-off": () => Promise.resolve().then(function () { return IconRollercoasterOff$1; }),
  "rollercoaster": () => Promise.resolve().then(function () { return IconRollercoaster$1; }),
  "rosette-discount-check-off": () => Promise.resolve().then(function () { return IconRosetteDiscountCheckOff$1; }),
  "rosette-discount-check": () => Promise.resolve().then(function () { return IconRosetteDiscountCheck$1; }),
  "rosette-discount-off": () => Promise.resolve().then(function () { return IconRosetteDiscountOff$1; }),
  "rosette-discount": () => Promise.resolve().then(function () { return IconRosetteDiscount$1; }),
  "rosette-number-0": () => Promise.resolve().then(function () { return IconRosetteNumber0$1; }),
  "rosette-number-1": () => Promise.resolve().then(function () { return IconRosetteNumber1$1; }),
  "rosette-number-2": () => Promise.resolve().then(function () { return IconRosetteNumber2$1; }),
  "rosette-number-3": () => Promise.resolve().then(function () { return IconRosetteNumber3$1; }),
  "rosette-number-4": () => Promise.resolve().then(function () { return IconRosetteNumber4$1; }),
  "rosette-number-5": () => Promise.resolve().then(function () { return IconRosetteNumber5$1; }),
  "rosette-number-6": () => Promise.resolve().then(function () { return IconRosetteNumber6$1; }),
  "rosette-number-7": () => Promise.resolve().then(function () { return IconRosetteNumber7$1; }),
  "rosette-number-8": () => Promise.resolve().then(function () { return IconRosetteNumber8$1; }),
  "rosette-number-9": () => Promise.resolve().then(function () { return IconRosetteNumber9$1; }),
  "rosette": () => Promise.resolve().then(function () { return IconRosette$1; }),
  "rotate-2": () => Promise.resolve().then(function () { return IconRotate2$1; }),
  "rotate-360": () => Promise.resolve().then(function () { return IconRotate360$1; }),
  "rotate-3d": () => Promise.resolve().then(function () { return IconRotate3d$1; }),
  "rotate-clockwise-2": () => Promise.resolve().then(function () { return IconRotateClockwise2$1; }),
  "rotate-clockwise": () => Promise.resolve().then(function () { return IconRotateClockwise$1; }),
  "rotate-dot": () => Promise.resolve().then(function () { return IconRotateDot$1; }),
  "rotate-rectangle": () => Promise.resolve().then(function () { return IconRotateRectangle$1; }),
  "rotate": () => Promise.resolve().then(function () { return IconRotate$1; }),
  "route-2": () => Promise.resolve().then(function () { return IconRoute2$1; }),
  "route-alt-left": () => Promise.resolve().then(function () { return IconRouteAltLeft$1; }),
  "route-alt-right": () => Promise.resolve().then(function () { return IconRouteAltRight$1; }),
  "route-off": () => Promise.resolve().then(function () { return IconRouteOff$1; }),
  "route-scan": () => Promise.resolve().then(function () { return IconRouteScan$1; }),
  "route-square-2": () => Promise.resolve().then(function () { return IconRouteSquare2$1; }),
  "route-square": () => Promise.resolve().then(function () { return IconRouteSquare$1; }),
  "route-x-2": () => Promise.resolve().then(function () { return IconRouteX2$1; }),
  "route-x": () => Promise.resolve().then(function () { return IconRouteX$1; }),
  "route": () => Promise.resolve().then(function () { return IconRoute$1; }),
  "router-off": () => Promise.resolve().then(function () { return IconRouterOff$1; }),
  "router": () => Promise.resolve().then(function () { return IconRouter$1; }),
  "row-insert-bottom": () => Promise.resolve().then(function () { return IconRowInsertBottom$1; }),
  "row-insert-top": () => Promise.resolve().then(function () { return IconRowInsertTop$1; }),
  "row-remove": () => Promise.resolve().then(function () { return IconRowRemove$1; }),
  "rss": () => Promise.resolve().then(function () { return IconRss$1; }),
  "rubber-stamp-off": () => Promise.resolve().then(function () { return IconRubberStampOff$1; }),
  "rubber-stamp": () => Promise.resolve().then(function () { return IconRubberStamp$1; }),
  "ruler-2-off": () => Promise.resolve().then(function () { return IconRuler2Off$1; }),
  "ruler-2": () => Promise.resolve().then(function () { return IconRuler2$1; }),
  "ruler-3": () => Promise.resolve().then(function () { return IconRuler3$1; }),
  "ruler-measure-2": () => Promise.resolve().then(function () { return IconRulerMeasure2$1; }),
  "ruler-measure": () => Promise.resolve().then(function () { return IconRulerMeasure$1; }),
  "ruler-off": () => Promise.resolve().then(function () { return IconRulerOff$1; }),
  "ruler": () => Promise.resolve().then(function () { return IconRuler$1; }),
  "run": () => Promise.resolve().then(function () { return IconRun$1; }),
  "rv-truck": () => Promise.resolve().then(function () { return IconRvTruck$1; }),
  "s-turn-down": () => Promise.resolve().then(function () { return IconSTurnDown$1; }),
  "s-turn-left": () => Promise.resolve().then(function () { return IconSTurnLeft$1; }),
  "s-turn-right": () => Promise.resolve().then(function () { return IconSTurnRight$1; }),
  "s-turn-up": () => Promise.resolve().then(function () { return IconSTurnUp$1; }),
  "sailboat-2": () => Promise.resolve().then(function () { return IconSailboat2$1; }),
  "sailboat-off": () => Promise.resolve().then(function () { return IconSailboatOff$1; }),
  "sailboat": () => Promise.resolve().then(function () { return IconSailboat$1; }),
  "salad": () => Promise.resolve().then(function () { return IconSalad$1; }),
  "salt": () => Promise.resolve().then(function () { return IconSalt$1; }),
  "sandbox": () => Promise.resolve().then(function () { return IconSandbox$1; }),
  "satellite-off": () => Promise.resolve().then(function () { return IconSatelliteOff$1; }),
  "satellite": () => Promise.resolve().then(function () { return IconSatellite$1; }),
  "sausage": () => Promise.resolve().then(function () { return IconSausage$1; }),
  "scale-off": () => Promise.resolve().then(function () { return IconScaleOff$1; }),
  "scale-outline-off": () => Promise.resolve().then(function () { return IconScaleOutlineOff$1; }),
  "scale-outline": () => Promise.resolve().then(function () { return IconScaleOutline$1; }),
  "scale": () => Promise.resolve().then(function () { return IconScale$1; }),
  "scan-eye": () => Promise.resolve().then(function () { return IconScanEye$1; }),
  "scan-position": () => Promise.resolve().then(function () { return IconScanPosition$1; }),
  "scan": () => Promise.resolve().then(function () { return IconScan$1; }),
  "schema-off": () => Promise.resolve().then(function () { return IconSchemaOff$1; }),
  "schema": () => Promise.resolve().then(function () { return IconSchema$1; }),
  "school-bell": () => Promise.resolve().then(function () { return IconSchoolBell$1; }),
  "school-off": () => Promise.resolve().then(function () { return IconSchoolOff$1; }),
  "school": () => Promise.resolve().then(function () { return IconSchool$1; }),
  "scissors-off": () => Promise.resolve().then(function () { return IconScissorsOff$1; }),
  "scissors": () => Promise.resolve().then(function () { return IconScissors$1; }),
  "scooter-electric": () => Promise.resolve().then(function () { return IconScooterElectric$1; }),
  "scooter": () => Promise.resolve().then(function () { return IconScooter$1; }),
  "scoreboard": () => Promise.resolve().then(function () { return IconScoreboard$1; }),
  "screen-share-off": () => Promise.resolve().then(function () { return IconScreenShareOff$1; }),
  "screen-share": () => Promise.resolve().then(function () { return IconScreenShare$1; }),
  "screenshot": () => Promise.resolve().then(function () { return IconScreenshot$1; }),
  "scribble-off": () => Promise.resolve().then(function () { return IconScribbleOff$1; }),
  "scribble": () => Promise.resolve().then(function () { return IconScribble$1; }),
  "script-minus": () => Promise.resolve().then(function () { return IconScriptMinus$1; }),
  "script-plus": () => Promise.resolve().then(function () { return IconScriptPlus$1; }),
  "script-x": () => Promise.resolve().then(function () { return IconScriptX$1; }),
  "script": () => Promise.resolve().then(function () { return IconScript$1; }),
  "scuba-diving-tank": () => Promise.resolve().then(function () { return IconScubaDivingTank$1; }),
  "scuba-diving": () => Promise.resolve().then(function () { return IconScubaDiving$1; }),
  "scuba-mask-off": () => Promise.resolve().then(function () { return IconScubaMaskOff$1; }),
  "scuba-mask": () => Promise.resolve().then(function () { return IconScubaMask$1; }),
  "sdk": () => Promise.resolve().then(function () { return IconSdk$1; }),
  "search-off": () => Promise.resolve().then(function () { return IconSearchOff$1; }),
  "search": () => Promise.resolve().then(function () { return IconSearch$1; }),
  "section-sign": () => Promise.resolve().then(function () { return IconSectionSign$1; }),
  "section": () => Promise.resolve().then(function () { return IconSection$1; }),
  "seedling-off": () => Promise.resolve().then(function () { return IconSeedlingOff$1; }),
  "seedling": () => Promise.resolve().then(function () { return IconSeedling$1; }),
  "select-all": () => Promise.resolve().then(function () { return IconSelectAll$1; }),
  "select": () => Promise.resolve().then(function () { return IconSelect$1; }),
  "selector": () => Promise.resolve().then(function () { return IconSelector$1; }),
  "send-2": () => Promise.resolve().then(function () { return IconSend2$1; }),
  "send-off": () => Promise.resolve().then(function () { return IconSendOff$1; }),
  "send": () => Promise.resolve().then(function () { return IconSend$1; }),
  "seo": () => Promise.resolve().then(function () { return IconSeo$1; }),
  "separator-horizontal": () => Promise.resolve().then(function () { return IconSeparatorHorizontal$1; }),
  "separator-vertical": () => Promise.resolve().then(function () { return IconSeparatorVertical$1; }),
  "separator": () => Promise.resolve().then(function () { return IconSeparator$1; }),
  "server-2": () => Promise.resolve().then(function () { return IconServer2$1; }),
  "server-bolt": () => Promise.resolve().then(function () { return IconServerBolt$1; }),
  "server-cog": () => Promise.resolve().then(function () { return IconServerCog$1; }),
  "server-off": () => Promise.resolve().then(function () { return IconServerOff$1; }),
  "server-spark": () => Promise.resolve().then(function () { return IconServerSpark$1; }),
  "server": () => Promise.resolve().then(function () { return IconServer$1; }),
  "servicemark": () => Promise.resolve().then(function () { return IconServicemark$1; }),
  "settings-2": () => Promise.resolve().then(function () { return IconSettings2$1; }),
  "settings-automation": () => Promise.resolve().then(function () { return IconSettingsAutomation$1; }),
  "settings-bolt": () => Promise.resolve().then(function () { return IconSettingsBolt$1; }),
  "settings-cancel": () => Promise.resolve().then(function () { return IconSettingsCancel$1; }),
  "settings-check": () => Promise.resolve().then(function () { return IconSettingsCheck$1; }),
  "settings-code": () => Promise.resolve().then(function () { return IconSettingsCode$1; }),
  "settings-cog": () => Promise.resolve().then(function () { return IconSettingsCog$1; }),
  "settings-dollar": () => Promise.resolve().then(function () { return IconSettingsDollar$1; }),
  "settings-down": () => Promise.resolve().then(function () { return IconSettingsDown$1; }),
  "settings-exclamation": () => Promise.resolve().then(function () { return IconSettingsExclamation$1; }),
  "settings-heart": () => Promise.resolve().then(function () { return IconSettingsHeart$1; }),
  "settings-minus": () => Promise.resolve().then(function () { return IconSettingsMinus$1; }),
  "settings-off": () => Promise.resolve().then(function () { return IconSettingsOff$1; }),
  "settings-pause": () => Promise.resolve().then(function () { return IconSettingsPause$1; }),
  "settings-pin": () => Promise.resolve().then(function () { return IconSettingsPin$1; }),
  "settings-plus": () => Promise.resolve().then(function () { return IconSettingsPlus$1; }),
  "settings-question": () => Promise.resolve().then(function () { return IconSettingsQuestion$1; }),
  "settings-search": () => Promise.resolve().then(function () { return IconSettingsSearch$1; }),
  "settings-share": () => Promise.resolve().then(function () { return IconSettingsShare$1; }),
  "settings-spark": () => Promise.resolve().then(function () { return IconSettingsSpark$1; }),
  "settings-star": () => Promise.resolve().then(function () { return IconSettingsStar$1; }),
  "settings-up": () => Promise.resolve().then(function () { return IconSettingsUp$1; }),
  "settings-x": () => Promise.resolve().then(function () { return IconSettingsX$1; }),
  "settings": () => Promise.resolve().then(function () { return IconSettings$1; }),
  "shadow-off": () => Promise.resolve().then(function () { return IconShadowOff$1; }),
  "shadow": () => Promise.resolve().then(function () { return IconShadow$1; }),
  "shape-2": () => Promise.resolve().then(function () { return IconShape2$1; }),
  "shape-3": () => Promise.resolve().then(function () { return IconShape3$1; }),
  "shape-off": () => Promise.resolve().then(function () { return IconShapeOff$1; }),
  "shape": () => Promise.resolve().then(function () { return IconShape$1; }),
  "share-2": () => Promise.resolve().then(function () { return IconShare2$1; }),
  "share-3": () => Promise.resolve().then(function () { return IconShare3$1; }),
  "share-off": () => Promise.resolve().then(function () { return IconShareOff$1; }),
  "share": () => Promise.resolve().then(function () { return IconShare$1; }),
  "shareplay": () => Promise.resolve().then(function () { return IconShareplay$1; }),
  "shield-bolt": () => Promise.resolve().then(function () { return IconShieldBolt$1; }),
  "shield-cancel": () => Promise.resolve().then(function () { return IconShieldCancel$1; }),
  "shield-check": () => Promise.resolve().then(function () { return IconShieldCheck$1; }),
  "shield-checkered": () => Promise.resolve().then(function () { return IconShieldCheckered$1; }),
  "shield-chevron": () => Promise.resolve().then(function () { return IconShieldChevron$1; }),
  "shield-code": () => Promise.resolve().then(function () { return IconShieldCode$1; }),
  "shield-cog": () => Promise.resolve().then(function () { return IconShieldCog$1; }),
  "shield-dollar": () => Promise.resolve().then(function () { return IconShieldDollar$1; }),
  "shield-down": () => Promise.resolve().then(function () { return IconShieldDown$1; }),
  "shield-exclamation": () => Promise.resolve().then(function () { return IconShieldExclamation$1; }),
  "shield-half": () => Promise.resolve().then(function () { return IconShieldHalf$1; }),
  "shield-heart": () => Promise.resolve().then(function () { return IconShieldHeart$1; }),
  "shield-lock": () => Promise.resolve().then(function () { return IconShieldLock$1; }),
  "shield-minus": () => Promise.resolve().then(function () { return IconShieldMinus$1; }),
  "shield-off": () => Promise.resolve().then(function () { return IconShieldOff$1; }),
  "shield-pause": () => Promise.resolve().then(function () { return IconShieldPause$1; }),
  "shield-pin": () => Promise.resolve().then(function () { return IconShieldPin$1; }),
  "shield-plus": () => Promise.resolve().then(function () { return IconShieldPlus$1; }),
  "shield-question": () => Promise.resolve().then(function () { return IconShieldQuestion$1; }),
  "shield-search": () => Promise.resolve().then(function () { return IconShieldSearch$1; }),
  "shield-share": () => Promise.resolve().then(function () { return IconShieldShare$1; }),
  "shield-star": () => Promise.resolve().then(function () { return IconShieldStar$1; }),
  "shield-up": () => Promise.resolve().then(function () { return IconShieldUp$1; }),
  "shield-x": () => Promise.resolve().then(function () { return IconShieldX$1; }),
  "shield": () => Promise.resolve().then(function () { return IconShield$1; }),
  "ship-off": () => Promise.resolve().then(function () { return IconShipOff$1; }),
  "ship": () => Promise.resolve().then(function () { return IconShip$1; }),
  "shirt-off": () => Promise.resolve().then(function () { return IconShirtOff$1; }),
  "shirt-sport": () => Promise.resolve().then(function () { return IconShirtSport$1; }),
  "shirt": () => Promise.resolve().then(function () { return IconShirt$1; }),
  "shoe-off": () => Promise.resolve().then(function () { return IconShoeOff$1; }),
  "shoe": () => Promise.resolve().then(function () { return IconShoe$1; }),
  "shopping-bag-check": () => Promise.resolve().then(function () { return IconShoppingBagCheck$1; }),
  "shopping-bag-discount": () => Promise.resolve().then(function () { return IconShoppingBagDiscount$1; }),
  "shopping-bag-edit": () => Promise.resolve().then(function () { return IconShoppingBagEdit$1; }),
  "shopping-bag-exclamation": () => Promise.resolve().then(function () { return IconShoppingBagExclamation$1; }),
  "shopping-bag-heart": () => Promise.resolve().then(function () { return IconShoppingBagHeart$1; }),
  "shopping-bag-minus": () => Promise.resolve().then(function () { return IconShoppingBagMinus$1; }),
  "shopping-bag-plus": () => Promise.resolve().then(function () { return IconShoppingBagPlus$1; }),
  "shopping-bag-search": () => Promise.resolve().then(function () { return IconShoppingBagSearch$1; }),
  "shopping-bag-x": () => Promise.resolve().then(function () { return IconShoppingBagX$1; }),
  "shopping-bag": () => Promise.resolve().then(function () { return IconShoppingBag$1; }),
  "shopping-cart-bolt": () => Promise.resolve().then(function () { return IconShoppingCartBolt$1; }),
  "shopping-cart-cancel": () => Promise.resolve().then(function () { return IconShoppingCartCancel$1; }),
  "shopping-cart-check": () => Promise.resolve().then(function () { return IconShoppingCartCheck$1; }),
  "shopping-cart-code": () => Promise.resolve().then(function () { return IconShoppingCartCode$1; }),
  "shopping-cart-cog": () => Promise.resolve().then(function () { return IconShoppingCartCog$1; }),
  "shopping-cart-copy": () => Promise.resolve().then(function () { return IconShoppingCartCopy$1; }),
  "shopping-cart-discount": () => Promise.resolve().then(function () { return IconShoppingCartDiscount$1; }),
  "shopping-cart-dollar": () => Promise.resolve().then(function () { return IconShoppingCartDollar$1; }),
  "shopping-cart-down": () => Promise.resolve().then(function () { return IconShoppingCartDown$1; }),
  "shopping-cart-exclamation": () => Promise.resolve().then(function () { return IconShoppingCartExclamation$1; }),
  "shopping-cart-heart": () => Promise.resolve().then(function () { return IconShoppingCartHeart$1; }),
  "shopping-cart-minus": () => Promise.resolve().then(function () { return IconShoppingCartMinus$1; }),
  "shopping-cart-off": () => Promise.resolve().then(function () { return IconShoppingCartOff$1; }),
  "shopping-cart-pause": () => Promise.resolve().then(function () { return IconShoppingCartPause$1; }),
  "shopping-cart-pin": () => Promise.resolve().then(function () { return IconShoppingCartPin$1; }),
  "shopping-cart-plus": () => Promise.resolve().then(function () { return IconShoppingCartPlus$1; }),
  "shopping-cart-question": () => Promise.resolve().then(function () { return IconShoppingCartQuestion$1; }),
  "shopping-cart-search": () => Promise.resolve().then(function () { return IconShoppingCartSearch$1; }),
  "shopping-cart-share": () => Promise.resolve().then(function () { return IconShoppingCartShare$1; }),
  "shopping-cart-star": () => Promise.resolve().then(function () { return IconShoppingCartStar$1; }),
  "shopping-cart-up": () => Promise.resolve().then(function () { return IconShoppingCartUp$1; }),
  "shopping-cart-x": () => Promise.resolve().then(function () { return IconShoppingCartX$1; }),
  "shopping-cart": () => Promise.resolve().then(function () { return IconShoppingCart$1; }),
  "shovel-pitchforks": () => Promise.resolve().then(function () { return IconShovelPitchforks$1; }),
  "shovel": () => Promise.resolve().then(function () { return IconShovel$1; }),
  "shredder": () => Promise.resolve().then(function () { return IconShredder$1; }),
  "sign-left": () => Promise.resolve().then(function () { return IconSignLeft$1; }),
  "sign-right": () => Promise.resolve().then(function () { return IconSignRight$1; }),
  "signal-2g": () => Promise.resolve().then(function () { return IconSignal2g$1; }),
  "signal-3g": () => Promise.resolve().then(function () { return IconSignal3g$1; }),
  "signal-4g-plus": () => Promise.resolve().then(function () { return IconSignal4gPlus$1; }),
  "signal-4g": () => Promise.resolve().then(function () { return IconSignal4g$1; }),
  "signal-5g": () => Promise.resolve().then(function () { return IconSignal5g$1; }),
  "signal-6g": () => Promise.resolve().then(function () { return IconSignal6g$1; }),
  "signal-e": () => Promise.resolve().then(function () { return IconSignalE$1; }),
  "signal-g": () => Promise.resolve().then(function () { return IconSignalG$1; }),
  "signal-h-plus": () => Promise.resolve().then(function () { return IconSignalHPlus$1; }),
  "signal-h": () => Promise.resolve().then(function () { return IconSignalH$1; }),
  "signal-lte": () => Promise.resolve().then(function () { return IconSignalLte$1; }),
  "signature-off": () => Promise.resolve().then(function () { return IconSignatureOff$1; }),
  "signature": () => Promise.resolve().then(function () { return IconSignature$1; }),
  "sitemap-off": () => Promise.resolve().then(function () { return IconSitemapOff$1; }),
  "sitemap": () => Promise.resolve().then(function () { return IconSitemap$1; }),
  "skateboard-off": () => Promise.resolve().then(function () { return IconSkateboardOff$1; }),
  "skateboard": () => Promise.resolve().then(function () { return IconSkateboard$1; }),
  "skateboarding": () => Promise.resolve().then(function () { return IconSkateboarding$1; }),
  "skew-x": () => Promise.resolve().then(function () { return IconSkewX$1; }),
  "skew-y": () => Promise.resolve().then(function () { return IconSkewY$1; }),
  "ski-jumping": () => Promise.resolve().then(function () { return IconSkiJumping$1; }),
  "skull": () => Promise.resolve().then(function () { return IconSkull$1; }),
  "slash": () => Promise.resolve().then(function () { return IconSlash$1; }),
  "slashes": () => Promise.resolve().then(function () { return IconSlashes$1; }),
  "sleigh": () => Promise.resolve().then(function () { return IconSleigh$1; }),
  "slice": () => Promise.resolve().then(function () { return IconSlice$1; }),
  "slideshow": () => Promise.resolve().then(function () { return IconSlideshow$1; }),
  "smart-home-off": () => Promise.resolve().then(function () { return IconSmartHomeOff$1; }),
  "smart-home": () => Promise.resolve().then(function () { return IconSmartHome$1; }),
  "smoking-no": () => Promise.resolve().then(function () { return IconSmokingNo$1; }),
  "smoking": () => Promise.resolve().then(function () { return IconSmoking$1; }),
  "snowboarding": () => Promise.resolve().then(function () { return IconSnowboarding$1; }),
  "snowflake-off": () => Promise.resolve().then(function () { return IconSnowflakeOff$1; }),
  "snowflake": () => Promise.resolve().then(function () { return IconSnowflake$1; }),
  "snowman": () => Promise.resolve().then(function () { return IconSnowman$1; }),
  "soccer-field": () => Promise.resolve().then(function () { return IconSoccerField$1; }),
  "social-off": () => Promise.resolve().then(function () { return IconSocialOff$1; }),
  "social": () => Promise.resolve().then(function () { return IconSocial$1; }),
  "sock": () => Promise.resolve().then(function () { return IconSock$1; }),
  "sofa-off": () => Promise.resolve().then(function () { return IconSofaOff$1; }),
  "sofa": () => Promise.resolve().then(function () { return IconSofa$1; }),
  "solar-electricity": () => Promise.resolve().then(function () { return IconSolarElectricity$1; }),
  "solar-panel-2": () => Promise.resolve().then(function () { return IconSolarPanel2$1; }),
  "solar-panel": () => Promise.resolve().then(function () { return IconSolarPanel$1; }),
  "sort-0-9": () => Promise.resolve().then(function () { return IconSort09$1; }),
  "sort-9-0": () => Promise.resolve().then(function () { return IconSort90$1; }),
  "sort-a-z": () => Promise.resolve().then(function () { return IconSortAZ$1; }),
  "sort-ascending-2": () => Promise.resolve().then(function () { return IconSortAscending2$1; }),
  "sort-ascending-letters": () => Promise.resolve().then(function () { return IconSortAscendingLetters$1; }),
  "sort-ascending-numbers": () => Promise.resolve().then(function () { return IconSortAscendingNumbers$1; }),
  "sort-ascending-shapes": () => Promise.resolve().then(function () { return IconSortAscendingShapes$1; }),
  "sort-ascending-small-big": () => Promise.resolve().then(function () { return IconSortAscendingSmallBig$1; }),
  "sort-ascending": () => Promise.resolve().then(function () { return IconSortAscending$1; }),
  "sort-descending-2": () => Promise.resolve().then(function () { return IconSortDescending2$1; }),
  "sort-descending-letters": () => Promise.resolve().then(function () { return IconSortDescendingLetters$1; }),
  "sort-descending-numbers": () => Promise.resolve().then(function () { return IconSortDescendingNumbers$1; }),
  "sort-descending-shapes": () => Promise.resolve().then(function () { return IconSortDescendingShapes$1; }),
  "sort-descending-small-big": () => Promise.resolve().then(function () { return IconSortDescendingSmallBig$1; }),
  "sort-descending": () => Promise.resolve().then(function () { return IconSortDescending$1; }),
  "sort-z-a": () => Promise.resolve().then(function () { return IconSortZA$1; }),
  "sos": () => Promise.resolve().then(function () { return IconSos$1; }),
  "soup-off": () => Promise.resolve().then(function () { return IconSoupOff$1; }),
  "soup": () => Promise.resolve().then(function () { return IconSoup$1; }),
  "source-code": () => Promise.resolve().then(function () { return IconSourceCode$1; }),
  "space-off": () => Promise.resolve().then(function () { return IconSpaceOff$1; }),
  "space": () => Promise.resolve().then(function () { return IconSpace$1; }),
  "spaces": () => Promise.resolve().then(function () { return IconSpaces$1; }),
  "spacing-horizontal": () => Promise.resolve().then(function () { return IconSpacingHorizontal$1; }),
  "spacing-vertical": () => Promise.resolve().then(function () { return IconSpacingVertical$1; }),
  "spade": () => Promise.resolve().then(function () { return IconSpade$1; }),
  "sparkles": () => Promise.resolve().then(function () { return IconSparkles$1; }),
  "speakerphone": () => Promise.resolve().then(function () { return IconSpeakerphone$1; }),
  "speedboat": () => Promise.resolve().then(function () { return IconSpeedboat$1; }),
  "sphere-off": () => Promise.resolve().then(function () { return IconSphereOff$1; }),
  "sphere-plus": () => Promise.resolve().then(function () { return IconSpherePlus$1; }),
  "sphere": () => Promise.resolve().then(function () { return IconSphere$1; }),
  "spider": () => Promise.resolve().then(function () { return IconSpider$1; }),
  "spiral-off": () => Promise.resolve().then(function () { return IconSpiralOff$1; }),
  "spiral": () => Promise.resolve().then(function () { return IconSpiral$1; }),
  "sport-billard": () => Promise.resolve().then(function () { return IconSportBillard$1; }),
  "spray": () => Promise.resolve().then(function () { return IconSpray$1; }),
  "spy-off": () => Promise.resolve().then(function () { return IconSpyOff$1; }),
  "spy": () => Promise.resolve().then(function () { return IconSpy$1; }),
  "sql": () => Promise.resolve().then(function () { return IconSql$1; }),
  "square-arrow-down": () => Promise.resolve().then(function () { return IconSquareArrowDown$1; }),
  "square-arrow-left": () => Promise.resolve().then(function () { return IconSquareArrowLeft$1; }),
  "square-arrow-right": () => Promise.resolve().then(function () { return IconSquareArrowRight$1; }),
  "square-arrow-up": () => Promise.resolve().then(function () { return IconSquareArrowUp$1; }),
  "square-asterisk": () => Promise.resolve().then(function () { return IconSquareAsterisk$1; }),
  "square-check": () => Promise.resolve().then(function () { return IconSquareCheck$1; }),
  "square-chevron-down": () => Promise.resolve().then(function () { return IconSquareChevronDown$1; }),
  "square-chevron-left": () => Promise.resolve().then(function () { return IconSquareChevronLeft$1; }),
  "square-chevron-right": () => Promise.resolve().then(function () { return IconSquareChevronRight$1; }),
  "square-chevron-up": () => Promise.resolve().then(function () { return IconSquareChevronUp$1; }),
  "square-chevrons-down": () => Promise.resolve().then(function () { return IconSquareChevronsDown$1; }),
  "square-chevrons-left": () => Promise.resolve().then(function () { return IconSquareChevronsLeft$1; }),
  "square-chevrons-right": () => Promise.resolve().then(function () { return IconSquareChevronsRight$1; }),
  "square-chevrons-up": () => Promise.resolve().then(function () { return IconSquareChevronsUp$1; }),
  "square-dashed": () => Promise.resolve().then(function () { return IconSquareDashed$1; }),
  "square-dot": () => Promise.resolve().then(function () { return IconSquareDot$1; }),
  "square-f0": () => Promise.resolve().then(function () { return IconSquareF0$1; }),
  "square-f1": () => Promise.resolve().then(function () { return IconSquareF1$1; }),
  "square-f2": () => Promise.resolve().then(function () { return IconSquareF2$1; }),
  "square-f3": () => Promise.resolve().then(function () { return IconSquareF3$1; }),
  "square-f4": () => Promise.resolve().then(function () { return IconSquareF4$1; }),
  "square-f5": () => Promise.resolve().then(function () { return IconSquareF5$1; }),
  "square-f6": () => Promise.resolve().then(function () { return IconSquareF6$1; }),
  "square-f7": () => Promise.resolve().then(function () { return IconSquareF7$1; }),
  "square-f8": () => Promise.resolve().then(function () { return IconSquareF8$1; }),
  "square-f9": () => Promise.resolve().then(function () { return IconSquareF9$1; }),
  "square-forbid-2": () => Promise.resolve().then(function () { return IconSquareForbid2$1; }),
  "square-forbid": () => Promise.resolve().then(function () { return IconSquareForbid$1; }),
  "square-half": () => Promise.resolve().then(function () { return IconSquareHalf$1; }),
  "square-key": () => Promise.resolve().then(function () { return IconSquareKey$1; }),
  "square-letter-a": () => Promise.resolve().then(function () { return IconSquareLetterA$1; }),
  "square-letter-b": () => Promise.resolve().then(function () { return IconSquareLetterB$1; }),
  "square-letter-c": () => Promise.resolve().then(function () { return IconSquareLetterC$1; }),
  "square-letter-d": () => Promise.resolve().then(function () { return IconSquareLetterD$1; }),
  "square-letter-e": () => Promise.resolve().then(function () { return IconSquareLetterE$1; }),
  "square-letter-f": () => Promise.resolve().then(function () { return IconSquareLetterF$1; }),
  "square-letter-g": () => Promise.resolve().then(function () { return IconSquareLetterG$1; }),
  "square-letter-h": () => Promise.resolve().then(function () { return IconSquareLetterH$1; }),
  "square-letter-i": () => Promise.resolve().then(function () { return IconSquareLetterI$1; }),
  "square-letter-j": () => Promise.resolve().then(function () { return IconSquareLetterJ$1; }),
  "square-letter-k": () => Promise.resolve().then(function () { return IconSquareLetterK$1; }),
  "square-letter-l": () => Promise.resolve().then(function () { return IconSquareLetterL$1; }),
  "square-letter-m": () => Promise.resolve().then(function () { return IconSquareLetterM$1; }),
  "square-letter-n": () => Promise.resolve().then(function () { return IconSquareLetterN$1; }),
  "square-letter-o": () => Promise.resolve().then(function () { return IconSquareLetterO$1; }),
  "square-letter-p": () => Promise.resolve().then(function () { return IconSquareLetterP$1; }),
  "square-letter-q": () => Promise.resolve().then(function () { return IconSquareLetterQ$1; }),
  "square-letter-r": () => Promise.resolve().then(function () { return IconSquareLetterR$1; }),
  "square-letter-s": () => Promise.resolve().then(function () { return IconSquareLetterS$1; }),
  "square-letter-t": () => Promise.resolve().then(function () { return IconSquareLetterT$1; }),
  "square-letter-u": () => Promise.resolve().then(function () { return IconSquareLetterU$1; }),
  "square-letter-v": () => Promise.resolve().then(function () { return IconSquareLetterV$1; }),
  "square-letter-w": () => Promise.resolve().then(function () { return IconSquareLetterW$1; }),
  "square-letter-x": () => Promise.resolve().then(function () { return IconSquareLetterX$1; }),
  "square-letter-y": () => Promise.resolve().then(function () { return IconSquareLetterY$1; }),
  "square-letter-z": () => Promise.resolve().then(function () { return IconSquareLetterZ$1; }),
  "square-minus": () => Promise.resolve().then(function () { return IconSquareMinus$1; }),
  "square-number-0": () => Promise.resolve().then(function () { return IconSquareNumber0$1; }),
  "square-number-1": () => Promise.resolve().then(function () { return IconSquareNumber1$1; }),
  "square-number-2": () => Promise.resolve().then(function () { return IconSquareNumber2$1; }),
  "square-number-3": () => Promise.resolve().then(function () { return IconSquareNumber3$1; }),
  "square-number-4": () => Promise.resolve().then(function () { return IconSquareNumber4$1; }),
  "square-number-5": () => Promise.resolve().then(function () { return IconSquareNumber5$1; }),
  "square-number-6": () => Promise.resolve().then(function () { return IconSquareNumber6$1; }),
  "square-number-7": () => Promise.resolve().then(function () { return IconSquareNumber7$1; }),
  "square-number-8": () => Promise.resolve().then(function () { return IconSquareNumber8$1; }),
  "square-number-9": () => Promise.resolve().then(function () { return IconSquareNumber9$1; }),
  "square-off": () => Promise.resolve().then(function () { return IconSquareOff$1; }),
  "square-percentage": () => Promise.resolve().then(function () { return IconSquarePercentage$1; }),
  "square-plus-2": () => Promise.resolve().then(function () { return IconSquarePlus2$1; }),
  "square-plus": () => Promise.resolve().then(function () { return IconSquarePlus$1; }),
  "square-root-2": () => Promise.resolve().then(function () { return IconSquareRoot2$1; }),
  "square-root": () => Promise.resolve().then(function () { return IconSquareRoot$1; }),
  "square-rotated-forbid-2": () => Promise.resolve().then(function () { return IconSquareRotatedForbid2$1; }),
  "square-rotated-forbid": () => Promise.resolve().then(function () { return IconSquareRotatedForbid$1; }),
  "square-rotated-off": () => Promise.resolve().then(function () { return IconSquareRotatedOff$1; }),
  "square-rotated": () => Promise.resolve().then(function () { return IconSquareRotated$1; }),
  "square-rounded-arrow-down": () => Promise.resolve().then(function () { return IconSquareRoundedArrowDown$1; }),
  "square-rounded-arrow-left": () => Promise.resolve().then(function () { return IconSquareRoundedArrowLeft$1; }),
  "square-rounded-arrow-right": () => Promise.resolve().then(function () { return IconSquareRoundedArrowRight$1; }),
  "square-rounded-arrow-up": () => Promise.resolve().then(function () { return IconSquareRoundedArrowUp$1; }),
  "square-rounded-check": () => Promise.resolve().then(function () { return IconSquareRoundedCheck$1; }),
  "square-rounded-chevron-down": () => Promise.resolve().then(function () { return IconSquareRoundedChevronDown$1; }),
  "square-rounded-chevron-left": () => Promise.resolve().then(function () { return IconSquareRoundedChevronLeft$1; }),
  "square-rounded-chevron-right": () => Promise.resolve().then(function () { return IconSquareRoundedChevronRight$1; }),
  "square-rounded-chevron-up": () => Promise.resolve().then(function () { return IconSquareRoundedChevronUp$1; }),
  "square-rounded-chevrons-down": () => Promise.resolve().then(function () { return IconSquareRoundedChevronsDown$1; }),
  "square-rounded-chevrons-left": () => Promise.resolve().then(function () { return IconSquareRoundedChevronsLeft$1; }),
  "square-rounded-chevrons-right": () => Promise.resolve().then(function () { return IconSquareRoundedChevronsRight$1; }),
  "square-rounded-chevrons-up": () => Promise.resolve().then(function () { return IconSquareRoundedChevronsUp$1; }),
  "square-rounded-letter-a": () => Promise.resolve().then(function () { return IconSquareRoundedLetterA$1; }),
  "square-rounded-letter-b": () => Promise.resolve().then(function () { return IconSquareRoundedLetterB$1; }),
  "square-rounded-letter-c": () => Promise.resolve().then(function () { return IconSquareRoundedLetterC$1; }),
  "square-rounded-letter-d": () => Promise.resolve().then(function () { return IconSquareRoundedLetterD$1; }),
  "square-rounded-letter-e": () => Promise.resolve().then(function () { return IconSquareRoundedLetterE$1; }),
  "square-rounded-letter-f": () => Promise.resolve().then(function () { return IconSquareRoundedLetterF$1; }),
  "square-rounded-letter-g": () => Promise.resolve().then(function () { return IconSquareRoundedLetterG$1; }),
  "square-rounded-letter-h": () => Promise.resolve().then(function () { return IconSquareRoundedLetterH$1; }),
  "square-rounded-letter-i": () => Promise.resolve().then(function () { return IconSquareRoundedLetterI$1; }),
  "square-rounded-letter-j": () => Promise.resolve().then(function () { return IconSquareRoundedLetterJ$1; }),
  "square-rounded-letter-k": () => Promise.resolve().then(function () { return IconSquareRoundedLetterK$1; }),
  "square-rounded-letter-l": () => Promise.resolve().then(function () { return IconSquareRoundedLetterL$1; }),
  "square-rounded-letter-m": () => Promise.resolve().then(function () { return IconSquareRoundedLetterM$1; }),
  "square-rounded-letter-n": () => Promise.resolve().then(function () { return IconSquareRoundedLetterN$1; }),
  "square-rounded-letter-o": () => Promise.resolve().then(function () { return IconSquareRoundedLetterO$1; }),
  "square-rounded-letter-p": () => Promise.resolve().then(function () { return IconSquareRoundedLetterP$1; }),
  "square-rounded-letter-q": () => Promise.resolve().then(function () { return IconSquareRoundedLetterQ$1; }),
  "square-rounded-letter-r": () => Promise.resolve().then(function () { return IconSquareRoundedLetterR$1; }),
  "square-rounded-letter-s": () => Promise.resolve().then(function () { return IconSquareRoundedLetterS$1; }),
  "square-rounded-letter-t": () => Promise.resolve().then(function () { return IconSquareRoundedLetterT$1; }),
  "square-rounded-letter-u": () => Promise.resolve().then(function () { return IconSquareRoundedLetterU$1; }),
  "square-rounded-letter-v": () => Promise.resolve().then(function () { return IconSquareRoundedLetterV$1; }),
  "square-rounded-letter-w": () => Promise.resolve().then(function () { return IconSquareRoundedLetterW$1; }),
  "square-rounded-letter-x": () => Promise.resolve().then(function () { return IconSquareRoundedLetterX$1; }),
  "square-rounded-letter-y": () => Promise.resolve().then(function () { return IconSquareRoundedLetterY$1; }),
  "square-rounded-letter-z": () => Promise.resolve().then(function () { return IconSquareRoundedLetterZ$1; }),
  "square-rounded-minus-2": () => Promise.resolve().then(function () { return IconSquareRoundedMinus2$1; }),
  "square-rounded-minus": () => Promise.resolve().then(function () { return IconSquareRoundedMinus$1; }),
  "square-rounded-number-0": () => Promise.resolve().then(function () { return IconSquareRoundedNumber0$1; }),
  "square-rounded-number-1": () => Promise.resolve().then(function () { return IconSquareRoundedNumber1$1; }),
  "square-rounded-number-2": () => Promise.resolve().then(function () { return IconSquareRoundedNumber2$1; }),
  "square-rounded-number-3": () => Promise.resolve().then(function () { return IconSquareRoundedNumber3$1; }),
  "square-rounded-number-4": () => Promise.resolve().then(function () { return IconSquareRoundedNumber4$1; }),
  "square-rounded-number-5": () => Promise.resolve().then(function () { return IconSquareRoundedNumber5$1; }),
  "square-rounded-number-6": () => Promise.resolve().then(function () { return IconSquareRoundedNumber6$1; }),
  "square-rounded-number-7": () => Promise.resolve().then(function () { return IconSquareRoundedNumber7$1; }),
  "square-rounded-number-8": () => Promise.resolve().then(function () { return IconSquareRoundedNumber8$1; }),
  "square-rounded-number-9": () => Promise.resolve().then(function () { return IconSquareRoundedNumber9$1; }),
  "square-rounded-percentage": () => Promise.resolve().then(function () { return IconSquareRoundedPercentage$1; }),
  "square-rounded-plus-2": () => Promise.resolve().then(function () { return IconSquareRoundedPlus2$1; }),
  "square-rounded-plus": () => Promise.resolve().then(function () { return IconSquareRoundedPlus$1; }),
  "square-rounded-x": () => Promise.resolve().then(function () { return IconSquareRoundedX$1; }),
  "square-rounded": () => Promise.resolve().then(function () { return IconSquareRounded$1; }),
  "square-toggle-horizontal": () => Promise.resolve().then(function () { return IconSquareToggleHorizontal$1; }),
  "square-toggle": () => Promise.resolve().then(function () { return IconSquareToggle$1; }),
  "square-x": () => Promise.resolve().then(function () { return IconSquareX$1; }),
  "square": () => Promise.resolve().then(function () { return IconSquare$1; }),
  "squares-diagonal": () => Promise.resolve().then(function () { return IconSquaresDiagonal$1; }),
  "squares-selected": () => Promise.resolve().then(function () { return IconSquaresSelected$1; }),
  "squares": () => Promise.resolve().then(function () { return IconSquares$1; }),
  "stack-2": () => Promise.resolve().then(function () { return IconStack2$1; }),
  "stack-3": () => Promise.resolve().then(function () { return IconStack3$1; }),
  "stack-back": () => Promise.resolve().then(function () { return IconStackBack$1; }),
  "stack-backward": () => Promise.resolve().then(function () { return IconStackBackward$1; }),
  "stack-forward": () => Promise.resolve().then(function () { return IconStackForward$1; }),
  "stack-front": () => Promise.resolve().then(function () { return IconStackFront$1; }),
  "stack-middle": () => Promise.resolve().then(function () { return IconStackMiddle$1; }),
  "stack-pop": () => Promise.resolve().then(function () { return IconStackPop$1; }),
  "stack-push": () => Promise.resolve().then(function () { return IconStackPush$1; }),
  "stack": () => Promise.resolve().then(function () { return IconStack$1; }),
  "stairs-down": () => Promise.resolve().then(function () { return IconStairsDown$1; }),
  "stairs-up": () => Promise.resolve().then(function () { return IconStairsUp$1; }),
  "stairs": () => Promise.resolve().then(function () { return IconStairs$1; }),
  "star-half": () => Promise.resolve().then(function () { return IconStarHalf$1; }),
  "star-off": () => Promise.resolve().then(function () { return IconStarOff$1; }),
  "star": () => Promise.resolve().then(function () { return IconStar$1; }),
  "stars-off": () => Promise.resolve().then(function () { return IconStarsOff$1; }),
  "stars": () => Promise.resolve().then(function () { return IconStars$1; }),
  "status-change": () => Promise.resolve().then(function () { return IconStatusChange$1; }),
  "steam": () => Promise.resolve().then(function () { return IconSteam$1; }),
  "steering-wheel-off": () => Promise.resolve().then(function () { return IconSteeringWheelOff$1; }),
  "steering-wheel": () => Promise.resolve().then(function () { return IconSteeringWheel$1; }),
  "step-into": () => Promise.resolve().then(function () { return IconStepInto$1; }),
  "step-out": () => Promise.resolve().then(function () { return IconStepOut$1; }),
  "stereo-glasses": () => Promise.resolve().then(function () { return IconStereoGlasses$1; }),
  "stethoscope-off": () => Promise.resolve().then(function () { return IconStethoscopeOff$1; }),
  "stethoscope": () => Promise.resolve().then(function () { return IconStethoscope$1; }),
  "sticker-2": () => Promise.resolve().then(function () { return IconSticker2$1; }),
  "sticker": () => Promise.resolve().then(function () { return IconSticker$1; }),
  "stopwatch": () => Promise.resolve().then(function () { return IconStopwatch$1; }),
  "storm-off": () => Promise.resolve().then(function () { return IconStormOff$1; }),
  "storm": () => Promise.resolve().then(function () { return IconStorm$1; }),
  "stretching-2": () => Promise.resolve().then(function () { return IconStretching2$1; }),
  "stretching": () => Promise.resolve().then(function () { return IconStretching$1; }),
  "strikethrough": () => Promise.resolve().then(function () { return IconStrikethrough$1; }),
  "submarine": () => Promise.resolve().then(function () { return IconSubmarine$1; }),
  "subscript": () => Promise.resolve().then(function () { return IconSubscript$1; }),
  "subtask": () => Promise.resolve().then(function () { return IconSubtask$1; }),
  "sum-off": () => Promise.resolve().then(function () { return IconSumOff$1; }),
  "sum": () => Promise.resolve().then(function () { return IconSum$1; }),
  "sun-electricity": () => Promise.resolve().then(function () { return IconSunElectricity$1; }),
  "sun-high": () => Promise.resolve().then(function () { return IconSunHigh$1; }),
  "sun-low": () => Promise.resolve().then(function () { return IconSunLow$1; }),
  "sun-moon": () => Promise.resolve().then(function () { return IconSunMoon$1; }),
  "sun-off": () => Promise.resolve().then(function () { return IconSunOff$1; }),
  "sun-wind": () => Promise.resolve().then(function () { return IconSunWind$1; }),
  "sun": () => Promise.resolve().then(function () { return IconSun$1; }),
  "sunglasses": () => Promise.resolve().then(function () { return IconSunglasses$1; }),
  "sunrise": () => Promise.resolve().then(function () { return IconSunrise$1; }),
  "sunset-2": () => Promise.resolve().then(function () { return IconSunset2$1; }),
  "sunset": () => Promise.resolve().then(function () { return IconSunset$1; }),
  "superscript": () => Promise.resolve().then(function () { return IconSuperscript$1; }),
  "svg": () => Promise.resolve().then(function () { return IconSvg$1; }),
  "swimming": () => Promise.resolve().then(function () { return IconSwimming$1; }),
  "swipe-down": () => Promise.resolve().then(function () { return IconSwipeDown$1; }),
  "swipe-left": () => Promise.resolve().then(function () { return IconSwipeLeft$1; }),
  "swipe-right": () => Promise.resolve().then(function () { return IconSwipeRight$1; }),
  "swipe-up": () => Promise.resolve().then(function () { return IconSwipeUp$1; }),
  "swipe": () => Promise.resolve().then(function () { return IconSwipe$1; }),
  "switch-2": () => Promise.resolve().then(function () { return IconSwitch2$1; }),
  "switch-3": () => Promise.resolve().then(function () { return IconSwitch3$1; }),
  "switch-horizontal": () => Promise.resolve().then(function () { return IconSwitchHorizontal$1; }),
  "switch-vertical": () => Promise.resolve().then(function () { return IconSwitchVertical$1; }),
  "switch": () => Promise.resolve().then(function () { return IconSwitch$1; }),
  "sword-off": () => Promise.resolve().then(function () { return IconSwordOff$1; }),
  "sword": () => Promise.resolve().then(function () { return IconSword$1; }),
  "swords": () => Promise.resolve().then(function () { return IconSwords$1; }),
  "table-alias": () => Promise.resolve().then(function () { return IconTableAlias$1; }),
  "table-column": () => Promise.resolve().then(function () { return IconTableColumn$1; }),
  "table-dashed": () => Promise.resolve().then(function () { return IconTableDashed$1; }),
  "table-down": () => Promise.resolve().then(function () { return IconTableDown$1; }),
  "table-export": () => Promise.resolve().then(function () { return IconTableExport$1; }),
  "table-heart": () => Promise.resolve().then(function () { return IconTableHeart$1; }),
  "table-import": () => Promise.resolve().then(function () { return IconTableImport$1; }),
  "table-minus": () => Promise.resolve().then(function () { return IconTableMinus$1; }),
  "table-off": () => Promise.resolve().then(function () { return IconTableOff$1; }),
  "table-options": () => Promise.resolve().then(function () { return IconTableOptions$1; }),
  "table-plus": () => Promise.resolve().then(function () { return IconTablePlus$1; }),
  "table-row": () => Promise.resolve().then(function () { return IconTableRow$1; }),
  "table-share": () => Promise.resolve().then(function () { return IconTableShare$1; }),
  "table-shortcut": () => Promise.resolve().then(function () { return IconTableShortcut$1; }),
  "table-spark": () => Promise.resolve().then(function () { return IconTableSpark$1; }),
  "table": () => Promise.resolve().then(function () { return IconTable$1; }),
  "tag-minus": () => Promise.resolve().then(function () { return IconTagMinus$1; }),
  "tag-off": () => Promise.resolve().then(function () { return IconTagOff$1; }),
  "tag-plus": () => Promise.resolve().then(function () { return IconTagPlus$1; }),
  "tag-starred": () => Promise.resolve().then(function () { return IconTagStarred$1; }),
  "tag": () => Promise.resolve().then(function () { return IconTag$1; }),
  "tags-off": () => Promise.resolve().then(function () { return IconTagsOff$1; }),
  "tags": () => Promise.resolve().then(function () { return IconTags$1; }),
  "tallymark-1": () => Promise.resolve().then(function () { return IconTallymark1$1; }),
  "tallymark-2": () => Promise.resolve().then(function () { return IconTallymark2$1; }),
  "tallymark-3": () => Promise.resolve().then(function () { return IconTallymark3$1; }),
  "tallymark-4": () => Promise.resolve().then(function () { return IconTallymark4$1; }),
  "tallymarks": () => Promise.resolve().then(function () { return IconTallymarks$1; }),
  "tank": () => Promise.resolve().then(function () { return IconTank$1; }),
  "target-arrow": () => Promise.resolve().then(function () { return IconTargetArrow$1; }),
  "target-off": () => Promise.resolve().then(function () { return IconTargetOff$1; }),
  "target": () => Promise.resolve().then(function () { return IconTarget$1; }),
  "tax-euro": () => Promise.resolve().then(function () { return IconTaxEuro$1; }),
  "tax-pound": () => Promise.resolve().then(function () { return IconTaxPound$1; }),
  "tax": () => Promise.resolve().then(function () { return IconTax$1; }),
  "teapot": () => Promise.resolve().then(function () { return IconTeapot$1; }),
  "telescope-off": () => Promise.resolve().then(function () { return IconTelescopeOff$1; }),
  "telescope": () => Promise.resolve().then(function () { return IconTelescope$1; }),
  "temperature-celsius": () => Promise.resolve().then(function () { return IconTemperatureCelsius$1; }),
  "temperature-fahrenheit": () => Promise.resolve().then(function () { return IconTemperatureFahrenheit$1; }),
  "temperature-minus": () => Promise.resolve().then(function () { return IconTemperatureMinus$1; }),
  "temperature-off": () => Promise.resolve().then(function () { return IconTemperatureOff$1; }),
  "temperature-plus": () => Promise.resolve().then(function () { return IconTemperaturePlus$1; }),
  "temperature-snow": () => Promise.resolve().then(function () { return IconTemperatureSnow$1; }),
  "temperature-sun": () => Promise.resolve().then(function () { return IconTemperatureSun$1; }),
  "temperature": () => Promise.resolve().then(function () { return IconTemperature$1; }),
  "template-off": () => Promise.resolve().then(function () { return IconTemplateOff$1; }),
  "template": () => Promise.resolve().then(function () { return IconTemplate$1; }),
  "tent-off": () => Promise.resolve().then(function () { return IconTentOff$1; }),
  "tent": () => Promise.resolve().then(function () { return IconTent$1; }),
  "terminal-2": () => Promise.resolve().then(function () { return IconTerminal2$1; }),
  "terminal": () => Promise.resolve().then(function () { return IconTerminal$1; }),
  "test-pipe-2": () => Promise.resolve().then(function () { return IconTestPipe2$1; }),
  "test-pipe-off": () => Promise.resolve().then(function () { return IconTestPipeOff$1; }),
  "test-pipe": () => Promise.resolve().then(function () { return IconTestPipe$1; }),
  "tex": () => Promise.resolve().then(function () { return IconTex$1; }),
  "text-caption": () => Promise.resolve().then(function () { return IconTextCaption$1; }),
  "text-color": () => Promise.resolve().then(function () { return IconTextColor$1; }),
  "text-decrease": () => Promise.resolve().then(function () { return IconTextDecrease$1; }),
  "text-direction-ltr": () => Promise.resolve().then(function () { return IconTextDirectionLtr$1; }),
  "text-direction-rtl": () => Promise.resolve().then(function () { return IconTextDirectionRtl$1; }),
  "text-grammar": () => Promise.resolve().then(function () { return IconTextGrammar$1; }),
  "text-increase": () => Promise.resolve().then(function () { return IconTextIncrease$1; }),
  "text-orientation": () => Promise.resolve().then(function () { return IconTextOrientation$1; }),
  "text-plus": () => Promise.resolve().then(function () { return IconTextPlus$1; }),
  "text-recognition": () => Promise.resolve().then(function () { return IconTextRecognition$1; }),
  "text-resize": () => Promise.resolve().then(function () { return IconTextResize$1; }),
  "text-scan-2": () => Promise.resolve().then(function () { return IconTextScan2$1; }),
  "text-size": () => Promise.resolve().then(function () { return IconTextSize$1; }),
  "text-spellcheck": () => Promise.resolve().then(function () { return IconTextSpellcheck$1; }),
  "text-wrap-column": () => Promise.resolve().then(function () { return IconTextWrapColumn$1; }),
  "text-wrap-disabled": () => Promise.resolve().then(function () { return IconTextWrapDisabled$1; }),
  "text-wrap": () => Promise.resolve().then(function () { return IconTextWrap$1; }),
  "texture": () => Promise.resolve().then(function () { return IconTexture$1; }),
  "theater": () => Promise.resolve().then(function () { return IconTheater$1; }),
  "thermometer": () => Promise.resolve().then(function () { return IconThermometer$1; }),
  "thumb-down-off": () => Promise.resolve().then(function () { return IconThumbDownOff$1; }),
  "thumb-down": () => Promise.resolve().then(function () { return IconThumbDown$1; }),
  "thumb-up-off": () => Promise.resolve().then(function () { return IconThumbUpOff$1; }),
  "thumb-up": () => Promise.resolve().then(function () { return IconThumbUp$1; }),
  "tic-tac": () => Promise.resolve().then(function () { return IconTicTac$1; }),
  "ticket-off": () => Promise.resolve().then(function () { return IconTicketOff$1; }),
  "ticket": () => Promise.resolve().then(function () { return IconTicket$1; }),
  "tie": () => Promise.resolve().then(function () { return IconTie$1; }),
  "tilde": () => Promise.resolve().then(function () { return IconTilde$1; }),
  "tilt-shift-off": () => Promise.resolve().then(function () { return IconTiltShiftOff$1; }),
  "tilt-shift": () => Promise.resolve().then(function () { return IconTiltShift$1; }),
  "time-duration-0": () => Promise.resolve().then(function () { return IconTimeDuration0$1; }),
  "time-duration-10": () => Promise.resolve().then(function () { return IconTimeDuration10$1; }),
  "time-duration-15": () => Promise.resolve().then(function () { return IconTimeDuration15$1; }),
  "time-duration-30": () => Promise.resolve().then(function () { return IconTimeDuration30$1; }),
  "time-duration-45": () => Promise.resolve().then(function () { return IconTimeDuration45$1; }),
  "time-duration-5": () => Promise.resolve().then(function () { return IconTimeDuration5$1; }),
  "time-duration-60": () => Promise.resolve().then(function () { return IconTimeDuration60$1; }),
  "time-duration-90": () => Promise.resolve().then(function () { return IconTimeDuration90$1; }),
  "time-duration-off": () => Promise.resolve().then(function () { return IconTimeDurationOff$1; }),
  "timeline-event-exclamation": () => Promise.resolve().then(function () { return IconTimelineEventExclamation$1; }),
  "timeline-event-minus": () => Promise.resolve().then(function () { return IconTimelineEventMinus$1; }),
  "timeline-event-plus": () => Promise.resolve().then(function () { return IconTimelineEventPlus$1; }),
  "timeline-event-text": () => Promise.resolve().then(function () { return IconTimelineEventText$1; }),
  "timeline-event-x": () => Promise.resolve().then(function () { return IconTimelineEventX$1; }),
  "timeline-event": () => Promise.resolve().then(function () { return IconTimelineEvent$1; }),
  "timeline": () => Promise.resolve().then(function () { return IconTimeline$1; }),
  "timezone": () => Promise.resolve().then(function () { return IconTimezone$1; }),
  "tip-jar-euro": () => Promise.resolve().then(function () { return IconTipJarEuro$1; }),
  "tip-jar-pound": () => Promise.resolve().then(function () { return IconTipJarPound$1; }),
  "tip-jar": () => Promise.resolve().then(function () { return IconTipJar$1; }),
  "tir": () => Promise.resolve().then(function () { return IconTir$1; }),
  "toggle-left": () => Promise.resolve().then(function () { return IconToggleLeft$1; }),
  "toggle-right": () => Promise.resolve().then(function () { return IconToggleRight$1; }),
  "toilet-paper-off": () => Promise.resolve().then(function () { return IconToiletPaperOff$1; }),
  "toilet-paper": () => Promise.resolve().then(function () { return IconToiletPaper$1; }),
  "toml": () => Promise.resolve().then(function () { return IconToml$1; }),
  "tool": () => Promise.resolve().then(function () { return IconTool$1; }),
  "tools-kitchen-2-off": () => Promise.resolve().then(function () { return IconToolsKitchen2Off$1; }),
  "tools-kitchen-2": () => Promise.resolve().then(function () { return IconToolsKitchen2$1; }),
  "tools-kitchen-3": () => Promise.resolve().then(function () { return IconToolsKitchen3$1; }),
  "tools-kitchen-off": () => Promise.resolve().then(function () { return IconToolsKitchenOff$1; }),
  "tools-kitchen": () => Promise.resolve().then(function () { return IconToolsKitchen$1; }),
  "tools-off": () => Promise.resolve().then(function () { return IconToolsOff$1; }),
  "tools": () => Promise.resolve().then(function () { return IconTools$1; }),
  "tooltip": () => Promise.resolve().then(function () { return IconTooltip$1; }),
  "topology-bus": () => Promise.resolve().then(function () { return IconTopologyBus$1; }),
  "topology-complex": () => Promise.resolve().then(function () { return IconTopologyComplex$1; }),
  "topology-full-hierarchy": () => Promise.resolve().then(function () { return IconTopologyFullHierarchy$1; }),
  "topology-full": () => Promise.resolve().then(function () { return IconTopologyFull$1; }),
  "topology-ring-2": () => Promise.resolve().then(function () { return IconTopologyRing2$1; }),
  "topology-ring-3": () => Promise.resolve().then(function () { return IconTopologyRing3$1; }),
  "topology-ring": () => Promise.resolve().then(function () { return IconTopologyRing$1; }),
  "topology-star-2": () => Promise.resolve().then(function () { return IconTopologyStar2$1; }),
  "topology-star-3": () => Promise.resolve().then(function () { return IconTopologyStar3$1; }),
  "topology-star-ring-2": () => Promise.resolve().then(function () { return IconTopologyStarRing2$1; }),
  "topology-star-ring-3": () => Promise.resolve().then(function () { return IconTopologyStarRing3$1; }),
  "topology-star-ring": () => Promise.resolve().then(function () { return IconTopologyStarRing$1; }),
  "topology-star": () => Promise.resolve().then(function () { return IconTopologyStar$1; }),
  "torii": () => Promise.resolve().then(function () { return IconTorii$1; }),
  "tornado": () => Promise.resolve().then(function () { return IconTornado$1; }),
  "tournament": () => Promise.resolve().then(function () { return IconTournament$1; }),
  "tower-off": () => Promise.resolve().then(function () { return IconTowerOff$1; }),
  "tower": () => Promise.resolve().then(function () { return IconTower$1; }),
  "track": () => Promise.resolve().then(function () { return IconTrack$1; }),
  "tractor": () => Promise.resolve().then(function () { return IconTractor$1; }),
  "trademark": () => Promise.resolve().then(function () { return IconTrademark$1; }),
  "traffic-cone-off": () => Promise.resolve().then(function () { return IconTrafficConeOff$1; }),
  "traffic-cone": () => Promise.resolve().then(function () { return IconTrafficCone$1; }),
  "traffic-lights-off": () => Promise.resolve().then(function () { return IconTrafficLightsOff$1; }),
  "traffic-lights": () => Promise.resolve().then(function () { return IconTrafficLights$1; }),
  "train": () => Promise.resolve().then(function () { return IconTrain$1; }),
  "transaction-bitcoin": () => Promise.resolve().then(function () { return IconTransactionBitcoin$1; }),
  "transaction-dollar": () => Promise.resolve().then(function () { return IconTransactionDollar$1; }),
  "transaction-euro": () => Promise.resolve().then(function () { return IconTransactionEuro$1; }),
  "transaction-pound": () => Promise.resolve().then(function () { return IconTransactionPound$1; }),
  "transaction-rupee": () => Promise.resolve().then(function () { return IconTransactionRupee$1; }),
  "transaction-yen": () => Promise.resolve().then(function () { return IconTransactionYen$1; }),
  "transaction-yuan": () => Promise.resolve().then(function () { return IconTransactionYuan$1; }),
  "transfer-in": () => Promise.resolve().then(function () { return IconTransferIn$1; }),
  "transfer-out": () => Promise.resolve().then(function () { return IconTransferOut$1; }),
  "transfer-vertical": () => Promise.resolve().then(function () { return IconTransferVertical$1; }),
  "transfer": () => Promise.resolve().then(function () { return IconTransfer$1; }),
  "transform-point-bottom-left": () => Promise.resolve().then(function () { return IconTransformPointBottomLeft$1; }),
  "transform-point-bottom-right": () => Promise.resolve().then(function () { return IconTransformPointBottomRight$1; }),
  "transform-point-top-left": () => Promise.resolve().then(function () { return IconTransformPointTopLeft$1; }),
  "transform-point-top-right": () => Promise.resolve().then(function () { return IconTransformPointTopRight$1; }),
  "transform-point": () => Promise.resolve().then(function () { return IconTransformPoint$1; }),
  "transform": () => Promise.resolve().then(function () { return IconTransform$1; }),
  "transition-bottom": () => Promise.resolve().then(function () { return IconTransitionBottom$1; }),
  "transition-left": () => Promise.resolve().then(function () { return IconTransitionLeft$1; }),
  "transition-right": () => Promise.resolve().then(function () { return IconTransitionRight$1; }),
  "transition-top": () => Promise.resolve().then(function () { return IconTransitionTop$1; }),
  "trash-off": () => Promise.resolve().then(function () { return IconTrashOff$1; }),
  "trash-x": () => Promise.resolve().then(function () { return IconTrashX$1; }),
  "trash": () => Promise.resolve().then(function () { return IconTrash$1; }),
  "treadmill": () => Promise.resolve().then(function () { return IconTreadmill$1; }),
  "tree": () => Promise.resolve().then(function () { return IconTree$1; }),
  "trees": () => Promise.resolve().then(function () { return IconTrees$1; }),
  "trekking": () => Promise.resolve().then(function () { return IconTrekking$1; }),
  "trending-down-2": () => Promise.resolve().then(function () { return IconTrendingDown2$1; }),
  "trending-down-3": () => Promise.resolve().then(function () { return IconTrendingDown3$1; }),
  "trending-down": () => Promise.resolve().then(function () { return IconTrendingDown$1; }),
  "trending-up-2": () => Promise.resolve().then(function () { return IconTrendingUp2$1; }),
  "trending-up-3": () => Promise.resolve().then(function () { return IconTrendingUp3$1; }),
  "trending-up": () => Promise.resolve().then(function () { return IconTrendingUp$1; }),
  "triangle-inverted": () => Promise.resolve().then(function () { return IconTriangleInverted$1; }),
  "triangle-minus-2": () => Promise.resolve().then(function () { return IconTriangleMinus2$1; }),
  "triangle-minus": () => Promise.resolve().then(function () { return IconTriangleMinus$1; }),
  "triangle-off": () => Promise.resolve().then(function () { return IconTriangleOff$1; }),
  "triangle-plus-2": () => Promise.resolve().then(function () { return IconTrianglePlus2$1; }),
  "triangle-plus": () => Promise.resolve().then(function () { return IconTrianglePlus$1; }),
  "triangle-square-circle": () => Promise.resolve().then(function () { return IconTriangleSquareCircle$1; }),
  "triangle": () => Promise.resolve().then(function () { return IconTriangle$1; }),
  "triangles": () => Promise.resolve().then(function () { return IconTriangles$1; }),
  "trident": () => Promise.resolve().then(function () { return IconTrident$1; }),
  "trolley": () => Promise.resolve().then(function () { return IconTrolley$1; }),
  "trophy-off": () => Promise.resolve().then(function () { return IconTrophyOff$1; }),
  "trophy": () => Promise.resolve().then(function () { return IconTrophy$1; }),
  "trowel": () => Promise.resolve().then(function () { return IconTrowel$1; }),
  "truck-delivery": () => Promise.resolve().then(function () { return IconTruckDelivery$1; }),
  "truck-loading": () => Promise.resolve().then(function () { return IconTruckLoading$1; }),
  "truck-off": () => Promise.resolve().then(function () { return IconTruckOff$1; }),
  "truck-return": () => Promise.resolve().then(function () { return IconTruckReturn$1; }),
  "truck": () => Promise.resolve().then(function () { return IconTruck$1; }),
  "txt": () => Promise.resolve().then(function () { return IconTxt$1; }),
  "typeface": () => Promise.resolve().then(function () { return IconTypeface$1; }),
  "typography-off": () => Promise.resolve().then(function () { return IconTypographyOff$1; }),
  "typography": () => Promise.resolve().then(function () { return IconTypography$1; }),
  "u-turn-left": () => Promise.resolve().then(function () { return IconUTurnLeft$1; }),
  "u-turn-right": () => Promise.resolve().then(function () { return IconUTurnRight$1; }),
  "ufo-off": () => Promise.resolve().then(function () { return IconUfoOff$1; }),
  "ufo": () => Promise.resolve().then(function () { return IconUfo$1; }),
  "uhd": () => Promise.resolve().then(function () { return IconUhd$1; }),
  "umbrella-2": () => Promise.resolve().then(function () { return IconUmbrella2$1; }),
  "umbrella-closed-2": () => Promise.resolve().then(function () { return IconUmbrellaClosed2$1; }),
  "umbrella-closed": () => Promise.resolve().then(function () { return IconUmbrellaClosed$1; }),
  "umbrella-off": () => Promise.resolve().then(function () { return IconUmbrellaOff$1; }),
  "umbrella": () => Promise.resolve().then(function () { return IconUmbrella$1; }),
  "underline": () => Promise.resolve().then(function () { return IconUnderline$1; }),
  "universe": () => Promise.resolve().then(function () { return IconUniverse$1; }),
  "unlink": () => Promise.resolve().then(function () { return IconUnlink$1; }),
  "upload": () => Promise.resolve().then(function () { return IconUpload$1; }),
  "urgent": () => Promise.resolve().then(function () { return IconUrgent$1; }),
  "usb": () => Promise.resolve().then(function () { return IconUsb$1; }),
  "user-bitcoin": () => Promise.resolve().then(function () { return IconUserBitcoin$1; }),
  "user-bolt": () => Promise.resolve().then(function () { return IconUserBolt$1; }),
  "user-cancel": () => Promise.resolve().then(function () { return IconUserCancel$1; }),
  "user-check": () => Promise.resolve().then(function () { return IconUserCheck$1; }),
  "user-circle": () => Promise.resolve().then(function () { return IconUserCircle$1; }),
  "user-code": () => Promise.resolve().then(function () { return IconUserCode$1; }),
  "user-cog": () => Promise.resolve().then(function () { return IconUserCog$1; }),
  "user-dollar": () => Promise.resolve().then(function () { return IconUserDollar$1; }),
  "user-down": () => Promise.resolve().then(function () { return IconUserDown$1; }),
  "user-edit": () => Promise.resolve().then(function () { return IconUserEdit$1; }),
  "user-exclamation": () => Promise.resolve().then(function () { return IconUserExclamation$1; }),
  "user-heart": () => Promise.resolve().then(function () { return IconUserHeart$1; }),
  "user-hexagon": () => Promise.resolve().then(function () { return IconUserHexagon$1; }),
  "user-minus": () => Promise.resolve().then(function () { return IconUserMinus$1; }),
  "user-off": () => Promise.resolve().then(function () { return IconUserOff$1; }),
  "user-pause": () => Promise.resolve().then(function () { return IconUserPause$1; }),
  "user-pentagon": () => Promise.resolve().then(function () { return IconUserPentagon$1; }),
  "user-pin": () => Promise.resolve().then(function () { return IconUserPin$1; }),
  "user-plus": () => Promise.resolve().then(function () { return IconUserPlus$1; }),
  "user-question": () => Promise.resolve().then(function () { return IconUserQuestion$1; }),
  "user-scan": () => Promise.resolve().then(function () { return IconUserScan$1; }),
  "user-screen": () => Promise.resolve().then(function () { return IconUserScreen$1; }),
  "user-search": () => Promise.resolve().then(function () { return IconUserSearch$1; }),
  "user-share": () => Promise.resolve().then(function () { return IconUserShare$1; }),
  "user-shield": () => Promise.resolve().then(function () { return IconUserShield$1; }),
  "user-square-rounded": () => Promise.resolve().then(function () { return IconUserSquareRounded$1; }),
  "user-square": () => Promise.resolve().then(function () { return IconUserSquare$1; }),
  "user-star": () => Promise.resolve().then(function () { return IconUserStar$1; }),
  "user-up": () => Promise.resolve().then(function () { return IconUserUp$1; }),
  "user-x": () => Promise.resolve().then(function () { return IconUserX$1; }),
  "user": () => Promise.resolve().then(function () { return IconUser$1; }),
  "users-group": () => Promise.resolve().then(function () { return IconUsersGroup$1; }),
  "users-minus": () => Promise.resolve().then(function () { return IconUsersMinus$1; }),
  "users-plus": () => Promise.resolve().then(function () { return IconUsersPlus$1; }),
  "users": () => Promise.resolve().then(function () { return IconUsers$1; }),
  "uv-index": () => Promise.resolve().then(function () { return IconUvIndex$1; }),
  "ux-circle": () => Promise.resolve().then(function () { return IconUxCircle$1; }),
  "vaccine-bottle-off": () => Promise.resolve().then(function () { return IconVaccineBottleOff$1; }),
  "vaccine-bottle": () => Promise.resolve().then(function () { return IconVaccineBottle$1; }),
  "vaccine-off": () => Promise.resolve().then(function () { return IconVaccineOff$1; }),
  "vaccine": () => Promise.resolve().then(function () { return IconVaccine$1; }),
  "vacuum-cleaner": () => Promise.resolve().then(function () { return IconVacuumCleaner$1; }),
  "variable-minus": () => Promise.resolve().then(function () { return IconVariableMinus$1; }),
  "variable-off": () => Promise.resolve().then(function () { return IconVariableOff$1; }),
  "variable-plus": () => Promise.resolve().then(function () { return IconVariablePlus$1; }),
  "variable": () => Promise.resolve().then(function () { return IconVariable$1; }),
  "vector-bezier-2": () => Promise.resolve().then(function () { return IconVectorBezier2$1; }),
  "vector-bezier-arc": () => Promise.resolve().then(function () { return IconVectorBezierArc$1; }),
  "vector-bezier-circle": () => Promise.resolve().then(function () { return IconVectorBezierCircle$1; }),
  "vector-bezier": () => Promise.resolve().then(function () { return IconVectorBezier$1; }),
  "vector-off": () => Promise.resolve().then(function () { return IconVectorOff$1; }),
  "vector-spline": () => Promise.resolve().then(function () { return IconVectorSpline$1; }),
  "vector-triangle-off": () => Promise.resolve().then(function () { return IconVectorTriangleOff$1; }),
  "vector-triangle": () => Promise.resolve().then(function () { return IconVectorTriangle$1; }),
  "vector": () => Promise.resolve().then(function () { return IconVector$1; }),
  "venus": () => Promise.resolve().then(function () { return IconVenus$1; }),
  "versions-off": () => Promise.resolve().then(function () { return IconVersionsOff$1; }),
  "versions": () => Promise.resolve().then(function () { return IconVersions$1; }),
  "video-minus": () => Promise.resolve().then(function () { return IconVideoMinus$1; }),
  "video-off": () => Promise.resolve().then(function () { return IconVideoOff$1; }),
  "video-plus": () => Promise.resolve().then(function () { return IconVideoPlus$1; }),
  "video": () => Promise.resolve().then(function () { return IconVideo$1; }),
  "view-360-arrow": () => Promise.resolve().then(function () { return IconView360Arrow$1; }),
  "view-360-number": () => Promise.resolve().then(function () { return IconView360Number$1; }),
  "view-360-off": () => Promise.resolve().then(function () { return IconView360Off$1; }),
  "view-360": () => Promise.resolve().then(function () { return IconView360$1; }),
  "viewfinder-off": () => Promise.resolve().then(function () { return IconViewfinderOff$1; }),
  "viewfinder": () => Promise.resolve().then(function () { return IconViewfinder$1; }),
  "viewport-narrow": () => Promise.resolve().then(function () { return IconViewportNarrow$1; }),
  "viewport-short": () => Promise.resolve().then(function () { return IconViewportShort$1; }),
  "viewport-tall": () => Promise.resolve().then(function () { return IconViewportTall$1; }),
  "viewport-wide": () => Promise.resolve().then(function () { return IconViewportWide$1; }),
  "vinyl": () => Promise.resolve().then(function () { return IconVinyl$1; }),
  "vip-off": () => Promise.resolve().then(function () { return IconVipOff$1; }),
  "vip": () => Promise.resolve().then(function () { return IconVip$1; }),
  "virus-off": () => Promise.resolve().then(function () { return IconVirusOff$1; }),
  "virus-search": () => Promise.resolve().then(function () { return IconVirusSearch$1; }),
  "virus": () => Promise.resolve().then(function () { return IconVirus$1; }),
  "vocabulary-off": () => Promise.resolve().then(function () { return IconVocabularyOff$1; }),
  "vocabulary": () => Promise.resolve().then(function () { return IconVocabulary$1; }),
  "volcano": () => Promise.resolve().then(function () { return IconVolcano$1; }),
  "volume-2": () => Promise.resolve().then(function () { return IconVolume2$1; }),
  "volume-3": () => Promise.resolve().then(function () { return IconVolume3$1; }),
  "volume-off": () => Promise.resolve().then(function () { return IconVolumeOff$1; }),
  "volume": () => Promise.resolve().then(function () { return IconVolume$1; }),
  "vs": () => Promise.resolve().then(function () { return IconVs$1; }),
  "walk": () => Promise.resolve().then(function () { return IconWalk$1; }),
  "wall-off": () => Promise.resolve().then(function () { return IconWallOff$1; }),
  "wall": () => Promise.resolve().then(function () { return IconWall$1; }),
  "wallet-off": () => Promise.resolve().then(function () { return IconWalletOff$1; }),
  "wallet": () => Promise.resolve().then(function () { return IconWallet$1; }),
  "wallpaper-off": () => Promise.resolve().then(function () { return IconWallpaperOff$1; }),
  "wallpaper": () => Promise.resolve().then(function () { return IconWallpaper$1; }),
  "wand-off": () => Promise.resolve().then(function () { return IconWandOff$1; }),
  "wand": () => Promise.resolve().then(function () { return IconWand$1; }),
  "wash-dry-1": () => Promise.resolve().then(function () { return IconWashDry1$1; }),
  "wash-dry-2": () => Promise.resolve().then(function () { return IconWashDry2$1; }),
  "wash-dry-3": () => Promise.resolve().then(function () { return IconWashDry3$1; }),
  "wash-dry-a": () => Promise.resolve().then(function () { return IconWashDryA$1; }),
  "wash-dry-dip": () => Promise.resolve().then(function () { return IconWashDryDip$1; }),
  "wash-dry-f": () => Promise.resolve().then(function () { return IconWashDryF$1; }),
  "wash-dry-flat": () => Promise.resolve().then(function () { return IconWashDryFlat$1; }),
  "wash-dry-hang": () => Promise.resolve().then(function () { return IconWashDryHang$1; }),
  "wash-dry-off": () => Promise.resolve().then(function () { return IconWashDryOff$1; }),
  "wash-dry-p": () => Promise.resolve().then(function () { return IconWashDryP$1; }),
  "wash-dry-shade": () => Promise.resolve().then(function () { return IconWashDryShade$1; }),
  "wash-dry-w": () => Promise.resolve().then(function () { return IconWashDryW$1; }),
  "wash-dry": () => Promise.resolve().then(function () { return IconWashDry$1; }),
  "wash-dryclean-off": () => Promise.resolve().then(function () { return IconWashDrycleanOff$1; }),
  "wash-dryclean": () => Promise.resolve().then(function () { return IconWashDryclean$1; }),
  "wash-eco": () => Promise.resolve().then(function () { return IconWashEco$1; }),
  "wash-gentle": () => Promise.resolve().then(function () { return IconWashGentle$1; }),
  "wash-hand": () => Promise.resolve().then(function () { return IconWashHand$1; }),
  "wash-machine": () => Promise.resolve().then(function () { return IconWashMachine$1; }),
  "wash-off": () => Promise.resolve().then(function () { return IconWashOff$1; }),
  "wash-press": () => Promise.resolve().then(function () { return IconWashPress$1; }),
  "wash-temperature-1": () => Promise.resolve().then(function () { return IconWashTemperature1$1; }),
  "wash-temperature-2": () => Promise.resolve().then(function () { return IconWashTemperature2$1; }),
  "wash-temperature-3": () => Promise.resolve().then(function () { return IconWashTemperature3$1; }),
  "wash-temperature-4": () => Promise.resolve().then(function () { return IconWashTemperature4$1; }),
  "wash-temperature-5": () => Promise.resolve().then(function () { return IconWashTemperature5$1; }),
  "wash-temperature-6": () => Promise.resolve().then(function () { return IconWashTemperature6$1; }),
  "wash-tumble-dry": () => Promise.resolve().then(function () { return IconWashTumbleDry$1; }),
  "wash-tumble-off": () => Promise.resolve().then(function () { return IconWashTumbleOff$1; }),
  "wash": () => Promise.resolve().then(function () { return IconWash$1; }),
  "waterpolo": () => Promise.resolve().then(function () { return IconWaterpolo$1; }),
  "wave-saw-tool": () => Promise.resolve().then(function () { return IconWaveSawTool$1; }),
  "wave-sine": () => Promise.resolve().then(function () { return IconWaveSine$1; }),
  "wave-square": () => Promise.resolve().then(function () { return IconWaveSquare$1; }),
  "waves-electricity": () => Promise.resolve().then(function () { return IconWavesElectricity$1; }),
  "webhook-off": () => Promise.resolve().then(function () { return IconWebhookOff$1; }),
  "webhook": () => Promise.resolve().then(function () { return IconWebhook$1; }),
  "weight": () => Promise.resolve().then(function () { return IconWeight$1; }),
  "wheat-off": () => Promise.resolve().then(function () { return IconWheatOff$1; }),
  "wheat": () => Promise.resolve().then(function () { return IconWheat$1; }),
  "wheel": () => Promise.resolve().then(function () { return IconWheel$1; }),
  "wheelchair-off": () => Promise.resolve().then(function () { return IconWheelchairOff$1; }),
  "wheelchair": () => Promise.resolve().then(function () { return IconWheelchair$1; }),
  "whirl": () => Promise.resolve().then(function () { return IconWhirl$1; }),
  "wifi-0": () => Promise.resolve().then(function () { return IconWifi0$1; }),
  "wifi-1": () => Promise.resolve().then(function () { return IconWifi1$1; }),
  "wifi-2": () => Promise.resolve().then(function () { return IconWifi2$1; }),
  "wifi-off": () => Promise.resolve().then(function () { return IconWifiOff$1; }),
  "wifi": () => Promise.resolve().then(function () { return IconWifi$1; }),
  "wind-electricity": () => Promise.resolve().then(function () { return IconWindElectricity$1; }),
  "wind-off": () => Promise.resolve().then(function () { return IconWindOff$1; }),
  "wind": () => Promise.resolve().then(function () { return IconWind$1; }),
  "windmill-off": () => Promise.resolve().then(function () { return IconWindmillOff$1; }),
  "windmill": () => Promise.resolve().then(function () { return IconWindmill$1; }),
  "window-maximize": () => Promise.resolve().then(function () { return IconWindowMaximize$1; }),
  "window-minimize": () => Promise.resolve().then(function () { return IconWindowMinimize$1; }),
  "window-off": () => Promise.resolve().then(function () { return IconWindowOff$1; }),
  "window": () => Promise.resolve().then(function () { return IconWindow$1; }),
  "windsock": () => Promise.resolve().then(function () { return IconWindsock$1; }),
  "wiper-wash": () => Promise.resolve().then(function () { return IconWiperWash$1; }),
  "wiper": () => Promise.resolve().then(function () { return IconWiper$1; }),
  "woman": () => Promise.resolve().then(function () { return IconWoman$1; }),
  "wood": () => Promise.resolve().then(function () { return IconWood$1; }),
  "world-bolt": () => Promise.resolve().then(function () { return IconWorldBolt$1; }),
  "world-cancel": () => Promise.resolve().then(function () { return IconWorldCancel$1; }),
  "world-check": () => Promise.resolve().then(function () { return IconWorldCheck$1; }),
  "world-code": () => Promise.resolve().then(function () { return IconWorldCode$1; }),
  "world-cog": () => Promise.resolve().then(function () { return IconWorldCog$1; }),
  "world-dollar": () => Promise.resolve().then(function () { return IconWorldDollar$1; }),
  "world-down": () => Promise.resolve().then(function () { return IconWorldDown$1; }),
  "world-download": () => Promise.resolve().then(function () { return IconWorldDownload$1; }),
  "world-exclamation": () => Promise.resolve().then(function () { return IconWorldExclamation$1; }),
  "world-heart": () => Promise.resolve().then(function () { return IconWorldHeart$1; }),
  "world-latitude": () => Promise.resolve().then(function () { return IconWorldLatitude$1; }),
  "world-longitude": () => Promise.resolve().then(function () { return IconWorldLongitude$1; }),
  "world-minus": () => Promise.resolve().then(function () { return IconWorldMinus$1; }),
  "world-off": () => Promise.resolve().then(function () { return IconWorldOff$1; }),
  "world-pause": () => Promise.resolve().then(function () { return IconWorldPause$1; }),
  "world-pin": () => Promise.resolve().then(function () { return IconWorldPin$1; }),
  "world-plus": () => Promise.resolve().then(function () { return IconWorldPlus$1; }),
  "world-question": () => Promise.resolve().then(function () { return IconWorldQuestion$1; }),
  "world-search": () => Promise.resolve().then(function () { return IconWorldSearch$1; }),
  "world-share": () => Promise.resolve().then(function () { return IconWorldShare$1; }),
  "world-star": () => Promise.resolve().then(function () { return IconWorldStar$1; }),
  "world-up": () => Promise.resolve().then(function () { return IconWorldUp$1; }),
  "world-upload": () => Promise.resolve().then(function () { return IconWorldUpload$1; }),
  "world-www": () => Promise.resolve().then(function () { return IconWorldWww$1; }),
  "world-x": () => Promise.resolve().then(function () { return IconWorldX$1; }),
  "world": () => Promise.resolve().then(function () { return IconWorld$1; }),
  "wrecking-ball": () => Promise.resolve().then(function () { return IconWreckingBall$1; }),
  "writing-off": () => Promise.resolve().then(function () { return IconWritingOff$1; }),
  "writing-sign-off": () => Promise.resolve().then(function () { return IconWritingSignOff$1; }),
  "writing-sign": () => Promise.resolve().then(function () { return IconWritingSign$1; }),
  "writing": () => Promise.resolve().then(function () { return IconWriting$1; }),
  "x-power-y": () => Promise.resolve().then(function () { return IconXPowerY$1; }),
  "x": () => Promise.resolve().then(function () { return IconX$1; }),
  "xbox-a": () => Promise.resolve().then(function () { return IconXboxA$1; }),
  "xbox-b": () => Promise.resolve().then(function () { return IconXboxB$1; }),
  "xbox-x": () => Promise.resolve().then(function () { return IconXboxX$1; }),
  "xbox-y": () => Promise.resolve().then(function () { return IconXboxY$1; }),
  "xd": () => Promise.resolve().then(function () { return IconXd$1; }),
  "xxx": () => Promise.resolve().then(function () { return IconXxx$1; }),
  "yin-yang": () => Promise.resolve().then(function () { return IconYinYang$1; }),
  "yoga": () => Promise.resolve().then(function () { return IconYoga$1; }),
  "zeppelin-off": () => Promise.resolve().then(function () { return IconZeppelinOff$1; }),
  "zeppelin": () => Promise.resolve().then(function () { return IconZeppelin$1; }),
  "zip": () => Promise.resolve().then(function () { return IconZip$1; }),
  "zodiac-aquarius": () => Promise.resolve().then(function () { return IconZodiacAquarius$1; }),
  "zodiac-aries": () => Promise.resolve().then(function () { return IconZodiacAries$1; }),
  "zodiac-cancer": () => Promise.resolve().then(function () { return IconZodiacCancer$1; }),
  "zodiac-capricorn": () => Promise.resolve().then(function () { return IconZodiacCapricorn$1; }),
  "zodiac-gemini": () => Promise.resolve().then(function () { return IconZodiacGemini$1; }),
  "zodiac-leo": () => Promise.resolve().then(function () { return IconZodiacLeo$1; }),
  "zodiac-libra": () => Promise.resolve().then(function () { return IconZodiacLibra$1; }),
  "zodiac-pisces": () => Promise.resolve().then(function () { return IconZodiacPisces$1; }),
  "zodiac-sagittarius": () => Promise.resolve().then(function () { return IconZodiacSagittarius$1; }),
  "zodiac-scorpio": () => Promise.resolve().then(function () { return IconZodiacScorpio$1; }),
  "zodiac-taurus": () => Promise.resolve().then(function () { return IconZodiacTaurus$1; }),
  "zodiac-virgo": () => Promise.resolve().then(function () { return IconZodiacVirgo$1; }),
  "zoom-cancel": () => Promise.resolve().then(function () { return IconZoomCancel$1; }),
  "zoom-check": () => Promise.resolve().then(function () { return IconZoomCheck$1; }),
  "zoom-code": () => Promise.resolve().then(function () { return IconZoomCode$1; }),
  "zoom-exclamation": () => Promise.resolve().then(function () { return IconZoomExclamation$1; }),
  "zoom-in-area": () => Promise.resolve().then(function () { return IconZoomInArea$1; }),
  "zoom-in": () => Promise.resolve().then(function () { return IconZoomIn$1; }),
  "zoom-money": () => Promise.resolve().then(function () { return IconZoomMoney$1; }),
  "zoom-out-area": () => Promise.resolve().then(function () { return IconZoomOutArea$1; }),
  "zoom-out": () => Promise.resolve().then(function () { return IconZoomOut$1; }),
  "zoom-pan": () => Promise.resolve().then(function () { return IconZoomPan$1; }),
  "zoom-question": () => Promise.resolve().then(function () { return IconZoomQuestion$1; }),
  "zoom-replace": () => Promise.resolve().then(function () { return IconZoomReplace$1; }),
  "zoom-reset": () => Promise.resolve().then(function () { return IconZoomReset$1; }),
  "zoom-scan": () => Promise.resolve().then(function () { return IconZoomScan$1; }),
  "zoom": () => Promise.resolve().then(function () { return IconZoom$1; }),
  "zzz-off": () => Promise.resolve().then(function () { return IconZzzOff$1; }),
  "zzz": () => Promise.resolve().then(function () { return IconZzz$1; }),
  "accessible-filled": () => Promise.resolve().then(function () { return IconAccessibleFilled$1; }),
  "ad-circle-filled": () => Promise.resolve().then(function () { return IconAdCircleFilled$1; }),
  "ad-filled": () => Promise.resolve().then(function () { return IconAdFilled$1; }),
  "adjustments-filled": () => Promise.resolve().then(function () { return IconAdjustmentsFilled$1; }),
  "aerial-lift-filled": () => Promise.resolve().then(function () { return IconAerialLiftFilled$1; }),
  "affiliate-filled": () => Promise.resolve().then(function () { return IconAffiliateFilled$1; }),
  "air-balloon-filled": () => Promise.resolve().then(function () { return IconAirBalloonFilled$1; }),
  "alarm-minus-filled": () => Promise.resolve().then(function () { return IconAlarmMinusFilled$1; }),
  "alarm-plus-filled": () => Promise.resolve().then(function () { return IconAlarmPlusFilled$1; }),
  "alarm-snooze-filled": () => Promise.resolve().then(function () { return IconAlarmSnoozeFilled$1; }),
  "alarm-filled": () => Promise.resolve().then(function () { return IconAlarmFilled$1; }),
  "alert-circle-filled": () => Promise.resolve().then(function () { return IconAlertCircleFilled$1; }),
  "alert-hexagon-filled": () => Promise.resolve().then(function () { return IconAlertHexagonFilled$1; }),
  "alert-octagon-filled": () => Promise.resolve().then(function () { return IconAlertOctagonFilled$1; }),
  "alert-square-rounded-filled": () => Promise.resolve().then(function () { return IconAlertSquareRoundedFilled$1; }),
  "alert-square-filled": () => Promise.resolve().then(function () { return IconAlertSquareFilled$1; }),
  "alert-triangle-filled": () => Promise.resolve().then(function () { return IconAlertTriangleFilled$1; }),
  "alien-filled": () => Promise.resolve().then(function () { return IconAlienFilled$1; }),
  "align-box-bottom-center-filled": () => Promise.resolve().then(function () { return IconAlignBoxBottomCenterFilled$1; }),
  "align-box-bottom-left-filled": () => Promise.resolve().then(function () { return IconAlignBoxBottomLeftFilled$1; }),
  "align-box-bottom-right-filled": () => Promise.resolve().then(function () { return IconAlignBoxBottomRightFilled$1; }),
  "align-box-center-middle-filled": () => Promise.resolve().then(function () { return IconAlignBoxCenterMiddleFilled$1; }),
  "align-box-left-bottom-filled": () => Promise.resolve().then(function () { return IconAlignBoxLeftBottomFilled$1; }),
  "align-box-left-middle-filled": () => Promise.resolve().then(function () { return IconAlignBoxLeftMiddleFilled$1; }),
  "align-box-left-top-filled": () => Promise.resolve().then(function () { return IconAlignBoxLeftTopFilled$1; }),
  "align-box-right-bottom-filled": () => Promise.resolve().then(function () { return IconAlignBoxRightBottomFilled$1; }),
  "align-box-right-middle-filled": () => Promise.resolve().then(function () { return IconAlignBoxRightMiddleFilled$1; }),
  "align-box-right-top-filled": () => Promise.resolve().then(function () { return IconAlignBoxRightTopFilled$1; }),
  "align-box-top-center-filled": () => Promise.resolve().then(function () { return IconAlignBoxTopCenterFilled$1; }),
  "align-box-top-left-filled": () => Promise.resolve().then(function () { return IconAlignBoxTopLeftFilled$1; }),
  "align-box-top-right-filled": () => Promise.resolve().then(function () { return IconAlignBoxTopRightFilled$1; }),
  "analyze-filled": () => Promise.resolve().then(function () { return IconAnalyzeFilled$1; }),
  "app-window-filled": () => Promise.resolve().then(function () { return IconAppWindowFilled$1; }),
  "apple-filled": () => Promise.resolve().then(function () { return IconAppleFilled$1; }),
  "apps-filled": () => Promise.resolve().then(function () { return IconAppsFilled$1; }),
  "archive-filled": () => Promise.resolve().then(function () { return IconArchiveFilled$1; }),
  "arrow-autofit-content-filled": () => Promise.resolve().then(function () { return IconArrowAutofitContentFilled$1; }),
  "arrow-autofit-down-filled": () => Promise.resolve().then(function () { return IconArrowAutofitDownFilled$1; }),
  "arrow-autofit-height-filled": () => Promise.resolve().then(function () { return IconArrowAutofitHeightFilled$1; }),
  "arrow-autofit-left-filled": () => Promise.resolve().then(function () { return IconArrowAutofitLeftFilled$1; }),
  "arrow-autofit-right-filled": () => Promise.resolve().then(function () { return IconArrowAutofitRightFilled$1; }),
  "arrow-autofit-up-filled": () => Promise.resolve().then(function () { return IconArrowAutofitUpFilled$1; }),
  "arrow-autofit-width-filled": () => Promise.resolve().then(function () { return IconArrowAutofitWidthFilled$1; }),
  "arrow-badge-down-filled": () => Promise.resolve().then(function () { return IconArrowBadgeDownFilled$1; }),
  "arrow-badge-left-filled": () => Promise.resolve().then(function () { return IconArrowBadgeLeftFilled$1; }),
  "arrow-badge-right-filled": () => Promise.resolve().then(function () { return IconArrowBadgeRightFilled$1; }),
  "arrow-badge-up-filled": () => Promise.resolve().then(function () { return IconArrowBadgeUpFilled$1; }),
  "arrow-big-down-line-filled": () => Promise.resolve().then(function () { return IconArrowBigDownLineFilled$1; }),
  "arrow-big-down-lines-filled": () => Promise.resolve().then(function () { return IconArrowBigDownLinesFilled$1; }),
  "arrow-big-down-filled": () => Promise.resolve().then(function () { return IconArrowBigDownFilled$1; }),
  "arrow-big-left-line-filled": () => Promise.resolve().then(function () { return IconArrowBigLeftLineFilled$1; }),
  "arrow-big-left-lines-filled": () => Promise.resolve().then(function () { return IconArrowBigLeftLinesFilled$1; }),
  "arrow-big-left-filled": () => Promise.resolve().then(function () { return IconArrowBigLeftFilled$1; }),
  "arrow-big-right-line-filled": () => Promise.resolve().then(function () { return IconArrowBigRightLineFilled$1; }),
  "arrow-big-right-lines-filled": () => Promise.resolve().then(function () { return IconArrowBigRightLinesFilled$1; }),
  "arrow-big-right-filled": () => Promise.resolve().then(function () { return IconArrowBigRightFilled$1; }),
  "arrow-big-up-line-filled": () => Promise.resolve().then(function () { return IconArrowBigUpLineFilled$1; }),
  "arrow-big-up-lines-filled": () => Promise.resolve().then(function () { return IconArrowBigUpLinesFilled$1; }),
  "arrow-big-up-filled": () => Promise.resolve().then(function () { return IconArrowBigUpFilled$1; }),
  "arrow-down-circle-filled": () => Promise.resolve().then(function () { return IconArrowDownCircleFilled$1; }),
  "arrow-down-rhombus-filled": () => Promise.resolve().then(function () { return IconArrowDownRhombusFilled$1; }),
  "arrow-down-square-filled": () => Promise.resolve().then(function () { return IconArrowDownSquareFilled$1; }),
  "arrow-guide-filled": () => Promise.resolve().then(function () { return IconArrowGuideFilled$1; }),
  "arrow-left-circle-filled": () => Promise.resolve().then(function () { return IconArrowLeftCircleFilled$1; }),
  "arrow-left-rhombus-filled": () => Promise.resolve().then(function () { return IconArrowLeftRhombusFilled$1; }),
  "arrow-left-square-filled": () => Promise.resolve().then(function () { return IconArrowLeftSquareFilled$1; }),
  "arrow-move-down-filled": () => Promise.resolve().then(function () { return IconArrowMoveDownFilled$1; }),
  "arrow-move-left-filled": () => Promise.resolve().then(function () { return IconArrowMoveLeftFilled$1; }),
  "arrow-move-right-filled": () => Promise.resolve().then(function () { return IconArrowMoveRightFilled$1; }),
  "arrow-move-up-filled": () => Promise.resolve().then(function () { return IconArrowMoveUpFilled$1; }),
  "arrow-right-circle-filled": () => Promise.resolve().then(function () { return IconArrowRightCircleFilled$1; }),
  "arrow-right-rhombus-filled": () => Promise.resolve().then(function () { return IconArrowRightRhombusFilled$1; }),
  "arrow-right-square-filled": () => Promise.resolve().then(function () { return IconArrowRightSquareFilled$1; }),
  "arrow-up-circle-filled": () => Promise.resolve().then(function () { return IconArrowUpCircleFilled$1; }),
  "arrow-up-rhombus-filled": () => Promise.resolve().then(function () { return IconArrowUpRhombusFilled$1; }),
  "arrow-up-square-filled": () => Promise.resolve().then(function () { return IconArrowUpSquareFilled$1; }),
  "artboard-filled": () => Promise.resolve().then(function () { return IconArtboardFilled$1; }),
  "article-filled": () => Promise.resolve().then(function () { return IconArticleFilled$1; }),
  "aspect-ratio-filled": () => Promise.resolve().then(function () { return IconAspectRatioFilled$1; }),
  "assembly-filled": () => Promise.resolve().then(function () { return IconAssemblyFilled$1; }),
  "asset-filled": () => Promise.resolve().then(function () { return IconAssetFilled$1; }),
  "atom-2-filled": () => Promise.resolve().then(function () { return IconAtom2Filled$1; }),
  "automatic-gearbox-filled": () => Promise.resolve().then(function () { return IconAutomaticGearboxFilled$1; }),
  "award-filled": () => Promise.resolve().then(function () { return IconAwardFilled$1; }),
  "baby-carriage-filled": () => Promise.resolve().then(function () { return IconBabyCarriageFilled$1; }),
  "backspace-filled": () => Promise.resolve().then(function () { return IconBackspaceFilled$1; }),
  "badge-3d-filled": () => Promise.resolve().then(function () { return IconBadge3dFilled$1; }),
  "badge-4k-filled": () => Promise.resolve().then(function () { return IconBadge4kFilled$1; }),
  "badge-8k-filled": () => Promise.resolve().then(function () { return IconBadge8kFilled$1; }),
  "badge-ad-filled": () => Promise.resolve().then(function () { return IconBadgeAdFilled$1; }),
  "badge-ar-filled": () => Promise.resolve().then(function () { return IconBadgeArFilled$1; }),
  "badge-cc-filled": () => Promise.resolve().then(function () { return IconBadgeCcFilled$1; }),
  "badge-hd-filled": () => Promise.resolve().then(function () { return IconBadgeHdFilled$1; }),
  "badge-sd-filled": () => Promise.resolve().then(function () { return IconBadgeSdFilled$1; }),
  "badge-tm-filled": () => Promise.resolve().then(function () { return IconBadgeTmFilled$1; }),
  "badge-vo-filled": () => Promise.resolve().then(function () { return IconBadgeVoFilled$1; }),
  "badge-vr-filled": () => Promise.resolve().then(function () { return IconBadgeVrFilled$1; }),
  "badge-wc-filled": () => Promise.resolve().then(function () { return IconBadgeWcFilled$1; }),
  "badge-filled": () => Promise.resolve().then(function () { return IconBadgeFilled$1; }),
  "badges-filled": () => Promise.resolve().then(function () { return IconBadgesFilled$1; }),
  "balloon-filled": () => Promise.resolve().then(function () { return IconBalloonFilled$1; }),
  "ballpen-filled": () => Promise.resolve().then(function () { return IconBallpenFilled$1; }),
  "bandage-filled": () => Promise.resolve().then(function () { return IconBandageFilled$1; }),
  "barbell-filled": () => Promise.resolve().then(function () { return IconBarbellFilled$1; }),
  "barrier-block-filled": () => Promise.resolve().then(function () { return IconBarrierBlockFilled$1; }),
  "basket-filled": () => Promise.resolve().then(function () { return IconBasketFilled$1; }),
  "bath-filled": () => Promise.resolve().then(function () { return IconBathFilled$1; }),
  "battery-1-filled": () => Promise.resolve().then(function () { return IconBattery1Filled$1; }),
  "battery-2-filled": () => Promise.resolve().then(function () { return IconBattery2Filled$1; }),
  "battery-3-filled": () => Promise.resolve().then(function () { return IconBattery3Filled$1; }),
  "battery-4-filled": () => Promise.resolve().then(function () { return IconBattery4Filled$1; }),
  "battery-automotive-filled": () => Promise.resolve().then(function () { return IconBatteryAutomotiveFilled$1; }),
  "battery-vertical-1-filled": () => Promise.resolve().then(function () { return IconBatteryVertical1Filled$1; }),
  "battery-vertical-2-filled": () => Promise.resolve().then(function () { return IconBatteryVertical2Filled$1; }),
  "battery-vertical-3-filled": () => Promise.resolve().then(function () { return IconBatteryVertical3Filled$1; }),
  "battery-vertical-4-filled": () => Promise.resolve().then(function () { return IconBatteryVertical4Filled$1; }),
  "battery-vertical-filled": () => Promise.resolve().then(function () { return IconBatteryVerticalFilled$1; }),
  "battery-filled": () => Promise.resolve().then(function () { return IconBatteryFilled$1; }),
  "bed-flat-filled": () => Promise.resolve().then(function () { return IconBedFlatFilled$1; }),
  "bed-filled": () => Promise.resolve().then(function () { return IconBedFilled$1; }),
  "beer-filled": () => Promise.resolve().then(function () { return IconBeerFilled$1; }),
  "bell-minus-filled": () => Promise.resolve().then(function () { return IconBellMinusFilled$1; }),
  "bell-plus-filled": () => Promise.resolve().then(function () { return IconBellPlusFilled$1; }),
  "bell-ringing-2-filled": () => Promise.resolve().then(function () { return IconBellRinging2Filled$1; }),
  "bell-ringing-filled": () => Promise.resolve().then(function () { return IconBellRingingFilled$1; }),
  "bell-x-filled": () => Promise.resolve().then(function () { return IconBellXFilled$1; }),
  "bell-z-filled": () => Promise.resolve().then(function () { return IconBellZFilled$1; }),
  "bell-filled": () => Promise.resolve().then(function () { return IconBellFilled$1; }),
  "bike-filled": () => Promise.resolve().then(function () { return IconBikeFilled$1; }),
  "binary-tree-2-filled": () => Promise.resolve().then(function () { return IconBinaryTree2Filled$1; }),
  "binary-tree-filled": () => Promise.resolve().then(function () { return IconBinaryTreeFilled$1; }),
  "binoculars-filled": () => Promise.resolve().then(function () { return IconBinocularsFilled$1; }),
  "biohazard-filled": () => Promise.resolve().then(function () { return IconBiohazardFilled$1; }),
  "blade-filled": () => Promise.resolve().then(function () { return IconBladeFilled$1; }),
  "blender-filled": () => Promise.resolve().then(function () { return IconBlenderFilled$1; }),
  "blob-filled": () => Promise.resolve().then(function () { return IconBlobFilled$1; }),
  "bolt-filled": () => Promise.resolve().then(function () { return IconBoltFilled$1; }),
  "bomb-filled": () => Promise.resolve().then(function () { return IconBombFilled$1; }),
  "bone-filled": () => Promise.resolve().then(function () { return IconBoneFilled$1; }),
  "bong-filled": () => Promise.resolve().then(function () { return IconBongFilled$1; }),
  "book-filled": () => Promise.resolve().then(function () { return IconBookFilled$1; }),
  "bookmark-filled": () => Promise.resolve().then(function () { return IconBookmarkFilled$1; }),
  "bookmarks-filled": () => Promise.resolve().then(function () { return IconBookmarksFilled$1; }),
  "boom-filled": () => Promise.resolve().then(function () { return IconBoomFilled$1; }),
  "bottle-filled": () => Promise.resolve().then(function () { return IconBottleFilled$1; }),
  "bounce-left-filled": () => Promise.resolve().then(function () { return IconBounceLeftFilled$1; }),
  "bounce-right-filled": () => Promise.resolve().then(function () { return IconBounceRightFilled$1; }),
  "bow-filled": () => Promise.resolve().then(function () { return IconBowFilled$1; }),
  "bowl-chopsticks-filled": () => Promise.resolve().then(function () { return IconBowlChopsticksFilled$1; }),
  "bowl-spoon-filled": () => Promise.resolve().then(function () { return IconBowlSpoonFilled$1; }),
  "bowl-filled": () => Promise.resolve().then(function () { return IconBowlFilled$1; }),
  "box-align-bottom-left-filled": () => Promise.resolve().then(function () { return IconBoxAlignBottomLeftFilled$1; }),
  "box-align-bottom-right-filled": () => Promise.resolve().then(function () { return IconBoxAlignBottomRightFilled$1; }),
  "box-align-bottom-filled": () => Promise.resolve().then(function () { return IconBoxAlignBottomFilled$1; }),
  "box-align-left-filled": () => Promise.resolve().then(function () { return IconBoxAlignLeftFilled$1; }),
  "box-align-right-filled": () => Promise.resolve().then(function () { return IconBoxAlignRightFilled$1; }),
  "box-align-top-left-filled": () => Promise.resolve().then(function () { return IconBoxAlignTopLeftFilled$1; }),
  "box-align-top-right-filled": () => Promise.resolve().then(function () { return IconBoxAlignTopRightFilled$1; }),
  "box-align-top-filled": () => Promise.resolve().then(function () { return IconBoxAlignTopFilled$1; }),
  "box-multiple-filled": () => Promise.resolve().then(function () { return IconBoxMultipleFilled$1; }),
  "brand-angular-filled": () => Promise.resolve().then(function () { return IconBrandAngularFilled$1; }),
  "brand-apple-filled": () => Promise.resolve().then(function () { return IconBrandAppleFilled$1; }),
  "brand-bitbucket-filled": () => Promise.resolve().then(function () { return IconBrandBitbucketFilled$1; }),
  "brand-discord-filled": () => Promise.resolve().then(function () { return IconBrandDiscordFilled$1; }),
  "brand-dribbble-filled": () => Promise.resolve().then(function () { return IconBrandDribbbleFilled$1; }),
  "brand-facebook-filled": () => Promise.resolve().then(function () { return IconBrandFacebookFilled$1; }),
  "brand-github-filled": () => Promise.resolve().then(function () { return IconBrandGithubFilled$1; }),
  "brand-google-filled": () => Promise.resolve().then(function () { return IconBrandGoogleFilled$1; }),
  "brand-instagram-filled": () => Promise.resolve().then(function () { return IconBrandInstagramFilled$1; }),
  "brand-kick-filled": () => Promise.resolve().then(function () { return IconBrandKickFilled$1; }),
  "brand-linkedin-filled": () => Promise.resolve().then(function () { return IconBrandLinkedinFilled$1; }),
  "brand-messenger-filled": () => Promise.resolve().then(function () { return IconBrandMessengerFilled$1; }),
  "brand-open-source-filled": () => Promise.resolve().then(function () { return IconBrandOpenSourceFilled$1; }),
  "brand-opera-filled": () => Promise.resolve().then(function () { return IconBrandOperaFilled$1; }),
  "brand-patreon-filled": () => Promise.resolve().then(function () { return IconBrandPatreonFilled$1; }),
  "brand-paypal-filled": () => Promise.resolve().then(function () { return IconBrandPaypalFilled$1; }),
  "brand-pinterest-filled": () => Promise.resolve().then(function () { return IconBrandPinterestFilled$1; }),
  "brand-sketch-filled": () => Promise.resolve().then(function () { return IconBrandSketchFilled$1; }),
  "brand-snapchat-filled": () => Promise.resolve().then(function () { return IconBrandSnapchatFilled$1; }),
  "brand-spotify-filled": () => Promise.resolve().then(function () { return IconBrandSpotifyFilled$1; }),
  "brand-steam-filled": () => Promise.resolve().then(function () { return IconBrandSteamFilled$1; }),
  "brand-stripe-filled": () => Promise.resolve().then(function () { return IconBrandStripeFilled$1; }),
  "brand-tabler-filled": () => Promise.resolve().then(function () { return IconBrandTablerFilled$1; }),
  "brand-tiktok-filled": () => Promise.resolve().then(function () { return IconBrandTiktokFilled$1; }),
  "brand-tinder-filled": () => Promise.resolve().then(function () { return IconBrandTinderFilled$1; }),
  "brand-tumblr-filled": () => Promise.resolve().then(function () { return IconBrandTumblrFilled$1; }),
  "brand-twitter-filled": () => Promise.resolve().then(function () { return IconBrandTwitterFilled$1; }),
  "brand-vercel-filled": () => Promise.resolve().then(function () { return IconBrandVercelFilled$1; }),
  "brand-vimeo-filled": () => Promise.resolve().then(function () { return IconBrandVimeoFilled$1; }),
  "brand-weibo-filled": () => Promise.resolve().then(function () { return IconBrandWeiboFilled$1; }),
  "brand-whatsapp-filled": () => Promise.resolve().then(function () { return IconBrandWhatsappFilled$1; }),
  "brand-windows-filled": () => Promise.resolve().then(function () { return IconBrandWindowsFilled$1; }),
  "brand-x-filled": () => Promise.resolve().then(function () { return IconBrandXFilled$1; }),
  "brand-youtube-filled": () => Promise.resolve().then(function () { return IconBrandYoutubeFilled$1; }),
  "bread-filled": () => Promise.resolve().then(function () { return IconBreadFilled$1; }),
  "briefcase-2-filled": () => Promise.resolve().then(function () { return IconBriefcase2Filled$1; }),
  "briefcase-filled": () => Promise.resolve().then(function () { return IconBriefcaseFilled$1; }),
  "brightness-auto-filled": () => Promise.resolve().then(function () { return IconBrightnessAutoFilled$1; }),
  "brightness-down-filled": () => Promise.resolve().then(function () { return IconBrightnessDownFilled$1; }),
  "brightness-up-filled": () => Promise.resolve().then(function () { return IconBrightnessUpFilled$1; }),
  "brightness-filled": () => Promise.resolve().then(function () { return IconBrightnessFilled$1; }),
  "bubble-text-filled": () => Promise.resolve().then(function () { return IconBubbleTextFilled$1; }),
  "bubble-filled": () => Promise.resolve().then(function () { return IconBubbleFilled$1; }),
  "bug-filled": () => Promise.resolve().then(function () { return IconBugFilled$1; }),
  "building-broadcast-tower-filled": () => Promise.resolve().then(function () { return IconBuildingBroadcastTowerFilled$1; }),
  "bulb-filled": () => Promise.resolve().then(function () { return IconBulbFilled$1; }),
  "bus-filled": () => Promise.resolve().then(function () { return IconBusFilled$1; }),
  "butterfly-filled": () => Promise.resolve().then(function () { return IconButterflyFilled$1; }),
  "cactus-filled": () => Promise.resolve().then(function () { return IconCactusFilled$1; }),
  "calculator-filled": () => Promise.resolve().then(function () { return IconCalculatorFilled$1; }),
  "calendar-event-filled": () => Promise.resolve().then(function () { return IconCalendarEventFilled$1; }),
  "calendar-month-filled": () => Promise.resolve().then(function () { return IconCalendarMonthFilled$1; }),
  "calendar-week-filled": () => Promise.resolve().then(function () { return IconCalendarWeekFilled$1; }),
  "calendar-filled": () => Promise.resolve().then(function () { return IconCalendarFilled$1; }),
  "camera-filled": () => Promise.resolve().then(function () { return IconCameraFilled$1; }),
  "campfire-filled": () => Promise.resolve().then(function () { return IconCampfireFilled$1; }),
  "candle-filled": () => Promise.resolve().then(function () { return IconCandleFilled$1; }),
  "cannabis-filled": () => Promise.resolve().then(function () { return IconCannabisFilled$1; }),
  "capsule-horizontal-filled": () => Promise.resolve().then(function () { return IconCapsuleHorizontalFilled$1; }),
  "capsule-filled": () => Promise.resolve().then(function () { return IconCapsuleFilled$1; }),
  "capture-filled": () => Promise.resolve().then(function () { return IconCaptureFilled$1; }),
  "car-4wd-filled": () => Promise.resolve().then(function () { return IconCar4wdFilled$1; }),
  "car-crane-filled": () => Promise.resolve().then(function () { return IconCarCraneFilled$1; }),
  "car-fan-filled": () => Promise.resolve().then(function () { return IconCarFanFilled$1; }),
  "car-suv-filled": () => Promise.resolve().then(function () { return IconCarSuvFilled$1; }),
  "car-filled": () => Promise.resolve().then(function () { return IconCarFilled$1; }),
  "carambola-filled": () => Promise.resolve().then(function () { return IconCarambolaFilled$1; }),
  "caravan-filled": () => Promise.resolve().then(function () { return IconCaravanFilled$1; }),
  "cardboards-filled": () => Promise.resolve().then(function () { return IconCardboardsFilled$1; }),
  "cards-filled": () => Promise.resolve().then(function () { return IconCardsFilled$1; }),
  "caret-down-filled": () => Promise.resolve().then(function () { return IconCaretDownFilled$1; }),
  "caret-left-right-filled": () => Promise.resolve().then(function () { return IconCaretLeftRightFilled$1; }),
  "caret-left-filled": () => Promise.resolve().then(function () { return IconCaretLeftFilled$1; }),
  "caret-right-filled": () => Promise.resolve().then(function () { return IconCaretRightFilled$1; }),
  "caret-up-down-filled": () => Promise.resolve().then(function () { return IconCaretUpDownFilled$1; }),
  "caret-up-filled": () => Promise.resolve().then(function () { return IconCaretUpFilled$1; }),
  "carousel-horizontal-filled": () => Promise.resolve().then(function () { return IconCarouselHorizontalFilled$1; }),
  "carousel-vertical-filled": () => Promise.resolve().then(function () { return IconCarouselVerticalFilled$1; }),
  "cash-banknote-filled": () => Promise.resolve().then(function () { return IconCashBanknoteFilled$1; }),
  "category-filled": () => Promise.resolve().then(function () { return IconCategoryFilled$1; }),
  "charging-pile-filled": () => Promise.resolve().then(function () { return IconChargingPileFilled$1; }),
  "chart-area-line-filled": () => Promise.resolve().then(function () { return IconChartAreaLineFilled$1; }),
  "chart-area-filled": () => Promise.resolve().then(function () { return IconChartAreaFilled$1; }),
  "chart-bubble-filled": () => Promise.resolve().then(function () { return IconChartBubbleFilled$1; }),
  "chart-candle-filled": () => Promise.resolve().then(function () { return IconChartCandleFilled$1; }),
  "chart-donut-filled": () => Promise.resolve().then(function () { return IconChartDonutFilled$1; }),
  "chart-dots-2-filled": () => Promise.resolve().then(function () { return IconChartDots2Filled$1; }),
  "chart-dots-3-filled": () => Promise.resolve().then(function () { return IconChartDots3Filled$1; }),
  "chart-dots-filled": () => Promise.resolve().then(function () { return IconChartDotsFilled$1; }),
  "chart-funnel-filled": () => Promise.resolve().then(function () { return IconChartFunnelFilled$1; }),
  "chart-grid-dots-filled": () => Promise.resolve().then(function () { return IconChartGridDotsFilled$1; }),
  "chart-pie-2-filled": () => Promise.resolve().then(function () { return IconChartPie2Filled$1; }),
  "chart-pie-3-filled": () => Promise.resolve().then(function () { return IconChartPie3Filled$1; }),
  "chart-pie-4-filled": () => Promise.resolve().then(function () { return IconChartPie4Filled$1; }),
  "chart-pie-filled": () => Promise.resolve().then(function () { return IconChartPieFilled$1; }),
  "chef-hat-filled": () => Promise.resolve().then(function () { return IconChefHatFilled$1; }),
  "cherry-filled": () => Promise.resolve().then(function () { return IconCherryFilled$1; }),
  "chess-bishop-filled": () => Promise.resolve().then(function () { return IconChessBishopFilled$1; }),
  "chess-king-filled": () => Promise.resolve().then(function () { return IconChessKingFilled$1; }),
  "chess-knight-filled": () => Promise.resolve().then(function () { return IconChessKnightFilled$1; }),
  "chess-queen-filled": () => Promise.resolve().then(function () { return IconChessQueenFilled$1; }),
  "chess-rook-filled": () => Promise.resolve().then(function () { return IconChessRookFilled$1; }),
  "chess-filled": () => Promise.resolve().then(function () { return IconChessFilled$1; }),
  "christmas-tree-filled": () => Promise.resolve().then(function () { return IconChristmasTreeFilled$1; }),
  "circle-arrow-down-left-filled": () => Promise.resolve().then(function () { return IconCircleArrowDownLeftFilled$1; }),
  "circle-arrow-down-right-filled": () => Promise.resolve().then(function () { return IconCircleArrowDownRightFilled$1; }),
  "circle-arrow-down-filled": () => Promise.resolve().then(function () { return IconCircleArrowDownFilled$1; }),
  "circle-arrow-left-filled": () => Promise.resolve().then(function () { return IconCircleArrowLeftFilled$1; }),
  "circle-arrow-right-filled": () => Promise.resolve().then(function () { return IconCircleArrowRightFilled$1; }),
  "circle-arrow-up-left-filled": () => Promise.resolve().then(function () { return IconCircleArrowUpLeftFilled$1; }),
  "circle-arrow-up-right-filled": () => Promise.resolve().then(function () { return IconCircleArrowUpRightFilled$1; }),
  "circle-arrow-up-filled": () => Promise.resolve().then(function () { return IconCircleArrowUpFilled$1; }),
  "circle-caret-down-filled": () => Promise.resolve().then(function () { return IconCircleCaretDownFilled$1; }),
  "circle-caret-left-filled": () => Promise.resolve().then(function () { return IconCircleCaretLeftFilled$1; }),
  "circle-caret-right-filled": () => Promise.resolve().then(function () { return IconCircleCaretRightFilled$1; }),
  "circle-caret-up-filled": () => Promise.resolve().then(function () { return IconCircleCaretUpFilled$1; }),
  "circle-check-filled": () => Promise.resolve().then(function () { return IconCircleCheckFilled$1; }),
  "circle-chevron-down-filled": () => Promise.resolve().then(function () { return IconCircleChevronDownFilled$1; }),
  "circle-chevron-left-filled": () => Promise.resolve().then(function () { return IconCircleChevronLeftFilled$1; }),
  "circle-chevron-right-filled": () => Promise.resolve().then(function () { return IconCircleChevronRightFilled$1; }),
  "circle-chevron-up-filled": () => Promise.resolve().then(function () { return IconCircleChevronUpFilled$1; }),
  "circle-chevrons-down-filled": () => Promise.resolve().then(function () { return IconCircleChevronsDownFilled$1; }),
  "circle-chevrons-left-filled": () => Promise.resolve().then(function () { return IconCircleChevronsLeftFilled$1; }),
  "circle-chevrons-right-filled": () => Promise.resolve().then(function () { return IconCircleChevronsRightFilled$1; }),
  "circle-chevrons-up-filled": () => Promise.resolve().then(function () { return IconCircleChevronsUpFilled$1; }),
  "circle-dot-filled": () => Promise.resolve().then(function () { return IconCircleDotFilled$1; }),
  "circle-key-filled": () => Promise.resolve().then(function () { return IconCircleKeyFilled$1; }),
  "circle-letter-a-filled": () => Promise.resolve().then(function () { return IconCircleLetterAFilled$1; }),
  "circle-letter-b-filled": () => Promise.resolve().then(function () { return IconCircleLetterBFilled$1; }),
  "circle-letter-c-filled": () => Promise.resolve().then(function () { return IconCircleLetterCFilled$1; }),
  "circle-letter-d-filled": () => Promise.resolve().then(function () { return IconCircleLetterDFilled$1; }),
  "circle-letter-e-filled": () => Promise.resolve().then(function () { return IconCircleLetterEFilled$1; }),
  "circle-letter-f-filled": () => Promise.resolve().then(function () { return IconCircleLetterFFilled$1; }),
  "circle-letter-g-filled": () => Promise.resolve().then(function () { return IconCircleLetterGFilled$1; }),
  "circle-letter-h-filled": () => Promise.resolve().then(function () { return IconCircleLetterHFilled$1; }),
  "circle-letter-i-filled": () => Promise.resolve().then(function () { return IconCircleLetterIFilled$1; }),
  "circle-letter-j-filled": () => Promise.resolve().then(function () { return IconCircleLetterJFilled$1; }),
  "circle-letter-k-filled": () => Promise.resolve().then(function () { return IconCircleLetterKFilled$1; }),
  "circle-letter-l-filled": () => Promise.resolve().then(function () { return IconCircleLetterLFilled$1; }),
  "circle-letter-m-filled": () => Promise.resolve().then(function () { return IconCircleLetterMFilled$1; }),
  "circle-letter-n-filled": () => Promise.resolve().then(function () { return IconCircleLetterNFilled$1; }),
  "circle-letter-o-filled": () => Promise.resolve().then(function () { return IconCircleLetterOFilled$1; }),
  "circle-letter-p-filled": () => Promise.resolve().then(function () { return IconCircleLetterPFilled$1; }),
  "circle-letter-q-filled": () => Promise.resolve().then(function () { return IconCircleLetterQFilled$1; }),
  "circle-letter-r-filled": () => Promise.resolve().then(function () { return IconCircleLetterRFilled$1; }),
  "circle-letter-s-filled": () => Promise.resolve().then(function () { return IconCircleLetterSFilled$1; }),
  "circle-letter-t-filled": () => Promise.resolve().then(function () { return IconCircleLetterTFilled$1; }),
  "circle-letter-u-filled": () => Promise.resolve().then(function () { return IconCircleLetterUFilled$1; }),
  "circle-letter-v-filled": () => Promise.resolve().then(function () { return IconCircleLetterVFilled$1; }),
  "circle-letter-w-filled": () => Promise.resolve().then(function () { return IconCircleLetterWFilled$1; }),
  "circle-letter-x-filled": () => Promise.resolve().then(function () { return IconCircleLetterXFilled$1; }),
  "circle-letter-y-filled": () => Promise.resolve().then(function () { return IconCircleLetterYFilled$1; }),
  "circle-letter-z-filled": () => Promise.resolve().then(function () { return IconCircleLetterZFilled$1; }),
  "circle-number-0-filled": () => Promise.resolve().then(function () { return IconCircleNumber0Filled$1; }),
  "circle-number-1-filled": () => Promise.resolve().then(function () { return IconCircleNumber1Filled$1; }),
  "circle-number-2-filled": () => Promise.resolve().then(function () { return IconCircleNumber2Filled$1; }),
  "circle-number-3-filled": () => Promise.resolve().then(function () { return IconCircleNumber3Filled$1; }),
  "circle-number-4-filled": () => Promise.resolve().then(function () { return IconCircleNumber4Filled$1; }),
  "circle-number-5-filled": () => Promise.resolve().then(function () { return IconCircleNumber5Filled$1; }),
  "circle-number-6-filled": () => Promise.resolve().then(function () { return IconCircleNumber6Filled$1; }),
  "circle-number-7-filled": () => Promise.resolve().then(function () { return IconCircleNumber7Filled$1; }),
  "circle-number-8-filled": () => Promise.resolve().then(function () { return IconCircleNumber8Filled$1; }),
  "circle-number-9-filled": () => Promise.resolve().then(function () { return IconCircleNumber9Filled$1; }),
  "circle-percentage-filled": () => Promise.resolve().then(function () { return IconCirclePercentageFilled$1; }),
  "circle-plus-filled": () => Promise.resolve().then(function () { return IconCirclePlusFilled$1; }),
  "circle-rectangle-filled": () => Promise.resolve().then(function () { return IconCircleRectangleFilled$1; }),
  "circle-x-filled": () => Promise.resolve().then(function () { return IconCircleXFilled$1; }),
  "circle-filled": () => Promise.resolve().then(function () { return IconCircleFilled$1; }),
  "circles-filled": () => Promise.resolve().then(function () { return IconCirclesFilled$1; }),
  "clipboard-check-filled": () => Promise.resolve().then(function () { return IconClipboardCheckFilled$1; }),
  "clipboard-data-filled": () => Promise.resolve().then(function () { return IconClipboardDataFilled$1; }),
  "clipboard-list-filled": () => Promise.resolve().then(function () { return IconClipboardListFilled$1; }),
  "clipboard-text-filled": () => Promise.resolve().then(function () { return IconClipboardTextFilled$1; }),
  "clipboard-typography-filled": () => Promise.resolve().then(function () { return IconClipboardTypographyFilled$1; }),
  "clipboard-x-filled": () => Promise.resolve().then(function () { return IconClipboardXFilled$1; }),
  "clipboard-filled": () => Promise.resolve().then(function () { return IconClipboardFilled$1; }),
  "clock-hour-1-filled": () => Promise.resolve().then(function () { return IconClockHour1Filled$1; }),
  "clock-hour-10-filled": () => Promise.resolve().then(function () { return IconClockHour10Filled$1; }),
  "clock-hour-11-filled": () => Promise.resolve().then(function () { return IconClockHour11Filled$1; }),
  "clock-hour-12-filled": () => Promise.resolve().then(function () { return IconClockHour12Filled$1; }),
  "clock-hour-2-filled": () => Promise.resolve().then(function () { return IconClockHour2Filled$1; }),
  "clock-hour-3-filled": () => Promise.resolve().then(function () { return IconClockHour3Filled$1; }),
  "clock-hour-4-filled": () => Promise.resolve().then(function () { return IconClockHour4Filled$1; }),
  "clock-hour-5-filled": () => Promise.resolve().then(function () { return IconClockHour5Filled$1; }),
  "clock-hour-6-filled": () => Promise.resolve().then(function () { return IconClockHour6Filled$1; }),
  "clock-hour-7-filled": () => Promise.resolve().then(function () { return IconClockHour7Filled$1; }),
  "clock-hour-8-filled": () => Promise.resolve().then(function () { return IconClockHour8Filled$1; }),
  "clock-hour-9-filled": () => Promise.resolve().then(function () { return IconClockHour9Filled$1; }),
  "clock-filled": () => Promise.resolve().then(function () { return IconClockFilled$1; }),
  "cloud-computing-filled": () => Promise.resolve().then(function () { return IconCloudComputingFilled$1; }),
  "cloud-data-connection-filled": () => Promise.resolve().then(function () { return IconCloudDataConnectionFilled$1; }),
  "cloud-filled": () => Promise.resolve().then(function () { return IconCloudFilled$1; }),
  "clover-filled": () => Promise.resolve().then(function () { return IconCloverFilled$1; }),
  "clubs-filled": () => Promise.resolve().then(function () { return IconClubsFilled$1; }),
  "code-circle-2-filled": () => Promise.resolve().then(function () { return IconCodeCircle2Filled$1; }),
  "code-circle-filled": () => Promise.resolve().then(function () { return IconCodeCircleFilled$1; }),
  "coin-bitcoin-filled": () => Promise.resolve().then(function () { return IconCoinBitcoinFilled$1; }),
  "coin-euro-filled": () => Promise.resolve().then(function () { return IconCoinEuroFilled$1; }),
  "coin-monero-filled": () => Promise.resolve().then(function () { return IconCoinMoneroFilled$1; }),
  "coin-pound-filled": () => Promise.resolve().then(function () { return IconCoinPoundFilled$1; }),
  "coin-rupee-filled": () => Promise.resolve().then(function () { return IconCoinRupeeFilled$1; }),
  "coin-taka-filled": () => Promise.resolve().then(function () { return IconCoinTakaFilled$1; }),
  "coin-yen-filled": () => Promise.resolve().then(function () { return IconCoinYenFilled$1; }),
  "coin-yuan-filled": () => Promise.resolve().then(function () { return IconCoinYuanFilled$1; }),
  "coin-filled": () => Promise.resolve().then(function () { return IconCoinFilled$1; }),
  "compass-filled": () => Promise.resolve().then(function () { return IconCompassFilled$1; }),
  "cone-2-filled": () => Promise.resolve().then(function () { return IconCone2Filled$1; }),
  "cone-filled": () => Promise.resolve().then(function () { return IconConeFilled$1; }),
  "contrast-2-filled": () => Promise.resolve().then(function () { return IconContrast2Filled$1; }),
  "contrast-filled": () => Promise.resolve().then(function () { return IconContrastFilled$1; }),
  "cookie-man-filled": () => Promise.resolve().then(function () { return IconCookieManFilled$1; }),
  "cookie-filled": () => Promise.resolve().then(function () { return IconCookieFilled$1; }),
  "copy-check-filled": () => Promise.resolve().then(function () { return IconCopyCheckFilled$1; }),
  "copy-minus-filled": () => Promise.resolve().then(function () { return IconCopyMinusFilled$1; }),
  "copy-plus-filled": () => Promise.resolve().then(function () { return IconCopyPlusFilled$1; }),
  "copy-x-filled": () => Promise.resolve().then(function () { return IconCopyXFilled$1; }),
  "copyleft-filled": () => Promise.resolve().then(function () { return IconCopyleftFilled$1; }),
  "copyright-filled": () => Promise.resolve().then(function () { return IconCopyrightFilled$1; }),
  "credit-card-filled": () => Promise.resolve().then(function () { return IconCreditCardFilled$1; }),
  "crop-1-1-filled": () => Promise.resolve().then(function () { return IconCrop11Filled$1; }),
  "crop-16-9-filled": () => Promise.resolve().then(function () { return IconCrop169Filled$1; }),
  "crop-3-2-filled": () => Promise.resolve().then(function () { return IconCrop32Filled$1; }),
  "crop-5-4-filled": () => Promise.resolve().then(function () { return IconCrop54Filled$1; }),
  "crop-7-5-filled": () => Promise.resolve().then(function () { return IconCrop75Filled$1; }),
  "crop-landscape-filled": () => Promise.resolve().then(function () { return IconCropLandscapeFilled$1; }),
  "crop-portrait-filled": () => Promise.resolve().then(function () { return IconCropPortraitFilled$1; }),
  "cross-filled": () => Promise.resolve().then(function () { return IconCrossFilled$1; }),
  "current-location-filled": () => Promise.resolve().then(function () { return IconCurrentLocationFilled$1; }),
  "dashboard-filled": () => Promise.resolve().then(function () { return IconDashboardFilled$1; }),
  "device-cctv-filled": () => Promise.resolve().then(function () { return IconDeviceCctvFilled$1; }),
  "device-desktop-filled": () => Promise.resolve().then(function () { return IconDeviceDesktopFilled$1; }),
  "device-gamepad-3-filled": () => Promise.resolve().then(function () { return IconDeviceGamepad3Filled$1; }),
  "device-heart-monitor-filled": () => Promise.resolve().then(function () { return IconDeviceHeartMonitorFilled$1; }),
  "device-imac-filled": () => Promise.resolve().then(function () { return IconDeviceImacFilled$1; }),
  "device-ipad-filled": () => Promise.resolve().then(function () { return IconDeviceIpadFilled$1; }),
  "device-mobile-filled": () => Promise.resolve().then(function () { return IconDeviceMobileFilled$1; }),
  "device-remote-filled": () => Promise.resolve().then(function () { return IconDeviceRemoteFilled$1; }),
  "device-speaker-filled": () => Promise.resolve().then(function () { return IconDeviceSpeakerFilled$1; }),
  "device-tablet-filled": () => Promise.resolve().then(function () { return IconDeviceTabletFilled$1; }),
  "device-tv-old-filled": () => Promise.resolve().then(function () { return IconDeviceTvOldFilled$1; }),
  "device-tv-filled": () => Promise.resolve().then(function () { return IconDeviceTvFilled$1; }),
  "device-unknown-filled": () => Promise.resolve().then(function () { return IconDeviceUnknownFilled$1; }),
  "device-usb-filled": () => Promise.resolve().then(function () { return IconDeviceUsbFilled$1; }),
  "device-vision-pro-filled": () => Promise.resolve().then(function () { return IconDeviceVisionProFilled$1; }),
  "device-watch-filled": () => Promise.resolve().then(function () { return IconDeviceWatchFilled$1; }),
  "dialpad-filled": () => Promise.resolve().then(function () { return IconDialpadFilled$1; }),
  "diamond-filled": () => Promise.resolve().then(function () { return IconDiamondFilled$1; }),
  "diamonds-filled": () => Promise.resolve().then(function () { return IconDiamondsFilled$1; }),
  "dice-1-filled": () => Promise.resolve().then(function () { return IconDice1Filled$1; }),
  "dice-2-filled": () => Promise.resolve().then(function () { return IconDice2Filled$1; }),
  "dice-3-filled": () => Promise.resolve().then(function () { return IconDice3Filled$1; }),
  "dice-4-filled": () => Promise.resolve().then(function () { return IconDice4Filled$1; }),
  "dice-5-filled": () => Promise.resolve().then(function () { return IconDice5Filled$1; }),
  "dice-6-filled": () => Promise.resolve().then(function () { return IconDice6Filled$1; }),
  "dice-filled": () => Promise.resolve().then(function () { return IconDiceFilled$1; }),
  "direction-arrows-filled": () => Promise.resolve().then(function () { return IconDirectionArrowsFilled$1; }),
  "direction-sign-filled": () => Promise.resolve().then(function () { return IconDirectionSignFilled$1; }),
  "directions-filled": () => Promise.resolve().then(function () { return IconDirectionsFilled$1; }),
  "disc-filled": () => Promise.resolve().then(function () { return IconDiscFilled$1; }),
  "discount-filled": () => Promise.resolve().then(function () { return IconDiscountFilled$1; }),
  "drop-circle-filled": () => Promise.resolve().then(function () { return IconDropCircleFilled$1; }),
  "droplet-half-2-filled": () => Promise.resolve().then(function () { return IconDropletHalf2Filled$1; }),
  "droplet-half-filled": () => Promise.resolve().then(function () { return IconDropletHalfFilled$1; }),
  "droplet-filled": () => Promise.resolve().then(function () { return IconDropletFilled$1; }),
  "droplets-filled": () => Promise.resolve().then(function () { return IconDropletsFilled$1; }),
  "dual-screen-filled": () => Promise.resolve().then(function () { return IconDualScreenFilled$1; }),
  "dumpling-filled": () => Promise.resolve().then(function () { return IconDumplingFilled$1; }),
  "egg-cracked-filled": () => Promise.resolve().then(function () { return IconEggCrackedFilled$1; }),
  "egg-fried-filled": () => Promise.resolve().then(function () { return IconEggFriedFilled$1; }),
  "egg-filled": () => Promise.resolve().then(function () { return IconEggFilled$1; }),
  "elevator-filled": () => Promise.resolve().then(function () { return IconElevatorFilled$1; }),
  "engine-filled": () => Promise.resolve().then(function () { return IconEngineFilled$1; }),
  "escalator-down-filled": () => Promise.resolve().then(function () { return IconEscalatorDownFilled$1; }),
  "escalator-up-filled": () => Promise.resolve().then(function () { return IconEscalatorUpFilled$1; }),
  "escalator-filled": () => Promise.resolve().then(function () { return IconEscalatorFilled$1; }),
  "exchange-filled": () => Promise.resolve().then(function () { return IconExchangeFilled$1; }),
  "exclamation-circle-filled": () => Promise.resolve().then(function () { return IconExclamationCircleFilled$1; }),
  "explicit-filled": () => Promise.resolve().then(function () { return IconExplicitFilled$1; }),
  "exposure-filled": () => Promise.resolve().then(function () { return IconExposureFilled$1; }),
  "eye-table-filled": () => Promise.resolve().then(function () { return IconEyeTableFilled$1; }),
  "eye-filled": () => Promise.resolve().then(function () { return IconEyeFilled$1; }),
  "eyeglass-2-filled": () => Promise.resolve().then(function () { return IconEyeglass2Filled$1; }),
  "eyeglass-filled": () => Promise.resolve().then(function () { return IconEyeglassFilled$1; }),
  "face-mask-filled": () => Promise.resolve().then(function () { return IconFaceMaskFilled$1; }),
  "favicon-filled": () => Promise.resolve().then(function () { return IconFaviconFilled$1; }),
  "feather-filled": () => Promise.resolve().then(function () { return IconFeatherFilled$1; }),
  "fence-filled": () => Promise.resolve().then(function () { return IconFenceFilled$1; }),
  "ferry-filled": () => Promise.resolve().then(function () { return IconFerryFilled$1; }),
  "fidget-spinner-filled": () => Promise.resolve().then(function () { return IconFidgetSpinnerFilled$1; }),
  "file-check-filled": () => Promise.resolve().then(function () { return IconFileCheckFilled$1; }),
  "file-code-2-filled": () => Promise.resolve().then(function () { return IconFileCode2Filled$1; }),
  "file-cv-filled": () => Promise.resolve().then(function () { return IconFileCvFilled$1; }),
  "file-delta-filled": () => Promise.resolve().then(function () { return IconFileDeltaFilled$1; }),
  "file-description-filled": () => Promise.resolve().then(function () { return IconFileDescriptionFilled$1; }),
  "file-digit-filled": () => Promise.resolve().then(function () { return IconFileDigitFilled$1; }),
  "file-download-filled": () => Promise.resolve().then(function () { return IconFileDownloadFilled$1; }),
  "file-horizontal-filled": () => Promise.resolve().then(function () { return IconFileHorizontalFilled$1; }),
  "file-invoice-filled": () => Promise.resolve().then(function () { return IconFileInvoiceFilled$1; }),
  "file-lambda-filled": () => Promise.resolve().then(function () { return IconFileLambdaFilled$1; }),
  "file-minus-filled": () => Promise.resolve().then(function () { return IconFileMinusFilled$1; }),
  "file-neutral-filled": () => Promise.resolve().then(function () { return IconFileNeutralFilled$1; }),
  "file-percent-filled": () => Promise.resolve().then(function () { return IconFilePercentFilled$1; }),
  "file-phone-filled": () => Promise.resolve().then(function () { return IconFilePhoneFilled$1; }),
  "file-power-filled": () => Promise.resolve().then(function () { return IconFilePowerFilled$1; }),
  "file-rss-filled": () => Promise.resolve().then(function () { return IconFileRssFilled$1; }),
  "file-sad-filled": () => Promise.resolve().then(function () { return IconFileSadFilled$1; }),
  "file-smile-filled": () => Promise.resolve().then(function () { return IconFileSmileFilled$1; }),
  "file-star-filled": () => Promise.resolve().then(function () { return IconFileStarFilled$1; }),
  "file-text-filled": () => Promise.resolve().then(function () { return IconFileTextFilled$1; }),
  "file-x-filled": () => Promise.resolve().then(function () { return IconFileXFilled$1; }),
  "file-filled": () => Promise.resolve().then(function () { return IconFileFilled$1; }),
  "filter-filled": () => Promise.resolve().then(function () { return IconFilterFilled$1; }),
  "filters-filled": () => Promise.resolve().then(function () { return IconFiltersFilled$1; }),
  "fish-bone-filled": () => Promise.resolve().then(function () { return IconFishBoneFilled$1; }),
  "flag-2-filled": () => Promise.resolve().then(function () { return IconFlag2Filled$1; }),
  "flag-3-filled": () => Promise.resolve().then(function () { return IconFlag3Filled$1; }),
  "flag-filled": () => Promise.resolve().then(function () { return IconFlagFilled$1; }),
  "flame-filled": () => Promise.resolve().then(function () { return IconFlameFilled$1; }),
  "flare-filled": () => Promise.resolve().then(function () { return IconFlareFilled$1; }),
  "flask-2-filled": () => Promise.resolve().then(function () { return IconFlask2Filled$1; }),
  "flask-filled": () => Promise.resolve().then(function () { return IconFlaskFilled$1; }),
  "flower-filled": () => Promise.resolve().then(function () { return IconFlowerFilled$1; }),
  "folder-filled": () => Promise.resolve().then(function () { return IconFolderFilled$1; }),
  "folders-filled": () => Promise.resolve().then(function () { return IconFoldersFilled$1; }),
  "forbid-2-filled": () => Promise.resolve().then(function () { return IconForbid2Filled$1; }),
  "forbid-filled": () => Promise.resolve().then(function () { return IconForbidFilled$1; }),
  "fountain-filled": () => Promise.resolve().then(function () { return IconFountainFilled$1; }),
  "function-filled": () => Promise.resolve().then(function () { return IconFunctionFilled$1; }),
  "garden-cart-filled": () => Promise.resolve().then(function () { return IconGardenCartFilled$1; }),
  "gas-station-filled": () => Promise.resolve().then(function () { return IconGasStationFilled$1; }),
  "gauge-filled": () => Promise.resolve().then(function () { return IconGaugeFilled$1; }),
  "ghost-2-filled": () => Promise.resolve().then(function () { return IconGhost2Filled$1; }),
  "ghost-3-filled": () => Promise.resolve().then(function () { return IconGhost3Filled$1; }),
  "ghost-filled": () => Promise.resolve().then(function () { return IconGhostFilled$1; }),
  "gift-card-filled": () => Promise.resolve().then(function () { return IconGiftCardFilled$1; }),
  "gift-filled": () => Promise.resolve().then(function () { return IconGiftFilled$1; }),
  "glass-full-filled": () => Promise.resolve().then(function () { return IconGlassFullFilled$1; }),
  "glass-filled": () => Promise.resolve().then(function () { return IconGlassFilled$1; }),
  "globe-filled": () => Promise.resolve().then(function () { return IconGlobeFilled$1; }),
  "golf-filled": () => Promise.resolve().then(function () { return IconGolfFilled$1; }),
  "gps-filled": () => Promise.resolve().then(function () { return IconGpsFilled$1; }),
  "graph-filled": () => Promise.resolve().then(function () { return IconGraphFilled$1; }),
  "grid-pattern-filled": () => Promise.resolve().then(function () { return IconGridPatternFilled$1; }),
  "guitar-pick-filled": () => Promise.resolve().then(function () { return IconGuitarPickFilled$1; }),
  "hanger-2-filled": () => Promise.resolve().then(function () { return IconHanger2Filled$1; }),
  "headphones-filled": () => Promise.resolve().then(function () { return IconHeadphonesFilled$1; }),
  "heart-filled": () => Promise.resolve().then(function () { return IconHeartFilled$1; }),
  "helicopter-landing-filled": () => Promise.resolve().then(function () { return IconHelicopterLandingFilled$1; }),
  "helicopter-filled": () => Promise.resolve().then(function () { return IconHelicopterFilled$1; }),
  "help-circle-filled": () => Promise.resolve().then(function () { return IconHelpCircleFilled$1; }),
  "help-hexagon-filled": () => Promise.resolve().then(function () { return IconHelpHexagonFilled$1; }),
  "help-octagon-filled": () => Promise.resolve().then(function () { return IconHelpOctagonFilled$1; }),
  "help-square-rounded-filled": () => Promise.resolve().then(function () { return IconHelpSquareRoundedFilled$1; }),
  "help-square-filled": () => Promise.resolve().then(function () { return IconHelpSquareFilled$1; }),
  "help-triangle-filled": () => Promise.resolve().then(function () { return IconHelpTriangleFilled$1; }),
  "hexagon-letter-a-filled": () => Promise.resolve().then(function () { return IconHexagonLetterAFilled$1; }),
  "hexagon-letter-b-filled": () => Promise.resolve().then(function () { return IconHexagonLetterBFilled$1; }),
  "hexagon-letter-c-filled": () => Promise.resolve().then(function () { return IconHexagonLetterCFilled$1; }),
  "hexagon-letter-d-filled": () => Promise.resolve().then(function () { return IconHexagonLetterDFilled$1; }),
  "hexagon-letter-e-filled": () => Promise.resolve().then(function () { return IconHexagonLetterEFilled$1; }),
  "hexagon-letter-f-filled": () => Promise.resolve().then(function () { return IconHexagonLetterFFilled$1; }),
  "hexagon-letter-g-filled": () => Promise.resolve().then(function () { return IconHexagonLetterGFilled$1; }),
  "hexagon-letter-h-filled": () => Promise.resolve().then(function () { return IconHexagonLetterHFilled$1; }),
  "hexagon-letter-i-filled": () => Promise.resolve().then(function () { return IconHexagonLetterIFilled$1; }),
  "hexagon-letter-j-filled": () => Promise.resolve().then(function () { return IconHexagonLetterJFilled$1; }),
  "hexagon-letter-k-filled": () => Promise.resolve().then(function () { return IconHexagonLetterKFilled$1; }),
  "hexagon-letter-l-filled": () => Promise.resolve().then(function () { return IconHexagonLetterLFilled$1; }),
  "hexagon-letter-m-filled": () => Promise.resolve().then(function () { return IconHexagonLetterMFilled$1; }),
  "hexagon-letter-n-filled": () => Promise.resolve().then(function () { return IconHexagonLetterNFilled$1; }),
  "hexagon-letter-o-filled": () => Promise.resolve().then(function () { return IconHexagonLetterOFilled$1; }),
  "hexagon-letter-p-filled": () => Promise.resolve().then(function () { return IconHexagonLetterPFilled$1; }),
  "hexagon-letter-q-filled": () => Promise.resolve().then(function () { return IconHexagonLetterQFilled$1; }),
  "hexagon-letter-r-filled": () => Promise.resolve().then(function () { return IconHexagonLetterRFilled$1; }),
  "hexagon-letter-s-filled": () => Promise.resolve().then(function () { return IconHexagonLetterSFilled$1; }),
  "hexagon-letter-t-filled": () => Promise.resolve().then(function () { return IconHexagonLetterTFilled$1; }),
  "hexagon-letter-u-filled": () => Promise.resolve().then(function () { return IconHexagonLetterUFilled$1; }),
  "hexagon-letter-v-filled": () => Promise.resolve().then(function () { return IconHexagonLetterVFilled$1; }),
  "hexagon-letter-w-filled": () => Promise.resolve().then(function () { return IconHexagonLetterWFilled$1; }),
  "hexagon-letter-x-filled": () => Promise.resolve().then(function () { return IconHexagonLetterXFilled$1; }),
  "hexagon-letter-y-filled": () => Promise.resolve().then(function () { return IconHexagonLetterYFilled$1; }),
  "hexagon-letter-z-filled": () => Promise.resolve().then(function () { return IconHexagonLetterZFilled$1; }),
  "hexagon-minus-filled": () => Promise.resolve().then(function () { return IconHexagonMinusFilled$1; }),
  "hexagon-number-0-filled": () => Promise.resolve().then(function () { return IconHexagonNumber0Filled$1; }),
  "hexagon-number-1-filled": () => Promise.resolve().then(function () { return IconHexagonNumber1Filled$1; }),
  "hexagon-number-2-filled": () => Promise.resolve().then(function () { return IconHexagonNumber2Filled$1; }),
  "hexagon-number-3-filled": () => Promise.resolve().then(function () { return IconHexagonNumber3Filled$1; }),
  "hexagon-number-4-filled": () => Promise.resolve().then(function () { return IconHexagonNumber4Filled$1; }),
  "hexagon-number-5-filled": () => Promise.resolve().then(function () { return IconHexagonNumber5Filled$1; }),
  "hexagon-number-6-filled": () => Promise.resolve().then(function () { return IconHexagonNumber6Filled$1; }),
  "hexagon-number-7-filled": () => Promise.resolve().then(function () { return IconHexagonNumber7Filled$1; }),
  "hexagon-number-8-filled": () => Promise.resolve().then(function () { return IconHexagonNumber8Filled$1; }),
  "hexagon-number-9-filled": () => Promise.resolve().then(function () { return IconHexagonNumber9Filled$1; }),
  "hexagon-plus-filled": () => Promise.resolve().then(function () { return IconHexagonPlusFilled$1; }),
  "hexagon-filled": () => Promise.resolve().then(function () { return IconHexagonFilled$1; }),
  "home-filled": () => Promise.resolve().then(function () { return IconHomeFilled$1; }),
  "hospital-circle-filled": () => Promise.resolve().then(function () { return IconHospitalCircleFilled$1; }),
  "hourglass-filled": () => Promise.resolve().then(function () { return IconHourglassFilled$1; }),
  "icons-filled": () => Promise.resolve().then(function () { return IconIconsFilled$1; }),
  "info-circle-filled": () => Promise.resolve().then(function () { return IconInfoCircleFilled$1; }),
  "info-hexagon-filled": () => Promise.resolve().then(function () { return IconInfoHexagonFilled$1; }),
  "info-octagon-filled": () => Promise.resolve().then(function () { return IconInfoOctagonFilled$1; }),
  "info-square-rounded-filled": () => Promise.resolve().then(function () { return IconInfoSquareRoundedFilled$1; }),
  "info-square-filled": () => Promise.resolve().then(function () { return IconInfoSquareFilled$1; }),
  "info-triangle-filled": () => Promise.resolve().then(function () { return IconInfoTriangleFilled$1; }),
  "inner-shadow-bottom-left-filled": () => Promise.resolve().then(function () { return IconInnerShadowBottomLeftFilled$1; }),
  "inner-shadow-bottom-right-filled": () => Promise.resolve().then(function () { return IconInnerShadowBottomRightFilled$1; }),
  "inner-shadow-bottom-filled": () => Promise.resolve().then(function () { return IconInnerShadowBottomFilled$1; }),
  "inner-shadow-left-filled": () => Promise.resolve().then(function () { return IconInnerShadowLeftFilled$1; }),
  "inner-shadow-right-filled": () => Promise.resolve().then(function () { return IconInnerShadowRightFilled$1; }),
  "inner-shadow-top-left-filled": () => Promise.resolve().then(function () { return IconInnerShadowTopLeftFilled$1; }),
  "inner-shadow-top-right-filled": () => Promise.resolve().then(function () { return IconInnerShadowTopRightFilled$1; }),
  "inner-shadow-top-filled": () => Promise.resolve().then(function () { return IconInnerShadowTopFilled$1; }),
  "ironing-1-filled": () => Promise.resolve().then(function () { return IconIroning1Filled$1; }),
  "ironing-2-filled": () => Promise.resolve().then(function () { return IconIroning2Filled$1; }),
  "ironing-3-filled": () => Promise.resolve().then(function () { return IconIroning3Filled$1; }),
  "ironing-steam-filled": () => Promise.resolve().then(function () { return IconIroningSteamFilled$1; }),
  "ironing-filled": () => Promise.resolve().then(function () { return IconIroningFilled$1; }),
  "jetpack-filled": () => Promise.resolve().then(function () { return IconJetpackFilled$1; }),
  "jewish-star-filled": () => Promise.resolve().then(function () { return IconJewishStarFilled$1; }),
  "key-filled": () => Promise.resolve().then(function () { return IconKeyFilled$1; }),
  "keyboard-filled": () => Promise.resolve().then(function () { return IconKeyboardFilled$1; }),
  "keyframe-align-center-filled": () => Promise.resolve().then(function () { return IconKeyframeAlignCenterFilled$1; }),
  "keyframe-align-horizontal-filled": () => Promise.resolve().then(function () { return IconKeyframeAlignHorizontalFilled$1; }),
  "keyframe-align-vertical-filled": () => Promise.resolve().then(function () { return IconKeyframeAlignVerticalFilled$1; }),
  "keyframe-filled": () => Promise.resolve().then(function () { return IconKeyframeFilled$1; }),
  "keyframes-filled": () => Promise.resolve().then(function () { return IconKeyframesFilled$1; }),
  "label-important-filled": () => Promise.resolve().then(function () { return IconLabelImportantFilled$1; }),
  "label-filled": () => Promise.resolve().then(function () { return IconLabelFilled$1; }),
  "lasso-polygon-filled": () => Promise.resolve().then(function () { return IconLassoPolygonFilled$1; }),
  "laurel-wreath-filled": () => Promise.resolve().then(function () { return IconLaurelWreathFilled$1; }),
  "layout-2-filled": () => Promise.resolve().then(function () { return IconLayout2Filled$1; }),
  "layout-align-bottom-filled": () => Promise.resolve().then(function () { return IconLayoutAlignBottomFilled$1; }),
  "layout-align-center-filled": () => Promise.resolve().then(function () { return IconLayoutAlignCenterFilled$1; }),
  "layout-align-left-filled": () => Promise.resolve().then(function () { return IconLayoutAlignLeftFilled$1; }),
  "layout-align-middle-filled": () => Promise.resolve().then(function () { return IconLayoutAlignMiddleFilled$1; }),
  "layout-align-right-filled": () => Promise.resolve().then(function () { return IconLayoutAlignRightFilled$1; }),
  "layout-align-top-filled": () => Promise.resolve().then(function () { return IconLayoutAlignTopFilled$1; }),
  "layout-bottombar-collapse-filled": () => Promise.resolve().then(function () { return IconLayoutBottombarCollapseFilled$1; }),
  "layout-bottombar-expand-filled": () => Promise.resolve().then(function () { return IconLayoutBottombarExpandFilled$1; }),
  "layout-bottombar-filled": () => Promise.resolve().then(function () { return IconLayoutBottombarFilled$1; }),
  "layout-cards-filled": () => Promise.resolve().then(function () { return IconLayoutCardsFilled$1; }),
  "layout-dashboard-filled": () => Promise.resolve().then(function () { return IconLayoutDashboardFilled$1; }),
  "layout-distribute-horizontal-filled": () => Promise.resolve().then(function () { return IconLayoutDistributeHorizontalFilled$1; }),
  "layout-distribute-vertical-filled": () => Promise.resolve().then(function () { return IconLayoutDistributeVerticalFilled$1; }),
  "layout-grid-filled": () => Promise.resolve().then(function () { return IconLayoutGridFilled$1; }),
  "layout-kanban-filled": () => Promise.resolve().then(function () { return IconLayoutKanbanFilled$1; }),
  "layout-list-filled": () => Promise.resolve().then(function () { return IconLayoutListFilled$1; }),
  "layout-navbar-collapse-filled": () => Promise.resolve().then(function () { return IconLayoutNavbarCollapseFilled$1; }),
  "layout-navbar-expand-filled": () => Promise.resolve().then(function () { return IconLayoutNavbarExpandFilled$1; }),
  "layout-navbar-filled": () => Promise.resolve().then(function () { return IconLayoutNavbarFilled$1; }),
  "layout-sidebar-left-collapse-filled": () => Promise.resolve().then(function () { return IconLayoutSidebarLeftCollapseFilled$1; }),
  "layout-sidebar-left-expand-filled": () => Promise.resolve().then(function () { return IconLayoutSidebarLeftExpandFilled$1; }),
  "layout-sidebar-right-collapse-filled": () => Promise.resolve().then(function () { return IconLayoutSidebarRightCollapseFilled$1; }),
  "layout-sidebar-right-expand-filled": () => Promise.resolve().then(function () { return IconLayoutSidebarRightExpandFilled$1; }),
  "layout-sidebar-right-filled": () => Promise.resolve().then(function () { return IconLayoutSidebarRightFilled$1; }),
  "layout-sidebar-filled": () => Promise.resolve().then(function () { return IconLayoutSidebarFilled$1; }),
  "layout-filled": () => Promise.resolve().then(function () { return IconLayoutFilled$1; }),
  "lego-filled": () => Promise.resolve().then(function () { return IconLegoFilled$1; }),
  "lemon-2-filled": () => Promise.resolve().then(function () { return IconLemon2Filled$1; }),
  "lifebuoy-filled": () => Promise.resolve().then(function () { return IconLifebuoyFilled$1; }),
  "live-photo-filled": () => Promise.resolve().then(function () { return IconLivePhotoFilled$1; }),
  "live-view-filled": () => Promise.resolve().then(function () { return IconLiveViewFilled$1; }),
  "location-filled": () => Promise.resolve().then(function () { return IconLocationFilled$1; }),
  "lock-square-rounded-filled": () => Promise.resolve().then(function () { return IconLockSquareRoundedFilled$1; }),
  "lock-filled": () => Promise.resolve().then(function () { return IconLockFilled$1; }),
  "lungs-filled": () => Promise.resolve().then(function () { return IconLungsFilled$1; }),
  "macro-filled": () => Promise.resolve().then(function () { return IconMacroFilled$1; }),
  "magnet-filled": () => Promise.resolve().then(function () { return IconMagnetFilled$1; }),
  "mail-opened-filled": () => Promise.resolve().then(function () { return IconMailOpenedFilled$1; }),
  "mail-filled": () => Promise.resolve().then(function () { return IconMailFilled$1; }),
  "man-filled": () => Promise.resolve().then(function () { return IconManFilled$1; }),
  "manual-gearbox-filled": () => Promise.resolve().then(function () { return IconManualGearboxFilled$1; }),
  "map-pin-filled": () => Promise.resolve().then(function () { return IconMapPinFilled$1; }),
  "medical-cross-filled": () => Promise.resolve().then(function () { return IconMedicalCrossFilled$1; }),
  "meeple-filled": () => Promise.resolve().then(function () { return IconMeepleFilled$1; }),
  "melon-filled": () => Promise.resolve().then(function () { return IconMelonFilled$1; }),
  "message-2-filled": () => Promise.resolve().then(function () { return IconMessage2Filled$1; }),
  "message-chatbot-filled": () => Promise.resolve().then(function () { return IconMessageChatbotFilled$1; }),
  "message-circle-filled": () => Promise.resolve().then(function () { return IconMessageCircleFilled$1; }),
  "message-report-filled": () => Promise.resolve().then(function () { return IconMessageReportFilled$1; }),
  "message-filled": () => Promise.resolve().then(function () { return IconMessageFilled$1; }),
  "meteor-filled": () => Promise.resolve().then(function () { return IconMeteorFilled$1; }),
  "michelin-star-filled": () => Promise.resolve().then(function () { return IconMichelinStarFilled$1; }),
  "mickey-filled": () => Promise.resolve().then(function () { return IconMickeyFilled$1; }),
  "microphone-filled": () => Promise.resolve().then(function () { return IconMicrophoneFilled$1; }),
  "microwave-filled": () => Promise.resolve().then(function () { return IconMicrowaveFilled$1; }),
  "military-rank-filled": () => Promise.resolve().then(function () { return IconMilitaryRankFilled$1; }),
  "milk-filled": () => Promise.resolve().then(function () { return IconMilkFilled$1; }),
  "mood-angry-filled": () => Promise.resolve().then(function () { return IconMoodAngryFilled$1; }),
  "mood-confuzed-filled": () => Promise.resolve().then(function () { return IconMoodConfuzedFilled$1; }),
  "mood-crazy-happy-filled": () => Promise.resolve().then(function () { return IconMoodCrazyHappyFilled$1; }),
  "mood-empty-filled": () => Promise.resolve().then(function () { return IconMoodEmptyFilled$1; }),
  "mood-happy-filled": () => Promise.resolve().then(function () { return IconMoodHappyFilled$1; }),
  "mood-kid-filled": () => Promise.resolve().then(function () { return IconMoodKidFilled$1; }),
  "mood-neutral-filled": () => Promise.resolve().then(function () { return IconMoodNeutralFilled$1; }),
  "mood-sad-filled": () => Promise.resolve().then(function () { return IconMoodSadFilled$1; }),
  "mood-smile-filled": () => Promise.resolve().then(function () { return IconMoodSmileFilled$1; }),
  "mood-wrrr-filled": () => Promise.resolve().then(function () { return IconMoodWrrrFilled$1; }),
  "moon-filled": () => Promise.resolve().then(function () { return IconMoonFilled$1; }),
  "motorbike-filled": () => Promise.resolve().then(function () { return IconMotorbikeFilled$1; }),
  "mountain-filled": () => Promise.resolve().then(function () { return IconMountainFilled$1; }),
  "mouse-filled": () => Promise.resolve().then(function () { return IconMouseFilled$1; }),
  "mug-filled": () => Promise.resolve().then(function () { return IconMugFilled$1; }),
  "mushroom-filled": () => Promise.resolve().then(function () { return IconMushroomFilled$1; }),
  "navigation-filled": () => Promise.resolve().then(function () { return IconNavigationFilled$1; }),
  "nurse-filled": () => Promise.resolve().then(function () { return IconNurseFilled$1; }),
  "octagon-filled": () => Promise.resolve().then(function () { return IconOctagonFilled$1; }),
  "oval-vertical-filled": () => Promise.resolve().then(function () { return IconOvalVerticalFilled$1; }),
  "oval-filled": () => Promise.resolve().then(function () { return IconOvalFilled$1; }),
  "paint-filled": () => Promise.resolve().then(function () { return IconPaintFilled$1; }),
  "palette-filled": () => Promise.resolve().then(function () { return IconPaletteFilled$1; }),
  "panorama-horizontal-filled": () => Promise.resolve().then(function () { return IconPanoramaHorizontalFilled$1; }),
  "panorama-vertical-filled": () => Promise.resolve().then(function () { return IconPanoramaVerticalFilled$1; }),
  "parking-circle-filled": () => Promise.resolve().then(function () { return IconParkingCircleFilled$1; }),
  "paw-filled": () => Promise.resolve().then(function () { return IconPawFilled$1; }),
  "pennant-2-filled": () => Promise.resolve().then(function () { return IconPennant2Filled$1; }),
  "pennant-filled": () => Promise.resolve().then(function () { return IconPennantFilled$1; }),
  "pentagon-filled": () => Promise.resolve().then(function () { return IconPentagonFilled$1; }),
  "phone-filled": () => Promise.resolve().then(function () { return IconPhoneFilled$1; }),
  "photo-filled": () => Promise.resolve().then(function () { return IconPhotoFilled$1; }),
  "picture-in-picture-top-filled": () => Promise.resolve().then(function () { return IconPictureInPictureTopFilled$1; }),
  "picture-in-picture-filled": () => Promise.resolve().then(function () { return IconPictureInPictureFilled$1; }),
  "pig-filled": () => Promise.resolve().then(function () { return IconPigFilled$1; }),
  "pill-filled": () => Promise.resolve().then(function () { return IconPillFilled$1; }),
  "pin-filled": () => Promise.resolve().then(function () { return IconPinFilled$1; }),
  "pinned-filled": () => Promise.resolve().then(function () { return IconPinnedFilled$1; }),
  "pizza-filled": () => Promise.resolve().then(function () { return IconPizzaFilled$1; }),
  "play-card-1-filled": () => Promise.resolve().then(function () { return IconPlayCard1Filled$1; }),
  "play-card-10-filled": () => Promise.resolve().then(function () { return IconPlayCard10Filled$1; }),
  "play-card-2-filled": () => Promise.resolve().then(function () { return IconPlayCard2Filled$1; }),
  "play-card-3-filled": () => Promise.resolve().then(function () { return IconPlayCard3Filled$1; }),
  "play-card-4-filled": () => Promise.resolve().then(function () { return IconPlayCard4Filled$1; }),
  "play-card-5-filled": () => Promise.resolve().then(function () { return IconPlayCard5Filled$1; }),
  "play-card-6-filled": () => Promise.resolve().then(function () { return IconPlayCard6Filled$1; }),
  "play-card-7-filled": () => Promise.resolve().then(function () { return IconPlayCard7Filled$1; }),
  "play-card-8-filled": () => Promise.resolve().then(function () { return IconPlayCard8Filled$1; }),
  "play-card-9-filled": () => Promise.resolve().then(function () { return IconPlayCard9Filled$1; }),
  "play-card-a-filled": () => Promise.resolve().then(function () { return IconPlayCardAFilled$1; }),
  "play-card-j-filled": () => Promise.resolve().then(function () { return IconPlayCardJFilled$1; }),
  "play-card-k-filled": () => Promise.resolve().then(function () { return IconPlayCardKFilled$1; }),
  "play-card-q-filled": () => Promise.resolve().then(function () { return IconPlayCardQFilled$1; }),
  "play-card-star-filled": () => Promise.resolve().then(function () { return IconPlayCardStarFilled$1; }),
  "player-eject-filled": () => Promise.resolve().then(function () { return IconPlayerEjectFilled$1; }),
  "player-pause-filled": () => Promise.resolve().then(function () { return IconPlayerPauseFilled$1; }),
  "player-play-filled": () => Promise.resolve().then(function () { return IconPlayerPlayFilled$1; }),
  "player-record-filled": () => Promise.resolve().then(function () { return IconPlayerRecordFilled$1; }),
  "player-skip-back-filled": () => Promise.resolve().then(function () { return IconPlayerSkipBackFilled$1; }),
  "player-skip-forward-filled": () => Promise.resolve().then(function () { return IconPlayerSkipForwardFilled$1; }),
  "player-stop-filled": () => Promise.resolve().then(function () { return IconPlayerStopFilled$1; }),
  "player-track-next-filled": () => Promise.resolve().then(function () { return IconPlayerTrackNextFilled$1; }),
  "player-track-prev-filled": () => Promise.resolve().then(function () { return IconPlayerTrackPrevFilled$1; }),
  "point-filled": () => Promise.resolve().then(function () { return IconPointFilled$1; }),
  "pointer-filled": () => Promise.resolve().then(function () { return IconPointerFilled$1; }),
  "polaroid-filled": () => Promise.resolve().then(function () { return IconPolaroidFilled$1; }),
  "poo-filled": () => Promise.resolve().then(function () { return IconPooFilled$1; }),
  "presentation-analytics-filled": () => Promise.resolve().then(function () { return IconPresentationAnalyticsFilled$1; }),
  "presentation-filled": () => Promise.resolve().then(function () { return IconPresentationFilled$1; }),
  "puzzle-filled": () => Promise.resolve().then(function () { return IconPuzzleFilled$1; }),
  "quote-filled": () => Promise.resolve().then(function () { return IconQuoteFilled$1; }),
  "radar-filled": () => Promise.resolve().then(function () { return IconRadarFilled$1; }),
  "radioactive-filled": () => Promise.resolve().then(function () { return IconRadioactiveFilled$1; }),
  "receipt-filled": () => Promise.resolve().then(function () { return IconReceiptFilled$1; }),
  "rectangle-vertical-filled": () => Promise.resolve().then(function () { return IconRectangleVerticalFilled$1; }),
  "rectangle-filled": () => Promise.resolve().then(function () { return IconRectangleFilled$1; }),
  "relation-many-to-many-filled": () => Promise.resolve().then(function () { return IconRelationManyToManyFilled$1; }),
  "relation-one-to-many-filled": () => Promise.resolve().then(function () { return IconRelationOneToManyFilled$1; }),
  "relation-one-to-one-filled": () => Promise.resolve().then(function () { return IconRelationOneToOneFilled$1; }),
  "replace-filled": () => Promise.resolve().then(function () { return IconReplaceFilled$1; }),
  "rollercoaster-filled": () => Promise.resolve().then(function () { return IconRollercoasterFilled$1; }),
  "rosette-discount-check-filled": () => Promise.resolve().then(function () { return IconRosetteDiscountCheckFilled$1; }),
  "rosette-discount-filled": () => Promise.resolve().then(function () { return IconRosetteDiscountFilled$1; }),
  "rosette-filled": () => Promise.resolve().then(function () { return IconRosetteFilled$1; }),
  "salad-filled": () => Promise.resolve().then(function () { return IconSaladFilled$1; }),
  "scuba-diving-tank-filled": () => Promise.resolve().then(function () { return IconScubaDivingTankFilled$1; }),
  "section-filled": () => Promise.resolve().then(function () { return IconSectionFilled$1; }),
  "seedling-filled": () => Promise.resolve().then(function () { return IconSeedlingFilled$1; }),
  "settings-filled": () => Promise.resolve().then(function () { return IconSettingsFilled$1; }),
  "shield-check-filled": () => Promise.resolve().then(function () { return IconShieldCheckFilled$1; }),
  "shield-checkered-filled": () => Promise.resolve().then(function () { return IconShieldCheckeredFilled$1; }),
  "shield-half-filled": () => Promise.resolve().then(function () { return IconShieldHalfFilled$1; }),
  "shield-lock-filled": () => Promise.resolve().then(function () { return IconShieldLockFilled$1; }),
  "shield-filled": () => Promise.resolve().then(function () { return IconShieldFilled$1; }),
  "shirt-filled": () => Promise.resolve().then(function () { return IconShirtFilled$1; }),
  "shopping-cart-filled": () => Promise.resolve().then(function () { return IconShoppingCartFilled$1; }),
  "sign-left-filled": () => Promise.resolve().then(function () { return IconSignLeftFilled$1; }),
  "sign-right-filled": () => Promise.resolve().then(function () { return IconSignRightFilled$1; }),
  "sitemap-filled": () => Promise.resolve().then(function () { return IconSitemapFilled$1; }),
  "sort-ascending-2-filled": () => Promise.resolve().then(function () { return IconSortAscending2Filled$1; }),
  "sort-ascending-shapes-filled": () => Promise.resolve().then(function () { return IconSortAscendingShapesFilled$1; }),
  "sort-descending-2-filled": () => Promise.resolve().then(function () { return IconSortDescending2Filled$1; }),
  "sort-descending-shapes-filled": () => Promise.resolve().then(function () { return IconSortDescendingShapesFilled$1; }),
  "soup-filled": () => Promise.resolve().then(function () { return IconSoupFilled$1; }),
  "spade-filled": () => Promise.resolve().then(function () { return IconSpadeFilled$1; }),
  "speedboat-filled": () => Promise.resolve().then(function () { return IconSpeedboatFilled$1; }),
  "spider-filled": () => Promise.resolve().then(function () { return IconSpiderFilled$1; }),
  "square-arrow-down-filled": () => Promise.resolve().then(function () { return IconSquareArrowDownFilled$1; }),
  "square-arrow-left-filled": () => Promise.resolve().then(function () { return IconSquareArrowLeftFilled$1; }),
  "square-arrow-right-filled": () => Promise.resolve().then(function () { return IconSquareArrowRightFilled$1; }),
  "square-arrow-up-filled": () => Promise.resolve().then(function () { return IconSquareArrowUpFilled$1; }),
  "square-asterisk-filled": () => Promise.resolve().then(function () { return IconSquareAsteriskFilled$1; }),
  "square-check-filled": () => Promise.resolve().then(function () { return IconSquareCheckFilled$1; }),
  "square-chevron-down-filled": () => Promise.resolve().then(function () { return IconSquareChevronDownFilled$1; }),
  "square-chevron-left-filled": () => Promise.resolve().then(function () { return IconSquareChevronLeftFilled$1; }),
  "square-chevron-right-filled": () => Promise.resolve().then(function () { return IconSquareChevronRightFilled$1; }),
  "square-chevron-up-filled": () => Promise.resolve().then(function () { return IconSquareChevronUpFilled$1; }),
  "square-chevrons-down-filled": () => Promise.resolve().then(function () { return IconSquareChevronsDownFilled$1; }),
  "square-chevrons-left-filled": () => Promise.resolve().then(function () { return IconSquareChevronsLeftFilled$1; }),
  "square-chevrons-right-filled": () => Promise.resolve().then(function () { return IconSquareChevronsRightFilled$1; }),
  "square-chevrons-up-filled": () => Promise.resolve().then(function () { return IconSquareChevronsUpFilled$1; }),
  "square-dot-filled": () => Promise.resolve().then(function () { return IconSquareDotFilled$1; }),
  "square-f0-filled": () => Promise.resolve().then(function () { return IconSquareF0Filled$1; }),
  "square-f1-filled": () => Promise.resolve().then(function () { return IconSquareF1Filled$1; }),
  "square-f2-filled": () => Promise.resolve().then(function () { return IconSquareF2Filled$1; }),
  "square-f3-filled": () => Promise.resolve().then(function () { return IconSquareF3Filled$1; }),
  "square-f4-filled": () => Promise.resolve().then(function () { return IconSquareF4Filled$1; }),
  "square-f5-filled": () => Promise.resolve().then(function () { return IconSquareF5Filled$1; }),
  "square-f6-filled": () => Promise.resolve().then(function () { return IconSquareF6Filled$1; }),
  "square-f7-filled": () => Promise.resolve().then(function () { return IconSquareF7Filled$1; }),
  "square-f8-filled": () => Promise.resolve().then(function () { return IconSquareF8Filled$1; }),
  "square-f9-filled": () => Promise.resolve().then(function () { return IconSquareF9Filled$1; }),
  "square-letter-a-filled": () => Promise.resolve().then(function () { return IconSquareLetterAFilled$1; }),
  "square-letter-b-filled": () => Promise.resolve().then(function () { return IconSquareLetterBFilled$1; }),
  "square-letter-c-filled": () => Promise.resolve().then(function () { return IconSquareLetterCFilled$1; }),
  "square-letter-d-filled": () => Promise.resolve().then(function () { return IconSquareLetterDFilled$1; }),
  "square-letter-e-filled": () => Promise.resolve().then(function () { return IconSquareLetterEFilled$1; }),
  "square-letter-f-filled": () => Promise.resolve().then(function () { return IconSquareLetterFFilled$1; }),
  "square-letter-g-filled": () => Promise.resolve().then(function () { return IconSquareLetterGFilled$1; }),
  "square-letter-h-filled": () => Promise.resolve().then(function () { return IconSquareLetterHFilled$1; }),
  "square-letter-i-filled": () => Promise.resolve().then(function () { return IconSquareLetterIFilled$1; }),
  "square-letter-j-filled": () => Promise.resolve().then(function () { return IconSquareLetterJFilled$1; }),
  "square-letter-k-filled": () => Promise.resolve().then(function () { return IconSquareLetterKFilled$1; }),
  "square-letter-l-filled": () => Promise.resolve().then(function () { return IconSquareLetterLFilled$1; }),
  "square-letter-m-filled": () => Promise.resolve().then(function () { return IconSquareLetterMFilled$1; }),
  "square-letter-n-filled": () => Promise.resolve().then(function () { return IconSquareLetterNFilled$1; }),
  "square-letter-o-filled": () => Promise.resolve().then(function () { return IconSquareLetterOFilled$1; }),
  "square-letter-p-filled": () => Promise.resolve().then(function () { return IconSquareLetterPFilled$1; }),
  "square-letter-q-filled": () => Promise.resolve().then(function () { return IconSquareLetterQFilled$1; }),
  "square-letter-r-filled": () => Promise.resolve().then(function () { return IconSquareLetterRFilled$1; }),
  "square-letter-s-filled": () => Promise.resolve().then(function () { return IconSquareLetterSFilled$1; }),
  "square-letter-t-filled": () => Promise.resolve().then(function () { return IconSquareLetterTFilled$1; }),
  "square-letter-u-filled": () => Promise.resolve().then(function () { return IconSquareLetterUFilled$1; }),
  "square-letter-v-filled": () => Promise.resolve().then(function () { return IconSquareLetterVFilled$1; }),
  "square-letter-w-filled": () => Promise.resolve().then(function () { return IconSquareLetterWFilled$1; }),
  "square-letter-x-filled": () => Promise.resolve().then(function () { return IconSquareLetterXFilled$1; }),
  "square-letter-y-filled": () => Promise.resolve().then(function () { return IconSquareLetterYFilled$1; }),
  "square-letter-z-filled": () => Promise.resolve().then(function () { return IconSquareLetterZFilled$1; }),
  "square-minus-filled": () => Promise.resolve().then(function () { return IconSquareMinusFilled$1; }),
  "square-number-0-filled": () => Promise.resolve().then(function () { return IconSquareNumber0Filled$1; }),
  "square-number-1-filled": () => Promise.resolve().then(function () { return IconSquareNumber1Filled$1; }),
  "square-number-2-filled": () => Promise.resolve().then(function () { return IconSquareNumber2Filled$1; }),
  "square-number-3-filled": () => Promise.resolve().then(function () { return IconSquareNumber3Filled$1; }),
  "square-number-4-filled": () => Promise.resolve().then(function () { return IconSquareNumber4Filled$1; }),
  "square-number-5-filled": () => Promise.resolve().then(function () { return IconSquareNumber5Filled$1; }),
  "square-number-6-filled": () => Promise.resolve().then(function () { return IconSquareNumber6Filled$1; }),
  "square-number-7-filled": () => Promise.resolve().then(function () { return IconSquareNumber7Filled$1; }),
  "square-number-8-filled": () => Promise.resolve().then(function () { return IconSquareNumber8Filled$1; }),
  "square-number-9-filled": () => Promise.resolve().then(function () { return IconSquareNumber9Filled$1; }),
  "square-rotated-filled": () => Promise.resolve().then(function () { return IconSquareRotatedFilled$1; }),
  "square-rounded-arrow-down-filled": () => Promise.resolve().then(function () { return IconSquareRoundedArrowDownFilled$1; }),
  "square-rounded-arrow-left-filled": () => Promise.resolve().then(function () { return IconSquareRoundedArrowLeftFilled$1; }),
  "square-rounded-arrow-right-filled": () => Promise.resolve().then(function () { return IconSquareRoundedArrowRightFilled$1; }),
  "square-rounded-arrow-up-filled": () => Promise.resolve().then(function () { return IconSquareRoundedArrowUpFilled$1; }),
  "square-rounded-check-filled": () => Promise.resolve().then(function () { return IconSquareRoundedCheckFilled$1; }),
  "square-rounded-chevron-down-filled": () => Promise.resolve().then(function () { return IconSquareRoundedChevronDownFilled$1; }),
  "square-rounded-chevron-left-filled": () => Promise.resolve().then(function () { return IconSquareRoundedChevronLeftFilled$1; }),
  "square-rounded-chevron-right-filled": () => Promise.resolve().then(function () { return IconSquareRoundedChevronRightFilled$1; }),
  "square-rounded-chevron-up-filled": () => Promise.resolve().then(function () { return IconSquareRoundedChevronUpFilled$1; }),
  "square-rounded-chevrons-down-filled": () => Promise.resolve().then(function () { return IconSquareRoundedChevronsDownFilled$1; }),
  "square-rounded-chevrons-left-filled": () => Promise.resolve().then(function () { return IconSquareRoundedChevronsLeftFilled$1; }),
  "square-rounded-chevrons-right-filled": () => Promise.resolve().then(function () { return IconSquareRoundedChevronsRightFilled$1; }),
  "square-rounded-chevrons-up-filled": () => Promise.resolve().then(function () { return IconSquareRoundedChevronsUpFilled$1; }),
  "square-rounded-letter-a-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterAFilled$1; }),
  "square-rounded-letter-b-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterBFilled$1; }),
  "square-rounded-letter-c-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterCFilled$1; }),
  "square-rounded-letter-d-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterDFilled$1; }),
  "square-rounded-letter-e-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterEFilled$1; }),
  "square-rounded-letter-f-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterFFilled$1; }),
  "square-rounded-letter-g-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterGFilled$1; }),
  "square-rounded-letter-h-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterHFilled$1; }),
  "square-rounded-letter-i-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterIFilled$1; }),
  "square-rounded-letter-j-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterJFilled$1; }),
  "square-rounded-letter-k-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterKFilled$1; }),
  "square-rounded-letter-l-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterLFilled$1; }),
  "square-rounded-letter-m-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterMFilled$1; }),
  "square-rounded-letter-n-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterNFilled$1; }),
  "square-rounded-letter-o-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterOFilled$1; }),
  "square-rounded-letter-p-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterPFilled$1; }),
  "square-rounded-letter-q-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterQFilled$1; }),
  "square-rounded-letter-r-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterRFilled$1; }),
  "square-rounded-letter-s-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterSFilled$1; }),
  "square-rounded-letter-t-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterTFilled$1; }),
  "square-rounded-letter-u-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterUFilled$1; }),
  "square-rounded-letter-v-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterVFilled$1; }),
  "square-rounded-letter-w-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterWFilled$1; }),
  "square-rounded-letter-x-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterXFilled$1; }),
  "square-rounded-letter-y-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterYFilled$1; }),
  "square-rounded-letter-z-filled": () => Promise.resolve().then(function () { return IconSquareRoundedLetterZFilled$1; }),
  "square-rounded-minus-filled": () => Promise.resolve().then(function () { return IconSquareRoundedMinusFilled$1; }),
  "square-rounded-number-0-filled": () => Promise.resolve().then(function () { return IconSquareRoundedNumber0Filled$1; }),
  "square-rounded-number-1-filled": () => Promise.resolve().then(function () { return IconSquareRoundedNumber1Filled$1; }),
  "square-rounded-number-2-filled": () => Promise.resolve().then(function () { return IconSquareRoundedNumber2Filled$1; }),
  "square-rounded-number-3-filled": () => Promise.resolve().then(function () { return IconSquareRoundedNumber3Filled$1; }),
  "square-rounded-number-4-filled": () => Promise.resolve().then(function () { return IconSquareRoundedNumber4Filled$1; }),
  "square-rounded-number-5-filled": () => Promise.resolve().then(function () { return IconSquareRoundedNumber5Filled$1; }),
  "square-rounded-number-6-filled": () => Promise.resolve().then(function () { return IconSquareRoundedNumber6Filled$1; }),
  "square-rounded-number-7-filled": () => Promise.resolve().then(function () { return IconSquareRoundedNumber7Filled$1; }),
  "square-rounded-number-8-filled": () => Promise.resolve().then(function () { return IconSquareRoundedNumber8Filled$1; }),
  "square-rounded-number-9-filled": () => Promise.resolve().then(function () { return IconSquareRoundedNumber9Filled$1; }),
  "square-rounded-plus-filled": () => Promise.resolve().then(function () { return IconSquareRoundedPlusFilled$1; }),
  "square-rounded-x-filled": () => Promise.resolve().then(function () { return IconSquareRoundedXFilled$1; }),
  "square-rounded-filled": () => Promise.resolve().then(function () { return IconSquareRoundedFilled$1; }),
  "square-x-filled": () => Promise.resolve().then(function () { return IconSquareXFilled$1; }),
  "square-filled": () => Promise.resolve().then(function () { return IconSquareFilled$1; }),
  "squares-filled": () => Promise.resolve().then(function () { return IconSquaresFilled$1; }),
  "stack-2-filled": () => Promise.resolve().then(function () { return IconStack2Filled$1; }),
  "stack-3-filled": () => Promise.resolve().then(function () { return IconStack3Filled$1; }),
  "stack-filled": () => Promise.resolve().then(function () { return IconStackFilled$1; }),
  "star-half-filled": () => Promise.resolve().then(function () { return IconStarHalfFilled$1; }),
  "star-filled": () => Promise.resolve().then(function () { return IconStarFilled$1; }),
  "stars-filled": () => Promise.resolve().then(function () { return IconStarsFilled$1; }),
  "steering-wheel-filled": () => Promise.resolve().then(function () { return IconSteeringWheelFilled$1; }),
  "sun-high-filled": () => Promise.resolve().then(function () { return IconSunHighFilled$1; }),
  "sun-low-filled": () => Promise.resolve().then(function () { return IconSunLowFilled$1; }),
  "sun-filled": () => Promise.resolve().then(function () { return IconSunFilled$1; }),
  "sunglasses-filled": () => Promise.resolve().then(function () { return IconSunglassesFilled$1; }),
  "sunrise-filled": () => Promise.resolve().then(function () { return IconSunriseFilled$1; }),
  "sunset-2-filled": () => Promise.resolve().then(function () { return IconSunset2Filled$1; }),
  "sunset-filled": () => Promise.resolve().then(function () { return IconSunsetFilled$1; }),
  "swipe-down-filled": () => Promise.resolve().then(function () { return IconSwipeDownFilled$1; }),
  "swipe-left-filled": () => Promise.resolve().then(function () { return IconSwipeLeftFilled$1; }),
  "swipe-right-filled": () => Promise.resolve().then(function () { return IconSwipeRightFilled$1; }),
  "swipe-up-filled": () => Promise.resolve().then(function () { return IconSwipeUpFilled$1; }),
  "table-filled": () => Promise.resolve().then(function () { return IconTableFilled$1; }),
  "tag-filled": () => Promise.resolve().then(function () { return IconTagFilled$1; }),
  "tags-filled": () => Promise.resolve().then(function () { return IconTagsFilled$1; }),
  "temperature-minus-filled": () => Promise.resolve().then(function () { return IconTemperatureMinusFilled$1; }),
  "temperature-plus-filled": () => Promise.resolve().then(function () { return IconTemperaturePlusFilled$1; }),
  "test-pipe-2-filled": () => Promise.resolve().then(function () { return IconTestPipe2Filled$1; }),
  "thumb-down-filled": () => Promise.resolve().then(function () { return IconThumbDownFilled$1; }),
  "thumb-up-filled": () => Promise.resolve().then(function () { return IconThumbUpFilled$1; }),
  "tilt-shift-filled": () => Promise.resolve().then(function () { return IconTiltShiftFilled$1; }),
  "timeline-event-filled": () => Promise.resolve().then(function () { return IconTimelineEventFilled$1; }),
  "toggle-left-filled": () => Promise.resolve().then(function () { return IconToggleLeftFilled$1; }),
  "toggle-right-filled": () => Promise.resolve().then(function () { return IconToggleRightFilled$1; }),
  "train-filled": () => Promise.resolve().then(function () { return IconTrainFilled$1; }),
  "transform-filled": () => Promise.resolve().then(function () { return IconTransformFilled$1; }),
  "transition-bottom-filled": () => Promise.resolve().then(function () { return IconTransitionBottomFilled$1; }),
  "transition-left-filled": () => Promise.resolve().then(function () { return IconTransitionLeftFilled$1; }),
  "transition-right-filled": () => Promise.resolve().then(function () { return IconTransitionRightFilled$1; }),
  "transition-top-filled": () => Promise.resolve().then(function () { return IconTransitionTopFilled$1; }),
  "trash-x-filled": () => Promise.resolve().then(function () { return IconTrashXFilled$1; }),
  "trash-filled": () => Promise.resolve().then(function () { return IconTrashFilled$1; }),
  "triangle-inverted-filled": () => Promise.resolve().then(function () { return IconTriangleInvertedFilled$1; }),
  "triangle-square-circle-filled": () => Promise.resolve().then(function () { return IconTriangleSquareCircleFilled$1; }),
  "triangle-filled": () => Promise.resolve().then(function () { return IconTriangleFilled$1; }),
  "trolley-filled": () => Promise.resolve().then(function () { return IconTrolleyFilled$1; }),
  "trophy-filled": () => Promise.resolve().then(function () { return IconTrophyFilled$1; }),
  "truck-filled": () => Promise.resolve().then(function () { return IconTruckFilled$1; }),
  "umbrella-filled": () => Promise.resolve().then(function () { return IconUmbrellaFilled$1; }),
  "user-filled": () => Promise.resolve().then(function () { return IconUserFilled$1; }),
  "versions-filled": () => Promise.resolve().then(function () { return IconVersionsFilled$1; }),
  "video-filled": () => Promise.resolve().then(function () { return IconVideoFilled$1; }),
  "windmill-filled": () => Promise.resolve().then(function () { return IconWindmillFilled$1; }),
  "windsock-filled": () => Promise.resolve().then(function () { return IconWindsockFilled$1; }),
  "woman-filled": () => Promise.resolve().then(function () { return IconWomanFilled$1; }),
  "xbox-a-filled": () => Promise.resolve().then(function () { return IconXboxAFilled$1; }),
  "xbox-b-filled": () => Promise.resolve().then(function () { return IconXboxBFilled$1; }),
  "xbox-x-filled": () => Promise.resolve().then(function () { return IconXboxXFilled$1; }),
  "xbox-y-filled": () => Promise.resolve().then(function () { return IconXboxYFilled$1; }),
  "yin-yang-filled": () => Promise.resolve().then(function () { return IconYinYangFilled$1; }),
  "zeppelin-filled": () => Promise.resolve().then(function () { return IconZeppelinFilled$1; }),
  "zoom-cancel-filled": () => Promise.resolve().then(function () { return IconZoomCancelFilled$1; }),
  "zoom-check-filled": () => Promise.resolve().then(function () { return IconZoomCheckFilled$1; }),
  "zoom-code-filled": () => Promise.resolve().then(function () { return IconZoomCodeFilled$1; }),
  "zoom-exclamation-filled": () => Promise.resolve().then(function () { return IconZoomExclamationFilled$1; }),
  "zoom-in-area-filled": () => Promise.resolve().then(function () { return IconZoomInAreaFilled$1; }),
  "zoom-in-filled": () => Promise.resolve().then(function () { return IconZoomInFilled$1; }),
  "zoom-money-filled": () => Promise.resolve().then(function () { return IconZoomMoneyFilled$1; }),
  "zoom-out-area-filled": () => Promise.resolve().then(function () { return IconZoomOutAreaFilled$1; }),
  "zoom-out-filled": () => Promise.resolve().then(function () { return IconZoomOutFilled$1; }),
  "zoom-pan-filled": () => Promise.resolve().then(function () { return IconZoomPanFilled$1; }),
  "zoom-question-filled": () => Promise.resolve().then(function () { return IconZoomQuestionFilled$1; }),
  "zoom-scan-filled": () => Promise.resolve().then(function () { return IconZoomScanFilled$1; }),
  "zoom-filled": () => Promise.resolve().then(function () { return IconZoomFilled$1; })
};

var dynamicImports$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: dynamicImports
});

exports.Icon123 = IconNumber123;
exports.Icon12Hours = IconHours12;
exports.Icon24Hours = IconHours24;
exports.Icon2fa = IconAuth2fa;
exports.Icon360 = IconView360Arrow;
exports.Icon360View = IconView360Number;
exports.Icon3dCubeSphere = IconCube3dSphere;
exports.Icon3dCubeSphereOff = IconCube3dSphereOff;
exports.Icon3dRotate = IconRotate3d;
exports.IconAB = IconAB;
exports.IconAB2 = IconAB2;
exports.IconABOff = IconABOff;
exports.IconAbacus = IconAbacus;
exports.IconAbacusOff = IconAbacusOff;
exports.IconAbc = IconAbc;
exports.IconAccessPoint = IconAccessPoint;
exports.IconAccessPointOff = IconAccessPointOff;
exports.IconAccessible = IconAccessible;
exports.IconAccessibleFilled = IconAccessibleFilled;
exports.IconAccessibleOff = IconAccessibleOff;
exports.IconActivity = IconActivity;
exports.IconActivityHeartbeat = IconActivityHeartbeat;
exports.IconAd = IconAd;
exports.IconAd2 = IconAd2;
exports.IconAdCircle = IconAdCircle;
exports.IconAdCircleFilled = IconAdCircleFilled;
exports.IconAdCircleOff = IconAdCircleOff;
exports.IconAdFilled = IconAdFilled;
exports.IconAdOff = IconAdOff;
exports.IconAddressBook = IconAddressBook;
exports.IconAddressBookOff = IconAddressBookOff;
exports.IconAdjustments = IconAdjustments;
exports.IconAdjustmentsAlt = IconAdjustmentsAlt;
exports.IconAdjustmentsBolt = IconAdjustmentsBolt;
exports.IconAdjustmentsCancel = IconAdjustmentsCancel;
exports.IconAdjustmentsCheck = IconAdjustmentsCheck;
exports.IconAdjustmentsCode = IconAdjustmentsCode;
exports.IconAdjustmentsCog = IconAdjustmentsCog;
exports.IconAdjustmentsDollar = IconAdjustmentsDollar;
exports.IconAdjustmentsDown = IconAdjustmentsDown;
exports.IconAdjustmentsExclamation = IconAdjustmentsExclamation;
exports.IconAdjustmentsFilled = IconAdjustmentsFilled;
exports.IconAdjustmentsHeart = IconAdjustmentsHeart;
exports.IconAdjustmentsHorizontal = IconAdjustmentsHorizontal;
exports.IconAdjustmentsMinus = IconAdjustmentsMinus;
exports.IconAdjustmentsOff = IconAdjustmentsOff;
exports.IconAdjustmentsPause = IconAdjustmentsPause;
exports.IconAdjustmentsPin = IconAdjustmentsPin;
exports.IconAdjustmentsPlus = IconAdjustmentsPlus;
exports.IconAdjustmentsQuestion = IconAdjustmentsQuestion;
exports.IconAdjustmentsSearch = IconAdjustmentsSearch;
exports.IconAdjustmentsShare = IconAdjustmentsShare;
exports.IconAdjustmentsSpark = IconAdjustmentsSpark;
exports.IconAdjustmentsStar = IconAdjustmentsStar;
exports.IconAdjustmentsUp = IconAdjustmentsUp;
exports.IconAdjustmentsX = IconAdjustmentsX;
exports.IconAerialLift = IconAerialLift;
exports.IconAerialLiftFilled = IconAerialLiftFilled;
exports.IconAffiliate = IconAffiliate;
exports.IconAffiliateFilled = IconAffiliateFilled;
exports.IconAi = IconAi;
exports.IconAirBalloon = IconAirBalloon;
exports.IconAirBalloonFilled = IconAirBalloonFilled;
exports.IconAirConditioning = IconAirConditioning;
exports.IconAirConditioningDisabled = IconAirConditioningDisabled;
exports.IconAirTrafficControl = IconAirTrafficControl;
exports.IconAlarm = IconAlarm;
exports.IconAlarmAverage = IconAlarmAverage;
exports.IconAlarmFilled = IconAlarmFilled;
exports.IconAlarmMinus = IconAlarmMinus;
exports.IconAlarmMinusFilled = IconAlarmMinusFilled;
exports.IconAlarmOff = IconAlarmOff;
exports.IconAlarmPlus = IconAlarmPlus;
exports.IconAlarmPlusFilled = IconAlarmPlusFilled;
exports.IconAlarmSmoke = IconAlarmSmoke;
exports.IconAlarmSnooze = IconAlarmSnooze;
exports.IconAlarmSnoozeFilled = IconAlarmSnoozeFilled;
exports.IconAlbum = IconAlbum;
exports.IconAlbumOff = IconAlbumOff;
exports.IconAlertCircle = IconAlertCircle;
exports.IconAlertCircleFilled = IconAlertCircleFilled;
exports.IconAlertCircleOff = IconAlertCircleOff;
exports.IconAlertHexagon = IconAlertHexagon;
exports.IconAlertHexagonFilled = IconAlertHexagonFilled;
exports.IconAlertHexagonOff = IconAlertHexagonOff;
exports.IconAlertOctagon = IconAlertOctagon;
exports.IconAlertOctagonFilled = IconAlertOctagonFilled;
exports.IconAlertSmall = IconAlertSmall;
exports.IconAlertSmallOff = IconAlertSmallOff;
exports.IconAlertSquare = IconAlertSquare;
exports.IconAlertSquareFilled = IconAlertSquareFilled;
exports.IconAlertSquareRounded = IconAlertSquareRounded;
exports.IconAlertSquareRoundedFilled = IconAlertSquareRoundedFilled;
exports.IconAlertSquareRoundedOff = IconAlertSquareRoundedOff;
exports.IconAlertTriangle = IconAlertTriangle;
exports.IconAlertTriangleFilled = IconAlertTriangleFilled;
exports.IconAlertTriangleOff = IconAlertTriangleOff;
exports.IconAlien = IconAlien;
exports.IconAlienFilled = IconAlienFilled;
exports.IconAlignBoxBottomCenter = IconAlignBoxBottomCenter;
exports.IconAlignBoxBottomCenterFilled = IconAlignBoxBottomCenterFilled;
exports.IconAlignBoxBottomLeft = IconAlignBoxBottomLeft;
exports.IconAlignBoxBottomLeftFilled = IconAlignBoxBottomLeftFilled;
exports.IconAlignBoxBottomRight = IconAlignBoxBottomRight;
exports.IconAlignBoxBottomRightFilled = IconAlignBoxBottomRightFilled;
exports.IconAlignBoxCenterBottom = IconAlignBoxCenterBottom;
exports.IconAlignBoxCenterMiddle = IconAlignBoxCenterMiddle;
exports.IconAlignBoxCenterMiddleFilled = IconAlignBoxCenterMiddleFilled;
exports.IconAlignBoxCenterStretch = IconAlignBoxCenterStretch;
exports.IconAlignBoxCenterTop = IconAlignBoxCenterTop;
exports.IconAlignBoxLeftBottom = IconAlignBoxLeftBottom;
exports.IconAlignBoxLeftBottomFilled = IconAlignBoxLeftBottomFilled;
exports.IconAlignBoxLeftMiddle = IconAlignBoxLeftMiddle;
exports.IconAlignBoxLeftMiddleFilled = IconAlignBoxLeftMiddleFilled;
exports.IconAlignBoxLeftStretch = IconAlignBoxLeftStretch;
exports.IconAlignBoxLeftTop = IconAlignBoxLeftTop;
exports.IconAlignBoxLeftTopFilled = IconAlignBoxLeftTopFilled;
exports.IconAlignBoxRightBottom = IconAlignBoxRightBottom;
exports.IconAlignBoxRightBottomFilled = IconAlignBoxRightBottomFilled;
exports.IconAlignBoxRightMiddle = IconAlignBoxRightMiddle;
exports.IconAlignBoxRightMiddleFilled = IconAlignBoxRightMiddleFilled;
exports.IconAlignBoxRightStretch = IconAlignBoxRightStretch;
exports.IconAlignBoxRightTop = IconAlignBoxRightTop;
exports.IconAlignBoxRightTopFilled = IconAlignBoxRightTopFilled;
exports.IconAlignBoxTopCenter = IconAlignBoxTopCenter;
exports.IconAlignBoxTopCenterFilled = IconAlignBoxTopCenterFilled;
exports.IconAlignBoxTopLeft = IconAlignBoxTopLeft;
exports.IconAlignBoxTopLeftFilled = IconAlignBoxTopLeftFilled;
exports.IconAlignBoxTopRight = IconAlignBoxTopRight;
exports.IconAlignBoxTopRightFilled = IconAlignBoxTopRightFilled;
exports.IconAlignCenter = IconAlignCenter;
exports.IconAlignJustified = IconAlignJustified;
exports.IconAlignLeft = IconAlignLeft;
exports.IconAlignLeft2 = IconAlignLeft2;
exports.IconAlignRight = IconAlignRight;
exports.IconAlignRight2 = IconAlignRight2;
exports.IconAlpha = IconAlpha;
exports.IconAlphabetArabic = IconAlphabetArabic;
exports.IconAlphabetBangla = IconAlphabetBangla;
exports.IconAlphabetCyrillic = IconAlphabetCyrillic;
exports.IconAlphabetGreek = IconAlphabetGreek;
exports.IconAlphabetHebrew = IconAlphabetHebrew;
exports.IconAlphabetKorean = IconAlphabetKorean;
exports.IconAlphabetLatin = IconAlphabetLatin;
exports.IconAlphabetThai = IconAlphabetThai;
exports.IconAlt = IconAlt;
exports.IconAmbulance = IconAmbulance;
exports.IconAmpersand = IconAmpersand;
exports.IconAnalyze = IconAnalyze;
exports.IconAnalyzeFilled = IconAnalyzeFilled;
exports.IconAnalyzeOff = IconAnalyzeOff;
exports.IconAnchor = IconAnchor;
exports.IconAnchorOff = IconAnchorOff;
exports.IconAngle = IconAngle;
exports.IconAnkh = IconAnkh;
exports.IconAntenna = IconAntenna;
exports.IconAntennaBars1 = IconAntennaBars1;
exports.IconAntennaBars2 = IconAntennaBars2;
exports.IconAntennaBars3 = IconAntennaBars3;
exports.IconAntennaBars4 = IconAntennaBars4;
exports.IconAntennaBars5 = IconAntennaBars5;
exports.IconAntennaBarsOff = IconAntennaBarsOff;
exports.IconAntennaOff = IconAntennaOff;
exports.IconAperture = IconAperture;
exports.IconApertureOff = IconApertureOff;
exports.IconApi = IconApi;
exports.IconApiApp = IconApiApp;
exports.IconApiAppOff = IconApiAppOff;
exports.IconApiOff = IconApiOff;
exports.IconAppWindow = IconAppWindow;
exports.IconAppWindowFilled = IconAppWindowFilled;
exports.IconApple = IconApple;
exports.IconAppleFilled = IconAppleFilled;
exports.IconApps = IconApps;
exports.IconAppsFilled = IconAppsFilled;
exports.IconAppsOff = IconAppsOff;
exports.IconArcheryArrow = IconArcheryArrow;
exports.IconArchive = IconArchive;
exports.IconArchiveFilled = IconArchiveFilled;
exports.IconArchiveOff = IconArchiveOff;
exports.IconArmchair = IconArmchair;
exports.IconArmchair2 = IconArmchair2;
exports.IconArmchair2Off = IconArmchair2Off;
exports.IconArmchairOff = IconArmchairOff;
exports.IconArrowAutofitContent = IconArrowAutofitContent;
exports.IconArrowAutofitContentFilled = IconArrowAutofitContentFilled;
exports.IconArrowAutofitDown = IconArrowAutofitDown;
exports.IconArrowAutofitDownFilled = IconArrowAutofitDownFilled;
exports.IconArrowAutofitHeight = IconArrowAutofitHeight;
exports.IconArrowAutofitHeightFilled = IconArrowAutofitHeightFilled;
exports.IconArrowAutofitLeft = IconArrowAutofitLeft;
exports.IconArrowAutofitLeftFilled = IconArrowAutofitLeftFilled;
exports.IconArrowAutofitRight = IconArrowAutofitRight;
exports.IconArrowAutofitRightFilled = IconArrowAutofitRightFilled;
exports.IconArrowAutofitUp = IconArrowAutofitUp;
exports.IconArrowAutofitUpFilled = IconArrowAutofitUpFilled;
exports.IconArrowAutofitWidth = IconArrowAutofitWidth;
exports.IconArrowAutofitWidthFilled = IconArrowAutofitWidthFilled;
exports.IconArrowBack = IconArrowBack;
exports.IconArrowBackUp = IconArrowBackUp;
exports.IconArrowBackUpDouble = IconArrowBackUpDouble;
exports.IconArrowBadgeDown = IconArrowBadgeDown;
exports.IconArrowBadgeDownFilled = IconArrowBadgeDownFilled;
exports.IconArrowBadgeLeft = IconArrowBadgeLeft;
exports.IconArrowBadgeLeftFilled = IconArrowBadgeLeftFilled;
exports.IconArrowBadgeRight = IconArrowBadgeRight;
exports.IconArrowBadgeRightFilled = IconArrowBadgeRightFilled;
exports.IconArrowBadgeUp = IconArrowBadgeUp;
exports.IconArrowBadgeUpFilled = IconArrowBadgeUpFilled;
exports.IconArrowBarBoth = IconArrowBarBoth;
exports.IconArrowBarDown = IconArrowBarDown;
exports.IconArrowBarLeft = IconArrowBarLeft;
exports.IconArrowBarRight = IconArrowBarRight;
exports.IconArrowBarToDown = IconArrowBarToDown;
exports.IconArrowBarToLeft = IconArrowBarToLeft;
exports.IconArrowBarToRight = IconArrowBarToRight;
exports.IconArrowBarToUp = IconArrowBarToUp;
exports.IconArrowBarUp = IconArrowBarUp;
exports.IconArrowBearLeft = IconArrowBearLeft;
exports.IconArrowBearLeft2 = IconArrowBearLeft2;
exports.IconArrowBearRight = IconArrowBearRight;
exports.IconArrowBearRight2 = IconArrowBearRight2;
exports.IconArrowBigDown = IconArrowBigDown;
exports.IconArrowBigDownFilled = IconArrowBigDownFilled;
exports.IconArrowBigDownLine = IconArrowBigDownLine;
exports.IconArrowBigDownLineFilled = IconArrowBigDownLineFilled;
exports.IconArrowBigDownLines = IconArrowBigDownLines;
exports.IconArrowBigDownLinesFilled = IconArrowBigDownLinesFilled;
exports.IconArrowBigLeft = IconArrowBigLeft;
exports.IconArrowBigLeftFilled = IconArrowBigLeftFilled;
exports.IconArrowBigLeftLine = IconArrowBigLeftLine;
exports.IconArrowBigLeftLineFilled = IconArrowBigLeftLineFilled;
exports.IconArrowBigLeftLines = IconArrowBigLeftLines;
exports.IconArrowBigLeftLinesFilled = IconArrowBigLeftLinesFilled;
exports.IconArrowBigRight = IconArrowBigRight;
exports.IconArrowBigRightFilled = IconArrowBigRightFilled;
exports.IconArrowBigRightLine = IconArrowBigRightLine;
exports.IconArrowBigRightLineFilled = IconArrowBigRightLineFilled;
exports.IconArrowBigRightLines = IconArrowBigRightLines;
exports.IconArrowBigRightLinesFilled = IconArrowBigRightLinesFilled;
exports.IconArrowBigUp = IconArrowBigUp;
exports.IconArrowBigUpFilled = IconArrowBigUpFilled;
exports.IconArrowBigUpLine = IconArrowBigUpLine;
exports.IconArrowBigUpLineFilled = IconArrowBigUpLineFilled;
exports.IconArrowBigUpLines = IconArrowBigUpLines;
exports.IconArrowBigUpLinesFilled = IconArrowBigUpLinesFilled;
exports.IconArrowBounce = IconArrowBounce;
exports.IconArrowCapsule = IconArrowCapsule;
exports.IconArrowCurveLeft = IconArrowCurveLeft;
exports.IconArrowCurveRight = IconArrowCurveRight;
exports.IconArrowDown = IconArrowDown;
exports.IconArrowDownBar = IconArrowDownBar;
exports.IconArrowDownCircle = IconArrowDownCircle;
exports.IconArrowDownCircleFilled = IconArrowDownCircleFilled;
exports.IconArrowDownDashed = IconArrowDownDashed;
exports.IconArrowDownFromArc = IconArrowDownFromArc;
exports.IconArrowDownLeft = IconArrowDownLeft;
exports.IconArrowDownLeftCircle = IconArrowDownLeftCircle;
exports.IconArrowDownRhombus = IconArrowDownRhombus;
exports.IconArrowDownRhombusFilled = IconArrowDownRhombusFilled;
exports.IconArrowDownRight = IconArrowDownRight;
exports.IconArrowDownRightCircle = IconArrowDownRightCircle;
exports.IconArrowDownSquare = IconArrowDownSquare;
exports.IconArrowDownSquareFilled = IconArrowDownSquareFilled;
exports.IconArrowDownTail = IconArrowDownTail;
exports.IconArrowDownToArc = IconArrowDownToArc;
exports.IconArrowElbowLeft = IconArrowElbowLeft;
exports.IconArrowElbowRight = IconArrowElbowRight;
exports.IconArrowFork = IconArrowFork;
exports.IconArrowForward = IconArrowForward;
exports.IconArrowForwardUp = IconArrowForwardUp;
exports.IconArrowForwardUpDouble = IconArrowForwardUpDouble;
exports.IconArrowGuide = IconArrowGuide;
exports.IconArrowGuideFilled = IconArrowGuideFilled;
exports.IconArrowIteration = IconArrowIteration;
exports.IconArrowLeft = IconArrowLeft;
exports.IconArrowLeftBar = IconArrowLeftBar;
exports.IconArrowLeftCircle = IconArrowLeftCircle;
exports.IconArrowLeftCircleFilled = IconArrowLeftCircleFilled;
exports.IconArrowLeftDashed = IconArrowLeftDashed;
exports.IconArrowLeftFromArc = IconArrowLeftFromArc;
exports.IconArrowLeftRhombus = IconArrowLeftRhombus;
exports.IconArrowLeftRhombusFilled = IconArrowLeftRhombusFilled;
exports.IconArrowLeftRight = IconArrowLeftRight;
exports.IconArrowLeftSquare = IconArrowLeftSquare;
exports.IconArrowLeftSquareFilled = IconArrowLeftSquareFilled;
exports.IconArrowLeftTail = IconArrowLeftTail;
exports.IconArrowLeftToArc = IconArrowLeftToArc;
exports.IconArrowLoopLeft = IconArrowLoopLeft;
exports.IconArrowLoopLeft2 = IconArrowLoopLeft2;
exports.IconArrowLoopRight = IconArrowLoopRight;
exports.IconArrowLoopRight2 = IconArrowLoopRight2;
exports.IconArrowMerge = IconArrowMerge;
exports.IconArrowMergeAltLeft = IconArrowMergeAltLeft;
exports.IconArrowMergeAltRight = IconArrowMergeAltRight;
exports.IconArrowMergeBoth = IconArrowMergeBoth;
exports.IconArrowMergeLeft = IconArrowMergeLeft;
exports.IconArrowMergeRight = IconArrowMergeRight;
exports.IconArrowMoveDown = IconArrowMoveDown;
exports.IconArrowMoveDownFilled = IconArrowMoveDownFilled;
exports.IconArrowMoveLeft = IconArrowMoveLeft;
exports.IconArrowMoveLeftFilled = IconArrowMoveLeftFilled;
exports.IconArrowMoveRight = IconArrowMoveRight;
exports.IconArrowMoveRightFilled = IconArrowMoveRightFilled;
exports.IconArrowMoveUp = IconArrowMoveUp;
exports.IconArrowMoveUpFilled = IconArrowMoveUpFilled;
exports.IconArrowNarrowDown = IconArrowNarrowDown;
exports.IconArrowNarrowDownDashed = IconArrowNarrowDownDashed;
exports.IconArrowNarrowLeft = IconArrowNarrowLeft;
exports.IconArrowNarrowLeftDashed = IconArrowNarrowLeftDashed;
exports.IconArrowNarrowRight = IconArrowNarrowRight;
exports.IconArrowNarrowRightDashed = IconArrowNarrowRightDashed;
exports.IconArrowNarrowUp = IconArrowNarrowUp;
exports.IconArrowNarrowUpDashed = IconArrowNarrowUpDashed;
exports.IconArrowRampLeft = IconArrowRampLeft;
exports.IconArrowRampLeft2 = IconArrowRampLeft2;
exports.IconArrowRampLeft3 = IconArrowRampLeft3;
exports.IconArrowRampRight = IconArrowRampRight;
exports.IconArrowRampRight2 = IconArrowRampRight2;
exports.IconArrowRampRight3 = IconArrowRampRight3;
exports.IconArrowRight = IconArrowRight;
exports.IconArrowRightBar = IconArrowRightBar;
exports.IconArrowRightCircle = IconArrowRightCircle;
exports.IconArrowRightCircleFilled = IconArrowRightCircleFilled;
exports.IconArrowRightDashed = IconArrowRightDashed;
exports.IconArrowRightFromArc = IconArrowRightFromArc;
exports.IconArrowRightRhombus = IconArrowRightRhombus;
exports.IconArrowRightRhombusFilled = IconArrowRightRhombusFilled;
exports.IconArrowRightSquare = IconArrowRightSquare;
exports.IconArrowRightSquareFilled = IconArrowRightSquareFilled;
exports.IconArrowRightTail = IconArrowRightTail;
exports.IconArrowRightToArc = IconArrowRightToArc;
exports.IconArrowRotaryFirstLeft = IconArrowRotaryFirstLeft;
exports.IconArrowRotaryFirstRight = IconArrowRotaryFirstRight;
exports.IconArrowRotaryLastLeft = IconArrowRotaryLastLeft;
exports.IconArrowRotaryLastRight = IconArrowRotaryLastRight;
exports.IconArrowRotaryLeft = IconArrowRotaryLeft;
exports.IconArrowRotaryRight = IconArrowRotaryRight;
exports.IconArrowRotaryStraight = IconArrowRotaryStraight;
exports.IconArrowRoundaboutLeft = IconArrowRoundaboutLeft;
exports.IconArrowRoundaboutRight = IconArrowRoundaboutRight;
exports.IconArrowSharpTurnLeft = IconArrowSharpTurnLeft;
exports.IconArrowSharpTurnRight = IconArrowSharpTurnRight;
exports.IconArrowUp = IconArrowUp;
exports.IconArrowUpBar = IconArrowUpBar;
exports.IconArrowUpCircle = IconArrowUpCircle;
exports.IconArrowUpCircleFilled = IconArrowUpCircleFilled;
exports.IconArrowUpDashed = IconArrowUpDashed;
exports.IconArrowUpFromArc = IconArrowUpFromArc;
exports.IconArrowUpLeft = IconArrowUpLeft;
exports.IconArrowUpLeftCircle = IconArrowUpLeftCircle;
exports.IconArrowUpRhombus = IconArrowUpRhombus;
exports.IconArrowUpRhombusFilled = IconArrowUpRhombusFilled;
exports.IconArrowUpRight = IconArrowUpRight;
exports.IconArrowUpRightCircle = IconArrowUpRightCircle;
exports.IconArrowUpSquare = IconArrowUpSquare;
exports.IconArrowUpSquareFilled = IconArrowUpSquareFilled;
exports.IconArrowUpTail = IconArrowUpTail;
exports.IconArrowUpToArc = IconArrowUpToArc;
exports.IconArrowWaveLeftDown = IconArrowWaveLeftDown;
exports.IconArrowWaveLeftUp = IconArrowWaveLeftUp;
exports.IconArrowWaveRightDown = IconArrowWaveRightDown;
exports.IconArrowWaveRightUp = IconArrowWaveRightUp;
exports.IconArrowZigZag = IconArrowZigZag;
exports.IconArrowsCross = IconArrowsCross;
exports.IconArrowsDiagonal = IconArrowsDiagonal;
exports.IconArrowsDiagonal2 = IconArrowsDiagonal2;
exports.IconArrowsDiagonalMinimize = IconArrowsDiagonalMinimize;
exports.IconArrowsDiagonalMinimize2 = IconArrowsDiagonalMinimize2;
exports.IconArrowsDiff = IconArrowsDiff;
exports.IconArrowsDoubleNeSw = IconArrowsDoubleNeSw;
exports.IconArrowsDoubleNwSe = IconArrowsDoubleNwSe;
exports.IconArrowsDoubleSeNw = IconArrowsDoubleSeNw;
exports.IconArrowsDoubleSwNe = IconArrowsDoubleSwNe;
exports.IconArrowsDown = IconArrowsDown;
exports.IconArrowsDownUp = IconArrowsDownUp;
exports.IconArrowsExchange = IconArrowsExchange;
exports.IconArrowsExchange2 = IconArrowsExchange2;
exports.IconArrowsHorizontal = IconArrowsHorizontal;
exports.IconArrowsJoin = IconArrowsJoin;
exports.IconArrowsJoin2 = IconArrowsJoin2;
exports.IconArrowsLeft = IconArrowsLeft;
exports.IconArrowsLeftDown = IconArrowsLeftDown;
exports.IconArrowsLeftRight = IconArrowsLeftRight;
exports.IconArrowsMaximize = IconArrowsMaximize;
exports.IconArrowsMinimize = IconArrowsMinimize;
exports.IconArrowsMove = IconArrowsMove;
exports.IconArrowsMoveHorizontal = IconArrowsMoveHorizontal;
exports.IconArrowsMoveVertical = IconArrowsMoveVertical;
exports.IconArrowsRandom = IconArrowsRandom;
exports.IconArrowsRight = IconArrowsRight;
exports.IconArrowsRightDown = IconArrowsRightDown;
exports.IconArrowsRightLeft = IconArrowsRightLeft;
exports.IconArrowsShuffle = IconArrowsShuffle;
exports.IconArrowsShuffle2 = IconArrowsShuffle2;
exports.IconArrowsSort = IconArrowsSort;
exports.IconArrowsSplit = IconArrowsSplit;
exports.IconArrowsSplit2 = IconArrowsSplit2;
exports.IconArrowsTransferDown = IconArrowsTransferDown;
exports.IconArrowsTransferUp = IconArrowsTransferUp;
exports.IconArrowsTransferUpDown = IconArrowsTransferUpDown;
exports.IconArrowsUp = IconArrowsUp;
exports.IconArrowsUpDown = IconArrowsUpDown;
exports.IconArrowsUpLeft = IconArrowsUpLeft;
exports.IconArrowsUpRight = IconArrowsUpRight;
exports.IconArrowsVertical = IconArrowsVertical;
exports.IconArtboard = IconArtboard;
exports.IconArtboardFilled = IconArtboardFilled;
exports.IconArtboardOff = IconArtboardOff;
exports.IconArticle = IconArticle;
exports.IconArticleFilled = IconArticleFilled;
exports.IconArticleOff = IconArticleOff;
exports.IconAspectRatio = IconAspectRatio;
exports.IconAspectRatioFilled = IconAspectRatioFilled;
exports.IconAspectRatioOff = IconAspectRatioOff;
exports.IconAssembly = IconAssembly;
exports.IconAssemblyFilled = IconAssemblyFilled;
exports.IconAssemblyOff = IconAssemblyOff;
exports.IconAsset = IconAsset;
exports.IconAssetFilled = IconAssetFilled;
exports.IconAsterisk = IconAsterisk;
exports.IconAsteriskSimple = IconAsteriskSimple;
exports.IconAt = IconAt;
exports.IconAtOff = IconAtOff;
exports.IconAtom = IconAtom;
exports.IconAtom2 = IconAtom2;
exports.IconAtom2Filled = IconAtom2Filled;
exports.IconAtomOff = IconAtomOff;
exports.IconAugmentedReality = IconAugmentedReality;
exports.IconAugmentedReality2 = IconAugmentedReality2;
exports.IconAugmentedRealityOff = IconAugmentedRealityOff;
exports.IconAuth2fa = IconAuth2fa;
exports.IconAutomaticGearbox = IconAutomaticGearbox;
exports.IconAutomaticGearboxFilled = IconAutomaticGearboxFilled;
exports.IconAutomation = IconAutomation;
exports.IconAvocado = IconAvocado;
exports.IconAward = IconAward;
exports.IconAwardFilled = IconAwardFilled;
exports.IconAwardOff = IconAwardOff;
exports.IconAxe = IconAxe;
exports.IconAxisX = IconAxisX;
exports.IconAxisY = IconAxisY;
exports.IconBabyBottle = IconBabyBottle;
exports.IconBabyCarriage = IconBabyCarriage;
exports.IconBabyCarriageFilled = IconBabyCarriageFilled;
exports.IconBackground = IconBackground;
exports.IconBackhoe = IconBackhoe;
exports.IconBackpack = IconBackpack;
exports.IconBackpackOff = IconBackpackOff;
exports.IconBackslash = IconBackslash;
exports.IconBackspace = IconBackspace;
exports.IconBackspaceFilled = IconBackspaceFilled;
exports.IconBadge = IconBadge;
exports.IconBadge2k = IconBadge2k;
exports.IconBadge3d = IconBadge3d;
exports.IconBadge3dFilled = IconBadge3dFilled;
exports.IconBadge3k = IconBadge3k;
exports.IconBadge4k = IconBadge4k;
exports.IconBadge4kFilled = IconBadge4kFilled;
exports.IconBadge5k = IconBadge5k;
exports.IconBadge8k = IconBadge8k;
exports.IconBadge8kFilled = IconBadge8kFilled;
exports.IconBadgeAd = IconBadgeAd;
exports.IconBadgeAdFilled = IconBadgeAdFilled;
exports.IconBadgeAdOff = IconBadgeAdOff;
exports.IconBadgeAr = IconBadgeAr;
exports.IconBadgeArFilled = IconBadgeArFilled;
exports.IconBadgeCc = IconBadgeCc;
exports.IconBadgeCcFilled = IconBadgeCcFilled;
exports.IconBadgeFilled = IconBadgeFilled;
exports.IconBadgeHd = IconBadgeHd;
exports.IconBadgeHdFilled = IconBadgeHdFilled;
exports.IconBadgeOff = IconBadgeOff;
exports.IconBadgeSd = IconBadgeSd;
exports.IconBadgeSdFilled = IconBadgeSdFilled;
exports.IconBadgeTm = IconBadgeTm;
exports.IconBadgeTmFilled = IconBadgeTmFilled;
exports.IconBadgeVo = IconBadgeVo;
exports.IconBadgeVoFilled = IconBadgeVoFilled;
exports.IconBadgeVr = IconBadgeVr;
exports.IconBadgeVrFilled = IconBadgeVrFilled;
exports.IconBadgeWc = IconBadgeWc;
exports.IconBadgeWcFilled = IconBadgeWcFilled;
exports.IconBadges = IconBadges;
exports.IconBadgesFilled = IconBadgesFilled;
exports.IconBadgesOff = IconBadgesOff;
exports.IconBaguette = IconBaguette;
exports.IconBallAmericanFootball = IconBallAmericanFootball;
exports.IconBallAmericanFootballOff = IconBallAmericanFootballOff;
exports.IconBallBaseball = IconBallBaseball;
exports.IconBallBasketball = IconBallBasketball;
exports.IconBallBowling = IconBallBowling;
exports.IconBallFootball = IconBallFootball;
exports.IconBallFootballOff = IconBallFootballOff;
exports.IconBallTennis = IconBallTennis;
exports.IconBallVolleyball = IconBallVolleyball;
exports.IconBalloon = IconBalloon;
exports.IconBalloonFilled = IconBalloonFilled;
exports.IconBalloonOff = IconBalloonOff;
exports.IconBallpen = IconBallpen;
exports.IconBallpenFilled = IconBallpenFilled;
exports.IconBallpenOff = IconBallpenOff;
exports.IconBan = IconBan;
exports.IconBandage = IconBandage;
exports.IconBandageFilled = IconBandageFilled;
exports.IconBandageOff = IconBandageOff;
exports.IconBarbell = IconBarbell;
exports.IconBarbellFilled = IconBarbellFilled;
exports.IconBarbellOff = IconBarbellOff;
exports.IconBarcode = IconBarcode;
exports.IconBarcodeOff = IconBarcodeOff;
exports.IconBarrel = IconBarrel;
exports.IconBarrelOff = IconBarrelOff;
exports.IconBarrierBlock = IconBarrierBlock;
exports.IconBarrierBlockFilled = IconBarrierBlockFilled;
exports.IconBarrierBlockOff = IconBarrierBlockOff;
exports.IconBaseline = IconBaseline;
exports.IconBaselineDensityLarge = IconBaselineDensityLarge;
exports.IconBaselineDensityMedium = IconBaselineDensityMedium;
exports.IconBaselineDensitySmall = IconBaselineDensitySmall;
exports.IconBasket = IconBasket;
exports.IconBasketBolt = IconBasketBolt;
exports.IconBasketCancel = IconBasketCancel;
exports.IconBasketCheck = IconBasketCheck;
exports.IconBasketCode = IconBasketCode;
exports.IconBasketCog = IconBasketCog;
exports.IconBasketDiscount = IconBasketDiscount;
exports.IconBasketDollar = IconBasketDollar;
exports.IconBasketDown = IconBasketDown;
exports.IconBasketExclamation = IconBasketExclamation;
exports.IconBasketFilled = IconBasketFilled;
exports.IconBasketHeart = IconBasketHeart;
exports.IconBasketMinus = IconBasketMinus;
exports.IconBasketOff = IconBasketOff;
exports.IconBasketPause = IconBasketPause;
exports.IconBasketPin = IconBasketPin;
exports.IconBasketPlus = IconBasketPlus;
exports.IconBasketQuestion = IconBasketQuestion;
exports.IconBasketSearch = IconBasketSearch;
exports.IconBasketShare = IconBasketShare;
exports.IconBasketStar = IconBasketStar;
exports.IconBasketUp = IconBasketUp;
exports.IconBasketX = IconBasketX;
exports.IconBat = IconBat;
exports.IconBath = IconBath;
exports.IconBathFilled = IconBathFilled;
exports.IconBathOff = IconBathOff;
exports.IconBattery = IconBattery;
exports.IconBattery1 = IconBattery1;
exports.IconBattery1Filled = IconBattery1Filled;
exports.IconBattery2 = IconBattery2;
exports.IconBattery2Filled = IconBattery2Filled;
exports.IconBattery3 = IconBattery3;
exports.IconBattery3Filled = IconBattery3Filled;
exports.IconBattery4 = IconBattery4;
exports.IconBattery4Filled = IconBattery4Filled;
exports.IconBatteryAutomotive = IconBatteryAutomotive;
exports.IconBatteryAutomotiveFilled = IconBatteryAutomotiveFilled;
exports.IconBatteryCharging = IconBatteryCharging;
exports.IconBatteryCharging2 = IconBatteryCharging2;
exports.IconBatteryEco = IconBatteryEco;
exports.IconBatteryExclamation = IconBatteryExclamation;
exports.IconBatteryFilled = IconBatteryFilled;
exports.IconBatteryOff = IconBatteryOff;
exports.IconBatterySpark = IconBatterySpark;
exports.IconBatteryVertical = IconBatteryVertical;
exports.IconBatteryVertical1 = IconBatteryVertical1;
exports.IconBatteryVertical1Filled = IconBatteryVertical1Filled;
exports.IconBatteryVertical2 = IconBatteryVertical2;
exports.IconBatteryVertical2Filled = IconBatteryVertical2Filled;
exports.IconBatteryVertical3 = IconBatteryVertical3;
exports.IconBatteryVertical3Filled = IconBatteryVertical3Filled;
exports.IconBatteryVertical4 = IconBatteryVertical4;
exports.IconBatteryVertical4Filled = IconBatteryVertical4Filled;
exports.IconBatteryVerticalCharging = IconBatteryVerticalCharging;
exports.IconBatteryVerticalCharging2 = IconBatteryVerticalCharging2;
exports.IconBatteryVerticalEco = IconBatteryVerticalEco;
exports.IconBatteryVerticalExclamation = IconBatteryVerticalExclamation;
exports.IconBatteryVerticalFilled = IconBatteryVerticalFilled;
exports.IconBatteryVerticalOff = IconBatteryVerticalOff;
exports.IconBeach = IconBeach;
exports.IconBeachOff = IconBeachOff;
exports.IconBed = IconBed;
exports.IconBedFilled = IconBedFilled;
exports.IconBedFlat = IconBedFlat;
exports.IconBedFlatFilled = IconBedFlatFilled;
exports.IconBedOff = IconBedOff;
exports.IconBeer = IconBeer;
exports.IconBeerFilled = IconBeerFilled;
exports.IconBeerOff = IconBeerOff;
exports.IconBell = IconBell;
exports.IconBellBolt = IconBellBolt;
exports.IconBellCancel = IconBellCancel;
exports.IconBellCheck = IconBellCheck;
exports.IconBellCode = IconBellCode;
exports.IconBellCog = IconBellCog;
exports.IconBellDollar = IconBellDollar;
exports.IconBellDown = IconBellDown;
exports.IconBellExclamation = IconBellExclamation;
exports.IconBellFilled = IconBellFilled;
exports.IconBellHeart = IconBellHeart;
exports.IconBellMinus = IconBellMinus;
exports.IconBellMinusFilled = IconBellMinusFilled;
exports.IconBellOff = IconBellOff;
exports.IconBellPause = IconBellPause;
exports.IconBellPin = IconBellPin;
exports.IconBellPlus = IconBellPlus;
exports.IconBellPlusFilled = IconBellPlusFilled;
exports.IconBellQuestion = IconBellQuestion;
exports.IconBellRinging = IconBellRinging;
exports.IconBellRinging2 = IconBellRinging2;
exports.IconBellRinging2Filled = IconBellRinging2Filled;
exports.IconBellRingingFilled = IconBellRingingFilled;
exports.IconBellSchool = IconBellSchool;
exports.IconBellSearch = IconBellSearch;
exports.IconBellShare = IconBellShare;
exports.IconBellStar = IconBellStar;
exports.IconBellUp = IconBellUp;
exports.IconBellX = IconBellX;
exports.IconBellXFilled = IconBellXFilled;
exports.IconBellZ = IconBellZ;
exports.IconBellZFilled = IconBellZFilled;
exports.IconBeta = IconBeta;
exports.IconBible = IconBible;
exports.IconBike = IconBike;
exports.IconBikeFilled = IconBikeFilled;
exports.IconBikeOff = IconBikeOff;
exports.IconBinary = IconBinary;
exports.IconBinaryOff = IconBinaryOff;
exports.IconBinaryTree = IconBinaryTree;
exports.IconBinaryTree2 = IconBinaryTree2;
exports.IconBinaryTree2Filled = IconBinaryTree2Filled;
exports.IconBinaryTreeFilled = IconBinaryTreeFilled;
exports.IconBinoculars = IconBinoculars;
exports.IconBinocularsFilled = IconBinocularsFilled;
exports.IconBiohazard = IconBiohazard;
exports.IconBiohazardFilled = IconBiohazardFilled;
exports.IconBiohazardOff = IconBiohazardOff;
exports.IconBlade = IconBlade;
exports.IconBladeFilled = IconBladeFilled;
exports.IconBleach = IconBleach;
exports.IconBleachChlorine = IconBleachChlorine;
exports.IconBleachNoChlorine = IconBleachNoChlorine;
exports.IconBleachOff = IconBleachOff;
exports.IconBlendMode = IconBlendMode;
exports.IconBlender = IconBlender;
exports.IconBlenderFilled = IconBlenderFilled;
exports.IconBlob = IconBlob;
exports.IconBlobFilled = IconBlobFilled;
exports.IconBlockquote = IconBlockquote;
exports.IconBlocks = IconBlocks;
exports.IconBluetooth = IconBluetooth;
exports.IconBluetoothConnected = IconBluetoothConnected;
exports.IconBluetoothOff = IconBluetoothOff;
exports.IconBluetoothX = IconBluetoothX;
exports.IconBlur = IconBlur;
exports.IconBlurOff = IconBlurOff;
exports.IconBmp = IconBmp;
exports.IconBodyScan = IconBodyScan;
exports.IconBold = IconBold;
exports.IconBoldOff = IconBoldOff;
exports.IconBolt = IconBolt;
exports.IconBoltFilled = IconBoltFilled;
exports.IconBoltOff = IconBoltOff;
exports.IconBomb = IconBomb;
exports.IconBombFilled = IconBombFilled;
exports.IconBone = IconBone;
exports.IconBoneFilled = IconBoneFilled;
exports.IconBoneOff = IconBoneOff;
exports.IconBong = IconBong;
exports.IconBongFilled = IconBongFilled;
exports.IconBongOff = IconBongOff;
exports.IconBook = IconBook;
exports.IconBook2 = IconBook2;
exports.IconBookDownload = IconBookDownload;
exports.IconBookFilled = IconBookFilled;
exports.IconBookOff = IconBookOff;
exports.IconBookUpload = IconBookUpload;
exports.IconBookmark = IconBookmark;
exports.IconBookmarkAi = IconBookmarkAi;
exports.IconBookmarkEdit = IconBookmarkEdit;
exports.IconBookmarkFilled = IconBookmarkFilled;
exports.IconBookmarkMinus = IconBookmarkMinus;
exports.IconBookmarkOff = IconBookmarkOff;
exports.IconBookmarkPlus = IconBookmarkPlus;
exports.IconBookmarkQuestion = IconBookmarkQuestion;
exports.IconBookmarks = IconBookmarks;
exports.IconBookmarksFilled = IconBookmarksFilled;
exports.IconBookmarksOff = IconBookmarksOff;
exports.IconBooks = IconBooks;
exports.IconBooksOff = IconBooksOff;
exports.IconBoom = IconBoom;
exports.IconBoomFilled = IconBoomFilled;
exports.IconBorderAll = IconBorderAll;
exports.IconBorderBottom = IconBorderBottom;
exports.IconBorderBottomPlus = IconBorderBottomPlus;
exports.IconBorderCornerIos = IconBorderCornerIos;
exports.IconBorderCornerPill = IconBorderCornerPill;
exports.IconBorderCornerRounded = IconBorderCornerRounded;
exports.IconBorderCornerSquare = IconBorderCornerSquare;
exports.IconBorderCorners = IconBorderCorners;
exports.IconBorderHorizontal = IconBorderHorizontal;
exports.IconBorderInner = IconBorderInner;
exports.IconBorderLeft = IconBorderLeft;
exports.IconBorderLeftPlus = IconBorderLeftPlus;
exports.IconBorderNone = IconBorderNone;
exports.IconBorderOuter = IconBorderOuter;
exports.IconBorderRadius = IconBorderRadius;
exports.IconBorderRight = IconBorderRight;
exports.IconBorderRightPlus = IconBorderRightPlus;
exports.IconBorderSides = IconBorderSides;
exports.IconBorderStyle = IconBorderStyle;
exports.IconBorderStyle2 = IconBorderStyle2;
exports.IconBorderTop = IconBorderTop;
exports.IconBorderTopPlus = IconBorderTopPlus;
exports.IconBorderVertical = IconBorderVertical;
exports.IconBottle = IconBottle;
exports.IconBottleFilled = IconBottleFilled;
exports.IconBottleOff = IconBottleOff;
exports.IconBounceLeft = IconBounceLeft;
exports.IconBounceLeftFilled = IconBounceLeftFilled;
exports.IconBounceRight = IconBounceRight;
exports.IconBounceRightFilled = IconBounceRightFilled;
exports.IconBow = IconBow;
exports.IconBowFilled = IconBowFilled;
exports.IconBowl = IconBowl;
exports.IconBowlChopsticks = IconBowlChopsticks;
exports.IconBowlChopsticksFilled = IconBowlChopsticksFilled;
exports.IconBowlFilled = IconBowlFilled;
exports.IconBowlSpoon = IconBowlSpoon;
exports.IconBowlSpoonFilled = IconBowlSpoonFilled;
exports.IconBowling = IconBowling;
exports.IconBox = IconBox;
exports.IconBoxAlignBottom = IconBoxAlignBottom;
exports.IconBoxAlignBottomFilled = IconBoxAlignBottomFilled;
exports.IconBoxAlignBottomLeft = IconBoxAlignBottomLeft;
exports.IconBoxAlignBottomLeftFilled = IconBoxAlignBottomLeftFilled;
exports.IconBoxAlignBottomRight = IconBoxAlignBottomRight;
exports.IconBoxAlignBottomRightFilled = IconBoxAlignBottomRightFilled;
exports.IconBoxAlignLeft = IconBoxAlignLeft;
exports.IconBoxAlignLeftFilled = IconBoxAlignLeftFilled;
exports.IconBoxAlignRight = IconBoxAlignRight;
exports.IconBoxAlignRightFilled = IconBoxAlignRightFilled;
exports.IconBoxAlignTop = IconBoxAlignTop;
exports.IconBoxAlignTopFilled = IconBoxAlignTopFilled;
exports.IconBoxAlignTopLeft = IconBoxAlignTopLeft;
exports.IconBoxAlignTopLeftFilled = IconBoxAlignTopLeftFilled;
exports.IconBoxAlignTopRight = IconBoxAlignTopRight;
exports.IconBoxAlignTopRightFilled = IconBoxAlignTopRightFilled;
exports.IconBoxMargin = IconBoxMargin;
exports.IconBoxModel = IconBoxModel;
exports.IconBoxModel2 = IconBoxModel2;
exports.IconBoxModel2Off = IconBoxModel2Off;
exports.IconBoxModelOff = IconBoxModelOff;
exports.IconBoxMultiple = IconBoxMultiple;
exports.IconBoxMultiple0 = IconBoxMultiple0;
exports.IconBoxMultiple1 = IconBoxMultiple1;
exports.IconBoxMultiple2 = IconBoxMultiple2;
exports.IconBoxMultiple3 = IconBoxMultiple3;
exports.IconBoxMultiple4 = IconBoxMultiple4;
exports.IconBoxMultiple5 = IconBoxMultiple5;
exports.IconBoxMultiple6 = IconBoxMultiple6;
exports.IconBoxMultiple7 = IconBoxMultiple7;
exports.IconBoxMultiple8 = IconBoxMultiple8;
exports.IconBoxMultiple9 = IconBoxMultiple9;
exports.IconBoxMultipleFilled = IconBoxMultipleFilled;
exports.IconBoxOff = IconBoxOff;
exports.IconBoxPadding = IconBoxPadding;
exports.IconBoxSeam = IconPackage;
exports.IconBraces = IconBraces;
exports.IconBracesOff = IconBracesOff;
exports.IconBrackets = IconBrackets;
exports.IconBracketsAngle = IconBracketsAngle;
exports.IconBracketsAngleOff = IconBracketsAngleOff;
exports.IconBracketsContain = IconBracketsContain;
exports.IconBracketsContainEnd = IconBracketsContainEnd;
exports.IconBracketsContainStart = IconBracketsContainStart;
exports.IconBracketsOff = IconBracketsOff;
exports.IconBraille = IconBraille;
exports.IconBrain = IconBrain;
exports.IconBrand4chan = IconBrand4chan;
exports.IconBrandAbstract = IconBrandAbstract;
exports.IconBrandAdobe = IconBrandAdobe;
exports.IconBrandAdobeAfterEffect = IconBrandAdobeAfterEffect;
exports.IconBrandAdobeIllustrator = IconBrandAdobeIllustrator;
exports.IconBrandAdobeIndesign = IconBrandAdobeIndesign;
exports.IconBrandAdobePhotoshop = IconBrandAdobePhotoshop;
exports.IconBrandAdobePremier = IconBrandAdobePremier;
exports.IconBrandAdobeXd = IconBrandAdobeXd;
exports.IconBrandAdonisJs = IconBrandAdonisJs;
exports.IconBrandAirbnb = IconBrandAirbnb;
exports.IconBrandAirtable = IconBrandAirtable;
exports.IconBrandAlgolia = IconBrandAlgolia;
exports.IconBrandAlipay = IconBrandAlipay;
exports.IconBrandAlpineJs = IconBrandAlpineJs;
exports.IconBrandAmazon = IconBrandAmazon;
exports.IconBrandAmd = IconBrandAmd;
exports.IconBrandAmie = IconBrandAmie;
exports.IconBrandAmigo = IconBrandAmigo;
exports.IconBrandAmongUs = IconBrandAmongUs;
exports.IconBrandAndroid = IconBrandAndroid;
exports.IconBrandAngular = IconBrandAngular;
exports.IconBrandAngularFilled = IconBrandAngularFilled;
exports.IconBrandAnsible = IconBrandAnsible;
exports.IconBrandAo3 = IconBrandAo3;
exports.IconBrandAppgallery = IconBrandAppgallery;
exports.IconBrandApple = IconBrandApple;
exports.IconBrandAppleArcade = IconBrandAppleArcade;
exports.IconBrandAppleFilled = IconBrandAppleFilled;
exports.IconBrandAppleNews = IconBrandAppleNews;
exports.IconBrandApplePodcast = IconBrandApplePodcast;
exports.IconBrandAppstore = IconBrandAppstore;
exports.IconBrandArc = IconBrandArc;
exports.IconBrandAsana = IconBrandAsana;
exports.IconBrandAstro = IconBrandAstro;
exports.IconBrandAuth0 = IconBrandAuth0;
exports.IconBrandAws = IconBrandAws;
exports.IconBrandAzure = IconBrandAzure;
exports.IconBrandBackbone = IconBrandBackbone;
exports.IconBrandBadoo = IconBrandBadoo;
exports.IconBrandBaidu = IconBrandBaidu;
exports.IconBrandBandcamp = IconBrandBandcamp;
exports.IconBrandBandlab = IconBrandBandlab;
exports.IconBrandBeats = IconBrandBeats;
exports.IconBrandBebo = IconBrandBebo;
exports.IconBrandBehance = IconBrandBehance;
exports.IconBrandBilibili = IconBrandBilibili;
exports.IconBrandBinance = IconBrandBinance;
exports.IconBrandBing = IconBrandBing;
exports.IconBrandBitbucket = IconBrandBitbucket;
exports.IconBrandBitbucketFilled = IconBrandBitbucketFilled;
exports.IconBrandBlackberry = IconBrandBlackberry;
exports.IconBrandBlender = IconBrandBlender;
exports.IconBrandBlogger = IconBrandBlogger;
exports.IconBrandBluesky = IconBrandBluesky;
exports.IconBrandBooking = IconBrandBooking;
exports.IconBrandBootstrap = IconBrandBootstrap;
exports.IconBrandBulma = IconBrandBulma;
exports.IconBrandBumble = IconBrandBumble;
exports.IconBrandBunpo = IconBrandBunpo;
exports.IconBrandCSharp = IconBrandCSharp;
exports.IconBrandCake = IconBrandCake;
exports.IconBrandCakephp = IconBrandCakephp;
exports.IconBrandCampaignmonitor = IconBrandCampaignmonitor;
exports.IconBrandCarbon = IconBrandCarbon;
exports.IconBrandCashapp = IconBrandCashapp;
exports.IconBrandChrome = IconBrandChrome;
exports.IconBrandCinema4d = IconBrandCinema4d;
exports.IconBrandCitymapper = IconBrandCitymapper;
exports.IconBrandCloudflare = IconBrandCloudflare;
exports.IconBrandCodecov = IconBrandCodecov;
exports.IconBrandCodepen = IconBrandCodepen;
exports.IconBrandCodesandbox = IconBrandCodesandbox;
exports.IconBrandCohost = IconBrandCohost;
exports.IconBrandCoinbase = IconBrandCoinbase;
exports.IconBrandComedyCentral = IconBrandComedyCentral;
exports.IconBrandCoreos = IconBrandCoreos;
exports.IconBrandCouchdb = IconBrandCouchdb;
exports.IconBrandCouchsurfing = IconBrandCouchsurfing;
exports.IconBrandCpp = IconBrandCpp;
exports.IconBrandCraft = IconBrandCraft;
exports.IconBrandCrunchbase = IconBrandCrunchbase;
exports.IconBrandCss3 = IconBrandCss3;
exports.IconBrandCtemplar = IconBrandCtemplar;
exports.IconBrandCucumber = IconBrandCucumber;
exports.IconBrandCupra = IconBrandCupra;
exports.IconBrandCypress = IconBrandCypress;
exports.IconBrandD3 = IconBrandD3;
exports.IconBrandDatabricks = IconBrandDatabricks;
exports.IconBrandDaysCounter = IconBrandDaysCounter;
exports.IconBrandDcos = IconBrandDcos;
exports.IconBrandDebian = IconBrandDebian;
exports.IconBrandDeezer = IconBrandDeezer;
exports.IconBrandDeliveroo = IconBrandDeliveroo;
exports.IconBrandDeno = IconBrandDeno;
exports.IconBrandDenodo = IconBrandDenodo;
exports.IconBrandDeviantart = IconBrandDeviantart;
exports.IconBrandDigg = IconBrandDigg;
exports.IconBrandDingtalk = IconBrandDingtalk;
exports.IconBrandDiscord = IconBrandDiscord;
exports.IconBrandDiscordFilled = IconBrandDiscordFilled;
exports.IconBrandDisney = IconBrandDisney;
exports.IconBrandDisqus = IconBrandDisqus;
exports.IconBrandDjango = IconBrandDjango;
exports.IconBrandDocker = IconBrandDocker;
exports.IconBrandDoctrine = IconBrandDoctrine;
exports.IconBrandDolbyDigital = IconBrandDolbyDigital;
exports.IconBrandDouban = IconBrandDouban;
exports.IconBrandDribbble = IconBrandDribbble;
exports.IconBrandDribbbleFilled = IconBrandDribbbleFilled;
exports.IconBrandDrops = IconBrandDrops;
exports.IconBrandDrupal = IconBrandDrupal;
exports.IconBrandEdge = IconBrandEdge;
exports.IconBrandElastic = IconBrandElastic;
exports.IconBrandElectronicArts = IconBrandElectronicArts;
exports.IconBrandEmber = IconBrandEmber;
exports.IconBrandEnvato = IconBrandEnvato;
exports.IconBrandEtsy = IconBrandEtsy;
exports.IconBrandEvernote = IconBrandEvernote;
exports.IconBrandFacebook = IconBrandFacebook;
exports.IconBrandFacebookFilled = IconBrandFacebookFilled;
exports.IconBrandFeedly = IconBrandFeedly;
exports.IconBrandFigma = IconBrandFigma;
exports.IconBrandFilezilla = IconBrandFilezilla;
exports.IconBrandFinder = IconBrandFinder;
exports.IconBrandFirebase = IconBrandFirebase;
exports.IconBrandFirefox = IconBrandFirefox;
exports.IconBrandFiverr = IconBrandFiverr;
exports.IconBrandFlickr = IconBrandFlickr;
exports.IconBrandFlightradar24 = IconBrandFlightradar24;
exports.IconBrandFlipboard = IconBrandFlipboard;
exports.IconBrandFlutter = IconBrandFlutter;
exports.IconBrandFortnite = IconBrandFortnite;
exports.IconBrandFoursquare = IconBrandFoursquare;
exports.IconBrandFramer = IconBrandFramer;
exports.IconBrandFramerMotion = IconBrandFramerMotion;
exports.IconBrandFunimation = IconBrandFunimation;
exports.IconBrandGatsby = IconBrandGatsby;
exports.IconBrandGit = IconBrandGit;
exports.IconBrandGithub = IconBrandGithub;
exports.IconBrandGithubCopilot = IconBrandGithubCopilot;
exports.IconBrandGithubFilled = IconBrandGithubFilled;
exports.IconBrandGitlab = IconBrandGitlab;
exports.IconBrandGmail = IconBrandGmail;
exports.IconBrandGolang = IconBrandGolang;
exports.IconBrandGoogle = IconBrandGoogle;
exports.IconBrandGoogleAnalytics = IconBrandGoogleAnalytics;
exports.IconBrandGoogleBigQuery = IconBrandGoogleBigQuery;
exports.IconBrandGoogleDrive = IconBrandGoogleDrive;
exports.IconBrandGoogleFilled = IconBrandGoogleFilled;
exports.IconBrandGoogleFit = IconBrandGoogleFit;
exports.IconBrandGoogleHome = IconBrandGoogleHome;
exports.IconBrandGoogleMaps = IconBrandGoogleMaps;
exports.IconBrandGoogleOne = IconBrandGoogleOne;
exports.IconBrandGooglePhotos = IconBrandGooglePhotos;
exports.IconBrandGooglePlay = IconBrandGooglePlay;
exports.IconBrandGooglePodcasts = IconBrandGooglePodcasts;
exports.IconBrandGrammarly = IconBrandGrammarly;
exports.IconBrandGraphql = IconBrandGraphql;
exports.IconBrandGravatar = IconBrandGravatar;
exports.IconBrandGrindr = IconBrandGrindr;
exports.IconBrandGuardian = IconBrandGuardian;
exports.IconBrandGumroad = IconBrandGumroad;
exports.IconBrandHackerrank = IconBrandHackerrank;
exports.IconBrandHbo = IconBrandHbo;
exports.IconBrandHeadlessui = IconBrandHeadlessui;
exports.IconBrandHexo = IconBrandHexo;
exports.IconBrandHipchat = IconBrandHipchat;
exports.IconBrandHtml5 = IconBrandHtml5;
exports.IconBrandInertia = IconBrandInertia;
exports.IconBrandInstagram = IconBrandInstagram;
exports.IconBrandInstagramFilled = IconBrandInstagramFilled;
exports.IconBrandIntercom = IconBrandIntercom;
exports.IconBrandItch = IconBrandItch;
exports.IconBrandJavascript = IconBrandJavascript;
exports.IconBrandJuejin = IconBrandJuejin;
exports.IconBrandKakoTalk = IconBrandKakoTalk;
exports.IconBrandKbin = IconBrandKbin;
exports.IconBrandKick = IconBrandKick;
exports.IconBrandKickFilled = IconBrandKickFilled;
exports.IconBrandKickstarter = IconBrandKickstarter;
exports.IconBrandKotlin = IconBrandKotlin;
exports.IconBrandLaravel = IconBrandLaravel;
exports.IconBrandLastfm = IconBrandLastfm;
exports.IconBrandLeetcode = IconBrandLeetcode;
exports.IconBrandLetterboxd = IconBrandLetterboxd;
exports.IconBrandLine = IconBrandLine;
exports.IconBrandLinkedin = IconBrandLinkedin;
exports.IconBrandLinkedinFilled = IconBrandLinkedinFilled;
exports.IconBrandLinktree = IconBrandLinktree;
exports.IconBrandLinqpad = IconBrandLinqpad;
exports.IconBrandLivewire = IconBrandLivewire;
exports.IconBrandLoom = IconBrandLoom;
exports.IconBrandMailgun = IconBrandMailgun;
exports.IconBrandMantine = IconBrandMantine;
exports.IconBrandMastercard = IconBrandMastercard;
exports.IconBrandMastodon = IconBrandMastodon;
exports.IconBrandMatrix = IconBrandMatrix;
exports.IconBrandMcdonalds = IconBrandMcdonalds;
exports.IconBrandMedium = IconBrandMedium;
exports.IconBrandMeetup = IconBrandMeetup;
exports.IconBrandMercedes = IconBrandMercedes;
exports.IconBrandMessenger = IconBrandMessenger;
exports.IconBrandMessengerFilled = IconBrandMessengerFilled;
exports.IconBrandMeta = IconBrandMeta;
exports.IconBrandMetabrainz = IconBrandMetabrainz;
exports.IconBrandMinecraft = IconBrandMinecraft;
exports.IconBrandMiniprogram = IconBrandMiniprogram;
exports.IconBrandMixpanel = IconBrandMixpanel;
exports.IconBrandMonday = IconBrandMonday;
exports.IconBrandMongodb = IconBrandMongodb;
exports.IconBrandMyOppo = IconBrandMyOppo;
exports.IconBrandMysql = IconBrandMysql;
exports.IconBrandNationalGeographic = IconBrandNationalGeographic;
exports.IconBrandNem = IconBrandNem;
exports.IconBrandNetbeans = IconBrandNetbeans;
exports.IconBrandNeteaseMusic = IconBrandNeteaseMusic;
exports.IconBrandNetflix = IconBrandNetflix;
exports.IconBrandNexo = IconBrandNexo;
exports.IconBrandNextcloud = IconBrandNextcloud;
exports.IconBrandNextjs = IconBrandNextjs;
exports.IconBrandNodejs = IconBrandNodejs;
exports.IconBrandNordVpn = IconBrandNordVpn;
exports.IconBrandNotion = IconBrandNotion;
exports.IconBrandNpm = IconBrandNpm;
exports.IconBrandNuxt = IconBrandNuxt;
exports.IconBrandNytimes = IconBrandNytimes;
exports.IconBrandOauth = IconBrandOauth;
exports.IconBrandOffice = IconBrandOffice;
exports.IconBrandOkRu = IconBrandOkRu;
exports.IconBrandOnedrive = IconBrandOnedrive;
exports.IconBrandOnlyfans = IconBrandOnlyfans;
exports.IconBrandOpenSource = IconBrandOpenSource;
exports.IconBrandOpenSourceFilled = IconBrandOpenSourceFilled;
exports.IconBrandOpenai = IconBrandOpenai;
exports.IconBrandOpenvpn = IconBrandOpenvpn;
exports.IconBrandOpera = IconBrandOpera;
exports.IconBrandOperaFilled = IconBrandOperaFilled;
exports.IconBrandPagekit = IconBrandPagekit;
exports.IconBrandParsinta = IconBrandParsinta;
exports.IconBrandPatreon = IconBrandPatreon;
exports.IconBrandPatreonFilled = IconBrandPatreonFilled;
exports.IconBrandPaypal = IconBrandPaypal;
exports.IconBrandPaypalFilled = IconBrandPaypalFilled;
exports.IconBrandPaypay = IconBrandPaypay;
exports.IconBrandPeanut = IconBrandPeanut;
exports.IconBrandPepsi = IconBrandPepsi;
exports.IconBrandPhp = IconBrandPhp;
exports.IconBrandPicsart = IconBrandPicsart;
exports.IconBrandPinterest = IconBrandPinterest;
exports.IconBrandPinterestFilled = IconBrandPinterestFilled;
exports.IconBrandPlanetscale = IconBrandPlanetscale;
exports.IconBrandPnpm = IconBrandPnpm;
exports.IconBrandPocket = IconBrandPocket;
exports.IconBrandPolymer = IconBrandPolymer;
exports.IconBrandPowershell = IconBrandPowershell;
exports.IconBrandPrintables = IconBrandPrintables;
exports.IconBrandPrisma = IconBrandPrisma;
exports.IconBrandProducthunt = IconBrandProducthunt;
exports.IconBrandPushbullet = IconBrandPushbullet;
exports.IconBrandPushover = IconBrandPushover;
exports.IconBrandPython = IconBrandPython;
exports.IconBrandQq = IconBrandQq;
exports.IconBrandRadixUi = IconBrandRadixUi;
exports.IconBrandReact = IconBrandReact;
exports.IconBrandReactNative = IconBrandReactNative;
exports.IconBrandReason = IconBrandReason;
exports.IconBrandReddit = IconBrandReddit;
exports.IconBrandRedhat = IconBrandRedhat;
exports.IconBrandRedux = IconBrandRedux;
exports.IconBrandRevolut = IconBrandRevolut;
exports.IconBrandRumble = IconBrandRumble;
exports.IconBrandRust = IconBrandRust;
exports.IconBrandSafari = IconBrandSafari;
exports.IconBrandSamsungpass = IconBrandSamsungpass;
exports.IconBrandSass = IconBrandSass;
exports.IconBrandSentry = IconBrandSentry;
exports.IconBrandSharik = IconBrandSharik;
exports.IconBrandShazam = IconBrandShazam;
exports.IconBrandShopee = IconBrandShopee;
exports.IconBrandSketch = IconBrandSketch;
exports.IconBrandSketchFilled = IconBrandSketchFilled;
exports.IconBrandSkype = IconBrandSkype;
exports.IconBrandSlack = IconBrandSlack;
exports.IconBrandSnapchat = IconBrandSnapchat;
exports.IconBrandSnapchatFilled = IconBrandSnapchatFilled;
exports.IconBrandSnapseed = IconBrandSnapseed;
exports.IconBrandSnowflake = IconBrandSnowflake;
exports.IconBrandSocketIo = IconBrandSocketIo;
exports.IconBrandSolidjs = IconBrandSolidjs;
exports.IconBrandSoundcloud = IconBrandSoundcloud;
exports.IconBrandSpacehey = IconBrandSpacehey;
exports.IconBrandSpeedtest = IconBrandSpeedtest;
exports.IconBrandSpotify = IconBrandSpotify;
exports.IconBrandSpotifyFilled = IconBrandSpotifyFilled;
exports.IconBrandStackoverflow = IconBrandStackoverflow;
exports.IconBrandStackshare = IconBrandStackshare;
exports.IconBrandSteam = IconBrandSteam;
exports.IconBrandSteamFilled = IconBrandSteamFilled;
exports.IconBrandStocktwits = IconBrandStocktwits;
exports.IconBrandStorj = IconBrandStorj;
exports.IconBrandStorybook = IconBrandStorybook;
exports.IconBrandStorytel = IconBrandStorytel;
exports.IconBrandStrava = IconBrandStrava;
exports.IconBrandStripe = IconBrandStripe;
exports.IconBrandStripeFilled = IconBrandStripeFilled;
exports.IconBrandSublimeText = IconBrandSublimeText;
exports.IconBrandSugarizer = IconBrandSugarizer;
exports.IconBrandSupabase = IconBrandSupabase;
exports.IconBrandSuperhuman = IconBrandSuperhuman;
exports.IconBrandSupernova = IconBrandSupernova;
exports.IconBrandSurfshark = IconBrandSurfshark;
exports.IconBrandSvelte = IconBrandSvelte;
exports.IconBrandSwift = IconBrandSwift;
exports.IconBrandSymfony = IconBrandSymfony;
exports.IconBrandTabler = IconBrandTabler;
exports.IconBrandTablerFilled = IconBrandTablerFilled;
exports.IconBrandTailwind = IconBrandTailwind;
exports.IconBrandTaobao = IconBrandTaobao;
exports.IconBrandTeams = IconBrandTeams;
exports.IconBrandTed = IconBrandTed;
exports.IconBrandTelegram = IconBrandTelegram;
exports.IconBrandTerraform = IconBrandTerraform;
exports.IconBrandTesla = IconBrandTesla;
exports.IconBrandTether = IconBrandTether;
exports.IconBrandThingiverse = IconBrandThingiverse;
exports.IconBrandThreads = IconBrandThreads;
exports.IconBrandThreejs = IconBrandThreejs;
exports.IconBrandTidal = IconBrandTidal;
exports.IconBrandTiktok = IconBrandTiktok;
exports.IconBrandTiktokFilled = IconBrandTiktokFilled;
exports.IconBrandTinder = IconBrandTinder;
exports.IconBrandTinderFilled = IconBrandTinderFilled;
exports.IconBrandTopbuzz = IconBrandTopbuzz;
exports.IconBrandTorchain = IconBrandTorchain;
exports.IconBrandToyota = IconBrandToyota;
exports.IconBrandTrello = IconBrandTrello;
exports.IconBrandTripadvisor = IconBrandTripadvisor;
exports.IconBrandTumblr = IconBrandTumblr;
exports.IconBrandTumblrFilled = IconBrandTumblrFilled;
exports.IconBrandTwilio = IconBrandTwilio;
exports.IconBrandTwitch = IconBrandTwitch;
exports.IconBrandTwitter = IconBrandTwitter;
exports.IconBrandTwitterFilled = IconBrandTwitterFilled;
exports.IconBrandTypescript = IconBrandTypescript;
exports.IconBrandUber = IconBrandUber;
exports.IconBrandUbuntu = IconBrandUbuntu;
exports.IconBrandUnity = IconBrandUnity;
exports.IconBrandUnsplash = IconBrandUnsplash;
exports.IconBrandUpwork = IconBrandUpwork;
exports.IconBrandValorant = IconBrandValorant;
exports.IconBrandVercel = IconBrandVercel;
exports.IconBrandVercelFilled = IconBrandVercelFilled;
exports.IconBrandVimeo = IconBrandVimeo;
exports.IconBrandVimeoFilled = IconBrandVimeoFilled;
exports.IconBrandVinted = IconBrandVinted;
exports.IconBrandVisa = IconBrandVisa;
exports.IconBrandVisualStudio = IconBrandVisualStudio;
exports.IconBrandVite = IconBrandVite;
exports.IconBrandVivaldi = IconBrandVivaldi;
exports.IconBrandVk = IconBrandVk;
exports.IconBrandVlc = IconBrandVlc;
exports.IconBrandVolkswagen = IconBrandVolkswagen;
exports.IconBrandVsco = IconBrandVsco;
exports.IconBrandVscode = IconBrandVscode;
exports.IconBrandVue = IconBrandVue;
exports.IconBrandWalmart = IconBrandWalmart;
exports.IconBrandWaze = IconBrandWaze;
exports.IconBrandWebflow = IconBrandWebflow;
exports.IconBrandWechat = IconBrandWechat;
exports.IconBrandWeibo = IconBrandWeibo;
exports.IconBrandWeiboFilled = IconBrandWeiboFilled;
exports.IconBrandWhatsapp = IconBrandWhatsapp;
exports.IconBrandWhatsappFilled = IconBrandWhatsappFilled;
exports.IconBrandWikipedia = IconBrandWikipedia;
exports.IconBrandWindows = IconBrandWindows;
exports.IconBrandWindowsFilled = IconBrandWindowsFilled;
exports.IconBrandWindy = IconBrandWindy;
exports.IconBrandWish = IconBrandWish;
exports.IconBrandWix = IconBrandWix;
exports.IconBrandWordpress = IconBrandWordpress;
exports.IconBrandX = IconBrandX;
exports.IconBrandXFilled = IconBrandXFilled;
exports.IconBrandXamarin = IconBrandXamarin;
exports.IconBrandXbox = IconBrandXbox;
exports.IconBrandXdeep = IconBrandXdeep;
exports.IconBrandXing = IconBrandXing;
exports.IconBrandYahoo = IconBrandYahoo;
exports.IconBrandYandex = IconBrandYandex;
exports.IconBrandYarn = IconBrandYarn;
exports.IconBrandYatse = IconBrandYatse;
exports.IconBrandYcombinator = IconBrandYcombinator;
exports.IconBrandYoutube = IconBrandYoutube;
exports.IconBrandYoutubeFilled = IconBrandYoutubeFilled;
exports.IconBrandYoutubeKids = IconBrandYoutubeKids;
exports.IconBrandZalando = IconBrandZalando;
exports.IconBrandZapier = IconBrandZapier;
exports.IconBrandZeit = IconBrandZeit;
exports.IconBrandZhihu = IconBrandZhihu;
exports.IconBrandZoom = IconBrandZoom;
exports.IconBrandZulip = IconBrandZulip;
exports.IconBrandZwift = IconBrandZwift;
exports.IconBread = IconBread;
exports.IconBreadFilled = IconBreadFilled;
exports.IconBreadOff = IconBreadOff;
exports.IconBriefcase = IconBriefcase;
exports.IconBriefcase2 = IconBriefcase2;
exports.IconBriefcase2Filled = IconBriefcase2Filled;
exports.IconBriefcaseFilled = IconBriefcaseFilled;
exports.IconBriefcaseOff = IconBriefcaseOff;
exports.IconBrightness = IconBrightness;
exports.IconBrightness2 = IconBrightness2;
exports.IconBrightnessAuto = IconBrightnessAuto;
exports.IconBrightnessAutoFilled = IconBrightnessAutoFilled;
exports.IconBrightnessDown = IconBrightnessDown;
exports.IconBrightnessDownFilled = IconBrightnessDownFilled;
exports.IconBrightnessFilled = IconBrightnessFilled;
exports.IconBrightnessHalf = IconBrightnessHalf;
exports.IconBrightnessOff = IconBrightnessOff;
exports.IconBrightnessUp = IconBrightnessUp;
exports.IconBrightnessUpFilled = IconBrightnessUpFilled;
exports.IconBroadcast = IconBroadcast;
exports.IconBroadcastOff = IconBroadcastOff;
exports.IconBrowser = IconBrowser;
exports.IconBrowserCheck = IconBrowserCheck;
exports.IconBrowserMaximize = IconBrowserMaximize;
exports.IconBrowserMinus = IconBrowserMinus;
exports.IconBrowserOff = IconBrowserOff;
exports.IconBrowserPlus = IconBrowserPlus;
exports.IconBrowserShare = IconBrowserShare;
exports.IconBrowserX = IconBrowserX;
exports.IconBrush = IconBrush;
exports.IconBrushOff = IconBrushOff;
exports.IconBubble = IconBubble;
exports.IconBubbleFilled = IconBubbleFilled;
exports.IconBubbleMinus = IconBubbleMinus;
exports.IconBubblePlus = IconBubblePlus;
exports.IconBubbleTea = IconBubbleTea;
exports.IconBubbleTea2 = IconBubbleTea2;
exports.IconBubbleText = IconBubbleText;
exports.IconBubbleTextFilled = IconBubbleTextFilled;
exports.IconBubbleX = IconBubbleX;
exports.IconBucket = IconBucket;
exports.IconBucketDroplet = IconBucketDroplet;
exports.IconBucketOff = IconBucketOff;
exports.IconBug = IconBug;
exports.IconBugFilled = IconBugFilled;
exports.IconBugOff = IconBugOff;
exports.IconBuilding = IconBuilding;
exports.IconBuildingAirport = IconBuildingAirport;
exports.IconBuildingArch = IconBuildingArch;
exports.IconBuildingBank = IconBuildingBank;
exports.IconBuildingBridge = IconBuildingBridge;
exports.IconBuildingBridge2 = IconBuildingBridge2;
exports.IconBuildingBroadcastTower = IconBuildingBroadcastTower;
exports.IconBuildingBroadcastTowerFilled = IconBuildingBroadcastTowerFilled;
exports.IconBuildingBurjAlArab = IconBuildingBurjAlArab;
exports.IconBuildingCarousel = IconBuildingCarousel;
exports.IconBuildingCastle = IconBuildingCastle;
exports.IconBuildingChurch = IconBuildingChurch;
exports.IconBuildingCircus = IconBuildingCircus;
exports.IconBuildingCog = IconBuildingCog;
exports.IconBuildingCommunity = IconBuildingCommunity;
exports.IconBuildingCottage = IconBuildingCottage;
exports.IconBuildingEstate = IconBuildingEstate;
exports.IconBuildingFactory = IconBuildingFactory;
exports.IconBuildingFactory2 = IconBuildingFactory2;
exports.IconBuildingFortress = IconBuildingFortress;
exports.IconBuildingHospital = IconBuildingHospital;
exports.IconBuildingLighthouse = IconBuildingLighthouse;
exports.IconBuildingMinus = IconBuildingMinus;
exports.IconBuildingMonument = IconBuildingMonument;
exports.IconBuildingMosque = IconBuildingMosque;
exports.IconBuildingOff = IconBuildingOff;
exports.IconBuildingPavilion = IconBuildingPavilion;
exports.IconBuildingPlus = IconBuildingPlus;
exports.IconBuildingSkyscraper = IconBuildingSkyscraper;
exports.IconBuildingStadium = IconBuildingStadium;
exports.IconBuildingStore = IconBuildingStore;
exports.IconBuildingTunnel = IconBuildingTunnel;
exports.IconBuildingWarehouse = IconBuildingWarehouse;
exports.IconBuildingWindTurbine = IconBuildingWindTurbine;
exports.IconBuildings = IconBuildings;
exports.IconBulb = IconBulb;
exports.IconBulbFilled = IconBulbFilled;
exports.IconBulbOff = IconBulbOff;
exports.IconBulldozer = IconBulldozer;
exports.IconBurger = IconBurger;
exports.IconBus = IconBus;
exports.IconBusFilled = IconBusFilled;
exports.IconBusOff = IconBusOff;
exports.IconBusStop = IconBusStop;
exports.IconBusinessplan = IconBusinessplan;
exports.IconButterfly = IconButterfly;
exports.IconButterflyFilled = IconButterflyFilled;
exports.IconCactus = IconCactus;
exports.IconCactusFilled = IconCactusFilled;
exports.IconCactusOff = IconCactusOff;
exports.IconCake = IconCake;
exports.IconCakeOff = IconCakeOff;
exports.IconCakeRoll = IconCakeRoll;
exports.IconCalculator = IconCalculator;
exports.IconCalculatorFilled = IconCalculatorFilled;
exports.IconCalculatorOff = IconCalculatorOff;
exports.IconCalendar = IconCalendar;
exports.IconCalendarBolt = IconCalendarBolt;
exports.IconCalendarCancel = IconCalendarCancel;
exports.IconCalendarCheck = IconCalendarCheck;
exports.IconCalendarClock = IconCalendarClock;
exports.IconCalendarCode = IconCalendarCode;
exports.IconCalendarCog = IconCalendarCog;
exports.IconCalendarDollar = IconCalendarDollar;
exports.IconCalendarDot = IconCalendarDot;
exports.IconCalendarDown = IconCalendarDown;
exports.IconCalendarDue = IconCalendarDue;
exports.IconCalendarEvent = IconCalendarEvent;
exports.IconCalendarEventFilled = IconCalendarEventFilled;
exports.IconCalendarExclamation = IconCalendarExclamation;
exports.IconCalendarFilled = IconCalendarFilled;
exports.IconCalendarHeart = IconCalendarHeart;
exports.IconCalendarMinus = IconCalendarMinus;
exports.IconCalendarMonth = IconCalendarMonth;
exports.IconCalendarMonthFilled = IconCalendarMonthFilled;
exports.IconCalendarOff = IconCalendarOff;
exports.IconCalendarPause = IconCalendarPause;
exports.IconCalendarPin = IconCalendarPin;
exports.IconCalendarPlus = IconCalendarPlus;
exports.IconCalendarQuestion = IconCalendarQuestion;
exports.IconCalendarRepeat = IconCalendarRepeat;
exports.IconCalendarSad = IconCalendarSad;
exports.IconCalendarSearch = IconCalendarSearch;
exports.IconCalendarShare = IconCalendarShare;
exports.IconCalendarSmile = IconCalendarSmile;
exports.IconCalendarStar = IconCalendarStar;
exports.IconCalendarStats = IconCalendarStats;
exports.IconCalendarTime = IconCalendarTime;
exports.IconCalendarUp = IconCalendarUp;
exports.IconCalendarUser = IconCalendarUser;
exports.IconCalendarWeek = IconCalendarWeek;
exports.IconCalendarWeekFilled = IconCalendarWeekFilled;
exports.IconCalendarX = IconCalendarX;
exports.IconCamera = IconCamera;
exports.IconCameraAi = IconCameraAi;
exports.IconCameraBitcoin = IconCameraBitcoin;
exports.IconCameraBolt = IconCameraBolt;
exports.IconCameraCancel = IconCameraCancel;
exports.IconCameraCheck = IconCameraCheck;
exports.IconCameraCode = IconCameraCode;
exports.IconCameraCog = IconCameraCog;
exports.IconCameraDollar = IconCameraDollar;
exports.IconCameraDown = IconCameraDown;
exports.IconCameraExclamation = IconCameraExclamation;
exports.IconCameraFilled = IconCameraFilled;
exports.IconCameraHeart = IconCameraHeart;
exports.IconCameraMinus = IconCameraMinus;
exports.IconCameraMoon = IconCameraMoon;
exports.IconCameraOff = IconCameraOff;
exports.IconCameraPause = IconCameraPause;
exports.IconCameraPin = IconCameraPin;
exports.IconCameraPlus = IconCameraPlus;
exports.IconCameraQuestion = IconCameraQuestion;
exports.IconCameraRotate = IconCameraRotate;
exports.IconCameraSearch = IconCameraSearch;
exports.IconCameraSelfie = IconCameraSelfie;
exports.IconCameraShare = IconCameraShare;
exports.IconCameraSpark = IconCameraSpark;
exports.IconCameraStar = IconCameraStar;
exports.IconCameraUp = IconCameraUp;
exports.IconCameraX = IconCameraX;
exports.IconCamper = IconCamper;
exports.IconCampfire = IconCampfire;
exports.IconCampfireFilled = IconCampfireFilled;
exports.IconCancel = IconCancel;
exports.IconCandle = IconCandle;
exports.IconCandleFilled = IconCandleFilled;
exports.IconCandy = IconCandy;
exports.IconCandyOff = IconCandyOff;
exports.IconCane = IconCane;
exports.IconCannabis = IconCannabis;
exports.IconCannabisFilled = IconCannabisFilled;
exports.IconCapProjecting = IconCapProjecting;
exports.IconCapRounded = IconCapRounded;
exports.IconCapStraight = IconCapStraight;
exports.IconCapsule = IconCapsule;
exports.IconCapsuleFilled = IconCapsuleFilled;
exports.IconCapsuleHorizontal = IconCapsuleHorizontal;
exports.IconCapsuleHorizontalFilled = IconCapsuleHorizontalFilled;
exports.IconCapture = IconCapture;
exports.IconCaptureFilled = IconCaptureFilled;
exports.IconCaptureOff = IconCaptureOff;
exports.IconCar = IconCar;
exports.IconCar4wd = IconCar4wd;
exports.IconCar4wdFilled = IconCar4wdFilled;
exports.IconCarCrane = IconCarCrane;
exports.IconCarCraneFilled = IconCarCraneFilled;
exports.IconCarCrash = IconCarCrash;
exports.IconCarFan = IconCarFan;
exports.IconCarFan1 = IconCarFan1;
exports.IconCarFan2 = IconCarFan2;
exports.IconCarFan3 = IconCarFan3;
exports.IconCarFanAuto = IconCarFanAuto;
exports.IconCarFanFilled = IconCarFanFilled;
exports.IconCarFilled = IconCarFilled;
exports.IconCarGarage = IconCarGarage;
exports.IconCarOff = IconCarOff;
exports.IconCarSuv = IconCarSuv;
exports.IconCarSuvFilled = IconCarSuvFilled;
exports.IconCarTurbine = IconCarTurbine;
exports.IconCarambola = IconCarambola;
exports.IconCarambolaFilled = IconCarambolaFilled;
exports.IconCaravan = IconCaravan;
exports.IconCaravanFilled = IconCaravanFilled;
exports.IconCardboards = IconCardboards;
exports.IconCardboardsFilled = IconCardboardsFilled;
exports.IconCardboardsOff = IconCardboardsOff;
exports.IconCards = IconCards;
exports.IconCardsFilled = IconCardsFilled;
exports.IconCaretDown = IconCaretDown;
exports.IconCaretDownFilled = IconCaretDownFilled;
exports.IconCaretLeft = IconCaretLeft;
exports.IconCaretLeftFilled = IconCaretLeftFilled;
exports.IconCaretLeftRight = IconCaretLeftRight;
exports.IconCaretLeftRightFilled = IconCaretLeftRightFilled;
exports.IconCaretRight = IconCaretRight;
exports.IconCaretRightFilled = IconCaretRightFilled;
exports.IconCaretUp = IconCaretUp;
exports.IconCaretUpDown = IconCaretUpDown;
exports.IconCaretUpDownFilled = IconCaretUpDownFilled;
exports.IconCaretUpFilled = IconCaretUpFilled;
exports.IconCarouselHorizontal = IconCarouselHorizontal;
exports.IconCarouselHorizontalFilled = IconCarouselHorizontalFilled;
exports.IconCarouselVertical = IconCarouselVertical;
exports.IconCarouselVerticalFilled = IconCarouselVerticalFilled;
exports.IconCarrot = IconCarrot;
exports.IconCarrotOff = IconCarrotOff;
exports.IconCash = IconCash;
exports.IconCashBanknote = IconCashBanknote;
exports.IconCashBanknoteEdit = IconCashBanknoteEdit;
exports.IconCashBanknoteFilled = IconCashBanknoteFilled;
exports.IconCashBanknoteHeart = IconCashBanknoteHeart;
exports.IconCashBanknoteMinus = IconCashBanknoteMinus;
exports.IconCashBanknoteMove = IconCashBanknoteMove;
exports.IconCashBanknoteMoveBack = IconCashBanknoteMoveBack;
exports.IconCashBanknoteOff = IconCashBanknoteOff;
exports.IconCashBanknotePlus = IconCashBanknotePlus;
exports.IconCashEdit = IconCashEdit;
exports.IconCashHeart = IconCashHeart;
exports.IconCashMinus = IconCashMinus;
exports.IconCashMove = IconCashMove;
exports.IconCashMoveBack = IconCashMoveBack;
exports.IconCashOff = IconCashOff;
exports.IconCashPlus = IconCashPlus;
exports.IconCashRegister = IconCashRegister;
exports.IconCast = IconCast;
exports.IconCastOff = IconCastOff;
exports.IconCat = IconCat;
exports.IconCategory = IconCategory;
exports.IconCategory2 = IconCategory2;
exports.IconCategoryFilled = IconCategoryFilled;
exports.IconCategoryMinus = IconCategoryMinus;
exports.IconCategoryPlus = IconCategoryPlus;
exports.IconCe = IconCe;
exports.IconCeOff = IconCeOff;
exports.IconCell = IconCell;
exports.IconCellSignal1 = IconCellSignal1;
exports.IconCellSignal2 = IconCellSignal2;
exports.IconCellSignal3 = IconCellSignal3;
exports.IconCellSignal4 = IconCellSignal4;
exports.IconCellSignal5 = IconCellSignal5;
exports.IconCellSignalOff = IconCellSignalOff;
exports.IconCertificate = IconCertificate;
exports.IconCertificate2 = IconCertificate2;
exports.IconCertificate2Off = IconCertificate2Off;
exports.IconCertificateOff = IconCertificateOff;
exports.IconChairDirector = IconChairDirector;
exports.IconChalkboard = IconChalkboard;
exports.IconChalkboardOff = IconChalkboardOff;
exports.IconChargingPile = IconChargingPile;
exports.IconChargingPileFilled = IconChargingPileFilled;
exports.IconChartArcs = IconChartArcs;
exports.IconChartArcs3 = IconChartArcs3;
exports.IconChartArea = IconChartArea;
exports.IconChartAreaFilled = IconChartAreaFilled;
exports.IconChartAreaLine = IconChartAreaLine;
exports.IconChartAreaLineFilled = IconChartAreaLineFilled;
exports.IconChartArrows = IconChartArrows;
exports.IconChartArrowsVertical = IconChartArrowsVertical;
exports.IconChartBar = IconChartBar;
exports.IconChartBarOff = IconChartBarOff;
exports.IconChartBarPopular = IconChartBarPopular;
exports.IconChartBubble = IconChartBubble;
exports.IconChartBubbleFilled = IconChartBubbleFilled;
exports.IconChartCandle = IconChartCandle;
exports.IconChartCandleFilled = IconChartCandleFilled;
exports.IconChartCircles = IconChartCircles;
exports.IconChartCohort = IconChartCohort;
exports.IconChartColumn = IconChartColumn;
exports.IconChartCovariate = IconChartCovariate;
exports.IconChartDonut = IconChartDonut;
exports.IconChartDonut2 = IconChartDonut2;
exports.IconChartDonut3 = IconChartDonut3;
exports.IconChartDonut4 = IconChartDonut4;
exports.IconChartDonutFilled = IconChartDonutFilled;
exports.IconChartDots = IconChartDots;
exports.IconChartDots2 = IconChartDots2;
exports.IconChartDots2Filled = IconChartDots2Filled;
exports.IconChartDots3 = IconChartDots3;
exports.IconChartDots3Filled = IconChartDots3Filled;
exports.IconChartDotsFilled = IconChartDotsFilled;
exports.IconChartFunnel = IconChartFunnel;
exports.IconChartFunnelFilled = IconChartFunnelFilled;
exports.IconChartGridDots = IconChartGridDots;
exports.IconChartGridDotsFilled = IconChartGridDotsFilled;
exports.IconChartHistogram = IconChartHistogram;
exports.IconChartInfographic = IconChartInfographic;
exports.IconChartLine = IconChartLine;
exports.IconChartPie = IconChartPie;
exports.IconChartPie2 = IconChartPie2;
exports.IconChartPie2Filled = IconChartPie2Filled;
exports.IconChartPie3 = IconChartPie3;
exports.IconChartPie3Filled = IconChartPie3Filled;
exports.IconChartPie4 = IconChartPie4;
exports.IconChartPie4Filled = IconChartPie4Filled;
exports.IconChartPieFilled = IconChartPieFilled;
exports.IconChartPieOff = IconChartPieOff;
exports.IconChartPpf = IconChartPpf;
exports.IconChartRadar = IconChartRadar;
exports.IconChartSankey = IconChartSankey;
exports.IconChartScatter = IconChartScatter;
exports.IconChartScatter3d = IconChartScatter3d;
exports.IconChartTreemap = IconChartTreemap;
exports.IconCheck = IconCheck;
exports.IconCheckbox = IconCheckbox;
exports.IconChecklist = IconChecklist;
exports.IconChecks = IconChecks;
exports.IconCheckupList = IconCheckupList;
exports.IconCheese = IconCheese;
exports.IconChefHat = IconChefHat;
exports.IconChefHatFilled = IconChefHatFilled;
exports.IconChefHatOff = IconChefHatOff;
exports.IconCherry = IconCherry;
exports.IconCherryFilled = IconCherryFilled;
exports.IconChess = IconChess;
exports.IconChessBishop = IconChessBishop;
exports.IconChessBishopFilled = IconChessBishopFilled;
exports.IconChessFilled = IconChessFilled;
exports.IconChessKing = IconChessKing;
exports.IconChessKingFilled = IconChessKingFilled;
exports.IconChessKnight = IconChessKnight;
exports.IconChessKnightFilled = IconChessKnightFilled;
exports.IconChessQueen = IconChessQueen;
exports.IconChessQueenFilled = IconChessQueenFilled;
exports.IconChessRook = IconChessRook;
exports.IconChessRookFilled = IconChessRookFilled;
exports.IconChevronCompactDown = IconChevronCompactDown;
exports.IconChevronCompactLeft = IconChevronCompactLeft;
exports.IconChevronCompactRight = IconChevronCompactRight;
exports.IconChevronCompactUp = IconChevronCompactUp;
exports.IconChevronDown = IconChevronDown;
exports.IconChevronDownLeft = IconChevronDownLeft;
exports.IconChevronDownRight = IconChevronDownRight;
exports.IconChevronLeft = IconChevronLeft;
exports.IconChevronLeftPipe = IconChevronLeftPipe;
exports.IconChevronRight = IconChevronRight;
exports.IconChevronRightPipe = IconChevronRightPipe;
exports.IconChevronUp = IconChevronUp;
exports.IconChevronUpLeft = IconChevronUpLeft;
exports.IconChevronUpRight = IconChevronUpRight;
exports.IconChevronsDown = IconChevronsDown;
exports.IconChevronsDownLeft = IconChevronsDownLeft;
exports.IconChevronsDownRight = IconChevronsDownRight;
exports.IconChevronsLeft = IconChevronsLeft;
exports.IconChevronsRight = IconChevronsRight;
exports.IconChevronsUp = IconChevronsUp;
exports.IconChevronsUpLeft = IconChevronsUpLeft;
exports.IconChevronsUpRight = IconChevronsUpRight;
exports.IconChisel = IconChisel;
exports.IconChristmasBall = IconChristmasBall;
exports.IconChristmasTree = IconChristmasTree;
exports.IconChristmasTreeFilled = IconChristmasTreeFilled;
exports.IconChristmasTreeOff = IconChristmasTreeOff;
exports.IconCircle = IconCircle;
exports.IconCircle0 = IconCircleNumber0;
exports.IconCircle1 = IconCircleNumber1;
exports.IconCircle2 = IconCircleNumber2;
exports.IconCircle3 = IconCircleNumber3;
exports.IconCircle4 = IconCircleNumber4;
exports.IconCircle5 = IconCircleNumber5;
exports.IconCircle6 = IconCircleNumber6;
exports.IconCircle7 = IconCircleNumber7;
exports.IconCircle8 = IconCircleNumber8;
exports.IconCircle9 = IconCircleNumber9;
exports.IconCircleArrowDown = IconCircleArrowDown;
exports.IconCircleArrowDownFilled = IconCircleArrowDownFilled;
exports.IconCircleArrowDownLeft = IconCircleArrowDownLeft;
exports.IconCircleArrowDownLeftFilled = IconCircleArrowDownLeftFilled;
exports.IconCircleArrowDownRight = IconCircleArrowDownRight;
exports.IconCircleArrowDownRightFilled = IconCircleArrowDownRightFilled;
exports.IconCircleArrowLeft = IconCircleArrowLeft;
exports.IconCircleArrowLeftFilled = IconCircleArrowLeftFilled;
exports.IconCircleArrowRight = IconCircleArrowRight;
exports.IconCircleArrowRightFilled = IconCircleArrowRightFilled;
exports.IconCircleArrowUp = IconCircleArrowUp;
exports.IconCircleArrowUpFilled = IconCircleArrowUpFilled;
exports.IconCircleArrowUpLeft = IconCircleArrowUpLeft;
exports.IconCircleArrowUpLeftFilled = IconCircleArrowUpLeftFilled;
exports.IconCircleArrowUpRight = IconCircleArrowUpRight;
exports.IconCircleArrowUpRightFilled = IconCircleArrowUpRightFilled;
exports.IconCircleCaretDown = IconCircleCaretDown;
exports.IconCircleCaretDownFilled = IconCircleCaretDownFilled;
exports.IconCircleCaretLeft = IconCircleCaretLeft;
exports.IconCircleCaretLeftFilled = IconCircleCaretLeftFilled;
exports.IconCircleCaretRight = IconCircleCaretRight;
exports.IconCircleCaretRightFilled = IconCircleCaretRightFilled;
exports.IconCircleCaretUp = IconCircleCaretUp;
exports.IconCircleCaretUpFilled = IconCircleCaretUpFilled;
exports.IconCircleCheck = IconCircleCheck;
exports.IconCircleCheckFilled = IconCircleCheckFilled;
exports.IconCircleChevronDown = IconCircleChevronDown;
exports.IconCircleChevronDownFilled = IconCircleChevronDownFilled;
exports.IconCircleChevronLeft = IconCircleChevronLeft;
exports.IconCircleChevronLeftFilled = IconCircleChevronLeftFilled;
exports.IconCircleChevronRight = IconCircleChevronRight;
exports.IconCircleChevronRightFilled = IconCircleChevronRightFilled;
exports.IconCircleChevronUp = IconCircleChevronUp;
exports.IconCircleChevronUpFilled = IconCircleChevronUpFilled;
exports.IconCircleChevronsDown = IconCircleChevronsDown;
exports.IconCircleChevronsDownFilled = IconCircleChevronsDownFilled;
exports.IconCircleChevronsLeft = IconCircleChevronsLeft;
exports.IconCircleChevronsLeftFilled = IconCircleChevronsLeftFilled;
exports.IconCircleChevronsRight = IconCircleChevronsRight;
exports.IconCircleChevronsRightFilled = IconCircleChevronsRightFilled;
exports.IconCircleChevronsUp = IconCircleChevronsUp;
exports.IconCircleChevronsUpFilled = IconCircleChevronsUpFilled;
exports.IconCircleDashed = IconCircleDashed;
exports.IconCircleDashedCheck = IconCircleDashedCheck;
exports.IconCircleDashedLetterA = IconCircleDashedLetterA;
exports.IconCircleDashedLetterB = IconCircleDashedLetterB;
exports.IconCircleDashedLetterC = IconCircleDashedLetterC;
exports.IconCircleDashedLetterD = IconCircleDashedLetterD;
exports.IconCircleDashedLetterE = IconCircleDashedLetterE;
exports.IconCircleDashedLetterF = IconCircleDashedLetterF;
exports.IconCircleDashedLetterG = IconCircleDashedLetterG;
exports.IconCircleDashedLetterH = IconCircleDashedLetterH;
exports.IconCircleDashedLetterI = IconCircleDashedLetterI;
exports.IconCircleDashedLetterJ = IconCircleDashedLetterJ;
exports.IconCircleDashedLetterK = IconCircleDashedLetterK;
exports.IconCircleDashedLetterL = IconCircleDashedLetterL;
exports.IconCircleDashedLetterLetterV = IconCircleDashedLetterV;
exports.IconCircleDashedLetterM = IconCircleDashedLetterM;
exports.IconCircleDashedLetterN = IconCircleDashedLetterN;
exports.IconCircleDashedLetterO = IconCircleDashedLetterO;
exports.IconCircleDashedLetterP = IconCircleDashedLetterP;
exports.IconCircleDashedLetterQ = IconCircleDashedLetterQ;
exports.IconCircleDashedLetterR = IconCircleDashedLetterR;
exports.IconCircleDashedLetterS = IconCircleDashedLetterS;
exports.IconCircleDashedLetterT = IconCircleDashedLetterT;
exports.IconCircleDashedLetterU = IconCircleDashedLetterU;
exports.IconCircleDashedLetterV = IconCircleDashedLetterV;
exports.IconCircleDashedLetterW = IconCircleDashedLetterW;
exports.IconCircleDashedLetterX = IconCircleDashedLetterX;
exports.IconCircleDashedLetterY = IconCircleDashedLetterY;
exports.IconCircleDashedLetterZ = IconCircleDashedLetterZ;
exports.IconCircleDashedMinus = IconCircleDashedMinus;
exports.IconCircleDashedNumber0 = IconCircleDashedNumber0;
exports.IconCircleDashedNumber1 = IconCircleDashedNumber1;
exports.IconCircleDashedNumber2 = IconCircleDashedNumber2;
exports.IconCircleDashedNumber3 = IconCircleDashedNumber3;
exports.IconCircleDashedNumber4 = IconCircleDashedNumber4;
exports.IconCircleDashedNumber5 = IconCircleDashedNumber5;
exports.IconCircleDashedNumber6 = IconCircleDashedNumber6;
exports.IconCircleDashedNumber7 = IconCircleDashedNumber7;
exports.IconCircleDashedNumber8 = IconCircleDashedNumber8;
exports.IconCircleDashedNumber9 = IconCircleDashedNumber9;
exports.IconCircleDashedPercentage = IconCircleDashedPercentage;
exports.IconCircleDashedPlus = IconCircleDashedPlus;
exports.IconCircleDashedX = IconCircleDashedX;
exports.IconCircleDot = IconCircleDot;
exports.IconCircleDotFilled = IconCircleDotFilled;
exports.IconCircleDotted = IconCircleDotted;
exports.IconCircleDottedLetterA = IconCircleDottedLetterA;
exports.IconCircleDottedLetterB = IconCircleDottedLetterB;
exports.IconCircleDottedLetterC = IconCircleDottedLetterC;
exports.IconCircleDottedLetterD = IconCircleDottedLetterD;
exports.IconCircleDottedLetterE = IconCircleDottedLetterE;
exports.IconCircleDottedLetterF = IconCircleDottedLetterF;
exports.IconCircleDottedLetterG = IconCircleDottedLetterG;
exports.IconCircleDottedLetterH = IconCircleDottedLetterH;
exports.IconCircleDottedLetterI = IconCircleDottedLetterI;
exports.IconCircleDottedLetterJ = IconCircleDottedLetterJ;
exports.IconCircleDottedLetterK = IconCircleDottedLetterK;
exports.IconCircleDottedLetterL = IconCircleDottedLetterL;
exports.IconCircleDottedLetterM = IconCircleDottedLetterM;
exports.IconCircleDottedLetterN = IconCircleDottedLetterN;
exports.IconCircleDottedLetterO = IconCircleDottedLetterO;
exports.IconCircleDottedLetterP = IconCircleDottedLetterP;
exports.IconCircleDottedLetterQ = IconCircleDottedLetterQ;
exports.IconCircleDottedLetterR = IconCircleDottedLetterR;
exports.IconCircleDottedLetterS = IconCircleDottedLetterS;
exports.IconCircleDottedLetterT = IconCircleDottedLetterT;
exports.IconCircleDottedLetterU = IconCircleDottedLetterU;
exports.IconCircleDottedLetterV = IconCircleDottedLetterV;
exports.IconCircleDottedLetterW = IconCircleDottedLetterW;
exports.IconCircleDottedLetterX = IconCircleDottedLetterX;
exports.IconCircleDottedLetterY = IconCircleDottedLetterY;
exports.IconCircleDottedLetterZ = IconCircleDottedLetterZ;
exports.IconCircleFilled = IconCircleFilled;
exports.IconCircleHalf = IconCircleHalf;
exports.IconCircleHalf2 = IconCircleHalf2;
exports.IconCircleHalfVertical = IconCircleHalfVertical;
exports.IconCircleKey = IconCircleKey;
exports.IconCircleKeyFilled = IconCircleKeyFilled;
exports.IconCircleLetterA = IconCircleLetterA;
exports.IconCircleLetterAFilled = IconCircleLetterAFilled;
exports.IconCircleLetterB = IconCircleLetterB;
exports.IconCircleLetterBFilled = IconCircleLetterBFilled;
exports.IconCircleLetterC = IconCircleLetterC;
exports.IconCircleLetterCFilled = IconCircleLetterCFilled;
exports.IconCircleLetterD = IconCircleLetterD;
exports.IconCircleLetterDFilled = IconCircleLetterDFilled;
exports.IconCircleLetterE = IconCircleLetterE;
exports.IconCircleLetterEFilled = IconCircleLetterEFilled;
exports.IconCircleLetterF = IconCircleLetterF;
exports.IconCircleLetterFFilled = IconCircleLetterFFilled;
exports.IconCircleLetterG = IconCircleLetterG;
exports.IconCircleLetterGFilled = IconCircleLetterGFilled;
exports.IconCircleLetterH = IconCircleLetterH;
exports.IconCircleLetterHFilled = IconCircleLetterHFilled;
exports.IconCircleLetterI = IconCircleLetterI;
exports.IconCircleLetterIFilled = IconCircleLetterIFilled;
exports.IconCircleLetterJ = IconCircleLetterJ;
exports.IconCircleLetterJFilled = IconCircleLetterJFilled;
exports.IconCircleLetterK = IconCircleLetterK;
exports.IconCircleLetterKFilled = IconCircleLetterKFilled;
exports.IconCircleLetterL = IconCircleLetterL;
exports.IconCircleLetterLFilled = IconCircleLetterLFilled;
exports.IconCircleLetterM = IconCircleLetterM;
exports.IconCircleLetterMFilled = IconCircleLetterMFilled;
exports.IconCircleLetterN = IconCircleLetterN;
exports.IconCircleLetterNFilled = IconCircleLetterNFilled;
exports.IconCircleLetterO = IconCircleLetterO;
exports.IconCircleLetterOFilled = IconCircleLetterOFilled;
exports.IconCircleLetterP = IconCircleLetterP;
exports.IconCircleLetterPFilled = IconCircleLetterPFilled;
exports.IconCircleLetterQ = IconCircleLetterQ;
exports.IconCircleLetterQFilled = IconCircleLetterQFilled;
exports.IconCircleLetterR = IconCircleLetterR;
exports.IconCircleLetterRFilled = IconCircleLetterRFilled;
exports.IconCircleLetterS = IconCircleLetterS;
exports.IconCircleLetterSFilled = IconCircleLetterSFilled;
exports.IconCircleLetterT = IconCircleLetterT;
exports.IconCircleLetterTFilled = IconCircleLetterTFilled;
exports.IconCircleLetterU = IconCircleLetterU;
exports.IconCircleLetterUFilled = IconCircleLetterUFilled;
exports.IconCircleLetterV = IconCircleLetterV;
exports.IconCircleLetterVFilled = IconCircleLetterVFilled;
exports.IconCircleLetterW = IconCircleLetterW;
exports.IconCircleLetterWFilled = IconCircleLetterWFilled;
exports.IconCircleLetterX = IconCircleLetterX;
exports.IconCircleLetterXFilled = IconCircleLetterXFilled;
exports.IconCircleLetterY = IconCircleLetterY;
exports.IconCircleLetterYFilled = IconCircleLetterYFilled;
exports.IconCircleLetterZ = IconCircleLetterZ;
exports.IconCircleLetterZFilled = IconCircleLetterZFilled;
exports.IconCircleMinus = IconCircleMinus;
exports.IconCircleMinus2 = IconCircleMinus2;
exports.IconCircleNumber0 = IconCircleNumber0;
exports.IconCircleNumber0Filled = IconCircleNumber0Filled;
exports.IconCircleNumber1 = IconCircleNumber1;
exports.IconCircleNumber1Filled = IconCircleNumber1Filled;
exports.IconCircleNumber2 = IconCircleNumber2;
exports.IconCircleNumber2Filled = IconCircleNumber2Filled;
exports.IconCircleNumber3 = IconCircleNumber3;
exports.IconCircleNumber3Filled = IconCircleNumber3Filled;
exports.IconCircleNumber4 = IconCircleNumber4;
exports.IconCircleNumber4Filled = IconCircleNumber4Filled;
exports.IconCircleNumber5 = IconCircleNumber5;
exports.IconCircleNumber5Filled = IconCircleNumber5Filled;
exports.IconCircleNumber6 = IconCircleNumber6;
exports.IconCircleNumber6Filled = IconCircleNumber6Filled;
exports.IconCircleNumber7 = IconCircleNumber7;
exports.IconCircleNumber7Filled = IconCircleNumber7Filled;
exports.IconCircleNumber8 = IconCircleNumber8;
exports.IconCircleNumber8Filled = IconCircleNumber8Filled;
exports.IconCircleNumber9 = IconCircleNumber9;
exports.IconCircleNumber9Filled = IconCircleNumber9Filled;
exports.IconCircleOff = IconCircleOff;
exports.IconCirclePercentage = IconCirclePercentage;
exports.IconCirclePercentageFilled = IconCirclePercentageFilled;
exports.IconCirclePlus = IconCirclePlus;
exports.IconCirclePlus2 = IconCirclePlus2;
exports.IconCirclePlusFilled = IconCirclePlusFilled;
exports.IconCircleRectangle = IconCircleRectangle;
exports.IconCircleRectangleFilled = IconCircleRectangleFilled;
exports.IconCircleRectangleOff = IconCircleRectangleOff;
exports.IconCircleSquare = IconCircleSquare;
exports.IconCircleTriangle = IconCircleTriangle;
exports.IconCircleX = IconCircleX;
exports.IconCircleXFilled = IconCircleXFilled;
exports.IconCircles = IconCircles;
exports.IconCirclesFilled = IconCirclesFilled;
exports.IconCirclesRelation = IconCirclesRelation;
exports.IconCircuitAmmeter = IconCircuitAmmeter;
exports.IconCircuitBattery = IconCircuitBattery;
exports.IconCircuitBulb = IconCircuitBulb;
exports.IconCircuitCapacitor = IconCircuitCapacitor;
exports.IconCircuitCapacitorPolarized = IconCircuitCapacitorPolarized;
exports.IconCircuitCell = IconCircuitCell;
exports.IconCircuitCellPlus = IconCircuitCellPlus;
exports.IconCircuitChangeover = IconCircuitChangeover;
exports.IconCircuitDiode = IconCircuitDiode;
exports.IconCircuitDiodeZener = IconCircuitDiodeZener;
exports.IconCircuitGround = IconCircuitGround;
exports.IconCircuitGroundDigital = IconCircuitGroundDigital;
exports.IconCircuitInductor = IconCircuitInductor;
exports.IconCircuitMotor = IconCircuitMotor;
exports.IconCircuitPushbutton = IconCircuitPushbutton;
exports.IconCircuitResistor = IconCircuitResistor;
exports.IconCircuitSwitchClosed = IconCircuitSwitchClosed;
exports.IconCircuitSwitchOpen = IconCircuitSwitchOpen;
exports.IconCircuitVoltmeter = IconCircuitVoltmeter;
exports.IconClearAll = IconClearAll;
exports.IconClearFormatting = IconClearFormatting;
exports.IconClick = IconClick;
exports.IconCliffJumping = IconCliffJumping;
exports.IconClipboard = IconClipboard;
exports.IconClipboardCheck = IconClipboardCheck;
exports.IconClipboardCheckFilled = IconClipboardCheckFilled;
exports.IconClipboardCopy = IconClipboardCopy;
exports.IconClipboardData = IconClipboardData;
exports.IconClipboardDataFilled = IconClipboardDataFilled;
exports.IconClipboardFilled = IconClipboardFilled;
exports.IconClipboardHeart = IconClipboardHeart;
exports.IconClipboardList = IconClipboardList;
exports.IconClipboardListFilled = IconClipboardListFilled;
exports.IconClipboardOff = IconClipboardOff;
exports.IconClipboardPlus = IconClipboardPlus;
exports.IconClipboardSearch = IconClipboardSearch;
exports.IconClipboardSmile = IconClipboardSmile;
exports.IconClipboardText = IconClipboardText;
exports.IconClipboardTextFilled = IconClipboardTextFilled;
exports.IconClipboardTypography = IconClipboardTypography;
exports.IconClipboardTypographyFilled = IconClipboardTypographyFilled;
exports.IconClipboardX = IconClipboardX;
exports.IconClipboardXFilled = IconClipboardXFilled;
exports.IconClock = IconClock;
exports.IconClock12 = IconClock12;
exports.IconClock2 = IconClock2;
exports.IconClock24 = IconClock24;
exports.IconClockBitcoin = IconClockBitcoin;
exports.IconClockBolt = IconClockBolt;
exports.IconClockCancel = IconClockCancel;
exports.IconClockCheck = IconClockCheck;
exports.IconClockCode = IconClockCode;
exports.IconClockCog = IconClockCog;
exports.IconClockDollar = IconClockDollar;
exports.IconClockDown = IconClockDown;
exports.IconClockEdit = IconClockEdit;
exports.IconClockExclamation = IconClockExclamation;
exports.IconClockFilled = IconClockFilled;
exports.IconClockHeart = IconClockHeart;
exports.IconClockHour1 = IconClockHour1;
exports.IconClockHour10 = IconClockHour10;
exports.IconClockHour10Filled = IconClockHour10Filled;
exports.IconClockHour11 = IconClockHour11;
exports.IconClockHour11Filled = IconClockHour11Filled;
exports.IconClockHour12 = IconClockHour12;
exports.IconClockHour12Filled = IconClockHour12Filled;
exports.IconClockHour1Filled = IconClockHour1Filled;
exports.IconClockHour2 = IconClockHour2;
exports.IconClockHour2Filled = IconClockHour2Filled;
exports.IconClockHour3 = IconClockHour3;
exports.IconClockHour3Filled = IconClockHour3Filled;
exports.IconClockHour4 = IconClockHour4;
exports.IconClockHour4Filled = IconClockHour4Filled;
exports.IconClockHour5 = IconClockHour5;
exports.IconClockHour5Filled = IconClockHour5Filled;
exports.IconClockHour6 = IconClockHour6;
exports.IconClockHour6Filled = IconClockHour6Filled;
exports.IconClockHour7 = IconClockHour7;
exports.IconClockHour7Filled = IconClockHour7Filled;
exports.IconClockHour8 = IconClockHour8;
exports.IconClockHour8Filled = IconClockHour8Filled;
exports.IconClockHour9 = IconClockHour9;
exports.IconClockHour9Filled = IconClockHour9Filled;
exports.IconClockMinus = IconClockMinus;
exports.IconClockOff = IconClockOff;
exports.IconClockPause = IconClockPause;
exports.IconClockPin = IconClockPin;
exports.IconClockPlay = IconClockPlay;
exports.IconClockPlus = IconClockPlus;
exports.IconClockQuestion = IconClockQuestion;
exports.IconClockRecord = IconClockRecord;
exports.IconClockSearch = IconClockSearch;
exports.IconClockShare = IconClockShare;
exports.IconClockShield = IconClockShield;
exports.IconClockStar = IconClockStar;
exports.IconClockStop = IconClockStop;
exports.IconClockUp = IconClockUp;
exports.IconClockX = IconClockX;
exports.IconClothesRack = IconClothesRack;
exports.IconClothesRackOff = IconClothesRackOff;
exports.IconCloud = IconCloud;
exports.IconCloudBitcoin = IconCloudBitcoin;
exports.IconCloudBolt = IconCloudBolt;
exports.IconCloudCancel = IconCloudCancel;
exports.IconCloudCheck = IconCloudCheck;
exports.IconCloudCode = IconCloudCode;
exports.IconCloudCog = IconCloudCog;
exports.IconCloudComputing = IconCloudComputing;
exports.IconCloudComputingFilled = IconCloudComputingFilled;
exports.IconCloudDataConnection = IconCloudDataConnection;
exports.IconCloudDataConnectionFilled = IconCloudDataConnectionFilled;
exports.IconCloudDollar = IconCloudDollar;
exports.IconCloudDown = IconCloudDown;
exports.IconCloudDownload = IconCloudDownload;
exports.IconCloudExclamation = IconCloudExclamation;
exports.IconCloudFilled = IconCloudFilled;
exports.IconCloudFog = IconCloudFog;
exports.IconCloudHeart = IconCloudHeart;
exports.IconCloudLock = IconCloudLock;
exports.IconCloudLockOpen = IconCloudLockOpen;
exports.IconCloudMinus = IconCloudMinus;
exports.IconCloudNetwork = IconCloudNetwork;
exports.IconCloudOff = IconCloudOff;
exports.IconCloudPause = IconCloudPause;
exports.IconCloudPin = IconCloudPin;
exports.IconCloudPlus = IconCloudPlus;
exports.IconCloudQuestion = IconCloudQuestion;
exports.IconCloudRain = IconCloudRain;
exports.IconCloudSearch = IconCloudSearch;
exports.IconCloudShare = IconCloudShare;
exports.IconCloudSnow = IconCloudSnow;
exports.IconCloudStar = IconCloudStar;
exports.IconCloudStorm = IconCloudStorm;
exports.IconCloudUp = IconCloudUp;
exports.IconCloudUpload = IconCloudUpload;
exports.IconCloudX = IconCloudX;
exports.IconClover = IconClover;
exports.IconClover2 = IconClover2;
exports.IconCloverFilled = IconCloverFilled;
exports.IconClubs = IconClubs;
exports.IconClubsFilled = IconClubsFilled;
exports.IconCode = IconCode;
exports.IconCodeAsterisk = IconCodeAsterisk;
exports.IconCodeAsterix = IconCodeAsterisk;
exports.IconCodeCircle = IconCodeCircle;
exports.IconCodeCircle2 = IconCodeCircle2;
exports.IconCodeCircle2Filled = IconCodeCircle2Filled;
exports.IconCodeCircleFilled = IconCodeCircleFilled;
exports.IconCodeDots = IconCodeDots;
exports.IconCodeMinus = IconCodeMinus;
exports.IconCodeOff = IconCodeOff;
exports.IconCodePlus = IconCodePlus;
exports.IconCodeVariable = IconCodeVariable;
exports.IconCodeVariableMinus = IconCodeVariableMinus;
exports.IconCodeVariablePlus = IconCodeVariablePlus;
exports.IconCoffee = IconCoffee;
exports.IconCoffeeOff = IconCoffeeOff;
exports.IconCoffin = IconCoffin;
exports.IconCoin = IconCoin;
exports.IconCoinBitcoin = IconCoinBitcoin;
exports.IconCoinBitcoinFilled = IconCoinBitcoinFilled;
exports.IconCoinEuro = IconCoinEuro;
exports.IconCoinEuroFilled = IconCoinEuroFilled;
exports.IconCoinFilled = IconCoinFilled;
exports.IconCoinMonero = IconCoinMonero;
exports.IconCoinMoneroFilled = IconCoinMoneroFilled;
exports.IconCoinOff = IconCoinOff;
exports.IconCoinPound = IconCoinPound;
exports.IconCoinPoundFilled = IconCoinPoundFilled;
exports.IconCoinRupee = IconCoinRupee;
exports.IconCoinRupeeFilled = IconCoinRupeeFilled;
exports.IconCoinTaka = IconCoinTaka;
exports.IconCoinTakaFilled = IconCoinTakaFilled;
exports.IconCoinYen = IconCoinYen;
exports.IconCoinYenFilled = IconCoinYenFilled;
exports.IconCoinYuan = IconCoinYuan;
exports.IconCoinYuanFilled = IconCoinYuanFilled;
exports.IconCoins = IconCoins;
exports.IconColorFilter = IconColorFilter;
exports.IconColorPicker = IconColorPicker;
exports.IconColorPickerOff = IconColorPickerOff;
exports.IconColorSwatch = IconColorSwatch;
exports.IconColorSwatchOff = IconColorSwatchOff;
exports.IconColumnInsertLeft = IconColumnInsertLeft;
exports.IconColumnInsertRight = IconColumnInsertRight;
exports.IconColumnRemove = IconColumnRemove;
exports.IconColumns = IconColumns;
exports.IconColumns1 = IconColumns1;
exports.IconColumns2 = IconColumns2;
exports.IconColumns3 = IconColumns3;
exports.IconColumnsOff = IconColumnsOff;
exports.IconComet = IconComet;
exports.IconCommand = IconCommand;
exports.IconCommandOff = IconCommandOff;
exports.IconCompass = IconCompass;
exports.IconCompassFilled = IconCompassFilled;
exports.IconCompassOff = IconCompassOff;
exports.IconComponents = IconComponents;
exports.IconComponentsOff = IconComponentsOff;
exports.IconCone = IconCone;
exports.IconCone2 = IconCone2;
exports.IconCone2Filled = IconCone2Filled;
exports.IconConeFilled = IconConeFilled;
exports.IconConeOff = IconConeOff;
exports.IconConePlus = IconConePlus;
exports.IconConfetti = IconConfetti;
exports.IconConfettiOff = IconConfettiOff;
exports.IconConfucius = IconConfucius;
exports.IconCongruentTo = IconCongruentTo;
exports.IconContainer = IconContainer;
exports.IconContainerOff = IconContainerOff;
exports.IconContract = IconContract;
exports.IconContrast = IconContrast;
exports.IconContrast2 = IconContrast2;
exports.IconContrast2Filled = IconContrast2Filled;
exports.IconContrast2Off = IconContrast2Off;
exports.IconContrastFilled = IconContrastFilled;
exports.IconContrastOff = IconContrastOff;
exports.IconCooker = IconCooker;
exports.IconCookie = IconCookie;
exports.IconCookieFilled = IconCookieFilled;
exports.IconCookieMan = IconCookieMan;
exports.IconCookieManFilled = IconCookieManFilled;
exports.IconCookieOff = IconCookieOff;
exports.IconCopy = IconCopy;
exports.IconCopyCheck = IconCopyCheck;
exports.IconCopyCheckFilled = IconCopyCheckFilled;
exports.IconCopyMinus = IconCopyMinus;
exports.IconCopyMinusFilled = IconCopyMinusFilled;
exports.IconCopyOff = IconCopyOff;
exports.IconCopyPlus = IconCopyPlus;
exports.IconCopyPlusFilled = IconCopyPlusFilled;
exports.IconCopyX = IconCopyX;
exports.IconCopyXFilled = IconCopyXFilled;
exports.IconCopyleft = IconCopyleft;
exports.IconCopyleftFilled = IconCopyleftFilled;
exports.IconCopyleftOff = IconCopyleftOff;
exports.IconCopyright = IconCopyright;
exports.IconCopyrightFilled = IconCopyrightFilled;
exports.IconCopyrightOff = IconCopyrightOff;
exports.IconCornerDownLeft = IconCornerDownLeft;
exports.IconCornerDownLeftDouble = IconCornerDownLeftDouble;
exports.IconCornerDownRight = IconCornerDownRight;
exports.IconCornerDownRightDouble = IconCornerDownRightDouble;
exports.IconCornerLeftDown = IconCornerLeftDown;
exports.IconCornerLeftDownDouble = IconCornerLeftDownDouble;
exports.IconCornerLeftUp = IconCornerLeftUp;
exports.IconCornerLeftUpDouble = IconCornerLeftUpDouble;
exports.IconCornerRightDown = IconCornerRightDown;
exports.IconCornerRightDownDouble = IconCornerRightDownDouble;
exports.IconCornerRightUp = IconCornerRightUp;
exports.IconCornerRightUpDouble = IconCornerRightUpDouble;
exports.IconCornerUpLeft = IconCornerUpLeft;
exports.IconCornerUpLeftDouble = IconCornerUpLeftDouble;
exports.IconCornerUpRight = IconCornerUpRight;
exports.IconCornerUpRightDouble = IconCornerUpRightDouble;
exports.IconCpu = IconCpu;
exports.IconCpu2 = IconCpu2;
exports.IconCpuOff = IconCpuOff;
exports.IconCrane = IconCrane;
exports.IconCraneOff = IconCraneOff;
exports.IconCreativeCommons = IconCreativeCommons;
exports.IconCreativeCommonsBy = IconCreativeCommonsBy;
exports.IconCreativeCommonsNc = IconCreativeCommonsNc;
exports.IconCreativeCommonsNd = IconCreativeCommonsNd;
exports.IconCreativeCommonsOff = IconCreativeCommonsOff;
exports.IconCreativeCommonsSa = IconCreativeCommonsSa;
exports.IconCreativeCommonsZero = IconCreativeCommonsZero;
exports.IconCreditCard = IconCreditCard;
exports.IconCreditCardFilled = IconCreditCardFilled;
exports.IconCreditCardOff = IconCreditCardOff;
exports.IconCreditCardPay = IconCreditCardPay;
exports.IconCreditCardRefund = IconCreditCardRefund;
exports.IconCricket = IconCricket;
exports.IconCrop = IconCrop;
exports.IconCrop11 = IconCrop11;
exports.IconCrop11Filled = IconCrop11Filled;
exports.IconCrop169 = IconCrop169;
exports.IconCrop169Filled = IconCrop169Filled;
exports.IconCrop32 = IconCrop32;
exports.IconCrop32Filled = IconCrop32Filled;
exports.IconCrop54 = IconCrop54;
exports.IconCrop54Filled = IconCrop54Filled;
exports.IconCrop75 = IconCrop75;
exports.IconCrop75Filled = IconCrop75Filled;
exports.IconCropLandscape = IconCropLandscape;
exports.IconCropLandscapeFilled = IconCropLandscapeFilled;
exports.IconCropPortrait = IconCropPortrait;
exports.IconCropPortraitFilled = IconCropPortraitFilled;
exports.IconCross = IconCross;
exports.IconCrossFilled = IconCrossFilled;
exports.IconCrossOff = IconCrossOff;
exports.IconCrosshair = IconCrosshair;
exports.IconCrown = IconCrown;
exports.IconCrownOff = IconCrownOff;
exports.IconCrutches = IconCrutches;
exports.IconCrutchesOff = IconCrutchesOff;
exports.IconCrystalBall = IconCrystalBall;
exports.IconCsv = IconCsv;
exports.IconCube = IconCube;
exports.IconCube3dSphere = IconCube3dSphere;
exports.IconCube3dSphereOff = IconCube3dSphereOff;
exports.IconCubeOff = IconCubeOff;
exports.IconCubePlus = IconCubePlus;
exports.IconCubeSend = IconCubeSend;
exports.IconCubeSpark = IconCubeSpark;
exports.IconCubeUnfolded = IconCubeUnfolded;
exports.IconCup = IconCup;
exports.IconCupOff = IconCupOff;
exports.IconCurling = IconCurling;
exports.IconCurlyLoop = IconCurlyLoop;
exports.IconCurrency = IconCurrency;
exports.IconCurrencyAfghani = IconCurrencyAfghani;
exports.IconCurrencyBahraini = IconCurrencyBahraini;
exports.IconCurrencyBaht = IconCurrencyBaht;
exports.IconCurrencyBitcoin = IconCurrencyBitcoin;
exports.IconCurrencyCent = IconCurrencyCent;
exports.IconCurrencyDinar = IconCurrencyDinar;
exports.IconCurrencyDirham = IconCurrencyDirham;
exports.IconCurrencyDogecoin = IconCurrencyDogecoin;
exports.IconCurrencyDollar = IconCurrencyDollar;
exports.IconCurrencyDollarAustralian = IconCurrencyDollarAustralian;
exports.IconCurrencyDollarBrunei = IconCurrencyDollarBrunei;
exports.IconCurrencyDollarCanadian = IconCurrencyDollarCanadian;
exports.IconCurrencyDollarGuyanese = IconCurrencyDollarGuyanese;
exports.IconCurrencyDollarOff = IconCurrencyDollarOff;
exports.IconCurrencyDollarSingapore = IconCurrencyDollarSingapore;
exports.IconCurrencyDollarZimbabwean = IconCurrencyDollarZimbabwean;
exports.IconCurrencyDong = IconCurrencyDong;
exports.IconCurrencyDram = IconCurrencyDram;
exports.IconCurrencyEthereum = IconCurrencyEthereum;
exports.IconCurrencyEuro = IconCurrencyEuro;
exports.IconCurrencyEuroOff = IconCurrencyEuroOff;
exports.IconCurrencyFlorin = IconCurrencyFlorin;
exports.IconCurrencyForint = IconCurrencyForint;
exports.IconCurrencyFrank = IconCurrencyFrank;
exports.IconCurrencyGuarani = IconCurrencyGuarani;
exports.IconCurrencyHryvnia = IconCurrencyHryvnia;
exports.IconCurrencyIranianRial = IconCurrencyIranianRial;
exports.IconCurrencyKip = IconCurrencyKip;
exports.IconCurrencyKroneCzech = IconCurrencyKroneCzech;
exports.IconCurrencyKroneDanish = IconCurrencyKroneDanish;
exports.IconCurrencyKroneSwedish = IconCurrencyKroneSwedish;
exports.IconCurrencyLari = IconCurrencyLari;
exports.IconCurrencyLeu = IconCurrencyLeu;
exports.IconCurrencyLira = IconCurrencyLira;
exports.IconCurrencyLitecoin = IconCurrencyLitecoin;
exports.IconCurrencyLyd = IconCurrencyLyd;
exports.IconCurrencyManat = IconCurrencyManat;
exports.IconCurrencyMonero = IconCurrencyMonero;
exports.IconCurrencyNaira = IconCurrencyNaira;
exports.IconCurrencyNano = IconCurrencyNano;
exports.IconCurrencyOff = IconCurrencyOff;
exports.IconCurrencyPaanga = IconCurrencyPaanga;
exports.IconCurrencyPeso = IconCurrencyPeso;
exports.IconCurrencyPound = IconCurrencyPound;
exports.IconCurrencyPoundOff = IconCurrencyPoundOff;
exports.IconCurrencyQuetzal = IconCurrencyQuetzal;
exports.IconCurrencyReal = IconCurrencyReal;
exports.IconCurrencyRenminbi = IconCurrencyRenminbi;
exports.IconCurrencyRipple = IconCurrencyRipple;
exports.IconCurrencyRiyal = IconCurrencyRiyal;
exports.IconCurrencyRubel = IconCurrencyRubel;
exports.IconCurrencyRufiyaa = IconCurrencyRufiyaa;
exports.IconCurrencyRupee = IconCurrencyRupee;
exports.IconCurrencyRupeeNepalese = IconCurrencyRupeeNepalese;
exports.IconCurrencyShekel = IconCurrencyShekel;
exports.IconCurrencySolana = IconCurrencySolana;
exports.IconCurrencySom = IconCurrencySom;
exports.IconCurrencyTaka = IconCurrencyTaka;
exports.IconCurrencyTenge = IconCurrencyTenge;
exports.IconCurrencyTugrik = IconCurrencyTugrik;
exports.IconCurrencyWon = IconCurrencyWon;
exports.IconCurrencyXrp = IconCurrencyXrp;
exports.IconCurrencyYen = IconCurrencyYen;
exports.IconCurrencyYenOff = IconCurrencyYenOff;
exports.IconCurrencyYuan = IconCurrencyYuan;
exports.IconCurrencyZloty = IconCurrencyZloty;
exports.IconCurrentLocation = IconCurrentLocation;
exports.IconCurrentLocationFilled = IconCurrentLocationFilled;
exports.IconCurrentLocationOff = IconCurrentLocationOff;
exports.IconCursorOff = IconCursorOff;
exports.IconCursorText = IconCursorText;
exports.IconCut = IconCut;
exports.IconCylinder = IconCylinder;
exports.IconCylinderOff = IconCylinderOff;
exports.IconCylinderPlus = IconCylinderPlus;
exports.IconDashboard = IconDashboard;
exports.IconDashboardFilled = IconDashboardFilled;
exports.IconDashboardOff = IconDashboardOff;
exports.IconDatabase = IconDatabase;
exports.IconDatabaseCog = IconDatabaseCog;
exports.IconDatabaseDollar = IconDatabaseDollar;
exports.IconDatabaseEdit = IconDatabaseEdit;
exports.IconDatabaseExclamation = IconDatabaseExclamation;
exports.IconDatabaseExport = IconDatabaseExport;
exports.IconDatabaseHeart = IconDatabaseHeart;
exports.IconDatabaseImport = IconDatabaseImport;
exports.IconDatabaseLeak = IconDatabaseLeak;
exports.IconDatabaseMinus = IconDatabaseMinus;
exports.IconDatabaseOff = IconDatabaseOff;
exports.IconDatabasePlus = IconDatabasePlus;
exports.IconDatabaseSearch = IconDatabaseSearch;
exports.IconDatabaseShare = IconDatabaseShare;
exports.IconDatabaseSmile = IconDatabaseSmile;
exports.IconDatabaseStar = IconDatabaseStar;
exports.IconDatabaseX = IconDatabaseX;
exports.IconDecimal = IconDecimal;
exports.IconDeer = IconDeer;
exports.IconDelta = IconDelta;
exports.IconDental = IconDental;
exports.IconDentalBroken = IconDentalBroken;
exports.IconDentalOff = IconDentalOff;
exports.IconDeselect = IconDeselect;
exports.IconDesk = IconDesk;
exports.IconDetails = IconDetails;
exports.IconDetailsOff = IconDetailsOff;
exports.IconDeviceAirpods = IconDeviceAirpods;
exports.IconDeviceAirpodsCase = IconDeviceAirpodsCase;
exports.IconDeviceAirtag = IconDeviceAirtag;
exports.IconDeviceAnalytics = IconDeviceAnalytics;
exports.IconDeviceAudioTape = IconDeviceAudioTape;
exports.IconDeviceCameraPhone = IconDeviceCameraPhone;
exports.IconDeviceCctv = IconDeviceCctv;
exports.IconDeviceCctvFilled = IconDeviceCctvFilled;
exports.IconDeviceCctvOff = IconDeviceCctvOff;
exports.IconDeviceComputerCamera = IconDeviceComputerCamera;
exports.IconDeviceComputerCameraOff = IconDeviceComputerCameraOff;
exports.IconDeviceDesktop = IconDeviceDesktop;
exports.IconDeviceDesktopAnalytics = IconDeviceDesktopAnalytics;
exports.IconDeviceDesktopBolt = IconDeviceDesktopBolt;
exports.IconDeviceDesktopCancel = IconDeviceDesktopCancel;
exports.IconDeviceDesktopCheck = IconDeviceDesktopCheck;
exports.IconDeviceDesktopCode = IconDeviceDesktopCode;
exports.IconDeviceDesktopCog = IconDeviceDesktopCog;
exports.IconDeviceDesktopDollar = IconDeviceDesktopDollar;
exports.IconDeviceDesktopDown = IconDeviceDesktopDown;
exports.IconDeviceDesktopExclamation = IconDeviceDesktopExclamation;
exports.IconDeviceDesktopFilled = IconDeviceDesktopFilled;
exports.IconDeviceDesktopHeart = IconDeviceDesktopHeart;
exports.IconDeviceDesktopMinus = IconDeviceDesktopMinus;
exports.IconDeviceDesktopOff = IconDeviceDesktopOff;
exports.IconDeviceDesktopPause = IconDeviceDesktopPause;
exports.IconDeviceDesktopPin = IconDeviceDesktopPin;
exports.IconDeviceDesktopPlus = IconDeviceDesktopPlus;
exports.IconDeviceDesktopQuestion = IconDeviceDesktopQuestion;
exports.IconDeviceDesktopSearch = IconDeviceDesktopSearch;
exports.IconDeviceDesktopShare = IconDeviceDesktopShare;
exports.IconDeviceDesktopStar = IconDeviceDesktopStar;
exports.IconDeviceDesktopUp = IconDeviceDesktopUp;
exports.IconDeviceDesktopX = IconDeviceDesktopX;
exports.IconDeviceFloppy = IconDeviceFloppy;
exports.IconDeviceGamepad = IconDeviceGamepad;
exports.IconDeviceGamepad2 = IconDeviceGamepad2;
exports.IconDeviceGamepad3 = IconDeviceGamepad3;
exports.IconDeviceGamepad3Filled = IconDeviceGamepad3Filled;
exports.IconDeviceHeartMonitor = IconDeviceHeartMonitor;
exports.IconDeviceHeartMonitorFilled = IconDeviceHeartMonitorFilled;
exports.IconDeviceImac = IconDeviceImac;
exports.IconDeviceImacBolt = IconDeviceImacBolt;
exports.IconDeviceImacCancel = IconDeviceImacCancel;
exports.IconDeviceImacCheck = IconDeviceImacCheck;
exports.IconDeviceImacCode = IconDeviceImacCode;
exports.IconDeviceImacCog = IconDeviceImacCog;
exports.IconDeviceImacDollar = IconDeviceImacDollar;
exports.IconDeviceImacDown = IconDeviceImacDown;
exports.IconDeviceImacExclamation = IconDeviceImacExclamation;
exports.IconDeviceImacFilled = IconDeviceImacFilled;
exports.IconDeviceImacHeart = IconDeviceImacHeart;
exports.IconDeviceImacMinus = IconDeviceImacMinus;
exports.IconDeviceImacOff = IconDeviceImacOff;
exports.IconDeviceImacPause = IconDeviceImacPause;
exports.IconDeviceImacPin = IconDeviceImacPin;
exports.IconDeviceImacPlus = IconDeviceImacPlus;
exports.IconDeviceImacQuestion = IconDeviceImacQuestion;
exports.IconDeviceImacSearch = IconDeviceImacSearch;
exports.IconDeviceImacShare = IconDeviceImacShare;
exports.IconDeviceImacStar = IconDeviceImacStar;
exports.IconDeviceImacUp = IconDeviceImacUp;
exports.IconDeviceImacX = IconDeviceImacX;
exports.IconDeviceIpad = IconDeviceIpad;
exports.IconDeviceIpadBolt = IconDeviceIpadBolt;
exports.IconDeviceIpadCancel = IconDeviceIpadCancel;
exports.IconDeviceIpadCheck = IconDeviceIpadCheck;
exports.IconDeviceIpadCode = IconDeviceIpadCode;
exports.IconDeviceIpadCog = IconDeviceIpadCog;
exports.IconDeviceIpadDollar = IconDeviceIpadDollar;
exports.IconDeviceIpadDown = IconDeviceIpadDown;
exports.IconDeviceIpadExclamation = IconDeviceIpadExclamation;
exports.IconDeviceIpadFilled = IconDeviceIpadFilled;
exports.IconDeviceIpadHeart = IconDeviceIpadHeart;
exports.IconDeviceIpadHorizontal = IconDeviceIpadHorizontal;
exports.IconDeviceIpadHorizontalBolt = IconDeviceIpadHorizontalBolt;
exports.IconDeviceIpadHorizontalCancel = IconDeviceIpadHorizontalCancel;
exports.IconDeviceIpadHorizontalCheck = IconDeviceIpadHorizontalCheck;
exports.IconDeviceIpadHorizontalCode = IconDeviceIpadHorizontalCode;
exports.IconDeviceIpadHorizontalCog = IconDeviceIpadHorizontalCog;
exports.IconDeviceIpadHorizontalDollar = IconDeviceIpadHorizontalDollar;
exports.IconDeviceIpadHorizontalDown = IconDeviceIpadHorizontalDown;
exports.IconDeviceIpadHorizontalExclamation = IconDeviceIpadHorizontalExclamation;
exports.IconDeviceIpadHorizontalHeart = IconDeviceIpadHorizontalHeart;
exports.IconDeviceIpadHorizontalMinus = IconDeviceIpadHorizontalMinus;
exports.IconDeviceIpadHorizontalOff = IconDeviceIpadHorizontalOff;
exports.IconDeviceIpadHorizontalPause = IconDeviceIpadHorizontalPause;
exports.IconDeviceIpadHorizontalPin = IconDeviceIpadHorizontalPin;
exports.IconDeviceIpadHorizontalPlus = IconDeviceIpadHorizontalPlus;
exports.IconDeviceIpadHorizontalQuestion = IconDeviceIpadHorizontalQuestion;
exports.IconDeviceIpadHorizontalSearch = IconDeviceIpadHorizontalSearch;
exports.IconDeviceIpadHorizontalShare = IconDeviceIpadHorizontalShare;
exports.IconDeviceIpadHorizontalStar = IconDeviceIpadHorizontalStar;
exports.IconDeviceIpadHorizontalUp = IconDeviceIpadHorizontalUp;
exports.IconDeviceIpadHorizontalX = IconDeviceIpadHorizontalX;
exports.IconDeviceIpadMinus = IconDeviceIpadMinus;
exports.IconDeviceIpadOff = IconDeviceIpadOff;
exports.IconDeviceIpadPause = IconDeviceIpadPause;
exports.IconDeviceIpadPin = IconDeviceIpadPin;
exports.IconDeviceIpadPlus = IconDeviceIpadPlus;
exports.IconDeviceIpadQuestion = IconDeviceIpadQuestion;
exports.IconDeviceIpadSearch = IconDeviceIpadSearch;
exports.IconDeviceIpadShare = IconDeviceIpadShare;
exports.IconDeviceIpadStar = IconDeviceIpadStar;
exports.IconDeviceIpadUp = IconDeviceIpadUp;
exports.IconDeviceIpadX = IconDeviceIpadX;
exports.IconDeviceLandlinePhone = IconDeviceLandlinePhone;
exports.IconDeviceLaptop = IconDeviceLaptop;
exports.IconDeviceLaptopOff = IconDeviceLaptopOff;
exports.IconDeviceMobile = IconDeviceMobile;
exports.IconDeviceMobileBolt = IconDeviceMobileBolt;
exports.IconDeviceMobileCancel = IconDeviceMobileCancel;
exports.IconDeviceMobileCharging = IconDeviceMobileCharging;
exports.IconDeviceMobileCheck = IconDeviceMobileCheck;
exports.IconDeviceMobileCode = IconDeviceMobileCode;
exports.IconDeviceMobileCog = IconDeviceMobileCog;
exports.IconDeviceMobileDollar = IconDeviceMobileDollar;
exports.IconDeviceMobileDown = IconDeviceMobileDown;
exports.IconDeviceMobileExclamation = IconDeviceMobileExclamation;
exports.IconDeviceMobileFilled = IconDeviceMobileFilled;
exports.IconDeviceMobileHeart = IconDeviceMobileHeart;
exports.IconDeviceMobileMessage = IconDeviceMobileMessage;
exports.IconDeviceMobileMinus = IconDeviceMobileMinus;
exports.IconDeviceMobileOff = IconDeviceMobileOff;
exports.IconDeviceMobilePause = IconDeviceMobilePause;
exports.IconDeviceMobilePin = IconDeviceMobilePin;
exports.IconDeviceMobilePlus = IconDeviceMobilePlus;
exports.IconDeviceMobileQuestion = IconDeviceMobileQuestion;
exports.IconDeviceMobileRotated = IconDeviceMobileRotated;
exports.IconDeviceMobileSearch = IconDeviceMobileSearch;
exports.IconDeviceMobileShare = IconDeviceMobileShare;
exports.IconDeviceMobileStar = IconDeviceMobileStar;
exports.IconDeviceMobileUp = IconDeviceMobileUp;
exports.IconDeviceMobileVibration = IconDeviceMobileVibration;
exports.IconDeviceMobileX = IconDeviceMobileX;
exports.IconDeviceNintendo = IconDeviceNintendo;
exports.IconDeviceNintendoOff = IconDeviceNintendoOff;
exports.IconDeviceProjector = IconDeviceProjector;
exports.IconDeviceRemote = IconDeviceRemote;
exports.IconDeviceRemoteFilled = IconDeviceRemoteFilled;
exports.IconDeviceSdCard = IconDeviceSdCard;
exports.IconDeviceSim = IconDeviceSim;
exports.IconDeviceSim1 = IconDeviceSim1;
exports.IconDeviceSim2 = IconDeviceSim2;
exports.IconDeviceSim3 = IconDeviceSim3;
exports.IconDeviceSpeaker = IconDeviceSpeaker;
exports.IconDeviceSpeakerFilled = IconDeviceSpeakerFilled;
exports.IconDeviceSpeakerOff = IconDeviceSpeakerOff;
exports.IconDeviceTablet = IconDeviceTablet;
exports.IconDeviceTabletBolt = IconDeviceTabletBolt;
exports.IconDeviceTabletCancel = IconDeviceTabletCancel;
exports.IconDeviceTabletCheck = IconDeviceTabletCheck;
exports.IconDeviceTabletCode = IconDeviceTabletCode;
exports.IconDeviceTabletCog = IconDeviceTabletCog;
exports.IconDeviceTabletDollar = IconDeviceTabletDollar;
exports.IconDeviceTabletDown = IconDeviceTabletDown;
exports.IconDeviceTabletExclamation = IconDeviceTabletExclamation;
exports.IconDeviceTabletFilled = IconDeviceTabletFilled;
exports.IconDeviceTabletHeart = IconDeviceTabletHeart;
exports.IconDeviceTabletMinus = IconDeviceTabletMinus;
exports.IconDeviceTabletOff = IconDeviceTabletOff;
exports.IconDeviceTabletPause = IconDeviceTabletPause;
exports.IconDeviceTabletPin = IconDeviceTabletPin;
exports.IconDeviceTabletPlus = IconDeviceTabletPlus;
exports.IconDeviceTabletQuestion = IconDeviceTabletQuestion;
exports.IconDeviceTabletSearch = IconDeviceTabletSearch;
exports.IconDeviceTabletShare = IconDeviceTabletShare;
exports.IconDeviceTabletStar = IconDeviceTabletStar;
exports.IconDeviceTabletUp = IconDeviceTabletUp;
exports.IconDeviceTabletX = IconDeviceTabletX;
exports.IconDeviceTv = IconDeviceTv;
exports.IconDeviceTvFilled = IconDeviceTvFilled;
exports.IconDeviceTvOff = IconDeviceTvOff;
exports.IconDeviceTvOld = IconDeviceTvOld;
exports.IconDeviceTvOldFilled = IconDeviceTvOldFilled;
exports.IconDeviceUnknown = IconDeviceUnknown;
exports.IconDeviceUnknownFilled = IconDeviceUnknownFilled;
exports.IconDeviceUsb = IconDeviceUsb;
exports.IconDeviceUsbFilled = IconDeviceUsbFilled;
exports.IconDeviceVisionPro = IconDeviceVisionPro;
exports.IconDeviceVisionProFilled = IconDeviceVisionProFilled;
exports.IconDeviceWatch = IconDeviceWatch;
exports.IconDeviceWatchBolt = IconDeviceWatchBolt;
exports.IconDeviceWatchCancel = IconDeviceWatchCancel;
exports.IconDeviceWatchCheck = IconDeviceWatchCheck;
exports.IconDeviceWatchCode = IconDeviceWatchCode;
exports.IconDeviceWatchCog = IconDeviceWatchCog;
exports.IconDeviceWatchDollar = IconDeviceWatchDollar;
exports.IconDeviceWatchDown = IconDeviceWatchDown;
exports.IconDeviceWatchExclamation = IconDeviceWatchExclamation;
exports.IconDeviceWatchFilled = IconDeviceWatchFilled;
exports.IconDeviceWatchHeart = IconDeviceWatchHeart;
exports.IconDeviceWatchMinus = IconDeviceWatchMinus;
exports.IconDeviceWatchOff = IconDeviceWatchOff;
exports.IconDeviceWatchPause = IconDeviceWatchPause;
exports.IconDeviceWatchPin = IconDeviceWatchPin;
exports.IconDeviceWatchPlus = IconDeviceWatchPlus;
exports.IconDeviceWatchQuestion = IconDeviceWatchQuestion;
exports.IconDeviceWatchSearch = IconDeviceWatchSearch;
exports.IconDeviceWatchShare = IconDeviceWatchShare;
exports.IconDeviceWatchStar = IconDeviceWatchStar;
exports.IconDeviceWatchStats = IconDeviceWatchStats;
exports.IconDeviceWatchStats2 = IconDeviceWatchStats2;
exports.IconDeviceWatchUp = IconDeviceWatchUp;
exports.IconDeviceWatchX = IconDeviceWatchX;
exports.IconDevices = IconDevices;
exports.IconDevices2 = IconDevices2;
exports.IconDevicesBolt = IconDevicesBolt;
exports.IconDevicesCancel = IconDevicesCancel;
exports.IconDevicesCheck = IconDevicesCheck;
exports.IconDevicesCode = IconDevicesCode;
exports.IconDevicesCog = IconDevicesCog;
exports.IconDevicesDollar = IconDevicesDollar;
exports.IconDevicesDown = IconDevicesDown;
exports.IconDevicesExclamation = IconDevicesExclamation;
exports.IconDevicesHeart = IconDevicesHeart;
exports.IconDevicesMinus = IconDevicesMinus;
exports.IconDevicesOff = IconDevicesOff;
exports.IconDevicesPause = IconDevicesPause;
exports.IconDevicesPc = IconDevicesPc;
exports.IconDevicesPcOff = IconDevicesPcOff;
exports.IconDevicesPin = IconDevicesPin;
exports.IconDevicesPlus = IconDevicesPlus;
exports.IconDevicesQuestion = IconDevicesQuestion;
exports.IconDevicesSearch = IconDevicesSearch;
exports.IconDevicesShare = IconDevicesShare;
exports.IconDevicesStar = IconDevicesStar;
exports.IconDevicesUp = IconDevicesUp;
exports.IconDevicesX = IconDevicesX;
exports.IconDiabolo = IconDiabolo;
exports.IconDiaboloOff = IconDiaboloOff;
exports.IconDiaboloPlus = IconDiaboloPlus;
exports.IconDialpad = IconDialpad;
exports.IconDialpadFilled = IconDialpadFilled;
exports.IconDialpadOff = IconDialpadOff;
exports.IconDiamond = IconDiamond;
exports.IconDiamondFilled = IconDiamondFilled;
exports.IconDiamondOff = IconDiamondOff;
exports.IconDiamonds = IconDiamonds;
exports.IconDiamondsFilled = IconDiamondsFilled;
exports.IconDiaper = IconDiaper;
exports.IconDice = IconDice;
exports.IconDice1 = IconDice1;
exports.IconDice1Filled = IconDice1Filled;
exports.IconDice2 = IconDice2;
exports.IconDice2Filled = IconDice2Filled;
exports.IconDice3 = IconDice3;
exports.IconDice3Filled = IconDice3Filled;
exports.IconDice4 = IconDice4;
exports.IconDice4Filled = IconDice4Filled;
exports.IconDice5 = IconDice5;
exports.IconDice5Filled = IconDice5Filled;
exports.IconDice6 = IconDice6;
exports.IconDice6Filled = IconDice6Filled;
exports.IconDiceFilled = IconDiceFilled;
exports.IconDimensions = IconDimensions;
exports.IconDirection = IconDirection;
exports.IconDirectionArrows = IconDirectionArrows;
exports.IconDirectionArrowsFilled = IconDirectionArrowsFilled;
exports.IconDirectionHorizontal = IconDirectionHorizontal;
exports.IconDirectionSign = IconDirectionSign;
exports.IconDirectionSignFilled = IconDirectionSignFilled;
exports.IconDirectionSignOff = IconDirectionSignOff;
exports.IconDirections = IconDirections;
exports.IconDirectionsFilled = IconDirectionsFilled;
exports.IconDirectionsOff = IconDirectionsOff;
exports.IconDisabled = IconDisabled;
exports.IconDisabled2 = IconDisabled2;
exports.IconDisabledOff = IconDisabledOff;
exports.IconDisc = IconDisc;
exports.IconDiscFilled = IconDiscFilled;
exports.IconDiscGolf = IconDiscGolf;
exports.IconDiscOff = IconDiscOff;
exports.IconDiscount = IconDiscount;
exports.IconDiscount2 = IconRosetteDiscount;
exports.IconDiscount2Off = IconRosetteDiscountOff;
exports.IconDiscountCheck = IconRosetteDiscountCheck;
exports.IconDiscountCheckFilled = IconRosetteDiscountCheckFilled;
exports.IconDiscountFilled = IconDiscountFilled;
exports.IconDiscountOff = IconDiscountOff;
exports.IconDivide = IconDivide;
exports.IconDna = IconDna;
exports.IconDna2 = IconDna2;
exports.IconDna2Off = IconDna2Off;
exports.IconDnaOff = IconDnaOff;
exports.IconDog = IconDog;
exports.IconDogBowl = IconDogBowl;
exports.IconDoor = IconDoor;
exports.IconDoorEnter = IconDoorEnter;
exports.IconDoorExit = IconDoorExit;
exports.IconDoorOff = IconDoorOff;
exports.IconDots = IconDots;
exports.IconDotsCircleHorizontal = IconDotsCircleHorizontal;
exports.IconDotsDiagonal = IconDotsDiagonal;
exports.IconDotsDiagonal2 = IconDotsDiagonal2;
exports.IconDotsVertical = IconDotsVertical;
exports.IconDownload = IconDownload;
exports.IconDownloadOff = IconDownloadOff;
exports.IconDragDrop = IconDragDrop;
exports.IconDragDrop2 = IconDragDrop2;
exports.IconDrone = IconDrone;
exports.IconDroneOff = IconDroneOff;
exports.IconDropCircle = IconDropCircle;
exports.IconDropCircleFilled = IconDropCircleFilled;
exports.IconDroplet = IconDroplet;
exports.IconDropletBolt = IconDropletBolt;
exports.IconDropletCancel = IconDropletCancel;
exports.IconDropletCheck = IconDropletCheck;
exports.IconDropletCode = IconDropletCode;
exports.IconDropletCog = IconDropletCog;
exports.IconDropletDollar = IconDropletDollar;
exports.IconDropletDown = IconDropletDown;
exports.IconDropletExclamation = IconDropletExclamation;
exports.IconDropletFilled = IconDropletFilled;
exports.IconDropletHalf = IconDropletHalf;
exports.IconDropletHalf2 = IconDropletHalf2;
exports.IconDropletHalf2Filled = IconDropletHalf2Filled;
exports.IconDropletHalfFilled = IconDropletHalfFilled;
exports.IconDropletHeart = IconDropletHeart;
exports.IconDropletMinus = IconDropletMinus;
exports.IconDropletOff = IconDropletOff;
exports.IconDropletPause = IconDropletPause;
exports.IconDropletPin = IconDropletPin;
exports.IconDropletPlus = IconDropletPlus;
exports.IconDropletQuestion = IconDropletQuestion;
exports.IconDropletSearch = IconDropletSearch;
exports.IconDropletShare = IconDropletShare;
exports.IconDropletStar = IconDropletStar;
exports.IconDropletUp = IconDropletUp;
exports.IconDropletX = IconDropletX;
exports.IconDroplets = IconDroplets;
exports.IconDropletsFilled = IconDropletsFilled;
exports.IconDualScreen = IconDualScreen;
exports.IconDualScreenFilled = IconDualScreenFilled;
exports.IconDumpling = IconDumpling;
exports.IconDumplingFilled = IconDumplingFilled;
exports.IconEPassport = IconEPassport;
exports.IconEar = IconEar;
exports.IconEarOff = IconEarOff;
exports.IconEarScan = IconEarScan;
exports.IconEaseIn = IconEaseIn;
exports.IconEaseInControlPoint = IconEaseInControlPoint;
exports.IconEaseInOut = IconEaseInOut;
exports.IconEaseInOutControlPoints = IconEaseInOutControlPoints;
exports.IconEaseOut = IconEaseOut;
exports.IconEaseOutControlPoint = IconEaseOutControlPoint;
exports.IconEdit = IconEdit;
exports.IconEditCircle = IconEditCircle;
exports.IconEditCircleOff = IconEditCircleOff;
exports.IconEditOff = IconEditOff;
exports.IconEgg = IconEgg;
exports.IconEggCracked = IconEggCracked;
exports.IconEggCrackedFilled = IconEggCrackedFilled;
exports.IconEggFilled = IconEggFilled;
exports.IconEggFried = IconEggFried;
exports.IconEggFriedFilled = IconEggFriedFilled;
exports.IconEggOff = IconEggOff;
exports.IconEggs = IconEggs;
exports.IconElevator = IconElevator;
exports.IconElevatorFilled = IconElevatorFilled;
exports.IconElevatorOff = IconElevatorOff;
exports.IconEmergencyBed = IconEmergencyBed;
exports.IconEmpathize = IconEmpathize;
exports.IconEmpathizeOff = IconEmpathizeOff;
exports.IconEmphasis = IconEmphasis;
exports.IconEngine = IconEngine;
exports.IconEngineFilled = IconEngineFilled;
exports.IconEngineOff = IconEngineOff;
exports.IconEqual = IconEqual;
exports.IconEqualDouble = IconEqualDouble;
exports.IconEqualNot = IconEqualNot;
exports.IconEraser = IconEraser;
exports.IconEraserOff = IconEraserOff;
exports.IconError404 = IconError404;
exports.IconError404Off = IconError404Off;
exports.IconEscalator = IconEscalator;
exports.IconEscalatorDown = IconEscalatorDown;
exports.IconEscalatorDownFilled = IconEscalatorDownFilled;
exports.IconEscalatorFilled = IconEscalatorFilled;
exports.IconEscalatorUp = IconEscalatorUp;
exports.IconEscalatorUpFilled = IconEscalatorUpFilled;
exports.IconExchange = IconExchange;
exports.IconExchangeFilled = IconExchangeFilled;
exports.IconExchangeOff = IconExchangeOff;
exports.IconExclamationCircle = IconExclamationCircle;
exports.IconExclamationCircleFilled = IconExclamationCircleFilled;
exports.IconExclamationMark = IconExclamationMark;
exports.IconExclamationMarkOff = IconExclamationMarkOff;
exports.IconExplicit = IconExplicit;
exports.IconExplicitFilled = IconExplicitFilled;
exports.IconExplicitOff = IconExplicitOff;
exports.IconExposure = IconExposure;
exports.IconExposure0 = IconExposure0;
exports.IconExposureFilled = IconExposureFilled;
exports.IconExposureMinus1 = IconExposureMinus1;
exports.IconExposureMinus2 = IconExposureMinus2;
exports.IconExposureOff = IconExposureOff;
exports.IconExposurePlus1 = IconExposurePlus1;
exports.IconExposurePlus2 = IconExposurePlus2;
exports.IconExternalLink = IconExternalLink;
exports.IconExternalLinkOff = IconExternalLinkOff;
exports.IconEye = IconEye;
exports.IconEyeBitcoin = IconEyeBitcoin;
exports.IconEyeBolt = IconEyeBolt;
exports.IconEyeCancel = IconEyeCancel;
exports.IconEyeCheck = IconEyeCheck;
exports.IconEyeClosed = IconEyeClosed;
exports.IconEyeCode = IconEyeCode;
exports.IconEyeCog = IconEyeCog;
exports.IconEyeDiscount = IconEyeDiscount;
exports.IconEyeDollar = IconEyeDollar;
exports.IconEyeDotted = IconEyeDotted;
exports.IconEyeDown = IconEyeDown;
exports.IconEyeEdit = IconEyeEdit;
exports.IconEyeExclamation = IconEyeExclamation;
exports.IconEyeFilled = IconEyeFilled;
exports.IconEyeHeart = IconEyeHeart;
exports.IconEyeMinus = IconEyeMinus;
exports.IconEyeOff = IconEyeOff;
exports.IconEyePause = IconEyePause;
exports.IconEyePin = IconEyePin;
exports.IconEyePlus = IconEyePlus;
exports.IconEyeQuestion = IconEyeQuestion;
exports.IconEyeSearch = IconEyeSearch;
exports.IconEyeShare = IconEyeShare;
exports.IconEyeSpark = IconEyeSpark;
exports.IconEyeStar = IconEyeStar;
exports.IconEyeTable = IconEyeTable;
exports.IconEyeTableFilled = IconEyeTableFilled;
exports.IconEyeUp = IconEyeUp;
exports.IconEyeX = IconEyeX;
exports.IconEyeglass = IconEyeglass;
exports.IconEyeglass2 = IconEyeglass2;
exports.IconEyeglass2Filled = IconEyeglass2Filled;
exports.IconEyeglassFilled = IconEyeglassFilled;
exports.IconEyeglassOff = IconEyeglassOff;
exports.IconFaceId = IconFaceId;
exports.IconFaceIdError = IconFaceIdError;
exports.IconFaceMask = IconFaceMask;
exports.IconFaceMaskFilled = IconFaceMaskFilled;
exports.IconFaceMaskOff = IconFaceMaskOff;
exports.IconFall = IconFall;
exports.IconFavicon = IconFavicon;
exports.IconFaviconFilled = IconFaviconFilled;
exports.IconFeather = IconFeather;
exports.IconFeatherFilled = IconFeatherFilled;
exports.IconFeatherOff = IconFeatherOff;
exports.IconFence = IconFence;
exports.IconFenceFilled = IconFenceFilled;
exports.IconFenceOff = IconFenceOff;
exports.IconFerry = IconFerry;
exports.IconFerryFilled = IconFerryFilled;
exports.IconFidgetSpinner = IconFidgetSpinner;
exports.IconFidgetSpinnerFilled = IconFidgetSpinnerFilled;
exports.IconFile = IconFile;
exports.IconFile3d = IconFile3d;
exports.IconFileAi = IconFileAi;
exports.IconFileAlert = IconFileAlert;
exports.IconFileAnalytics = IconFileAnalytics;
exports.IconFileArrowLeft = IconFileArrowLeft;
exports.IconFileArrowRight = IconFileArrowRight;
exports.IconFileBarcode = IconFileBarcode;
exports.IconFileBitcoin = IconFileBitcoin;
exports.IconFileBroken = IconFileBroken;
exports.IconFileCertificate = IconFileCertificate;
exports.IconFileChart = IconFileChart;
exports.IconFileCheck = IconFileCheck;
exports.IconFileCheckFilled = IconFileCheckFilled;
exports.IconFileCode = IconFileCode;
exports.IconFileCode2 = IconFileCode2;
exports.IconFileCode2Filled = IconFileCode2Filled;
exports.IconFileCv = IconFileCv;
exports.IconFileCvFilled = IconFileCvFilled;
exports.IconFileDatabase = IconFileDatabase;
exports.IconFileDelta = IconFileDelta;
exports.IconFileDeltaFilled = IconFileDeltaFilled;
exports.IconFileDescription = IconFileDescription;
exports.IconFileDescriptionFilled = IconFileDescriptionFilled;
exports.IconFileDiff = IconFileDiff;
exports.IconFileDigit = IconFileDigit;
exports.IconFileDigitFilled = IconFileDigitFilled;
exports.IconFileDislike = IconFileDislike;
exports.IconFileDollar = IconFileDollar;
exports.IconFileDots = IconFileDots;
exports.IconFileDownload = IconFileDownload;
exports.IconFileDownloadFilled = IconFileDownloadFilled;
exports.IconFileEuro = IconFileEuro;
exports.IconFileExcel = IconFileExcel;
exports.IconFileExport = IconFileExport;
exports.IconFileFilled = IconFileFilled;
exports.IconFileFunction = IconFileFunction;
exports.IconFileHorizontal = IconFileHorizontal;
exports.IconFileHorizontalFilled = IconFileHorizontalFilled;
exports.IconFileImport = IconFileImport;
exports.IconFileInfinity = IconFileInfinity;
exports.IconFileInfo = IconFileInfo;
exports.IconFileInvoice = IconFileInvoice;
exports.IconFileInvoiceFilled = IconFileInvoiceFilled;
exports.IconFileIsr = IconFileIsr;
exports.IconFileLambda = IconFileLambda;
exports.IconFileLambdaFilled = IconFileLambdaFilled;
exports.IconFileLike = IconFileLike;
exports.IconFileMinus = IconFileMinus;
exports.IconFileMinusFilled = IconFileMinusFilled;
exports.IconFileMusic = IconFileMusic;
exports.IconFileNeutral = IconFileNeutral;
exports.IconFileNeutralFilled = IconFileNeutralFilled;
exports.IconFileOff = IconFileOff;
exports.IconFileOrientation = IconFileOrientation;
exports.IconFilePencil = IconFilePencil;
exports.IconFilePercent = IconFilePercent;
exports.IconFilePercentFilled = IconFilePercentFilled;
exports.IconFilePhone = IconFilePhone;
exports.IconFilePhoneFilled = IconFilePhoneFilled;
exports.IconFilePlus = IconFilePlus;
exports.IconFilePower = IconFilePower;
exports.IconFilePowerFilled = IconFilePowerFilled;
exports.IconFileReport = IconFileReport;
exports.IconFileRss = IconFileRss;
exports.IconFileRssFilled = IconFileRssFilled;
exports.IconFileSad = IconFileSad;
exports.IconFileSadFilled = IconFileSadFilled;
exports.IconFileScissors = IconFileScissors;
exports.IconFileSearch = IconFileSearch;
exports.IconFileSettings = IconFileSettings;
exports.IconFileShredder = IconFileShredder;
exports.IconFileSignal = IconFileSignal;
exports.IconFileSmile = IconFileSmile;
exports.IconFileSmileFilled = IconFileSmileFilled;
exports.IconFileSpark = IconFileSpark;
exports.IconFileSpreadsheet = IconFileSpreadsheet;
exports.IconFileStack = IconFileStack;
exports.IconFileStar = IconFileStar;
exports.IconFileStarFilled = IconFileStarFilled;
exports.IconFileSymlink = IconFileSymlink;
exports.IconFileText = IconFileText;
exports.IconFileTextAi = IconFileTextAi;
exports.IconFileTextFilled = IconFileTextFilled;
exports.IconFileTextShield = IconFileTextShield;
exports.IconFileTextSpark = IconFileTextSpark;
exports.IconFileTime = IconFileTime;
exports.IconFileTypeBmp = IconFileTypeBmp;
exports.IconFileTypeCss = IconFileTypeCss;
exports.IconFileTypeCsv = IconFileTypeCsv;
exports.IconFileTypeDoc = IconFileTypeDoc;
exports.IconFileTypeDocx = IconFileTypeDocx;
exports.IconFileTypeHtml = IconFileTypeHtml;
exports.IconFileTypeJpg = IconFileTypeJpg;
exports.IconFileTypeJs = IconFileTypeJs;
exports.IconFileTypeJsx = IconFileTypeJsx;
exports.IconFileTypePdf = IconFileTypePdf;
exports.IconFileTypePhp = IconFileTypePhp;
exports.IconFileTypePng = IconFileTypePng;
exports.IconFileTypePpt = IconFileTypePpt;
exports.IconFileTypeRs = IconFileTypeRs;
exports.IconFileTypeSql = IconFileTypeSql;
exports.IconFileTypeSvg = IconFileTypeSvg;
exports.IconFileTypeTs = IconFileTypeTs;
exports.IconFileTypeTsx = IconFileTypeTsx;
exports.IconFileTypeTxt = IconFileTypeTxt;
exports.IconFileTypeVue = IconFileTypeVue;
exports.IconFileTypeXls = IconFileTypeXls;
exports.IconFileTypeXml = IconFileTypeXml;
exports.IconFileTypeZip = IconFileTypeZip;
exports.IconFileTypography = IconFileTypography;
exports.IconFileUnknown = IconFileUnknown;
exports.IconFileUpload = IconFileUpload;
exports.IconFileVector = IconFileVector;
exports.IconFileWord = IconFileWord;
exports.IconFileX = IconFileX;
exports.IconFileXFilled = IconFileXFilled;
exports.IconFileZip = IconFileZip;
exports.IconFiles = IconFiles;
exports.IconFilesOff = IconFilesOff;
exports.IconFilter = IconFilter;
exports.IconFilterBolt = IconFilterBolt;
exports.IconFilterCancel = IconFilterCancel;
exports.IconFilterCheck = IconFilterCheck;
exports.IconFilterCode = IconFilterCode;
exports.IconFilterCog = IconFilterCog;
exports.IconFilterDiscount = IconFilterDiscount;
exports.IconFilterDollar = IconFilterDollar;
exports.IconFilterDown = IconFilterDown;
exports.IconFilterEdit = IconFilterEdit;
exports.IconFilterExclamation = IconFilterExclamation;
exports.IconFilterFilled = IconFilterFilled;
exports.IconFilterHeart = IconFilterHeart;
exports.IconFilterMinus = IconFilterMinus;
exports.IconFilterOff = IconFilterOff;
exports.IconFilterPause = IconFilterPause;
exports.IconFilterPin = IconFilterPin;
exports.IconFilterPlus = IconFilterPlus;
exports.IconFilterQuestion = IconFilterQuestion;
exports.IconFilterSearch = IconFilterSearch;
exports.IconFilterShare = IconFilterShare;
exports.IconFilterStar = IconFilterStar;
exports.IconFilterUp = IconFilterUp;
exports.IconFilterX = IconFilterX;
exports.IconFilters = IconFilters;
exports.IconFiltersFilled = IconFiltersFilled;
exports.IconFingerprint = IconFingerprint;
exports.IconFingerprintOff = IconFingerprintOff;
exports.IconFingerprintScan = IconFingerprintScan;
exports.IconFireExtinguisher = IconFireExtinguisher;
exports.IconFireHydrant = IconFireHydrant;
exports.IconFireHydrantOff = IconFireHydrantOff;
exports.IconFiretruck = IconFiretruck;
exports.IconFirstAidKit = IconFirstAidKit;
exports.IconFirstAidKitOff = IconFirstAidKitOff;
exports.IconFish = IconFish;
exports.IconFishBone = IconFishBone;
exports.IconFishBoneFilled = IconFishBoneFilled;
exports.IconFishChristianity = IconFishChristianity;
exports.IconFishHook = IconFishHook;
exports.IconFishHookOff = IconFishHookOff;
exports.IconFishOff = IconFishOff;
exports.IconFlag = IconFlag;
exports.IconFlag2 = IconFlag2;
exports.IconFlag2Filled = IconFlag2Filled;
exports.IconFlag2Off = IconFlag2Off;
exports.IconFlag3 = IconFlag3;
exports.IconFlag3Filled = IconFlag3Filled;
exports.IconFlagBitcoin = IconFlagBitcoin;
exports.IconFlagBolt = IconFlagBolt;
exports.IconFlagCancel = IconFlagCancel;
exports.IconFlagCheck = IconFlagCheck;
exports.IconFlagCode = IconFlagCode;
exports.IconFlagCog = IconFlagCog;
exports.IconFlagDiscount = IconFlagDiscount;
exports.IconFlagDollar = IconFlagDollar;
exports.IconFlagDown = IconFlagDown;
exports.IconFlagExclamation = IconFlagExclamation;
exports.IconFlagFilled = IconFlagFilled;
exports.IconFlagHeart = IconFlagHeart;
exports.IconFlagMinus = IconFlagMinus;
exports.IconFlagOff = IconFlagOff;
exports.IconFlagPause = IconFlagPause;
exports.IconFlagPin = IconFlagPin;
exports.IconFlagPlus = IconFlagPlus;
exports.IconFlagQuestion = IconFlagQuestion;
exports.IconFlagSearch = IconFlagSearch;
exports.IconFlagShare = IconFlagShare;
exports.IconFlagSpark = IconFlagSpark;
exports.IconFlagStar = IconFlagStar;
exports.IconFlagUp = IconFlagUp;
exports.IconFlagX = IconFlagX;
exports.IconFlame = IconFlame;
exports.IconFlameFilled = IconFlameFilled;
exports.IconFlameOff = IconFlameOff;
exports.IconFlare = IconFlare;
exports.IconFlareFilled = IconFlareFilled;
exports.IconFlask = IconFlask;
exports.IconFlask2 = IconFlask2;
exports.IconFlask2Filled = IconFlask2Filled;
exports.IconFlask2Off = IconFlask2Off;
exports.IconFlaskFilled = IconFlaskFilled;
exports.IconFlaskOff = IconFlaskOff;
exports.IconFlipFlops = IconFlipFlops;
exports.IconFlipHorizontal = IconFlipHorizontal;
exports.IconFlipVertical = IconFlipVertical;
exports.IconFloatCenter = IconFloatCenter;
exports.IconFloatLeft = IconFloatLeft;
exports.IconFloatNone = IconFloatNone;
exports.IconFloatRight = IconFloatRight;
exports.IconFlower = IconFlower;
exports.IconFlowerFilled = IconFlowerFilled;
exports.IconFlowerOff = IconFlowerOff;
exports.IconFocus = IconFocus;
exports.IconFocus2 = IconFocus2;
exports.IconFocusAuto = IconFocusAuto;
exports.IconFocusCentered = IconFocusCentered;
exports.IconFold = IconFold;
exports.IconFoldDown = IconFoldDown;
exports.IconFoldUp = IconFoldUp;
exports.IconFolder = IconFolder;
exports.IconFolderBolt = IconFolderBolt;
exports.IconFolderCancel = IconFolderCancel;
exports.IconFolderCheck = IconFolderCheck;
exports.IconFolderCode = IconFolderCode;
exports.IconFolderCog = IconFolderCog;
exports.IconFolderDollar = IconFolderDollar;
exports.IconFolderDown = IconFolderDown;
exports.IconFolderExclamation = IconFolderExclamation;
exports.IconFolderFilled = IconFolderFilled;
exports.IconFolderHeart = IconFolderHeart;
exports.IconFolderMinus = IconFolderMinus;
exports.IconFolderOff = IconFolderOff;
exports.IconFolderOpen = IconFolderOpen;
exports.IconFolderPause = IconFolderPause;
exports.IconFolderPin = IconFolderPin;
exports.IconFolderPlus = IconFolderPlus;
exports.IconFolderQuestion = IconFolderQuestion;
exports.IconFolderRoot = IconFolderRoot;
exports.IconFolderSearch = IconFolderSearch;
exports.IconFolderShare = IconFolderShare;
exports.IconFolderStar = IconFolderStar;
exports.IconFolderSymlink = IconFolderSymlink;
exports.IconFolderUp = IconFolderUp;
exports.IconFolderX = IconFolderX;
exports.IconFolders = IconFolders;
exports.IconFoldersFilled = IconFoldersFilled;
exports.IconFoldersOff = IconFoldersOff;
exports.IconForbid = IconForbid;
exports.IconForbid2 = IconForbid2;
exports.IconForbid2Filled = IconForbid2Filled;
exports.IconForbidFilled = IconForbidFilled;
exports.IconForklift = IconForklift;
exports.IconForms = IconForms;
exports.IconFountain = IconFountain;
exports.IconFountainFilled = IconFountainFilled;
exports.IconFountainOff = IconFountainOff;
exports.IconFrame = IconFrame;
exports.IconFrameOff = IconFrameOff;
exports.IconFreeRights = IconFreeRights;
exports.IconFreezeColumn = IconFreezeColumn;
exports.IconFreezeRow = IconFreezeRow;
exports.IconFreezeRowColumn = IconFreezeRowColumn;
exports.IconFridge = IconFridge;
exports.IconFridgeOff = IconFridgeOff;
exports.IconFriends = IconFriends;
exports.IconFriendsOff = IconFriendsOff;
exports.IconFrustum = IconFrustum;
exports.IconFrustumOff = IconFrustumOff;
exports.IconFrustumPlus = IconFrustumPlus;
exports.IconFunction = IconFunction;
exports.IconFunctionFilled = IconFunctionFilled;
exports.IconFunctionOff = IconFunctionOff;
exports.IconGalaxy = IconGalaxy;
exports.IconGardenCart = IconGardenCart;
exports.IconGardenCartFilled = IconGardenCartFilled;
exports.IconGardenCartOff = IconGardenCartOff;
exports.IconGasStation = IconGasStation;
exports.IconGasStationFilled = IconGasStationFilled;
exports.IconGasStationOff = IconGasStationOff;
exports.IconGauge = IconGauge;
exports.IconGaugeFilled = IconGaugeFilled;
exports.IconGaugeOff = IconGaugeOff;
exports.IconGavel = IconGavel;
exports.IconGenderAgender = IconGenderAgender;
exports.IconGenderAndrogyne = IconGenderAndrogyne;
exports.IconGenderBigender = IconGenderBigender;
exports.IconGenderDemiboy = IconGenderDemiboy;
exports.IconGenderDemigirl = IconGenderDemigirl;
exports.IconGenderEpicene = IconGenderEpicene;
exports.IconGenderFemale = IconGenderFemale;
exports.IconGenderFemme = IconGenderFemme;
exports.IconGenderGenderfluid = IconGenderGenderfluid;
exports.IconGenderGenderless = IconGenderGenderless;
exports.IconGenderGenderqueer = IconGenderGenderqueer;
exports.IconGenderHermaphrodite = IconGenderHermaphrodite;
exports.IconGenderIntergender = IconGenderIntergender;
exports.IconGenderMale = IconGenderMale;
exports.IconGenderNeutrois = IconGenderNeutrois;
exports.IconGenderThird = IconGenderThird;
exports.IconGenderTransgender = IconGenderTransgender;
exports.IconGenderTrasvesti = IconGenderTrasvesti;
exports.IconGeometry = IconGeometry;
exports.IconGhost = IconGhost;
exports.IconGhost2 = IconGhost2;
exports.IconGhost2Filled = IconGhost2Filled;
exports.IconGhost3 = IconGhost3;
exports.IconGhost3Filled = IconGhost3Filled;
exports.IconGhostFilled = IconGhostFilled;
exports.IconGhostOff = IconGhostOff;
exports.IconGif = IconGif;
exports.IconGift = IconGift;
exports.IconGiftCard = IconGiftCard;
exports.IconGiftCardFilled = IconGiftCardFilled;
exports.IconGiftFilled = IconGiftFilled;
exports.IconGiftOff = IconGiftOff;
exports.IconGitBranch = IconGitBranch;
exports.IconGitBranchDeleted = IconGitBranchDeleted;
exports.IconGitCherryPick = IconGitCherryPick;
exports.IconGitCommit = IconGitCommit;
exports.IconGitCompare = IconGitCompare;
exports.IconGitFork = IconGitFork;
exports.IconGitMerge = IconGitMerge;
exports.IconGitPullRequest = IconGitPullRequest;
exports.IconGitPullRequestClosed = IconGitPullRequestClosed;
exports.IconGitPullRequestDraft = IconGitPullRequestDraft;
exports.IconGizmo = IconGizmo;
exports.IconGlass = IconGlass;
exports.IconGlassChampagne = IconGlassChampagne;
exports.IconGlassCocktail = IconGlassCocktail;
exports.IconGlassFilled = IconGlassFilled;
exports.IconGlassFull = IconGlassFull;
exports.IconGlassFullFilled = IconGlassFullFilled;
exports.IconGlassGin = IconGlassGin;
exports.IconGlassOff = IconGlassOff;
exports.IconGlobe = IconGlobe;
exports.IconGlobeFilled = IconGlobeFilled;
exports.IconGlobeOff = IconGlobeOff;
exports.IconGoGame = IconGoGame;
exports.IconGolf = IconGolf;
exports.IconGolfFilled = IconGolfFilled;
exports.IconGolfOff = IconGolfOff;
exports.IconGps = IconGps;
exports.IconGpsFilled = IconGpsFilled;
exports.IconGradienter = IconGradienter;
exports.IconGrain = IconGrain;
exports.IconGraph = IconGraph;
exports.IconGraphFilled = IconGraphFilled;
exports.IconGraphOff = IconGraphOff;
exports.IconGrave = IconGrave;
exports.IconGrave2 = IconGrave2;
exports.IconGrid3x3 = IconGrid3x3;
exports.IconGrid4x4 = IconGrid4x4;
exports.IconGridDots = IconGridDots;
exports.IconGridGoldenratio = IconGridGoldenratio;
exports.IconGridPattern = IconGridPattern;
exports.IconGridPatternFilled = IconGridPatternFilled;
exports.IconGridScan = IconGridScan;
exports.IconGrill = IconGrill;
exports.IconGrillFork = IconGrillFork;
exports.IconGrillOff = IconGrillOff;
exports.IconGrillSpatula = IconGrillSpatula;
exports.IconGripHorizontal = IconGripHorizontal;
exports.IconGripVertical = IconGripVertical;
exports.IconGrowth = IconGrowth;
exports.IconGuitarPick = IconGuitarPick;
exports.IconGuitarPickFilled = IconGuitarPickFilled;
exports.IconGymnastics = IconGymnastics;
exports.IconH1 = IconH1;
exports.IconH2 = IconH2;
exports.IconH3 = IconH3;
exports.IconH4 = IconH4;
exports.IconH5 = IconH5;
exports.IconH6 = IconH6;
exports.IconHammer = IconHammer;
exports.IconHammerOff = IconHammerOff;
exports.IconHandClick = IconHandClick;
exports.IconHandClickOff = IconHandClickOff;
exports.IconHandFinger = IconHandFinger;
exports.IconHandFingerDown = IconHandFingerDown;
exports.IconHandFingerLeft = IconHandFingerLeft;
exports.IconHandFingerOff = IconHandFingerOff;
exports.IconHandFingerRight = IconHandFingerRight;
exports.IconHandGrab = IconHandGrab;
exports.IconHandLittleFinger = IconHandLittleFinger;
exports.IconHandLoveYou = IconHandLoveYou;
exports.IconHandMiddleFinger = IconHandMiddleFinger;
exports.IconHandMove = IconHandMove;
exports.IconHandOff = IconHandOff;
exports.IconHandRingFinger = IconHandRingFinger;
exports.IconHandRock = IconHandLoveYou;
exports.IconHandSanitizer = IconHandSanitizer;
exports.IconHandStop = IconHandStop;
exports.IconHandThreeFingers = IconHandThreeFingers;
exports.IconHandTwoFingers = IconHandTwoFingers;
exports.IconHanger = IconHanger;
exports.IconHanger2 = IconHanger2;
exports.IconHanger2Filled = IconHanger2Filled;
exports.IconHangerOff = IconHangerOff;
exports.IconHash = IconHash;
exports.IconHaze = IconHaze;
exports.IconHazeMoon = IconHazeMoon;
exports.IconHdr = IconHdr;
exports.IconHeading = IconHeading;
exports.IconHeadingOff = IconHeadingOff;
exports.IconHeadphones = IconHeadphones;
exports.IconHeadphonesFilled = IconHeadphonesFilled;
exports.IconHeadphonesOff = IconHeadphonesOff;
exports.IconHeadset = IconHeadset;
exports.IconHeadsetOff = IconHeadsetOff;
exports.IconHealthRecognition = IconHealthRecognition;
exports.IconHeart = IconHeart;
exports.IconHeartBitcoin = IconHeartBitcoin;
exports.IconHeartBolt = IconHeartBolt;
exports.IconHeartBroken = IconHeartBroken;
exports.IconHeartCancel = IconHeartCancel;
exports.IconHeartCheck = IconHeartCheck;
exports.IconHeartCode = IconHeartCode;
exports.IconHeartCog = IconHeartCog;
exports.IconHeartDiscount = IconHeartDiscount;
exports.IconHeartDollar = IconHeartDollar;
exports.IconHeartDown = IconHeartDown;
exports.IconHeartExclamation = IconHeartExclamation;
exports.IconHeartFilled = IconHeartFilled;
exports.IconHeartHandshake = IconHeartHandshake;
exports.IconHeartMinus = IconHeartMinus;
exports.IconHeartOff = IconHeartOff;
exports.IconHeartPause = IconHeartPause;
exports.IconHeartPin = IconHeartPin;
exports.IconHeartPlus = IconHeartPlus;
exports.IconHeartQuestion = IconHeartQuestion;
exports.IconHeartRateMonitor = IconHeartRateMonitor;
exports.IconHeartSearch = IconHeartSearch;
exports.IconHeartShare = IconHeartShare;
exports.IconHeartSpark = IconHeartSpark;
exports.IconHeartStar = IconHeartStar;
exports.IconHeartUp = IconHeartUp;
exports.IconHeartX = IconHeartX;
exports.IconHeartbeat = IconHeartbeat;
exports.IconHearts = IconHearts;
exports.IconHeartsOff = IconHeartsOff;
exports.IconHelicopter = IconHelicopter;
exports.IconHelicopterFilled = IconHelicopterFilled;
exports.IconHelicopterLanding = IconHelicopterLanding;
exports.IconHelicopterLandingFilled = IconHelicopterLandingFilled;
exports.IconHelmet = IconHelmet;
exports.IconHelmetOff = IconHelmetOff;
exports.IconHelp = IconHelp;
exports.IconHelpCircle = IconHelpCircle;
exports.IconHelpCircleFilled = IconHelpCircleFilled;
exports.IconHelpHexagon = IconHelpHexagon;
exports.IconHelpHexagonFilled = IconHelpHexagonFilled;
exports.IconHelpOctagon = IconHelpOctagon;
exports.IconHelpOctagonFilled = IconHelpOctagonFilled;
exports.IconHelpOff = IconHelpOff;
exports.IconHelpSmall = IconHelpSmall;
exports.IconHelpSquare = IconHelpSquare;
exports.IconHelpSquareFilled = IconHelpSquareFilled;
exports.IconHelpSquareRounded = IconHelpSquareRounded;
exports.IconHelpSquareRoundedFilled = IconHelpSquareRoundedFilled;
exports.IconHelpTriangle = IconHelpTriangle;
exports.IconHelpTriangleFilled = IconHelpTriangleFilled;
exports.IconHemisphere = IconHemisphere;
exports.IconHemisphereOff = IconHemisphereOff;
exports.IconHemispherePlus = IconHemispherePlus;
exports.IconHexagon = IconHexagon;
exports.IconHexagon0 = IconHexagonNumber0;
exports.IconHexagon1 = IconHexagonNumber1;
exports.IconHexagon2 = IconHexagonNumber2;
exports.IconHexagon3 = IconHexagonNumber3;
exports.IconHexagon3d = IconHexagon3d;
exports.IconHexagon4 = IconHexagonNumber4;
exports.IconHexagon5 = IconHexagonNumber5;
exports.IconHexagon6 = IconHexagonNumber6;
exports.IconHexagon7 = IconHexagonNumber7;
exports.IconHexagon8 = IconHexagonNumber8;
exports.IconHexagon9 = IconHexagonNumber9;
exports.IconHexagonFilled = IconHexagonFilled;
exports.IconHexagonLetterA = IconHexagonLetterA;
exports.IconHexagonLetterAFilled = IconHexagonLetterAFilled;
exports.IconHexagonLetterB = IconHexagonLetterB;
exports.IconHexagonLetterBFilled = IconHexagonLetterBFilled;
exports.IconHexagonLetterC = IconHexagonLetterC;
exports.IconHexagonLetterCFilled = IconHexagonLetterCFilled;
exports.IconHexagonLetterD = IconHexagonLetterD;
exports.IconHexagonLetterDFilled = IconHexagonLetterDFilled;
exports.IconHexagonLetterE = IconHexagonLetterE;
exports.IconHexagonLetterEFilled = IconHexagonLetterEFilled;
exports.IconHexagonLetterF = IconHexagonLetterF;
exports.IconHexagonLetterFFilled = IconHexagonLetterFFilled;
exports.IconHexagonLetterG = IconHexagonLetterG;
exports.IconHexagonLetterGFilled = IconHexagonLetterGFilled;
exports.IconHexagonLetterH = IconHexagonLetterH;
exports.IconHexagonLetterHFilled = IconHexagonLetterHFilled;
exports.IconHexagonLetterI = IconHexagonLetterI;
exports.IconHexagonLetterIFilled = IconHexagonLetterIFilled;
exports.IconHexagonLetterJ = IconHexagonLetterJ;
exports.IconHexagonLetterJFilled = IconHexagonLetterJFilled;
exports.IconHexagonLetterK = IconHexagonLetterK;
exports.IconHexagonLetterKFilled = IconHexagonLetterKFilled;
exports.IconHexagonLetterL = IconHexagonLetterL;
exports.IconHexagonLetterLFilled = IconHexagonLetterLFilled;
exports.IconHexagonLetterM = IconHexagonLetterM;
exports.IconHexagonLetterMFilled = IconHexagonLetterMFilled;
exports.IconHexagonLetterN = IconHexagonLetterN;
exports.IconHexagonLetterNFilled = IconHexagonLetterNFilled;
exports.IconHexagonLetterO = IconHexagonLetterO;
exports.IconHexagonLetterOFilled = IconHexagonLetterOFilled;
exports.IconHexagonLetterP = IconHexagonLetterP;
exports.IconHexagonLetterPFilled = IconHexagonLetterPFilled;
exports.IconHexagonLetterQ = IconHexagonLetterQ;
exports.IconHexagonLetterQFilled = IconHexagonLetterQFilled;
exports.IconHexagonLetterR = IconHexagonLetterR;
exports.IconHexagonLetterRFilled = IconHexagonLetterRFilled;
exports.IconHexagonLetterS = IconHexagonLetterS;
exports.IconHexagonLetterSFilled = IconHexagonLetterSFilled;
exports.IconHexagonLetterT = IconHexagonLetterT;
exports.IconHexagonLetterTFilled = IconHexagonLetterTFilled;
exports.IconHexagonLetterU = IconHexagonLetterU;
exports.IconHexagonLetterUFilled = IconHexagonLetterUFilled;
exports.IconHexagonLetterV = IconHexagonLetterV;
exports.IconHexagonLetterVFilled = IconHexagonLetterVFilled;
exports.IconHexagonLetterW = IconHexagonLetterW;
exports.IconHexagonLetterWFilled = IconHexagonLetterWFilled;
exports.IconHexagonLetterX = IconHexagonLetterX;
exports.IconHexagonLetterXFilled = IconHexagonLetterXFilled;
exports.IconHexagonLetterY = IconHexagonLetterY;
exports.IconHexagonLetterYFilled = IconHexagonLetterYFilled;
exports.IconHexagonLetterZ = IconHexagonLetterZ;
exports.IconHexagonLetterZFilled = IconHexagonLetterZFilled;
exports.IconHexagonMinus = IconHexagonMinus;
exports.IconHexagonMinus2 = IconHexagonMinus2;
exports.IconHexagonMinusFilled = IconHexagonMinusFilled;
exports.IconHexagonNumber0 = IconHexagonNumber0;
exports.IconHexagonNumber0Filled = IconHexagonNumber0Filled;
exports.IconHexagonNumber1 = IconHexagonNumber1;
exports.IconHexagonNumber1Filled = IconHexagonNumber1Filled;
exports.IconHexagonNumber2 = IconHexagonNumber2;
exports.IconHexagonNumber2Filled = IconHexagonNumber2Filled;
exports.IconHexagonNumber3 = IconHexagonNumber3;
exports.IconHexagonNumber3Filled = IconHexagonNumber3Filled;
exports.IconHexagonNumber4 = IconHexagonNumber4;
exports.IconHexagonNumber4Filled = IconHexagonNumber4Filled;
exports.IconHexagonNumber5 = IconHexagonNumber5;
exports.IconHexagonNumber5Filled = IconHexagonNumber5Filled;
exports.IconHexagonNumber6 = IconHexagonNumber6;
exports.IconHexagonNumber6Filled = IconHexagonNumber6Filled;
exports.IconHexagonNumber7 = IconHexagonNumber7;
exports.IconHexagonNumber7Filled = IconHexagonNumber7Filled;
exports.IconHexagonNumber8 = IconHexagonNumber8;
exports.IconHexagonNumber8Filled = IconHexagonNumber8Filled;
exports.IconHexagonNumber9 = IconHexagonNumber9;
exports.IconHexagonNumber9Filled = IconHexagonNumber9Filled;
exports.IconHexagonOff = IconHexagonOff;
exports.IconHexagonPlus = IconHexagonPlus;
exports.IconHexagonPlus2 = IconHexagonPlus2;
exports.IconHexagonPlusFilled = IconHexagonPlusFilled;
exports.IconHexagonalPrism = IconHexagonalPrism;
exports.IconHexagonalPrismOff = IconHexagonalPrismOff;
exports.IconHexagonalPrismPlus = IconHexagonalPrismPlus;
exports.IconHexagonalPyramid = IconHexagonalPyramid;
exports.IconHexagonalPyramidOff = IconHexagonalPyramidOff;
exports.IconHexagonalPyramidPlus = IconHexagonalPyramidPlus;
exports.IconHexagons = IconHexagons;
exports.IconHexagonsOff = IconHexagonsOff;
exports.IconHierarchy = IconHierarchy;
exports.IconHierarchy2 = IconHierarchy2;
exports.IconHierarchy3 = IconHierarchy3;
exports.IconHierarchyOff = IconHierarchyOff;
exports.IconHighlight = IconHighlight;
exports.IconHighlightOff = IconHighlightOff;
exports.IconHistory = IconHistory;
exports.IconHistoryOff = IconHistoryOff;
exports.IconHistoryToggle = IconHistoryToggle;
exports.IconHome = IconHome;
exports.IconHome2 = IconHome2;
exports.IconHomeBitcoin = IconHomeBitcoin;
exports.IconHomeBolt = IconHomeBolt;
exports.IconHomeCancel = IconHomeCancel;
exports.IconHomeCheck = IconHomeCheck;
exports.IconHomeCog = IconHomeCog;
exports.IconHomeDollar = IconHomeDollar;
exports.IconHomeDot = IconHomeDot;
exports.IconHomeDown = IconHomeDown;
exports.IconHomeEco = IconHomeEco;
exports.IconHomeEdit = IconHomeEdit;
exports.IconHomeExclamation = IconHomeExclamation;
exports.IconHomeFilled = IconHomeFilled;
exports.IconHomeHand = IconHomeHand;
exports.IconHomeHeart = IconHomeHeart;
exports.IconHomeInfinity = IconHomeInfinity;
exports.IconHomeLink = IconHomeLink;
exports.IconHomeMinus = IconHomeMinus;
exports.IconHomeMove = IconHomeMove;
exports.IconHomeOff = IconHomeOff;
exports.IconHomePlus = IconHomePlus;
exports.IconHomeQuestion = IconHomeQuestion;
exports.IconHomeRibbon = IconHomeRibbon;
exports.IconHomeSearch = IconHomeSearch;
exports.IconHomeShare = IconHomeShare;
exports.IconHomeShield = IconHomeShield;
exports.IconHomeSignal = IconHomeSignal;
exports.IconHomeSpark = IconHomeSpark;
exports.IconHomeStar = IconHomeStar;
exports.IconHomeStats = IconHomeStats;
exports.IconHomeUp = IconHomeUp;
exports.IconHomeX = IconHomeX;
exports.IconHorse = IconHorse;
exports.IconHorseToy = IconHorseToy;
exports.IconHorseshoe = IconHorseshoe;
exports.IconHospital = IconHospital;
exports.IconHospitalCircle = IconHospitalCircle;
exports.IconHospitalCircleFilled = IconHospitalCircleFilled;
exports.IconHotelService = IconHotelService;
exports.IconHourglass = IconHourglass;
exports.IconHourglassEmpty = IconHourglassEmpty;
exports.IconHourglassFilled = IconHourglassFilled;
exports.IconHourglassHigh = IconHourglassHigh;
exports.IconHourglassLow = IconHourglassLow;
exports.IconHourglassOff = IconHourglassOff;
exports.IconHours12 = IconHours12;
exports.IconHours24 = IconHours24;
exports.IconHtml = IconHtml;
exports.IconHttpConnect = IconHttpConnect;
exports.IconHttpConnectOff = IconHttpConnectOff;
exports.IconHttpDelete = IconHttpDelete;
exports.IconHttpDeleteOff = IconHttpDeleteOff;
exports.IconHttpGet = IconHttpGet;
exports.IconHttpGetOff = IconHttpGetOff;
exports.IconHttpHead = IconHttpHead;
exports.IconHttpHeadOff = IconHttpHeadOff;
exports.IconHttpOptions = IconHttpOptions;
exports.IconHttpOptionsOff = IconHttpOptionsOff;
exports.IconHttpPatch = IconHttpPatch;
exports.IconHttpPatchOff = IconHttpPatchOff;
exports.IconHttpPost = IconHttpPost;
exports.IconHttpPostOff = IconHttpPostOff;
exports.IconHttpPut = IconHttpPut;
exports.IconHttpPutOff = IconHttpPutOff;
exports.IconHttpQue = IconHttpQue;
exports.IconHttpQueOff = IconHttpQueOff;
exports.IconHttpTrace = IconHttpTrace;
exports.IconHttpTraceOff = IconHttpTraceOff;
exports.IconIceCream = IconIceCream;
exports.IconIceCream2 = IconIceCream2;
exports.IconIceCreamOff = IconIceCreamOff;
exports.IconIceSkating = IconIceSkating;
exports.IconIcons = IconIcons;
exports.IconIconsFilled = IconIconsFilled;
exports.IconIconsOff = IconIconsOff;
exports.IconId = IconId;
exports.IconIdBadge = IconIdBadge;
exports.IconIdBadge2 = IconIdBadge2;
exports.IconIdBadgeOff = IconIdBadgeOff;
exports.IconIdOff = IconIdOff;
exports.IconIkosaedr = IconIkosaedr;
exports.IconImageInPicture = IconImageInPicture;
exports.IconInbox = IconInbox;
exports.IconInboxOff = IconInboxOff;
exports.IconIndentDecrease = IconIndentDecrease;
exports.IconIndentIncrease = IconIndentIncrease;
exports.IconInfinity = IconInfinity;
exports.IconInfinityOff = IconInfinityOff;
exports.IconInfoCircle = IconInfoCircle;
exports.IconInfoCircleFilled = IconInfoCircleFilled;
exports.IconInfoHexagon = IconInfoHexagon;
exports.IconInfoHexagonFilled = IconInfoHexagonFilled;
exports.IconInfoOctagon = IconInfoOctagon;
exports.IconInfoOctagonFilled = IconInfoOctagonFilled;
exports.IconInfoSmall = IconInfoSmall;
exports.IconInfoSquare = IconInfoSquare;
exports.IconInfoSquareFilled = IconInfoSquareFilled;
exports.IconInfoSquareRounded = IconInfoSquareRounded;
exports.IconInfoSquareRoundedFilled = IconInfoSquareRoundedFilled;
exports.IconInfoTriangle = IconInfoTriangle;
exports.IconInfoTriangleFilled = IconInfoTriangleFilled;
exports.IconInnerShadowBottom = IconInnerShadowBottom;
exports.IconInnerShadowBottomFilled = IconInnerShadowBottomFilled;
exports.IconInnerShadowBottomLeft = IconInnerShadowBottomLeft;
exports.IconInnerShadowBottomLeftFilled = IconInnerShadowBottomLeftFilled;
exports.IconInnerShadowBottomRight = IconInnerShadowBottomRight;
exports.IconInnerShadowBottomRightFilled = IconInnerShadowBottomRightFilled;
exports.IconInnerShadowLeft = IconInnerShadowLeft;
exports.IconInnerShadowLeftFilled = IconInnerShadowLeftFilled;
exports.IconInnerShadowRight = IconInnerShadowRight;
exports.IconInnerShadowRightFilled = IconInnerShadowRightFilled;
exports.IconInnerShadowTop = IconInnerShadowTop;
exports.IconInnerShadowTopFilled = IconInnerShadowTopFilled;
exports.IconInnerShadowTopLeft = IconInnerShadowTopLeft;
exports.IconInnerShadowTopLeftFilled = IconInnerShadowTopLeftFilled;
exports.IconInnerShadowTopRight = IconInnerShadowTopRight;
exports.IconInnerShadowTopRightFilled = IconInnerShadowTopRightFilled;
exports.IconInputAi = IconInputAi;
exports.IconInputCheck = IconInputCheck;
exports.IconInputSearch = IconInputSearch;
exports.IconInputSpark = IconInputSpark;
exports.IconInputX = IconInputX;
exports.IconInvoice = IconInvoice;
exports.IconIroning = IconIroning;
exports.IconIroning1 = IconIroning1;
exports.IconIroning1Filled = IconIroning1Filled;
exports.IconIroning2 = IconIroning2;
exports.IconIroning2Filled = IconIroning2Filled;
exports.IconIroning3 = IconIroning3;
exports.IconIroning3Filled = IconIroning3Filled;
exports.IconIroningFilled = IconIroningFilled;
exports.IconIroningOff = IconIroningOff;
exports.IconIroningSteam = IconIroningSteam;
exports.IconIroningSteamFilled = IconIroningSteamFilled;
exports.IconIroningSteamOff = IconIroningSteamOff;
exports.IconIrregularPolyhedron = IconIrregularPolyhedron;
exports.IconIrregularPolyhedronOff = IconIrregularPolyhedronOff;
exports.IconIrregularPolyhedronPlus = IconIrregularPolyhedronPlus;
exports.IconItalic = IconItalic;
exports.IconJacket = IconJacket;
exports.IconJetpack = IconJetpack;
exports.IconJetpackFilled = IconJetpackFilled;
exports.IconJewishStar = IconJewishStar;
exports.IconJewishStarFilled = IconJewishStarFilled;
exports.IconJoinBevel = IconJoinBevel;
exports.IconJoinRound = IconJoinRound;
exports.IconJoinStraight = IconJoinStraight;
exports.IconJoker = IconJoker;
exports.IconJpg = IconJpg;
exports.IconJson = IconJson;
exports.IconJumpRope = IconJumpRope;
exports.IconKarate = IconKarate;
exports.IconKayak = IconKayak;
exports.IconKering = IconKerning;
exports.IconKerning = IconKerning;
exports.IconKey = IconKey;
exports.IconKeyFilled = IconKeyFilled;
exports.IconKeyOff = IconKeyOff;
exports.IconKeyboard = IconKeyboard;
exports.IconKeyboardFilled = IconKeyboardFilled;
exports.IconKeyboardHide = IconKeyboardHide;
exports.IconKeyboardOff = IconKeyboardOff;
exports.IconKeyboardShow = IconKeyboardShow;
exports.IconKeyframe = IconKeyframe;
exports.IconKeyframeAlignCenter = IconKeyframeAlignCenter;
exports.IconKeyframeAlignCenterFilled = IconKeyframeAlignCenterFilled;
exports.IconKeyframeAlignHorizontal = IconKeyframeAlignHorizontal;
exports.IconKeyframeAlignHorizontalFilled = IconKeyframeAlignHorizontalFilled;
exports.IconKeyframeAlignVertical = IconKeyframeAlignVertical;
exports.IconKeyframeAlignVerticalFilled = IconKeyframeAlignVerticalFilled;
exports.IconKeyframeFilled = IconKeyframeFilled;
exports.IconKeyframes = IconKeyframes;
exports.IconKeyframesFilled = IconKeyframesFilled;
exports.IconLabel = IconLabel;
exports.IconLabelFilled = IconLabelFilled;
exports.IconLabelImportant = IconLabelImportant;
exports.IconLabelImportantFilled = IconLabelImportantFilled;
exports.IconLabelOff = IconLabelOff;
exports.IconLadder = IconLadder;
exports.IconLadderOff = IconLadderOff;
exports.IconLadle = IconLadle;
exports.IconLambda = IconLambda;
exports.IconLamp = IconLamp;
exports.IconLamp2 = IconLamp2;
exports.IconLampOff = IconLampOff;
exports.IconLane = IconLane;
exports.IconLanguage = IconLanguage;
exports.IconLanguageHiragana = IconLanguageHiragana;
exports.IconLanguageKatakana = IconLanguageKatakana;
exports.IconLanguageOff = IconLanguageOff;
exports.IconLasso = IconLasso;
exports.IconLassoOff = IconLassoOff;
exports.IconLassoPolygon = IconLassoPolygon;
exports.IconLassoPolygonFilled = IconLassoPolygonFilled;
exports.IconLaurelWreath = IconLaurelWreath;
exports.IconLaurelWreath1 = IconLaurelWreath1;
exports.IconLaurelWreath2 = IconLaurelWreath2;
exports.IconLaurelWreath3 = IconLaurelWreath3;
exports.IconLaurelWreathFilled = IconLaurelWreathFilled;
exports.IconLayersDifference = IconLayersDifference;
exports.IconLayersIntersect = IconLayersIntersect;
exports.IconLayersIntersect2 = IconLayersIntersect2;
exports.IconLayersLinked = IconLayersLinked;
exports.IconLayersOff = IconLayersOff;
exports.IconLayersSelected = IconLayersSelected;
exports.IconLayersSelectedBottom = IconLayersSelectedBottom;
exports.IconLayersSubtract = IconLayersSubtract;
exports.IconLayersUnion = IconLayersUnion;
exports.IconLayout = IconLayout;
exports.IconLayout2 = IconLayout2;
exports.IconLayout2Filled = IconLayout2Filled;
exports.IconLayoutAlignBottom = IconLayoutAlignBottom;
exports.IconLayoutAlignBottomFilled = IconLayoutAlignBottomFilled;
exports.IconLayoutAlignCenter = IconLayoutAlignCenter;
exports.IconLayoutAlignCenterFilled = IconLayoutAlignCenterFilled;
exports.IconLayoutAlignLeft = IconLayoutAlignLeft;
exports.IconLayoutAlignLeftFilled = IconLayoutAlignLeftFilled;
exports.IconLayoutAlignMiddle = IconLayoutAlignMiddle;
exports.IconLayoutAlignMiddleFilled = IconLayoutAlignMiddleFilled;
exports.IconLayoutAlignRight = IconLayoutAlignRight;
exports.IconLayoutAlignRightFilled = IconLayoutAlignRightFilled;
exports.IconLayoutAlignTop = IconLayoutAlignTop;
exports.IconLayoutAlignTopFilled = IconLayoutAlignTopFilled;
exports.IconLayoutBoard = IconLayoutBoard;
exports.IconLayoutBoardSplit = IconLayoutBoardSplit;
exports.IconLayoutBottombar = IconLayoutBottombar;
exports.IconLayoutBottombarCollapse = IconLayoutBottombarCollapse;
exports.IconLayoutBottombarCollapseFilled = IconLayoutBottombarCollapseFilled;
exports.IconLayoutBottombarExpand = IconLayoutBottombarExpand;
exports.IconLayoutBottombarExpandFilled = IconLayoutBottombarExpandFilled;
exports.IconLayoutBottombarFilled = IconLayoutBottombarFilled;
exports.IconLayoutBottombarInactive = IconLayoutBottombarInactive;
exports.IconLayoutCards = IconLayoutCards;
exports.IconLayoutCardsFilled = IconLayoutCardsFilled;
exports.IconLayoutCollage = IconLayoutCollage;
exports.IconLayoutColumns = IconLayoutColumns;
exports.IconLayoutDashboard = IconLayoutDashboard;
exports.IconLayoutDashboardFilled = IconLayoutDashboardFilled;
exports.IconLayoutDistributeHorizontal = IconLayoutDistributeHorizontal;
exports.IconLayoutDistributeHorizontalFilled = IconLayoutDistributeHorizontalFilled;
exports.IconLayoutDistributeVertical = IconLayoutDistributeVertical;
exports.IconLayoutDistributeVerticalFilled = IconLayoutDistributeVerticalFilled;
exports.IconLayoutFilled = IconLayoutFilled;
exports.IconLayoutGrid = IconLayoutGrid;
exports.IconLayoutGridAdd = IconLayoutGridAdd;
exports.IconLayoutGridFilled = IconLayoutGridFilled;
exports.IconLayoutGridRemove = IconLayoutGridRemove;
exports.IconLayoutKanban = IconLayoutKanban;
exports.IconLayoutKanbanFilled = IconLayoutKanbanFilled;
exports.IconLayoutList = IconLayoutList;
exports.IconLayoutListFilled = IconLayoutListFilled;
exports.IconLayoutNavbar = IconLayoutNavbar;
exports.IconLayoutNavbarCollapse = IconLayoutNavbarCollapse;
exports.IconLayoutNavbarCollapseFilled = IconLayoutNavbarCollapseFilled;
exports.IconLayoutNavbarExpand = IconLayoutNavbarExpand;
exports.IconLayoutNavbarExpandFilled = IconLayoutNavbarExpandFilled;
exports.IconLayoutNavbarFilled = IconLayoutNavbarFilled;
exports.IconLayoutNavbarInactive = IconLayoutNavbarInactive;
exports.IconLayoutOff = IconLayoutOff;
exports.IconLayoutRows = IconLayoutRows;
exports.IconLayoutSidebar = IconLayoutSidebar;
exports.IconLayoutSidebarFilled = IconLayoutSidebarFilled;
exports.IconLayoutSidebarInactive = IconLayoutSidebarInactive;
exports.IconLayoutSidebarLeftCollapse = IconLayoutSidebarLeftCollapse;
exports.IconLayoutSidebarLeftCollapseFilled = IconLayoutSidebarLeftCollapseFilled;
exports.IconLayoutSidebarLeftExpand = IconLayoutSidebarLeftExpand;
exports.IconLayoutSidebarLeftExpandFilled = IconLayoutSidebarLeftExpandFilled;
exports.IconLayoutSidebarRight = IconLayoutSidebarRight;
exports.IconLayoutSidebarRightCollapse = IconLayoutSidebarRightCollapse;
exports.IconLayoutSidebarRightCollapseFilled = IconLayoutSidebarRightCollapseFilled;
exports.IconLayoutSidebarRightExpand = IconLayoutSidebarRightExpand;
exports.IconLayoutSidebarRightExpandFilled = IconLayoutSidebarRightExpandFilled;
exports.IconLayoutSidebarRightFilled = IconLayoutSidebarRightFilled;
exports.IconLayoutSidebarRightInactive = IconLayoutSidebarRightInactive;
exports.IconLeaf = IconLeaf;
exports.IconLeaf2 = IconLeaf2;
exports.IconLeafOff = IconLeafOff;
exports.IconLego = IconLego;
exports.IconLegoFilled = IconLegoFilled;
exports.IconLegoOff = IconLegoOff;
exports.IconLemon = IconLemon;
exports.IconLemon2 = IconLemon2;
exports.IconLemon2Filled = IconLemon2Filled;
exports.IconLetterA = IconLetterA;
exports.IconLetterASmall = IconLetterASmall;
exports.IconLetterB = IconLetterB;
exports.IconLetterBSmall = IconLetterBSmall;
exports.IconLetterC = IconLetterC;
exports.IconLetterCSmall = IconLetterCSmall;
exports.IconLetterCase = IconLetterCase;
exports.IconLetterCaseLower = IconLetterCaseLower;
exports.IconLetterCaseToggle = IconLetterCaseToggle;
exports.IconLetterCaseUpper = IconLetterCaseUpper;
exports.IconLetterD = IconLetterD;
exports.IconLetterDSmall = IconLetterDSmall;
exports.IconLetterE = IconLetterE;
exports.IconLetterESmall = IconLetterESmall;
exports.IconLetterF = IconLetterF;
exports.IconLetterFSmall = IconLetterFSmall;
exports.IconLetterG = IconLetterG;
exports.IconLetterGSmall = IconLetterGSmall;
exports.IconLetterH = IconLetterH;
exports.IconLetterHSmall = IconLetterHSmall;
exports.IconLetterI = IconLetterI;
exports.IconLetterISmall = IconLetterISmall;
exports.IconLetterJ = IconLetterJ;
exports.IconLetterJSmall = IconLetterJSmall;
exports.IconLetterK = IconLetterK;
exports.IconLetterKSmall = IconLetterKSmall;
exports.IconLetterL = IconLetterL;
exports.IconLetterLSmall = IconLetterLSmall;
exports.IconLetterM = IconLetterM;
exports.IconLetterMSmall = IconLetterMSmall;
exports.IconLetterN = IconLetterN;
exports.IconLetterNSmall = IconLetterNSmall;
exports.IconLetterO = IconLetterO;
exports.IconLetterOSmall = IconLetterOSmall;
exports.IconLetterP = IconLetterP;
exports.IconLetterPSmall = IconLetterPSmall;
exports.IconLetterQ = IconLetterQ;
exports.IconLetterQSmall = IconLetterQSmall;
exports.IconLetterR = IconLetterR;
exports.IconLetterRSmall = IconLetterRSmall;
exports.IconLetterS = IconLetterS;
exports.IconLetterSSmall = IconLetterSSmall;
exports.IconLetterSpacing = IconLetterSpacing;
exports.IconLetterT = IconLetterT;
exports.IconLetterTSmall = IconLetterTSmall;
exports.IconLetterU = IconLetterU;
exports.IconLetterUSmall = IconLetterUSmall;
exports.IconLetterV = IconLetterV;
exports.IconLetterVSmall = IconLetterVSmall;
exports.IconLetterW = IconLetterW;
exports.IconLetterWSmall = IconLetterWSmall;
exports.IconLetterX = IconLetterX;
exports.IconLetterXSmall = IconLetterXSmall;
exports.IconLetterY = IconLetterY;
exports.IconLetterYSmall = IconLetterYSmall;
exports.IconLetterZ = IconLetterZ;
exports.IconLetterZSmall = IconLetterZSmall;
exports.IconLibrary = IconLibrary;
exports.IconLibraryMinus = IconLibraryMinus;
exports.IconLibraryPhoto = IconLibraryPhoto;
exports.IconLibraryPlus = IconLibraryPlus;
exports.IconLicense = IconLicense;
exports.IconLicenseOff = IconLicenseOff;
exports.IconLifebuoy = IconLifebuoy;
exports.IconLifebuoyFilled = IconLifebuoyFilled;
exports.IconLifebuoyOff = IconLifebuoyOff;
exports.IconLighter = IconLighter;
exports.IconLine = IconLine;
exports.IconLineDashed = IconLineDashed;
exports.IconLineDotted = IconLineDotted;
exports.IconLineHeight = IconLineHeight;
exports.IconLineScan = IconLineScan;
exports.IconLink = IconLink;
exports.IconLinkMinus = IconLinkMinus;
exports.IconLinkOff = IconLinkOff;
exports.IconLinkPlus = IconLinkPlus;
exports.IconList = IconList;
exports.IconListCheck = IconListCheck;
exports.IconListDetails = IconListDetails;
exports.IconListLetters = IconListLetters;
exports.IconListNumbers = IconListNumbers;
exports.IconListSearch = IconListSearch;
exports.IconListTree = IconListTree;
exports.IconLivePhoto = IconLivePhoto;
exports.IconLivePhotoFilled = IconLivePhotoFilled;
exports.IconLivePhotoOff = IconLivePhotoOff;
exports.IconLiveView = IconLiveView;
exports.IconLiveViewFilled = IconLiveViewFilled;
exports.IconLoadBalancer = IconLoadBalancer;
exports.IconLoader = IconLoader;
exports.IconLoader2 = IconLoader2;
exports.IconLoader3 = IconLoader3;
exports.IconLoaderQuarter = IconLoaderQuarter;
exports.IconLocation = IconLocation;
exports.IconLocationBolt = IconLocationBolt;
exports.IconLocationBroken = IconLocationBroken;
exports.IconLocationCancel = IconLocationCancel;
exports.IconLocationCheck = IconLocationCheck;
exports.IconLocationCode = IconLocationCode;
exports.IconLocationCog = IconLocationCog;
exports.IconLocationDiscount = IconLocationDiscount;
exports.IconLocationDollar = IconLocationDollar;
exports.IconLocationDown = IconLocationDown;
exports.IconLocationExclamation = IconLocationExclamation;
exports.IconLocationFilled = IconLocationFilled;
exports.IconLocationHeart = IconLocationHeart;
exports.IconLocationMinus = IconLocationMinus;
exports.IconLocationOff = IconLocationOff;
exports.IconLocationPause = IconLocationPause;
exports.IconLocationPin = IconLocationPin;
exports.IconLocationPlus = IconLocationPlus;
exports.IconLocationQuestion = IconLocationQuestion;
exports.IconLocationSearch = IconLocationSearch;
exports.IconLocationShare = IconLocationShare;
exports.IconLocationStar = IconLocationStar;
exports.IconLocationUp = IconLocationUp;
exports.IconLocationX = IconLocationX;
exports.IconLock = IconLock;
exports.IconLockAccess = IconLockAccess;
exports.IconLockAccessOff = IconLockAccessOff;
exports.IconLockBitcoin = IconLockBitcoin;
exports.IconLockBolt = IconLockBolt;
exports.IconLockCancel = IconLockCancel;
exports.IconLockCheck = IconLockCheck;
exports.IconLockCode = IconLockCode;
exports.IconLockCog = IconLockCog;
exports.IconLockDollar = IconLockDollar;
exports.IconLockDown = IconLockDown;
exports.IconLockExclamation = IconLockExclamation;
exports.IconLockFilled = IconLockFilled;
exports.IconLockHeart = IconLockHeart;
exports.IconLockMinus = IconLockMinus;
exports.IconLockOff = IconLockOff;
exports.IconLockOpen = IconLockOpen;
exports.IconLockOpen2 = IconLockOpen2;
exports.IconLockOpenOff = IconLockOpenOff;
exports.IconLockPassword = IconLockPassword;
exports.IconLockPause = IconLockPause;
exports.IconLockPin = IconLockPin;
exports.IconLockPlus = IconLockPlus;
exports.IconLockQuestion = IconLockQuestion;
exports.IconLockSearch = IconLockSearch;
exports.IconLockShare = IconLockShare;
exports.IconLockSquare = IconLockSquare;
exports.IconLockSquareRounded = IconLockSquareRounded;
exports.IconLockSquareRoundedFilled = IconLockSquareRoundedFilled;
exports.IconLockStar = IconLockStar;
exports.IconLockUp = IconLockUp;
exports.IconLockX = IconLockX;
exports.IconLogicAnd = IconLogicAnd;
exports.IconLogicBuffer = IconLogicBuffer;
exports.IconLogicNand = IconLogicNand;
exports.IconLogicNor = IconLogicNor;
exports.IconLogicNot = IconLogicNot;
exports.IconLogicOr = IconLogicOr;
exports.IconLogicXnor = IconLogicXnor;
exports.IconLogicXor = IconLogicXor;
exports.IconLogin = IconLogin;
exports.IconLogin2 = IconLogin2;
exports.IconLogout = IconLogout;
exports.IconLogout2 = IconLogout2;
exports.IconLogs = IconLogs;
exports.IconLollipop = IconLollipop;
exports.IconLollipopOff = IconLollipopOff;
exports.IconLuggage = IconLuggage;
exports.IconLuggageOff = IconLuggageOff;
exports.IconLungs = IconLungs;
exports.IconLungsFilled = IconLungsFilled;
exports.IconLungsOff = IconLungsOff;
exports.IconMacro = IconMacro;
exports.IconMacroFilled = IconMacroFilled;
exports.IconMacroOff = IconMacroOff;
exports.IconMagnet = IconMagnet;
exports.IconMagnetFilled = IconMagnetFilled;
exports.IconMagnetOff = IconMagnetOff;
exports.IconMagnetic = IconMagnetic;
exports.IconMail = IconMail;
exports.IconMailAi = IconMailAi;
exports.IconMailBitcoin = IconMailBitcoin;
exports.IconMailBolt = IconMailBolt;
exports.IconMailCancel = IconMailCancel;
exports.IconMailCheck = IconMailCheck;
exports.IconMailCode = IconMailCode;
exports.IconMailCog = IconMailCog;
exports.IconMailDollar = IconMailDollar;
exports.IconMailDown = IconMailDown;
exports.IconMailExclamation = IconMailExclamation;
exports.IconMailFast = IconMailFast;
exports.IconMailFilled = IconMailFilled;
exports.IconMailForward = IconMailForward;
exports.IconMailHeart = IconMailHeart;
exports.IconMailMinus = IconMailMinus;
exports.IconMailOff = IconMailOff;
exports.IconMailOpened = IconMailOpened;
exports.IconMailOpenedFilled = IconMailOpenedFilled;
exports.IconMailPause = IconMailPause;
exports.IconMailPin = IconMailPin;
exports.IconMailPlus = IconMailPlus;
exports.IconMailQuestion = IconMailQuestion;
exports.IconMailSearch = IconMailSearch;
exports.IconMailShare = IconMailShare;
exports.IconMailSpark = IconMailSpark;
exports.IconMailStar = IconMailStar;
exports.IconMailUp = IconMailUp;
exports.IconMailX = IconMailX;
exports.IconMailbox = IconMailbox;
exports.IconMailboxOff = IconMailboxOff;
exports.IconMan = IconMan;
exports.IconManFilled = IconManFilled;
exports.IconManualGearbox = IconManualGearbox;
exports.IconManualGearboxFilled = IconManualGearboxFilled;
exports.IconMap = IconMap;
exports.IconMap2 = IconMap2;
exports.IconMapBolt = IconMapBolt;
exports.IconMapCancel = IconMapCancel;
exports.IconMapCheck = IconMapCheck;
exports.IconMapCode = IconMapCode;
exports.IconMapCog = IconMapCog;
exports.IconMapDiscount = IconMapDiscount;
exports.IconMapDollar = IconMapDollar;
exports.IconMapDown = IconMapDown;
exports.IconMapEast = IconMapEast;
exports.IconMapExclamation = IconMapExclamation;
exports.IconMapHeart = IconMapHeart;
exports.IconMapMinus = IconMapMinus;
exports.IconMapNorth = IconMapNorth;
exports.IconMapOff = IconMapOff;
exports.IconMapPause = IconMapPause;
exports.IconMapPin = IconMapPin;
exports.IconMapPin2 = IconMapPin2;
exports.IconMapPinBolt = IconMapPinBolt;
exports.IconMapPinCancel = IconMapPinCancel;
exports.IconMapPinCheck = IconMapPinCheck;
exports.IconMapPinCode = IconMapPinCode;
exports.IconMapPinCog = IconMapPinCog;
exports.IconMapPinDollar = IconMapPinDollar;
exports.IconMapPinDown = IconMapPinDown;
exports.IconMapPinExclamation = IconMapPinExclamation;
exports.IconMapPinFilled = IconMapPinFilled;
exports.IconMapPinHeart = IconMapPinHeart;
exports.IconMapPinMinus = IconMapPinMinus;
exports.IconMapPinOff = IconMapPinOff;
exports.IconMapPinPause = IconMapPinPause;
exports.IconMapPinPin = IconMapPinPin;
exports.IconMapPinPlus = IconMapPinPlus;
exports.IconMapPinQuestion = IconMapPinQuestion;
exports.IconMapPinSearch = IconMapPinSearch;
exports.IconMapPinShare = IconMapPinShare;
exports.IconMapPinStar = IconMapPinStar;
exports.IconMapPinUp = IconMapPinUp;
exports.IconMapPinX = IconMapPinX;
exports.IconMapPins = IconMapPins;
exports.IconMapPlus = IconMapPlus;
exports.IconMapQuestion = IconMapQuestion;
exports.IconMapRoute = IconMapRoute;
exports.IconMapSearch = IconMapSearch;
exports.IconMapShare = IconMapShare;
exports.IconMapSouth = IconMapSouth;
exports.IconMapStar = IconMapStar;
exports.IconMapUp = IconMapUp;
exports.IconMapWest = IconMapWest;
exports.IconMapX = IconMapX;
exports.IconMarkdown = IconMarkdown;
exports.IconMarkdownOff = IconMarkdownOff;
exports.IconMarquee = IconMarquee;
exports.IconMarquee2 = IconMarquee2;
exports.IconMarqueeOff = IconMarqueeOff;
exports.IconMars = IconMars;
exports.IconMask = IconMask;
exports.IconMaskOff = IconMaskOff;
exports.IconMasksTheater = IconMasksTheater;
exports.IconMasksTheaterOff = IconMasksTheaterOff;
exports.IconMassage = IconMassage;
exports.IconMatchstick = IconMatchstick;
exports.IconMath = IconMath;
exports.IconMath1Divide2 = IconMath1Divide2;
exports.IconMath1Divide3 = IconMath1Divide3;
exports.IconMathAvg = IconMathAvg;
exports.IconMathCos = IconMathCos;
exports.IconMathCtg = IconMathCtg;
exports.IconMathEqualGreater = IconMathEqualGreater;
exports.IconMathEqualLower = IconMathEqualLower;
exports.IconMathFunction = IconMathFunction;
exports.IconMathFunctionOff = IconMathFunctionOff;
exports.IconMathFunctionY = IconMathFunctionY;
exports.IconMathGreater = IconMathGreater;
exports.IconMathIntegral = IconMathIntegral;
exports.IconMathIntegralX = IconMathIntegralX;
exports.IconMathIntegrals = IconMathIntegrals;
exports.IconMathLower = IconMathLower;
exports.IconMathMax = IconMathMax;
exports.IconMathMaxMin = IconMathMaxMin;
exports.IconMathMin = IconMathMin;
exports.IconMathNot = IconMathNot;
exports.IconMathOff = IconMathOff;
exports.IconMathPi = IconMathPi;
exports.IconMathPiDivide2 = IconMathPiDivide2;
exports.IconMathSec = IconMathSec;
exports.IconMathSin = IconMathSin;
exports.IconMathSymbols = IconMathSymbols;
exports.IconMathTg = IconMathTg;
exports.IconMathXDivide2 = IconMathXDivide2;
exports.IconMathXDivideY = IconMathXDivideY;
exports.IconMathXDivideY2 = IconMathXDivideY2;
exports.IconMathXFloorDivideY = IconMathXFloorDivideY;
exports.IconMathXMinusX = IconMathXMinusX;
exports.IconMathXMinusY = IconMathXMinusY;
exports.IconMathXPlusX = IconMathXPlusX;
exports.IconMathXPlusY = IconMathXPlusY;
exports.IconMathXy = IconMathXy;
exports.IconMathYMinusY = IconMathYMinusY;
exports.IconMathYPlusY = IconMathYPlusY;
exports.IconMatrix = IconMatrix;
exports.IconMaximize = IconMaximize;
exports.IconMaximizeOff = IconMaximizeOff;
exports.IconMeat = IconMeat;
exports.IconMeatOff = IconMeatOff;
exports.IconMedal = IconMedal;
exports.IconMedal2 = IconMedal2;
exports.IconMedicalCross = IconMedicalCross;
exports.IconMedicalCrossCircle = IconMedicalCrossCircle;
exports.IconMedicalCrossFilled = IconMedicalCrossFilled;
exports.IconMedicalCrossOff = IconMedicalCrossOff;
exports.IconMedicineSyrup = IconMedicineSyrup;
exports.IconMeeple = IconMeeple;
exports.IconMeepleFilled = IconMeepleFilled;
exports.IconMelon = IconMelon;
exports.IconMelonFilled = IconMelonFilled;
exports.IconMenorah = IconMenorah;
exports.IconMenu = IconMenu;
exports.IconMenu2 = IconMenu2;
exports.IconMenu3 = IconMenu3;
exports.IconMenu4 = IconMenu4;
exports.IconMenuDeep = IconMenuDeep;
exports.IconMenuOrder = IconMenuOrder;
exports.IconMessage = IconMessage;
exports.IconMessage2 = IconMessage2;
exports.IconMessage2Bolt = IconMessage2Bolt;
exports.IconMessage2Cancel = IconMessage2Cancel;
exports.IconMessage2Check = IconMessage2Check;
exports.IconMessage2Code = IconMessage2Code;
exports.IconMessage2Cog = IconMessage2Cog;
exports.IconMessage2Dollar = IconMessage2Dollar;
exports.IconMessage2Down = IconMessage2Down;
exports.IconMessage2Exclamation = IconMessage2Exclamation;
exports.IconMessage2Filled = IconMessage2Filled;
exports.IconMessage2Heart = IconMessage2Heart;
exports.IconMessage2Minus = IconMessage2Minus;
exports.IconMessage2Off = IconMessage2Off;
exports.IconMessage2Pause = IconMessage2Pause;
exports.IconMessage2Pin = IconMessage2Pin;
exports.IconMessage2Plus = IconMessage2Plus;
exports.IconMessage2Question = IconMessage2Question;
exports.IconMessage2Search = IconMessage2Search;
exports.IconMessage2Share = IconMessage2Share;
exports.IconMessage2Star = IconMessage2Star;
exports.IconMessage2Up = IconMessage2Up;
exports.IconMessage2X = IconMessage2X;
exports.IconMessageBolt = IconMessageBolt;
exports.IconMessageCancel = IconMessageCancel;
exports.IconMessageChatbot = IconMessageChatbot;
exports.IconMessageChatbotFilled = IconMessageChatbotFilled;
exports.IconMessageCheck = IconMessageCheck;
exports.IconMessageCircle = IconMessageCircle;
exports.IconMessageCircle2 = IconMessageCircle;
exports.IconMessageCircle2Filled = IconMessageCircleFilled;
exports.IconMessageCircleBolt = IconMessageCircleBolt;
exports.IconMessageCircleCancel = IconMessageCircleCancel;
exports.IconMessageCircleCheck = IconMessageCircleCheck;
exports.IconMessageCircleCode = IconMessageCircleCode;
exports.IconMessageCircleCog = IconMessageCircleCog;
exports.IconMessageCircleDollar = IconMessageCircleDollar;
exports.IconMessageCircleDown = IconMessageCircleDown;
exports.IconMessageCircleExclamation = IconMessageCircleExclamation;
exports.IconMessageCircleFilled = IconMessageCircleFilled;
exports.IconMessageCircleHeart = IconMessageCircleHeart;
exports.IconMessageCircleMinus = IconMessageCircleMinus;
exports.IconMessageCircleOff = IconMessageCircleOff;
exports.IconMessageCirclePause = IconMessageCirclePause;
exports.IconMessageCirclePin = IconMessageCirclePin;
exports.IconMessageCirclePlus = IconMessageCirclePlus;
exports.IconMessageCircleQuestion = IconMessageCircleQuestion;
exports.IconMessageCircleSearch = IconMessageCircleSearch;
exports.IconMessageCircleShare = IconMessageCircleShare;
exports.IconMessageCircleStar = IconMessageCircleStar;
exports.IconMessageCircleUp = IconMessageCircleUp;
exports.IconMessageCircleUser = IconMessageCircleUser;
exports.IconMessageCircleX = IconMessageCircleX;
exports.IconMessageCode = IconMessageCode;
exports.IconMessageCog = IconMessageCog;
exports.IconMessageDollar = IconMessageDollar;
exports.IconMessageDots = IconMessageDots;
exports.IconMessageDown = IconMessageDown;
exports.IconMessageExclamation = IconMessageExclamation;
exports.IconMessageFilled = IconMessageFilled;
exports.IconMessageForward = IconMessageForward;
exports.IconMessageHeart = IconMessageHeart;
exports.IconMessageLanguage = IconMessageLanguage;
exports.IconMessageMinus = IconMessageMinus;
exports.IconMessageOff = IconMessageOff;
exports.IconMessagePause = IconMessagePause;
exports.IconMessagePin = IconMessagePin;
exports.IconMessagePlus = IconMessagePlus;
exports.IconMessageQuestion = IconMessageQuestion;
exports.IconMessageReply = IconMessageReply;
exports.IconMessageReport = IconMessageReport;
exports.IconMessageReportFilled = IconMessageReportFilled;
exports.IconMessageSearch = IconMessageSearch;
exports.IconMessageShare = IconMessageShare;
exports.IconMessageStar = IconMessageStar;
exports.IconMessageUp = IconMessageUp;
exports.IconMessageUser = IconMessageUser;
exports.IconMessageX = IconMessageX;
exports.IconMessages = IconMessages;
exports.IconMessagesOff = IconMessagesOff;
exports.IconMeteor = IconMeteor;
exports.IconMeteorFilled = IconMeteorFilled;
exports.IconMeteorOff = IconMeteorOff;
exports.IconMeterCube = IconMeterCube;
exports.IconMeterSquare = IconMeterSquare;
exports.IconMetronome = IconMetronome;
exports.IconMichelinBibGourmand = IconMichelinBibGourmand;
exports.IconMichelinStar = IconMichelinStar;
exports.IconMichelinStarFilled = IconMichelinStarFilled;
exports.IconMichelinStarGreen = IconMichelinStarGreen;
exports.IconMickey = IconMickey;
exports.IconMickeyFilled = IconMickeyFilled;
exports.IconMicrophone = IconMicrophone;
exports.IconMicrophone2 = IconMicrophone2;
exports.IconMicrophone2Off = IconMicrophone2Off;
exports.IconMicrophoneFilled = IconMicrophoneFilled;
exports.IconMicrophoneOff = IconMicrophoneOff;
exports.IconMicroscope = IconMicroscope;
exports.IconMicroscopeOff = IconMicroscopeOff;
exports.IconMicrowave = IconMicrowave;
exports.IconMicrowaveFilled = IconMicrowaveFilled;
exports.IconMicrowaveOff = IconMicrowaveOff;
exports.IconMilitaryAward = IconMilitaryAward;
exports.IconMilitaryRank = IconMilitaryRank;
exports.IconMilitaryRankFilled = IconMilitaryRankFilled;
exports.IconMilk = IconMilk;
exports.IconMilkFilled = IconMilkFilled;
exports.IconMilkOff = IconMilkOff;
exports.IconMilkshake = IconMilkshake;
exports.IconMinimize = IconMinimize;
exports.IconMinus = IconMinus;
exports.IconMinusVertical = IconMinusVertical;
exports.IconMist = IconMist;
exports.IconMistOff = IconMistOff;
exports.IconMobiledata = IconMobiledata;
exports.IconMobiledataOff = IconMobiledataOff;
exports.IconMoneybag = IconMoneybag;
exports.IconMoneybagEdit = IconMoneybagEdit;
exports.IconMoneybagHeart = IconMoneybagHeart;
exports.IconMoneybagMinus = IconMoneybagMinus;
exports.IconMoneybagMove = IconMoneybagMove;
exports.IconMoneybagMoveBack = IconMoneybagMoveBack;
exports.IconMoneybagPlus = IconMoneybagPlus;
exports.IconMonkeybar = IconMonkeybar;
exports.IconMoodAngry = IconMoodAngry;
exports.IconMoodAngryFilled = IconMoodAngryFilled;
exports.IconMoodAnnoyed = IconMoodAnnoyed;
exports.IconMoodAnnoyed2 = IconMoodAnnoyed2;
exports.IconMoodBitcoin = IconMoodBitcoin;
exports.IconMoodBoy = IconMoodBoy;
exports.IconMoodCheck = IconMoodCheck;
exports.IconMoodCog = IconMoodCog;
exports.IconMoodConfuzed = IconMoodConfuzed;
exports.IconMoodConfuzedFilled = IconMoodConfuzedFilled;
exports.IconMoodCrazyHappy = IconMoodCrazyHappy;
exports.IconMoodCrazyHappyFilled = IconMoodCrazyHappyFilled;
exports.IconMoodCry = IconMoodCry;
exports.IconMoodDollar = IconMoodDollar;
exports.IconMoodEdit = IconMoodEdit;
exports.IconMoodEmpty = IconMoodEmpty;
exports.IconMoodEmptyFilled = IconMoodEmptyFilled;
exports.IconMoodHappy = IconMoodHappy;
exports.IconMoodHappyFilled = IconMoodHappyFilled;
exports.IconMoodHeart = IconMoodHeart;
exports.IconMoodKid = IconMoodKid;
exports.IconMoodKidFilled = IconMoodKidFilled;
exports.IconMoodLookDown = IconMoodLookDown;
exports.IconMoodLookLeft = IconMoodLookLeft;
exports.IconMoodLookRight = IconMoodLookRight;
exports.IconMoodLookUp = IconMoodLookUp;
exports.IconMoodMinus = IconMoodMinus;
exports.IconMoodNerd = IconMoodNerd;
exports.IconMoodNervous = IconMoodNervous;
exports.IconMoodNeutral = IconMoodNeutral;
exports.IconMoodNeutralFilled = IconMoodNeutralFilled;
exports.IconMoodOff = IconMoodOff;
exports.IconMoodPin = IconMoodPin;
exports.IconMoodPlus = IconMoodPlus;
exports.IconMoodPuzzled = IconMoodPuzzled;
exports.IconMoodSad = IconMoodSad;
exports.IconMoodSad2 = IconMoodSad2;
exports.IconMoodSadDizzy = IconMoodSadDizzy;
exports.IconMoodSadFilled = IconMoodSadFilled;
exports.IconMoodSadSquint = IconMoodSadSquint;
exports.IconMoodSearch = IconMoodSearch;
exports.IconMoodShare = IconMoodShare;
exports.IconMoodSick = IconMoodSick;
exports.IconMoodSilence = IconMoodSilence;
exports.IconMoodSing = IconMoodSing;
exports.IconMoodSmile = IconMoodSmile;
exports.IconMoodSmileBeam = IconMoodSmileBeam;
exports.IconMoodSmileDizzy = IconMoodSmileDizzy;
exports.IconMoodSmileFilled = IconMoodSmileFilled;
exports.IconMoodSpark = IconMoodSpark;
exports.IconMoodSuprised = IconMoodSurprised;
exports.IconMoodSurprised = IconMoodSurprised;
exports.IconMoodTongue = IconMoodTongue;
exports.IconMoodTongueWink = IconMoodTongueWink;
exports.IconMoodTongueWink2 = IconMoodTongueWink2;
exports.IconMoodUnamused = IconMoodUnamused;
exports.IconMoodUp = IconMoodUp;
exports.IconMoodWink = IconMoodWink;
exports.IconMoodWink2 = IconMoodWink2;
exports.IconMoodWrrr = IconMoodWrrr;
exports.IconMoodWrrrFilled = IconMoodWrrrFilled;
exports.IconMoodX = IconMoodX;
exports.IconMoodXd = IconMoodXd;
exports.IconMoon = IconMoon;
exports.IconMoon2 = IconMoon2;
exports.IconMoonFilled = IconMoonFilled;
exports.IconMoonOff = IconMoonOff;
exports.IconMoonStars = IconMoonStars;
exports.IconMoped = IconMoped;
exports.IconMotorbike = IconMotorbike;
exports.IconMotorbikeFilled = IconMotorbikeFilled;
exports.IconMountain = IconMountain;
exports.IconMountainFilled = IconMountainFilled;
exports.IconMountainOff = IconMountainOff;
exports.IconMouse = IconMouse;
exports.IconMouse2 = IconMouse2;
exports.IconMouseFilled = IconMouseFilled;
exports.IconMouseOff = IconMouseOff;
exports.IconMoustache = IconMoustache;
exports.IconMovie = IconMovie;
exports.IconMovieOff = IconMovieOff;
exports.IconMug = IconMug;
exports.IconMugFilled = IconMugFilled;
exports.IconMugOff = IconMugOff;
exports.IconMultiplier05x = IconMultiplier05x;
exports.IconMultiplier15x = IconMultiplier15x;
exports.IconMultiplier1x = IconMultiplier1x;
exports.IconMultiplier2x = IconMultiplier2x;
exports.IconMushroom = IconMushroom;
exports.IconMushroomFilled = IconMushroomFilled;
exports.IconMushroomOff = IconMushroomOff;
exports.IconMusic = IconMusic;
exports.IconMusicBolt = IconMusicBolt;
exports.IconMusicCancel = IconMusicCancel;
exports.IconMusicCheck = IconMusicCheck;
exports.IconMusicCode = IconMusicCode;
exports.IconMusicCog = IconMusicCog;
exports.IconMusicDiscount = IconMusicDiscount;
exports.IconMusicDollar = IconMusicDollar;
exports.IconMusicDown = IconMusicDown;
exports.IconMusicExclamation = IconMusicExclamation;
exports.IconMusicHeart = IconMusicHeart;
exports.IconMusicMinus = IconMusicMinus;
exports.IconMusicOff = IconMusicOff;
exports.IconMusicPause = IconMusicPause;
exports.IconMusicPin = IconMusicPin;
exports.IconMusicPlus = IconMusicPlus;
exports.IconMusicQuestion = IconMusicQuestion;
exports.IconMusicSearch = IconMusicSearch;
exports.IconMusicShare = IconMusicShare;
exports.IconMusicStar = IconMusicStar;
exports.IconMusicUp = IconMusicUp;
exports.IconMusicX = IconMusicX;
exports.IconNavigation = IconNavigation;
exports.IconNavigationBolt = IconNavigationBolt;
exports.IconNavigationCancel = IconNavigationCancel;
exports.IconNavigationCheck = IconNavigationCheck;
exports.IconNavigationCode = IconNavigationCode;
exports.IconNavigationCog = IconNavigationCog;
exports.IconNavigationDiscount = IconNavigationDiscount;
exports.IconNavigationDollar = IconNavigationDollar;
exports.IconNavigationDown = IconNavigationDown;
exports.IconNavigationEast = IconNavigationEast;
exports.IconNavigationExclamation = IconNavigationExclamation;
exports.IconNavigationFilled = IconNavigationFilled;
exports.IconNavigationHeart = IconNavigationHeart;
exports.IconNavigationMinus = IconNavigationMinus;
exports.IconNavigationNorth = IconNavigationNorth;
exports.IconNavigationOff = IconNavigationOff;
exports.IconNavigationPause = IconNavigationPause;
exports.IconNavigationPin = IconNavigationPin;
exports.IconNavigationPlus = IconNavigationPlus;
exports.IconNavigationQuestion = IconNavigationQuestion;
exports.IconNavigationSearch = IconNavigationSearch;
exports.IconNavigationShare = IconNavigationShare;
exports.IconNavigationSouth = IconNavigationSouth;
exports.IconNavigationStar = IconNavigationStar;
exports.IconNavigationTop = IconNavigationTop;
exports.IconNavigationUp = IconNavigationUp;
exports.IconNavigationWest = IconNavigationWest;
exports.IconNavigationX = IconNavigationX;
exports.IconNeedle = IconNeedle;
exports.IconNeedleThread = IconNeedleThread;
exports.IconNetwork = IconNetwork;
exports.IconNetworkOff = IconNetworkOff;
exports.IconNewSection = IconNewSection;
exports.IconNews = IconNews;
exports.IconNewsOff = IconNewsOff;
exports.IconNfc = IconNfc;
exports.IconNfcOff = IconNfcOff;
exports.IconNoCopyright = IconNoCopyright;
exports.IconNoCreativeCommons = IconNoCreativeCommons;
exports.IconNoDerivatives = IconNoDerivatives;
exports.IconNorthStar = IconNorthStar;
exports.IconNote = IconNote;
exports.IconNoteOff = IconNoteOff;
exports.IconNotebook = IconNotebook;
exports.IconNotebookOff = IconNotebookOff;
exports.IconNotes = IconNotes;
exports.IconNotesOff = IconNotesOff;
exports.IconNotification = IconNotification;
exports.IconNotificationOff = IconNotificationOff;
exports.IconNumber = IconNumber;
exports.IconNumber0 = IconNumber0;
exports.IconNumber0Small = IconNumber0Small;
exports.IconNumber1 = IconNumber1;
exports.IconNumber10 = IconNumber10;
exports.IconNumber100Small = IconNumber100Small;
exports.IconNumber10Small = IconNumber10Small;
exports.IconNumber11 = IconNumber11;
exports.IconNumber11Small = IconNumber11Small;
exports.IconNumber123 = IconNumber123;
exports.IconNumber12Small = IconNumber12Small;
exports.IconNumber13Small = IconNumber13Small;
exports.IconNumber14Small = IconNumber14Small;
exports.IconNumber15Small = IconNumber15Small;
exports.IconNumber16Small = IconNumber16Small;
exports.IconNumber17Small = IconNumber17Small;
exports.IconNumber18Small = IconNumber18Small;
exports.IconNumber19Small = IconNumber19Small;
exports.IconNumber1Small = IconNumber1Small;
exports.IconNumber2 = IconNumber2;
exports.IconNumber20Small = IconNumber20Small;
exports.IconNumber21Small = IconNumber21Small;
exports.IconNumber22Small = IconNumber22Small;
exports.IconNumber23Small = IconNumber23Small;
exports.IconNumber24Small = IconNumber24Small;
exports.IconNumber25Small = IconNumber25Small;
exports.IconNumber26Small = IconNumber26Small;
exports.IconNumber27Small = IconNumber27Small;
exports.IconNumber28Small = IconNumber28Small;
exports.IconNumber29Small = IconNumber29Small;
exports.IconNumber2Small = IconNumber2Small;
exports.IconNumber3 = IconNumber3;
exports.IconNumber30Small = IconNumber30Small;
exports.IconNumber31Small = IconNumber31Small;
exports.IconNumber32Small = IconNumber32Small;
exports.IconNumber33Small = IconNumber33Small;
exports.IconNumber34Small = IconNumber34Small;
exports.IconNumber35Small = IconNumber35Small;
exports.IconNumber36Small = IconNumber36Small;
exports.IconNumber37Small = IconNumber37Small;
exports.IconNumber38Small = IconNumber38Small;
exports.IconNumber39Small = IconNumber39Small;
exports.IconNumber3Small = IconNumber3Small;
exports.IconNumber4 = IconNumber4;
exports.IconNumber40Small = IconNumber40Small;
exports.IconNumber41Small = IconNumber41Small;
exports.IconNumber42Small = IconNumber42Small;
exports.IconNumber43Small = IconNumber43Small;
exports.IconNumber44Small = IconNumber44Small;
exports.IconNumber45Small = IconNumber45Small;
exports.IconNumber46Small = IconNumber46Small;
exports.IconNumber47Small = IconNumber47Small;
exports.IconNumber48Small = IconNumber48Small;
exports.IconNumber49Small = IconNumber49Small;
exports.IconNumber4Small = IconNumber4Small;
exports.IconNumber5 = IconNumber5;
exports.IconNumber50Small = IconNumber50Small;
exports.IconNumber51Small = IconNumber51Small;
exports.IconNumber52Small = IconNumber52Small;
exports.IconNumber53Small = IconNumber53Small;
exports.IconNumber54Small = IconNumber54Small;
exports.IconNumber55Small = IconNumber55Small;
exports.IconNumber56Small = IconNumber56Small;
exports.IconNumber57Small = IconNumber57Small;
exports.IconNumber58Small = IconNumber58Small;
exports.IconNumber59Small = IconNumber59Small;
exports.IconNumber5Small = IconNumber5Small;
exports.IconNumber6 = IconNumber6;
exports.IconNumber60Small = IconNumber60Small;
exports.IconNumber61Small = IconNumber61Small;
exports.IconNumber62Small = IconNumber62Small;
exports.IconNumber63Small = IconNumber63Small;
exports.IconNumber64Small = IconNumber64Small;
exports.IconNumber65Small = IconNumber65Small;
exports.IconNumber66Small = IconNumber66Small;
exports.IconNumber67Small = IconNumber67Small;
exports.IconNumber68Small = IconNumber68Small;
exports.IconNumber69Small = IconNumber69Small;
exports.IconNumber6Small = IconNumber6Small;
exports.IconNumber7 = IconNumber7;
exports.IconNumber70Small = IconNumber70Small;
exports.IconNumber71Small = IconNumber71Small;
exports.IconNumber72Small = IconNumber72Small;
exports.IconNumber73Small = IconNumber73Small;
exports.IconNumber74Small = IconNumber74Small;
exports.IconNumber75Small = IconNumber75Small;
exports.IconNumber76Small = IconNumber76Small;
exports.IconNumber77Small = IconNumber77Small;
exports.IconNumber78Small = IconNumber78Small;
exports.IconNumber79Small = IconNumber79Small;
exports.IconNumber7Small = IconNumber7Small;
exports.IconNumber8 = IconNumber8;
exports.IconNumber80Small = IconNumber80Small;
exports.IconNumber81Small = IconNumber81Small;
exports.IconNumber82Small = IconNumber82Small;
exports.IconNumber83Small = IconNumber83Small;
exports.IconNumber84Small = IconNumber84Small;
exports.IconNumber85Small = IconNumber85Small;
exports.IconNumber86Small = IconNumber86Small;
exports.IconNumber87Small = IconNumber87Small;
exports.IconNumber88Small = IconNumber88Small;
exports.IconNumber89Small = IconNumber89Small;
exports.IconNumber8Small = IconNumber8Small;
exports.IconNumber9 = IconNumber9;
exports.IconNumber90Small = IconNumber90Small;
exports.IconNumber91Small = IconNumber91Small;
exports.IconNumber92Small = IconNumber92Small;
exports.IconNumber93Small = IconNumber93Small;
exports.IconNumber94Small = IconNumber94Small;
exports.IconNumber95Small = IconNumber95Small;
exports.IconNumber96Small = IconNumber96Small;
exports.IconNumber97Small = IconNumber97Small;
exports.IconNumber98Small = IconNumber98Small;
exports.IconNumber99Small = IconNumber99Small;
exports.IconNumber9Small = IconNumber9Small;
exports.IconNumbers = IconNumbers;
exports.IconNurse = IconNurse;
exports.IconNurseFilled = IconNurseFilled;
exports.IconNut = IconNut;
exports.IconObjectScan = IconObjectScan;
exports.IconOctagon = IconOctagon;
exports.IconOctagonFilled = IconOctagonFilled;
exports.IconOctagonMinus = IconOctagonMinus;
exports.IconOctagonMinus2 = IconOctagonMinus2;
exports.IconOctagonOff = IconOctagonOff;
exports.IconOctagonPlus = IconOctagonPlus;
exports.IconOctagonPlus2 = IconOctagonPlus2;
exports.IconOctahedron = IconOctahedron;
exports.IconOctahedronOff = IconOctahedronOff;
exports.IconOctahedronPlus = IconOctahedronPlus;
exports.IconOld = IconOld;
exports.IconOlympics = IconOlympics;
exports.IconOlympicsOff = IconOlympicsOff;
exports.IconOm = IconOm;
exports.IconOmega = IconOmega;
exports.IconOutbound = IconOutbound;
exports.IconOutlet = IconOutlet;
exports.IconOval = IconOval;
exports.IconOvalFilled = IconOvalFilled;
exports.IconOvalVertical = IconOvalVertical;
exports.IconOvalVerticalFilled = IconOvalVerticalFilled;
exports.IconOverline = IconOverline;
exports.IconPackage = IconPackage;
exports.IconPackageExport = IconPackageExport;
exports.IconPackageImport = IconPackageImport;
exports.IconPackageOff = IconPackageOff;
exports.IconPackages = IconPackages;
exports.IconPacman = IconPacman;
exports.IconPageBreak = IconPageBreak;
exports.IconPaint = IconPaint;
exports.IconPaintFilled = IconPaintFilled;
exports.IconPaintOff = IconPaintOff;
exports.IconPalette = IconPalette;
exports.IconPaletteFilled = IconPaletteFilled;
exports.IconPaletteOff = IconPaletteOff;
exports.IconPanoramaHorizontal = IconPanoramaHorizontal;
exports.IconPanoramaHorizontalFilled = IconPanoramaHorizontalFilled;
exports.IconPanoramaHorizontalOff = IconPanoramaHorizontalOff;
exports.IconPanoramaVertical = IconPanoramaVertical;
exports.IconPanoramaVerticalFilled = IconPanoramaVerticalFilled;
exports.IconPanoramaVerticalOff = IconPanoramaVerticalOff;
exports.IconPaperBag = IconPaperBag;
exports.IconPaperBagOff = IconPaperBagOff;
exports.IconPaperclip = IconPaperclip;
exports.IconParachute = IconParachute;
exports.IconParachuteOff = IconParachuteOff;
exports.IconParentheses = IconParentheses;
exports.IconParenthesesOff = IconParenthesesOff;
exports.IconParking = IconParking;
exports.IconParkingCircle = IconParkingCircle;
exports.IconParkingCircleFilled = IconParkingCircleFilled;
exports.IconParkingOff = IconParkingOff;
exports.IconPassword = IconPassword;
exports.IconPasswordFingerprint = IconPasswordFingerprint;
exports.IconPasswordMobilePhone = IconPasswordMobilePhone;
exports.IconPasswordUser = IconPasswordUser;
exports.IconPaw = IconPaw;
exports.IconPawFilled = IconPawFilled;
exports.IconPawOff = IconPawOff;
exports.IconPaywall = IconPaywall;
exports.IconPdf = IconPdf;
exports.IconPeace = IconPeace;
exports.IconPencil = IconPencil;
exports.IconPencilBolt = IconPencilBolt;
exports.IconPencilCancel = IconPencilCancel;
exports.IconPencilCheck = IconPencilCheck;
exports.IconPencilCode = IconPencilCode;
exports.IconPencilCog = IconPencilCog;
exports.IconPencilDiscount = IconPencilDiscount;
exports.IconPencilDollar = IconPencilDollar;
exports.IconPencilDown = IconPencilDown;
exports.IconPencilExclamation = IconPencilExclamation;
exports.IconPencilHeart = IconPencilHeart;
exports.IconPencilMinus = IconPencilMinus;
exports.IconPencilOff = IconPencilOff;
exports.IconPencilPause = IconPencilPause;
exports.IconPencilPin = IconPencilPin;
exports.IconPencilPlus = IconPencilPlus;
exports.IconPencilQuestion = IconPencilQuestion;
exports.IconPencilSearch = IconPencilSearch;
exports.IconPencilShare = IconPencilShare;
exports.IconPencilStar = IconPencilStar;
exports.IconPencilUp = IconPencilUp;
exports.IconPencilX = IconPencilX;
exports.IconPennant = IconPennant;
exports.IconPennant2 = IconPennant2;
exports.IconPennant2Filled = IconPennant2Filled;
exports.IconPennantFilled = IconPennantFilled;
exports.IconPennantOff = IconPennantOff;
exports.IconPentagon = IconPentagon;
exports.IconPentagonFilled = IconPentagonFilled;
exports.IconPentagonMinus = IconPentagonMinus;
exports.IconPentagonNumber0 = IconPentagonNumber0;
exports.IconPentagonNumber1 = IconPentagonNumber1;
exports.IconPentagonNumber2 = IconPentagonNumber2;
exports.IconPentagonNumber3 = IconPentagonNumber3;
exports.IconPentagonNumber4 = IconPentagonNumber4;
exports.IconPentagonNumber5 = IconPentagonNumber5;
exports.IconPentagonNumber6 = IconPentagonNumber6;
exports.IconPentagonNumber7 = IconPentagonNumber7;
exports.IconPentagonNumber8 = IconPentagonNumber8;
exports.IconPentagonNumber9 = IconPentagonNumber9;
exports.IconPentagonOff = IconPentagonOff;
exports.IconPentagonPlus = IconPentagonPlus;
exports.IconPentagonX = IconPentagonX;
exports.IconPentagram = IconPentagram;
exports.IconPepper = IconPepper;
exports.IconPepperOff = IconPepperOff;
exports.IconPercentage = IconPercentage;
exports.IconPercentage0 = IconPercentage0;
exports.IconPercentage10 = IconPercentage10;
exports.IconPercentage100 = IconPercentage100;
exports.IconPercentage20 = IconPercentage20;
exports.IconPercentage25 = IconPercentage25;
exports.IconPercentage30 = IconPercentage30;
exports.IconPercentage33 = IconPercentage33;
exports.IconPercentage40 = IconPercentage40;
exports.IconPercentage50 = IconPercentage50;
exports.IconPercentage60 = IconPercentage60;
exports.IconPercentage66 = IconPercentage66;
exports.IconPercentage70 = IconPercentage70;
exports.IconPercentage75 = IconPercentage75;
exports.IconPercentage80 = IconPercentage80;
exports.IconPercentage90 = IconPercentage90;
exports.IconPerfume = IconPerfume;
exports.IconPerspective = IconPerspective;
exports.IconPerspectiveOff = IconPerspectiveOff;
exports.IconPhone = IconPhone;
exports.IconPhoneCall = IconPhoneCall;
exports.IconPhoneCalling = IconPhoneCalling;
exports.IconPhoneCheck = IconPhoneCheck;
exports.IconPhoneDone = IconPhoneDone;
exports.IconPhoneEnd = IconPhoneEnd;
exports.IconPhoneFilled = IconPhoneFilled;
exports.IconPhoneIncoming = IconPhoneIncoming;
exports.IconPhoneOff = IconPhoneOff;
exports.IconPhoneOutgoing = IconPhoneOutgoing;
exports.IconPhonePause = IconPhonePause;
exports.IconPhonePlus = IconPhonePlus;
exports.IconPhoneRinging = IconPhoneRinging;
exports.IconPhoneSpark = IconPhoneSpark;
exports.IconPhoneX = IconPhoneX;
exports.IconPhoto = IconPhoto;
exports.IconPhotoAi = IconPhotoAi;
exports.IconPhotoBitcoin = IconPhotoBitcoin;
exports.IconPhotoBolt = IconPhotoBolt;
exports.IconPhotoCancel = IconPhotoCancel;
exports.IconPhotoCheck = IconPhotoCheck;
exports.IconPhotoCircle = IconPhotoCircle;
exports.IconPhotoCircleMinus = IconPhotoCircleMinus;
exports.IconPhotoCirclePlus = IconPhotoCirclePlus;
exports.IconPhotoCode = IconPhotoCode;
exports.IconPhotoCog = IconPhotoCog;
exports.IconPhotoDollar = IconPhotoDollar;
exports.IconPhotoDown = IconPhotoDown;
exports.IconPhotoEdit = IconPhotoEdit;
exports.IconPhotoExclamation = IconPhotoExclamation;
exports.IconPhotoFilled = IconPhotoFilled;
exports.IconPhotoHeart = IconPhotoHeart;
exports.IconPhotoHexagon = IconPhotoHexagon;
exports.IconPhotoMinus = IconPhotoMinus;
exports.IconPhotoOff = IconPhotoOff;
exports.IconPhotoPause = IconPhotoPause;
exports.IconPhotoPentagon = IconPhotoPentagon;
exports.IconPhotoPin = IconPhotoPin;
exports.IconPhotoPlus = IconPhotoPlus;
exports.IconPhotoQuestion = IconPhotoQuestion;
exports.IconPhotoScan = IconPhotoScan;
exports.IconPhotoSearch = IconPhotoSearch;
exports.IconPhotoSensor = IconPhotoSensor;
exports.IconPhotoSensor2 = IconPhotoSensor2;
exports.IconPhotoSensor3 = IconPhotoSensor3;
exports.IconPhotoShare = IconPhotoShare;
exports.IconPhotoShield = IconPhotoShield;
exports.IconPhotoSpark = IconPhotoSpark;
exports.IconPhotoSquareRounded = IconPhotoSquareRounded;
exports.IconPhotoStar = IconPhotoStar;
exports.IconPhotoUp = IconPhotoUp;
exports.IconPhotoVideo = IconPhotoVideo;
exports.IconPhotoX = IconPhotoX;
exports.IconPhysotherapist = IconPhysotherapist;
exports.IconPiano = IconPiano;
exports.IconPick = IconPick;
exports.IconPicnicTable = IconPicnicTable;
exports.IconPictureInPicture = IconPictureInPicture;
exports.IconPictureInPictureFilled = IconPictureInPictureFilled;
exports.IconPictureInPictureOff = IconPictureInPictureOff;
exports.IconPictureInPictureOn = IconPictureInPictureOn;
exports.IconPictureInPictureTop = IconPictureInPictureTop;
exports.IconPictureInPictureTopFilled = IconPictureInPictureTopFilled;
exports.IconPig = IconPig;
exports.IconPigFilled = IconPigFilled;
exports.IconPigMoney = IconPigMoney;
exports.IconPigOff = IconPigOff;
exports.IconPilcrow = IconPilcrow;
exports.IconPilcrowLeft = IconPilcrowLeft;
exports.IconPilcrowRight = IconPilcrowRight;
exports.IconPill = IconPill;
exports.IconPillFilled = IconPillFilled;
exports.IconPillOff = IconPillOff;
exports.IconPills = IconPills;
exports.IconPin = IconPin;
exports.IconPinEnd = IconPinEnd;
exports.IconPinFilled = IconPinFilled;
exports.IconPinInvoke = IconPinInvoke;
exports.IconPingPong = IconPingPong;
exports.IconPinned = IconPinned;
exports.IconPinnedFilled = IconPinnedFilled;
exports.IconPinnedOff = IconPinnedOff;
exports.IconPizza = IconPizza;
exports.IconPizzaFilled = IconPizzaFilled;
exports.IconPizzaOff = IconPizzaOff;
exports.IconPlaceholder = IconPlaceholder;
exports.IconPlane = IconPlane;
exports.IconPlaneArrival = IconPlaneArrival;
exports.IconPlaneDeparture = IconPlaneDeparture;
exports.IconPlaneInflight = IconPlaneInflight;
exports.IconPlaneOff = IconPlaneOff;
exports.IconPlaneTilt = IconPlaneTilt;
exports.IconPlanet = IconPlanet;
exports.IconPlanetOff = IconPlanetOff;
exports.IconPlant = IconPlant;
exports.IconPlant2 = IconPlant2;
exports.IconPlant2Off = IconPlant2Off;
exports.IconPlantOff = IconPlantOff;
exports.IconPlayBasketball = IconPlayBasketball;
exports.IconPlayCard = IconPlayCard;
exports.IconPlayCard1 = IconPlayCard1;
exports.IconPlayCard10 = IconPlayCard10;
exports.IconPlayCard10Filled = IconPlayCard10Filled;
exports.IconPlayCard1Filled = IconPlayCard1Filled;
exports.IconPlayCard2 = IconPlayCard2;
exports.IconPlayCard2Filled = IconPlayCard2Filled;
exports.IconPlayCard3 = IconPlayCard3;
exports.IconPlayCard3Filled = IconPlayCard3Filled;
exports.IconPlayCard4 = IconPlayCard4;
exports.IconPlayCard4Filled = IconPlayCard4Filled;
exports.IconPlayCard5 = IconPlayCard5;
exports.IconPlayCard5Filled = IconPlayCard5Filled;
exports.IconPlayCard6 = IconPlayCard6;
exports.IconPlayCard6Filled = IconPlayCard6Filled;
exports.IconPlayCard7 = IconPlayCard7;
exports.IconPlayCard7Filled = IconPlayCard7Filled;
exports.IconPlayCard8 = IconPlayCard8;
exports.IconPlayCard8Filled = IconPlayCard8Filled;
exports.IconPlayCard9 = IconPlayCard9;
exports.IconPlayCard9Filled = IconPlayCard9Filled;
exports.IconPlayCardA = IconPlayCardA;
exports.IconPlayCardAFilled = IconPlayCardAFilled;
exports.IconPlayCardJ = IconPlayCardJ;
exports.IconPlayCardJFilled = IconPlayCardJFilled;
exports.IconPlayCardK = IconPlayCardK;
exports.IconPlayCardKFilled = IconPlayCardKFilled;
exports.IconPlayCardOff = IconPlayCardOff;
exports.IconPlayCardQ = IconPlayCardQ;
exports.IconPlayCardQFilled = IconPlayCardQFilled;
exports.IconPlayCardStar = IconPlayCardStar;
exports.IconPlayCardStarFilled = IconPlayCardStarFilled;
exports.IconPlayFootball = IconPlayFootball;
exports.IconPlayHandball = IconPlayHandball;
exports.IconPlayVolleyball = IconPlayVolleyball;
exports.IconPlayerEject = IconPlayerEject;
exports.IconPlayerEjectFilled = IconPlayerEjectFilled;
exports.IconPlayerPause = IconPlayerPause;
exports.IconPlayerPauseFilled = IconPlayerPauseFilled;
exports.IconPlayerPlay = IconPlayerPlay;
exports.IconPlayerPlayFilled = IconPlayerPlayFilled;
exports.IconPlayerRecord = IconPlayerRecord;
exports.IconPlayerRecordFilled = IconPlayerRecordFilled;
exports.IconPlayerSkipBack = IconPlayerSkipBack;
exports.IconPlayerSkipBackFilled = IconPlayerSkipBackFilled;
exports.IconPlayerSkipForward = IconPlayerSkipForward;
exports.IconPlayerSkipForwardFilled = IconPlayerSkipForwardFilled;
exports.IconPlayerStop = IconPlayerStop;
exports.IconPlayerStopFilled = IconPlayerStopFilled;
exports.IconPlayerTrackNext = IconPlayerTrackNext;
exports.IconPlayerTrackNextFilled = IconPlayerTrackNextFilled;
exports.IconPlayerTrackPrev = IconPlayerTrackPrev;
exports.IconPlayerTrackPrevFilled = IconPlayerTrackPrevFilled;
exports.IconPlaylist = IconPlaylist;
exports.IconPlaylistAdd = IconPlaylistAdd;
exports.IconPlaylistOff = IconPlaylistOff;
exports.IconPlaylistX = IconPlaylistX;
exports.IconPlaystationCircle = IconPlaystationCircle;
exports.IconPlaystationSquare = IconPlaystationSquare;
exports.IconPlaystationTriangle = IconPlaystationTriangle;
exports.IconPlaystationX = IconPlaystationX;
exports.IconPlug = IconPlug;
exports.IconPlugConnected = IconPlugConnected;
exports.IconPlugConnectedX = IconPlugConnectedX;
exports.IconPlugOff = IconPlugOff;
exports.IconPlugX = IconPlugX;
exports.IconPlus = IconPlus;
exports.IconPlusEqual = IconPlusEqual;
exports.IconPlusMinus = IconPlusMinus;
exports.IconPng = IconPng;
exports.IconPodium = IconPodium;
exports.IconPodiumOff = IconPodiumOff;
exports.IconPoint = IconPoint;
exports.IconPointFilled = IconPointFilled;
exports.IconPointOff = IconPointOff;
exports.IconPointer = IconPointer;
exports.IconPointerBolt = IconPointerBolt;
exports.IconPointerCancel = IconPointerCancel;
exports.IconPointerCheck = IconPointerCheck;
exports.IconPointerCode = IconPointerCode;
exports.IconPointerCog = IconPointerCog;
exports.IconPointerDollar = IconPointerDollar;
exports.IconPointerDown = IconPointerDown;
exports.IconPointerExclamation = IconPointerExclamation;
exports.IconPointerFilled = IconPointerFilled;
exports.IconPointerHeart = IconPointerHeart;
exports.IconPointerMinus = IconPointerMinus;
exports.IconPointerOff = IconPointerOff;
exports.IconPointerPause = IconPointerPause;
exports.IconPointerPin = IconPointerPin;
exports.IconPointerPlus = IconPointerPlus;
exports.IconPointerQuestion = IconPointerQuestion;
exports.IconPointerSearch = IconPointerSearch;
exports.IconPointerShare = IconPointerShare;
exports.IconPointerStar = IconPointerStar;
exports.IconPointerUp = IconPointerUp;
exports.IconPointerX = IconPointerX;
exports.IconPokeball = IconPokeball;
exports.IconPokeballOff = IconPokeballOff;
exports.IconPokerChip = IconPokerChip;
exports.IconPolaroid = IconPolaroid;
exports.IconPolaroidFilled = IconPolaroidFilled;
exports.IconPolygon = IconPolygon;
exports.IconPolygonOff = IconPolygonOff;
exports.IconPoo = IconPoo;
exports.IconPooFilled = IconPooFilled;
exports.IconPool = IconPool;
exports.IconPoolOff = IconPoolOff;
exports.IconPower = IconPower;
exports.IconPray = IconPray;
exports.IconPremiumRights = IconPremiumRights;
exports.IconPrescription = IconPrescription;
exports.IconPresentation = IconPresentation;
exports.IconPresentationAnalytics = IconPresentationAnalytics;
exports.IconPresentationAnalyticsFilled = IconPresentationAnalyticsFilled;
exports.IconPresentationFilled = IconPresentationFilled;
exports.IconPresentationOff = IconPresentationOff;
exports.IconPrinter = IconPrinter;
exports.IconPrinterOff = IconPrinterOff;
exports.IconPrism = IconPrism;
exports.IconPrismLight = IconPrismLight;
exports.IconPrismOff = IconPrismOff;
exports.IconPrismPlus = IconPrismPlus;
exports.IconPrison = IconPrison;
exports.IconProgress = IconProgress;
exports.IconProgressAlert = IconProgressAlert;
exports.IconProgressBolt = IconProgressBolt;
exports.IconProgressCheck = IconProgressCheck;
exports.IconProgressDown = IconProgressDown;
exports.IconProgressHelp = IconProgressHelp;
exports.IconProgressX = IconProgressX;
exports.IconPrompt = IconPrompt;
exports.IconProng = IconProng;
exports.IconPropeller = IconPropeller;
exports.IconPropellerOff = IconPropellerOff;
exports.IconProtocol = IconProtocol;
exports.IconPumpkinScary = IconPumpkinScary;
exports.IconPuzzle = IconPuzzle;
exports.IconPuzzle2 = IconPuzzle2;
exports.IconPuzzleFilled = IconPuzzleFilled;
exports.IconPuzzleOff = IconPuzzleOff;
exports.IconPyramid = IconPyramid;
exports.IconPyramidOff = IconPyramidOff;
exports.IconPyramidPlus = IconPyramidPlus;
exports.IconQrcode = IconQrcode;
exports.IconQrcodeOff = IconQrcodeOff;
exports.IconQuestionMark = IconQuestionMark;
exports.IconQuote = IconQuote;
exports.IconQuoteFilled = IconQuoteFilled;
exports.IconQuoteOff = IconQuoteOff;
exports.IconQuotes = IconQuotes;
exports.IconRadar = IconRadar;
exports.IconRadar2 = IconRadar2;
exports.IconRadarFilled = IconRadarFilled;
exports.IconRadarOff = IconRadarOff;
exports.IconRadio = IconRadio;
exports.IconRadioOff = IconRadioOff;
exports.IconRadioactive = IconRadioactive;
exports.IconRadioactiveFilled = IconRadioactiveFilled;
exports.IconRadioactiveOff = IconRadioactiveOff;
exports.IconRadiusBottomLeft = IconRadiusBottomLeft;
exports.IconRadiusBottomRight = IconRadiusBottomRight;
exports.IconRadiusTopLeft = IconRadiusTopLeft;
exports.IconRadiusTopRight = IconRadiusTopRight;
exports.IconRainbow = IconRainbow;
exports.IconRainbowOff = IconRainbowOff;
exports.IconRating12Plus = IconRating12Plus;
exports.IconRating14Plus = IconRating14Plus;
exports.IconRating16Plus = IconRating16Plus;
exports.IconRating18Plus = IconRating18Plus;
exports.IconRating21Plus = IconRating21Plus;
exports.IconRazor = IconRazor;
exports.IconRazorElectric = IconRazorElectric;
exports.IconReceipt = IconReceipt;
exports.IconReceipt2 = IconReceipt2;
exports.IconReceiptBitcoin = IconReceiptBitcoin;
exports.IconReceiptDollar = IconReceiptDollar;
exports.IconReceiptEuro = IconReceiptEuro;
exports.IconReceiptFilled = IconReceiptFilled;
exports.IconReceiptOff = IconReceiptOff;
exports.IconReceiptPound = IconReceiptPound;
exports.IconReceiptRefund = IconReceiptRefund;
exports.IconReceiptRupee = IconReceiptRupee;
exports.IconReceiptTax = IconReceiptTax;
exports.IconReceiptYen = IconReceiptYen;
exports.IconReceiptYuan = IconReceiptYuan;
exports.IconRecharging = IconRecharging;
exports.IconRecordMail = IconRecordMail;
exports.IconRecordMailOff = IconRecordMailOff;
exports.IconRectangle = IconRectangle;
exports.IconRectangleFilled = IconRectangleFilled;
exports.IconRectangleRoundedBottom = IconRectangleRoundedBottom;
exports.IconRectangleRoundedTop = IconRectangleRoundedTop;
exports.IconRectangleVertical = IconRectangleVertical;
exports.IconRectangleVerticalFilled = IconRectangleVerticalFilled;
exports.IconRectangularPrism = IconRectangularPrism;
exports.IconRectangularPrismOff = IconRectangularPrismOff;
exports.IconRectangularPrismPlus = IconRectangularPrismPlus;
exports.IconRecycle = IconRecycle;
exports.IconRecycleOff = IconRecycleOff;
exports.IconRefresh = IconRefresh;
exports.IconRefreshAlert = IconRefreshAlert;
exports.IconRefreshDot = IconRefreshDot;
exports.IconRefreshOff = IconRefreshOff;
exports.IconRegex = IconRegex;
exports.IconRegexOff = IconRegexOff;
exports.IconRegistered = IconRegistered;
exports.IconRelationManyToMany = IconRelationManyToMany;
exports.IconRelationManyToManyFilled = IconRelationManyToManyFilled;
exports.IconRelationOneToMany = IconRelationOneToMany;
exports.IconRelationOneToManyFilled = IconRelationOneToManyFilled;
exports.IconRelationOneToOne = IconRelationOneToOne;
exports.IconRelationOneToOneFilled = IconRelationOneToOneFilled;
exports.IconReload = IconReload;
exports.IconReorder = IconReorder;
exports.IconRepeat = IconRepeat;
exports.IconRepeatOff = IconRepeatOff;
exports.IconRepeatOnce = IconRepeatOnce;
exports.IconReplace = IconReplace;
exports.IconReplaceFilled = IconReplaceFilled;
exports.IconReplaceOff = IconReplaceOff;
exports.IconReplaceUser = IconReplaceUser;
exports.IconReport = IconReport;
exports.IconReportAnalytics = IconReportAnalytics;
exports.IconReportMedical = IconReportMedical;
exports.IconReportMoney = IconReportMoney;
exports.IconReportOff = IconReportOff;
exports.IconReportSearch = IconReportSearch;
exports.IconReservedLine = IconReservedLine;
exports.IconResize = IconResize;
exports.IconRestore = IconRestore;
exports.IconRewindBackward10 = IconRewindBackward10;
exports.IconRewindBackward15 = IconRewindBackward15;
exports.IconRewindBackward20 = IconRewindBackward20;
exports.IconRewindBackward30 = IconRewindBackward30;
exports.IconRewindBackward40 = IconRewindBackward40;
exports.IconRewindBackward5 = IconRewindBackward5;
exports.IconRewindBackward50 = IconRewindBackward50;
exports.IconRewindBackward60 = IconRewindBackward60;
exports.IconRewindForward10 = IconRewindForward10;
exports.IconRewindForward15 = IconRewindForward15;
exports.IconRewindForward20 = IconRewindForward20;
exports.IconRewindForward30 = IconRewindForward30;
exports.IconRewindForward40 = IconRewindForward40;
exports.IconRewindForward5 = IconRewindForward5;
exports.IconRewindForward50 = IconRewindForward50;
exports.IconRewindForward60 = IconRewindForward60;
exports.IconRibbonHealth = IconRibbonHealth;
exports.IconRings = IconRings;
exports.IconRipple = IconRipple;
exports.IconRippleOff = IconRippleOff;
exports.IconRoad = IconRoad;
exports.IconRoadOff = IconRoadOff;
exports.IconRoadSign = IconRoadSign;
exports.IconRobot = IconRobot;
exports.IconRobotFace = IconRobotFace;
exports.IconRobotOff = IconRobotOff;
exports.IconRocket = IconRocket;
exports.IconRocketOff = IconRocketOff;
exports.IconRollerSkating = IconRollerSkating;
exports.IconRollercoaster = IconRollercoaster;
exports.IconRollercoasterFilled = IconRollercoasterFilled;
exports.IconRollercoasterOff = IconRollercoasterOff;
exports.IconRosette = IconRosette;
exports.IconRosetteDiscount = IconRosetteDiscount;
exports.IconRosetteDiscountCheck = IconRosetteDiscountCheck;
exports.IconRosetteDiscountCheckFilled = IconRosetteDiscountCheckFilled;
exports.IconRosetteDiscountCheckOff = IconRosetteDiscountCheckOff;
exports.IconRosetteDiscountFilled = IconRosetteDiscountFilled;
exports.IconRosetteDiscountOff = IconRosetteDiscountOff;
exports.IconRosetteFilled = IconRosetteFilled;
exports.IconRosetteNumber0 = IconRosetteNumber0;
exports.IconRosetteNumber1 = IconRosetteNumber1;
exports.IconRosetteNumber2 = IconRosetteNumber2;
exports.IconRosetteNumber3 = IconRosetteNumber3;
exports.IconRosetteNumber4 = IconRosetteNumber4;
exports.IconRosetteNumber5 = IconRosetteNumber5;
exports.IconRosetteNumber6 = IconRosetteNumber6;
exports.IconRosetteNumber7 = IconRosetteNumber7;
exports.IconRosetteNumber8 = IconRosetteNumber8;
exports.IconRosetteNumber9 = IconRosetteNumber9;
exports.IconRotate = IconRotate;
exports.IconRotate2 = IconRotate2;
exports.IconRotate360 = IconRotate360;
exports.IconRotate3d = IconRotate3d;
exports.IconRotateClockwise = IconRotateClockwise;
exports.IconRotateClockwise2 = IconRotateClockwise2;
exports.IconRotateDot = IconRotateDot;
exports.IconRotateRectangle = IconRotateRectangle;
exports.IconRoute = IconRoute;
exports.IconRoute2 = IconRoute2;
exports.IconRouteAltLeft = IconRouteAltLeft;
exports.IconRouteAltRight = IconRouteAltRight;
exports.IconRouteOff = IconRouteOff;
exports.IconRouteScan = IconRouteScan;
exports.IconRouteSquare = IconRouteSquare;
exports.IconRouteSquare2 = IconRouteSquare2;
exports.IconRouteX = IconRouteX;
exports.IconRouteX2 = IconRouteX2;
exports.IconRouter = IconRouter;
exports.IconRouterOff = IconRouterOff;
exports.IconRowInsertBottom = IconRowInsertBottom;
exports.IconRowInsertTop = IconRowInsertTop;
exports.IconRowRemove = IconRowRemove;
exports.IconRss = IconRss;
exports.IconRubberStamp = IconRubberStamp;
exports.IconRubberStampOff = IconRubberStampOff;
exports.IconRuler = IconRuler;
exports.IconRuler2 = IconRuler2;
exports.IconRuler2Off = IconRuler2Off;
exports.IconRuler3 = IconRuler3;
exports.IconRulerMeasure = IconRulerMeasure;
exports.IconRulerMeasure2 = IconRulerMeasure2;
exports.IconRulerOff = IconRulerOff;
exports.IconRun = IconRun;
exports.IconRvTruck = IconRvTruck;
exports.IconSTurnDown = IconSTurnDown;
exports.IconSTurnLeft = IconSTurnLeft;
exports.IconSTurnRight = IconSTurnRight;
exports.IconSTurnUp = IconSTurnUp;
exports.IconSailboat = IconSailboat;
exports.IconSailboat2 = IconSailboat2;
exports.IconSailboatOff = IconSailboatOff;
exports.IconSalad = IconSalad;
exports.IconSaladFilled = IconSaladFilled;
exports.IconSalt = IconSalt;
exports.IconSandbox = IconSandbox;
exports.IconSatellite = IconSatellite;
exports.IconSatelliteOff = IconSatelliteOff;
exports.IconSausage = IconSausage;
exports.IconScale = IconScale;
exports.IconScaleOff = IconScaleOff;
exports.IconScaleOutline = IconScaleOutline;
exports.IconScaleOutlineOff = IconScaleOutlineOff;
exports.IconScan = IconScan;
exports.IconScanEye = IconScanEye;
exports.IconScanPosition = IconScanPosition;
exports.IconSchema = IconSchema;
exports.IconSchemaOff = IconSchemaOff;
exports.IconSchool = IconSchool;
exports.IconSchoolBell = IconSchoolBell;
exports.IconSchoolOff = IconSchoolOff;
exports.IconScissors = IconScissors;
exports.IconScissorsOff = IconScissorsOff;
exports.IconScooter = IconScooter;
exports.IconScooterElectric = IconScooterElectric;
exports.IconScoreboard = IconScoreboard;
exports.IconScreenShare = IconScreenShare;
exports.IconScreenShareOff = IconScreenShareOff;
exports.IconScreenshot = IconScreenshot;
exports.IconScribble = IconScribble;
exports.IconScribbleOff = IconScribbleOff;
exports.IconScript = IconScript;
exports.IconScriptMinus = IconScriptMinus;
exports.IconScriptPlus = IconScriptPlus;
exports.IconScriptX = IconScriptX;
exports.IconScubaDiving = IconScubaDiving;
exports.IconScubaDivingTank = IconScubaDivingTank;
exports.IconScubaDivingTankFilled = IconScubaDivingTankFilled;
exports.IconScubaMask = IconScubaMask;
exports.IconScubaMaskOff = IconScubaMaskOff;
exports.IconSdk = IconSdk;
exports.IconSearch = IconSearch;
exports.IconSearchOff = IconSearchOff;
exports.IconSection = IconSection;
exports.IconSectionFilled = IconSectionFilled;
exports.IconSectionSign = IconSectionSign;
exports.IconSeeding = IconSeedling;
exports.IconSeedingFilled = IconSeedlingFilled;
exports.IconSeedingOff = IconSeedlingOff;
exports.IconSeedling = IconSeedling;
exports.IconSeedlingFilled = IconSeedlingFilled;
exports.IconSeedlingOff = IconSeedlingOff;
exports.IconSelect = IconSelect;
exports.IconSelectAll = IconSelectAll;
exports.IconSelector = IconSelector;
exports.IconSend = IconSend;
exports.IconSend2 = IconSend2;
exports.IconSendOff = IconSendOff;
exports.IconSeo = IconSeo;
exports.IconSeparator = IconSeparator;
exports.IconSeparatorHorizontal = IconSeparatorHorizontal;
exports.IconSeparatorVertical = IconSeparatorVertical;
exports.IconServer = IconServer;
exports.IconServer2 = IconServer2;
exports.IconServerBolt = IconServerBolt;
exports.IconServerCog = IconServerCog;
exports.IconServerOff = IconServerOff;
exports.IconServerSpark = IconServerSpark;
exports.IconServicemark = IconServicemark;
exports.IconSettings = IconSettings;
exports.IconSettings2 = IconSettings2;
exports.IconSettingsAutomation = IconSettingsAutomation;
exports.IconSettingsBolt = IconSettingsBolt;
exports.IconSettingsCancel = IconSettingsCancel;
exports.IconSettingsCheck = IconSettingsCheck;
exports.IconSettingsCode = IconSettingsCode;
exports.IconSettingsCog = IconSettingsCog;
exports.IconSettingsDollar = IconSettingsDollar;
exports.IconSettingsDown = IconSettingsDown;
exports.IconSettingsExclamation = IconSettingsExclamation;
exports.IconSettingsFilled = IconSettingsFilled;
exports.IconSettingsHeart = IconSettingsHeart;
exports.IconSettingsMinus = IconSettingsMinus;
exports.IconSettingsOff = IconSettingsOff;
exports.IconSettingsPause = IconSettingsPause;
exports.IconSettingsPin = IconSettingsPin;
exports.IconSettingsPlus = IconSettingsPlus;
exports.IconSettingsQuestion = IconSettingsQuestion;
exports.IconSettingsSearch = IconSettingsSearch;
exports.IconSettingsShare = IconSettingsShare;
exports.IconSettingsSpark = IconSettingsSpark;
exports.IconSettingsStar = IconSettingsStar;
exports.IconSettingsUp = IconSettingsUp;
exports.IconSettingsX = IconSettingsX;
exports.IconShadow = IconShadow;
exports.IconShadowOff = IconShadowOff;
exports.IconShape = IconShape;
exports.IconShape2 = IconShape2;
exports.IconShape3 = IconShape3;
exports.IconShapeOff = IconShapeOff;
exports.IconShare = IconShare;
exports.IconShare2 = IconShare2;
exports.IconShare3 = IconShare3;
exports.IconShareOff = IconShareOff;
exports.IconShareplay = IconShareplay;
exports.IconShiJumping = IconSkiJumping;
exports.IconShield = IconShield;
exports.IconShieldBolt = IconShieldBolt;
exports.IconShieldCancel = IconShieldCancel;
exports.IconShieldCheck = IconShieldCheck;
exports.IconShieldCheckFilled = IconShieldCheckFilled;
exports.IconShieldCheckered = IconShieldCheckered;
exports.IconShieldCheckeredFilled = IconShieldCheckeredFilled;
exports.IconShieldChevron = IconShieldChevron;
exports.IconShieldCode = IconShieldCode;
exports.IconShieldCog = IconShieldCog;
exports.IconShieldDollar = IconShieldDollar;
exports.IconShieldDown = IconShieldDown;
exports.IconShieldExclamation = IconShieldExclamation;
exports.IconShieldFilled = IconShieldFilled;
exports.IconShieldHalf = IconShieldHalf;
exports.IconShieldHalfFilled = IconShieldHalfFilled;
exports.IconShieldHeart = IconShieldHeart;
exports.IconShieldLock = IconShieldLock;
exports.IconShieldLockFilled = IconShieldLockFilled;
exports.IconShieldMinus = IconShieldMinus;
exports.IconShieldOff = IconShieldOff;
exports.IconShieldPause = IconShieldPause;
exports.IconShieldPin = IconShieldPin;
exports.IconShieldPlus = IconShieldPlus;
exports.IconShieldQuestion = IconShieldQuestion;
exports.IconShieldSearch = IconShieldSearch;
exports.IconShieldShare = IconShieldShare;
exports.IconShieldStar = IconShieldStar;
exports.IconShieldUp = IconShieldUp;
exports.IconShieldX = IconShieldX;
exports.IconShip = IconShip;
exports.IconShipOff = IconShipOff;
exports.IconShirt = IconShirt;
exports.IconShirtFilled = IconShirtFilled;
exports.IconShirtOff = IconShirtOff;
exports.IconShirtSport = IconShirtSport;
exports.IconShoe = IconShoe;
exports.IconShoeOff = IconShoeOff;
exports.IconShoppingBag = IconShoppingBag;
exports.IconShoppingBagCheck = IconShoppingBagCheck;
exports.IconShoppingBagDiscount = IconShoppingBagDiscount;
exports.IconShoppingBagEdit = IconShoppingBagEdit;
exports.IconShoppingBagExclamation = IconShoppingBagExclamation;
exports.IconShoppingBagHeart = IconShoppingBagHeart;
exports.IconShoppingBagMinus = IconShoppingBagMinus;
exports.IconShoppingBagPlus = IconShoppingBagPlus;
exports.IconShoppingBagSearch = IconShoppingBagSearch;
exports.IconShoppingBagX = IconShoppingBagX;
exports.IconShoppingCart = IconShoppingCart;
exports.IconShoppingCartBolt = IconShoppingCartBolt;
exports.IconShoppingCartCancel = IconShoppingCartCancel;
exports.IconShoppingCartCheck = IconShoppingCartCheck;
exports.IconShoppingCartCode = IconShoppingCartCode;
exports.IconShoppingCartCog = IconShoppingCartCog;
exports.IconShoppingCartCopy = IconShoppingCartCopy;
exports.IconShoppingCartDiscount = IconShoppingCartDiscount;
exports.IconShoppingCartDollar = IconShoppingCartDollar;
exports.IconShoppingCartDown = IconShoppingCartDown;
exports.IconShoppingCartExclamation = IconShoppingCartExclamation;
exports.IconShoppingCartFilled = IconShoppingCartFilled;
exports.IconShoppingCartHeart = IconShoppingCartHeart;
exports.IconShoppingCartMinus = IconShoppingCartMinus;
exports.IconShoppingCartOff = IconShoppingCartOff;
exports.IconShoppingCartPause = IconShoppingCartPause;
exports.IconShoppingCartPin = IconShoppingCartPin;
exports.IconShoppingCartPlus = IconShoppingCartPlus;
exports.IconShoppingCartQuestion = IconShoppingCartQuestion;
exports.IconShoppingCartSearch = IconShoppingCartSearch;
exports.IconShoppingCartShare = IconShoppingCartShare;
exports.IconShoppingCartStar = IconShoppingCartStar;
exports.IconShoppingCartUp = IconShoppingCartUp;
exports.IconShoppingCartX = IconShoppingCartX;
exports.IconShovel = IconShovel;
exports.IconShovelPitchforks = IconShovelPitchforks;
exports.IconShredder = IconShredder;
exports.IconSignLeft = IconSignLeft;
exports.IconSignLeftFilled = IconSignLeftFilled;
exports.IconSignRight = IconSignRight;
exports.IconSignRightFilled = IconSignRightFilled;
exports.IconSignal2g = IconSignal2g;
exports.IconSignal3g = IconSignal3g;
exports.IconSignal4g = IconSignal4g;
exports.IconSignal4gPlus = IconSignal4gPlus;
exports.IconSignal5g = IconSignal5g;
exports.IconSignal6g = IconSignal6g;
exports.IconSignalE = IconSignalE;
exports.IconSignalG = IconSignalG;
exports.IconSignalH = IconSignalH;
exports.IconSignalHPlus = IconSignalHPlus;
exports.IconSignalLte = IconSignalLte;
exports.IconSignature = IconSignature;
exports.IconSignatureOff = IconSignatureOff;
exports.IconSitemap = IconSitemap;
exports.IconSitemapFilled = IconSitemapFilled;
exports.IconSitemapOff = IconSitemapOff;
exports.IconSkateboard = IconSkateboard;
exports.IconSkateboardOff = IconSkateboardOff;
exports.IconSkateboarding = IconSkateboarding;
exports.IconSkewX = IconSkewX;
exports.IconSkewY = IconSkewY;
exports.IconSkiJumping = IconSkiJumping;
exports.IconSkull = IconSkull;
exports.IconSlash = IconSlash;
exports.IconSlashes = IconSlashes;
exports.IconSleigh = IconSleigh;
exports.IconSlice = IconSlice;
exports.IconSlideshow = IconSlideshow;
exports.IconSmartHome = IconSmartHome;
exports.IconSmartHomeOff = IconSmartHomeOff;
exports.IconSmoking = IconSmoking;
exports.IconSmokingNo = IconSmokingNo;
exports.IconSnowboarding = IconSnowboarding;
exports.IconSnowflake = IconSnowflake;
exports.IconSnowflakeOff = IconSnowflakeOff;
exports.IconSnowman = IconSnowman;
exports.IconSoccerField = IconSoccerField;
exports.IconSocial = IconSocial;
exports.IconSocialOff = IconSocialOff;
exports.IconSock = IconSock;
exports.IconSofa = IconSofa;
exports.IconSofaOff = IconSofaOff;
exports.IconSolarElectricity = IconSolarElectricity;
exports.IconSolarPanel = IconSolarPanel;
exports.IconSolarPanel2 = IconSolarPanel2;
exports.IconSort09 = IconSort09;
exports.IconSort90 = IconSort90;
exports.IconSortAZ = IconSortAZ;
exports.IconSortAscending = IconSortAscending;
exports.IconSortAscending2 = IconSortAscending2;
exports.IconSortAscending2Filled = IconSortAscending2Filled;
exports.IconSortAscendingLetters = IconSortAscendingLetters;
exports.IconSortAscendingNumbers = IconSortAscendingNumbers;
exports.IconSortAscendingShapes = IconSortAscendingShapes;
exports.IconSortAscendingShapesFilled = IconSortAscendingShapesFilled;
exports.IconSortAscendingSmallBig = IconSortAscendingSmallBig;
exports.IconSortDeacendingSmallBig = IconSortDescendingSmallBig;
exports.IconSortDescending = IconSortDescending;
exports.IconSortDescending2 = IconSortDescending2;
exports.IconSortDescending2Filled = IconSortDescending2Filled;
exports.IconSortDescendingLetters = IconSortDescendingLetters;
exports.IconSortDescendingNumbers = IconSortDescendingNumbers;
exports.IconSortDescendingShapes = IconSortDescendingShapes;
exports.IconSortDescendingShapesFilled = IconSortDescendingShapesFilled;
exports.IconSortDescendingSmallBig = IconSortDescendingSmallBig;
exports.IconSortZA = IconSortZA;
exports.IconSos = IconSos;
exports.IconSoup = IconSoup;
exports.IconSoupFilled = IconSoupFilled;
exports.IconSoupOff = IconSoupOff;
exports.IconSourceCode = IconSourceCode;
exports.IconSpace = IconSpace;
exports.IconSpaceOff = IconSpaceOff;
exports.IconSpaces = IconSpaces;
exports.IconSpacingHorizontal = IconSpacingHorizontal;
exports.IconSpacingVertical = IconSpacingVertical;
exports.IconSpade = IconSpade;
exports.IconSpadeFilled = IconSpadeFilled;
exports.IconSparkles = IconSparkles;
exports.IconSpeakerphone = IconSpeakerphone;
exports.IconSpeedboat = IconSpeedboat;
exports.IconSpeedboatFilled = IconSpeedboatFilled;
exports.IconSphere = IconSphere;
exports.IconSphereOff = IconSphereOff;
exports.IconSpherePlus = IconSpherePlus;
exports.IconSpider = IconSpider;
exports.IconSpiderFilled = IconSpiderFilled;
exports.IconSpiral = IconSpiral;
exports.IconSpiralOff = IconSpiralOff;
exports.IconSportBillard = IconSportBillard;
exports.IconSpray = IconSpray;
exports.IconSpy = IconSpy;
exports.IconSpyOff = IconSpyOff;
exports.IconSql = IconSql;
exports.IconSquare = IconSquare;
exports.IconSquare0 = IconSquareNumber0;
exports.IconSquare1 = IconSquareNumber1;
exports.IconSquare2 = IconSquareNumber2;
exports.IconSquare3 = IconSquareNumber3;
exports.IconSquare4 = IconSquareNumber4;
exports.IconSquare5 = IconSquareNumber5;
exports.IconSquare6 = IconSquareNumber6;
exports.IconSquare7 = IconSquareNumber7;
exports.IconSquare8 = IconSquareNumber8;
exports.IconSquare9 = IconSquareNumber9;
exports.IconSquareArrowDown = IconSquareArrowDown;
exports.IconSquareArrowDownFilled = IconSquareArrowDownFilled;
exports.IconSquareArrowLeft = IconSquareArrowLeft;
exports.IconSquareArrowLeftFilled = IconSquareArrowLeftFilled;
exports.IconSquareArrowRight = IconSquareArrowRight;
exports.IconSquareArrowRightFilled = IconSquareArrowRightFilled;
exports.IconSquareArrowUp = IconSquareArrowUp;
exports.IconSquareArrowUpFilled = IconSquareArrowUpFilled;
exports.IconSquareAsterisk = IconSquareAsterisk;
exports.IconSquareAsteriskFilled = IconSquareAsteriskFilled;
exports.IconSquareCheck = IconSquareCheck;
exports.IconSquareCheckFilled = IconSquareCheckFilled;
exports.IconSquareChevronDown = IconSquareChevronDown;
exports.IconSquareChevronDownFilled = IconSquareChevronDownFilled;
exports.IconSquareChevronLeft = IconSquareChevronLeft;
exports.IconSquareChevronLeftFilled = IconSquareChevronLeftFilled;
exports.IconSquareChevronRight = IconSquareChevronRight;
exports.IconSquareChevronRightFilled = IconSquareChevronRightFilled;
exports.IconSquareChevronUp = IconSquareChevronUp;
exports.IconSquareChevronUpFilled = IconSquareChevronUpFilled;
exports.IconSquareChevronsDown = IconSquareChevronsDown;
exports.IconSquareChevronsDownFilled = IconSquareChevronsDownFilled;
exports.IconSquareChevronsLeft = IconSquareChevronsLeft;
exports.IconSquareChevronsLeftFilled = IconSquareChevronsLeftFilled;
exports.IconSquareChevronsRight = IconSquareChevronsRight;
exports.IconSquareChevronsRightFilled = IconSquareChevronsRightFilled;
exports.IconSquareChevronsUp = IconSquareChevronsUp;
exports.IconSquareChevronsUpFilled = IconSquareChevronsUpFilled;
exports.IconSquareDashed = IconSquareDashed;
exports.IconSquareDot = IconSquareDot;
exports.IconSquareDotFilled = IconSquareDotFilled;
exports.IconSquareF0 = IconSquareF0;
exports.IconSquareF0Filled = IconSquareF0Filled;
exports.IconSquareF1 = IconSquareF1;
exports.IconSquareF1Filled = IconSquareF1Filled;
exports.IconSquareF2 = IconSquareF2;
exports.IconSquareF2Filled = IconSquareF2Filled;
exports.IconSquareF3 = IconSquareF3;
exports.IconSquareF3Filled = IconSquareF3Filled;
exports.IconSquareF4 = IconSquareF4;
exports.IconSquareF4Filled = IconSquareF4Filled;
exports.IconSquareF5 = IconSquareF5;
exports.IconSquareF5Filled = IconSquareF5Filled;
exports.IconSquareF6 = IconSquareF6;
exports.IconSquareF6Filled = IconSquareF6Filled;
exports.IconSquareF7 = IconSquareF7;
exports.IconSquareF7Filled = IconSquareF7Filled;
exports.IconSquareF8 = IconSquareF8;
exports.IconSquareF8Filled = IconSquareF8Filled;
exports.IconSquareF9 = IconSquareF9;
exports.IconSquareF9Filled = IconSquareF9Filled;
exports.IconSquareFilled = IconSquareFilled;
exports.IconSquareForbid = IconSquareForbid;
exports.IconSquareForbid2 = IconSquareForbid2;
exports.IconSquareHalf = IconSquareHalf;
exports.IconSquareKey = IconSquareKey;
exports.IconSquareLetterA = IconSquareLetterA;
exports.IconSquareLetterAFilled = IconSquareLetterAFilled;
exports.IconSquareLetterB = IconSquareLetterB;
exports.IconSquareLetterBFilled = IconSquareLetterBFilled;
exports.IconSquareLetterC = IconSquareLetterC;
exports.IconSquareLetterCFilled = IconSquareLetterCFilled;
exports.IconSquareLetterD = IconSquareLetterD;
exports.IconSquareLetterDFilled = IconSquareLetterDFilled;
exports.IconSquareLetterE = IconSquareLetterE;
exports.IconSquareLetterEFilled = IconSquareLetterEFilled;
exports.IconSquareLetterF = IconSquareLetterF;
exports.IconSquareLetterFFilled = IconSquareLetterFFilled;
exports.IconSquareLetterG = IconSquareLetterG;
exports.IconSquareLetterGFilled = IconSquareLetterGFilled;
exports.IconSquareLetterH = IconSquareLetterH;
exports.IconSquareLetterHFilled = IconSquareLetterHFilled;
exports.IconSquareLetterI = IconSquareLetterI;
exports.IconSquareLetterIFilled = IconSquareLetterIFilled;
exports.IconSquareLetterJ = IconSquareLetterJ;
exports.IconSquareLetterJFilled = IconSquareLetterJFilled;
exports.IconSquareLetterK = IconSquareLetterK;
exports.IconSquareLetterKFilled = IconSquareLetterKFilled;
exports.IconSquareLetterL = IconSquareLetterL;
exports.IconSquareLetterLFilled = IconSquareLetterLFilled;
exports.IconSquareLetterM = IconSquareLetterM;
exports.IconSquareLetterMFilled = IconSquareLetterMFilled;
exports.IconSquareLetterN = IconSquareLetterN;
exports.IconSquareLetterNFilled = IconSquareLetterNFilled;
exports.IconSquareLetterO = IconSquareLetterO;
exports.IconSquareLetterOFilled = IconSquareLetterOFilled;
exports.IconSquareLetterP = IconSquareLetterP;
exports.IconSquareLetterPFilled = IconSquareLetterPFilled;
exports.IconSquareLetterQ = IconSquareLetterQ;
exports.IconSquareLetterQFilled = IconSquareLetterQFilled;
exports.IconSquareLetterR = IconSquareLetterR;
exports.IconSquareLetterRFilled = IconSquareLetterRFilled;
exports.IconSquareLetterS = IconSquareLetterS;
exports.IconSquareLetterSFilled = IconSquareLetterSFilled;
exports.IconSquareLetterT = IconSquareLetterT;
exports.IconSquareLetterTFilled = IconSquareLetterTFilled;
exports.IconSquareLetterU = IconSquareLetterU;
exports.IconSquareLetterUFilled = IconSquareLetterUFilled;
exports.IconSquareLetterV = IconSquareLetterV;
exports.IconSquareLetterVFilled = IconSquareLetterVFilled;
exports.IconSquareLetterW = IconSquareLetterW;
exports.IconSquareLetterWFilled = IconSquareLetterWFilled;
exports.IconSquareLetterX = IconSquareLetterX;
exports.IconSquareLetterXFilled = IconSquareLetterXFilled;
exports.IconSquareLetterY = IconSquareLetterY;
exports.IconSquareLetterYFilled = IconSquareLetterYFilled;
exports.IconSquareLetterZ = IconSquareLetterZ;
exports.IconSquareLetterZFilled = IconSquareLetterZFilled;
exports.IconSquareMinus = IconSquareMinus;
exports.IconSquareMinusFilled = IconSquareMinusFilled;
exports.IconSquareNumber0 = IconSquareNumber0;
exports.IconSquareNumber0Filled = IconSquareNumber0Filled;
exports.IconSquareNumber1 = IconSquareNumber1;
exports.IconSquareNumber1Filled = IconSquareNumber1Filled;
exports.IconSquareNumber2 = IconSquareNumber2;
exports.IconSquareNumber2Filled = IconSquareNumber2Filled;
exports.IconSquareNumber3 = IconSquareNumber3;
exports.IconSquareNumber3Filled = IconSquareNumber3Filled;
exports.IconSquareNumber4 = IconSquareNumber4;
exports.IconSquareNumber4Filled = IconSquareNumber4Filled;
exports.IconSquareNumber5 = IconSquareNumber5;
exports.IconSquareNumber5Filled = IconSquareNumber5Filled;
exports.IconSquareNumber6 = IconSquareNumber6;
exports.IconSquareNumber6Filled = IconSquareNumber6Filled;
exports.IconSquareNumber7 = IconSquareNumber7;
exports.IconSquareNumber7Filled = IconSquareNumber7Filled;
exports.IconSquareNumber8 = IconSquareNumber8;
exports.IconSquareNumber8Filled = IconSquareNumber8Filled;
exports.IconSquareNumber9 = IconSquareNumber9;
exports.IconSquareNumber9Filled = IconSquareNumber9Filled;
exports.IconSquareOff = IconSquareOff;
exports.IconSquarePercentage = IconSquarePercentage;
exports.IconSquarePlus = IconSquarePlus;
exports.IconSquarePlus2 = IconSquarePlus2;
exports.IconSquareRoot = IconSquareRoot;
exports.IconSquareRoot2 = IconSquareRoot2;
exports.IconSquareRotated = IconSquareRotated;
exports.IconSquareRotatedFilled = IconSquareRotatedFilled;
exports.IconSquareRotatedForbid = IconSquareRotatedForbid;
exports.IconSquareRotatedForbid2 = IconSquareRotatedForbid2;
exports.IconSquareRotatedOff = IconSquareRotatedOff;
exports.IconSquareRounded = IconSquareRounded;
exports.IconSquareRoundedArrowDown = IconSquareRoundedArrowDown;
exports.IconSquareRoundedArrowDownFilled = IconSquareRoundedArrowDownFilled;
exports.IconSquareRoundedArrowLeft = IconSquareRoundedArrowLeft;
exports.IconSquareRoundedArrowLeftFilled = IconSquareRoundedArrowLeftFilled;
exports.IconSquareRoundedArrowRight = IconSquareRoundedArrowRight;
exports.IconSquareRoundedArrowRightFilled = IconSquareRoundedArrowRightFilled;
exports.IconSquareRoundedArrowUp = IconSquareRoundedArrowUp;
exports.IconSquareRoundedArrowUpFilled = IconSquareRoundedArrowUpFilled;
exports.IconSquareRoundedCheck = IconSquareRoundedCheck;
exports.IconSquareRoundedCheckFilled = IconSquareRoundedCheckFilled;
exports.IconSquareRoundedChevronDown = IconSquareRoundedChevronDown;
exports.IconSquareRoundedChevronDownFilled = IconSquareRoundedChevronDownFilled;
exports.IconSquareRoundedChevronLeft = IconSquareRoundedChevronLeft;
exports.IconSquareRoundedChevronLeftFilled = IconSquareRoundedChevronLeftFilled;
exports.IconSquareRoundedChevronRight = IconSquareRoundedChevronRight;
exports.IconSquareRoundedChevronRightFilled = IconSquareRoundedChevronRightFilled;
exports.IconSquareRoundedChevronUp = IconSquareRoundedChevronUp;
exports.IconSquareRoundedChevronUpFilled = IconSquareRoundedChevronUpFilled;
exports.IconSquareRoundedChevronsDown = IconSquareRoundedChevronsDown;
exports.IconSquareRoundedChevronsDownFilled = IconSquareRoundedChevronsDownFilled;
exports.IconSquareRoundedChevronsLeft = IconSquareRoundedChevronsLeft;
exports.IconSquareRoundedChevronsLeftFilled = IconSquareRoundedChevronsLeftFilled;
exports.IconSquareRoundedChevronsRight = IconSquareRoundedChevronsRight;
exports.IconSquareRoundedChevronsRightFilled = IconSquareRoundedChevronsRightFilled;
exports.IconSquareRoundedChevronsUp = IconSquareRoundedChevronsUp;
exports.IconSquareRoundedChevronsUpFilled = IconSquareRoundedChevronsUpFilled;
exports.IconSquareRoundedFilled = IconSquareRoundedFilled;
exports.IconSquareRoundedLetterA = IconSquareRoundedLetterA;
exports.IconSquareRoundedLetterAFilled = IconSquareRoundedLetterAFilled;
exports.IconSquareRoundedLetterB = IconSquareRoundedLetterB;
exports.IconSquareRoundedLetterBFilled = IconSquareRoundedLetterBFilled;
exports.IconSquareRoundedLetterC = IconSquareRoundedLetterC;
exports.IconSquareRoundedLetterCFilled = IconSquareRoundedLetterCFilled;
exports.IconSquareRoundedLetterD = IconSquareRoundedLetterD;
exports.IconSquareRoundedLetterDFilled = IconSquareRoundedLetterDFilled;
exports.IconSquareRoundedLetterE = IconSquareRoundedLetterE;
exports.IconSquareRoundedLetterEFilled = IconSquareRoundedLetterEFilled;
exports.IconSquareRoundedLetterF = IconSquareRoundedLetterF;
exports.IconSquareRoundedLetterFFilled = IconSquareRoundedLetterFFilled;
exports.IconSquareRoundedLetterG = IconSquareRoundedLetterG;
exports.IconSquareRoundedLetterGFilled = IconSquareRoundedLetterGFilled;
exports.IconSquareRoundedLetterH = IconSquareRoundedLetterH;
exports.IconSquareRoundedLetterHFilled = IconSquareRoundedLetterHFilled;
exports.IconSquareRoundedLetterI = IconSquareRoundedLetterI;
exports.IconSquareRoundedLetterIFilled = IconSquareRoundedLetterIFilled;
exports.IconSquareRoundedLetterJ = IconSquareRoundedLetterJ;
exports.IconSquareRoundedLetterJFilled = IconSquareRoundedLetterJFilled;
exports.IconSquareRoundedLetterK = IconSquareRoundedLetterK;
exports.IconSquareRoundedLetterKFilled = IconSquareRoundedLetterKFilled;
exports.IconSquareRoundedLetterL = IconSquareRoundedLetterL;
exports.IconSquareRoundedLetterLFilled = IconSquareRoundedLetterLFilled;
exports.IconSquareRoundedLetterM = IconSquareRoundedLetterM;
exports.IconSquareRoundedLetterMFilled = IconSquareRoundedLetterMFilled;
exports.IconSquareRoundedLetterN = IconSquareRoundedLetterN;
exports.IconSquareRoundedLetterNFilled = IconSquareRoundedLetterNFilled;
exports.IconSquareRoundedLetterO = IconSquareRoundedLetterO;
exports.IconSquareRoundedLetterOFilled = IconSquareRoundedLetterOFilled;
exports.IconSquareRoundedLetterP = IconSquareRoundedLetterP;
exports.IconSquareRoundedLetterPFilled = IconSquareRoundedLetterPFilled;
exports.IconSquareRoundedLetterQ = IconSquareRoundedLetterQ;
exports.IconSquareRoundedLetterQFilled = IconSquareRoundedLetterQFilled;
exports.IconSquareRoundedLetterR = IconSquareRoundedLetterR;
exports.IconSquareRoundedLetterRFilled = IconSquareRoundedLetterRFilled;
exports.IconSquareRoundedLetterS = IconSquareRoundedLetterS;
exports.IconSquareRoundedLetterSFilled = IconSquareRoundedLetterSFilled;
exports.IconSquareRoundedLetterT = IconSquareRoundedLetterT;
exports.IconSquareRoundedLetterTFilled = IconSquareRoundedLetterTFilled;
exports.IconSquareRoundedLetterU = IconSquareRoundedLetterU;
exports.IconSquareRoundedLetterUFilled = IconSquareRoundedLetterUFilled;
exports.IconSquareRoundedLetterV = IconSquareRoundedLetterV;
exports.IconSquareRoundedLetterVFilled = IconSquareRoundedLetterVFilled;
exports.IconSquareRoundedLetterW = IconSquareRoundedLetterW;
exports.IconSquareRoundedLetterWFilled = IconSquareRoundedLetterWFilled;
exports.IconSquareRoundedLetterX = IconSquareRoundedLetterX;
exports.IconSquareRoundedLetterXFilled = IconSquareRoundedLetterXFilled;
exports.IconSquareRoundedLetterY = IconSquareRoundedLetterY;
exports.IconSquareRoundedLetterYFilled = IconSquareRoundedLetterYFilled;
exports.IconSquareRoundedLetterZ = IconSquareRoundedLetterZ;
exports.IconSquareRoundedLetterZFilled = IconSquareRoundedLetterZFilled;
exports.IconSquareRoundedMinus = IconSquareRoundedMinus;
exports.IconSquareRoundedMinus2 = IconSquareRoundedMinus2;
exports.IconSquareRoundedMinusFilled = IconSquareRoundedMinusFilled;
exports.IconSquareRoundedNumber0 = IconSquareRoundedNumber0;
exports.IconSquareRoundedNumber0Filled = IconSquareRoundedNumber0Filled;
exports.IconSquareRoundedNumber1 = IconSquareRoundedNumber1;
exports.IconSquareRoundedNumber1Filled = IconSquareRoundedNumber1Filled;
exports.IconSquareRoundedNumber2 = IconSquareRoundedNumber2;
exports.IconSquareRoundedNumber2Filled = IconSquareRoundedNumber2Filled;
exports.IconSquareRoundedNumber3 = IconSquareRoundedNumber3;
exports.IconSquareRoundedNumber3Filled = IconSquareRoundedNumber3Filled;
exports.IconSquareRoundedNumber4 = IconSquareRoundedNumber4;
exports.IconSquareRoundedNumber4Filled = IconSquareRoundedNumber4Filled;
exports.IconSquareRoundedNumber5 = IconSquareRoundedNumber5;
exports.IconSquareRoundedNumber5Filled = IconSquareRoundedNumber5Filled;
exports.IconSquareRoundedNumber6 = IconSquareRoundedNumber6;
exports.IconSquareRoundedNumber6Filled = IconSquareRoundedNumber6Filled;
exports.IconSquareRoundedNumber7 = IconSquareRoundedNumber7;
exports.IconSquareRoundedNumber7Filled = IconSquareRoundedNumber7Filled;
exports.IconSquareRoundedNumber8 = IconSquareRoundedNumber8;
exports.IconSquareRoundedNumber8Filled = IconSquareRoundedNumber8Filled;
exports.IconSquareRoundedNumber9 = IconSquareRoundedNumber9;
exports.IconSquareRoundedNumber9Filled = IconSquareRoundedNumber9Filled;
exports.IconSquareRoundedPercentage = IconSquareRoundedPercentage;
exports.IconSquareRoundedPlus = IconSquareRoundedPlus;
exports.IconSquareRoundedPlus2 = IconSquareRoundedPlus2;
exports.IconSquareRoundedPlusFilled = IconSquareRoundedPlusFilled;
exports.IconSquareRoundedX = IconSquareRoundedX;
exports.IconSquareRoundedXFilled = IconSquareRoundedXFilled;
exports.IconSquareToggle = IconSquareToggle;
exports.IconSquareToggleHorizontal = IconSquareToggleHorizontal;
exports.IconSquareX = IconSquareX;
exports.IconSquareXFilled = IconSquareXFilled;
exports.IconSquares = IconSquares;
exports.IconSquaresDiagonal = IconSquaresDiagonal;
exports.IconSquaresFilled = IconSquaresFilled;
exports.IconSquaresSelected = IconSquaresSelected;
exports.IconStack = IconStack;
exports.IconStack2 = IconStack2;
exports.IconStack2Filled = IconStack2Filled;
exports.IconStack3 = IconStack3;
exports.IconStack3Filled = IconStack3Filled;
exports.IconStackBack = IconStackBack;
exports.IconStackBackward = IconStackBackward;
exports.IconStackFilled = IconStackFilled;
exports.IconStackForward = IconStackForward;
exports.IconStackFront = IconStackFront;
exports.IconStackMiddle = IconStackMiddle;
exports.IconStackPop = IconStackPop;
exports.IconStackPush = IconStackPush;
exports.IconStairs = IconStairs;
exports.IconStairsDown = IconStairsDown;
exports.IconStairsUp = IconStairsUp;
exports.IconStar = IconStar;
exports.IconStarFilled = IconStarFilled;
exports.IconStarHalf = IconStarHalf;
exports.IconStarHalfFilled = IconStarHalfFilled;
exports.IconStarOff = IconStarOff;
exports.IconStars = IconStars;
exports.IconStarsFilled = IconStarsFilled;
exports.IconStarsOff = IconStarsOff;
exports.IconStatusChange = IconStatusChange;
exports.IconSteam = IconSteam;
exports.IconSteeringWheel = IconSteeringWheel;
exports.IconSteeringWheelFilled = IconSteeringWheelFilled;
exports.IconSteeringWheelOff = IconSteeringWheelOff;
exports.IconStepInto = IconStepInto;
exports.IconStepOut = IconStepOut;
exports.IconStereoGlasses = IconStereoGlasses;
exports.IconStethoscope = IconStethoscope;
exports.IconStethoscopeOff = IconStethoscopeOff;
exports.IconSticker = IconSticker;
exports.IconSticker2 = IconSticker2;
exports.IconStopwatch = IconStopwatch;
exports.IconStorm = IconStorm;
exports.IconStormOff = IconStormOff;
exports.IconStretching = IconStretching;
exports.IconStretching2 = IconStretching2;
exports.IconStrikethrough = IconStrikethrough;
exports.IconSubmarine = IconSubmarine;
exports.IconSubscript = IconSubscript;
exports.IconSubtask = IconSubtask;
exports.IconSum = IconSum;
exports.IconSumOff = IconSumOff;
exports.IconSun = IconSun;
exports.IconSunElectricity = IconSunElectricity;
exports.IconSunFilled = IconSunFilled;
exports.IconSunHigh = IconSunHigh;
exports.IconSunHighFilled = IconSunHighFilled;
exports.IconSunLow = IconSunLow;
exports.IconSunLowFilled = IconSunLowFilled;
exports.IconSunMoon = IconSunMoon;
exports.IconSunOff = IconSunOff;
exports.IconSunWind = IconSunWind;
exports.IconSunglasses = IconSunglasses;
exports.IconSunglassesFilled = IconSunglassesFilled;
exports.IconSunrise = IconSunrise;
exports.IconSunriseFilled = IconSunriseFilled;
exports.IconSunset = IconSunset;
exports.IconSunset2 = IconSunset2;
exports.IconSunset2Filled = IconSunset2Filled;
exports.IconSunsetFilled = IconSunsetFilled;
exports.IconSuperscript = IconSuperscript;
exports.IconSvg = IconSvg;
exports.IconSwimming = IconSwimming;
exports.IconSwipe = IconSwipe;
exports.IconSwipeDown = IconSwipeDown;
exports.IconSwipeDownFilled = IconSwipeDownFilled;
exports.IconSwipeLeft = IconSwipeLeft;
exports.IconSwipeLeftFilled = IconSwipeLeftFilled;
exports.IconSwipeRight = IconSwipeRight;
exports.IconSwipeRightFilled = IconSwipeRightFilled;
exports.IconSwipeUp = IconSwipeUp;
exports.IconSwipeUpFilled = IconSwipeUpFilled;
exports.IconSwitch = IconSwitch;
exports.IconSwitch2 = IconSwitch2;
exports.IconSwitch3 = IconSwitch3;
exports.IconSwitchHorizontal = IconSwitchHorizontal;
exports.IconSwitchVertical = IconSwitchVertical;
exports.IconSword = IconSword;
exports.IconSwordOff = IconSwordOff;
exports.IconSwords = IconSwords;
exports.IconTable = IconTable;
exports.IconTableAlias = IconTableAlias;
exports.IconTableColumn = IconTableColumn;
exports.IconTableDashed = IconTableDashed;
exports.IconTableDown = IconTableDown;
exports.IconTableExport = IconTableExport;
exports.IconTableFilled = IconTableFilled;
exports.IconTableHeart = IconTableHeart;
exports.IconTableImport = IconTableImport;
exports.IconTableMinus = IconTableMinus;
exports.IconTableOff = IconTableOff;
exports.IconTableOptions = IconTableOptions;
exports.IconTablePlus = IconTablePlus;
exports.IconTableRow = IconTableRow;
exports.IconTableShare = IconTableShare;
exports.IconTableShortcut = IconTableShortcut;
exports.IconTableSpark = IconTableSpark;
exports.IconTag = IconTag;
exports.IconTagFilled = IconTagFilled;
exports.IconTagMinus = IconTagMinus;
exports.IconTagOff = IconTagOff;
exports.IconTagPlus = IconTagPlus;
exports.IconTagStarred = IconTagStarred;
exports.IconTags = IconTags;
exports.IconTagsFilled = IconTagsFilled;
exports.IconTagsOff = IconTagsOff;
exports.IconTallymark1 = IconTallymark1;
exports.IconTallymark2 = IconTallymark2;
exports.IconTallymark3 = IconTallymark3;
exports.IconTallymark4 = IconTallymark4;
exports.IconTallymarks = IconTallymarks;
exports.IconTank = IconTank;
exports.IconTarget = IconTarget;
exports.IconTargetArrow = IconTargetArrow;
exports.IconTargetOff = IconTargetOff;
exports.IconTax = IconTax;
exports.IconTaxEuro = IconTaxEuro;
exports.IconTaxPound = IconTaxPound;
exports.IconTeapot = IconTeapot;
exports.IconTelescope = IconTelescope;
exports.IconTelescopeOff = IconTelescopeOff;
exports.IconTemperature = IconTemperature;
exports.IconTemperatureCelsius = IconTemperatureCelsius;
exports.IconTemperatureFahrenheit = IconTemperatureFahrenheit;
exports.IconTemperatureMinus = IconTemperatureMinus;
exports.IconTemperatureMinusFilled = IconTemperatureMinusFilled;
exports.IconTemperatureOff = IconTemperatureOff;
exports.IconTemperaturePlus = IconTemperaturePlus;
exports.IconTemperaturePlusFilled = IconTemperaturePlusFilled;
exports.IconTemperatureSnow = IconTemperatureSnow;
exports.IconTemperatureSun = IconTemperatureSun;
exports.IconTemplate = IconTemplate;
exports.IconTemplateOff = IconTemplateOff;
exports.IconTent = IconTent;
exports.IconTentOff = IconTentOff;
exports.IconTerminal = IconTerminal;
exports.IconTerminal2 = IconTerminal2;
exports.IconTestPipe = IconTestPipe;
exports.IconTestPipe2 = IconTestPipe2;
exports.IconTestPipe2Filled = IconTestPipe2Filled;
exports.IconTestPipeOff = IconTestPipeOff;
exports.IconTex = IconTex;
exports.IconTextCaption = IconTextCaption;
exports.IconTextColor = IconTextColor;
exports.IconTextDecrease = IconTextDecrease;
exports.IconTextDirectionLtr = IconTextDirectionLtr;
exports.IconTextDirectionRtl = IconTextDirectionRtl;
exports.IconTextGrammar = IconTextGrammar;
exports.IconTextIncrease = IconTextIncrease;
exports.IconTextOrientation = IconTextOrientation;
exports.IconTextPlus = IconTextPlus;
exports.IconTextRecognition = IconTextRecognition;
exports.IconTextResize = IconTextResize;
exports.IconTextScan2 = IconTextScan2;
exports.IconTextSize = IconTextSize;
exports.IconTextSpellcheck = IconTextSpellcheck;
exports.IconTextWrap = IconTextWrap;
exports.IconTextWrapColumn = IconTextWrapColumn;
exports.IconTextWrapDisabled = IconTextWrapDisabled;
exports.IconTexture = IconTexture;
exports.IconTheater = IconTheater;
exports.IconThermometer = IconThermometer;
exports.IconThumbDown = IconThumbDown;
exports.IconThumbDownFilled = IconThumbDownFilled;
exports.IconThumbDownOff = IconThumbDownOff;
exports.IconThumbUp = IconThumbUp;
exports.IconThumbUpFilled = IconThumbUpFilled;
exports.IconThumbUpOff = IconThumbUpOff;
exports.IconTicTac = IconTicTac;
exports.IconTicket = IconTicket;
exports.IconTicketOff = IconTicketOff;
exports.IconTie = IconTie;
exports.IconTilde = IconTilde;
exports.IconTiltShift = IconTiltShift;
exports.IconTiltShiftFilled = IconTiltShiftFilled;
exports.IconTiltShiftOff = IconTiltShiftOff;
exports.IconTimeDuration0 = IconTimeDuration0;
exports.IconTimeDuration10 = IconTimeDuration10;
exports.IconTimeDuration15 = IconTimeDuration15;
exports.IconTimeDuration30 = IconTimeDuration30;
exports.IconTimeDuration45 = IconTimeDuration45;
exports.IconTimeDuration5 = IconTimeDuration5;
exports.IconTimeDuration60 = IconTimeDuration60;
exports.IconTimeDuration90 = IconTimeDuration90;
exports.IconTimeDurationOff = IconTimeDurationOff;
exports.IconTimeline = IconTimeline;
exports.IconTimelineEvent = IconTimelineEvent;
exports.IconTimelineEventExclamation = IconTimelineEventExclamation;
exports.IconTimelineEventFilled = IconTimelineEventFilled;
exports.IconTimelineEventMinus = IconTimelineEventMinus;
exports.IconTimelineEventPlus = IconTimelineEventPlus;
exports.IconTimelineEventText = IconTimelineEventText;
exports.IconTimelineEventX = IconTimelineEventX;
exports.IconTimezone = IconTimezone;
exports.IconTipJar = IconTipJar;
exports.IconTipJarEuro = IconTipJarEuro;
exports.IconTipJarPound = IconTipJarPound;
exports.IconTir = IconTir;
exports.IconToggleLeft = IconToggleLeft;
exports.IconToggleLeftFilled = IconToggleLeftFilled;
exports.IconToggleRight = IconToggleRight;
exports.IconToggleRightFilled = IconToggleRightFilled;
exports.IconToiletPaper = IconToiletPaper;
exports.IconToiletPaperOff = IconToiletPaperOff;
exports.IconToml = IconToml;
exports.IconTool = IconTool;
exports.IconTools = IconTools;
exports.IconToolsKitchen = IconToolsKitchen;
exports.IconToolsKitchen2 = IconToolsKitchen2;
exports.IconToolsKitchen2Off = IconToolsKitchen2Off;
exports.IconToolsKitchen3 = IconToolsKitchen3;
exports.IconToolsKitchenOff = IconToolsKitchenOff;
exports.IconToolsOff = IconToolsOff;
exports.IconTooltip = IconTooltip;
exports.IconTopologyBus = IconTopologyBus;
exports.IconTopologyComplex = IconTopologyComplex;
exports.IconTopologyFull = IconTopologyFull;
exports.IconTopologyFullHierarchy = IconTopologyFullHierarchy;
exports.IconTopologyRing = IconTopologyRing;
exports.IconTopologyRing2 = IconTopologyRing2;
exports.IconTopologyRing3 = IconTopologyRing3;
exports.IconTopologyStar = IconTopologyStar;
exports.IconTopologyStar2 = IconTopologyStar2;
exports.IconTopologyStar3 = IconTopologyStar3;
exports.IconTopologyStarRing = IconTopologyStarRing;
exports.IconTopologyStarRing2 = IconTopologyStarRing2;
exports.IconTopologyStarRing3 = IconTopologyStarRing3;
exports.IconTorii = IconTorii;
exports.IconTornado = IconTornado;
exports.IconTournament = IconTournament;
exports.IconTower = IconTower;
exports.IconTowerOff = IconTowerOff;
exports.IconTrack = IconTrack;
exports.IconTractor = IconTractor;
exports.IconTrademark = IconTrademark;
exports.IconTrafficCone = IconTrafficCone;
exports.IconTrafficConeOff = IconTrafficConeOff;
exports.IconTrafficLights = IconTrafficLights;
exports.IconTrafficLightsOff = IconTrafficLightsOff;
exports.IconTrain = IconTrain;
exports.IconTrainFilled = IconTrainFilled;
exports.IconTransactionBitcoin = IconTransactionBitcoin;
exports.IconTransactionDollar = IconTransactionDollar;
exports.IconTransactionEuro = IconTransactionEuro;
exports.IconTransactionPound = IconTransactionPound;
exports.IconTransactionRupee = IconTransactionRupee;
exports.IconTransactionYen = IconTransactionYen;
exports.IconTransactionYuan = IconTransactionYuan;
exports.IconTransfer = IconTransfer;
exports.IconTransferIn = IconTransferIn;
exports.IconTransferOut = IconTransferOut;
exports.IconTransferVertical = IconTransferVertical;
exports.IconTransform = IconTransform;
exports.IconTransformFilled = IconTransformFilled;
exports.IconTransformPoint = IconTransformPoint;
exports.IconTransformPointBottomLeft = IconTransformPointBottomLeft;
exports.IconTransformPointBottomRight = IconTransformPointBottomRight;
exports.IconTransformPointTopLeft = IconTransformPointTopLeft;
exports.IconTransformPointTopRight = IconTransformPointTopRight;
exports.IconTransitionBottom = IconTransitionBottom;
exports.IconTransitionBottomFilled = IconTransitionBottomFilled;
exports.IconTransitionLeft = IconTransitionLeft;
exports.IconTransitionLeftFilled = IconTransitionLeftFilled;
exports.IconTransitionRight = IconTransitionRight;
exports.IconTransitionRightFilled = IconTransitionRightFilled;
exports.IconTransitionTop = IconTransitionTop;
exports.IconTransitionTopFilled = IconTransitionTopFilled;
exports.IconTrash = IconTrash;
exports.IconTrashFilled = IconTrashFilled;
exports.IconTrashOff = IconTrashOff;
exports.IconTrashX = IconTrashX;
exports.IconTrashXFilled = IconTrashXFilled;
exports.IconTreadmill = IconTreadmill;
exports.IconTree = IconTree;
exports.IconTrees = IconTrees;
exports.IconTrekking = IconTrekking;
exports.IconTrendingDown = IconTrendingDown;
exports.IconTrendingDown2 = IconTrendingDown2;
exports.IconTrendingDown3 = IconTrendingDown3;
exports.IconTrendingUp = IconTrendingUp;
exports.IconTrendingUp2 = IconTrendingUp2;
exports.IconTrendingUp3 = IconTrendingUp3;
exports.IconTriangle = IconTriangle;
exports.IconTriangleFilled = IconTriangleFilled;
exports.IconTriangleInverted = IconTriangleInverted;
exports.IconTriangleInvertedFilled = IconTriangleInvertedFilled;
exports.IconTriangleMinus = IconTriangleMinus;
exports.IconTriangleMinus2 = IconTriangleMinus2;
exports.IconTriangleOff = IconTriangleOff;
exports.IconTrianglePlus = IconTrianglePlus;
exports.IconTrianglePlus2 = IconTrianglePlus2;
exports.IconTriangleSquareCircle = IconTriangleSquareCircle;
exports.IconTriangleSquareCircleFilled = IconTriangleSquareCircleFilled;
exports.IconTriangles = IconTriangles;
exports.IconTrident = IconTrident;
exports.IconTrolley = IconTrolley;
exports.IconTrolleyFilled = IconTrolleyFilled;
exports.IconTrophy = IconTrophy;
exports.IconTrophyFilled = IconTrophyFilled;
exports.IconTrophyOff = IconTrophyOff;
exports.IconTrowel = IconTrowel;
exports.IconTruck = IconTruck;
exports.IconTruckDelivery = IconTruckDelivery;
exports.IconTruckFilled = IconTruckFilled;
exports.IconTruckLoading = IconTruckLoading;
exports.IconTruckOff = IconTruckOff;
exports.IconTruckReturn = IconTruckReturn;
exports.IconTxt = IconTxt;
exports.IconTypeface = IconTypeface;
exports.IconTypography = IconTypography;
exports.IconTypographyOff = IconTypographyOff;
exports.IconUTurnLeft = IconUTurnLeft;
exports.IconUTurnRight = IconUTurnRight;
exports.IconUfo = IconUfo;
exports.IconUfoOff = IconUfoOff;
exports.IconUhd = IconUhd;
exports.IconUmbrella = IconUmbrella;
exports.IconUmbrella2 = IconUmbrella2;
exports.IconUmbrellaClosed = IconUmbrellaClosed;
exports.IconUmbrellaClosed2 = IconUmbrellaClosed2;
exports.IconUmbrellaFilled = IconUmbrellaFilled;
exports.IconUmbrellaOff = IconUmbrellaOff;
exports.IconUnderline = IconUnderline;
exports.IconUniverse = IconUniverse;
exports.IconUnlink = IconUnlink;
exports.IconUpload = IconUpload;
exports.IconUrgent = IconUrgent;
exports.IconUsb = IconUsb;
exports.IconUser = IconUser;
exports.IconUserBitcoin = IconUserBitcoin;
exports.IconUserBolt = IconUserBolt;
exports.IconUserCancel = IconUserCancel;
exports.IconUserCheck = IconUserCheck;
exports.IconUserCircle = IconUserCircle;
exports.IconUserCode = IconUserCode;
exports.IconUserCog = IconUserCog;
exports.IconUserDollar = IconUserDollar;
exports.IconUserDown = IconUserDown;
exports.IconUserEdit = IconUserEdit;
exports.IconUserExclamation = IconUserExclamation;
exports.IconUserFilled = IconUserFilled;
exports.IconUserHeart = IconUserHeart;
exports.IconUserHexagon = IconUserHexagon;
exports.IconUserMinus = IconUserMinus;
exports.IconUserOff = IconUserOff;
exports.IconUserPause = IconUserPause;
exports.IconUserPentagon = IconUserPentagon;
exports.IconUserPin = IconUserPin;
exports.IconUserPlus = IconUserPlus;
exports.IconUserQuestion = IconUserQuestion;
exports.IconUserScan = IconUserScan;
exports.IconUserScreen = IconUserScreen;
exports.IconUserSearch = IconUserSearch;
exports.IconUserShare = IconUserShare;
exports.IconUserShield = IconUserShield;
exports.IconUserSquare = IconUserSquare;
exports.IconUserSquareRounded = IconUserSquareRounded;
exports.IconUserStar = IconUserStar;
exports.IconUserUp = IconUserUp;
exports.IconUserX = IconUserX;
exports.IconUsers = IconUsers;
exports.IconUsersGroup = IconUsersGroup;
exports.IconUsersMinus = IconUsersMinus;
exports.IconUsersPlus = IconUsersPlus;
exports.IconUvIndex = IconUvIndex;
exports.IconUxCircle = IconUxCircle;
exports.IconVaccine = IconVaccine;
exports.IconVaccineBottle = IconVaccineBottle;
exports.IconVaccineBottleOff = IconVaccineBottleOff;
exports.IconVaccineOff = IconVaccineOff;
exports.IconVacuumCleaner = IconVacuumCleaner;
exports.IconVariable = IconVariable;
exports.IconVariableMinus = IconVariableMinus;
exports.IconVariableOff = IconVariableOff;
exports.IconVariablePlus = IconVariablePlus;
exports.IconVector = IconVector;
exports.IconVectorBezier = IconVectorBezier;
exports.IconVectorBezier2 = IconVectorBezier2;
exports.IconVectorBezierArc = IconVectorBezierArc;
exports.IconVectorBezierCircle = IconVectorBezierCircle;
exports.IconVectorOff = IconVectorOff;
exports.IconVectorSpline = IconVectorSpline;
exports.IconVectorTriangle = IconVectorTriangle;
exports.IconVectorTriangleOff = IconVectorTriangleOff;
exports.IconVenus = IconVenus;
exports.IconVersions = IconVersions;
exports.IconVersionsFilled = IconVersionsFilled;
exports.IconVersionsOff = IconVersionsOff;
exports.IconVideo = IconVideo;
exports.IconVideoFilled = IconVideoFilled;
exports.IconVideoMinus = IconVideoMinus;
exports.IconVideoOff = IconVideoOff;
exports.IconVideoPlus = IconVideoPlus;
exports.IconView360 = IconView360;
exports.IconView360Arrow = IconView360Arrow;
exports.IconView360Number = IconView360Number;
exports.IconView360Off = IconView360Off;
exports.IconViewfinder = IconViewfinder;
exports.IconViewfinderOff = IconViewfinderOff;
exports.IconViewportNarrow = IconViewportNarrow;
exports.IconViewportShort = IconViewportShort;
exports.IconViewportTall = IconViewportTall;
exports.IconViewportWide = IconViewportWide;
exports.IconVinyl = IconVinyl;
exports.IconVip = IconVip;
exports.IconVipOff = IconVipOff;
exports.IconVirus = IconVirus;
exports.IconVirusOff = IconVirusOff;
exports.IconVirusSearch = IconVirusSearch;
exports.IconVocabulary = IconVocabulary;
exports.IconVocabularyOff = IconVocabularyOff;
exports.IconVolcano = IconVolcano;
exports.IconVolume = IconVolume;
exports.IconVolume2 = IconVolume2;
exports.IconVolume3 = IconVolume3;
exports.IconVolumeOff = IconVolumeOff;
exports.IconVs = IconVs;
exports.IconWalk = IconWalk;
exports.IconWall = IconWall;
exports.IconWallOff = IconWallOff;
exports.IconWallet = IconWallet;
exports.IconWalletOff = IconWalletOff;
exports.IconWallpaper = IconWallpaper;
exports.IconWallpaperOff = IconWallpaperOff;
exports.IconWand = IconWand;
exports.IconWandOff = IconWandOff;
exports.IconWash = IconWash;
exports.IconWashDry = IconWashDry;
exports.IconWashDry1 = IconWashDry1;
exports.IconWashDry2 = IconWashDry2;
exports.IconWashDry3 = IconWashDry3;
exports.IconWashDryA = IconWashDryA;
exports.IconWashDryDip = IconWashDryDip;
exports.IconWashDryF = IconWashDryF;
exports.IconWashDryFlat = IconWashDryFlat;
exports.IconWashDryHang = IconWashDryHang;
exports.IconWashDryOff = IconWashDryOff;
exports.IconWashDryP = IconWashDryP;
exports.IconWashDryShade = IconWashDryShade;
exports.IconWashDryW = IconWashDryW;
exports.IconWashDryclean = IconWashDryclean;
exports.IconWashDrycleanOff = IconWashDrycleanOff;
exports.IconWashEco = IconWashEco;
exports.IconWashGentle = IconWashGentle;
exports.IconWashHand = IconWashHand;
exports.IconWashMachine = IconWashMachine;
exports.IconWashOff = IconWashOff;
exports.IconWashPress = IconWashPress;
exports.IconWashTemperature1 = IconWashTemperature1;
exports.IconWashTemperature2 = IconWashTemperature2;
exports.IconWashTemperature3 = IconWashTemperature3;
exports.IconWashTemperature4 = IconWashTemperature4;
exports.IconWashTemperature5 = IconWashTemperature5;
exports.IconWashTemperature6 = IconWashTemperature6;
exports.IconWashTumbleDry = IconWashTumbleDry;
exports.IconWashTumbleOff = IconWashTumbleOff;
exports.IconWaterpolo = IconWaterpolo;
exports.IconWaveSawTool = IconWaveSawTool;
exports.IconWaveSine = IconWaveSine;
exports.IconWaveSquare = IconWaveSquare;
exports.IconWavesElectricity = IconWavesElectricity;
exports.IconWebhook = IconWebhook;
exports.IconWebhookOff = IconWebhookOff;
exports.IconWeight = IconWeight;
exports.IconWheat = IconWheat;
exports.IconWheatOff = IconWheatOff;
exports.IconWheel = IconWheel;
exports.IconWheelchair = IconWheelchair;
exports.IconWheelchairOff = IconWheelchairOff;
exports.IconWhirl = IconWhirl;
exports.IconWifi = IconWifi;
exports.IconWifi0 = IconWifi0;
exports.IconWifi1 = IconWifi1;
exports.IconWifi2 = IconWifi2;
exports.IconWifiOff = IconWifiOff;
exports.IconWind = IconWind;
exports.IconWindElectricity = IconWindElectricity;
exports.IconWindOff = IconWindOff;
exports.IconWindmill = IconWindmill;
exports.IconWindmillFilled = IconWindmillFilled;
exports.IconWindmillOff = IconWindmillOff;
exports.IconWindow = IconWindow;
exports.IconWindowMaximize = IconWindowMaximize;
exports.IconWindowMinimize = IconWindowMinimize;
exports.IconWindowOff = IconWindowOff;
exports.IconWindsock = IconWindsock;
exports.IconWindsockFilled = IconWindsockFilled;
exports.IconWiper = IconWiper;
exports.IconWiperWash = IconWiperWash;
exports.IconWoman = IconWoman;
exports.IconWomanFilled = IconWomanFilled;
exports.IconWood = IconWood;
exports.IconWorld = IconWorld;
exports.IconWorldBolt = IconWorldBolt;
exports.IconWorldCancel = IconWorldCancel;
exports.IconWorldCheck = IconWorldCheck;
exports.IconWorldCode = IconWorldCode;
exports.IconWorldCog = IconWorldCog;
exports.IconWorldDollar = IconWorldDollar;
exports.IconWorldDown = IconWorldDown;
exports.IconWorldDownload = IconWorldDownload;
exports.IconWorldExclamation = IconWorldExclamation;
exports.IconWorldHeart = IconWorldHeart;
exports.IconWorldLatitude = IconWorldLatitude;
exports.IconWorldLongitude = IconWorldLongitude;
exports.IconWorldMinus = IconWorldMinus;
exports.IconWorldOff = IconWorldOff;
exports.IconWorldPause = IconWorldPause;
exports.IconWorldPin = IconWorldPin;
exports.IconWorldPlus = IconWorldPlus;
exports.IconWorldQuestion = IconWorldQuestion;
exports.IconWorldSearch = IconWorldSearch;
exports.IconWorldShare = IconWorldShare;
exports.IconWorldStar = IconWorldStar;
exports.IconWorldUp = IconWorldUp;
exports.IconWorldUpload = IconWorldUpload;
exports.IconWorldWww = IconWorldWww;
exports.IconWorldX = IconWorldX;
exports.IconWreckingBall = IconWreckingBall;
exports.IconWriting = IconWriting;
exports.IconWritingOff = IconWritingOff;
exports.IconWritingSign = IconWritingSign;
exports.IconWritingSignOff = IconWritingSignOff;
exports.IconX = IconX;
exports.IconXPowerY = IconXPowerY;
exports.IconXboxA = IconXboxA;
exports.IconXboxAFilled = IconXboxAFilled;
exports.IconXboxB = IconXboxB;
exports.IconXboxBFilled = IconXboxBFilled;
exports.IconXboxX = IconXboxX;
exports.IconXboxXFilled = IconXboxXFilled;
exports.IconXboxY = IconXboxY;
exports.IconXboxYFilled = IconXboxYFilled;
exports.IconXd = IconXd;
exports.IconXxx = IconXxx;
exports.IconYinYang = IconYinYang;
exports.IconYinYangFilled = IconYinYangFilled;
exports.IconYoga = IconYoga;
exports.IconZeppelin = IconZeppelin;
exports.IconZeppelinFilled = IconZeppelinFilled;
exports.IconZeppelinOff = IconZeppelinOff;
exports.IconZip = IconZip;
exports.IconZodiacAquarius = IconZodiacAquarius;
exports.IconZodiacAries = IconZodiacAries;
exports.IconZodiacCancer = IconZodiacCancer;
exports.IconZodiacCapricorn = IconZodiacCapricorn;
exports.IconZodiacGemini = IconZodiacGemini;
exports.IconZodiacLeo = IconZodiacLeo;
exports.IconZodiacLibra = IconZodiacLibra;
exports.IconZodiacPisces = IconZodiacPisces;
exports.IconZodiacSagittarius = IconZodiacSagittarius;
exports.IconZodiacScorpio = IconZodiacScorpio;
exports.IconZodiacTaurus = IconZodiacTaurus;
exports.IconZodiacVirgo = IconZodiacVirgo;
exports.IconZoom = IconZoom;
exports.IconZoomCancel = IconZoomCancel;
exports.IconZoomCancelFilled = IconZoomCancelFilled;
exports.IconZoomCheck = IconZoomCheck;
exports.IconZoomCheckFilled = IconZoomCheckFilled;
exports.IconZoomCode = IconZoomCode;
exports.IconZoomCodeFilled = IconZoomCodeFilled;
exports.IconZoomExclamation = IconZoomExclamation;
exports.IconZoomExclamationFilled = IconZoomExclamationFilled;
exports.IconZoomFilled = IconZoomFilled;
exports.IconZoomIn = IconZoomIn;
exports.IconZoomInArea = IconZoomInArea;
exports.IconZoomInAreaFilled = IconZoomInAreaFilled;
exports.IconZoomInFilled = IconZoomInFilled;
exports.IconZoomMoney = IconZoomMoney;
exports.IconZoomMoneyFilled = IconZoomMoneyFilled;
exports.IconZoomOut = IconZoomOut;
exports.IconZoomOutArea = IconZoomOutArea;
exports.IconZoomOutAreaFilled = IconZoomOutAreaFilled;
exports.IconZoomOutFilled = IconZoomOutFilled;
exports.IconZoomPan = IconZoomPan;
exports.IconZoomPanFilled = IconZoomPanFilled;
exports.IconZoomQuestion = IconZoomQuestion;
exports.IconZoomQuestionFilled = IconZoomQuestionFilled;
exports.IconZoomReplace = IconZoomReplace;
exports.IconZoomReset = IconZoomReset;
exports.IconZoomScan = IconZoomScan;
exports.IconZoomScanFilled = IconZoomScanFilled;
exports.IconZzz = IconZzz;
exports.IconZzzOff = IconZzzOff;
exports.createReactComponent = createReactComponent;
exports.dynamicImports = dynamicImports$1;
exports.icons = index;
exports.iconsList = iconsList$1;
//# sourceMappingURL=tabler-icons-react.cjs.map
